webpackJsonp([0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var platform_browser_dynamic_1 = __webpack_require__(1);
	var core_1 = __webpack_require__(3);
	var app_module_1 = __webpack_require__(23);
	// if (process.env.ENV != 'development') {
	if (true) {
	    core_1.enableProdMode();
	}
	platform_browser_dynamic_1.platformBrowserDynamic().bootstrapModule(app_module_1.AppModule);


/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var currency_formatter_pipe_1 = __webpack_require__(24);
	var auth_guard_admin_service_1 = __webpack_require__(25);
	var snail_trail_map_component_1 = __webpack_require__(62);
	var snail_trail_component_1 = __webpack_require__(64);
	var snail_trail_filter_component_1 = __webpack_require__(81);
	var ngx_color_picker_1 = __webpack_require__(198);
	var branding_component_1 = __webpack_require__(199);
	// import { ActiveMenuItemDirective } from './branding/active-menu-item.directive';
	// import { HighLightDirective } from './branding/highlight-panel.directive';
	// import { CalendarEventDirective } from './branding/calendar-event.directive';
	// import { SecondaryButtonDirective } from './branding/secondary-button.directive';
	// import { HyperLinkDirective } from './branding/hyper-link.directive';
	// import { PrimaryButtonDirective } from './branding/primary-button.directive';
	// import { TopBarItemDirective } from "./branding/top-bar-item.directive";
	var vehicle_occupancy_component_1 = __webpack_require__(503);
	var admin_dashboard_grid_component_1 = __webpack_require__(506);
	var admin_dashboard_filter_component_1 = __webpack_require__(508);
	var admin_dashboard_component_1 = __webpack_require__(512);
	var language_herlper_api_component_1 = __webpack_require__(526);
	var odometerlogtrail_update_component_1 = __webpack_require__(527);
	var odometerlogtrail_list_component_1 = __webpack_require__(532);
	var decimal_formatter_service_1 = __webpack_require__(69);
	var decimal_formatter_pipe_1 = __webpack_require__(534);
	var language_herlper_component_1 = __webpack_require__(535);
	var geo_location_map_component_1 = __webpack_require__(536);
	var vtshistory_list_component_1 = __webpack_require__(545);
	var event_viewer_component_1 = __webpack_require__(548);
	var vehiclefuturebooking_list_component_1 = __webpack_require__(552);
	var tripdetailreport_components_1 = __webpack_require__(555);
	var vehicle_information_component_1 = __webpack_require__(560);
	var report_damage_popup_component_1 = __webpack_require__(565);
	var svgdriver_list_component_1 = __webpack_require__(569);
	var booking_overview_driver_component_1 = __webpack_require__(572);
	var confirm_booking_driver_component_1 = __webpack_require__(576);
	var vehicle_overview_driver_component_1 = __webpack_require__(580);
	var filter_vehicle_overview_driver_component_1 = __webpack_require__(582);
	var scheduler_booking_driver_component_1 = __webpack_require__(584);
	var search_booking_driver_component_1 = __webpack_require__(588);
	var booking_driver_component_1 = __webpack_require__(590);
	var driver_profile_component_1 = __webpack_require__(596);
	var driver_dashboard_component_1 = __webpack_require__(600);
	var ng2_popover_1 = __webpack_require__(605);
	var inbox_driver_component_1 = __webpack_require__(608);
	var driver_search_list_component_1 = __webpack_require__(611);
	var search_filter_component_1 = __webpack_require__(612);
	var driver_role_component_1 = __webpack_require__(618);
	var driver_navbar_component_1 = __webpack_require__(619);
	var driver_footer_component_1 = __webpack_require__(628);
	var personprofilesuccess_componets_1 = __webpack_require__(630);
	var personprofilefailure_componets_1 = __webpack_require__(635);
	var personprofile_componets_1 = __webpack_require__(636);
	var underconstruction_component_1 = __webpack_require__(642);
	var link_expired_compontnet_1 = __webpack_require__(643);
	var forgotpassword_component_1 = __webpack_require__(644);
	var changepasswordsuccess_component_1 = __webpack_require__(648);
	var changepassword_component_1 = __webpack_require__(650);
	var gadmin_component_1 = __webpack_require__(652);
	var cadmin_component_1 = __webpack_require__(653);
	// import { AssignVehicleGroupPopupComponent } from './vehicle/components/assign-vehicle-group-popup.component';
	// import { VehicleSVGListComponent } from './vehicle/components/vehicle-svg-list.component';
	var inbox_view_component_1 = __webpack_require__(654);
	var inbox_list_component_1 = __webpack_require__(656);
	var inbox_component_1 = __webpack_require__(658);
	var editor_component_1 = __webpack_require__(660);
	var template_update_component_1 = __webpack_require__(661);
	var userprofile_componets_1 = __webpack_require__(666);
	var changepassword_popup_component_1 = __webpack_require__(668);
	var progressbar_1 = __webpack_require__(671);
	var alert_1 = __webpack_require__(676);
	var flatpickr_directive_1 = __webpack_require__(82);
	var vehicle_overview_component_1 = __webpack_require__(679);
	var search_booking_component_1 = __webpack_require__(591);
	var scheduler_booking_component_1 = __webpack_require__(681);
	var filter_vehicle_overview_component_1 = __webpack_require__(683);
	var select_driver_popup_component_1 = __webpack_require__(685);
	var confirm_booking_component_1 = __webpack_require__(687);
	var booking_overview_component_1 = __webpack_require__(689);
	var booking_request_component_1 = __webpack_require__(691);
	var booking_history_component_1 = __webpack_require__(694);
	var booking_approve_component_1 = __webpack_require__(696);
	var booking_component_1 = __webpack_require__(698);
	var booking_information_component_1 = __webpack_require__(700);
	var booking_information2_component_1 = __webpack_require__(707);
	var booking_information3_component_1 = __webpack_require__(709);
	var driver_bookinginformation_component_1 = __webpack_require__(711);
	var select_vehicle_popup_component_1 = __webpack_require__(713);
	var special_booking_component_1 = __webpack_require__(715);
	var invoice_legacy_list_component_1 = __webpack_require__(718);
	var invoice_list_component_1 = __webpack_require__(722);
	var contractType_history_component_1 = __webpack_require__(725);
	var contractType_update_component_1 = __webpack_require__(728);
	var contractType_list_component_1 = __webpack_require__(732);
	var add_contracttypegroup_popup_component_1 = __webpack_require__(734);
	var contracttypegroup_update_component_1 = __webpack_require__(736);
	var contracttypegroup_list_component_1 = __webpack_require__(739);
	var sharedvehiclegroup_update_component_1 = __webpack_require__(741);
	var sharedvehicelsubscription_update_component_1 = __webpack_require__(751);
	var sharedvehiclesubscription_list_component_1 = __webpack_require__(755);
	var subscriptionavailabilityrestriction_list_component_1 = __webpack_require__(757);
	var subscriptionavailabilityrestriction_update_component_1 = __webpack_require__(759);
	var svgvehicle_list_component_1 = __webpack_require__(762);
	var add_groupvehicle_popup_component_1 = __webpack_require__(764);
	var add_sharedvehiclegroupadmin_popup_component_1 = __webpack_require__(766);
	var sharedvehiclegroupadmin_list_component_1 = __webpack_require__(770);
	var driversubscription_list_component_1 = __webpack_require__(773);
	var driverSVG_list_component_1 = __webpack_require__(775);
	var assign_driver_group_popup_component_1 = __webpack_require__(777);
	var template_list_component_1 = __webpack_require__(779);
	var add_wegoadmin_popup_component_1 = __webpack_require__(781);
	var wegoadmin_list_component_1 = __webpack_require__(784);
	var add_driver_popup_component_1 = __webpack_require__(786);
	var sharedvehiclegroup_list_component_1 = __webpack_require__(788);
	var driver_list_component_1 = __webpack_require__(790);
	var specialperiod_update_component_1 = __webpack_require__(792);
	var specialperiod_list_component_1 = __webpack_require__(796);
	var vehicleattribute_update_component_1 = __webpack_require__(798);
	var vehicleattribute_list_component_1 = __webpack_require__(802);
	var vehicleattributecategory_update_component_1 = __webpack_require__(804);
	var vehicleattributecategory_list_component_1 = __webpack_require__(807);
	var vehicle_update_component_1 = __webpack_require__(809);
	var vehicle_list_component_1 = __webpack_require__(812);
	var vtsvehicle_update_component_1 = __webpack_require__(814);
	var vtsvehicle_list_component_1 = __webpack_require__(816);
	var add_companyadmin_popup_component_1 = __webpack_require__(818);
	var companyAdmin_list_component_1 = __webpack_require__(822);
	var company_update_component_1 = __webpack_require__(824);
	var company_contact_popup_component_1 = __webpack_require__(832);
	var company_list_component_1 = __webpack_require__(834);
	var person_update_component_1 = __webpack_require__(836);
	var person_list_component_1 = __webpack_require__(839);
	var instance_update_component_1 = __webpack_require__(841);
	var read_more_pipe_1 = __webpack_require__(848);
	var server_error_pipe_1 = __webpack_require__(849);
	var confirm_popup_component_1 = __webpack_require__(850);
	var success_popup_component_1 = __webpack_require__(851);
	var auth_guard_driveradmin_service_1 = __webpack_require__(852);
	var auth_guard_gadmin_service_1 = __webpack_require__(853);
	var auth_guard_cadmin_service_1 = __webpack_require__(854);
	var auth_guard_wadmin_service_1 = __webpack_require__(855);
	var auth_guard_service_1 = __webpack_require__(856);
	var content_wrapper_component_1 = __webpack_require__(857);
	var wegoadmin_component_1 = __webpack_require__(858);
	var instance_list_component_1 = __webpack_require__(859);
	var search_list_component_1 = __webpack_require__(862);
	var sort_list_component_1 = __webpack_require__(863);
	var backoffice_component_1 = __webpack_require__(864);
	var trip_history_component_1 = __webpack_require__(867);
	var driver_tripinformation_component_1 = __webpack_require__(871);
	var translate_1 = __webpack_require__(631);
	var lodder_component_1 = __webpack_require__(874);
	var popup_lodder_component_1 = __webpack_require__(875);
	var auth_service_1 = __webpack_require__(58);
	var notfound_component_1 = __webpack_require__(876);
	var privacy_not_allow_component_1 = __webpack_require__(877);
	var unauthenticated_component_1 = __webpack_require__(878);
	var unauthorized_component_1 = __webpack_require__(879);
	var app_routing_module_1 = __webpack_require__(880);
	var login_component_1 = __webpack_require__(896);
	var core_1 = __webpack_require__(3);
	var platform_browser_1 = __webpack_require__(21);
	var forms_1 = __webpack_require__(826);
	var http_1 = __webpack_require__(59);
	var app_component_1 = __webpack_require__(1052);
	var admin_template_1 = __webpack_require__(1053);
	var ng2_bootstrap_1 = __webpack_require__(1061);
	var ng2_file_upload_1 = __webpack_require__(810);
	var google_address_autocomplete_1 = __webpack_require__(825);
	var import_person_csv_component_1 = __webpack_require__(884);
	var additionalfreeitems_update_component_1 = __webpack_require__(886);
	var select_driver_subscription_popup_component_1 = __webpack_require__(1229);
	var additionalfreeitems_list_component_1 = __webpack_require__(890);
	var bookingtrip_detail_popup_component_1 = __webpack_require__(1231);
	var driverlicencedetail_component_1 = __webpack_require__(892);
	var image_popup_component_1 = __webpack_require__(1233);
	var booking_expense_popup_component_1 = __webpack_require__(1234);
	var vts_troubleshoot_component_1 = __webpack_require__(899);
	var free_booking_popup_component_1 = __webpack_require__(1236);
	var calander_popup_component_1 = __webpack_require__(1239);
	var booking_info_popup_component_1 = __webpack_require__(1240);
	var signupformconfig_update_compnent_1 = __webpack_require__(908);
	var signup_component_1 = __webpack_require__(902);
	var signupformconfig_list_component_1 = __webpack_require__(910);
	var signup_list_component_1 = __webpack_require__(912);
	var confirm_signup_popup_component_1 = __webpack_require__(1241);
	var missing_iban_popup_component_1 = __webpack_require__(1243);
	var directdebit_file_list_component_1 = __webpack_require__(916);
	var batch_upload_person_component_1 = __webpack_require__(919);
	var create_directdebit_file_popup_component_1 = __webpack_require__(1245);
	var directdebit_collection_date_popup_component_1 = __webpack_require__(1247);
	var assign_to_svg_popup_component_1 = __webpack_require__(1249);
	var report_filter_component_1 = __webpack_require__(1251);
	var maintenance_planning_component_1 = __webpack_require__(922);
	var revenue_per_vehicle_component_1 = __webpack_require__(925);
	var tripdatareport_component_1 = __webpack_require__(928);
	var organization_update_component_1 = __webpack_require__(934);
	var organization_list_component_1 = __webpack_require__(937);
	var organization_contact_popup_component_1 = __webpack_require__(1254);
	var organizationAdmin_list_component_1 = __webpack_require__(939);
	var add_organizationadmin_popup_component_1 = __webpack_require__(1256);
	var orgadmin_component_1 = __webpack_require__(942);
	var auth_guard_orgadmin_service_1 = __webpack_require__(943);
	var organizationdriver_list_component_1 = __webpack_require__(944);
	var snail_trail_driver_popup_component_1 = __webpack_require__(1259);
	var snail_trail_booking_popup_component_1 = __webpack_require__(1261);
	var snail_trail_vehicle_popup_component_1 = __webpack_require__(1263);
	var booking_vehicle_popup_component_1 = __webpack_require__(1265);
	var booking_driver_popup_component_1 = __webpack_require__(1267);
	var booking_request_admin_popup_component_1 = __webpack_require__(1269);
	var booking_svg_popup_component_1 = __webpack_require__(1271);
	var customer_list_component_1 = __webpack_require__(946);
	var customer_update_component_1 = __webpack_require__(948);
	var role_list_component_1 = __webpack_require__(951);
	var role_update_component_1 = __webpack_require__(954);
	var copy_role_popup_component_1 = __webpack_require__(1273);
	var roleavailability_list_component_1 = __webpack_require__(957);
	var roleavailability_update_popup_component_1 = __webpack_require__(1275);
	var save_roleavailability_popup_component_1 = __webpack_require__(1277);
	var assign_role_to_customer_popup_component_1 = __webpack_require__(1279);
	var admin_of_customer_list_component_1 = __webpack_require__(961);
	var admin_of_sharedvehiclegroup_list_component_1 = __webpack_require__(977);
	var admin_of_instance_list_component_1 = __webpack_require__(965);
	var admin_invitation_component_1 = __webpack_require__(968);
	var admin_invitation_accept_component_1 = __webpack_require__(972);
	var admin_invitation_reject_component_1 = __webpack_require__(973);
	var invite_admin_popup_component_1 = __webpack_require__(1281);
	var admin_of_comapny_list_component_1 = __webpack_require__(974);
	var admin_of_organization_list_component_1 = __webpack_require__(980);
	var organization_subscription_list_component_1 = __webpack_require__(983);
	var organization_subscription_popup_component_1 = __webpack_require__(1283);
	var organization_driver_list_component_1 = __webpack_require__(986);
	var organization_driver_popup_component_1 = __webpack_require__(1286);
	var invite_driver_popup_component_1 = __webpack_require__(1289);
	var admin_component_1 = __webpack_require__(989);
	var autorized_link_component_1 = __webpack_require__(1291);
	var vat_setting_popup_component_1 = __webpack_require__(1292);
	var vat_setting_component_1 = __webpack_require__(1294);
	var report_filter_customer_component_1 = __webpack_require__(1296);
	var auth_guard_home_page_service_1 = __webpack_require__(990);
	var errorlog_list_component_1 = __webpack_require__(991);
	var interfacestatus_list_component_1 = __webpack_require__(999);
	var errorescalation_list_component_1 = __webpack_require__(995);
	var errorescalation_update_component_1 = __webpack_require__(1003);
	var cost_expenses_list_components_1 = __webpack_require__(1009);
	var costandexpense_person_popup_component_1 = __webpack_require__(1298);
	var confirm_costandexpense_popup_component_1 = __webpack_require__(1300);
	var invoice_update_component_1 = __webpack_require__(1005);
	var invoice_driver_popup_component_1 = __webpack_require__(1302);
	var invoice_organization_popup_component_1 = __webpack_require__(1304);
	var manual_invoice_line_component_1 = __webpack_require__(1306);
	var terms_condition_list_component_1 = __webpack_require__(881);
	var terms_condition_update_component_1 = __webpack_require__(1019);
	var terms_condition_popup_component_1 = __webpack_require__(1021);
	var terms_and_conditions_popup_component_1 = __webpack_require__(1308);
	var kickback_component_1 = __webpack_require__(1012);
	var kickback_data_grid_component_1 = __webpack_require__(1310);
	var invoicing_setting_component_1 = __webpack_require__(1312);
	var cost_expenses_driver_list_components_1 = __webpack_require__(1015);
	var costandexpense_driver_popup_component_1 = __webpack_require__(1314);
	var confirm_costandexpense_driver_popup_component_1 = __webpack_require__(1316);
	var manual_invoice_line_update_component_1 = __webpack_require__(1318);
	var cost_added_by_admin_popup_component_1 = __webpack_require__(1320);
	var rounding_formatter_service_1 = __webpack_require__(1007);
	var rounding_formatter_pipe_1 = __webpack_require__(1322);
	var safe_html_pipe_1 = __webpack_require__(1323);
	var invoice_payment_history_component_1 = __webpack_require__(1017);
	var cost_center_report_component_1 = __webpack_require__(1024);
	var report_filter_cost_center_component_1 = __webpack_require__(1324);
	var select_costtype_popup_component_1 = __webpack_require__(1326);
	var organization_driver_list_popup_component_1 = __webpack_require__(1329);
	var select_vehicle_cost_center_popup_component_1 = __webpack_require__(1331);
	var snail_trail_driver_booking_popup_component_1 = __webpack_require__(1333);
	var snail_trail_driver_filter_component_1 = __webpack_require__(1335);
	var snail_trail_driver_component_1 = __webpack_require__(1028);
	var privacy_popup_component_1 = __webpack_require__(1337);
	var pre_post_trip_question_component_1 = __webpack_require__(743);
	var pre_post_trip_question_update_component_1 = __webpack_require__(1339);
	var pre_post_trip_question_overview_components_1 = __webpack_require__(1034);
	var pre_post_question_search_component_1 = __webpack_require__(1341);
	var terms_condition_company_popup_component_1 = __webpack_require__(1343);
	var image_slider_popup_component_1 = __webpack_require__(1345);
	var carousel_1 = __webpack_require__(1072);
	var privacy_statement_popup_component_1 = __webpack_require__(1038);
	var tc_activity_log_popup_component_1 = __webpack_require__(1348);
	var tc_activity_log_driver_component_1 = __webpack_require__(1032);
	var terms_and_conditions_revoke_popup_component_1 = __webpack_require__(1350);
	var terms_and_conditions_accept_reject_popup_component_1 = __webpack_require__(1352);
	var creditcard_payment_popup_component_1 = __webpack_require__(1354);
	var creditcard_payment_success_component_1 = __webpack_require__(1040);
	var creditcard_payment_failure_component_1 = __webpack_require__(1043);
	var two_fa_selection_1 = __webpack_require__(1045);
	var two_fa_google_setup_1 = __webpack_require__(1048);
	var two_fa_email_otp_1 = __webpack_require__(1050);
	var tripcomment_popup_component_1 = __webpack_require__(1356);
	//import { TripOverviewDriverComponent } from "./trip-driver/components/trip-overview-driver.component";
	var AppModule = (function () {
	    function AppModule() {
	    }
	    AppModule = __decorate([
	        core_1.NgModule({
	            imports: [
	                platform_browser_1.BrowserModule,
	                forms_1.FormsModule,
	                http_1.HttpModule,
	                app_routing_module_1.AppRoutingModule,
	                ng2_bootstrap_1.DropdownModule,
	                ng2_bootstrap_1.PaginationModule,
	                ng2_bootstrap_1.ModalModule,
	                alert_1.AlertModule,
	                progressbar_1.ProgressbarModule,
	                ng2_popover_1.PopoverModule,
	                ngx_color_picker_1.ColorPickerModule,
	                carousel_1.CarouselModule
	            ],
	            declarations: [
	                app_component_1.AppComponent,
	                login_component_1.LoginComponent,
	                notfound_component_1.NotFoundComponent,
	                privacy_not_allow_component_1.PrivacyNotAllowComponent,
	                unauthenticated_component_1.UnAuthenticatedComponent,
	                unauthorized_component_1.UnAuthorizedComponent,
	                // Branding Directives
	                branding_component_1.BrandingComponent,
	                // TopBarItemDirective, PrimaryButtonDirective, SecondaryButtonDirective, HyperLinkDirective,
	                // CalendarEventDirective, HighLightDirective, ActiveMenuItemDirective,
	                flatpickr_directive_1.FlatPickrDirective,
	                editor_component_1.TinymceEditorComponent,
	                lodder_component_1.LodderComponent,
	                popup_lodder_component_1.PopupLodderComponent,
	                translate_1.TranslatePipe,
	                safe_html_pipe_1.SafeHtmlPipe,
	                server_error_pipe_1.ServerErrorMessagePipe,
	                read_more_pipe_1.ReadMorePipe,
	                decimal_formatter_pipe_1.DecimalFormatterPipe,
	                rounding_formatter_pipe_1.RoundingFormatterPipe,
	                admin_template_1.NavbarComponent,
	                admin_template_1.SidebarComponent,
	                admin_template_1.MenuItem,
	                admin_template_1.FooterComponent,
	                content_wrapper_component_1.ContentWrapperComponent,
	                driver_navbar_component_1.DriverNavBarComponent,
	                driver_footer_component_1.DriverFooterComponent,
	                search_list_component_1.SearchListComponent,
	                sort_list_component_1.SortListComponent,
	                driver_search_list_component_1.DriverSearchListComponent,
	                search_filter_component_1.SearchFilterComponent,
	                success_popup_component_1.SuccessPopupComponent,
	                confirm_popup_component_1.ConfirmPopupComponent,
	                //GeoLocationPopupComponent,
	                backoffice_component_1.BackofficeComponent,
	                wegoadmin_component_1.WegoAdminComponent,
	                cadmin_component_1.CAdminComponent,
	                gadmin_component_1.GAdminComponent,
	                driver_role_component_1.DriverRoleComponent,
	                orgadmin_component_1.OrgAdminComponent,
	                driver_dashboard_component_1.DriverDashboardComponent,
	                admin_dashboard_component_1.AdminDashboardComponent,
	                admin_dashboard_filter_component_1.AdminDashboardFilterComponent,
	                admin_dashboard_grid_component_1.AdminDashboardGridComponent,
	                instance_list_component_1.InstanceListComponent,
	                instance_update_component_1.InstanceUpdateComponent,
	                person_list_component_1.PersonListComponent,
	                person_update_component_1.PersonUpdateComponent,
	                company_list_component_1.CompanyListComponent,
	                company_update_component_1.CompanyUpdateComponent,
	                company_contact_popup_component_1.CompanyContactPopupComponent,
	                companyAdmin_list_component_1.CompanyAdminListComponent,
	                add_companyadmin_popup_component_1.AddCompanyAdminPopupComponent,
	                vehicle_list_component_1.VehicleListComponent,
	                vehicle_update_component_1.VehicleUpdateComponent,
	                vtsvehicle_update_component_1.VtsVehicleUpdateComponent,
	                vtsvehicle_list_component_1.VtsVehicleListComponent,
	                vehicleattributecategory_list_component_1.VehicleAttributeCategoryListComponent,
	                vehicleattributecategory_update_component_1.VehicleAttributeCategoryUpdateComponent,
	                vehiclefuturebooking_list_component_1.VehicleFutureBookingListComponent,
	                vehicleattribute_list_component_1.VehicleAttributeListComponent,
	                vehicleattribute_update_component_1.VehicleAttributeUpdateComponent,
	                vehicle_information_component_1.VehicleInformationComponent,
	                specialperiod_list_component_1.SpecialPeriodListComponent,
	                specialperiod_update_component_1.SpecialPeriodUpdateComponent,
	                driver_list_component_1.DriverListComponent,
	                add_driver_popup_component_1.AddDriverPopupComponent,
	                assign_driver_group_popup_component_1.AssignDriverGroupPopupComponent,
	                driverSVG_list_component_1.DriverSVGListComponent,
	                driversubscription_list_component_1.DriverSubscriptionListComponent,
	                sharedvehiclegroup_list_component_1.SharedVehicleGroupListComponent,
	                sharedvehiclegroup_update_component_1.SharedVehicleGroupUpdateComponent,
	                sharedvehiclegroupadmin_list_component_1.SharedVehicleGroupAdminListComponent,
	                add_sharedvehiclegroupadmin_popup_component_1.AddSharedVehicleGroupAdminPopupComponent,
	                add_groupvehicle_popup_component_1.AddGroupVehiclePopupComponent,
	                svgvehicle_list_component_1.SVGVehicleComponent,
	                svgdriver_list_component_1.SVGDriverComponent,
	                wegoadmin_list_component_1.WegoAdminListComponent,
	                add_wegoadmin_popup_component_1.AddWegoAdminPopupComponent,
	                template_list_component_1.TemplateListComponent,
	                template_update_component_1.TemplateUpdateComponent,
	                sharedvehiclesubscription_list_component_1.SubscriptionListComponent,
	                sharedvehicelsubscription_update_component_1.SubscriptionUpdateComponent,
	                contracttypegroup_list_component_1.ContractTypeGroupListComponent,
	                contracttypegroup_update_component_1.ContractTypeGroupUpdateComponent,
	                add_contracttypegroup_popup_component_1.InActiveContractTypeGroupPopupComponent,
	                contractType_list_component_1.ContractTypeListComponent,
	                contractType_update_component_1.ContractTypeUpdateComponent,
	                contractType_history_component_1.ContractTypeHistoryComponent,
	                invoice_legacy_list_component_1.InvoiceLegacyListComponent,
	                invoice_list_component_1.InvoiceListComponent,
	                special_booking_component_1.SpecialBookingComponent,
	                select_vehicle_popup_component_1.SelectVehiclePopupComponent,
	                booking_component_1.BookingComponent,
	                booking_approve_component_1.BookingApproveComponent,
	                booking_history_component_1.BookingHistoryComponent,
	                booking_information_component_1.BookingInformationComponent,
	                booking_information2_component_1.BookingInformationComponent2,
	                booking_information3_component_1.BookingInformationComponent3,
	                driver_bookinginformation_component_1.DriverBookingInformationComponent,
	                booking_overview_component_1.BookingOverviewComponent,
	                booking_request_component_1.BookingRequestComponent,
	                booking_history_component_1.BookingHistoryComponent,
	                report_damage_popup_component_1.ReportDamagePopupComponent,
	                terms_condition_list_component_1.TermsAndConditionComponent,
	                confirm_booking_component_1.ConfirmBookingComponent,
	                select_driver_popup_component_1.SelectDriverPopupComponent,
	                filter_vehicle_overview_component_1.FilterVehicleOverviewComponent,
	                scheduler_booking_component_1.SchedularBookingComponent,
	                search_booking_component_1.SearchBookingComponent,
	                vehicle_overview_component_1.VehicleOverviewComponent,
	                changepassword_popup_component_1.ChangePasswordPopupComponent,
	                userprofile_componets_1.UserProfile,
	                inbox_component_1.InboxComponent,
	                inbox_list_component_1.InboxListComponent,
	                inbox_view_component_1.InboxViewComponent,
	                inbox_driver_component_1.InboxDriverListComponent,
	                trip_history_component_1.TripHistoryComponent,
	                driver_tripinformation_component_1.DriverTripInformationComponent,
	                // VehicleSVGListComponent, AssignVehicleGroupPopupComponent,
	                changepassword_component_1.ChangePasswordComponent,
	                changepasswordsuccess_component_1.ChangePasswordSuccessComponent,
	                forgotpassword_component_1.ForgotPasswordComponent,
	                link_expired_compontnet_1.LinkExpiredComponent,
	                underconstruction_component_1.UnderConstructionComponent,
	                personprofile_componets_1.PersonProfile,
	                personprofilefailure_componets_1.PersonProfileFailurComponent,
	                personprofilesuccess_componets_1.PersonProfileSuccessComponent,
	                ng2_file_upload_1.FileSelectDirective,
	                google_address_autocomplete_1.GoogleplaceDirective,
	                booking_driver_component_1.BookingDriverComponent,
	                search_booking_driver_component_1.SearchBookingDriverComponent,
	                scheduler_booking_driver_component_1.SchedularBookingDriverComponent,
	                booking_overview_driver_component_1.BookingOverviewDriverComponent,
	                filter_vehicle_overview_driver_component_1.FilterVehicleOverviewDriverComponent,
	                vehicle_overview_driver_component_1.VehicleOverviewDriverComponent,
	                confirm_booking_driver_component_1.ConfirmBookingDriverComponent,
	                personprofile_componets_1.PersonProfile,
	                personprofilefailure_componets_1.PersonProfileFailurComponent,
	                personprofilesuccess_componets_1.PersonProfileSuccessComponent,
	                ng2_file_upload_1.FileSelectDirective,
	                driver_profile_component_1.DriverProfile,
	                import_person_csv_component_1.ImportPersonCsvComponent,
	                subscriptionavailabilityrestriction_update_component_1.SubscriptionaAvailabilityUpdateComponent,
	                subscriptionavailabilityrestriction_list_component_1.SubscriptionAvailabilityListComponent,
	                additionalfreeitems_update_component_1.AdditionalFreeItemsUpdateComponent,
	                select_driver_subscription_popup_component_1.SelectDriverSubscriptionPopupComponent,
	                additionalfreeitems_list_component_1.AdditionalFreeItemListComponent,
	                tripdetailreport_components_1.TripDetailReportComponent,
	                driverlicencedetail_component_1.DriverLicenceComponent,
	                bookingtrip_detail_popup_component_1.BookingTripDetailpopupComponent,
	                booking_expense_popup_component_1.BookingExpensePopupComponent,
	                image_popup_component_1.ImagePopupComponent,
	                event_viewer_component_1.EventViewerComponent,
	                pre_post_trip_question_component_1.PrePostTripQuestionComponent,
	                vts_troubleshoot_component_1.VTSTroubleshootComponent,
	                vtshistory_list_component_1.VTSHistoryListComponent,
	                free_booking_popup_component_1.FreeBookingpopupComponent,
	                geo_location_map_component_1.GeoLocationMapComponent,
	                calander_popup_component_1.CalanderPopupComponent,
	                language_herlper_component_1.LanguageHelperComponent,
	                language_herlper_api_component_1.LanguageHelperAPIComponent,
	                booking_info_popup_component_1.BookingInfoPopupComponent,
	                odometerlogtrail_list_component_1.OdometerLogTrailListComponent,
	                odometerlogtrail_update_component_1.OdometerLogTrailUpdateComponent,
	                signupformconfig_update_compnent_1.SignupFormConfigUpdateComponent,
	                signupformconfig_list_component_1.SignupFormConfigListComponent,
	                signup_list_component_1.SignupListComponent,
	                confirm_signup_popup_component_1.ConfirmSignupPopupComponent,
	                signup_component_1.SignUpComponent,
	                signup_list_component_1.SignupListComponent,
	                missing_iban_popup_component_1.MissingIBANPopupComponent,
	                directdebit_file_list_component_1.DirectDebitFileListComponent,
	                signup_component_1.SignUpComponent,
	                signup_list_component_1.SignupListComponent,
	                batch_upload_person_component_1.BatchUploadPersonComponent,
	                create_directdebit_file_popup_component_1.CreateDirectDebitFilePopupComponent,
	                directdebit_collection_date_popup_component_1.DirectdebitCollectionDatePopupComponent,
	                assign_to_svg_popup_component_1.AssignToSVGComponent,
	                vehicle_occupancy_component_1.VehicleOccupancy,
	                report_filter_component_1.ReportFilter,
	                pre_post_question_search_component_1.PrePostQuestionSearchComponent,
	                maintenance_planning_component_1.MaintenancePlanningReportComponent,
	                revenue_per_vehicle_component_1.RevenuepervehicleReportComponent,
	                tripdatareport_component_1.TripDataReportComponent,
	                organization_update_component_1.OrganizationUpdateComponent,
	                organization_list_component_1.OrganizationListComponent,
	                organization_contact_popup_component_1.OrganizationContactPopupComponent,
	                organizationAdmin_list_component_1.OrganizationAdminListComponent,
	                errorlog_list_component_1.ErrorLogListComponent,
	                errorescalation_list_component_1.ErrorEscalationComponent,
	                errorescalation_update_component_1.ErrorEscalationUpdateComponent,
	                interfacestatus_list_component_1.InterfaceStatusListComponent,
	                add_organizationadmin_popup_component_1.AddOrganizationAdminPopupComponent,
	                organizationdriver_list_component_1.OrganizationDriverComponent,
	                snail_trail_component_1.SnailTrailComponent,
	                snail_trail_filter_component_1.SnailTrailFilterComponent,
	                snail_trail_driver_popup_component_1.SnailTrailDriverPopupComponent,
	                snail_trail_booking_popup_component_1.SnailTrailBookingPopupComponent,
	                snail_trail_vehicle_popup_component_1.SnailTrailVehiclePopupComponent,
	                snail_trail_map_component_1.SnailTrailMapComponent,
	                booking_vehicle_popup_component_1.BookingVehiclePopupComponent,
	                booking_driver_popup_component_1.BookingDriverPopupComponent,
	                booking_svg_popup_component_1.BookingSvgPopupComponent,
	                customer_list_component_1.CustomerListComponent,
	                customer_update_component_1.CustomerUpdateComponent,
	                terms_condition_update_component_1.TermsAndConditionAddUpdateComponent,
	                terms_condition_popup_component_1.ViewTermsAndConditionPopupComponent,
	                booking_svg_popup_component_1.BookingSvgPopupComponent,
	                role_list_component_1.RoleListComponent,
	                role_update_component_1.RoleUpdateComponent,
	                copy_role_popup_component_1.CopyRolePopupComponent,
	                roleavailability_list_component_1.RoleAvailabilityListComponent,
	                roleavailability_update_popup_component_1.RoleAvailabilityPopupComponent,
	                assign_role_to_customer_popup_component_1.AssignRoleToCustomerComponent,
	                save_roleavailability_popup_component_1.SaveRoleAvailablityPopupComponent,
	                admin_of_customer_list_component_1.AdminOfCustomerListComponent,
	                admin_of_sharedvehiclegroup_list_component_1.AdminOfsharedVehicleGroupListComponent,
	                admin_of_instance_list_component_1.AdminOfInstanceListComponent,
	                admin_invitation_component_1.AdminInvitationComponent,
	                admin_invitation_accept_component_1.AdminInvitationAcceptComponent,
	                admin_invitation_reject_component_1.AdminInvitationRejectComponent,
	                invite_admin_popup_component_1.InviteAdminPopupComponent,
	                admin_of_comapny_list_component_1.AdminOfCompanyListComponent,
	                admin_of_organization_list_component_1.AdminOfOrganizationListComponent,
	                organization_subscription_list_component_1.OrganizationSubscriptionComponent,
	                organization_subscription_popup_component_1.AssignOrganizationSubscriptionPopupComponent,
	                organization_driver_list_component_1.OrganizationDriverListComponent,
	                organization_driver_popup_component_1.AssignOrganizationDriverPopupComponent,
	                invite_driver_popup_component_1.InviteDriverPopupComponent,
	                admin_component_1.AdminComponent,
	                autorized_link_component_1.AuthorizedLinkComponent,
	                vat_setting_popup_component_1.VatSettingsPopupComponent,
	                vat_setting_component_1.VatSettingsComponent,
	                cost_expenses_list_components_1.CostAndExpenseListComponent,
	                costandexpense_person_popup_component_1.CostAndExpensePersonPopupComponent,
	                confirm_costandexpense_popup_component_1.ConfirmCostAndExpenseComponent,
	                missing_iban_popup_component_1.MissingIBANPopupComponent,
	                invoice_update_component_1.InvoiceUpdateComponent,
	                invoice_driver_popup_component_1.InvoiceDriverPopupComponent,
	                invoice_organization_popup_component_1.InvoiceOrganizationPopupComponent,
	                manual_invoice_line_component_1.ManualInvoiceLinePopupComponent,
	                autorized_link_component_1.AuthorizedLinkComponent,
	                vat_setting_popup_component_1.VatSettingsPopupComponent,
	                vat_setting_component_1.VatSettingsComponent,
	                kickback_component_1.KickbackComponent,
	                report_filter_customer_component_1.ReportCustomerFilter,
	                cost_expenses_driver_list_components_1.CostAndExpenseListDriverComponent,
	                costandexpense_driver_popup_component_1.CostAndExpenseDriverPopupComponent,
	                confirm_costandexpense_driver_popup_component_1.ConfirmCostAndExpenseDriverComponent,
	                cost_added_by_admin_popup_component_1.CostAddedByAdminPopupComponent,
	                kickback_data_grid_component_1.KickbackDataGridComponent,
	                invoicing_setting_component_1.InvoicingSettingComponent,
	                manual_invoice_line_update_component_1.ManualInvoiceLineUpdatePopupComponent,
	                terms_and_conditions_popup_component_1.TermsAndConditionsPopup,
	                cost_center_report_component_1.CostCenterReportComponent,
	                report_filter_cost_center_component_1.ReportFilterCostCenterComponent,
	                select_costtype_popup_component_1.SelectCostTypePopupComponent,
	                organization_driver_list_popup_component_1.OrganizationDriverListPopupComponent,
	                select_vehicle_cost_center_popup_component_1.SelectVehicleListPopupComponent,
	                snail_trail_driver_booking_popup_component_1.SnailTrailDriverBookingPopupComponent,
	                snail_trail_driver_filter_component_1.SnailTrailDriverFilterComponent,
	                snail_trail_driver_component_1.SnailTrailDriverComponent,
	                manual_invoice_line_update_component_1.ManualInvoiceLineUpdatePopupComponent,
	                terms_and_conditions_popup_component_1.TermsAndConditionsPopup,
	                cost_center_report_component_1.CostCenterReportComponent,
	                report_filter_cost_center_component_1.ReportFilterCostCenterComponent,
	                select_costtype_popup_component_1.SelectCostTypePopupComponent,
	                organization_driver_list_popup_component_1.OrganizationDriverListPopupComponent,
	                select_vehicle_cost_center_popup_component_1.SelectVehicleListPopupComponent,
	                privacy_popup_component_1.PrivacyPopupComponent,
	                invoice_payment_history_component_1.InvoicePaymentHistoryListComponent,
	                manual_invoice_line_update_component_1.ManualInvoiceLineUpdatePopupComponent,
	                terms_and_conditions_popup_component_1.TermsAndConditionsPopup,
	                cost_center_report_component_1.CostCenterReportComponent,
	                report_filter_cost_center_component_1.ReportFilterCostCenterComponent,
	                select_costtype_popup_component_1.SelectCostTypePopupComponent,
	                organization_driver_list_popup_component_1.OrganizationDriverListPopupComponent,
	                select_vehicle_cost_center_popup_component_1.SelectVehicleListPopupComponent,
	                pre_post_trip_question_update_component_1.PrePostTripQuestionUpdateComponent,
	                pre_post_trip_question_overview_components_1.PrePostQuestionsOverviewComponent,
	                terms_condition_company_popup_component_1.CompanyPopupComponent,
	                image_slider_popup_component_1.ImageSliderComponent,
	                currency_formatter_pipe_1.CurrencyFormatterPipe,
	                privacy_statement_popup_component_1.ViewPrivacyStatementPopupComponent,
	                booking_request_admin_popup_component_1.BookingRequestAdminPopupComponent,
	                tc_activity_log_popup_component_1.TCActivityPopupComponent,
	                tc_activity_log_driver_component_1.TCActivityLogDriverComponent,
	                terms_and_conditions_revoke_popup_component_1.TermsAndConditionsRevokePopup,
	                terms_and_conditions_accept_reject_popup_component_1.TermsAndConditionsAcceptRejectPopup,
	                creditcard_payment_popup_component_1.CreditCardPaymentPopupComponent,
	                creditcard_payment_success_component_1.CreditCardPaymentSuccessComponent,
	                creditcard_payment_failure_component_1.CreditCardPaymentFailureComponent,
	                two_fa_selection_1.TwoFASelectionPopupComponent,
	                two_fa_google_setup_1.TwoFAGoogleSetupPopupComponent,
	                two_fa_email_otp_1.TwoFAEmailOTPPopupComponent,
	                tripcomment_popup_component_1.TripCommentComponent,
	            ],
	            bootstrap: [app_component_1.AppComponent],
	            providers: [
	                auth_service_1.AuthService,
	                auth_guard_service_1.AuthGuard,
	                auth_guard_admin_service_1.AdminAuthGuard,
	                auth_guard_home_page_service_1.HomePageAuthGuard,
	                auth_guard_wadmin_service_1.WAdminAuthGuard,
	                auth_guard_cadmin_service_1.CAdminAuthGuard,
	                auth_guard_gadmin_service_1.GAdminAuthGuard,
	                auth_guard_orgadmin_service_1.OrgAdminAuthGuard,
	                auth_guard_driveradmin_service_1.DriverAdminAuthGuard,
	                translate_1.TRANSLATION_PROVIDERS,
	                translate_1.TranslateService,
	                decimal_formatter_service_1.DecimalFormatterService,
	                rounding_formatter_service_1.RoundingFormatterService
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AppModule);
	    return AppModule;
	}());
	exports.AppModule = AppModule;


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var CurrencyFormatterPipe = (function () {
	    function CurrencyFormatterPipe() {
	    }
	    CurrencyFormatterPipe.prototype.transform = function (value, currencySymbol, isCurrencySymbolBefore) {
	        if (isCurrencySymbolBefore === void 0) { isCurrencySymbolBefore = true; }
	        return isCurrencySymbolBefore
	            ? currencySymbol + ' ' + value
	            : value + ' ' + currencySymbol;
	    };
	    CurrencyFormatterPipe = __decorate([
	        core_1.Pipe({ name: 'currencyFormatter' }), 
	        __metadata('design:paramtypes', [])
	    ], CurrencyFormatterPipe);
	    return CurrencyFormatterPipe;
	}());
	exports.CurrencyFormatterPipe = CurrencyFormatterPipe;


/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var Subject_1 = __webpack_require__(4);
	var Observable_1 = __webpack_require__(5);
	var auth_service_1 = __webpack_require__(58);
	var config_1 = __webpack_require__(60);
	var AdminAuthGuard = (function () {
	    function AdminAuthGuard(authService, router) {
	        this.authService = authService;
	        this.router = router;
	        this.showLoader = new Subject_1.Subject();
	    }
	    AdminAuthGuard.prototype.canActivate = function (route, state) {
	        if (this.authService.isAuthorized(config_1.UserRoles.ADMIN)) {
	            var permissionName = route.data["permission"];
	            var permissionType = route.data["permissionType"];
	            if (permissionName || permissionType) {
	                this.SetLoaderStatus(true);
	                return this.IsAuthorizeFor(permissionName, permissionType);
	            }
	            else {
	                return true;
	            }
	        }
	        // Store the attempted URL for redirecting
	        //this.authService.redirectUrl = state.url;
	        // Navigate to the login page
	        this.router.navigate(["/Unauthorized"]);
	        return false;
	    };
	    AdminAuthGuard.prototype.IsAuthorizeFor = function (permissionName, permissionType) {
	        var _this = this;
	        return this.authService
	            .IsAuthorizeURL(permissionName, permissionType)
	            .map(function (res) {
	            _this.SetLoaderStatus(false);
	            if (!res.data) {
	                _this.router.navigate(["/NotFound"]);
	            }
	            return res.data;
	        })
	            .catch(function (error) {
	            console.log(error);
	            _this.authService.HandleErrorStatusCode(error);
	            _this.SetLoaderStatus(false);
	            return Observable_1.Observable.of(false);
	            ;
	        });
	    };
	    AdminAuthGuard.prototype.GetLoaderStatus = function () {
	        return this.showLoader.asObservable();
	    };
	    AdminAuthGuard.prototype.SetLoaderStatus = function (value) {
	        this.showLoader.next(value);
	    };
	    AdminAuthGuard = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object])
	    ], AdminAuthGuard);
	    return AdminAuthGuard;
	    var _a, _b;
	}());
	exports.AdminAuthGuard = AdminAuthGuard;


/***/ },
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var router_1 = __webpack_require__(26);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var Observable_1 = __webpack_require__(5);
	var config_1 = __webpack_require__(60);
	// saveAs variable is used for the external javascript library reference to save the csv file
	var saveAs = __webpack_require__(61);
	var AuthService = (function () {
	    function AuthService(http, router) {
	        this.http = http;
	        this.router = router;
	        this.MODULE_NAME = {
	            PersonBatchUpload: "PersonBatchUpload",
	            DirectDebitFile: "DirectDebitFile",
	            CreateOrganization: "CreateOrganization",
	            MAINTAINANCE_PLANNING_REPORT: "MAINTAINANCE_PLANNING_REPORT",
	            REVENUE_PER_VEHICLE_REPORT: "REVENUE_PER_VEHICLE_REPORT",
	            TRIP_DATA_REPORT: "TRIP_DATA_REPORT",
	            VEHICLE_OCCUPENCY_REPORT: "VEHICLE_OCCUPENCY_REPORT",
	            SnailTrailReport: "SnailTrailReport",
	        };
	    }
	    AuthService.prototype.isLoggedIn = function () {
	        return localStorage.getItem("access_token") ? true : false;
	    };
	    AuthService.prototype.accessToken = function () {
	        return localStorage.getItem("access_token");
	    };
	    AuthService.prototype.isAuthorized = function (role) {
	        var currentRole = localStorage.getItem("current_role");
	        return currentRole && currentRole.toUpperCase() == role.toUpperCase()
	            ? true
	            : false;
	    };
	    AuthService.prototype.IsAdmin = function () {
	        var currentRole = localStorage.getItem("current_role");
	        return currentRole &&
	            currentRole.toUpperCase() == config_1.UserRoles.ADMIN.toUpperCase()
	            ? true
	            : false;
	    };
	    AuthService.prototype.IsWeGoAdmin = function () {
	        var currentRole = localStorage.getItem("current_role");
	        return currentRole &&
	            currentRole.toUpperCase() == config_1.UserRoles.WEGOADMIN.toUpperCase()
	            ? true
	            : false;
	    };
	    AuthService.prototype.IsCompanyAdmin = function () {
	        var currentRole = localStorage.getItem("current_role");
	        return currentRole &&
	            currentRole.toUpperCase() == config_1.UserRoles.COMPANYADMIN.toUpperCase()
	            ? true
	            : false;
	    };
	    AuthService.prototype.IsGroupAdmin = function () {
	        var currentRole = localStorage.getItem("current_role");
	        return currentRole &&
	            currentRole.toUpperCase() == config_1.UserRoles.GROUPADMIN.toUpperCase()
	            ? true
	            : false;
	    };
	    AuthService.prototype.IsOrganizationAdmin = function () {
	        var currentRole = localStorage.getItem("current_role");
	        return currentRole &&
	            currentRole.toUpperCase() == config_1.UserRoles.ORGANIZATIONADMIN.toUpperCase()
	            ? true
	            : false;
	    };
	    AuthService.prototype.IsDriver = function () {
	        var currentRole = localStorage.getItem("current_role");
	        return currentRole &&
	            currentRole.toUpperCase() == config_1.UserRoles.DRIVER.toUpperCase()
	            ? true
	            : false;
	    };
	    AuthService.prototype.GetCurrentRole = function () {
	        var currentRole = localStorage.getItem("current_role");
	        if (currentRole)
	            return currentRole;
	        else
	            return;
	    };
	    AuthService.prototype.GetHighestRoleLevel = function () {
	        var highest_role_level = localStorage.getItem("highest_role_level");
	        if (highest_role_level)
	            return parseInt(highest_role_level);
	        else
	            return 100;
	    };
	    AuthService.prototype.GetPersonHashId = function () {
	        var personHashId = localStorage.getItem("personMasterHashId");
	        if (personHashId)
	            return personHashId;
	        else
	            return;
	    };
	    AuthService.prototype.GetUserSetting = function () {
	        var userSetting = localStorage.getItem("user_setting");
	        if (userSetting)
	            return JSON.parse(userSetting);
	        else
	            return;
	    };
	    AuthService.prototype.getTwoFaMethod = function () {
	        var twoFamethod = localStorage.getItem("TwoFa_method");
	        if (twoFamethod)
	            return twoFamethod;
	        else
	            return;
	    };
	    AuthService.prototype.GetURL = function (url) {
	        var currentRole = localStorage.getItem("current_role") || "";
	        if (currentRole.toUpperCase() == config_1.UserRoles.ADMIN)
	            return "/admin/" + url;
	        if (currentRole.toUpperCase() == config_1.UserRoles.WEGOADMIN)
	            return "/wegoadmin/" + url;
	        else if (currentRole.toUpperCase() == config_1.UserRoles.COMPANYADMIN)
	            return "/cadmin/" + url;
	        else if (currentRole.toUpperCase() == config_1.UserRoles.GROUPADMIN)
	            return "/gadmin/" + url;
	        else if (currentRole.toUpperCase() == config_1.UserRoles.DRIVER)
	            return "/driver/" + url;
	        else if (currentRole.toUpperCase() == config_1.UserRoles.ORGANIZATIONADMIN)
	            return "/orgadmin/" + url;
	        else
	            return "/" + url;
	    };
	    AuthService.prototype.GetNotificationCount = function () {
	        var getNotificationInboxListUrl = config_1.WeGoConfig.API_GET_NOTIFICATION_COUNT;
	        var headers = this.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getNotificationInboxListUrl, options)
	            .map(this.HandleAPIResponse)
	            .catch(this.HandleAPIError);
	    };
	    AuthService.prototype.ResetNotificationCount = function () {
	        var getNotificationInboxListUrl = config_1.WeGoConfig.API_GET_RESET_NOTIFICATION_COUNT;
	        var headers = this.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getNotificationInboxListUrl, options)
	            .map(this.HandleAPIResponse)
	            .catch(this.HandleAPIError);
	    };
	    AuthService.prototype.Login = function (userName, password) {
	        var _this = this;
	        var getAccessToken = config_1.WeGoConfig.API_GET_LOGIN_ACCESS_TOKEN;
	        var headers = new http_1.Headers({
	            "Content-Type": "application/x-www-form-urlencoded",
	            Accept: "application/json",
	        });
	        // headers.append("computerId", computerId);
	        var options = new http_1.RequestOptions({ headers: headers });
	        var body = "grant_type=password" +
	            "&username=" +
	            encodeURIComponent(userName) +
	            "&password=" +
	            encodeURIComponent(password) +
	            "&client_id=" +
	            config_1.WeGoConfig.API_CLIENT_ID;
	        return this.http
	            .post(getAccessToken, body, options)
	            .map(function (res) {
	            var body = res.json();
	            return body || {};
	        })
	            .map(function (res) {
	            console.log(res);
	            if (res) {
	                localStorage.setItem("access_token", res.access_token);
	                localStorage.setItem("refresh_token", res.refresh_token);
	                localStorage.setItem("personMasterHashId", res.personMasterHashId);
	                var computerId = localStorage.getItem("computerId");
	                if (!computerId) {
	                    localStorage.setItem("computerId", res.userComputerId);
	                }
	                _this.redirectMsg = "";
	            }
	            return res;
	        })
	            .catch(function (error) {
	            // let body = error.json();
	            var body = { status: error.status };
	            return Observable_1.Observable.throw(body);
	        });
	    };
	    AuthService.prototype.Signout = function () {
	        var getBackOfficeSignoutUrl = config_1.WeGoConfig.API_GET_LOGOUT;
	        var headers = this.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getBackOfficeSignoutUrl, options)
	            .map(this.HandleAPIResponse)
	            .catch(this.HandleAPIError);
	    };
	    AuthService.prototype.UpdateUserLanguagePreference = function (language) {
	        var headers = this.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        var getPersonLanguageUrl = config_1.WeGoConfig.API_POST_UPDATE_PERSON_LANGUAGE + "?language=" + language;
	        return this.http
	            .get(getPersonLanguageUrl, options)
	            .map(this.HandleAPIResponse)
	            .catch(this.HandleAPIError);
	    };
	    AuthService.prototype.Logout = function () {
	        localStorage.removeItem("access_token");
	        localStorage.removeItem("refresh_token");
	        localStorage.removeItem("current_role");
	        localStorage.removeItem("user_setting");
	        localStorage.removeItem("personMasterHashId");
	        localStorage.removeItem("itemsPerPage");
	        localStorage.removeItem("language");
	        localStorage.removeItem("driverSelectedMenu");
	        this.redirectMsg = "";
	        RemoveBranding();
	    };
	    AuthService.prototype.GetHeader = function (accept, content) {
	        var acceptType = accept || "application/json";
	        var contentType = content || "application/json";
	        var access_token = localStorage.getItem("access_token");
	        var authorization = access_token ? "Bearer " + access_token : "";
	        var language = localStorage.getItem("language");
	        var accept_language = language ? language : "en";
	        var refresh = localStorage.getItem("refresh_token");
	        var refresh_token = refresh ? refresh : "";
	        var currentRole = localStorage.getItem("current_role");
	        var current_role = currentRole ? currentRole : "";
	        var computerId = localStorage.getItem("computerId");
	        var headers = new http_1.Headers({
	            "Content-Type": contentType,
	            Accept: acceptType,
	            Authorization: authorization,
	            "Accept-Language": accept_language,
	            RefreshToken: refresh_token,
	            CurrentRole: current_role,
	            ComputerId: computerId,
	        });
	        return headers;
	    };
	    // public GetHeaderVehicle(accept?: string, content?: string) {
	    //   let acceptType = accept || 'application/json';
	    //   let access_token = localStorage.getItem("access_token");
	    //   let authorization = access_token ? 'Bearer ' + access_token : '';
	    //   let language = localStorage.getItem("language");
	    //   let accept_language = language ? language : 'en';
	    //   let refresh = localStorage.getItem("refresh_token");
	    //   let refresh_token = refresh ? refresh : '';
	    //   let currentRole = localStorage.getItem("current_role");
	    //   let current_role = currentRole ? currentRole : '';
	    //   let headers = new Headers({
	    //     'Content-Type': 'application/x-www-form-urlencoded',
	    //     'Accept': acceptType,
	    //     'Authorization': authorization,
	    //     'Accept-Language': accept_language,
	    //     'RefreshToken': refresh_token,
	    //     'CurrentRole': current_role
	    //   });
	    //   return headers;
	    // }
	    AuthService.prototype.GetHeaderForFile = function (accept) {
	        var acceptType = accept || "application/json";
	        var access_token = localStorage.getItem("access_token");
	        var authorization = access_token ? "Bearer " + access_token : "";
	        var language = localStorage.getItem("language");
	        var accept_language = language ? language : "en";
	        var refresh = localStorage.getItem("refresh_token");
	        var refresh_token = refresh ? refresh : "";
	        var currentRole = localStorage.getItem("current_role");
	        var current_role = currentRole ? currentRole : "DRIVER";
	        var computerId = localStorage.getItem("computerId");
	        var headers = [];
	        headers.push({ name: "Accept", value: acceptType });
	        headers.push({ name: "Authorization", value: authorization });
	        headers.push({ name: "Accept-Language", value: accept_language });
	        headers.push({ name: "RefreshToken", value: refresh_token });
	        headers.push({ name: "CurrentRole", value: current_role });
	        headers.push({ name: "ComputerId", value: computerId });
	        return headers;
	    };
	    AuthService.prototype.DownloadFile = function (fileName, data) {
	        // let downloadLink = document.createElement("a");
	        // downloadLink.setAttribute("href", uri);
	        // downloadLink.setAttribute("download", fileName);
	        // downloadLink.setAttribute("target", "_blank");
	        // document.body.appendChild(downloadLink);
	        // downloadLink.click();
	        // document.body.removeChild(downloadLink);
	        var blob = new Blob([data], { type: "text/plain;charset=utf-8" });
	        saveAs(blob, fileName);
	    };
	    AuthService.prototype.IsAuthorizeURL = function (permissionName, permissionType, entity, entityId) {
	        if (entity === void 0) { entity = ""; }
	        if (entityId === void 0) { entityId = ""; }
	        var getPersonUrl = config_1.WeGoConfig.API_GET_IS_AUTHORIZE_URL +
	            "?permissionName=" +
	            permissionName +
	            "&permissionType=" +
	            permissionType +
	            "&entity=" +
	            entity +
	            "&entityId=" +
	            entityId;
	        var headers = this.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getPersonUrl, options)
	            .map(this.HandleAPIResponse)
	            .catch(this.HandleAPIError);
	    };
	    AuthService.prototype.IsAuthorizeForDualPermission = function (primaryPermissionName, primaryPermissionType, secondaryPermissionName, secondaryPermissionType, entity, entityId) {
	        if (entity === void 0) { entity = ""; }
	        if (entityId === void 0) { entityId = ""; }
	        var getPersonUrl = config_1.WeGoConfig.API_GET_IS_AUTHORIZE_FOR_DUAL_PERMISSION +
	            "?primaryPermissionName=" +
	            primaryPermissionName +
	            "&primaryPermissionType=" +
	            primaryPermissionType +
	            "&secondaryPermissionName=" +
	            secondaryPermissionName +
	            "&secondaryPermissionType=" +
	            secondaryPermissionType +
	            "&entity=" +
	            entity +
	            "&entityId=" +
	            entityId;
	        var headers = this.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getPersonUrl, options)
	            .map(this.HandleAPIResponse)
	            .catch(this.HandleAPIError);
	    };
	    AuthService.prototype.IsAuthorizeFor = function (moduleName) {
	        var getPersonUrl = config_1.WeGoConfig.API_GET_IS_AUTHORIZE_FOR + "?moduleName=" + moduleName;
	        var headers = this.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getPersonUrl, options)
	            .map(this.HandleAPIResponse)
	            .catch(this.HandleAPIError);
	    };
	    AuthService.prototype.GetBackOfficeMenu = function () {
	        var getPersonUrl = config_1.WeGoConfig.API_GET_BACKOFFICE_MENU;
	        var headers = this.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getPersonUrl, options)
	            .map(this.HandleAPIResponse)
	            .catch(this.HandleAPIError);
	    };
	    AuthService.prototype.HandleAPIListInput = function (input) {
	        var queryString;
	        if (input) {
	            var searchField_1 = "";
	            if (input.searchField && input.searchField.length > 0) {
	                input.searchField.forEach(function (element) {
	                    searchField_1 += "&searchField=" + element;
	                });
	            }
	            queryString =
	                "pageNo=" +
	                    input.currentPage +
	                    "&record=" +
	                    input.itemsPerPage +
	                    "&sortField=" +
	                    input.sortType +
	                    "&sortReverse=" +
	                    input.sortReverse +
	                    "&searchTerm=" +
	                    encodeURIComponent(input.searchTerm) +
	                    searchField_1;
	        }
	        return queryString;
	    };
	    AuthService.prototype.HandleAPIResponse = function (res) {
	        var body = res.json();
	        console.log(body);
	        return body || {};
	    };
	    AuthService.prototype.HandleAPIError = function (error) {
	        console.log(error);
	        return Observable_1.Observable.throw(error.status);
	    };
	    AuthService.prototype.HandleErrorStatusCode = function (error) {
	        if (error && error == "401") {
	            this.Logout();
	            this.redirectMsg =
	                "You don’t have an access to this page. Please try again with different user Role. Thank you!! Login again.";
	            this.router.navigate(["/"]);
	        }
	        else if (error && error == "403") {
	            this.Logout();
	            this.redirectMsg =
	                "Your session has expired due to no activities on website. Please Login again.";
	            this.router.navigate(["/"]);
	        }
	        else if (error && error == "404") {
	            //this.Logout();
	            this.router.navigate(["/NotFound"]);
	        }
	        else if (error && error == "412") {
	            this.router.navigate(["/privacy-not-allow"]);
	        }
	        else if (error && error == "400") {
	            return "Bad request error.";
	        }
	        else {
	            return error;
	        }
	    };
	    AuthService.prototype.RetriveFilter = function (key, dataListModel) {
	        if (dataListModel === void 0) { dataListModel = null; }
	        var prevParameters = localStorage.getItem(key);
	        if (prevParameters) {
	            localStorage.removeItem(key);
	            return JSON.parse(prevParameters);
	        }
	        else {
	            return new config_1.DataListModel();
	        }
	    };
	    AuthService.prototype.AssignFromStorage = function (key, model) {
	        var prevParameters = localStorage.getItem(key);
	        if (prevParameters) {
	            localStorage.removeItem(key);
	            return JSON.parse(prevParameters);
	        }
	        else {
	            return model;
	        }
	    };
	    AuthService.prototype.GetSearchParameters = function (datalistmodel, searchTerm, isReset) {
	        datalistmodel.searchTerm = searchTerm;
	        datalistmodel.currentPage = 1;
	        if (isReset) {
	            datalistmodel.sortType = "";
	            datalistmodel.sortReverse = false;
	            datalistmodel.itemsPerPage = config_1.WeGoConfig.GRID_MAX_DATA_SIZE;
	        }
	        return datalistmodel;
	    };
	    AuthService.prototype.SetFilter = function (key, dataListModel) {
	        localStorage.setItem(key, JSON.stringify(dataListModel));
	    };
	    AuthService.prototype.SaveToStorage = function (key, model) {
	        localStorage.setItem(key, JSON.stringify(model));
	    };
	    AuthService.prototype.CheckAccountActivationTermsConditionStatus = function () {
	        var getUrl = config_1.WeGoConfig.API_GET_CHECK_ACCOUNT_ACTIVATION_TERMS_CONDITION_STATUS;
	        var options = { headers: this.GetHeader() };
	        return this.http
	            .get(getUrl, options)
	            .map(this.HandleAPIResponse)
	            .catch(this.HandleAPIError);
	    };
	    AuthService.prototype.CheckAccountActivationPrivacyStatus = function () {
	        var getUrl = config_1.WeGoConfig.API_GET_CHECK_ACCOUNT_ACTIVATION_PRIVACYSTATEMENT_STATUS;
	        var options = { headers: this.GetHeader() };
	        return this.http
	            .get(getUrl, options)
	            .map(this.HandleAPIResponse)
	            .catch(this.HandleAPIError);
	    };
	    AuthService.prototype.GetResourceLabel = function (accept_language) {
	        var getInvoiceUrl = config_1.WeGoConfig.API_GET_RESOURCE_LABEL;
	        var headers = new http_1.Headers({
	            "Content-Type": "application/json",
	            Accept: "application/json",
	            "Accept-Language": accept_language,
	        });
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInvoiceUrl, options)
	            .map(this.HandleAPIResponse)
	            .catch(this.HandleAPIError);
	    };
	    AuthService.prototype.DownloadXlsFile = function (fileName, data) {
	        var blob = new Blob([data], {
	            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
	        });
	        saveAs(blob, fileName);
	    };
	    AuthService.prototype.GetTelephoneCountry = function () {
	        var getUrl = config_1.WeGoConfig.API_GET_TELEPHONE_COUNTRY;
	        var headers = this.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getUrl, options)
	            .map(this.HandleAPIResponse)
	            .catch(this.HandleAPIError);
	    };
	    AuthService.prototype.GetPersonCountry = function () {
	        var getUrl = config_1.WeGoConfig.API_GET_PERSON_COUNTRY_LIST;
	        var headers = this.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getUrl, options)
	            .map(this.HandleAPIResponse)
	            .catch(this.HandleAPIError);
	    };
	    AuthService.prototype.IsAuthorizedForPrePostQuestion = function (primaryPermissionName, primaryPermissionType, secondaryPermissionName, secondaryPermissionType, entity, entityId) {
	        if (entity === void 0) { entity = ""; }
	        if (entityId === void 0) { entityId = ""; }
	        var getPersonUrl = config_1.WeGoConfig.API_GET_IS_AUTHORIZE_FOR_PREPOST_QUESTION +
	            "?primaryPermissionName=" +
	            primaryPermissionName +
	            "&primaryPermissionType=" +
	            primaryPermissionType +
	            "&secondaryPermissionName=" +
	            secondaryPermissionName +
	            "&secondaryPermissionType=" +
	            secondaryPermissionType +
	            "&entity=" +
	            entity +
	            "&entityId=" +
	            entityId;
	        var headers = this.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getPersonUrl, options)
	            .map(this.HandleAPIResponse)
	            .catch(this.HandleAPIError);
	    };
	    AuthService.prototype.GetSsoConfig = function (subdomain) {
	        var getUrl = config_1.WeGoConfig.API_GET_SSO_CONFIG + "?subdomain=" + subdomain;
	        var headers = this.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getUrl, options)
	            .map(this.HandleAPIResponse)
	            .catch(this.HandleAPIError);
	    };
	    AuthService.prototype.GetSsoTokenAssertion = function (token) {
	        var _this = this;
	        var getUrl = config_1.WeGoConfig.API_GET_ASSERTION_SSO + token;
	        var headers = this.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getUrl, options)
	            .map(function (res) {
	            var body = res.json();
	            return body || {};
	        })
	            .map(function (res) {
	            console.log(res);
	            if (res) {
	                localStorage.setItem("access_token", res.access_token);
	                localStorage.setItem("refresh_token", res.refresh_token);
	                localStorage.setItem("personMasterHashId", res.personMasterHashId);
	                var computerId = localStorage.getItem("computerId");
	                if (!computerId) {
	                    localStorage.setItem("computerId", res.userComputerId);
	                }
	                _this.redirectMsg = "";
	            }
	            return res;
	        })
	            .catch(function (error) {
	            var body = { status: error.status };
	            return Observable_1.Observable.throw(body);
	        });
	    };
	    AuthService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object])
	    ], AuthService);
	    return AuthService;
	    var _a, _b;
	}());
	exports.AuthService = AuthService;


/***/ },
/* 59 */,
/* 60 */
/***/ function(module, exports) {

	"use strict";
	var LEGACY_API_BASE_URL = 'https://legacy-api.wego.app/';
	var GATEWAY_BASE_URL = 'https://api.wego.app/';
	var SSO_BASE_URL = GATEWAY_BASE_URL;
	var API_SERVER_URL = GATEWAY_BASE_URL + 'api/backoffice/v1/gateway/';
	var CONFIRMED_URL = 'https://wego.app/confirmed/index.html';
	exports.WeGoConfig = {
	    GATEWAY_BASE_URL: GATEWAY_BASE_URL,
	    LEGACY_API_BASE_URL: LEGACY_API_BASE_URL,
	    TELTONIKA_CONFIG_BASE_URL: GATEWAY_BASE_URL + 'teltonika',
	    INVERS_CONFIG_BASE_URL: "https://fleetcontrol.invers.com/inspect/C-",
	    APP_VERSION: "v3.3.1",
	    API_SERVER_URL: API_SERVER_URL,
	    GRID_MAX_PAGE_SIZE: 5,
	    GRID_MAX_DATA_SIZE: 10,
	    GRID_PAGGING: [10, 20, 50, 100],
	    NOTIFICATION_REFRESH_INTERVAL_SEC: 30,
	    ONLINE_PAYMENT_SERVICE_REFRESH_INTERVAL_SEC: 30,
	    API_CLIENT_ID: 'wegoBackoffice',
	    API_GOOGLE_MAP_URL: 'https://maps.googleapis.com/maps/api/geocode/json?sensor=false&key=AIzaSyD4J2ULaq2kZFRxfULmLqyWC5HEtns2JXo&latlng=',
	    API_GET_LOGIN_ACCESS_TOKEN: GATEWAY_BASE_URL + 'token',
	    API_GET_ROLE_BY_PERSON: API_SERVER_URL + 'api/Backoffice/GetRolesByPersonHashID',
	    API_GET_USER_SETTING_BY_PERSON: API_SERVER_URL + 'api/Backoffice/GetUserSettingByPersonHashID',
	    CONFIRMED_URL: CONFIRMED_URL,
	    FLATPICKR_DATE_TIME_FORMAT: 'd-m-Y H:i',
	    FLATPICKR_TIME_FORMAT: 'H:i',
	    FLATPICKR_DATE_FORMAT: 'd-m-Y',
	    WEGOADMIN_USER: 'wegoadmin',
	    HERE_MAP_AUTOCOMPLETION_URL: 'https://autocomplete.geocoder.api.here.com/6.2/suggest.json',
	    HERE_MAP_LOCATION_URL: 'https://geocoder.api.here.com/6.2/geocode.json',
	    HERE_MAP_REVERSE_GEOCODE_URL: 'https://revgeocode.search.hereapi.com/v1/revgeocode',
	    HERE_MAP_API_KEY: 'vhwGi_VH2seP-qvlCC9ricG-7gu9hA-1IFHPVZxLBy8',
	    HERE_MAP_APP_ID: 'cRmJl4dUw8q4uoLZnLyq',
	    HERE_MAP_APP_CODE: 'gOrxJBGaXLBnzZPF7Ba67A',
	    HERE_MAP_LOC_RADIUS: '250',
	    CURRENCY_ABBREVIATION: [
	        'AED',
	        'AFN',
	        'ALL',
	        'AMD',
	        'ANG',
	        'AOA',
	        'AQD',
	        'ARS',
	        'AUD',
	        'AZN',
	        'BAM',
	        'BBD',
	        'BGN',
	        'BHD',
	        'BIF',
	        'BMD',
	        'BND',
	        'BOB',
	        'BRL',
	        'BSD',
	        'BWP',
	        'BYR',
	        'BZD',
	        'CAD',
	        'CDF',
	        'CHF',
	        'CLP',
	        'CNY',
	        'COP',
	        'CRC',
	        'CUP',
	        'CVE',
	        'CYP',
	        'CZK',
	        'DJF',
	        'DKK',
	        'DOP',
	        'DZD',
	        'ECS',
	        'EEK',
	        'EGP',
	        'ETB',
	        'EUR',
	        'FJD',
	        'FKP',
	        'GBP',
	        'GEL',
	        'GGP',
	        'GHS',
	        'GIP',
	        'GMD',
	        'GNF',
	        'GTQ',
	        'GYD',
	        'HKD',
	        'HNL',
	        'HRK',
	        'HTG',
	        'HUF',
	        'IDR',
	        'ILS',
	        'INR',
	        'IQD',
	        'IRR',
	        'ISK',
	        'JMD',
	        'JOD',
	        'JPY',
	        'KES',
	        'KGS',
	        'KHR',
	        'KMF',
	        'KPW',
	        'KRW',
	        'KWD',
	        'KYD',
	        'KZT',
	        'LAK',
	        'LBP',
	        'LKR',
	        'LRD',
	        'LSL',
	        'LTL',
	        'LVL',
	        'LYD',
	        'MAD',
	        'MDL',
	        'MGA',
	        'MKD',
	        'MMK',
	        'MNT',
	        'MOP',
	        'MRO',
	        'MTL',
	        'MUR',
	        'MVR',
	        'MWK',
	        'MXN',
	        'MYR',
	        'MZN',
	        'NAD',
	        'NGN',
	        'NIO',
	        'NOK',
	        'NPR',
	        'NZD',
	        'OMR',
	        'PAB',
	        'PEN',
	        'PGK',
	        'PHP',
	        'PKR',
	        'PLN',
	        'PYG',
	        'QAR',
	        'RON',
	        'RSD',
	        'RUB',
	        'RWF',
	        'SAR',
	        'SBD',
	        'SCR',
	        'SDG',
	        'SEK',
	        'SGD',
	        'SKK',
	        'SLL',
	        'SOS',
	        'SRD',
	        'STD',
	        'SVC',
	        'SYP',
	        'SZL',
	        'THB',
	        'TJS',
	        'TMT',
	        'TND',
	        'TOP',
	        'TRY',
	        'TTD',
	        'TWD',
	        'TZS',
	        'UAH',
	        'UGX',
	        'USD',
	        'UYU',
	        'UZS',
	        'VEF',
	        'VND',
	        'VUV',
	        'XAF',
	        'XCD',
	        'XOF',
	        'XPF',
	        'YER',
	        'ZAR',
	        'ZMK',
	        'ZWD'
	    ],
	    PREFERRED_LANGUAGE: ['NL', 'DE', 'EN', 'FR', 'PT'],
	    TERMS_CONDITION_PRIVACYTYPE: ['T&C', 'Privacy'],
	    DEFAULT_GEOLOCATION: { Lat: 52.3702, Long: 4.89517 },
	    API_GET_IS_AUTHORIZE_FOR: API_SERVER_URL + 'api/HasRights/IsAuthorizeFor',
	    API_GET_IS_AUTHORIZE_URL: API_SERVER_URL + 'api/HasRights/IsAuthorizeURL',
	    API_GET_IS_AUTHORIZE_FOR_DUAL_PERMISSION: API_SERVER_URL + 'api/HasRights/IsAuthorizeForDualPermission',
	    API_GET_BACKOFFICE_MENU: API_SERVER_URL + 'api/HasRights/GetBackOfficeMenu',
	    API_GET_TELEPHONE_COUNTRY: API_SERVER_URL + 'api/Backoffice/GetTelephoneCountry',
	    API_GET_PERSON_COUNTRY_LIST: API_SERVER_URL + 'api/Backoffice/GetPersonCountryList',
	    //Branding
	    API_POST_UPDATE_BRANDING: API_SERVER_URL + 'api/Branding/UpdateBranding',
	    API_GET_BRANDING: API_SERVER_URL + 'api/Branding/GetBranding',
	    //PersonMaster
	    API_GET_PERSON_LIST: API_SERVER_URL + 'api/PersonMaster/GetAllPersonList',
	    API_GET_ADMIN_LIST: API_SERVER_URL + 'api/PersonMaster/GetAllAdminForBookingRequest',
	    API_GET_PERSON_BY_HASH: API_SERVER_URL + 'api/PersonMaster/GetPersonByHashID',
	    API_POST_PERSON_DETAIL: API_SERVER_URL + 'api/PersonMaster/UpdatePersonMaster',
	    API_DELETE_PERSON: API_SERVER_URL + 'api/PersonMaster/DeletePersonMaster',
	    API_RESET_PASSWORD_PERSON: API_SERVER_URL + 'api/PersonMaster/ResetPersonPassword',
	    API_EXPORT_PERSON_LIST: API_SERVER_URL + 'api/PersonMaster/ExportPerson',
	    API_POST_UPDATE_PERSON_LANGUAGE: API_SERVER_URL + 'api/PersonMaster/UpdateUserLanguagePreference',
	    API_RESEND_ACTIVATION_MAIL_URL: API_SERVER_URL + 'api/PersonMaster/ReSendActivationMail',
	    API_GET_PROFILE_DETAIL: API_SERVER_URL + 'api/PersonMaster/GetProfileDetail',
	    API_GET_CREDITCARD_DETAILS: API_SERVER_URL + 'api/PersonMaster/GetCreditCardDetails',
	    API_GET_PERSON_LIST_FOR_COST_EXPENSE_LIST: API_SERVER_URL + 'api/PersonMaster/GetPersonListForCostExpense',
	    API_UPDATE_PERSON_REMOVAL_DATE_URL: API_SERVER_URL + 'api/PersonMaster/UpdatePersonRemovalDate',
	    API_ACTIVATE_PERSON_URL: API_SERVER_URL + 'api/PersonMaster/ActivatePerson',
	    API_RESET_TWOFA_COOKIE_PERSON: API_SERVER_URL + 'api/PersonMaster/ResetTwoFaCookiesForPerson',
	    API_RESET_TWOFA_KEY_PERSON: API_SERVER_URL + 'api/PersonMaster/ResetTwoFaKeyForPerson',
	    //Instance Clone
	    API_CLONE_INSTANCE_DETAIL: API_SERVER_URL + 'api/Instance/CloneInstance',
	    //WegoAdmin
	    API_GET_WEGOADMIN_LIST: API_SERVER_URL + 'api/WegoAdmin/GetWegoAdminList',
	    API_GET_WEGOADMIN_PERSON_LIST: API_SERVER_URL + 'api/WegoAdmin/GetPersonList',
	    API_GET_WEGOADMIN: API_SERVER_URL + 'api/WegoAdmin/UpdateWegoAdmin',
	    API_DELETE_WEGOADMIN: API_SERVER_URL + 'api/WegoAdmin/DeleteWegoAdmin',
	    API_EXPORT_WEGOADMIN_LIST: API_SERVER_URL + 'api/WegoAdmin/ExportWegoAdmin',
	    API_GET_INACTIVEWEGOADMIN: API_SERVER_URL + 'api/WegoAdmin/InActiveWegoAdminMaster',
	    API_RESET_TWOFA_COOKIES_WEGOADMIN: API_SERVER_URL + 'api/WegoAdmin/ResetWegoAdminTwoFaCookies',
	    API_RESET_TWOFA_KEYS_WEGOADMIN: API_SERVER_URL + 'api/WegoAdmin/ResetWeGoAdminTwoFaKeys',
	    API_UPDATE_WEGOADMIN_TWOFA_VALIDITY: API_SERVER_URL + 'api/WegoAdmin/UpdateTwoFAValidityDays',
	    API_GET_TWOFA_KEYS_WEGOADMIN: API_SERVER_URL + 'api/WegoAdmin/GetTwoFAValidityDays',
	    //CompanyMaster
	    API_GET_COMPANY_LIST: API_SERVER_URL + 'api/CompanyMaster/GetAllCompanyList',
	    API_GET_COMPNAY_BY_HASH: API_SERVER_URL + 'api/CompanyMaster/GetCompanyByHashID',
	    API_GET_COMPANY_BASIC_DETAIL: API_SERVER_URL + 'api/CompanyMaster/GetCompanyBasicDetail',
	    API_POST_COMPANY_DETAIL: API_SERVER_URL + 'api/CompanyMaster/UpdateCompanyMaster',
	    API_UPDATE_COMPANY_CONTACT_PERSON: API_SERVER_URL + 'api/CompanyMaster/UpdateCompanyContactPerson',
	    API_EXPORT_COMPANY_LIST: API_SERVER_URL + 'api/CompanyMaster/ExportCompany',
	    API_POST_DELETE_COMPANY: API_SERVER_URL + 'api/CompanyMaster/DeleteCompanyMasterList',
	    API_REMOVE_COMPANY_CONTACT_PERSON: API_SERVER_URL + 'api/CompanyMaster/RemoveCompanyContactPerson',
	    API_GET_GEOFENCE: API_SERVER_URL + 'api/CompanyMaster/IsGeofenceEnabled',
	    API_GET_LOCATION_MODE: API_SERVER_URL + 'api/CompanyMaster/IsHomeLocationEnabled',
	    API_GET_ODOMETER_CONFIG: API_SERVER_URL + 'api/CompanyMaster/IsOdometerConfigEnabled',
	    API_GET_INSTANCE_LANGUAGE_BY_COMPANY: API_SERVER_URL + 'api/CompanyMaster/GetInstanceLanguage',
	    API_GET_COMPANY_BY_INSTANCE: API_SERVER_URL + 'api/CompanyMaster/GetCompanyByInstance',
	    API_GET_COMPANY_BY_INSTANCEHASHID: API_SERVER_URL +
	        'api/CompanyMaster/GetDropdownCompanyListForPrePostTripQuestion',
	    API_GET_DROPDOWN_COMPANY_LIST_VEHICLEOCCUPANCYREPORT: API_SERVER_URL +
	        'api/CompanyMaster/GetDropdownCompanyListForVehicleOccupancyReport',
	    API_GET_DROPDOWN_COMPANY_LIST_REVENUEVEHICLEREPORT: API_SERVER_URL +
	        'api/CompanyMaster/GetDropdownCompanyListForRevenueVehicleReport',
	    API_GET_DROPDOWN_COMPANY_LIST_TRIPDATAREPORT: API_SERVER_URL + 'api/CompanyMaster/GetDropdownCompanyListFoTripDataReport',
	    API_GET_DROPDOWN_COMPANY_LIST_MAINTENCEPLANNINGREPORT: API_SERVER_URL +
	        'api/CompanyMaster/GetDropdownCompanyListForMaintencePlanningReport',
	    API_GET_DROPDOWN_COMPANY_LIST_SVG: API_SERVER_URL + 'api/CompanyMaster/GetDropdownCompanyListForSVG',
	    API_GET_DROPDOWN_COMPANY_LIST_ORGANIZATION: API_SERVER_URL + 'api/CompanyMaster/GetDropdownCompanyListForOrganization',
	    API_GET_DROPDOWN_COMPANY_LIST_VEHICLE: API_SERVER_URL + 'api/CompanyMaster/GetDropdownCompanyListForVehicle',
	    API_GET_DROPDOWN_COMPANY_LIST_BRANDING: API_SERVER_URL + 'api/CompanyMaster/GetDropdownCompanyListForBranding',
	    API_GET_DROPDOWN_COMPANY_LIST_DASHBOARD: API_SERVER_URL + 'api/CompanyMaster/GetDropdownCompanyListForDashboard',
	    API_GET_DROPDOWN_COMPANY_LIST_TEMPLATE: API_SERVER_URL + 'api/CompanyMaster/GetDropdownCompanyListForTemplate',
	    API_GET_DROPDOWN_COMPANY_LIST_INVOICE_UPDATE: API_SERVER_URL + 'api/CompanyMaster/GetDropdownCompanyListForInvoiceUpdate',
	    API_GET_DROPDOWN_COMPANY_LIST_PRE_POST_TRIP_QUESTION: API_SERVER_URL +
	        'api/CompanyMaster/GetDropdownCompanyListForPrePostTripQuestion',
	    API_GET_DROPDOWN_COMPANY_LIST_FOR_COST_CENTER_REPORT: API_SERVER_URL +
	        'api/CompanyMaster/GetDropdownCompanyListForCostCenterReport',
	    API_GET_DROPDOWN_COMAPNY_LIST_KICKBACKREPORT: API_SERVER_URL +
	        'api/CompanyMaster/GetDropdownCompanyListForKickBackReport',
	    API_GET_DROPDOWN_COMPANY_LIST_TERMS_AND_CONDITION: API_SERVER_URL +
	        'api/CompanyMaster/GetDropdownCompanyListForTermsAndCondition',
	    API_GET_DROPDOWN_COMPANY_LIST_BY_INSTANCE_LIST_TERMS_AND_CONDITION: API_SERVER_URL +
	        'api/CompanyMaster/GetDropdownCompanyListForTermsCondByInstanceList',
	    API_RESET_TWOFA_COOKIES_COMPANY: API_SERVER_URL + 'api/CompanyMaster/ResetCompanyAdminTwoFaCookies',
	    API_RESET_TWOFA_KEYS_COMPANY: API_SERVER_URL + 'api/CompanyMaster/ResetCompanyAdminTwoFaKeys',
	    API_GET_TWOFA_ENABLED_COMPANY: API_SERVER_URL + 'api/CompanyMaster/IsTwoFAEnabledForInstanceByCompany',
	    //CompanyAdmin
	    API_GET_COMPANY_ADMIN_LIST: API_SERVER_URL + 'api/CompanyAdmin/GetAllCompanyAdminListByCompany',
	    API_GET_PERSON_LIST_BY_COMPANY_ID: API_SERVER_URL + 'api/CompanyAdmin/GetPersonListForCompanyAdmin',
	    API_GET_COMPANY_CONATACT_PERSON_LIST: API_SERVER_URL + 'api/CompanyMaster/GetPersonListForContactPerson',
	    API_POST_COMPANY_ADMIN_DETAIL: API_SERVER_URL + 'api/CompanyAdmin/UpdateCompanyAdmin',
	    API_EXPORT_COMPANY_ADMIN_LIST: API_SERVER_URL + 'api/CompanyAdmin/ExportCompanyAdminListByCompany',
	    API_POST_DELETE_COMPANY_ADMIN: API_SERVER_URL + 'api/CompanyAdmin/DeleteCompanyAdminMasterList',
	    API_GET_INACTIVE_COMPANY_ADMIN: API_SERVER_URL + 'api/CompanyAdmin/InActiveCompanyAdmin',
	    //ErrorLog
	    // API_GET_ERRORLOG_LIST: API_SERVER_URL + 'api/ErrorLog/GetErrorLogList',
	    // API_GET_EXPORT_ERRORLOG: API_SERVER_URL + 'api/ErrorLog/ExportErrorLog',
	    API_GET_ERRORLOG_LIST: API_SERVER_URL + 'api/ErrorReporting/GetEventLog',
	    API_GET_EXPORT_ERRORLOG: API_SERVER_URL + 'api/ErrorReporting/ExportEventLog',
	    API_GET_DROPDOWN_ERRORLOGTYPE_LIST: API_SERVER_URL + 'api/ErrorReporting/GetDropdownLogTypeListForErroLog',
	    API_GET_DROPDOWN_ERRORLOGCOMPONENT_LIST: API_SERVER_URL + 'api/ErrorReporting/GetDropdownComponentListForErroLog',
	    //ErrorEscalation
	    API_GET_ErrorEscalation_LIST: API_SERVER_URL + 'api/ErrorEscalation/GetErrorEscalationConfigList',
	    API_GET_EXPORT_ErrorEscalation: API_SERVER_URL + 'api/ErrorEscalation/ExportErrorEscalation',
	    API_GET_DELETE_ERRORESCALATION: API_SERVER_URL + 'api/ErrorEscalation/DeleteErrorEscalation',
	    API_GET_ERRORESCALATION_BY_HASH: API_SERVER_URL + 'api/ErrorEscalation/GetErrorEsclationByHashID',
	    API_POST_ERRORESCALATION_DETAIL: API_SERVER_URL + 'api/ErrorEscalation/UpdateErrorEsclationConfig',
	    API_GET_DROPDOWN_ERRORESCLATION_LIST: API_SERVER_URL + 'api/ErrorEscalation/GetErrorEsclationDropDownData',
	    API_GET_INSTANCEADMINLISTBYINSTANCE_LIST: API_SERVER_URL + 'api/Instance/GetInstanceAdminListByInstance',
	    API_GET_CUSTOMERADMINLISTBYCUSTOMER_LIST: API_SERVER_URL + 'api/Customer/GetCustomerAdminListByCustomer',
	    API_GET_DROPDOWN_INSTANCE_LIST_ERRORESCLATION: API_SERVER_URL + 'api/Instance/GetDropdownInstanceListForErrorEsclation',
	    API_GET_DROPDOWN_INSTANCE_LIST_ERRORLOG: API_SERVER_URL + 'api/Instance/GetDropdownInstanceListForErrorLog',
	    // Interface Status
	    //API_GET_INTERFACESTATUS_LIST: API_SERVER_URL + 'api/InterfaceStatus/GetInterfaceStatusList',
	    API_GET_INTERFACESTATUS_LIST: API_SERVER_URL + 'api/CarwiseInterfaceStatus/GetCarwiseInterfaceStatus',
	    //API_GET_EXPORT_INTERFACESTATUS: API_SERVER_URL + 'api/InterfaceStatus/ExportInterfaceStatus',
	    API_GET_EXPORT_INTERFACESTATUS: API_SERVER_URL + 'api/CarwiseInterfaceStatus/ExportCarwiseStatus',
	    //OrganizationMaster
	    API_GET_ORGANIZATION_LIST: API_SERVER_URL + 'api/OrganizationMaster/GetAllOrganizationList',
	    API_POST_ORGANIZATION_BLOCKUNBLOCK: API_SERVER_URL + 'api/OrganizationMaster/BlockUnblockOrganization',
	    API_GET_ORGANIZATION_BY_HASH: API_SERVER_URL + 'api/OrganizationMaster/GetOrganizationByHashID',
	    API_GET_ORGANIZATION_BASIC_DETAIL: API_SERVER_URL + 'api/OrganizationMaster/GetOrganizationBasicDetail',
	    API_POST_ORGANIZATION_DETAIL: API_SERVER_URL + 'api/OrganizationMaster/UpdateOrganizationMaster',
	    API_UPDATE_ORGANIZATION_CONTACT_PERSON: API_SERVER_URL + 'api/OrganizationMaster/UpdateOrganizationContactPerson',
	    API_EXPORT_ORGANIZATION_LIST: API_SERVER_URL + 'api/OrganizationMaster/ExportOrganization',
	    API_POST_DELETE_ORGANIZATION: API_SERVER_URL + 'api/OrganizationMaster/DeleteOrganizationMasterList',
	    API_REMOVE_ORGANIZATION_CONTACT_PERSON: API_SERVER_URL + 'api/OrganizationMaster/RemoveOrganizationContactPerson',
	    API_EXPORT_ORGANIZATION_DRIVER_LIST: API_SERVER_URL + 'api/OrganizationMaster/ExportOrganizationDriver',
	    API_GET_ORGANIZATION_FOR_BATCH_UPLOAD: API_SERVER_URL + 'api/OrganizationMaster/GetOrgazationsForBatchUpload',
	    API_GET_ORGANIZATION_DRIVER_LIST: API_SERVER_URL + 'api/OrganizationMaster/GetAllOrganizationDriver',
	    //API_GET_ORGANIZATION_LIST_BY_INSTANCE: API_SERVER_URL + 'api/OrganizationMaster/GetOrganizationByInstanceID',
	    API_GET_ORGANIZATION_COMPANY_LIST: API_SERVER_URL + 'api/OrganizationMaster/GetAllCompanyList',
	    API_GET_DROPDOWN_ORGANIZATION_LIST_SIGNUPCONFIG: API_SERVER_URL +
	        'api/OrganizationMaster/GetDropdownOrganizationListForSignUpConfig',
	    API_GET_DROPDOWN_ORGANIZATION_LIST_BATCHUPLOADPERSON: API_SERVER_URL +
	        'api/OrganizationMaster/GetDropdownOrganizationListForBatchUploadPerson',
	    API_GET_DROPDOWN_ORGANIZATION_LIST_TEMPLATE: API_SERVER_URL +
	        'api/OrganizationMaster/GetDropdownOrganizationListForTemplate',
	    API_GET_DROPDOWN_ORGANIZATION_LIST_BY_SVG_KICK_BACK_REPORT: API_SERVER_URL +
	        'api/OrganizationMaster/GetDropdownOrganizationListForKickBackReport',
	    API_GET_DROPDOWN_ORGANIZATION_LIST_BY_SVG_TRIP_DATA_REPORT: API_SERVER_URL +
	        'api/OrganizationMaster/GetDropdownOrganizationListForTripDataReport',
	    API_GET_DROPDOWN_ORGANIZATION_LIST_COST_CENTER_REPORT: API_SERVER_URL +
	        'api/OrganizationMaster/GetDropdownOrganizationListForCostCenterReport',
	    API_GET_ORGANIZATION_GDPR_SETTINGS: API_SERVER_URL + 'api/OrganizationMaster/GetOrganizationGDPRSettings',
	    API_GET_DROPDOWN_ORGANIZATION_LIST_TERMS_AND_CONDITION: API_SERVER_URL +
	        'api/OrganizationMaster/GetDropdownOrganizationListForTermsAndCondition',
	    API_GET_DROPDOWN_ORGANIZATION_LIST_BY_COMPANY_LIST_TERMS_AND_CONDITION: API_SERVER_URL +
	        'api/OrganizationMaster/GetDropdownOrganizationListForTermsCondByCompanyList',
	    API_RESET_TWOFA_COOKIES_ORGANIZATION: API_SERVER_URL + 'api/OrganizationMaster/ResetOrganizationAdminTwoFaCookies',
	    API_RESET_TWOFA_KEYS_ORGANIZATION: API_SERVER_URL + 'api/OrganizationMaster/ResetOrganizationAdminTwoFaKeys',
	    API_GET_ORGANIZATION_DETAIL: API_SERVER_URL + 'api/OrganizationMaster/GetDropdownOrganizationListBySVG',
	    //ORGANIZATIONADMIN
	    API_GET_ORGANIZATION_ADMIN_LIST: API_SERVER_URL +
	        'api/OrganizationAdmin/GetAllOrganizationAdminListByOrganization',
	    API_GET_PERSON_LIST_BY_ORGANIZATION_ID: API_SERVER_URL + 'api/OrganizationAdmin/GetPersonListForOrganizationAdmin',
	    API_GET_ORGANIZATION_CONATACT_PERSON_LIST: API_SERVER_URL + 'api/OrganizationMaster/GetPersonListForContactPerson',
	    API_POST_ORGANIZATION_ADMIN_DETAIL: API_SERVER_URL + 'api/OrganizationAdmin/UpdateOrganizationAdmin',
	    API_EXPORT_ORGANIZATIONY_ADMIN_LIST: API_SERVER_URL +
	        'api/OrganizationAdmin/ExportOrganizationAdminListByOrganization',
	    API_POST_DELETE_ORGANIZATION_ADMIN: API_SERVER_URL + 'api/OrganizationAdmin/DeleteCompanyAdminMasterList',
	    API_GET_INACTIVE_ORGANIZATION_ADMIN: API_SERVER_URL + 'api/OrganizationAdmin/InActiveOrganizationAdmin',
	    //Driver Dashboard
	    API_GET_UPCOMING_BOOKING_LIST: API_SERVER_URL + 'api/DriverDashboard/GetUpcomingBooking',
	    // Admin Dashboard
	    API_GET_VEHICLE_WITH_STATUS: API_SERVER_URL + 'api/AdminDashboard/GetVehicleWithStatus',
	    API_GET_WINDOWS_SERVICE_STATUS: API_SERVER_URL + 'api/AdminDashboard/GetWindowsServiceStatus',
	    API_GET_PRIORITY_FOR_ISSUE: API_SERVER_URL + 'api/AdminDashboard/GetPriorityForIssues',
	    API_EXPORT_VEHICLE_WITH_STATUS_XLS: API_SERVER_URL + 'api/AdminDashboard/ExportVehicleWithStatusExcel',
	    API_GET_ONLINE_PAYMENT_SERVICE_STATUS: API_SERVER_URL + 'api/AdminDashboard/GetPaymentServiceStatus',
	    //Instance
	    API_GET_INSTANCE_LIST: API_SERVER_URL + 'api/Instance/GetAllInstance',
	    API_GET_INSTANCE_BY_HASH: API_SERVER_URL + 'api/Instance/GetInstanceByHashID',
	    API_GET_INSTANCE_BY_COMPANY_HASH: API_SERVER_URL + 'api/Instance/GetInstanceByCompanyHashID',
	    API_GET_INSTANCE_BASIC_DETAIL: API_SERVER_URL + 'api/Instance/GetInstanceBasicDetail',
	    API_POST_INSTANCE_DETAIL: API_SERVER_URL + 'api/Instance/UpdateInstance',
	    API_EXPORT_INSTANCE_LIST: API_SERVER_URL + 'api/Instance/ExportInstance',
	    API_DELETE_INSTANCE: API_SERVER_URL + 'api/Instance/DeleteInstance',
	    API_GET_IMPORT_ALLOWED_INSTANCE_LIST: API_SERVER_URL + 'api/Instance/GetImportAllowedInstance',
	    API_GET_IMPORT_ALLOWED_TO_USER: API_SERVER_URL + 'api/Instance/CheckIsAllowToImportPerson',
	    API_GET_ODOMETER_ENABLED: API_SERVER_URL + 'api/Instance/IsOdometerEnabled',
	    API_GET_BATCH_UPLOAD_ALLOW_TO_USER: API_SERVER_URL + 'api/Instance/CheckIsAllowToBatchUploadPerson',
	    API_GET_BATCH_UPLOAD_DETAIL_BY_HASH: API_SERVER_URL + 'api/Instance/GetBatchUploadDetailFromInstanceByHashID',
	    API_GET_INSTANCES_FOR_BATCH_UPLOAD: API_SERVER_URL + 'api/Instance/GetInstancesForBatchUpload',
	    API_GET_DIRECTDEBIT_ENABLED_COMPANY: API_SERVER_URL + 'api/Instance/IsDirectDebitEnabledForCompany',
	    API_GET_PAYMENTSETTING_REQUIRED_ON_INSTANCE: API_SERVER_URL + 'api/Instance/PaymentSettingRequired',
	    API_GET_DIRECTDEBIT_ENABLED: API_SERVER_URL + 'api/Instance/IsDirectDebitEnabled',
	    API_GET_INSTANCE_LANGUAGE: API_SERVER_URL + 'api/Instance/GetInstanceLanguage',
	    API_GET_NIF_NUMBER_ENABLED: API_SERVER_URL + 'api/Instance/IsNIFNumberEnabled',
	    API_GET_COUNTRYCODE: API_SERVER_URL + 'api/Instance/GetCountryCode',
	    API_GET_DROPDOWN_INSTANCE_LIST_VEHICLEOCCUPANCYREPORT: API_SERVER_URL +
	        'api/Instance/GetDropdownInstanceListForVehicleOccupancyReport',
	    API_GET_DROPDOWN_INSTANCE_LIST_REVENUEVEHICLEREPORT: API_SERVER_URL +
	        'api/Instance/GetDropdownInstanceListForRevenueVehicleReport',
	    API_GET_DROPDOWN_INSTANCE_LIST_TRIPDATAREPORT: API_SERVER_URL + 'api/Instance/GetDropdownInstanceListFoTripDataReport',
	    API_GET_DROPDOWN_INSTANCE_LIST_MAINTENCEPLANNINGREPORT: API_SERVER_URL +
	        'api/Instance/GetDropdownInstanceListForMaintencePlanningReport',
	    API_GET_DROPDOWN_INSTANCE_LIST_PERSON: API_SERVER_URL + 'api/Instance/GetDropdownInstanceListPerson',
	    API_GET_DROPDOWN_INSTANCE_LIST_CATEGORY_ATTRIBUTE: API_SERVER_URL + 'api/Instance/GetDropdownInstanceListForCategoryAttribute',
	    API_GET_DROPDOWN_INSTANCE_LIST_VEHICLE_ATTRIBUTE: API_SERVER_URL + 'api/Instance/GetDropdownInstanceListForVehicleAttribute',
	    API_GET_DROPDOWN_INSTANCE_LIST_TEMPLATE: API_SERVER_URL + 'api/Instance/GetDropdownInstanceListForTemplate',
	    API_GET_DROPDOWN_INSTANCE_LIST_COMPANY: API_SERVER_URL + 'api/Instance/GetDropdownInstanceListCompany',
	    API_GET_DROPDOWN_INSTANCE_LIST_ORGANIZATION: API_SERVER_URL + 'api/Instance/GetDropdownInstanceListForOrganization',
	    API_GET_DROPDOWN_INSTANCE_LIST_BRANDING: API_SERVER_URL + 'api/Instance/GetDropdownInstanceListForBranding',
	    API_GET_DROPDOWN_INSTANCE_LIST_DASHBOARD: API_SERVER_URL + 'api/Instance/GetDropdownInstanceListForDashboard',
	    API_GET_DROPDOWN_INSTANCE_LIST_TERMSANDCONDITIONS: API_SERVER_URL + 'api/Instance/GetDropdownInstanceListForTermsAndCondtions',
	    API_GET_DROPDOWN_INSTANCE_LIST_INVOICE_UPDATE: API_SERVER_URL + 'api/Instance/GetDropdownInstanceListForInvoiceUpdate',
	    API_GET_DROPDOWN_INSTANCE_LIST_KICKBACKREPORT: API_SERVER_URL + 'api/Instance/GetDropdownInstanceListForKickBackReport',
	    API_GET_DROPDOWN_INSTANCE_TIMEZONE_LIST: API_SERVER_URL + 'api/Instance/GetDropdownTimeZoneList',
	    API_GET_DROPDOWN_INSTANCE_LIST_FOR_COST_CENTER_REPORT: API_SERVER_URL + 'api/Instance/GetDropdownInstanceListForCostCenterReport',
	    API_GET_DROPDOWN_INSTANCE_LIST_FOR_PRE_POST_TRIP_QUESTION: API_SERVER_URL + 'api/Instance/GetDropdownInstanceListPrePostTripQuestion',
	    API_RESET_TWOFA_COOKIES_INSTANCE: API_SERVER_URL + 'api/Instance/ResetInstanceAdminTwoFaCookies',
	    API_RESET_TWOFA_KEYS_INSTANCE: API_SERVER_URL + 'api/Instance/ResetInstanceAdminTwoFaKeys',
	    API_GET_TWOFA_ENABLED: API_SERVER_URL + 'api/Instance/IsTwoFAEnabledForInstance',
	    //VehicleMaster
	    API_GET_VEHICLE_LIST: API_SERVER_URL + 'api/VehicleMaster/GetAllVehicleList',
	    API_GET_VEHICLE_BY_HASH: API_SERVER_URL + 'api/VehicleMaster/GetVehicleByHashID',
	    API_POST_VEHICLE_DETAIL: API_SERVER_URL + 'api/VehicleMaster/UpdateVehicleMaster',
	    API_Block_UNBLOCK_VEHICLE: API_SERVER_URL + 'api/VehicleMaster/BlockUnblockVehicle',
	    API_POST_DELETE_VEHICLES: API_SERVER_URL + 'api/VehicleMaster/DeleteVehicleList',
	    API_EXPORT_VEHICLE_LIST: API_SERVER_URL + 'api/VehicleMaster/ExportVehicleList',
	    //API_GET_VEHICLE_SVG_LIST: API_SERVER_URL + 'api/VehicleMaster/GetAllVehicleSVGList',
	    API_EXPORT_VEHICLE_SVG_LIST: API_SERVER_URL + 'api/VehicleMaster/ExportVehicleSVGList',
	    API_EXPORT_VTSVEHICLE_SVG_LIST: API_SERVER_URL + 'api/VehicleMaster/ExportVtsVehicleList',
	    API_GET_VEHICLE_LIST_BY_SVGID: API_SERVER_URL + 'api/VehicleMaster/GetVehicleListBySVGID',
	    API_POST_VEHICLE_BLOCK: API_SERVER_URL + 'api/VehicleMaster/BlockUnblockVehicle',
	    API_GET_AFFECTEDBOOKING: API_SERVER_URL + 'api/VehicleMaster/GetAffectedBookings',
	    API_GET_VTS_VEHICLE_LIST: API_SERVER_URL + 'api/VehicleMaster/GetVTSVehicleList',
	    API_POST_VTSVEHICLE_DETAIL: API_SERVER_URL + 'api/VehicleMaster/VtsVehicleUpdate',
	    API_GET_VTSVEHICLE_LIST: API_SERVER_URL + 'api/VehicleMaster/GetAllVtsVehicleList',
	    API_GET_VTSVEHICLE_BY_HASH: API_SERVER_URL + 'api/VehicleMaster/GetVtsVehicleByHashID',
	    API_UPDATE_REPORT_DAMAGE_STATUS: API_SERVER_URL + 'api/ReportDamage/UpdateReportDamageStatus',
	    API_GET_VEHICLE_FUTURE_BOOKING_LIST: API_SERVER_URL + 'api/VehicleMaster/GetVehicleFutureBookingList',
	    API_POST_VEHICLE_INFO: API_SERVER_URL + 'api/VehicleMaster/UpdateVehicleInfo',
	    API_GET_DROPDOWN_VEHICLE_LIST_VEHICLEOCCUPANCYREPORT: API_SERVER_URL +
	        'api/VehicleMaster/GetDropdownVehicleListForVehicleOccupancyReport',
	    API_GET_DROPDOWN_VEHICLE_LIST_REVENUEVEHICLEREPORT: API_SERVER_URL +
	        'api/VehicleMaster/GetDropdownVehicleListForRevenueVehicleReport',
	    API_GET_DROPDOWN_VEHICLE_LIST_TRIPDATAREPORT: API_SERVER_URL + 'api/VehicleMaster/GetDropdownVehicleListFoTripDataReport',
	    API_GET_DROPDOWN_VEHICLE_LIST_MAINTENCEPLANNINGREPORT: API_SERVER_URL +
	        'api/VehicleMaster/GetDropdownVehicleListForMaintencePlanningReport',
	    API_GET_VEHICLE_DROPDOWN_LIST_BY_SVGID: API_SERVER_URL +
	        'api/VehicleMaster/GetDropdownVehicleListForDriverBookingAgenda',
	    API_GET_DROPDOWN_VEHICLE_LIST_KICKBACKREPORT: API_SERVER_URL +
	        'api/VehicleMaster/GetDropdownVehicleListForKickBackReport',
	    API_GET_VEHICLE_LIST_FOR_COST_CENTER_REPORT: API_SERVER_URL + 'api/VehicleMaster/GetAllVehicleListForCostCenterReport',
	    //SharedVehicleGroup
	    API_GET_DROPDOWN_SVG_LIST_TERMS_AND_CONDITION: API_SERVER_URL + 'api/SharedVehicleGroup/GetSVGListForTermsAndCondition',
	    API_GET_SHAREDVEHICLEGROUP_DETAIL: API_SERVER_URL + 'api/SharedVehicleGroup/GetAllSharedVehicleGroup',
	    API_GET_SHAREDVEHICLEGROUP_BY_HASH: API_SERVER_URL + 'api/SharedVehicleGroup/GetShareVehicleGroupByHashID',
	    API_GET_SHAREDVEHICLEGROUP_BASIC_DETAIL: API_SERVER_URL + 'api/SharedVehicleGroup/GetSharedVehicleGroupBasicDetail',
	    API_POST_SHAREDVEHICLEGROUP_DETAIL: API_SERVER_URL + 'api/SharedVehicleGroup/UpdateSharedvehiclegroup',
	    API_EXPORT_SHAREDVEHICLEGROUP_LIST: API_SERVER_URL + 'api/SharedVehicleGroup/ExportSharedVehicleGroup',
	    API_POST_DELETE_SVG_VEHICLE_DETAIL: API_SERVER_URL + 'api/SharedVehicleGroup/DeleteSharedVehicleGroupList',
	    API_GET_SVGVEHICLEGLIST: API_SERVER_URL + 'api/SharedVehicleGroup/GetAllGroupVehicle',
	    API_GET_VEHICLEGROUP_LIST: API_SERVER_URL + 'api/SharedVehicleGroup/GetVehicleListForGroup',
	    API_GET_INACTIVE_SHAREDVEHICLEGROUP: API_SERVER_URL + 'api/SharedVehicleGroup/InActiveSharedVehicleGroup',
	    API_GET_SVGDRIVERGLIST: API_SERVER_URL + 'api/SharedVehicleGroup/GetAllGroupDriver',
	    API_GET_DROPDOWN_SVG_LIST_VEHICLEOCCUPANCYREPORT: API_SERVER_URL +
	        'api/SharedVehicleGroup/GetDropdownSVGListForVehicleOccupancyReport',
	    API_GET_DROPDOWN_SVG_LIST_REVENUEVEHICLEREPORT: API_SERVER_URL +
	        'api/SharedVehicleGroup/GetDropdownSVGListForRevenueVehicleReport',
	    API_GET_DROPDOWN_SVG_LIST_TRIPDATAREPORT: API_SERVER_URL +
	        'api/SharedVehicleGroup/GetDropdownSVGListFoTripDataReport',
	    API_GET_DROPDOWN_SVG_LIST_MAINTENCEPLANNINGREPORT: API_SERVER_URL +
	        'api/SharedVehicleGroup/GetDropdownSVGListForMaintencePlanningReport',
	    API_GET_DROPDOWN_SVG_LIST_DASHBOARD: API_SERVER_URL + 'api/SharedVehicleGroup/GetDropdownSVGListForDashboard',
	    API_GET_DROPDOWN_DRIVER_LIST: API_SERVER_URL +
	        'api/SharedVehicleGroup/GetDropdownDriverListForTripDataReport',
	    API_GET_DROPDOWN_SVG_LIST_BOOKING_AGENDA: API_SERVER_URL + 'api/SharedVehicleGroup/GetSVGListForDriverBookingAgenda',
	    API_GET_DROPDOWN_SVG_LIST_TEMPLATE: API_SERVER_URL + 'api/SharedVehicleGroup/GetSVGListForTemplate',
	    API_GET_DROPDOWN_SVG_LIST_KICK_BACK_REPORT: API_SERVER_URL + 'api/SharedVehicleGroup/GetSVGListForKickBackReport',
	    API_GET_DROPDOWN_SVG_LIST_PRE_POST_TRIP_QUESTION: API_SERVER_URL + 'api/SharedVehicleGroup/GetSVGListForPrePostTripQuestion',
	    API_GET_DROPDOWN_SVG_LIST_BY_ORG_LIST_TERMS_AND_CONDITION: API_SERVER_URL +
	        'api/SharedVehicleGroup/GetDropdownSharedVehicelGroupListForTermsCondByOrgList',
	    API_RESET_TWOFA_COOKIES_SVG: API_SERVER_URL + 'api/SharedVehicleGroup/ResetSharedvehicleGroupAdminTwoFaCookies',
	    API_RESET_TWOFA_KEYS_SVG: API_SERVER_URL + 'api/SharedVehicleGroup/ResetSharedvehicleGroupAdminTwoFaKeys',
	    //SharedVehicleGroupAdmin
	    API_GET_SHAREDVEHICLEGROUPADMIN_DETAIL: API_SERVER_URL +
	        'api/SharedVehicleGroupAdmin/GetAllSharedVehicleGroupAdmin',
	    API_GET_PERSON_LIST_BY_SHAREDVEHICLEGROUP_ID: API_SERVER_URL +
	        'api/SharedVehicleGroupAdmin/GetPersonListForSharedVehicleGroupAdmin',
	    API_POST_SHAREDVEHICLEGROUP_ADMIN_DETAIL: API_SERVER_URL +
	        'api/SharedVehicleGroupAdmin/UpdateSharedVehicleGroupAdmin',
	    API_EXPORT_SHAREDVEHICLEGROUPADMIN_LIST: API_SERVER_URL +
	        'api/SharedVehicleGroupAdmin/ExportSharedVehicleGroupAdmin',
	    API_POST_DELETE_SHAREDVEHICLEGROUP_ADMIN: API_SERVER_URL +
	        'api/SharedVehicleGroupAdmin/DeleteSharedVehicleGroupAdminList',
	    API_GET_INACTIVE_SHAREDVEHICLEGROUP_ADMIN: API_SERVER_URL +
	        'api/SharedVehicleGroupAdmin/InActiveSharedVehicleGroupAdmin',
	    //SharedVehicleDriver
	    API_GET_SVG_LIST_FOR_DRIVERS: API_SERVER_URL + 'api/SharedVehicleDriver/GetSVGListForDrivers',
	    API_POST_SVG_DRIVER_DETAIL: API_SERVER_URL + 'api/SharedVehicleDriver/UpdateSharedVehicleDriver',
	    API_POST_DELETE_DRIVER_SVG: API_SERVER_URL + 'api/SharedVehicleDriver/DeleteSharedVehicleDriverList',
	    API_GET_UNSUBSCRIBE_DRIVER_SVG: API_SERVER_URL + 'api/SharedVehicleDriver/UnsubscribeDriver',
	    API_GET_AFFECTED_SUBSCRIPTION_BOOKING: API_SERVER_URL + 'api/SharedVehicleDriver/GetAffectedSubscriptionBookings',
	    API_POST_SVG_DETAIL_FOR_BATCHUPLOAD: API_SERVER_URL + 'api/SharedVehicleDriver/GetSVGListForBatchUpload',
	    API_CHECK_BOOKING_RUNNING_STATUS: API_SERVER_URL + 'api/SharedVehicleDriver/CheckRunningBookingStatus',
	    //VehicleGroupMapping
	    API_GET_SVG_LIST_FOR_VEHICLE: API_SERVER_URL + 'api/VehicleGroupMapping/GetSVGListForVehicle',
	    API_POST_SVG_VEHICLE_DETAIL: API_SERVER_URL + 'api/VehicleGroupMapping/UpdateVehicleGroupMapping',
	    API_POST_DELETE_VEHICLE_SVG: API_SERVER_URL + 'api/VehicleGroupMapping/DeleteVehicleSVGList',
	    //DriverMaster
	    API_GET_DRIVER_LIST: API_SERVER_URL + 'api/DriverMaster/GetAllDriverList',
	    API_GET_ACTIVE_DRIVER_LIST: API_SERVER_URL + 'api/DriverMaster/GetActiveDriverList',
	    API_GET_DRIVER_SVG_LIST: API_SERVER_URL + 'api/DriverMaster/GetAllDriverSVGList',
	    API_GET_DRIVER_BY_HASH: API_SERVER_URL + 'api/DriverMaster/GetDriverByHashID',
	    API_POST_DRIVER_DETAIL: API_SERVER_URL + 'api/DriverMaster/UpdateDriverMaster',
	    API_INACTIVE_DRIVER: API_SERVER_URL + 'api/DriverMaster/InActiveDriverMaster',
	    API_GET_PERSON_LIST_BY_PERSON_ID: API_SERVER_URL + 'api/DriverMaster/GetPersonListForDrivers',
	    API_EXPORT_DRIVER_LIST: API_SERVER_URL + 'api/DriverMaster/ExportDriverList',
	    API_EXPORT_DRIVER_SVG_LIST: API_SERVER_URL + 'api/DriverMaster/ExportDriverSVGList',
	    // API_POST_DELETE_DRIVER_LIST: API_SERVER_URL + 'api/DriverMaster/DeleteDriverList',
	    API_POST_DRIVER_INACTIVE: API_SERVER_URL + 'api/DriverMaster/InActiveDriverMaster',
	    API_POST_DRIVER_REMOVELICENSEBIRTHDATE: API_SERVER_URL + 'api/DriverMaster/RemoveDriverLicense',
	    API_GET_CURRENT_DRIVER: API_SERVER_URL + 'api/DriverMaster/GetCurrentDriverDetail',
	    API_GET_SELECTED_DRIVER: API_SERVER_URL + 'api/DriverMaster/GetSelectedDriverDetailByDriverId',
	    API_GET_DRIVER_SUBSCRIPTION_DETAIL: API_SERVER_URL + 'api/DriverMaster/GetDriverSubscriptionDetail',
	    API_EXPORT_DRIVER_SUBSCRIPTION_LIST: API_SERVER_URL + 'api/DriverMaster/ExportDriverSubscription',
	    API_EXPORT_SVG_DRIVER_LIST: API_SERVER_URL + 'api/SharedVehicleGroup/ExportSVGDriverList',
	    API_GET_SUBSCRIPTION_DETAIL_BY_SVGDRIVER_HASH: API_SERVER_URL + 'api/DriverMaster/GetDriverSubscriptionDetailByHash',
	    //DriverTerms
	    API_GET_DRIVERTERMS_DETAIL: API_SERVER_URL + 'api/DriverTerms/GetDriverTermsByDriverHashId',
	    API_POST_DRIVERTERMS_DETAIL: API_SERVER_URL + 'api/DriverTerms/UpdateDriverTerm',
	    // API_GET_DRIVERTERMSFILE: API_SERVER_URL + 'api/DriverTerms/Test',
	    //VehicleAttribute
	    API_GET_VEHICLEATTRIBUTE_DETAIL: API_SERVER_URL + 'api/VehicleAttribute/GetAllVehicleAttribute',
	    API_GET_VEHICLEATTRIBUTE_BY_HASH: API_SERVER_URL + 'api/VehicleAttribute/GetVehicleAttributeByHashID',
	    API_POST_VEHICLEATTRIBUTE_DETAIL: API_SERVER_URL + 'api/VehicleAttribute/UpdateVehicleAttribute',
	    API_GET_VEHICLEATTRIBUTECATEGORY_DETAIL: API_SERVER_URL +
	        'api/VehicleAttributeCategory/GetAllVehicleAttributeCategory',
	    API_EXPORT_VEHICLEATTRIBUTE_LIST: API_SERVER_URL + 'api/VehicleAttribute/ExportVehicleAttribute',
	    API_GET_VEHICLEATTRIBUTE_BY_COMPANY: API_SERVER_URL + 'api/VehicleAttribute/GetVehicleAttributeForCompany',
	    //Contract Type Group
	    API_GET_CONTRACT_TYPE_GROUP_LIST: API_SERVER_URL +
	        'api/ContractTypeGroup/GetContractTypeGroupBySharedVehicleGroup',
	    API_EXPORT_CONTRACT_TYPE_GROUP_LIST: API_SERVER_URL +
	        'api/ContractTypeGroup/ExportContractTypeGroupBySharedVehicleGroup',
	    API_GET_UNASSIGN_CONTRACT_TYPE_GROUP_LIST: API_SERVER_URL + 'api/ContractTypeGroup/GetUnassignContractTypeGroupName',
	    API_POST_ASSIGN_CONTRACT_TYPE_GROUP: API_SERVER_URL +
	        'api/ContractTypeGroup/AssignContractGroupToSharedVehicleGroup',
	    API_GET_CONTRACT_TYPE_GROUP_DETAIL: API_SERVER_URL + 'api/ContractTypeGroup/GetContractTypeGroupByHashId',
	    API_POST_CONTRACT_TYPE_GROUP_DETAIL: API_SERVER_URL + 'api/ContractTypeGroup/UpdateContractTypeGroup',
	    API_GET_INACTIVE_REASON: API_SERVER_URL + 'api/ContractTypeGroup/GetInActiveReasonByHashID',
	    API_GET_INSTANCE_BY_GROUP: API_SERVER_URL + 'api/ContractTypeGroup/GetCurrencyByGroup',
	    API_GET_DELETE_GROUP: API_SERVER_URL + 'api/ContractTypeGroup/DeleteContracttypeGroup',
	    API_GET_DROPDOWN_VATSETTING_LIST: API_SERVER_URL + 'api/ContractTypeGroup/GetDropdownVatSetting',
	    API_GET_VATSETTING_DEFAULT_VALUES: API_SERVER_URL + 'api/ContractTypeGroup/GetVatSettingDefaultValues',
	    API_GET_CONTRACTTYPEGROUP_BASIC_DETAIL: API_SERVER_URL + 'api/ContractTypeGroup/GetContractTypeGroupBasicDetail',
	    API_GET_CONTRACT_TYPE_BY_SVGHASHID: API_SERVER_URL + 'api/ContractTypeGroup/GetDropdownContractTypeGroup',
	    API_GET_DROPDOWN_CTG_LIST_BY_SVG_KICK_BACK_REPORT: API_SERVER_URL +
	        'api/ContractTypeGroup/GetCTGDropdowonListForKickBackReport',
	    API_GET_DROPDOWN_CTG_LIST_BY_SVG_TERMS_AND_CONDITION: API_SERVER_URL +
	        'api/ContractTypeGroup/GetCTGDropdowonListForTermsAndCondition',
	    //Contract Type
	    API_GET_CONTRACT_TYPE_LIST: API_SERVER_URL + 'api/ContractType/GetAllContractTypeList',
	    API_GET_CONTRACT_TYPE_BY_HASH: API_SERVER_URL + 'api/ContractType/GetContractTypeByHashID',
	    API_POST_CONTRACT_TYPE_DETAIL: API_SERVER_URL + 'api/ContractType/UpdateContractTypeMaster',
	    API_EXPORT_CONTRACT_TYPE_LIST: API_SERVER_URL + 'api/ContractType/ExportContractType',
	    API_POST_DELETE_CONTRACT_TYPE: API_SERVER_URL + 'api/ContractType/DeleteContractTypeList',
	    API_GET_CONTRACT_TYPE_HISTORY: API_SERVER_URL + 'api/ContractType/GetContractTypeHistory',
	    API_GET_SPECIAL_PERIOD_LIST: API_SERVER_URL + 'api/ContractType/GetSpecialPeriods',
	    //VehicleAttributeCategory
	    //API_GET_VEHICLEATTRIBUTECATEGORY_DETAIL: API_SERVER_URL + 'api/VehicleAttributeCategory/GetAllVehicleAttributeCategory',
	    API_GET_VEHICLEATTRIBUTE_CATEGORY_BY_HASH: API_SERVER_URL +
	        'api/VehicleAttributeCategory/GetVehicleAttributeByCategoryHashID',
	    API_POST_VEHICLEATTRIBUTE_CATEGORY_DETAIL: API_SERVER_URL +
	        'api/VehicleAttributeCategory/UpdateVehicleAttributeCategory',
	    API_EXPORT_VEHICLEATTRIBUTECATEGORY_LIST: API_SERVER_URL +
	        'api/VehicleAttributeCategory/ExportVehicleAttributeCategory',
	    API_GET_VEHICLEATTRIBUTECATEGORY_BY_INSTANCE: API_SERVER_URL +
	        'api/VehicleAttributeCategory/GetVehicleAttributeCategoryByInstance',
	    //PersonProfile
	    API_GET_PERSONPROFILE_BY_ACTIVATION_CODE: API_SERVER_URL + 'api/PersonProfile/GetPersonByActivationCode',
	    API_POST_PERSONPROFILE_DETAIL: API_SERVER_URL + 'api/PersonProfile/UpdatePersonProfile',
	    //ForgotPassword
	    API_POST_FORGOTPASSSWORD: API_SERVER_URL + 'api/ForgotPassword/SendForgotPassword',
	    API_POST_CHANGEPASSSWORD: API_SERVER_URL + 'api/ForgotPassword/ChangePassword',
	    API_GET_CHECKACTIVATIONCODE: API_SERVER_URL + 'api/ForgotPassword/CheckActivationCode',
	    //Booking
	    API_GET_SCHEDULED_BOOKING_LIST: API_SERVER_URL + 'api/BookingMaster/GetScheduledBookingList',
	    API_GET_AFFECTED_BOOKING_LIST: API_SERVER_URL + 'api/BookingMaster/GetAffectedBookingList',
	    API_GET_BOOKING_LIST: API_SERVER_URL + 'api/BookingMaster/GetBookingList',
	    API_GET_EDIT_BOOKING: API_SERVER_URL + 'api/BookingMaster/EditBookingDetail',
	    API_GET_VEHICLE_OVERVIEW: API_SERVER_URL + 'api/BookingMaster/GetVehicleOverview',
	    API_GET_BOOKING_OVERVIEW: API_SERVER_URL + 'api/BookingMaster/GetBookingOverview',
	    API_GET_BOOKING_Details: API_SERVER_URL + 'api/BookingMaster/GetBookingDetails',
	    API_POST_MAKE_PROVISIONAL_BOOKING: API_SERVER_URL + 'api/BookingMaster/MakeProvisionalBooking',
	    API_POST_CONFIRM_PROVISIONAL_BOOKING: API_SERVER_URL + 'api/BookingMaster/ConfirmProvisionalBooking',
	    API_POST_RECURRING_PAYMENT_BOOKING: API_SERVER_URL + 'api/BookingMaster/MakeRecurringPaymentForCreateBooking',
	    API_CREATE_INITIAL_PAYMENT: API_SERVER_URL + 'api/BookingMaster/StartInitialPaymentForCreateBooking',
	    API_START_INITIAL_PAYMENT: API_SERVER_URL + 'api/BookingMaster/StartInitialPaymentForStartBooking',
	    API_GET_CANCEL_PROVISIONAL_BOOKING: API_SERVER_URL + 'api/BookingMaster/CancelProvisionalBooking',
	    API_GET_BOOKING_OVERVIEW_LIST: API_SERVER_URL + 'api/BookingMaster/GetBookingOverViewList',
	    API_GET_BOOKING_REQUEST_LIST: API_SERVER_URL + 'api/BookingMaster/GetBookingRequestList',
	    API_GET_BOOKING_History_LIST: API_SERVER_URL + 'api/DriverMaster/GetBookingHistroyForDriver',
	    API_EXPORT_BOOKING_HISTORY_LIST: API_SERVER_URL + 'api/DriverMaster/ExportBookingHistroyForDriver',
	    API_EXPORT_BOOKING_LIST: API_SERVER_URL + 'api/BookingMaster/ExportBookings',
	    API_EXPORT_BOOKING_REQUEST_LIST: API_SERVER_URL + 'api/BookingMaster/ExportBookingRequest',
	    API_POST_CANCEL_BOOKINGS_LIST: API_SERVER_URL + 'api/BookingMaster/CancelBooking',
	    API_POST_REVOKE_ABORT_BOOKING: API_SERVER_URL + 'api/BookingMaster/RevokeOrAbortBooking',
	    API_POST_MAKE_SPECIAL_BOOKING: API_SERVER_URL + 'api/BookingMaster/SpecialBooking',
	    API_GET_VEHICLE_LIST_SPECIAL_BOOKING: API_SERVER_URL + 'api/BookingMaster/GetVehicleListForSpecialBooking',
	    API_POST_APPROVE_BOOKING_REQUEST: API_SERVER_URL + 'api/BookingMaster/ApproveBookingRequest',
	    API_POST_APPROVE_REJECT_MULTIPLE_BOOKING_REQUEST: API_SERVER_URL + 'api/BookingMaster/ApproveRejectMultipleBookingRequest ',
	    API_GET_ACTIVE_DRIVER_LIST_BOOKING: API_SERVER_URL + 'api/BookingMaster/GetActiveDriverListForBooking',
	    API_GET_BOOKING_INFORMATION: API_SERVER_URL + 'api/BookingMaster/GetBookingInformation',
	    API_CHECK_BOOKING_EXTEND_TIME: API_SERVER_URL + 'api/BookingMaster/CheckBookingExtendTime',
	    API_EXTEND_ONGOING_BOOKING: API_SERVER_URL + 'api/BookingMaster/ExtendOnGoingBooking',
	    API_REPORT_DAMAGE: API_SERVER_URL + 'api/ReportDamage/ReportDamage',
	    API_RECURRING_BOOKING_DRIVER: API_SERVER_URL + 'api/BookingMaster/AllowRecurringBookingForDriver',
	    API_ALLOW_TIME_BOOKING_DRIVER: API_SERVER_URL + 'api/BookingMaster/AllowTimeForBooking',
	    API_POST_UPDATE_BOOKINGTRIP: API_SERVER_URL + 'api/BookingTrip/UpdateBookingTrip',
	    API_DELETE_BOOKINGTRIP: API_SERVER_URL + 'api/BookingTrip/DeleteBookingTrip',
	    API_UPDATE_USER_EXPENSE: API_SERVER_URL + 'api/BookingExpense/UpdateUserExpense',
	    API_FREE_BOOKING: API_SERVER_URL + 'api/BookingMaster/UpdateFreeBooking',
	    API_GET_AQUIRED_TIMESLOT: API_SERVER_URL + 'api/BookingMaster/GetAquiredTimeSlots',
	    API_GET_NORMAL_BOOKING_LIST: API_SERVER_URL + 'api/BookingMaster/GetNormalBookingList',
	    API_GET_BOOKING_ORGANIZATION_LIST: API_SERVER_URL + 'api/BookingMaster/GetOrganizationListForDriver',
	    API_GET_SPECIAL_BOOKING_SVG_LIST: API_SERVER_URL + 'api/BookingMaster/GetSharedVehicleGroupListForSpecialBooking',
	    API_BOOKINGEXPENSE_VATSETTINGLIST_DROPDOWN: API_SERVER_URL + 'api/BookingExpense/GetDropdownVatSetting',
	    API_BOOKINGEXPENSE_API_GET_VATSETTING_DEFAULT_VALUES: API_SERVER_URL + 'api/BookingExpense/GetVatSettingDefaultValues',
	    API_GET_BOOKING_SPECIAL_PERIODS_LIST: API_SERVER_URL + 'api/BookingMaster/GetSpecialPeriodList',
	    //BookingInvoice
	    API_GET_BOOKING_INVOICE_LIST: API_SERVER_URL + 'api/BookingInvoice/CCE/GetBookingInvoiceList',
	    API_EXPORT_BOOKING_INVOICE_LIST: API_SERVER_URL + 'api/BookingInvoice/CCE/ExportBookingInvoice',
	    API_RESEND_BOOKING_INVOICE: API_SERVER_URL + 'api/BookingInvoice/CCE/ResendBookingInvoice',
	    API_DOWNLOAD_BOOKING_INVOICE: API_SERVER_URL + 'api/BookingInvoice/CCE/DownloadBookingInvoice',
	    API_DOWNLOAD_BOOKING_INVOICE_OFFLINE_PDF: API_SERVER_URL + 'api/BookingInvoice/CCE/DownloadOfflineInvoicePDF',
	    API_GET_IS_DIRECTDEBIT_ENABLED: API_SERVER_URL + 'api/BookingInvoice/IsDirectDebitEnabled',
	    API_GET_INVOICE_BASIC_DETAILS: API_SERVER_URL + 'api/BookingInvoice/CCE/GetBookingInvoiceBasicDetails',
	    //BookingInvoiceLegacy
	    API_GET_BOOKING_INVOICE_LIST_LEGACY: API_SERVER_URL + 'api/BookingInvoice/GetBookingInvoiceList',
	    API_EXPORT_BOOKING_INVOICE_LIST_LEGACY: API_SERVER_URL + 'api/BookingInvoice/ExportBookingInvoice',
	    API_RESEND_BOOKING_INVOICE_LEGACY: API_SERVER_URL + 'api/BookingInvoice/ResendBookingInvoice',
	    API_DOWNLOAD_BOOKING_INVOICE_LEGACY: API_SERVER_URL + 'api/BookingInvoice/DownloadBookingInvoice',
	    API_DOWNLOAD_BOOKING_INVOICE_OFFLINE_PDF_LEGACY: API_SERVER_URL + 'api/BookingInvoice/DownloadOfflineInvoicePDF',
	    API_GET_IS_DIRECTDEBIT_ENABLED_LEGACY: API_SERVER_URL + 'api/BookingInvoice/IsDirectDebitEnabled',
	    API_GET_INVOICE_BASIC_DETAILS_LEGACY: API_SERVER_URL + 'api/BookingInvoice/GetBookingInvoiceBasicDetails',
	    API_GET_UPDATE_DUE_DATE_FOR_INVOICE_LEGACY: API_SERVER_URL + 'api/BookingInvoice/UpdateDueDateForInvoice',
	    API_POST_UPDATE_INVOICE_STATUS_LEGACY: API_SERVER_URL + 'api/BookingInvoice/UpdateInvoiceStatus',
	    API_POST_MANUAL_INVOICE_LEGACY: API_SERVER_URL + 'api/BookingInvoice/UpdateManualInvoice',
	    // Trips
	    API_GET_TRIP_OVERVIEW: API_SERVER_URL + 'api/DriverMaster/GetTripOverview',
	    API_GET_TRIP_DETAILS: API_SERVER_URL + 'api/DriverMaster/GetTripDetails',
	    API_GET_EDIT_TRIP: API_SERVER_URL + 'api/DriverMaster/EditTripDetail',
	    API_EXPORT_TRIP_HISTORY_LIST: API_SERVER_URL + 'api/DriverMaster/ExportTripHistoryForDriver',
	    API_EXPORT_TRIP_LIST: API_SERVER_URL + 'api/DriverMaster/ExportTrips',
	    API_EXPORT_TRIP_REQUEST_LIST: API_SERVER_URL + 'api/DriverMaster/ExportTripRequest',
	    API_GET_TRIP_OVERVIEW_LIST: API_SERVER_URL + 'api/DriverMaster/GetTripOverViewList',
	    API_GET_TRIP_REQUEST_LIST: API_SERVER_URL + 'api/DriverMaster/GetTripRequestList',
	    API_GET_TRIP_HISTORY_LIST: API_SERVER_URL + 'api/DriverMaster/GetTripHistoryForDriver',
	    API_GET_TRIP_INFORMATION: API_SERVER_URL + 'api/DriverMaster/GetTripInformation',
	    API_POST_TRIP_ANSWER: API_SERVER_URL + 'api/DriverMaster/UpdateTripAnswer',
	    //Invoice InvoiceTestModel
	    API_GET_INVOICE_TEST_LIST: API_SERVER_URL + 'api/InvoiceTest/GetInvoiceTestDriver',
	    API_POST_GENERATE_INVOICE: API_SERVER_URL + 'api/InvoiceTest/GenerateInvoice',
	    //
	    API_GET_TEST_TRIP_BOOKING_LIST: API_SERVER_URL + 'api/VTS/GetBookingList',
	    API_GET_TEST_TRIP_LIST: API_SERVER_URL + 'api/VTS/GetTripListByBookingId',
	    API_CONTACTYPE_LIST: API_SERVER_URL + 'api/VTS/GetAllContactTypeGroupInfromation',
	    API_POST_TEST_TRIP_DETAIL: API_SERVER_URL + 'api/VTS/BookingTripSimulation',
	    API_UPDATE_VTS_VEHICLE_STATUS: API_SERVER_URL + 'api/VTS/UpdateVTSVehicleStatus',
	    API_UNLOCK_VTS_VEHICLE: API_SERVER_URL + 'api/VTS/UnLockVTSVehicle',
	    API_LOCK_VTS_VEHICLE: API_SERVER_URL + 'api/VTS/LockVTSVehicle',
	    API_GET_VEHICLE_DAMAGE_REPORT_BY_HASH: API_SERVER_URL + 'api/VehicleMaster/GetVehicleDamageHistory',
	    API_PETROL_NEED: API_SERVER_URL + 'api/VTS/IsFuelNeed',
	    API_CLEANINGNEED: API_SERVER_URL + 'api/VTS/IsCleanigNeed',
	    API_UPDATE_VEHICLE_FOR_CLEANING_AND_FUEL: API_SERVER_URL + 'api/VTS/UpdateVehicleForCleanningAndFuel',
	    API_UPDATE_VEHICLE_FOR_INVALID_TAG_USED: API_SERVER_URL + 'api/VTS/UpdateVehicleStatusForInvalidTagUsed',
	    //UserProfile
	    API_POST_UserPROFILE_DETAIL: API_SERVER_URL + 'api/PersonProfile/UpdateUserProfile',
	    //ChangePassword From Profile
	    API_POST_CHANGEUSERPASSSWORD: API_SERVER_URL + 'api/ChangePassword/ChangePassword',
	    //Notification Inbox
	    API_GET_NOTIFICATION_INBOX_LIST: API_SERVER_URL + 'api/NotificationInbox/GetNotificationInboxList',
	    API_GET_SHOW_NOTIFICATION: API_SERVER_URL + 'api/NotificationInbox/ShowNotification',
	    API_GET_NOTIFICATION_COUNT: API_SERVER_URL + 'api/NotificationInbox/GetNotificationCount',
	    API_GET_RESET_NOTIFICATION_COUNT: API_SERVER_URL + 'api/NotificationInbox/ResetNotificationCount',
	    // Template
	    API_GET_TEMPLATE_LIST: API_SERVER_URL + 'api/Template/GetTemplateList',
	    API_GET_TEMPLATE_BY_HASH: API_SERVER_URL + 'api/Template/GetTemplateByHashId',
	    API_GET_SAMPLE_TEMPLATE_BY_HASH: API_SERVER_URL + 'api/Template/GetSampleTemplateByHashId',
	    API_POST_TEMPLATE_DETAIL: API_SERVER_URL + 'api/Template/UpdateTemplate',
	    API_GET_TEMPLATE_NAME_LIST: API_SERVER_URL + 'api/Template/GetTemplateNameList',
	    API_GET_MASTER_TEMPLATE_BY_HASH: API_SERVER_URL + 'api/Template/GetMasterTemplateByHashId',
	    API_GET_UNUSED_INSTANCE_LIST_FOR_TEMPLATE: API_SERVER_URL + 'api/Template/GetUnusedInsatnceListForTemplate',
	    API_POST_DELETE_TEMPLATES: API_SERVER_URL + 'api/Template/DeleteTemplateList',
	    API_GENERATE_LATEX_PDF_BY_HASH: API_SERVER_URL + 'api/Template/GenerateLatexPdf',
	    API_DOWNLAOD_LATEX_PDF_BY_HASH: API_SERVER_URL + 'api/Template/DownloadLatexPdf',
	    API_GET_TEMPLATE_NAME_RECIPIENT_LIST: API_SERVER_URL + 'api/Template/GetTemplateNameRecipientList',
	    // Notification Event
	    API_GET_NOTIFICATION_EVENT_LIST: API_SERVER_URL + 'api/NotificationEvent/GetNotificationEventList',
	    API_POST_NOTIFICATION_EVENT_LIST: API_SERVER_URL + 'api/NotificationEvent/UpdateNotificationEventList',
	    //TimeBlock
	    API_POST_TIMEBLOCK_DETAIL: API_SERVER_URL + 'api/TimeBlock/UpdateTimeBlock',
	    API_GET_TIMEBLOCK_BY_HASH: API_SERVER_URL + 'api/TimeBlock/GetTimeBlockByHashID',
	    // Service Offer
	    API_GET_SERVICE_OFFER_LIST: API_SERVER_URL + 'api/ServiceOffer/GetServiceOfferList',
	    API_GET_DISTANCE_UNIT_LIST: API_SERVER_URL + 'api/ServiceOffer/GetDistanceUnitList',
	    API_GET_TIME_UNIT_LIST: API_SERVER_URL + 'api/ServiceOffer/GetTimeUnitList',
	    //SharedVehicle Subscription
	    API_GET_SUBSCRIPTION_LIST: API_SERVER_URL + 'api/SharedvehicleSubscription/GetSubscriptionBySVGID',
	    API_POST_SUBSCRIPTION_DETAIL: API_SERVER_URL + 'api/SharedvehicleSubscription/UpdateSubscriptionMaster',
	    API_GET_SUBSCRIPTION_BY_HASH: API_SERVER_URL + 'api/SharedvehicleSubscription/GetSubscriptionByHashID',
	    API_EXPORT_SUBSCRIPTION_LIST: API_SERVER_URL + 'api/SharedvehicleSubscription/ExportSubscription',
	    API_POST_DELETE_SUBSCRIPTION: API_SERVER_URL + 'api/SharedvehicleSubscription/DeleteSubscription',
	    API_GET_SUBSCRIPTION_AVAILABILITY: API_SERVER_URL +
	        'api/SharedvehicleSubscription/GetSubscriptionAvailability',
	    API_POST_SUBSCRIPTION_AVAILABILITY: API_SERVER_URL +
	        'api/SharedvehicleSubscription/UpdateSubscriptionAvailabilityRestriction',
	    API_DELETE_SUBSCRIPTION_AVAILABILITY: API_SERVER_URL +
	        'api/SharedvehicleSubscription/DeleteAvailabilityRestrictionList',
	    API_GET_SUBSCRIPTION_AVAILABILITY_BY_HASH: API_SERVER_URL +
	        'api/SharedvehicleSubscription/GetAvailabilityRestrictionByHashId',
	    API_EXPORT_SUBSCRIPTION_AVAILABILITY_LIST: API_SERVER_URL +
	        'api/SharedvehicleSubscription/ExportAvailabilityRestriction',
	    API_GET_SUBSCRIPTION_BASIC_DETAIL: API_SERVER_URL + 'api/SharedvehicleSubscription/GetSubscriptionBasicDetail',
	    API_GET_DROPDOWN_SUBSCRIPTION_LIST_TEMPLATE: API_SERVER_URL +
	        'api/SharedvehicleSubscription/GetSubscriptionListForTemplate',
	    //Special Period
	    API_GET_SPECIALPERIOD_LIST: API_SERVER_URL + 'api/SpecialPeriod/GetSpecialPeriodList',
	    API_GET_SPECIAL_PERIOD_BY_HASH: API_SERVER_URL + 'api/SpecialPeriod/GetSpecialPerionByHashId',
	    API_POST_SPECIAL_PERIOD_DETAIL: API_SERVER_URL + 'api/SpecialPeriod/UpdateSpecialPeriod',
	    API_EXPORT_SPECIAL_PERIOD_LIST: API_SERVER_URL + 'api/SpecialPeriod/ExportSpecialPeriod',
	    //lock unlock with vts
	    API_UnLOCK: API_SERVER_URL + 'api/VTS/UnLockVehicle',
	    API_LOCK: API_SERVER_URL + 'api/VTS/LockVehicle',
	    API_PARTIALLOCK: API_SERVER_URL + 'api/VTS/PartialLockVehicle',
	    API_STARTRIDE: API_SERVER_URL + 'api/VTS/StartTrip',
	    API_ENDRIDE: API_SERVER_URL + 'api/VTS/EndTrip',
	    // Import Data
	    API_VALIDATE_PERSON_CSV: API_SERVER_URL + 'api/ImportCSV/ValidatePersonCSVRecord',
	    API_IMPORT_PERSON_CSV: API_SERVER_URL + 'api/ImportCSV/ImportPersonRecord',
	    //Additional Free items
	    API_GET_ADDITIONAL_FREEITEMS: API_SERVER_URL + 'api/AdditionalFreeItem/GetAllAdditionalFreeItemList',
	    API_GET_DRIVERSUBSCRIPTION_LIST: API_SERVER_URL + 'api/AdditionalFreeItem/GetDriverSubscriptionList',
	    API_POST_DRIVERSUBSCRIPTION: API_SERVER_URL + 'api/AdditionalFreeItem/UpdateAdditionalFreeItems',
	    API_EXPORT_DRIVERSUBSCRIPTION: API_SERVER_URL + 'api/AdditionalFreeItem/ExportAdditionalFreeItems',
	    API_POST_DELETE_DRIVERSUBSCRIPTION: API_SERVER_URL + 'api/AdditionalFreeItem/DeleteAdditionalFreeItemList',
	    API_GET_ADDITIONALFREEITEM_BY_HASH: API_SERVER_URL + 'api/AdditionalFreeItem/GetAdditionalFreeItemByHashID',
	    //Trip Detail Report
	    API_GET_DRIVER_VEHICLE_LIST: API_SERVER_URL + 'api/TripDetailReport/GetDriverVehicleList',
	    API_GET_DRIVER_BOOKING_TRIP_LIST: API_SERVER_URL + 'api/TripDetailReport/GetTripDetailListForDirver',
	    API_EXPORT_TRIP_DETAIL_REPORT: API_SERVER_URL + 'api/TripDetailReport/ExportTripDetailReport',
	    API_EXPORT_TRIP_DETAIL_REPORT_PDF: API_SERVER_URL + 'api/TripDetailReport/ExportTripDetailReportPdf',
	    API_GET_TRIP_DATA_LIST: API_SERVER_URL + 'api/TripDetailReport/GetTripData',
	    API_EXPORT_TRIP_DATA_REPORT_PDF: API_SERVER_URL + 'api/TripDetailReport/ExportTripDataReportPdf',
	    API_EXPORT_TRIP_DATA_REPORT_CSV: API_SERVER_URL + 'api/TripDetailReport/ExportTripDataXls',
	    API_GET_TRIP_COMMENT: API_SERVER_URL + 'api/TripDetailReport/GetTripComment',
	    API_SET_TRIP_COMMENT: API_SERVER_URL + 'api/TripDetailReport/SetTripComment',
	    //Kickback Report
	    API_GET_KICKBACK_DATA_LIST: API_SERVER_URL + 'api/KickbackReport/GetKickbackData',
	    API_EXPORT_KICKBACK_REPORT_EXCEL: API_SERVER_URL + 'api/KickbackReport/ExportKickBackReportXls',
	    API_EXPORT_KICKBACK_REPORT_PDF: API_SERVER_URL + 'api/KickbackReport/ExportKickbackReportPdf',
	    //Cost Center Report
	    API_GET_COST_CENTER_REPORT_DATA: API_SERVER_URL + 'api/CostCenterReport/GetCostCenterData',
	    API_EXPORT_COST_CENTER_REPORT_EXCEL: API_SERVER_URL + 'api/CostCenterReport/ExportCostCenterReportXls',
	    API_EXPORT_COST_CENTER_REPORT_PDF: API_SERVER_URL + 'api/CostCenterReport/ExportCostCenterReportPdf',
	    //Driverlicencedetail
	    API_POST_DRIVER_LICENCE_DETAIL: API_SERVER_URL + 'api/Backoffice/UpdateDriverLicenceDetail',
	    //VTS Troubleshoot
	    API_VTS_TROUBLESHOOT_GETVTSSTATUS_URL: API_SERVER_URL + 'api/VTSTroubleshoot/GetVtsStatus',
	    API_VTS_TROUBLESHOOT_GETOBUSTATUS_URL: API_SERVER_URL + 'api/VTSTroubleshoot/GetAllVehicleObuStatus',
	    API_VTS_TROUBLESHOOT_EXPORTOBUSTATUS_URL: API_SERVER_URL + 'api/VTSTroubleshoot/ExportAllVehicleObuStatus',
	    // Event viewer
	    API_GET_AUDIT_LOG_TRAIL_LIST: API_SERVER_URL + 'api/EventViewer/GetAuditLogTrailList',
	    //VTS HISTORY
	    API_GET_VTS_HISTORY_LIST: API_SERVER_URL + 'api/VTS/GetVTSHistoryList',
	    API_EXPORT_VTS_HISTORY_LIST: API_SERVER_URL + 'api/VTS/ExportVTSHistoryList',
	    // OdometerLogTrail
	    API_GET_ODOMETERLOGTRAIL_LIST: API_SERVER_URL + 'api/OdometerLogTrail/GetOdometerLogList',
	    API_GET_ODOMETER_VEHICLE_DROPDOWN_LIST: API_SERVER_URL + 'api/OdometerLogTrail/GetVehicleDropdownForOdometer',
	    API_GET_ODOMETERLOGTRAIL_BY_HASH: API_SERVER_URL + 'api/OdometerLogTrail/GetOdometerByHashID',
	    API_POST_ODOMETERLOGTRAIL_DETAIL: API_SERVER_URL + 'api/OdometerLogTrail/UpdateOdometerLogTrail',
	    API_EXPORT_ODOMETER_LIST: API_SERVER_URL + 'api/OdometerLogTrail/ExportOdometerLogTrail',
	    API_POST_ODOMETER_DESCRIPTION: API_SERVER_URL + 'api/OdometerLogTrail/UpdateDescriptionOfDeviation',
	    //Signup form config
	    API_POST_SIGNUP_CONFIG_DETAIL: API_SERVER_URL + 'api/SignupFormConfig/UpdateSignupFormConfig',
	    API_GET_SIGNUP_CONFIG_LIST: API_SERVER_URL + 'api/SignupFormConfig/GetAllSignupFormConfig',
	    API_GET_SIGNUP_CONFIG_BY_HASH: API_SERVER_URL + 'api/SignupFormConfig/GetSignupFormConfigByHashID',
	    API_POST_DELETE_SIGNUP_CONFIG: API_SERVER_URL + 'api/SignupFormConfig/DeleteSignupFormConfig',
	    API_GET_SIGNUP_CONFIG_DETAILS: API_SERVER_URL + 'api/Backoffice/GetSignUpConfiguration',
	    API_POST_SIGNUP_DETAIL: API_SERVER_URL + 'api/Backoffice/SaveSignupDetail',
	    API_GET_SUBSCRIPTION_LIST_SIGNUP: API_SERVER_URL + 'api/SignupFormConfig/GetSubscriptiopnListForSignupForm',
	    API_EXPORT_SIGNUP_CONFIG: API_SERVER_URL + 'api/SignupFormConfig/ExportSignupFormConfig',
	    API_GET_SIGNUP_LIST: API_SERVER_URL + 'api/SignupForm/GetSignupFormOverviewList',
	    API_EXPORT_SIGNUP_LIST: API_SERVER_URL + 'api/SignupForm/ExportSignupFormOverviewList',
	    API_ACCEPT_REJECT_SIGNUP: API_SERVER_URL + 'api/SignupForm/AcceptRejectSignup',
	    API_GET_DIRECT_DEBIT_LIST: API_SERVER_URL + 'api/BookingInvoice/GetDirectDebitList',
	    API_EXPORT_DIRECT_DEBIT_LIST: API_SERVER_URL + 'api/BookingInvoice/ExportDirectDebitInvoice',
	    API_GET_DIRECTDEBIT: API_SERVER_URL + 'api/BookingInvoice/GetDirectDebitFile',
	    API_CREATE_DIRECT_DEBIT_FOR_COMPANY: API_SERVER_URL + 'api/BookingInvoice/CreateDirectDebitFileForCompany',
	    API_RECREATE_DIRECT_DEBIT_FOR_COMPANY: API_SERVER_URL + 'api/BookingInvoice/ReCreateDirectDebitFileForCompany',
	    API_GET_DROPDOWN_INSTANCE_LIST_SIGNUPCONFIG: API_SERVER_URL + 'api/Instance/GetDropdownInstanceListForSignUpConfig',
	    //Sign Out
	    API_GET_LOGOUT: API_SERVER_URL + 'api/Logout/Logout',
	    API_GET_VEHICLE_OCCUPANCY_REPORT: API_SERVER_URL + 'api/VehicleOccupancy/GenerateVehicleOccupancyReport',
	    API_EXPORT_VEHICLE_OCCUPANCY_REPORT_PDF: API_SERVER_URL + 'api/VehicleOccupancy/ExportVehicleOccupancyReportPDF',
	    API_EXPORT_VEHICLE_OCCUPANCY_REPORT_EXCEL: API_SERVER_URL + 'api/VehicleOccupancy/ExportVehicleOccupancyReportExcel',
	    API_GET_RESOURCE_LABEL: API_SERVER_URL + 'api/BackOffice/GetResourceLable',
	    API_GET_CHECK_ACCOUNT_ACTIVATION_TERMS_CONDITION_STATUS: API_SERVER_URL +
	        'api/Backoffice/CheckAccountActivationTermsConditionStatus',
	    //Batch Upload
	    API_VALIDATE_BATCH_UPLOAD_PERSON_CSV: API_SERVER_URL + 'api/BatchUploadPerson/ValidatePersonCSVRecord',
	    API_IMPORT_BATCH_UPLOAD_CSV: API_SERVER_URL + 'api/SignupForm/ImportPersonRecord',
	    API_GET_MAINTENANCE_PLANNING_VEHICLE_LIST: API_SERVER_URL + 'api/MaintenencePlanning/GetMaintenencePlanning',
	    API_GET_MAINTENANCE_PLANNING_VEHICLE_LIST_PDF: API_SERVER_URL + 'api/MaintenencePlanning/GetMaintenencePlanningPdf',
	    API_GET_MAINTENANCE_PLANNING_VEHICLE_LIST_XLS: API_SERVER_URL + 'api/MaintenencePlanning/GetMaintenencePlanningXls',
	    //Revenue Per Vehicle Report
	    API_GET_REVENUE_PER_VEHICLE_LIST: API_SERVER_URL + 'api/Revenue/GetRevenuePerVehicle',
	    API_EXPORT_REVENUE_PER_VEHICLE_LIST_PDF: API_SERVER_URL + 'api/Revenue/GetRevenuePerVehiclePdf',
	    API_EXPORT_REVENUE_PER_VEHICLE_LIST_XLS: API_SERVER_URL + 'api/Revenue/GetRevenuePerVehicleXls',
	    // Snail Trail
	    API_POST_SEARCH_SNAIL_TRAIL: API_SERVER_URL + 'api/SnailTrail/GetSnailTrail',
	    API_GET_SEARCH_SNAIL_TRAIL_CSV: API_SERVER_URL + 'api/SnailTrail/ExportSnailTrail',
	    //Customer
	    API_POST_CUSTOMER_DETAIL: API_SERVER_URL + 'api/Customer/UpdateCustomer',
	    API_GET_CUSTOMER_LIST: API_SERVER_URL + 'api/Customer/GetAllCustomer',
	    API_GET_CUSTOMER_BY_HASH: API_SERVER_URL + 'api/Customer/GetCustomerByHashID',
	    API_GET_CUSTOMER_BASIC_DETAIL: API_SERVER_URL + 'api/Customer/GetCustomerBasicDetail',
	    API_POST_DELETE_CUSTOMER: API_SERVER_URL + 'api/Customer/DeleteCustomer',
	    API_EXPORT_CUSTOMER_LIST: API_SERVER_URL + 'api/Customer/ExportCustomer',
	    API_GET_DROPDOWN_CUSTOMER_LIST: API_SERVER_URL + 'api/Customer/GetDropdownCustomerList',
	    API_GET_DROPDOWN_CUSTOMER_LIST_TEMPLATE: API_SERVER_URL + 'api/Customer/GetDropdownCustomerListForTemplate',
	    API_GET_DROPDOWN_CUSTOMER_LIST_FOR_KICK_BACK_REPORT: API_SERVER_URL + 'api/Customer/GetDropdownCustomerListForKickBackReport',
	    API_GET_DROPDOWN_CUSTOMER_LIST_FOR_COST_CENTER_REPORT: API_SERVER_URL + 'api/Customer/GetDropdownCustomerListForCostCenterReport',
	    // Role Management
	    API_GET_ROLE_LIST: API_SERVER_URL + 'api/Role/GetAllRoleList',
	    API_EXPORT_ROLE_LIST: API_SERVER_URL + 'api/Role/ExportRole',
	    API_GET_ROLE_BY_HASH: API_SERVER_URL + 'api/Role/GetRoleByHashID',
	    API_POST_ROLE_DETAIL: API_SERVER_URL + 'api/Role/UpdateRole',
	    API_GET_ENTITY_LIST: API_SERVER_URL + 'api/Role/GetAllDefaultEntityList',
	    API_GET_ROLE_LIST_BY_ENTITY: API_SERVER_URL + 'api/Role/GetRoleListByEntity',
	    API_GET_ACCESSIBILITY_BY_HASH: API_SERVER_URL + 'api/Role/GetAccessibilityMatrixByRoleHashId',
	    API_POST_DELETE_ROLE: API_SERVER_URL + 'api/Role/DeleteRole',
	    //RoleAvailability
	    API_POST_ROLEAVAILABILITY_DETAIL: API_SERVER_URL + 'api/RoleAvailability/UpdateRoleAvailability',
	    API_GET_ROLEAVAILABILITY_LIST: API_SERVER_URL + 'api/RoleAvailability/GetAllRoleAvailability',
	    API_GET_ROLEAVAILABILITY_BY_HASH: API_SERVER_URL + 'api/RoleAvailability/GetRoleAvailabilityByHashID',
	    API_POST_DELETE_ROLEAVAILABILITY: API_SERVER_URL + 'api/RoleAvailability/DeleteRoleAvailability',
	    API_EXPORT_ROLEAVAILABILITY_LIST: API_SERVER_URL + 'api/RoleAvailability/ExportRoleAvailability',
	    API_GET_ROLE_FOR_ASSIGN_TO_CUSTOMER_LIST: API_SERVER_URL + 'api/RoleAvailability/GetAllRoleForAssignToCustomer',
	    API_POST_ADD_ROLEAVAILABILITY: API_SERVER_URL + 'api/RoleAvailability/AddRoleAvailability',
	    //Admin Of Customer
	    API_GET_ADMIN_OF_CUSTOMER_LIST: API_SERVER_URL + 'api/AdminOfCustomer/GetAdminOfCustomerList',
	    API_POST_DELETE_ADMIN_OF_CUSTOMER: API_SERVER_URL + 'api/AdminOfCustomer/DeleteAdminOfCustomerList',
	    API_GET_CUSTOMER_ROLEAVAILABILITY_LIST: API_SERVER_URL + 'api/AdminOfCustomer/GetAllRoleAvailability',
	    API_POST_DELETE_ADMIN_OF_CUSTOMER_ROLE: API_SERVER_URL + 'api/AdminOfCustomer/DeleteAdminOfCustomerRole',
	    API_POST_ADD_ADMIN_OF_CUSTOMER_ROLE: API_SERVER_URL + 'api/AdminOfCustomer/AddAdminOfCustomerRole',
	    API_EXPORT_ADMIN_OF_CUSTOMER_LIST: API_SERVER_URL + 'api/AdminOfCustomer/ExportAdminOfCustomer',
	    API_GET_CUSTOMER_PERSON_TO_INVITE_LIST: API_SERVER_URL + 'api/AdminOfCustomer/GetPersonListToInvite',
	    API_POST_INVITE_ADMIN_OF_CUSTOMER: API_SERVER_URL + 'api/AdminOfCustomer/InviteAdminOfCustomer',
	    //Admin Of SharedVehicleGroup
	    API_GET_ADMIN_OF_SVG_LIST: API_SERVER_URL +
	        'api/AdminOfSharedVehicleGroup/GetAdminOfSharedVehicleGroupList',
	    API_POST_DELETE_ADMIN_OF_SVG: API_SERVER_URL +
	        'api/AdminOfSharedVehicleGroup/DeleteAdminOfSharedVehicleGroupList',
	    API_GET_SVG_ROLEAVAILABILITY_LIST: API_SERVER_URL + 'api/AdminOfSharedVehicleGroup/GetAllRoleAvailability',
	    API_POST_DELETE_ADMIN_OF_SVG_ROLE: API_SERVER_URL +
	        'api/AdminOfSharedVehicleGroup/DeleteAdminOfSharedVehicleGroupRole',
	    API_POST_ADD_ADMIN_OF_SVG_ROLE: API_SERVER_URL +
	        'api/AdminOfSharedVehicleGroup/AddAdminOfSharedVehicleGroupRole',
	    API_EXPORT_ADMIN_OF_SVG_LIST: API_SERVER_URL +
	        'api/AdminOfSharedVehicleGroup/ExportAdminOfSharedVehicleGroup',
	    API_GET_SVG_PERSON_TO_INVITE_LIST: API_SERVER_URL + 'api/AdminOfSharedVehicleGroup/GetPersonListToInvite',
	    API_POST_INVITE_ADMIN_OF_SVG: API_SERVER_URL +
	        'api/AdminOfSharedVehicleGroup/InviteAdminOfSharedVehicleGroup',
	    //Admin Of Instance
	    API_GET_ADMIN_OF_INSTANCE_LIST: API_SERVER_URL + 'api/AdminOfInstance/GetAdminOfInstanceList',
	    API_POST_DELETE_ADMIN_OF_INSTANCE: API_SERVER_URL + 'api/AdminOfInstance/DeleteAdminOfInstanceList',
	    API_GET_INSTANCE_ROLEAVAILABILITY_LIST: API_SERVER_URL + 'api/AdminOfInstance/GetAllRoleAvailability',
	    API_POST_DELETE_ADMIN_OF_INSTANCE_ROLE: API_SERVER_URL + 'api/AdminOfInstance/DeleteAdminOfInstanceRole',
	    API_POST_ADD_ADMIN_OF_INSTANCE_ROLE: API_SERVER_URL + 'api/AdminOfInstance/AddAdminOfInstanceRole',
	    API_EXPORT_ADMIN_OF_INSTANCE_LIST: API_SERVER_URL + 'api/AdminOfInstance/ExportAdminOfInstance',
	    API_GET_INSTANCE_PERSON_TO_INVITE_LIST: API_SERVER_URL + 'api/AdminOfInstance/GetPersonListToInvite',
	    API_POST_INVITE_ADMIN_OF_INSTANCE: API_SERVER_URL + 'api/AdminOfInstance/InviteAdminOfInstance',
	    //AdminInvitation
	    API_GET_CHECK_ADMIN_VALID_ACTIVATION_CODE: API_SERVER_URL + 'api/AdminInvitation/CheckActivationCodeIsValid',
	    API_GET_CHECK_ADMIN_USER_EXIST_BY_ACTIVATION_CODE: API_SERVER_URL + 'api/AdminInvitation/CheckPersonExistByActivationCode',
	    API_GET_REJECT_ADMIN_INVITATION_BY_REJECTION_CODE: API_SERVER_URL + 'api/AdminInvitation/InvitationRejected',
	    API_GET_ACCEPT_ADMIN_INVITATION_BY_APPROVAL_CODE: API_SERVER_URL + 'api/AdminInvitation/InvitationAccepted',
	    API_POST_ADMIN_ADD_DETAIL: API_SERVER_URL + 'api/AdminInvitation/AddPersonProfile',
	    API_GET_CHECK_ADMIN_USER_ROLE_EXIST_BY_ACTIVATION_CODE: API_SERVER_URL + 'api/AdminInvitation/CheckPersonRoleExistByActivationCode',
	    //Admin Of Company
	    API_GET_ADMIN_OF_COMPANY_LIST: API_SERVER_URL + 'api/AdminOfCompany/GetAdminOfCompanyList',
	    API_POST_DELETE_ADMIN_OF_COMPANY: API_SERVER_URL + 'api/AdminOfCompany/DeleteAdminOfCompanyList',
	    API_GET_COMPANY_ROLEAVAILABILITY_LIST: API_SERVER_URL + 'api/AdminOfCompany/GetAllRoleAvailability',
	    API_POST_DELETE_ADMIN_OF_COMPANY_ROLE: API_SERVER_URL + 'api/AdminOfCompany/DeleteAdminOfCompanyRole',
	    API_POST_ADD_ADMIN_OF_COMPANY_ROLE: API_SERVER_URL + 'api/AdminOfCompany/AddAdminOfCompanyRole',
	    API_EXPORT_ADMIN_OF_COMPANY_LIST: API_SERVER_URL + 'api/AdminOfCompany/ExportAdminOfCompany',
	    API_GET_COMPANY_PERSON_TO_INVITE_LIST: API_SERVER_URL + 'api/AdminOfCompany/GetPersonListToInvite',
	    API_POST_INVITE_ADMIN_OF_COMPANY: API_SERVER_URL + 'api/AdminOfCompany/InviteAdminOfCompany',
	    //Admin Of Instance
	    API_GET_ADMIN_OF_ORGANIZATION_LIST: API_SERVER_URL + 'api/AdminOfOrganization/GetAdminOfOrganizationList',
	    API_POST_DELETE_ADMIN_OF_ORGANIZATION: API_SERVER_URL + 'api/AdminOfOrganization/DeleteAdminOfOrganizationList',
	    API_GET_ORGANIZATION_ROLEAVAILABILITY_LIST: API_SERVER_URL + 'api/AdminOfOrganization/GetAllRoleAvailability',
	    API_POST_DELETE_ADMIN_OF_ORGANIZATION_ROLE: API_SERVER_URL + 'api/AdminOfOrganization/DeleteAdminOfOrganizationRole',
	    API_POST_ADD_ADMIN_OF_ORGANIZATION_ROLE: API_SERVER_URL + 'api/AdminOfOrganization/AddAdminOfOrganizationRole',
	    API_EXPORT_ADMIN_OF_ORGANIZATION_LIST: API_SERVER_URL + 'api/AdminOfOrganization/ExportAdminOfOrganization',
	    API_GET_ORGANIZATION_PERSON_TO_INVITE_LIST: API_SERVER_URL + 'api/AdminOfOrganization/GetPersonListToInvite',
	    API_POST_INVITE_ADMIN_OF_ORGANIZATION: API_SERVER_URL + 'api/AdminOfOrganization/InviteAdminOfOrganization',
	    // Organization's Subscriptions
	    API_GET_SUBSCRIPTION_LIST_FOR_ORGANIZATION: API_SERVER_URL +
	        'api/OrganizationSubscription/GetSubscriptionByOrganizationHashId',
	    API_GET_SUBSCRIPTION_LIST_FOR_ORGANIZATION_TO_INSTANCE: API_SERVER_URL +
	        'api/OrganizationSubscription/GetSubscriptionListByOrganizationToInstanceId',
	    API_POST_ORGANIZATION_SUBSCRIPTION_DETAIL: API_SERVER_URL +
	        'api/OrganizationSubscription/UpdateOrganizationToSubscriptionMapping',
	    API_EXPORT_ORGANIZATION_SUBSCRIPTION_LIST: API_SERVER_URL + 'api/OrganizationSubscription/ExportSubscription',
	    API_DELETE_ORGANIZATION_SUBSCRIPTION_MAPPING: API_SERVER_URL +
	        'api/OrganizationSubscription/DeleteSubscriptionToOrganizationMapping',
	    // Organization's Drivers
	    API_GET_DRIVER_LIST_FOR_ORGANIZATION: API_SERVER_URL + 'api/OrganizationDriver/GetDriverListByOrganizationHashId',
	    API_GET_DRIVER_LIST_FOR_ORGANIZATION_TO_INSTANCE: API_SERVER_URL +
	        'api/OrganizationDriver/GetDriverListByOrganizationToInstanceId',
	    API_POST_ORGANIZATION_DRIVER_DETAIL: API_SERVER_URL + 'api/OrganizationDriver/UpdateOrganizationToDriverMapping',
	    API_EXPORT_ORGANIZATION_MAP_DRIVER_LIST: API_SERVER_URL + 'api/OrganizationDriver/ExportDriverList',
	    API_DELETE_ORGANIZATION_DRIVER_MAPPING: API_SERVER_URL + 'api/OrganizationDriver/DeleteDriverToOrganizationMapping',
	    API_POST_ORGANIZATION_DRIVER_PERSON_DETAIL: API_SERVER_URL + 'api/OrganizationDriver/AddOrganizationDriverPersonMaster',
	    API_GET_ORGANIZATION_PERSON_TO_INVITE_AS_DRIVER_LIST: API_SERVER_URL + 'api/OrganizationDriver/GetPersonListToInvite',
	    API_POST_INVITE_DRIVER_OF_ORGANIZATION: API_SERVER_URL + 'api/OrganizationDriver/AddOrganizationDriver',
	    API_GET_DRIVER_LIST_FOR_COST_CENTER_REPORT: API_SERVER_URL +
	        'api/OrganizationDriver/GetOrganizationBasedDriverListForCostCenterReport',
	    //Terms and Conditions
	    API_GET_TERMSANDCONDITIONS_LIST: API_SERVER_URL + 'api/TermsAndConditions/GetTermsAndConditionsList',
	    API_EXPORT_TERMSANDCONDITIONS_LIST: API_SERVER_URL + 'api/TermsAndConditions/ExportTermsAndConditions',
	    API_POST_TERMSANDCONDITIONS_DETAILS: API_SERVER_URL + 'api/TermsAndConditions/UpdateTermsAndConditions',
	    API_GET_TERMSANDCONDITIONS_BY_HASH: API_SERVER_URL + 'api/TermsAndConditions/GetTermsAndConditionsByHashId',
	    API_POST_DELETE_TERMSANDCONDITIONS: API_SERVER_URL + 'api/TermsAndConditions/DeleteTermsAndConditions',
	    API_GET_TERMSANDCONDITION_BYINSTANCEHASH: API_SERVER_URL +
	        'api/TermsAndConditions/GetTermsAndConditionsByIntanceHashId',
	    API_GET_TERMSANDCONDITION_BYACTIVATIONCODE: API_SERVER_URL +
	        'api/TermsAndConditions/GetTermsAndConditionsByActivationCode',
	    API_GET_PRIVACYSTATEMENT_BYACTIVATIONCODE: API_SERVER_URL +
	        'api/TermsAndConditions/GetPrivacyStatementByActivationCode',
	    API_GET_TERMSANDCONDITION_BYPERSONACTIVATIONCODE: API_SERVER_URL +
	        'api/TermsAndConditions/GetTermsAndConditionsByPersonActivationCode',
	    API_GET_PRIVACYSTATEMENT_BYPERSONACTIVATIONCODE: API_SERVER_URL +
	        'api/TermsAndConditions/GetPrivacyStatementByPersonActivationCode',
	    API_GET_TERMSANDCONDITION_BYSIGNUPPARAM: API_SERVER_URL +
	        'api/TermsAndConditions/GetTermsAndConditionsBySignupParam',
	    API_POST_TERMSANDCONDITION_ACTIVITYLOG: API_SERVER_URL +
	        'api/TermsAndConditions/AddUpdateTermsConditionActivityLog',
	    API_GET_ACTION_ON_ACCOUNT_ACTIVATION_TERMS_CONDITION: API_SERVER_URL + 'api/Backoffice/ActionOnAccountActivationTermsCondition',
	    API_GET_TERMSANDCONDITIONS_ACTIVITY_LIST: API_SERVER_URL + 'api/TermsAndConditions/GetTermsAndConditionsActivityList',
	    API_GET_TERMSANDCONDITIONS_ACTIVITY_LIST_DRIVER: API_SERVER_URL +
	        'api/TermsAndConditions/GetTermsAndConditionsActivityListDriver',
	    API_EXPORT_TERMSANDCONDITIONS_ACTIVITY_LIST: API_SERVER_URL + 'api/TermsAndConditions/ExportTermsAndConditionsActivity',
	    API_EXPORT_TERMSANDCONDITIONS_ACTIVITY_LIST_DRIVER: API_SERVER_URL +
	        'api/TermsAndConditions/ExportTermsAndConditionsActivityListDriver',
	    API_GET_TERMSANDCONDITIONS_ACTIVITY_BY_HASH: API_SERVER_URL +
	        'api/TermsAndConditions/GetTermsAndConditionsActivityLogByHashId',
	    API_POST_REVOKE_TERMSANDCONDITIONS: API_SERVER_URL + 'api/TermsAndConditions/RevokeTermsAndConditions',
	    API_GET_TERMSANDCONDITION_FOR_DRIVER: API_SERVER_URL + 'api/TermsAndConditions/GetTermsConditionForDriver',
	    // Privacy Statements
	    API_GET_PRIVACYSTATEMENTS_BYSIGNUPPARAM: API_SERVER_URL + 'api/TermsAndConditions/GetPrivacyBySignupParam',
	    API_GET_CHECK_ACCOUNT_ACTIVATION_PRIVACYSTATEMENT_STATUS: API_SERVER_URL + 'api/Backoffice/CheckAccountActivationPrivacyStatus',
	    //Cost And Expenses
	    API_GET_COSTANDEXPENSE_LIST: API_SERVER_URL + 'api/CostAndExpense/GetCostAndExpenseList',
	    API_EXPORT_COSTANDEXPENSE_LIST: API_SERVER_URL + 'api/CostAndExpense/ExportCostAndExpenseList',
	    API_POST_DELETE_COSTANDEXPENSE: API_SERVER_URL + 'api/CostAndExpense/DeleteCostAndExpenseList',
	    API_GET_COSTANDEXPENSE_BY_HASH: API_SERVER_URL + 'api/CostAndExpense/GetCostAndExpenseByHashID',
	    API_GET_DROPDOWN_COSTTYPE_LIST: API_SERVER_URL + 'api/CostAndExpense/GetDropdownCostTypeList',
	    API_GET_DROPDOWN_COSTANDEXPENSE_ORGANIZATION_LIST: API_SERVER_URL + 'api/CostAndExpense/GetDropdownOrganizationList',
	    API_POST_APPROVE_REJECT_COSTANDEXPENSE: API_SERVER_URL + 'api/CostAndExpense/ApproveRejectCostAndExpense',
	    API_POST_UPDATE_COSTANDEXPENSE: API_SERVER_URL + 'api/CostAndExpense/UpdateCostAndExpense',
	    API_GET_APPROVED_COSTANDEXPENSE_LIST: API_SERVER_URL + 'api/CostAndExpense/GetApprovedExpenseList',
	    API_POST_REMOVE_COSTANDEXPENSE_FROM_INVOICE: API_SERVER_URL + 'api/CostAndExpense/RemoveCostAndExpenseFromInvoice',
	    API_GET_COST_TYPE_LIST_FOR_COST_CENTER_REPORT: API_SERVER_URL + 'api/CostAndExpense/GetCostTypeListForCostCenterReport',
	    API_POST_UPDATE_COSTANDEXPENSE_MANUALINVOICE: API_SERVER_URL + 'api/CostAndExpense/UpdateCostAndExpenseManualInvoice',
	    //Invoice List
	    API_DELETE_INVOICE: API_SERVER_URL + 'api/BookingInvoice/DeleteInvoice',
	    API_INVOICE_PAYMENT_HISTORY_LIST: API_SERVER_URL + 'api/Payment/GetPaymentHistoryByInvoiceId',
	    API_EXPORT_INVOICE_PAYMENT_HISTORY: API_SERVER_URL + 'api/Payment/ExportPaymentHistoryByInvoiceId',
	    //Invoice Update
	    API_GET_DRIVER_LIST_INVOICE: API_SERVER_URL + 'api/BookingInvoice/GetDriverListForInvoice',
	    API_GET_ORGANIZATION_LIST_INVOICE: API_SERVER_URL + 'api/BookingInvoice/GetOrganizationListForInvoice',
	    API_POST_MANUAL_INVOICE: API_SERVER_URL + 'api/BookingInvoice/CCE/UpdateManualInvoice',
	    API_GET_INVOICE_NUMBER: API_SERVER_URL + 'api/BookingInvoice/GetInvoiceNumber',
	    API_GET_INVOICE_BY_HASH: API_SERVER_URL + 'api/BookingInvoice/GetManualInvoiceByHashID',
	    API_GET_COMPANY_ADDRESS: API_SERVER_URL + 'api/BookingInvoice/GetCompanyAddress',
	    API_GET_DRIVER_ADDRESS: API_SERVER_URL + 'api/BookingInvoice/GetDriverAddress',
	    API_GET_ORGANIZATION_ADDRESS: API_SERVER_URL + 'api/BookingInvoice/GetOrganizationAddress',
	    API_GET_DROPDOWN_MANUAL_INVOICE_BOOKING_LIST: API_SERVER_URL + 'api/BookingInvoice/GetBookingDropDownList',
	    API_GET_UPDATE_DUE_DATE_FOR_INVOICE: API_SERVER_URL + 'api/BookingInvoice/CCE/UpdateDueDateForInvoice',
	    API_POST_UPDATE_INVOICE_STATUS: API_SERVER_URL + 'api/BookingInvoice/CCE/UpdateInvoiceStatus',
	    API_GET_INVOICE_REOPEN_REASON_DROPDOWN_URL: API_SERVER_URL + 'api/BookingInvoice/GetReopenReasonDropdownList',
	    API_GET_INVOICE_CLOSED_REASON_DROPDOWN_URL: API_SERVER_URL + 'api/BookingInvoice/GetClosedReasonDropdownList',
	    //Pre post trip question
	    API_PRE_POST_TRIP_QUESTION_LIST: API_SERVER_URL + 'api/PrePostTripQuestion/GetPrePostQuestionList',
	    API_PRE_POST_TRIP_QUESTION_DETAILS: API_SERVER_URL + 'api/PrePostTripQuestion/GetAllPrePostTripQuestionList',
	    API_PRE_POST_TRIP_QUESTION_CUSTOM: API_SERVER_URL + 'api/PrePostTripQuestion/ValidatePrePostCustomQuestion',
	    API_PRE_POST_TRIP_QUESTION_UPDATE: API_SERVER_URL + 'api/PrePostTripQuestion/UpdatePrePostTripQuestionMaster',
	    API_PRE_POST_TRIP_QUESTION_BY_HASHID: API_SERVER_URL + 'api/PrePostTripQuestion/GetPrePostTripQuestionByHashID',
	    API_PRE_POST_TRIP_QUESTION_BY_INSTANCEHASHID: API_SERVER_URL +
	        'api/PrePostTripQuestion/GetPrePostTripQuestionByInstanceHashID',
	    //Pre post trip question overview
	    API_PRE_POST_QUESTION_OVERVIEW: API_SERVER_URL + 'api/PrePostTripQuestion/GetPrePostQuestionOverviewList',
	    API_GET_PRE_POST_QUESTION_NAME: API_SERVER_URL + 'api/PrePostTripQuestion/GetDropdownQuestionTypeList',
	    API_PRE_POST_QUESTION__Export: API_SERVER_URL + 'api/PrePostTripQuestion/ExportPrePostQuestionsOverview',
	    API_GET_IS_AUTHORIZE_FOR_PREPOST_QUESTION: API_SERVER_URL + 'api/PrePostTripQuestion/IsAuthorizeForPrePostQuestions',
	    //Credit card payment
	    API_GET_VERIFY_REDIRECT_FOR_PAYMENT: API_SERVER_URL + 'api/BookingMaster/VerifyRedirectKeyForPayment',
	    API_DELETE_CREDITCARD_DETAILS_BYHASHID: API_SERVER_URL + 'api/PersonMaster/DeleteCreditCardDetailsByHashId',
	    API_UPDATE_BOOKING_SUCCESSPAYMENT: API_SERVER_URL + 'api/BookingMaster/UpdateBookingAfterSuccessfulPayment',
	    //Invoice InvoiceMissingSendModel
	    API_GET_INVOICE_MISSING_SEND_LIST: API_SERVER_URL + 'api/InvoiceMissingSend/GetInvoiceMissingDriver',
	    API_POST_GENERATE_MISSING_INVOICE: API_SERVER_URL + 'api/InvoiceMissingSend/GenerateInvoice',
	    //
	    //TwoFA
	    API_GET_TWOFA_GOOGLE_SETUP_DETAILS: API_SERVER_URL + 'api/TwoFAAuth/GetTwoFAGoogleSetupCode',
	    API_VERIFY_TWOFA_TOTP: API_SERVER_URL + 'api/TwoFAAuth/VerifyTwoFAGoogleTOTP',
	    API_SEND_TWOFA_EMAIL_CODE: API_SERVER_URL + 'api/TwoFAAuth/SendTwoFaEmailCode',
	    API_VERIFY_EMAIL_CODE: API_SERVER_URL + 'api/TwoFAAuth/VerifyTwoFAEmailOTP',
	    //
	    //SSO
	    API_GET_SSO_CONFIG: SSO_BASE_URL + 'saml/GetSingleSignOnConfig',
	    API_GET_INITIATE_SSO: SSO_BASE_URL + 'saml/InitiateSingleSignOn/',
	    API_GET_ASSERTION_SSO: SSO_BASE_URL + 'saml/TokenAssertionConsumerService/',
	    //
	    //Fix RFID Tag
	    API_CORRECT_TAG: API_SERVER_URL + 'api/PersonMaster/CorrectTag',
	};
	exports.UserRoles = {
	    WEGOADMIN: 'WEGOADMIN',
	    COMPANYADMIN: 'COMPANYADMIN',
	    GROUPADMIN: 'GROUPADMIN',
	    ORGANIZATIONADMIN: 'ORGANIZATIONADMIN',
	    DRIVER: 'DRIVER',
	    PERSON: 'PERSON',
	    ADMIN: 'ADMIN'
	};
	exports.BookingStatus = {
	    PROVISIONAL: 'PROVISIONAL',
	    CONFIRMED: 'CONFIRMED',
	    CANCELLED: 'CANCELLED',
	    ABORTED: 'ABORTED',
	    REVOKED: 'REVOKED',
	    FINISHED: 'FINISHED',
	    PENDING: 'PENDING'
	};
	exports.BookingType = {
	    NORMAL: 'NORMAL',
	    MAINTENANCE: 'MAINTENANCE',
	    UNAVAILABLE: 'UNAVAILABLE'
	};
	exports.QuestionType = {
	    PREBEFORE: 'PREBEFORE',
	    PREAFTER: 'PREAFTER',
	    POST: 'POST'
	};
	exports.ApplicationRouteURL = {
	    URL_DEFAULT_PAGE: '',
	    URL_DASHBOARD_PAGE: 'dashboard',
	    URL_BRANDING_PAGE: 'branding',
	    URL_INBOX_PAGE: 'inbox',
	    URL_TERMS_CONDITION_PAGE: 'termsandcondition',
	    URL_INSTANCE_LIST: 'instance/list',
	    URL_INSTANCE_UPDATE: 'instance/update',
	    URL_INSTANCE_ADD: 'instance/add',
	    URL_PERSON_LIST: 'person/list',
	    URL_PERSON_ADD: 'person/add',
	    URL_PERSON_UPDATE: 'person/update',
	    URL_COMPANY_LIST: 'company/list',
	    URL_ERRORLOG_List: 'errorlog/list',
	    URL_ERROR_ESCALATION_LIST: 'errorescalation/list',
	    URL_ERROR_ESCALATION_UPDATE: 'errorescalation/update',
	    URL_ERROR_ESCALATION_ADD: 'errorescalation/add',
	    URL_INTERFACESTATUS_List: 'interfacestatus/list',
	    URL_COMPANY_UPDATE: 'company/update',
	    URL_COMPANY_ADD: 'company/add',
	    URL_COMPANYADMIN_LIST: 'companyAdmin/list',
	    URL_SVG_LIST: 'sharedvehiclegroup/list',
	    URL_SVG_ADD: 'sharedvehiclegroup/add',
	    URL_SVG_UPDATE: 'sharedvehiclegroup/update',
	    URL_SVGADMIN_LIST: 'sharedvehiclegroupadmin/list',
	    URL_VEHICLE_LIST: 'vehicle/list',
	    URL_SVGVEHICLE_LIST: 'sharedvehiclegroup/svgvehicle',
	    URL_SVGDRIVER_LIST: 'sharedvehiclegroup/svgdriver',
	    URL_VEHICLE_ADD: 'vehicle/add',
	    URL_VEHICLE_UPDATE: 'vehicle/update',
	    URL_VTSVEHICLE_ADD: 'vtsvehicle/add',
	    URL_VTSVEHICLE_UPDATE: 'vtsvehicle/update',
	    URL_VTSVEHICLE_LIST: 'vtsvehicle/list',
	    //URL_VEHICLE_SVG_LIST: 'vehicle/svglist',
	    URL_VEHICLE_INFO: 'vehicle/vehicleinformation',
	    URL_REPORT_DAMGE_UPDATE: 'vehicle/updatereportdamage',
	    URL_DRIVER_LIST: 'driver/list',
	    URL_DRIVER_UPDATE: 'driver/update',
	    URL_VEHICLEATTRIBUTE_LIST: 'vehicleattribute/list',
	    URL_VEHICLEATTRIBUTE_ADD: 'vehicleattribute/add',
	    URL_VEHICLEATTRIBUTE_UPDATE: 'vehicleattribute/update',
	    URL_DRIVER_SVG_LIST: 'driverSVG/list',
	    URL_CONTRACT_TYPE_LIST: 'contractType/list',
	    URL_CONTRACT_TYPE_ADD: 'contractType/add',
	    URL_CONTRACT_TYPE_UPDATE: 'contractType/update',
	    URL_CONTRACT_TYPE_GROUP_LIST: 'contractTypegroup/list',
	    URL_CONTRACT_TYPE__GROUP_ADD: 'contractTypegroup/add',
	    URL_CONTRACT_TYPE__GROUP_UPDATE: 'contractTypegroup/update',
	    URL_VEHICLEATTRIBUTE_CATEGORY_LIST: 'vehicleattributecategory/list',
	    URL_VEHICLEATTRIBUTE_CATEGORY_UPDATE: 'vehicleattributecategory/update',
	    URL_VEHICLEATTRIBUTE_CATEGORY_ADD: 'vehicleattributecategory/add',
	    URL_BOOKING: 'booking',
	    URL_BOOKING_OVERVIEW: 'booking/overview',
	    URL_BOOKING_REQUEST: 'booking/request',
	    URL_COST_EXPENSE_DRIVER_LIST: 'drivercostexpense/list',
	    URL_SNAIL_TRAIL_DRIVER: 'snailtrail',
	    URL_BOOKING_HISTORY: 'booking/history',
	    URL_BOOKING_INFORMATION: 'booking/information',
	    URL_BOOKING_INFORMATION2: 'booking/information2',
	    URL_BOOKING_INFORMATION3: 'booking/information3',
	    URL_BOOKING_INFORMATION_DRIVER: 'bookinginformation',
	    URL_DRIVER_PROFILE: 'profile',
	    URL_USER_PROFILE_UPDATE: 'userprofile',
	    URL_TEMPLATE_LIST: 'template/list',
	    URL_TEMPLATE_UPDATE: 'template/update',
	    URL_TEMPLATE_ADD: 'template/add',
	    URL_TRIP_HISTORY: 'trip/history',
	    URL_TRIP_INFORMATION_DRIVER: 'tripinformation',
	    URL_TRIP_INFORMATION: 'trip/information',
	    URL_SERVICE_OFFER_LIST: 'serviceoffer/list',
	    URL_TIMEBLOCK_UPDATE: 'timeblock/update',
	    URL_TERMS_CONDITION_ACTIVITY_DRIVER: 'TAndCLog',
	    URL_SUBSCRIPTION_LIST: 'subscription/list',
	    URL_SUBSCRIPTION_UPDATE: 'subscription/update',
	    URL_SUBSCRIPTION_ADD: 'subscription/update',
	    URL_SPECIAL_PERIOD_LIST: 'specialperiod/list',
	    URL_SPECIAL_PERIOD_UPDATE: 'specialperiod/update',
	    URL_WEGOADMIN_LIST: 'wegoadminlist/list',
	    URL_BOOKING_INVOICE_LIST: 'invoice/list',
	    URL_BOOKING_INVOICE_LEGACY_LIST: 'invoice-legacy/list',
	    URL_BOOKING_INVOICE_TEST_LIST: 'invoicetest/list',
	    URL_BOOKING_INVOICE_MISSING_SEND_LIST: 'invoicemissingsend/list',
	    URL_SPECIAL_BOOKING: 'specialbooking',
	    URL_BOOKING_TRIP_TEST: 'bookingtriptest',
	    URL_UNLOCK: '/mobile/unlock',
	    URL_START_RIDE: '/mobile/startride',
	    URL_DIRECTDEBIT_LIST: 'directdebit/list',
	    URL_IMPORT_PERSON: 'import/person',
	    URL_DRIVER_LICENCE: 'validatedriverlicence/driverlicencedetail',
	    URL_SUBSCRIPTIONAVAILABILITY_LIST: 'subscriptionavailabilityrestriction-list',
	    URL_SUBSCRIPTIONAVAILABILITY_UPDATE: 'subscriptionavailabilityrestriction-update',
	    URL_SUBSCRIPTIONAVAILABILITY_ADD: 'subscriptionavailabilityrestriction-add',
	    URL_ADDITIONALFREEITEM_UPDATE: 'additionalfreeitem/update',
	    URL_ADDITIONALFREEITEM_ADD: 'additionalfreeitem/add',
	    URL_ADDITIONALFREEITEM_LIST: 'additionalfreeitem/list',
	    URL_TRIP_DETAIL_REPORT: 'tripdetailreport',
	    URL_VEHICLE_FUTURE_BOOKING_LIST: 'vehiclefuterbooking',
	    URL_VTS_TROUBLESHOOT: 'vtstroubleshoot',
	    URL_EVENT_VIEWER_LIST: 'eventviewer',
	    URL_VTS_HISTORY_LIST: 'vtseventhistory',
	    URL_ORGANIZATION_ADD: 'organization/add',
	    URL_ORGANIZATION_UPDATE: 'organization/update',
	    URL_ORGANIZATION_LIST: 'organization/list',
	    URL_ORGANIZATION_ADMIN_LIST: 'organizationAdmin/list',
	    URL_ORGANIZATION_DRIVER_LIST: 'organizationDriver/list',
	    URL_DRIVERINVOICE_LIST: 'driverinvoice/list',
	    URL_VEHICLE_OCCUPANCY_REPORT: 'report/vehicleoccupancy',
	    URL_ODOMETERLOGTRAIL_LIST: 'odometerlogtrail/list',
	    URL_ODOMETERLOGTRAIL_ADD: 'odometerlogtrail/add',
	    URL_ODOMETERLOGTRAIL_UPDATE: 'odometerlogtrail/update',
	    URL_SIGNUPFORM_LIST: 'signupform/list',
	    URL_SIGNUPFORM_UPDATE: 'signupform/update',
	    URL_SIGNUPFORM_ADD: 'signupform/add',
	    URL_SIGNUP_LIST: 'signup/list',
	    URL_BATCHUPLOADPERSON: 'batchupload/person',
	    URL_REVENUE_PER_VEHICLE_REPORT: 'report/revenuepervehiclereport',
	    URL_MAINTENANCE_PLANNING_REPORT: 'report/maintenanceplanningreport',
	    URL_TRIPDATA_REPORT: 'tripdatareport/tripdatareport',
	    URL_SNAIL_TRAIL_REPORT: 'report/snailtrail',
	    URL_KICKBACK_REPORT: 'report/kickback',
	    URL_ROLE_LIST: 'role/list',
	    URL_ROLE_UPDATE: 'role/update',
	    URL_CUSTOMER_LIST: 'customer/list',
	    URL_CUSTOMER_ADD: 'customer/add',
	    URL_CUSTOMER_UPDATE: 'customer/update',
	    URL_ROLEAVAILABILITY_LIST: 'roleavailability/list',
	    URL_ADMIN_OF_CUSTOMER_LIST: 'adminsofcustomer/list',
	    URL_ADMIN_OF_SHAREDVEHICLEGROUP_LIST: 'adminsofsharedvehiclegroup/list',
	    URL_ADMIN_OF_INSTANCE_LIST: 'adminsofinstance/list',
	    URL_ADMIN_OF_COMPANY_LIST: 'adminsofcompany/list',
	    URL_ADMIN_OF_ORGANIZATION_LIST: 'adminsoforganization/list',
	    URL_ORGANIZATION_TO_SUBSCRIPTION_LIST: 'organizationtosubscription/list',
	    URL_ORGANIZATION_TO_DRIVER_LIST: 'organizationtodriver/list',
	    URL_TERMS_AND_CONDITION_ADD: 'termsandcondition/add',
	    URL_TERMS_AND_CONDITION_UPDATE: 'termsandcondition/update',
	    URL_TERMS_AND_CONDITION_POPUP: 'termsconditionpopup/popup',
	    URL_COSTANDEXPENSE_LIST: 'costandexpense/list',
	    URL_INVOICE_UPDATE: 'invoice/update',
	    URL_COST_CENTER_REPORT: 'report/costcenterreport',
	    URL_PAYMENT_HISTORY: 'invoice/invoicePaymentHistory',
	    //Pre - post - trip question
	    URL_PRE_POST_QUESTION: 'preposttripquestion',
	    URL_PRE_POST_QUESTION_UPDATE: 'preposttripquestion/update',
	    URL_PRE_POST_QUESTION_ADD: 'preposttripquestion/add',
	    //pre-post-trip-questions overview
	    URL_PRE_POST_TRIP_QUESTION_OVERVIEW: 'prepostquestionsoverview',
	    URL_PRIVACY_STATEMENT_POPUP: 'privacystatement/popup',
	    URL_TWO_FA_SELECTION: 'twofaselection',
	    URL_TWO_FA_GOOGLE_SETUP: 'twofagooglesetup',
	    URL_TWO_FA_EMAIL_OTP: 'twofaemailotp'
	};
	exports.PermissionType = {
	    VIEW: 'VIEW',
	    INSERT: 'INSERT',
	    EDIT: 'EDIT',
	    DELETE: 'DELETE'
	};
	exports.Entity = {
	    CUSTOMER: 'Customer',
	    INSTANCE: 'Instance',
	    COMPANY: 'Company',
	    SVG: 'SVG',
	    ORGANIZATION: 'Organization',
	    DRIVER: 'Driver'
	};
	exports.Permission = {
	    PR_CUSTOMER_OVERVIEW: 'PR_CUSTOMER_OVERVIEW',
	    PR_DASHBOARD: 'PR_DASHBOARD',
	    PR_INSTANCE: 'PR_INSTANCE',
	    PR_BRANDING: 'PR_BRANDING',
	    PR_PERSON_OVERVIEW: 'PR_PERSON_OVERVIEW',
	    PR_WEGO_ADMINS: 'PR_WEGO_ADMINS',
	    PR_COMPANY_OVERVIEW: 'PR_COMPANY_OVERVIEW',
	    PR_ERRORLOG: 'PR_ERRORLOG',
	    PR_INTERFACE_STATUS: 'PR_INTERFACE_STATUS',
	    PR_CONTACT_PERSON: 'PR_CONTACT_PERSON',
	    PR_COMPANY_ADMIN: 'PR_COMPANY_ADMIN',
	    // PR_COMPANY_VEHICLE_OVERVIEW: "PR_COMPANY_VEHICLE_OVERVIEW",
	    // PR_COMPANY_SVG_OVERVIEW: "PR_COMPANY_SVG_OVERVIEW",
	    PR_ORGANIZATION_OVERVIEW: 'PR_ORGANIZATION_OVERVIEW',
	    PR_ORGANIZATION_CONTACT_PERSON: 'PR_ORGANIZATION_CONTACT_PERSON',
	    PR_ORGANIZATION_ADMIN_OVERVIEW: 'PR_ORGANIZATION_ADMIN_OVERVIEW',
	    PR_ORGANIZATION_DRIVER_OVERVIEW: 'PR_ORGANIZATION_DRIVER_OVERVIEW',
	    PR_SHARED_VEHICLE_GROUP_OVERVIEW: 'PR_SHARED_VEHICLE_GROUP_OVERVIEW',
	    PR_SHARED_VEHICLE_GROUP_ADMIN_OVERVIEW: 'PR_SHARED_VEHICLE_GROUP_ADMIN_OVERVIEW',
	    PR_SHARED_VEHICLE_GROUP_VEHICLE_OVERVIEW: 'PR_SHARED_VEHICLE_GROUP_VEHICLE_OVERVIEW',
	    PR_SHARED_VEHICLE_GROUP_DRIVER_OVERVIEW: 'PR_SHARED_VEHICLE_GROUP_DRIVER_OVERVIEW',
	    PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_GROUP_OVERVIEW: 'PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_GROUP_OVERVIEW',
	    PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_OVERVIEW: 'PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_OVERVIEW',
	    PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW: 'PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW',
	    PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_AVAILIBILTY_RESTRICTION_OVERVIEW: 'PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_AVAILIBILTY_RESTRICTION_OVERVIEW',
	    PR_SPECIAL_PERIODS: 'PR_SPECIAL_PERIODS',
	    PR_VEHICLES_OVERVIEW: 'PR_VEHICLES_OVERVIEW',
	    PR_VEHICLE_SVG_OVERVIEW: 'PR_VEHICLE_SVG_OVERVIEW',
	    PR_VTS_VEHICLE_LIST: 'PR_VTS_VEHICLE_LIST',
	    PR_VTS_TROUBLESHOOT: 'PR_VTS_TROUBLESHOOT',
	    PR_VEHICLE_ATTRIBUTE_CATEGORIES: 'PR_VEHICLE_ATTRIBUTE_CATEGORIES',
	    PR_VEHICLE_ATTRIBUTE: 'PR_VEHICLE_ATTRIBUTE',
	    PR_VEHICLE_FUTURE_BOOKINGS: 'PR_VEHICLE_FUTURE_BOOKINGS',
	    PR_ODOMETER_LOG_TRAIL: 'PR_ODOMETER_LOG_TRAIL',
	    PR_ODOMETER_LOG_TRAIL_REGISTERED_BY: 'PR_ODOMETER_LOG_TRAIL_REGISTERED_BY',
	    PR_DRIVER_OVERVIEW: 'PR_DRIVER_OVERVIEW',
	    PR_DRIVER_SHARED_VEHICLE_GROUP_OVERVIEW: 'PR_DRIVER_SHARED_VEHICLE_GROUP_OVERVIEW',
	    PR_DRIVER_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW: 'PR_DRIVER_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW',
	    PR_BOOKINGS_OVERVIEW: 'PR_BOOKINGS_OVERVIEW',
	    PR_BOOKINGS_REQUEST: 'PR_BOOKING_REQUEST',
	    PR_NORMAL_BOOKING: 'PR_NORMAL_BOOKING',
	    PR_SPECIAL_BOOKING: 'PR_SPECIAL_BOOKING',
	    PR_TRIP_SIMULATOR: 'PR_TRIP_SIMULATOR',
	    PR_INVOICE: 'PR_INVOICE',
	    PR_INVOICE_PAYMENT_HISTORY: 'PR_INVOICE_PAYMENT_HISTORY',
	    PR_INVOICE_PAYMENT_HISTORY_LIST: 'PR_PAYMENT_HISTORY_LIST',
	    PR_DIRECT_DEBIT_FILE: 'PR_DIRECT_DEBIT_FILE',
	    PR_ADDITIONAL_FREE_ITEMS: 'PR_ADDITIONAL_FREE_ITEMS',
	    PR_TEST_INVOICE_GENERATOR: 'PR_TEST_INVOICE_GENERATOR',
	    PR_MISSING_INVOICE_GENERATOR: 'PR_MISSING_INVOICE_GENERATOR',
	    PR_VEHICLE_OCCUPANCY_REPORT: 'PR_VEHICLE_OCCUPANCY_REPORT',
	    PR_REVENUE_PER_VEHICLE_REPORT: 'PR_REVENUE_PER_VEHICLE_REPORT',
	    PR_TRIP_DATA_REPORT: 'PR_TRIP_DATA_REPORT',
	    PR_MAINTENANCE_PLANNING_REPORT: 'PR_MAINTENANCE_PLANNING_REPORT',
	    PR_SANIL_TRAIL_REPORT: 'PR_SANIL_TRAIL_REPORT',
	    PR_KICKBACK_REPORT: 'PR_KICKBACK_REPORT',
	    PR_TEMPLATES: 'PR_TEMPLATES',
	    PR_SIGNUP_FORMS_OVERVIEW: 'PR_SIGNUP_FORMS_OVERVIEW',
	    PR_SIGNUPS_OVERVIEW: 'PR_SIGNUPS_OVERVIEW',
	    PR_SIGNUP_OVERVIEW_TO_SIGNUP_FORM: 'PR_SIGNUP_OVERVIEW_TO_SIGNUP_FORM',
	    PR_SIGNUP_OVERVIEW_TO_SHARED_VEHICLE_GROUP: 'PR_SIGNUP_OVERVIEW_TO_SHARED_VEHICLE_GROUP',
	    PR_EVENT_VIEWER: 'PR_EVENT_VIEWER',
	    PR_USER_PROFILE: 'PR_USER_PROFILE',
	    PR_CUSTOMER_ADMIN_OVERVIEW: 'PR_CUSTOMER_ADMIN_OVERVIEW',
	    PR_INSTANCE_ADMIN_OVERVIEW: 'PR_INSTANCE_ADMIN_OVERVIEW',
	    PR_ROLE_OVERVIEW: 'PR_ROLE_OVERVIEW',
	    PR_ROLE_ASSIGN: 'PR_ROLE_ASSIGN',
	    PR_SHARED_VEHICLE_GROUP_ACTIVE_INACTIVE: 'PR_SHARED_VEHICLE_GROUP_ACTIVE_INACTIVE',
	    PR_ORGANIZATION_SUBSCRIPTION_OVERVIEW: 'PR_ORGANIZATION_SUBSCRIPTION_OVERVIEW',
	    PR_BATCH_UPLOAD_PERSON: 'PR_BATCH_UPLOAD_PERSON',
	    PR_ERRORESCALATION_OVERVIEW: 'PR_ERROR_ESCALATION_OVERVIEW',
	    PR_IMPORT_PERSON: 'PR_IMPORT_PERSON',
	    PR_TERMS_AND_CONDITION: 'PR_TERMS_AND_CONDITION',
	    PR_COSTANDEXPENSES_LIST: 'PR_COST_EXPENSES',
	    PR_COST_CENTER_REPORT: 'PR_COST_CENTER_REPORT',
	    PR_PRE_POST_TRIP_SETTING: 'PR_PRE_POST_TRIP_SETTING',
	    PR_PRE_POST_TRIP_QUESTIONS: 'PR_PRE_POST_TRIP_QUESTIONS',
	    PR_PREPOST_TRIP_QUESTIONS_UPDATE: 'PR_PREPOST_TRIP_QUESTIONS_UPDATE'
	};
	var WeGoAuthorizedLink = (function () {
	    function WeGoAuthorizedLink(routerLink, permissionName, permissionType, cssClass, label, Entity, EntityId, displayElementIfNotAuth, iconClass) {
	        if (Entity === void 0) { Entity = ''; }
	        if (EntityId === void 0) { EntityId = ''; }
	        if (displayElementIfNotAuth === void 0) { displayElementIfNotAuth = false; }
	        if (iconClass === void 0) { iconClass = ''; }
	        this.routerLink = routerLink;
	        this.permissionName = permissionName;
	        this.permissionType = permissionType;
	        this.cssClass = cssClass;
	        this.label = label;
	        this.EntityId = EntityId;
	        this.Entity = Entity;
	        this.displayElementIfNotAuth = displayElementIfNotAuth;
	        this.iconClass = iconClass;
	    }
	    return WeGoAuthorizedLink;
	}());
	exports.WeGoAuthorizedLink = WeGoAuthorizedLink;
	(function (RoleLevel) {
	    RoleLevel[RoleLevel["WeGo"] = 0] = "WeGo";
	    RoleLevel[RoleLevel["Customer"] = 1] = "Customer";
	    RoleLevel[RoleLevel["Instance"] = 2] = "Instance";
	    RoleLevel[RoleLevel["Company"] = 3] = "Company";
	    RoleLevel[RoleLevel["SVG"] = 4] = "SVG";
	    RoleLevel[RoleLevel["Organization"] = 5] = "Organization";
	})(exports.RoleLevel || (exports.RoleLevel = {}));
	var RoleLevel = exports.RoleLevel;
	(function (PreferredLanguage) {
	    PreferredLanguage[PreferredLanguage["NL"] = 1] = "NL";
	    PreferredLanguage[PreferredLanguage["EN"] = 2] = "EN";
	    PreferredLanguage[PreferredLanguage["DE"] = 3] = "DE";
	})(exports.PreferredLanguage || (exports.PreferredLanguage = {}));
	var PreferredLanguage = exports.PreferredLanguage;
	var DataListModel = (function () {
	    function DataListModel() {
	        this.totalItems = 0;
	        this.currentPage = 1;
	        this.maxSize = exports.WeGoConfig.GRID_MAX_PAGE_SIZE;
	        this.sortType = '';
	        this.sortReverse = false;
	        this.searchField = [];
	        this.searchTerm = '';
	        this.infoMessage = '';
	        // let selectedNumber = localStorage.getItem("itemsPerPage");
	        // if (selectedNumber) {
	        //   this.itemsPerPage = parseInt(selectedNumber);
	        // }
	        // else {
	        this.itemsPerPage = exports.WeGoConfig.GRID_MAX_DATA_SIZE;
	        // }
	    }
	    return DataListModel;
	}());
	exports.DataListModel = DataListModel;


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! FileSaver.js v1.3.5
	 *
	 * A saveAs() FileSaver implementation.
	 *
	 * By Travis Clarke, https://travismclarke.com
	 * By Eli Grey, http://eligrey.com
	 *
	 * License: MIT (https://github.com/clarketm/FileSaver.js/blob/master/LICENSE.md)
	 */
	
	;(function (root, factory) {
	    if (typeof exports === 'object' && typeof exports.nodeName !== 'string') {
	        module.exports = root.document ? factory(root, true) : function (w) {
	            if (!w.document) {
	                throw new Error("FileSaver requires a window with a document");
	            }
	            return factory(w);
	        };
	    } else {
	        factory(root);
	    }
	}(window || this, function (window, noGlobal) {
	        "use strict";
	        // IE <10 is explicitly unsupported
	        if (typeof window === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) {
	            return;
	        }
	        var
	            doc = window.document
	            // only get URL when necessary in case Blob.js hasn't overridden it yet
	            , get_URL = function () {
	                return window.URL || window.webkitURL || window;
	            }
	            , save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a")
	            , can_use_save_link = "download" in save_link
	            , click = function (node) {
	                var event = new MouseEvent("click");
	                node.dispatchEvent(event);
	            }
	            , is_safari = /constructor/i.test(window.HTMLElement) || window.safari
	            , is_chrome_ios = /CriOS\/[\d]+/.test(navigator.userAgent)
	            , throw_outside = function (ex) {
	                (window.setImmediate || window.setTimeout)(function () {
	                    throw ex;
	                }, 0);
	            }
	            , force_saveable_type = "application/octet-stream"
	            // the Blob API is fundamentally broken as there is no "downloadfinished" event to subscribe to
	            , arbitrary_revoke_timeout = 1000 * 40 // in ms
	            , revoke = function (file) {
	                var revoker = function () {
	                    if (typeof file === "string") { // file is an object URL
	                        get_URL().revokeObjectURL(file);
	                    } else { // file is a File
	                        file.remove();
	                    }
	                };
	                setTimeout(revoker, arbitrary_revoke_timeout);
	            }
	            , dispatch = function (filesaver, event_types, event) {
	                event_types = [].concat(event_types);
	                var i = event_types.length;
	                while (i--) {
	                    var listener = filesaver["on" + event_types[i]];
	                    if (typeof listener === "function") {
	                        try {
	                            listener.call(filesaver, event || filesaver);
	                        } catch (ex) {
	                            throw_outside(ex);
	                        }
	                    }
	                }
	            }
	            , auto_bom = function (blob) {
	                // prepend BOM for UTF-8 XML and text/* types (including HTML)
	                // note: your browser will automatically convert UTF-16 U+FEFF to EF BB BF
	                if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) {
	                    return new Blob([String.fromCharCode(0xFEFF), blob], {type: blob.type});
	                }
	                return blob;
	            }
	            , FileSaver = function (blob, name, no_auto_bom) {
	                if (!no_auto_bom) {
	                    blob = auto_bom(blob);
	                }
	                // First try a.download, then web filesystem, then object URLs
	                var
	                    filesaver = this
	                    , type = blob.type
	                    , force = type === force_saveable_type
	                    , object_url
	                    , dispatch_all = function () {
	                        dispatch(filesaver, "writestart progress write writeend".split(" "));
	                    }
	                    // on any filesys errors revert to saving with object URLs
	                    , fs_error = function () {
	                        if ((is_chrome_ios || (force && is_safari)) && window.FileReader) {
	                            // Safari doesn't allow downloading of blob urls
	                            var reader = new FileReader();
	                            reader.onloadend = function () {
	                                var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
	                                var popup = window.open(url, '_blank');
	                                if (!popup) window.location.href = url;
	                                url = undefined; // release reference before dispatching
	                                filesaver.readyState = filesaver.DONE;
	                                dispatch_all();
	                            };
	                            reader.readAsDataURL(blob);
	                            filesaver.readyState = filesaver.INIT;
	                            return;
	                        }
	                        // don't create more object URLs than needed
	                        if (!object_url) {
	                            object_url = get_URL().createObjectURL(blob);
	                        }
	                        if (force) {
	                            window.location.href = object_url;
	                        } else {
	                            var opened = window.open(object_url, "_blank");
	                            if (!opened) {
	                                // Apple does not allow window.open, see https://developer.apple.com/library/safari/documentation/Tools/Conceptual/SafariExtensionGuide/WorkingwithWindowsandTabs/WorkingwithWindowsandTabs.html
	                                window.location.href = object_url;
	                            }
	                        }
	                        filesaver.readyState = filesaver.DONE;
	                        dispatch_all();
	                        revoke(object_url);
	                    }
	                    ;
	                filesaver.readyState = filesaver.INIT;
	
	                if (can_use_save_link) {
	                    object_url = get_URL().createObjectURL(blob);
	                    setTimeout(function () {
	                        save_link.href = object_url;
	                        save_link.download = name;
	                        click(save_link);
	                        dispatch_all();
	                        revoke(object_url);
	                        filesaver.readyState = filesaver.DONE;
	                    });
	                    return;
	                }
	
	                fs_error();
	            }
	            , FS_proto = FileSaver.prototype
	            , saveAs = function (blob, name, no_auto_bom) {
	                return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
	            }
	            ;
	        // IE 10+ (native saveAs)
	        if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) {
	            return function (blob, name, no_auto_bom) {
	                name = name || blob.name || "download";
	
	                if (!no_auto_bom) {
	                    blob = auto_bom(blob);
	                }
	                return navigator.msSaveOrOpenBlob(blob, name);
	            };
	        }
	
	        FS_proto.abort = function () {
	        };
	        FS_proto.readyState = FS_proto.INIT = 0;
	        FS_proto.WRITING = 1;
	        FS_proto.DONE = 2;
	
	        FS_proto.error =
	            FS_proto.onwritestart =
	                FS_proto.onprogress =
	                    FS_proto.onwrite =
	                        FS_proto.onabort =
	                            FS_proto.onerror =
	                                FS_proto.onwriteend =
	                                    null;
	
	        if (true) {
	            !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	                return saveAs;
	            }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	        }
	
	        if (typeof noGlobal === 'undefined') {
	            window.saveAs = saveAs;
	        }
	        return saveAs;
	    }
	));


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var SnailTrailMapComponent = (function () {
	    function SnailTrailMapComponent() {
	        this.listOfPolyline = [];
	        this.listOfPolylineCoordinate = [];
	        this.onSegmentChange = new core_1.EventEmitter();
	    }
	    Object.defineProperty(SnailTrailMapComponent.prototype, "CurrentTrip", {
	        get: function () {
	            return this.currentTrip;
	        },
	        // Input from the parent component
	        set: function (currentTrip) {
	            var _this = this;
	            this.currentTrip = currentTrip;
	            setTimeout(function () {
	                _this.ResizeMap();
	                _this.DrawPolyline();
	            });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SnailTrailMapComponent.prototype, "CurrentSegment", {
	        get: function () {
	            return this.currentSegment;
	        },
	        // Input from the parent component
	        set: function (currentSegment) {
	            var _this = this;
	            this.currentSegment = currentSegment;
	            setTimeout(function () {
	                _this.ResizeMap();
	                _this.HighlightPolyline();
	            });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SnailTrailMapComponent.prototype.ngOnInit = function () {
	        this.InitMap();
	    };
	    SnailTrailMapComponent.prototype.InitMap = function () {
	        this.listOfPolyline = [];
	        this.listOfPolylineCoordinate = [];
	        this.map = new google.maps.Map(document.getElementById('map'), {
	            center: { lat: 52.3702164, lng: 4.895168 },
	            zoom: 13,
	        });
	    };
	    SnailTrailMapComponent.prototype.DrawPolyline = function () {
	        var _this = this;
	        this.RemovePolyline();
	        if (this.currentTrip) {
	            var listOfSegment = this.currentTrip.snailTrailSegment;
	            if (listOfSegment && listOfSegment.length > 0) {
	                var _loop_1 = function(i) {
	                    var segmentDetail = listOfSegment[i];
	                    if (segmentDetail.startLocation.latitude && segmentDetail.startLocation.longitude
	                        && segmentDetail.endLocation.latitude && segmentDetail.endLocation.longitude) {
	                        var segmentCoordinates = [
	                            { lat: segmentDetail.startLocation.latitude, lng: segmentDetail.startLocation.longitude },
	                            { lat: segmentDetail.endLocation.latitude, lng: segmentDetail.endLocation.longitude }
	                        ];
	                        var arrowIcon = [];
	                        if (i == 0) {
	                            var arrowSymbol = {
	                                path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
	                                fillColor: '#FF0000',
	                                fillOpacity: 0.4,
	                                strokeColor: '#FF0000',
	                                strokeOpacity: 0.8
	                            };
	                            arrowIcon.push({
	                                icon: arrowSymbol,
	                                offset: '0%'
	                            });
	                        }
	                        var segmentPath = new google.maps.Polyline({
	                            path: segmentCoordinates,
	                            geodesic: true,
	                            strokeColor: '#000000',
	                            strokeOpacity: 0.4,
	                            strokeWeight: 5,
	                            zIndex: 1,
	                            icons: arrowIcon
	                        });
	                        segmentPath.setMap(this_1.map);
	                        google.maps.event.addListener(segmentPath, 'click', function () { return _this.HandleSegmentClick(i); });
	                        this_1.listOfPolyline.push(segmentPath);
	                        this_1.listOfPolylineCoordinate.push({ lat: segmentDetail.startLocation.latitude, lng: segmentDetail.startLocation.longitude }, { lat: segmentDetail.endLocation.latitude, lng: segmentDetail.endLocation.longitude });
	                    }
	                };
	                var this_1 = this;
	                for (var i = 0; i < listOfSegment.length; i++) {
	                    _loop_1(i);
	                }
	            }
	        }
	        this.FitPolylineToBound();
	    };
	    SnailTrailMapComponent.prototype.RemovePolyline = function () {
	        if (this.listOfPolyline) {
	            while (this.listOfPolyline.length) {
	                this.listOfPolyline.pop().setMap(null);
	            }
	        }
	        this.listOfPolylineCoordinate = [];
	        this.RemoveHighlightPolyline();
	    };
	    SnailTrailMapComponent.prototype.HighlightPolyline = function () {
	        this.RemoveHighlightPolyline();
	        if (this.currentSegment) {
	            if (this.currentSegment.startLocation.latitude && this.currentSegment.startLocation.longitude
	                && this.currentSegment.endLocation.latitude && this.currentSegment.endLocation.longitude) {
	                var segmentCoordinates = [
	                    { lat: this.currentSegment.startLocation.latitude, lng: this.currentSegment.startLocation.longitude },
	                    { lat: this.currentSegment.endLocation.latitude, lng: this.currentSegment.endLocation.longitude }
	                ];
	                this.highlightedPolyline = new google.maps.Polyline({
	                    path: segmentCoordinates,
	                    geodesic: true,
	                    strokeColor: '#FF0000',
	                    strokeOpacity: 1,
	                    strokeWeight: 10,
	                    zIndex: 2
	                });
	                this.highlightedPolyline.setMap(this.map);
	            }
	        }
	    };
	    SnailTrailMapComponent.prototype.RemoveHighlightPolyline = function () {
	        if (this.highlightedPolyline) {
	            this.highlightedPolyline.setMap(null);
	        }
	    };
	    SnailTrailMapComponent.prototype.HandleSegmentClick = function (segmentPosition) {
	        this.onSegmentChange.emit({ position: segmentPosition });
	    };
	    SnailTrailMapComponent.prototype.ResizeMap = function () {
	        //setTimeout(() => {
	        // let center = this.map.getCenter();
	        google.maps.event.trigger(this.map, "resize");
	        // this.map.setCenter(center);
	        //});
	    };
	    SnailTrailMapComponent.prototype.FitPolylineToBound = function () {
	        if (this.listOfPolylineCoordinate && this.listOfPolylineCoordinate.length > 0) {
	            var bound = new google.maps.LatLngBounds();
	            for (var i in this.listOfPolylineCoordinate) {
	                bound.extend(this.listOfPolylineCoordinate[i]);
	            }
	            if (this.map) {
	                this.map.fitBounds(bound);
	            }
	        }
	    };
	    SnailTrailMapComponent.prototype.ngOnDestroy = function () {
	    };
	    __decorate([
	        core_1.Output('OnSegmentChange'), 
	        __metadata('design:type', Object)
	    ], SnailTrailMapComponent.prototype, "onSegmentChange", void 0);
	    __decorate([
	        core_1.Input('CurrentTrip'), 
	        __metadata('design:type', Object), 
	        __metadata('design:paramtypes', [Object])
	    ], SnailTrailMapComponent.prototype, "CurrentTrip", null);
	    __decorate([
	        core_1.Input('CurrentSegment'), 
	        __metadata('design:type', Object), 
	        __metadata('design:paramtypes', [Object])
	    ], SnailTrailMapComponent.prototype, "CurrentSegment", null);
	    SnailTrailMapComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-snail-trail-map',
	            template: __webpack_require__(63),
	            styles: ["\n      #map {\n          height: 1100px;\n      }\n  "]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], SnailTrailMapComponent);
	    return SnailTrailMapComponent;
	}());
	exports.SnailTrailMapComponent = SnailTrailMapComponent;


/***/ },
/* 63 */
/***/ function(module, exports) {

	module.exports = "<div id=\"map\"></div>";

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var config_1 = __webpack_require__(60);
	var auth_service_1 = __webpack_require__(58);
	var snail_trail_search_model_1 = __webpack_require__(65);
	var snail_trail_service_1 = __webpack_require__(66);
	var core_1 = __webpack_require__(3);
	var decimal_formatter_service_1 = __webpack_require__(69);
	var SnailTrailComponent = (function () {
	    function SnailTrailComponent(snailTrailService, decimalFormatter, authService) {
	        this.snailTrailService = snailTrailService;
	        this.decimalFormatter = decimalFormatter;
	        this.authService = authService;
	        this.tripCounter = 0;
	        this.segmentCounter = 0;
	        this.roleLevel = config_1.RoleLevel;
	    }
	    SnailTrailComponent.prototype.ngOnInit = function () {
	        this.urlDriverInfo = this.authService.GetURL(config_1.ApplicationRouteURL.URL_PERSON_UPDATE);
	    };
	    SnailTrailComponent.prototype.OnSearch = function ($event) {
	        this.HandleFilterParam($event);
	        // Get snail trail report from server
	        this.GetSnailTrail();
	    };
	    SnailTrailComponent.prototype.OnExport = function ($event) {
	        this.HandleFilterParam($event);
	        // Get snail trail excel format report from server
	        this.ExportExcel();
	    };
	    SnailTrailComponent.prototype.HandleFilterParam = function ($event) {
	        // Assigned filter parameter to search model
	        this.searchModel = new snail_trail_search_model_1.SnailTrailSearchModel();
	        this.searchModel.reportSearchType = $event.reportSearchType;
	        if (this.searchModel.reportSearchType == 'PER_BOOKING') {
	            this.searchModel.bookingHashId = $event.bookingHashId;
	        }
	        if (this.searchModel.reportSearchType == 'PER_VEHICLE') {
	            this.searchModel.vehicleHashId = $event.vehicleHashId;
	            this.searchModel.startDateTime = $event.startDateTime;
	            this.searchModel.endDateTime = $event.endDateTime;
	            this.searchModel.driverHashId = $event.driverHashId;
	        }
	    };
	    // Get snail trail report from the server
	    SnailTrailComponent.prototype.GetSnailTrail = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.snailTrailService.GetSnailTrail(this.searchModel)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.listOfSnailTrail = res.data;
	                _this.errorModel = [];
	                if (_this.listOfSnailTrail && _this.listOfSnailTrail.length > 0) {
	                    _this.noDataFoundMsg = '';
	                    _this.SelectTrip(0);
	                }
	                else {
	                    _this.noDataFoundMsg = res.error;
	                }
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SnailTrailComponent.prototype.ExportExcel = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.snailTrailService.ExportSnailTrailExcel(this.searchModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "SnailTrail" + new Date().toISOString() + ".xlsx";
	                _this.authService.DownloadXlsFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    // Trip related event
	    SnailTrailComponent.prototype.PreviousTrip = function () {
	        // If trip counter is 0 then don't allow to go to previous
	        if (this.tripCounter != 0) {
	            this.tripCounter--;
	            this.SelectTrip(this.tripCounter);
	        }
	    };
	    SnailTrailComponent.prototype.NextTrip = function () {
	        // If trip counter try to reach more than record then don't allow to go to next
	        if (this.listOfSnailTrail && ((this.tripCounter + 1) != this.listOfSnailTrail.length)) {
	            this.tripCounter++;
	            this.SelectTrip(this.tripCounter);
	        }
	    };
	    SnailTrailComponent.prototype.SelectTrip = function (position) {
	        // If data not available for position then don't allow
	        if (this.listOfSnailTrail && position < this.listOfSnailTrail.length) {
	            this.currentTrip = this.listOfSnailTrail[position];
	            this.tripCounter = position;
	            this.ResetSegment();
	            this.SelectSegment(0);
	        }
	    };
	    // Segment related event
	    SnailTrailComponent.prototype.PreviousSegment = function () {
	        // If Segment counter is 0 then don't allow to go to previous
	        if (this.segmentCounter != 0) {
	            this.segmentCounter--;
	            this.SelectSegment(this.segmentCounter);
	        }
	    };
	    SnailTrailComponent.prototype.NextSegment = function () {
	        // If current trip is not selected then segment is not available
	        // If Segment counter try to reach more than record then don't allow to go to next
	        if (this.currentTrip && ((this.segmentCounter + 1) != this.currentTrip.snailTrailSegment.length)) {
	            this.segmentCounter++;
	            this.SelectSegment(this.segmentCounter);
	        }
	    };
	    SnailTrailComponent.prototype.SelectSegment = function (position) {
	        // If current trip is not selected then segment is not available
	        // If data not available for position then don't allow
	        if (this.currentTrip && this.currentTrip.snailTrailSegment && position < this.currentTrip.snailTrailSegment.length) {
	            this.currentSegment = this.currentTrip.snailTrailSegment[position];
	            this.segmentCounter = position;
	        }
	    };
	    SnailTrailComponent.prototype.ResetSegment = function () {
	        this.currentSegment = null;
	        this.segmentCounter = 0;
	    };
	    SnailTrailComponent.prototype.ResetData = function () {
	        // Reset the data based on change the filter parameter
	        this.searchModel = null;
	        this.errorModel = [];
	        this.listOfSnailTrail = [];
	        this.currentTrip = null;
	        this.currentSegment = null;
	        this.tripCounter = 0;
	        this.segmentCounter = 0;
	    };
	    SnailTrailComponent.prototype.DecimalFormatter = function (value) {
	        return this.decimalFormatter.transform(value);
	    };
	    SnailTrailComponent.prototype.ngOnDestroy = function () {
	    };
	    SnailTrailComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-snail-trail',
	            template: __webpack_require__(79),
	            styles: [__webpack_require__(80)],
	            providers: [snail_trail_service_1.SnailTrailService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof snail_trail_service_1.SnailTrailService !== 'undefined' && snail_trail_service_1.SnailTrailService) === 'function' && _a) || Object, (typeof (_b = typeof decimal_formatter_service_1.DecimalFormatterService !== 'undefined' && decimal_formatter_service_1.DecimalFormatterService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object])
	    ], SnailTrailComponent);
	    return SnailTrailComponent;
	    var _a, _b, _c;
	}());
	exports.SnailTrailComponent = SnailTrailComponent;


/***/ },
/* 65 */
/***/ function(module, exports) {

	"use strict";
	var SnailTrailSearchModel = (function () {
	    function SnailTrailSearchModel() {
	    }
	    return SnailTrailSearchModel;
	}());
	exports.SnailTrailSearchModel = SnailTrailSearchModel;


/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var config_1 = __webpack_require__(60);
	var http_1 = __webpack_require__(59);
	var core_1 = __webpack_require__(3);
	var auth_service_1 = __webpack_require__(58);
	var jquery_helper_service_1 = __webpack_require__(67);
	var SnailTrailService = (function () {
	    function SnailTrailService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	        this.JQueryHelper = new jquery_helper_service_1.JQueryHelperService();
	    }
	    SnailTrailService.prototype.GetSnailTrail = function (searchModel) {
	        var body = searchModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_POST_SEARCH_SNAIL_TRAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SnailTrailService.prototype.ExportSnailTrailExcel = function (model) {
	        var getUrl = config_1.WeGoConfig.API_GET_SEARCH_SNAIL_TRAIL_CSV;
	        var queryString = this.JQueryHelper.Param(model);
	        getUrl = getUrl + "?" + queryString;
	        var headers = this.authService.GetHeader('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
	        var options = new http_1.RequestOptions({ headers: headers, responseType: http_1.ResponseContentType.Blob });
	        return this.http.get(getUrl, options);
	    };
	    SnailTrailService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], SnailTrailService);
	    return SnailTrailService;
	    var _a, _b;
	}());
	exports.SnailTrailService = SnailTrailService;


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var $ = __webpack_require__(68);
	//declare var $: any;
	var JQueryHelperService = (function () {
	    function JQueryHelperService() {
	    }
	    JQueryHelperService.prototype.Param = function (input) {
	        if (input) {
	            return $.param(input);
	        }
	        return "";
	    };
	    JQueryHelperService.prototype.Unique = function (input) {
	        if (input) {
	            return $.unique(input);
	        }
	        return input;
	    };
	    JQueryHelperService.prototype.RemoveFromArray = function (input, removeItem) {
	        input = $.grep(input, function (value) {
	            return value != removeItem;
	        });
	        return input;
	    };
	    return JQueryHelperService;
	}());
	exports.JQueryHelperService = JQueryHelperService;


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * jQuery JavaScript Library v3.1.1
	 * https://jquery.com/
	 *
	 * Includes Sizzle.js
	 * https://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * https://jquery.org/license
	 *
	 * Date: 2016-09-22T22:30Z
	 */
	( function( global, factory ) {
	
		"use strict";
	
		if ( typeof module === "object" && typeof module.exports === "object" ) {
	
			// For CommonJS and CommonJS-like environments where a proper `window`
			// is present, execute the factory and get jQuery.
			// For environments that do not have a `window` with a `document`
			// (such as Node.js), expose a factory as module.exports.
			// This accentuates the need for the creation of a real `window`.
			// e.g. var jQuery = require("jquery")(window);
			// See ticket #14549 for more info.
			module.exports = global.document ?
				factory( global, true ) :
				function( w ) {
					if ( !w.document ) {
						throw new Error( "jQuery requires a window with a document" );
					}
					return factory( w );
				};
		} else {
			factory( global );
		}
	
	// Pass this if window is not defined yet
	} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {
	
	// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
	// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
	// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
	// enough that all such attempts are guarded in a try block.
	"use strict";
	
	var arr = [];
	
	var document = window.document;
	
	var getProto = Object.getPrototypeOf;
	
	var slice = arr.slice;
	
	var concat = arr.concat;
	
	var push = arr.push;
	
	var indexOf = arr.indexOf;
	
	var class2type = {};
	
	var toString = class2type.toString;
	
	var hasOwn = class2type.hasOwnProperty;
	
	var fnToString = hasOwn.toString;
	
	var ObjectFunctionString = fnToString.call( Object );
	
	var support = {};
	
	
	
		function DOMEval( code, doc ) {
			doc = doc || document;
	
			var script = doc.createElement( "script" );
	
			script.text = code;
			doc.head.appendChild( script ).parentNode.removeChild( script );
		}
	/* global Symbol */
	// Defining this global in .eslintrc.json would create a danger of using the global
	// unguarded in another place, it seems safer to define global only for this module
	
	
	
	var
		version = "3.1.1",
	
		// Define a local copy of jQuery
		jQuery = function( selector, context ) {
	
			// The jQuery object is actually just the init constructor 'enhanced'
			// Need init if jQuery is called (just allow error to be thrown if not included)
			return new jQuery.fn.init( selector, context );
		},
	
		// Support: Android <=4.0 only
		// Make sure we trim BOM and NBSP
		rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,
	
		// Matches dashed string for camelizing
		rmsPrefix = /^-ms-/,
		rdashAlpha = /-([a-z])/g,
	
		// Used by jQuery.camelCase as callback to replace()
		fcamelCase = function( all, letter ) {
			return letter.toUpperCase();
		};
	
	jQuery.fn = jQuery.prototype = {
	
		// The current version of jQuery being used
		jquery: version,
	
		constructor: jQuery,
	
		// The default length of a jQuery object is 0
		length: 0,
	
		toArray: function() {
			return slice.call( this );
		},
	
		// Get the Nth element in the matched element set OR
		// Get the whole matched element set as a clean array
		get: function( num ) {
	
			// Return all the elements in a clean array
			if ( num == null ) {
				return slice.call( this );
			}
	
			// Return just the one element from the set
			return num < 0 ? this[ num + this.length ] : this[ num ];
		},
	
		// Take an array of elements and push it onto the stack
		// (returning the new matched element set)
		pushStack: function( elems ) {
	
			// Build a new jQuery matched element set
			var ret = jQuery.merge( this.constructor(), elems );
	
			// Add the old object onto the stack (as a reference)
			ret.prevObject = this;
	
			// Return the newly-formed element set
			return ret;
		},
	
		// Execute a callback for every element in the matched set.
		each: function( callback ) {
			return jQuery.each( this, callback );
		},
	
		map: function( callback ) {
			return this.pushStack( jQuery.map( this, function( elem, i ) {
				return callback.call( elem, i, elem );
			} ) );
		},
	
		slice: function() {
			return this.pushStack( slice.apply( this, arguments ) );
		},
	
		first: function() {
			return this.eq( 0 );
		},
	
		last: function() {
			return this.eq( -1 );
		},
	
		eq: function( i ) {
			var len = this.length,
				j = +i + ( i < 0 ? len : 0 );
			return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
		},
	
		end: function() {
			return this.prevObject || this.constructor();
		},
	
		// For internal use only.
		// Behaves like an Array's method, not like a jQuery method.
		push: push,
		sort: arr.sort,
		splice: arr.splice
	};
	
	jQuery.extend = jQuery.fn.extend = function() {
		var options, name, src, copy, copyIsArray, clone,
			target = arguments[ 0 ] || {},
			i = 1,
			length = arguments.length,
			deep = false;
	
		// Handle a deep copy situation
		if ( typeof target === "boolean" ) {
			deep = target;
	
			// Skip the boolean and the target
			target = arguments[ i ] || {};
			i++;
		}
	
		// Handle case when target is a string or something (possible in deep copy)
		if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
			target = {};
		}
	
		// Extend jQuery itself if only one argument is passed
		if ( i === length ) {
			target = this;
			i--;
		}
	
		for ( ; i < length; i++ ) {
	
			// Only deal with non-null/undefined values
			if ( ( options = arguments[ i ] ) != null ) {
	
				// Extend the base object
				for ( name in options ) {
					src = target[ name ];
					copy = options[ name ];
	
					// Prevent never-ending loop
					if ( target === copy ) {
						continue;
					}
	
					// Recurse if we're merging plain objects or arrays
					if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
						( copyIsArray = jQuery.isArray( copy ) ) ) ) {
	
						if ( copyIsArray ) {
							copyIsArray = false;
							clone = src && jQuery.isArray( src ) ? src : [];
	
						} else {
							clone = src && jQuery.isPlainObject( src ) ? src : {};
						}
	
						// Never move original objects, clone them
						target[ name ] = jQuery.extend( deep, clone, copy );
	
					// Don't bring in undefined values
					} else if ( copy !== undefined ) {
						target[ name ] = copy;
					}
				}
			}
		}
	
		// Return the modified object
		return target;
	};
	
	jQuery.extend( {
	
		// Unique for each copy of jQuery on the page
		expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),
	
		// Assume jQuery is ready without the ready module
		isReady: true,
	
		error: function( msg ) {
			throw new Error( msg );
		},
	
		noop: function() {},
	
		isFunction: function( obj ) {
			return jQuery.type( obj ) === "function";
		},
	
		isArray: Array.isArray,
	
		isWindow: function( obj ) {
			return obj != null && obj === obj.window;
		},
	
		isNumeric: function( obj ) {
	
			// As of jQuery 3.0, isNumeric is limited to
			// strings and numbers (primitives or objects)
			// that can be coerced to finite numbers (gh-2662)
			var type = jQuery.type( obj );
			return ( type === "number" || type === "string" ) &&
	
				// parseFloat NaNs numeric-cast false positives ("")
				// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
				// subtraction forces infinities to NaN
				!isNaN( obj - parseFloat( obj ) );
		},
	
		isPlainObject: function( obj ) {
			var proto, Ctor;
	
			// Detect obvious negatives
			// Use toString instead of jQuery.type to catch host objects
			if ( !obj || toString.call( obj ) !== "[object Object]" ) {
				return false;
			}
	
			proto = getProto( obj );
	
			// Objects with no prototype (e.g., `Object.create( null )`) are plain
			if ( !proto ) {
				return true;
			}
	
			// Objects with prototype are plain iff they were constructed by a global Object function
			Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
			return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
		},
	
		isEmptyObject: function( obj ) {
	
			/* eslint-disable no-unused-vars */
			// See https://github.com/eslint/eslint/issues/6125
			var name;
	
			for ( name in obj ) {
				return false;
			}
			return true;
		},
	
		type: function( obj ) {
			if ( obj == null ) {
				return obj + "";
			}
	
			// Support: Android <=2.3 only (functionish RegExp)
			return typeof obj === "object" || typeof obj === "function" ?
				class2type[ toString.call( obj ) ] || "object" :
				typeof obj;
		},
	
		// Evaluates a script in a global context
		globalEval: function( code ) {
			DOMEval( code );
		},
	
		// Convert dashed to camelCase; used by the css and data modules
		// Support: IE <=9 - 11, Edge 12 - 13
		// Microsoft forgot to hump their vendor prefix (#9572)
		camelCase: function( string ) {
			return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
		},
	
		nodeName: function( elem, name ) {
			return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
		},
	
		each: function( obj, callback ) {
			var length, i = 0;
	
			if ( isArrayLike( obj ) ) {
				length = obj.length;
				for ( ; i < length; i++ ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			} else {
				for ( i in obj ) {
					if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
						break;
					}
				}
			}
	
			return obj;
		},
	
		// Support: Android <=4.0 only
		trim: function( text ) {
			return text == null ?
				"" :
				( text + "" ).replace( rtrim, "" );
		},
	
		// results is for internal usage only
		makeArray: function( arr, results ) {
			var ret = results || [];
	
			if ( arr != null ) {
				if ( isArrayLike( Object( arr ) ) ) {
					jQuery.merge( ret,
						typeof arr === "string" ?
						[ arr ] : arr
					);
				} else {
					push.call( ret, arr );
				}
			}
	
			return ret;
		},
	
		inArray: function( elem, arr, i ) {
			return arr == null ? -1 : indexOf.call( arr, elem, i );
		},
	
		// Support: Android <=4.0 only, PhantomJS 1 only
		// push.apply(_, arraylike) throws on ancient WebKit
		merge: function( first, second ) {
			var len = +second.length,
				j = 0,
				i = first.length;
	
			for ( ; j < len; j++ ) {
				first[ i++ ] = second[ j ];
			}
	
			first.length = i;
	
			return first;
		},
	
		grep: function( elems, callback, invert ) {
			var callbackInverse,
				matches = [],
				i = 0,
				length = elems.length,
				callbackExpect = !invert;
	
			// Go through the array, only saving the items
			// that pass the validator function
			for ( ; i < length; i++ ) {
				callbackInverse = !callback( elems[ i ], i );
				if ( callbackInverse !== callbackExpect ) {
					matches.push( elems[ i ] );
				}
			}
	
			return matches;
		},
	
		// arg is for internal usage only
		map: function( elems, callback, arg ) {
			var length, value,
				i = 0,
				ret = [];
	
			// Go through the array, translating each of the items to their new values
			if ( isArrayLike( elems ) ) {
				length = elems.length;
				for ( ; i < length; i++ ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
	
			// Go through every key on the object,
			} else {
				for ( i in elems ) {
					value = callback( elems[ i ], i, arg );
	
					if ( value != null ) {
						ret.push( value );
					}
				}
			}
	
			// Flatten any nested arrays
			return concat.apply( [], ret );
		},
	
		// A global GUID counter for objects
		guid: 1,
	
		// Bind a function to a context, optionally partially applying any
		// arguments.
		proxy: function( fn, context ) {
			var tmp, args, proxy;
	
			if ( typeof context === "string" ) {
				tmp = fn[ context ];
				context = fn;
				fn = tmp;
			}
	
			// Quick check to determine if target is callable, in the spec
			// this throws a TypeError, but we will just return undefined.
			if ( !jQuery.isFunction( fn ) ) {
				return undefined;
			}
	
			// Simulated bind
			args = slice.call( arguments, 2 );
			proxy = function() {
				return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
			};
	
			// Set the guid of unique handler to the same of original handler, so it can be removed
			proxy.guid = fn.guid = fn.guid || jQuery.guid++;
	
			return proxy;
		},
	
		now: Date.now,
	
		// jQuery.support is not used in Core but other projects attach their
		// properties to it so it needs to exist.
		support: support
	} );
	
	if ( typeof Symbol === "function" ) {
		jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
	}
	
	// Populate the class2type map
	jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );
	
	function isArrayLike( obj ) {
	
		// Support: real iOS 8.2 only (not reproducible in simulator)
		// `in` check used to prevent JIT error (gh-2145)
		// hasOwn isn't used here due to false negatives
		// regarding Nodelist length in IE
		var length = !!obj && "length" in obj && obj.length,
			type = jQuery.type( obj );
	
		if ( type === "function" || jQuery.isWindow( obj ) ) {
			return false;
		}
	
		return type === "array" || length === 0 ||
			typeof length === "number" && length > 0 && ( length - 1 ) in obj;
	}
	var Sizzle =
	/*!
	 * Sizzle CSS Selector Engine v2.3.3
	 * https://sizzlejs.com/
	 *
	 * Copyright jQuery Foundation and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: 2016-08-08
	 */
	(function( window ) {
	
	var i,
		support,
		Expr,
		getText,
		isXML,
		tokenize,
		compile,
		select,
		outermostContext,
		sortInput,
		hasDuplicate,
	
		// Local document vars
		setDocument,
		document,
		docElem,
		documentIsHTML,
		rbuggyQSA,
		rbuggyMatches,
		matches,
		contains,
	
		// Instance-specific data
		expando = "sizzle" + 1 * new Date(),
		preferredDoc = window.document,
		dirruns = 0,
		done = 0,
		classCache = createCache(),
		tokenCache = createCache(),
		compilerCache = createCache(),
		sortOrder = function( a, b ) {
			if ( a === b ) {
				hasDuplicate = true;
			}
			return 0;
		},
	
		// Instance methods
		hasOwn = ({}).hasOwnProperty,
		arr = [],
		pop = arr.pop,
		push_native = arr.push,
		push = arr.push,
		slice = arr.slice,
		// Use a stripped-down indexOf as it's faster than native
		// https://jsperf.com/thor-indexof-vs-for/5
		indexOf = function( list, elem ) {
			var i = 0,
				len = list.length;
			for ( ; i < len; i++ ) {
				if ( list[i] === elem ) {
					return i;
				}
			}
			return -1;
		},
	
		booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
		// Regular expressions
	
		// http://www.w3.org/TR/css3-selectors/#whitespace
		whitespace = "[\\x20\\t\\r\\n\\f]",
	
		// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
		identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+",
	
		// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
		attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
			// Operator (capture 2)
			"*([*^$|!~]?=)" + whitespace +
			// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
			"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
			"*\\]",
	
		pseudos = ":(" + identifier + ")(?:\\((" +
			// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
			// 1. quoted (capture 3; capture 4 or capture 5)
			"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
			// 2. simple (capture 6)
			"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
			// 3. anything else (capture 2)
			".*" +
			")\\)|)",
	
		// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
		rwhitespace = new RegExp( whitespace + "+", "g" ),
		rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),
	
		rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
		rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),
	
		rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),
	
		rpseudo = new RegExp( pseudos ),
		ridentifier = new RegExp( "^" + identifier + "$" ),
	
		matchExpr = {
			"ID": new RegExp( "^#(" + identifier + ")" ),
			"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
			"TAG": new RegExp( "^(" + identifier + "|[*])" ),
			"ATTR": new RegExp( "^" + attributes ),
			"PSEUDO": new RegExp( "^" + pseudos ),
			"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
				"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
				"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
			"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
			// For use in libraries implementing .is()
			// We use this for POS matching in `select`
			"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
				whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
		},
	
		rinputs = /^(?:input|select|textarea|button)$/i,
		rheader = /^h\d$/i,
	
		rnative = /^[^{]+\{\s*\[native \w/,
	
		// Easily-parseable/retrievable ID or TAG or CLASS selectors
		rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
		rsibling = /[+~]/,
	
		// CSS escapes
		// http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
		runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
		funescape = function( _, escaped, escapedWhitespace ) {
			var high = "0x" + escaped - 0x10000;
			// NaN means non-codepoint
			// Support: Firefox<24
			// Workaround erroneous numeric interpretation of +"0x"
			return high !== high || escapedWhitespace ?
				escaped :
				high < 0 ?
					// BMP codepoint
					String.fromCharCode( high + 0x10000 ) :
					// Supplemental Plane codepoint (surrogate pair)
					String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
		},
	
		// CSS string/identifier serialization
		// https://drafts.csswg.org/cssom/#common-serializing-idioms
		rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
		fcssescape = function( ch, asCodePoint ) {
			if ( asCodePoint ) {
	
				// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
				if ( ch === "\0" ) {
					return "\uFFFD";
				}
	
				// Control characters and (dependent upon position) numbers get escaped as code points
				return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
			}
	
			// Other potentially-special ASCII characters get backslash-escaped
			return "\\" + ch;
		},
	
		// Used for iframes
		// See setDocument()
		// Removing the function wrapper causes a "Permission Denied"
		// error in IE
		unloadHandler = function() {
			setDocument();
		},
	
		disabledAncestor = addCombinator(
			function( elem ) {
				return elem.disabled === true && ("form" in elem || "label" in elem);
			},
			{ dir: "parentNode", next: "legend" }
		);
	
	// Optimize for push.apply( _, NodeList )
	try {
		push.apply(
			(arr = slice.call( preferredDoc.childNodes )),
			preferredDoc.childNodes
		);
		// Support: Android<4.0
		// Detect silently failing push.apply
		arr[ preferredDoc.childNodes.length ].nodeType;
	} catch ( e ) {
		push = { apply: arr.length ?
	
			// Leverage slice if possible
			function( target, els ) {
				push_native.apply( target, slice.call(els) );
			} :
	
			// Support: IE<9
			// Otherwise append directly
			function( target, els ) {
				var j = target.length,
					i = 0;
				// Can't trust NodeList.length
				while ( (target[j++] = els[i++]) ) {}
				target.length = j - 1;
			}
		};
	}
	
	function Sizzle( selector, context, results, seed ) {
		var m, i, elem, nid, match, groups, newSelector,
			newContext = context && context.ownerDocument,
	
			// nodeType defaults to 9, since context defaults to document
			nodeType = context ? context.nodeType : 9;
	
		results = results || [];
	
		// Return early from calls with invalid selector or context
		if ( typeof selector !== "string" || !selector ||
			nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {
	
			return results;
		}
	
		// Try to shortcut find operations (as opposed to filters) in HTML documents
		if ( !seed ) {
	
			if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
				setDocument( context );
			}
			context = context || document;
	
			if ( documentIsHTML ) {
	
				// If the selector is sufficiently simple, try using a "get*By*" DOM method
				// (excepting DocumentFragment context, where the methods don't exist)
				if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {
	
					// ID selector
					if ( (m = match[1]) ) {
	
						// Document context
						if ( nodeType === 9 ) {
							if ( (elem = context.getElementById( m )) ) {
	
								// Support: IE, Opera, Webkit
								// TODO: identify versions
								// getElementById can match elements by name instead of ID
								if ( elem.id === m ) {
									results.push( elem );
									return results;
								}
							} else {
								return results;
							}
	
						// Element context
						} else {
	
							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( newContext && (elem = newContext.getElementById( m )) &&
								contains( context, elem ) &&
								elem.id === m ) {
	
								results.push( elem );
								return results;
							}
						}
	
					// Type selector
					} else if ( match[2] ) {
						push.apply( results, context.getElementsByTagName( selector ) );
						return results;
	
					// Class selector
					} else if ( (m = match[3]) && support.getElementsByClassName &&
						context.getElementsByClassName ) {
	
						push.apply( results, context.getElementsByClassName( m ) );
						return results;
					}
				}
	
				// Take advantage of querySelectorAll
				if ( support.qsa &&
					!compilerCache[ selector + " " ] &&
					(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {
	
					if ( nodeType !== 1 ) {
						newContext = context;
						newSelector = selector;
	
					// qSA looks outside Element context, which is not what we want
					// Thanks to Andrew Dupont for this workaround technique
					// Support: IE <=8
					// Exclude object elements
					} else if ( context.nodeName.toLowerCase() !== "object" ) {
	
						// Capture the context ID, setting it first if necessary
						if ( (nid = context.getAttribute( "id" )) ) {
							nid = nid.replace( rcssescape, fcssescape );
						} else {
							context.setAttribute( "id", (nid = expando) );
						}
	
						// Prefix every selector in the list
						groups = tokenize( selector );
						i = groups.length;
						while ( i-- ) {
							groups[i] = "#" + nid + " " + toSelector( groups[i] );
						}
						newSelector = groups.join( "," );
	
						// Expand context for sibling selectors
						newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
							context;
					}
	
					if ( newSelector ) {
						try {
							push.apply( results,
								newContext.querySelectorAll( newSelector )
							);
							return results;
						} catch ( qsaError ) {
						} finally {
							if ( nid === expando ) {
								context.removeAttribute( "id" );
							}
						}
					}
				}
			}
		}
	
		// All others
		return select( selector.replace( rtrim, "$1" ), context, results, seed );
	}
	
	/**
	 * Create key-value caches of limited size
	 * @returns {function(string, object)} Returns the Object data after storing it on itself with
	 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	 *	deleting the oldest entry
	 */
	function createCache() {
		var keys = [];
	
		function cache( key, value ) {
			// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
			if ( keys.push( key + " " ) > Expr.cacheLength ) {
				// Only keep the most recent entries
				delete cache[ keys.shift() ];
			}
			return (cache[ key + " " ] = value);
		}
		return cache;
	}
	
	/**
	 * Mark a function for special use by Sizzle
	 * @param {Function} fn The function to mark
	 */
	function markFunction( fn ) {
		fn[ expando ] = true;
		return fn;
	}
	
	/**
	 * Support testing using an element
	 * @param {Function} fn Passed the created element and returns a boolean result
	 */
	function assert( fn ) {
		var el = document.createElement("fieldset");
	
		try {
			return !!fn( el );
		} catch (e) {
			return false;
		} finally {
			// Remove from its parent by default
			if ( el.parentNode ) {
				el.parentNode.removeChild( el );
			}
			// release memory in IE
			el = null;
		}
	}
	
	/**
	 * Adds the same handler for all of the specified attrs
	 * @param {String} attrs Pipe-separated list of attributes
	 * @param {Function} handler The method that will be applied
	 */
	function addHandle( attrs, handler ) {
		var arr = attrs.split("|"),
			i = arr.length;
	
		while ( i-- ) {
			Expr.attrHandle[ arr[i] ] = handler;
		}
	}
	
	/**
	 * Checks document order of two siblings
	 * @param {Element} a
	 * @param {Element} b
	 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	 */
	function siblingCheck( a, b ) {
		var cur = b && a,
			diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
				a.sourceIndex - b.sourceIndex;
	
		// Use IE sourceIndex if available on both nodes
		if ( diff ) {
			return diff;
		}
	
		// Check if b follows a
		if ( cur ) {
			while ( (cur = cur.nextSibling) ) {
				if ( cur === b ) {
					return -1;
				}
			}
		}
	
		return a ? 1 : -1;
	}
	
	/**
	 * Returns a function to use in pseudos for input types
	 * @param {String} type
	 */
	function createInputPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for buttons
	 * @param {String} type
	 */
	function createButtonPseudo( type ) {
		return function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return (name === "input" || name === "button") && elem.type === type;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for :enabled/:disabled
	 * @param {Boolean} disabled true for :disabled; false for :enabled
	 */
	function createDisabledPseudo( disabled ) {
	
		// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
		return function( elem ) {
	
			// Only certain elements can match :enabled or :disabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
			// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
			if ( "form" in elem ) {
	
				// Check for inherited disabledness on relevant non-disabled elements:
				// * listed form-associated elements in a disabled fieldset
				//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
				// * option elements in a disabled optgroup
				//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
				// All such elements have a "form" property.
				if ( elem.parentNode && elem.disabled === false ) {
	
					// Option elements defer to a parent optgroup if present
					if ( "label" in elem ) {
						if ( "label" in elem.parentNode ) {
							return elem.parentNode.disabled === disabled;
						} else {
							return elem.disabled === disabled;
						}
					}
	
					// Support: IE 6 - 11
					// Use the isDisabled shortcut property to check for disabled fieldset ancestors
					return elem.isDisabled === disabled ||
	
						// Where there is no isDisabled, check manually
						/* jshint -W018 */
						elem.isDisabled !== !disabled &&
							disabledAncestor( elem ) === disabled;
				}
	
				return elem.disabled === disabled;
	
			// Try to winnow out elements that can't be disabled before trusting the disabled property.
			// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
			// even exist on them, let alone have a boolean value.
			} else if ( "label" in elem ) {
				return elem.disabled === disabled;
			}
	
			// Remaining elements are neither :enabled nor :disabled
			return false;
		};
	}
	
	/**
	 * Returns a function to use in pseudos for positionals
	 * @param {Function} fn
	 */
	function createPositionalPseudo( fn ) {
		return markFunction(function( argument ) {
			argument = +argument;
			return markFunction(function( seed, matches ) {
				var j,
					matchIndexes = fn( [], seed.length, argument ),
					i = matchIndexes.length;
	
				// Match elements found at the specified indexes
				while ( i-- ) {
					if ( seed[ (j = matchIndexes[i]) ] ) {
						seed[j] = !(matches[j] = seed[j]);
					}
				}
			});
		});
	}
	
	/**
	 * Checks a node for validity as a Sizzle context
	 * @param {Element|Object=} context
	 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	 */
	function testContext( context ) {
		return context && typeof context.getElementsByTagName !== "undefined" && context;
	}
	
	// Expose support vars for convenience
	support = Sizzle.support = {};
	
	/**
	 * Detects XML nodes
	 * @param {Element|Object} elem An element or a document
	 * @returns {Boolean} True iff elem is a non-HTML XML node
	 */
	isXML = Sizzle.isXML = function( elem ) {
		// documentElement is verified for cases where it doesn't yet exist
		// (such as loading iframes in IE - #4833)
		var documentElement = elem && (elem.ownerDocument || elem).documentElement;
		return documentElement ? documentElement.nodeName !== "HTML" : false;
	};
	
	/**
	 * Sets document-related variables once based on the current document
	 * @param {Element|Object} [doc] An element or document object to use to set the document
	 * @returns {Object} Returns the current document
	 */
	setDocument = Sizzle.setDocument = function( node ) {
		var hasCompare, subWindow,
			doc = node ? node.ownerDocument || node : preferredDoc;
	
		// Return early if doc is invalid or already selected
		if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
			return document;
		}
	
		// Update global variables
		document = doc;
		docElem = document.documentElement;
		documentIsHTML = !isXML( document );
	
		// Support: IE 9-11, Edge
		// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
		if ( preferredDoc !== document &&
			(subWindow = document.defaultView) && subWindow.top !== subWindow ) {
	
			// Support: IE 11, Edge
			if ( subWindow.addEventListener ) {
				subWindow.addEventListener( "unload", unloadHandler, false );
	
			// Support: IE 9 - 10 only
			} else if ( subWindow.attachEvent ) {
				subWindow.attachEvent( "onunload", unloadHandler );
			}
		}
	
		/* Attributes
		---------------------------------------------------------------------- */
	
		// Support: IE<8
		// Verify that getAttribute really returns attributes and not properties
		// (excepting IE8 booleans)
		support.attributes = assert(function( el ) {
			el.className = "i";
			return !el.getAttribute("className");
		});
	
		/* getElement(s)By*
		---------------------------------------------------------------------- */
	
		// Check if getElementsByTagName("*") returns only elements
		support.getElementsByTagName = assert(function( el ) {
			el.appendChild( document.createComment("") );
			return !el.getElementsByTagName("*").length;
		});
	
		// Support: IE<9
		support.getElementsByClassName = rnative.test( document.getElementsByClassName );
	
		// Support: IE<10
		// Check if getElementById returns elements by name
		// The broken getElementById methods don't pick up programmatically-set names,
		// so use a roundabout getElementsByName test
		support.getById = assert(function( el ) {
			docElem.appendChild( el ).id = expando;
			return !document.getElementsByName || !document.getElementsByName( expando ).length;
		});
	
		// ID filter and find
		if ( support.getById ) {
			Expr.filter["ID"] = function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					return elem.getAttribute("id") === attrId;
				};
			};
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var elem = context.getElementById( id );
					return elem ? [ elem ] : [];
				}
			};
		} else {
			Expr.filter["ID"] =  function( id ) {
				var attrId = id.replace( runescape, funescape );
				return function( elem ) {
					var node = typeof elem.getAttributeNode !== "undefined" &&
						elem.getAttributeNode("id");
					return node && node.value === attrId;
				};
			};
	
			// Support: IE 6 - 7 only
			// getElementById is not reliable as a find shortcut
			Expr.find["ID"] = function( id, context ) {
				if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
					var node, i, elems,
						elem = context.getElementById( id );
	
					if ( elem ) {
	
						// Verify the id attribute
						node = elem.getAttributeNode("id");
						if ( node && node.value === id ) {
							return [ elem ];
						}
	
						// Fall back on getElementsByName
						elems = context.getElementsByName( id );
						i = 0;
						while ( (elem = elems[i++]) ) {
							node = elem.getAttributeNode("id");
							if ( node && node.value === id ) {
								return [ elem ];
							}
						}
					}
	
					return [];
				}
			};
		}
	
		// Tag
		Expr.find["TAG"] = support.getElementsByTagName ?
			function( tag, context ) {
				if ( typeof context.getElementsByTagName !== "undefined" ) {
					return context.getElementsByTagName( tag );
	
				// DocumentFragment nodes don't have gEBTN
				} else if ( support.qsa ) {
					return context.querySelectorAll( tag );
				}
			} :
	
			function( tag, context ) {
				var elem,
					tmp = [],
					i = 0,
					// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
					results = context.getElementsByTagName( tag );
	
				// Filter out possible comments
				if ( tag === "*" ) {
					while ( (elem = results[i++]) ) {
						if ( elem.nodeType === 1 ) {
							tmp.push( elem );
						}
					}
	
					return tmp;
				}
				return results;
			};
	
		// Class
		Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
			if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
				return context.getElementsByClassName( className );
			}
		};
	
		/* QSA/matchesSelector
		---------------------------------------------------------------------- */
	
		// QSA and matchesSelector support
	
		// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
		rbuggyMatches = [];
	
		// qSa(:focus) reports false when true (Chrome 21)
		// We allow this because of a bug in IE8/9 that throws an error
		// whenever `document.activeElement` is accessed on an iframe
		// So, we allow :focus to pass through QSA all the time to avoid the IE error
		// See https://bugs.jquery.com/ticket/13378
		rbuggyQSA = [];
	
		if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
			// Build QSA regex
			// Regex strategy adopted from Diego Perini
			assert(function( el ) {
				// Select is set to empty string on purpose
				// This is to test IE's treatment of not explicitly
				// setting a boolean content attribute,
				// since its presence should be enough
				// https://bugs.jquery.com/ticket/12359
				docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
					"<select id='" + expando + "-\r\\' msallowcapture=''>" +
					"<option selected=''></option></select>";
	
				// Support: IE8, Opera 11-12.16
				// Nothing should be selected when empty strings follow ^= or $= or *=
				// The test attribute must be unknown in Opera but "safe" for WinRT
				// https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
				if ( el.querySelectorAll("[msallowcapture^='']").length ) {
					rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
				}
	
				// Support: IE8
				// Boolean attributes and "value" are not treated correctly
				if ( !el.querySelectorAll("[selected]").length ) {
					rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
				}
	
				// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
				if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
					rbuggyQSA.push("~=");
				}
	
				// Webkit/Opera - :checked should return selected option elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				// IE8 throws error here and will not see later tests
				if ( !el.querySelectorAll(":checked").length ) {
					rbuggyQSA.push(":checked");
				}
	
				// Support: Safari 8+, iOS 8+
				// https://bugs.webkit.org/show_bug.cgi?id=136851
				// In-page `selector#id sibling-combinator selector` fails
				if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
					rbuggyQSA.push(".#.+[+~]");
				}
			});
	
			assert(function( el ) {
				el.innerHTML = "<a href='' disabled='disabled'></a>" +
					"<select disabled='disabled'><option/></select>";
	
				// Support: Windows 8 Native Apps
				// The type and name attributes are restricted during .innerHTML assignment
				var input = document.createElement("input");
				input.setAttribute( "type", "hidden" );
				el.appendChild( input ).setAttribute( "name", "D" );
	
				// Support: IE8
				// Enforce case-sensitivity of name attribute
				if ( el.querySelectorAll("[name=d]").length ) {
					rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
				}
	
				// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
				// IE8 throws error here and will not see later tests
				if ( el.querySelectorAll(":enabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Support: IE9-11+
				// IE's :disabled selector does not pick up the children of disabled fieldsets
				docElem.appendChild( el ).disabled = true;
				if ( el.querySelectorAll(":disabled").length !== 2 ) {
					rbuggyQSA.push( ":enabled", ":disabled" );
				}
	
				// Opera 10-11 does not throw on post-comma invalid pseudos
				el.querySelectorAll("*,:x");
				rbuggyQSA.push(",.*:");
			});
		}
	
		if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
			docElem.webkitMatchesSelector ||
			docElem.mozMatchesSelector ||
			docElem.oMatchesSelector ||
			docElem.msMatchesSelector) )) ) {
	
			assert(function( el ) {
				// Check to see if it's possible to do matchesSelector
				// on a disconnected node (IE 9)
				support.disconnectedMatch = matches.call( el, "*" );
	
				// This should fail with an exception
				// Gecko does not error, returns false instead
				matches.call( el, "[s!='']:x" );
				rbuggyMatches.push( "!=", pseudos );
			});
		}
	
		rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
		rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );
	
		/* Contains
		---------------------------------------------------------------------- */
		hasCompare = rnative.test( docElem.compareDocumentPosition );
	
		// Element contains another
		// Purposefully self-exclusive
		// As in, an element does not contain itself
		contains = hasCompare || rnative.test( docElem.contains ) ?
			function( a, b ) {
				var adown = a.nodeType === 9 ? a.documentElement : a,
					bup = b && b.parentNode;
				return a === bup || !!( bup && bup.nodeType === 1 && (
					adown.contains ?
						adown.contains( bup ) :
						a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
				));
			} :
			function( a, b ) {
				if ( b ) {
					while ( (b = b.parentNode) ) {
						if ( b === a ) {
							return true;
						}
					}
				}
				return false;
			};
	
		/* Sorting
		---------------------------------------------------------------------- */
	
		// Document order sorting
		sortOrder = hasCompare ?
		function( a, b ) {
	
			// Flag for duplicate removal
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			// Sort on method existence if only one input has compareDocumentPosition
			var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
			if ( compare ) {
				return compare;
			}
	
			// Calculate position if both inputs belong to the same document
			compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
				a.compareDocumentPosition( b ) :
	
				// Otherwise we know they are disconnected
				1;
	
			// Disconnected nodes
			if ( compare & 1 ||
				(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {
	
				// Choose the first element that is related to our preferred document
				if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
					return -1;
				}
				if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
					return 1;
				}
	
				// Maintain original order
				return sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
			}
	
			return compare & 4 ? -1 : 1;
		} :
		function( a, b ) {
			// Exit early if the nodes are identical
			if ( a === b ) {
				hasDuplicate = true;
				return 0;
			}
	
			var cur,
				i = 0,
				aup = a.parentNode,
				bup = b.parentNode,
				ap = [ a ],
				bp = [ b ];
	
			// Parentless nodes are either documents or disconnected
			if ( !aup || !bup ) {
				return a === document ? -1 :
					b === document ? 1 :
					aup ? -1 :
					bup ? 1 :
					sortInput ?
					( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
					0;
	
			// If the nodes are siblings, we can do a quick check
			} else if ( aup === bup ) {
				return siblingCheck( a, b );
			}
	
			// Otherwise we need full lists of their ancestors for comparison
			cur = a;
			while ( (cur = cur.parentNode) ) {
				ap.unshift( cur );
			}
			cur = b;
			while ( (cur = cur.parentNode) ) {
				bp.unshift( cur );
			}
	
			// Walk down the tree looking for a discrepancy
			while ( ap[i] === bp[i] ) {
				i++;
			}
	
			return i ?
				// Do a sibling check if the nodes have a common ancestor
				siblingCheck( ap[i], bp[i] ) :
	
				// Otherwise nodes in our document sort first
				ap[i] === preferredDoc ? -1 :
				bp[i] === preferredDoc ? 1 :
				0;
		};
	
		return document;
	};
	
	Sizzle.matches = function( expr, elements ) {
		return Sizzle( expr, null, null, elements );
	};
	
	Sizzle.matchesSelector = function( elem, expr ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		// Make sure that attribute selectors are quoted
		expr = expr.replace( rattributeQuotes, "='$1']" );
	
		if ( support.matchesSelector && documentIsHTML &&
			!compilerCache[ expr + " " ] &&
			( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
			( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {
	
			try {
				var ret = matches.call( elem, expr );
	
				// IE 9's matchesSelector returns false on disconnected nodes
				if ( ret || support.disconnectedMatch ||
						// As well, disconnected nodes are said to be in a document
						// fragment in IE 9
						elem.document && elem.document.nodeType !== 11 ) {
					return ret;
				}
			} catch (e) {}
		}
	
		return Sizzle( expr, document, null, [ elem ] ).length > 0;
	};
	
	Sizzle.contains = function( context, elem ) {
		// Set document vars if needed
		if ( ( context.ownerDocument || context ) !== document ) {
			setDocument( context );
		}
		return contains( context, elem );
	};
	
	Sizzle.attr = function( elem, name ) {
		// Set document vars if needed
		if ( ( elem.ownerDocument || elem ) !== document ) {
			setDocument( elem );
		}
	
		var fn = Expr.attrHandle[ name.toLowerCase() ],
			// Don't get fooled by Object.prototype properties (jQuery #13807)
			val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
				fn( elem, name, !documentIsHTML ) :
				undefined;
	
		return val !== undefined ?
			val :
			support.attributes || !documentIsHTML ?
				elem.getAttribute( name ) :
				(val = elem.getAttributeNode(name)) && val.specified ?
					val.value :
					null;
	};
	
	Sizzle.escape = function( sel ) {
		return (sel + "").replace( rcssescape, fcssescape );
	};
	
	Sizzle.error = function( msg ) {
		throw new Error( "Syntax error, unrecognized expression: " + msg );
	};
	
	/**
	 * Document sorting and removing duplicates
	 * @param {ArrayLike} results
	 */
	Sizzle.uniqueSort = function( results ) {
		var elem,
			duplicates = [],
			j = 0,
			i = 0;
	
		// Unless we *know* we can detect duplicates, assume their presence
		hasDuplicate = !support.detectDuplicates;
		sortInput = !support.sortStable && results.slice( 0 );
		results.sort( sortOrder );
	
		if ( hasDuplicate ) {
			while ( (elem = results[i++]) ) {
				if ( elem === results[ i ] ) {
					j = duplicates.push( i );
				}
			}
			while ( j-- ) {
				results.splice( duplicates[ j ], 1 );
			}
		}
	
		// Clear input after sorting to release objects
		// See https://github.com/jquery/sizzle/pull/225
		sortInput = null;
	
		return results;
	};
	
	/**
	 * Utility function for retrieving the text value of an array of DOM nodes
	 * @param {Array|Element} elem
	 */
	getText = Sizzle.getText = function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;
	
		if ( !nodeType ) {
			// If no nodeType, this is expected to be an array
			while ( (node = elem[i++]) ) {
				// Do not traverse comment nodes
				ret += getText( node );
			}
		} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
			// Use textContent for elements
			// innerText usage removed for consistency of new lines (jQuery #11153)
			if ( typeof elem.textContent === "string" ) {
				return elem.textContent;
			} else {
				// Traverse its children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					ret += getText( elem );
				}
			}
		} else if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}
		// Do not include comment or processing instruction nodes
	
		return ret;
	};
	
	Expr = Sizzle.selectors = {
	
		// Can be adjusted by the user
		cacheLength: 50,
	
		createPseudo: markFunction,
	
		match: matchExpr,
	
		attrHandle: {},
	
		find: {},
	
		relative: {
			">": { dir: "parentNode", first: true },
			" ": { dir: "parentNode" },
			"+": { dir: "previousSibling", first: true },
			"~": { dir: "previousSibling" }
		},
	
		preFilter: {
			"ATTR": function( match ) {
				match[1] = match[1].replace( runescape, funescape );
	
				// Move the given value to match[3] whether quoted or unquoted
				match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );
	
				if ( match[2] === "~=" ) {
					match[3] = " " + match[3] + " ";
				}
	
				return match.slice( 0, 4 );
			},
	
			"CHILD": function( match ) {
				/* matches from matchExpr["CHILD"]
					1 type (only|nth|...)
					2 what (child|of-type)
					3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
					4 xn-component of xn+y argument ([+-]?\d*n|)
					5 sign of xn-component
					6 x of xn-component
					7 sign of y-component
					8 y of y-component
				*/
				match[1] = match[1].toLowerCase();
	
				if ( match[1].slice( 0, 3 ) === "nth" ) {
					// nth-* requires argument
					if ( !match[3] ) {
						Sizzle.error( match[0] );
					}
	
					// numeric x and y parameters for Expr.filter.CHILD
					// remember that false/true cast respectively to 0/1
					match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
					match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );
	
				// other types prohibit arguments
				} else if ( match[3] ) {
					Sizzle.error( match[0] );
				}
	
				return match;
			},
	
			"PSEUDO": function( match ) {
				var excess,
					unquoted = !match[6] && match[2];
	
				if ( matchExpr["CHILD"].test( match[0] ) ) {
					return null;
				}
	
				// Accept quoted arguments as-is
				if ( match[3] ) {
					match[2] = match[4] || match[5] || "";
	
				// Strip excess characters from unquoted arguments
				} else if ( unquoted && rpseudo.test( unquoted ) &&
					// Get excess from tokenize (recursively)
					(excess = tokenize( unquoted, true )) &&
					// advance to the next closing parenthesis
					(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {
	
					// excess is a negative index
					match[0] = match[0].slice( 0, excess );
					match[2] = unquoted.slice( 0, excess );
				}
	
				// Return only captures needed by the pseudo filter method (type and argument)
				return match.slice( 0, 3 );
			}
		},
	
		filter: {
	
			"TAG": function( nodeNameSelector ) {
				var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
				return nodeNameSelector === "*" ?
					function() { return true; } :
					function( elem ) {
						return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
					};
			},
	
			"CLASS": function( className ) {
				var pattern = classCache[ className + " " ];
	
				return pattern ||
					(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
					classCache( className, function( elem ) {
						return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
					});
			},
	
			"ATTR": function( name, operator, check ) {
				return function( elem ) {
					var result = Sizzle.attr( elem, name );
	
					if ( result == null ) {
						return operator === "!=";
					}
					if ( !operator ) {
						return true;
					}
	
					result += "";
	
					return operator === "=" ? result === check :
						operator === "!=" ? result !== check :
						operator === "^=" ? check && result.indexOf( check ) === 0 :
						operator === "*=" ? check && result.indexOf( check ) > -1 :
						operator === "$=" ? check && result.slice( -check.length ) === check :
						operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
						operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
						false;
				};
			},
	
			"CHILD": function( type, what, argument, first, last ) {
				var simple = type.slice( 0, 3 ) !== "nth",
					forward = type.slice( -4 ) !== "last",
					ofType = what === "of-type";
	
				return first === 1 && last === 0 ?
	
					// Shortcut for :nth-*(n)
					function( elem ) {
						return !!elem.parentNode;
					} :
	
					function( elem, context, xml ) {
						var cache, uniqueCache, outerCache, node, nodeIndex, start,
							dir = simple !== forward ? "nextSibling" : "previousSibling",
							parent = elem.parentNode,
							name = ofType && elem.nodeName.toLowerCase(),
							useCache = !xml && !ofType,
							diff = false;
	
						if ( parent ) {
	
							// :(first|last|only)-(child|of-type)
							if ( simple ) {
								while ( dir ) {
									node = elem;
									while ( (node = node[ dir ]) ) {
										if ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) {
	
											return false;
										}
									}
									// Reverse direction for :only-* (if we haven't yet done so)
									start = dir = type === "only" && !start && "nextSibling";
								}
								return true;
							}
	
							start = [ forward ? parent.firstChild : parent.lastChild ];
	
							// non-xml :nth-child(...) stores cache data on `parent`
							if ( forward && useCache ) {
	
								// Seek `elem` from a previously-cached index
	
								// ...in a gzip-friendly way
								node = parent;
								outerCache = node[ expando ] || (node[ expando ] = {});
	
								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});
	
								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex && cache[ 2 ];
								node = nodeIndex && parent.childNodes[ nodeIndex ];
	
								while ( (node = ++nodeIndex && node && node[ dir ] ||
	
									// Fallback to seeking `elem` from the start
									(diff = nodeIndex = 0) || start.pop()) ) {
	
									// When found, cache indexes on `parent` and break
									if ( node.nodeType === 1 && ++diff && node === elem ) {
										uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
										break;
									}
								}
	
							} else {
								// Use previously-cached element index if available
								if ( useCache ) {
									// ...in a gzip-friendly way
									node = elem;
									outerCache = node[ expando ] || (node[ expando ] = {});
	
									// Support: IE <9 only
									// Defend against cloned attroperties (jQuery gh-1709)
									uniqueCache = outerCache[ node.uniqueID ] ||
										(outerCache[ node.uniqueID ] = {});
	
									cache = uniqueCache[ type ] || [];
									nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
									diff = nodeIndex;
								}
	
								// xml :nth-child(...)
								// or :nth-last-child(...) or :nth(-last)?-of-type(...)
								if ( diff === false ) {
									// Use the same loop as above to seek `elem` from the start
									while ( (node = ++nodeIndex && node && node[ dir ] ||
										(diff = nodeIndex = 0) || start.pop()) ) {
	
										if ( ( ofType ?
											node.nodeName.toLowerCase() === name :
											node.nodeType === 1 ) &&
											++diff ) {
	
											// Cache the index of each encountered element
											if ( useCache ) {
												outerCache = node[ expando ] || (node[ expando ] = {});
	
												// Support: IE <9 only
												// Defend against cloned attroperties (jQuery gh-1709)
												uniqueCache = outerCache[ node.uniqueID ] ||
													(outerCache[ node.uniqueID ] = {});
	
												uniqueCache[ type ] = [ dirruns, diff ];
											}
	
											if ( node === elem ) {
												break;
											}
										}
									}
								}
							}
	
							// Incorporate the offset, then check against cycle size
							diff -= last;
							return diff === first || ( diff % first === 0 && diff / first >= 0 );
						}
					};
			},
	
			"PSEUDO": function( pseudo, argument ) {
				// pseudo-class names are case-insensitive
				// http://www.w3.org/TR/selectors/#pseudo-classes
				// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
				// Remember that setFilters inherits from pseudos
				var args,
					fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
						Sizzle.error( "unsupported pseudo: " + pseudo );
	
				// The user may use createPseudo to indicate that
				// arguments are needed to create the filter function
				// just as Sizzle does
				if ( fn[ expando ] ) {
					return fn( argument );
				}
	
				// But maintain support for old signatures
				if ( fn.length > 1 ) {
					args = [ pseudo, pseudo, "", argument ];
					return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
						markFunction(function( seed, matches ) {
							var idx,
								matched = fn( seed, argument ),
								i = matched.length;
							while ( i-- ) {
								idx = indexOf( seed, matched[i] );
								seed[ idx ] = !( matches[ idx ] = matched[i] );
							}
						}) :
						function( elem ) {
							return fn( elem, 0, args );
						};
				}
	
				return fn;
			}
		},
	
		pseudos: {
			// Potentially complex pseudos
			"not": markFunction(function( selector ) {
				// Trim the selector passed to compile
				// to avoid treating leading and trailing
				// spaces as combinators
				var input = [],
					results = [],
					matcher = compile( selector.replace( rtrim, "$1" ) );
	
				return matcher[ expando ] ?
					markFunction(function( seed, matches, context, xml ) {
						var elem,
							unmatched = matcher( seed, null, xml, [] ),
							i = seed.length;
	
						// Match elements unmatched by `matcher`
						while ( i-- ) {
							if ( (elem = unmatched[i]) ) {
								seed[i] = !(matches[i] = elem);
							}
						}
					}) :
					function( elem, context, xml ) {
						input[0] = elem;
						matcher( input, null, xml, results );
						// Don't keep the element (issue #299)
						input[0] = null;
						return !results.pop();
					};
			}),
	
			"has": markFunction(function( selector ) {
				return function( elem ) {
					return Sizzle( selector, elem ).length > 0;
				};
			}),
	
			"contains": markFunction(function( text ) {
				text = text.replace( runescape, funescape );
				return function( elem ) {
					return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
				};
			}),
	
			// "Whether an element is represented by a :lang() selector
			// is based solely on the element's language value
			// being equal to the identifier C,
			// or beginning with the identifier C immediately followed by "-".
			// The matching of C against the element's language value is performed case-insensitively.
			// The identifier C does not have to be a valid language name."
			// http://www.w3.org/TR/selectors/#lang-pseudo
			"lang": markFunction( function( lang ) {
				// lang value must be a valid identifier
				if ( !ridentifier.test(lang || "") ) {
					Sizzle.error( "unsupported lang: " + lang );
				}
				lang = lang.replace( runescape, funescape ).toLowerCase();
				return function( elem ) {
					var elemLang;
					do {
						if ( (elemLang = documentIsHTML ?
							elem.lang :
							elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {
	
							elemLang = elemLang.toLowerCase();
							return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
						}
					} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
					return false;
				};
			}),
	
			// Miscellaneous
			"target": function( elem ) {
				var hash = window.location && window.location.hash;
				return hash && hash.slice( 1 ) === elem.id;
			},
	
			"root": function( elem ) {
				return elem === docElem;
			},
	
			"focus": function( elem ) {
				return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
			},
	
			// Boolean properties
			"enabled": createDisabledPseudo( false ),
			"disabled": createDisabledPseudo( true ),
	
			"checked": function( elem ) {
				// In CSS3, :checked should return both checked and selected elements
				// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
				var nodeName = elem.nodeName.toLowerCase();
				return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
			},
	
			"selected": function( elem ) {
				// Accessing this property makes selected-by-default
				// options in Safari work properly
				if ( elem.parentNode ) {
					elem.parentNode.selectedIndex;
				}
	
				return elem.selected === true;
			},
	
			// Contents
			"empty": function( elem ) {
				// http://www.w3.org/TR/selectors/#empty-pseudo
				// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
				//   but not by others (comment: 8; processing instruction: 7; etc.)
				// nodeType < 6 works because attributes (2) do not appear as children
				for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
					if ( elem.nodeType < 6 ) {
						return false;
					}
				}
				return true;
			},
	
			"parent": function( elem ) {
				return !Expr.pseudos["empty"]( elem );
			},
	
			// Element/input types
			"header": function( elem ) {
				return rheader.test( elem.nodeName );
			},
	
			"input": function( elem ) {
				return rinputs.test( elem.nodeName );
			},
	
			"button": function( elem ) {
				var name = elem.nodeName.toLowerCase();
				return name === "input" && elem.type === "button" || name === "button";
			},
	
			"text": function( elem ) {
				var attr;
				return elem.nodeName.toLowerCase() === "input" &&
					elem.type === "text" &&
	
					// Support: IE<8
					// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
					( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
			},
	
			// Position-in-collection
			"first": createPositionalPseudo(function() {
				return [ 0 ];
			}),
	
			"last": createPositionalPseudo(function( matchIndexes, length ) {
				return [ length - 1 ];
			}),
	
			"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
				return [ argument < 0 ? argument + length : argument ];
			}),
	
			"even": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 0;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"odd": createPositionalPseudo(function( matchIndexes, length ) {
				var i = 1;
				for ( ; i < length; i += 2 ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; --i >= 0; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			}),
	
			"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
				var i = argument < 0 ? argument + length : argument;
				for ( ; ++i < length; ) {
					matchIndexes.push( i );
				}
				return matchIndexes;
			})
		}
	};
	
	Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	// Add button/input type pseudos
	for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
		Expr.pseudos[ i ] = createInputPseudo( i );
	}
	for ( i in { submit: true, reset: true } ) {
		Expr.pseudos[ i ] = createButtonPseudo( i );
	}
	
	// Easy API for creating new setFilters
	function setFilters() {}
	setFilters.prototype = Expr.filters = Expr.pseudos;
	Expr.setFilters = new setFilters();
	
	tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
		var matched, match, tokens, type,
			soFar, groups, preFilters,
			cached = tokenCache[ selector + " " ];
	
		if ( cached ) {
			return parseOnly ? 0 : cached.slice( 0 );
		}
	
		soFar = selector;
		groups = [];
		preFilters = Expr.preFilter;
	
		while ( soFar ) {
	
			// Comma and first run
			if ( !matched || (match = rcomma.exec( soFar )) ) {
				if ( match ) {
					// Don't consume trailing commas as valid
					soFar = soFar.slice( match[0].length ) || soFar;
				}
				groups.push( (tokens = []) );
			}
	
			matched = false;
	
			// Combinators
			if ( (match = rcombinators.exec( soFar )) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					// Cast descendant combinators to space
					type: match[0].replace( rtrim, " " )
				});
				soFar = soFar.slice( matched.length );
			}
	
			// Filters
			for ( type in Expr.filter ) {
				if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
					(match = preFilters[ type ]( match ))) ) {
					matched = match.shift();
					tokens.push({
						value: matched,
						type: type,
						matches: match
					});
					soFar = soFar.slice( matched.length );
				}
			}
	
			if ( !matched ) {
				break;
			}
		}
	
		// Return the length of the invalid excess
		// if we're just parsing
		// Otherwise, throw an error or return tokens
		return parseOnly ?
			soFar.length :
			soFar ?
				Sizzle.error( selector ) :
				// Cache the tokens
				tokenCache( selector, groups ).slice( 0 );
	};
	
	function toSelector( tokens ) {
		var i = 0,
			len = tokens.length,
			selector = "";
		for ( ; i < len; i++ ) {
			selector += tokens[i].value;
		}
		return selector;
	}
	
	function addCombinator( matcher, combinator, base ) {
		var dir = combinator.dir,
			skip = combinator.next,
			key = skip || dir,
			checkNonElements = base && key === "parentNode",
			doneName = done++;
	
		return combinator.first ?
			// Check against closest ancestor/preceding element
			function( elem, context, xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						return matcher( elem, context, xml );
					}
				}
				return false;
			} :
	
			// Check against all ancestor/preceding elements
			function( elem, context, xml ) {
				var oldCache, uniqueCache, outerCache,
					newCache = [ dirruns, doneName ];
	
				// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
				if ( xml ) {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							if ( matcher( elem, context, xml ) ) {
								return true;
							}
						}
					}
				} else {
					while ( (elem = elem[ dir ]) ) {
						if ( elem.nodeType === 1 || checkNonElements ) {
							outerCache = elem[ expando ] || (elem[ expando ] = {});
	
							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});
	
							if ( skip && skip === elem.nodeName.toLowerCase() ) {
								elem = elem[ dir ] || elem;
							} else if ( (oldCache = uniqueCache[ key ]) &&
								oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {
	
								// Assign to newCache so results back-propagate to previous elements
								return (newCache[ 2 ] = oldCache[ 2 ]);
							} else {
								// Reuse newcache so results back-propagate to previous elements
								uniqueCache[ key ] = newCache;
	
								// A match means we're done; a fail means we have to keep checking
								if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
									return true;
								}
							}
						}
					}
				}
				return false;
			};
	}
	
	function elementMatcher( matchers ) {
		return matchers.length > 1 ?
			function( elem, context, xml ) {
				var i = matchers.length;
				while ( i-- ) {
					if ( !matchers[i]( elem, context, xml ) ) {
						return false;
					}
				}
				return true;
			} :
			matchers[0];
	}
	
	function multipleContexts( selector, contexts, results ) {
		var i = 0,
			len = contexts.length;
		for ( ; i < len; i++ ) {
			Sizzle( selector, contexts[i], results );
		}
		return results;
	}
	
	function condense( unmatched, map, filter, context, xml ) {
		var elem,
			newUnmatched = [],
			i = 0,
			len = unmatched.length,
			mapped = map != null;
	
		for ( ; i < len; i++ ) {
			if ( (elem = unmatched[i]) ) {
				if ( !filter || filter( elem, context, xml ) ) {
					newUnmatched.push( elem );
					if ( mapped ) {
						map.push( i );
					}
				}
			}
		}
	
		return newUnmatched;
	}
	
	function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
		if ( postFilter && !postFilter[ expando ] ) {
			postFilter = setMatcher( postFilter );
		}
		if ( postFinder && !postFinder[ expando ] ) {
			postFinder = setMatcher( postFinder, postSelector );
		}
		return markFunction(function( seed, results, context, xml ) {
			var temp, i, elem,
				preMap = [],
				postMap = [],
				preexisting = results.length,
	
				// Get initial elements from seed or context
				elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),
	
				// Prefilter to get matcher input, preserving a map for seed-results synchronization
				matcherIn = preFilter && ( seed || !selector ) ?
					condense( elems, preMap, preFilter, context, xml ) :
					elems,
	
				matcherOut = matcher ?
					// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
					postFinder || ( seed ? preFilter : preexisting || postFilter ) ?
	
						// ...intermediate processing is necessary
						[] :
	
						// ...otherwise use results directly
						results :
					matcherIn;
	
			// Find primary matches
			if ( matcher ) {
				matcher( matcherIn, matcherOut, context, xml );
			}
	
			// Apply postFilter
			if ( postFilter ) {
				temp = condense( matcherOut, postMap );
				postFilter( temp, [], context, xml );
	
				// Un-match failing elements by moving them back to matcherIn
				i = temp.length;
				while ( i-- ) {
					if ( (elem = temp[i]) ) {
						matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
					}
				}
			}
	
			if ( seed ) {
				if ( postFinder || preFilter ) {
					if ( postFinder ) {
						// Get the final matcherOut by condensing this intermediate into postFinder contexts
						temp = [];
						i = matcherOut.length;
						while ( i-- ) {
							if ( (elem = matcherOut[i]) ) {
								// Restore matcherIn since elem is not yet a final match
								temp.push( (matcherIn[i] = elem) );
							}
						}
						postFinder( null, (matcherOut = []), temp, xml );
					}
	
					// Move matched elements from seed to results to keep them synchronized
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) &&
							(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {
	
							seed[temp] = !(results[temp] = elem);
						}
					}
				}
	
			// Add elements to results, through postFinder if defined
			} else {
				matcherOut = condense(
					matcherOut === results ?
						matcherOut.splice( preexisting, matcherOut.length ) :
						matcherOut
				);
				if ( postFinder ) {
					postFinder( null, results, matcherOut, xml );
				} else {
					push.apply( results, matcherOut );
				}
			}
		});
	}
	
	function matcherFromTokens( tokens ) {
		var checkContext, matcher, j,
			len = tokens.length,
			leadingRelative = Expr.relative[ tokens[0].type ],
			implicitRelative = leadingRelative || Expr.relative[" "],
			i = leadingRelative ? 1 : 0,
	
			// The foundational matcher ensures that elements are reachable from top-level context(s)
			matchContext = addCombinator( function( elem ) {
				return elem === checkContext;
			}, implicitRelative, true ),
			matchAnyContext = addCombinator( function( elem ) {
				return indexOf( checkContext, elem ) > -1;
			}, implicitRelative, true ),
			matchers = [ function( elem, context, xml ) {
				var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
					(checkContext = context).nodeType ?
						matchContext( elem, context, xml ) :
						matchAnyContext( elem, context, xml ) );
				// Avoid hanging onto element (issue #299)
				checkContext = null;
				return ret;
			} ];
	
		for ( ; i < len; i++ ) {
			if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
				matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
			} else {
				matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );
	
				// Return special upon seeing a positional matcher
				if ( matcher[ expando ] ) {
					// Find the next relative operator (if any) for proper handling
					j = ++i;
					for ( ; j < len; j++ ) {
						if ( Expr.relative[ tokens[j].type ] ) {
							break;
						}
					}
					return setMatcher(
						i > 1 && elementMatcher( matchers ),
						i > 1 && toSelector(
							// If the preceding token was a descendant combinator, insert an implicit any-element `*`
							tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
						).replace( rtrim, "$1" ),
						matcher,
						i < j && matcherFromTokens( tokens.slice( i, j ) ),
						j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
						j < len && toSelector( tokens )
					);
				}
				matchers.push( matcher );
			}
		}
	
		return elementMatcher( matchers );
	}
	
	function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
		var bySet = setMatchers.length > 0,
			byElement = elementMatchers.length > 0,
			superMatcher = function( seed, context, xml, results, outermost ) {
				var elem, j, matcher,
					matchedCount = 0,
					i = "0",
					unmatched = seed && [],
					setMatched = [],
					contextBackup = outermostContext,
					// We must always have either seed elements or outermost context
					elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
					// Use integer dirruns iff this is the outermost matcher
					dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
					len = elems.length;
	
				if ( outermost ) {
					outermostContext = context === document || context || outermost;
				}
	
				// Add elements passing elementMatchers directly to results
				// Support: IE<9, Safari
				// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
				for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
					if ( byElement && elem ) {
						j = 0;
						if ( !context && elem.ownerDocument !== document ) {
							setDocument( elem );
							xml = !documentIsHTML;
						}
						while ( (matcher = elementMatchers[j++]) ) {
							if ( matcher( elem, context || document, xml) ) {
								results.push( elem );
								break;
							}
						}
						if ( outermost ) {
							dirruns = dirrunsUnique;
						}
					}
	
					// Track unmatched elements for set filters
					if ( bySet ) {
						// They will have gone through all possible matchers
						if ( (elem = !matcher && elem) ) {
							matchedCount--;
						}
	
						// Lengthen the array for every element, matched or not
						if ( seed ) {
							unmatched.push( elem );
						}
					}
				}
	
				// `i` is now the count of elements visited above, and adding it to `matchedCount`
				// makes the latter nonnegative.
				matchedCount += i;
	
				// Apply set filters to unmatched elements
				// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
				// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
				// no element matchers and no seed.
				// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
				// case, which will result in a "00" `matchedCount` that differs from `i` but is also
				// numerically zero.
				if ( bySet && i !== matchedCount ) {
					j = 0;
					while ( (matcher = setMatchers[j++]) ) {
						matcher( unmatched, setMatched, context, xml );
					}
	
					if ( seed ) {
						// Reintegrate element matches to eliminate the need for sorting
						if ( matchedCount > 0 ) {
							while ( i-- ) {
								if ( !(unmatched[i] || setMatched[i]) ) {
									setMatched[i] = pop.call( results );
								}
							}
						}
	
						// Discard index placeholder values to get only actual matches
						setMatched = condense( setMatched );
					}
	
					// Add matches to results
					push.apply( results, setMatched );
	
					// Seedless set matches succeeding multiple successful matchers stipulate sorting
					if ( outermost && !seed && setMatched.length > 0 &&
						( matchedCount + setMatchers.length ) > 1 ) {
	
						Sizzle.uniqueSort( results );
					}
				}
	
				// Override manipulation of globals by nested matchers
				if ( outermost ) {
					dirruns = dirrunsUnique;
					outermostContext = contextBackup;
				}
	
				return unmatched;
			};
	
		return bySet ?
			markFunction( superMatcher ) :
			superMatcher;
	}
	
	compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
		var i,
			setMatchers = [],
			elementMatchers = [],
			cached = compilerCache[ selector + " " ];
	
		if ( !cached ) {
			// Generate a function of recursive functions that can be used to check each element
			if ( !match ) {
				match = tokenize( selector );
			}
			i = match.length;
			while ( i-- ) {
				cached = matcherFromTokens( match[i] );
				if ( cached[ expando ] ) {
					setMatchers.push( cached );
				} else {
					elementMatchers.push( cached );
				}
			}
	
			// Cache the compiled function
			cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );
	
			// Save selector and tokenization
			cached.selector = selector;
		}
		return cached;
	};
	
	/**
	 * A low-level selection function that works with Sizzle's compiled
	 *  selector functions
	 * @param {String|Function} selector A selector or a pre-compiled
	 *  selector function built with Sizzle.compile
	 * @param {Element} context
	 * @param {Array} [results]
	 * @param {Array} [seed] A set of elements to match against
	 */
	select = Sizzle.select = function( selector, context, results, seed ) {
		var i, tokens, token, type, find,
			compiled = typeof selector === "function" && selector,
			match = !seed && tokenize( (selector = compiled.selector || selector) );
	
		results = results || [];
	
		// Try to minimize operations if there is only one selector in the list and no seed
		// (the latter of which guarantees us context)
		if ( match.length === 1 ) {
	
			// Reduce context if the leading compound selector is an ID
			tokens = match[0] = match[0].slice( 0 );
			if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
					context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[1].type ] ) {
	
				context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
				if ( !context ) {
					return results;
	
				// Precompiled matchers will still verify ancestry, so step up a level
				} else if ( compiled ) {
					context = context.parentNode;
				}
	
				selector = selector.slice( tokens.shift().value.length );
			}
	
			// Fetch a seed set for right-to-left matching
			i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
			while ( i-- ) {
				token = tokens[i];
	
				// Abort if we hit a combinator
				if ( Expr.relative[ (type = token.type) ] ) {
					break;
				}
				if ( (find = Expr.find[ type ]) ) {
					// Search, expanding context for leading sibling combinators
					if ( (seed = find(
						token.matches[0].replace( runescape, funescape ),
						rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
					)) ) {
	
						// If seed is empty or no tokens remain, we can return early
						tokens.splice( i, 1 );
						selector = seed.length && toSelector( tokens );
						if ( !selector ) {
							push.apply( results, seed );
							return results;
						}
	
						break;
					}
				}
			}
		}
	
		// Compile and execute a filtering function if one is not provided
		// Provide `match` to avoid retokenization if we modified the selector above
		( compiled || compile( selector, match ) )(
			seed,
			context,
			!documentIsHTML,
			results,
			!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
		);
		return results;
	};
	
	// One-time assignments
	
	// Sort stability
	support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;
	
	// Support: Chrome 14-35+
	// Always assume duplicates if they aren't passed to the comparison function
	support.detectDuplicates = !!hasDuplicate;
	
	// Initialize against the default document
	setDocument();
	
	// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	// Detached nodes confoundingly follow *each other*
	support.sortDetached = assert(function( el ) {
		// Should return 1, but returns 4 (following)
		return el.compareDocumentPosition( document.createElement("fieldset") ) & 1;
	});
	
	// Support: IE<8
	// Prevent attribute/property "interpolation"
	// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	if ( !assert(function( el ) {
		el.innerHTML = "<a href='#'></a>";
		return el.firstChild.getAttribute("href") === "#" ;
	}) ) {
		addHandle( "type|href|height|width", function( elem, name, isXML ) {
			if ( !isXML ) {
				return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
			}
		});
	}
	
	// Support: IE<9
	// Use defaultValue in place of getAttribute("value")
	if ( !support.attributes || !assert(function( el ) {
		el.innerHTML = "<input/>";
		el.firstChild.setAttribute( "value", "" );
		return el.firstChild.getAttribute( "value" ) === "";
	}) ) {
		addHandle( "value", function( elem, name, isXML ) {
			if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
				return elem.defaultValue;
			}
		});
	}
	
	// Support: IE<9
	// Use getAttributeNode to fetch booleans when getAttribute lies
	if ( !assert(function( el ) {
		return el.getAttribute("disabled") == null;
	}) ) {
		addHandle( booleans, function( elem, name, isXML ) {
			var val;
			if ( !isXML ) {
				return elem[ name ] === true ? name.toLowerCase() :
						(val = elem.getAttributeNode( name )) && val.specified ?
						val.value :
					null;
			}
		});
	}
	
	return Sizzle;
	
	})( window );
	
	
	
	jQuery.find = Sizzle;
	jQuery.expr = Sizzle.selectors;
	
	// Deprecated
	jQuery.expr[ ":" ] = jQuery.expr.pseudos;
	jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
	jQuery.text = Sizzle.getText;
	jQuery.isXMLDoc = Sizzle.isXML;
	jQuery.contains = Sizzle.contains;
	jQuery.escapeSelector = Sizzle.escape;
	
	
	
	
	var dir = function( elem, dir, until ) {
		var matched = [],
			truncate = until !== undefined;
	
		while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
			if ( elem.nodeType === 1 ) {
				if ( truncate && jQuery( elem ).is( until ) ) {
					break;
				}
				matched.push( elem );
			}
		}
		return matched;
	};
	
	
	var siblings = function( n, elem ) {
		var matched = [];
	
		for ( ; n; n = n.nextSibling ) {
			if ( n.nodeType === 1 && n !== elem ) {
				matched.push( n );
			}
		}
	
		return matched;
	};
	
	
	var rneedsContext = jQuery.expr.match.needsContext;
	
	var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );
	
	
	
	var risSimple = /^.[^:#\[\.,]*$/;
	
	// Implement the identical functionality for filter and not
	function winnow( elements, qualifier, not ) {
		if ( jQuery.isFunction( qualifier ) ) {
			return jQuery.grep( elements, function( elem, i ) {
				return !!qualifier.call( elem, i, elem ) !== not;
			} );
		}
	
		// Single element
		if ( qualifier.nodeType ) {
			return jQuery.grep( elements, function( elem ) {
				return ( elem === qualifier ) !== not;
			} );
		}
	
		// Arraylike of elements (jQuery, arguments, Array)
		if ( typeof qualifier !== "string" ) {
			return jQuery.grep( elements, function( elem ) {
				return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
			} );
		}
	
		// Simple selector that can be filtered directly, removing non-Elements
		if ( risSimple.test( qualifier ) ) {
			return jQuery.filter( qualifier, elements, not );
		}
	
		// Complex selector, compare the two sets, removing non-Elements
		qualifier = jQuery.filter( qualifier, elements );
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not && elem.nodeType === 1;
		} );
	}
	
	jQuery.filter = function( expr, elems, not ) {
		var elem = elems[ 0 ];
	
		if ( not ) {
			expr = ":not(" + expr + ")";
		}
	
		if ( elems.length === 1 && elem.nodeType === 1 ) {
			return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
		}
	
		return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
	};
	
	jQuery.fn.extend( {
		find: function( selector ) {
			var i, ret,
				len = this.length,
				self = this;
	
			if ( typeof selector !== "string" ) {
				return this.pushStack( jQuery( selector ).filter( function() {
					for ( i = 0; i < len; i++ ) {
						if ( jQuery.contains( self[ i ], this ) ) {
							return true;
						}
					}
				} ) );
			}
	
			ret = this.pushStack( [] );
	
			for ( i = 0; i < len; i++ ) {
				jQuery.find( selector, self[ i ], ret );
			}
	
			return len > 1 ? jQuery.uniqueSort( ret ) : ret;
		},
		filter: function( selector ) {
			return this.pushStack( winnow( this, selector || [], false ) );
		},
		not: function( selector ) {
			return this.pushStack( winnow( this, selector || [], true ) );
		},
		is: function( selector ) {
			return !!winnow(
				this,
	
				// If this is a positional/relative selector, check membership in the returned set
				// so $("p:first").is("p:last") won't return true for a doc with two "p".
				typeof selector === "string" && rneedsContext.test( selector ) ?
					jQuery( selector ) :
					selector || [],
				false
			).length;
		}
	} );
	
	
	// Initialize a jQuery object
	
	
	// A central reference to the root jQuery(document)
	var rootjQuery,
	
		// A simple way to check for HTML strings
		// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
		// Strict HTML recognition (#11290: must start with <)
		// Shortcut simple #id case for speed
		rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
	
		init = jQuery.fn.init = function( selector, context, root ) {
			var match, elem;
	
			// HANDLE: $(""), $(null), $(undefined), $(false)
			if ( !selector ) {
				return this;
			}
	
			// Method init() accepts an alternate rootjQuery
			// so migrate can support jQuery.sub (gh-2101)
			root = root || rootjQuery;
	
			// Handle HTML strings
			if ( typeof selector === "string" ) {
				if ( selector[ 0 ] === "<" &&
					selector[ selector.length - 1 ] === ">" &&
					selector.length >= 3 ) {
	
					// Assume that strings that start and end with <> are HTML and skip the regex check
					match = [ null, selector, null ];
	
				} else {
					match = rquickExpr.exec( selector );
				}
	
				// Match html or make sure no context is specified for #id
				if ( match && ( match[ 1 ] || !context ) ) {
	
					// HANDLE: $(html) -> $(array)
					if ( match[ 1 ] ) {
						context = context instanceof jQuery ? context[ 0 ] : context;
	
						// Option to run scripts is true for back-compat
						// Intentionally let the error be thrown if parseHTML is not present
						jQuery.merge( this, jQuery.parseHTML(
							match[ 1 ],
							context && context.nodeType ? context.ownerDocument || context : document,
							true
						) );
	
						// HANDLE: $(html, props)
						if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
							for ( match in context ) {
	
								// Properties of context are called as methods if possible
								if ( jQuery.isFunction( this[ match ] ) ) {
									this[ match ]( context[ match ] );
	
								// ...and otherwise set as attributes
								} else {
									this.attr( match, context[ match ] );
								}
							}
						}
	
						return this;
	
					// HANDLE: $(#id)
					} else {
						elem = document.getElementById( match[ 2 ] );
	
						if ( elem ) {
	
							// Inject the element directly into the jQuery object
							this[ 0 ] = elem;
							this.length = 1;
						}
						return this;
					}
	
				// HANDLE: $(expr, $(...))
				} else if ( !context || context.jquery ) {
					return ( context || root ).find( selector );
	
				// HANDLE: $(expr, context)
				// (which is just equivalent to: $(context).find(expr)
				} else {
					return this.constructor( context ).find( selector );
				}
	
			// HANDLE: $(DOMElement)
			} else if ( selector.nodeType ) {
				this[ 0 ] = selector;
				this.length = 1;
				return this;
	
			// HANDLE: $(function)
			// Shortcut for document ready
			} else if ( jQuery.isFunction( selector ) ) {
				return root.ready !== undefined ?
					root.ready( selector ) :
	
					// Execute immediately if ready is not present
					selector( jQuery );
			}
	
			return jQuery.makeArray( selector, this );
		};
	
	// Give the init function the jQuery prototype for later instantiation
	init.prototype = jQuery.fn;
	
	// Initialize central reference
	rootjQuery = jQuery( document );
	
	
	var rparentsprev = /^(?:parents|prev(?:Until|All))/,
	
		// Methods guaranteed to produce a unique set when starting from a unique set
		guaranteedUnique = {
			children: true,
			contents: true,
			next: true,
			prev: true
		};
	
	jQuery.fn.extend( {
		has: function( target ) {
			var targets = jQuery( target, this ),
				l = targets.length;
	
			return this.filter( function() {
				var i = 0;
				for ( ; i < l; i++ ) {
					if ( jQuery.contains( this, targets[ i ] ) ) {
						return true;
					}
				}
			} );
		},
	
		closest: function( selectors, context ) {
			var cur,
				i = 0,
				l = this.length,
				matched = [],
				targets = typeof selectors !== "string" && jQuery( selectors );
	
			// Positional selectors never match, since there's no _selection_ context
			if ( !rneedsContext.test( selectors ) ) {
				for ( ; i < l; i++ ) {
					for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {
	
						// Always skip document fragments
						if ( cur.nodeType < 11 && ( targets ?
							targets.index( cur ) > -1 :
	
							// Don't pass non-elements to Sizzle
							cur.nodeType === 1 &&
								jQuery.find.matchesSelector( cur, selectors ) ) ) {
	
							matched.push( cur );
							break;
						}
					}
				}
			}
	
			return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
		},
	
		// Determine the position of an element within the set
		index: function( elem ) {
	
			// No argument, return index in parent
			if ( !elem ) {
				return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
			}
	
			// Index in selector
			if ( typeof elem === "string" ) {
				return indexOf.call( jQuery( elem ), this[ 0 ] );
			}
	
			// Locate the position of the desired element
			return indexOf.call( this,
	
				// If it receives a jQuery object, the first element is used
				elem.jquery ? elem[ 0 ] : elem
			);
		},
	
		add: function( selector, context ) {
			return this.pushStack(
				jQuery.uniqueSort(
					jQuery.merge( this.get(), jQuery( selector, context ) )
				)
			);
		},
	
		addBack: function( selector ) {
			return this.add( selector == null ?
				this.prevObject : this.prevObject.filter( selector )
			);
		}
	} );
	
	function sibling( cur, dir ) {
		while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
		return cur;
	}
	
	jQuery.each( {
		parent: function( elem ) {
			var parent = elem.parentNode;
			return parent && parent.nodeType !== 11 ? parent : null;
		},
		parents: function( elem ) {
			return dir( elem, "parentNode" );
		},
		parentsUntil: function( elem, i, until ) {
			return dir( elem, "parentNode", until );
		},
		next: function( elem ) {
			return sibling( elem, "nextSibling" );
		},
		prev: function( elem ) {
			return sibling( elem, "previousSibling" );
		},
		nextAll: function( elem ) {
			return dir( elem, "nextSibling" );
		},
		prevAll: function( elem ) {
			return dir( elem, "previousSibling" );
		},
		nextUntil: function( elem, i, until ) {
			return dir( elem, "nextSibling", until );
		},
		prevUntil: function( elem, i, until ) {
			return dir( elem, "previousSibling", until );
		},
		siblings: function( elem ) {
			return siblings( ( elem.parentNode || {} ).firstChild, elem );
		},
		children: function( elem ) {
			return siblings( elem.firstChild );
		},
		contents: function( elem ) {
			return elem.contentDocument || jQuery.merge( [], elem.childNodes );
		}
	}, function( name, fn ) {
		jQuery.fn[ name ] = function( until, selector ) {
			var matched = jQuery.map( this, fn, until );
	
			if ( name.slice( -5 ) !== "Until" ) {
				selector = until;
			}
	
			if ( selector && typeof selector === "string" ) {
				matched = jQuery.filter( selector, matched );
			}
	
			if ( this.length > 1 ) {
	
				// Remove duplicates
				if ( !guaranteedUnique[ name ] ) {
					jQuery.uniqueSort( matched );
				}
	
				// Reverse order for parents* and prev-derivatives
				if ( rparentsprev.test( name ) ) {
					matched.reverse();
				}
			}
	
			return this.pushStack( matched );
		};
	} );
	var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );
	
	
	
	// Convert String-formatted options into Object-formatted ones
	function createOptions( options ) {
		var object = {};
		jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
			object[ flag ] = true;
		} );
		return object;
	}
	
	/*
	 * Create a callback list using the following parameters:
	 *
	 *	options: an optional list of space-separated options that will change how
	 *			the callback list behaves or a more traditional option object
	 *
	 * By default a callback list will act like an event callback list and can be
	 * "fired" multiple times.
	 *
	 * Possible options:
	 *
	 *	once:			will ensure the callback list can only be fired once (like a Deferred)
	 *
	 *	memory:			will keep track of previous values and will call any callback added
	 *					after the list has been fired right away with the latest "memorized"
	 *					values (like a Deferred)
	 *
	 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
	 *
	 *	stopOnFalse:	interrupt callings when a callback returns false
	 *
	 */
	jQuery.Callbacks = function( options ) {
	
		// Convert options from String-formatted to Object-formatted if needed
		// (we check in cache first)
		options = typeof options === "string" ?
			createOptions( options ) :
			jQuery.extend( {}, options );
	
		var // Flag to know if list is currently firing
			firing,
	
			// Last fire value for non-forgettable lists
			memory,
	
			// Flag to know if list was already fired
			fired,
	
			// Flag to prevent firing
			locked,
	
			// Actual callback list
			list = [],
	
			// Queue of execution data for repeatable lists
			queue = [],
	
			// Index of currently firing callback (modified by add/remove as needed)
			firingIndex = -1,
	
			// Fire callbacks
			fire = function() {
	
				// Enforce single-firing
				locked = options.once;
	
				// Execute callbacks for all pending executions,
				// respecting firingIndex overrides and runtime changes
				fired = firing = true;
				for ( ; queue.length; firingIndex = -1 ) {
					memory = queue.shift();
					while ( ++firingIndex < list.length ) {
	
						// Run callback and check for early termination
						if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
							options.stopOnFalse ) {
	
							// Jump to end and forget the data so .add doesn't re-fire
							firingIndex = list.length;
							memory = false;
						}
					}
				}
	
				// Forget the data if we're done with it
				if ( !options.memory ) {
					memory = false;
				}
	
				firing = false;
	
				// Clean up if we're done firing for good
				if ( locked ) {
	
					// Keep an empty list if we have data for future add calls
					if ( memory ) {
						list = [];
	
					// Otherwise, this object is spent
					} else {
						list = "";
					}
				}
			},
	
			// Actual Callbacks object
			self = {
	
				// Add a callback or a collection of callbacks to the list
				add: function() {
					if ( list ) {
	
						// If we have memory from a past run, we should fire after adding
						if ( memory && !firing ) {
							firingIndex = list.length - 1;
							queue.push( memory );
						}
	
						( function add( args ) {
							jQuery.each( args, function( _, arg ) {
								if ( jQuery.isFunction( arg ) ) {
									if ( !options.unique || !self.has( arg ) ) {
										list.push( arg );
									}
								} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {
	
									// Inspect recursively
									add( arg );
								}
							} );
						} )( arguments );
	
						if ( memory && !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Remove a callback from the list
				remove: function() {
					jQuery.each( arguments, function( _, arg ) {
						var index;
						while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
							list.splice( index, 1 );
	
							// Handle firing indexes
							if ( index <= firingIndex ) {
								firingIndex--;
							}
						}
					} );
					return this;
				},
	
				// Check if a given callback is in the list.
				// If no argument is given, return whether or not list has callbacks attached.
				has: function( fn ) {
					return fn ?
						jQuery.inArray( fn, list ) > -1 :
						list.length > 0;
				},
	
				// Remove all callbacks from the list
				empty: function() {
					if ( list ) {
						list = [];
					}
					return this;
				},
	
				// Disable .fire and .add
				// Abort any current/pending executions
				// Clear all callbacks and values
				disable: function() {
					locked = queue = [];
					list = memory = "";
					return this;
				},
				disabled: function() {
					return !list;
				},
	
				// Disable .fire
				// Also disable .add unless we have memory (since it would have no effect)
				// Abort any pending executions
				lock: function() {
					locked = queue = [];
					if ( !memory && !firing ) {
						list = memory = "";
					}
					return this;
				},
				locked: function() {
					return !!locked;
				},
	
				// Call all callbacks with the given context and arguments
				fireWith: function( context, args ) {
					if ( !locked ) {
						args = args || [];
						args = [ context, args.slice ? args.slice() : args ];
						queue.push( args );
						if ( !firing ) {
							fire();
						}
					}
					return this;
				},
	
				// Call all the callbacks with the given arguments
				fire: function() {
					self.fireWith( this, arguments );
					return this;
				},
	
				// To know if the callbacks have already been called at least once
				fired: function() {
					return !!fired;
				}
			};
	
		return self;
	};
	
	
	function Identity( v ) {
		return v;
	}
	function Thrower( ex ) {
		throw ex;
	}
	
	function adoptValue( value, resolve, reject ) {
		var method;
	
		try {
	
			// Check for promise aspect first to privilege synchronous behavior
			if ( value && jQuery.isFunction( ( method = value.promise ) ) ) {
				method.call( value ).done( resolve ).fail( reject );
	
			// Other thenables
			} else if ( value && jQuery.isFunction( ( method = value.then ) ) ) {
				method.call( value, resolve, reject );
	
			// Other non-thenables
			} else {
	
				// Support: Android 4.0 only
				// Strict mode functions invoked without .call/.apply get global-object context
				resolve.call( undefined, value );
			}
	
		// For Promises/A+, convert exceptions into rejections
		// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
		// Deferred#then to conditionally suppress rejection.
		} catch ( value ) {
	
			// Support: Android 4.0 only
			// Strict mode functions invoked without .call/.apply get global-object context
			reject.call( undefined, value );
		}
	}
	
	jQuery.extend( {
	
		Deferred: function( func ) {
			var tuples = [
	
					// action, add listener, callbacks,
					// ... .then handlers, argument index, [final state]
					[ "notify", "progress", jQuery.Callbacks( "memory" ),
						jQuery.Callbacks( "memory" ), 2 ],
					[ "resolve", "done", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 0, "resolved" ],
					[ "reject", "fail", jQuery.Callbacks( "once memory" ),
						jQuery.Callbacks( "once memory" ), 1, "rejected" ]
				],
				state = "pending",
				promise = {
					state: function() {
						return state;
					},
					always: function() {
						deferred.done( arguments ).fail( arguments );
						return this;
					},
					"catch": function( fn ) {
						return promise.then( null, fn );
					},
	
					// Keep pipe for back-compat
					pipe: function( /* fnDone, fnFail, fnProgress */ ) {
						var fns = arguments;
	
						return jQuery.Deferred( function( newDefer ) {
							jQuery.each( tuples, function( i, tuple ) {
	
								// Map tuples (progress, done, fail) to arguments (done, fail, progress)
								var fn = jQuery.isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];
	
								// deferred.progress(function() { bind to newDefer or newDefer.notify })
								// deferred.done(function() { bind to newDefer or newDefer.resolve })
								// deferred.fail(function() { bind to newDefer or newDefer.reject })
								deferred[ tuple[ 1 ] ]( function() {
									var returned = fn && fn.apply( this, arguments );
									if ( returned && jQuery.isFunction( returned.promise ) ) {
										returned.promise()
											.progress( newDefer.notify )
											.done( newDefer.resolve )
											.fail( newDefer.reject );
									} else {
										newDefer[ tuple[ 0 ] + "With" ](
											this,
											fn ? [ returned ] : arguments
										);
									}
								} );
							} );
							fns = null;
						} ).promise();
					},
					then: function( onFulfilled, onRejected, onProgress ) {
						var maxDepth = 0;
						function resolve( depth, deferred, handler, special ) {
							return function() {
								var that = this,
									args = arguments,
									mightThrow = function() {
										var returned, then;
	
										// Support: Promises/A+ section 2.3.3.3.3
										// https://promisesaplus.com/#point-59
										// Ignore double-resolution attempts
										if ( depth < maxDepth ) {
											return;
										}
	
										returned = handler.apply( that, args );
	
										// Support: Promises/A+ section 2.3.1
										// https://promisesaplus.com/#point-48
										if ( returned === deferred.promise() ) {
											throw new TypeError( "Thenable self-resolution" );
										}
	
										// Support: Promises/A+ sections 2.3.3.1, 3.5
										// https://promisesaplus.com/#point-54
										// https://promisesaplus.com/#point-75
										// Retrieve `then` only once
										then = returned &&
	
											// Support: Promises/A+ section 2.3.4
											// https://promisesaplus.com/#point-64
											// Only check objects and functions for thenability
											( typeof returned === "object" ||
												typeof returned === "function" ) &&
											returned.then;
	
										// Handle a returned thenable
										if ( jQuery.isFunction( then ) ) {
	
											// Special processors (notify) just wait for resolution
											if ( special ) {
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special )
												);
	
											// Normal processors (resolve) also hook into progress
											} else {
	
												// ...and disregard older resolution values
												maxDepth++;
	
												then.call(
													returned,
													resolve( maxDepth, deferred, Identity, special ),
													resolve( maxDepth, deferred, Thrower, special ),
													resolve( maxDepth, deferred, Identity,
														deferred.notifyWith )
												);
											}
	
										// Handle all other returned values
										} else {
	
											// Only substitute handlers pass on context
											// and multiple values (non-spec behavior)
											if ( handler !== Identity ) {
												that = undefined;
												args = [ returned ];
											}
	
											// Process the value(s)
											// Default process is resolve
											( special || deferred.resolveWith )( that, args );
										}
									},
	
									// Only normal processors (resolve) catch and reject exceptions
									process = special ?
										mightThrow :
										function() {
											try {
												mightThrow();
											} catch ( e ) {
	
												if ( jQuery.Deferred.exceptionHook ) {
													jQuery.Deferred.exceptionHook( e,
														process.stackTrace );
												}
	
												// Support: Promises/A+ section 2.3.3.3.4.1
												// https://promisesaplus.com/#point-61
												// Ignore post-resolution exceptions
												if ( depth + 1 >= maxDepth ) {
	
													// Only substitute handlers pass on context
													// and multiple values (non-spec behavior)
													if ( handler !== Thrower ) {
														that = undefined;
														args = [ e ];
													}
	
													deferred.rejectWith( that, args );
												}
											}
										};
	
								// Support: Promises/A+ section 2.3.3.3.1
								// https://promisesaplus.com/#point-57
								// Re-resolve promises immediately to dodge false rejection from
								// subsequent errors
								if ( depth ) {
									process();
								} else {
	
									// Call an optional hook to record the stack, in case of exception
									// since it's otherwise lost when execution goes async
									if ( jQuery.Deferred.getStackHook ) {
										process.stackTrace = jQuery.Deferred.getStackHook();
									}
									window.setTimeout( process );
								}
							};
						}
	
						return jQuery.Deferred( function( newDefer ) {
	
							// progress_handlers.add( ... )
							tuples[ 0 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onProgress ) ?
										onProgress :
										Identity,
									newDefer.notifyWith
								)
							);
	
							// fulfilled_handlers.add( ... )
							tuples[ 1 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onFulfilled ) ?
										onFulfilled :
										Identity
								)
							);
	
							// rejected_handlers.add( ... )
							tuples[ 2 ][ 3 ].add(
								resolve(
									0,
									newDefer,
									jQuery.isFunction( onRejected ) ?
										onRejected :
										Thrower
								)
							);
						} ).promise();
					},
	
					// Get a promise for this deferred
					// If obj is provided, the promise aspect is added to the object
					promise: function( obj ) {
						return obj != null ? jQuery.extend( obj, promise ) : promise;
					}
				},
				deferred = {};
	
			// Add list-specific methods
			jQuery.each( tuples, function( i, tuple ) {
				var list = tuple[ 2 ],
					stateString = tuple[ 5 ];
	
				// promise.progress = list.add
				// promise.done = list.add
				// promise.fail = list.add
				promise[ tuple[ 1 ] ] = list.add;
	
				// Handle state
				if ( stateString ) {
					list.add(
						function() {
	
							// state = "resolved" (i.e., fulfilled)
							// state = "rejected"
							state = stateString;
						},
	
						// rejected_callbacks.disable
						// fulfilled_callbacks.disable
						tuples[ 3 - i ][ 2 ].disable,
	
						// progress_callbacks.lock
						tuples[ 0 ][ 2 ].lock
					);
				}
	
				// progress_handlers.fire
				// fulfilled_handlers.fire
				// rejected_handlers.fire
				list.add( tuple[ 3 ].fire );
	
				// deferred.notify = function() { deferred.notifyWith(...) }
				// deferred.resolve = function() { deferred.resolveWith(...) }
				// deferred.reject = function() { deferred.rejectWith(...) }
				deferred[ tuple[ 0 ] ] = function() {
					deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
					return this;
				};
	
				// deferred.notifyWith = list.fireWith
				// deferred.resolveWith = list.fireWith
				// deferred.rejectWith = list.fireWith
				deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
			} );
	
			// Make the deferred a promise
			promise.promise( deferred );
	
			// Call given func if any
			if ( func ) {
				func.call( deferred, deferred );
			}
	
			// All done!
			return deferred;
		},
	
		// Deferred helper
		when: function( singleValue ) {
			var
	
				// count of uncompleted subordinates
				remaining = arguments.length,
	
				// count of unprocessed arguments
				i = remaining,
	
				// subordinate fulfillment data
				resolveContexts = Array( i ),
				resolveValues = slice.call( arguments ),
	
				// the master Deferred
				master = jQuery.Deferred(),
	
				// subordinate callback factory
				updateFunc = function( i ) {
					return function( value ) {
						resolveContexts[ i ] = this;
						resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
						if ( !( --remaining ) ) {
							master.resolveWith( resolveContexts, resolveValues );
						}
					};
				};
	
			// Single- and empty arguments are adopted like Promise.resolve
			if ( remaining <= 1 ) {
				adoptValue( singleValue, master.done( updateFunc( i ) ).resolve, master.reject );
	
				// Use .then() to unwrap secondary thenables (cf. gh-3000)
				if ( master.state() === "pending" ||
					jQuery.isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {
	
					return master.then();
				}
			}
	
			// Multiple arguments are aggregated like Promise.all array elements
			while ( i-- ) {
				adoptValue( resolveValues[ i ], updateFunc( i ), master.reject );
			}
	
			return master.promise();
		}
	} );
	
	
	// These usually indicate a programmer mistake during development,
	// warn about them ASAP rather than swallowing them by default.
	var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
	
	jQuery.Deferred.exceptionHook = function( error, stack ) {
	
		// Support: IE 8 - 9 only
		// Console exists when dev tools are open, which can happen at any time
		if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
			window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
		}
	};
	
	
	
	
	jQuery.readyException = function( error ) {
		window.setTimeout( function() {
			throw error;
		} );
	};
	
	
	
	
	// The deferred used on DOM ready
	var readyList = jQuery.Deferred();
	
	jQuery.fn.ready = function( fn ) {
	
		readyList
			.then( fn )
	
			// Wrap jQuery.readyException in a function so that the lookup
			// happens at the time of error handling instead of callback
			// registration.
			.catch( function( error ) {
				jQuery.readyException( error );
			} );
	
		return this;
	};
	
	jQuery.extend( {
	
		// Is the DOM ready to be used? Set to true once it occurs.
		isReady: false,
	
		// A counter to track how many items to wait for before
		// the ready event fires. See #6781
		readyWait: 1,
	
		// Hold (or release) the ready event
		holdReady: function( hold ) {
			if ( hold ) {
				jQuery.readyWait++;
			} else {
				jQuery.ready( true );
			}
		},
	
		// Handle when the DOM is ready
		ready: function( wait ) {
	
			// Abort if there are pending holds or we're already ready
			if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
				return;
			}
	
			// Remember that the DOM is ready
			jQuery.isReady = true;
	
			// If a normal DOM Ready event fired, decrement, and wait if need be
			if ( wait !== true && --jQuery.readyWait > 0 ) {
				return;
			}
	
			// If there are functions bound, to execute
			readyList.resolveWith( document, [ jQuery ] );
		}
	} );
	
	jQuery.ready.then = readyList.then;
	
	// The ready event handler and self cleanup method
	function completed() {
		document.removeEventListener( "DOMContentLoaded", completed );
		window.removeEventListener( "load", completed );
		jQuery.ready();
	}
	
	// Catch cases where $(document).ready() is called
	// after the browser event has already occurred.
	// Support: IE <=9 - 10 only
	// Older IE sometimes signals "interactive" too soon
	if ( document.readyState === "complete" ||
		( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {
	
		// Handle it asynchronously to allow scripts the opportunity to delay ready
		window.setTimeout( jQuery.ready );
	
	} else {
	
		// Use the handy event callback
		document.addEventListener( "DOMContentLoaded", completed );
	
		// A fallback to window.onload, that will always work
		window.addEventListener( "load", completed );
	}
	
	
	
	
	// Multifunctional method to get and set values of a collection
	// The value/s can optionally be executed if it's a function
	var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
		var i = 0,
			len = elems.length,
			bulk = key == null;
	
		// Sets many values
		if ( jQuery.type( key ) === "object" ) {
			chainable = true;
			for ( i in key ) {
				access( elems, fn, i, key[ i ], true, emptyGet, raw );
			}
	
		// Sets one value
		} else if ( value !== undefined ) {
			chainable = true;
	
			if ( !jQuery.isFunction( value ) ) {
				raw = true;
			}
	
			if ( bulk ) {
	
				// Bulk operations run against the entire set
				if ( raw ) {
					fn.call( elems, value );
					fn = null;
	
				// ...except when executing function values
				} else {
					bulk = fn;
					fn = function( elem, key, value ) {
						return bulk.call( jQuery( elem ), value );
					};
				}
			}
	
			if ( fn ) {
				for ( ; i < len; i++ ) {
					fn(
						elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
					);
				}
			}
		}
	
		if ( chainable ) {
			return elems;
		}
	
		// Gets
		if ( bulk ) {
			return fn.call( elems );
		}
	
		return len ? fn( elems[ 0 ], key ) : emptyGet;
	};
	var acceptData = function( owner ) {
	
		// Accepts only:
		//  - Node
		//    - Node.ELEMENT_NODE
		//    - Node.DOCUMENT_NODE
		//  - Object
		//    - Any
		return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
	};
	
	
	
	
	function Data() {
		this.expando = jQuery.expando + Data.uid++;
	}
	
	Data.uid = 1;
	
	Data.prototype = {
	
		cache: function( owner ) {
	
			// Check if the owner object already has a cache
			var value = owner[ this.expando ];
	
			// If not, create one
			if ( !value ) {
				value = {};
	
				// We can accept data for non-element nodes in modern browsers,
				// but we should not, see #8335.
				// Always return an empty object.
				if ( acceptData( owner ) ) {
	
					// If it is a node unlikely to be stringify-ed or looped over
					// use plain assignment
					if ( owner.nodeType ) {
						owner[ this.expando ] = value;
	
					// Otherwise secure it in a non-enumerable property
					// configurable must be true to allow the property to be
					// deleted when data is removed
					} else {
						Object.defineProperty( owner, this.expando, {
							value: value,
							configurable: true
						} );
					}
				}
			}
	
			return value;
		},
		set: function( owner, data, value ) {
			var prop,
				cache = this.cache( owner );
	
			// Handle: [ owner, key, value ] args
			// Always use camelCase key (gh-2257)
			if ( typeof data === "string" ) {
				cache[ jQuery.camelCase( data ) ] = value;
	
			// Handle: [ owner, { properties } ] args
			} else {
	
				// Copy the properties one-by-one to the cache object
				for ( prop in data ) {
					cache[ jQuery.camelCase( prop ) ] = data[ prop ];
				}
			}
			return cache;
		},
		get: function( owner, key ) {
			return key === undefined ?
				this.cache( owner ) :
	
				// Always use camelCase key (gh-2257)
				owner[ this.expando ] && owner[ this.expando ][ jQuery.camelCase( key ) ];
		},
		access: function( owner, key, value ) {
	
			// In cases where either:
			//
			//   1. No key was specified
			//   2. A string key was specified, but no value provided
			//
			// Take the "read" path and allow the get method to determine
			// which value to return, respectively either:
			//
			//   1. The entire cache object
			//   2. The data stored at the key
			//
			if ( key === undefined ||
					( ( key && typeof key === "string" ) && value === undefined ) ) {
	
				return this.get( owner, key );
			}
	
			// When the key is not a string, or both a key and value
			// are specified, set or extend (existing objects) with either:
			//
			//   1. An object of properties
			//   2. A key and value
			//
			this.set( owner, key, value );
	
			// Since the "set" path can have two possible entry points
			// return the expected data based on which path was taken[*]
			return value !== undefined ? value : key;
		},
		remove: function( owner, key ) {
			var i,
				cache = owner[ this.expando ];
	
			if ( cache === undefined ) {
				return;
			}
	
			if ( key !== undefined ) {
	
				// Support array or space separated string of keys
				if ( jQuery.isArray( key ) ) {
	
					// If key is an array of keys...
					// We always set camelCase keys, so remove that.
					key = key.map( jQuery.camelCase );
				} else {
					key = jQuery.camelCase( key );
	
					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					key = key in cache ?
						[ key ] :
						( key.match( rnothtmlwhite ) || [] );
				}
	
				i = key.length;
	
				while ( i-- ) {
					delete cache[ key[ i ] ];
				}
			}
	
			// Remove the expando if there's no more data
			if ( key === undefined || jQuery.isEmptyObject( cache ) ) {
	
				// Support: Chrome <=35 - 45
				// Webkit & Blink performance suffers when deleting properties
				// from DOM nodes, so set to undefined instead
				// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
				if ( owner.nodeType ) {
					owner[ this.expando ] = undefined;
				} else {
					delete owner[ this.expando ];
				}
			}
		},
		hasData: function( owner ) {
			var cache = owner[ this.expando ];
			return cache !== undefined && !jQuery.isEmptyObject( cache );
		}
	};
	var dataPriv = new Data();
	
	var dataUser = new Data();
	
	
	
	//	Implementation Summary
	//
	//	1. Enforce API surface and semantic compatibility with 1.9.x branch
	//	2. Improve the module's maintainability by reducing the storage
	//		paths to a single mechanism.
	//	3. Use the same single mechanism to support "private" and "user" data.
	//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
	//	5. Avoid exposing implementation details on user objects (eg. expando properties)
	//	6. Provide a clear path for implementation upgrade to WeakMap in 2014
	
	var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
		rmultiDash = /[A-Z]/g;
	
	function getData( data ) {
		if ( data === "true" ) {
			return true;
		}
	
		if ( data === "false" ) {
			return false;
		}
	
		if ( data === "null" ) {
			return null;
		}
	
		// Only convert to a number if it doesn't change the string
		if ( data === +data + "" ) {
			return +data;
		}
	
		if ( rbrace.test( data ) ) {
			return JSON.parse( data );
		}
	
		return data;
	}
	
	function dataAttr( elem, key, data ) {
		var name;
	
		// If nothing was found internally, try to fetch any
		// data from the HTML5 data-* attribute
		if ( data === undefined && elem.nodeType === 1 ) {
			name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
			data = elem.getAttribute( name );
	
			if ( typeof data === "string" ) {
				try {
					data = getData( data );
				} catch ( e ) {}
	
				// Make sure we set the data so it isn't changed later
				dataUser.set( elem, key, data );
			} else {
				data = undefined;
			}
		}
		return data;
	}
	
	jQuery.extend( {
		hasData: function( elem ) {
			return dataUser.hasData( elem ) || dataPriv.hasData( elem );
		},
	
		data: function( elem, name, data ) {
			return dataUser.access( elem, name, data );
		},
	
		removeData: function( elem, name ) {
			dataUser.remove( elem, name );
		},
	
		// TODO: Now that all calls to _data and _removeData have been replaced
		// with direct calls to dataPriv methods, these can be deprecated.
		_data: function( elem, name, data ) {
			return dataPriv.access( elem, name, data );
		},
	
		_removeData: function( elem, name ) {
			dataPriv.remove( elem, name );
		}
	} );
	
	jQuery.fn.extend( {
		data: function( key, value ) {
			var i, name, data,
				elem = this[ 0 ],
				attrs = elem && elem.attributes;
	
			// Gets all values
			if ( key === undefined ) {
				if ( this.length ) {
					data = dataUser.get( elem );
	
					if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
						i = attrs.length;
						while ( i-- ) {
	
							// Support: IE 11 only
							// The attrs elements can be null (#14894)
							if ( attrs[ i ] ) {
								name = attrs[ i ].name;
								if ( name.indexOf( "data-" ) === 0 ) {
									name = jQuery.camelCase( name.slice( 5 ) );
									dataAttr( elem, name, data[ name ] );
								}
							}
						}
						dataPriv.set( elem, "hasDataAttrs", true );
					}
				}
	
				return data;
			}
	
			// Sets multiple values
			if ( typeof key === "object" ) {
				return this.each( function() {
					dataUser.set( this, key );
				} );
			}
	
			return access( this, function( value ) {
				var data;
	
				// The calling jQuery object (element matches) is not empty
				// (and therefore has an element appears at this[ 0 ]) and the
				// `value` parameter was not undefined. An empty jQuery object
				// will result in `undefined` for elem = this[ 0 ] which will
				// throw an exception if an attempt to read a data cache is made.
				if ( elem && value === undefined ) {
	
					// Attempt to get data from the cache
					// The key will always be camelCased in Data
					data = dataUser.get( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// Attempt to "discover" the data in
					// HTML5 custom data-* attrs
					data = dataAttr( elem, key );
					if ( data !== undefined ) {
						return data;
					}
	
					// We tried really hard, but the data doesn't exist.
					return;
				}
	
				// Set the data...
				this.each( function() {
	
					// We always store the camelCased key
					dataUser.set( this, key, value );
				} );
			}, null, value, arguments.length > 1, null, true );
		},
	
		removeData: function( key ) {
			return this.each( function() {
				dataUser.remove( this, key );
			} );
		}
	} );
	
	
	jQuery.extend( {
		queue: function( elem, type, data ) {
			var queue;
	
			if ( elem ) {
				type = ( type || "fx" ) + "queue";
				queue = dataPriv.get( elem, type );
	
				// Speed up dequeue by getting out quickly if this is just a lookup
				if ( data ) {
					if ( !queue || jQuery.isArray( data ) ) {
						queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
					} else {
						queue.push( data );
					}
				}
				return queue || [];
			}
		},
	
		dequeue: function( elem, type ) {
			type = type || "fx";
	
			var queue = jQuery.queue( elem, type ),
				startLength = queue.length,
				fn = queue.shift(),
				hooks = jQuery._queueHooks( elem, type ),
				next = function() {
					jQuery.dequeue( elem, type );
				};
	
			// If the fx queue is dequeued, always remove the progress sentinel
			if ( fn === "inprogress" ) {
				fn = queue.shift();
				startLength--;
			}
	
			if ( fn ) {
	
				// Add a progress sentinel to prevent the fx queue from being
				// automatically dequeued
				if ( type === "fx" ) {
					queue.unshift( "inprogress" );
				}
	
				// Clear up the last queue stop function
				delete hooks.stop;
				fn.call( elem, next, hooks );
			}
	
			if ( !startLength && hooks ) {
				hooks.empty.fire();
			}
		},
	
		// Not public - generate a queueHooks object, or return the current one
		_queueHooks: function( elem, type ) {
			var key = type + "queueHooks";
			return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
				empty: jQuery.Callbacks( "once memory" ).add( function() {
					dataPriv.remove( elem, [ type + "queue", key ] );
				} )
			} );
		}
	} );
	
	jQuery.fn.extend( {
		queue: function( type, data ) {
			var setter = 2;
	
			if ( typeof type !== "string" ) {
				data = type;
				type = "fx";
				setter--;
			}
	
			if ( arguments.length < setter ) {
				return jQuery.queue( this[ 0 ], type );
			}
	
			return data === undefined ?
				this :
				this.each( function() {
					var queue = jQuery.queue( this, type, data );
	
					// Ensure a hooks for this queue
					jQuery._queueHooks( this, type );
	
					if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
						jQuery.dequeue( this, type );
					}
				} );
		},
		dequeue: function( type ) {
			return this.each( function() {
				jQuery.dequeue( this, type );
			} );
		},
		clearQueue: function( type ) {
			return this.queue( type || "fx", [] );
		},
	
		// Get a promise resolved when queues of a certain type
		// are emptied (fx is the type by default)
		promise: function( type, obj ) {
			var tmp,
				count = 1,
				defer = jQuery.Deferred(),
				elements = this,
				i = this.length,
				resolve = function() {
					if ( !( --count ) ) {
						defer.resolveWith( elements, [ elements ] );
					}
				};
	
			if ( typeof type !== "string" ) {
				obj = type;
				type = undefined;
			}
			type = type || "fx";
	
			while ( i-- ) {
				tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
				if ( tmp && tmp.empty ) {
					count++;
					tmp.empty.add( resolve );
				}
			}
			resolve();
			return defer.promise( obj );
		}
	} );
	var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;
	
	var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );
	
	
	var cssExpand = [ "Top", "Right", "Bottom", "Left" ];
	
	var isHiddenWithinTree = function( elem, el ) {
	
			// isHiddenWithinTree might be called from jQuery#filter function;
			// in that case, element will be second argument
			elem = el || elem;
	
			// Inline style trumps all
			return elem.style.display === "none" ||
				elem.style.display === "" &&
	
				// Otherwise, check computed style
				// Support: Firefox <=43 - 45
				// Disconnected elements can have computed display: none, so first confirm that elem is
				// in the document.
				jQuery.contains( elem.ownerDocument, elem ) &&
	
				jQuery.css( elem, "display" ) === "none";
		};
	
	var swap = function( elem, options, callback, args ) {
		var ret, name,
			old = {};
	
		// Remember the old values, and insert the new ones
		for ( name in options ) {
			old[ name ] = elem.style[ name ];
			elem.style[ name ] = options[ name ];
		}
	
		ret = callback.apply( elem, args || [] );
	
		// Revert the old values
		for ( name in options ) {
			elem.style[ name ] = old[ name ];
		}
	
		return ret;
	};
	
	
	
	
	function adjustCSS( elem, prop, valueParts, tween ) {
		var adjusted,
			scale = 1,
			maxIterations = 20,
			currentValue = tween ?
				function() {
					return tween.cur();
				} :
				function() {
					return jQuery.css( elem, prop, "" );
				},
			initial = currentValue(),
			unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),
	
			// Starting value computation is required for potential unit mismatches
			initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
				rcssNum.exec( jQuery.css( elem, prop ) );
	
		if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {
	
			// Trust units reported by jQuery.css
			unit = unit || initialInUnit[ 3 ];
	
			// Make sure we update the tween properties later on
			valueParts = valueParts || [];
	
			// Iteratively approximate from a nonzero starting point
			initialInUnit = +initial || 1;
	
			do {
	
				// If previous iteration zeroed out, double until we get *something*.
				// Use string for doubling so we don't accidentally see scale as unchanged below
				scale = scale || ".5";
	
				// Adjust and apply
				initialInUnit = initialInUnit / scale;
				jQuery.style( elem, prop, initialInUnit + unit );
	
			// Update scale, tolerating zero or NaN from tween.cur()
			// Break the loop if scale is unchanged or perfect, or if we've just had enough.
			} while (
				scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
			);
		}
	
		if ( valueParts ) {
			initialInUnit = +initialInUnit || +initial || 0;
	
			// Apply relative offset (+=/-=) if specified
			adjusted = valueParts[ 1 ] ?
				initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
				+valueParts[ 2 ];
			if ( tween ) {
				tween.unit = unit;
				tween.start = initialInUnit;
				tween.end = adjusted;
			}
		}
		return adjusted;
	}
	
	
	var defaultDisplayMap = {};
	
	function getDefaultDisplay( elem ) {
		var temp,
			doc = elem.ownerDocument,
			nodeName = elem.nodeName,
			display = defaultDisplayMap[ nodeName ];
	
		if ( display ) {
			return display;
		}
	
		temp = doc.body.appendChild( doc.createElement( nodeName ) );
		display = jQuery.css( temp, "display" );
	
		temp.parentNode.removeChild( temp );
	
		if ( display === "none" ) {
			display = "block";
		}
		defaultDisplayMap[ nodeName ] = display;
	
		return display;
	}
	
	function showHide( elements, show ) {
		var display, elem,
			values = [],
			index = 0,
			length = elements.length;
	
		// Determine new display value for elements that need to change
		for ( ; index < length; index++ ) {
			elem = elements[ index ];
			if ( !elem.style ) {
				continue;
			}
	
			display = elem.style.display;
			if ( show ) {
	
				// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
				// check is required in this first loop unless we have a nonempty display value (either
				// inline or about-to-be-restored)
				if ( display === "none" ) {
					values[ index ] = dataPriv.get( elem, "display" ) || null;
					if ( !values[ index ] ) {
						elem.style.display = "";
					}
				}
				if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
					values[ index ] = getDefaultDisplay( elem );
				}
			} else {
				if ( display !== "none" ) {
					values[ index ] = "none";
	
					// Remember what we're overwriting
					dataPriv.set( elem, "display", display );
				}
			}
		}
	
		// Set the display of the elements in a second loop to avoid constant reflow
		for ( index = 0; index < length; index++ ) {
			if ( values[ index ] != null ) {
				elements[ index ].style.display = values[ index ];
			}
		}
	
		return elements;
	}
	
	jQuery.fn.extend( {
		show: function() {
			return showHide( this, true );
		},
		hide: function() {
			return showHide( this );
		},
		toggle: function( state ) {
			if ( typeof state === "boolean" ) {
				return state ? this.show() : this.hide();
			}
	
			return this.each( function() {
				if ( isHiddenWithinTree( this ) ) {
					jQuery( this ).show();
				} else {
					jQuery( this ).hide();
				}
			} );
		}
	} );
	var rcheckableType = ( /^(?:checkbox|radio)$/i );
	
	var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]+)/i );
	
	var rscriptType = ( /^$|\/(?:java|ecma)script/i );
	
	
	
	// We have to close these tags to support XHTML (#13200)
	var wrapMap = {
	
		// Support: IE <=9 only
		option: [ 1, "<select multiple='multiple'>", "</select>" ],
	
		// XHTML parsers do not magically insert elements in the
		// same way that tag soup parsers do. So we cannot shorten
		// this by omitting <tbody> or other required elements.
		thead: [ 1, "<table>", "</table>" ],
		col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
		tr: [ 2, "<table><tbody>", "</tbody></table>" ],
		td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],
	
		_default: [ 0, "", "" ]
	};
	
	// Support: IE <=9 only
	wrapMap.optgroup = wrapMap.option;
	
	wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
	wrapMap.th = wrapMap.td;
	
	
	function getAll( context, tag ) {
	
		// Support: IE <=9 - 11 only
		// Use typeof to avoid zero-argument method invocation on host objects (#15151)
		var ret;
	
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			ret = context.getElementsByTagName( tag || "*" );
	
		} else if ( typeof context.querySelectorAll !== "undefined" ) {
			ret = context.querySelectorAll( tag || "*" );
	
		} else {
			ret = [];
		}
	
		if ( tag === undefined || tag && jQuery.nodeName( context, tag ) ) {
			return jQuery.merge( [ context ], ret );
		}
	
		return ret;
	}
	
	
	// Mark scripts as having already been evaluated
	function setGlobalEval( elems, refElements ) {
		var i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			dataPriv.set(
				elems[ i ],
				"globalEval",
				!refElements || dataPriv.get( refElements[ i ], "globalEval" )
			);
		}
	}
	
	
	var rhtml = /<|&#?\w+;/;
	
	function buildFragment( elems, context, scripts, selection, ignored ) {
		var elem, tmp, tag, wrap, contains, j,
			fragment = context.createDocumentFragment(),
			nodes = [],
			i = 0,
			l = elems.length;
	
		for ( ; i < l; i++ ) {
			elem = elems[ i ];
	
			if ( elem || elem === 0 ) {
	
				// Add nodes directly
				if ( jQuery.type( elem ) === "object" ) {
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );
	
				// Convert non-html into a text node
				} else if ( !rhtml.test( elem ) ) {
					nodes.push( context.createTextNode( elem ) );
	
				// Convert html into DOM nodes
				} else {
					tmp = tmp || fragment.appendChild( context.createElement( "div" ) );
	
					// Deserialize a standard representation
					tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
					wrap = wrapMap[ tag ] || wrapMap._default;
					tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];
	
					// Descend through wrappers to the right content
					j = wrap[ 0 ];
					while ( j-- ) {
						tmp = tmp.lastChild;
					}
	
					// Support: Android <=4.0 only, PhantomJS 1 only
					// push.apply(_, arraylike) throws on ancient WebKit
					jQuery.merge( nodes, tmp.childNodes );
	
					// Remember the top-level container
					tmp = fragment.firstChild;
	
					// Ensure the created nodes are orphaned (#12392)
					tmp.textContent = "";
				}
			}
		}
	
		// Remove wrapper from fragment
		fragment.textContent = "";
	
		i = 0;
		while ( ( elem = nodes[ i++ ] ) ) {
	
			// Skip elements already in the context collection (trac-4087)
			if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
				if ( ignored ) {
					ignored.push( elem );
				}
				continue;
			}
	
			contains = jQuery.contains( elem.ownerDocument, elem );
	
			// Append to fragment
			tmp = getAll( fragment.appendChild( elem ), "script" );
	
			// Preserve script evaluation history
			if ( contains ) {
				setGlobalEval( tmp );
			}
	
			// Capture executables
			if ( scripts ) {
				j = 0;
				while ( ( elem = tmp[ j++ ] ) ) {
					if ( rscriptType.test( elem.type || "" ) ) {
						scripts.push( elem );
					}
				}
			}
		}
	
		return fragment;
	}
	
	
	( function() {
		var fragment = document.createDocumentFragment(),
			div = fragment.appendChild( document.createElement( "div" ) ),
			input = document.createElement( "input" );
	
		// Support: Android 4.0 - 4.3 only
		// Check state lost if the name is set (#11217)
		// Support: Windows Web Apps (WWA)
		// `name` and `type` must use .setAttribute for WWA (#14901)
		input.setAttribute( "type", "radio" );
		input.setAttribute( "checked", "checked" );
		input.setAttribute( "name", "t" );
	
		div.appendChild( input );
	
		// Support: Android <=4.1 only
		// Older WebKit doesn't clone checked state correctly in fragments
		support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;
	
		// Support: IE <=11 only
		// Make sure textarea (and checkbox) defaultValue is properly cloned
		div.innerHTML = "<textarea>x</textarea>";
		support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
	} )();
	var documentElement = document.documentElement;
	
	
	
	var
		rkeyEvent = /^key/,
		rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
		rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
	
	function returnTrue() {
		return true;
	}
	
	function returnFalse() {
		return false;
	}
	
	// Support: IE <=9 only
	// See #13393 for more info
	function safeActiveElement() {
		try {
			return document.activeElement;
		} catch ( err ) { }
	}
	
	function on( elem, types, selector, data, fn, one ) {
		var origFn, type;
	
		// Types can be a map of types/handlers
		if ( typeof types === "object" ) {
	
			// ( types-Object, selector, data )
			if ( typeof selector !== "string" ) {
	
				// ( types-Object, data )
				data = data || selector;
				selector = undefined;
			}
			for ( type in types ) {
				on( elem, type, selector, data, types[ type ], one );
			}
			return elem;
		}
	
		if ( data == null && fn == null ) {
	
			// ( types, fn )
			fn = selector;
			data = selector = undefined;
		} else if ( fn == null ) {
			if ( typeof selector === "string" ) {
	
				// ( types, selector, fn )
				fn = data;
				data = undefined;
			} else {
	
				// ( types, data, fn )
				fn = data;
				data = selector;
				selector = undefined;
			}
		}
		if ( fn === false ) {
			fn = returnFalse;
		} else if ( !fn ) {
			return elem;
		}
	
		if ( one === 1 ) {
			origFn = fn;
			fn = function( event ) {
	
				// Can use an empty set, since event contains the info
				jQuery().off( event );
				return origFn.apply( this, arguments );
			};
	
			// Use same guid so caller can remove using origFn
			fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
		}
		return elem.each( function() {
			jQuery.event.add( this, types, fn, data, selector );
		} );
	}
	
	/*
	 * Helper functions for managing events -- not part of the public interface.
	 * Props to Dean Edwards' addEvent library for many of the ideas.
	 */
	jQuery.event = {
	
		global: {},
	
		add: function( elem, types, handler, data, selector ) {
	
			var handleObjIn, eventHandle, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.get( elem );
	
			// Don't attach events to noData or text/comment nodes (but allow plain objects)
			if ( !elemData ) {
				return;
			}
	
			// Caller can pass in an object of custom data in lieu of the handler
			if ( handler.handler ) {
				handleObjIn = handler;
				handler = handleObjIn.handler;
				selector = handleObjIn.selector;
			}
	
			// Ensure that invalid selectors throw exceptions at attach time
			// Evaluate against documentElement in case elem is a non-element node (e.g., document)
			if ( selector ) {
				jQuery.find.matchesSelector( documentElement, selector );
			}
	
			// Make sure that the handler has a unique ID, used to find/remove it later
			if ( !handler.guid ) {
				handler.guid = jQuery.guid++;
			}
	
			// Init the element's event structure and main handler, if this is the first
			if ( !( events = elemData.events ) ) {
				events = elemData.events = {};
			}
			if ( !( eventHandle = elemData.handle ) ) {
				eventHandle = elemData.handle = function( e ) {
	
					// Discard the second event of a jQuery.event.trigger() and
					// when an event is called after a page has unloaded
					return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
						jQuery.event.dispatch.apply( elem, arguments ) : undefined;
				};
			}
	
			// Handle multiple events separated by a space
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// There *must* be a type, no attaching namespace-only handlers
				if ( !type ) {
					continue;
				}
	
				// If event changes its type, use the special event handlers for the changed type
				special = jQuery.event.special[ type ] || {};
	
				// If selector defined, determine special event api type, otherwise given type
				type = ( selector ? special.delegateType : special.bindType ) || type;
	
				// Update special based on newly reset type
				special = jQuery.event.special[ type ] || {};
	
				// handleObj is passed to all event handlers
				handleObj = jQuery.extend( {
					type: type,
					origType: origType,
					data: data,
					handler: handler,
					guid: handler.guid,
					selector: selector,
					needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
					namespace: namespaces.join( "." )
				}, handleObjIn );
	
				// Init the event handler queue if we're the first
				if ( !( handlers = events[ type ] ) ) {
					handlers = events[ type ] = [];
					handlers.delegateCount = 0;
	
					// Only use addEventListener if the special events handler returns false
					if ( !special.setup ||
						special.setup.call( elem, data, namespaces, eventHandle ) === false ) {
	
						if ( elem.addEventListener ) {
							elem.addEventListener( type, eventHandle );
						}
					}
				}
	
				if ( special.add ) {
					special.add.call( elem, handleObj );
	
					if ( !handleObj.handler.guid ) {
						handleObj.handler.guid = handler.guid;
					}
				}
	
				// Add to the element's handler list, delegates in front
				if ( selector ) {
					handlers.splice( handlers.delegateCount++, 0, handleObj );
				} else {
					handlers.push( handleObj );
				}
	
				// Keep track of which events have ever been used, for event optimization
				jQuery.event.global[ type ] = true;
			}
	
		},
	
		// Detach an event or set of events from an element
		remove: function( elem, types, handler, selector, mappedTypes ) {
	
			var j, origCount, tmp,
				events, t, handleObj,
				special, handlers, type, namespaces, origType,
				elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );
	
			if ( !elemData || !( events = elemData.events ) ) {
				return;
			}
	
			// Once for each type.namespace in types; type may be omitted
			types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
			t = types.length;
			while ( t-- ) {
				tmp = rtypenamespace.exec( types[ t ] ) || [];
				type = origType = tmp[ 1 ];
				namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();
	
				// Unbind all events (on this namespace, if provided) for the element
				if ( !type ) {
					for ( type in events ) {
						jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
					}
					continue;
				}
	
				special = jQuery.event.special[ type ] || {};
				type = ( selector ? special.delegateType : special.bindType ) || type;
				handlers = events[ type ] || [];
				tmp = tmp[ 2 ] &&
					new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );
	
				// Remove matching events
				origCount = j = handlers.length;
				while ( j-- ) {
					handleObj = handlers[ j ];
	
					if ( ( mappedTypes || origType === handleObj.origType ) &&
						( !handler || handler.guid === handleObj.guid ) &&
						( !tmp || tmp.test( handleObj.namespace ) ) &&
						( !selector || selector === handleObj.selector ||
							selector === "**" && handleObj.selector ) ) {
						handlers.splice( j, 1 );
	
						if ( handleObj.selector ) {
							handlers.delegateCount--;
						}
						if ( special.remove ) {
							special.remove.call( elem, handleObj );
						}
					}
				}
	
				// Remove generic event handler if we removed something and no more handlers exist
				// (avoids potential for endless recursion during removal of special event handlers)
				if ( origCount && !handlers.length ) {
					if ( !special.teardown ||
						special.teardown.call( elem, namespaces, elemData.handle ) === false ) {
	
						jQuery.removeEvent( elem, type, elemData.handle );
					}
	
					delete events[ type ];
				}
			}
	
			// Remove data and the expando if it's no longer used
			if ( jQuery.isEmptyObject( events ) ) {
				dataPriv.remove( elem, "handle events" );
			}
		},
	
		dispatch: function( nativeEvent ) {
	
			// Make a writable jQuery.Event from the native event object
			var event = jQuery.event.fix( nativeEvent );
	
			var i, j, ret, matched, handleObj, handlerQueue,
				args = new Array( arguments.length ),
				handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
				special = jQuery.event.special[ event.type ] || {};
	
			// Use the fix-ed jQuery.Event rather than the (read-only) native event
			args[ 0 ] = event;
	
			for ( i = 1; i < arguments.length; i++ ) {
				args[ i ] = arguments[ i ];
			}
	
			event.delegateTarget = this;
	
			// Call the preDispatch hook for the mapped type, and let it bail if desired
			if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
				return;
			}
	
			// Determine handlers
			handlerQueue = jQuery.event.handlers.call( this, event, handlers );
	
			// Run delegates first; they may want to stop propagation beneath us
			i = 0;
			while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
				event.currentTarget = matched.elem;
	
				j = 0;
				while ( ( handleObj = matched.handlers[ j++ ] ) &&
					!event.isImmediatePropagationStopped() ) {
	
					// Triggered event must either 1) have no namespace, or 2) have namespace(s)
					// a subset or equal to those in the bound event (both can have no namespace).
					if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {
	
						event.handleObj = handleObj;
						event.data = handleObj.data;
	
						ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
							handleObj.handler ).apply( matched.elem, args );
	
						if ( ret !== undefined ) {
							if ( ( event.result = ret ) === false ) {
								event.preventDefault();
								event.stopPropagation();
							}
						}
					}
				}
			}
	
			// Call the postDispatch hook for the mapped type
			if ( special.postDispatch ) {
				special.postDispatch.call( this, event );
			}
	
			return event.result;
		},
	
		handlers: function( event, handlers ) {
			var i, handleObj, sel, matchedHandlers, matchedSelectors,
				handlerQueue = [],
				delegateCount = handlers.delegateCount,
				cur = event.target;
	
			// Find delegate handlers
			if ( delegateCount &&
	
				// Support: IE <=9
				// Black-hole SVG <use> instance trees (trac-13180)
				cur.nodeType &&
	
				// Support: Firefox <=42
				// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
				// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
				// Support: IE 11 only
				// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
				!( event.type === "click" && event.button >= 1 ) ) {
	
				for ( ; cur !== this; cur = cur.parentNode || this ) {
	
					// Don't check non-elements (#13208)
					// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
					if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
						matchedHandlers = [];
						matchedSelectors = {};
						for ( i = 0; i < delegateCount; i++ ) {
							handleObj = handlers[ i ];
	
							// Don't conflict with Object.prototype properties (#13203)
							sel = handleObj.selector + " ";
	
							if ( matchedSelectors[ sel ] === undefined ) {
								matchedSelectors[ sel ] = handleObj.needsContext ?
									jQuery( sel, this ).index( cur ) > -1 :
									jQuery.find( sel, this, null, [ cur ] ).length;
							}
							if ( matchedSelectors[ sel ] ) {
								matchedHandlers.push( handleObj );
							}
						}
						if ( matchedHandlers.length ) {
							handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
						}
					}
				}
			}
	
			// Add the remaining (directly-bound) handlers
			cur = this;
			if ( delegateCount < handlers.length ) {
				handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
			}
	
			return handlerQueue;
		},
	
		addProp: function( name, hook ) {
			Object.defineProperty( jQuery.Event.prototype, name, {
				enumerable: true,
				configurable: true,
	
				get: jQuery.isFunction( hook ) ?
					function() {
						if ( this.originalEvent ) {
								return hook( this.originalEvent );
						}
					} :
					function() {
						if ( this.originalEvent ) {
								return this.originalEvent[ name ];
						}
					},
	
				set: function( value ) {
					Object.defineProperty( this, name, {
						enumerable: true,
						configurable: true,
						writable: true,
						value: value
					} );
				}
			} );
		},
	
		fix: function( originalEvent ) {
			return originalEvent[ jQuery.expando ] ?
				originalEvent :
				new jQuery.Event( originalEvent );
		},
	
		special: {
			load: {
	
				// Prevent triggered image.load events from bubbling to window.load
				noBubble: true
			},
			focus: {
	
				// Fire native event if possible so blur/focus sequence is correct
				trigger: function() {
					if ( this !== safeActiveElement() && this.focus ) {
						this.focus();
						return false;
					}
				},
				delegateType: "focusin"
			},
			blur: {
				trigger: function() {
					if ( this === safeActiveElement() && this.blur ) {
						this.blur();
						return false;
					}
				},
				delegateType: "focusout"
			},
			click: {
	
				// For checkbox, fire native event so checked state will be right
				trigger: function() {
					if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
						this.click();
						return false;
					}
				},
	
				// For cross-browser consistency, don't fire native .click() on links
				_default: function( event ) {
					return jQuery.nodeName( event.target, "a" );
				}
			},
	
			beforeunload: {
				postDispatch: function( event ) {
	
					// Support: Firefox 20+
					// Firefox doesn't alert if the returnValue field is not set.
					if ( event.result !== undefined && event.originalEvent ) {
						event.originalEvent.returnValue = event.result;
					}
				}
			}
		}
	};
	
	jQuery.removeEvent = function( elem, type, handle ) {
	
		// This "if" is needed for plain objects
		if ( elem.removeEventListener ) {
			elem.removeEventListener( type, handle );
		}
	};
	
	jQuery.Event = function( src, props ) {
	
		// Allow instantiation without the 'new' keyword
		if ( !( this instanceof jQuery.Event ) ) {
			return new jQuery.Event( src, props );
		}
	
		// Event object
		if ( src && src.type ) {
			this.originalEvent = src;
			this.type = src.type;
	
			// Events bubbling up the document may have been marked as prevented
			// by a handler lower down the tree; reflect the correct value.
			this.isDefaultPrevented = src.defaultPrevented ||
					src.defaultPrevented === undefined &&
	
					// Support: Android <=2.3 only
					src.returnValue === false ?
				returnTrue :
				returnFalse;
	
			// Create target properties
			// Support: Safari <=6 - 7 only
			// Target should not be a text node (#504, #13143)
			this.target = ( src.target && src.target.nodeType === 3 ) ?
				src.target.parentNode :
				src.target;
	
			this.currentTarget = src.currentTarget;
			this.relatedTarget = src.relatedTarget;
	
		// Event type
		} else {
			this.type = src;
		}
	
		// Put explicitly provided properties onto the event object
		if ( props ) {
			jQuery.extend( this, props );
		}
	
		// Create a timestamp if incoming event doesn't have one
		this.timeStamp = src && src.timeStamp || jQuery.now();
	
		// Mark it as fixed
		this[ jQuery.expando ] = true;
	};
	
	// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
	// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
	jQuery.Event.prototype = {
		constructor: jQuery.Event,
		isDefaultPrevented: returnFalse,
		isPropagationStopped: returnFalse,
		isImmediatePropagationStopped: returnFalse,
		isSimulated: false,
	
		preventDefault: function() {
			var e = this.originalEvent;
	
			this.isDefaultPrevented = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.preventDefault();
			}
		},
		stopPropagation: function() {
			var e = this.originalEvent;
	
			this.isPropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopPropagation();
			}
		},
		stopImmediatePropagation: function() {
			var e = this.originalEvent;
	
			this.isImmediatePropagationStopped = returnTrue;
	
			if ( e && !this.isSimulated ) {
				e.stopImmediatePropagation();
			}
	
			this.stopPropagation();
		}
	};
	
	// Includes all common event props including KeyEvent and MouseEvent specific props
	jQuery.each( {
		altKey: true,
		bubbles: true,
		cancelable: true,
		changedTouches: true,
		ctrlKey: true,
		detail: true,
		eventPhase: true,
		metaKey: true,
		pageX: true,
		pageY: true,
		shiftKey: true,
		view: true,
		"char": true,
		charCode: true,
		key: true,
		keyCode: true,
		button: true,
		buttons: true,
		clientX: true,
		clientY: true,
		offsetX: true,
		offsetY: true,
		pointerId: true,
		pointerType: true,
		screenX: true,
		screenY: true,
		targetTouches: true,
		toElement: true,
		touches: true,
	
		which: function( event ) {
			var button = event.button;
	
			// Add which for key events
			if ( event.which == null && rkeyEvent.test( event.type ) ) {
				return event.charCode != null ? event.charCode : event.keyCode;
			}
	
			// Add which for click: 1 === left; 2 === middle; 3 === right
			if ( !event.which && button !== undefined && rmouseEvent.test( event.type ) ) {
				if ( button & 1 ) {
					return 1;
				}
	
				if ( button & 2 ) {
					return 3;
				}
	
				if ( button & 4 ) {
					return 2;
				}
	
				return 0;
			}
	
			return event.which;
		}
	}, jQuery.event.addProp );
	
	// Create mouseenter/leave events using mouseover/out and event-time checks
	// so that event delegation works in jQuery.
	// Do the same for pointerenter/pointerleave and pointerover/pointerout
	//
	// Support: Safari 7 only
	// Safari sends mouseenter too often; see:
	// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
	// for the description of the bug (it existed in older Chrome versions as well).
	jQuery.each( {
		mouseenter: "mouseover",
		mouseleave: "mouseout",
		pointerenter: "pointerover",
		pointerleave: "pointerout"
	}, function( orig, fix ) {
		jQuery.event.special[ orig ] = {
			delegateType: fix,
			bindType: fix,
	
			handle: function( event ) {
				var ret,
					target = this,
					related = event.relatedTarget,
					handleObj = event.handleObj;
	
				// For mouseenter/leave call the handler if related is outside the target.
				// NB: No relatedTarget if the mouse left/entered the browser window
				if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
					event.type = handleObj.origType;
					ret = handleObj.handler.apply( this, arguments );
					event.type = fix;
				}
				return ret;
			}
		};
	} );
	
	jQuery.fn.extend( {
	
		on: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn );
		},
		one: function( types, selector, data, fn ) {
			return on( this, types, selector, data, fn, 1 );
		},
		off: function( types, selector, fn ) {
			var handleObj, type;
			if ( types && types.preventDefault && types.handleObj ) {
	
				// ( event )  dispatched jQuery.Event
				handleObj = types.handleObj;
				jQuery( types.delegateTarget ).off(
					handleObj.namespace ?
						handleObj.origType + "." + handleObj.namespace :
						handleObj.origType,
					handleObj.selector,
					handleObj.handler
				);
				return this;
			}
			if ( typeof types === "object" ) {
	
				// ( types-object [, selector] )
				for ( type in types ) {
					this.off( type, selector, types[ type ] );
				}
				return this;
			}
			if ( selector === false || typeof selector === "function" ) {
	
				// ( types [, fn] )
				fn = selector;
				selector = undefined;
			}
			if ( fn === false ) {
				fn = returnFalse;
			}
			return this.each( function() {
				jQuery.event.remove( this, types, fn, selector );
			} );
		}
	} );
	
	
	var
	
		/* eslint-disable max-len */
	
		// See https://github.com/eslint/eslint/issues/3229
		rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi,
	
		/* eslint-enable */
	
		// Support: IE <=10 - 11, Edge 12 - 13
		// In IE/Edge using regex groups here causes severe slowdowns.
		// See https://connect.microsoft.com/IE/feedback/details/1736512/
		rnoInnerhtml = /<script|<style|<link/i,
	
		// checked="checked" or checked
		rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
		rscriptTypeMasked = /^true\/(.*)/,
		rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
	
	function manipulationTarget( elem, content ) {
		if ( jQuery.nodeName( elem, "table" ) &&
			jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {
	
			return elem.getElementsByTagName( "tbody" )[ 0 ] || elem;
		}
	
		return elem;
	}
	
	// Replace/restore the type attribute of script elements for safe DOM manipulation
	function disableScript( elem ) {
		elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
		return elem;
	}
	function restoreScript( elem ) {
		var match = rscriptTypeMasked.exec( elem.type );
	
		if ( match ) {
			elem.type = match[ 1 ];
		} else {
			elem.removeAttribute( "type" );
		}
	
		return elem;
	}
	
	function cloneCopyEvent( src, dest ) {
		var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
	
		if ( dest.nodeType !== 1 ) {
			return;
		}
	
		// 1. Copy private data: events, handlers, etc.
		if ( dataPriv.hasData( src ) ) {
			pdataOld = dataPriv.access( src );
			pdataCur = dataPriv.set( dest, pdataOld );
			events = pdataOld.events;
	
			if ( events ) {
				delete pdataCur.handle;
				pdataCur.events = {};
	
				for ( type in events ) {
					for ( i = 0, l = events[ type ].length; i < l; i++ ) {
						jQuery.event.add( dest, type, events[ type ][ i ] );
					}
				}
			}
		}
	
		// 2. Copy user data
		if ( dataUser.hasData( src ) ) {
			udataOld = dataUser.access( src );
			udataCur = jQuery.extend( {}, udataOld );
	
			dataUser.set( dest, udataCur );
		}
	}
	
	// Fix IE bugs, see support tests
	function fixInput( src, dest ) {
		var nodeName = dest.nodeName.toLowerCase();
	
		// Fails to persist the checked state of a cloned checkbox or radio button.
		if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
			dest.checked = src.checked;
	
		// Fails to return the selected option to the default selected state when cloning options
		} else if ( nodeName === "input" || nodeName === "textarea" ) {
			dest.defaultValue = src.defaultValue;
		}
	}
	
	function domManip( collection, args, callback, ignored ) {
	
		// Flatten any nested arrays
		args = concat.apply( [], args );
	
		var fragment, first, scripts, hasScripts, node, doc,
			i = 0,
			l = collection.length,
			iNoClone = l - 1,
			value = args[ 0 ],
			isFunction = jQuery.isFunction( value );
	
		// We can't cloneNode fragments that contain checked, in WebKit
		if ( isFunction ||
				( l > 1 && typeof value === "string" &&
					!support.checkClone && rchecked.test( value ) ) ) {
			return collection.each( function( index ) {
				var self = collection.eq( index );
				if ( isFunction ) {
					args[ 0 ] = value.call( this, index, self.html() );
				}
				domManip( self, args, callback, ignored );
			} );
		}
	
		if ( l ) {
			fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
			first = fragment.firstChild;
	
			if ( fragment.childNodes.length === 1 ) {
				fragment = first;
			}
	
			// Require either new content or an interest in ignored elements to invoke the callback
			if ( first || ignored ) {
				scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
				hasScripts = scripts.length;
	
				// Use the original fragment for the last item
				// instead of the first because it can end up
				// being emptied incorrectly in certain situations (#8070).
				for ( ; i < l; i++ ) {
					node = fragment;
	
					if ( i !== iNoClone ) {
						node = jQuery.clone( node, true, true );
	
						// Keep references to cloned scripts for later restoration
						if ( hasScripts ) {
	
							// Support: Android <=4.0 only, PhantomJS 1 only
							// push.apply(_, arraylike) throws on ancient WebKit
							jQuery.merge( scripts, getAll( node, "script" ) );
						}
					}
	
					callback.call( collection[ i ], node, i );
				}
	
				if ( hasScripts ) {
					doc = scripts[ scripts.length - 1 ].ownerDocument;
	
					// Reenable scripts
					jQuery.map( scripts, restoreScript );
	
					// Evaluate executable scripts on first document insertion
					for ( i = 0; i < hasScripts; i++ ) {
						node = scripts[ i ];
						if ( rscriptType.test( node.type || "" ) &&
							!dataPriv.access( node, "globalEval" ) &&
							jQuery.contains( doc, node ) ) {
	
							if ( node.src ) {
	
								// Optional AJAX dependency, but won't run scripts if not present
								if ( jQuery._evalUrl ) {
									jQuery._evalUrl( node.src );
								}
							} else {
								DOMEval( node.textContent.replace( rcleanScript, "" ), doc );
							}
						}
					}
				}
			}
		}
	
		return collection;
	}
	
	function remove( elem, selector, keepData ) {
		var node,
			nodes = selector ? jQuery.filter( selector, elem ) : elem,
			i = 0;
	
		for ( ; ( node = nodes[ i ] ) != null; i++ ) {
			if ( !keepData && node.nodeType === 1 ) {
				jQuery.cleanData( getAll( node ) );
			}
	
			if ( node.parentNode ) {
				if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
					setGlobalEval( getAll( node, "script" ) );
				}
				node.parentNode.removeChild( node );
			}
		}
	
		return elem;
	}
	
	jQuery.extend( {
		htmlPrefilter: function( html ) {
			return html.replace( rxhtmlTag, "<$1></$2>" );
		},
	
		clone: function( elem, dataAndEvents, deepDataAndEvents ) {
			var i, l, srcElements, destElements,
				clone = elem.cloneNode( true ),
				inPage = jQuery.contains( elem.ownerDocument, elem );
	
			// Fix IE cloning issues
			if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
					!jQuery.isXMLDoc( elem ) ) {
	
				// We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
				destElements = getAll( clone );
				srcElements = getAll( elem );
	
				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					fixInput( srcElements[ i ], destElements[ i ] );
				}
			}
	
			// Copy the events from the original to the clone
			if ( dataAndEvents ) {
				if ( deepDataAndEvents ) {
					srcElements = srcElements || getAll( elem );
					destElements = destElements || getAll( clone );
	
					for ( i = 0, l = srcElements.length; i < l; i++ ) {
						cloneCopyEvent( srcElements[ i ], destElements[ i ] );
					}
				} else {
					cloneCopyEvent( elem, clone );
				}
			}
	
			// Preserve script evaluation history
			destElements = getAll( clone, "script" );
			if ( destElements.length > 0 ) {
				setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
			}
	
			// Return the cloned set
			return clone;
		},
	
		cleanData: function( elems ) {
			var data, elem, type,
				special = jQuery.event.special,
				i = 0;
	
			for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
				if ( acceptData( elem ) ) {
					if ( ( data = elem[ dataPriv.expando ] ) ) {
						if ( data.events ) {
							for ( type in data.events ) {
								if ( special[ type ] ) {
									jQuery.event.remove( elem, type );
	
								// This is a shortcut to avoid jQuery.event.remove's overhead
								} else {
									jQuery.removeEvent( elem, type, data.handle );
								}
							}
						}
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataPriv.expando ] = undefined;
					}
					if ( elem[ dataUser.expando ] ) {
	
						// Support: Chrome <=35 - 45+
						// Assign undefined instead of using delete, see Data#remove
						elem[ dataUser.expando ] = undefined;
					}
				}
			}
		}
	} );
	
	jQuery.fn.extend( {
		detach: function( selector ) {
			return remove( this, selector, true );
		},
	
		remove: function( selector ) {
			return remove( this, selector );
		},
	
		text: function( value ) {
			return access( this, function( value ) {
				return value === undefined ?
					jQuery.text( this ) :
					this.empty().each( function() {
						if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
							this.textContent = value;
						}
					} );
			}, null, value, arguments.length );
		},
	
		append: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.appendChild( elem );
				}
			} );
		},
	
		prepend: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
					var target = manipulationTarget( this, elem );
					target.insertBefore( elem, target.firstChild );
				}
			} );
		},
	
		before: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this );
				}
			} );
		},
	
		after: function() {
			return domManip( this, arguments, function( elem ) {
				if ( this.parentNode ) {
					this.parentNode.insertBefore( elem, this.nextSibling );
				}
			} );
		},
	
		empty: function() {
			var elem,
				i = 0;
	
			for ( ; ( elem = this[ i ] ) != null; i++ ) {
				if ( elem.nodeType === 1 ) {
	
					// Prevent memory leaks
					jQuery.cleanData( getAll( elem, false ) );
	
					// Remove any remaining nodes
					elem.textContent = "";
				}
			}
	
			return this;
		},
	
		clone: function( dataAndEvents, deepDataAndEvents ) {
			dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
			deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
	
			return this.map( function() {
				return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
			} );
		},
	
		html: function( value ) {
			return access( this, function( value ) {
				var elem = this[ 0 ] || {},
					i = 0,
					l = this.length;
	
				if ( value === undefined && elem.nodeType === 1 ) {
					return elem.innerHTML;
				}
	
				// See if we can take a shortcut and just use innerHTML
				if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
					!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {
	
					value = jQuery.htmlPrefilter( value );
	
					try {
						for ( ; i < l; i++ ) {
							elem = this[ i ] || {};
	
							// Remove element nodes and prevent memory leaks
							if ( elem.nodeType === 1 ) {
								jQuery.cleanData( getAll( elem, false ) );
								elem.innerHTML = value;
							}
						}
	
						elem = 0;
	
					// If using innerHTML throws an exception, use the fallback method
					} catch ( e ) {}
				}
	
				if ( elem ) {
					this.empty().append( value );
				}
			}, null, value, arguments.length );
		},
	
		replaceWith: function() {
			var ignored = [];
	
			// Make the changes, replacing each non-ignored context element with the new content
			return domManip( this, arguments, function( elem ) {
				var parent = this.parentNode;
	
				if ( jQuery.inArray( this, ignored ) < 0 ) {
					jQuery.cleanData( getAll( this ) );
					if ( parent ) {
						parent.replaceChild( elem, this );
					}
				}
	
			// Force callback invocation
			}, ignored );
		}
	} );
	
	jQuery.each( {
		appendTo: "append",
		prependTo: "prepend",
		insertBefore: "before",
		insertAfter: "after",
		replaceAll: "replaceWith"
	}, function( name, original ) {
		jQuery.fn[ name ] = function( selector ) {
			var elems,
				ret = [],
				insert = jQuery( selector ),
				last = insert.length - 1,
				i = 0;
	
			for ( ; i <= last; i++ ) {
				elems = i === last ? this : this.clone( true );
				jQuery( insert[ i ] )[ original ]( elems );
	
				// Support: Android <=4.0 only, PhantomJS 1 only
				// .get() because push.apply(_, arraylike) throws on ancient WebKit
				push.apply( ret, elems.get() );
			}
	
			return this.pushStack( ret );
		};
	} );
	var rmargin = ( /^margin/ );
	
	var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );
	
	var getStyles = function( elem ) {
	
			// Support: IE <=11 only, Firefox <=30 (#15098, #14150)
			// IE throws on elements created in popups
			// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
			var view = elem.ownerDocument.defaultView;
	
			if ( !view || !view.opener ) {
				view = window;
			}
	
			return view.getComputedStyle( elem );
		};
	
	
	
	( function() {
	
		// Executing both pixelPosition & boxSizingReliable tests require only one layout
		// so they're executed at the same time to save the second computation.
		function computeStyleTests() {
	
			// This is a singleton, we need to execute it only once
			if ( !div ) {
				return;
			}
	
			div.style.cssText =
				"box-sizing:border-box;" +
				"position:relative;display:block;" +
				"margin:auto;border:1px;padding:1px;" +
				"top:1%;width:50%";
			div.innerHTML = "";
			documentElement.appendChild( container );
	
			var divStyle = window.getComputedStyle( div );
			pixelPositionVal = divStyle.top !== "1%";
	
			// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
			reliableMarginLeftVal = divStyle.marginLeft === "2px";
			boxSizingReliableVal = divStyle.width === "4px";
	
			// Support: Android 4.0 - 4.3 only
			// Some styles come back with percentage values, even though they shouldn't
			div.style.marginRight = "50%";
			pixelMarginRightVal = divStyle.marginRight === "4px";
	
			documentElement.removeChild( container );
	
			// Nullify the div so it wouldn't be stored in the memory and
			// it will also be a sign that checks already performed
			div = null;
		}
	
		var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
			container = document.createElement( "div" ),
			div = document.createElement( "div" );
	
		// Finish early in limited (non-browser) environments
		if ( !div.style ) {
			return;
		}
	
		// Support: IE <=9 - 11 only
		// Style of cloned element affects source element cloned (#8908)
		div.style.backgroundClip = "content-box";
		div.cloneNode( true ).style.backgroundClip = "";
		support.clearCloneStyle = div.style.backgroundClip === "content-box";
	
		container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
			"padding:0;margin-top:1px;position:absolute";
		container.appendChild( div );
	
		jQuery.extend( support, {
			pixelPosition: function() {
				computeStyleTests();
				return pixelPositionVal;
			},
			boxSizingReliable: function() {
				computeStyleTests();
				return boxSizingReliableVal;
			},
			pixelMarginRight: function() {
				computeStyleTests();
				return pixelMarginRightVal;
			},
			reliableMarginLeft: function() {
				computeStyleTests();
				return reliableMarginLeftVal;
			}
		} );
	} )();
	
	
	function curCSS( elem, name, computed ) {
		var width, minWidth, maxWidth, ret,
			style = elem.style;
	
		computed = computed || getStyles( elem );
	
		// Support: IE <=9 only
		// getPropertyValue is only needed for .css('filter') (#12537)
		if ( computed ) {
			ret = computed.getPropertyValue( name ) || computed[ name ];
	
			if ( ret === "" && !jQuery.contains( elem.ownerDocument, elem ) ) {
				ret = jQuery.style( elem, name );
			}
	
			// A tribute to the "awesome hack by Dean Edwards"
			// Android Browser returns percentage for some values,
			// but width seems to be reliably pixels.
			// This is against the CSSOM draft spec:
			// https://drafts.csswg.org/cssom/#resolved-values
			if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {
	
				// Remember the original values
				width = style.width;
				minWidth = style.minWidth;
				maxWidth = style.maxWidth;
	
				// Put in the new values to get a computed value out
				style.minWidth = style.maxWidth = style.width = ret;
				ret = computed.width;
	
				// Revert the changed values
				style.width = width;
				style.minWidth = minWidth;
				style.maxWidth = maxWidth;
			}
		}
	
		return ret !== undefined ?
	
			// Support: IE <=9 - 11 only
			// IE returns zIndex value as an integer.
			ret + "" :
			ret;
	}
	
	
	function addGetHookIf( conditionFn, hookFn ) {
	
		// Define the hook, we'll check on the first run if it's really needed.
		return {
			get: function() {
				if ( conditionFn() ) {
	
					// Hook not needed (or it's not possible to use it due
					// to missing dependency), remove it.
					delete this.get;
					return;
				}
	
				// Hook needed; redefine it so that the support test is not executed again.
				return ( this.get = hookFn ).apply( this, arguments );
			}
		};
	}
	
	
	var
	
		// Swappable if display is none or starts with table
		// except "table", "table-cell", or "table-caption"
		// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
		rdisplayswap = /^(none|table(?!-c[ea]).+)/,
		cssShow = { position: "absolute", visibility: "hidden", display: "block" },
		cssNormalTransform = {
			letterSpacing: "0",
			fontWeight: "400"
		},
	
		cssPrefixes = [ "Webkit", "Moz", "ms" ],
		emptyStyle = document.createElement( "div" ).style;
	
	// Return a css property mapped to a potentially vendor prefixed property
	function vendorPropName( name ) {
	
		// Shortcut for names that are not vendor prefixed
		if ( name in emptyStyle ) {
			return name;
		}
	
		// Check for vendor prefixed names
		var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
			i = cssPrefixes.length;
	
		while ( i-- ) {
			name = cssPrefixes[ i ] + capName;
			if ( name in emptyStyle ) {
				return name;
			}
		}
	}
	
	function setPositiveNumber( elem, value, subtract ) {
	
		// Any relative (+/-) values have already been
		// normalized at this point
		var matches = rcssNum.exec( value );
		return matches ?
	
			// Guard against undefined "subtract", e.g., when used as in cssHooks
			Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
			value;
	}
	
	function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
		var i,
			val = 0;
	
		// If we already have the right measurement, avoid augmentation
		if ( extra === ( isBorderBox ? "border" : "content" ) ) {
			i = 4;
	
		// Otherwise initialize for horizontal or vertical properties
		} else {
			i = name === "width" ? 1 : 0;
		}
	
		for ( ; i < 4; i += 2 ) {
	
			// Both box models exclude margin, so add it if we want it
			if ( extra === "margin" ) {
				val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
			}
	
			if ( isBorderBox ) {
	
				// border-box includes padding, so remove it if we want content
				if ( extra === "content" ) {
					val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
				}
	
				// At this point, extra isn't border nor margin, so remove border
				if ( extra !== "margin" ) {
					val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			} else {
	
				// At this point, extra isn't content, so add padding
				val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
	
				// At this point, extra isn't content nor padding, so add border
				if ( extra !== "padding" ) {
					val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
				}
			}
		}
	
		return val;
	}
	
	function getWidthOrHeight( elem, name, extra ) {
	
		// Start with offset property, which is equivalent to the border-box value
		var val,
			valueIsBorderBox = true,
			styles = getStyles( elem ),
			isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";
	
		// Support: IE <=11 only
		// Running getBoundingClientRect on a disconnected node
		// in IE throws an error.
		if ( elem.getClientRects().length ) {
			val = elem.getBoundingClientRect()[ name ];
		}
	
		// Some non-html elements return undefined for offsetWidth, so check for null/undefined
		// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
		// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
		if ( val <= 0 || val == null ) {
	
			// Fall back to computed then uncomputed css if necessary
			val = curCSS( elem, name, styles );
			if ( val < 0 || val == null ) {
				val = elem.style[ name ];
			}
	
			// Computed unit is not pixels. Stop here and return.
			if ( rnumnonpx.test( val ) ) {
				return val;
			}
	
			// Check for style in case a browser which returns unreliable values
			// for getComputedStyle silently falls back to the reliable elem.style
			valueIsBorderBox = isBorderBox &&
				( support.boxSizingReliable() || val === elem.style[ name ] );
	
			// Normalize "", auto, and prepare for extra
			val = parseFloat( val ) || 0;
		}
	
		// Use the active box-sizing model to add/subtract irrelevant styles
		return ( val +
			augmentWidthOrHeight(
				elem,
				name,
				extra || ( isBorderBox ? "border" : "content" ),
				valueIsBorderBox,
				styles
			)
		) + "px";
	}
	
	jQuery.extend( {
	
		// Add in style property hooks for overriding the default
		// behavior of getting and setting a style property
		cssHooks: {
			opacity: {
				get: function( elem, computed ) {
					if ( computed ) {
	
						// We should always get a number back from opacity
						var ret = curCSS( elem, "opacity" );
						return ret === "" ? "1" : ret;
					}
				}
			}
		},
	
		// Don't automatically add "px" to these possibly-unitless properties
		cssNumber: {
			"animationIterationCount": true,
			"columnCount": true,
			"fillOpacity": true,
			"flexGrow": true,
			"flexShrink": true,
			"fontWeight": true,
			"lineHeight": true,
			"opacity": true,
			"order": true,
			"orphans": true,
			"widows": true,
			"zIndex": true,
			"zoom": true
		},
	
		// Add in properties whose names you wish to fix before
		// setting or getting the value
		cssProps: {
			"float": "cssFloat"
		},
	
		// Get and set the style property on a DOM Node
		style: function( elem, name, value, extra ) {
	
			// Don't set styles on text and comment nodes
			if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
				return;
			}
	
			// Make sure that we're working with the right name
			var ret, type, hooks,
				origName = jQuery.camelCase( name ),
				style = elem.style;
	
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// Gets hook for the prefixed version, then unprefixed version
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// Check if we're setting a value
			if ( value !== undefined ) {
				type = typeof value;
	
				// Convert "+=" or "-=" to relative numbers (#7345)
				if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
					value = adjustCSS( elem, name, ret );
	
					// Fixes bug #9237
					type = "number";
				}
	
				// Make sure that null and NaN values aren't set (#7116)
				if ( value == null || value !== value ) {
					return;
				}
	
				// If a number was passed in, add the unit (except for certain CSS properties)
				if ( type === "number" ) {
					value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
				}
	
				// background-* props affect original clone's values
				if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
					style[ name ] = "inherit";
				}
	
				// If a hook was provided, use that value, otherwise just set the specified value
				if ( !hooks || !( "set" in hooks ) ||
					( value = hooks.set( elem, value, extra ) ) !== undefined ) {
	
					style[ name ] = value;
				}
	
			} else {
	
				// If a hook was provided get the non-computed value from there
				if ( hooks && "get" in hooks &&
					( ret = hooks.get( elem, false, extra ) ) !== undefined ) {
	
					return ret;
				}
	
				// Otherwise just get the value from the style object
				return style[ name ];
			}
		},
	
		css: function( elem, name, extra, styles ) {
			var val, num, hooks,
				origName = jQuery.camelCase( name );
	
			// Make sure that we're working with the right name
			name = jQuery.cssProps[ origName ] ||
				( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );
	
			// Try prefixed name followed by the unprefixed name
			hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];
	
			// If a hook was provided get the computed value from there
			if ( hooks && "get" in hooks ) {
				val = hooks.get( elem, true, extra );
			}
	
			// Otherwise, if a way to get the computed value exists, use that
			if ( val === undefined ) {
				val = curCSS( elem, name, styles );
			}
	
			// Convert "normal" to computed value
			if ( val === "normal" && name in cssNormalTransform ) {
				val = cssNormalTransform[ name ];
			}
	
			// Make numeric if forced or a qualifier was provided and val looks numeric
			if ( extra === "" || extra ) {
				num = parseFloat( val );
				return extra === true || isFinite( num ) ? num || 0 : val;
			}
			return val;
		}
	} );
	
	jQuery.each( [ "height", "width" ], function( i, name ) {
		jQuery.cssHooks[ name ] = {
			get: function( elem, computed, extra ) {
				if ( computed ) {
	
					// Certain elements can have dimension info if we invisibly show them
					// but it must have a current display style that would benefit
					return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
	
						// Support: Safari 8+
						// Table columns in Safari have non-zero offsetWidth & zero
						// getBoundingClientRect().width unless display is changed.
						// Support: IE <=11 only
						// Running getBoundingClientRect on a disconnected node
						// in IE throws an error.
						( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
							swap( elem, cssShow, function() {
								return getWidthOrHeight( elem, name, extra );
							} ) :
							getWidthOrHeight( elem, name, extra );
				}
			},
	
			set: function( elem, value, extra ) {
				var matches,
					styles = extra && getStyles( elem ),
					subtract = extra && augmentWidthOrHeight(
						elem,
						name,
						extra,
						jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
						styles
					);
	
				// Convert to pixels if value adjustment is needed
				if ( subtract && ( matches = rcssNum.exec( value ) ) &&
					( matches[ 3 ] || "px" ) !== "px" ) {
	
					elem.style[ name ] = value;
					value = jQuery.css( elem, name );
				}
	
				return setPositiveNumber( elem, value, subtract );
			}
		};
	} );
	
	jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
		function( elem, computed ) {
			if ( computed ) {
				return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
					elem.getBoundingClientRect().left -
						swap( elem, { marginLeft: 0 }, function() {
							return elem.getBoundingClientRect().left;
						} )
					) + "px";
			}
		}
	);
	
	// These hooks are used by animate to expand properties
	jQuery.each( {
		margin: "",
		padding: "",
		border: "Width"
	}, function( prefix, suffix ) {
		jQuery.cssHooks[ prefix + suffix ] = {
			expand: function( value ) {
				var i = 0,
					expanded = {},
	
					// Assumes a single number if not a string
					parts = typeof value === "string" ? value.split( " " ) : [ value ];
	
				for ( ; i < 4; i++ ) {
					expanded[ prefix + cssExpand[ i ] + suffix ] =
						parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
				}
	
				return expanded;
			}
		};
	
		if ( !rmargin.test( prefix ) ) {
			jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
		}
	} );
	
	jQuery.fn.extend( {
		css: function( name, value ) {
			return access( this, function( elem, name, value ) {
				var styles, len,
					map = {},
					i = 0;
	
				if ( jQuery.isArray( name ) ) {
					styles = getStyles( elem );
					len = name.length;
	
					for ( ; i < len; i++ ) {
						map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
					}
	
					return map;
				}
	
				return value !== undefined ?
					jQuery.style( elem, name, value ) :
					jQuery.css( elem, name );
			}, name, value, arguments.length > 1 );
		}
	} );
	
	
	function Tween( elem, options, prop, end, easing ) {
		return new Tween.prototype.init( elem, options, prop, end, easing );
	}
	jQuery.Tween = Tween;
	
	Tween.prototype = {
		constructor: Tween,
		init: function( elem, options, prop, end, easing, unit ) {
			this.elem = elem;
			this.prop = prop;
			this.easing = easing || jQuery.easing._default;
			this.options = options;
			this.start = this.now = this.cur();
			this.end = end;
			this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
		},
		cur: function() {
			var hooks = Tween.propHooks[ this.prop ];
	
			return hooks && hooks.get ?
				hooks.get( this ) :
				Tween.propHooks._default.get( this );
		},
		run: function( percent ) {
			var eased,
				hooks = Tween.propHooks[ this.prop ];
	
			if ( this.options.duration ) {
				this.pos = eased = jQuery.easing[ this.easing ](
					percent, this.options.duration * percent, 0, 1, this.options.duration
				);
			} else {
				this.pos = eased = percent;
			}
			this.now = ( this.end - this.start ) * eased + this.start;
	
			if ( this.options.step ) {
				this.options.step.call( this.elem, this.now, this );
			}
	
			if ( hooks && hooks.set ) {
				hooks.set( this );
			} else {
				Tween.propHooks._default.set( this );
			}
			return this;
		}
	};
	
	Tween.prototype.init.prototype = Tween.prototype;
	
	Tween.propHooks = {
		_default: {
			get: function( tween ) {
				var result;
	
				// Use a property on the element directly when it is not a DOM element,
				// or when there is no matching style property that exists.
				if ( tween.elem.nodeType !== 1 ||
					tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
					return tween.elem[ tween.prop ];
				}
	
				// Passing an empty string as a 3rd parameter to .css will automatically
				// attempt a parseFloat and fallback to a string if the parse fails.
				// Simple values such as "10px" are parsed to Float;
				// complex values such as "rotate(1rad)" are returned as-is.
				result = jQuery.css( tween.elem, tween.prop, "" );
	
				// Empty strings, null, undefined and "auto" are converted to 0.
				return !result || result === "auto" ? 0 : result;
			},
			set: function( tween ) {
	
				// Use step hook for back compat.
				// Use cssHook if its there.
				// Use .style if available and use plain properties where available.
				if ( jQuery.fx.step[ tween.prop ] ) {
					jQuery.fx.step[ tween.prop ]( tween );
				} else if ( tween.elem.nodeType === 1 &&
					( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
						jQuery.cssHooks[ tween.prop ] ) ) {
					jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
				} else {
					tween.elem[ tween.prop ] = tween.now;
				}
			}
		}
	};
	
	// Support: IE <=9 only
	// Panic based approach to setting things on disconnected nodes
	Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
		set: function( tween ) {
			if ( tween.elem.nodeType && tween.elem.parentNode ) {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	};
	
	jQuery.easing = {
		linear: function( p ) {
			return p;
		},
		swing: function( p ) {
			return 0.5 - Math.cos( p * Math.PI ) / 2;
		},
		_default: "swing"
	};
	
	jQuery.fx = Tween.prototype.init;
	
	// Back compat <1.8 extension point
	jQuery.fx.step = {};
	
	
	
	
	var
		fxNow, timerId,
		rfxtypes = /^(?:toggle|show|hide)$/,
		rrun = /queueHooks$/;
	
	function raf() {
		if ( timerId ) {
			window.requestAnimationFrame( raf );
			jQuery.fx.tick();
		}
	}
	
	// Animations created synchronously will run synchronously
	function createFxNow() {
		window.setTimeout( function() {
			fxNow = undefined;
		} );
		return ( fxNow = jQuery.now() );
	}
	
	// Generate parameters to create a standard animation
	function genFx( type, includeWidth ) {
		var which,
			i = 0,
			attrs = { height: type };
	
		// If we include width, step value is 1 to do all cssExpand values,
		// otherwise step value is 2 to skip over Left and Right
		includeWidth = includeWidth ? 1 : 0;
		for ( ; i < 4; i += 2 - includeWidth ) {
			which = cssExpand[ i ];
			attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
		}
	
		if ( includeWidth ) {
			attrs.opacity = attrs.width = type;
		}
	
		return attrs;
	}
	
	function createTween( value, prop, animation ) {
		var tween,
			collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
			index = 0,
			length = collection.length;
		for ( ; index < length; index++ ) {
			if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {
	
				// We're done with this property
				return tween;
			}
		}
	}
	
	function defaultPrefilter( elem, props, opts ) {
		var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
			isBox = "width" in props || "height" in props,
			anim = this,
			orig = {},
			style = elem.style,
			hidden = elem.nodeType && isHiddenWithinTree( elem ),
			dataShow = dataPriv.get( elem, "fxshow" );
	
		// Queue-skipping animations hijack the fx hooks
		if ( !opts.queue ) {
			hooks = jQuery._queueHooks( elem, "fx" );
			if ( hooks.unqueued == null ) {
				hooks.unqueued = 0;
				oldfire = hooks.empty.fire;
				hooks.empty.fire = function() {
					if ( !hooks.unqueued ) {
						oldfire();
					}
				};
			}
			hooks.unqueued++;
	
			anim.always( function() {
	
				// Ensure the complete handler is called before this completes
				anim.always( function() {
					hooks.unqueued--;
					if ( !jQuery.queue( elem, "fx" ).length ) {
						hooks.empty.fire();
					}
				} );
			} );
		}
	
		// Detect show/hide animations
		for ( prop in props ) {
			value = props[ prop ];
			if ( rfxtypes.test( value ) ) {
				delete props[ prop ];
				toggle = toggle || value === "toggle";
				if ( value === ( hidden ? "hide" : "show" ) ) {
	
					// Pretend to be hidden if this is a "show" and
					// there is still data from a stopped show/hide
					if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
						hidden = true;
	
					// Ignore all other no-op show/hide data
					} else {
						continue;
					}
				}
				orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
			}
		}
	
		// Bail out if this is a no-op like .hide().hide()
		propTween = !jQuery.isEmptyObject( props );
		if ( !propTween && jQuery.isEmptyObject( orig ) ) {
			return;
		}
	
		// Restrict "overflow" and "display" styles during box animations
		if ( isBox && elem.nodeType === 1 ) {
	
			// Support: IE <=9 - 11, Edge 12 - 13
			// Record all 3 overflow attributes because IE does not infer the shorthand
			// from identically-valued overflowX and overflowY
			opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];
	
			// Identify a display type, preferring old show/hide data over the CSS cascade
			restoreDisplay = dataShow && dataShow.display;
			if ( restoreDisplay == null ) {
				restoreDisplay = dataPriv.get( elem, "display" );
			}
			display = jQuery.css( elem, "display" );
			if ( display === "none" ) {
				if ( restoreDisplay ) {
					display = restoreDisplay;
				} else {
	
					// Get nonempty value(s) by temporarily forcing visibility
					showHide( [ elem ], true );
					restoreDisplay = elem.style.display || restoreDisplay;
					display = jQuery.css( elem, "display" );
					showHide( [ elem ] );
				}
			}
	
			// Animate inline elements as inline-block
			if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
				if ( jQuery.css( elem, "float" ) === "none" ) {
	
					// Restore the original display value at the end of pure show/hide animations
					if ( !propTween ) {
						anim.done( function() {
							style.display = restoreDisplay;
						} );
						if ( restoreDisplay == null ) {
							display = style.display;
							restoreDisplay = display === "none" ? "" : display;
						}
					}
					style.display = "inline-block";
				}
			}
		}
	
		if ( opts.overflow ) {
			style.overflow = "hidden";
			anim.always( function() {
				style.overflow = opts.overflow[ 0 ];
				style.overflowX = opts.overflow[ 1 ];
				style.overflowY = opts.overflow[ 2 ];
			} );
		}
	
		// Implement show/hide animations
		propTween = false;
		for ( prop in orig ) {
	
			// General show/hide setup for this element animation
			if ( !propTween ) {
				if ( dataShow ) {
					if ( "hidden" in dataShow ) {
						hidden = dataShow.hidden;
					}
				} else {
					dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
				}
	
				// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
				if ( toggle ) {
					dataShow.hidden = !hidden;
				}
	
				// Show elements before animating them
				if ( hidden ) {
					showHide( [ elem ], true );
				}
	
				/* eslint-disable no-loop-func */
	
				anim.done( function() {
	
				/* eslint-enable no-loop-func */
	
					// The final step of a "hide" animation is actually hiding the element
					if ( !hidden ) {
						showHide( [ elem ] );
					}
					dataPriv.remove( elem, "fxshow" );
					for ( prop in orig ) {
						jQuery.style( elem, prop, orig[ prop ] );
					}
				} );
			}
	
			// Per-property setup
			propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = propTween.start;
				if ( hidden ) {
					propTween.end = propTween.start;
					propTween.start = 0;
				}
			}
		}
	}
	
	function propFilter( props, specialEasing ) {
		var index, name, easing, value, hooks;
	
		// camelCase, specialEasing and expand cssHook pass
		for ( index in props ) {
			name = jQuery.camelCase( index );
			easing = specialEasing[ name ];
			value = props[ index ];
			if ( jQuery.isArray( value ) ) {
				easing = value[ 1 ];
				value = props[ index ] = value[ 0 ];
			}
	
			if ( index !== name ) {
				props[ name ] = value;
				delete props[ index ];
			}
	
			hooks = jQuery.cssHooks[ name ];
			if ( hooks && "expand" in hooks ) {
				value = hooks.expand( value );
				delete props[ name ];
	
				// Not quite $.extend, this won't overwrite existing keys.
				// Reusing 'index' because we have the correct "name"
				for ( index in value ) {
					if ( !( index in props ) ) {
						props[ index ] = value[ index ];
						specialEasing[ index ] = easing;
					}
				}
			} else {
				specialEasing[ name ] = easing;
			}
		}
	}
	
	function Animation( elem, properties, options ) {
		var result,
			stopped,
			index = 0,
			length = Animation.prefilters.length,
			deferred = jQuery.Deferred().always( function() {
	
				// Don't match elem in the :animated selector
				delete tick.elem;
			} ),
			tick = function() {
				if ( stopped ) {
					return false;
				}
				var currentTime = fxNow || createFxNow(),
					remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),
	
					// Support: Android 2.3 only
					// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
					temp = remaining / animation.duration || 0,
					percent = 1 - temp,
					index = 0,
					length = animation.tweens.length;
	
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( percent );
				}
	
				deferred.notifyWith( elem, [ animation, percent, remaining ] );
	
				if ( percent < 1 && length ) {
					return remaining;
				} else {
					deferred.resolveWith( elem, [ animation ] );
					return false;
				}
			},
			animation = deferred.promise( {
				elem: elem,
				props: jQuery.extend( {}, properties ),
				opts: jQuery.extend( true, {
					specialEasing: {},
					easing: jQuery.easing._default
				}, options ),
				originalProperties: properties,
				originalOptions: options,
				startTime: fxNow || createFxNow(),
				duration: options.duration,
				tweens: [],
				createTween: function( prop, end ) {
					var tween = jQuery.Tween( elem, animation.opts, prop, end,
							animation.opts.specialEasing[ prop ] || animation.opts.easing );
					animation.tweens.push( tween );
					return tween;
				},
				stop: function( gotoEnd ) {
					var index = 0,
	
						// If we are going to the end, we want to run all the tweens
						// otherwise we skip this part
						length = gotoEnd ? animation.tweens.length : 0;
					if ( stopped ) {
						return this;
					}
					stopped = true;
					for ( ; index < length; index++ ) {
						animation.tweens[ index ].run( 1 );
					}
	
					// Resolve when we played the last frame; otherwise, reject
					if ( gotoEnd ) {
						deferred.notifyWith( elem, [ animation, 1, 0 ] );
						deferred.resolveWith( elem, [ animation, gotoEnd ] );
					} else {
						deferred.rejectWith( elem, [ animation, gotoEnd ] );
					}
					return this;
				}
			} ),
			props = animation.props;
	
		propFilter( props, animation.opts.specialEasing );
	
		for ( ; index < length; index++ ) {
			result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
			if ( result ) {
				if ( jQuery.isFunction( result.stop ) ) {
					jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
						jQuery.proxy( result.stop, result );
				}
				return result;
			}
		}
	
		jQuery.map( props, createTween, animation );
	
		if ( jQuery.isFunction( animation.opts.start ) ) {
			animation.opts.start.call( elem, animation );
		}
	
		jQuery.fx.timer(
			jQuery.extend( tick, {
				elem: elem,
				anim: animation,
				queue: animation.opts.queue
			} )
		);
	
		// attach callbacks from options
		return animation.progress( animation.opts.progress )
			.done( animation.opts.done, animation.opts.complete )
			.fail( animation.opts.fail )
			.always( animation.opts.always );
	}
	
	jQuery.Animation = jQuery.extend( Animation, {
	
		tweeners: {
			"*": [ function( prop, value ) {
				var tween = this.createTween( prop, value );
				adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
				return tween;
			} ]
		},
	
		tweener: function( props, callback ) {
			if ( jQuery.isFunction( props ) ) {
				callback = props;
				props = [ "*" ];
			} else {
				props = props.match( rnothtmlwhite );
			}
	
			var prop,
				index = 0,
				length = props.length;
	
			for ( ; index < length; index++ ) {
				prop = props[ index ];
				Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
				Animation.tweeners[ prop ].unshift( callback );
			}
		},
	
		prefilters: [ defaultPrefilter ],
	
		prefilter: function( callback, prepend ) {
			if ( prepend ) {
				Animation.prefilters.unshift( callback );
			} else {
				Animation.prefilters.push( callback );
			}
		}
	} );
	
	jQuery.speed = function( speed, easing, fn ) {
		var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
			complete: fn || !fn && easing ||
				jQuery.isFunction( speed ) && speed,
			duration: speed,
			easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
		};
	
		// Go to the end state if fx are off or if document is hidden
		if ( jQuery.fx.off || document.hidden ) {
			opt.duration = 0;
	
		} else {
			if ( typeof opt.duration !== "number" ) {
				if ( opt.duration in jQuery.fx.speeds ) {
					opt.duration = jQuery.fx.speeds[ opt.duration ];
	
				} else {
					opt.duration = jQuery.fx.speeds._default;
				}
			}
		}
	
		// Normalize opt.queue - true/undefined/null -> "fx"
		if ( opt.queue == null || opt.queue === true ) {
			opt.queue = "fx";
		}
	
		// Queueing
		opt.old = opt.complete;
	
		opt.complete = function() {
			if ( jQuery.isFunction( opt.old ) ) {
				opt.old.call( this );
			}
	
			if ( opt.queue ) {
				jQuery.dequeue( this, opt.queue );
			}
		};
	
		return opt;
	};
	
	jQuery.fn.extend( {
		fadeTo: function( speed, to, easing, callback ) {
	
			// Show any hidden elements after setting opacity to 0
			return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()
	
				// Animate to the value specified
				.end().animate( { opacity: to }, speed, easing, callback );
		},
		animate: function( prop, speed, easing, callback ) {
			var empty = jQuery.isEmptyObject( prop ),
				optall = jQuery.speed( speed, easing, callback ),
				doAnimation = function() {
	
					// Operate on a copy of prop so per-property easing won't be lost
					var anim = Animation( this, jQuery.extend( {}, prop ), optall );
	
					// Empty animations, or finishing resolves immediately
					if ( empty || dataPriv.get( this, "finish" ) ) {
						anim.stop( true );
					}
				};
				doAnimation.finish = doAnimation;
	
			return empty || optall.queue === false ?
				this.each( doAnimation ) :
				this.queue( optall.queue, doAnimation );
		},
		stop: function( type, clearQueue, gotoEnd ) {
			var stopQueue = function( hooks ) {
				var stop = hooks.stop;
				delete hooks.stop;
				stop( gotoEnd );
			};
	
			if ( typeof type !== "string" ) {
				gotoEnd = clearQueue;
				clearQueue = type;
				type = undefined;
			}
			if ( clearQueue && type !== false ) {
				this.queue( type || "fx", [] );
			}
	
			return this.each( function() {
				var dequeue = true,
					index = type != null && type + "queueHooks",
					timers = jQuery.timers,
					data = dataPriv.get( this );
	
				if ( index ) {
					if ( data[ index ] && data[ index ].stop ) {
						stopQueue( data[ index ] );
					}
				} else {
					for ( index in data ) {
						if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
							stopQueue( data[ index ] );
						}
					}
				}
	
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this &&
						( type == null || timers[ index ].queue === type ) ) {
	
						timers[ index ].anim.stop( gotoEnd );
						dequeue = false;
						timers.splice( index, 1 );
					}
				}
	
				// Start the next in the queue if the last step wasn't forced.
				// Timers currently will call their complete callbacks, which
				// will dequeue but only if they were gotoEnd.
				if ( dequeue || !gotoEnd ) {
					jQuery.dequeue( this, type );
				}
			} );
		},
		finish: function( type ) {
			if ( type !== false ) {
				type = type || "fx";
			}
			return this.each( function() {
				var index,
					data = dataPriv.get( this ),
					queue = data[ type + "queue" ],
					hooks = data[ type + "queueHooks" ],
					timers = jQuery.timers,
					length = queue ? queue.length : 0;
	
				// Enable finishing flag on private data
				data.finish = true;
	
				// Empty the queue first
				jQuery.queue( this, type, [] );
	
				if ( hooks && hooks.stop ) {
					hooks.stop.call( this, true );
				}
	
				// Look for any active animations, and finish them
				for ( index = timers.length; index--; ) {
					if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
						timers[ index ].anim.stop( true );
						timers.splice( index, 1 );
					}
				}
	
				// Look for any animations in the old queue and finish them
				for ( index = 0; index < length; index++ ) {
					if ( queue[ index ] && queue[ index ].finish ) {
						queue[ index ].finish.call( this );
					}
				}
	
				// Turn off finishing flag
				delete data.finish;
			} );
		}
	} );
	
	jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
		var cssFn = jQuery.fn[ name ];
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return speed == null || typeof speed === "boolean" ?
				cssFn.apply( this, arguments ) :
				this.animate( genFx( name, true ), speed, easing, callback );
		};
	} );
	
	// Generate shortcuts for custom animations
	jQuery.each( {
		slideDown: genFx( "show" ),
		slideUp: genFx( "hide" ),
		slideToggle: genFx( "toggle" ),
		fadeIn: { opacity: "show" },
		fadeOut: { opacity: "hide" },
		fadeToggle: { opacity: "toggle" }
	}, function( name, props ) {
		jQuery.fn[ name ] = function( speed, easing, callback ) {
			return this.animate( props, speed, easing, callback );
		};
	} );
	
	jQuery.timers = [];
	jQuery.fx.tick = function() {
		var timer,
			i = 0,
			timers = jQuery.timers;
	
		fxNow = jQuery.now();
	
		for ( ; i < timers.length; i++ ) {
			timer = timers[ i ];
	
			// Checks the timer has not already been removed
			if ( !timer() && timers[ i ] === timer ) {
				timers.splice( i--, 1 );
			}
		}
	
		if ( !timers.length ) {
			jQuery.fx.stop();
		}
		fxNow = undefined;
	};
	
	jQuery.fx.timer = function( timer ) {
		jQuery.timers.push( timer );
		if ( timer() ) {
			jQuery.fx.start();
		} else {
			jQuery.timers.pop();
		}
	};
	
	jQuery.fx.interval = 13;
	jQuery.fx.start = function() {
		if ( !timerId ) {
			timerId = window.requestAnimationFrame ?
				window.requestAnimationFrame( raf ) :
				window.setInterval( jQuery.fx.tick, jQuery.fx.interval );
		}
	};
	
	jQuery.fx.stop = function() {
		if ( window.cancelAnimationFrame ) {
			window.cancelAnimationFrame( timerId );
		} else {
			window.clearInterval( timerId );
		}
	
		timerId = null;
	};
	
	jQuery.fx.speeds = {
		slow: 600,
		fast: 200,
	
		// Default speed
		_default: 400
	};
	
	
	// Based off of the plugin by Clint Helfers, with permission.
	// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
	jQuery.fn.delay = function( time, type ) {
		time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
		type = type || "fx";
	
		return this.queue( type, function( next, hooks ) {
			var timeout = window.setTimeout( next, time );
			hooks.stop = function() {
				window.clearTimeout( timeout );
			};
		} );
	};
	
	
	( function() {
		var input = document.createElement( "input" ),
			select = document.createElement( "select" ),
			opt = select.appendChild( document.createElement( "option" ) );
	
		input.type = "checkbox";
	
		// Support: Android <=4.3 only
		// Default value for a checkbox should be "on"
		support.checkOn = input.value !== "";
	
		// Support: IE <=11 only
		// Must access selectedIndex to make default options select
		support.optSelected = opt.selected;
	
		// Support: IE <=11 only
		// An input loses its value after becoming a radio
		input = document.createElement( "input" );
		input.value = "t";
		input.type = "radio";
		support.radioValue = input.value === "t";
	} )();
	
	
	var boolHook,
		attrHandle = jQuery.expr.attrHandle;
	
	jQuery.fn.extend( {
		attr: function( name, value ) {
			return access( this, jQuery.attr, name, value, arguments.length > 1 );
		},
	
		removeAttr: function( name ) {
			return this.each( function() {
				jQuery.removeAttr( this, name );
			} );
		}
	} );
	
	jQuery.extend( {
		attr: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set attributes on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			// Fallback to prop when attributes are not supported
			if ( typeof elem.getAttribute === "undefined" ) {
				return jQuery.prop( elem, name, value );
			}
	
			// Attribute hooks are determined by the lowercase version
			// Grab necessary hook if one is defined
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
				hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
					( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
			}
	
			if ( value !== undefined ) {
				if ( value === null ) {
					jQuery.removeAttr( elem, name );
					return;
				}
	
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				elem.setAttribute( name, value + "" );
				return value;
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			ret = jQuery.find.attr( elem, name );
	
			// Non-existent attributes return null, we normalize to undefined
			return ret == null ? undefined : ret;
		},
	
		attrHooks: {
			type: {
				set: function( elem, value ) {
					if ( !support.radioValue && value === "radio" &&
						jQuery.nodeName( elem, "input" ) ) {
						var val = elem.value;
						elem.setAttribute( "type", value );
						if ( val ) {
							elem.value = val;
						}
						return value;
					}
				}
			}
		},
	
		removeAttr: function( elem, value ) {
			var name,
				i = 0,
	
				// Attribute names can contain non-HTML whitespace characters
				// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
				attrNames = value && value.match( rnothtmlwhite );
	
			if ( attrNames && elem.nodeType === 1 ) {
				while ( ( name = attrNames[ i++ ] ) ) {
					elem.removeAttribute( name );
				}
			}
		}
	} );
	
	// Hooks for boolean attributes
	boolHook = {
		set: function( elem, value, name ) {
			if ( value === false ) {
	
				// Remove boolean attributes when set to false
				jQuery.removeAttr( elem, name );
			} else {
				elem.setAttribute( name, name );
			}
			return name;
		}
	};
	
	jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
		var getter = attrHandle[ name ] || jQuery.find.attr;
	
		attrHandle[ name ] = function( elem, name, isXML ) {
			var ret, handle,
				lowercaseName = name.toLowerCase();
	
			if ( !isXML ) {
	
				// Avoid an infinite loop by temporarily removing this function from the getter
				handle = attrHandle[ lowercaseName ];
				attrHandle[ lowercaseName ] = ret;
				ret = getter( elem, name, isXML ) != null ?
					lowercaseName :
					null;
				attrHandle[ lowercaseName ] = handle;
			}
			return ret;
		};
	} );
	
	
	
	
	var rfocusable = /^(?:input|select|textarea|button)$/i,
		rclickable = /^(?:a|area)$/i;
	
	jQuery.fn.extend( {
		prop: function( name, value ) {
			return access( this, jQuery.prop, name, value, arguments.length > 1 );
		},
	
		removeProp: function( name ) {
			return this.each( function() {
				delete this[ jQuery.propFix[ name ] || name ];
			} );
		}
	} );
	
	jQuery.extend( {
		prop: function( elem, name, value ) {
			var ret, hooks,
				nType = elem.nodeType;
	
			// Don't get/set properties on text, comment and attribute nodes
			if ( nType === 3 || nType === 8 || nType === 2 ) {
				return;
			}
	
			if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
	
				// Fix name and attach hooks
				name = jQuery.propFix[ name ] || name;
				hooks = jQuery.propHooks[ name ];
			}
	
			if ( value !== undefined ) {
				if ( hooks && "set" in hooks &&
					( ret = hooks.set( elem, value, name ) ) !== undefined ) {
					return ret;
				}
	
				return ( elem[ name ] = value );
			}
	
			if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
				return ret;
			}
	
			return elem[ name ];
		},
	
		propHooks: {
			tabIndex: {
				get: function( elem ) {
	
					// Support: IE <=9 - 11 only
					// elem.tabIndex doesn't always return the
					// correct value when it hasn't been explicitly set
					// https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
					// Use proper attribute retrieval(#12072)
					var tabindex = jQuery.find.attr( elem, "tabindex" );
	
					if ( tabindex ) {
						return parseInt( tabindex, 10 );
					}
	
					if (
						rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) &&
						elem.href
					) {
						return 0;
					}
	
					return -1;
				}
			}
		},
	
		propFix: {
			"for": "htmlFor",
			"class": "className"
		}
	} );
	
	// Support: IE <=11 only
	// Accessing the selectedIndex property
	// forces the browser to respect setting selected
	// on the option
	// The getter ensures a default option is selected
	// when in an optgroup
	// eslint rule "no-unused-expressions" is disabled for this code
	// since it considers such accessions noop
	if ( !support.optSelected ) {
		jQuery.propHooks.selected = {
			get: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent && parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
				return null;
			},
			set: function( elem ) {
	
				/* eslint no-unused-expressions: "off" */
	
				var parent = elem.parentNode;
				if ( parent ) {
					parent.selectedIndex;
	
					if ( parent.parentNode ) {
						parent.parentNode.selectedIndex;
					}
				}
			}
		};
	}
	
	jQuery.each( [
		"tabIndex",
		"readOnly",
		"maxLength",
		"cellSpacing",
		"cellPadding",
		"rowSpan",
		"colSpan",
		"useMap",
		"frameBorder",
		"contentEditable"
	], function() {
		jQuery.propFix[ this.toLowerCase() ] = this;
	} );
	
	
	
	
		// Strip and collapse whitespace according to HTML spec
		// https://html.spec.whatwg.org/multipage/infrastructure.html#strip-and-collapse-whitespace
		function stripAndCollapse( value ) {
			var tokens = value.match( rnothtmlwhite ) || [];
			return tokens.join( " " );
		}
	
	
	function getClass( elem ) {
		return elem.getAttribute && elem.getAttribute( "class" ) || "";
	}
	
	jQuery.fn.extend( {
		addClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnothtmlwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
							if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
								cur += clazz + " ";
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		removeClass: function( value ) {
			var classes, elem, cur, curValue, clazz, j, finalValue,
				i = 0;
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( j ) {
					jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
				} );
			}
	
			if ( !arguments.length ) {
				return this.attr( "class", "" );
			}
	
			if ( typeof value === "string" && value ) {
				classes = value.match( rnothtmlwhite ) || [];
	
				while ( ( elem = this[ i++ ] ) ) {
					curValue = getClass( elem );
	
					// This expression is here for better compressibility (see addClass)
					cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );
	
					if ( cur ) {
						j = 0;
						while ( ( clazz = classes[ j++ ] ) ) {
	
							// Remove *all* instances
							while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
								cur = cur.replace( " " + clazz + " ", " " );
							}
						}
	
						// Only assign if different to avoid unneeded rendering.
						finalValue = stripAndCollapse( cur );
						if ( curValue !== finalValue ) {
							elem.setAttribute( "class", finalValue );
						}
					}
				}
			}
	
			return this;
		},
	
		toggleClass: function( value, stateVal ) {
			var type = typeof value;
	
			if ( typeof stateVal === "boolean" && type === "string" ) {
				return stateVal ? this.addClass( value ) : this.removeClass( value );
			}
	
			if ( jQuery.isFunction( value ) ) {
				return this.each( function( i ) {
					jQuery( this ).toggleClass(
						value.call( this, i, getClass( this ), stateVal ),
						stateVal
					);
				} );
			}
	
			return this.each( function() {
				var className, i, self, classNames;
	
				if ( type === "string" ) {
	
					// Toggle individual class names
					i = 0;
					self = jQuery( this );
					classNames = value.match( rnothtmlwhite ) || [];
	
					while ( ( className = classNames[ i++ ] ) ) {
	
						// Check each className given, space separated list
						if ( self.hasClass( className ) ) {
							self.removeClass( className );
						} else {
							self.addClass( className );
						}
					}
	
				// Toggle whole class name
				} else if ( value === undefined || type === "boolean" ) {
					className = getClass( this );
					if ( className ) {
	
						// Store className if set
						dataPriv.set( this, "__className__", className );
					}
	
					// If the element has a class name or if we're passed `false`,
					// then remove the whole classname (if there was one, the above saved it).
					// Otherwise bring back whatever was previously saved (if anything),
					// falling back to the empty string if nothing was stored.
					if ( this.setAttribute ) {
						this.setAttribute( "class",
							className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
						);
					}
				}
			} );
		},
	
		hasClass: function( selector ) {
			var className, elem,
				i = 0;
	
			className = " " + selector + " ";
			while ( ( elem = this[ i++ ] ) ) {
				if ( elem.nodeType === 1 &&
					( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
						return true;
				}
			}
	
			return false;
		}
	} );
	
	
	
	
	var rreturn = /\r/g;
	
	jQuery.fn.extend( {
		val: function( value ) {
			var hooks, ret, isFunction,
				elem = this[ 0 ];
	
			if ( !arguments.length ) {
				if ( elem ) {
					hooks = jQuery.valHooks[ elem.type ] ||
						jQuery.valHooks[ elem.nodeName.toLowerCase() ];
	
					if ( hooks &&
						"get" in hooks &&
						( ret = hooks.get( elem, "value" ) ) !== undefined
					) {
						return ret;
					}
	
					ret = elem.value;
	
					// Handle most common string cases
					if ( typeof ret === "string" ) {
						return ret.replace( rreturn, "" );
					}
	
					// Handle cases where value is null/undef or number
					return ret == null ? "" : ret;
				}
	
				return;
			}
	
			isFunction = jQuery.isFunction( value );
	
			return this.each( function( i ) {
				var val;
	
				if ( this.nodeType !== 1 ) {
					return;
				}
	
				if ( isFunction ) {
					val = value.call( this, i, jQuery( this ).val() );
				} else {
					val = value;
				}
	
				// Treat null/undefined as ""; convert numbers to string
				if ( val == null ) {
					val = "";
	
				} else if ( typeof val === "number" ) {
					val += "";
	
				} else if ( jQuery.isArray( val ) ) {
					val = jQuery.map( val, function( value ) {
						return value == null ? "" : value + "";
					} );
				}
	
				hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];
	
				// If set returns undefined, fall back to normal setting
				if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
					this.value = val;
				}
			} );
		}
	} );
	
	jQuery.extend( {
		valHooks: {
			option: {
				get: function( elem ) {
	
					var val = jQuery.find.attr( elem, "value" );
					return val != null ?
						val :
	
						// Support: IE <=10 - 11 only
						// option.text throws exceptions (#14686, #14858)
						// Strip and collapse whitespace
						// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
						stripAndCollapse( jQuery.text( elem ) );
				}
			},
			select: {
				get: function( elem ) {
					var value, option, i,
						options = elem.options,
						index = elem.selectedIndex,
						one = elem.type === "select-one",
						values = one ? null : [],
						max = one ? index + 1 : options.length;
	
					if ( index < 0 ) {
						i = max;
	
					} else {
						i = one ? index : 0;
					}
	
					// Loop through all the selected options
					for ( ; i < max; i++ ) {
						option = options[ i ];
	
						// Support: IE <=9 only
						// IE8-9 doesn't update selected after form reset (#2551)
						if ( ( option.selected || i === index ) &&
	
								// Don't return options that are disabled or in a disabled optgroup
								!option.disabled &&
								( !option.parentNode.disabled ||
									!jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {
	
							// Get the specific value for the option
							value = jQuery( option ).val();
	
							// We don't need an array for one selects
							if ( one ) {
								return value;
							}
	
							// Multi-Selects return an array
							values.push( value );
						}
					}
	
					return values;
				},
	
				set: function( elem, value ) {
					var optionSet, option,
						options = elem.options,
						values = jQuery.makeArray( value ),
						i = options.length;
	
					while ( i-- ) {
						option = options[ i ];
	
						/* eslint-disable no-cond-assign */
	
						if ( option.selected =
							jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
						) {
							optionSet = true;
						}
	
						/* eslint-enable no-cond-assign */
					}
	
					// Force browsers to behave consistently when non-matching value is set
					if ( !optionSet ) {
						elem.selectedIndex = -1;
					}
					return values;
				}
			}
		}
	} );
	
	// Radios and checkboxes getter/setter
	jQuery.each( [ "radio", "checkbox" ], function() {
		jQuery.valHooks[ this ] = {
			set: function( elem, value ) {
				if ( jQuery.isArray( value ) ) {
					return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
				}
			}
		};
		if ( !support.checkOn ) {
			jQuery.valHooks[ this ].get = function( elem ) {
				return elem.getAttribute( "value" ) === null ? "on" : elem.value;
			};
		}
	} );
	
	
	
	
	// Return jQuery for attributes-only inclusion
	
	
	var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;
	
	jQuery.extend( jQuery.event, {
	
		trigger: function( event, data, elem, onlyHandlers ) {
	
			var i, cur, tmp, bubbleType, ontype, handle, special,
				eventPath = [ elem || document ],
				type = hasOwn.call( event, "type" ) ? event.type : event,
				namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];
	
			cur = tmp = elem = elem || document;
	
			// Don't do events on text and comment nodes
			if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
				return;
			}
	
			// focus/blur morphs to focusin/out; ensure we're not firing them right now
			if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
				return;
			}
	
			if ( type.indexOf( "." ) > -1 ) {
	
				// Namespaced trigger; create a regexp to match event type in handle()
				namespaces = type.split( "." );
				type = namespaces.shift();
				namespaces.sort();
			}
			ontype = type.indexOf( ":" ) < 0 && "on" + type;
	
			// Caller can pass in a jQuery.Event object, Object, or just an event type string
			event = event[ jQuery.expando ] ?
				event :
				new jQuery.Event( type, typeof event === "object" && event );
	
			// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
			event.isTrigger = onlyHandlers ? 2 : 3;
			event.namespace = namespaces.join( "." );
			event.rnamespace = event.namespace ?
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
				null;
	
			// Clean up the event in case it is being reused
			event.result = undefined;
			if ( !event.target ) {
				event.target = elem;
			}
	
			// Clone any incoming data and prepend the event, creating the handler arg list
			data = data == null ?
				[ event ] :
				jQuery.makeArray( data, [ event ] );
	
			// Allow special events to draw outside the lines
			special = jQuery.event.special[ type ] || {};
			if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
				return;
			}
	
			// Determine event propagation path in advance, per W3C events spec (#9951)
			// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
			if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {
	
				bubbleType = special.delegateType || type;
				if ( !rfocusMorph.test( bubbleType + type ) ) {
					cur = cur.parentNode;
				}
				for ( ; cur; cur = cur.parentNode ) {
					eventPath.push( cur );
					tmp = cur;
				}
	
				// Only add window if we got to document (e.g., not plain obj or detached DOM)
				if ( tmp === ( elem.ownerDocument || document ) ) {
					eventPath.push( tmp.defaultView || tmp.parentWindow || window );
				}
			}
	
			// Fire handlers on the event path
			i = 0;
			while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
	
				event.type = i > 1 ?
					bubbleType :
					special.bindType || type;
	
				// jQuery handler
				handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
					dataPriv.get( cur, "handle" );
				if ( handle ) {
					handle.apply( cur, data );
				}
	
				// Native handler
				handle = ontype && cur[ ontype ];
				if ( handle && handle.apply && acceptData( cur ) ) {
					event.result = handle.apply( cur, data );
					if ( event.result === false ) {
						event.preventDefault();
					}
				}
			}
			event.type = type;
	
			// If nobody prevented the default action, do it now
			if ( !onlyHandlers && !event.isDefaultPrevented() ) {
	
				if ( ( !special._default ||
					special._default.apply( eventPath.pop(), data ) === false ) &&
					acceptData( elem ) ) {
	
					// Call a native DOM method on the target with the same name as the event.
					// Don't do default actions on window, that's where global variables be (#6170)
					if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {
	
						// Don't re-trigger an onFOO event when we call its FOO() method
						tmp = elem[ ontype ];
	
						if ( tmp ) {
							elem[ ontype ] = null;
						}
	
						// Prevent re-triggering of the same event, since we already bubbled it above
						jQuery.event.triggered = type;
						elem[ type ]();
						jQuery.event.triggered = undefined;
	
						if ( tmp ) {
							elem[ ontype ] = tmp;
						}
					}
				}
			}
	
			return event.result;
		},
	
		// Piggyback on a donor event to simulate a different one
		// Used only for `focus(in | out)` events
		simulate: function( type, elem, event ) {
			var e = jQuery.extend(
				new jQuery.Event(),
				event,
				{
					type: type,
					isSimulated: true
				}
			);
	
			jQuery.event.trigger( e, null, elem );
		}
	
	} );
	
	jQuery.fn.extend( {
	
		trigger: function( type, data ) {
			return this.each( function() {
				jQuery.event.trigger( type, data, this );
			} );
		},
		triggerHandler: function( type, data ) {
			var elem = this[ 0 ];
			if ( elem ) {
				return jQuery.event.trigger( type, data, elem, true );
			}
		}
	} );
	
	
	jQuery.each( ( "blur focus focusin focusout resize scroll click dblclick " +
		"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
		"change select submit keydown keypress keyup contextmenu" ).split( " " ),
		function( i, name ) {
	
		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	} );
	
	jQuery.fn.extend( {
		hover: function( fnOver, fnOut ) {
			return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
		}
	} );
	
	
	
	
	support.focusin = "onfocusin" in window;
	
	
	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	if ( !support.focusin ) {
		jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {
	
			// Attach a single capturing handler on the document while someone wants focusin/focusout
			var handler = function( event ) {
				jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
			};
	
			jQuery.event.special[ fix ] = {
				setup: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix );
	
					if ( !attaches ) {
						doc.addEventListener( orig, handler, true );
					}
					dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
				},
				teardown: function() {
					var doc = this.ownerDocument || this,
						attaches = dataPriv.access( doc, fix ) - 1;
	
					if ( !attaches ) {
						doc.removeEventListener( orig, handler, true );
						dataPriv.remove( doc, fix );
	
					} else {
						dataPriv.access( doc, fix, attaches );
					}
				}
			};
		} );
	}
	var location = window.location;
	
	var nonce = jQuery.now();
	
	var rquery = ( /\?/ );
	
	
	
	// Cross-browser xml parsing
	jQuery.parseXML = function( data ) {
		var xml;
		if ( !data || typeof data !== "string" ) {
			return null;
		}
	
		// Support: IE 9 - 11 only
		// IE throws on parseFromString with invalid input.
		try {
			xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
		} catch ( e ) {
			xml = undefined;
		}
	
		if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
			jQuery.error( "Invalid XML: " + data );
		}
		return xml;
	};
	
	
	var
		rbracket = /\[\]$/,
		rCRLF = /\r?\n/g,
		rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
		rsubmittable = /^(?:input|select|textarea|keygen)/i;
	
	function buildParams( prefix, obj, traditional, add ) {
		var name;
	
		if ( jQuery.isArray( obj ) ) {
	
			// Serialize array item.
			jQuery.each( obj, function( i, v ) {
				if ( traditional || rbracket.test( prefix ) ) {
	
					// Treat each array item as a scalar.
					add( prefix, v );
	
				} else {
	
					// Item is non-scalar (array or object), encode its numeric index.
					buildParams(
						prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
						v,
						traditional,
						add
					);
				}
			} );
	
		} else if ( !traditional && jQuery.type( obj ) === "object" ) {
	
			// Serialize object item.
			for ( name in obj ) {
				buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
			}
	
		} else {
	
			// Serialize scalar item.
			add( prefix, obj );
		}
	}
	
	// Serialize an array of form elements or a set of
	// key/values into a query string
	jQuery.param = function( a, traditional ) {
		var prefix,
			s = [],
			add = function( key, valueOrFunction ) {
	
				// If value is a function, invoke it and use its return value
				var value = jQuery.isFunction( valueOrFunction ) ?
					valueOrFunction() :
					valueOrFunction;
	
				s[ s.length ] = encodeURIComponent( key ) + "=" +
					encodeURIComponent( value == null ? "" : value );
			};
	
		// If an array was passed in, assume that it is an array of form elements.
		if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {
	
			// Serialize the form elements
			jQuery.each( a, function() {
				add( this.name, this.value );
			} );
	
		} else {
	
			// If traditional, encode the "old" way (the way 1.3.2 or older
			// did it), otherwise encode params recursively.
			for ( prefix in a ) {
				buildParams( prefix, a[ prefix ], traditional, add );
			}
		}
	
		// Return the resulting serialization
		return s.join( "&" );
	};
	
	jQuery.fn.extend( {
		serialize: function() {
			return jQuery.param( this.serializeArray() );
		},
		serializeArray: function() {
			return this.map( function() {
	
				// Can add propHook for "elements" to filter or add form elements
				var elements = jQuery.prop( this, "elements" );
				return elements ? jQuery.makeArray( elements ) : this;
			} )
			.filter( function() {
				var type = this.type;
	
				// Use .is( ":disabled" ) so that fieldset[disabled] works
				return this.name && !jQuery( this ).is( ":disabled" ) &&
					rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
					( this.checked || !rcheckableType.test( type ) );
			} )
			.map( function( i, elem ) {
				var val = jQuery( this ).val();
	
				if ( val == null ) {
					return null;
				}
	
				if ( jQuery.isArray( val ) ) {
					return jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} );
				}
	
				return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
			} ).get();
		}
	} );
	
	
	var
		r20 = /%20/g,
		rhash = /#.*$/,
		rantiCache = /([?&])_=[^&]*/,
		rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
	
		// #7653, #8125, #8152: local protocol detection
		rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
		rnoContent = /^(?:GET|HEAD)$/,
		rprotocol = /^\/\//,
	
		/* Prefilters
		 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
		 * 2) These are called:
		 *    - BEFORE asking for a transport
		 *    - AFTER param serialization (s.data is a string if s.processData is true)
		 * 3) key is the dataType
		 * 4) the catchall symbol "*" can be used
		 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
		 */
		prefilters = {},
	
		/* Transports bindings
		 * 1) key is the dataType
		 * 2) the catchall symbol "*" can be used
		 * 3) selection will start with transport dataType and THEN go to "*" if needed
		 */
		transports = {},
	
		// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
		allTypes = "*/".concat( "*" ),
	
		// Anchor tag for parsing the document origin
		originAnchor = document.createElement( "a" );
		originAnchor.href = location.href;
	
	// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
	function addToPrefiltersOrTransports( structure ) {
	
		// dataTypeExpression is optional and defaults to "*"
		return function( dataTypeExpression, func ) {
	
			if ( typeof dataTypeExpression !== "string" ) {
				func = dataTypeExpression;
				dataTypeExpression = "*";
			}
	
			var dataType,
				i = 0,
				dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];
	
			if ( jQuery.isFunction( func ) ) {
	
				// For each dataType in the dataTypeExpression
				while ( ( dataType = dataTypes[ i++ ] ) ) {
	
					// Prepend if requested
					if ( dataType[ 0 ] === "+" ) {
						dataType = dataType.slice( 1 ) || "*";
						( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );
	
					// Otherwise append
					} else {
						( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
					}
				}
			}
		};
	}
	
	// Base inspection function for prefilters and transports
	function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {
	
		var inspected = {},
			seekingTransport = ( structure === transports );
	
		function inspect( dataType ) {
			var selected;
			inspected[ dataType ] = true;
			jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
				var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
				if ( typeof dataTypeOrTransport === "string" &&
					!seekingTransport && !inspected[ dataTypeOrTransport ] ) {
	
					options.dataTypes.unshift( dataTypeOrTransport );
					inspect( dataTypeOrTransport );
					return false;
				} else if ( seekingTransport ) {
					return !( selected = dataTypeOrTransport );
				}
			} );
			return selected;
		}
	
		return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
	}
	
	// A special extend for ajax options
	// that takes "flat" options (not to be deep extended)
	// Fixes #9887
	function ajaxExtend( target, src ) {
		var key, deep,
			flatOptions = jQuery.ajaxSettings.flatOptions || {};
	
		for ( key in src ) {
			if ( src[ key ] !== undefined ) {
				( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
			}
		}
		if ( deep ) {
			jQuery.extend( true, target, deep );
		}
	
		return target;
	}
	
	/* Handles responses to an ajax request:
	 * - finds the right dataType (mediates between content-type and expected dataType)
	 * - returns the corresponding response
	 */
	function ajaxHandleResponses( s, jqXHR, responses ) {
	
		var ct, type, finalDataType, firstDataType,
			contents = s.contents,
			dataTypes = s.dataTypes;
	
		// Remove auto dataType and get content-type in the process
		while ( dataTypes[ 0 ] === "*" ) {
			dataTypes.shift();
			if ( ct === undefined ) {
				ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
			}
		}
	
		// Check if we're dealing with a known content-type
		if ( ct ) {
			for ( type in contents ) {
				if ( contents[ type ] && contents[ type ].test( ct ) ) {
					dataTypes.unshift( type );
					break;
				}
			}
		}
	
		// Check to see if we have a response for the expected dataType
		if ( dataTypes[ 0 ] in responses ) {
			finalDataType = dataTypes[ 0 ];
		} else {
	
			// Try convertible dataTypes
			for ( type in responses ) {
				if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
					finalDataType = type;
					break;
				}
				if ( !firstDataType ) {
					firstDataType = type;
				}
			}
	
			// Or just use first one
			finalDataType = finalDataType || firstDataType;
		}
	
		// If we found a dataType
		// We add the dataType to the list if needed
		// and return the corresponding response
		if ( finalDataType ) {
			if ( finalDataType !== dataTypes[ 0 ] ) {
				dataTypes.unshift( finalDataType );
			}
			return responses[ finalDataType ];
		}
	}
	
	/* Chain conversions given the request and the original response
	 * Also sets the responseXXX fields on the jqXHR instance
	 */
	function ajaxConvert( s, response, jqXHR, isSuccess ) {
		var conv2, current, conv, tmp, prev,
			converters = {},
	
			// Work with a copy of dataTypes in case we need to modify it for conversion
			dataTypes = s.dataTypes.slice();
	
		// Create converters map with lowercased keys
		if ( dataTypes[ 1 ] ) {
			for ( conv in s.converters ) {
				converters[ conv.toLowerCase() ] = s.converters[ conv ];
			}
		}
	
		current = dataTypes.shift();
	
		// Convert to each sequential dataType
		while ( current ) {
	
			if ( s.responseFields[ current ] ) {
				jqXHR[ s.responseFields[ current ] ] = response;
			}
	
			// Apply the dataFilter if provided
			if ( !prev && isSuccess && s.dataFilter ) {
				response = s.dataFilter( response, s.dataType );
			}
	
			prev = current;
			current = dataTypes.shift();
	
			if ( current ) {
	
				// There's only work to do if current dataType is non-auto
				if ( current === "*" ) {
	
					current = prev;
	
				// Convert response if prev dataType is non-auto and differs from current
				} else if ( prev !== "*" && prev !== current ) {
	
					// Seek a direct converter
					conv = converters[ prev + " " + current ] || converters[ "* " + current ];
	
					// If none found, seek a pair
					if ( !conv ) {
						for ( conv2 in converters ) {
	
							// If conv2 outputs current
							tmp = conv2.split( " " );
							if ( tmp[ 1 ] === current ) {
	
								// If prev can be converted to accepted input
								conv = converters[ prev + " " + tmp[ 0 ] ] ||
									converters[ "* " + tmp[ 0 ] ];
								if ( conv ) {
	
									// Condense equivalence converters
									if ( conv === true ) {
										conv = converters[ conv2 ];
	
									// Otherwise, insert the intermediate dataType
									} else if ( converters[ conv2 ] !== true ) {
										current = tmp[ 0 ];
										dataTypes.unshift( tmp[ 1 ] );
									}
									break;
								}
							}
						}
					}
	
					// Apply converter (if not an equivalence)
					if ( conv !== true ) {
	
						// Unless errors are allowed to bubble, catch and return them
						if ( conv && s.throws ) {
							response = conv( response );
						} else {
							try {
								response = conv( response );
							} catch ( e ) {
								return {
									state: "parsererror",
									error: conv ? e : "No conversion from " + prev + " to " + current
								};
							}
						}
					}
				}
			}
		}
	
		return { state: "success", data: response };
	}
	
	jQuery.extend( {
	
		// Counter for holding the number of active queries
		active: 0,
	
		// Last-Modified header cache for next request
		lastModified: {},
		etag: {},
	
		ajaxSettings: {
			url: location.href,
			type: "GET",
			isLocal: rlocalProtocol.test( location.protocol ),
			global: true,
			processData: true,
			async: true,
			contentType: "application/x-www-form-urlencoded; charset=UTF-8",
	
			/*
			timeout: 0,
			data: null,
			dataType: null,
			username: null,
			password: null,
			cache: null,
			throws: false,
			traditional: false,
			headers: {},
			*/
	
			accepts: {
				"*": allTypes,
				text: "text/plain",
				html: "text/html",
				xml: "application/xml, text/xml",
				json: "application/json, text/javascript"
			},
	
			contents: {
				xml: /\bxml\b/,
				html: /\bhtml/,
				json: /\bjson\b/
			},
	
			responseFields: {
				xml: "responseXML",
				text: "responseText",
				json: "responseJSON"
			},
	
			// Data converters
			// Keys separate source (or catchall "*") and destination types with a single space
			converters: {
	
				// Convert anything to text
				"* text": String,
	
				// Text to html (true = no transformation)
				"text html": true,
	
				// Evaluate text as a json expression
				"text json": JSON.parse,
	
				// Parse text as xml
				"text xml": jQuery.parseXML
			},
	
			// For options that shouldn't be deep extended:
			// you can add your own custom options here if
			// and when you create one that shouldn't be
			// deep extended (see ajaxExtend)
			flatOptions: {
				url: true,
				context: true
			}
		},
	
		// Creates a full fledged settings object into target
		// with both ajaxSettings and settings fields.
		// If target is omitted, writes into ajaxSettings.
		ajaxSetup: function( target, settings ) {
			return settings ?
	
				// Building a settings object
				ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :
	
				// Extending ajaxSettings
				ajaxExtend( jQuery.ajaxSettings, target );
		},
	
		ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
		ajaxTransport: addToPrefiltersOrTransports( transports ),
	
		// Main method
		ajax: function( url, options ) {
	
			// If url is an object, simulate pre-1.5 signature
			if ( typeof url === "object" ) {
				options = url;
				url = undefined;
			}
	
			// Force options to be an object
			options = options || {};
	
			var transport,
	
				// URL without anti-cache param
				cacheURL,
	
				// Response headers
				responseHeadersString,
				responseHeaders,
	
				// timeout handle
				timeoutTimer,
	
				// Url cleanup var
				urlAnchor,
	
				// Request state (becomes false upon send and true upon completion)
				completed,
	
				// To know if global events are to be dispatched
				fireGlobals,
	
				// Loop variable
				i,
	
				// uncached part of the url
				uncached,
	
				// Create the final options object
				s = jQuery.ajaxSetup( {}, options ),
	
				// Callbacks context
				callbackContext = s.context || s,
	
				// Context for global events is callbackContext if it is a DOM node or jQuery collection
				globalEventContext = s.context &&
					( callbackContext.nodeType || callbackContext.jquery ) ?
						jQuery( callbackContext ) :
						jQuery.event,
	
				// Deferreds
				deferred = jQuery.Deferred(),
				completeDeferred = jQuery.Callbacks( "once memory" ),
	
				// Status-dependent callbacks
				statusCode = s.statusCode || {},
	
				// Headers (they are sent all at once)
				requestHeaders = {},
				requestHeadersNames = {},
	
				// Default abort message
				strAbort = "canceled",
	
				// Fake xhr
				jqXHR = {
					readyState: 0,
	
					// Builds headers hashtable if needed
					getResponseHeader: function( key ) {
						var match;
						if ( completed ) {
							if ( !responseHeaders ) {
								responseHeaders = {};
								while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
									responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
								}
							}
							match = responseHeaders[ key.toLowerCase() ];
						}
						return match == null ? null : match;
					},
	
					// Raw string
					getAllResponseHeaders: function() {
						return completed ? responseHeadersString : null;
					},
	
					// Caches the header
					setRequestHeader: function( name, value ) {
						if ( completed == null ) {
							name = requestHeadersNames[ name.toLowerCase() ] =
								requestHeadersNames[ name.toLowerCase() ] || name;
							requestHeaders[ name ] = value;
						}
						return this;
					},
	
					// Overrides response content-type header
					overrideMimeType: function( type ) {
						if ( completed == null ) {
							s.mimeType = type;
						}
						return this;
					},
	
					// Status-dependent callbacks
					statusCode: function( map ) {
						var code;
						if ( map ) {
							if ( completed ) {
	
								// Execute the appropriate callbacks
								jqXHR.always( map[ jqXHR.status ] );
							} else {
	
								// Lazy-add the new callbacks in a way that preserves old ones
								for ( code in map ) {
									statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
								}
							}
						}
						return this;
					},
	
					// Cancel the request
					abort: function( statusText ) {
						var finalText = statusText || strAbort;
						if ( transport ) {
							transport.abort( finalText );
						}
						done( 0, finalText );
						return this;
					}
				};
	
			// Attach deferreds
			deferred.promise( jqXHR );
	
			// Add protocol if not provided (prefilters might expect it)
			// Handle falsy url in the settings object (#10093: consistency with old signature)
			// We also use the url parameter if available
			s.url = ( ( url || s.url || location.href ) + "" )
				.replace( rprotocol, location.protocol + "//" );
	
			// Alias method option to type as per ticket #12004
			s.type = options.method || options.type || s.method || s.type;
	
			// Extract dataTypes list
			s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];
	
			// A cross-domain request is in order when the origin doesn't match the current origin.
			if ( s.crossDomain == null ) {
				urlAnchor = document.createElement( "a" );
	
				// Support: IE <=8 - 11, Edge 12 - 13
				// IE throws exception on accessing the href property if url is malformed,
				// e.g. http://example.com:80x/
				try {
					urlAnchor.href = s.url;
	
					// Support: IE <=8 - 11 only
					// Anchor's host property isn't correctly set when s.url is relative
					urlAnchor.href = urlAnchor.href;
					s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
						urlAnchor.protocol + "//" + urlAnchor.host;
				} catch ( e ) {
	
					// If there is an error parsing the URL, assume it is crossDomain,
					// it can be rejected by the transport if it is invalid
					s.crossDomain = true;
				}
			}
	
			// Convert data if not already a string
			if ( s.data && s.processData && typeof s.data !== "string" ) {
				s.data = jQuery.param( s.data, s.traditional );
			}
	
			// Apply prefilters
			inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );
	
			// If request was aborted inside a prefilter, stop there
			if ( completed ) {
				return jqXHR;
			}
	
			// We can fire global events as of now if asked to
			// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
			fireGlobals = jQuery.event && s.global;
	
			// Watch for a new set of requests
			if ( fireGlobals && jQuery.active++ === 0 ) {
				jQuery.event.trigger( "ajaxStart" );
			}
	
			// Uppercase the type
			s.type = s.type.toUpperCase();
	
			// Determine if request has content
			s.hasContent = !rnoContent.test( s.type );
	
			// Save the URL in case we're toying with the If-Modified-Since
			// and/or If-None-Match header later on
			// Remove hash to simplify url manipulation
			cacheURL = s.url.replace( rhash, "" );
	
			// More options handling for requests with no content
			if ( !s.hasContent ) {
	
				// Remember the hash so we can put it back
				uncached = s.url.slice( cacheURL.length );
	
				// If data is available, append data to url
				if ( s.data ) {
					cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;
	
					// #9682: remove data so that it's not used in an eventual retry
					delete s.data;
				}
	
				// Add or update anti-cache param if needed
				if ( s.cache === false ) {
					cacheURL = cacheURL.replace( rantiCache, "$1" );
					uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce++ ) + uncached;
				}
	
				// Put hash and anti-cache on the URL that will be requested (gh-1732)
				s.url = cacheURL + uncached;
	
			// Change '%20' to '+' if this is encoded form body content (gh-2658)
			} else if ( s.data && s.processData &&
				( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
				s.data = s.data.replace( r20, "+" );
			}
	
			// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
			if ( s.ifModified ) {
				if ( jQuery.lastModified[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
				}
				if ( jQuery.etag[ cacheURL ] ) {
					jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
				}
			}
	
			// Set the correct header, if data is being sent
			if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
				jqXHR.setRequestHeader( "Content-Type", s.contentType );
			}
	
			// Set the Accepts header for the server, depending on the dataType
			jqXHR.setRequestHeader(
				"Accept",
				s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
					s.accepts[ s.dataTypes[ 0 ] ] +
						( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
					s.accepts[ "*" ]
			);
	
			// Check for headers option
			for ( i in s.headers ) {
				jqXHR.setRequestHeader( i, s.headers[ i ] );
			}
	
			// Allow custom headers/mimetypes and early abort
			if ( s.beforeSend &&
				( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {
	
				// Abort if not done already and return
				return jqXHR.abort();
			}
	
			// Aborting is no longer a cancellation
			strAbort = "abort";
	
			// Install callbacks on deferreds
			completeDeferred.add( s.complete );
			jqXHR.done( s.success );
			jqXHR.fail( s.error );
	
			// Get transport
			transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );
	
			// If no transport, we auto-abort
			if ( !transport ) {
				done( -1, "No Transport" );
			} else {
				jqXHR.readyState = 1;
	
				// Send global event
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
				}
	
				// If request was aborted inside ajaxSend, stop there
				if ( completed ) {
					return jqXHR;
				}
	
				// Timeout
				if ( s.async && s.timeout > 0 ) {
					timeoutTimer = window.setTimeout( function() {
						jqXHR.abort( "timeout" );
					}, s.timeout );
				}
	
				try {
					completed = false;
					transport.send( requestHeaders, done );
				} catch ( e ) {
	
					// Rethrow post-completion exceptions
					if ( completed ) {
						throw e;
					}
	
					// Propagate others as results
					done( -1, e );
				}
			}
	
			// Callback for when everything is done
			function done( status, nativeStatusText, responses, headers ) {
				var isSuccess, success, error, response, modified,
					statusText = nativeStatusText;
	
				// Ignore repeat invocations
				if ( completed ) {
					return;
				}
	
				completed = true;
	
				// Clear timeout if it exists
				if ( timeoutTimer ) {
					window.clearTimeout( timeoutTimer );
				}
	
				// Dereference transport for early garbage collection
				// (no matter how long the jqXHR object will be used)
				transport = undefined;
	
				// Cache response headers
				responseHeadersString = headers || "";
	
				// Set readyState
				jqXHR.readyState = status > 0 ? 4 : 0;
	
				// Determine if successful
				isSuccess = status >= 200 && status < 300 || status === 304;
	
				// Get response data
				if ( responses ) {
					response = ajaxHandleResponses( s, jqXHR, responses );
				}
	
				// Convert no matter what (that way responseXXX fields are always set)
				response = ajaxConvert( s, response, jqXHR, isSuccess );
	
				// If successful, handle type chaining
				if ( isSuccess ) {
	
					// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
					if ( s.ifModified ) {
						modified = jqXHR.getResponseHeader( "Last-Modified" );
						if ( modified ) {
							jQuery.lastModified[ cacheURL ] = modified;
						}
						modified = jqXHR.getResponseHeader( "etag" );
						if ( modified ) {
							jQuery.etag[ cacheURL ] = modified;
						}
					}
	
					// if no content
					if ( status === 204 || s.type === "HEAD" ) {
						statusText = "nocontent";
	
					// if not modified
					} else if ( status === 304 ) {
						statusText = "notmodified";
	
					// If we have data, let's convert it
					} else {
						statusText = response.state;
						success = response.data;
						error = response.error;
						isSuccess = !error;
					}
				} else {
	
					// Extract error from statusText and normalize for non-aborts
					error = statusText;
					if ( status || !statusText ) {
						statusText = "error";
						if ( status < 0 ) {
							status = 0;
						}
					}
				}
	
				// Set data for the fake xhr object
				jqXHR.status = status;
				jqXHR.statusText = ( nativeStatusText || statusText ) + "";
	
				// Success/Error
				if ( isSuccess ) {
					deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
				} else {
					deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
				}
	
				// Status-dependent callbacks
				jqXHR.statusCode( statusCode );
				statusCode = undefined;
	
				if ( fireGlobals ) {
					globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
						[ jqXHR, s, isSuccess ? success : error ] );
				}
	
				// Complete
				completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );
	
				if ( fireGlobals ) {
					globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );
	
					// Handle the global AJAX counter
					if ( !( --jQuery.active ) ) {
						jQuery.event.trigger( "ajaxStop" );
					}
				}
			}
	
			return jqXHR;
		},
	
		getJSON: function( url, data, callback ) {
			return jQuery.get( url, data, callback, "json" );
		},
	
		getScript: function( url, callback ) {
			return jQuery.get( url, undefined, callback, "script" );
		}
	} );
	
	jQuery.each( [ "get", "post" ], function( i, method ) {
		jQuery[ method ] = function( url, data, callback, type ) {
	
			// Shift arguments if data argument was omitted
			if ( jQuery.isFunction( data ) ) {
				type = type || callback;
				callback = data;
				data = undefined;
			}
	
			// The url can be an options object (which then must have .url)
			return jQuery.ajax( jQuery.extend( {
				url: url,
				type: method,
				dataType: type,
				data: data,
				success: callback
			}, jQuery.isPlainObject( url ) && url ) );
		};
	} );
	
	
	jQuery._evalUrl = function( url ) {
		return jQuery.ajax( {
			url: url,
	
			// Make this explicit, since user can override this through ajaxSetup (#11264)
			type: "GET",
			dataType: "script",
			cache: true,
			async: false,
			global: false,
			"throws": true
		} );
	};
	
	
	jQuery.fn.extend( {
		wrapAll: function( html ) {
			var wrap;
	
			if ( this[ 0 ] ) {
				if ( jQuery.isFunction( html ) ) {
					html = html.call( this[ 0 ] );
				}
	
				// The elements to wrap the target around
				wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );
	
				if ( this[ 0 ].parentNode ) {
					wrap.insertBefore( this[ 0 ] );
				}
	
				wrap.map( function() {
					var elem = this;
	
					while ( elem.firstElementChild ) {
						elem = elem.firstElementChild;
					}
	
					return elem;
				} ).append( this );
			}
	
			return this;
		},
	
		wrapInner: function( html ) {
			if ( jQuery.isFunction( html ) ) {
				return this.each( function( i ) {
					jQuery( this ).wrapInner( html.call( this, i ) );
				} );
			}
	
			return this.each( function() {
				var self = jQuery( this ),
					contents = self.contents();
	
				if ( contents.length ) {
					contents.wrapAll( html );
	
				} else {
					self.append( html );
				}
			} );
		},
	
		wrap: function( html ) {
			var isFunction = jQuery.isFunction( html );
	
			return this.each( function( i ) {
				jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
			} );
		},
	
		unwrap: function( selector ) {
			this.parent( selector ).not( "body" ).each( function() {
				jQuery( this ).replaceWith( this.childNodes );
			} );
			return this;
		}
	} );
	
	
	jQuery.expr.pseudos.hidden = function( elem ) {
		return !jQuery.expr.pseudos.visible( elem );
	};
	jQuery.expr.pseudos.visible = function( elem ) {
		return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
	};
	
	
	
	
	jQuery.ajaxSettings.xhr = function() {
		try {
			return new window.XMLHttpRequest();
		} catch ( e ) {}
	};
	
	var xhrSuccessStatus = {
	
			// File protocol always yields status code 0, assume 200
			0: 200,
	
			// Support: IE <=9 only
			// #1450: sometimes IE returns 1223 when it should be 204
			1223: 204
		},
		xhrSupported = jQuery.ajaxSettings.xhr();
	
	support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
	support.ajax = xhrSupported = !!xhrSupported;
	
	jQuery.ajaxTransport( function( options ) {
		var callback, errorCallback;
	
		// Cross domain only allowed if supported through XMLHttpRequest
		if ( support.cors || xhrSupported && !options.crossDomain ) {
			return {
				send: function( headers, complete ) {
					var i,
						xhr = options.xhr();
	
					xhr.open(
						options.type,
						options.url,
						options.async,
						options.username,
						options.password
					);
	
					// Apply custom fields if provided
					if ( options.xhrFields ) {
						for ( i in options.xhrFields ) {
							xhr[ i ] = options.xhrFields[ i ];
						}
					}
	
					// Override mime type if needed
					if ( options.mimeType && xhr.overrideMimeType ) {
						xhr.overrideMimeType( options.mimeType );
					}
	
					// X-Requested-With header
					// For cross-domain requests, seeing as conditions for a preflight are
					// akin to a jigsaw puzzle, we simply never set it to be sure.
					// (it can always be set on a per-request basis or even using ajaxSetup)
					// For same-domain requests, won't change header if already provided.
					if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
						headers[ "X-Requested-With" ] = "XMLHttpRequest";
					}
	
					// Set headers
					for ( i in headers ) {
						xhr.setRequestHeader( i, headers[ i ] );
					}
	
					// Callback
					callback = function( type ) {
						return function() {
							if ( callback ) {
								callback = errorCallback = xhr.onload =
									xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;
	
								if ( type === "abort" ) {
									xhr.abort();
								} else if ( type === "error" ) {
	
									// Support: IE <=9 only
									// On a manual native abort, IE9 throws
									// errors on any property access that is not readyState
									if ( typeof xhr.status !== "number" ) {
										complete( 0, "error" );
									} else {
										complete(
	
											// File: protocol always yields status 0; see #8605, #14207
											xhr.status,
											xhr.statusText
										);
									}
								} else {
									complete(
										xhrSuccessStatus[ xhr.status ] || xhr.status,
										xhr.statusText,
	
										// Support: IE <=9 only
										// IE9 has no XHR2 but throws on binary (trac-11426)
										// For XHR2 non-text, let the caller handle it (gh-2498)
										( xhr.responseType || "text" ) !== "text"  ||
										typeof xhr.responseText !== "string" ?
											{ binary: xhr.response } :
											{ text: xhr.responseText },
										xhr.getAllResponseHeaders()
									);
								}
							}
						};
					};
	
					// Listen to events
					xhr.onload = callback();
					errorCallback = xhr.onerror = callback( "error" );
	
					// Support: IE 9 only
					// Use onreadystatechange to replace onabort
					// to handle uncaught aborts
					if ( xhr.onabort !== undefined ) {
						xhr.onabort = errorCallback;
					} else {
						xhr.onreadystatechange = function() {
	
							// Check readyState before timeout as it changes
							if ( xhr.readyState === 4 ) {
	
								// Allow onerror to be called first,
								// but that will not handle a native abort
								// Also, save errorCallback to a variable
								// as xhr.onerror cannot be accessed
								window.setTimeout( function() {
									if ( callback ) {
										errorCallback();
									}
								} );
							}
						};
					}
	
					// Create the abort callback
					callback = callback( "abort" );
	
					try {
	
						// Do send the request (this may raise an exception)
						xhr.send( options.hasContent && options.data || null );
					} catch ( e ) {
	
						// #14683: Only rethrow if this hasn't been notified as an error yet
						if ( callback ) {
							throw e;
						}
					}
				},
	
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
	jQuery.ajaxPrefilter( function( s ) {
		if ( s.crossDomain ) {
			s.contents.script = false;
		}
	} );
	
	// Install script dataType
	jQuery.ajaxSetup( {
		accepts: {
			script: "text/javascript, application/javascript, " +
				"application/ecmascript, application/x-ecmascript"
		},
		contents: {
			script: /\b(?:java|ecma)script\b/
		},
		converters: {
			"text script": function( text ) {
				jQuery.globalEval( text );
				return text;
			}
		}
	} );
	
	// Handle cache's special case and crossDomain
	jQuery.ajaxPrefilter( "script", function( s ) {
		if ( s.cache === undefined ) {
			s.cache = false;
		}
		if ( s.crossDomain ) {
			s.type = "GET";
		}
	} );
	
	// Bind script tag hack transport
	jQuery.ajaxTransport( "script", function( s ) {
	
		// This transport only deals with cross domain requests
		if ( s.crossDomain ) {
			var script, callback;
			return {
				send: function( _, complete ) {
					script = jQuery( "<script>" ).prop( {
						charset: s.scriptCharset,
						src: s.url
					} ).on(
						"load error",
						callback = function( evt ) {
							script.remove();
							callback = null;
							if ( evt ) {
								complete( evt.type === "error" ? 404 : 200, evt.type );
							}
						}
					);
	
					// Use native DOM manipulation to avoid our domManip AJAX trickery
					document.head.appendChild( script[ 0 ] );
				},
				abort: function() {
					if ( callback ) {
						callback();
					}
				}
			};
		}
	} );
	
	
	
	
	var oldCallbacks = [],
		rjsonp = /(=)\?(?=&|$)|\?\?/;
	
	// Default jsonp settings
	jQuery.ajaxSetup( {
		jsonp: "callback",
		jsonpCallback: function() {
			var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
			this[ callback ] = true;
			return callback;
		}
	} );
	
	// Detect, normalize options and install callbacks for jsonp requests
	jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {
	
		var callbackName, overwritten, responseContainer,
			jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
				"url" :
				typeof s.data === "string" &&
					( s.contentType || "" )
						.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
					rjsonp.test( s.data ) && "data"
			);
	
		// Handle iff the expected data type is "jsonp" or we have a parameter to set
		if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {
	
			// Get callback name, remembering preexisting value associated with it
			callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
				s.jsonpCallback() :
				s.jsonpCallback;
	
			// Insert callback into url or form data
			if ( jsonProp ) {
				s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
			} else if ( s.jsonp !== false ) {
				s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
			}
	
			// Use data converter to retrieve json after script execution
			s.converters[ "script json" ] = function() {
				if ( !responseContainer ) {
					jQuery.error( callbackName + " was not called" );
				}
				return responseContainer[ 0 ];
			};
	
			// Force json dataType
			s.dataTypes[ 0 ] = "json";
	
			// Install callback
			overwritten = window[ callbackName ];
			window[ callbackName ] = function() {
				responseContainer = arguments;
			};
	
			// Clean-up function (fires after converters)
			jqXHR.always( function() {
	
				// If previous value didn't exist - remove it
				if ( overwritten === undefined ) {
					jQuery( window ).removeProp( callbackName );
	
				// Otherwise restore preexisting value
				} else {
					window[ callbackName ] = overwritten;
				}
	
				// Save back as free
				if ( s[ callbackName ] ) {
	
					// Make sure that re-using the options doesn't screw things around
					s.jsonpCallback = originalSettings.jsonpCallback;
	
					// Save the callback name for future use
					oldCallbacks.push( callbackName );
				}
	
				// Call if it was a function and we have a response
				if ( responseContainer && jQuery.isFunction( overwritten ) ) {
					overwritten( responseContainer[ 0 ] );
				}
	
				responseContainer = overwritten = undefined;
			} );
	
			// Delegate to script
			return "script";
		}
	} );
	
	
	
	
	// Support: Safari 8 only
	// In Safari 8 documents created via document.implementation.createHTMLDocument
	// collapse sibling forms: the second one becomes a child of the first one.
	// Because of that, this security measure has to be disabled in Safari 8.
	// https://bugs.webkit.org/show_bug.cgi?id=137337
	support.createHTMLDocument = ( function() {
		var body = document.implementation.createHTMLDocument( "" ).body;
		body.innerHTML = "<form></form><form></form>";
		return body.childNodes.length === 2;
	} )();
	
	
	// Argument "data" should be string of html
	// context (optional): If specified, the fragment will be created in this context,
	// defaults to document
	// keepScripts (optional): If true, will include scripts passed in the html string
	jQuery.parseHTML = function( data, context, keepScripts ) {
		if ( typeof data !== "string" ) {
			return [];
		}
		if ( typeof context === "boolean" ) {
			keepScripts = context;
			context = false;
		}
	
		var base, parsed, scripts;
	
		if ( !context ) {
	
			// Stop scripts or inline event handlers from being executed immediately
			// by using document.implementation
			if ( support.createHTMLDocument ) {
				context = document.implementation.createHTMLDocument( "" );
	
				// Set the base href for the created document
				// so any parsed elements with URLs
				// are based on the document's URL (gh-2965)
				base = context.createElement( "base" );
				base.href = document.location.href;
				context.head.appendChild( base );
			} else {
				context = document;
			}
		}
	
		parsed = rsingleTag.exec( data );
		scripts = !keepScripts && [];
	
		// Single tag
		if ( parsed ) {
			return [ context.createElement( parsed[ 1 ] ) ];
		}
	
		parsed = buildFragment( [ data ], context, scripts );
	
		if ( scripts && scripts.length ) {
			jQuery( scripts ).remove();
		}
	
		return jQuery.merge( [], parsed.childNodes );
	};
	
	
	/**
	 * Load a url into a page
	 */
	jQuery.fn.load = function( url, params, callback ) {
		var selector, type, response,
			self = this,
			off = url.indexOf( " " );
	
		if ( off > -1 ) {
			selector = stripAndCollapse( url.slice( off ) );
			url = url.slice( 0, off );
		}
	
		// If it's a function
		if ( jQuery.isFunction( params ) ) {
	
			// We assume that it's the callback
			callback = params;
			params = undefined;
	
		// Otherwise, build a param string
		} else if ( params && typeof params === "object" ) {
			type = "POST";
		}
	
		// If we have elements to modify, make the request
		if ( self.length > 0 ) {
			jQuery.ajax( {
				url: url,
	
				// If "type" variable is undefined, then "GET" method will be used.
				// Make value of this field explicit since
				// user can override it through ajaxSetup method
				type: type || "GET",
				dataType: "html",
				data: params
			} ).done( function( responseText ) {
	
				// Save response for use in complete callback
				response = arguments;
	
				self.html( selector ?
	
					// If a selector was specified, locate the right elements in a dummy div
					// Exclude scripts to avoid IE 'Permission Denied' errors
					jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :
	
					// Otherwise use the full result
					responseText );
	
			// If the request succeeds, this function gets "data", "status", "jqXHR"
			// but they are ignored because response was set above.
			// If it fails, this function gets "jqXHR", "status", "error"
			} ).always( callback && function( jqXHR, status ) {
				self.each( function() {
					callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
				} );
			} );
		}
	
		return this;
	};
	
	
	
	
	// Attach a bunch of functions for handling common AJAX events
	jQuery.each( [
		"ajaxStart",
		"ajaxStop",
		"ajaxComplete",
		"ajaxError",
		"ajaxSuccess",
		"ajaxSend"
	], function( i, type ) {
		jQuery.fn[ type ] = function( fn ) {
			return this.on( type, fn );
		};
	} );
	
	
	
	
	jQuery.expr.pseudos.animated = function( elem ) {
		return jQuery.grep( jQuery.timers, function( fn ) {
			return elem === fn.elem;
		} ).length;
	};
	
	
	
	
	/**
	 * Gets a window from an element
	 */
	function getWindow( elem ) {
		return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
	}
	
	jQuery.offset = {
		setOffset: function( elem, options, i ) {
			var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
				position = jQuery.css( elem, "position" ),
				curElem = jQuery( elem ),
				props = {};
	
			// Set position first, in-case top/left are set even on static elem
			if ( position === "static" ) {
				elem.style.position = "relative";
			}
	
			curOffset = curElem.offset();
			curCSSTop = jQuery.css( elem, "top" );
			curCSSLeft = jQuery.css( elem, "left" );
			calculatePosition = ( position === "absolute" || position === "fixed" ) &&
				( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;
	
			// Need to be able to calculate position if either
			// top or left is auto and position is either absolute or fixed
			if ( calculatePosition ) {
				curPosition = curElem.position();
				curTop = curPosition.top;
				curLeft = curPosition.left;
	
			} else {
				curTop = parseFloat( curCSSTop ) || 0;
				curLeft = parseFloat( curCSSLeft ) || 0;
			}
	
			if ( jQuery.isFunction( options ) ) {
	
				// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
				options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
			}
	
			if ( options.top != null ) {
				props.top = ( options.top - curOffset.top ) + curTop;
			}
			if ( options.left != null ) {
				props.left = ( options.left - curOffset.left ) + curLeft;
			}
	
			if ( "using" in options ) {
				options.using.call( elem, props );
	
			} else {
				curElem.css( props );
			}
		}
	};
	
	jQuery.fn.extend( {
		offset: function( options ) {
	
			// Preserve chaining for setter
			if ( arguments.length ) {
				return options === undefined ?
					this :
					this.each( function( i ) {
						jQuery.offset.setOffset( this, options, i );
					} );
			}
	
			var docElem, win, rect, doc,
				elem = this[ 0 ];
	
			if ( !elem ) {
				return;
			}
	
			// Support: IE <=11 only
			// Running getBoundingClientRect on a
			// disconnected node in IE throws an error
			if ( !elem.getClientRects().length ) {
				return { top: 0, left: 0 };
			}
	
			rect = elem.getBoundingClientRect();
	
			// Make sure element is not hidden (display: none)
			if ( rect.width || rect.height ) {
				doc = elem.ownerDocument;
				win = getWindow( doc );
				docElem = doc.documentElement;
	
				return {
					top: rect.top + win.pageYOffset - docElem.clientTop,
					left: rect.left + win.pageXOffset - docElem.clientLeft
				};
			}
	
			// Return zeros for disconnected and hidden elements (gh-2310)
			return rect;
		},
	
		position: function() {
			if ( !this[ 0 ] ) {
				return;
			}
	
			var offsetParent, offset,
				elem = this[ 0 ],
				parentOffset = { top: 0, left: 0 };
	
			// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
			// because it is its only offset parent
			if ( jQuery.css( elem, "position" ) === "fixed" ) {
	
				// Assume getBoundingClientRect is there when computed position is fixed
				offset = elem.getBoundingClientRect();
	
			} else {
	
				// Get *real* offsetParent
				offsetParent = this.offsetParent();
	
				// Get correct offsets
				offset = this.offset();
				if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
					parentOffset = offsetParent.offset();
				}
	
				// Add offsetParent borders
				parentOffset = {
					top: parentOffset.top + jQuery.css( offsetParent[ 0 ], "borderTopWidth", true ),
					left: parentOffset.left + jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true )
				};
			}
	
			// Subtract parent offsets and element margins
			return {
				top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
				left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
			};
		},
	
		// This method will return documentElement in the following cases:
		// 1) For the element inside the iframe without offsetParent, this method will return
		//    documentElement of the parent window
		// 2) For the hidden or detached element
		// 3) For body or html element, i.e. in case of the html node - it will return itself
		//
		// but those exceptions were never presented as a real life use-cases
		// and might be considered as more preferable results.
		//
		// This logic, however, is not guaranteed and can change at any point in the future
		offsetParent: function() {
			return this.map( function() {
				var offsetParent = this.offsetParent;
	
				while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
					offsetParent = offsetParent.offsetParent;
				}
	
				return offsetParent || documentElement;
			} );
		}
	} );
	
	// Create scrollLeft and scrollTop methods
	jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
		var top = "pageYOffset" === prop;
	
		jQuery.fn[ method ] = function( val ) {
			return access( this, function( elem, method, val ) {
				var win = getWindow( elem );
	
				if ( val === undefined ) {
					return win ? win[ prop ] : elem[ method ];
				}
	
				if ( win ) {
					win.scrollTo(
						!top ? val : win.pageXOffset,
						top ? val : win.pageYOffset
					);
	
				} else {
					elem[ method ] = val;
				}
			}, method, val, arguments.length );
		};
	} );
	
	// Support: Safari <=7 - 9.1, Chrome <=37 - 49
	// Add the top/left cssHooks using jQuery.fn.position
	// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
	// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
	// getComputedStyle returns percent when specified for top/left/bottom/right;
	// rather than make the css module depend on the offset module, just check for it here
	jQuery.each( [ "top", "left" ], function( i, prop ) {
		jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
			function( elem, computed ) {
				if ( computed ) {
					computed = curCSS( elem, prop );
	
					// If curCSS returns percentage, fallback to offset
					return rnumnonpx.test( computed ) ?
						jQuery( elem ).position()[ prop ] + "px" :
						computed;
				}
			}
		);
	} );
	
	
	// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
	jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
		jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
			function( defaultExtra, funcName ) {
	
			// Margin is only for outerHeight, outerWidth
			jQuery.fn[ funcName ] = function( margin, value ) {
				var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
					extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );
	
				return access( this, function( elem, type, value ) {
					var doc;
	
					if ( jQuery.isWindow( elem ) ) {
	
						// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
						return funcName.indexOf( "outer" ) === 0 ?
							elem[ "inner" + name ] :
							elem.document.documentElement[ "client" + name ];
					}
	
					// Get document width or height
					if ( elem.nodeType === 9 ) {
						doc = elem.documentElement;
	
						// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
						// whichever is greatest
						return Math.max(
							elem.body[ "scroll" + name ], doc[ "scroll" + name ],
							elem.body[ "offset" + name ], doc[ "offset" + name ],
							doc[ "client" + name ]
						);
					}
	
					return value === undefined ?
	
						// Get width or height on the element, requesting but not forcing parseFloat
						jQuery.css( elem, type, extra ) :
	
						// Set width or height on the element
						jQuery.style( elem, type, value, extra );
				}, type, chainable ? margin : undefined, chainable );
			};
		} );
	} );
	
	
	jQuery.fn.extend( {
	
		bind: function( types, data, fn ) {
			return this.on( types, null, data, fn );
		},
		unbind: function( types, fn ) {
			return this.off( types, null, fn );
		},
	
		delegate: function( selector, types, data, fn ) {
			return this.on( types, selector, data, fn );
		},
		undelegate: function( selector, types, fn ) {
	
			// ( namespace ) or ( selector, types [, fn] )
			return arguments.length === 1 ?
				this.off( selector, "**" ) :
				this.off( types, selector || "**", fn );
		}
	} );
	
	jQuery.parseJSON = JSON.parse;
	
	
	
	
	// Register as a named AMD module, since jQuery can be concatenated with other
	// files that may use define, but not via a proper concatenation script that
	// understands anonymous AMD modules. A named AMD is safest and most robust
	// way to register. Lowercase jquery is used because AMD module names are
	// derived from file names, and jQuery is normally delivered in a lowercase
	// file name. Do this after creating the global so that if an AMD module wants
	// to call noConflict to hide this version of jQuery, it will work.
	
	// Note that for maximum portability, libraries that are not jQuery should
	// declare themselves as anonymous modules, and avoid setting a global if an
	// AMD loader is present. jQuery is a special case. For more information, see
	// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
	
	if ( true ) {
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
			return jQuery;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	
	
	
	
	var
	
		// Map over jQuery in case of overwrite
		_jQuery = window.jQuery,
	
		// Map over the $ in case of overwrite
		_$ = window.$;
	
	jQuery.noConflict = function( deep ) {
		if ( window.$ === jQuery ) {
			window.$ = _$;
		}
	
		if ( deep && window.jQuery === jQuery ) {
			window.jQuery = _jQuery;
		}
	
		return jQuery;
	};
	
	// Expose jQuery and $ identifiers, even in AMD
	// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
	// and CommonJS for browser emulators (#13566)
	if ( !noGlobal ) {
		window.jQuery = window.$ = jQuery;
	}
	
	
	
	
	
	return jQuery;
	} );


/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var core_1 = __webpack_require__(3);
	var DecimalFormatterService = (function () {
	    function DecimalFormatterService(translate) {
	        this.translate = translate;
	        // TODO comes from configuration settings
	        this.DECIMAL_SEPARATOR = ".";
	        this.THOUSANDS_SEPARATOR = ",";
	    }
	    DecimalFormatterService.prototype.transform = function (value, allowGrouping) {
	        if (allowGrouping === void 0) { allowGrouping = false; }
	        value = value != null ? value.toString() : value;
	        var _a = (value || "").toString()
	            .split(this.DECIMAL_SEPARATOR), integer = _a[0], _b = _a[1], fraction = _b === void 0 ? "" : _b;
	        var newDecimalSeparator = this.translate.currentLang == "nl" ? "," : ".";
	        var newThousandSeparator = this.translate.currentLang == "nl" ? "." : ",";
	        // fraction = fractionSize > 0
	        //   ? newDecimalSeparator + (fraction + PADDING).substring(0, fractionSize)
	        //   : "";
	        fraction = fraction ? newDecimalSeparator + fraction : "";
	        if (allowGrouping) {
	            integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, newThousandSeparator);
	        }
	        return integer + fraction;
	    };
	    DecimalFormatterService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _a) || Object])
	    ], DecimalFormatterService);
	    return DecimalFormatterService;
	    var _a;
	}());
	exports.DecimalFormatterService = DecimalFormatterService;


/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var core_1 = __webpack_require__(3);
	var translations_1 = __webpack_require__(71); // import our opaque token
	var TranslateService = (function () {
	    // inject our translations
	    function TranslateService(_translations) {
	        this._translations = _translations;
	        this.PLACEHOLDER = '%';
	        this._defaultLang = "en";
	        this.onLangChanged = new core_1.EventEmitter();
	    }
	    TranslateService.prototype.setDetectedLang = function () {
	        var language = localStorage.getItem("language");
	        var accept_language = language ? language : this._defaultLang;
	        this.setDefaultLang(accept_language); // set English as default
	        this.enableFallback(true); // enable fallback
	        this.use(accept_language);
	    };
	    Object.defineProperty(TranslateService.prototype, "currentLang", {
	        get: function () {
	            return this._currentLang || this._defaultLang;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    TranslateService.prototype.setDefaultLang = function (lang) {
	        this._defaultLang = lang;
	    };
	    TranslateService.prototype.enableFallback = function (enable) {
	        this._fallback = enable;
	    };
	    TranslateService.prototype.use = function (lang) {
	        // set current language
	        this._currentLang = lang;
	        this.onLangChanged.emit(lang);
	    };
	    TranslateService.prototype.translate = function (key) {
	        var translation = key;
	        // found in current language
	        if (this._translations[this.currentLang] && this._translations[this.currentLang][key]) {
	            return this._translations[this.currentLang][key];
	        }
	        // fallback disabled
	        if (!this._fallback) {
	            return translation;
	        }
	        // found in default language
	        if (this._translations[this._defaultLang] && this._translations[this._defaultLang][key]) {
	            return this._translations[this._defaultLang][key];
	        }
	        // not found
	        return translation;
	    };
	    TranslateService.prototype.replace = function (word, words) {
	        var _this = this;
	        if (word === void 0) { word = ''; }
	        if (words === void 0) { words = ''; }
	        var translation = word;
	        var values = [].concat(words);
	        values.forEach(function (e, i) {
	            translation = translation.replace(_this.PLACEHOLDER.concat(i), e);
	        });
	        return translation;
	    };
	    TranslateService.prototype.instant = function (key, words) {
	        // public perform translation
	        var translation = this.translate(key);
	        if (!words)
	            return translation;
	        return this.replace(translation, words);
	    };
	    TranslateService = __decorate([
	        // import our opaque token
	        core_1.Injectable(),
	        __param(0, core_1.Inject(translations_1.TRANSLATIONS)), 
	        __metadata('design:paramtypes', [Object])
	    ], TranslateService);
	    return TranslateService;
	}());
	exports.TranslateService = TranslateService;


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	// app/translate/translation.ts
	"use strict";
	var core_1 = __webpack_require__(3);
	// import translations
	var lang_en_1 = __webpack_require__(72);
	var lang_nl_1 = __webpack_require__(73);
	var lang_de_1 = __webpack_require__(74);
	var lang_es_1 = __webpack_require__(75);
	var lang_pt_1 = __webpack_require__(76);
	var lang_fr_1 = __webpack_require__(77);
	var lang_pl_1 = __webpack_require__(78);
	// translation token
	exports.TRANSLATIONS = new core_1.OpaqueToken('translations');
	// all traslations
	var dictionary = (_a = {},
	    _a[lang_en_1.LANG_EN_NAME] = lang_en_1.LANG_EN_TRANS,
	    _a[lang_nl_1.LANG_NL_NAME] = lang_nl_1.LANG_NL_TRANS,
	    _a[lang_de_1.LANG_DE_NAME] = lang_de_1.LANG_DE_TRANS,
	    _a[lang_es_1.LANG_ES_NAME] = lang_es_1.LANG_ES_TRANS,
	    _a[lang_pt_1.LANG_PT_NAME] = lang_pt_1.LANG_PT_TRANS,
	    _a[lang_fr_1.LANG_FR_NAME] = lang_fr_1.LANG_FR_TRANS,
	    _a[lang_pl_1.LANG_PL_NAME] = lang_pl_1.LANG_PL_TRANS,
	    _a
	);
	// providers
	exports.TRANSLATION_PROVIDERS = [
	    { provide: exports.TRANSLATIONS, useValue: dictionary },
	];
	var _a;


/***/ },
/* 72 */
/***/ function(module, exports) {

	// https://scotch.io/tutorials/simple-language-translation-in-angular-2-part-2
	"use strict";
	// lang-en.ts
	// 'hello world': 'hello world',
	// 'hello greet': 'Hello, %0 %1!',
	// 'well done': 'Well done %0',
	// 'good bye': 'bye bye',
	exports.LANG_EN_NAME = "en";
	exports.LANG_EN_TRANS = {
	    LblWeekdays: {
	        shorthand: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
	        longhand: [
	            "Sunday",
	            "Monday",
	            "Tuesday",
	            "Wednesday",
	            "Thursday",
	            "Friday",
	            "Saturday"
	        ]
	    },
	    LblMonths: {
	        shorthand: [
	            "Jan",
	            "Feb",
	            "Mar",
	            "Apr",
	            "May",
	            "Jun",
	            "Jul",
	            "Aug",
	            "Sep",
	            "Oct",
	            "Nov",
	            "Dec"
	        ],
	        longhand: [
	            "January",
	            "February",
	            "March",
	            "April",
	            "May",
	            "June",
	            "July",
	            "August",
	            "September",
	            "October",
	            "November",
	            "December"
	        ]
	    },
	    LblButtonText: {
	        today: "Today",
	        month: "Month",
	        week: "Week",
	        day: "Day",
	        list: "List"
	    },
	    // Common Name
	    LblActivityLog: "Activity Log",
	    LblEdit: "Edit",
	    LblDelete: "Delete",
	    LblRemove: "Remove",
	    LblActiveInactive: "Active/Inactive",
	    LblActive: "Active",
	    LblInactive: "Deactivate",
	    LblInactiveReason: "Inactive Reason",
	    LblAddNew: "Add New",
	    LblAdd: "Add",
	    LblUpdate: "Update",
	    LblSave: "Save",
	    LblCancel: "Cancel",
	    LblReset: "Reset",
	    LblSelect: "Select",
	    LblSuccess: "Success",
	    LblWarning: "Warning",
	    LblList: "List",
	    LblAssign: "Assign",
	    LblHome: "Home",
	    LblYes: "Yes",
	    LblOK: "Ok",
	    LblNo: "No",
	    LblBack: "Back",
	    LblReason: "Reason",
	    LblRecordSavedSuccess: "Record Saved Successfully",
	    LblRecordDeleteSuccess: "Record Deleted Successfully",
	    LblResetPasswordSuccess: "Password Reset successfully",
	    LblConfirm: "Confirm",
	    LblBlockUnblockConfirm: "Are you sure you want to %0 the %1 ?",
	    LblRecordDeleteConfirmation: "Are you sure you want to remove %0 ?",
	    LblRecordMultiplDeleteConfirmation: "Are you sure you want to remove selected %0?",
	    LblConfirmMessage: "Are you sure?",
	    LblResetPassword: "Reset Password",
	    LblResetPasswordConfirmation: "Are you sure you want to reset password?",
	    LblGeoLocationError: "Please Enter Correct Geo Location",
	    LblPersonDeleteCheck: "Delete permanently",
	    LblBookingCancelSuccess: "Bookings Canceled successfully",
	    LblBookingAbortSuccess: "Booking Aborted successfully",
	    LblBookingRevokeSuccess: "Booking Revoked successfully",
	    LblContactPersonRemoveSuccess: "Contact Person removed successfully",
	    LblContactPersonAddedSuccess: "Contact Person added successfully",
	    LblNoRecords: "No Record Available",
	    LblAffectedBookingList: "Affected booking list",
	    LblSubscriptionEndDateError: "Please Enter Subscription End Date",
	    LblIsSpecialPeriodAllow: "Would you like to apply special period Cost? If Applicable",
	    LblContractSlotisnotdefined: "Contract Type for below given time slot is not defined",
	    LblUnscubscribeSuccess: "Unsubscribe Successfully",
	    LblModifiedBy: "Modified By",
	    LblModifiedDate: "Modified Date",
	    LblContractTypeGroupAvailableForSubscription: "No Contract Type Group available to add new %0.",
	    LblRemoveContactPersonConfirm: "Are you sure you want to remove Contact Person?",
	    LblBookingApproveRejectSuccess: "%0 %1 successfully",
	    LblRecordAddedSuccess: "%0 added successfully.",
	    LblRecordUpdatedSuccess: "%0 updated successfully.",
	    LblRecordRemovedSuccess: "%0 removed successfully",
	    LblRecordActiveInActiveSuccess: "%0 %1 successfully.",
	    LblinvoiceResendSuccess: "%0 resend successfully",
	    LblRecordBlokUnBlockSuccess: "%0 %1 successfully.",
	    LblEditPage: "Edit %0",
	    LblAddPage: "Add %0",
	    LblListPage: "%0 List",
	    LblKilometers: "Kilometer",
	    LblKM: "Km",
	    LblDeletePersonNote: "Pending invoices for this person will not be sent",
	    LblFileNotFound: "The File does not exist, contact the helpdesk",
	    //'LblRecordUnBlockedSuccess':'%0 unBlocked successfully',
	    //Instance Clone
	    'LblInstanceClone': 'Instance Clone',
	    'LblNewInstanceName': 'New Instance Name',
	    'LblCloneResult': 'Clone Result',
	    'LblCloneStatus': 'Clone Status',
	    'CloneError': 'Error occurred While Cloning the Instance And It\'s Corresponding Entities.',
	    //Instance Page
	    LblCarwiseEnable: "Carwise Enabled",
	    LblAdminDependencyValidationOnDelete: "Selected Admin cannot be deleted because it is associated with other entity.",
	    LblAdminDependencyValidation: "Admin Role cannot be removed because it is associated with other entity.",
	    LblAdminDependencyAlert: "Admin Dependency Alert",
	    LblCarwiseConfiguration: "Carwise Configuration",
	    LblCarwiseConnectionUrl: "Connection Url",
	    LblCarwiseConnectionUsername: "Connection Username",
	    LblCarwiseConnectionPassword: "Connection Password",
	    LblCarwiseAutoDeleteFrequencyInDays: "AutoDelete Frequency(InDays)",
	    LblDamageImageExtentions: "Damage Image Extensions",
	    LblInstance: "Instance",
	    LblWegoAdminDependencyValidation: "WeGo Admin cannot be deleted because it is associated with other entity",
	    LblInstanceName: "Instance Name",
	    LblInstanceType: "Instance Type",
	    LblDescription: "Description",
	    LblCurrencySymbol: "Currency Symbol",
	    LblPreferredLanguage: "Language",
	    LblTimeZone: "Time Zone",
	    LblCurrencyAbbreviation: "Currency Abbreviation",
	    LblInstanceDeleteValidation: "Cannot Delete Instance Due To Association With Other Entity",
	    LblIsBookingApprovalReq: "Booking Approval Required",
	    LblInstanceConfiguration: "Instance Configuration",
	    LblBookingAlertTime: "Booking Alert Time",
	    LblBookingCancelTime: "Booking Cancel Time",
	    LblBookingTemporaryTime: "Provisional Booking Time",
	    LblVtsRequestTimeout: "VTS Request Timeout",
	    LblVtsTripLogTimeout: "VTS Triplog Timeout",
	    LblEmailConfiguration: "Email Configuration (SMTP)",
	    LblInSeconds: "In Seconds",
	    LblFromEmail: "From Email",
	    LblHost: "Host",
	    LblPort: "Port",
	    LblEnableSsl: "Enable SSL",
	    LblSmtpEmail: "SMTP Email",
	    LblBookingCancelTimeMessage: "This defines time (in seconds) after which booking cancellation will not be possible",
	    LblBookingTemporaryTimeMessage: "Time for provisional Booking. When user has selected the vehicle to book but has not yet been confirmed.",
	    LblVtSRequestTimeoutMessage: "Time out period for Lock/Unlock command within mobile App.",
	    LblVtsTriplogTimeoutMessage: "Time out period for calculating the trip after executing lock command.",
	    LblContractTypeDeleteValidation: "Cannot Delete Contract Type Group Due To Association With Other Entity",
	    LblSelectFuelType: "Select Fuel Type",
	    LblSelectPricingCatagory: "Select Pricing Catagory",
	    LblSelectBodyStyle: "Select Body Style",
	    LblSelectVehicleClass: "Select Vehicle Class",
	    LblIsImportPersonAllow: "Allow importing person",
	    LblValidateLicenseA2SP: "A2SP License Check",
	    LblValidateLicense24IDCheck: "24ID License Check",
	    LblValidateLicenseForAllBookings: "Revalidate license every booking",
	    LblGeofenceLocation: "Geofence Location",
	    LblRadius: "Radius",
	    LblEmailRecepients: "Email Recipients",
	    LblRecepients: "Recipients",
	    LblEmailAddresses: "Email addresses",
	    LblMap: "Map",
	    // AFAS/Azure Config
	    LblImportConfiguration: "Import Configuration",
	    LblImportConnectionType: "Connection Type",
	    LblAfas: "AFAS",
	    LblAzure: "Azure",
	    LblAzureTenantId: "Azure Tenant ID",
	    LblAzureClientId: "Azure Client ID",
	    LblAzureClientSecret: "Azure Client Secret",
	    LblAfasClientId: "AFAS Client ID",
	    LblAfasConnectorName: "AFAS Connector Name",
	    LblAfasConnectionType: "AFAS Connection Type",
	    LblAfasTest: "Test",
	    LblAfasAccept: "Acceptation",
	    LblAfasProduction: "Production",
	    LblAfasToken: "AFAS Token",
	    LblAfasClientIdError: "Please enter AFAS Client ID",
	    LblAfasConnectorNameError: "Please enter AFAS Client ID",
	    LblAfasConnectionTypeError: "Please enter AFAS Connection Type",
	    LblAfasTokenError: "Please enter AFAS-Token",
	    LblAzureTenantIdError: "Please enter Azure Tenant ID",
	    LblAzureClientIdError: "Please enter Azure Client ID",
	    LblAzureClientSecretError: "Please enter Azure Client Secret",
	    // SSO Config
	    LblSsoConfiguration: "SSO Configuration",
	    LblDefaultSsoSharedVehicleGroup: "Default Shared Vehicle Group",
	    LblDefaultSsoOrganization: "Default Organization",
	    LblDefaultSsoSubscription: "Default Subscription",
	    // Dropoff Message
	    LblDropoffMessageConfiguration: "Dropoff Message Configuration",
	    LblDropoffMessageExternalUrl: "External Url",
	    LblDropoffMessageApiKey: "Api Key",
	    LblDropoffMessageActive: "Active",
	    LblValidate: "Validate",
	    LblRejection: "Rejection",
	    LblrejectionReasonMsg: "Please Provide Reason For rejection of selected booking requests",
	    LblApproveConfirmationMsg: "Are You Sure you want to approve all selected booking request ?",
	    LblBookingCalanderSettings: "Booking calendar settings",
	    LblShowDriverInfo: "Show driver information in booking calendar",
	    LblOrganizationAdmin: "Organization Admin",
	    LblDriverInfoToShow: "Driver information to show",
	    //Person Page
	    LblUserName: "Username",
	    LblFirstName: "First Name",
	    LblLastName: "Last Name",
	    LblEmail: "Email",
	    LblMobileNumber: "Mobile Number",
	    LblPhoneNumber: "Phone Number",
	    LblHomeAddress: "Home Address",
	    LblWorkAddress: "Work Address",
	    LblHouseNo: "House No",
	    LblHouseExtention: "House Extension",
	    LblStreetName: "Street Name",
	    LblCity: "City",
	    LblZipCode: "Zip Code",
	    LblPassword: "Password",
	    LblConfirmPassword: "Confirm Password",
	    LblMiddleName: "Middle Name",
	    LblMandateId: "Mandate Id",
	    LblMandateSignatureDate: "Mandate Signature Date",
	    LblIsAmmandment: "Is Ammandment",
	    LblRemovePersonDetails: "Remove Person Details",
	    LblMonitoring: "Monitoring",
	    LblDropoffMessage: "Dropoff message",
	    LblPreferredlanguage: "Preferred language",
	    LblDebtornr: "Debtornumber",
	    LblEnableLogin: "Enable Login",
	    LblEnableErrorEscalation: "Enable Error Escalation",
	    LblErrorEscalationMinutes: "Error Escalation Minutes",
	    //Booking Type
	    LblNORMALBOOKINGTYPE: 'NORMAL',
	    LblMAINTENANCEBOOKINGTYPE: 'MAINTENANCE',
	    LblUNAVAILABLEBOOKINGTYPE: 'UNAVAILABLE',
	    //Booking Status
	    LblABORTED: 'ABORTED',
	    LblCANCELLED: 'CANCELLED',
	    LblCONFIRMED: 'CONFIRMED',
	    LblFINISHED: 'FINISHED',
	    LblNOSHOW: 'NOSHOW',
	    LblPENDING: 'PENDING',
	    LblREVOKED: 'REVOKED',
	    LblRUNNING: 'RUNNING',
	    LblREADYFORPAYMENT: 'READYFORPAYMENT',
	    //Invoice Status
	    LblOPEN: 'OPEN',
	    LblSENT: 'SENT',
	    LblCLOSED: 'CLOSED',
	    LblREQUESTFORPAYMENT: 'REQUESTFORPAYMENT',
	    LblREOPEN: 'REOPENED',
	    //Booking Request Status
	    LblAPPROVEDBOOKINGREQUEST: 'APPROVED',
	    LblREJECTEDBOOKINGREQUEST: 'REJECTED',
	    LblPENDINGBOOKINGREQUEST: 'PENDING',
	    // Error Log
	    LblErrorLog: "Error Log",
	    LblComponentName: "Component Name",
	    LblLogType: "Log Type",
	    LblEventDateTime: "Event DateTime",
	    // Interface Status
	    LblInterfaceStatus: "Interface Status",
	    LblLastStatusChangeDateTime: "Last Status Change DateTime",
	    LblLastCarwisePollDateTime: "Last Carwise Poll DateTime",
	    LblUpdatedDateTime: "Updated DateTime",
	    //ErrorEscalation
	    LblDuplicateErrorEscalation: "Duplicate Error Escalation Configuration Found",
	    LblErrorEscalation: "Error Escalation",
	    LblComponent: "Component",
	    LblSelectAdminLevel: "Select Admin Level",
	    LblWegoAdminLevel: "Wego Admin Level",
	    LblCustomerAdminLevel: "Customer Admin Level",
	    LblInstanceAdminLevel: "Instance Admin Level",
	    //Company Page
	    LblCompany: "Company",
	    LblCompanyName: "Company Name",
	    LblContactPerson: "Contact Person",
	    LblCompanyAdmin: "Company Admin",
	    LblCompanyAddress: "Company Address",
	    LblInternalOrganization: "Internal Organization",
	    LblNoOfVegicles: "No.Of Vehicles",
	    LblNoOfSharedVehicleGroups: "No.Of SVG",
	    LblGeoLocation: "Geo Location",
	    LblSelectGeoLocation: "Select Location",
	    LblPerson: "Person",
	    LblRole: "Roles",
	    LblDateOfBirth: "Date Of Birth",
	    LblDriverLicenceNumber: "Driver Licence Number",
	    LblApkExiprationSetting: "Periodic Maintenance Notification Settings",
	    LblApkTimeInterval: "Notification Time Interval",
	    LblEmailNotification: "Email Notification",
	    LblNotificationFrequency: "Notification Frequency",
	    lblThresholdFrequency: "Threshold Frequency",
	    lblThresholdTimeInterval: "Threshold Time Interval",
	    LblIsEmailEnabled: "Notification Email",
	    lblThreshold: "Threshold Period",
	    LblFrequency: "Frequency",
	    LblDay: "Day",
	    LblWeek: "WEEK",
	    LblMonth: "Month",
	    lblPerBooking: "Perbooking",
	    LblPersons: "Persons",
	    LblPersonOverview: "Person Overview",
	    LblCompanies: "Companies",
	    //Vehicle Page
	    LblVehicle: "Vehicle",
	    LblVtsVehicle: "VTS Vehicle",
	    LblFleetId: "Fleet ID",
	    LblContractId: "Contract ID",
	    LblVIN: "VIN",
	    LblLicenceTag: "Licence Tag",
	    LblLicence: "Licence",
	    LblMobile: "Mobile",
	    LblVehicleOwner: "Vehicle Owner",
	    LblLocationDataExchange: "Location Data Exchange",
	    LblBrand: "Brand",
	    LblType: "Type",
	    LblColor: "Color",
	    LblVehicleClass: "Vehicle Class",
	    LblPricingCategory: "Pricing Category",
	    LblBodyStyle: "Body Style",
	    LblAvailable: "Available",
	    LblUnAvailable: "Unavailable",
	    LblAvailableFrom: "Available From",
	    LblAvailableTo: "Available to",
	    LblFuelType: "Fuel Type",
	    LblMinBookingTimeBefore: "Minimum time available before booking (minutes)",
	    LblMinBookingTimeAfter: "Minimum time available after booking (minutes)",
	    LblTowbar: "Towbar",
	    LblAirco: "Airco",
	    LblVehicleAttributes: "Vehicle Attributes",
	    LblBlockUnBlock: "Block/Unblock",
	    LblRemoveLicense: "Remove License",
	    LblRemoveLicenseBirthDate: "Remove License and Birth Date",
	    LblLicenseBirthDate: "Birth Date",
	    LblBlock: "Block",
	    LblUnblock: "Unblock",
	    LblAvailableUnAvailable: "Available/Unavailable",
	    LblVehicles: "Vehicles",
	    LblBookingsOverview: "Bookings Overview",
	    LblApkExpirationDateCet: "Periodic Maintenance Expiration Date",
	    LblEnabled: "Enabled",
	    LblDisabled: "Disabled",
	    LblIntialOdometerValue: "Initial Odometer Value",
	    LblFuelCardPinCode: "Fuel Card Pin Code",
	    LblFuel: "Fuel",
	    LblVINnumber: "VIN number",
	    LblVehicletype: "Vehicle type",
	    LblDoors: "Number of doors",
	    LblWeight: "Vehicle weight",
	    LblTrunkSpace: "Trunk space",
	    LblGears: "Number of gears",
	    LblEngineHorsepower: "Engine horsepower (hp)",
	    LblFuelConsumption: "Fuel consumption",
	    LblSeats: "Number of seats",
	    LblDimensions: "Vehicle dimensions",
	    LblTransmissionType: "Transmission type",
	    LblTransmissionUnknown: "Unknown",
	    LblManualTransmission: "Manual",
	    LblAutomaticTransmission: "Automatic",
	    LblVehicleDetails: "Vehicle details",
	    LblSelectVehicletype: "Select vehicle type",
	    LblWrongVinNumber: "Wrong VIN number",
	    //WEGO2DEV-325(Settings for Dashboard statuses)
	    LblVehicleOnSameLocationTime: "Vehicle at same location for more than",
	    LblNoBookingIn: "Vehicle not booked in more than",
	    lblHour: "Hour",
	    //'lblInterval':'HOUR/DAY/WEEK/MONTH',
	    lblHourDayWeekMonth: "Hour / Day / Week / Month",
	    //SharedVehicleGroup
	    LblSharedVehicleGroup: "Shared Vehicle Group",
	    LblVehicleGroup: "Vehicle Group",
	    LblSharedVehicleGroupAdmin: "Shared Vehicle Group Admin",
	    LblDisplayPeriod: "Display Period",
	    LblBookingWeekDays: "Booking WeekDays",
	    LblBookingInterval: "Booking Interval (minutes)",
	    LblBookingStartTime: "Booking Start Time (hh:mm)",
	    LblBookingEndTime: "Booking End Time (hh:mm)",
	    LblBookingMinDuration: "Minimum Booking Duration (minutes)",
	    LblBookingMaxDuration: "Maximum Booking Duration (minutes)",
	    LblMaxRecurringBooking: "Maximum Recurring Booking",
	    LblPreBookingInterval: "Pre-Booking Interval (minutes)",
	    LblPostBookingInterval: "Post-Booking Interval (minutes)",
	    LblBookingExtensionTime: "Max. Booking Extension Time (minutes)",
	    LblBookAheadTime: 'Booking possible "X" minutes after now',
	    LblBookingHorizon: "Booking Horizon",
	    LblNumberOfContactTypeGroup: "No.Of Contract Type Groups",
	    LblNumberOfContactType: "No.Of Contract Type",
	    LblInvoiceInterval: "Invoice Interval",
	    LblIsBookingIntervalAlignToCalendar: "Align Booking Interval To Calender",
	    LblBookings: "Bookings",
	    LblSharedVehicleGroups: "Shared Vehicle Groups",
	    LblSharedVehicleGroupOverview: "Shared Vehicle Group Overview",
	    LblEarlyOpenInterval: "Early Open Interval (minuten)",
	    LblFeatureFlags: "Feature Flags",
	    LblCreateBooking: "Create Booking",
	    LblEditBooking: "Edit Booking",
	    LblLicenseCheck: "License Check",
	    LblBookingLicenseCheck: "Booking License Check",
	    //Driver
	    LblDriver: "Driver",
	    LblLicenceNumber: "Licence No",
	    LblDriverName: "Driver Name",
	    LblDriverSVG: "Driver Shared Vehicle Group",
	    LblDriverUserName: "Driver Username",
	    //VehicleAttribute
	    LblVehicleAttributeCategory: "Vehicle Attribute Category",
	    LblVehicleAttributeName: "Attribute Name",
	    LblVehicleAttributeDesc: "Description",
	    LblVehicleAttribute: "Vehicle Attribute",
	    LbAdditionallVehicleAttribute: "Additional Vehicle Attributes",
	    LblVehicleAttributeCategories: "Vehicle Attribute Categories",
	    //ContractType Page
	    LblRegular: "Regular",
	    LblWeekEnd: "Weekend",
	    LblDayCT: "Day",
	    LblExtraTimeBefore: "Extra Time Before (Minute)",
	    LblExtraTimeAfter: "Extra Time After (Minute)",
	    LblFreeTextDescription: "Specify the special booking rate plus begin and end times (free text)",
	    LblPeriodRate: "Period Rate",
	    LblPeriodRateVat: "Period Rate VAT",
	    LblSelectContractTypeType: "Select Contract Type Type",
	    LblContractTypeType: "Contract Type Type",
	    LblContractType: "Contract Type",
	    LblContractName: "Contract Name",
	    LblContractTypeGroup: "Contract Type Group",
	    LblContractTypeGroupName: "Contract Type Group Name",
	    LblContractAvailableDays: "Contract Available Days",
	    LblApplicableDays: "Applicable Days",
	    LblDayStartTime: "Day Start Time (hh:mm)",
	    LblDayEndTime: "Day End Time (hh:mm)",
	    LblApplicableStartTime: "Applicable Start Time (hh:mm)",
	    LblApplicableEndTime: "Applicable End Time (hh:mm)",
	    LblComment: "Comment",
	    LblProcessingFee: "Processing Fee",
	    LblVatPercentage: "VAT Percentage",
	    LblVatIncludedInPrice: "VAT Included In Price",
	    LblPlateformUsageCost: "Platform Usage Cost",
	    LblCatA: "Category A",
	    LblCatB: "Category B",
	    LblCatC: "Category C",
	    LblCatD: "Category D",
	    LblCatE: "Category E",
	    LblCatF: "Category F",
	    LblCatG: "Category G",
	    LblCatH: "Category H",
	    LblHourlyRate: "Time Cost",
	    LblMileageRate: "Mileage Rate",
	    LblFixedFee: "Fixed Fee",
	    LblPricingModel: "Pricing Model",
	    LblContractStartDateTime: "Contract Start Date/Time",
	    LblContractEndDateTime: "Contract End Date/Time",
	    LblContractTypeHistory: "History",
	    LblContractTypPeriod: "Contract Type Period",
	    LblInactiveContractTypeGroupReason: "Reason for deactivating Contract Type Group",
	    LblPenaltyAmount: "Penalty Amount",
	    LblPenaltyTimeInterval: "Penalty Time Interval (minutes)",
	    LblIsPenaltyEnabled: "Penalty Enabled",
	    LblTripDisplayType: "How should trips be presented in reports?",
	    LblAllTripsIndividually: "All trips individually",
	    LblAllTripsGrouped: "All trips grouped in one single trip",
	    // DateTime Picker
	    LblJanuary: "January",
	    LblFebruary: "February",
	    LblMarch: "March",
	    LblApril: "April",
	    LblMay: "May",
	    LblJune: "June",
	    LblJuly: "July",
	    LblAugust: "August",
	    LblSeptember: "September",
	    LblOctober: "October",
	    LblNovember: "November",
	    LblDecember: "December",
	    LblSJan: "Jan",
	    LblSFeb: "Feb",
	    LblSMar: "Mar",
	    LblSApr: "Apr",
	    LblSMay: "May",
	    LblSJun: "Jun",
	    LblSJul: "Jul",
	    LblSAug: "Aug",
	    LblSSep: "Sep",
	    LblSOct: "Oct",
	    LblSNov: "Nov",
	    LblSDec: "Dec",
	    LblSunday: "Sunday",
	    LblMonday: "Monday",
	    LblTuesday: "Tuesday",
	    LblWednesday: "Wednesday",
	    LblThursday: "Thursday",
	    LblFriday: "Friday",
	    LblSaturday: "Saturday",
	    LblSSu: "Su",
	    LblSMo: "Mo",
	    LblSTu: "Tu",
	    LblSWe: "We",
	    LblSTh: "Th",
	    LblSFr: "Fr",
	    LblSSa: "Sa",
	    //Forgot Password
	    LblForgotPassword: "Forgot Password",
	    LblChangePassword: "Change Password",
	    LblOldPassword: "Old Password",
	    LblNewPassword: "Password",
	    LblProfileUpdatedSucessFully: "Profile updated successfully",
	    LblPasswordChangedSucessFully: "You have successfully changed your password",
	    //
	    LblUpdateProfile: "Update Profile",
	    LbLReasonVehicle: "Unavailability Reason",
	    LblReasonDriver: "Reason for block driver",
	    //Booking
	    LblFrom: "From",
	    LblApprovalAdminName: "Approved by admin",
	    LblApprovedRejectedby: "Approved/Rejected by",
	    LblBookingRequestList: "Booking Request List",
	    LblTo: "To",
	    LblBooking: "Booking",
	    LblBookingRequest: "Booking Request",
	    LblOverview: "Booking Overview",
	    LblOverviewList: "Booking Overview List",
	    LblApproveBooking: "Booking Approval",
	    LblApprove: "Approve",
	    LblBookingApprovedSuccessMsg: "Selected Booking Requests Approved Successfully",
	    LblBookingRejectedSuccessMsg: "Selected Booking Requests Rejected Successfully",
	    LblReject: "Reject",
	    LblNormal: "New Booking",
	    LblSpecial: "Special Booking",
	    LblHistory: "Booking History",
	    LblBookingStatus: "Booking Status",
	    LblBookingType: "Booking Type",
	    LblAdminRemarks: "Admin Remarks",
	    LblBookingRemarks: "Booking Remarks",
	    LblDriverRemarks: "Driver Remarks",
	    LblBookingReferenceId: "Booking Id",
	    SelectionRequiredMsg: "Please select at least one booking to approve/reject",
	    LblSelectionRequired: "Selection Required",
	    LblAbort: "Abort",
	    LblRevoke: "Revoke",
	    LblStatus: "Status",
	    LblReference: "ReferenceID",
	    LblRemarks: "Remarks",
	    LblSearchForVehicle: "Search for Vehicle",
	    LblVehicleOverview: "Vehicle Overview",
	    LblConfirmBooking: "Confirm Booking",
	    LblCurrentBookingDetail: "Current Booking Detail",
	    LblCheckAvailability: "Check Availability",
	    LblBookingStartDateTime: "Booking Start",
	    LblBookingEndDateTime: "Booking End",
	    LblSource: "Source",
	    LblRecurring: "Recurring",
	    LblRecurringId: "Recurring Id",
	    LblRecurringBookingReference: "Recurring Booking Reference",
	    LblDaily: "Daily",
	    LblWeekly: "Weekly",
	    LblMonthly: "Monthly",
	    LblRecurrenceEndDate: "Recurrence End Date",
	    LblSearch: "Search",
	    LblBookNow: "Book Now",
	    LblUpdateBooking: "Update Booking",
	    LblEditCarNotAvailable: "Original booked car is not available",
	    LblSortBy: "Sort By",
	    LblAvaibility: "Avaibility",
	    LblDistance: "Distance",
	    LblNoMatchingVehicle: "No matching vehicles are found",
	    LblAvailableSlots: "Available Slots",
	    LblFeatures: "Features",
	    LblDriverDetail: "Driver Details",
	    LblBookingDetail: "Booking Details",
	    LblVehicleDetail: "Vehicle Details",
	    LblBookingSuccess: "You created a Booking request successfully. A copy of the request is sent to registered e-mail address. A notification is also sent for approval and you will be notified when the booking is accepted.",
	    LblBookingUpdateSuccess: "Booking updated successfully. A notification is sent to driver's email address.",
	    LblBlockNormalBooking: "Your account is blocked. Please contact administrator.",
	    LblSingle: "Single",
	    LblSeries: "Series",
	    LblAll: "All",
	    LblLicenceRequired1: "Please validate Licence Number, Go to",
	    LblLicenceRequired2: "to update Licence Number details",
	    LblAcceptOrReject: "Approve / Reject",
	    //Special Booking
	    LblSpecialBooking: "Special Booking",
	    LblAffectedBooking: "Affected Booking",
	    LblSpecialBookingType: "Special Booking Type",
	    LblSelectSpecialBookingType: "Select Special Booking Type",
	    LblSpecialBookingConfiramtionmsg: "Are you sure to create special booking ?",
	    LblEndDate: "Recurrence End Date",
	    // Notification
	    LblNotification: "Notification",
	    LblSubject: "Subject",
	    LblDate: "Date",
	    LblWelcomeNotification: "Welcome to WeGo Notification Inbox",
	    //Template
	    LblTemplate: "Template",
	    LblTemplateList: "Template List",
	    LblTemplateName: "Template Name",
	    LblTemplateType: "Template Type",
	    LblBody: "Body",
	    LblIsEmailTemplate: "Email",
	    LblIsWebTemplate: "Web",
	    // Notification Event Management
	    LblNotificationEventManagement: "Notification Events Management",
	    LblNotificationEvent: "Notification Event",
	    LblModuleName: "Module Name",
	    LblSMS: "SMS",
	    //User Type
	    LblUserType: "User Type",
	    //TimeBlock
	    LblTimeBlock: "Time Block",
	    LblTimeBlockName: "TimeBlock Name",
	    LblTimeBlockWeekDays: "TimeBlock WeekDays",
	    LblTimeBlockStartTime: "TimeBlock StartTime",
	    LblTimeBlockEndTime: "TimeBlock EndTime",
	    LblTimeBlockStartDate: "TimeBlock StartDate",
	    LblTimeBlockEndDate: "TimeBlock EndDate",
	    // Service Offer
	    LblServiceOffer: "Service Offer",
	    LblServiceOfferList: "Service Offer List",
	    LblServiceOfferName: "Offer Name",
	    LblServiceOfferType: "Offer Type",
	    LblStandardTariff: "Standard Tariff",
	    LblTimeUsedOrBooked: "Time Used/Booked",
	    LblPenalty: "Penalty",
	    LblAdditional: "Additional",
	    LblAdditionalAbbr: "Add'l",
	    LblUnit: "Unit",
	    //WegoAdminList
	    LblWegoAdmin: "WeGo Admin",
	    LblWegoAdmins: "Wego Admins",
	    LblReSend: "Resend",
	    LblResendActivationMail: "Activation email",
	    LblResendActivationMailFailure: "Failed to send activation email",
	    LblResendActivationMailSuccess: "Activation email sent",
	    //Subscription
	    LblSubscription: "Subscription",
	    LblSubscriptionName: "Subscription Name",
	    LblTimeInterval: "Time Interval",
	    LblAmount: "Amount",
	    LblFreeKilometer: "Free Credits",
	    LblFreeMinute: "Free Minutes",
	    LblFreeHours: "Free Hours",
	    LblNumberOfSubscription: "No.Of Subscriptions",
	    LblUnsubscribe: "Unsubscribe",
	    LblsubscribeEndDate: "Subscription End Date",
	    LblSubscriptionStartDate: "Subscription Start Date",
	    //Special Period
	    LblSpecialPeriod: "Special Period",
	    LblspecialPeriodName: "Special Period Name",
	    LblSpecialPeriodStartTime: "Special Period Start Time",
	    LblSpecialPeriodEndTime: "Special Period End Time",
	    LblSpecialPeriodWeekDays: "Special Period WeekDays",
	    LblNormalPeriod: "Normal Period",
	    LblSpecialPeriods: "Special Periods",
	    //Booking InvoiceModel
	    LblBookingInvoice: "Booking Invoice",
	    LblInvoiceStatus: "Invoice Status",
	    LblInvoiceType: "Invoice Type",
	    LblSummary: "Summary",
	    LblTotalHours: "Total Hours",
	    LblTotalKm: "Total distance (km.)",
	    LblTotalExpense: "Total Expense",
	    LblInvoiceNumber: "Invoice Number",
	    LblBegin: "Begin",
	    LblEnd: "End",
	    LblVat: "VAT",
	    LblDone: "Done",
	    LblClear: "Clear",
	    LblTotal: "Total",
	    LblInvoiceRequestDateTime: "Invoice Request DateTime",
	    LblInvoiceSendDateTime: "Invoice Send DateTime",
	    LblInvoiceDateTime: "Invoice  DateTime",
	    LblInvoiceDetail: "Invoice Detail",
	    LblResend: "Resend",
	    LblDownload: "Download",
	    LblResendInvoiceConfirm: "Are you sure to resend %0?",
	    LblSendInvoiceConfirm: "Are you sure you want to send the invoice?",
	    LblPenaltyRate: "Penalty Rate",
	    LblInvoicing: "Invoicing",
	    LblInvoices: "Invoices",
	    LblProfile: "Profile",
	    LblSignOut: "Sign out",
	    LblTemplateNote1: "Please do not change/remove the text written like this { variablename }. It is a dynamic attribute name which will be replaced with actual database entry when email will be sent to user.",
	    LblTemplateNote2: "Please do not modify the table structure. You can create a new one. However, old one should not be modified.",
	    LblTemplateNote3: 'Please make sure once you copy placeholder and while paste it in html editor, you have to do "Paste as plain text".',
	    LblConfirmUnsubscribe: "Are you sure you want to unsubscribe?",
	    LblDriveHours: "Drive Hours",
	    LblVehicleImage: "Vehicle Image",
	    LblMaintenance: "Maintenance",
	    LblUNAVAILABLE: "Unavailable",
	    LblTestInvoiceGenerator: "Test Invoice Generator",
	    LblMissingInvoiceGenerator: "Missing Invoice Generator",
	    LblInvoicingDateTime: "Invoicing DateTime (UTC)",
	    LblGenerateInvoice: "Generate Invoice",
	    LblDeleteAllSelectedRecords: "Delete All Selected Record",
	    LblCancelAllSelectedRecords: "Cancel All Selected Records",
	    "LblExportAll(CSV)": "Export All(CSV)",
	    LblAddContactPerson: "Add Contact Person",
	    LblRemoveContactPerson: "Remove Contact Person",
	    LblNote: "Note",
	    LblCompletelyEndConfirm: "Completely End Trip",
	    LblEndTrip: "End Trip",
	    LblTestTrip: "Test Trip",
	    LblTripSimulator: "Trip Simulator",
	    LblPrePostTripQuestions: "Pre and Post Trip Questions",
	    LblTestTripSuccess: "Test Trip created Successfully",
	    LblDrivingStartDateTime: "Driving Start Date / Time",
	    LblDrivingEndDateTime: "Driving End Date / Time",
	    LblInvoiceMoment: "Invoice Moment",
	    LblExtend: "Extend",
	    LblExtendRequire: "Please Enter Booking Extension Time (minutes)",
	    LblExtendInfoMsg: "You can extend booking up to %0 min",
	    LblExtendValidationMsg: "This booking cannot be extended",
	    LblExtendBooking: "Extend Booking",
	    LblBookingExtendedSuccess: "Booking extended successfully",
	    LblOverExtendValidationMsg: "Booking cannot be extended by more than %0 minutes",
	    LblUnLock: "UnLock",
	    LblLock: "Lock",
	    LblVehicleStatus: "Vehicle Status",
	    LblTripSuccess: "Trip saved Successfully",
	    LblLockSuccessfully: "Vehicle Locked Successfully",
	    LblLockCompletelySuccessfully: "Vehicle Locked Successfully",
	    LblUnLockSuccessfully: "Vehicle UnLocked Successfully",
	    LblUnlockProblem: "Problem during Unlock command",
	    LbllockProblem: "Problem during lock command",
	    LblLockCarCompletely: "Lock and close Booking",
	    LblStartDateTime: "Start Date/Time",
	    LblEndDateTime: "End Date/Time",
	    LblBookingTripDetail: "Booking Trip Detail",
	    LblAddNewTrip: "Add New Trip",
	    LblBookingExpenseDetail: "Booking Expense Details",
	    LblUnlockErrorMessage: "No Active Contract Type Group Available At Booking Creation Time",
	    LblExpenseAmount: "Expense Amount",
	    LblExpenseName: "Expense Name",
	    LblExpenseSuccess: "Expense saved Successfully",
	    LblReceipt: "Receipt",
	    LblHelpdeskNo: "Helpdesk No",
	    LblBookingExpired: "Vehicle Cannot be Unlock As Booking is Expired",
	    LblTripCalculationInProgress: "We hope you had a nice trip! The vehicle will close in a few seconds.",
	    LblVTSReqLogDetail: "VTS Request Log Detail",
	    LblVTSReqDateTime: "Request Date/Time",
	    LblVTSProcessTime: "Process Time",
	    LblVTSResTime: "Result Time",
	    LblVTSReqType: "Request Type",
	    LblVTSResult: "Result",
	    LblActualInvoiceGenerationDate: "Actual Invoice Generation Date",
	    LblAvailableForAllSlots: "Vehicle available for all slots",
	    LblUnAvailableSlots: "UnAvailable Slots",
	    LblNoOfDrivers: "No.Of Drivers",
	    LblSVGDriversList: "Shared Vehicle Group Drivers",
	    LblVehicleInformation: "Vehicle Information",
	    LblVTSVehicle: "VTS Vehicle",
	    LblVTSVehicleUpdateSuccess: "Vehicle %0 successfully.",
	    LblVTSVehicleList: "VTS Vehicle List",
	    //Report Damage
	    LblReportDamage: "Report Damage",
	    LblCompleteDamageReport: "Complete damage report",
	    LblDamageFile: "Damage File",
	    LblDescribe: "Describe the damage...",
	    LblCause: "Describe the cause...",
	    LblReportDamageMsg: "Damage Reported successfully",
	    LblSelectFile: "Please Select File",
	    // Import Data
	    LblCSVImport: "Import CSV",
	    LblValidateCSV: "Validate CSV",
	    LblImportValidPerson: "Import Valid Person",
	    LblImportValidDriver: "Import Valid Driver",
	    LblImportValidVehicle: "Import Valid Vehicle",
	    LblCSVType: "CSV Type",
	    LblCSVFile: "CSV File",
	    LblRecordImportedSuccess: "%0 are imported successfully",
	    LblInvalidReason: "Invalid Reason",
	    LblSameVTSCommand: "Request is already in progress. Please wait.",
	    LblImportPerson: "Import Person",
	    //Subscription related Changes
	    LblSubscriptionInterval: "Subscription Interval",
	    LblPaymentInterval: "Payment Interval",
	    LblInvoicInterval: "Invoice Interval",
	    LblInterval: "Interval",
	    LblInvoiceMomentDay: "Invoice Moment (Day of Week)",
	    LblInvoiceMomentMonth: "Invoice Moment (Day of Month)",
	    LblFreeMinuteInterval: "Free Minutes Interval",
	    LblFreeKMInterval: "Free Kilometers Interval",
	    LblSelectSubscriptionInterval: "Select Subscription Interval",
	    LblSelectInvoiceInterval: "Select Invoice Interval",
	    LblSelectPaymentInterval: "Select Payment Interval",
	    LblSelectFreeKMInterval: "Select Free Kilometer Interval",
	    LblSelectFreeMinInterval: "Select Minute Interval",
	    LblYearlySub: "Yearly",
	    LblMonthlySub: "Monthly",
	    LblWeeklySub: "Weekly",
	    LblFreePerWeek: "Per week",
	    LblFreePerMonth: "Per month",
	    LblFreePerTriMonth: "Per 3 months",
	    LblFreePerBiannual: "Per 6 months",
	    LblFreePerYear: "Per year",
	    LblDefaultContractTypeGroup: "Default Contract Type Group",
	    LblSelectDefaultContractTypeGroup: "Select Default Contract Type Group",
	    LblSendInvoiceToDriver: "Send Invoice To Driver",
	    LblInherit: "Inherit",
	    //Invoice Moment
	    LblDayOfMonth: "Day Of Month",
	    LblDayOfWeek: "Day Of Week",
	    LblSelectDayOfWeek: "Select Day Of Week",
	    LblInstanceLogo: "Instance Logo",
	    LblInvoiceDeleteValidation: "Cannot Delete Invoice Due To Association With Other Entity",
	    //SubscriptionAvailabilityRestriction
	    LblSubscriptionAvailabilityRestriction: "Subscription Availability Restriction",
	    LblStartDay: "Start Day",
	    LblEndDay: "End Day",
	    LblStartTime: "Start Time (hh:mm)",
	    LblEndTime: "End Time (hh:mm)",
	    LblRestriction: "Restriction",
	    LblTotalFreeKilometer: "Total Free Kilometer",
	    LblTotalFreeMinute: "Total Free Minute",
	    LblCurRemainFreeKilometer: "Remaining Free Kilometer",
	    LblPrevRemainFreeKilometer: "Previous Remaining Free Kilometers",
	    LblCurRemainFreeMinute: "Remaining Free Minute",
	    LblPrevRemainFreeMinute: "Previous Remaining Free Minutes",
	    LblResetPasswordFailure: "Password can not be reset because user is not yet activated.",
	    //Additional Free Item
	    LblAdditionalFreeItems: "Additional Free Credits",
	    LblDateAwared: "Date Awarded",
	    LblAdditionalFreeItemsMenu: "Additional Free Credits",
	    LblPrevious: "Previous",
	    LblCurrent: "Current",
	    LblTripDetailReport: "Trip Detail Report",
	    LblTripDetailList: "Detailed booking overview",
	    LblSearchTripforDriver: "Search Driver Booking Trips",
	    LblExportReport: "Export Report",
	    LblValidateLiceanceNumberMessage: "Please Validate Your Licence Number",
	    LblBookingIntervalRate: "Interval Rate",
	    LblPerHour: "Per Hour",
	    LblPerBookingIntarval: "Per Booking Interval",
	    LblTimeRate: "Time Rate",
	    LblToalBookingDuration: "Booking Duration",
	    LblTripComments: "Trip Comment",
	    LblTripCommentDescription: "Enter trip comment",
	    LblTripCommentError: "Please enter trip comment",
	    LblShowTripComment: "View comment",
	    LblAddTripComment: "Add comment",
	    LblTripCommentBy: "Trip Comment by",
	    LblTripCommentOn: "Trip Comment op",
	    LblCleanRequire: "Cleaning Required",
	    LblFualRequire: "Fuel Required",
	    LblVehicleDamageList: "Vehicle Damage List",
	    LblDamageCause: "Damage Cause",
	    LblDamageReportedBy: "Reported By",
	    LblDamageReportedOn: "Reported On",
	    LblConfirmResolveDamage: "Are you sure you want to resolve vehicle damage?",
	    LblVehicleDamgeResolveSuccess: "Vehicle damage resolved successfully",
	    LblDamageDesc: "Damage Description",
	    LblFutureBooking: "Future Bookings",
	    LblVehFutureBookingList: "Vehicle Future Booking List",
	    LblResolveDamge: "Resolve Damage",
	    LblReserved: "Reserved",
	    LblVehicleInfoSuccess: "Vehicle information updated successfully",
	    LblInformation: "Information",
	    LblVTSHistory: "VTS Event History",
	    LblWegoRequestTime: "WeGo Request Time",
	    LblVTSRequestTime: "VTS Request Time",
	    LblRequestType: "Request Type",
	    LblWegoProcessTime: "Wego Process Time",
	    LblResult: "Result",
	    LblWegoResultTime: "WeGo Result Time",
	    LblVTSResultTime: "VTS Result Time",
	    LblCommandInitiator: "Command Initiator",
	    LblTroubleShootVTS: "VTS Troubleshoot",
	    LblVtsServiceStatus: "VTS Service Status",
	    LblVtsLicencetag: "VTS Licence Tag",
	    LblVtsDoorStatus: "Door Status",
	    LblVtsIssueCommand: "Issue Command",
	    LblVehicleLocation: "Vehicle Location",
	    LblEventHistory: "VTS Event History",
	    LblView: "View",
	    LblVehicleObuStatus: "Vehicle Obu Status",
	    LblVehicleNotInitialized: "Vehicle Not Initialized",
	    LblLastReceivedTime: "Last Received Message Time",
	    LblFreePerBookingInterval: "Per Booking Interval",
	    LblSelectFilter: "Select Filter",
	    LblAuditEntries: "Audit Entries",
	    LblFilter: "Filter",
	    LblCategory: "Category",
	    LblEventName: "Event Name",
	    LblEventData: "Event Data",
	    LblMoment: "Moment",
	    LblUser: "User",
	    LblNoEventDataFound: "No Event Data Found",
	    LblEventViewer: "Event Viewer",
	    LblSelectObuType: "Select OBU Type",
	    LblObuType: "OBU Type",
	    LblDeviceId: "Device Id",
	    LblClaimCode: "Claim code",
	    LblVtsLocation: "VTS Location",
	    LblRetriveAddress: "Retrieve Address",
	    LblCrearedDate: "Created Date",
	    LblCreatedBy: "Created By",
	    LblPerBooking: "Perbooking",
	    LblOBU: "OBU",
	    LblClone: "Clone",
	    LblCloneVehicle: "Clone %0",
	    LblFualNotRequire: "Fuel Not Required",
	    LblCleanNotRequire: "Cleaning Not Required",
	    LblSubscriptionInfo: "Subscription Info",
	    LblVehiclDamaged: "Vehicle Damaged",
	    LblVehicleNotDamaged: "Vehicle Not Damaged",
	    LblDamage: "Damaged",
	    LblFreeBooking: "Adjust Booking Cost",
	    LblBookingCustomFee: "Booking Custom Cost",
	    LblFreeBookingSuccess: "Booking Cost Saved Successfully",
	    LblEnterLocation: "Enter Location",
	    LblHomeLocation: "Home Location",
	    LblLocationMode: "Location Mode",
	    LblMeter: "Meter",
	    LblLocation: "Location",
	    LblPickupLocation: "Pickup Location",
	    LblLocationUnavailable: "Location Unavailable",
	    LblAvailabilityCalander: "Availability Calendar",
	    LblAvailableOn: "Available On",
	    LblGeofenceEnabled: "Geofence Enabled",
	    LblLocationNotFound: "Cannot determine address",
	    LblAddressNotAvailable: "Cannot determine address at this location",
	    LblReports: "Reports",
	    LblDrivers: "Drivers",
	    LblTemplates: "Templates",
	    LblVehicleOccupancyReport: "Vehicle Occupancy Report",
	    LblPlaceHolder: "Place Holder",
	    LblSampleTemplate: "Sample Template",
	    LblLatexFileDownloadValidation: "Invalid Latex content",
	    LblLocationDataExchangeNotAssign: "This vehicle cannot be booked when no VTS vehicle is assigned to it. Would you like to continue ?",
	    LblReservedTime: "Reserved Time",
	    LblUsageTime: "Usage Time",
	    LblUsageTimeAtOffice: "Usage Time in Office Hours",
	    LblUsageTimeoutOffice: "Usage Time out of Office Hours",
	    LblRevenue: "Revenue",
	    LblRevenuePerVehicleReport: "Revenue Per Vehicle Report",
	    LblSearchRevenuePerVehicle: "Search Revenue Per Vehicle",
	    LblRevenuePerVehicleList: "Revenue Per Vehicle List",
	    //Dashboard
	    LblInuse: "In Use",
	    LblPriority: "Priority",
	    LblDefaultStatus: "Default Status",
	    //OdometerLogTrail
	    LblOdometerLogTrail: "Odometer Log Trail",
	    LblUserProvidedOdometerValueInKmr: "Odometer Value (km)",
	    LblDescriptionOfDeviation: "Description of deviation",
	    LblFromOdometer: "From Odometer",
	    LblToOdometer: "To Odometer",
	    LblAddDescriptionOfDeviation: "Add Description of Deviation",
	    LblDeviation: "Deviation (km)",
	    LblLastOdometerValue: "Previous odometer value (km)",
	    LblLastOdometerDT: "Previous odometer date",
	    LblOdometerRegistered: "Odometer Registered",
	    LblOdometerValue: "Odometer Value",
	    LblMaintenancePlanningList: "Maintenance Planning List",
	    LblSearchMaintenancePlanningValue: "Search Maintenance Planning",
	    LblMaintenancePlanningreport: "Maintenance Planning Report",
	    LblodometerConfiguration: "Odometer Configuration",
	    LbLOdometerEnabled: "Odometer Enabled",
	    LblEnableOnApp: "Enable on App",
	    LblWarningPer: "Warning (%)",
	    LblShowDeviation: "Show deviation which requires explanation",
	    LblTitle: "Title",
	    LblFooterText: "Footer Text",
	    LblvalidEmailDomain: "Only allow email addresses from the following domain",
	    LblURLSettings: "URL settings",
	    LblSuccessUrl: "Success URL",
	    LblEmailSettings: "Email settings",
	    LblSendActivationEmail: "Enable automatic activation mails",
	    LblSendConfirmationEmail: "Enable signup confirmation mails",
	    LblRequireAdminApprovel: "Require admin approval of new signups",
	    LblDriverInformationToBeInclude: "Driver information to be included in form (all required fields)",
	    LblSignUpForm: "Signup Form",
	    LblSignupForms: "Signup Forms",
	    LblSignupFormsOverview: "Signup Forms Overview",
	    LblWhoCanApprove: "Who can approve new signups?",
	    LblSignupFormLogo: "Signup form logo",
	    LblChooseSubscription: "Choose the subscription(s) available to the signup form",
	    LblSignupParameter: "Signup URL",
	    LblSignupParameterText: "Signup URL text",
	    DomainNameString: "Comma separated domain name(like gmail.com,yahoo.com)",
	    SignupParameterString: "Only letters ,number and - are allowed",
	    LblAvailability: "Availability",
	    LblSettings: "Settings",
	    LblCurrentStatus: "Current Status",
	    LblFlags: "Flags",
	    LblNA: "NA",
	    //Sign up form
	    LblConfirmEmail: "Confirm Email",
	    LblSignup: "Signup",
	    LblSignupsOverView: "Signups Overview",
	    LblSignupApproval: "Signup Approval",
	    LblAccept: "Accept",
	    LblSignupFormDescription: "Signup form description",
	    LblCurrentOdometerValue: "Current Odometer value",
	    LblCurrentOdometerDateTime: "Current Odometer date/time",
	    LblCreateDirectDebitFile: "Create Direct Debit file",
	    LblCheckEmptyIbanNumber: "Check IBAN numbers",
	    LblCreatedDate: "Date created",
	    LblIncludeInDirectDebit: "Include in Direct Debit file",
	    LblDirectDebitFileDate: "Direct Debit file date",
	    LblDirectDebitConfiguration: "Direct Debit configuration",
	    LbLDirectDebitEnabled: "Enable Direct Debit File generation",
	    LblDirectDebitEnableper: "Direct Debit File enabled per",
	    LbLCreditorDetails: "Creditor details",
	    LblAddress: "Address",
	    LblIBANNumber: "IBAN",
	    LblCountryCode: "Country code",
	    LbLBillingInformation: "Billing information",
	    LblFormat: "Format",
	    LblInvoicingDetails: "Invoicing Details",
	    LbLSubjectToDirectDebit: "Subject to direct debit?",
	    //Person Upload Batch
	    LblBatchUploadPersonSetting: "Batch Import Person Setting",
	    LblShowBatchUploadInfo: "Allow batch import person",
	    LblAllowBatchUpload: "Allow import for",
	    LblAllowActivationMail: "Use activation emails",
	    LblGenerateRandomPassword: "System generates passwords",
	    LblUserUploadPassword: "Import passwords",
	    LblFieldToUploadedOrValidated: "Fields in importfile",
	    LblBatchUploadPerson: "Batch Upload Person",
	    LblBatchUpload: "Batch Upload Person",
	    LblImportDriverRole: "Assign driver role automatically?",
	    LblAssignToSVG: "Assign to Shared Vehicle Group(s)",
	    LblSVG: "Shared Vehicle Group",
	    LblDownloadTemplate: "Importfile example",
	    LblUserAssignSVGMessage: "User Not Yet Assigned to Shared Vehicle Group!",
	    LblInvalidRecordReason: "Invalid Record(s)",
	    LblSelectedSVGs: "Selected SVG(s)",
	    LblDashboard: "Dashboard",
	    LblGroupAdmin: "Group Admin",
	    LblDashboardConfiguration: "Dashboard Configuration",
	    LblCurrentLocation: "Current Location",
	    LblEnableCurrentLocation: "Enable Current Location",
	    LblDefaultLocation: "Default Location",
	    LblEnableAutoUpdate: "Enable Auto Update",
	    LblPriorityNotificationSetting: "Vehicle Status Notification settings",
	    LblCollectionDate: "Direct Debit Collection Date",
	    LblBICCode: "BIC Code",
	    LblDirectDebitFile: "Direct Debit File",
	    LblLegacyInvoicing: "Invoices (before 2025-04-22)",
	    LblMissingIBANNumber: "Missing IBAN",
	    LblCurrentDriver: "Current Driver",
	    LblNextDriver: "Next Driver",
	    LblSecond: "Second(s)",
	    LblCleaning: "Cleaning",
	    LblRefueling: "Refueling/charging",
	    LblAPKMaintenance: "Periodic Maintenance",
	    LblOutsideGeofence: "Outside geofence",
	    LblNotBooked: "Not Booked",
	    LblNotBookedSince: "Not Booked Since",
	    LblLowBattery: "Low Battery",
	    LblBatteryVolt: "V.",
	    LblLowCharge: "Low Charge",
	    LblChargingPercentage: "%",
	    LblOnSamePosition: "On Same Position",
	    LblLastPosition: "Last Position",
	    LblNotReturn: "Not Return",
	    LblCommunicationProblem: "Communication Problem",
	    LblDirectDebitDownloadSuccess: "Direct Debit file downloaded",
	    LblWarnings: "Warnings",
	    LblDirectDebitFileId: "Direct Debit file Id",
	    LblTotalAmount: "Total Amount",
	    LblReCreate: "Download again",
	    LblPleaseEnterCollectionDate: "Please enter Collection Date",
	    LblOpenViaLowLevel: "Opened via Low level",
	    LblInstanceNotificationNote1: "Setting works as set per Company",
	    LblNoInvoiceSelected: "No invoice(s) selected for direct debit file",
	    LblIBANNumberRequired: "Please enter IBAN and BIC",
	    LblNoEmptyIBANFound: "No empty IBAN found",
	    LblInvalidTagUsed: "Invalid Tag used",
	    LblNotInvalidTagUsed: "No invalid Tag used",
	    LblShowVehicleChargeLevel: "Show vehicle charge level in web and mobile applications?",
	    LblChargeLevel: "Charge Level",
	    LblCharging: "Charging",
	    LblNoDataFound: "No Data Available",
	    LblOfficeStartTime: "Office Hours Start Time (hh:mm)",
	    LblOfficeEndTime: "Office Hours End Time (hh:mm)",
	    //Reports
	    LblTripDataReport: "Trip Data Report",
	    LblByDriver: "By Driver",
	    LblByVehicle: "By Vehicle",
	    LblModuleRights: "Module Rights",
	    LblByOrganization: "By Organization",
	    //Organization
	    LblOrganization: "Organization",
	    LblOrganizationName: "Organization Name",
	    LblExistingDriverAddSuccessMsg: "Driver Added and also associated with organization successfully.",
	    LblAddDriverSuccessMsg: "Driver Added and also activation link to that driver has been sent successfully.",
	    LblOrganizationAddress: "Organization Address",
	    LblCreateOrganization: "Create Organization",
	    LblAddDriverToOrganization: "Add Driver To Organization",
	    LblAddDriver: "Add Driver",
	    LblOrganizationDriversList: "Organization Driver",
	    // Branding
	    LblBranding: "Branding",
	    LblLogo: "Logo's",
	    LblEmailNotificationInvoiceTemplate: "Email notification & invoice templates",
	    LblExpandedWebMenu: "Expanded web application menu",
	    LblCollapsedWebMenu: "Collapsed web application menu",
	    LblMobileApp: "Mobile app",
	    LblSplashScreen: "Splash screen",
	    LblWebApplication: "Web application",
	    LblMobileApplication: "Mobile application",
	    LblBrandingSavedSuccess: "Branding saved successfully",
	    LblBrandingTemplateConfiguration: "Branding & Template Configuration",
	    LblAppWebUI: "App & Web UI",
	    LblNonBookingCommunication: "Non-Booking Related Communication",
	    LblBookingCommunication: "Booking Related Communication",
	    LblInstanceBranding: "Always use Instance branding",
	    LblCompanyBranding: "Use Company branding when possible",
	    BO_TOP_MENU_ACTIVE_ITEM_BACKGROUND: "Top bar, menu and active items",
	    BO_TOP_MENU_ACTIVE_ITEM_TEXT: "Menu text",
	    BO_HIGHLIGHTED_BUTTON_BACKGROUND: "Highlighted button",
	    BO_HIGHLIGHTED_BUTTON_TEXT: "Highlighted button text",
	    BO_HIGHLIGHTED_BUTTON_BACKGROUND_HOVER: "Highlighted button (hover)",
	    BO_HIGHLIGHTED_BUTTON_TEXT_HOVER: "Highlighted button text (hover)",
	    BO_PRIMARY_BUTTON_BACKGROUND: "Primary button",
	    BO_PRIMARY_BUTTON_TEXT: "Primary button text",
	    BO_PRIMARY_BUTTON_BACKGROUND_HOVER: "Primary button (hover)",
	    BO_PRIMARY_BUTTON_TEXT_HOVER: "Primary button text(hover)",
	    BO_SECONDARY_BUTTON_BACKGROUND: "Secondary button",
	    BO_SECONDARY_BUTTON_TEXT: "Secondary button text",
	    BO_SECONDARY_BUTTON_BACKGROUND_HOVER: "Secondary button (hover)",
	    BO_SECONDARY_BUTTON_TEXT_HOVER: "Secondary button text (hover)",
	    BO_HYPERLINK_TEXT: "Hyperlink text",
	    BO_HIGHLIGHT_BACKGROUND: "Highlight color",
	    BO_HIGHLIGHT_TEXT: "Highlight text",
	    BO_CALENDAR_EVENT_BACKGROUND: "Calendar events",
	    BO_CALENDAR_EVENT_TEXT: "Calendar events text",
	    MO_TOP_MENU_ACTIVE_ITEM_BACKGROUND: "Top bar and menu",
	    MO_LOGO_AREA_BACKGROUND: "Logo area background",
	    MO_PAGE_BACKGROUND: "Background",
	    MO_MENU_TEXT: "Menu text",
	    MO_TITLE_TEXT: "Title text",
	    MO_HYPERLINK_TEXT: "Hyperlink text",
	    MO_ENABLED_BUTTON_BACKGROUND: "Enabled button",
	    MO_ENABLED_BUTTON_TEXT: "Enabled button text",
	    MO_ENABLED_BUTTON_BACKGROUND_ACTIVE: "Enabled button (active)",
	    MO_ENABLED_BUTTON_TEXT_ACTIVE: "Enabled button text (active)",
	    MO_DISABLED_BUTTON_BACKGROUND: "Disabled button",
	    MO_DISABLED_BUTTON_TEXT: "Disabled button text",
	    MO_DISABLED_BUTTON_BACKGROUND_ACTIVE: "Disabled button (active)",
	    MO_DISABLED_BUTTON_TEXT_ACTIVE: "Disabled button text (active)",
	    MO_HIGHLIGHT_BACKGROUND: "Highlight color",
	    MO_HIGHLIGHT_TEXT: "Highlight text",
	    MO_CALENDAR_EVENT_BACKGROUND: "Calendar events",
	    MO_CALENDAR_EVENT_TEXT: "Calendar events text",
	    LblBookingDelayConfig: "Booking delay configuration",
	    LblBookingDelayConfigEnabled: "Send email to admin",
	    LblEnableSnauilTrail: "Enable Snail Trail",
	    LblAppSupportTo: "App Support To",
	    LblNotificationInterval: "Notification Interval",
	    LblNotifyAfterMinutes: 'Notify After "X" Minutes',
	    LblMinutesAfterBookingEndTime: "How many minutes after scheduled booking end time?",
	    LblResendNotoficationEvery: "Resend notification every minute(s)",
	    LblMinutes: "Minutes",
	    lblNotificationRecipients: "Notification Recipients",
	    LbLEnableBookingStillRunning: "Enable Booking Still Running Notification",
	    LblBookingrunningNotification: "Booking still running notification configuration",
	    LblPreferableImageSize: "Preferable Image Size",
	    LblWebBrandingExapandImageSize: "1150px X 260px",
	    LblMobileBrandingImageSize: "550px X 250px",
	    LblWebBrandingCollapseImageSize: "325px X 250px",
	    //MobileApp Configuration
	    LblMobileAppConfiguration: "Mobile App Configuration",
	    LblEnableNewBooking: "Enable New Booking",
	    LblEnableBookingCalender: "Enable Booking Calender",
	    LblEnableSubscription: "Enable Subscription",
	    LblEnableUpdateProfile: "Enable Update Profile",
	    LblEnableNotification: "Enable Notification",
	    LblEnableChangeBooking: "Enable Change Booking",
	    LblEnableAddExpenseMenu: "Enable Add Expense Menu",
	    //Raise and clear settings for low battery flag
	    LblDefaultVehicleSetting: "Default Vehicle Setting",
	    LblLowBatteryFlagRaised: "Low Battery Flag raised at (voltage)",
	    LblLowBatteryFlagClear: "Low Battery Flag cleared at (voltage)",
	    LblByBooking: "By Booking",
	    LblSnailTrailReport: "Snail Trail Report",
	    LblKickbackReport: "Kickback Report",
	    LblGroupBy: "Group By",
	    LblTripDetail: "Trip Detail",
	    LblTripNumber: "Trip No",
	    LblStart: "Start",
	    LblAverageSpeed: "Avg. Speed",
	    LblSegmentDetail: "Segment Detail",
	    LblSegmentNumber: "Segment No",
	    LblSpeed: "Speed",
	    LblOdometer: "Odometer",
	    LblNext: "Next",
	    LblSegmentDetailNotAvailable: "Segment detail not available",
	    LblUnitPerKm: "per km.",
	    LblUnitPerBooking: "p/bk",
	    LblBookingCostSummary: "Booking Cost Summary",
	    LblTimeCost: "Booking Cost",
	    LblTotalTime: "Total Time",
	    LblTime: "Time",
	    LblCostRateUnits: "Cost (Amount * Rate)",
	    LblFreeTime: "Free Time",
	    LblRate: "Rate",
	    LblExVat: "Ex. VAT",
	    LblInclVat: "In. VAT",
	    LblKmDriven: "Kms driven",
	    LblFreeKms: "Free credits",
	    LblTimePercent: "Time percent",
	    LblTotalExVat: "Total ex. VAT",
	    LblTotalVat: "Total VAT",
	    LblTotalInclVat: "Total in. VAT",
	    LblKilometerCost: "Kilometer Cost",
	    LblFixedCost: "Fixed Cost",
	    LblTotals: "Totals",
	    LblTypeDamage: "Damage",
	    LblTypeMaintenance: "Periodic Maintenance Due",
	    LblTypeOnSamePosition: "Vehicle at same location for more than %0 %1",
	    LblTypeNotBooked: "Vehicle not booked in more than %0 %1",
	    LblTypeNotReturn: "Booking time expired and vehicle not at home location",
	    LblBatteryVoltage: "Battery voltage",
	    LblCannotUnsubscribe: "Cannot unsubscribe now as this user has a running booking",
	    LblPer: "Per",
	    LblDateRegistered: "Registered date",
	    LblRegisteredBy: "Registered by",
	    LblKMPerHour: "Km/h",
	    LblMeters: "Meters",
	    LblSubscriptionEndOnBookingEnd: "Booking is still running for this subscription. Driver will be unsubscribed after end of the booking.",
	    LblMarkedForDeletion: "Marked for Deletion",
	    LblApplyDateFilter: "Apply Date",
	    LblNoRestriction: "NO_RESTRICTION",
	    LblCustomAppTestApp: "CUSTOM_APP_AND_TEST_APP",
	    LblCustomAppOnly: "CUSTOM_APP_ONLY",
	    //Customer
	    LblCustomer: "Customer",
	    LblCustomerName: "Customer Name",
	    //Role Page
	    LblRoleManagement: "Role",
	    LblRoleName: "Role Name",
	    LblEntityName: "Entity Name",
	    LblRoleType: "Role Type",
	    LblRoleAvailability: "Customer Role Availability",
	    LblInternalRoleName: "Internal Role Name",
	    LblPresentationName: "Presentation Name",
	    LblDefaultRole: "Default Role",
	    LblCustomRole: "Custom Role",
	    LblAddRole: "Add Role",
	    LblEntity: "Entity",
	    LblCopy: "Copy",
	    LblAccessibilityMatrix: "Accessibility Matrix",
	    LblDefaultRoleModifyWarning: "Modifying default permissions will affect all users that have the default role",
	    LblCopyAccessibilityMatrix: "Copy Accessibility Matrix",
	    LblAccess: "Access",
	    LblCustomerAdmin: "Customer Admin",
	    LblAdmin: "Admin",
	    LblDoYouWantToRemove: "Do you want to remove %0 as %1?",
	    LblDoYouWantToAdd: "Do you want to make %0 as %1?",
	    LblRoleAddedSuccess: "%0 added to %1 successfully.",
	    LblRoleDeletedSuccess: "%0 removed from %1 successfully.",
	    LblInstanceAdmin: "Instance Admin",
	    LblInvitationMailSuccess: "Invitation mail has been sent to the given email address.",
	    LblInvite: "Send Invite",
	    LblCreateNew: "Create New",
	    LblCommonErrorMessage: "The server encountered an error during processing the request. Please contact administrator.",
	    LblError: "Error",
	    LblThankYouForAcceptingInvitation: "Thank you for accepting the invitation",
	    LblPleaseClick: "Please click",
	    LblHere: "here",
	    LblToLogin: "to Login",
	    LblThankYouForConfirmation: "Thank you for your confirmation.",
	    LblGoToHome: "goto Home.",
	    LblInvitationSuccess: "Invitation Success",
	    LblInvitationReject: "Invitation Reject",
	    //
	    LblAssignExisting: "Assign Existing",
	    LblPersonProfileSuccessMessage: "Your profile has been successfully activated",
	    LblPlease: "Please",
	    LblLogin: "Login",
	    //Organization
	    LblVatNumber: "VAT Number",
	    //Branding & Template
	    LblBrandingandTemplates: "Branding & Templates",
	    LblTermsAndCondition: "Terms & Conditions",
	    LblTermsAndConditionList: "T&C and Privacy Statement List",
	    LblName: "Name",
	    LblVersion: "Version",
	    LblAcceptance1: "Before account activation",
	    LblAcceptanceMoment: "Acceptance Moment",
	    LblContents: "Contents",
	    LblIsAccept: "I accept",
	    LblReadAndAgree: "I have read and agree with",
	    LblClose: "Close",
	    LblTermsConditionPrivacy: "T&C and Privacy Statement",
	    LblPrivacyStatements: "Privacy Statements",
	    //Pre Post Trip Setting
	    LblPrePostTripSetting: "Pre & Post Trip Question Setting",
	    LblPrePostTripQuestion: "Pre and Post Trip Question",
	    LblPrePostTripQuestionList: "Pre and Post Trip Question List",
	    LblPreTripQuestion: "Pre-trip questions",
	    LblCustom: "Custom",
	    LblPostTripQuestion: "Post-trip questions",
	    LblRequired: "Required",
	    LblBeforeOpeningTheVehicle: "Before opening the vehicle",
	    LblAfterOpeningTheVehicle: "After opening the vehicle",
	    LblOrder: "Order",
	    LblQuestion: "Question",
	    LblOn: "On",
	    LblOptional: "Optional",
	    LblOff: "Off",
	    LblAnswerType: "Answer Type",
	    LblText: "Text",
	    LblYesNo: "Yes/No",
	    LblAnswer: "Answer",
	    LblTimeStamp: "Timestamp",
	    LblFazTripQuestion: "FaZ Questions",
	    LblFazTripQuestionAfterClosingTheVehicle: "FaZ questions after closing the vehicle",
	    //Accessibility Matrix
	    LG_WEB_DASHBOARD: "Web Dashboard",
	    PR_BOOKING_REQUEST: "Booking Request",
	    LblApproveBookingRequest: "Approve",
	    LblRejectBookingRequest: "Reject",
	    PR_DASHBOARD: "Dashboard",
	    PR_REMOVE_DRIVER_LICENSE: "Remove Drivers License",
	    PR_VEHICLE_FUTURE_BOOKINGS: "Vehicle Future Bookings",
	    PR_INSTANCE: "Instance",
	    PR_BRANDING: "Branding",
	    PR_PERSON_OVERVIEW: "Person Overview",
	    PR_WEGO_ADMINS: "Wego Admins",
	    PR_COMPANY_OVERVIEW: "Company Overview",
	    PR_CONTACT_PERSON: "Contact Person",
	    PR_COMPANY_ADMIN: "Company Admin",
	    PR_COMPANY_VEHICLE_OVERVIEW: "Company Vehicle Overview",
	    PR_COMPANY_SVG_OVERVIEW: "Company SVG Overview",
	    PR_ORGANIZATION_OVERVIEW: "Organization Overview",
	    PR_ORGANIZATION_CONTACT_PERSON: "Organization Contact Person",
	    PR_ORGANIZATION_ADMIN_OVERVIEW: "Organization Admin Overview",
	    PR_ORGANIZATION_DRIVER_OVERVIEW: "Organization Driver Overview",
	    PR_SHARED_VEHICLE_GROUP_OVERVIEW: "Shared Vehicle Group Overview",
	    PR_SHARED_VEHICLE_GROUP_ADMIN_OVERVIEW: "Shared Vehicle Group Admin Overview",
	    PR_SHARED_VEHICLE_GROUP_VEHICLE_OVERVIEW: "Shared Vehicle Group Vehicle Overview",
	    PR_SHARED_VEHICLE_GROUP_DRIVER_OVERVIEW: "Shared Vehicle Group Driver Overview",
	    PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_GROUP_OVERVIEW: "Shared Vehicle Group Contract Type Group Overview",
	    PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_OVERVIEW: "Shared Vehicle Group Contract Type Overview",
	    PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW: "Shared Vehicle Group Subscription Overview",
	    PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_AVAILIBILTY_RESTRICTION_OVERVIEW: "Shared Vehicle Group Subscription Availibilty Restriction Overview",
	    PR_SPECIAL_PERIODS: "Special Periods",
	    PR_VEHICLES_OVERVIEW: "Vehicles Overview",
	    PR_VEHICLE_SVG_OVERVIEW: "Vehicle SVG Overview",
	    PR_VTS_VEHICLE_LIST: "VTS Vehicle List",
	    PR_VTS_TROUBLESHOOT: "VTS Troubleshoot",
	    PR_VEHICLE_ATTRIBUTE_CATEGORIES: "Vehicle Attribute Categories",
	    PR_VEHICLE_ATTRIBUTE: "Vehicle Attribute",
	    PR_ODOMETER_LOG_TRAIL: "Odometer Log Trail",
	    PR_ODOMETER_LOG_TRAIL_REGISTERED_BY: "Odometer Log Trail Registered by",
	    PR_DRIVER_OVERVIEW: "Driver Overview",
	    PR_DRIVER_SHARED_VEHICLE_GROUP_OVERVIEW: "Driver Shared Vehicle Group Overview",
	    PR_DRIVER_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW: "Driver Shared Vehicle Group's Subscription Overview",
	    PR_BOOKINGS_OVERVIEW: "Bookings Overview",
	    PR_PRE_POST_TRIP_QUESTIONS: "Pre-post Trip Question Overview",
	    PR_NORMAL_BOOKING: "New Booking",
	    PR_SPECIAL_BOOKING: "Special Booking",
	    PR_TRIP_SIMULATOR: "Trip Simulator",
	    PR_INVOICE: "Invoice",
	    PR_DIRECT_DEBIT_FILE: "Direct Debit File",
	    PR_ADDITIONAL_FREE_ITEMS: "Additional Free Items",
	    PR_TEST_INVOICE_GENERATOR: "Test Invoice Generator",
	    PR_VEHICLE_OCCUPANCY_REPORT: "Vehicle Occupancy Report",
	    PR_REVENUE_PER_VEHICLE_REPORT: "Revenue Per Vehicle Report",
	    PR_TRIP_DATA_REPORT: "Trip Data Report",
	    PR_MAINTENANCE_PLANNING_REPORT: "Maintenance Planning Report",
	    PR_SANIL_TRAIL_REPORT: "Snail Trail Report",
	    PR_KICKBACK_REPORT: "Kickback Report",
	    PR_INVOICE_PAYMENT_HISTORY: "Invoice Payment History",
	    PR_TEMPLATES: "Templates",
	    PR_SIGNUP_FORMS_OVERVIEW: "Signup Forms Overview",
	    PR_SIGNUPS_OVERVIEW: "Signups Overview",
	    PR_SIGNUP_OVERVIEW_TO_SIGNUP_FORM: "Signup Overview to Signup Form",
	    PR_SIGNUP_OVERVIEW_TO_SHARED_VEHICLE_GROUP: "Signup Overview to Shared Vehicle Group",
	    PR_TERMS_AND_CONDITION: "Terms & Condition",
	    PR_EVENT_VIEWER: "Event Viewer",
	    PR_PRE_POST_TRIP_SETTING: "Pre-Post Trip Question Setting",
	    PR_PREPOST_TRIP_QUESTIONS_UPDATE: "Pre Post Trip Questions",
	    PR_USER_PROFILE: "User Profile",
	    LG_CUSTOMER: "Customer",
	    LG_INSTANCE: "Instance",
	    LG_BRANDING: "Branding",
	    LG_PERSON: "Person",
	    LG_COMPANY: "Company",
	    LG_ORGANIZATION: "Organization",
	    LG_SHARED_VEHICLE_GROUP: "Shared Vehicle Group",
	    LG_VEHICLE: "Vehicle",
	    LG_DRIVER: "Driver",
	    LG_BOOKING: "Booking",
	    LG_INVOICE: "Invoice",
	    LG_REPORT: "Report",
	    LG_TEMPLATE: "Template",
	    LG_SIGNUP_FORM: "Signup Form",
	    LG_EVENT_VIEWER: "Event Viewer",
	    LG_PRE_POST_TRIP_SETTING: "Pre Post Trip Question Setting",
	    LG_USER: "User",
	    LG_BRANDING_AND_TEMPLATE: "Branding & Templates",
	    LG_ROLE: "Role",
	    LG_PREPOSTTRIPQUESTION: "Pre Post Trip Questions",
	    PR_CUSTOMER_ADMIN_OVERVIEW: "Customer Admin Overview",
	    PR_INSTANCE_ADMIN_OVERVIEW: "Instance Admin Overview",
	    PR_ROLE_OVERVIEW: "Role",
	    PR_ROLE_ASSIGN: "Role Assign",
	    PR_SHARED_VEHICLE_GROUP_ACTIVE_INACTIVE: "Shared vehicle group active or inactive",
	    PR_CUSTOMER_OVERVIEW: "Customer",
	    PR_ORGANIZATION_SUBSCRIPTION_OVERVIEW: "Organization Subscription Overview",
	    PR_VTS_VEHICLE_EVENT_HISTORY: "VTS Vehicle Event History",
	    PR_BATCH_UPLOAD_PERSON: "Person Batch Upload",
	    PR_IMPORT_PERSON: "Import Person",
	    PR_PRE_POST_TRIP_QUESTION_UPDATE: "Pre Post Trip Questions",
	    LG_REPORTINGTOOL: "Reporting Tool",
	    PR_BOOKING_OVERVIEW: "Booking overview",
	    PR_ROB_NOTIFICATIONS: "ROB overview",
	    PR_MILEAGE_OVERVIEW: "Mileage overview",
	    PR_USAGE_OVERVIEW: "Number of days not used",
	    PR_POSITION_ON_MAP: "Position on the map",
	    PR_VEHICLE_ON_LOCATION_MAP: "Vehicle on location",
	    PR_TRIP_OVERVIEW: "Trip registration",
	    PR_ALTERNATE_TRANSPORTATION: "Alternate transportation",
	    PR_AVERAGE_OVERVIEW: "Averages overview",
	    PR_PRE_POST_BOOKING_OVERVIEW: "Pre/post questions per booking overview",
	    PR_HOME_LOCATIONS_OVERVIEW: "Vehicle and SVG home locations overview",
	    LblPrivacyErrorMessage: "You are not authorized to view this page",
	    LblPrivacyNavigate: "Please navigate to",
	    LblPrivacyError: "Privacy Error",
	    LblLinkExpired: "Link Expired",
	    LblLinkExpiredMessage: "Link is expired and can't be used anymore. Please try again.",
	    LblBearer: "Bearer",
	    LblWhoBenifitFreeItem: "Who benefits from subscription credits?",
	    LblNoDistinction: "Default (no distinction)",
	    LblSendInvoiceToOrganization: "Send Invoice To Organization",
	    //Vat Setting
	    LblVatSettings: "VAT Settings",
	    LblVatPercentages: "VAT Percentages",
	    LblDefaultCost: "By Default, Show and Edit Costs",
	    LblExcludingVat: "Excluding VAT",
	    LblIncludingVat: "Including VAT",
	    LblVatEnterDescription: "Enter Description",
	    LblEnterVatPercentage: "Enter VAT %",
	    LblVatPercentageError: "Please enter valid percentage",
	    LblVatDescriptionError: "Please enter valid Description",
	    LblVatStartDate: "Start Date",
	    LblVatStartDateError: "Please select start date",
	    LblStartDate: "Start Date",
	    LblVatEndDate: "End Date",
	    LblVatDeleteConfirmation: "Are you sure you want set VAT End Date?",
	    LblVatEndDateError: "Please enter VAT end date",
	    LblVatEndDateNote: "Note: Data will be excluded from the selected date",
	    LblDefaultVatContractTypeGroupCost: "VAT % for Contract Type Group Costs",
	    LblDefaultVatContractTypeCost: "VAT % for Contract Type Costs",
	    LblDefaultVatSubscriptionCost: "VAT % for Subscription Costs",
	    LblPenaltyCost: "Penalty Cost",
	    LblTimeRates: "Time Rates",
	    LblDistanceRates: "Distance Rates",
	    LblFixedRates: "Fixed Rates",
	    LblSubscriptionCost: "Subscription Costs",
	    LblPenaltyVat: "Penalty VAT",
	    LblTimeRateVat: "Time Rate VAT",
	    LblMileageRateVat: "Mileage Rate VAT",
	    LblFixedFeeVat: "Fixed Fee VAT",
	    LblExpenseAmountVat: "Expense Amount VAT",
	    // template
	    LblEmailTemplate: "Email Template",
	    LblWebTemplate: "Web Template",
	    LblEmailAddressesEntryPattern: "Comma separated email addresses(like ex1@ex.com, ex2@ex.com)",
	    LblNoRecipientWarning: "No recipients applicable. Default recipients will be the receiver of this template.",
	    LblCostAndExpenses: "Cost And Expenses",
	    LblSender: "Sender",
	    LblAddressee: "Addressee",
	    LblAddLine: "Add Line",
	    LblSaveInvoice: "Save Invoice",
	    LblVatAmount: "VAT Amount",
	    LblBookingId: "Booking Id",
	    LblReceiptOrSuppor: "Receipt Or Support",
	    LblVATPercentage: "VAT(%)",
	    LblChargeTo: "Charge To",
	    LblReimburseTo: "Reimburse To",
	    LblReportedBy: "Reported By",
	    LblReportedAmount: "Reported Amount",
	    LblApprovedAmount: "Approved Amount",
	    LblCostType: "Cost Type",
	    LblRecipient: "Recipient",
	    LblCostDetail: "Cost Detail",
	    LblCostCenterReport: "Cost Center Report",
	    LblShowTotalOnly: "Show Total Only",
	    LblChamberOfCommerce: "Chamber of Commerce",
	    LblInvoicingSettings: "Invoicing Settings",
	    LblInvoiceSender: "Invoice Sender",
	    LblAddExisting: "Add Existing",
	    LblReceiptOrSupport: "Receipt Or Support",
	    LblManualInvoiceLine: "Manual Invoice Line",
	    LblInvoiceLine: "Invoice Line",
	    LblInvoice: "Invoice",
	    LblInvoiceLines: "Invoice Lines",
	    LblSendInvoice: "Send Invoice",
	    LblInvoiceSent: "Invoice Sent",
	    LblAddNewInvoiceLine: "Add a new invoice line",
	    LblSelectUnprocessedExpenses: "Select an unprocessed expenses",
	    LblSelectAtLeastOneExpense: "Please select at least one expense",
	    PR_COST_EXPENSES: "Cost And Expenses",
	    PR_COST_CENTER_REPORT: "Cost Center Report",
	    LblInactiveAfterDays: "Inactive After (Days)",
	    LblMarkDeleteAfterDays: "Mark Delete After (Days)",
	    LblNotifyAdminBeforeDays: "Notify Admin Before (Days)",
	    LblGdprSettings: "GDPR Settings",
	    LblRemovalDate: "Removal Date",
	    LblRemovePersonOn: "Remove Person On",
	    LblInvoicePaymentHistory: "Invoice Payment History",
	    LblPaymentMode: "Payment Mode",
	    LblLogTime: "Log Time",
	    LblWhenOpeningAppAndRepeat: "When opening the app for the first time and repeat every",
	    LblEveryTimeOpenApp: "Every time the app is opened",
	    LblWhenMakeBooking: "When making a booking",
	    LblWhenStartBooking: "When starting a booking",
	    LblWhenOpenBooking: "When opening a vehicle",
	    LblSelectContractTypeGroup: "When choosing a specific Contract Type Group(s)",
	    LblDays: "Days",
	    LblNewVersion: "New Version",
	    LblAction: "Action",
	    LblTAndCName: "T&C Name",
	    LblOldVersion: "Old Version",
	    LblSureToRevoke: "Are you sure to revoke T&C?",
	    LblNoPaymentLinkGenerated: "No Payment Link Generated",
	    //Payment Module
	    LblPaymentConfig: "Payment Configuration",
	    LblPaymentConfigButton: "Payment configuration",
	    LblPaymentProvider: "Payment Provider",
	    LblCountry: "Country",
	    LblEmailAddress: "Email Address",
	    LblAllowPaymentConfiguration: "Allow Payment Configuration",
	    LblAllowPayment: "Allow Payment",
	    LblPaymentSetting: "Payment Provider Settings",
	    LblEnvironment: "Environment",
	    LblInvoicePaymentTermDays: "Invoice Payment Terms Days",
	    LblLinkValidityDays: "Link Validity Days",
	    LblPaymentMethods: "Payment Methods",
	    LblPaymentProviderSecretKey: "PSP Secret Key",
	    LblPaymentProviderUsername: "PSP User Name (key)",
	    LblCreditCardPayment: "Credit Card Payment",
	    LblInitialPayment: "Initial Payment",
	    LblCreateBookingPayment: "Create Booking Payment",
	    LblStartBookingPayment: "Start Booking Payment",
	    LblPaymentLink: "Payment Link",
	    LblPaymentHistory: "Payment History",
	    LblReasonOrganization: "Reason for blocking organization",
	    LblDueDateUpdateSuccess: "Due Date Updated Successfully",
	    LblDueDateRequiredError: "Please Select Due Date.",
	    LblDueDate: "Due Date",
	    LblConfirmDuedatechange: "Are you sure you want to update due date ?",
	    LblConfirmCloseInvoice: "Are you sure you want to close invoice ?",
	    LblConfirmReOpenInvoice: "Are you sure you want to reopen invoice ?",
	    LblInvoiceOpenCloseSuccess: "Invoice %0 successfully",
	    LblReOpen: "Reopen",
	    LblClosed: "Closed",
	    LblReOpenClose: "Reopen / Close",
	    PR_PAYMENT_HISTORY_LIST: "Payment History",
	    LblUserBlockMessage: "User Block Message",
	    PR_BLOCK_UNBLOCK_ORGANIZATION: "Block / Unblock Organization",
	    LblReportedOn: "Reported On",
	    LblCurrencyConfiguration: "Currency Configuration",
	    LblNameSingular: "Name Singular",
	    LblNamePlural: "Name Plural",
	    //Special Period
	    LblRegularBooking: "Regular Booking",
	    LblSpecialRate: "Special Rate",
	    LblFirstDay: "First Day",
	    LblLastDay: "Last Day",
	    LblWeekEndContaining: "Weekend Containing",
	    LblSignBeforeAmount: "Currency symbol before Amount",
	    //Credit card payment
	    LblCrediCardPayment: "Credit Card Payment",
	    LblFirstBooking: "First Booking",
	    LblAllowRecurringPayment: "Authorize credit card",
	    LblProceed: "Proceed",
	    LblCheckAllowPayment: "Please check allow recurring payment.",
	    LblPaymentFailed: "Authorize credit card",
	    LblPaymentSuccess: "Authorization Success",
	    LblPaymentFailure: "Authorization Failure",
	    LblCompletedSuccess: "Your authorization has been processed successfully",
	    LblCompletedFailure: "Your authorization has failed. Please go back and try again.",
	    LblCreditCardNumber: "Credit Card Number",
	    LblCreditCardExpirationDate: "Credit Card Expiration Date",
	    LblCreditCardDetails: "Credit Card Details",
	    LblMakePayment: "Authorize credit card",
	    LblAdminPaymentConfirmation: "There is no active authorisation or a deduction from the card failed. Would you like to proceed?",
	    LblPaymentDescription: "In order to book a vehicle, a verification payment of %0 is required. Additionally, the permission to deduct future payments from your credit card is required. Payments are processed by our payment provider Buckaroo. You're being redirected to the Buckaroo website for the actual payment.",
	    LblPay: "Pay",
	    LblOutOf: "Out Of",
	    // NIF Number
	    LblEnableNIFNumber: "Enable NIF Number",
	    LblNIFNumber: "NIF Number",
	    LblWeGoDefault: "WeGo Default",
	    LblPersonActiveSuccess: "Person Successfully Activated",
	    LblActivate: 'Activate',
	    LblInActiveReason: "InActive Reason",
	    LblDefaultLanguage: 'Default Language',
	    LblRestoreInheritConfirmation: "The current settings will be overridden by the inherited settings. Are you sure?",
	    LblQestionTextRequired: "Question text required",
	    LblManualSecretKey: "Secret Key",
	    // Two Factor Authentication
	    LblTwoFaConfig: "Two Factor Authentication",
	    LblEnableTwoFa: "Enable Two Factor Authentication",
	    LblExpirationDays: "Expiration Days",
	    LblTextBoxExpirationDays: "Expiration Days",
	    Lbl2FactorAuthenticateExpDays: "2FA expiration period (days):",
	    LblResetCookiesWegoAdmin: "Reset cookies for all WeGo admin",
	    LblReset2FactorAuthWegoAdmin: "Reset all 2FA for all WeGo admin",
	    LblAuthentication: "Authentication",
	    LblResetCookiesForAllAdmin: "Reset Cookies for all admin",
	    LblReset2FaForAllAdmin: "Reset 2FA for all admin",
	    LblEnterTotp: "Please enter code",
	    LblEnterOtp: "Please enter code",
	    LblSubmit: "Submit",
	    LblKeyResetSuccess: "2FA Key has been reset",
	    LblKeyResetFailed: "2FA Key reset failed",
	    LblCookieResetSuccess: "2FA cookies has been reset",
	    LblCookieResetFailed: "2FA cookies reset failed",
	    LblGoogleAuthenticator: "Google Authenticator App",
	    LblEmailOtpSent: "A code has been sent to your registered email address",
	    LblContinue: "Continue",
	    LblInvalidTOTP: "Invalid code",
	    LblResetCookie: "Reset Cookie",
	    LblResetTwoFA: "Reset 2FA",
	    LblDisableTwoFA: "Disable 2FA",
	    LblTwoFaMethod: "2FA Method",
	    LblEmailAuthentication: "Email Authentication",
	    LblTwoFaMethodSelect: "You will need to verify your identity one more time. Please select your 2FA method",
	    LblInvoicePreFix: "Invoice number prefix",
	    LblEngineStillRunning: 'Lock command sent while engine is running',
	    LblMobileAppLink: "Mobile App Link",
	    // License Check Configuration
	    LblLicenseCheckConfiguration: "License Check Configuration",
	    LblValidateLicenseCheckForBooking: "Check for booking",
	    // Access Cards Enabled SVG
	    LblAccessCardsEnabled: "Access Card Use",
	    // Payment Methods
	    LblIdeal: "Ideal",
	    LblBCMC: "BCMC",
	    LblSepa: "Sepa",
	    LblPaypal: "Paypal",
	    LblCreditCard: "Credit card",
	    LblSofort: "Sofort",
	    LblMyBank: "MyBank",
	    LblGiroPay: "GiroPay",
	    // Track & Trace
	    LblTrackAndTrace: "Track & Trace",
	    LblRfidTagId: "RFID Tag ID",
	    LblEmployeeNumber: "Employee number",
	    BtnAddVehicleInfo: "Show Vts Log",
	    // Access Card
	    LblAccessCardId: "Access Card ID",
	    LblDriversLicenseAndCertificates: "Driver's license and certificates",
	    LblLicense: "Driver's license",
	    LblCertificates: "Certificates",
	    LblTrips: "Trips",
	    LblCostsSummary: "Costs Summary",
	    LblStartBooking: "Start booking",
	    LblStopBooking: "Stop booking",
	    LblTripHistory: "Trip history",
	    LblTripStartDateTime: "From",
	    LblTripEndDateTime: "To",
	    LblFaZTripQuestions: "FaZ questions",
	    LblNoQuestionsFound: "No FaZ questions found.",
	    LblNoTripsFound: "No trips found.",
	    LblTripDetails: "Trip details",
	    LblUnansweredQuestions: "Unanswered Questions",
	    LblNoUnansweredQuestions: "No unanswered Questions",
	    LblAnswerSaved: "The answer is successfully saved",
	    LblAnswerSavedError: "The answer could not be saved. Please contact the Administrator",
	    LblAnswerEmptyError: "Please enter a valid answer",
	    LblLoginError: "An unknown error ocurred while logging in",
	    LblLoginCredentialsError: "This username or password is incorrect, please verify and try again",
	    LblBookingStarted: "The booking has started",
	    LblCouldnotStartBooking: "The booking could not be started",
	    LblBookingStopped: "The booking has been stopped",
	    LblCouldnotStopBooking: "The booking cannot be stopped",
	    ValidatePhoneNumberVts: "Please enter valid phone number (e.g. +31623456789)",
	    LblInfo: "Info"
	};


/***/ },
/* 73 */
/***/ function(module, exports) {

	// lang-es.ts
	"use strict";
	exports.LANG_NL_NAME = "nl";
	exports.LANG_NL_TRANS = {
	    LblWeekdays: {
	        shorthand: ["Zo", "Ma", "Di", "Wo", "Do", "Vr", "Za"],
	        longhand: [
	            "Zondag",
	            "Maandag",
	            "Dinsdag",
	            "Woensdag",
	            "Donderdag",
	            "Vrijdag",
	            "Zaterdag"
	        ]
	    },
	    LblMonths: {
	        shorthand: [
	            "Jan",
	            "Feb",
	            "Mar",
	            "Apr",
	            "Mei",
	            "Jun",
	            "Jul",
	            "Aug",
	            "Sep",
	            "Okt",
	            "Nov",
	            "Dec"
	        ],
	        longhand: [
	            "Januari",
	            "Februari",
	            "Maart",
	            "April",
	            "Mei",
	            "Juni",
	            "Juli",
	            "Augustus",
	            "September",
	            "Oktober",
	            "November",
	            "December"
	        ]
	    },
	    LblButtonText: {
	        today: "Vandaag",
	        month: "Maand",
	        week: "Week",
	        day: "Dag",
	        list: "Lijst"
	    },
	    LblEdit: "Bewerken",
	    LblDelete: "Verwijderen",
	    LblRemove: "Verwijderen",
	    LblActiveInactive: "Actief/Inactief",
	    LblActive: "Actief",
	    LblInactive: "Deaktiveren",
	    LblAddNew: "Toevoegen",
	    LblAdd: "Toevoegen",
	    LblUpdate: "Wijzigen",
	    LblSave: "Opslaan",
	    LblCancel: "Annuleren",
	    LblReset: "Reset",
	    LblSelect: "Selecteer",
	    LblSuccess: "Gelukt",
	    LblWarning: "Waarschuwing",
	    LblList: "Lijst",
	    LblAssign: "Toewijzen aan",
	    LblHome: "Home",
	    LblYes: "Ja",
	    LblOK: "Ok",
	    LblNo: "Nee",
	    LblBack: "Terug",
	    LblReason: "Reden",
	    LblRecordSavedSuccess: "Opslaan gelukt",
	    LblRecordDeleteSuccess: "Verwijderen gelukt",
	    LblResetPasswordSuccess: "Wachtwoord gereset",
	    LblBookingApproveRejectSuccess: "%0 %1 succesvol",
	    LblRecordAddedSuccess: "%0 toegevoegd",
	    LblRecordUpdatedSuccess: "%0 wijzigen gelukt",
	    LblRecordRemovedSuccess: "%0 verwijderd",
	    LblRecordActiveInActiveSuccess: "%0 %1 gelukt",
	    LblinvoiceResendSuccess: "%0 opnieuw verzonden",
	    LblRecordBlokUnBlockSuccess: "%0 %1 gelukt",
	    LblConfirm: "Bevestigen",
	    LblContactPersonAddedSuccess: "Contactpersoon toegevoegd",
	    LblBlockUnblockConfirm: "Weet je zeker dat je de %1 wilt %0?",
	    LblRecordDeleteConfirmation: "Weet je zeker dat je %0 wilt verwijderen?",
	    LblRecordMultiplDeleteConfirmation: "Weet je zeker dat je de selectie wilt verwijderen?",
	    LblConfirmMessage: "Weet u het zeker?",
	    LblResetPassword: "Reset wachtwoord",
	    LblResetPasswordConfirmation: "Weet je zeker dat je je wachtwoord wilt resetten?",
	    LblGeoLocationError: "Voer een correcte geolocatie in",
	    LblPersonDeleteCheck: "Verwijder permanent",
	    LblBookingCancelSuccess: "Reserveringen annuleren is gelukt",
	    LblBookingAbortSuccess: "Reservering afbreken is gelukt",
	    LblBookingRevokeSuccess: "Reservering intrekken is gelukt",
	    LblContactPersonRemoveSuccess: "Contactpersoon verwijderd",
	    LblNoRecords: "Geen regels beschikbaar",
	    LblAffectedBookingList: "Lijst met betrokken reserveringen",
	    LblSubscriptionEndDateError: "Voer einddatum van abonnement in",
	    LblIsSpecialPeriodAllow: "Wil je kosten voor speciale periode toepassen?",
	    LblContractSlotisnotdefined: "Contracttype voor hieronder gegeven tijd slot is niet gedefinieerd",
	    LblUnscubscribeSuccess: "Succesvol uitgeschreven",
	    LblModifiedBy: "Gewijzigd door",
	    LblModifiedDate: "Wijzigingsdatum",
	    LblInstance: "Instantie",
	    LblInstanceName: "Instantienaam",
	    LblInstanceType: "Instantietype",
	    LblDescription: "Omschrijving",
	    LblCurrencySymbol: "Symbool van valuta",
	    LblPreferredLanguage: "Taal",
	    LblTimeZone: "Tijdzone",
	    LblCurrencyAbbreviation: "Valuta afkorting",
	    LblInstanceDeleteValidation: "Kan Instance niet verwijderen omdat deze aan andere entiteit refereert",
	    LblIsBookingApprovalReq: "Goedkeuring reservering vereist",
	    LblKilometers: "Kilometers",
	    LblKM: "Km",
	    LblDeletePersonNote: "In afwachting van facturen voor deze persoon zal niet worden verzonden",
	    LblInstanceConfiguration: "Service Configuratie",
	    LblBookingAlertTime: "Boeking waarschuwingstijd",
	    LblBookingCancelTime: "Boeking annuleringstijd",
	    LblBookingTemporaryTime: "Reservering Bevestiging Tijd",
	    LblVtsRequestTimeout: "VTS aanvraag - geen reactie",
	    LblVtsTripLogTimeout: "VTS ritlog - geen reactie",
	    LblEmailConfiguration: "E-mail configuratie (SMTP)",
	    LblInSeconds: "In Seconden",
	    LblFromEmail: "Verzend mailadres",
	    LblHost: "Gastheer",
	    LblPort: "Port",
	    LblEnableSsl: "Enable SSL",
	    LblSmtpEmail: "SMTP Email",
	    LblIsImportPersonAllow: "Persoon importeren toestaan",
	    LblValidateLiceanceNumber: "Rijbewijs controle",
	    LblValidateLicenseA2SP: "A2SP Rijbewijs controle",
	    LblValidateLicense24IDCheck: "24ID Rijbewijs controle",
	    LblValidateLicenseForAllBookings: "Rijbewijs controle elke boeking uitvoeren",
	    LblGeofenceLocation: "Geofence locatie",
	    LblRadius: "Straal",
	    LblEmailRecepients: "Email Ontvangers",
	    LblRecepients: "Ontvangers",
	    LblEmailAddresses: "Email addresses",
	    LblMap: "Kaart",
	    // AFAS/Azure Config
	    LblImportConfiguration: "Import Configuratie",
	    LblImportConnectionType: "Connection Type",
	    LblAfas: "AFAS",
	    LblAzure: "Azure",
	    LblAzureTenantId: "Azure Tenant ID",
	    LblAzureClientId: "Azure Client ID",
	    LblAzureClientSecret: "Azure Client Secret",
	    LblAfasClientId: "AFAS Client ID",
	    LblAfasConnectorName: "AFAS connector naam",
	    LblAfasConnectionType: "AFAS connectie type",
	    LblAfasTest: "Test",
	    LblAfasAccept: "Acceptatie",
	    LblAfasProduction: "Productie",
	    LblAfasToken: "AFAS Token",
	    LblAfasClientIdError: "Voer AFAS Client ID in",
	    LblAfasConnectorNameError: "Voer AFAS Client ID in",
	    LblAfasConnectionTypeError: "Voer AFAS Connection Type in",
	    LblAfasTokenError: "Voer AFAS-Token in",
	    LblAzureTenantIdError: "Voer Azure Tenant ID in",
	    LblAzureClientIdError: "Voer Azure Client ID in",
	    LblAzureClientSecretError: "Voer Azure Client Secret in",
	    // SSO Config
	    LblSsoConfiguration: "SSO Configuratie",
	    LblDefaultSsoSharedVehicleGroup: "Standaard poolgroep",
	    LblDefaultSsoOrganization: "Standaard organisatie",
	    LblDefaultSsoSubscription: "Standaard abonnement",
	    // Dropoff Message
	    LblDropoffMessageConfiguration: "Dropoff Message Configuratie",
	    LblDropoffMessageExternalUrl: "Externe Url",
	    LblDropoffMessageApiKey: "Api Key",
	    LblDropoffMessageActive: "Actief",
	    LblBookingCalanderSettings: "Kalenderinstellingen",
	    LblShowDriverInfo: "Toon bestuurdersinformatie in kalender",
	    LblOrganizationAdmin: "Organisatiebeheerder",
	    LblDriverInfoToShow: "Bestuurdersinformatie die wordt getoond",
	    LblValidate: "Valideer",
	    LblBookingCancelTimeMessage: "Dit definieert de tijd (in seconden) waarna het annuleren van een boeking niet meer mogelijk is",
	    LblBookingTemporaryTimeMessage: "Tijd voor voorlopige boeking. Nadat de gebruiker het voertuig heeft geselecteerd om te boeken maar deze nog niet is bevestigd.",
	    LblVtSRequestTimeoutMessage: "Geen reactie voor het ontgrendel / vergrendel commando in de App",
	    LblVtsTriplogTimeoutMessage: "Geen reactie voor tripberekening na uitvoering van het vergrendel commando",
	    LblContractTypeDeleteValidation: "Kan Contract Type Group niet verwijderen omdat deze met een andere entiteit is gekoppeld",
	    LblUserName: "Gebruikersnaam",
	    LblFirstName: "Voornaam",
	    LblLastName: "Achternaam",
	    LblEmail: "E-mail",
	    LblMobileNumber: "Mobiel nr.",
	    LblPhoneNumber: "Telefoon",
	    LblHomeAddress: "Adres privé",
	    LblWorkAddress: "Werkadres",
	    LblHouseNo: "Huisnr.",
	    LblHouseExtention: "Toevoeging",
	    LblStreetName: "Straat",
	    LblCity: "Stad",
	    LblZipCode: "Postcode",
	    LblPassword: "Wachtwoord",
	    LblConfirmPassword: "Bevestig wachtwoord",
	    LblMiddleName: "Tussenvoegsel",
	    LblCompany: "Bedrijf",
	    LblCompanyName: "Bedrijfsnaam",
	    LblContactPerson: "Contactpersoon",
	    LblCompanyAdmin: "Company Admin",
	    LblCompanyAddress: "Bedrijfsadres",
	    LblApkExiprationSetting: "APK-meldingsinstellingen",
	    LblNotificationFrequency: "Meldingsfrequentie",
	    lblThresholdFrequency: "Frequentie van vooraf waarschuwen",
	    lblThresholdTimeInterval: "Hoe vaak waarschuwingen vooraf",
	    LblIsEmailEnabled: "E-mail bericht",
	    LblEnabled: "Ingeschakeld",
	    LblDisabled: "Uitgeschakeld",
	    LblFrequency: "Frequentie",
	    LblApkTimeInterval: "Tijdsinterval waarschuwingen",
	    LblEmailNotification: "Email bericht",
	    LblWeek: "WEEK",
	    LblMonth: "Maand",
	    lblPerBooking: "Perreservering",
	    LblInternalOrganization: "Interne organisatie",
	    LblNoOfVegicles: "Aantal voertuigen",
	    LblNoOfSharedVehicleGroups: "Aantal poolgroepen",
	    LblGeoLocation: "Locatie",
	    LblSelectGeoLocation: "Selecteer een locatie",
	    LblPerson: "Persoon",
	    LblRole: "Rollen",
	    LblDateOfBirth: "Geboortedatum",
	    LblDriverLicenceNumber: "Rijbewijsnummer",
	    LblPersons: "Personen",
	    LblPersonOverview: "Persoonoverzicht",
	    LblCompanies: "Bedrijven",
	    LblVehicle: "Voertuig",
	    LblVtsVehicle: "VTS voertuig",
	    LblLicenceTag: "Kenteken",
	    LblLicence: "Rijbewijs",
	    LblMobile: "Mobiel",
	    LblVehicleOwner: "Voertuigeigenaar",
	    LblLocationDataExchange: "Locatie data uitwisseling",
	    LblBrand: "Merk",
	    LblType: "Type",
	    LblColor: "Kleur",
	    LblVehicleClass: "Voertuigklasse",
	    LblPricingCategory: "Prijsklasse",
	    LblBodyStyle: "Carrosserievorm",
	    LblAvailable: "Beschikbaar",
	    LblUnAvailable: "Onbeschikbaar",
	    LblAvailableFrom: "Beschikbaar vanaf",
	    LblAvailableTo: "Beschikbaar tot",
	    LblFuelType: "Brandstofsoort",
	    LblMinBookingTimeBefore: "Minimale tijd  vrij voor reservering (minuten)",
	    LblMinBookingTimeAfter: "Minimale tijd vrij na reservering (minuten)",
	    LblTowbar: "Trekhaak",
	    LblAirco: "Airco",
	    LblApkExpirationDateCet: "APK-vervaldatum",
	    LblVehicleAttributes: "Voertuigkenmerken",
	    LblBlockUnBlock: "Blokkeren/Deblokkeren",
	    LblRemoveLicense: "Remove License",
	    LblRemoveLicenseBirthDate: "Remove License and Birth Date",
	    LblLicenseBirthDate: "Geboortedatum",
	    LblBlock: "Blokkeren",
	    LblUnblock: "Deblokkeren",
	    LblAvailableUnAvailable: "Beschikbaar/Onbeschikbaar",
	    LblIntialOdometerValue: "Begin kilometerstand",
	    LblVehicles: "Voertuigen",
	    LblBookingsOverview: "Boekingsoverzicht",
	    LblFuelCardPinCode: "Pincode voor brandstofkaart",
	    LblFuel: "Brandstof",
	    LblVINnumber: "VIN nummer",
	    LblVehicletype: "Voertuig type",
	    LblDoors: "Aantal deuren",
	    LblWeight: "Gewicht voertuig",
	    LblTrunkSpace: "Kofferbakruimte",
	    LblGears: "Aantal versnellingen",
	    LblEngineHorsepower: "Motor (pk)",
	    LblFuelConsumption: "Opgegeven verbruik",
	    LblSeats: "Aantal zitplaatsen",
	    LblDimensions: "Afmetingen voertuig",
	    LblTransmissionType: "Soort transmissie",
	    LblTransmissionUnknown: "Onbekend",
	    LblManualTransmission: "Handgeschakeld",
	    LblAutomaticTransmission: "Automaat",
	    LblVehicleDetails: "Voertuig details",
	    LblSelectVehicletype: "Kies voertuig type",
	    LblWrongVinNumber: "Ongeldig VIN nummer",
	    //WEGO2DEV-325(Settings for Dashboard statuses)
	    LblVehicleOnSameLocationTime: "Voertuig op zelfde locatie langer dan",
	    LblNoBookingIn: "Geen boeking in meer dan",
	    lblHour: "Uur",
	    lblHourDayWeekMonth: "Uur / dag / week / maand",
	    LblSharedVehicleGroup: "Poolgroep",
	    LblVehicleGroup: "Voertuiggroep",
	    LblSharedVehicleGroupAdmin: "Poolgroepbeheerder",
	    LblDisplayPeriod: "Weergave periode",
	    LblBookingWeekDays: "Weekdagen boeken",
	    LblBookingInterval: "Boekingsinterval (minuten)",
	    LblBookingStartTime: "Starttijd van de boeking (uu:mm)",
	    LblBookingEndTime: "Eindtijd boeking (uu:mm)",
	    LblBookingMinDuration: "Minimale boekingsduur (minuten)",
	    LblBookingMaxDuration: "Maximale boekingsduur (minuten)",
	    LblMaxRecurringBooking: "Maximaal aantal herhalingen",
	    LblPreBookingInterval: "Tijdbuffer voor reservering (minuten)",
	    LblPostBookingInterval: "Tijdbuffer na reservering (minuten)",
	    LblBookingExtensionTime: "Max. verlengingstijd reserveren (minuten)",
	    LblBookAheadTime: 'Boeking mogelijk "X" minuten na nu',
	    LblBookingHorizon: "Reserveringshorizon",
	    LblDay: "Dag",
	    LblNumberOfContactTypeGroup: "Aantal Contracttype groepen",
	    LblNumberOfContactType: "Aantal Contracttypen",
	    LblInvoiceInterval: "Factuurinterval",
	    LblIsBookingIntervalAlignToCalendar: "Tijdkeuze boeking conformeren aan tijdblok",
	    LblEarlyOpenInterval: "Eerder openen interval (minuten)",
	    LblFeatureFlags: "Functies",
	    LblCreateBooking: "Boeking maken",
	    LblEditBooking: "Boeking bewerken",
	    LblLicenseCheck: "Rijbewijs controle",
	    LblBookingLicenseCheck: "Boeking rijbewijs controle",
	    LblBookings: "Boekingen",
	    LblSharedVehicleGroups: "Poolgroepen",
	    LblSharedVehicleGroupOverview: "Poolgroep overzicht",
	    LblDriver: "Bestuurder",
	    LblLicenceNumber: "Rijbewijsnummer",
	    LblDriverName: "Naam bestuurder",
	    LblDriverSVG: "Poolgroep bestuurder",
	    LblDriverUserName: "Gebruikersnaam Bestuurder",
	    LblSelectFuelType: "Kies brandstofsoort",
	    LblSelectPricingCatagory: "Kies prijsklasse",
	    LblSelectBodyStyle: "Kies carrosserie",
	    LblSelectVehicleClass: "Kies voertuigklasse",
	    LblVehicleAttributeCategory: "Voertuigkenmerk categorie",
	    LblVehicleAttributeName: "Kenmerk",
	    LblVehicleAttributeDesc: "Omschrijving",
	    LblVehicleAttribute: "Voertuigkenmerk",
	    LbAdditionallVehicleAttribute: "Extra kenmerken",
	    LblVehicleAttributeCategories: "Categorie\u00EBn voor voertuigattributen",
	    LblRegular: "Regulier",
	    LblWeekEnd: "Weekend",
	    LblDayCT: "Dag",
	    LblExtraTimeBefore: "Extra tijd eerder (minuten)",
	    LblExtraTimeAfter: "Extra tijd na (minuten)",
	    LblFreeTextDescription: "Geef het tarief, begin- en eindtijden van de speciale boekig op (vrije tekst)",
	    LblPeriodRate: "Periodetarief",
	    LblPeriodRateVat: "Periodetarief BTW",
	    LblSelectContractTypeType: "Selecteer type contracttype",
	    LblContractTypeType: "Contract type type",
	    LblContractType: "Contract Type",
	    LblContractName: "Contractnaam",
	    LblContractTypeGroup: "Contract Type Groep",
	    LblContractTypeGroupName: "Contract Type Groep naam",
	    LblContractAvailableDays: "Contract beschikbare dagen",
	    LblApplicableDays: "Dagen van toepassing",
	    LblDayStartTime: "Dag starttijd (uu:mm)",
	    LblDayEndTime: "Dag eindtijd (uu:mm)",
	    LblApplicableStartTime: "Toepasselijke starttijd (uu:mm)",
	    LblApplicableEndTime: "Van toepassing zijnde eindtijd (uu:mm)",
	    LblComment: "Opmerking",
	    LblProcessingFee: "Verwerkingskosten",
	    LblTripDisplayType: "Hoe moeten ritten in de rapporten worden getoond?",
	    LblAllTripsIndividually: "Alle ritten afzonderlijk",
	    LblAllTripsGrouped: "Alle ritten gegroepeerd in een enkele rit",
	    LblVatPercentage: "BTW percentage",
	    LblVatIncludedInPrice: "Incl. BTW",
	    LblPlateformUsageCost: "Gebruikskosten van het platform",
	    LblCatA: "Categorie A",
	    LblCatB: "Categorie B",
	    LblCatC: "Categorie C",
	    LblCatD: "Categorie D",
	    LblCatE: "Categorie E",
	    LblCatF: "Categorie F",
	    LblCatG: "Categorie G",
	    LblCatH: "Categorie H",
	    LblHourlyRate: "Kosten huurtijd",
	    LblMileageRate: "Kilometerprijs",
	    LblFixedFee: "Vaste kosten",
	    LblPricingModel: "Prijsmodel",
	    LblContractStartDateTime: "Startdatum contract",
	    LblContractEndDateTime: "Contract einddatum/tijd",
	    LblContractTypeHistory: "Geschiedenis",
	    LblContractTypPeriod: "Contracttype periode",
	    LblInactiveContractTypeGroupReason: "Reden voor het deactiveren van contracttype groep",
	    LblPenaltyAmount: "Boetebedrag",
	    LblPenaltyTimeInterval: "Boetetijdsinterval (minuten)",
	    LblIsPenaltyEnabled: "Boete geactiveerd",
	    LblJanuary: "Januari",
	    LblFebruary: "Februari",
	    LblMarch: "Maart",
	    LblApril: "April",
	    LblMay: "Mei",
	    LblJune: "Juni",
	    LblJuly: "Juli",
	    LblAugust: "Augustus",
	    LblSeptember: "September",
	    LblOctober: "Oktober",
	    LblNovember: "November",
	    LblDecember: "December",
	    LblSJan: "Jan",
	    LblSFeb: "Feb",
	    LblSMar: "Mar",
	    LblSApr: "Apr",
	    LblSMay: "Mei",
	    LblSJun: "Jun",
	    LblSJul: "Jul",
	    LblSAug: "Aug",
	    LblSSep: "Sep",
	    LblSOct: "Okt",
	    LblSNov: "Nov",
	    LblSDec: "Dec",
	    LblSunday: "Zondag",
	    LblMonday: "Maandag",
	    LblTuesday: "Dinsdag",
	    LblWednesday: "Woensdag",
	    LblThursday: "Donderdag",
	    LblFriday: "Vrijdag",
	    LblSaturday: "Zaterdag",
	    LblSSu: "Zo",
	    LblSMo: "Ma",
	    LblSTu: "Di",
	    LblSWe: "Wo",
	    LblSTh: "Do",
	    LblSFr: "Vr",
	    LblSSa: "Za",
	    LblForgotPassword: "Wachtwoord vergeten",
	    LblChangePassword: "Wachtwoord wijzigen",
	    LblOldPassword: "Oude wachtwoord",
	    LblNewPassword: "Wachtwoord",
	    LblProfileUpdatedSucessFully: "Profiel succesvol aangepast",
	    LblPasswordChangedSucessFully: "Je wachtwoord is gewijzigd",
	    LblUpdateProfile: "Profiel wijzigen",
	    LbLReasonVehicle: "Reden onbeschikbaarheid",
	    LblReasonDriver: "Reden blokkeren bestuurder",
	    LblFrom: "Van",
	    LblTo: "Tot",
	    LblBooking: "Reservering",
	    LblBookingRequest: "Reserveringsverzoek",
	    LblOverview: "Reserveringsoverzicht",
	    LblOverviewList: "Lijst met reserveringen",
	    LblApproveBooking: "Reservering goedkeuring",
	    LblApprove: "Goedkeuren",
	    LblReject: "Afwijzen",
	    LblNormal: "Nieuwe reservering",
	    LblSpecial: "Speciale reservering",
	    LblHistory: "Reserveringsgeschiedenis",
	    LblBookingStatus: "Reserveringsstatus",
	    LblBookingType: "Reserveringstype",
	    LblAdminRemarks: "Opmerking Admin",
	    LblBookingRemarks: "Reservering opmerkingen",
	    LblDriverRemarks: "Opmerkingen bestuurder",
	    LblBookingReferenceId: "Reserveringsnr.",
	    LblAbort: "Afbreken",
	    LblRevoke: "Intrekken",
	    LblStatus: "Status",
	    LblReference: "Referentienr.",
	    LblRemarks: "Opmerkingen",
	    LblSearchForVehicle: "Zoek voertuig",
	    LblVehicleOverview: "Voertuigoverzicht",
	    LblConfirmBooking: "Bevestig reservering",
	    LblCurrentBookingDetail: "Details huidige reservering",
	    LblCheckAvailability: "Controleer beschikbaarheid",
	    LblBookingStartDateTime: "Start reservering",
	    LblBookingEndDateTime: "Einde reservering",
	    LblSource: "Ophaallocatie",
	    LblRecurring: "Herhalend",
	    LblRecurringId: "Herhalingreserveringsnr.",
	    LblRecurringBookingReference: "Referentie herhalingsreserving",
	    LblDaily: "Dagelijks",
	    LblWeekly: "Wekelijks",
	    LblMonthly: "Maandelijks",
	    LblRecurrenceEndDate: "Einddatum herhaling",
	    LblSearch: "Zoek",
	    LblBookNow: "Reserveer",
	    LblUpdateBooking: "Wijzig Reservering",
	    LblEditCarNotAvailable: "Origineel geboekte auto is niet beschikbaar",
	    LblSortBy: "Sorteer op",
	    LblAvaibility: "Beschikbaarheid",
	    LblNoMatchingVehicle: "Geen beschikbare voertuigen gevonden",
	    LblAvailableSlots: "Beschikbare perioden",
	    LblFeatures: "Kenmerken",
	    LblDriverDetail: "Bestuurdersgegevens",
	    LblBookingDetail: "Reserveringsgegevens",
	    LblVehicleDetail: "Voertuiggegevens",
	    LblBookingSuccess: "U heeft een boekingsaanvraag succesvol aangemaakt. Een kopie van het verzoek wordt verzonden naar het geregistreerde e-mailadres. Een kennisgeving wordt ook ter goedkeuring verzonden en u zult op de hoogte worden gesteld wanneer de boeking wordt geaccepteerd.",
	    LblBookingUpdateSuccess: "Boeking succesvol bijgewerkt. Er wordt een melding verzonden naar het e-mailadres van de bestuurder.",
	    LblBlockNormalBooking: "Je account is geblokkeerd. Neem contact op met de Administrator.",
	    LblSingle: "Enkele",
	    LblSeries: "Reeks",
	    LblLicenceRequired1: "Gelieve het rijbewijsnummer te valideren, ga naar",
	    LblLicenceRequired2: "Om de rijbewijsdetails bij te werken.",
	    LblAcceptOrReject: "Goedkeuren / afwijzen",
	    LblSpecialBooking: "Speciale reservering",
	    LblAffectedBooking: "Betrokken reservering ",
	    LblSpecialBookingType: "Speciale reservering type",
	    LblSelectSpecialBookingType: "Selecteer speciaal reserveringtype",
	    LblSpecialBookingConfiramtionmsg: "Weet je zeker dat je een speciale reservering wilt aanmaken?",
	    LblEndDate: "Einde herhaling",
	    LblNotification: "Melding",
	    LblSubject: "Onderwerp",
	    LblDate: "Datum",
	    LblWelcomeNotification: "Welkom bij de meldingen inbox",
	    LblTemplate: "Sjabloon",
	    LblTemplateList: "Sjabloonlijst",
	    LblTemplateName: "Sjabloonnaam",
	    LblTemplateType: "Sjabloontype",
	    LblIsEmailTemplate: "E-mail",
	    LblIsWebTemplate: "Web",
	    LblBody: "Carrosserie",
	    LblNotificationEventManagement: "Melding gebeurtenis management",
	    LblNotificationEvent: "Melding gebeurtenis",
	    LblModuleName: "Modulenaam",
	    LblSMS: "SMS",
	    LblUserType: "Gebruikerstype",
	    LblTimeBlock: "Tijdblok",
	    LblTimeBlockName: "Tijdblok naam",
	    LblTimeBlockWeekDays: "Tijdblok weekdagen",
	    LblTimeBlockStartTime: "Tijdblok starttijd",
	    LblTimeBlockEndTime: "Tijdblok eindtijd",
	    LblTimeBlockStartDate: "Tijdblok startdatum",
	    LblTimeBlockEndDate: "Tijdblok einddatum",
	    LblServiceOffer: "Service-aanbod",
	    LblServiceOfferList: "Service-aanbod lijst",
	    LblServiceOfferName: "Servicenaam",
	    LblServiceOfferType: "Servicetype",
	    LblStandardTariff: "Standaardtarief",
	    LblTimeUsedOrBooked: "Tijd gebruikt/gereserveerd",
	    LblDistance: "Afstand",
	    LblPenalty: "Boete",
	    LblAdditional: "Extra",
	    LblAdditionalAbbr: "Bovendien",
	    LblUnit: "Eenheid",
	    LblWegoAdmin: "WeGo beheerder",
	    LblWegoAdmins: "Wego Admins",
	    LblReSend: "Stuur opnieuw",
	    LblResendActivationMail: "Activatiemail",
	    LblResendActivationMailFailure: "Versturen van activatiemail niet gelukt",
	    LblResendActivationMailSuccess: "Activatiemail verstuurd",
	    LblSubscription: "Abonnement",
	    LblSubscriptionName: "Abonnementnaam",
	    LblTimeInterval: "Tijdsinterval",
	    LblAmount: "Hoeveelheid",
	    LblFreeKilometer: "Gratis credits",
	    LblFreeMinute: "Gratis minuten",
	    LblFreeHours: "Gratis uren",
	    LblNumberOfSubscription: "Aantal abonnementen",
	    LblUnsubscribe: "Opzeggen abonnement",
	    LblsubscribeEndDate: "Einddatum abonnement",
	    LblSubscriptionStartDate: "Startdatum abonnement",
	    LblSpecialPeriod: "Speciale periode",
	    LblspecialPeriodName: "Speciale periode naam",
	    LblSpecialPeriodStartTime: "Speciale periode starttijd",
	    LblSpecialPeriodEndTime: "Speciale periode eindtijd",
	    LblSpecialPeriodWeekDays: "Speciale periode weekdagen",
	    LblNormalPeriod: "Normale periode",
	    LblSpecialPeriods: "Speciale Periode",
	    LblWegoAdminDependencyValidation: "WeGo beheerder kan niet worden verwijderd omdat deze aan een andere entiteit is gekoppeld",
	    LblBookingInvoice: "Reserveringsfactuur",
	    LblInvoiceStatus: "Factuurstatus",
	    LblAdminDependencyValidation: "Beheerdersrol kan niet worden verwijderd omdat deze aan een andere entiteit is gekoppeld.",
	    LblAdminDependencyAlert: "Beheerdersafhankelijkheidswaarschuwing",
	    LblTotalHours: "Totaaltijd",
	    LblInvoiceType: "Factuurtype",
	    LblSummary: "Summary",
	    LblTotalKm: "Totaalafstand (km.)",
	    LblTotalExpense: "Totale kosten",
	    LblInvoiceNumber: "Factuurnummer",
	    LblAdminDependencyValidationOnDelete: "Geselecteerde beheerder kan niet worden verwijderd omdat deze aan een andere entiteit is gekoppeld.",
	    LblBegin: "Start",
	    LblEnd: "Eind",
	    LblVat: "BTW",
	    LblTotal: "Totaal",
	    LblInvoiceRequestDateTime: "Factuurverzoek datum/tijd",
	    LblInvoiceSendDateTime: "Factuurverzend datum/tijd",
	    LblInvoiceDateTime: "Factuur datum/tijd",
	    LblInvoiceDetail: "Factuurdetails",
	    LblResend: "Herzenden",
	    LblDownload: "Download",
	    LblResendInvoiceConfirm: "Weet u zeker dat u %0 wilt herzenden?",
	    LblRemoveContactPersonConfirm: "Weet u zeker dat u de contactpersoon wilt verwijderen?",
	    LblPenaltyRate: "Boetetarief",
	    LblSendInvoiceConfirm: "Weet u zeker dat u de factuur wilt verzenden?",
	    LblInvoicing: "Facturatie",
	    LblLegacyInvoicing: "Factuur (voor 2025-04-22)",
	    LblInvoices: "Factuur",
	    LblCarwiseConfiguration: "Carwise-configuratie",
	    LblCarwiseConnectionUrl: "Verbindings-URL",
	    LblCarwiseConnectionUsername: "Verbindingsnaam",
	    LblCarwiseEnable: "Carwise ingeschakeld",
	    LblCarwiseConnectionPassword: "Verbindingswachtwoord",
	    LblCarwiseAutoDeleteFrequencyInDays: "Automatische verwijderfrequentie (in dagen)",
	    LblDamageImageExtentions: "Schadebestand formaat",
	    LblDone: "Gereed",
	    LblClear: "Clear",
	    LblEditPage: "Bewerk %0",
	    LblAddPage: "Voeg %0 toe",
	    LblListPage: "%0 Overzicht",
	    LblAll: "Alle",
	    LblProfile: "Profiel",
	    LblSignOut: "Log uit",
	    LblTemplateNote1: "Verwijder of wijzig tekst geschreven als {variabelename} niet. Dit is een variabel element dat tijdens versturen wordt vervangen door de betreffende waarde uit de database.",
	    LblTemplateNote2: "Wijzig a.u.b. niets aan de tabelstructuur. U kunt een nieuwe toevoegen, echter de bestaande dient niet gewijzigd te worden.",
	    LblTemplateNote3: "Zorg er alstublieft voor dat wanneer u een 'placeholder' kopieert en deze in een HTML-editor wilt plakken, u deze als \"Plakken als gewone tekst\" plakt.",
	    LblConfirmUnsubscribe: "Weet u zeker dat u zich wilt afmelden?",
	    LblDriveHours: "Beschikbare uren",
	    LblVehicleImage: "Voertuigafbeelding",
	    LblMaintenance: "Onderhoud",
	    LblUNAVAILABLE: "Onbeschikbaar",
	    LblTestInvoiceGenerator: "Testfactuur generator",
	    LblInvoicingDateTime: "Factuur datum/tijd (UTC)",
	    LblGenerateInvoice: "Genereer factuur",
	    LblDeleteAllSelectedRecords: "Verwijder alle geselecteerde regels",
	    LblCancelAllSelectedRecords: "Annuleer alle geselecteerde regels",
	    "LblExportAll(CSV)": "Exporteer (CSV)",
	    LblContractTypeGroupAvailableForSubscription: "Geen contracttype groep beschikbaar om %0 toe te voegen.",
	    LblAddContactPerson: "Voeg contactpersoon toe",
	    LblRemoveContactPerson: "Verwijder contactpersoon",
	    LblNote: "Notitie",
	    LblCompletelyEndConfirm: "Rit volledig beindigen",
	    LblEndTrip: "Beëindig rit",
	    LblTestTrip: "Testrit",
	    LblTripSimulator: "Ritsimulator",
	    LblTestTripSuccess: "Testrit succesvol aangemaakt",
	    LblDrivingStartDateTime: "Begin datum/tijd rijden",
	    LblDrivingEndDateTime: "Eind datum/tijd rijden",
	    LblInvoiceMoment: "Factuurtijdstip",
	    LblExtend: "Verlengen",
	    LblExtendRequire: "Voer a.u.b. de verlengingstijd in (minuten)",
	    LblExtendInfoMsg: "U kunt boeking tot %0 minuten verlengen",
	    LblExtendValidationMsg: "Deze reservering kan niet verlengd worden",
	    LblExtendBooking: "Verleng Reservering",
	    LblBookingExtendedSuccess: "Verlenging Resevering gelukt",
	    LblOverExtendValidationMsg: "Reservering kan niet met meer dan %0 minuten verlengd worden",
	    LblUnLock: "Ontgrendelen",
	    LblLock: "Sluit",
	    LblVehicleStatus: "Voertuig status",
	    LblTripSuccess: "Rit opgeslagen",
	    LblLockSuccessfully: "Voertuig succesvol gesloten",
	    LblLockCompletelySuccessfully: "Voertuig afgesloten",
	    LblUnLockSuccessfully: "Voertuig ontgrendeld",
	    LblUnlockProblem: "Probleem tijdens ontgrendelcommando",
	    LbllockProblem: "Probleem tijdens afsluitcommando",
	    LblLockCarCompletely: "Sluit en beëindig de reservering",
	    LblStartDateTime: "Start datum/tijd",
	    LblEndDateTime: "Eind datum/tijd",
	    LblBookingTripDetail: "Boeking rit details",
	    LblAddNewTrip: "Voeg nieuwe rit toe",
	    LblBookingExpenseDetail: "Details Reseveringsonkosten",
	    LblUnlockErrorMessage: "Geen actieve contracttype groep beschikbaar bij deze reservingstijd",
	    LblExpenseAmount: "Onkostenbedrag",
	    LblExpenseName: "Onkostennaam",
	    LblExpenseSuccess: "Onkosten succesvol opgeslagen",
	    LblReceipt: "Ontvangst",
	    LblHelpdeskNo: "Helpdesknummer",
	    LblInactiveReason: "Reden voor inactiviteit",
	    LblBookingExpired: "U kunt het voertuig niet ontgrendelen als de reservering is verlopen",
	    LblTripCalculationInProgress: "Hopelijk heeft u een voorspoedige rit gehad! Het voertuig zal binnen een paar seconden sluiten.",
	    LblActualInvoiceGenerationDate: "Datum factuurcreatie",
	    LblAvailableForAllSlots: "Voertuig beschikbaar voor alle tijdslots",
	    LblUnAvailableSlots: "Onbeschikbare tijdslots",
	    LblNoOfDrivers: "Aantal bestuurders",
	    LblVTSReqLogDetail: "VTS log details aanvraag",
	    LblVTSReqDateTime: "Verzoek datum/tijd",
	    LblVTSProcessTime: "Verwerkingstijd",
	    LblVTSResTime: "Resultaat tijdstip",
	    LblVTSReqType: "Verzoek type",
	    LblVTSResult: "Resultaat",
	    LblSVGDriversList: "Poolgroepbestuurders",
	    LblVehicleInformation: "Voertuiginformatie",
	    LblVTSVehicle: "VTS Voertuig",
	    LblFleetId: "Vloot ID",
	    LblContractId: "Contract ID",
	    LblVIN: "VIN",
	    LblVTSVehicleUpdateSuccess: "Voertuig succesvol %0",
	    LblTroubleShootVTS: "VTS Probleemoplossing",
	    LblVTSVehicleList: "VTS voertuig lijst",
	    //Booking Type
	    LblNORMALBOOKINGTYPE: 'NORMAAL',
	    LblMAINTENANCEBOOKINGTYPE: 'ONDERHOUD',
	    LblUNAVAILABLEBOOKINGTYPE: 'ONBESCHIKBAAR',
	    //Booking Request Status
	    LblAPPROVEDBOOKINGREQUEST: 'GOEDGEKEURD',
	    LblREJECTEDBOOKINGREQUEST: 'AFGEKEURD',
	    LblPENDINGBOOKINGREQUEST: 'INAFWACHTING',
	    //Booking Status
	    LblABORTED: 'AFGEBROKEN',
	    LblCANCELLED: 'GEANNULEERD',
	    LblCONFIRMED: 'BEVESTIGD',
	    LblFINISHED: 'BEËINDIGD',
	    LblNOSHOW: 'NOSHOW',
	    LblPENDING: 'INAFWACHTING',
	    LblREVOKED: 'INGETROKKEN',
	    LblRUNNING: 'GESTART',
	    LblREADYFORPAYMENT: 'KLAAR VOOR BETALING',
	    //Invoice Status
	    LblOPEN: 'OPEN',
	    LblSENT: 'VERZONDEN',
	    LblCLOSED: 'AFGESLOTEN',
	    LblREQUESTFORPAYMENT: 'VERZOEK OM BETALING',
	    LblREOPEN: 'HEROPEND',
	    LblFileNotFound: "Het bestand bestaat niet, neem contact op met de helpdesk",
	    // Error Log
	    LblErrorLog: "Foutenlogboek",
	    LblComponentName: "Componentnaam",
	    LblLogType: "Log Type",
	    LblEventDateTime: "Gebeurtenis datum/tijd",
	    // Interface Status
	    LblInterfaceStatus: "Interface Status",
	    LblLastStatusChangeDateTime: "Laatste status wijziging datum/tijd",
	    LblLastCarwisePollDateTime: "Last Carwise Poll DateTime",
	    LblUpdatedDateTime: "Gewijzigde datum / tijd",
	    LblMonitoring: "Monitoring",
	    LblDropoffMessage: "Dropoff bericht",
	    LblPreferredlanguage: "Voorkeurs taal",
	    LblDebtornr: "Debiteurnummer",
	    //ErrorEscalation
	    LblDuplicateErrorEscalation: "Dubbele foutescalatieconfiguratie gevonden",
	    LblErrorEscalation: "Foutescalatie",
	    LblComponent: "Component",
	    LblSelectAdminLevel: "Selecteer beheerdersniveau",
	    LblWegoAdminLevel: "Wego Admin Level",
	    LblCustomerAdminLevel: "Klantbeheerderniveau",
	    LblInstanceAdminLevel: "Instantiebeheerderniveau",
	    LblEnableLogin: "Login inschakelen",
	    LblEnableErrorEscalation: "Schakel foutescalatie in",
	    LblErrorEscalationMinutes: "Fout bij escalatie minuten",
	    //Report Damage
	    LblReportDamage: "Schade rapporteren",
	    LblCompleteDamageReport: "Schaderapport indienen",
	    LblDamageFile: "Schade bestand",
	    LblDescribe: "Beschrijf de schade...",
	    LblCause: "Beschrijf de oorzaak...",
	    LblReportDamageMsg: "Schade gerapporteerd",
	    LblSelectFile: "Selecteer bestand",
	    // Import Data
	    LblCSVImport: "CSV bestand importeren",
	    LblValidateCSV: "Valideren CSV",
	    LblImportValidPerson: "Importeren geldig Persoon",
	    LblImportValidDriver: "Geldige bestuurder importeren",
	    LblImportValidVehicle: "Geldig voertuig importeren",
	    LblCSVType: "CSV bestandstype",
	    LblCSVFile: "CSV bestand",
	    LblRecordImportedSuccess: "%0 is geïmporteerd",
	    LblInvalidReason: "Ongeldige Reden",
	    LblSameVTSCommand: "Het verzoek wordt al verwerkt. Een moment geduld alstublieft.",
	    LblImportPerson: "Persoon importeren",
	    //Subscription related Changes
	    LblSubscriptionInterval: "Abonnementsperiode",
	    LblPaymentInterval: "Betalingsinterval",
	    LblInvoicInterval: "Factuurinterval",
	    LblInterval: "Interval",
	    LblInvoiceMomentDay: "Factuur moment (dag van de week)",
	    LblInvoiceMomentMonth: "Factuur moment (dag van de maand)",
	    LblFreeMinuteInterval: "Gratis minuten interval",
	    LblFreeKMInterval: "Gratis kilometers interval",
	    LblSelectSubscriptionInterval: "Selecteer abonnementsperiode",
	    LblSelectInvoiceInterval: "Selecteer factuurinterval",
	    LblSelectPaymentInterval: "Selecteer betalingsinterval",
	    LblSelectFreeKMInterval: "Selecteer gratis kilometerinterval",
	    LblSelectFreeMinInterval: "Selecteer gratis minuteninterval",
	    LblYearlySub: "Jaarlijks",
	    LblMonthlySub: "Maandelijks",
	    LblWeeklySub: "Wekelijks",
	    LblFreePerWeek: "Per week",
	    LblFreePerMonth: "Per maand",
	    LblFreePerTriMonth: "Per 3 maanden",
	    LblFreePerBiannual: "Per 6 maanden",
	    LblFreePerYear: "Per jaar",
	    LblDefaultContractTypeGroup: "Standaard contractype groep",
	    LblSelectDefaultContractTypeGroup: "Selecteer standaard contracttype groep",
	    LblSendInvoiceToDriver: "Factuur verzenden naar bestuurder",
	    LblInherit: "Neem over",
	    //Invoice Moment
	    LblDayOfMonth: "Dag van de maand",
	    LblDayOfWeek: "Dag van de week",
	    LblSelectDayOfWeek: "Selecteer dag van de week",
	    LblInstanceLogo: "Instantie Logo",
	    LblResetPasswordFailure: "Het wachtwoord kan niet worden gereset, want de gebruiker is nog niet geactiveerd.",
	    LblInvoiceDeleteValidation: "Kan factuur niet verwijderen vanwege associatie met andere entiteit",
	    //Additional Free Item
	    LblAdditionalFreeItems: "Extra gratis credits",
	    LblDateAwared: "Toekenningsdatum",
	    LblAdditionalFreeItemsMenu: "Extra gratis credits",
	    LblTotalFreeKilometer: "Totaal gratis kilometers",
	    LblTotalFreeMinute: "Totaal gratis minuten",
	    LblCurRemainFreeKilometer: "Resterende gratis kilometers",
	    LblPrevRemainFreeKilometer: "Vorige hoeveelheid resterende gratis kilometers",
	    LblCurRemainFreeMinute: "Resterende gratis minuten",
	    LblPrevRemainFreeMinute: "Vorige hoeveelheid resterende gratis minuten",
	    LblPrevious: "Vorige",
	    LblCurrent: "Huidig",
	    //Instance Clone
	    LblInstanceClone: "Instantie klonen",
	    LblNewInstanceName: "Naam nieuwe instantie",
	    LblCloneResult: "Resultaat klonen",
	    LblCloneStatus: "Kloon Status",
	    CloneError: "Er is een fout opgetreden bij het klonen van de instantie en de bijbehorende entiteiten.",
	    //SubscriptionAvailabilityRestriction
	    LblSubscriptionAvailabilityRestriction: "Beperking beschikbaarheid abonnement",
	    LblStartDay: "Begindag",
	    LblEndDay: "Einddag",
	    LblStartTime: "Starttijd (hh:mm)",
	    LblEndTime: "Eindtijd (hh:mm)",
	    LblRestriction: "Beperking",
	    //Trip Detail Report
	    LblTripDetailReport: "Rit overzicht",
	    LblTripDetailList: "Gedetailleerd reserveringsoverzicht",
	    LblSearchTripforDriver: "Zoek ritten voor bestuurder",
	    LblExportReport: "Exporteer rapport",
	    LblValidateLiceanceNumberMessage: "Controleer je rijbewijs",
	    LblBookingIntervalRate: "Intervaltarief",
	    LblPerHour: "Per uur",
	    LblPerBookingIntarval: "Per reserveringsinterval",
	    LblTimeRate: "Tijdtarief",
	    LblToalBookingDuration: "Reserveringsduur",
	    LblTripComments: "Rit opmerking",
	    LblTripCommentDescription: "Voer opmerking in",
	    LblTripCommentError: "Voer a.u.b. opmerking in",
	    LblShowTripComment: "Bekijk opmerking",
	    LblAddTripComment: "Voeg opmerking toe",
	    LblTripCommentBy: "Rit opmerking door",
	    LblTripCommentOn: "Rit opmerking op",
	    LblCleanRequire: "Schoonmaak benodigd",
	    LblFualRequire: "Brandstof benodigd",
	    LblVehicleDamageList: "Lijst van voertuigschades",
	    LblDamageCause: "Schadeoorzaak",
	    LblDamageReportedBy: "Gemeld door",
	    LblDamageReportedOn: "Gemeld op",
	    LblConfirmResolveDamage: "Weet u zeker dat u de schademelding wilt verwijderen?",
	    LblVehicleDamgeResolveSuccess: "Schademelding verwijderd",
	    LblDamageDesc: "Schade omschrijving",
	    LblFutureBooking: "Toekomstige reserveringen",
	    LblVehFutureBookingList: "Lijst met toekomstige voertuigboekingen",
	    LblResolveDamge: "Schademelding verwijderen",
	    LblReserved: "Gereserveerd",
	    LblVehicleInfoSuccess: "Voertuiginformatie opgeslagen",
	    LblInformation: "Informatie",
	    LblVtsServiceStatus: "VTS service status",
	    LblVtsLicencetag: "VTS kenteken",
	    LblVtsDoorStatus: "Status portier",
	    LblVtsIssueCommand: "Stuur commando",
	    LblVehicleLocation: "Voertuiglocatie",
	    LblEventHistory: "VTS gebeurtenis geschiedenis",
	    LblVehicleObuStatus: "Status Voertuig OBU",
	    LblVTSHistory: "VTS gebeurtenis geschiedenis",
	    LblRequestType: "Opdracht Type",
	    LblCommandInitiator: "Opdracht verstuurd door",
	    LblResult: "Resultaat",
	    LblVTSRequestTime: "VTS aanvraag tijd",
	    LblVTSResultTime: "VTS Resultaat tijd",
	    LblWegoProcessTime: "WeGo verwerkingsduur",
	    LblWegoRequestTime: "WeGo aanvraag tijd",
	    LblWegoResultTime: "WeGo resultaat tijd",
	    LblView: "Overzicht",
	    LblVehicleNotInitialized: "Voertuig niet geïnitialiseerd",
	    LblLastReceivedTime: "Tijd laatst ontvangen bericht",
	    LblFreePerBookingInterval: "Per reserveringsinterval",
	    LblVtsLocation: "VTS locatie",
	    LblSelectObuType: "Selecteer OBU Type",
	    LblObuType: "OBU Type",
	    LblDeviceId: "Device Id",
	    LblClaimCode: "Claim code",
	    LblRetriveAddress: "Adres ophalen",
	    LblCrearedDate: "Datum gemaakt",
	    LblCreatedBy: "Gemaakt door",
	    LblPerBooking: "Perreservering",
	    LblSelectFilter: "Selecteer filter",
	    LblAuditEntries: "Controleer invoer",
	    LblFilter: "Filter",
	    LblCategory: "Categorie",
	    LblEventName: "Gebeurtenis naam",
	    LblEventData: "Gebeurtenis gegevens",
	    LblMoment: "Moment",
	    LblUser: "Gebruiker",
	    LblNoEventDataFound: "Geen eventgegevens gevonden",
	    LblEventViewer: "Gebeurtenis bekijken",
	    LblOBU: "OBU",
	    LblClone: "Kopieer",
	    LblCloneVehicle: "Kopieer %0",
	    LblFualNotRequire: "Brandstof niet benodigd",
	    LblCleanNotRequire: "Schoonmaak niet benodigd",
	    LblSubscriptionInfo: "Abonnementsinformatie",
	    LblVehiclDamaged: "Voertuig met schade",
	    LblVehicleNotDamaged: "Voertuig zonder schade",
	    LblDamage: "Schade",
	    LblFreeBooking: "Aanpassen reserveringskosten",
	    LblBookingCustomFee: "Totale reserveringskosten",
	    LblFreeBookingSuccess: "Reserveringskosten opgeslagen",
	    LblEnterLocation: "Voer locatie in",
	    LblHomeLocation: "Thuislocatie",
	    LblLocationMode: "Locatieinstelling",
	    LblMeter: "Meter",
	    LblLocation: "Locatie",
	    LblPickupLocation: "Ophaallocatie",
	    LblLocationUnavailable: "Locatie onbeschikbaar",
	    LblAvailabilityCalander: "Beschikbaarheidskalender",
	    LblAvailableOn: "Beschikbaar op",
	    LblGeofenceEnabled: "Geofence actief",
	    LblLocationNotFound: "Kan adres niet te bepalen",
	    LblAddressNotAvailable: "Kan adres niet te bepalen op deze locatie",
	    LblReports: "Rapporten",
	    LblDrivers: "Bestuurders",
	    LblTemplates: "Sjablonen",
	    LblPlaceHolder: "Placeholder",
	    LblSampleTemplate: "Voorbeeld sjabloon",
	    LblLatexFileDownloadValidation: "Ongeldige Latex inhoud",
	    LblLocationDataExchangeNotAssign: "Dit voertuig kan niet geboekt worden als er geen VTS-voertuig is toegewezen. Wil je verder gaan ?",
	    LblRevenue: "Omzet",
	    // Vehicle Occupancy Report
	    LblVehicleOccupancyReport: "Bezettingsgraadrapport",
	    LblReservedTime: "Gereserveerde tijd",
	    LblUsageTime: "Gebruiksduur",
	    LblUsageTimeAtOffice: "Gebruik tijdens kantooruren",
	    LblUsageTimeoutOffice: "Gebruik buiten kantooruren",
	    LblRevenuePerVehicleReport: "Omzet per voertuig",
	    LblSearchRevenuePerVehicle: "Zoek omzet per voertuig",
	    LblRevenuePerVehicleList: "Lijst van omzet per voertuig",
	    lblThreshold: "Vooraf waarschuwen vanaf",
	    //OdometerLogTrail
	    LblOdometerLogTrail: "Kilometerteller historie",
	    LblUserProvidedOdometerValueInKmr: "Kilometerstand (km)",
	    LblDescriptionOfDeviation: "Verklaring voor afwijking",
	    LblFromOdometer: "Van kilometerteller",
	    LblToOdometer: "Naar kilometerteller",
	    LblAddDescriptionOfDeviation: "Voeg verklaring voor afwijking toe",
	    LblDeviation: "Afwijking (km)",
	    LblLastOdometerValue: "Vorige kilometerstand (km)",
	    LblLastOdometerDT: "Vorige odometer datum",
	    LblodometerConfiguration: "Instellingen kilometerteller",
	    LblEnableOnApp: "Toon in app",
	    LblWarningPer: "Waarschuwing (%)",
	    LblOdometerRegistered: "Kilometerstand geregistreerd",
	    LbLOdometerEnabled: "Kilometerteller aan",
	    LblOdometerValue: "Kilometerstand",
	    LblMaintenancePlanningList: "Onderhoudsplanning",
	    LblSearchMaintenancePlanningValue: "Zoek in onderhoudsplanning",
	    LblMaintenancePlanningreport: "Onderhoudsplanning rapport",
	    LblShowDeviation: "Toon afwijking zonder verklaring",
	    LblTitle: "Titel",
	    LblFooterText: "Voetnoot",
	    LblvalidEmailDomain: "Alleen e-mailadressen van dit domein toegestaan",
	    LblURLSettings: "URL instellingen",
	    LblSuccessUrl: "URL instellen gelukt",
	    LblEmailSettings: "E-mail instellingen",
	    LblSendActivationEmail: "Stuur automatische activatiemails",
	    LblSendConfirmationEmail: "Stuur automatische bevestigingsmails",
	    LblRequireAdminApprovel: "Verplicht toestemming van beheerder bij nieuwe inschrijving",
	    LblDriverInformationToBeInclude: "Bestuurdersinformatie welke moet worden toegevoegd",
	    LblSignUpForm: "Aanmeldformulier",
	    LblSignupForms: "Aanmeldformulieren",
	    LblSignupFormsOverview: "Overzicht aanmeldformulieren",
	    LblWhoCanApprove: "Wie kan nieuwe aanmeldingen toestaan?",
	    LblSignupFormLogo: "Logo aanmeldformulier",
	    LblChooseSubscription: "Kies de abonnementen voor op het aanmeldformulier",
	    LblSignupParameter: "Webpagina aanmeldformulier",
	    LblSignupParameterText: "Aanmeldformulier URL-tekst",
	    DomainNameString: "Door komma's gescheiden domeinnamen (zoals gmail.com,yahoo.com)",
	    SignupParameterString: "Alleen letter, cijfers en - zijn toegestaan",
	    LblAvailability: "Beschikbaarheid",
	    LblSettings: "Instellingen",
	    LblCurrentStatus: "Huidige status",
	    LblFlags: "Flags",
	    LblNA: "Niet beschikbaar",
	    //Sign up form
	    LblConfirmEmail: "Bevestig e-mailadres",
	    LblSignup: "Aanmelden",
	    LblSignupsOverView: "Aanmeldoverzicht",
	    LblSignupApproval: "Toestemming aanmeldingen",
	    LblAccept: "Accepteer",
	    LblSignupFormDescription: "Aanmeldformulier omschrijving",
	    LblCurrentOdometerValue: "Huidige kilometerstand",
	    LblCurrentOdometerDateTime: "Tijdstip huidige km stand",
	    LblCreateDirectDebitFile: "Maak incassobestand aan",
	    LblCheckEmptyIbanNumber: "Controleer IBAN nummers",
	    LblCreatedDate: "Datum gecreëerd",
	    LblIncludeInDirectDebit: "Aan incassobestand toevoegen",
	    LblDirectDebitFileDate: "Datum incassobestand",
	    LblDirectDebitConfiguration: "Incasso configuratie",
	    LbLDirectDebitEnabled: "Incasso functionaliteit inschakelen",
	    LblDirectDebitEnableper: "Incasso functionaliteit ingeschakeld vanaf",
	    LbLCreditorDetails: "Crediteur informatie",
	    LblAddress: "Adres",
	    LblIBANNumber: "IBAN",
	    LblCountryCode: "Landcode",
	    LbLBillingInformation: "Betaalgegevens",
	    LblInvoicingDetails: "Factuurgegevens",
	    LbLSubjectToDirectDebit: "Gebruikt automatische incasso?",
	    //Batch Upload Person
	    LblBatchUploadPersonSetting: "Import Personen instellingen",
	    LblShowBatchUploadInfo: "Batch invoer voor personen functionaliteit inschakelen?",
	    LblAllowBatchUpload: "Rol die mag importeren",
	    LblAllowActivationMail: "Gebruik activatiemails",
	    LblGenerateRandomPassword: "Systeem genereert wachtwoorden",
	    LblUserUploadPassword: "Wachtwoord in importbestand",
	    LblFieldToUploadedOrValidated: "Aangeleverde velden",
	    LblBatchUploadPerson: "Importeer Personen",
	    LblBatchUpload: "Importeer Personen",
	    LblDownloadTemplate: "Importbestand voorbeeld",
	    LblUserAssignSVGMessage: "Gebruiker nog niet toegewezen aan poolgroep!",
	    LblInvalidRecordReason: "Ongeldig(e) record(s)",
	    LblSelectedSVGs: "Geselecteerde poolgroep(en)",
	    LblDashboardConfiguration: "Dashboard Configuratie",
	    LblEnableCurrentLocation: "Zet 'Huidige locatie' aan",
	    LblDefaultLocation: "Standaard te tonen locatie",
	    LblEnableAutoUpdate: "Zet automatisch verversen aan",
	    LblPriorityNotificationSetting: "Voertuigstatusmelding instellingen",
	    SelectionRequiredMsg: "Selecteer ten minste één boeking om goed te keuren / af te wijzen",
	    LblSelectionRequired: "Selectie vereist",
	    LblCollectionDate: "Incassodatum",
	    LblBICCode: "BIC code",
	    LblDirectDebitFile: "Incasso Bestand",
	    LblFormat: "Formaat",
	    LblMissingIBANNumber: "Ontbrekende IBAN",
	    LblImportDriverRole: "Bestuurdersrol automatisch toewijzen?",
	    LblAssignToSVG: "Toewijzen aan poolgroep(en)",
	    LblSVG: "Poolgroep",
	    LblMandateId: "Mandaat Id",
	    LblMandateSignatureDate: "Datum handtekening mandaat",
	    LblIsAmmandment: "Is Ammandement",
	    LblRemovePersonDetails: "Verwijder persoonsgegevens",
	    LblDashboard: "Dashboard",
	    LblGroupAdmin: "Groepsbeheerder",
	    LblCurrentLocation: "Huidige locatie",
	    LblCurrentDriver: "Huidige bestuurder",
	    LblNextDriver: "Volgende bestuurder",
	    LblSecond: "Second(en)",
	    LblCleaning: "Schoonmaken",
	    LblRefueling: "Tanken/opladen",
	    LblAPKMaintenance: "APK onderhoud",
	    LblOutsideGeofence: "Buiten geofence",
	    LblNotBooked: "Niet geboekt",
	    LblNotBookedSince: "Niet geboekt sinds",
	    LblLowBattery: "Lage accuspanning",
	    LblBatteryVolt: "V.",
	    LblLowCharge: "Batterij (bijna) leeg",
	    LblChargingPercentage: "%",
	    LblOnSamePosition: "Niet verplaatst",
	    LblLastPosition: "Laatste positie",
	    LblNotReturn: "Niet Retour",
	    LblCommunicationProblem: "Communicatie probleem",
	    LblInuse: "In gebruik",
	    LblPriority: "Prioriteit",
	    LblDirectDebitDownloadSuccess: "Incassobestand gedownload",
	    LblDefaultStatus: "Default Status",
	    LblWarnings: "Waarschuwingen",
	    LblDirectDebitFileId: "Incassobestand Id",
	    LblTotalAmount: "Totaalbedrag",
	    LblReCreate: "Download opnieuw",
	    LblPleaseEnterCollectionDate: "Voer incassodatum in",
	    LblOpenViaLowLevel: "Low level ontgrendeld",
	    LblInstanceNotificationNote1: "Instelling werkt als instelling bij bedrijf",
	    LblNoInvoiceSelected: "Geen facturen geselecteerd voor incasso",
	    LblIBANNumberRequired: "Voer IBAN en BIC Code in",
	    LblNoEmptyIBANFound: "Geen lege IBAN gevonden",
	    LblInvalidTagUsed: "Ongeldige tag gebruikt",
	    LblNotInvalidTagUsed: "Geen ongeldige tag gebruikt",
	    LblShowVehicleChargeLevel: "Toon voertuig laadniveau in web- en App?",
	    LblChargeLevel: "Laadniveau",
	    LblCharging: "Opladen",
	    LblNoDataFound: "Geen data beschikbaar",
	    LblOfficeStartTime: "Start kantooruren (hh:mm)",
	    LblOfficeEndTime: "Einde kantooruren (hh:mm)",
	    //Reports
	    LblTripDataReport: "Ritdata overzicht",
	    LblByDriver: "Op bestuurder",
	    LblByVehicle: "Op voertuig",
	    LblModuleRights: "Module rechten",
	    LblCostCenterReport: "Kostenplaatsrapport",
	    LblShowTotalOnly: "Toon alleen totaal",
	    LblByOrganization: "Op organisatie",
	    //Organization
	    LblOrganization: "Organisatie",
	    LblOrganizationName: "Organisatienaam",
	    LblOrganizationAddress: "Organisatieadres",
	    LblExistingDriverAddSuccessMsg: "De bestuurder is succesvol toegevoegd en gekoppeld met de organisatie",
	    LblAddDriverSuccessMsg: "Bestuurder toegevoegd en activerings link aan de bestuurder is succesvol verzonden.",
	    LblCreateOrganization: "Creeer organisatie",
	    LblOrganizationDriversList: "Organisatie Bestuurder",
	    LblAddDriverToOrganization: "Bestuurder toevoegen aan organisatie",
	    LblAddDriver: "Bestuurder toevoegen",
	    LblVatNumber: "BTW-nummer",
	    // Branding
	    LblBranding: "Branding",
	    LblLogo: "Logo's",
	    LblEmailNotificationInvoiceTemplate: "E-mail melding & factuursjablonen",
	    LblExpandedWebMenu: "Uitgeklapt web menu",
	    LblCollapsedWebMenu: "Ingeklapt web menu",
	    LblMobileApp: "Mobiele app",
	    LblSplashScreen: "Opstartscherm",
	    LblWebApplication: "Web applicatie",
	    LblMobileApplication: "Mobiele applicatie",
	    LblBrandingSavedSuccess: "Branding opgeslagen",
	    LblBrandingTemplateConfiguration: "Branding & sjabloon configuratie",
	    LblAppWebUI: "App & Web UI",
	    LblNonBookingCommunication: "Algemene communicatie",
	    LblApprovalAdminName: "Goedkeuring door beheerder",
	    LblBookingCommunication: "Communicatie m.b.t. reservering",
	    LblInstanceBranding: "Gebruik altijd instantie branding",
	    LblCompanyBranding: "Gebruik bedrijfsbranding indien mogelijk",
	    BO_TOP_MENU_ACTIVE_ITEM_BACKGROUND: "Top bar, menu and actieve items",
	    BO_TOP_MENU_ACTIVE_ITEM_TEXT: "Menu tekst",
	    BO_HIGHLIGHTED_BUTTON_BACKGROUND: "Gemarkeerde knop",
	    BO_HIGHLIGHTED_BUTTON_TEXT: "Gemarkeerde knop tekst",
	    BO_HIGHLIGHTED_BUTTON_BACKGROUND_HOVER: "Gemarkeerde knop (hover)",
	    BO_HIGHLIGHTED_BUTTON_TEXT_HOVER: "Gemarkeerde knop tekst (hover)",
	    BO_PRIMARY_BUTTON_BACKGROUND: "Primaire knop",
	    BO_PRIMARY_BUTTON_TEXT: "Primaire knop tekst",
	    BO_PRIMARY_BUTTON_BACKGROUND_HOVER: "Primaire knop (hover)",
	    BO_PRIMARY_BUTTON_TEXT_HOVER: "Primaire knop tekst(hover)",
	    BO_SECONDARY_BUTTON_BACKGROUND: "Secundaire knop",
	    BO_SECONDARY_BUTTON_TEXT: "Secundaire knop tekst",
	    BO_SECONDARY_BUTTON_BACKGROUND_HOVER: "Secundaire knop (hover)",
	    BO_SECONDARY_BUTTON_TEXT_HOVER: "Secundaire knop tekst (hover)",
	    BO_HYPERLINK_TEXT: "Hyperlink tekst",
	    BO_HIGHLIGHT_BACKGROUND: "Markeer kleur",
	    BO_HIGHLIGHT_TEXT: "Markeer tekst",
	    BO_CALENDAR_EVENT_BACKGROUND: "Kalender item",
	    BO_CALENDAR_EVENT_TEXT: "Kalender item tekst",
	    MO_TOP_MENU_ACTIVE_ITEM_BACKGROUND: "Top bar en menu",
	    MO_LOGO_AREA_BACKGROUND: "Logo achtergrond",
	    MO_PAGE_BACKGROUND: "Achtergrond",
	    MO_MENU_TEXT: "Menu tekst",
	    MO_TITLE_TEXT: "Titel tekst",
	    MO_HYPERLINK_TEXT: "Hyperlink tekst",
	    MO_ENABLED_BUTTON_BACKGROUND: "Bruikbare knop",
	    MO_ENABLED_BUTTON_TEXT: "Bruikbare knop tekst",
	    MO_ENABLED_BUTTON_BACKGROUND_ACTIVE: "Bruikbare knop (actief)",
	    MO_ENABLED_BUTTON_TEXT_ACTIVE: "Bruikbare knop tekst (actief)",
	    MO_DISABLED_BUTTON_BACKGROUND: "Onbruikbare knop",
	    MO_DISABLED_BUTTON_TEXT: "Onbruikbare knop tekst",
	    MO_DISABLED_BUTTON_BACKGROUND_ACTIVE: "Onbruikbare knop (actief)",
	    MO_DISABLED_BUTTON_TEXT_ACTIVE: "Onbruikbare knop tekst (actief)",
	    MO_HIGHLIGHT_BACKGROUND: "Highlight kleur",
	    MO_HIGHLIGHT_TEXT: "Highlight tekst",
	    MO_CALENDAR_EVENT_BACKGROUND: "Kalender item",
	    MO_CALENDAR_EVENT_TEXT: "Kalender item tekst",
	    LblBookingDelayConfig: "Configuratie vertraging reservering",
	    LblBookingDelayConfigEnabled: "Stuur e-mail naar beheerder",
	    LblEnableSnauilTrail: "Activeer Snail Trail",
	    LblAppSupportTo: "App Support Aan",
	    LblNotificationInterval: "Meldingsinterval",
	    LblNotifyAfterMinutes: 'Melding na "X" minuten',
	    LblMinutes: "Minuten",
	    lblNotificationRecipients: "Meldingsontvangers",
	    LbLEnableBookingStillRunning: "Activeer notificatie 'Reservering niet afgesloten'",
	    LblBookingrunningNotification: "Configuratie notificatie Reservering niet afgesloten",
	    //Raise and clear settings for low battery flag
	    LblDefaultVehicleSetting: "Standaard voertuiginstelling",
	    LblLowBatteryFlagRaised: "Lage batterij waarschuwing op (spanning)",
	    LblLowBatteryFlagClear: "Lage batterij waarschuwing gewist bij (spanning)",
	    LblPreferableImageSize: "Voorkeursformaat afbeelding",
	    LblWebBrandingExapandImageSize: "1150px X 260px",
	    LblMobileBrandingImageSize: "550px X 250px",
	    LblWebBrandingCollapseImageSize: "325px X 250px",
	    LblMinutesAfterBookingEndTime: "Hoeveel minuten na reserveringseindtijd?",
	    LblResendNotoficationEvery: "Herzend notificatie elke minu(u)t(en)",
	    LblByBooking: "Op reservering",
	    LblSnailTrailReport: "Snail Trail rapport",
	    LblKickbackReport: "Kickback Report",
	    LblGroupBy: "Groepeer bij",
	    LblTripDetail: "Ritdetails",
	    LblTripNumber: "Trip nummer",
	    LblStart: "Start",
	    LblAverageSpeed: "Gem. snelheid",
	    LblSegmentDetail: "Segment detail",
	    LblSegmentNumber: "Segmentnummer",
	    LblSpeed: "Snelheid",
	    LblOdometer: "Kilometerteller",
	    LblNext: "Volgende",
	    LblSegmentDetailNotAvailable: "Segment detail niet beschikbaar",
	    LblUnitPerKm: "per km.",
	    LblUnitPerBooking: "p/res.",
	    LblBookingCostSummary: "Kostenoverzicht reservering",
	    LblTimeCost: "Tijdkosten",
	    LblTotalTime: "Totale tijd",
	    LblTime: "Tijd",
	    LblCostRateUnits: "Kosten (Hoeveelheid * Aantal)",
	    LblFreeTime: "Gratis extra tijd",
	    LblRate: "Tarief",
	    LblExVat: "Ex. BTW",
	    LblInclVat: "Incl. BTW",
	    LblKmDriven: "Kms gereden",
	    LblFreeKms: "Gratis credits",
	    LblTimePercent: "Tijdpercentage",
	    LblTotalExVat: "Totaal ex. BTW",
	    LblTotalVat: "Totaal BTW",
	    LblTotalInclVat: "Totaal incl. BTW",
	    LblKilometerCost: "Kilometerkosten",
	    LblBookingApprovedSuccessMsg: "Geselecteerde reserveringsaanvragen succesvol goedgekeurd",
	    LblBookingRejectedSuccessMsg: "Geselecteerde reserveringssaanvraag afgewezen",
	    LblRejection: "Afwijzing",
	    LblrejectionReasonMsg: "Geef een reden voor de afwijzing van geselecteerde boekingsaanvragen",
	    LblApproveConfirmationMsg: "Weet u zeker dat u alle geselecteerde boekingsaanvragen wilt goedkeuren?",
	    LblFixedCost: "Vaste Kosten",
	    LblTotals: "Totalen",
	    LblTypeDamage: "Schade",
	    LblTypeMaintenance: "APK onderhoud binnenkort",
	    LblTypeOnSamePosition: "Voertuig meer dan %0 %1 op dezelfde locatie",
	    LblTypeNotBooked: "Voertuig meer dan %0 %1 niet geboekt",
	    LblTypeNotReturn: "Reservering eindtijd bereikt, voertuig niet op huislocatie",
	    LblBatteryVoltage: "Batterij voltage",
	    LblApprovedRejectedby: "Goedgekeurd / afgewezen door",
	    LblBookingRequestList: "Reserveringsaanvraaglijst",
	    LblCannotUnsubscribe: "Kan niet uitschrijven omdat de bestuurder een actieve reservering heeft",
	    LblPer: "Per",
	    LblDateRegistered: "Registratiedatum",
	    LblRegisteredBy: "Geregistreerd door",
	    LblKMPerHour: "Km/h",
	    LblMeters: "Meters",
	    LblSubscriptionEndOnBookingEnd: "Nog lopende reservering. Dit abonnement zal beeindigd worden wanneer reservering is voltooid.",
	    LblMarkedForDeletion: "Geselecteerd voor verwijdering",
	    LblApplyDateFilter: "Datum van toepassing",
	    LblNoRestriction: "GEEN_BEPERKING",
	    LblCustomAppTestApp: "CUSTOM_APP_EN_TEST_APP",
	    LblCustomAppOnly: "CUSTOM_APP_ALLEEN",
	    //Customer
	    LblCustomer: "Klant",
	    LblCustomerName: "Klantnaam",
	    //Role Page
	    LblRoleManagement: "Rol",
	    LblRoleName: "Rolnaam",
	    LblEntityName: "Entiteit Naam",
	    LblRoleType: "Roltype",
	    LblRoleAvailability: "Klant rol beschikbaarheid",
	    LblInternalRoleName: "Interne Rol Naam",
	    LblPresentationName: "Presentatienaam",
	    LblDefaultRole: "Standaard rol",
	    LblCustomRole: "Klantrol",
	    LblAddRole: "Voeg Rol toe",
	    LblEntity: "Entiteit",
	    LblCopy: "Kopieer",
	    LblAccessibilityMatrix: "Toegangsmatrix",
	    LblDefaultRoleModifyWarning: "Aanpassen van de standaard rechten beïnvloedt alle gebruikers met de Standaard Rol.",
	    LblCopyAccessibilityMatrix: "Kopieer Toegangsmatrix",
	    LblAccess: "Toegang",
	    LblCustomerAdmin: "Klantbeheerder",
	    LblAdmin: "Beheerder",
	    LblDoYouWantToRemove: "Wilt u %0 verwijderen als %1?",
	    LblDoYouWantToAdd: "Wilt u %0 toevoegen als %1?",
	    LblRoleAddedSuccess: "%0 als %1 toegevoegd",
	    LblRoleDeletedSuccess: "%0 verwijderd als %1",
	    LblInstanceAdmin: "Instantiebeheerder",
	    LblInvitationMailSuccess: "Uitnodigingsmail is aan opgegeven e-mailadres verzonden",
	    LblInvite: "Stuur uitnodiging",
	    LblCreateNew: "Nieuw",
	    LblCommonErrorMessage: "Een fout is opgetreden tijdens het verwerken van het verzoek. Neem contact met de beheerder.",
	    LblError: "Fout",
	    LblThankYouForAcceptingInvitation: "Dank voor het accepteren van de uitnodiging",
	    LblPleaseClick: "Alstublieft klikken",
	    LblHere: "hier",
	    LblToLogin: "om in te loggen",
	    LblThankYouForConfirmation: "Dank voor uw bevestiging",
	    LblGoToHome: "ga naar Home",
	    LblInvitationSuccess: "Uitnodiging succesvol",
	    LblInvitationReject: "Uuitnodiging geweigerd",
	    //
	    LblAssignExisting: "Bestaande toewijzen",
	    LblPersonProfileSuccessMessage: "Je profiel is succesvol geactiveerd",
	    LblPlease: "Alstublieft",
	    LblLogin: "Login",
	    //Branding & Template
	    LblBrandingandTemplates: "Branding & sjablonen",
	    LblTermsAndCondition: "Algemene voorwaarden",
	    LblTermsAndConditionList: "Algemene voorwaarden- en privacyverklaringlijst",
	    LblName: "Naam",
	    LblVersion: "Versie",
	    LblActivityLog: "Activiteiten logboek",
	    LblAcceptance1: "Vóór accountactivering",
	    LblAcceptanceMoment: "Acceptatie moment",
	    LblContents: "Inhoud",
	    LblIsAccept: "Ik aanvaard",
	    LblReadAndAgree: "Ik heb het gelezen en ga hiermee akkoord",
	    LblClose: "Sluiten",
	    LblTermsConditionPrivacy: "Algemene voorwaarden en privacyverklaring",
	    LblPrivacyStatements: "Privacyverklaringen",
	    //Pre Post Trip Setting
	    LblPrePostTripSetting: "Begin en einde reis vragen instelling",
	    LblPrePostTripQuestions: "Vragen voor en na de reis",
	    LblPrePostTripQuestion: "Vraag voor en na de reis",
	    LblPrePostTripQuestionList: "Vragenlijst begin en eind reis",
	    LblPreTripQuestion: "Vragen aan het begin van de reis",
	    LblCustom: "Aangepast",
	    LblPostTripQuestion: "Vragen na de reis",
	    LblRequired: "Verplicht",
	    LblBeforeOpeningTheVehicle: "Voordat u het voertuig opent",
	    LblAfterOpeningTheVehicle: "Na het openen van het voertuig",
	    LblOrder: "Volgorde",
	    LblQuestion: "Vraag",
	    LblOn: "Aan",
	    LblOptional: "Optioneel",
	    LblOff: "Uit",
	    LblAnswerType: "Antwoordtype",
	    LblText: "Tekst",
	    LblYesNo: "Ja/nee",
	    LblAnswer: "Antwoord",
	    LblTimeStamp: "Tijdstip",
	    LblFazTripQuestion: "FaZ vragen",
	    LblFazTripQuestionAfterClosingTheVehicle: "FaZ vragen na het sluiten van het voertuig",
	    //Accessibility Matrix
	    LG_WEB_DASHBOARD: "Web Dashboard",
	    PR_BOOKING_REQUEST: "Boekingsaanvraag",
	    LblApproveBookingRequest: "Goedkeuren",
	    LblRejectBookingRequest: "Afkeuren",
	    PR_DASHBOARD: "Dashboard",
	    PR_REMOVE_DRIVER_LICENSE: "Remove Driver License",
	    PR_VEHICLE_FUTURE_BOOKINGS: "Toekomstige boekingen voertuig",
	    PR_INSTANCE: "Instance",
	    PR_BRANDING: "Branding",
	    PR_PERSON_OVERVIEW: "Person Overview",
	    PR_WEGO_ADMINS: "Wego Admins",
	    PR_COMPANY_OVERVIEW: "Company Overview",
	    PR_CONTACT_PERSON: "Contact Person",
	    PR_COMPANY_ADMIN: "Bedrijfsbeheerder",
	    PR_COMPANY_VEHICLE_OVERVIEW: "Bedrijfswagenoverzicht",
	    PR_COMPANY_SVG_OVERVIEW: "Bedrijfspoolgroepoverzicht",
	    PR_ORGANIZATION_OVERVIEW: "Organization Overview",
	    PR_ORGANIZATION_CONTACT_PERSON: "Organization Contact Person",
	    PR_ORGANIZATION_ADMIN_OVERVIEW: "Organisatie beheerdersoverzicht",
	    PR_ORGANIZATION_DRIVER_OVERVIEW: "Organisatie bestuurdersoverzicht",
	    PR_SHARED_VEHICLE_GROUP_OVERVIEW: "Poolgroep overzicht",
	    PR_SHARED_VEHICLE_GROUP_ADMIN_OVERVIEW: "Poolgroep eheerdersoverzicht",
	    PR_SHARED_VEHICLE_GROUP_VEHICLE_OVERVIEW: "Overzicht poolgroepvoertuigen",
	    PR_SHARED_VEHICLE_GROUP_DRIVER_OVERVIEW: "Poolgroep bstuurdersoverzicht",
	    PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_GROUP_OVERVIEW: "Poolgroep contracttype groepsoverzicht",
	    PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_OVERVIEW: "Poolgroep contracttype overzicht",
	    PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW: "Poolgroepabonnementen overzicht",
	    PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_AVAILIBILTY_RESTRICTION_OVERVIEW: "Beschikbaarheid poolgroepabbonementen overzicht",
	    PR_SPECIAL_PERIODS: "Special Periods",
	    PR_VEHICLES_OVERVIEW: "Vehicles Overview",
	    PR_VEHICLE_SVG_OVERVIEW: "Voertuig poolgroepoverzicht",
	    PR_VTS_VEHICLE_LIST: "VTS Vehicle List",
	    PR_VTS_TROUBLESHOOT: "VTS Troubleshoot",
	    PR_VEHICLE_ATTRIBUTE_CATEGORIES: "Voertuigkenmerkcategorieën",
	    PR_VEHICLE_ATTRIBUTE: "Voertuigkenmerk",
	    PR_ODOMETER_LOG_TRAIL: "Odometer Log Trail",
	    PR_ODOMETER_LOG_TRAIL_REGISTERED_BY: "Odometer Log Trail Registered by",
	    PR_DRIVER_OVERVIEW: "Driver Overview",
	    PR_DRIVER_SHARED_VEHICLE_GROUP_OVERVIEW: "Overzicht bestuurder poolgroep",
	    PR_DRIVER_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW: "Overzicht van de abonnementen voor de poolgroepbestuurders",
	    PR_BOOKINGS_OVERVIEW: "Reserveringsoverzicht",
	    PR_NORMAL_BOOKING: "Nieuwe reservering",
	    PR_SPECIAL_BOOKING: "Special Booking",
	    PR_TRIP_SIMULATOR: "Tripsimulator",
	    PR_INVOICE: "Invoice",
	    PR_DIRECT_DEBIT_FILE: "Incassobestand",
	    PR_ADDITIONAL_FREE_ITEMS: "Additional Free Items",
	    PR_TEST_INVOICE_GENERATOR: "Testfactuur generator",
	    PR_VEHICLE_OCCUPANCY_REPORT: "Bezettingrapport voertuig",
	    PR_REVENUE_PER_VEHICLE_REPORT: "Revenue Per Vehicle Report",
	    PR_TRIP_DATA_REPORT: "Trip Data Report",
	    PR_MAINTENANCE_PLANNING_REPORT: "Maintenance Planning Report",
	    PR_SANIL_TRAIL_REPORT: "Snail Trail-rapport",
	    PR_KICKBACK_REPORT: "Kickback rapport",
	    PR_INVOICE_PAYMENT_HISTORY: "Factuur betalingsgeschiedenis",
	    PR_TEMPLATES: "Sjablonen",
	    PR_SIGNUP_FORMS_OVERVIEW: "Aanmeldingsformulieren overzicht",
	    PR_SIGNUPS_OVERVIEW: "Signups Overview",
	    PR_SIGNUP_OVERVIEW_TO_SIGNUP_FORM: "Aanmelden overzicht voor aanmeldingsformulier",
	    PR_SIGNUP_OVERVIEW_TO_SHARED_VEHICLE_GROUP: "Aanmeldingsoverzicht aan poolgroep",
	    PR_EVENT_VIEWER: "Gebeurtenissenoverzicht",
	    PR_USER_PROFILE: "User Profile",
	    PR_PRE_POST_TRIP_SETTING: "Begin en einde rit vragen instellingen",
	    PR_PRE_POST_TRIP_QUESTIONS: "Begin en einde rit vragenoverzicht",
	    PR_TERMS_AND_CONDITION: "Regels en voorwaarden",
	    PR_PREPOST_TRIP_QUESTIONS_UPDATE: "Begin en einde rit vragen",
	    LG_CUSTOMER: "Customer",
	    LG_INSTANCE: "Instance",
	    LG_BRANDING: "Branding",
	    LG_PERSON: "Person",
	    LG_COMPANY: "Company",
	    LG_ORGANIZATION: "Organization",
	    LG_SHARED_VEHICLE_GROUP: "Shared Vehicle Group",
	    LG_VEHICLE: "Vehicle",
	    LG_DRIVER: "Driver",
	    LG_BOOKING: "Booking",
	    LG_INVOICE: "Invoice",
	    LG_REPORT: "Report",
	    LG_TEMPLATE: "Sjabloon",
	    LG_SIGNUP_FORM: "Signup Form",
	    LG_EVENT_VIEWER: "Event Viewer",
	    LG_PRE_POST_TRIP_SETTING: "Begin en einde rit vragen instellingen",
	    LG_USER: "User",
	    LG_BRANDING_AND_TEMPLATE: "Branding & sjablonen",
	    LG_PREPOSTTRIPQUESTION: "Begin en einde rit vragen",
	    LG_REPORTINGTOOL: "Rapportagetool",
	    PR_BOOKING_OVERVIEW: "Boekingsoverzicht",
	    PR_ROB_NOTIFICATIONS: "ROB Overzicht",
	    PR_MILEAGE_OVERVIEW: "Kilometer overzicht",
	    PR_USAGE_OVERVIEW: "Aantal dagen niet gebruikt",
	    PR_POSITION_ON_MAP: "Positie op de kaart",
	    PR_VEHICLE_ON_LOCATION_MAP: "Voertuig op locatie",
	    PR_TRIP_OVERVIEW: "Ritregistratie",
	    PR_ALTERNATE_TRANSPORTATION: "Vervangend vervoer",
	    PR_AVERAGE_OVERVIEW: "Gemiddelden overzicht",
	    PR_PRE_POST_BOOKING_OVERVIEW: "Pre/post vragen per boeking overzicht",
	    PR_HOME_LOCATIONS_OVERVIEW: "Voertuig en SVG thuis locaties overzicht",
	    //Vat Setting
	    LblVatSettings: "BTW-instellingen",
	    LblVatPercentages: "BTW Percentages",
	    LblDefaultCost: "Standaard kosten weergeven en bewerken",
	    LblExcludingVat: "Exclusief BTW",
	    LblIncludingVat: "BTW inbegrepen",
	    LblVatEnterDescription: "Voer omschrijving in",
	    LblEnterVatPercentage: "Enter VAT %",
	    LblVatPercentageError: "Please enter valid percentage",
	    LblVatDescriptionError: "Please enter valid Description",
	    LblStartDate: "Start Date",
	    LblVatEndDate: "End Date",
	    LblVatDeleteConfirmation: "Weet u zeker dat u de BTW-einddatum wilt instellen?",
	    LblVatEndDateError: "Please enter VAT end date",
	    LblVatEndDateNote: "Opmerking: gegevens worden uitgesloten vanaf de geselecteerde datum",
	    LblVatStartDate: "Begindatum",
	    LblVatStartDateError: "Please select start date",
	    //
	    LG_ROLE: "Role",
	    PR_CUSTOMER_ADMIN_OVERVIEW: "Customer Admin Overview",
	    PR_INSTANCE_ADMIN_OVERVIEW: "Instantie beheerdersoverzicht",
	    PR_ROLE_OVERVIEW: "Role",
	    PR_ROLE_ASSIGN: "Role Assign",
	    PR_SHARED_VEHICLE_GROUP_ACTIVE_INACTIVE: "Poolgroep actief of inactief",
	    PR_CUSTOMER_OVERVIEW: "Customer",
	    PR_ORGANIZATION_SUBSCRIPTION_OVERVIEW: "Organisatie abonnementenoverzicht",
	    PR_VTS_VEHICLE_EVENT_HISTORY: "VTS voertuig gebeurtenissen geschiedenis",
	    PR_BATCH_UPLOAD_PERSON: "Personen batch-upload",
	    PR_IMPORT_PERSON: "Import Person",
	    PR_PRE_POST_TRIP_QUESTION_UPDATE: "Begin en einde rit vragen",
	    LblPrivacyErrorMessage: "U bent niet gemachtigd om deze pagina te bekijken",
	    LblPrivacyNavigate: "Navigeer a.u.b. naar",
	    LblPrivacyError: "Privacy Error",
	    LblLinkExpired: "Link Expired",
	    LblLinkExpiredMessage: "Link is verlopen en kan niet meer worden gebruikt. Probeer het opnieuw.",
	    LblBearer: "Bearer",
	    LblWhoBenifitFreeItem: "Wie profiteert van abonnementscredits?",
	    LblNoDistinction: "Default (no distinction)",
	    LblPenaltyVat: "Boete BTW",
	    LblTimeRateVat: "Time Rate VAT",
	    LblMileageRateVat: "Kilometerprijs BTW",
	    LblFixedFeeVat: "BTW over vaste kosten",
	    LblSendInvoiceToOrganization: "Factuur verzenden naar organisatie",
	    LblExpenseAmountVat: "Onkosten BTW",
	    LblDefaultVatContractTypeGroupCost: "BTW% voor contracttype groepskosten",
	    LblDefaultVatContractTypeCost: "BTW% voor contracttypekosten",
	    LblDefaultVatSubscriptionCost: "VAT % for Subscription Costs",
	    LblPenaltyCost: "Boetekosten",
	    LblTimeRates: "Tijdtarieven",
	    LblDistanceRates: "Distance Rates",
	    LblFixedRates: "Fixed Rates",
	    LblSubscriptionCost: "Subscription Costs",
	    // template
	    LblEmailTemplate: "E-mail sjabloon",
	    LblWebTemplate: "Web Template",
	    LblEmailAddressesEntryPattern: "Comma separated email addresses(like ex1@ex.com, ex2@ex.com)",
	    LblNoRecipientWarning: "No recipients applicable. Default recipients will be the receiver of this template.",
	    //MobileApp Configuration
	    LblMobileAppConfiguration: "Mobile App Configuration",
	    LblEnableNewBooking: "Enable New Booking",
	    LblEnableBookingCalender: "Enable Booking Calender",
	    LblEnableSubscription: "Enable Subscription",
	    LblEnableUpdateProfile: "Schakel 'Profiel bijwerken' in",
	    LblEnableNotification: "Enable Notification",
	    LblEnableChangeBooking: "Schakel 'Boeking wijzigen' in",
	    LblEnableAddExpenseMenu: "Schakel het menu 'Uitgaven toevoegen' in",
	    LblChamberOfCommerce: "Kamer van Koophandel",
	    LblInvoicingSettings: "Factureringsinstellingen",
	    LblInvoiceSender: "Factuurverzender",
	    LblCostAndExpenses: "Kosten en uitgaven",
	    LblSender: "Afzender",
	    LblAddressee: "Geadresseerde",
	    LblAddLine: "Lijn toevoegen",
	    LblSaveInvoice: "Factuur opslaan",
	    LblVatAmount: "BTW bedrag",
	    LblBookingId: "Boekings-ID",
	    LblReceiptOrSuppor: "Bon of ondersteuning",
	    LblVATPercentage: "BTW(%)",
	    LblChargeTo: "In rekening brengen",
	    LblReimburseTo: "Terugbetalen aan",
	    LblReportedBy: "Gerapporteerd door",
	    LblReportedAmount: "Gerapporteerde hoeveelheid",
	    LblApprovedAmount: "Goedgekeurd bedrag",
	    LblCostType: "Kostentype",
	    LblRecipient: "Ontvanger",
	    LblCostDetail: "Kostendetail",
	    LblAddExisting: "Bestaande toevoegen",
	    LblReceiptOrSupport: "Bon of ondersteuning",
	    LblManualInvoiceLine: "Handmatige factuurregel",
	    LblInvoiceLine: "Factuurregel",
	    LblInvoice: "Factuur",
	    LblInvoiceLines: "Factuurregels",
	    LblSendInvoice: "Factuur verzenden",
	    LblInvoiceSent: "Factuur verzonden",
	    LblAddNewInvoiceLine: "Voeg een nieuwe factuurregel toe",
	    LblSelectUnprocessedExpenses: "Selecteer een onverwerkte uitgave",
	    LblSelectAtLeastOneExpense: "Selecteer ten minste één onkost",
	    LblInvoicePaymentHistory: "Factuur betalingsgeschiedenis",
	    LblPaymentMode: "Betaalmethode",
	    LblLogTime: "Log tijd",
	    PR_COST_EXPENSES: "Kosten en uitgaven",
	    PR_COST_CENTER_REPORT: "Kostenplaatsrapport",
	    LblInactiveAfterDays: "Inactief na (dagen)",
	    LblMarkDeleteAfterDays: "Markeer Verwijderen na (dagen)",
	    LblNotifyAdminBeforeDays: 'Beheerder voor "X" dagen informeren',
	    LblGdprSettings: "GDPR-instellingen",
	    LblRemovalDate: "Verwijderingsdatum",
	    LblRemovePersonOn: "Persoon verwijderen op",
	    LblNoPaymentLinkGenerated: "Geen betalingslink gegenereerd",
	    //Payment Module
	    LblPaymentConfig: "Betalingsconfiguratie",
	    LblPaymentConfigButton: "Betalingsconfiguratie",
	    LblPaymentProvider: "Betalingsprovider",
	    LblCountry: "Land",
	    LblEmailAddress: "E-mailadres",
	    LblAllowPaymentConfiguration: "Betalingsconfiguratie toestaan",
	    LblAllowPayment: "Betaling toestaan",
	    LblPaymentSetting: "Betalingsproviderinstellingen",
	    LblEnvironment: "Omgeving",
	    LblInvoicePaymentTermDays: "Factuur betalingsvoorwaarden dagen",
	    LblLinkValidityDays: "Link geldigheidsduur (dagen)",
	    LblReportedOn: "Gerapporteerd op",
	    LblPaymentMethods: "Betaalmethoden",
	    LblPaymentProviderSecretKey: "PSP geheime sleutel",
	    LblPaymentProviderUsername: "PSP gebruikersnaam (key)",
	    LblCreditCardPayment: "Creditcard betaling",
	    LblInitialPayment: "Voorschot",
	    LblCreateBookingPayment: "Maak reserveringsbetaling aan",
	    LblStartBookingPayment: "Start boeking Betaling",
	    LblPaymentLink: "Betalingslink",
	    LblPaymentHistory: "Betaalgeschiedenis",
	    LblReasonOrganization: "Reden voor blokkering organisatie",
	    LblDueDateUpdateSuccess: "Vervaldatum succesvol bijgewerkt",
	    LblDueDateRequiredError: "Selecteer de vervaldatum.",
	    LblDueDate: "Vervaldatum",
	    LblConfirmDuedatechange: "Weet u zeker dat u de vervaldatum wilt bijwerken?",
	    LblConfirmCloseInvoice: "Weet u zeker dat u de factuur wilt sluiten?",
	    LblConfirmReOpenInvoice: "Weet u zeker dat u de factuur wilt heropenen?",
	    LblInvoiceOpenCloseSuccess: "Factuur% 0 succesvol",
	    LblReOpen: "Heropenen",
	    LblClosed: "Gesloten",
	    LblReOpenClose: "Open / sluit opnieuw",
	    PR_PAYMENT_HISTORY_LIST: "Betaalgeschiedenis",
	    LblUserBlockMessage: "Reden voor blokkering gebruiker",
	    PR_BLOCK_UNBLOCK_ORGANIZATION: "Blokkeer / de-blokkeer organisatie",
	    LblWhenOpeningAppAndRepeat: "Bij het openen van de app voor de eerste keer en herhaal elke",
	    LblEveryTimeOpenApp: "Elke keer dat de app wordt geopend",
	    LblWhenMakeBooking: "Bij het maken van een boeking",
	    LblWhenStartBooking: "Bij het starten van een boeking",
	    LblWhenOpenBooking: "Bij het openen van een voertuig",
	    LblSelectContractTypeGroup: "Bij het kiezen van een specifieke contracttype groep (en)",
	    LblDays: "Dagen",
	    LblNewVersion: "Nieuwe versie",
	    LblAction: "Actie",
	    LblTAndCName: "T &C naam",
	    LblOldVersion: "Oude versie",
	    LblSureToRevoke: "Weet je zeker dat %0 wordt ingetrokken?",
	    LblCurrencyConfiguration: "Valutaconfiguratie",
	    LblNameSingular: "Naam enkelvoud",
	    //Special Period
	    LblRegularBooking: "Reguliere boeking",
	    LblSpecialRate: "Speciaal tarief",
	    LblFirstDay: "Eerste dag",
	    LblLastDay: "Laatste dag",
	    LblWeekEndContaining: "Weekend met",
	    LblNamePlural: "Naam meervoud",
	    LblSignBeforeAmount: "Valutasymbool vóór bedrag",
	    LblOutOf: "buiten",
	    //Credit card payment
	    LblCrediCardPayment: "Creditcard betaling",
	    LblFirstBooking: "Eerste boeking",
	    LblAllowRecurringPayment: "Authoriseer creditcard",
	    LblProceed: "Doorgaan",
	    LblCheckAllowPayment: "Controleer of het is toegestaan ​​om een ​​periodieke betaling toe te staan",
	    LblPaymentFailed: "Authoriseer creditcard",
	    LblPaymentSuccess: "Authorisatie gelukt",
	    LblPaymentFailure: "Authorisatiefout",
	    LblCompletedSuccess: "Uw authorisatie is succesvol verwerkt",
	    LblCompletedFailure: "Uw authorisatie is mislukt. Ga terug en probeer het alstublieft opnieuw.",
	    LblCreditCardNumber: "Creditcardnummer",
	    LblCreditCardExpirationDate: "Creditcard Vervaldatum",
	    LblCreditCardDetails: "Creditcard details",
	    LblMakePayment: "Authoriseer creditcard",
	    LblAdminPaymentConfirmation: "Er is geen actieve authorisatie of een betaling is mislukt. Wilt u doorgaan?",
	    LblPaymentDescription: "Om een ​​voertuig te boeken, is een verificatiebetaling van %0 vereist. Daarnaast is de toestemming vereist om toekomstige betalingen van uw creditcard af te trekken. Betalingen worden verwerkt door onze betaalprovider Buckaroo. U wordt doorverwezen naar de Buckaroo-website voor de daadwerkelijke betaling. ",
	    LblPay: "Betalen",
	    // NIF Number
	    LblEnableNIFNumber: "Schakel NIF-nummer in",
	    LblNIFNumber: "NIF-nummer",
	    LblWeGoDefault: "WeGo Standaard",
	    LblPersonActiveSuccess: "Persoon met succes geactiveerd",
	    LblActivate: 'Activeren',
	    LblInActiveReason: "InActive Reason",
	    LblDefaultLanguage: 'Standaardtaal',
	    LblRestoreInheritConfirmation: "De huidige instellingen worden overschreven door de overgenomen instellingen. Weet u het zeker?",
	    LblQestionTextRequired: "Tekst met vraag vereist",
	    LblManualSecretKey: "Geheime sleutel",
	    // Two Factor Authentication
	    LblTwoFaConfig: "Twee-factorauthenticatie",
	    LblEnableTwoFa: "Schakel twee-factorauthenticatie in",
	    LblExpirationDays: "Vervaldagen",
	    LblTextBoxExpirationDays: "Vervaldagen",
	    Lbl2FactorAuthenticateExpDays: "2FA-vervaltermijn (dagen):",
	    LblResetCookiesWegoAdmin: "Reset cookies voor alle WeGo-beheerders",
	    LblReset2FactorAuthWegoAdmin: "Reset 2FA voor alle WeGo-beheerders",
	    LblAuthentication: "Authenticatie",
	    LblResetCookiesForAllAdmin: "Reset cookies voor alle beheerders",
	    LblReset2FaForAllAdmin: "Reset 2FA voor alle beheerders",
	    LblEnterTotp: "Voer alstublieft de code in",
	    LblEnterOtp: "Voer alstublieft de code in",
	    LblSubmit: "Verstuur",
	    LblKeyResetSuccess: "2FA sleutel is gereset",
	    LblKeyResetFailed: "2FA sleutel resetten mislukt",
	    LblCookieResetSuccess: "2FA cookies zijn gereset",
	    LblCookieResetFailed: "2FA cookies resetten mislukt",
	    LblGoogleAuthenticator: "Google Authenticator-app",
	    LblEmailOtpSent: "Er is een code verzonden naar uw geregistreerde e-mailadres",
	    LblContinue: "Doorgaan",
	    LblInvalidTOTP: "Ongeldige code",
	    LblResetCookie: "Reset Cookie",
	    LblResetTwoFA: "Reset 2FA",
	    LblDisableTwoFA: "Schakel 2FA uit",
	    LblTwoFaMethod: "2FA methode",
	    LblEmailAuthentication: "E-mail authenticatie",
	    LblTwoFaMethodSelect: "U moet uw identiteit nog een keer verifiëren. Selecteer alstublieft uw 2FA methode",
	    LblMissingInvoiceGenerator: "Ontbrekende factuurgenerator",
	    LblInvoicePreFix: "Factuurnummer voorvoegsel",
	    LblEngineStillRunning: 'Vergrendelopdracht verzonden terwijl de motor draait',
	    LblMobileAppLink: "Mobile App Link",
	    // License Check Configuration
	    LblLicenseCheckConfiguration: "Rijbewijs Check Configuratie",
	    LblValidateLicenseCheckForBooking: "Check voor boeking",
	    // Access Cards Enabled SVG
	    LblAccessCardsEnabled: "Gebruik toegangspas",
	    // Track & Trace
	    LblTrackAndTrace: "Track & Trace",
	    LblRfidTagId: "RFID Tag ID",
	    LblEmployeeNumber: "Werknemersnummer",
	    // Access Card
	    LblAccessCardId: "Pas ID",
	    BtnAddVehicleInfo: "Laat vts log zien",
	    LblDriversLicenseAndCertificates: "Rijbewijs en certificaten",
	    LblLicense: "Rijbewijs",
	    LblCertificates: "Certificaten",
	    LblTrips: "Trips",
	    LblCostsSummary: "Kosten overzicht",
	    LblStartBooking: "Start boeking",
	    LblStopBooking: "Stop boeking",
	    LblTripHistory: "Ritgeschiedenis",
	    LblTripStartDateTime: "Van",
	    LblTripEndDateTime: "Tot",
	    LblFaZTripQuestions: "FaZ vragen",
	    LblNoQuestionsFound: "Geen FaZ-vragen gevonden.",
	    LblNoTripsFound: "Geen ritten gevonden.",
	    LblTripDetails: "Ritdetails",
	    LblUnansweredQuestions: "Onbeantwoorde vragen",
	    LblNoUnansweredQuestions: "Geen onbeantwoorde vragen",
	    LblAnswerSaved: "Het antwoord is succesvol opgeslagen",
	    LblAnswerSavedError: "Het antwoord kon niet worden opgeslagen. Neem dan contact op met de beheerder",
	    LblAnswerEmptyError: "Voer een geldig antwoord in",
	    LblLoginError: "Er is een onbekende fout opgetreden bij het inloggen",
	    LblLoginCredentialsError: "Deze gebruikersnaam of wachtwoord is ongeldig, controleer uw gegevens en probeer opnieuw",
	    LblBookingStarted: "De boeking is gestart",
	    LblCouldnotStartBooking: "De boeking kan niet gestart worden.",
	    LblBookingStopped: "De boeking is gestopt",
	    LblCouldnotStopBooking: "De boeking kan niet gestopt worden",
	    LblInfo: "Info",
	    ValidatePhoneNumberVts: "Voer een geldig telefoonnummer in (b.v. +31623456789)",
	};


/***/ },
/* 74 */
/***/ function(module, exports) {

	// https://scotch.io/tutorials/simple-language-translation-in-angular-2-part-2
	"use strict";
	// lang-de.ts
	// 'hello world': 'hello world',
	// 'hello greet': 'Hello, %0 %1!',
	// 'well done': 'Well done %0',
	// 'good bye': 'bye bye',
	exports.LANG_DE_NAME = "de";
	exports.LANG_DE_TRANS = {
	    LblWeekdays: {
	        shorthand: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
	        longhand: [
	            "Sonntag",
	            "Montag",
	            "Dienstag",
	            "Mittwoch",
	            "Donnerstag",
	            "Freitag",
	            "Samstag"
	        ]
	    },
	    LblMonths: {
	        shorthand: [
	            "Jan",
	            "Feb",
	            "März ",
	            "Apr",
	            "Mai",
	            "Jun",
	            "Jul",
	            "Aug",
	            "Sep",
	            "Okt",
	            "Nov",
	            "Dez"
	        ],
	        longhand: [
	            "Januar",
	            "Februar",
	            "März",
	            "April",
	            "Mai",
	            "Juni",
	            "Juli",
	            "August",
	            "September",
	            "Oktober",
	            "November",
	            "Dezember"
	        ]
	    },
	    LblButtonText: {
	        Heute: "Heute",
	        Monat: "Monat",
	        Woche: "Woche",
	        Tag: "Tag",
	        Liste: "Liste"
	    },
	    // Common Name
	    LblActivityLog: "Aktivitätsprotokoll",
	    LblEdit: "Bearbeiten",
	    LblDelete: "Löschen",
	    LblRemove: "Entfernen",
	    LblActiveInactive: "Aktiv/Inaktiv",
	    LblActive: "Aktiv",
	    LblInactive: "Deaktivieren",
	    LblInactiveReason: "Inaktiver Grund",
	    LblAddNew: "Neu hinzufügen",
	    LblAdd: "Hinzufügen",
	    LblUpdate: "Aktualisieren",
	    LblSave: "Speichern",
	    LblCancel: "Abbrechen",
	    LblReset: "Zurücksetzen",
	    LblSelect: "Auswählen",
	    LblSuccess: "Glückwunsch",
	    LblWarning: "Warnung",
	    LblList: "Liste",
	    LblAssign: "Zuweisen",
	    LblHome: "Home",
	    LblYes: "Ja",
	    LblOK: "Ok",
	    LblNo: "Nein",
	    LblBack: "Zurück",
	    LblReason: "Grund",
	    LblRecordSavedSuccess: "Eintrag erfolgreich gespeichert",
	    LblRecordDeleteSuccess: "Eintrag erfolgreich gelöscht",
	    LblResetPasswordSuccess: "Passwort erfolgreich zurückgesetzt",
	    LblConfirm: "Bestätigen",
	    LblBlockUnblockConfirm: "Möchten Sie %0 wirklich %1?",
	    LblRecordDeleteConfirmation: "Möchten Sie %0 wirklich entfernen?",
	    LblRecordMultiplDeleteConfirmation: "Möchten Sie die ausgewählten %0 wirklich entfernen?",
	    LblConfirmMessage: "Sind Sie sicher?",
	    LblResetPassword: "Passwort zurücksetzen",
	    LblResetPasswordConfirmation: "Möchten Sie Ihr Passwort wirklich zurücksetzen?",
	    LblGeoLocationError: "Bitte geben Sie den richtigen Standort ein",
	    LblPersonDeleteCheck: "Dauerhaft entfernen",
	    LblRejection: "Ablehnung",
	    LblrejectionReasonMsg: "Bitte begründen Sie die Ablehnung ausgewählter Buchungsanfragen",
	    LblApproveConfirmationMsg: "Möchten Sie wirklich alle ausgewählten Buchungsanfragen genehmigen?",
	    LblBookingCancelSuccess: "Buchungen erfolgreich storniert",
	    LblBookingApprovedSuccessMsg: "Ausgewählte Buchungsanfragen erfolgreich genehmigt",
	    LblBookingRejectedSuccessMsg: "Ausgewählte Buchungsanfrage erfolgreich abgelehnt",
	    LblBookingAbortSuccess: "Buchung erfolgreich abgebrochen",
	    LblBookingRevokeSuccess: "Buchung erfolgreich widerrufen",
	    LblContactPersonRemoveSuccess: "Ansprechpartner erfolgreich entfernt",
	    LblContactPersonAddedSuccess: "Ansprechpartner erfolgreich hinzugefügt",
	    LblNoRecords: "Kein Eintrag verfügbar",
	    LblAffectedBookingList: "Liste der betroffenen Buchungen",
	    LblSubscriptionEndDateError: "Bitte geben Sie das Enddatum des Abonnements ein",
	    LblIsSpecialPeriodAllow: "Möchten Sie die Sonderperiodenkosten anwenden? Falls zutreffend",
	    LblContractSlotisnotdefined: "Für das unten stehende Zeitfenster ist kein Vertragstyp definiert",
	    LblUnscubscribeSuccess: "Erfolgreich abgemeldet",
	    LblModifiedBy: "Geändert von",
	    LblModifiedDate: "Änderungsdatum",
	    LblContractTypeGroupAvailableForSubscription: "Keine Vertragstypengruppe verfügbar, um neue %0 hinzuzufügen.",
	    LblRemoveContactPersonConfirm: "Sind Sie sicher, dass Sie den Ansprechpartner entfernen wollen?",
	    LblBookingApproveRejectSuccess: "%0 %1 erfolgreich",
	    LblRecordAddedSuccess: "%0 erfolgreich hinzugefügt.",
	    LblRecordUpdatedSuccess: "%0 erfolgreich aktualisiert.",
	    LblRecordRemovedSuccess: "%0 erfolgreich entfernt",
	    LblRecordActiveInActiveSuccess: "%0 %1 erfolgreich.",
	    LblinvoiceResendSuccess: "%0 erfolgreich erneut gesendet",
	    LblRecordBlokUnBlockSuccess: "%0 %1 erfolgreich.",
	    LblEditPage: "%0 bearbeiten",
	    LblAddPage: "%0 hinzufügen",
	    LblListPage: "Liste %0",
	    LblKilometers: "Kilometer",
	    LblKM: "Km",
	    LblDeletePersonNote: "Ausstehende Rechnungen für diese Person werden nicht gesendet",
	    LblFileNotFound: "Die Datei existiert nicht, wenden Sie sich an den Helpdesk",
	    //'LblRecordUnBlockedSuccess':'%0 unBlocked successfully',
	    //MobileApp Configuration
	    LblMobileAppConfiguration: "Konfiguration Mobiltelefon-App",
	    LblEnableNewBooking: "Neue Buchung aktivieren",
	    LblEnableBookingCalender: "Buchungskalender aktivieren",
	    LblEnableSubscription: "Abonnement aktivieren",
	    LblEnableUpdateProfile: "«Profil aktualisieren» aktivieren",
	    LblEnableNotification: "Benachrichtigung aktivieren",
	    LblEnableChangeBooking: "«Buchung ändern» aktivieren",
	    LblEnableAddExpenseMenu: "Menü für Kostenangabe aktivieren",
	    //Instance Page
	    LblCarwiseEnable: "Carwise aktiviert",
	    LblAdminDependencyValidationOnDelete: "Der ausgewählte Admin kann nicht gelöscht werden, da er mit einer anderen Einheit verknüpft ist.",
	    LblWegoAdminDependencyValidation: "WeGo-Admin kann nicht gelöscht werden, da er mit einer anderen Einheit verknüpft ist.",
	    LblAdminDependencyValidation: "Die Adminrolle kann nicht entfernt werden, da sie einer anderen Einheit zugeordnet ist.",
	    LblCarwiseConfiguration: "Carwise-Konfiguration",
	    LblAdminDependencyAlert: "Abhängigkeitsalarm Admin",
	    LblCarwiseConnectionUrl: "Verbindungs-URL",
	    LblCarwiseConnectionUsername: "Verbindungsbenutzername",
	    LblCarwiseConnectionPassword: "Verbindungspasswort",
	    LblCarwiseAutoDeleteFrequencyInDays: "Frequenz automatisches Löschen (in Tagen)",
	    LblDamageImageExtentions: "Beschädigte Bilderweiterungen",
	    LblInstance: "Instanz",
	    LblInstanceName: "Instanzname",
	    LblInstanceType: "Instanztyp",
	    LblDescription: "Beschreibung",
	    LblCurrencySymbol: "Währungszeichen",
	    LblPreferredLanguage: "Sprache",
	    LblTimeZone: "Zeitzone",
	    LblCurrencyAbbreviation: "Währungskürzel",
	    LblInstanceDeleteValidation: "Instanz kann nicht gelöscht werden wegen Verknüpfung mit anderer Einheit",
	    LblIsBookingApprovalReq: "Buchungsgenehmigung erforderlich",
	    LblInstanceConfiguration: "Instanzkonfiguration",
	    LblBookingAlertTime: "Zeit Buchungsbenachrichtigung",
	    LblBookingCancelTime: "Zeit Buchungsstorno",
	    LblBookingTemporaryTime: "Vorläufige Buchungszeit",
	    LblVtsRequestTimeout: "Zeitüberschreitung VTS-Anfrage",
	    LblVtsTripLogTimeout: "Zeitüberschreitung VTS-Triplog",
	    LblEmailConfiguration: "E-Mail-Konfiguration (SMTP)",
	    LblInSeconds: "In Sekunden",
	    LblFromEmail: "Aus E-Mail",
	    LblHost: "Host",
	    LblPort: "Port",
	    LblEnableSsl: "SSL aktivieren",
	    LblSmtpEmail: "SMTP-E-Mail",
	    LblBookingCancelTimeMessage: "Zeit (in Sekunden), nach welcher eine Buchung nicht mehr storniert werden kann",
	    LblBookingTemporaryTimeMessage: "Zeit der vorläufigen Buchung. Wenn der Benutzer ein Fahrzeug für die Buchung ausgewählt, die Buchung aber noch nicht bestätigt hat.",
	    LblVtSRequestTimeoutMessage: "Zeitüberschreitung für Verriegelungs-/Entriegelungsbefehl in Mobiltelefon-App.",
	    LblVtsTriplogTimeoutMessage: "Dauer der Zeitüberschreitung für die Berechnung der Fahrt nach Ausführung von Verriegelungsbefehl.",
	    LblContractTypeDeleteValidation: "Vertragstypengruppe kann nicht gelöscht werden wegen Verknüpfung mit anderer Einheit",
	    LblSelectFuelType: "Kraftstoffart auswählen",
	    LblSelectPricingCatagory: "Preisklasse auswählen",
	    LblSelectBodyStyle: "Karosserietyp auswählen",
	    LblSelectVehicleClass: "Fahrzeugklasse auswählen",
	    LblIsImportPersonAllow: "Import von Person zulassen",
	    LblValidateLicenseA2SP: "A2SP Führerschein validieren",
	    LblValidateLicense24IDCheck: "24ID Führerschein validieren",
	    LblValidateLicenseForAllBookings: "Führerschein erneut validieren für aller Buchungen",
	    LblGeofenceLocation: "Standort Geofence",
	    LblRadius: "Radius",
	    LblEmailRecepients: "E-Mail-Empfänger",
	    LblRecepients: "Empfänger",
	    LblEmailAddresses: "E-Mail-Adressen",
	    LblMap: "Karte",
	    // AFAS/Azure Config
	    LblImportConfiguration: "Importkonfiguration",
	    LblImportConnectionType: "Connection Type",
	    LblAfas: "AFAS",
	    LblAzure: "Azure",
	    LblAzureTenantId: "Azure Tenant ID",
	    LblAzureClientId: "Azure Client ID",
	    LblAzureClientSecret: "Azure Client Secret",
	    LblAfasClientId: "AFAS Client ID",
	    LblAfasConnectorName: "AFAS Connector Name",
	    LblAfasConnectionType: "AFAS Connection Type",
	    LblAfasTest: "Test",
	    LblAfasAccept: "Acceptation",
	    LblAfasProduction: "Production",
	    LblAfasToken: "AFAS-Token",
	    LblAfasClientIdError: "Bitte geben Sie AFAS Client ID ein",
	    LblAfasConnectorNameError: "Bitte geben Sie AFAS Client ID ein",
	    LblAfasConnectionTypeError: "Bitte geben Sie AFAS Connection Type ein",
	    LblAfasTokenError: "Bitte geben Sie AFAS-Token ein",
	    LblAzureTenantIdError: "Bitte geben Sie Azure Tenant ID ein",
	    LblAzureClientIdError: "Bitte geben Sie Azure Client ID ein",
	    LblAzureClientSecretError: "Bitte geben Sie Azure Client Secret ein",
	    // SSO Config
	    LblSsoConfiguration: "SSO Configuration",
	    LblDefaultSsoSharedVehicleGroup: "Default Shared Vehicle Group",
	    LblDefaultSsoOrganization: "Default Organization",
	    LblDefaultSsoSubscription: "Default Subscription",
	    // Dropoff Message
	    LblDropoffMessageConfiguration: "Dropoff Message Configuration",
	    LblDropoffMessageExternalUrl: "External Url",
	    LblDropoffMessageApiKey: "Api Key",
	    LblDropoffMessageActive: "Active",
	    //Instance Page
	    LblValidate: "Validieren",
	    LblBookingCalanderSettings: "Einstellungen Buchungskalender",
	    LblShowDriverInfo: "Fahrerinformationen in Buchungskalender anzeigen",
	    LblOrganizationAdmin: "Admin Organisation",
	    LblDriverInfoToShow: "Anzugebende Fahrerinformationen",
	    //Person Page
	    LblEnableLogin: "Anmeldung aktivieren",
	    LblEnableErrorEscalation: "Fehlereskalation aktivieren",
	    LblErrorEscalationMinutes: "Fehlereskalation Minuten",
	    LblDuplicateErrorEscalation: "Doppelte Fehlereskalationskonfiguration gefunden",
	    LblUserName: "Benutzername",
	    LblFirstName: "Vorname",
	    LblLastName: "Nachname",
	    LblEmail: "E-Mail",
	    LblMobileNumber: "Mobiltelefonnummer",
	    LblPhoneNumber: "Telefonnummer",
	    LblHomeAddress: "Heimatadresse",
	    LblWorkAddress: "Arbeitsadresse",
	    LblHouseNo: "Hausnr.",
	    LblHouseExtention: "Hausanbau",
	    LblStreetName: "Strassenname",
	    LblCity: "Ort",
	    LblZipCode: "Postleitzahl",
	    LblPassword: "Passwort",
	    LblConfirmPassword: "Passwort bestätigen",
	    LblMiddleName: "Zweiter Vorname",
	    LblMandateId: "Mandats-ID",
	    LblMandateSignatureDate: "Unterschriftsdatum Mandat",
	    LblIsAmmandment: "Ist Amendement",
	    LblRemovePersonDetails: "Personendetails entfernen",
	    //Company Page
	    LblCompany: "Unternehmen",
	    LblCompanyName: "Unternehmensname",
	    LblContactPerson: "Ansprechpartner",
	    LblCompanyAdmin: "Unternehmensadmin",
	    LblCompanyAddress: "Unternehmensadresse",
	    LblInternalOrganization: "Interne Organisation",
	    LblNoOfVegicles: "Anzahl Fahrzeuge",
	    LblNoOfSharedVehicleGroups: "Anzahl Carsharing-Gruppen",
	    LblGeoLocation: "Standort",
	    LblSelectGeoLocation: "Standort auswählen",
	    LblPerson: "Person",
	    LblRole: "Rollen",
	    LblDateOfBirth: "Geburtsdatum",
	    LblDriverLicenceNumber: "Führerscheinnummer",
	    LblApkExiprationSetting: "Benachrichtigungseinstellungen periodische Wartung",
	    LblApkTimeInterval: "Zeitintervall für Benachrichtigungen",
	    LblEmailNotification: "E-Mail-Benachrichtigung",
	    LblNotificationFrequency: "Benachrichtigungsfrequenz",
	    lblThresholdFrequency: "Grenzperiodenfrequenz",
	    lblThresholdTimeInterval: "Zeitintervall für Grenzperiode",
	    LblIsEmailEnabled: "Benachrichtigungs-E-Mail",
	    lblThreshold: "Grenzperiode",
	    LblFrequency: "Frequenz",
	    LblDay: "Tag",
	    LblWeek: "Woche",
	    LblMonth: "Monat",
	    lblPerBooking: "Pro Buchung",
	    LblPersons: "Personen",
	    LblPersonOverview: "Personenübersicht",
	    LblCompanies: "Unternehmen",
	    //Vehicle Page
	    LblVehicle: "Fahrzeug",
	    LblVtsVehicle: "VTS-Fahrzeug",
	    LblFleetId: "Flotten-ID",
	    LblContractId: "Vertrags-ID",
	    LblVIN: "FIN",
	    LblLicenceTag: "Autokennzeichen",
	    LblLicence: "Führerschein",
	    LblMobile: "Mobiltelefon",
	    LblVehicleOwner: "Fahrzeugbesitzer",
	    LblLocationDataExchange: "Datenaustausch Standort",
	    LblBrand: "Marke",
	    LblType: "Typ",
	    LblColor: "Farbe",
	    LblVehicleClass: "Fahrzeugklasse",
	    LblPricingCategory: "Preiskategorie",
	    LblBodyStyle: "Karosserietyp",
	    LblAvailable: "Verfügbar",
	    LblUnAvailable: "Nicht verfügbar",
	    LblAvailableFrom: "Verfügbar ab",
	    LblAvailableTo: "Verfügbar bis",
	    LblFuelType: "Kraftstoffart",
	    LblMinBookingTimeBefore: "Mindeste verfügbare Zeit vor Buchung (Minuten)",
	    LblMinBookingTimeAfter: "Mindeste verfügbare Zeit nach Buchung (Minuten)",
	    LblTowbar: "Anhängerkupplung",
	    LblAirco: "Klimaanlage",
	    LblVehicleAttributes: "Fahrzeugattribute",
	    LblBlockUnBlock: "Blockieren/Freigeben",
	    LblRemoveLicense: "Führerschein entfernen",
	    LblRemoveLicenseBirthDate: "Führerschein und Geburtsdatum entfernen",
	    LblLicenseBirthDate: "Führerschein und Geburtsdatum",
	    LblBlock: "Blockieren",
	    LblUnblock: "Freigeben",
	    LblAvailableUnAvailable: "Verfügbar/Nicht verfügbar",
	    LblVehicles: "Fahrzeuge",
	    LblBookingsOverview: "Buchungsübersicht",
	    LblApkExpirationDateCet: "Ablaufdatum periodische Wartung",
	    LblEnabled: "Aktiviert",
	    LblDisabled: "Deaktiviert",
	    LblIntialOdometerValue: "Ursprünglicher Kilometerstand",
	    LblFuelCardPinCode: "Pincode Tankkarte",
	    LblFuel: "Kraftstoffart",
	    LblVINnumber: "Fahrgestellnummer",
	    LblVehicletype: "Fahrzeugtyp",
	    LblDoors: "Anzahl Türen",
	    LblWeight: "Fahrzeuggewicht",
	    LblTrunkSpace: "Kofferraum",
	    LblGears: "Anzahl Gänge",
	    LblEngineHorsepower: "Motorleistung (PS)",
	    LblFuelConsumption: "Krafftstoffverbrauch",
	    LblSeats: "Anzahl der Sitze",
	    LblDimensions: "Fahrzeugmaße",
	    LblTransmissionType: "Getriebeart",
	    LblTransmissionUnknown: "Unbekannt",
	    LblManualTransmission: "Schaltgetriebe",
	    LblAutomaticTransmission: "Automatik",
	    LblVehicleDetails: "Fahrzeugdaten",
	    LblSelectVehicletype: "Fahrzeugtyp auswählen",
	    LblWrongVinNumber: "Falsche Fahrgestellnummer",
	    //WEGO2DEV-325(Settings for Dashboard statuses)
	    LblVehicleOnSameLocationTime: "Fahrzeug am selben Standort seit mehr als",
	    LblNoBookingIn: "Fahrzeug nicht gebucht in mehr als",
	    lblHour: "Stunde",
	    //'lblInterval':'HOUR/DAY/WEEK/MONTH',
	    lblHourDayWeekMonth: "Stunde/Tag/Woche/Monat",
	    // Error Log
	    LblErrorLog: "Fehlerprotokoll",
	    LblComponentName: "Komponentenname",
	    LblLogType: "Protokolltyp",
	    LblEventDateTime: "Ereignis DatumUhrzeit",
	    LblComponent: "Komponente",
	    LblMonitoring: "Überwachung",
	    LblDropoffMessage: "Dropoff-Nachricht",
	    LblPreferredlanguage: "Bevorzugte Sprache",
	    LblDebtornr: "Schuldnernummer",
	    // Interface Status
	    LblInterfaceStatus: "Schnittstellenstatus",
	    LblLastStatusChangeDateTime: "DatumUhrzeit letzte Statusänderung DatumUhrzeit",
	    LblLastCarwisePollDateTime: "Letzte Carwise-Umfrage DatumUhrzeit",
	    LblUpdatedDateTime: "DatumUhrzeit aktualisiert",
	    //Booking Type
	    LblNORMALBOOKINGTYPE: 'NORMAL',
	    LblMAINTENANCEBOOKINGTYPE: 'WARTUNG',
	    LblUNAVAILABLEBOOKINGTYPE: 'NICHTVERFÜGBAR',
	    //Booking Request Status
	    LblAPPROVEDBOOKINGREQUEST: 'ANGENOMMEN',
	    LblREJECTEDBOOKINGREQUEST: 'ABGELEHNT',
	    LblPENDINGBOOKINGREQUEST: 'AUSSTEHEND',
	    //Booking Status
	    LblABORTED: 'ABGEBROCHEN',
	    LblCANCELLED: 'ANNULLIERT',
	    LblCONFIRMED: 'BESTÄTIGT',
	    LblFINISHED: 'FERTIG',
	    LblNOSHOW: 'NOSHOW',
	    LblPENDING: 'AUSSTEHEND',
	    LblREVOKED: 'WIDERRUFFEN',
	    LblRUNNING: 'GESTARTET',
	    LblREADYFORPAYMENT: 'BEREIT FÜR DIE ZAHLUNG',
	    //Invoice Status
	    LblOPEN: 'OFFEN',
	    LblSENT: 'GESENDET',
	    LblCLOSED: 'ABGESCHLOSSEN',
	    LblREQUESTFORPAYMENT: 'ZAHLUNGSANTRAG',
	    LblREOPEN: 'ERNEUERT',
	    //ErrorEscalation
	    LblErrorEscalation: "Fehlereskalation",
	    LblSelectAdminLevel: "Adminlevel auswählen",
	    LblWegoAdminLevel: "WeGo-Adminlevel",
	    LblCustomerAdminLevel: "Level Kundenadmin",
	    LblInstanceAdminLevel: "Level Instanzadmin",
	    //SharedVehicleGroup
	    LblSharedVehicleGroup: "Carsharing-Gruppe",
	    LblVehicleGroup: "Fahrzeuggruppe",
	    LblSharedVehicleGroupAdmin: "Admin Carsharing-Gruppe",
	    LblDisplayPeriod: "Anzeigeperiode",
	    LblBookingWeekDays: "Buchung Wochentage",
	    LblBookingInterval: "Buchungsintervall (Minuten)",
	    LblBookingStartTime: "Startzeitpunkt Buchung (hh.mm)",
	    LblBookingEndTime: "Endzeitpunkt der Buchung (hh.mm)",
	    LblBookingMinDuration: "Minimale Buchungsdauer (Minuten)",
	    LblBookingMaxDuration: "Maximale Buchungsdauer (Minuten)",
	    LblMaxRecurringBooking: "Maximum wiederkehrende Buchung",
	    LblPreBookingInterval: "Intervall vor Buchungen (Minuten)",
	    LblPostBookingInterval: "Intervall nach Buchungen (Minuten)",
	    LblBookingExtensionTime: "Maximale Verlängerungszeit (Minuten)",
	    LblBookAheadTime: 'Buchung ab jetzt für «X» Minuten möglich',
	    LblBookingHorizon: "Buchungszeitraum",
	    LblNumberOfContactTypeGroup: "Anzahl Vertragstypengruppe",
	    LblNumberOfContactType: "Anzahl Vertragstypen",
	    LblInvoiceInterval: "Rechnungsintervall",
	    LblIsBookingIntervalAlignToCalendar: "Buchungsintervall an Kalender angleichen",
	    LblBookings: "Buchungen",
	    LblSharedVehicleGroups: "Carsharing-Gruppen",
	    LblSharedVehicleGroupOverview: "Übersicht Carsharing-Gruppe",
	    LblEarlyOpenInterval: "Voraböffnungsintervall (Minuten)",
	    LblFeatureFlags: "Feature-Flags",
	    LblCreateBooking: "Buchung erstellen",
	    LblEditBooking: "Buchung bearbeiten",
	    LblLicenseCheck: "Lizenzprüfung",
	    LblBookingLicenseCheck: "Überprüfen vor Buchung",
	    //Driver
	    LblDriver: "Fahrer",
	    LblLicenceNumber: "Führerscheinnr.",
	    LblDriverName: "Name des Fahrers",
	    LblDriverSVG: "Fahrer Carsharing-Gruppe",
	    LblDriverUserName: "Benutzername des Fahrers",
	    //VehicleAttribute
	    LblVehicleAttributeCategory: "Fahrzeugattributkategorie",
	    LblVehicleAttributeName: "Attributname",
	    LblVehicleAttributeDesc: "Beschreibung",
	    LblVehicleAttribute: "Fahrzeugattribut",
	    LbAdditionallVehicleAttribute: "Zusätzliche Fahrzeugmerkmale",
	    LblVehicleAttributeCategories: "Fahrzeugattributkategorien",
	    //ContractType Page
	    LblRegular: "Regelmässig",
	    LblWeekEnd: "Wochenende",
	    LblDayCT: "Tag",
	    LblExtraTimeBefore: "Zusätzliche Zeit vor (Minute)",
	    LblExtraTimeAfter: "Zusätzliche Zeit nach (Minute)",
	    LblFreeTextDescription: "Geben Sie den Sonderbuchungstarif sowie Start- und Endzeitpunkte an (Freitext)",
	    LblPeriodRate: "Periodensatz",
	    LblPeriodRateVat: "Periodensatz MWST",
	    LblSelectContractTypeType: "Vertragstyp auswählen",
	    LblContractTypeType: "Vertragstyp",
	    LblContractType: "Vertragstyp",
	    LblContractName: "Vertragsname",
	    LblContractTypeGroup: "Vertragstypengruppe",
	    LblContractTypeGroupName: "Name der Vertragstypengruppe",
	    LblContractAvailableDays: "Verfügbare Tage Vertrag",
	    LblApplicableDays: "Anwendbare Tage",
	    LblDayStartTime: "Startzeitpunkt (hh.mm)",
	    LblDayEndTime: "Endzeitpunkt (hh.mm)",
	    LblApplicableStartTime: "Anwendbarer Startzeitpunkt (hh.mm)",
	    LblApplicableEndTime: "Anwendbarer Endzeitpunkt (hh.mm)",
	    LblComment: "Kommentar",
	    LblProcessingFee: "Verarbeitungsgebühr",
	    LblVatPercentage: "MWST (%)",
	    LblVatIncludedInPrice: "MWST im Preis enthalten",
	    LblPlateformUsageCost: "Nutzungskosten Plattform",
	    LblCatA: "Kategorie A",
	    LblCatB: "Kategorie B",
	    LblCatC: "Kategorie C",
	    LblCatD: "Kategorie D",
	    LblCatE: "Kategorie E",
	    LblCatF: "Kategorie F",
	    LblCatG: "Kategorie G",
	    LblCatH: "Kategorie H",
	    LblHourlyRate: "Zeitkosten",
	    LblMileageRate: "Kilometergeld",
	    LblFixedFee: "Fixgebühr",
	    LblPricingModel: "Preismodell",
	    LblContractStartDateTime: "Startdatum/Startzeitpunkt Vertrag",
	    LblContractEndDateTime: "Enddatum des Vertrags",
	    LblContractTypeHistory: "Historie",
	    LblContractTypPeriod: "Vertragstypenperiode",
	    LblInactiveContractTypeGroupReason: "Grund für die Deaktivierung der Vertragstypengruppe",
	    LblPenaltyAmount: "Höhe der Strafe",
	    LblPenaltyTimeInterval: "Intervall Strafzeit (Minuten)",
	    LblIsPenaltyEnabled: "Strafe aktiviert",
	    LblTripDisplayType: "Wie sollen Fahrten in Berichten dargestellt werden?",
	    LblAllTripsIndividually: "Alle Fahrten individuell",
	    LblAllTripsGrouped: "Alle Fahrten in einer einzelnen Fahrt gruppiert",
	    // DateTime Picker
	    LblJanuary: "Januar",
	    LblFebruary: "Februar",
	    LblMarch: "März",
	    LblApril: "April",
	    LblMay: "Mai",
	    LblJune: "Juni",
	    LblJuly: "Juli",
	    LblAugust: "August",
	    LblSeptember: "September",
	    LblOctober: "Oktober",
	    LblNovember: "November",
	    LblDecember: "Dezember",
	    LblSJan: "Jan",
	    LblSFeb: "Feb",
	    LblSMar: "März",
	    LblSApr: "Apr",
	    LblSMay: "Mai",
	    LblSJun: "Juni",
	    LblSJul: "Juli",
	    LblSAug: "Aug",
	    LblSSep: "Sep",
	    LblSOct: "Okt",
	    LblSNov: "Nov",
	    LblSDec: "Dez",
	    LblSunday: "Sonntag",
	    LblMonday: "Montag",
	    LblTuesday: "Dienstag",
	    LblWednesday: "Mittwoch",
	    LblThursday: "Donnerstag",
	    LblFriday: "Freitag",
	    LblSaturday: "Samstag",
	    LblSSu: "So",
	    LblSMo: "Mo",
	    LblSTu: "Di",
	    LblSWe: "Mi",
	    LblSTh: "Do",
	    LblSFr: "Fr",
	    LblSSa: "Sa",
	    //Forgot Password
	    LblForgotPassword: "Passwort vergessen",
	    LblChangePassword: "Passwort ändern",
	    LblOldPassword: "Altes Passwort",
	    LblNewPassword: "Passwort",
	    LblProfileUpdatedSucessFully: "Profilaktualisierung erfolgreich",
	    LblPasswordChangedSucessFully: "Sie haben Ihr Passwort erfolgreich geändert",
	    //
	    LblUpdateProfile: "Profil aktualisieren",
	    LbLReasonVehicle: "Grund für Nichtverfügbarkeit",
	    LblReasonDriver: "Grund für Fahrerblockierung",
	    //Booking
	    LblFrom: "Von",
	    LblApprovalAdminName: "Vom Admin genehmigt",
	    LblApprovedRejectedby: "Genehmigt/Abgelehnt von",
	    LblBookingRequestList: "Liste Buchungsanfragen",
	    LblTo: "Bis",
	    LblBooking: "Buchung",
	    LblBookingRequest: "Buchungsanfrage",
	    LblOverview: "Buchungsübersicht",
	    LblOverviewList: "Liste Buchungsübersicht",
	    LblApproveBooking: "Buchungsgenehmigung",
	    LblApprove: "Genehmigen",
	    LblReject: "Ablehnen",
	    LblNormal: "Neue Buchung",
	    LblSpecial: "Sonderbuchung",
	    LblHistory: "Buchungshistorie",
	    LblBookingStatus: "Buchungsstatus",
	    LblBookingType: "Buchungstyp",
	    LblAdminRemarks: "Bemerkungen Admin",
	    LblBookingRemarks: "Anmerkungen zur Buchung",
	    LblDriverRemarks: "Anmerkungen des Fahrers",
	    LblBookingReferenceId: "Buchungs-ID",
	    LblAbort: "Abbrechen",
	    LblRevoke: "Widerrufen",
	    LblStatus: "Status",
	    LblReference: "Referenz-ID",
	    LblRemarks: "Anmerkungen",
	    LblSearchForVehicle: "Fahrzeug suchen",
	    LblVehicleOverview: "Fahrzeugübersicht",
	    LblConfirmBooking: "Buchung bestätigen",
	    LblCurrentBookingDetail: "Informationen zur aktuellen Buchung",
	    LblCheckAvailability: "Verfügbarkeit prüfen",
	    LblBookingStartDateTime: "Beginn Buchung",
	    LblBookingEndDateTime: "Ende der Buchung",
	    LblSource: "Quelle",
	    LblRecurring: "Wiederkehrend",
	    LblRecurringId: "Wiederkehrende ID",
	    LblRecurringBookingReference: "Wiederkehrende Buchungsreferenz",
	    LblDaily: "Täglich",
	    LblWeekly: "Wöchentlich",
	    LblMonthly: "Monatlich",
	    LblRecurrenceEndDate: "Enddatum Wiederholung",
	    LblSearch: "Suchen",
	    LblBookNow: "Jetzt buchen",
	    LblUpdateBooking: "Buchung aktualisieren",
	    LblEditCarNotAvailable: "Ursprünglich gebuchtes Fahrzeug nicht verfügbar",
	    LblSortBy: "Sortieren nach",
	    LblAvaibility: "Verfügbarkeit",
	    LblDistance: "Distanz",
	    LblNoMatchingVehicle: "Keine passenden Fahrzeuge gefunden",
	    LblAvailableSlots: "Verfügbare Zeitfenster",
	    LblFeatures: "Funktionen",
	    LblDriverDetail: "Fahrerinformationen",
	    LblBookingDetail: "Buchungsinformationen",
	    LblVehicleDetail: "Fahrzeugdetails",
	    LblBookingSuccess: "Sie haben die Buchungsanfrage erfolgreich erstellt. Eine Kopie der Anfrage wird an die registrierte E-Mail-Adresse gesendet. Es wurde auch eine Benachrichtigung zur ",
	    LblBookingUpdateSuccess: "Buchung wurde erfolgreich angepasst. Eine Benachrichtigung wird an die E-Mail-Adresse des Fahrers gesendet.",
	    LblBlockNormalBooking: "Ihr Account wurde blockiert. Bitte wenden Sie sich an den Administrator.",
	    LblSingle: "Einzeln",
	    LblSeries: "Serie",
	    LblAll: "Alle",
	    SelectionRequiredMsg: "Bitte wählen Sie mindestens eine Buchung aus, um sie zu genehmigen/abzulehnen",
	    LblSelectionRequired: "Auswahl erforderlich",
	    LblLicenceRequired1: "Bitte Führerscheinnummer validieren, gehen Sie auf",
	    LblLicenceRequired2: "um Einzelheiten zur Führerscheinnummer zu aktualisieren",
	    LblAcceptOrReject: "Genehmigen/Ablehnen",
	    //Special Booking
	    LblSpecialBooking: "Sonderbuchung",
	    LblAffectedBooking: "Betroffene Buchungen",
	    LblSpecialBookingType: "Sonderbuchungstyp",
	    LblSelectSpecialBookingType: "Sonderbuchungstyp auswählen",
	    LblSpecialBookingConfiramtionmsg: "Möchten Sie wirklich eine Sonderbuchung erstellen?",
	    LblEndDate: "Enddatum Wiederholung",
	    // Notification
	    LblNotification: "Benachrichtigung",
	    LblSubject: "Betreff",
	    LblDate: "Datum",
	    LblWelcomeNotification: "Willkommen zum WeGo-Benachrichtigungspostfach",
	    //Template
	    LblTemplate: "Vorlage",
	    LblTemplateList: "Vorlagenliste",
	    LblTemplateName: "Vorlagenname",
	    LblTemplateType: "Vorlagentyp",
	    LblBody: "Karosserie",
	    LblIsEmailTemplate: "E-Mail",
	    LblIsWebTemplate: "Web",
	    // Notification Event Management
	    LblNotificationEventManagement: "Benachrichtigungsereignisse Management",
	    LblNotificationEvent: "Benachrichtigungsereignis",
	    LblModuleName: "Modulname",
	    LblSMS: "SMS",
	    //User Type
	    LblUserType: "Nutzertyp",
	    //TimeBlock
	    LblTimeBlock: "ZeitBlock",
	    LblTimeBlockName: "ZeitBlock Name",
	    LblTimeBlockWeekDays: "ZeitBlock Wochentage",
	    LblTimeBlockStartTime: "ZeitBlock Startzeitpunkt",
	    LblTimeBlockEndTime: "ZeitBlock Endzeitpunkt",
	    LblTimeBlockStartDate: "ZeitBlock Startdatum",
	    LblTimeBlockEndDate: "ZeitBlock Enddatum",
	    // Service Offer
	    LblServiceOffer: "Dienstleistungsangebot",
	    LblServiceOfferList: "Liste Dienstleistungsangebot",
	    LblServiceOfferName: "Angebotsname",
	    LblServiceOfferType: "Angebotstyp",
	    LblStandardTariff: "Standardtarif",
	    LblTimeUsedOrBooked: "Zeit genutzt/gebucht",
	    LblPenalty: "Strafe  ",
	    LblAdditional: "Zusätzlich",
	    LblAdditionalAbbr: "Zusätzlich",
	    LblUnit: "Einheit",
	    //WegoAdminList
	    LblWegoAdmin: "WeGo-Admin",
	    LblWegoAdmins: "WeGo-Admins",
	    LblReSend: "Erneut senden",
	    LblResendActivationMail: "Aktivierungs-E-Mail",
	    LblResendActivationMailFailure: "Senden der Aktivierungs-E-Mail fehlgeschlagen",
	    LblResendActivationMailSuccess: "Aktivierungs-E-Mail gesendet",
	    //Subscription
	    LblSubscription: "Abonnement",
	    LblSubscriptionName: "Abonnementname",
	    LblTimeInterval: "Zeitintervall",
	    LblAmount: "Anzahl",
	    LblFreeKilometer: "Freicredits",
	    LblFreeMinute: "Freiminuten",
	    LblFreeHours: "Freistunden",
	    LblNumberOfSubscription: "Anzahl Abonnements",
	    LblUnsubscribe: "Abmelden",
	    LblsubscribeEndDate: "Enddatum Abonnement",
	    LblSubscriptionStartDate: "Startdatum Abonnement",
	    //Special Period
	    LblSpecialPeriod: "Sonderperiode",
	    LblspecialPeriodName: "Name der Sonderperiode",
	    LblSpecialPeriodStartTime: "Startzeitpunkt der Sonderperiode",
	    LblSpecialPeriodEndTime: "Endzeitpunkt Sonderperiode",
	    LblSpecialPeriodWeekDays: "Sonderperiode Wochentage",
	    LblNormalPeriod: "Normaler Zeitraum",
	    LblSpecialPeriods: "Sonderperioden",
	    //Booking InvoiceModel
	    LblBookingInvoice: "Buchungsrechnung",
	    LblInvoiceStatus: "Rechnungsstatus",
	    LblInvoiceType: "Rechnungstyp",
	    LblSummary: "Zusammenfassung",
	    LblTotalHours: "Stunden insgesamt",
	    LblTotalKm: "Strecke insgesamt (km)",
	    LblTotalExpense: "Gesamtausgabe",
	    LblInvoiceNumber: "Rechnungsnummer",
	    LblBegin: "Start",
	    LblEnd: "Ende",
	    LblVat: "MWST",
	    LblDone: "Fertig",
	    LblClear: "Löschen",
	    LblTotal: "Total",
	    LblInvoiceRequestDateTime: "Rechnungsanforderung DatumUhrzeit",
	    LblInvoiceSendDateTime: "Rechnung versenden DatumUhrzeit",
	    LblInvoiceDateTime: "Rechnung DatumUhrzeit",
	    LblInvoiceDetail: "Rechnungsdetails",
	    LblResend: "Erneut senden",
	    LblDownload: "Herunterladen",
	    LblResendInvoiceConfirm: "Möchten Sie %0 wirklich erneut versenden?",
	    LblSendInvoiceConfirm: "Möchten Sie die Rechnung wirklich senden?",
	    LblPenaltyRate: "Straftarif",
	    LblInvoicing: "Rechnungsstellung",
	    LblInvoices: "Rechnungen",
	    LblLegacyInvoicing: "Rechnungen (vor dem 22.04.2025)",
	    LblProfile: "Profil",
	    LblSignOut: "Abmelden",
	    LblTemplateNote1: "Bitte Texte in Form von {variablename} nicht ändern/entfernen. Dies ist ein dynamischer Attributname, der durch einen tatsächlichen Datenbankeintrag ersetzt wird, wenn die E-Mail an den Benutzer gesendet wird.",
	    LblTemplateNote2: "Bitte die Struktur der Tabellen nicht ändern. Sie können eine neue erstellen, die alte sollte jedoch nicht geändert werden.",
	    LblTemplateNote3: "Bitte achten sie darauf, dass Sie «Einfügen als normaler Text» wählen, wenn Sie einen Platzhalter kopieren und im HTML-Editor einfügen.",
	    LblConfirmUnsubscribe: "Möchten Sie sich wirklich abmelden?",
	    LblDriveHours: "Fahrzeiten",
	    LblVehicleImage: "Fahrzeugbild",
	    LblMaintenance: "Wartung",
	    LblUNAVAILABLE: "Nicht verfügbar",
	    LblTestInvoiceGenerator: "Generator Testrechnung",
	    LblMissingInvoiceGenerator: "Fehlender Generator Rechnung",
	    LblInvoicingDateTime: "Rechnungsstellung DatumUhrzeit (UTC)",
	    LblGenerateInvoice: "Rechnung generieren",
	    LblDeleteAllSelectedRecords: "Alle markierten Einträge löschen",
	    LblCancelAllSelectedRecords: "Alle markierten Einträge annullieren",
	    "LblExportAll(CSV)": "Alle exportieren (CSV)",
	    LblAddContactPerson: "Ansprechpartner hinzufügen",
	    LblRemoveContactPerson: "Ansprechpartner entfernen",
	    LblNote: "Anmerkung",
	    LblCompletelyEndConfirm: "Fahrt vollständig abschliessen",
	    LblEndTrip: "Fahrtende",
	    LblTestTrip: "Testfahrt",
	    LblTripSimulator: "Fahrtsimulator",
	    LblTestTripSuccess: "Testfahrt erfolgreich erstellt",
	    LblDrivingStartDateTime: "Enddatum/Startzeitpunkt der Fahrt",
	    LblDrivingEndDateTime: "Enddatum/Endzeitpunkt der Fahrt",
	    LblInvoiceMoment: "Rechnungszeitpunkt",
	    LblExtend: "Verlängern",
	    LblExtendRequire: "Bitte geben Sie die Buchungsverlängerung ein (Minuten)",
	    LblExtendInfoMsg: "Sie können die Buchung um maximal %0 Minuten verlängern",
	    LblExtendValidationMsg: "Diese Buchung kann nicht verlängert werden",
	    LblExtendBooking: "Buchung verlängern",
	    LblBookingExtendedSuccess: "Buchung erfolgreich verlängert",
	    LblOverExtendValidationMsg: "Die Buchung kann nicht um mehr als %0 Minuten erweitert werden",
	    LblUnLock: "Entriegeln",
	    LblLock: "Sperren",
	    LblVehicleStatus: "Fahrzeugstatus",
	    LblTripSuccess: "Fahrt erfolgreich gespeichert",
	    LblLockSuccessfully: "Fahrzeug erfolgreich verriegelt",
	    LblLockCompletelySuccessfully: "Fahrzeug erfolgreich verriegelt",
	    LblUnLockSuccessfully: "Fahrzeug erfolgreich entriegelt",
	    LblUnlockProblem: "Problem bei Entriegelungsbefehl",
	    LbllockProblem: "Problem bei Verriegelungsbefehl",
	    LblLockCarCompletely: "Buchung sperren und schliessen",
	    LblStartDateTime: "Startdatum/Startzeitpunkt",
	    LblEndDateTime: "Enddatum/Endzeitpunkt",
	    LblBookingTripDetail: "Fahrtdetails für Buchung",
	    LblAddNewTrip: "Neue Fahrt hinzufügen",
	    LblBookingExpenseDetail: "Details Buchungsausgaben",
	    LblUnlockErrorMessage: "Keine aktive Vertragstypengruppe zum Erstellzeitpunkt der Buchung verfügbar",
	    LblExpenseAmount: "Betrag Ausgaben",
	    LblExpenseName: "Name Ausgaben",
	    LblExpenseSuccess: "Ausgaben erfolgreich gespeichert",
	    LblReceipt: "Beleg",
	    LblHelpdeskNo: "Helpdesk-Nr.",
	    LblBookingExpired: "Fahrzeug kann nicht geöffnet werden, da die Buchung abgelaufen ist.",
	    LblTripCalculationInProgress: "Wir hoffen, dass Sie eine gute Fahrt hatten! Das Fahrzeug wird sich in wenigen Sekunden schliessen.",
	    LblVTSReqLogDetail: "VTS-Anforderung Protokolldetails",
	    LblVTSReqDateTime: "Datum/Uhrzeit anfordern",
	    LblVTSProcessTime: "Bearbeitungszeit",
	    LblVTSResTime: "Ergebniszeit",
	    LblVTSReqType: "Anforderungstyp",
	    LblVTSResult: "Ergebnis ",
	    LblActualInvoiceGenerationDate: "Tatsächliches Datum der Rechnungsgenerierung",
	    LblAvailableForAllSlots: "Fahrzeug verfügbar für alle Zeitfenster",
	    LblUnAvailableSlots: "Nicht verfügbare Zeitfenster",
	    LblNoOfDrivers: "Anzahl Fahrer",
	    LblSVGDriversList: "Fahrer Carsharing-Gruppe",
	    LblVehicleInformation: "Fahrzeuginformationen",
	    LblVTSVehicle: "VTS-Fahrzeug",
	    LblVTSVehicleUpdateSuccess: "Fahrzeug erfolgreich %0.",
	    LblVTSVehicleList: "VTS-Fahrzeugliste",
	    //Report Damage
	    LblReportDamage: "Schaden melden",
	    LblCompleteDamageReport: "Schadensmeldung abschliessen",
	    LblDamageFile: "Schadendatei",
	    LblDescribe: "Beschreiben Sie den Schaden ...",
	    LblCause: "Beschreiben Sie die Ursache ...",
	    LblReportDamageMsg: "Schaden erfolgreich gemeldet",
	    LblSelectFile: "Datei auswählen",
	    // Import Data
	    LblCSVImport: "CSV-Datei importieren",
	    LblValidateCSV: "CSV validieren",
	    LblImportValidPerson: "Gültige Person importieren",
	    LblImportValidDriver: "Gültigen Fahrer importieren",
	    LblImportValidVehicle: "Gültiges Fahrzeug importieren",
	    LblCSVType: "CSV-Typ",
	    LblCSVFile: "CSV-Datei",
	    LblRecordImportedSuccess: "%0 wurden erfolgreich importiert",
	    LblInvalidReason: "Ungültiger Grund",
	    LblSameVTSCommand: "Anfrage wird bereits bearbeitet. Bitte warten Sie.",
	    LblImportPerson: "Person importieren",
	    //Subscription related Changes
	    LblSubscriptionInterval: "Abonnementintervall",
	    LblPaymentInterval: "Zahlungsintervall",
	    LblInvoicInterval: "Rechnungsintervall",
	    LblInterval: "Intervall",
	    LblInvoiceMomentDay: "Rechnungszeitpunkt (Wochentag)",
	    LblInvoiceMomentMonth: "Rechnungszeitpunkt (Tag des Monats)",
	    LblFreeMinuteInterval: "Freiminuten Intervall",
	    LblFreeKMInterval: "Freicredits Intervall",
	    LblSelectSubscriptionInterval: "Abonnementintervall auswählen",
	    LblSelectInvoiceInterval: "Rechnungsintervall auswählen",
	    LblSelectPaymentInterval: "Zahlungsintervall auswählen",
	    LblSelectFreeKMInterval: "Intervall Freikilometer auswählen",
	    LblSelectFreeMinInterval: "Minutenintervall auswählen",
	    LblYearlySub: "Jährlich",
	    LblMonthlySub: "Monatlich",
	    LblWeeklySub: "Wöchentlich",
	    LblFreePerWeek: "Pro Woche",
	    LblFreePerMonth: "Pro Monat",
	    LblFreePerTriMonth: "Pro 3 Monate",
	    LblFreePerBiannual: "Pro 6 Monate",
	    LblFreePerYear: "Pro Jahr",
	    LblDefaultContractTypeGroup: "Standard-Vertragstypengruppe",
	    LblSelectDefaultContractTypeGroup: "Standard-Vertragstypengruppe auswählen",
	    LblSendInvoiceToDriver: "Rechnung an Fahrer senden",
	    LblInherit: "übernehmen",
	    //Invoice Moment
	    LblDayOfMonth: "Tag des Monats",
	    LblDayOfWeek: "Wochentag",
	    LblSelectDayOfWeek: "Wochentag auswählen",
	    LblInstanceLogo: "Instanzlogo",
	    LblInvoiceDeleteValidation: "Rechnung kann nicht gelöscht werden wegen Verknüpfung mit anderer Einheit",
	    //SubscriptionAvailabilityRestriction
	    LblSubscriptionAvailabilityRestriction: "Verfügbarkeitsbeschränkung Abonnement",
	    LblStartDay: "Starttag",
	    LblEndDay: "Endtag",
	    LblStartTime: "Startzeitpunkt (hh.mm)",
	    LblEndTime: "Endzeitpunkt (hh.mm)",
	    LblRestriction: "Beschränkung",
	    LblTotalFreeKilometer: "Freikilometer insgesamt",
	    LblTotalFreeMinute: "Freiminuten insgesamt",
	    LblCurRemainFreeKilometer: "Verbleibende Freikilometer",
	    LblPrevRemainFreeKilometer: "Vorherige verbleibende Freikilometer",
	    LblCurRemainFreeMinute: "Verbleibende Freiminuten",
	    LblPrevRemainFreeMinute: "Vorherige verbleibende Freiminuten",
	    LblResetPasswordFailure: "Das Passwort kann nicht zurückgesetzt worden, da der Benutzer noch nicht aktiviert ist.",
	    //Additional Free Item
	    LblAdditionalFreeItems: "Zusätzliches Gratis Credits",
	    LblDateAwared: "Zuerkennungsdatum",
	    LblAdditionalFreeItemsMenu: "Zusätzliche Gratis Credits",
	    LblPrevious: "Vorherige",
	    LblCurrent: "Aktuell",
	    LblTripDetailReport: "Fahrtdetailbericht",
	    LblTripDetailList: "Detaillierte Buchungsübersicht",
	    LblSearchTripforDriver: "Gebuchte Fahrten von Fahrer suchen",
	    LblExportReport: "Bericht exportieren",
	    LblTripComments: "Fahrt bemerkung",
	    LblTripCommentDescription: "Bemerkung eingeben",
	    LblTripCommentError: "Bitte gültige bemerkung eingeben",
	    LblShowTripComment: "Bemerkung ansehen",
	    LblAddTripComment: "Bemerkung eingeben",
	    LblTripCommentBy: "Fahrt bemerkung von",
	    LblTripCommentOn: "Fahrt bemerkung am",
	    LblValidateLiceanceNumberMessage: "Bitte validieren Sie Ihre Führerscheinnummer",
	    LblBookingIntervalRate: "Intervalltarif",
	    LblPerHour: "Pro Stunde",
	    LblPerBookingIntarval: "Pro Buchungsintervall",
	    LblTimeRate: "Zeittarif",
	    LblToalBookingDuration: "Buchungsdauer",
	    LblCleanRequire: "Reinigung erforderlich",
	    LblFualRequire: "Kraftstoff erforderlich",
	    LblVehicleDamageList: "Liste für Fahrzeugschaden",
	    LblDamageCause: "Schadensursache",
	    LblDamageReportedBy: "Gemeldet von",
	    LblDamageReportedOn: "Gemeldet am",
	    LblConfirmResolveDamage: "Möchten Sie den Fahrzeugschaden wirklich beheben?",
	    LblVehicleDamgeResolveSuccess: "Fahrzeugschaden erfolgreich behoben",
	    LblDamageDesc: "Schadensbeschreibung",
	    LblFutureBooking: "Künftige Buchungen",
	    LblResolveDamge: "Schaden beheben",
	    LblReserved: "Reserviert",
	    LblVehicleInfoSuccess: "Fahrzeuginformationen erfolgreich aktualisiert",
	    LblInformation: "Information ",
	    LblVTSHistory: "VTS-Ereignishistorie",
	    LblWegoRequestTime: "WeGo-Anfragebearbeitungszeit",
	    LblVTSRequestTime: "VTS-Anfragebearbeitungszeit",
	    LblRequestType: "Anforderungstyp",
	    LblWegoProcessTime: "WeGo-Bearbeitungszeit",
	    LblResult: "Ergebnis",
	    LblWegoResultTime: "WeGo-Ergebniszeit",
	    LblVTSResultTime: "VTS-Ergebniszeit",
	    LblCommandInitiator: "Anfrage gesendet von",
	    LblTroubleShootVTS: "VTS-Fehlerbehebung",
	    LblVtsServiceStatus: "VTS-Servicestatus",
	    LblVtsLicencetag: "VTS-Kennzeichen",
	    LblVtsDoorStatus: "Türstatus",
	    LblVtsIssueCommand: "Befehl senden",
	    LblVehicleLocation: "Fahrzeugstandort",
	    LblEventHistory: "VTS-Ereignishistorie",
	    LblView: "Ansehen",
	    LblVehicleObuStatus: "Bordgerätstatus Fahrzeug",
	    LblVehicleNotInitialized: "Fahrzeug nicht initialisiert",
	    LblLastReceivedTime: "Zeit letzte erhaltene Nachricht",
	    LblFreePerBookingInterval: "Pro Buchungsintervall",
	    LblSelectFilter: "Filter auswählen",
	    LblAuditEntries: "Einträge prüfen",
	    LblFilter: "Filter ",
	    LblCategory: "Kategorie",
	    LblEventName: "Ereignisname",
	    LblEventData: "Ereignisdaten",
	    LblMoment: "Moment",
	    LblUser: "Nutzer",
	    LblNoEventDataFound: "Keine Ereignisdaten gefunden",
	    LblEventViewer: "Ereignisviewer",
	    LblSelectObuType: "Bordgerättyp auswählen",
	    LblObuType: "Bordgerättyp",
	    LblDeviceId: "Geräte-ID",
	    LblClaimCode: "Claim code",
	    LblVtsLocation: "VTS-Standort",
	    LblRetriveAddress: "Adresse abrufen",
	    LblCrearedDate: "Erstelldatum",
	    LblCreatedBy: "Erstellt durch",
	    LblPerBooking: "PerReservierung",
	    LblOBU: "Bordgerät",
	    LblClone: "Kopieren",
	    LblCloneVehicle: "%0 kopieren",
	    LblFualNotRequire: "Kraftstoff nicht erforderlich",
	    LblCleanNotRequire: "Reinigung nicht erforderlich",
	    LblSubscriptionInfo: "Abonnementinformationen",
	    LblVehiclDamaged: "Fahrzeug beschädigt",
	    LblVehicleNotDamaged: "Fahrzeug nicht beschädigt",
	    LblDamage: "Beschädigt",
	    LblFreeBooking: "Buchungskosten anpassen",
	    LblBookingCustomFee: "Benutzerdefinierte Buchungskosten",
	    LblFreeBookingSuccess: "Buchungskosten erfolgreich gespeichert",
	    LblEnterLocation: "Standort eingeben",
	    LblHomeLocation: "Heimatstandort",
	    LblLocationMode: "Standortmodus",
	    LblMeter: "Meter",
	    LblLocation: "Standort",
	    LblPickupLocation: "Abholort",
	    LblLocationUnavailable: "Standort nicht verfügbar",
	    LblAvailabilityCalander: "Verfügbarkeitskalender",
	    LblAvailableOn: "Verfügbar auf",
	    LblGeofenceEnabled: "Geofence aktiviert",
	    LblLocationNotFound: "Adresse kann nicht gefunden werden",
	    LblAddressNotAvailable: "Adresse kann an diesem Standort nicht bestimmt werden",
	    LblReports: "Berichte",
	    LblDrivers: "Fahrer",
	    LblTemplates: "Vorlagen",
	    LblVehicleOccupancyReport: "Fahrzeugbelegungsbericht",
	    LblPlaceHolder: "Platzhalter",
	    LblSampleTemplate: "Mustervorlage",
	    LblLatexFileDownloadValidation: "Ungültiger Latex-Inhalt",
	    LblLocationDataExchangeNotAssign: "Dieses Fahrzeug kann nicht gebucht werden, wenn ihm kein VTS-Fahrzeug zugewiesen ist. Möchten Sie fortfahren?",
	    LblReservedTime: "Reservierte Zeit",
	    LblUsageTime: "Nutzungsdauer",
	    LblUsageTimeAtOffice: "Nutzungsdauer während der Arbeitszeit",
	    LblUsageTimeoutOffice: "Nutzungsdauer ausserhalb der Arbeitszeit",
	    LblRevenue: "Erlös",
	    LblRevenuePerVehicleReport: "Bericht Erlös pro Fahrzeug",
	    LblSearchRevenuePerVehicle: "Erlös pro Fahrzeug suchen",
	    LblRevenuePerVehicleList: "Liste Erlös pro Fahrzeug",
	    //Dashboard
	    LblInuse: "In Benutzung",
	    LblPriority: "Priorität",
	    LblDefaultStatus: "Standardstatus",
	    //OdometerLogTrail
	    LblOdometerLogTrail: "Historie Kilometerzähler",
	    LblUserProvidedOdometerValueInKmr: "Kilometerstand (km)",
	    LblDescriptionOfDeviation: "Beschreibung Abweichung",
	    LblFromOdometer: "Aus Kilometerzähler",
	    LblToOdometer: "Zum Kilometerzähler",
	    LblAddDescriptionOfDeviation: "Erklärung für Abweichung hinzufügen",
	    LblDeviation: "Abweichung (km)",
	    LblLastOdometerValue: "Vorheriger Kilometerstand (km)",
	    LblLastOdometerDT: "Vorheriges Kilometerzählerdatum",
	    LblOdometerRegistered: "Kilometerstand registriert",
	    LblOdometerValue: "Kilometerstand",
	    LblMaintenancePlanningList: "Liste Wartungsplanung",
	    LblSearchMaintenancePlanningValue: "Wartungsplanung durchsuchen",
	    LblMaintenancePlanningreport: "Bericht Wartungsplanung",
	    LblodometerConfiguration: "Konfiguration Kilometerzähler",
	    LbLOdometerEnabled: "Kilometerzähler aktiviert",
	    LblEnableOnApp: "In App aktivieren",
	    LblWarningPer: "Warnung (%)",
	    LblShowDeviation: "Abweichung anzeigen, die eine Erklärung erfordert",
	    LblTitle: "Titel",
	    LblFooterText: "Fussnotentext",
	    LblvalidEmailDomain: "Nur E-Mail-Adressen der folgenden Domäne erlauben",
	    LblURLSettings: "URL-Einstellungen",
	    LblSuccessUrl: "Erfolg URL",
	    LblEmailSettings: "E-Mail-Einstellungen",
	    LblSendActivationEmail: "Automatische Aktivierungs-E-Mails aktivieren",
	    LblSendConfirmationEmail: "Bestätigungs-E-Mails Registrierung aktivieren",
	    LblRequireAdminApprovel: "Neue Registrierungen erfordern Genehmigung des Admins",
	    LblDriverInformationToBeInclude: "Fahrerinformationen müssen im Formular eingetragen werden (alle erforderlichen Felder)",
	    LblSignUpForm: "Registrierungsformular",
	    LblSignupForms: "Registrierungsformulare",
	    LblSignupFormsOverview: "Übersicht Registrierungsformulare",
	    LblWhoCanApprove: "Wer kann neue Registrierungen bestätigen?",
	    LblSignupFormLogo: "Logo Registrierungsformular",
	    LblChooseSubscription: "Wählen Sie das/die für das Registrierungsformular verfügbare(n) Abonnement(s)",
	    LblSignupParameter: "Registrierungs-URL",
	    DomainNameString: "Domänennamen durch Komma getrennt (Beispiel: gmail.com, yahoo.com)",
	    SignupParameterString: "Nur Buchstaben, Zahlen und - sind erlaubt",
	    LblSignupParameterText: "Text Registrierungs-URL",
	    LblAvailability: "Verfügbarkeit",
	    LblSettings: "Einstellungen",
	    LblCurrentStatus: "Aktueller Status",
	    LblFlags: "Flags",
	    LblNA: "Keine Angabe",
	    //Sign up form
	    LblConfirmEmail: "E-Mail-Adresse bestätigen",
	    LblSignup: "Registrieren",
	    LblSignupsOverView: "Registrierungsübersicht",
	    LblSignupApproval: "Registrierungsbestätigung",
	    LblAccept: "Akzeptieren",
	    LblSignupFormDescription: "Beschreibung Registrierungsformular",
	    LblCurrentOdometerValue: "Aktueller Kilometerstand",
	    LblCurrentOdometerDateTime: "Aktuelles Datum/aktuelle Uhrzeit Kilometerzähler",
	    LblCreateDirectDebitFile: "Lastschriftdatei erstellen",
	    LblCheckEmptyIbanNumber: "IBAN-Nummern prüfen",
	    LblCreatedDate: "Erstelldatum",
	    LblIncludeInDirectDebit: "Lastschriftdatei einschliessen",
	    LblDirectDebitFileDate: "Datum Lastschriftdatei",
	    LblDirectDebitConfiguration: "Lastschriftkonfiguration",
	    LbLDirectDebitEnabled: "Generierung Lastschriftdatei aktivieren",
	    LblDirectDebitEnableper: "Lastschriftdatei aktiviert per",
	    LbLCreditorDetails: "Angaben zum Gläubiger",
	    LblAddress: "Adresse",
	    LblIBANNumber: "IBAN",
	    LblCountryCode: "Ländervorwahl",
	    LbLBillingInformation: "Zahlungsinformation",
	    LblFormat: "Format",
	    LblInvoicingDetails: "Details Rechnungsstellung",
	    LbLSubjectToDirectDebit: "Der Lastschrift unterliegend?",
	    //Person Upload Batch
	    LblBatchUploadPersonSetting: "Einstellung für «Personen gesammelt importieren»",
	    LblShowBatchUploadInfo: "«Personen gesammelt importieren» zulassen",
	    LblAllowBatchUpload: "Import erlauben für",
	    LblAllowActivationMail: "Aktivierungs-E-Mails benutzen",
	    LblGenerateRandomPassword: "System generiert Passwörter",
	    LblUserUploadPassword: "Passwörter importieren",
	    LblFieldToUploadedOrValidated: "Felder in Importdatei",
	    LblBatchUploadPerson: "Personen gesammelt importieren",
	    LblBatchUpload: "Personen gesammelt importieren",
	    LblImportDriverRole: "Fahrerrolle automatisch zuweisen?",
	    LblAssignToSVG: "Carsharing-Gruppe(n) zuweisen",
	    LblSVG: "Carsharing-Gruppe",
	    LblDownloadTemplate: "Beispiel Importdatei",
	    LblUserAssignSVGMessage: "Nutzer wurde Carsharing-Gruppe noch nicht zugewiesen!",
	    LblInvalidRecordReason: "Ungültiger Eintrag",
	    LblSelectedSVGs: "Ausgewählte Carsharing-Gruppe(n)",
	    LblDashboard: "Dashboard",
	    LblGroupAdmin: "Gruppenadmin",
	    LblDashboardConfiguration: "Dashboard-Konfiguration",
	    LblCurrentLocation: "Aktueller Standort",
	    LblEnableCurrentLocation: "Aktueller Standort aktivieren",
	    LblDefaultLocation: "Standardstandort",
	    LblEnableAutoUpdate: "Automatische Aktualisierung aktivieren",
	    LblPriorityNotificationSetting: "Benachrichtigungseinstellungen für Fahrzeugstatus",
	    LblCollectionDate: "Datum Lastschrift",
	    LblBICCode: "BIC-Code",
	    LblDirectDebitFile: "Lastschriftdatei ",
	    LblMissingIBANNumber: "Fehlende IBAN",
	    LblCurrentDriver: "Aktueller Fahrer",
	    LblNextDriver: "Nächster Fahrer",
	    LblSecond: "Sekunde(n)",
	    LblCleaning: "Reinigung",
	    LblRefueling: "Auftanken/Aufladen",
	    LblAPKMaintenance: "Periodische Wartung",
	    LblOutsideGeofence: "Ausserhalb Geofence",
	    LblNotBooked: "Nicht gebucht",
	    LblNotBookedSince: "Nicht gebucht seit",
	    LblLowBattery: "Niedriger Batteriestand",
	    LblBatteryVolt: "V.",
	    LblLowCharge: "Batterie beinahe leer",
	    LblChargingPercentage: "%",
	    LblOnSamePosition: "An derselben Position",
	    LblLastPosition: "Letzte Position",
	    LblNotReturn: "Nicht zurück",
	    LblCommunicationProblem: "Kommunikationsproblem",
	    LblDirectDebitDownloadSuccess: "Lastschriftdatei heruntergeladen",
	    LblWarnings: "Warnungen",
	    LblDirectDebitFileId: "Lastschriftdatei-ID",
	    LblTotalAmount: "Gesamtbetrag",
	    LblReCreate: "Erneut herunterladen",
	    LblPleaseEnterCollectionDate: "Bitte geben Sie ein Abholdatum ein",
	    LblOpenViaLowLevel: "Geöffnet über Low Level",
	    LblInstanceNotificationNote1: "Einstellung erfolgt nach Unternehmensvorgabe",
	    LblNoInvoiceSelected: "Keine Rechnung(en) für Lastschriftdatei gefunden",
	    LblIBANNumberRequired: "Bitte geben Sie IBAN und BIC ein",
	    LblNoEmptyIBANFound: "Keine IBAN gefunden",
	    LblInvalidTagUsed: "Ungültiges Tag verwendet",
	    LblNotInvalidTagUsed: "Keine ungültiges Tag verwendet",
	    LblShowVehicleChargeLevel: "Fahrzeugbatteriestand im Web und in Mobiltelefon-Apps anzeigen?",
	    LblChargeLevel: "Batteriestand",
	    LblCharging: "Aufladen",
	    LblNoDataFound: "Keine Daten verfügbar",
	    LblOfficeStartTime: "Startzeitpunkt Geschäftszeiten (hh.mm)",
	    LblOfficeEndTime: "Endzeitpunkt Geschäftszeiten (hh.mm))",
	    //Reports
	    LblTripDataReport: "Fahrtdatenbericht",
	    LblByDriver: "Nach Fahrer",
	    LblByVehicle: "Nach Fahrzeug",
	    LblModuleRights: "Modulrechte",
	    LblCostCenterReport: "Kostenstellenbericht",
	    LblShowTotalOnly: "Nur Total anzeigen",
	    // 'LblCostCenterReport':'Cost Center Report',
	    //Organization
	    LblOrganization: "Organisation ",
	    LblOrganizationName: "Name Organisation",
	    LblAddDriver: "Fahrer hinzufügen",
	    LblExistingDriverAddSuccessMsg: "Fahrer hinzugefügt, ebenfalls erfolgreich mit der Organisation verbunden.",
	    LblAddDriverSuccessMsg: "Fahrer hinzugefügt, Aktivierungslink ebenfalls erfolgreich an diesen Fahrer gesendet.",
	    LblOrganizationAddress: "Adresse Organisation",
	    LblAddDriverToOrganization: "Fahrer zur Organisation hinzufügen",
	    LblCreateOrganization: "Organisation erstellen",
	    LblOrganizationDriversList: "Fahrer Organisation",
	    // Branding
	    LblBranding: "Branding",
	    LblLogo: "Logos",
	    LblEmailNotificationInvoiceTemplate: "E-Mail-Benachrichtigung und Rechnungsvorlagen",
	    LblExpandedWebMenu: "Ausgeklapptes Webmenü",
	    LblCollapsedWebMenu: "Eingeklapptes Webmenü",
	    LblMobileApp: "Mobiltelefon-App",
	    LblSplashScreen: "Startbildschirm",
	    LblWebApplication: "Webanwendungen",
	    LblMobileApplication: "Anwendung Mobiltelefon-App",
	    LblBrandingSavedSuccess: "Branding erfolgreich gespeichert",
	    LblBrandingTemplateConfiguration: "Branding und Vorlagenkonfiguration",
	    LblAppWebUI: "App und Web UI",
	    LblNonBookingCommunication: "Allgemeine Kommunikation",
	    LblBookingCommunication: "Kommunikation bezüglich Buchungen",
	    LblInstanceBranding: "Stets Instanz-Branding nutzen",
	    LblCompanyBranding: "Wenn möglich Unternehmensbranding benutzen",
	    BO_TOP_MENU_ACTIVE_ITEM_BACKGROUND: "Obere Leiste, Menü und aktive Elemente",
	    BO_TOP_MENU_ACTIVE_ITEM_TEXT: "Menütext",
	    BO_HIGHLIGHTED_BUTTON_BACKGROUND: "Hervorgehobene Taste",
	    BO_HIGHLIGHTED_BUTTON_TEXT: "Hervorgehobene Tastenbeschriftung",
	    BO_HIGHLIGHTED_BUTTON_BACKGROUND_HOVER: "Hervorgehobene Taste(hover)",
	    BO_HIGHLIGHTED_BUTTON_TEXT_HOVER: "Hervorgehobene Tastenbeschriftung (hover)",
	    BO_PRIMARY_BUTTON_BACKGROUND: "Primäre Taste",
	    BO_PRIMARY_BUTTON_TEXT: "Primäre Tastenbeschriftung",
	    BO_PRIMARY_BUTTON_BACKGROUND_HOVER: "Primäre Taste (hover)",
	    BO_PRIMARY_BUTTON_TEXT_HOVER: "Primäre Tastenbeschriftung (hover)",
	    BO_SECONDARY_BUTTON_BACKGROUND: "Sekundäre Taste",
	    BO_SECONDARY_BUTTON_TEXT: "Sekundäre Tastenbeschriftung",
	    BO_SECONDARY_BUTTON_BACKGROUND_HOVER: "Sekundäre Taste (hover)",
	    BO_SECONDARY_BUTTON_TEXT_HOVER: "Sekundäre Tastenbeschriftung (hover)",
	    BO_HYPERLINK_TEXT: "Hyperlinktext",
	    BO_HIGHLIGHT_BACKGROUND: "Farbe hervorheben",
	    BO_HIGHLIGHT_TEXT: "Text hervorheben",
	    BO_CALENDAR_EVENT_BACKGROUND: "Kalenderereignis",
	    BO_CALENDAR_EVENT_TEXT: "Text Kalenderereignis",
	    MO_TOP_MENU_ACTIVE_ITEM_BACKGROUND: "Kopfleiste und Menü",
	    MO_LOGO_AREA_BACKGROUND: "Hintergrund Logofläche",
	    MO_PAGE_BACKGROUND: "Hintergrund",
	    MO_MENU_TEXT: "Menütext",
	    MO_HYPERLINK_TEXT: "Hyperlinktext",
	    MO_ENABLED_BUTTON_BACKGROUND: "Aktivierte Taste",
	    MO_ENABLED_BUTTON_TEXT: "Text aktivierte Taste",
	    MO_ENABLED_BUTTON_BACKGROUND_ACTIVE: "Aktivierte Taste (aktiv)",
	    MO_ENABLED_BUTTON_TEXT_ACTIVE: "Text aktivierte Taste (aktiv)",
	    MO_DISABLED_BUTTON_BACKGROUND: "Deaktivierte Taste",
	    MO_DISABLED_BUTTON_TEXT: "Text gesperrte Taste",
	    MO_DISABLED_BUTTON_BACKGROUND_ACTIVE: "Deaktivierte Taste (aktiv)",
	    MO_DISABLED_BUTTON_TEXT_ACTIVE: "Text gesperrte Taste (aktiv)",
	    MO_HIGHLIGHT_BACKGROUND: "Farbe hervorheben",
	    MO_HIGHLIGHT_TEXT: "Text hervorheben",
	    MO_CALENDAR_EVENT_BACKGROUND: "Kalenderereignis",
	    MO_CALENDAR_EVENT_TEXT: "Text Kalenderereignis",
	    MO_TITLE_TEXT: "Titeltext",
	    LblBookingDelayConfig: "Einstellungen für Buchungsverzögerung",
	    LblBookingDelayConfigEnabled: "E-Mail an Admin senden",
	    LblEnableSnauilTrail: "Snail-Trail aktivieren",
	    LblAppSupportTo: "App-Support für",
	    LblNotificationInterval: "Benachrichtigungsintervall",
	    LblNotifyAfterMinutes: 'Benachrichtigung nach «X» Minuten',
	    LblMinutesAfterBookingEndTime: "Wie viele Minuten nach geplantem Buchungsende?",
	    LblResendNotoficationEvery: "Benachrichtigung jede Minute erneut senden",
	    LblMinutes: "Minuten",
	    lblNotificationRecipients: "Benachrichtigungsempfänger",
	    LbLEnableBookingStillRunning: "Benachrichtigung «Buchung nicht abgeschlossen» aktivieren",
	    LblBookingrunningNotification: "Benachrichtigungseinstellungen «Buchung noch nicht abgeschlossen»",
	    LblPreferableImageSize: "Bevorzugte Bildgrösse",
	    LblWebBrandingExapandImageSize: "1150 px × 260 px",
	    LblMobileBrandingImageSize: "550 px × 250 px",
	    LblWebBrandingCollapseImageSize: "325 px × 250 px",
	    //Raise and clear settings for low battery flag
	    LblDefaultVehicleSetting: "Standard-Fahrzeugeinstellungen",
	    LblLowBatteryFlagRaised: "Warnung für niedrigen Batteriestand erhöht bei (Spannung)",
	    LblLowBatteryFlagClear: "Warnung für niedrigen Batteriestand aufgehoben bei (Spannung)",
	    LblByBooking: "Nach Buchung",
	    LblSnailTrailReport: "Snail-Trail-Bericht",
	    LblKickbackReport: "Rückerstattungsbericht",
	    LblGroupBy: "Gruppieren nach",
	    LblTripDetail: "Fahrtdetails",
	    LblTripNumber: "Fahrtnr.",
	    LblStart: "Start ",
	    LblAverageSpeed: "Durchschnittsgeschwindigkeit",
	    LblSegmentDetail: "Abschnittdetails",
	    LblSegmentNumber: "Abschnittsnr.",
	    LblSpeed: "Geschwindigkeit",
	    LblOdometer: "Kilometerzähler",
	    LblNext: "Weiter",
	    LblSegmentDetailNotAvailable: "Abschnittdetails nicht verfügbar",
	    LblUnitPerKm: "pro km",
	    LblUnitPerBooking: "pro Reservation",
	    LblBookingCostSummary: "Übersicht Buchungskosten",
	    LblTimeCost: "Zeitkosten",
	    LblTotalTime: "Gesamtzeit",
	    LblTime: "Zeit",
	    LblCostRateUnits: "Kosten (Anzahl * Rate)",
	    LblFreeTime: "Freie Zeit",
	    LblRate: "Tarif",
	    LblExVat: "Exkl. MWST",
	    LblInclVat: "Inkl. MWST",
	    LblKmDriven: "Gefahrene km",
	    LblFreeKms: "Freicredits",
	    LblTimePercent: "Zeitprozentsatz",
	    LblTotalExVat: "Total exkl. MWST",
	    LblTotalVat: "MWST insgesamt",
	    LblTotalInclVat: "Total inkl. MWST",
	    LblKilometerCost: "Kilometerkosten",
	    LblFixedCost: "Fixkosten",
	    LblTotals: "Gesamtsummen",
	    LblTypeDamage: "Schaden",
	    LblTypeMaintenance: "Periodische Wartung fällig",
	    LblTypeOnSamePosition: "Fahrzeug am selben Standort seit mehr als %0 %1",
	    LblTypeNotBooked: "Fahrzeug in nicht mehr als %0 %1 gebucht",
	    LblTypeNotReturn: "Buchungszeit abgelaufen, Fahrzeug nicht am Heimatstandort",
	    LblBatteryVoltage: "Batteriespannung",
	    LblCannotUnsubscribe: "Abmelden jetzt nicht möglich, weil der Benutzer eine laufende Buchung hat",
	    LblPer: "Pro",
	    LblDateRegistered: "Registrierungsdatum",
	    LblRegisteredBy: "Registriert durch",
	    LblKMPerHour: "Km/h",
	    LblMeters: "Meter",
	    LblSubscriptionEndOnBookingEnd: "Buchung wird noch für dieses Abonnement ausgeführt. Der Fahrer wird abgemeldet, nachdem die Buchung abgeschlossen ist.",
	    LblMarkedForDeletion: "Zwecks Löschung markiert",
	    LblApplyDateFilter: "Datum Anwendbarkeit",
	    LblNoRestriction: "Keine_Beschränkung",
	    LblCustomAppTestApp: "CUSTOM_APP_UND_TEST_APP",
	    LblCustomAppOnly: "NUR_CUSTOM_APP",
	    LblPrePostTripQuestions: "Fragen für vor und nach der Fahrt",
	    //Customer
	    LblCustomer: "Anbieter",
	    LblCustomerName: "Kundenname",
	    //Role Page
	    LblRoleManagement: "Rolle",
	    LblRoleName: "Rollenname",
	    LblEntityName: "Name Einheit",
	    LblRoleType: "Rollentyp",
	    LblRoleAvailability: "Verfügbarkeit Kundenrollen",
	    LblInternalRoleName: "Interner Rollenname",
	    LblPresentationName: "Präsentationsname",
	    LblDefaultRole: "Standardrolle",
	    LblCustomRole: "Benutzerdefinierte Rolle",
	    LblAddRole: "Rolle hinzufügen",
	    LblEntity: "Einheit",
	    LblCopy: "Kopieren",
	    LblAccessibilityMatrix: "Zugangsmatrix",
	    LblDefaultRoleModifyWarning: "Das Anpassen von Standardrechten wirkt sich auf alle Benutzer mit Standardrolle aus",
	    LblCopyAccessibilityMatrix: "Zugangsmatrix kopieren",
	    LblAccess: "Zugang ",
	    LblCustomerAdmin: "Kundenadmin",
	    LblAdmin: "Admin",
	    LblDoYouWantToRemove: "Möchten Sie %0 als %1 entfernen?",
	    LblDoYouWantToAdd: "Möchten Sie %0 als %1 hinzufügen?",
	    LblRoleAddedSuccess: "%0 %1 erfolgreich hinzugefügt.",
	    LblRoleDeletedSuccess: "%0 erfolgreich aus %1 entfernt.",
	    LblInstanceAdmin: "Instanzadmin",
	    LblInvitationMailSuccess: "Einladungs-E-Mail wurde an die gegebene E-Mail-Adresse gesendet.",
	    LblInvite: "Einladung versenden",
	    LblCreateNew: "Neu erstellen",
	    LblCommonErrorMessage: "Beim Verarbeiten der Anfrage ist ein Serverfehler aufgetreten. Bitte wenden Sie sich an den Administrator.",
	    LblError: "Fehler",
	    LblThankYouForAcceptingInvitation: "Vielen Dank, dass Sie die Einladung angenommen haben.",
	    LblPleaseClick: "Bitte klicken Sie auf",
	    LblHere: "hier",
	    LblToLogin: "Zur Anmeldung",
	    LblThankYouForConfirmation: "Vielen Dank für Ihre Bestätigung.",
	    LblGoToHome: "Zurück auf Startseite",
	    LblInvitationSuccess: "Einladung erfolgreich",
	    LblInvitationReject: "Einladung abgelehnt",
	    LblVehFutureBookingList: "Fahrzeugliste für künftige Buchungen",
	    //
	    LblAssignExisting: "Bestehende zuweisen",
	    LblPersonProfileSuccessMessage: "Ihr Profil wurde erfolgreich aktiviert",
	    LblPlease: "Bitte",
	    LblLogin: "Anmeldung",
	    //Organization
	    LblVatNumber: "MWST-Nummer",
	    //Branding & Template
	    LblBrandingandTemplates: "Branding und Vorlagen",
	    LblTermsAndCondition: "Allgemeine Geschäftsbedingungen",
	    LblTermsAndConditionList: "AGB und Liste Datenschutzerklärung",
	    LblVersion: "Version",
	    LblAcceptance1: "Vor der Kontoaktivierung",
	    LblAcceptanceMoment: "Genehmigungszeitpunkt",
	    LblContents: "Inhaltsverzeichnis",
	    LblIsAccept: "Ich stimme zu",
	    LblReadAndAgree: "Ich habe [...] gelesen und erkläre mich damit einverstanden",
	    LblClose: "Schliessen",
	    LblTermsConditionPrivacy: "AGB und Datenschutzerklärung",
	    LblPrivacyStatements: "Datenschutzerklärung",
	    //Pre Post Trip Setting
	    LblPrePostTripSetting: "Einstellungen Fragen für vor und nach der Fahrt",
	    LblPrePostTripQuestion: "Frage für vor und nach der Fahrt",
	    LblPrePostTripQuestionList: "Frageliste für vor und nach der Fahrt",
	    LblPreTripQuestion: "Fragen für vor der Fahrt",
	    LblCustom: "Kundenspezifisch",
	    LblPostTripQuestion: "Fragen für nach der Fahrt",
	    LblRequired: "Erforderlich",
	    LblBeforeOpeningTheVehicle: "Vor Öffnen des Fahrzeugs",
	    LblAfterOpeningTheVehicle: "Nach Öffnen des Fahrzeugs",
	    LblOrder: "Sortieren",
	    LblQuestion: "Frage",
	    LblOn: "Auf",
	    LblOptional: "Optional",
	    LblOff: "Aus",
	    LblAnswerType: "Antworttyp",
	    LblText: "Text",
	    LblYesNo: "Ja/Nein",
	    LblAnswer: "Antwort",
	    LblTimeStamp: "Zeitstempel",
	    LblFazTripQuestion: "FaZ fragen",
	    LblFazTripQuestionAfterClosingTheVehicle: "FaZ fragen nach Schließen des Fahrzeugs",
	    //Instance Clone
	    'LblInstanceClone': 'Instanz kopieren',
	    'LblNewInstanceName': 'Neuer Instanzname',
	    'LblCloneResult': 'Ergebnis kopieren',
	    'LblCloneStatus': 'Status kopieren',
	    'CloneError': 'Beim Kopieren der Instanz und der entsprechenden Einheiten ist ein Fehler aufgetreten.',
	    //Accessibility Matrix
	    LG_WEB_DASHBOARD: "Web-Dashboard",
	    PR_BOOKING_REQUEST: "Buchungsanfrage",
	    PR_PRE_POST_TRIP_QUESTIONS: "Fragenübersicht für vor und nach der Fahrt",
	    LblApproveBookingRequest: "Genehmigen",
	    LblRejectBookingRequest: "Ablehnen",
	    PR_DASHBOARD: "Dashboard",
	    PR_REMOVE_DRIVER_LICENSE: "Remove Driver License",
	    PR_VEHICLE_FUTURE_BOOKINGS: "Künftige Fahrzeugbuchungen",
	    PR_INSTANCE: "Instanz",
	    PR_BRANDING: "Branding",
	    PR_PERSON_OVERVIEW: "Personenübersicht",
	    PR_WEGO_ADMINS: "WeGo-Admins",
	    PR_COMPANY_OVERVIEW: "Unternehmensübersicht",
	    PR_CONTACT_PERSON: "Ansprechpartner",
	    PR_COMPANY_ADMIN: "Unternehmensadmin",
	    PR_COMPANY_VEHICLE_OVERVIEW: "Übersicht Unternehmensfahrzeuge",
	    PR_COMPANY_SVG_OVERVIEW: "Übersicht Carsharing-Gruppen Unternehmen",
	    PR_ORGANIZATION_OVERVIEW: "Organisationsübersicht",
	    PR_ORGANIZATION_CONTACT_PERSON: "Ansprechpartner Organisation",
	    PR_ORGANIZATION_ADMIN_OVERVIEW: "Übersicht Organisationsadmin",
	    PR_ORGANIZATION_DRIVER_OVERVIEW: "Fahrerübersicht Organisation",
	    PR_SHARED_VEHICLE_GROUP_OVERVIEW: "Übersicht Carsharing-Gruppe",
	    PR_SHARED_VEHICLE_GROUP_ADMIN_OVERVIEW: "Adminübersicht Carsharing-Gruppe",
	    PR_SHARED_VEHICLE_GROUP_VEHICLE_OVERVIEW: "Fahrzeugübersicht Carsharing-Gruppe",
	    PR_SHARED_VEHICLE_GROUP_DRIVER_OVERVIEW: "Fahrerübersicht Carsharing-Gruppe",
	    PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_GROUP_OVERVIEW: "Übersicht Vertragstypengruppe Carsharing-Gruppe",
	    PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_OVERVIEW: "Übersicht Vertragstypen Carsharing-Gruppe",
	    PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW: "Abonnementübersicht Carsharing-Gruppe",
	    PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_AVAILIBILTY_RESTRICTION_OVERVIEW: "Übersicht Verfügbarkeitsbeschränkung Abonnement Carsharing-Gruppe",
	    PR_SPECIAL_PERIODS: "Sonderperioden",
	    PR_VEHICLES_OVERVIEW: "Fahrzeugübersicht",
	    PR_VEHICLE_SVG_OVERVIEW: "Übersicht Carsharing-Gruppen",
	    PR_VTS_VEHICLE_LIST: "VTS-Fahrzeugliste",
	    PR_VTS_TROUBLESHOOT: "VTS-Fehlerbehebung",
	    PR_VEHICLE_ATTRIBUTE_CATEGORIES: "Fahrzeugattributkategorien",
	    PR_VEHICLE_ATTRIBUTE: "Fahrzeugattribut",
	    PR_ODOMETER_LOG_TRAIL: "Historie Kilometerzähler",
	    PR_ODOMETER_LOG_TRAIL_REGISTERED_BY: "Historie Kilometerzähler registriert von",
	    PR_DRIVER_OVERVIEW: "Fahrerübersicht",
	    PR_DRIVER_SHARED_VEHICLE_GROUP_OVERVIEW: "Fahrerübersicht Carsharing-Gruppe",
	    PR_DRIVER_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW: "Abonnementübersicht Fahrer Carsharing-Gruppe",
	    PR_BOOKINGS_OVERVIEW: "Buchungsübersicht",
	    PR_NORMAL_BOOKING: "Neue Buchung",
	    PR_SPECIAL_BOOKING: "Sonderbuchung",
	    PR_TRIP_SIMULATOR: "Fahrtsimulator",
	    PR_INVOICE: "Rechnung",
	    PR_DIRECT_DEBIT_FILE: "Lastschriftdatei",
	    PR_ADDITIONAL_FREE_ITEMS: "Zusätzliche Gratiselemente",
	    PR_TEST_INVOICE_GENERATOR: "Generator Testrechnung",
	    PR_VEHICLE_OCCUPANCY_REPORT: "Fahrzeugbelegungsbericht",
	    PR_REVENUE_PER_VEHICLE_REPORT: "Bericht Erlös pro Fahrzeug",
	    PR_TRIP_DATA_REPORT: "Fahrtdatenbericht",
	    PR_MAINTENANCE_PLANNING_REPORT: "Bericht Wartungsplanung",
	    PR_SANIL_TRAIL_REPORT: "Snail-Trail-Bericht",
	    PR_KICKBACK_REPORT: "Rückerstattungsbericht",
	    PR_INVOICE_PAYMENT_HISTORY: "Verlauf Rechnungszahlung",
	    PR_TEMPLATES: "Vorlagen",
	    PR_SIGNUP_FORMS_OVERVIEW: "Übersicht Registrierungsformulare",
	    PR_SIGNUPS_OVERVIEW: "Registrierungsübersicht",
	    PR_SIGNUP_OVERVIEW_TO_SIGNUP_FORM: "Registrierungsübersicht an Registrierungsformular",
	    PR_SIGNUP_OVERVIEW_TO_SHARED_VEHICLE_GROUP: "Registrierungsübersicht an Carsharing-Gruppe",
	    PR_TERMS_AND_CONDITION: "Allgemeine Geschäftsbedingungen",
	    PR_EVENT_VIEWER: "Ereignisviewer",
	    PR_PRE_POST_TRIP_SETTING: "Einstellungen Fragen für vor und nach der Fahrt",
	    PR_PREPOST_TRIP_QUESTIONS_UPDATE: "Fragen für vor und nach der Fahrt",
	    PR_USER_PROFILE: "Nutzerprofil",
	    LG_CUSTOMER: "Kunde",
	    LG_INSTANCE: "Instanz",
	    LG_BRANDING: "Branding",
	    LG_PERSON: "Person",
	    LG_COMPANY: "Unternehmen",
	    LG_ORGANIZATION: "Organisation",
	    LG_SHARED_VEHICLE_GROUP: "Carsharing-Gruppe",
	    LG_VEHICLE: "Fahrzeug",
	    LG_DRIVER: "Fahrer",
	    LG_BOOKING: "Buchung",
	    LG_INVOICE: "Rechnung",
	    LG_REPORT: "Bericht",
	    LG_TEMPLATE: "Vorlage",
	    LG_SIGNUP_FORM: "Registrierungsformular",
	    LG_EVENT_VIEWER: "Ereignisviewer",
	    LG_PRE_POST_TRIP_SETTING: "Einstellungen Fragen für vor und nach der Fahrt",
	    LG_USER: "Nutzer",
	    LG_BRANDING_AND_TEMPLATE: "Branding und Vorlagen",
	    LG_ROLE: "Rolle",
	    LG_PREPOSTTRIPQUESTION: "Fragen für vor und nach der Fahrt",
	    PR_CUSTOMER_ADMIN_OVERVIEW: "Übersicht Kundenadmin",
	    PR_INSTANCE_ADMIN_OVERVIEW: "Übersicht Instanzadmin",
	    PR_ROLE_OVERVIEW: "Rolle",
	    PR_ROLE_ASSIGN: "Rollenzuweisung",
	    PR_SHARED_VEHICLE_GROUP_ACTIVE_INACTIVE: "Carsharing-Gruppe aktiv oder inaktiv",
	    PR_CUSTOMER_OVERVIEW: "Kunde",
	    PR_ORGANIZATION_SUBSCRIPTION_OVERVIEW: "Abonnementübersicht Organisation",
	    PR_VTS_VEHICLE_EVENT_HISTORY: "VTS-Fahrzeugereignishistorie",
	    PR_BATCH_UPLOAD_PERSON: "Personen gesammelt importieren",
	    PR_IMPORT_PERSON: "Person importieren",
	    PR_PRE_POST_TRIP_QUESTION_UPDATE: "Fragen für vor und nach der Fahrt",
	    LG_REPORTINGTOOL: "Reporting-Tool",
	    PR_BOOKING_OVERVIEW: "Buchungsübersicht",
	    PR_ROBNOTIFICATIONS: "ROB-Übersicht",
	    PR_MILEAGE_OVERVIEW: "Kilometerübersicht",
	    PR_USAGE_OVERVIEW: "Anzahl der nicht genutzten Tage",
	    PR_POSITION_ON_MAP: "Position auf der Karte",
	    PR_VEHICLE_ON_LOCATION_MAP: "Fahrzeug vor Ort",
	    PR_TRIP_OVERVIEW: "Reiseübersicht",
	    PR_ALTERNATE_TRANSPORTATION: "Ersatzfahrzeuge",
	    PR_AVERAGE_OVERVIEW: "Durchschnitte Übersicht",
	    PR_PRE_POST_BOOKING_OVERVIEW: "Fragen vor/nach der Buchung übersicht",
	    PR_HOME_LOCATIONS_OVERVIEW: "Übersicht über Fahrzeug- und SVG-Heimstandorte",
	    LblPrivacyErrorMessage: "Sie sind nicht dazu berechtigt, diese Seite aufzurufen",
	    LblPrivacyNavigate: "Bitte navigieren Sie zu",
	    LblPrivacyError: "Datenschutzfehler",
	    LblLinkExpired: "Link abgelaufen",
	    LblLinkExpiredMessage: "Der Link ist abgelaufen und kann nicht mehr genutzt werden. Bitte versuchen Sie es erneut.",
	    LblBearer: "Inhaber",
	    LblWhoBenifitFreeItem: "Wer profitiert von Abonnementguthaben?",
	    LblNoDistinction: "Standard (keine Unterscheidung)",
	    LblSendInvoiceToOrganization: "Rechnung an Organisation senden",
	    //Vat Setting
	    LblVatSettings: "MWST-Einstellungen",
	    LblVatPercentages: "MWST-Satz",
	    LblDefaultCost: "Kosten automatisch anzeigen und bearbeiten",
	    LblExcludingVat: "Exklusive MWST",
	    LblIncludingVat: "Inklusive MWST",
	    LblVatEnterDescription: "Beschreibung eingeben",
	    LblEnterVatPercentage: "MWST in % eingeben",
	    LblVatPercentageError: "Bitte geben Sie einen gültigen Prozentsatz ein",
	    LblVatDescriptionError: "Bitte geben Sie eine gültige Beschreibung ein",
	    LblVatStartDate: "Startdatum",
	    LblVatStartDateError: "Bitte Startdatum wählen",
	    LblVatEndDate: "Enddatum",
	    LblVatDeleteConfirmation: "Möchten Sie dieses MWST-Enddatum wirklich festlegen?",
	    LblVatEndDateError: "Bitte geben Sie das MWST-Enddatum ein",
	    LblVatEndDateNote: "Hinweis: Daten werden ab dem gewählten Datum ausgeschlossen",
	    LblDefaultVatContractTypeGroupCost: "MWST in % für Vertragstypen-Gruppenkosten",
	    LblDefaultVatContractTypeCost: "MWST in % für Vertragstypkosten",
	    LblDefaultVatSubscriptionCost: "MWST in % für Abonnementkosten",
	    LblPenaltyCost: "Strafkosten",
	    LblTimeRates: "Zeittarife",
	    LblDistanceRates: "Distanztarife",
	    LblFixedRates: "Feste Tarife",
	    LblSubscriptionCost: "Abonnementkosten",
	    LblPenaltyVat: "Strafe MWST",
	    LblTimeRateVat: "Zeittarif MWST",
	    LblMileageRateVat: "Kilometergeld MWST",
	    LblFixedFeeVat: "Fixgebühr MWST",
	    LblExpenseAmountVat: "Betrag Ausgaben MWST",
	    // template
	    LblEmailTemplate: "E-Mail-Vorlage",
	    LblWebTemplate: "Webvorlage",
	    LblEmailAddressesEntryPattern: "E-Mail-Adressen durch Komma getrennt (Beispiel: ex1@ex.com, ex2@ex.com)",
	    LblNoRecipientWarning: "Keine Empfänger verfügbar. Standardempfänger sind Empfänger dieser Vorlage.",
	    LblStartDate: "Startdatum",
	    LblChamberOfCommerce: "Handelskammer",
	    LblInvoicingSettings: "Einstellungen Rechnungsstellung",
	    LblInvoiceSender: "Rechnungsabsender",
	    LblCostAndExpenses: "Kosten und Ausgaben",
	    LblSender: "Absender",
	    LblAddressee: "Empfänger",
	    LblAddLine: "Zeile hinzufügen",
	    LblSaveInvoice: "Rechnung speichern",
	    LblVatAmount: "Betrag MWST",
	    LblBookingId: "Buchungs-ID",
	    LblReceiptOrSuppor: "Beleg oder Support",
	    LblVATPercentage: "MWST-Satz",
	    LblChargeTo: "Aufladen bis",
	    LblReimburseTo: "Rückerstattung an",
	    LblReportedBy: "Gemeldet von",
	    LblReportedAmount: "Gemeldeter Betrag",
	    LblApprovedAmount: "Genehmigter Betrag",
	    LblCostType: "Kostenart",
	    LblRecipient: "Empfänger",
	    LblName: "Name",
	    LblCostDetail: "Kostendetails",
	    LblAddExisting: "Vorhandene hinzufügen",
	    LblReceiptOrSupport: "Beleg oder Support",
	    LblManualInvoiceLine: "Manuelle Rechnungszeile",
	    LblInvoiceLine: "Rechnungszeile",
	    LblInvoice: "Rechnung",
	    LblInvoiceLines: "Rechnungszeilen",
	    LblSendInvoice: "Rechnung versenden",
	    LblInvoiceSent: "Rechnung versendet",
	    LblAddNewInvoiceLine: "Neue Rechnungszeile hinzufügen",
	    LblSelectUnprocessedExpenses: "Wählen Sie unverarbeitete Ausgaben",
	    LblSelectAtLeastOneExpense: "Bitte wählen Sie mindestens eine Ausgabe",
	    LblInvoicePaymentHistory: "Verlauf Rechnungszahlung",
	    LblPaymentMode: "Zahlungsart",
	    LblLogTime: "Protokollierungszeit",
	    LblNoPaymentLinkGenerated: "Kein Zahlungslink generiert",
	    //Payment
	    LblAllowPaymentConfiguration: "Zahlungskonfiguration zulassen",
	    LblAllowPayment: "Zahlung zulassen",
	    LblPaymentSetting: "Einstellungen Zahlungsanbieter",
	    LblEnvironment: "Umgebung",
	    LblInvoicePaymentTermDays: "Rechnungszahlungsbedingungen Tage",
	    LblLinkValidityDays: "Linkgültigkeit in Tagen",
	    LblPaymentMethods: "Zahlungsmethoden",
	    LblPaymentConfig: "Zahlungskonfiguration",
	    LblPaymentConfigButton: "Zahlungskonfiguration",
	    LblPaymentProvider: "Zahlungsanbieter",
	    LblCountry: "Land",
	    LblEmailAddress: "E-Mail-Addresse",
	    LblPaymentProviderSecretKey: "Geheimer Schlüssel des Anbieters",
	    LblPaymentProviderUsername: "Benutzername Anbieter (key)",
	    LblCreditCardPayment: "Kreditkartenzahlung",
	    LblInitialPayment: "Anzahlung",
	    LblCreateBookingPayment: "Buchungszahlung erstellen",
	    LblStartBookingPayment: "Buchungszahlung starten",
	    LblPaymentLink: "Zahlungslink",
	    LblPaymentHistory: "Zahlungsverlauf",
	    LblReasonOrganization: "Grund für die Blockierung der Organisation",
	    LblDueDateUpdateSuccess: "Fälligkeitsdatum erfolgreich aktualisiert",
	    LblDueDateRequiredError: "Bitte wählen Sie das Fälligkeitsdatum",
	    LblDueDate: "Fälligkeitsdatum",
	    LblConfirmDuedatechange: "Möchten Sie das Fälligkeitsdatum wirklich aktualisieren?",
	    LblConfirmCloseInvoice: "Möchten Sie die Rechnung wirklich schliessen?",
	    LblConfirmReOpenInvoice: "Möchten Sie die Rechnung wirklich erneut öffnen?",
	    LblInvoiceOpenCloseSuccess: "Rechnung %0 erfolgreich",
	    LblReOpen: "Erneut öffnen",
	    LblClosed: "Geschlossen",
	    LblReOpenClose: "Erneut öffnen/Schliessen",
	    PR_COST_EXPENSES: "Kosten und Ausgaben",
	    PR_COST_CENTER_REPORT: "Kostenstellenbericht",
	    LblReportedOn: "Gemeldet am",
	    LblInactiveAfterDays: "Inaktiv nach (Tagen)",
	    LblMarkDeleteAfterDays: "Markierung löschen nach (Tagen)",
	    LblNotifyAdminBeforeDays: "Admin vor Ablauf von (Tagen) benachrichtigen",
	    LblGdprSettings: "DSGVO-Einstellungen",
	    LblRemovalDate: "Entfernungsdatum",
	    LblRemovePersonOn: "Person entfernen am",
	    PR_PAYMENT_HISTORY_LIST: "Zahlungsverlauf",
	    LblUserBlockMessage: "Nachricht bei Benutzerblockung",
	    PR_BLOCK_UNBLOCK_ORGANIZATION: "Organisation blocken/entsperren",
	    LblWhenOpeningAppAndRepeat: "Beim ersten Öffnen der App und anschliessend alle",
	    LblEveryTimeOpenApp: "Jedes Mal, wenn die App geöffnet wird",
	    LblWhenMakeBooking: "Beim Erstellen einer Buchung",
	    LblWhenStartBooking: "Beim Start einer Buchung",
	    LblWhenOpenBooking: "Beim Öffnen eines Fahrzeugs",
	    LblSelectContractTypeGroup: "Bei der Auswahl einer bestimmten Vertragsartgruppe/bestimmter Vertragsartgruppen",
	    LblDays: "Tage",
	    LblNewVersion: "Neue Version",
	    LblAction: "Aktion",
	    LblTAndCName: "AGB-Name",
	    LblOldVersion: "Alte Version",
	    LblSureToRevoke: "Möchten Sie %0 wirklich widerrufen?",
	    LblCurrencyConfiguration: "Währungskonfiguration",
	    LblNameSingular: "Name Singular",
	    LblNamePlural: "Name Plural",
	    //Special Period
	    LblRegularBooking: "Regelmässige Buchung",
	    LblSpecialRate: "Sondertarif",
	    LblFirstDay: "Erster Tag",
	    LblLastDay: "Letzter Tag",
	    LblWeekEndContaining: "Wochenende mit",
	    //Credit card payment
	    LblCrediCardPayment: "Kreditkartenzahlung",
	    LblFirstBooking: "Erstbuchung",
	    LblAllowRecurringPayment: "Kreditkarte autorisieren",
	    LblProceed: "Fortsetzen",
	    LblCheckAllowPayment: "Bitte wiederkehrende Zahlung prüfen",
	    LblPaymentFailed: "Kreditkarte autorisieren",
	    LblPaymentSuccess: "Autorisierung erfolgreich",
	    LblPaymentFailure: "Autorisierung fehlgeschlagen",
	    LblCompletedSuccess: "Ihre Autorisierung wurde erfolgreich bearbeitet",
	    LblCompletedFailure: "Ihre Autorisierung ist fehlgeschlagen. Bitte gehen Sie zurück und versuchen Sie es erneut.",
	    LblCreditCardNumber: "Kreditkartennummer",
	    LblCreditCardExpirationDate: "Verfalldatum Kreditkarte",
	    LblCreditCardDetails: "Kreditkartendetails",
	    LblMakePayment: "Kreditkarte autorisieren",
	    LblAdminPaymentConfirmation: "Es liegt keine aktive Autorisierung vor oder die Zahlung ist fehlgeschlagen. Möchten Sie fortfahren?",
	    LblPaymentDescription: "Um ein Fahrzeug zu buchen, ist eine Verifizierungszahlung von %0 erforderlich. Darüber hinaus ist die Genehmigung erforderlich, zukünftige Zahlungen von Ihrer Kreditkarte abzuziehen. Zahlungen werden von unserem Zahlungsanbieter Buckaroo bearbeitet. Sie werden für die Zahlung auf die Website von Buckaroo weitergeleitet.",
	    LblPay: "Bezahlen",
	    LblWeGoDefault: "WeGo Standard",
	    LblPersonActiveSuccess: "Person erfolgreich aktiviert",
	    LblActivate: 'Aktivieren',
	    LblSignBeforeAmount: "Währungssymbol vor Betrag",
	    LblOutOf: 'Aus',
	    LblByOrganization: "Nach Organisation",
	    // NIF Number
	    LblEnableNIFNumber: "NIF-Nummer aktivieren",
	    LblNIFNumber: "NIF-Nummer",
	    LblDefaultLanguage: 'Standardsprache',
	    LblRestoreInheritConfirmation: "Die aktuellen Einstellungen werden von den geerbten Einstellungen überschrieben. Möchten Sie wirklich?",
	    LblQestionTextRequired: "Fragentext erforderlich",
	    LblManualSecretKey: "Geheimer Schlüssel",
	    // Two Factor Authentication
	    LblTwoFaConfig: "Zwei-Faktor-Authentifizierung",
	    LblEnableTwoFa: "Aktivieren Sie die Zwei-Faktor-Authentifizierung",
	    LblExpirationDays: "Verfallstage",
	    LblTextBoxExpirationDays: "Verfallstage",
	    Lbl2FactorAuthenticateExpDays: "2FA Verfallszeit (Tage):",
	    LblResetCookiesWegoAdmin: "Setzen Sie die Cookies für alle WeGo-Admin zurück",
	    LblReset2FactorAuthWegoAdmin: "Setzen Sie alle 2FA für alle WeGo-Admin zurück",
	    LblAuthentication: "Authentifizierung",
	    LblResetCookiesForAllAdmin: "Setzen Sie die Cookies für alle Admin zurück",
	    LblReset2FaForAllAdmin: "Setzen Sie 2FA für alle Admin zurück",
	    LblEnterTotp: "Bitte geben Sie den Code ein",
	    LblEnterOtp: "Bitte geben Sie den Code ein",
	    LblSubmit: "Einreichen",
	    LblKeyResetSuccess: "2FA-Schlüssel wurde zurückgesetzt",
	    LblKeyResetFailed: "2FA-Schlüsselrücksetzung fehlgeschlagen",
	    LblCookieResetSuccess: "2FA-Cookies wurden zurückgesetzt",
	    LblCookieResetFailed: "Das Zurücksetzen der 2FA-Cookies ist fehlgeschlagen",
	    LblGoogleAuthenticator: "Google Authenticator App",
	    LblEmailOtpSent: "Ein Code wurde an Ihre registrierte E-Mail-Adresse gesendet",
	    LblContinue: "Fortsetzen",
	    LblInvalidTOTP: "Ungültiger Code",
	    LblResetCookie: "Cookie zurücksetzen",
	    LblResetTwoFA: "2FA zurücksetzen",
	    LblDisableTwoFA: "Deaktivieren Sie 2FA",
	    LblTwoFaMethod: "2FA-Methode",
	    LblEmailAuthentication: "E-Mail-Authentifikation",
	    LblTwoFaMethodSelect: "Sie müssen Ihre Identität noch einmal überprüfen. Bitte wählen Sie Ihre 2FA-Methode",
	    LblInvoicePreFix: "Präfix der Rechnungsnummer",
	    LblEngineStillRunning: 'Verriegelungsbefehl wurde gesendet, während der Motor lief',
	    LblMobileAppLink: "Mobile App Link",
	    // License Check Configuration
	    LblLicenseCheckConfiguration: "Konfiguration der Lizenzprüfung",
	    LblValidateLicenseCheckForBooking: "Überprüfen vor Buchung",
	    // Access Cards Enabled SVG
	    LblAccessCardsEnabled: "Zugangskarte nutzung",
	    // Track & Trace
	    LblTrackAndTrace: "Track & Trace",
	    LblRfidTagId: "RFID Tag ID",
	    LblEmployeeNumber: "Mitarbeiternummer",
	    BtnAddVehicleInfo: "Mit Vts Log",
	    // Access Card
	    LblAccessCardId: "Access Card ID",
	    LblDriversLicenseAndCertificates: "Führerschein und Zertifikate",
	    LblLicense: "Führerschein",
	    LblCertificates: "Zertifikate",
	    LblTrips: "Fahrten",
	    LblCostsSummary: "Buchungskosten",
	    LblStartBooking: "Buchung starten",
	    LblStopBooking: "Buchung abbrechen",
	    LblTripHistory: "Fahrgeschichte",
	    LblTripStartDateTime: "Ab",
	    LblTripEndDateTime: "Bis",
	    LblFaZTripQuestions: "FaZ-Fragen",
	    LblNoQuestionsFound: "Keine FaZ-Fragen gefunden.",
	    LblTripDetails: "Fahrt details",
	    LblNoTripsFound: "Keine Fahrten gefunden",
	    LblUnansweredQuestions: "Unbeantwortete Fragen",
	    LblNoUnansweredQuestions: "Keine unbeantwortete Fragen",
	    LblAnswerSaved: "Die Antwort wurde erfolgreich gespeichert",
	    LblAnswerSavedError: "Die Antwort konnte nicht gespeichert werden. Bitte wenden Sie sich an den Administrator",
	    LblAnswerEmptyError: "Bitte geben Sie eine gültige Antwort ein",
	    LblLoginError: "Beim Einloggen ist ein unbekannter Fehler aufgetreten",
	    LblLoginCredentialsError: "Dieser Benutzername oder dieses Passwort ist falsch, bitte überprüfen Sie es und versuchen Sie es erneut",
	    ValidatePhoneNumberVts: "Bitte geben Sie eine gültige Telefonnummer ein (zum Beispiel +31623456789)",
	    LblInfo: "Info",
	};


/***/ },
/* 75 */
/***/ function(module, exports) {

	// https://scotch.io/tutorials/simple-language-translation-in-angular-2-part-2
	"use strict";
	// lang-es.ts
	// 'hello world': 'hello world',
	// 'hello greet': 'Hello, %0 %1!',
	// 'well done': 'Well done %0',
	// 'good bye': 'bye bye',
	exports.LANG_ES_NAME = "es";
	exports.LANG_ES_TRANS = {
	    LblWeekdays: {
	        shorthand: ["LSu", "LMo", "LTu", "LWe", "LTh", "LFr", "LSa"],
	        longhand: [
	            "LSunday",
	            "LMonday",
	            "LTuesday",
	            "LWednesday",
	            "LThursday",
	            "LFriday",
	            "LSaturday"
	        ]
	    },
	    LblMonths: {
	        shorthand: [
	            "LJan",
	            "LFeb",
	            "LMar",
	            "LApr",
	            "LMay",
	            "LJun",
	            "LJul",
	            "LAug",
	            "LSep",
	            "LOct",
	            "LNov",
	            "LDec"
	        ],
	        longhand: [
	            "LJanuary",
	            "LFebruary",
	            "LMarch",
	            "LApril",
	            "LMay",
	            "LJune",
	            "LJuly",
	            "LAugust",
	            "LSeptember",
	            "LOctober",
	            "LNovember",
	            "LDecember"
	        ]
	    },
	    LblButtonText: {
	        today: "LblToday",
	        month: "LblMonth",
	        week: "LblWeek",
	        day: "LblDay",
	        list: "LblList"
	    },
	    // Common Name
	    LblEdit: "LblEdit",
	    LblDelete: "LblDelete",
	    LblRemove: "LblRemove",
	    LblActiveInactive: "LblActiveInactive",
	    LblActive: "LblActive",
	    LblInactive: "LblInactive",
	    LblInactiveReason: "LblInactiveReason",
	    LblActivityLog: "LblActivityLog",
	    LblAddNew: "LblAddNew",
	    LblAdd: "LblAdd",
	    LblUpdate: "LblUpdate",
	    LblSave: "LblSave",
	    LblCancel: "LblCancel",
	    LblReset: "LblReset",
	    LblSelect: "LblSelect",
	    LblSuccess: "LblSuccess",
	    LblWarning: "LblWarning",
	    LblList: "LblList",
	    LblAssign: "LblAssign",
	    LblHome: "LblHome",
	    LblYes: "LblYes",
	    LblOK: "LblOK",
	    LblNo: "LblNo",
	    LblBack: "LblBack",
	    LblReason: "LblReason",
	    LblApprovalAdminName: "LblApprovalAdminName",
	    LblRecordSavedSuccess: "LblRecordSavedSuccess",
	    LblRecordDeleteSuccess: "LblRecordDeleteSuccess",
	    LblResetPasswordSuccess: "LblResetPasswordSuccess",
	    LblConfirm: "LblConfirm",
	    LblBlockUnblockConfirm: "LblBlockUnblockConfirm",
	    LblRecordDeleteConfirmation: "LblRecordDeleteConfirmation",
	    LblRecordMultiplDeleteConfirmation: "LblRecordMultiplDeleteConfirmation",
	    LblConfirmMessage: "LblConfirmMessage",
	    LblResetPassword: "LblResetPassword",
	    LblResetPasswordConfirmation: "LblResetPasswordConfirmation",
	    LblGeoLocationError: "LblGeoLocationError",
	    LblPersonDeleteCheck: "LblPersonDeleteCheck",
	    LblBookingCancelSuccess: "LblBookingCancelSuccess",
	    LblBookingAbortSuccess: "LblBookingAbortSuccess",
	    LblBookingRevokeSuccess: "LblBookingRevokeSuccess",
	    LblContactPersonRemoveSuccess: "LblContactPersonRemoveSuccess",
	    LblContactPersonAddedSuccess: "LblContactPersonAddedSuccess",
	    LblNoRecords: "LblNoRecords",
	    LblAffectedBookingList: "LblAffectedBookingList",
	    LblSubscriptionEndDateError: "LblSubscriptionEndDateError",
	    LblIsSpecialPeriodAllow: "LblIsSpecialPeriodAllow",
	    LblContractSlotisnotdefined: "LblContractSlotisnotdefined",
	    LblUnscubscribeSuccess: "LblUnscubscribeSuccess",
	    LblModifiedBy: "LblModifiedBy",
	    LblModifiedDate: "LblModifiedDate",
	    LblContractTypeGroupAvailableForSubscription: "LblContractTypeGroupAvailableForSubscription",
	    LblRemoveContactPersonConfirm: "LblRemoveContactPersonConfirm",
	    LblBookingApproveRejectSuccess: "LblBookingApproveRejectSuccess",
	    LblRecordAddedSuccess: "LblRecordAddedSuccess",
	    LblRecordUpdatedSuccess: "LblRecordUpdatedSuccess",
	    LblRecordRemovedSuccess: "LblRecordRemovedSuccess",
	    LblRecordActiveInActiveSuccess: "LblRecordActiveInActiveSuccess",
	    LblinvoiceResendSuccess: "LblinvoiceResendSuccess",
	    LblRecordBlokUnBlockSuccess: "LblRecordBlokUnBlockSuccess",
	    LblEditPage: "LblEditPage",
	    LblAddPage: "LblAddPage",
	    LblListPage: "LblListPage",
	    LblKilometers: "LblKilometers",
	    LblKM: "LblKM",
	    //'LblRecordUnBlockedSuccess':'unBlocked successfully',
	    //MobileApp Configuration
	    LblMobileAppConfiguration: "LblMobileAppConfiguration",
	    LblEnableNewBooking: "LblEnableNewBooking",
	    LblEnableBookingCalender: "LblEnableBookingCalender",
	    LblEnableSubscription: "LblEnableSubscription",
	    LblEnableUpdateProfile: "LblEnableUpdateProfile",
	    LblEnableNotification: "LblEnableNotification",
	    LblEnableChangeBooking: "LblEnableChangeBooking",
	    LblEnableAddExpenseMenu: "LblEnableAddExpenseMenu",
	    //Instance Clone
	    LblInstanceClone: "LblInstanceClone",
	    LblNewInstanceName: "LblNewInstanceName",
	    LblCloneResult: "LblCloneResult",
	    LblCloneStatus: "LblCloneStatus",
	    CloneError: "CloneError",
	    //Booking Type
	    LblNORMALBOOKINGTYPE: 'LblNORMALBOOKINGTYPE',
	    LblMAINTENANCEBOOKINGTYPE: 'LblMAINTENANCEBOOKINGTYPE',
	    LblUNAVAILABLEBOOKINGTYPE: 'LblUNAVAILABLEBOOKINGTYPE',
	    //Booking Request Status
	    LblAPPROVEDBOOKINGREQUEST: 'LblAPPROVEDBOOKINGREQUEST',
	    LblREJECTEDBOOKINGREQUEST: 'LblREJECTEDBOOKINGREQUEST',
	    LblPENDINGBOOKINGREQUEST: 'LblPENDINGBOOKINGREQUEST',
	    //Booking Status
	    LblABORTED: 'LblABORTED',
	    LblCANCELLED: 'LblCANCELLED',
	    LblCONFIRMED: 'LblCONFIRMED',
	    LblFINISHED: 'LblFINISHED',
	    LblNOSHOW: 'LblNOSHOW',
	    LblPENDING: 'LblPENDING',
	    LblREVOKED: 'LblREVOKED',
	    LblRUNNING: 'LblRUNNING',
	    LblREADYFORPAYMENT: 'LblREADYFORPAYMENT',
	    //Invoice Status
	    LblOPEN: 'LblOPEN',
	    LblSENT: 'LblSENT',
	    LblCLOSED: 'LblCLOSED',
	    LblREQUESTFORPAYMENT: 'LblREQUESTFORPAYMENT',
	    LblREOPEN: 'LblREOPEN',
	    // Error Log
	    LblErrorLog: "LblErrorLog",
	    LblComponentName: "LblComponentName",
	    LblLogType: "LblLogType",
	    LblEventDateTime: "LblEventDateTime",
	    //ErrorEscalation
	    LblDuplicateErrorEscalation: "LblDuplicateErrorEscalation",
	    LblErrorEscalation: "LblErrorEscalation",
	    LblComponent: "Component",
	    LblSelectAdminLevel: "LblSelectAdminLevel",
	    LblWegoAdminLevel: "LblWegoAdminLevel",
	    LblCustomerAdminLevel: "LblCustomerAdminLevel",
	    LblInstanceAdminLevel: "LblInstanceAdminLevel",
	    // Interface Status
	    LblInterfaceStatus: "LblInterfaceStatus",
	    LblLastStatusChangeDateTime: "LblLastStatusChangeDateTime",
	    LblWegoAdminDependencyValidation: "Wego Admin Can not be deleted because it is associated with other entity.",
	    LblLastCarwisePollDateTime: "LblLastCarwisePollDateTime",
	    LblUpdatedDateTime: "LblUpdatedDateTime",
	    LblMonitoring: "LblMonitoring",
	    LblEnableLogin: "LblEnableLogin",
	    LblEnableErrorEscalation: "LblEnableErrorEscalation",
	    LblErrorEscalationMinutes: "LblErrorEscalationMinutes",
	    //Instance Page
	    LblCarwiseEnable: "LblCarwiseEnable",
	    LblAdminDependencyValidationOnDelete: "LblAdminDependencyValidationOnDelete",
	    LblAdminDependencyValidation: "LblAdminDependencyValidation",
	    LblAdminDependencyAlert: "LblAdminDependencyAlert",
	    LblCarwiseConfiguration: "LblCarwiseConfiguration",
	    LblCarwiseConnectionUrl: "LblCarwiseConnectionUrl",
	    LblCarwiseConnectionUsername: "LblCarwiseConnectionUsername",
	    LblCarwiseConnectionPassword: "LblCarwiseConnectionPassword",
	    LblCarwiseAutoDeleteFrequencyInDays: "LblCarwiseAutoDeleteFrequencyInDays",
	    LblDamageImageExtentions: "LblDamageImageExtentions",
	    LblInstance: "LblInstance",
	    LblInstanceName: "LblInstanceName",
	    LblInstanceType: "LblInstanceType",
	    LblDescription: "LblDescription",
	    LblCurrencySymbol: "LblCurrencySymbol",
	    LblPreferredLanguage: "LblPreferredLanguage",
	    LblTimeZone: "LblTimeZone",
	    LblCurrencyAbbreviation: "LblCurrencyAbbreviation",
	    LblInstanceDeleteValidation: "LblInstanceDeleteValidation",
	    LblIsBookingApprovalReq: "LblIsBookingApprovalReq",
	    LblInstanceConfiguration: "LblInstanceConfiguration",
	    LblBookingAlertTime: "LblBookingAlertTime",
	    LblBookingCancelTime: "LblBookingCancelTime",
	    LblBookingTemporaryTime: "LblBookingTemporaryTime",
	    LblVtsRequestTimeout: "LblVtsRequestTimeout",
	    LblVtsTripLogTimeout: "LblVtsTripLogTimeout",
	    LblEmailConfiguration: "LblEmailConfiguration",
	    LblInSeconds: "LblInSeconds",
	    LblFromEmail: "LblFromEmail",
	    LblHost: "LblHost",
	    LblPort: "LblPort",
	    LblEnableSsl: "LblEnableSsl",
	    LblSmtpEmail: "LblSmtpEmail",
	    LblBookingCancelTimeMessage: "LblBookingCancelTimeMessage",
	    LblBookingTemporaryTimeMessage: "LblBookingTemporaryTimeMessage",
	    LblVtSRequestTimeoutMessage: "LblVtSRequestTimeoutMessage",
	    LblVtsTriplogTimeoutMessage: "LblVtsTriplogTimeoutMessage",
	    LblContractTypeDeleteValidation: "LblContractTypeDeleteValidation",
	    LblSelectFuelType: "LblSelectFuelType",
	    LblSelectPricingCatagory: "LblSelectPricingCatagory",
	    LblSelectBodyStyle: "LblSelectBodyStyle",
	    LblSelectVehicleClass: "LblSelectVehicleClass",
	    LblIsImportPersonAllow: "LblIsImportPersonAllow",
	    LblValidateLiceanceNumber: "LblValidateLiceanceNumber",
	    LblGeofenceLocation: "LblGeofenceLocation",
	    LblRadius: "LblRadius",
	    LblEmailRecepients: "LblEmailRecepients",
	    LblRecepients: "LblRecepients",
	    LblEmailAddresses: "LblEmailAddresses",
	    LblMap: "LblMap",
	    // AFAS/Azure Config
	    LblImportConfiguration: "Import Configuration",
	    LblImportConnectionType: "Connection Type",
	    LblAfas: "AFAS",
	    LblAzure: "Azure",
	    LblAzureTenantId: "Azure Tenant ID",
	    LblAzureClientId: "Azure Client ID",
	    LblAzureClientSecret: "Azure Client Secret",
	    LblAfasClientId: "AFAS Client ID",
	    LblAfasConnectorName: "AFAS Connector Name",
	    LblAfasConnectionType: "AFAS Connection Type",
	    LblAfasTest: "Test",
	    LblAfasAccept: "Acceptation",
	    LblAfasProduction: "Production",
	    LblAfasToken: "AFAS Token",
	    LblAfasClientIdError: "Please enter AFAS Client ID",
	    LblAfasConnectorNameError: "Please enter AFAS Client ID",
	    LblAfasConnectionTypeError: "Please enter AFAS Connection Type",
	    LblAfasTokenError: "Please enter AFAS-Token",
	    LblAzureTenantIdError: "Please enter Azure Tenant ID",
	    LblAzureClientIdError: "Please enter Azure Client ID",
	    LblAzureClientSecretError: "Please enter Azure Client Secret",
	    // SSO Config
	    LblSsoConfiguration: "SSO Configuration",
	    LblDefaultSsoSharedVehicleGroup: "Default Shared Vehicle Group",
	    LblDefaultSsoOrganization: "Default Organization",
	    LblDefaultSsoSubscription: "Default Subscription",
	    // Dropoff Message
	    LblDropoffMessageConfiguration: "Dropoff Message Configuration",
	    LblDropoffMessageExternalUrl: "External Url",
	    LblDropoffMessageApiKey: "Api Key",
	    LblDropoffMessageActive: "Active",
	    LblValidate: "LblValidate",
	    LblBookingCalanderSettings: "LblBookingCalanderSettings",
	    LblShowDriverInfo: "LblShowDriverInfo",
	    LblOrganizationAdmin: "LblOrganizationAdmin",
	    LblDriverInfoToShow: "LblDriverInfoToShow",
	    //Person Page
	    LblUserName: "LblUserName",
	    LblFirstName: "LblFirstName",
	    LblLastName: "LblLastName",
	    LblEmail: "LblEmail",
	    LblMobileNumber: "LblMobileNumber",
	    LblPhoneNumber: "LblPhoneNumber",
	    LblHomeAddress: "LblHomeAddress",
	    LblWorkAddress: "LblWorkAddress",
	    LblHouseNo: "LblHouseNo",
	    LblHouseExtention: "LblHouseExtention",
	    LblStreetName: "LblStreetName",
	    LblCity: "LblCity",
	    LblZipCode: "LblZipCode",
	    LblPassword: "LblPassword",
	    LblConfirmPassword: "LblConfirmPassword",
	    LblMiddleName: "LblMiddleName",
	    LblMandateId: "LblMandateId",
	    LblMandateSignatureDate: "LblMandateSignatureDate",
	    LblIsAmmandment: "LblIsAmmandment",
	    LblRemovePersonDetails: "LblRemovePersonDetails",
	    //Company Page
	    LblCompany: "LblCompany",
	    LblCompanyName: "LblCompanyName",
	    LblContactPerson: "LblContactPerson",
	    LblCompanyAdmin: "LblCompanyAdmin",
	    LblCompanyAddress: "LblCompanyAddress",
	    LblInternalOrganization: "LblInternalOrganization",
	    LblNoOfVegicles: "LblNoOfVegicles",
	    LblNoOfSharedVehicleGroups: "LblNoOfSharedVehicleGroups",
	    LblGeoLocation: "LblGeoLocation",
	    LblSelectGeoLocation: "LblSelectGeoLocation",
	    LblPerson: "LblPerson",
	    LblRole: "LblRole",
	    LblDateOfBirth: "LblDateOfBirth",
	    LblDriverLicenceNumber: "LblDriverLicenceNumber",
	    LblApkExiprationSetting: "LblApkExiprationSetting",
	    LblApkTimeInterval: "LblApkTimeInterval",
	    LblEmailNotification: "LblEmailNotification",
	    LblNotificationFrequency: "LblNotificationFrequency",
	    lblThresholdFrequency: "lblThresholdFrequency",
	    lblThresholdTimeInterval: "lblThresholdTimeInterval",
	    LblIsEmailEnabled: "LblIsEmailEnabled",
	    lblThreshold: "lblThreshold",
	    LblFrequency: "LblFrequency",
	    LblDay: "LblDay",
	    LblWeek: "LblWeek",
	    LblMonth: "LblMonth",
	    lblPerBooking: "lblPerBooking",
	    LblPersons: "LblPersons",
	    LblPersonOverview: "LblPersonOverview",
	    LblCompanies: "LblCompanies",
	    //Vehicle Page
	    LblVehicle: "LblVehicle",
	    LblVtsVehicle: "LblVtsVehicle",
	    LblFleetId: "LblFleetId",
	    LblContractId: "LblContractId",
	    LblVIN: "LblVIN",
	    LblLicenceTag: "LblLicenceTag",
	    LblLicence: "LblLicence",
	    LblMobile: "LblMobile",
	    LblVehicleOwner: "LblVehicleOwner",
	    LblLocationDataExchange: "LblLocationDataExchange",
	    LblBrand: "LblBrand",
	    LblType: "LblType",
	    LblColor: "LblColor",
	    LblVehicleClass: "LblVehicleClass",
	    LblPricingCategory: "LblPricingCategory",
	    LblBodyStyle: "LblBodyStyle",
	    LblAvailable: "LblAvailable",
	    LblUnAvailable: "LblUnAvailable",
	    LblAvailableFrom: "LblAvailableFrom",
	    LblAvailableTo: "LblAvailableTo",
	    LblFuelType: "LblFuelType",
	    LblMinBookingTimeBefore: "LblMinBookingTimeBefore",
	    LblMinBookingTimeAfter: "LblMinBookingTimeAfter",
	    LblTowbar: "LblTowbar",
	    LblAirco: "LblAirco",
	    LblVehicleAttributes: "LblVehicleAttributes",
	    LblBlockUnBlock: "LblBlockUnBlock",
	    LblRemoveLicense: "LblRemoveLicense",
	    LblLicenseBirthDate: "LblLicenseBirthDate",
	    LblRemoveLicenseBirthDate: "LblRemoveLicenseBirthDate",
	    LblBlock: "LblBlock",
	    LblUnblock: "LblUnblock",
	    LblAvailableUnAvailable: "LblAvailableUnAvailable",
	    LblVehicles: "LblVehicles",
	    LblBookingsOverview: "LblBookingsOverview",
	    LblApkExpirationDateCet: "LblApkExpirationDateCet",
	    LblEnabled: "LblEnabled",
	    LblDisabled: "LblDisabled",
	    LblIntialOdometerValue: "LblIntialOdometerValue",
	    LblFuelCardPinCode: "LblFuelCardPinCode",
	    //WEGO2DEV-325(Settings for Dashboard statuses)
	    LblVehicleOnSameLocationTime: "LblVehicleOnSameLocationTime",
	    LblNoBookingIn: "LblNoBookingIn",
	    lblHour: "lblHour",
	    //'lblInterval':'HOUR/DAY/WEEK/MONTH',
	    lblHourDayWeekMonth: "lblHourDayWeekMonth",
	    //SharedVehicleGroup
	    LblSharedVehicleGroup: "LblSharedVehicleGroup",
	    LblVehicleGroup: "LblVehicleGroup",
	    LblSharedVehicleGroupAdmin: "LblSharedVehicleGroupAdmin",
	    LblDisplayPeriod: "LblDisplayPeriod",
	    LblBookingWeekDays: "LblBookingWeekDays",
	    LblBookingInterval: "LblBookingInterval",
	    LblBookingStartTime: "LblBookingStartTime",
	    LblBookingEndTime: "LblBookingEndTime",
	    LblBookingMinDuration: "LblBookingMinDuration",
	    LblBookingMaxDuration: "LblBookingMaxDuration",
	    LblMaxRecurringBooking: "LblMaxRecurringBooking",
	    LblPreBookingInterval: "LblPreBookingInterval",
	    LblPostBookingInterval: "LblPostBookingInterval",
	    LblBookingExtensionTime: "LblBookingExtensionTime",
	    LblBookAheadTime: "LblBookAheadTime",
	    LblBookingHorizon: "LblBookingHorizon",
	    LblNumberOfContactTypeGroup: "LblNumberOfContactTypeGroup",
	    LblNumberOfContactType: "LblNumberOfContactType",
	    LblInvoiceInterval: "LblInvoiceInterval",
	    LblIsBookingIntervalAlignToCalendar: "LblIsBookingIntervalAlignToCalendar",
	    LblBookings: "LblBookings",
	    LblSharedVehicleGroups: "LblSharedVehicleGroups",
	    LblSharedVehicleGroupOverview: "LblSharedVehicleGroupOverview",
	    LblEarlyOpenInterval: "LblEarlyOpenInterval",
	    //Driver
	    LblDriver: "LblDriver",
	    LblLicenceNumber: "LblLicenceNumber",
	    LblDriverName: "LblDriverName",
	    LblDriverSVG: "LblDriverSVG",
	    LblDriverUserName: "LblDriverUserName",
	    //VehicleAttribute
	    LblVehicleAttributeCategory: "LblVehicleAttributeCategory",
	    LblVehicleAttributeName: "LblVehicleAttributeName",
	    LblVehicleAttributeDesc: "LblVehicleAttributeDesc",
	    LblVehicleAttribute: "LblVehicleAttribute",
	    LbAdditionallVehicleAttribute: "LbAdditionallVehicleAttribute",
	    LblVehicleAttributeCategories: "LblVehicleAttributeCategories",
	    //ContractType Page
	    LblRegular: "LblRegular",
	    LblWeekEnd: "LblWeekEnd",
	    LblDayCT: "LblDayCT",
	    LblExtraTimeBefore: "LblExtraTimeBefore",
	    LblExtraTimeAfter: "LblExtraTimeAfter",
	    LblFreeTextDescription: "LblFreeTextDescription",
	    LblPeriodRate: "LblPeriodRate",
	    LblPeriodRateVat: "LblPeriodRateVat",
	    LblSelectContractTypeType: "LblSelectContractTypeType",
	    LblContractTypeType: "LblContractTypeType",
	    LblContractType: "LblContractType",
	    LblContractName: "LblContractName",
	    LblContractTypeGroup: "LblContractTypeGroup",
	    LblContractTypeGroupName: "LblContractTypeGroupName",
	    LblContractAvailableDays: "LblContractAvailableDays",
	    LblApplicableDays: "LblApplicableDays",
	    LblDayStartTime: "LblDayStartTime",
	    LblDayEndTime: "LblDayEndTime",
	    LblApplicableStartTime: "LblApplicableStartTime",
	    LblApplicableEndTime: "LblApplicableEndTime",
	    LblComment: "LblComment",
	    LblProcessingFee: "LblProcessingFee",
	    LblVatPercentage: "LblVatPercentage",
	    LblVatIncludedInPrice: "LblVatIncludedInPrice",
	    LblPlateformUsageCost: "LblPlateformUsageCost",
	    LblCatA: "LblCatA",
	    LblCatB: "LblCatB",
	    LblCatC: "LblCatC",
	    LblCatD: "LblCatD",
	    LblCatE: "LblCatE",
	    LblCatF: "LblCatF",
	    LblCatG: "LblCatG",
	    LblCatH: "LblCatH",
	    LblHourlyRate: "LblHourlyRate",
	    LblMileageRate: "LblMileageRate",
	    LblFixedFee: "LblFixedFee",
	    LblPricingModel: "LblPricingModel",
	    LblContractStartDateTime: "LblContractStartDateTime",
	    LblContractEndDateTime: "LblContractEndDateTime",
	    LblContractTypeHistory: "LblContractTypeHistory",
	    LblContractTypPeriod: "LblContractTypPeriod",
	    LblInactiveContractTypeGroupReason: "LblInactiveContractTypeGroupReason",
	    LblPenaltyAmount: "LblPenaltyAmount",
	    LblPenaltyTimeInterval: "LblPenaltyTimeInterval",
	    LblIsPenaltyEnabled: "LblIsPenaltyEnabled",
	    LblTripDisplayType: "LblTripDisplayType",
	    LblAllTripsIndividually: "LblAllTripsIndividually",
	    LblAllTripsGrouped: "LblAllTripsGrouped",
	    // DateTime Picker
	    LblJanuary: "LblJanuary",
	    LblFebruary: "LblFebruary",
	    LblMarch: "LblMarch",
	    LblApril: "LblApril",
	    LblMay: "LblMay",
	    LblJune: "LblJune",
	    LblJuly: "LblJuly",
	    LblAugust: "LblAugust",
	    LblSeptember: "LblSeptember",
	    LblOctober: "LblOctober",
	    LblNovember: "LblNovember",
	    LblDecember: "LblDecember",
	    LblSJan: "LblSJan",
	    LblSFeb: "LblSFeb",
	    LblSMar: "LblSMar",
	    LblSApr: "LblSApr",
	    LblSMay: "LblSMay",
	    LblSJun: "LblSJun",
	    LblSJul: "LblSJul",
	    LblSAug: "LblSAug",
	    LblSSep: "LblSSep",
	    LblSOct: "LblSOct",
	    LblSNov: "LblSNov",
	    LblSDec: "LblSDec",
	    LblSunday: "LblSunday",
	    LblMonday: "LblMonday",
	    LblTuesday: "LblTuesday",
	    LblWednesday: "LblWednesday",
	    LblThursday: "LblThursday",
	    LblFriday: "LblFriday",
	    LblSaturday: "LblSaturday",
	    LblSSu: "LblSSu",
	    LblSMo: "LblSMo",
	    LblSTu: "LblSTu",
	    LblSWe: "LblSWe",
	    LblSTh: "LblSTh",
	    LblSFr: "LblSFr",
	    LblSSa: "LblSSa",
	    //Forgot Password
	    LblForgotPassword: "LblForgotPassword",
	    LblChangePassword: "LblChangePassword",
	    LblOldPassword: "LblOldPassword",
	    LblNewPassword: "LblNewPassword",
	    LblProfileUpdatedSucessFully: "LblProfileUpdatedSucessFully",
	    LblPasswordChangedSucessFully: "LblPasswordChangedSucessFully",
	    //
	    LblUpdateProfile: "LblUpdateProfile",
	    LbLReasonVehicle: "LbLReasonVehicle",
	    LblReasonDriver: "LblReasonDriver",
	    //Booking
	    LblFrom: "LblFrom",
	    LblTo: "LblTo",
	    LblBooking: "LblBooking",
	    LblBookingRequest: "LblBookingRequest",
	    LblOverview: "LblOverview",
	    LblOverviewList: "LblOverviewList",
	    LblApproveBooking: "LblApproveBooking",
	    LblApprove: "LblApprove",
	    LblReject: "LblReject",
	    LblNormal: "LblNormal",
	    LblSpecial: "LblSpecial",
	    LblHistory: "LblHistory",
	    LblBookingStatus: "LblBookingStatus",
	    LblBookingType: "LblBookingType",
	    LblAdminRemarks: "LblAdminRemarks",
	    LblBookingRemarks: "LblBookingRemarks",
	    LblDriverRemarks: "LblDriverRemarks",
	    LblBookingReferenceId: "LblBookingReferenceId",
	    LblAbort: "LblAbort",
	    LblRevoke: "LblRevoke",
	    LblStatus: "LblStatus",
	    LblReference: "LblReference",
	    LblRemarks: "LblRemarks",
	    LblSearchForVehicle: "LblSearchForVehicle",
	    LblVehicleOverview: "LblVehicleOverview",
	    LblConfirmBooking: "LblConfirmBooking",
	    LblCurrentBookingDetail: "LblCurrentBookingDetail",
	    LblCheckAvailability: "LblCheckAvailability",
	    LblBookingStartDateTime: "LblBookingStartDateTime",
	    LblBookingEndDateTime: "LblBookingEndDateTime",
	    LblSource: "LblSource",
	    LblRecurring: "LblRecurring",
	    LblRecurringId: "LblRecurringId",
	    LblRecurringBookingReference: "LblRecurringBookingReference",
	    LblDaily: "LblDaily",
	    LblWeekly: "LblWeekly",
	    LblMonthly: "LblMonthly",
	    LblRecurrenceEndDate: "LblRecurrenceEndDate",
	    LblSearch: "LblSearch",
	    LblBookNow: "LblBookNow",
	    LblUpdateBooking: "LblUpdateBooking",
	    LblEditCarNotAvailable: "LblEditCarNotAvailable",
	    LblSortBy: "LblSortBy",
	    LblAvaibility: "LblAvaibility",
	    LblDistance: "LblDistance",
	    LblNoMatchingVehicle: "LblNoMatchingVehicle",
	    LblAvailableSlots: "LblAvailableSlots",
	    LblFeatures: "LblFeatures",
	    LblDriverDetail: "LblDriverDetail",
	    LblBookingDetail: "LblBookingDetail",
	    LblVehicleDetail: "LblVehicleDetail",
	    LblBookingSuccess: "LblBookingSuccess",
	    LblBookingUpdateSuccess: "LblBookingUpdateSuccess",
	    LblBlockNormalBooking: "LblBlockNormalBooking",
	    LblSingle: "LblSingle",
	    LblSeries: "LblSeries",
	    LblAll: "LblAll",
	    LblLicenceRequired1: "LblLicenceRequired1",
	    LblLicenceRequired2: "LblLicenceRequired2",
	    //Special Booking
	    LblSpecialBooking: "LblSpecialBooking",
	    LblAffectedBooking: "LblAffectedBooking",
	    LblSpecialBookingType: "LblSpecialBookingType",
	    LblSelectSpecialBookingType: "LblSelectSpecialBookingType",
	    LblSpecialBookingConfiramtionmsg: "LblSpecialBookingConfiramtionmsg",
	    LblEndDate: "LblEndDate",
	    // Notification
	    LblNotification: "LblNotification",
	    LblSubject: "LblSubject",
	    LblDate: "LblDate",
	    LblWelcomeNotification: "LblWelcomeNotification",
	    //Template
	    LblTemplate: "LblTemplate",
	    LblTemplateList: "LblTemplateList",
	    LblTemplateName: "LblTemplateName",
	    LblTemplateType: "LblTemplateType",
	    LblBody: "LblBody",
	    LblIsEmailTemplate: "LblEmail",
	    LblIsWebTemplate: "LblWeb",
	    // Notification Event Management
	    LblNotificationEventManagement: "LblNotificationEventManagement",
	    LblNotificationEvent: "LblNotificationEvent",
	    LblModuleName: "LblModuleName",
	    LblSMS: "LblSMS",
	    //User Type
	    LblUserType: "LblUserType",
	    //TimeBlock
	    LblTimeBlock: "LblTimeBlock",
	    LblTimeBlockName: "LblTimeBlockName",
	    LblTimeBlockWeekDays: "LblTimeBlockWeekDays",
	    LblTimeBlockStartTime: "LblTimeBlockStartTime",
	    LblTimeBlockEndTime: "LblTimeBlockEndTime",
	    LblTimeBlockStartDate: "LblTimeBlockStartDate",
	    LblTimeBlockEndDate: "LblTimeBlockEndDate",
	    // Service Offer
	    LblServiceOffer: "LblServiceOffer",
	    LblServiceOfferList: "LblServiceOfferList",
	    LblServiceOfferName: "LblServiceOfferName",
	    LblServiceOfferType: "LblServiceOfferType",
	    LblStandardTariff: "LblStandardTarifff",
	    LblTimeUsedOrBooked: "LblTimeUsedOrBooked",
	    LblPenalty: "LblPenalty",
	    LblAdditional: "LblAdditional",
	    LblAdditionalAbbr: "LblAdditionalAbbr",
	    LblUnit: "LblUnit",
	    //WegoAdminList
	    LblWegoAdmin: "LblWegoAdmin",
	    LblWegoAdmins: "LblWegoAdmins",
	    LblReSend: "LblReSend",
	    LblResendActivationMail: "LblResendActivationMail",
	    LblResendActivationMailFailure: "LblResendActivationMailFailure",
	    LblResendActivationMailSuccess: "LblResendActivationMailSuccess",
	    //Subscription
	    LblSubscription: "LblSubscription",
	    LblSubscriptionName: "LblSubscriptionName",
	    LblTimeInterval: "Time Interval",
	    LblAmount: "LblAmount",
	    LblFreeKilometer: "LblFreeKilometer",
	    LblFreeMinute: "LblFreeMinute",
	    LblFreeHours: "LblFreeHours",
	    LblNumberOfSubscription: "LblNumberOfSubscription",
	    LblUnsubscribe: "LblUnsubscribe",
	    LblsubscribeEndDate: "LblsubscribeEndDate",
	    LblSubscriptionStartDate: "LblSubscriptionStartDate",
	    //Special Period
	    LblSpecialPeriod: "LblSpecialPeriod",
	    LblspecialPeriodName: "LblspecialPeriodName",
	    LblSpecialPeriodStartTime: "LblSpecialPeriodStartTime",
	    LblSpecialPeriodEndTime: "LblSpecialPeriodEndTime",
	    LblSpecialPeriodWeekDays: "LblSpecialPeriodWeekDays",
	    LblNormalPeriod: "LblNormalPeriod",
	    LblSpecialPeriods: "LblSpecialPeriods",
	    //Booking InvoiceModel
	    LblBookingInvoice: "LblBookingInvoice",
	    LblInvoiceStatus: "LblInvoiceStatus",
	    LblInvoiceType: "LblInvoiceType",
	    LblSummary: "LblSummary",
	    LblTotalHours: "LblTotalHours",
	    LblTotalKm: "LblTotalKm",
	    LblTotalExpense: "LblTotalExpense",
	    LblInvoiceNumber: "LblInvoiceNumber",
	    LblBegin: "LblBegin",
	    LblEnd: "LblEnd",
	    LblVat: "VAT",
	    LblDone: "LblDone",
	    LblClear: "LblClear",
	    LblTotal: "LblTotal",
	    LblInvoiceRequestDateTime: "LblInvoiceRequestDateTime",
	    LblInvoiceSendDateTime: "LblInvoiceSendDateTime",
	    LblInvoiceDateTime: "LblInvoiceDateTime",
	    LblInvoiceDetail: "LblInvoiceDetail",
	    LblResend: "LblResend",
	    LblDownload: "LblDownload",
	    LblResendInvoiceConfirm: "LblResendInvoiceConfirm",
	    LblSendInvoiceConfirm: "LblSendInvoiceConfirm",
	    LblPenaltyRate: "LblPenaltyRate",
	    LblInvoicing: "LblInvoicing",
	    LblInvoices: "LblInvoices",
	    LblProfile: "LblProfile",
	    LblSignOut: "LblSignOut",
	    LblTemplateNote1: "LblTemplateNote1",
	    LblTemplateNote2: "LblTemplateNote2",
	    LblTemplateNote3: "LblTemplateNote3",
	    LblConfirmUnsubscribe: "LblConfirmUnsubscribe",
	    LblDriveHours: "LblDriveHours",
	    LblVehicleImage: "LblVehicleImage",
	    LblMaintenance: "LblMaintenance",
	    LblUNAVAILABLE: "LblUNAVAILABLE",
	    LblTestInvoiceGenerator: "LblTestInvoiceGenerator",
	    LblMissingInvoiceGenerator: "Missing Invoice Generator",
	    LblInvoicingDateTime: "LblInvoicingDateTime",
	    LblGenerateInvoice: "LblGenerateInvoice",
	    LblDeleteAllSelectedRecords: "LblDeleteAllSelectedRecords",
	    LblCancelAllSelectedRecords: "LblCancelAllSelectedRecords",
	    "LblExportAll(CSV)": "LblExportAll(CSV)",
	    LblAddContactPerson: "LblAddContactPerson",
	    LblRemoveContactPerson: "LblRemoveContactPerson",
	    LblNote: "LblNote",
	    LblCompletelyEndConfirm: "LblCompletelyEndConfirm",
	    LblEndTrip: "LblEndTrip",
	    LblTestTrip: "LblTestTrip",
	    LblTripSimulator: "LblTripSimulator",
	    LblPrePostTripQuestions: "LblPrePostTripQuestions",
	    LblTestTripSuccess: "LblTestTripSuccess",
	    LblDrivingStartDateTime: "LblDrivingStartDateTime",
	    LblDrivingEndDateTime: "LblDrivingEndDateTime",
	    LblInvoiceMoment: "LblInvoiceMoment",
	    LblExtend: "LblExtend",
	    LblExtendRequire: "LblExtendRequire",
	    LblExtendInfoMsg: "LblExtendInfoMsg",
	    LblExtendValidationMsg: "LblExtendValidationMsg",
	    LblExtendBooking: "LblExtendBooking",
	    LblBookingExtendedSuccess: "LblBookingExtendedSuccess",
	    LblOverExtendValidationMsg: "LblOverExtendValidationMsg",
	    LblUnLock: "LblUnLock",
	    LblLock: "LblLock",
	    LblVehicleStatus: "LblVehicleStatus",
	    LblTripSuccess: "LblTripSuccess",
	    LblLockSuccessfully: "LblLockSuccessfully",
	    LblLockCompletelySuccessfully: "LblLockCompletelySuccessfully",
	    LblUnLockSuccessfully: "LblUnLockSuccessfully",
	    LblUnlockProblem: "LblUnlockProblem",
	    LbllockProblem: "LbllockProblem",
	    LblLockCarCompletely: "LblLockCarCompletely",
	    LblStartDateTime: "LblStartDateTime",
	    LblEndDateTime: "LblEndDateTime",
	    LblBookingTripDetail: "LblBookingTripDetail",
	    LblAddNewTrip: "LblAddNewTrip",
	    LblBookingExpenseDetail: "LblBookingExpenseDetail",
	    LblUnlockErrorMessage: "LblUnlockErrorMessage",
	    LblExpenseAmount: "LblExpenseAmount",
	    LblExpenseName: "LblExpenseName",
	    LblExpenseSuccess: "LblExpenseSuccess",
	    LblReceipt: "LblReceipt",
	    LblHelpdeskNo: "LblHelpdeskNo",
	    LblBookingExpired: "LblBookingExpired",
	    LblTripCalculationInProgress: "LblTripCalculationInProgress",
	    LblVTSReqLogDetail: "LblVTSReqLogDetail",
	    LblVTSReqDateTime: "LblVTSReqDateTime",
	    LblVTSProcessTime: "LblVTSProcessTime",
	    LblVTSResTime: "LblVTSResTime",
	    LblVTSReqType: "LblVTSReqType",
	    LblVTSResult: "LblVTSResult",
	    LblActualInvoiceGenerationDate: "LblActualInvoiceGenerationDate",
	    LblAvailableForAllSlots: "LblAvailableForAllSlots",
	    LblUnAvailableSlots: "LblUnAvailableSlots",
	    LblNoOfDrivers: "LblNoOfDrivers",
	    LblSVGDriversList: "LblSVGDriversList",
	    LblVehicleInformation: "LblVehicleInformation",
	    LblVTSVehicle: "LblVTSVehicle",
	    LblVTSVehicleUpdateSuccess: "LblVTSVehicleUpdateSuccess",
	    LblVTSVehicleList: "LblVTSVehicleList",
	    //Report Damage
	    LblReportDamage: "LblReportDamage",
	    LblCompleteDamageReport: "LblCompleteDamageReport",
	    LblDamageFile: "LblDamageFile",
	    LblDescribe: "LblDescribe",
	    LblCause: "LblCause",
	    LblReportDamageMsg: "LblReportDamageMsg",
	    LblSelectFile: "LblSelectFile",
	    // Import Data
	    LblCSVImport: "LblCSVImport",
	    LblValidateCSV: "LblValidateCSV",
	    LblImportValidPerson: "LblImportValidPerson",
	    LblImportValidDriver: "LblImportValidDriver",
	    LblImportValidVehicle: "LblImportValidVehicle",
	    LblCSVType: "LblCSVType",
	    LblCSVFile: "LblCSVFile",
	    LblRecordImportedSuccess: "LblRecordImportedSuccess",
	    LblInvalidReason: "LblInvalidReason",
	    LblSameVTSCommand: "LblSameVTSCommand",
	    LblImportPerson: "LblImportPerson",
	    //Subscription related Changes
	    LblSubscriptionInterval: "LblSubscriptionInterval",
	    LblPaymentInterval: "LblPaymentInterval",
	    LblInvoicInterval: "LblInvoicInterval",
	    LblInterval: "LblInterval",
	    LblInvoiceMomentDay: "LblInvoiceMomentDay",
	    LblInvoiceMomentMonth: "LblInvoiceMomentMonth",
	    LblFreeMinuteInterval: "LblFreeMinuteInterval",
	    LblFreeKMInterval: "LblFreeKMInterval",
	    LblSelectSubscriptionInterval: "LblSelectSubscriptionInterval",
	    LblSelectInvoiceInterval: "LblSelectInvoiceInterval",
	    LblSelectPaymentInterval: "LblSelectPaymentInterval",
	    LblSelectFreeKMInterval: "LblSelectFreeKMInterval",
	    LblSelectFreeMinInterval: "LblSelectFreeMinInterval",
	    LblYearlySub: "LblYearlySub",
	    LblMonthlySub: "LblMonthlySub",
	    LblWeeklySub: "LblWeeklySub",
	    LblFreePerWeek: "LblFreePerWeek",
	    LblFreePerMonth: "LblFreePerMonth",
	    LblFreePerTriMonth: "LblFreePerTriMonth",
	    LblFreePerBiannual: "LblFreePerBiannual",
	    LblFreePerYear: "LblFreePerYear",
	    LblDefaultContractTypeGroup: "LblDefaultContractTypeGroup",
	    LblSelectDefaultContractTypeGroup: "LblSelectDefaultContractTypeGroup",
	    LblSendInvoiceToDriver: "LblSendInvoiceToDriver",
	    LblInherit: "LblInherit",
	    //Invoice Moment
	    LblDayOfMonth: "LblDayOfMonth",
	    LblDayOfWeek: "LblDayOfWeek",
	    LblSelectDayOfWeek: "LblSelectDayOfWeek",
	    LblInstanceLogo: "LblInstanceLogo",
	    LblInvoiceDeleteValidation: "LblInvoiceDeleteValidation",
	    //SubscriptionAvailabilityRestriction
	    LblSubscriptionAvailabilityRestriction: "LblSubscriptionAvailabilityRestriction",
	    LblStartDay: "LblStartDay",
	    LblEndDay: "LblEndDay",
	    LblStartTime: "LblStartTime",
	    LblEndTime: "LblEndTime",
	    LblRestriction: "LblRestriction",
	    LblTotalFreeKilometer: "LblTotalFreeKilometer",
	    LblTotalFreeMinute: "LblTotalFreeMinute",
	    LblCurRemainFreeKilometer: "LblCurRemainFreeKilometer",
	    LblPrevRemainFreeKilometer: "LblPrevRemainFreeKilometer",
	    LblCurRemainFreeMinute: "LblCurRemainFreeMinute",
	    LblPrevRemainFreeMinute: "LblPrevRemainFreeMinute",
	    LblResetPasswordFailure: "LblResetPasswordFailure",
	    //Additional Free Item
	    LblAdditionalFreeItems: "LblAdditionalFreeItems",
	    LblDateAwared: "LblDateAwared",
	    LblAdditionalFreeItemsMenu: "LblAdditionalFreeItemsMenu",
	    LblPrevious: "LblPrevious",
	    LblCurrent: "LblCurrent",
	    LblTripDetailReport: "LblTripDetailReport",
	    LblTripDetailList: "LblTripDetailList",
	    LblSearchTripforDriver: "LblSearchTripforDriver",
	    LblExportReport: "LblExportReport",
	    LblValidateLiceanceNumberMessage: "LblValidateLiceanceNumberMessage",
	    LblBookingIntervalRate: "LblBookingIntervalRate",
	    LblPerHour: "LblPerHour",
	    LblPerBookingIntarval: "LblPerBookingIntarval",
	    LblTimeRate: "LblTimeRate",
	    LblToalBookingDuration: "LblToalBookingDuration",
	    LblTripComments: "LblTripComment",
	    LblTripCommentDescription: "LblTripCommentDescription",
	    LblTripCommentError: "LblTripCommentError",
	    LblShowTripComment: "LblShowTripComment",
	    LblAddTripComment: "LblAddTripComment",
	    LblTripCommentBy: "LblTripCommentBy",
	    LblTripCommentOn: "LblTripCommentOn",
	    LblCleanRequire: "LblCleanRequire",
	    LblFualRequire: "LblFualRequire",
	    LblVehicleDamageList: "LblVehicleDamageList",
	    LblDamageCause: "LblDamageCause",
	    LblDamageReportedBy: "LblDamageReportedBy",
	    LblDamageReportedOn: "LblDamageReportedOn",
	    LblConfirmResolveDamage: "LblConfirmResolveDamage",
	    LblVehicleDamgeResolveSuccess: "LblVehicleDamgeResolveSuccess",
	    LblDamageDesc: "LblDamageDesc",
	    LblFutureBooking: "LblFutuLblVehFutureBookingList",
	    LblResolveDamge: "LblResolveDamge",
	    LblReserved: "LblReserved",
	    LblVehicleInfoSuccess: "LblVehicleInfoSuccess",
	    LblInformation: "LblInformation",
	    LblVTSHistory: "LblVTSHistory",
	    LblWegoRequestTime: "LblWegoRequestTime",
	    LblVTSRequestTime: "LblVTSRequestTime",
	    LblRequestType: "LblRequestType",
	    LblWegoProcessTime: "LblWegoProcessTime",
	    LblResult: "LblResult",
	    LblWegoResultTime: "LblWegoResultTime",
	    LblVTSResultTime: "LblVTSResultTime",
	    LblCommandInitiator: "LblCommandInitiator",
	    LblTroubleShootVTS: "LblTroubleShootVTS",
	    LblVtsServiceStatus: "LblVtsServiceStatus",
	    LblVtsLicencetag: "LblVtsLicencetag",
	    LblVtsDoorStatus: "LblVtsDoorStatus",
	    LblVtsIssueCommand: "LblVtsIssueCommand",
	    LblVehicleLocation: "LblVehicleLocation",
	    LblEventHistory: "LblEventHistory",
	    LblView: "LblView",
	    LblVehicleObuStatus: "LblVehicleObuStatus",
	    LblVehicleNotInitialized: "LblVehicleNotInitialized",
	    LblLastReceivedTime: "LblLastReceivedTime",
	    LblFreePerBookingInterval: "LblFreePerBookingInterval",
	    LblSelectFilter: "LblSelectFilter",
	    LblAuditEntries: "LblAuditEntries",
	    LblFilter: "LblFilter",
	    LblCategory: "LblCategory",
	    LblEventName: "LblEventName",
	    LblEventData: "LblEventData",
	    LblMoment: "LblMoment",
	    LblUser: "LblUser",
	    LblNoEventDataFound: "LblNoEventDataFound",
	    LblEventViewer: "LblEventViewer",
	    LblSelectObuType: "LblSelectObuType",
	    LblObuType: "LblObuType",
	    LblDeviceId: "LblDeviceId",
	    LblClaimCode: "Claim code",
	    LblVtsLocation: "LblVtsLocation",
	    LblRetriveAddress: "LblRetriveAddress",
	    LblCrearedDate: "LblCrearedDate",
	    LblCreatedBy: "LblCreatedBy",
	    LblPerBooking: "LblPerBooking",
	    LblOBU: "LblOBU",
	    LblClone: "LblClone",
	    LblCloneVehicle: "LblCloneVehicle",
	    LblFualNotRequire: "LblFualNotRequire",
	    LblCleanNotRequire: "LblCleanNotRequire",
	    LblSubscriptionInfo: "LblSubscriptionInfo",
	    LblVehiclDamaged: "LblVehiclDamaged",
	    LblVehicleNotDamaged: "LblVehicleNotDamaged",
	    LblDamage: "LblDamage",
	    LblFreeBooking: "LblFreeBooking",
	    LblBookingCustomFee: "LblBookingCustomFee",
	    LblFreeBookingSuccess: "LblFreeBookingSuccess",
	    LblEnterLocation: "LblEnterLocation",
	    LblHomeLocation: "LblHomeLocation",
	    LblLocationMode: "LblLocationMode",
	    LblMeter: "LblMeter",
	    LblLocation: "LblLocation",
	    LblPickupLocation: "LblPickupLocation",
	    LblLocationUnavailable: "LblLocationUnavailable",
	    LblAvailabilityCalander: "LblAvailabilityCalander",
	    LblAvailableOn: "LblAvailableOn",
	    LblGeofenceEnabled: "LblGeofenceEnabled",
	    LblLocationNotFound: "LblLocationNotFound",
	    LblAddressNotAvailable: "LblAddressNotAvailable",
	    LblReports: "LblReports",
	    LblDrivers: "LblDrivers",
	    LblTemplates: "LblTemplates",
	    LblVehicleOccupancyReport: "LblVehicleOccupancyReport",
	    LblPlaceHolder: "LblPlaceHolder",
	    LblSampleTemplate: "LblSampleTemplate",
	    LblLatexFileDownloadValidation: "LblLatexFileDownloadValidation",
	    LblLocationDataExchangeNotAssign: "LblLocationDataExchangeNotAssign",
	    LblReservedTime: "LblReservedTime",
	    LblUsageTime: "LblUsageTime",
	    LblUsageTimeAtOffice: "LblUsageTimeAtOffice",
	    LblUsageTimeoutOffice: "LblUsageTimeoutOffice",
	    LblRevenue: "LblRevenue",
	    LblRevenuePerVehicleReport: "LblRevenuePerVehicleReport",
	    LblSearchRevenuePerVehicle: "LblSearchRevenuePerVehicle",
	    LblRevenuePerVehicleList: "LblRevenuePerVehicleList",
	    //Dashboard
	    LblInuse: "LblInuse",
	    LblPriority: "LblPriority",
	    LblDefaultStatus: "LblDefaultStatus",
	    //OdometerLogTrail
	    LblOdometerLogTrail: "LblOdometerLogTrail",
	    LblUserProvidedOdometerValueInKmr: "LblUserProvidedOdometerValueInKmr",
	    LblDescriptionOfDeviation: "LblDescriptionOfDeviation",
	    LblFromOdometer: "LblFromOdometer",
	    LblToOdometer: "LblToOdometer",
	    LblAddDescriptionOfDeviation: "LblAddDescriptionOfDeviation",
	    LblDeviation: "LblDeviation",
	    LblLastOdometerValue: "LblLastOdometerValue",
	    LblLastOdometerDT: "LblLastOdometerDT",
	    LblOdometerRegistered: "LblOdometerRegistered",
	    LblOdometerValue: "LblOdometerValue",
	    LblMaintenancePlanningList: "LblMaintenancePlanningList",
	    LblSearchMaintenancePlanningValue: "LblSearchMaintenancePlanningValue",
	    LblMaintenancePlanningreport: "LblMaintenancePlanningreport",
	    LblodometerConfiguration: "LblodometerConfiguration",
	    LbLOdometerEnabled: "LbLOdometerEnabled",
	    LblEnableOnApp: "LblEnableOnApp",
	    LblWarningPer: "LblWarningPer",
	    LblShowDeviation: "LblShowDeviation",
	    LblTitle: "LblTitle",
	    LblFooterText: "LblFooterText",
	    LblvalidEmailDomain: "LblvalidEmailDomain",
	    LblURLSettings: "LblURLSettings",
	    LblSuccessUrl: "LblSuccessUrl",
	    LblEmailSettings: "LblEmailSettings",
	    LblSendActivationEmail: "LblSendActivationEmail",
	    LblSendConfirmationEmail: "LblSendConfirmationEmail",
	    LblRequireAdminApprovel: "LblRequireAdminApprovel",
	    LblDriverInformationToBeInclude: "LblDriverInformationToBeInclude",
	    LblSignUpForm: "LblSignUpForm",
	    LblSignupForms: "LblSignupForms",
	    LblSignupFormsOverview: "LblSignupFormsOverview",
	    LblWhoCanApprove: "LblWhoCanApprove",
	    LblSignupFormLogo: "LblSignupFormLogo",
	    LblChooseSubscription: "LblChooseSubscription",
	    LblSignupParameter: "LblSignupParameter",
	    LblSignupParameterText: "LblSignupParameterText",
	    DomainNameString: "DomainNameString",
	    SignupParameterString: "SignupParameterString",
	    LblAvailability: "LblAvailability",
	    LblSettings: "LblSettings",
	    LblCurrentStatus: "LblCurrentStatus",
	    LblFlags: "LblFlags",
	    LblNA: "LblNA",
	    //Sign up form
	    LblConfirmEmail: "LblConfirmEmail",
	    LblSignup: "LblSignup",
	    LblSignupsOverView: "LblSignupsOverView",
	    LblSignupApproval: "LblSignupApproval",
	    LblAccept: "LblAccept",
	    LblSignupFormDescription: "LblSignupFormDescription",
	    LblCurrentOdometerValue: "LblCurrentOdometerValue",
	    LblCurrentOdometerDateTime: "LblCurrentOdometerDateTime",
	    LblCreateDirectDebitFile: "LblCreateDirectDebitFile",
	    LblCheckEmptyIbanNumber: "LblCheckEmptyIbanNumber",
	    LblCreatedDate: "LblCreatedDate",
	    LblIncludeInDirectDebit: "LblIncludeInDirectDebit",
	    LblDirectDebitFileDate: "LblDirectDebitFileDate",
	    LblDirectDebitConfiguration: "LblDirectDebitConfiguration",
	    LbLDirectDebitEnabled: "LbLDirectDebitEnabled",
	    LblDirectDebitEnableper: "LblDirectDebitEnableper",
	    LbLCreditorDetails: "LbLCreditorDetails",
	    LblAddress: "LblAddress",
	    LblIBANNumber: "LblIBANNumber",
	    LblCountryCode: "LblCountryCode",
	    LbLBillingInformation: "LbLBillingInformation",
	    LblFormat: "LblFormat",
	    LblInvoicingDetails: "LblInvoicingDetails",
	    LbLSubjectToDirectDebit: "LbLSubjectToDirectDebit",
	    //Person Upload Batch
	    LblBatchUploadPersonSetting: "LblBatchUploadPersonSetting",
	    LblShowBatchUploadInfo: "LblShowBatchUploadInfo",
	    LblAllowBatchUpload: "LblAllowBatchUpload",
	    LblAllowActivationMail: "LblAllowActivationMail",
	    LblGenerateRandomPassword: "LblGenerateRandomPassword",
	    LblUserUploadPassword: "LblUserUploadPassword",
	    LblFieldToUploadedOrValidated: "LblFieldToUploadedOrValidated",
	    LblBatchUploadPerson: "LblBatchUploadPerson",
	    LblBatchUpload: "LblBatchUpload",
	    LblImportDriverRole: "LblImportDriverRole",
	    LblAssignToSVG: "LblAssignToSVG",
	    LblSVG: "LblSVG",
	    LblDownloadTemplate: "LblDownloadTemplate",
	    LblUserAssignSVGMessage: "LblUserAssignSVGMessage",
	    LblInvalidRecordReason: "LblInvalidRecordReason",
	    LblSelectedSVGs: "LblSelectedSVGs",
	    LblDashboard: "LblDashboard",
	    LblGroupAdmin: "LblGroupAdmin",
	    LblDashboardConfiguration: "LblDashboardConfiguration",
	    LblCurrentLocation: "LblCurrentLocation",
	    LblEnableCurrentLocation: "LblEnableCurrentLocation",
	    LblDefaultLocation: "LblDefaultLocation",
	    LblEnableAutoUpdate: "LblEnableAutoUpdate",
	    LblPriorityNotificationSetting: "LblPriorityNotificationSetting",
	    LblCollectionDate: "LblCollectionDate",
	    LblBICCode: "LblBICCode",
	    LblDirectDebitFile: "LblDirectDebitFile",
	    LblMissingIBANNumber: "LblMissingIBANNumber",
	    LblCurrentDriver: "LblCurrentDriver",
	    LblNextDriver: "LblNextDriver",
	    LblSecond: "LblSecond",
	    LblCleaning: "LblCleaning",
	    LblRefueling: "LblRefueling",
	    LblAPKMaintenance: "LblAPKMaintenance",
	    LblOutsideGeofence: "LblOutsideGeofence",
	    LblNotBooked: "LblNotBooked",
	    LblNotBookedSince: "LblNotBookedSince",
	    LblLowBattery: "LblLowBattery",
	    LblBatteryVolt: "LblBatteryVolt",
	    LblLowCharge: "LblLowCharge",
	    LblChargingPercentage: "LblChargingPercentage",
	    LblOnSamePosition: "LblOnSamePosition",
	    LblLastPosition: "LblLastPosition",
	    LblNotReturn: "LblNotReturn",
	    LblCommunicationProblem: "LblCommunicationProblem",
	    LblDirectDebitDownloadSuccess: "LblDirectDebitDownloadSuccess",
	    LblWarnings: "LblWarnings",
	    LblDirectDebitFileId: "LblDirectDebitFileId",
	    LblTotalAmount: "LblTotalAmount",
	    LblReCreate: "LblReCreate",
	    LblPleaseEnterCollectionDate: "LblPleaseEnterCollectionDate",
	    LblOpenViaLowLevel: "LblOpenViaLowLevel",
	    LblInstanceNotificationNote1: "LblInstanceNotificationNote1",
	    LblNoInvoiceSelected: "LblNoInvoiceSelected",
	    LblIBANNumberRequired: "LblIBANNumberRequired",
	    LblNoEmptyIBANFound: "LblNoEmptyIBANFound",
	    LblInvalidTagUsed: "LblInvalidTagUsed",
	    LblNotInvalidTagUsed: "LblNotInvalidTagUsed",
	    LblShowVehicleChargeLevel: "LblShowVehicleChargeLevel",
	    LblChargeLevel: "LblChargeLevel",
	    LblCharging: "Charging",
	    LblNoDataFound: "LblNoDataFound",
	    LblOfficeStartTime: "LblOfficeStartTime",
	    LblOfficeEndTime: "LblOfficeEndTime",
	    //Reports
	    LblTripDataReport: "LblTripDataReport",
	    LblByDriver: "LblByDriver",
	    LblByVehicle: "LblByVehicle",
	    LblByOrganization: "LblOrgnization",
	    LblModuleRights: "LblModuleRights",
	    //Organization
	    LblOrganization: "LblOrganization",
	    LblOrganizationName: "LblOrganizationName",
	    LblOrganizationAddress: "LblOrganizationAddress",
	    LblAddDriverSuccessMsg: "LblAddDriverSuccessMsg",
	    LblExistingDriverAddSuccessMsg: "LblExistingDriverAddSuccessMsg",
	    LblAddDriver: "LblAddDriver",
	    LblCreateOrganization: "LblCreateOrganization",
	    LblAddDriverToOrganization: "Add Driver To Organization",
	    LblOrganizationDriversList: "LblOrganizationDriversList",
	    LblVatNumber: "LblVatNumber",
	    // Branding
	    LblBranding: "LblBranding",
	    LblLogo: "LblLogo",
	    LblEmailNotificationInvoiceTemplate: "LblEmailNotificationInvoiceTemplate",
	    LblExpandedWebMenu: "LblExpandedWebMenu",
	    LblCollapsedWebMenu: "LblCollapsedWebMenu",
	    LblMobileApp: "LblMobileApp",
	    LblSplashScreen: "LblSplashScreen",
	    LblWebApplication: "LblWebApplication",
	    LblMobileApplication: "LblMobileApplication",
	    LblBrandingSavedSuccess: "LblBrandingSavedSuccess",
	    LblBrandingTemplateConfiguration: "LblBrandingTemplateConfiguration",
	    LblAppWebUI: "LblAppWebUI",
	    LblNonBookingCommunication: "LblNonBookingCommunication",
	    LblBookingCommunication: "LblBookingCommunication",
	    LblInstanceBranding: "LblInstanceBranding",
	    LblCompanyBranding: "LblCompanyBranding",
	    BO_TOP_MENU_ACTIVE_ITEM_BACKGROUND: "BO_TOP_MENU_ACTIVE_ITEM_BACKGROUND",
	    BO_TOP_MENU_ACTIVE_ITEM_TEXT: "BO_TOP_MENU_ACTIVE_ITEM_TEXT",
	    BO_HIGHLIGHTED_BUTTON_BACKGROUND: "BO_HIGHLIGHTED_BUTTON_BACKGROUND",
	    BO_HIGHLIGHTED_BUTTON_TEXT: "BO_HIGHLIGHTED_BUTTON_TEXT",
	    BO_HIGHLIGHTED_BUTTON_BACKGROUND_HOVER: "BO_HIGHLIGHTED_BUTTON_BACKGROUND_HOVER",
	    BO_HIGHLIGHTED_BUTTON_TEXT_HOVER: "BO_HIGHLIGHTED_BUTTON_TEXT_HOVER",
	    BO_PRIMARY_BUTTON_BACKGROUND: "BO_PRIMARY_BUTTON_BACKGROUND",
	    BO_PRIMARY_BUTTON_TEXT: "BO_PRIMARY_BUTTON_TEXT",
	    BO_PRIMARY_BUTTON_BACKGROUND_HOVER: "BO_PRIMARY_BUTTON_BACKGROUND_HOVER",
	    BO_PRIMARY_BUTTON_TEXT_HOVER: "BO_PRIMARY_BUTTON_TEXT_HOVER",
	    BO_SECONDARY_BUTTON_BACKGROUND: "BO_SECONDARY_BUTTON_BACKGROUND",
	    BO_SECONDARY_BUTTON_TEXT: "BO_SECONDARY_BUTTON_TEXT",
	    BO_SECONDARY_BUTTON_BACKGROUND_HOVER: "BO_SECONDARY_BUTTON_BACKGROUND_HOVER",
	    BO_SECONDARY_BUTTON_TEXT_HOVER: "BO_SECONDARY_BUTTON_TEXT_HOVER",
	    BO_HYPERLINK_TEXT: "BO_HYPERLINK_TEXT",
	    BO_HIGHLIGHT_BACKGROUND: "BO_HIGHLIGHT_BACKGROUND",
	    BO_HIGHLIGHT_TEXT: "BO_HIGHLIGHT_TEXT",
	    BO_CALENDAR_EVENT_BACKGROUND: "BO_CALENDAR_EVENT_BACKGROUND",
	    BO_CALENDAR_EVENT_TEXT: "BO_CALENDAR_EVENT_TEXT",
	    MO_TOP_MENU_ACTIVE_ITEM_BACKGROUND: "MO_TOP_MENU_ACTIVE_ITEM_BACKGROUND",
	    MO_LOGO_AREA_BACKGROUND: "MO_LOGO_AREA_BACKGROUND",
	    MO_PAGE_BACKGROUND: "MO_PAGE_BACKGROUND",
	    MO_MENU_TEXT: "MO_MENU_TEXT",
	    MO_TITLE_TEXT: "MO_TITLE_TEXT",
	    MO_HYPERLINK_TEXT: "MO_HYPERLINK_TEXT",
	    MO_ENABLED_BUTTON_BACKGROUND: "MO_ENABLED_BUTTON_BACKGROUND",
	    MO_ENABLED_BUTTON_TEXT: "MO_ENABLED_BUTTON_TEXT",
	    MO_ENABLED_BUTTON_BACKGROUND_ACTIVE: "MO_ENABLED_BUTTON_BACKGROUND_ACTIVE",
	    MO_ENABLED_BUTTON_TEXT_ACTIVE: "MO_ENABLED_BUTTON_TEXT_ACTIVE",
	    MO_DISABLED_BUTTON_BACKGROUND: "MO_DISABLED_BUTTON_BACKGROUND",
	    MO_DISABLED_BUTTON_TEXT: "MO_DISABLED_BUTTON_TEXT",
	    MO_DISABLED_BUTTON_BACKGROUND_ACTIVE: "MO_DISABLED_BUTTON_BACKGROUND_ACTIVE",
	    MO_DISABLED_BUTTON_TEXT_ACTIVE: "MO_DISABLED_BUTTON_TEXT_ACTIVE",
	    MO_HIGHLIGHT_BACKGROUND: "MO_HIGHLIGHT_BACKGROUND",
	    MO_HIGHLIGHT_TEXT: "MO_HIGHLIGHT_TEXT",
	    MO_CALENDAR_EVENT_BACKGROUND: "MO_CALENDAR_EVENT_BACKGROUND",
	    MO_CALENDAR_EVENT_TEXT: "MO_CALENDAR_EVENT_TEXT",
	    LblBookingDelayConfig: "LblBookingDelayConfig",
	    LblBookingDelayConfigEnabled: "LblBookingDelayConfigEnabled",
	    LblEnableSnauilTrail: "LblEnableSnauilTrail",
	    LblAppSupportTo: "LblAppSupportTo",
	    LblNotificationInterval: "LblNotificationInterval",
	    LblNotifyAfterMinutes: "LblNotifyAfterMinutes",
	    LblMinutesAfterBookingEndTime: "LblMinutesAfterBookingEndTime",
	    LblResendNotoficationEvery: "LblResendNotoficationEvery",
	    LblMinutes: "LblMinutes",
	    lblNotificationRecipients: "lblNotificationRecipients",
	    LbLEnableBookingStillRunning: "LbLEnableBookingStillRunning",
	    LblBookingrunningNotification: "LblBookingrunningNotification",
	    LblPreferableImageSize: "LblPreferableImageSize",
	    LblWebBrandingExapandImageSize: "LblWebBrandingExapandImageSize",
	    LblMobileBrandingImageSize: "LblMobileBrandingImageSize",
	    LblWebBrandingCollapseImageSize: "LblWebBrandingCollapseImageSize",
	    //Raise and clear settings for low battery flag
	    LblDefaultVehicleSetting: "LblDefaultVehicleSetting",
	    LblLowBatteryFlagRaised: "LblLowBatteryFlagRaised",
	    LblLowBatteryFlagClear: "LblLowBatteryFlagClear",
	    LblByBooking: "LblByBooking",
	    LblSnailTrailReport: "LblSnailTrailReport",
	    LblKickbackReport: "LblKickbackReport",
	    LblGroupBy: "LblGroupBy",
	    LblTripDetail: "LblTripDetail",
	    LblTripNumber: "LblTripNumber",
	    LblStart: "LblStart",
	    LblAverageSpeed: "LblAverageSpeed",
	    LblSegmentDetail: "LblSegmentDetail",
	    LblSegmentNumber: "LblSegmentNumber",
	    LblSpeed: "LblSpeed",
	    LblOdometer: "LblOdometer",
	    LblNext: "LblNext",
	    LblSegmentDetailNotAvailable: "LblSegmentDetailNotAvailable",
	    LblUnitPerKm: "LblUnitPerKm",
	    LblUnitPerBooking: "LblUnitPerBooking",
	    LblBookingCostSummary: "LblBookingCostSummary",
	    LblTimeCost: "LblTimeCost",
	    LblTotalTime: "LblTotalTime",
	    LblTime: "LblTime",
	    LblFreeTime: "LblFreeTime",
	    LblRate: "LblRate",
	    LblExVat: "LblExVat",
	    LblInclVat: "LblInclVat",
	    LblKmDriven: "LblKmDriven",
	    LblFreeKms: "LblFreeKms",
	    LblTimePercent: "LblTimePercent",
	    LblTotalExVat: "LblTotalExVat",
	    LblTotalVat: "LblTotalVat",
	    LblTotalInclVat: "LblTotalInclVat",
	    LblKilometerCost: "LblKilometerCost",
	    LblFixedCost: "LblFixedCost",
	    LblTotals: "LblTotals",
	    LblTypeDamage: "LblTypeDamage",
	    LblTypeMaintenance: "LblTypeMaintenance",
	    LblTypeOnSamePosition: "LblTypeOnSamePosition",
	    LblTypeNotBooked: "LblTypeNotBooked",
	    LblTypeNotReturn: "LblTypeNotReturn",
	    LblBatteryVoltage: "LblBatteryVoltage",
	    LblCannotUnsubscribe: "LblCannotUnsubscribe",
	    LblPer: "LblPer",
	    LblDateRegistered: "LblDateRegistered",
	    LblRegisteredBy: "LblRegisteredBy",
	    LblKMPerHour: "LblKMPerHour",
	    LblMeters: "LblMeters",
	    LblSubscriptionEndOnBookingEnd: "LblSubscriptionEndOnBookingEnd",
	    LblMarkedForDeletion: "LblMarkedForDeletion",
	    LblApplyDateFilter: "LblApplyDateFilter",
	    LblNoRestriction: "LblNoRestriction",
	    LblCustomAppTestApp: "LblCustomAppTestApp",
	    LblCustomAppOnly: "LblCustomAppOnly",
	    //Customer
	    LblCustomer: "LblCustomer",
	    LblCustomerName: "LblCustomerName",
	    //Role Page
	    LblRoleManagement: "LblRoleManagement",
	    LblRoleName: "LblRoleName",
	    LblEntityName: "LblEntityName",
	    LblRoleType: "LblRoleType",
	    LblVehFutureBookingList: "LblVehFutureBookingList",
	    LblRoleAvailability: "LblRoleAvailability",
	    LblInternalRoleName: "LblInternalRoleName",
	    LblPresentationName: "LblPresentationName",
	    LblDefaultRole: "LblDefaultRole",
	    LblCustomRole: "LblCustomRole",
	    LblAddRole: "LblAddRole",
	    LblEntity: "LblEntity",
	    LblCopy: "LblCopy",
	    LblAccessibilityMatrix: "LblAccessibilityMatrix",
	    LblDefaultRoleModifyWarning: "LblDefaultRoleModifyWarning",
	    LblCopyAccessibilityMatrix: "LblCopyAccessibilityMatrix",
	    LblAccess: "LblAccess",
	    LblCustomerAdmin: "LblCustomerAdmin",
	    LblAdmin: "LblAdmin",
	    LblDoYouWantToRemove: "LblDoYouWantToRemove",
	    LblDoYouWantToAdd: "LblDoYouWantToAdd",
	    LblRoleAddedSuccess: "LblRoleAddedSuccess",
	    LblRoleDeletedSuccess: "LblRoleDeletedSuccess",
	    LblInstanceAdmin: "LblInstanceAdmin",
	    LblInvitationMailSuccess: "LblInvitationMailSuccess",
	    LblInvite: "LblInvite",
	    LblCreateNew: "LblCreateNew",
	    LblCommonErrorMessage: "LblCommonErrorMessage",
	    LblError: "LblError",
	    LblThankYouForAcceptingInvitation: "LblThankYouForAcceptingInvitation",
	    LblPleaseClick: "LblPleaseClick",
	    LblHere: "LblHere",
	    LblToLogin: "LblToLogin",
	    LblThankYouForConfirmation: "LblThankYouForConfirmation",
	    LblGoToHome: "LblGoToHome",
	    LblInvitationSuccess: "LblInvitationSuccess",
	    LblInvitationReject: "LblInvitationReject",
	    //
	    LblAssignExisting: "LblAssignExisting",
	    LblPersonProfileSuccessMessage: "LblPersonProfileSuccessMessage",
	    LblPlease: "LblPlease",
	    LblLogin: "LblLogin",
	    //Branding & Template
	    LblBrandingandTemplates: "LblBrandingandTemplates",
	    LblTermsAndCondition: "LblTermsAndCondition",
	    LblTermsAndConditionList: "LblTermsAndCondition",
	    LblName: "LblName",
	    LblVersion: "LblVersion",
	    LblAcceptance1: "LblAcceptance1",
	    LblAcceptanceMoment: "LblAcceptanceMoment",
	    LblContents: "LblContents",
	    LblIsAccept: "LblIsAccept",
	    LblReadAndAgree: "LblReadAndAgree",
	    LblClose: "LblClose",
	    LblTermsConditionPrivacy: "LblTermsConditionPrivacy",
	    LblPrivacyStatements: "LblPrivacyStatements",
	    //Pre Post Trip Setting
	    LblPrePostTripSetting: "LblPrePostTripSetting",
	    LblPrePostTripQuestion: "LblPrePostTripQuestion",
	    LblPrePostTripQuestionList: "LblPrePostTripQuestionList",
	    LblPreTripQuestion: "LblPreTripQuestion",
	    LblCustom: "LblCustom",
	    LblPostTripQuestion: "LblPostTripQuestion",
	    LblRequired: "LblRequired",
	    LblBeforeOpeningTheVehicle: "LblBeforeOpeningTheVehicle",
	    LblAfterOpeningTheVehicle: "LblAfterOpeningTheVehicle",
	    LblOrder: "LblOrder",
	    LblQuestion: "LblQuestion",
	    LblOptional: "LblOptional",
	    LblAnswerType: "LblAnswerType",
	    LblText: "LblText",
	    LblYesNo: "LblYesNo",
	    LblAnswer: "LblAnswer",
	    LblTimeStamp: "LblTimeStamp",
	    LblFazTripQuestion: "LblFazTripQuestion",
	    LblFazTripQuestionAfterClosingTheVehicle: "LblFazTripQuestionAfterClosingTheVehicle",
	    //Accessibility Matrix
	    LG_WEB_DASHBOARD: "LG_WEB_DASHBOARD",
	    PR_DASHBOARD: "PR_DASHBOARD",
	    PR_REMOVE_DRIVER_LICENSE: "Remove Driver License",
	    PR_VEHICLE_FUTURE_BOOKINGS: "PR_VEHICLE_FUTURE_BOOKINGS",
	    PR_INSTANCE: "PR_INSTANCE",
	    PR_BRANDING: "PR_BRANDING",
	    PR_PERSON_OVERVIEW: "PR_PERSON_OVERVIEW",
	    PR_WEGO_ADMINS: "PR_WEGO_ADMINS",
	    PR_COMPANY_OVERVIEW: "PR_COMPANY_OVERVIEW",
	    PR_CONTACT_PERSON: "PR_CONTACT_PERSON",
	    PR_COMPANY_ADMIN: "PR_COMPANY_ADMIN",
	    PR_COMPANY_VEHICLE_OVERVIEW: "PR_COMPANY_VEHICLE_OVERVIEW",
	    PR_COMPANY_SVG_OVERVIEW: "PR_COMPANY_SVG_OVERVIEW",
	    PR_ORGANIZATION_OVERVIEW: "PR_ORGANIZATION_OVERVIEW",
	    PR_ORGANIZATION_CONTACT_PERSON: "PR_ORGANIZATION_CONTACT_PERSON",
	    PR_ORGANIZATION_ADMIN_OVERVIEW: "PR_ORGANIZATION_ADMIN_OVERVIEW",
	    PR_ORGANIZATION_DRIVER_OVERVIEW: "PR_ORGANIZATION_DRIVER_OVERVIEW",
	    PR_SHARED_VEHICLE_GROUP_OVERVIEW: "PR_SHARED_VEHICLE_GROUP_OVERVIEW",
	    PR_SHARED_VEHICLE_GROUP_ADMIN_OVERVIEW: "PR_SHARED_VEHICLE_GROUP_ADMIN_OVERVIEW",
	    PR_SHARED_VEHICLE_GROUP_VEHICLE_OVERVIEW: "PR_SHARED_VEHICLE_GROUP_VEHICLE_OVERVIEW",
	    PR_SHARED_VEHICLE_GROUP_DRIVER_OVERVIEW: "PR_SHARED_VEHICLE_GROUP_DRIVER_OVERVIEW",
	    PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_GROUP_OVERVIEW: "PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_GROUP_OVERVIEW",
	    PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_OVERVIEW: "PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_OVERVIEW",
	    PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW: "PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW",
	    PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_AVAILIBILTY_RESTRICTION_OVERVIEW: "PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_AVAILIBILTY_RESTRICTION_OVERVIEW",
	    PR_SPECIAL_PERIODS: "PR_SPECIAL_PERIODS",
	    PR_VEHICLES_OVERVIEW: "PR_VEHICLES_OVERVIEW",
	    PR_VEHICLE_SVG_OVERVIEW: "PR_VEHICLE_SVG_OVERVIEW",
	    PR_VTS_VEHICLE_LIST: "PR_VTS_VEHICLE_LIST",
	    PR_VTS_TROUBLESHOOT: "PR_VTS_TROUBLESHOOT",
	    PR_VEHICLE_ATTRIBUTE_CATEGORIES: "PR_VEHICLE_ATTRIBUTE_CATEGORIES",
	    PR_VEHICLE_ATTRIBUTE: "PR_VEHICLE_ATTRIBUTE",
	    PR_ODOMETER_LOG_TRAIL: "PR_ODOMETER_LOG_TRAIL",
	    PR_ODOMETER_LOG_TRAIL_REGISTERED_BY: "PR_ODOMETER_LOG_TRAIL_REGISTERED_BY",
	    PR_DRIVER_OVERVIEW: "PR_DRIVER_OVERVIEW",
	    PR_DRIVER_SHARED_VEHICLE_GROUP_OVERVIEW: "PR_DRIVER_SHARED_VEHICLE_GROUP_OVERVIEW",
	    PR_DRIVER_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW: "PR_DRIVER_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW",
	    PR_BOOKINGS_OVERVIEW: "PR_BOOKINGS_OVERVIEW",
	    PR_NORMAL_BOOKING: "PR_NORMAL_BOOKING",
	    PR_SPECIAL_BOOKING: "PR_SPECIAL_BOOKING",
	    PR_TRIP_SIMULATOR: "PR_TRIP_SIMULATOR",
	    PR_INVOICE: "PR_INVOICE",
	    PR_DIRECT_DEBIT_FILE: "PR_DIRECT_DEBIT_FILE",
	    PR_ADDITIONAL_FREE_ITEMS: "PR_ADDITIONAL_FREE_ITEMS",
	    PR_TEST_INVOICE_GENERATOR: "PR_TEST_INVOICE_GENERATOR",
	    PR_VEHICLE_OCCUPANCY_REPORT: "PR_VEHICLE_OCCUPANCY_REPORT",
	    PR_REVENUE_PER_VEHICLE_REPORT: "PR_REVENUE_PER_VEHICLE_REPORT",
	    PR_TRIP_DATA_REPORT: "PR_TRIP_DATA_REPORT",
	    PR_MAINTENANCE_PLANNING_REPORT: "PR_MAINTENANCE_PLANNING_REPORT",
	    PR_SANIL_TRAIL_REPORT: "PR_SANIL_TRAIL_REPORT",
	    PR_KICKBACK_REPORT: "PR_KICKBACK_REPORT",
	    PR_INVOICE_PAYMENT_HISTORY: "PR_INVOICE_PAYMENT_HISTORY",
	    PR_TEMPLATES: "PR_TEMPLATES",
	    PR_SIGNUP_FORMS_OVERVIEW: "PR_SIGNUP_FORMS_OVERVIEW",
	    PR_SIGNUPS_OVERVIEW: "PR_SIGNUPS_OVERVIEW",
	    PR_SIGNUP_OVERVIEW_TO_SIGNUP_FORM: "PR_SIGNUP_OVERVIEW_TO_SIGNUP_FORM",
	    PR_SIGNUP_OVERVIEW_TO_SHARED_VEHICLE_GROUP: "PR_SIGNUP_OVERVIEW_TO_SHARED_VEHICLE_GROUP",
	    PR_EVENT_VIEWER: "PR_EVENT_VIEWER",
	    PR_PRE_POST_TRIP_SETTING: "PR_PRE_POST_TRIP_SETTING",
	    PR_PREPOST_TRIP_QUESTIONS_UPDATE: "PR_PREPOST_TRIP_QUESTIONS_UPDATE",
	    PR_USER_PROFILE: "PR_USER_PROFILE",
	    LG_CUSTOMER: "LG_CUSTOMER",
	    LG_INSTANCE: "LG_INSTANCE",
	    LG_BRANDING: "LG_BRANDING",
	    PR_TERMS_AND_CONDITION: "PR_TERMS_AND_CONDITION",
	    LG_PERSON: "LG_PERSON",
	    LG_COMPANY: "LG_COMPANY",
	    LG_ORGANIZATION: "LG_ORGANIZATION",
	    LG_SHARED_VEHICLE_GROUP: "LG_SHARED_VEHICLE_GROUP",
	    LG_VEHICLE: "LG_VEHICLE",
	    LG_DRIVER: "LG_DRIVER",
	    LG_BOOKING: "LG_BOOKING",
	    LG_INVOICE: "LG_INVOICE",
	    LG_REPORT: "LG_REPORT",
	    LG_TEMPLATE: "LG_TEMPLATE",
	    LG_SIGNUP_FORM: "LG_SIGNUP_FORM",
	    LG_EVENT_VIEWER: "LG_EVENT_VIEWER",
	    LG_PRE_POST_TRIP_SETTING: "LG_PRE_POST_TRIP_SETTING",
	    LG_USER: "LG_USER",
	    LG_BRANDING_AND_TEMPLATE: "LG_BRANDING_AND_TEMPLATE",
	    LG_ROLE: "LG_ROLE",
	    LG_PREPOSTTRIPQUESTION: "LG_PREPOSTTRIPQUESTION",
	    PR_CUSTOMER_ADMIN_OVERVIEW: "PR_CUSTOMER_ADMIN_OVERVIEW",
	    PR_INSTANCE_ADMIN_OVERVIEW: "PR_INSTANCE_ADMIN_OVERVIEW",
	    PR_ROLE_OVERVIEW: "PR_ROLE_OVERVIEW",
	    PR_ROLE_ASSIGN: "PR_ROLE_ASSIGN",
	    PR_SHARED_VEHICLE_GROUP_ACTIVE_INACTIVE: "PR_SHARED_VEHICLE_GROUP_ACTIVE_INACTIVE",
	    PR_CUSTOMER_OVERVIEW: "PR_CUSTOMER_OVERVIEW",
	    PR_ORGANIZATION_SUBSCRIPTION_OVERVIEW: "PR_ORGANIZATION_SUBSCRIPTION_OVERVIEW",
	    PR_VTS_VEHICLE_EVENT_HISTORY: "PR_VTS_VEHICLE_EVENT_HISTORY",
	    PR_BATCH_UPLOAD_PERSON: "PR_BATCH_UPLOAD_PERSON",
	    PR_IMPORT_PERSON: "PR_IMPORT_PERSON",
	    LG_REPORTINGTOOL: "Reporting Tool",
	    PR_BOOKING_OVERVIEW: "Booking overview",
	    PR_ROB_NOTIFICATIONS: "ROB overview",
	    PR_MILEAGE_OVERVIEW: "Mileage overview",
	    PR_USAGE_OVERVIEW: "Number of days not used",
	    PR_POSITION_ON_MAP: "Position on the map",
	    PR_VEHICLE_ON_LOCATION_MAP: "Vehicle on location",
	    PR_TRIP_OVERVIEW: "Trip registration",
	    PR_ALTERNATE_TRANSPORTATION: "Alternate transportation",
	    PR_AVERAGE_OVERVIEW: "Averages overview",
	    PR_PRE_POST_BOOKING_OVERVIEW: "Pre/post questions per booking overview",
	    PR_HOME_LOCATIONS_OVERVIEW: "Vehicle and SVG home locations overview",
	    LblPrivacyErrorMessage: "LblPrivacyErrorMessage",
	    LblPrivacyNavigate: "LblPrivacyNavigate",
	    LblPrivacyError: "LblPrivacyError",
	    LblLinkExpired: "LblLinkExpired",
	    LblLinkExpiredMessage: "LblLinkExpiredMessage",
	    PR_PRE_POST_TRIP_QUESTION_UPDATE: "PR_PRE_POST_TRIP_QUESTION_UPDATE",
	    //Vat Setting
	    LblVatSettings: "LblVatSettings",
	    LblVatPercentages: "LblVatPercentages",
	    LblDefaultCost: "LblDefaultCost",
	    LblExcludingVat: "LblExcludingVat",
	    LblIncludingVat: "LblIncludingVat",
	    LblVatEnterDescription: "LblVatEnterDescription",
	    LblEnterVatPercentage: "LblEnterVatPercentage",
	    LblVatPercentageError: "LblVatPercentageError",
	    LblVatDescriptionError: "LblVatDescriptionError",
	    LblStartDate: "LblStartDate",
	    LblVatEndDate: "LblVatEndDate",
	    LblVatDeleteConfirmation: "LblVatDeleteConfirmation",
	    LblVatEndDateError: "LblVatEndDateError",
	    LblVatEndDateNote: "LblVatEndDateNote",
	    LblExpenseAmountVat: "LblExpenseAmountVat",
	    LblDefaultVatContractTypeGroupCost: "LblDefaultVatContractTypeGroupCost",
	    LblDefaultVatContractTypeCost: "LblDefaultVatContractTypeCost",
	    LblDefaultVatSubscriptionCost: "LblDefaultVatSubscriptionCost",
	    LblPenaltyCost: "LblPenaltyCost",
	    LblTimeRates: "LblTimeRates",
	    LblDistanceRates: "LblDistanceRates",
	    LblFixedRates: "LblFixedRates",
	    LblSubscriptionCost: "LblSubscriptionCost",
	    LblVatStartDate: "LblVatStartDate",
	    LblVatStartDateError: "LblVatStartDateError",
	    //
	    LblBearer: "LblBearer",
	    LblWhoBenifitFreeItem: "LblWhoBenifitFreeItem",
	    LblNoDistinction: "LblNoDistinction",
	    LblPenaltyVat: "LblPenaltyVat",
	    LblTimeRateVat: "LblTimeRateVat",
	    LblMileageRateVat: "LblMileageRateVat",
	    LblFixedFeeVat: "LblFixedFeeVat",
	    LblSendInvoiceToOrganization: "LblSendInvoiceToOrganization",
	    // template
	    LblEmailTemplate: "LblEmailTemplate",
	    LblWebTemplate: "LblWebTemplate",
	    LblEmailAddressesEntryPattern: "LblEmailAddressesEntryPattern",
	    LblNoRecipientWarning: "LblNoRecipientWarning",
	    LblCostAndExpenses: "LblCostAndExpenses",
	    LblSender: "LblSender",
	    LblAddressee: "LblAddressee",
	    LblAddLine: "LblAddLine",
	    LblSaveInvoice: "LblSaveInvoice",
	    LblVatAmount: "LblVatAmount",
	    LblBookingId: "LblBookingId",
	    LblReceiptOrSuppor: "LblReceiptOrSuppor",
	    LblVATPercentage: "LblVATPercentage",
	    LblChargeTo: "LblChargeTo",
	    LblReimburseTo: "LblReimburseTo",
	    LblReportedBy: "LblReportedBy",
	    LblReportedAmount: "LblReportedAmount",
	    LblApprovedAmount: "LblApprovedAmount",
	    LblCostType: "LblCostType",
	    LblRecipient: "LblRecipient",
	    LblCostDetail: "LblCostDetail",
	    LblCostCenterReport: "LblCostCenterReport",
	    LblShowTotalOnly: "LblShowTotalOnly",
	    LblChamberOfCommerce: "LblChamberOfCommerce",
	    LblInvoicingSettings: "LblInvoicingSettings",
	    LblInvoiceSender: "LblInvoiceSender",
	    LblAddExisting: "LblAddExisting",
	    LblReceiptOrSupport: "LblReceiptOrSupport",
	    LblManualInvoiceLine: "LblManualInvoiceLine",
	    LblInvoiceLine: "LblInvoiceLine",
	    LblInvoice: "LblInvoice",
	    LblInvoiceLines: "LblInvoiceLines",
	    LblSendInvoice: "LblSendInvoice",
	    LblInvoiceSent: "LblInvoiceSent",
	    LblAddNewInvoiceLine: "LblAddNewInvoiceLine",
	    LblSelectUnprocessedExpenses: "LblSelectUnprocessedExpenses",
	    LblSelectAtLeastOneExpense: "LblSelectAtLeastOneExpense",
	    LblInvoicePaymentHistory: "LblInvoicePaymentHistory",
	    LblPaymentMode: "LblPaymentMode",
	    LblLogTime: "LblLogTime",
	    LblNoPaymentLinkGenerated: "LblNoPaymentLinkGenerated",
	    //Payment Module
	    LblAllowPaymentConfiguration: "LblAllowPaymentConfiguration",
	    LblAllowPayment: "LblAllowPayment",
	    LblPaymentSetting: "LblPaymentSetting",
	    LblEnvironment: "LblEnvironment",
	    LblInvoicePaymentTermDays: "LblInvoicePaymentTermDays",
	    LblLinkValidityDays: "LblLinkValidityDays",
	    LblPaymentMethods: "LblPaymentMethods",
	    LblPaymentProviderSecretKey: "LblPaymentProviderSecretKey",
	    LblPaymentProviderUsername: "LblPaymentProviderUsername",
	    LblCreditCardPayment: "LblCreditCardPayment",
	    LblInitialPayment: "LblInitialPayment",
	    LblCreateBookingPayment: "LblCreateBookingPayment",
	    LblStartBookingPayment: "LblStartBookingPayment",
	    LblPaymentLink: "LblPaymentLink",
	    LblPaymentHistory: "LblPaymentHistory",
	    LblReasonOrganization: "LblReasonOrganization",
	    LblDueDateUpdateSuccess: "LblDueDateUpdateSuccess",
	    LblDueDateRequiredError: "LblDueDateRequiredError",
	    LblDueDate: "LblDueDate",
	    LblConfirmDuedatechange: "LblConfirmDuedatechange",
	    LblConfirmCloseInvoice: "LblConfirmCloseInvoice",
	    LblConfirmReOpenInvoice: "LblConfirmReOpenInvoice",
	    LblInvoiceOpenCloseSuccess: "LblInvoiceOpenCloseSuccess",
	    LblReOpen: "LblReOpen",
	    LblClosed: "LblClosed",
	    LblReOpenClose: "LblReOpenClose",
	    PR_COST_EXPENSES: "PR_COST_EXPENSES",
	    PR_COST_CENTER_REPORT: "PR_COST_CENTER_REPORT",
	    LblInactiveAfterDays: "LblInactiveAfterDays",
	    LblMarkDeleteAfterDays: "LblMarkDeleteAfterDays",
	    LblNotifyAdminBeforeDays: "LblNotifyAdminBeforeDays",
	    LblGdprSettings: "LblGdprSettings",
	    LblRemovalDate: "LblRemovalDate",
	    LblRemovePersonOn: "LblRemovePersonOn",
	    PR_PAYMENT_HISTORY_LIST: "PR_PAYMENT_HISTORY_LIST",
	    LblUserBlockMessage: "LblUserBlockMessage",
	    PR_BLOCK_UNBLOCK_ORGANIZATION: "PR_BLOCK_UNBLOCK_ORGANIZATION",
	    LblWhenOpeningAppAndRepeat: "LblWhenOpeningAppAndRepeat",
	    LblEveryTimeOpenApp: "LblEveryTimeOpenApp",
	    LblWhenMakeBooking: "LblWhenMakeBooking",
	    LblWhenStartBooking: "LblWhenStartBooking",
	    LblWhenOpenBooking: "LblWhenOpenBooking",
	    LblSelectContractTypeGroup: "LblSelectContractTypeGroup",
	    LblDays: "LblDays",
	    LblNewVersion: "LblNewVersion",
	    LblAction: "LblAction",
	    LblTAndCName: "LblTAndCName",
	    LblOldVersion: "LblOldVersion",
	    LblSureToRevoke: "LblSureToRevoke",
	    LblReportedOn: "LblReportedOn",
	    LblCurrencyConfiguration: "LblCurrencyConfiguration",
	    LblNameSingular: "LblNameSingular",
	    LblNamePlural: "LblNamePlural",
	    //Special Period
	    LblRegularBooking: "LblRegularBooking",
	    LblSpecialRate: "LblSpecialRate",
	    LblFirstDay: "LblFirstDay",
	    LblLastDay: "LblLastDay",
	    LblWeekEndContaining: "LblWeekEndContaining",
	    LblSignBeforeAmount: "LblSignBeforeAmount",
	    //Credit card payment
	    LblCrediCardPayment: "LblCrediCardPayment",
	    LblFirstBooking: "LblFirstBooking",
	    LblAllowRecurringPayment: "LblAllowRecurringPayment",
	    LblProceed: "LblProceed",
	    LblCheckAllowPayment: "LblCheckAllowPayment",
	    LblPaymentFailed: "LblPaymentFailed",
	    LblPaymentSuccess: "LblPaymentSuccess",
	    LblPaymentFailure: "LblPaymentFailure",
	    LblCompletedSuccess: "LblCompletedSuccess",
	    LblCompletedFailure: "LblCompletedFailure",
	    LblCreditCardNumber: "LblCreditCardNumber",
	    LblCreditCardExpirationDate: "LblCreditCardExpirationDate",
	    LblCreditCardDetails: "LblCreditCardDetails",
	    LblMakePayment: "LblMakePayment",
	    LblAdminPaymentConfirmation: "LblAdminPaymentConfirmation",
	    LblPaymentDescription: "LblPaymentDescription",
	    LblPay: "LblPay",
	    LblOutOf: "LblOutOf",
	    // NIF Number
	    LblEnableNIFNumber: "LblEnableNIFNumber",
	    LblNIFNumber: "LblNIFNumber",
	    LblWeGoDefault: "LblWeGoDefault",
	    LblPersonActiveSuccess: "LblPersonActiveSuccess",
	    LblActivate: 'LblActivate',
	    LblInActiveReason: "LblInActiveReason",
	    LblDefaultLanguage: 'LblDefaultLanguage',
	    LblRestoreInheritConfirmation: "The current settings will be overridden by the inherited settings. Are you sure?",
	    LblQestionTextRequired: "Question text required",
	    LblManualSecretKey: "Secret Key",
	    // Two Factor Authentication
	    LblTwoFaConfig: "Two Factor Authentication",
	    LblEnableTwoFa: "Enable Two Factor Authentication",
	    LblExpirationDays: "Expiration Days",
	    LblTextBoxExpirationDays: "expiration days",
	    Lbl2FactorAuthenticateExpDays: "2FA expiration period (days):",
	    LblResetCookiesWegoAdmin: "Reset cookies for all WeGo admin",
	    LblReset2FactorAuthWegoAdmin: "Reset all 2FA for all WeGo admin",
	    LblAuthentication: "Authentication",
	    LblResetCookiesForAllAdmin: "Reset Cookies for all admin",
	    LblReset2FaForAllAdmin: "Reset 2FA for all admin",
	    LblEnterTotp: "Please enter code",
	    LblEnterOtp: "Please enter code",
	    LblSubmit: "Submit",
	    LblKeyResetSuccess: "2FA Key has been reset",
	    LblKeyResetFailed: "2FA Key reset failed",
	    LblCookieResetSuccess: "2FA cookies has been reset",
	    LblCookieResetFailed: "2FA cookies reset failed",
	    LblGoogleAuthenticator: "Google Authenticator App",
	    LblEmailOtpSent: "A code has been sent to your registered email address",
	    LblContinue: "Continue",
	    LblInvalidTOTP: "Invalid TOTP",
	    LblResetCookie: "Reset Cookie",
	    LblResetTwoFA: "Reset 2FA",
	    LblDisableTwoFA: "Disable 2FA",
	    LblTwoFaMethod: "2-Factor Method",
	    LblEmailAuthentication: "Email Authentication",
	    LblTwoFaMethodSelect: "You will need to verify your identity one more time. Please select your two factor authentication method",
	    LblInvoicePreFix: "Invoice Prefix",
	    LblEngineStillRunning: 'LblEngineStillRunning',
	    LblMobileAppLink: "Mobile App Link",
	    LblCountry: "Country",
	    LblFileNotFound: "The File does not exist, contact the helpdesk",
	    // Track & Trace
	    LblTrackAndTrace: "Track & Trace",
	    LblRfidTagId: "RFID Tag ID",
	    LblEmployeeNumber: "Employee number",
	    BtnAddVehicleInfo: "Mostrar registro de vts",
	    // Access Card
	    LblAccessCardId: "Access Card ID",
	    LblDriversLicenseAndCertificates: "Driver's license and certificates",
	    LblLicense: "Driver's license",
	    LblCertificates: "Certificates",
	    LblTrips: "Trips",
	    LblCostsSummary: "Costs Summary",
	    LblStartBooking: "Start booking",
	    LblStopBooking: "Stop booking",
	    LblTripHistory: "Trip history",
	    LblTripStartDateTime: "From",
	    LblTripEndDateTime: "To",
	    LblFaZTripQuestions: "FaZ questions",
	    LblNoQuestionsFound: "No FaZ questions found.",
	    LblNoTripsFound: "No trips found.",
	    LblTripDetails: "Trip details",
	    LblUnansweredQuestions: "Unanswered Questions",
	    LblNoUnansweredQuestions: "No unanswered Questions",
	    LblAnswerSaved: "The answer is successfully saved",
	    LblAnswerSavedError: "The answer could not be saved. Please contact the Administrator",
	    LblAnswerEmptyError: "Please enter a valid answer",
	    ValidatePhoneNumberVts: "Please enter valid phone number (e.g. +31623456789)",
	    LblInfo: "Información",
	};


/***/ },
/* 76 */
/***/ function(module, exports) {

	// https://scotch.io/tutorials/simple-language-translation-in-angular-2-part-2
	"use strict";
	// lang-pt.ts
	// 'hello world': 'hello world',
	// 'hello greet': 'Hello, %0 %1!',
	// 'well done': 'Well done %0',
	// 'good bye': 'bye bye',
	exports.LANG_PT_NAME = "pt";
	exports.LANG_PT_TRANS = {
	    LblWeekdays: {
	        shorthand: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
	        longhand: [
	            "Domingo",
	            "Segunda-feira",
	            "Terça-feira",
	            "Quarta-feira",
	            "Quinta-feira",
	            "Sexta-feira",
	            "Sábado"
	        ]
	    },
	    LblMonths: {
	        shorthand: [
	            "Jan",
	            "Fev",
	            "Mar",
	            "Apr",
	            "Mai",
	            "Jun",
	            "Jul",
	            "Ago",
	            "Set",
	            "Out",
	            "Nov",
	            "Dez"
	        ],
	        longhand: [
	            "Janeiro",
	            "Fevereiro",
	            "Março",
	            "Abril",
	            "Maio",
	            "Junho",
	            "Julho",
	            "Agosto",
	            "Setembro",
	            "Outubro",
	            "Novembro",
	            "Dezembro"
	        ]
	    },
	    LblButtonText: {
	        today: "Hoje",
	        month: "MÊS",
	        week: "SEMANA",
	        day: "Dia",
	        list: "Lista"
	    },
	    // Common Name
	    LblActivityLog: "Registo de atividade",
	    LblEdit: "Editar",
	    LblDelete: "Excluir",
	    LblRemove: "Remover",
	    LblActiveInactive: "Ativo/Inativo",
	    LblActive: "Ativo",
	    LblInactive: "Desativar",
	    LblInactiveReason: "Razão de inativaçāo",
	    LblAddNew: "Adicionar novo",
	    LblAdd: "Adicionar",
	    LblUpdate: "Atualizar",
	    LblSave: "Salvar",
	    LblCancel: "Anular",
	    LblReset: "Reiniciar",
	    LblSelect: "Selecionar",
	    LblSuccess: "Sucesso",
	    LblWarning: "Atenção",
	    LblList: "Lista",
	    LblAssign: "Atribuir",
	    LblHome: "Pagina Inicial",
	    LblYes: "Sim",
	    LblOK: "Ok",
	    LblNo: "Não",
	    LblBack: "Retornar",
	    LblReason: "Razão",
	    LblRecordSavedSuccess: "Salvo com sucesso",
	    LblRecordDeleteSuccess: "Excluido com sucesso",
	    LblResetPasswordSuccess: "Senha redefinida com sucesso",
	    LblConfirm: "Confirmar",
	    LblBlockUnblockConfirm: "Tem a certeza que pretende passar de 1% para 0%?",
	    LblRecordDeleteConfirmation: "Tem a certeza que pretende remover os 0%?",
	    LblRecordMultiplDeleteConfirmation: "Tem a certeza que pretende remover os 0% selecionados?",
	    LblConfirmMessage: "Você tem certeza?",
	    LblResetPassword: "Redefinir senha",
	    LblResetPasswordConfirmation: "Tem a certeza que pretende redefinir a sua senha?",
	    LblGeoLocationError: "Insira a geolocalização correta",
	    LblPersonDeleteCheck: "Excluir permanentemente",
	    LblRejection: "Rejection",
	    LblrejectionReasonMsg: "Please Provide Reason For rejection of selected booking requests",
	    LblApproveConfirmationMsg: "Are You Sure you want to approve all selected booking request?",
	    LblBookingCancelSuccess: "Reserva cancelada com sucesso",
	    LblBookingApprovedSuccessMsg: "Pedidos de reservas selecionados aprovados com sucesso",
	    LblBookingRejectedSuccessMsg: "Pedidos de reservas selecionados rejeitados com sucesso",
	    LblBookingAbortSuccess: "Reserva interrompida com sucesso",
	    LblBookingRevokeSuccess: "Reserva rescindida com sucesso",
	    LblContactPersonRemoveSuccess: "Contato removido com sucesso",
	    LblContactPersonAddedSuccess: "Contato adicionado com sucesso",
	    LblNoRecords: "Registo não disponível",
	    LblAffectedBookingList: "Lista com reservas afetadas",
	    LblSubscriptionEndDateError: "Insira a data de término da subscrição",
	    LblIsSpecialPeriodAllow: "Deseja solicitar o período de custo especial? Se aplicável",
	    LblContractSlotisnotdefined: "O tipo de contrato não está definido para o período abaixo indicado",
	    LblUnscubscribeSuccess: "subscrição cancelada com sucesso",
	    LblModifiedBy: "Modificado por",
	    LblModifiedDate: "Data de Modificação",
	    LblContractTypeGroupAvailableForSubscription: "Não existe um grupo para o tipo de contrato para adicionar novo 0%",
	    LblRemoveContactPersonConfirm: "Tem a certeza que pretende remover o contacto?",
	    LblBookingApproveRejectSuccess: "%0 %1 com sucesso.",
	    LblRecordAddedSuccess: "%0 added successfully.",
	    LblRecordUpdatedSuccess: "%0 atualizado com sucesso.",
	    LblRecordRemovedSuccess: "0% excluído com sucesso.",
	    LblRecordActiveInActiveSuccess: "%0 %1 com sucesso.",
	    LblinvoiceResendSuccess: "%0 enviado novamente com sucesso.",
	    LblRecordBlokUnBlockSuccess: "%0 %1 com sucesso.",
	    LblEditPage: "Editar %0",
	    LblAddPage: "Adicionar %0",
	    LblListPage: "%0 List",
	    LblKilometers: "Quilómetro",
	    LblKM: "Km",
	    LblRecordUnBlockedSuccess: "%0 desbloqueado com sucesso",
	    LblDeletePersonNote: "As faturas pendentes para essa pessoa não serão enviadas",
	    //Instance Page
	    LblWegoAdminDependencyValidation: "Administrador WeGo não pode ser removido por estar associado a outra entidade",
	    LblCarwiseEnable: "Carwise Enabled",
	    LblAdminDependencyValidationOnDelete: "Administrador selecionado não pode ser removido por estar associado a outra entidade",
	    LblAdminDependencyValidation: "função de administrador não pode ser removido por estar associado a outra entidade",
	    LblAdminDependencyAlert: "Pendente de validação do administrador",
	    LblCarwiseConfiguration: 'Configuração "Carwise"',
	    LblCarwiseConnectionUrl: "URL de ligação",
	    LblCarwiseConnectionUsername: "Nome de utilizador de ligação",
	    LblCarwiseConnectionPassword: "Senha de acesso de ligação",
	    LblCarwiseAutoDeleteFrequencyInDays: "Eliminação periódica automática (Em dias)",
	    LblInstance: "Instância",
	    LblInstanceName: "Nome da instância",
	    LblInstanceType: "Tipo de instância",
	    LblDescription: "Descrição",
	    LblCurrencySymbol: "Símbolo de moeda",
	    LblPreferredLanguage: "Língua",
	    LblTimeZone: "fuso horário",
	    LblCurrencyAbbreviation: "Abreviação de moeda",
	    LblInstanceDeleteValidation: "Não é possível excluir a instância por estar associada a outra entidade ",
	    LblIsBookingApprovalReq: "É necessária aprovação da reserva",
	    LblInstanceConfiguration: "Configuração de instância",
	    LblBookingAlertTime: "Tempo de alerta de reserva",
	    LblBookingCancelTime: "Tempo de cancelamento de reserva",
	    LblBookingTemporaryTime: "Tempo de reserva provisório",
	    LblVtsRequestTimeout: "Pedido do sistema de localização do veículo excedido",
	    LblVtsTripLogTimeout: "Tempo de diário de viagem do sistema de localização do veículo excedido",
	    LblEmailConfiguration: "Configuração de email (SMTP)",
	    LblInSeconds: "Em segundos",
	    LblFromEmail: "Do email",
	    LblHost: "Convidado",
	    LblPort: "Porta",
	    LblEnableSsl: "Ativar SSL",
	    LblSmtpEmail: "SMTP Email",
	    LblBookingCancelTimeMessage: "Tempo (em segundos) após o qual não poderá cancelar a reserva.",
	    LblBookingTemporaryTimeMessage: "Data para reserva provisória. O usuário já selecionou o veículo para a reserva mas ainda não confirmou.",
	    LblVtSRequestTimeoutMessage: "Tempo esgotado para utilização do comando Abrir/Fechar na App",
	    LblVtsTriplogTimeoutMessage: "Tempo esgotado para o cálculo da viagem após utilização do comando Fechar",
	    LblContractTypeDeleteValidation: "Não é possível excluir o grupo do tipo de contrato porque está associado a outra entidade ",
	    LblSelectFuelType: "Selecione tipo de combustível",
	    LblSelectPricingCatagory: "Selecione categoria de preço",
	    LblSelectBodyStyle: "Selecione o modelo",
	    LblSelectVehicleClass: "Selecione classe de veículo",
	    LblIsImportPersonAllow: "Permitir importar pessoa",
	    LblValidateLicenseA2SP: "Validar carta de condução com A2SP",
	    LblValidateLicense24IDCheck: "Validar carta de condução com 24ID",
	    LblValidateLicenseForAllBookings: "Revalida carta de condução para todas as reservas",
	    LblGeofenceLocation: "Perímetro de localização geográfica",
	    LblRadius: "Raio",
	    LblEmailRecepients: "Destinatários do e-mail",
	    LblRecepients: "Destinatários",
	    LblEmailAddresses: "E-mail",
	    LblMap: "Mapa",
	    // AFAS/Azure Config
	    LblImportConfiguration: "Import Configuration",
	    LblImportConnectionType: "Connection Type",
	    LblAfas: "AFAS",
	    LblAzure: "Azure",
	    LblAzureTenantId: "Azure Tenant ID",
	    LblAzureClientId: "Azure Client ID",
	    LblAzureClientSecret: "Azure Client Secret",
	    LblAfasClientId: "AFAS Client ID",
	    LblAfasConnectorName: "AFAS Connector Name",
	    LblAfasConnectionType: "AFAS Connection Type",
	    LblAfasTest: "Test",
	    LblAfasAccept: "Acceptation",
	    LblAfasProduction: "Production",
	    LblAfasToken: "AFAS Token",
	    LblAfasClientIdError: "Please enter AFAS Client ID",
	    LblAfasConnectorNameError: "Please enter AFAS Client ID",
	    LblAfasConnectionTypeError: "Please enter AFAS Connection Type",
	    LblAfasTokenError: "Please enter AFAS-Token",
	    LblAzureTenantIdError: "Please enter Azure Tenant ID",
	    LblAzureClientIdError: "Please enter Azure Client ID",
	    LblAzureClientSecretError: "Please enter Azure Client Secret",
	    // SSO Config
	    LblSsoConfiguration: "SSO Configuration",
	    LblDefaultSsoSharedVehicleGroup: "Default Shared Vehicle Group",
	    LblDefaultSsoOrganization: "Default Organization",
	    LblDefaultSsoSubscription: "Default Subscription",
	    // Dropoff Message
	    LblDropoffMessageConfiguration: "Dropoff Message Configuration",
	    LblDropoffMessageExternalUrl: "External Url",
	    LblDropoffMessageApiKey: "Api Key",
	    LblDropoffMessageActive: "Active",
	    LblValidate: "Validar",
	    LblBookingCalanderSettings: "Configuração do calendário de reservas",
	    LblShowDriverInfo: "Mostrar informações do condutor no calendário de reservas",
	    LblOrganizationAdmin: "Administrador da organização",
	    LblDriverInfoToShow: "Informação do condutor a apresentar",
	    //Person Page
	    LblUserName: "Usuário",
	    LblFirstName: "Nome",
	    LblLastName: "Sobrenome",
	    LblEmail: "Email",
	    LblMobileNumber: "Número de telemóvel",
	    LblPhoneNumber: "Número de telefone fixo",
	    LblHomeAddress: "Endereço de residência",
	    LblWorkAddress: "Endereço profissional",
	    LblHouseNo: "Número da residência",
	    LblHouseExtention: "Andar",
	    LblStreetName: "Rua",
	    LblCity: "Cidade",
	    LblZipCode: "Código Postal",
	    LblPassword: "Senha",
	    LblConfirmPassword: "Confirmar senha",
	    LblMiddleName: "Nome do meio",
	    LblMandateId: "ID do mandato",
	    LblMandateSignatureDate: "Data da assinatura do mandato",
	    LblIsAmmandment: "É uma emenda",
	    LblRemovePersonDetails: "Excluir informação de utilizador",
	    //Instance Clone
	    LblInstanceClone: "Cópia da instância",
	    LblNewInstanceName: "Nome da nova instância",
	    LblCloneResult: "Clone Result",
	    LblCloneStatus: "Clone Status",
	    CloneError: "Ocorreu um erro ao copiar a instância e toda a sua informação",
	    //Company Page
	    LblCompany: "Empresa",
	    LblCompanyName: "Nome da Empresa",
	    LblContactPerson: "Pessoa de contato",
	    LblCompanyAdmin: "Administrador da empresa",
	    LblCompanyAddress: "Endereço da empresa",
	    LblInternalOrganization: "Organização interna",
	    LblNoOfVegicles: "Número de veículos",
	    LblNoOfSharedVehicleGroups: "Número de grupos de veículos partilhados",
	    LblGeoLocation: "Geolocalização",
	    LblSelectGeoLocation: "Selecione localização",
	    LblPerson: "Pessoa",
	    LblRole: "Função",
	    LblDateOfBirth: "Data de nascimento",
	    LblDriverLicenceNumber: "Número da licença de condução",
	    LblApkExiprationSetting: "Configurações de notificações da inspeção do veículo",
	    LblApkTimeInterval: "período de tempo de notificação",
	    LblEmailNotification: "Notificação por e-mail",
	    LblNotificationFrequency: "Frequência de notificações",
	    lblThresholdFrequency: "Limite de frequência",
	    lblThresholdTimeInterval: "Limite do período de tempo",
	    LblIsEmailEnabled: "Notificação de e-mail",
	    lblThreshold: "Limite de período de tempo",
	    LblFrequency: "Frequência",
	    LblDay: "Dia",
	    LblWeek: "SEMANA",
	    LblMonth: "Mês",
	    lblPerBooking: "Por reserva",
	    LblPersons: "Pessoas",
	    LblPersonOverview: "Resumo da pessoa",
	    LblCompanies: "Empresas",
	    //Vehicle Page
	    LblVehicle: "Veículo",
	    LblVtsVehicle: "sistema de localização do veículo",
	    LblFleetId: "ID da frota",
	    LblContractId: "ID do contato",
	    LblVIN: "Número de chassis",
	    LblLicenceTag: "Matrícula",
	    LblLicence: "Licença",
	    LblMobile: "Telemóvel",
	    LblVehicleOwner: "Proprietário do veículo",
	    LblLocationDataExchange: "Sincronização da informação de localização",
	    LblBrand: "Marca",
	    LblType: "Tipo",
	    LblColor: "Cor",
	    LblVehicleClass: "Classe de veículo",
	    LblPricingCategory: "Categoria de preço",
	    LblBodyStyle: "Carroçaria",
	    LblAvailable: "Disponível",
	    LblUnAvailable: "Não disponível",
	    LblAvailableFrom: "Disponível a partir de",
	    LblAvailableTo: "Disponível até",
	    LblFuelType: "Tipo de combustível",
	    LblMinBookingTimeBefore: "Tempo mínimo antes de reserva (minuto)",
	    LblMinBookingTimeAfter: "Tempo mínimo após reserva (minuto)",
	    LblTowbar: "Gancho de reboque",
	    LblAirco: "Ar condicionado",
	    LblVehicleAttributes: "Atributos de veículo",
	    LblBlockUnBlock: "Bloquear/Desbloquear",
	    LblRemoveLicense: "Excluir Carta de Condução",
	    LblRemoveLicenseBirthDate: "Excluir Data Carta de condução e Data de Nascimento",
	    LblLicenseBirthDate: "Data Carta de condução e Data de Nascimento",
	    LblBlock: "Bloquear",
	    LblUnblock: "Desbloquear",
	    LblAvailableUnAvailable: "Disponível/Indisponível",
	    LblVehicles: "Veículos",
	    LblBookingsOverview: "Resumo das reservas",
	    LblApkExpirationDateCet: "Data limite da inspeção do veículo",
	    LblEnabled: "Ativar",
	    LblDisabled: "Desativar",
	    LblIntialOdometerValue: "Valor inicial do conta-quilómetros",
	    LblFuelCardPinCode: "Código PIN do cartão de combustível",
	    LblDropoffMessage: "Mensagem de entrega",
	    LblPreferredlanguage: "Idioma preferido",
	    LblDebtornr: "Número do devedor",
	    LblFuel: "Fuel",
	    LblVINnumber: "VIN number",
	    LblVehicletype: "Vehicle type",
	    LblDoors: "Number of doors",
	    LblWeight: "Vehicle weight",
	    LblTrunkSpace: "Trunk space",
	    LblGears: "Number of gears",
	    LblEngineHorsepower: "Engine horsepower (hp)",
	    LblFuelConsumption: "Fuel consumption",
	    LblSeats: "Number of seats",
	    LblDimensions: "Vehicle dimensions",
	    LblTransmissionType: "Transmission type",
	    LblTransmissionUnknown: "Unknown",
	    LblManualTransmission: "Manual",
	    LblAutomaticTransmission: "Automatic",
	    LblVehicleDetails: "Vehicle details",
	    LblSelectVehicletype: "Select vehicle type",
	    LblWrongVinNumber: "Wrong VIN number",
	    //WEGO2DEV-325(Settings for Dashboard statuses)
	    LblVehicleOnSameLocationTime: "Veículo na mesma localização mais do que",
	    LblNoBookingIn: "Veículo sem reservas há mais de ",
	    lblHour: "Hora",
	    lblHourDayWeekMonth: "Hora / dia / semana / mês",
	    //SharedVehicleGroup
	    LblSharedVehicleGroup: "Grupo de veículos partilhados",
	    LblVehicleGroup: "Grupo de veículo",
	    LblSharedVehicleGroupAdmin: "Administrador de grupo de veículo partilhados",
	    LblDisplayPeriod: "Exibir período",
	    LblBookingWeekDays: "Dias disponivéis",
	    LblBookingInterval: "Intervalo da reserva (minutos)",
	    LblBookingStartTime: "Reserva a partir de (hh:mm)",
	    LblBookingEndTime: "Reserva até (hh:mm)",
	    LblBookingMinDuration: "Tempo mínimo da reserva (minutos)",
	    LblBookingMaxDuration: "Tempo máximo da reserva (minutos)",
	    LblMaxRecurringBooking: "Máximo de reservas recorrentes",
	    LblPreBookingInterval: "Período pré-reserva (min)",
	    LblPostBookingInterval: "Período pós-reserva (min)",
	    LblBookingExtensionTime: "Tempo máximo de prolongamento (min)",
	    LblBookAheadTime: "Reserva possível daqui a X min",
	    LblBookingHorizon: "Horizonte da reserva",
	    LblNumberOfContactTypeGroup: "Número de grupo de tipo de contrato",
	    LblNumberOfContactType: "Número de tipos de contrato",
	    LblInvoiceInterval: "Período de faturação",
	    LblIsBookingIntervalAlignToCalendar: "Alinhamento do período de reserva no calendário",
	    LblBookings: "Reservas",
	    LblSharedVehicleGroups: "Grupos de veículos partilhados",
	    LblSharedVehicleGroupOverview: "Resumo de grupos de veículos compartilhados",
	    LblEarlyOpenInterval: "Intervalo de abertura adiantada (min)",
	    //Driver
	    LblDriver: "Motorista",
	    LblLicenceNumber: "Número da carta de condução",
	    LblDriverName: "Nome do condutor",
	    LblDriverSVG: "Condutor do grupo de veículos partilhados",
	    LblDriverUserName: "Nome de utilizador",
	    //VehicleAttribute
	    LblVehicleAttributeCategory: "Categoria de características do veículo",
	    LblVehicleAttributeName: "Característica",
	    LblVehicleAttributeDesc: "Descrição",
	    LblVehicleAttribute: "Característica do veículo",
	    LbAdditionallVehicleAttribute: "Additional Vehicle Attributes",
	    LblVehicleAttributeCategories: "Categorias das características do veículo",
	    //ContractType Page
	    LblRegular: "Regular",
	    LblWeekEnd: "Fim de semana",
	    LblDayCT: "Dia",
	    LblExtraTimeBefore: "Tempo extra antes (Minutos)",
	    LblExtraTimeAfter: "Tempo extra depois (Minutos)",
	    LblFreeTextDescription: "Especifique a taxa de reserva especial mais os horários de início e término (texto livre)",
	    LblPeriodRate: "Período de tarifa",
	    LblPeriodRateVat: "Período de tarifa",
	    LblSelectContractTypeType: "Selecione tipo de tipo de contrato",
	    LblContractTypeType: "Tipo de tipo de contrato",
	    LblContractType: "Tipo de contrato",
	    LblContractName: "Nome do contrato",
	    LblContractTypeGroup: "Grupo de tipo de contrato",
	    LblContractTypeGroupName: "Nome do grupo de tipo de contrato",
	    LblContractAvailableDays: "Dias disponíveis do contrato",
	    LblApplicableDays: "Dias aplicavéis",
	    LblDayStartTime: "Início do horário (hh:mm)",
	    LblDayEndTime: "Fim do horário (hh:mm)",
	    LblApplicableStartTime: "Início do tempo aplicável (hh:mm)",
	    LblApplicableEndTime: "Fim do tempo aplicável (hh:mm)",
	    LblComment: "Observação",
	    LblProcessingFee: "Taxa administrativa",
	    LblVatPercentage: "percentagem de IVA",
	    LblVatIncludedInPrice: "IVA incluído no preço",
	    LblPlateformUsageCost: "Custo de utilização da plataforma",
	    LblCatA: "Categoria A",
	    LblCatB: "Categoria B",
	    LblCatC: "Categoria C",
	    LblCatD: "Categoria D",
	    LblCatE: "Categoria E",
	    LblCatF: "Categoria F",
	    LblCatG: "Categoria G",
	    LblCatH: "Categoria H",
	    LblHourlyRate: "Preço por hora",
	    LblMileageRate: "Valor por quilómetro",
	    LblFixedFee: "Taxa fixa",
	    LblPricingModel: "Modalidade de preço",
	    LblContractStartDateTime: "Data/hora do início de contrato",
	    LblContractEndDateTime: "Data/hora do fim de contrato",
	    LblContractTypeHistory: "Histórico",
	    LblContractTypPeriod: "Período do contrato tipo",
	    LblInactiveContractTypeGroupReason: "Razão da desactivação do grupo de tipo de contrato",
	    LblPenaltyAmount: "Valor da penalização",
	    LblPenaltyTimeInterval: "período de tempo de penalização (minuto)",
	    LblIsPenaltyEnabled: "Penalização ativada",
	    LblTripDisplayType: "Como devem ser apresentadas as viagens nos relatórios?",
	    LblAllTripsIndividually: "Por viagem, individualmente",
	    LblAllTripsGrouped: "Agrupadas, todas as viagens numa só",
	    // DateTime Picker
	    LblJanuary: "Janeiro",
	    LblFebruary: "Fevereiro",
	    LblMarch: "Março",
	    LblApril: "Abril",
	    LblMay: "Maio",
	    LblJune: "Junho",
	    LblJuly: "Julho ",
	    LblAugust: "Agosto",
	    LblSeptember: "Setembro",
	    LblOctober: "Outubro",
	    LblNovember: "Novembro",
	    LblDecember: "Dezembro",
	    LblSJan: "Jan",
	    LblSFeb: "Fev",
	    LblSMar: "Mar",
	    LblSApr: "Abr",
	    LblSMay: "Mai",
	    LblSJun: "Jun",
	    LblSJul: "Jul",
	    LblSAug: "Ago",
	    LblSSep: "Set",
	    LblSOct: "Out",
	    LblSNov: "Nov",
	    LblSDec: "Dez",
	    LblSunday: "Domingo",
	    LblMonday: "Segunda-feira",
	    LblTuesday: "Terça-feira",
	    LblWednesday: "Quarta-feira",
	    LblThursday: "Quinta-feira",
	    LblFriday: "Sexta-feira",
	    LblSaturday: "Sábado",
	    LblSSu: "Dom",
	    LblSMo: "Seg",
	    LblSTu: "Ter",
	    LblSWe: "Qua",
	    LblSTh: "Qui",
	    LblSFr: "Sex",
	    LblSSa: "Sáb",
	    //Forgot Password
	    LblForgotPassword: "Esqueci-me da senha",
	    LblChangePassword: "Alterar senha",
	    LblOldPassword: "Senha antiga",
	    LblNewPassword: "Senha",
	    LblProfileUpdatedSucessFully: "Perfil atualizado com sucesso",
	    LblPasswordChangedSucessFully: "Senha alterada com sucesso",
	    //
	    LblUpdateProfile: "Atualizar perfil",
	    LbLReasonVehicle: "Causa da indisponibilidade",
	    LblReasonDriver: "Causa do bloqueio do condutor",
	    //Booking
	    LblFrom: "De",
	    LblTo: "Até",
	    LblBooking: "Reserva",
	    LblApprovalAdminName: "Nome de administrador de aprovação",
	    LblApprovedRejectedby: "Approved/Rejected by",
	    LblBookingRequestList: "Booking Request List",
	    LblBookingRequest: "Pedido de reserva",
	    LblOverview: "Resumo de reserva",
	    LblOverviewList: "Lista de reservas",
	    LblApproveBooking: "Aprovação da reserva",
	    LblApprove: "Aprovar",
	    LblReject: "Recusar",
	    LblNormal: "Reserva normal",
	    LblSpecial: "Reserva especial",
	    LblHistory: "História das reservas",
	    LblBookingStatus: "Situação da reserva",
	    LblBookingType: "Tipo de reserva",
	    LblAdminRemarks: "Observação do administrador",
	    LblBookingRemarks: "Observações da reserva",
	    LblDriverRemarks: "Observação do condutor",
	    LblBookingReferenceId: "Número da reserva",
	    LblAbort: "Interromper",
	    LblRevoke: "Rescindir",
	    LblStatus: "Estado",
	    LblReference: "Número da referência",
	    LblRemarks: "Observações",
	    LblSearchForVehicle: "Procura por veículo",
	    LblVehicleOverview: "Resumo do veículo",
	    LblConfirmBooking: "Confirmar reserva",
	    LblCurrentBookingDetail: "Detalhes da reserva actual",
	    LblCheckAvailability: "Verificar disponibilidade",
	    LblBookingStartDateTime: "Início da reserva",
	    LblBookingEndDateTime: "Fim da reserva",
	    LblSource: "minha localização atual",
	    LblRecurring: "Recorrente",
	    LblRecurringId: "ID recorrente",
	    LblRecurringBookingReference: "ID de reserva recorrente",
	    LblDaily: "Diária",
	    LblWeekly: "Semanal",
	    LblMonthly: "Mensal",
	    LblRecurrenceEndDate: "Repetiação da data final",
	    LblSearch: "Procurar",
	    LblBookNow: "Reservar agora",
	    LblUpdateBooking: "Alterar reserva",
	    LblEditCarNotAvailable: "Veículo original reservado não está disponível",
	    LblSortBy: "Ordenar por",
	    LblAvaibility: "Disponibilidade",
	    LblDistance: "Distância",
	    LblNoMatchingVehicle: "Não existe nenhum veículo correspondente",
	    LblAvailableSlots: "Períodos disponíveis",
	    LblFeatures: "Características",
	    LblDriverDetail: "Dados do condutor",
	    LblBookingDetail: "Dados da reserva",
	    LblVehicleDetail: "Dados do veículo",
	    LblBookingSuccess: "Pedido de reserva efetuada com sucesso. O seu pedido está pendente de validação. Será notificado quando a reserva for aceite.",
	    LblBookingUpdateSuccess: "Reserva atualizada com sucesso. Notificação enviada para o e-mail do condutor.",
	    LblBlockNormalBooking: "A sua conta encontra-se bloqueada. Entre em contacto com administrador de conta.",
	    LblSingle: "Único",
	    LblSeries: "Série",
	    LblAll: "Todos",
	    SelectionRequiredMsg: "Por favor selecione pelo menos um pedido para aprovar/rejeitar",
	    LblSelectionRequired: "Selection Required",
	    LblLicenceRequired1: "Por favor, verifique o número da sua licença, Ir para",
	    LblLicenceRequired2: "Atualizar detalhes da licença",
	    LblAcceptOrReject: "Aprovar/Rejeitar",
	    //Special Booking
	    LblSpecialBooking: "Reserva especial",
	    LblAffectedBooking: "Reserva envolvida",
	    LblSpecialBookingType: "Tipo de reserva especial",
	    LblSelectSpecialBookingType: "Selecionar tipo de reserva especial",
	    LblSpecialBookingConfiramtionmsg: "Tem a certeza que pretende criar uma reserva especial?",
	    LblEndDate: "Data final da recorrência",
	    // Notification
	    LblNotification: "Notificação",
	    LblSubject: "Assunto",
	    LblDate: "Data",
	    LblWelcomeNotification: "Bem-vindo à caixa de entrada de notificações da WeGo",
	    //Template
	    LblTemplate: "Modelo",
	    LblTemplateList: "Lista de modelos",
	    LblTemplateName: "Nome de modelos",
	    LblTemplateType: "Tipo de modelos",
	    LblBody: "Corpo",
	    LblIsEmailTemplate: "E-mail",
	    LblIsWebTemplate: "Rede",
	    // Notification Event Management
	    LblNotificationEventManagement: "Gestão de notificações de eventos",
	    LblNotificationEvent: "Notificação do evento",
	    LblModuleName: "Nome do módulo",
	    LblSMS: "SMS",
	    //User Type
	    LblUserType: "Tipo de utilizador",
	    //TimeBlock
	    LblTimeBlock: "Período temporal",
	    LblTimeBlockName: "Nome do período temporal",
	    LblTimeBlockWeekDays: "Dias úteis do período temporal",
	    LblTimeBlockStartDate: "Data de início do período temporal",
	    LblTimeBlockStartTime: "Início do período temporal",
	    LblTimeBlockEndDate: "Data de fim do período temporal",
	    LblTimeBlockEndTime: "Fim do período temporal",
	    // Service Offer
	    LblServiceOffer: "Oferta de serviços",
	    LblServiceOfferList: "Lista de oferta de serviços",
	    LblServiceOfferName: "Nome do serviço",
	    LblServiceOfferType: "Tipo de serviço",
	    LblStandardTariff: "Tarifa padrão",
	    LblTimeUsedOrBooked: "Tempo usado/reservado",
	    LblPenalty: "Penalização",
	    LblAdditional: "Extra",
	    LblAdditionalAbbr: "Adicionar",
	    LblUnit: "Unidade",
	    //WegoAdminList
	    LblWegoAdmin: "Administrador WeGo",
	    LblWegoAdmins: "Administração WeGo",
	    LblResend: "Reenviar",
	    LblResendActivationMail: "E-mail de ativação",
	    LblResendActivationMailFailure: "Falha no envio do e-mail de ativação",
	    LblResendActivationMailSuccess: "E-mail de ativação enviado",
	    //Subscription
	    LblSubscription: "subscrição",
	    LblSubscriptionName: "Nome da subscrição",
	    LblTimeInterval: "Intervalo de tempo",
	    LblAmount: "Montante",
	    LblFreeKilometer: "Créditos livres",
	    LblFreeMinute: "Minutos livres",
	    LblFreeHours: "Horas livres",
	    LblNumberOfSubscription: "Número de subscrições",
	    LblUnsubscribe: "Cancelar subscrição",
	    LblsubscribeEndDate: "Data de fim da subscrição",
	    LblSubscriptionStartDate: "Data de início da subscrição",
	    //Special Period
	    LblSpecialPeriod: "Período especial",
	    LblspecialPeriodName: "Nome do periodo especial",
	    LblSpecialPeriodStartTime: "Início do período especial",
	    LblSpecialPeriodEndTime: "Fim do período especial",
	    LblSpecialPeriodWeekDays: "Dias úteis do período especial",
	    LblNormalPeriod: "Período normal",
	    LblSpecialPeriods: "Períodos especiais",
	    //Booking InvoiceModel
	    LblBookingInvoice: "Fatura de reserva",
	    LblInvoiceStatus: "Situação da fatura",
	    LblInvoiceType: "Tipo de fatura",
	    LblSummary: "Resumo",
	    LblTotalHours: "Horas totais",
	    LblTotalKm: "Distância total (km)",
	    LblTotalExpense: "Despesa total",
	    LblInvoiceNumber: "Número da fatura",
	    LblBegin: "Início",
	    LblEnd: "Fim",
	    LblVat: "IVA",
	    LblDone: "Concluído",
	    LblClear: "Remover",
	    LblTotal: "Total",
	    LblInvoiceRequestDateTime: "Data/Hora de requisição da fatura",
	    LblInvoiceSendDateTime: "Data/Hora do envio da fatura",
	    LblInvoiceDateTime: "Detalhes da fatura",
	    LblInvoiceDetail: "Detalhes da fatura",
	    LblReSend: "Reenviar",
	    LblDownload: "Descarregar",
	    LblResendInvoiceConfirm: "Tem a certeza do reenvio",
	    LblPenaltyRate: "Taxa de penalização",
	    LblInvoicing: "Faturar",
	    LblInvoices: "data de vencimento",
	    LblSendInvoiceConfirm: "Tem a certeza que deseja enviar a fatura?",
	    LblProfile: "Perfil",
	    LblSignOut: "Sair",
	    LblTemplateNote1: "Por favor, não modifique nem elimine nenhum texto como { nome da variável }. Este é um atributo dinâmico que será substituído quando o e-mail for enviado para o utilizador.",
	    LblTemplateNote2: "Por favor, não modifique a estrutura da tabela. Pode criar uma nova tabela. No entanto, a tabela original não deverá ser alterada.",
	    LblTemplateNote3: 'Por favor, certifique-se que depois de copiar o titular do lugar o cola no editor html através da opção "Colar como texto simples"',
	    LblConfirmUnsubscribe: "Tem a certeza que deseja cancelar a sua subscrição?",
	    LblDriveHours: "Horas de condução",
	    LblVehicleImage: "Imagem do veículo",
	    LblMaintenance: "Manutenção",
	    LblUNAVAILABLE: "Não disponível",
	    LblTestInvoiceGenerator: "Teste emissão de fatura",
	    LblMissingInvoiceGenerator: "Gerador de faturas ausente",
	    LblInvoicingDateTime: "Data/Hora da fatura (UTC)",
	    LblGenerateInvoice: "Criar fatura",
	    LblDeleteAllSelectedRecords: "Eliminar todos os arquivos selecionados",
	    LblCancelAllSelectedRecords: "Cancelar todos os arquivos selecionados",
	    "LblExportAll(CSV)": "Exportar todos (CSV)",
	    LblAddContactPerson: "Adicionar contacto pessoal",
	    LblRemoveContactPerson: "Remover contacto pessoal",
	    LblNote: "Anotação",
	    LblCompletelyEndConfirm: "Finalizar reserva",
	    LblEndTrip: "Concluir a viagem",
	    LblTestTrip: "Viagem de teste",
	    LblTripSimulator: "Simulador de viagem",
	    LblTestTripSuccess: "Viagem de teste criada com sucesso",
	    LblDrivingStartDateTime: "Data/hora de início de viagem",
	    LblDrivingEndDateTime: "Data/hora de fim de viagem",
	    LblInvoiceMoment: "Momento de faturação",
	    LblExtend: "Prolongar",
	    LblExtendRequire: "Por favor, insira a duração (min) de prolongamento da reserva",
	    LblExtendInfoMsg: "Poderá prolongar a reserva no máximo até % minutos",
	    LblExtendValidationMsg: "Esta reserva não pode ser prolongada",
	    LblExtendBooking: "Prolongamento da reserva",
	    LblBookingExtendedSuccess: "Prolongamento da reserva bem sucedido",
	    LblOverExtendValidationMsg: "Prolongamento da reserva não pode exceder % minutos",
	    LblUnLock: "Desbloquear",
	    LblLock: "Bloquear (Intermediário)",
	    LblVehicleStatus: "Estado do veículo",
	    LblTripSuccess: "Viagem guardada com sucesso",
	    LblLockSuccessfully: "Veículo bloqueado com sucesso",
	    LblLockCompletelySuccessfully: "Veículo completamente bloqueado com sucesso",
	    LblUnLockSuccessfully: "Veículo desbloqueado com sucesso",
	    LblUnlockProblem: "Problemas durante o comando de desbloqueio",
	    LbllockProblem: "Problemas durante o comando de bloqueio",
	    LblLockCarCompletely: "Bloquear e terminar reserva",
	    LblStartDateTime: "Data/hora de inicío",
	    LblEndDateTime: "Data/hora de fim ",
	    LblBookingTripDetail: "Detalhes da reserva de viagem",
	    LblAddNewTrip: "Adicionar nova viagem",
	    LblBookingExpenseDetail: "Despesas detalhadas das reservas",
	    LblUnlockErrorMessage: "Não existe grupo deste tipo de contrato disponível para criação da reserva",
	    LblExpenseAmount: "Valor das despesas",
	    LblExpenseName: "Nome das despesas",
	    LblExpenseSuccess: "Despesas guardadas com sucesso",
	    LblReceipt: "Recibo",
	    LblHelpdeskNo: "Apoio ao cliente",
	    LblBookingExpired: "Veículo não pode ser desbloqueado porque a reserva expirou",
	    LblTripCalculationInProgress: "Esperamos que tenha tido uma óptima viagem! O veículo será bloqueado dentro de segundos.",
	    LblVTSReqLogDetail: "Pedir detalhes do registo em sistema de localização do veículo",
	    LblVTSReqDateTime: "Data/hora da requisição",
	    LblVTSProcessTime: "Tempo de processamento",
	    LblVTSResTime: "Tempo de resultado",
	    LblVTSReqType: "Tipo de requisição",
	    LblVTSResult: "Resultado",
	    LblActualInvoiceGenerationDate: "Data da criação da fatura em vigor",
	    LblAvailableForAllSlots: "Veículo disponível para todos períodos",
	    LblUnAvailableSlots: "Períodos indisponíveis",
	    LblNoOfDrivers: "Número de condutores",
	    LblSVGDriversList: "Grupo de condutores de veículos partilhados",
	    LblVehicleInformation: "Informação do veículo",
	    LblVTSVehicle: "Sistema de localização do veículo",
	    LblVTSVehicleUpdateSuccess: "Veículo atualizado com sucesso",
	    LblVTSVehicleList: "Lista de veículos no sistema de localização do veículo",
	    //Report Damage
	    LblReportDamage: "Reportar dano",
	    LblCompleteDamageReport: "Finalizar relatório de dano",
	    LblDamageFile: "Arquivo de danos",
	    LblDescribe: "Descreva o dano…",
	    LblCause: "Descreva a causa do dano…",
	    LblReportDamageMsg: "Dano reportado com sucesso",
	    LblSelectFile: "Por favor selecione o arquivo",
	    // Import Data
	    LblCSVImport: "Importar CSV",
	    LblValidateCSV: "Validar CSV",
	    LblImportValidPerson: "Importar pessoa válida",
	    LblImportValidDriver: "Importar condutor válido",
	    LblImportValidVehicle: "Importar veículo válido",
	    LblCSVType: "CSV Tipo",
	    LblCSVFile: "CSV Arquivo",
	    LblRecordImportedSuccess: "% importado com sucesso",
	    LblInvalidReason: "Motivo inválido",
	    LblSameVTSCommand: "Pedido está a ser processado. Por favor, aguarde.",
	    LblImportPerson: "Importar pessoa",
	    //Subscription related Changes
	    LblSubscriptionInterval: "Período da subscrição",
	    LblPaymentInterval: "Período de pagamento",
	    LblInvoicInterval: "Período da fatura",
	    LblInterval: "Período ",
	    LblInvoiceMomentDay: "Momento da fatura (dia da semana)",
	    LblInvoiceMomentMonth: "Momento da fatura (dia do mês)",
	    LblFreeMinuteInterval: "Período de minutos livres",
	    LblFreeKMInterval: "Período de quilómetros livres",
	    LblSelectSubscriptionInterval: "Selecionar período de subscrição",
	    LblSelectInvoiceInterval: "Selecionar período de fatura",
	    LblSelectPaymentInterval: "Selecionar período de pagamento",
	    LblSelectFreeKMInterval: "Selecionar período de quilómteros livres",
	    LblSelectFreeMinInterval: "Selecionar período de minutos livres",
	    LblYearlySub: "Anual",
	    LblMonthlySub: "Mensal",
	    LblWeeklySub: "Semanal",
	    LblFreePerWeek: "Por semana",
	    LblFreePerMonth: "Por mês",
	    LblFreePerTriMonth: "Por trimestre",
	    LblFreePerBiannual: "Por semestre",
	    LblFreePerYear: "Por ano",
	    LblDefaultContractTypeGroup: "Grupo padrão do tipo de contrato",
	    LblSelectDefaultContractTypeGroup: "Selecionar grupo padrão do tipo de contrato",
	    LblSendInvoiceToDriver: "Enviar fatura para o condutor",
	    LblInherit: "Receber",
	    //Invoice Moment
	    LblDayOfMonth: "Dia do mês",
	    LblDayOfWeek: "Dia da semana",
	    LblSelectDayOfWeek: "Selecionar dia da semana",
	    LblInstanceLogo: "Logotipo da instância",
	    LblInvoiceDeleteValidation: "Fatura não pode ser removida por estar associada a outra entidade",
	    //SubscriptionAvailabilityRestriction
	    LblSubscriptionAvailabilityRestriction: "Restrição na disponibilidade da assinatura",
	    LblStartDay: "Dia inicial",
	    LblEndDay: "Dia final",
	    LblStartTime: "Tempo inicial (hh:mm)",
	    LblEndTime: "Tempo final (hh:mm)",
	    LblRestriction: "Restrição",
	    LblTotalFreeKilometer: "Total de quilómetros livres",
	    LblTotalFreeMinute: "Total de minutos livres",
	    LblCurRemainFreeKilometer: "Restantes quilómetros livres",
	    LblPrevRemainFreeKilometer: "Restantes quilómetros livres anteriores",
	    LblCurRemainFreeMinute: "Restantes minutos livres",
	    LblPrevRemainFreeMinute: "Restantes minutos livres anteriores",
	    LblResetPasswordFailure: "A senha não pode ser redefinida porque o utilizador ainda dão está ativo.",
	    //Additional Free Item
	    LblAdditionalFreeItems: "Créditos gratuitos adicionais",
	    LblAdditionalFreeItemsMenu: "Créditos gratuitos adicionais",
	    LblDateAwared: "Data selecionada",
	    LblPrevious: "Anterior",
	    LblCurrent: "Atual",
	    LblTripDetailReport: "Relatório da viagem detalhado",
	    LblTripDetailList: "Resumo detalhado das reservas",
	    LblSearchTripforDriver: "Procurar reservas do condutor",
	    LblExportReport: "Exportar relatório",
	    LblValidateLiceanceNumberMessage: "Por favor, valide o número da sua carta de condução",
	    LblBookingIntervalRate: "Taxa de período",
	    LblPerHour: "Por hora",
	    LblPerBookingIntarval: "Por período por reserva",
	    LblTimeRate: "Taxa de tempo",
	    LblToalBookingDuration: "Duração da reserva",
	    LblTripComments: "LblTripComment",
	    LblTripCommentDescription: "LblTripCommentDescription",
	    LblTripCommentError: "LblTripCommentError",
	    LblShowTripComment: "LblShowTripComment",
	    LblAddTripComment: "LblAddTripComment",
	    LblTripCommentBy: "LblTripCommentBy",
	    LblTripCommentOn: "LblTripCommentOn",
	    LblCleanRequire: "Limpeza necessária",
	    LblFualRequire: "Combustível necessário",
	    LblVehicleDamageList: "Lista dos danos do veículo",
	    LblDamageCause: "Causa do dano",
	    LblDamageReportedBy: "Reportado por",
	    LblDamageReportedOn: "Reportado em",
	    LblConfirmResolveDamage: "Tem a certeza que deseja remover o dano do veículo?",
	    LblVehicleDamgeResolveSuccess: "Dano do veículo removido com sucesso",
	    LblDamageDesc: "Descrição do dano",
	    LblFutureBooking: "Reservas futuras",
	    LblVehFutureBookingList: "Lista de reservas futuras do veículo",
	    LblResolveDamge: "Remover dano",
	    LblReserved: "Reservado",
	    LblVehicleInfoSuccess: "Informação do veículo atualizada com sucesso",
	    LblInformation: "Informação",
	    LblVTSHistory: "Histórico dos eventos no sistema de localização do veículo",
	    LblWegoRequestTime: "Data do pedido WeGo",
	    LblVTSRequestTime: "Data do requisito do sistema de localização do veículo",
	    LblRequestType: "Tipo de pedido",
	    LblWegoProcessTime: "Data do processamento WeGo",
	    LblResult: "Resultado",
	    LblWegoResultTime: "Data do resultado WeGo",
	    LblVTSResultTime: "Data do resultado do sistema de localização do veículo",
	    LblCommandInitiator: "Comando Inicial",
	    LblTroubleShootVTS: "Solução de problemas no sistema de localização do veículo",
	    LblVtsServiceStatus: "Estado do serviço sistema de localização do veículo",
	    LblVtsLicencetag: "Matrícula no sistema de localização do veículo",
	    LblVtsDoorStatus: "Estado da porta",
	    LblVtsIssueCommand: "Emitir comando",
	    LblVehicleLocation: "Localização do veículo",
	    LblEventHistory: "Histórico de ocorrências no sistema de localização do veículo",
	    LblView: "Ver",
	    LblVehicleObuStatus: "Estado da unidade de bordo do veículo ",
	    LblVehicleNotInitialized: "Veículo não iniciado",
	    LblLastReceivedTime: "Hora da última mensagem recebida",
	    LblFreePerBookingInterval: "Por período por reserva",
	    LblSelectFilter: "Selecionar filtro",
	    LblAuditEntries: "Revisitar registos",
	    LblFilter: "Filtro",
	    LblCategory: "Categoria",
	    LblEventName: "Nome do evento",
	    LblEventData: "Informação do evento",
	    LblMoment: "Momento",
	    LblUser: "Utilizador",
	    LblNoEventDataFound: "Não foram encontradas informações do evento",
	    LblEventViewer: "Observador do evento",
	    LblPrePostTripQuestions: "Pre and Post Trip Questions",
	    LblPrePostTripQuestion: "Questão Pré e Pós viagem",
	    LblPrePostTripQuestionList: "Pre and Post Trip Question List",
	    LblPreTripQuestion: "Questões Pré-viagem",
	    LblPostTripQuestion: "Post-trip questions",
	    LblRequired: "Required",
	    LblCustom: "Personalizar",
	    LblBeforeOpeningTheVehicle: "Before opening the vehicle",
	    LblAfterOpeningTheVehicle: "After opening the vehicle",
	    LblOrder: "Order",
	    LblQuestion: "Question",
	    LblOn: "Sobre",
	    LblOptional: "Opcional",
	    LblOff: "Desligado",
	    LblAnswerType: "Answer Type",
	    LblText: "Text",
	    LblYesNo: "Yes/No",
	    LblAnswer: "Answer",
	    LblTimeStamp: "Carimbo dia/hora",
	    LblPrePostTripSetting: "Definições de questões Pré e Pós viagem",
	    LblSelectObuType: "Selecionar tipo de unidade de bordo",
	    LblFazTripQuestion: "Perguntas do FaZ",
	    LblFazTripQuestionAfterClosingTheVehicle: "Perguntas FaZ após fechar o veículo",
	    LblObuType: "Tipo de unidade de bordo",
	    LblDeviceId: "ID do dispositivo",
	    LblClaimCode: "Claim code",
	    LblVtsLocation: "Localização no sistema de localização do veículo",
	    LblRetriveAddress: "Recuperar o endereço",
	    LblCrearedDate: "Data criada",
	    LblCreatedBy: "Criado por",
	    LblPerBooking: "Por reserva",
	    LblOBU: "Unidade de bordo",
	    LblClone: "Copiar",
	    LblCloneVehicle: "Copiar %",
	    LblFualNotRequire: "Combustível não necessário",
	    LblCleanNotRequire: "Limpeza não necessária",
	    LblSubscriptionInfo: "Informação da assinatura",
	    LblVehiclDamaged: "Veículo danificado",
	    LblVehicleNotDamaged: "Veículo sem danos",
	    LblDamage: "Danificado",
	    LblFreeBooking: "Ajustar custo da reserva",
	    LblBookingCustomFee: "Customizar custo da reserva",
	    LblFreeBookingSuccess: "Custo da reserva guardado com sucesso",
	    LblEnterLocation: "Colocar localização",
	    LblHomeLocation: "Localização da casa",
	    LblLocationMode: "Modo localização",
	    LblMeter: "Metro",
	    LblLocation: "Localização",
	    LblPickupLocation: "minha localização atual",
	    LblLocationUnavailable: "Localização indisponível",
	    LblAvailabilityCalander: "Calendário de disponibilidade",
	    LblAvailableOn: "Disponível em",
	    LblGeofenceEnabled: "Geofence ativada",
	    LblLocationNotFound: "Não é possível determinar endereço no GPS",
	    LblAddressNotAvailable: "Não é possível determinar a endereço nesta localização",
	    LblReports: "Relatórios",
	    LblDrivers: "Condutores",
	    LblTemplates: "Modelos",
	    LblVehicleOccupancyReport: "Relatório da ocupação do veículo",
	    LblPlaceHolder: "Titular do lugar",
	    LblSampleTemplate: "Ilustrativo do modelo",
	    LblLatexFileDownloadValidation: "Conteúdo de látex inválido",
	    LblLocationDataExchangeNotAssign: "Este veículo não pode ser reservado enquanto não for atribuído um sistema de localização do veículo. Deseja continuar o processo?",
	    LblReservedTime: "Período de tempo reservado",
	    LblUsageTime: "Período de tempo utilizado",
	    LblUsageTimeAtOffice: "Período de tempo utilizado durante o horário de trabalho",
	    LblUsageTimeoutOffice: "Uso fora de horário de expediente",
	    LblRevenue: "Rendimento",
	    LblRevenuePerVehicleReport: "Relatório de rendimento por veículo",
	    LblSearchRevenuePerVehicle: "Pesquisar rendimento por veículo",
	    LblRevenuePerVehicleList: "Rendimento por lista de veículos",
	    //Dashboard
	    LblInuse: "Em utilização",
	    LblPriority: "Prioridade",
	    LblDefaultStatus: "Estado padrão",
	    //OdometerLogTrail
	    LblOdometerLogTrail: "Histórico conta-quilómetros",
	    LblUserProvidedOdometerValueInKmr: "Valor do conta-quilómetros (km)",
	    LblDescriptionOfDeviation: "Descrição do desvio",
	    LblFromOdometer: "Do conta-quilómetros",
	    LblToOdometer: "To Odometer",
	    LblAddDescriptionOfDeviation: "Adicionar descrição do desvio",
	    LblDeviation: "Desvio (km)",
	    LblLastOdometerValue: "Valor anterior de conta-quilómetros",
	    LblLastOdometerDT: "Data anterior de conta-quilómetros",
	    LblOdometerRegistered: "conta-quilómetros registado",
	    LblOdometerValue: "Valor do conta-quilómetros",
	    LblMaintenancePlanningList: "Lista dos planos de manutenção",
	    LblSearchMaintenancePlanningValue: "Procurar plano de manutenção",
	    LblMaintenancePlanningreport: "Relatórios dos planos de manutenção",
	    LblodometerConfiguration: "Configuração do conta-quilómetros",
	    LbLOdometerEnabled: "Conta-quilómetros ativado",
	    LblEnableOnApp: "Ativar na App",
	    LblWarningPer: "Aviso (%)",
	    LblShowDeviation: "apresentar desvio que requere esclarecimento",
	    LblTitle: "Título",
	    LblFooterText: "Texto de rodapé",
	    LblvalidEmailDomain: "Permitir apenas endereços de e-mail do seguinte domínio",
	    LblURLSettings: "Configurações dos URL",
	    LblSuccessUrl: "URL correto",
	    LblEmailSettings: "Configuração de email",
	    LblSendActivationEmail: "Ativar e-mails de ativação automáticos",
	    LblSendConfirmationEmail: "Ativar e-mails de confirmação de inscrição",
	    LblRequireAdminApprovel: "Exigir a aprovação do administrador a novas inscrições",
	    LblDriverInformationToBeInclude: "Informação do condutor a ser incluída  no formulário (preenchimento obrigatório de todos os campos)",
	    LblSignUpForm: "Formulário de inscrição",
	    LblSignupForms: "Formulários de inscrição",
	    LblSignupFormsOverview: "Resumo dos formulários de inscrição",
	    LblWhoCanApprove: "Quem pode aprovar novas inscrições?",
	    LblSignupFormLogo: "Logotipo do formulário de inscrição",
	    LblChooseSubscription: "Escolha a(s) subscrição(s) disponíveis para o formulário de inscrição",
	    LblSignupParameter: "URL de inscrição",
	    LblSignupParameterText: "URL Texto de inscrição",
	    DomainNameString: "Nome do domínio separado por vírgula (igual gmail.com,yahoo.com)",
	    SignupParameterString: "São apenas permitidas letras de A a Z, números e hífen",
	    LblAvailability: "Disponibilidade",
	    LblSettings: "Configurações",
	    LblCurrentStatus: "Estado atual",
	    LblFlags: "Aviso",
	    LblNA: "Não aplicável/Não disponível",
	    //Sign up form
	    LblConfirmEmail: "Confirmar e-mail",
	    LblSignup: "Inscrever",
	    LblSignupsOverView: "Resumo de inscrições",
	    LblSignupApproval: "Aprovação da inscrição",
	    LblAccept: "Aceitar",
	    LblSignupFormDescription: "Descrição do formulário de inscrição",
	    LblCurrentOdometerValue: "Valor atual do conta-quilómetros",
	    LblCurrentOdometerDateTime: "Data/hora atual do conta-quilómetros",
	    LblCreateDirectDebitFile: "Criar arquivo para débio direto",
	    LblCheckEmptyIbanNumber: "Confirmar os números do IBAN",
	    LblCreatedDate: "Data criada",
	    LblIncludeInDirectDebit: "Incluir no arquivo de débito direto",
	    LblDirectDebitFileDate: "Data do arquivo de débito direto",
	    LblDirectDebitConfiguration: "Configuração de débito direto",
	    LbLDirectDebitEnabled: "Ativar geração de arquivo de débito direto",
	    LblDirectDebitEnableper: "Arquivo de débito direto ativado por",
	    LbLCreditorDetails: "Informação do credor",
	    LblAddress: "Endereço",
	    LblIBANNumber: "Número de IBAN",
	    LblCountryCode: "Código do país",
	    LbLBillingInformation: "Dados de pagamento",
	    LblFormat: "Formato",
	    LblInvoicingDetails: "Dados da fatura",
	    LbLSubjectToDirectDebit: "Sujeito a débito direto?",
	    //Person Upload Batch
	    LblBatchUploadPersonSetting: "Confirguação da importação de dados da pessoa em grupos",
	    LblShowBatchUploadInfo: "Permitir importação de grupo de pessoas",
	    LblAllowBatchUpload: "Permitir importação por",
	    LblAllowActivationMail: "Use activation emails",
	    LblGenerateRandomPassword: "Sistema gera senhas",
	    LblUserUploadPassword: "Importar senhas",
	    LblFieldToUploadedOrValidated: "Campos no arquivo importado",
	    LblBatchUploadPerson: "Importar grupo de pessoas",
	    LblBatchUpload: "Importar grupo de pessoas",
	    LblImportDriverRole: "Atribuir papel do condutor automaticamente?",
	    LblAssignToSVG: "Atribuir a grupo de veículos partilhados",
	    LblSVG: "Grupo de veículos partilhados",
	    LblDownloadTemplate: "Exemplo de arquivo importado",
	    LblUserAssignSVGMessage: "Utilizador não atribuido a grupo de veículos partilhados",
	    LblInvalidRecordReason: "Registo inválido",
	    LblSelectedSVGs: "Grupo(s) de veículos compartilhados selecionado (s)",
	    LblDashboard: "Painel",
	    LblGroupAdmin: "Admin do grupo",
	    LblDashboardConfiguration: "Configuração do painel",
	    LblCurrentLocation: "Localização atual",
	    LblEnableCurrentLocation: 'Ativar "localização atual"',
	    LblDefaultLocation: "Localização padrão",
	    LblEnableAutoUpdate: "Ativar atualização automática",
	    LblPriorityNotificationSetting: "Configurações de notificações do estado do veículo",
	    LblCollectionDate: "Data débito direto",
	    LblBICCode: "Código BIC",
	    LblDirectDebitFile: "Ficheiro débito direto",
	    LblMissingIBANNumber: "IBAN incompleto",
	    LblCurrentDriver: "Condutor atual",
	    LblNextDriver: "Condutor seguinte",
	    LblSecond: "Segundo(s)",
	    LblCleaning: "Limpar",
	    LblRefueling: "Reabastecer (de combustível)",
	    LblAPKMaintenance: "Inspeção do veículo",
	    LblOutsideGeofence: "Fora do perímetro de localização geográfica",
	    LblNotBooked: "Sem reserva",
	    LblNotBookedSince: "Sem reserva desde",
	    LblLowBattery: "Bateria baixa",
	    LblBatteryVolt: "Volt",
	    LblLowCharge: "Carga baixa",
	    LblChargingPercentage: "Carga %",
	    LblOnSamePosition: "Na mesma posição",
	    LblLastPosition: "Posição anterior",
	    LblNotReturn: "Não entregue",
	    LblCommunicationProblem: "Problema de comunicação",
	    LblDirectDebitDownloadSuccess: "Ficheiro débito direto descarregado",
	    LblWarnings: "Aviso",
	    LblDirectDebitFileId: "ID do ficheiro débito direto",
	    LblTotalAmount: "Valor total",
	    LblReCreate: "Descarregar novamente",
	    LblPleaseEnterCollectionDate: "Por favor introduzir data de débito direto",
	    LblOpenViaLowLevel: "Abrir via urgente",
	    LblInstanceNotificationNote1: "Repor definições de fábrica",
	    LblNoInvoiceSelected: "Faturas não foram selecionadas para débito direto",
	    LblIBANNumberRequired: "Por favor introduzir número de IBAN e código BIC",
	    LblNoEmptyIBANFound: "IBAN não encontrado",
	    LblInvalidTagUsed: "LblInvalidTagUsed",
	    LblNotInvalidTagUsed: "LblNotInvalidTagUsed",
	    LblShowVehicleChargeLevel: "Mostrar nível da carga do veículo na plataforma e na aplicação",
	    LblChargeLevel: "Nível de carga",
	    LblCharging: "Carregando",
	    LblNoDataFound: "Dados não disponivéis",
	    LblOfficeStartTime: "Início do horário de expediente (hh:mm)",
	    LblOfficeEndTime: "Fim do horário de expediente (hh:mm)",
	    //Reports
	    LblTripDataReport: "Detalhes da viagem",
	    LblByDriver: "Por condutor",
	    LblByVehicle: "Por veículo",
	    LblModuleRights: "Direitos do módulo",
	    LblByOrganization: "Por empresa",
	    //Organization
	    LblOrganization: "Empresa",
	    LblOrganizationName: "Nome da empresa",
	    LblOrganizationAddress: "endereço da empresa",
	    LblAddDriverSuccessMsg: "Condutor adicionado e link de ativação enviado com sucesso",
	    LblExistingDriverAddSuccessMsg: "Condutor adicionado e associado à organização com sucesso",
	    LblCreateOrganization: "Criar empresa",
	    LblOrganizationDriversList: "Condutor da organização",
	    LblAddDriver: "Adicionar condutor",
	    // Branding
	    LblBranding: "Marca",
	    LblLogo: "Logotipo",
	    LblEmailNotificationInvoiceTemplate: "Notificação de email & modelo de fatura",
	    LblExpandedWebMenu: "Menu da plataforma expandido",
	    LblCollapsedWebMenu: "Menu da plataforma escondido",
	    LblMobileApp: "Aplicação móvel",
	    LblSplashScreen: "Ecrãn incial",
	    LblWebApplication: "Plataforma",
	    LblMobileApplication: "Aplicação móvel",
	    LblBrandingSavedSuccess: "Marca guardada com sucesso",
	    LblBrandingTemplateConfiguration: "Configuração de branding & modelo",
	    LblAppWebUI: "Aplicação & plataforma",
	    LblNonBookingCommunication: "Comunicação geral",
	    LblBookingCommunication: "Comunicação relacionada com a reserva",
	    LblInstanceBranding: "Usar sempre a marca da instância",
	    LblCompanyBranding: "Usar o branding da empresa sempre que possível",
	    BO_TOP_MENU_ACTIVE_ITEM_BACKGROUND: "Barra superior, menu e itens ativos",
	    BO_TOP_MENU_ACTIVE_ITEM_TEXT: "Texto do menu",
	    BO_HIGHLIGHTED_BUTTON_BACKGROUND: "Botão destacado",
	    BO_HIGHLIGHTED_BUTTON_TEXT: "Botão de texto destacado",
	    BO_HIGHLIGHTED_BUTTON_BACKGROUND_HOVER: "Botão destacado (suspenso)",
	    BO_HIGHLIGHTED_BUTTON_TEXT_HOVER: "Botão de texto destacado (suspenso)",
	    BO_PRIMARY_BUTTON_BACKGROUND: "Botão principal",
	    BO_PRIMARY_BUTTON_TEXT: "Botão de texto principal",
	    BO_PRIMARY_BUTTON_BACKGROUND_HOVER: "Botão principal (suspenso)",
	    BO_PRIMARY_BUTTON_TEXT_HOVER: "Botão de texto principal (suspenso)",
	    BO_SECONDARY_BUTTON_BACKGROUND: "Botão secundário",
	    BO_SECONDARY_BUTTON_TEXT: "Botão de texto secundário",
	    BO_SECONDARY_BUTTON_BACKGROUND_HOVER: "Botão secundário (suspenso)",
	    BO_SECONDARY_BUTTON_TEXT_HOVER: "Botão de texto secundário (suspenso)",
	    BO_HYPERLINK_TEXT: "ligação de texto",
	    BO_HIGHLIGHT_BACKGROUND: "Cor de destaque",
	    BO_HIGHLIGHT_TEXT: "Texto de destaque",
	    BO_CALENDAR_EVENT_BACKGROUND: "Reservas no calendário",
	    BO_CALENDAR_EVENT_TEXT: "texto de reservas no calendário",
	    MO_CALENDAR_EVENT_BACKGROUND: "Reservas no calendário",
	    MO_CALENDAR_EVENT_TEXT: "texto de reservas no calendário",
	    MO_DISABLED_BUTTON_BACKGROUND: "Botão desativado",
	    MO_DISABLED_BUTTON_BACKGROUND_ACTIVE: "Botão desativado (ativo)",
	    MO_DISABLED_BUTTON_TEXT: "botão de texto desativado",
	    MO_DISABLED_BUTTON_TEXT_ACTIVE: "botão de texto desativado (ativo)",
	    MO_ENABLED_BUTTON_BACKGROUND: "Botão ativado",
	    MO_ENABLED_BUTTON_BACKGROUND_ACTIVE: "Botão ativado (ativo)",
	    MO_ENABLED_BUTTON_TEXT: "Botão de texto ativado",
	    MO_ENABLED_BUTTON_TEXT_ACTIVE: "Botão de texto ativado (ativo)",
	    MO_HIGHLIGHT_BACKGROUND: "Cor de destaque",
	    MO_HIGHLIGHT_TEXT: "Texto de destaque",
	    MO_HYPERLINK_TEXT: "ligação de texto",
	    MO_LOGO_AREA_BACKGROUND: "Fundo do logotipo",
	    MO_MENU_TEXT: "Texto de menu",
	    MO_PAGE_BACKGROUND: "Fundo ",
	    MO_TITLE_TEXT: "Texto do título",
	    MO_TOP_MENU_ACTIVE_ITEM_BACKGROUND: "Barra superior e menu ",
	    LblBookingDelayConfig: "Configuração de atraso da reserva",
	    LblBookingDelayConfigEnabled: "Enviar email para administrador",
	    LblEnableSnauilTrail: "Ativar registo de trajecto",
	    LblAppSupportTo: "Apoio para",
	    LblNotificationInterval: "Intervalo de notificação",
	    LblNotifyAfterMinutes: 'Notificar depois de "X" minutos',
	    LblMinutesAfterBookingEndTime: "Quantos minutos após o fim de reserva deve ser enviada a notificação?",
	    LblResendNotoficationEvery: 'Reenviar a notificação a cada "X" minuto(s)',
	    LblMinutes: "Minutos",
	    lblNotificationRecipients: "Destinatários da notificação",
	    LbLEnableBookingStillRunning: "Ativar notificação de reserva a decorrer",
	    LblBookingrunningNotification: "Configuração da notificação de reserva a decorrer",
	    LblPreferableImageSize: "Resolução de imagem",
	    LblWebBrandingExapandImageSize: "1150px X 260px",
	    LblMobileBrandingImageSize: "550px X 250px",
	    LblWebBrandingCollapseImageSize: "325px X 250px",
	    //MobileApp Configuration
	    LblMobileAppConfiguration: "Configurações da aplicação",
	    LblEnableNewBooking: "ativar nova reserva",
	    LblEnableBookingCalender: "ativar calendário de reservas",
	    LblEnableSubscription: "ativar subscrição",
	    LblEnableUpdateProfile: "ativar atualização de perfil",
	    LblEnableNotification: "ativar notificações",
	    LblEnableChangeBooking: "ativar alteração de reservas",
	    LblEnableAddExpenseMenu: "ativar menu de adicionar despesas",
	    //Raise and clear settings for low battery flag
	    LblDefaultVehicleSetting: "Definições padrão do veículo",
	    LblLowBatteryFlagRaised: "Aviso de bateria fraca na (voltagem) ",
	    LblLowBatteryFlagClear: "Aviso de bateria fraca removido na (voltagem) ",
	    LblByBooking: "Na reserva",
	    LblSnailTrailReport: "Relatório de trajecto",
	    LblKickbackReport: "Relatório kickback",
	    LblGroupBy: "Agrupar por",
	    LblTripDetail: "Detalhe de viagem",
	    LblTripNumber: "Número de viagem",
	    LblStart: "Início",
	    LblAverageSpeed: "Velocidade média",
	    LblSegmentDetail: "Detalhe de segmento?",
	    LblSegmentNumber: "Número de segmento",
	    LblSpeed: "Velocidade",
	    LblOdometer: "Velocímetro",
	    LblNext: "Próximo",
	    LblSegmentDetailNotAvailable: "Detalhe de segmento não disponível",
	    LblUnitPerKm: "por quilómetro",
	    LblUnitPerBooking: "Por reserva",
	    LblBookingCostSummary: "Resumo de custo de reserva",
	    LblTimeCost: "Custo de tempo",
	    LblTotalTime: "Tempo total",
	    LblTime: "Tempo",
	    LblFreeTime: "Tempo livre",
	    LblRate: "Taxa",
	    LblExVat: "Sem IVA",
	    LblInclVat: "IVA incluído",
	    LblKmDriven: "Quilómetros conduzidos",
	    LblFreeKms: "Quilómetros disponíveis",
	    LblTimePercent: "Percentagem de tempo",
	    LblTotalExVat: "Total sem IVA",
	    LblTotalVat: "Total IVA",
	    LblTotalInclVat: "Total IVA incluído",
	    LblKilometerCost: "Custo do quilómetro",
	    LblFixedCost: "Custo fixo",
	    LblTotals: "Totais",
	    LblTypeDamage: "Dano",
	    LblTypeMaintenance: "Manuntenção da inspeção veícular previsto",
	    LblTypeOnSamePosition: "Veículo na mesma localização mais do que  %0 %1",
	    LblTypeNotBooked: "Veículo sem reservas há mais de %0%1",
	    LblTypeNotReturn: "Tempo de reserva expirado e veículo não devolvido",
	    LblBatteryVoltage: "Voltagem da bateria",
	    LblCannotUnsubscribe: "Não é possível cancelar a reserva, uma vez iniciada",
	    LblPer: "Por",
	    LblDateRegistered: "Data de registo",
	    LblRegisteredBy: "Registado por",
	    LblKMPerHour: "Km/h",
	    LblMeters: "Metros",
	    LblSubscriptionEndOnBookingEnd: "Reserva a decorrer. O utilizador passará a ser inválido após esta reserva.",
	    LblMarkedForDeletion: "Marcado para exclusão",
	    LblApplyDateFilter: "Aplicar data",
	    LblNoRestriction: "SEM RESTRIÇÕES",
	    LblCustomAppTestApp: "PERSONALIZAR_APLICAÇÃO_E_TESTAR_APLICAÇÃO",
	    LblCustomAppOnly: "PERSONALIZAR_SÓ_APLICAÇÃO",
	    //Customer
	    LblCustomer: "Cliente",
	    LblCustomerName: "Nome do cliente",
	    //Role Page
	    LblRoleManagement: "Função",
	    LblRoleName: "Nome da função",
	    LblEntityName: "Nome da empresa",
	    LblRoleType: "Tipo de função",
	    LblRoleAvailability: "Disponibilidade função do cliente",
	    LblInternalRoleName: "Nome interno da função",
	    LblPresentationName: "Nome de apresentação",
	    LblDefaultRole: "Função padrão",
	    LblCustomRole: "Personalizar função",
	    LblAddRole: "Adiconar função",
	    LblEntity: "Empresa",
	    LblCopy: "Copiar",
	    LblAccessibilityMatrix: "Matriz de acesso",
	    LblDefaultRoleModifyWarning: "A alteração das permissões padrão irá afetar todos os utilizadores que usem a função padrão.",
	    LblCopyAccessibilityMatrix: "Copiar matrix de acessos",
	    LblAccess: "Acesso",
	    LblCustomerAdmin: "Administrador do cliente",
	    LblAdmin: "Administrador",
	    LblDoYouWantToRemove: "Pretende remover %0 para %1?",
	    LblDoYouWantToAdd: "Pretende passar de %0 para %1?",
	    LblRoleAddedSuccess: "%0 adicionado com sucesso",
	    LblRoleDeletedSuccess: "%0 removido com sucesso",
	    LblInstanceAdmin: "administrador de instância",
	    LblInvitationMailSuccess: "convite rejeitado",
	    LblInvite: "Enviar convite",
	    LblCreateNew: "Criar novo",
	    LblCommonErrorMessage: "Ocorreu um erro durante o processamento do pedido. Por favor contacte o adminstrador",
	    LblError: "Erro",
	    LblThankYouForAcceptingInvitation: "Obrigado(a) por aceitar o convite",
	    LblPleaseClick: "Por favor selecione",
	    LblHere: "aqui",
	    LblToLogin: "para entrar",
	    LblThankYouForConfirmation: "Obrigado(a) pela sua confirmação",
	    LblGoToHome: "Ir para páginal inicial",
	    LblInvitationSuccess: "Enviar convite",
	    LblInvitationReject: "convite rejeitado",
	    //
	    LblAssignExisting: "Atribuição existente",
	    LblPersonProfileSuccessMessage: "O seu perfil foi ativado com sucesso",
	    LblPlease: "Por favor",
	    LblLogin: "Entrar",
	    //Organization
	    LblVatNumber: "Número de iva",
	    //Branding & Template
	    LblBrandingandTemplates: "Branding & Templates",
	    LblTermsAndCondition: "Termos e Condições",
	    LblTermsAndConditionList: "Termos e Condições & Privacidade",
	    LblName: "Nome",
	    LblVersion: "Versão",
	    LblAcceptance1: "Antes da ativação da conta",
	    LblAcceptanceMoment: "Momento de aceitação",
	    LblContents: "Conteúdo",
	    LblIsAccept: "Aceito",
	    LblReadAndAgree: "Li e aceito",
	    LblClose: "Fechar",
	    LblTermsConditionPrivacy: "Termos e Condições & Privacidade",
	    LblPrivacyStatements: "Termos de Privacidade",
	    LblDamageImageExtentions: "Extensão da imagem do Dano",
	    //Accessibility Matrix
	    LG_WEB_DASHBOARD: "Painel de controlo de rede",
	    PR_BOOKING_REQUEST: "Booking Request",
	    LblApproveBookingRequest: "Aprovar",
	    LblRejectBookingRequest: "Rejeitar",
	    PR_INVOICE_PAYMENT_HISTORY: "Histórico de pagamentos de faturas",
	    PR_TERMS_AND_CONDITION: "Termos e Condições",
	    PR_PRE_POST_TRIP_QUESTIONS: "Resumo Questões Pré e Pós viagem",
	    PR_ADDITIONAL_FREE_ITEMS: "Adicionar items gratuitos",
	    PR_BATCH_UPLOAD_PERSON: "Importar lote de pessoas",
	    PR_BOOKINGS_OVERVIEW: "Resumo de reservas",
	    PR_BRANDING: "Marca",
	    PR_COMPANY_ADMIN: "Adminstrador da empresa",
	    PR_COMPANY_OVERVIEW: "Resumo da empresa",
	    PR_COMPANY_SVG_OVERVIEW: "Resumo de grupos de veículos partilhados da empresa",
	    PR_COMPANY_VEHICLE_OVERVIEW: "Resumo veículos da empresa",
	    PR_CONTACT_PERSON: "Contacto da pessoa",
	    PR_CUSTOMER_ADMIN_OVERVIEW: "Resumo administrador do cliente",
	    PR_CUSTOMER_OVERVIEW: "Cliente",
	    PR_DASHBOARD: "Painel de controlo",
	    PR_REMOVE_DRIVER_LICENSE: "Remove Driver License",
	    PR_DIRECT_DEBIT_FILE: "Ficheiro débito directo",
	    PR_DRIVER_OVERVIEW: "Resumo do condutor",
	    PR_DRIVER_SHARED_VEHICLE_GROUP_OVERVIEW: "Resumo do grupo de veículos partilhados do condutor",
	    PR_DRIVER_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW: "Resumo da subscrição de grupo de veículos partilhados do condutor",
	    PR_EVENT_VIEWER: "Visualizar evento",
	    PR_PRE_POST_TRIP_SETTING: "Definições Questões Pré e Pós viagem",
	    PR_IMPORT_PERSON: "importar pessoa",
	    PR_PRE_POST_TRIP_QUESTION_UPDATE: "Questões Pré e Pós viagem",
	    PR_INSTANCE: "instância",
	    PR_INSTANCE_ADMIN_OVERVIEW: "Resumo administrador de instância",
	    PR_INVOICE: "Fatura",
	    PR_KICKBACK_REPORT: "Relatório kickback",
	    PR_MAINTENANCE_PLANNING_REPORT: "Relatório de planeamento de manutenções",
	    PR_NORMAL_BOOKING: "Reserva normal",
	    PR_ODOMETER_LOG_TRAIL: "Registo conta-quilómetros",
	    PR_ODOMETER_LOG_TRAIL_REGISTERED_BY: "Registo conta-quilómetros criado por",
	    PR_ORGANIZATION_ADMIN_OVERVIEW: "Resumo administrador da empresa",
	    PR_ORGANIZATION_CONTACT_PERSON: "Pessoa de contacto da empresa",
	    PR_ORGANIZATION_DRIVER_OVERVIEW: "Resumo de condutor da empresa",
	    PR_ORGANIZATION_OVERVIEW: "Resumo da empresa",
	    PR_ORGANIZATION_SUBSCRIPTION_OVERVIEW: "Subscrição da empresa",
	    PR_PERSON_OVERVIEW: "Resumo pessoa",
	    PR_REVENUE_PER_VEHICLE_REPORT: "Relatório de rendimentos por veículo",
	    PR_ROLE_ASSIGN: "Função atribuida",
	    PR_ROLE_OVERVIEW: "Função",
	    PR_SANIL_TRAIL_REPORT: "relatório snail trail",
	    PR_SHARED_VEHICLE_GROUP_ACTIVE_INACTIVE: "Grupo de veículos partilhados ativo ou inativo",
	    PR_SHARED_VEHICLE_GROUP_ADMIN_OVERVIEW: "Resumo Grupo de veículos partilhados do administrador",
	    PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_GROUP_OVERVIEW: "Resumo do Grupo de Tipo de contratos do Grupo de veículos partilhados",
	    PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_OVERVIEW: "Resumo de tipo de contrato de grupo de veículos partilhados",
	    PR_SHARED_VEHICLE_GROUP_DRIVER_OVERVIEW: "Resumo de grupo de veículos partilhados do condutor",
	    PR_SHARED_VEHICLE_GROUP_OVERVIEW: "Resumo Grupo de veículos partilhados",
	    PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_AVAILIBILTY_RESTRICTION_OVERVIEW: "Resumo de restrições de disponibilidades de grupos de veículos partilhados",
	    PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW: "Resumo de subscrições de grupos de veículos partilhados",
	    PR_SHARED_VEHICLE_GROUP_VEHICLE_OVERVIEW: "Resumo de veículos de grupos de veículos partilhados",
	    PR_SIGNUP_FORMS_OVERVIEW: "Resumo de formulário de inscrição",
	    PR_SIGNUP_OVERVIEW_TO_SHARED_VEHICLE_GROUP: "Resumo de inscrições de grupos de veículos partilhados",
	    PR_SIGNUP_OVERVIEW_TO_SIGNUP_FORM: "Resumo de formulário de inscrição",
	    PR_SIGNUPS_OVERVIEW: "Resumo de inscrições",
	    PR_SPECIAL_BOOKING: "reserva especial",
	    PR_SPECIAL_PERIODS: "Períodos especiais",
	    PR_TEMPLATES: "Modelos",
	    PR_TEST_INVOICE_GENERATOR: "Teste de emissão de faturas",
	    PR_TRIP_DATA_REPORT: "detalhes da viagem",
	    PR_TRIP_SIMULATOR: "simulador de viagem",
	    PR_USER_PROFILE: "perfil de utilizador",
	    PR_VEHICLE_ATTRIBUTE: "Características do veículo",
	    PR_VEHICLE_ATTRIBUTE_CATEGORIES: "Categoria de características do veículo",
	    PR_VEHICLE_FUTURE_BOOKINGS: "Futuras reservas do veículo",
	    PR_VEHICLE_OCCUPANCY_REPORT: "Relatório de ocupação do veículo",
	    PR_VEHICLE_SVG_OVERVIEW: "Resumo de veículos de grupos de veículos partilhados",
	    PR_VEHICLES_OVERVIEW: "Resumo de veículos",
	    PR_VTS_TROUBLESHOOT: "Resolução de problema para o sistema de localização do veículo",
	    PR_VTS_VEHICLE_EVENT_HISTORY: "Histórico do sistema de localização do veículo",
	    PR_VTS_VEHICLE_LIST: "Lista de veículos no sistema de localização do veículo",
	    PR_WEGO_ADMINS: "Administrador WeGo",
	    PR_PREPOST_TRIP_QUESTIONS_UPDATE: "Questões Pré e Pós viagem",
	    LG_CUSTOMER: "Cliente",
	    LG_INSTANCE: "instância",
	    LG_BRANDING: "Marca",
	    LG_PERSON: "Pessoa",
	    LG_COMPANY: "Empresa",
	    LG_ORGANIZATION: "Empresa",
	    LG_SHARED_VEHICLE_GROUP: "Grupo de veículos partilhados",
	    LG_VEHICLE: "Veículo",
	    LG_DRIVER: "Condutor",
	    LG_BOOKING: "Reserva",
	    LG_INVOICE: "Fatura",
	    LG_REPORT: "Relatório",
	    LG_TEMPLATE: "Modelo",
	    LG_SIGNUP_FORM: "Formulário de inscrição",
	    LG_EVENT_VIEWER: "Visualizar evento",
	    LG_PRE_POST_TRIP_SETTING: "Definições Questões Pré e Pós viagem",
	    LG_USER: "utilizador",
	    LG_BRANDING_AND_TEMPLATE: "Branding & Templates",
	    LG_ROLE: "Função",
	    LG_PREPOSTTRIPQUESTION: "Questões Pré e Pós viagem",
	    LG_REPORTINGTOOL: "Reporting Tool",
	    PR_BOOKING_OVERVIEW: "Booking overview",
	    PR_ROB_NOTIFICATIONS: "ROB overview",
	    PR_MILEAGE_OVERVIEW: "Mileage overview",
	    PR_USAGE_OVERVIEW: "Number of days not used",
	    PR_POSITION_ON_MAP: "Position on the map",
	    PR_VEHICLE_ON_LOCATION_MAP: "Vehicle on location",
	    PR_TRIP_OVERVIEW: "Trip registration",
	    PR_ALTERNATE_TRANSPORTATION: "Alternate transportation",
	    PR_AVERAGE_OVERVIEW: "Averages overview",
	    PR_PRE_POST_BOOKING_OVERVIEW: "Pre/post questions per booking overview",
	    PR_HOME_LOCATIONS_OVERVIEW: "Vehicle and SVG home locations overview",
	    LblPrivacyErrorMessage: "Quem não está autorizado a ver esta página?",
	    LblPrivacyNavigate: "Por favor vá para a página",
	    LblPrivacyError: "Erro de privacidade",
	    LblLinkExpired: "Ligação expirada",
	    LblLinkExpiredMessage: "O link está expirado e não pode mais ser usado. Por favor, tente novamente.",
	    LblBearer: "Barreira",
	    LblWhoBenifitFreeItem: "Quem beneficia dos créditos de subscrição?",
	    LblNoDistinction: "Padrão",
	    LblSendInvoiceToOrganization: "Enviar fatura para a empresa",
	    //Vat Setting
	    LblVatSettings: "Definições de iva",
	    LblVatPercentages: "Percentagem de iva",
	    LblDefaultCost: "Mostrar e editar custos, por defeito",
	    LblExcludingVat: "Sem iva",
	    LblIncludingVat: "iva incluído",
	    LblVatEnterDescription: "Introduzir descrição",
	    LblEnterVatPercentage: "introduzir percentagem de iva",
	    LblVatPercentageError: "Por favor introduza uma percentagem válida",
	    LblVatDescriptionError: "Por favor introduza uma descrição válida",
	    LblVatStartDate: "Data de inicio",
	    LblVatStartDateError: "Por favor selecione a data de inicio",
	    LblStartDate: "Data de inicio",
	    LblVatEndDate: "data final",
	    LblVatDeleteConfirmation: "Tem a certeza que pretende defenir data de fim para o IVA?",
	    LblVatEndDateError: "Por favor introduza data final de IVA",
	    LblVatEndDateNote: "Nota: a informação excluida para a data selecionada",
	    LblDefaultVatContractTypeGroupCost: "% IVA para custos com grupos de tipo de contrato",
	    LblDefaultVatContractTypeCost: "% IVA para custos com o tipo de contrato",
	    LblDefaultVatSubscriptionCost: "% IVA para custos com subscrições",
	    LblPenaltyCost: "Valor de penalização",
	    LblTimeRates: "taxa de tempo",
	    LblDistanceRates: "Taxas de distância",
	    LblFixedRates: "Taxa fixa",
	    LblSubscriptionCost: "Valor de subscrição",
	    LblPenaltyVat: "percentagem de iva da penalização",
	    LblTimeRateVat: "Percentagem de iva do tempo",
	    LblMileageRateVat: "Percentagem de iva para quilometragem",
	    LblFixedFeeVat: "Taxa fixa de iva",
	    LblExpenseAmountVat: "Valor de iva",
	    // template
	    LblEmailTemplate: "Modelo de e-mail",
	    LblWebTemplate: "Modelo de rede",
	    LblEmailAddressesEntryPattern: "Separar e-mail por virgulas (ex1@ex.com, ex2@ex.com)",
	    LblNoRecipientWarning: "Sem destinatário atríbuido. O modelo será enviado para os destinatários padrão.",
	    LblCostAndExpenses: "Custos e despesas",
	    LblSender: "Sender",
	    LblAddressee: "Inativo após (dias)",
	    LblAddLine: "Apagar após (dias)",
	    LblSaveInvoice: "Save Invoice",
	    LblVatAmount: "Definições de Política de proteção de dados",
	    LblBookingId: "Data de exclusão",
	    LblReceiptOrSuppor: "Excluir utilizador a",
	    LblVATPercentage: "Histórico de pagamentos de faturas",
	    LblChargeTo: "Método de pagamento",
	    LblReimburseTo: "Hora de registo",
	    LblReportedBy: "Link de pagamento não foi gerado",
	    LblReportedAmount: "Permitir configuração de pagamento",
	    LblApprovedAmount: "Autorizar pagamento",
	    LblCostType: "Configuração pagamento a fornecedor",
	    LblRecipient: "Ambiente",
	    LblCostDetail: "Histórico de pagamentos",
	    LblCostCenterReport: "Validade da ligação (dias)",
	    LblShowTotalOnly: "Método de pagamento",
	    LblChamberOfCommerce: "Senha de acesso do fornecedor",
	    LblInvoicingSettings: "Invoicing Settings",
	    LblInvoiceSender: "link para pagamento",
	    LblAddExisting: "Histórico de pagamentos",
	    LblReceiptOrSupport: "Motivo para empresa bloqueada",
	    LblManualInvoiceLine: "Manual Invoice Line",
	    LblInvoiceLine: "Por favor selecione data de vencimento",
	    LblInvoice: "data de vencimento",
	    LblInvoiceLines: "Invoice Lines",
	    LblSendInvoice: "Enviar fatura",
	    LblInvoiceSent: "Invoice Sent",
	    LblAddNewInvoiceLine: "Fatura 0% com sucesso",
	    LblSelectUnprocessedExpenses: "Select an unprocessed expenses",
	    LblSelectAtLeastOneExpense: "Fechado",
	    PR_COST_EXPENSES: "Reabrir/ Fechar",
	    PR_COST_CENTER_REPORT: "Histórico de pagamentos",
	    LblReportedOn: "Reportado em",
	    LblInvoicePaymentHistory: "Invoice Payment History",
	    LblLogTime: "Hora de registo",
	    LblNoPaymentLinkGenerated: "No Payment Link Generated",
	    //Payment module
	    LblPaymentConfig: "Configuração de pagamento",
	    LblPaymentConfigButton: "Configuração de pagamento",
	    LblPaymentProvider: "Provedor de pagamento",
	    LblCountry: "País",
	    LblEmailAddress: "Endereço de e-mail",
	    LblInvoicePaymentTermDays: "Histórico de pagamento por data de vencimento",
	    LblAllowPaymentConfiguration: "Allow Payment Configuration",
	    LblPaymentSetting: "Payment Provider Settings",
	    LblAllowPayment: "Allow Payment",
	    LblEnvironment: "Ambiente",
	    LblLinkValidityDays: "Validade da ligação (dias)",
	    LblClosed: "Closed",
	    LblConfirmDuedatechange: "Tem a certeza que pretende atualizar a data de vencimento?",
	    LblConfirmCloseInvoice: "Tem a certeza que pretende encerrar a fatura?",
	    LblConfirmReOpenInvoice: "Tem a certeza que pretende re-abrir a fatura?",
	    LblDueDateUpdateSuccess: "Data de vencimento atualizada com sucesso",
	    LblDueDateRequiredError: "Please Select Due Date.",
	    LblDueDate: "Data de Vencimento",
	    LblInvoiceOpenCloseSuccess: "Fatura 0% com sucesso",
	    LblPaymentHistory: "Payment History",
	    LblPaymentLink: "Payment Link",
	    LblPaymentMethods: "Payment Methods",
	    LblPaymentMode: "Payment Mode",
	    LblPaymentProviderSecretKey: "Senha de acesso do fornecedor",
	    LblPaymentProviderUsername: "Nome de utilizador do fornecedor (key)",
	    LblCreditCardPayment: "Pagamento com cartão de crédito",
	    LblInitialPayment: "Pagamento inicial",
	    LblCreateBookingPayment: "Criar pagamento da reserva",
	    LblStartBookingPayment: "Iniciar pagamento da reserva",
	    LblReasonOrganization: "Motivo para empresa bloqueada",
	    LblReOpen: "Reabrir",
	    LblReOpenClose: "Reabrir/ Fechar",
	    // Error Log
	    LblLogType: "Tipo de registo",
	    LblErrorLog: "Erro de registo",
	    LblComponent: "Componente",
	    LblComponentName: "Nome do componente",
	    LblEventDateTime: "Data e hora do evento",
	    LblMonitoring: "Monitorizar",
	    // Interface Status
	    LblLastStatusChangeDateTime: "Data/hora da última alteração de estado",
	    LblLastCarwisePollDateTime: "Last Carwise Poll DateTime",
	    //Booking Type
	    LblNORMALBOOKINGTYPE: 'NORMAL',
	    LblMAINTENANCEBOOKINGTYPE: 'MANUTENÇÃO',
	    LblUNAVAILABLEBOOKINGTYPE: 'INDISPONÍVEL',
	    //Booking Request Status
	    LblAPPROVEDBOOKINGREQUEST: 'APROVADO',
	    LblREJECTEDBOOKINGREQUEST: 'REJEITADO',
	    LblPENDINGBOOKINGREQUEST: 'PENDENTE',
	    //Booking Status
	    LblABORTED: 'ABORTADO',
	    LblCANCELLED: 'CANCELADO',
	    LblCONFIRMED: 'CONFIRMADO',
	    LblFINISHED: 'ACABADO',
	    LblNOSHOW: 'NOSHOW',
	    LblPENDING: 'PENDENTE',
	    LblREVOKED: 'RESCINDIDA',
	    LblRUNNING: 'INICIADA',
	    LblREADYFORPAYMENT: 'PRONTO PARA PAGAMENTO',
	    //Invoice Status
	    LblOPEN: 'ABERTA',
	    LblSENT: 'ENVIADA',
	    LblCLOSED: 'CONCLUÍDO',
	    LblREQUESTFORPAYMENT: 'PEDIDO DE PAGAMENTO',
	    LblREOPEN: 'REABERTADO',
	    //ErrorEscalation
	    LblSelectAdminLevel: "Selecionar nível de administrador",
	    LblErrorEscalation: "Agravamento de erro",
	    LblDuplicateErrorEscalation: "Encontrado erro na duplicação da configuração",
	    LblCustomerAdminLevel: "Nível de administrador",
	    LblEnableErrorEscalation: "Ativar agravamento de erro",
	    LblEnableLogin: "Ativar Registo",
	    LblErrorEscalationMinutes: "Minutos para agravamento de erro",
	    LblWegoAdminLevel: "Nível administrador WeGo",
	    LblInstanceAdminLevel: "Instance Admin Level",
	    LblInactiveAfterDays: "Mensagem de utilizador bloqueado",
	    LblGdprSettings: "GDPR Settings",
	    // Interface Status
	    LblInterfaceStatus: "Estado do interface",
	    LblUpdatedDateTime: "Atualizar Data/Hora",
	    LblMarkDeleteAfterDays: "Mark Delete After (Days)",
	    LblNotifyAdminBeforeDays: "Notificar administrador antes de (dias)",
	    LblRemovalDate: "Removal Date",
	    LblRemovePersonOn: "Excluir utilizador a",
	    LblUserBlockMessage: "Mensagem de utilizador bloqueado",
	    PR_PAYMENT_HISTORY_LIST: "Payment History",
	    PR_BLOCK_UNBLOCK_ORGANIZATION: "Boquear/Desbloquear empresa",
	    LblCurrencyConfiguration: "Currency Configuration",
	    LblNameSingular: "Nome",
	    LblNamePlural: "Name Plural",
	    //Special Period
	    LblRegularBooking: "Reserva regular",
	    LblSpecialRate: "Tarifa especial",
	    LblFirstDay: "Primeiro dia",
	    LblLastDay: "último dia",
	    LblWeekEndContaining: "Fim de semana contém",
	    LblSignBeforeAmount: "Símbolo da moeda antes de Montante",
	    LblOutOf: "fora de",
	    //Credit card payment
	    LblCrediCardPayment: "Pagamento com cartão de crédito",
	    LblFirstBooking: "Primeira reserva",
	    LblAllowRecurringPayment: "Autorizar cartão de crédito",
	    LblProceed: "Avançar",
	    LblCheckAllowPayment: "Por favor confirme as permissões de pagamentos recurrentes",
	    LblPaymentFailed: "Autorizar cartão de crédito",
	    LblPaymentSuccess: "Autorização com sucesso",
	    LblPaymentFailure: "Autorização sem sucesso",
	    LblCompletedSuccess: "O seu autorização foi processado com sucesso",
	    LblCompletedFailure: "A sua autorização falhou. Por favor tente novamente.",
	    LblCreditCardNumber: "Número de cartão de crédito",
	    LblCreditCardExpirationDate: "Data de validade cartão de crédito",
	    LblCreditCardDetails: "Detalhes Cartão de Crédito",
	    LblMakePayment: "Autorizar cartão de crédito",
	    LblAdminPaymentConfirmation: "Não existe um Autorização ativo ou o pagamento falhou. Quer continuar?",
	    LblPaymentDescription: "Para poder reservar o veículo, é necessário confirmar a validade do cartão através do pagamento de %0. Adicionalmente, é necessária permissão para dedução do pagamento para futuras reservas. Os pagamentos são processados pelo nosso parceiro Buckaroo. Será reencaminhado para o site do Buckaroo para fazer o pagamento.",
	    LblPay: "Pague",
	    LblWhenOpeningAppAndRepeat: 'When opening the app for the first time and repeat every',
	    LblEveryTimeOpenApp: 'Every time the app is opened',
	    'LblWhenMakeBooking': 'When making a booking',
	    'LblWhenStartBooking': 'When starting a booking',
	    'LblWhenOpenBooking': 'When opening a vehicle',
	    'LblSelectContractTypeGroup': 'Quando fechar um grupo de tipo de contrato específico',
	    'LblDays': 'Days',
	    'LblNewVersion': 'New Version',
	    'LblAction': 'Action',
	    'LblTAndCName': 'T&C Name',
	    'LblOldVersion': 'Old Version',
	    LblSureToRevoke: "Tem a certeza que pretende revogar %0?",
	    // NIF Number
	    LblEnableNIFNumber: "Ativar Número de contribuinte",
	    LblNIFNumber: "Número de contribuinte",
	    LblAddDriverToOrganization: "Adicionar condutor à organização",
	    LblWeGoDefault: "WeGo padrão",
	    LblPersonActiveSuccess: "Pessoa ativada com sucesso",
	    LblActivate: 'Ativar',
	    LblInActiveReason: "InActive Reason",
	    LblDefaultLanguage: 'Idioma padrão',
	    LblRestoreInheritConfirmation: "As configurações atuais serão substituídas pelas configurações herdadas. Você tem certeza?",
	    LblQestionTextRequired: "Texto da pergunta requerido",
	    LblManualSecretKey: "Chave secreta",
	    // Two Factor Authentication
	    LblTwoFaConfig: "Autenticação de dois fatores",
	    LblEnableTwoFa: "Ativar autenticação de dois fatores",
	    LblExpirationDays: "Dias de expiração",
	    LblTextBoxExpirationDays: "Dias de expiração",
	    Lbl2FactorAuthenticateExpDays: "2FA expiration period (days):",
	    LblResetCookiesWegoAdmin: "Redefinir cookies para todos os administradores do WeGo",
	    LblReset2FactorAuthWegoAdmin: "Redefinir todos os 2FA para todos os administradores do WeGo",
	    LblAuthentication: "Autenticação",
	    LblResetCookiesForAllAdmin: "Redefinir cookies para todos os administradores",
	    LblReset2FaForAllAdmin: "Redefinir 2FA para todo administrador",
	    LblEnterTotp: "Por favor digite o código",
	    LblEnterOtp: "Por favor digite o código",
	    LblSubmit: "Enviar",
	    LblKeyResetSuccess: "2FA Key foi redefinida",
	    LblKeyResetFailed: "Falha na redefinição da chave 2FA",
	    LblCookieResetSuccess: "2FA cookies foi redefinido",
	    LblCookieResetFailed: "Falha na redefinição dos cookies de 2FA",
	    LblGoogleAuthenticator: "Google Authenticator App",
	    LblEmailOtpSent: "Um código foi enviado para o seu endereço de e-mail cadastrado",
	    LblContinue: "Continuar",
	    LblInvalidTOTP: "Código inválido",
	    LblResetCookie: "Redefinir Cookie",
	    LblResetTwoFA: "Redefinir 2FA",
	    LblDisableTwoFA: "Desativar 2FA",
	    LblTwoFaMethod: "Método 2FA",
	    LblEmailAuthentication: "Autenticação do email",
	    LblTwoFaMethodSelect: "Você precisará confirmar sua identidade mais uma vez. Por favor, selecione o seu método 2FA",
	    LblInvoicePreFix: "Prefixo do número da fatura",
	    LblEngineStillRunning: 'Comando de fechamento enviado enquanto o motor está em execução',
	    LblMobileAppLink: "Mobile App Link",
	    LblFileNotFound: "O arquivo não existe, entre em contato com o helpdesk",
	    // License Check Configuration
	    LblLicenseCheckConfiguration: "Configuração de verificação de licença",
	    LblValidateLicenseCheckForBooking: "Verifique antes de reservar",
	    // Access Cards Enabled SVG
	    LblAccessCardsEnabled: "Access Card Use",
	    // Track & Trace
	    LblTrackAndTrace: "Rastrear e rastrear",
	    LblRfidTagId: "ID da etiqueta RFID",
	    LblEmployeeNumber: "Número de empregado",
	    BtnAddVehicleInfo: "Mostra Log de VTS",
	    // Access Card
	    LblAccessCardId: "Access Card ID",
	    LblDriversLicenseAndCertificates: "Driver's license and certificates",
	    LblLicense: "Driver's license",
	    LblCertificates: "Certificates",
	    LblTrips: "Viagens",
	    LblCostsSummary: "Costs Summary",
	    LblStartBooking: "Start booking",
	    LblStopBooking: "Stop booking",
	    LblTripHistory: "Histórico de viagem",
	    LblTripStartDateTime: "A partir das",
	    LblTripEndDateTime: "Às",
	    LblFaZTripQuestions: "Perguntas do FaZ",
	    LblNoQuestionsFound: "Nenhuma pergunta FaZ encontrada.",
	    LblNoTripsFound: "Nenhuma viagem encontrada.",
	    LblTripDetails: "Detalhes da viagem",
	    LblUnansweredQuestions: "Perguntas não respondidas",
	    LblNoUnansweredQuestions: "Nenhuma pergunta sem resposta",
	    LblAnswerSaved: "The answer is successfully saved",
	    LblAnswerSavedError: "The answer could not be saved. Please contact the Administrator",
	    LblAnswerEmptyError: "Please enter a valid answer",
	    LblLoginError: "Acconteceu um erro desconhecido ao tentar fazer login.",
	    LblLoginCredentialsError: "Este nome de usuário ou senha estão incorretos. Por favor, tente novamente.",
	    ValidatePhoneNumberVts: "Por favor introduza um número de telefone fixo válido (Ex.: +31623456789)",
	};


/***/ },
/* 77 */
/***/ function(module, exports) {

	// lang-fr.ts
	"use strict";
	exports.LANG_FR_NAME = "fr";
	exports.LANG_FR_TRANS = {
	    LblWeekdays: {
	        shorthand: ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"],
	        longhand: [
	            "Dimanche",
	            "Lundi",
	            "Mardi",
	            "Mercredi",
	            "Jeudi",
	            "Vendredi",
	            "Samedi"
	        ]
	    },
	    LblMonths: {
	        shorthand: [
	            "Jan.",
	            "Fév.",
	            "Mars.",
	            "Avr.",
	            "Mai",
	            "Juin",
	            "Juil.",
	            "Août",
	            "Sep.",
	            "Oct.",
	            "Nov.",
	            "Déc."
	        ],
	        longhand: [
	            "Janvier",
	            "Février",
	            "Mars",
	            "Avril",
	            "Mai",
	            "Juin",
	            "Juillet",
	            "Août",
	            "Septembre",
	            "Octobre",
	            "Novembre",
	            "Décembre"
	        ]
	    },
	    LblButtonText: {
	        today: "Aujourd'hui",
	        month: "Mois",
	        week: "Semaine",
	        day: "Jour",
	        list: "Liste"
	    },
	    LblEdit: "Modifier",
	    LblDelete: "Supprimer",
	    LblRemove: "Supprimer",
	    LblActiveInactive: "Actif / Inactif",
	    LblActive: "Actif",
	    LblInactive: "Désactiver",
	    LblAddNew: "Ajouter",
	    LblAdd: "Ajouter",
	    LblUpdate: "Modifier",
	    LblSave: "Enregistrer",
	    LblCancel: "Annuler",
	    LblReset: "Réinitialiser",
	    LblSelect: "Sélectionnez",
	    LblSuccess: "Réussi",
	    LblWarning: "Avertissement",
	    LblList: "Liste",
	    LblAssign: "Attribuer à",
	    LblHome: "Accueil",
	    LblYes: "Oui",
	    LblOK: "Ok",
	    LblNo: "Non",
	    LblBack: "Revenir à la page précédente",
	    LblReason: "Motif",
	    LblRecordSavedSuccess: "Enregistrement réussi",
	    LblRecordDeleteSuccess: "Suppression réussie",
	    LblResetPasswordSuccess: "Mot de passe réinitialisé",
	    LblBookingApproveRejectSuccess: "%0 %1 avec succès",
	    LblRecordAddedSuccess: "%0 ajouté(s)",
	    LblRecordUpdatedSuccess: "%0 modifié(s) avec succès",
	    LblRecordRemovedSuccess: "0% supprimé(s)",
	    LblRecordActiveInActiveSuccess: "%0 %1 réussi(s)",
	    LblinvoiceResendSuccess: "%0 à nouveau envoyé(s)",
	    LblRecordBlokUnBlockSuccess: "%0 %1 réussi(s)",
	    LblConfirm: "Confirmer",
	    LblContactPersonAddedSuccess: "Personne à contacter ajoutée",
	    LblBlockUnblockConfirm: "Êtes-vous certain de vouloir %0 le %1 ?",
	    LblRecordDeleteConfirmation: "Êtes-vous certain de vouloir supprimer %0 ?",
	    LblRecordMultiplDeleteConfirmation: "Êtes-vous certain de vouloir supprimer la sélection ?",
	    LblConfirmMessage: "Êtes-vous sûr ?",
	    LblResetPassword: "Réinitialiser le mot de passe",
	    LblResetPasswordConfirmation: "Êtes-vous certain de vouloir réinitialiser le mot de passe ?",
	    LblGeoLocationError: "Saisissez une géolocalisation correcte",
	    LblPersonDeleteCheck: "Supprimer définitivement",
	    LblBookingCancelSuccess: "L'annulation des réservations a été effectuée avec succès",
	    LblBookingAbortSuccess: "La réservation a bien été annulée",
	    LblBookingRevokeSuccess: "La réservation a bien été supprimée",
	    LblContactPersonRemoveSuccess: "Personne à contacter supprimée",
	    LblNoRecords: "Aucune donnée disponible",
	    LblAffectedBookingList: "Liste des réservations concernées",
	    LblSubscriptionEndDateError: "Saisir la date de fin d'abonnement",
	    LblIsSpecialPeriodAllow: "Souhaitez-vous appliquer des frais pour une période particulière ?",
	    LblContractSlotisnotdefined: "Le type de contrat pour le créneau horaire indiqué ci-dessous n'est pas défini",
	    LblUnscubscribeSuccess: "Désabonnement confirmé",
	    LblModifiedBy: "Modifié par",
	    LblModifiedDate: "Date de modification",
	    LblInstance: "Organisme",
	    LblInstanceName: "Nom de l'organisme",
	    LblInstanceType: "Type d'organisme",
	    LblDescription: "Description",
	    LblCurrencySymbol: "Symbole de la devise monétaire",
	    LblPreferredLanguage: "Langue",
	    LblTimeZone: "Fuseau horaire",
	    LblCurrencyAbbreviation: "Abréviation de la devise monétaire",
	    LblInstanceDeleteValidation: "Impossible de supprimer l'instance car elle fait référence à une autre entité",
	    LblIsBookingApprovalReq: "Autorisation de la réservation requise",
	    LblKilometers: "Kilomètres",
	    LblKM: "Km",
	    LblDeletePersonNote: "Les factures en attente pour cette personne ne seront pas envoyées",
	    LblInstanceConfiguration: "Configuration des services",
	    LblBookingAlertTime: "Délai d'avertissement de réservation",
	    LblBookingCancelTime: "Délai d'annulation de la réservation",
	    LblBookingTemporaryTime: "Heure de confirmation de la réservation",
	    LblVtsRequestTimeout: "Demande de VTS - aucune réaction",
	    LblVtsTripLogTimeout: "Carnet de route VTS - aucune réaction",
	    LblEmailConfiguration: "Configuration de la messagerie (SMTP)",
	    LblInSeconds: "En secondes",
	    LblFromEmail: "Envoyer l'adresse électronique",
	    LblHost: "Hôte",
	    LblPort: "Port",
	    LblEnableSsl: "Activer SSL",
	    LblSmtpEmail: "Courriel SMTP",
	    LblIsImportPersonAllow: "Permission d'importer la personne",
	    LblValidateLiceanceNumber: "Vérification du permis de conduire",
	    LblValidateLicenseA2SP: "Vérification du permis de conduire A2SP",
	    LblValidateLicense24IDCheck: "Vérification du permis de conduire 24ID",
	    LblValidateLicenseForAllBookings: "Effectuer une vérification du permis de conduire pour chaque réservation",
	    LblGeofenceLocation: "Location geofence",
	    LblRadius: "Rayon",
	    LblEmailRecepients: "Destinataires des courriels",
	    LblRecepients: "Destinataires",
	    LblEmailAddresses: "Adresses mail",
	    LblMap: "Carte",
	    // AFAS/Azure Config
	    LblImportConfiguration: "Import Configuration",
	    LblImportConnectionType: "Connection Type",
	    LblAfas: "AFAS",
	    LblAzure: "Azure",
	    LblAzureTenantId: "Azure Tenant ID",
	    LblAzureClientId: "Azure Client ID",
	    LblAzureClientSecret: "Azure Client Secret",
	    LblAfasClientId: "AFAS Client ID",
	    LblAfasConnectorName: "AFAS Connector Name",
	    LblAfasConnectionType: "AFAS Connection Type",
	    LblAfasTest: "Test",
	    LblAfasAccept: "Acceptation",
	    LblAfasProduction: "Production",
	    LblAfasToken: "AFAS Token",
	    LblAfasClientIdError: "Please enter AFAS Client ID",
	    LblAfasConnectorNameError: "Please enter AFAS Client ID",
	    LblAfasConnectionTypeError: "Please enter AFAS Connection Type",
	    LblAfasTokenError: "Please enter AFAS-Token",
	    LblAzureTenantIdError: "Please enter Azure Tenant ID",
	    LblAzureClientIdError: "Please enter Azure Client ID",
	    LblAzureClientSecretError: "Please enter Azure Client Secret",
	    // SSO Config
	    LblSsoConfiguration: "SSO Configuration",
	    LblDefaultSsoSharedVehicleGroup: "Default Shared Vehicle Group",
	    LblDefaultSsoOrganization: "Default Organization",
	    LblDefaultSsoSubscription: "Default Subscription",
	    // Dropoff Message
	    LblDropoffMessageConfiguration: "Dropoff Message Configuration",
	    LblDropoffMessageExternalUrl: "External Url",
	    LblDropoffMessageApiKey: "Api Key",
	    LblDropoffMessageActive: "Active",
	    LblBookingCalanderSettings: "Configuration de l'agenda",
	    LblShowDriverInfo: "Afficher les données du conducteur dans l'agenda",
	    LblOrganizationAdmin: "Gestionnaire de l'organisation",
	    LblDriverInfoToShow: "Données du conducteur qui sont affichées",
	    LblValidate: "Valider",
	    LblBookingCancelTimeMessage: "Ceci définit le laps de temps (en secondes) après lequel l'annulation d'une réservation n'est plus possible",
	    LblBookingTemporaryTimeMessage: "Temps pour une réservation provisoire. Après que l'utilisateur ait sélectionné le véhicule à réserver mais celui-ci n'a pas encore été confirmé.",
	    LblVtSRequestTimeoutMessage: "Aucune réaction pour la commande de déverrouillage / verrouillage dans l'appli",
	    LblVtsTriplogTimeoutMessage: "Aucune réaction pour le calcul des déplacements après exécution de la commande de verrouillage",
	    LblContractTypeDeleteValidation: "Impossible de supprimer le Groupe de Type de Contrat car celui-ci est rattaché à une autre entité",
	    LblUserName: "Nom d'utilisateur",
	    LblFirstName: "Prénom",
	    LblLastName: "Nom",
	    LblEmail: "Adresse mail",
	    LblMobileNumber: "Numéro de téléphone portable",
	    LblPhoneNumber: "Numéro de téléphone",
	    LblHomeAddress: "Adresse personnelle",
	    LblWorkAddress: "Adresse professionnelle",
	    LblHouseNo: "Numéro",
	    LblHouseExtention: "Extension",
	    LblStreetName: "Rue",
	    LblCity: "Ville",
	    LblZipCode: "Code postal",
	    LblPassword: "Mot de passe",
	    LblConfirmPassword: "Confirmez le mot de passe",
	    LblMiddleName: "Particule",
	    LblCompany: "Entreprise",
	    LblCompanyName: "Nom de l'entreprise",
	    LblContactPerson: "Personne à contacter",
	    LblCompanyAdmin: "Administrateur de l'entreprise",
	    LblCompanyAddress: "Adresse de l'entreprise",
	    LblApkExiprationSetting: "Paramètres de notification CT",
	    LblNotificationFrequency: "Fréquence de notification",
	    lblThresholdFrequency: "Fréquence d'avertissement au préalable",
	    lblThresholdTimeInterval: "À quelle fréquence les avertissements seront envoyés au préalable",
	    LblIsEmailEnabled: "Message par mail",
	    LblEnabled: "Activé",
	    LblDisabled: "Désactivé",
	    LblFrequency: "Fréquence",
	    LblApkTimeInterval: "Intervalle de temps des avertissements",
	    LblEmailNotification: "Message par mail",
	    LblWeek: "SEMAINE",
	    LblMonth: "Mois",
	    lblPerBooking: "Par réservation",
	    LblInternalOrganization: "Organisation interne",
	    LblNoOfVegicles: "Nombre de véhicules",
	    LblNoOfSharedVehicleGroups: "Nombre de groupes cibles",
	    LblGeoLocation: "Site",
	    LblSelectGeoLocation: "Sélectionnez un site",
	    LblPerson: "Personne",
	    LblRole: "Fonction",
	    LblDateOfBirth: "Date de naissance",
	    LblDriverLicenceNumber: "Numéro de permis de conduire",
	    LblPersons: "Personnes",
	    LblPersonOverview: "Aperçu de la ou des personnes",
	    LblCompanies: "Entreprises",
	    LblVehicle: "Véhicule",
	    LblVtsVehicle: "Véhicule VTS",
	    LblLicenceTag: "Plaque d'immatriculation",
	    LblLicence: "Permis de conduire",
	    LblMobile: "Téléphone portable",
	    LblVehicleOwner: "Propriétaire du véhicule",
	    LblLocationDataExchange: "Lieu d'échange de données",
	    LblBrand: "Marque",
	    LblType: "Type",
	    LblColor: "Couleur",
	    LblVehicleClass: "Catégorie de véhicule",
	    LblPricingCategory: "Catégorie de prix",
	    LblBodyStyle: "Type de carrosserie",
	    LblAvailable: "Disponible",
	    LblUnAvailable: "Indisponible",
	    LblAvailableFrom: "Disponible à partir du",
	    LblAvailableTo: "Disponible jusqu'au",
	    LblFuelType: "Type de carburant",
	    LblMinBookingTimeBefore: "Temps minimum avant la réservation (en minutes)",
	    LblMinBookingTimeAfter: "Temps minimum après la réservation (en minutes)",
	    LblTowbar: "Dispositif d'attelage",
	    LblAirco: "Climatisation",
	    LblApkExpirationDateCet: "Date d'expiration CT",
	    LblVehicleAttributes: "Caractéristiques du véhicule",
	    LblBlockUnBlock: "Bloquer / Débloquer",
	    LblRemoveLicense: "Supprimer permis de conduire",
	    LblRemoveLicenseBirthDate: "Supprimer permis de conduire et date de naissance",
	    LblLicenseBirthDate: "Date de naissance",
	    LblBlock: "Bloquer",
	    LblUnblock: "Débloquer",
	    LblAvailableUnAvailable: "Disponible / Indisponible",
	    LblIntialOdometerValue: "Kilométrage de début",
	    LblVehicles: "Véhicules",
	    LblBookingsOverview: "Récapitulatif des réservations",
	    LblFuelCardPinCode: "Code PIN pour la carte de carburant",
	    LblFuel: "Carburant",
	    LblVINnumber: "Numéro d'identification du véhicule",
	    LblVehicletype: "Type de véhicule",
	    LblDoors: "Nombre de portes",
	    LblWeight: "Poids du véhicule",
	    LblTrunkSpace: "Volume du coffre",
	    LblGears: "Nombre de vitesses",
	    LblEngineHorsepower: "Puissance moteur ",
	    LblFuelConsumption: "Consommation de carburant",
	    LblSeats: "Nombre de places",
	    LblDimensions: "Dimensions du véhicule",
	    LblTransmissionType: "Type de transmission",
	    LblTransmissionUnknown: "Type de transmission inconnu",
	    LblManualTransmission: "Transmission manuelle",
	    LblAutomaticTransmission: "Transmission automatique",
	    LblVehicleDetails: "Détails du véhicule",
	    LblSelectVehicletype: "Sélectionnez le type de véhicule",
	    LblWrongVinNumber: "Numéro d'identification non valide",
	    LblVehicleOnSameLocationTime: "Véhicule au même endroit plus longtemps que",
	    LblNoBookingIn: "Aucune réservation pour plus de",
	    lblHour: "Heure",
	    lblHourDayWeekMonth: "Heure / jour / semaine / mois",
	    LblSharedVehicleGroup: "Groupe cible",
	    LblVehicleGroup: "Groupe de véhicule",
	    LblSharedVehicleGroupAdmin: "Administrateur du groupe de pool",
	    LblDisplayPeriod: "Période d'affichage",
	    LblBookingWeekDays: "Réserver des jours ouvrables",
	    LblBookingInterval: "Intervalle de réservation (en minutes)",
	    LblBookingStartTime: "Heure de début de la réservation (hh:mm)",
	    LblBookingEndTime: "Heure de fin de la réservation (hh:mm)",
	    LblBookingMinDuration: "Durée minimale de réservation (en minutes)",
	    LblBookingMaxDuration: "Durée maximale de réservation (en minutes)",
	    LblMaxRecurringBooking: "Nombre maximum de répétitions",
	    LblPreBookingInterval: "Marge de temps avant la réservation (en minutes)",
	    LblPostBookingInterval: "Marge de temps après la réservation (en minutes)",
	    LblBookingExtensionTime: "Durée maximale d'extension de la réservation (en minutes)",
	    LblBookAheadTime: "Réservation possible dans X minutes",
	    LblBookingHorizon: "Horizon des réservations",
	    LblDay: "Jour",
	    LblNumberOfContactTypeGroup: "Nombre de groupes de types de contrats",
	    LblNumberOfContactType: "Nombre de types de contrats",
	    LblInvoiceInterval: "Intervalle de facturation",
	    LblIsBookingIntervalAlignToCalendar: "Choix de l'heure de la réservation conforme au bloc horaire",
	    LblEarlyOpenInterval: "Intervalle ouverture plus tôt (en minutes)",
	    LblFeatureFlags: "Indicateurs de fonctionnalité",
	    LblCreateBooking: "Créer une réservation",
	    LblEditBooking: "Modifier la réservation",
	    LblLicenseCheck: "Vérification de licence",
	    LblBookingLicenseCheck: "Vérification de la licence de réservation",
	    LblBookings: "Réservations",
	    LblSharedVehicleGroups: "Groupes de pool",
	    LblSharedVehicleGroupOverview: "Aperçu du groupe de pool",
	    LblDriver: "Conducteur",
	    LblLicenceNumber: "Numéro de permis de conduire",
	    LblDriverName: "Nom du conducteur",
	    LblDriverSVG: "Conducteur groupe de pool",
	    LblDriverUserName: "Nom d'utilisateur du conducteur",
	    LblSelectFuelType: "Sélectionnez le type de carburant",
	    LblSelectPricingCatagory: "Sélectionnez la gamme de prix",
	    LblSelectBodyStyle: "Sélectionnez le type de carrosserie",
	    LblSelectVehicleClass: "Sélectionnez la catégorie de véhicule",
	    LblVehicleAttributeCategory: "Catégorie de caractéristiques du véhicule",
	    LblVehicleAttributeName: "Caractéristique",
	    LblVehicleAttributeDesc: "Description",
	    LblVehicleAttribute: "Caractéristique du véhicule",
	    LbAdditionallVehicleAttribute: "Caractéristiques supplémentaires",
	    LblVehicleAttributeCategories: "Catégories pour les attributs du véhicule",
	    LblRegular: "Standard",
	    LblWeekEnd: "Week-end",
	    LblDayCT: "Jour",
	    LblExtraTimeBefore: "Temps supplémentaire plus tôt (en minutes)",
	    LblExtraTimeAfter: "Temps supplémentaire après (en minutes)",
	    LblFreeTextDescription: "Indiquez le tarif, les heures de début et de fin de la réservation particulière (champs libre)",
	    LblPeriodRate: "Période tarifaire",
	    LblPeriodRateVat: "TVA période tarifaire",
	    LblSelectContractTypeType: "Sélectionnez le type de type de contrat",
	    LblContractTypeType: "Type de type de contrat",
	    LblContractType: "Type de contrat",
	    LblContractName: "Nom du contrat",
	    LblContractTypeGroup: "Groupe de type de contrat",
	    LblContractTypeGroupName: "Nom du groupe du type de contrat",
	    LblContractAvailableDays: "Jours disponibles contrat",
	    LblApplicableDays: "Jours applicables",
	    LblDayStartTime: "Heure de début du jour (hh:mm)",
	    LblDayEndTime: "Heure de fin du jour (hh:mm)",
	    LblApplicableStartTime: "Heure de début applicable (hh:mm)",
	    LblApplicableEndTime: "Heure de fin applicable (hh:mm)",
	    LblComment: "Remarque",
	    LblProcessingFee: "Frais administratifs",
	    LblTripDisplayType: "De quelle façon les trajets doivent-ils être affichées dans les rapports ?",
	    LblAllTripsIndividually: "Tous les trajets séparément",
	    LblAllTripsGrouped: "Tous les trajets regroupés en un seul trajet",
	    LblVatPercentage: "Pourcentage TVA",
	    LblVatIncludedInPrice: "TTC",
	    LblPlateformUsageCost: "Frais d'utilisation de la plateforme",
	    LblCatA: "Catégorie A",
	    LblCatB: "Catégorie B",
	    LblCatC: "Catégorie C",
	    LblCatD: "Catégorie D",
	    LblCatE: "Catégorie E",
	    LblCatF: "Catégorie F",
	    LblCatG: "Catégorie G",
	    LblCatH: "Catégorie H",
	    LblHourlyRate: "Coûts de la location",
	    LblMileageRate: "Prix au kilomètre",
	    LblFixedFee: "Frais fixes",
	    LblPricingModel: "Modèle de tarification",
	    LblContractStartDateTime: "Date de début du contrat",
	    LblContractEndDateTime: "Date / heure de fin du contrat",
	    LblContractTypeHistory: "Historique",
	    LblContractTypPeriod: "Période du type de contrat",
	    LblInactiveContractTypeGroupReason: "Motif de la désactivation du groupe de types de contrat",
	    LblPenaltyAmount: "Montant de la pénalité",
	    LblPenaltyTimeInterval: "Intervalle de temps des pénalités (en minutes)",
	    LblIsPenaltyEnabled: "Pénalité activée",
	    LblJanuary: "Janvier",
	    LblFebruary: "Février",
	    LblMarch: "Mars",
	    LblApril: "Avril",
	    LblMay: "Mai",
	    LblJune: "Juin",
	    LblJuly: "Juillet",
	    LblAugust: "Août",
	    LblSeptember: "Septembre",
	    LblOctober: "Octobre",
	    LblNovember: "Novembre",
	    LblDecember: "Décember",
	    LblSJan: "Jan.",
	    LblSFeb: "Fév.",
	    LblSMar: "Mar.",
	    LblSApr: "Avr.",
	    LblSMay: "Mai",
	    LblSJun: "Juin",
	    LblSJul: "Juil.",
	    LblSAug: "Août",
	    LblSSep: "Sep.",
	    LblSOct: "Oct.",
	    LblSNov: "Nov.",
	    LblSDec: "Déc.",
	    LblSunday: "Dimanche",
	    LblMonday: "Lundi",
	    LblTuesday: "Mardi",
	    LblWednesday: "Mercredi",
	    LblThursday: "Jeudi",
	    LblFriday: "Vendredi",
	    LblSaturday: "Samedi",
	    LblSSu: "Di",
	    LblSMo: "Lu",
	    LblSTu: "Ma",
	    LblSWe: "Me",
	    LblSTh: "Je",
	    LblSFr: "Ve",
	    LblSSa: "Sa",
	    LblForgotPassword: "Mot de passe oublié",
	    LblChangePassword: "Modifier mot de passe",
	    LblOldPassword: "Ancien mot de passe",
	    LblNewPassword: "Mot de passe",
	    LblProfileUpdatedSucessFully: "Profil modifié avec succès",
	    LblPasswordChangedSucessFully: "Votre mot de passe a été modifié",
	    LblUpdateProfile: "Modifier profil",
	    LbLReasonVehicle: "Motif de l'indisponibilité",
	    LblReasonDriver: "Motif de suspension du conducteur",
	    LblFrom: "De",
	    LblTo: "À",
	    LblBooking: "Réservation ",
	    LblBookingRequest: "Demande de réservation",
	    LblOverview: "Aperçu des réservations",
	    LblOverviewList: "Liste des réservations",
	    LblApproveBooking: "Approbation de la réservation",
	    LblApprove: "Approuver",
	    LblReject: "Rejeter",
	    LblNormal: "Nouvelle réservation",
	    LblSpecial: "Réservation particulière",
	    LblHistory: "Historique de la réservation",
	    LblBookingStatus: "Statut de la réservation",
	    LblBookingType: "Type de réservation",
	    LblAdminRemarks: "Remarque Admin",
	    LblBookingRemarks: "Remarques de la réservation",
	    LblDriverRemarks: "Remarques du conducteur",
	    LblBookingReferenceId: "Nº de réservation",
	    LblAbort: "Annuler",
	    LblRevoke: "Supprimer",
	    LblStatus: "Statut",
	    LblReference: "Nº de référence",
	    LblRemarks: "Remarques",
	    LblSearchForVehicle: "Trouver véhicule",
	    LblVehicleOverview: "Aperçu des véhicules",
	    LblConfirmBooking: "Confirmer la réservation",
	    LblCurrentBookingDetail: "Détails de la réservation actuelle",
	    LblCheckAvailability: "Contrôler la disponibilité",
	    LblBookingStartDateTime: "Commencer la réservation",
	    LblBookingEndDateTime: "Terminer la réservation",
	    LblSource: "Lieu de prise en charge",
	    LblRecurring: "Récurrente",
	    LblRecurringId: "Nº de réservation récurrente",
	    LblRecurringBookingReference: "Référence du nº de réservation récurrente",
	    LblDaily: "Chaque jour",
	    LblWeekly: "Chaque semaine",
	    LblMonthly: "Chaque mois",
	    LblRecurrenceEndDate: "Date de fin de la récurrence",
	    LblSearch: "Chercher",
	    LblBookNow: "Réserver",
	    LblUpdateBooking: "Modifier la réservation",
	    LblEditCarNotAvailable: "Le véhicule réservé à l'origine n'est pas disponible",
	    LblSortBy: "Trier par",
	    LblAvaibility: "Disponibilité",
	    LblNoMatchingVehicle: "Aucun véhicule disponible trouvé",
	    LblAvailableSlots: "Périodes disponibles",
	    LblFeatures: "Caractéristiques",
	    LblDriverDetail: "Données du conducteur",
	    LblBookingDetail: "Données de la réservation",
	    LblVehicleDetail: "Données du véhicule",
	    LblBookingSuccess: "Votre demande de réservation a bien été créée. Vous recevrez une copie de cette demande à l'adresse mail enregistrée. Vous recevrez également une notification pour approbation et vous serez averti lorsque la réservation sera acceptée.",
	    LblBookingUpdateSuccess: "La réservation a bien été mise à jour. Une notification a été envoyée à l'adresse mail du conducteur.",
	    LblBlockNormalBooking: "Votre compte est bloqué. Veuillez contacter l'administrateur.",
	    LblSingle: "Unique",
	    LblSeries: "Série",
	    LblLicenceRequired1: "Merci de bien vouloir valider le numéro du permis de conduire, allez à",
	    LblLicenceRequired2: "Pour mettre à jour les détails du permis de conduire.",
	    LblAcceptOrReject: "Approuver / rejeter",
	    LblSpecialBooking: "Réservation particulière",
	    LblAffectedBooking: "Réservation concernée",
	    LblSpecialBookingType: "Type de réservation particulière",
	    LblSelectSpecialBookingType: "Sélectionnez le type de réservation particulière",
	    LblSpecialBookingConfiramtionmsg: "Êtes-vous certain de vouloir créer une réservation particulière ?",
	    LblEndDate: "Fin de la réservation récurrente",
	    LblNotification: "Notification",
	    LblSubject: "Sujet",
	    LblDate: "Date",
	    LblWelcomeNotification: "Bienvenue dans la boîte de réception des notifications",
	    LblTemplate: "Modèle",
	    LblTemplateList: "Liste des modèles",
	    LblTemplateName: "Nom du modèle",
	    LblTemplateType: "Type de modèle",
	    LblIsEmailTemplate: "Adresse mail",
	    LblIsWebTemplate: "Web",
	    LblBody: "Carrosserie",
	    LblNotificationEventManagement: "Gestion de notification d'événement",
	    LblNotificationEvent: "Notification d'événement",
	    LblModuleName: "Nom du module",
	    LblSMS: "SMS",
	    LblUserType: "Type d'utilisateur",
	    LblTimeBlock: "Bloc horaire",
	    LblTimeBlockName: "Nom du bloc horaire",
	    LblTimeBlockWeekDays: "Jours de la semaine du bloc horaire",
	    LblTimeBlockStartTime: "Heure de début du bloc horaire",
	    LblTimeBlockEndTime: "Heure de fin du bloc horaire",
	    LblTimeBlockStartDate: "Date de début du bloc horaire",
	    LblTimeBlockEndDate: "Date de fin du bloc horaire",
	    LblServiceOffer: "Offre de services",
	    LblServiceOfferList: "Liste d'offre de services",
	    LblServiceOfferName: "Nom du service",
	    LblServiceOfferType: "Type de service",
	    LblStandardTariff: "Tarif standard",
	    LblTimeUsedOrBooked: "Temps utilisé / réservé",
	    LblDistance: "Distance",
	    LblPenalty: "Pénalité",
	    LblAdditional: "Extra",
	    LblAdditionalAbbr: "En supplément",
	    LblUnit: "Unité",
	    LblWegoAdmin: "Administrateur WeGo",
	    LblWegoAdmins: "Admins WeGo",
	    LblReSend: "Envoyer à nouveau",
	    LblResendActivationMail: "Mail d'activation",
	    LblResendActivationMailFailure: "Impossible d'envoyer le mail d'activation",
	    LblResendActivationMailSuccess: "Mail d'activation envoyé",
	    LblSubscription: "Abonnement",
	    LblSubscriptionName: "Nom de l'abonnement",
	    LblTimeInterval: "Intervalle de temps",
	    LblAmount: "Quantité",
	    LblFreeKilometer: "Crédits offerts",
	    LblFreeMinute: "Minutes offertes",
	    LblFreeHours: "Heures offertes",
	    LblNumberOfSubscription: "Nombre d'abonnements",
	    LblUnsubscribe: "Résilier l'abonnement",
	    LblsubscribeEndDate: "Date de fin de l'abonnement",
	    LblSubscriptionStartDate: "Date de début de l'abonnement",
	    LblSpecialPeriod: "Période particulière",
	    LblspecialPeriodName: "Nom de la période particulière",
	    LblSpecialPeriodStartTime: "Heure de début de la période particulière",
	    LblSpecialPeriodEndTime: "Heure de fin de la période particulière",
	    LblSpecialPeriodWeekDays: "Jours de la semaine de la période particulière",
	    LblNormalPeriod: "Période normale",
	    LblSpecialPeriods: "Période particulière",
	    LblWegoAdminDependencyValidation: "L'administrateur WeGo ne peut pas être supprimé car il est rattaché à une autre entité",
	    LblBookingInvoice: "Facture de réservation",
	    LblInvoiceStatus: "Statut de la facture",
	    LblAdminDependencyValidation: "Le rôle d'administrateur ne peut pas être supprimé car il est rattaché à une autre entité",
	    LblAdminDependencyAlert: "Notification de rattachement à l'administrateur",
	    LblTotalHours: "Temps total",
	    LblInvoiceType: "Type de facture",
	    LblSummary: "Résumé",
	    LblTotalKm: "Distance totale (en km.)",
	    LblTotalExpense: "Totalité des coûts",
	    LblInvoiceNumber: "Numéro de factuur",
	    LblAdminDependencyValidationOnDelete: "L'administrateur sélectionné ne peut pas être supprimé car il est rattaché à une autre entité",
	    LblBegin: "Début",
	    LblEnd: "Fin",
	    LblVat: "TVA",
	    LblTotal: "Total",
	    LblInvoiceRequestDateTime: "Date / heure de demande de facture",
	    LblInvoiceSendDateTime: "Date / heure d'envoi de la facture",
	    LblInvoiceDateTime: "Date / heure de la facture",
	    LblInvoiceDetail: "Détails de la facture",
	    LblResend: "Renvoyer",
	    LblDownload: "Télécharger",
	    LblResendInvoiceConfirm: "Êtes-vous certain de vouloir renvoyer %0 ?",
	    LblRemoveContactPersonConfirm: "Êtes-vous sûr de vouloir supprimer le contact ?",
	    LblPenaltyRate: "Penalité",
	    LblSendInvoiceConfirm: "Êtes-vous sûr de vouloir envoyer la facture ?",
	    LblInvoicing: "Facturation",
	    LblInvoices: "Facture",
	    LblCarwiseConfiguration: "Configuration Carwise",
	    LblCarwiseConnectionUrl: "URL de connexion",
	    LblCarwiseConnectionUsername: "Nom de la connexion",
	    LblCarwiseEnable: "Carwise activé",
	    LblCarwiseConnectionPassword: "Mot de la passe de la connexion",
	    LblCarwiseAutoDeleteFrequencyInDays: "Fréquence de suppression automatique (en jours)",
	    LblDamageImageExtentions: "Format du fichier des dommages",
	    LblDone: "Prêt",
	    LblClear: "Effacer",
	    LblEditPage: "Modifier %0",
	    LblAddPage: "Ajouter %0",
	    LblListPage: "Aperçu %0",
	    LblAll: "Tout",
	    LblProfile: "Profil",
	    LblSignOut: "Se déconnecter",
	    LblTemplateNote1: "Veuillez ne pas supprimer ou modifier le texte rédigé comme {nom de la variable}. Il s'agit d'un élément variable qui sera remplacé par la valeur correspondante de la base de données lors de l'envoi.",
	    LblTemplateNote2: "Veuillez ne pas modifier la structure du tableau. Vous pouvez en ajouter un nouveau, mais pas modifier celui qui existe déjà.",
	    LblTemplateNote3: "Veuillez vous assurer, lorsque vous copiez un « placeholder » et que vous le collez dans un éditeur HTML, que vous le « collez comme texte brut ».",
	    LblConfirmUnsubscribe: "Êtes-vous sûr de vouloir vous déconnecter ?",
	    LblDriveHours: "Heures disponibles",
	    LblVehicleImage: "Image du véhicule",
	    LblMaintenance: "Entretien",
	    LblUNAVAILABLE: "Indisponible",
	    LblTestInvoiceGenerator: "Générateur de factures test",
	    LblInvoicingDateTime: "Date / heure de la facture (UTC)",
	    LblGenerateInvoice: "Générer la facture",
	    LblDeleteAllSelectedRecords: "Supprimer toutes les lignes sélectionnées",
	    LblCancelAllSelectedRecords: "Annuler toutes les lignes sélectionnées",
	    "LblExportAll(CSV)": "Exporter (CSV)",
	    LblContractTypeGroupAvailableForSubscription: "Aucun groupe de type de contrat n'est disponible pour ajouter %0.",
	    LblAddContactPerson: "Ajouter une personne à contacter",
	    LblRemoveContactPerson: "Supprimer une personne à contacter",
	    LblNote: "Note",
	    LblCompletelyEndConfirm: "Terminer complètement le trajet",
	    LblEndTrip: "Terminer le trajet",
	    LblTestTrip: "Trajet test",
	    LblTripSimulator: "Simulateur de trajet",
	    LblTestTripSuccess: "Trajet test créé avec succès",
	    LblDrivingStartDateTime: "Date / heure de début du trajet",
	    LblDrivingEndDateTime: "Date / heure de fin du trajet",
	    LblInvoiceMoment: "Moment de la facturation",
	    LblExtend: "Prolonger",
	    LblExtendRequire: "Veuillez saisir le temps de prolongation (en minutes)",
	    LblExtendInfoMsg: "Vous pouvez prolonger votre réservation jusqu'à %0 minutes.",
	    LblExtendValidationMsg: "Cette réservation ne peut pas être prolongée",
	    LblExtendBooking: "Prolonger la réservation",
	    LblBookingExtendedSuccess: "Réservation prolongée",
	    LblOverExtendValidationMsg: "La réservation peut être prolongée de %0 minutes tout au plus",
	    LblUnLock: "Déverrouiller",
	    LblLock: "Verrouiller",
	    LblVehicleStatus: "Statut du véhicule",
	    LblTripSuccess: "Trajet enregistré",
	    LblLockSuccessfully: "Véhicule verrouillé avec succès",
	    LblLockCompletelySuccessfully: "Véhicule verrouillé",
	    LblUnLockSuccessfully: "Véhicule déverrouillé",
	    LblUnlockProblem: "Problème lors de la commande de déverrouillage",
	    LbllockProblem: "Problème lors de la commande de verrouillage",
	    LblLockCarCompletely: "Fermer et terminer la réservation",
	    LblStartDateTime: "Date / heure de début",
	    LblEndDateTime: "Date / heure de fin",
	    LblBookingTripDetail: "Détails du trajet de la réservation",
	    LblAddNewTrip: "Ajouter un nouveau trajet",
	    LblBookingExpenseDetail: "Détails des frais de réservation",
	    LblUnlockErrorMessage: "Aucun groupe de type de contrat actif n'est disponible au moment de la réservation.",
	    LblExpenseAmount: "Montant des frais",
	    LblExpenseName: "Nom des dépenses",
	    LblExpenseSuccess: "Dépenses sauvegardées avec succès",
	    LblReceipt: "Réception",
	    LblHelpdeskNo: "Numéro du service d'assistance",
	    LblInactiveReason: "Motif de l'inactivité",
	    LblBookingExpired: "Vous ne pouvez pas déverrouiller le véhicule si la réservation a expiré.",
	    LblTripCalculationInProgress: "J'espère que vous avez fait un bon voyage ! Le véhicule se fermera dans quelques secondes.",
	    LblActualInvoiceGenerationDate: "Date de création de la facture",
	    LblAvailableForAllSlots: "Véhicule disponible pour tous les créneaux horaires",
	    LblUnAvailableSlots: "Créneaux horaires non disponibles",
	    LblNoOfDrivers: "Nombre de conducteurs",
	    LblVTSReqLogDetail: "Demande de détails sur le journal VTS",
	    LblVTSReqDateTime: "Date / heure de la demande",
	    LblVTSProcessTime: "Délai de traitement",
	    LblVTSResTime: "Heure du résultat",
	    LblVTSReqType: "Type de demande",
	    LblVTSResult: "Résultat",
	    LblSVGDriversList: "Conducteurs de groupe de pool",
	    LblVehicleInformation: "Informations sur le véhicule",
	    LblVTSVehicle: "VTS Voertuig",
	    LblFleetId: "ID de la flotte",
	    LblContractId: "ID du contrat",
	    LblVIN: "VIN",
	    LblVTSVehicleUpdateSuccess: "Véhicule %0 avec succès",
	    LblTroubleShootVTS: "Dépannage du VTS",
	    LblVTSVehicleList: "Liste des véhicules VTS",
	    //Booking Type
	    LblNORMALBOOKINGTYPE: "STANDARD",
	    LblMAINTENANCEBOOKINGTYPE: "ENTRETIEN",
	    LblUNAVAILABLEBOOKINGTYPE: "NON DISPONIBLE",
	    //Booking Request Status
	    LblAPPROVEDBOOKINGREQUEST: "APPROUVÉE",
	    LblREJECTEDBOOKINGREQUEST: "REJETÉE",
	    LblPENDINGBOOKINGREQUEST: "EN ATTENTE",
	    //Booking Status
	    LblABORTED: "INTERROMPUE",
	    LblCANCELLED: "ANNULÉE",
	    LblCONFIRMED: "CONFIRMÉE",
	    LblFINISHED: "FINALISÉE",
	    LblNOSHOW: "NON PRÉSENTATION",
	    LblPENDING: "EN ATTENTE",
	    LblREVOKED: "ANNULÉE",
	    LblRUNNING: "LANCÉE",
	    LblREADYFORPAYMENT: "PRÊTE POUR PAIEMENT",
	    //Invoice Status
	    LblOPEN: "OUVERTE",
	    LblSENT: "ENVOYÉE",
	    LblCLOSED: "CLÔTURÉE",
	    LblREQUESTFORPAYMENT: "DEMANDE DE PAIEMENT",
	    LblREOPEN: "RÉOUVERTE",
	    LblFileNotFound: "Le fichier n'existe pas, veuillez contacter le service d'assistance.",
	    // Error Log
	    LblErrorLog: "Rapport d'erreurs",
	    LblComponentName: "Nom du composant",
	    LblLogType: "Type de journal",
	    LblEventDateTime: "Date / heure de l'événement",
	    // Interface Status
	    LblInterfaceStatus: "Statut de l'interface",
	    LblLastStatusChangeDateTime: "Date / heure du dernier changement de statut",
	    LblLastCarwisePollDateTime: "Date / heure dernier sondage Carwise",
	    LblUpdatedDateTime: "Date et heure modifiées",
	    LblMonitoring: "Suivi",
	    LblDropoffMessage: "Message de dépôt",
	    LblPreferredlanguage: "Langue préférée",
	    LblDebtornr: "numéro du débiteur",
	    //ErrorEscalation
	    LblDuplicateErrorEscalation: "Doublons trouvés dans la configuration d'escalade d'erreurs",
	    LblErrorEscalation: "Escalade d'erreurs",
	    LblComponent: "Composant",
	    LblSelectAdminLevel: "Sélectionnez le niveau de l'administrateur",
	    LblWegoAdminLevel: "Niveau de l'administrateur de Wego",
	    LblCustomerAdminLevel: "Niveau de gestion des clients",
	    LblInstanceAdminLevel: "Niveau de gestion des instances",
	    LblEnableLogin: "Ouverture de session",
	    LblEnableErrorEscalation: "Activation de l'escalade d'erreurs",
	    LblErrorEscalationMinutes: "Erreur dans l'escalade en minutes",
	    //Report Damage
	    LblReportDamage: "Signaler des dommages",
	    LblCompleteDamageReport: "Soumettre un rapport de dommages",
	    LblDamageFile: "Fichier de dommages",
	    LblDescribe: "Décrivez le(s) dommage(s) ...",
	    LblCause: "Décrivez la cause ...",
	    LblReportDamageMsg: "Dommages signalés",
	    LblSelectFile: "Sélectionnez le fichier",
	    // Import Data
	    LblCSVImport: "Importer un fichier CSV",
	    LblValidateCSV: "Valider CSV",
	    LblImportValidPerson: "Importer une personne valide",
	    LblImportValidDriver: "Importer un conducteur valide",
	    LblImportValidVehicle: "Importer un véhicule valide",
	    LblCSVType: "Type de fichier CSV",
	    LblCSVFile: "Fichier CSV",
	    LblRecordImportedSuccess: "%0 a été importé",
	    LblInvalidReason: "Raison invalide",
	    LblSameVTSCommand: "La demande est déjà en cours de traitement. Veuillez patienter s'il vous plaît.",
	    LblImportPerson: "Importer une personne",
	    //Subscription related Changes
	    LblSubscriptionInterval: "Période d'abonnement",
	    LblPaymentInterval: "Intervalle de paiement",
	    LblInvoicInterval: "Intervalle de facturation",
	    LblInterval: "Intervalle",
	    LblInvoiceMomentDay: "Moment de facturation (jour de la semaine)",
	    LblInvoiceMomentMonth: "Moment de facturation (jour du mois)",
	    LblFreeMinuteInterval: "Intervalle de minutes gratuites",
	    LblFreeKMInterval: "Intervalle de crédits gratuits",
	    LblSelectSubscriptionInterval: "Sélectionnez la période d'abonnement",
	    LblSelectInvoiceInterval: "Sélectionnez l'intervalle de facturation",
	    LblSelectPaymentInterval: "Sélectionnez l'intervalle de paiement",
	    LblSelectFreeKMInterval: "Sélectionnez l'intervalle de kilomètres gratuits",
	    LblSelectFreeMinInterval: "Sélectionnez un intervalle de minutes gratuites",
	    LblYearlySub: "Annuel",
	    LblMonthlySub: "Mensuel",
	    LblWeeklySub: "Hebdomadaire",
	    LblFreePerWeek: "Par semaine",
	    LblFreePerMonth: "Par mois",
	    LblFreePerTriMonth: "Per 3 mois",
	    LblFreePerBiannual: "Par 6 mois",
	    LblFreePerYear: "Par an",
	    LblDefaultContractTypeGroup: "Groupe de types de contrats standards",
	    LblSelectDefaultContractTypeGroup: "Sélectionnez le type de contrat standard du groupe",
	    LblSendInvoiceToDriver: "Envoyer la facture au chauffeur",
	    LblInherit: "Reprendre",
	    //Invoice Moment
	    LblDayOfMonth: "Jour du mois",
	    LblDayOfWeek: "Jour de la semaine",
	    LblSelectDayOfWeek: "Sélectionnez un jour de la semaine",
	    LblInstanceLogo: "Logo de l'instance",
	    LblResetPasswordFailure: "Le mot de passe ne peut pas être réinitialisé, car l'utilisateur n'a pas encore été activé.",
	    LblInvoiceDeleteValidation: "Impossible de supprimer une facture en raison de son association avec une autre entité",
	    //Additional Free Item
	    LblAdditionalFreeItems: "Crédits gratuits supplémentaires",
	    LblDateAwared: "Date d'attribution",
	    LblAdditionalFreeItemsMenu: "Crédits gratuits supplémentaires",
	    LblTotalFreeKilometer: "Total des kilomètres gratuits",
	    LblTotalFreeMinute: "Total des minutes gratuites",
	    LblCurRemainFreeKilometer: "Kilomètres gratuits restants",
	    LblPrevRemainFreeKilometer: "Quantité précédente de kilomètres gratuits restants",
	    LblCurRemainFreeMinute: "Minutes gratuites restantes",
	    LblPrevRemainFreeMinute: "Quantité précédente de minutes gratuites restantes",
	    LblPrevious: "Précédent",
	    LblCurrent: "Actuel",
	    //Instance Clone
	    LblInstanceClone: "Cloner l'instance",
	    LblNewInstanceName: "Nom de la nouvelle instance",
	    LblCloneResult: "Cloner le résultat",
	    LblCloneStatus: "Statut du clone",
	    CloneError: "Une erreur s'est produite lors du clonage de l'instance et de ses entités.",
	    //SubscriptionAvailabilityRestriction
	    LblSubscriptionAvailabilityRestriction: "Limitation de la disponibilité des abonnements",
	    LblStartDay: "Jour de début",
	    LblEndDay: "Jour de fin",
	    LblStartTime: "Heure de début (hh:mm)",
	    LblEndTime: "Heure de fin (hh:mm)",
	    LblRestriction: "Restriction",
	    //Trip Detail Report
	    LblTripDetailReport: "Aperçu du trajet",
	    LblTripDetailList: "Aperçu détaillé de la réservation",
	    LblSearchTripforDriver: "Trouver les trajets pour le conducteur",
	    LblExportReport: "Exporter le rapport",
	    LblValidateLiceanceNumberMessage: "Veuillez vérifier votre permis de conduire",
	    LblBookingIntervalRate: "Tarif de l'intervalle",
	    LblPerHour: "Par heure",
	    LblPerBookingIntarval: "Par intervalle de réservation",
	    LblTimeRate: "Tarif horaire",
	    LblToalBookingDuration: "Durée de la réservation",
	    LblTripComments: "Remarque sur le voyage",
	    LblTripCommentDescription: "Entrer la remarque de voyage",
	    LblTripCommentError: "Veuillez entrer une remarque sur le voyage",
	    LblShowTripComment: "Voir la remarque",
	    LblAddTripComment: "Ajouter une remarque",
	    LblTripCommentBy: "Remarque de",
	    LblTripCommentOn: "Remarque sur",
	    LblCleanRequire: "Nettoyage nécessaire",
	    LblFualRequire: "Carburant nécessaire",
	    LblVehicleDamageList: "Liste des dommages au véhicule",
	    LblDamageCause: "Cause des dommages",
	    LblDamageReportedBy: "Signalé par",
	    LblDamageReportedOn: "Signalé le",
	    LblConfirmResolveDamage: "Êtes-vous sûr de vouloir supprimer le rapport de dommages ?",
	    LblVehicleDamgeResolveSuccess: "Rapport de dommages supprimé",
	    LblDamageDesc: "Description des dommages",
	    LblFutureBooking: "Réservations futures",
	    LblVehFutureBookingList: "Liste des futures réservations de véhicules",
	    LblResolveDamge: "Supprimer le rapport de dommages",
	    LblReserved: "Réservé",
	    LblVehicleInfoSuccess: "Informations sur le véhicule enregistrées",
	    LblInformation: "Informations",
	    LblVtsServiceStatus: "État du service VTS",
	    LblVtsLicencetag: "Plaque d'immatriculation VTS",
	    LblVtsDoorStatus: "Statut de la portière",
	    LblVtsIssueCommand: "Envoyer une commande",
	    LblVehicleLocation: "Emplacement du véhicule",
	    LblEventHistory: "Historique des événements VTS",
	    LblVehicleObuStatus: "Statut de l'OBU du véhicule",
	    LblVTSHistory: "Historique des événements VTS",
	    LblRequestType: "Type de commande",
	    LblCommandInitiator: "Commande envoyée par",
	    LblResult: "Résultat",
	    LblVTSRequestTime: "Temps de demande de VTS",
	    LblVTSResultTime: "VTS Temps de résultat",
	    LblWegoProcessTime: "Délai de traitement WeGo",
	    LblWegoRequestTime: "Durée de la demande WeGo",
	    LblWegoResultTime: "Temps de résultat WeGo",
	    LblView: "Aperçu",
	    LblVehicleNotInitialized: "Véhicule non initialisé",
	    LblLastReceivedTime: "Heure du dernier message reçu",
	    LblFreePerBookingInterval: "Par intervalle de réservation",
	    LblVtsLocation: "VTS locatie",
	    LblSelectObuType: "Sélectionnez le type d'OBU",
	    LblObuType: "Type d'OBU",
	    LblDeviceId: "Id. du dispositif",
	    LblClaimCode: "Code de réclamation",
	    LblRetriveAddress: "Obtenir l'adresse",
	    LblCrearedDate: "Date de création",
	    LblCreatedBy: "Créée par",
	    LblPerBooking: "Par réservation",
	    LblSelectFilter: "Sélectionner le filtre",
	    LblAuditEntries: "Contrôler les données saisies",
	    LblFilter: "Filtre",
	    LblCategory: "Catégorie",
	    LblEventName: "Nom de l'événement",
	    LblEventData: "Données de l'événement",
	    LblMoment: "Moment",
	    LblUser: "Utilisateur",
	    LblNoEventDataFound: "Aucune donnée de l'événement trouvée",
	    LblEventViewer: "Consulter l'événement",
	    LblOBU: "OBU",
	    LblClone: "Copier",
	    LblCloneVehicle: "Copier %0",
	    LblFualNotRequire: "Carburant non requis",
	    LblCleanNotRequire: "Nettoyage non requis",
	    LblSubscriptionInfo: "Informations concernant l'abonnement",
	    LblVehiclDamaged: "Véhicule endommagé",
	    LblVehicleNotDamaged: "Véhicule non endommagé",
	    LblDamage: "Dommages",
	    LblFreeBooking: "Modifier les frais de réservation",
	    LblBookingCustomFee: "Total des frais de réservation",
	    LblFreeBookingSuccess: "Frais de réservation enregistrés",
	    LblEnterLocation: "Saisir un emplacement",
	    LblHomeLocation: "Site d'origine",
	    LblLocationMode: "Paramètres du site",
	    LblMeter: "Mètre",
	    LblLocation: "Site",
	    LblPickupLocation: "Site de prise en charge",
	    LblLocationUnavailable: "Site non disponible",
	    LblAvailabilityCalander: "Calendrier des disponibilités",
	    LblAvailableOn: "Disponible le",
	    LblGeofenceEnabled: "Géofence active",
	    LblLocationNotFound: "Impossible de déterminer l'adresse",
	    LblAddressNotAvailable: "Impossible de déterminer l'adresse sur ce site",
	    LblReports: "Rapports",
	    LblDrivers: "Conducteurs",
	    LblTemplates: "Modèles",
	    LblPlaceHolder: "Placeholder",
	    LblSampleTemplate: "Exemple de modèle",
	    LblLatexFileDownloadValidation: "Contenu Latex non valide",
	    LblLocationDataExchangeNotAssign: "Ce véhicule ne peut être réservé s'il n'y a pas de véhicule VTS attribué. Souhaitez-vous continuer ?",
	    LblRevenue: "Chiffre d'affaires",
	    // Vehicle Occupancy Report
	    LblVehicleOccupancyReport: "Rapport d'occupation",
	    LblReservedTime: "Temps réservé",
	    LblUsageTime: "Durée d'utilisation",
	    LblUsageTimeAtOffice: "Utilisation pendant les heures de bureau",
	    LblUsageTimeoutOffice: "Utilisation en dehors des heures de bureau",
	    LblRevenuePerVehicleReport: "Chiffre d'affaires par véhicule",
	    LblSearchRevenuePerVehicle: "Rechercher chiffre d'affaires par véhicule",
	    LblRevenuePerVehicleList: "Liste des chiffres d'affaires par véhicule",
	    lblThreshold: "Avertir au préalable à partir de",
	    //OdometerLogTrail
	    LblOdometerLogTrail: "Historique du compteur kilométrique",
	    LblUserProvidedOdometerValueInKmr: "Kilométrage (en km)",
	    LblDescriptionOfDeviation: "Explication des écarts",
	    LblFromOdometer: "Compteur kilométrique de",
	    LblToOdometer: "Compteur kilométrique à",
	    LblAddDescriptionOfDeviation: "Ajouter une explication pour l'écart",
	    LblDeviation: "Écart (en km)",
	    LblLastOdometerValue: "Kilométrage précédent (en km)",
	    LblLastOdometerDT: "Date du compteur kilométrique précédent",
	    LblodometerConfiguration: "Paramètres du compteur kilométrique",
	    LblEnableOnApp: "Afficher dans l'appli",
	    LblWarningPer: "Avertissement (%)",
	    LblOdometerRegistered: "Kilométrage enregistré",
	    LbLOdometerEnabled: "Compteur kilométrique en marche",
	    LblOdometerValue: "Kilométrage",
	    LblMaintenancePlanningList: "Planification de l'entretien",
	    LblSearchMaintenancePlanningValue: "Recherche dans la planification de l'entretien",
	    LblMaintenancePlanningreport: "Rapport de planification de l'entretien",
	    LblShowDeviation: "Afficher l'écart sans explication",
	    LblTitle: "Titre",
	    LblFooterText: "Note de pas de page",
	    LblvalidEmailDomain: "Seules les adresses mail de ce domaine sont autorisées",
	    LblURLSettings: "Paramètres URL",
	    LblSuccessUrl: "Paramètres URL réussis",
	    LblEmailSettings: "Paramètres des courriels",
	    LblSendActivationEmail: "Envoyer des courriels d'activation automatique",
	    LblSendConfirmationEmail: "Envoyer des courriels de confirmation automatiques",
	    LblRequireAdminApprovel: "Autorisation obligatoire de l'administrateur pour une nouvelle inscription",
	    LblDriverInformationToBeInclude: "Informations sur le conducteur à ajouter",
	    LblSignUpForm: "Formulaire d'inscription",
	    LblSignupForms: "Formulaires d'inscription",
	    LblSignupFormsOverview: "Aperçu des formulaires d'inscription",
	    LblWhoCanApprove: "Qui peut autoriser les nouvelles inscriptions ?",
	    LblSignupFormLogo: "Logo formulaire d'inscription",
	    LblChooseSubscription: "Choisissez les abonnements figurant sur le formulaire d'inscription",
	    LblSignupParameter: "Page web formulaire d'inscription",
	    LblSignupParameterText: "Texte URL formulaire d'inscription",
	    DomainNameString: "Noms de domaine séparés par des virgules (tels que gmail.com,yahoo.com)",
	    SignupParameterString: "Seuls les lettres, les chiffres et les - sont autorisés",
	    LblAvailability: "Disponibilité",
	    LblSettings: "Paramètres",
	    LblCurrentStatus: "Statut actuel",
	    LblFlags: "Flags",
	    LblNA: "Non disponible",
	    //Sign up form
	    LblConfirmEmail: "Confirmer l'adresse mail",
	    LblSignup: "S'inscrire",
	    LblSignupsOverView: "Aperçu des inscriptions",
	    LblSignupApproval: "Autorisation inscriptions",
	    LblAccept: "Accepter",
	    LblSignupFormDescription: "Descriptif du formulaire d'inscription",
	    LblCurrentOdometerValue: "Kilométrage actuel",
	    LblCurrentOdometerDateTime: "Heure du kilométrage actuel",
	    LblCreateDirectDebitFile: "Créer un fichier de prélèvement automatique",
	    LblCheckEmptyIbanNumber: "Vérifier les numéros IBAN",
	    LblCreatedDate: "Date de création",
	    LblIncludeInDirectDebit: "Ajouter au fichier de prélèvement automatique",
	    LblDirectDebitFileDate: "Date fichier de prélèvement automatique",
	    LblDirectDebitConfiguration: "Configuration du prélèvement",
	    LbLDirectDebitEnabled: "Activer la fonctionnalité de prélèvement automatique",
	    LblDirectDebitEnableper: "Fonctionnalité de collecte activée à partir de",
	    LbLCreditorDetails: "Informations sur le créancier",
	    LblAddress: "Adresse",
	    LblIBANNumber: "IBAN",
	    LblCountryCode: "Code pays",
	    LbLBillingInformation: "Données de paiement",
	    LblInvoicingDetails: "Données de facturation",
	    LbLSubjectToDirectDebit: "Utiliser prélèvement automatique ?",
	    //Batch Upload Person
	    LblBatchUploadPersonSetting: "Paramétrages importation de personnes",
	    LblShowBatchUploadInfo: "Activer la fonctionnalité de saisie par lots pour des personnes ?",
	    LblAllowBatchUpload: "Rôle autorisé à importer",
	    LblAllowActivationMail: "Utiliser courriels d'activation",
	    LblGenerateRandomPassword: "Le système génère des mots de passe",
	    LblUserUploadPassword: "Mot de passe dans le fichier d'importation",
	    LblFieldToUploadedOrValidated: "Champs fournis",
	    LblBatchUploadPerson: "Importer des personnes",
	    LblBatchUpload: "Importer des personnes",
	    LblDownloadTemplate: "Exemple de fichier d'importation",
	    LblUserAssignSVGMessage: "L'utilisateur n'est pas encore assigné au groupe de pool !",
	    LblInvalidRecordReason: "Dossier(s) non valide(s)",
	    LblSelectedSVGs: "Groupe(s) de pool sélectionné(s)",
	    LblDashboardConfiguration: "Configuration du tableau de bord",
	    LblEnableCurrentLocation: "Activez l'option « Emplacement actuel »",
	    LblDefaultLocation: "Emplacement affiché par défaut",
	    LblEnableAutoUpdate: "Activer l'actualisation automatique",
	    LblPriorityNotificationSetting: "Paramètres de notification d'état du véhicule",
	    SelectionRequiredMsg: "Sélectionnez au moins une réservation à approuver / rejeter",
	    LblSelectionRequired: "Sélection requise",
	    LblCollectionDate: "Date du prélèvement automatique",
	    LblBICCode: "Code BIC",
	    LblDirectDebitFile: "Fichier de prélèvement automatique",
	    LblFormat: "Format",
	    LblMissingIBANNumber: "IBAN manquant",
	    LblImportDriverRole: "Attribuer automatiquement le rôle de conducteur ?",
	    LblAssignToSVG: "Affecter au(x) groupe(s) du pool",
	    LblSVG: "Groupe de pool",
	    LblMandateId: "Id. du mandat",
	    LblMandateSignatureDate: "Date de signature du mandat",
	    LblIsAmmandment: "Est une modification",
	    LblRemovePersonDetails: "Supprimer les données à caractère personnel",
	    LblDashboard: "Tableau de bord",
	    LblGroupAdmin: "Administrateur du groupe",
	    LblCurrentLocation: "Emplacement actuel",
	    LblCurrentDriver: "Conducteur actuel",
	    LblNextDriver: "Conducteur suivant",
	    LblSecond: "Seconde(s)",
	    LblCleaning: "Nettoyer",
	    LblRefueling: "Faire le plein / Recharger",
	    LblAPKMaintenance: "Entretien CT",
	    LblOutsideGeofence: "Géofence extérieure",
	    LblNotBooked: "Non réservé",
	    LblNotBookedSince: "Non réservé depuis",
	    LblLowBattery: "Tension de la batterie faible",
	    LblBatteryVolt: "V.",
	    LblLowCharge: "Batterie (presque) vide",
	    LblChargingPercentage: "%",
	    LblOnSamePosition: "Non déplacé",
	    LblLastPosition: "Dernier emplacement",
	    LblNotReturn: "Non retourné",
	    LblCommunicationProblem: "Problème de communication",
	    LblInuse: "En cours d'utilisation",
	    LblPriority: "Priorité",
	    LblDirectDebitDownloadSuccess: "Fichier de prélèvement automatique téléchargé",
	    LblDefaultStatus: "Statut par défaut",
	    LblWarnings: "Avertissements",
	    LblDirectDebitFileId: "Id du fichier de prélèvement automatique",
	    LblTotalAmount: "Montant total",
	    LblReCreate: "Télécharger à nouveau",
	    LblPleaseEnterCollectionDate: "Saisissez date de prélèvement automatique",
	    LblOpenViaLowLevel: "Low level déverrouillé",
	    LblInstanceNotificationNote1: "L'institution travaille comme une institution dans l'entreprise",
	    LblNoInvoiceSelected: "Aucune facture sélectionnée pour le prélèvement automatique",
	    LblIBANNumberRequired: "Saisissez l'IBAN et le code BIC",
	    LblNoEmptyIBANFound: "Aucun IBAN vide trouvé",
	    LblShowVehicleChargeLevel: "Afficher le niveau de charge du véhicule sur le eeb et l'application ?",
	    LblChargeLevel: "Niveau de charge",
	    LblCharging: "Recharger",
	    LblNoDataFound: "Aucune donnée disponible",
	    LblOfficeStartTime: "Heures d'ouverture du bureau (hh:mm)",
	    LblOfficeEndTime: "Heures de fermeture du bureau (hh:mm)",
	    //Reports
	    LblTripDataReport: "Aperçu des données des trajets",
	    LblByDriver: "Sur conducteur",
	    LblByVehicle: "Sur véhicule",
	    LblModuleRights: "Droits du module",
	    LblCostCenterReport: "Rapport sur les centres de coûts",
	    LblShowTotalOnly: "Afficher le total uniquement",
	    LblByOrganization: "Sur l'organisation",
	    //Organization
	    LblOrganization: "Organisation",
	    LblOrganizationName: "Nom de l'organisation",
	    LblOrganizationAddress: "Adresse de l'organisation",
	    LblExistingDriverAddSuccessMsg: "Le conducteur a été ajouté avec succès et rattaché à l'organisation",
	    LblAddDriverSuccessMsg: "Le conducteur a été ajouté et le lien d'activation lui a été envoyé avec succès.",
	    LblCreateOrganization: "Créer une organisation",
	    LblOrganizationDriversList: "Conducteur organisation",
	    LblAddDriverToOrganization: "Ajouter conducteur à organisation",
	    LblAddDriver: "Ajouter un conducteur",
	    LblVatNumber: "Numéro de TVA",
	    // Branding
	    LblBranding: "Image de marque",
	    LblLogo: "Logos",
	    LblEmailNotificationInvoiceTemplate: "Modèles de notification et de facture par mail",
	    LblExpandedWebMenu: "Menu web déplié",
	    LblCollapsedWebMenu: "Menu web plié",
	    LblMobileApp: "Application mobile",
	    LblSplashScreen: "Écran de démarrage",
	    LblWebApplication: "Application web",
	    LblMobileApplication: "Application mobile",
	    LblBrandingSavedSuccess: "Image de marque enregistrée",
	    LblBrandingTemplateConfiguration: "Configuration image de marque & modèle",
	    LblAppWebUI: "Application et interface utilisateur web",
	    LblNonBookingCommunication: "Communication générale",
	    LblApprovalAdminName: "Approbation de l'administrateur",
	    LblBookingCommunication: "Communication concernant la réservation",
	    LblInstanceBranding: "Utilisez toujours l'image de marque de l'instance",
	    LblCompanyBranding: "Utilisez l'image de marque de l'entreprise si possible",
	    BO_TOP_MENU_ACTIVE_ITEM_BACKGROUND: "Barre supérieure, menu et éléments actifs",
	    BO_TOP_MENU_ACTIVE_ITEM_TEXT: "Texte des menus",
	    BO_HIGHLIGHTED_BUTTON_BACKGROUND: "Bouton en surbrillance",
	    BO_HIGHLIGHTED_BUTTON_TEXT: "Texte du bouton en surbrillance",
	    BO_HIGHLIGHTED_BUTTON_BACKGROUND_HOVER: "Bouton en surbrillance (survol)",
	    BO_HIGHLIGHTED_BUTTON_TEXT_HOVER: "Texte du bouton en surbrillance (survol)",
	    BO_PRIMARY_BUTTON_BACKGROUND: "Bouton principal",
	    BO_PRIMARY_BUTTON_TEXT: "Texte du bouton principal",
	    BO_PRIMARY_BUTTON_BACKGROUND_HOVER: "Bouton principal (survol)",
	    BO_PRIMARY_BUTTON_TEXT_HOVER: "Texte du bouton principal (survol)",
	    BO_SECONDARY_BUTTON_BACKGROUND: "Bouton secondaire",
	    BO_SECONDARY_BUTTON_TEXT: "Texte du bouton secondaire",
	    BO_SECONDARY_BUTTON_BACKGROUND_HOVER: "Bouton secondaire (survol)",
	    BO_SECONDARY_BUTTON_TEXT_HOVER: "Texte du bouton secondaire (survol)",
	    BO_HYPERLINK_TEXT: "Texte du lien hypertexte",
	    BO_HIGHLIGHT_BACKGROUND: "Surligner la couleur",
	    BO_HIGHLIGHT_TEXT: "Surligner le texte",
	    BO_CALENDAR_EVENT_BACKGROUND: "Élément du calendrier",
	    BO_CALENDAR_EVENT_TEXT: "Texte de l'élément de calendrier",
	    MO_TOP_MENU_ACTIVE_ITEM_BACKGROUND: "Barre supérieure et menu",
	    MO_LOGO_AREA_BACKGROUND: "Arrière-plan logo",
	    MO_PAGE_BACKGROUND: "Arrière-plan",
	    MO_MENU_TEXT: "Texte des menus",
	    MO_TITLE_TEXT: "Texte du titre",
	    MO_HYPERLINK_TEXT: "Texte du lien hypertexte",
	    MO_ENABLED_BUTTON_BACKGROUND: "Bouton utilisable",
	    MO_ENABLED_BUTTON_TEXT: "Texte de bouton utilisable",
	    MO_ENABLED_BUTTON_BACKGROUND_ACTIVE: "Bouton utilisable (actif)",
	    MO_ENABLED_BUTTON_TEXT_ACTIVE: "Texte du bouton utilisable (actif)",
	    MO_DISABLED_BUTTON_BACKGROUND: "Bouton inutilisable",
	    MO_DISABLED_BUTTON_TEXT: "Texte du bouton inutilisable",
	    MO_DISABLED_BUTTON_BACKGROUND_ACTIVE: "Bouton inutilisable (actif)",
	    MO_DISABLED_BUTTON_TEXT_ACTIVE: "Texte du bouton inutilisable (actif)",
	    MO_HIGHLIGHT_BACKGROUND: "Couleur de surbrillance",
	    MO_HIGHLIGHT_TEXT: "Texte surligné",
	    MO_CALENDAR_EVENT_BACKGROUND: "Élément du calendrier",
	    MO_CALENDAR_EVENT_TEXT: "Texte de l'élément de calendrier",
	    LblBookingDelayConfig: "Configuration du délai de réservation",
	    LblBookingDelayConfigEnabled: "Envoyer un courriel à l'administrateur",
	    LblEnableSnauilTrail: "Activer Snail Trail",
	    LblAppSupportTo: "Utilisation appli",
	    LblNotificationInterval: "Intervalle de notification",
	    LblNotifyAfterMinutes: "Notification après X minutes",
	    LblMinutes: "Minutes",
	    lblNotificationRecipients: "Destinataires des notifications",
	    LbLEnableBookingStillRunning: "Activer la notification « Réservation non terminée »",
	    LblBookingrunningNotification: "Notification de configuration Réservation non terminée",
	    //Raise and clear settings for low battery flag
	    LblDefaultVehicleSetting: "Paramètre par défaut du véhicule",
	    LblLowBatteryFlagRaised: "Avertissement de batterie faible activé (tension)",
	    LblLowBatteryFlagClear: "Avertissement de batterie faible effacé à (tension)",
	    LblPreferableImageSize: "Taille d'image souhaitée",
	    LblWebBrandingExapandImageSize: "1150px X 260px",
	    LblMobileBrandingImageSize: "550px X 250px",
	    LblWebBrandingCollapseImageSize: "325px X 250px",
	    LblMinutesAfterBookingEndTime: "Combien de minutes après l'heure de fin de réservation ?",
	    LblResendNotoficationEvery: "Renvoyer la notification toutes les minutes",
	    LblByBooking: "Sur réservation",
	    LblSnailTrailReport: "Rapport Snail Trail",
	    LblKickbackReport: "Rapport Kickback",
	    LblGroupBy: "Grouper par",
	    LblTripDetail: "Détails du trajet",
	    LblTripNumber: "Numéro de trajet",
	    LblStart: "Début",
	    LblAverageSpeed: "Vitesse moyenne",
	    LblSegmentDetail: "Détail du segment",
	    LblSegmentNumber: "Numéro du segment",
	    LblSpeed: "Vitesse",
	    LblOdometer: "Compteur kilométrique",
	    LblNext: "Suivant",
	    LblSegmentDetailNotAvailable: "Détail du segment non disponible",
	    LblUnitPerKm: "par km",
	    LblUnitPerBooking: "par résa.",
	    LblBookingCostSummary: "Aperçu des coûts de réservation",
	    LblTimeCost: "Coûts de temps",
	    LblTotalTime: "Durée totale",
	    LblTime: "Temps",
	    LblCostRateUnits: "Coût (nombre * taux)",
	    LblFreeTime: "Temps supplémentaire gratuit",
	    LblRate: "Tarif",
	    LblExVat: "HT",
	    LblInclVat: "TTC",
	    LblKmDriven: "Kms effectués",
	    LblFreeKms: "Crédits offerts",
	    LblTimePercent: "Pourcentage de temps",
	    LblTotalExVat: "Total HT",
	    LblTotalVat: "Total TVA",
	    LblTotalInclVat: "Total TTC",
	    LblKilometerCost: "Frais kilométriques",
	    LblBookingApprovedSuccessMsg: "Les demandes de réservation sélectionnées ont été approuvées avec succès",
	    LblBookingRejectedSuccessMsg: "Les demandes de réservation sélectionnées ont été rejetées",
	    LblRejection: "Rejet",
	    LblrejectionReasonMsg: "Donnez un motif pour le rejet des demandes de réservation sélectionnées",
	    LblApproveConfirmationMsg: "Êtes-vous sûr de vouloir approuver toutes les demandes de réservation sélectionnées ?",
	    LblFixedCost: "Coûts fixes",
	    LblTotals: "Totaux",
	    LblTypeDamage: "Dommages",
	    LblTypeMaintenance: "Entretien CT prochainement",
	    LblTypeOnSamePosition: "Véhicule plus de %0 %1 au même endroit",
	    LblTypeNotBooked: "Véhicule plus de %0 %1 non réservé",
	    LblTypeNotReturn: "L'heure de fin de réservation est atteinte, le véhicule n'est pas au site d'origine",
	    LblBatteryVoltage: "Voltage de batterie",
	    LblApprovedRejectedby: "Approuvée / rejetée par",
	    LblBookingRequestList: "Liste des demandes de réservation",
	    LblCannotUnsubscribe: "Impossible de se désinscrire car le chauffeur a une réservation active",
	    LblPer: "Par",
	    LblDateRegistered: "Date d'inscription",
	    LblRegisteredBy: "Enregistré par",
	    LblKMPerHour: "Km/h",
	    LblMeters: "Mètres",
	    LblSubscriptionEndOnBookingEnd: "Réservation en cours. Cet abonnement sera résilié lorsque la réservation sera terminée.",
	    LblMarkedForDeletion: "Sélectionnée(s) pour être supprimée(s)",
	    LblApplyDateFilter: "Date de l'application",
	    LblNoRestriction: "AUCUNE_RESTRICTION",
	    LblCustomAppTestApp: "APPLICATION_ET_TEST_PERSONNALISÉS",
	    LblCustomAppOnly: "APPLICATION_PERSONNALISÉE_UNIQUEMENT",
	    //Customer
	    LblCustomer: "Client",
	    LblCustomerName: "Nom du client",
	    //Role Page
	    LblRoleManagement: "rôle",
	    LblRoleName: "Nom du rôle",
	    LblEntityName: "Nom de l'entité",
	    LblRoleType: "Type de rôle",
	    LblRoleAvailability: "Disponibilité du rôle client",
	    LblInternalRoleName: "Nom du rôle interne",
	    LblPresentationName: "Nom de la présentation",
	    LblDefaultRole: "Rôle standard",
	    LblCustomRole: "Rôle client",
	    LblAddRole: "Ajouter un rôle",
	    LblEntity: "Entité",
	    LblCopy: "Copier",
	    LblAccessibilityMatrix: "Matrice d'accès",
	    LblDefaultRoleModifyWarning: "La modification des droits par défaut affecte tous les utilisateurs ayant le rôle par défaut.",
	    LblCopyAccessibilityMatrix: "Copier la matrice d'accès",
	    LblAccess: "Accès",
	    LblCustomerAdmin: "Responsable Clientèle",
	    LblAdmin: "Beheerder",
	    LblDoYouWantToRemove: "Voulez-vous supprimer %0 en tant que %1 ?",
	    LblDoYouWantToAdd: "Voulez-vous ajouter %0 en tant que %1 ?",
	    LblRoleAddedSuccess: "%0 ajouté en tant que %1",
	    LblRoleDeletedSuccess: "%0 supprimé en tant que %1",
	    LblInstanceAdmin: "Gestionnaire d'instances",
	    LblInvitationMailSuccess: "Le mail d'invitation a été envoyé à l'adresse mail spécifiée.",
	    LblInvite: "Envoyer invitation",
	    LblCreateNew: "Nouvel élément",
	    LblCommonErrorMessage: "Une erreur s'est produite lors du traitement de la demande. Veuillez contacter l'administrateur.",
	    LblError: "Erreur",
	    LblThankYouForAcceptingInvitation: "Merci d'avoir accepté l'invitation",
	    LblPleaseClick: "Veuillez s'il vous plaît cliquer",
	    LblHere: "ici",
	    LblToLogin: "pour vous connecter",
	    LblThankYouForConfirmation: "Merci pour votre confirmation",
	    LblGoToHome: "Aller à la page d'accueil",
	    LblInvitationSuccess: "Invitation réussie",
	    LblInvitationReject: "Invitation refusée",
	    //
	    LblAssignExisting: "Attribuer droits existants",
	    LblPersonProfileSuccessMessage: "Votre profil a été activé avec succès",
	    LblPlease: "S'il vous plaît",
	    LblLogin: "Connexion",
	    //Branding & Template
	    LblBrandingandTemplates: "Image de marque et modèles",
	    LblTermsAndCondition: "Conditions générales",
	    LblTermsAndConditionList: "Liste des conditions générales et déclaration de confidentialité",
	    LblName: "Nom",
	    LblVersion: "Version",
	    LblActivityLog: "Journal de bord",
	    LblAcceptance1: "Avant l'activation du compte",
	    LblAcceptanceMoment: "Acceptatie moment",
	    LblContents: "Contenu",
	    LblIsAccept: "J'accepte",
	    LblReadAndAgree: "J'ai lu et j'accepte",
	    LblClose: "Fermer",
	    LblTermsConditionPrivacy: "Conditions générales et déclaration de confidentialité",
	    LblPrivacyStatements: "Déclarations de confidentialité",
	    //Pre Post Trip Setting
	    LblPrePostTripSetting: "Configuration des questions en début et fin de trajet",
	    LblPrePostTripQuestions: "Questions avant et après le voyage",
	    LblPrePostTripQuestion: "Questions avant et après le voyage",
	    LblPrePostTripQuestionList: "Questionnaire début et fin du trajet",
	    LblPreTripQuestion: "Questions au début du trajet",
	    LblCustom: "Modifiée",
	    LblPostTripQuestion: "Questions après le trajet",
	    LblRequired: "Obligatoire",
	    LblBeforeOpeningTheVehicle: "Avant l'ouverture du véhicule",
	    LblAfterOpeningTheVehicle: "Après l'ouverture du véhicule",
	    LblOrder: "Ordre",
	    LblQuestion: "Question",
	    LblOn: "Activée",
	    LblOptional: "Facultatif",
	    LblOff: "Désactivée",
	    LblAnswerType: "Type de réponse",
	    LblText: "Texte",
	    LblYesNo: "Oui / Non",
	    LblAnswer: "Réponse",
	    LblTimeStamp: "Heure",
	    LblFazTripQuestion: "FaZ Questions",
	    LblFazTripQuestionAfterClosingTheVehicle: "Questions FaZ après la fermeture du véhicule",
	    //Accessibility Matrix
	    LG_WEB_DASHBOARD: "Tableau de bord web",
	    PR_BOOKING_REQUEST: "Demande de réservation",
	    LblApproveBookingRequest: "Approuver",
	    LblRejectBookingRequest: "Rejeter",
	    PR_DASHBOARD: "Tableau de bord",
	    PR_REMOVE_DRIVER_LICENSE: "Supprimer le permis de conduire",
	    PR_VEHICLE_FUTURE_BOOKINGS: "Réservations futures du véhicule",
	    PR_INSTANCE: "Instance",
	    PR_BRANDING: "Image de marque",
	    PR_PERSON_OVERVIEW: "Aperçu des personnes",
	    PR_WEGO_ADMINS: "Admins WeGo",
	    PR_COMPANY_OVERVIEW: "Aperçu de l'entreprise",
	    PR_CONTACT_PERSON: "Personne de contact",
	    PR_COMPANY_ADMIN: "Administrateur d'entreprise",
	    PR_COMPANY_VEHICLE_OVERVIEW: "Aperçu des véhicules de l'entreprise",
	    PR_COMPANY_SVG_OVERVIEW: "Aperçu des groupes de pools de l'entreprise",
	    PR_ORGANIZATION_OVERVIEW: "Aperçu de l'organisation",
	    PR_ORGANIZATION_CONTACT_PERSON: "Personne de contact de l'organisation",
	    PR_ORGANIZATION_ADMIN_OVERVIEW: "Aperçu de l'administrateur de l'organisation",
	    PR_ORGANIZATION_DRIVER_OVERVIEW: "Aperçu des conducteurs de l'organisation",
	    PR_SHARED_VEHICLE_GROUP_OVERVIEW: "Aperçu des groupes de pools",
	    PR_SHARED_VEHICLE_GROUP_ADMIN_OVERVIEW: "Aperçu de l'administrateur des groupes de pools",
	    PR_SHARED_VEHICLE_GROUP_VEHICLE_OVERVIEW: "Aperçu des véhicules des groupes de pools",
	    PR_SHARED_VEHICLE_GROUP_DRIVER_OVERVIEW: "Aperçu des conducteurs des groupes de pools",
	    PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_GROUP_OVERVIEW: "Aperçu du groupe de type de contrat des groupes de pools",
	    PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_OVERVIEW: "Aperçu du type de contrat des groupes de pools",
	    PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW: "Aperçu des abonnements de groupes de pools",
	    PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_AVAILIBILTY_RESTRICTION_OVERVIEW: "Aperçu des disponibilités des abonnements de groupes de pools",
	    PR_SPECIAL_PERIODS: "Périodes particulières",
	    PR_VEHICLES_OVERVIEW: "Aperçu des véhicules",
	    PR_VEHICLE_SVG_OVERVIEW: "Aperçu des groupes de pools de véhicules",
	    PR_VTS_VEHICLE_LIST: "VTS Vehicle List",
	    PR_VTS_TROUBLESHOOT: "VTS Troubleshoot",
	    PR_VEHICLE_ATTRIBUTE_CATEGORIES: "Catégories de caractéristiques des véhicules",
	    PR_VEHICLE_ATTRIBUTE: "Caractéristiques des véhicules",
	    PR_ODOMETER_LOG_TRAIL: "Journal de bord du compteur kilométrique",
	    PR_ODOMETER_LOG_TRAIL_REGISTERED_BY: "Journal de bord du compteur kilométrique Enregistré par",
	    PR_DRIVER_OVERVIEW: "Aperçu du conducteur",
	    PR_DRIVER_SHARED_VEHICLE_GROUP_OVERVIEW: "Aperçu des conducteurs du groupe de pools",
	    PR_DRIVER_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW: "Overzicht van de abonnementen voor de conducteurs de groupes de pools",
	    PR_BOOKINGS_OVERVIEW: "Aperçu des réservations",
	    PR_NORMAL_BOOKING: "Nouvelle réservation",
	    PR_SPECIAL_BOOKING: "Réservation particulière",
	    PR_TRIP_SIMULATOR: "Simulateur de trajet",
	    PR_INVOICE: "Facture",
	    PR_DIRECT_DEBIT_FILE: "Fichier de prélèvement automatique",
	    PR_ADDITIONAL_FREE_ITEMS: "Éléments supplémentaires gratuits",
	    PR_TEST_INVOICE_GENERATOR: "Générateur de facture test",
	    PR_VEHICLE_OCCUPANCY_REPORT: "Rapport d'occupation du véhicule",
	    PR_REVENUE_PER_VEHICLE_REPORT: "Rapport de revenus par véhicule",
	    PR_TRIP_DATA_REPORT: "Rapport de données de trajet",
	    PR_MAINTENANCE_PLANNING_REPORT: "Rapport de planification de l'entretien",
	    PR_SANIL_TRAIL_REPORT: "Rapport Snail Trail",
	    PR_KICKBACK_REPORT: "Rapport Kickback",
	    PR_INVOICE_PAYMENT_HISTORY: "Historique de paiement des factures",
	    PR_TEMPLATES: "Modèles",
	    PR_SIGNUP_FORMS_OVERVIEW: "Aperçu des formulaires d'inscription",
	    PR_SIGNUPS_OVERVIEW: "Aperçu des inscriptions",
	    PR_SIGNUP_OVERVIEW_TO_SIGNUP_FORM: "Aperçu des inscriptions pour le formulaire d'inscription",
	    PR_SIGNUP_OVERVIEW_TO_SHARED_VEHICLE_GROUP: "Aperçu des inscriptions au groupe de pool",
	    PR_EVENT_VIEWER: "Aperçu des événements",
	    PR_USER_PROFILE: "Profil de l'utilisateur",
	    PR_PRE_POST_TRIP_SETTING: "Paramètres questions de début et de fin de trajet",
	    PR_PRE_POST_TRIP_QUESTIONS: "Aperçu des questions de début et de fin de trajet",
	    PR_TERMS_AND_CONDITION: "Règles et conditions",
	    PR_PREPOST_TRIP_QUESTIONS_UPDATE: "Questions de début et de fin de trajet",
	    LG_CUSTOMER: "Client",
	    LG_INSTANCE: "Instance",
	    LG_BRANDING: "Image de marque",
	    LG_PERSON: "Personne",
	    LG_COMPANY: "Société",
	    LG_ORGANIZATION: "Organisation",
	    LG_SHARED_VEHICLE_GROUP: "Groupe de véhicules partagés",
	    LG_VEHICLE: "Véhicule",
	    LG_DRIVER: "Conducteur",
	    LG_BOOKING: "Réservation",
	    LG_INVOICE: "Facture",
	    LG_REPORT: "Rapport",
	    LG_TEMPLATE: "Modèle",
	    LG_SIGNUP_FORM: "Formulaire d'inscription",
	    LG_EVENT_VIEWER: "Observateur d'événements",
	    LG_PRE_POST_TRIP_SETTING: "Paramètres questions de début et de fin de trajet",
	    LG_USER: "Utilisateur",
	    LG_BRANDING_AND_TEMPLATE: "Image de marque & modèles",
	    LG_PREPOSTTRIPQUESTION: "Questions de début et de fin de trajet",
	    PR_RESET_ADMIN_COOKIES: "Supprimer les cookies admin",
	    PR_RESET_ADMIN_TWOFA: "Supprimer les cookies d'authentification à deux facteurs",
	    LG_REPORTINGTOOL: "Application de reporting",
	    PR_BOOKING_OVERVIEW: "Aperçu de la réservation",
	    PR_ROB_NOTIFICATIONS: "Aperçu du ROB",
	    PR_MILEAGE_OVERVIEW: "Aperçu du kilométrage",
	    PR_USAGE_OVERVIEW: "Nombre de jours non utilisés",
	    PR_POSITION_ON_MAP: "Position sur la carte",
	    PR_VEHICLE_ON_LOCATION_MAP: "Véhicule sur site",
	    PR_TRIP_OVERVIEW: "Enregistrement des trajets",
	    PR_ALTERNATE_TRANSPORTATION: "Véhicule de remplacement",
	    PR_AVERAGE_OVERVIEW: "Aperçu des moyennes",
	    PR_PRE_POST_BOOKING_OVERVIEW: "Questions avant/après par aperçu de réservation",
	    PR_HOME_LOCATIONS_OVERVIEW: "Vue d'ensemble des emplacements d'accueil des véhicules et des SVG",
	    //Vat Setting
	    LblVatSettings: "Paramètres de TVA",
	    LblVatPercentages: "Pourcentages de TVA",
	    LblDefaultCost: "Afficher et modifier les coûts standard",
	    LblExcludingVat: "HT",
	    LblIncludingVat: "TTC",
	    LblVatEnterDescription: "Saisir description",
	    LblEnterVatPercentage: "Saisir % TVA",
	    LblVatPercentageError: "Veuillez saisir un pourcentage valide",
	    LblVatDescriptionError: "Veuillez saisir une description valide",
	    LblStartDate: "Date de début",
	    LblVatEndDate: "Date de fin",
	    LblVatDeleteConfirmation: "Êtes-vous sûr de vouloir fixer la date de fin de la TVA ?",
	    LblVatEndDateError: "Veuillez indiquer la date de fin de la TVA",
	    LblVatEndDateNote: "Note : les données seront exclues à partir de la date sélectionnée.",
	    LblVatStartDate: "Date de début",
	    LblVatStartDateError: "Veuillez sélectionner la date de début",
	    //Accessibility Matrix
	    LG_ROLE: "Rôle",
	    PR_CUSTOMER_ADMIN_OVERVIEW: "Aperçu admin clients",
	    PR_INSTANCE_ADMIN_OVERVIEW: "Aperçu administrateur instance",
	    PR_ROLE_OVERVIEW: "Rôle",
	    PR_ROLE_ASSIGN: "Attribuer un rôle",
	    PR_SHARED_VEHICLE_GROUP_ACTIVE_INACTIVE: "Groupe de pool actif ou inactif",
	    PR_CUSTOMER_OVERVIEW: "Client",
	    PR_ORGANIZATION_SUBSCRIPTION_OVERVIEW: "Aperçu de l'abonnement de l'organisation",
	    PR_VTS_VEHICLE_EVENT_HISTORY: "Historique des événements du véhicule VTS",
	    PR_BATCH_UPLOAD_PERSON: "Téléchargement par lots de personnes",
	    PR_IMPORT_PERSON: "Importer la personne",
	    PR_PRE_POST_TRIP_QUESTION_UPDATE: "Questions de début et de fin de trajet",
	    LblPrivacyErrorMessage: "Vous n'êtes pas autorisé à consulter cette page",
	    LblPrivacyNavigate: "Veuillez naviguer vers",
	    LblPrivacyError: "Erreur de confidentialité",
	    LblLinkExpired: "Lien expiré",
	    LblLinkExpiredMessage: "Le lien a expiré et ne peut plus être utilisé. Veuillez réessayer.",
	    LblBearer: "Centre de coûts",
	    LblWhoBenifitFreeItem: "À qui profitent les crédits d’abonnement?",
	    LblNoDistinction: "Par défaut (aucune distinction)",
	    LblPenaltyVat: "TVA pénalité",
	    LblTimeRateVat: "TVA taux horaire",
	    LblMileageRateVat: "TVA prix kilométrique",
	    LblFixedFeeVat: "TVA sur les coûts fixes",
	    LblSendInvoiceToOrganization: "Envoyer la facture à l'organisation",
	    LblExpenseAmountVat: "TVA dépenses",
	    LblDefaultVatContractTypeGroupCost: "TVA% pour les coûts du groupe de type de contrat",
	    LblDefaultVatContractTypeCost: "TVA% pour les coûts du groupe",
	    LblDefaultVatSubscriptionCost: "TVA % pour les frais d'abonnement",
	    LblPenaltyCost: "Frais de pénalité",
	    LblTimeRates: "Tarifs horaires",
	    LblDistanceRates: "Tarifs distance",
	    LblFixedRates: "Tarifs fixes",
	    LblSubscriptionCost: "Frais d'abonnement",
	    // template
	    LblEmailTemplate: "Modèle mail",
	    LblWebTemplate: "Modèle web",
	    LblEmailAddressesEntryPattern: "Adresses mail séparées par des virgules (comme ex1@ex.com, ex2@ex.com)",
	    LblNoRecipientWarning: "Aucun destinataire applicable. Les destinataires par défaut seront les destinataires de ce modèle.",
	    //MobileApp Configuration
	    LblMobileAppConfiguration: "Configuration de l'application mobile",
	    LblEnableNewBooking: "Activer nouvelle réservation",
	    LblEnableBookingCalender: "Activer le calendrier de réservation",
	    LblEnableSubscription: "Activer abonnement",
	    LblEnableUpdateProfile: "Activer « Mettre à jour le profil »",
	    LblEnableNotification: "Activer les notifications",
	    LblEnableChangeBooking: "Activer « Modifier la réservation »",
	    LblEnableAddExpenseMenu: "Activer le menu « Ajouter des dépenses »",
	    LblChamberOfCommerce: "Chambre de commerce",
	    LblInvoicingSettings: "Paramètres de facturation",
	    LblInvoiceSender: "Expéditeur de la facture",
	    LblCostAndExpenses: "Coûts et dépenses",
	    LblSender: "Expéditeur",
	    LblAddressee: "Destinataire",
	    LblAddLine: "Ajouter une ligne",
	    LblSaveInvoice: "Enregistrer la facture",
	    LblVatAmount: "Montant de la TVA",
	    LblBookingId: "ID de la réservation",
	    LblReceiptOrSuppor: "Bon ou soutien",
	    LblVATPercentage: "TVA (%)",
	    LblChargeTo: "Facturer",
	    LblReimburseTo: "Rembourser à",
	    LblReportedBy: "Signalé par",
	    LblReportedAmount: "Quantité déclarée",
	    LblApprovedAmount: "Montant autorisé",
	    LblCostType: "Type de coût",
	    LblRecipient: "Destinataire",
	    LblCostDetail: "Détail des coûts",
	    LblAddExisting: "Ajouter frais mentionnés précédemment",
	    LblReceiptOrSupport: "Bon ou soutien",
	    LblManualInvoiceLine: "Ligne de facture manuelle",
	    LblInvoiceLine: "Ligne de facture",
	    LblInvoice: "Facture",
	    LblInvoiceLines: "Lignes de facture",
	    LblSendInvoice: "Envoyer la facture",
	    LblInvoiceSent: "Facture envoyée",
	    LblAddNewInvoiceLine: "Ajouter une nouvelle ligne de facture",
	    LblSelectUnprocessedExpenses: "Sélectionnez une dépense non traitée",
	    LblSelectAtLeastOneExpense: "Sélectionnez au moins une dépense",
	    LblInvoicePaymentHistory: "Historique des paiements des factures",
	    LblPaymentMode: "Méthode de paiement",
	    LblLogTime: "Temps de connexion",
	    PR_COST_EXPENSES: "Coûts et dépenses",
	    PR_COST_CENTER_REPORT: "Rapport sur les centres de coûts",
	    LblInactiveAfterDays: "Inactif après (jours)",
	    LblMarkDeleteAfterDays: "Marquer Supprimer après (jours)",
	    LblNotifyAdminBeforeDays: "Informer l'administrateur X jours auparavant",
	    LblGdprSettings: "Paramètres GDPR",
	    LblRemovalDate: "Date de suppression",
	    LblRemovePersonOn: "Supprimer la personne le",
	    LblNoPaymentLinkGenerated: "Aucun lien de paiement généré",
	    //Payment Module
	    LblPaymentConfig: "Configuration des paiements",
	    LblPaymentConfigButton: "Configuration des paiements",
	    LblPaymentProvider: "Prestataire de services de paiement",
	    LblCountry: "Pays",
	    LblEmailAddress: "Adresse mail",
	    LblAllowPaymentConfiguration: "Autoriser la configuration des paiements",
	    LblAllowPayment: "Autoriser le paiement",
	    LblPaymentSetting: "Paramètres du prestataire de services de paiement",
	    LblEnvironment: "Environnement",
	    LblInvoicePaymentTermDays: "Délai de paiement de la facture (jours)",
	    LblLinkValidityDays: "Période de validité du lien (jours)",
	    LblReportedOn: "Signalé le",
	    LblPaymentMethods: "Méthodes de paiement",
	    LblPaymentProviderSecretKey: "Clé secrète PSP",
	    LblPaymentProviderUsername: "Nom d'utilisateur PSP (clé)",
	    LblCreditCardPayment: "Paiement par carte de crédit",
	    LblInitialPayment: "Acompte",
	    LblCreateBookingPayment: "Créer un paiement de réservation",
	    LblStartBookingPayment: "Commencer à réserver Paiement",
	    LblPaymentLink: "Lien pour le paiement",
	    LblPaymentHistory: "Historique des paiements",
	    LblReasonOrganization: "Motif du blocage de l'organisation",
	    LblDueDateUpdateSuccess: "Date d'expiration mise à jour avec succès",
	    LblDueDateRequiredError: "Sélectionnez la date d'expiration.",
	    LblDueDate: "Date d'expiration",
	    LblConfirmDuedatechange: "Êtes-vous sûr de vouloir mettre à jour la date d'expiration ?",
	    LblConfirmCloseInvoice: "Êtes-vous sûr de vouloir fermer la facture ?",
	    LblConfirmReOpenInvoice: "Êtes-vous sûr de vouloir rouvrir la facture ?",
	    LblInvoiceOpenCloseSuccess: "%0 de la facture avec succès",
	    LblReOpen: "Rouvrir",
	    LblClosed: "Clôturée",
	    LblReOpenClose: "Ouvrir / fermer à nouveau",
	    PR_PAYMENT_HISTORY_LIST: "Historique des paiements",
	    LblUserBlockMessage: "Motif de suspension de l'utilisateur",
	    PR_BLOCK_UNBLOCK_ORGANIZATION: "Bloquer / débloquer l'organisation",
	    LblWhenOpeningAppAndRepeat: "Lorsque vous ouvrez l'application pour la première fois et répétez chaque ",
	    LblEveryTimeOpenApp: "Chaque fois que l'on ouvre l'application",
	    LblWhenMakeBooking: "Lors de la création d'une réservation",
	    LblWhenStartBooking: "Lors du commencement d'une réservation",
	    LblWhenOpenBooking: "Lors de l'ouverture d'un véhicule",
	    LblSelectContractTypeGroup: "Lors du choix d'un ou de plusieurs groupes spécifiques de types de contrats ",
	    LblDays: "Jours",
	    LblNewVersion: "Nouvelle version",
	    LblAction: "Action",
	    LblTAndCName: "Nom CG",
	    LblOldVersion: "Ancienne version",
	    LblSureToRevoke: "Êtes-vous sûr de vouloir annuler %0 ?",
	    LblCurrencyConfiguration: "Configuration de la devise",
	    LblNameSingular: "Nom singulier",
	    //Special Period
	    LblRegularBooking: "Réservation normale",
	    LblSpecialRate: "Tarif spécial",
	    LblFirstDay: "Premier jour",
	    LblLastDay: "Dernier jour",
	    LblWeekEndContaining: "Week-end avec",
	    LblNamePlural: "Nom pluriel",
	    LblSignBeforeAmount: "Symbole de devise avant le montant",
	    LblOutOf: "hors",
	    //Credit card payment
	    LblCrediCardPayment: "Paiement par carte de crédit",
	    LblFirstBooking: "Première réservation",
	    LblAllowRecurringPayment: "Autoriser la carte de crédit",
	    LblProceed: "Continuer",
	    LblCheckAllowPayment: "Vérifiez s'il est possible d'effectuer un versement périodique",
	    LblPaymentFailed: "Autoriser la carte de crédit",
	    LblPaymentSuccess: "Autorisation accordée",
	    LblPaymentFailure: "Erreur d'autorisation",
	    LblCompletedSuccess: "Votre autorisation a été traitée avec succès",
	    LblCompletedFailure: "Votre autorisation a échoué. Veuillez revenir en arrière et réessayer.",
	    LblCreditCardNumber: "Numéro de carte de crédit",
	    LblCreditCardExpirationDate: "Date d'expiration Carte de crédit",
	    LblCreditCardDetails: "Détails Carte de crédit",
	    LblMakePayment: "Autoriser la carte de crédit",
	    LblAdminPaymentConfirmation: "Il n'y a pas d'autorisation active ou un paiement a échoué. Souhaitez-vous continuer ?",
	    LblPaymentDescription: "Pour réserver un véhicule, un paiement de vérification de 0 % est requis. En outre, une autorisation est nécessaire pour déduire les paiements futurs de votre carte de crédit. Les paiements sont traités par notre prestataire de paiement Buckaroo. Vous serez dirigé vers le site web de Buckaroo pour le paiement effectif. ",
	    LblPay: "Payer",
	    // NIF Number
	    LblEnableNIFNumber: "Activer numéro NIF",
	    LblNIFNumber: "Numéro NIF",
	    LblWeGoDefault: "WeGo Standard",
	    LblPersonActiveSuccess: "Personne activée avec succès",
	    LblActivate: "Activer",
	    LblInActiveReason: "Motif d'inactivité",
	    LblDefaultLanguage: "Langue standard",
	    LblRestoreInheritConfirmation: "Les paramètres actuels seront remplacés par les paramètres adoptés. Êtes-vous sûr de vouloir procéder ?",
	    LblQestionTextRequired: "Texte avec question obligatoire",
	    LblManualSecretKey: "Clé confidentielle",
	    // Two Factor Authentication
	    LblTwoFaConfig: "Authentification à deux facteurs",
	    LblEnableTwoFa: "Activez l'authentification à deux facteurs",
	    LblExpirationDays: "Dates d'expiration",
	    LblTextBoxExpirationDays: "Dates d'expiration",
	    Lbl2FactorAuthenticateExpDays: "Durée d'expiration du 2FA (jours) :",
	    LblResetCookiesWegoAdmin: "Réinitialiser les cookies pour tous les administrateurs de WeGo",
	    LblReset2FactorAuthWegoAdmin: "Réinitialiser le 2FA pour tous les administrateurs de WeGo",
	    LblAuthentication: "Authentification",
	    LblResetCookiesForAllAdmin: "Réinitialiser les cookies pour tous les administrateurs",
	    LblReset2FaForAllAdmin: "Réinitialiser le 2FA pour tous les administrateurs",
	    LblEnterTotp: "Veuillez saisir le code",
	    LblEnterOtp: "Veuillez saisir le code",
	    LblSubmit: "Envoyer",
	    LblKeyResetSuccess: "La clé 2FA a été réinitialisée",
	    LblKeyResetFailed: "Échec de la réinitialisation de la clé 2FA",
	    LblCookieResetSuccess: "Les cookies 2FA ont été réinitialisés",
	    LblCookieResetFailed: "Échec de la réinitialisation des cookies 2FA",
	    LblGoogleAuthenticator: "Application Google Authenticator",
	    LblEmailOtpSent: "Un code a été envoyé à votre adresse mail enregistrée",
	    LblContinue: "Continuer",
	    LblInvalidTOTP: "Ongeldige code",
	    LblResetCookie: "Réinitialiser le cookie",
	    LblResetTwoFA: "Réinitialiser le 2FA",
	    LblDisableTwoFA: "Schakel 2FA uit",
	    LblTwoFaMethod: "2FA methode",
	    LblEmailAuthentication: "Authentification par mail",
	    LblTwoFaMethodSelect: "Vous devez vérifier votre identité une fois de plus. Veuillez sélectionner votre méthode 2FA",
	    LblMissingInvoiceGenerator: "Générateur de factures manquantes",
	    LblInvoicePreFix: "Préfixe de numéro de facture",
	    LblEngineStillRunning: "Commande de verrouillage envoyée alorsque le moteur tourne",
	    LblMobileAppLink: "Lien vers l'application mobile",
	    // License Check Configuration
	    LblLicenseCheckConfiguration: "Configuration de la vérification du permis de conduire",
	    LblValidateLicenseCheckForBooking: "Contrôler avant réservation",
	    // Access Cards Enabled SVG
	    LblAccessCardsEnabled: "Utilisation de la carte d'accès",
	    // Track & Trace
	    LblTrackAndTrace: "Track & Trace",
	    LblRfidTagId: "RFID Tag ID",
	    LblEmployeeNumber: "Numéro d'employé",
	    // Access Card
	    LblAccessCardId: "Access Card ID",
	    LblDriversLicenseAndCertificates: "Certificats et permis de conduire du conducteur",
	    LblLicense: "Permis de conduire du conducteur",
	    LblCertificates: "Certificats",
	    LblTrips: "Voyages",
	    LblCostsSummary: "Résumé des coûts",
	    LblStartBooking: "Commencer à réserver",
	    LblStopBooking: "Arrêter la réservation",
	    LblTripHistory: "Historique de trajet",
	    LblTripStartDateTime: "À partir",
	    LblTripEndDateTime: "À",
	    LblFaZTripQuestions: "Questions FaZ",
	    LblNoQuestionsFound: "Aucune question FaZ trouvée.",
	    LblNoTripsFound: "Aucun trajet trouvé.",
	    LblUnansweredQuestions: "Questions sans réponse",
	    LblTripDetails: "Détails du trajet",
	    LblNoUnansweredQuestions: "Aucune question sans réponse",
	    LblAnswerSaved: "La réponse est enregistrée avec succès",
	    LblAnswerSavedError: "La réponse n'a pas pu être enregistrée. Veuillez contacter l'administrateur",
	    LblAnswerEmptyError: "Veuillez entrer une réponse valide",
	    BtnAddVehicleInfo: "Afficher le journal vts",
	    LblLoginError: "Une erreur inconnue s'est produite lors de la connexion",
	    LblLoginCredentialsError: "Ce nom d'utilisateur ou mot de passe est incorrect, veuillez vérifier et réessayer",
	    LblInfo: "Informations",
	    ValidatePhoneNumberVts: "Veuillez saisir un numéro de téléphone valide (par exemple, +31623456789)",
	};


/***/ },
/* 78 */
/***/ function(module, exports) {

	// https://scotch.io/tutorials/simple-language-translation-in-angular-2-part-2
	"use strict";
	// lang-en.ts
	// 'hello world': 'hello world',
	// 'hello greet': 'Hello, %0 %1!',
	// 'well done': 'Well done %0',
	// 'good bye': 'bye bye',
	exports.LANG_PL_NAME = "pl";
	exports.LANG_PL_TRANS = {
	    LblWeekdays: {
	        shorthand: ["Nd", "Pn", "Wt", "Śr", "Cz", "Pt", "So"],
	        longhand: [
	            "Niedziela",
	            "poniedziałek",
	            "wtorek",
	            "środa",
	            "czwartek",
	            "piątek",
	            "sobota"
	        ]
	    },
	    LblMonths: {
	        shorthand: [
	            "Sty",
	            "Lut",
	            "Mar",
	            "Kwi",
	            "Maj",
	            "Cze",
	            "Lip",
	            "Sie",
	            "Wrz",
	            "Paź",
	            "Lis",
	            "Gru"
	        ],
	        longhand: [
	            "Styczeń",
	            "Luty",
	            "Marzec",
	            "Kwiecień",
	            "Maj",
	            "Czerwiec",
	            "Lipiec",
	            "Sierpień",
	            "Wrzesień",
	            "Październik",
	            "Listopad",
	            "Grudzień"
	        ]
	    },
	    LblButtonText: {
	        today: "Dzisiaj",
	        month: "Miesiąc",
	        week: "Tydzień",
	        day: "Dzień",
	        list: "Lista"
	    },
	    // Common Name
	    LblActivityLog: "Dziennik aktywności",
	    LblEdit: "Edytuj",
	    LblDelete: "Usuń",
	    LblRemove: "Usuń",
	    LblActiveInactive: "Aktywny/nieaktywny",
	    LblActive: "Aktywny",
	    LblInactive: "Dezaktywuj",
	    LblInactiveReason: "Nieaktywny Powód",
	    LblAddNew: "Dodaj nowy",
	    LblAdd: "Dodaj",
	    LblUpdate: "Aktualizuj",
	    LblSave: "Zapisz",
	    LblCancel: "Anuluj",
	    LblReset: "Resetuj",
	    LblSelect: "Wybierz",
	    LblSuccess: "Sukces",
	    LblWarning: "Ostrzeżenie",
	    LblList: "Lista",
	    LblAssign: "Przypisz",
	    LblHome: "Strona główna",
	    LblYes: "Tak",
	    LblOK: "Ok",
	    LblNo: "Nie",
	    LblBack: "Powrót",
	    LblReason: "Powód",
	    LblRecordSavedSuccess: "Rejestr zapisany pomyślnie",
	    LblRecordDeleteSuccess: "Rejestr usunięty pomyślnie",
	    LblResetPasswordSuccess: "Hasło zresetowane pomyślnie",
	    LblConfirm: "Potwierdź",
	    LblBlockUnblockConfirm: "Czy na pewno chcesz %0 %1 ?",
	    LblRecordDeleteConfirmation: "Czy na pewno chcesz usunąć %0 ?",
	    LblRecordMultiplDeleteConfirmation: "Czy na pewno chcesz usunąć wybrane %0 ?",
	    LblConfirmMessage: "Czy jesteś pewien?",
	    LblResetPassword: "Zresetuj hasło",
	    LblResetPasswordConfirmation: "Czy na pewno chcesz zresetować hasło?",
	    LblGeoLocationError: "Wprowadź poprawną lokalizację geograficzną",
	    LblPersonDeleteCheck: "Usuń na stałe",
	    LblBookingCancelSuccess: "Rezerwacje anulowane pomyślnie",
	    LblBookingAbortSuccess: "Rezerwacja przerwana pomyślnie",
	    LblBookingRevokeSuccess: "Rezerwacja unieważniona pomyślnie",
	    LblContactPersonRemoveSuccess: "Osoba kontaktowa została usunięta",
	    LblContactPersonAddedSuccess: "Dodano osobę kontaktową",
	    LblNoRecords: "Brak dostępnego zapisu",
	    LblAffectedBookingList: "Wadliwa lista rezerwacji",
	    LblSubscriptionEndDateError: "Wpisz datę zakończenia subskrypcji",
	    LblIsSpecialPeriodAllow: "WCzy chcesz zastosować specjalny okres rozliczeniowy? Jeśli jest on dostępny",
	    LblContractSlotisnotdefined: "Typ umowy dla podanego poniżej przedziału czasowego nie jest zdefiniowany.",
	    LblUnscubscribeSuccess: "Anulowanie subskrypcji zakończone sukcesem",
	    LblModifiedBy: "Zmodyfikowano przez",
	    LblModifiedDate: "Zmienione dane",
	    LblContractTypeGroupAvailableForSubscription: "Brak dostępnej grupy typów umów, aby dodać nowy %0.",
	    LblRemoveContactPersonConfirm: "Czy na pewno chcesz usunąć osobę wyznaczoną do kontaktu?",
	    LblBookingApproveRejectSuccess: "%0 %1 pomyślnie",
	    LblRecordAddedSuccess: "%0 dodano pomyślnie.",
	    LblRecordUpdatedSuccess: "%0 zaktualizowano pomyślnie.",
	    LblRecordRemovedSuccess: "%0 usunięto pomyślnie",
	    LblRecordActiveInActiveSuccess: "%0 %1 pomyślnie.",
	    LblinvoiceResendSuccess: "%0 wysłano ponownie",
	    LblRecordBlokUnBlockSuccess: "%0 %1 pomyślnie.",
	    LblEditPage: "Edytuj %0",
	    LblAddPage: "Dodaj %0",
	    LblListPage: "%0 Lista",
	    LblKilometers: "Kilometr",
	    LblKM: "Km",
	    LblDeletePersonNote: "Faktury oczekujące na realizację dla tej osoby nie będą wysyłane",
	    LblFileNotFound: "Plik nie istnieje, skontaktuj się z działem pomocy technicznej",
	    //'LblRecordUnBlockedSuccess':'%0 unBlocked successfully',
	    //Instance Clone
	    'LblInstanceClone': 'Sklonuj platformę',
	    'LblNewInstanceName': 'Nazwa nowej platformy',
	    'LblCloneResult': 'Wynik klonowania',
	    'LblCloneStatus': 'Status klonowania',
	    'CloneError': 'Wystąpił błąd podczas klonowania przypadku i odpowiadających mu jednostek.',
	    //Instance Page
	    LblCarwiseEnable: "Odblokowano Carwise",
	    LblAdminDependencyValidationOnDelete: "Wybrany Administrator nie może zostać usunięty, ponieważ jest powiązany z innym podmiotem.",
	    LblAdminDependencyValidation: "Funkcja administratora nie może zostać usunięta, ponieważ jest powiązana z innym podmiotem.",
	    LblAdminDependencyAlert: "Alert zależności od administratora",
	    LblCarwiseConfiguration: "Konfiguracja Carwise",
	    LblCarwiseConnectionUrl: "Url połączenia",
	    LblCarwiseConnectionUsername: "Nazwa użytkownika połączenia",
	    LblCarwiseConnectionPassword: "Hasło połączenia",
	    LblCarwiseAutoDeleteFrequencyInDays: "Częstotliwość automatycznego usuwania (w dniach)",
	    LblDamageImageExtentions: "Rozszerzenia zdjęć uszkodzeń",
	    LblInstance: "Platforma",
	    LblWegoAdminDependencyValidation: "Admin WeGo nie może zostać usunięty, ponieważ jest powiązany z innym podmiotem",
	    LblInstanceName: "Nazwa platformy",
	    LblInstanceType: "Typ platformy",
	    LblDescription: "Opis",
	    LblCurrencySymbol: "Symbol waluty",
	    LblPreferredLanguage: "Język",
	    LblTimeZone: "Strefa czasowa",
	    LblCurrencyAbbreviation: "Skrót waluty",
	    LblInstanceDeleteValidation: "Nie można usunąć platformy z powodu powiązania z innym podmiotem",
	    LblIsBookingApprovalReq: "Wymagane zatwierdzenie rezerwacji",
	    LblInstanceConfiguration: "Konfiguracja platformy",
	    LblBookingAlertTime: "Czas powiadomienia o rezerwacji",
	    LblBookingCancelTime: "Czas anulowania rezerwacji",
	    LblBookingTemporaryTime: "Czas rezerwacji tymczasowej",
	    LblVtsRequestTimeout: "Timeout wniosku VTS",
	    LblVtsTripLogTimeout: "Timeout VTS danych podróży",
	    LblEmailConfiguration: "Konfiguracja poczty elektronicznej (SMTP)",
	    LblInSeconds: "W sekundach",
	    LblFromEmail: "Z poczty elektronicznej",
	    LblHost: "Host",
	    LblPort: "Port",
	    LblEnableSsl: "Włącz SSL",
	    LblSmtpEmail: "Poczta elektroniczna SMTP",
	    LblBookingCancelTimeMessage: "Określa czas (w sekundach), po którym anulowanie rezerwacji nie będzie możliwe",
	    LblBookingTemporaryTimeMessage: "Czas dla rezerwacji tymczasowej. Gdy użytkownik wybrał pojazd do rezerwacji, ale nie został jeszcze zatwierdzony.",
	    LblVtSRequestTimeoutMessage: "Dostępny czas dla polecenia Zablokuj/Odblokuj w aplikacji mobilnej.",
	    LblVtsTriplogTimeoutMessage: "Czas dla obliczenia podróży po wybraniu polecenia Blokuj.",
	    LblContractTypeDeleteValidation: "Nie można usunąć grupy typów umów ze względu na powiązanie z innym podmiotem",
	    LblSelectFuelType: "Wybierz rodzaj paliwa",
	    LblSelectPricingCatagory: "Wybierz kategorię cenową",
	    LblSelectBodyStyle: "Wybierz styl nadwozia",
	    LblSelectVehicleClass: "Wybierz klasę pojazdu",
	    LblIsImportPersonAllow: "Pozwól zaimportować osobę",
	    LblValidateLicenseA2SP: "Kontrola licencji A2SP",
	    LblValidateLicense24IDCheck: "Kontrola licencji 24ID",
	    LblValidateLicenseForAllBookings: "Potwierdzaj ponownie licencję przy każdej rezerwacji",
	    LblGeofenceLocation: "Lokalizacja geofence",
	    LblRadius: "Promień",
	    LblEmailRecepients: "Odbiorcy e-maila",
	    LblRecepients: "Odbiorcy",
	    LblEmailAddresses: "Adresy e-mail",
	    LblMap: "Mapa",
	    // AFAS/Azure Config
	    LblImportConfiguration: "Konfiguracja importu",
	    LblImportConnectionType: "Typ połączenia",
	    LblAfas: "AFAS",
	    LblAzure: "Azure",
	    LblAzureTenantId: "Identyfikator użytkownika Azure",
	    LblAzureClientId: "Identyfikator klienta Azure",
	    LblAzureClientSecret: "Klucz prywatny klienta Azure",
	    LblAfasClientId: "ID klienta AFAS",
	    LblAfasConnectorName: "Nazwa Connectora AFAS",
	    LblAfasConnectionType: "Typ połączenia AFAS",
	    LblAfasTest: "Test",
	    LblAfasAccept: "Akceptacja",
	    LblAfasProduction: "Produkcja",
	    LblAfasToken: "Token AFAS",
	    LblAfasClientIdError: "Proszę wprowadzić identyfikator klienta AFAS",
	    LblAfasConnectorNameError: "Proszę wprowadzić identyfikator klienta AFAS",
	    LblAfasConnectionTypeError: "Proszę wprowadzić typ połączenia AFAS",
	    LblAfasTokenError: "Proszę wprowadzić Token AFAS",
	    LblAzureTenantIdError: "Proszę wprowadzić identyfikator użytkownika Azure",
	    LblAzureClientIdError: "Proszę wprowadzić identyfikator klienta Azure",
	    LblAzureClientSecretError: "Proszę wprowadzić kod klienta Azure",
	    // SSO Config
	    LblSsoConfiguration: "Konfiguracja SSO",
	    LblDefaultSsoSharedVehicleGroup: "Domyślna grupa pojazdów współdzielonych",
	    LblDefaultSsoOrganization: "Domyślna organizacja",
	    LblDefaultSsoSubscription: "Domyślna subskrypcja",
	    // Dropoff Message
	    LblDropoffMessageConfiguration: "Konfiguracja komunikatu Dropoff",
	    LblDropoffMessageExternalUrl: "Adres zewnętrzny",
	    LblDropoffMessageApiKey: "Klucz Api",
	    LblDropoffMessageActive: "Aktywny",
	    LblValidate: "Walidacja",
	    LblRejection: "Odrzucenie",
	    LblrejectionReasonMsg: "Proszę podać powód odrzucenia wybranych wniosków o rezerwację",
	    LblApproveConfirmationMsg: "Czy na pewno chcesz zatwierdzić wszystkie wybrane wnioski o rezerwację?",
	    LblBookingCalanderSettings: "Ustawienia kalendarza rezerwacji",
	    LblShowDriverInfo: "Pokaż informacje o kierowcy w kalendarzu rezerwacji",
	    LblOrganizationAdmin: "Administrator organizacji",
	    LblDriverInfoToShow: "Informacje o kierowcy do pokazania",
	    //Person Page
	    LblUserName: "Nazwa użytkownika",
	    LblFirstName: "Imię",
	    LblLastName: "Nazwisko",
	    LblEmail: "E-mail",
	    LblMobileNumber: "Numer telefonu komórkowego",
	    LblPhoneNumber: "Numer telefonu",
	    LblHomeAddress: "Adres domowy",
	    LblWorkAddress: "Adres miejsca pracy",
	    LblHouseNo: "Nr domu",
	    LblHouseExtention: "Nr mieszkania",
	    LblStreetName: "Nazwa ulicy",
	    LblCity: "Miasto",
	    LblZipCode: "Kod pocztowy",
	    LblPassword: "Hasło",
	    LblConfirmPassword: "Potwierdź hasło",
	    LblMiddleName: "Drugie imię",
	    LblMandateId: "Identyfikator zezwolenia",
	    LblMandateSignatureDate: "Data podpisania zezwolenia",
	    LblIsAmmandment: "Poprawiono",
	    LblRemovePersonDetails: "Usuń dane osoby",
	    LblMonitoring: "Monitoring",
	    LblDropoffMessage: "Komunikat Dropoff",
	    LblPreferredlanguage: "Preferowany język",
	    LblDebtornr: "Liczba należności",
	    LblEnableLogin: "Włącz logowanie",
	    LblEnableErrorEscalation: "Włącz eskalację błędów",
	    LblErrorEscalationMinutes: "Minuty eskalacji błędów",
	    //Booking Type
	    LblNORMALBOOKINGTYPE: 'NORMALNY',
	    LblMAINTENANCEBOOKINGTYPE: 'UTRZYMANIE',
	    LblUNAVAILABLEBOOKINGTYPE: 'NIEDOSTĘPNY',
	    //Booking Status
	    LblABORTED: 'ODRZUCONY',
	    LblCANCELLED: 'ANULOWANY',
	    LblCONFIRMED: 'POTWIERDZONY',
	    LblFINISHED: 'ZAKOŃCZONY',
	    LblNOSHOW: 'NOSHOW',
	    LblPENDING: 'W TRAKCIE REALIZACJI',
	    LblREVOKED: 'ODWOŁANY',
	    LblRUNNING: 'W TOKU',
	    LblREADYFORPAYMENT: 'GOTOWY DO ZAPŁATY',
	    //Invoice Status
	    LblOPEN: 'OTWARTY',
	    LblSENT: 'WYSŁANY',
	    LblCLOSED: 'ZAMKNIĘTY',
	    LblREQUESTFORPAYMENT: 'ŻĄDANIEZAPŁATY',
	    LblREOPEN: 'PONOWNIEOTWARTY',
	    //Booking Request Status
	    LblAPPROVEDBOOKINGREQUEST: 'ZATWIERDZONY',
	    LblREJECTEDBOOKINGREQUEST: 'ODRZUCONY',
	    LblPENDINGBOOKINGREQUEST: 'W TRAKCIE REALIZACJI',
	    // Error Log
	    LblErrorLog: "Dziennik błędów",
	    LblComponentName: "Nazwa składnika",
	    LblLogType: "Typ dziennika",
	    LblEventDateTime: "Data i czas zdarzenia",
	    // Interface Status
	    LblInterfaceStatus: "Status interfejsu",
	    LblLastStatusChangeDateTime: "Ostatnia zmiana stanu DataGodzina",
	    LblLastCarwisePollDateTime: "Ostatnia próba usunięcia usterki (Carwise Poll)",
	    LblUpdatedDateTime: "Zaktualizowany czas",
	    //ErrorEscalation
	    LblDuplicateErrorEscalation: "Znaleziono podwójną konfigurację eskalacji błędu",
	    LblErrorEscalation: "Eskalacja błędu",
	    LblComponent: "Komponent",
	    LblSelectAdminLevel: "Wybierz poziom administratora",
	    LblWegoAdminLevel: "Poziom administratora Wego",
	    LblCustomerAdminLevel: "Poziom administratora klienta",
	    LblInstanceAdminLevel: "Poziom administratora platformy",
	    //Company Page
	    LblCompany: "Firma",
	    LblCompanyName: "Nazwa firmy",
	    LblContactPerson: "Osoba kontaktowa",
	    LblCompanyAdmin: "Administrator firmy",
	    LblCompanyAddress: "Adres firmy",
	    LblInternalOrganization: "Organizacja wewnętrzna",
	    LblNoOfVegicles: "Liczba pojazdów",
	    LblNoOfSharedVehicleGroups: "Numer SVG",
	    LblGeoLocation: "Geo Lokalizacja",
	    LblSelectGeoLocation: "Wybierz lokalizację",
	    LblPerson: "Osoba",
	    LblRole: "Role",
	    LblDateOfBirth: "Data urodzenia",
	    LblDriverLicenceNumber: "Numer prawa jazdy",
	    LblApkExiprationSetting: "Ustawienia powiadomień o okresowej konserwacji",
	    LblApkTimeInterval: "Odstęp czasu między powiadomieniami",
	    LblEmailNotification: "Powiadomienie e-mail",
	    LblNotificationFrequency: "Częstotliwość powiadomień",
	    lblThresholdFrequency: "Częstotliwość progowa",
	    lblThresholdTimeInterval: "Odstęp czasowy progu",
	    LblIsEmailEnabled: "E-mail powiadamiający",
	    lblThreshold: "Okres progowy",
	    LblFrequency: "Częstotliwość",
	    LblDay: "Dzień",
	    LblWeek: "TYDZIEŃ",
	    LblMonth: "Miesiąc",
	    lblPerBooking: "Perbooking",
	    LblPersons: "Osoby",
	    LblPersonOverview: "Przegląd osób",
	    LblCompanies: "Firmy",
	    //Vehicle Page
	    LblVehicle: "Pojazd",
	    LblVtsVehicle: "Pojazd VTS",
	    LblFleetId: "ID floty",
	    LblContractId: "Identyfikator umowy",
	    LblVIN: "VIN",
	    LblLicenceTag: "Znacznik licencji",
	    LblLicence: "Licencja",
	    LblMobile: "Mobilny",
	    LblVehicleOwner: "Właściciel pojazdu",
	    LblLocationDataExchange: "Wymiana danych dotyczących lokalizacji",
	    LblBrand: "Marka",
	    LblType: "Typ",
	    LblColor: "Kolor",
	    LblVehicleClass: "Klasa pojazdu",
	    LblPricingCategory: "Kategoria cenowa",
	    LblBodyStyle: "Styl nadwozia",
	    LblAvailable: "Dostępny",
	    LblUnAvailable: "Niedostępne",
	    LblAvailableFrom: "Dostępny Od",
	    LblAvailableTo: "Dostępny do",
	    LblFuelType: "Typ paliwa",
	    LblMinBookingTimeBefore: "Minimalny czas dostępny przed rezerwacją (minuty)",
	    LblMinBookingTimeAfter: "Minimalny czas dostępny po rezerwacji (minuty)",
	    LblTowbar: "Hak holowniczy",
	    LblAirco: "Klimatyzacja",
	    LblVehicleAttributes: "Atrybuty pojazdu",
	    LblBlockUnBlock: "Zablokuj/Odblokuj",
	    LblRemoveLicense: "Usuń prawo jazdy",
	    LblRemoveLicenseBirthDate: "Usuń prawo jazdy i datę urodzenia",
	    LblLicenseBirthDate: "Data urodzenia",
	    LblBlock: "Zablokuj",
	    LblUnblock: "Odblokuj",
	    LblAvailableUnAvailable: "Dostępne/Niedostępne",
	    LblVehicles: "Pojazdy",
	    LblBookingsOverview: "Przegląd rezerwacji",
	    LblApkExpirationDateCet: "Data wygaśnięcia okresowej konserwacji",
	    LblEnabled: "Włączone",
	    LblDisabled: "Wyłączone",
	    LblIntialOdometerValue: "Początkowa wartość licznika kilometrów",
	    LblFuelCardPinCode: "Kod PIN karty paliwowej",
	    LblFuel: "Paliwo",
	    LblVINnumber: "Numer VIN",
	    LblVehicletype: "Typ pojazdu",
	    LblDoors: "Liczba drzwi",
	    LblWeight: "Masa pojazdu",
	    LblTrunkSpace: "Przestrzeń bagażnika",
	    LblGears: "Liczba biegów",
	    LblEngineHorsepower: "Moc silnika (KM)",
	    LblFuelConsumption: "Zużycie paliwa",
	    LblSeats: "Liczba miejsc",
	    LblDimensions: "Wymiary pojazdu",
	    LblTransmissionType: "Typ skrzyni biegów",
	    LblTransmissionUnknown: "Nieznany",
	    LblManualTransmission: "Manualna",
	    LblAutomaticTransmission: "Automatyczna",
	    LblVehicleDetails: "Szczegóły pojazdu",
	    LblSelectVehicletype: "Wybierz typ pojazdu",
	    LblWrongVinNumber: "Nieprawidłowy numer VIN",
	    //WEGO2DEV-325(Settings for Dashboard statuses)
	    LblVehicleOnSameLocationTime: "Pojazd w tym samym miejscu przez więcej niż",
	    LblNoBookingIn: "Pojazd nie zarezerwowany od ponad",
	    lblHour: "Godzina",
	    //'lblInterval':'HOUR/DAY/WEEK/MONTH',
	    lblHourDayWeekMonth: "Godzina / Dzień / Tydzień / Miesiąc",
	    //SharedVehicleGroup
	    LblSharedVehicleGroup: "Wspólna grupa pojazdów",
	    LblVehicleGroup: "Grupa pojazdów",
	    LblSharedVehicleGroupAdmin: "Administrator współdzielonej grupy pojazdów",
	    LblDisplayPeriod: "Wyświetl okres",
	    LblBookingWeekDays: "Dni rezerwacji",
	    LblBookingInterval: "Odstęp czasu między rezerwacjami (minuty)",
	    LblBookingStartTime: "Godzina rozpoczęcia rezerwacji (gg:mm)",
	    LblBookingEndTime: "Godzina zakończenia rezerwacji (gg:mm)",
	    LblBookingMinDuration: "Minimalny czas trwania rezerwacji (minuty)",
	    LblBookingMaxDuration: "Maksymalny czas trwania rezerwacji (minuty)",
	    LblMaxRecurringBooking: "Maksymalna rezerwacja cykliczna",
	    LblPreBookingInterval: "Odstęp czasu między rezerwacjami wstępnymi (minuty)",
	    LblPostBookingInterval: "Odstęp czasu po dokonaniu rezerwacji (minuty)",
	    LblBookingExtensionTime: "Maksymalny czas przedłużenia rezerwacji (minuty)",
	    LblBookAheadTime: 'Rezerwacja możliwa X" minut od teraz',
	    LblBookingHorizon: "Najpóźniejszy możliwy czas dokonania rezerwacji",
	    LblNumberOfContactTypeGroup: "Liczba grup typów umów",
	    LblNumberOfContactType: "Liczba typów umów",
	    LblInvoiceInterval: "Przedział czasowy faktury",
	    LblIsBookingIntervalAlignToCalendar: "Dopasuj przedział rezerwacji do kalendarza",
	    LblBookings: "Rezerwacje",
	    LblSharedVehicleGroups: "Grupy wspólnych pojazdów",
	    LblSharedVehicleGroupOverview: "Przegląd wspólnych grup pojazdów",
	    LblEarlyOpenInterval: "Przedział czasowy (minuty)",
	    LblFeatureFlags: "Feature Flags",
	    LblCreateBooking: "Utwórz rezerwację",
	    LblEditBooking: "Edytuj rezerwację",
	    LblLicenseCheck: "Sprawdzanie licencji",
	    LblBookingLicenseCheck: "Sprawdzenie licencji rezerwacji",
	    //Driver
	    LblDriver: "Kierowca",
	    LblLicenceNumber: "Nr licencji",
	    LblDriverName: "Nazwisko kierowcy",
	    LblDriverSVG: "Grupa pojazdów współdzielonych przez kierowcę",
	    LblDriverUserName: "Nazwa użytkownika kierowcy",
	    //VehicleAttribute
	    LblVehicleAttributeCategory: "Kategoria atrybutu pojazdu",
	    LblVehicleAttributeName: "Nazwa atrybutu",
	    LblVehicleAttributeDesc: "Opis",
	    LblVehicleAttribute: "Atrybut pojazdu",
	    LbAdditionallVehicleAttribute: "Dodatkowe atrybuty pojazdu",
	    LblVehicleAttributeCategories: "Kategorie atrybutów pojazdu",
	    //ContractType Page
	    LblRegular: "Regularnie",
	    LblWeekEnd: "Weekend",
	    LblDayCT: "Dzień",
	    LblExtraTimeBefore: "Dodatkowy czas przed (minuty)",
	    LblExtraTimeAfter: "Dodatkowy czas po (minuty)",
	    LblFreeTextDescription: "Podaj stawkę za rezerwację specjalną oraz czas rozpoczęcia i zakończenia (dowolny tekst)",
	    LblPeriodRate: "Stawka za okres",
	    LblPeriodRateVat: "Kwota VAT stawki za okres",
	    LblSelectContractTypeType: "Wybierz typ rodzaju umowy",
	    LblContractTypeType: "Typ rodzaju umowy",
	    LblContractType: "Typ umowy",
	    LblContractName: "Nazwa umowy",
	    LblContractTypeGroup: "Grupa typów umowy",
	    LblContractTypeGroupName: "Nazwa grupy typów umowy",
	    LblContractAvailableDays: "Dostępne dni dla umowy",
	    LblApplicableDays: "Obowiązujące dni",
	    LblDayStartTime: "Godzina rozpoczęcia dnia (gg:mm)",
	    LblDayEndTime: "Godzina zakończenia dnia (gg:mm)",
	    LblApplicableStartTime: "Obowiązująca godzina rozpoczęcia (gg:mm)",
	    LblApplicableEndTime: "Obowiązująca godzina zakończenia (gg:mm)",
	    LblComment: "Skomentuj",
	    LblProcessingFee: "Opłata za przetwarzanie",
	    LblVatPercentage: "Procent VAT",
	    LblVatIncludedInPrice: "VAT zawarty w cenie",
	    LblPlateformUsageCost: "Koszt użytkowania platformy",
	    LblCatA: "Kategoria A",
	    LblCatB: "Kategoria B",
	    LblCatC: "Kategoria C",
	    LblCatD: "Kategoria D",
	    LblCatE: "Kategoria E",
	    LblCatF: "Kategoria F",
	    LblCatG: "Kategoria G",
	    LblCatH: "Kategoria H",
	    LblHourlyRate: "Koszt czasu",
	    LblMileageRate: "Stawka za kilometr",
	    LblFixedFee: "Opłata stała",
	    LblPricingModel: "Model cenowy",
	    LblContractStartDateTime: "Data/czas rozpoczęcia umowy",
	    LblContractEndDateTime: "Data/czas zakończenia umowy",
	    LblContractTypeHistory: "Historia",
	    LblContractTypPeriod: "Okres obowiązywania typu umowy",
	    LblInactiveContractTypeGroupReason: "Powód deaktywacji grupy typów umów",
	    LblPenaltyAmount: "Kwota kary",
	    LblPenaltyTimeInterval: "Przedział czasu kary (minuty)",
	    LblIsPenaltyEnabled: "Kara włączona",
	    LblTripDisplayType: "Jak powinny być prezentowane przejazdy w raportach?",
	    LblAllTripsIndividually: "Wszystkie podróże indywidualnie",
	    LblAllTripsGrouped: "Wszystkie podróże zgrupowane w jedną podróż",
	    // DateTime Picker
	    LblJanuary: "Styczeń",
	    LblFebruary: "Luty",
	    LblMarch: "Marzec",
	    LblApril: "Kwiecień",
	    LblMay: "Maj",
	    LblJune: "Czerwiec",
	    LblJuly: "Lipiec",
	    LblAugust: "Sierpień",
	    LblSeptember: "Wrzesień",
	    LblOctober: "Październik",
	    LblNovember: "Listopad",
	    LblDecember: "Grudzień",
	    LblSJan: "St",
	    LblSFeb: "Lut",
	    LblSMar: "Mrz",
	    LblSApr: "Kw",
	    LblSMay: "Maj",
	    LblSJun: "Cz",
	    LblSJul: "Lip",
	    LblSAug: "Sier",
	    LblSSep: "Wrz",
	    LblSOct: "Paź",
	    LblSNov: "Lis",
	    LblSDec: "Gr",
	    LblSunday: "Niedziela",
	    LblMonday: "Poniedziałek",
	    LblTuesday: "Wtorek",
	    LblWednesday: "Środa",
	    LblThursday: "Czwartek",
	    LblFriday: "Piątek",
	    LblSaturday: "Sobota",
	    LblSSu: "Nd",
	    LblSMo: "Pon",
	    LblSTu: "Wt",
	    LblSWe: "Śr",
	    LblSTh: "Czw",
	    LblSFr: "Pt",
	    LblSSa: "Sob",
	    //Forgot Password
	    LblForgotPassword: "Nie pamiętam hasła",
	    LblChangePassword: "Zmień hasło",
	    LblOldPassword: "Stare hasło",
	    LblNewPassword: "Hasło",
	    LblProfileUpdatedSucessFully: "Profil został pomyślnie zaktualizowany",
	    LblPasswordChangedSucessFully: "Hasło zmienione pomyślnie",
	    //
	    LblUpdateProfile: "Zaktualizuj profil",
	    LbLReasonVehicle: "Powód niedostępności",
	    LblReasonDriver: "Powód zablokowania kierowcy",
	    //Booking
	    LblFrom: "Od",
	    LblApprovalAdminName: "Zatwierdzone przez administratora",
	    LblApprovedRejectedby: "Zatwierdzone/Odrzucone przez",
	    LblBookingRequestList: "Lista wniosków o rezerwację",
	    LblTo: "Do",
	    LblBooking: "Rezerwacja",
	    LblBookingRequest: "Zapytanie o rezerwację",
	    LblOverview: "Przegląd rezerwacji",
	    LblOverviewList: "Lista przeglądów rezerwacji",
	    LblApproveBooking: "Zatwierdzanie rezerwacji",
	    LblApprove: "Zatwierdź",
	    LblBookingApprovedSuccessMsg: "Wybrane żądania rezerwacji zatwierdzone pomyślnie",
	    LblBookingRejectedSuccessMsg: "Wybrane zapytania o rezerwację odrzucone pomyślnie",
	    LblReject: "Odrzuć",
	    LblNormal: "Nowa rezerwacja",
	    LblSpecial: "Rezerwacja specjalna",
	    LblHistory: "Historia rezerwacji",
	    LblBookingStatus: "Status rezerwacji",
	    LblBookingType: "Typ rezerwacji",
	    LblAdminRemarks: "Uwagi administratora",
	    LblBookingRemarks: "Uwagi do rezerwacji",
	    LblDriverRemarks: "Uwagi kierowcy",
	    LblBookingReferenceId: "ID rezerwacji",
	    SelectionRequiredMsg: "Proszę wybrać co najmniej jedną rezerwację do zatwierdzenia/odrzucenia",
	    LblSelectionRequired: "Wymagany wybór",
	    LblAbort: "Przerwij",
	    LblRevoke: "Odwołaj",
	    LblStatus: "Status",
	    LblReference: "ReferenceID",
	    LblRemarks: "Uwagi",
	    LblSearchForVehicle: "Wyszukiwanie pojazdu",
	    LblVehicleOverview: "Przegląd pojazdu",
	    LblConfirmBooking: "Potwierdź rezerwację",
	    LblCurrentBookingDetail: "Szczegóły obecnej rezerwacji",
	    LblCheckAvailability: "Sprawdź dostępność",
	    LblBookingStartDateTime: "Początek rezerwacji",
	    LblBookingEndDateTime: "Koniec rezerwacji",
	    LblSource: "Źródło",
	    LblRecurring: "Cykliczne",
	    LblRecurringId: "ID rezerwacji cyklicznej",
	    LblRecurringBookingReference: "Odnośnik rezerwacji cyklicznej",
	    LblDaily: "Codziennie",
	    LblWeekly: "Co tydzień",
	    LblMonthly: "Miesięcznie",
	    LblRecurrenceEndDate: "Data zakończenia powtarzania",
	    LblSearch: "Szukaj",
	    LblBookNow: "Zarezerwuj teraz",
	    LblUpdateBooking: "Aktualizuj rezerwację",
	    LblEditCarNotAvailable: "Pierwotnie zarezerwowany samochód nie jest dostępny",
	    LblSortBy: "Sortuj według",
	    LblAvaibility: "Dostępność",
	    LblDistance: "Odległość",
	    LblNoMatchingVehicle: "Nie znaleziono pasujących pojazdów",
	    LblAvailableSlots: "Dostępne sloty",
	    LblFeatures: "Funkcje?",
	    LblDriverDetail: "Szczegóły o kierowcy",
	    LblBookingDetail: "Szczegóły rezerwacji",
	    LblVehicleDetail: "Dane pojazdu",
	    LblBookingSuccess: "Udało Ci się utworzyć wniosek o rezerwację. Kopia wniosku jest wysyłana na zarejestrowany adres e-mail. Wysyłane jest również powiadomienie do zatwierdzenia, a Ty zostaniesz powiadomiony, gdy rezerwacja zostanie zaakceptowana.",
	    LblBookingUpdateSuccess: "Rezerwacja została pomyślnie zaktualizowana. Powiadomienie zostaje wysłane na adres e-mail kierowcy.",
	    LblBlockNormalBooking: "Twoje konto jest zablokowane. Prosimy o kontakt z administratorem.",
	    LblSingle: "Pojedynczy",
	    LblSeries: "Seria",
	    LblAll: "Wszystkie",
	    LblLicenceRequired1: "Proszę sprawdzić numer licencji, przejdź do",
	    LblLicenceRequired2: "aby zaktualizować szczegóły numeru licencji",
	    LblAcceptOrReject: "Zatwierdź / Odrzuć",
	    //Special Booking
	    LblSpecialBooking: "Rezerwacja specjalna",
	    LblAffectedBooking: "Rezerwacja naruszona",
	    LblSpecialBookingType: "Typ rezerwacji specjalnej",
	    LblSelectSpecialBookingType: "Wybierz typ rezerwacji specjalnej",
	    LblSpecialBookingConfiramtionmsg: "Czy na pewno chcesz utworzyć rezerwację specjalną?",
	    LblEndDate: "Data zakończenia powtarzalności",
	    // Notification
	    LblNotification: "Powiadomienie",
	    LblSubject: "Przedmiot",
	    LblDate: "Data",
	    LblWelcomeNotification: "Witamy w skrzynce powiadomień WeGo",
	    //Template
	    LblTemplate: "Szablon",
	    LblTemplateList: "Lista szablonów",
	    LblTemplateName: "Nazwa szablonu",
	    LblTemplateType: "Typ szablonu",
	    LblBody: "Nadwozie",
	    LblIsEmailTemplate: "Email",
	    LblIsWebTemplate: "Strona internetowa",
	    // Notification Event Management
	    LblNotificationEventManagement: "Zarządzanie zdarzeniami powiadamiania",
	    LblNotificationEvent: "Zdarzenie powiadamiania",
	    LblModuleName: "Nazwa modułu",
	    LblSMS: "SMS",
	    //User Type
	    LblUserType: "Typ użytkownika",
	    //TimeBlock
	    LblTimeBlock: "Blok czasowy",
	    LblTimeBlockName: "Nazwa bloku czasowego",
	    LblTimeBlockWeekDays: "Blok czasowy Dni tygodnia",
	    LblTimeBlockStartTime: "Czas rozpoczęcia bloku czasowego",
	    LblTimeBlockEndTime: "Czas zakończenia bloku czasowego",
	    LblTimeBlockStartDate: "Data rozpoczęcia bloku czasowego",
	    LblTimeBlockEndDate: "Data zakończenia bloku czasowego",
	    // Service Offer
	    LblServiceOffer: "Oferta serwisowa",
	    LblServiceOfferList: "Lista ofert serwisowych",
	    LblServiceOfferName: "Nazwa oferty",
	    LblServiceOfferType: "Typ oferty",
	    LblStandardTariff: "Taryfa standardowa",
	    LblTimeUsedOrBooked: "Czas wykorzystany/ zarezerwowany",
	    LblPenalty: "Kara umowna",
	    LblAdditional: "Dodatkowa",
	    LblAdditionalAbbr: "Dodatkowa",
	    LblUnit: "Jednostka",
	    //WegoAdminList
	    LblWegoAdmin: "Administrator WeGo",
	    LblWegoAdmins: "Administratorzy WeGo",
	    LblReSend: "Wyślij ponownie",
	    LblResendActivationMail: "E-mail aktywacyjny",
	    LblResendActivationMailFailure: "Nie udało się wysłać e-maila aktywacyjnego",
	    LblResendActivationMailSuccess: "E-mail aktywacyjny został wysłany",
	    //Subscription
	    LblSubscription: "Subskrypcja",
	    LblSubscriptionName: "Nazwa subskrypcji",
	    LblTimeInterval: "Odstęp czasu",
	    LblAmount: "Kwota",
	    LblFreeKilometer: "Bezpłatne kredyty",
	    LblFreeMinute: "Bezpłatne minuty",
	    LblFreeHours: "Bezpłatne godziny",
	    LblNumberOfSubscription: "Liczba subskrypcji",
	    LblUnsubscribe: "Odsubskrybuj",
	    LblsubscribeEndDate: "Data zakończenia subskrypcji",
	    LblSubscriptionStartDate: "Data rozpoczęcia subskrypcji",
	    //Special Period
	    LblSpecialPeriod: "Okres Specjalny",
	    LblspecialPeriodName: "Nazwa Okresu Specjalnego",
	    LblSpecialPeriodStartTime: "Godzina rozpoczęcia Okresu Specjalnego",
	    LblSpecialPeriodEndTime: "Godzina zakończenia okresu specjalnego",
	    LblSpecialPeriodWeekDays: "Okres specjalny Dni tygodnia",
	    LblNormalPeriod: "Okres zwykły",
	    LblSpecialPeriods: "Okresy specjalne",
	    //Booking InvoiceModel
	    LblBookingInvoice: "Faktura Rezerwacji",
	    LblInvoiceStatus: "Status faktury",
	    LblInvoiceType: "Typ faktury",
	    LblSummary: "Podsumowanie",
	    LblTotalHours: "Całkowita liczba godzin",
	    LblTotalKm: "Całkowita odległość (km.)",
	    LblTotalExpense: "Wydatki ogółem",
	    LblInvoiceNumber: "Numer faktury",
	    LblBegin: "Początek",
	    LblEnd: "Koniec",
	    LblVat: "VAT",
	    LblDone: "Gotowe",
	    LblClear: "Wyczyść",
	    LblTotal: "Razem",
	    LblInvoiceRequestDateTime: "Data zażądania faktury",
	    LblInvoiceSendDateTime: "Data wysłania faktury",
	    LblInvoiceDateTime: "Data faktury",
	    LblInvoiceDetail: "Szczegóły faktury",
	    LblResend: "Wyślij ponownie",
	    LblDownload: "Pobierz",
	    LblResendInvoiceConfirm: "Czy na pewno chcesz wysłać ponownie %0?",
	    LblSendInvoiceConfirm: "Czy na pewno chcesz wysłać fakturę?",
	    LblPenaltyRate: "Stawka kary",
	    LblInvoicing: "Fakturowanie",
	    LblInvoices: "Faktury",
	    LblProfile: "Profil",
	    LblSignOut: "Wyloguj się",
	    LblTemplateNote1: "Proszę nie zmieniać/usuwać tekstu napisanego w ten sposób { variablename }. Jest to dynamiczna nazwa atrybutu, która zostanie zastąpiona przez rzeczywisty wpis w bazie danych, gdy email zostanie wysłany do użytkownika.",
	    LblTemplateNote2: "Proszę nie modyfikować struktury tabeli. Możesz stworzyć nową, a stara nie powinna być modyfikowana.",
	    LblTemplateNote3: 'Upewnij się, że po skopiowaniu symoblu zastępczego i wklejeniu go do edytora html, musisz użyć funkcji Kopiuj w postaci zwykłego tekstu "plain text".',
	    LblConfirmUnsubscribe: "Czy na pewno chcesz zakończyć subskrypcję?",
	    LblDriveHours: "Godziny jazdy",
	    LblVehicleImage: "Obraz pojazdu",
	    LblMaintenance: "Serwis",
	    LblUNAVAILABLE: "Niedostępne",
	    LblTestInvoiceGenerator: "Generator faktur testowych",
	    LblMissingInvoiceGenerator: "Brak generatora faktur",
	    LblInvoicingDateTime: "Data wystawienia faktury (UTC)",
	    LblGenerateInvoice: "Wygeneruj fakturę",
	    LblDeleteAllSelectedRecords: "Usuń wszystkie wybrane zapisy",
	    LblCancelAllSelectedRecords: "Anuluj wszystkie wybrane zapisy",
	    "LblExportAll(CSV)": "Eksportuj wszystko (CSV)",
	    LblAddContactPerson: "Dodaj osobę kontaktową",
	    LblRemoveContactPerson: "Usuń osobę kontaktową",
	    LblNote: "Notatka",
	    LblCompletelyEndConfirm: "Całkowicie zakończ podróż",
	    LblEndTrip: "Zakończ podróż",
	    LblTestTrip: "Testuj podróż",
	    LblTripSimulator: "Symulator podróży",
	    LblPrePostTripQuestions: "Pytania przed i po wycieczce",
	    LblTestTripSuccess: "Wycieczka testowa utworzona z powodzeniem",
	    LblDrivingStartDateTime: "Data / godzina rozpoczęcia jazdy",
	    LblDrivingEndDateTime: "Data / godzina zakończenia jazdy",
	    LblInvoiceMoment: "Moment wystawienia faktury",
	    LblExtend: "Rozszerzenie pliku",
	    LblExtendRequire: "Proszę wprowadzić czas przedłużenia rezerwacji (w minutach)",
	    LblExtendInfoMsg: "Możesz przedłużyć rezerwację do %0 min",
	    LblExtendValidationMsg: "Ta rezerwacja nie może być przedłużona",
	    LblExtendBooking: "Przedłużenie rezerwacji",
	    LblBookingExtendedSuccess: "Rezerwacja została przedłużona pomyślnie",
	    LblOverExtendValidationMsg: "Nie można przedłużyć rezerwacji o więcej niż %0 minut",
	    LblUnLock: "Odblokuj",
	    LblLock: "Zablokuj",
	    LblVehicleStatus: "Status pojazdu",
	    LblTripSuccess: "Podróż zapisana pomyślnie",
	    LblLockSuccessfully: "Pojazd zablokowany pomyślnie",
	    LblLockCompletelySuccessfully: "Pojazd zablokowany pomyślnie",
	    LblUnLockSuccessfully: "Pojazd odblokowany pomyślnie",
	    LblUnlockProblem: "Problem podczas polecenia odblokowania",
	    LbllockProblem: "Problem podczas polecenia zablokowania",
	    LblLockCarCompletely: "Zablokuj i zamknij rezerwację",
	    LblStartDateTime: "Data/godzina rozpoczęcia",
	    LblEndDateTime: "Data/godzina zakończenia rezerwacji",
	    LblBookingTripDetail: "Szczegóły rezerwacji podróży",
	    LblAddNewTrip: "Dodaj nową podróż",
	    LblBookingExpenseDetail: "Szczegóły wydatków dot. rezerwacji",
	    LblUnlockErrorMessage: "Brak aktywnej grupy typu umowy dostępnej w czasie tworzenia rezerwacji",
	    LblExpenseAmount: "Kwota wydatku",
	    LblExpenseName: "Nazwa wydatku",
	    LblExpenseSuccess: "Wydatek zapisany pomyślnie",
	    LblReceipt: "Pokwitowanie",
	    LblHelpdeskNo: "Nr pomocy technicznej",
	    LblBookingExpired: "Pojazd nie może być odblokowany, ponieważ rezerwacja wygasła",
	    LblTripCalculationInProgress: "Mamy nadzieję, że miałeś miłą podróż! Pojazd zostanie zamknięty za kilka sekund.",
	    LblVTSReqLogDetail: "Szczegóły dziennika zgłoszeń VTS",
	    LblVTSReqDateTime: "Data/godzina zgłoszenia",
	    LblVTSProcessTime: "Czas przetwarzania",
	    LblVTSResTime: "Czas wyniku",
	    LblVTSReqType: "Typ żądania",
	    LblVTSResult: "Wynik",
	    LblActualInvoiceGenerationDate: "Data wygenerowania faktury",
	    LblAvailableForAllSlots: "Pojazd dostępny dla wszystkich slotów",
	    LblUnAvailableSlots: "Niedostępne sloty",
	    LblNoOfDrivers: "Liczba kierowców",
	    LblSVGDriversList: "Kierowcy z grupy pojazdów współdzielonych",
	    LblVehicleInformation: "Informacje o pojeździe",
	    LblVTSVehicle: "Pojazd VTS",
	    LblVTSVehicleUpdateSuccess: "Pojazd %0 pomyślnie.",
	    LblVTSVehicleList: "Lista pojazdów VTS",
	    //Report Damage
	    LblReportDamage: "Zgłoś szkodę",
	    LblCompleteDamageReport: "Uzupełnij zgłoszenie szkody",
	    LblDamageFile: "Plik uszkodzeń",
	    LblDescribe: "Opisz szkodę...",
	    LblCause: "Opisz przyczynę...",
	    LblReportDamageMsg: "Szkoda została zgłoszona pomyślnie",
	    LblSelectFile: "Proszę wybrać plik",
	    // Import Data
	    LblCSVImport: "Importuj CSV",
	    LblValidateCSV: "Sprawdź CSV",
	    LblImportValidPerson: "Importuj prawidłową osobę",
	    LblImportValidDriver: "Importuj poprawnego kierowcę",
	    LblImportValidVehicle: "Importuj ważny pojazd",
	    LblCSVType: "Typ CSV",
	    LblCSVFile: "Plik CSV",
	    LblRecordImportedSuccess: "%0 zostało zaimportowane z powodzeniem",
	    LblInvalidReason: "Nieważny powód",
	    LblSameVTSCommand: "Żądanie jest już w toku. Proszę czekać.",
	    LblImportPerson: "Importuj osobę",
	    //Subscription related Changes
	    LblSubscriptionInterval: "Okres subskrypcji",
	    LblPaymentInterval: "Okres płatności",
	    LblInvoicInterval: "Okres faktury",
	    LblInterval: "Okres/Przedział",
	    LblInvoiceMomentDay: "Moment wystawienia faktury (dzień tygodnia)",
	    LblInvoiceMomentMonth: "Moment wystawienia faktury (dzień miesiąca)",
	    LblFreeMinuteInterval: "Przedział darmowych minut",
	    LblFreeKMInterval: "Przedział bezpłatnych kilometrów",
	    LblSelectSubscriptionInterval: "Wybierz przedział abonamentu",
	    LblSelectInvoiceInterval: "Wybierz przedział czasowy faktury",
	    LblSelectPaymentInterval: "Wybierz przedział płatności",
	    LblSelectFreeKMInterval: "Wybierz przedział bezpłatnych Kilometrów",
	    LblSelectFreeMinInterval: "Wybierz przedział minutowy",
	    LblYearlySub: "Roczny",
	    LblMonthlySub: "Miesięczny",
	    LblWeeklySub: "Tygodniowy",
	    LblFreePerWeek: "Na tydzień",
	    LblFreePerMonth: "Za miesiąc",
	    LblFreePerTriMonth: "Za 3 miesiące",
	    LblFreePerBiannual: "Za 6 miesięcy",
	    LblFreePerYear: "Za rok",
	    LblDefaultContractTypeGroup: "Domyślna grupa typów umów",
	    LblSelectDefaultContractTypeGroup: "Wybierz domyślną grupę typów umów",
	    LblSendInvoiceToDriver: "Wyślij fakturę do kierowcy",
	    LblInherit: "Przejęcie",
	    //Invoice Moment
	    LblDayOfMonth: "Dzień miesiąca",
	    LblDayOfWeek: "Dzień tygodnia",
	    LblSelectDayOfWeek: "Wybierz dzień tygodnia",
	    LblInstanceLogo: "Logo platformy",
	    LblInvoiceDeleteValidation: "Nie można usunąć faktury z powodu powiązania z innym podmiotem",
	    //SubscriptionAvailabilityRestriction
	    LblSubscriptionAvailabilityRestriction: "Ograniczenie dostępności subskrypcji",
	    LblStartDay: "Dzień rozpoczęcia",
	    LblEndDay: "Dzień zakończenia",
	    LblStartTime: "Godzina rozpoczęcia (hh:mm)",
	    LblEndTime: "Czas zakończenia (hh:mm)",
	    LblRestriction: "Ograniczenie",
	    LblTotalFreeKilometer: "Liczba darmowych kilometrów",
	    LblTotalFreeMinute: "Liczba darmowych minut",
	    LblCurRemainFreeKilometer: "Pozostałe darmowe kilometry",
	    LblPrevRemainFreeKilometer: "Poprzednie pozostałe darmowe kilometry",
	    LblCurRemainFreeMinute: "Pozostałe darmowe minuty",
	    LblPrevRemainFreeMinute: "Poprzednie pozostałe darmowe minuty",
	    LblResetPasswordFailure: "Hasło nie może zostać zresetowane, ponieważ użytkownik nie jest jeszcze aktywowany.",
	    //Additional Free Item
	    LblAdditionalFreeItems: "Dodatkowe darmowe kredyty",
	    LblDateAwared: "Data przyznania",
	    LblAdditionalFreeItemsMenu: "Dodatkowe darmowe kredyty",
	    LblPrevious: "Poprzedni",
	    LblCurrent: "Bieżący",
	    LblTripDetailReport: "Raport szczegółowy z podróży",
	    LblTripDetailList: "Szczegółowy przegląd rezerwacji",
	    LblSearchTripforDriver: "Wyszukaj rezerwację podróży kierowcy",
	    LblExportReport: "Eksportuj raport",
	    LblValidateLiceanceNumberMessage: "Proszę potwierdzić swój numer licencji",
	    LblBookingIntervalRate: "Stawka za interwał",
	    LblPerHour: "Za godzinę",
	    LblPerBookingIntarval: "Za interwał rezerwacji",
	    LblTimeRate: "Czas trwania rezerwacji",
	    LblToalBookingDuration: "Czas trwania rezerwacji",
	    LblTripComments: "Komentarz do podróży",
	    LblTripCommentDescription: "Wpisz komentarz do podróży",
	    LblTripCommentError: "Proszę wpisać komentarz do podróży",
	    LblShowTripComment: "Zobacz komentarz",
	    LblAddTripComment: "Dodaj komentarz",
	    LblTripCommentBy: "Komentarz do pordóży napisany przez",
	    LblTripCommentOn: "Komentarz do wycieczki op",
	    LblCleanRequire: "Wymagane czyszczenie",
	    LblFualRequire: "Wymagane paliwo",
	    LblVehicleDamageList: "Lista uszkodzeń pojazdu",
	    LblDamageCause: "Uszkodzenie Przyczyna",
	    LblDamageReportedBy: "Zgłoszone przez",
	    LblDamageReportedOn: "Zgłoszona w dniu",
	    LblConfirmResolveDamage: "Czy na pewno chcesz zlikwidować szkodę w pojeździe?",
	    LblVehicleDamgeResolveSuccess: "Uszkodzenie pojazdu zostało pomyślnie rozwiązane",
	    LblDamageDesc: "Opis szkody",
	    LblFutureBooking: "Przyszłe rezerwacje",
	    LblVehFutureBookingList: "Lista przyszłych rezerwacji pojazdu",
	    LblResolveDamge: "Usunięcie szkody",
	    LblReserved: "Zarezerwowane",
	    LblVehicleInfoSuccess: "Udana aktualizacja informacji o pojeździe",
	    LblInformation: "Informacje",
	    LblVTSHistory: "Historia zdarzeń VTS",
	    LblWegoRequestTime: "Czas żądania WeGo",
	    LblVTSRequestTime: "Czas żądania VTS",
	    LblRequestType: "Typ wniosku",
	    LblWegoProcessTime: "Czas procesu Wego",
	    LblResult: "Wynik",
	    LblWegoResultTime: "Czas wyniku WeGo",
	    LblVTSResultTime: "Czas wyniku VTS",
	    LblCommandInitiator: "Inicjator polecenia",
	    LblTroubleShootVTS: "VTS Troubleshoot",
	    LblVtsServiceStatus: "Status usługi VTS",
	    LblVtsLicencetag: "Znacznik licencji VTS",
	    LblVtsDoorStatus: "Status drzwi",
	    LblVtsIssueCommand: "Wydaj Polecenie",
	    LblVehicleLocation: "Lokalizacja pojazdu",
	    LblEventHistory: "Historia zdarzeń VTS",
	    LblView: "Zobacz",
	    LblVehicleObuStatus: "Status OBU Pojazdu",
	    LblVehicleNotInitialized: "Brak inicjalizacji pojazdu",
	    LblLastReceivedTime: "Czas ostatniego otrzymanego komunikatu",
	    LblFreePerBookingInterval: "Według przedziału rezerwacji",
	    LblSelectFilter: "Wybierz filtr",
	    LblAuditEntries: "Kontrola wpisów",
	    LblFilter: "Filtr",
	    LblCategory: "Kategoria",
	    LblEventName: "Nazwa zdarzenia",
	    LblEventData: "Dane zdarzenia",
	    LblMoment: "Moment",
	    LblUser: "Użytkownik",
	    LblNoEventDataFound: "Nie znaleziono danych o zdarzeniu",
	    LblEventViewer: "Przeglądarka zdarzeń",
	    LblSelectObuType: "Wybierz typ urządzenia OBU",
	    LblObuType: "Typ OBU",
	    LblDeviceId: "Id urządzenia",
	    LblClaimCode: "Kod roszczenia",
	    LblVtsLocation: "Lokalizacja VTS",
	    LblRetriveAddress: "Pobierz adres",
	    LblCrearedDate: "Data utworzenia",
	    LblCreatedBy: "Utworzony przez",
	    LblPerBooking: "Per booking",
	    LblOBU: "OBU",
	    LblClone: "Sklonuj",
	    LblCloneVehicle: "Sklonuj %0",
	    LblFualNotRequire: "Paliwo niewymagane",
	    LblCleanNotRequire: "Czyszczenie niewymagane",
	    LblSubscriptionInfo: "Informacje o subskrypcji",
	    LblVehiclDamaged: "Pojazd uszkodzony",
	    LblVehicleNotDamaged: "Pojazd nie uszkodzony",
	    LblDamage: "Uszkodzony",
	    LblFreeBooking: "Dostosuj koszt rezerwacji",
	    LblBookingCustomFee: "Niestandardowy koszt rezerwacji",
	    LblFreeBookingSuccess: "Koszty rezerwacji zapisane pomyślnie",
	    LblEnterLocation: "Wprowadź lokalizację",
	    LblHomeLocation: "Lokalizacja domowa",
	    LblLocationMode: "Tryb lokalizacji",
	    LblMeter: "Metr",
	    LblLocation: "Lokalizacja",
	    LblPickupLocation: "Lokalizacja odbioru",
	    LblLocationUnavailable: "Lokalizacja niedostępna",
	    LblAvailabilityCalander: "Kalendarz dostępności",
	    LblAvailableOn: "Dostępny na",
	    LblGeofenceEnabled: "Geofence włączone",
	    LblLocationNotFound: "Nie można ustalić adresu",
	    LblAddressNotAvailable: "Nie można ustalić adresu w tej lokalizacji",
	    LblReports: "Raporty",
	    LblDrivers: "Kierowcy",
	    LblTemplates: "Szablony",
	    LblVehicleOccupancyReport: "Raport o zajętości pojazdu",
	    LblPlaceHolder: "Przykładowy tekst",
	    LblSampleTemplate: "Przykładowy szablon",
	    LblLatexFileDownloadValidation: "Nieważna zawartość lateksu",
	    LblLocationDataExchangeNotAssign: "Ten pojazd nie może być zarezerwowany, gdy nie jest do niego przypisany żaden pojazd VTS. Czy chcesz kontynuować?",
	    LblReservedTime: "Zarezerwowany czas",
	    LblUsageTime: "Czas użytkowania",
	    LblUsageTimeAtOffice: "Czas użytkowania w godzinach pracy",
	    LblUsageTimeoutOffice: "Czas użytkowania poza godzinami pracy",
	    LblRevenue: "Dochód",
	    LblRevenuePerVehicleReport: "Raport o przychodach z pojazdu",
	    LblSearchRevenuePerVehicle: "Wyszukaj przychód na pojazd",
	    LblRevenuePerVehicleList: "Dochód za pojazd Lista",
	    //Dashboard
	    LblInuse: "W użyciu",
	    LblPriority: "Priorytet",
	    LblDefaultStatus: "Domyślny status",
	    //OdometerLogTrail
	    LblOdometerLogTrail: "Ścieżka dziennika licznika kilometrów",
	    LblUserProvidedOdometerValueInKmr: "Wartość licznika kilometrów (km)",
	    LblDescriptionOfDeviation: "Opis odchylenia",
	    LblFromOdometer: "Od licznika",
	    LblToOdometer: "Do licznika",
	    LblAddDescriptionOfDeviation: "Dodaj opis odchylenia",
	    LblDeviation: "Odchylenie (km)",
	    LblLastOdometerValue: "Poprzednia wartość licznika kilometrów (km)",
	    LblLastOdometerDT: "Data poprzedniego stanu licznika",
	    LblOdometerRegistered: "Zarejestrowany licznik kilometrów",
	    LblOdometerValue: "Wartość licznika",
	    LblMaintenancePlanningList: "Lista planowania konserwacji",
	    LblSearchMaintenancePlanningValue: "Wyszukiwanie planów konserwacji",
	    LblMaintenancePlanningreport: "Raport z planowania konserwacji",
	    LblodometerConfiguration: "Konfiguracja licznika kilometrów",
	    LbLOdometerEnabled: "Licznik włączony",
	    LblEnableOnApp: "Włącz w aplikacji",
	    LblWarningPer: "Ostrzeżenie (%)",
	    LblShowDeviation: "Pokaż odchylenie, które wymaga wyjaśnienia",
	    LblTitle: "Tytuł",
	    LblFooterText: "Tekst stopki",
	    LblvalidEmailDomain: "Zezwalaj tylko na adresy e-mail z następującej domeny",
	    LblURLSettings: "Ustawienia URL",
	    LblSuccessUrl: "Success URL",
	    LblEmailSettings: "Ustawienia e-mail",
	    LblSendActivationEmail: "Włącz automatyczną aktywację e-maili",
	    LblSendConfirmationEmail: "Włącz maile potwierdzające rejestrację",
	    LblRequireAdminApprovel: "Wymagaj zatwierdzenia przez administratora nowych zapisów",
	    LblDriverInformationToBeInclude: "Informacje o kierowcy, które mają być zawarte w formularzu (wszystkie wymagane pola)",
	    LblSignUpForm: "Formularz rejestracji",
	    LblSignupForms: "Formularze rejestracji",
	    LblSignupFormsOverview: "Przegląd formularzy zapisu",
	    LblWhoCanApprove: "Kto może zatwierdzać nowe zapisy?",
	    LblSignupFormLogo: "Logo formularza zapisu",
	    LblChooseSubscription: "Wybierz subskrypcję(y) dostępną dla formularza zapisu",
	    LblSignupParameter: "Adres URL rejestracji",
	    LblSignupParameterText: "Tekst adresu URL rejestracji",
	    DomainNameString: "Nazwa domeny oddzielona przecinkami (jak gmail.com, yahoo.com)",
	    SignupParameterString: "Tylko litery, cyfry i - są dozwolone",
	    LblAvailability: "Dostępność",
	    LblSettings: "Ustawienia",
	    LblCurrentStatus: "Aktualny status",
	    LblFlags: "Flagi",
	    LblNA: "NA",
	    //Sign up form
	    LblConfirmEmail: "Potwierdź e-mail",
	    LblSignup: "Zarejestruj się",
	    LblSignupsOverView: "Przegląd rejestracji",
	    LblSignupApproval: "Zatwierdzenie rejestracji",
	    LblAccept: "Zaakceptuj",
	    LblSignupFormDescription: "Opis formularza rejestracji",
	    LblCurrentOdometerValue: "Aktualna wartość licznika kilometrów",
	    LblCurrentOdometerDateTime: "Bieżąca data/godzina licznika kilometrów",
	    LblCreateDirectDebitFile: "Tworzenie pliku polecenia zapłaty",
	    LblCheckEmptyIbanNumber: "Sprawdź numery IBAN",
	    LblCreatedDate: "Data utworzenia",
	    LblIncludeInDirectDebit: "Włączenie do pliku polecenia zapłaty",
	    LblDirectDebitFileDate: "Data pliku polecenia zapłaty",
	    LblDirectDebitConfiguration: "Konfiguracja poleceń zapłaty",
	    LbLDirectDebitEnabled: "Włączenie generowania pliku poleceń zapłaty",
	    LblDirectDebitEnableper: "Włączenie pliku poleceń zapłaty na",
	    LbLCreditorDetails: "Szczegóły wierzyciela",
	    LblAddress: "Adres",
	    LblIBANNumber: "IBAN",
	    LblCountryCode: "Kod kraju",
	    LbLBillingInformation: "Informacje o rozliczeniach",
	    LblFormat: "Format",
	    LblInvoicingDetails: "Szczegóły fakturowania",
	    LbLSubjectToDirectDebit: "Czy podlega poleceniu zapłaty?",
	    //Person Upload Batch
	    LblBatchUploadPersonSetting: "Import wsadowy Ustawienie osoby",
	    LblShowBatchUploadInfo: "Zezwól na import wsadowy osoby",
	    LblAllowBatchUpload: "Pozwól na import dla",
	    LblAllowActivationMail: "Użyj e-maili aktywacyjnych",
	    LblGenerateRandomPassword: "System generuje hasła",
	    LblUserUploadPassword: "Importuj hasła",
	    LblFieldToUploadedOrValidated: "Pola w pliku importowym",
	    LblBatchUploadPerson: "Wczytaj osobę",
	    LblBatchUpload: "Wysyłaj osoby",
	    LblImportDriverRole: "Przypisać automatycznie rolę kierowcy?",
	    LblAssignToSVG: "Przypisanie do wspólnej grupy (grup) pojazdów",
	    LblSVG: "Grupa wspólnych pojazdów",
	    LblDownloadTemplate: "Przykład pliku importowego",
	    LblUserAssignSVGMessage: "Użytkownik nie jest jeszcze przypisany do wspólnej grupy pojazdów!",
	    LblInvalidRecordReason: "Nieważny rekord(y)",
	    LblSelectedSVGs: "Wybrane SVG",
	    LblDashboard: "Dashboard",
	    LblGroupAdmin: "Administrator grupy",
	    LblDashboardConfiguration: "Konfiguracja Dashboardu",
	    LblCurrentLocation: "Bieżąca lokalizacja",
	    LblEnableCurrentLocation: "Włącz bieżącą lokalizację",
	    LblDefaultLocation: "Domyślna lokalizacja",
	    LblEnableAutoUpdate: "Włącz automatyczną aktualizację",
	    LblPriorityNotificationSetting: "Ustawienia powiadomień o stanie pojazdu",
	    LblCollectionDate: "Data odbioru polecenia zapłaty",
	    LblBICCode: "Kod BIC",
	    LblDirectDebitFile: "Plik polecenia zapłaty",
	    LblMissingIBANNumber: "Brakujący numer IBAN",
	    LblCurrentDriver: "Aktualny kierowca",
	    LblNextDriver: "Następny kierowca",
	    LblSecond: "Sekundy",
	    LblCleaning: "Czyszczenie",
	    LblRefueling: "Tankowanie/ładowanie",
	    LblAPKMaintenance: "Konserwacja okresowa",
	    LblOutsideGeofence: "Poza geofence",
	    LblNotBooked: "Nie zarezerwowany",
	    LblNotBookedSince: "Nie zarezerwowane od",
	    LblLowBattery: "Niski poziom baterii",
	    LblBatteryVolt: "V.",
	    LblLowCharge: "Niski poziom naładowania",
	    LblChargingPercentage: "%",
	    LblOnSamePosition: "Na tej samej pozycji",
	    LblLastPosition: "Ostatnia pozycja",
	    LblNotReturn: "Nie wraca",
	    LblCommunicationProblem: "Problem z komunikacją",
	    LblDirectDebitDownloadSuccess: "Plik polecenia zapłaty pobrany",
	    LblWarnings: "Ostrzeżenia",
	    LblDirectDebitFileId: "Plik polecenia zapłaty Id",
	    LblTotalAmount: "Całkowita kwota",
	    LblReCreate: "Pobierz ponownie",
	    LblPleaseEnterCollectionDate: "Proszę wprowadzić datę pobrania",
	    LblOpenViaLowLevel: "Otwarte przez niski poziom",
	    LblInstanceNotificationNote1: "Ustawienie działa zgodnie z ustawieniami dla firmy",
	    LblNoInvoiceSelected: "Brak wybranych faktur do pliku polecenia zapłaty",
	    LblIBANNumberRequired: "Proszę wprowadzić IBAN i BIC",
	    LblNoEmptyIBANFound: "Nie znaleziono pustego numeru IBAN",
	    LblInvalidTagUsed: "Użyto nieważnego znacznika",
	    LblNotInvalidTagUsed: "Nie użyto nieważnego znacznika",
	    LblShowVehicleChargeLevel: "Pokazać poziom doładowania pojazdu w aplikacji internetowej i mobilnej?",
	    LblChargeLevel: "Poziom naładowania",
	    LblCharging: "Ładowanie",
	    LblNoDataFound: "Brak dostępnych danych",
	    LblOfficeStartTime: "Godziny urzędowania Godzina rozpoczęcia (hh:mm)",
	    LblOfficeEndTime: "Godzina zakończenia pracy biura (hh:mm)",
	    //Reports
	    LblTripDataReport: "Raport danych o podróży",
	    LblByDriver: "Według kierowcy",
	    LblByVehicle: "Według pojazdu",
	    LblModuleRights: "Uprawnienia Modułu",
	    LblByOrganization: "Według organizacji",
	    //Organization
	    LblOrganization: "Organizacja",
	    LblOrganizationName: "Nazwa organizacji",
	    LblExistingDriverAddSuccessMsg: "Kierowca został dodany i pomyślnie powiązany z organizacją.",
	    LblAddDriverSuccessMsg: "Kierowca został dodany, a link aktywacyjny do tego kierowcy został wysłany z powodzeniem.",
	    LblOrganizationAddress: "Adres organizacji",
	    LblCreateOrganization: "Utwórz organizację",
	    LblAddDriverToOrganization: "Dodaj kierowcę do organizacji",
	    LblAddDriver: "Dodaj kierowcę",
	    LblOrganizationDriversList: "Kierowca organizacji",
	    // Branding
	    LblBranding: "Branding",
	    LblLogo: "Logo",
	    LblEmailNotificationInvoiceTemplate: "Powiadomienia e-mail i szablony faktur",
	    LblExpandedWebMenu: "Rozwinięte menu aplikacji internetowej",
	    LblCollapsedWebMenu: "Zwinięte menu aplikacji internetowej",
	    LblMobileApp: "Aplikacja mobilna",
	    LblSplashScreen: "Splash screen",
	    LblWebApplication: "Aplikacja internetowa",
	    LblMobileApplication: "Aplikacja mobilna",
	    LblBrandingSavedSuccess: "Branding zapisany pomyślnie",
	    LblBrandingTemplateConfiguration: "Konfiguracja marki i szablonu",
	    LblAppWebUI: "Aplikacja i Web UI",
	    LblNonBookingCommunication: "Komunikacja niezwiązana z rezerwacją",
	    LblBookingCommunication: "Komunikacja związana z rezerwacją",
	    LblInstanceBranding: "Zawsze używaj marki instancji",
	    LblCompanyBranding: "W miarę możliwości używaj brandingu firmy",
	    BO_TOP_MENU_ACTIVE_ITEM_BACKGROUND: "Górny pasek, menu i aktywne elementy",
	    BO_TOP_MENU_ACTIVE_ITEM_TEXT: "Tekst menu",
	    BO_HIGHLIGHTED_BUTTON_BACKGROUND: "Podświetlony przycisk",
	    BO_HIGHLIGHTED_BUTTON_TEXT: "Podświetlony tekst przycisku",
	    BO_HIGHLIGHTED_BUTTON_BACKGROUND_HOVER: "Podświetlony przycisk (hover)",
	    BO_HIGHLIGHTED_BUTTON_TEXT_HOVER: "Podświetlony tekst przycisku (hover)",
	    BO_PRIMARY_BUTTON_BACKGROUND: "Przycisk główny",
	    BO_PRIMARY_BUTTON_TEXT: "Tekst przycisku głównego",
	    BO_PRIMARY_BUTTON_BACKGROUND_HOVER: "Przycisk główny (hover)",
	    BO_PRIMARY_BUTTON_TEXT_HOVER: "Tekst przycisku podstawowego (hover)",
	    BO_SECONDARY_BUTTON_BACKGROUND: "Przycisk dodatkowy",
	    BO_SECONDARY_BUTTON_TEXT: "Tekst przycisku dodatkowego",
	    BO_SECONDARY_BUTTON_BACKGROUND_HOVER: "Przycisk dodatkowy (wysunięcie)",
	    BO_SECONDARY_BUTTON_TEXT_HOVER: "Tekst drugiego przycisku (hover)",
	    BO_HYPERLINK_TEXT: "Tekst hiperłącza",
	    BO_HIGHLIGHT_BACKGROUND: "Kolor podświetlenia",
	    BO_HIGHLIGHT_TEXT: "Tekst podświetlenia",
	    BO_CALENDAR_EVENT_BACKGROUND: "Wydarzenia z kalendarza",
	    BO_CALENDAR_EVENT_TEXT: "Tekst wydarzeń kalendarza",
	    MO_TOP_MENU_ACTIVE_ITEM_BACKGROUND: "Górny pasek i menu",
	    MO_LOGO_AREA_BACKGROUND: "Tło obszaru logo",
	    MO_PAGE_BACKGROUND: "Tło",
	    MO_MENU_TEXT: "Tekst menu",
	    MO_TITLE_TEXT: "Tekst tytułu",
	    MO_HYPERLINK_TEXT: "Tekst hiperłącza",
	    MO_ENABLED_BUTTON_BACKGROUND: "Przycisk włączony",
	    MO_ENABLED_BUTTON_TEXT: "Tekst przycisku aktywnego",
	    MO_ENABLED_BUTTON_BACKGROUND_ACTIVE: "Aktywny przycisk (aktywny)",
	    MO_ENABLED_BUTTON_TEXT_ACTIVE: "Tekst aktywnego przycisku (aktywny)",
	    MO_DISABLED_BUTTON_BACKGROUND: "Wyłączony przycisk",
	    MO_DISABLED_BUTTON_TEXT: "Tekst wyłączonego przycisku",
	    MO_DISABLED_BUTTON_BACKGROUND_ACTIVE: "Wyłączony przycisk (aktywny)",
	    MO_DISABLED_BUTTON_TEXT_ACTIVE: "Tekst wyłączonego przycisku (aktywny)",
	    MO_HIGHLIGHT_BACKGROUND: "Kolor podświetlenia",
	    MO_HIGHLIGHT_TEXT: "Tekst podświetlenia",
	    MO_CALENDAR_EVENT_BACKGROUND: "Wydarzenia z kalendarza",
	    MO_CALENDAR_EVENT_TEXT: "Tekst wydarzeń z kalendarza",
	    LblBookingDelayConfig: "Konfiguracja opóźnienia rezerwacji",
	    LblBookingDelayConfigEnabled: "Wyślij wiadomość e-mail do administratora",
	    LblEnableSnauilTrail: "Włącz wizualizację trasy",
	    LblAppSupportTo: "Obsługa aplikacji do",
	    LblNotificationInterval: "Częstotliwość powiadomień",
	    LblNotifyAfterMinutes: 'Powiadom po X" minutach"',
	    LblMinutesAfterBookingEndTime: "Ile minut po planowanym czasie zakończenia rezerwacji?",
	    LblResendNotoficationEvery: "Wysyłaj ponownie powiadomienie co minutę(y)",
	    LblMinutes: "Minuty",
	    lblNotificationRecipients: "Odbiorcy powiadomień",
	    LbLEnableBookingStillRunning: "Włącz powiadomienie o wciąż trwającej rezerwacji",
	    LblBookingrunningNotification: "Konfiguracja powiadomienia o wciąż trwającej rezerwacji",
	    LblPreferableImageSize: "Preferowany rozmiar obrazu",
	    LblWebBrandingExapandImageSize: "1150px X 260px",
	    LblMobileBrandingImageSize: "550px X 250px",
	    LblWebBrandingCollapseImageSize: "325px X 250px",
	    //MobileApp Configuration
	    LblMobileAppConfiguration: "Konfiguracja aplikacji mobilnej",
	    LblEnableNewBooking: "Włącz nową rezerwację",
	    LblEnableBookingCalender: "Włącz kalendarz rezerwacji",
	    LblEnableSubscription: "Włącz subskrypcję",
	    LblEnableUpdateProfile: "Włącz aktualizację profilu",
	    LblEnableNotification: "Włącz powiadomienie",
	    LblEnableChangeBooking: "Włącz zmianę rezerwacji",
	    LblEnableAddExpenseMenu: "Włącz menu dodawania wydatków",
	    //Raise and clear settings for low battery flag
	    LblDefaultVehicleSetting: "Domyślne ustawienia pojazdu",
	    LblLowBatteryFlagRaised: "Flaga niskiego poziomu naładowania akumulatora jest podniesiona przy (napięcie)",
	    LblLowBatteryFlagClear: "Flaga niskiego poziomu naładowania akumulatora jest kasowana przy (napięcie)",
	    LblByBooking: "Przez rezerwację",
	    LblSnailTrailReport: "Raport z wizualizacją trasy",
	    LblKickbackReport: "Raport Kickback",
	    LblGroupBy: "Grupa według",
	    LblTripDetail: "Szczegóły podróży",
	    LblTripNumber: "Nr wycieczki",
	    LblStart: "Start",
	    LblAverageSpeed: "Średnia prędkość Prędkość",
	    LblSegmentDetail: "Szczegółowy segment",
	    LblSegmentNumber: "Segment nr",
	    LblSpeed: "Prędkość",
	    LblOdometer: "Licznik kilometrów",
	    LblNext: "Następny",
	    LblSegmentDetailNotAvailable: "Szczegóły segmentu niedostępne",
	    LblUnitPerKm: "na km.",
	    LblUnitPerBooking: "p/bk",
	    LblBookingCostSummary: "Podsumowanie kosztów rezerwacji",
	    LblTimeCost: "Czas Koszt",
	    LblTotalTime: "Czas całkowity",
	    LblCostRateUnits: "Koszt (kwota * stawka)",
	    LblFreeTime: "Czas wolny",
	    LblRate: "Stawka",
	    LblExVat: "Wył. VAT",
	    LblInclVat: "Wł. VAT",
	    LblKmDriven: "Przejechane kilometry",
	    LblFreeKms: "Bezpłatne km",
	    LblTimePercent: "Czas procent",
	    LblTotalExVat: "Razem bez VAT",
	    LblTotalVat: "Razem VAT",
	    LblTotalInclVat: "Razem z VAT",
	    LblKilometerCost: "Koszt kilometra",
	    LblFixedCost: "Koszt stały",
	    LblTotals: "Razem",
	    LblTypeDamage: "Uszkodzenia",
	    LblTypeMaintenance: "Należny przegląd okresowy",
	    LblTypeOnSamePosition: "Pojazd w tym samym miejscu przez ponad %0 %1",
	    LblTypeNotBooked: "Pojazd nie był zarezerwowany przez więcej niż %0 %1",
	    LblTypeNotReturn: "Upłynął czas rezerwacji i pojazdu nie ma w miejscu zamieszkania",
	    LblBatteryVoltage: "Napięcie akumulatora",
	    LblCannotUnsubscribe: "Nie można teraz wypisać, ponieważ ten użytkownik ma trwającą rezerwację",
	    LblPer: "Za",
	    LblDateRegistered: "Data rejestracji",
	    LblRegisteredBy: "Zarejestrowany przez",
	    LblKMPerHour: "Km/h",
	    LblMeters: "Metry",
	    LblSubscriptionEndOnBookingEnd: "Rezerwacja jest nadal prowadzona dla tego abonamentu. Kierowca zostanie wypisany po zakończeniu rezerwacji.",
	    LblMarkedForDeletion: "Oznaczony do usunięcia",
	    LblApplyDateFilter: "Data zastosowania",
	    LblNoRestriction: "NO_RESTRICTION",
	    LblCustomAppTestApp: "CUSTOM_APP_AND_TEST_APP",
	    LblCustomAppOnly: "CUSTOM_APP_ONLY",
	    //Customer
	    LblCustomer: "Klient",
	    LblCustomerName: "Nazwa klienta",
	    //Role Page
	    LblRoleManagement: "Rola",
	    LblRoleName: "Nazwa roli",
	    LblEntityName: "Nazwa podmiotu",
	    LblRoleType: "Typ roli",
	    LblRoleAvailability: "Dostępność roli klienta",
	    LblInternalRoleName: "Nazwa roli wewnętrznej",
	    LblPresentationName: "Nazwa prezentacji",
	    LblDefaultRole: "Rola domyślna",
	    LblCustomRole: "Rola niestandardowa",
	    LblAddRole: "Dodaj rolę",
	    LblEntity: "Podmiot",
	    LblCopy: "Kopiuj",
	    LblAccessibilityMatrix: "Matryca dostępności",
	    LblDefaultRoleModifyWarning: "Modyfikacja domyślnych uprawnień będzie miała wpływ na wszystkich użytkowników, którzy mają domyślną rolę",
	    LblCopyAccessibilityMatrix: "Kopiuj matrycę dostępności",
	    LblAccess: "Dostęp",
	    LblCustomerAdmin: "Klient Administrator",
	    LblAdmin: "Administrator",
	    LblDoYouWantToRemove: "Czy chcesz usunąć %0 jako %1?",
	    LblDoYouWantToAdd: "Czy chcesz zrobić %0 jako %1?",
	    LblRoleAddedSuccess: "%0 dodano do %1 pomyślnie.",
	    LblRoleDeletedSuccess: "%0 usunięto z %1 z powodzeniem.",
	    LblInstanceAdmin: "Instance Admin",
	    LblInvitationMailSuccess: "Mail z zaproszeniem został wysłany na podany adres e-mail.",
	    LblInvite: "Wyślij zaproszenie",
	    LblCreateNew: "Utwórz nową",
	    LblCommonErrorMessage: "Serwer napotkał błąd podczas przetwarzania żądania. Prosimy o kontakt z administratorem.",
	    LblError: "Błąd",
	    LblThankYouForAcceptingInvitation: "Dziękujemy za przyjęcie zaproszenia",
	    LblPleaseClick: "Proszę kliknąć",
	    LblHere: "tutaj",
	    LblToLogin: "aby się zalogować",
	    LblThankYouForConfirmation: "Dziękujemy za potwierdzenie.",
	    LblGoToHome: "przejdź do strony głównej.",
	    LblInvitationSuccess: "Zaproszenie Udane",
	    LblInvitationReject: "Odrzucenie zaproszenia",
	    //
	    LblAssignExisting: "Przypisz istniejące",
	    LblPersonProfileSuccessMessage: "Twój profil został pomyślnie aktywowany.",
	    LblPlease: "Proszę",
	    LblLogin: "Zaloguj się",
	    //Organization
	    LblVatNumber: "Numer VAT",
	    //Branding & Template
	    LblBrandingandTemplates: "Branding i szablony",
	    LblTermsAndCondition: "Zasady i warunki",
	    LblTermsAndConditionList: "Lista oświadczeń o ochronie danych osobowych",
	    LblName: "Nazwa",
	    LblVersion: "Wersja",
	    LblAcceptance1: "Przed aktywacją konta",
	    LblAcceptanceMoment: "Moment akceptacji",
	    LblContents: "Treść",
	    LblIsAccept: "Akceptuję",
	    LblReadAndAgree: "Przeczytałem i zgadzam się z",
	    LblClose: "Zamknij",
	    LblTermsConditionPrivacy: "OWU i Oświadczenie o ochronie prywatności",
	    LblPrivacyStatements: "Oświadczenie o ochronie prywatności",
	    //Pre Post Trip Setting
	    LblPrePostTripSetting: "Ustawienia pytań przed i po podróży",
	    LblPrePostTripQuestion: "Pytanie przed i po podróży",
	    LblPrePostTripQuestionList: "Lista pytań przed i po podróży",
	    LblPreTripQuestion: "Pytania przed podróżą",
	    LblCustom: "Własna strona",
	    LblPostTripQuestion: "Pytania po podróży",
	    LblRequired: "Wymagane",
	    LblBeforeOpeningTheVehicle: "Przed otwarciem pojazdu",
	    LblAfterOpeningTheVehicle: "Po otwarciu pojazdu",
	    LblOrder: "Zamówienie",
	    LblQuestion: "Pytanie",
	    LblOn: "Na stronie",
	    LblOptional: "Opcjonalnie",
	    LblOff: "Wyłączone",
	    LblAnswerType: "Typ odpowiedzi",
	    LblText: "Tekst",
	    LblYesNo: "Tak/Nie",
	    LblAnswer: "Odpowiedź",
	    LblTimeStamp: "Znacznik czasu",
	    LblFazTripQuestion: "Pytania FaZ",
	    LblFazTripQuestionAfterClosingTheVehicle: "Pytania FaZ po zamknięciu pojazdu",
	    //Accessibility Matrix
	    LG_WEB_DASHBOARD: "Pulpit nawigacyjny",
	    PR_BOOKING_REQUEST: "Wniosek o rezerwację",
	    LblApproveBookingRequest: "Zatwierdź",
	    LblRejectBookingRequest: "Odrzuć",
	    PR_DASHBOARD: "Deska rozdzielcza",
	    PR_REMOVE_DRIVER_LICENSE: "Usuń prawo jazdy",
	    PR_VEHICLE_FUTURE_BOOKINGS: "Przyszłe rezerwacje pojazdu",
	    PR_INSTANCE: "Instancja",
	    PR_BRANDING: "Branding",
	    PR_PERSON_OVERVIEW: "Przegląd osób",
	    PR_WEGO_ADMINS: "Wego Admins",
	    PR_COMPANY_OVERVIEW: "Przegląd firmy",
	    PR_CONTACT_PERSON: "Osoba kontaktowa",
	    PR_COMPANY_ADMIN: "Administrator firmy",
	    PR_COMPANY_VEHICLE_OVERVIEW: "Przegląd pojazdów",
	    PR_COMPANY_SVG_OVERVIEW: "Przegląd SVG firmy",
	    PR_ORGANIZATION_OVERVIEW: "Przegląd organizacji",
	    PR_ORGANIZATION_CONTACT_PERSON: "Osoba Kontaktowa Organizacji",
	    PR_ORGANIZATION_ADMIN_OVERVIEW: "Przegląd Administratorów Organizacji",
	    PR_ORGANIZATION_DRIVER_OVERVIEW: "Przegląd Kierowców Organizacji",
	    PR_SHARED_VEHICLE_GROUP_OVERVIEW: "Przegląd grupy współdzielonych pojazdów",
	    PR_SHARED_VEHICLE_GROUP_ADMIN_OVERVIEW: "Przegląd administratora grupy współdzielonych pojazdów",
	    PR_SHARED_VEHICLE_GROUP_VEHICLE_OVERVIEW: "Grupa współdzielonych pojazdów Przegląd pojazdów",
	    PR_SHARED_VEHICLE_GROUP_DRIVER_OVERVIEW: "Przegląd kierowców grupy współdzielonych pojazdów",
	    PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_GROUP_OVERVIEW: "Przegląd grupy pojazdów Grupa typu umowy",
	    PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_OVERVIEW: "Przegląd Grupy Pojazdów Typ Umowy",
	    PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW: "Przegląd grupy pojazdów - abonament",
	    PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_AVAILIBILTY_RESTRICTION_OVERVIEW: "Przegląd ograniczeń dostępności abonamentu dla grupy współdzielonych pojazdów",
	    PR_SPECIAL_PERIODS: "Okresy specjalne",
	    PR_VEHICLES_OVERVIEW: "Przegląd pojazdów",
	    PR_VEHICLE_SVG_OVERVIEW: "Przegląd pojazdów SVG",
	    PR_VTS_VEHICLE_LIST: "Lista pojazdów VTS",
	    PR_VTS_TROUBLESHOOT: "Rozwiązywanie problemów VTS",
	    PR_VEHICLE_ATTRIBUTE_CATEGORIES: "Kategorie atrybutów pojazdu",
	    PR_VEHICLE_ATTRIBUTE: "Atrybut pojazdu",
	    PR_ODOMETER_LOG_TRAIL: "Ścieżka dziennika pomiaru",
	    PR_ODOMETER_LOG_TRAIL_REGISTERED_BY: "Ślad licznika kilometrów zarejestrowany przez",
	    PR_DRIVER_OVERVIEW: "Kierowca Przegląd",
	    PR_DRIVER_SHARED_VEHICLE_GROUP_OVERVIEW: "Przegląd grupy pojazdów współdzielonych przez kierowcę",
	    PR_DRIVER_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW: "Przegląd abonamentów Grupy Pojazdów Współdzielonych przez Kierowcę",
	    PR_BOOKINGS_OVERVIEW: "Przegląd rezerwacji",
	    PR_PRE_POST_TRIP_QUESTIONS: "Przegląd pytań przed podróżą",
	    PR_NORMAL_BOOKING: "Nowa rezerwacja",
	    PR_SPECIAL_BOOKING: "Rezerwacja specjalna",
	    PR_TRIP_SIMULATOR: "Symulator podróży",
	    PR_INVOICE: "Faktura",
	    PR_DIRECT_DEBIT_FILE: "Plik polecenia zapłaty",
	    PR_ADDITIONAL_FREE_ITEMS: "Dodatkowe darmowe pozycje",
	    PR_TEST_INVOICE_GENERATOR: "Generator faktur testowych",
	    PR_VEHICLE_OCCUPANCY_REPORT: "Raport o zajętości pojazdu",
	    PR_REVENUE_PER_VEHICLE_REPORT: "Raport o przychodach na pojazd",
	    PR_TRIP_DATA_REPORT: "Raport danych o podróży",
	    PR_MAINTENANCE_PLANNING_REPORT: "Raport o planowaniu obsługi technicznej",
	    PR_SANIL_TRAIL_REPORT: "Raport z wizualizacją trasy",
	    PR_KICKBACK_REPORT: "Raport zwrotów akcji",
	    PR_INVOICE_PAYMENT_HISTORY: "Historia płatności faktur",
	    PR_TEMPLATES: "Szablony",
	    PR_SIGNUP_FORMS_OVERVIEW: "Przegląd formularzy rejestracji",
	    PR_SIGNUPS_OVERVIEW: "Przegląd formularzy zapisu",
	    PR_SIGNUP_OVERVIEW_TO_SIGNUP_FORM: "Przegląd rejestracji do formularza rejestracji",
	    PR_SIGNUP_OVERVIEW_TO_SHARED_VEHICLE_GROUP: "Przegląd rejestracji do grupy pojazdów współdzielonych",
	    PR_TERMS_AND_CONDITION: "Warunki i zasady",
	    PR_EVENT_VIEWER: "Przeglądarka zdarzeń",
	    PR_PRE_POST_TRIP_SETTING: "Ustawienia pytań przed podróżą",
	    PR_PREPOST_TRIP_QUESTIONS_UPDATE: "Pytania przed podróżą",
	    PR_USER_PROFILE: "Profil użytkownika",
	    LG_CUSTOMER: "Klient",
	    LG_INSTANCE: "Instancja",
	    LG_BRANDING: "Branding",
	    LG_PERSON: "Osoba",
	    LG_COMPANY: "Firma",
	    LG_ORGANIZATION: "Organizacja",
	    LG_SHARED_VEHICLE_GROUP: "Grupa pojazdów współdzielonych",
	    LG_VEHICLE: "Pojazd",
	    LG_DRIVER: "Kierowca",
	    LG_BOOKING: "Rezerwacja",
	    LG_INVOICE: "Faktura",
	    LG_REPORT: "Raport",
	    LG_TEMPLATE: "Szablon",
	    LG_SIGNUP_FORM: "Formularz zgłoszeniowy",
	    LG_EVENT_VIEWER: "Przeglądarka wydarzeń",
	    LG_PRE_POST_TRIP_SETTING: "Ustawienia pytań przed i po podróży",
	    LG_USER: "Użytkownik",
	    LG_BRANDING_AND_TEMPLATE: "Branding i szablony",
	    LG_ROLE: "Rola",
	    LG_PREPOSTTRIPQUESTION: "Pytania przed podróżą",
	    PR_CUSTOMER_ADMIN_OVERVIEW: "Przegląd funkcji Customer Admin",
	    PR_INSTANCE_ADMIN_OVERVIEW: "Przegląd administratorów instancji",
	    PR_ROLE_OVERVIEW: "Rola",
	    PR_ROLE_ASSIGN: "Przypisanie roli",
	    PR_SHARED_VEHICLE_GROUP_ACTIVE_INACTIVE: "Wspólna grupa pojazdów aktywna lub nieaktywna",
	    PR_CUSTOMER_OVERVIEW: "Klient",
	    PR_ORGANIZATION_SUBSCRIPTION_OVERVIEW: "Organizacja Przegląd subskrypcji",
	    PR_VTS_VEHICLE_EVENT_HISTORY: "Historia zdarzeń pojazdu VTS",
	    PR_BATCH_UPLOAD_PERSON: "Przesyłanie partii osób",
	    PR_IMPORT_PERSON: "Importuj osobę",
	    PR_PRE_POST_TRIP_QUESTION_UPDATE: "Pytania dotyczące podróży przed i po",
	    LG_REPORTINGTOOL: "Narzędzie do raportowania",
	    PR_BOOKING_OVERVIEW: "Przegląd rezerwacji",
	    PR_ROB_NOTIFICATIONS: "Przegląd ROB",
	    PR_MILEAGE_OVERVIEW: "Przegląd przebiegu",
	    PR_USAGE_OVERVIEW: "Liczba dni niewykorzystanych",
	    PR_POSITION_ON_MAP: "Pozycja na mapie",
	    PR_VEHICLE_ON_LOCATION_MAP: "Pojazd na miejscu",
	    PR_TRIP_OVERVIEW: "Rejestracja wycieczki",
	    PR_ALTERNATE_TRANSPORTATION: "Pojazdy zastępcze",
	    PR_AVERAGE_OVERVIEW: "Przegląd średnichi",
	    PR_PRE_POST_BOOKING_OVERVIEW: "Pytania przed/post na przegląd rezerwacji",
	    PR_HOME_LOCATIONS_OVERVIEW: "Przegląd lokalizacji pojazdów i domów SVG",
	    LblPrivacyErrorMessage: "Nie masz uprawnień do oglądania tej strony",
	    LblPrivacyNavigate: "Proszę przejść do",
	    LblPrivacyError: "Błąd prywatności",
	    LblLinkExpired: "Link wygasł",
	    LblLinkExpiredMessage: "Link stracił ważność i nie może być już używany. Proszę spróbować ponownie.",
	    LblBearer: "Bearer",
	    LblWhoBenifitFreeItem: "Kto korzysta z kredytów subskrypcyjnych?",
	    LblNoDistinction: "Domyślnie (bez rozróżnienia)",
	    LblSendInvoiceToOrganization: "Wyślij fakturę do organizacji",
	    //Vat Setting
	    LblVatSettings: "Ustawienia VAT",
	    LblVatPercentages: "Stawki VAT",
	    LblDefaultCost: "Domyślnie, pokaż i edytuj koszty",
	    LblExcludingVat: "Z wyłączeniem podatku VAT",
	    LblIncludingVat: "Z VAT",
	    LblVatEnterDescription: "Wprowadź opis",
	    LblEnterVatPercentage: "Wprowadź % VAT",
	    LblVatPercentageError: "Wprowadź prawidłową wartość procentową",
	    LblVatDescriptionError: "Proszę wpisać prawidłowy opis",
	    LblVatStartDate: "Data rozpoczęcia",
	    LblVatStartDateError: "Proszę wybrać datę rozpoczęcia",
	    LblStartDate: "Data rozpoczęcia",
	    LblVatEndDate: "Data końcowa",
	    LblVatDeleteConfirmation: "Czy na pewno chcesz ustawić datę końcową VAT?",
	    LblVatEndDateError: "Proszę wprowadzić datę końcową VAT",
	    LblVatEndDateNote: "Uwaga: Dane zostaną wyłączone od wybranej daty",
	    LblDefaultVatContractTypeGroupCost: "VAT % dla Grupy Rodzaju Umowy Koszty",
	    LblDefaultVatContractTypeCost: "VAT % dla kosztów typu umowy",
	    LblDefaultVatSubscriptionCost: "VAT % dla kosztów abonamentu",
	    LblPenaltyCost: "Koszty karne",
	    LblTimeRates: "Stawki za czas",
	    LblDistanceRates: "Stawki za odległość",
	    LblFixedRates: "Stałe stawki",
	    LblSubscriptionCost: "Koszty abonamentu",
	    LblPenaltyVat: "Opłata karna VAT",
	    LblTimeRateVat: "Stawka czasowa VAT",
	    LblMileageRateVat: "Stawka milowa VAT",
	    LblFixedFeeVat: "Stała opłata VAT",
	    LblExpenseAmountVat: "Kwota wydatków VAT",
	    // template
	    LblEmailTemplate: "Szablon e-mail",
	    LblWebTemplate: "Szablon internetowy",
	    LblEmailAddressesEntryPattern: "Adresy e-mail oddzielone przecinkami (np. ex1@ex.com, ex2@ex.com)",
	    LblNoRecipientWarning: "Brak odbiorców. Domyślnymi odbiorcami będą odbiorcy tego szablonu.",
	    LblCostAndExpenses: "Koszty i wydatki",
	    LblSender: "Nadawca",
	    LblAddressee: "Adresat",
	    LblAddLine: "Dodaj linię",
	    LblSaveInvoice: "Zapisz fakturę",
	    LblVatAmount: "Kwota VAT",
	    LblBookingId: "Id rezerwacji",
	    LblReceiptOrSuppor: "Potwierdzenie lub wsparcie",
	    LblVATPercentage: "VAT(%)",
	    LblChargeTo: "Obciążenie do",
	    LblReimburseTo: "Zwrot kosztów do",
	    LblReportedBy: "Zgłoszony przez",
	    LblReportedAmount: "Kwota zgłoszona",
	    LblApprovedAmount: "Zatwierdzona kwota",
	    LblCostType: "Rodzaj kosztów",
	    LblRecipient: "Odbiorca",
	    LblCostDetail: "Szczegóły dotyczące kosztów",
	    LblCostCenterReport: "Raport Centrum Kosztów",
	    LblShowTotalOnly: "Pokaż tylko sumę",
	    LblChamberOfCommerce: "Izba Handlowa",
	    LblInvoicingSettings: "Ustawienia fakturowania",
	    LblInvoiceSender: "Nadawca faktury",
	    LblAddExisting: "Dodaj istniejące",
	    LblReceiptOrSupport: "Pokwitowanie lub wsparcie",
	    LblManualInvoiceLine: "Ręczna linia faktury",
	    LblInvoiceLine: "Linia faktury",
	    LblInvoice: "Faktura",
	    LblInvoiceLines: "Linie faktury",
	    LblSendInvoice: "Wyślij fakturę",
	    LblInvoiceSent: "Wysłana faktura",
	    LblAddNewInvoiceLine: "Dodaj nową linię faktury",
	    LblSelectUnprocessedExpenses: "Wybierz nieprzetworzony wydatek",
	    LblSelectAtLeastOneExpense: "Proszę wybrać co najmniej jeden wydatek",
	    PR_COST_EXPENSES: "Koszty i wydatki",
	    PR_COST_CENTER_REPORT: "Raport Centrum Kosztów",
	    LblInactiveAfterDays: "Nieaktywny po (dniach)",
	    LblMarkDeleteAfterDays: "Zaznacz Usuń po (dni)",
	    LblNotifyAdminBeforeDays: "Powiadom administratora przed (dni)",
	    LblGdprSettings: "Ustawienia GDPR",
	    LblRemovalDate: "Data usunięcia",
	    LblRemovePersonOn: "Usuń osobę na",
	    LblInvoicePaymentHistory: "Historia płatności faktury",
	    LblPaymentMode: "Tryb płatności",
	    LblLogTime: "Czas logowania",
	    LblWhenOpeningAppAndRepeat: "Przy pierwszym otwarciu aplikacji i powtarzać za każdym razem",
	    LblEveryTimeOpenApp: "Przy każdym otwarciu aplikacji",
	    LblWhenMakeBooking: "Przy dokonywaniu rezerwacji",
	    LblWhenStartBooking: "Przy rozpoczynaniu rezerwacji",
	    LblWhenOpenBooking: "Przy otwieraniu pojazdu",
	    LblSelectContractTypeGroup: "Przy wyborze konkretnego typu umowy Grupa(y)",
	    LblDays: "Dni",
	    LblNewVersion: "Nowa wersja",
	    LblAction: "Działanie",
	    LblTAndCName: "Nazwa T&C",
	    LblOldVersion: "Stara wersja",
	    LblSureToRevoke: "Czy jesteś pewien, że chcesz odwołać T&C?",
	    LblNoPaymentLinkGenerated: "Nie wygenerowano linku do płatności",
	    //Payment Module
	    LblPaymentConfig: "Konfiguracja płatności",
	    LblPaymentConfigButton: "Konfiguracja płatności",
	    LblPaymentProvider: "Dostawca płatności",
	    LblCountry: "Kraj",
	    LblEmailAddress: "Adres e-mail",
	    LblAllowPaymentConfiguration: "Zezwól na konfigurację płatności",
	    LblAllowPayment: "Zezwolenie na płatność",
	    LblPaymentSetting: "Ustawienia dostawcy płatności",
	    LblEnvironment: "Środowisko",
	    LblInvoicePaymentTermDays: "Warunki płatności faktury dni",
	    LblLinkValidityDays: "Dni ważności linku",
	    LblPaymentMethods: "Metody płatności",
	    LblPaymentProviderSecretKey: "Tajny klucz PSP",
	    LblPaymentProviderUsername: "Nazwa użytkownika PSP (klucz)",
	    LblCreditCardPayment: "Płatność kartą kredytową",
	    LblInitialPayment: "Płatność początkowa",
	    LblCreateBookingPayment: "Utwórz rezerwację Płatność",
	    LblStartBookingPayment: "Rozpoczęcie Rezerwacji Płatności",
	    LblPaymentLink: "Link do płatności",
	    LblPaymentHistory: "Historia płatności",
	    LblReasonOrganization: "Powód zablokowania organizacji",
	    LblDueDateUpdateSuccess: "Termin płatności Zaktualizowano pomyślnie",
	    LblDueDateRequiredError: "Proszę wybrać termin płatności.",
	    LblDueDate: "Data płatności",
	    LblConfirmDuedatechange: "Czy na pewno chcesz zaktualizować termin płatności?",
	    LblConfirmCloseInvoice: "Czy na pewno chcesz zamknąć fakturę?",
	    LblConfirmReOpenInvoice: "Czy na pewno chcesz ponownie otworzyć fakturę?",
	    LblInvoiceOpenCloseSuccess: "Faktura %0 pomyślnie",
	    LblReOpen: "Otwórz ponownie",
	    LblClosed: "Zamknięto",
	    LblReOpenClose: "Otwórz ponownie / Zamknij",
	    PR_PAYMENT_HISTORY_LIST: "Historia płatności",
	    LblUserBlockMessage: "Blokada użytkownika Wiadomość",
	    PR_BLOCK_UNBLOCK_ORGANIZATION: "Zablokuj / Odblokuj Organizację",
	    LblReportedOn: "Zgłoszony",
	    LblCurrencyConfiguration: "Konfiguracja waluty",
	    LblNameSingular: "Nazwa pojedyncza",
	    LblNamePlural: "Nazwa Liczba mnoga",
	    //Special Period
	    LblRegularBooking: "Rezerwacja regularna",
	    LblSpecialRate: "Cena specjalna",
	    LblFirstDay: "Pierwszy dzień",
	    LblLastDay: "Ostatni dzień",
	    LblWeekEndContaining: "Weekend Zawierający",
	    LblSignBeforeAmount: "Symbol waluty przed kwotą",
	    //Credit card payment
	    LblCrediCardPayment: "Płatność kartą kredytową",
	    LblFirstBooking: "Pierwsza rezerwacja",
	    LblAllowRecurringPayment: "Autoryzacja karty kredytowej",
	    LblProceed: "Kontynuuj",
	    LblCheckAllowPayment: "Proszę zaznaczyć, aby umożliwić powtarzające się płatności.",
	    LblPaymentFailed: "Autoryzuj kartę kredytową",
	    LblPaymentSuccess: "Sukces autoryzacji",
	    LblPaymentFailure: "Niepowodzenie autoryzacji",
	    LblCompletedSuccess: "Twoja autoryzacja została przeprowadzona pomyślnie.",
	    LblCompletedFailure: "Twoja autoryzacja nie powiodła się. Proszę wrócić i spróbować ponownie.",
	    LblCreditCardNumber: "Numer karty kredytowej",
	    LblCreditCardExpirationDate: "Data ważności karty kredytowej",
	    LblCreditCardDetails: "Szczegóły karty kredytowej",
	    LblMakePayment: "Autoryzacja karty kredytowej",
	    LblAdminPaymentConfirmation: "Nie ma aktywnej autoryzacji lub potrącenie z karty nie powiodło się. Czy chcesz kontynuować?",
	    LblPaymentDescription: "Aby zarezerwować pojazd, wymagana jest płatność weryfikacyjna w wysokości %0. Dodatkowo wymagana jest zgoda na potrącanie przyszłych płatności z Twojej karty kredytowej. Płatności są przetwarzane przez naszego dostawcę płatności Buckaroo. Zostaniesz przekierowany na stronę Buckaroo, aby dokonać faktycznej płatności.",
	    LblPay: "Zapłać",
	    LblOutOf: "Z",
	    // NIF Number
	    LblEnableNIFNumber: "Włącz numer identyfikacji podatkowej",
	    LblNIFNumber: "Numer identyfikacji podatkowej",
	    LblWeGoDefault: "WeGo Default",
	    LblPersonActiveSuccess: "Osoba pomyślnie aktywowana",
	    LblActivate: 'Aktywuj',
	    LblInActiveReason: "InActive Reason",
	    LblDefaultLanguage: 'Domyślny język',
	    LblRestoreInheritConfirmation: "Bieżące ustawienia zostaną zastąpione przez ustawienia dziedziczone. Czy jesteś pewien?",
	    LblQestionTextRequired: "Wymagany tekst pytania",
	    LblManualSecretKey: "Tajny klucz",
	    // Two Factor Authentication
	    LblTwoFaConfig: "Uwierzytelnianie dwuskładnikowe",
	    LblEnableTwoFa: "Włącz uwierzytelnianie dwuskładnikowe",
	    LblExpirationDays: "Dni wygaśnięcia",
	    LblTextBoxExpirationDays: "Dni wygaśnięcia",
	    Lbl2FactorAuthenticateExpDays: "Okres ważności 2FA (w dniach):",
	    LblResetCookiesWegoAdmin: "Zresetuj pliki cookie dla wszystkich administratorów WeGo",
	    LblReset2FactorAuthWegoAdmin: "Resetuj wszystkie 2FA dla wszystkich administratorów WeGo",
	    LblAuthentication: "Uwierzytelnianie",
	    LblResetCookiesForAllAdmin: "Resetuj pliki cookie dla wszystkich administratorów",
	    LblReset2FaForAllAdmin: "Zresetuj 2FA dla wszystkich administratorów",
	    LblEnterTotp: "Proszę wprowadzić kod",
	    LblEnterOtp: "Proszę wprowadzić kod",
	    LblSubmit: "Prześlij",
	    LblKeyResetSuccess: "Klucz 2FA został zresetowany",
	    LblKeyResetFailed: "Reset klucza 2FA nie powiódł się",
	    LblCookieResetSuccess: "Ciasteczka 2FA zostały zresetowane",
	    LblCookieResetFailed: "Nie udało się zresetować plików cookie 2FA",
	    LblGoogleAuthenticator: "Aplikacja Google Authenticator",
	    LblEmailOtpSent: "Kod został wysłany na Twój zarejestrowany adres e-mail.",
	    LblContinue: "Kontynuuj",
	    LblInvalidTOTP: "Nieważny kod",
	    LblResetCookie: "Zresetuj ciasteczka",
	    LblResetTwoFA: "Wyzeruj 2FA",
	    LblDisableTwoFA: "Wyłącz 2FA",
	    LblTwoFaMethod: "Metoda 2FA",
	    LblEmailAuthentication: "Uwierzytelnianie przez e-mail",
	    LblTwoFaMethodSelect: "Będziesz musiał zweryfikować swoją tożsamość jeszcze raz. Proszę wybrać metodę 2FA",
	    LblInvoicePreFix: "Prefiks numeru faktury",
	    LblEngineStillRunning: 'Polecenie blokady wysłane podczas pracy silnika',
	    LblMobileAppLink: "Link do aplikacji mobilnej",
	    // License Check Configuration
	    LblLicenseCheckConfiguration: "Licencja Sprawdź Konfigurację",
	    LblValidateLicenseCheckForBooking: "Sprawdzenie rezerwacji",
	    // Access Cards Enabled SVG
	    LblAccessCardsEnabled: "Użycie karty dostępu",
	    // Payment Methods
	    LblIdeal: "Ideal",
	    LblBCMC: "BCMC",
	    LblSepa: "Sepa",
	    LblPaypal: "Paypal",
	    LblCreditCard: "Karta kredytowa",
	    LblSofort: "Sofort",
	    LblMyBank: "MyBank",
	    LblGiroPay: "GiroPay",
	    // Track & Trace
	    LblTrackAndTrace: "Track & Trace",
	    LblRfidTagId: "Identyfikator znacznika RFID",
	    LblEmployeeNumber: "Numer pracownika",
	    BtnAddVehicleInfo: "Pokaż VTS Log",
	    // Access Card
	    LblAccessCardId: "Identyfikator karty dostępu",
	    LblDriversLicenseAndCertificates: "Prawo jazdy i certyfikaty",
	    LblLicense: "Prawo jazdy",
	    LblCertificates: "Świadectwa",
	    LblTrips: "Wycieczki",
	    LblCostsSummary: "Podsumowanie kosztów",
	    LblStartBooking: "Rozpocznij rezerwację",
	    LblStopBooking: "Zatrzymaj rezerwację",
	    LblTripHistory: "Historia podróży",
	    LblTripStartDateTime: "Od",
	    LblTripEndDateTime: "Do",
	    LblFaZTripQuestions: "Pytania FaZ",
	    LblNoQuestionsFound: "Nie znaleziono pytań FaZ.",
	    LblNoTripsFound: "Nie znaleziono podróży.",
	    LblTripDetails: "Szczegóły podróży",
	    LblUnansweredQuestions: "Pytania bez odpowiedzi",
	    LblNoUnansweredQuestions: "Brak pytań bez odpowiedzi",
	    LblAnswerSaved: "Odpowiedź została pomyślnie zapisana",
	    LblAnswerSavedError: "Nie udało się zapisać odpowiedzi. Prosimy o kontakt z Administratorem",
	    LblAnswerEmptyError: "Proszę podać poprawną odpowiedź",
	    LblLoginError: "Podczas logowania wystąpił nieznany błąd",
	    LblLoginCredentialsError: "Ta nazwa użytkownika lub hasło są nieprawidłowe, proszę sprawdzić i spróbować ponownie.",
	    LblBookingStarted: "Rezerwacja została rozpoczęta",
	    LblCouldnotStartBooking: "Rezerwacja nie może zostać rozpoczęta",
	    LblBookingStopped: "Rezerwacja została zatrzymana",
	    LblCouldnotStopBooking: "Nie można zatrzymać rezerwacji",
	    ValidatePhoneNumberVts: "Proszę wpisać prawidłowy numer telefonu (np. +31623456789)",
	    LblInfo: "Info"
	};


/***/ },
/* 79 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content\">\r\n    <!--Filter Start-->\r\n    <div class=\"row\">\r\n      <div class=\"col-sm-12\">\r\n        <div class=\"box box-default\">\r\n          <div class=\"box-body\">\r\n            <div class=\"row\">\r\n              <div class=\"col-md-12\">\r\n                <wego-snail-trail-filter [ErrorModel]=\"errorModel\" [IsValidReport]=\"listOfSnailTrail && listOfSnailTrail.length > 0\" (OnResetData)=\"ResetData()\"\r\n                  (OnSearch)=\"OnSearch($event)\" (OnExportXls)=\"OnExport($event)\"></wego-snail-trail-filter>\r\n                <div class=\"text-danger text-center\">\r\n                  {{ noDataFoundMsg }}\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <!-- Filter End -->\r\n\r\n    <div class=\"row\" *ngIf=\"listOfSnailTrail && listOfSnailTrail.length > 0\">\r\n      <!--Map Panel-->\r\n      <div class=\"col-sm-8\">\r\n        <wego-snail-trail-map [CurrentTrip]=\"currentTrip\" [CurrentSegment]=\"currentSegment\" (OnSegmentChange)=\"SelectSegment($event.position)\"></wego-snail-trail-map>\r\n      </div>\r\n      <!--Trip and Segment Details-->\r\n      <div class=\"col-sm-4\" style=\"padding-left:0px\">\r\n        <!--Trip Details-->\r\n        <div class=\"box box-default\">\r\n          <div class=\"box-header with-border\">\r\n            <h3 class=\"box-title\">\r\n              <span>{{ 'LblTripDetail' | translate }}</span>\r\n            </h3>\r\n          </div>\r\n          <div class=\"box-body\">\r\n            <div class=\"form-horizontal\">\r\n              <div class=\"form-group\">\r\n                <label class=\"control-label col-sm-4\">{{ 'LblTripNumber' | translate }}: </label>\r\n                <div class=\"col-sm-8\">\r\n                  <input type=\"text\" class=\"form-control input-sm\" [ngModel]=\"currentTrip?.tripNumber\" readonly>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"form-group\">\r\n                <label class=\"control-label col-sm-4\">{{ 'LblStart' | translate }}: </label>\r\n                <div class=\"col-sm-8\">\r\n                  <input type=\"text\" class=\"form-control input-sm\" [ngModel]=\"currentTrip?.startDateTime\" readonly>\r\n                </div>\r\n              </div>\r\n              <div class=\"form-group\">\r\n                <label class=\"control-label col-sm-4\"></label>\r\n                <div class=\"col-sm-8\">\r\n                  <input type=\"text\" class=\"form-control input-sm\" [ngModel]=\"currentTrip?.startLocation.location\" [title]=\"currentTrip?.startLocation.location\"\r\n                    readonly>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"form-group\">\r\n                <label class=\"control-label col-sm-4\">{{ 'LblEnd' | translate }}: </label>\r\n                <div class=\"col-sm-8\">\r\n                  <input type=\"text\" class=\"form-control input-sm\" [ngModel]=\"currentTrip?.endDateTime\" readonly>\r\n                </div>\r\n              </div>\r\n              <div class=\"form-group\">\r\n                <label class=\"control-label col-sm-4\"></label>\r\n                <div class=\"col-sm-8\">\r\n                  <input type=\"text\" class=\"form-control input-sm\" [ngModel]=\"currentTrip?.endLocation.location\" [title]=\"currentTrip?.endLocation.location\"\r\n                    readonly>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"form-group\">\r\n                <label class=\"control-label col-sm-4\">{{ 'LblAverageSpeed' | translate }} ({{ 'LblKMPerHour' | translate }}): </label>\r\n                <div class=\"col-sm-8\">\r\n                  <input type=\"text\" class=\"form-control input-sm\" [ngModel]=\"currentTrip?.avgSpeed\" readonly>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"form-group\" *ngIf=\"currentTrip?.driverName\">\r\n                <label class=\"control-label col-sm-4\">{{ 'LblDriver' | translate }}: </label>\r\n                <div class=\"col-sm-8\">\r\n                  <div class=\"input-group\">\r\n                    <input type=\"text\" class=\"form-control input-sm\" [ngModel]=\"currentTrip?.driverName\" readonly>\r\n                    <div *ngIf=\"(authService.GetHighestRoleLevel() <= roleLevel.Company) && !currentTrip?.isPersonDeleted && currentTrip.isPersonEdit\" class=\"input-group-btn\">\r\n                      <button class=\"btn btn-default btn-sm\" type=\"button\" [routerLink]=\"urlDriverInfo + '/' +  currentTrip?.personHashId\">\r\n                        <i class=\"fa fa-external-link\" aria-hidden=\"true\"></i>\r\n                      </button>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <ul class=\"pager\">\r\n              <li class=\"previous noselect\" [ngClass]=\"{'disabled': tripCounter == 0 }\">\r\n                <a (click)=\"PreviousTrip()\"><i class=\"fa fa-arrow-left fa-fw\" aria-hidden=\"true\"></i> &nbsp; {{ 'LblPrevious' | translate }}</a>\r\n              </li>\r\n              <li class=\"next noselect\" [ngClass]=\"{'disabled': (tripCounter + 1) == listOfSnailTrail?.length }\">\r\n                <a (click)=\"NextTrip()\">{{ 'LblNext' | translate }} &nbsp; <i class=\"fa fa-arrow-right fa-fw\" aria-hidden=\"true\"></i></a>\r\n              </li>\r\n            </ul>\r\n          </div>\r\n        </div>\r\n        <!--End Trip Details-->\r\n\r\n        <!--Segment Details-->\r\n        <div class=\"box box-default\">\r\n          <div class=\"box-header with-border\">\r\n            <h3 class=\"box-title\">\r\n              <span>{{ 'LblSegmentDetail' | translate }}</span>\r\n            </h3>\r\n          </div>\r\n          <div class=\"box-body\">\r\n            <div *ngIf=\"currentSegment\" class=\"form-horizontal\">\r\n              <div class=\"form-group\">\r\n                <label class=\"control-label col-sm-4\">{{ 'LblSegmentNumber' | translate }}: </label>\r\n                <div class=\"col-sm-8\">\r\n                  <input type=\"text\" class=\"form-control input-sm\" [ngModel]=\"currentSegment?.segmentNumber\" readonly>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"form-group\">\r\n                <label class=\"control-label col-sm-4\" style=\"margin-right:0px;\" >{{ 'LblDistance' | translate }} ({{ 'LblMeter' | translate }}):</label>\r\n                <div class=\"col-sm-8\">\r\n                  <input type=\"text\" class=\"form-control input-sm\" [ngModel]=\"currentSegment?.distance\" readonly>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"form-group\">\r\n                <label class=\"control-label col-sm-4\">{{ 'LblStart' | translate }}: </label>\r\n                <div class=\"col-sm-8\">\r\n                  <input type=\"text\" class=\"form-control input-sm\" [ngModel]=\"currentSegment?.startDateTime\" readonly>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"form-group\">\r\n                <label class=\"control-label col-sm-4\"></label>\r\n                <div class=\"col-sm-8\">\r\n                  <input type=\"text\" class=\"form-control input-sm\" [ngModel]=\"currentSegment?.startLocation.location\" [title]=\"currentSegment?.startLocation.location\"\r\n                    readonly>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"form-group\">\r\n                <label class=\"control-label col-sm-4\">{{ 'LblSpeed' | translate }} ({{ 'LblKMPerHour' | translate }}):</label>\r\n                <div class=\"col-sm-8\">\r\n                  <input type=\"text\" class=\"form-control input-sm\" [ngModel]=\"currentSegment?.startSpeed\" readonly>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"form-group\">\r\n                <label class=\"control-label col-sm-4\">{{ 'LblOdometer' | translate }} ({{ 'LblMeters' | translate }}):</label>\r\n                <div class=\"col-sm-8\">\r\n                  <input type=\"text\" class=\"form-control input-sm\" [ngModel]=\"currentSegment?.startOdometer\" readonly>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"form-group\">\r\n                <label class=\"control-label col-sm-4\">{{ 'LblEnd' | translate }}: </label>\r\n                <div class=\"col-sm-8\">\r\n                  <input type=\"text\" class=\"form-control input-sm\" [ngModel]=\"currentSegment?.endDateTime\" readonly>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"form-group\">\r\n                <label class=\"control-label col-sm-4\"></label>\r\n                <div class=\"col-sm-8\">\r\n                  <input type=\"text\" class=\"form-control input-sm\" [ngModel]=\"currentSegment?.endLocation.location\" [title]=\"currentSegment?.endLocation.location\"\r\n                    readonly>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"form-group\">\r\n                <label class=\"control-label col-sm-4\">{{ 'LblSpeed' | translate }} ({{ 'LblKMPerHour' | translate }}):</label>\r\n                <div class=\"col-sm-8\">\r\n                  <input type=\"text\" class=\"form-control input-sm\" [ngModel]=\"currentSegment?.endSpeed\" readonly>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"form-group\">\r\n                <label class=\"control-label col-sm-4\">{{ 'LblOdometer' | translate }} ({{ 'LblMeters' | translate }}):</label>\r\n                <div class=\"col-sm-8\">\r\n                  <input type=\"text\" class=\"form-control input-sm\" [ngModel]=\"currentSegment?.endOdometer\" readonly>\r\n                </div>\r\n              </div>\r\n\r\n              <ul class=\"pager\">\r\n                <li class=\"previous noselect\" [ngClass]=\"{'disabled': segmentCounter == 0 }\">\r\n                  <a (click)=\"PreviousSegment()\"><i class=\"fa fa-arrow-left fa-fw\" aria-hidden=\"true\"></i> &nbsp; {{ 'LblPrevious' | translate }}</a>\r\n                </li>\r\n                <li class=\"next noselect\" [ngClass]=\"{'disabled': (segmentCounter + 1) == currentTrip?.snailTrailSegment.length }\">\r\n                  <a (click)=\"NextSegment()\">{{ 'LblNext' | translate }} &nbsp; <i class=\"fa fa-arrow-right fa-fw\" aria-hidden=\"true\"></i></a>\r\n                </li>\r\n              </ul>\r\n            </div>\r\n\r\n            <div *ngIf=\"!currentSegment\">\r\n              <p class=\"text-center text-danger\">\r\n                {{ 'LblSegmentDetailNotAvailable' | translate }}\r\n              </p>\r\n            </div>\r\n          </div>\r\n          <!--End Segment Details-->\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n  </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>";

/***/ },
/* 80 */
/***/ function(module, exports) {

	module.exports = ".form-horizontal .control-label {\r\n    text-align: left;\r\n}\r\n\r\n.pager li>a {\r\n    cursor: pointer;\r\n    padding: 2px 15px;\r\n    border-radius: 10px;\r\n}\r\n\r\n.pager .disabled>a,\r\n.pager .disabled>a:hover,\r\n.pager .disabled>a:focus,\r\n.pager .disabled>a:active,\r\n.pager .disabled>span {\r\n    cursor: not-allowed;\r\n}\r\n\r\n.noselect {\r\n    -webkit-touch-callout: none;\r\n    /* iOS Safari */\r\n    -webkit-user-select: none;\r\n    /* Safari */\r\n    -khtml-user-select: none;\r\n    /* Konqueror HTML */\r\n    -moz-user-select: none;\r\n    /* Firefox */\r\n    -ms-user-select: none;\r\n    /* Internet Explorer/Edge */\r\n    user-select: none;\r\n    /* Non-prefixed version, currently supported by Chrome and Opera */\r\n}"

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var flatpickr_directive_1 = __webpack_require__(82);
	var flatpickr_model_1 = __webpack_require__(83);
	var config_1 = __webpack_require__(60);
	var moment = __webpack_require__(84);
	var SnailTrailFilterComponent = (function () {
	    function SnailTrailFilterComponent() {
	        this.onSearchEvent = new core_1.EventEmitter();
	        this.onExportXls = new core_1.EventEmitter();
	        this.onResetData = new core_1.EventEmitter();
	        this.isValidReport = false;
	        this.isBookingSearch = true;
	        this.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
	    }
	    Object.defineProperty(SnailTrailFilterComponent.prototype, "ErrorModel", {
	        get: function () { return this.errorModel; },
	        set: function (errorModel) {
	            this.errorModel = errorModel;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SnailTrailFilterComponent.prototype.ngOnInit = function () {
	        this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigTo.defaultDate = "23:59";
	    };
	    SnailTrailFilterComponent.prototype.SetDefaultFlatPickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = true;
	        flatPickrConfig.time_24hr = true;
	        flatPickrConfig.dateFormat = this.dateFormat;
	        flatPickrConfig.minuteIncrement = 1;
	        return flatPickrConfig;
	    };
	    SnailTrailFilterComponent.prototype.SuccessSelectDriverModal = function ($event) {
	        this.driverhashId = $event.DriverHashID;
	        this.driverName = $event.DriverName;
	        this.OnFilterReset();
	    };
	    SnailTrailFilterComponent.prototype.SuccessSelectBookingModal = function ($event) {
	        this.bookingRefrenceId = $event.BookingReferenceId;
	        this.bookingHashId = $event.BookingHashID;
	        this.driverhashId = $event.DriverHashID;
	        this.driverName = $event.DriverName;
	        this.licenceTag = $event.LicenceTage;
	        this.vehicleHashId = $event.VehicleMasterHashID;
	        this.OnFilterReset();
	    };
	    SnailTrailFilterComponent.prototype.SuccessSelectVehicleModal = function ($event) {
	        this.licenceTag = $event.LicenceTage;
	        this.vehicleHashId = $event.VehicleMasterHashID;
	        this.OnFilterReset();
	    };
	    SnailTrailFilterComponent.prototype.OnFromDateChange = function (value) {
	        if (value) {
	            var format = 'DD-MM-YYYY HH:mm';
	            var newDate = moment(value, format).toDate();
	            var endDate = moment(this.endDateTime, format).toDate();
	            if (endDate < newDate) {
	                var endDateVal = moment(value, format).add('H', 1);
	                this.flatPickrConfigToDate.ChangeValue(endDateVal.format('DD-MM-YYYY HH:mm'));
	            }
	            this.flatPickrConfigToDate.SetOption("minDate", newDate);
	        }
	        this.OnFilterReset();
	    };
	    SnailTrailFilterComponent.prototype.ClearDriver = function () {
	        this.driverhashId = "";
	        this.driverName = "";
	        this.OnFilterReset();
	    };
	    SnailTrailFilterComponent.prototype.OnToDateChange = function () {
	        this.OnFilterReset();
	    };
	    SnailTrailFilterComponent.prototype.OnFilterReset = function () {
	        this.onResetData.emit();
	    };
	    SnailTrailFilterComponent.prototype.OnSearchChange = function () {
	        this.bookingRefrenceId = "";
	        this.bookingHashId = "";
	        this.driverhashId = "";
	        this.driverName = "";
	        this.licenceTag = "";
	        this.vehicleHashId = "";
	        this.startDateTime = "";
	        this.endDateTime = "";
	        this.onResetData.emit();
	    };
	    SnailTrailFilterComponent.prototype.OnSearch = function ($event) {
	        if (this.isBookingSearch) {
	            this.onSearchEvent.emit({ reportSearchType: 'PER_BOOKING', bookingHashId: this.bookingHashId, driverHashId: "", vehicleHashId: "", startDateTime: "", endDateTime: "" });
	        }
	        else {
	            this.onSearchEvent.emit({ reportSearchType: 'PER_VEHICLE', bookingHashId: "", driverHashId: this.driverhashId, vehicleHashId: this.vehicleHashId, startDateTime: this.startDateTime, endDateTime: this.endDateTime });
	        }
	    };
	    SnailTrailFilterComponent.prototype.OnExportXls = function ($event) {
	        if (this.isBookingSearch) {
	            this.onExportXls.emit({ reportSearchType: 'PER_BOOKING', bookingHashId: this.bookingHashId, driverHashId: "", vehicleHashId: "", startDateTime: "", endDateTime: "" });
	        }
	        else {
	            this.onExportXls.emit({ reportSearchType: 'PER_VEHICLE', bookingHashId: "", driverHashId: this.driverhashId, vehicleHashId: this.vehicleHashId, startDateTime: this.startDateTime, endDateTime: this.endDateTime });
	        }
	    };
	    SnailTrailFilterComponent.prototype.ngOnDestroy = function () {
	    };
	    __decorate([
	        core_1.ViewChild('flatPickrConfigFromDate'), 
	        __metadata('design:type', (typeof (_a = typeof flatpickr_directive_1.FlatPickrDirective !== 'undefined' && flatpickr_directive_1.FlatPickrDirective) === 'function' && _a) || Object)
	    ], SnailTrailFilterComponent.prototype, "flatPickrConfigFromDate", void 0);
	    __decorate([
	        core_1.ViewChild('flatPickrConfigToDate'), 
	        __metadata('design:type', (typeof (_b = typeof flatpickr_directive_1.FlatPickrDirective !== 'undefined' && flatpickr_directive_1.FlatPickrDirective) === 'function' && _b) || Object)
	    ], SnailTrailFilterComponent.prototype, "flatPickrConfigToDate", void 0);
	    __decorate([
	        core_1.Output('OnSearch'), 
	        __metadata('design:type', Object)
	    ], SnailTrailFilterComponent.prototype, "onSearchEvent", void 0);
	    __decorate([
	        core_1.Output('OnExportXls'), 
	        __metadata('design:type', Object)
	    ], SnailTrailFilterComponent.prototype, "onExportXls", void 0);
	    __decorate([
	        core_1.Output('OnResetData'), 
	        __metadata('design:type', Object)
	    ], SnailTrailFilterComponent.prototype, "onResetData", void 0);
	    __decorate([
	        core_1.Input('IsValidReport'), 
	        __metadata('design:type', Boolean)
	    ], SnailTrailFilterComponent.prototype, "isValidReport", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object), 
	        __metadata('design:paramtypes', [Object])
	    ], SnailTrailFilterComponent.prototype, "ErrorModel", null);
	    SnailTrailFilterComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-snail-trail-filter',
	            template: __webpack_require__(197),
	            styles: ["\n    .nopad-left{\n      padding-left: 0px;\n    } \n  "]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], SnailTrailFilterComponent);
	    return SnailTrailFilterComponent;
	    var _a, _b;
	}());
	exports.SnailTrailFilterComponent = SnailTrailFilterComponent;


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var core_1 = __webpack_require__(3);
	var flatpickr_model_1 = __webpack_require__(83);
	var $ = __webpack_require__(68);
	var moment = __webpack_require__(84);
	var Flatpickr = __webpack_require__(196);
	//const Flatpickr = require("../../../../public/plugin/flatpickr/final/flatpickr.min.js");
	// declare var Flatpickr: any;
	// declare var $: any;
	// declare var moment: any;
	var FlatPickrDirective = (function () {
	    function FlatPickrDirective(_el, translate) {
	        this.translate = translate;
	        this.ngModelChange = new core_1.EventEmitter();
	        this.isAlreadyChange = false;
	        this.el = _el.nativeElement;
	    }
	    FlatPickrDirective.prototype.ngOnChanges = function (change) {
	        this.defaultDate = change.ngModel.currentValue;
	        if (this.picker && !this.isAlreadyChange && this.defaultDate) {
	            var format = this.Config.noCalendar ? 'HH:mm' : this.Config.enableSeconds ? 'DD-MM-YYYY HH:mm:ss' : 'DD-MM-YYYY HH:mm';
	            var newDate = moment(this.defaultDate, format).toDate(); //this.picker.parseDate(this.defaultDate);
	            this.picker.setDate(newDate, "Change");
	            this.isAlreadyChange = true;
	        }
	    };
	    FlatPickrDirective.prototype.ngOnInit = function () {
	        this.InitializePicker();
	    };
	    FlatPickrDirective.prototype.InitializePicker = function () {
	        var _this = this;
	        this.translate.setDetectedLang();
	        Flatpickr.l10ns.default.weekdays = this.translate.instant('LblWeekdays');
	        Flatpickr.l10ns.default.months = this.translate.instant('LblMonths');
	        if (this.defaultDate) {
	            var format = this.Config.noCalendar ? 'HH:mm' : this.Config.enableSeconds ? 'DD-MM-YYYY HH:mm:ss' : 'DD-MM-YYYY HH:mm';
	            var newDate = moment(this.defaultDate, format).toDate();
	            this.Config.defaultDate = newDate;
	        }
	        this.Config.onReady = function (dateObj, dateStr, instance) {
	            var LblCancel = _this.translate.instant('LblCancel');
	            var LblSave = _this.translate.instant('LblSave');
	            var extraPanel = "<div class=\"flatpickr-close\" style=\"padding: 5px 0px;border-top: 1px solid #e6e6e6;\">\n                          <button class=\"btn flatpickr-btn-clear\" style=\"padding: 2px; width: 45%;\">"
	                + LblCancel +
	                "</button>\n                          <button class=\"btn flatpickr-btn-check\" style=\"padding: 2px; width: 45%;\">"
	                + LblSave +
	                "</button>\n                        </div>";
	            var $cal = $(instance.calendarContainer);
	            if ($cal.find('.flatpickr-clear').length < 1) {
	                $cal.append(extraPanel);
	                $cal.find('.flatpickr-btn-check').on('click', function () {
	                    instance.close();
	                });
	                $cal.find('.flatpickr-btn-clear').on('click', function () {
	                    instance.clear();
	                    instance.close();
	                });
	            }
	        };
	        this.picker = new Flatpickr(this.el, this.Config);
	        this.picker.config.onChange = function (dateObj, dateStr, instance) {
	            _this.ngModelChange.emit(dateStr);
	        };
	    };
	    FlatPickrDirective.prototype.ChangeValue = function (newVal) {
	        var format = this.Config.noCalendar ? 'HH:mm' : this.Config.enableSeconds ? 'DD-MM-YYYY HH:mm:ss' : 'DD-MM-YYYY HH:mm';
	        var newDate = moment(newVal, format).toDate(); //this.picker.parseDate(this.defaultDate);
	        this.picker.setDate(newDate, "Change");
	    };
	    FlatPickrDirective.prototype.SetOption = function (configKey, value) {
	        this.picker.set(configKey, value);
	    };
	    FlatPickrDirective.prototype.ToggleTimePicker = function (enableTime) {
	        this.Config.enableTime = enableTime;
	        this.picker.destroy();
	        this.isAlreadyChange = false;
	        this.InitializePicker();
	    };
	    FlatPickrDirective.prototype.ToggleDatePickerFormat = function (enableTime, dateFormat) {
	        this.Config.enableTime = enableTime;
	        this.Config.dateFormat = dateFormat;
	        this.picker.destroy();
	        this.isAlreadyChange = false;
	        this.InitializePicker();
	    };
	    FlatPickrDirective.prototype.ngOnDestroy = function () {
	        this.picker.destroy();
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], FlatPickrDirective.prototype, "ngModel", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], FlatPickrDirective.prototype, "ngModelChange", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof flatpickr_model_1.FlatPickrModel !== 'undefined' && flatpickr_model_1.FlatPickrModel) === 'function' && _a) || Object)
	    ], FlatPickrDirective.prototype, "Config", void 0);
	    FlatPickrDirective = __decorate([
	        core_1.Directive({
	            selector: '[flatpickr]',
	            exportAs: 'wego-flatpickr',
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof core_1.ElementRef !== 'undefined' && core_1.ElementRef) === 'function' && _b) || Object, (typeof (_c = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _c) || Object])
	    ], FlatPickrDirective);
	    return FlatPickrDirective;
	    var _a, _b, _c;
	}());
	exports.FlatPickrDirective = FlatPickrDirective;


/***/ },
/* 83 */
/***/ function(module, exports) {

	"use strict";
	var FlatPickrModel = (function () {
	    function FlatPickrModel() {
	        /* if true; dates will be parsed; formatted; and displayed in UTC.
	       preloading date strings w/ timezones is recommended but not necessary */
	        this.utc = false;
	        // wrap: see https://chmln.github.io/flatpickr/#strap
	        this.wrap = false;
	        // enables week numbers
	        this.weekNumbers = false;
	        this.allowInput = false;
	        /*
	        clicking on input opens the date(time)picker.
	        disable if you wish to open the calendar manually with .open()
	     */
	        this.clickOpens = true;
	        // display time picker in 24 hour mode
	        this.time_24hr = false;
	        // enables the time picker functionality
	        this.enableTime = false;
	        // noCalendar: true will hide the calendar. use for a time picker along w/ enableTime
	        this.noCalendar = false;
	        // more date format chars at https://chmln.github.io/flatpickr/#dateformat
	        this.dateFormat = "Y-m-d";
	        // altInput - see https://chmln.github.io/flatpickr/#altinput
	        this.altInput = null;
	        // the created altInput element will have this class.
	        this.altInputClass = "";
	        // defaultDate - either a datestring or a date object. used for datetimepicker"s initial value
	        this.defaultDate = null;
	        // initial value in the hour element
	        this.defaultHour = 0;
	        // the minimum date that user can pick (inclusive)
	        this.minDate = null;
	        // the maximum date that user can pick (inclusive)
	        this.maxDate = null;
	        // dateparser that transforms a given string to a date object
	        this.parseDate = null;
	        // see https://chmln.github.io/flatpickr/#disable
	        this.enable = [];
	        // see https://chmln.github.io/flatpickr/#disable
	        this.disable = [];
	        // display the short version of month names - e.g. Sep instead of September
	        this.shorthandCurrentMonth = true;
	        // displays calendar inline. see https://chmln.github.io/flatpickr/#inline-calendar
	        this.inline = false;
	        // position calendar inside wrapper and next to the input element
	        // leave at false unless you know what you"re doing
	        this.static = false;
	        // code for previous/next icons. this is where you put your custom icon code e.g. fontawesome
	        this.prevArrow = "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>";
	        this.nextArrow = "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>";
	        // enables seconds in the time picker
	        this.enableSeconds = false;
	        // step size used when scrolling/incrementing the hour element
	        this.hourIncrement = 1;
	        // step size used when scrolling/incrementing the minute element
	        this.minuteIncrement = 5;
	        // disable native mobile datetime input support
	        this.disableMobile = false;
	        // onChange callback when user selects a date or time
	        this.onChange = null; // function (dateObj; dateStr) {}
	        // called every time calendar is opened
	        this.onOpen = null; // function (dateObj; dateStr) {}
	        // called every time calendar is closed
	        this.onClose = null; // function (dateObj; dateStr) {}
	        // called after calendar is ready
	        this.onReady = null; // function (dateObj; dateStr) {}
	        this.onValueUpdate = null;
	    }
	    return FlatPickrModel;
	}());
	exports.FlatPickrModel = FlatPickrModel;


/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.17.0
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	var hookCallback;
	
	function hooks () {
	    return hookCallback.apply(null, arguments);
	}
	
	// This is done to register the method called with moment()
	// without creating circular dependencies.
	function setHookCallback (callback) {
	    hookCallback = callback;
	}
	
	function isArray(input) {
	    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	}
	
	function isObject(input) {
	    // IE8 will treat undefined and null as object if it wasn't for
	    // input != null
	    return input != null && Object.prototype.toString.call(input) === '[object Object]';
	}
	
	function isObjectEmpty(obj) {
	    var k;
	    for (k in obj) {
	        // even if its not own property I'd still call it non-empty
	        return false;
	    }
	    return true;
	}
	
	function isNumber(input) {
	    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
	}
	
	function isDate(input) {
	    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	}
	
	function map(arr, fn) {
	    var res = [], i;
	    for (i = 0; i < arr.length; ++i) {
	        res.push(fn(arr[i], i));
	    }
	    return res;
	}
	
	function hasOwnProp(a, b) {
	    return Object.prototype.hasOwnProperty.call(a, b);
	}
	
	function extend(a, b) {
	    for (var i in b) {
	        if (hasOwnProp(b, i)) {
	            a[i] = b[i];
	        }
	    }
	
	    if (hasOwnProp(b, 'toString')) {
	        a.toString = b.toString;
	    }
	
	    if (hasOwnProp(b, 'valueOf')) {
	        a.valueOf = b.valueOf;
	    }
	
	    return a;
	}
	
	function createUTC (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, true).utc();
	}
	
	function defaultParsingFlags() {
	    // We need to deep clone this object.
	    return {
	        empty           : false,
	        unusedTokens    : [],
	        unusedInput     : [],
	        overflow        : -2,
	        charsLeftOver   : 0,
	        nullInput       : false,
	        invalidMonth    : null,
	        invalidFormat   : false,
	        userInvalidated : false,
	        iso             : false,
	        parsedDateParts : [],
	        meridiem        : null
	    };
	}
	
	function getParsingFlags(m) {
	    if (m._pf == null) {
	        m._pf = defaultParsingFlags();
	    }
	    return m._pf;
	}
	
	var some;
	if (Array.prototype.some) {
	    some = Array.prototype.some;
	} else {
	    some = function (fun) {
	        var t = Object(this);
	        var len = t.length >>> 0;
	
	        for (var i = 0; i < len; i++) {
	            if (i in t && fun.call(this, t[i], i, t)) {
	                return true;
	            }
	        }
	
	        return false;
	    };
	}
	
	var some$1 = some;
	
	function isValid(m) {
	    if (m._isValid == null) {
	        var flags = getParsingFlags(m);
	        var parsedParts = some$1.call(flags.parsedDateParts, function (i) {
	            return i != null;
	        });
	        var isNowValid = !isNaN(m._d.getTime()) &&
	            flags.overflow < 0 &&
	            !flags.empty &&
	            !flags.invalidMonth &&
	            !flags.invalidWeekday &&
	            !flags.nullInput &&
	            !flags.invalidFormat &&
	            !flags.userInvalidated &&
	            (!flags.meridiem || (flags.meridiem && parsedParts));
	
	        if (m._strict) {
	            isNowValid = isNowValid &&
	                flags.charsLeftOver === 0 &&
	                flags.unusedTokens.length === 0 &&
	                flags.bigHour === undefined;
	        }
	
	        if (Object.isFrozen == null || !Object.isFrozen(m)) {
	            m._isValid = isNowValid;
	        }
	        else {
	            return isNowValid;
	        }
	    }
	    return m._isValid;
	}
	
	function createInvalid (flags) {
	    var m = createUTC(NaN);
	    if (flags != null) {
	        extend(getParsingFlags(m), flags);
	    }
	    else {
	        getParsingFlags(m).userInvalidated = true;
	    }
	
	    return m;
	}
	
	function isUndefined(input) {
	    return input === void 0;
	}
	
	// Plugins that add properties should also add the key here (null value),
	// so we can properly clone ourselves.
	var momentProperties = hooks.momentProperties = [];
	
	function copyConfig(to, from) {
	    var i, prop, val;
	
	    if (!isUndefined(from._isAMomentObject)) {
	        to._isAMomentObject = from._isAMomentObject;
	    }
	    if (!isUndefined(from._i)) {
	        to._i = from._i;
	    }
	    if (!isUndefined(from._f)) {
	        to._f = from._f;
	    }
	    if (!isUndefined(from._l)) {
	        to._l = from._l;
	    }
	    if (!isUndefined(from._strict)) {
	        to._strict = from._strict;
	    }
	    if (!isUndefined(from._tzm)) {
	        to._tzm = from._tzm;
	    }
	    if (!isUndefined(from._isUTC)) {
	        to._isUTC = from._isUTC;
	    }
	    if (!isUndefined(from._offset)) {
	        to._offset = from._offset;
	    }
	    if (!isUndefined(from._pf)) {
	        to._pf = getParsingFlags(from);
	    }
	    if (!isUndefined(from._locale)) {
	        to._locale = from._locale;
	    }
	
	    if (momentProperties.length > 0) {
	        for (i in momentProperties) {
	            prop = momentProperties[i];
	            val = from[prop];
	            if (!isUndefined(val)) {
	                to[prop] = val;
	            }
	        }
	    }
	
	    return to;
	}
	
	var updateInProgress = false;
	
	// Moment prototype object
	function Moment(config) {
	    copyConfig(this, config);
	    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	    if (!this.isValid()) {
	        this._d = new Date(NaN);
	    }
	    // Prevent infinite loop in case updateOffset creates new moment
	    // objects.
	    if (updateInProgress === false) {
	        updateInProgress = true;
	        hooks.updateOffset(this);
	        updateInProgress = false;
	    }
	}
	
	function isMoment (obj) {
	    return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	}
	
	function absFloor (number) {
	    if (number < 0) {
	        // -0 -> 0
	        return Math.ceil(number) || 0;
	    } else {
	        return Math.floor(number);
	    }
	}
	
	function toInt(argumentForCoercion) {
	    var coercedNumber = +argumentForCoercion,
	        value = 0;
	
	    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	        value = absFloor(coercedNumber);
	    }
	
	    return value;
	}
	
	// compare two arrays, return the number of differences
	function compareArrays(array1, array2, dontConvert) {
	    var len = Math.min(array1.length, array2.length),
	        lengthDiff = Math.abs(array1.length - array2.length),
	        diffs = 0,
	        i;
	    for (i = 0; i < len; i++) {
	        if ((dontConvert && array1[i] !== array2[i]) ||
	            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	            diffs++;
	        }
	    }
	    return diffs + lengthDiff;
	}
	
	function warn(msg) {
	    if (hooks.suppressDeprecationWarnings === false &&
	            (typeof console !==  'undefined') && console.warn) {
	        console.warn('Deprecation warning: ' + msg);
	    }
	}
	
	function deprecate(msg, fn) {
	    var firstTime = true;
	
	    return extend(function () {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(null, msg);
	        }
	        if (firstTime) {
	            var args = [];
	            var arg;
	            for (var i = 0; i < arguments.length; i++) {
	                arg = '';
	                if (typeof arguments[i] === 'object') {
	                    arg += '\n[' + i + '] ';
	                    for (var key in arguments[0]) {
	                        arg += key + ': ' + arguments[0][key] + ', ';
	                    }
	                    arg = arg.slice(0, -2); // Remove trailing comma and space
	                } else {
	                    arg = arguments[i];
	                }
	                args.push(arg);
	            }
	            warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	            firstTime = false;
	        }
	        return fn.apply(this, arguments);
	    }, fn);
	}
	
	var deprecations = {};
	
	function deprecateSimple(name, msg) {
	    if (hooks.deprecationHandler != null) {
	        hooks.deprecationHandler(name, msg);
	    }
	    if (!deprecations[name]) {
	        warn(msg);
	        deprecations[name] = true;
	    }
	}
	
	hooks.suppressDeprecationWarnings = false;
	hooks.deprecationHandler = null;
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	function set (config) {
	    var prop, i;
	    for (i in config) {
	        prop = config[i];
	        if (isFunction(prop)) {
	            this[i] = prop;
	        } else {
	            this['_' + i] = prop;
	        }
	    }
	    this._config = config;
	    // Lenient ordinal parsing accepts just a number in addition to
	    // number + (possibly) stuff coming from _ordinalParseLenient.
	    this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
	}
	
	function mergeConfigs(parentConfig, childConfig) {
	    var res = extend({}, parentConfig), prop;
	    for (prop in childConfig) {
	        if (hasOwnProp(childConfig, prop)) {
	            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                res[prop] = {};
	                extend(res[prop], parentConfig[prop]);
	                extend(res[prop], childConfig[prop]);
	            } else if (childConfig[prop] != null) {
	                res[prop] = childConfig[prop];
	            } else {
	                delete res[prop];
	            }
	        }
	    }
	    for (prop in parentConfig) {
	        if (hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])) {
	            // make sure changes to properties don't modify parent config
	            res[prop] = extend({}, res[prop]);
	        }
	    }
	    return res;
	}
	
	function Locale(config) {
	    if (config != null) {
	        this.set(config);
	    }
	}
	
	var keys;
	
	if (Object.keys) {
	    keys = Object.keys;
	} else {
	    keys = function (obj) {
	        var i, res = [];
	        for (i in obj) {
	            if (hasOwnProp(obj, i)) {
	                res.push(i);
	            }
	        }
	        return res;
	    };
	}
	
	var keys$1 = keys;
	
	var defaultCalendar = {
	    sameDay : '[Today at] LT',
	    nextDay : '[Tomorrow at] LT',
	    nextWeek : 'dddd [at] LT',
	    lastDay : '[Yesterday at] LT',
	    lastWeek : '[Last] dddd [at] LT',
	    sameElse : 'L'
	};
	
	function calendar (key, mom, now) {
	    var output = this._calendar[key] || this._calendar['sameElse'];
	    return isFunction(output) ? output.call(mom, now) : output;
	}
	
	var defaultLongDateFormat = {
	    LTS  : 'h:mm:ss A',
	    LT   : 'h:mm A',
	    L    : 'MM/DD/YYYY',
	    LL   : 'MMMM D, YYYY',
	    LLL  : 'MMMM D, YYYY h:mm A',
	    LLLL : 'dddd, MMMM D, YYYY h:mm A'
	};
	
	function longDateFormat (key) {
	    var format = this._longDateFormat[key],
	        formatUpper = this._longDateFormat[key.toUpperCase()];
	
	    if (format || !formatUpper) {
	        return format;
	    }
	
	    this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	        return val.slice(1);
	    });
	
	    return this._longDateFormat[key];
	}
	
	var defaultInvalidDate = 'Invalid date';
	
	function invalidDate () {
	    return this._invalidDate;
	}
	
	var defaultOrdinal = '%d';
	var defaultOrdinalParse = /\d{1,2}/;
	
	function ordinal (number) {
	    return this._ordinal.replace('%d', number);
	}
	
	var defaultRelativeTime = {
	    future : 'in %s',
	    past   : '%s ago',
	    s  : 'a few seconds',
	    m  : 'a minute',
	    mm : '%d minutes',
	    h  : 'an hour',
	    hh : '%d hours',
	    d  : 'a day',
	    dd : '%d days',
	    M  : 'a month',
	    MM : '%d months',
	    y  : 'a year',
	    yy : '%d years'
	};
	
	function relativeTime (number, withoutSuffix, string, isFuture) {
	    var output = this._relativeTime[string];
	    return (isFunction(output)) ?
	        output(number, withoutSuffix, string, isFuture) :
	        output.replace(/%d/i, number);
	}
	
	function pastFuture (diff, output) {
	    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	}
	
	var aliases = {};
	
	function addUnitAlias (unit, shorthand) {
	    var lowerCase = unit.toLowerCase();
	    aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	}
	
	function normalizeUnits(units) {
	    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	}
	
	function normalizeObjectUnits(inputObject) {
	    var normalizedInput = {},
	        normalizedProp,
	        prop;
	
	    for (prop in inputObject) {
	        if (hasOwnProp(inputObject, prop)) {
	            normalizedProp = normalizeUnits(prop);
	            if (normalizedProp) {
	                normalizedInput[normalizedProp] = inputObject[prop];
	            }
	        }
	    }
	
	    return normalizedInput;
	}
	
	var priorities = {};
	
	function addUnitPriority(unit, priority) {
	    priorities[unit] = priority;
	}
	
	function getPrioritizedUnits(unitsObj) {
	    var units = [];
	    for (var u in unitsObj) {
	        units.push({unit: u, priority: priorities[u]});
	    }
	    units.sort(function (a, b) {
	        return a.priority - b.priority;
	    });
	    return units;
	}
	
	function makeGetSet (unit, keepTime) {
	    return function (value) {
	        if (value != null) {
	            set$1(this, unit, value);
	            hooks.updateOffset(this, keepTime);
	            return this;
	        } else {
	            return get(this, unit);
	        }
	    };
	}
	
	function get (mom, unit) {
	    return mom.isValid() ?
	        mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	}
	
	function set$1 (mom, unit, value) {
	    if (mom.isValid()) {
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	    }
	}
	
	// MOMENTS
	
	function stringGet (units) {
	    units = normalizeUnits(units);
	    if (isFunction(this[units])) {
	        return this[units]();
	    }
	    return this;
	}
	
	
	function stringSet (units, value) {
	    if (typeof units === 'object') {
	        units = normalizeObjectUnits(units);
	        var prioritized = getPrioritizedUnits(units);
	        for (var i = 0; i < prioritized.length; i++) {
	            this[prioritized[i].unit](units[prioritized[i].unit]);
	        }
	    } else {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units](value);
	        }
	    }
	    return this;
	}
	
	function zeroFill(number, targetLength, forceSign) {
	    var absNumber = '' + Math.abs(number),
	        zerosToFill = targetLength - absNumber.length,
	        sign = number >= 0;
	    return (sign ? (forceSign ? '+' : '') : '-') +
	        Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	}
	
	var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	var formatFunctions = {};
	
	var formatTokenFunctions = {};
	
	// token:    'M'
	// padded:   ['MM', 2]
	// ordinal:  'Mo'
	// callback: function () { this.month() + 1 }
	function addFormatToken (token, padded, ordinal, callback) {
	    var func = callback;
	    if (typeof callback === 'string') {
	        func = function () {
	            return this[callback]();
	        };
	    }
	    if (token) {
	        formatTokenFunctions[token] = func;
	    }
	    if (padded) {
	        formatTokenFunctions[padded[0]] = function () {
	            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	        };
	    }
	    if (ordinal) {
	        formatTokenFunctions[ordinal] = function () {
	            return this.localeData().ordinal(func.apply(this, arguments), token);
	        };
	    }
	}
	
	function removeFormattingTokens(input) {
	    if (input.match(/\[[\s\S]/)) {
	        return input.replace(/^\[|\]$/g, '');
	    }
	    return input.replace(/\\/g, '');
	}
	
	function makeFormatFunction(format) {
	    var array = format.match(formattingTokens), i, length;
	
	    for (i = 0, length = array.length; i < length; i++) {
	        if (formatTokenFunctions[array[i]]) {
	            array[i] = formatTokenFunctions[array[i]];
	        } else {
	            array[i] = removeFormattingTokens(array[i]);
	        }
	    }
	
	    return function (mom) {
	        var output = '', i;
	        for (i = 0; i < length; i++) {
	            output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
	        }
	        return output;
	    };
	}
	
	// format date using native date object
	function formatMoment(m, format) {
	    if (!m.isValid()) {
	        return m.localeData().invalidDate();
	    }
	
	    format = expandFormat(format, m.localeData());
	    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	    return formatFunctions[format](m);
	}
	
	function expandFormat(format, locale) {
	    var i = 5;
	
	    function replaceLongDateFormatTokens(input) {
	        return locale.longDateFormat(input) || input;
	    }
	
	    localFormattingTokens.lastIndex = 0;
	    while (i >= 0 && localFormattingTokens.test(format)) {
	        format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	        localFormattingTokens.lastIndex = 0;
	        i -= 1;
	    }
	
	    return format;
	}
	
	var match1         = /\d/;            //       0 - 9
	var match2         = /\d\d/;          //      00 - 99
	var match3         = /\d{3}/;         //     000 - 999
	var match4         = /\d{4}/;         //    0000 - 9999
	var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	var match1to2      = /\d\d?/;         //       0 - 99
	var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	var match1to3      = /\d{1,3}/;       //       0 - 999
	var match1to4      = /\d{1,4}/;       //       0 - 9999
	var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	var matchUnsigned  = /\d+/;           //       0 - inf
	var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	// any word (or two) characters or numbers including two/three word month in arabic.
	// includes scottish gaelic two word and hyphenated months
	var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
	var regexes = {};
	
	function addRegexToken (token, regex, strictRegex) {
	    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	        return (isStrict && strictRegex) ? strictRegex : regex;
	    };
	}
	
	function getParseRegexForToken (token, config) {
	    if (!hasOwnProp(regexes, token)) {
	        return new RegExp(unescapeFormat(token));
	    }
	
	    return regexes[token](config._strict, config._locale);
	}
	
	// Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	function unescapeFormat(s) {
	    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	        return p1 || p2 || p3 || p4;
	    }));
	}
	
	function regexEscape(s) {
	    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	}
	
	var tokens = {};
	
	function addParseToken (token, callback) {
	    var i, func = callback;
	    if (typeof token === 'string') {
	        token = [token];
	    }
	    if (isNumber(callback)) {
	        func = function (input, array) {
	            array[callback] = toInt(input);
	        };
	    }
	    for (i = 0; i < token.length; i++) {
	        tokens[token[i]] = func;
	    }
	}
	
	function addWeekParseToken (token, callback) {
	    addParseToken(token, function (input, array, config, token) {
	        config._w = config._w || {};
	        callback(input, config._w, config, token);
	    });
	}
	
	function addTimeToArrayFromToken(token, input, config) {
	    if (input != null && hasOwnProp(tokens, token)) {
	        tokens[token](input, config._a, config, token);
	    }
	}
	
	var YEAR = 0;
	var MONTH = 1;
	var DATE = 2;
	var HOUR = 3;
	var MINUTE = 4;
	var SECOND = 5;
	var MILLISECOND = 6;
	var WEEK = 7;
	var WEEKDAY = 8;
	
	var indexOf;
	
	if (Array.prototype.indexOf) {
	    indexOf = Array.prototype.indexOf;
	} else {
	    indexOf = function (o) {
	        // I know
	        var i;
	        for (i = 0; i < this.length; ++i) {
	            if (this[i] === o) {
	                return i;
	            }
	        }
	        return -1;
	    };
	}
	
	var indexOf$1 = indexOf;
	
	function daysInMonth(year, month) {
	    return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	}
	
	// FORMATTING
	
	addFormatToken('M', ['MM', 2], 'Mo', function () {
	    return this.month() + 1;
	});
	
	addFormatToken('MMM', 0, 0, function (format) {
	    return this.localeData().monthsShort(this, format);
	});
	
	addFormatToken('MMMM', 0, 0, function (format) {
	    return this.localeData().months(this, format);
	});
	
	// ALIASES
	
	addUnitAlias('month', 'M');
	
	// PRIORITY
	
	addUnitPriority('month', 8);
	
	// PARSING
	
	addRegexToken('M',    match1to2);
	addRegexToken('MM',   match1to2, match2);
	addRegexToken('MMM',  function (isStrict, locale) {
	    return locale.monthsShortRegex(isStrict);
	});
	addRegexToken('MMMM', function (isStrict, locale) {
	    return locale.monthsRegex(isStrict);
	});
	
	addParseToken(['M', 'MM'], function (input, array) {
	    array[MONTH] = toInt(input) - 1;
	});
	
	addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	    var month = config._locale.monthsParse(input, token, config._strict);
	    // if we didn't find a month name, mark the date as invalid.
	    if (month != null) {
	        array[MONTH] = month;
	    } else {
	        getParsingFlags(config).invalidMonth = input;
	    }
	});
	
	// LOCALES
	
	var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
	var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	function localeMonths (m, format) {
	    if (!m) {
	        return this._months;
	    }
	    return isArray(this._months) ? this._months[m.month()] :
	        this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	function localeMonthsShort (m, format) {
	    if (!m) {
	        return this._monthsShort;
	    }
	    return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	        this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	}
	
	function handleStrictParse(monthName, format, strict) {
	    var i, ii, mom, llc = monthName.toLocaleLowerCase();
	    if (!this._monthsParse) {
	        // this is not used
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	        for (i = 0; i < 12; ++i) {
	            mom = createUTC([2000, i]);
	            this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	            this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'MMM') {
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._longMonthsParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortMonthsParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeMonthsParse (monthName, format, strict) {
	    var i, mom, regex;
	
	    if (this._monthsParseExact) {
	        return handleStrictParse.call(this, monthName, format, strict);
	    }
	
	    if (!this._monthsParse) {
	        this._monthsParse = [];
	        this._longMonthsParse = [];
	        this._shortMonthsParse = [];
	    }
	
	    // TODO: add sorting
	    // Sorting makes sure if one month (or abbr) is a prefix of another
	    // see sorting in computeMonthsParse
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        if (strict && !this._longMonthsParse[i]) {
	            this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	            this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	        }
	        if (!strict && !this._monthsParse[i]) {
	            regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	            this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	            return i;
	        } else if (!strict && this._monthsParse[i].test(monthName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function setMonth (mom, value) {
	    var dayOfMonth;
	
	    if (!mom.isValid()) {
	        // No op
	        return mom;
	    }
	
	    if (typeof value === 'string') {
	        if (/^\d+$/.test(value)) {
	            value = toInt(value);
	        } else {
	            value = mom.localeData().monthsParse(value);
	            // TODO: Another silent failure?
	            if (!isNumber(value)) {
	                return mom;
	            }
	        }
	    }
	
	    dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	    mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	    return mom;
	}
	
	function getSetMonth (value) {
	    if (value != null) {
	        setMonth(this, value);
	        hooks.updateOffset(this, true);
	        return this;
	    } else {
	        return get(this, 'Month');
	    }
	}
	
	function getDaysInMonth () {
	    return daysInMonth(this.year(), this.month());
	}
	
	var defaultMonthsShortRegex = matchWord;
	function monthsShortRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsShortStrictRegex;
	        } else {
	            return this._monthsShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsShortRegex')) {
	            this._monthsShortRegex = defaultMonthsShortRegex;
	        }
	        return this._monthsShortStrictRegex && isStrict ?
	            this._monthsShortStrictRegex : this._monthsShortRegex;
	    }
	}
	
	var defaultMonthsRegex = matchWord;
	function monthsRegex (isStrict) {
	    if (this._monthsParseExact) {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            computeMonthsParse.call(this);
	        }
	        if (isStrict) {
	            return this._monthsStrictRegex;
	        } else {
	            return this._monthsRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_monthsRegex')) {
	            this._monthsRegex = defaultMonthsRegex;
	        }
	        return this._monthsStrictRegex && isStrict ?
	            this._monthsStrictRegex : this._monthsRegex;
	    }
	}
	
	function computeMonthsParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom;
	    for (i = 0; i < 12; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, i]);
	        shortPieces.push(this.monthsShort(mom, ''));
	        longPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.months(mom, ''));
	        mixedPieces.push(this.monthsShort(mom, ''));
	    }
	    // Sorting makes sure if one month (or abbr) is a prefix of another it
	    // will match the longer piece.
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 12; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	    }
	    for (i = 0; i < 24; i++) {
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._monthsShortRegex = this._monthsRegex;
	    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	addFormatToken('Y', 0, 0, function () {
	    var y = this.year();
	    return y <= 9999 ? '' + y : '+' + y;
	});
	
	addFormatToken(0, ['YY', 2], 0, function () {
	    return this.year() % 100;
	});
	
	addFormatToken(0, ['YYYY',   4],       0, 'year');
	addFormatToken(0, ['YYYYY',  5],       0, 'year');
	addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	// ALIASES
	
	addUnitAlias('year', 'y');
	
	// PRIORITIES
	
	addUnitPriority('year', 1);
	
	// PARSING
	
	addRegexToken('Y',      matchSigned);
	addRegexToken('YY',     match1to2, match2);
	addRegexToken('YYYY',   match1to4, match4);
	addRegexToken('YYYYY',  match1to6, match6);
	addRegexToken('YYYYYY', match1to6, match6);
	
	addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	addParseToken('YYYY', function (input, array) {
	    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	});
	addParseToken('YY', function (input, array) {
	    array[YEAR] = hooks.parseTwoDigitYear(input);
	});
	addParseToken('Y', function (input, array) {
	    array[YEAR] = parseInt(input, 10);
	});
	
	// HELPERS
	
	function daysInYear(year) {
	    return isLeapYear(year) ? 366 : 365;
	}
	
	function isLeapYear(year) {
	    return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	}
	
	// HOOKS
	
	hooks.parseTwoDigitYear = function (input) {
	    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	};
	
	// MOMENTS
	
	var getSetYear = makeGetSet('FullYear', true);
	
	function getIsLeapYear () {
	    return isLeapYear(this.year());
	}
	
	function createDate (y, m, d, h, M, s, ms) {
	    //can't just apply() to create a date:
	    //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
	    var date = new Date(y, m, d, h, M, s, ms);
	
	    //the date constructor remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	        date.setFullYear(y);
	    }
	    return date;
	}
	
	function createUTCDate (y) {
	    var date = new Date(Date.UTC.apply(null, arguments));
	
	    //the Date.UTC function remaps years 0-99 to 1900-1999
	    if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	        date.setUTCFullYear(y);
	    }
	    return date;
	}
	
	// start-of-first-week - start-of-year
	function firstWeekOffset(year, dow, doy) {
	    var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	        fwd = 7 + dow - doy,
	        // first-week day local weekday -- which local weekday is fwd
	        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	    return -fwdlw + fwd - 1;
	}
	
	//http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	    var localWeekday = (7 + weekday - dow) % 7,
	        weekOffset = firstWeekOffset(year, dow, doy),
	        dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	        resYear, resDayOfYear;
	
	    if (dayOfYear <= 0) {
	        resYear = year - 1;
	        resDayOfYear = daysInYear(resYear) + dayOfYear;
	    } else if (dayOfYear > daysInYear(year)) {
	        resYear = year + 1;
	        resDayOfYear = dayOfYear - daysInYear(year);
	    } else {
	        resYear = year;
	        resDayOfYear = dayOfYear;
	    }
	
	    return {
	        year: resYear,
	        dayOfYear: resDayOfYear
	    };
	}
	
	function weekOfYear(mom, dow, doy) {
	    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	        week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	        resWeek, resYear;
	
	    if (week < 1) {
	        resYear = mom.year() - 1;
	        resWeek = week + weeksInYear(resYear, dow, doy);
	    } else if (week > weeksInYear(mom.year(), dow, doy)) {
	        resWeek = week - weeksInYear(mom.year(), dow, doy);
	        resYear = mom.year() + 1;
	    } else {
	        resYear = mom.year();
	        resWeek = week;
	    }
	
	    return {
	        week: resWeek,
	        year: resYear
	    };
	}
	
	function weeksInYear(year, dow, doy) {
	    var weekOffset = firstWeekOffset(year, dow, doy),
	        weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	}
	
	// FORMATTING
	
	addFormatToken('w', ['ww', 2], 'wo', 'week');
	addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	// ALIASES
	
	addUnitAlias('week', 'w');
	addUnitAlias('isoWeek', 'W');
	
	// PRIORITIES
	
	addUnitPriority('week', 5);
	addUnitPriority('isoWeek', 5);
	
	// PARSING
	
	addRegexToken('w',  match1to2);
	addRegexToken('ww', match1to2, match2);
	addRegexToken('W',  match1to2);
	addRegexToken('WW', match1to2, match2);
	
	addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	    week[token.substr(0, 1)] = toInt(input);
	});
	
	// HELPERS
	
	// LOCALES
	
	function localeWeek (mom) {
	    return weekOfYear(mom, this._week.dow, this._week.doy).week;
	}
	
	var defaultLocaleWeek = {
	    dow : 0, // Sunday is the first day of the week.
	    doy : 6  // The week that contains Jan 1st is the first week of the year.
	};
	
	function localeFirstDayOfWeek () {
	    return this._week.dow;
	}
	
	function localeFirstDayOfYear () {
	    return this._week.doy;
	}
	
	// MOMENTS
	
	function getSetWeek (input) {
	    var week = this.localeData().week(this);
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	function getSetISOWeek (input) {
	    var week = weekOfYear(this, 1, 4).week;
	    return input == null ? week : this.add((input - week) * 7, 'd');
	}
	
	// FORMATTING
	
	addFormatToken('d', 0, 'do', 'day');
	
	addFormatToken('dd', 0, 0, function (format) {
	    return this.localeData().weekdaysMin(this, format);
	});
	
	addFormatToken('ddd', 0, 0, function (format) {
	    return this.localeData().weekdaysShort(this, format);
	});
	
	addFormatToken('dddd', 0, 0, function (format) {
	    return this.localeData().weekdays(this, format);
	});
	
	addFormatToken('e', 0, 0, 'weekday');
	addFormatToken('E', 0, 0, 'isoWeekday');
	
	// ALIASES
	
	addUnitAlias('day', 'd');
	addUnitAlias('weekday', 'e');
	addUnitAlias('isoWeekday', 'E');
	
	// PRIORITY
	addUnitPriority('day', 11);
	addUnitPriority('weekday', 11);
	addUnitPriority('isoWeekday', 11);
	
	// PARSING
	
	addRegexToken('d',    match1to2);
	addRegexToken('e',    match1to2);
	addRegexToken('E',    match1to2);
	addRegexToken('dd',   function (isStrict, locale) {
	    return locale.weekdaysMinRegex(isStrict);
	});
	addRegexToken('ddd',   function (isStrict, locale) {
	    return locale.weekdaysShortRegex(isStrict);
	});
	addRegexToken('dddd',   function (isStrict, locale) {
	    return locale.weekdaysRegex(isStrict);
	});
	
	addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	    var weekday = config._locale.weekdaysParse(input, token, config._strict);
	    // if we didn't get a weekday name, mark the date as invalid
	    if (weekday != null) {
	        week.d = weekday;
	    } else {
	        getParsingFlags(config).invalidWeekday = input;
	    }
	});
	
	addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	    week[token] = toInt(input);
	});
	
	// HELPERS
	
	function parseWeekday(input, locale) {
	    if (typeof input !== 'string') {
	        return input;
	    }
	
	    if (!isNaN(input)) {
	        return parseInt(input, 10);
	    }
	
	    input = locale.weekdaysParse(input);
	    if (typeof input === 'number') {
	        return input;
	    }
	
	    return null;
	}
	
	function parseIsoWeekday(input, locale) {
	    if (typeof input === 'string') {
	        return locale.weekdaysParse(input) % 7 || 7;
	    }
	    return isNaN(input) ? null : input;
	}
	
	// LOCALES
	
	var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	function localeWeekdays (m, format) {
	    if (!m) {
	        return this._weekdays;
	    }
	    return isArray(this._weekdays) ? this._weekdays[m.day()] :
	        this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	}
	
	var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	function localeWeekdaysShort (m) {
	    return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	}
	
	var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	function localeWeekdaysMin (m) {
	    return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	}
	
	function handleStrictParse$1(weekdayName, format, strict) {
	    var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._minWeekdaysParse = [];
	
	        for (i = 0; i < 7; ++i) {
	            mom = createUTC([2000, 1]).day(i);
	            this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	            this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	            this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	        }
	    }
	
	    if (strict) {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    } else {
	        if (format === 'dddd') {
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else if (format === 'ddd') {
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        } else {
	            ii = indexOf$1.call(this._minWeekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._weekdaysParse, llc);
	            if (ii !== -1) {
	                return ii;
	            }
	            ii = indexOf$1.call(this._shortWeekdaysParse, llc);
	            return ii !== -1 ? ii : null;
	        }
	    }
	}
	
	function localeWeekdaysParse (weekdayName, format, strict) {
	    var i, mom, regex;
	
	    if (this._weekdaysParseExact) {
	        return handleStrictParse$1.call(this, weekdayName, format, strict);
	    }
	
	    if (!this._weekdaysParse) {
	        this._weekdaysParse = [];
	        this._minWeekdaysParse = [];
	        this._shortWeekdaysParse = [];
	        this._fullWeekdaysParse = [];
	    }
	
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	
	        mom = createUTC([2000, 1]).day(i);
	        if (strict && !this._fullWeekdaysParse[i]) {
	            this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	            this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	            this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	        }
	        if (!this._weekdaysParse[i]) {
	            regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	            this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	        }
	        // test the regex
	        if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	            return i;
	        } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	            return i;
	        }
	    }
	}
	
	// MOMENTS
	
	function getSetDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	    if (input != null) {
	        input = parseWeekday(input, this.localeData());
	        return this.add(input - day, 'd');
	    } else {
	        return day;
	    }
	}
	
	function getSetLocaleDayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	    return input == null ? weekday : this.add(input - weekday, 'd');
	}
	
	function getSetISODayOfWeek (input) {
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	
	    // behaves the same as moment#day except
	    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	    // as a setter, sunday should belong to the previous week.
	
	    if (input != null) {
	        var weekday = parseIsoWeekday(input, this.localeData());
	        return this.day(this.day() % 7 ? weekday : weekday - 7);
	    } else {
	        return this.day() || 7;
	    }
	}
	
	var defaultWeekdaysRegex = matchWord;
	function weekdaysRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysStrictRegex;
	        } else {
	            return this._weekdaysRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            this._weekdaysRegex = defaultWeekdaysRegex;
	        }
	        return this._weekdaysStrictRegex && isStrict ?
	            this._weekdaysStrictRegex : this._weekdaysRegex;
	    }
	}
	
	var defaultWeekdaysShortRegex = matchWord;
	function weekdaysShortRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysShortStrictRegex;
	        } else {
	            return this._weekdaysShortRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	            this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	        }
	        return this._weekdaysShortStrictRegex && isStrict ?
	            this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	    }
	}
	
	var defaultWeekdaysMinRegex = matchWord;
	function weekdaysMinRegex (isStrict) {
	    if (this._weekdaysParseExact) {
	        if (!hasOwnProp(this, '_weekdaysRegex')) {
	            computeWeekdaysParse.call(this);
	        }
	        if (isStrict) {
	            return this._weekdaysMinStrictRegex;
	        } else {
	            return this._weekdaysMinRegex;
	        }
	    } else {
	        if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	            this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	        }
	        return this._weekdaysMinStrictRegex && isStrict ?
	            this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	    }
	}
	
	
	function computeWeekdaysParse () {
	    function cmpLenRev(a, b) {
	        return b.length - a.length;
	    }
	
	    var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	        i, mom, minp, shortp, longp;
	    for (i = 0; i < 7; i++) {
	        // make the regex if we don't have it already
	        mom = createUTC([2000, 1]).day(i);
	        minp = this.weekdaysMin(mom, '');
	        shortp = this.weekdaysShort(mom, '');
	        longp = this.weekdays(mom, '');
	        minPieces.push(minp);
	        shortPieces.push(shortp);
	        longPieces.push(longp);
	        mixedPieces.push(minp);
	        mixedPieces.push(shortp);
	        mixedPieces.push(longp);
	    }
	    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	    // will match the longer piece.
	    minPieces.sort(cmpLenRev);
	    shortPieces.sort(cmpLenRev);
	    longPieces.sort(cmpLenRev);
	    mixedPieces.sort(cmpLenRev);
	    for (i = 0; i < 7; i++) {
	        shortPieces[i] = regexEscape(shortPieces[i]);
	        longPieces[i] = regexEscape(longPieces[i]);
	        mixedPieces[i] = regexEscape(mixedPieces[i]);
	    }
	
	    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	    this._weekdaysShortRegex = this._weekdaysRegex;
	    this._weekdaysMinRegex = this._weekdaysRegex;
	
	    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	}
	
	// FORMATTING
	
	function hFormat() {
	    return this.hours() % 12 || 12;
	}
	
	function kFormat() {
	    return this.hours() || 24;
	}
	
	addFormatToken('H', ['HH', 2], 0, 'hour');
	addFormatToken('h', ['hh', 2], 0, hFormat);
	addFormatToken('k', ['kk', 2], 0, kFormat);
	
	addFormatToken('hmm', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('hmmss', 0, 0, function () {
	    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	addFormatToken('Hmm', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2);
	});
	
	addFormatToken('Hmmss', 0, 0, function () {
	    return '' + this.hours() + zeroFill(this.minutes(), 2) +
	        zeroFill(this.seconds(), 2);
	});
	
	function meridiem (token, lowercase) {
	    addFormatToken(token, 0, 0, function () {
	        return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	    });
	}
	
	meridiem('a', true);
	meridiem('A', false);
	
	// ALIASES
	
	addUnitAlias('hour', 'h');
	
	// PRIORITY
	addUnitPriority('hour', 13);
	
	// PARSING
	
	function matchMeridiem (isStrict, locale) {
	    return locale._meridiemParse;
	}
	
	addRegexToken('a',  matchMeridiem);
	addRegexToken('A',  matchMeridiem);
	addRegexToken('H',  match1to2);
	addRegexToken('h',  match1to2);
	addRegexToken('HH', match1to2, match2);
	addRegexToken('hh', match1to2, match2);
	
	addRegexToken('hmm', match3to4);
	addRegexToken('hmmss', match5to6);
	addRegexToken('Hmm', match3to4);
	addRegexToken('Hmmss', match5to6);
	
	addParseToken(['H', 'HH'], HOUR);
	addParseToken(['a', 'A'], function (input, array, config) {
	    config._isPm = config._locale.isPM(input);
	    config._meridiem = input;
	});
	addParseToken(['h', 'hh'], function (input, array, config) {
	    array[HOUR] = toInt(input);
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	    getParsingFlags(config).bigHour = true;
	});
	addParseToken('Hmm', function (input, array, config) {
	    var pos = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos));
	    array[MINUTE] = toInt(input.substr(pos));
	});
	addParseToken('Hmmss', function (input, array, config) {
	    var pos1 = input.length - 4;
	    var pos2 = input.length - 2;
	    array[HOUR] = toInt(input.substr(0, pos1));
	    array[MINUTE] = toInt(input.substr(pos1, 2));
	    array[SECOND] = toInt(input.substr(pos2));
	});
	
	// LOCALES
	
	function localeIsPM (input) {
	    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	    // Using charAt should be more compatible.
	    return ((input + '').toLowerCase().charAt(0) === 'p');
	}
	
	var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	function localeMeridiem (hours, minutes, isLower) {
	    if (hours > 11) {
	        return isLower ? 'pm' : 'PM';
	    } else {
	        return isLower ? 'am' : 'AM';
	    }
	}
	
	
	// MOMENTS
	
	// Setting the hour should keep the time, because the user explicitly
	// specified which hour he wants. So trying to maintain the same hour (in
	// a new timezone) makes sense. Adding/subtracting hours does not follow
	// this rule.
	var getSetHour = makeGetSet('Hours', true);
	
	// months
	// week
	// weekdays
	// meridiem
	var baseConfig = {
	    calendar: defaultCalendar,
	    longDateFormat: defaultLongDateFormat,
	    invalidDate: defaultInvalidDate,
	    ordinal: defaultOrdinal,
	    ordinalParse: defaultOrdinalParse,
	    relativeTime: defaultRelativeTime,
	
	    months: defaultLocaleMonths,
	    monthsShort: defaultLocaleMonthsShort,
	
	    week: defaultLocaleWeek,
	
	    weekdays: defaultLocaleWeekdays,
	    weekdaysMin: defaultLocaleWeekdaysMin,
	    weekdaysShort: defaultLocaleWeekdaysShort,
	
	    meridiemParse: defaultLocaleMeridiemParse
	};
	
	// internal storage for locale config files
	var locales = {};
	var localeFamilies = {};
	var globalLocale;
	
	function normalizeLocale(key) {
	    return key ? key.toLowerCase().replace('_', '-') : key;
	}
	
	// pick the locale from the array
	// try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	// substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	function chooseLocale(names) {
	    var i = 0, j, next, locale, split;
	
	    while (i < names.length) {
	        split = normalizeLocale(names[i]).split('-');
	        j = split.length;
	        next = normalizeLocale(names[i + 1]);
	        next = next ? next.split('-') : null;
	        while (j > 0) {
	            locale = loadLocale(split.slice(0, j).join('-'));
	            if (locale) {
	                return locale;
	            }
	            if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                //the next array item is better than a shallower substring of this one
	                break;
	            }
	            j--;
	        }
	        i++;
	    }
	    return null;
	}
	
	function loadLocale(name) {
	    var oldLocale = null;
	    // TODO: Find a better way to register and load all the locales in Node
	    if (!locales[name] && (typeof module !== 'undefined') &&
	            module && module.exports) {
	        try {
	            oldLocale = globalLocale._abbr;
	            __webpack_require__(86)("./" + name);
	            // because defineLocale currently also sets the global locale, we
	            // want to undo that for lazy loaded locales
	            getSetGlobalLocale(oldLocale);
	        } catch (e) { }
	    }
	    return locales[name];
	}
	
	// This function will load locale and then set the global locale.  If
	// no arguments are passed in, it will simply return the current global
	// locale key.
	function getSetGlobalLocale (key, values) {
	    var data;
	    if (key) {
	        if (isUndefined(values)) {
	            data = getLocale(key);
	        }
	        else {
	            data = defineLocale(key, values);
	        }
	
	        if (data) {
	            // moment.duration._locale = moment._locale = data;
	            globalLocale = data;
	        }
	    }
	
	    return globalLocale._abbr;
	}
	
	function defineLocale (name, config) {
	    if (config !== null) {
	        var parentConfig = baseConfig;
	        config.abbr = name;
	        if (locales[name] != null) {
	            deprecateSimple('defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                    'an existing locale. moment.defineLocale(localeName, ' +
	                    'config) should only be used for creating a new locale ' +
	                    'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	            parentConfig = locales[name]._config;
	        } else if (config.parentLocale != null) {
	            if (locales[config.parentLocale] != null) {
	                parentConfig = locales[config.parentLocale]._config;
	            } else {
	                if (!localeFamilies[config.parentLocale]) {
	                    localeFamilies[config.parentLocale] = [];
	                }
	                localeFamilies[config.parentLocale].push({
	                    name: name,
	                    config: config
	                });
	                return null;
	            }
	        }
	        locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	        if (localeFamilies[name]) {
	            localeFamilies[name].forEach(function (x) {
	                defineLocale(x.name, x.config);
	            });
	        }
	
	        // backwards compat for now: also set the locale
	        // make sure we set the locale AFTER all child locales have been
	        // created, so we won't end up with the child locale set.
	        getSetGlobalLocale(name);
	
	
	        return locales[name];
	    } else {
	        // useful for testing
	        delete locales[name];
	        return null;
	    }
	}
	
	function updateLocale(name, config) {
	    if (config != null) {
	        var locale, parentConfig = baseConfig;
	        // MERGE
	        if (locales[name] != null) {
	            parentConfig = locales[name]._config;
	        }
	        config = mergeConfigs(parentConfig, config);
	        locale = new Locale(config);
	        locale.parentLocale = locales[name];
	        locales[name] = locale;
	
	        // backwards compat for now: also set the locale
	        getSetGlobalLocale(name);
	    } else {
	        // pass null for config to unupdate, useful for tests
	        if (locales[name] != null) {
	            if (locales[name].parentLocale != null) {
	                locales[name] = locales[name].parentLocale;
	            } else if (locales[name] != null) {
	                delete locales[name];
	            }
	        }
	    }
	    return locales[name];
	}
	
	// returns locale data
	function getLocale (key) {
	    var locale;
	
	    if (key && key._locale && key._locale._abbr) {
	        key = key._locale._abbr;
	    }
	
	    if (!key) {
	        return globalLocale;
	    }
	
	    if (!isArray(key)) {
	        //short-circuit everything else
	        locale = loadLocale(key);
	        if (locale) {
	            return locale;
	        }
	        key = [key];
	    }
	
	    return chooseLocale(key);
	}
	
	function listLocales() {
	    return keys$1(locales);
	}
	
	function checkOverflow (m) {
	    var overflow;
	    var a = m._a;
	
	    if (a && getParsingFlags(m).overflow === -2) {
	        overflow =
	            a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	            a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	            a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	            a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	            a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	            a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	            -1;
	
	        if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	            overflow = DATE;
	        }
	        if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	            overflow = WEEK;
	        }
	        if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	            overflow = WEEKDAY;
	        }
	
	        getParsingFlags(m).overflow = overflow;
	    }
	
	    return m;
	}
	
	// iso 8601 regex
	// 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
	
	var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	var isoDates = [
	    ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	    ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	    ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	    ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	    ['YYYY-DDD', /\d{4}-\d{3}/],
	    ['YYYY-MM', /\d{4}-\d\d/, false],
	    ['YYYYYYMMDD', /[+-]\d{10}/],
	    ['YYYYMMDD', /\d{8}/],
	    // YYYYMM is NOT allowed by the standard
	    ['GGGG[W]WWE', /\d{4}W\d{3}/],
	    ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	    ['YYYYDDD', /\d{7}/]
	];
	
	// iso time formats and regexes
	var isoTimes = [
	    ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	    ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	    ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	    ['HH:mm', /\d\d:\d\d/],
	    ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	    ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	    ['HHmmss', /\d\d\d\d\d\d/],
	    ['HHmm', /\d\d\d\d/],
	    ['HH', /\d\d/]
	];
	
	var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	// date from iso format
	function configFromISO(config) {
	    var i, l,
	        string = config._i,
	        match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	        allowTime, dateFormat, timeFormat, tzFormat;
	
	    if (match) {
	        getParsingFlags(config).iso = true;
	
	        for (i = 0, l = isoDates.length; i < l; i++) {
	            if (isoDates[i][1].exec(match[1])) {
	                dateFormat = isoDates[i][0];
	                allowTime = isoDates[i][2] !== false;
	                break;
	            }
	        }
	        if (dateFormat == null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[3]) {
	            for (i = 0, l = isoTimes.length; i < l; i++) {
	                if (isoTimes[i][1].exec(match[3])) {
	                    // match[2] should be 'T' or space
	                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                    break;
	                }
	            }
	            if (timeFormat == null) {
	                config._isValid = false;
	                return;
	            }
	        }
	        if (!allowTime && timeFormat != null) {
	            config._isValid = false;
	            return;
	        }
	        if (match[4]) {
	            if (tzRegex.exec(match[4])) {
	                tzFormat = 'Z';
	            } else {
	                config._isValid = false;
	                return;
	            }
	        }
	        config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	        configFromStringAndFormat(config);
	    } else {
	        config._isValid = false;
	    }
	}
	
	// date from iso format or fallback
	function configFromString(config) {
	    var matched = aspNetJsonRegex.exec(config._i);
	
	    if (matched !== null) {
	        config._d = new Date(+matched[1]);
	        return;
	    }
	
	    configFromISO(config);
	    if (config._isValid === false) {
	        delete config._isValid;
	        hooks.createFromInputFallback(config);
	    }
	}
	
	hooks.createFromInputFallback = deprecate(
	    'value provided is not in a recognized ISO format. moment construction falls back to js Date(), ' +
	    'which is not reliable across all browsers and versions. Non ISO date formats are ' +
	    'discouraged and will be removed in an upcoming major release. Please refer to ' +
	    'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	    function (config) {
	        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	    }
	);
	
	// Pick the first defined of two or three arguments.
	function defaults(a, b, c) {
	    if (a != null) {
	        return a;
	    }
	    if (b != null) {
	        return b;
	    }
	    return c;
	}
	
	function currentDateArray(config) {
	    // hooks is actually the exported moment object
	    var nowValue = new Date(hooks.now());
	    if (config._useUTC) {
	        return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	    }
	    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	}
	
	// convert an array to a date.
	// the array should mirror the parameters below
	// note: all values past the year are optional and will default to the lowest possible value.
	// [year, month, day , hour, minute, second, millisecond]
	function configFromArray (config) {
	    var i, date, input = [], currentDate, yearToUse;
	
	    if (config._d) {
	        return;
	    }
	
	    currentDate = currentDateArray(config);
	
	    //compute day of the year from weeks and weekdays
	    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	        dayOfYearFromWeekInfo(config);
	    }
	
	    //if the day of the year is set, figure out what it is
	    if (config._dayOfYear) {
	        yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	        if (config._dayOfYear > daysInYear(yearToUse)) {
	            getParsingFlags(config)._overflowDayOfYear = true;
	        }
	
	        date = createUTCDate(yearToUse, 0, config._dayOfYear);
	        config._a[MONTH] = date.getUTCMonth();
	        config._a[DATE] = date.getUTCDate();
	    }
	
	    // Default to current date.
	    // * if no year, month, day of month are given, default to today
	    // * if day of month is given, default month and year
	    // * if month is given, default only year
	    // * if year is given, don't default anything
	    for (i = 0; i < 3 && config._a[i] == null; ++i) {
	        config._a[i] = input[i] = currentDate[i];
	    }
	
	    // Zero out whatever was not defaulted, including time
	    for (; i < 7; i++) {
	        config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	    }
	
	    // Check for 24:00:00.000
	    if (config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0) {
	        config._nextDay = true;
	        config._a[HOUR] = 0;
	    }
	
	    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	    // Apply timezone offset from input. The actual utcOffset can be changed
	    // with parseZone.
	    if (config._tzm != null) {
	        config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	    }
	
	    if (config._nextDay) {
	        config._a[HOUR] = 24;
	    }
	}
	
	function dayOfYearFromWeekInfo(config) {
	    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	    w = config._w;
	    if (w.GG != null || w.W != null || w.E != null) {
	        dow = 1;
	        doy = 4;
	
	        // TODO: We need to take the current isoWeekYear, but that depends on
	        // how we interpret now (local, utc, fixed offset). So create
	        // a now version of current config (take local/utc/offset flags, and
	        // create now).
	        weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
	        week = defaults(w.W, 1);
	        weekday = defaults(w.E, 1);
	        if (weekday < 1 || weekday > 7) {
	            weekdayOverflow = true;
	        }
	    } else {
	        dow = config._locale._week.dow;
	        doy = config._locale._week.doy;
	
	        var curWeek = weekOfYear(createLocal(), dow, doy);
	
	        weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	        // Default to current week.
	        week = defaults(w.w, curWeek.week);
	
	        if (w.d != null) {
	            // weekday -- low day numbers are considered next week
	            weekday = w.d;
	            if (weekday < 0 || weekday > 6) {
	                weekdayOverflow = true;
	            }
	        } else if (w.e != null) {
	            // local weekday -- counting starts from begining of week
	            weekday = w.e + dow;
	            if (w.e < 0 || w.e > 6) {
	                weekdayOverflow = true;
	            }
	        } else {
	            // default to begining of week
	            weekday = dow;
	        }
	    }
	    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	        getParsingFlags(config)._overflowWeeks = true;
	    } else if (weekdayOverflow != null) {
	        getParsingFlags(config)._overflowWeekday = true;
	    } else {
	        temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	        config._a[YEAR] = temp.year;
	        config._dayOfYear = temp.dayOfYear;
	    }
	}
	
	// constant that refers to the ISO standard
	hooks.ISO_8601 = function () {};
	
	// date from string and format string
	function configFromStringAndFormat(config) {
	    // TODO: Move this to another part of the creation flow to prevent circular deps
	    if (config._f === hooks.ISO_8601) {
	        configFromISO(config);
	        return;
	    }
	
	    config._a = [];
	    getParsingFlags(config).empty = true;
	
	    // This array is used to make a Date, either with `new Date` or `Date.UTC`
	    var string = '' + config._i,
	        i, parsedInput, tokens, token, skipped,
	        stringLength = string.length,
	        totalParsedInputLength = 0;
	
	    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	    for (i = 0; i < tokens.length; i++) {
	        token = tokens[i];
	        parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	        // console.log('token', token, 'parsedInput', parsedInput,
	        //         'regex', getParseRegexForToken(token, config));
	        if (parsedInput) {
	            skipped = string.substr(0, string.indexOf(parsedInput));
	            if (skipped.length > 0) {
	                getParsingFlags(config).unusedInput.push(skipped);
	            }
	            string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	            totalParsedInputLength += parsedInput.length;
	        }
	        // don't parse if it's not a known token
	        if (formatTokenFunctions[token]) {
	            if (parsedInput) {
	                getParsingFlags(config).empty = false;
	            }
	            else {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	            addTimeToArrayFromToken(token, parsedInput, config);
	        }
	        else if (config._strict && !parsedInput) {
	            getParsingFlags(config).unusedTokens.push(token);
	        }
	    }
	
	    // add remaining unparsed input length to the string
	    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	    if (string.length > 0) {
	        getParsingFlags(config).unusedInput.push(string);
	    }
	
	    // clear _12h flag if hour is <= 12
	    if (config._a[HOUR] <= 12 &&
	        getParsingFlags(config).bigHour === true &&
	        config._a[HOUR] > 0) {
	        getParsingFlags(config).bigHour = undefined;
	    }
	
	    getParsingFlags(config).parsedDateParts = config._a.slice(0);
	    getParsingFlags(config).meridiem = config._meridiem;
	    // handle meridiem
	    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	    configFromArray(config);
	    checkOverflow(config);
	}
	
	
	function meridiemFixWrap (locale, hour, meridiem) {
	    var isPm;
	
	    if (meridiem == null) {
	        // nothing to do
	        return hour;
	    }
	    if (locale.meridiemHour != null) {
	        return locale.meridiemHour(hour, meridiem);
	    } else if (locale.isPM != null) {
	        // Fallback
	        isPm = locale.isPM(meridiem);
	        if (isPm && hour < 12) {
	            hour += 12;
	        }
	        if (!isPm && hour === 12) {
	            hour = 0;
	        }
	        return hour;
	    } else {
	        // this is not supposed to happen
	        return hour;
	    }
	}
	
	// date from string and array of format strings
	function configFromStringAndArray(config) {
	    var tempConfig,
	        bestMoment,
	
	        scoreToBeat,
	        i,
	        currentScore;
	
	    if (config._f.length === 0) {
	        getParsingFlags(config).invalidFormat = true;
	        config._d = new Date(NaN);
	        return;
	    }
	
	    for (i = 0; i < config._f.length; i++) {
	        currentScore = 0;
	        tempConfig = copyConfig({}, config);
	        if (config._useUTC != null) {
	            tempConfig._useUTC = config._useUTC;
	        }
	        tempConfig._f = config._f[i];
	        configFromStringAndFormat(tempConfig);
	
	        if (!isValid(tempConfig)) {
	            continue;
	        }
	
	        // if there is any input that was not parsed add a penalty for that format
	        currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	        //or tokens
	        currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	        getParsingFlags(tempConfig).score = currentScore;
	
	        if (scoreToBeat == null || currentScore < scoreToBeat) {
	            scoreToBeat = currentScore;
	            bestMoment = tempConfig;
	        }
	    }
	
	    extend(config, bestMoment || tempConfig);
	}
	
	function configFromObject(config) {
	    if (config._d) {
	        return;
	    }
	
	    var i = normalizeObjectUnits(config._i);
	    config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	        return obj && parseInt(obj, 10);
	    });
	
	    configFromArray(config);
	}
	
	function createFromConfig (config) {
	    var res = new Moment(checkOverflow(prepareConfig(config)));
	    if (res._nextDay) {
	        // Adding is smart enough around DST
	        res.add(1, 'd');
	        res._nextDay = undefined;
	    }
	
	    return res;
	}
	
	function prepareConfig (config) {
	    var input = config._i,
	        format = config._f;
	
	    config._locale = config._locale || getLocale(config._l);
	
	    if (input === null || (format === undefined && input === '')) {
	        return createInvalid({nullInput: true});
	    }
	
	    if (typeof input === 'string') {
	        config._i = input = config._locale.preparse(input);
	    }
	
	    if (isMoment(input)) {
	        return new Moment(checkOverflow(input));
	    } else if (isDate(input)) {
	        config._d = input;
	    } else if (isArray(format)) {
	        configFromStringAndArray(config);
	    } else if (format) {
	        configFromStringAndFormat(config);
	    }  else {
	        configFromInput(config);
	    }
	
	    if (!isValid(config)) {
	        config._d = null;
	    }
	
	    return config;
	}
	
	function configFromInput(config) {
	    var input = config._i;
	    if (input === undefined) {
	        config._d = new Date(hooks.now());
	    } else if (isDate(input)) {
	        config._d = new Date(input.valueOf());
	    } else if (typeof input === 'string') {
	        configFromString(config);
	    } else if (isArray(input)) {
	        config._a = map(input.slice(0), function (obj) {
	            return parseInt(obj, 10);
	        });
	        configFromArray(config);
	    } else if (typeof(input) === 'object') {
	        configFromObject(config);
	    } else if (isNumber(input)) {
	        // from milliseconds
	        config._d = new Date(input);
	    } else {
	        hooks.createFromInputFallback(config);
	    }
	}
	
	function createLocalOrUTC (input, format, locale, strict, isUTC) {
	    var c = {};
	
	    if (locale === true || locale === false) {
	        strict = locale;
	        locale = undefined;
	    }
	
	    if ((isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)) {
	        input = undefined;
	    }
	    // object construction must be done this way.
	    // https://github.com/moment/moment/issues/1423
	    c._isAMomentObject = true;
	    c._useUTC = c._isUTC = isUTC;
	    c._l = locale;
	    c._i = input;
	    c._f = format;
	    c._strict = strict;
	
	    return createFromConfig(c);
	}
	
	function createLocal (input, format, locale, strict) {
	    return createLocalOrUTC(input, format, locale, strict, false);
	}
	
	var prototypeMin = deprecate(
	    'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other < this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	var prototypeMax = deprecate(
	    'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	    function () {
	        var other = createLocal.apply(null, arguments);
	        if (this.isValid() && other.isValid()) {
	            return other > this ? this : other;
	        } else {
	            return createInvalid();
	        }
	    }
	);
	
	// Pick a moment m from moments so that m[fn](other) is true for all
	// other. This relies on the function fn to be transitive.
	//
	// moments should either be an array of moment objects or an array, whose
	// first element is an array of moment objects.
	function pickBy(fn, moments) {
	    var res, i;
	    if (moments.length === 1 && isArray(moments[0])) {
	        moments = moments[0];
	    }
	    if (!moments.length) {
	        return createLocal();
	    }
	    res = moments[0];
	    for (i = 1; i < moments.length; ++i) {
	        if (!moments[i].isValid() || moments[i][fn](res)) {
	            res = moments[i];
	        }
	    }
	    return res;
	}
	
	// TODO: Use [].sort instead?
	function min () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isBefore', args);
	}
	
	function max () {
	    var args = [].slice.call(arguments, 0);
	
	    return pickBy('isAfter', args);
	}
	
	var now = function () {
	    return Date.now ? Date.now() : +(new Date());
	};
	
	function Duration (duration) {
	    var normalizedInput = normalizeObjectUnits(duration),
	        years = normalizedInput.year || 0,
	        quarters = normalizedInput.quarter || 0,
	        months = normalizedInput.month || 0,
	        weeks = normalizedInput.week || 0,
	        days = normalizedInput.day || 0,
	        hours = normalizedInput.hour || 0,
	        minutes = normalizedInput.minute || 0,
	        seconds = normalizedInput.second || 0,
	        milliseconds = normalizedInput.millisecond || 0;
	
	    // representation for dateAddRemove
	    this._milliseconds = +milliseconds +
	        seconds * 1e3 + // 1000
	        minutes * 6e4 + // 1000 * 60
	        hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	    // Because of dateAddRemove treats 24 hours as different from a
	    // day when working around DST, we need to store them separately
	    this._days = +days +
	        weeks * 7;
	    // It is impossible translate months into days without knowing
	    // which months you are are talking about, so we have to store
	    // it separately.
	    this._months = +months +
	        quarters * 3 +
	        years * 12;
	
	    this._data = {};
	
	    this._locale = getLocale();
	
	    this._bubble();
	}
	
	function isDuration (obj) {
	    return obj instanceof Duration;
	}
	
	function absRound (number) {
	    if (number < 0) {
	        return Math.round(-1 * number) * -1;
	    } else {
	        return Math.round(number);
	    }
	}
	
	// FORMATTING
	
	function offset (token, separator) {
	    addFormatToken(token, 0, 0, function () {
	        var offset = this.utcOffset();
	        var sign = '+';
	        if (offset < 0) {
	            offset = -offset;
	            sign = '-';
	        }
	        return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	    });
	}
	
	offset('Z', ':');
	offset('ZZ', '');
	
	// PARSING
	
	addRegexToken('Z',  matchShortOffset);
	addRegexToken('ZZ', matchShortOffset);
	addParseToken(['Z', 'ZZ'], function (input, array, config) {
	    config._useUTC = true;
	    config._tzm = offsetFromString(matchShortOffset, input);
	});
	
	// HELPERS
	
	// timezone chunker
	// '+10:00' > ['10',  '00']
	// '-1530'  > ['-15', '30']
	var chunkOffset = /([\+\-]|\d\d)/gi;
	
	function offsetFromString(matcher, string) {
	    var matches = (string || '').match(matcher);
	
	    if (matches === null) {
	        return null;
	    }
	
	    var chunk   = matches[matches.length - 1] || [];
	    var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	    var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	    return minutes === 0 ?
	      0 :
	      parts[0] === '+' ? minutes : -minutes;
	}
	
	// Return a moment from input, that is local/utc/zone equivalent to model.
	function cloneWithOffset(input, model) {
	    var res, diff;
	    if (model._isUTC) {
	        res = model.clone();
	        diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
	        // Use low-level api, because this fn is low-level api.
	        res._d.setTime(res._d.valueOf() + diff);
	        hooks.updateOffset(res, false);
	        return res;
	    } else {
	        return createLocal(input).local();
	    }
	}
	
	function getDateOffset (m) {
	    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	    // https://github.com/moment/moment/pull/1871
	    return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	}
	
	// HOOKS
	
	// This function will be called whenever a moment is mutated.
	// It is intended to keep the offset in sync with the timezone.
	hooks.updateOffset = function () {};
	
	// MOMENTS
	
	// keepLocalTime = true means only change the timezone, without
	// affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	// 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	// +0200, so we adjust the time as needed, to be valid.
	//
	// Keeping the time actually adds/subtracts (one hour)
	// from the actual represented time. That is why we call updateOffset
	// a second time. In case it wants us to change the offset again
	// _changeInProgress == true case, then we have to adjust, because
	// there is no such time in the given timezone.
	function getSetOffset (input, keepLocalTime) {
	    var offset = this._offset || 0,
	        localAdjust;
	    if (!this.isValid()) {
	        return input != null ? this : NaN;
	    }
	    if (input != null) {
	        if (typeof input === 'string') {
	            input = offsetFromString(matchShortOffset, input);
	            if (input === null) {
	                return this;
	            }
	        } else if (Math.abs(input) < 16) {
	            input = input * 60;
	        }
	        if (!this._isUTC && keepLocalTime) {
	            localAdjust = getDateOffset(this);
	        }
	        this._offset = input;
	        this._isUTC = true;
	        if (localAdjust != null) {
	            this.add(localAdjust, 'm');
	        }
	        if (offset !== input) {
	            if (!keepLocalTime || this._changeInProgress) {
	                addSubtract(this, createDuration(input - offset, 'm'), 1, false);
	            } else if (!this._changeInProgress) {
	                this._changeInProgress = true;
	                hooks.updateOffset(this, true);
	                this._changeInProgress = null;
	            }
	        }
	        return this;
	    } else {
	        return this._isUTC ? offset : getDateOffset(this);
	    }
	}
	
	function getSetZone (input, keepLocalTime) {
	    if (input != null) {
	        if (typeof input !== 'string') {
	            input = -input;
	        }
	
	        this.utcOffset(input, keepLocalTime);
	
	        return this;
	    } else {
	        return -this.utcOffset();
	    }
	}
	
	function setOffsetToUTC (keepLocalTime) {
	    return this.utcOffset(0, keepLocalTime);
	}
	
	function setOffsetToLocal (keepLocalTime) {
	    if (this._isUTC) {
	        this.utcOffset(0, keepLocalTime);
	        this._isUTC = false;
	
	        if (keepLocalTime) {
	            this.subtract(getDateOffset(this), 'm');
	        }
	    }
	    return this;
	}
	
	function setOffsetToParsedOffset () {
	    if (this._tzm != null) {
	        this.utcOffset(this._tzm);
	    } else if (typeof this._i === 'string') {
	        var tZone = offsetFromString(matchOffset, this._i);
	        if (tZone != null) {
	            this.utcOffset(tZone);
	        }
	        else {
	            this.utcOffset(0, true);
	        }
	    }
	    return this;
	}
	
	function hasAlignedHourOffset (input) {
	    if (!this.isValid()) {
	        return false;
	    }
	    input = input ? createLocal(input).utcOffset() : 0;
	
	    return (this.utcOffset() - input) % 60 === 0;
	}
	
	function isDaylightSavingTime () {
	    return (
	        this.utcOffset() > this.clone().month(0).utcOffset() ||
	        this.utcOffset() > this.clone().month(5).utcOffset()
	    );
	}
	
	function isDaylightSavingTimeShifted () {
	    if (!isUndefined(this._isDSTShifted)) {
	        return this._isDSTShifted;
	    }
	
	    var c = {};
	
	    copyConfig(c, this);
	    c = prepareConfig(c);
	
	    if (c._a) {
	        var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	        this._isDSTShifted = this.isValid() &&
	            compareArrays(c._a, other.toArray()) > 0;
	    } else {
	        this._isDSTShifted = false;
	    }
	
	    return this._isDSTShifted;
	}
	
	function isLocal () {
	    return this.isValid() ? !this._isUTC : false;
	}
	
	function isUtcOffset () {
	    return this.isValid() ? this._isUTC : false;
	}
	
	function isUtc () {
	    return this.isValid() ? this._isUTC && this._offset === 0 : false;
	}
	
	// ASP.NET json date format regex
	var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	// from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	// somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	// and further modified to allow for strings containing both week and day
	var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
	
	function createDuration (input, key) {
	    var duration = input,
	        // matching against regexp is expensive, do it on demand
	        match = null,
	        sign,
	        ret,
	        diffRes;
	
	    if (isDuration(input)) {
	        duration = {
	            ms : input._milliseconds,
	            d  : input._days,
	            M  : input._months
	        };
	    } else if (isNumber(input)) {
	        duration = {};
	        if (key) {
	            duration[key] = input;
	        } else {
	            duration.milliseconds = input;
	        }
	    } else if (!!(match = aspNetRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y  : 0,
	            d  : toInt(match[DATE])                         * sign,
	            h  : toInt(match[HOUR])                         * sign,
	            m  : toInt(match[MINUTE])                       * sign,
	            s  : toInt(match[SECOND])                       * sign,
	            ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	        };
	    } else if (!!(match = isoRegex.exec(input))) {
	        sign = (match[1] === '-') ? -1 : 1;
	        duration = {
	            y : parseIso(match[2], sign),
	            M : parseIso(match[3], sign),
	            w : parseIso(match[4], sign),
	            d : parseIso(match[5], sign),
	            h : parseIso(match[6], sign),
	            m : parseIso(match[7], sign),
	            s : parseIso(match[8], sign)
	        };
	    } else if (duration == null) {// checks for null or undefined
	        duration = {};
	    } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	        diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
	
	        duration = {};
	        duration.ms = diffRes.milliseconds;
	        duration.M = diffRes.months;
	    }
	
	    ret = new Duration(duration);
	
	    if (isDuration(input) && hasOwnProp(input, '_locale')) {
	        ret._locale = input._locale;
	    }
	
	    return ret;
	}
	
	createDuration.fn = Duration.prototype;
	
	function parseIso (inp, sign) {
	    // We'd normally use ~~inp for this, but unfortunately it also
	    // converts floats to ints.
	    // inp may be undefined, so careful calling replace on it.
	    var res = inp && parseFloat(inp.replace(',', '.'));
	    // apply sign while we're at it
	    return (isNaN(res) ? 0 : res) * sign;
	}
	
	function positiveMomentsDifference(base, other) {
	    var res = {milliseconds: 0, months: 0};
	
	    res.months = other.month() - base.month() +
	        (other.year() - base.year()) * 12;
	    if (base.clone().add(res.months, 'M').isAfter(other)) {
	        --res.months;
	    }
	
	    res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	    return res;
	}
	
	function momentsDifference(base, other) {
	    var res;
	    if (!(base.isValid() && other.isValid())) {
	        return {milliseconds: 0, months: 0};
	    }
	
	    other = cloneWithOffset(other, base);
	    if (base.isBefore(other)) {
	        res = positiveMomentsDifference(base, other);
	    } else {
	        res = positiveMomentsDifference(other, base);
	        res.milliseconds = -res.milliseconds;
	        res.months = -res.months;
	    }
	
	    return res;
	}
	
	// TODO: remove 'name' arg after deprecation is removed
	function createAdder(direction, name) {
	    return function (val, period) {
	        var dur, tmp;
	        //invert the arguments, but complain about it
	        if (period !== null && !isNaN(+period)) {
	            deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	            'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	            tmp = val; val = period; period = tmp;
	        }
	
	        val = typeof val === 'string' ? +val : val;
	        dur = createDuration(val, period);
	        addSubtract(this, dur, direction);
	        return this;
	    };
	}
	
	function addSubtract (mom, duration, isAdding, updateOffset) {
	    var milliseconds = duration._milliseconds,
	        days = absRound(duration._days),
	        months = absRound(duration._months);
	
	    if (!mom.isValid()) {
	        // No op
	        return;
	    }
	
	    updateOffset = updateOffset == null ? true : updateOffset;
	
	    if (milliseconds) {
	        mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	    }
	    if (days) {
	        set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	    }
	    if (months) {
	        setMonth(mom, get(mom, 'Month') + months * isAdding);
	    }
	    if (updateOffset) {
	        hooks.updateOffset(mom, days || months);
	    }
	}
	
	var add      = createAdder(1, 'add');
	var subtract = createAdder(-1, 'subtract');
	
	function getCalendarFormat(myMoment, now) {
	    var diff = myMoment.diff(now, 'days', true);
	    return diff < -6 ? 'sameElse' :
	            diff < -1 ? 'lastWeek' :
	            diff < 0 ? 'lastDay' :
	            diff < 1 ? 'sameDay' :
	            diff < 2 ? 'nextDay' :
	            diff < 7 ? 'nextWeek' : 'sameElse';
	}
	
	function calendar$1 (time, formats) {
	    // We want to compare the start of today, vs this.
	    // Getting start-of-today depends on whether we're local/utc/offset or not.
	    var now = time || createLocal(),
	        sod = cloneWithOffset(now, this).startOf('day'),
	        format = hooks.calendarFormat(this, sod) || 'sameElse';
	
	    var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
	}
	
	function clone () {
	    return new Moment(this);
	}
	
	function isAfter (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() > localInput.valueOf();
	    } else {
	        return localInput.valueOf() < this.clone().startOf(units).valueOf();
	    }
	}
	
	function isBefore (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input);
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() < localInput.valueOf();
	    } else {
	        return this.clone().endOf(units).valueOf() < localInput.valueOf();
	    }
	}
	
	function isBetween (from, to, units, inclusivity) {
	    inclusivity = inclusivity || '()';
	    return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	        (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	}
	
	function isSame (input, units) {
	    var localInput = isMoment(input) ? input : createLocal(input),
	        inputMs;
	    if (!(this.isValid() && localInput.isValid())) {
	        return false;
	    }
	    units = normalizeUnits(units || 'millisecond');
	    if (units === 'millisecond') {
	        return this.valueOf() === localInput.valueOf();
	    } else {
	        inputMs = localInput.valueOf();
	        return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	    }
	}
	
	function isSameOrAfter (input, units) {
	    return this.isSame(input, units) || this.isAfter(input,units);
	}
	
	function isSameOrBefore (input, units) {
	    return this.isSame(input, units) || this.isBefore(input,units);
	}
	
	function diff (input, units, asFloat) {
	    var that,
	        zoneDelta,
	        delta, output;
	
	    if (!this.isValid()) {
	        return NaN;
	    }
	
	    that = cloneWithOffset(input, this);
	
	    if (!that.isValid()) {
	        return NaN;
	    }
	
	    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	    units = normalizeUnits(units);
	
	    if (units === 'year' || units === 'month' || units === 'quarter') {
	        output = monthDiff(this, that);
	        if (units === 'quarter') {
	            output = output / 3;
	        } else if (units === 'year') {
	            output = output / 12;
	        }
	    } else {
	        delta = this - that;
	        output = units === 'second' ? delta / 1e3 : // 1000
	            units === 'minute' ? delta / 6e4 : // 1000 * 60
	            units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	            units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	            units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	            delta;
	    }
	    return asFloat ? output : absFloor(output);
	}
	
	function monthDiff (a, b) {
	    // difference in months
	    var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	        // b is in (anchor - 1 month, anchor + 1 month)
	        anchor = a.clone().add(wholeMonthDiff, 'months'),
	        anchor2, adjust;
	
	    if (b - anchor < 0) {
	        anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor - anchor2);
	    } else {
	        anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	        // linear across the month
	        adjust = (b - anchor) / (anchor2 - anchor);
	    }
	
	    //check for negative zero, return zero if negative zero
	    return -(wholeMonthDiff + adjust) || 0;
	}
	
	hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	function toString () {
	    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	}
	
	function toISOString () {
	    var m = this.clone().utc();
	    if (0 < m.year() && m.year() <= 9999) {
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            return this.toDate().toISOString();
	        } else {
	            return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	        }
	    } else {
	        return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	    }
	}
	
	/**
	 * Return a human readable representation of a moment that can
	 * also be evaluated to get a new moment which is the same
	 *
	 * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	 */
	function inspect () {
	    if (!this.isValid()) {
	        return 'moment.invalid(/* ' + this._i + ' */)';
	    }
	    var func = 'moment';
	    var zone = '';
	    if (!this.isLocal()) {
	        func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	        zone = 'Z';
	    }
	    var prefix = '[' + func + '("]';
	    var year = (0 < this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
	    var datetime = '-MM-DD[T]HH:mm:ss.SSS';
	    var suffix = zone + '[")]';
	
	    return this.format(prefix + year + datetime + suffix);
	}
	
	function format (inputString) {
	    if (!inputString) {
	        inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
	    }
	    var output = formatMoment(this, inputString);
	    return this.localeData().postformat(output);
	}
	
	function from (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function fromNow (withoutSuffix) {
	    return this.from(createLocal(), withoutSuffix);
	}
	
	function to (time, withoutSuffix) {
	    if (this.isValid() &&
	            ((isMoment(time) && time.isValid()) ||
	             createLocal(time).isValid())) {
	        return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	    } else {
	        return this.localeData().invalidDate();
	    }
	}
	
	function toNow (withoutSuffix) {
	    return this.to(createLocal(), withoutSuffix);
	}
	
	// If passed a locale key, it will set the locale for this
	// instance.  Otherwise, it will return the locale configuration
	// variables for this instance.
	function locale (key) {
	    var newLocaleData;
	
	    if (key === undefined) {
	        return this._locale._abbr;
	    } else {
	        newLocaleData = getLocale(key);
	        if (newLocaleData != null) {
	            this._locale = newLocaleData;
	        }
	        return this;
	    }
	}
	
	var lang = deprecate(
	    'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	    function (key) {
	        if (key === undefined) {
	            return this.localeData();
	        } else {
	            return this.locale(key);
	        }
	    }
	);
	
	function localeData () {
	    return this._locale;
	}
	
	function startOf (units) {
	    units = normalizeUnits(units);
	    // the following switch intentionally omits break keywords
	    // to utilize falling through the cases.
	    switch (units) {
	        case 'year':
	            this.month(0);
	            /* falls through */
	        case 'quarter':
	        case 'month':
	            this.date(1);
	            /* falls through */
	        case 'week':
	        case 'isoWeek':
	        case 'day':
	        case 'date':
	            this.hours(0);
	            /* falls through */
	        case 'hour':
	            this.minutes(0);
	            /* falls through */
	        case 'minute':
	            this.seconds(0);
	            /* falls through */
	        case 'second':
	            this.milliseconds(0);
	    }
	
	    // weeks are a special case
	    if (units === 'week') {
	        this.weekday(0);
	    }
	    if (units === 'isoWeek') {
	        this.isoWeekday(1);
	    }
	
	    // quarters are also special
	    if (units === 'quarter') {
	        this.month(Math.floor(this.month() / 3) * 3);
	    }
	
	    return this;
	}
	
	function endOf (units) {
	    units = normalizeUnits(units);
	    if (units === undefined || units === 'millisecond') {
	        return this;
	    }
	
	    // 'date' is an alias for 'day', so it should be considered as such.
	    if (units === 'date') {
	        units = 'day';
	    }
	
	    return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	}
	
	function valueOf () {
	    return this._d.valueOf() - ((this._offset || 0) * 60000);
	}
	
	function unix () {
	    return Math.floor(this.valueOf() / 1000);
	}
	
	function toDate () {
	    return new Date(this.valueOf());
	}
	
	function toArray () {
	    var m = this;
	    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	}
	
	function toObject () {
	    var m = this;
	    return {
	        years: m.year(),
	        months: m.month(),
	        date: m.date(),
	        hours: m.hours(),
	        minutes: m.minutes(),
	        seconds: m.seconds(),
	        milliseconds: m.milliseconds()
	    };
	}
	
	function toJSON () {
	    // new Date(NaN).toJSON() === null
	    return this.isValid() ? this.toISOString() : null;
	}
	
	function isValid$1 () {
	    return isValid(this);
	}
	
	function parsingFlags () {
	    return extend({}, getParsingFlags(this));
	}
	
	function invalidAt () {
	    return getParsingFlags(this).overflow;
	}
	
	function creationData() {
	    return {
	        input: this._i,
	        format: this._f,
	        locale: this._locale,
	        isUTC: this._isUTC,
	        strict: this._strict
	    };
	}
	
	// FORMATTING
	
	addFormatToken(0, ['gg', 2], 0, function () {
	    return this.weekYear() % 100;
	});
	
	addFormatToken(0, ['GG', 2], 0, function () {
	    return this.isoWeekYear() % 100;
	});
	
	function addWeekYearFormatToken (token, getter) {
	    addFormatToken(0, [token, token.length], 0, getter);
	}
	
	addWeekYearFormatToken('gggg',     'weekYear');
	addWeekYearFormatToken('ggggg',    'weekYear');
	addWeekYearFormatToken('GGGG',  'isoWeekYear');
	addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	// ALIASES
	
	addUnitAlias('weekYear', 'gg');
	addUnitAlias('isoWeekYear', 'GG');
	
	// PRIORITY
	
	addUnitPriority('weekYear', 1);
	addUnitPriority('isoWeekYear', 1);
	
	
	// PARSING
	
	addRegexToken('G',      matchSigned);
	addRegexToken('g',      matchSigned);
	addRegexToken('GG',     match1to2, match2);
	addRegexToken('gg',     match1to2, match2);
	addRegexToken('GGGG',   match1to4, match4);
	addRegexToken('gggg',   match1to4, match4);
	addRegexToken('GGGGG',  match1to6, match6);
	addRegexToken('ggggg',  match1to6, match6);
	
	addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	    week[token.substr(0, 2)] = toInt(input);
	});
	
	addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	    week[token] = hooks.parseTwoDigitYear(input);
	});
	
	// MOMENTS
	
	function getSetWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy);
	}
	
	function getSetISOWeekYear (input) {
	    return getSetWeekYearHelper.call(this,
	            input, this.isoWeek(), this.isoWeekday(), 1, 4);
	}
	
	function getISOWeeksInYear () {
	    return weeksInYear(this.year(), 1, 4);
	}
	
	function getWeeksInYear () {
	    var weekInfo = this.localeData()._week;
	    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	}
	
	function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	    var weeksTarget;
	    if (input == null) {
	        return weekOfYear(this, dow, doy).year;
	    } else {
	        weeksTarget = weeksInYear(input, dow, doy);
	        if (week > weeksTarget) {
	            week = weeksTarget;
	        }
	        return setWeekAll.call(this, input, week, weekday, dow, doy);
	    }
	}
	
	function setWeekAll(weekYear, week, weekday, dow, doy) {
	    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	        date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	    this.year(date.getUTCFullYear());
	    this.month(date.getUTCMonth());
	    this.date(date.getUTCDate());
	    return this;
	}
	
	// FORMATTING
	
	addFormatToken('Q', 0, 'Qo', 'quarter');
	
	// ALIASES
	
	addUnitAlias('quarter', 'Q');
	
	// PRIORITY
	
	addUnitPriority('quarter', 7);
	
	// PARSING
	
	addRegexToken('Q', match1);
	addParseToken('Q', function (input, array) {
	    array[MONTH] = (toInt(input) - 1) * 3;
	});
	
	// MOMENTS
	
	function getSetQuarter (input) {
	    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	}
	
	// FORMATTING
	
	addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	// ALIASES
	
	addUnitAlias('date', 'D');
	
	// PRIOROITY
	addUnitPriority('date', 9);
	
	// PARSING
	
	addRegexToken('D',  match1to2);
	addRegexToken('DD', match1to2, match2);
	addRegexToken('Do', function (isStrict, locale) {
	    return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
	});
	
	addParseToken(['D', 'DD'], DATE);
	addParseToken('Do', function (input, array) {
	    array[DATE] = toInt(input.match(match1to2)[0], 10);
	});
	
	// MOMENTS
	
	var getSetDayOfMonth = makeGetSet('Date', true);
	
	// FORMATTING
	
	addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	// ALIASES
	
	addUnitAlias('dayOfYear', 'DDD');
	
	// PRIORITY
	addUnitPriority('dayOfYear', 4);
	
	// PARSING
	
	addRegexToken('DDD',  match1to3);
	addRegexToken('DDDD', match3);
	addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	    config._dayOfYear = toInt(input);
	});
	
	// HELPERS
	
	// MOMENTS
	
	function getSetDayOfYear (input) {
	    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	    return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	}
	
	// FORMATTING
	
	addFormatToken('m', ['mm', 2], 0, 'minute');
	
	// ALIASES
	
	addUnitAlias('minute', 'm');
	
	// PRIORITY
	
	addUnitPriority('minute', 14);
	
	// PARSING
	
	addRegexToken('m',  match1to2);
	addRegexToken('mm', match1to2, match2);
	addParseToken(['m', 'mm'], MINUTE);
	
	// MOMENTS
	
	var getSetMinute = makeGetSet('Minutes', false);
	
	// FORMATTING
	
	addFormatToken('s', ['ss', 2], 0, 'second');
	
	// ALIASES
	
	addUnitAlias('second', 's');
	
	// PRIORITY
	
	addUnitPriority('second', 15);
	
	// PARSING
	
	addRegexToken('s',  match1to2);
	addRegexToken('ss', match1to2, match2);
	addParseToken(['s', 'ss'], SECOND);
	
	// MOMENTS
	
	var getSetSecond = makeGetSet('Seconds', false);
	
	// FORMATTING
	
	addFormatToken('S', 0, 0, function () {
	    return ~~(this.millisecond() / 100);
	});
	
	addFormatToken(0, ['SS', 2], 0, function () {
	    return ~~(this.millisecond() / 10);
	});
	
	addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	addFormatToken(0, ['SSSS', 4], 0, function () {
	    return this.millisecond() * 10;
	});
	addFormatToken(0, ['SSSSS', 5], 0, function () {
	    return this.millisecond() * 100;
	});
	addFormatToken(0, ['SSSSSS', 6], 0, function () {
	    return this.millisecond() * 1000;
	});
	addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	    return this.millisecond() * 10000;
	});
	addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	    return this.millisecond() * 100000;
	});
	addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	    return this.millisecond() * 1000000;
	});
	
	
	// ALIASES
	
	addUnitAlias('millisecond', 'ms');
	
	// PRIORITY
	
	addUnitPriority('millisecond', 16);
	
	// PARSING
	
	addRegexToken('S',    match1to3, match1);
	addRegexToken('SS',   match1to3, match2);
	addRegexToken('SSS',  match1to3, match3);
	
	var token;
	for (token = 'SSSS'; token.length <= 9; token += 'S') {
	    addRegexToken(token, matchUnsigned);
	}
	
	function parseMs(input, array) {
	    array[MILLISECOND] = toInt(('0.' + input) * 1000);
	}
	
	for (token = 'S'; token.length <= 9; token += 'S') {
	    addParseToken(token, parseMs);
	}
	// MOMENTS
	
	var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	// FORMATTING
	
	addFormatToken('z',  0, 0, 'zoneAbbr');
	addFormatToken('zz', 0, 0, 'zoneName');
	
	// MOMENTS
	
	function getZoneAbbr () {
	    return this._isUTC ? 'UTC' : '';
	}
	
	function getZoneName () {
	    return this._isUTC ? 'Coordinated Universal Time' : '';
	}
	
	var proto = Moment.prototype;
	
	proto.add               = add;
	proto.calendar          = calendar$1;
	proto.clone             = clone;
	proto.diff              = diff;
	proto.endOf             = endOf;
	proto.format            = format;
	proto.from              = from;
	proto.fromNow           = fromNow;
	proto.to                = to;
	proto.toNow             = toNow;
	proto.get               = stringGet;
	proto.invalidAt         = invalidAt;
	proto.isAfter           = isAfter;
	proto.isBefore          = isBefore;
	proto.isBetween         = isBetween;
	proto.isSame            = isSame;
	proto.isSameOrAfter     = isSameOrAfter;
	proto.isSameOrBefore    = isSameOrBefore;
	proto.isValid           = isValid$1;
	proto.lang              = lang;
	proto.locale            = locale;
	proto.localeData        = localeData;
	proto.max               = prototypeMax;
	proto.min               = prototypeMin;
	proto.parsingFlags      = parsingFlags;
	proto.set               = stringSet;
	proto.startOf           = startOf;
	proto.subtract          = subtract;
	proto.toArray           = toArray;
	proto.toObject          = toObject;
	proto.toDate            = toDate;
	proto.toISOString       = toISOString;
	proto.inspect           = inspect;
	proto.toJSON            = toJSON;
	proto.toString          = toString;
	proto.unix              = unix;
	proto.valueOf           = valueOf;
	proto.creationData      = creationData;
	
	// Year
	proto.year       = getSetYear;
	proto.isLeapYear = getIsLeapYear;
	
	// Week Year
	proto.weekYear    = getSetWeekYear;
	proto.isoWeekYear = getSetISOWeekYear;
	
	// Quarter
	proto.quarter = proto.quarters = getSetQuarter;
	
	// Month
	proto.month       = getSetMonth;
	proto.daysInMonth = getDaysInMonth;
	
	// Week
	proto.week           = proto.weeks        = getSetWeek;
	proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
	proto.weeksInYear    = getWeeksInYear;
	proto.isoWeeksInYear = getISOWeeksInYear;
	
	// Day
	proto.date       = getSetDayOfMonth;
	proto.day        = proto.days             = getSetDayOfWeek;
	proto.weekday    = getSetLocaleDayOfWeek;
	proto.isoWeekday = getSetISODayOfWeek;
	proto.dayOfYear  = getSetDayOfYear;
	
	// Hour
	proto.hour = proto.hours = getSetHour;
	
	// Minute
	proto.minute = proto.minutes = getSetMinute;
	
	// Second
	proto.second = proto.seconds = getSetSecond;
	
	// Millisecond
	proto.millisecond = proto.milliseconds = getSetMillisecond;
	
	// Offset
	proto.utcOffset            = getSetOffset;
	proto.utc                  = setOffsetToUTC;
	proto.local                = setOffsetToLocal;
	proto.parseZone            = setOffsetToParsedOffset;
	proto.hasAlignedHourOffset = hasAlignedHourOffset;
	proto.isDST                = isDaylightSavingTime;
	proto.isLocal              = isLocal;
	proto.isUtcOffset          = isUtcOffset;
	proto.isUtc                = isUtc;
	proto.isUTC                = isUtc;
	
	// Timezone
	proto.zoneAbbr = getZoneAbbr;
	proto.zoneName = getZoneName;
	
	// Deprecations
	proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	function createUnix (input) {
	    return createLocal(input * 1000);
	}
	
	function createInZone () {
	    return createLocal.apply(null, arguments).parseZone();
	}
	
	function preParsePostFormat (string) {
	    return string;
	}
	
	var proto$1 = Locale.prototype;
	
	proto$1.calendar        = calendar;
	proto$1.longDateFormat  = longDateFormat;
	proto$1.invalidDate     = invalidDate;
	proto$1.ordinal         = ordinal;
	proto$1.preparse        = preParsePostFormat;
	proto$1.postformat      = preParsePostFormat;
	proto$1.relativeTime    = relativeTime;
	proto$1.pastFuture      = pastFuture;
	proto$1.set             = set;
	
	// Month
	proto$1.months            =        localeMonths;
	proto$1.monthsShort       =        localeMonthsShort;
	proto$1.monthsParse       =        localeMonthsParse;
	proto$1.monthsRegex       = monthsRegex;
	proto$1.monthsShortRegex  = monthsShortRegex;
	
	// Week
	proto$1.week = localeWeek;
	proto$1.firstDayOfYear = localeFirstDayOfYear;
	proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	// Day of Week
	proto$1.weekdays       =        localeWeekdays;
	proto$1.weekdaysMin    =        localeWeekdaysMin;
	proto$1.weekdaysShort  =        localeWeekdaysShort;
	proto$1.weekdaysParse  =        localeWeekdaysParse;
	
	proto$1.weekdaysRegex       =        weekdaysRegex;
	proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
	proto$1.weekdaysMinRegex    =        weekdaysMinRegex;
	
	// Hours
	proto$1.isPM = localeIsPM;
	proto$1.meridiem = localeMeridiem;
	
	function get$1 (format, index, field, setter) {
	    var locale = getLocale();
	    var utc = createUTC().set(setter, index);
	    return locale[field](utc, format);
	}
	
	function listMonthsImpl (format, index, field) {
	    if (isNumber(format)) {
	        index = format;
	        format = undefined;
	    }
	
	    format = format || '';
	
	    if (index != null) {
	        return get$1(format, index, field, 'month');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 12; i++) {
	        out[i] = get$1(format, i, field, 'month');
	    }
	    return out;
	}
	
	// ()
	// (5)
	// (fmt, 5)
	// (fmt)
	// (true)
	// (true, 5)
	// (true, fmt, 5)
	// (true, fmt)
	function listWeekdaysImpl (localeSorted, format, index, field) {
	    if (typeof localeSorted === 'boolean') {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    } else {
	        format = localeSorted;
	        index = format;
	        localeSorted = false;
	
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	    }
	
	    var locale = getLocale(),
	        shift = localeSorted ? locale._week.dow : 0;
	
	    if (index != null) {
	        return get$1(format, (index + shift) % 7, field, 'day');
	    }
	
	    var i;
	    var out = [];
	    for (i = 0; i < 7; i++) {
	        out[i] = get$1(format, (i + shift) % 7, field, 'day');
	    }
	    return out;
	}
	
	function listMonths (format, index) {
	    return listMonthsImpl(format, index, 'months');
	}
	
	function listMonthsShort (format, index) {
	    return listMonthsImpl(format, index, 'monthsShort');
	}
	
	function listWeekdays (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	}
	
	function listWeekdaysShort (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	}
	
	function listWeekdaysMin (localeSorted, format, index) {
	    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	}
	
	getSetGlobalLocale('en', {
	    ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (toInt(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	// Side effect imports
	hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
	hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
	
	var mathAbs = Math.abs;
	
	function abs () {
	    var data           = this._data;
	
	    this._milliseconds = mathAbs(this._milliseconds);
	    this._days         = mathAbs(this._days);
	    this._months       = mathAbs(this._months);
	
	    data.milliseconds  = mathAbs(data.milliseconds);
	    data.seconds       = mathAbs(data.seconds);
	    data.minutes       = mathAbs(data.minutes);
	    data.hours         = mathAbs(data.hours);
	    data.months        = mathAbs(data.months);
	    data.years         = mathAbs(data.years);
	
	    return this;
	}
	
	function addSubtract$1 (duration, input, value, direction) {
	    var other = createDuration(input, value);
	
	    duration._milliseconds += direction * other._milliseconds;
	    duration._days         += direction * other._days;
	    duration._months       += direction * other._months;
	
	    return duration._bubble();
	}
	
	// supports only 2.0-style add(1, 's') or add(duration)
	function add$1 (input, value) {
	    return addSubtract$1(this, input, value, 1);
	}
	
	// supports only 2.0-style subtract(1, 's') or subtract(duration)
	function subtract$1 (input, value) {
	    return addSubtract$1(this, input, value, -1);
	}
	
	function absCeil (number) {
	    if (number < 0) {
	        return Math.floor(number);
	    } else {
	        return Math.ceil(number);
	    }
	}
	
	function bubble () {
	    var milliseconds = this._milliseconds;
	    var days         = this._days;
	    var months       = this._months;
	    var data         = this._data;
	    var seconds, minutes, hours, years, monthsFromDays;
	
	    // if we have a mix of positive and negative values, bubble down first
	    // check: https://github.com/moment/moment/issues/2166
	    if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	            (milliseconds <= 0 && days <= 0 && months <= 0))) {
	        milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	        days = 0;
	        months = 0;
	    }
	
	    // The following code bubbles up values, see the tests for
	    // examples of what that means.
	    data.milliseconds = milliseconds % 1000;
	
	    seconds           = absFloor(milliseconds / 1000);
	    data.seconds      = seconds % 60;
	
	    minutes           = absFloor(seconds / 60);
	    data.minutes      = minutes % 60;
	
	    hours             = absFloor(minutes / 60);
	    data.hours        = hours % 24;
	
	    days += absFloor(hours / 24);
	
	    // convert days to months
	    monthsFromDays = absFloor(daysToMonths(days));
	    months += monthsFromDays;
	    days -= absCeil(monthsToDays(monthsFromDays));
	
	    // 12 months -> 1 year
	    years = absFloor(months / 12);
	    months %= 12;
	
	    data.days   = days;
	    data.months = months;
	    data.years  = years;
	
	    return this;
	}
	
	function daysToMonths (days) {
	    // 400 years have 146097 days (taking into account leap year rules)
	    // 400 years have 12 months === 4800
	    return days * 4800 / 146097;
	}
	
	function monthsToDays (months) {
	    // the reverse of daysToMonths
	    return months * 146097 / 4800;
	}
	
	function as (units) {
	    var days;
	    var months;
	    var milliseconds = this._milliseconds;
	
	    units = normalizeUnits(units);
	
	    if (units === 'month' || units === 'year') {
	        days   = this._days   + milliseconds / 864e5;
	        months = this._months + daysToMonths(days);
	        return units === 'month' ? months : months / 12;
	    } else {
	        // handle milliseconds separately because of floating point math errors (issue #1867)
	        days = this._days + Math.round(monthsToDays(this._months));
	        switch (units) {
	            case 'week'   : return days / 7     + milliseconds / 6048e5;
	            case 'day'    : return days         + milliseconds / 864e5;
	            case 'hour'   : return days * 24    + milliseconds / 36e5;
	            case 'minute' : return days * 1440  + milliseconds / 6e4;
	            case 'second' : return days * 86400 + milliseconds / 1000;
	            // Math.floor prevents floating point math errors here
	            case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	            default: throw new Error('Unknown unit ' + units);
	        }
	    }
	}
	
	// TODO: Use this.as('ms')?
	function valueOf$1 () {
	    return (
	        this._milliseconds +
	        this._days * 864e5 +
	        (this._months % 12) * 2592e6 +
	        toInt(this._months / 12) * 31536e6
	    );
	}
	
	function makeAs (alias) {
	    return function () {
	        return this.as(alias);
	    };
	}
	
	var asMilliseconds = makeAs('ms');
	var asSeconds      = makeAs('s');
	var asMinutes      = makeAs('m');
	var asHours        = makeAs('h');
	var asDays         = makeAs('d');
	var asWeeks        = makeAs('w');
	var asMonths       = makeAs('M');
	var asYears        = makeAs('y');
	
	function get$2 (units) {
	    units = normalizeUnits(units);
	    return this[units + 's']();
	}
	
	function makeGetter(name) {
	    return function () {
	        return this._data[name];
	    };
	}
	
	var milliseconds = makeGetter('milliseconds');
	var seconds      = makeGetter('seconds');
	var minutes      = makeGetter('minutes');
	var hours        = makeGetter('hours');
	var days         = makeGetter('days');
	var months       = makeGetter('months');
	var years        = makeGetter('years');
	
	function weeks () {
	    return absFloor(this.days() / 7);
	}
	
	var round = Math.round;
	var thresholds = {
	    s: 45,  // seconds to minute
	    m: 45,  // minutes to hour
	    h: 22,  // hours to day
	    d: 26,  // days to month
	    M: 11   // months to year
	};
	
	// helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	}
	
	function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
	    var duration = createDuration(posNegDuration).abs();
	    var seconds  = round(duration.as('s'));
	    var minutes  = round(duration.as('m'));
	    var hours    = round(duration.as('h'));
	    var days     = round(duration.as('d'));
	    var months   = round(duration.as('M'));
	    var years    = round(duration.as('y'));
	
	    var a = seconds < thresholds.s && ['s', seconds]  ||
	            minutes <= 1           && ['m']           ||
	            minutes < thresholds.m && ['mm', minutes] ||
	            hours   <= 1           && ['h']           ||
	            hours   < thresholds.h && ['hh', hours]   ||
	            days    <= 1           && ['d']           ||
	            days    < thresholds.d && ['dd', days]    ||
	            months  <= 1           && ['M']           ||
	            months  < thresholds.M && ['MM', months]  ||
	            years   <= 1           && ['y']           || ['yy', years];
	
	    a[2] = withoutSuffix;
	    a[3] = +posNegDuration > 0;
	    a[4] = locale;
	    return substituteTimeAgo.apply(null, a);
	}
	
	// This function allows you to set the rounding function for relative time strings
	function getSetRelativeTimeRounding (roundingFunction) {
	    if (roundingFunction === undefined) {
	        return round;
	    }
	    if (typeof(roundingFunction) === 'function') {
	        round = roundingFunction;
	        return true;
	    }
	    return false;
	}
	
	// This function allows you to set a threshold for relative time strings
	function getSetRelativeTimeThreshold (threshold, limit) {
	    if (thresholds[threshold] === undefined) {
	        return false;
	    }
	    if (limit === undefined) {
	        return thresholds[threshold];
	    }
	    thresholds[threshold] = limit;
	    return true;
	}
	
	function humanize (withSuffix) {
	    var locale = this.localeData();
	    var output = relativeTime$1(this, !withSuffix, locale);
	
	    if (withSuffix) {
	        output = locale.pastFuture(+this, output);
	    }
	
	    return locale.postformat(output);
	}
	
	var abs$1 = Math.abs;
	
	function toISOString$1() {
	    // for ISO strings we do not use the normal bubbling rules:
	    //  * milliseconds bubble up until they become hours
	    //  * days do not bubble at all
	    //  * months bubble up until they become years
	    // This is because there is no context-free conversion between hours and days
	    // (think of clock changes)
	    // and also not between days and months (28-31 days per month)
	    var seconds = abs$1(this._milliseconds) / 1000;
	    var days         = abs$1(this._days);
	    var months       = abs$1(this._months);
	    var minutes, hours, years;
	
	    // 3600 seconds -> 60 minutes -> 1 hour
	    minutes           = absFloor(seconds / 60);
	    hours             = absFloor(minutes / 60);
	    seconds %= 60;
	    minutes %= 60;
	
	    // 12 months -> 1 year
	    years  = absFloor(months / 12);
	    months %= 12;
	
	
	    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	    var Y = years;
	    var M = months;
	    var D = days;
	    var h = hours;
	    var m = minutes;
	    var s = seconds;
	    var total = this.asSeconds();
	
	    if (!total) {
	        // this is the same as C#'s (Noda) and python (isodate)...
	        // but not other JS (goog.date)
	        return 'P0D';
	    }
	
	    return (total < 0 ? '-' : '') +
	        'P' +
	        (Y ? Y + 'Y' : '') +
	        (M ? M + 'M' : '') +
	        (D ? D + 'D' : '') +
	        ((h || m || s) ? 'T' : '') +
	        (h ? h + 'H' : '') +
	        (m ? m + 'M' : '') +
	        (s ? s + 'S' : '');
	}
	
	var proto$2 = Duration.prototype;
	
	proto$2.abs            = abs;
	proto$2.add            = add$1;
	proto$2.subtract       = subtract$1;
	proto$2.as             = as;
	proto$2.asMilliseconds = asMilliseconds;
	proto$2.asSeconds      = asSeconds;
	proto$2.asMinutes      = asMinutes;
	proto$2.asHours        = asHours;
	proto$2.asDays         = asDays;
	proto$2.asWeeks        = asWeeks;
	proto$2.asMonths       = asMonths;
	proto$2.asYears        = asYears;
	proto$2.valueOf        = valueOf$1;
	proto$2._bubble        = bubble;
	proto$2.get            = get$2;
	proto$2.milliseconds   = milliseconds;
	proto$2.seconds        = seconds;
	proto$2.minutes        = minutes;
	proto$2.hours          = hours;
	proto$2.days           = days;
	proto$2.weeks          = weeks;
	proto$2.months         = months;
	proto$2.years          = years;
	proto$2.humanize       = humanize;
	proto$2.toISOString    = toISOString$1;
	proto$2.toString       = toISOString$1;
	proto$2.toJSON         = toISOString$1;
	proto$2.locale         = locale;
	proto$2.localeData     = localeData;
	
	// Deprecations
	proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
	proto$2.lang = lang;
	
	// Side effect imports
	
	// FORMATTING
	
	addFormatToken('X', 0, 0, 'unix');
	addFormatToken('x', 0, 0, 'valueOf');
	
	// PARSING
	
	addRegexToken('x', matchSigned);
	addRegexToken('X', matchTimestamp);
	addParseToken('X', function (input, array, config) {
	    config._d = new Date(parseFloat(input, 10) * 1000);
	});
	addParseToken('x', function (input, array, config) {
	    config._d = new Date(toInt(input));
	});
	
	// Side effect imports
	
	
	hooks.version = '2.17.0';
	
	setHookCallback(createLocal);
	
	hooks.fn                    = proto;
	hooks.min                   = min;
	hooks.max                   = max;
	hooks.now                   = now;
	hooks.utc                   = createUTC;
	hooks.unix                  = createUnix;
	hooks.months                = listMonths;
	hooks.isDate                = isDate;
	hooks.locale                = getSetGlobalLocale;
	hooks.invalid               = createInvalid;
	hooks.duration              = createDuration;
	hooks.isMoment              = isMoment;
	hooks.weekdays              = listWeekdays;
	hooks.parseZone             = createInZone;
	hooks.localeData            = getLocale;
	hooks.isDuration            = isDuration;
	hooks.monthsShort           = listMonthsShort;
	hooks.weekdaysMin           = listWeekdaysMin;
	hooks.defineLocale          = defineLocale;
	hooks.updateLocale          = updateLocale;
	hooks.locales               = listLocales;
	hooks.weekdaysShort         = listWeekdaysShort;
	hooks.normalizeUnits        = normalizeUnits;
	hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	hooks.calendarFormat        = getCalendarFormat;
	hooks.prototype             = proto;
	
	return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(85)(module)))

/***/ },
/* 85 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 87,
		"./af.js": 87,
		"./ar": 88,
		"./ar-dz": 89,
		"./ar-dz.js": 89,
		"./ar-ly": 90,
		"./ar-ly.js": 90,
		"./ar-ma": 91,
		"./ar-ma.js": 91,
		"./ar-sa": 92,
		"./ar-sa.js": 92,
		"./ar-tn": 93,
		"./ar-tn.js": 93,
		"./ar.js": 88,
		"./az": 94,
		"./az.js": 94,
		"./be": 95,
		"./be.js": 95,
		"./bg": 96,
		"./bg-x": 97,
		"./bg-x.js": 97,
		"./bg.js": 96,
		"./bn": 98,
		"./bn.js": 98,
		"./bo": 99,
		"./bo.js": 99,
		"./br": 100,
		"./br.js": 100,
		"./bs": 101,
		"./bs.js": 101,
		"./ca": 102,
		"./ca.js": 102,
		"./cs": 103,
		"./cs.js": 103,
		"./cv": 104,
		"./cv.js": 104,
		"./cy": 105,
		"./cy.js": 105,
		"./da": 106,
		"./da.js": 106,
		"./de": 107,
		"./de-at": 108,
		"./de-at.js": 108,
		"./de.js": 107,
		"./dv": 109,
		"./dv.js": 109,
		"./el": 110,
		"./el.js": 110,
		"./en-au": 111,
		"./en-au.js": 111,
		"./en-ca": 112,
		"./en-ca.js": 112,
		"./en-gb": 113,
		"./en-gb.js": 113,
		"./en-ie": 114,
		"./en-ie.js": 114,
		"./en-nz": 115,
		"./en-nz.js": 115,
		"./eo": 116,
		"./eo.js": 116,
		"./es": 117,
		"./es-do": 118,
		"./es-do.js": 118,
		"./es.js": 117,
		"./et": 119,
		"./et.js": 119,
		"./eu": 120,
		"./eu.js": 120,
		"./fa": 121,
		"./fa.js": 121,
		"./fi": 122,
		"./fi.js": 122,
		"./fo": 123,
		"./fo.js": 123,
		"./fr": 124,
		"./fr-ca": 125,
		"./fr-ca.js": 125,
		"./fr-ch": 126,
		"./fr-ch.js": 126,
		"./fr.js": 124,
		"./fy": 127,
		"./fy.js": 127,
		"./gd": 128,
		"./gd.js": 128,
		"./gl": 129,
		"./gl.js": 129,
		"./he": 130,
		"./he.js": 130,
		"./hi": 131,
		"./hi.js": 131,
		"./hr": 132,
		"./hr.js": 132,
		"./hu": 133,
		"./hu.js": 133,
		"./hy-am": 134,
		"./hy-am.js": 134,
		"./id": 135,
		"./id.js": 135,
		"./is": 136,
		"./is.js": 136,
		"./it": 137,
		"./it.js": 137,
		"./ja": 138,
		"./ja.js": 138,
		"./jv": 139,
		"./jv.js": 139,
		"./ka": 140,
		"./ka.js": 140,
		"./kk": 141,
		"./kk.js": 141,
		"./km": 142,
		"./km.js": 142,
		"./ko": 143,
		"./ko.js": 143,
		"./ky": 144,
		"./ky.js": 144,
		"./lb": 145,
		"./lb.js": 145,
		"./lo": 146,
		"./lo.js": 146,
		"./lt": 147,
		"./lt.js": 147,
		"./lv": 148,
		"./lv.js": 148,
		"./me": 149,
		"./me.js": 149,
		"./mi": 150,
		"./mi.js": 150,
		"./mk": 151,
		"./mk.js": 151,
		"./ml": 152,
		"./ml.js": 152,
		"./mr": 153,
		"./mr.js": 153,
		"./ms": 154,
		"./ms-my": 155,
		"./ms-my.js": 155,
		"./ms.js": 154,
		"./my": 156,
		"./my.js": 156,
		"./nb": 157,
		"./nb.js": 157,
		"./ne": 158,
		"./ne.js": 158,
		"./nl": 159,
		"./nl-be": 160,
		"./nl-be.js": 160,
		"./nl.js": 159,
		"./nn": 161,
		"./nn.js": 161,
		"./pa-in": 162,
		"./pa-in.js": 162,
		"./pl": 163,
		"./pl.js": 163,
		"./pt": 164,
		"./pt-br": 165,
		"./pt-br.js": 165,
		"./pt.js": 164,
		"./ro": 166,
		"./ro.js": 166,
		"./ru": 167,
		"./ru.js": 167,
		"./se": 168,
		"./se.js": 168,
		"./si": 169,
		"./si.js": 169,
		"./sk": 170,
		"./sk.js": 170,
		"./sl": 171,
		"./sl.js": 171,
		"./sq": 172,
		"./sq.js": 172,
		"./sr": 173,
		"./sr-cyrl": 174,
		"./sr-cyrl.js": 174,
		"./sr.js": 173,
		"./ss": 175,
		"./ss.js": 175,
		"./sv": 176,
		"./sv.js": 176,
		"./sw": 177,
		"./sw.js": 177,
		"./ta": 178,
		"./ta.js": 178,
		"./te": 179,
		"./te.js": 179,
		"./tet": 180,
		"./tet.js": 180,
		"./th": 181,
		"./th.js": 181,
		"./tl-ph": 182,
		"./tl-ph.js": 182,
		"./tlh": 183,
		"./tlh.js": 183,
		"./tr": 184,
		"./tr.js": 184,
		"./tzl": 185,
		"./tzl.js": 185,
		"./tzm": 186,
		"./tzm-latn": 187,
		"./tzm-latn.js": 187,
		"./tzm.js": 186,
		"./uk": 188,
		"./uk.js": 188,
		"./uz": 189,
		"./uz.js": 189,
		"./vi": 190,
		"./vi.js": 190,
		"./x-pseudo": 191,
		"./x-pseudo.js": 191,
		"./yo": 192,
		"./yo.js": 192,
		"./zh-cn": 193,
		"./zh-cn.js": 193,
		"./zh-hk": 194,
		"./zh-hk.js": 194,
		"./zh-tw": 195,
		"./zh-tw.js": 195
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 86;


/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var af = moment.defineLocale('af', {
	    months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	    weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	    weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	    meridiemParse: /vm|nm/i,
	    isPM : function (input) {
	        return /^nm$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'vm' : 'VM';
	        } else {
	            return isLower ? 'nm' : 'NM';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Vandag om] LT',
	        nextDay : '[Môre om] LT',
	        nextWeek : 'dddd [om] LT',
	        lastDay : '[Gister om] LT',
	        lastWeek : '[Laas] dddd [om] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'oor %s',
	        past : '%s gelede',
	        s : '\'n paar sekondes',
	        m : '\'n minuut',
	        mm : '%d minute',
	        h : '\'n uur',
	        hh : '%d ure',
	        d : '\'n dag',
	        dd : '%d dae',
	        M : '\'n maand',
	        MM : '%d maande',
	        y : '\'n jaar',
	        yy : '%d jaar'
	    },
	    ordinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	    },
	    week : {
	        dow : 1, // Maandag is die eerste dag van die week.
	        doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	    }
	});
	
	return af;
	
	})));


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'كانون الثاني يناير',
	    'شباط فبراير',
	    'آذار مارس',
	    'نيسان أبريل',
	    'أيار مايو',
	    'حزيران يونيو',
	    'تموز يوليو',
	    'آب أغسطس',
	    'أيلول سبتمبر',
	    'تشرين الأول أكتوبر',
	    'تشرين الثاني نوفمبر',
	    'كانون الأول ديسمبر'
	];
	
	var ar = moment.defineLocale('ar', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ar;
	
	})));


/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddineme
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arDz = moment.defineLocale('ar-dz', {
	    months : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'أح_إث_ثلا_أر_خم_جم_سب'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 4  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arDz;
	
	})));


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '1',
	    '2': '2',
	    '3': '3',
	    '4': '4',
	    '5': '5',
	    '6': '6',
	    '7': '7',
	    '8': '8',
	    '9': '9',
	    '0': '0'
	};
	var pluralForm = function (n) {
	    return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	};
	var plurals = {
	    s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	    m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	    h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	    d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	    M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	    y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	};
	var pluralize = function (u) {
	    return function (number, withoutSuffix, string, isFuture) {
	        var f = pluralForm(number),
	            str = plurals[u][pluralForm(number)];
	        if (f === 2) {
	            str = str[withoutSuffix ? 0 : 1];
	        }
	        return str.replace(/%d/i, number);
	    };
	};
	var months = [
	    'يناير',
	    'فبراير',
	    'مارس',
	    'أبريل',
	    'مايو',
	    'يونيو',
	    'يوليو',
	    'أغسطس',
	    'سبتمبر',
	    'أكتوبر',
	    'نوفمبر',
	    'ديسمبر'
	];
	
	var arLy = moment.defineLocale('ar-ly', {
	    months : months,
	    monthsShort : months,
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/\u200FM/\u200FYYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم عند الساعة] LT',
	        nextDay: '[غدًا عند الساعة] LT',
	        nextWeek: 'dddd [عند الساعة] LT',
	        lastDay: '[أمس عند الساعة] LT',
	        lastWeek: 'dddd [عند الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'بعد %s',
	        past : 'منذ %s',
	        s : pluralize('s'),
	        m : pluralize('m'),
	        mm : pluralize('m'),
	        h : pluralize('h'),
	        hh : pluralize('h'),
	        d : pluralize('d'),
	        dd : pluralize('d'),
	        M : pluralize('M'),
	        MM : pluralize('M'),
	        y : pluralize('y'),
	        yy : pluralize('y')
	    },
	    preparse: function (string) {
	        return string.replace(/\u200f/g, '').replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arLy;
	
	})));


/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arMa = moment.defineLocale('ar-ma', {
	    months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	    weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arMa;
	
	})));


/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '١',
	    '2': '٢',
	    '3': '٣',
	    '4': '٤',
	    '5': '٥',
	    '6': '٦',
	    '7': '٧',
	    '8': '٨',
	    '9': '٩',
	    '0': '٠'
	};
	var numberMap = {
	    '١': '1',
	    '٢': '2',
	    '٣': '3',
	    '٤': '4',
	    '٥': '5',
	    '٦': '6',
	    '٧': '7',
	    '٨': '8',
	    '٩': '9',
	    '٠': '0'
	};
	
	var arSa = moment.defineLocale('ar-sa', {
	    months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ص|م/,
	    isPM : function (input) {
	        return 'م' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ص';
	        } else {
	            return 'م';
	        }
	    },
	    calendar : {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'في %s',
	        past : 'منذ %s',
	        s : 'ثوان',
	        m : 'دقيقة',
	        mm : '%d دقائق',
	        h : 'ساعة',
	        hh : '%d ساعات',
	        d : 'يوم',
	        dd : '%d أيام',
	        M : 'شهر',
	        MM : '%d أشهر',
	        y : 'سنة',
	        yy : '%d سنوات'
	    },
	    preparse: function (string) {
	        return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return arSa;
	
	})));


/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var arTn = moment.defineLocale('ar-tn', {
	    months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	    weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	    weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	    weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[اليوم على الساعة] LT',
	        nextDay: '[غدا على الساعة] LT',
	        nextWeek: 'dddd [على الساعة] LT',
	        lastDay: '[أمس على الساعة] LT',
	        lastWeek: 'dddd [على الساعة] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'في %s',
	        past: 'منذ %s',
	        s: 'ثوان',
	        m: 'دقيقة',
	        mm: '%d دقائق',
	        h: 'ساعة',
	        hh: '%d ساعات',
	        d: 'يوم',
	        dd: '%d أيام',
	        M: 'شهر',
	        MM: '%d أشهر',
	        y: 'سنة',
	        yy: '%d سنوات'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return arTn;
	
	})));


/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '-inci',
	    5: '-inci',
	    8: '-inci',
	    70: '-inci',
	    80: '-inci',
	    2: '-nci',
	    7: '-nci',
	    20: '-nci',
	    50: '-nci',
	    3: '-üncü',
	    4: '-üncü',
	    100: '-üncü',
	    6: '-ncı',
	    9: '-uncu',
	    10: '-uncu',
	    30: '-uncu',
	    60: '-ıncı',
	    90: '-ıncı'
	};
	
	var az = moment.defineLocale('az', {
	    months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	    monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	    weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	    weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	    weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[sabah saat] LT',
	        nextWeek : '[gələn həftə] dddd [saat] LT',
	        lastDay : '[dünən] LT',
	        lastWeek : '[keçən həftə] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s əvvəl',
	        s : 'birneçə saniyyə',
	        m : 'bir dəqiqə',
	        mm : '%d dəqiqə',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir il',
	        yy : '%d il'
	    },
	    meridiemParse: /gecə|səhər|gündüz|axşam/,
	    isPM : function (input) {
	        return /^(gündüz|axşam)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'gecə';
	        } else if (hour < 12) {
	            return 'səhər';
	        } else if (hour < 17) {
	            return 'gündüz';
	        } else {
	            return 'axşam';
	        }
	    },
	    ordinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '-ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return az;
	
	})));


/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	        'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	        'dd': 'дзень_дні_дзён',
	        'MM': 'месяц_месяцы_месяцаў',
	        'yy': 'год_гады_гадоў'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвіліна' : 'хвіліну';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'гадзіна' : 'гадзіну';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	
	var be = moment.defineLocale('be', {
	    months : {
	        format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	        standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	    },
	    monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	    weekdays : {
	        format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	        standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	    },
	    weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сёння ў] LT',
	        nextDay: '[Заўтра ў] LT',
	        lastDay: '[Учора ў] LT',
	        nextWeek: function () {
	            return '[У] dddd [ў] LT';
	        },
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return '[У мінулую] dddd [ў] LT';
	                case 1:
	                case 2:
	                case 4:
	                    return '[У мінулы] dddd [ў] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'праз %s',
	        past : '%s таму',
	        s : 'некалькі секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithPlural,
	        hh : relativeTimeWithPlural,
	        d : 'дзень',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночы|раніцы|дня|вечара/,
	    isPM : function (input) {
	        return /^(дня|вечара)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночы';
	        } else if (hour < 12) {
	            return 'раніцы';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечара';
	        }
	    },
	    ordinalParse: /\d{1,2}-(і|ы|га)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	            case 'D':
	                return number + '-га';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return be;
	
	})));


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var bg = moment.defineLocale('bg', {
	    months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Днес в] LT',
	        nextDay : '[Утре в] LT',
	        nextWeek : 'dddd [в] LT',
	        lastDay : '[Вчера в] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[В изминалата] dddd [в] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[В изминалия] dddd [в] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'след %s',
	        past : 'преди %s',
	        s : 'няколко секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дни',
	        M : 'месец',
	        MM : '%d месеца',
	        y : 'година',
	        yy : '%d години'
	    },
	    ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bg;
	
	})));


/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	var bgX = moment.defineLocale('bg-x', {
	    parentLocale: 'bg'
	});
	
	return bgX;
	
	})));


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '১',
	    '2': '২',
	    '3': '৩',
	    '4': '৪',
	    '5': '৫',
	    '6': '৬',
	    '7': '৭',
	    '8': '৮',
	    '9': '৯',
	    '0': '০'
	};
	var numberMap = {
	    '১': '1',
	    '২': '2',
	    '৩': '3',
	    '৪': '4',
	    '৫': '5',
	    '৬': '6',
	    '৭': '7',
	    '৮': '8',
	    '৯': '9',
	    '০': '0'
	};
	
	var bn = moment.defineLocale('bn', {
	    months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	    monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	    weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	    weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	    weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm সময়',
	        LTS : 'A h:mm:ss সময়',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm সময়',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	    },
	    calendar : {
	        sameDay : '[আজ] LT',
	        nextDay : '[আগামীকাল] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[গতকাল] LT',
	        lastWeek : '[গত] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s পরে',
	        past : '%s আগে',
	        s : 'কয়েক সেকেন্ড',
	        m : 'এক মিনিট',
	        mm : '%d মিনিট',
	        h : 'এক ঘন্টা',
	        hh : '%d ঘন্টা',
	        d : 'এক দিন',
	        dd : '%d দিন',
	        M : 'এক মাস',
	        MM : '%d মাস',
	        y : 'এক বছর',
	        yy : '%d বছর'
	    },
	    preparse: function (string) {
	        return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'রাত';
	        } else if (hour < 10) {
	            return 'সকাল';
	        } else if (hour < 17) {
	            return 'দুপুর';
	        } else if (hour < 20) {
	            return 'বিকাল';
	        } else {
	            return 'রাত';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bn;
	
	})));


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '༡',
	    '2': '༢',
	    '3': '༣',
	    '4': '༤',
	    '5': '༥',
	    '6': '༦',
	    '7': '༧',
	    '8': '༨',
	    '9': '༩',
	    '0': '༠'
	};
	var numberMap = {
	    '༡': '1',
	    '༢': '2',
	    '༣': '3',
	    '༤': '4',
	    '༥': '5',
	    '༦': '6',
	    '༧': '7',
	    '༨': '8',
	    '༩': '9',
	    '༠': '0'
	};
	
	var bo = moment.defineLocale('bo', {
	    months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	    weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	    weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[དི་རིང] LT',
	        nextDay : '[སང་ཉིན] LT',
	        nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	        lastDay : '[ཁ་སང] LT',
	        lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ལ་',
	        past : '%s སྔན་ལ',
	        s : 'ལམ་སང',
	        m : 'སྐར་མ་གཅིག',
	        mm : '%d སྐར་མ',
	        h : 'ཆུ་ཚོད་གཅིག',
	        hh : '%d ཆུ་ཚོད',
	        d : 'ཉིན་གཅིག',
	        dd : '%d ཉིན་',
	        M : 'ཟླ་བ་གཅིག',
	        MM : '%d ཟླ་བ',
	        y : 'ལོ་གཅིག',
	        yy : '%d ལོ'
	    },
	    preparse: function (string) {
	        return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'མཚན་མོ';
	        } else if (hour < 10) {
	            return 'ཞོགས་ཀས';
	        } else if (hour < 17) {
	            return 'ཉིན་གུང';
	        } else if (hour < 20) {
	            return 'དགོང་དག';
	        } else {
	            return 'མཚན་མོ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bo;
	
	})));


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithMutation(number, withoutSuffix, key) {
	    var format = {
	        'mm': 'munutenn',
	        'MM': 'miz',
	        'dd': 'devezh'
	    };
	    return number + ' ' + mutation(format[key], number);
	}
	function specialMutationForYears(number) {
	    switch (lastNumber(number)) {
	        case 1:
	        case 3:
	        case 4:
	        case 5:
	        case 9:
	            return number + ' bloaz';
	        default:
	            return number + ' vloaz';
	    }
	}
	function lastNumber(number) {
	    if (number > 9) {
	        return lastNumber(number % 10);
	    }
	    return number;
	}
	function mutation(text, number) {
	    if (number === 2) {
	        return softMutation(text);
	    }
	    return text;
	}
	function softMutation(text) {
	    var mutationTable = {
	        'm': 'v',
	        'b': 'v',
	        'd': 'z'
	    };
	    if (mutationTable[text.charAt(0)] === undefined) {
	        return text;
	    }
	    return mutationTable[text.charAt(0)] + text.substring(1);
	}
	
	var br = moment.defineLocale('br', {
	    months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	    monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	    weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	    weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	    weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h[e]mm A',
	        LTS : 'h[e]mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [a viz] MMMM YYYY',
	        LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	        LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	    },
	    calendar : {
	        sameDay : '[Hiziv da] LT',
	        nextDay : '[Warc\'hoazh da] LT',
	        nextWeek : 'dddd [da] LT',
	        lastDay : '[Dec\'h da] LT',
	        lastWeek : 'dddd [paset da] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'a-benn %s',
	        past : '%s \'zo',
	        s : 'un nebeud segondennoù',
	        m : 'ur vunutenn',
	        mm : relativeTimeWithMutation,
	        h : 'un eur',
	        hh : '%d eur',
	        d : 'un devezh',
	        dd : relativeTimeWithMutation,
	        M : 'ur miz',
	        MM : relativeTimeWithMutation,
	        y : 'ur bloaz',
	        yy : specialMutationForYears
	    },
	    ordinalParse: /\d{1,2}(añ|vet)/,
	    ordinal : function (number) {
	        var output = (number === 1) ? 'añ' : 'vet';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return br;
	
	})));


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var bs = moment.defineLocale('bs', {
	    months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return bs;
	
	})));


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ca = moment.defineLocale('ca', {
	    months : 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	    monthsShort : 'gen._febr._mar._abr._mai._jun._jul._ag._set._oct._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	    weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	    weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextDay : function () {
	            return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastDay : function () {
	            return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'd\'aquí %s',
	        past : 'fa %s',
	        s : 'uns segons',
	        m : 'un minut',
	        mm : '%d minuts',
	        h : 'una hora',
	        hh : '%d hores',
	        d : 'un dia',
	        dd : '%d dies',
	        M : 'un mes',
	        MM : '%d mesos',
	        y : 'un any',
	        yy : '%d anys'
	    },
	    ordinalParse: /\d{1,2}(r|n|t|è|a)/,
	    ordinal : function (number, period) {
	        var output = (number === 1) ? 'r' :
	            (number === 2) ? 'n' :
	            (number === 3) ? 'r' :
	            (number === 4) ? 't' : 'è';
	        if (period === 'w' || period === 'W') {
	            output = 'a';
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ca;
	
	})));


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
	var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minuty' : 'minut');
	            } else {
	                return result + 'minutami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodin');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dny' : 'dní');
	            } else {
	                return result + 'dny';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'měsíce' : 'měsíců');
	            } else {
	                return result + 'měsíci';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'let');
	            } else {
	                return result + 'lety';
	            }
	            break;
	    }
	}
	
	var cs = moment.defineLocale('cs', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParse : (function (months, monthsShort) {
	        var i, _monthsParse = [];
	        for (i = 0; i < 12; i++) {
	            // use custom parser to solve problem with July (červenec)
	            _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	        }
	        return _monthsParse;
	    }(months, monthsShort)),
	    shortMonthsParse : (function (monthsShort) {
	        var i, _shortMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	        }
	        return _shortMonthsParse;
	    }(monthsShort)),
	    longMonthsParse : (function (months) {
	        var i, _longMonthsParse = [];
	        for (i = 0; i < 12; i++) {
	            _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	        }
	        return _longMonthsParse;
	    }(months)),
	    weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	    weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	    weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm',
	        l : 'D. M. YYYY'
	    },
	    calendar : {
	        sameDay: '[dnes v] LT',
	        nextDay: '[zítra v] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v neděli v] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [v] LT';
	                case 3:
	                    return '[ve středu v] LT';
	                case 4:
	                    return '[ve čtvrtek v] LT';
	                case 5:
	                    return '[v pátek v] LT';
	                case 6:
	                    return '[v sobotu v] LT';
	            }
	        },
	        lastDay: '[včera v] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulou neděli v] LT';
	                case 1:
	                case 2:
	                    return '[minulé] dddd [v] LT';
	                case 3:
	                    return '[minulou středu v] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [v] LT';
	                case 6:
	                    return '[minulou sobotu v] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'před %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse : /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cs;
	
	})));


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cv = moment.defineLocale('cv', {
	    months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	    monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	    weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	    weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	    weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	        LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	    },
	    calendar : {
	        sameDay: '[Паян] LT [сехетре]',
	        nextDay: '[Ыран] LT [сехетре]',
	        lastDay: '[Ӗнер] LT [сехетре]',
	        nextWeek: '[Ҫитес] dddd LT [сехетре]',
	        lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (output) {
	            var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	            return output + affix;
	        },
	        past : '%s каялла',
	        s : 'пӗр-ик ҫеккунт',
	        m : 'пӗр минут',
	        mm : '%d минут',
	        h : 'пӗр сехет',
	        hh : '%d сехет',
	        d : 'пӗр кун',
	        dd : '%d кун',
	        M : 'пӗр уйӑх',
	        MM : '%d уйӑх',
	        y : 'пӗр ҫул',
	        yy : '%d ҫул'
	    },
	    ordinalParse: /\d{1,2}-мӗш/,
	    ordinal : '%d-мӗш',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return cv;
	
	})));


/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var cy = moment.defineLocale('cy', {
	    months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	    monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	    weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	    weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	    weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	    weekdaysParseExact : true,
	    // time formats are the same as en-gb
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[Heddiw am] LT',
	        nextDay: '[Yfory am] LT',
	        nextWeek: 'dddd [am] LT',
	        lastDay: '[Ddoe am] LT',
	        lastWeek: 'dddd [diwethaf am] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'mewn %s',
	        past: '%s yn ôl',
	        s: 'ychydig eiliadau',
	        m: 'munud',
	        mm: '%d munud',
	        h: 'awr',
	        hh: '%d awr',
	        d: 'diwrnod',
	        dd: '%d diwrnod',
	        M: 'mis',
	        MM: '%d mis',
	        y: 'blwyddyn',
	        yy: '%d flynedd'
	    },
	    ordinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	    // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	    ordinal: function (number) {
	        var b = number,
	            output = '',
	            lookup = [
	                '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	            ];
	        if (b > 20) {
	            if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                output = 'fed'; // not 30ain, 70ain or 90ain
	            } else {
	                output = 'ain';
	            }
	        } else if (b > 0) {
	            output = lookup[b];
	        }
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return cy;
	
	})));


/***/ },
/* 106 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var da = moment.defineLocale('da', {
	    months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd [d.] D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[I dag kl.] LT',
	        nextDay : '[I morgen kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[I går kl.] LT',
	        lastWeek : '[sidste] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'få sekunder',
	        m : 'et minut',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dage',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'et år',
	        yy : '%d år'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return da;
	
	})));


/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var de = moment.defineLocale('de', {
	    months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return de;
	
	})));


/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eine Minute', 'einer Minute'],
	        'h': ['eine Stunde', 'einer Stunde'],
	        'd': ['ein Tag', 'einem Tag'],
	        'dd': [number + ' Tage', number + ' Tagen'],
	        'M': ['ein Monat', 'einem Monat'],
	        'MM': [number + ' Monate', number + ' Monaten'],
	        'y': ['ein Jahr', 'einem Jahr'],
	        'yy': [number + ' Jahre', number + ' Jahren']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	
	var deAt = moment.defineLocale('de-at', {
	    months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	    weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	    weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY HH:mm',
	        LLLL : 'dddd, D. MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[heute um] LT [Uhr]',
	        sameElse: 'L',
	        nextDay: '[morgen um] LT [Uhr]',
	        nextWeek: 'dddd [um] LT [Uhr]',
	        lastDay: '[gestern um] LT [Uhr]',
	        lastWeek: '[letzten] dddd [um] LT [Uhr]'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : 'vor %s',
	        s : 'ein paar Sekunden',
	        m : processRelativeTime,
	        mm : '%d Minuten',
	        h : processRelativeTime,
	        hh : '%d Stunden',
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return deAt;
	
	})));


/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'ޖެނުއަރީ',
	    'ފެބްރުއަރީ',
	    'މާރިޗު',
	    'އޭޕްރީލު',
	    'މޭ',
	    'ޖޫން',
	    'ޖުލައި',
	    'އޯގަސްޓު',
	    'ސެޕްޓެމްބަރު',
	    'އޮކްޓޯބަރު',
	    'ނޮވެމްބަރު',
	    'ޑިސެމްބަރު'
	];
	var weekdays = [
	    'އާދިއްތަ',
	    'ހޯމަ',
	    'އަންގާރަ',
	    'ބުދަ',
	    'ބުރާސްފަތި',
	    'ހުކުރު',
	    'ހޮނިހިރު'
	];
	
	var dv = moment.defineLocale('dv', {
	    months : months,
	    monthsShort : months,
	    weekdays : weekdays,
	    weekdaysShort : weekdays,
	    weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	    longDateFormat : {
	
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'D/M/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /މކ|މފ/,
	    isPM : function (input) {
	        return 'މފ' === input;
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'މކ';
	        } else {
	            return 'މފ';
	        }
	    },
	    calendar : {
	        sameDay : '[މިއަދު] LT',
	        nextDay : '[މާދަމާ] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[އިއްޔެ] LT',
	        lastWeek : '[ފާއިތުވި] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ތެރޭގައި %s',
	        past : 'ކުރިން %s',
	        s : 'ސިކުންތުކޮޅެއް',
	        m : 'މިނިޓެއް',
	        mm : 'މިނިޓު %d',
	        h : 'ގަޑިއިރެއް',
	        hh : 'ގަޑިއިރު %d',
	        d : 'ދުވަހެއް',
	        dd : 'ދުވަސް %d',
	        M : 'މަހެއް',
	        MM : 'މަސް %d',
	        y : 'އަހަރެއް',
	        yy : 'އަހަރު %d'
	    },
	    preparse: function (string) {
	        return string.replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/,/g, '،');
	    },
	    week : {
	        dow : 7,  // Sunday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return dv;
	
	})));


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	function isFunction(input) {
	    return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	}
	
	
	var el = moment.defineLocale('el', {
	    monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	    monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	    months : function (momentToFormat, format) {
	        if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	            return this._monthsGenitiveEl[momentToFormat.month()];
	        } else {
	            return this._monthsNominativeEl[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	    weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	    weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	    weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'μμ' : 'ΜΜ';
	        } else {
	            return isLower ? 'πμ' : 'ΠΜ';
	        }
	    },
	    isPM : function (input) {
	        return ((input + '').toLowerCase()[0] === 'μ');
	    },
	    meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendarEl : {
	        sameDay : '[Σήμερα {}] LT',
	        nextDay : '[Αύριο {}] LT',
	        nextWeek : 'dddd [{}] LT',
	        lastDay : '[Χθες {}] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 6:
	                    return '[το προηγούμενο] dddd [{}] LT';
	                default:
	                    return '[την προηγούμενη] dddd [{}] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    calendar : function (key, mom) {
	        var output = this._calendarEl[key],
	            hours = mom && mom.hours();
	        if (isFunction(output)) {
	            output = output.apply(mom);
	        }
	        return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	    },
	    relativeTime : {
	        future : 'σε %s',
	        past : '%s πριν',
	        s : 'λίγα δευτερόλεπτα',
	        m : 'ένα λεπτό',
	        mm : '%d λεπτά',
	        h : 'μία ώρα',
	        hh : '%d ώρες',
	        d : 'μία μέρα',
	        dd : '%d μέρες',
	        M : 'ένας μήνας',
	        MM : '%d μήνες',
	        y : 'ένας χρόνος',
	        yy : '%d χρόνια'
	    },
	    ordinalParse: /\d{1,2}η/,
	    ordinal: '%dη',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4st is the first week of the year.
	    }
	});
	
	return el;
	
	})));


/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enAu = moment.defineLocale('en-au', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enAu;
	
	})));


/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enCa = moment.defineLocale('en-ca', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'YYYY-MM-DD',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    }
	});
	
	return enCa;
	
	})));


/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enGb = moment.defineLocale('en-gb', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enGb;
	
	})));


/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enIe = moment.defineLocale('en-ie', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enIe;
	
	})));


/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var enNz = moment.defineLocale('en-nz', {
	    months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	    weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	    weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	    weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'in %s',
	        past : '%s ago',
	        s : 'a few seconds',
	        m : 'a minute',
	        mm : '%d minutes',
	        h : 'an hour',
	        hh : '%d hours',
	        d : 'a day',
	        dd : '%d days',
	        M : 'a month',
	        MM : '%d months',
	        y : 'a year',
	        yy : '%d years'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return enNz;
	
	})));


/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! komento: Mi estas malcerta se mi korekte traktis akuzativojn en tiu traduko.
	//!          Se ne, bonvolu korekti kaj avizi min por ke mi povas lerni!
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eo = moment.defineLocale('eo', {
	    months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	    weekdays : 'Dimanĉo_Lundo_Mardo_Merkredo_Ĵaŭdo_Vendredo_Sabato'.split('_'),
	    weekdaysShort : 'Dim_Lun_Mard_Merk_Ĵaŭ_Ven_Sab'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Ĵa_Ve_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D[-an de] MMMM, YYYY',
	        LLL : 'D[-an de] MMMM, YYYY HH:mm',
	        LLLL : 'dddd, [la] D[-an de] MMMM, YYYY HH:mm'
	    },
	    meridiemParse: /[ap]\.t\.m/i,
	    isPM: function (input) {
	        return input.charAt(0).toLowerCase() === 'p';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'p.t.m.' : 'P.T.M.';
	        } else {
	            return isLower ? 'a.t.m.' : 'A.T.M.';
	        }
	    },
	    calendar : {
	        sameDay : '[Hodiaŭ je] LT',
	        nextDay : '[Morgaŭ je] LT',
	        nextWeek : 'dddd [je] LT',
	        lastDay : '[Hieraŭ je] LT',
	        lastWeek : '[pasinta] dddd [je] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'je %s',
	        past : 'antaŭ %s',
	        s : 'sekundoj',
	        m : 'minuto',
	        mm : '%d minutoj',
	        h : 'horo',
	        hh : '%d horoj',
	        d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	        dd : '%d tagoj',
	        M : 'monato',
	        MM : '%d monatoj',
	        y : 'jaro',
	        yy : '%d jaroj'
	    },
	    ordinalParse: /\d{1,2}a/,
	    ordinal : '%da',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eo;
	
	})));


/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var es = moment.defineLocale('es', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    ordinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return es;
	
	})));


/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_');
	var monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	var esDo = moment.defineLocale('es-do', {
	    months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShort[m.month()];
	        } else {
	            return monthsShortDot[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY h:mm A',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastDay : function () {
	            return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        lastWeek : function () {
	            return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'en %s',
	        past : 'hace %s',
	        s : 'unos segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'una hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un año',
	        yy : '%d años'
	    },
	    ordinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return esDo;
	
	})));


/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	        'm' : ['ühe minuti', 'üks minut'],
	        'mm': [number + ' minuti', number + ' minutit'],
	        'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	        'hh': [number + ' tunni', number + ' tundi'],
	        'd' : ['ühe päeva', 'üks päev'],
	        'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	        'MM': [number + ' kuu', number + ' kuud'],
	        'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	        'yy': [number + ' aasta', number + ' aastat']
	    };
	    if (withoutSuffix) {
	        return format[key][2] ? format[key][2] : format[key][1];
	    }
	    return isFuture ? format[key][0] : format[key][1];
	}
	
	var et = moment.defineLocale('et', {
	    months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	    monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	    weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	    weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	    weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	    longDateFormat : {
	        LT   : 'H:mm',
	        LTS : 'H:mm:ss',
	        L    : 'DD.MM.YYYY',
	        LL   : 'D. MMMM YYYY',
	        LLL  : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[Täna,] LT',
	        nextDay  : '[Homme,] LT',
	        nextWeek : '[Järgmine] dddd LT',
	        lastDay  : '[Eile,] LT',
	        lastWeek : '[Eelmine] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s pärast',
	        past   : '%s tagasi',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : '%d päeva',
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return et;
	
	})));


/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var eu = moment.defineLocale('eu', {
	    months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	    monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	    weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	    weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY[ko] MMMM[ren] D[a]',
	        LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	        LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	        l : 'YYYY-M-D',
	        ll : 'YYYY[ko] MMM D[a]',
	        lll : 'YYYY[ko] MMM D[a] HH:mm',
	        llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	    },
	    calendar : {
	        sameDay : '[gaur] LT[etan]',
	        nextDay : '[bihar] LT[etan]',
	        nextWeek : 'dddd LT[etan]',
	        lastDay : '[atzo] LT[etan]',
	        lastWeek : '[aurreko] dddd LT[etan]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s barru',
	        past : 'duela %s',
	        s : 'segundo batzuk',
	        m : 'minutu bat',
	        mm : '%d minutu',
	        h : 'ordu bat',
	        hh : '%d ordu',
	        d : 'egun bat',
	        dd : '%d egun',
	        M : 'hilabete bat',
	        MM : '%d hilabete',
	        y : 'urte bat',
	        yy : '%d urte'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return eu;
	
	})));


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '۱',
	    '2': '۲',
	    '3': '۳',
	    '4': '۴',
	    '5': '۵',
	    '6': '۶',
	    '7': '۷',
	    '8': '۸',
	    '9': '۹',
	    '0': '۰'
	};
	var numberMap = {
	    '۱': '1',
	    '۲': '2',
	    '۳': '3',
	    '۴': '4',
	    '۵': '5',
	    '۶': '6',
	    '۷': '7',
	    '۸': '8',
	    '۹': '9',
	    '۰': '0'
	};
	
	var fa = moment.defineLocale('fa', {
	    months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	    weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	    weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /قبل از ظهر|بعد از ظهر/,
	    isPM: function (input) {
	        return /بعد از ظهر/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'قبل از ظهر';
	        } else {
	            return 'بعد از ظهر';
	        }
	    },
	    calendar : {
	        sameDay : '[امروز ساعت] LT',
	        nextDay : '[فردا ساعت] LT',
	        nextWeek : 'dddd [ساعت] LT',
	        lastDay : '[دیروز ساعت] LT',
	        lastWeek : 'dddd [پیش] [ساعت] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'در %s',
	        past : '%s پیش',
	        s : 'چندین ثانیه',
	        m : 'یک دقیقه',
	        mm : '%d دقیقه',
	        h : 'یک ساعت',
	        hh : '%d ساعت',
	        d : 'یک روز',
	        dd : '%d روز',
	        M : 'یک ماه',
	        MM : '%d ماه',
	        y : 'یک سال',
	        yy : '%d سال'
	    },
	    preparse: function (string) {
	        return string.replace(/[۰-۹]/g, function (match) {
	            return numberMap[match];
	        }).replace(/،/g, ',');
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        }).replace(/,/g, '،');
	    },
	    ordinalParse: /\d{1,2}م/,
	    ordinal : '%dم',
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return fa;
	
	})));


/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' ');
	var numbersFuture = [
	        'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	        numbersPast[7], numbersPast[8], numbersPast[9]
	    ];
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = '';
	    switch (key) {
	        case 's':
	            return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	        case 'm':
	            return isFuture ? 'minuutin' : 'minuutti';
	        case 'mm':
	            result = isFuture ? 'minuutin' : 'minuuttia';
	            break;
	        case 'h':
	            return isFuture ? 'tunnin' : 'tunti';
	        case 'hh':
	            result = isFuture ? 'tunnin' : 'tuntia';
	            break;
	        case 'd':
	            return isFuture ? 'päivän' : 'päivä';
	        case 'dd':
	            result = isFuture ? 'päivän' : 'päivää';
	            break;
	        case 'M':
	            return isFuture ? 'kuukauden' : 'kuukausi';
	        case 'MM':
	            result = isFuture ? 'kuukauden' : 'kuukautta';
	            break;
	        case 'y':
	            return isFuture ? 'vuoden' : 'vuosi';
	        case 'yy':
	            result = isFuture ? 'vuoden' : 'vuotta';
	            break;
	    }
	    result = verbalNumber(number, isFuture) + ' ' + result;
	    return result;
	}
	function verbalNumber(number, isFuture) {
	    return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	}
	
	var fi = moment.defineLocale('fi', {
	    months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	    monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	    weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	    weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'Do MMMM[ta] YYYY',
	        LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	        LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	        l : 'D.M.YYYY',
	        ll : 'Do MMM YYYY',
	        lll : 'Do MMM YYYY, [klo] HH.mm',
	        llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	    },
	    calendar : {
	        sameDay : '[tänään] [klo] LT',
	        nextDay : '[huomenna] [klo] LT',
	        nextWeek : 'dddd [klo] LT',
	        lastDay : '[eilen] [klo] LT',
	        lastWeek : '[viime] dddd[na] [klo] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s päästä',
	        past : '%s sitten',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fi;
	
	})));


/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fo = moment.defineLocale('fo', {
	    months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	    weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	    weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D. MMMM, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Í dag kl.] LT',
	        nextDay : '[Í morgin kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[Í gjár kl.] LT',
	        lastWeek : '[síðstu] dddd [kl] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'um %s',
	        past : '%s síðani',
	        s : 'fá sekund',
	        m : 'ein minutt',
	        mm : '%d minuttir',
	        h : 'ein tími',
	        hh : '%d tímar',
	        d : 'ein dagur',
	        dd : '%d dagar',
	        M : 'ein mánaði',
	        MM : '%d mánaðir',
	        y : 'eitt ár',
	        yy : '%d ár'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fo;
	
	})));


/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var fr = moment.defineLocale('fr', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Aujourd\'hui à] LT',
	        nextDay: '[Demain à] LT',
	        nextWeek: 'dddd [à] LT',
	        lastDay: '[Hier à] LT',
	        lastWeek: 'dddd [dernier à] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    ordinalParse: /\d{1,2}(er|)/,
	    ordinal : function (number) {
	        return number + (number === 1 ? 'er' : '');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fr;
	
	})));


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCa = moment.defineLocale('fr-ca', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Aujourd\'hui à] LT',
	        nextDay: '[Demain à] LT',
	        nextWeek: 'dddd [à] LT',
	        lastDay: '[Hier à] LT',
	        lastWeek: 'dddd [dernier à] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    ordinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number) {
	        return number + (number === 1 ? 'er' : 'e');
	    }
	});
	
	return frCa;
	
	})));


/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var frCh = moment.defineLocale('fr-ch', {
	    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Aujourd\'hui à] LT',
	        nextDay: '[Demain à] LT',
	        nextWeek: 'dddd [à] LT',
	        lastDay: '[Hier à] LT',
	        lastWeek: 'dddd [dernier à] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dans %s',
	        past : 'il y a %s',
	        s : 'quelques secondes',
	        m : 'une minute',
	        mm : '%d minutes',
	        h : 'une heure',
	        hh : '%d heures',
	        d : 'un jour',
	        dd : '%d jours',
	        M : 'un mois',
	        MM : '%d mois',
	        y : 'un an',
	        yy : '%d ans'
	    },
	    ordinalParse: /\d{1,2}(er|e)/,
	    ordinal : function (number) {
	        return number + (number === 1 ? 'er' : 'e');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return frCh;
	
	})));


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	var fy = moment.defineLocale('fy', {
	    months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	    monthsParseExact : true,
	    weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	    weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	    weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[hjoed om] LT',
	        nextDay: '[moarn om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[juster om] LT',
	        lastWeek: '[ôfrûne] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'oer %s',
	        past : '%s lyn',
	        s : 'in pear sekonden',
	        m : 'ien minút',
	        mm : '%d minuten',
	        h : 'ien oere',
	        hh : '%d oeren',
	        d : 'ien dei',
	        dd : '%d dagen',
	        M : 'ien moanne',
	        MM : '%d moannen',
	        y : 'ien jier',
	        yy : '%d jierren'
	    },
	    ordinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return fy;
	
	})));


/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = [
	    'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	];
	
	var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	var gd = moment.defineLocale('gd', {
	    months : months,
	    monthsShort : monthsShort,
	    monthsParseExact : true,
	    weekdays : weekdays,
	    weekdaysShort : weekdaysShort,
	    weekdaysMin : weekdaysMin,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[An-diugh aig] LT',
	        nextDay : '[A-màireach aig] LT',
	        nextWeek : 'dddd [aig] LT',
	        lastDay : '[An-dè aig] LT',
	        lastWeek : 'dddd [seo chaidh] [aig] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ann an %s',
	        past : 'bho chionn %s',
	        s : 'beagan diogan',
	        m : 'mionaid',
	        mm : '%d mionaidean',
	        h : 'uair',
	        hh : '%d uairean',
	        d : 'latha',
	        dd : '%d latha',
	        M : 'mìos',
	        MM : '%d mìosan',
	        y : 'bliadhna',
	        yy : '%d bliadhna'
	    },
	    ordinalParse : /\d{1,2}(d|na|mh)/,
	    ordinal : function (number) {
	        var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gd;
	
	})));


/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var gl = moment.defineLocale('gl', {
	    months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	    monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	    weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	    weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY H:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	    },
	    calendar : {
	        sameDay : function () {
	            return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextDay : function () {
	            return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	        },
	        nextWeek : function () {
	            return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        lastDay : function () {
	            return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	        },
	        lastWeek : function () {
	            return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (str) {
	            if (str.indexOf('un') === 0) {
	                return 'n' + str;
	            }
	            return 'en ' + str;
	        },
	        past : 'hai %s',
	        s : 'uns segundos',
	        m : 'un minuto',
	        mm : '%d minutos',
	        h : 'unha hora',
	        hh : '%d horas',
	        d : 'un día',
	        dd : '%d días',
	        M : 'un mes',
	        MM : '%d meses',
	        y : 'un ano',
	        yy : '%d anos'
	    },
	    ordinalParse : /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return gl;
	
	})));


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var he = moment.defineLocale('he', {
	    months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	    monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	    weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	    weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	    weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [ב]MMMM YYYY',
	        LLL : 'D [ב]MMMM YYYY HH:mm',
	        LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	        l : 'D/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[היום ב־]LT',
	        nextDay : '[מחר ב־]LT',
	        nextWeek : 'dddd [בשעה] LT',
	        lastDay : '[אתמול ב־]LT',
	        lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'בעוד %s',
	        past : 'לפני %s',
	        s : 'מספר שניות',
	        m : 'דקה',
	        mm : '%d דקות',
	        h : 'שעה',
	        hh : function (number) {
	            if (number === 2) {
	                return 'שעתיים';
	            }
	            return number + ' שעות';
	        },
	        d : 'יום',
	        dd : function (number) {
	            if (number === 2) {
	                return 'יומיים';
	            }
	            return number + ' ימים';
	        },
	        M : 'חודש',
	        MM : function (number) {
	            if (number === 2) {
	                return 'חודשיים';
	            }
	            return number + ' חודשים';
	        },
	        y : 'שנה',
	        yy : function (number) {
	            if (number === 2) {
	                return 'שנתיים';
	            } else if (number % 10 === 0 && number !== 10) {
	                return number + ' שנה';
	            }
	            return number + ' שנים';
	        }
	    },
	    meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	    isPM : function (input) {
	        return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 5) {
	            return 'לפנות בוקר';
	        } else if (hour < 10) {
	            return 'בבוקר';
	        } else if (hour < 12) {
	            return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	        } else if (hour < 18) {
	            return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	        } else {
	            return 'בערב';
	        }
	    }
	});
	
	return he;
	
	})));


/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var hi = moment.defineLocale('hi', {
	    months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	    monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm बजे',
	        LTS : 'A h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[कल] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[कल] LT',
	        lastWeek : '[पिछले] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s में',
	        past : '%s पहले',
	        s : 'कुछ ही क्षण',
	        m : 'एक मिनट',
	        mm : '%d मिनट',
	        h : 'एक घंटा',
	        hh : '%d घंटे',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महीने',
	        MM : '%d महीने',
	        y : 'एक वर्ष',
	        yy : '%d वर्ष'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	    meridiemParse: /रात|सुबह|दोपहर|शाम/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सुबह') {
	            return hour;
	        } else if (meridiem === 'दोपहर') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'शाम') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात';
	        } else if (hour < 10) {
	            return 'सुबह';
	        } else if (hour < 17) {
	            return 'दोपहर';
	        } else if (hour < 20) {
	            return 'शाम';
	        } else {
	            return 'रात';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hi;
	
	})));


/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	        case 'mm':
	            if (number === 1) {
	                result += 'minuta';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'minute';
	            } else {
	                result += 'minuta';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'jedan sat' : 'jednog sata';
	        case 'hh':
	            if (number === 1) {
	                result += 'sat';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'sata';
	            } else {
	                result += 'sati';
	            }
	            return result;
	        case 'dd':
	            if (number === 1) {
	                result += 'dan';
	            } else {
	                result += 'dana';
	            }
	            return result;
	        case 'MM':
	            if (number === 1) {
	                result += 'mjesec';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'mjeseca';
	            } else {
	                result += 'mjeseci';
	            }
	            return result;
	        case 'yy':
	            if (number === 1) {
	                result += 'godina';
	            } else if (number === 2 || number === 3 || number === 4) {
	                result += 'godine';
	            } else {
	                result += 'godina';
	            }
	            return result;
	    }
	}
	
	var hr = moment.defineLocale('hr', {
	    months : {
	        format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	        standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	    },
	    monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danas u] LT',
	        nextDay  : '[sutra u] LT',
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[jučer u] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                    return '[prošlu] dddd [u] LT';
	                case 6:
	                    return '[prošle] [subote] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prošli] dddd [u] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'par sekundi',
	        m      : translate,
	        mm     : translate,
	        h      : translate,
	        hh     : translate,
	        d      : 'dan',
	        dd     : translate,
	        M      : 'mjesec',
	        MM     : translate,
	        y      : 'godinu',
	        yy     : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hr;
	
	})));


/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	function translate(number, withoutSuffix, key, isFuture) {
	    var num = number,
	        suffix;
	    switch (key) {
	        case 's':
	            return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	        case 'm':
	            return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'mm':
	            return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	        case 'h':
	            return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'hh':
	            return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	        case 'd':
	            return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'dd':
	            return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	        case 'M':
	            return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'MM':
	            return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	        case 'y':
	            return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	        case 'yy':
	            return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	    }
	    return '';
	}
	function week(isFuture) {
	    return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	}
	
	var hu = moment.defineLocale('hu', {
	    months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	    monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	    weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	    weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	    weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY.MM.DD.',
	        LL : 'YYYY. MMMM D.',
	        LLL : 'YYYY. MMMM D. H:mm',
	        LLLL : 'YYYY. MMMM D., dddd H:mm'
	    },
	    meridiemParse: /de|du/i,
	    isPM: function (input) {
	        return input.charAt(1).toLowerCase() === 'u';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower === true ? 'de' : 'DE';
	        } else {
	            return isLower === true ? 'du' : 'DU';
	        }
	    },
	    calendar : {
	        sameDay : '[ma] LT[-kor]',
	        nextDay : '[holnap] LT[-kor]',
	        nextWeek : function () {
	            return week.call(this, true);
	        },
	        lastDay : '[tegnap] LT[-kor]',
	        lastWeek : function () {
	            return week.call(this, false);
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s múlva',
	        past : '%s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return hu;
	
	})));


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var hyAm = moment.defineLocale('hy-am', {
	    months : {
	        format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	        standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	    },
	    monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	    weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	    weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY թ.',
	        LLL : 'D MMMM YYYY թ., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	    },
	    calendar : {
	        sameDay: '[այսօր] LT',
	        nextDay: '[վաղը] LT',
	        lastDay: '[երեկ] LT',
	        nextWeek: function () {
	            return 'dddd [օրը ժամը] LT';
	        },
	        lastWeek: function () {
	            return '[անցած] dddd [օրը ժամը] LT';
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s հետո',
	        past : '%s առաջ',
	        s : 'մի քանի վայրկյան',
	        m : 'րոպե',
	        mm : '%d րոպե',
	        h : 'ժամ',
	        hh : '%d ժամ',
	        d : 'օր',
	        dd : '%d օր',
	        M : 'ամիս',
	        MM : '%d ամիս',
	        y : 'տարի',
	        yy : '%d տարի'
	    },
	    meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	    isPM: function (input) {
	        return /^(ցերեկվա|երեկոյան)$/.test(input);
	    },
	    meridiem : function (hour) {
	        if (hour < 4) {
	            return 'գիշերվա';
	        } else if (hour < 12) {
	            return 'առավոտվա';
	        } else if (hour < 17) {
	            return 'ցերեկվա';
	        } else {
	            return 'երեկոյան';
	        }
	    },
	    ordinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'DDD':
	            case 'w':
	            case 'W':
	            case 'DDDo':
	                if (number === 1) {
	                    return number + '-ին';
	                }
	                return number + '-րդ';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return hyAm;
	
	})));


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var id = moment.defineLocale('id', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|siang|sore|malam/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'siang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sore' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'siang';
	        } else if (hours < 19) {
	            return 'sore';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Besok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kemarin pukul] LT',
	        lastWeek : 'dddd [lalu pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lalu',
	        s : 'beberapa detik',
	        m : 'semenit',
	        mm : '%d menit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return id;
	
	})));


/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(n) {
	    if (n % 100 === 11) {
	        return true;
	    } else if (n % 10 === 1) {
	        return false;
	    }
	    return true;
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	        case 'm':
	            return withoutSuffix ? 'mínúta' : 'mínútu';
	        case 'mm':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	            } else if (withoutSuffix) {
	                return result + 'mínúta';
	            }
	            return result + 'mínútu';
	        case 'hh':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	            }
	            return result + 'klukkustund';
	        case 'd':
	            if (withoutSuffix) {
	                return 'dagur';
	            }
	            return isFuture ? 'dag' : 'degi';
	        case 'dd':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'dagar';
	                }
	                return result + (isFuture ? 'daga' : 'dögum');
	            } else if (withoutSuffix) {
	                return result + 'dagur';
	            }
	            return result + (isFuture ? 'dag' : 'degi');
	        case 'M':
	            if (withoutSuffix) {
	                return 'mánuður';
	            }
	            return isFuture ? 'mánuð' : 'mánuði';
	        case 'MM':
	            if (plural(number)) {
	                if (withoutSuffix) {
	                    return result + 'mánuðir';
	                }
	                return result + (isFuture ? 'mánuði' : 'mánuðum');
	            } else if (withoutSuffix) {
	                return result + 'mánuður';
	            }
	            return result + (isFuture ? 'mánuð' : 'mánuði');
	        case 'y':
	            return withoutSuffix || isFuture ? 'ár' : 'ári';
	        case 'yy':
	            if (plural(number)) {
	                return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	            }
	            return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	    }
	}
	
	var is = moment.defineLocale('is', {
	    months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	    weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	    weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	    weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	    },
	    calendar : {
	        sameDay : '[í dag kl.] LT',
	        nextDay : '[á morgun kl.] LT',
	        nextWeek : 'dddd [kl.] LT',
	        lastDay : '[í gær kl.] LT',
	        lastWeek : '[síðasta] dddd [kl.] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'eftir %s',
	        past : 'fyrir %s síðan',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : 'klukkustund',
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return is;
	
	})));


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var it = moment.defineLocale('it', {
	    months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	    monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	    weekdays : 'Domenica_Lunedì_Martedì_Mercoledì_Giovedì_Venerdì_Sabato'.split('_'),
	    weekdaysShort : 'Dom_Lun_Mar_Mer_Gio_Ven_Sab'.split('_'),
	    weekdaysMin : 'Do_Lu_Ma_Me_Gi_Ve_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Oggi alle] LT',
	        nextDay: '[Domani alle] LT',
	        nextWeek: 'dddd [alle] LT',
	        lastDay: '[Ieri alle] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[la scorsa] dddd [alle] LT';
	                default:
	                    return '[lo scorso] dddd [alle] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	        },
	        past : '%s fa',
	        s : 'alcuni secondi',
	        m : 'un minuto',
	        mm : '%d minuti',
	        h : 'un\'ora',
	        hh : '%d ore',
	        d : 'un giorno',
	        dd : '%d giorni',
	        M : 'un mese',
	        MM : '%d mesi',
	        y : 'un anno',
	        yy : '%d anni'
	    },
	    ordinalParse : /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return it;
	
	})));


/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ja = moment.defineLocale('ja', {
	    months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	    weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	    weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	    longDateFormat : {
	        LT : 'Ah時m分',
	        LTS : 'Ah時m分s秒',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY年M月D日',
	        LLL : 'YYYY年M月D日Ah時m分',
	        LLLL : 'YYYY年M月D日Ah時m分 dddd'
	    },
	    meridiemParse: /午前|午後/i,
	    isPM : function (input) {
	        return input === '午後';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return '午前';
	        } else {
	            return '午後';
	        }
	    },
	    calendar : {
	        sameDay : '[今日] LT',
	        nextDay : '[明日] LT',
	        nextWeek : '[来週]dddd LT',
	        lastDay : '[昨日] LT',
	        lastWeek : '[前週]dddd LT',
	        sameElse : 'L'
	    },
	    ordinalParse : /\d{1,2}日/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s後',
	        past : '%s前',
	        s : '数秒',
	        m : '1分',
	        mm : '%d分',
	        h : '1時間',
	        hh : '%d時間',
	        d : '1日',
	        dd : '%d日',
	        M : '1ヶ月',
	        MM : '%dヶ月',
	        y : '1年',
	        yy : '%d年'
	    }
	});
	
	return ja;
	
	})));


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var jv = moment.defineLocale('jv', {
	    months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	    monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	    weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	    weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	    weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /enjing|siyang|sonten|ndalu/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'enjing') {
	            return hour;
	        } else if (meridiem === 'siyang') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'enjing';
	        } else if (hours < 15) {
	            return 'siyang';
	        } else if (hours < 19) {
	            return 'sonten';
	        } else {
	            return 'ndalu';
	        }
	    },
	    calendar : {
	        sameDay : '[Dinten puniko pukul] LT',
	        nextDay : '[Mbenjang pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kala wingi pukul] LT',
	        lastWeek : 'dddd [kepengker pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'wonten ing %s',
	        past : '%s ingkang kepengker',
	        s : 'sawetawis detik',
	        m : 'setunggal menit',
	        mm : '%d menit',
	        h : 'setunggal jam',
	        hh : '%d jam',
	        d : 'sedinten',
	        dd : '%d dinten',
	        M : 'sewulan',
	        MM : '%d wulan',
	        y : 'setaun',
	        yy : '%d taun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return jv;
	
	})));


/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ka = moment.defineLocale('ka', {
	    months : {
	        standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	        format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	    },
	    monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	    weekdays : {
	        standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	        format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	        isFormat: /(წინა|შემდეგ)/
	    },
	    weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	    weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[დღეს] LT[-ზე]',
	        nextDay : '[ხვალ] LT[-ზე]',
	        lastDay : '[გუშინ] LT[-ზე]',
	        nextWeek : '[შემდეგ] dddd LT[-ზე]',
	        lastWeek : '[წინა] dddd LT-ზე',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : function (s) {
	            return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                s.replace(/ი$/, 'ში') :
	                s + 'ში';
	        },
	        past : function (s) {
	            if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                return s.replace(/(ი|ე)$/, 'ის წინ');
	            }
	            if ((/წელი/).test(s)) {
	                return s.replace(/წელი$/, 'წლის წინ');
	            }
	        },
	        s : 'რამდენიმე წამი',
	        m : 'წუთი',
	        mm : '%d წუთი',
	        h : 'საათი',
	        hh : '%d საათი',
	        d : 'დღე',
	        dd : '%d დღე',
	        M : 'თვე',
	        MM : '%d თვე',
	        y : 'წელი',
	        yy : '%d წელი'
	    },
	    ordinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	    ordinal : function (number) {
	        if (number === 0) {
	            return number;
	        }
	        if (number === 1) {
	            return number + '-ლი';
	        }
	        if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	            return 'მე-' + number;
	        }
	        return number + '-ე';
	    },
	    week : {
	        dow : 1,
	        doy : 7
	    }
	});
	
	return ka;
	
	})));


/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    0: '-ші',
	    1: '-ші',
	    2: '-ші',
	    3: '-ші',
	    4: '-ші',
	    5: '-ші',
	    6: '-шы',
	    7: '-ші',
	    8: '-ші',
	    9: '-шы',
	    10: '-шы',
	    20: '-шы',
	    30: '-шы',
	    40: '-шы',
	    50: '-ші',
	    60: '-шы',
	    70: '-ші',
	    80: '-ші',
	    90: '-шы',
	    100: '-ші'
	};
	
	var kk = moment.defineLocale('kk', {
	    months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	    monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	    weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	    weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	    weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгін сағат] LT',
	        nextDay : '[Ертең сағат] LT',
	        nextWeek : 'dddd [сағат] LT',
	        lastDay : '[Кеше сағат] LT',
	        lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ішінде',
	        past : '%s бұрын',
	        s : 'бірнеше секунд',
	        m : 'бір минут',
	        mm : '%d минут',
	        h : 'бір сағат',
	        hh : '%d сағат',
	        d : 'бір күн',
	        dd : '%d күн',
	        M : 'бір ай',
	        MM : '%d ай',
	        y : 'бір жыл',
	        yy : '%d жыл'
	    },
	    ordinalParse: /\d{1,2}-(ші|шы)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return kk;
	
	})));


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var km = moment.defineLocale('km', {
	    months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	    weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	        nextDay: '[ស្អែក ម៉ោង] LT',
	        nextWeek: 'dddd [ម៉ោង] LT',
	        lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	        lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: '%sទៀត',
	        past: '%sមុន',
	        s: 'ប៉ុន្មានវិនាទី',
	        m: 'មួយនាទី',
	        mm: '%d នាទី',
	        h: 'មួយម៉ោង',
	        hh: '%d ម៉ោង',
	        d: 'មួយថ្ងៃ',
	        dd: '%d ថ្ងៃ',
	        M: 'មួយខែ',
	        MM: '%d ខែ',
	        y: 'មួយឆ្នាំ',
	        yy: '%d ឆ្នាំ'
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return km;
	
	})));


/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ko = moment.defineLocale('ko', {
	    months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	    weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	    weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	    weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	    longDateFormat : {
	        LT : 'A h시 m분',
	        LTS : 'A h시 m분 s초',
	        L : 'YYYY.MM.DD',
	        LL : 'YYYY년 MMMM D일',
	        LLL : 'YYYY년 MMMM D일 A h시 m분',
	        LLLL : 'YYYY년 MMMM D일 dddd A h시 m분'
	    },
	    calendar : {
	        sameDay : '오늘 LT',
	        nextDay : '내일 LT',
	        nextWeek : 'dddd LT',
	        lastDay : '어제 LT',
	        lastWeek : '지난주 dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s 후',
	        past : '%s 전',
	        s : '몇 초',
	        ss : '%d초',
	        m : '일분',
	        mm : '%d분',
	        h : '한 시간',
	        hh : '%d시간',
	        d : '하루',
	        dd : '%d일',
	        M : '한 달',
	        MM : '%d달',
	        y : '일 년',
	        yy : '%d년'
	    },
	    ordinalParse : /\d{1,2}일/,
	    ordinal : '%d일',
	    meridiemParse : /오전|오후/,
	    isPM : function (token) {
	        return token === '오후';
	    },
	    meridiem : function (hour, minute, isUpper) {
	        return hour < 12 ? '오전' : '오후';
	    }
	});
	
	return ko;
	
	})));


/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var suffixes = {
	    0: '-чү',
	    1: '-чи',
	    2: '-чи',
	    3: '-чү',
	    4: '-чү',
	    5: '-чи',
	    6: '-чы',
	    7: '-чи',
	    8: '-чи',
	    9: '-чу',
	    10: '-чу',
	    20: '-чы',
	    30: '-чу',
	    40: '-чы',
	    50: '-чү',
	    60: '-чы',
	    70: '-чи',
	    80: '-чи',
	    90: '-чу',
	    100: '-чү'
	};
	
	var ky = moment.defineLocale('ky', {
	    months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	    monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	    weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	    weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бүгүн саат] LT',
	        nextDay : '[Эртең саат] LT',
	        nextWeek : 'dddd [саат] LT',
	        lastDay : '[Кече саат] LT',
	        lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ичинде',
	        past : '%s мурун',
	        s : 'бирнече секунд',
	        m : 'бир мүнөт',
	        mm : '%d мүнөт',
	        h : 'бир саат',
	        hh : '%d саат',
	        d : 'бир күн',
	        dd : '%d күн',
	        M : 'бир ай',
	        MM : '%d ай',
	        y : 'бир жыл',
	        yy : '%d жыл'
	    },
	    ordinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	    ordinal : function (number) {
	        var a = number % 10,
	            b = number >= 100 ? 100 : null;
	        return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ky;
	
	})));


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        'm': ['eng Minutt', 'enger Minutt'],
	        'h': ['eng Stonn', 'enger Stonn'],
	        'd': ['een Dag', 'engem Dag'],
	        'M': ['ee Mount', 'engem Mount'],
	        'y': ['ee Joer', 'engem Joer']
	    };
	    return withoutSuffix ? format[key][0] : format[key][1];
	}
	function processFutureTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'a ' + string;
	    }
	    return 'an ' + string;
	}
	function processPastTime(string) {
	    var number = string.substr(0, string.indexOf(' '));
	    if (eifelerRegelAppliesToNumber(number)) {
	        return 'viru ' + string;
	    }
	    return 'virun ' + string;
	}
	/**
	 * Returns true if the word before the given number loses the '-n' ending.
	 * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	 *
	 * @param number {integer}
	 * @returns {boolean}
	 */
	function eifelerRegelAppliesToNumber(number) {
	    number = parseInt(number, 10);
	    if (isNaN(number)) {
	        return false;
	    }
	    if (number < 0) {
	        // Negative Number --> always true
	        return true;
	    } else if (number < 10) {
	        // Only 1 digit
	        if (4 <= number && number <= 7) {
	            return true;
	        }
	        return false;
	    } else if (number < 100) {
	        // 2 digits
	        var lastDigit = number % 10, firstDigit = number / 10;
	        if (lastDigit === 0) {
	            return eifelerRegelAppliesToNumber(firstDigit);
	        }
	        return eifelerRegelAppliesToNumber(lastDigit);
	    } else if (number < 10000) {
	        // 3 or 4 digits --> recursively check first digit
	        while (number >= 10) {
	            number = number / 10;
	        }
	        return eifelerRegelAppliesToNumber(number);
	    } else {
	        // Anything larger than 4 digits: recursively check first n-3 digits
	        number = number / 1000;
	        return eifelerRegelAppliesToNumber(number);
	    }
	}
	
	var lb = moment.defineLocale('lb', {
	    months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	    monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	    weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	    weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm [Auer]',
	        LTS: 'H:mm:ss [Auer]',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm [Auer]',
	        LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	    },
	    calendar: {
	        sameDay: '[Haut um] LT',
	        sameElse: 'L',
	        nextDay: '[Muer um] LT',
	        nextWeek: 'dddd [um] LT',
	        lastDay: '[Gëschter um] LT',
	        lastWeek: function () {
	            // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	            switch (this.day()) {
	                case 2:
	                case 4:
	                    return '[Leschten] dddd [um] LT';
	                default:
	                    return '[Leschte] dddd [um] LT';
	            }
	        }
	    },
	    relativeTime : {
	        future : processFutureTime,
	        past : processPastTime,
	        s : 'e puer Sekonnen',
	        m : processRelativeTime,
	        mm : '%d Minutten',
	        h : processRelativeTime,
	        hh : '%d Stonnen',
	        d : processRelativeTime,
	        dd : '%d Deeg',
	        M : processRelativeTime,
	        MM : '%d Méint',
	        y : processRelativeTime,
	        yy : '%d Joer'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal: '%d.',
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lb;
	
	})));


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var lo = moment.defineLocale('lo', {
	    months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	    weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	    weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	    },
	    meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	    isPM: function (input) {
	        return input === 'ຕອນແລງ';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ຕອນເຊົ້າ';
	        } else {
	            return 'ຕອນແລງ';
	        }
	    },
	    calendar : {
	        sameDay : '[ມື້ນີ້ເວລາ] LT',
	        nextDay : '[ມື້ອື່ນເວລາ] LT',
	        nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	        lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	        lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ອີກ %s',
	        past : '%sຜ່ານມາ',
	        s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	        m : '1 ນາທີ',
	        mm : '%d ນາທີ',
	        h : '1 ຊົ່ວໂມງ',
	        hh : '%d ຊົ່ວໂມງ',
	        d : '1 ມື້',
	        dd : '%d ມື້',
	        M : '1 ເດືອນ',
	        MM : '%d ເດືອນ',
	        y : '1 ປີ',
	        yy : '%d ປີ'
	    },
	    ordinalParse: /(ທີ່)\d{1,2}/,
	    ordinal : function (number) {
	        return 'ທີ່' + number;
	    }
	});
	
	return lo;
	
	})));


/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm' : 'minutė_minutės_minutę',
	    'mm': 'minutės_minučių_minutes',
	    'h' : 'valanda_valandos_valandą',
	    'hh': 'valandos_valandų_valandas',
	    'd' : 'diena_dienos_dieną',
	    'dd': 'dienos_dienų_dienas',
	    'M' : 'mėnuo_mėnesio_mėnesį',
	    'MM': 'mėnesiai_mėnesių_mėnesius',
	    'y' : 'metai_metų_metus',
	    'yy': 'metai_metų_metus'
	};
	function translateSeconds(number, withoutSuffix, key, isFuture) {
	    if (withoutSuffix) {
	        return 'kelios sekundės';
	    } else {
	        return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	    }
	}
	function translateSingular(number, withoutSuffix, key, isFuture) {
	    return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	}
	function special(number) {
	    return number % 10 === 0 || (number > 10 && number < 20);
	}
	function forms(key) {
	    return units[key].split('_');
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    if (number === 1) {
	        return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	    } else if (withoutSuffix) {
	        return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	    } else {
	        if (isFuture) {
	            return result + forms(key)[1];
	        } else {
	            return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	        }
	    }
	}
	var lt = moment.defineLocale('lt', {
	    months : {
	        format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	        standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	        isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/
	    },
	    monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	    weekdays : {
	        format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	        standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	        isFormat: /dddd HH:mm/
	    },
	    weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	    weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY [m.] MMMM D [d.]',
	        LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY [m.] MMMM D [d.]',
	        lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	        llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	    },
	    calendar : {
	        sameDay : '[Šiandien] LT',
	        nextDay : '[Rytoj] LT',
	        nextWeek : 'dddd LT',
	        lastDay : '[Vakar] LT',
	        lastWeek : '[Praėjusį] dddd LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'po %s',
	        past : 'prieš %s',
	        s : translateSeconds,
	        m : translateSingular,
	        mm : translate,
	        h : translateSingular,
	        hh : translate,
	        d : translateSingular,
	        dd : translate,
	        M : translateSingular,
	        MM : translate,
	        y : translateSingular,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}-oji/,
	    ordinal : function (number) {
	        return number + '-oji';
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lt;
	
	})));


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var units = {
	    'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	    'h': 'stundas_stundām_stunda_stundas'.split('_'),
	    'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	    'd': 'dienas_dienām_diena_dienas'.split('_'),
	    'dd': 'dienas_dienām_diena_dienas'.split('_'),
	    'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	    'y': 'gada_gadiem_gads_gadi'.split('_'),
	    'yy': 'gada_gadiem_gads_gadi'.split('_')
	};
	/**
	 * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	 */
	function format(forms, number, withoutSuffix) {
	    if (withoutSuffix) {
	        // E.g. "21 minūte", "3 minūtes".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	    } else {
	        // E.g. "21 minūtes" as in "pēc 21 minūtes".
	        // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	        return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	    }
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    return number + ' ' + format(units[key], number, withoutSuffix);
	}
	function relativeTimeWithSingular(number, withoutSuffix, key) {
	    return format(units[key], number, withoutSuffix);
	}
	function relativeSeconds(number, withoutSuffix) {
	    return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	}
	
	var lv = moment.defineLocale('lv', {
	    months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	    weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY.',
	        LL : 'YYYY. [gada] D. MMMM',
	        LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	        LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	    },
	    calendar : {
	        sameDay : '[Šodien pulksten] LT',
	        nextDay : '[Rīt pulksten] LT',
	        nextWeek : 'dddd [pulksten] LT',
	        lastDay : '[Vakar pulksten] LT',
	        lastWeek : '[Pagājušā] dddd [pulksten] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'pēc %s',
	        past : 'pirms %s',
	        s : relativeSeconds,
	        m : relativeTimeWithSingular,
	        mm : relativeTimeWithPlural,
	        h : relativeTimeWithSingular,
	        hh : relativeTimeWithPlural,
	        d : relativeTimeWithSingular,
	        dd : relativeTimeWithPlural,
	        M : relativeTimeWithSingular,
	        MM : relativeTimeWithPlural,
	        y : relativeTimeWithSingular,
	        yy : relativeTimeWithPlural
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return lv;
	
	})));


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jednog minuta'],
	        mm: ['minut', 'minuta', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mjesec', 'mjeseca', 'mjeseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var me = moment.defineLocale('me', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact : true,
	    weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sjutra u] LT',
	
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedjelju] [u] LT';
	                case 3:
	                    return '[u] [srijedu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedjelje] [u] LT',
	                '[prošlog] [ponedjeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srijede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'prije %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mjesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return me;
	
	})));


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mi = moment.defineLocale('mi', {
	    months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	    monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	    monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	    monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	    weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	    weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY [i] HH:mm',
	        LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	    },
	    calendar: {
	        sameDay: '[i teie mahana, i] LT',
	        nextDay: '[apopo i] LT',
	        nextWeek: 'dddd [i] LT',
	        lastDay: '[inanahi i] LT',
	        lastWeek: 'dddd [whakamutunga i] LT',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'i roto i %s',
	        past: '%s i mua',
	        s: 'te hēkona ruarua',
	        m: 'he meneti',
	        mm: '%d meneti',
	        h: 'te haora',
	        hh: '%d haora',
	        d: 'he ra',
	        dd: '%d ra',
	        M: 'he marama',
	        MM: '%d marama',
	        y: 'he tau',
	        yy: '%d tau'
	    },
	    ordinalParse: /\d{1,2}º/,
	    ordinal: '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return mi;
	
	})));


/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var mk = moment.defineLocale('mk', {
	    months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	    monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	    weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	    weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	    weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'D.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay : '[Денес во] LT',
	        nextDay : '[Утре во] LT',
	        nextWeek : '[Во] dddd [во] LT',
	        lastDay : '[Вчера во] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 6:
	                    return '[Изминатата] dddd [во] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[Изминатиот] dddd [во] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'после %s',
	        past : 'пред %s',
	        s : 'неколку секунди',
	        m : 'минута',
	        mm : '%d минути',
	        h : 'час',
	        hh : '%d часа',
	        d : 'ден',
	        dd : '%d дена',
	        M : 'месец',
	        MM : '%d месеци',
	        y : 'година',
	        yy : '%d години'
	    },
	    ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	    ordinal : function (number) {
	        var lastDigit = number % 10,
	            last2Digits = number % 100;
	        if (number === 0) {
	            return number + '-ев';
	        } else if (last2Digits === 0) {
	            return number + '-ен';
	        } else if (last2Digits > 10 && last2Digits < 20) {
	            return number + '-ти';
	        } else if (lastDigit === 1) {
	            return number + '-ви';
	        } else if (lastDigit === 2) {
	            return number + '-ри';
	        } else if (lastDigit === 7 || lastDigit === 8) {
	            return number + '-ми';
	        } else {
	            return number + '-ти';
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mk;
	
	})));


/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ml = moment.defineLocale('ml', {
	    months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	    monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	    weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	    weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm -നു',
	        LTS : 'A h:mm:ss -നു',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm -നു',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	    },
	    calendar : {
	        sameDay : '[ഇന്ന്] LT',
	        nextDay : '[നാളെ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ഇന്നലെ] LT',
	        lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s കഴിഞ്ഞ്',
	        past : '%s മുൻപ്',
	        s : 'അൽപ നിമിഷങ്ങൾ',
	        m : 'ഒരു മിനിറ്റ്',
	        mm : '%d മിനിറ്റ്',
	        h : 'ഒരു മണിക്കൂർ',
	        hh : '%d മണിക്കൂർ',
	        d : 'ഒരു ദിവസം',
	        dd : '%d ദിവസം',
	        M : 'ഒരു മാസം',
	        MM : '%d മാസം',
	        y : 'ഒരു വർഷം',
	        yy : '%d വർഷം'
	    },
	    meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം') {
	            return hour + 12;
	        } else {
	            return hour;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'രാത്രി';
	        } else if (hour < 12) {
	            return 'രാവിലെ';
	        } else if (hour < 17) {
	            return 'ഉച്ച കഴിഞ്ഞ്';
	        } else if (hour < 20) {
	            return 'വൈകുന്നേരം';
	        } else {
	            return 'രാത്രി';
	        }
	    }
	});
	
	return ml;
	
	})));


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	function relativeTimeMr(number, withoutSuffix, string, isFuture)
	{
	    var output = '';
	    if (withoutSuffix) {
	        switch (string) {
	            case 's': output = 'काही सेकंद'; break;
	            case 'm': output = 'एक मिनिट'; break;
	            case 'mm': output = '%d मिनिटे'; break;
	            case 'h': output = 'एक तास'; break;
	            case 'hh': output = '%d तास'; break;
	            case 'd': output = 'एक दिवस'; break;
	            case 'dd': output = '%d दिवस'; break;
	            case 'M': output = 'एक महिना'; break;
	            case 'MM': output = '%d महिने'; break;
	            case 'y': output = 'एक वर्ष'; break;
	            case 'yy': output = '%d वर्षे'; break;
	        }
	    }
	    else {
	        switch (string) {
	            case 's': output = 'काही सेकंदां'; break;
	            case 'm': output = 'एका मिनिटा'; break;
	            case 'mm': output = '%d मिनिटां'; break;
	            case 'h': output = 'एका तासा'; break;
	            case 'hh': output = '%d तासां'; break;
	            case 'd': output = 'एका दिवसा'; break;
	            case 'dd': output = '%d दिवसां'; break;
	            case 'M': output = 'एका महिन्या'; break;
	            case 'MM': output = '%d महिन्यां'; break;
	            case 'y': output = 'एका वर्षा'; break;
	            case 'yy': output = '%d वर्षां'; break;
	        }
	    }
	    return output.replace(/%d/i, number);
	}
	
	var mr = moment.defineLocale('mr', {
	    months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	    monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	    weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	    weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm वाजता',
	        LTS : 'A h:mm:ss वाजता',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm वाजता',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[उद्या] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[काल] LT',
	        lastWeek: '[मागील] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future: '%sमध्ये',
	        past: '%sपूर्वी',
	        s: relativeTimeMr,
	        m: relativeTimeMr,
	        mm: relativeTimeMr,
	        h: relativeTimeMr,
	        hh: relativeTimeMr,
	        d: relativeTimeMr,
	        dd: relativeTimeMr,
	        M: relativeTimeMr,
	        MM: relativeTimeMr,
	        y: relativeTimeMr,
	        yy: relativeTimeMr
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'रात्री') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'सकाळी') {
	            return hour;
	        } else if (meridiem === 'दुपारी') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'सायंकाळी') {
	            return hour + 12;
	        }
	    },
	    meridiem: function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'रात्री';
	        } else if (hour < 10) {
	            return 'सकाळी';
	        } else if (hour < 17) {
	            return 'दुपारी';
	        } else if (hour < 20) {
	            return 'सायंकाळी';
	        } else {
	            return 'रात्री';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return mr;
	
	})));


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ms = moment.defineLocale('ms', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ms;
	
	})));


/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var msMy = moment.defineLocale('ms-my', {
	    months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	    weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	    weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	    weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [pukul] HH.mm',
	        LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	    },
	    meridiemParse: /pagi|tengahari|petang|malam/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'pagi') {
	            return hour;
	        } else if (meridiem === 'tengahari') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'petang' || meridiem === 'malam') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'pagi';
	        } else if (hours < 15) {
	            return 'tengahari';
	        } else if (hours < 19) {
	            return 'petang';
	        } else {
	            return 'malam';
	        }
	    },
	    calendar : {
	        sameDay : '[Hari ini pukul] LT',
	        nextDay : '[Esok pukul] LT',
	        nextWeek : 'dddd [pukul] LT',
	        lastDay : '[Kelmarin pukul] LT',
	        lastWeek : 'dddd [lepas pukul] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'dalam %s',
	        past : '%s yang lepas',
	        s : 'beberapa saat',
	        m : 'seminit',
	        mm : '%d minit',
	        h : 'sejam',
	        hh : '%d jam',
	        d : 'sehari',
	        dd : '%d hari',
	        M : 'sebulan',
	        MM : '%d bulan',
	        y : 'setahun',
	        yy : '%d tahun'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return msMy;
	
	})));


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '၁',
	    '2': '၂',
	    '3': '၃',
	    '4': '၄',
	    '5': '၅',
	    '6': '၆',
	    '7': '၇',
	    '8': '၈',
	    '9': '၉',
	    '0': '၀'
	};
	var numberMap = {
	    '၁': '1',
	    '၂': '2',
	    '၃': '3',
	    '၄': '4',
	    '၅': '5',
	    '၆': '6',
	    '၇': '7',
	    '၈': '8',
	    '၉': '9',
	    '၀': '0'
	};
	
	var my = moment.defineLocale('my', {
	    months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	    monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	    weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	    weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	    weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	    longDateFormat: {
	        LT: 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L: 'DD/MM/YYYY',
	        LL: 'D MMMM YYYY',
	        LLL: 'D MMMM YYYY HH:mm',
	        LLLL: 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar: {
	        sameDay: '[ယနေ.] LT [မှာ]',
	        nextDay: '[မနက်ဖြန်] LT [မှာ]',
	        nextWeek: 'dddd LT [မှာ]',
	        lastDay: '[မနေ.က] LT [မှာ]',
	        lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	        sameElse: 'L'
	    },
	    relativeTime: {
	        future: 'လာမည့် %s မှာ',
	        past: 'လွန်ခဲ့သော %s က',
	        s: 'စက္ကန်.အနည်းငယ်',
	        m: 'တစ်မိနစ်',
	        mm: '%d မိနစ်',
	        h: 'တစ်နာရီ',
	        hh: '%d နာရီ',
	        d: 'တစ်ရက်',
	        dd: '%d ရက်',
	        M: 'တစ်လ',
	        MM: '%d လ',
	        y: 'တစ်နှစ်',
	        yy: '%d နှစ်'
	    },
	    preparse: function (string) {
	        return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    week: {
	        dow: 1, // Monday is the first day of the week.
	        doy: 4 // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return my;
	
	})));


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nb = moment.defineLocale('nb', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	    weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	    weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[i dag kl.] LT',
	        nextDay: '[i morgen kl.] LT',
	        nextWeek: 'dddd [kl.] LT',
	        lastDay: '[i går kl.] LT',
	        lastWeek: '[forrige] dddd [kl.] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s siden',
	        s : 'noen sekunder',
	        m : 'ett minutt',
	        mm : '%d minutter',
	        h : 'en time',
	        hh : '%d timer',
	        d : 'en dag',
	        dd : '%d dager',
	        M : 'en måned',
	        MM : '%d måneder',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nb;
	
	})));


/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '१',
	    '2': '२',
	    '3': '३',
	    '4': '४',
	    '5': '५',
	    '6': '६',
	    '7': '७',
	    '8': '८',
	    '9': '९',
	    '0': '०'
	};
	var numberMap = {
	    '१': '1',
	    '२': '2',
	    '३': '3',
	    '४': '4',
	    '५': '5',
	    '६': '6',
	    '७': '7',
	    '८': '8',
	    '९': '9',
	    '०': '0'
	};
	
	var ne = moment.defineLocale('ne', {
	    months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	    monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	    weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	    weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'Aको h:mm बजे',
	        LTS : 'Aको h:mm:ss बजे',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, Aको h:mm बजे',
	        LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	    },
	    preparse: function (string) {
	        return string.replace(/[१२३४५६७८९०]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'राति') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'बिहान') {
	            return hour;
	        } else if (meridiem === 'दिउँसो') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'साँझ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 3) {
	            return 'राति';
	        } else if (hour < 12) {
	            return 'बिहान';
	        } else if (hour < 16) {
	            return 'दिउँसो';
	        } else if (hour < 20) {
	            return 'साँझ';
	        } else {
	            return 'राति';
	        }
	    },
	    calendar : {
	        sameDay : '[आज] LT',
	        nextDay : '[भोलि] LT',
	        nextWeek : '[आउँदो] dddd[,] LT',
	        lastDay : '[हिजो] LT',
	        lastWeek : '[गएको] dddd[,] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sमा',
	        past : '%s अगाडि',
	        s : 'केही क्षण',
	        m : 'एक मिनेट',
	        mm : '%d मिनेट',
	        h : 'एक घण्टा',
	        hh : '%d घण्टा',
	        d : 'एक दिन',
	        dd : '%d दिन',
	        M : 'एक महिना',
	        MM : '%d महिना',
	        y : 'एक बर्ष',
	        yy : '%d बर्ष'
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ne;
	
	})));


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nl = moment.defineLocale('nl', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD-MM-YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    ordinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nl;
	
	})));


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_');
	var monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	var nlBe = moment.defineLocale('nl-be', {
	    months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	    monthsShort : function (m, format) {
	        if (/-MMM-/.test(format)) {
	            return monthsShortWithoutDots[m.month()];
	        } else {
	            return monthsShortWithDots[m.month()];
	        }
	    },
	
	    monthsRegex: monthsRegex,
	    monthsShortRegex: monthsRegex,
	    monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	    weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	    weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[vandaag om] LT',
	        nextDay: '[morgen om] LT',
	        nextWeek: 'dddd [om] LT',
	        lastDay: '[gisteren om] LT',
	        lastWeek: '[afgelopen] dddd [om] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'over %s',
	        past : '%s geleden',
	        s : 'een paar seconden',
	        m : 'één minuut',
	        mm : '%d minuten',
	        h : 'één uur',
	        hh : '%d uur',
	        d : 'één dag',
	        dd : '%d dagen',
	        M : 'één maand',
	        MM : '%d maanden',
	        y : 'één jaar',
	        yy : '%d jaar'
	    },
	    ordinalParse: /\d{1,2}(ste|de)/,
	    ordinal : function (number) {
	        return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nlBe;
	
	})));


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var nn = moment.defineLocale('nn', {
	    months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	    weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	    weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	    weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY [kl.] H:mm',
	        LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[I dag klokka] LT',
	        nextDay: '[I morgon klokka] LT',
	        nextWeek: 'dddd [klokka] LT',
	        lastDay: '[I går klokka] LT',
	        lastWeek: '[Føregåande] dddd [klokka] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : '%s sidan',
	        s : 'nokre sekund',
	        m : 'eit minutt',
	        mm : '%d minutt',
	        h : 'ein time',
	        hh : '%d timar',
	        d : 'ein dag',
	        dd : '%d dagar',
	        M : 'ein månad',
	        MM : '%d månader',
	        y : 'eit år',
	        yy : '%d år'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return nn;
	
	})));


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '੧',
	    '2': '੨',
	    '3': '੩',
	    '4': '੪',
	    '5': '੫',
	    '6': '੬',
	    '7': '੭',
	    '8': '੮',
	    '9': '੯',
	    '0': '੦'
	};
	var numberMap = {
	    '੧': '1',
	    '੨': '2',
	    '੩': '3',
	    '੪': '4',
	    '੫': '5',
	    '੬': '6',
	    '੭': '7',
	    '੮': '8',
	    '੯': '9',
	    '੦': '0'
	};
	
	var paIn = moment.defineLocale('pa-in', {
	    // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	    months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	    weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	    weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm ਵਜੇ',
	        LTS : 'A h:mm:ss ਵਜੇ',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	    },
	    calendar : {
	        sameDay : '[ਅਜ] LT',
	        nextDay : '[ਕਲ] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[ਕਲ] LT',
	        lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s ਵਿੱਚ',
	        past : '%s ਪਿਛਲੇ',
	        s : 'ਕੁਝ ਸਕਿੰਟ',
	        m : 'ਇਕ ਮਿੰਟ',
	        mm : '%d ਮਿੰਟ',
	        h : 'ਇੱਕ ਘੰਟਾ',
	        hh : '%d ਘੰਟੇ',
	        d : 'ਇੱਕ ਦਿਨ',
	        dd : '%d ਦਿਨ',
	        M : 'ਇੱਕ ਮਹੀਨਾ',
	        MM : '%d ਮਹੀਨੇ',
	        y : 'ਇੱਕ ਸਾਲ',
	        yy : '%d ਸਾਲ'
	    },
	    preparse: function (string) {
	        return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	    // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	    meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ਰਾਤ') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ਸਵੇਰ') {
	            return hour;
	        } else if (meridiem === 'ਦੁਪਹਿਰ') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'ਸ਼ਾਮ') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ਰਾਤ';
	        } else if (hour < 10) {
	            return 'ਸਵੇਰ';
	        } else if (hour < 17) {
	            return 'ਦੁਪਹਿਰ';
	        } else if (hour < 20) {
	            return 'ਸ਼ਾਮ';
	        } else {
	            return 'ਰਾਤ';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return paIn;
	
	})));


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
	var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	function plural(n) {
	    return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	}
	function translate(number, withoutSuffix, key) {
	    var result = number + ' ';
	    switch (key) {
	        case 'm':
	            return withoutSuffix ? 'minuta' : 'minutę';
	        case 'mm':
	            return result + (plural(number) ? 'minuty' : 'minut');
	        case 'h':
	            return withoutSuffix  ? 'godzina'  : 'godzinę';
	        case 'hh':
	            return result + (plural(number) ? 'godziny' : 'godzin');
	        case 'MM':
	            return result + (plural(number) ? 'miesiące' : 'miesięcy');
	        case 'yy':
	            return result + (plural(number) ? 'lata' : 'lat');
	    }
	}
	
	var pl = moment.defineLocale('pl', {
	    months : function (momentToFormat, format) {
	        if (format === '') {
	            // Hack: if format empty we know this is used to generate
	            // RegExp by moment. Give then back both valid forms of months
	            // in RegExp ready format.
	            return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	        } else if (/D MMMM/.test(format)) {
	            return monthsSubjective[momentToFormat.month()];
	        } else {
	            return monthsNominative[momentToFormat.month()];
	        }
	    },
	    monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	    weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	    weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	    weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Dziś o] LT',
	        nextDay: '[Jutro o] LT',
	        nextWeek: '[W] dddd [o] LT',
	        lastDay: '[Wczoraj o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[W zeszłą niedzielę o] LT';
	                case 3:
	                    return '[W zeszłą środę o] LT';
	                case 6:
	                    return '[W zeszłą sobotę o] LT';
	                default:
	                    return '[W zeszły] dddd [o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : '%s temu',
	        s : 'kilka sekund',
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : '1 dzień',
	        dd : '%d dni',
	        M : 'miesiąc',
	        MM : translate,
	        y : 'rok',
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pl;
	
	})));


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var pt = moment.defineLocale('pt', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : 'há %s',
	        s : 'segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    ordinalParse: /\d{1,2}º/,
	    ordinal : '%dº',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return pt;
	
	})));


/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var ptBr = moment.defineLocale('pt-br', {
	    months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	    weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D [de] MMMM [de] YYYY',
	        LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	        LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hoje às] LT',
	        nextDay: '[Amanhã às] LT',
	        nextWeek: 'dddd [às] LT',
	        lastDay: '[Ontem às] LT',
	        lastWeek: function () {
	            return (this.day() === 0 || this.day() === 6) ?
	                '[Último] dddd [às] LT' : // Saturday + Sunday
	                '[Última] dddd [às] LT'; // Monday - Friday
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'em %s',
	        past : '%s atrás',
	        s : 'poucos segundos',
	        m : 'um minuto',
	        mm : '%d minutos',
	        h : 'uma hora',
	        hh : '%d horas',
	        d : 'um dia',
	        dd : '%d dias',
	        M : 'um mês',
	        MM : '%d meses',
	        y : 'um ano',
	        yy : '%d anos'
	    },
	    ordinalParse: /\d{1,2}º/,
	    ordinal : '%dº'
	});
	
	return ptBr;
	
	})));


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	            'mm': 'minute',
	            'hh': 'ore',
	            'dd': 'zile',
	            'MM': 'luni',
	            'yy': 'ani'
	        },
	        separator = ' ';
	    if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	        separator = ' de ';
	    }
	    return number + separator + format[key];
	}
	
	var ro = moment.defineLocale('ro', {
	    months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	    monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	    weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	    weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY H:mm',
	        LLLL : 'dddd, D MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[azi la] LT',
	        nextDay: '[mâine la] LT',
	        nextWeek: 'dddd [la] LT',
	        lastDay: '[ieri la] LT',
	        lastWeek: '[fosta] dddd [la] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'peste %s',
	        past : '%s în urmă',
	        s : 'câteva secunde',
	        m : 'un minut',
	        mm : relativeTimeWithPlural,
	        h : 'o oră',
	        hh : relativeTimeWithPlural,
	        d : 'o zi',
	        dd : relativeTimeWithPlural,
	        M : 'o lună',
	        MM : relativeTimeWithPlural,
	        y : 'un an',
	        yy : relativeTimeWithPlural
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ro;
	
	})));


/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	        'hh': 'час_часа_часов',
	        'dd': 'день_дня_дней',
	        'MM': 'месяц_месяца_месяцев',
	        'yy': 'год_года_лет'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'минута' : 'минуту';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	// http://new.gramota.ru/spravka/rules/139-prop : § 103
	// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	var ru = moment.defineLocale('ru', {
	    months : {
	        format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	        standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	    },
	    monthsShort : {
	        // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	        format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	        standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	    },
	    weekdays : {
	        standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	        format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	        isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	    },
	    weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	    monthsParse : monthsParse,
	    longMonthsParse : monthsParse,
	    shortMonthsParse : monthsParse,
	
	    // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	    monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // копия предыдущего
	    monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	    // полные названия с падежами
	    monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	    // Выражение, которое соотвествует только сокращённым формам
	    monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY г.',
	        LLL : 'D MMMM YYYY г., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	    },
	    calendar : {
	        sameDay: '[Сегодня в] LT',
	        nextDay: '[Завтра в] LT',
	        lastDay: '[Вчера в] LT',
	        nextWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В следующее] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В следующий] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В следующую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        lastWeek: function (now) {
	            if (now.week() !== this.week()) {
	                switch (this.day()) {
	                    case 0:
	                        return '[В прошлое] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[В прошлый] dddd [в] LT';
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[В прошлую] dddd [в] LT';
	                }
	            } else {
	                if (this.day() === 2) {
	                    return '[Во] dddd [в] LT';
	                } else {
	                    return '[В] dddd [в] LT';
	                }
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'через %s',
	        past : '%s назад',
	        s : 'несколько секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'час',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'месяц',
	        MM : relativeTimeWithPlural,
	        y : 'год',
	        yy : relativeTimeWithPlural
	    },
	    meridiemParse: /ночи|утра|дня|вечера/i,
	    isPM : function (input) {
	        return /^(дня|вечера)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночи';
	        } else if (hour < 12) {
	            return 'утра';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечера';
	        }
	    },
	    ordinalParse: /\d{1,2}-(й|го|я)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            case 'w':
	            case 'W':
	                return number + '-я';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ru;
	
	})));


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var se = moment.defineLocale('se', {
	    months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	    monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	    weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	    weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	    weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'MMMM D. [b.] YYYY',
	        LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	        LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	    },
	    calendar : {
	        sameDay: '[otne ti] LT',
	        nextDay: '[ihttin ti] LT',
	        nextWeek: 'dddd [ti] LT',
	        lastDay: '[ikte ti] LT',
	        lastWeek: '[ovddit] dddd [ti] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s geažes',
	        past : 'maŋit %s',
	        s : 'moadde sekunddat',
	        m : 'okta minuhta',
	        mm : '%d minuhtat',
	        h : 'okta diimmu',
	        hh : '%d diimmut',
	        d : 'okta beaivi',
	        dd : '%d beaivvit',
	        M : 'okta mánnu',
	        MM : '%d mánut',
	        y : 'okta jahki',
	        yy : '%d jagit'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return se;
	
	})));


/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	/*jshint -W100*/
	var si = moment.defineLocale('si', {
	    months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	    monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	    weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	    weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	    weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'a h:mm',
	        LTS : 'a h:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'YYYY MMMM D',
	        LLL : 'YYYY MMMM D, a h:mm',
	        LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	    },
	    calendar : {
	        sameDay : '[අද] LT[ට]',
	        nextDay : '[හෙට] LT[ට]',
	        nextWeek : 'dddd LT[ට]',
	        lastDay : '[ඊයේ] LT[ට]',
	        lastWeek : '[පසුගිය] dddd LT[ට]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%sකින්',
	        past : '%sකට පෙර',
	        s : 'තත්පර කිහිපය',
	        m : 'මිනිත්තුව',
	        mm : 'මිනිත්තු %d',
	        h : 'පැය',
	        hh : 'පැය %d',
	        d : 'දිනය',
	        dd : 'දින %d',
	        M : 'මාසය',
	        MM : 'මාස %d',
	        y : 'වසර',
	        yy : 'වසර %d'
	    },
	    ordinalParse: /\d{1,2} වැනි/,
	    ordinal : function (number) {
	        return number + ' වැනි';
	    },
	    meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	    isPM : function (input) {
	        return input === 'ප.ව.' || input === 'පස් වරු';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'ප.ව.' : 'පස් වරු';
	        } else {
	            return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	        }
	    }
	});
	
	return si;
	
	})));


/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_');
	var monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	function plural(n) {
	    return (n > 1) && (n < 5);
	}
	function translate(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':  // a few seconds / in a few seconds / a few seconds ago
	            return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	        case 'm':  // a minute / in a minute / a minute ago
	            return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	        case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'minúty' : 'minút');
	            } else {
	                return result + 'minútami';
	            }
	            break;
	        case 'h':  // an hour / in an hour / an hour ago
	            return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	        case 'hh': // 9 hours / in 9 hours / 9 hours ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'hodiny' : 'hodín');
	            } else {
	                return result + 'hodinami';
	            }
	            break;
	        case 'd':  // a day / in a day / a day ago
	            return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	        case 'dd': // 9 days / in 9 days / 9 days ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'dni' : 'dní');
	            } else {
	                return result + 'dňami';
	            }
	            break;
	        case 'M':  // a month / in a month / a month ago
	            return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	        case 'MM': // 9 months / in 9 months / 9 months ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'mesiace' : 'mesiacov');
	            } else {
	                return result + 'mesiacmi';
	            }
	            break;
	        case 'y':  // a year / in a year / a year ago
	            return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	        case 'yy': // 9 years / in 9 years / 9 years ago
	            if (withoutSuffix || isFuture) {
	                return result + (plural(number) ? 'roky' : 'rokov');
	            } else {
	                return result + 'rokmi';
	            }
	            break;
	    }
	}
	
	var sk = moment.defineLocale('sk', {
	    months : months,
	    monthsShort : monthsShort,
	    weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	    weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	    weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	    longDateFormat : {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay: '[dnes o] LT',
	        nextDay: '[zajtra o] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[v] dddd [o] LT';
	                case 3:
	                    return '[v stredu o] LT';
	                case 4:
	                    return '[vo štvrtok o] LT';
	                case 5:
	                    return '[v piatok o] LT';
	                case 6:
	                    return '[v sobotu o] LT';
	            }
	        },
	        lastDay: '[včera o] LT',
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[minulú nedeľu o] LT';
	                case 1:
	                case 2:
	                    return '[minulý] dddd [o] LT';
	                case 3:
	                    return '[minulú stredu o] LT';
	                case 4:
	                case 5:
	                    return '[minulý] dddd [o] LT';
	                case 6:
	                    return '[minulú sobotu o] LT';
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past : 'pred %s',
	        s : translate,
	        m : translate,
	        mm : translate,
	        h : translate,
	        hh : translate,
	        d : translate,
	        dd : translate,
	        M : translate,
	        MM : translate,
	        y : translate,
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sk;
	
	})));


/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var result = number + ' ';
	    switch (key) {
	        case 's':
	            return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	        case 'm':
	            return withoutSuffix ? 'ena minuta' : 'eno minuto';
	        case 'mm':
	            if (number === 1) {
	                result += withoutSuffix ? 'minuta' : 'minuto';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	            } else {
	                result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	            }
	            return result;
	        case 'h':
	            return withoutSuffix ? 'ena ura' : 'eno uro';
	        case 'hh':
	            if (number === 1) {
	                result += withoutSuffix ? 'ura' : 'uro';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'uri' : 'urama';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'ure' : 'urami';
	            } else {
	                result += withoutSuffix || isFuture ? 'ur' : 'urami';
	            }
	            return result;
	        case 'd':
	            return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	        case 'dd':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	            } else {
	                result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	            }
	            return result;
	        case 'M':
	            return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	        case 'MM':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	            } else {
	                result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	            }
	            return result;
	        case 'y':
	            return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	        case 'yy':
	            if (number === 1) {
	                result += withoutSuffix || isFuture ? 'leto' : 'letom';
	            } else if (number === 2) {
	                result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	            } else if (number < 5) {
	                result += withoutSuffix || isFuture ? 'leta' : 'leti';
	            } else {
	                result += withoutSuffix || isFuture ? 'let' : 'leti';
	            }
	            return result;
	    }
	}
	
	var sl = moment.defineLocale('sl', {
	    months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	    weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	    weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM YYYY',
	        LLL : 'D. MMMM YYYY H:mm',
	        LLLL : 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar : {
	        sameDay  : '[danes ob] LT',
	        nextDay  : '[jutri ob] LT',
	
	        nextWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[v] [nedeljo] [ob] LT';
	                case 3:
	                    return '[v] [sredo] [ob] LT';
	                case 6:
	                    return '[v] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[v] dddd [ob] LT';
	            }
	        },
	        lastDay  : '[včeraj ob] LT',
	        lastWeek : function () {
	            switch (this.day()) {
	                case 0:
	                    return '[prejšnjo] [nedeljo] [ob] LT';
	                case 3:
	                    return '[prejšnjo] [sredo] [ob] LT';
	                case 6:
	                    return '[prejšnjo] [soboto] [ob] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[prejšnji] dddd [ob] LT';
	            }
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'čez %s',
	        past   : 'pred %s',
	        s      : processRelativeTime,
	        m      : processRelativeTime,
	        mm     : processRelativeTime,
	        h      : processRelativeTime,
	        hh     : processRelativeTime,
	        d      : processRelativeTime,
	        dd     : processRelativeTime,
	        M      : processRelativeTime,
	        MM     : processRelativeTime,
	        y      : processRelativeTime,
	        yy     : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sl;
	
	})));


/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sq = moment.defineLocale('sq', {
	    months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	    monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	    weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	    weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	    weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /PD|MD/,
	    isPM: function (input) {
	        return input.charAt(0) === 'M';
	    },
	    meridiem : function (hours, minutes, isLower) {
	        return hours < 12 ? 'PD' : 'MD';
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[Sot në] LT',
	        nextDay : '[Nesër në] LT',
	        nextWeek : 'dddd [në] LT',
	        lastDay : '[Dje në] LT',
	        lastWeek : 'dddd [e kaluar në] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'në %s',
	        past : '%s më parë',
	        s : 'disa sekonda',
	        m : 'një minutë',
	        mm : '%d minuta',
	        h : 'një orë',
	        hh : '%d orë',
	        d : 'një ditë',
	        dd : '%d ditë',
	        M : 'një muaj',
	        MM : '%d muaj',
	        y : 'një vit',
	        yy : '%d vite'
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sq;
	
	})));


/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['jedan minut', 'jedne minute'],
	        mm: ['minut', 'minute', 'minuta'],
	        h: ['jedan sat', 'jednog sata'],
	        hh: ['sat', 'sata', 'sati'],
	        dd: ['dan', 'dana', 'dana'],
	        MM: ['mesec', 'meseca', 'meseci'],
	        yy: ['godina', 'godine', 'godina']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var sr = moment.defineLocale('sr', {
	    months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	    monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	    weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	    weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[danas u] LT',
	        nextDay: '[sutra u] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[u] [nedelju] [u] LT';
	                case 3:
	                    return '[u] [sredu] [u] LT';
	                case 6:
	                    return '[u] [subotu] [u] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[u] dddd [u] LT';
	            }
	        },
	        lastDay  : '[juče u] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[prošle] [nedelje] [u] LT',
	                '[prošlog] [ponedeljka] [u] LT',
	                '[prošlog] [utorka] [u] LT',
	                '[prošle] [srede] [u] LT',
	                '[prošlog] [četvrtka] [u] LT',
	                '[prošlog] [petka] [u] LT',
	                '[prošle] [subote] [u] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'za %s',
	        past   : 'pre %s',
	        s      : 'nekoliko sekundi',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'dan',
	        dd     : translator.translate,
	        M      : 'mesec',
	        MM     : translator.translate,
	        y      : 'godinu',
	        yy     : translator.translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sr;
	
	})));


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var translator = {
	    words: { //Different grammatical cases
	        m: ['један минут', 'једне минуте'],
	        mm: ['минут', 'минуте', 'минута'],
	        h: ['један сат', 'једног сата'],
	        hh: ['сат', 'сата', 'сати'],
	        dd: ['дан', 'дана', 'дана'],
	        MM: ['месец', 'месеца', 'месеци'],
	        yy: ['година', 'године', 'година']
	    },
	    correctGrammaticalCase: function (number, wordKey) {
	        return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	    },
	    translate: function (number, withoutSuffix, key) {
	        var wordKey = translator.words[key];
	        if (key.length === 1) {
	            return withoutSuffix ? wordKey[0] : wordKey[1];
	        } else {
	            return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	        }
	    }
	};
	
	var srCyrl = moment.defineLocale('sr-cyrl', {
	    months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	    monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	    monthsParseExact: true,
	    weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	    weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	    weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat: {
	        LT: 'H:mm',
	        LTS : 'H:mm:ss',
	        L: 'DD.MM.YYYY',
	        LL: 'D. MMMM YYYY',
	        LLL: 'D. MMMM YYYY H:mm',
	        LLLL: 'dddd, D. MMMM YYYY H:mm'
	    },
	    calendar: {
	        sameDay: '[данас у] LT',
	        nextDay: '[сутра у] LT',
	        nextWeek: function () {
	            switch (this.day()) {
	                case 0:
	                    return '[у] [недељу] [у] LT';
	                case 3:
	                    return '[у] [среду] [у] LT';
	                case 6:
	                    return '[у] [суботу] [у] LT';
	                case 1:
	                case 2:
	                case 4:
	                case 5:
	                    return '[у] dddd [у] LT';
	            }
	        },
	        lastDay  : '[јуче у] LT',
	        lastWeek : function () {
	            var lastWeekDays = [
	                '[прошле] [недеље] [у] LT',
	                '[прошлог] [понедељка] [у] LT',
	                '[прошлог] [уторка] [у] LT',
	                '[прошле] [среде] [у] LT',
	                '[прошлог] [четвртка] [у] LT',
	                '[прошлог] [петка] [у] LT',
	                '[прошле] [суботе] [у] LT'
	            ];
	            return lastWeekDays[this.day()];
	        },
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past   : 'пре %s',
	        s      : 'неколико секунди',
	        m      : translator.translate,
	        mm     : translator.translate,
	        h      : translator.translate,
	        hh     : translator.translate,
	        d      : 'дан',
	        dd     : translator.translate,
	        M      : 'месец',
	        MM     : translator.translate,
	        y      : 'годину',
	        yy     : translator.translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return srCyrl;
	
	})));


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	
	var ss = moment.defineLocale('ss', {
	    months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	    monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	    weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	    weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	    weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Namuhla nga] LT',
	        nextDay : '[Kusasa nga] LT',
	        nextWeek : 'dddd [nga] LT',
	        lastDay : '[Itolo nga] LT',
	        lastWeek : 'dddd [leliphelile] [nga] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'nga %s',
	        past : 'wenteka nga %s',
	        s : 'emizuzwana lomcane',
	        m : 'umzuzu',
	        mm : '%d emizuzu',
	        h : 'lihora',
	        hh : '%d emahora',
	        d : 'lilanga',
	        dd : '%d emalanga',
	        M : 'inyanga',
	        MM : '%d tinyanga',
	        y : 'umnyaka',
	        yy : '%d iminyaka'
	    },
	    meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 11) {
	            return 'ekuseni';
	        } else if (hours < 15) {
	            return 'emini';
	        } else if (hours < 19) {
	            return 'entsambama';
	        } else {
	            return 'ebusuku';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'ekuseni') {
	            return hour;
	        } else if (meridiem === 'emini') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	            if (hour === 0) {
	                return 0;
	            }
	            return hour + 12;
	        }
	    },
	    ordinalParse: /\d{1,2}/,
	    ordinal : '%d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return ss;
	
	})));


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sv = moment.defineLocale('sv', {
	    months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	    monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	    weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	    weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	    weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'YYYY-MM-DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY [kl.] HH:mm',
	        LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Idag] LT',
	        nextDay: '[Imorgon] LT',
	        lastDay: '[Igår] LT',
	        nextWeek: '[På] dddd LT',
	        lastWeek: '[I] dddd[s] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'om %s',
	        past : 'för %s sedan',
	        s : 'några sekunder',
	        m : 'en minut',
	        mm : '%d minuter',
	        h : 'en timme',
	        hh : '%d timmar',
	        d : 'en dag',
	        dd : '%d dagar',
	        M : 'en månad',
	        MM : '%d månader',
	        y : 'ett år',
	        yy : '%d år'
	    },
	    ordinalParse: /\d{1,2}(e|a)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'e' :
	            (b === 1) ? 'a' :
	            (b === 2) ? 'a' :
	            (b === 3) ? 'e' : 'e';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return sv;
	
	})));


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var sw = moment.defineLocale('sw', {
	    months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	    monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	    weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	    weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	    weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[leo saa] LT',
	        nextDay : '[kesho saa] LT',
	        nextWeek : '[wiki ijayo] dddd [saat] LT',
	        lastDay : '[jana] LT',
	        lastWeek : '[wiki iliyopita] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s baadaye',
	        past : 'tokea %s',
	        s : 'hivi punde',
	        m : 'dakika moja',
	        mm : 'dakika %d',
	        h : 'saa limoja',
	        hh : 'masaa %d',
	        d : 'siku moja',
	        dd : 'masiku %d',
	        M : 'mwezi mmoja',
	        MM : 'miezi %d',
	        y : 'mwaka mmoja',
	        yy : 'miaka %d'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return sw;
	
	})));


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var symbolMap = {
	    '1': '௧',
	    '2': '௨',
	    '3': '௩',
	    '4': '௪',
	    '5': '௫',
	    '6': '௬',
	    '7': '௭',
	    '8': '௮',
	    '9': '௯',
	    '0': '௦'
	};
	var numberMap = {
	    '௧': '1',
	    '௨': '2',
	    '௩': '3',
	    '௪': '4',
	    '௫': '5',
	    '௬': '6',
	    '௭': '7',
	    '௮': '8',
	    '௯': '9',
	    '௦': '0'
	};
	
	var ta = moment.defineLocale('ta', {
	    months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	    weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	    weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	    weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, HH:mm',
	        LLLL : 'dddd, D MMMM YYYY, HH:mm'
	    },
	    calendar : {
	        sameDay : '[இன்று] LT',
	        nextDay : '[நாளை] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[நேற்று] LT',
	        lastWeek : '[கடந்த வாரம்] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s இல்',
	        past : '%s முன்',
	        s : 'ஒரு சில விநாடிகள்',
	        m : 'ஒரு நிமிடம்',
	        mm : '%d நிமிடங்கள்',
	        h : 'ஒரு மணி நேரம்',
	        hh : '%d மணி நேரம்',
	        d : 'ஒரு நாள்',
	        dd : '%d நாட்கள்',
	        M : 'ஒரு மாதம்',
	        MM : '%d மாதங்கள்',
	        y : 'ஒரு வருடம்',
	        yy : '%d ஆண்டுகள்'
	    },
	    ordinalParse: /\d{1,2}வது/,
	    ordinal : function (number) {
	        return number + 'வது';
	    },
	    preparse: function (string) {
	        return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	            return numberMap[match];
	        });
	    },
	    postformat: function (string) {
	        return string.replace(/\d/g, function (match) {
	            return symbolMap[match];
	        });
	    },
	    // refer http://ta.wikipedia.org/s/1er1
	    meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 2) {
	            return ' யாமம்';
	        } else if (hour < 6) {
	            return ' வைகறை';  // வைகறை
	        } else if (hour < 10) {
	            return ' காலை'; // காலை
	        } else if (hour < 14) {
	            return ' நண்பகல்'; // நண்பகல்
	        } else if (hour < 18) {
	            return ' எற்பாடு'; // எற்பாடு
	        } else if (hour < 22) {
	            return ' மாலை'; // மாலை
	        } else {
	            return ' யாமம்';
	        }
	    },
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'யாமம்') {
	            return hour < 2 ? hour : hour + 12;
	        } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	            return hour;
	        } else if (meridiem === 'நண்பகல்') {
	            return hour >= 10 ? hour : hour + 12;
	        } else {
	            return hour + 12;
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return ta;
	
	})));


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var te = moment.defineLocale('te', {
	    months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	    monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	    weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	    weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	    longDateFormat : {
	        LT : 'A h:mm',
	        LTS : 'A h:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY, A h:mm',
	        LLLL : 'dddd, D MMMM YYYY, A h:mm'
	    },
	    calendar : {
	        sameDay : '[నేడు] LT',
	        nextDay : '[రేపు] LT',
	        nextWeek : 'dddd, LT',
	        lastDay : '[నిన్న] LT',
	        lastWeek : '[గత] dddd, LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s లో',
	        past : '%s క్రితం',
	        s : 'కొన్ని క్షణాలు',
	        m : 'ఒక నిమిషం',
	        mm : '%d నిమిషాలు',
	        h : 'ఒక గంట',
	        hh : '%d గంటలు',
	        d : 'ఒక రోజు',
	        dd : '%d రోజులు',
	        M : 'ఒక నెల',
	        MM : '%d నెలలు',
	        y : 'ఒక సంవత్సరం',
	        yy : '%d సంవత్సరాలు'
	    },
	    ordinalParse : /\d{1,2}వ/,
	    ordinal : '%dవ',
	    meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === 'రాత్రి') {
	            return hour < 4 ? hour : hour + 12;
	        } else if (meridiem === 'ఉదయం') {
	            return hour;
	        } else if (meridiem === 'మధ్యాహ్నం') {
	            return hour >= 10 ? hour : hour + 12;
	        } else if (meridiem === 'సాయంత్రం') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'రాత్రి';
	        } else if (hour < 10) {
	            return 'ఉదయం';
	        } else if (hour < 17) {
	            return 'మధ్యాహ్నం';
	        } else if (hour < 20) {
	            return 'సాయంత్రం';
	        } else {
	            return 'రాత్రి';
	        }
	    },
	    week : {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return te;
	
	})));


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tet = moment.defineLocale('tet', {
	    months : 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juniu_Juliu_Augustu_Setembru_Outubru_Novembru_Dezembru'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Aug_Set_Out_Nov_Dez'.split('_'),
	    weekdays : 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sexta_Sabadu'.split('_'),
	    weekdaysShort : 'Dom_Seg_Ters_Kua_Kint_Sext_Sab'.split('_'),
	    weekdaysMin : 'Do_Seg_Te_Ku_Ki_Sex_Sa'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Ohin iha] LT',
	        nextDay: '[Aban iha] LT',
	        nextWeek: 'dddd [iha] LT',
	        lastDay: '[Horiseik iha] LT',
	        lastWeek: 'dddd [semana kotuk] [iha] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'iha %s',
	        past : '%s liuba',
	        s : 'minutu balun',
	        m : 'minutu ida',
	        mm : 'minutus %d',
	        h : 'horas ida',
	        hh : 'horas %d',
	        d : 'loron ida',
	        dd : 'loron %d',
	        M : 'fulan ida',
	        MM : 'fulan %d',
	        y : 'tinan ida',
	        yy : 'tinan %d'
	    },
	    ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tet;
	
	})));


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var th = moment.defineLocale('th', {
	    months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	    monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	    monthsParseExact: true,
	    weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	    weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	    weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'H:mm',
	        LTS : 'H:mm:ss',
	        L : 'YYYY/MM/DD',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY เวลา H:mm',
	        LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	    },
	    meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	    isPM: function (input) {
	        return input === 'หลังเที่ยง';
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 12) {
	            return 'ก่อนเที่ยง';
	        } else {
	            return 'หลังเที่ยง';
	        }
	    },
	    calendar : {
	        sameDay : '[วันนี้ เวลา] LT',
	        nextDay : '[พรุ่งนี้ เวลา] LT',
	        nextWeek : 'dddd[หน้า เวลา] LT',
	        lastDay : '[เมื่อวานนี้ เวลา] LT',
	        lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'อีก %s',
	        past : '%sที่แล้ว',
	        s : 'ไม่กี่วินาที',
	        m : '1 นาที',
	        mm : '%d นาที',
	        h : '1 ชั่วโมง',
	        hh : '%d ชั่วโมง',
	        d : '1 วัน',
	        dd : '%d วัน',
	        M : '1 เดือน',
	        MM : '%d เดือน',
	        y : '1 ปี',
	        yy : '%d ปี'
	    }
	});
	
	return th;
	
	})));


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tlPh = moment.defineLocale('tl-ph', {
	    months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	    monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	    weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	    weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	    weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'MM/D/YYYY',
	        LL : 'MMMM D, YYYY',
	        LLL : 'MMMM D, YYYY HH:mm',
	        LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: 'LT [ngayong araw]',
	        nextDay: '[Bukas ng] LT',
	        nextWeek: 'LT [sa susunod na] dddd',
	        lastDay: 'LT [kahapon]',
	        lastWeek: 'LT [noong nakaraang] dddd',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'sa loob ng %s',
	        past : '%s ang nakalipas',
	        s : 'ilang segundo',
	        m : 'isang minuto',
	        mm : '%d minuto',
	        h : 'isang oras',
	        hh : '%d oras',
	        d : 'isang araw',
	        dd : '%d araw',
	        M : 'isang buwan',
	        MM : '%d buwan',
	        y : 'isang taon',
	        yy : '%d taon'
	    },
	    ordinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlPh;
	
	})));


/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	function translateFuture(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'leS' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'waQ' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'nem' :
	    time + ' pIq';
	    return time;
	}
	
	function translatePast(output) {
	    var time = output;
	    time = (output.indexOf('jaj') !== -1) ?
	    time.slice(0, -3) + 'Hu’' :
	    (output.indexOf('jar') !== -1) ?
	    time.slice(0, -3) + 'wen' :
	    (output.indexOf('DIS') !== -1) ?
	    time.slice(0, -3) + 'ben' :
	    time + ' ret';
	    return time;
	}
	
	function translate(number, withoutSuffix, string, isFuture) {
	    var numberNoun = numberAsNoun(number);
	    switch (string) {
	        case 'mm':
	            return numberNoun + ' tup';
	        case 'hh':
	            return numberNoun + ' rep';
	        case 'dd':
	            return numberNoun + ' jaj';
	        case 'MM':
	            return numberNoun + ' jar';
	        case 'yy':
	            return numberNoun + ' DIS';
	    }
	}
	
	function numberAsNoun(number) {
	    var hundred = Math.floor((number % 1000) / 100),
	    ten = Math.floor((number % 100) / 10),
	    one = number % 10,
	    word = '';
	    if (hundred > 0) {
	        word += numbersNouns[hundred] + 'vatlh';
	    }
	    if (ten > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	    }
	    if (one > 0) {
	        word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	    }
	    return (word === '') ? 'pagh' : word;
	}
	
	var tlh = moment.defineLocale('tlh', {
	    months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	    monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[DaHjaj] LT',
	        nextDay: '[wa’leS] LT',
	        nextWeek: 'LLL',
	        lastDay: '[wa’Hu’] LT',
	        lastWeek: 'LLL',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : translateFuture,
	        past : translatePast,
	        s : 'puS lup',
	        m : 'wa’ tup',
	        mm : translate,
	        h : 'wa’ rep',
	        hh : translate,
	        d : 'wa’ jaj',
	        dd : translate,
	        M : 'wa’ jar',
	        MM : translate,
	        y : 'wa’ DIS',
	        yy : translate
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return tlh;
	
	})));


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var suffixes = {
	    1: '\'inci',
	    5: '\'inci',
	    8: '\'inci',
	    70: '\'inci',
	    80: '\'inci',
	    2: '\'nci',
	    7: '\'nci',
	    20: '\'nci',
	    50: '\'nci',
	    3: '\'üncü',
	    4: '\'üncü',
	    100: '\'üncü',
	    6: '\'ncı',
	    9: '\'uncu',
	    10: '\'uncu',
	    30: '\'uncu',
	    60: '\'ıncı',
	    90: '\'ıncı'
	};
	
	var tr = moment.defineLocale('tr', {
	    months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	    monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	    weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	    weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	    weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[bugün saat] LT',
	        nextDay : '[yarın saat] LT',
	        nextWeek : '[haftaya] dddd [saat] LT',
	        lastDay : '[dün] LT',
	        lastWeek : '[geçen hafta] dddd [saat] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : '%s sonra',
	        past : '%s önce',
	        s : 'birkaç saniye',
	        m : 'bir dakika',
	        mm : '%d dakika',
	        h : 'bir saat',
	        hh : '%d saat',
	        d : 'bir gün',
	        dd : '%d gün',
	        M : 'bir ay',
	        MM : '%d ay',
	        y : 'bir yıl',
	        yy : '%d yıl'
	    },
	    ordinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	    ordinal : function (number) {
	        if (number === 0) {  // special case for zero
	            return number + '\'ıncı';
	        }
	        var a = number % 10,
	            b = number % 100 - a,
	            c = number >= 100 ? 100 : null;
	        return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tr;
	
	})));


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	// After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	// This is currently too difficult (maybe even impossible) to add.
	var tzl = moment.defineLocale('tzl', {
	    months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	    monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	    weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	    weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	    weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	    longDateFormat : {
	        LT : 'HH.mm',
	        LTS : 'HH.mm.ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D. MMMM [dallas] YYYY',
	        LLL : 'D. MMMM [dallas] YYYY HH.mm',
	        LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	    },
	    meridiemParse: /d\'o|d\'a/i,
	    isPM : function (input) {
	        return 'd\'o' === input.toLowerCase();
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'd\'o' : 'D\'O';
	        } else {
	            return isLower ? 'd\'a' : 'D\'A';
	        }
	    },
	    calendar : {
	        sameDay : '[oxhi à] LT',
	        nextDay : '[demà à] LT',
	        nextWeek : 'dddd [à] LT',
	        lastDay : '[ieiri à] LT',
	        lastWeek : '[sür el] dddd [lasteu à] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'osprei %s',
	        past : 'ja%s',
	        s : processRelativeTime,
	        m : processRelativeTime,
	        mm : processRelativeTime,
	        h : processRelativeTime,
	        hh : processRelativeTime,
	        d : processRelativeTime,
	        dd : processRelativeTime,
	        M : processRelativeTime,
	        MM : processRelativeTime,
	        y : processRelativeTime,
	        yy : processRelativeTime
	    },
	    ordinalParse: /\d{1,2}\./,
	    ordinal : '%d.',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	function processRelativeTime(number, withoutSuffix, key, isFuture) {
	    var format = {
	        's': ['viensas secunds', '\'iensas secunds'],
	        'm': ['\'n míut', '\'iens míut'],
	        'mm': [number + ' míuts', '' + number + ' míuts'],
	        'h': ['\'n þora', '\'iensa þora'],
	        'hh': [number + ' þoras', '' + number + ' þoras'],
	        'd': ['\'n ziua', '\'iensa ziua'],
	        'dd': [number + ' ziuas', '' + number + ' ziuas'],
	        'M': ['\'n mes', '\'iens mes'],
	        'MM': [number + ' mesen', '' + number + ' mesen'],
	        'y': ['\'n ar', '\'iens ar'],
	        'yy': [number + ' ars', '' + number + ' ars']
	    };
	    return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	}
	
	return tzl;
	
	})));


/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzm = moment.defineLocale('tzm', {
	    months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	    weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS: 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	        nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	        nextWeek: 'dddd [ⴴ] LT',
	        lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	        lastWeek: 'dddd [ⴴ] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	        past : 'ⵢⴰⵏ %s',
	        s : 'ⵉⵎⵉⴽ',
	        m : 'ⵎⵉⵏⵓⴺ',
	        mm : '%d ⵎⵉⵏⵓⴺ',
	        h : 'ⵙⴰⵄⴰ',
	        hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	        d : 'ⴰⵙⵙ',
	        dd : '%d oⵙⵙⴰⵏ',
	        M : 'ⴰⵢoⵓⵔ',
	        MM : '%d ⵉⵢⵢⵉⵔⵏ',
	        y : 'ⴰⵙⴳⴰⵙ',
	        yy : '%d ⵉⵙⴳⴰⵙⵏ'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzm;
	
	})));


/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var tzmLatn = moment.defineLocale('tzm-latn', {
	    months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	    weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[asdkh g] LT',
	        nextDay: '[aska g] LT',
	        nextWeek: 'dddd [g] LT',
	        lastDay: '[assant g] LT',
	        lastWeek: 'dddd [g] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'dadkh s yan %s',
	        past : 'yan %s',
	        s : 'imik',
	        m : 'minuḍ',
	        mm : '%d minuḍ',
	        h : 'saɛa',
	        hh : '%d tassaɛin',
	        d : 'ass',
	        dd : '%d ossan',
	        M : 'ayowr',
	        MM : '%d iyyirn',
	        y : 'asgas',
	        yy : '%d isgasn'
	    },
	    week : {
	        dow : 6, // Saturday is the first day of the week.
	        doy : 12  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return tzmLatn;
	
	})));


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	function plural(word, num) {
	    var forms = word.split('_');
	    return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
	    var format = {
	        'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	        'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	        'dd': 'день_дні_днів',
	        'MM': 'місяць_місяці_місяців',
	        'yy': 'рік_роки_років'
	    };
	    if (key === 'm') {
	        return withoutSuffix ? 'хвилина' : 'хвилину';
	    }
	    else if (key === 'h') {
	        return withoutSuffix ? 'година' : 'годину';
	    }
	    else {
	        return number + ' ' + plural(format[key], +number);
	    }
	}
	function weekdaysCaseReplace(m, format) {
	    var weekdays = {
	        'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	        'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	        'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	    },
	    nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	        'accusative' :
	        ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	            'genitive' :
	            'nominative');
	    return weekdays[nounCase][m.day()];
	}
	function processHoursFunction(str) {
	    return function () {
	        return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	    };
	}
	
	var uk = moment.defineLocale('uk', {
	    months : {
	        'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	        'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	    },
	    monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	    weekdays : weekdaysCaseReplace,
	    weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD.MM.YYYY',
	        LL : 'D MMMM YYYY р.',
	        LLL : 'D MMMM YYYY р., HH:mm',
	        LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	    },
	    calendar : {
	        sameDay: processHoursFunction('[Сьогодні '),
	        nextDay: processHoursFunction('[Завтра '),
	        lastDay: processHoursFunction('[Вчора '),
	        nextWeek: processHoursFunction('[У] dddd ['),
	        lastWeek: function () {
	            switch (this.day()) {
	                case 0:
	                case 3:
	                case 5:
	                case 6:
	                    return processHoursFunction('[Минулої] dddd [').call(this);
	                case 1:
	                case 2:
	                case 4:
	                    return processHoursFunction('[Минулого] dddd [').call(this);
	            }
	        },
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : 'за %s',
	        past : '%s тому',
	        s : 'декілька секунд',
	        m : relativeTimeWithPlural,
	        mm : relativeTimeWithPlural,
	        h : 'годину',
	        hh : relativeTimeWithPlural,
	        d : 'день',
	        dd : relativeTimeWithPlural,
	        M : 'місяць',
	        MM : relativeTimeWithPlural,
	        y : 'рік',
	        yy : relativeTimeWithPlural
	    },
	    // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	    meridiemParse: /ночі|ранку|дня|вечора/,
	    isPM: function (input) {
	        return /^(дня|вечора)$/.test(input);
	    },
	    meridiem : function (hour, minute, isLower) {
	        if (hour < 4) {
	            return 'ночі';
	        } else if (hour < 12) {
	            return 'ранку';
	        } else if (hour < 17) {
	            return 'дня';
	        } else {
	            return 'вечора';
	        }
	    },
	    ordinalParse: /\d{1,2}-(й|го)/,
	    ordinal: function (number, period) {
	        switch (period) {
	            case 'M':
	            case 'd':
	            case 'DDD':
	            case 'w':
	            case 'W':
	                return number + '-й';
	            case 'D':
	                return number + '-го';
	            default:
	                return number;
	        }
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 1st is the first week of the year.
	    }
	});
	
	return uk;
	
	})));


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var uz = moment.defineLocale('uz', {
	    months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	    monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	    weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	    weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	    weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'D MMMM YYYY, dddd HH:mm'
	    },
	    calendar : {
	        sameDay : '[Бугун соат] LT [да]',
	        nextDay : '[Эртага] LT [да]',
	        nextWeek : 'dddd [куни соат] LT [да]',
	        lastDay : '[Кеча соат] LT [да]',
	        lastWeek : '[Утган] dddd [куни соат] LT [да]',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'Якин %s ичида',
	        past : 'Бир неча %s олдин',
	        s : 'фурсат',
	        m : 'бир дакика',
	        mm : '%d дакика',
	        h : 'бир соат',
	        hh : '%d соат',
	        d : 'бир кун',
	        dd : '%d кун',
	        M : 'бир ой',
	        MM : '%d ой',
	        y : 'бир йил',
	        yy : '%d йил'
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 7  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return uz;
	
	})));


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var vi = moment.defineLocale('vi', {
	    months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	    monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	    weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	    weekdaysParseExact : true,
	    meridiemParse: /sa|ch/i,
	    isPM : function (input) {
	        return /^ch$/i.test(input);
	    },
	    meridiem : function (hours, minutes, isLower) {
	        if (hours < 12) {
	            return isLower ? 'sa' : 'SA';
	        } else {
	            return isLower ? 'ch' : 'CH';
	        }
	    },
	    longDateFormat : {
	        LT : 'HH:mm',
	        LTS : 'HH:mm:ss',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM [năm] YYYY',
	        LLL : 'D MMMM [năm] YYYY HH:mm',
	        LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	        l : 'DD/M/YYYY',
	        ll : 'D MMM YYYY',
	        lll : 'D MMM YYYY HH:mm',
	        llll : 'ddd, D MMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay: '[Hôm nay lúc] LT',
	        nextDay: '[Ngày mai lúc] LT',
	        nextWeek: 'dddd [tuần tới lúc] LT',
	        lastDay: '[Hôm qua lúc] LT',
	        lastWeek: 'dddd [tuần rồi lúc] LT',
	        sameElse: 'L'
	    },
	    relativeTime : {
	        future : '%s tới',
	        past : '%s trước',
	        s : 'vài giây',
	        m : 'một phút',
	        mm : '%d phút',
	        h : 'một giờ',
	        hh : '%d giờ',
	        d : 'một ngày',
	        dd : '%d ngày',
	        M : 'một tháng',
	        MM : '%d tháng',
	        y : 'một năm',
	        yy : '%d năm'
	    },
	    ordinalParse: /\d{1,2}/,
	    ordinal : function (number) {
	        return number;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return vi;
	
	})));


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var xPseudo = moment.defineLocale('x-pseudo', {
	    months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	    monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	    monthsParseExact : true,
	    weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	    weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	    weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	    weekdaysParseExact : true,
	    longDateFormat : {
	        LT : 'HH:mm',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY HH:mm',
	        LLLL : 'dddd, D MMMM YYYY HH:mm'
	    },
	    calendar : {
	        sameDay : '[T~ódá~ý át] LT',
	        nextDay : '[T~ómó~rró~w át] LT',
	        nextWeek : 'dddd [át] LT',
	        lastDay : '[Ý~ést~érdá~ý át] LT',
	        lastWeek : '[L~ást] dddd [át] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'í~ñ %s',
	        past : '%s á~gó',
	        s : 'á ~féw ~sécó~ñds',
	        m : 'á ~míñ~úté',
	        mm : '%d m~íñú~tés',
	        h : 'á~ñ hó~úr',
	        hh : '%d h~óúrs',
	        d : 'á ~dáý',
	        dd : '%d d~áýs',
	        M : 'á ~móñ~th',
	        MM : '%d m~óñt~hs',
	        y : 'á ~ýéár',
	        yy : '%d ý~éárs'
	    },
	    ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	    ordinal : function (number) {
	        var b = number % 10,
	            output = (~~(number % 100 / 10) === 1) ? 'th' :
	            (b === 1) ? 'st' :
	            (b === 2) ? 'nd' :
	            (b === 3) ? 'rd' : 'th';
	        return number + output;
	    },
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return xPseudo;
	
	})));


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria (yo)
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var yo = moment.defineLocale('yo', {
	    months : 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split('_'),
	    monthsShort : 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	    weekdays : 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	    weekdaysShort : 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	    weekdaysMin : 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	    longDateFormat : {
	        LT : 'h:mm A',
	        LTS : 'h:mm:ss A',
	        L : 'DD/MM/YYYY',
	        LL : 'D MMMM YYYY',
	        LLL : 'D MMMM YYYY h:mm A',
	        LLLL : 'dddd, D MMMM YYYY h:mm A'
	    },
	    calendar : {
	        sameDay : '[Ònì ni] LT',
	        nextDay : '[Ọ̀la ni] LT',
	        nextWeek : 'dddd [Ọsẹ̀ tón\'bọ] [ni] LT',
	        lastDay : '[Àna ni] LT',
	        lastWeek : 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	        sameElse : 'L'
	    },
	    relativeTime : {
	        future : 'ní %s',
	        past : '%s kọjá',
	        s : 'ìsẹjú aayá die',
	        m : 'ìsẹjú kan',
	        mm : 'ìsẹjú %d',
	        h : 'wákati kan',
	        hh : 'wákati %d',
	        d : 'ọjọ́ kan',
	        dd : 'ọjọ́ %d',
	        M : 'osù kan',
	        MM : 'osù %d',
	        y : 'ọdún kan',
	        yy : 'ọdún %d'
	    },
	    ordinalParse : /ọjọ́\s\d{1,2}/,
	    ordinal : 'ọjọ́ %d',
	    week : {
	        dow : 1, // Monday is the first day of the week.
	        doy : 4 // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return yo;
	
	})));


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhCn = moment.defineLocale('zh-cn', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'Ah点mm分',
	        LTS : 'Ah点m分s秒',
	        L : 'YYYY-MM-DD',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah点mm分',
	        LLLL : 'YYYY年MMMD日ddddAh点mm分',
	        l : 'YYYY-MM-DD',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日Ah点mm分',
	        llll : 'YYYY年MMMD日ddddAh点mm分'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour: function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' ||
	                meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        } else {
	            // '中午'
	            return hour >= 11 ? hour : hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : function () {
	            return this.minutes() === 0 ? '[今天]Ah[点整]' : '[今天]LT';
	        },
	        nextDay : function () {
	            return this.minutes() === 0 ? '[明天]Ah[点整]' : '[明天]LT';
	        },
	        lastDay : function () {
	            return this.minutes() === 0 ? '[昨天]Ah[点整]' : '[昨天]LT';
	        },
	        nextWeek : function () {
	            var startOfWeek, prefix;
	            startOfWeek = moment().startOf('week');
	            prefix = this.diff(startOfWeek, 'days') >= 7 ? '[下]' : '[本]';
	            return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	        },
	        lastWeek : function () {
	            var startOfWeek, prefix;
	            startOfWeek = moment().startOf('week');
	            prefix = this.unix() < startOfWeek.unix()  ? '[上]' : '[本]';
	            return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	        },
	        sameElse : 'LL'
	    },
	    ordinalParse: /\d{1,2}(日|月|周)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd':
	            case 'D':
	            case 'DDD':
	                return number + '日';
	            case 'M':
	                return number + '月';
	            case 'w':
	            case 'W':
	                return number + '周';
	            default:
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s内',
	        past : '%s前',
	        s : '几秒',
	        m : '1 分钟',
	        mm : '%d 分钟',
	        h : '1 小时',
	        hh : '%d 小时',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 个月',
	        MM : '%d 个月',
	        y : '1 年',
	        yy : '%d 年'
	    },
	    week : {
	        // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	        dow : 1, // Monday is the first day of the week.
	        doy : 4  // The week that contains Jan 4th is the first week of the year.
	    }
	});
	
	return zhCn;
	
	})));


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhHk = moment.defineLocale('zh-hk', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'Ah點mm分',
	        LTS : 'Ah點m分s秒',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah點mm分',
	        LLLL : 'YYYY年MMMD日ddddAh點mm分',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日Ah點mm分',
	        llll : 'YYYY年MMMD日ddddAh點mm分'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    ordinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhHk;
	
	})));


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(84)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	
	var zhTw = moment.defineLocale('zh-tw', {
	    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	    longDateFormat : {
	        LT : 'Ah點mm分',
	        LTS : 'Ah點m分s秒',
	        L : 'YYYY年MMMD日',
	        LL : 'YYYY年MMMD日',
	        LLL : 'YYYY年MMMD日Ah點mm分',
	        LLLL : 'YYYY年MMMD日ddddAh點mm分',
	        l : 'YYYY年MMMD日',
	        ll : 'YYYY年MMMD日',
	        lll : 'YYYY年MMMD日Ah點mm分',
	        llll : 'YYYY年MMMD日ddddAh點mm分'
	    },
	    meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	    meridiemHour : function (hour, meridiem) {
	        if (hour === 12) {
	            hour = 0;
	        }
	        if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	            return hour;
	        } else if (meridiem === '中午') {
	            return hour >= 11 ? hour : hour + 12;
	        } else if (meridiem === '下午' || meridiem === '晚上') {
	            return hour + 12;
	        }
	    },
	    meridiem : function (hour, minute, isLower) {
	        var hm = hour * 100 + minute;
	        if (hm < 600) {
	            return '凌晨';
	        } else if (hm < 900) {
	            return '早上';
	        } else if (hm < 1130) {
	            return '上午';
	        } else if (hm < 1230) {
	            return '中午';
	        } else if (hm < 1800) {
	            return '下午';
	        } else {
	            return '晚上';
	        }
	    },
	    calendar : {
	        sameDay : '[今天]LT',
	        nextDay : '[明天]LT',
	        nextWeek : '[下]ddddLT',
	        lastDay : '[昨天]LT',
	        lastWeek : '[上]ddddLT',
	        sameElse : 'L'
	    },
	    ordinalParse: /\d{1,2}(日|月|週)/,
	    ordinal : function (number, period) {
	        switch (period) {
	            case 'd' :
	            case 'D' :
	            case 'DDD' :
	                return number + '日';
	            case 'M' :
	                return number + '月';
	            case 'w' :
	            case 'W' :
	                return number + '週';
	            default :
	                return number;
	        }
	    },
	    relativeTime : {
	        future : '%s內',
	        past : '%s前',
	        s : '幾秒',
	        m : '1 分鐘',
	        mm : '%d 分鐘',
	        h : '1 小時',
	        hh : '%d 小時',
	        d : '1 天',
	        dd : '%d 天',
	        M : '1 個月',
	        MM : '%d 個月',
	        y : '1 年',
	        yy : '%d 年'
	    }
	});
	
	return zhTw;
	
	})));


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*! flatpickr v2.2.3, @license MIT */
	function Flatpickr(element, config) {
		var self = this;
	
		function init() {
			if (element._flatpickr) destroy(element._flatpickr);
	
			element._flatpickr = self;
	
			self.element = element;
			self.instanceConfig = config || {};
	
			setupFormats();
	
			parseConfig();
			setupLocale();
			setupInputs();
			setupDates();
	
			setupHelperFunctions();
	
			self.isOpen = self.config.inline;
			self.changeMonth = changeMonth;
			self.clear = clear;
			self.close = close;
			self.destroy = destroy;
			self.formatDate = formatDate;
			self.jumpToDate = jumpToDate;
			self.open = open;
			self.parseDate = parseDate;
			self.redraw = redraw;
			self.set = set;
			self.setDate = setDate;
			self.toggle = toggle;
	
			self.isMobile = !self.config.disableMobile && !self.config.inline && self.config.mode === "single" && !self.config.disable.length && !self.config.enable.length && /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	
			if (!self.isMobile) build();
	
			bind();
	
			self.minDateHasTime = self.config.minDate && (self.config.minDate.getHours() || self.config.minDate.getMinutes() || self.config.minDate.getSeconds());
	
			self.maxDateHasTime = self.config.maxDate && (self.config.maxDate.getHours() || self.config.maxDate.getMinutes() || self.config.maxDate.getSeconds());
	
			if (!self.isMobile) {
				Object.defineProperty(self, "dateIsPicked", {
					set: function set(bool) {
						if (bool) return self.calendarContainer.classList.add("dateIsPicked");
						self.calendarContainer.classList.remove("dateIsPicked");
					}
				});
			}
	
			self.dateIsPicked = self.selectedDates.length > 0 || self.config.noCalendar;
	
			if (self.selectedDates.length) {
				if (self.config.enableTime) setHoursFromDate();
				updateValue();
			}
	
			if (self.config.weekNumbers) self.calendarContainer.style.width = self.days.offsetWidth + self.weekWrapper.offsetWidth + 2 + "px";
	
			triggerEvent("Ready");
		}
	
		function updateTime(e) {
			if (self.config.noCalendar && !self.selectedDates.length)
				// picking time only
				self.selectedDates = [self.now];
	
			timeWrapper(e);
	
			if (!self.selectedDates.length) return;
	
			setHoursFromInputs();
			updateValue();
		}
	
		function setHoursFromInputs() {
			if (!self.config.enableTime) return;
	
			var hours = parseInt(self.hourElement.value, 10) || 0,
			    minutes = parseInt(self.minuteElement.value, 10) || 0,
			    seconds = self.config.enableSeconds ? parseInt(self.secondElement.value, 10) || 0 : 0;
	
			if (self.amPM) hours = hours % 12 + 12 * (self.amPM.innerHTML === "PM");
	
			if (self.minDateHasTime && compareDates(latestSelectedDateObj(), self.config.minDate) === 0) {
				hours = Math.max(hours, self.config.minDate.getHours());
				if (hours === self.config.minDate.getHours()) minutes = Math.max(minutes, self.config.minDate.getMinutes());
			} else if (self.maxDateHasTime && compareDates(latestSelectedDateObj(), self.config.maxDate) === 0) {
				hours = Math.min(hours, self.config.maxDate.getHours());
				if (hours === self.config.maxDate.getHours()) minutes = Math.min(minutes, self.config.maxDate.getMinutes());
			}
	
			setHours(hours, minutes, seconds);
		}
	
		function setHoursFromDate(dateObj) {
			var date = dateObj || latestSelectedDateObj();
	
			if (date) setHours(date.getHours(), date.getMinutes(), date.getSeconds());
		}
	
		function setHours(hours, minutes, seconds) {
			if (self.selectedDates.length) {
				self.selectedDates[self.selectedDates.length - 1].setHours(hours % 24, minutes, seconds || 0, 0);
			}
	
			if (!self.config.enableTime || self.isMobile) return;
	
			self.hourElement.value = self.pad(!self.config.time_24hr ? (12 + hours) % 12 + 12 * (hours % 12 === 0) : hours);
	
			self.minuteElement.value = self.pad(minutes);
	
			if (!self.config.time_24hr && self.selectedDates.length) self.amPM.textContent = latestSelectedDateObj().getHours() >= 12 ? "PM" : "AM";
	
			if (self.config.enableSeconds) self.secondElement.value = self.pad(seconds);
		}
	
		function bind() {
			if (self.config.wrap) {
				["open", "close", "toggle", "clear"].forEach(function (el) {
					try {
						self.element.querySelector("[data-" + el + "]").addEventListener("click", self[el]);
					} catch (e) {
						//
					}
				});
			}
	
			if ("createEvent" in document) {
				self.changeEvent = document.createEvent("HTMLEvents");
				self.changeEvent.initEvent("change", false, true);
			}
	
			if (self.isMobile) return setupMobile();
	
			self.debouncedResize = debounce(onResize, 50);
			self.triggerChange = function () {
				return triggerEvent("Change");
			};
			self.debouncedChange = debounce(self.triggerChange, 1000);
	
			if (self.config.mode === "range") self.days.addEventListener("mouseover", onMouseOver);
	
			document.addEventListener("keydown", onKeyDown);
			window.addEventListener("resize", self.debouncedResize);
	
			var clickEvent = typeof window.ontouchstart !== "undefined" ? "touchstart" : "click";
	
			document.addEventListener(clickEvent, documentClick);
			document.addEventListener("blur", documentClick);
	
			if (self.config.clickOpens) (self.altInput || self.input).addEventListener("focus", open);
	
			if (!self.config.noCalendar) {
				self.prevMonthNav.addEventListener("click", function () {
					return changeMonth(-1);
				});
				self.nextMonthNav.addEventListener("click", function () {
					return changeMonth(1);
				});
	
				self.currentYearElement.addEventListener("wheel", function (e) {
					return debounce(yearScroll(e), 50);
				});
				self.currentYearElement.addEventListener("focus", function () {
					self.currentYearElement.select();
				});
	
				self.currentYearElement.addEventListener("input", function (event) {
					if (event.target.value.length === 4) {
						self.currentYearElement.blur();
						handleYearChange(event.target.value);
						event.target.value = self.currentYear;
					}
				});
	
				self.days.addEventListener("click", selectDate);
			}
	
			if (self.config.enableTime) {
				self.timeContainer.addEventListener("wheel", function (e) {
					return debounce(updateTime(e), 5);
				});
				self.timeContainer.addEventListener("input", updateTime);
	
				self.timeContainer.addEventListener("wheel", self.debouncedChange);
				self.timeContainer.addEventListener("input", self.triggerChange);
	
				self.hourElement.addEventListener("focus", function () {
					self.hourElement.select();
				});
				self.minuteElement.addEventListener("focus", function () {
					self.minuteElement.select();
				});
	
				if (self.secondElement) {
					self.secondElement.addEventListener("focus", function () {
						self.secondElement.select();
					});
				}
	
				if (self.amPM) {
					self.amPM.addEventListener("click", function (e) {
						updateTime(e);
						self.triggerChange(e);
					});
				}
			}
		}
	
		function jumpToDate(jumpDate) {
			jumpDate = jumpDate ? parseDate(jumpDate) : latestSelectedDateObj() || (self.config.minDate > self.now ? self.config.minDate : self.now);
	
			try {
				self.currentYear = jumpDate.getFullYear();
				self.currentMonth = jumpDate.getMonth();
			} catch (e) {
				console.error(e.stack);
				console.warn("Invalid date supplied: " + jumpDate);
			}
	
			self.redraw();
		}
	
		function incrementNumInput(e, delta) {
			var input = e.target.parentNode.childNodes[0];
			input.value = parseInt(input.value, 10) + delta * (input.step || 1);
	
			try {
				input.dispatchEvent(new Event("input", { "bubbles": true }));
			} catch (e) {
				var ev = document.createEvent("CustomEvent");
				ev.initCustomEvent("input", true, true, {});
				input.dispatchEvent(ev);
			}
		}
	
		function createNumberInput(inputClassName) {
			var wrapper = createElement("div", "numInputWrapper"),
			    numInput = createElement("input", "numInput " + inputClassName),
			    arrowUp = createElement("span", "arrowUp"),
			    arrowDown = createElement("span", "arrowDown");
	
			numInput.type = "text";
			wrapper.appendChild(numInput);
			wrapper.appendChild(arrowUp);
			wrapper.appendChild(arrowDown);
	
			arrowUp.addEventListener("click", function (e) {
				return incrementNumInput(e, 1);
			});
			arrowDown.addEventListener("click", function (e) {
				return incrementNumInput(e, -1);
			});
			return wrapper;
		}
	
		function build() {
			var fragment = document.createDocumentFragment();
			self.calendarContainer = createElement("div", "flatpickr-calendar");
			self.numInputType = navigator.userAgent.indexOf("MSIE 9.0") > 0 ? "text" : "number";
	
			if (!self.config.noCalendar) {
				fragment.appendChild(buildMonthNav());
				self.innerContainer = createElement("div", "flatpickr-innerContainer");
	
				if (self.config.weekNumbers) self.innerContainer.appendChild(buildWeeks());
	
				self.rContainer = createElement("div", "flatpickr-rContainer");
				self.rContainer.appendChild(buildWeekdays());
				self.rContainer.appendChild(buildDays());
				self.innerContainer.appendChild(self.rContainer);
				fragment.appendChild(self.innerContainer);
			}
	
			if (self.config.enableTime) fragment.appendChild(buildTime());
	
			self.calendarContainer.appendChild(fragment);
	
			if (self.config.inline || self.config.static) {
				self.calendarContainer.classList.add(self.config.inline ? "inline" : "static");
				positionCalendar();
	
				if (self.config.appendTo && self.config.appendTo.nodeType) self.config.appendTo.appendChild(self.calendarContainer);else {
					self.element.parentNode.insertBefore(self.calendarContainer, (self.altInput || self.input).nextSibling);
				}
			} else document.body.appendChild(self.calendarContainer);
		}
	
		function createDay(className, date, dayNumber) {
			var dateIsEnabled = isEnabled(date),
			    dayElement = createElement("span", "flatpickr-day " + className, date.getDate());
	
			dayElement.dateObj = date;
	
			if (compareDates(date, self.now) === 0) dayElement.classList.add("today");
	
			if (dateIsEnabled) {
				dayElement.tabIndex = 0;
	
				if (isDateSelected(date)) {
					dayElement.classList.add("selected");
	
					if (self.config.mode === "range") {
						dayElement.classList.add(compareDates(date, self.selectedDates[0]) === 0 ? "startRange" : "endRange");
					} else self.selectedDateElem = dayElement;
				}
			} else {
				dayElement.classList.add("disabled");
				if (self.selectedDates[0] && date > self.minRangeDate && date < self.selectedDates[0]) self.minRangeDate = date;else if (self.selectedDates[0] && date < self.maxRangeDate && date > self.selectedDates[0]) self.maxRangeDate = date;
			}
	
			if (self.config.mode === "range") {
				if (isDateInRange(date) && !isDateSelected(date)) dayElement.classList.add("inRange");
	
				if (self.selectedDates.length === 1 && (date < self.minRangeDate || date > self.maxRangeDate)) dayElement.classList.add("notAllowed");
			}
	
			if (self.config.weekNumbers && className !== "prevMonthDay" && dayNumber % 7 === 1) {
				self.weekNumbers.insertAdjacentHTML("beforeend", "<span class='disabled flatpickr-day'>" + self.config.getWeek(date) + "</span>");
			}
	
			triggerEvent("DayCreate", dayElement);
	
			return dayElement;
		}
	
		function buildDays() {
			if (!self.days) {
				self.days = createElement("div", "flatpickr-days");
				self.days.tabIndex = -1;
			}
	
			self.firstOfMonth = (new Date(self.currentYear, self.currentMonth, 1).getDay() - self.l10n.firstDayOfWeek + 7) % 7;
	
			self.prevMonthDays = self.utils.getDaysinMonth((self.currentMonth - 1 + 12) % 12);
	
			var daysInMonth = self.utils.getDaysinMonth(),
			    days = document.createDocumentFragment();
	
			var dayNumber = self.prevMonthDays + 1 - self.firstOfMonth;
	
			if (self.config.weekNumbers) self.weekNumbers.innerHTML = "";
	
			if (self.config.mode === "range") {
				// const dateLimits = self.config.enable.length || self.config.disable.length || self.config.mixDate || self.config.maxDate;
				self.minRangeDate = new Date(self.currentYear, self.currentMonth - 1, dayNumber);
				self.maxRangeDate = new Date(self.currentYear, self.currentMonth + 1, (42 - self.firstOfMonth) % daysInMonth);
			}
	
			self.days.innerHTML = "";
	
			// prepend days from the ending of previous month
			for (var i = 0; dayNumber <= self.prevMonthDays; i++, dayNumber++) {
				days.appendChild(createDay("prevMonthDay", new Date(self.currentYear, self.currentMonth - 1, dayNumber), dayNumber));
			}
	
			// Start at 1 since there is no 0th day
			for (dayNumber = 1; dayNumber <= daysInMonth; dayNumber++) {
				days.appendChild(createDay("", new Date(self.currentYear, self.currentMonth, dayNumber), dayNumber));
			}
	
			// append days from the next month
			for (var dayNum = daysInMonth + 1; dayNum <= 42 - self.firstOfMonth; dayNum++) {
				days.appendChild(createDay("nextMonthDay", new Date(self.currentYear, self.currentMonth + 1, dayNum % daysInMonth), dayNum));
			}
	
			self.days.appendChild(days);
			return self.days;
		}
	
		function buildMonthNav() {
			var monthNavFragment = document.createDocumentFragment();
			self.monthNav = createElement("div", "flatpickr-month");
	
			self.prevMonthNav = createElement("span", "flatpickr-prev-month");
			self.prevMonthNav.innerHTML = self.config.prevArrow;
	
			self.currentMonthElement = createElement("span", "cur-month");
	
			var yearInput = createNumberInput("cur-year");
			self.currentYearElement = yearInput.childNodes[0];
			self.currentYearElement.title = self.l10n.scrollTitle;
	
			if (self.config.minDate) self.currentYearElement.min = self.config.minDate.getFullYear();
	
			if (self.config.maxDate) {
				self.currentYearElement.max = self.config.maxDate.getFullYear();
	
				self.currentYearElement.disabled = self.config.minDate && self.config.minDate.getFullYear() === self.config.maxDate.getFullYear();
			}
	
			self.nextMonthNav = createElement("span", "flatpickr-next-month");
			self.nextMonthNav.innerHTML = self.config.nextArrow;
	
			self.navigationCurrentMonth = createElement("span", "flatpickr-current-month");
			self.navigationCurrentMonth.appendChild(self.currentMonthElement);
			self.navigationCurrentMonth.appendChild(yearInput);
	
			monthNavFragment.appendChild(self.prevMonthNav);
			monthNavFragment.appendChild(self.navigationCurrentMonth);
			monthNavFragment.appendChild(self.nextMonthNav);
			self.monthNav.appendChild(monthNavFragment);
	
			updateNavigationCurrentMonth();
	
			return self.monthNav;
		}
	
		function buildTime() {
			self.calendarContainer.classList.add("hasTime");
			self.timeContainer = createElement("div", "flatpickr-time");
			self.timeContainer.tabIndex = -1;
			var separator = createElement("span", "flatpickr-time-separator", ":");
	
			var hourInput = createNumberInput("flatpickr-hour");
			self.hourElement = hourInput.childNodes[0];
	
			var minuteInput = createNumberInput("flatpickr-minute");
			self.minuteElement = minuteInput.childNodes[0];
	
			self.hourElement.tabIndex = self.minuteElement.tabIndex = 0;
			self.hourElement.pattern = self.minuteElement.pattern = "\d*";
	
			self.hourElement.value = self.pad(latestSelectedDateObj() ? latestSelectedDateObj().getHours() : self.config.defaultHour);
	
			self.minuteElement.value = self.pad(latestSelectedDateObj() ? latestSelectedDateObj().getMinutes() : self.config.defaultMinute);
	
			self.hourElement.step = self.config.hourIncrement;
			self.minuteElement.step = self.config.minuteIncrement;
	
			self.hourElement.min = self.config.time_24hr ? 0 : 1;
			self.hourElement.max = self.config.time_24hr ? 23 : 12;
	
			self.minuteElement.min = 0;
			self.minuteElement.max = 59;
	
			self.hourElement.title = self.minuteElement.title = self.l10n.scrollTitle;
	
			self.timeContainer.appendChild(hourInput);
			self.timeContainer.appendChild(separator);
			self.timeContainer.appendChild(minuteInput);
	
			if (self.config.time_24hr) self.timeContainer.classList.add("time24hr");
	
			if (self.config.enableSeconds) {
				self.timeContainer.classList.add("hasSeconds");
	
				var secondInput = createNumberInput("flatpickr-second");
				self.secondElement = secondInput.childNodes[0];
	
				self.secondElement.pattern = self.hourElement.pattern;
				self.secondElement.value = latestSelectedDateObj() ? self.pad(latestSelectedDateObj().getSeconds()) : "00";
	
				self.secondElement.step = self.minuteElement.step;
				self.secondElement.min = self.minuteElement.min;
				self.secondElement.max = self.minuteElement.max;
	
				self.timeContainer.appendChild(createElement("span", "flatpickr-time-separator", ":"));
				self.timeContainer.appendChild(secondInput);
			}
	
			if (!self.config.time_24hr) {
				// add self.amPM if appropriate
				self.amPM = createElement("span", "flatpickr-am-pm", ["AM", "PM"][self.hourElement.value > 11 | 0]);
				self.amPM.title = self.l10n.toggleTitle;
				self.amPM.tabIndex = 0;
				self.timeContainer.appendChild(self.amPM);
			}
	
			return self.timeContainer;
		}
	
		function buildWeekdays() {
			if (!self.weekdayContainer) self.weekdayContainer = createElement("div", "flatpickr-weekdays");
	
			var firstDayOfWeek = self.l10n.firstDayOfWeek;
			var weekdays = self.l10n.weekdays.shorthand.slice();
	
			if (firstDayOfWeek > 0 && firstDayOfWeek < weekdays.length) {
				weekdays = [].concat(weekdays.splice(firstDayOfWeek, weekdays.length), weekdays.splice(0, firstDayOfWeek));
			}
	
			self.weekdayContainer.innerHTML = "\n\t\t<span class=flatpickr-weekday>\n\t\t\t" + weekdays.join("</span><span class=flatpickr-weekday>") + "\n\t\t</span>\n\t\t";
	
			return self.weekdayContainer;
		}
	
		function buildWeeks() {
			self.calendarContainer.classList.add("hasWeeks");
			self.weekWrapper = createElement("div", "flatpickr-weekwrapper");
			self.weekWrapper.appendChild(createElement("span", "flatpickr-weekday", self.l10n.weekAbbreviation));
			self.weekNumbers = createElement("div", "flatpickr-weeks");
			self.weekWrapper.appendChild(self.weekNumbers);
	
			return self.weekWrapper;
		}
	
		function changeMonth(value, is_offset) {
			self.currentMonth = typeof is_offset === "undefined" || is_offset ? self.currentMonth + value : value;
	
			handleYearChange();
			updateNavigationCurrentMonth();
			buildDays();
	
			if (!self.config.noCalendar) self.days.focus();
	
			triggerEvent("MonthChange");
		}
	
		function clear() {
			var triggerChangeEvent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	
			self.input.value = "";
	
			if (self.altInput) self.altInput.value = "";
	
			if (self.mobileInput) self.mobileInput.value = "";
	
			self.selectedDates = [];
			self.dateIsPicked = false;
	
			self.redraw();
	
			if (triggerChangeEvent !== false)
				// triggerChangeEvent is true (default) or an Event
				triggerEvent("Change");
		}
	
		function close() {
			self.isOpen = false;
	
			if (!self.isMobile) {
				self.calendarContainer.classList.remove("open");
				(self.altInput || self.input).classList.remove("active");
			}
	
			triggerEvent("Close");
		}
	
		function destroy(instance) {
			instance = instance || self;
			instance.clear(false);
	
			document.removeEventListener("keydown", onKeyDown);
			window.removeEventListener("resize", instance.debouncedResize);
	
			document.removeEventListener("click", documentClick);
			document.removeEventListener("blur", documentClick);
	
			if (instance.isMobile && instance.mobileInput && instance.mobileInput.parentNode) instance.mobileInput.parentNode.removeChild(instance.mobileInput);else if (instance.calendarContainer && instance.calendarContainer.parentNode) instance.calendarContainer.parentNode.removeChild(instance.calendarContainer);
	
			if (instance.altInput) {
				instance.input.type = "text";
				if (instance.altInput.parentNode) instance.altInput.parentNode.removeChild(instance.altInput);
			}
	
			instance.input.classList.remove("flatpickr-input");
			instance.input.removeEventListener("focus", open);
			instance.input.removeAttribute("readonly");
		}
	
		function isCalendarElem(elem) {
			var e = elem;
			while (e) {
				if (/flatpickr-day|flatpickr-calendar/.test(e.className)) return true;
				e = e.parentNode;
			}
	
			return false;
		}
	
		function documentClick(e) {
			var isInput = self.element.contains(e.target) || e.target === self.input || e.target === self.altInput;
	
			if (self.isOpen && !isCalendarElem(e.target) && !isInput) {
				self.close();
	
				if (self.config.mode === "range" && self.selectedDates.length === 1) {
					self.clear();
					self.redraw();
				}
			}
		}
	
		function formatDate(frmt, dateObj) {
			if (self.config.formatDate) return self.config.formatDate(frmt, dateObj);
	
			var chars = frmt.split("");
			return chars.map(function (c, i) {
				return self.formats[c] && chars[i - 1] !== "\\" ? self.formats[c](dateObj) : c !== "\\" ? c : "";
			}).join("");
		}
	
		function handleYearChange(newYear) {
			if (self.currentMonth < 0 || self.currentMonth > 11) {
				self.currentYear += self.currentMonth % 11;
				self.currentMonth = (self.currentMonth + 12) % 12;
				triggerEvent("YearChange");
			} else if (newYear && (!self.currentYearElement.min || newYear >= self.currentYearElement.min) && (!self.currentYearElement.max || newYear <= self.currentYearElement.max)) {
				self.currentYear = parseInt(newYear, 10) || self.currentYear;
	
				if (self.config.maxDate && self.currentYear === self.config.maxDate.getFullYear()) {
					self.currentMonth = Math.min(self.config.maxDate.getMonth(), self.currentMonth);
				} else if (self.config.minDate && self.currentYear === self.config.minDate.getFullYear()) {
					self.currentMonth = Math.max(self.config.minDate.getMonth(), self.currentMonth);
				}
	
				self.redraw();
				triggerEvent("YearChange");
			}
		}
	
		function isEnabled(dateToCheck) {
			if (self.config.minDate && compareDates(dateToCheck, self.config.minDate) < 0 || self.config.maxDate && compareDates(dateToCheck, self.config.maxDate) > 0) return false;
	
			if (!self.config.enable.length && !self.config.disable.length) return true;
	
			dateToCheck = parseDate(dateToCheck, true); // timeless
	
			var bool = self.config.enable.length > 0,
			    array = bool ? self.config.enable : self.config.disable;
	
			for (var i = 0, d; i < array.length; i++) {
				d = array[i];
	
				if (d instanceof Function && d(dateToCheck)) // disabled by function
					return bool;else if ((d instanceof Date || typeof d === "string") && parseDate(d, true).getTime() === dateToCheck.getTime())
					// disabled by date string
					return bool;else if ( // disabled by range
				(typeof d === "undefined" ? "undefined" : _typeof(d)) === "object" && d.from && d.to && dateToCheck >= parseDate(d.from) && dateToCheck <= parseDate(d.to)) return bool;
			}
	
			return !bool;
		}
	
		function onKeyDown(e) {
			if (self.isOpen) {
				switch (e.which) {
					case 13:
						if (self.timeContainer && self.timeContainer.contains(e.target)) updateValue();else selectDate(e);
	
						break;
	
					case 27:
						// escape
						self.clear();
						self.redraw();
						self.close();
						break;
	
					case 37:
						if (e.target !== self.input & e.target !== self.altInput) changeMonth(-1);
						break;
	
					case 38:
						e.preventDefault();
	
						if (self.timeContainer && self.timeContainer.contains(e.target)) updateTime(e);else {
							self.currentYear++;
							self.redraw();
						}
	
						break;
	
					case 39:
						if (e.target !== self.input & e.target !== self.altInput) changeMonth(1);
						break;
	
					case 40:
						e.preventDefault();
						if (self.timeContainer && self.timeContainer.contains(e.target)) updateTime(e);else {
							self.currentYear--;
							self.redraw();
						}
	
						break;
	
					default:
						break;
				}
			}
		}
	
		function onMouseOver(e) {
			if (self.selectedDates.length !== 1 || !e.target.classList.contains("flatpickr-day")) return;
	
			var hoverDate = e.target.dateObj,
			    initialDate = parseDate(self.selectedDates[0], true),
			    rangeStartDate = Math.min(hoverDate.getTime(), self.selectedDates[0].getTime()),
			    rangeEndDate = Math.max(hoverDate.getTime(), self.selectedDates[0].getTime()),
			    containsDisabled = false;
	
			for (var t = rangeStartDate; t < rangeEndDate; t += self.utils.duration.DAY) {
				if (!isEnabled(new Date(t))) {
					containsDisabled = true;
					break;
				}
			}
	
			for (var timestamp = self.days.childNodes[0].dateObj.getTime(), i = 0; i < 42; i++, timestamp += self.utils.duration.DAY) {
				var outOfRange = timestamp < self.minRangeDate.getTime() || timestamp > self.maxRangeDate.getTime();
	
				if (outOfRange) {
					self.days.childNodes[i].classList.add("notAllowed");
					self.days.childNodes[i].classList.remove("inRange", "startRange", "endRange");
					continue;
				} else if (containsDisabled && !outOfRange) continue;
	
				self.days.childNodes[i].classList.remove("startRange", "inRange", "endRange", "notAllowed");
	
				var minRangeDate = Math.max(self.minRangeDate.getTime(), rangeStartDate),
				    maxRangeDate = Math.min(self.maxRangeDate.getTime(), rangeEndDate);
	
				e.target.classList.add(hoverDate < self.selectedDates[0] ? "startRange" : "endRange");
	
				if (initialDate > hoverDate && timestamp === initialDate.getTime()) self.days.childNodes[i].classList.add("endRange");else if (initialDate < hoverDate && timestamp === initialDate.getTime()) self.days.childNodes[i].classList.add("startRange");else if (timestamp > minRangeDate && timestamp < maxRangeDate) self.days.childNodes[i].classList.add("inRange");
			}
		}
	
		function onResize() {
			if (self.isOpen && !self.config.static && !self.config.inline) positionCalendar();
		}
	
		function open(e) {
			if (self.isMobile) {
				if (e) {
					e.preventDefault();
					e.target.blur();
				}
	
				setTimeout(function () {
					self.mobileInput.click();
				}, 0);
	
				triggerEvent("Open");
				return;
			} else if (self.isOpen || (self.altInput || self.input).disabled || self.config.inline) return;
	
			self.calendarContainer.classList.add("open");
	
			if (!self.config.static && !self.config.inline) positionCalendar();
	
			self.isOpen = true;
	
			if (!self.config.allowInput) {
				(self.altInput || self.input).blur();
				(self.config.noCalendar ? self.timeContainer : self.selectedDateElem ? self.selectedDateElem : self.days).focus();
			}
	
			(self.altInput || self.input).classList.add("active");
			triggerEvent("Open");
		}
	
		function parseConfig() {
			var boolOpts = ["utc", "wrap", "weekNumbers", "allowInput", "clickOpens", "time_24hr", "enableTime", "noCalendar", "altInput", "shorthandCurrentMonth", "inline", "static", "enableSeconds", "disableMobile"];
			self.config = Object.create(Flatpickr.defaultConfig);
			var userConfig = _extends({}, self.instanceConfig, self.element.dataset || {});
	
			Object.defineProperty(self.config, "minDate", {
				get: function get() {
					return this._minDate;
				},
				set: function set(date) {
					this._minDate = parseDate(date);
	
					if (self.days) redraw();
	
					if (!self.currentYearElement) return;
	
					if (date && this._minDate instanceof Date) {
						self.minDateHasTime = this._minDate.getHours() || this._minDate.getMinutes() || this._minDate.getSeconds();
	
						self.currentYearElement.min = this._minDate.getFullYear();
					} else self.currentYearElement.removeAttribute("min");
	
					self.currentYearElement.disabled = this._maxDate && this._minDate && this._maxDate.getFullYear() === this._minDate.getFullYear();
				}
			});
	
			Object.defineProperty(self.config, "maxDate", {
				get: function get() {
					return this._maxDate;
				},
				set: function set(date) {
					this._maxDate = parseDate(date);
					if (self.days) redraw();
	
					if (!self.currentYearElement) return;
	
					if (date && this._maxDate instanceof Date) {
						self.currentYearElement.max = this._maxDate.getFullYear();
						self.maxDateHasTime = this._maxDate.getHours() || this._maxDate.getMinutes() || this._maxDate.getSeconds();
					} else self.currentYearElement.removeAttribute("max");
	
					self.currentYearElement.disabled = this._maxDate && this._minDate && this._maxDate.getFullYear() === this._minDate.getFullYear();
				}
			});
	
			_extends(self.config, userConfig);
	
			for (var i = 0; i < boolOpts.length; i++) {
				self.config[boolOpts[i]] = self.config[boolOpts[i]] === true || self.config[boolOpts[i]] === "true";
			}if (!userConfig.dateFormat && userConfig.enableTime) {
				self.config.dateFormat = self.config.noCalendar ? "H:i" + (self.config.enableSeconds ? ":S" : "") : Flatpickr.defaultConfig.dateFormat + " H:i" + (self.config.enableSeconds ? ":S" : "");
			}
	
			if (userConfig.altInput && userConfig.enableTime && !userConfig.altFormat) {
				self.config.altFormat = self.config.noCalendar ? "h:i" + (self.config.enableSeconds ? ":S K" : " K") : Flatpickr.defaultConfig.altFormat + (" h:i" + (self.config.enableSeconds ? ":S" : "") + " K");
			}
		}
	
		function setupLocale() {
			if (_typeof(self.config.locale) !== "object" && typeof Flatpickr.l10ns[self.config.locale] === "undefined") console.warn("flatpickr: invalid locale " + self.config.locale);
	
			self.l10n = _extends(Object.create(Flatpickr.l10ns.default), _typeof(self.config.locale) === "object" ? self.config.locale : self.config.locale !== "default" ? Flatpickr.l10ns[self.config.locale] || {} : {});
		}
	
		function parseDate(date) {
			var timeless = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
			if (!date) return null;
	
			var dateTimeRegex = /(\d+)/g,
			    timeRegex = /^(\d{1,2})[:\s](\d\d)?[:\s]?(\d\d)?\s?(a|p)?/i,
			    timestamp = /^(\d+)$/g,
			    date_orig = date;
	
			if (date.toFixed) // timestamp
				date = new Date(date);else if (typeof date === "string") {
				date = date.trim();
	
				if (date === "today") {
					date = new Date();
					timeless = true;
				} else if (self.config.parseDate) date = self.config.parseDate(date);else if (timeRegex.test(date)) {
					// time picker
					var m = date.match(timeRegex),
					    hours = !m[4] ? m[1] // military time, no conversion needed
					: m[1] % 12 + (m[4].toLowerCase() === "p" ? 12 : 0); // am/pm
	
					date = new Date();
					date.setHours(hours, m[2] || 0, m[3] || 0);
				} else if (/Z$/.test(date) || /GMT$/.test(date)) // datestrings w/ timezone
					date = new Date(date);else if (dateTimeRegex.test(date) && /^[0-9]/.test(date)) {
					var d = date.match(dateTimeRegex);
					date = new Date(d[0] + "/" + (d[1] || 1) + "/" + (d[2] || 1) + " " + (d[3] || 0) + ":" + (d[4] || 0) + ":" + (d[5] || 0));
				} else // fallback
					date = new Date(date);
			}
	
			if (!(date instanceof Date)) {
				console.warn("flatpickr: invalid date " + date_orig);
				console.info(self.element);
				return null;
			}
	
			if (self.config.utc && !date.fp_isUTC) date = date.fp_toUTC();
	
			if (timeless) date.setHours(0, 0, 0, 0);
	
			return date;
		}
	
		function positionCalendar() {
			var calendarHeight = self.calendarContainer.offsetHeight,
			    input = self.altInput || self.input,
			    inputBounds = input.getBoundingClientRect(),
			    distanceFromBottom = window.innerHeight - inputBounds.bottom + input.offsetHeight;
	
			var top = void 0,
			    left = window.pageXOffset + inputBounds.left;
	
			if (distanceFromBottom < calendarHeight) {
				top = window.pageYOffset - calendarHeight + inputBounds.top - 2;
				self.calendarContainer.classList.remove("arrowTop");
				self.calendarContainer.classList.add("arrowBottom");
			} else {
				top = window.pageYOffset + input.offsetHeight + inputBounds.top + 2;
				self.calendarContainer.classList.remove("arrowBottom");
				self.calendarContainer.classList.add("arrowTop");
			}
	
			if (!self.config.static && !self.config.inline) {
				self.calendarContainer.style.top = top + "px";
				self.calendarContainer.style.left = left + "px";
			}
		}
	
		function redraw() {
			if (self.config.noCalendar || self.isMobile) return;
	
			buildWeekdays();
			updateNavigationCurrentMonth();
			buildDays();
		}
	
		function selectDate(e) {
			if (self.config.allowInput && e.which === 13 && e.target === (self.altInput || self.input)) return self.setDate((self.altInput || self.input).value), e.target.blur();
	
			if (!e.target.classList.contains("flatpickr-day") || e.target.classList.contains("disabled") || e.target.classList.contains("notAllowed")) return;
	
			var selectedDate = e.target.dateObj;
			self.selectedDateElem = e.target;
	
			if (self.config.mode === "single") {
				self.selectedDates = [selectedDate];
	
				if (!self.config.enableTime) self.close();
			} else if (self.config.mode === "multiple") {
				var selectedIndex = isDateSelected(selectedDate);
				if (selectedIndex) self.selectedDates.splice(selectedIndex, 1);else self.selectedDates.push(selectedDate);
			} else if (self.config.mode === "range") {
				if (self.selectedDates.length === 2) self.clear();
	
				self.selectedDates.push(selectedDate);
				self.selectedDates.sort(function (a, b) {
					return a.getTime() - b.getTime();
				});
			}
	
			setHoursFromInputs();
	
			if (selectedDate.getMonth() !== self.currentMonth && self.config.mode !== "range") {
				self.currentYear = selectedDate.getFullYear();
				self.currentMonth = selectedDate.getMonth();
				updateNavigationCurrentMonth();
			}
	
			buildDays();
	
			if (self.minDateHasTime && self.config.enableTime && compareDates(selectedDate, self.config.minDate) === 0) setHoursFromDate(self.config.minDate);
	
			updateValue();
	
			setTimeout(function () {
				return self.dateIsPicked = true;
			}, 50);
	
			if (self.config.mode === "range" && self.selectedDates.length === 1) onMouseOver(e);
	
			triggerEvent("Change");
		}
	
		function set(option, value) {
			self.config[option] = value;
			self.redraw();
			jumpToDate();
		}
	
		function setDate(date, triggerChange) {
			if (!date) return self.clear();
	
			self.selectedDates = (Array.isArray(date) ? date.map(parseDate) : [parseDate(date)]).filter(function (d) {
				return d instanceof Date && isEnabled(d);
			});
			self.redraw();
			jumpToDate();
	
			setHoursFromDate();
			updateValue();
	
			self.dateIsPicked = self.selectedDates.length > 0;
	
			if (triggerChange) triggerEvent("Change");
		}
	
		function setupDates() {
			self.selectedDates = [];
			self.now = new Date();
			var inputDate = self.config.defaultDate || self.input.value;
	
			if (Array.isArray(inputDate)) self.selectedDates = inputDate.map(parseDate);else if (inputDate) {
				switch (self.config.mode) {
					case "single":
						self.selectedDates = [parseDate(inputDate)];
						break;
	
					case "multiple":
						self.selectedDates = inputDate.split("; ").map(parseDate);
						break;
	
					case "range":
						self.selectedDates = inputDate.split(self.l10n.rangeSeparator).map(parseDate);
						break;
	
					default:
						break;
				}
			}
	
			self.selectedDates = self.selectedDates.filter(function (d) {
				return d instanceof Date && d.getTime() && isEnabled(d);
			});
	
			var initialDate = self.selectedDates.length ? self.selectedDates[0] : self.config.minDate > self.now ? self.config.minDate : self.now;
	
			self.currentYear = initialDate.getFullYear();
			self.currentMonth = initialDate.getMonth();
		}
	
		function setupHelperFunctions() {
			self.utils = {
				duration: {
					DAY: 86400000
				},
				getDaysinMonth: function getDaysinMonth() {
					var month = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : self.currentMonth;
					var yr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : self.currentYear;
	
					if (month === 1 && (yr % 4 === 0 && yr % 100 !== 0 || yr % 400 === 0)) return 29;
					return self.l10n.daysInMonth[month];
				},
	
				monthToStr: function monthToStr(monthNumber) {
					var short = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : self.config.shorthandCurrentMonth;
					return self.l10n.months[(short ? "short" : "long") + "hand"][monthNumber];
				}
			};
		}
	
		function setupFormats() {
			self.formats = {
				// weekday name, short, e.g. Thu
				D: function D(date) {
					return self.l10n.weekdays.shorthand[self.formats.w(date)];
				},
	
				// full month name e.g. January
				F: function F(date) {
					return self.utils.monthToStr(self.formats.n(date) - 1, false);
				},
	
				// hours with leading zero e.g. 03
				H: function H(date) {
					return Flatpickr.prototype.pad(date.getHours());
				},
	
				// day (1-30) with ordinal suffix e.g. 1st, 2nd
				J: function J(date) {
					return date.getDate() + self.l10n.ordinal(date.getDate());
				},
	
				// AM/PM
				K: function K(date) {
					return date.getHours() > 11 ? "PM" : "AM";
				},
	
				// shorthand month e.g. Jan, Sep, Oct, etc
				M: function M(date) {
					return self.utils.monthToStr(date.getMonth(), true);
				},
	
				// seconds 00-59
				S: function S(date) {
					return Flatpickr.prototype.pad(date.getSeconds());
				},
	
				// unix timestamp
				U: function U(date) {
					return date.getTime() / 1000;
				},
	
				// full year e.g. 2016
				Y: function Y(date) {
					return date.getFullYear();
				},
	
				// day in month, padded (01-30)
				d: function d(date) {
					return Flatpickr.prototype.pad(self.formats.j(date));
				},
	
				// hour from 1-12 (am/pm)
				h: function h(date) {
					return date.getHours() % 12 ? date.getHours() % 12 : 12;
				},
	
				// minutes, padded with leading zero e.g. 09
				i: function i(date) {
					return Flatpickr.prototype.pad(date.getMinutes());
				},
	
				// day in month (1-30)
				j: function j(date) {
					return date.getDate();
				},
	
				// weekday name, full, e.g. Thursday
				l: function l(date) {
					return self.l10n.weekdays.longhand[self.formats.w(date)];
				},
	
				// padded month number (01-12)
				m: function m(date) {
					return Flatpickr.prototype.pad(self.formats.n(date));
				},
	
				// the month number (1-12)
				n: function n(date) {
					return date.getMonth() + 1;
				},
	
				// seconds 0-59
				s: function s(date) {
					return date.getSeconds();
				},
	
				// number of the day of the week
				w: function w(date) {
					return date.getDay();
				},
	
				// last two digits of year e.g. 16 for 2016
				y: function y(date) {
					return String(self.formats.Y(date)).substring(2);
				}
			};
		}
	
		function setupInputs() {
			self.input = self.config.wrap ? self.element.querySelector("[data-input]") : self.element;
	
			self.input.classList.add("flatpickr-input");
			if (self.config.altInput) {
				// replicate self.element
				self.altInput = createElement(self.input.nodeName, self.config.altInputClass);
				self.altInput.placeholder = self.input.placeholder;
				self.altInput.type = "text";
	
				self.input.type = "hidden";
				if (self.input.parentNode) self.input.parentNode.insertBefore(self.altInput, self.input.nextSibling);
			}
	
			if (!self.config.allowInput) (self.altInput || self.input).setAttribute("readonly", "readonly");
		}
	
		function setupMobile() {
			var inputType = self.config.enableTime ? self.config.noCalendar ? "time" : "datetime-local" : "date";
	
			self.mobileInput = createElement("input", "flatpickr-input flatpickr-mobile");
			self.mobileInput.step = "any";
			self.mobileInput.tabIndex = -1;
			self.mobileInput.type = inputType;
			self.mobileInput.disabled = self.input.disabled;
	
			self.mobileFormatStr = inputType === "datetime-local" ? "Y-m-d\\TH:i:S" : inputType === "date" ? "Y-m-d" : "H:i:S";
	
			if (self.selectedDates.length) {
				self.mobileInput.defaultValue = self.mobileInput.value = formatDate(self.mobileFormatStr, self.selectedDates[0]);
			}
	
			if (self.config.minDate) self.mobileInput.min = formatDate("Y-m-d", self.config.minDate);
	
			if (self.config.maxDate) self.mobileInput.max = formatDate("Y-m-d", self.config.maxDate);
	
			self.input.type = "hidden";
			if (self.config.altInput) self.altInput.type = "hidden";
	
			try {
				self.input.parentNode.insertBefore(self.mobileInput, self.input.nextSibling);
			} catch (e) {
				//
			}
	
			self.mobileInput.addEventListener("change", function (e) {
				self.setDate(e.target.value);
				triggerEvent("Change");
				triggerEvent("Close");
			});
		}
	
		function toggle() {
			if (self.isOpen) self.close();else self.open();
		}
	
		function triggerEvent(event, data) {
			if (self.config["on" + event]) {
				var hooks = Array.isArray(self.config["on" + event]) ? self.config["on" + event] : [self.config["on" + event]];
	
				for (var i = 0; i < hooks.length; i++) {
					hooks[i](self.selectedDates, self.input.value, self, data);
				}
			}
	
			if (event === "Change") {
				try {
					self.input.dispatchEvent(new Event("change", { "bubbles": true }));
	
					// many front-end frameworks bind to the input event
					self.input.dispatchEvent(new Event("input", { "bubbles": true }));
				} catch (e) {
					if ("createEvent" in document) return self.input.dispatchEvent(self.changeEvent);
	
					self.input.fireEvent("onchange");
				}
			}
		}
	
		function latestSelectedDateObj() {
			if (self.selectedDates.length) return self.selectedDates[self.selectedDates.length - 1];
			return null;
		}
	
		function isDateSelected(date) {
			for (var i = 0; i < self.selectedDates.length; i++) {
				if (compareDates(self.selectedDates[i], date) === 0) return "" + i;
			}
	
			return false;
		}
	
		function isDateInRange(date) {
			if (self.config.mode !== "range" || self.selectedDates.length < 2) return false;
			return compareDates(date, self.selectedDates[0]) >= 0 && compareDates(date, self.selectedDates[1]) <= 0;
		}
	
		function updateNavigationCurrentMonth() {
			if (self.config.noCalendar || self.isMobile || !self.monthNav) return;
	
			self.currentMonthElement.textContent = self.utils.monthToStr(self.currentMonth) + " ";
			self.currentYearElement.value = self.currentYear;
	
			if (self.config.minDate) {
				var hidePrevMonthArrow = self.currentYear === self.config.minDate.getFullYear() ? (self.currentMonth + 11) % 12 < self.config.minDate.getMonth() : self.currentYear < self.config.minDate.getFullYear();
	
				self.prevMonthNav.style.display = hidePrevMonthArrow ? "none" : "block";
			} else self.prevMonthNav.style.display = "block";
	
			if (self.config.maxDate) {
				var hideNextMonthArrow = self.currentYear === self.config.maxDate.getFullYear() ? self.currentMonth + 1 > self.config.maxDate.getMonth() : self.currentYear > self.config.maxDate.getFullYear();
	
				self.nextMonthNav.style.display = hideNextMonthArrow ? "none" : "block";
			} else self.nextMonthNav.style.display = "block";
		}
	
		function updateValue() {
			if (!self.selectedDates.length) return self.clear();
	
			if (self.isMobile) {
				self.mobileInput.value = self.selectedDates.length ? formatDate(self.mobileFormatStr, latestSelectedDateObj()) : "";
			}
	
			var joinChar = self.config.mode !== "range" ? "; " : self.l10n.rangeSeparator;
	
			self.input.value = self.selectedDates.map(function (dObj) {
				return formatDate(self.config.dateFormat, dObj);
			}).join(joinChar);
	
			if (self.config.altInput) {
				self.altInput.value = self.selectedDates.map(function (dObj) {
					return formatDate(self.config.altFormat, dObj);
				}).join(joinChar);
			}
	
			triggerEvent("ValueUpdate");
		}
	
		function yearScroll(e) {
			e.preventDefault();
	
			var delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.deltaY)),
			    newYear = parseInt(e.target.value, 10) + delta;
	
			handleYearChange(newYear);
			e.target.value = self.currentYear;
		}
	
		function createElement(tag) {
			var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
			var content = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
	
			var e = document.createElement(tag);
			e.className = className;
	
			if (content) e.innerHTML = content;
	
			return e;
		}
	
		function debounce(func, wait, immediate) {
			var timeout = void 0;
			return function () {
				for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
					args[_key] = arguments[_key];
				}
	
				var context = this;
				var later = function later() {
					timeout = null;
					if (!immediate) func.apply(context, args);
				};
	
				clearTimeout(timeout);
				timeout = setTimeout(later, wait);
				if (immediate && !timeout) func.apply(context, args);
			};
		}
	
		function compareDates(date1, date2) {
			if (!(date1 instanceof Date) || !(date2 instanceof Date)) return false;
	
			return new Date(date1.getTime()).setHours(0, 0, 0, 0) - new Date(date2.getTime()).setHours(0, 0, 0, 0);
		}
	
		function timeWrapper(e) {
			e.preventDefault();
			if (e && ((e.target.value || e.target.textContent).length >= 2 || // typed two digits
			e.type !== "keydown" && e.type !== "input" // scroll event
			)) e.target.blur();
	
			if (self.amPM && e.target === self.amPM) return e.target.textContent = ["AM", "PM"][e.target.textContent === "AM" | 0];
	
			var min = Number(e.target.min),
			    max = Number(e.target.max),
			    step = Number(e.target.step),
			    curValue = parseInt(e.target.value, 10),
			    delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.deltaY));
	
			var newValue = Number(curValue);
	
			if (e.type === "wheel") newValue = curValue + step * delta;else if (e.type === "keydown") newValue = curValue + step * (e.which === 38 ? 1 : -1);
	
			if (newValue < min) {
				newValue = max + newValue + (e.target !== self.hourElement) + (e.target === self.hourElement && !self.amPM);
			} else if (newValue > max) {
				newValue = e.target === self.hourElement ? newValue - max - !self.amPM : min;
			}
	
			if (self.amPM && e.target === self.hourElement && (step === 1 ? newValue + curValue === 23 : Math.abs(newValue - curValue) > step)) self.amPM.textContent = self.amPM.innerHTML === "PM" ? "AM" : "PM";
	
			e.target.value = self.pad(newValue);
		}
	
		init();
		return self;
	}
	
	Flatpickr.defaultConfig = {
	
		mode: "single",
	
		/* if true, dates will be parsed, formatted, and displayed in UTC.
	 preloading date strings w/ timezones is recommended but not necessary */
		utc: false,
	
		// wrap: see https://chmln.github.io/flatpickr/#strap
		wrap: false,
	
		// enables week numbers
		weekNumbers: false,
	
		// allow manual datetime input
		allowInput: false,
	
		/*
	 	clicking on input opens the date(time)picker.
	 	disable if you wish to open the calendar manually with .open()
	 */
		clickOpens: true,
	
		// display time picker in 24 hour mode
		time_24hr: false,
	
		// enables the time picker functionality
		enableTime: false,
	
		// noCalendar: true will hide the calendar. use for a time picker along w/ enableTime
		noCalendar: false,
	
		// more date format chars at https://chmln.github.io/flatpickr/#dateformat
		dateFormat: "Y-m-d",
	
		// altInput - see https://chmln.github.io/flatpickr/#altinput
		altInput: false,
	
		// the created altInput element will have this class.
		altInputClass: "form-control input",
	
		// same as dateFormat, but for altInput
		altFormat: "F j, Y", // defaults to e.g. June 10, 2016
	
		// defaultDate - either a datestring or a date object. used for datetimepicker"s initial value
		defaultDate: null,
	
		// the minimum date that user can pick (inclusive)
		minDate: null,
	
		// the maximum date that user can pick (inclusive)
		maxDate: null,
	
		// dateparser that transforms a given string to a date object
		parseDate: null,
	
		// dateformatter that transforms a given date object to a string, according to passed format
		formatDate: null,
	
		getWeek: function getWeek(givenDate) {
			var date = new Date(givenDate.getTime());
			date.setHours(0, 0, 0, 0);
	
			// Thursday in current week decides the year.
			date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
			// January 4 is always in week 1.
			var week1 = new Date(date.getFullYear(), 0, 4);
			// Adjust to Thursday in week 1 and count number of weeks from date to week1.
			return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
		},
	
		// see https://chmln.github.io/flatpickr/#disable
		enable: [],
	
		// see https://chmln.github.io/flatpickr/#disable
		disable: [],
	
		// display the short version of month names - e.g. Sep instead of September
		shorthandCurrentMonth: false,
	
		// displays calendar inline. see https://chmln.github.io/flatpickr/#inline-calendar
		inline: false,
	
		// position calendar inside wrapper and next to the input element
		// leave at false unless you know what you"re doing
		static: false,
	
		// DOM node to append the calendar to in *static* mode
		appendTo: null,
	
		// code for previous/next icons. this is where you put your custom icon code e.g. fontawesome
		prevArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
		nextArrow: "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
	
		// enables seconds in the time picker
		enableSeconds: false,
	
		// step size used when scrolling/incrementing the hour element
		hourIncrement: 1,
	
		// step size used when scrolling/incrementing the minute element
		minuteIncrement: 5,
	
		// initial value in the hour element
		defaultHour: 12,
	
		// initial value in the minute element
		defaultMinute: 0,
	
		// disable native mobile datetime input support
		disableMobile: false,
	
		// default locale
		locale: "default",
	
		// onChange callback when user selects a date or time
		onChange: null, // function (dateObj, dateStr) {}
	
		// called every time calendar is opened
		onOpen: null, // function (dateObj, dateStr) {}
	
		// called every time calendar is closed
		onClose: null, // function (dateObj, dateStr) {}
	
		// called after calendar is ready
		onReady: null, // function (dateObj, dateStr) {}
	
		onValueUpdate: null,
	
		onDayCreate: null
	};
	
	Flatpickr.l10ns = {
		en: {
			weekdays: {
				shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
				longhand: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
			},
			months: {
				shorthand: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
				longhand: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
			},
			daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
			firstDayOfWeek: 0,
			ordinal: function ordinal(nth) {
				var s = nth % 100;
				if (s > 3 && s < 21) return "th";
				switch (s % 10) {
					case 1:
						return "st";
					case 2:
						return "nd";
					case 3:
						return "rd";
					default:
						return "th";
				}
			},
			rangeSeparator: " to ",
			weekAbbreviation: "Wk",
			scrollTitle: "Scroll to increment",
			toggleTitle: "Click to toggle"
		}
	};
	
	Flatpickr.l10ns.default = Flatpickr.l10ns.en;
	
	Flatpickr.localize = function (l10n) {
		return _extends(Flatpickr.l10ns.default, l10n || {});
	};
	
	Flatpickr.prototype = {
		pad: function pad(number) {
			return ("0" + number).slice(-2);
		}
	};
	
	function _flatpickr(nodeList, config) {
		var instances = [];
		for (var i = 0; i < nodeList.length; i++) {
			try {
				nodeList[i]._flatpickr = new Flatpickr(nodeList[i], config || {});
				instances.push(nodeList[i]._flatpickr);
			} catch (e) {
				console.warn(e, e.stack);
			}
		}
	
		return instances.length === 1 ? instances[0] : instances;
	}
	if (typeof HTMLElement !== "undefined") {
		// browser env
		HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr = function (config) {
			return _flatpickr(this, config);
		};
	
		HTMLElement.prototype.flatpickr = function (config) {
			return _flatpickr([this], config);
		};
	}
	
	function flatpickr(selector, config) {
		return _flatpickr(document.querySelectorAll(selector), config);
	}
	
	if (typeof jQuery !== "undefined") {
		jQuery.fn.flatpickr = function (config) {
			return _flatpickr(this, config);
		};
	}
	
	Date.prototype.fp_incr = function (days) {
		return new Date(this.getFullYear(), this.getMonth(), this.getDate() + parseInt(days, 10));
	};
	
	Date.prototype.fp_isUTC = false;
	Date.prototype.fp_toUTC = function () {
		var newDate = new Date(this.getUTCFullYear(), this.getUTCMonth(), this.getUTCDate(), this.getUTCHours(), this.getUTCMinutes(), this.getUTCSeconds());
	
		newDate.fp_isUTC = true;
		return newDate;
	};
	
	// IE9 classList polyfill
	if (!("classList" in document.documentElement) && Object.defineProperty && typeof HTMLElement !== "undefined") {
		Object.defineProperty(HTMLElement.prototype, "classList", {
			get: function get() {
				var self = this;
				function update(fn) {
					return function (value) {
						var classes = self.className.split(/\s+/),
						    index = classes.indexOf(value);
	
						fn(classes, index, value);
						self.className = classes.join(" ");
					};
				}
	
				var ret = {
					add: update(function (classes, index, value) {
						if (!~index) classes.push(value);
					}),
	
					remove: update(function (classes, index) {
						if (~index) classes.splice(index, 1);
					}),
	
					toggle: update(function (classes, index, value) {
						if (~index) classes.splice(index, 1);else classes.push(value);
					}),
	
					contains: function contains(value) {
						return !!~self.className.split(/\s+/).indexOf(value);
					},
	
					item: function item(i) {
						return self.className.split(/\s+/)[i] || null;
					}
				};
	
				Object.defineProperty(ret, "length", {
					get: function get() {
						return self.className.split(/\s+/).length;
					}
				});
	
				return ret;
			}
		});
	}
	
	if (true) module.exports = Flatpickr;


/***/ },
/* 197 */
/***/ function(module, exports) {

	module.exports = "<form #searchForm=\"ngForm\">\r\n  <div class=\"row\">\r\n    <div class=\"col-md-2\" style=\"width: auto;\">\r\n      <label>{{ 'LblSearch' | translate }}</label>\r\n      <div class=\"radio\" style=\"margin-top: 0px;\">\r\n        <label><input type=\"radio\" [(ngModel)]=\"isBookingSearch\" name=\"isBookingSearch\" (change)=\"OnSearchChange()\" [value]=\"true\">{{ 'LblByBooking' | translate}}</label>\r\n      </div>\r\n      <div class=\"radio\">\r\n        <label><input type=\"radio\" [(ngModel)]=\"isBookingSearch\" name=\"isBookingSearch\" (change)=\"OnSearchChange()\" [value]=\"false\">{{ 'LblByVehicle' | translate}}</label>\r\n      </div>\r\n    </div>\r\n\r\n    <!--Per Booking Option-->\r\n    <div *ngIf=\"isBookingSearch\" class=\"form-group col-md-3 nopad-left\">\r\n      <label><span class=\"text text-danger\">*</span>{{ 'LblBooking' | translate }}</label>\r\n      <div class=\"input-group\">\r\n        <input [(ngModel)]=\"bookingRefrenceId\" name=\"bookingRefrenceId\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblSelect' | translate }} {{ 'LblBooking' | translate }}\"\r\n          readonly>\r\n        <div class=\"input-group-btn\">\r\n          <button class=\"btn btn-default\" type=\"button\" (click)=\"selectBookingModal.show()\">\r\n            <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\r\n          </button>\r\n        </div>\r\n      </div>\r\n      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'BookingHashId' }}</span>\r\n    </div>\r\n\r\n    <div *ngIf=\"isBookingSearch\" class=\"form-group col-md-2 nopad-left\">\r\n      <label>{{ 'LblVehicle' | translate }}</label>\r\n      <input [ngModel]=\"licenceTag\" name=\"LicenceTag\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblVehicle' | translate }}\"\r\n        readonly>\r\n    </div>\r\n\r\n    <div *ngIf=\"isBookingSearch\" class=\"form-group col-md-2 nopad-left\">\r\n      <label>{{ 'LblDriver' | translate }}</label>\r\n      <input [ngModel]=\"driverName\" name=\"driverName\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblDriver' | translate }}\"\r\n        readonly>\r\n    </div>\r\n    <!--End Per Booking Option-->\r\n\r\n    <!--Per Vehicle Option-->\r\n    <div *ngIf=\"!isBookingSearch\" class=\"form-group col-md-2 nopad-left\">\r\n      <label><span class=\"text text-danger\">*</span>{{ 'LblVehicle' | translate }}</label>\r\n      <div class=\"input-group\">\r\n        <input [(ngModel)]=\"licenceTag\" name=\"LicenceTag\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblSelect' | translate }} {{ 'LblVehicle' | translate }}\"\r\n          readonly>\r\n        <div class=\"input-group-btn\">\r\n          <button class=\"btn btn-default\" type=\"button\" (click)=\"selectVehicleModal.show()\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i></button>\r\n        </div>\r\n      </div>\r\n      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'VehicleHashId' }}</span>\r\n    </div>\r\n    <div *ngIf=\"!isBookingSearch\" class=\"form-group col-md-2 nopad-left\">\r\n      <label><span class=\"text text-danger\">*</span>{{ 'LblFrom' | translate }}</label>\r\n      <div class=\"clearfix\"></div>\r\n      <div class=\"input-group\">\r\n        <span class=\"input-group-addon\"><i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i></span>\r\n        <input #flatPickrConfigFromDate=\"wego-flatpickr\" flatpickr readonly [Config]=\"flatPickrConfigFrom\" [(ngModel)]=\"startDateTime\"\r\n          name=\"startDateTime\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblFrom' | translate}}\" (change)=\"OnFromDateChange($event.target.value)\">\r\n      </div>\r\n      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'StartDateTime' }}</span>\r\n    </div>\r\n    <div *ngIf=\"!isBookingSearch\" class=\"form-group col-md-2 nopad-left\">\r\n      <label><span class=\"text text-danger\">*</span>{{ 'LblTo' | translate }}</label>\r\n      <div class=\"clearfix \"></div>\r\n      <div class=\"input-group\">\r\n        <span class=\"input-group-addon\"><i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i></span>\r\n        <input #flatPickrConfigToDate=\"wego-flatpickr\" flatpickr readonly [Config]=\"flatPickrConfigTo\" [(ngModel)]=\"endDateTime\"\r\n          name=\"endDateTime\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblTo' | translate }}\" (change)=\"OnToDateChange($event)\">\r\n      </div>\r\n      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'EndDateTime' }}</span>\r\n    </div>\r\n    <div *ngIf=\"!isBookingSearch\" class=\"form-group col-md-3 nopad-left\">\r\n      <label>{{ 'LblDriver' | translate }}</label>\r\n      <div class=\"input-group\">\r\n        <input [(ngModel)]=\"driverName\" name=\"driverName\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblSelect' | translate }} {{ 'LblDriver' | translate }}\"\r\n          readonly>\r\n        <div class=\"input-group-btn\">\r\n          <button class=\"btn btn-default\" type=\"button\" (click)=\"selectDriverModal.show()\">\r\n            <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>          \r\n          </button>\r\n          <button class=\"btn btn-default\" type=\"button\" (click)=\"ClearDriver()\">\r\n            <i class=\"fa fa-eraser\" aria-hidden=\"true\"></i>          \r\n          </button>\r\n        </div>\r\n      </div>\r\n      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'DriverHashId' }}</span>\r\n    </div>\r\n    <!--End Per Vehicle Option-->\r\n\r\n    <div class=\"input-group\">\r\n      <label>&nbsp;</label>\r\n      <div class=\"clearfix\"></div>\r\n      <button class=\"btn btn-default\" type=\"button\" (click)=\"OnSearch($event)\" title=\"{{'LblSearch' | translate}}\">\r\n        <i class=\"fa fa-search\" aria-hidden=\"true\"></i>\r\n      </button>\r\n      <button *ngIf=\"isValidReport\" class=\"btn btn-default\" type=\"button\" (click)=\"OnExportXls($event)\" title=\"{{'LblExportReport' | translate}}\" style=\"margin-left:10px;\">\r\n        <i class=\"fa fa-file-excel-o\" aria-hidden=\"true\"></i>\r\n      </button>\r\n    </div>\r\n  </div>\r\n</form>\r\n\r\n<wego-snail-trail-driver-popup #selectDriverModal (OnSuccessSelect)=\"SuccessSelectDriverModal($event)\"></wego-snail-trail-driver-popup>\r\n<wego-snail-trail-booking-popup #selectBookingModal (OnSuccessSelect)=\"SuccessSelectBookingModal($event)\"></wego-snail-trail-booking-popup>\r\n<wego-snail-trail-vehicle-popup #selectVehicleModal (OnSuccessSelect)=\"SuccessSelectVehicleModal($event)\"></wego-snail-trail-vehicle-popup>";

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(3), __webpack_require__(22));
		else if(typeof define === 'function' && define.amd)
			define("ngx-color-picker", ["@angular/core", "@angular/common"], factory);
		else if(typeof exports === 'object')
			exports["ngx-color-picker"] = factory(require("@angular/core"), require("@angular/common"));
		else
			root["ngx-color-picker"] = factory(root["@angular/core"], root["@angular/common"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_11__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// identity function for calling harmony imports with the correct context
	/******/ 	__webpack_require__.i = function(value) { return value; };
	/******/
	/******/ 	// define getter function for harmony exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		if(!__webpack_require__.o(exports, name)) {
	/******/ 			Object.defineProperty(exports, name, {
	/******/ 				configurable: false,
	/******/ 				enumerable: true,
	/******/ 				get: getter
	/******/ 			});
	/******/ 		}
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 9);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_0__;
	
	/***/ }),
	/* 1 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(0);
	var formats_1 = __webpack_require__(3);
	var ColorPickerService = (function () {
	    function ColorPickerService() {
	    }
	    ColorPickerService.prototype.hsla2hsva = function (hsla) {
	        var h = Math.min(hsla.h, 1), s = Math.min(hsla.s, 1), l = Math.min(hsla.l, 1), a = Math.min(hsla.a, 1);
	        if (l === 0) {
	            return new formats_1.Hsva(h, 0, 0, a);
	        }
	        else {
	            var v = l + s * (1 - Math.abs(2 * l - 1)) / 2;
	            return new formats_1.Hsva(h, 2 * (v - l) / v, v, a);
	        }
	    };
	    ColorPickerService.prototype.hsva2hsla = function (hsva) {
	        var h = hsva.h, s = hsva.s, v = hsva.v, a = hsva.a;
	        if (v === 0) {
	            return new formats_1.Hsla(h, 0, 0, a);
	        }
	        else if (s === 0 && v === 1) {
	            return new formats_1.Hsla(h, 1, 1, a);
	        }
	        else {
	            var l = v * (2 - s) / 2;
	            return new formats_1.Hsla(h, v * s / (1 - Math.abs(2 * l - 1)), l, a);
	        }
	    };
	    ColorPickerService.prototype.rgbaToHsva = function (rgba) {
	        var r = Math.min(rgba.r, 1), g = Math.min(rgba.g, 1), b = Math.min(rgba.b, 1), a = Math.min(rgba.a, 1);
	        var max = Math.max(r, g, b), min = Math.min(r, g, b);
	        var h, s, v = max;
	        var d = max - min;
	        s = max === 0 ? 0 : d / max;
	        if (max === min) {
	            h = 0;
	        }
	        else {
	            switch (max) {
	                case r:
	                    h = (g - b) / d + (g < b ? 6 : 0);
	                    break;
	                case g:
	                    h = (b - r) / d + 2;
	                    break;
	                case b:
	                    h = (r - g) / d + 4;
	                    break;
	            }
	            h /= 6;
	        }
	        return new formats_1.Hsva(h, s, v, a);
	    };
	    ColorPickerService.prototype.hsvaToRgba = function (hsva) {
	        var h = hsva.h, s = hsva.s, v = hsva.v, a = hsva.a;
	        var r, g, b;
	        var i = Math.floor(h * 6);
	        var f = h * 6 - i;
	        var p = v * (1 - s);
	        var q = v * (1 - f * s);
	        var t = v * (1 - (1 - f) * s);
	        switch (i % 6) {
	            case 0:
	                r = v, g = t, b = p;
	                break;
	            case 1:
	                r = q, g = v, b = p;
	                break;
	            case 2:
	                r = p, g = v, b = t;
	                break;
	            case 3:
	                r = p, g = q, b = v;
	                break;
	            case 4:
	                r = t, g = p, b = v;
	                break;
	            case 5:
	                r = v, g = p, b = q;
	                break;
	        }
	        return new formats_1.Rgba(r, g, b, a);
	    };
	    ColorPickerService.prototype.stringToHsva = function (colorString, allowHex8) {
	        if (colorString === void 0) { colorString = ''; }
	        if (allowHex8 === void 0) { allowHex8 = false; }
	        var stringParsers = [
	            {
	                re: /(rgb)a?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*%?,\s*(\d{1,3})\s*%?(?:,\s*(\d+(?:\.\d+)?)\s*)?\)/,
	                parse: function (execResult) {
	                    return new formats_1.Rgba(parseInt(execResult[2]) / 255, parseInt(execResult[3]) / 255, parseInt(execResult[4]) / 255, isNaN(parseFloat(execResult[5])) ? 1 : parseFloat(execResult[5]));
	                }
	            },
	            {
	                re: /(hsl)a?\(\s*(\d{1,3})\s*,\s*(\d{1,3})%\s*,\s*(\d{1,3})%\s*(?:,\s*(\d+(?:\.\d+)?)\s*)?\)/,
	                parse: function (execResult) {
	                    return new formats_1.Hsla(parseInt(execResult[2]) / 360, parseInt(execResult[3]) / 100, parseInt(execResult[4]) / 100, isNaN(parseFloat(execResult[5])) ? 1 : parseFloat(execResult[5]));
	                }
	            }
	        ];
	        if (allowHex8) {
	            stringParsers.push({
	                re: /#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})?$/,
	                parse: function (execResult) {
	                    return new formats_1.Rgba(parseInt(execResult[1], 16) / 255, parseInt(execResult[2], 16) / 255, parseInt(execResult[3], 16) / 255, parseInt(execResult[4] || 'FF', 16) / 255);
	                }
	            });
	        }
	        else {
	            stringParsers.push({
	                re: /#([a-fA-F0-9]{2})([a-fA-F0-9]{2})([a-fA-F0-9]{2})$/,
	                parse: function (execResult) {
	                    return new formats_1.Rgba(parseInt(execResult[1], 16) / 255, parseInt(execResult[2], 16) / 255, parseInt(execResult[3], 16) / 255, 1);
	                }
	            }, {
	                re: /#([a-fA-F0-9])([a-fA-F0-9])([a-fA-F0-9])$/,
	                parse: function (execResult) {
	                    return new formats_1.Rgba(parseInt(execResult[1] + execResult[1], 16) / 255, parseInt(execResult[2] + execResult[2], 16) / 255, parseInt(execResult[3] + execResult[3], 16) / 255, 1);
	                }
	            });
	        }
	        colorString = (colorString || '').toLowerCase();
	        var hsva = null;
	        for (var key in stringParsers) {
	            if (stringParsers.hasOwnProperty(key)) {
	                var parser = stringParsers[key];
	                var match = parser.re.exec(colorString), color = match && parser.parse(match);
	                if (color) {
	                    if (color instanceof formats_1.Rgba) {
	                        hsva = this.rgbaToHsva(color);
	                    }
	                    else if (color instanceof formats_1.Hsla) {
	                        hsva = this.hsla2hsva(color);
	                    }
	                    return hsva;
	                }
	            }
	        }
	        return hsva;
	    };
	    ColorPickerService.prototype.outputFormat = function (hsva, outputFormat, alphaChannel) {
	        switch (outputFormat) {
	            case 'hsla':
	                var hsla = this.hsva2hsla(hsva);
	                var hslaText = new formats_1.Hsla(Math.round((hsla.h) * 360), Math.round(hsla.s * 100), Math.round(hsla.l * 100), Math.round(hsla.a * 100) / 100);
	                if (hsva.a < 1 || alphaChannel === 'always') {
	                    return 'hsla(' + hslaText.h + ',' + hslaText.s + '%,' + hslaText.l + '%,' + hslaText.a + ')';
	                }
	                else {
	                    return 'hsl(' + hslaText.h + ',' + hslaText.s + '%,' + hslaText.l + '%)';
	                }
	            case 'rgba':
	                var rgba = this.denormalizeRGBA(this.hsvaToRgba(hsva));
	                if (hsva.a < 1 || alphaChannel === 'always') {
	                    return 'rgba(' + rgba.r + ',' + rgba.g + ',' + rgba.b + ',' + Math.round(rgba.a * 100) / 100 + ')';
	                }
	                else {
	                    return 'rgb(' + rgba.r + ',' + rgba.g + ',' + rgba.b + ')';
	                }
	            default:
	                return this.hexText(this.denormalizeRGBA(this.hsvaToRgba(hsva)), alphaChannel === 'always' || alphaChannel === 'hex8');
	        }
	    };
	    ColorPickerService.prototype.hexText = function (rgba, allowHex8) {
	        var hexText = '#' + ((1 << 24) | (rgba.r << 16) | (rgba.g << 8) | rgba.b).toString(16).substr(1);
	        if (hexText[1] === hexText[2] && hexText[3] === hexText[4] && hexText[5] === hexText[6] && !allowHex8) {
	            hexText = '#' + hexText[1] + hexText[3] + hexText[5];
	        }
	        if (allowHex8) {
	            hexText += ((1 << 8) | Math.round(rgba.a * 255)).toString(16).substr(1);
	        }
	        return hexText;
	    };
	    ColorPickerService.prototype.denormalizeRGBA = function (rgba) {
	        return new formats_1.Rgba(Math.round(rgba.r * 255), Math.round(rgba.g * 255), Math.round(rgba.b * 255), rgba.a);
	    };
	    return ColorPickerService;
	}());
	ColorPickerService = __decorate([
	    core_1.Injectable(),
	    __metadata("design:paramtypes", [])
	], ColorPickerService);
	exports.ColorPickerService = ColorPickerService;
	
	
	/***/ }),
	/* 2 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(0);
	var color_picker_service_1 = __webpack_require__(1);
	var formats_1 = __webpack_require__(3);
	var helpers_1 = __webpack_require__(4);
	var ColorPickerComponent = (function () {
	    function ColorPickerComponent(el, cdr, service) {
	        this.el = el;
	        this.cdr = cdr;
	        this.service = service;
	        this.dialogArrowSize = 10;
	        this.dialogArrowOffset = 15;
	        this.useRootViewContainer = false;
	        this.isIE10 = false;
	    }
	    ColorPickerComponent.prototype.setDialog = function (instance, elementRef, color, cpPosition, cpPositionOffset, cpPositionRelativeToArrow, cpOutputFormat, cpPresetLabel, cpPresetColors, cpCancelButton, cpCancelButtonClass, cpCancelButtonText, cpOKButton, cpOKButtonClass, cpOKButtonText, cpHeight, cpWidth, cpIgnoredElements, cpDialogDisplay, cpSaveClickOutside, cpAlphaChannel, cpUseRootViewContainer) {
	        this.directiveInstance = instance;
	        this.initialColor = color;
	        this.directiveElementRef = elementRef;
	        this.cpPosition = cpPosition;
	        this.cpPositionOffset = parseInt(cpPositionOffset);
	        if (!cpPositionRelativeToArrow) {
	            this.dialogArrowOffset = 0;
	        }
	        this.cpOutputFormat = cpOutputFormat;
	        this.cpPresetLabel = cpPresetLabel;
	        this.cpPresetColors = cpPresetColors;
	        this.cpCancelButton = cpCancelButton;
	        this.cpCancelButtonClass = cpCancelButtonClass;
	        this.cpCancelButtonText = cpCancelButtonText;
	        this.cpOKButton = cpOKButton;
	        this.cpOKButtonClass = cpOKButtonClass;
	        this.cpOKButtonText = cpOKButtonText;
	        this.cpHeight = parseInt(cpHeight);
	        this.cpWidth = parseInt(cpWidth);
	        if (!this.cpWidth) {
	            this.cpWidth = elementRef.nativeElement.offsetWidth;
	        }
	        this.cpIgnoredElements = cpIgnoredElements;
	        this.cpDialogDisplay = cpDialogDisplay;
	        if (this.cpDialogDisplay === 'inline') {
	            this.dialogArrowOffset = 0;
	            this.dialogArrowSize = 0;
	        }
	        this.cpSaveClickOutside = cpSaveClickOutside;
	        this.cpAlphaChannel = cpAlphaChannel;
	        this.useRootViewContainer = cpUseRootViewContainer;
	        if (cpOutputFormat === 'hex' && cpAlphaChannel !== 'always' && cpAlphaChannel !== 'hex8') {
	            this.cpAlphaChannel = 'disabled';
	        }
	        this.isIE10 = helpers_1.detectIE() === 10;
	    };
	    ColorPickerComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        var alphaWidth = this.alphaSlider.nativeElement.offsetWidth;
	        var hueWidth = this.hueSlider.nativeElement.offsetWidth;
	        this.sliderDimMax = new helpers_1.SliderDimension(hueWidth, this.cpWidth, 130, alphaWidth);
	        this.slider = new helpers_1.SliderPosition(0, 0, 0, 0);
	        if (this.cpOutputFormat === 'rgba') {
	            this.format = 1;
	        }
	        else if (this.cpOutputFormat === 'hsla') {
	            this.format = 2;
	        }
	        else {
	            this.format = 0;
	        }
	        this.listenerMouseDown = function (event) { _this.onMouseDown(event); };
	        this.listenerResize = function () { _this.onResize(); };
	        this.openDialog(this.initialColor, false);
	    };
	    ColorPickerComponent.prototype.ngAfterViewInit = function () {
	        if (this.cpWidth != 230) {
	            var alphaWidth = this.alphaSlider.nativeElement.offsetWidth;
	            var hueWidth = this.hueSlider.nativeElement.offsetWidth;
	            this.sliderDimMax = new helpers_1.SliderDimension(hueWidth, this.cpWidth, 130, alphaWidth);
	            this.update(false);
	            this.cdr.detectChanges();
	        }
	    };
	    ColorPickerComponent.prototype.setInitialColor = function (color) {
	        this.initialColor = color;
	    };
	    ColorPickerComponent.prototype.setPresetConfig = function (cpPresetLabel, cpPresetColors) {
	        this.cpPresetLabel = cpPresetLabel;
	        this.cpPresetColors = cpPresetColors;
	    };
	    ColorPickerComponent.prototype.openDialog = function (color, emit) {
	        if (emit === void 0) { emit = true; }
	        this.setInitialColor(color);
	        this.setColorFromString(color, emit);
	        this.openColorPicker();
	    };
	    ColorPickerComponent.prototype.cancelColor = function (event) {
	        if (event && event.stopPropagation) {
	            event.stopPropagation();
	        }
	        this.setColorFromString(this.initialColor, true);
	        if (this.cpDialogDisplay === 'popup') {
	            this.directiveInstance.colorChanged(this.initialColor, true);
	            this.closeColorPicker();
	        }
	        this.directiveInstance.colorCanceled();
	    };
	    ColorPickerComponent.prototype.oKColor = function (event) {
	        if (event && event.stopPropagation) {
	            event.stopPropagation();
	        }
	        if (this.cpDialogDisplay === 'popup') {
	            this.closeColorPicker();
	        }
	        if (this.outputColor) {
	            this.directiveInstance.colorSelected(this.outputColor);
	        }
	    };
	    ColorPickerComponent.prototype.setColorFromString = function (value, emit) {
	        if (emit === void 0) { emit = true; }
	        var hsva;
	        if (this.cpAlphaChannel === 'always' || this.cpAlphaChannel === 'hex8') {
	            hsva = this.service.stringToHsva(value, true);
	            if (!hsva && !this.hsva) {
	                hsva = this.service.stringToHsva(value, false);
	            }
	        }
	        else {
	            hsva = this.service.stringToHsva(value, false);
	        }
	        if (hsva) {
	            this.hsva = hsva;
	            this.update(emit);
	        }
	    };
	    ColorPickerComponent.prototype.onDragEnd = function (slider) {
	        this.directiveInstance.sliderDragEnd({ slider: slider, color: this.outputColor });
	    };
	    ColorPickerComponent.prototype.onDragStart = function (slider) {
	        this.directiveInstance.sliderDragStart({ slider: slider, color: this.outputColor });
	    };
	    ColorPickerComponent.prototype.onMouseDown = function (event) {
	        // Workaround for IE10: We need to manually click on OK/Cancel button to close the color-picker [detectIE() !== 10]
	        if ((!this.isDescendant(this.el.nativeElement, event.target)
	            && event.target != this.directiveElementRef.nativeElement &&
	            this.cpIgnoredElements.filter(function (item) { return item === event.target; }).length === 0) &&
	            this.cpDialogDisplay === 'popup' && !this.isIE10) {
	            if (!this.cpSaveClickOutside) {
	                this.setColorFromString(this.initialColor, false);
	                this.directiveInstance.colorChanged(this.initialColor);
	            }
	            this.closeColorPicker();
	        }
	    };
	    ColorPickerComponent.prototype.openColorPicker = function () {
	        var _this = this;
	        if (!this.show) {
	            this.show = true;
	            this.hidden = true;
	            setTimeout(function () {
	                _this.setDialogPosition();
	                _this.hidden = false;
	                _this.cdr.detectChanges();
	            }, 0);
	            this.directiveInstance.toggle(true);
	            /**
	             * Required for IE10
	             * This event listener is conditional to avoid memory leaks
	             * If the directive was applied at the root level then this won't affect anything
	             * but if we implement this color picker in child components then it closes on clicking anywhere (including this component)
	             * and stopPropagation() does not work
	             */
	            if (!this.isIE10) {
	                document.addEventListener('mousedown', this.listenerMouseDown);
	            }
	            window.addEventListener('resize', this.listenerResize);
	        }
	    };
	    ColorPickerComponent.prototype.closeColorPicker = function () {
	        if (this.show) {
	            this.show = false;
	            this.directiveInstance.toggle(false);
	            /**
	             * Required for IE10
	             * If this is not attached then no need to remove the listener
	             */
	            if (!this.isIE10) {
	                document.removeEventListener('mousedown', this.listenerMouseDown);
	            }
	            window.removeEventListener('resize', this.listenerResize);
	            this.cdr.detectChanges();
	        }
	    };
	    ColorPickerComponent.prototype.onResize = function () {
	        if (this.position === 'fixed') {
	            this.setDialogPosition();
	        }
	    };
	    ColorPickerComponent.prototype.setDialogPosition = function () {
	        var dialogHeight = this.dialogElement.nativeElement.offsetHeight;
	        var node = this.directiveElementRef.nativeElement, position = 'static', transform = '';
	        var parentNode = null, transformNode = null, style = null;
	        while (node !== null && node.tagName !== 'HTML') {
	            style = window.getComputedStyle(node);
	            position = style.getPropertyValue("position");
	            transform = style.getPropertyValue("transform");
	            if (position !== 'static' && parentNode === null) {
	                parentNode = node;
	            }
	            if (transform && transform !== 'none' && transformNode === null) {
	                transformNode = node;
	            }
	            if (position === 'fixed') {
	                parentNode = transformNode;
	                break;
	            }
	            node = node.parentNode;
	        }
	        var boxDirective = this.createBox(this.directiveElementRef.nativeElement, (position !== 'fixed'));
	        if ((position !== 'fixed' || parentNode) && !this.useRootViewContainer) {
	            if (parentNode === null) {
	                parentNode = node;
	            }
	            var boxParent = this.createBox(parentNode, true);
	            this.top = boxDirective.top - boxParent.top;
	            this.left = boxDirective.left - boxParent.left;
	        }
	        else {
	            this.top = boxDirective.top;
	            this.left = boxDirective.left;
	        }
	        if (position === 'fixed') {
	            this.position = 'fixed';
	        }
	        if (this.cpPosition === 'left') {
	            this.top += boxDirective.height * this.cpPositionOffset / 100 - this.dialogArrowOffset;
	            this.left -= this.cpWidth + this.dialogArrowSize - 2;
	        }
	        else if (this.cpPosition === 'top') {
	            this.top -= dialogHeight + this.dialogArrowSize;
	            this.left += this.cpPositionOffset / 100 * boxDirective.width - this.dialogArrowOffset;
	            this.arrowTop = dialogHeight - 1;
	        }
	        else if (this.cpPosition === 'bottom') {
	            this.top += boxDirective.height + this.dialogArrowSize;
	            this.left += this.cpPositionOffset / 100 * boxDirective.width - this.dialogArrowOffset;
	        }
	        else {
	            this.top += boxDirective.height * this.cpPositionOffset / 100 - this.dialogArrowOffset;
	            this.left += boxDirective.width + this.dialogArrowSize - 2;
	        }
	    };
	    ColorPickerComponent.prototype.setSaturation = function (val) {
	        var hsla = this.service.hsva2hsla(this.hsva);
	        hsla.s = val.v / val.rg;
	        this.hsva = this.service.hsla2hsva(hsla);
	        this.update();
	        this.directiveInstance.inputChanged({ input: 'saturation', value: hsla.s, color: this.outputColor });
	    };
	    ColorPickerComponent.prototype.setLightness = function (val) {
	        var hsla = this.service.hsva2hsla(this.hsva);
	        hsla.l = val.v / val.rg;
	        this.hsva = this.service.hsla2hsva(hsla);
	        this.update();
	        this.directiveInstance.inputChanged({ input: 'lightness', value: hsla.l, color: this.outputColor });
	    };
	    ColorPickerComponent.prototype.setHue = function (val) {
	        this.hsva.h = val.v / val.rg;
	        this.update();
	        this.directiveInstance.sliderChanged({ slider: 'hue', value: this.hsva.h, color: this.outputColor });
	    };
	    ColorPickerComponent.prototype.setAlpha = function (val) {
	        this.hsva.a = val.v / val.rg;
	        this.update();
	        this.directiveInstance.sliderChanged({ slider: 'alpha', value: this.hsva.a, color: this.outputColor });
	    };
	    ColorPickerComponent.prototype.setR = function (val) {
	        var rgba = this.service.hsvaToRgba(this.hsva);
	        rgba.r = val.v / val.rg;
	        this.hsva = this.service.rgbaToHsva(rgba);
	        this.update();
	        this.directiveInstance.inputChanged({ input: 'red', value: rgba.r, color: this.outputColor });
	    };
	    ColorPickerComponent.prototype.setG = function (val) {
	        var rgba = this.service.hsvaToRgba(this.hsva);
	        rgba.g = val.v / val.rg;
	        this.hsva = this.service.rgbaToHsva(rgba);
	        this.update();
	        this.directiveInstance.inputChanged({ input: 'green', value: rgba.g, color: this.outputColor });
	    };
	    ColorPickerComponent.prototype.setB = function (val) {
	        var rgba = this.service.hsvaToRgba(this.hsva);
	        rgba.b = val.v / val.rg;
	        this.hsva = this.service.rgbaToHsva(rgba);
	        this.update();
	        this.directiveInstance.inputChanged({ input: 'blue', value: rgba.b, color: this.outputColor });
	    };
	    ColorPickerComponent.prototype.setA = function (val) {
	        this.hsva.a = val.v / val.rg;
	        this.update();
	        this.directiveInstance.inputChanged({ input: 'alpha', value: this.hsva.a, color: this.outputColor });
	    };
	    ColorPickerComponent.prototype.setHex = function (val) {
	        this.setColorFromString(val);
	        this.directiveInstance.inputChanged({ input: 'hex', value: val, color: this.outputColor });
	    };
	    ColorPickerComponent.prototype.setSaturationAndBrightness = function (val) {
	        this.hsva.s = val.s / val.rgX;
	        this.hsva.v = val.v / val.rgY;
	        this.update();
	        this.directiveInstance.sliderChanged({ slider: 'lightness', value: this.hsva.v, color: this.outputColor });
	        this.directiveInstance.sliderChanged({ slider: 'saturation', value: this.hsva.s, color: this.outputColor });
	    };
	    ColorPickerComponent.prototype.formatPolicy = function () {
	        this.format = (this.format + 1) % 3;
	        return this.format;
	    };
	    ColorPickerComponent.prototype.update = function (emit) {
	        if (emit === void 0) { emit = true; }
	        if (this.sliderDimMax) {
	            var hsla = this.service.hsva2hsla(this.hsva);
	            var rgba = this.service.denormalizeRGBA(this.service.hsvaToRgba(this.hsva));
	            var hueRgba = this.service.denormalizeRGBA(this.service.hsvaToRgba(new formats_1.Hsva(this.hsva.h, 1, 1, 1)));
	            this.hslaText = new formats_1.Hsla(Math.round((hsla.h) * 360), Math.round(hsla.s * 100), Math.round(hsla.l * 100), Math.round(hsla.a * 100) / 100);
	            this.rgbaText = new formats_1.Rgba(rgba.r, rgba.g, rgba.b, Math.round(rgba.a * 100) / 100);
	            this.hexText = this.service.hexText(rgba, this.cpAlphaChannel === 'always' || this.cpAlphaChannel === 'hex8');
	            this.alphaSliderColor = 'rgb(' + rgba.r + ',' + rgba.g + ',' + rgba.b + ')';
	            this.hueSliderColor = 'rgb(' + hueRgba.r + ',' + hueRgba.g + ',' + hueRgba.b + ')';
	            var lastOutput = this.outputColor;
	            this.outputColor = this.service.outputFormat(this.hsva, this.cpOutputFormat, this.cpAlphaChannel);
	            this.selectedColor = this.service.outputFormat(this.hsva, 'rgba', null);
	            this.slider = new helpers_1.SliderPosition((this.hsva.h) * this.sliderDimMax.h - 8, this.hsva.s * this.sliderDimMax.s - 8, (1 - this.hsva.v) * this.sliderDimMax.v - 8, this.hsva.a * this.sliderDimMax.a - 8);
	            if (emit && lastOutput !== this.outputColor) {
	                this.directiveInstance.colorChanged(this.outputColor);
	            }
	        }
	    };
	    ColorPickerComponent.prototype.isDescendant = function (parent, child) {
	        var node = child.parentNode;
	        while (node !== null) {
	            if (node === parent) {
	                return true;
	            }
	            node = node.parentNode;
	        }
	        return false;
	    };
	    ColorPickerComponent.prototype.createBox = function (element, offset) {
	        return {
	            top: element.getBoundingClientRect().top + (offset ? window.pageYOffset : 0),
	            left: element.getBoundingClientRect().left + (offset ? window.pageXOffset : 0),
	            width: element.offsetWidth,
	            height: element.offsetHeight
	        };
	    };
	    return ColorPickerComponent;
	}());
	__decorate([
	    core_1.ViewChild('hueSlider'),
	    __metadata("design:type", Object)
	], ColorPickerComponent.prototype, "hueSlider", void 0);
	__decorate([
	    core_1.ViewChild('alphaSlider'),
	    __metadata("design:type", Object)
	], ColorPickerComponent.prototype, "alphaSlider", void 0);
	__decorate([
	    core_1.ViewChild('dialogPopup'),
	    __metadata("design:type", Object)
	], ColorPickerComponent.prototype, "dialogElement", void 0);
	ColorPickerComponent = __decorate([
	    core_1.Component({
	        selector: 'color-picker',
	        template: __webpack_require__(8),
	        styles: [__webpack_require__(7)]
	    }),
	    __metadata("design:paramtypes", [core_1.ElementRef, core_1.ChangeDetectorRef, color_picker_service_1.ColorPickerService])
	], ColorPickerComponent);
	exports.ColorPickerComponent = ColorPickerComponent;
	
	
	/***/ }),
	/* 3 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var Hsva = (function () {
	    function Hsva(h, s, v, a) {
	        this.h = h;
	        this.s = s;
	        this.v = v;
	        this.a = a;
	    }
	    return Hsva;
	}());
	exports.Hsva = Hsva;
	var Hsla = (function () {
	    function Hsla(h, s, l, a) {
	        this.h = h;
	        this.s = s;
	        this.l = l;
	        this.a = a;
	    }
	    return Hsla;
	}());
	exports.Hsla = Hsla;
	var Rgba = (function () {
	    function Rgba(r, g, b, a) {
	        this.r = r;
	        this.g = g;
	        this.b = b;
	        this.a = a;
	    }
	    return Rgba;
	}());
	exports.Rgba = Rgba;
	
	
	/***/ }),
	/* 4 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(0);
	var TextDirective = (function () {
	    function TextDirective() {
	        this.newValue = new core_1.EventEmitter();
	    }
	    TextDirective.prototype.changeInput = function (value) {
	        if (this.rg === undefined) {
	            this.newValue.emit(value);
	        }
	        else {
	            var numeric = parseFloat(value);
	            if (!isNaN(numeric) && numeric >= 0 && numeric <= this.rg) {
	                this.newValue.emit({ v: numeric, rg: this.rg });
	            }
	        }
	    };
	    return TextDirective;
	}());
	__decorate([
	    core_1.Output('newValue'),
	    __metadata("design:type", Object)
	], TextDirective.prototype, "newValue", void 0);
	__decorate([
	    core_1.Input('text'),
	    __metadata("design:type", Object)
	], TextDirective.prototype, "text", void 0);
	__decorate([
	    core_1.Input('rg'),
	    __metadata("design:type", Number)
	], TextDirective.prototype, "rg", void 0);
	TextDirective = __decorate([
	    core_1.Directive({
	        selector: '[text]',
	        host: {
	            '(input)': 'changeInput($event.target.value)'
	        }
	    })
	], TextDirective);
	exports.TextDirective = TextDirective;
	var SliderDirective = (function () {
	    function SliderDirective(el) {
	        var _this = this;
	        this.el = el;
	        this.newValue = new core_1.EventEmitter();
	        this.dragStart = new core_1.EventEmitter();
	        this.dragEnd = new core_1.EventEmitter();
	        this.listenerMove = function (event) { _this.move(event); };
	        this.listenerStop = function () { _this.stop(); };
	    }
	    SliderDirective.prototype.setCursor = function (event) {
	        var height = this.el.nativeElement.offsetHeight;
	        var width = this.el.nativeElement.offsetWidth;
	        var x = Math.max(0, Math.min(this.getX(event), width));
	        var y = Math.max(0, Math.min(this.getY(event), height));
	        if (this.rgX !== undefined && this.rgY !== undefined) {
	            this.newValue.emit({ s: x / width, v: (1 - y / height), rgX: this.rgX, rgY: this.rgY });
	        }
	        else if (this.rgX === undefined && this.rgY !== undefined) {
	            this.newValue.emit({ v: y / height, rg: this.rgY });
	        }
	        else {
	            this.newValue.emit({ v: x / width, rg: this.rgX });
	        }
	    };
	    SliderDirective.prototype.move = function (event) {
	        event.preventDefault();
	        this.setCursor(event);
	    };
	    SliderDirective.prototype.start = function (event) {
	        this.setCursor(event);
	        document.addEventListener('mousemove', this.listenerMove);
	        document.addEventListener('touchmove', this.listenerMove);
	        document.addEventListener('mouseup', this.listenerStop);
	        document.addEventListener('touchend', this.listenerStop);
	        this.dragStart.emit();
	    };
	    SliderDirective.prototype.stop = function () {
	        document.removeEventListener('mousemove', this.listenerMove);
	        document.removeEventListener('touchmove', this.listenerMove);
	        document.removeEventListener('mouseup', this.listenerStop);
	        document.removeEventListener('touchend', this.listenerStop);
	        this.dragEnd.emit();
	    };
	    SliderDirective.prototype.getX = function (event) {
	        return (event.pageX !== undefined ? event.pageX : event.touches[0].pageX) - this.el.nativeElement.getBoundingClientRect().left - window.pageXOffset;
	    };
	    SliderDirective.prototype.getY = function (event) {
	        return (event.pageY !== undefined ? event.pageY : event.touches[0].pageY) - this.el.nativeElement.getBoundingClientRect().top - window.pageYOffset;
	    };
	    return SliderDirective;
	}());
	__decorate([
	    core_1.Output('newValue'),
	    __metadata("design:type", Object)
	], SliderDirective.prototype, "newValue", void 0);
	__decorate([
	    core_1.Output('dragStart'),
	    __metadata("design:type", Object)
	], SliderDirective.prototype, "dragStart", void 0);
	__decorate([
	    core_1.Output('dragEnd'),
	    __metadata("design:type", Object)
	], SliderDirective.prototype, "dragEnd", void 0);
	__decorate([
	    core_1.Input('slider'),
	    __metadata("design:type", String)
	], SliderDirective.prototype, "slider", void 0);
	__decorate([
	    core_1.Input('rgX'),
	    __metadata("design:type", Number)
	], SliderDirective.prototype, "rgX", void 0);
	__decorate([
	    core_1.Input('rgY'),
	    __metadata("design:type", Number)
	], SliderDirective.prototype, "rgY", void 0);
	SliderDirective = __decorate([
	    core_1.Directive({
	        selector: '[slider]',
	        host: {
	            '(mousedown)': 'start($event)',
	            '(touchstart)': 'start($event)'
	        }
	    }),
	    __metadata("design:paramtypes", [core_1.ElementRef])
	], SliderDirective);
	exports.SliderDirective = SliderDirective;
	var SliderPosition = (function () {
	    function SliderPosition(h, s, v, a) {
	        this.h = h;
	        this.s = s;
	        this.v = v;
	        this.a = a;
	    }
	    return SliderPosition;
	}());
	exports.SliderPosition = SliderPosition;
	var SliderDimension = (function () {
	    function SliderDimension(h, s, v, a) {
	        this.h = h;
	        this.s = s;
	        this.v = v;
	        this.a = a;
	    }
	    return SliderDimension;
	}());
	exports.SliderDimension = SliderDimension;
	var ua = navigator.userAgent.toLowerCase();
	function detectIE() {
	    var msie = ua.indexOf('msie ');
	    if (msie > 0) {
	        // IE 10 or older => return version number
	        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
	    }
	    // other browser
	    return false;
	}
	exports.detectIE = detectIE;
	
	
	/***/ }),
	/* 5 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(0);
	var color_picker_service_1 = __webpack_require__(1);
	var color_picker_component_1 = __webpack_require__(2);
	var ColorPickerDirective = (function () {
	    function ColorPickerDirective(injector, cfr, appRef, vcRef, elRef, service) {
	        this.injector = injector;
	        this.cfr = cfr;
	        this.appRef = appRef;
	        this.vcRef = vcRef;
	        this.elRef = elRef;
	        this.service = service;
	        this.cpPosition = 'right';
	        this.cpPositionOffset = '0%';
	        this.cpPositionRelativeToArrow = false;
	        this.cpOutputFormat = 'hex';
	        this.cpPresetLabel = 'Preset colors';
	        this.cpCancelButton = false;
	        this.cpCancelButtonClass = 'cp-cancel-button-class';
	        this.cpCancelButtonText = 'Cancel';
	        this.cpOKButton = false;
	        this.cpOKButtonClass = 'cp-ok-button-class';
	        this.cpOKButtonText = 'OK';
	        this.cpFallbackColor = '#000';
	        this.cpHeight = 'auto';
	        this.cpWidth = '230px';
	        this.cpIgnoredElements = [];
	        this.cpDialogDisplay = 'popup';
	        this.cpSaveClickOutside = true;
	        this.cpAlphaChannel = 'enabled';
	        this.cpUseRootViewContainer = false;
	        this.cpInputChange = new core_1.EventEmitter(true);
	        this.cpToggleChange = new core_1.EventEmitter(true);
	        this.cpSliderChange = new core_1.EventEmitter(true);
	        this.cpSliderDragEnd = new core_1.EventEmitter(true);
	        this.cpSliderDragStart = new core_1.EventEmitter(true);
	        this.colorPickerCancel = new core_1.EventEmitter(true);
	        this.colorPickerSelect = new core_1.EventEmitter(true);
	        this.colorPickerChange = new core_1.EventEmitter(false);
	        this.ignoreChanges = false;
	        this.created = false;
	    }
	    ColorPickerDirective.prototype.ngOnChanges = function (changes) {
	        if (changes.cpToggle) {
	            if (changes.cpToggle.currentValue)
	                this.openDialog();
	            if (!changes.cpToggle.currentValue && this.dialog)
	                this.dialog.closeColorPicker();
	        }
	        if (changes.colorPicker) {
	            if (this.dialog && !this.ignoreChanges) {
	                if (this.cpDialogDisplay === 'inline') {
	                    this.dialog.setInitialColor(changes.colorPicker.currentValue);
	                }
	                this.dialog.setColorFromString(changes.colorPicker.currentValue, false);
	            }
	            this.ignoreChanges = false;
	        }
	        if (changes.cpPresetLabel || changes.cpPresetColors) {
	            if (this.dialog) {
	                this.dialog.setPresetConfig(this.cpPresetLabel, this.cpPresetColors);
	            }
	        }
	    };
	    ColorPickerDirective.prototype.ngOnInit = function () {
	        this.colorPicker = this.colorPicker || this.cpFallbackColor || 'rgba(0, 0, 0, 1)';
	        /*let hsva = this.service.stringToHsva(this.colorPicker);
	        if (hsva === null) hsva = this.service.stringToHsva(this.colorPicker, true);
	        if (hsva == null) {
	            hsva = this.service.stringToHsva(this.cpFallbackColor);
	        }
	        let color = this.service.outputFormat(hsva, this.cpOutputFormat, this.cpAlphaChannel);
	        if (color !== this.colorPicker) {
	            //setTimeout(() => {
	              this.colorPickerChange.emit(color);
	              this.cdr.detectChanges();
	            //}, 0);
	        }*/
	    };
	    ColorPickerDirective.prototype.onClick = function () {
	        var _this = this;
	        if (this.cpIgnoredElements.filter(function (item) { return item === _this.elRef.nativeElement; }).length === 0) {
	            this.openDialog();
	        }
	    };
	    ColorPickerDirective.prototype.openDialog = function () {
	        if (!this.created) {
	            this.created = true;
	            var vcRef = this.vcRef;
	            if (this.cpUseRootViewContainer && this.cpDialogDisplay !== 'inline') {
	                var classOfRootComponent = this.appRef.componentTypes[0];
	                var appInstance = this.injector.get(classOfRootComponent);
	                vcRef = appInstance.vcRef || appInstance.viewContainerRef || this.vcRef;
	                if (vcRef === this.vcRef) {
	                    console.warn("You are using cpUseRootViewContainer, but the root component is not exposing viewContainerRef!" +
	                        "Please expose it by adding 'public vcRef: ViewContainerRef' to the constructor.");
	                }
	            }
	            var compFactory = this.cfr.resolveComponentFactory(color_picker_component_1.ColorPickerComponent);
	            var injector = core_1.ReflectiveInjector.fromResolvedProviders([], vcRef.parentInjector);
	            var cmpRef = vcRef.createComponent(compFactory, 0, injector, []);
	            cmpRef.instance.setDialog(this, this.elRef, this.colorPicker, this.cpPosition, this.cpPositionOffset, this.cpPositionRelativeToArrow, this.cpOutputFormat, this.cpPresetLabel, this.cpPresetColors, this.cpCancelButton, this.cpCancelButtonClass, this.cpCancelButtonText, this.cpOKButton, this.cpOKButtonClass, this.cpOKButtonText, this.cpHeight, this.cpWidth, this.cpIgnoredElements, this.cpDialogDisplay, this.cpSaveClickOutside, this.cpAlphaChannel, this.cpUseRootViewContainer);
	            this.dialog = cmpRef.instance;
	            if (this.vcRef !== vcRef) {
	                cmpRef.changeDetectorRef.detectChanges();
	            }
	        }
	        else if (this.dialog) {
	            this.dialog.openDialog(this.colorPicker);
	        }
	    };
	    ColorPickerDirective.prototype.toggle = function (value) {
	        this.cpToggleChange.emit(value);
	    };
	    ColorPickerDirective.prototype.colorChanged = function (value, ignore) {
	        if (ignore === void 0) { ignore = true; }
	        this.ignoreChanges = ignore;
	        this.colorPickerChange.emit(value);
	    };
	    ColorPickerDirective.prototype.colorCanceled = function () {
	        this.colorPickerCancel.emit();
	    };
	    ColorPickerDirective.prototype.colorSelected = function (value) {
	        this.colorPickerSelect.emit(value);
	    };
	    ColorPickerDirective.prototype.inputChange = function (value) {
	        this.dialog.setColorFromString(value, true);
	    };
	    ColorPickerDirective.prototype.inputChanged = function (event) {
	        this.cpInputChange.emit(event);
	    };
	    ColorPickerDirective.prototype.sliderChanged = function (event) {
	        this.cpSliderChange.emit(event);
	    };
	    ColorPickerDirective.prototype.sliderDragEnd = function (event) {
	        this.cpSliderDragEnd.emit(event);
	    };
	    ColorPickerDirective.prototype.sliderDragStart = function (event) {
	        this.cpSliderDragStart.emit(event);
	    };
	    return ColorPickerDirective;
	}());
	__decorate([
	    core_1.Input('colorPicker'),
	    __metadata("design:type", String)
	], ColorPickerDirective.prototype, "colorPicker", void 0);
	__decorate([
	    core_1.Input('cpToggle'),
	    __metadata("design:type", Boolean)
	], ColorPickerDirective.prototype, "cpToggle", void 0);
	__decorate([
	    core_1.Input('cpPosition'),
	    __metadata("design:type", String)
	], ColorPickerDirective.prototype, "cpPosition", void 0);
	__decorate([
	    core_1.Input('cpPositionOffset'),
	    __metadata("design:type", String)
	], ColorPickerDirective.prototype, "cpPositionOffset", void 0);
	__decorate([
	    core_1.Input('cpPositionRelativeToArrow'),
	    __metadata("design:type", Boolean)
	], ColorPickerDirective.prototype, "cpPositionRelativeToArrow", void 0);
	__decorate([
	    core_1.Input('cpOutputFormat'),
	    __metadata("design:type", String)
	], ColorPickerDirective.prototype, "cpOutputFormat", void 0);
	__decorate([
	    core_1.Input('cpPresetLabel'),
	    __metadata("design:type", String)
	], ColorPickerDirective.prototype, "cpPresetLabel", void 0);
	__decorate([
	    core_1.Input('cpPresetColors'),
	    __metadata("design:type", Array)
	], ColorPickerDirective.prototype, "cpPresetColors", void 0);
	__decorate([
	    core_1.Input('cpCancelButton'),
	    __metadata("design:type", Boolean)
	], ColorPickerDirective.prototype, "cpCancelButton", void 0);
	__decorate([
	    core_1.Input('cpCancelButtonClass'),
	    __metadata("design:type", String)
	], ColorPickerDirective.prototype, "cpCancelButtonClass", void 0);
	__decorate([
	    core_1.Input('cpCancelButtonText'),
	    __metadata("design:type", String)
	], ColorPickerDirective.prototype, "cpCancelButtonText", void 0);
	__decorate([
	    core_1.Input('cpOKButton'),
	    __metadata("design:type", Boolean)
	], ColorPickerDirective.prototype, "cpOKButton", void 0);
	__decorate([
	    core_1.Input('cpOKButtonClass'),
	    __metadata("design:type", String)
	], ColorPickerDirective.prototype, "cpOKButtonClass", void 0);
	__decorate([
	    core_1.Input('cpOKButtonText'),
	    __metadata("design:type", String)
	], ColorPickerDirective.prototype, "cpOKButtonText", void 0);
	__decorate([
	    core_1.Input('cpFallbackColor'),
	    __metadata("design:type", String)
	], ColorPickerDirective.prototype, "cpFallbackColor", void 0);
	__decorate([
	    core_1.Input('cpHeight'),
	    __metadata("design:type", String)
	], ColorPickerDirective.prototype, "cpHeight", void 0);
	__decorate([
	    core_1.Input('cpWidth'),
	    __metadata("design:type", String)
	], ColorPickerDirective.prototype, "cpWidth", void 0);
	__decorate([
	    core_1.Input('cpIgnoredElements'),
	    __metadata("design:type", Object)
	], ColorPickerDirective.prototype, "cpIgnoredElements", void 0);
	__decorate([
	    core_1.Input('cpDialogDisplay'),
	    __metadata("design:type", String)
	], ColorPickerDirective.prototype, "cpDialogDisplay", void 0);
	__decorate([
	    core_1.Input('cpSaveClickOutside'),
	    __metadata("design:type", Boolean)
	], ColorPickerDirective.prototype, "cpSaveClickOutside", void 0);
	__decorate([
	    core_1.Input('cpAlphaChannel'),
	    __metadata("design:type", String)
	], ColorPickerDirective.prototype, "cpAlphaChannel", void 0);
	__decorate([
	    core_1.Input('cpUseRootViewContainer'),
	    __metadata("design:type", Boolean)
	], ColorPickerDirective.prototype, "cpUseRootViewContainer", void 0);
	__decorate([
	    core_1.Output('cpInputChange'),
	    __metadata("design:type", Object)
	], ColorPickerDirective.prototype, "cpInputChange", void 0);
	__decorate([
	    core_1.Output('cpToggleChange'),
	    __metadata("design:type", Object)
	], ColorPickerDirective.prototype, "cpToggleChange", void 0);
	__decorate([
	    core_1.Output('cpSliderChange'),
	    __metadata("design:type", Object)
	], ColorPickerDirective.prototype, "cpSliderChange", void 0);
	__decorate([
	    core_1.Output('cpSliderDragEnd'),
	    __metadata("design:type", Object)
	], ColorPickerDirective.prototype, "cpSliderDragEnd", void 0);
	__decorate([
	    core_1.Output('cpSliderDragStart'),
	    __metadata("design:type", Object)
	], ColorPickerDirective.prototype, "cpSliderDragStart", void 0);
	__decorate([
	    core_1.Output('colorPickerCancel'),
	    __metadata("design:type", Object)
	], ColorPickerDirective.prototype, "colorPickerCancel", void 0);
	__decorate([
	    core_1.Output('colorPickerSelect'),
	    __metadata("design:type", Object)
	], ColorPickerDirective.prototype, "colorPickerSelect", void 0);
	__decorate([
	    core_1.Output('colorPickerChange'),
	    __metadata("design:type", Object)
	], ColorPickerDirective.prototype, "colorPickerChange", void 0);
	ColorPickerDirective = __decorate([
	    core_1.Directive({
	        selector: '[colorPicker]',
	        host: {
	            '(input)': 'inputChange($event.target.value)',
	            '(click)': 'onClick()'
	        }
	    }),
	    __metadata("design:paramtypes", [core_1.Injector, core_1.ComponentFactoryResolver,
	        core_1.ApplicationRef, core_1.ViewContainerRef, core_1.ElementRef,
	        color_picker_service_1.ColorPickerService])
	], ColorPickerDirective);
	exports.ColorPickerDirective = ColorPickerDirective;
	
	
	/***/ }),
	/* 6 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(2));
	__export(__webpack_require__(5));
	__export(__webpack_require__(10));
	__export(__webpack_require__(1));
	__export(__webpack_require__(3));
	__export(__webpack_require__(4));
	
	
	/***/ }),
	/* 7 */
	/***/ (function(module, exports) {
	
	module.exports = "/*\n * Styles for Color Picker\n * \n * Alberto Pujante\n * \n * @licence: http://opensource.org/licenses/MIT\n */\n.color-picker * {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  margin: 0;\n  font-size: 11px; }\n\n.color-picker {\n  cursor: default;\n  width: 230px;\n  height: auto;\n  border: #777 solid 1px;\n  left: 30px;\n  top: 250px;\n  position: absolute;\n  z-index: 100000;\n  background-color: #fff;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -khtml-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none; }\n  .color-picker i {\n    cursor: default;\n    position: relative; }\n  .color-picker input {\n    text-align: center;\n    font-size: 13px;\n    height: 26px;\n    -moz-appearance: textfield; }\n    .color-picker input:invalid {\n      box-shadow: none; }\n    .color-picker input:-moz-submit-invalid {\n      box-shadow: none; }\n    .color-picker input:-moz-ui-invalid {\n      box-shadow: none; }\n    .color-picker input::-webkit-inner-spin-button, .color-picker input::-webkit-outer-spin-button {\n      -webkit-appearance: none;\n      margin: 0; }\n  .color-picker .button-area {\n    padding: 0 16px 16px 16px;\n    text-align: right; }\n  .color-picker .preset-area {\n    padding: 4px 15px; }\n    .color-picker .preset-area .preset-label {\n      width: 100%;\n      padding: 4px;\n      font-size: 11px;\n      text-align: left;\n      color: #555; }\n    .color-picker .preset-area .preset-color {\n      cursor: pointer;\n      display: inline-block;\n      width: 18px;\n      height: 18px;\n      margin: 4px 6px 8px 6px;\n      -moz-border-radius: 25%;\n      -webkit-border-radius: 25%;\n      border-radius: 25%;\n      -khtml-border-radius: 25%;\n      border: #a9a9a9 solid 1px; }\n  .color-picker .arrow {\n    height: 0;\n    width: 0;\n    border-style: solid;\n    position: absolute;\n    z-index: 999999; }\n  .color-picker .arrow-right {\n    border-width: 5px 10px;\n    border-color: transparent #777 transparent transparent;\n    top: 10px;\n    left: -20px; }\n  .color-picker .arrow-left {\n    border-width: 5px 10px;\n    border-color: transparent transparent transparent #777;\n    top: 10px;\n    left: 100%; }\n  .color-picker .arrow-bottom {\n    border-width: 10px 5px;\n    border-color: transparent transparent #777 transparent;\n    top: -20px;\n    left: 10px; }\n  .color-picker .arrow-top {\n    border-width: 10px 5px;\n    border-color: #777 transparent transparent transparent;\n    left: 10px; }\n  .color-picker div.cursor-sv {\n    cursor: default;\n    position: relative;\n    -moz-border-radius: 50%;\n    -webkit-border-radius: 50%;\n    border-radius: 50%;\n    -khtml-border-radius: 50%;\n    width: 15px;\n    height: 15px;\n    border: #ddd solid 1px; }\n  .color-picker div.cursor {\n    cursor: default;\n    position: relative;\n    -moz-border-radius: 50%;\n    -webkit-border-radius: 50%;\n    border-radius: 50%;\n    -khtml-border-radius: 50%;\n    width: 16px;\n    height: 16px;\n    border: #222 solid 2px; }\n  .color-picker .saturation-lightness {\n    cursor: pointer;\n    width: 100%;\n    height: 130px;\n    border: none;\n    background-size: 100% 100%;\n    background-image: url(\"data:image/png;base64,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\"); }\n  .color-picker .box {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -moz-flex;\n    display: -ms-flexbox;\n    display: flex;\n    padding: 4px 8px; }\n    .color-picker .box .left {\n      position: relative;\n      padding: 16px 8px; }\n    .color-picker .box .right {\n      -webkit-flex: 1 1 auto;\n      -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n      padding: 12px 8px; }\n  .color-picker .hue {\n    cursor: pointer;\n    width: 100%;\n    height: 16px;\n    border: none;\n    margin-bottom: 16px;\n    background-size: 100% 100%;\n    background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAAAQCAYAAAD06IYnAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AIWDwkUFWbCCAAAAFxJREFUaN7t0kEKg0AQAME2x83/n2qu5qCgD1iDhCoYdpnbQC9bbY1qVO/jvc6k3ad91s7/7F1/csgPrujuQ17BDYSFsBAWwgJhISyEBcJCWAgLhIWwEBYIi2f7Ar/1TCgFH2X9AAAAAElFTkSuQmCC\"); }\n  .color-picker .alpha {\n    cursor: pointer;\n    width: 100%;\n    height: 16px;\n    border: none;\n    background-size: 100% 100%;\n    background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAAAQCAYAAAD06IYnAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4AIWDwYQlZMa3gAAAWVJREFUaN7tmEGO6jAQRCsOArHgBpyAJYGjcGocxAm4A2IHpmoWE0eBH+ezmFlNvU06shJ3W6VEelWMUQAIIF9f6qZpimsA1LYtS2uF51/u27YVAFZVRUkEoGHdPV/sIcbIEIIkUdI/9Xa7neyv61+SWFUVAVCSct00TWn2fv6u3+Ecfd3tXzy/0+nEUu+SPjo/kqzrmiQpScN6v98XewfA8/lMkiLJ2WxGSUopcT6fM6U0NX9/frfbjev1WtfrlZfLhYfDQQHG/AIOlnGwjINlHCxjHCzjYJm/TJWdCwquJXseFFzGwDNNeiKMOJTO8xQdDQaeB29+K9efeLaBo9J7vdvtJj1RjFFjfiv7qv95tjx/7leSQgh93e1ffMeIp6O+YQjho/N791t1XVOSSI7N//K+4/GoxWLBx+PB5/Op5XLJ+/3OlJJWqxU3m83ovv5iGf8KjYNlHCxjHCzjYBkHy5gf5gusvQU7U37jTAAAAABJRU5ErkJggg==\"); }\n  .color-picker .selected-color {\n    width: 40px;\n    height: 40px;\n    top: 16px;\n    left: 8px;\n    position: absolute;\n    -moz-border-radius: 50%;\n    -webkit-border-radius: 50%;\n    border-radius: 50%;\n    -khtml-border-radius: 50%; }\n  .color-picker .selected-color-background {\n    width: 40px;\n    height: 40px;\n    -moz-border-radius: 50%;\n    -webkit-border-radius: 50%;\n    border-radius: 50%;\n    -khtml-border-radius: 50%;\n    background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAh0lEQVRYR+2W0QlAMQgD60zdfwOdqa8TmI/wQMr5K0I5bZLIzLOa2nt37VVVbd+dDx5obgCC3KBLwJ2ff4PnVidkf+ucIhw80HQaCLo3DMH3CRK3iFsmAWVl6hPNDwt8EvNE5q+YuEXcMgkonVM6SdyCoEvAnZ8v1Hjx817MilmxSUB5rdLJDycZgUAZUch/AAAAAElFTkSuQmCC\"); }\n  .color-picker .type-policy {\n    position: absolute;\n    top: 215px;\n    right: 12px;\n    background-image: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAgCAYAAAAffCjxAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAACewAAAnsB01CO3AAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAIASURBVEiJ7ZY9axRRFIafsxMStrLQJpAgpBFhi+C9w1YSo00I6RZ/g9vZpBf/QOr4GyRgkSKNSrAadsZqQGwCkuAWyRZJsySwvhZ7N/vhzrgbLH3Ld8597jlzz50zJokyxXH8DqDVar0qi6v8BbItqSGpEcfxdlmsFWXkvX8AfAVWg3UKPEnT9GKujMzsAFgZsVaCN1VTQd77XUnrgE1kv+6935268WRpzrnHZvYRWC7YvC3pRZZl3wozqtVqiyH9IgjAspkd1Gq1xUJQtVrdB9ZKIAOthdg/Qc65LUk7wNIMoCVJO865rYFhkqjX6/d7vV4GPJwBMqofURS5JEk6FYBer/eeYb/Mo9WwFnPOvQbeAvfuAAK4BN4sAJtAG/gJIElmNuiJyba3EGNmZiPeZuEVmVell/Y/6N+CzDn3AXhEOOo7Hv/3BeAz8IzQkMPnJbuPx1wC+yYJ7/0nYIP5S/0FHKdp+rwCEEXRS/rf5Hl1Gtb2M0iSpCOpCZzPATmX1EySpHMLAsiy7MjMDoHrGSDXZnaYZdnRwBh7J91utwmczAA6CbG3GgPleX4jqUH/a1CktqRGnuc3hSCAMB32gKspkCtgb3KCQMmkjeP4WNJThrNNZval1WptTIsv7JtQ4tmIdRa8qSoEpWl6YWZNoAN0zKxZNPehpLSBZv2t+Q0CJ9lLnARQLAAAAABJRU5ErkJggg==\");\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: 8px 16px;\n    -moz-background-size: 8px 16px;\n    -webkit-background-size: 8px 16px;\n    -o-background-size: 8px 16px;\n    width: 16px;\n    height: 24px; }\n  .color-picker .hsla-text, .color-picker .rgba-text {\n    width: 100%;\n    font-size: 11px;\n    padding: 4px 8px; }\n    .color-picker .hsla-text .box, .color-picker .rgba-text .box {\n      padding: 0 24px 8px 8px; }\n      .color-picker .hsla-text .box input, .color-picker .rgba-text .box input {\n        min-width: 0;\n        -webkit-flex: 1;\n        -ms-flex: 1;\n        flex: 1;\n        margin: 0;\n        float: left;\n        margin-right: 8px;\n        border: #a9a9a9 solid 1px;\n        padding: 1px; }\n        .color-picker .hsla-text .box input:last-child, .color-picker .rgba-text .box input:last-child {\n          margin-right: 0; }\n      .color-picker .hsla-text .box div, .color-picker .rgba-text .box div {\n        -webkit-flex: 1 1 auto;\n        -ms-flex: 1 1 auto;\n        flex: 1 1 auto;\n        text-align: center;\n        color: #555;\n        margin-right: 8px; }\n        .color-picker .hsla-text .box div:last-child, .color-picker .rgba-text .box div:last-child {\n          margin-right: 0; }\n  .color-picker .hex-text {\n    width: 100%;\n    font-size: 11px;\n    padding: 4px 8px; }\n    .color-picker .hex-text .box {\n      padding: 0 24px 8px 8px; }\n      .color-picker .hex-text .box input {\n        -webkit-flex: 1 1 auto;\n        -ms-flex: 1 1 auto;\n        flex: 1 1 auto;\n        border: #a9a9a9 solid 1px;\n        padding: 1px; }\n      .color-picker .hex-text .box div {\n        -webkit-flex: 1 1 auto;\n        -ms-flex: 1 1 auto;\n        flex: 1 1 auto;\n        text-align: center;\n        color: #555;\n        float: left;\n        clear: left; }\n"
	
	/***/ }),
	/* 8 */
	/***/ (function(module, exports) {
	
	module.exports = "<div class=\"color-picker\" [style.visibility]=\"this.hidden || !show ? 'hidden' : 'visible'\" [style.height.px]=\"cpHeight\" [style.width.px]=\"cpWidth\" [style.top.px]=\"top\" [style.left.px]=\"left\" [style.position]=\"position\" #dialogPopup>\n    <div *ngIf=\"cpDialogDisplay=='popup'\" class=\"arrow arrow-{{cpPosition}}\" [style.top.px]=\"arrowTop\"></div>\n\n    <div [slider] [style.background-color]=\"hueSliderColor\" [rgX]=\"1\" [rgY]=\"1\" (newValue)=\"setSaturationAndBrightness($event)\" (dragStart)=\"onDragStart('saturation-lightness')\" (dragEnd)=\"onDragEnd('saturation-lightness')\" class=\"saturation-lightness\">\n        <div [style.left.px]=\"slider.s\" [style.top.px]=\"slider.v\" class=\"cursor\"></div>\n    </div>\n    <div class=\"box\">\n        <div class=\"left\">\n            <div class=\"selected-color-background\"></div>\n            <div [style.background-color]=\"selectedColor\" class=\"selected-color\"></div>\n        </div>\n        <div class=\"right\">\n            <div *ngIf=\"cpAlphaChannel==='disabled'\" style=\"height: 16px;\"></div>\n\n            <div [slider] [rgX]=\"1\" (newValue)=\"setHue($event)\" (dragStart)=\"onDragStart('hue')\" (dragEnd)=\"onDragEnd('hue')\" class=\"hue\" #hueSlider>\n                <div [style.left.px]=\"slider.h\" class=\"cursor\"></div>\n            </div>\n\n            <div [style.display]=\"cpAlphaChannel === 'disabled' ? 'none' : 'block'\" [slider] [style.background-color]=\"alphaSliderColor\" [rgX]=\"1\" (newValue)=\"setAlpha($event)\" (dragStart)=\"onDragStart('alpha')\" (dragEnd)=\"onDragEnd('alpha')\" class=\"alpha\" #alphaSlider>\n                <div [style.left.px]=\"slider.a\" class=\"cursor\"></div>\n            </div>\n        </div>\n    </div>\n\n    <div [style.display]=\"format !== 2 ? 'none' : 'block'\" class=\"hsla-text\">\n        <div class=\"box\">\n            <input [text] type=\"number\" pattern=\"[0-9]*\" min=\"0\" max=\"360\" [rg]=\"360\" (newValue)=\"setHue($event)\" [value]=\"hslaText.h\"/>\n            <input [text] type=\"number\" pattern=\"[0-9]*\" min=\"0\" max=\"100\" [rg]=\"100\" (newValue)=\"setSaturation($event)\" [value]=\"hslaText.s\"/>\n            <input [text] type=\"number\" pattern=\"[0-9]*\" min=\"0\" max=\"100\" [rg]=\"100\" (newValue)=\"setLightness($event)\" [value]=\"hslaText.l\"/>\n            <input *ngIf=\"cpAlphaChannel!=='disabled'\" [text] type=\"number\" pattern=\"[0-9]+([\\.,][0-9]{1,2})?\" min=\"0\" max=\"1\" step=\"0.1\" [rg]=\"1\" (newValue)=\"setA($event)\" [value]=\"hslaText.a\"/>\n        </div>\n        <div class=\"box\">\n            <div>H</div><div>S</div><div>L</div><div *ngIf=\"cpAlphaChannel!=='disabled'\">A</div>\n        </div>\n    </div>\n\n    <div [style.display]=\"format !== 1 ? 'none' : 'block'\" class=\"rgba-text\">\n        <div class=\"box\">\n            <input [text] type=\"number\" pattern=\"[0-9]*\" min=\"0\" max=\"255\" [rg]=\"255\" (newValue)=\"setR($event)\" [value]=\"rgbaText.r\"/>\n            <input [text] type=\"number\" pattern=\"[0-9]*\" min=\"0\" max=\"255\" [rg]=\"255\" (newValue)=\"setG($event)\" [value]=\"rgbaText.g\"/>\n            <input [text] type=\"number\" pattern=\"[0-9]*\" min=\"0\" max=\"255\" [rg]=\"255\" (newValue)=\"setB($event)\" [value]=\"rgbaText.b\"/>\n            <input *ngIf=\"cpAlphaChannel!=='disabled'\" [text] type=\"number\" pattern=\"[0-9]+([\\.,][0-9]{1,2})?\" min=\"0\" max=\"1\" step=\"0.1\" [rg]=\"1\" (newValue)=\"setA($event)\" [value]=\"rgbaText.a\"/>\n        </div>\n        <div class=\"box\">\n            <div>R</div><div>G</div><div>B</div><div *ngIf=\"cpAlphaChannel!=='disabled'\" >A</div>\n        </div>\n    </div>\n\n    <div [style.display]=\"format !== 0 ? 'none' : 'block'\" class=\"hex-text\">\n        <div class=\"box\">\n            <input [text] (newValue)=\"setHex($event)\" [value]=\"hexText\"/>\n        </div>\n        <div class=\"box\">\n            <div>Hex</div>\n        </div>\n    </div>\n\n    <div (click)=\"formatPolicy()\" class=\"type-policy\"></div>\n\n    <div *ngIf=\"cpPresetColors && cpPresetColors.length\" class=\"preset-area\">\n       <hr>\n\n       <div class=\"preset-label\">{{cpPresetLabel}}</div>\n\n       <div *ngFor=\"let color of cpPresetColors\" class=\"preset-color\" [style.backgroundColor]=\"color\" (click)=\"setColorFromString(color)\"></div>\n    </div>\n\n    <div *ngIf=\"cpOKButton || cpCancelButton\" class=\"button-area\">\n        <button *ngIf=\"cpOKButton\" type=\"button\" class=\"{{cpOKButtonClass}}\" (click)=\"oKColor($event)\">{{cpOKButtonText}}</button>\n        <button *ngIf=\"cpCancelButton\" type=\"button\" class=\"{{cpCancelButtonClass}}\" (click)=\"cancelColor($event)\">{{cpCancelButtonText}}</button>\n    </div>\n\n</div>\n"
	
	/***/ }),
	/* 9 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(6));
	
	
	/***/ }),
	/* 10 */
	/***/ (function(module, exports, __webpack_require__) {
	
	"use strict";
	
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var core_1 = __webpack_require__(0);
	var common_1 = __webpack_require__(11);
	var helpers_1 = __webpack_require__(4);
	var color_picker_service_1 = __webpack_require__(1);
	var color_picker_component_1 = __webpack_require__(2);
	var color_picker_directive_1 = __webpack_require__(5);
	var ColorPickerModule = (function () {
	    function ColorPickerModule() {
	    }
	    return ColorPickerModule;
	}());
	ColorPickerModule = __decorate([
	    core_1.NgModule({
	        imports: [common_1.CommonModule],
	        providers: [color_picker_service_1.ColorPickerService],
	        declarations: [color_picker_component_1.ColorPickerComponent, color_picker_directive_1.ColorPickerDirective, helpers_1.TextDirective, helpers_1.SliderDirective],
	        exports: [color_picker_directive_1.ColorPickerDirective],
	        entryComponents: [color_picker_component_1.ColorPickerComponent]
	    })
	], ColorPickerModule);
	exports.ColorPickerModule = ColorPickerModule;
	
	
	/***/ }),
	/* 11 */
	/***/ (function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_11__;
	
	/***/ })
	/******/ ]);
	});
	//# sourceMappingURL=ngx-color-picker.umd.js.map

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var branding_model_1 = __webpack_require__(200);
	var core_1 = __webpack_require__(3);
	var common_1 = __webpack_require__(22);
	var config_1 = __webpack_require__(60);
	var branding_service_1 = __webpack_require__(201);
	var instance_service_1 = __webpack_require__(500);
	var company_service_1 = __webpack_require__(501);
	var BrandingComponent = (function () {
	    function BrandingComponent(authService, locationService, translateService, instanceService, companyService, brandingService) {
	        this.authService = authService;
	        this.locationService = locationService;
	        this.translateService = translateService;
	        this.instanceService = instanceService;
	        this.companyService = companyService;
	        this.brandingService = brandingService;
	        this.instanceHashId = "";
	        this.companyHashId = "";
	        this.roleLevel = config_1.RoleLevel;
	    }
	    BrandingComponent.prototype.ngOnInit = function () {
	        this.pageName = "Branding";
	        // this.model = new BrandingModel();
	        this.popupMsg = this.translateService.instant("LblBrandingSavedSuccess");
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.InitFilter();
	    };
	    BrandingComponent.prototype.InitFilter = function () {
	        //if (this.authService.GetHighestRoleLevel() <= this.roleLevel.Instance) {
	        this.GetInstanceDropDownList(config_1.PermissionType.EDIT);
	        this.instanceHashId = "";
	        // }
	    };
	    BrandingComponent.prototype.OnSubmit = function () {
	        console.log(this.notificationFile);
	        var formData = new FormData();
	        if (this.notificationFile &&
	            this.notificationFile.nativeElement &&
	            this.notificationFile.nativeElement.files &&
	            this.notificationFile.nativeElement.files.length > 0) {
	            formData.append("notificationFile", this.notificationFile.nativeElement.files[0], this.notificationFile.nativeElement.files[0].name);
	        }
	        if (this.expandedWebMenuFile &&
	            this.expandedWebMenuFile.nativeElement &&
	            this.expandedWebMenuFile.nativeElement.files &&
	            this.expandedWebMenuFile.nativeElement.files.length > 0) {
	            formData.append("expandedWebMenuFile", this.expandedWebMenuFile.nativeElement.files[0], this.expandedWebMenuFile.nativeElement.files[0].name);
	        }
	        if (this.collapsedWebMenuFile &&
	            this.collapsedWebMenuFile.nativeElement &&
	            this.collapsedWebMenuFile.nativeElement.files &&
	            this.collapsedWebMenuFile.nativeElement.files.length > 0) {
	            formData.append("collapsedWebMenuFile", this.collapsedWebMenuFile.nativeElement.files[0], this.collapsedWebMenuFile.nativeElement.files[0].name);
	        }
	        if (this.mobileAppFile &&
	            this.mobileAppFile.nativeElement &&
	            this.mobileAppFile.nativeElement.files &&
	            this.mobileAppFile.nativeElement.files.length > 0) {
	            formData.append("mobileAppFile", this.mobileAppFile.nativeElement.files[0], this.mobileAppFile.nativeElement.files[0].name);
	        }
	        if (this.splashScreenFile &&
	            this.splashScreenFile.nativeElement &&
	            this.splashScreenFile.nativeElement.files &&
	            this.splashScreenFile.nativeElement.files.length > 0) {
	            formData.append("splashScreenFile", this.splashScreenFile.nativeElement.files[0], this.splashScreenFile.nativeElement.files[0].name);
	        }
	        if (this.model) {
	            this.model.instanceHashId = this.instanceHashId;
	            this.model.companyHashId = this.companyHashId;
	            formData.append("brandingFormData", JSON.stringify(this.model));
	        }
	        else {
	            formData.append("brandingFormData", JSON.stringify(new branding_model_1.BrandingModel()));
	        }
	        this.UploadBranding(formData);
	    };
	    BrandingComponent.prototype.GetBranding = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.brandingService
	            .GetBranding(this.instanceHashId, this.companyHashId)
	            .subscribe(function (res) {
	            console.log(res);
	            _this.model = res.data;
	            _this.isLoading = false;
	        }, function (error) {
	            console.log(error);
	            _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    BrandingComponent.prototype.UploadBranding = function (formData) {
	        var _this = this;
	        this.brandingService.UploadBranding(formData).subscribe(function (res) {
	            console.log(res);
	            if (res.data) {
	                _this.ShowSuccessPopup();
	                _this.errorModel = [];
	                _this.ClearFileInput();
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            console.log(error);
	            _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    // Helper Method
	    BrandingComponent.prototype.OnBackClick = function () {
	        this.locationService.back();
	    };
	    BrandingComponent.prototype.GetImageURL = function (imagePath) {
	        if (imagePath)
	            return config_1.WeGoConfig.API_SERVER_URL + imagePath;
	        else
	            return "";
	    };
	    BrandingComponent.prototype.GetBrandingColorList = function (brandingColorList, type) {
	        if (brandingColorList) {
	            return brandingColorList.filter(function (x) { return x.type == type; });
	        }
	        return new Array();
	    };
	    BrandingComponent.prototype.ClearFileInput = function () {
	        if (this.notificationFile && this.notificationFile.nativeElement) {
	            this.notificationFile.nativeElement.value = "";
	        }
	        if (this.expandedWebMenuFile && this.expandedWebMenuFile.nativeElement) {
	            this.expandedWebMenuFile.nativeElement.value = "";
	        }
	        if (this.collapsedWebMenuFile && this.collapsedWebMenuFile.nativeElement) {
	            this.collapsedWebMenuFile.nativeElement.value = "";
	        }
	        if (this.mobileAppFile && this.mobileAppFile.nativeElement) {
	            this.mobileAppFile.nativeElement.value = "";
	        }
	        if (this.splashScreenFile && this.splashScreenFile.nativeElement) {
	            this.splashScreenFile.nativeElement.value = "";
	        }
	    };
	    BrandingComponent.prototype.GetDefaultCompanySelection = function () {
	        if (this.authService.GetHighestRoleLevel() <= this.roleLevel.Instance) {
	            return "-";
	        }
	        else {
	            return (this.translateService.instant("LblSelect") +
	                " " +
	                this.translateService.instant("LblCompany"));
	        }
	    };
	    // End Helper Method
	    BrandingComponent.prototype.ngOnDestroy = function () { };
	    // Filter List
	    BrandingComponent.prototype.GetInstanceDropDownList = function (permissionType) {
	        var _this = this;
	        this.instanceService
	            .GetInstanceListDropdownForAddUpdatePage(this.pageName, permissionType)
	            .subscribe(function (res) {
	            _this.instanceList = res.data;
	            if (_this.instanceList && _this.instanceList.length > 0) {
	                if (!_this.instanceHashId && _this.instanceList.length == 1) {
	                    _this.instanceHashId = _this.instanceList[0].keyHash;
	                }
	                _this.OnInstanceChange();
	            }
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    BrandingComponent.prototype.GetCompanyDropDownList = function (instanceHashId) {
	        var _this = this;
	        this.companyService
	            .GetCompanyListDropdownForAddUpdatePage(this.pageName, config_1.PermissionType.EDIT, instanceHashId)
	            .subscribe(function (res) {
	            _this.companyList = res.data;
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    // End Filter List
	    // Event
	    BrandingComponent.prototype.OnInstanceChange = function () {
	        if (this.instanceHashId) {
	            this.GetCompanyDropDownList(this.instanceHashId);
	        }
	        else {
	            this.companyList = [];
	        }
	        this.companyHashId = "";
	        this.OnCompanyChange();
	    };
	    BrandingComponent.prototype.OnCompanyChange = function () {
	        if ((this.instanceHashId && this.authService.GetHighestRoleLevel() <= this.roleLevel.Instance) || this.companyHashId) {
	            this.GetBranding();
	        }
	        else {
	            this.model = null;
	        }
	        this.errorModel = [];
	        this.ClearFileInput();
	    };
	    // End Event
	    // Success Popup Event
	    BrandingComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    BrandingComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	        this.GetBranding();
	    };
	    BrandingComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	        this.GetBranding();
	    };
	    __decorate([
	        core_1.ViewChild("notificationFile"), 
	        __metadata('design:type', Object)
	    ], BrandingComponent.prototype, "notificationFile", void 0);
	    __decorate([
	        core_1.ViewChild("expandedWebMenuFile"), 
	        __metadata('design:type', Object)
	    ], BrandingComponent.prototype, "expandedWebMenuFile", void 0);
	    __decorate([
	        core_1.ViewChild("collapsedWebMenuFile"), 
	        __metadata('design:type', Object)
	    ], BrandingComponent.prototype, "collapsedWebMenuFile", void 0);
	    __decorate([
	        core_1.ViewChild("mobileAppFile"), 
	        __metadata('design:type', Object)
	    ], BrandingComponent.prototype, "mobileAppFile", void 0);
	    __decorate([
	        core_1.ViewChild("splashScreenFile"), 
	        __metadata('design:type', Object)
	    ], BrandingComponent.prototype, "splashScreenFile", void 0);
	    __decorate([
	        core_1.ViewChild("successPopup"), 
	        __metadata('design:type', Object)
	    ], BrandingComponent.prototype, "successPopup", void 0);
	    BrandingComponent = __decorate([
	        core_1.Component({
	            selector: "wego-branding",
	            template: __webpack_require__(502),
	            styles: [
	                "\n      .form-horizontal .control-label{\n        text-align: left;\n      }\n    "
	            ],
	            providers: [branding_service_1.BrandingService, instance_service_1.InstanceService, company_service_1.CompanyService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _b) || Object, (typeof (_c = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _c) || Object, (typeof (_d = typeof instance_service_1.InstanceService !== 'undefined' && instance_service_1.InstanceService) === 'function' && _d) || Object, (typeof (_e = typeof company_service_1.CompanyService !== 'undefined' && company_service_1.CompanyService) === 'function' && _e) || Object, (typeof (_f = typeof branding_service_1.BrandingService !== 'undefined' && branding_service_1.BrandingService) === 'function' && _f) || Object])
	    ], BrandingComponent);
	    return BrandingComponent;
	    var _a, _b, _c, _d, _e, _f;
	}());
	exports.BrandingComponent = BrandingComponent;


/***/ },
/* 200 */
/***/ function(module, exports) {

	"use strict";
	var BrandingModel = (function () {
	    function BrandingModel() {
	    }
	    return BrandingModel;
	}());
	exports.BrandingModel = BrandingModel;
	var BrandingColorList = (function () {
	    function BrandingColorList() {
	    }
	    return BrandingColorList;
	}());
	exports.BrandingColorList = BrandingColorList;


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var Rx_1 = __webpack_require__(202);
	var config_1 = __webpack_require__(60);
	var auth_service_1 = __webpack_require__(58);
	var http_1 = __webpack_require__(59);
	// Refer from https://stackoverflow.com/questions/35985347/how-to-upload-file-in-angular2
	var BrandingService = (function () {
	    function BrandingService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    BrandingService.prototype.GetBranding = function (instanceHashId, companyHashId) {
	        var getBrandingUrl = config_1.WeGoConfig.API_GET_BRANDING;
	        getBrandingUrl = getBrandingUrl + "?instanceHashId=" + instanceHashId
	            + "&companyHashId=" + companyHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getBrandingUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BrandingService.prototype.UploadBranding = function (formData) {
	        var _this = this;
	        return Rx_1.Observable.create(function (observer) {
	            var url = config_1.WeGoConfig.API_POST_UPDATE_BRANDING;
	            var xhr = new XMLHttpRequest();
	            var header = _this.authService.GetHeaderForFile();
	            xhr.onreadystatechange = function () {
	                if (xhr.readyState === 4) {
	                    if (xhr.status === 200) {
	                        console.log(xhr.response);
	                        observer.next(JSON.parse(xhr.response));
	                        observer.complete();
	                    }
	                    else {
	                        observer.error(xhr.status);
	                    }
	                }
	            };
	            xhr.open('POST', url, true);
	            for (var i = 0; i < header.length; i++) {
	                xhr.setRequestHeader(header[i]['name'], header[i]['value']);
	            }
	            xhr.send(formData);
	        });
	    };
	    BrandingService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], BrandingService);
	    return BrandingService;
	    var _a, _b;
	}());
	exports.BrandingService = BrandingService;


/***/ },
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var InstanceService = (function () {
	    function InstanceService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    InstanceService.prototype.GetInstanceList = function (input, customerHashId) {
	        var getInstanceUrl = config_1.WeGoConfig.API_GET_INSTANCE_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getInstanceUrl = getInstanceUrl + "?" + queryString;
	        }
	        if (customerHashId) {
	            getInstanceUrl = getInstanceUrl + "&customerHashId=" + customerHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInstanceUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InstanceService.prototype.ExportInstanceList = function (input, customerHashId) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var getInstanceUrl = config_1.WeGoConfig.API_EXPORT_INSTANCE_LIST + "?" + queryString;
	        if (customerHashId) {
	            getInstanceUrl = getInstanceUrl + "&customerHashId=" + customerHashId;
	        }
	        var headers = this.authService.GetHeader("text/csv");
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getInstanceUrl, options);
	    };
	    InstanceService.prototype.GetInstanceByHashId = function (instanceHashId) {
	        var getInstanceUrl = config_1.WeGoConfig.API_GET_INSTANCE_BY_HASH + "?instanceHashId=" + instanceHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInstanceUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InstanceService.prototype.GetInstanceByCompanyHashId = function (companyHashId) {
	        var getInstanceUrl = config_1.WeGoConfig.API_GET_INSTANCE_BY_COMPANY_HASH + "?companyHashId=" + companyHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInstanceUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InstanceService.prototype.GetInstanceBasicDetail = function (instanceHashId) {
	        var getInstanceUrl = config_1.WeGoConfig.API_GET_INSTANCE_BASIC_DETAIL +
	            "?instanceHashId=" +
	            instanceHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInstanceUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    // public CloneInstance(
	    //   cloneEntityModel : CloneEntityModel
	    // ): Observable<IAPIResponse> {
	    //   let getVehicleUrl =
	    //     WeGoConfig.API_CLONE_INSTANCE +
	    //     "?existingInstanceHashId=" +
	    //     existingInstanceHashId +
	    //     "&newInstanceName=" +
	    //     newInstanceName;
	    //   let headers = this.authService.GetHeader();
	    //   let options = new RequestOptions({ headers: headers });
	    //   return this.http
	    //     .get(getVehicleUrl, options)
	    //     .map(this.authService.HandleAPIResponse)
	    //     .catch(this.authService.HandleAPIError);
	    // }
	    InstanceService.prototype.CloneInstance = function (cloneEntityModel) {
	        var body = cloneEntityModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_CLONE_INSTANCE_DETAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    // public CloneInstance(cloneEntityModel: CloneEntityModel): Observable<IAPIResponse> {
	    //   let body = cloneEntityModel;
	    //   let headers = this.authService.GetHeader();
	    //   let options = new RequestOptions({ headers: headers });
	    //   let url= WeGoConfig.API_CLONE_INSTANCE_DETAIL;
	    //   return this.http.get(url, body, options)
	    //     .map(this.authService.HandleAPIResponse)
	    //     .catch(this.authService.HandleAPIError);
	    // }
	    // public CloneInstance(cloneEntityModel: any): Observable<IAPIResponse> {
	    //   let url= WeGoConfig.API_CLONE_INSTANCE_DETAIL + "?intanceHashId=" + intanceHashId;
	    //   let headers = this.authService.GetHeader();
	    //   let options = new RequestOptions({ headers: headers });
	    //   return this.http
	    //     .get(getInstanceUrl, options)
	    //     .map(this.authService.HandleAPIResponse)
	    //     .catch(this.authService.HandleAPIError);
	    // }
	    InstanceService.prototype.AddNewInstance = function (bodyData) {
	        var body = bodyData;
	        var headers = this.authService.GetHeader("application/json", "application/x-www-form-urlencoded");
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_INSTANCE_DETAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InstanceService.prototype.DeleteInstance = function (intanceHashId) {
	        var getInstanceUrl = config_1.WeGoConfig.API_DELETE_INSTANCE + "?intanceHashId=" + intanceHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInstanceUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InstanceService.prototype.GetImportAllowedInstance = function () {
	        var getInstanceUrl = config_1.WeGoConfig.API_GET_IMPORT_ALLOWED_INSTANCE_LIST;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInstanceUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InstanceService.prototype.CheckIsAllowToImportPerson = function () {
	        var getInstanceUrl = config_1.WeGoConfig.API_GET_IMPORT_ALLOWED_TO_USER;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInstanceUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InstanceService.prototype.CheckIsAllowToBatchUploadPerson = function () {
	        var getInstanceUrl = config_1.WeGoConfig.API_GET_BATCH_UPLOAD_ALLOW_TO_USER;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInstanceUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InstanceService.prototype.IsOdometerEnabled = function (instanceHashId) {
	        var getInactiveCompanyAdminUrl = config_1.WeGoConfig.API_GET_ODOMETER_ENABLED + "?instanceHashId=" + instanceHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInactiveCompanyAdminUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InstanceService.prototype.GetBatchUploadDetailByHashId = function (instanceHashId) {
	        var getBatchUploadDetail = config_1.WeGoConfig.API_GET_BATCH_UPLOAD_DETAIL_BY_HASH +
	            "?instanceHashId=" +
	            instanceHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getBatchUploadDetail, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InstanceService.prototype.GetInstanceForBatchUpload = function (input) {
	        var getInstanceUrl = config_1.WeGoConfig.API_GET_INSTANCES_FOR_BATCH_UPLOAD;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getInstanceUrl = getInstanceUrl + "?" + queryString;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInstanceUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InstanceService.prototype.IsDirectDebitEnabledForCompany = function (instanceHashId) {
	        var getInactiveCompanyAdminUrl = config_1.WeGoConfig.API_GET_DIRECTDEBIT_ENABLED_COMPANY +
	            "?instanceHashId=" +
	            instanceHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInactiveCompanyAdminUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InstanceService.prototype.IsDirectDebitEnabled = function (instanceHashId) {
	        var getInactiveCompanyAdminUrl = config_1.WeGoConfig.API_GET_DIRECTDEBIT_ENABLED +
	            "?instanceHashId=" +
	            instanceHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInactiveCompanyAdminUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InstanceService.prototype.IsTwoFaEnabled = function (instanceHashId) {
	        var getInactiveCompanyAdminUrl = config_1.WeGoConfig.API_GET_TWOFA_ENABLED +
	            "?instanceHashId=" +
	            instanceHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInactiveCompanyAdminUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InstanceService.prototype.GetInstanceLanguage = function (instanceHashId) {
	        var getInactiveCompanyAdminUrl = config_1.WeGoConfig.API_GET_INSTANCE_LANGUAGE +
	            "?instanceHashId=" +
	            instanceHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInactiveCompanyAdminUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InstanceService.prototype.IsNIFNumberEnabled = function (instanceHashId) {
	        var getNIFNumberEnabledUrl = config_1.WeGoConfig.API_GET_NIF_NUMBER_ENABLED +
	            "?instanceHashId=" +
	            instanceHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getNIFNumberEnabledUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InstanceService.prototype.GetCountryCode = function (instanceHashId) {
	        var getCountryCodeURL = config_1.WeGoConfig.API_GET_COUNTRYCODE +
	            "?instanceHashId=" +
	            instanceHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getCountryCodeURL, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InstanceService.prototype.PaymentSettingRequiredOnInstance = function (instanceHashId) {
	        var getInactiveCompanyAdminUrl = config_1.WeGoConfig.API_GET_PAYMENTSETTING_REQUIRED_ON_INSTANCE +
	            "?instanceHashId=" +
	            instanceHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInactiveCompanyAdminUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InstanceService.prototype.ResetTwoFaCookies = function (intanceHashId) {
	        var getInstanceUrl = config_1.WeGoConfig.API_RESET_TWOFA_COOKIES_INSTANCE + "?intanceHashId=" + intanceHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInstanceUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InstanceService.prototype.ResetTwoFaKeys = function (intanceHashId) {
	        var getInstanceUrl = config_1.WeGoConfig.API_RESET_TWOFA_KEYS_INSTANCE + "?intanceHashId=" + intanceHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInstanceUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InstanceService.prototype.GetDropdownInstanceList = function (moduleName, customerHashId) {
	        var getInstanceUrl;
	        switch (moduleName) {
	            case "Vehicle_Occupancy_Report":
	                getInstanceUrl =
	                    config_1.WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_VEHICLEOCCUPANCYREPORT;
	                break;
	            case "Revenue_Per_Vehicle_Report":
	                getInstanceUrl =
	                    config_1.WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_REVENUEVEHICLEREPORT;
	                break;
	            case "Maintenance_Planning_Report":
	                getInstanceUrl =
	                    config_1.WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_MAINTENCEPLANNINGREPORT;
	                break;
	            case "TripData_Report":
	                getInstanceUrl =
	                    config_1.WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_TRIPDATAREPORT;
	                break;
	            case "Admin_Dashboard":
	                getInstanceUrl = config_1.WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_DASHBOARD;
	                break;
	            case "Error_Log":
	                getInstanceUrl = config_1.WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_ERRORLOG;
	                break;
	            case "Terms_And_Condition":
	                getInstanceUrl = config_1.WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_TERMSANDCONDITIONS;
	                break;
	            case "Cost_Center_Report":
	                getInstanceUrl =
	                    config_1.WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_FOR_COST_CENTER_REPORT;
	                break;
	            case "Kick_Back_Report":
	                getInstanceUrl =
	                    config_1.WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_KICKBACKREPORT;
	                break;
	            default:
	                getInstanceUrl =
	                    config_1.WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_VEHICLEOCCUPANCYREPORT;
	                break;
	        }
	        if (customerHashId) {
	            getInstanceUrl = getInstanceUrl + "?customerHashId=" + customerHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInstanceUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InstanceService.prototype.GetInstanceListDropdownForAddUpdatePage = function (pageName, permissionType, customerHashId) {
	        var getInstanceUrl;
	        switch (pageName) {
	            case "Vehicle_Attribute_Category":
	                getInstanceUrl =
	                    config_1.WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_CATEGORY_ATTRIBUTE;
	                break;
	            case "Vehicle_Attribute":
	                getInstanceUrl =
	                    config_1.WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_VEHICLE_ATTRIBUTE;
	                break;
	            case "Template":
	                getInstanceUrl = config_1.WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_TEMPLATE;
	                break;
	            case "SignupFormConfig":
	                getInstanceUrl = config_1.WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_SIGNUPCONFIG;
	                break;
	            case "person":
	                getInstanceUrl = config_1.WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_PERSON;
	                break;
	            case "company":
	                getInstanceUrl = config_1.WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_COMPANY;
	                break;
	            case "Organization":
	                getInstanceUrl = config_1.WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_ORGANIZATION;
	                break;
	            case "Branding":
	                getInstanceUrl = config_1.WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_BRANDING;
	                break;
	            case "ErrorEsclation":
	                getInstanceUrl =
	                    config_1.WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_ERRORESCLATION;
	                break;
	            case "Terms_And_Condition":
	                getInstanceUrl =
	                    config_1.WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_TERMSANDCONDITIONS;
	                break;
	            case "invoice_update":
	                getInstanceUrl =
	                    config_1.WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_INVOICE_UPDATE;
	                break;
	            case "Pre Post Trip Question":
	                getInstanceUrl =
	                    config_1.WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_FOR_PRE_POST_TRIP_QUESTION;
	                break;
	            default:
	                getInstanceUrl = config_1.WeGoConfig.API_GET_INSTANCE_LIST;
	                break;
	        }
	        if (permissionType) {
	            getInstanceUrl = getInstanceUrl + "?permissionType=" + permissionType;
	        }
	        if (customerHashId) {
	            getInstanceUrl = getInstanceUrl + "&customerHashId=" + customerHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInstanceUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InstanceService.prototype.GetDropdownTimeZoneList = function (input) {
	        var getInstanceTimeZoneListUrl = config_1.WeGoConfig.API_GET_DROPDOWN_INSTANCE_TIMEZONE_LIST;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInstanceTimeZoneListUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InstanceService.prototype.GetSharedVehicleGroupList = function (instanceHashId) {
	        var getSVGUrl = config_1.WeGoConfig.API_GET_SHAREDVEHICLEGROUP_DETAIL + "?instanceHashId=" + instanceHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getSVGUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InstanceService.prototype.GetOrganizationListBySharedVehicleGroup = function (instanceHashId, sharedVehicleGroupHashId) {
	        var getSVGUrl = config_1.WeGoConfig.API_GET_ORGANIZATION_DETAIL + "?instanceHashId=" + instanceHashId + "&sharedVehicleGroupHashId=" + sharedVehicleGroupHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getSVGUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InstanceService.prototype.GetSubscriptionListByOrganization = function (organizationHashId) {
	        var getSubscriptionUrl = config_1.WeGoConfig.API_GET_SUBSCRIPTION_LIST_FOR_ORGANIZATION + "?organizationHashId=" + organizationHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getSubscriptionUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InstanceService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], InstanceService);
	    return InstanceService;
	    var _a, _b;
	}());
	exports.InstanceService = InstanceService;


/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var CompanyService = (function () {
	    function CompanyService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    CompanyService.prototype.GetCompanyList = function (input) {
	        var getCompanyUrl = config_1.WeGoConfig.API_GET_COMPANY_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getCompanyUrl = getCompanyUrl + "?" + queryString;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getCompanyUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CompanyService.prototype.ExportCompanyList = function (input) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var getUrl = config_1.WeGoConfig.API_EXPORT_COMPANY_LIST + "?" + queryString;
	        var headers = this.authService.GetHeader("text/csv");
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getUrl, options);
	    };
	    CompanyService.prototype.GetCompanyByHashId = function (companyHashId) {
	        var getCompnayUrl = config_1.WeGoConfig.API_GET_COMPNAY_BY_HASH + "?companyHashId=" + companyHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getCompnayUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CompanyService.prototype.GetCompanyBasicDetail = function (companyHashId) {
	        var getCompnayUrl = config_1.WeGoConfig.API_GET_COMPANY_BASIC_DETAIL +
	            "?companyHashId=" +
	            companyHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getCompnayUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CompanyService.prototype.AddCompany = function (companyModel) {
	        var body = companyModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_COMPANY_DETAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CompanyService.prototype.DeleteCompany = function (selectedCompanyList) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_DELETE_COMPANY, selectedCompanyList, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CompanyService.prototype.UpdateCompanyContactPerson = function (companyHashId, personHashId) {
	        var getComapanyUrl = config_1.WeGoConfig.API_UPDATE_COMPANY_CONTACT_PERSON +
	            "?companyHashId=" +
	            companyHashId +
	            "&personHashId=" +
	            personHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getComapanyUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CompanyService.prototype.GetPersonListByCompanyId = function (companyMasterHashId, input) {
	        var getPersonUrl = config_1.WeGoConfig.API_GET_PERSON_LIST_BY_COMPANY_ID;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getPersonUrl =
	                getPersonUrl +
	                    "?" +
	                    queryString +
	                    "&companyMasterHashId=" +
	                    companyMasterHashId;
	        }
	        else {
	            getPersonUrl =
	                getPersonUrl + "?companyMasterHashId=" + companyMasterHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getPersonUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CompanyService.prototype.GetPersonListForContactPerson = function (companyMasterHashId, input) {
	        var getPersonUrl = config_1.WeGoConfig.API_GET_COMPANY_CONATACT_PERSON_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getPersonUrl =
	                getPersonUrl +
	                    "?" +
	                    queryString +
	                    "&companyMasterHashId=" +
	                    companyMasterHashId;
	        }
	        else {
	            getPersonUrl =
	                getPersonUrl + "?companyMasterHashId=" + companyMasterHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getPersonUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CompanyService.prototype.RemocveCompanyContactPerson = function (companyHashId) {
	        var getComapanyUrl = config_1.WeGoConfig.API_REMOVE_COMPANY_CONTACT_PERSON +
	            "?companyHashId=" +
	            companyHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getComapanyUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CompanyService.prototype.InActiveCompanyAdmin = function (companyAdminHashId) {
	        var getInactiveCompanyAdminUrl = config_1.WeGoConfig.API_GET_INACTIVE_COMPANY_ADMIN +
	            "?companyAdminHashId=" +
	            companyAdminHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInactiveCompanyAdminUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CompanyService.prototype.IsGeofenceEnables = function (companyHashId) {
	        var getInactiveCompanyAdminUrl = config_1.WeGoConfig.API_GET_GEOFENCE + "?companyHashId=" + companyHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInactiveCompanyAdminUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CompanyService.prototype.IsOdometerConfigEnabled = function (companyHashId) {
	        var getInactiveCompanyAdminUrl = config_1.WeGoConfig.API_GET_ODOMETER_CONFIG + "?companyHashId=" + companyHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInactiveCompanyAdminUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CompanyService.prototype.IsTwoFaEnabled = function (companyHashId) {
	        var getInactiveCompanyAdminUrl = config_1.WeGoConfig.API_GET_TWOFA_ENABLED_COMPANY + "?companyHashId=" + companyHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInactiveCompanyAdminUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CompanyService.prototype.GetInstanceLanguage = function (companyHashId) {
	        var getInactiveCompanyAdminUrl = config_1.WeGoConfig.API_GET_INSTANCE_LANGUAGE_BY_COMPANY +
	            "?companyHashId=" +
	            companyHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInactiveCompanyAdminUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CompanyService.prototype.GetLocationMode = function (companyHashId) {
	        var getInactiveCompanyAdminUrl = config_1.WeGoConfig.API_GET_LOCATION_MODE + "?companyHashId=" + companyHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInactiveCompanyAdminUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CompanyService.prototype.GetCompanybyInstance = function (instanceHashId) {
	        var getCompanyUrl = config_1.WeGoConfig.API_GET_COMPANY_BY_INSTANCE +
	            "?instanceHashId=" +
	            instanceHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getCompanyUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CompanyService.prototype.GetCompanyByInstance = function (instanceHashId) {
	        var getCompanyUrl = config_1.WeGoConfig.API_GET_COMPANY_BY_INSTANCE +
	            "?instanceHashId=" +
	            instanceHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getCompanyUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CompanyService.prototype.GetCompanybyInstanceHashId = function (input, instanceHashId) {
	        var queryString = this.authService.HandleAPIListInput(input);
	        var getCompanyUrl = config_1.WeGoConfig.API_GET_COMPANY_BY_INSTANCEHASHID +
	            "?" +
	            queryString +
	            "&instanceHashId=" +
	            instanceHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getCompanyUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CompanyService.prototype.GetDropdownCompanyList = function (reportName, instanceHashId) {
	        var getCompanyUrl;
	        // getCompanyUrl = WeGoConfig.API_GET_COMPANY_LIST;
	        switch (reportName) {
	            case "Vehicle_Occupancy_Report":
	                getCompanyUrl =
	                    config_1.WeGoConfig.API_GET_DROPDOWN_COMPANY_LIST_VEHICLEOCCUPANCYREPORT;
	                break;
	            case "Revenue_Per_Vehicle_Report":
	                getCompanyUrl =
	                    config_1.WeGoConfig.API_GET_DROPDOWN_COMPANY_LIST_REVENUEVEHICLEREPORT;
	                break;
	            case "Maintenance_Planning_Report":
	                getCompanyUrl =
	                    config_1.WeGoConfig.API_GET_DROPDOWN_COMPANY_LIST_MAINTENCEPLANNINGREPORT;
	                break;
	            case "TripData_Report":
	                getCompanyUrl = config_1.WeGoConfig.API_GET_DROPDOWN_COMPANY_LIST_TRIPDATAREPORT;
	                break;
	            case "Admin_Dashboard":
	                getCompanyUrl = config_1.WeGoConfig.API_GET_DROPDOWN_COMPANY_LIST_DASHBOARD;
	                break;
	            case "Kick_Back_Report":
	                getCompanyUrl = config_1.WeGoConfig.API_GET_DROPDOWN_COMAPNY_LIST_KICKBACKREPORT;
	                break;
	            case "Cost_Center_Report":
	                getCompanyUrl =
	                    config_1.WeGoConfig.API_GET_DROPDOWN_COMPANY_LIST_FOR_COST_CENTER_REPORT;
	                break;
	            default:
	                getCompanyUrl =
	                    config_1.WeGoConfig.API_GET_DROPDOWN_COMPANY_LIST_VEHICLEOCCUPANCYREPORT;
	                break;
	        }
	        getCompanyUrl = getCompanyUrl + "?instanceHashId=" + instanceHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getCompanyUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    // public GetCompanyListDropdownForAddUpdatePage1(pageName: string, permissionType: string, instanceHashId?: string): Observable<IAPIResponse> {
	    //     let getCompanyUrl: string;
	    //     switch (pageName) {
	    //         case "SharedVehicleGroup":
	    //             getCompanyUrl = WeGoConfig.API_GET_DROPDOWN_COMPANY_LIST_SVG;
	    //             break;
	    //         case "Organization":
	    //             getCompanyUrl = WeGoConfig.API_GET_DROPDOWN_COMPANY_LIST_ORGANIZATION;
	    //             break;
	    //         case "Vehicle":
	    //             getCompanyUrl = WeGoConfig.API_GET_DROPDOWN_COMPANY_LIST_VEHICLE;
	    //             break;
	    //         // case "person":
	    //         //   getInstanceUrl = WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_PERSON;
	    //         //   break;
	    //         default:
	    //             getCompanyUrl = WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_VEHICLEOCCUPANCYREPORT;
	    //             break;
	    //     }
	    CompanyService.prototype.GetDropdownCompanyListByInstanceIdList = function (reportName, permissionType, instanceHashIds) {
	        var getCompanyUrl;
	        switch (reportName) {
	            case "Terms_And_Condition":
	                getCompanyUrl = config_1.WeGoConfig.API_GET_DROPDOWN_COMPANY_LIST_BY_INSTANCE_LIST_TERMS_AND_CONDITION;
	                break;
	        }
	        if (permissionType) {
	            getCompanyUrl = getCompanyUrl + '?permissionType=' + permissionType;
	        }
	        var queryString = '';
	        instanceHashIds.forEach(function (element) {
	            queryString += "&instanceHashIdList=" + element;
	        });
	        getCompanyUrl = getCompanyUrl + queryString;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getCompanyUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CompanyService.prototype.ResetTwoFaCookies = function (companyHashId) {
	        var getInstanceUrl = config_1.WeGoConfig.API_RESET_TWOFA_COOKIES_COMPANY + "?companyHashId=" + companyHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInstanceUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CompanyService.prototype.ResetTwoFaKeys = function (companyHashId) {
	        var getInstanceUrl = config_1.WeGoConfig.API_RESET_TWOFA_KEYS_COMPANY + "?companyHashId=" + companyHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInstanceUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CompanyService.prototype.GetCompanyListDropdownForAddUpdatePage = function (pageName, permissionType, instanceHashId, customerHashId) {
	        var getCompanyUrl;
	        switch (pageName) {
	            case "SharedVehicleGroup":
	                getCompanyUrl = config_1.WeGoConfig.API_GET_DROPDOWN_COMPANY_LIST_SVG;
	                break;
	            case "Organization":
	                getCompanyUrl = config_1.WeGoConfig.API_GET_DROPDOWN_COMPANY_LIST_ORGANIZATION;
	                break;
	            case "Branding":
	                getCompanyUrl = config_1.WeGoConfig.API_GET_DROPDOWN_COMPANY_LIST_BRANDING;
	                break;
	            case "Vehicle":
	                getCompanyUrl = config_1.WeGoConfig.API_GET_DROPDOWN_COMPANY_LIST_VEHICLE;
	                break;
	            case "Template":
	                getCompanyUrl = config_1.WeGoConfig.API_GET_DROPDOWN_COMPANY_LIST_TEMPLATE;
	                break;
	            case "Terms_And_Condition":
	                getCompanyUrl = config_1.WeGoConfig.API_GET_DROPDOWN_COMPANY_LIST_TERMS_AND_CONDITION;
	                break;
	            case "invoice_update":
	                getCompanyUrl = config_1.WeGoConfig.API_GET_DROPDOWN_COMPANY_LIST_INVOICE_UPDATE;
	                break;
	            case "Pre Post Trip Question":
	                getCompanyUrl =
	                    config_1.WeGoConfig.API_GET_DROPDOWN_COMPANY_LIST_PRE_POST_TRIP_QUESTION;
	                break;
	            default:
	                getCompanyUrl = config_1.WeGoConfig.API_GET_COMPANY_LIST;
	                break;
	        }
	        if (permissionType) {
	            getCompanyUrl = getCompanyUrl + '?permissionType=' + permissionType;
	        }
	        if (instanceHashId) {
	            getCompanyUrl = getCompanyUrl + "&instanceHashId=" + instanceHashId;
	        }
	        if (customerHashId) {
	            getCompanyUrl = getCompanyUrl + "&customerHashId=" + customerHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getCompanyUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CompanyService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], CompanyService);
	    return CompanyService;
	    var _a, _b;
	}());
	exports.CompanyService = CompanyService;


/***/ },
/* 502 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ 'LblBranding' | translate }}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li class=\"active\"> {{ 'LblBranding' | translate }} </li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-sm-12\">\r\n        <form (ngSubmit)=\"OnSubmit()\" #brandingForm=\"ngForm\">\r\n          <!--General Configuration-->\r\n          <div class=\"row col-md-12\">\r\n            <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Instance\" class=\"form-group col-md-4\">\r\n              <label>\r\n                <span class=\"text text-danger\">*</span>{{ 'LblInstance' | translate }}</label>\r\n              <select [(ngModel)]=\"instanceHashId\" name=\"instance\" class=\"form-control\" (change)=\"OnInstanceChange()\">\r\n                <option value=\"\" [selected]=\"selected\">{{ 'LblSelect' | translate }} {{ 'LblInstance' | translate }}</option>\r\n                <option *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.WeGo\" value=\"0\">{{'LblWeGoDefault' | translate}} </option>\r\n                <option *ngFor=\"let inst of instanceList\" [ngValue]='inst.keyHash'>{{inst.value}}</option>\r\n              </select>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'InstanceHashId' }}</span>\r\n            </div>\r\n\r\n            <div class=\"form-group col-md-4\">\r\n              <label>\r\n                <span class=\"text text-danger\"></span>{{ 'LblCompany' | translate }}</label>\r\n              <select [(ngModel)]=\"companyHashId\" name=\"company\" class=\"form-control\" (change)=\"OnCompanyChange()\">\r\n                <option value=\"\" [selected]=\"selected\">{{ GetDefaultCompanySelection() }}</option>\r\n                <option *ngFor=\"let company of companyList\" [ngValue]='company.keyHash'>{{company.value}}</option>\r\n              </select>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'CompanyHashId' }}</span>\r\n            </div>\r\n          </div>\r\n          <!--End General Configuration-->\r\n\r\n          <div *ngIf=\"model\">\r\n            <!--Logos-->\r\n            <div class=\"row col-md-12\">\r\n              <fieldset class=\"col-md-12\">\r\n                <legend class=\"legendStyle\">\r\n                  {{ 'LblLogo' | translate }}\r\n                </legend>\r\n                <div class=\"clearfix\"></div>\r\n\r\n                <div class=\"row\">\r\n                  <div class=\"form-group col-sm-3\">\r\n                    <label>\r\n                      {{ 'LblEmailNotificationInvoiceTemplate' | translate }}</label>\r\n                    <input #notificationFile type=\"file\" name=\"notificationFile\" accept=\"image/x-png,image/png,image/gif,image/jpeg\" style=\"width: 100%;\"\r\n                    />\r\n                    <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'notificationFile' }}</span>\r\n                  </div>\r\n                  <div class=\"form-group col-sm-9\">\r\n                    <img [src]=\"GetImageURL(model?.notificationFile)\" class=\"img-thumbnail\" alt=\"No Image Preview\" style=\"max-height: 100px;\">\r\n                  </div>\r\n                </div>\r\n                <div class=\"row\">\r\n                  <div class=\"form-group col-sm-3\">\r\n                    <label>\r\n                      {{ 'LblExpandedWebMenu' | translate }}</label>\r\n                    <input #expandedWebMenuFile type=\"file\" name=\"expandedWebMenuFile\" accept=\"image/x-png,image/png,image/gif,image/jpeg\" style=\"width: 100%;\"\r\n                    />\r\n                    <span class=\"text-info\">{{ 'LblPreferableImageSize' | translate }} : {{'LblWebBrandingExapandImageSize' | translate}}</span>\r\n                    <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'expandedWebMenuFile' }}</span>\r\n                  </div>\r\n                  <div class=\"form-group col-sm-9\">\r\n                    <img [src]=\"GetImageURL(model?.expandedWebMenuFile)\" class=\"img-thumbnail\" alt=\"No Image Preview\" style=\"max-height: 100px;\">\r\n                  </div>\r\n                </div>\r\n                <div class=\"row\">\r\n                  <div class=\"form-group col-sm-3\">\r\n                    <label>\r\n                      {{ 'LblCollapsedWebMenu' | translate }}</label>\r\n                    <input #collapsedWebMenuFile type=\"file\" name=\"collapsedWebMenuFile\" accept=\"image/x-png,image/png,image/gif,image/jpeg\"\r\n                      style=\"width: 100%;\" />\r\n                    <span class=\"text-info\">{{ 'LblPreferableImageSize' | translate }} : {{'LblWebBrandingCollapseImageSize' | translate}}</span>\r\n                    <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'collapsedWebMenuFile' }}</span>\r\n                  </div>\r\n                  <div class=\"form-group col-sm-9\">\r\n                    <img [src]=\"GetImageURL(model?.collapsedWebMenuFile)\" class=\"img-thumbnail\" alt=\"No Image Preview\" style=\"max-height: 100px;\">\r\n                  </div>\r\n                </div>\r\n                <div class=\"row\">\r\n                  <div class=\"form-group col-sm-3\">\r\n                    <label>\r\n                      {{ 'LblMobileApp' | translate }}</label>\r\n                    <input #mobileAppFile type=\"file\" name=\"mobileAppFile\" accept=\"image/x-png,image/png,image/gif,image/jpeg\" style=\"width: 100%;\"\r\n                    />\r\n                    <span class=\"text-info\">{{ 'LblPreferableImageSize' | translate }} : {{'LblMobileBrandingImageSize' | translate}}</span>\r\n                    <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'mobileAppFile' }}</span>\r\n                  </div>\r\n                  <div class=\"form-group col-sm-9\">\r\n                    <img [src]=\"GetImageURL(model?.mobileAppFile)\" class=\"img-thumbnail\" alt=\"No Image Preview\" style=\"max-height: 100px;\">\r\n                  </div>\r\n                </div>\r\n                <!-- <div [hidden]=\"authService.IsCompanyAdmin() || companyHashId\" class=\"row\"> -->\r\n                <div class=\"row\">\r\n                  <div class=\"form-group col-sm-3\">\r\n                    <label>{{ 'LblSplashScreen' | translate }}</label>\r\n                    <input #splashScreenFile type=\"file\" name=\"mobileAppFile\" accept=\"image/x-png,image/png,image/gif,image/jpeg\" style=\"width: 100%;\"\r\n                    />\r\n                    <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'splashScreenFile' }}</span>\r\n                  </div>\r\n                  <div class=\"form-group col-sm-9\">\r\n                    <img [src]=\"GetImageURL(model?.splashScreenFile)\" class=\"img-thumbnail\" alt=\"No Image Preview\" style=\"max-height: 200px;\">\r\n                  </div>\r\n                </div>\r\n              </fieldset>\r\n            </div>\r\n            <!--End Logos-->\r\n\r\n            <div class=\"row col-md-12\">\r\n              <!--Web Application-->\r\n              <fieldset class=\"col-md-6\">\r\n                <legend class=\"legendStyle\">\r\n                  <span class=\"text text-danger\">*</span> {{ 'LblWebApplication' | translate }}\r\n                </legend>\r\n                <div class=\"clearfix\"></div>\r\n                <div class=\"form-horizontal\">\r\n                  <div *ngFor=\"let item of GetBrandingColorList(model?.brandingColorList, 'BACKOFFICE')\" class=\"col-sm-12\">\r\n                    <div class=\"form-group\">\r\n                      <label class=\"control-label col-sm-9\">{{ item.template | translate }}</label>\r\n                      <div class=\"input-group col-sm-3\">\r\n                        <span class=\"input-group-addon\">\r\n                          <span [style.background]=\"item.color\">&nbsp;&nbsp;&nbsp;&nbsp;</span>\r\n                        </span>\r\n                        <input readonly name=\"topBarMenuItem\" type=\"text\" class=\"form-control\" [(colorPicker)]=\"item.color\" [cpPosition]=\"'bottom'\"\r\n                          [cpPositionRelativeToArrow]=\"'false'\" [cpPositionOffset]=\"'-100%'\" [value]=\"item.color\">\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </fieldset>\r\n              <!--End Web Application-->\r\n              <!--Mobile Application-->\r\n              <fieldset class=\"col-md-6\">\r\n                <legend class=\"legendStyle\">\r\n                  <span class=\"text text-danger\">*</span> {{ 'LblMobileApplication' | translate }}\r\n                </legend>\r\n                <div class=\"clearfix\"></div>\r\n                <div class=\"form-horizontal\">\r\n                  <div *ngFor=\"let item of GetBrandingColorList(model?.brandingColorList, 'MOBILE')\" class=\"col-sm-12\">\r\n                    <div class=\"form-group\">\r\n                      <label class=\"control-label col-sm-9\">{{ item.template | translate }}</label>\r\n                      <div class=\"input-group col-sm-3\">\r\n                        <span class=\"input-group-addon\">\r\n                          <span [style.background]=\"item.color\">&nbsp;&nbsp;&nbsp;&nbsp;</span>\r\n                        </span>\r\n                        <input readonly name=\"topBarMenuItem\" type=\"text\" class=\"form-control\" [(colorPicker)]=\"item.color\" [cpPosition]=\"'bottom'\"\r\n                          [cpPositionRelativeToArrow]=\"'false'\" [cpPositionOffset]=\"'-100%'\" [value]=\"item.color\">\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </fieldset>\r\n              <!--End Mobile Application-->\r\n            </div>\r\n\r\n            <!--Update Button-->\r\n            <div class=\"row no-margin\">\r\n              <div class=\"col-sm-12\">\r\n                <hr>\r\n                <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnBackClick()\">{{ 'LblCancel' | translate }}</a> &nbsp;&nbsp;\r\n                <button class=\"btn btn-green\" type=\"submit\">{{ 'LblSave' | translate }}</button>\r\n              </div>\r\n            </div>\r\n            <!--End Update Button-->\r\n          </div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>";

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var config_1 = __webpack_require__(60);
	var auth_service_1 = __webpack_require__(58);
	var vehicle_occupancy_service_1 = __webpack_require__(504);
	var core_1 = __webpack_require__(3);
	var VehicleOccupancy = (function () {
	    function VehicleOccupancy(authService, vehicleOccupancyService) {
	        this.authService = authService;
	        this.vehicleOccupancyService = vehicleOccupancyService;
	        this.isValidSearch = false;
	        this.roleLevel = config_1.RoleLevel;
	    }
	    VehicleOccupancy.prototype.ngOnInit = function () {
	        this.reportName = "Vehicle_Occupancy_Report";
	        this.itemPerPageList = config_1.WeGoConfig.GRID_PAGGING;
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.ResetPaging();
	    };
	    VehicleOccupancy.prototype.OnSearch = function ($event) {
	        var _this = this;
	        this.ResetPaging();
	        this.isLoading = true;
	        var model = $event.model;
	        this.vehicleOccupancyService.GenerateVehicleOccupancyReport(model).subscribe(function (res) {
	            if (!res.data) {
	                _this.isValidSearch = false;
	                _this.errorModel = res.error;
	                _this.isLoading = false;
	            }
	            else {
	                _this.isValidSearch = res.data.length > 0 ? true : false;
	                _this.errorModel = null;
	                _this.listOfVehicleOccupancyModel = res.data;
	                _this.DataListModel.totalItems = res.data.length;
	                _this.DataListModel.infoMessage = res.error;
	                _this.FilterList();
	                _this.isLoading = false;
	            }
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	            _this.listOfVehicleOccupancyModel = [];
	            _this.FilterList();
	        });
	    };
	    VehicleOccupancy.prototype.OnExportPDF = function ($event) {
	        var _this = this;
	        this.isLoading = true;
	        var model = $event.model;
	        this.vehicleOccupancyService.ExportVehicleOccupancyReportPDF(model)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "VehicleOccupancyReport" + new Date().toISOString() + ".pdf";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    VehicleOccupancy.prototype.OnExportExcel = function ($event) {
	        var _this = this;
	        this.isLoading = true;
	        var model = $event.model;
	        this.vehicleOccupancyService.ExportVehicleOccupancyReportExcel(model)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "VehicleOccupancyReport" + new Date().toISOString() + ".xlsx";
	                _this.authService.DownloadXlsFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    VehicleOccupancy.prototype.ResetValidSearch = function ($event) {
	        var isValidSearch = $event.isValidSearch;
	        this.isValidSearch = isValidSearch;
	        this.listOfVehicleOccupancyModel = [];
	        this.listOfFilterRecord = [];
	        this.DataListModel.totalItems = 0;
	    };
	    // Client side paging event
	    VehicleOccupancy.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.itemsPerPage = parseInt(event);
	        this.FilterList();
	    };
	    VehicleOccupancy.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.FilterList();
	    };
	    VehicleOccupancy.prototype.FilterList = function () {
	        var start = this.DataListModel.itemsPerPage * (this.DataListModel.currentPage - 1);
	        var end = start + (this.DataListModel.itemsPerPage);
	        this.listOfFilterRecord = this.listOfVehicleOccupancyModel.slice(start, end);
	    };
	    VehicleOccupancy.prototype.ResetPaging = function () {
	        this.listOfVehicleOccupancyModel = [];
	        this.listOfFilterRecord = [];
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.itemsPerPage = 10;
	        this.itemsPerPage = 10;
	    };
	    VehicleOccupancy = __decorate([
	        core_1.Component({
	            selector: 'wego-vehicle-occupancy-report',
	            template: __webpack_require__(505),
	            providers: [vehicle_occupancy_service_1.VehicleOccupancyService],
	            styles: ["\n          .box-body{\n            padding: 0px 10px 10px;\n          }\n          .checkbox-inline{\n            padding-left: 0px !important;\n          }         \n          "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof vehicle_occupancy_service_1.VehicleOccupancyService !== 'undefined' && vehicle_occupancy_service_1.VehicleOccupancyService) === 'function' && _b) || Object])
	    ], VehicleOccupancy);
	    return VehicleOccupancy;
	    var _a, _b;
	}());
	exports.VehicleOccupancy = VehicleOccupancy;


/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var jquery_helper_service_1 = __webpack_require__(67);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var VehicleOccupancyService = (function () {
	    function VehicleOccupancyService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	        this.JQueryHelper = new jquery_helper_service_1.JQueryHelperService();
	    }
	    VehicleOccupancyService.prototype.GenerateVehicleOccupancyReport = function (model) {
	        var getUrl = config_1.WeGoConfig.API_GET_VEHICLE_OCCUPANCY_REPORT;
	        var queryStringReportFilterModel = this.JQueryHelper.Param(model);
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        getUrl = getUrl + "?" + decodeURIComponent(queryStringReportFilterModel);
	        return this.http.get(getUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    VehicleOccupancyService.prototype.ExportVehicleOccupancyReportPDF = function (model) {
	        var queryStringReportFilterModel = this.JQueryHelper.Param(model);
	        var getInstanceUrl = config_1.WeGoConfig.API_EXPORT_VEHICLE_OCCUPANCY_REPORT_PDF + "?" + queryStringReportFilterModel;
	        var headers = this.authService.GetHeader('application/pdf');
	        var options = new http_1.RequestOptions({ headers: headers, responseType: http_1.ResponseContentType.Blob });
	        return this.http.get(getInstanceUrl, options);
	    };
	    VehicleOccupancyService.prototype.ExportVehicleOccupancyReportExcel = function (model) {
	        var getUrl = config_1.WeGoConfig.API_EXPORT_VEHICLE_OCCUPANCY_REPORT_EXCEL;
	        var queryStringReportFilterModel = this.JQueryHelper.Param(model);
	        getUrl = getUrl + "?" + decodeURIComponent(queryStringReportFilterModel);
	        var headers = this.authService.GetHeader('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
	        var options = new http_1.RequestOptions({ headers: headers, responseType: http_1.ResponseContentType.Blob });
	        return this.http.get(getUrl, options);
	    };
	    VehicleOccupancyService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], VehicleOccupancyService);
	    return VehicleOccupancyService;
	    var _a, _b;
	}());
	exports.VehicleOccupancyService = VehicleOccupancyService;


/***/ },
/* 505 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ 'LblVehicleOccupancyReport' | translate }}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li><a [routerLink]=\"urlDefaultPage\"><i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a></li>\r\n        <li class=\"active\">{{ 'LblVehicleOccupancyReport' | translate }}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <div class=\"box box-default\">\r\n          <div class=\"box-body\" style=\"display: block;\">\r\n            <!--Filter-->\r\n            <div class=\"row\" style=\"margin-top:10px;\">\r\n              <div class=\"col-md-12\">\r\n                <wego-report-filter [IsValidSearch]=\"isValidSearch\" [ErrorModel]=\"errorModel\" [ReportName]=\"reportName\" (OnSearch)=\"OnSearch($event)\" (OnExportPDF)=\"OnExportPDF($event)\"\r\n                  (OnExportExcel)=\"OnExportExcel($event)\" (ResetValidSearch)=\"ResetValidSearch($event)\"></wego-report-filter>\r\n              </div>\r\n            </div>\r\n\r\n            <!--No record found-->\r\n            <div class=\"row\">\r\n              <div class=\"col-sm-12 text-danger text-center\">\r\n                <div *ngIf=\"DataListModel.totalItems == 0\">\r\n                  {{ DataListModel.infoMessage }}\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Trip detail table-->\r\n            <div class=\"row\" *ngIf=\"listOfFilterRecord && listOfFilterRecord.length > 0\">\r\n              <fieldset class=\"col-md-12\">\r\n                <legend class=\"legendStyle\">\r\n                  <div class=\"form-inline\" style=\"padding-bottom: 5px;\">\r\n                    <div class=\"form-group\">\r\n                      {{ 'LblVehicle' | translate }} {{ 'LblList' | translate }}\r\n                    </div>\r\n                    <div class=\"form-group pull-right\">\r\n                      <select class=\"form-control\" title='Items Per Page' [(ngModel)]=\"DataListModel.itemsPerPage\" name=\"itemPerPage\" (change)=\"OnPagingChange($event.target.value)\">\r\n                        <option *ngFor=\"let item of itemPerPageList\" [attr.value]='item' >{{ item }}</option>\r\n                      </select>\r\n                    </div>\r\n                  </div>\r\n                </legend>\r\n                <div class=\"clearfix\"></div>\r\n                <div class=\"row\">\r\n                  <div class=\"col-sm-12\">\r\n                    <div class=\"table table-responsive mar_bot_ziro\">\r\n                      <table class=\"table table-bordered mar_bot_ziro\">\r\n                        <thead>\r\n                          <tr>\r\n                            <th>{{ 'LblLicenceTag' | translate }}\r\n                            </th>\r\n                            <th>{{ 'LblReservedTime' | translate }} (%)\r\n                            </th>\r\n                            <th>{{ 'LblUsageTime' | translate }} (%)\r\n                            </th>\r\n                            <th>{{ 'LblUsageTimeoutOffice' | translate }} (%)\r\n                            </th>\r\n                            <th>{{ 'LblSharedVehicleGroup' | translate }}\r\n                            </th>\r\n                            <th *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Company\">{{ 'LblCompany' | translate }}\r\n                            </th>\r\n                           \r\n                          </tr>\r\n                        </thead>\r\n                        <tbody>\r\n                          <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                            <tr *ngFor=\"let trip of listOfFilterRecord\">\r\n                              <td>{{ trip.licensePlate }}</td>\r\n                              <td>{{ trip.reservedTime | decimalFormatter }}</td>\r\n                              <td>{{ trip.usageTime | decimalFormatter }}</td>\r\n                              <td>{{ trip.usageAtOfficeTime | decimalFormatter }}</td>\r\n                              <td>{{ trip.svgName }} </td>\r\n                              <td *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Company\">{{ trip.companyName }} </td>\r\n                            </tr>\r\n                          </template>\r\n                          <tr *ngIf=\"DataListModel.totalItems == 0\">\r\n                            <td class=\"text-center text-danger\" colspan=\"7\">\r\n                              {{ DataListModel.infoMessage }}\r\n                            </td>\r\n                          </tr>\r\n                        </tbody>\r\n                      </table>\r\n                      <div *ngIf=\"DataListModel.totalItems > 0\" class=\"col-sm-12\">\r\n                        <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                          [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\"\r\n                          firstText=\"&laquo;\" lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n                      </div>\r\n                    </div>\r\n                    <div class=\"clearfix\"></div>\r\n                  </div>\r\n                </div>\r\n              </fieldset>\r\n            </div>\r\n\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n\r\n  <wego-lodder [isLoading]=\"isLoading\"></wego-lodder>";

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var core_1 = __webpack_require__(3);
	var AdminDashboardGridComponent = (function () {
	    function AdminDashboardGridComponent(translateService) {
	        this.translateService = translateService;
	        this.onExport = new core_1.EventEmitter();
	        this.column = 'licenceTag';
	        this.isDesc = false;
	    }
	    AdminDashboardGridComponent.prototype.ngOnInit = function () {
	        this.LblNA = this.translateService.instant('LblNA');
	    };
	    AdminDashboardGridComponent.prototype.show = function () {
	        this.vehicleStatusGridModal.show();
	    };
	    AdminDashboardGridComponent.prototype.hide = function () {
	        this.vehicleStatusGridModal.hide();
	    };
	    AdminDashboardGridComponent.prototype.OnExport = function ($event) {
	        this.onExport.emit($event);
	    };
	    AdminDashboardGridComponent.prototype.TransformValue = function (listOfIssues, issueType) {
	        var issueItem = listOfIssues.find(function (x) { return x.type.toLowerCase() == issueType.toLowerCase(); });
	        if (issueItem)
	            return issueItem.issueFound;
	        else
	            return false;
	    };
	    AdminDashboardGridComponent.prototype.HandleNotAvailable = function (item) {
	        if (item != null)
	            return item;
	        else
	            return this.LblNA;
	    };
	    AdminDashboardGridComponent.prototype.IsIssueTypeDefined = function (issueType) {
	        if (this.vehicleIssuePriorityList)
	            return this.vehicleIssuePriorityList.some(function (x) { return x.type == issueType && (x.priority == "PRIORITY1" || x.priority == "PRIORITY2"); });
	        else
	            false;
	    };
	    AdminDashboardGridComponent.prototype.sort = function (property) {
	        var _this = this;
	        this.isDesc = !this.isDesc; //change the direction    
	        this.column = property;
	        this.direction = this.isDesc ? 1 : -1;
	        this.vehicleList.sort(function (x, y) { return _this.HandleSorting(x, y); });
	    };
	    AdminDashboardGridComponent.prototype.HandleSorting = function (x, y) {
	        if (this.column == 'stateOfChargeInPercentage'
	            || this.column == 'batteryLevelInVolts') {
	            if (x[this.column] < y[this.column]) {
	                return -1 * this.direction;
	            }
	            else if (x[this.column] > y[this.column]) {
	                return 1 * this.direction;
	            }
	            else {
	                return 0;
	            }
	        }
	        else if (this.column == 'lastLocationUpdateBefore'
	            || this.column == 'lastBookingDateTimeBefore'
	            || this.column == 'licenceTag'
	            || this.column == 'vehicleStatus') {
	            if (this.HandleNotAvailable(x[this.column]) < this.HandleNotAvailable(y[this.column])) {
	                return -1 * this.direction;
	            }
	            else if (this.HandleNotAvailable(x[this.column]) > this.HandleNotAvailable(y[this.column])) {
	                return 1 * this.direction;
	            }
	            else {
	                return 0;
	            }
	        }
	        else if (this.column == 'DamageReported'
	            || this.column == 'CleaningRequired'
	            || this.column == 'RefuelingRequired'
	            || this.column == 'APKMaintananceScheduled'
	            || this.column == 'OutSideGeofence'
	            || this.column == 'VehicleNotReturn'
	            || this.column == 'VehicleNotBooked'
	            || this.column == 'LowBattery'
	            || this.column == 'LowCharge'
	            || this.column == 'CommunicationProblem'
	            || this.column == 'VehicleSamePosition'
	            || this.column == 'InvalidTagUsed') {
	            if (this.TransformValue(x.listOfVehicleIssue, this.column) < this.TransformValue(y.listOfVehicleIssue, this.column)) {
	                return -1 * this.direction;
	            }
	            if (this.TransformValue(x.listOfVehicleIssue, this.column) > this.TransformValue(y.listOfVehicleIssue, this.column)) {
	                return 1 * this.direction;
	            }
	            else {
	                return 0;
	            }
	        }
	    };
	    __decorate([
	        core_1.Input('VehicleList'), 
	        __metadata('design:type', Array)
	    ], AdminDashboardGridComponent.prototype, "vehicleList", void 0);
	    __decorate([
	        core_1.Input('IssuePriorityList'), 
	        __metadata('design:type', Array)
	    ], AdminDashboardGridComponent.prototype, "vehicleIssuePriorityList", void 0);
	    __decorate([
	        core_1.ViewChild('vehicleStatusGridModal'), 
	        __metadata('design:type', Object)
	    ], AdminDashboardGridComponent.prototype, "vehicleStatusGridModal", void 0);
	    __decorate([
	        core_1.Output('OnExport'), 
	        __metadata('design:type', Object)
	    ], AdminDashboardGridComponent.prototype, "onExport", void 0);
	    AdminDashboardGridComponent = __decorate([
	        core_1.Component({
	            selector: 'admin-dashboard-grid',
	            template: __webpack_require__(507),
	            styles: ["\n    tbody {\n      display: block;\n      max-height: 450px;\n      overflow: auto;\n    }\n    thead, tbody tr {\n      display: table;\n      width: 100%;\n      table-layout: fixed;\n    }\n    thead {\n      width: calc( 100% - 1em );\n    }\n"]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _a) || Object])
	    ], AdminDashboardGridComponent);
	    return AdminDashboardGridComponent;
	    var _a;
	}());
	exports.AdminDashboardGridComponent = AdminDashboardGridComponent;


/***/ },
/* 507 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #vehicleStatusGridModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\" style=\"width: 95%;\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <h4 class=\"modal-title\">{{ 'LblVehicleStatus' | translate }}\r\n          <span class=\"pull-right\">\r\n            <button class=\"btn btn-default\" type=\"button\" (click)=\"OnExport($event)\">\r\n              <i class=\"fa fa-file-excel-o fa-fw\" aria-hidden=\"true\"></i>\r\n            </button>\r\n            <button type=\"button\" class=\"btn btn-default\" aria-label=\"Close\" (click)=\"hide()\">\r\n              <i class=\"fa fa-times text-danger fa-fw\" aria-hidden=\"true\"></i>\r\n          </button>\r\n          </span>\r\n        </h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <div class=\"table table-responsive mar_bot_ziro\" style=\"font-size:13px\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"cursor-pointer\" (click)=\"sort('licenceTag')\">\r\n                  {{ 'LblLicenceTag' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'licenceTag'\" [SortType]=\"column\" [SortReverse]=\"isDesc\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"sort('vehicleStatus')\">{{ 'LblStatus' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'vehicleStatus'\" [SortType]=\"column\" [SortReverse]=\"isDesc\"></wego-sort-list>\r\n                </th>\r\n                <th (click)=\"sort('DamageReported')\" *ngIf=\"IsIssueTypeDefined('DamageReported')\" class=\"text-center cursor-pointer\">{{ 'LblDamage' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'DamageReported'\" [SortType]=\"column\" [SortReverse]=\"isDesc\"></wego-sort-list>\r\n                </th>\r\n\r\n                <th (click)=\"sort('CleaningRequired')\" *ngIf=\"IsIssueTypeDefined('CleaningRequired')\" class=\"text-center cursor-pointer\">{{ 'LblCleaning' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'CleaningRequired'\" [SortType]=\"column\" [SortReverse]=\"isDesc\"></wego-sort-list>\r\n                </th>\r\n\r\n                <th (click)=\"sort('RefuelingRequired')\" *ngIf=\"IsIssueTypeDefined('RefuelingRequired')\" class=\"text-center cursor-pointer wordwrap\">{{ 'LblRefueling' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'RefuelingRequired'\" [SortType]=\"column\" [SortReverse]=\"isDesc\"></wego-sort-list>\r\n                </th>\r\n\r\n                <th (click)=\"sort('APKMaintananceScheduled')\" *ngIf=\"IsIssueTypeDefined('APKMaintananceScheduled')\" class=\"text-center cursor-pointer\">{{ 'LblAPKMaintenance'| translate }}\r\n                  <wego-sort-list [FieldName]=\"'APKMaintananceScheduled'\" [SortType]=\"column\" [SortReverse]=\"isDesc\"></wego-sort-list>\r\n                </th>\r\n\r\n                <th (click)=\"sort('OutSideGeofence')\" *ngIf=\"IsIssueTypeDefined('OutSideGeofence')\" class=\"text-center cursor-pointer\">{{ 'LblOutsideGeofence' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'OutSideGeofence'\" [SortType]=\"column\" [SortReverse]=\"isDesc\"></wego-sort-list>\r\n                </th>\r\n\r\n                <th (click)=\"sort('VehicleNotReturn')\" *ngIf=\"IsIssueTypeDefined('VehicleNotReturn')\" class=\"text-center cursor-pointer\">{{ 'LblNotReturn' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'VehicleNotReturn'\" [SortType]=\"column\" [SortReverse]=\"isDesc\"></wego-sort-list>\r\n                </th>\r\n\r\n                <th (click)=\"sort('VehicleNotBooked')\" *ngIf=\"IsIssueTypeDefined('VehicleNotBooked')\" class=\"text-center cursor-pointer\">{{ 'LblNotBooked' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'VehicleNotBooked'\" [SortType]=\"column\" [SortReverse]=\"isDesc\"></wego-sort-list>\r\n                </th>\r\n\r\n                <th (click)=\"sort('lastBookingDateTimeBefore')\" *ngIf=\"IsIssueTypeDefined('VehicleNotBooked')\" class=\"text-center cursor-pointer\">{{ 'LblNotBookedSince' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'lastBookingDateTimeBefore'\" [SortType]=\"column\" [SortReverse]=\"isDesc\"></wego-sort-list>\r\n                </th>\r\n\r\n                <th (click)=\"sort('LowBattery')\" *ngIf=\"IsIssueTypeDefined('LowBattery')\" class=\"text-center cursor-pointer\">{{ 'LblLowBattery' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'LowBattery'\" [SortType]=\"column\" [SortReverse]=\"isDesc\"></wego-sort-list>\r\n                </th>\r\n                <th (click)=\"sort('batteryLevelInVolts')\" *ngIf=\"IsIssueTypeDefined('LowBattery')\" class=\"text-center cursor-pointer\">{{ 'LblBatteryVolt' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'batteryLevelInVolts'\" [SortType]=\"column\" [SortReverse]=\"isDesc\"></wego-sort-list>\r\n                </th>\r\n\r\n                <th (click)=\"sort('LowCharge')\" *ngIf=\"IsIssueTypeDefined('LowCharge')\" class=\"text-center cursor-pointer\">{{ 'LblLowCharge' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'LowCharge'\" [SortType]=\"column\" [SortReverse]=\"isDesc\"></wego-sort-list>\r\n                </th>\r\n\r\n                <th (click)=\"sort('stateOfChargeInPercentage')\" *ngIf=\"IsIssueTypeDefined('LowCharge')\" class=\"text-center cursor-pointer\">{{ 'LblChargingPercentage' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'stateOfChargeInPercentage'\" [SortType]=\"column\" [SortReverse]=\"isDesc\"></wego-sort-list>\r\n                </th>\r\n\r\n                <th (click)=\"sort('CommunicationProblem')\" *ngIf=\"IsIssueTypeDefined('CommunicationProblem')\" class=\"text-center cursor-pointer wordwrap\">{{ 'LblCommunicationProblem' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'CommunicationProblem'\" [SortType]=\"column\" [SortReverse]=\"isDesc\"></wego-sort-list>\r\n                </th>\r\n\r\n                <th (click)=\"sort('VehicleSamePosition')\" *ngIf=\"IsIssueTypeDefined('VehicleSamePosition')\" class=\"text-center cursor-pointer\">{{ 'LblOnSamePosition' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'VehicleSamePosition'\" [SortType]=\"column\" [SortReverse]=\"isDesc\"></wego-sort-list>\r\n                </th>\r\n\r\n                <th (click)=\"sort('lastLocationUpdateBefore')\" *ngIf=\"IsIssueTypeDefined('VehicleSamePosition')\" class=\"text-center cursor-pointer\">{{ 'LblLastPosition' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'lastLocationUpdateBefore'\" [SortType]=\"column\" [SortReverse]=\"isDesc\"></wego-sort-list>\r\n                </th>\r\n\r\n                <th (click)=\"sort('InvalidTagUsed')\" *ngIf=\"IsIssueTypeDefined('InvalidTagUsed')\" class=\"text-center cursor-pointer\">{{ 'LblInvalidTagUsed' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'InvalidTagUsed'\" [SortType]=\"column\" [SortReverse]=\"isDesc\"></wego-sort-list>\r\n                </th>                \r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"vehicleList && vehicleList.length > 0\">\r\n                <tr *ngFor=\"let vehicle of vehicleList\">\r\n                  <td>{{ vehicle.licenceTag }}</td>\r\n                  <td>{{ vehicle.vehicleStatus }}</td>\r\n                  <td *ngIf=\"IsIssueTypeDefined('DamageReported')\" class=\"text-center\">\r\n                    <i [ngClass]=\"{ 'fa-check text-success': !TransformValue(vehicle.listOfVehicleIssue, 'DamageReported'), 'fa-times text-danger': TransformValue(vehicle.listOfVehicleIssue, 'DamageReported') }\"\r\n                      class=\"fa\" aria-hidden=\"true\"></i>\r\n                  </td>\r\n                  <td *ngIf=\"IsIssueTypeDefined('CleaningRequired')\" class=\"text-center\">\r\n                    <i [ngClass]=\"{ 'fa-check text-success': !TransformValue(vehicle.listOfVehicleIssue, 'CleaningRequired'), 'fa-times text-danger': TransformValue(vehicle.listOfVehicleIssue, 'CleaningRequired') }\"\r\n                      class=\"fa\" aria-hidden=\"true\"></i>\r\n                  </td>\r\n                  <td *ngIf=\"IsIssueTypeDefined('RefuelingRequired')\" class=\"text-center\">\r\n                    <i [ngClass]=\"{ 'fa-check text-success': !TransformValue(vehicle.listOfVehicleIssue, 'RefuelingRequired'), 'fa-times text-danger': TransformValue(vehicle.listOfVehicleIssue, 'RefuelingRequired') }\"\r\n                      class=\"fa\" aria-hidden=\"true\"></i>\r\n                  </td>\r\n                  <td *ngIf=\"IsIssueTypeDefined('APKMaintananceScheduled')\" class=\"text-center\">\r\n                    <i [ngClass]=\"{ 'fa-check text-success': !TransformValue(vehicle.listOfVehicleIssue, 'APKMaintananceScheduled'), 'fa-times text-danger': TransformValue(vehicle.listOfVehicleIssue, 'APKMaintananceScheduled') }\"\r\n                      class=\"fa\" aria-hidden=\"true\"></i>\r\n                  </td>\r\n                  <td *ngIf=\"IsIssueTypeDefined('OutSideGeofence')\" class=\"text-center\">\r\n                    <i [ngClass]=\"{ 'fa-check text-success': !TransformValue(vehicle.listOfVehicleIssue, 'OutSideGeofence'), 'fa-times text-danger': TransformValue(vehicle.listOfVehicleIssue, 'OutSideGeofence') }\"\r\n                      class=\"fa\" aria-hidden=\"true\"></i>\r\n                  </td>\r\n                  <td *ngIf=\"IsIssueTypeDefined('VehicleNotReturn')\" class=\"text-center\">\r\n                    <i [ngClass]=\"{ 'fa-check text-success': !TransformValue(vehicle.listOfVehicleIssue, 'VehicleNotReturn'), 'fa-times text-danger': TransformValue(vehicle.listOfVehicleIssue, 'VehicleNotReturn') }\"\r\n                      class=\"fa\" aria-hidden=\"true\"></i>\r\n                  </td>\r\n                  <td *ngIf=\"IsIssueTypeDefined('VehicleNotBooked')\" class=\"text-center\">\r\n                    <i [ngClass]=\"{ 'fa-check text-success': !TransformValue(vehicle.listOfVehicleIssue, 'VehicleNotBooked'), 'fa-times text-danger': TransformValue(vehicle.listOfVehicleIssue, 'VehicleNotBooked') }\"\r\n                      class=\"fa\" aria-hidden=\"true\"></i>\r\n                  </td>\r\n                  <td *ngIf=\"IsIssueTypeDefined('VehicleNotBooked')\" class=\"text-center\">\r\n                    {{ HandleNotAvailable(vehicle.lastBookingDateTimeBefore) }}\r\n                  </td>\r\n                  <td *ngIf=\"IsIssueTypeDefined('LowBattery')\" class=\"text-center\">\r\n                    <i [ngClass]=\"{ 'fa-check text-success': !TransformValue(vehicle.listOfVehicleIssue, 'LowBattery'), 'fa-times text-danger': TransformValue(vehicle.listOfVehicleIssue, 'LowBattery') }\"\r\n                      class=\"fa\" aria-hidden=\"true\"></i>\r\n                  </td>\r\n                  <td *ngIf=\"IsIssueTypeDefined('LowBattery')\" class=\"text-center\">\r\n                    {{ HandleNotAvailable(vehicle.batteryLevelInVolts) }}\r\n                  </td>\r\n                  <td *ngIf=\"IsIssueTypeDefined('LowCharge')\" class=\"text-center\">\r\n                    <i [ngClass]=\"{ 'fa-check text-success': !TransformValue(vehicle.listOfVehicleIssue, 'LowCharge'), 'fa-times text-danger': TransformValue(vehicle.listOfVehicleIssue, 'LowCharge') }\"\r\n                      class=\"fa\" aria-hidden=\"true\"></i>\r\n                  </td>\r\n                  <td *ngIf=\"IsIssueTypeDefined('LowCharge')\" class=\"text-center\">\r\n                    {{ HandleNotAvailable(vehicle.stateOfChargeInPercentage) }}\r\n                  </td>\r\n                  <td *ngIf=\"IsIssueTypeDefined('CommunicationProblem')\" class=\"text-center\">\r\n                    <i [ngClass]=\"{ 'fa-check text-success': !TransformValue(vehicle.listOfVehicleIssue, 'CommunicationProblem'), 'fa-times text-danger': TransformValue(vehicle.listOfVehicleIssue, 'CommunicationProblem') }\"\r\n                      class=\"fa\" aria-hidden=\"true\"></i>\r\n                  </td>\r\n                  <td *ngIf=\"IsIssueTypeDefined('VehicleSamePosition')\" class=\"text-center\">\r\n                    <i [ngClass]=\"{ 'fa-check text-success': !TransformValue(vehicle.listOfVehicleIssue, 'VehicleSamePosition'), 'fa-times text-danger': TransformValue(vehicle.listOfVehicleIssue, 'VehicleSamePosition') }\"\r\n                      class=\"fa\" aria-hidden=\"true\"></i>\r\n                  </td>\r\n                  <td *ngIf=\"IsIssueTypeDefined('VehicleSamePosition')\" class=\"text-center\">\r\n                    {{ HandleNotAvailable(vehicle.lastLocationUpdateBefore) }}\r\n                  </td>\r\n                  <td *ngIf=\"IsIssueTypeDefined('InvalidTagUsed')\" class=\"text-center\">\r\n                    <i [ngClass]=\"{ 'fa-check text-success': !TransformValue(vehicle.listOfVehicleIssue, 'InvalidTagUsed'), 'fa-times text-danger': TransformValue(vehicle.listOfVehicleIssue, 'InvalidTagUsed') }\"\r\n                      class=\"fa\" aria-hidden=\"true\"></i>\r\n                  </td>                  \r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"!vehicleList || vehicleList.length == 0\">\r\n                <td class=\"text-center text-danger\" colspan=\"18\">\r\n                  {{ 'LblNoRecords' | translate }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var admin_dashboard_service_1 = __webpack_require__(509);
	var company_service_1 = __webpack_require__(501);
	var instance_service_1 = __webpack_require__(500);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var sharedvehiclegroup_service_1 = __webpack_require__(510);
	var config_1 = __webpack_require__(60);
	var AdminDashboardFilterComponent = (function () {
	    function AdminDashboardFilterComponent(authService, adminDashboardService, instanceService, companyService, sharedVehicleGroupService) {
	        this.authService = authService;
	        this.adminDashboardService = adminDashboardService;
	        this.instanceService = instanceService;
	        this.companyService = companyService;
	        this.sharedVehicleGroupService = sharedVehicleGroupService;
	        this.onSearch = new core_1.EventEmitter();
	        this.instanceHashId = "";
	        this.companyHashId = "";
	        this.sVGHashId = "";
	        this.notBookedValue = "";
	        this.notBookedValueInterval = "";
	        this.samePositionValue = "";
	        this.samePositionValueInterval = "";
	        this.roleLevel = config_1.RoleLevel;
	    }
	    AdminDashboardFilterComponent.prototype.ngOnInit = function () {
	        this.pageName = "Admin_Dashboard";
	        this.RetriveFilter();
	        this.GetAllInstanceList();
	    };
	    AdminDashboardFilterComponent.prototype.GetAllInstanceList = function () {
	        var _this = this;
	        this.instanceService.GetDropdownInstanceList(this.pageName).subscribe(function (res) {
	            _this.instanceList = res.data;
	            if (_this.instanceList && _this.instanceList.length > 0) {
	                if (_this.filterInstanceHashId) {
	                    _this.instanceHashId = _this.filterInstanceHashId;
	                    _this.filterInstanceHashId = null;
	                }
	                else {
	                    _this.instanceHashId = _this.instanceList[0].keyHash;
	                }
	                _this.OnInstanceChange();
	                _this.OnSearch();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    AdminDashboardFilterComponent.prototype.RetriveFilter = function () {
	        var filter = this.authService.AssignFromStorage(this.constructor.name + "_model", null);
	        if (filter) {
	            this.filterInstanceHashId = filter["instanceHashId"];
	            this.filterCompanyHashId = filter["companyHashId"];
	            this.filterSVGHashId = filter["svgHashId"];
	            this.filterVehicleIssuePriorityList = filter["vehicleIssuePriorityList"];
	            this.filterDashboardConfig = filter["dashboardConfig"];
	            this.filterNotBookedValue = filter["notBookedValue"];
	            this.filterSamePositionValue = filter["samePositionValue"];
	        }
	    };
	    AdminDashboardFilterComponent.prototype.GetAllCompanyList = function () {
	        var _this = this;
	        //this.companyService.GetCompanyList()
	        this.companyService
	            .GetDropdownCompanyList(this.pageName, this.instanceHashId)
	            .subscribe(function (res) {
	            _this.companyList = res.data;
	            if (_this.filterCompanyHashId) {
	                _this.companyHashId = _this.filterCompanyHashId;
	                _this.filterCompanyHashId = null;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    // Value should be null in case required all svg
	    AdminDashboardFilterComponent.prototype.GetAllSVGList = function () {
	        var _this = this;
	        // public GetAllSVGList(companyHashId?: string, instanceHashId?: string) {
	        //this.adminDashboardService.GetSharedVehicleGroupList(companyHashId, instanceHashId)
	        this.sharedVehicleGroupService
	            .GetDropdownSVGList(this.pageName, this.companyHashId, this.instanceHashId)
	            .subscribe(function (res) {
	            _this.sharedVehicleGroupList = res.data;
	            if (_this.filterSVGHashId) {
	                _this.sVGHashId = _this.filterSVGHashId;
	                _this.filterSVGHashId = null;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    AdminDashboardFilterComponent.prototype.GetCompanyListByInstance = function (instanceHashId) {
	        var _this = this;
	        this.companyService.GetCompanyByInstance(instanceHashId).subscribe(function (res) {
	            _this.companyList = res.data;
	            if (_this.filterCompanyHashId) {
	                _this.companyHashId = _this.filterCompanyHashId;
	                _this.filterCompanyHashId = null;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    AdminDashboardFilterComponent.prototype.GetPriorityForIssues = function (instanceHashId) {
	        var _this = this;
	        this.adminDashboardService.GetPriorityForIssues(instanceHashId).subscribe(function (res) {
	            _this.vehicleIssuePriorityList = res.data.vehicleIssue;
	            _this.dashboardConfig = res.data.dashboardConfig;
	            if (_this.filterDashboardConfig) {
	                _this.dashboardConfig.defaultLocation = _this.filterDashboardConfig.defaultLocation;
	                _this.dashboardConfig.defaultStatus = _this.filterDashboardConfig.defaultStatus;
	                _this.filterDashboardConfig = null;
	            }
	            _this.notBookedValue = res.data.notBookedValue;
	            _this.notBookedValueInterval = res.data.notBookedValueInterval;
	            _this.samePositionValue = res.data.samePositionValue;
	            _this.samePositionValueInterval = res.data.samePositionValueInterval;
	            _this.PassDataToParent();
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    // Event
	    AdminDashboardFilterComponent.prototype.OnInstanceChange = function () {
	        //this.ResetValidSearch();
	        if (this.instanceHashId) {
	            //this.GetCompanyListByInstance(this.instanceHashId);
	            this.GetAllCompanyList();
	            this.companyHashId = "";
	            this.OnCompanyChange();
	        }
	        else {
	            this.companyList = [];
	            this.sharedVehicleGroupList = [];
	            this.companyHashId = "";
	            this.sVGHashId = "";
	        }
	    };
	    AdminDashboardFilterComponent.prototype.OnCompanyChange = function () {
	        //this.ResetValidSearch();
	        //this.GetAllSVGList(this.companyHashId, this.instanceHashId);
	        this.GetAllSVGList();
	        this.sVGHashId = "";
	    };
	    // Button Click
	    AdminDashboardFilterComponent.prototype.PassDataToParent = function () {
	        this.onSearch.emit({
	            instanceHashId: this.instanceHashId,
	            companyHashId: this.companyHashId,
	            svgHashId: this.sVGHashId,
	            vehicleIssuePriorityList: this.vehicleIssuePriorityList,
	            dashboardConfig: this.dashboardConfig,
	            notBookedValue: this.notBookedValue,
	            samePositionValue: this.samePositionValue,
	            notBookedValueInterval: this.notBookedValueInterval,
	            samePositionValueInterval: this.samePositionValueInterval
	        });
	    };
	    AdminDashboardFilterComponent.prototype.OnSearch = function () {
	        if (!this.instanceHashId) {
	            this.isDirty = true;
	        }
	        else {
	            this.isDirty = false;
	            this.GetPriorityForIssues(this.instanceHashId);
	        }
	    };
	    // AllowToDisplayInstanceDropDown() {
	    //   if (this.instanceList) {
	    //     if (this.instanceList.length > 1) {
	    //       return true;
	    //     } else if (this.instanceList.length == 1) {
	    //       let odlInstanceHashId = this.instanceHashId;
	    //       let newInstanceHashId = this.instanceList[0].keyHash;
	    //       if (odlInstanceHashId != newInstanceHashId) {
	    //         this.instanceHashId = newInstanceHashId;
	    //         this.OnInstanceChange();
	    //       }
	    //     }
	    //   }
	    //   return false;
	    // }
	    // AllowToDisplayDropDown(
	    //   dropDownItems: DropdownModel[],
	    //   currentDropDownValue: string,
	    //   callback: any
	    // ) {
	    //   if (dropDownItems) {
	    //     if (dropDownItems.length > 1) {
	    //       return true;
	    //     } else if (dropDownItems.length == 1) {
	    //       let odlHashId = currentDropDownValue;
	    //       let newHashId = dropDownItems[0].keyHash;
	    //       if (odlHashId != newHashId) {
	    //         callback(this, newHashId);
	    //       }
	    //     }
	    //   }
	    //   return false;
	    // }
	    // SetInstanceDropDownValue(ref: any, newHashId: string) {
	    //   ref.instanceHashId = newHashId;
	    //   ref.OnInstanceChange();
	    // }
	    // SetCompanyDropDownValue(ref: any, newHashId: string) {
	    //   ref.companyHashId = newHashId;
	    //   ref.OnCompanyChange();
	    // }
	    AdminDashboardFilterComponent.prototype.ngOnDestroy = function () {
	        this.authService.SaveToStorage(this.constructor.name + "_model", {
	            instanceHashId: this.instanceHashId,
	            companyHashId: this.companyHashId,
	            svgHashId: this.sVGHashId,
	            dashboardConfig: this.dashboardConfig
	        });
	    };
	    __decorate([
	        core_1.Output("OnSearch"), 
	        __metadata('design:type', Object)
	    ], AdminDashboardFilterComponent.prototype, "onSearch", void 0);
	    AdminDashboardFilterComponent = __decorate([
	        core_1.Component({
	            selector: "admin-dashboard-filter",
	            template: __webpack_require__(511),
	            providers: [instance_service_1.InstanceService, company_service_1.CompanyService, sharedvehiclegroup_service_1.SharedVehicleGroupService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof admin_dashboard_service_1.AdminDashboardService !== 'undefined' && admin_dashboard_service_1.AdminDashboardService) === 'function' && _b) || Object, (typeof (_c = typeof instance_service_1.InstanceService !== 'undefined' && instance_service_1.InstanceService) === 'function' && _c) || Object, (typeof (_d = typeof company_service_1.CompanyService !== 'undefined' && company_service_1.CompanyService) === 'function' && _d) || Object, (typeof (_e = typeof sharedvehiclegroup_service_1.SharedVehicleGroupService !== 'undefined' && sharedvehiclegroup_service_1.SharedVehicleGroupService) === 'function' && _e) || Object])
	    ], AdminDashboardFilterComponent);
	    return AdminDashboardFilterComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.AdminDashboardFilterComponent = AdminDashboardFilterComponent;


/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var Observable_1 = __webpack_require__(5);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var AdminDashboardService = (function () {
	    function AdminDashboardService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    AdminDashboardService.prototype.GetVehicleLocation = function () {
	        // let getUpcomingBookingUrl = WeGoConfig.API_GET_UPCOMING_BOOKING_LIST;
	        // let queryString = this.authService.HandleAPIListInput(input);
	        // if (queryString) {
	        //   getUpcomingBookingUrl = getUpcomingBookingUrl + "?" + queryString;
	        // }
	        // let headers = this.authService.GetHeader();
	        // let options = new RequestOptions({ headers: headers });
	        // return this.http.get(getUpcomingBookingUrl, options)
	        //   .map(this.authService.HandleAPIResponse)
	        //   .catch(this.authService.HandleAPIError);
	        var tt = {
	            "data": [
	                {
	                    "vehicleMasterHashId": "Test",
	                    "licenceTag": "AA-BB-01",
	                    "vehicleStatus": "Available",
	                    "homeLocation": {
	                        "latitude": -33.91747,
	                        "longitude": 151.22912
	                    },
	                    "currentLocation": {
	                        "latitude": -33.91910,
	                        "longitude": 151.22907
	                    }
	                },
	                {
	                    "vehicleMasterHashId": "Test",
	                    "licenceTag": "AA-BB-02",
	                    "vehicleStatus": "Unavailable",
	                    "homeLocation": {
	                        "latitude": -33.658452,
	                        "longitude": 151.7851212
	                    },
	                    "currentLocation": {
	                        "latitude": -33.985241,
	                        "longitude": 151.23255
	                    }
	                },
	                {
	                    "vehicleMasterHashId": "Test",
	                    "licenceTag": "AA-BB-03",
	                    "vehicleStatus": "Priority1",
	                    "homeLocation": {
	                        "latitude": -33.987722,
	                        "longitude": 151.714452
	                    },
	                    "currentLocation": {
	                        "latitude": -33.111022,
	                        "longitude": 151.322554
	                    }
	                }
	            ],
	            "error": "",
	            "totalRecords": 0,
	            "status": {
	                "dateTimeUTC": "23-05-2017 05:17",
	                "version": "1.0.0.0",
	                "isSpecialBookingExist": false
	            }
	        };
	        return Observable_1.Observable.create(function (observer) {
	            observer.next(tt);
	            observer.complete();
	        });
	    };
	    AdminDashboardService.prototype.GetVehicleWithStatus = function (instanceHashId, companyHashId, svgHashId) {
	        var getVehicleUrl = config_1.WeGoConfig.API_GET_VEHICLE_WITH_STATUS;
	        getVehicleUrl = getVehicleUrl + "?instanceHashId=" + instanceHashId
	            + "&companyHashId=" + companyHashId
	            + "&svgHashId=" + svgHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getVehicleUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminDashboardService.prototype.GetWindowsServiceStatus = function () {
	        var getWindowsServiceStatusUrl = config_1.WeGoConfig.API_GET_WINDOWS_SERVICE_STATUS;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getWindowsServiceStatusUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminDashboardService.prototype.GetPaymentServiceStatus = function () {
	        var getWindowsServiceStatusUrl = config_1.WeGoConfig.API_GET_ONLINE_PAYMENT_SERVICE_STATUS;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getWindowsServiceStatusUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminDashboardService.prototype.GetPriorityForIssues = function (instantHashId) {
	        var getUrl = config_1.WeGoConfig.API_GET_PRIORITY_FOR_ISSUE + "?instanceHashId=" + instantHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminDashboardService.prototype.GetSharedVehicleGroupList = function (companyHashId, instanceHashId) {
	        var getSVGUrl = config_1.WeGoConfig.API_GET_SHAREDVEHICLEGROUP_DETAIL;
	        getSVGUrl = getSVGUrl + "?";
	        if (companyHashId) {
	            getSVGUrl = getSVGUrl + "&companyHashId=" + companyHashId;
	        }
	        if (instanceHashId) {
	            getSVGUrl = getSVGUrl + "&instanceHashId=" + instanceHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getSVGUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminDashboardService.prototype.ExportVehicleWithStatusXls = function (instanceHashId, companyHashId, svgHashId) {
	        var getUrl = config_1.WeGoConfig.API_EXPORT_VEHICLE_WITH_STATUS_XLS;
	        getUrl = getUrl + "?instanceHashId=" + instanceHashId
	            + "&companyHashId=" + companyHashId
	            + "&svgHashId=" + svgHashId;
	        var headers = this.authService.GetHeader('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
	        var options = new http_1.RequestOptions({ headers: headers, responseType: http_1.ResponseContentType.Blob });
	        return this.http.get(getUrl, options);
	    };
	    AdminDashboardService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], AdminDashboardService);
	    return AdminDashboardService;
	    var _a, _b;
	}());
	exports.AdminDashboardService = AdminDashboardService;


/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var SharedVehicleGroupService = (function () {
	    function SharedVehicleGroupService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    SharedVehicleGroupService.prototype.GetSharedVehicleGroupList = function (input, companyHashIdList, companyHashId, vehicleHashId, permissionName) {
	        var getSVGUrl = config_1.WeGoConfig.API_GET_SHAREDVEHICLEGROUP_DETAIL;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getSVGUrl = getSVGUrl + "?" + queryString;
	            if (companyHashIdList) {
	                getSVGUrl = getSVGUrl + "&companyHashIdList=" + companyHashIdList;
	            }
	            if (companyHashId) {
	                getSVGUrl = getSVGUrl + "&companyHashId=" + companyHashId;
	            }
	            if (vehicleHashId) {
	                getSVGUrl = getSVGUrl + "&vehicleHashId=" + vehicleHashId;
	            }
	            if (permissionName) {
	                getSVGUrl = getSVGUrl + "&permissionName=" + permissionName;
	            }
	        }
	        else {
	            if (companyHashIdList) {
	                getSVGUrl = getSVGUrl + "&companyHashIdList=" + companyHashIdList;
	            }
	            if (companyHashId) {
	                getSVGUrl = getSVGUrl + "?companyHashId=" + companyHashId;
	                if (vehicleHashId) {
	                    getSVGUrl = getSVGUrl + "&vehicleHashId=" + vehicleHashId;
	                }
	            }
	            else {
	                if (vehicleHashId) {
	                    getSVGUrl = getSVGUrl + "?vehicleHashId=" + vehicleHashId;
	                }
	            }
	            if (getSVGUrl.indexOf("?")) {
	                if (permissionName) {
	                    getSVGUrl = getSVGUrl + "&permissionName=" + permissionName;
	                }
	            }
	            else {
	                if (permissionName) {
	                    getSVGUrl = getSVGUrl + "?permissionName=" + permissionName;
	                }
	            }
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getSVGUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SharedVehicleGroupService.prototype.ExportSharedVehicleGroupList = function (companyHashID, vehicleHashId, input) {
	        var getSVGUrl = config_1.WeGoConfig.API_EXPORT_SHAREDVEHICLEGROUP_LIST;
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (companyHashID) {
	            getSVGUrl =
	                getSVGUrl + "?" + queryString + "&companyHashID=" + companyHashID;
	        }
	        else {
	            getSVGUrl = getSVGUrl + "?" + queryString;
	        }
	        if (vehicleHashId) {
	            getSVGUrl = getSVGUrl + "&vehicleHashId=" + vehicleHashId;
	        }
	        var headers = this.authService.GetHeader("text/csv");
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getSVGUrl, options);
	    };
	    SharedVehicleGroupService.prototype.AddSharedVehicleGroupModel = function (sharedVehicleGroupModel) {
	        var body = sharedVehicleGroupModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_SHAREDVEHICLEGROUP_DETAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SharedVehicleGroupService.prototype.GetSharedVehicleGroupHashId = function (sharedvehiclegroupHashId) {
	        var getSharedVehicleGroupUrl = config_1.WeGoConfig.API_GET_SHAREDVEHICLEGROUP_BY_HASH +
	            "?sharedVehicleGroupHashId=" +
	            sharedvehiclegroupHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getSharedVehicleGroupUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SharedVehicleGroupService.prototype.GetSharedVehicleGroupBasicDetail = function (sharedvehiclegroupHashId) {
	        var getSharedVehicleGroupUrl = config_1.WeGoConfig.API_GET_SHAREDVEHICLEGROUP_BASIC_DETAIL +
	            "?sharedVehicleGroupHashId=" +
	            sharedvehiclegroupHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getSharedVehicleGroupUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SharedVehicleGroupService.prototype.GetSVGListForDrivers = function (driverMasterHashId, input) {
	        var getSharedVehicleGroup = config_1.WeGoConfig.API_GET_SVG_LIST_FOR_DRIVERS;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getSharedVehicleGroup =
	                getSharedVehicleGroup +
	                    "?" +
	                    queryString +
	                    "&driverMasterHashId=" +
	                    driverMasterHashId;
	        }
	        else {
	            getSharedVehicleGroup =
	                getSharedVehicleGroup + "?driverMasterHashId=" + driverMasterHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getSharedVehicleGroup, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SharedVehicleGroupService.prototype.GetSVGListForBatchUpload = function (instanceHashId, organizationMasterHashId, input) {
	        var getSVGForBatchUploadDetail = config_1.WeGoConfig.API_POST_SVG_DETAIL_FOR_BATCHUPLOAD;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getSVGForBatchUploadDetail =
	                getSVGForBatchUploadDetail +
	                    "?" +
	                    queryString +
	                    "&instanceId=" +
	                    instanceHashId;
	        }
	        else {
	            getSVGForBatchUploadDetail =
	                getSVGForBatchUploadDetail + "?instanceId=" + instanceHashId;
	        }
	        if (organizationMasterHashId != "") {
	            getSVGForBatchUploadDetail =
	                getSVGForBatchUploadDetail +
	                    "&organizationMasterId=" +
	                    organizationMasterHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getSVGForBatchUploadDetail, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SharedVehicleGroupService.prototype.GetSVGListForVehicle = function (vehicleMasterHashId, input) {
	        var getSharedVehicleGroup = config_1.WeGoConfig.API_GET_SVG_LIST_FOR_VEHICLE;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getSharedVehicleGroup =
	                getSharedVehicleGroup +
	                    "?" +
	                    queryString +
	                    "&vehicleMasterHashId=" +
	                    vehicleMasterHashId;
	        }
	        else {
	            getSharedVehicleGroup =
	                getSharedVehicleGroup + "?vehicleMasterHashId=" + vehicleMasterHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getSharedVehicleGroup, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SharedVehicleGroupService.prototype.DeleteSharedVehicleGroup = function (selectedsharedVehicelGroupHashId) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_DELETE_SVG_VEHICLE_DETAIL, selectedsharedVehicelGroupHashId, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SharedVehicleGroupService.prototype.GetSVGVehicleList = function (sharedvehiclegroupHashId, input) {
	        var getSVGVehicleList = config_1.WeGoConfig.API_GET_SVGVEHICLEGLIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getSVGVehicleList =
	                getSVGVehicleList +
	                    "?" +
	                    queryString +
	                    "&sharedVehicleGroupHashId=" +
	                    sharedvehiclegroupHashId;
	        }
	        else {
	            getSVGVehicleList =
	                getSVGVehicleList +
	                    "?sharedVehicleGroupHashId=" +
	                    sharedvehiclegroupHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getSVGVehicleList, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SharedVehicleGroupService.prototype.AssignGroupVehicle = function (SVGvehicleModel) {
	        var body = SVGvehicleModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_SVG_VEHICLE_DETAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SharedVehicleGroupService.prototype.GetVehicleListForGroup = function (sharedvehiclegroupHashId, input) {
	        var getSVGVehicleList = config_1.WeGoConfig.API_GET_VEHICLEGROUP_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getSVGVehicleList =
	                getSVGVehicleList +
	                    "?" +
	                    queryString +
	                    "&sharedVehicleGroupHashId=" +
	                    sharedvehiclegroupHashId;
	        }
	        else {
	            getSVGVehicleList =
	                getSVGVehicleList +
	                    "?sharedVehicleGroupHashId=" +
	                    sharedvehiclegroupHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getSVGVehicleList, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SharedVehicleGroupService.prototype.DeleteVehicleSVG = function (selectedVehicleSVGList) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_DELETE_VEHICLE_SVG, selectedVehicleSVGList, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SharedVehicleGroupService.prototype.InActiveSharedVehicleGroup = function (svgHashId) {
	        var getInactiveSVGUrl = config_1.WeGoConfig.API_GET_INACTIVE_SHAREDVEHICLEGROUP +
	            "?sharedVehicleGroupHashId=" +
	            svgHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInactiveSVGUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SharedVehicleGroupService.prototype.GetSVGDriverList = function (sharedvehiclegroupHashId, instanceHashId, companyHashId, input) {
	        var getSVGDriverList = config_1.WeGoConfig.API_GET_SVGDRIVERGLIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getSVGDriverList =
	                getSVGDriverList +
	                    "?" +
	                    queryString +
	                    "&sharedVehicleGroupHashId=" +
	                    sharedvehiclegroupHashId +
	                    "&instanceHashId=" +
	                    instanceHashId +
	                    "&companyHashId=" +
	                    companyHashId;
	        }
	        else {
	            getSVGDriverList =
	                getSVGDriverList +
	                    "?sharedVehicleGroupHashId=" +
	                    sharedvehiclegroupHashId +
	                    "&instanceHashId=" +
	                    instanceHashId +
	                    "&companyHashId=" +
	                    companyHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getSVGDriverList, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SharedVehicleGroupService.prototype.GetDropdownSVGList = function (reportName, companyHashId, instanceHashId) {
	        var getSVGUrl;
	        switch (reportName) {
	            case "Vehicle_Occupancy_Report":
	                getSVGUrl = config_1.WeGoConfig.API_GET_DROPDOWN_SVG_LIST_VEHICLEOCCUPANCYREPORT;
	                break;
	            case "Revenue_Per_Vehicle_Report":
	                getSVGUrl = config_1.WeGoConfig.API_GET_DROPDOWN_SVG_LIST_REVENUEVEHICLEREPORT;
	                break;
	            case "Maintenance_Planning_Report":
	                getSVGUrl =
	                    config_1.WeGoConfig.API_GET_DROPDOWN_SVG_LIST_MAINTENCEPLANNINGREPORT;
	                break;
	            case "TripData_Report":
	                getSVGUrl = config_1.WeGoConfig.API_GET_DROPDOWN_SVG_LIST_TRIPDATAREPORT;
	                break;
	            case "Admin_Dashboard":
	                getSVGUrl = config_1.WeGoConfig.API_GET_DROPDOWN_SVG_LIST_DASHBOARD;
	                break;
	            case "Kick_Back_Report":
	                getSVGUrl = config_1.WeGoConfig.API_GET_DROPDOWN_SVG_LIST_KICK_BACK_REPORT;
	                break;
	            case "Pre Post Trip Question":
	                getSVGUrl = config_1.WeGoConfig.API_GET_DROPDOWN_SVG_LIST_PRE_POST_TRIP_QUESTION;
	                break;
	            default:
	                getSVGUrl = config_1.WeGoConfig.API_GET_DROPDOWN_SVG_LIST_VEHICLEOCCUPANCYREPORT;
	                break;
	        }
	        getSVGUrl = getSVGUrl + "?companyHashId=" + companyHashId;
	        if (instanceHashId) {
	            getSVGUrl = getSVGUrl + "&instanceHashId=" + instanceHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getSVGUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SharedVehicleGroupService.prototype.GetDropdownDriverList = function (sharedvehiclegroupHashId, organizationHashId, instanceHashId, companyHashId, input) {
	        var getSVGDriverList = config_1.WeGoConfig.API_GET_DROPDOWN_DRIVER_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getSVGDriverList =
	                getSVGDriverList +
	                    "?" +
	                    queryString +
	                    "&sharedVehicleGroupHashId=" +
	                    sharedvehiclegroupHashId +
	                    "&organizationHashId=" + organizationHashId +
	                    "&instanceHashId=" +
	                    instanceHashId +
	                    "&companyHashId=" +
	                    companyHashId;
	        }
	        else {
	            getSVGDriverList =
	                getSVGDriverList +
	                    "?sharedVehicleGroupHashId=" +
	                    sharedvehiclegroupHashId +
	                    "&organizationHashId=" + organizationHashId +
	                    "&instanceHashId=" +
	                    instanceHashId +
	                    "&companyHashId=" +
	                    companyHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getSVGDriverList, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SharedVehicleGroupService.prototype.GetSharedVehicleDropdownList = function () {
	        var getSVGListUrl = config_1.WeGoConfig.API_GET_DROPDOWN_SVG_LIST_BOOKING_AGENDA;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getSVGListUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SharedVehicleGroupService.prototype.GetSharedVehicleDropdownListByOrganization = function (reportName, permissionType, organizationHashId) {
	        var getSVGListUrl = config_1.WeGoConfig.API_GET_DROPDOWN_SVG_LIST_TEMPLATE;
	        switch (reportName) {
	            case "Template":
	                getSVGListUrl = config_1.WeGoConfig.API_GET_DROPDOWN_SVG_LIST_TEMPLATE;
	                break;
	            case "Terms_And_Condition":
	                getSVGListUrl = config_1.WeGoConfig.API_GET_DROPDOWN_SVG_LIST_TERMS_AND_CONDITION;
	                break;
	        }
	        if (permissionType) {
	            getSVGListUrl = getSVGListUrl + "?permissionType=" + permissionType;
	        }
	        if (organizationHashId) {
	            getSVGListUrl =
	                getSVGListUrl + "&organizationHashId=" + organizationHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getSVGListUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SharedVehicleGroupService.prototype.ResetTwoFaCookies = function (SharedVehicleGroupHashId) {
	        var getInstanceUrl = config_1.WeGoConfig.API_RESET_TWOFA_COOKIES_SVG + "?SharedVehicleGroupHashId=" + SharedVehicleGroupHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInstanceUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SharedVehicleGroupService.prototype.ResetTwoFaKeys = function (SharedVehicleGroupHashId) {
	        var getInstanceUrl = config_1.WeGoConfig.API_RESET_TWOFA_KEYS_SVG + "?SharedVehicleGroupHashId=" + SharedVehicleGroupHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInstanceUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SharedVehicleGroupService.prototype.GetDropdownSharedVehicleGroupListByCompanyIdList = function (reportName, permissionType, organizationHashIds) {
	        var getOrganizationUrl;
	        switch (reportName) {
	            case "Terms_And_Condition":
	                getOrganizationUrl = config_1.WeGoConfig.API_GET_DROPDOWN_SVG_LIST_BY_ORG_LIST_TERMS_AND_CONDITION;
	                break;
	        }
	        if (permissionType) {
	            getOrganizationUrl = getOrganizationUrl + '?permissionType=' + permissionType;
	        }
	        var queryString = '';
	        organizationHashIds.forEach(function (element) {
	            queryString += "&organizationHashIdList=" + element;
	        });
	        getOrganizationUrl = getOrganizationUrl + queryString;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getOrganizationUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SharedVehicleGroupService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], SharedVehicleGroupService);
	    return SharedVehicleGroupService;
	    var _a, _b;
	}());
	exports.SharedVehicleGroupService = SharedVehicleGroupService;


/***/ },
/* 511 */
/***/ function(module, exports) {

	module.exports = "<div>\r\n  \r\n  <!-- *ngIf=\"AllowToDisplayDropDown(instanceList, instanceHashId, SetInstanceDropDownValue)\" -->\r\n  <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Instance\" class=\"form-group padding-left-zero\"\r\n    [ngClass]=\"{'has-error': !instanceHashId && isDirty }\">\r\n    <label>{{ 'LblInstance' | translate }}</label>\r\n    <select [(ngModel)]=\"instanceHashId\" name=\"Instance\" class=\"form-control\" (change)=\"OnInstanceChange()\">\r\n      <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblInstance' | translate }} </option>\r\n      <option *ngFor=\"let item of instanceList\" [ngValue]='item.keyHash'>{{ item.value }}</option>\r\n    </select>\r\n  </div>  \r\n  <!-- *ngIf=\"instanceHashId == '' || AllowToDisplayDropDown(companyList, instanceHashId, SetCompanyDropDownValue)\" -->\r\n  <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Company\" class=\"form-group padding-left-zero\">\r\n    <label>{{ 'LblCompany' | translate }}</label>\r\n    <select [(ngModel)]=\"companyHashId\" name=\"ownerCompanyID\" class=\"form-control\" (change)=\"OnCompanyChange()\">\r\n      <option value=\"\">{{ 'LblAll' | translate }} {{ 'LblCompany' | translate }} </option>\r\n      <option *ngFor=\"let company of companyList\" [ngValue]='company.keyHash'>{{company.value}}</option>\r\n    </select>\r\n  </div>\r\n  <div class=\"form-group padding-left-zero\">\r\n    <label>{{ 'LblSharedVehicleGroup' | translate }}</label>\r\n    <select [(ngModel)]=\"sVGHashId\" name=\"sharedvehiclegroup\" class=\"form-control\">\r\n      <option value=\"\">{{ 'LblAll' | translate }} {{ 'LblSharedVehicleGroup' | translate }} </option>\r\n      <option *ngFor=\"let sharedvehiclegroup of sharedVehicleGroupList\" [ngValue]='sharedvehiclegroup.keyHash'>{{ sharedvehiclegroup.value }}</option>\r\n    </select>\r\n  </div>\r\n  <div class=\"form-group padding-left-zero\">\r\n    <div class=\"clearfix\"></div>\r\n    <button class=\"btn btn-default\" (click)=\"OnSearch()\">\r\n      <i class=\"fa fa-search\" aria-hidden=\"true\"></i> {{ 'LblSearch' | translate }} </button>\r\n  </div>\r\n</div>";

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var instance_model_1 = __webpack_require__(513);
	var config_1 = __webpack_require__(60);
	var translate_service_1 = __webpack_require__(70);
	var windows_service_status_model_1 = __webpack_require__(516);
	var jquery_helper_service_1 = __webpack_require__(67);
	var auth_service_1 = __webpack_require__(58);
	var admin_dashboard_service_1 = __webpack_require__(509);
	var core_1 = __webpack_require__(3);
	var greenIcon = __webpack_require__(517);
	var blueIcon = __webpack_require__(518);
	var orangeIcon = __webpack_require__(519);
	var grayIcon = __webpack_require__(520);
	var redIcon = __webpack_require__(521);
	var MarkerWithLabel = __webpack_require__(522)(google.maps);
	var overlappingMarkerSpiderfier = __webpack_require__(523);
	var AdminDashboardComponent = (function () {
	    function AdminDashboardComponent(adminDashboardService, translateService, authService) {
	        this.adminDashboardService = adminDashboardService;
	        this.translateService = translateService;
	        this.authService = authService;
	        this.JQueryHelper = new jquery_helper_service_1.JQueryHelperService();
	        this.instanceHashId = "";
	        this.companyHashId = "";
	        this.svgHashId = "";
	        this.onlinePaymentServiceStatus = new windows_service_status_model_1.WindowsServiceStatusModel();
	        this.notBookedValue = "";
	        this.samePositionValue = "";
	        this.notBookedValueInterval = "";
	        this.samePositionValueInterval = "";
	        this.roleLevel = config_1.RoleLevel;
	        this.icon = {
	            available: {
	                icon: greenIcon
	            },
	            unavailable: {
	                icon: grayIcon
	            },
	            inuse: {
	                icon: blueIcon
	            },
	            priority1: {
	                icon: redIcon
	            },
	            priority2: {
	                icon: orangeIcon
	            }
	        };
	    }
	    AdminDashboardComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.InitDefaultValue();
	        //this.UpdateMarkerOnMap();
	        this.GetWindowsServiceStatus();
	        this.intervalHandler = setInterval(function () { return _this.GetPaymentServiceStatus(); }, config_1.WeGoConfig.ONLINE_PAYMENT_SERVICE_REFRESH_INTERVAL_SEC * 1000);
	        this.GetPaymentServiceStatus();
	    };
	    AdminDashboardComponent.prototype.OnSearch = function ($event) {
	        this.instanceHashId = $event.instanceHashId;
	        this.companyHashId = $event.companyHashId;
	        this.svgHashId = $event.svgHashId;
	        this.vehicleIssuePriorityList = $event.vehicleIssuePriorityList;
	        this.dashboardConfig = $event.dashboardConfig;
	        this.notBookedValue = $event.notBookedValue;
	        this.samePositionValue = $event.samePositionValue;
	        this.notBookedValueInterval = $event.notBookedValueInterval;
	        this.samePositionValueInterval = $event.samePositionValueInterval;
	        console.log(this.dashboardConfig);
	        this.RetriveFilter();
	        this.HandleDefaultDashboardConfig();
	        this.HandleAutoUpdateInterval();
	        this.HandleOverLappingMarker();
	        this.UpdateMarkerOnMap();
	    };
	    AdminDashboardComponent.prototype.InitDefaultValue = function () {
	        this.markers = [];
	        this.vehicleList = [];
	        this.filterEnable = true;
	        this.dashboardConfig = new instance_model_1.DashboardConfigModel();
	        this.HandleDefaultDashboardConfig();
	        this.urlVehicleInfo = this.authService.GetURL(config_1.ApplicationRouteURL.URL_VEHICLE_INFO);
	        console.log(this.urlVehicleInfo);
	        this.map = new google.maps.Map(document.getElementById("map"), {
	            center: { lat: 52.3702164, lng: 4.895168 },
	            zoom: 13,
	            zoomControlOptions: {
	                position: google.maps.ControlPosition.LEFT_TOP
	            }
	        });
	        this.infoWindow = new google.maps.InfoWindow();
	    };
	    AdminDashboardComponent.prototype.HandleOverLappingMarker = function () {
	        var _this = this;
	        this.markerSpiderfier = new overlappingMarkerSpiderfier(this.map, {
	            keepSpiderfied: true,
	            circleFootSeparation: 60,
	            nearbyDistance: 50
	        });
	        this.markerSpiderfier.addListener("unspiderfy", function (tempmarkers) {
	            tempmarkers.forEach(function (tempmarker) {
	                _this.infoWindow.close();
	            });
	        });
	        this.markerSpiderfier.addListener("spiderfy", function (tempmarkers) {
	            tempmarkers.forEach(function (tempmarker) {
	                _this.infoWindow.close();
	            });
	        });
	        google.maps.event.addListener(this.map, "click", function (event) {
	            _this.infoWindow.close();
	        });
	    };
	    AdminDashboardComponent.prototype.HandleDefaultDashboardConfig = function () {
	        this.enableCurrentLocation = this.dashboardConfig.enableCurrentLocation;
	        if (this.filtervehicleLocationType &&
	            (this.filtervehicleLocationType != "CURRENT" ||
	                this.enableCurrentLocation)) {
	            this.vehicleLocationType = this.filtervehicleLocationType;
	            this.filtervehicleLocationType = null;
	        }
	        else {
	            this.vehicleLocationType = this.dashboardConfig.defaultLocation;
	        }
	        if (this.filterselectedStatus) {
	            this.selectedStatus = this.filterselectedStatus;
	            this.filterselectedStatus = null;
	        }
	        else {
	            this.selectedStatus = this.dashboardConfig.defaultStatus;
	        }
	    };
	    AdminDashboardComponent.prototype.HandleAutoUpdateInterval = function () {
	        var _this = this;
	        if (this.autoUpdateTimer) {
	            clearInterval(this.autoUpdateTimer);
	        }
	        var updateInterval = parseInt(this.dashboardConfig.updateIntervalInSecond);
	        if (this.enableCurrentLocation &&
	            this.vehicleLocationType == "CURRENT" &&
	            isFinite(updateInterval) &&
	            updateInterval >= 15) {
	            this.autoUpdateTimer = setInterval(function () { return _this.UpdateMarkerOnMap(); }, updateInterval * 1000);
	        }
	    };
	    AdminDashboardComponent.prototype.GetWindowsServiceStatus = function () {
	        var _this = this;
	        this.adminDashboardService.GetWindowsServiceStatus().subscribe(function (res) {
	            _this.windowsServiceStatusList = res.data;
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    AdminDashboardComponent.prototype.ChangeVehicleLocationType = function (locationType) {
	        this.vehicleLocationType = locationType;
	        this.HandleAutoUpdateInterval();
	        this.AddMarkers();
	    };
	    AdminDashboardComponent.prototype.FilterVehicleStatus = function () {
	        this.AddMarkers();
	    };
	    AdminDashboardComponent.prototype.ToggleFilter = function () {
	        var _this = this;
	        this.filterEnable = !this.filterEnable;
	        setTimeout(function () {
	            var center = _this.map.getCenter();
	            google.maps.event.trigger(_this.map, "resize");
	            _this.map.setCenter(center);
	        }, 1000);
	    };
	    AdminDashboardComponent.prototype.UpdateMarkerOnMap = function () {
	        var _this = this;
	        console.log("New Vehicle Data");
	        this.adminDashboardService
	            .GetVehicleWithStatus(this.instanceHashId, this.companyHashId, this.svgHashId)
	            .subscribe(function (res) {
	            _this.vehicleList = res.data;
	            _this.AddMarkers();
	            // this.isLoading = false;
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	            // this.isLoading = false;
	        });
	    };
	    AdminDashboardComponent.prototype.ExportVehicleStatus = function () {
	        var _this = this;
	        this.adminDashboardService
	            .ExportVehicleWithStatusXls(this.instanceHashId, this.companyHashId, this.svgHashId)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "VehicleStatus" + new Date().toISOString() + ".xlsx";
	                _this.authService.DownloadXlsFile(fileName, res._body);
	            }
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    AdminDashboardComponent.prototype.AddMarkers = function () {
	        var _this = this;
	        var filterVehicleList = this.vehicleList.filter(function (x) {
	            return _this.selectedStatus == "ALL" ||
	                _this.selectedStatus.toUpperCase() == x.vehicleStatus.toUpperCase();
	        });
	        this.RemoveMarkers();
	        filterVehicleList.forEach(function (element) {
	            var locationType = _this.vehicleLocationType == "CURRENT"
	                ? "currentLocation"
	                : "homeLocation";
	            if (element[locationType] &&
	                element[locationType]["latitude"] &&
	                element[locationType]["longitude"]) {
	                var marker_1 = new MarkerWithLabel({
	                    position: new google.maps.LatLng(element[locationType]["latitude"], element[locationType]["longitude"]),
	                    icon: _this.icon[element.vehicleStatus.toLowerCase()].icon,
	                    map: _this.map,
	                    labelContent: element.licenceTag,
	                    labelAnchor: new google.maps.Point(32, 0),
	                    labelClass: "markerMapLabels",
	                    labelStyle: { opacity: 0.75 }
	                });
	                _this.markers.push(marker_1);
	                marker_1.addListener("click", function () {
	                    return _this.OpenInfoWindow(_this.map, marker_1, _this.infoWindow, element);
	                });
	                _this.markerSpiderfier.addMarker(marker_1);
	            }
	        });
	        setTimeout(function () {
	            _this.FitMarkerToBound();
	        }, 1000);
	    };
	    AdminDashboardComponent.prototype.RemoveMarkers = function () {
	        while (this.markers.length) {
	            this.markers.pop().setMap(null);
	        }
	    };
	    AdminDashboardComponent.prototype.FitMarkerToBound = function () {
	        var _this = this;
	        if (this.markers && this.markers.length > 0) {
	            var bound = new google.maps.LatLngBounds();
	            for (var i in this.markers) {
	                bound.extend(this.markers[i].getPosition());
	            }
	            this.map.fitBounds(bound);
	            var zoomChangeBoundsListener_1 = google.maps.event.addListenerOnce(this.map, "bounds_changed", function (event) {
	                if (_this.map.getZoom() > 15) {
	                    _this.map.setZoom(15);
	                }
	            });
	            setTimeout(function () {
	                google.maps.event.removeListener(zoomChangeBoundsListener_1);
	            }, 2000);
	        }
	    };
	    AdminDashboardComponent.prototype.OpenInfoWindow = function (map, marker, infoWindow, contentItems) {
	        var LblVehicleOwner = this.translateService.instant("LblVehicleOwner");
	        var LblLicenceTag = this.translateService.instant("LblLicenceTag");
	        var LblApkExpirationDateCet = this.translateService.instant("LblApkExpirationDateCet");
	        var LblBrand = this.translateService.instant("LblBrand");
	        var LblType = this.translateService.instant("LblType");
	        var LblInstance = this.translateService.instant("LblInstance");
	        var priorityContent = this.GeneratePriorityContent(contentItems);
	        var instanceDetail = this.authService.GetHighestRoleLevel() <= config_1.RoleLevel.Instance
	            ? "<div><b>" +
	                LblInstance +
	                " : </b> " +
	                contentItems.instanceName +
	                "</div>"
	            : "";
	        // let vehicleURL = `/#` + this.urlVehicleInfo + `;vehicleHashId=` + contentItems.vehicleHashId;
	        var vehicleURL = "/#" + this.urlVehicleInfo + "/" + contentItems.vehicleHashId;
	        var content = "";
	        if (contentItems.isLinkEnable) {
	            content +=
	                "<div>\n      <div><b>" +
	                    LblLicenceTag +
	                    " : </b> <a href=\"" +
	                    vehicleURL +
	                    "\">" +
	                    contentItems.licenceTag +
	                    "</a> </div>\n      <div><b>" +
	                    LblBrand +
	                    " : </b> " +
	                    this.HandleEmptyValue(contentItems.brand) +
	                    "</div>\n      <div><b>" +
	                    LblType +
	                    " : </b> " +
	                    this.HandleEmptyValue(contentItems.type) +
	                    "</div>\n      <div><b>" +
	                    LblVehicleOwner +
	                    " : </b> " +
	                    contentItems.vehicleOwner +
	                    "</div>" +
	                    instanceDetail +
	                    "\n      <div><b>" +
	                    LblApkExpirationDateCet +
	                    " : </b> " +
	                    this.HandleEmptyValue(contentItems.apkMaintenanceDateCETFormat) +
	                    "</div>\n      <div>" +
	                    priorityContent +
	                    "</div>\n      </div>";
	        }
	        else {
	            content +=
	                "<div>\n      <div><b>" +
	                    LblLicenceTag +
	                    " : </b>" +
	                    contentItems.licenceTag +
	                    "</div>\n      <div><b>" +
	                    LblBrand +
	                    " : </b> " +
	                    this.HandleEmptyValue(contentItems.brand) +
	                    "</div>\n      <div><b>" +
	                    LblType +
	                    " : </b> " +
	                    this.HandleEmptyValue(contentItems.type) +
	                    "</div>\n      <div><b>" +
	                    LblVehicleOwner +
	                    " : </b> " +
	                    contentItems.vehicleOwner +
	                    "</div>" +
	                    instanceDetail +
	                    "\n      <div><b>" +
	                    LblApkExpirationDateCet +
	                    " : </b> " +
	                    this.HandleEmptyValue(contentItems.apkMaintenanceDateCETFormat) +
	                    "</div>\n      <div>" +
	                    priorityContent +
	                    "</div>\n      </div>";
	        }
	        infoWindow.setContent(content);
	        infoWindow.open(this.map, marker);
	    };
	    AdminDashboardComponent.prototype.GeneratePriorityContent = function (contentItems) {
	        var _this = this;
	        var LblPriority = this.translateService.instant("LblPriority");
	        var content = "<br><div><b>" + LblPriority + " 1</b></div>";
	        content += "<table><tbody>";
	        contentItems.listOfVehicleIssue
	            .filter(function (x) { return x.priority == "PRIORITY1"; })
	            .forEach(function (item) {
	            content +=
	                "<tr>" +
	                    "<td style=\"width: 235px\">" +
	                    _this.GetLabelFromType(item.type) +
	                    "</td>" +
	                    (item.issueFound
	                        ? "<td><i class=\"fa fa-times text-danger\" aria-hidden=\"true\"></i>&nbsp;</td>"
	                        : "<td><i class=\"fa fa-check text-success\" aria-hidden=\"true\"></i>&nbsp;</td>") +
	                    "</tr>";
	        });
	        content += "</tbody></table>";
	        content += "<br><div><b>" + LblPriority + " 2</b></div>";
	        content += "<table><tbody>";
	        contentItems.listOfVehicleIssue
	            .filter(function (x) { return x.priority == "PRIORITY2"; })
	            .forEach(function (item) {
	            content +=
	                "<tr>" +
	                    "<td style=\"width: 235px\">" +
	                    _this.GetLabelFromType(item.type) +
	                    "</td>" +
	                    (item.issueFound
	                        ? "<td><i class=\"fa fa-times text-danger\" aria-hidden=\"true\"></i>&nbsp;</td>"
	                        : "<td><i class=\"fa fa-check text-success\" aria-hidden=\"true\"></i>&nbsp;</td>") +
	                    "</tr>";
	        });
	        content += "</tbody></table>";
	        return content;
	    };
	    AdminDashboardComponent.prototype.HandleEmptyValue = function (value) {
	        var LblNA = this.translateService.instant("LblNA");
	        if (value != null && value)
	            return value;
	        else
	            return LblNA;
	    };
	    AdminDashboardComponent.prototype.GetPriorityLegend = function (listOfVehicleIssue, priority) {
	        if (listOfVehicleIssue) {
	            return listOfVehicleIssue.filter(function (x) { return x.priority == priority; });
	        }
	    };
	    AdminDashboardComponent.prototype.GetLabelFromType = function (issueType) {
	        switch (issueType) {
	            case "DamageReported":
	                return this.translateService.instant("LblTypeDamage");
	            case "APKMaintananceScheduled":
	                return this.translateService.instant("LblTypeMaintenance");
	            case "OutSideGeofence":
	                return this.translateService.instant("LblOutsideGeofence");
	            case "VehicleSamePosition":
	                return this.translateService.instant("LblTypeOnSamePosition", [
	                    this.samePositionValue == "" ? "0" : this.samePositionValue,
	                    this.samePositionValueInterval
	                ]);
	            case "VehicleNotReturn":
	                return this.translateService.instant("LblTypeNotReturn");
	            case "VehicleNotBooked":
	                return this.translateService.instant("LblTypeNotBooked", [
	                    this.notBookedValue == "" ? "0" : this.notBookedValue,
	                    this.notBookedValueInterval
	                ]);
	            case "CleaningRequired":
	                return this.translateService.instant("LblCleaning");
	            case "RefuelingRequired":
	                return this.translateService.instant("LblRefueling");
	            case "LowBattery":
	                return this.translateService.instant("LblLowBattery");
	            case "LowCharge":
	                return this.translateService.instant("LblLowCharge");
	            case "CommunicationProblem":
	                return this.translateService.instant("LblCommunicationProblem");
	            case "InvalidTagUsed":
	                return this.translateService.instant("LblInvalidTagUsed");
	            default:
	                return this.translateService.instant("LblNA");
	        }
	    };
	    AdminDashboardComponent.prototype.RetriveFilter = function () {
	        var filter = this.authService.AssignFromStorage(this.constructor.name + "_model", null);
	        if (filter) {
	            this.filtervehicleLocationType = filter["vehicleLocationType"];
	            this.filterselectedStatus = filter["selectedStatus"];
	        }
	    };
	    AdminDashboardComponent.prototype.GetPaymentServiceStatus = function () {
	        var _this = this;
	        this.adminDashboardService.GetPaymentServiceStatus().subscribe(function (res) {
	            _this.onlinePaymentServiceStatus = res.data;
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    AdminDashboardComponent.prototype.ngOnDestroy = function () {
	        if (this.autoUpdateTimer) {
	            clearInterval(this.autoUpdateTimer);
	        }
	        if (this.intervalHandler) {
	            clearInterval(this.intervalHandler);
	        }
	        this.authService.SaveToStorage(this.constructor.name + "_model", {
	            vehicleLocationType: this.vehicleLocationType,
	            selectedStatus: this.selectedStatus
	        });
	    };
	    AdminDashboardComponent = __decorate([
	        core_1.Component({
	            selector: "map",
	            template: __webpack_require__(524),
	            styles: [__webpack_require__(525)],
	            providers: [admin_dashboard_service_1.AdminDashboardService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof admin_dashboard_service_1.AdminDashboardService !== 'undefined' && admin_dashboard_service_1.AdminDashboardService) === 'function' && _a) || Object, (typeof (_b = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object])
	    ], AdminDashboardComponent);
	    return AdminDashboardComponent;
	    var _a, _b, _c;
	}());
	exports.AdminDashboardComponent = AdminDashboardComponent;


/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var direct_debitfile_config_model_1 = __webpack_require__(514);
	var vat_settings_model_1 = __webpack_require__(515);
	var InstanceModel = (function () {
	    function InstanceModel() {
	        this.preferredLanguage = "";
	        this.timeZone = "";
	        this.isBookingApprovalReq = false;
	        this.bookingCancelTime = "3600";
	        this.bookingTemporaryTime = "300";
	        this.vtsRequestTimeout = "1800";
	        this.vtsTriplogTimeout = "1800";
	        this.fromEmail = "";
	        this.defaultEmailConfig = true;
	        this.host = "";
	        this.port = "";
	        this.userName = "";
	        this.password = "";
	        this.enablessl = false;
	        this.countryCode = "";
	        this.isImportPersonAllow = false;
	        this.validateLiceanceNumber = false;
	        this.validateLicense24IDCheck = 2;
	        this.importConnectionType = 0;
	        this.validateLicenseCheckForBooking = false;
	        this.dayOfWeek = "";
	        this.damageImageExtensions = "";
	        this.sendInvoiceToDriver = "YES";
	        this.sendInvoiceToOrganization = "YES";
	        this.isGefenceEnabled = false;
	        //public isCreateOrganizationEnabled: boolean = false;
	        this.enableSnailTrail = false;
	        this.vehicleAtSameLocationTime = "";
	        this.vehicleAtSameLocationTimeInterval = "";
	        this.noBookingInTime = "";
	        this.noBookingInTimeInterval = "";
	        this.appSupportTo = "";
	        this.customerMasterHashId = "";
	        this.customerName = "";
	        this.locationMode = "HOME";
	        this.enableBookingCalendarInfo = false;
	        this.enableBatchUploadPersonInfo = false;
	        this.vatSettingDefaultCost = true;
	        // Mobile App Configuration
	        this.enableNewBooking = true;
	        this.enableBookingCalender = true;
	        this.enableSubscription = true;
	        this.enableUpdateProfile = true;
	        this.enableNotification = true;
	        this.enableChangeBooking = true;
	        this.enableAddExpenseMenu = true;
	        this.isPaymentRequired = false;
	        this.userBlockMessage = "";
	        // Afas
	        this.afasClientId = "";
	        this.afasConnectorName = "";
	        this.afasConnectionType = "";
	        this.afasToken = "";
	        // Azure
	        this.azureTenantId = "";
	        this.azureClientId = "";
	        this.azureClientSecret = "";
	        //SSO
	        this.defaultSsoSharedVehicleGroupHashId = "";
	        this.defaultSsoOrganizationHashId = "";
	        this.defaultSsoSubscriptionHashId = "";
	        //Dropoff Message
	        this.dropOffExternalUrl = "";
	        this.dropOffApiKey = "";
	        this.dropOffActive = false;
	        //NIF Number
	        this.enableNIFNumber = false;
	        this.validateLicenseForAllBookings = true;
	        this.geofenceAttributeModel = new GeofenceAttributeModel();
	        this.geofenceNotificationModel = new InstanceNotificationModel();
	        this.apkMaintenanceNotificationModel = new InstanceNotificationModel();
	        this.odometerNotificationModel = new InstanceNotificationModel();
	        this.reportDamageNotificationModel = new InstanceNotificationModel();
	        this.vehicleSameLocationNotificationModel = new InstanceNotificationModel();
	        this.vehicleNotReturnNotificationModel = new InstanceNotificationModel();
	        this.vehicleNotBookedNotificationModel = new InstanceNotificationModel();
	        this.cleaningRequiredNotificationModel = new InstanceNotificationModel();
	        this.refuelingRequiredNotificationModel = new InstanceNotificationModel();
	        this.lowBatteryNotificationModel = new InstanceNotificationModel();
	        this.lowChargeNotificationModel = new InstanceNotificationModel();
	        this.communicationProblemNotificationModel = new InstanceNotificationModel();
	        this.invalidTagScansNotificationModel = new InstanceNotificationModel();
	        this.bookingCalendarSettingModel = new BookingCalendarSettingModel();
	        this.odometerConfigurationModel = new OdometerConfigurationModel();
	        this.directDebitfileConfigModel = new direct_debitfile_config_model_1.DirectDebitfileConfigModel();
	        this.directDebitfileConfigModel.fileLevel = "COMPANY";
	        this.batchUploadPersonConfigurationModel = new BatchUploadPersonConfigurationModel();
	        this.dashboardConfigModel = new DashboardConfigModel();
	        //this.instanceNotifictionDashbordStatusModel = new InstanceNotifictionDashbordStatusModel();
	        this.brandingTemplateConfig = new BrandingTemplateConfig();
	        // this.vehicleOccupencyReportModulerightsModel = new ModuleRightsModel();
	        // this.revenuePerVehicleReportModulerightsModel = new ModuleRightsModel();
	        // this.tripDataReportReportModulerightsModel = new ModuleRightsModel();
	        // this.maintanancePlanningReportModulerightsModel = new ModuleRightsModel();
	        this.bookingDelayConfig = new BookingDelayConfigurationModel();
	        this.bookingDelayConfig.enabled = "NO";
	        this.vatSettingsList = new Array();
	        this.vatDefaultRate = new vat_settings_model_1.VatDefaultModel();
	        this.gdprSettingsModel = new GdprSettingsModel();
	        this.carwiseConfigurationModel = new CarwiseConfigurationModel();
	        this.currencyConfigurationModel = new CurrencyConfigurationModel();
	        this.customTripQuestionList = new Array();
	        this.twoFAConfig = new TwoFAConfigModel();
	    }
	    return InstanceModel;
	}());
	exports.InstanceModel = InstanceModel;
	var GeofenceAttributeModel = (function () {
	    function GeofenceAttributeModel() {
	    }
	    return GeofenceAttributeModel;
	}());
	exports.GeofenceAttributeModel = GeofenceAttributeModel;
	var CarwiseConfigurationModel = (function () {
	    function CarwiseConfigurationModel() {
	        this.isCarwiseEnabled = false;
	    }
	    return CarwiseConfigurationModel;
	}());
	exports.CarwiseConfigurationModel = CarwiseConfigurationModel;
	var InstanceNotificationModel = (function () {
	    function InstanceNotificationModel() {
	        this.priority = "NA";
	    }
	    return InstanceNotificationModel;
	}());
	exports.InstanceNotificationModel = InstanceNotificationModel;
	var BookingCalendarSettingModel = (function () {
	    function BookingCalendarSettingModel() {
	    }
	    return BookingCalendarSettingModel;
	}());
	exports.BookingCalendarSettingModel = BookingCalendarSettingModel;
	var OdometerConfigurationModel = (function () {
	    function OdometerConfigurationModel() {
	        this.enabled = "INHERIT";
	        this.enabledOnApp = false;
	        this.timeInterval = "";
	    }
	    return OdometerConfigurationModel;
	}());
	exports.OdometerConfigurationModel = OdometerConfigurationModel;
	var BatchUploadPersonConfigurationModel = (function () {
	    function BatchUploadPersonConfigurationModel() {
	        // public companyAdmin: boolean = true;
	        // public groupAdmin: boolean = true;
	        // public organizationAdmin: boolean = true;
	        this.sendActivationMail = true;
	        this.generateRandom_UseUploadedPassword = true;
	    }
	    return BatchUploadPersonConfigurationModel;
	}());
	exports.BatchUploadPersonConfigurationModel = BatchUploadPersonConfigurationModel;
	var DashboardConfigModel = (function () {
	    function DashboardConfigModel() {
	        this.enableCurrentLocation = false;
	        this.defaultLocation = "HOME";
	        this.defaultStatus = "ALL";
	        this.enableAutoUpdate = false;
	    }
	    return DashboardConfigModel;
	}());
	exports.DashboardConfigModel = DashboardConfigModel;
	var BrandingTemplateConfig = (function () {
	    function BrandingTemplateConfig() {
	        this.ui = "INSTANCE";
	        this.nonBooking = "INSTANCE";
	        this.booking = "INSTANCE";
	        this.invoice = "INSTANCE";
	    }
	    return BrandingTemplateConfig;
	}());
	exports.BrandingTemplateConfig = BrandingTemplateConfig;
	// export class ModuleRightsModel {
	//   public modulerightsHashId: string;
	//   public moduleName: string;
	//   public companyAdmin: boolean;
	//   public groupAdmin: boolean;
	// }
	var BookingDelayConfigurationModel = (function () {
	    function BookingDelayConfigurationModel() {
	    }
	    return BookingDelayConfigurationModel;
	}());
	exports.BookingDelayConfigurationModel = BookingDelayConfigurationModel;
	var GdprSettingsModel = (function () {
	    function GdprSettingsModel() {
	    }
	    return GdprSettingsModel;
	}());
	exports.GdprSettingsModel = GdprSettingsModel;
	var CurrencyConfigurationModel = (function () {
	    function CurrencyConfigurationModel() {
	        this.currencyAbbreviation = "";
	        this.currencySignBeforeAmount = true;
	    }
	    return CurrencyConfigurationModel;
	}());
	exports.CurrencyConfigurationModel = CurrencyConfigurationModel;
	var TwoFAConfigModel = (function () {
	    function TwoFAConfigModel() {
	        this.twoFAConfigHashId = "";
	        this.enabled = 'INHERIT';
	        this.expirationDays = 0;
	    }
	    return TwoFAConfigModel;
	}());
	exports.TwoFAConfigModel = TwoFAConfigModel;
	var SharedVehicleGroupDropdownModel = (function () {
	    function SharedVehicleGroupDropdownModel() {
	    }
	    return SharedVehicleGroupDropdownModel;
	}());
	exports.SharedVehicleGroupDropdownModel = SharedVehicleGroupDropdownModel;


/***/ },
/* 514 */
/***/ function(module, exports) {

	"use strict";
	var DirectDebitfileConfigModel = (function () {
	    function DirectDebitfileConfigModel() {
	        this.enableFileGeneration = false;
	        this.countryCode = "NL";
	    }
	    return DirectDebitfileConfigModel;
	}());
	exports.DirectDebitfileConfigModel = DirectDebitfileConfigModel;


/***/ },
/* 515 */
/***/ function(module, exports) {

	"use strict";
	var VatSettingsModel = (function () {
	    function VatSettingsModel() {
	    }
	    return VatSettingsModel;
	}());
	exports.VatSettingsModel = VatSettingsModel;
	var VatDefaultModel = (function () {
	    function VatDefaultModel() {
	        this.vatSettingDefaultCost = false;
	        this.defaultVatPenaltyCost = "";
	        this.defaultVatPeriodRates = "";
	        this.defaultVatTimeRates = "";
	        this.defaultVatDistanceRates = "";
	        this.defaultVatFixedRates = "";
	        this.defaultVatSubscriptionCost = "";
	    }
	    return VatDefaultModel;
	}());
	exports.VatDefaultModel = VatDefaultModel;


/***/ },
/* 516 */
/***/ function(module, exports) {

	"use strict";
	var WindowsServiceStatusModel = (function () {
	    function WindowsServiceStatusModel() {
	    }
	    return WindowsServiceStatusModel;
	}());
	exports.WindowsServiceStatusModel = WindowsServiceStatusModel;


/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/pin-green.942dc259cb935a01795a2c882513bbf4.png";

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/pin-blue.176d72bf513652ab99810563d1c44bac.png";

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/pin-orange.43d1d91038785a280f7077dac44db998.png";

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/pin-gray.b3d760a5e684867d53bde1233bbbb769.png";

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/pin-red.c7d8bd889cc7dc29a2641d3f1f74ba38.png";

/***/ },
/* 522 */
/***/ function(module, exports) {

	/**
	 * @name MarkerWithLabel for V3
	 * @version 1.1.9 [June 30, 2013]
	 * @author Gary Little (inspired by code from Marc Ridey of Google).
	 * @copyright Copyright 2012 Gary Little [gary at luxcentral.com]
	 * @fileoverview MarkerWithLabel extends the Google Maps JavaScript API V3
	 *  <code>google.maps.Marker</code> class.
	 *  <p>
	 *  MarkerWithLabel allows you to define markers with associated labels. As you would expect,
	 *  if the marker is draggable, so too will be the label. In addition, a marker with a label
	 *  responds to all mouse events in the same manner as a regular marker. It also fires mouse
	 *  events and "property changed" events just as a regular marker would. Version 1.1 adds
	 *  support for the raiseOnDrag feature introduced in API V3.3.
	 *  <p>
	 *  If you drag a marker by its label, you can cancel the drag and return the marker to its
	 *  original position by pressing the <code>Esc</code> key. This doesn't work if you drag the marker
	 *  itself because this feature is not (yet) supported in the <code>google.maps.Marker</code> class.
	 */
	
	/*!
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 *       http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */
	
	/*jslint browser:true */
	/*global document,google */
	
	/**
	 * @param {Function} childCtor Child class.
	 * @param {Function} parentCtor Parent class.
	 */
	function inherits(childCtor, parentCtor) {
	  /** @constructor */
	  function tempCtor() {};
	  tempCtor.prototype = parentCtor.prototype;
	  childCtor.superClass_ = parentCtor.prototype;
	  childCtor.prototype = new tempCtor();
	  /** @override */
	  childCtor.prototype.constructor = childCtor;
	}
	
	/**
	 * @param {Object} gMapsApi The Google Maps API instance (usually `google.maps`)
	 * @return {Function} The instantiable MarkerWithLabel class
	 */
	module.exports = function(gMapsApi) {
	
	  /**
	   * This constructor creates a label and associates it with a marker.
	   * It is for the private use of the MarkerWithLabel class.
	   * @constructor
	   * @param {Marker} marker The marker with which the label is to be associated.
	   * @param {string} crossURL The URL of the cross image =.
	   * @param {string} handCursor The URL of the hand cursor.
	   * @private
	   */
	  function MarkerLabel_(marker, crossURL, handCursorURL) {
	    this.marker_ = marker;
	    this.handCursorURL_ = marker.handCursorURL;
	
	    this.labelDiv_ = document.createElement("div");
	    this.labelDiv_.style.cssText = "position: absolute; overflow: hidden;";
	
	    // Set up the DIV for handling mouse events in the label. This DIV forms a transparent veil
	    // in the "overlayMouseTarget" pane, a veil that covers just the label. This is done so that
	    // events can be captured even if the label is in the shadow of a google.maps.InfoWindow.
	    // Code is included here to ensure the veil is always exactly the same size as the label.
	    this.eventDiv_ = document.createElement("div");
	    this.eventDiv_.style.cssText = this.labelDiv_.style.cssText;
	
	    // This is needed for proper behavior on MSIE:
	    this.eventDiv_.setAttribute("onselectstart", "return false;");
	    this.eventDiv_.setAttribute("ondragstart", "return false;");
	
	    // Get the DIV for the "X" to be displayed when the marker is raised.
	    this.crossDiv_ = MarkerLabel_.getSharedCross(crossURL);
	  }
	  inherits(MarkerLabel_, gMapsApi.OverlayView);
	
	  /**
	   * Returns the DIV for the cross used when dragging a marker when the
	   * raiseOnDrag parameter set to true. One cross is shared with all markers.
	   * @param {string} crossURL The URL of the cross image =.
	   * @private
	   */
	  MarkerLabel_.getSharedCross = function (crossURL) {
	    var div;
	    if (typeof MarkerLabel_.getSharedCross.crossDiv === "undefined") {
	      div = document.createElement("img");
	      div.style.cssText = "position: absolute; z-index: 1000002; display: none;";
	      // Hopefully Google never changes the standard "X" attributes:
	      div.style.marginLeft = "-8px";
	      div.style.marginTop = "-9px";
	      div.src = crossURL;
	      MarkerLabel_.getSharedCross.crossDiv = div;
	    }
	    return MarkerLabel_.getSharedCross.crossDiv;
	  };
	
	  /**
	   * Adds the DIV representing the label to the DOM. This method is called
	   * automatically when the marker's <code>setMap</code> method is called.
	   * @private
	   */
	  MarkerLabel_.prototype.onAdd = function () {
	    var me = this;
	    var cMouseIsDown = false;
	    var cDraggingLabel = false;
	    var cSavedZIndex;
	    var cLatOffset, cLngOffset;
	    var cIgnoreClick;
	    var cRaiseEnabled;
	    var cStartPosition;
	    var cStartCenter;
	    // Constants:
	    var cRaiseOffset = 20;
	    var cDraggingCursor = "url(" + this.handCursorURL_ + ")";
	
	    // Stops all processing of an event.
	    //
	    var cAbortEvent = function (e) {
	      if (e.preventDefault) {
	        e.preventDefault();
	      }
	      e.cancelBubble = true;
	      if (e.stopPropagation) {
	        e.stopPropagation();
	      }
	    };
	
	    var cStopBounce = function () {
	      me.marker_.setAnimation(null);
	    };
	
	    this.getPanes().markerLayer.appendChild(this.labelDiv_);
	    this.getPanes().overlayMouseTarget.appendChild(this.eventDiv_);
	    // One cross is shared with all markers, so only add it once:
	    if (typeof MarkerLabel_.getSharedCross.processed === "undefined") {
	      this.getPanes().markerLayer.appendChild(this.crossDiv_);
	      MarkerLabel_.getSharedCross.processed = true;
	    }
	
	    this.listeners_ = [
	      gMapsApi.event.addDomListener(this.eventDiv_, "mouseover", function (e) {
	        if (me.marker_.getDraggable() || me.marker_.getClickable()) {
	          this.style.cursor = "pointer";
	          gMapsApi.event.trigger(me.marker_, "mouseover", e);
	        }
	      }),
	      gMapsApi.event.addDomListener(this.eventDiv_, "mouseout", function (e) {
	        if ((me.marker_.getDraggable() || me.marker_.getClickable()) && !cDraggingLabel) {
	          this.style.cursor = me.marker_.getCursor();
	          gMapsApi.event.trigger(me.marker_, "mouseout", e);
	        }
	      }),
	      gMapsApi.event.addDomListener(this.eventDiv_, "mousedown", function (e) {
	        cDraggingLabel = false;
	        if (me.marker_.getDraggable()) {
	          cMouseIsDown = true;
	          this.style.cursor = cDraggingCursor;
	        }
	        if (me.marker_.getDraggable() || me.marker_.getClickable()) {
	          gMapsApi.event.trigger(me.marker_, "mousedown", e);
	          cAbortEvent(e); // Prevent map pan when starting a drag on a label
	        }
	      }),
	      gMapsApi.event.addDomListener(document, "mouseup", function (mEvent) {
	        var position;
	        if (cMouseIsDown) {
	          cMouseIsDown = false;
	          me.eventDiv_.style.cursor = "pointer";
	          gMapsApi.event.trigger(me.marker_, "mouseup", mEvent);
	        }
	        if (cDraggingLabel) {
	          if (cRaiseEnabled) { // Lower the marker & label
	            position = me.getProjection().fromLatLngToDivPixel(me.marker_.getPosition());
	            position.y += cRaiseOffset;
	            me.marker_.setPosition(me.getProjection().fromDivPixelToLatLng(position));
	            // This is not the same bouncing style as when the marker portion is dragged,
	            // but it will have to do:
	            try { // Will fail if running Google Maps API earlier than V3.3
	              me.marker_.setAnimation(gMapsApi.Animation.BOUNCE);
	              setTimeout(cStopBounce, 1406);
	            } catch (e) {}
	          }
	          me.crossDiv_.style.display = "none";
	          me.marker_.setZIndex(cSavedZIndex);
	          cIgnoreClick = true; // Set flag to ignore the click event reported after a label drag
	          cDraggingLabel = false;
	          mEvent.latLng = me.marker_.getPosition();
	          gMapsApi.event.trigger(me.marker_, "dragend", mEvent);
	        }
	      }),
	      gMapsApi.event.addListener(me.marker_.getMap(), "mousemove", function (mEvent) {
	        var position;
	        if (cMouseIsDown) {
	          if (cDraggingLabel) {
	            // Change the reported location from the mouse position to the marker position:
	            mEvent.latLng = new gMapsApi.LatLng(mEvent.latLng.lat() - cLatOffset, mEvent.latLng.lng() - cLngOffset);
	            position = me.getProjection().fromLatLngToDivPixel(mEvent.latLng);
	            if (cRaiseEnabled) {
	              me.crossDiv_.style.left = position.x + "px";
	              me.crossDiv_.style.top = position.y + "px";
	              me.crossDiv_.style.display = "";
	              position.y -= cRaiseOffset;
	            }
	            me.marker_.setPosition(me.getProjection().fromDivPixelToLatLng(position));
	            if (cRaiseEnabled) { // Don't raise the veil; this hack needed to make MSIE act properly
	              me.eventDiv_.style.top = (position.y + cRaiseOffset) + "px";
	            }
	            gMapsApi.event.trigger(me.marker_, "drag", mEvent);
	          } else {
	            // Calculate offsets from the click point to the marker position:
	            cLatOffset = mEvent.latLng.lat() - me.marker_.getPosition().lat();
	            cLngOffset = mEvent.latLng.lng() - me.marker_.getPosition().lng();
	            cSavedZIndex = me.marker_.getZIndex();
	            cStartPosition = me.marker_.getPosition();
	            cStartCenter = me.marker_.getMap().getCenter();
	            cRaiseEnabled = me.marker_.get("raiseOnDrag");
	            cDraggingLabel = true;
	            me.marker_.setZIndex(1000000); // Moves the marker & label to the foreground during a drag
	            mEvent.latLng = me.marker_.getPosition();
	            gMapsApi.event.trigger(me.marker_, "dragstart", mEvent);
	          }
	        }
	      }),
	      gMapsApi.event.addDomListener(document, "keydown", function (e) {
	        if (cDraggingLabel) {
	          if (e.keyCode === 27) { // Esc key
	            cRaiseEnabled = false;
	            me.marker_.setPosition(cStartPosition);
	            me.marker_.getMap().setCenter(cStartCenter);
	            gMapsApi.event.trigger(document, "mouseup", e);
	          }
	        }
	      }),
	      gMapsApi.event.addDomListener(this.eventDiv_, "click", function (e) {
	        if (me.marker_.getDraggable() || me.marker_.getClickable()) {
	          if (cIgnoreClick) { // Ignore the click reported when a label drag ends
	            cIgnoreClick = false;
	          } else {
	            gMapsApi.event.trigger(me.marker_, "click", e);
	            cAbortEvent(e); // Prevent click from being passed on to map
	          }
	        }
	      }),
	      gMapsApi.event.addDomListener(this.eventDiv_, "dblclick", function (e) {
	        if (me.marker_.getDraggable() || me.marker_.getClickable()) {
	          gMapsApi.event.trigger(me.marker_, "dblclick", e);
	          cAbortEvent(e); // Prevent map zoom when double-clicking on a label
	        }
	      }),
	      gMapsApi.event.addListener(this.marker_, "dragstart", function (mEvent) {
	        if (!cDraggingLabel) {
	          cRaiseEnabled = this.get("raiseOnDrag");
	        }
	      }),
	      gMapsApi.event.addListener(this.marker_, "drag", function (mEvent) {
	        if (!cDraggingLabel) {
	          if (cRaiseEnabled) {
	            me.setPosition(cRaiseOffset);
	            // During a drag, the marker's z-index is temporarily set to 1000000 to
	            // ensure it appears above all other markers. Also set the label's z-index
	            // to 1000000 (plus or minus 1 depending on whether the label is supposed
	            // to be above or below the marker).
	            me.labelDiv_.style.zIndex = 1000000 + (this.get("labelInBackground") ? -1 : +1);
	          }
	        }
	      }),
	      gMapsApi.event.addListener(this.marker_, "dragend", function (mEvent) {
	        if (!cDraggingLabel) {
	          if (cRaiseEnabled) {
	            me.setPosition(0); // Also restores z-index of label
	          }
	        }
	      }),
	      gMapsApi.event.addListener(this.marker_, "position_changed", function () {
	        me.setPosition();
	      }),
	      gMapsApi.event.addListener(this.marker_, "zindex_changed", function () {
	        me.setZIndex();
	      }),
	      gMapsApi.event.addListener(this.marker_, "visible_changed", function () {
	        me.setVisible();
	      }),
	      gMapsApi.event.addListener(this.marker_, "labelvisible_changed", function () {
	        me.setVisible();
	      }),
	      gMapsApi.event.addListener(this.marker_, "title_changed", function () {
	        me.setTitle();
	      }),
	      gMapsApi.event.addListener(this.marker_, "labelcontent_changed", function () {
	        me.setContent();
	      }),
	      gMapsApi.event.addListener(this.marker_, "labelanchor_changed", function () {
	        me.setAnchor();
	      }),
	      gMapsApi.event.addListener(this.marker_, "labelclass_changed", function () {
	        me.setStyles();
	      }),
	      gMapsApi.event.addListener(this.marker_, "labelstyle_changed", function () {
	        me.setStyles();
	      })
	    ];
	  };
	
	  /**
	   * Removes the DIV for the label from the DOM. It also removes all event handlers.
	   * This method is called automatically when the marker's <code>setMap(null)</code>
	   * method is called.
	   * @private
	   */
	  MarkerLabel_.prototype.onRemove = function () {
	    var i;
	    this.labelDiv_.parentNode.removeChild(this.labelDiv_);
	    this.eventDiv_.parentNode.removeChild(this.eventDiv_);
	
	    // Remove event listeners:
	    for (i = 0; i < this.listeners_.length; i++) {
	      gMapsApi.event.removeListener(this.listeners_[i]);
	    }
	  };
	
	  /**
	   * Draws the label on the map.
	   * @private
	   */
	  MarkerLabel_.prototype.draw = function () {
	    this.setContent();
	    this.setTitle();
	    this.setStyles();
	  };
	
	  /**
	   * Sets the content of the label.
	   * The content can be plain text or an HTML DOM node.
	   * @private
	   */
	  MarkerLabel_.prototype.setContent = function () {
	    var content = this.marker_.get("labelContent");
	    if (typeof content.nodeType === "undefined") {
	      this.labelDiv_.innerHTML = content;
	      this.eventDiv_.innerHTML = this.labelDiv_.innerHTML;
	    } else {
	      // Remove current content
	      while (this.labelDiv_.lastChild) {
	        this.labelDiv_.removeChild(this.labelDiv_.lastChild);
	      }
	
	      while (this.eventDiv_.lastChild) {
	        this.eventDiv_.removeChild(this.eventDiv_.lastChild);
	      }
	
	      this.labelDiv_.appendChild(content);
	      content = content.cloneNode(true);
	      this.eventDiv_.appendChild(content);
	    }
	  };
	
	  /**
	   * Sets the content of the tool tip for the label. It is
	   * always set to be the same as for the marker itself.
	   * @private
	   */
	  MarkerLabel_.prototype.setTitle = function () {
	    this.eventDiv_.title = this.marker_.getTitle() || "";
	  };
	
	  /**
	   * Sets the style of the label by setting the style sheet and applying
	   * other specific styles requested.
	   * @private
	   */
	  MarkerLabel_.prototype.setStyles = function () {
	    var i, labelStyle;
	
	    // Apply style values from the style sheet defined in the labelClass parameter:
	    this.labelDiv_.className = this.marker_.get("labelClass");
	    this.eventDiv_.className = this.labelDiv_.className;
	
	    // Clear existing inline style values:
	    this.labelDiv_.style.cssText = "";
	    this.eventDiv_.style.cssText = "";
	    // Apply style values defined in the labelStyle parameter:
	    labelStyle = this.marker_.get("labelStyle");
	    for (i in labelStyle) {
	      if (labelStyle.hasOwnProperty(i)) {
	        this.labelDiv_.style[i] = labelStyle[i];
	        this.eventDiv_.style[i] = labelStyle[i];
	      }
	    }
	    this.setMandatoryStyles();
	  };
	
	  /**
	   * Sets the mandatory styles to the DIV representing the label as well as to the
	   * associated event DIV. This includes setting the DIV position, z-index, and visibility.
	   * @private
	   */
	  MarkerLabel_.prototype.setMandatoryStyles = function () {
	    this.labelDiv_.style.position = "absolute";
	    this.labelDiv_.style.overflow = "hidden";
	    // Make sure the opacity setting causes the desired effect on MSIE:
	    if (typeof this.labelDiv_.style.opacity !== "undefined" && this.labelDiv_.style.opacity !== "") {
	      this.labelDiv_.style.MsFilter = "\"progid:DXImageTransform.Microsoft.Alpha(opacity=" + (this.labelDiv_.style.opacity * 100) + ")\"";
	      this.labelDiv_.style.filter = "alpha(opacity=" + (this.labelDiv_.style.opacity * 100) + ")";
	    }
	
	    this.eventDiv_.style.position = this.labelDiv_.style.position;
	    this.eventDiv_.style.overflow = this.labelDiv_.style.overflow;
	    this.eventDiv_.style.opacity = 0.01; // Don't use 0; DIV won't be clickable on MSIE
	    this.eventDiv_.style.MsFilter = "\"progid:DXImageTransform.Microsoft.Alpha(opacity=1)\"";
	    this.eventDiv_.style.filter = "alpha(opacity=1)"; // For MSIE
	
	    this.setAnchor();
	    this.setPosition(); // This also updates z-index, if necessary.
	    this.setVisible();
	  };
	
	  /**
	   * Sets the anchor point of the label.
	   * @private
	   */
	  MarkerLabel_.prototype.setAnchor = function () {
	    var anchor = this.marker_.get("labelAnchor");
	    this.labelDiv_.style.marginLeft = -anchor.x + "px";
	    this.labelDiv_.style.marginTop = -anchor.y + "px";
	    this.eventDiv_.style.marginLeft = -anchor.x + "px";
	    this.eventDiv_.style.marginTop = -anchor.y + "px";
	  };
	
	  /**
	   * Sets the position of the label. The z-index is also updated, if necessary.
	   * @private
	   */
	  MarkerLabel_.prototype.setPosition = function (yOffset) {
	    var position = this.getProjection().fromLatLngToDivPixel(this.marker_.getPosition());
	    if (typeof yOffset === "undefined") {
	      yOffset = 0;
	    }
	    this.labelDiv_.style.left = Math.round(position.x) + "px";
	    this.labelDiv_.style.top = Math.round(position.y - yOffset) + "px";
	    this.eventDiv_.style.left = this.labelDiv_.style.left;
	    this.eventDiv_.style.top = this.labelDiv_.style.top;
	
	    this.setZIndex();
	  };
	
	  /**
	   * Sets the z-index of the label. If the marker's z-index property has not been defined, the z-index
	   * of the label is set to the vertical coordinate of the label. This is in keeping with the default
	   * stacking order for Google Maps: markers to the south are in front of markers to the north.
	   * @private
	   */
	  MarkerLabel_.prototype.setZIndex = function () {
	    var zAdjust = (this.marker_.get("labelInBackground") ? -1 : +1);
	    if (typeof this.marker_.getZIndex() === "undefined") {
	      this.labelDiv_.style.zIndex = parseInt(this.labelDiv_.style.top, 10) + zAdjust;
	      this.eventDiv_.style.zIndex = this.labelDiv_.style.zIndex;
	    } else {
	      this.labelDiv_.style.zIndex = this.marker_.getZIndex() + zAdjust;
	      this.eventDiv_.style.zIndex = this.labelDiv_.style.zIndex;
	    }
	  };
	
	  /**
	   * Sets the visibility of the label. The label is visible only if the marker itself is
	   * visible (i.e., its visible property is true) and the labelVisible property is true.
	   * @private
	   */
	  MarkerLabel_.prototype.setVisible = function () {
	    if (this.marker_.get("labelVisible")) {
	      this.labelDiv_.style.display = this.marker_.getVisible() ? "block" : "none";
	    } else {
	      this.labelDiv_.style.display = "none";
	    }
	    this.eventDiv_.style.display = this.labelDiv_.style.display;
	  };
	
	  /**
	   * @name MarkerWithLabelOptions
	   * @class This class represents the optional parameter passed to the {@link MarkerWithLabel} constructor.
	   *  The properties available are the same as for <code>google.maps.Marker</code> with the addition
	   *  of the properties listed below. To change any of these additional properties after the labeled
	   *  marker has been created, call <code>google.maps.Marker.set(propertyName, propertyValue)</code>.
	   *  <p>
	   *  When any of these properties changes, a property changed event is fired. The names of these
	   *  events are derived from the name of the property and are of the form <code>propertyname_changed</code>.
	   *  For example, if the content of the label changes, a <code>labelcontent_changed</code> event
	   *  is fired.
	   *  <p>
	   * @property {string|Node} [labelContent] The content of the label (plain text or an HTML DOM node).
	   * @property {Point} [labelAnchor] By default, a label is drawn with its anchor point at (0,0) so
	   *  that its top left corner is positioned at the anchor point of the associated marker. Use this
	   *  property to change the anchor point of the label. For example, to center a 50px-wide label
	   *  beneath a marker, specify a <code>labelAnchor</code> of <code>google.maps.Point(25, 0)</code>.
	   *  (Note: x-values increase to the right and y-values increase to the top.)
	   * @property {string} [labelClass] The name of the CSS class defining the styles for the label.
	   *  Note that style values for <code>position</code>, <code>overflow</code>, <code>top</code>,
	   *  <code>left</code>, <code>zIndex</code>, <code>display</code>, <code>marginLeft</code>, and
	   *  <code>marginTop</code> are ignored; these styles are for internal use only.
	   * @property {Object} [labelStyle] An object literal whose properties define specific CSS
	   *  style values to be applied to the label. Style values defined here override those that may
	   *  be defined in the <code>labelClass</code> style sheet. If this property is changed after the
	   *  label has been created, all previously set styles (except those defined in the style sheet)
	   *  are removed from the label before the new style values are applied.
	   *  Note that style values for <code>position</code>, <code>overflow</code>, <code>top</code>,
	   *  <code>left</code>, <code>zIndex</code>, <code>display</code>, <code>marginLeft</code>, and
	   *  <code>marginTop</code> are ignored; these styles are for internal use only.
	   * @property {boolean} [labelInBackground] A flag indicating whether a label that overlaps its
	   *  associated marker should appear in the background (i.e., in a plane below the marker).
	   *  The default is <code>false</code>, which causes the label to appear in the foreground.
	   * @property {boolean} [labelVisible] A flag indicating whether the label is to be visible.
	   *  The default is <code>true</code>. Note that even if <code>labelVisible</code> is
	   *  <code>true</code>, the label will <i>not</i> be visible unless the associated marker is also
	   *  visible (i.e., unless the marker's <code>visible</code> property is <code>true</code>).
	   * @property {boolean} [raiseOnDrag] A flag indicating whether the label and marker are to be
	   *  raised when the marker is dragged. The default is <code>true</code>. If a draggable marker is
	   *  being created and a version of Google Maps API earlier than V3.3 is being used, this property
	   *  must be set to <code>false</code>.
	   * @property {boolean} [optimized] A flag indicating whether rendering is to be optimized for the
	   *  marker. <b>Important: The optimized rendering technique is not supported by MarkerWithLabel,
	   *  so the value of this parameter is always forced to <code>false</code>.
	   * @property {string} [crossImage="http://maps.gstatic.com/intl/en_us/mapfiles/drag_cross_67_16.png"]
	   *  The URL of the cross image to be displayed while dragging a marker.
	   * @property {string} [handCursor="http://maps.gstatic.com/intl/en_us/mapfiles/closedhand_8_8.cur"]
	   *  The URL of the cursor to be displayed while dragging a marker.
	   */
	  /**
	   * Creates a MarkerWithLabel with the options specified in {@link MarkerWithLabelOptions}.
	   * @constructor
	   * @param {MarkerWithLabelOptions} [opt_options] The optional parameters.
	   */
	  function MarkerWithLabel(opt_options) {
	    opt_options = opt_options || {};
	    opt_options.labelContent = opt_options.labelContent || "";
	    opt_options.labelAnchor = opt_options.labelAnchor || new gMapsApi.Point(0, 0);
	    opt_options.labelClass = opt_options.labelClass || "markerLabels";
	    opt_options.labelStyle = opt_options.labelStyle || {};
	    opt_options.labelInBackground = opt_options.labelInBackground || false;
	    if (typeof opt_options.labelVisible === "undefined") {
	      opt_options.labelVisible = true;
	    }
	    if (typeof opt_options.raiseOnDrag === "undefined") {
	      opt_options.raiseOnDrag = true;
	    }
	    if (typeof opt_options.clickable === "undefined") {
	      opt_options.clickable = true;
	    }
	    if (typeof opt_options.draggable === "undefined") {
	      opt_options.draggable = false;
	    }
	    if (typeof opt_options.optimized === "undefined") {
	      opt_options.optimized = false;
	    }
	    opt_options.crossImage = opt_options.crossImage || "http" + (document.location.protocol === "https:" ? "s" : "") + "://maps.gstatic.com/intl/en_us/mapfiles/drag_cross_67_16.png";
	    opt_options.handCursor = opt_options.handCursor || "http" + (document.location.protocol === "https:" ? "s" : "") + "://maps.gstatic.com/intl/en_us/mapfiles/closedhand_8_8.cur";
	    opt_options.optimized = false; // Optimized rendering is not supported
	
	    this.label = new MarkerLabel_(this, opt_options.crossImage, opt_options.handCursor); // Bind the label to the marker
	
	    // Call the parent constructor. It calls Marker.setValues to initialize, so all
	    // the new parameters are conveniently saved and can be accessed with get/set.
	    // Marker.set triggers a property changed event (called "propertyname_changed")
	    // that the marker label listens for in order to react to state changes.
	    gMapsApi.Marker.apply(this, arguments);
	  }
	  inherits(MarkerWithLabel, gMapsApi.Marker);
	
	  /**
	   * Overrides the standard Marker setMap function.
	   * @param {Map} theMap The map to which the marker is to be added.
	   * @private
	   */
	  MarkerWithLabel.prototype.setMap = function (theMap) {
	
	    // Call the inherited function...
	    gMapsApi.Marker.prototype.setMap.apply(this, arguments);
	
	    // ... then deal with the label:
	    this.label.setMap(theMap);
	  };
	
	  return MarkerWithLabel;
	}


/***/ },
/* 523 */
/***/ function(module, exports) {

	// Generated by CoffeeScript 1.10.0
	
	/** @preserve OverlappingMarkerSpiderfier
	https://github.com/jawj/OverlappingMarkerSpiderfier
	Copyright (c) 2011 - 2013 George MacKerron
	Released under the MIT licence: http://opensource.org/licenses/mit-license
	Note: The Google Maps API v3 must be included *before* this code
	 */
	var hasProp = {}.hasOwnProperty,
	  slice = [].slice;
	
	this['OverlappingMarkerSpiderfier'] = (function() {
	  var ge, gm, lcH, lcU, mt, p, twoPi;
	
	  p = _Class.prototype;
	
	  gm = google.maps;
	
	  ge = gm.event;
	
	  mt = gm.MapTypeId;
	
	  twoPi = Math.PI * 2;
	
	  p['keepSpiderfied'] = false;
	
	  p['markersWontHide'] = false;
	
	  p['markersWontMove'] = false;
	
	  p['spiderfiedShadowColor'] = 'white';
	
	  p['nudgeStackedMarkers'] = true;
	
	  p['minNudgeZoomLevel'] = 8;
	
	  p['nudgeRadius'] = 1;
	
	  p['markerCountInBaseNudgeLevel'] = 9;
	
	  p['maxNudgeCount'] = 9;
	
	  p['nudgeBucketSize'] = 12;
	
	  p['nearbyDistance'] = 20;
	
	  p['circleSpiralSwitchover'] = 9;
	
	  p['circleFootSeparation'] = 23;
	
	  p['circleStartAngle'] = twoPi / 12;
	
	  p['spiralFootSeparation'] = 26;
	
	  p['spiralLengthStart'] = 11;
	
	  p['spiralLengthFactor'] = 4;
	
	  p['spiderfiedZIndex'] = 1000;
	
	  p['usualLegZIndex'] = 10;
	
	  p['highlightedLegZIndex'] = 20;
	
	  p['event'] = 'click';
	
	  p['minZoomLevel'] = false;
	
	  p['lineToCenter'] = true;
	
	  p['legWeight'] = 1.5;
	
	  p['legColors'] = {
	    'usual': {},
	    'highlighted': {}
	  };
	
	  lcU = p['legColors']['usual'];
	
	  lcH = p['legColors']['highlighted'];
	
	  lcU[mt.HYBRID] = lcU[mt.SATELLITE] = '#fff';
	
	  lcH[mt.HYBRID] = lcH[mt.SATELLITE] = '#f00';
	
	  lcU[mt.TERRAIN] = lcU[mt.ROADMAP] = '#444';
	
	  lcH[mt.TERRAIN] = lcH[mt.ROADMAP] = '#f00';
	
	  function _Class(map1, opts) {
	    var e, j, k, len, ref, v;
	    this.map = map1;
	    if (opts == null) {
	      opts = {};
	    }
	    for (k in opts) {
	      if (!hasProp.call(opts, k)) continue;
	      v = opts[k];
	      this[k] = v;
	    }
	    this.projHelper = new this.constructor.ProjHelper(this.map);
	    this.initMarkerArrays();
	    this.listeners = {};
	    ref = ['click', 'zoom_changed', 'maptypeid_changed'];
	    for (j = 0, len = ref.length; j < len; j++) {
	      e = ref[j];
	      ge.addListener(this.map, e, (function(_this) {
	        return function() {
	          return _this['unspiderfy']();
	        };
	      })(this));
	    }
	    if (this['nudgeStackedMarkers']) {
	      ge.addListenerOnce(this.map, 'idle', (function(_this) {
	        return function() {
	          ge.addListener(_this.map, 'zoom_changed', function() {
	            return _this.mapZoomChangeListener();
	          });
	          return _this.mapZoomChangeListener();
	        };
	      })(this));
	    }
	  }
	
	  p.initMarkerArrays = function() {
	    this.markers = [];
	    return this.markerListenerRefs = [];
	  };
	
	  p['addMarker'] = function(marker) {
	    var listenerRefs;
	    if (marker['_oms'] != null) {
	      return this;
	    }
	    marker['_oms'] = true;
	    listenerRefs = [
	      ge.addListener(marker, this['event'], (function(_this) {
	        return function(event) {
	          return _this.spiderListener(marker, event);
	        };
	      })(this))
	    ];
	    if (!this['markersWontHide']) {
	      listenerRefs.push(ge.addListener(marker, 'visible_changed', (function(_this) {
	        return function() {
	          return _this.markerChangeListener(marker, false);
	        };
	      })(this)));
	    }
	    if (!this['markersWontMove']) {
	      listenerRefs.push(ge.addListener(marker, 'position_changed', (function(_this) {
	        return function() {
	          return _this.markerChangeListener(marker, true);
	        };
	      })(this)));
	    }
	    this.markerListenerRefs.push(listenerRefs);
	    this.markers.push(marker);
	    if (this.isNudgingActive()) {
	      this.requestNudge();
	    }
	    return this;
	  };
	
	  p.nudgeTimeout = null;
	
	  p.requestNudge = function() {
	    if (this.nudgeTimeout) {
	      clearTimeout(this.nudgeTimeout);
	    }
	    return this.nudgeTimeout = setTimeout((function(_this) {
	      return function() {
	        return _this.nudgeAllMarkers();
	      };
	    })(this), 10);
	  };
	
	  p.isNudgingActive = function() {
	    return this['nudgeStackedMarkers'] && !(this['minNudgeZoomLevel'] && this.map.getZoom() < this['minNudgeZoomLevel']) && !this.spiderfied;
	  };
	
	  p.markerChangeListener = function(marker, positionChanged) {
	    if ((marker['_omsData'] != null) && marker['_omsData'].leg && (positionChanged || !marker.getVisible()) && !((this.spiderfying != null) || (this.unspiderfying != null))) {
	      return this['unspiderfy'](positionChanged ? marker : null);
	    }
	  };
	
	  p.countsPerLevel = [1, 1];
	
	  p.levelsByCount = [];
	
	  p.getCountPerNudgeLevel = function(level) {
	    if (this.countsPerLevel[level] != null) {
	      return this.countsPerLevel[level];
	    }
	    this.countsPerLevel[level] = this.getCountPerNudgeLevel(level - 1) + Math.pow(2, level - 2) * this['markerCountInBaseNudgeLevel'];
	    return this.countsPerLevel[level];
	  };
	
	  p.getNudgeLevel = function(markerIndex) {
	    var level;
	    if (this.levelsByCount[markerIndex] != null) {
	      return this.levelsByCount[markerIndex];
	    }
	    level = 0;
	    while (markerIndex >= this.countsPerLevel[level]) {
	      if (level + 1 >= this.countsPerLevel.length) {
	        this.getCountPerNudgeLevel(level + 1);
	      }
	      level++;
	    }
	    this.levelsByCount[markerIndex] = level - 1;
	    return this.levelsByCount[markerIndex];
	  };
	
	  p.nudgeAllMarkers = function() {
	    var bucketSize, changeX, changeY, changesX, changesY, count, getHash, j, len, m, needsNudge, originalPos, pos, posHash, positions, ref, ref1, ref2, ref3, ref4, ref5, results, ringLevel;
	    if (!this.isNudgingActive()) {
	      return;
	    }
	    positions = {};
	    changesX = [];
	    changesY = [];
	    bucketSize = 1 / ((1 + this['nudgeBucketSize']) * this['nudgeRadius']);
	    getHash = (function(_this) {
	      return function(pos) {
	        return Math.floor(pos.x * bucketSize) + ',' + Math.floor(pos.y * bucketSize);
	      };
	    })(this);
	    ref = this.markers;
	    results = [];
	    for (j = 0, len = ref.length; j < len; j++) {
	      m = ref[j];
	      needsNudge = false;
	      pos = this.llToPt((ref1 = (ref2 = m['_omsData']) != null ? ref2.usualPosition : void 0) != null ? ref1 : m.position);
	      originalPos = {
	        x: pos.x,
	        y: pos.y
	      };
	      posHash = getHash(pos);
	      while ((positions[posHash] != null) && ((this['maxNudgeCount'] == null) || positions[posHash] <= this['maxNudgeCount'])) {
	        count = positions[posHash];
	        positions[posHash] += 1;
	        if (changesX[count] != null) {
	          changeX = changesX[count];
	          changeY = changesY[count];
	        } else {
	          ringLevel = this.getNudgeLevel(count);
	          changesX[count] = changeX = Math.sin(twoPi * count / this['markerCountInBaseNudgeLevel'] / ringLevel) * 20 * this['nudgeRadius'] * ringLevel;
	          changesY[count] = changeY = Math.cos(twoPi * count / this['markerCountInBaseNudgeLevel'] / ringLevel) * 20 * this['nudgeRadius'] * ringLevel;
	        }
	        pos.x = originalPos.x + changeX;
	        pos.y = originalPos.y + changeY;
	        this.nudged = true;
	        needsNudge = true;
	        posHash = getHash(pos);
	      }
	      if (needsNudge) {
	        m['_omsData'] = (ref3 = m['_omsData']) != null ? ref3 : {};
	        m['_omsData'].usualPosition = (ref4 = (ref5 = m['_omsData']) != null ? ref5.usualPosition : void 0) != null ? ref4 : m.position;
	        m.setPosition(this.ptToLl(pos));
	      } else if ((m['_omsData'] != null) && (m['_omsData'].leg == null)) {
	        m.setPosition(m['_omsData'].usualPosition);
	        delete m['_omsData'];
	      }
	      if (!(posHash in positions)) {
	        results.push(positions[posHash] = 1);
	      } else {
	        results.push(void 0);
	      }
	    }
	    return results;
	  };
	
	  p.resetNudgedMarkers = function() {
	    var j, len, m, ref;
	    if (!this.nudged) {
	      return;
	    }
	    ref = this.markers;
	    for (j = 0, len = ref.length; j < len; j++) {
	      m = ref[j];
	      if ((m['_omsData'] != null) && (m['_omsData'].leg == null)) {
	        m.setPosition(m['_omsData'].usualPosition);
	        delete m['_omsData'];
	      }
	    }
	    return delete this.nudged;
	  };
	
	  p.mapZoomChangeListener = function() {
	    if (this['minNudgeZoomLevel'] && this.map.getZoom() < this['minNudgeZoomLevel']) {
	      return this.resetNudgedMarkers();
	    }
	    return this.requestNudge();
	  };
	
	  p['getMarkers'] = function() {
	    return this.markers.slice(0);
	  };
	
	  p['removeMarker'] = function(marker) {
	    var i, j, len, listenerRef, listenerRefs;
	    if (marker['_omsData'] != null) {
	      this['unspiderfy']();
	    }
	    i = this.arrIndexOf(this.markers, marker);
	    if (i < 0) {
	      return this;
	    }
	    listenerRefs = this.markerListenerRefs.splice(i, 1)[0];
	    for (j = 0, len = listenerRefs.length; j < len; j++) {
	      listenerRef = listenerRefs[j];
	      ge.removeListener(listenerRef);
	    }
	    delete marker['_oms'];
	    this.markers.splice(i, 1);
	    if (this.isNudgingActive()) {
	      this.requestNudge();
	    }
	    return this;
	  };
	
	  p['clearMarkers'] = function() {
	    var i, j, l, len, len1, listenerRef, listenerRefs, marker, ref;
	    this['unspiderfy']();
	    ref = this.markers;
	    for (i = j = 0, len = ref.length; j < len; i = ++j) {
	      marker = ref[i];
	      listenerRefs = this.markerListenerRefs[i];
	      for (l = 0, len1 = listenerRefs.length; l < len1; l++) {
	        listenerRef = listenerRefs[l];
	        ge.removeListener(listenerRef);
	      }
	      delete marker['_oms'];
	    }
	    this.initMarkerArrays();
	    return this;
	  };
	
	  p['addListener'] = function(event, func) {
	    var base;
	    ((base = this.listeners)[event] != null ? base[event] : base[event] = []).push(func);
	    return this;
	  };
	
	  p['removeListener'] = function(event, func) {
	    var i;
	    i = this.arrIndexOf(this.listeners[event], func);
	    if (!(i < 0)) {
	      this.listeners[event].splice(i, 1);
	    }
	    return this;
	  };
	
	  p['clearListeners'] = function(event) {
	    this.listeners[event] = [];
	    return this;
	  };
	
	  p.trigger = function() {
	    var args, event, func, j, len, ref, ref1, results;
	    event = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
	    ref1 = (ref = this.listeners[event]) != null ? ref : [];
	    results = [];
	    for (j = 0, len = ref1.length; j < len; j++) {
	      func = ref1[j];
	      results.push(func.apply(null, args));
	    }
	    return results;
	  };
	
	  p.generatePtsCircle = function(count, centerPt) {
	    var angle, angleStep, circumference, i, j, legLength, ref, results;
	    circumference = this['circleFootSeparation'] * (2 + count);
	    legLength = circumference / twoPi;
	    angleStep = twoPi / count;
	    results = [];
	    for (i = j = 0, ref = count; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	      angle = this['circleStartAngle'] + i * angleStep;
	      results.push(new gm.Point(centerPt.x + legLength * Math.cos(angle), centerPt.y + legLength * Math.sin(angle)));
	    }
	    return results;
	  };
	
	  p.generatePtsSpiral = function(count, centerPt) {
	    var angle, i, j, legLength, pt, ref, results;
	    legLength = this['spiralLengthStart'];
	    angle = 0;
	    results = [];
	    for (i = j = 0, ref = count; 0 <= ref ? j < ref : j > ref; i = 0 <= ref ? ++j : --j) {
	      angle += this['spiralFootSeparation'] / legLength + i * 0.0005;
	      pt = new gm.Point(centerPt.x + legLength * Math.cos(angle), centerPt.y + legLength * Math.sin(angle));
	      legLength += twoPi * this['spiralLengthFactor'] / angle;
	      results.push(pt);
	    }
	    return results;
	  };
	
	  p.spiderListener = function(marker, event) {
	    var j, len, m, mPt, markerPt, markerSpiderfied, nDist, nearbyMarkerData, nonNearbyMarkers, pxSq, ref;
	    markerSpiderfied = (marker['_omsData'] != null) && (marker['_omsData'].leg != null);
	    if (!(markerSpiderfied && this['keepSpiderfied'])) {
	      if (this['event'] === 'mouseover') {
	        window.clearTimeout(p.timeout);
	        p.timeout = setTimeout((function(_this) {
	          return function() {
	            return _this['unspiderfy']();
	          };
	        })(this), 3000);
	      } else {
	        this['unspiderfy']();
	      }
	    }
	    if (markerSpiderfied || this.map.getStreetView().getVisible() || this.map.getMapTypeId() === 'GoogleEarthAPI' || this['minZoomLevel'] && this.map.getZoom() < this['minZoomLevel']) {
	      return this.trigger('click', marker, event);
	    } else {
	      nearbyMarkerData = [];
	      nonNearbyMarkers = [];
	      nDist = this['nearbyDistance'];
	      pxSq = nDist * nDist;
	      markerPt = this.llToPt(marker.position);
	      ref = this.markers;
	      for (j = 0, len = ref.length; j < len; j++) {
	        m = ref[j];
	        if (!((m.map != null) && m.getVisible())) {
	          continue;
	        }
	        mPt = this.llToPt(m.position);
	        if (this.ptDistanceSq(mPt, markerPt) < pxSq) {
	          nearbyMarkerData.push({
	            marker: m,
	            markerPt: mPt
	          });
	        } else {
	          nonNearbyMarkers.push(m);
	        }
	      }
	      if (nearbyMarkerData.length === 1) {
	        return this.trigger('click', marker, event);
	      } else {
	        return this.spiderfy(nearbyMarkerData, nonNearbyMarkers);
	      }
	    }
	  };
	
	  p['markersNearMarker'] = function(marker, firstOnly) {
	    var j, len, m, mPt, markerPt, markers, nDist, pxSq, ref, ref1, ref2;
	    if (firstOnly == null) {
	      firstOnly = false;
	    }
	    if (this.projHelper.getProjection() == null) {
	      throw "Must wait for 'idle' event on map before calling markersNearMarker";
	    }
	    nDist = this['nearbyDistance'];
	    pxSq = nDist * nDist;
	    markerPt = this.llToPt(marker.position);
	    markers = [];
	    ref = this.markers;
	    for (j = 0, len = ref.length; j < len; j++) {
	      m = ref[j];
	      if (m === marker || (m.map == null) || !m.getVisible()) {
	        continue;
	      }
	      mPt = this.llToPt((ref1 = (ref2 = m['_omsData']) != null ? ref2.usualPosition : void 0) != null ? ref1 : m.position);
	      if (this.ptDistanceSq(mPt, markerPt) < pxSq) {
	        markers.push(m);
	        if (firstOnly) {
	          break;
	        }
	      }
	    }
	    return markers;
	  };
	
	  p['markersNearAnyOtherMarker'] = function() {
	    var i, i1, i2, j, l, len, len1, len2, m, m1, m1Data, m2, m2Data, mData, n, nDist, pxSq, ref, ref1, ref2, results;
	    if (this.projHelper.getProjection() == null) {
	      throw "Must wait for 'idle' event on map before calling markersNearAnyOtherMarker";
	    }
	    nDist = this['nearbyDistance'];
	    pxSq = nDist * nDist;
	    mData = (function() {
	      var j, len, ref, ref1, ref2, results;
	      ref = this.markers;
	      results = [];
	      for (j = 0, len = ref.length; j < len; j++) {
	        m = ref[j];
	        results.push({
	          pt: this.llToPt((ref1 = (ref2 = m['_omsData']) != null ? ref2.usualPosition : void 0) != null ? ref1 : m.position),
	          willSpiderfy: false
	        });
	      }
	      return results;
	    }).call(this);
	    ref = this.markers;
	    for (i1 = j = 0, len = ref.length; j < len; i1 = ++j) {
	      m1 = ref[i1];
	      if (!((m1.map != null) && m1.getVisible())) {
	        continue;
	      }
	      m1Data = mData[i1];
	      if (m1Data.willSpiderfy) {
	        continue;
	      }
	      ref1 = this.markers;
	      for (i2 = l = 0, len1 = ref1.length; l < len1; i2 = ++l) {
	        m2 = ref1[i2];
	        if (i2 === i1) {
	          continue;
	        }
	        if (!((m2.map != null) && m2.getVisible())) {
	          continue;
	        }
	        m2Data = mData[i2];
	        if (i2 < i1 && !m2Data.willSpiderfy) {
	          continue;
	        }
	        if (this.ptDistanceSq(m1Data.pt, m2Data.pt) < pxSq) {
	          m1Data.willSpiderfy = m2Data.willSpiderfy = true;
	          break;
	        }
	      }
	    }
	    ref2 = this.markers;
	    results = [];
	    for (i = n = 0, len2 = ref2.length; n < len2; i = ++n) {
	      m = ref2[i];
	      if (mData[i].willSpiderfy) {
	        results.push(m);
	      }
	    }
	    return results;
	  };
	
	  p.makeHighlightListenerFuncs = function(marker) {
	    return {
	      highlight: (function(_this) {
	        return function() {
	          var icon;
	          marker['_omsData'].leg.setOptions({
	            strokeColor: _this['legColors']['highlighted'][_this.map.mapTypeId],
	            zIndex: _this['highlightedLegZIndex']
	          });
	          if (marker['_omsData'].shadow != null) {
	            icon = marker['_omsData'].shadow.getIcon();
	            icon.fillOpacity = 0.8;
	            return marker['_omsData'].shadow.setOptions({
	              icon: icon
	            });
	          }
	        };
	      })(this),
	      unhighlight: (function(_this) {
	        return function() {
	          var icon;
	          marker['_omsData'].leg.setOptions({
	            strokeColor: _this['legColors']['usual'][_this.map.mapTypeId],
	            zIndex: _this['usualLegZIndex']
	          });
	          if (marker['_omsData'].shadow != null) {
	            icon = marker['_omsData'].shadow.getIcon();
	            icon.fillOpacity = 0.3;
	            return marker['_omsData'].shadow.setOptions({
	              icon: icon
	            });
	          }
	        };
	      })(this)
	    };
	  };
	
	  p.spiderfy = function(markerData, nonNearbyMarkers) {
	    var bodyPt, centerLl, footLl, footPt, footPts, highlightListenerFuncs, leg, lineOrigin, marker, md, nearestMarkerDatum, numFeet, spiderfiedMarkers;
	    this.spiderfying = true;
	    numFeet = markerData.length;
	    bodyPt = this.ptAverage((function() {
	      var j, len, results;
	      results = [];
	      for (j = 0, len = markerData.length; j < len; j++) {
	        md = markerData[j];
	        results.push(md.markerPt);
	      }
	      return results;
	    })());
	    footPts = numFeet >= this['circleSpiralSwitchover'] ? this.generatePtsSpiral(numFeet, bodyPt).reverse() : this.generatePtsCircle(numFeet, bodyPt);
	    centerLl = this.ptToLl(bodyPt);
	    spiderfiedMarkers = (function() {
	      var j, len, ref, ref1, ref2, results;
	      results = [];
	      for (j = 0, len = footPts.length; j < len; j++) {
	        footPt = footPts[j];
	        footLl = this.ptToLl(footPt);
	        nearestMarkerDatum = this.minExtract(markerData, (function(_this) {
	          return function(md) {
	            return _this.ptDistanceSq(md.markerPt, footPt);
	          };
	        })(this));
	        marker = nearestMarkerDatum.marker;
	        lineOrigin = this['lineToCenter'] ? centerLl : marker.position;
	        leg = new gm.Polyline({
	          map: this.map,
	          path: [lineOrigin, footLl],
	          strokeColor: this['legColors']['usual'][this.map.mapTypeId],
	          strokeWeight: this['legWeight'],
	          zIndex: this['usualLegZIndex']
	        });
	        marker['_omsData'] = (ref = marker['_omsData']) != null ? ref : {};
	        marker['_omsData'].usualPosition = (ref1 = (ref2 = marker['_omsData']) != null ? ref2.usualPosition : void 0) != null ? ref1 : marker.position;
	        marker['_omsData'].leg = leg;
	        if (this['spiderfiedShadowColor']) {
	          marker['_omsData'].shadow = new gm.Marker({
	            position: footLl,
	            map: this.map,
	            clickable: false,
	            zIndex: -2,
	            icon: {
	              path: google.maps.SymbolPath.CIRCLE,
	              fillOpacity: 0.3,
	              fillColor: this['spiderfiedShadowColor'],
	              strokeWeight: 0,
	              scale: 20
	            }
	          });
	        }
	        if (this['legColors']['highlighted'][this.map.mapTypeId] !== this['legColors']['usual'][this.map.mapTypeId]) {
	          highlightListenerFuncs = this.makeHighlightListenerFuncs(marker);
	          marker['_omsData'].hightlightListeners = {
	            highlight: ge.addListener(marker, 'mouseover', highlightListenerFuncs.highlight),
	            unhighlight: ge.addListener(marker, 'mouseout', highlightListenerFuncs.unhighlight)
	          };
	        }
	        marker.setPosition(footLl);
	        marker.setZIndex(Math.round(this['spiderfiedZIndex'] + footPt.y));
	        results.push(marker);
	      }
	      return results;
	    }).call(this);
	    delete this.spiderfying;
	    this.spiderfied = true;
	    return this.trigger('spiderfy', spiderfiedMarkers, nonNearbyMarkers);
	  };
	
	  p['unspiderfy'] = function(markerNotToMove) {
	    var j, len, listeners, marker, nonNearbyMarkers, ref, ref1, unspiderfiedMarkers;
	    if (markerNotToMove == null) {
	      markerNotToMove = null;
	    }
	    if (!((this.spiderfied != null) || (this.nudged != null))) {
	      return this;
	    }
	    this.unspiderfying = true;
	    unspiderfiedMarkers = [];
	    nonNearbyMarkers = [];
	    ref = this.markers;
	    for (j = 0, len = ref.length; j < len; j++) {
	      marker = ref[j];
	      if ((marker['_omsData'] != null) && (marker['_omsData'].leg != null)) {
	        marker['_omsData'].leg.setMap(null);
	        if ((ref1 = marker['_omsData'].shadow) != null) {
	          ref1.setMap(null);
	        }
	        if (marker !== markerNotToMove) {
	          marker.setPosition(marker['_omsData'].usualPosition);
	        }
	        marker.setZIndex(null);
	        listeners = marker['_omsData'].hightlightListeners;
	        if (listeners != null) {
	          ge.removeListener(listeners.highlight);
	          ge.removeListener(listeners.unhighlight);
	        }
	        delete marker['_omsData'];
	        unspiderfiedMarkers.push(marker);
	      } else {
	        nonNearbyMarkers.push(marker);
	      }
	    }
	    delete this.unspiderfying;
	    delete this.spiderfied;
	    this.trigger('unspiderfy', unspiderfiedMarkers, nonNearbyMarkers);
	    if (this.nudged) {
	      this.requestNudge();
	    }
	    return this;
	  };
	
	  p.ptDistanceSq = function(pt1, pt2) {
	    var dx, dy;
	    dx = pt1.x - pt2.x;
	    dy = pt1.y - pt2.y;
	    return dx * dx + dy * dy;
	  };
	
	  p.ptAverage = function(pts) {
	    var j, len, numPts, pt, sumX, sumY;
	    sumX = sumY = 0;
	    for (j = 0, len = pts.length; j < len; j++) {
	      pt = pts[j];
	      sumX += pt.x;
	      sumY += pt.y;
	    }
	    numPts = pts.length;
	    return new gm.Point(sumX / numPts, sumY / numPts);
	  };
	
	  p.llToPt = function(ll) {
	    return this.projHelper.getProjection().fromLatLngToDivPixel(ll);
	  };
	
	  p.ptToLl = function(pt) {
	    return this.projHelper.getProjection().fromDivPixelToLatLng(pt);
	  };
	
	  p.minExtract = function(set, func) {
	    var bestIndex, bestVal, index, item, j, len, val;
	    for (index = j = 0, len = set.length; j < len; index = ++j) {
	      item = set[index];
	      val = func(item);
	      if ((typeof bestIndex === "undefined" || bestIndex === null) || val < bestVal) {
	        bestVal = val;
	        bestIndex = index;
	      }
	    }
	    return set.splice(bestIndex, 1)[0];
	  };
	
	  p.arrIndexOf = function(arr, obj) {
	    var i, j, len, o;
	    if (arr.indexOf != null) {
	      return arr.indexOf(obj);
	    }
	    for (i = j = 0, len = arr.length; j < len; i = ++j) {
	      o = arr[i];
	      if (o === obj) {
	        return i;
	      }
	    }
	    return -1;
	  };
	
	  _Class.ProjHelper = function(map) {
	    return this.setMap(map);
	  };
	
	  _Class.ProjHelper.prototype = new gm.OverlayView();
	
	  _Class.ProjHelper.prototype['draw'] = function() {};
	
	  return _Class;
	
	})();
	
	module.exports = this['OverlappingMarkerSpiderfier'];


/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content\">\r\n    <!--<div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <div class=\"box box-default\">\r\n          <div class=\"box-body\" style=\"display: block;\">\r\n            <div>\r\n              <div class=\"form-group col-md-2 padding-left-zero\">\r\n                <label>Instance</label>\r\n                <select class=\"form-control\" id=\"sel1\">\r\n                <option>All Instance</option>\r\n                <option>Instance 1</option>\r\n                <option>Instance 2</option>\r\n                <option>Instance 3</option>\r\n              </select>\r\n              </div>\r\n              <div class=\"form-group col-md-2 padding-left-zero\">\r\n                <label>Company</label>\r\n                <select class=\"form-control\" id=\"sel1\">\r\n                <option>All Company</option>\r\n                <option>Company 1</option>\r\n                <option>Company 2</option>\r\n                <option>Company 3</option>\r\n              </select>\r\n              </div>\r\n              <div class=\"form-group col-md-2 padding-left-zero\">\r\n                <label>Shared Vehicle Group</label>\r\n                <select class=\"form-control\" id=\"sel1\">\r\n                  <option>All Shared Vehicle Group</option>\r\n                  <option>Shared Vehicle Group 1</option>\r\n                  <option>Shared Vehicle Group 2</option>\r\n                  <option>Shared Vehicle Group 3</option>\r\n                </select>\r\n              </div>\r\n              <div class=\"form-group col-md-2 padding-left-zero\">\r\n                <label>Vehicle</label>\r\n                <input type=\"text\" class=\"form-control\">\r\n              </div>\r\n              <div class=\"form-group col-md-1 padding-left-zero\">\r\n                <label>&nbsp;</label>\r\n                <div class=\"clearfix\"></div>\r\n                <button type=\"submit\" class=\"btn btn-default\">\r\n                  <i aria-hidden=\"true\" class=\"fa fa-search\"></i>\r\n                </button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>-->\r\n    <div class=\"row\">\r\n      <div class=\"padding-right-zero\" [ngClass]=\"{'col-md-9' : filterEnable, 'col-md-12' : !filterEnable}\">\r\n        <div class=\"col-md-9 padding-zero\">\r\n          <ul class=\"nav nav-pills\">\r\n            <li [ngClass]=\"{'active': vehicleLocationType == 'HOME' }\" (click)=\"ChangeVehicleLocationType('HOME')\">\r\n              <a class=\"cursor-pointer\">{{ 'LblHomeLocation' | translate }}</a>\r\n            </li>\r\n            <li *ngIf=\"enableCurrentLocation\" [ngClass]=\"{'active': vehicleLocationType == 'CURRENT' }\" (click)=\"ChangeVehicleLocationType('CURRENT')\">\r\n              <a class=\"cursor-pointer\">{{ 'LblCurrentLocation' | translate }}</a>\r\n            </li>\r\n          </ul>\r\n        </div>\r\n        <div class=\"col-md-1 text-right\">\r\n          <button class=\"btn btn-default\" (click)=\"adminDashboardGrid.show()\">\r\n            <i class=\"fa fa-list\" aria-hidden=\"true\"></i>\r\n          </button>\r\n        </div>\r\n        <div class=\"col-md-2 padding-zero\">\r\n          <div class=\"form-group padding-left-zero\">\r\n            <select class=\"form-control\" [(ngModel)]=\"selectedStatus\" (change)=\"FilterVehicleStatus()\">\r\n              <option value=\"ALL\">{{ 'LblAll' | translate }}</option>\r\n              <option value=\"AVAILABLE\">{{ 'LblAvailable' | translate }}</option>\r\n              <option value=\"UNAVAILABLE\">{{ 'LblUnAvailable' | translate }}</option>\r\n              <option value=\"INUSE\">{{ 'LblInuse' | translate }}</option>\r\n              <option value=\"PRIORITY1\">{{ 'LblPriority' | translate }} 1</option>\r\n              <option value=\"PRIORITY2\">{{ 'LblPriority' | translate }} 2</option>\r\n            </select>\r\n          </div>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"col-md-12 padding-zero\">\r\n          <div id=\"map\"></div>\r\n          <div class=\"collapse-outer\" (click)=\"ToggleFilter()\">\r\n            <div class=\"collapse-inner\">\r\n              <i class=\"fa\" [ngClass]=\"{'fa-caret-right' : filterEnable, 'fa-caret-left' : !filterEnable}\" aria-hidden=\"true\"></i>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-md-3 padding-left-zero filter\" [ngClass]=\"{'enable-fliter' : filterEnable, 'disable-fliter' : !filterEnable}\">\r\n        <div style=\"padding-left: 12px;\">\r\n          <div class=\"box box-default\">\r\n            <div class=\"box-body\" style=\"display: block;\">\r\n              <admin-dashboard-filter (OnSearch)=\"OnSearch($event)\"></admin-dashboard-filter>\r\n            </div>\r\n          </div>\r\n          <div class=\"box box-default\">\r\n            <div class=\"box-body\" style=\"display: block;\">\r\n              <div class='my-legend'>\r\n                <ul class='legend-labels'>\r\n                  <li style='color:#28A3AA;'>\r\n                    <img src=\"" + __webpack_require__(517) + "\" />&nbsp;{{ 'LblAvailable' | translate }}</li>\r\n                  <li style='color:#B5B5B6;'>\r\n                    <img src=\"" + __webpack_require__(520) + "\" />&nbsp;{{ 'LblUnAvailable' | translate }}</li>\r\n                  <li style='color:#0B436C;'>\r\n                    <img src=\"" + __webpack_require__(518) + "\" />&nbsp;{{ 'LblInuse' | translate }}</li>\r\n                  <li style='color:#E62B25;'>\r\n                    <img src=\"" + __webpack_require__(521) + "\" />&nbsp;{{ 'LblPriority' | translate }} 1</li>\r\n                  <ul class=\"legend-priority types\" style=\"float: none;\">\r\n                    <li *ngFor=\"let item of GetPriorityLegend(vehicleIssuePriorityList, 'PRIORITY1')\">{{ GetLabelFromType(item.type) }}</li>\r\n                  </ul>\r\n                  <li style='color:#FDBD45;'>\r\n                    <img src=\"" + __webpack_require__(519) + "\" />&nbsp;{{ 'LblPriority' | translate }} 2</li>\r\n                  <ul class=\"legend-priority types\">\r\n                    <li *ngFor=\"let item of GetPriorityLegend(vehicleIssuePriorityList, 'PRIORITY2')\">{{ GetLabelFromType(item.type) }}</li>\r\n                  </ul>\r\n                </ul>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <!--\r\n          <div class=\"box box-default\">\r\n            <div class=\"box-header with-border\">\r\n              <h3 class=\"box-title\">Service Status</h3>\r\n            </div>\r\n            <div class=\"box-body\" style=\"display: block;\">\r\n              <ul style=\"list-style-type: none;\">\r\n                <li *ngFor=\"let item of windowsServiceStatusList\">\r\n                  <span style=\"width: auto;\">\r\n                    <i [ngClass]=\"{ 'fa-check text-success': item.isRunning, 'fa-times text-danger': !item.isRunning  }\" class=\"fa\" aria-hidden=\"true\"></i>\r\n                  </span> {{ item.displayName }}\r\n                </li>\r\n                <li>\r\n                  <span style=\"width: auto;\">\r\n                    <i [ngClass]=\"{ 'fa-check text-success': onlinePaymentServiceStatus.isRunning, 'fa-times text-danger': !onlinePaymentServiceStatus.isRunning  }\"\r\n                      class=\"fa\" aria-hidden=\"true\"></i>\r\n                  </span> {{ onlinePaymentServiceStatus.displayName }}\r\n                </li>\r\n              </ul>\r\n              <div class='my-legend'>\r\n                <ul class='legend-labels'>\r\n                  <li *ngFor=\"let item of windowsServiceStatusList\">\r\n                    {{ item.serviceName }}\r\n                    <span style=\"width: auto;\">\r\n                      <i [ngClass]=\"{ 'fa-check text-success': item.isRunning, 'fa-times text-danger': !item.isRunning  }\" class=\"fa\" aria-hidden=\"true\"></i>\r\n                      </span>\r\n                  </li>\r\n                </ul>\r\n              </div>\r\n            </div>\r\n          </div>-->\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n<admin-dashboard-grid #adminDashboardGrid [VehicleList]=\"vehicleList\" [IssuePriorityList]=\"vehicleIssuePriorityList\" (OnExport)=\"ExportVehicleStatus()\"></admin-dashboard-grid>";

/***/ },
/* 525 */
/***/ function(module, exports) {

	module.exports = "#map {\r\n    height: 875px;\r\n}\r\n\r\n.nav-pills>li {\r\n    /*width: 50%;*/\r\n    text-align: center;\r\n}\r\n\r\n.nav-pills>li>a {\r\n    border-top: 0;\r\n    background-color: #d7d7d7;\r\n}\r\n\r\n.nav>li>a {\r\n    padding: 7px 15px;\r\n}\r\n\r\n.nav>li>a:hover,\r\n.nav>li>a:active,\r\n.nav>li>a:focus {\r\n    background-color: #ddd;\r\n}\r\n\r\n.nav-pills>li+li {\r\n    margin: 0;\r\n}\r\n\r\n.my-legend .legend-title {\r\n    text-align: left;\r\n    margin-bottom: 5px;\r\n    font-weight: bold;\r\n    font-size: 90%;\r\n}\r\n\r\n.my-legend ul {\r\n    margin: 0;\r\n    margin-bottom: 5px;\r\n    padding: 0;\r\n    float: left;\r\n    list-style: none;\r\n}\r\n\r\n.my-legend ul li {\r\n    list-style: none;\r\n    margin-left: 0;\r\n    margin-bottom: 2px;\r\n}\r\n\r\n.my-legend ul.legend-labels li img {\r\n    height: 25px;\r\n}\r\n\r\n.my-legend ul.legend-labels li span {\r\n    display: block;\r\n    float: left;\r\n    height: 16px;\r\n    width: 30px;\r\n    margin-right: 5px;\r\n    margin-left: 0;\r\n}\r\n\r\n.legend-priority li {\r\n    list-style: none;\r\n    margin-left: 25px !important;\r\n}\r\n\r\n.my-legend .legend-source {\r\n    font-size: 70%;\r\n    color: #999;\r\n    clear: both;\r\n}\r\n\r\n.my-legend a {\r\n    color: #777;\r\n}\r\n\r\n.disable-legend {\r\n    opacity: 0.3;\r\n}\r\n\r\n.enable-legend {\r\n    opacity: 0.3;\r\n}\r\n\r\n.box-body {\r\n    padding: 10px;\r\n}\r\n\r\n.padding-zero {\r\n    padding: 0px;\r\n}\r\n\r\n.padding-left-zero {\r\n    padding-left: 0px;\r\n}\r\n\r\n.padding-right-zero {\r\n    padding-right: 0px;\r\n}\r\n\r\n.collapse-outer {\r\n    position: absolute;\r\n    height: 100%;\r\n    width: 12px;\r\n    border: 1px solid #ccc;\r\n    background-color: #ddd;\r\n    text-align: center;\r\n    top: 0;\r\n    right: 0;\r\n}\r\n\r\n.collapse-inner {\r\n    display: table;\r\n    height: 100%;\r\n    width: 100%;\r\n    cursor: pointer;\r\n}\r\n\r\n.collapse-inner i {\r\n    display: table-cell;\r\n    vertical-align: middle;\r\n}\r\n\r\n.filter {\r\n    display: block;\r\n    /*transition-timing-function: ease-in;\r\n    -webkit-transition-property: display;\r\n    -webkit-transition-duration: 2s;\r\n    -webkit-transition-timing-function: ease-in;\r\n    -webkit-transition-delay: 1s;*/\r\n    /* Standard syntax */\r\n    /*transition-property: display;\r\n    transition-duration: 2s;\r\n    transition-timing-function: ease-in;\r\n    transition-delay: 1s;*/\r\n}\r\n\r\n.enable-fliter {\r\n    display: block;\r\n}\r\n\r\n.disable-fliter {\r\n    display: none;\r\n}\r\n\r\n.types{\r\n   margin-left: 12px !important;\r\n}\r\n.types li{\r\n  list-style: square !important;\r\n}\r\n"

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var LanguageHelperAPIComponent = (function () {
	    function LanguageHelperAPIComponent(authService) {
	        this.authService = authService;
	        this.combineArray = [];
	        //oldKeys: any;
	        this.onlyNewKeys = false;
	    }
	    LanguageHelperAPIComponent.prototype.ngOnInit = function () {
	        this.GetEnglishLabel();
	    };
	    LanguageHelperAPIComponent.prototype.GetEnglishLabel = function () {
	        var _this = this;
	        this.authService.GetResourceLabel("en").subscribe(function (res) {
	            _this.en = res.data;
	            _this.GetDutchLabel();
	        }, function (error) {
	            console.log(error);
	        });
	    };
	    LanguageHelperAPIComponent.prototype.GetDutchLabel = function () {
	        var _this = this;
	        this.authService.GetResourceLabel("nl").subscribe(function (res) {
	            _this.nl = res.data;
	            _this.GetDeLabels();
	        }, function (error) {
	            console.log(error);
	        });
	    };
	    LanguageHelperAPIComponent.prototype.GetDeLabels = function () {
	        var _this = this;
	        this.authService.GetResourceLabel("de").subscribe(function (res) {
	            _this.de = res.data;
	            _this.Init();
	            // this.GetDutchLabel();
	        }, function (error) {
	            console.log(error);
	        });
	    };
	    LanguageHelperAPIComponent.prototype.GetPtLabels = function () {
	        var _this = this;
	        this.authService.GetResourceLabel("pt").subscribe(function (res) {
	            _this.pt = res.data;
	            _this.Init();
	        }, function (error) {
	            console.log(error);
	        });
	    };
	    LanguageHelperAPIComponent.prototype.GetFrLabels = function () {
	        var _this = this;
	        this.authService.GetResourceLabel("fr").subscribe(function (res) {
	            _this.fr = res.data;
	            _this.Init();
	        }, function (error) {
	            console.log(error);
	        });
	    };
	    LanguageHelperAPIComponent.prototype.GetPlLabels = function () {
	        var _this = this;
	        this.authService.GetResourceLabel("pl").subscribe(function (res) {
	            _this.pl = res.data;
	            _this.Init();
	        }, function (error) {
	            console.log(error);
	        });
	    };
	    LanguageHelperAPIComponent.prototype.Init = function () {
	        var en = this.en;
	        var nl = this.nl;
	        var de = this.de;
	        var pt = this.pt;
	        var fr = this.fr;
	        var pl = this.pl;
	        // let pt = this.pt;
	        var enKeys = Object.keys(en);
	        var nlKeys = Object.keys(nl);
	        var deKeys = Object.keys(de);
	        var ptKeys = Object.keys(pt);
	        var frKeys = Object.keys(fr);
	        var plKeys = Object.keys(pl);
	        // let ptKeys = Object.keys(pt);
	        this.missingInNLArray = this.MissingKeys(enKeys, nlKeys);
	        console.log(this.missingInNLArray);
	        this.missingInENArray = this.MissingKeys(nlKeys, enKeys);
	        console.log(this.missingInENArray);
	        this.missingInDEArray = this.MissingKeys(enKeys, deKeys);
	        console.log(this.missingInDEArray);
	        this.missingInPtArray = this.MissingKeys(enKeys, ptKeys);
	        console.log(this.missingInPtArray);
	        this.missingInFRArray = this.MissingKeys(enKeys, frKeys);
	        console.log(this.missingInFRArray);
	        this.missingInPLArray = this.MissingKeys(enKeys, plKeys);
	        console.log(this.missingInPLArray);
	        var matchKeys = enKeys;
	        matchKeys = matchKeys.concat(this.missingInENArray);
	        // this.missingInPTArray = this.MissingKeys(matchKeys, ptKeys);
	        // console.log(this.missingInPTArray);
	        this.mapArray = this.MapArray(matchKeys, en, nl, de, pt, fr, pl);
	        console.log(this.mapArray);
	    };
	    LanguageHelperAPIComponent.prototype.MissingKeys = function (array1, array2) {
	        var missingArray = [];
	        array1.forEach(function (element) {
	            if (!(array2.indexOf(element) > -1)) {
	                missingArray.push(element);
	            }
	        });
	        return missingArray;
	    };
	    LanguageHelperAPIComponent.prototype.MapArray = function (keys, enArray, nlArray, deArray, ptArray, frArray, plArray) {
	        var mapArray = [];
	        keys.forEach(function (element) {
	            var mapObject = {};
	            mapObject["key"] = element;
	            mapObject["en"] = enArray[element];
	            mapObject["nl"] = nlArray[element];
	            mapObject["de"] = deArray[element];
	            mapObject["pt"] = ptArray[element];
	            mapObject["fr"] = frArray[element];
	            mapObject["pl"] = plArray[element];
	            mapArray.push(mapObject);
	        });
	        return mapArray;
	    };
	    LanguageHelperAPIComponent.prototype.DownloadAllLabelCSV = function () {
	        this.JSONToCSVConvertor(this.mapArray, "Language_BackOffice", true);
	    };
	    LanguageHelperAPIComponent.prototype.DownloadNewLabelCSV = function () {
	        var _this = this;
	        var newMapArray = this.mapArray.filter(function (x) { return _this.ExistInOld(x.key); });
	        this.JSONToCSVConvertor(newMapArray, "Language_BackOffice", true);
	    };
	    LanguageHelperAPIComponent.prototype.JSONToCSVConvertor = function (JSONData, ReportTitle, ShowLabel) {
	        //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
	        var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;
	        var CSV = '';
	        //Set Report title in first row or line
	        //CSV += ReportTitle + '\r\n\n';
	        //This condition will generate the Label/Header
	        if (ShowLabel) {
	            var row = "";
	            //This loop will extract the label from 1st index of on array
	            for (var index in arrData[0]) {
	                //Now convert each value to string and comma-seprated
	                row += index + ',';
	            }
	            row = row.slice(0, -1);
	            //append Label row with line break
	            CSV += row + '\r\n';
	        }
	        //1st loop is to extract each row
	        for (var i = 0; i < arrData.length; i++) {
	            var row = "";
	            //2nd loop will extract each column and convert it in string comma-seprated
	            for (var index in arrData[i]) {
	                row += '"' + arrData[i][index] + '",';
	            }
	            row.slice(0, row.length - 1);
	            //add a line break after each row
	            CSV += row + '\r\n';
	        }
	        if (CSV == '') {
	            alert("Invalid data");
	            return;
	        }
	        //Generate a file name
	        var fileName = "File_";
	        //this will remove the blank-spaces from the title and replace it with an underscore
	        fileName += ReportTitle.replace(/ /g, "_");
	        //Initialize file format you want csv or xls
	        var uri = 'data:text/csv;charset=utf-8,' + encodeURIComponent(CSV);
	        // Now the little tricky part.
	        // you can use either>> window.open(uri);
	        // but this will not work in some browsers
	        // or you will not get the correct file extension    
	        //this trick will generate a temp a /> tag
	        var link = document.createElement("a");
	        link.href = uri;
	        //set the visibility hidden so it will not effect on your web-layout
	        link.style = "visibility:hidden";
	        link.download = fileName + ".csv";
	        //this part will append the anchor tag and remove it after automatic click
	        document.body.appendChild(link);
	        link.click();
	        document.body.removeChild(link);
	    };
	    LanguageHelperAPIComponent.prototype.DisplayNewOnly = function (item) {
	        if (this.onlyNewKeys) {
	            return !this.ExistInOld(item.key) && !this.MatchValue(item.en_old, item.en) && !this.MatchValue(item.nl_old, item.nl) && !this.MatchValue(item.de_old, item.de) && !this.MatchValue(item.pt_old, item.pt) && !this.MatchValue(item.fr_old, item.fr) && !this.MatchValue(item.pl_old, item.pl);
	        }
	        else {
	            return false;
	        }
	    };
	    LanguageHelperAPIComponent.prototype.ExistInOld = function (key) {
	        if (this.oldArray) {
	            //let oldKeyArray = this.oldKeys.split("\n");
	            var oldKeyArray = this.oldArray.map(function (x) { return x.key; });
	            if (!(oldKeyArray.indexOf(key) > -1))
	                return true;
	            else
	                return false;
	        }
	        else {
	            return true;
	        }
	    };
	    LanguageHelperAPIComponent.prototype.MatchValue = function (value1, value2) {
	        if (value1 == value2)
	            return false;
	        else
	            return true;
	    };
	    LanguageHelperAPIComponent.prototype.HandleFiles = function (files) {
	        // Check for the various File API support.
	        if (window.FileReader) {
	            // FileReader are supported.
	            if (files && files.length > 0) {
	                var file = files.item(0);
	                //Now you can get
	                console.log(file.name);
	                console.log(file.size);
	                console.log(file.type);
	                this.GetAsText(file);
	            }
	        }
	        else {
	            alert('FileReader are not supported in this browser.');
	        }
	    };
	    LanguageHelperAPIComponent.prototype.GetAsText = function (fileToRead) {
	        var _this = this;
	        var reader = new FileReader();
	        // Read file into memory as UTF-8      
	        reader.readAsText(fileToRead);
	        // Handle errors load
	        reader.onload = function (event) { return _this.LoadHandler(event); };
	        reader.onerror = function (event) { return _this.ErrorHandler(event); };
	    };
	    LanguageHelperAPIComponent.prototype.LoadHandler = function (event) {
	        var csv = event.target.result;
	        this.oldArray = this.CSV2JSON(csv);
	        this.combineArray = this.JoinObjects([this.mapArray, this.oldArray]);
	        console.log(this.combineArray);
	    };
	    LanguageHelperAPIComponent.prototype.CSVToArray = function (strData, strDelimiter) {
	        // Check to see if the delimiter is defined. If not,
	        // then default to comma.
	        strDelimiter = (strDelimiter || ",");
	        // Create a regular expression to parse the CSV values.
	        var objPattern = new RegExp((
	        // Delimiters.
	        "(\\" + strDelimiter + "|\\r?\\n|\\r|^)" +
	            // Quoted fields.
	            "(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +
	            // Standard fields.
	            "([^\"\\" + strDelimiter + "\\r\\n]*))"), "gi");
	        // Create an array to hold our data. Give the array
	        // a default empty first row.
	        var arrData = [[]];
	        // Create an array to hold our individual pattern
	        // matching groups.
	        var arrMatches = null;
	        // Keep looping over the regular expression matches
	        // until we can no longer find a match.
	        while (arrMatches = objPattern.exec(strData)) {
	            // Get the delimiter that was found.
	            var strMatchedDelimiter = arrMatches[1];
	            // Check to see if the given delimiter has a length
	            // (is not the start of string) and if it matches
	            // field delimiter. If id does not, then we know
	            // that this delimiter is a row delimiter.
	            if (strMatchedDelimiter.length && (strMatchedDelimiter != strDelimiter)) {
	                // Since we have reached a new row of data,
	                // add an empty row to our data array.
	                arrData.push([]);
	            }
	            // Now that we have our delimiter out of the way,
	            // let's check to see which kind of value we
	            // captured (quoted or unquoted).
	            if (arrMatches[2]) {
	                // We found a quoted value. When we capture
	                // this value, unescape any double quotes.
	                var strMatchedValue = arrMatches[2].replace(new RegExp("\"\"", "g"), "\"");
	            }
	            else {
	                // We found a non-quoted value.
	                var strMatchedValue = arrMatches[3];
	            }
	            // Now that we have our value string, let's add
	            // it to the data array.
	            arrData[arrData.length - 1].push(strMatchedValue);
	        }
	        // Return the parsed data.
	        return (arrData);
	    };
	    LanguageHelperAPIComponent.prototype.CSV2JSON = function (csv) {
	        var array = this.CSVToArray(csv);
	        var objArray = [];
	        for (var i = 1; i < array.length; i++) {
	            objArray[i - 1] = {};
	            for (var k = 0; k < array[0].length && k < array[i].length; k++) {
	                var key = array[0][k];
	                objArray[i - 1][key] = array[i][k];
	            }
	        }
	        // let json: any = JSON.stringify(objArray);
	        // let str: any = json.replace(/},/g, "},\r\n");
	        return objArray;
	    };
	    LanguageHelperAPIComponent.prototype.ErrorHandler = function (evt) {
	        if (evt.target.error.name == "NotReadableError") {
	            alert("Can't read file !");
	        }
	    };
	    LanguageHelperAPIComponent.prototype.JoinObjects = function (magicArray) {
	        var idMap = {};
	        // Iterate over arguments
	        for (var i = 0; i < magicArray.length; i++) {
	            // Iterate over individual argument arrays (aka json1, json2)
	            for (var j = 0; j < magicArray[i].length; j++) {
	                var currentID = magicArray[i][j]['key'];
	                if (!idMap[currentID]) {
	                    idMap[currentID] = {};
	                }
	                // Iterate over properties of objects in arrays (aka id, name, etc.)
	                for (var key in magicArray[i][j]) {
	                    idMap[currentID][key] = magicArray[i][j][key];
	                }
	            }
	        }
	        // push properties of idMap into an array
	        var newArray = [];
	        for (var property in idMap) {
	            newArray.push(idMap[property]);
	        }
	        return newArray;
	    };
	    LanguageHelperAPIComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-language-api-helper',
	            styles: ["\n    .wrap-language{\n      padding: 15px;  \n    }\n    .list-group-item{\n      padding: 5px 15px;\n    }\n  "],
	            template: "\n          <div class=\"wrap-language\">\n            <header>\n              <h1 class=\"text-center\">Language API File</h1>\n            </header>\n            <article>\n              <div class=\"row\">\n                <section class=\"col-sm-6\" *ngIf=\"missingInENArray && missingInENArray.length > 0\">\n                  <header>\n                    <h4>Missing in English Label</h4>\n                  </header>\n                  <ul class=\"list-group\">\n                    <li class=\"list-group-item\" *ngFor=\"let item of missingInENArray\">{{ item }}</li>\n                  </ul>\n                </section>\n                <section class=\"col-sm-6\" *ngIf=\"missingInNLArray && missingInNLArray.length > 0\">\n                  <header>\n                    <h4>Missing in Dutch Label</h4>\n                  </header>\n                  <ul class=\"list-group\">\n                    <li class=\"list-group-item\" *ngFor=\"let item of missingInNLArray\">{{ item }}</li>\n                  </ul>\n                </section>\n                <section class=\"col-sm-6\" *ngIf=\"missingInDEArray && missingInDEArray.length > 0\">\n                  <header>\n                    <h4>Missing in German Label</h4>\n                  </header>\n                  <ul class=\"list-group\">\n                    <li class=\"list-group-item\" *ngFor=\"let item of missingInDEArray\">{{ item }}</li>\n                  </ul>\n                </section>\n              </div>\n              <div class=\"row\">\n                <section class=\"col-sm-6\" *ngIf=\"missingInDEArray && missingInDEArray.length > 0\">\n                <header>\n                  <h4>Missing in Lbl Label</h4>\n                </header>\n                <ul class=\"list-group\">\n                  <li class=\"list-group-item\" *ngFor=\"let item of missingInDEArray\">{{ item }}</li>\n                </ul>\n              </section>\n              </div>\n              <div class=\"row\">\n                <section class=\"col-sm-6\" *ngIf=\"missingInPTArray && missingInPTArray.length > 0\">\n                <header>\n                  <h4>Missing in Portuguese Label</h4>\n                </header>\n                <ul class=\"list-group\">\n                  <li class=\"list-group-item\" *ngFor=\"let item of missingInPTArray\">{{ item }}</li>\n                </ul>\n              </section>\n              </div>\n              <div class=\"row\">\n                <section class=\"col-sm-6\" *ngIf=\"missingInFRArray && missingInFRArray.length > 0\">\n                <header>\n                  <h4>Missing in French Label</h4>\n                </header>\n                <ul class=\"list-group\">\n                  <li class=\"list-group-item\" *ngFor=\"let item of missingInFRArray\">{{ item }}</li>\n                </ul>\n              </section>\n              </div>\n              <div class=\"row\">\n                <section class=\"col-sm-6\" *ngIf=\"missingInPLArray && missingInPLArray.length > 0\">\n                <header>\n                  <h4>Missing in Polish Label</h4>\n                </header>\n                <ul class=\"list-group\">\n                  <li class=\"list-group-item\" *ngFor=\"let item of missingInPLArray\">{{ item }}</li>\n                </ul>\n              </section>\n              </div>\n              <div class=\"clearfix\"></div>\n              <section>\n                <header>\n                  <h4>Old Key Values</h4>\n                </header>\n            \n                <input type=\"file\" id=\"csvFileInput\" (change)=\"HandleFiles($event.target.files)\" accept=\".csv\">\n              </section>\n              <section>\n                <header>\n                  <h4>System Labels</h4>\n                </header>\n                <div class=\"row\">\n                  <div class=\"col-sm-6\">\n                    <label class=\"radio-inline\"><input type=\"radio\" [(ngModel)]=\"onlyNewKeys\" name=\"onlyNewKeys\" [value]=\"true\">Only New Label</label>\n                    <label class=\"radio-inline\"><input type=\"radio\" [(ngModel)]=\"onlyNewKeys\" name=\"onlyNewKeys\" [value]=\"false\">All Label</label>\n                  </div>\n                  <div class=\"col-sm-6 text-right\">\n                    <button class=\"btn btn-success btn-xs\" type=\"button\" (click)=\"DownloadNewLabelCSV()\">Download New Label</button>&nbsp;&nbsp;\n                    <button class=\"btn btn-info btn-xs\" type=\"button\" (click)=\"DownloadAllLabelCSV()\">Download All Label</button>\n                  </div>\n                </div>\n                <table class=\"table table-bordered\">\n                  <tr>\n                    <th>Key</th>\n                    <th>English Old</th>\n                    <th>English New</th>\n                    <th>Dutch Old</th>\n                    <th>Dutch New</th>\n                    <th>Germany Old</th>\n                    <th>Germany New</th>\n                    <th>Portuguese Old</th>\n                    <th>Portuguese New</th>\n                    <th>French Old</th>\n                    <th>French New</th>\n                    <th>Polish Old</th>\n                    <th>Polish New</th>                                        \n                  </tr>\n                  <tr *ngFor=\"let item of combineArray\" [ngClass]=\"{'hide': DisplayNewOnly(item) }\">\n                    <td [ngClass]=\"{'success' : ExistInOld(item.key) }\">{{ item.key }}</td>\n                    <td [ngClass]=\"{'danger' : MatchValue(item.en_old, item.en) }\">{{ item.en_old }}</td>\n                    <td [ngClass]=\"{'danger' : MatchValue(item.en_old, item.en) }\">{{ item.en }}</td>\n                    <td [ngClass]=\"{'danger' : MatchValue(item.nl_old, item.nl) }\">{{ item.nl_old }}</td>\n                    <td [ngClass]=\"{'danger' : MatchValue(item.nl_old, item.nl) }\">{{ item.nl }}</td>\n                    <td [ngClass]=\"{'danger' : MatchValue(item.de_old, item.de) }\">{{ item.de_old }}</td>\n                    <td [ngClass]=\"{'danger' : MatchValue(item.de_old, item.de) }\">{{ item.de }}</td>\n                    <td [ngClass]=\"{'danger' : MatchValue(item.pt_old, item.pt) }\">{{ item.pt_old }}</td>\n                    <td [ngClass]=\"{'danger' : MatchValue(item.pt_old, item.pt) }\">{{ item.pt }}</td>\n                    <td [ngClass]=\"{'danger' : MatchValue(item.fr_old, item.fr) }\">{{ item.fr_old }}</td>\n                    <td [ngClass]=\"{'danger' : MatchValue(item.fr_old, item.fr) }\">{{ item.fr }}</td>\n                    <td [ngClass]=\"{'danger' : MatchValue(item.pl_old, item.pl) }\">{{ item.pl_old }}</td>\n                    <td [ngClass]=\"{'danger' : MatchValue(item.pl_old, item.pl) }\">{{ item.pl }}</td>\n                  </tr>\n                </table>\n              </section>\n            </article>\n          </div>\n  "
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], LanguageHelperAPIComponent);
	    return LanguageHelperAPIComponent;
	    var _a;
	}());
	exports.LanguageHelperAPIComponent = LanguageHelperAPIComponent;


/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var config_1 = __webpack_require__(60);
	var auth_service_1 = __webpack_require__(58);
	var translate_service_1 = __webpack_require__(70);
	var core_1 = __webpack_require__(3);
	var odometerlogtrail_model_1 = __webpack_require__(528);
	var odometerlogtrail_service_1 = __webpack_require__(529);
	var vehicle_service_1 = __webpack_require__(530);
	var router_1 = __webpack_require__(26);
	var config_2 = __webpack_require__(60);
	var common_1 = __webpack_require__(22);
	var flatpickr_model_1 = __webpack_require__(83);
	var OdometerLogTrailUpdateComponent = (function () {
	    function OdometerLogTrailUpdateComponent(odometerLogTrailService, translate, vehicleService, activeRoute, authService, router, locationService) {
	        this.odometerLogTrailService = odometerLogTrailService;
	        this.translate = translate;
	        this.vehicleService = vehicleService;
	        this.activeRoute = activeRoute;
	        this.authService = authService;
	        this.router = router;
	        this.locationService = locationService;
	        this.totalItems = 0;
	        this.currentPage = 1;
	        this.maxSize = config_2.WeGoConfig.GRID_MAX_PAGE_SIZE;
	        this.itemsPerPage = config_2.WeGoConfig.GRID_MAX_DATA_SIZE;
	        this.isEditMode = false;
	        this.searchField = "";
	        this.searchTerm = "";
	        this.roleLevel = config_1.RoleLevel;
	    }
	    OdometerLogTrailUpdateComponent.prototype.ngOnInit = function () {
	        this.pageName = "OdometerLogTrail";
	        this.module = this.translate.instant('LblOdometerLogTrail');
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	        this.urlDefaultPage = this.authService.GetURL(config_2.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlOdometerLogTrailList = this.authService.GetURL(config_2.ApplicationRouteURL.URL_ODOMETERLOGTRAIL_LIST);
	        this.flatPickrConfigDateTimePicker = this.SetDefaultFlatPickrConfig();
	        this.model = new odometerlogtrail_model_1.OdometerLogTrailModel();
	        this.GetOdometerLogTrailDetail();
	    };
	    OdometerLogTrailUpdateComponent.prototype.SetDefaultFlatPickrConfig = function (isDateOnly) {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = !isDateOnly ? true : false;
	        flatPickrConfig.time_24hr = true;
	        flatPickrConfig.maxDate = new Date(new Date().setHours(0, 0, 0));
	        flatPickrConfig.dateFormat = config_2.WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
	        flatPickrConfig.minuteIncrement = 1;
	        return flatPickrConfig;
	    };
	    OdometerLogTrailUpdateComponent.prototype.GetOdometerLogTrailDetail = function () {
	        var _this = this;
	        this.sub = this.activeRoute
	            .params
	            .subscribe(function (params) {
	            _this.odometerLogHashId = params['id'] || '';
	            if (_this.odometerLogHashId != '') {
	                _this.isEditMode = true;
	                _this.odometerLogTrailService.GetOdometerLogTrailByHashId(_this.odometerLogHashId)
	                    .subscribe(function (res) {
	                    _this.model = res.data;
	                }, function (error) {
	                    _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	                });
	            }
	            else {
	                _this.isEditMode = false;
	                _this.model = new odometerlogtrail_model_1.OdometerLogTrailModel();
	                _this.GetVehicleList(config_2.PermissionType.INSERT);
	            }
	        });
	        this.breadCrumbTitle = this.isEditMode ? this.translate.instant('LblEditPage', [this.module]) : this.translate.instant('LblAddPage', [this.module]);
	    };
	    OdometerLogTrailUpdateComponent.prototype.onSubmit = function (forms) {
	        console.log(this.model);
	        this.AddOdometerLogTrail();
	    };
	    OdometerLogTrailUpdateComponent.prototype.AddOdometerLogTrail = function () {
	        var _this = this;
	        this.odometerLogTrailService.AddOdometerLogTrail(this.model)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.isEditMode ? _this.translate.instant('LblRecordUpdatedSuccess', [_this.module]) : _this.translate.instant('LblRecordAddedSuccess', [_this.module]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    OdometerLogTrailUpdateComponent.prototype.GetVehicleList = function (permissionType) {
	        var _this = this;
	        this.odometerLogTrailService.GetVehicleDropdownForOdometer(permissionType)
	            .subscribe(function (res) {
	            _this.vehicleList = res.data;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    OdometerLogTrailUpdateComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    OdometerLogTrailUpdateComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    OdometerLogTrailUpdateComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    OdometerLogTrailUpdateComponent.prototype.OnBackClick = function () {
	        this.locationService.back();
	    };
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], OdometerLogTrailUpdateComponent.prototype, "successPopup", void 0);
	    OdometerLogTrailUpdateComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-odometerlogtrail',
	            template: __webpack_require__(531),
	            providers: [odometerlogtrail_service_1.OdometerLogTrailService, vehicle_service_1.VehicleService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof odometerlogtrail_service_1.OdometerLogTrailService !== 'undefined' && odometerlogtrail_service_1.OdometerLogTrailService) === 'function' && _a) || Object, (typeof (_b = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _b) || Object, (typeof (_c = typeof vehicle_service_1.VehicleService !== 'undefined' && vehicle_service_1.VehicleService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object, (typeof (_e = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _f) || Object, (typeof (_g = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _g) || Object])
	    ], OdometerLogTrailUpdateComponent);
	    return OdometerLogTrailUpdateComponent;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.OdometerLogTrailUpdateComponent = OdometerLogTrailUpdateComponent;


/***/ },
/* 528 */
/***/ function(module, exports) {

	"use strict";
	var OdometerLogTrailModel = (function () {
	    function OdometerLogTrailModel() {
	        this.vehicleMasterHashId = '';
	        this.userUpdatedDateTime = '';
	        this.descriptionOfDeviation = 'GPS correction';
	        this.listOfOdometerLogTrailHashId = [];
	    }
	    return OdometerLogTrailModel;
	}());
	exports.OdometerLogTrailModel = OdometerLogTrailModel;


/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var OdometerLogTrailService = (function () {
	    function OdometerLogTrailService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    OdometerLogTrailService.prototype.GetOdometerLogTrail = function (input, onlyRequiredDescription) {
	        var getOdometerLogTrailUrl = config_1.WeGoConfig.API_GET_ODOMETERLOGTRAIL_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getOdometerLogTrailUrl = getOdometerLogTrailUrl + "?" + queryString + "&onlyRequiredDescription=" + onlyRequiredDescription;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getOdometerLogTrailUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OdometerLogTrailService.prototype.GetVehicleDropdownForOdometer = function (permissionType) {
	        var getOdometerLogTrailUrl = config_1.WeGoConfig.API_GET_ODOMETER_VEHICLE_DROPDOWN_LIST + '?permissionType=' + permissionType;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getOdometerLogTrailUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OdometerLogTrailService.prototype.ExportOdometerLogTrailList = function (input, onlyRequiredDescription) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var getUrl = config_1.WeGoConfig.API_EXPORT_ODOMETER_LIST + "?" + queryString + "&onlyRequiredDescription=" + onlyRequiredDescription;
	        var headers = this.authService.GetHeader('text/csv');
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getUrl, options);
	    };
	    OdometerLogTrailService.prototype.GetOdometerLogTrailByHashId = function (odometerLogTrailHashId) {
	        var getCompnayUrl = config_1.WeGoConfig.API_GET_ODOMETERLOGTRAIL_BY_HASH + "?odometerLogTrailHashId=" + odometerLogTrailHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getCompnayUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OdometerLogTrailService.prototype.AddOdometerLogTrail = function (odometerLogTrailModel) {
	        var body = odometerLogTrailModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_POST_ODOMETERLOGTRAIL_DETAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OdometerLogTrailService.prototype.UpdateDescriptionOfDeviation = function (odometerLogTrailModel) {
	        var body = odometerLogTrailModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_POST_ODOMETER_DESCRIPTION, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OdometerLogTrailService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], OdometerLogTrailService);
	    return OdometerLogTrailService;
	    var _a, _b;
	}());
	exports.OdometerLogTrailService = OdometerLogTrailService;


/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var jquery_helper_service_1 = __webpack_require__(67);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var VehicleService = (function () {
	    function VehicleService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	        this.JQueryHelper = new jquery_helper_service_1.JQueryHelperService();
	    }
	    VehicleService.prototype.GetVehicleList = function (input, ownerCompanyHashID, sharedVehicleGroupHashId, instanceHashId, forSnailTrailReport, chkCleanRequireFilter, chkFuelRequireFilter, chkDamageFilter, permissionName) {
	        if (forSnailTrailReport === void 0) { forSnailTrailReport = false; }
	        if (chkCleanRequireFilter === void 0) { chkCleanRequireFilter = false; }
	        if (chkFuelRequireFilter === void 0) { chkFuelRequireFilter = false; }
	        if (chkDamageFilter === void 0) { chkDamageFilter = false; }
	        if (permissionName === void 0) { permissionName = ""; }
	        var getVehicleUrl = config_1.WeGoConfig.API_GET_VEHICLE_LIST + "?";
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString)
	            getVehicleUrl = getVehicleUrl + queryString;
	        if (instanceHashId)
	            getVehicleUrl = getVehicleUrl + "&instanceHashId=" + instanceHashId;
	        if (ownerCompanyHashID)
	            getVehicleUrl =
	                getVehicleUrl + "&ownerCompanyHashID=" + ownerCompanyHashID;
	        if (sharedVehicleGroupHashId)
	            getVehicleUrl =
	                getVehicleUrl + "&sharedVehicleGroupHashId=" + sharedVehicleGroupHashId;
	        getVehicleUrl =
	            getVehicleUrl + "&ForSnailTrailReport=" + forSnailTrailReport;
	        getVehicleUrl =
	            getVehicleUrl + "&CleanRequireFilter=" + chkCleanRequireFilter;
	        getVehicleUrl =
	            getVehicleUrl + "&FuelRequireFilter=" + chkFuelRequireFilter;
	        getVehicleUrl = getVehicleUrl + "&DamageFilter=" + chkDamageFilter;
	        if (permissionName)
	            getVehicleUrl = getVehicleUrl + "&permissionName=" + permissionName;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getVehicleUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    VehicleService.prototype.ExportVehicleList = function (input, ownerCompanyHashID, sharedVehicleGroupHashId, instanceHashId, forSnailTrailReport, chkCleanRequireFilter, chkFuelRequireFilter, chkDamageFilter, permissionName) {
	        if (forSnailTrailReport === void 0) { forSnailTrailReport = false; }
	        if (chkCleanRequireFilter === void 0) { chkCleanRequireFilter = false; }
	        if (chkFuelRequireFilter === void 0) { chkFuelRequireFilter = false; }
	        if (chkDamageFilter === void 0) { chkDamageFilter = false; }
	        if (permissionName === void 0) { permissionName = ""; }
	        input.currentPage = 0;
	        var getVehicleUrl = config_1.WeGoConfig.API_EXPORT_VEHICLE_LIST + "?";
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString)
	            getVehicleUrl = getVehicleUrl + queryString;
	        if (instanceHashId)
	            getVehicleUrl = getVehicleUrl + "&instanceHashId=" + instanceHashId;
	        if (ownerCompanyHashID)
	            getVehicleUrl =
	                getVehicleUrl + "&ownerCompanyHashID=" + ownerCompanyHashID;
	        if (sharedVehicleGroupHashId)
	            getVehicleUrl =
	                getVehicleUrl + "&sharedVehicleGroupHashId=" + sharedVehicleGroupHashId;
	        getVehicleUrl =
	            getVehicleUrl + "&ForSnailTrailReport=" + forSnailTrailReport;
	        getVehicleUrl =
	            getVehicleUrl + "&CleanRequireFilter=" + chkCleanRequireFilter;
	        getVehicleUrl =
	            getVehicleUrl + "&FuelRequireFilter=" + chkFuelRequireFilter;
	        getVehicleUrl = getVehicleUrl + "&DamageFilter=" + chkDamageFilter;
	        if (permissionName)
	            getVehicleUrl = getVehicleUrl + "&permissionName=" + permissionName;
	        var headers = this.authService.GetHeader("text/csv");
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getVehicleUrl, options);
	    };
	    VehicleService.prototype.ExportSVGDriverList = function (ownerCompanyHashID, sharedVehicleGroupHashId, input) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var getVehicleUrl = config_1.WeGoConfig.API_EXPORT_SVG_DRIVER_LIST;
	        if (ownerCompanyHashID) {
	            getVehicleUrl =
	                getVehicleUrl +
	                    "?" +
	                    queryString +
	                    "&ownerCompanyHashID=" +
	                    ownerCompanyHashID;
	        }
	        else if (sharedVehicleGroupHashId) {
	            getVehicleUrl =
	                getVehicleUrl +
	                    "?" +
	                    queryString +
	                    "&sharedVehicleGroupHashId=" +
	                    sharedVehicleGroupHashId;
	        }
	        else {
	            getVehicleUrl = getVehicleUrl + "?" + queryString;
	        }
	        var headers = this.authService.GetHeader("text/csv");
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getVehicleUrl, options);
	    };
	    VehicleService.prototype.GetVehicleByHashId = function (vehicleHashId, isEditMode) {
	        var getVehicleUrl = config_1.WeGoConfig.API_GET_VEHICLE_BY_HASH +
	            "?vehicleHashId=" +
	            vehicleHashId +
	            "&isEditMode=" +
	            isEditMode;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getVehicleUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    VehicleService.prototype.UpdateVehicleMaster = function (bodyData) {
	        var body = bodyData;
	        var headers = this.authService.GetHeader("application/json", "application/x-www-form-urlencoded");
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_VEHICLE_DETAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    VehicleService.prototype.AddNewVehicle = function (vehicleModel) {
	        var body = vehicleModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_VEHICLE_DETAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    VehicleService.prototype.DeleteVehicle = function (selectedVehicles) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_DELETE_VEHICLES, selectedVehicles, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    // public GetVehicleSVGList(
	    //   vehicleHashId: string,
	    //   input?: DataListModel
	    // ): Observable<IAPIResponse> {
	    //   let getDriverUrl = WeGoConfig.API_GET_VEHICLE_SVG_LIST;
	    //   let queryString = this.authService.HandleAPIListInput(input);
	    //   if (queryString) {
	    //     getDriverUrl =
	    //       getDriverUrl + "?" + queryString + "&vehicleHashId=" + vehicleHashId;
	    //   } else {
	    //     getDriverUrl = getDriverUrl + "?vehicleHashId=" + vehicleHashId;
	    //   }
	    //   let headers = this.authService.GetHeader();
	    //   let options = new RequestOptions({ headers: headers });
	    //   return this.http
	    //     .get(getDriverUrl, options)
	    //     .map(this.authService.HandleAPIResponse)
	    //     .catch(this.authService.HandleAPIError);
	    // }
	    // public ExportVehicleSVGList(vehicleHashId: string): any {
	    //   let getInstanceUrl =
	    //     WeGoConfig.API_EXPORT_VEHICLE_SVG_LIST +
	    //     "?vehicleHashId=" +
	    //     vehicleHashId;
	    //   let headers = this.authService.GetHeader("text/csv");
	    //   let options = new RequestOptions({ headers: headers });
	    //   return this.http.get(getInstanceUrl, options);
	    // }
	    VehicleService.prototype.DeleteVehicleSVG = function (selectedVehicleSVGList) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_DELETE_VEHICLE_SVG, selectedVehicleSVGList, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    VehicleService.prototype.AssignSVGToVehicle = function (SVGvehicleModel) {
	        var body = SVGvehicleModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_SVG_VEHICLE_DETAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    VehicleService.prototype.BlockUnBlockVehicle = function (vehicleBlockModel) {
	        var body = vehicleBlockModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_VEHICLE_BLOCK, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    VehicleService.prototype.GetVehicleListBySVGID = function (input, sharedVehicleGroupHashId) {
	        var getVehicleUrl = config_1.WeGoConfig.API_GET_VEHICLE_LIST_BY_SVGID;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getVehicleUrl = getVehicleUrl + "?" + queryString;
	            if (sharedVehicleGroupHashId)
	                getVehicleUrl =
	                    getVehicleUrl +
	                        "&sharedVehicleGroupHashId=" +
	                        sharedVehicleGroupHashId;
	        }
	        else {
	            if (sharedVehicleGroupHashId)
	                getVehicleUrl =
	                    getVehicleUrl +
	                        "?sharedVehicleGroupHashId=" +
	                        sharedVehicleGroupHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getVehicleUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    VehicleService.prototype.GetBookingOverviewList = function (vehicleModel, input) {
	        var body = vehicleModel;
	        var getBookingOverviewUrl = config_1.WeGoConfig.API_GET_AFFECTEDBOOKING;
	        var queryStringDataListModel = this.authService.HandleAPIListInput(input);
	        var queryStringBookingOverviewModel = this.JQueryHelper.Param(vehicleModel);
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        getBookingOverviewUrl =
	            getBookingOverviewUrl +
	                "?" +
	                queryStringDataListModel; //?// +
	        ///"&" +
	        ///decodeURIComponent(queryStringBookingOverviewModel);
	        return this.http
	            .post(getBookingOverviewUrl, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    VehicleService.prototype.AddNewVtsVehicle = function (vehicleModel) {
	        var body = vehicleModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_VTSVEHICLE_DETAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    VehicleService.prototype.GetVTSVehicleList = function (input) {
	        var getVehicleUrl = config_1.WeGoConfig.API_GET_VTS_VEHICLE_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getVehicleUrl = getVehicleUrl + "?" + queryString;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getVehicleUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    VehicleService.prototype.GetVtsVehicleByHashId = function (vehicleHashId) {
	        var getVehicleUrl = config_1.WeGoConfig.API_GET_VTSVEHICLE_BY_HASH + "?vehicleHashId=" + vehicleHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getVehicleUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    VehicleService.prototype.GetAllVtsVehicleList = function (input) {
	        var getVehicleUrl = config_1.WeGoConfig.API_GET_VTSVEHICLE_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getVehicleUrl = getVehicleUrl + "?" + queryString;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getVehicleUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    VehicleService.prototype.ExportVTSVehicleList = function (input) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var getUrl = config_1.WeGoConfig.API_EXPORT_VTSVEHICLE_SVG_LIST + "?" + queryString;
	        var headers = this.authService.GetHeader("text/csv");
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getUrl, options);
	    };
	    // public UpdateVTSVehicleStatus(vehicleHashId: string, vehicleStatus: string): Observable<IAPIResponse> {
	    //   let updateVtsVehicleUrl = WeGoConfig.API_UPDATE_VTS_VEHICLE_STATUS;
	    //   updateVtsVehicleUrl = updateVtsVehicleUrl + "?vehicleHashId=" + vehicleHashId + "&vehicleStatus=" + vehicleStatus;
	    //   let headers = this.authService.GetHeader();
	    //   let options = new RequestOptions({ headers: headers });
	    //   return this.http.get(updateVtsVehicleUrl, options)
	    //     .map(this.authService.HandleAPIResponse)
	    //     .catch(this.authService.HandleAPIError);
	    // }
	    VehicleService.prototype.UnLockVTSVehicle = function (vehicleHashId, isMobileRequest) {
	        var updateVtsVehicleUrl = config_1.WeGoConfig.API_UNLOCK_VTS_VEHICLE;
	        updateVtsVehicleUrl =
	            updateVtsVehicleUrl +
	                "?vehicleHashId=" +
	                vehicleHashId +
	                "&isMobileRequest=" +
	                isMobileRequest;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(updateVtsVehicleUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    VehicleService.prototype.LockVTSVehicle = function (vehicleHashId, isMobileRequest) {
	        var updateVtsVehicleUrl = config_1.WeGoConfig.API_LOCK_VTS_VEHICLE;
	        updateVtsVehicleUrl =
	            updateVtsVehicleUrl +
	                "?vehicleHashId=" +
	                vehicleHashId +
	                "&isMobileRequest=" +
	                isMobileRequest;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(updateVtsVehicleUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    VehicleService.prototype.GetVehicleDamageReport = function (vehicleHashId, input) {
	        var getVehicleUrl = config_1.WeGoConfig.API_GET_VEHICLE_DAMAGE_REPORT_BY_HASH;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getVehicleUrl =
	                getVehicleUrl + "?" + queryString + "&vehicleHashId=" + vehicleHashId;
	        }
	        else {
	            getVehicleUrl = getVehicleUrl + "?vehicleHashId=" + vehicleHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getVehicleUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    VehicleService.prototype.UpdateReportDamageStatus = function (reportDamageHashId) {
	        var getDamgeReportUrl = config_1.WeGoConfig.API_UPDATE_REPORT_DAMAGE_STATUS +
	            "?reportDamageHashId=" +
	            reportDamageHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getDamgeReportUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    VehicleService.prototype.GetVehicleFutureBookingList = function (vehicleHashId, input) {
	        var getDriverUrl = config_1.WeGoConfig.API_GET_VEHICLE_FUTURE_BOOKING_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getDriverUrl =
	                getDriverUrl + "?" + queryString + "&vehicleHashId=" + vehicleHashId;
	        }
	        else {
	            getDriverUrl = getDriverUrl + "?vehicleHashId=" + vehicleHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getDriverUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    VehicleService.prototype.UpdateVehicleInfo = function (vehicleModel) {
	        var body = vehicleModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_VEHICLE_INFO, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    VehicleService.prototype.UpdateVehicleForCleaningAndFuel = function (vehicleHashId, isCleaningNeed, isFuelNeed) {
	        var updateVehicleCleaningAndFuel = config_1.WeGoConfig.API_UPDATE_VEHICLE_FOR_CLEANING_AND_FUEL +
	            "?vehicleHashId=" +
	            vehicleHashId +
	            "&isCleaningNeed=" +
	            isCleaningNeed +
	            "&isFuelNeed=" +
	            isFuelNeed;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(updateVehicleCleaningAndFuel, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    VehicleService.prototype.UpdateVehicleForInvalidTag = function (vehicleHashId, invalidTagUsed) {
	        var UpdateVehicleForInvalidTag = config_1.WeGoConfig.API_UPDATE_VEHICLE_FOR_INVALID_TAG_USED +
	            "?vehicleHashId=" +
	            vehicleHashId +
	            "&invalidTagUsed=" +
	            invalidTagUsed;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(UpdateVehicleForInvalidTag, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    VehicleService.prototype.GetDropdownVehicleList = function (reportName, instanceHashId, companyHashId, sharedVehicleGroupHashId) {
	        var getVehicleListUrl;
	        switch (reportName) {
	            case "Vehicle_Occupancy_Report":
	                getVehicleListUrl =
	                    config_1.WeGoConfig.API_GET_DROPDOWN_VEHICLE_LIST_VEHICLEOCCUPANCYREPORT;
	                break;
	            case "Revenue_Per_Vehicle_Report":
	                getVehicleListUrl =
	                    config_1.WeGoConfig.API_GET_DROPDOWN_VEHICLE_LIST_REVENUEVEHICLEREPORT;
	                break;
	            case "Maintenance_Planning_Report":
	                getVehicleListUrl =
	                    config_1.WeGoConfig.API_GET_DROPDOWN_VEHICLE_LIST_MAINTENCEPLANNINGREPORT;
	                break;
	            case "TripData_Report":
	                getVehicleListUrl =
	                    config_1.WeGoConfig.API_GET_DROPDOWN_VEHICLE_LIST_TRIPDATAREPORT;
	                break;
	            case "Kick_Back_Report":
	                getVehicleListUrl =
	                    config_1.WeGoConfig.API_GET_DROPDOWN_VEHICLE_LIST_KICKBACKREPORT;
	                break;
	            default:
	                getVehicleListUrl =
	                    config_1.WeGoConfig.API_GET_DROPDOWN_VEHICLE_LIST_VEHICLEOCCUPANCYREPORT;
	                break;
	        }
	        getVehicleListUrl =
	            getVehicleListUrl +
	                "?instanceHashId=" +
	                instanceHashId +
	                "&companyHashId=" +
	                companyHashId +
	                "&sharedVehicleGroupHashId=" +
	                sharedVehicleGroupHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getVehicleListUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    VehicleService.prototype.GetVehicleDropdownListBySVGID = function (sharedVehicleGroupHashId) {
	        var getVehicleUrl = config_1.WeGoConfig.API_GET_VEHICLE_DROPDOWN_LIST_BY_SVGID;
	        if (sharedVehicleGroupHashId)
	            getVehicleUrl =
	                getVehicleUrl + "?sharedVehicleGroupHashId=" + sharedVehicleGroupHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getVehicleUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    VehicleService.prototype.GetVehicleListByOrganization = function (input, customerHashId, instanceHashId, companyHashId, organizationHashId, svgHashId, pageName) {
	        if (customerHashId === void 0) { customerHashId = ""; }
	        if (instanceHashId === void 0) { instanceHashId = ""; }
	        if (companyHashId === void 0) { companyHashId = ""; }
	        if (organizationHashId === void 0) { organizationHashId = ""; }
	        if (svgHashId === void 0) { svgHashId = ""; }
	        if (pageName === void 0) { pageName = ""; }
	        var getVehicleUrl = "";
	        switch (pageName) {
	            case "Cost_Center_Report":
	                getVehicleUrl =
	                    config_1.WeGoConfig.API_GET_VEHICLE_LIST_FOR_COST_CENTER_REPORT + "?";
	                break;
	            default:
	                getVehicleUrl =
	                    config_1.WeGoConfig.API_GET_VEHICLE_LIST_FOR_COST_CENTER_REPORT + "?";
	                break;
	        }
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString)
	            getVehicleUrl = getVehicleUrl + queryString;
	        if (customerHashId)
	            getVehicleUrl = getVehicleUrl + "&customerHashId=" + customerHashId;
	        if (instanceHashId)
	            getVehicleUrl = getVehicleUrl + "&instanceHashId=" + instanceHashId;
	        if (companyHashId)
	            getVehicleUrl = getVehicleUrl + "&companyHashId=" + companyHashId;
	        if (svgHashId)
	            getVehicleUrl = getVehicleUrl + "&svgHashId=" + svgHashId;
	        if (organizationHashId)
	            getVehicleUrl =
	                getVehicleUrl + "&organizationHashId=" + organizationHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getVehicleUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    VehicleService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], VehicleService);
	    return VehicleService;
	    var _a, _b;
	}());
	exports.VehicleService = VehicleService;


/***/ },
/* 531 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{breadCrumbTitle}}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li><a [routerLink]=\"urlDefaultPage\"><i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a></li>\r\n        <li><a [routerLink]=\"urlOdometerLogTrailList\"><i class=\"fa fa-tasks\"></i> {{ breadCrumbList }}</a></li>\r\n        <li class=\"active\">{{ breadCrumbTitle }}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"nopad\">\r\n      <form (ngSubmit)=\"onSubmit(AddOdometerForm.value)\" #AddOdometerForm=\"ngForm\">\r\n        <div *ngIf=\"!isEditMode\" class=\"form-group col-md-3\">\r\n          <label><span class=\"text text-danger\">*</span>{{ 'LblVehicle' | translate }}</label>\r\n          <select [(ngModel)]=\"model.vehicleMasterHashId\" name=\"vehicle\" class=\"form-control\" [disabled]=\"isEditMode\">\r\n            <option  value=\"\">{{ 'LblSelect' | translate }} {{ 'LblVehicle' | translate }} </option>\r\n            <option *ngFor=\"let vehicle of vehicleList\"  [ngValue]='vehicle.keyHash' >{{ vehicle.value }}</option>\r\n          </select>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'VehicleMasterHashId' }}</span>\r\n        </div>\r\n        <div *ngIf=\"isEditMode\" class=\"form-group col-md-3\">\r\n          <label><span class=\"text text-danger\">*</span> {{ 'LblVehicle' | translate }}</label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblVehicle' | translate }}\" [ngModel]=\"model.licenceTag\"\r\n            name=\"licenceTag\" disabled>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'VehicleMasterHashId' }}</span>\r\n        </div>\r\n        <div class=\"form-group col-md-3\">\r\n          <label><span class=\"text text-danger\">*</span> {{ 'LblUserProvidedOdometerValueInKmr' | translate }}</label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblUserProvidedOdometerValueInKmr' | translate }}\" [(ngModel)]=\"model.userProvidedOdometerValueInKm\"\r\n            name=\"userProvidedOdometerValueInKm\" maxlength=\"6\" [disabled]=\"((isEditMode) && !(authService.GetHighestRoleLevel() <= roleLevel.SVG))\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'userProvidedOdometerValueInKm' }}</span>\r\n        </div>\r\n        <div *ngIf=\"isEditMode && authService.GetHighestRoleLevel() <= roleLevel.Instance\" class=\"form-group col-md-3\">\r\n          <label><span class=\"text text-danger\">*</span>{{ 'LblModifiedDate' | translate }}</label>\r\n          <div class=\"input-group\">\r\n            <span class=\"input-group-addon\"><i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i></span>\r\n            <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblModifiedDate' | translate }}\" [(ngModel)]=\"model.userUpdatedDateTime\"\r\n              name=\"userUpdatedDateTime\" [Config]=\"flatPickrConfigDateTimePicker\" flatpickr readonly>\r\n          </div>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'userUpdatedDateTime' }}</span>\r\n        </div>\r\n        <div class=\"form-group col-md-3\">\r\n          <label><span class=\"text text-danger\">*</span> {{ 'LblDescriptionOfDeviation' | translate }}</label>\r\n          <textarea class=\"form-control\" placeholder=\"{{ 'LblDescriptionOfDeviation' | translate }}\" [(ngModel)]=\"model.descriptionOfDeviation\"\r\n            name=\"descriptionOfDeviation\" maxlength=\"100\"></textarea>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'descriptionOfDeviation' }}</span>\r\n        </div>\r\n        <div class=\"row no-margin\">\r\n          <div class=\"col-sm-12\">\r\n            <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnBackClick()\">{{ 'LblCancel' | translate }}</a> &nbsp;&nbsp;\r\n            <button class=\"btn btn-green\" type=\"submit\">{{ 'LblSave' | translate }}</button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </section>\r\n</div>\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>";

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var odometerlogtrail_model_1 = __webpack_require__(528);
	var odometerlogtrail_service_1 = __webpack_require__(529);
	var config_1 = __webpack_require__(60);
	var router_1 = __webpack_require__(26);
	var config_2 = __webpack_require__(60);
	var OdometerLogTrailListComponent = (function () {
	    function OdometerLogTrailListComponent(odometerLogTrailService, authService, router, translate) {
	        this.odometerLogTrailService = odometerLogTrailService;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.model = new odometerlogtrail_model_1.OdometerLogTrailModel();
	        this.chkDescription = false;
	        this.roleLevel = config_1.RoleLevel;
	    }
	    Object.defineProperty(OdometerLogTrailListComponent.prototype, "isAnyChecked", {
	        get: function () {
	            if (this.odometerLogTrailList) {
	                var isCheck = this.odometerLogTrailList.some(function (x) { return x.isChecked == true; });
	                if (isCheck) {
	                    if (this.odometerLogTrailList
	                        .filter(function (x) { return x.descriptionOfDeviation == null; })
	                        .every(function (x) { return x.isChecked == true; }))
	                        this.isParentCheck = true;
	                    else
	                        this.isParentCheck = false;
	                }
	                else {
	                    this.isParentCheck = false;
	                }
	                return isCheck;
	            }
	            else {
	                this.isParentCheck = false;
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(OdometerLogTrailListComponent.prototype, "isEditAccess", {
	        get: function () {
	            if (this.odometerLogTrailList) {
	                return this.odometerLogTrailList.some(function (x) { return x.isEditable; });
	            }
	            else {
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    OdometerLogTrailListComponent.prototype.ngOnInit = function () {
	        this.LblAddDescriptionOfDeviation = this.translate.instant("LblAddDescriptionOfDeviation");
	        this.LblIcon = "fa fa-comments";
	        this.module = this.translate.instant("LblOdometerLogTrail");
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = [
	            "personName",
	            "companyName",
	            "licenceTag"
	        ];
	        if (this.authService.GetHighestRoleLevel() <= config_1.RoleLevel.Instance) {
	            this.DataListModel.searchField.push("instanceName");
	        }
	        this.chkDescription = this.authService.AssignFromStorage(this.constructor.name + "_model", this.chkDescription);
	        this.urlDefaultPage = this.authService.GetURL(config_2.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlOdometerLogTrailUpdate = this.authService.GetURL(config_2.ApplicationRouteURL.URL_ODOMETERLOGTRAIL_UPDATE);
	        this.urlOdometerLogTrailAdd = this.authService.GetURL(config_2.ApplicationRouteURL.URL_ODOMETERLOGTRAIL_ADD);
	        this.urlPersonInfo = this.authService.GetURL(config_2.ApplicationRouteURL.URL_PERSON_UPDATE);
	        this.GetOdometerLogTrailList();
	        this.breadCrumbList = this.translate.instant("LblListPage", [this.module]);
	        this.addOdometerLogTrailLink = new config_1.WeGoAuthorizedLink(this.urlOdometerLogTrailAdd, config_1.Permission.PR_ODOMETER_LOG_TRAIL, config_1.PermissionType.INSERT, 'btn btn-highlight navbar-right', 'LblAddNew');
	    };
	    OdometerLogTrailListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetOdometerLogTrailList();
	    };
	    OdometerLogTrailListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetOdometerLogTrailList();
	    };
	    OdometerLogTrailListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetOdometerLogTrailList();
	    };
	    OdometerLogTrailListComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetOdometerLogTrailList();
	    };
	    OdometerLogTrailListComponent.prototype.OnDescriptionFilterChange = function () {
	        this.GetOdometerLogTrailList();
	    };
	    OdometerLogTrailListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.odometerLogTrailService
	            .ExportOdometerLogTrailList(this.DataListModel, this.chkDescription)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "odometerLogTrailList" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    OdometerLogTrailListComponent.prototype.GetOdometerLogTrailList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.odometerLogTrailService
	            .GetOdometerLogTrail(this.DataListModel, this.chkDescription)
	            .subscribe(function (res) {
	            _this.odometerLogTrailList = res.data;
	            _this.isParentCheckEnable =
	                _this.odometerLogTrailList.filter(function (x) { return x.descriptionOfDeviation == null; }).length > 0
	                    ? true
	                    : false;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    OdometerLogTrailListComponent.prototype.OnParentCheck = function (isChecked) {
	        this.odometerLogTrailList
	            .filter(function (x) { return x.descriptionOfDeviation == null; })
	            .forEach(function (x) { return (x.isChecked = isChecked); });
	    };
	    OdometerLogTrailListComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    OdometerLogTrailListComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    OdometerLogTrailListComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    OdometerLogTrailListComponent.prototype.onSubmit = function (forms) {
	        this.model.listOfOdometerLogTrailHashId = this.odometerLogTrailList
	            .filter(function (x) { return x.isChecked; })
	            .map(function (x) { return x.odometerLogTrailHashId; });
	        this.DeviationDescription(JSON.stringify(this.model));
	    };
	    OdometerLogTrailListComponent.prototype.DeviationDescription = function (formData) {
	        var _this = this;
	        this.isLoading = true;
	        this.odometerLogTrailService
	            .UpdateDescriptionOfDeviation(formData)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.DataListModel.currentPage = 1;
	                _this.GetOdometerLogTrailList();
	                _this.descriptionModal.hide();
	                var replaceWord = _this.translate.instant("LblDescriptionOfDeviation");
	                _this.popupMsg = _this.translate.instant("LblRecordUpdatedSuccess", [
	                    replaceWord
	                ]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.errorModel = res.error;
	                _this.isLoading = false;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    OdometerLogTrailListComponent.prototype.OnCustomeButton = function () {
	        this.model.descriptionOfDeviation = null;
	        this.errorModel = null;
	        this.descriptionModal.show();
	    };
	    OdometerLogTrailListComponent.prototype.HideDescriptionModal = function () {
	        this.descriptionModal.hide();
	    };
	    OdometerLogTrailListComponent.prototype.SuccessCancelModalClick = function () {
	        this.descriptionModal.hide();
	    };
	    OdometerLogTrailListComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	        this.authService.SaveToStorage(this.constructor.name + "_model", this.chkDescription);
	    };
	    __decorate([
	        core_1.ViewChild("successPopup"), 
	        __metadata('design:type', Object)
	    ], OdometerLogTrailListComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild("descriptionModal"), 
	        __metadata('design:type', Object)
	    ], OdometerLogTrailListComponent.prototype, "descriptionModal", void 0);
	    OdometerLogTrailListComponent = __decorate([
	        core_1.Component({
	            selector: "wego-odometerlogtrail",
	            template: __webpack_require__(533),
	            providers: [odometerlogtrail_service_1.OdometerLogTrailService],
	            styles: [
	                "\n  .nowrap{\n    white-space: nowrap;\n   } \n   :host /deep/ .sort-icon {\n    float: none !important;    \n  }\n  "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof odometerlogtrail_service_1.OdometerLogTrailService !== 'undefined' && odometerlogtrail_service_1.OdometerLogTrailService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object])
	    ], OdometerLogTrailListComponent);
	    return OdometerLogTrailListComponent;
	    var _a, _b, _c, _d;
	}());
	exports.OdometerLogTrailListComponent = OdometerLogTrailListComponent;


/***/ },
/* 533 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ breadCrumbList}} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li class=\"active\"> {{ breadCrumbList}} </li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25\">\r\n      <wego-authorized-link [LinkModel]=\"addOdometerLogTrailLink\"></wego-authorized-link>\r\n      <!-- <a class=\"btn btn-highlight navbar-right\" [routerLink]=\"[urlOdometerLogTrailUpdate]\" routerLinkActive=\"active\">{{ 'LblAddNew' | translate }}</a> -->\r\n    </div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <p class=\"text-success\">{{ message }}</p>\r\n        <wego-search-list [IsDeleted]=\"false\" [IsCustomButton]='true' [CustomeIcon]=\"LblIcon\" [Title]=\"LblAddDescriptionOfDeviation\"\r\n          [IsCustomButtonEnabled]=\"isAnyChecked && isEditAccess\" (OnCustomeButton)=\"OnCustomeButton($event) \" (OnSearch)=\"OnSearch($event)\"\r\n          (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm \"\r\n          [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"checkbox\">\r\n          <label>\r\n            <input [(ngModel)]=\"chkDescription\" type=\"checkbox\" name=\"chkDescription\" (change)=\"OnDescriptionFilterChange()\">{{ 'LblShowDeviation' | translate }}</label>\r\n        </div>\r\n        <div class=\"table table-responsive mar_bot_ziro \">\r\n          <table class=\"table table-bordered mar_bot_ziro \">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center parent-checkbox\">\r\n                  <input type=\"checkbox\" [(ngModel)]=\"isParentCheck\" [disabled]=\"!(isParentCheckEnable && isEditAccess)\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\">\r\n                </th>\r\n                <th class=\"cursor-pointer nowrap\" (click)=\"OnSort('instanceName')\">\r\n                  {{ 'LblInstanceName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'instanceName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer nowrap\" (click)=\"OnSort('companyName')\">\r\n                  {{ 'LblCompany' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'companyName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer nowrap\" (click)=\"OnSort('licenceTag')\">\r\n                  {{ 'LblLicenceTag' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'licenceTag'\" [SortType]=\"DataListModel.sortType \" [SortReverse]=\"DataListModel.sortReverse \"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer nowrap\" (click)=\"OnSort( 'userProvidedOdometerValueInKm') \">\r\n                  {{ 'LblUserProvidedOdometerValueInKmr' | translate }}\r\n                  <wego-sort-list [FieldName]=\" 'userProvidedOdometerValueInKm'\" [SortType]=\"DataListModel.sortType \" [SortReverse]=\"DataListModel.sortReverse \"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer nowrap\" (click)=\"OnSort( 'userUpdatedDateTimeUTC')\">\r\n                  {{ 'LblDateRegistered' | translate }}\r\n                  <wego-sort-list [FieldName]='userUpdatedDateTimeUTC' [SortType]=\"DataListModel.sortType \" [SortReverse]=\"DataListModel.sortReverse \"></wego-sort-list>\r\n                </th>\r\n                <th>{{ 'LblLastOdometerValue' | translate }}</th>\r\n                <th>{{ 'LblLastOdometerDT' | translate }}</th>\r\n                <th> {{ 'LblDeviation' | translate }} </th>\r\n                <th>\r\n                  {{ 'LblDescriptionOfDeviation' | translate }}\r\n                </th>\r\n                <th class=\"cursor-pointer nowrap\" (click)=\"OnSort('personName')\">\r\n                  {{ 'LblRegisteredBy' | translate }}\r\n                  <wego-sort-list [FieldName]=\" 'personName' \" [SortType]=\"DataListModel.sortType \" [SortReverse]=\"DataListModel.sortReverse \"></wego-sort-list>\r\n                </th>\r\n                <th class=\"text-center \">{{ 'LblEdit' | translate }}</th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems !=0 \">\r\n                <tr *ngFor=\"let odometer of odometerLogTrailList\">\r\n                  <td class=\"text-center \">\r\n                    <input [disabled]=\"!(odometer.descriptionOfDeviation==null && odometer.isEditable)\" type=\"checkbox\" name=\"isActive\" [(ngModel)]=\"odometer.isChecked\">\r\n                  </td>\r\n                  <td>{{ odometer.instanceName }}</td>\r\n                  <td>{{ odometer.companyName }}</td>\r\n                  <td>{{ odometer.licenceTag }}</td>\r\n                  <td>{{ odometer.userProvidedOdometerValueInKm }}</td>\r\n                  <td>{{ odometer.userUpdatedDateTime }}</td>\r\n                  <td>{{ odometer.calculateOdometerValue }}</td>\r\n                  <td>{{ odometer.lastOdometerDateTime }}</td>\r\n                  <td>{{ odometer.deviation }}</td>\r\n                  <td>{{odometer.descriptionOfDeviation}}</td>\r\n                  <td>\r\n                    <template [ngIf]=\"!odometer.isPersonDeleted && odometer.isRegisterBy\">\r\n                      <a [routerLink]=\"urlPersonInfo + '/' + odometer.personMasterHashId\">\r\n                        {{ odometer.personName }}\r\n                      </a>\r\n                    </template>\r\n                    <template [ngIf]=\"odometer.isPersonDeleted || !odometer.isRegisterBy\">\r\n                      {{ odometer.personName }}\r\n                    </template>\r\n                  </td>\r\n                  <!-- <td >\r\n                    {{ odometer.personName }}\r\n                  </td> -->\r\n                  <td class=\"text-center \">\r\n                    <a *ngIf=\"odometer.isEditable\" [routerLink]=\"urlOdometerLogTrailUpdate + '/' + odometer.odometerLogTrailHashId\">\r\n                      <i class=\"fa fa-pencil-square-o fa-fw \"></i>\r\n                    </a>\r\n                  </td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems==0 && !isLoading \">\r\n                <td class=\"text-center text-danger \" colspan=\"12\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix \"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro \">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad \">\r\n            <div class=\"col-md-12 \">\r\n              <pagination class=\"pull-right \" [totalItems]=\"DataListModel.totalItems \" [itemsPerPage]=\"DataListModel.itemsPerPage \" [(ngModel)]=\"DataListModel.currentPage \"\r\n                [maxSize]=\"DataListModel.maxSize \" [boundaryLinks]=\"true \" previousText=\"&lsaquo;\r\n                    \" nextText=\"&rsaquo; \" firstText=\"&laquo; \" lastText=\"&raquo; \" [rotate]=\"false \" (pageChanged)=\"OnPageChanged($event) \"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n\r\n<div bsModal #descriptionModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1 \" role=\"dialog \" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-sm \">\r\n    <div class=\"modal-content \">\r\n      <div class=\"modal-header \">\r\n        {{ 'LblDescriptionOfDeviation' | translate }}\r\n        <button type=\"button \" class=\"close \" aria-label=\"Close \" (click)=\"HideDescriptionModal() \">\r\n          <span aria-hidden=\"true \">&times;</span>\r\n        </button>\r\n        <div class=\"clearfix\"></div>\r\n      </div>\r\n      <form (ngSubmit)=\"onSubmit(DescriptionForm.value)\" #DescriptionForm=\"ngForm\">\r\n        <div class=\"modal-body \">\r\n          <div class=\"row \">\r\n            <div class=\"col-xs-12 form-group \">\r\n              <textarea class=\"form-control \" id=\"description \" [(ngModel)]=\"model.descriptionOfDeviation \" name=\"descriptionOfDeviation \"\r\n                placeholder=\"{{ 'LblDescriptionOfDeviation' | translate }}\"></textarea>\r\n              <span class=\"text text-danger \">{{ errorModel | serverErrorMessage : 'descriptionOfDeviation' }}</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"modal-footer \">\r\n          <button type=\"submit \" class=\"btn btn-primary \">{{ 'LblSave' | translate }}</button>\r\n          <!--<button type=\"button \" class=\"btn btn-default \" (click)=\"HideDescriptionModal() \">{{ 'LblNo' | translate }}</button>-->\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var decimal_formatter_service_1 = __webpack_require__(69);
	var core_1 = __webpack_require__(3);
	var PADDING = "000000";
	var DecimalFormatterPipe = (function () {
	    function DecimalFormatterPipe(decimalFormatterService) {
	        this.decimalFormatterService = decimalFormatterService;
	    }
	    //transform(value: number | string, fractionSize: number = 2): string {
	    DecimalFormatterPipe.prototype.transform = function (value, allowGrouping) {
	        if (allowGrouping === void 0) { allowGrouping = false; }
	        return this.decimalFormatterService.transform(value, allowGrouping);
	    };
	    DecimalFormatterPipe = __decorate([
	        core_1.Pipe({ name: "decimalFormatter" }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof decimal_formatter_service_1.DecimalFormatterService !== 'undefined' && decimal_formatter_service_1.DecimalFormatterService) === 'function' && _a) || Object])
	    ], DecimalFormatterPipe);
	    return DecimalFormatterPipe;
	    var _a;
	}());
	exports.DecimalFormatterPipe = DecimalFormatterPipe;


/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var lang_de_1 = __webpack_require__(74);
	var lang_nl_1 = __webpack_require__(73);
	var lang_en_1 = __webpack_require__(72);
	var lang_fr_1 = __webpack_require__(77);
	var lang_pl_1 = __webpack_require__(78);
	var lang_pt_1 = __webpack_require__(76);
	var core_1 = __webpack_require__(3);
	var LanguageHelperComponent = (function () {
	    function LanguageHelperComponent() {
	        this.combineArray = [];
	        //oldKeys: any;
	        this.onlyNewKeys = false;
	    }
	    LanguageHelperComponent.prototype.ngOnInit = function () {
	        this.Init();
	    };
	    LanguageHelperComponent.prototype.Init = function () {
	        var en = lang_en_1.LANG_EN_TRANS;
	        var nl = lang_nl_1.LANG_NL_TRANS;
	        var de = lang_de_1.LANG_DE_TRANS;
	        var pt = lang_pt_1.LANG_PT_TRANS;
	        var fr = lang_fr_1.LANG_FR_TRANS;
	        var pl = lang_pl_1.LANG_PL_TRANS;
	        var enKeys = Object.keys(en);
	        var nlKeys = Object.keys(nl);
	        var deKeys = Object.keys(de);
	        var ptKeys = Object.keys(pt);
	        var frKeys = Object.keys(fr);
	        var plKeys = Object.keys(pl);
	        this.missingInNLArray = this.MissingKeys(enKeys, nlKeys);
	        console.log(this.missingInNLArray);
	        this.missingInENArray = this.MissingKeys(nlKeys, enKeys);
	        console.log(this.missingInENArray);
	        this.missingInDEArray = this.MissingKeys(enKeys, deKeys);
	        console.log(this.missingInDEArray);
	        this.missingInPTArray = this.MissingKeys(enKeys, ptKeys);
	        console.log(this.missingInPTArray);
	        this.missingInFRArray = this.MissingKeys(enKeys, frKeys);
	        console.log(this.missingInFRArray);
	        this.missingInPLArray = this.MissingKeys(enKeys, plKeys);
	        console.log(this.missingInPLArray);
	        var matchKeys = enKeys;
	        matchKeys = matchKeys.concat(this.missingInENArray);
	        this.mapArray = this.MapArray(matchKeys, en, nl, de, pt, fr, pl);
	        console.log(this.mapArray);
	    };
	    LanguageHelperComponent.prototype.MissingKeys = function (array1, array2) {
	        var missingArray = [];
	        array1.forEach(function (element) {
	            if (!(array2.indexOf(element) > -1)) {
	                missingArray.push(element);
	            }
	        });
	        return missingArray;
	    };
	    LanguageHelperComponent.prototype.MapArray = function (keys, enArray, nlArray, deArray, ptArray, frArray, plArray) {
	        var mapArray = [];
	        keys.forEach(function (element) {
	            var mapObject = {};
	            mapObject["key"] = element;
	            mapObject["en"] = enArray[element];
	            mapObject["nl"] = nlArray[element];
	            mapObject["de"] = deArray[element];
	            mapObject["pt"] = ptArray[element];
	            mapObject["fr"] = frArray[element];
	            mapObject["pl"] = plArray[element];
	            mapArray.push(mapObject);
	        });
	        return mapArray;
	    };
	    LanguageHelperComponent.prototype.DownloadAllLabelCSV = function () {
	        this.JSONToCSVConvertor(this.mapArray, "Language_BackOffice", true);
	    };
	    LanguageHelperComponent.prototype.DownloadNewLabelCSV = function () {
	        var _this = this;
	        var newMapArray = this.mapArray.filter(function (x) { return _this.ExistInOld(x.key); });
	        this.JSONToCSVConvertor(newMapArray, "Language_BackOffice", true);
	    };
	    LanguageHelperComponent.prototype.JSONToCSVConvertor = function (JSONData, ReportTitle, ShowLabel) {
	        //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
	        var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;
	        var CSV = '';
	        //Set Report title in first row or line
	        //CSV += ReportTitle + '\r\n\n';
	        //This condition will generate the Label/Header
	        if (ShowLabel) {
	            var row = "";
	            //This loop will extract the label from 1st index of on array
	            for (var index in arrData[0]) {
	                //Now convert each value to string and comma-seprated
	                row += index + ',';
	            }
	            row = row.slice(0, -1);
	            //append Label row with line break
	            CSV += row + '\r\n';
	        }
	        //1st loop is to extract each row
	        for (var i = 0; i < arrData.length; i++) {
	            var row = "";
	            //2nd loop will extract each column and convert it in string comma-seprated
	            for (var index in arrData[i]) {
	                row += '"' + arrData[i][index] + '",';
	            }
	            row.slice(0, row.length - 1);
	            //add a line break after each row
	            CSV += row + '\r\n';
	        }
	        if (CSV == '') {
	            alert("Invalid data");
	            return;
	        }
	        //Generate a file name
	        var fileName = "File_";
	        //this will remove the blank-spaces from the title and replace it with an underscore
	        fileName += ReportTitle.replace(/ /g, "_");
	        //Initialize file format you want csv or xls
	        var uri = 'data:text/csv;charset=utf-8,' + encodeURIComponent(CSV);
	        // Now the little tricky part.
	        // you can use either>> window.open(uri);
	        // but this will not work in some browsers
	        // or you will not get the correct file extension    
	        //this trick will generate a temp a /> tag
	        var link = document.createElement("a");
	        link.href = uri;
	        //set the visibility hidden so it will not effect on your web-layout
	        link.style = "visibility:hidden";
	        link.download = fileName + ".csv";
	        //this part will append the anchor tag and remove it after automatic click
	        document.body.appendChild(link);
	        link.click();
	        document.body.removeChild(link);
	    };
	    LanguageHelperComponent.prototype.DisplayNewOnly = function (item) {
	        if (this.onlyNewKeys) {
	            return !this.ExistInOld(item.key) && !this.MatchValue(item.en_old, item.en) && !this.MatchValue(item.nl_old, item.nl) && !this.MatchValue(item.de_old, item.de) && !this.MatchValue(item.fr_old, item.fr) && !this.MatchValue(item.pl_old, item.pl) && !this.MatchValue(item.pt_old, item.pt);
	        }
	        else {
	            return false;
	        }
	    };
	    LanguageHelperComponent.prototype.ExistInOld = function (key) {
	        if (this.oldArray) {
	            //let oldKeyArray = this.oldKeys.split("\n");
	            var oldKeyArray = this.oldArray.map(function (x) { return x.key; });
	            if (!(oldKeyArray.indexOf(key) > -1))
	                return true;
	            else
	                return false;
	        }
	        else {
	            return true;
	        }
	    };
	    LanguageHelperComponent.prototype.MatchValue = function (value1, value2) {
	        if (value1 == value2)
	            return false;
	        else
	            return true;
	    };
	    LanguageHelperComponent.prototype.HandleFiles = function (files) {
	        // Check for the various File API support.
	        if (window.FileReader) {
	            // FileReader are supported.
	            if (files && files.length > 0) {
	                var file = files.item(0);
	                //Now you can get
	                console.log(file.name);
	                console.log(file.size);
	                console.log(file.type);
	                this.GetAsText(file);
	            }
	        }
	        else {
	            alert('FileReader are not supported in this browser.');
	        }
	    };
	    LanguageHelperComponent.prototype.GetAsText = function (fileToRead) {
	        var _this = this;
	        var reader = new FileReader();
	        // Read file into memory as UTF-8      
	        reader.readAsText(fileToRead);
	        // Handle errors load
	        reader.onload = function (event) { return _this.LoadHandler(event); };
	        reader.onerror = function (event) { return _this.ErrorHandler(event); };
	    };
	    LanguageHelperComponent.prototype.LoadHandler = function (event) {
	        var csv = event.target.result;
	        this.oldArray = this.CSV2JSON(csv);
	        this.combineArray = this.JoinObjects([this.mapArray, this.oldArray]);
	        console.log(this.combineArray);
	    };
	    LanguageHelperComponent.prototype.CSVToArray = function (strData, strDelimiter) {
	        // Check to see if the delimiter is defined. If not,
	        // then default to comma.
	        strDelimiter = (strDelimiter || ",");
	        // Create a regular expression to parse the CSV values.
	        var objPattern = new RegExp((
	        // Delimiters.
	        "(\\" + strDelimiter + "|\\r?\\n|\\r|^)" +
	            // Quoted fields.
	            "(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" +
	            // Standard fields.
	            "([^\"\\" + strDelimiter + "\\r\\n]*))"), "gi");
	        // Create an array to hold our data. Give the array
	        // a default empty first row.
	        var arrData = [[]];
	        // Create an array to hold our individual pattern
	        // matching groups.
	        var arrMatches = null;
	        // Keep looping over the regular expression matches
	        // until we can no longer find a match.
	        while (arrMatches = objPattern.exec(strData)) {
	            // Get the delimiter that was found.
	            var strMatchedDelimiter = arrMatches[1];
	            // Check to see if the given delimiter has a length
	            // (is not the start of string) and if it matches
	            // field delimiter. If id does not, then we know
	            // that this delimiter is a row delimiter.
	            if (strMatchedDelimiter.length && (strMatchedDelimiter != strDelimiter)) {
	                // Since we have reached a new row of data,
	                // add an empty row to our data array.
	                arrData.push([]);
	            }
	            // Now that we have our delimiter out of the way,
	            // let's check to see which kind of value we
	            // captured (quoted or unquoted).
	            if (arrMatches[2]) {
	                // We found a quoted value. When we capture
	                // this value, unescape any double quotes.
	                var strMatchedValue = arrMatches[2].replace(new RegExp("\"\"", "g"), "\"");
	            }
	            else {
	                // We found a non-quoted value.
	                var strMatchedValue = arrMatches[3];
	            }
	            // Now that we have our value string, let's add
	            // it to the data array.
	            arrData[arrData.length - 1].push(strMatchedValue);
	        }
	        // Return the parsed data.
	        return (arrData);
	    };
	    LanguageHelperComponent.prototype.CSV2JSON = function (csv) {
	        var array = this.CSVToArray(csv);
	        var objArray = [];
	        for (var i = 1; i < array.length; i++) {
	            objArray[i - 1] = {};
	            for (var k = 0; k < array[0].length && k < array[i].length; k++) {
	                var key = array[0][k];
	                objArray[i - 1][key] = array[i][k];
	            }
	        }
	        // let json: any = JSON.stringify(objArray);
	        // let str: any = json.replace(/},/g, "},\r\n");
	        return objArray;
	    };
	    LanguageHelperComponent.prototype.ErrorHandler = function (evt) {
	        if (evt.target.error.name == "NotReadableError") {
	            alert("Can't read file !");
	        }
	    };
	    LanguageHelperComponent.prototype.JoinObjects = function (magicArray) {
	        var idMap = {};
	        // Iterate over arguments
	        for (var i = 0; i < magicArray.length; i++) {
	            // Iterate over individual argument arrays (aka json1, json2)
	            for (var j = 0; j < magicArray[i].length; j++) {
	                var currentID = magicArray[i][j]['key'];
	                if (!idMap[currentID]) {
	                    idMap[currentID] = {};
	                }
	                // Iterate over properties of objects in arrays (aka id, name, etc.)
	                for (var key in magicArray[i][j]) {
	                    idMap[currentID][key] = magicArray[i][j][key];
	                }
	            }
	        }
	        // push properties of idMap into an array
	        var newArray = [];
	        for (var property in idMap) {
	            newArray.push(idMap[property]);
	        }
	        return newArray;
	    };
	    LanguageHelperComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-language-helper',
	            styles: ["\n    .wrap-language{\n      padding: 15px;  \n    }\n    .list-group-item{\n      padding: 5px 15px;\n    }\n  "],
	            template: "\n          <div class=\"wrap-language\">\n            <header>\n              <h1 class=\"text-center\">Language BackOffice File</h1>\n            </header>\n            <article>\n              <div class=\"row\">\n                <section class=\"col-sm-4\" *ngIf=\"missingInENArray && missingInENArray.length > 0\">\n                  <header>\n                    <h4>Missing in English Label</h4>\n                  </header>\n                  <ul class=\"list-group\">\n                    <li class=\"list-group-item\" *ngFor=\"let item of missingInENArray\">{{ item }}</li>\n                  </ul>\n                </section>\n                <section class=\"col-sm-4\" *ngIf=\"missingInNLArray && missingInNLArray.length > 0\">\n                  <header>\n                    <h4>Missing in Dutch Label</h4>\n                  </header>\n                  <ul class=\"list-group\">\n                    <li class=\"list-group-item\" *ngFor=\"let item of missingInNLArray\">{{ item }}</li>\n                  </ul>\n                </section>\n                <section class=\"col-sm-4\" *ngIf=\"missingInDEArray && missingInDEArray.length > 0\">\n                  <header>\n                    <h4>Missing in Lbl Label</h4>\n                  </header>\n                  <ul class=\"list-group\">\n                    <li class=\"list-group-item\" *ngFor=\"let item of missingInDEArray\">{{ item }}</li>\n                  </ul>\n                </section>\n                <section class=\"col-sm-4\" *ngIf=\"missingInPTArray && missingInPTArray.length > 0\">\n                  <header>\n                    <h4>Missing in Portuguese Label</h4>\n                  </header>\n                  <ul class=\"list-group\">\n                    <li class=\"list-group-item\" *ngFor=\"let item of missingInPTArray\">{{ item }}</li>\n                  </ul>\n                </section>\n                <section class=\"col-sm-4\" *ngIf=\"missingInFRArray && missingInFRArray.length > 0\">\n                  <header>\n                    <h4>Missing in French Label</h4>\n                  </header>\n                  <ul class=\"list-group\">\n                    <li class=\"list-group-item\" *ngFor=\"let item of missingInFRArray\">{{ item }}</li>\n                  </ul>\n                </section>\n                <section class=\"col-sm-4\" *ngIf=\"missingInPLArray && missingInPLArray.length > 0\">\n                  <header>\n                    <h4>Missing in Polish Label</h4>\n                  </header>\n                  <ul class=\"list-group\">\n                    <li class=\"list-group-item\" *ngFor=\"let item of missingInPLArray\">{{ item }}</li>\n                  </ul>\n                </section>\n              </div>\n              <div class=\"clearfix\"></div>\n              <section>\n                <header>\n                  <h4>Old Key Values</h4>\n                </header>\n            \n                <input type=\"file\" id=\"csvFileInput\" (change)=\"HandleFiles($event.target.files)\" accept=\".csv\">\n              </section>\n              <section>\n                <header>\n                  <h4>System Labels</h4>\n                </header>\n                <div class=\"row\">\n                  <div class=\"col-sm-6\">\n                    <label class=\"radio-inline\"><input type=\"radio\" [(ngModel)]=\"onlyNewKeys\" name=\"onlyNewKeys\" [value]=\"true\">Only New Label</label>\n                    <label class=\"radio-inline\"><input type=\"radio\" [(ngModel)]=\"onlyNewKeys\" name=\"onlyNewKeys\" [value]=\"false\">All Label</label>\n                  </div>\n                  <div class=\"col-sm-6 text-right\">\n                    <button class=\"btn btn-success btn-xs\" type=\"button\" (click)=\"DownloadNewLabelCSV()\">Download New Label</button>&nbsp;&nbsp;\n                    <button class=\"btn btn-info btn-xs\" type=\"button\" (click)=\"DownloadAllLabelCSV()\">Download All Label</button>\n                  </div>\n                </div>\n                <table class=\"table table-bordered\">\n                  <tr>\n                    <th>Key</th>\n                    <th>English Old</th>\n                    <th>English New</th>\n                    <th>Dutch Old</th>\n                    <th>Dutch New</th>\n                    <th>German Old</th>\n                    <th>German New</th>\n                    <th>Portuguese Old</th>\n                    <th>Portuguese New</th>\n                    <th>French Old</th>\n                    <th>French New</th>\n                    <th>Polish Old</th>\n                    <th>Polish New</th>\n                  </tr>\n                  <tr *ngFor=\"let item of combineArray\" [ngClass]=\"{'hide': DisplayNewOnly(item) }\">\n                    <td [ngClass]=\"{'success' : ExistInOld(item.key) }\">{{ item.key }}</td>\n                    <td [ngClass]=\"{'danger' : MatchValue(item.en_old, item.en) }\">{{ item.en_old }}</td>\n                    <td [ngClass]=\"{'danger' : MatchValue(item.en_old, item.en) }\">{{ item.en }}</td>\n                    <td [ngClass]=\"{'danger' : MatchValue(item.nl_old, item.nl) }\">{{ item.nl_old }}</td>\n                    <td [ngClass]=\"{'danger' : MatchValue(item.nl_old, item.nl) }\">{{ item.nl }}</td>\n                    <td [ngClass]=\"{'danger' : MatchValue(item.de_old, item.de) }\">{{ item.de_old }}</td>\n                    <td [ngClass]=\"{'danger' : MatchValue(item.de_old, item.de) }\">{{ item.de }}</td>\n                    <td [ngClass]=\"{'danger' : MatchValue(item.pt_old, item.pt) }\">{{ item.pt_old }}</td>\n                    <td [ngClass]=\"{'danger' : MatchValue(item.pt_old, item.pt) }\">{{ item.pt }}</td>\n                    <td [ngClass]=\"{'danger' : MatchValue(item.fr_old, item.fr) }\">{{ item.fr_old }}</td>\n                    <td [ngClass]=\"{'danger' : MatchValue(item.fr_old, item.fr) }\">{{ item.fr }}</td>\n                    <td [ngClass]=\"{'danger' : MatchValue(item.pl_old, item.pl) }\">{{ item.pl_old }}</td>\n                    <td [ngClass]=\"{'danger' : MatchValue(item.pl_old, item.pl) }\">{{ item.pl }}</td>\n                  </tr>\n                </table>\n              </section>\n            </article>\n          </div>\n  "
	        }), 
	        __metadata('design:paramtypes', [])
	    ], LanguageHelperComponent);
	    return LanguageHelperComponent;
	}());
	exports.LanguageHelperComponent = LanguageHelperComponent;


/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var modal_1 = __webpack_require__(537);
	var translate_service_1 = __webpack_require__(70);
	var core_1 = __webpack_require__(3);
	var config_1 = __webpack_require__(60);
	var auth_service_1 = __webpack_require__(58);
	var GeoLocationMapComponent = (function () {
	    function GeoLocationMapComponent(translate, authService) {
	        this.translate = translate;
	        this.authService = authService;
	        this._popupTitle = this.translate.instant('LblSelectGeoLocation');
	        this.onConfirm = new core_1.EventEmitter();
	        this.platform = new H.service.Platform({
	            'api_key': config_1.WeGoConfig.HERE_MAP_API_KEY
	        });
	        this.platform.setUseHTTPS(true);
	        this.hgeocoder = this.platform.getGeocodingService();
	    }
	    Object.defineProperty(GeoLocationMapComponent.prototype, "popupTitle", {
	        get: function () { return this._popupTitle; },
	        set: function (popupTitle) {
	            this._popupTitle = (popupTitle && popupTitle.trim()) || this.translate.instant('LblSelectGeoLocation');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(GeoLocationMapComponent.prototype, "Language", {
	        get: function () { return this._language; },
	        set: function (language) {
	            this._language = language.trim();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    GeoLocationMapComponent.prototype.ngOnInit = function () {
	        this.InitDefaultValue();
	    };
	    GeoLocationMapComponent.prototype.show = function (address, lat, long) {
	        var _this = this;
	        this.geoLocationModal.show();
	        var pos;
	        this.RemoveMarkers();
	        this.searchInput.value = "";
	        if (address && lat != 0 && long != 0) {
	            pos = new google.maps.LatLng(lat, long);
	            this.AddMarker(pos);
	            this.GeoCodePosition(pos);
	        }
	        else {
	            //this.UpdateAddress('', 0, 0);      
	            pos = new google.maps.LatLng(config_1.WeGoConfig.DEFAULT_GEOLOCATION.Lat, config_1.WeGoConfig.DEFAULT_GEOLOCATION.Long);
	            this.AddMarker(pos);
	            this.GeoCodePosition(pos);
	        }
	        setTimeout(function () {
	            var center = pos ? pos : _this.map.getCenter();
	            google.maps.event.trigger(_this.map, "resize");
	            _this.map.setCenter(center);
	        }, 2000);
	    };
	    GeoLocationMapComponent.prototype.hide = function () {
	        this.geoLocationModal.hide();
	    };
	    GeoLocationMapComponent.prototype.InitDefaultValue = function () {
	        var _this = this;
	        this.searchInput = document.getElementById('search-input');
	        this.searchError = document.getElementById('search-error');
	        this.markers = [];
	        this.map = new google.maps.Map(document.getElementById('map'), {
	            center: { lat: 52.3702164, lng: 4.895168 },
	            zoom: 13,
	        });
	        // Create the search box and link it to the UI element.
	        this.searchBox = new google.maps.places.SearchBox(this.searchInput);
	        //this.map.controls[google.maps.ControlPosition.TOP_CENTER].push(this.searchInput);
	        // Bias the SearchBox results towards current map's viewport.
	        this.map.addListener('bounds_changed', function () { return _this.BoundChange(); });
	        // Listen for the event fired when the user selects a prediction and retrieve
	        // more details for that place.
	        this.searchBox.addListener('places_changed', function () { return _this.PlaceChange(); });
	    };
	    GeoLocationMapComponent.prototype.RemoveMarkers = function () {
	        while (this.markers.length) {
	            this.markers.pop().setMap(null);
	        }
	    };
	    GeoLocationMapComponent.prototype.BoundChange = function () {
	        this.searchBox.setBounds(this.map.getBounds());
	    };
	    GeoLocationMapComponent.prototype.PlaceChange = function () {
	        this.RemoveMarkers();
	        this.searchError.innerHTML = "";
	        var places = this.searchBox.getPlaces();
	        if (places.length == 0) {
	            this.searchError.innerHTML = this.translate.instant('LblAddressNotAvailable');
	            this.UpdateAddress('', 0, 0);
	            return;
	        }
	        var place = places[0];
	        if (!place.geometry) {
	            this.searchError.innerHTML = this.translate.instant('LblAddressNotAvailable');
	            this.UpdateAddress('', 0, 0);
	            return;
	        }
	        console.log(place);
	        this.AddMarker(place.geometry.location);
	        this.UpdateAddress(place.formatted_address, place.geometry.location.lat(), place.geometry.location.lng());
	        this.searchInput.value = place.formatted_address;
	        var bounds = new google.maps.LatLngBounds();
	        if (place.geometry.viewport) {
	            // Only geo codes have viewport.
	            bounds.union(place.geometry.viewport);
	        }
	        else {
	            bounds.extend(place.geometry.location);
	        }
	        this.map.fitBounds(bounds);
	    };
	    GeoLocationMapComponent.prototype.AddMarker = function (pos) {
	        var _this = this;
	        // Create a marker for each place.
	        var marker = new google.maps.Marker({
	            map: this.map,
	            //icon: icon,
	            //title: place.name,
	            position: pos,
	            draggable: true,
	        });
	        this.markers.push(marker);
	        marker.addListener('dragend', function () { return _this.GeoCodePosition(marker.getPosition()); });
	    };
	    GeoLocationMapComponent.prototype.GeoCodePosition = function (pos) {
	        var _this = this;
	        console.log('GeoCodePosition - reverseGeocode call');
	        // let geocoder = new google.maps.Geocoder();
	        // geocoder.geocode
	        //   ({ latLng: pos },
	        //   (results: any, status: any) => {
	        //     console.log(results);
	        //     console.log(pos);
	        //     if (status == google.maps.GeocoderStatus.OK) {
	        //       this.searchInput.value = results[0].formatted_address;
	        //       this.searchError.innerHTML = "";
	        //       this.UpdateAddress(results[0].formatted_address, pos.lat(), pos.lng());
	        //     }
	        //     else {
	        //       this.searchError.innerHTML = this.translate.instant('LblAddressNotAvailable');
	        //       this.UpdateAddress('', 0, 0);
	        //     }
	        //   });
	        var userlanguage = 'en';
	        if (this.authService.IsDriver()) {
	            var usersetting = this.authService.GetUserSetting();
	            if (usersetting) {
	                userlanguage = usersetting.instanceLanguage;
	            }
	        }
	        else {
	            userlanguage = this.Language ? this.Language : 'en';
	        }
	        this.hgeocoder.reverseGeocode({
	            prox: pos.lat() + ',' + pos.lng() + ',' + config_1.WeGoConfig.HERE_MAP_LOC_RADIUS, resultType: 'houseNumber',
	            query: 'High', language: userlanguage.toLowerCase(), mode: 'retrieveAddress', gen: '9'
	        }, function (result) {
	            if (result.Response.View.length > 0) {
	                if (result.Response.View[0].Result.length > 0) {
	                    console.log(result.Response.View[0].Result);
	                    var houseMatch = result.Response.View[0].Result.filter(function (x) { return x.MatchLevel == 'houseNumber'; });
	                    var matchedAddress;
	                    if (houseMatch.length > 0) {
	                        matchedAddress = houseMatch[0];
	                    }
	                    else {
	                        matchedAddress = result.Response.View[0].Result[0];
	                    }
	                    _this.searchInput.value = matchedAddress.Location.Address.Label;
	                    _this.searchError.innerHTML = '';
	                    _this.UpdateAddress(matchedAddress.Location.Address.Label, pos.lat(), pos.lng());
	                }
	                else {
	                    _this.searchError.innerHTML = _this.translate.instant('LblAddressNotAvailable');
	                    _this.UpdateAddress('', 0, 0);
	                }
	            }
	            else {
	                _this.searchError.innerHTML = _this.translate.instant('LblAddressNotAvailable');
	                _this.UpdateAddress('', 0, 0);
	            }
	        }, function (error) {
	            console.log(error);
	        });
	    };
	    GeoLocationMapComponent.prototype.UpdateAddress = function (address, lat, long) {
	        this.address = address;
	        this.lat = lat;
	        this.long = long;
	    };
	    GeoLocationMapComponent.prototype.Confirm = function ($event) {
	        this.onConfirm.emit({ address: this.address, lat: this.lat, long: this.long });
	        this.hide();
	    };
	    GeoLocationMapComponent.prototype.ResetInput = function () {
	        this.RemoveMarkers();
	        this.searchInput.value = "";
	        this.searchError.innerHTML = "";
	        this.UpdateAddress('', 0, 0);
	    };
	    __decorate([
	        core_1.ViewChild('geoLocationModal'), 
	        __metadata('design:type', (typeof (_a = typeof modal_1.ModalDirective !== 'undefined' && modal_1.ModalDirective) === 'function' && _a) || Object)
	    ], GeoLocationMapComponent.prototype, "geoLocationModal", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String), 
	        __metadata('design:paramtypes', [String])
	    ], GeoLocationMapComponent.prototype, "popupTitle", null);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String), 
	        __metadata('design:paramtypes', [String])
	    ], GeoLocationMapComponent.prototype, "Language", null);
	    __decorate([
	        core_1.Output('onConfirm'), 
	        __metadata('design:type', Object)
	    ], GeoLocationMapComponent.prototype, "onConfirm", void 0);
	    GeoLocationMapComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-geo-location-map',
	            styles: ["\n  #map{\n    height: 300px;\n  }\n  "],
	            template: "\n  <div bsModal #geoLocationModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" \n  aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\n    <div class=\"modal-dialog modal-lg\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n            <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\n                    <span aria-hidden=\"true\">&times;</span></button>\n                <h4 class=\"modal-title\">{{ popupTitle }}</h4>\n            </div>\n            <div class=\"modal-body\">\n                <div class=\"form-group\">\n                  <label>{{ 'LblEnterLocation' | translate }}</label>\n                  <div class=\"input-group\">\n                \n\n                    <input id=\"search-input\" placeholder=\"{{ 'LblEnterLocation' | translate }}\" class=\"form-control\" type=\"text\">\n                    <div class=\"input-group-btn\">\n                        <button class=\"btn btn-default\" type=\"button\" (click)=\"ResetInput()\">\n                          <i class=\"fa fa-eraser\" aria-hidden=\"true\"></i>\n                        </button>\n                    </div>\n                  </div>\n                  <span id=\"search-error\" class=\"text text-danger\"></span>\n                </div>\n                <div id=\"map\"></div>\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-green\" (click)=\"Confirm($event)\">{{ 'LblOK' |  translate }}</button>\n                <button type=\"button\" class=\"btn btn-gray\" (click)=\"hide()\">{{ 'LblCancel' |  translate }}</button>\n            </div>\n        </div>\n    </div>\n  </div>\n  "
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object])
	    ], GeoLocationMapComponent);
	    return GeoLocationMapComponent;
	    var _a, _b, _c;
	}());
	exports.GeoLocationMapComponent = GeoLocationMapComponent;


/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(538));
	__export(__webpack_require__(539));
	__export(__webpack_require__(540));
	var modal_module_1 = __webpack_require__(544);
	exports.ModalModule = modal_module_1.ModalModule;


/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var modal_options_class_1 = __webpack_require__(539);
	var ModalBackdropOptions = (function () {
	    function ModalBackdropOptions(options) {
	        this.animate = true;
	        Object.assign(this, options);
	    }
	    return ModalBackdropOptions;
	}());
	exports.ModalBackdropOptions = ModalBackdropOptions;
	var ModalBackdropComponent = (function () {
	    function ModalBackdropComponent(options, element, renderer) {
	        this._isShown = false;
	        this.element = element;
	        this.renderer = renderer;
	        this.isAnimated = options.animate !== false;
	    }
	    Object.defineProperty(ModalBackdropComponent.prototype, "isAnimated", {
	        get: function () {
	            return this._isAnimated;
	        },
	        set: function (value) {
	            this._isAnimated = value;
	            this.renderer.setElementClass(this.element.nativeElement, "" + modal_options_class_1.ClassName.FADE, value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ModalBackdropComponent.prototype, "isShown", {
	        get: function () {
	            return this._isShown;
	        },
	        set: function (value) {
	            this._isShown = value;
	            this.renderer.setElementClass(this.element.nativeElement, "" + modal_options_class_1.ClassName.IN, value);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ModalBackdropComponent.decorators = [
	        { type: core_1.Component, args: [{
	                    selector: 'bs-modal-backdrop',
	                    template: '',
	                    host: { 'class': modal_options_class_1.ClassName.BACKDROP }
	                },] },
	    ];
	    /** @nocollapse */
	    ModalBackdropComponent.ctorParameters = [
	        { type: ModalBackdropOptions, },
	        { type: core_1.ElementRef, },
	        { type: core_1.Renderer, },
	    ];
	    return ModalBackdropComponent;
	}());
	exports.ModalBackdropComponent = ModalBackdropComponent;


/***/ },
/* 539 */
/***/ function(module, exports) {

	"use strict";
	exports.modalConfigDefaults = {
	    backdrop: true,
	    keyboard: true,
	    focus: true,
	    show: true,
	    ignoreBackdropClick: false
	};
	exports.ClassName = {
	    SCROLLBAR_MEASURER: 'modal-scrollbar-measure',
	    BACKDROP: 'modal-backdrop',
	    OPEN: 'modal-open',
	    FADE: 'fade',
	    IN: 'in'
	};
	exports.Selector = {
	    DIALOG: '.modal-dialog',
	    DATA_TOGGLE: '[data-toggle="modal"]',
	    DATA_DISMISS: '[data-dismiss="modal"]',
	    FIXED_CONTENT: '.navbar-fixed-top, .navbar-fixed-bottom, .is-fixed'
	};


/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	// todo: should we support enforce focus in?
	// todo: in original bs there are was a way to prevent modal from showing
	// todo: original modal had resize events
	"use strict";
	var core_1 = __webpack_require__(3);
	var components_helper_service_1 = __webpack_require__(541);
	var utils_class_1 = __webpack_require__(542);
	var modal_backdrop_component_1 = __webpack_require__(538);
	var modal_options_class_1 = __webpack_require__(539);
	var browser_1 = __webpack_require__(543);
	var TRANSITION_DURATION = 300;
	var BACKDROP_TRANSITION_DURATION = 150;
	var ModalDirective = (function () {
	    function ModalDirective(element, renderer, componentsHelper) {
	        this.element = element;
	        this.renderer = renderer;
	        this.componentsHelper = componentsHelper;
	        this.onShow = new core_1.EventEmitter();
	        this.onShown = new core_1.EventEmitter();
	        this.onHide = new core_1.EventEmitter();
	        this.onHidden = new core_1.EventEmitter();
	        // seems like an Options
	        this.isAnimated = true;
	        this._isShown = false;
	        this.isBodyOverflowing = false;
	        this.originalBodyPadding = 0;
	        this.scrollbarWidth = 0;
	        this.timerHideModal = 0;
	        this.timerRmBackDrop = 0;
	    }
	    Object.defineProperty(ModalDirective.prototype, "config", {
	        get: function () {
	            return this._config;
	        },
	        set: function (conf) {
	            this._config = this.getConfig(conf);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ;
	    Object.defineProperty(ModalDirective.prototype, "isShown", {
	        get: function () {
	            return this._isShown;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ModalDirective.prototype, "document", {
	        get: function () {
	            return this.componentsHelper.getDocument();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ;
	    /** Host element manipulations */
	    // @HostBinding(`class.${ClassName.IN}`) private _addClassIn:boolean;
	    ModalDirective.prototype.onClick = function (event) {
	        if (this.config.ignoreBackdropClick || this.config.backdrop === 'static' || event.target !== this.element.nativeElement) {
	            return;
	        }
	        this.hide(event);
	    };
	    // todo: consider preventing default and stopping propagation
	    ModalDirective.prototype.onEsc = function () {
	        if (this.config.keyboard) {
	            this.hide();
	        }
	    };
	    ModalDirective.prototype.ngOnDestroy = function () {
	        this.config = void 0;
	        // this._element             = null
	        // this._dialog              = null
	        // this._backdrop            = null
	        if (this._isShown) {
	            this._isShown = false;
	            this.hideModal();
	        }
	        this._isShown = void 0;
	        this.isBodyOverflowing = void 0;
	        this.originalBodyPadding = void 0;
	        this.scrollbarWidth = void 0;
	        this.timerHideModal = void 0;
	        this.timerRmBackDrop = void 0;
	    };
	    ModalDirective.prototype.ngAfterViewInit = function () {
	        this._config = this._config || this.getConfig();
	    };
	    /** Public methods */
	    ModalDirective.prototype.toggle = function () {
	        return this._isShown ? this.hide() : this.show();
	    };
	    ModalDirective.prototype.show = function () {
	        var _this = this;
	        this.onShow.emit(this);
	        if (this._isShown) {
	            return;
	        }
	        clearTimeout(this.timerHideModal);
	        clearTimeout(this.timerRmBackDrop);
	        this._isShown = true;
	        this.checkScrollbar();
	        this.setScrollbar();
	        if (this.document && this.document.body) {
	            this.renderer.setElementClass(this.document.body, modal_options_class_1.ClassName.OPEN, true);
	        }
	        this.showBackdrop(function () {
	            _this.showElement();
	        });
	    };
	    ModalDirective.prototype.hide = function (event) {
	        var _this = this;
	        if (event) {
	            event.preventDefault();
	        }
	        this.onHide.emit(this);
	        // todo: add an option to prevent hiding
	        if (!this._isShown) {
	            return;
	        }
	        clearTimeout(this.timerHideModal);
	        clearTimeout(this.timerRmBackDrop);
	        this._isShown = false;
	        this.renderer.setElementClass(this.element.nativeElement, modal_options_class_1.ClassName.IN, false);
	        // this._addClassIn = false;
	        if (this.isAnimated) {
	            this.timerHideModal = setTimeout(function () { return _this.hideModal(); }, TRANSITION_DURATION);
	        }
	        else {
	            this.hideModal();
	        }
	    };
	    /** Private methods */
	    ModalDirective.prototype.getConfig = function (config) {
	        return Object.assign({}, modal_options_class_1.modalConfigDefaults, config);
	    };
	    /**
	     *  Show dialog
	     */
	    ModalDirective.prototype.showElement = function () {
	        var _this = this;
	        // todo: replace this with component helper usage `add to root`
	        if (!this.element.nativeElement.parentNode ||
	            (this.element.nativeElement.parentNode.nodeType !== Node.ELEMENT_NODE)) {
	            // don't move modals dom position
	            if (this.document && this.document.body) {
	                this.document.body.appendChild(this.element.nativeElement);
	            }
	        }
	        this.renderer.setElementAttribute(this.element.nativeElement, 'aria-hidden', 'false');
	        this.renderer.setElementStyle(this.element.nativeElement, 'display', 'block');
	        this.renderer.setElementProperty(this.element.nativeElement, 'scrollTop', 0);
	        if (this.isAnimated) {
	            utils_class_1.Utils.reflow(this.element.nativeElement);
	        }
	        // this._addClassIn = true;
	        this.renderer.setElementClass(this.element.nativeElement, modal_options_class_1.ClassName.IN, true);
	        var transitionComplete = function () {
	            if (_this._config.focus) {
	                _this.element.nativeElement.focus();
	            }
	            _this.onShown.emit(_this);
	        };
	        if (this.isAnimated) {
	            setTimeout(transitionComplete, TRANSITION_DURATION);
	        }
	        else {
	            transitionComplete();
	        }
	    };
	    ModalDirective.prototype.hideModal = function () {
	        var _this = this;
	        this.renderer.setElementAttribute(this.element.nativeElement, 'aria-hidden', 'true');
	        this.renderer.setElementStyle(this.element.nativeElement, 'display', 'none');
	        this.showBackdrop(function () {
	            if (_this.document && _this.document.body) {
	                _this.renderer.setElementClass(_this.document.body, modal_options_class_1.ClassName.OPEN, false);
	            }
	            _this.resetAdjustments();
	            _this.resetScrollbar();
	            _this.onHidden.emit(_this);
	        });
	    };
	    // todo: original show was calling a callback when done, but we can use promise
	    ModalDirective.prototype.showBackdrop = function (callback) {
	        var _this = this;
	        if (this._isShown && this.config.backdrop && (!this.backdrop || !this.backdrop.instance.isShown)) {
	            this.removeBackdrop();
	            this.backdrop = this.componentsHelper
	                .appendNextToRoot(modal_backdrop_component_1.ModalBackdropComponent, modal_backdrop_component_1.ModalBackdropOptions, new modal_backdrop_component_1.ModalBackdropOptions({ animate: false }));
	            if (this.isAnimated) {
	                this.backdrop.instance.isAnimated = this.isAnimated;
	                utils_class_1.Utils.reflow(this.backdrop.instance.element.nativeElement);
	            }
	            this.backdrop.instance.isShown = true;
	            if (!callback) {
	                return;
	            }
	            if (!this.isAnimated) {
	                callback();
	                return;
	            }
	            setTimeout(callback, BACKDROP_TRANSITION_DURATION);
	        }
	        else if (!this._isShown && this.backdrop) {
	            this.backdrop.instance.isShown = false;
	            var callbackRemove = function () {
	                _this.removeBackdrop();
	                if (callback) {
	                    callback();
	                }
	            };
	            if (this.backdrop.instance.isAnimated) {
	                this.timerRmBackDrop = setTimeout(callbackRemove, BACKDROP_TRANSITION_DURATION);
	            }
	            else {
	                callbackRemove();
	            }
	        }
	        else if (callback) {
	            callback();
	        }
	    };
	    ModalDirective.prototype.removeBackdrop = function () {
	        if (this.backdrop) {
	            this.backdrop.destroy();
	            this.backdrop = void 0;
	        }
	    };
	    /** Events tricks */
	    // no need for it
	    // private setEscapeEvent():void {
	    //   if (this._isShown && this._config.keyboard) {
	    //     $(this._element).on(Event.KEYDOWN_DISMISS, (event) => {
	    //       if (event.which === 27) {
	    //         this.hide()
	    //       }
	    //     })
	    //
	    //   } else if (!this._isShown) {
	    //     $(this._element).off(Event.KEYDOWN_DISMISS)
	    //   }
	    // }
	    // private setResizeEvent():void {
	    // console.log(this.renderer.listenGlobal('', Event.RESIZE));
	    // if (this._isShown) {
	    //   $(window).on(Event.RESIZE, $.proxy(this._handleUpdate, this))
	    // } else {
	    //   $(window).off(Event.RESIZE)
	    // }
	    // }
	    ModalDirective.prototype.resetAdjustments = function () {
	        this.renderer.setElementStyle(this.element.nativeElement, 'paddingLeft', '');
	        this.renderer.setElementStyle(this.element.nativeElement, 'paddingRight', '');
	    };
	    /** Scroll bar tricks */
	    ModalDirective.prototype.checkScrollbar = function () {
	        this.isBodyOverflowing = this.document.body.clientWidth < browser_1.window.innerWidth;
	        this.scrollbarWidth = this.getScrollbarWidth();
	    };
	    ModalDirective.prototype.setScrollbar = function () {
	        if (!this.document) {
	            return;
	        }
	        var fixedEl = this.document.querySelector(modal_options_class_1.Selector.FIXED_CONTENT);
	        if (!fixedEl) {
	            return;
	        }
	        var bodyPadding = parseInt(utils_class_1.Utils.getStyles(fixedEl).paddingRight || 0, 10);
	        this.originalBodyPadding = parseInt(this.document.body.style.paddingRight || 0, 10);
	        if (this.isBodyOverflowing) {
	            this.document.body.style.paddingRight = (bodyPadding + this.scrollbarWidth) + "px";
	        }
	    };
	    ModalDirective.prototype.resetScrollbar = function () {
	        this.document.body.style.paddingRight = this.originalBodyPadding;
	    };
	    // thx d.walsh
	    ModalDirective.prototype.getScrollbarWidth = function () {
	        var scrollDiv = this.renderer.createElement(this.document.body, 'div', void 0);
	        scrollDiv.className = modal_options_class_1.ClassName.SCROLLBAR_MEASURER;
	        var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	        this.document.body.removeChild(scrollDiv);
	        return scrollbarWidth;
	    };
	    ModalDirective.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: '[bsModal]',
	                    exportAs: 'bs-modal'
	                },] },
	    ];
	    /** @nocollapse */
	    ModalDirective.ctorParameters = [
	        { type: core_1.ElementRef, },
	        { type: core_1.Renderer, },
	        { type: components_helper_service_1.ComponentsHelper, },
	    ];
	    ModalDirective.propDecorators = {
	        'config': [{ type: core_1.Input },],
	        'onShow': [{ type: core_1.Output },],
	        'onShown': [{ type: core_1.Output },],
	        'onHide': [{ type: core_1.Output },],
	        'onHidden': [{ type: core_1.Output },],
	        'onClick': [{ type: core_1.HostListener, args: ['click', ['$event'],] },],
	        'onEsc': [{ type: core_1.HostListener, args: ['keydown.esc',] },],
	    };
	    return ModalDirective;
	}());
	exports.ModalDirective = ModalDirective;


/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var platform_browser_1 = __webpack_require__(21);
	/**
	 * Components helper class to easily work with
	 * allows to:
	 * - get application root view container ref
	 */
	var ComponentsHelper = (function () {
	    function ComponentsHelper(applicationRef, componentFactoryResolver, injector) {
	        this.applicationRef = applicationRef;
	        this.componentFactoryResolver = componentFactoryResolver;
	        this.injector = injector;
	    }
	    ComponentsHelper.prototype.getDocument = function () {
	        return this.injector.get(platform_browser_1.DOCUMENT);
	    };
	    /**
	     * In some cases, like using ngUpgrate,
	     * you need to explicitly set view container ref
	     * to made this method working you need to add:
	     * ```typescript
	     *  @Component({
	     *   selector: 'my-app',
	     *   ...
	     *   })
	     *  export class MyApp {
	     *    constructor(componentsHelper:ComponentsHelper, viewContainerRef: ViewContainerRef) {
	     *        // A Default view container ref, usually the app root container ref.
	     *        // Has to be set manually until we can find a way to get it automatically.
	     *        componentsHelper.setRootViewContainerRef(viewContainerRef)
	     *      }
	     *  }
	     * ```
	     */
	    ComponentsHelper.prototype.setRootViewContainerRef = function (value) {
	        this.root = value;
	    };
	    /**
	     * This is a name conventional class to get application root view component ref
	     * @returns {ViewContainerRef} - application root view component ref
	     */
	    ComponentsHelper.prototype.getRootViewContainerRef = function () {
	        // https://github.com/angular/angular/issues/9293
	        if (this.root) {
	            return this.root;
	        }
	        var comps = this.applicationRef.components;
	        if (!comps.length) {
	            throw new Error("ApplicationRef instance not found");
	        }
	        try {
	            /* one more ugly hack, read issue above for details */
	            var rootComponent = this.applicationRef._rootComponents[0];
	            this.root = rootComponent._hostElement.vcRef;
	            return this.root;
	        }
	        catch (e) {
	            throw new Error("ApplicationRef instance not found");
	        }
	    };
	    /**
	     * Creates an instance of a Component and attaches it to the View Container found at the
	     * `location` specified as {@link ViewContainerRef}.
	     *
	     * You can optionally provide `providers` to configure the {@link Injector} provisioned for this
	     * Component Instance.
	     *
	     * Returns {@link ComponentRef} representing the newly created Component.
	     * @param ComponentClass - @Component class
	     * @param location - reference to the location
	     * @param providers - optional array of providers
	     * @returns {ComponentRef<T>} - returns ComponentRef<T>
	     */
	    ComponentsHelper.prototype.appendNextToLocation = function (ComponentClass, location, providers) {
	        var componentFactory = this.componentFactoryResolver.resolveComponentFactory(ComponentClass);
	        var parentInjector = location.parentInjector;
	        var childInjector = parentInjector;
	        if (providers && providers.length > 0) {
	            childInjector = core_1.ReflectiveInjector.fromResolvedProviders(providers, parentInjector);
	        }
	        return location.createComponent(componentFactory, location.length, childInjector);
	    };
	    /**
	     * Helper methods to add ComponentClass(like modal backdrop) with options
	     * of type ComponentOptionsClass to element next to application root
	     * or next to provided instance of view container
	     * @param ComponentClass - @Component class
	     * @param ComponentOptionsClass - options class
	     * @param options - instance of options
	     * @returns {ComponentRef<T>} - returns ComponentRef<T>
	     */
	    ComponentsHelper.prototype.appendNextToRoot = function (ComponentClass, ComponentOptionsClass, options) {
	        var location = this.getRootViewContainerRef();
	        var providers = core_1.ReflectiveInjector.resolve([
	            { provide: ComponentOptionsClass, useValue: options }
	        ]);
	        return this.appendNextToLocation(ComponentClass, location, providers);
	    };
	    ComponentsHelper.decorators = [
	        { type: core_1.Injectable },
	    ];
	    /** @nocollapse */
	    ComponentsHelper.ctorParameters = [
	        { type: core_1.ApplicationRef, },
	        { type: core_1.ComponentFactoryResolver, },
	        { type: core_1.Injector, },
	    ];
	    return ComponentsHelper;
	}());
	exports.ComponentsHelper = ComponentsHelper;


/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var browser_1 = __webpack_require__(543);
	var Utils = (function () {
	    function Utils() {
	    }
	    Utils.reflow = function (element) {
	        new Function('bs', 'return bs')(element.offsetHeight);
	    };
	    // source: https://github.com/jquery/jquery/blob/master/src/css/var/getStyles.js
	    Utils.getStyles = function (elem) {
	        // Support: IE <=11 only, Firefox <=30 (#15098, #14150)
	        // IE throws on elements created in popups
	        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
	        var view = elem.ownerDocument.defaultView;
	        if (!view || !view.opener) {
	            view = browser_1.window;
	        }
	        return view.getComputedStyle(elem);
	    };
	    return Utils;
	}());
	exports.Utils = Utils;


/***/ },
/* 543 */
/***/ function(module, exports) {

	/*tslint:disable */
	/**
	 * @license
	 * Copyright Google Inc. All Rights Reserved.
	 *
	 * Use of this source code is governed by an MIT-style license that can be
	 * found in the LICENSE file at https://angular.io/license
	 */
	"use strict";
	/**
	 * JS version of browser APIs. This library can only run in the browser.
	 */
	var win = typeof window !== 'undefined' && window || {};
	exports.window = win;
	exports.document = win.document;
	exports.location = win.location;
	exports.gc = win['gc'] ? function () { return win['gc'](); } : function () { return null; };
	exports.performance = win['performance'] ? win['performance'] : null;
	exports.Event = win['Event'];
	exports.MouseEvent = win['MouseEvent'];
	exports.KeyboardEvent = win['KeyboardEvent'];
	exports.EventTarget = win['EventTarget'];
	exports.History = win['History'];
	exports.Location = win['Location'];
	exports.EventListener = win['EventListener'];


/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var modal_backdrop_component_1 = __webpack_require__(538);
	var modal_component_1 = __webpack_require__(540);
	var components_helper_service_1 = __webpack_require__(541);
	var ModalModule = (function () {
	    function ModalModule() {
	    }
	    ModalModule.decorators = [
	        { type: core_1.NgModule, args: [{
	                    declarations: [modal_backdrop_component_1.ModalBackdropComponent, modal_component_1.ModalDirective],
	                    exports: [modal_backdrop_component_1.ModalBackdropComponent, modal_component_1.ModalDirective],
	                    entryComponents: [modal_backdrop_component_1.ModalBackdropComponent],
	                    providers: [components_helper_service_1.ComponentsHelper]
	                },] },
	    ];
	    /** @nocollapse */
	    ModalModule.ctorParameters = [];
	    return ModalModule;
	}());
	exports.ModalModule = ModalModule;


/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var vtshistory_service_1 = __webpack_require__(546);
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var VTSHistoryListComponent = (function () {
	    function VTSHistoryListComponent(vtsHistoryService, translate, authService, activeRoute, router) {
	        this.vtsHistoryService = vtsHistoryService;
	        this.translate = translate;
	        this.authService = authService;
	        this.activeRoute = activeRoute;
	        this.router = router;
	    }
	    VTSHistoryListComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.module = this.translate.instant('LblEventHistory');
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = ["licenceTag", "requestType", "result", "commandInitiator"];
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlVtsTroubleShootPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_VTS_TROUBLESHOOT);
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	        this.sub = this.activeRoute
	            .params
	            .subscribe(function (params) {
	            _this.vehicleMasterHashId = params['vehicleMasterHashId'] || '';
	            if (_this.vehicleMasterHashId != '') {
	                _this.GetVTSHistoryList();
	            }
	        });
	    };
	    VTSHistoryListComponent.prototype.GetVTSHistoryList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.vtsHistoryService.GetVTSHistoryList(this.DataListModel, this.vehicleMasterHashId)
	            .subscribe(function (res) {
	            _this.vtsHistoryList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    VTSHistoryListComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetVTSHistoryList();
	    };
	    VTSHistoryListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetVTSHistoryList();
	    };
	    VTSHistoryListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetVTSHistoryList();
	    };
	    VTSHistoryListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetVTSHistoryList();
	    };
	    ;
	    VTSHistoryListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.vtsHistoryService.ExportVTSHistoryList(this.DataListModel, this.vehicleMasterHashId)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "VTSHistory" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    VTSHistoryListComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    VTSHistoryListComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    VTSHistoryListComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    VTSHistoryListComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], VTSHistoryListComponent.prototype, "successPopup", void 0);
	    VTSHistoryListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-VTSHistory',
	            template: __webpack_require__(547),
	            providers: [vtshistory_service_1.VTSHistoryService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof vtshistory_service_1.VTSHistoryService !== 'undefined' && vtshistory_service_1.VTSHistoryService) === 'function' && _a) || Object, (typeof (_b = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object, (typeof (_e = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _e) || Object])
	    ], VTSHistoryListComponent);
	    return VTSHistoryListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.VTSHistoryListComponent = VTSHistoryListComponent;


/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var VTSHistoryService = (function () {
	    function VTSHistoryService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    VTSHistoryService.prototype.GetVTSHistoryList = function (input, vehicleMasterHashId) {
	        var getVTSHistoryUrl = config_1.WeGoConfig.API_GET_VTS_HISTORY_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getVTSHistoryUrl = getVTSHistoryUrl + "?" + queryString + "&vehicleMasterHashId=" + vehicleMasterHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getVTSHistoryUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    VTSHistoryService.prototype.ExportVTSHistoryList = function (input, vehicleMasterHashId) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var getVTSHistoryUrl = config_1.WeGoConfig.API_EXPORT_VTS_HISTORY_LIST + "?" + queryString + "&vehicleMasterHashId=" + vehicleMasterHashId;
	        var headers = this.authService.GetHeader('text/csv');
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getVTSHistoryUrl, options);
	    };
	    VTSHistoryService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], VTSHistoryService);
	    return VTSHistoryService;
	    var _a, _b;
	}());
	exports.VTSHistoryService = VTSHistoryService;


/***/ },
/* 547 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n    <section class=\"content-header\">\r\n        <div class=\"col-md-9 col-sm-6\">\r\n            <h1 class=\"pagename\">{{ breadCrumbList}} </h1>\r\n            <ol class=\"breadcrumb\">\r\n                <li><a [routerLink]=\"urlDefaultPage\"><i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a></li>\r\n                <li><a [routerLink]=\"urlVtsTroubleShootPage\"><i class=\"fa fa-wrench\"></i> {{ 'LblTroubleShootVTS' | translate }}</a></li>\r\n                <li class=\"active\"> {{ breadCrumbList}} </li>\r\n\r\n            </ol>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n        <div class=\"clearfix\"></div>\r\n    </section>\r\n    <section class=\"content\">\r\n        <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n                <p class=\"text-success\">{{ message }}</p>\r\n                <wego-search-list (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n                <div class=\"table table-responsive mar_bot_ziro\">\r\n                    <table class=\"table table-bordered mar_bot_ziro\">\r\n                        <thead>\r\n                            <tr>\r\n                                <th class=\"cursor-pointer\" (click)=\"OnSort('licenceTag')\">\r\n                                    {{ 'LblLicenceTag' | translate }}\r\n                                    <wego-sort-list [FieldName]=\"'licenceTag'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                                </th>\r\n                                <th class=\"cursor-pointer\" (click)=\"OnSort('updatedWegoRequestUserTimezone')\">\r\n                                    {{ 'LblWegoRequestTime' | translate }}\r\n                                    <wego-sort-list [FieldName]=\"'updatedWegoRequestUserTimezone'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                                </th>\r\n                                <th class=\"cursor-pointer\" (click)=\"OnSort('updatedVTSResultTimeUser')\">\r\n                                    {{ 'LblVTSRequestTime' | translate }}\r\n                                    <wego-sort-list [FieldName]=\"'updatedVTSResultTimeUser'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                                </th>\r\n                                <th class=\"cursor-pointer\" (click)=\"OnSort('requestType')\">\r\n                                    {{ 'LblRequestType' | translate }}\r\n                                    <wego-sort-list [FieldName]=\"'requestType'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                                </th>\r\n                                <th class=\"cursor-pointer\" (click)=\"OnSort('updatedWegoProcessUserTimezone')\">\r\n                                    {{ 'LblWegoProcessTime' | translate }}\r\n                                    <wego-sort-list [FieldName]=\"'updatedWegoProcessUserTimezone'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                                </th>\r\n                                <th class=\"cursor-pointer\" (click)=\"OnSort('updatedVTSProcessTime')\">\r\n                                    {{ 'LblVTSProcessTime' | translate }}\r\n                                    <wego-sort-list [FieldName]=\"'updatedVTSProcessTime'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                                </th>\r\n                                <th class=\"cursor-pointer\" (click)=\"OnSort('result')\">\r\n                                    {{ 'LblResult' | translate }}\r\n                                    <wego-sort-list [FieldName]=\"'result'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                                </th>\r\n                                <th class=\"cursor-pointer\" (click)=\"OnSort('updatedWegoResultUserTime')\">\r\n                                    {{ 'LblWegoResultTime' | translate }}\r\n                                    <wego-sort-list [FieldName]=\"'updatedWegoResultUserTime'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                                </th>\r\n                                <th class=\"cursor-pointer\" (click)=\"OnSort('updatedVTSResultTimeUser')\">\r\n                                    {{ 'LblVTSResultTime' | translate }}\r\n                                    <wego-sort-list [FieldName]=\"'updatedVTSResultTimeUser'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                                </th>\r\n                                <th class=\"cursor-pointer\" (click)=\"OnSort('commandInitiator')\">\r\n                                    {{ 'LblCommandInitiator' | translate }}\r\n                                    <wego-sort-list [FieldName]=\"'commandInitiator'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                                </th>\r\n                            </tr>\r\n                        </thead>\r\n                        <tbody>\r\n                            <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                                <tr *ngFor=\"let vtsHistory of vtsHistoryList\">\r\n                                  <td>{{vtsHistory.licenceTag}}</td>\r\n                                  <td>{{vtsHistory.updatedWegoRequestUserTimezone}}</td>\r\n                                  <td>{{vtsHistory.updatedVTSResultTimeUser}}</td>\r\n                                  <td>{{vtsHistory.requestType}}</td>                                  \r\n                                  <td>{{vtsHistory.updatedWegoProcessUserTimezone}}</td>\r\n                                  <td>{{vtsHistory.updatedVTSProcessTime}}</td>\r\n                                  <td>{{vtsHistory.result}}</td>\r\n                                  <td>{{vtsHistory.updatedWegoResultUserTime}}</td>\r\n                                  <td>{{vtsHistory.updatedVTSResultTimeUser}}</td>\r\n                                  <td>{{vtsHistory.commandInitiator}}</td>\r\n                                </tr>\r\n                            </template>\r\n                            <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                                <td class=\"text-center text-danger\" colspan=\"10\">\r\n                                    {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                                </td>\r\n                            </tr>\r\n                        </tbody>\r\n                    </table>\r\n                </div>\r\n                <div class=\"clearfix\"></div>\r\n                <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n                    <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n                        <div class=\"col-md-12\">\r\n                            <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\" [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\"\r\n                                firstText=\"&laquo;\" lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </section>\r\n</div>\r\n<div [hidden]=\"!isLoading\" class=\"my-loading\">\r\n    <div class=\"dimmer\"></div>\r\n    <div class=\"loading-bg\">\r\n        <i class=\"fa fa-refresh fa-spin fa-3x fa-fw\"></i>\r\n    </div>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>";

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var flatpickr_model_1 = __webpack_require__(83);
	var event_viewer_model_1 = __webpack_require__(549);
	var event_viewer_service_1 = __webpack_require__(550);
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var EventViewerComponent = (function () {
	    function EventViewerComponent(eventViewerService, authService, activeRoute, translate) {
	        this.eventViewerService = eventViewerService;
	        this.authService = authService;
	        this.activeRoute = activeRoute;
	        this.translate = translate;
	    }
	    EventViewerComponent.prototype.ngOnInit = function () {
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.searchModel = new event_viewer_model_1.EventViewerSearchModel();
	        this.itemPerPageList = config_1.WeGoConfig.GRID_PAGGING;
	        this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigTo.defaultDate = "23:59";
	        this.LoadSearchCategory();
	        this.HandleParameter();
	    };
	    EventViewerComponent.prototype.HandleParameter = function () {
	        var _this = this;
	        this.sub = this.activeRoute
	            .params
	            .subscribe(function (params) {
	            var filter = params['filter'] || '';
	            var searchField = params['searchTerm'] || '';
	            if (filter && searchField) {
	                _this.searchModel.filter = decodeURIComponent(filter);
	                _this.searchModel.searchField = decodeURIComponent(searchField);
	                _this.GetAuditLogTrailList();
	            }
	        });
	    };
	    EventViewerComponent.prototype.LoadSearchCategory = function () {
	        this.searchCategoryList = [
	            {
	                Key: this.translate.instant('LblSelectFilter'),
	                Value: '',
	            },
	            {
	                Key: this.translate.instant('LblVehicle'),
	                Value: 'VEHICLE',
	            },
	            {
	                Key: this.translate.instant('LblOBU'),
	                Value: 'OBU',
	            },
	            {
	                Key: this.translate.instant('LblBooking'),
	                Value: 'BOOKING',
	            },
	            {
	                Key: this.translate.instant('LblPerson'),
	                Value: 'PERSON',
	            },
	            {
	                Key: this.translate.instant('LblAuditEntries'),
	                Value: 'AUDIT',
	            },
	            {
	                Key: this.translate.instant('LblSharedVehicleGroup'),
	                Value: 'SVG',
	            },
	            {
	                Key: this.translate.instant('LblCompany'),
	                Value: 'COMPANY',
	            },
	            {
	                Key: this.translate.instant('LblSubscription'),
	                Value: 'SUBSCRIPTION',
	            }
	        ];
	    };
	    EventViewerComponent.prototype.GetAuditLogTrailList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.eventViewerService.GetAuditLogTrailList(this.searchModel)
	            .subscribe(function (res) {
	            _this.eventList = res.data;
	            _this.searchModel.totalItems = res.totalRecords;
	            _this.errorModel = typeof res.error != "string" ? res.error : null;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    EventViewerComponent.prototype.SearchCategoryOnChange = function () {
	        console.log(this.searchModel.filter);
	        var filter = this.searchModel.filter;
	        if (filter == "VEHICLE" || filter == "OBU") {
	            this.searchLabel = this.translate.instant('LblLicenceTag');
	        }
	        else if (filter == "BOOKING") {
	            this.searchLabel = this.translate.instant('LblBookingReferenceId');
	        }
	        else if (filter == "PERSON" || filter == "AUDIT") {
	            this.searchLabel = this.translate.instant('LblUserName');
	        }
	        else if (filter == "SVG") {
	            this.searchLabel = this.translate.instant('LblSharedVehicleGroup') + " / " + this.translate.instant('LblInstance');
	        }
	        else if (filter == "COMPANY") {
	            this.searchLabel = this.translate.instant('LblCompany') + " / " + this.translate.instant('LblInstance');
	        }
	        else if (filter == "SUBSCRIPTION") {
	            this.searchLabel = this.translate.instant('LblSubscription');
	        }
	        else {
	            this.searchLabel = ' ';
	        }
	    };
	    EventViewerComponent.prototype.OnSearch = function () {
	        this.searchModel.pageNo = 1;
	        this.GetAuditLogTrailList();
	    };
	    EventViewerComponent.prototype.OnPageChanged = function (event) {
	        this.searchModel.pageNo = event.page;
	        this.GetAuditLogTrailList();
	    };
	    EventViewerComponent.prototype.OnPagingChange = function (itemPerPage) {
	        this.searchModel.pageNo = 1;
	        this.searchModel.totalItems = 0;
	        this.searchModel.record = itemPerPage;
	        this.GetAuditLogTrailList();
	    };
	    EventViewerComponent.prototype.OnSort = function (sortName) {
	        this.searchModel.sortType = sortName;
	        this.searchModel.sortReverse = !this.searchModel.sortReverse;
	        this.GetAuditLogTrailList();
	    };
	    EventViewerComponent.prototype.ViewJsonPopup = function (eventData) {
	        this.jsonEventData = JSON.parse(eventData);
	        this.jsonDataPopup.show();
	    };
	    EventViewerComponent.prototype.SetDefaultFlatPickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = true;
	        flatPickrConfig.time_24hr = true;
	        flatPickrConfig.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
	        flatPickrConfig.minuteIncrement = 1;
	        return flatPickrConfig;
	    };
	    EventViewerComponent.prototype.ngOnDestroy = function () {
	        if (this.sub) {
	            this.sub.unsubscribe();
	        }
	    };
	    __decorate([
	        core_1.ViewChild('jsonDataPopup'), 
	        __metadata('design:type', Object)
	    ], EventViewerComponent.prototype, "jsonDataPopup", void 0);
	    EventViewerComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-event-viewer',
	            template: __webpack_require__(551),
	            providers: [event_viewer_service_1.EventViewerService],
	            styles: [
	                "\n      .truncate-event-data{\n        max-width: 0;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n\n      .search-icon {\n        color:#2ba2aa;\n      }\n\n      .form-control{\n        padding: 5px;\n      }\n    "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof event_viewer_service_1.EventViewerService !== 'undefined' && event_viewer_service_1.EventViewerService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object])
	    ], EventViewerComponent);
	    return EventViewerComponent;
	    var _a, _b, _c, _d;
	}());
	exports.EventViewerComponent = EventViewerComponent;


/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var config_1 = __webpack_require__(60);
	var EventViewerModel = (function () {
	    function EventViewerModel() {
	    }
	    return EventViewerModel;
	}());
	exports.EventViewerModel = EventViewerModel;
	var EventViewerSearchModel = (function () {
	    function EventViewerSearchModel() {
	        this.filter = '';
	        this.totalItems = 0;
	        this.pageNo = 1;
	        this.maxSize = config_1.WeGoConfig.GRID_MAX_PAGE_SIZE;
	        this.record = config_1.WeGoConfig.GRID_MAX_DATA_SIZE;
	        this.sortType = "";
	        this.sortReverse = false;
	    }
	    return EventViewerSearchModel;
	}());
	exports.EventViewerSearchModel = EventViewerSearchModel;


/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var jquery_helper_service_1 = __webpack_require__(67);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var EventViewerService = (function () {
	    function EventViewerService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	        this.JQueryHelper = new jquery_helper_service_1.JQueryHelperService();
	    }
	    EventViewerService.prototype.GetAuditLogTrailList = function (searchModel) {
	        var getAuditLogTrailListUrl = config_1.WeGoConfig.API_GET_AUDIT_LOG_TRAIL_LIST;
	        var queryString = this.JQueryHelper.Param(searchModel);
	        if (queryString) {
	            getAuditLogTrailListUrl = getAuditLogTrailListUrl + "?" + queryString;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getAuditLogTrailListUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    EventViewerService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], EventViewerService);
	    return EventViewerService;
	    var _a, _b;
	}());
	exports.EventViewerService = EventViewerService;


/***/ },
/* 551 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ 'LblEventViewer' | translate }}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li><a [routerLink]=\"urlDefaultPage\"><i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a></li>\r\n        <li class=\"active\">{{ 'LblEventViewer' | translate }}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25 \">\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <div class=\"row\">\r\n          <form (ngSubmit)=\"OnSearch()\" class=\"mar_bot_10\">\r\n            <div class=\"form-group col-sm-2\">\r\n              <label><span class=\"text text-danger\">*</span>{{ 'LblFilter' | translate }}</label>\r\n              <select [(ngModel)]=\"searchModel.filter\" class=\"form-control\" name=\"searchCategory\" (change)=\"SearchCategoryOnChange()\">\r\n                <option *ngFor=\"let item of searchCategoryList\" [ngValue]=\"item.Value\">{{ item.Key }}</option>\r\n              </select>\r\n              <div class=\"clearfix\"></div>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'Filter' }}</span>\r\n            </div>\r\n            <div class=\"form-group col-sm-2\">\r\n              <label>{{ 'LblFrom' | translate }}</label>\r\n              <div class=\"clearfix\"></div>\r\n              <div class=\"input-group\">\r\n                <span class=\"input-group-addon\"><i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i></span>\r\n                <input class=\"form-control\" [Config]=\"flatPickrConfigFrom\" placeholder=\"{{ 'LblFrom' | translate }}\" name=\"FromDateTime\" [(ngModel)]=\"searchModel.fromDate\" flatpickr readonly>\r\n              </div>\r\n              <div class=\"clearfix\"></div>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'FromDate' }}</span>\r\n            </div>\r\n            <div class=\"form-group col-sm-2\">\r\n              <label>{{ 'LblTo' | translate }}</label>\r\n              <div class=\"clearfix\"></div>\r\n              <div class=\"input-group\">\r\n                <span class=\"input-group-addon\"><i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i></span>\r\n                <input class=\"form-control\" [Config]=\"flatPickrConfigTo\" placeholder=\"{{ 'LblTo' | translate }}\" name=\"ToDateTime\" [(ngModel)]=\"searchModel.toDate\" flatpickr readonly>\r\n              </div>\r\n              <div class=\"clearfix\"></div>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'ToDate' }}</span>\r\n            </div>\r\n            <div class=\"form-group col-sm-4\">\r\n              <label>{{ searchLabel }} &nbsp;</label>\r\n              <div class=\"clearfix\"></div>\r\n              <input class=\"form-control\" name=\"SearchField\" [(ngModel)]=\"searchModel.searchField\">\r\n            </div>\r\n            <div class=\"form-group col-sm-1\">\r\n              <label>&nbsp;</label>\r\n              <div class=\"clearfix\"></div>\r\n              <button class=\"btn btn-default search-icon\" type=\"submit\">\r\n                <i class=\"fa fa-search\" aria-hidden=\"true\"></i>\r\n              </button>\r\n            </div>\r\n            <div *ngIf=\"eventList\" class=\"form-group col-sm-1 pull-right\">\r\n              <label>&nbsp;</label>\r\n              <select class=\"form-control\" title='Items Per Page' [(ngModel)]=\"searchModel.record\" name=\"itemPerPage\" (change)=\"OnPagingChange($event.target.value)\">\r\n                <option *ngFor=\"let item of itemPerPageList\"  [attr.value]='item.value' >{{ item }}</option>\r\n              </select>\r\n            </div>\r\n          </form>\r\n        </div>\r\n        <p class=\"text-success\">{{ message }}</p>\r\n        <div *ngIf=\"eventList\" class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('category')\">\r\n                  {{ 'LblCategory' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'category'\" [SortType]=\"searchModel.sortType\" [SortReverse]=\"searchModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('eventName')\">\r\n                  {{'LblEventName' | translate}}\r\n                  <wego-sort-list [FieldName]=\"'eventName'\" [SortType]=\"searchModel.sortType\" [SortReverse]=\"searchModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" style=\"width: 12%;\" (click)=\"OnSort('momentUTC')\">\r\n                  {{'LblMoment' | translate}}\r\n                  <wego-sort-list [FieldName]=\"'momentUTC'\" [SortType]=\"searchModel.sortType\" [SortReverse]=\"searchModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th style=\"width: 48%;\">\r\n                  {{'LblEventData' | translate }}\r\n                </th>\r\n                <th style=\"width: 10%;\">{{ 'LblUser' | translate }}</th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <tr *ngFor=\"let event of eventList\">\r\n                <td>{{ event.category }}</td>\r\n                <td>{{ event.eventName }}</td>\r\n                <td>{{ event.moment }}</td>\r\n                <td class=\"truncate-event-data\">\r\n                  <span title=\"View Event Data\">\r\n                    <a class=\"cursor-pointer\" (click)=\"ViewJsonPopup(event.eventData)\">\r\n                        <i class=\"fa fa-search fa-fw\"></i>\r\n                    </a>\r\n                  </span> {{ event.eventData }}\r\n                </td>\r\n                <td>{{ event.user }}</td>\r\n              </tr>\r\n              <tr *ngIf=\"eventList.length == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"5\">\r\n                  {{ 'LblNoEventDataFound' | translate}}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div *ngIf=\"eventList\" class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"searchModel.totalItems\" [itemsPerPage]=\"searchModel.record\" [(ngModel)]=\"searchModel.pageNo\" [maxSize]=\"searchModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<div bsModal #jsonDataPopup=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n\r\n        <h4 class=\"modal-title\">\r\n          Event Data\r\n          <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"jsonDataPopup.hide()\">\r\n            <span aria-hidden=\"true\">&times;</span>\r\n          </button>\r\n        </h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <pre>{{jsonEventData | json}}</pre>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var vehicle_model_1 = __webpack_require__(553);
	var vehicle_service_1 = __webpack_require__(530);
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var VehicleFutureBookingListComponent = (function () {
	    function VehicleFutureBookingListComponent(vehicleService, translate, authService, activeRoute, router) {
	        this.vehicleService = vehicleService;
	        this.translate = translate;
	        this.authService = authService;
	        this.activeRoute = activeRoute;
	        this.router = router;
	    }
	    VehicleFutureBookingListComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = ["bookingReferenceID", "driver", "translatedBookingStatus"];
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlVehicleList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_VEHICLE_LIST);
	        this.urlBooking = this.authService.GetURL(config_1.ApplicationRouteURL.URL_BOOKING);
	        this.model = new vehicle_model_1.VehicleModel();
	        this.breadCrumbList = this.translate.instant('LblVehFutureBookingList');
	        this.sub = this.activeRoute
	            .params
	            .subscribe(function (params) {
	            _this.vehicleMasterHashId = params['vehicleHashId'] || '';
	            if (_this.vehicleMasterHashId != '') {
	                _this.GetFutureBookingList();
	            }
	        });
	    };
	    VehicleFutureBookingListComponent.prototype.GetFutureBookingList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.vehicleService.GetVehicleFutureBookingList(this.vehicleMasterHashId, this.DataListModel)
	            .subscribe(function (res) {
	            _this.futureBookingList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    VehicleFutureBookingListComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetFutureBookingList();
	    };
	    VehicleFutureBookingListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetFutureBookingList();
	    };
	    VehicleFutureBookingListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetFutureBookingList();
	    };
	    VehicleFutureBookingListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetFutureBookingList();
	    };
	    ;
	    VehicleFutureBookingListComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    VehicleFutureBookingListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-vehiclefuturebooking-list',
	            template: __webpack_require__(554),
	            providers: [vehicle_service_1.VehicleService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof vehicle_service_1.VehicleService !== 'undefined' && vehicle_service_1.VehicleService) === 'function' && _a) || Object, (typeof (_b = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object, (typeof (_e = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _e) || Object])
	    ], VehicleFutureBookingListComponent);
	    return VehicleFutureBookingListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.VehicleFutureBookingListComponent = VehicleFutureBookingListComponent;


/***/ },
/* 553 */
/***/ function(module, exports) {

	"use strict";
	var VehicleModel = (function () {
	    //WEGO2DEV-325(Settings for Dashboard statuses)
	    // public locationVehicleTime : number;
	    // public locationTimeInterval : string = "";
	    // public bookedBeforeTime : number;
	    // public bookedBeforeInterval : string = "";
	    function VehicleModel() {
	        this.ownerCompanyHashID = "";
	        this.locationDataExchangeHashId = "";
	        this.available = true;
	        this.transmissionType = "";
	        this.attributeList = [];
	        this.isFuelRequire = false;
	        this.isCleaningRequire = false;
	        this.isGefenceEnabled = false;
	        this.showVehicleChargeLevel = "INHERIT";
	        this.instanceLanguage = 'en';
	        this.invalidTagUsed = false;
	        this.tagAccessDisabled = false;
	        this.geofenceAttributeModel = new GeofenceAttributeModel();
	        this.homeLocationModel = new HomeLocationModel();
	        this.inUseBookingDetail = new InUseBookingDetail();
	        this.customTripQuestionList = new Array();
	    }
	    return VehicleModel;
	}());
	exports.VehicleModel = VehicleModel;
	var InUseBookingDetail = (function () {
	    function InUseBookingDetail() {
	    }
	    return InUseBookingDetail;
	}());
	exports.InUseBookingDetail = InUseBookingDetail;
	var VehicleBlockModel = (function () {
	    function VehicleBlockModel() {
	    }
	    return VehicleBlockModel;
	}());
	exports.VehicleBlockModel = VehicleBlockModel;
	var SVGVehicleModel = (function () {
	    function SVGVehicleModel() {
	        this.listOfVehicleHashId = [];
	    }
	    return SVGVehicleModel;
	}());
	exports.SVGVehicleModel = SVGVehicleModel;
	var VTSVehicleModel = (function () {
	    function VTSVehicleModel() {
	        this.fleetId = "52275965BBRACCGEO";
	        this.contractId = "52275965";
	    }
	    return VTSVehicleModel;
	}());
	exports.VTSVehicleModel = VTSVehicleModel;
	var GeofenceAttributeModel = (function () {
	    function GeofenceAttributeModel() {
	    }
	    return GeofenceAttributeModel;
	}());
	exports.GeofenceAttributeModel = GeofenceAttributeModel;
	var HomeLocationModel = (function () {
	    function HomeLocationModel() {
	    }
	    return HomeLocationModel;
	}());
	exports.HomeLocationModel = HomeLocationModel;
	var VehicleMappingModel = (function () {
	    function VehicleMappingModel() {
	        this.listOfvehicleHashId = [];
	    }
	    return VehicleMappingModel;
	}());
	exports.VehicleMappingModel = VehicleMappingModel;


/***/ },
/* 554 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ breadCrumbList}} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li><a [routerLink]=\"urlDefaultPage\"><i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a></li>\r\n        <li><a [routerLink]=\"urlVehicleList\"><i class=\"fa fa-cab fa-fw\"></i> {{ 'LblVehicle' | translate }} {{ 'LblList' | translate }}</a></li>\r\n        <li class=\"active\"> {{ breadCrumbList}} </li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <wego-search-list (OnSearch)=\"OnSearch($event)\" [IsExported]=\"false\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\"\r\n          [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <p class=\"text-success\">{{ message }}</p>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('bookingReferenceID')\">{{ 'LblBookingReferenceId' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'bookingReferenceID'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('startDateTime')\">{{ 'LblBookingStartDateTime' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'startDateTime'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('endDateTimeUTC')\"> {{ 'LblBookingEndDateTime' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'endDateTimeUTC'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('translatedBookingStatus')\">\r\n                  {{ 'LblStatus' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'translatedBookingStatus'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('driverName')\"> {{ 'LblDriverName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'driverName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n              </tr>\r\n              <tbody>\r\n                <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                  <tr *ngFor=\"let booking of futureBookingList\">\r\n                    <td>\r\n                      <template [ngIf]=\"booking.isAuthorisedBooking\">\r\n                        <a *ngIf=\"booking.isBookingEditable\" [routerLink]=\"[urlBooking, { ref: booking.bookingHashId, isRecurring: false }]\">{{ booking.bookingReferenceID }} </a>\r\n                        <span *ngIf=\"!booking.isBookingEditable\"> {{ booking.bookingReferenceID }} </span>\r\n                      </template>\r\n                      <template [ngIf]=\"!booking.isAuthorisedBooking\">\r\n                        <span>{{'LblReserved' | translate}}</span>\r\n                      </template>\r\n                    </td>\r\n                    <td>{{ booking.startDateTime }}</td>\r\n                    <td>{{ booking.endDateTime }}</td>\r\n                    <td>{{ booking.translatedBookingStatus }}</td>\r\n                    <td>{{ booking.driver }}</td>\r\n                  </tr>\r\n                </template>\r\n                <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                  <td class=\"text-center text-danger\" colspan=\"5\">\r\n                    {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                  </td>\r\n                </tr>\r\n              </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>";

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var booking_service_1 = __webpack_require__(556);
	var flatpickr_directive_1 = __webpack_require__(82);
	var flatpickr_model_1 = __webpack_require__(83);
	var tripdetailreport_service_1 = __webpack_require__(557);
	var tripdetailreport_model_1 = __webpack_require__(558);
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var moment = __webpack_require__(84);
	var TripDetailReportComponent = (function () {
	    function TripDetailReportComponent(tripdetailreportservice, translate, authService, router) {
	        this.tripdetailreportservice = tripdetailreportservice;
	        this.translate = translate;
	        this.authService = authService;
	        this.router = router;
	        this.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
	        this.isInit = true;
	    }
	    TripDetailReportComponent.prototype.ngOnInit = function () {
	        this.itemPerPageList = config_1.WeGoConfig.GRID_PAGGING;
	        this.module = this.translate.instant('LblTripDetailReport');
	        this.ResetPaging();
	        this.model = new tripdetailreport_model_1.TripDetailReportModel();
	        //this.model.startDateTime = moment().format('DD-MM-YYYY HH:mm');
	        //this.model.endDateTime = moment().add(+1, 'M').format('DD-MM-YYYY HH:mm');
	        this.model.startDateTime = moment().add(-2, 'M').format('DD-MM-YYYY HH:mm');
	        this.model.endDateTime = moment().format('DD-MM-YYYY HH:mm');
	        this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigTo.defaultDate = "23:59";
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	    };
	    TripDetailReportComponent.prototype.SetDefaultFlatPickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = true;
	        flatPickrConfig.time_24hr = true;
	        flatPickrConfig.dateFormat = this.dateFormat;
	        flatPickrConfig.minuteIncrement = 1;
	        return flatPickrConfig;
	    };
	    TripDetailReportComponent.prototype.OnFromDateChange = function (value) {
	        console.log(value);
	        this.ResetPaging();
	        console.log(this.model.endDateTime);
	        if (value) {
	            var format = 'DD-MM-YYYY HH:mm';
	            var newDate = moment(value, format).toDate();
	            var endDate = moment(this.model.endDateTime, format).toDate();
	            if (endDate < newDate) {
	                var endDateVal = moment(value, format).add('H', 1);
	                this.flatPickrConfigToDate.ChangeValue(endDateVal.format('DD-MM-YYYY HH:mm'));
	            }
	            this.flatPickrConfigToDate.SetOption("minDate", newDate);
	        }
	    };
	    TripDetailReportComponent.prototype.OnToDateChange = function ($event) {
	        this.ResetPaging();
	    };
	    TripDetailReportComponent.prototype.OnVehicleChange = function ($event) {
	        this.ResetPaging();
	    };
	    TripDetailReportComponent.prototype.SuccessSelectDriverModal = function ($event) {
	        this.model.driverHashId = $event.DriverHashID;
	        this.model.filterDriverName = $event.DriverName;
	        this.model.vehicleHashId = '';
	        this.GetDriverVehicleList(this.model.driverHashId);
	        this.ResetPaging();
	    };
	    TripDetailReportComponent.prototype.OnSearchTrips = function () {
	        console.log(this.model);
	        this.ResetPaging();
	        this.GetDriverTripDetail();
	    };
	    TripDetailReportComponent.prototype.GetDriverTripDetail = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.tripdetailreportservice.GetDriverTripDetailList(this.model)
	            .subscribe(function (res) {
	            if (!res.data) {
	                _this.errorModel = res.error;
	                _this.isLoading = false;
	            }
	            else {
	                _this.errorModel = null;
	                _this.tripDetailList = res.data;
	                _this.DataListModel.totalItems = res.data.length;
	                _this.DataListModel.infoMessage = res.error;
	                _this.FilterList();
	                _this.isLoading = false;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.tripDetailList = [];
	        });
	    };
	    TripDetailReportComponent.prototype.GetDriverVehicleList = function (driverHashId) {
	        var _this = this;
	        this.isLoading = true;
	        this.tripdetailreportservice.GetDriverVehicleList(driverHashId)
	            .subscribe(function (res) {
	            if (!res.data) {
	                _this.errorModel = res.error;
	                _this.isLoading = false;
	            }
	            else {
	                _this.errorModel = null;
	                _this.driverVehicleList = res.data;
	                _this.isLoading = false;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    TripDetailReportComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.itemsPerPage = event;
	        this.FilterList();
	    };
	    TripDetailReportComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.FilterList();
	    };
	    TripDetailReportComponent.prototype.FilterList = function () {
	        var start = this.DataListModel.itemsPerPage * (this.DataListModel.currentPage - 1);
	        var end = start + (this.DataListModel.itemsPerPage);
	        this.listOfFilterRecord = this.tripDetailList.slice(start, end);
	    };
	    TripDetailReportComponent.prototype.ResetPaging = function () {
	        this.tripDetailList = [];
	        this.listOfFilterRecord = [];
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.itemsPerPage = 10;
	    };
	    TripDetailReportComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.tripdetailreportservice.ExportTripDetailReport(this.model)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "TripDetailReport" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    TripDetailReportComponent.prototype.OnExportPdf = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.tripdetailreportservice.ExportTripDetailReportPDF(this.model)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "TripDetailReport" + new Date().toISOString() + ".pdf";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    __decorate([
	        core_1.ViewChild('flatPickrConfigFromDate'), 
	        __metadata('design:type', (typeof (_a = typeof flatpickr_directive_1.FlatPickrDirective !== 'undefined' && flatpickr_directive_1.FlatPickrDirective) === 'function' && _a) || Object)
	    ], TripDetailReportComponent.prototype, "flatPickrConfigFromDate", void 0);
	    __decorate([
	        core_1.ViewChild('flatPickrConfigToDate'), 
	        __metadata('design:type', (typeof (_b = typeof flatpickr_directive_1.FlatPickrDirective !== 'undefined' && flatpickr_directive_1.FlatPickrDirective) === 'function' && _b) || Object)
	    ], TripDetailReportComponent.prototype, "flatPickrConfigToDate", void 0);
	    TripDetailReportComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-tripdetail-report',
	            template: __webpack_require__(559),
	            providers: [tripdetailreport_service_1.TripDetilReportService, booking_service_1.BookingService],
	            styles: ["\n          .box-body{\n            padding: 0px 10px 10px;\n          }\n          .checkbox-inline{\n            padding-left: 0px !important;\n          }\n          .box-body{\n            padding:10px 10px 10px 10px;\n          }\n          .search\n          {\n            margin-top:5px;\n          }\n          "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_c = typeof tripdetailreport_service_1.TripDetilReportService !== 'undefined' && tripdetailreport_service_1.TripDetilReportService) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object, (typeof (_e = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _f) || Object])
	    ], TripDetailReportComponent);
	    return TripDetailReportComponent;
	    var _a, _b, _c, _d, _e, _f;
	}());
	exports.TripDetailReportComponent = TripDetailReportComponent;


/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var jquery_helper_service_1 = __webpack_require__(67);
	var BookingService = (function () {
	    function BookingService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	        this.JQueryHelper = new jquery_helper_service_1.JQueryHelperService();
	    }
	    BookingService.prototype.GetScheduledBookingList = function (input) {
	        var getSchedulerBookinUrl = config_1.WeGoConfig.API_GET_SCHEDULED_BOOKING_LIST;
	        var queryString = this.JQueryHelper.Param(input);
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        getSchedulerBookinUrl =
	            getSchedulerBookinUrl + '?' + decodeURIComponent(queryString);
	        return this.http
	            .get(getSchedulerBookinUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.GetBookingList = function (schedulerBookingModel, input) {
	        var getSchedulerBookinUrl = config_1.WeGoConfig.API_GET_BOOKING_LIST;
	        var queryStringDataListModel = this.authService.HandleAPIListInput(input);
	        var queryStringSchedulerBookingModel = this.JQueryHelper.Param(schedulerBookingModel);
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        getSchedulerBookinUrl =
	            getSchedulerBookinUrl +
	                '?' +
	                queryStringDataListModel +
	                '&' +
	                decodeURIComponent(queryStringSchedulerBookingModel);
	        return this.http
	            .get(getSchedulerBookinUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.GetVehicleOverview = function (input) {
	        var getVehicleOverviewUrl = config_1.WeGoConfig.API_GET_VEHICLE_OVERVIEW;
	        var queryString = this.JQueryHelper.Param(input);
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        getVehicleOverviewUrl =
	            getVehicleOverviewUrl + '?' + decodeURIComponent(queryString);
	        return this.http
	            .get(getVehicleOverviewUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.EditBookingDetail = function (ref, isRecurring) {
	        var getEditBookingDetailUrl = config_1.WeGoConfig.API_GET_EDIT_BOOKING;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        getEditBookingDetailUrl =
	            getEditBookingDetailUrl +
	                '?referanceID=' +
	                ref +
	                '&isReccuring=' +
	                isRecurring;
	        return this.http
	            .get(getEditBookingDetailUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.MakeProvisionalBooking = function (searchBookingModel) {
	        var body = searchBookingModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_MAKE_PROVISIONAL_BOOKING, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.ConfirmProvisionalBooking = function (searchBookingModel) {
	        var body = searchBookingModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_CONFIRM_PROVISIONAL_BOOKING, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.ConfirmRecurringPaymentBooking = function (bookingMasterHashId, recurringBookingId, editBookingReferenceId) {
	        if (editBookingReferenceId === void 0) { editBookingReferenceId = ""; }
	        var getUrl = config_1.WeGoConfig.API_POST_RECURRING_PAYMENT_BOOKING;
	        getUrl = getUrl + '?bookingHashId=' + bookingMasterHashId;
	        if (recurringBookingId) {
	            getUrl = getUrl + '&recurringBookingId=' + recurringBookingId;
	        }
	        if (editBookingReferenceId) {
	            getUrl = getUrl + '&editBookingReferenceId=' + editBookingReferenceId;
	        }
	        var options = { headers: this.authService.GetHeader() };
	        return this.http
	            .get(getUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.StartInitialPayment = function (searchBookingModel) {
	        var body = searchBookingModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_CREATE_INITIAL_PAYMENT, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.StartInitialPaymentForStartBooking = function (bookingHashId) {
	        var getUrl = config_1.WeGoConfig.API_START_INITIAL_PAYMENT;
	        getUrl =
	            getUrl +
	                '?provisionalBookingHashId=' +
	                bookingHashId +
	                '&isFromMobileSide=' +
	                false;
	        var options = { headers: this.authService.GetHeader() };
	        return this.http
	            .get(getUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.CancelProvisionalBooking = function (referanceID, isRecurring) {
	        var getCancelProvisionalBooking = config_1.WeGoConfig.API_GET_CANCEL_PROVISIONAL_BOOKING;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        getCancelProvisionalBooking =
	            getCancelProvisionalBooking +
	                '?referanceID=' +
	                referanceID +
	                '&isReccuring=' +
	                isRecurring;
	        return this.http
	            .get(getCancelProvisionalBooking, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.GetBookingOverview = function (referanceID, isRecurring) {
	        var getBookingOverviewUrl = config_1.WeGoConfig.API_GET_BOOKING_OVERVIEW;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        getBookingOverviewUrl =
	            getBookingOverviewUrl +
	                '?referanceID=' +
	                referanceID +
	                '&isReccuring=' +
	                isRecurring;
	        return this.http
	            .get(getBookingOverviewUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.GetBookingDetails = function (referanceID, isRecurring) {
	        var getBookingDetailsUrl = config_1.WeGoConfig.API_GET_BOOKING_Details;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        getBookingDetailsUrl =
	            getBookingDetailsUrl +
	                '?referanceID=' +
	                referanceID +
	                '&isReccuring=' +
	                isRecurring;
	        return this.http
	            .get(getBookingDetailsUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.GetAffectedBookingList = function (specialBookingModel, input) {
	        var getAffectedBookinUrl = config_1.WeGoConfig.API_GET_AFFECTED_BOOKING_LIST;
	        var queryStringDataListModel = this.authService.HandleAPIListInput(input);
	        var queryStringSchedulerBookingModel = this.JQueryHelper.Param(specialBookingModel);
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        getAffectedBookinUrl =
	            getAffectedBookinUrl +
	                '?' +
	                queryStringDataListModel +
	                '&' +
	                decodeURIComponent(queryStringSchedulerBookingModel);
	        return this.http
	            .get(getAffectedBookinUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.GetVehicleList = function (input, ownerCompanyHashID, sharedVehicleGroupHashId) {
	        var getVehicleUrl = config_1.WeGoConfig.API_GET_VEHICLE_LIST_SPECIAL_BOOKING;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getVehicleUrl = getVehicleUrl + '?' + queryString;
	            if (ownerCompanyHashID)
	                getVehicleUrl =
	                    getVehicleUrl + '&ownerCompanyHashID=' + ownerCompanyHashID;
	            if (sharedVehicleGroupHashId)
	                getVehicleUrl =
	                    getVehicleUrl +
	                        '&sharedVehicleGroupHashId=' +
	                        sharedVehicleGroupHashId;
	        }
	        else {
	            if (ownerCompanyHashID)
	                getVehicleUrl =
	                    getVehicleUrl + '?ownerCompanyHashID=' + ownerCompanyHashID;
	            if (sharedVehicleGroupHashId)
	                getVehicleUrl =
	                    getVehicleUrl +
	                        '&sharedVehicleGroupHashId=' +
	                        sharedVehicleGroupHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getVehicleUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.MakeSpecialBooking = function (specialBookingModel) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_MAKE_SPECIAL_BOOKING, specialBookingModel, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.ExportBokingList = function (bookingOverviewList, input) {
	        var getUrl = config_1.WeGoConfig.API_EXPORT_BOOKING_LIST;
	        input.currentPage = 0;
	        var queryStringDataListModel = this.authService.HandleAPIListInput(input);
	        var queryStringBookingOverviewModel = this.JQueryHelper.Param(bookingOverviewList);
	        var headers = this.authService.GetHeader('text/csv');
	        var options = new http_1.RequestOptions({ headers: headers });
	        getUrl =
	            getUrl +
	                '?' +
	                queryStringDataListModel +
	                '&' +
	                decodeURIComponent(queryStringBookingOverviewModel);
	        return this.http.get(getUrl, options);
	    };
	    BookingService.prototype.ExportBokingRequestList = function (bookingOverviewList, input) {
	        var getUrl = config_1.WeGoConfig.API_EXPORT_BOOKING_REQUEST_LIST;
	        input.currentPage = 0;
	        var queryStringDataListModel = this.authService.HandleAPIListInput(input);
	        var queryStringBookingOverviewModel = this.JQueryHelper.Param(bookingOverviewList);
	        var headers = this.authService.GetHeader('text/csv');
	        var options = new http_1.RequestOptions({ headers: headers });
	        getUrl =
	            getUrl +
	                '?' +
	                queryStringDataListModel +
	                '&' +
	                decodeURIComponent(queryStringBookingOverviewModel);
	        return this.http.get(getUrl, options);
	    };
	    BookingService.prototype.ExportBokingHistoryList = function (input) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var getUrl = config_1.WeGoConfig.API_EXPORT_BOOKING_HISTORY_LIST + '?' + queryString;
	        var headers = this.authService.GetHeader('text/csv');
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getUrl, options);
	    };
	    BookingService.prototype.CancelBookings = function (bookingOverviewList) {
	        var body = bookingOverviewList;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_CANCEL_BOOKINGS_LIST, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.GetBookingOverviewList = function (bookingOverviewList, input) {
	        var getBookingOverviewUrl = config_1.WeGoConfig.API_GET_BOOKING_OVERVIEW_LIST;
	        var queryStringDataListModel = this.authService.HandleAPIListInput(input);
	        var queryStringBookingOverviewModel = this.JQueryHelper.Param(bookingOverviewList);
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        getBookingOverviewUrl =
	            getBookingOverviewUrl +
	                '?' +
	                queryStringDataListModel +
	                '&' +
	                decodeURIComponent(queryStringBookingOverviewModel);
	        return this.http
	            .get(getBookingOverviewUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.GetBookingRequestList = function (bookingRequestList, input) {
	        var getBookingRequestUrl = config_1.WeGoConfig.API_GET_BOOKING_REQUEST_LIST;
	        var queryStringDataListModel = this.authService.HandleAPIListInput(input);
	        var queryStringBookingRequestModel = this.JQueryHelper.Param(bookingRequestList);
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        getBookingRequestUrl =
	            getBookingRequestUrl +
	                '?' +
	                queryStringDataListModel +
	                '&' +
	                decodeURIComponent(queryStringBookingRequestModel);
	        return this.http
	            .get(getBookingRequestUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.RevokeOrAbortBookings = function (bookingOverviewList) {
	        var body = bookingOverviewList;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_REVOKE_ABORT_BOOKING, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.GetBookingHistoryList = function (input) {
	        var getBookingHistoryUrl = config_1.WeGoConfig.API_GET_BOOKING_History_LIST;
	        var queryStringDataListModel = this.authService.HandleAPIListInput(input);
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        getBookingHistoryUrl =
	            getBookingHistoryUrl + '?' + queryStringDataListModel;
	        return this.http
	            .get(getBookingHistoryUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.ApproveBookingRequest = function (bookingApproveModel) {
	        var body = bookingApproveModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_APPROVE_BOOKING_REQUEST, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.ApproveRejectMultipleBookingRequest = function (bookingApproveModel) {
	        var body = bookingApproveModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_APPROVE_REJECT_MULTIPLE_BOOKING_REQUEST, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.GetActiveDriverList = function (input, CompanyHashID) {
	        if (CompanyHashID === void 0) { CompanyHashID = ''; }
	        var getDriverUrl = config_1.WeGoConfig.API_GET_ACTIVE_DRIVER_LIST_BOOKING;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getDriverUrl = getDriverUrl + '?' + queryString;
	        }
	        if (CompanyHashID && !queryString) {
	            getDriverUrl = getDriverUrl + '?CompanyHashId=' + CompanyHashID;
	        }
	        else if (CompanyHashID) {
	            getDriverUrl = getDriverUrl + '&CompanyHashId=' + CompanyHashID;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getDriverUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.GetBookingInformationByHashId = function (bookingHashId, page) {
	        var getbookingUrl = config_1.WeGoConfig.API_GET_BOOKING_INFORMATION + '?bookingHashId=' + bookingHashId + '&page=' + page;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getbookingUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.CheckBookingExtendTime = function (bookingHashId) {
	        var getbookingUrl = config_1.WeGoConfig.API_CHECK_BOOKING_EXTEND_TIME +
	            '?bookingHashId=' +
	            bookingHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getbookingUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.GetHeaderX = function (accept, content) {
	        var acceptType = accept || "application/json";
	        var contentType = content || "application/json";
	        var access_token = localStorage.getItem("access_token");
	        var authorization = access_token ? "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0ZW5hbnRJZCI6IjI4MGJiYmZlLTY1NjUtMTFlYi04YjlkLTJmYzEzOWRhOWE3MyIsInVzZXJJZCI6ImJiZDhmMzJiLTI0OTctNDVkMi05ZjZmLWFiMzZiZTY3MmY2NiIsImJhY2tvZmZpY2VJZCI6IjE1OTkwIiwicGVybWlzc2lvbnMiOiJBZGFwdGVyR2F0ZXdheS5MaXN0QWRhcHRlcnMsQm9va2luZy5DcmVhdGVCb29raW5nLERhbWFnZS5SZXBvcnREYW1hZ2UsRGFtYWdlLkdldERhbWFnZSxEYW1hZ2UuTGlzdERhbWFnZXMsQm9va2luZy5TdGFydEJvb2tpbmciLCJiYWNrb2ZmaWNlUm9sZUlkcyI6IiIsIm5iZiI6MTY0MTIxODA1NCwiZXhwIjoxNjQxMjQ2ODU0LCJpYXQiOjE2NDEyMTgwNTR9.PH0vGsVCjwu3ndy029pjnFK0z8H23_5ZHEyrvClMse4" : "";
	        var language = localStorage.getItem("language");
	        var accept_language = language ? language : "en";
	        var refresh = localStorage.getItem("refresh_token");
	        var refresh_token = refresh ? refresh : "";
	        var currentRole = localStorage.getItem("current_role");
	        var current_role = currentRole ? currentRole : "";
	        var computerId = localStorage.getItem("computerId");
	        var headers = new http_1.Headers({
	            "Content-Type": contentType,
	            Accept: acceptType,
	            Authorization: authorization,
	            "Accept-Language": accept_language,
	            RefreshToken: refresh_token,
	            CurrentRole: current_role,
	            ComputerId: computerId
	        });
	        return headers;
	    };
	    BookingService.prototype.StartBooking = function (externalId) {
	        var getbookingUrl = config_1.WeGoConfig.GATEWAY_BASE_URL + 'api/booking/v2/' + externalId + '/start';
	        var headers = this.authService.GetHeader();
	        return this.http
	            .put(getbookingUrl, {}, { headers: headers })
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.StopBooking = function (externalId) {
	        var getbookingUrl = config_1.WeGoConfig.GATEWAY_BASE_URL + 'api/booking/v2/' + externalId + '/stop';
	        var headers = this.authService.GetHeader();
	        return this.http
	            .put(getbookingUrl, {}, { headers: headers })
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.ExtendOnGoingBooking = function (bookingHashId, bookingExtendTime) {
	        var getbookingUrl = config_1.WeGoConfig.API_EXTEND_ONGOING_BOOKING +
	            '?bookingHashId=' +
	            bookingHashId +
	            '&bookingExtendTime=' +
	            bookingExtendTime;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getbookingUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.AllowRecurringBooking = function (driverHashId, organizationHashId) {
	        var getBookingUrl = config_1.WeGoConfig.API_RECURRING_BOOKING_DRIVER;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        getBookingUrl =
	            getBookingUrl +
	                '?driverHashId=' +
	                driverHashId +
	                '&organizationHashId=' +
	                organizationHashId;
	        return this.http
	            .get(getBookingUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.AllowTimeForBooking = function (driverHashId, organizationHashId) {
	        var getBookingUrl = config_1.WeGoConfig.API_ALLOW_TIME_BOOKING_DRIVER;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        getBookingUrl =
	            getBookingUrl +
	                '?driverHashId=' +
	                driverHashId +
	                '&organizationHashId=' +
	                organizationHashId;
	        return this.http
	            .get(getBookingUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.UpdateBookingTrip = function (bookingTripDetail) {
	        var updateBookingTripUrl = config_1.WeGoConfig.API_POST_UPDATE_BOOKINGTRIP;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        var queryString = this.JQueryHelper.Param(bookingTripDetail);
	        updateBookingTripUrl =
	            updateBookingTripUrl + '?' + decodeURIComponent(queryString);
	        return this.http
	            .post(updateBookingTripUrl, bookingTripDetail, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.DeleteBookingTrip = function (bookingTripHashId) {
	        var getBookingTripUrl = config_1.WeGoConfig.API_DELETE_BOOKINGTRIP +
	            '?bookingTripHashId=' +
	            bookingTripHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getBookingTripUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.UpdateUserExpense = function (bookingExpense) {
	        var getUpdateUserExpenseUrl = config_1.WeGoConfig.API_UPDATE_USER_EXPENSE;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        var queryString = this.JQueryHelper.Param(bookingExpense);
	        getUpdateUserExpenseUrl =
	            getUpdateUserExpenseUrl + '?' + decodeURIComponent(queryString);
	        return this.http
	            .post(getUpdateUserExpenseUrl, bookingExpense, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.UpdateFreeBooking = function (freebooking) {
	        var freebookingUrl = config_1.WeGoConfig.API_FREE_BOOKING;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        var queryString = this.JQueryHelper.Param(freebooking);
	        freebookingUrl = freebookingUrl + '?' + decodeURIComponent(queryString);
	        return this.http
	            .post(freebookingUrl, freebooking, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.GetAquiredTimeSlots = function (vehicleHashId, driverHashId, organizationHashId) {
	        var getAquiredTimeSlotsUrl = config_1.WeGoConfig.API_GET_AQUIRED_TIMESLOT;
	        getAquiredTimeSlotsUrl =
	            getAquiredTimeSlotsUrl +
	                '?vehicleHashId=' +
	                vehicleHashId +
	                ' &driverHashId=' +
	                driverHashId +
	                '&organizationHashId=' +
	                organizationHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getAquiredTimeSlotsUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.GetNormalBookingList = function (input, forSnailTrailReport, permission) {
	        if (forSnailTrailReport === void 0) { forSnailTrailReport = false; }
	        var getBookingOverviewUrl = config_1.WeGoConfig.API_GET_NORMAL_BOOKING_LIST;
	        var queryStringDataListModel = this.authService.HandleAPIListInput(input);
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        getBookingOverviewUrl =
	            getBookingOverviewUrl +
	                '?' +
	                queryStringDataListModel +
	                '&ForSnailTrailReport=' +
	                forSnailTrailReport +
	                '&permission=' +
	                permission;
	        return this.http
	            .get(getBookingOverviewUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.GetOrganizationList = function (driverHashId, sharedVehicleGroupHashID) {
	        if (sharedVehicleGroupHashID === void 0) { sharedVehicleGroupHashID = ''; }
	        var getDriverUrl = config_1.WeGoConfig.API_GET_BOOKING_ORGANIZATION_LIST +
	            '?driverHashId=' +
	            driverHashId + '&sharedVehicleGroupHashID=' + sharedVehicleGroupHashID;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getDriverUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.GetSpecialPeriodList = function (organizationIdHashID, driverHashId) {
	        var getSpecialPeriodListUrl = config_1.WeGoConfig.API_GET_BOOKING_SPECIAL_PERIODS_LIST +
	            "?organizationIdHashID=" +
	            organizationIdHashID +
	            "&driverHashId=" +
	            driverHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getSpecialPeriodListUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.GetVatSettingDropdownList = function (bookingHashId) {
	        var getUrl = config_1.WeGoConfig.API_BOOKINGEXPENSE_VATSETTINGLIST_DROPDOWN +
	            '?bookingHashId=' +
	            bookingHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.GetVatSettingDefaultValues = function (bookingHashId) {
	        var getUrl = config_1.WeGoConfig.API_BOOKINGEXPENSE_API_GET_VATSETTING_DEFAULT_VALUES +
	            '?bookingHashId=' +
	            bookingHashId;
	        var options = { headers: this.authService.GetHeader() };
	        return this.http
	            .get(getUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.UpdateBookingAfterSuccessfulPayment = function (bookingHashId) {
	        var getUrl = config_1.WeGoConfig.API_UPDATE_BOOKING_SUCCESSPAYMENT +
	            '?bookingHashId=' +
	            bookingHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService.prototype.GetSharedVehicleGroupListForSpecialBooking = function (driverHashId, companyHashId) {
	        if (companyHashId === void 0) { companyHashId = ''; }
	        var getDriverUrl = config_1.WeGoConfig.API_GET_SPECIAL_BOOKING_SVG_LIST +
	            '?driverHashId=' +
	            driverHashId + '&companyHashId=' + companyHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getDriverUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BookingService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], BookingService);
	    return BookingService;
	    var _a, _b;
	}());
	exports.BookingService = BookingService;


/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var jquery_helper_service_1 = __webpack_require__(67);
	var TripDetilReportService = (function () {
	    function TripDetilReportService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	        this.JQueryHelper = new jquery_helper_service_1.JQueryHelperService();
	    }
	    // public GetDriverTripDetailList(input: TripDetailReportModel): Observable<IAPIResponse> {
	    //   let getDriverTripUrl = WeGoConfig.API_GET_DRIVER_BOOKING_TRIP_LIST;
	    //   let queryStringtripreportModel = this.JQueryHelper.Param(input);
	    //   let headers = this.authService.GetHeader();
	    //   let options = new RequestOptions({ headers: headers });
	    //   getDriverTripUrl = getDriverTripUrl + "?" + decodeURIComponent(queryStringtripreportModel);
	    //   return this.http.get(getDriverTripUrl, options)
	    //     .map(this.authService.HandleAPIResponse)
	    //     .catch(this.authService.HandleAPIError);
	    // }
	    TripDetilReportService.prototype.GetDriverTripDetailList = function (input) {
	        var body = input;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_GET_DRIVER_BOOKING_TRIP_LIST, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    TripDetilReportService.prototype.GetDriverVehicleList = function (driverHashID, input) {
	        var getVehicleUrl = config_1.WeGoConfig.API_GET_DRIVER_VEHICLE_LIST;
	        var queryString = input ? this.authService.HandleAPIListInput(input) : null;
	        if (queryString) {
	            getVehicleUrl = getVehicleUrl + "?" + queryString;
	            if (driverHashID)
	                getVehicleUrl = getVehicleUrl + "&driverHashID=" + driverHashID;
	        }
	        else {
	            if (driverHashID)
	                getVehicleUrl = getVehicleUrl + "?driverHashID=" + driverHashID;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getVehicleUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    TripDetilReportService.prototype.ExportTripDetailReport = function (input) {
	        var queryString = "DriverHashId=" + input.driverHashId + "&VehicleHashId=" + input.vehicleHashId +
	            "&StartDateTime=" + input.startDateTime + "&EndDateTime=" + input.endDateTime;
	        var getInstanceUrl = config_1.WeGoConfig.API_EXPORT_TRIP_DETAIL_REPORT + "?" + queryString;
	        var headers = this.authService.GetHeader('text/csv');
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getInstanceUrl, options);
	    };
	    TripDetilReportService.prototype.ExportTripDetailReportPDF = function (input) {
	        var queryString = "DriverHashId=" + input.driverHashId + "&VehicleHashId=" + input.vehicleHashId +
	            "&StartDateTime=" + input.startDateTime + "&EndDateTime=" + input.endDateTime;
	        var getInstanceUrl = config_1.WeGoConfig.API_EXPORT_TRIP_DETAIL_REPORT_PDF + "?" + queryString;
	        var headers = this.authService.GetHeader('application/pdf');
	        var options = new http_1.RequestOptions({ headers: headers, responseType: http_1.ResponseContentType.Blob });
	        return this.http.get(getInstanceUrl, options);
	    };
	    TripDetilReportService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], TripDetilReportService);
	    return TripDetilReportService;
	    var _a, _b;
	}());
	exports.TripDetilReportService = TripDetilReportService;


/***/ },
/* 558 */
/***/ function(module, exports) {

	"use strict";
	var TripDetailReportModel = (function () {
	    function TripDetailReportModel() {
	        this.vehicleHashId = '';
	    }
	    return TripDetailReportModel;
	}());
	exports.TripDetailReportModel = TripDetailReportModel;


/***/ },
/* 559 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ 'LblTripDetailReport' | translate }}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li><a [routerLink]=\"urlDefaultPage\"><i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a></li>\r\n        <li class=\"active\">{{ 'LblTripDetailReport' | translate }}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <div class=\"box box-default\">\r\n          <div class=\"box-header with-border\">\r\n            <h3 class=\"box-title\">{{ 'LblSearchTripforDriver' | translate }}</h3>\r\n          </div>\r\n          <div class=\"box-body\" style=\"display: block;\">\r\n            <!--Filter-->\r\n            <div class=\"row\">\r\n              <div class=\"col-md-12\">\r\n                <div class=\"col-sm-11\">\r\n                  <form (ngSubmit)=\"OnSearch(searchForm.value)\" #searchForm=\"ngForm\">\r\n                    <div class=\"row\">\r\n                      <div class=\"form-group col-md-3\">\r\n                        <label><span class=\"text text-danger\">*</span>{{ 'LblDriver' | translate }}</label>\r\n                        <div class=\"input-group\">\r\n                          <input [(ngModel)]=\"model.filterDriverName\" name=\"driverName\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblDriver' | translate }}\"\r\n                            readonly>\r\n                          <div class=\"input-group-btn\">\r\n                            <button class=\"btn btn-default\" type=\"button\" (click)=\"selectDriverModal.show()\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i></button>\r\n                          </div>\r\n                        </div>\r\n                        <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'DriverHashId' }}</span>\r\n                      </div>\r\n                      <div class=\"form-group col-md-3\">\r\n                        <label>{{ 'LblVehicle' | translate }}</label>\r\n                        <select [(ngModel)]=\"model.vehicleHashId\" name=\"Vehicle\" class=\"form-control\" (change)=\"OnVehicleChange($event)\">\r\n                          <option value=\"\" [selected]=\"selected\">{{ 'LblAll' | translate }}</option>\r\n                          <option *ngFor=\"let item of driverVehicleList\"  [ngValue]='item.vehicleMasterHashId' >{{item.licenceTag}}</option>\r\n                          </select>\r\n                        <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'VehicleHashId' }}</span>\r\n                      </div>\r\n                      <div class=\"form-group col-md-3\">\r\n                        <label><span class=\"text text-danger\">*</span>{{ 'LblFrom' | translate }}</label>\r\n                        <div class=\"clearfix\"></div>\r\n                        <div class=\"input-group\">\r\n                          <span class=\"input-group-addon\"><i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i></span>\r\n                          <input #flatPickrConfigFromDate=\"wego-flatpickr\" flatpickr readonly [Config]=\"flatPickrConfigFrom\" [(ngModel)]=\"model.startDateTime\"\r\n                            name=\"startDateTime\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblFrom' | translate\r\n                                  }}\" (change)=\"OnFromDateChange($event.target.value)\">\r\n                        </div>\r\n                        <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'StartDateTime' }}</span>\r\n                      </div>\r\n                      <div class=\"form-group col-md-3\">\r\n                        <label><span class=\"text text-danger\">*</span>{{ 'LblTo' | translate }}</label>\r\n                        <div class=\"clearfix \"></div>\r\n                        <div class=\"input-group\">\r\n                          <span class=\"input-group-addon\"><i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i></span>\r\n                          <input #flatPickrConfigToDate=\"wego-flatpickr\" flatpickr readonly [Config]=\"flatPickrConfigTo\" [(ngModel)]=\"model.endDateTime\"\r\n                            name=\"endDateTime\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblTo' | translate }}\" (change)=\"OnToDateChange($event)\">\r\n                        </div>\r\n                        <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'EndDateTime' }}</span>\r\n                      </div>\r\n                    </div>\r\n                  </form>\r\n                </div>\r\n                <div class=\"col-sm-1\">\r\n                  <div class=\"row\">\r\n                    <div class=\"form-group\">\r\n                      <div class=\"input-group\">\r\n                        <label>&nbsp;</label>\r\n                        <div class=\"clearfix\"></div>\r\n                        <button class=\"btn btn-default\" type=\"button\" (click)=\"OnSearchTrips($event)\" title=\"{{'LblSearch' | translate}}\">\r\n                        <i class=\"fa fa-search\" aria-hidden=\"true\"></i>\r\n                      </button>\r\n                        <!--<button *ngIf=\"listOfFilterRecord && listOfFilterRecord.length > 0\" class=\"btn btn-default\" type=\"button\" (click)=\"OnExport($event)\" title=\"{{'LblExportReport' | translate}}\" style=\"margin-left:10px;\">\r\n                        <i class=\"fa fa-download\" aria-hidden=\"true\"></i>\r\n                      </button>-->\r\n                        <button *ngIf=\"listOfFilterRecord && listOfFilterRecord.length > 0\" class=\"btn btn-default\" type=\"button\" (click)=\"OnExportPdf($event)\"\r\n                          title=\"{{'LblExportReport' | translate}}\" style=\"margin-left:10px;\">\r\n                        <i class=\"fa fa-file-pdf-o\" aria-hidden=\"true\"></i>\r\n                      </button>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--No record found-->\r\n            <div class=\"row\">\r\n              <div class=\"col-sm-12 text-danger text-center\">\r\n                <div *ngIf=\"DataListModel.totalItems == 0\">\r\n                  {{ DataListModel.infoMessage }}\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Trip detail table-->\r\n            <div class=\"row\" *ngIf=\"listOfFilterRecord && listOfFilterRecord.length > 0\">\r\n              <fieldset class=\"col-md-12\">\r\n                <legend class=\"legendStyle\">\r\n                  <div class=\"form-inline\" style=\"padding-bottom: 5px;\">\r\n                    <div class=\"form-group\">\r\n                      {{ 'LblTripDetailList' | translate }}\r\n                    </div>\r\n                    <div class=\"form-group pull-right\">\r\n                      <select class=\"form-control\" title='Items Per Page' [(ngModel)]=\"DataListModel.itemsPerPage\" name=\"itemPerPage\" (change)=\"OnPagingChange($event.target.value)\">\r\n                        <option *ngFor=\"let item of itemPerPageList\"  [attr.value]='item.value' >{{ item }}</option>\r\n                      </select>\r\n                    </div>\r\n                  </div>\r\n                </legend>\r\n                <div class=\"clearfix\"></div>\r\n                <div class=\"row\">\r\n                  <div class=\"col-sm-12\">\r\n                    <div class=\"table table-responsive mar_bot_ziro\">\r\n                      <table class=\"table table-bordered mar_bot_ziro\">\r\n                        <thead>\r\n                          <tr>\r\n                            <th>{{ 'LblStartDateTime' | translate }}\r\n                            </th>\r\n                            <th> {{ 'LblEndDateTime' | translate }}\r\n                            </th>\r\n                            <th>{{ 'LblDistance' | translate }}\r\n                            </th>\r\n                            <th>{{ 'LblVehicle' | translate }}\r\n                            </th>\r\n                            <th>{{ 'LblBookingReferenceId' | translate }}\r\n                            </th>\r\n                            <th>{{ 'LblContractType' | translate }}\r\n                            </th>\r\n                          </tr>\r\n                        </thead>\r\n                        <tbody>\r\n                          <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                            <tr *ngFor=\"let trip of listOfFilterRecord\">\r\n                              <td>{{ trip.startDateTime }}</td>\r\n                              <td>{{ trip.endDateTime }}</td>\r\n                              <td>{{ trip.distance | decimalFormatter }}</td>\r\n                              <td>{{ trip.licenseTag }}</td>\r\n                              <td>{{ trip.bookingRefId }} </td>\r\n                              <td>{{ trip.contractTypeGroup }} </td>\r\n                            </tr>\r\n                          </template>\r\n                          <tr *ngIf=\"DataListModel.totalItems == 0\">\r\n                            <td class=\"text-center text-danger\" colspan=\"6\">\r\n                              {{ DataListModel.infoMessage }}\r\n                            </td>\r\n                          </tr>\r\n                        </tbody>\r\n                      </table>\r\n                      <div *ngIf=\"DataListModel.totalItems > 0\" class=\"col-sm-12\">\r\n                        <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                          [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\"\r\n                          firstText=\"&laquo;\" lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n                      </div>\r\n                    </div>\r\n                    <div class=\"clearfix\"></div>\r\n                  </div>\r\n                </div>\r\n              </fieldset>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n\r\n  <wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n  <wego-select-driver-popup #selectDriverModal (OnSuccessSelect)=\"SuccessSelectDriverModal($event)\"></wego-select-driver-popup>";

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var http_1 = __webpack_require__(59);
	var vehicleattribute_service_1 = __webpack_require__(561);
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var vehicle_model_1 = __webpack_require__(553);
	var vehicle_service_1 = __webpack_require__(530);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var common_1 = __webpack_require__(22);
	var geolocation_service_1 = __webpack_require__(562);
	var decimal_formatter_service_1 = __webpack_require__(69);
	var modal_1 = __webpack_require__(537);
	var VehicleInformationComponent = (function () {
	    function VehicleInformationComponent(vehicleService, vehicleAttributeSerive, activeRoute, authService, translate, router, http, locationService, geoLocationService, decimalFormatter) {
	        this.vehicleService = vehicleService;
	        this.vehicleAttributeSerive = vehicleAttributeSerive;
	        this.activeRoute = activeRoute;
	        this.authService = authService;
	        this.translate = translate;
	        this.router = router;
	        this.http = http;
	        this.locationService = locationService;
	        this.geoLocationService = geoLocationService;
	        this.decimalFormatter = decimalFormatter;
	        this.headers = this.authService.GetHeaderForFile();
	        this.vehicleAttributeList = [];
	        this.isLoading = true;
	        this.isMobileRequest = false;
	        this.roleLevel = config_1.RoleLevel;
	        this.fileListQuer = [];
	    }
	    VehicleInformationComponent.prototype.ngOnInit = function () {
	        this.module = this.translate.instant("LblVehicle");
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.itemsPerPage = 4;
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlVehicleList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_VEHICLE_LIST);
	        this.urlUpdateDamageStatus = this.authService.GetURL(config_1.ApplicationRouteURL.URL_REPORT_DAMGE_UPDATE);
	        this.urlVtsTroubleShoot = this.authService.GetURL(config_1.ApplicationRouteURL.URL_VTS_TROUBLESHOOT);
	        this.urlVehicleUpdate = this.authService.GetURL(config_1.ApplicationRouteURL.URL_VEHICLE_UPDATE);
	        this.urlCompanyUpdate = this.authService.GetURL(config_1.ApplicationRouteURL.URL_COMPANY_UPDATE);
	        this.urlBookingInformation = this.authService.GetURL(config_1.ApplicationRouteURL.URL_BOOKING_INFORMATION);
	        this.model = new vehicle_model_1.VehicleModel();
	        this.GetVehicleAttributeList();
	    };
	    VehicleInformationComponent.prototype.OnBackClick = function () {
	        this.locationService.back();
	    };
	    VehicleInformationComponent.prototype.UpdateDamageReportStatus = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.vehicleService
	            .UpdateReportDamageStatus(this.reportDamageHashId)
	            .subscribe(function (res) {
	            _this.apiResponse = res;
	            _this.popupMsg = _this.translate.instant("LblVehicleDamgeResolveSuccess");
	            _this.ShowReportSuccessPopup();
	            _this.isLoading = false;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    VehicleInformationComponent.prototype.UpdateVehicleDetails = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.vehicleService
	            .UpdateVehicleForCleaningAndFuel(this.model.vehicleMasterHashId, this.model.isCleaningRequire, this.model.isFuelRequire)
	            .subscribe(function (res) {
	            _this.apiResponse = res;
	            _this.popupMsg = _this.translate.instant("LblVehicleInfoSuccess");
	            _this.ShowSuccessPopup();
	            _this.isLoading = false;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        }, function () { return _this.UpdateVehicleForInvalidTag(); });
	    };
	    VehicleInformationComponent.prototype.UpdateVehicleForInvalidTag = function () {
	        var _this = this;
	        this.vehicleService
	            .UpdateVehicleForInvalidTag(this.model.vehicleMasterHashId, this.model.invalidTagUsed)
	            .subscribe(function (res) {
	            _this.apiResponse = res;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        }, function () { return _this.GetVehicleDetails(); });
	    };
	    VehicleInformationComponent.prototype.GetVehicleAttributeList = function () {
	        var _this = this;
	        this.vehicleAttributeSerive.GetVehicleAttributeList().subscribe(function (res) {
	            _this.apiResponse = res;
	            _this.vehicleAttributeList = res.data;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        }, function () { return _this.GetVehicleDetails(); });
	    };
	    VehicleInformationComponent.prototype.GetVehicleAttributeForCompany = function (ownerCompanyHashID) {
	        var _this = this;
	        this.vehicleAttributeSerive
	            .GetVehicleAttributeForCompany(ownerCompanyHashID)
	            .subscribe(function (res) {
	            _this.apiResponse = res;
	            _this.vehicleAttributeList = res.data;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        }, function () {
	            if (_this.isEditMode) {
	                if (_this.authService.GetHighestRoleLevel() <= config_1.RoleLevel.Instance)
	                    _this.vehicleAttributeList
	                        .filter(function (x) {
	                        return _this.model.attributeList &&
	                            _this.model.attributeList.indexOf(x.vehicleAttributeHashId) >
	                                -1;
	                    })
	                        .forEach(function (x) { return (x.isChecked = true); });
	            }
	        });
	    };
	    VehicleInformationComponent.prototype.GetVehicleDetails = function () {
	        var _this = this;
	        this.sub = this.activeRoute.params.subscribe(function (params) {
	            _this.vehicleMasterHashId = params["id"] || "";
	            _this.isEditMode = true;
	            if (_this.vehicleMasterHashId != "") {
	                _this.vehicleService
	                    .GetVehicleByHashId(_this.vehicleMasterHashId, false)
	                    .subscribe(function (res) {
	                    _this.isLoading = false;
	                    _this.model = res.data;
	                    _this.updateCompanyLink = new config_1.WeGoAuthorizedLink(_this.urlCompanyUpdate + "/" + _this.model.ownerCompanyHashID, config_1.Permission.PR_COMPANY_OVERVIEW, config_1.PermissionType.EDIT, "", _this.model.ownerName, "", "", true);
	                    _this.vtsTroubleShootLink = new config_1.WeGoAuthorizedLink(_this.urlVtsTroubleShoot + "/" + _this.model.vehicleMasterHashId, config_1.Permission.PR_VTS_TROUBLESHOOT, config_1.PermissionType.VIEW, "", "LblTroubleShootVTS", "", "", false, "fa fa-wrench");
	                    _this.updateVehicleLink = new config_1.WeGoAuthorizedLink(_this.urlVehicleUpdate + "/" + _this.model.vehicleMasterHashId, config_1.Permission.PR_VEHICLES_OVERVIEW, config_1.PermissionType.EDIT, "", _this.model.licenceTag, "", "", true);
	                    _this.vehicleListLink = new config_1.WeGoAuthorizedLink(_this.urlVehicleList, config_1.Permission.PR_VEHICLES_OVERVIEW, config_1.PermissionType.VIEW, "", _this.breadCrumbList, "", "", false, "fa fa-cab");
	                    _this.locationDataExchangeHashId =
	                        res.data.locationDataExchangeHashId;
	                    _this.vehicleAttributeList
	                        .filter(function (x) {
	                        return _this.model.attributeList &&
	                            _this.model.attributeList.indexOf(x.vehicleAttributeHashId) >
	                                -1;
	                    })
	                        .forEach(function (x) { return (x.isChecked = true); });
	                    if (_this.authService.GetHighestRoleLevel() <= config_1.RoleLevel.Instance)
	                        _this.GetVehicleAttributeForCompany(_this.model.ownerCompanyHashID);
	                }, function (error) {
	                    _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	                    _this.isLoading = false;
	                }, function () {
	                    _this.GetVehicleDamageReport();
	                });
	            }
	            else {
	                _this.isLoading = false;
	                _this.isEditMode = false;
	            }
	        });
	        this.breadCrumbTitle = this.translate.instant("LblVehicleStatus");
	        this.breadCrumbList = this.translate.instant("LblListPage", [this.module]);
	    };
	    // public UpdateVTSVehicleStatus(vehicleStatus: string) {
	    //   this.isLoading = true;
	    //   this.vehicleService.UpdateVTSVehicleStatus(this.vehicleMasterHashId, vehicleStatus)
	    //     .subscribe(
	    //     res => {
	    //       this.isLoading = false;
	    //       this.popupMsg = this.translate.instant('LblVTSVehicleUpdateSuccess', vehicleStatus);
	    //       this.ShowSuccessPopup();
	    //     },
	    //     error => {
	    //       this.isLoading = false;
	    //       this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
	    //     });
	    // }
	    VehicleInformationComponent.prototype.LockVTSVehicle = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.vehicleService
	            .LockVTSVehicle(this.locationDataExchangeHashId, this.isMobileRequest)
	            .subscribe(function (res) {
	            _this.isLoading = false;
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant("LblLockSuccessfully");
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant("LbllockProblem");
	                _this.popupTitle = _this.translate.instant("LblWarning");
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.isLoading = false;
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    VehicleInformationComponent.prototype.UnLockVTSVehicle = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.vehicleService
	            .UnLockVTSVehicle(this.locationDataExchangeHashId, this.isMobileRequest)
	            .subscribe(function (res) {
	            _this.isLoading = false;
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant("LblUnLockSuccessfully");
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant("LblUnlockProblem");
	                _this.popupTitle = _this.translate.instant("LblWarning");
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.isLoading = false;
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    VehicleInformationComponent.prototype.ShowReportSuccessPopup = function () {
	        this.successPopupReport.show();
	    };
	    VehicleInformationComponent.prototype.HideReportSuccessPopup = function () {
	        this.successPopupReport.hide();
	    };
	    VehicleInformationComponent.prototype.ConfirmReportSuccessPopup = function () {
	        this.GetVehicleDamageReport();
	    };
	    VehicleInformationComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    VehicleInformationComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    VehicleInformationComponent.prototype.ConfirmSuccessPopup = function () {
	        this.OnBackClick();
	    };
	    VehicleInformationComponent.prototype.GetImageURL = function (imagePath) {
	        return config_1.WeGoConfig.LEGACY_API_BASE_URL + imagePath;
	    };
	    VehicleInformationComponent.prototype.DecimalFormatter = function (val) {
	        return this.decimalFormatter.transform(val);
	    };
	    VehicleInformationComponent.prototype.GetVehicleDamageReport = function () {
	        var _this = this;
	        this.vehicleService
	            .GetVehicleDamageReport(this.vehicleMasterHashId, this.DataListModel)
	            .subscribe(function (res) {
	            _this.damageReportList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    VehicleInformationComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetVehicleDamageReport();
	    };
	    VehicleInformationComponent.prototype.ConfirmSuccessClick = function () {
	        this.confirmModal.hide();
	        this.UpdateDamageReportStatus();
	    };
	    VehicleInformationComponent.prototype.ShowConfirmModal = function (reportHashId) {
	        this.isLoading = false;
	        this.confirmMsg = this.translate.instant("LblConfirmResolveDamage");
	        this.reportDamageHashId = reportHashId;
	        this.confirmModal.show();
	    };
	    VehicleInformationComponent.prototype.HideConfirmModal = function () {
	        this.confirmModal.hide();
	    };
	    VehicleInformationComponent.prototype.GetVTSAddress = function () {
	        var _this = this;
	        var latlng = this.model.vtsLocation;
	        this.geoLocationService.GetFormatedAddressFromLatlng(latlng, this.model.instanceLanguage).subscribe(function (result) {
	            if (result.Response.View.length > 0) {
	                if (result.Response.View[0].Result.length > 0) {
	                    console.log(result.Response.View[0].Result);
	                    var houseMatch = result.Response.View[0].Result.filter(function (x) { return x.MatchLevel == 'houseNumber'; });
	                    var matchedAddress;
	                    if (houseMatch.length > 0) {
	                        matchedAddress = houseMatch[0];
	                    }
	                    else {
	                        matchedAddress = result.Response.View[0].Result[0];
	                    }
	                    _this.vtsLocationAddress = matchedAddress.Location.Address.Label;
	                }
	                else {
	                    _this.vtsLocationAddress = _this.translate.instant('LblAddressNotAvailable');
	                }
	            }
	            else {
	                _this.vtsLocationAddress = _this.translate.instant('LblAddressNotAvailable');
	            }
	        }, function (error) { });
	    };
	    VehicleInformationComponent.prototype.GetAttributeName = function (key) {
	        var vehicleAttr = this.vehicleAttributeList.find(function (x) { return x.vehicleAttributeHashId == key; });
	        if (vehicleAttr)
	            return vehicleAttr.attributeName;
	        else
	            return "";
	    };
	    Object.defineProperty(VehicleInformationComponent.prototype, "GetAdditionalAttribute", {
	        get: function () {
	            var _this = this;
	            var vehicleAttrList = this.vehicleAttributeList.filter(function (x) {
	                return _this.model.attributeList &&
	                    _this.model.attributeList.indexOf(x.vehicleAttributeHashId) > -1;
	            });
	            return this.GroupByCategory(vehicleAttrList);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    VehicleInformationComponent.prototype.GroupByCategory = function (vehicleAttrList) {
	        if (vehicleAttrList) {
	            var prop_1 = "vehicleAttributeCategoryName";
	            return vehicleAttrList.reduce(function (groups, item) {
	                var val = item[prop_1];
	                groups[val] = groups[val] || [];
	                groups[val].push(item);
	                groups[val] = groups[val].sort(function (obj1, obj2) {
	                    if (obj1.attributeName > obj2.attributeName) {
	                        return 1;
	                    }
	                    if (obj1.attributeName < obj2.attributeName) {
	                        return -1;
	                    }
	                    return 0;
	                });
	                return groups;
	            }, {});
	        }
	        else {
	            return {};
	        }
	    };
	    VehicleInformationComponent.prototype.FormatString = function (data) {
	        if (data)
	            return data;
	        else
	            return this.translate.instant("LblNA");
	    };
	    VehicleInformationComponent.prototype.ReportDamage = function (vehicleMasterHashId) {
	        this.reportDamageModal.model.vehicleHashId = vehicleMasterHashId;
	        this.reportDamageModal.show();
	    };
	    VehicleInformationComponent.prototype.SuccessReportDamage = function (successMsg) {
	        this.popupMsg = successMsg;
	        this.ShowReportSuccessPopup();
	    };
	    VehicleInformationComponent.prototype.KeyOfObject = function (obj) {
	        return Object.keys(obj);
	    };
	    VehicleInformationComponent.prototype.ConfirmImageSlider = function (event) { };
	    VehicleInformationComponent.prototype.ngOnDestroy = function () {
	        if (this.sub) {
	            this.sub.unsubscribe();
	        }
	    };
	    __decorate([
	        core_1.ViewChild("confirmModal"), 
	        __metadata('design:type', Object)
	    ], VehicleInformationComponent.prototype, "confirmModal", void 0);
	    __decorate([
	        core_1.ViewChild("googleMapComp"), 
	        __metadata('design:type', Object)
	    ], VehicleInformationComponent.prototype, "googleMapComp", void 0);
	    __decorate([
	        core_1.ViewChild("successPopup"), 
	        __metadata('design:type', Object)
	    ], VehicleInformationComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild("successPopupReport"), 
	        __metadata('design:type', Object)
	    ], VehicleInformationComponent.prototype, "successPopupReport", void 0);
	    __decorate([
	        core_1.ViewChild("reportDamageModal"), 
	        __metadata('design:type', Object)
	    ], VehicleInformationComponent.prototype, "reportDamageModal", void 0);
	    __decorate([
	        core_1.ViewChild("damageImageSliderModel"), 
	        __metadata('design:type', (typeof (_a = typeof modal_1.ModalDirective !== 'undefined' && modal_1.ModalDirective) === 'function' && _a) || Object)
	    ], VehicleInformationComponent.prototype, "damageImagesModal", void 0);
	    VehicleInformationComponent = __decorate([
	        core_1.Component({
	            selector: "wego-vehicle-information",
	            template: __webpack_require__(563),
	            styles: [
	                "       .clear-div {\n              clear: both;\n            }\n            span.label.label-default{\n              font-size: 13px;\n              line-height: 35px;\n              background-color: #eeeeee;\n              color: #2BA2AA;\n              margin-right: 5px;\n            }\n            .modal.and.carousel {\n              position: fixed;\n            }\n  "
	            ],
	            providers: [
	                vehicle_service_1.VehicleService,
	                vehicleattribute_service_1.VehicleAttributeService,
	                geolocation_service_1.GeoLocationService,
	                decimal_formatter_service_1.DecimalFormatterService
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof vehicle_service_1.VehicleService !== 'undefined' && vehicle_service_1.VehicleService) === 'function' && _b) || Object, (typeof (_c = typeof vehicleattribute_service_1.VehicleAttributeService !== 'undefined' && vehicleattribute_service_1.VehicleAttributeService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object, (typeof (_e = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _e) || Object, (typeof (_f = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _f) || Object, (typeof (_g = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _g) || Object, (typeof (_h = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _h) || Object, (typeof (_j = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _j) || Object, (typeof (_k = typeof geolocation_service_1.GeoLocationService !== 'undefined' && geolocation_service_1.GeoLocationService) === 'function' && _k) || Object, (typeof (_l = typeof decimal_formatter_service_1.DecimalFormatterService !== 'undefined' && decimal_formatter_service_1.DecimalFormatterService) === 'function' && _l) || Object])
	    ], VehicleInformationComponent);
	    return VehicleInformationComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
	}());
	exports.VehicleInformationComponent = VehicleInformationComponent;


/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var VehicleAttributeService = (function () {
	    function VehicleAttributeService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    VehicleAttributeService.prototype.GetVehicleAttributeList = function (input) {
	        var getVehicleAttributeUrl = config_1.WeGoConfig.API_GET_VEHICLEATTRIBUTE_DETAIL;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getVehicleAttributeUrl = getVehicleAttributeUrl + "?" + queryString;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getVehicleAttributeUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    VehicleAttributeService.prototype.ExportVehicleAttributeList = function (input) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var getAttributeListUrl = config_1.WeGoConfig.API_EXPORT_VEHICLEATTRIBUTE_LIST + "?" + queryString;
	        var headers = this.authService.GetHeader('text/csv');
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getAttributeListUrl, options);
	    };
	    VehicleAttributeService.prototype.GetVehicleAttributeByHashId = function (vehicleAttributeHashId) {
	        var getvehicleAttributeUrl = config_1.WeGoConfig.API_GET_VEHICLEATTRIBUTE_BY_HASH + "?vehicleAttributeHashId=" + vehicleAttributeHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getvehicleAttributeUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    VehicleAttributeService.prototype.AddNewVehicleAttribute = function (vehicleAttributeModel) {
	        var body = vehicleAttributeModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_POST_VEHICLEATTRIBUTE_DETAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    VehicleAttributeService.prototype.GetVehicleAttributeForCompany = function (ownerCompanyHashID) {
	        var getvehicleAttributeUrl = config_1.WeGoConfig.API_GET_VEHICLEATTRIBUTE_BY_COMPANY + "?ownerCompanyHashID=" + ownerCompanyHashID;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getvehicleAttributeUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    VehicleAttributeService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], VehicleAttributeService);
	    return VehicleAttributeService;
	    var _a, _b;
	}());
	exports.VehicleAttributeService = VehicleAttributeService;


/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var config_1 = __webpack_require__(60);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var GeoLocationService = (function () {
	    function GeoLocationService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    GeoLocationService.prototype.GetFormatedAddressFromLatlng = function (latlng, language) {
	        var reqUrl = config_1.WeGoConfig.HERE_MAP_REVERSE_GEOCODE_URL + '?' +
	            'at=' + latlng + ',' + config_1.WeGoConfig.HERE_MAP_LOC_RADIUS +
	            '&lang=' + language.toLowerCase() +
	            '&apiKey=' + config_1.WeGoConfig.HERE_MAP_API_KEY;
	        ;
	        return this.http.get(reqUrl)
	            .map(this.authService.HandleAPIResponse).map(function (res) {
	            var label = '';
	            if (res && res.items && res.items.length > 0) {
	                var firstItem = res.items[0];
	                if (firstItem.title) {
	                    label = firstItem.title;
	                }
	                else if (firstItem.address && firstItem.address.label) {
	                    label = firstItem.address.label;
	                }
	                return {
	                    Response: {
	                        View: [
	                            {
	                                Result: [
	                                    {
	                                        MatchLevel: 'houseNumber',
	                                        Location: {
	                                            Address: {
	                                                Label: label
	                                            }
	                                        }
	                                    }
	                                ]
	                            }
	                        ]
	                    }
	                };
	            }
	            // Fallback if no items
	            return {
	                Response: {
	                    View: []
	                }
	            };
	        })
	            .catch(this.authService.HandleAPIError);
	    };
	    GeoLocationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], GeoLocationService);
	    return GeoLocationService;
	    var _a, _b;
	}());
	exports.GeoLocationService = GeoLocationService;


/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{breadCrumbTitle}}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li>\r\n          <wego-authorized-link [LinkModel]=\"vehicleListLink\"></wego-authorized-link>\r\n        </li>\r\n        <li class=\"active\">{{breadCrumbTitle}}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25\">\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"nopad\">\r\n\r\n      <input type=\"hidden\" class=\"form-control\" [(ngModel)]=\"model.vehicleMasterHashId\" name=\"vehicleMasterHashId\">\r\n\r\n      <!--Basic Information-->\r\n      <div class=\"media\">\r\n        <div class=\"media-left media-top\">\r\n          <img *ngIf=\"!model.vehicleImagePath\" class=\"media-object\" src=\"" + __webpack_require__(564) + "\" alt=\"No\"\r\n            style=\"max-height: 100px; border: 1px solid;\">\r\n          <img *ngIf=\"model.vehicleImagePath\" class=\"media-object\" [src]=\"GetImageURL(model.vehicleImagePath)\" style=\"max-height: 100px; border: 1px solid;\"\r\n          />\r\n        </div>\r\n        <div class=\"media-body\">\r\n          <div class=\"form-group\">\r\n            <label>{{ 'LblLicenceTag' | translate }}</label> :\r\n            <!-- <a [routerLink]=\"[urlVehicleUpdate, { vehicleHashId : model.vehicleMasterHashId }]\">{{ model.licenceTag }}</a> -->\r\n            <wego-authorized-link [LinkModel]=\"updateVehicleLink\"></wego-authorized-link>\r\n          </div>\r\n          <!-- <div class=\"form-group\">\r\n            <label>{{ 'LblVehicleOwner' | translate }}</label> :\r\n              <wego-authorized-link [LinkModel]=\"updateCompanyLink\"></wego-authorized-link>\r\n          </div> -->\r\n          <div class=\"form-group\">\r\n\r\n            <div class=\"col-lg-12\" style=\"padding-left:  0px;\">\r\n\r\n              <div class=\"col-lg-6\" style=\"padding-left:  0px;\">\r\n                <label class=\"col-lg-3\" style=\"padding-left:  0px;\">\r\n                  {{ 'LblVehicleOwner' | translate }} :\r\n                </label>\r\n                <div class=\"col-lg-3\" style=\"padding-left:  0px;\">\r\n                  <div *ngIf=\"model.isCompanyEditable\">\r\n                    <wego-authorized-link [LinkModel]=\"updateCompanyLink\"></wego-authorized-link>\r\n                  </div>\r\n                  <div *ngIf=\"!model.isCompanyEditable\">\r\n                    <span>{{model.ownerName}}</span>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-lg-6\"></div>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-group\">\r\n            <div *ngIf=\"model.isvtsTroubleshootEnable\">\r\n              <wego-authorized-link [LinkModel]=\"vtsTroubleShootLink\"></wego-authorized-link>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <!--Current Status-->\r\n      <fieldset class=\"row col-md-12\">\r\n        <legend class=\"legendStyle\">\r\n          {{ 'LblCurrentStatus' | translate }}\r\n        </legend>\r\n        <div class=\"form-group col-md-3\">\r\n          <label> {{ 'LblVtsDoorStatus' | translate }} </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblVtsDoorStatus' | translate }}\" [ngModel]=\"FormatString(model.vehicleStatus)\"\r\n            name=\"vehicleStatus\" readonly>\r\n        </div>\r\n        <div class=\"form-group col-md-3\" *ngIf=\"(authService.GetHighestRoleLevel() <= roleLevel.SVG)\">\r\n          <label> {{ 'LblVtsLocation' | translate }} </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblVtsLocation' | translate }}\" [ngModel]=\"FormatString(model.vtsLocation)\"\r\n            name=\"vtsLocation\" readonly>\r\n          <a *ngIf=\"!vtsLocationAddress && model.vtsLocation && model.bookingStatus != 'RUNNING'\" class=\"cursor-pointer pull-right\"\r\n            (click)=\"GetVTSAddress()\">{{ 'LblRetriveAddress' | translate }}\r\n          </a>\r\n        </div>\r\n        <div *ngIf=\"vtsLocationAddress\" class=\"form-group col-md-6\">\r\n          <label>&nbsp;</label>\r\n          <input type=\"text\" class=\"form-control\" [ngModel]=\"vtsLocationAddress\" name=\"vtsLocationAddress\" readonly>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"form-group col-md-3\" *ngIf=\"(authService.GetHighestRoleLevel() <= roleLevel.SVG)\">\r\n          <label> {{ 'LblCurrentOdometerValue' | translate }} </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblCurrentOdometerValue' | translate }}\" [ngModel]=\"FormatString(model.calculateOdometerValue)\"\r\n            name=\"calculateOdometerValue\" readonly>\r\n        </div>\r\n        <div class=\"form-group col-md-3\" *ngIf=\"(authService.GetHighestRoleLevel() <= roleLevel.SVG)\">\r\n          <label> {{ 'LblCurrentOdometerDateTime' | translate }} </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblCurrentOdometerDateTime' | translate }}\" [ngModel]=\"model.currentOdometerDateTime\"\r\n            name=\"currentOdometerDateTime\" readonly>\r\n        </div>\r\n        <div class=\"form-group col-md-3\">\r\n          <label> {{ 'LblVehicleStatus' | translate }} </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblVehicleStatus' | translate }}\" [ngModel]=\"model.dashboardStatus\"\r\n            name=\"dashboardStatus\" readonly>\r\n          <a *ngIf=\"model.dashboardStatus == 'INUSE' && model.inUseBookingDetail && model.inUseBookingDetail?.bookingReferenceID\" class=\"cursor-pointer pull-right\"\r\n            [routerLink]=\"urlBookingInformation +'/'+ model.inUseBookingDetail?.bookingMasterHashId\">{{ model.inUseBookingDetail?.bookingReferenceID }}\r\n          </a>\r\n          <span *ngIf=\"model.dashboardStatus == 'INUSE' && !(model.inUseBookingDetail && model.inUseBookingDetail?.bookingReferenceID)\"\r\n            class=\"pull-right\" style=\"color : #007777;\"> {{ 'LblOpenViaLowLevel' | translate}}\r\n          </span>\r\n        </div>\r\n        <div class=\"form-group col-md-3\">\r\n          <label> {{ 'LblBatteryVoltage' | translate }} </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblBatteryVoltage' | translate }}\" [ngModel]=\"DecimalFormatter(model.batteryVoltage)\"\r\n            name=\"batteryVoltage\" readonly>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div *ngIf=\"model.isChargeLevelVisible\" class=\"form-group col-md-3\">\r\n          <label> {{ 'LblChargeLevel' | translate }} </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblChargeLevel' | translate }}\" [ngModel]=\"DecimalFormatter(model.chargeLevel)\"\r\n            name=\"chargeLevel\" readonly>\r\n        </div>\r\n        <div *ngIf=\"model.isChargeLevelVisible\" class=\"form-group col-md-3\">\r\n          <label> {{ 'LblCharging' | translate }} </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblCharging' | translate }}\" [ngModel]=\"model.filling ? ( 'LblYes' | translate ) : ( 'LblNo' | translate )\"\r\n                 name=\"charging\" readonly>\r\n        </div>\r\n\r\n      </fieldset>\r\n\r\n      <!--Flag-->\r\n      <fieldset class=\"row col-md-12\">\r\n        <legend class=\"legendStyle\">\r\n          {{ 'LblFlags' | translate }}\r\n          <a class=\"btn btn-green btn-sm cursor-pointer pull-right\" style=\"margin-top: -6px; margin-right: 1px; width: 114px;\" (click)=\"UpdateVehicleDetails()\">\r\n            <i class=\"fa fa-flag\"></i> {{ 'LblUpdate' | translate }} {{ 'LblFlags' | translate }}\r\n          </a>\r\n        </legend>\r\n        <div class=\"form-group col-md-3\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblCleanRequire' | translate }}</label>\r\n          <div class=\"clearfix\"></div>\r\n          <label class=\"radio-inline\">\r\n            <input type=\"radio\" [(ngModel)]=\"model.isCleaningRequire\" name=\"CleaningReq\" [value]=\"true\">{{ 'LblYes' | translate }}</label>\r\n          <label class=\"radio-inline\">\r\n            <input type=\"radio\" [(ngModel)]=\"model.isCleaningRequire\" name=\"CleaningReq\" [value]=\"false\">{{ 'LblNo' | translate }}</label>\r\n        </div>\r\n        <div class=\"form-group col-md-3\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblFualRequire' | translate }}</label>\r\n          <div class=\"clearfix\"></div>\r\n          <label class=\"radio-inline\">\r\n            <input type=\"radio\" [(ngModel)]=\"model.isFuelRequire\" name=\"FuelReq\" [value]=\"true\">{{ 'LblYes' | translate }}</label>\r\n          <label class=\"radio-inline\">\r\n            <input type=\"radio\" [(ngModel)]=\"model.isFuelRequire\" name=\"FuelReq\" [value]=\"false\">{{ 'LblNo' | translate }}</label>\r\n        </div>\r\n        <div class=\"form-group col-md-3\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblInvalidTagUsed' | translate }}</label>\r\n          <div class=\"clearfix\"></div>\r\n          <label class=\"radio-inline\">\r\n            <input type=\"radio\" [(ngModel)]=\"model.invalidTagUsed\" name=\"InvalidTagUsed\" [value]=\"true\">{{ 'LblYes' | translate }}</label>\r\n          <label class=\"radio-inline\">\r\n            <input type=\"radio\" [(ngModel)]=\"model.invalidTagUsed\" name=\"InvalidTagUsed\" [value]=\"false\">{{ 'LblNo' | translate }}</label>\r\n        </div>        \r\n        <div class=\"form-group col-md-6\">\r\n          <label>&nbsp;</label>\r\n          <div class=\"clearfix\"></div>\r\n\r\n        </div>\r\n\r\n      </fieldset>\r\n\r\n      <!--Report Damage-->\r\n      <fieldset class=\"row col-sm-12\">\r\n        <legend class=\"legendStyle\">{{ 'LblVehicleDamageList' | translate }}\r\n          <a class=\"btn btn-green btn-sm cursor-pointer pull-right\" style=\"margin-top: -6px; margin-right: 1px;\" (click)=\"ReportDamage(model.vehicleMasterHashId)\">\r\n            <i class=\"fa fa-car\"></i>&nbsp;{{ 'LblReportDamage' | translate }}</a>\r\n        </legend>\r\n        <div class=\"container-fluid\">\r\n          <div class=\"row\">\r\n            <template [ngIf]=\"DataListModel.totalItems == 0 && !isLoading\">\r\n              <div class=\"text-danger\" style=\"padding: 0px\">\r\n                <p class=\"text-center\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </p>\r\n              </div>\r\n            </template>\r\n            <div class=\"col-md-12\">\r\n              <div class=\"row\">\r\n                <div class=\"col-md-12\" *ngFor=\"let damage of damageReportList; let i = index\" [ngClass]=\"{'clear-div': i % 2 == 0}\">\r\n                  <div class=\"media\" style=\"border: 1px solid #ddd !important; min-height: 135px; padding: 15px; margin-bottom: 10px;\">\r\n                    <div class=\"media-left media-top\" style=\"min-width:155px; text-align:center;\">\r\n                      <a data-toggle=\"modal\" (click)=\"damageImagesModal.show(model.licenceTag,damage.reportDamageDatetime,damage.allImagePathList)\">\r\n                        <img *ngIf=\"damage.damagePath\" class=\"media-object\" [src]=\"damage.damagePath\" alt=\"No Image Available\" style=\"max-height: 100px; max-width: 150px; text-align: center; border: 1px solid;padding: 5px;\">\r\n                      </a>\r\n                      <label *ngIf=\"damage.damagePath\"> 1 / {{ damage.totalImages }}</label>\r\n                    </div>\r\n                    <div class=\"media-body\">\r\n                      <div class=\"form-group col-md-12\">\r\n                        <div class=\"col-md-3\">\r\n                          <label> {{ 'LblDamageReportedBy' | translate }} </label>\r\n                        </div>\r\n                        <div class=\"col-md-9\">\r\n                          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblDamageReportedBy' | translate }}\" [ngModel]=\"damage.reportedBy\"\r\n                            readonly>\r\n                        </div>\r\n                      </div>\r\n                      <div class=\"form-group col-md-12\">\r\n                        <div class=\"col-md-3\">\r\n                          <label> {{ 'LblDamageReportedOn' | translate }} </label>\r\n                        </div>\r\n                        <div class=\"col-md-9\">\r\n                          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblDamageReportedOn' | translate }}\" [ngModel]=\"damage.reportDamageDatetime\"\r\n                            readonly>\r\n                        </div>\r\n                      </div>\r\n                      <div *ngIf=\"damage.bookingReferenceID\" class=\"form-group col-md-12\">\r\n                        <div class=\"col-md-3\">\r\n                          <label> {{ 'LblBookingReferenceId' | translate }} </label>\r\n                        </div>\r\n                        <div class=\"col-md-9\">\r\n                          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblBookingReferenceId' | translate }}\" [ngModel]=\"damage.bookingReferenceID\"\r\n                            readonly>\r\n                        </div>\r\n                      </div>\r\n                      <div class=\"form-group col-md-12\">\r\n                        <div class=\"col-md-3\">\r\n                          <label> {{ 'LblDamageCause' | translate }} </label>\r\n                        </div>\r\n                        <div class=\"col-md-9\">\r\n                          <!--<input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblDamageCause' | translate }}\" [ngModel]=\"damage.reportDamageCause\"\r\n                            readonly>-->\r\n                          <textarea class=\"form-control\" [ngModel]=\"damage.reportDamageCause\" style=\"resize: vertical;\" readonly></textarea>\r\n                        </div>\r\n                      </div>\r\n                      <div class=\"form-group col-md-12\">\r\n                        <div class=\"col-md-3\">\r\n                          <label> {{ 'LblDamageDesc' | translate }} </label>\r\n                        </div>\r\n                        <div class=\"col-md-9\">\r\n                          <!--<input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblDamageDesc' | translate }}\" [ngModel]=\"damage.reportDamageParticularCause\"\r\n                            readonly>-->\r\n                          <textarea class=\"form-control\" [ngModel]=\"damage.reportDamageParticularCause\" style=\"resize: vertical;\" readonly></textarea>\r\n                        </div>\r\n                      </div>\r\n                    </div>\r\n                    <div *ngIf=\"!damage.isResolved\" class=\"media-right media-top\">\r\n                      <a class=\"btn btn-xs btn-default cursor-pointer\" title=\"{{'LblResolveDamge' | translate }}\" (click)=\"ShowConfirmModal(damage.reportDamageHashId)\">\r\n                        <i class=\"fa fa-thumbs-o-up fa-2x text-success\"></i>\r\n                      </a>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n              <div *ngIf=\"DataListModel.totalItems > 0\" class=\"col-md-12\">\r\n                <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                  [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                  lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </fieldset>\r\n    </div>\r\n  </section>\r\n  <div class=\"row no-margin\">\r\n    <div class=\"col-sm-12\">\r\n      <hr>\r\n      <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnBackClick()\">{{ 'LblBack' | translate }}</a>\r\n      <!--<a class=\"btn btn-green cursor-pointer\" (click)=\"UnLockVTSVehicle()\" *ngIf=\"(model.vehicleStatus == 'Unknown' || ( model.isLock || model.vehicleStatus == 'Unlock error' )) && !authService.IsGroupAdmin()\">\r\n        <i class=\"fa fa-unlock-alt\"></i>&nbsp;{{ 'LblUnLock' | translate }}</a>\r\n            <a class=\"btn btn-green cursor-pointer\" (click)=\"LockVTSVehicle()\" *ngIf=\"(model.isUnlock || model.vehicleStatus == 'Lock error') && !authService.IsGroupAdmin()\"><i class=\"fa fa-lock\"></i>&nbsp;{{ 'LblLock' | translate }}</a>-->\r\n      <!--<a class=\"btn btn-green cursor-pointer\" (click)=\"LockVehicle(model.bookingIdHashId, model.vehicleExchangeHashId)\" *ngIf=\"model.isUnlock && !model.isCancel && (!model.isBookingFinished) && (!model.isPending) && (model.isLock || model.isUnlock)\">\r\n        <i class=\"fa fa-unlock\"></i>&nbsp;{{ 'LblLockCarCompletely' | translate }}</a>-->\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<wego-confirm-popup #confirmModal [popupMsg]=\"confirmMsg\" (onConfirm)=\"ConfirmSuccessClick()\" (onReject)=\"HideConfirmModal()\"></wego-confirm-popup>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n\r\n<wego-success-popup #successPopupReport [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmReportSuccessPopup()\"></wego-success-popup>\r\n\r\n<wego-report-damage-popup #reportDamageModal (OnSuccessSelect)=\"SuccessReportDamage($event.SuccessMessage)\"></wego-report-damage-popup>\r\n<wego-image-slider #damageImageSliderModel [popupTitle]=\"popupTitle\"></wego-image-slider>";

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/no-image-available.5deb5512e9d3f4f96d51a9ee68980dcb.jpg";

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var reportdamage_model_1 = __webpack_require__(566);
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var report_damage_service_1 = __webpack_require__(567);
	var ReportDamagePopupComponent = (function () {
	    function ReportDamagePopupComponent(authService, router, translate, reportDamageService) {
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.reportDamageService = reportDamageService;
	        this.onSuccessSelect = new core_1.EventEmitter();
	    }
	    ReportDamagePopupComponent.prototype.ngOnInit = function () {
	        this.model = new reportdamage_model_1.ReportDamage();
	    };
	    ReportDamagePopupComponent.prototype.ngOnChanges = function (change) {
	        console.log(change);
	    };
	    ReportDamagePopupComponent.prototype.show = function () {
	        this.errorMsg = "";
	        this.errorModel = [];
	        this.model.damagecause = "";
	        this.model.damagedescription = "";
	        this.ClearFileInput();
	        this.reportDamageModal.show();
	    };
	    ReportDamagePopupComponent.prototype.hide = function () {
	        this.reportDamageModal.hide();
	    };
	    ReportDamagePopupComponent.prototype.OnSuccessSelect = function () {
	        this.hide();
	        var successMsg = this.translate.instant("LblReportDamageMsg");
	        this.onSuccessSelect.emit({ SuccessMessage: successMsg });
	    };
	    // public HandleOnAfterAddingFile(fileItem: any) {
	    //   if (this.uploader.queue.length > 1) {
	    //     this.uploader.queue.forEach(element => {
	    //       element.remove();
	    //     });
	    //   }
	    // }
	    ReportDamagePopupComponent.prototype.HandleOnBuildItemForm = function (fileItem, Form) {
	        Form.append("reportdamage", JSON.stringify(this.model));
	    };
	    ReportDamagePopupComponent.prototype.HandleOnCompleteItem = function (item, response, status, headers) {
	        var apiresponse = JSON.parse(response);
	        console.log(apiresponse);
	        if (status == 200) {
	            if (apiresponse.data) {
	                this.OnSuccessSelect();
	                console.log("Success");
	            }
	            else {
	                if (typeof apiresponse.error === "string") {
	                    this.errorMsg = apiresponse.error;
	                }
	                else {
	                    this.errorModel = apiresponse.error;
	                }
	            }
	        }
	        else {
	            this.errorMsg = this.authService.HandleErrorStatusCode(status);
	        }
	        this.isLoading = false;
	        this.ClearFileInput();
	    };
	    ReportDamagePopupComponent.prototype.ClearFileInput = function () {
	        // console.log(this.imageFile);
	        // if (this.imageFile.nativeElement) {
	        //   console.log(this.imageFile.nativeElement.value);
	        //   this.imageFile.nativeElement.value = "";
	        //   this.uploader.clearQueue();
	        // }
	    };
	    ReportDamagePopupComponent.prototype.HandleFileInput = function (files) {
	        this.fileToUpload = [];
	        for (var i = 0; i < files.length; i++) {
	            this.fileToUpload.push(files.item(i));
	        }
	    };
	    // public OnSubmit(forms: any) {
	    //   if (
	    //     this.uploader &&
	    //     this.uploader.queue &&
	    //     this.uploader.queue.length > 0
	    //   ) {
	    //     this.isLoading = true;
	    //     this.errorMsg = "";
	    //     this.uploader.uploadAll();
	    //   } else {
	    //     this.errorMsg = this.translate.instant("LblSelectFile");
	    //   }
	    // }
	    ReportDamagePopupComponent.prototype.UpdateReportDamage = function () {
	        var _this = this;
	        if (!this.fileToUpload) {
	            this.isLoading = false;
	            this.errorMsg = this.translate.instant("LblSelectFile");
	            return;
	        }
	        var formData = new FormData();
	        formData.append("reportdamage", JSON.stringify(this.model));
	        for (var index = 0; index < this.fileToUpload.length; index++) {
	            formData.append("file" + index, this.fileToUpload[index], this.fileToUpload[index].name);
	        }
	        this.reportDamageService.UpdateDamageReport(formData).subscribe(function (res) {
	            if (res.data) {
	                _this.OnSuccessSelect();
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            console.log(error);
	            _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    ReportDamagePopupComponent.prototype.OnCancel = function ($event) {
	        this.hide();
	    };
	    __decorate([
	        core_1.Output("OnSuccessSelect"), 
	        __metadata('design:type', Object)
	    ], ReportDamagePopupComponent.prototype, "onSuccessSelect", void 0);
	    __decorate([
	        core_1.ViewChild("reportDamageModal"), 
	        __metadata('design:type', Object)
	    ], ReportDamagePopupComponent.prototype, "reportDamageModal", void 0);
	    __decorate([
	        core_1.ViewChild("imageFile"), 
	        __metadata('design:type', Object)
	    ], ReportDamagePopupComponent.prototype, "imageFile", void 0);
	    ReportDamagePopupComponent = __decorate([
	        core_1.Component({
	            selector: "wego-report-damage-popup",
	            template: __webpack_require__(568),
	            providers: [report_damage_service_1.ReportDamageService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _c) || Object, (typeof (_d = typeof report_damage_service_1.ReportDamageService !== 'undefined' && report_damage_service_1.ReportDamageService) === 'function' && _d) || Object])
	    ], ReportDamagePopupComponent);
	    return ReportDamagePopupComponent;
	    var _a, _b, _c, _d;
	}());
	exports.ReportDamagePopupComponent = ReportDamagePopupComponent;


/***/ },
/* 566 */
/***/ function(module, exports) {

	"use strict";
	var ReportDamage = (function () {
	    function ReportDamage() {
	    }
	    return ReportDamage;
	}());
	exports.ReportDamage = ReportDamage;


/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var Observable_1 = __webpack_require__(5);
	var config_1 = __webpack_require__(60);
	var auth_service_1 = __webpack_require__(58);
	var http_1 = __webpack_require__(59);
	var ReportDamageService = (function () {
	    function ReportDamageService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    ReportDamageService.prototype.UpdateDamageReport = function (formData) {
	        var _this = this;
	        return Observable_1.Observable.create(function (observer) {
	            var url = config_1.WeGoConfig.API_REPORT_DAMAGE;
	            var xhr = new XMLHttpRequest();
	            var header = _this.authService.GetHeaderForFile();
	            xhr.onreadystatechange = function () {
	                if (xhr.readyState === 4) {
	                    if (xhr.status === 200) {
	                        console.log(xhr.response);
	                        observer.next(JSON.parse(xhr.response));
	                        observer.complete();
	                    }
	                    else {
	                        observer.error(xhr.status);
	                    }
	                }
	            };
	            xhr.open("POST", url, true);
	            for (var i = 0; i < header.length; i++) {
	                xhr.setRequestHeader(header[i]["name"], header[i]["value"]);
	            }
	            xhr.send(formData);
	        });
	    };
	    ReportDamageService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], ReportDamageService);
	    return ReportDamageService;
	    var _a, _b;
	}());
	exports.ReportDamageService = ReportDamageService;


/***/ },
/* 568 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #reportDamageModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n                    <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblReportDamage' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <form (ngSubmit)=\"UpdateReportDamage()\" #ReportDamageForm=\"ngForm\">\r\n          <div class=\"form-group row\">\r\n            <div class=\"col-sm-3\"><span class=\"text text-danger\">*</span> {{ 'LblDamageFile' | translate }}</div>\r\n            <div class=\"col-sm-9\">\r\n              <input #imageFile id=\"damageFile\" (change)=\"HandleFileInput($event.target.files)\" type=\"file\" accept=\"image/x-png,image/png,image/gif,image/jpeg\" multiple=\"multiple\" />\r\n              <div class=\"text text-danger \">{{ errorMsg }}</div>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-group row\">\r\n            <div class=\"col-sm-3\"><span class=\"text text-danger\">*</span> {{ 'LblDescribe' | translate }}</div>\r\n            <div class=\"col-sm-9\">\r\n              <textarea class=\"form-control\" rows=\"2\" [(ngModel)]=\"model.damagedescription\" name=\"damagedescription\"></textarea>\r\n              <div class=\"text text-danger \">{{ errorModel | serverErrorMessage : 'damagedescription' }}</div>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-group row\">\r\n            <div class=\"col-sm-3\"><span class=\"text text-danger\">*</span> {{ 'LblCause' | translate }}</div>\r\n            <div class=\"col-sm-9\">\r\n              <textarea class=\"form-control\" rows=\"2\" [(ngModel)]=\"model.damagecause\" name=\"damagecause\"></textarea>\r\n              <div class=\"text text-danger \">{{ errorModel | serverErrorMessage : 'damagecause' }}</div>\r\n            </div>\r\n          </div>\r\n          <hr>\r\n          <div class=\"form-group row\">\r\n            <div class=\"col-sm-12\">\r\n              <button type=\"submit\" class=\"btn btn-green\">{{ 'LblCompleteDamageReport' | translate }}</button>\r\n              <button type=\"button\" class=\"btn btn-gray\" (click)=\"OnCancel($event)\">{{ 'LblCancel' | translate }}</button>\r\n            </div>\r\n          </div>\r\n        </form>\r\n        <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var vehicle_service_1 = __webpack_require__(530);
	var driver_service_1 = __webpack_require__(570);
	var sharedvehiclegroup_service_1 = __webpack_require__(510);
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var common_1 = __webpack_require__(22);
	var SVGDriverComponent = (function () {
	    function SVGDriverComponent(sharedVehicleService, driverService, vehicleService, activeRoute, router, authService, translate, locationService) {
	        this.sharedVehicleService = sharedVehicleService;
	        this.driverService = driverService;
	        this.vehicleService = vehicleService;
	        this.activeRoute = activeRoute;
	        this.router = router;
	        this.authService = authService;
	        this.translate = translate;
	        this.locationService = locationService;
	        this.sharedVehicleGroupHashId = "";
	    }
	    Object.defineProperty(SVGDriverComponent.prototype, "isAnyChecked", {
	        get: function () {
	            if (this.driverList) {
	                var isCheck = this.driverList.some(function (x) { return x.isChecked == true; });
	                if (isCheck) {
	                    if (this.driverList.every(function (x) { return x.isChecked == true; }))
	                        this.isParentCheck = true;
	                    else
	                        this.isParentCheck = false;
	                }
	                else {
	                    this.isParentCheck = false;
	                }
	                return isCheck;
	            }
	            else {
	                this.isParentCheck = false;
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SVGDriverComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.module = this.translate.instant('LblDriver');
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = ["driverName", "firstName", "lastName"];
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlSVGList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SVG_LIST);
	        this.activeRoute
	            .params
	            .subscribe(function (params) {
	            var sharedVehicleGroupHashId = params['sharedVehicleGroupHashId'] || '';
	            if (sharedVehicleGroupHashId != '') {
	                _this.sharedVehicleGroupHashId = sharedVehicleGroupHashId;
	                _this.GetGroupDriverList();
	                _this.GetSharedVehicleGropuDetailsByHashId();
	            }
	        });
	    };
	    SVGDriverComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.vehicleService.ExportSVGDriverList(null, this.sharedVehicleGroupHashId, this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "SharedVehicleGroupDrivers" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	        ;
	    };
	    SVGDriverComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetGroupDriverList();
	    };
	    SVGDriverComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetGroupDriverList();
	    };
	    SVGDriverComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetGroupDriverList();
	    };
	    ;
	    SVGDriverComponent.prototype.OnPagingChange = function (event) {
	        console.log(this.DataListModel);
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetGroupDriverList();
	    };
	    SVGDriverComponent.prototype.OnParentCheck = function (isChecked) {
	        this.driverList.forEach(function (x) { return x.isChecked = isChecked; });
	    };
	    SVGDriverComponent.prototype.GetGroupDriverList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.sharedVehicleService.GetSVGDriverList(this.sharedVehicleGroupHashId, "", "", this.DataListModel)
	            .subscribe(function (res) {
	            _this.driverList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SVGDriverComponent.prototype.GetSharedVehicleGropuDetailsByHashId = function () {
	        var _this = this;
	        this.sharedVehicleService.GetSharedVehicleGroupBasicDetail(this.sharedVehicleGroupHashId)
	            .subscribe(function (res) {
	            _this.groupName = res.data.entityName;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SVGDriverComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    SVGDriverComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-svgdriver-list',
	            template: __webpack_require__(571),
	            providers: [sharedvehiclegroup_service_1.SharedVehicleGroupService, driver_service_1.DriverService, vehicle_service_1.VehicleService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof sharedvehiclegroup_service_1.SharedVehicleGroupService !== 'undefined' && sharedvehiclegroup_service_1.SharedVehicleGroupService) === 'function' && _a) || Object, (typeof (_b = typeof driver_service_1.DriverService !== 'undefined' && driver_service_1.DriverService) === 'function' && _b) || Object, (typeof (_c = typeof vehicle_service_1.VehicleService !== 'undefined' && vehicle_service_1.VehicleService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object, (typeof (_e = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _e) || Object, (typeof (_f = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _f) || Object, (typeof (_g = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _g) || Object, (typeof (_h = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _h) || Object])
	    ], SVGDriverComponent);
	    return SVGDriverComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h;
	}());
	exports.SVGDriverComponent = SVGDriverComponent;


/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var DriverService = (function () {
	    function DriverService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    DriverService.prototype.GetDriverList = function (input, permissionName) {
	        var getDriverUrl = config_1.WeGoConfig.API_GET_DRIVER_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getDriverUrl = getDriverUrl + '?' + queryString;
	            getDriverUrl = getDriverUrl + '&permissionName' + permissionName;
	        }
	        else {
	            getDriverUrl = getDriverUrl + '?permissionName' + permissionName;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getDriverUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    DriverService.prototype.ExportDriverList = function (input) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var getDriverUrl = config_1.WeGoConfig.API_EXPORT_DRIVER_LIST + '?' + queryString;
	        var headers = this.authService.GetHeader('text/csv');
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getDriverUrl, options);
	    };
	    DriverService.prototype.GetActiveDriverList = function (input, forSnailTrailReport, permissionName) {
	        if (forSnailTrailReport === void 0) { forSnailTrailReport = false; }
	        var getDriverUrl = config_1.WeGoConfig.API_GET_ACTIVE_DRIVER_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getDriverUrl =
	                getDriverUrl +
	                    '?' +
	                    queryString +
	                    '&ForSnailTrailReport=' +
	                    forSnailTrailReport +
	                    '&permissionName' +
	                    permissionName;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getDriverUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    DriverService.prototype.GetDriverSVGList = function (driverHashId, input) {
	        var getDriverUrl = config_1.WeGoConfig.API_GET_DRIVER_SVG_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getDriverUrl =
	                getDriverUrl + '?' + queryString + '&driverHashId=' + driverHashId;
	        }
	        else {
	            getDriverUrl = getDriverUrl + '?driverHashId=' + driverHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getDriverUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    DriverService.prototype.ExportDriverSVGList = function (driverHashId) {
	        var getInstanceUrl = config_1.WeGoConfig.API_EXPORT_DRIVER_SVG_LIST + '?driverHashId=' + driverHashId;
	        var headers = this.authService.GetHeader('text/csv');
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getInstanceUrl, options);
	    };
	    DriverService.prototype.GetDriverByHashId = function (driverHashId) {
	        var getDriverUrl = config_1.WeGoConfig.API_GET_DRIVER_BY_HASH + '?driverHashId=' + driverHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getDriverUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    DriverService.prototype.GetPersonListForDrivers = function (input) {
	        //This Method is unused and removed form API side
	        var getPersonUrl = config_1.WeGoConfig.API_GET_PERSON_LIST_BY_PERSON_ID;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getPersonUrl = getPersonUrl + '?' + queryString;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getPersonUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    DriverService.prototype.AddNewDriver = function (driverModel) {
	        var body = driverModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_DRIVER_DETAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    // public DeleteDriver(selectedDriverList: string[]): Observable<IAPIResponse> {
	    //   let headers = this.authService.GetHeader();
	    //   let options = new RequestOptions({ headers: headers });
	    //   return this.http.post(WeGoConfig.API_POST_DELETE_DRIVER_LIST, selectedDriverList, options)
	    //     .map(this.authService.HandleAPIResponse)
	    //     .catch(this.authService.HandleAPIError);
	    // }
	    DriverService.prototype.UnsubscribeDriverSVG = function (sharedVehicleGroupDriverHashId, affectedDateTime) {
	        var getDriverUrl = config_1.WeGoConfig.API_GET_UNSUBSCRIBE_DRIVER_SVG +
	            '?sharedVehicleGroupDriverHashId=' +
	            sharedVehicleGroupDriverHashId +
	            '&affectedDateTime=' +
	            affectedDateTime;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getDriverUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    DriverService.prototype.AssignSVGToDriver = function (SVGdriverModel) {
	        var body = SVGdriverModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_SVG_DRIVER_DETAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    DriverService.prototype.InActiveDriver = function (driverBlockModel) {
	        var body = driverBlockModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_DRIVER_INACTIVE, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    DriverService.prototype.RemoveDriverLicenseBirthDate = function (driverBlockModel) {
	        var body = driverBlockModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        var urlRemoveDriverLicense = config_1.WeGoConfig.API_POST_DRIVER_REMOVELICENSEBIRTHDATE;
	        return this.http
	            .post(urlRemoveDriverLicense, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    DriverService.prototype.CheckBookingInRunningStage = function (sharedVehicleGroupHashId, driverHashId) {
	        var getBookingRunningStageURL = config_1.WeGoConfig.API_CHECK_BOOKING_RUNNING_STATUS;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        getBookingRunningStageURL =
	            getBookingRunningStageURL +
	                '?sharedVehicleGroupHashId=' +
	                sharedVehicleGroupHashId +
	                '&driverHashId=' +
	                driverHashId;
	        return this.http
	            .get(getBookingRunningStageURL, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    DriverService.prototype.GetAffectedSubscriptionBookingList = function (sharedVehicleGroupDriverHashId, affectedDateTime, input) {
	        var getBookingOverviewUrl = config_1.WeGoConfig.API_GET_AFFECTED_SUBSCRIPTION_BOOKING;
	        var queryStringDataListModel = this.authService.HandleAPIListInput(input);
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        getBookingOverviewUrl =
	            getBookingOverviewUrl +
	                '?sharedVehicleGroupDriverHashId=' +
	                sharedVehicleGroupDriverHashId +
	                '&affectedDateTime=' +
	                affectedDateTime +
	                '&' +
	                queryStringDataListModel;
	        return this.http
	            .get(getBookingOverviewUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    DriverService.prototype.GetDriversSubscriptionDetail = function (input) {
	        var getSubscriptionUrl = config_1.WeGoConfig.API_GET_DRIVER_SUBSCRIPTION_DETAIL;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getSubscriptionUrl = getSubscriptionUrl + '?' + queryString;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getSubscriptionUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    DriverService.prototype.ExportDriverSubscriptionList = function (input) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var getDriverUrl = config_1.WeGoConfig.API_EXPORT_DRIVER_SUBSCRIPTION_LIST + '?' + queryString;
	        var headers = this.authService.GetHeader('text/csv');
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getDriverUrl, options);
	    };
	    DriverService.prototype.GetDriverSubscriptionDetail = function (driverSubscriptionHashId) {
	        var getSubscriptionUrl = config_1.WeGoConfig.API_GET_SUBSCRIPTION_DETAIL_BY_SVGDRIVER_HASH +
	            '?driverSubscriptionHashId=' +
	            driverSubscriptionHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getSubscriptionUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    DriverService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], DriverService);
	    return DriverService;
	    var _a, _b;
	}());
	exports.DriverService = DriverService;


/***/ },
/* 571 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ 'LblSVGDriversList' | translate }} {{ 'LblList' | translate }} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li><a [routerLink]=\"urlDefaultPage\"><i class=\"fa fa-dashboard\"></i>{{ 'LblHome' | translate }}</a></li>\r\n        <li><a [routerLink]=\"urlSVGList\"><i class=\"fa fa-group fa-fw\"></i> {{ 'LblSharedVehicleGroup' | translate }} {{ 'LblList' | translate }}</a></li>\r\n        <li class=\"active\"> {{ 'LblSVGDriversList' | translate }} {{ 'LblList' | translate }}</li>\r\n      </ol>\r\n    </div>\r\n    <!--<div class=\"col-md-3 col-sm-6 mar_t_25 \">\r\n      <a class=\"btn btn-highlight navbar-right\" (click)=\"ShowAssignVehicleGroupModal()\">{{ 'LblAddNew' | translate }}</a>\r\n    </div>-->\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <h4><label>{{ 'LblSharedVehicleGroup' | translate }} : </label> {{groupName}}</h4>\r\n        <p class=\"text-success\">{{ message }}</p>\r\n        <wego-search-list [IsDeleted]=\"false\" [IsDeleteEnabled]=\"isAnyChecked\" [IsExported]=\"false\" (OnDeleteAll)=\"ShowDeleteModal()\"\r\n          (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\"\r\n          [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <!--<th class=\"text-center parent-checkbox\"><input type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\"></th>-->\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('firstName')\">\r\n                  {{ 'LblFirstName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'firstName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('lastName')\">\r\n                  {{ 'LblLastName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'lastName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('driverName')\">\r\n                  {{ 'LblDriver' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'driverName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let driver of driverList\" >\r\n                  <!--<td class=\"text-center\"><input type=\"checkbox\" name=\"isActive\" [(ngModel)]=\"driver.isChecked\"></td>-->\r\n                  <td>{{ driver.firstName }}</td>\r\n                  <td>{{ driver.lastName }}</td>\r\n                  <td>{{ driver.driverName }}</td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"4\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<div [hidden]=\"!isLoading\" class=\"my-loading\">\r\n  <div class=\"dimmer\"></div>\r\n  <div class=\"loading-bg\">\r\n    <i class=\"fa fa-refresh fa-spin fa-3x fa-fw\"></i>\r\n  </div>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>";

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var flatpickr_model_1 = __webpack_require__(83);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var booking_service_1 = __webpack_require__(556);
	var booking_overviewlist_model_1 = __webpack_require__(573);
	var config_1 = __webpack_require__(60);
	var search_booking_model_1 = __webpack_require__(574);
	var moment = __webpack_require__(84);
	var BookingOverviewDriverComponent = (function () {
	    function BookingOverviewDriverComponent(authService, bookingService, router, translate) {
	        this.authService = authService;
	        this.bookingService = bookingService;
	        this.router = router;
	        this.translate = translate;
	        this.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
	        this.model = new booking_overviewlist_model_1.BookingOverviewList();
	        this.remarkslength = 15;
	        this.bookingSearchModel = new search_booking_model_1.SearchBookingModel();
	        this.isAllowInitialPaymentValue = false;
	    }
	    Object.defineProperty(BookingOverviewDriverComponent.prototype, "isAnyChecked", {
	        get: function () {
	            if (this.bookingList) {
	                var isCheck = this.bookingList.some(function (x) { return x.isChecked == true; });
	                if (isCheck) {
	                    if (this.bookingList
	                        .filter(function (y) {
	                        return (y.bookingStatus == config_1.BookingStatus.CONFIRMED ||
	                            y.bookingStatus == config_1.BookingStatus.PENDING) &&
	                            y.bookingType == config_1.BookingType.NORMAL &&
	                            y.startDateTime >
	                                moment()
	                                    .utc()
	                                    .format('DD-MM-YYYY HH:mm');
	                    })
	                        .every(function (x) { return x.isChecked == true; }))
	                        this.isParentCheck = true;
	                    else
	                        this.isParentCheck = false;
	                }
	                else {
	                    this.isParentCheck = false;
	                }
	                return isCheck;
	            }
	            else {
	                this.isParentCheck = false;
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BookingOverviewDriverComponent.prototype.ngOnInit = function () {
	        this.module = this.translate.instant('LblBooking');
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = [
	            'licenceTag',
	            'translatedBookingStatus',
	            'bookingReferenceID'
	        ];
	        this.model = new booking_overviewlist_model_1.BookingOverviewList();
	        this.model.startDateTime = moment().format('DD-MM-YYYY 00:00');
	        this.model.endDateTime = moment()
	            .add(+1, 'M')
	            .format('DD-MM-YYYY 00:00');
	        this.model = this.authService.AssignFromStorage(this.constructor.name + '_model', this.model);
	        console.log(this.model);
	        this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
	        this.urlBooking = this.authService.GetURL(config_1.ApplicationRouteURL.URL_BOOKING);
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlBooking = this.authService.GetURL(config_1.ApplicationRouteURL.URL_BOOKING);
	        this.urlBookingInformation = this.authService.GetURL(config_1.ApplicationRouteURL.URL_BOOKING_INFORMATION);
	        this.urlDriverBookingInformation = this.authService.GetURL(config_1.ApplicationRouteURL.URL_BOOKING_INFORMATION_DRIVER);
	        this.GetBookingOverview();
	    };
	    BookingOverviewDriverComponent.prototype.SetDefaultFlatPickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = true;
	        flatPickrConfig.time_24hr = true;
	        //flatPickrConfig.enableSeconds = true;
	        flatPickrConfig.dateFormat = this.dateFormat;
	        flatPickrConfig.minuteIncrement = 1;
	        return flatPickrConfig;
	    };
	    BookingOverviewDriverComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetBookingOverview();
	    };
	    BookingOverviewDriverComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        if (event.isReset) {
	            this.model.startDateTime = moment().format('DD-MM-YYYY 00:00');
	            this.model.endDateTime = moment()
	                .add(+1, 'M')
	                .format('DD-MM-YYYY 00:00');
	        }
	        this.GetBookingOverview();
	    };
	    BookingOverviewDriverComponent.prototype.OnDateSearch = function () {
	        this.GetBookingOverview();
	    };
	    BookingOverviewDriverComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetBookingOverview();
	    };
	    BookingOverviewDriverComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.bookingService
	            .ExportBokingList(this.model, this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = 'Booking' + new Date().toISOString() + '.csv';
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BookingOverviewDriverComponent.prototype.GetBookingOverview = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.bookingService
	            .GetBookingOverviewList(this.model, this.DataListModel)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.bookingList = res.data;
	                _this.isParentCheckEnable =
	                    _this.bookingList.filter(function (x) { return x.isBookingCancel; }).length > 0
	                        ? true
	                        : false;
	                _this.DataListModel.totalItems = res.totalRecords;
	                _this.DataListModel.infoMessage = res.error;
	                _this.isLoading = false;
	                _this.errorModel = null;
	            }
	            else {
	                _this.DataListModel.totalItems = res.totalRecords;
	                _this.DataListModel.infoMessage = _this.translate.instant('LblNoRecords');
	                _this.errorModel = res.error;
	                _this.bookingList = null;
	                _this.isLoading = false;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BookingOverviewDriverComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetBookingOverview();
	    };
	    BookingOverviewDriverComponent.prototype.OnParentCheck = function (isChecked) {
	        this.bookingList
	            .filter(function (y) {
	            return (y.bookingStatus == config_1.BookingStatus.CONFIRMED ||
	                y.bookingStatus == config_1.BookingStatus.PENDING) &&
	                y.bookingType == config_1.BookingType.NORMAL &&
	                y.startDateTime >
	                    moment()
	                        .utc()
	                        .format('DD-MM-YYYY HH:mm');
	        })
	            .forEach(function (x) { return (x.isChecked = isChecked); });
	    };
	    BookingOverviewDriverComponent.prototype.onSubmit = function (forms) {
	        //this.model.listOfBookingHashId = this.bookingList.filter(x => x.isChecked).map(x => x.bookingHashId);
	        this.CancelBookings(JSON.stringify(this.model));
	    };
	    BookingOverviewDriverComponent.prototype.CancelBookings = function (formData) {
	        var _this = this;
	        this.isLoading = true;
	        this.bookingService.CancelBookings(formData).subscribe(function (res) {
	            if (res.data) {
	                _this.DataListModel.currentPage = 1;
	                _this.GetBookingOverview();
	                _this.cancelModal.hide();
	                _this.isLoading = false;
	                _this.popupMsg = _this.translate.instant('LblBookingCancelSuccess', [
	                    _this.module
	                ]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.errorModel = res.error;
	                _this.isLoading = false;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BookingOverviewDriverComponent.prototype.ShowCancelModal = function (bookingReferenceId) {
	        this.model.remarks = null;
	        this.errorModel = null;
	        this.model.listOfBookingHashId = [];
	        this.model.listOfBookingHashId.push(bookingReferenceId);
	        this.cancelModal.show();
	    };
	    BookingOverviewDriverComponent.prototype.HideCancelModal = function () {
	        this.cancelModal.hide();
	    };
	    BookingOverviewDriverComponent.prototype.SuccessCancelModalClick = function () {
	        this.cancelModal.hide();
	    };
	    BookingOverviewDriverComponent.prototype.onSubmitAbortRevoke = function (forms) {
	        this.RevokeAbortBooking(JSON.stringify(this.model));
	    };
	    BookingOverviewDriverComponent.prototype.RevokeAbortBooking = function (formData) {
	        var _this = this;
	        this.isLoading = true;
	        this.bookingService.RevokeOrAbortBookings(formData).subscribe(function (res) {
	            if (res.data) {
	                _this.DataListModel.currentPage = 1;
	                _this.GetBookingOverview();
	                _this.revokeAborkModal.hide();
	                _this.isLoading = false;
	                _this.popupMsg =
	                    _this.popupMessage == config_1.BookingStatus.ABORTED
	                        ? _this.translate.instant('LblBookingAbortSuccess')
	                        : _this.translate.instant('LblBookingRevokeSuccess');
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.errorModel = res.error;
	                _this.isLoading = false;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BookingOverviewDriverComponent.prototype.ShowAbort = function (bookingHashId, bookingStatus) {
	        this.model.remarks = null;
	        this.model.bookingHashId = bookingHashId;
	        this.model.bookingStatus = config_1.BookingStatus.ABORTED;
	        this.popupMessage = config_1.BookingStatus.ABORTED;
	        this.errorModel = null;
	        this.revokeAborkModal.show();
	    };
	    BookingOverviewDriverComponent.prototype.ShowRevoke = function (bookingHashId, bookingStatus) {
	        this.model.remarks = null;
	        this.model.bookingHashId = bookingHashId;
	        this.model.bookingStatus = config_1.BookingStatus.REVOKED;
	        this.popupMessage = config_1.BookingStatus.REVOKED;
	        this.errorModel = null;
	        this.revokeAborkModal.show();
	    };
	    BookingOverviewDriverComponent.prototype.HideRevokeAbortModal = function () {
	        this.revokeAborkModal.hide();
	    };
	    BookingOverviewDriverComponent.prototype.SuccessRevokeAbortModal = function () {
	        this.revokeAborkModal.hide();
	    };
	    //Addedd for remarksModal
	    BookingOverviewDriverComponent.prototype.ShowRemakrsModal = function (remarks) {
	        this.remarks = remarks;
	        this.remarksModal.show();
	    };
	    BookingOverviewDriverComponent.prototype.HideRemarksModal = function () {
	        this.remarks = null;
	        this.remarksModal.hide();
	    };
	    //Addedd for edit recurringbooking
	    BookingOverviewDriverComponent.prototype.ShowBookingModal = function (isRecurringSeriesEditable, bookingHashId, recurringID) {
	        if (isRecurringSeriesEditable) {
	            if (bookingHashId)
	                this.bookingHashId = bookingHashId;
	            if (recurringID)
	                this.recurringId = recurringID;
	            this.editBookingModal.show();
	        }
	        else {
	            this.router.navigate([
	                this.urlBooking,
	                { ref: this.recurringId, isRecurring: true }
	            ]);
	        }
	    };
	    BookingOverviewDriverComponent.prototype.SuccessSingleBooking = function () {
	        this.editBookingModal.hide();
	        this.router.navigate([
	            this.urlBooking,
	            { ref: this.bookingHashId, isRecurring: false }
	        ]);
	    };
	    BookingOverviewDriverComponent.prototype.SuccessRecurringBooking = function () {
	        this.editBookingModal.hide();
	        this.router.navigate([
	            this.urlBooking,
	            { ref: this.recurringId, isRecurring: true }
	        ]);
	    };
	    BookingOverviewDriverComponent.prototype.HideBookingModal = function () {
	        this.editBookingModal.hide();
	    };
	    BookingOverviewDriverComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    BookingOverviewDriverComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    BookingOverviewDriverComponent.prototype.OnPayment = function (bookingHashId) {
	        var _this = this;
	        this.isLoading = true;
	        this.bookingHashId = bookingHashId;
	        this.bookingService
	            .ConfirmRecurringPaymentBooking(bookingHashId, this.recurringId)
	            .subscribe(function (res) {
	            _this.isLoading = false;
	            if (res.data) {
	                if (res.data.askForInitialPayment) {
	                    _this.popupDescription = _this.translate.instant('LblPaymentDescription', [res.data.initialPaymentAmount]);
	                    if (res.data.isPaymentSuccess || res.data.isFirstTimePayment) {
	                        _this.initialPaymentPopupTitle = _this.translate.instant('LblFirstBooking');
	                    }
	                    else {
	                        _this.initialPaymentPopupTitle = _this.translate.instant('LblPaymentFailed');
	                    }
	                    _this.isAllowInitialPaymentValue = false;
	                    _this.creditCardPaymentModal.show();
	                }
	                else if (!res.data.askForInitialPayment &&
	                    res.data.isPaymentSuccess) {
	                    _this.isLoading = true;
	                    //call api
	                    _this.bookingService
	                        .UpdateBookingAfterSuccessfulPayment(_this.bookingHashId)
	                        .subscribe(function (res) {
	                        _this.isLoading = false;
	                        _this.DataListModel.currentPage = 1;
	                        _this.GetBookingOverview();
	                        _this.popupMsg = res.data;
	                        _this.ShowSuccessPopup();
	                    });
	                }
	                else {
	                }
	            }
	            else {
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.popupMsg = res.error;
	                _this.isSuccess = false;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BookingOverviewDriverComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    BookingOverviewDriverComponent.prototype.GetInitialPaymentValue = function (isAllowInitialPayment) {
	        this.isAllowInitialPaymentValue = isAllowInitialPayment;
	    };
	    BookingOverviewDriverComponent.prototype.ConfirmInitialPayment = function () {
	        var _this = this;
	        this.isLoading = true;
	        if (this.isAllowInitialPaymentValue == false) {
	            this.isLoading = false;
	            var errorMessage = this.translate.instant('LblCheckAllowPayment');
	            this.errorMessage = errorMessage + ':' + Date.now().toString();
	        }
	        else {
	            this.bookingSearchModel.bookingMasterHashId = this.bookingHashId;
	            this.bookingSearchModel.isFromMobileSide = false;
	            this.bookingService
	                .StartInitialPayment(this.bookingSearchModel)
	                .subscribe(function (res) {
	                if (res.data.redirectURL) {
	                    _this.isLoading = false;
	                    window.location.href = res.data.redirectURL;
	                }
	                else {
	                    _this.isLoading = false;
	                    _this.creditCardPaymentModal.hide();
	                    _this.popupMsg = res.error;
	                    _this.ShowSuccessPopup();
	                }
	            });
	        }
	    };
	    BookingOverviewDriverComponent.prototype.GetImageURL = function (imagePath) {
	        return config_1.WeGoConfig.API_SERVER_URL + imagePath;
	    };
	    BookingOverviewDriverComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	        this.authService.SaveToStorage(this.constructor.name + '_model', this.model);
	    };
	    __decorate([
	        core_1.ViewChild('cancelModal'), 
	        __metadata('design:type', Object)
	    ], BookingOverviewDriverComponent.prototype, "cancelModal", void 0);
	    __decorate([
	        core_1.ViewChild('revokeAborkModal'), 
	        __metadata('design:type', Object)
	    ], BookingOverviewDriverComponent.prototype, "revokeAborkModal", void 0);
	    __decorate([
	        core_1.ViewChild('remarksModal'), 
	        __metadata('design:type', Object)
	    ], BookingOverviewDriverComponent.prototype, "remarksModal", void 0);
	    __decorate([
	        core_1.ViewChild('EditBookingModal'), 
	        __metadata('design:type', Object)
	    ], BookingOverviewDriverComponent.prototype, "editBookingModal", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], BookingOverviewDriverComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild('creditCardPaymentModal'), 
	        __metadata('design:type', Object)
	    ], BookingOverviewDriverComponent.prototype, "creditCardPaymentModal", void 0);
	    BookingOverviewDriverComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-booking-overview-driver',
	            template: __webpack_require__(575),
	            providers: [booking_service_1.BookingService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof booking_service_1.BookingService !== 'undefined' && booking_service_1.BookingService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object])
	    ], BookingOverviewDriverComponent);
	    return BookingOverviewDriverComponent;
	    var _a, _b, _c, _d;
	}());
	exports.BookingOverviewDriverComponent = BookingOverviewDriverComponent;


/***/ },
/* 573 */
/***/ function(module, exports) {

	"use strict";
	var BookingOverviewList = (function () {
	    function BookingOverviewList() {
	        this.sharedVehicleGroupHashId = '';
	        this.vehicleHashId = '';
	        this.bookingHashId = '';
	        this.bookingType = '';
	        this.bookingStatus = '';
	        this.listOfBookingHashId = [];
	        this.sharedVehicleGroupHashIdList = [];
	        this.vehicleHashIdList = [];
	        this.driverHashIdList = [];
	        this.bookingStatusList = [''];
	        this.bookingTypeList = [''];
	        this.adminHashIdList = [];
	        this.searchAdminNameList = [];
	        this.searchLicenceTagList = [];
	        this.searchDriverNameList = [];
	        this.searchSVGNameList = [];
	        this.applyDateFilter = true;
	        this.isDeletable = true;
	    }
	    return BookingOverviewList;
	}());
	exports.BookingOverviewList = BookingOverviewList;


/***/ },
/* 574 */
/***/ function(module, exports) {

	"use strict";
	var SearchBookingModel = (function () {
	    function SearchBookingModel() {
	        this.isRecurring = false;
	        this.recurringPeriod = 'DAILY';
	        this.isEditMode = false;
	        this.isSpecialPeriod = false;
	        this.isRecurringBookingAllow = false;
	        this.organizationIdHashID = '';
	        this.organizationList = [];
	        // public dayStartDate: string;
	        // public dayEndDate: string;
	        // public weekendContainingDate: string;
	        this.specialPeriodType = 'regular';
	        this.isRegularbooking = true;
	    }
	    return SearchBookingModel;
	}());
	exports.SearchBookingModel = SearchBookingModel;


/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<section class=\"banner-img-in\">\r\n  <div class=\"banner-in\">\r\n    <div class=\"search-bg-in\">\r\n      <div class=\"container-fluid\">\r\n        <div class=\"row\" style=\"padding-right:15px;\">\r\n          <div class=\"col-md-3 col-sm-6\">\r\n            <h2 class=\"pagename\">{{ 'LblOverview' | translate }}</h2>\r\n          </div>\r\n          <div class=\"col-md-5 col-sm-6\">\r\n            <div class=\"row\" style=\"margin-top:10px;\">\r\n              <div class=\"form-group col-md-5\">\r\n                <label for=\"from\">{{ 'LblFrom' | translate }}</label>\r\n                <div class=\"input-group\">\r\n                  <span class=\"input-group-addon\">\r\n                    <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n                  </span>\r\n                  <input flatpickr readonly [Config]=\"flatPickrConfigFrom\" [(ngModel)]=\"model.startDateTime\" name=\"TimeBlockStartDate\" type=\"text\"\r\n                    class=\"form-control\" placeholder=\"{{ 'LblFrom' | translate }}\">\r\n                </div>\r\n              </div>\r\n              <div class=\"form-group col-md-5\">\r\n                <label for=\"to\">{{ 'LblTo' | translate }}</label>\r\n                <div class=\"input-group\">\r\n                  <span class=\"input-group-addon\">\r\n                    <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n                  </span>\r\n                  <input flatpickr readonly [Config]=\"flatPickrConfigTo\" [(ngModel)]=\"model.endDateTime\" name=\"TimeBlockStartDate\" type=\"text\"\r\n                    class=\"form-control\" placeholder=\"{{ 'LblTo' | translate }}\">\r\n                </div>\r\n              </div>\r\n              <div class=\"form-group col-md-2\">\r\n                <label>\r\n                  <span class=\"text text-danger\">&nbsp;</span>\r\n                </label>\r\n                <div class=\"clearfix\"></div>\r\n                <button class=\"btn btn-success\" (click)=\"OnDateSearch()\">{{ 'LblSearch' | translate}}</button>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"col-md-4 navbar-right\">\r\n            <div class=\"form-space-top pull-right\">\r\n              <wego-driver-search-list (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\"\r\n                [SearchTerm]=\"DataListModel.searchTerm\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-driver-search-list>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n<div class=\"clearfix\"></div>\r\n<section>\r\n  <div class=\"container-fluid\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\" style=\"margin-top:20px;\">\r\n        <template [ngIf]=\"DataListModel.totalItems == 0 && !isLoading\">\r\n          <div class=\"alert alert-danger\">\r\n            <p class=\"text-center\">\r\n              {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n            </p>\r\n          </div>\r\n        </template>\r\n        <div class=\"row\">\r\n          <div class=\"col-md-6\" *ngFor=\"let bookings of bookingList\">\r\n            <div class=\"hp-listing\" style=\"word-break: break-word;\">\r\n              <div class=\"list\">\r\n                <div class=\"media no-border\">\r\n                  <div class=\"media-left\">\r\n                    <img *ngIf=\"bookings.vehicleImagePath\" class=\"media-object\" [src]=\"GetImageURL(bookings.vehicleImagePath)\" alt=\"No\" style=\"max-width: 150px; max-height: 100px;\">\r\n                    <img *ngIf=\"!bookings.vehicleImagePath\" class=\"media-object\" src=\"" + __webpack_require__(564) + "\" alt=\"No\"\r\n                      style=\"max-width: 150px;  max-height: 100px;\">\r\n                  </div>\r\n                  <div class=\"media-body\" style=\"padding-right: 15px;\">\r\n                    <div class=\"col-md-11\">\r\n                      <div class=\"row\">\r\n                        <div class=\"col-md-4\">\r\n                          <strong>{{ 'LblBookingReferenceId' | translate }} :</strong>\r\n                        </div>\r\n                        <div class=\"col-md-8\">{{ bookings.bookingReferenceID }}\r\n                          <i *ngIf=\"bookings.reccuringID\" class=\"fa fa-refresh fa-fw text-success\"></i>\r\n                        </div>\r\n                      </div>\r\n                      <!--<div *ngIf=\"bookings.reccuringID\" class=\"row\">\r\n                        <div class=\"col-md-4\"><strong>{{ 'LblRecurringId' | translate }} :</strong></div>\r\n                        <div class=\"col-md-8\">{{ bookings.reccuringID }}</div>\r\n                      </div>-->\r\n                      <div class=\"row\">\r\n                        <div class=\"col-md-4\">\r\n                          <strong>{{ 'LblVehicle' | translate }} :</strong>\r\n                        </div>\r\n                        <div class=\"col-md-8\">{{ bookings.licenceTag }}</div>\r\n                      </div>\r\n                      <div class=\"row\">\r\n                        <div class=\"col-md-4\">\r\n                          <strong>{{ 'LblStatus' | translate }} :</strong>\r\n                        </div>\r\n                        <div class=\"col-md-5\">{{ bookings.translatedBookingStatus }}</div>\r\n                        <div class=\"col-md-2\">\r\n                          <button class=\"btn btn-success\" style=\"height: 19px; padding-top:0px; \" (click)=\"OnPayment(bookings.bookingHashId)\" *ngIf=\"bookings.bookingStatus == 'READYFORPAYMENT'\">\r\n                            {{ 'LblPay' | translate}}</button>\r\n                        </div>\r\n                      </div>\r\n                      <div class=\"row\">\r\n                        <div class=\"col-md-4\">\r\n                          <strong>{{ 'LblFrom' | translate }} :</strong>\r\n                        </div>\r\n                        <div class=\"col-md-8\">{{ bookings.startDateTime }}</div>\r\n                      </div>\r\n                      <div class=\"row\">\r\n                        <div class=\"col-md-4\">\r\n                          <strong>{{ 'LblTo' | translate }} :</strong>\r\n                        </div>\r\n                        <div class=\"col-md-8\">{{ bookings.endDateTime }}</div>\r\n                      </div>\r\n                    </div>\r\n                    <div class=\"col-md-1\">\r\n                      <a class=\"btn btn-xs btn-default cursor-pointer\" *ngIf=\"authService.IsDriver()\" [routerLink]=\"[urlDriverBookingInformation,{ bookingHashId : bookings.bookingHashId }]\">\r\n                        <i class=\"fa fa-eye fa-fw text-success\"></i>\r\n                      </a>\r\n                      <a class=\"btn btn-xs btn-default cursor-pointer\" *ngIf=\"!bookings.reccuringID && bookings.isBookingEditable && bookings.bookingType=='NORMAL'\"\r\n                        [routerLink]=\"[urlBooking,{ ref : bookings.bookingHashId }]\">\r\n                        <i class=\"fa fa-pencil fa-fw\"></i>\r\n                      </a>\r\n                      <a class=\"btn btn-xs btn-default cursor-pointer\" *ngIf=\"bookings.reccuringID &&bookings.isBookingEditable && bookings.bookingType=='NORMAL'\"\r\n                        (click)=\"ShowBookingModal(bookings.isRecurringSeriesEditable,bookings.bookingHashId, bookings.reccuringID)\">\r\n                        <i class=\"fa fa-pencil fa-fw\"></i>\r\n                      </a>\r\n                      <a class=\"btn btn-xs btn-default cursor-pointer\" *ngIf=\"bookings.isBookingCancel\" (click)=\"ShowCancelModal(bookings.bookingHashId)\">\r\n                        <i class=\"fa fa-times fa-fw\" style=\"color: #8b0000;\"></i>\r\n                      </a>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"clearfix\"></div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-12\" *ngIf=\"bookingList\">\r\n          <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n            [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n            lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<div bsModal #cancelModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\"\r\n  [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-sm\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"HideCancelModal()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblConfirm' | translate }}</h4>\r\n      </div>\r\n      <form (ngSubmit)=\"onSubmit(CancelBookingForm.value)\" #CancelBookingForm=\"ngForm\">\r\n        <div class=\"modal-body\">\r\n          <div class=\"row\">\r\n            <div class=\"col-xs-12 form-group\">\r\n              {{ 'LblConfirmMessage' | translate }} {{ 'LblCancel' | translate }} {{ 'LblBooking' | translate }}?\r\n            </div>\r\n            <div class=\"col-xs-12 form-group\">\r\n              <textarea class=\"form-control\" id=\"comment\" [(ngModel)]=\"model.remarks\" name=\"remarks\" placeholder=\"{{ 'LblRemarks' | translate }}\"></textarea>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'remarks' }}</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"modal-footer\">\r\n          <button type=\"submit\" class=\"btn btn-primary\">{{ 'LblYes' | translate }}</button>\r\n          <button type=\"button\" class=\"btn btn-default\" (click)=\"HideCancelModal()\">{{ 'LblNo' | translate }}</button>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div bsModal #revokeAborkModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-sm\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"HideRevokeAbortModal()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblConfirm' | translate }}</h4>\r\n      </div>\r\n      <form (ngSubmit)=\"onSubmitAbortRevoke(revokeAbortBookingForm.value)\" #revokeAbortBookingForm=\"ngForm\">\r\n        <div class=\"modal-body\">\r\n          <div class=\"row\">\r\n            <div class=\"col-xs-12 form-group\">\r\n              {{ 'LblConfirmMessage' | translate }} {{ popupMessage}} {{ 'LblBooking' | translate }}?\r\n            </div>\r\n            <div class=\"col-xs-12 form-group\">\r\n              <textarea class=\"form-control\" id=\"comment\" [(ngModel)]=\"model.remarks\" name=\"remarks\" placeholder=\"{{ 'LblRemarks' | translate }}\"></textarea>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'remarks' }}</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"modal-footer\">\r\n          <button type=\"submit\" class=\"btn btn-primary\">{{ 'LblYes' | translate }}</button>\r\n          <button type=\"button\" class=\"btn btn-default\" (click)=\"HideRevokeAbortModal()\">{{ 'LblNo' | translate }}</button>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div bsModal #remarksModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-sm\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"HideRemarksModal()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{'LblRemarks'| translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        {{remarks}}\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div bsModal #EditBookingModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-sm\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"HideBookingModal()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblEdit' | translate }} {{ 'LblBooking' | translate }} </h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <div class=\"row mar_bot_10\">\r\n          <div class=\"col-xs-12\">\r\n            <button type=\"button\" class=\"btn btn-success col-xs-12\" (click)=\"SuccessSingleBooking()\"> {{ 'LblSingle' | translate }} {{ 'LblBooking' | translate }}</button>\r\n          </div>\r\n        </div>\r\n        <div class=\"row\">\r\n          <div class=\"col-xs-12\">\r\n            <button type=\"button\" class=\"btn btn-success col-xs-12\" (click)=\"SuccessRecurringBooking()\">{{ 'LblSeries' | translate }} {{ 'LblBooking' | translate }}</button>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n<wego-credit-card-payment-popup #creditCardPaymentModal [initialPaymentPopupTitle]=\"initialPaymentPopupTitle\" [popupDescription]=\"popupDescription\"\r\n  [errorMessage]=\"errorMessage\" (isAllowInitialPayment)=\"GetInitialPaymentValue($event)\" (onProceed)=\"ConfirmInitialPayment()\"></wego-credit-card-payment-popup>";

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var config_1 = __webpack_require__(60);
	var booking_overview_model_1 = __webpack_require__(577);
	var search_booking_model_1 = __webpack_require__(574);
	var core_1 = __webpack_require__(3);
	var common_1 = __webpack_require__(22);
	var auth_service_1 = __webpack_require__(58);
	var router_1 = __webpack_require__(26);
	var enum_helper_1 = __webpack_require__(578);
	var ConfirmBookingDriverComponent = (function () {
	    function ConfirmBookingDriverComponent(locationService, router, authService) {
	        this.locationService = locationService;
	        this.router = router;
	        this.authService = authService;
	        this.onConfirmBooking = new core_1.EventEmitter();
	        this.onCancelBooking = new core_1.EventEmitter();
	    }
	    ConfirmBookingDriverComponent.prototype.ngOnInit = function () { };
	    ConfirmBookingDriverComponent.prototype.OnConfirmBooking = function ($event) {
	        if (!this.searchBookingModel.isRecurring) {
	            this.termsConditionModel.show([enum_helper_1.TNCAcceptanceMoment.MAKE_BOOKING], this.searchBookingModel.bookingMasterHashId, '', enum_helper_1.TNCAcceptanceMoment.MAKE_BOOKING);
	        }
	        else {
	            this.onConfirmBooking.emit({ BookingRemarks: this.bookingRemarks });
	        }
	    };
	    ConfirmBookingDriverComponent.prototype.AllTncAccepted = function () {
	        this.onConfirmBooking.emit({ BookingRemarks: this.bookingRemarks });
	    };
	    ConfirmBookingDriverComponent.prototype.TncRejected = function () {
	        this.OnCancelBooking({ BookingRemarks: this.bookingRemarks });
	    };
	    ConfirmBookingDriverComponent.prototype.OnCancelBooking = function ($event) {
	        this.onCancelBooking.emit($event);
	        var urlData = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DASHBOARD_PAGE);
	        this.router.navigate([urlData]);
	    };
	    ConfirmBookingDriverComponent.prototype.GetImageURL = function (imagePath) {
	        return config_1.WeGoConfig.API_SERVER_URL + imagePath;
	    };
	    ConfirmBookingDriverComponent.prototype.GroupByCategory = function (vehicleAttributeList) {
	        if (vehicleAttributeList) {
	            var prop_1 = 'vehicleAttributeCategoryName';
	            return vehicleAttributeList.reduce(function (groups, item) {
	                var val = item[prop_1];
	                groups[val] = groups[val] || [];
	                groups[val].push(item);
	                groups[val] = groups[val].sort(function (obj1, obj2) {
	                    if (obj1.attributeName > obj2.attributeName) {
	                        return 1;
	                    }
	                    if (obj1.attributeName < obj2.attributeName) {
	                        return -1;
	                    }
	                    return 0;
	                });
	                return groups;
	            }, {});
	        }
	        else {
	            return {};
	        }
	    };
	    ConfirmBookingDriverComponent.prototype.KeyOfObject = function (obj) {
	        return Object.keys(obj);
	    };
	    __decorate([
	        core_1.Input('BookingOverview'), 
	        __metadata('design:type', (typeof (_a = typeof booking_overview_model_1.BookingOverview !== 'undefined' && booking_overview_model_1.BookingOverview) === 'function' && _a) || Object)
	    ], ConfirmBookingDriverComponent.prototype, "bookingOverview", void 0);
	    __decorate([
	        core_1.Input('searchBookingModel'), 
	        __metadata('design:type', (typeof (_b = typeof search_booking_model_1.SearchBookingModel !== 'undefined' && search_booking_model_1.SearchBookingModel) === 'function' && _b) || Object)
	    ], ConfirmBookingDriverComponent.prototype, "searchBookingModel", void 0);
	    __decorate([
	        core_1.Input('BookingRemarks'), 
	        __metadata('design:type', String)
	    ], ConfirmBookingDriverComponent.prototype, "bookingRemarks", void 0);
	    __decorate([
	        core_1.Output('OnConfirmBooking'), 
	        __metadata('design:type', Object)
	    ], ConfirmBookingDriverComponent.prototype, "onConfirmBooking", void 0);
	    __decorate([
	        core_1.Output('OnCancelBooking'), 
	        __metadata('design:type', Object)
	    ], ConfirmBookingDriverComponent.prototype, "onCancelBooking", void 0);
	    __decorate([
	        core_1.ViewChild("termsConditionModel"), 
	        __metadata('design:type', Object)
	    ], ConfirmBookingDriverComponent.prototype, "termsConditionModel", void 0);
	    ConfirmBookingDriverComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-confirm-booking-driver',
	            template: __webpack_require__(579),
	            styles: ["\n    span.label.label-default{\n      font-size: 13px;\n      line-height: 35px;\n      background-color: #eeeeee;\n      color: #2BA2AA;\n      margin-right: 5px;\n    }\n    \n    span.label.label-default.text-success{\n      color: #3c763d;\n    }\n    \n    span.label.label-default.text-danger{\n      color: #a94442;\n    }\n          "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_c = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _e) || Object])
	    ], ConfirmBookingDriverComponent);
	    return ConfirmBookingDriverComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.ConfirmBookingDriverComponent = ConfirmBookingDriverComponent;


/***/ },
/* 577 */
/***/ function(module, exports) {

	"use strict";
	var Booking = (function () {
	    function Booking() {
	    }
	    return Booking;
	}());
	exports.Booking = Booking;
	var Vehicle = (function () {
	    function Vehicle() {
	    }
	    return Vehicle;
	}());
	exports.Vehicle = Vehicle;
	var Driver = (function () {
	    function Driver() {
	    }
	    return Driver;
	}());
	exports.Driver = Driver;
	var BookingOverview = (function () {
	    function BookingOverview() {
	    }
	    return BookingOverview;
	}());
	exports.BookingOverview = BookingOverview;


/***/ },
/* 578 */
/***/ function(module, exports) {

	"use strict";
	(function (TNCAcceptanceMoment) {
	    TNCAcceptanceMoment[TNCAcceptanceMoment["ACCOUNT_ACTIVATION"] = 1] = "ACCOUNT_ACTIVATION";
	    TNCAcceptanceMoment[TNCAcceptanceMoment["REPEAT_TIME_OPEN_APP"] = 2] = "REPEAT_TIME_OPEN_APP";
	    TNCAcceptanceMoment[TNCAcceptanceMoment["EVERY_TIME_OPEN_APP"] = 3] = "EVERY_TIME_OPEN_APP";
	    TNCAcceptanceMoment[TNCAcceptanceMoment["MAKE_BOOKING"] = 4] = "MAKE_BOOKING";
	    TNCAcceptanceMoment[TNCAcceptanceMoment["START_BOOKING"] = 5] = "START_BOOKING";
	    TNCAcceptanceMoment[TNCAcceptanceMoment["OPEN_BOOKING"] = 6] = "OPEN_BOOKING";
	    TNCAcceptanceMoment[TNCAcceptanceMoment["CTG_SELECTION"] = 7] = "CTG_SELECTION";
	})(exports.TNCAcceptanceMoment || (exports.TNCAcceptanceMoment = {}));
	var TNCAcceptanceMoment = exports.TNCAcceptanceMoment;
	(function (TNCAction) {
	    TNCAction[TNCAction["ACCEPTED"] = 1] = "ACCEPTED";
	    TNCAction[TNCAction["REJECTED"] = 2] = "REJECTED";
	    TNCAction[TNCAction["REVOKED"] = 3] = "REVOKED";
	})(exports.TNCAction || (exports.TNCAction = {}));
	var TNCAction = exports.TNCAction;
	(function (InvoiceStatusEnum) {
	    InvoiceStatusEnum[InvoiceStatusEnum["OPEN"] = 0] = "OPEN";
	    InvoiceStatusEnum[InvoiceStatusEnum["SENT"] = 1] = "SENT";
	    InvoiceStatusEnum[InvoiceStatusEnum["CLOSED"] = 2] = "CLOSED";
	    InvoiceStatusEnum[InvoiceStatusEnum["REQUESTFORPAYMENT"] = 3] = "REQUESTFORPAYMENT";
	    InvoiceStatusEnum[InvoiceStatusEnum["REOPEN"] = 4] = "REOPEN";
	})(exports.InvoiceStatusEnum || (exports.InvoiceStatusEnum = {}));
	var InvoiceStatusEnum = exports.InvoiceStatusEnum;


/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"row\">\r\n  <div class=\"col-md-6\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <div class=\"hp-listing\">\r\n          <div class=\"list-box\" style=\"padding: 25px;\">\r\n            <div class=\"media\">\r\n              <div class=\"media-body\">\r\n                <fieldset>\r\n                  <legend class=\"legendStyle\">\r\n                    {{ 'LblDriverDetail' | translate }}\r\n                  </legend>\r\n                  <div class=\"clearfix\"></div>\r\n                  <div class=\"row\">\r\n                    <div *ngIf=\"bookingOverview?.driver.licenceNumber\" class=\"col-sm-4 col-xs-6\">\r\n                      <label>{{ 'LblLicenceNumber' | translate }} :</label> {{ bookingOverview?.driver.licenceNumber }}\r\n                    </div>\r\n                    <div *ngIf=\"bookingOverview?.driver.driverName\" class=\"col-sm-4 col-xs-6\">\r\n                      <label>{{ 'LblDriverName' | translate }} :</label> {{ bookingOverview?.driver.driverName }}\r\n                    </div>\r\n                    <div *ngIf=\"bookingOverview?.driver.email\" class=\"col-sm-4 col-xs-6\">\r\n                      <label>{{ 'LblEmail' | translate }} :</label> {{ bookingOverview?.driver.email }}\r\n                    </div>\r\n                  </div>\r\n                </fieldset>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-md-12\">\r\n        <div class=\"hp-listing\">\r\n          <div class=\"list-box\" style=\"padding: 25px;\">\r\n            <div class=\"media\">\r\n              <div class=\"media-body\">\r\n                <fieldset>\r\n                  <legend class=\"legendStyle\">\r\n                    {{ 'LblBookingDetail' | translate }}\r\n                  </legend>\r\n                  <div class=\"clearfix\"></div>\r\n                  <!-- <div class=\"row\">\r\n                       <div *ngIf=\"bookingOverview?.booking.bookingType\" class=\"col-sm-6 col-xs-6\">\r\n                        <label>{{ 'LblBookingType' | translate }} :</label> {{ bookingOverview?.booking.bookingType }}</div>\r\n                    </div> -->\r\n                  <div *ngIf=\"bookingOverview?.booking\" class=\"row\">\r\n                    <div *ngIf=\"bookingOverview?.booking.bookingStartDateTime\" class=\"col-sm-6 col-xs-6\">\r\n                      <label>{{ 'LblBookingStartDateTime' | translate }} :</label> {{ bookingOverview?.booking.bookingStartDateTime\r\n                      }}\r\n                    </div>\r\n                    <div *ngIf=\"bookingOverview?.booking.bookingEndDateTime\" class=\"col-sm-6 col-xs-6\">\r\n                      <label>{{ 'LblBookingEndDateTime' | translate }} :</label> {{ bookingOverview?.booking.bookingEndDateTime\r\n                      }}\r\n                    </div>\r\n                  </div>\r\n                  <template [ngIf]=\"bookingOverview?.reccuringBooking\">\r\n                    <div *ngFor=\"let item of bookingOverview?.reccuringBooking\" class=\"row\">\r\n                      <div *ngIf=\"item.bookingStartDateTime\" class=\"col-sm-6 col-xs-6\">\r\n                        <label>{{ 'LblBookingStartDateTime' | translate }} :</label> {{ item.bookingStartDateTime }}</div>\r\n                      <div *ngIf=\"item.bookingEndDateTime\" class=\"col-sm-6 col-xs-6\">\r\n                        <label>{{ 'LblBookingEndDateTime' | translate }} :</label> {{ item.bookingEndDateTime }}</div>\r\n                    </div>\r\n                  </template>\r\n                  <div class=\"row\">\r\n                    <div class=\"col-sm-6 col-xs-6\">\r\n                      <label>{{ 'LblToalBookingDuration' | translate }} :</label> {{ bookingOverview?.bookingDuration }}</div>\r\n                    <div *ngIf=\"bookingOverview?.booking\" class=\"col-sm-4 col-xs-4\">\r\n                      <label>{{ 'LblPickupLocation' | translate }} :</label> {{ bookingOverview?.booking.pickupAddress }}</div>\r\n                    <div *ngIf=\"bookingOverview?.reccuringBooking && bookingOverview?.reccuringBooking.length>0\" class=\"col-sm-4 col-xs-4\">\r\n                      <label>{{ 'LblPickupLocation' | translate }} :</label> {{ bookingOverview?.reccuringBooking[0].pickupAddress\r\n                      }}\r\n                    </div>\r\n                  </div>\r\n                </fieldset>\r\n                <div class=\"form-group \">\r\n                  <label>{{ 'LblBookingRemarks' | translate }}</label>\r\n                  <div class=\"input-group col-sm-6 col-xs-6\">\r\n                    <textarea class=\"form-control\" id=\"BookingRemarks\" [(ngModel)]=\"bookingRemarks\" name=\"BookingRemarks\" placeholder=\"{{ 'LblBookingRemarks' | translate }}\"></textarea>\r\n                    <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'BookingRemarks' }}</span>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"col-md-6\">\r\n    <div class=\"hp-listing\">\r\n      <div class=\"list-box\" style=\"padding: 25px;\">\r\n        <div class=\"media\">\r\n          <div class=\"media-body\">\r\n            <fieldset>\r\n              <legend class=\"legendStyle\">\r\n                {{ 'LblVehicleDetail' | translate }}\r\n              </legend>\r\n              <div class=\"clearfix\"></div>\r\n              <div class=\"media-left\">\r\n                <img *ngIf=\"bookingOverview?.vehicle.vehicleImagePath\" class=\"media-object\" [src]=\"GetImageURL(bookingOverview?.vehicle.vehicleImagePath)\"\r\n                  style=\"max-width: 150px;  max-height: 100px;\">\r\n                <img *ngIf=\"!bookingOverview?.vehicle.vehicleImagePath\" class=\"media-object\" src=\"" + __webpack_require__(564) + "\"\r\n                  alt=\"No\" style=\"max-width: 150px;  max-height: 100px;\">\r\n              </div>\r\n              <div class=\"media-body\">\r\n                <div class=\"row\">\r\n                  <div class=\"col-md-12\">\r\n                    <div class=\"row\">\r\n                      <div class=\"col-sm-4\">\r\n                        <strong>{{ 'LblLicenceTag' | translate }} :</strong>\r\n                      </div>\r\n                      <div class=\"col-sm-8\">\r\n                        {{ bookingOverview?.vehicle.licenceTag }}\r\n                      </div>\r\n                    </div>\r\n                    <div *ngIf=\"bookingOverview?.vehicle.brand\" class=\"row\">\r\n                      <div class=\"col-sm-4\">\r\n                        <strong>{{ 'LblBrand' | translate }} :</strong>\r\n                      </div>\r\n                      <div class=\"col-sm-8\">\r\n                        {{ bookingOverview?.vehicle.brand }}\r\n                      </div>\r\n                    </div>\r\n                    <div *ngIf=\"bookingOverview?.vehicle.color\" class=\"row\">\r\n                      <div class=\"col-sm-4\">\r\n                        <strong>{{ 'LblColor' | translate }} :</strong>\r\n                      </div>\r\n                      <div class=\"col-sm-8\">\r\n                        {{ bookingOverview?.vehicle.color }}\r\n                      </div>\r\n                    </div>\r\n                    <div *ngIf=\"bookingOverview?.vehicle.vehicleClass\" class=\"row\">\r\n                      <div class=\"col-sm-4\">\r\n                        <strong>{{ 'LblVehicleClass' | translate }} :</strong>\r\n                      </div>\r\n                      <div class=\"col-sm-8\">\r\n                        {{ bookingOverview?.vehicle.vehicleClass }}\r\n                      </div>\r\n                    </div>\r\n                    <div *ngIf=\"bookingOverview?.vehicle.pricingCategory\" class=\"row\">\r\n                      <div class=\"col-sm-4\">\r\n                        <strong>{{ 'LblBrand' | translate }} :</strong>\r\n                      </div>\r\n                      <div class=\"col-sm-8\">\r\n                        {{ bookingOverview?.vehicle.pricingCategory }}\r\n                      </div>\r\n                    </div>\r\n                    <div *ngIf=\"bookingOverview?.vehicle.bodyStyle\" class=\"row\">\r\n                      <div class=\"col-sm-4\">\r\n                        <strong>{{ 'LblBodyStyle' | translate }} :</strong>\r\n                      </div>\r\n                      <div class=\"col-sm-8\">\r\n                        {{ bookingOverview?.vehicle.bodyStyle }}\r\n                      </div>\r\n                    </div>\r\n                    <div *ngIf=\"bookingOverview?.vehicle.fuelType\" class=\"row\">\r\n                      <div class=\"col-sm-4\">\r\n                        <strong>{{ 'LblFuelType' | translate }} :</strong>\r\n                      </div>\r\n                      <div class=\"col-sm-8\">\r\n                        {{ bookingOverview?.vehicle.fuelType }}\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"clearfix\"></div>\r\n                  <div class=\"col-sm-12\" *ngFor=\"let cat of KeyOfObject(GroupByCategory(bookingOverview?.vehicle.attributeList))\">\r\n                    <label>{{ cat }} : </label>\r\n                    <span *ngFor=\"let attribute of GroupByCategory(bookingOverview?.vehicle.attributeList)[cat]\" class=\"label label-default\">\r\n                      <i class=\"fa fa-tag fa-lg\" aria-hidden=\"true\"></i>&nbsp;{{ attribute.attributeName }}\r\n                    </span>\r\n                  </div>\r\n                  <!-- <div class=\"col-sm-12\">\r\n                    <span *ngIf=\"bookingOverview?.vehicle.airco\" class=\"label label-default\">\r\n                          <i class=\"fa fa-tag fa-lg\" aria-hidden=\"true\"></i>\r\n                          &nbsp;{{ 'LblAirco' | translate }}\r\n                        </span>\r\n                    <span *ngIf=\"bookingOverview?.vehicle.towbar\" class=\"label label-default\">\r\n                          <i class=\"fa fa-tag fa-lg\" aria-hidden=\"true\"></i>\r\n                          &nbsp;{{ 'LblTowbar' | translate }}\r\n                        </span>\r\n                  </div> -->\r\n                </div>\r\n              </div>\r\n            </fieldset>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"row\">\r\n  <div class=\"col-sm-12\">\r\n    <hr>\r\n    <a class=\"btn btn-gray btn-md cursor-pointer\" (click)=\"OnCancelBooking($event)\">{{ 'LblCancel' | translate }}</a> &nbsp;&nbsp;\r\n    <button class=\"btn btn-confirm btn-md mar-right-5\" (click)=\"OnConfirmBooking($event)\" type=\"submit\">{{ 'LblConfirm' | translate }}</button>\r\n  </div>\r\n</div>\r\n\r\n<wego-terms-condition-accept-reject-popup #termsConditionModel (onAccept)=\"AllTncAccepted()\" (onReject)=\"TncRejected()\"></wego-terms-condition-accept-reject-popup>";

/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var decimal_formatter_service_1 = __webpack_require__(69);
	var translate_service_1 = __webpack_require__(70);
	var config_1 = __webpack_require__(60);
	var search_booking_model_1 = __webpack_require__(574);
	var core_1 = __webpack_require__(3);
	var booking_service_1 = __webpack_require__(556);
	var moment = __webpack_require__(84);
	var $ = __webpack_require__(68);
	var VehicleOverviewDriverComponent = (function () {
	    function VehicleOverviewDriverComponent(translate, bookingService, decimalFormatter) {
	        this.translate = translate;
	        this.bookingService = bookingService;
	        this.decimalFormatter = decimalFormatter;
	        this.onBook = new core_1.EventEmitter();
	        this.SortByDistance = true;
	    }
	    VehicleOverviewDriverComponent.prototype.ngOnChanges = function (change) { };
	    VehicleOverviewDriverComponent.prototype.ngOnInit = function () {
	        this.LblKM = this.translate.instant("LblKM");
	        this.LblLocationUnavailable = this.translate.instant("LblLocationUnavailable");
	        this.LblAvailibilityCalander = this.translate.instant("LblAvailabilityCalander");
	        this.SortList();
	    };
	    VehicleOverviewDriverComponent.prototype.BookVehicle = function (sharedVehicleGroupHashID, vehicleHashID) {
	        this.onBook.emit({
	            SharedVehicleGroupHashID: sharedVehicleGroupHashID,
	            VehicleHashID: vehicleHashID
	        });
	    };
	    VehicleOverviewDriverComponent.prototype.GetImageURL = function (imagePath) {
	        return config_1.WeGoConfig.API_SERVER_URL + imagePath;
	    };
	    VehicleOverviewDriverComponent.prototype.GroupByCategory = function (vehicleAttributeList) {
	        if (vehicleAttributeList) {
	            var prop_1 = "vehicleAttributeCategoryName";
	            return vehicleAttributeList.reduce(function (groups, item) {
	                var val = item[prop_1];
	                groups[val] = groups[val] || [];
	                groups[val].push(item);
	                groups[val] = groups[val].sort(function (obj1, obj2) {
	                    if (obj1.attributeName > obj2.attributeName) {
	                        return 1;
	                    }
	                    if (obj1.attributeName < obj2.attributeName) {
	                        return -1;
	                    }
	                    return 0;
	                });
	                return groups;
	            }, {});
	        }
	        else {
	            return {};
	        }
	    };
	    VehicleOverviewDriverComponent.prototype.KeyOfObject = function (obj) {
	        return Object.keys(obj);
	    };
	    VehicleOverviewDriverComponent.prototype.PrintLocation = function (item) {
	        if (item.address && item.lat != 0 && item.long != 0) {
	            return (item.address +
	                " (" +
	                this.decimalFormatter.transform(item.distance) +
	                " " +
	                this.LblKM +
	                ")");
	        }
	        else {
	            return this.LblLocationUnavailable;
	        }
	    };
	    VehicleOverviewDriverComponent.prototype.OpenAvailabilityCalander = function (vehcleHashId, licenceTag) {
	        var _this = this;
	        this.isLoading = true;
	        this.bookingService
	            .GetAquiredTimeSlots(vehcleHashId, this.searchBookingModel.driverHashId, this.searchBookingModel.organizationIdHashID)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.calanderpopup.occupiedTime = res.data;
	                _this.calanderpopup.licenceTag = licenceTag;
	                res.data.forEach(function (x) {
	                    _this.calanderpopup.driverName = x.driverName;
	                    _this.calanderpopup.email = x.email;
	                    _this.calanderpopup.mobileNumber = x.mobile;
	                });
	                _this.calanderpopup.popupTitle = _this.LblAvailibilityCalander;
	                _this.calanderpopup.show();
	                _this.isLoading = false;
	            }
	        }, function (error) { });
	    };
	    VehicleOverviewDriverComponent.prototype.OnSort = function () {
	        if ($("#sortByDDL").val() == "avaibility") {
	            this.SortByDistance = false;
	            this.SortList();
	        }
	        else if ($("#sortByDDL").val() == "distance")
	            this.SortByDistance = true;
	        this.SortList();
	    };
	    VehicleOverviewDriverComponent.prototype.SortList = function () {
	        var _this = this;
	        this.vehicleOverviewList = this.vehicleOverviewList.sort(function (x, y) {
	            return _this.HandleSorting(x, y);
	        });
	    };
	    VehicleOverviewDriverComponent.prototype.HandleSorting = function (obj1, obj2) {
	        var val1 = this.SortByDistance
	            ? obj1.distance == "NaN"
	                ? Infinity
	                : obj1.distance
	            : obj1.nextAvailableFromTime
	                ? moment(obj1.nextAvailableFromTime, "DD-MM-YYYY HH:mm")
	                : moment("01-01-1900 00:00");
	        var val2 = this.SortByDistance
	            ? obj2.distance == "NaN"
	                ? Infinity
	                : obj2.distance
	            : obj2.nextAvailableFromTime
	                ? moment(obj2.nextAvailableFromTime, "DD-MM-YYYY HH:mm")
	                : moment("01-01-1900 00:00");
	        if (val1 < val2) {
	            return -1;
	        }
	        else if (val1 > val2) {
	            return 1;
	        }
	        else {
	            return 0;
	        }
	    };
	    __decorate([
	        core_1.Output("OnBook"), 
	        __metadata('design:type', Object)
	    ], VehicleOverviewDriverComponent.prototype, "onBook", void 0);
	    __decorate([
	        core_1.Input("VehicleOverviewList"), 
	        __metadata('design:type', Array)
	    ], VehicleOverviewDriverComponent.prototype, "vehicleOverviewList", void 0);
	    __decorate([
	        core_1.Input("SearchBookingModel"), 
	        __metadata('design:type', (typeof (_a = typeof search_booking_model_1.SearchBookingModel !== 'undefined' && search_booking_model_1.SearchBookingModel) === 'function' && _a) || Object)
	    ], VehicleOverviewDriverComponent.prototype, "searchBookingModel", void 0);
	    __decorate([
	        core_1.ViewChild("calanderpopup"), 
	        __metadata('design:type', Object)
	    ], VehicleOverviewDriverComponent.prototype, "calanderpopup", void 0);
	    VehicleOverviewDriverComponent = __decorate([
	        core_1.Component({
	            selector: "wego-vehicle-overview-driver",
	            template: __webpack_require__(581),
	            styles: [
	                "\n      .media {\n        padding: 10px;\n        border: 1px solid #ddd;\n      }\n\n      span.label.label-default {\n        font-size: 13px;\n        line-height: 35px;\n        background-color: #eeeeee;\n        color: #2ba2aa;\n        margin-right: 5px;\n      }\n\n      span.label.label-default.text-success {\n        color: #3c763d;\n      }\n\n      span.label.label-default.text-danger {\n        color: #a94442;\n      }\n\n      .progress-bar-success {\n        background-color: #2ba2aa;\n      }\n      .dropdown {\n        position: relative;\n        display: inline-block;\n      }\n\n      .dropdown-content {\n        display: none;\n        position: absolute;\n        background-color: #f9f9f9;\n        min-width: 105px;\n        box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n        padding: 12px 16px;\n        z-index: 1;\n      }\n\n      .dropdown:hover .dropdown-content {\n        display: block;\n      }\n    "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _b) || Object, (typeof (_c = typeof booking_service_1.BookingService !== 'undefined' && booking_service_1.BookingService) === 'function' && _c) || Object, (typeof (_d = typeof decimal_formatter_service_1.DecimalFormatterService !== 'undefined' && decimal_formatter_service_1.DecimalFormatterService) === 'function' && _d) || Object])
	    ], VehicleOverviewDriverComponent);
	    return VehicleOverviewDriverComponent;
	    var _a, _b, _c, _d;
	}());
	exports.VehicleOverviewDriverComponent = VehicleOverviewDriverComponent;


/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"row\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"row\" style=\"margin-bottom: 4px;\">\r\n      <div class=\"col-md-10\">\r\n        <div style=\"margin-top: 5px;\" class=\"pull-right\">{{'LblSortBy' | translate}} : </div>\r\n      </div>\r\n      <div class=\"col-md-2\">\r\n        <select class=\"form-control\" id=\"sortByDDL\" (change)=\"OnSort()\">\r\n                      <option  selected value=\"distance\">{{ 'LblDistance' | translate }}</option>\r\n                      <option value=\"avaibility\">{{ 'LblAvaibility' | translate }}  </option>\r\n          </select>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"hp-listing\" *ngFor=\"let item of vehicleOverviewList\">\r\n  <div class=\"list\">\r\n    <div class=\"media-1 no-border\">\r\n      <div class=\"media-left-1\">\r\n        <img *ngIf=\"!item.vehicleImagePath\" class=\"media-object\" src=\"" + __webpack_require__(564) + "\" alt=\"No\"\r\n          style=\"max-width: 150px; max-height: 100px;\">\r\n        <img *ngIf=\"item.vehicleImagePath\" class=\"media-object center-block\" [src]=\"GetImageURL(item.vehicleImagePath)\" style=\"max-width: 150px; max-height: 100px;\"\r\n        />\r\n        <br />\r\n        <progressbar class=\"cursor-pointer\" [popover]=\"availableSlots\" popoverPlacement=\"auto\" *ngIf=\"searchBookingModel.isRecurring\"\r\n          [value]=\"item.availabilityPercentage\" type=\"success\" title=\"Availability Percentage\">{{ item.availabilityPercentage }} %</progressbar>\r\n        <popover-content #availableSlots title=\"{{ 'LblUnAvailableSlots' | translate }}\" placement=\"auto\" [animation]=\"true\" [closeOnClickOutside]=\"true\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center\">{{ 'LblFrom' | translate }}</th>\r\n                <th class=\"text-center\"> {{'LblTo' | translate}} </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <tr *ngFor=\"let unAvailabileSlots of item.unAvailabileSlots\">\r\n                <td>{{ unAvailabileSlots.stDate }}</td>\r\n                <td>{{ unAvailabileSlots.enDate }}</td>\r\n              </tr>\r\n              <tr *ngIf=\"item.unAvailabileSlots==0 \">\r\n                <td class=\"text-center text-danger \" colspan=\"2 \">\r\n                  {{ 'LblAvailableForAllSlots' | translate }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </popover-content>\r\n      </div>\r\n      <div class=\"media-body-1\">\r\n        <div class=\"col-md-9\">\r\n          <div class=\"col-sm-12\">\r\n            <label>{{ 'LblLocation' | translate }} :</label> {{ PrintLocation(item) }}\r\n          </div>\r\n          <div class=\"col-sm-6\">\r\n            <label>{{ 'LblLicenceTag' | translate }} :</label> {{ item.licenceTag}}\r\n          </div>\r\n          <div *ngIf=\"item.sharedVehicleGroup\" class=\"col-sm-6\">\r\n            <label>{{ 'LblSharedVehicleGroup' | translate }} :</label> {{ item.sharedVehicleGroup }}\r\n          </div>\r\n          <div *ngIf=\"item.brand\" class=\"col-sm-6\">\r\n            <label>{{ 'LblBrand' | translate }} :</label> {{ item.brand }}\r\n          </div>\r\n          <div *ngIf=\"item.type\" class=\"col-sm-6\">\r\n            <label>{{ 'LblType' | translate }} :</label> {{ item.type }}\r\n          </div>\r\n          <div *ngIf=\"item.color\" class=\"col-sm-6\">\r\n            <label>{{ 'LblColor' | translate }} :</label> {{ item.color }}\r\n          </div>\r\n          <div *ngIf=\"item.vehicleClass\" class=\"col-sm-6\">\r\n            <label>{{ 'LblVehicleClass' | translate }} :</label> {{ item.vehicleClass }}\r\n          </div>\r\n          <div *ngIf=\"item.pricingCategory\" class=\"col-sm-6\">\r\n            <label>{{ 'LblPricingCategory' | translate }} :</label> {{ item.pricingCategory }}\r\n          </div>\r\n          <div *ngIf=\"item.bodyStyle\" class=\"col-sm-6\">\r\n            <label>{{ 'LblBodyStyle' | translate }} :</label> {{ item.bodyStyle }}\r\n          </div>\r\n          <div *ngIf=\"item.fuelType\" class=\"col-sm-6\">\r\n            <label>{{ 'LblFuelType' | translate }} :</label> {{ item.fuelType }}\r\n          </div>\r\n        </div>\r\n        <div *ngIf=\"item.available\" class=\"col-md-3 text-center\">\r\n          <button (click)=\"BookVehicle(item.sharedVehicleGroupHashID, item.vehicleHashID)\" class=\"btn btn-success\">\r\n            <span *ngIf=\"!(searchBookingModel?.isEditMode && searchBookingModel?.vehicleHashId == item.vehicleHashID && searchBookingModel?.sharedVehicleGroupHashID == item.sharedVehicleGroupHashID)\">{{ 'LblBookNow' | translate }}</span>\r\n            <span *ngIf=\"searchBookingModel?.isEditMode && searchBookingModel?.vehicleHashId == item.vehicleHashID && searchBookingModel?.sharedVehicleGroupHashID == item.sharedVehicleGroupHashID\">{{ 'LblUpdateBooking' | translate }}</span>\r\n          </button>\r\n          <div *ngIf=\"item.showChargeLevel\" class=\"col-sm-12 col-xs-12 nopad text-center\">\r\n            <span><label>{{ 'LblChargeLevel' | translate }} :</label> {{item.chargeLevel |decimalFormatter  }}</span>\r\n          </div>\r\n        </div>\r\n        <div *ngIf=\"!item.available\" class=\"col-md-3 text-center\">\r\n          <span class=\"add-new-button\">{{ 'LblUnAvailable' | translate }}</span><br>\r\n          <div *ngIf=\"item.showChargeLevel\" class=\"col-sm-12 col-xs-12 nopad text-center\">\r\n            <span> <label>{{ 'LblChargeLevel' | translate }} :</label> {{item.chargeLevel |decimalFormatter }}</span>\r\n          </div>\r\n          <span>{{ 'LblAvailableOn' | translate }}</span><br>\r\n          <span>{{ item.nextAvailableFromTime }}</span><br>\r\n          <!--<span>{{ 'LblTo' | translate }}</span><br>\r\n          <span>{{item.nextAvailableToTime}}</span><br>-->\r\n          <a (click)=\"OpenAvailabilityCalander(item.vehicleHashID,item.licenceTag)\" class=\"cursor-pointer\">\r\n            <u>{{ 'LblAvailabilityCalander' | translate }}</u>\r\n          </a>\r\n\r\n        </div>\r\n\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"col-md-12\">\r\n          <div class=\"col-md-12\" *ngFor=\"let cat of KeyOfObject(GroupByCategory(item.attributeList))\">\r\n            <label>{{ cat }} : </label>\r\n            <span *ngFor=\"let attribute of GroupByCategory(item.attributeList)[cat]\" class=\"label label-default\" style=\"cursor: default\">\r\n              <i class=\"fa fa-tag fa-lg\" aria-hidden=\"true\"></i>&nbsp;{{ attribute.attributeName }}\r\n            </span>\r\n          </div>\r\n          <!-- <div class=\"col-md-12\">\r\n            <span *ngIf=\"item.airco\" class=\"label label-default\" style=\"cursor: default\">\r\n             <i class=\"fa fa-tag fa-lg\" aria-hidden=\"true\"></i>&nbsp;{{ 'LblAirco' | translate }}\r\n            </span>\r\n            <span *ngIf=\"item.towbar\" class=\"label label-default\" style=\"cursor: default\">  \r\n            <i class=\"fa fa-tag fa-lg\" aria-hidden=\"true\"></i>&nbsp;{{ 'LblTowbar' | translate }}\r\n          </span>\r\n          </div> -->\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div *ngIf=\"vehicleOverviewList.length == 0\" class=\"alert alert-danger\">\r\n  <p class=\"text-center\">\r\n    {{ 'LblNoMatchingVehicle' | translate }}\r\n  </p>\r\n</div>\r\n<wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n<wego-calander-popup #calanderpopup></wego-calander-popup>";

/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var jquery_helper_service_1 = __webpack_require__(67);
	var core_1 = __webpack_require__(3);
	var FilterVehicleOverviewDriverComponent = (function () {
	    function FilterVehicleOverviewDriverComponent() {
	        this.onUpdateVehicleOverView = new core_1.EventEmitter();
	        this.JQueryHelper = new jquery_helper_service_1.JQueryHelperService();
	        this.additionalAttribute = [];
	        this.selBrandList = [];
	        this.selTypeList = [];
	        this.selFuleTypeList = [];
	        this.selBodyStyleList = [];
	        this.selPriceingCategoryList = [];
	        this.seladditionalAttribute = [];
	        this.selAirco = false;
	        this.selTowbar = false;
	    }
	    FilterVehicleOverviewDriverComponent.prototype.ngOnChanges = function (change) {
	        console.log(change);
	        this.UpdateFilter();
	    };
	    FilterVehicleOverviewDriverComponent.prototype.ngOnInit = function () {
	    };
	    FilterVehicleOverviewDriverComponent.prototype.UpdateFilter = function () {
	        this.filterVehicleOverviewList = this.vehicleOverviewList;
	        this.BrandFilter();
	        this.TypeFilter();
	        this.FuleFilter();
	        this.BodyStyleFilter();
	        this.PriceingCategoryFilter();
	        this.AdditionalAttributeFilter();
	        this.UpdateVehicleOverView();
	    };
	    FilterVehicleOverviewDriverComponent.prototype.AdditionalAttributeFilter = function () {
	        // let additionalAttribute = this.vehicleOverviewList.filter(x => this.HasValue(x.attributeList) && x.attributeList.length > 0).map(x => x.attributeList.map((y: any) => y.attributeName)).sort();
	        // additionalAttribute.forEach(element => {
	        //   element.forEach((element: any) => {
	        //     this.additionalAttribute.push(element);
	        //   });
	        // });
	        // this.additionalAttribute = this.JQueryHelper.Unique(this.additionalAttribute);
	        var _this = this;
	        var additionalAttribute = this.vehicleOverviewList.filter(function (x) { return _this.HasValue(x.attributeList) && x.attributeList.length > 0; }).map(function (x) { return x.attributeList; }).sort();
	        var place = [];
	        additionalAttribute.forEach(function (element) {
	            element.forEach(function (element) {
	                place.push(element);
	            });
	        });
	        var flags = {};
	        this.additionalAttribute = place.filter(function (entry) {
	            if (flags[entry.attributeName]) {
	                return false;
	            }
	            flags[entry.attributeName] = true;
	            return true;
	        });
	    };
	    FilterVehicleOverviewDriverComponent.prototype.BrandFilter = function () {
	        var _this = this;
	        var brand = this.vehicleOverviewList.filter(function (x) { return _this.HasValue(x.brand); }).map(function (x) { return x.brand; }).sort();
	        this.brandList = this.JQueryHelper.Unique(brand);
	    };
	    FilterVehicleOverviewDriverComponent.prototype.TypeFilter = function () {
	        var _this = this;
	        var type = this.vehicleOverviewList.filter(function (x) { return _this.HasValue(x.type); }).map(function (x) { return x.type; }).sort();
	        this.typeList = this.JQueryHelper.Unique(type);
	    };
	    FilterVehicleOverviewDriverComponent.prototype.FuleFilter = function () {
	        var _this = this;
	        var fuelType = this.vehicleOverviewList.filter(function (x) { return _this.HasValue(x.fuelType); }).map(function (x) { return x.fuelType; }).sort();
	        this.fuleTypeList = this.JQueryHelper.Unique(fuelType);
	    };
	    FilterVehicleOverviewDriverComponent.prototype.BodyStyleFilter = function () {
	        var _this = this;
	        var bodyStyle = this.vehicleOverviewList.filter(function (x) { return _this.HasValue(x.bodyStyle); }).map(function (x) { return x.bodyStyle; }).sort();
	        this.bodyStyleList = this.JQueryHelper.Unique(bodyStyle);
	    };
	    FilterVehicleOverviewDriverComponent.prototype.PriceingCategoryFilter = function () {
	        var _this = this;
	        var pricingCategory = this.vehicleOverviewList.filter(function (x) { return _this.HasValue(x.pricingCategory); }).map(function (x) { return x.pricingCategory; }).sort();
	        this.priceingCategoryList = this.JQueryHelper.Unique(pricingCategory);
	    };
	    FilterVehicleOverviewDriverComponent.prototype.HasValue = function (input) {
	        if (input)
	            return true;
	        else
	            return false;
	    };
	    FilterVehicleOverviewDriverComponent.prototype.OnFilter = function (filterName, item, isChekced) {
	        if (filterName == 'brand') {
	            if (isChekced) {
	                if (!(this.selBrandList.indexOf(item) > -1)) {
	                    this.selBrandList.push(item);
	                }
	            }
	            else {
	                this.selBrandList = this.JQueryHelper.RemoveFromArray(this.selBrandList, item);
	            }
	        }
	        else if (filterName == 'type') {
	            if (isChekced) {
	                if (!(this.selTypeList.indexOf(item) > -1)) {
	                    this.selTypeList.push(item);
	                }
	            }
	            else {
	                this.selTypeList = this.JQueryHelper.RemoveFromArray(this.selTypeList, item);
	            }
	        }
	        else if (filterName == 'fuletype') {
	            if (isChekced) {
	                if (!(this.selFuleTypeList.indexOf(item) > -1)) {
	                    this.selFuleTypeList.push(item);
	                }
	            }
	            else {
	                this.selFuleTypeList = this.JQueryHelper.RemoveFromArray(this.selFuleTypeList, item);
	            }
	        }
	        else if (filterName == 'bodystyle') {
	            if (isChekced) {
	                if (!(this.selBodyStyleList.indexOf(item) > -1)) {
	                    this.selBodyStyleList.push(item);
	                }
	            }
	            else {
	                this.selBodyStyleList = this.JQueryHelper.RemoveFromArray(this.selBodyStyleList, item);
	            }
	        }
	        else if (filterName == 'pricingcategory') {
	            if (isChekced) {
	                if (!(this.selPriceingCategoryList.indexOf(item) > -1)) {
	                    this.selPriceingCategoryList.push(item);
	                }
	            }
	            else {
	                this.selPriceingCategoryList = this.JQueryHelper.RemoveFromArray(this.selPriceingCategoryList, item);
	            }
	        }
	        else if (filterName == 'additionalAttribute') {
	            if (isChekced) {
	                if (!(this.seladditionalAttribute.indexOf(item) > -1)) {
	                    this.seladditionalAttribute.push(item);
	                }
	            }
	            else {
	                this.seladditionalAttribute = this.JQueryHelper.RemoveFromArray(this.seladditionalAttribute, item);
	            }
	        }
	        this.UpdateVehicleOverView();
	    };
	    FilterVehicleOverviewDriverComponent.prototype.UpdateVehicleOverView = function () {
	        var _this = this;
	        var localList = this.vehicleOverviewList;
	        localList = localList.filter(function (x) { return _this.selBrandList.length == 0
	            || _this.selBrandList.indexOf(x.brand) > -1; })
	            .filter(function (x) { return _this.selTypeList.length == 0
	            || _this.selTypeList.indexOf(x.type) > -1; })
	            .filter(function (x) { return _this.selFuleTypeList.length == 0
	            || _this.selFuleTypeList.indexOf(x.fuelType) > -1; })
	            .filter(function (x) { return _this.selBodyStyleList.length == 0
	            || _this.selBodyStyleList.indexOf(x.bodyStyle) > -1; })
	            .filter(function (x) { return _this.selPriceingCategoryList.length == 0
	            || _this.selPriceingCategoryList.indexOf(x.pricingCategory) > -1; })
	            .filter(function (x) { return _this.seladditionalAttribute.length == 0
	            || _this.ArrayContainsArray(x.attributeList.map(function (y) { return y.attributeName; }), _this.seladditionalAttribute); });
	        // .filter(x => this.selAirco == false || x.airco == this.selAirco)
	        // .filter(x => this.selTowbar == false || x.towbar == this.selTowbar)
	        this.onUpdateVehicleOverView.emit({ FilterVehicleOverview: localList });
	    };
	    FilterVehicleOverviewDriverComponent.prototype.OnSearch = function ($event) {
	    };
	    FilterVehicleOverviewDriverComponent.prototype.intersect = function (a, b) {
	        var t;
	        if (b.length > a.length)
	            t = b, b = a, a = t; // indexOf to loop over shorter
	        return a.filter(function (e) {
	            if (b.indexOf(e) !== -1)
	                return true;
	        });
	    };
	    FilterVehicleOverviewDriverComponent.prototype.ArrayContainsArray = function (superset, subset) {
	        if (0 == subset.length) {
	            return true;
	        }
	        var retVal = subset.every(function (value) {
	            return (superset.indexOf(value) >= 0);
	        });
	        return retVal;
	    };
	    FilterVehicleOverviewDriverComponent.prototype.GroupByCategory = function (vehicleAttributeList) {
	        if (vehicleAttributeList) {
	            var prop_1 = 'vehicleAttributeCategoryName';
	            return vehicleAttributeList.reduce(function (groups, item) {
	                var val = item[prop_1];
	                groups[val] = groups[val] || [];
	                groups[val].push(item);
	                groups[val] = groups[val].sort(function (obj1, obj2) {
	                    if (obj1.vehicleAttributeCategoryName != obj2.vehicleAttributeCategoryName) {
	                        return 0;
	                    }
	                    if (obj1.attributeName > obj2.attributeName) {
	                        return 1;
	                    }
	                    if (obj1.attributeName < obj2.attributeName) {
	                        return -1;
	                    }
	                    return 0;
	                });
	                return groups;
	            }, {});
	        }
	        else {
	            return {};
	        }
	    };
	    FilterVehicleOverviewDriverComponent.prototype.KeyOfObject = function (obj) {
	        return Object.keys(obj);
	    };
	    __decorate([
	        core_1.Output('OnUpdateVehicleOverView'), 
	        __metadata('design:type', Object)
	    ], FilterVehicleOverviewDriverComponent.prototype, "onUpdateVehicleOverView", void 0);
	    __decorate([
	        core_1.Input('VehicleOverviewList'), 
	        __metadata('design:type', Array)
	    ], FilterVehicleOverviewDriverComponent.prototype, "vehicleOverviewList", void 0);
	    FilterVehicleOverviewDriverComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-filter-vehicle-overview-driver',
	            template: __webpack_require__(583),
	            styles: ["\n          .box.box-default{\n            border: 1px solid #ddd;\n            border-top: 3px solid #2BA2AA;\n          }\n          .box-body{\n            padding: 0px 10px;\n          }\n          "
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], FilterVehicleOverviewDriverComponent);
	    return FilterVehicleOverviewDriverComponent;
	}());
	exports.FilterVehicleOverviewDriverComponent = FilterVehicleOverviewDriverComponent;


/***/ },
/* 583 */
/***/ function(module, exports) {

	module.exports = "<div class=\"panel-group\">\r\n  <div *ngIf=\"brandList.length > 0\" class=\"panel panel-default\">\r\n    <div class=\"panel-heading\">\r\n      <h3 class=\"panel-title\"> {{ 'LblBrand' | translate }} </h3>\r\n    </div>\r\n    <div class=\"panel-body\" style=\"display: block;\">\r\n      <div class=\"checkbox\" *ngFor=\"let item of brandList\">\r\n        <label>\r\n        <input type=\"checkbox\" (change)=\"OnFilter('brand', item, $event.target.checked)\">\r\n        {{ item }}\r\n      </label>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div *ngIf=\"typeList.length > 0\" class=\"panel panel-default\">\r\n    <div class=\"panel-heading\">\r\n      <h3 class=\"panel-title\"> {{ 'LblType' | translate }} </h3>\r\n    </div>\r\n    <div class=\"panel-body\" style=\"display: block;\">\r\n      <div class=\"checkbox\" *ngFor=\"let item of typeList\">\r\n        <label>\r\n        <input type=\"checkbox\" (change)=\"OnFilter('type', item, $event.target.checked)\">\r\n        {{ item }}\r\n      </label>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div *ngIf=\"fuleTypeList.length > 0\" class=\"panel panel-default\">\r\n    <div class=\"panel-heading\">\r\n      <h3 class=\"panel-title\">{{ 'LblFuelType' | translate }}</h3>\r\n    </div>\r\n    <div class=\"panel-body\" style=\"display: block;\">\r\n      <div class=\"checkbox\" *ngFor=\"let item of fuleTypeList\">\r\n        <label>\r\n        <input type=\"checkbox\" (change)=\"OnFilter('fuletype', item, $event.target.checked)\">\r\n        {{ item }}\r\n      </label>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div *ngIf=\"bodyStyleList.length > 0\" class=\"panel panel-default\">\r\n    <div class=\"panel-heading\">\r\n      <h3 class=\"panel-title\">{{ 'LblBodyStyle' | translate }}</h3>\r\n    </div>\r\n    <div class=\"panel-body\" style=\"display: block;\">\r\n      <div class=\"checkbox\" *ngFor=\"let item of bodyStyleList\">\r\n        <label>\r\n        <input type=\"checkbox\" (change)=\"OnFilter('bodystyle', item, $event.target.checked)\">\r\n        {{ item }}\r\n      </label>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div *ngIf=\"priceingCategoryList.length > 0\" class=\"panel panel-default\">\r\n    <div class=\"panel-heading with-border\">\r\n      <h3 class=\"panel-title\">{{ 'LblPricingCategory' | translate }}</h3>\r\n    </div>\r\n    <div class=\"panel-body\" style=\"display: block;\">\r\n      <div class=\"checkbox\" *ngFor=\"let item of priceingCategoryList\">\r\n        <label>\r\n        <input type=\"checkbox\" (change)=\"OnFilter('pricingcategory', item, $event.target.checked)\">\r\n        {{ item }}\r\n      </label>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <!-- <div class=\"panel panel-default\">\r\n    <div class=\"panel-heading\">\r\n      <h3 class=\"panel-title\">{{ 'LblFeatures' | translate }}</h3>\r\n    </div>\r\n    <div class=\"panel-body\" style=\"display: block;\">\r\n      <div class=\"checkbox\">\r\n        <label>\r\n        <input type=\"checkbox\" [ngModel]=\"selAirco\" (ngModelChange)=\"selAirco = !selAirco; UpdateVehicleOverView();\">\r\n        {{ 'LblAirco' | translate }}\r\n      </label>\r\n      </div>\r\n      <div class=\"checkbox\">\r\n        <label>\r\n        <input type=\"checkbox\" [ngModel]=\"selTowbar\" (ngModelChange)=\"selTowbar = !selTowbar; UpdateVehicleOverView();\">\r\n        {{ 'LblTowbar' | translate }}\r\n      </label>\r\n      </div>\r\n    </div>\r\n  </div> -->\r\n  <div *ngIf=\"additionalAttribute.length > 0\" class=\"panel panel-default\">\r\n    <div class=\"panel-heading\">\r\n      <h3 class=\"panel-title\">{{ 'LbAdditionallVehicleAttribute' | translate }}</h3>\r\n    </div>\r\n    <div class=\"panel-body\" style=\"display: block;\">\r\n      <div *ngFor=\"let cat of KeyOfObject(GroupByCategory(additionalAttribute))\">\r\n        <label>{{ cat }}</label>\r\n        <div class=\"checkbox\" *ngFor=\"let item of GroupByCategory(additionalAttribute)[cat]\">\r\n          <label>\r\n        <input type=\"checkbox\" (change)=\"OnFilter('additionalAttribute', item.attributeName, $event.target.checked)\">\r\n        {{ item.attributeName }}\r\n      </label>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var translate_service_1 = __webpack_require__(70);
	var flatpickr_model_1 = __webpack_require__(83);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var booking_service_1 = __webpack_require__(556);
	var vehicle_service_1 = __webpack_require__(530);
	var sharedvehiclegroup_service_1 = __webpack_require__(510);
	var schedular_booking_model_1 = __webpack_require__(585);
	var core_1 = __webpack_require__(3);
	var $ = __webpack_require__(68);
	var moment = __webpack_require__(84);
	var fullCalendar = __webpack_require__(586);
	//declare var fullCalendar: any;
	var SchedularBookingDriverComponent = (function () {
	    function SchedularBookingDriverComponent(authService, bookigService, sharedVehicleGroupService, vehicleService, router, translate) {
	        this.authService = authService;
	        this.bookigService = bookigService;
	        this.sharedVehicleGroupService = sharedVehicleGroupService;
	        this.vehicleService = vehicleService;
	        this.router = router;
	        this.translate = translate;
	        this.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
	        this.isSharedVehicleGroupVisible = true;
	    }
	    SchedularBookingDriverComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
	        this.model = new schedular_booking_model_1.SchedulerBookingModel();
	        this.model.startDateTime = moment().utc().format('DD-MM-YYYY HH:mm');
	        this.model.endDateTime = moment().utc().add(1, 'M').format('DD-MM-YYYY HH:mm');
	        this.DataListModel = new config_1.DataListModel();
	        this.GetSharedVehicleGroupList();
	        this.GetVehicleList();
	        //this.GetScheduledBookingList();
	        var currentLang = this.translate.currentLang;
	        var LblWeekdays = this.translate.instant('LblWeekdays');
	        var LblMonths = this.translate.instant('LblMonths');
	        var LblButtonText = this.translate.instant('LblButtonText');
	        $('#calendar').fullCalendar({
	            header: {
	                left: 'prev,today,next ',
	                center: 'title',
	                right: 'month,agendaWeek,agendaDay'
	            },
	            displayEventEnd: {
	                month: true,
	                basicWeek: true,
	                default: true
	            },
	            eventRender: function (event, element) {
	                element.attr('href', 'javascript:void(0);');
	                element.click(function () {
	                    _this.bookingInfoModel.bookingInfo = event;
	                    _this.bookingInfoModel.show();
	                });
	            },
	            viewRender: function (view, element) {
	                if (_this.model) {
	                    _this.model.startDateTime = view.start.format('DD-MM-YYYY HH:mm');
	                    _this.model.endDateTime = view.end.format('DD-MM-YYYY HH:mm');
	                    _this.OnSearchVehicleBooking();
	                }
	            },
	            //locale: currentLang,
	            buttonText: LblButtonText,
	            monthNames: LblMonths.longhand,
	            monthNamesShort: LblMonths.shorthand,
	            dayNames: LblWeekdays.longhand,
	            dayNamesShort: LblWeekdays.shorthand,
	            navLinks: true,
	            editable: false,
	            eventLimit: true,
	        });
	    };
	    SchedularBookingDriverComponent.prototype.SetDefaultFlatPickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = true;
	        flatPickrConfig.time_24hr = true;
	        //flatPickrConfig.enableSeconds = true;
	        flatPickrConfig.dateFormat = this.dateFormat;
	        flatPickrConfig.minuteIncrement = 1;
	        return flatPickrConfig;
	    };
	    SchedularBookingDriverComponent.prototype.GetSharedVehicleGroupList = function () {
	        var _this = this;
	        this.sharedVehicleGroupService.GetSharedVehicleDropdownList()
	            .subscribe(function (res) {
	            _this.sharedVehicleGroupList = res.data;
	            if (_this.sharedVehicleGroupList.length > 0) {
	                _this.model.sharedVehicleGroupHashId = _this.model.sharedVehicleGroupHashId || _this.sharedVehicleGroupList.length > 1 ? '' : _this.sharedVehicleGroupList[0].keyHash;
	                if (_this.sharedVehicleGroupList.length > 1) {
	                    _this.isSharedVehicleGroupVisible = true;
	                }
	                else {
	                    _this.isSharedVehicleGroupVisible = false;
	                    _this.GetVehicleList();
	                }
	            }
	            else {
	                _this.isSharedVehicleGroupVisible = false;
	            }
	        }, function (error) {
	            _this.errorMessage = error;
	        });
	    };
	    SchedularBookingDriverComponent.prototype.GetVehicleList = function () {
	        var _this = this;
	        this.vehicleService.GetVehicleDropdownListBySVGID(this.model.sharedVehicleGroupHashId)
	            .subscribe(function (res) {
	            _this.VehicleList = res.data;
	            _this.model.vehicleHashId = _this.model.vehicleHashId || _this.VehicleList.length > 0 ? '' : '';
	        }, function (error) {
	            _this.errorMessage = error;
	        });
	    };
	    SchedularBookingDriverComponent.prototype.onChangeSelectedSVG = function (selectedField) {
	        this.model.sharedVehicleGroupHashId = selectedField;
	        this.GetVehicleList();
	        console.log(this.model.sharedVehicleGroupHashId);
	    };
	    SchedularBookingDriverComponent.prototype.onChangeSelectedVehicle = function (selectedField) {
	        this.model.vehicleHashId = selectedField;
	        console.log(this.model.vehicleHashId);
	    };
	    SchedularBookingDriverComponent.prototype.OnSearchVehicleBooking = function () {
	        console.log(this.model);
	        this.GetScheduledBookingList();
	    };
	    SchedularBookingDriverComponent.prototype.GetScheduledBookingList = function () {
	        var _this = this;
	        this.bookigService.GetScheduledBookingList(this.model)
	            .subscribe(function (res) {
	            if (!res.data) {
	                _this.errorModel = res.error;
	            }
	            else {
	                _this.bookingList = res.data;
	                $('#calendar').fullCalendar('removeEvents');
	                //$('#calendar').fullCalendar('refetchEvents');
	                $('#calendar').fullCalendar('addEventSource', { events: _this.bookingList });
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    __decorate([
	        core_1.ViewChild('bookingInfoModel'), 
	        __metadata('design:type', Object)
	    ], SchedularBookingDriverComponent.prototype, "bookingInfoModel", void 0);
	    SchedularBookingDriverComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-scheduler-booking-driver',
	            template: __webpack_require__(587),
	            styles: ["\n          .box.box-default{\n            border: 1px solid #ddd;\n            border-top: 3px solid #2BA2AA;\n          }\n          .box-body{\n            padding: 0px 10px 10px;\n          }\n          "
	            ],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof booking_service_1.BookingService !== 'undefined' && booking_service_1.BookingService) === 'function' && _b) || Object, (typeof (_c = typeof sharedvehiclegroup_service_1.SharedVehicleGroupService !== 'undefined' && sharedvehiclegroup_service_1.SharedVehicleGroupService) === 'function' && _c) || Object, (typeof (_d = typeof vehicle_service_1.VehicleService !== 'undefined' && vehicle_service_1.VehicleService) === 'function' && _d) || Object, (typeof (_e = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _e) || Object, (typeof (_f = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _f) || Object])
	    ], SchedularBookingDriverComponent);
	    return SchedularBookingDriverComponent;
	    var _a, _b, _c, _d, _e, _f;
	}());
	exports.SchedularBookingDriverComponent = SchedularBookingDriverComponent;


/***/ },
/* 585 */
/***/ function(module, exports) {

	"use strict";
	var SchedulerBookingModel = (function () {
	    function SchedulerBookingModel() {
	        this.sharedVehicleGroupHashId = '';
	        this.vehicleHashId = '';
	        this.toggleOption = true;
	    }
	    return SchedulerBookingModel;
	}());
	exports.SchedulerBookingModel = SchedulerBookingModel;


/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * FullCalendar v3.1.0
	 * Docs & License: http://fullcalendar.io/
	 * (c) 2016 Adam Shaw
	 */
	
	(function(factory) {
		if (true) {
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [ __webpack_require__(68), __webpack_require__(84) ], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}
		else if (typeof exports === 'object') { // Node/CommonJS
			module.exports = factory(require('jquery'), require('moment'));
		}
		else {
			factory(jQuery, moment);
		}
	})(function($, moment) {
	
	;;
	
	var FC = $.fullCalendar = {
		version: "3.1.0",
		internalApiVersion: 7
	};
	var fcViews = FC.views = {};
	
	
	$.fn.fullCalendar = function(options) {
		var args = Array.prototype.slice.call(arguments, 1); // for a possible method call
		var res = this; // what this function will return (this jQuery object by default)
	
		this.each(function(i, _element) { // loop each DOM element involved
			var element = $(_element);
			var calendar = element.data('fullCalendar'); // get the existing calendar object (if any)
			var singleRes; // the returned value of this single method call
	
			// a method call
			if (typeof options === 'string') {
				if (calendar && $.isFunction(calendar[options])) {
					singleRes = calendar[options].apply(calendar, args);
					if (!i) {
						res = singleRes; // record the first method call result
					}
					if (options === 'destroy') { // for the destroy method, must remove Calendar object data
						element.removeData('fullCalendar');
					}
				}
			}
			// a new calendar initialization
			else if (!calendar) { // don't initialize twice
				calendar = new Calendar(element, options);
				element.data('fullCalendar', calendar);
				calendar.render();
			}
		});
	
		return res;
	};
	
	
	var complexOptions = [ // names of options that are objects whose properties should be combined
		'header',
		'footer',
		'buttonText',
		'buttonIcons',
		'themeButtonIcons'
	];
	
	
	// Merges an array of option objects into a single object
	function mergeOptions(optionObjs) {
		return mergeProps(optionObjs, complexOptions);
	}
	
	;;
	
	// exports
	FC.intersectRanges = intersectRanges;
	FC.applyAll = applyAll;
	FC.debounce = debounce;
	FC.isInt = isInt;
	FC.htmlEscape = htmlEscape;
	FC.cssToStr = cssToStr;
	FC.proxy = proxy;
	FC.capitaliseFirstLetter = capitaliseFirstLetter;
	
	
	/* FullCalendar-specific DOM Utilities
	----------------------------------------------------------------------------------------------------------------------*/
	
	
	// Given the scrollbar widths of some other container, create borders/margins on rowEls in order to match the left
	// and right space that was offset by the scrollbars. A 1-pixel border first, then margin beyond that.
	function compensateScroll(rowEls, scrollbarWidths) {
		if (scrollbarWidths.left) {
			rowEls.css({
				'border-left-width': 1,
				'margin-left': scrollbarWidths.left - 1
			});
		}
		if (scrollbarWidths.right) {
			rowEls.css({
				'border-right-width': 1,
				'margin-right': scrollbarWidths.right - 1
			});
		}
	}
	
	
	// Undoes compensateScroll and restores all borders/margins
	function uncompensateScroll(rowEls) {
		rowEls.css({
			'margin-left': '',
			'margin-right': '',
			'border-left-width': '',
			'border-right-width': ''
		});
	}
	
	
	// Make the mouse cursor express that an event is not allowed in the current area
	function disableCursor() {
		$('body').addClass('fc-not-allowed');
	}
	
	
	// Returns the mouse cursor to its original look
	function enableCursor() {
		$('body').removeClass('fc-not-allowed');
	}
	
	
	// Given a total available height to fill, have `els` (essentially child rows) expand to accomodate.
	// By default, all elements that are shorter than the recommended height are expanded uniformly, not considering
	// any other els that are already too tall. if `shouldRedistribute` is on, it considers these tall rows and 
	// reduces the available height.
	function distributeHeight(els, availableHeight, shouldRedistribute) {
	
		// *FLOORING NOTE*: we floor in certain places because zoom can give inaccurate floating-point dimensions,
		// and it is better to be shorter than taller, to avoid creating unnecessary scrollbars.
	
		var minOffset1 = Math.floor(availableHeight / els.length); // for non-last element
		var minOffset2 = Math.floor(availableHeight - minOffset1 * (els.length - 1)); // for last element *FLOORING NOTE*
		var flexEls = []; // elements that are allowed to expand. array of DOM nodes
		var flexOffsets = []; // amount of vertical space it takes up
		var flexHeights = []; // actual css height
		var usedHeight = 0;
	
		undistributeHeight(els); // give all elements their natural height
	
		// find elements that are below the recommended height (expandable).
		// important to query for heights in a single first pass (to avoid reflow oscillation).
		els.each(function(i, el) {
			var minOffset = i === els.length - 1 ? minOffset2 : minOffset1;
			var naturalOffset = $(el).outerHeight(true);
	
			if (naturalOffset < minOffset) {
				flexEls.push(el);
				flexOffsets.push(naturalOffset);
				flexHeights.push($(el).height());
			}
			else {
				// this element stretches past recommended height (non-expandable). mark the space as occupied.
				usedHeight += naturalOffset;
			}
		});
	
		// readjust the recommended height to only consider the height available to non-maxed-out rows.
		if (shouldRedistribute) {
			availableHeight -= usedHeight;
			minOffset1 = Math.floor(availableHeight / flexEls.length);
			minOffset2 = Math.floor(availableHeight - minOffset1 * (flexEls.length - 1)); // *FLOORING NOTE*
		}
	
		// assign heights to all expandable elements
		$(flexEls).each(function(i, el) {
			var minOffset = i === flexEls.length - 1 ? minOffset2 : minOffset1;
			var naturalOffset = flexOffsets[i];
			var naturalHeight = flexHeights[i];
			var newHeight = minOffset - (naturalOffset - naturalHeight); // subtract the margin/padding
	
			if (naturalOffset < minOffset) { // we check this again because redistribution might have changed things
				$(el).height(newHeight);
			}
		});
	}
	
	
	// Undoes distrubuteHeight, restoring all els to their natural height
	function undistributeHeight(els) {
		els.height('');
	}
	
	
	// Given `els`, a jQuery set of <td> cells, find the cell with the largest natural width and set the widths of all the
	// cells to be that width.
	// PREREQUISITE: if you want a cell to take up width, it needs to have a single inner element w/ display:inline
	function matchCellWidths(els) {
		var maxInnerWidth = 0;
	
		els.find('> *').each(function(i, innerEl) {
			var innerWidth = $(innerEl).outerWidth();
			if (innerWidth > maxInnerWidth) {
				maxInnerWidth = innerWidth;
			}
		});
	
		maxInnerWidth++; // sometimes not accurate of width the text needs to stay on one line. insurance
	
		els.width(maxInnerWidth);
	
		return maxInnerWidth;
	}
	
	
	// Given one element that resides inside another,
	// Subtracts the height of the inner element from the outer element.
	function subtractInnerElHeight(outerEl, innerEl) {
		var both = outerEl.add(innerEl);
		var diff;
	
		// effin' IE8/9/10/11 sometimes returns 0 for dimensions. this weird hack was the only thing that worked
		both.css({
			position: 'relative', // cause a reflow, which will force fresh dimension recalculation
			left: -1 // ensure reflow in case the el was already relative. negative is less likely to cause new scroll
		});
		diff = outerEl.outerHeight() - innerEl.outerHeight(); // grab the dimensions
		both.css({ position: '', left: '' }); // undo hack
	
		return diff;
	}
	
	
	/* Element Geom Utilities
	----------------------------------------------------------------------------------------------------------------------*/
	
	FC.getOuterRect = getOuterRect;
	FC.getClientRect = getClientRect;
	FC.getContentRect = getContentRect;
	FC.getScrollbarWidths = getScrollbarWidths;
	
	
	// borrowed from https://github.com/jquery/jquery-ui/blob/1.11.0/ui/core.js#L51
	function getScrollParent(el) {
		var position = el.css('position'),
			scrollParent = el.parents().filter(function() {
				var parent = $(this);
				return (/(auto|scroll)/).test(
					parent.css('overflow') + parent.css('overflow-y') + parent.css('overflow-x')
				);
			}).eq(0);
	
		return position === 'fixed' || !scrollParent.length ? $(el[0].ownerDocument || document) : scrollParent;
	}
	
	
	// Queries the outer bounding area of a jQuery element.
	// Returns a rectangle with absolute coordinates: left, right (exclusive), top, bottom (exclusive).
	// Origin is optional.
	function getOuterRect(el, origin) {
		var offset = el.offset();
		var left = offset.left - (origin ? origin.left : 0);
		var top = offset.top - (origin ? origin.top : 0);
	
		return {
			left: left,
			right: left + el.outerWidth(),
			top: top,
			bottom: top + el.outerHeight()
		};
	}
	
	
	// Queries the area within the margin/border/scrollbars of a jQuery element. Does not go within the padding.
	// Returns a rectangle with absolute coordinates: left, right (exclusive), top, bottom (exclusive).
	// Origin is optional.
	// NOTE: should use clientLeft/clientTop, but very unreliable cross-browser.
	function getClientRect(el, origin) {
		var offset = el.offset();
		var scrollbarWidths = getScrollbarWidths(el);
		var left = offset.left + getCssFloat(el, 'border-left-width') + scrollbarWidths.left - (origin ? origin.left : 0);
		var top = offset.top + getCssFloat(el, 'border-top-width') + scrollbarWidths.top - (origin ? origin.top : 0);
	
		return {
			left: left,
			right: left + el[0].clientWidth, // clientWidth includes padding but NOT scrollbars
			top: top,
			bottom: top + el[0].clientHeight // clientHeight includes padding but NOT scrollbars
		};
	}
	
	
	// Queries the area within the margin/border/padding of a jQuery element. Assumed not to have scrollbars.
	// Returns a rectangle with absolute coordinates: left, right (exclusive), top, bottom (exclusive).
	// Origin is optional.
	function getContentRect(el, origin) {
		var offset = el.offset(); // just outside of border, margin not included
		var left = offset.left + getCssFloat(el, 'border-left-width') + getCssFloat(el, 'padding-left') -
			(origin ? origin.left : 0);
		var top = offset.top + getCssFloat(el, 'border-top-width') + getCssFloat(el, 'padding-top') -
			(origin ? origin.top : 0);
	
		return {
			left: left,
			right: left + el.width(),
			top: top,
			bottom: top + el.height()
		};
	}
	
	
	// Returns the computed left/right/top/bottom scrollbar widths for the given jQuery element.
	// NOTE: should use clientLeft/clientTop, but very unreliable cross-browser.
	function getScrollbarWidths(el) {
		var leftRightWidth = el.innerWidth() - el[0].clientWidth; // the paddings cancel out, leaving the scrollbars
		var widths = {
			left: 0,
			right: 0,
			top: 0,
			bottom: el.innerHeight() - el[0].clientHeight // the paddings cancel out, leaving the bottom scrollbar
		};
	
		if (getIsLeftRtlScrollbars() && el.css('direction') == 'rtl') { // is the scrollbar on the left side?
			widths.left = leftRightWidth;
		}
		else {
			widths.right = leftRightWidth;
		}
	
		return widths;
	}
	
	
	// Logic for determining if, when the element is right-to-left, the scrollbar appears on the left side
	
	var _isLeftRtlScrollbars = null;
	
	function getIsLeftRtlScrollbars() { // responsible for caching the computation
		if (_isLeftRtlScrollbars === null) {
			_isLeftRtlScrollbars = computeIsLeftRtlScrollbars();
		}
		return _isLeftRtlScrollbars;
	}
	
	function computeIsLeftRtlScrollbars() { // creates an offscreen test element, then removes it
		var el = $('<div><div/></div>')
			.css({
				position: 'absolute',
				top: -1000,
				left: 0,
				border: 0,
				padding: 0,
				overflow: 'scroll',
				direction: 'rtl'
			})
			.appendTo('body');
		var innerEl = el.children();
		var res = innerEl.offset().left > el.offset().left; // is the inner div shifted to accommodate a left scrollbar?
		el.remove();
		return res;
	}
	
	
	// Retrieves a jQuery element's computed CSS value as a floating-point number.
	// If the queried value is non-numeric (ex: IE can return "medium" for border width), will just return zero.
	function getCssFloat(el, prop) {
		return parseFloat(el.css(prop)) || 0;
	}
	
	
	/* Mouse / Touch Utilities
	----------------------------------------------------------------------------------------------------------------------*/
	
	FC.preventDefault = preventDefault;
	
	
	// Returns a boolean whether this was a left mouse click and no ctrl key (which means right click on Mac)
	function isPrimaryMouseButton(ev) {
		return ev.which == 1 && !ev.ctrlKey;
	}
	
	
	function getEvX(ev) {
		if (ev.pageX !== undefined) {
			return ev.pageX;
		}
		var touches = ev.originalEvent.touches;
		if (touches) {
			return touches[0].pageX;
		}
	}
	
	
	function getEvY(ev) {
		if (ev.pageY !== undefined) {
			return ev.pageY;
		}
		var touches = ev.originalEvent.touches;
		if (touches) {
			return touches[0].pageY;
		}
	}
	
	
	function getEvIsTouch(ev) {
		return /^touch/.test(ev.type);
	}
	
	
	function preventSelection(el) {
		el.addClass('fc-unselectable')
			.on('selectstart', preventDefault);
	}
	
	
	// Stops a mouse/touch event from doing it's native browser action
	function preventDefault(ev) {
		ev.preventDefault();
	}
	
	
	// attach a handler to get called when ANY scroll action happens on the page.
	// this was impossible to do with normal on/off because 'scroll' doesn't bubble.
	// http://stackoverflow.com/a/32954565/96342
	// returns `true` on success.
	function bindAnyScroll(handler) {
		if (window.addEventListener) {
			window.addEventListener('scroll', handler, true); // useCapture=true
			return true;
		}
		return false;
	}
	
	
	// undoes bindAnyScroll. must pass in the original function.
	// returns `true` on success.
	function unbindAnyScroll(handler) {
		if (window.removeEventListener) {
			window.removeEventListener('scroll', handler, true); // useCapture=true
			return true;
		}
		return false;
	}
	
	
	/* General Geometry Utils
	----------------------------------------------------------------------------------------------------------------------*/
	
	FC.intersectRects = intersectRects;
	
	// Returns a new rectangle that is the intersection of the two rectangles. If they don't intersect, returns false
	function intersectRects(rect1, rect2) {
		var res = {
			left: Math.max(rect1.left, rect2.left),
			right: Math.min(rect1.right, rect2.right),
			top: Math.max(rect1.top, rect2.top),
			bottom: Math.min(rect1.bottom, rect2.bottom)
		};
	
		if (res.left < res.right && res.top < res.bottom) {
			return res;
		}
		return false;
	}
	
	
	// Returns a new point that will have been moved to reside within the given rectangle
	function constrainPoint(point, rect) {
		return {
			left: Math.min(Math.max(point.left, rect.left), rect.right),
			top: Math.min(Math.max(point.top, rect.top), rect.bottom)
		};
	}
	
	
	// Returns a point that is the center of the given rectangle
	function getRectCenter(rect) {
		return {
			left: (rect.left + rect.right) / 2,
			top: (rect.top + rect.bottom) / 2
		};
	}
	
	
	// Subtracts point2's coordinates from point1's coordinates, returning a delta
	function diffPoints(point1, point2) {
		return {
			left: point1.left - point2.left,
			top: point1.top - point2.top
		};
	}
	
	
	/* Object Ordering by Field
	----------------------------------------------------------------------------------------------------------------------*/
	
	FC.parseFieldSpecs = parseFieldSpecs;
	FC.compareByFieldSpecs = compareByFieldSpecs;
	FC.compareByFieldSpec = compareByFieldSpec;
	FC.flexibleCompare = flexibleCompare;
	
	
	function parseFieldSpecs(input) {
		var specs = [];
		var tokens = [];
		var i, token;
	
		if (typeof input === 'string') {
			tokens = input.split(/\s*,\s*/);
		}
		else if (typeof input === 'function') {
			tokens = [ input ];
		}
		else if ($.isArray(input)) {
			tokens = input;
		}
	
		for (i = 0; i < tokens.length; i++) {
			token = tokens[i];
	
			if (typeof token === 'string') {
				specs.push(
					token.charAt(0) == '-' ?
						{ field: token.substring(1), order: -1 } :
						{ field: token, order: 1 }
				);
			}
			else if (typeof token === 'function') {
				specs.push({ func: token });
			}
		}
	
		return specs;
	}
	
	
	function compareByFieldSpecs(obj1, obj2, fieldSpecs) {
		var i;
		var cmp;
	
		for (i = 0; i < fieldSpecs.length; i++) {
			cmp = compareByFieldSpec(obj1, obj2, fieldSpecs[i]);
			if (cmp) {
				return cmp;
			}
		}
	
		return 0;
	}
	
	
	function compareByFieldSpec(obj1, obj2, fieldSpec) {
		if (fieldSpec.func) {
			return fieldSpec.func(obj1, obj2);
		}
		return flexibleCompare(obj1[fieldSpec.field], obj2[fieldSpec.field]) *
			(fieldSpec.order || 1);
	}
	
	
	function flexibleCompare(a, b) {
		if (!a && !b) {
			return 0;
		}
		if (b == null) {
			return -1;
		}
		if (a == null) {
			return 1;
		}
		if ($.type(a) === 'string' || $.type(b) === 'string') {
			return String(a).localeCompare(String(b));
		}
		return a - b;
	}
	
	
	/* FullCalendar-specific Misc Utilities
	----------------------------------------------------------------------------------------------------------------------*/
	
	
	// Computes the intersection of the two ranges. Will return fresh date clones in a range.
	// Returns undefined if no intersection.
	// Expects all dates to be normalized to the same timezone beforehand.
	// TODO: move to date section?
	function intersectRanges(subjectRange, constraintRange) {
		var subjectStart = subjectRange.start;
		var subjectEnd = subjectRange.end;
		var constraintStart = constraintRange.start;
		var constraintEnd = constraintRange.end;
		var segStart, segEnd;
		var isStart, isEnd;
	
		if (subjectEnd > constraintStart && subjectStart < constraintEnd) { // in bounds at all?
	
			if (subjectStart >= constraintStart) {
				segStart = subjectStart.clone();
				isStart = true;
			}
			else {
				segStart = constraintStart.clone();
				isStart =  false;
			}
	
			if (subjectEnd <= constraintEnd) {
				segEnd = subjectEnd.clone();
				isEnd = true;
			}
			else {
				segEnd = constraintEnd.clone();
				isEnd = false;
			}
	
			return {
				start: segStart,
				end: segEnd,
				isStart: isStart,
				isEnd: isEnd
			};
		}
	}
	
	
	/* Date Utilities
	----------------------------------------------------------------------------------------------------------------------*/
	
	FC.computeIntervalUnit = computeIntervalUnit;
	FC.divideRangeByDuration = divideRangeByDuration;
	FC.divideDurationByDuration = divideDurationByDuration;
	FC.multiplyDuration = multiplyDuration;
	FC.durationHasTime = durationHasTime;
	
	var dayIDs = [ 'sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat' ];
	var intervalUnits = [ 'year', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond' ];
	
	
	// Diffs the two moments into a Duration where full-days are recorded first, then the remaining time.
	// Moments will have their timezones normalized.
	function diffDayTime(a, b) {
		return moment.duration({
			days: a.clone().stripTime().diff(b.clone().stripTime(), 'days'),
			ms: a.time() - b.time() // time-of-day from day start. disregards timezone
		});
	}
	
	
	// Diffs the two moments via their start-of-day (regardless of timezone). Produces whole-day durations.
	function diffDay(a, b) {
		return moment.duration({
			days: a.clone().stripTime().diff(b.clone().stripTime(), 'days')
		});
	}
	
	
	// Diffs two moments, producing a duration, made of a whole-unit-increment of the given unit. Uses rounding.
	function diffByUnit(a, b, unit) {
		return moment.duration(
			Math.round(a.diff(b, unit, true)), // returnFloat=true
			unit
		);
	}
	
	
	// Computes the unit name of the largest whole-unit period of time.
	// For example, 48 hours will be "days" whereas 49 hours will be "hours".
	// Accepts start/end, a range object, or an original duration object.
	function computeIntervalUnit(start, end) {
		var i, unit;
		var val;
	
		for (i = 0; i < intervalUnits.length; i++) {
			unit = intervalUnits[i];
			val = computeRangeAs(unit, start, end);
	
			if (val >= 1 && isInt(val)) {
				break;
			}
		}
	
		return unit; // will be "milliseconds" if nothing else matches
	}
	
	
	// Computes the number of units (like "hours") in the given range.
	// Range can be a {start,end} object, separate start/end args, or a Duration.
	// Results are based on Moment's .as() and .diff() methods, so results can depend on internal handling
	// of month-diffing logic (which tends to vary from version to version).
	function computeRangeAs(unit, start, end) {
	
		if (end != null) { // given start, end
			return end.diff(start, unit, true);
		}
		else if (moment.isDuration(start)) { // given duration
			return start.as(unit);
		}
		else { // given { start, end } range object
			return start.end.diff(start.start, unit, true);
		}
	}
	
	
	// Intelligently divides a range (specified by a start/end params) by a duration
	function divideRangeByDuration(start, end, dur) {
		var months;
	
		if (durationHasTime(dur)) {
			return (end - start) / dur;
		}
		months = dur.asMonths();
		if (Math.abs(months) >= 1 && isInt(months)) {
			return end.diff(start, 'months', true) / months;
		}
		return end.diff(start, 'days', true) / dur.asDays();
	}
	
	
	// Intelligently divides one duration by another
	function divideDurationByDuration(dur1, dur2) {
		var months1, months2;
	
		if (durationHasTime(dur1) || durationHasTime(dur2)) {
			return dur1 / dur2;
		}
		months1 = dur1.asMonths();
		months2 = dur2.asMonths();
		if (
			Math.abs(months1) >= 1 && isInt(months1) &&
			Math.abs(months2) >= 1 && isInt(months2)
		) {
			return months1 / months2;
		}
		return dur1.asDays() / dur2.asDays();
	}
	
	
	// Intelligently multiplies a duration by a number
	function multiplyDuration(dur, n) {
		var months;
	
		if (durationHasTime(dur)) {
			return moment.duration(dur * n);
		}
		months = dur.asMonths();
		if (Math.abs(months) >= 1 && isInt(months)) {
			return moment.duration({ months: months * n });
		}
		return moment.duration({ days: dur.asDays() * n });
	}
	
	
	// Returns a boolean about whether the given duration has any time parts (hours/minutes/seconds/ms)
	function durationHasTime(dur) {
		return Boolean(dur.hours() || dur.minutes() || dur.seconds() || dur.milliseconds());
	}
	
	
	function isNativeDate(input) {
		return  Object.prototype.toString.call(input) === '[object Date]' || input instanceof Date;
	}
	
	
	// Returns a boolean about whether the given input is a time string, like "06:40:00" or "06:00"
	function isTimeString(str) {
		return /^\d+\:\d+(?:\:\d+\.?(?:\d{3})?)?$/.test(str);
	}
	
	
	/* Logging and Debug
	----------------------------------------------------------------------------------------------------------------------*/
	
	FC.log = function() {
		var console = window.console;
	
		if (console && console.log) {
			return console.log.apply(console, arguments);
		}
	};
	
	FC.warn = function() {
		var console = window.console;
	
		if (console && console.warn) {
			return console.warn.apply(console, arguments);
		}
		else {
			return FC.log.apply(FC, arguments);
		}
	};
	
	
	/* General Utilities
	----------------------------------------------------------------------------------------------------------------------*/
	
	var hasOwnPropMethod = {}.hasOwnProperty;
	
	
	// Merges an array of objects into a single object.
	// The second argument allows for an array of property names who's object values will be merged together.
	function mergeProps(propObjs, complexProps) {
		var dest = {};
		var i, name;
		var complexObjs;
		var j, val;
		var props;
	
		if (complexProps) {
			for (i = 0; i < complexProps.length; i++) {
				name = complexProps[i];
				complexObjs = [];
	
				// collect the trailing object values, stopping when a non-object is discovered
				for (j = propObjs.length - 1; j >= 0; j--) {
					val = propObjs[j][name];
	
					if (typeof val === 'object') {
						complexObjs.unshift(val);
					}
					else if (val !== undefined) {
						dest[name] = val; // if there were no objects, this value will be used
						break;
					}
				}
	
				// if the trailing values were objects, use the merged value
				if (complexObjs.length) {
					dest[name] = mergeProps(complexObjs);
				}
			}
		}
	
		// copy values into the destination, going from last to first
		for (i = propObjs.length - 1; i >= 0; i--) {
			props = propObjs[i];
	
			for (name in props) {
				if (!(name in dest)) { // if already assigned by previous props or complex props, don't reassign
					dest[name] = props[name];
				}
			}
		}
	
		return dest;
	}
	
	
	// Create an object that has the given prototype. Just like Object.create
	function createObject(proto) {
		var f = function() {};
		f.prototype = proto;
		return new f();
	}
	FC.createObject = createObject;
	
	
	function copyOwnProps(src, dest) {
		for (var name in src) {
			if (hasOwnProp(src, name)) {
				dest[name] = src[name];
			}
		}
	}
	
	
	function hasOwnProp(obj, name) {
		return hasOwnPropMethod.call(obj, name);
	}
	
	
	// Is the given value a non-object non-function value?
	function isAtomic(val) {
		return /undefined|null|boolean|number|string/.test($.type(val));
	}
	
	
	function applyAll(functions, thisObj, args) {
		if ($.isFunction(functions)) {
			functions = [ functions ];
		}
		if (functions) {
			var i;
			var ret;
			for (i=0; i<functions.length; i++) {
				ret = functions[i].apply(thisObj, args) || ret;
			}
			return ret;
		}
	}
	
	
	function firstDefined() {
		for (var i=0; i<arguments.length; i++) {
			if (arguments[i] !== undefined) {
				return arguments[i];
			}
		}
	}
	
	
	function htmlEscape(s) {
		return (s + '').replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/'/g, '&#039;')
			.replace(/"/g, '&quot;')
			.replace(/\n/g, '<br />');
	}
	
	
	function stripHtmlEntities(text) {
		return text.replace(/&.*?;/g, '');
	}
	
	
	// Given a hash of CSS properties, returns a string of CSS.
	// Uses property names as-is (no camel-case conversion). Will not make statements for null/undefined values.
	function cssToStr(cssProps) {
		var statements = [];
	
		$.each(cssProps, function(name, val) {
			if (val != null) {
				statements.push(name + ':' + val);
			}
		});
	
		return statements.join(';');
	}
	
	
	// Given an object hash of HTML attribute names to values,
	// generates a string that can be injected between < > in HTML
	function attrsToStr(attrs) {
		var parts = [];
	
		$.each(attrs, function(name, val) {
			if (val != null) {
				parts.push(name + '="' + htmlEscape(val) + '"');
			}
		});
	
		return parts.join(' ');
	}
	
	
	function capitaliseFirstLetter(str) {
		return str.charAt(0).toUpperCase() + str.slice(1);
	}
	
	
	function compareNumbers(a, b) { // for .sort()
		return a - b;
	}
	
	
	function isInt(n) {
		return n % 1 === 0;
	}
	
	
	// Returns a method bound to the given object context.
	// Just like one of the jQuery.proxy signatures, but without the undesired behavior of treating the same method with
	// different contexts as identical when binding/unbinding events.
	function proxy(obj, methodName) {
		var method = obj[methodName];
	
		return function() {
			return method.apply(obj, arguments);
		};
	}
	
	
	// Returns a function, that, as long as it continues to be invoked, will not
	// be triggered. The function will be called after it stops being called for
	// N milliseconds. If `immediate` is passed, trigger the function on the
	// leading edge, instead of the trailing.
	// https://github.com/jashkenas/underscore/blob/1.6.0/underscore.js#L714
	function debounce(func, wait, immediate) {
		var timeout, args, context, timestamp, result;
	
		var later = function() {
			var last = +new Date() - timestamp;
			if (last < wait) {
				timeout = setTimeout(later, wait - last);
			}
			else {
				timeout = null;
				if (!immediate) {
					result = func.apply(context, args);
					context = args = null;
				}
			}
		};
	
		return function() {
			context = this;
			args = arguments;
			timestamp = +new Date();
			var callNow = immediate && !timeout;
			if (!timeout) {
				timeout = setTimeout(later, wait);
			}
			if (callNow) {
				result = func.apply(context, args);
				context = args = null;
			}
			return result;
		};
	}
	
	;;
	
	/*
	GENERAL NOTE on moments throughout the *entire rest* of the codebase:
	All moments are assumed to be ambiguously-zoned unless otherwise noted,
	with the NOTABLE EXCEOPTION of start/end dates that live on *Event Objects*.
	Ambiguously-TIMED moments are assumed to be ambiguously-zoned by nature.
	*/
	
	var ambigDateOfMonthRegex = /^\s*\d{4}-\d\d$/;
	var ambigTimeOrZoneRegex =
		/^\s*\d{4}-(?:(\d\d-\d\d)|(W\d\d$)|(W\d\d-\d)|(\d\d\d))((T| )(\d\d(:\d\d(:\d\d(\.\d+)?)?)?)?)?$/;
	var newMomentProto = moment.fn; // where we will attach our new methods
	var oldMomentProto = $.extend({}, newMomentProto); // copy of original moment methods
	
	// tell momentjs to transfer these properties upon clone
	var momentProperties = moment.momentProperties;
	momentProperties.push('_fullCalendar');
	momentProperties.push('_ambigTime');
	momentProperties.push('_ambigZone');
	
	
	// Creating
	// -------------------------------------------------------------------------------------------------
	
	// Creates a new moment, similar to the vanilla moment(...) constructor, but with
	// extra features (ambiguous time, enhanced formatting). When given an existing moment,
	// it will function as a clone (and retain the zone of the moment). Anything else will
	// result in a moment in the local zone.
	FC.moment = function() {
		return makeMoment(arguments);
	};
	
	// Sames as FC.moment, but forces the resulting moment to be in the UTC timezone.
	FC.moment.utc = function() {
		var mom = makeMoment(arguments, true);
	
		// Force it into UTC because makeMoment doesn't guarantee it
		// (if given a pre-existing moment for example)
		if (mom.hasTime()) { // don't give ambiguously-timed moments a UTC zone
			mom.utc();
		}
	
		return mom;
	};
	
	// Same as FC.moment, but when given an ISO8601 string, the timezone offset is preserved.
	// ISO8601 strings with no timezone offset will become ambiguously zoned.
	FC.moment.parseZone = function() {
		return makeMoment(arguments, true, true);
	};
	
	// Builds an enhanced moment from args. When given an existing moment, it clones. When given a
	// native Date, or called with no arguments (the current time), the resulting moment will be local.
	// Anything else needs to be "parsed" (a string or an array), and will be affected by:
	//    parseAsUTC - if there is no zone information, should we parse the input in UTC?
	//    parseZone - if there is zone information, should we force the zone of the moment?
	function makeMoment(args, parseAsUTC, parseZone) {
		var input = args[0];
		var isSingleString = args.length == 1 && typeof input === 'string';
		var isAmbigTime;
		var isAmbigZone;
		var ambigMatch;
		var mom;
	
		if (moment.isMoment(input) || isNativeDate(input) || input === undefined) {
			mom = moment.apply(null, args);
		}
		else { // "parsing" is required
			isAmbigTime = false;
			isAmbigZone = false;
	
			if (isSingleString) {
				if (ambigDateOfMonthRegex.test(input)) {
					// accept strings like '2014-05', but convert to the first of the month
					input += '-01';
					args = [ input ]; // for when we pass it on to moment's constructor
					isAmbigTime = true;
					isAmbigZone = true;
				}
				else if ((ambigMatch = ambigTimeOrZoneRegex.exec(input))) {
					isAmbigTime = !ambigMatch[5]; // no time part?
					isAmbigZone = true;
				}
			}
			else if ($.isArray(input)) {
				// arrays have no timezone information, so assume ambiguous zone
				isAmbigZone = true;
			}
			// otherwise, probably a string with a format
	
			if (parseAsUTC || isAmbigTime) {
				mom = moment.utc.apply(moment, args);
			}
			else {
				mom = moment.apply(null, args);
			}
	
			if (isAmbigTime) {
				mom._ambigTime = true;
				mom._ambigZone = true; // ambiguous time always means ambiguous zone
			}
			else if (parseZone) { // let's record the inputted zone somehow
				if (isAmbigZone) {
					mom._ambigZone = true;
				}
				else if (isSingleString) {
					mom.utcOffset(input); // if not a valid zone, will assign UTC
				}
			}
		}
	
		mom._fullCalendar = true; // flag for extended functionality
	
		return mom;
	}
	
	
	// Week Number
	// -------------------------------------------------------------------------------------------------
	
	
	// Returns the week number, considering the locale's custom week number calcuation
	// `weeks` is an alias for `week`
	newMomentProto.week = newMomentProto.weeks = function(input) {
		var weekCalc = this._locale._fullCalendar_weekCalc;
	
		if (input == null && typeof weekCalc === 'function') { // custom function only works for getter
			return weekCalc(this);
		}
		else if (weekCalc === 'ISO') {
			return oldMomentProto.isoWeek.apply(this, arguments); // ISO getter/setter
		}
	
		return oldMomentProto.week.apply(this, arguments); // local getter/setter
	};
	
	
	// Time-of-day
	// -------------------------------------------------------------------------------------------------
	
	// GETTER
	// Returns a Duration with the hours/minutes/seconds/ms values of the moment.
	// If the moment has an ambiguous time, a duration of 00:00 will be returned.
	//
	// SETTER
	// You can supply a Duration, a Moment, or a Duration-like argument.
	// When setting the time, and the moment has an ambiguous time, it then becomes unambiguous.
	newMomentProto.time = function(time) {
	
		// Fallback to the original method (if there is one) if this moment wasn't created via FullCalendar.
		// `time` is a generic enough method name where this precaution is necessary to avoid collisions w/ other plugins.
		if (!this._fullCalendar) {
			return oldMomentProto.time.apply(this, arguments);
		}
	
		if (time == null) { // getter
			return moment.duration({
				hours: this.hours(),
				minutes: this.minutes(),
				seconds: this.seconds(),
				milliseconds: this.milliseconds()
			});
		}
		else { // setter
	
			this._ambigTime = false; // mark that the moment now has a time
	
			if (!moment.isDuration(time) && !moment.isMoment(time)) {
				time = moment.duration(time);
			}
	
			// The day value should cause overflow (so 24 hours becomes 00:00:00 of next day).
			// Only for Duration times, not Moment times.
			var dayHours = 0;
			if (moment.isDuration(time)) {
				dayHours = Math.floor(time.asDays()) * 24;
			}
	
			// We need to set the individual fields.
			// Can't use startOf('day') then add duration. In case of DST at start of day.
			return this.hours(dayHours + time.hours())
				.minutes(time.minutes())
				.seconds(time.seconds())
				.milliseconds(time.milliseconds());
		}
	};
	
	// Converts the moment to UTC, stripping out its time-of-day and timezone offset,
	// but preserving its YMD. A moment with a stripped time will display no time
	// nor timezone offset when .format() is called.
	newMomentProto.stripTime = function() {
	
		if (!this._ambigTime) {
	
			this.utc(true); // keepLocalTime=true (for keeping *date* value)
	
			// set time to zero
			this.set({
				hours: 0,
				minutes: 0,
				seconds: 0,
				ms: 0
			});
	
			// Mark the time as ambiguous. This needs to happen after the .utc() call, which might call .utcOffset(),
			// which clears all ambig flags.
			this._ambigTime = true;
			this._ambigZone = true; // if ambiguous time, also ambiguous timezone offset
		}
	
		return this; // for chaining
	};
	
	// Returns if the moment has a non-ambiguous time (boolean)
	newMomentProto.hasTime = function() {
		return !this._ambigTime;
	};
	
	
	// Timezone
	// -------------------------------------------------------------------------------------------------
	
	// Converts the moment to UTC, stripping out its timezone offset, but preserving its
	// YMD and time-of-day. A moment with a stripped timezone offset will display no
	// timezone offset when .format() is called.
	newMomentProto.stripZone = function() {
		var wasAmbigTime;
	
		if (!this._ambigZone) {
	
			wasAmbigTime = this._ambigTime;
	
			this.utc(true); // keepLocalTime=true (for keeping date and time values)
	
			// the above call to .utc()/.utcOffset() unfortunately might clear the ambig flags, so restore
			this._ambigTime = wasAmbigTime || false;
	
			// Mark the zone as ambiguous. This needs to happen after the .utc() call, which might call .utcOffset(),
			// which clears the ambig flags.
			this._ambigZone = true;
		}
	
		return this; // for chaining
	};
	
	// Returns of the moment has a non-ambiguous timezone offset (boolean)
	newMomentProto.hasZone = function() {
		return !this._ambigZone;
	};
	
	
	// implicitly marks a zone
	newMomentProto.local = function(keepLocalTime) {
	
		// for when converting from ambiguously-zoned to local,
		// keep the time values when converting from UTC -> local
		oldMomentProto.local.call(this, this._ambigZone || keepLocalTime);
	
		// ensure non-ambiguous
		// this probably already happened via local() -> utcOffset(), but don't rely on Moment's internals
		this._ambigTime = false;
		this._ambigZone = false;
	
		return this; // for chaining
	};
	
	
	// implicitly marks a zone
	newMomentProto.utc = function(keepLocalTime) {
	
		oldMomentProto.utc.call(this, keepLocalTime);
	
		// ensure non-ambiguous
		// this probably already happened via utc() -> utcOffset(), but don't rely on Moment's internals
		this._ambigTime = false;
		this._ambigZone = false;
	
		return this;
	};
	
	
	// implicitly marks a zone (will probably get called upon .utc() and .local())
	newMomentProto.utcOffset = function(tzo) {
	
		if (tzo != null) { // setter
			// these assignments needs to happen before the original zone method is called.
			// I forget why, something to do with a browser crash.
			this._ambigTime = false;
			this._ambigZone = false;
		}
	
		return oldMomentProto.utcOffset.apply(this, arguments);
	};
	
	
	// Formatting
	// -------------------------------------------------------------------------------------------------
	
	newMomentProto.format = function() {
		if (this._fullCalendar && arguments[0]) { // an enhanced moment? and a format string provided?
			return formatDate(this, arguments[0]); // our extended formatting
		}
		if (this._ambigTime) {
			return oldMomentFormat(this, 'YYYY-MM-DD');
		}
		if (this._ambigZone) {
			return oldMomentFormat(this, 'YYYY-MM-DD[T]HH:mm:ss');
		}
		return oldMomentProto.format.apply(this, arguments);
	};
	
	newMomentProto.toISOString = function() {
		if (this._ambigTime) {
			return oldMomentFormat(this, 'YYYY-MM-DD');
		}
		if (this._ambigZone) {
			return oldMomentFormat(this, 'YYYY-MM-DD[T]HH:mm:ss');
		}
		return oldMomentProto.toISOString.apply(this, arguments);
	};
	
	;;
	
	// Single Date Formatting
	// -------------------------------------------------------------------------------------------------
	
	
	// call this if you want Moment's original format method to be used
	function oldMomentFormat(mom, formatStr) {
		return oldMomentProto.format.call(mom, formatStr); // oldMomentProto defined in moment-ext.js
	}
	
	
	// Formats `date` with a Moment formatting string, but allow our non-zero areas and
	// additional token.
	function formatDate(date, formatStr) {
		return formatDateWithChunks(date, getFormatStringChunks(formatStr));
	}
	
	
	function formatDateWithChunks(date, chunks) {
		var s = '';
		var i;
	
		for (i=0; i<chunks.length; i++) {
			s += formatDateWithChunk(date, chunks[i]);
		}
	
		return s;
	}
	
	
	// addition formatting tokens we want recognized
	var tokenOverrides = {
		t: function(date) { // "a" or "p"
			return oldMomentFormat(date, 'a').charAt(0);
		},
		T: function(date) { // "A" or "P"
			return oldMomentFormat(date, 'A').charAt(0);
		}
	};
	
	
	function formatDateWithChunk(date, chunk) {
		var token;
		var maybeStr;
	
		if (typeof chunk === 'string') { // a literal string
			return chunk;
		}
		else if ((token = chunk.token)) { // a token, like "YYYY"
			if (tokenOverrides[token]) {
				return tokenOverrides[token](date); // use our custom token
			}
			return oldMomentFormat(date, token);
		}
		else if (chunk.maybe) { // a grouping of other chunks that must be non-zero
			maybeStr = formatDateWithChunks(date, chunk.maybe);
			if (maybeStr.match(/[1-9]/)) {
				return maybeStr;
			}
		}
	
		return '';
	}
	
	
	// Date Range Formatting
	// -------------------------------------------------------------------------------------------------
	// TODO: make it work with timezone offset
	
	// Using a formatting string meant for a single date, generate a range string, like
	// "Sep 2 - 9 2013", that intelligently inserts a separator where the dates differ.
	// If the dates are the same as far as the format string is concerned, just return a single
	// rendering of one date, without any separator.
	function formatRange(date1, date2, formatStr, separator, isRTL) {
		var localeData;
	
		date1 = FC.moment.parseZone(date1);
		date2 = FC.moment.parseZone(date2);
	
		localeData = date1.localeData();
	
		// Expand localized format strings, like "LL" -> "MMMM D YYYY"
		formatStr = localeData.longDateFormat(formatStr) || formatStr;
		// BTW, this is not important for `formatDate` because it is impossible to put custom tokens
		// or non-zero areas in Moment's localized format strings.
	
		separator = separator || ' - ';
	
		return formatRangeWithChunks(
			date1,
			date2,
			getFormatStringChunks(formatStr),
			separator,
			isRTL
		);
	}
	FC.formatRange = formatRange; // expose
	
	
	function formatRangeWithChunks(date1, date2, chunks, separator, isRTL) {
		var unzonedDate1 = date1.clone().stripZone(); // for formatSimilarChunk
		var unzonedDate2 = date2.clone().stripZone(); // "
		var chunkStr; // the rendering of the chunk
		var leftI;
		var leftStr = '';
		var rightI;
		var rightStr = '';
		var middleI;
		var middleStr1 = '';
		var middleStr2 = '';
		var middleStr = '';
	
		// Start at the leftmost side of the formatting string and continue until you hit a token
		// that is not the same between dates.
		for (leftI=0; leftI<chunks.length; leftI++) {
			chunkStr = formatSimilarChunk(date1, date2, unzonedDate1, unzonedDate2, chunks[leftI]);
			if (chunkStr === false) {
				break;
			}
			leftStr += chunkStr;
		}
	
		// Similarly, start at the rightmost side of the formatting string and move left
		for (rightI=chunks.length-1; rightI>leftI; rightI--) {
			chunkStr = formatSimilarChunk(date1, date2, unzonedDate1, unzonedDate2,  chunks[rightI]);
			if (chunkStr === false) {
				break;
			}
			rightStr = chunkStr + rightStr;
		}
	
		// The area in the middle is different for both of the dates.
		// Collect them distinctly so we can jam them together later.
		for (middleI=leftI; middleI<=rightI; middleI++) {
			middleStr1 += formatDateWithChunk(date1, chunks[middleI]);
			middleStr2 += formatDateWithChunk(date2, chunks[middleI]);
		}
	
		if (middleStr1 || middleStr2) {
			if (isRTL) {
				middleStr = middleStr2 + separator + middleStr1;
			}
			else {
				middleStr = middleStr1 + separator + middleStr2;
			}
		}
	
		return leftStr + middleStr + rightStr;
	}
	
	
	var similarUnitMap = {
		Y: 'year',
		M: 'month',
		D: 'day', // day of month
		d: 'day', // day of week
		// prevents a separator between anything time-related...
		A: 'second', // AM/PM
		a: 'second', // am/pm
		T: 'second', // A/P
		t: 'second', // a/p
		H: 'second', // hour (24)
		h: 'second', // hour (12)
		m: 'second', // minute
		s: 'second' // second
	};
	// TODO: week maybe?
	
	
	// Given a formatting chunk, and given that both dates are similar in the regard the
	// formatting chunk is concerned, format date1 against `chunk`. Otherwise, return `false`.
	function formatSimilarChunk(date1, date2, unzonedDate1, unzonedDate2, chunk) {
		var token;
		var unit;
	
		if (typeof chunk === 'string') { // a literal string
			return chunk;
		}
		else if ((token = chunk.token)) {
			unit = similarUnitMap[token.charAt(0)];
	
			// are the dates the same for this unit of measurement?
			// use the unzoned dates for this calculation because unreliable when near DST (bug #2396)
			if (unit && unzonedDate1.isSame(unzonedDate2, unit)) {
				return oldMomentFormat(date1, token); // would be the same if we used `date2`
				// BTW, don't support custom tokens
			}
		}
	
		return false; // the chunk is NOT the same for the two dates
		// BTW, don't support splitting on non-zero areas
	}
	
	
	// Chunking Utils
	// -------------------------------------------------------------------------------------------------
	
	
	var formatStringChunkCache = {};
	
	
	function getFormatStringChunks(formatStr) {
		if (formatStr in formatStringChunkCache) {
			return formatStringChunkCache[formatStr];
		}
		return (formatStringChunkCache[formatStr] = chunkFormatString(formatStr));
	}
	
	
	// Break the formatting string into an array of chunks
	function chunkFormatString(formatStr) {
		var chunks = [];
		var chunker = /\[([^\]]*)\]|\(([^\)]*)\)|(LTS|LT|(\w)\4*o?)|([^\w\[\(]+)/g; // TODO: more descrimination
		var match;
	
		while ((match = chunker.exec(formatStr))) {
			if (match[1]) { // a literal string inside [ ... ]
				chunks.push(match[1]);
			}
			else if (match[2]) { // non-zero formatting inside ( ... )
				chunks.push({ maybe: chunkFormatString(match[2]) });
			}
			else if (match[3]) { // a formatting token
				chunks.push({ token: match[3] });
			}
			else if (match[5]) { // an unenclosed literal string
				chunks.push(match[5]);
			}
		}
	
		return chunks;
	}
	
	
	// Misc Utils
	// -------------------------------------------------------------------------------------------------
	
	
	// granularity only goes up until day
	// TODO: unify with similarUnitMap
	var tokenGranularities = {
		Y: { value: 1, unit: 'year' },
		M: { value: 2, unit: 'month' },
		W: { value: 3, unit: 'week' },
		w: { value: 3, unit: 'week' },
		D: { value: 4, unit: 'day' }, // day of month
		d: { value: 4, unit: 'day' } // day of week
	};
	
	// returns a unit string, either 'year', 'month', 'day', or null
	// for the most granular formatting token in the string.
	FC.queryMostGranularFormatUnit = function(formatStr) {
		var chunks = getFormatStringChunks(formatStr);
		var i, chunk;
		var candidate;
		var best;
	
		for (i = 0; i < chunks.length; i++) {
			chunk = chunks[i];
			if (chunk.token) {
				candidate = tokenGranularities[chunk.token.charAt(0)];
				if (candidate) {
					if (!best || candidate.value > best.value) {
						best = candidate;
					}
				}
			}
		}
	
		if (best) {
			return best.unit;
		}
	
		return null;
	};
	
	;;
	
	FC.Class = Class; // export
	
	// Class that all other classes will inherit from
	function Class() { }
	
	
	// Called on a class to create a subclass.
	// Last argument contains instance methods. Any argument before the last are considered mixins.
	Class.extend = function() {
		var len = arguments.length;
		var i;
		var members;
	
		for (i = 0; i < len; i++) {
			members = arguments[i];
			if (i < len - 1) { // not the last argument?
				mixIntoClass(this, members);
			}
		}
	
		return extendClass(this, members || {}); // members will be undefined if no arguments
	};
	
	
	// Adds new member variables/methods to the class's prototype.
	// Can be called with another class, or a plain object hash containing new members.
	Class.mixin = function(members) {
		mixIntoClass(this, members);
	};
	
	
	function extendClass(superClass, members) {
		var subClass;
	
		// ensure a constructor for the subclass, forwarding all arguments to the super-constructor if it doesn't exist
		if (hasOwnProp(members, 'constructor')) {
			subClass = members.constructor;
		}
		if (typeof subClass !== 'function') {
			subClass = members.constructor = function() {
				superClass.apply(this, arguments);
			};
		}
	
		// build the base prototype for the subclass, which is an new object chained to the superclass's prototype
		subClass.prototype = createObject(superClass.prototype);
	
		// copy each member variable/method onto the the subclass's prototype
		copyOwnProps(members, subClass.prototype);
	
		// copy over all class variables/methods to the subclass, such as `extend` and `mixin`
		copyOwnProps(superClass, subClass);
	
		return subClass;
	}
	
	
	function mixIntoClass(theClass, members) {
		copyOwnProps(members, theClass.prototype);
	}
	;;
	
	/*
	Wrap jQuery's Deferred Promise object to be slightly more Promise/A+ compliant.
	With the added non-standard feature of synchronously executing handlers on resolved promises,
	which doesn't always happen otherwise (esp with nested .then handlers!?),
	so, this makes things a lot easier, esp because jQuery 3 changed the synchronicity for Deferred objects.
	
	TODO: write tests and more comments
	*/
	
	function Promise(executor) {
		var deferred = $.Deferred();
		var promise = deferred.promise();
	
		if (typeof executor === 'function') {
			executor(
				function(value) { // resolve
					if (Promise.immediate) {
						promise._value = value;
					}
					deferred.resolve(value);
				},
				function() { // reject
					deferred.reject();
				}
			);
		}
		
		if (Promise.immediate) {
			var origThen = promise.then;
	
			promise.then = function(onFulfilled, onRejected) {
				var state = promise.state();
				
				if (state === 'resolved') {
					if (typeof onFulfilled === 'function') {
						return Promise.resolve(onFulfilled(promise._value));
					}
				}
				else if (state === 'rejected') {
					if (typeof onRejected === 'function') {
						onRejected();
						return promise; // already rejected
					}
				}
	
				return origThen.call(promise, onFulfilled, onRejected);
			};
		}
	
		return promise; // instanceof Promise will break :( TODO: make Promise a real class
	}
	
	FC.Promise = Promise;
	
	Promise.immediate = true;
	
	
	Promise.resolve = function(value) {
		if (value && typeof value.resolve === 'function') {
			return value.promise();
		}
		if (value && typeof value.then === 'function') {
			return value;
		}
		else {
			var deferred = $.Deferred().resolve(value);
			var promise = deferred.promise();
	
			if (Promise.immediate) {
				var origThen = promise.then;
	
				promise._value = value;
	
				promise.then = function(onFulfilled, onRejected) {
					if (typeof onFulfilled === 'function') {
						return Promise.resolve(onFulfilled(value));
					}
					return origThen.call(promise, onFulfilled, onRejected);
				};
			}
	
			return promise;
		}
	};
	
	
	Promise.reject = function() {
		return $.Deferred().reject().promise();
	};
	
	
	Promise.all = function(inputs) {
		var hasAllValues = false;
		var values;
		var i, input;
	
		if (Promise.immediate) {
			hasAllValues = true;
			values = [];
	
			for (i = 0; i < inputs.length; i++) {
				input = inputs[i];
	
				if (input && typeof input.state === 'function' && input.state() === 'resolved' && ('_value' in input)) {
					values.push(input._value);
				}
				else if (input && typeof input.then === 'function') {
					hasAllValues = false;
					break;
				}
				else {
					values.push(input);
				}
			}
		}
	
		if (hasAllValues) {
			return Promise.resolve(values);
		}
		else {
			return $.when.apply($.when, inputs).then(function() {
				return $.when($.makeArray(arguments));
			});
		}
	};
	
	;;
	
	// TODO: write tests and clean up code
	
	function TaskQueue(debounceWait) {
		var q = []; // array of runFuncs
	
		function addTask(taskFunc) {
			return new Promise(function(resolve) {
	
				// should run this function when it's taskFunc's turn to run.
				// responsible for popping itself off the queue.
				var runFunc = function() {
					Promise.resolve(taskFunc()) // result might be async, coerce to promise
						.then(resolve) // resolve TaskQueue::push's promise, for the caller. will receive result of taskFunc.
						.then(function() {
							q.shift(); // pop itself off
	
							// run the next task, if any
							if (q.length) {
								q[0]();
							}
						});
				};
	
				// always put the task at the end of the queue, BEFORE running the task
				q.push(runFunc);
	
				// if it's the only task in the queue, run immediately
				if (q.length === 1) {
					runFunc();
				}
			});
		}
	
		this.add = // potentially debounce, for the public method
			typeof debounceWait === 'number' ?
				debounce(addTask, debounceWait) :
				addTask; // if not a number (null/undefined/false), no debounce at all
	
		this.addQuickly = addTask; // guaranteed no debounce
	}
	
	FC.TaskQueue = TaskQueue;
	
	/*
	q = new TaskQueue();
	
	function work(i) {
		return q.push(function() {
			trigger();
			console.log('work' + i);
		});
	}
	
	var cnt = 0;
	
	function trigger() {
		if (cnt < 5) {
			cnt++;
			work(cnt);
		}
	}
	
	work(9);
	*/
	
	;;
	
	var EmitterMixin = FC.EmitterMixin = {
	
		// jQuery-ification via $(this) allows a non-DOM object to have
		// the same event handling capabilities (including namespaces).
	
	
		on: function(types, handler) {
			$(this).on(types, this._prepareIntercept(handler));
			return this; // for chaining
		},
	
	
		one: function(types, handler) {
			$(this).one(types, this._prepareIntercept(handler));
			return this; // for chaining
		},
	
	
		_prepareIntercept: function(handler) {
			// handlers are always called with an "event" object as their first param.
			// sneak the `this` context and arguments into the extra parameter object
			// and forward them on to the original handler.
			var intercept = function(ev, extra) {
				return handler.apply(
					extra.context || this,
					extra.args || []
				);
			};
	
			// mimick jQuery's internal "proxy" system (risky, I know)
			// causing all functions with the same .guid to appear to be the same.
			// https://github.com/jquery/jquery/blob/2.2.4/src/core.js#L448
			// this is needed for calling .off with the original non-intercept handler.
			if (!handler.guid) {
				handler.guid = $.guid++;
			}
			intercept.guid = handler.guid;
	
			return intercept;
		},
	
	
		off: function(types, handler) {
			$(this).off(types, handler);
	
			return this; // for chaining
		},
	
	
		trigger: function(types) {
			var args = Array.prototype.slice.call(arguments, 1); // arguments after the first
	
			// pass in "extra" info to the intercept
			$(this).triggerHandler(types, { args: args });
	
			return this; // for chaining
		},
	
	
		triggerWith: function(types, context, args) {
	
			// `triggerHandler` is less reliant on the DOM compared to `trigger`.
			// pass in "extra" info to the intercept.
			$(this).triggerHandler(types, { context: context, args: args });
	
			return this; // for chaining
		}
	
	};
	
	;;
	
	/*
	Utility methods for easily listening to events on another object,
	and more importantly, easily unlistening from them.
	*/
	var ListenerMixin = FC.ListenerMixin = (function() {
		var guid = 0;
		var ListenerMixin = {
	
			listenerId: null,
	
			/*
			Given an `other` object that has on/off methods, bind the given `callback` to an event by the given name.
			The `callback` will be called with the `this` context of the object that .listenTo is being called on.
			Can be called:
				.listenTo(other, eventName, callback)
			OR
				.listenTo(other, {
					eventName1: callback1,
					eventName2: callback2
				})
			*/
			listenTo: function(other, arg, callback) {
				if (typeof arg === 'object') { // given dictionary of callbacks
					for (var eventName in arg) {
						if (arg.hasOwnProperty(eventName)) {
							this.listenTo(other, eventName, arg[eventName]);
						}
					}
				}
				else if (typeof arg === 'string') {
					other.on(
						arg + '.' + this.getListenerNamespace(), // use event namespacing to identify this object
						$.proxy(callback, this) // always use `this` context
							// the usually-undesired jQuery guid behavior doesn't matter,
							// because we always unbind via namespace
					);
				}
			},
	
			/*
			Causes the current object to stop listening to events on the `other` object.
			`eventName` is optional. If omitted, will stop listening to ALL events on `other`.
			*/
			stopListeningTo: function(other, eventName) {
				other.off((eventName || '') + '.' + this.getListenerNamespace());
			},
	
			/*
			Returns a string, unique to this object, to be used for event namespacing
			*/
			getListenerNamespace: function() {
				if (this.listenerId == null) {
					this.listenerId = guid++;
				}
				return '_listener' + this.listenerId;
			}
	
		};
		return ListenerMixin;
	})();
	;;
	
	// simple class for toggle a `isIgnoringMouse` flag on delay
	// initMouseIgnoring must first be called, with a millisecond delay setting.
	var MouseIgnorerMixin = {
	
		isIgnoringMouse: false, // bool
		delayUnignoreMouse: null, // method
	
	
		initMouseIgnoring: function(delay) {
			this.delayUnignoreMouse = debounce(proxy(this, 'unignoreMouse'), delay || 1000);
		},
	
	
		// temporarily ignore mouse actions on segments
		tempIgnoreMouse: function() {
			this.isIgnoringMouse = true;
			this.delayUnignoreMouse();
		},
	
	
		// delayUnignoreMouse eventually calls this
		unignoreMouse: function() {
			this.isIgnoringMouse = false;
		}
	
	};
	
	;;
	
	/* A rectangular panel that is absolutely positioned over other content
	------------------------------------------------------------------------------------------------------------------------
	Options:
		- className (string)
		- content (HTML string or jQuery element set)
		- parentEl
		- top
		- left
		- right (the x coord of where the right edge should be. not a "CSS" right)
		- autoHide (boolean)
		- show (callback)
		- hide (callback)
	*/
	
	var Popover = Class.extend(ListenerMixin, {
	
		isHidden: true,
		options: null,
		el: null, // the container element for the popover. generated by this object
		margin: 10, // the space required between the popover and the edges of the scroll container
	
	
		constructor: function(options) {
			this.options = options || {};
		},
	
	
		// Shows the popover on the specified position. Renders it if not already
		show: function() {
			if (this.isHidden) {
				if (!this.el) {
					this.render();
				}
				this.el.show();
				this.position();
				this.isHidden = false;
				this.trigger('show');
			}
		},
	
	
		// Hides the popover, through CSS, but does not remove it from the DOM
		hide: function() {
			if (!this.isHidden) {
				this.el.hide();
				this.isHidden = true;
				this.trigger('hide');
			}
		},
	
	
		// Creates `this.el` and renders content inside of it
		render: function() {
			var _this = this;
			var options = this.options;
	
			this.el = $('<div class="fc-popover"/>')
				.addClass(options.className || '')
				.css({
					// position initially to the top left to avoid creating scrollbars
					top: 0,
					left: 0
				})
				.append(options.content)
				.appendTo(options.parentEl);
	
			// when a click happens on anything inside with a 'fc-close' className, hide the popover
			this.el.on('click', '.fc-close', function() {
				_this.hide();
			});
	
			if (options.autoHide) {
				this.listenTo($(document), 'mousedown', this.documentMousedown);
			}
		},
	
	
		// Triggered when the user clicks *anywhere* in the document, for the autoHide feature
		documentMousedown: function(ev) {
			// only hide the popover if the click happened outside the popover
			if (this.el && !$(ev.target).closest(this.el).length) {
				this.hide();
			}
		},
	
	
		// Hides and unregisters any handlers
		removeElement: function() {
			this.hide();
	
			if (this.el) {
				this.el.remove();
				this.el = null;
			}
	
			this.stopListeningTo($(document), 'mousedown');
		},
	
	
		// Positions the popover optimally, using the top/left/right options
		position: function() {
			var options = this.options;
			var origin = this.el.offsetParent().offset();
			var width = this.el.outerWidth();
			var height = this.el.outerHeight();
			var windowEl = $(window);
			var viewportEl = getScrollParent(this.el);
			var viewportTop;
			var viewportLeft;
			var viewportOffset;
			var top; // the "position" (not "offset") values for the popover
			var left; //
	
			// compute top and left
			top = options.top || 0;
			if (options.left !== undefined) {
				left = options.left;
			}
			else if (options.right !== undefined) {
				left = options.right - width; // derive the left value from the right value
			}
			else {
				left = 0;
			}
	
			if (viewportEl.is(window) || viewportEl.is(document)) { // normalize getScrollParent's result
				viewportEl = windowEl;
				viewportTop = 0; // the window is always at the top left
				viewportLeft = 0; // (and .offset() won't work if called here)
			}
			else {
				viewportOffset = viewportEl.offset();
				viewportTop = viewportOffset.top;
				viewportLeft = viewportOffset.left;
			}
	
			// if the window is scrolled, it causes the visible area to be further down
			viewportTop += windowEl.scrollTop();
			viewportLeft += windowEl.scrollLeft();
	
			// constrain to the view port. if constrained by two edges, give precedence to top/left
			if (options.viewportConstrain !== false) {
				top = Math.min(top, viewportTop + viewportEl.outerHeight() - height - this.margin);
				top = Math.max(top, viewportTop + this.margin);
				left = Math.min(left, viewportLeft + viewportEl.outerWidth() - width - this.margin);
				left = Math.max(left, viewportLeft + this.margin);
			}
	
			this.el.css({
				top: top - origin.top,
				left: left - origin.left
			});
		},
	
	
		// Triggers a callback. Calls a function in the option hash of the same name.
		// Arguments beyond the first `name` are forwarded on.
		// TODO: better code reuse for this. Repeat code
		trigger: function(name) {
			if (this.options[name]) {
				this.options[name].apply(this, Array.prototype.slice.call(arguments, 1));
			}
		}
	
	});
	
	;;
	
	/*
	A cache for the left/right/top/bottom/width/height values for one or more elements.
	Works with both offset (from topleft document) and position (from offsetParent).
	
	options:
	- els
	- isHorizontal
	- isVertical
	*/
	var CoordCache = FC.CoordCache = Class.extend({
	
		els: null, // jQuery set (assumed to be siblings)
		forcedOffsetParentEl: null, // options can override the natural offsetParent
		origin: null, // {left,top} position of offsetParent of els
		boundingRect: null, // constrain cordinates to this rectangle. {left,right,top,bottom} or null
		isHorizontal: false, // whether to query for left/right/width
		isVertical: false, // whether to query for top/bottom/height
	
		// arrays of coordinates (offsets from topleft of document)
		lefts: null,
		rights: null,
		tops: null,
		bottoms: null,
	
	
		constructor: function(options) {
			this.els = $(options.els);
			this.isHorizontal = options.isHorizontal;
			this.isVertical = options.isVertical;
			this.forcedOffsetParentEl = options.offsetParent ? $(options.offsetParent) : null;
		},
	
	
		// Queries the els for coordinates and stores them.
		// Call this method before using and of the get* methods below.
		build: function() {
			var offsetParentEl = this.forcedOffsetParentEl;
			if (!offsetParentEl && this.els.length > 0) {
				offsetParentEl = this.els.eq(0).offsetParent();
			}
	
			this.origin = offsetParentEl ?
				offsetParentEl.offset() :
				null;
	
			this.boundingRect = this.queryBoundingRect();
	
			if (this.isHorizontal) {
				this.buildElHorizontals();
			}
			if (this.isVertical) {
				this.buildElVerticals();
			}
		},
	
	
		// Destroys all internal data about coordinates, freeing memory
		clear: function() {
			this.origin = null;
			this.boundingRect = null;
			this.lefts = null;
			this.rights = null;
			this.tops = null;
			this.bottoms = null;
		},
	
	
		// When called, if coord caches aren't built, builds them
		ensureBuilt: function() {
			if (!this.origin) {
				this.build();
			}
		},
	
	
		// Populates the left/right internal coordinate arrays
		buildElHorizontals: function() {
			var lefts = [];
			var rights = [];
	
			this.els.each(function(i, node) {
				var el = $(node);
				var left = el.offset().left;
				var width = el.outerWidth();
	
				lefts.push(left);
				rights.push(left + width);
			});
	
			this.lefts = lefts;
			this.rights = rights;
		},
	
	
		// Populates the top/bottom internal coordinate arrays
		buildElVerticals: function() {
			var tops = [];
			var bottoms = [];
	
			this.els.each(function(i, node) {
				var el = $(node);
				var top = el.offset().top;
				var height = el.outerHeight();
	
				tops.push(top);
				bottoms.push(top + height);
			});
	
			this.tops = tops;
			this.bottoms = bottoms;
		},
	
	
		// Given a left offset (from document left), returns the index of the el that it horizontally intersects.
		// If no intersection is made, returns undefined.
		getHorizontalIndex: function(leftOffset) {
			this.ensureBuilt();
	
			var lefts = this.lefts;
			var rights = this.rights;
			var len = lefts.length;
			var i;
	
			for (i = 0; i < len; i++) {
				if (leftOffset >= lefts[i] && leftOffset < rights[i]) {
					return i;
				}
			}
		},
	
	
		// Given a top offset (from document top), returns the index of the el that it vertically intersects.
		// If no intersection is made, returns undefined.
		getVerticalIndex: function(topOffset) {
			this.ensureBuilt();
	
			var tops = this.tops;
			var bottoms = this.bottoms;
			var len = tops.length;
			var i;
	
			for (i = 0; i < len; i++) {
				if (topOffset >= tops[i] && topOffset < bottoms[i]) {
					return i;
				}
			}
		},
	
	
		// Gets the left offset (from document left) of the element at the given index
		getLeftOffset: function(leftIndex) {
			this.ensureBuilt();
			return this.lefts[leftIndex];
		},
	
	
		// Gets the left position (from offsetParent left) of the element at the given index
		getLeftPosition: function(leftIndex) {
			this.ensureBuilt();
			return this.lefts[leftIndex] - this.origin.left;
		},
	
	
		// Gets the right offset (from document left) of the element at the given index.
		// This value is NOT relative to the document's right edge, like the CSS concept of "right" would be.
		getRightOffset: function(leftIndex) {
			this.ensureBuilt();
			return this.rights[leftIndex];
		},
	
	
		// Gets the right position (from offsetParent left) of the element at the given index.
		// This value is NOT relative to the offsetParent's right edge, like the CSS concept of "right" would be.
		getRightPosition: function(leftIndex) {
			this.ensureBuilt();
			return this.rights[leftIndex] - this.origin.left;
		},
	
	
		// Gets the width of the element at the given index
		getWidth: function(leftIndex) {
			this.ensureBuilt();
			return this.rights[leftIndex] - this.lefts[leftIndex];
		},
	
	
		// Gets the top offset (from document top) of the element at the given index
		getTopOffset: function(topIndex) {
			this.ensureBuilt();
			return this.tops[topIndex];
		},
	
	
		// Gets the top position (from offsetParent top) of the element at the given position
		getTopPosition: function(topIndex) {
			this.ensureBuilt();
			return this.tops[topIndex] - this.origin.top;
		},
	
		// Gets the bottom offset (from the document top) of the element at the given index.
		// This value is NOT relative to the offsetParent's bottom edge, like the CSS concept of "bottom" would be.
		getBottomOffset: function(topIndex) {
			this.ensureBuilt();
			return this.bottoms[topIndex];
		},
	
	
		// Gets the bottom position (from the offsetParent top) of the element at the given index.
		// This value is NOT relative to the offsetParent's bottom edge, like the CSS concept of "bottom" would be.
		getBottomPosition: function(topIndex) {
			this.ensureBuilt();
			return this.bottoms[topIndex] - this.origin.top;
		},
	
	
		// Gets the height of the element at the given index
		getHeight: function(topIndex) {
			this.ensureBuilt();
			return this.bottoms[topIndex] - this.tops[topIndex];
		},
	
	
		// Bounding Rect
		// TODO: decouple this from CoordCache
	
		// Compute and return what the elements' bounding rectangle is, from the user's perspective.
		// Right now, only returns a rectangle if constrained by an overflow:scroll element.
		// Returns null if there are no elements
		queryBoundingRect: function() {
			var scrollParentEl;
	
			if (this.els.length > 0) {
				scrollParentEl = getScrollParent(this.els.eq(0));
	
				if (!scrollParentEl.is(document)) {
					return getClientRect(scrollParentEl);
				}
			}
	
			return null;
		},
	
		isPointInBounds: function(leftOffset, topOffset) {
			return this.isLeftInBounds(leftOffset) && this.isTopInBounds(topOffset);
		},
	
		isLeftInBounds: function(leftOffset) {
			return !this.boundingRect || (leftOffset >= this.boundingRect.left && leftOffset < this.boundingRect.right);
		},
	
		isTopInBounds: function(topOffset) {
			return !this.boundingRect || (topOffset >= this.boundingRect.top && topOffset < this.boundingRect.bottom);
		}
	
	});
	
	;;
	
	/* Tracks a drag's mouse movement, firing various handlers
	----------------------------------------------------------------------------------------------------------------------*/
	// TODO: use Emitter
	
	var DragListener = FC.DragListener = Class.extend(ListenerMixin, MouseIgnorerMixin, {
	
		options: null,
		subjectEl: null,
	
		// coordinates of the initial mousedown
		originX: null,
		originY: null,
	
		// the wrapping element that scrolls, or MIGHT scroll if there's overflow.
		// TODO: do this for wrappers that have overflow:hidden as well.
		scrollEl: null,
	
		isInteracting: false,
		isDistanceSurpassed: false,
		isDelayEnded: false,
		isDragging: false,
		isTouch: false,
	
		delay: null,
		delayTimeoutId: null,
		minDistance: null,
	
		handleTouchScrollProxy: null, // calls handleTouchScroll, always bound to `this`
	
	
		constructor: function(options) {
			this.options = options || {};
			this.handleTouchScrollProxy = proxy(this, 'handleTouchScroll');
			this.initMouseIgnoring(500);
		},
	
	
		// Interaction (high-level)
		// -----------------------------------------------------------------------------------------------------------------
	
	
		startInteraction: function(ev, extraOptions) {
			var isTouch = getEvIsTouch(ev);
	
			if (ev.type === 'mousedown') {
				if (this.isIgnoringMouse) {
					return;
				}
				else if (!isPrimaryMouseButton(ev)) {
					return;
				}
				else {
					ev.preventDefault(); // prevents native selection in most browsers
				}
			}
	
			if (!this.isInteracting) {
	
				// process options
				extraOptions = extraOptions || {};
				this.delay = firstDefined(extraOptions.delay, this.options.delay, 0);
				this.minDistance = firstDefined(extraOptions.distance, this.options.distance, 0);
				this.subjectEl = this.options.subjectEl;
	
				this.isInteracting = true;
				this.isTouch = isTouch;
				this.isDelayEnded = false;
				this.isDistanceSurpassed = false;
	
				this.originX = getEvX(ev);
				this.originY = getEvY(ev);
				this.scrollEl = getScrollParent($(ev.target));
	
				this.bindHandlers();
				this.initAutoScroll();
				this.handleInteractionStart(ev);
				this.startDelay(ev);
	
				if (!this.minDistance) {
					this.handleDistanceSurpassed(ev);
				}
			}
		},
	
	
		handleInteractionStart: function(ev) {
			this.trigger('interactionStart', ev);
		},
	
	
		endInteraction: function(ev, isCancelled) {
			if (this.isInteracting) {
				this.endDrag(ev);
	
				if (this.delayTimeoutId) {
					clearTimeout(this.delayTimeoutId);
					this.delayTimeoutId = null;
				}
	
				this.destroyAutoScroll();
				this.unbindHandlers();
	
				this.isInteracting = false;
				this.handleInteractionEnd(ev, isCancelled);
	
				// a touchstart+touchend on the same element will result in the following addition simulated events:
				// mouseover + mouseout + click
				// let's ignore these bogus events
				if (this.isTouch) {
					this.tempIgnoreMouse();
				}
			}
		},
	
	
		handleInteractionEnd: function(ev, isCancelled) {
			this.trigger('interactionEnd', ev, isCancelled || false);
		},
	
	
		// Binding To DOM
		// -----------------------------------------------------------------------------------------------------------------
	
	
		bindHandlers: function() {
			var _this = this;
			var touchStartIgnores = 1;
	
			if (this.isTouch) {
				this.listenTo($(document), {
					touchmove: this.handleTouchMove,
					touchend: this.endInteraction,
					touchcancel: this.endInteraction,
	
					// Sometimes touchend doesn't fire
					// (can't figure out why. touchcancel doesn't fire either. has to do with scrolling?)
					// If another touchstart happens, we know it's bogus, so cancel the drag.
					// touchend will continue to be broken until user does a shorttap/scroll, but this is best we can do.
					touchstart: function(ev) {
						if (touchStartIgnores) { // bindHandlers is called from within a touchstart,
							touchStartIgnores--; // and we don't want this to fire immediately, so ignore.
						}
						else {
							_this.endInteraction(ev, true); // isCancelled=true
						}
					}
				});
	
				// listen to ALL scroll actions on the page
				if (
					!bindAnyScroll(this.handleTouchScrollProxy) && // hopefully this works and short-circuits the rest
					this.scrollEl // otherwise, attach a single handler to this
				) {
					this.listenTo(this.scrollEl, 'scroll', this.handleTouchScroll);
				}
			}
			else {
				this.listenTo($(document), {
					mousemove: this.handleMouseMove,
					mouseup: this.endInteraction
				});
			}
	
			this.listenTo($(document), {
				selectstart: preventDefault, // don't allow selection while dragging
				contextmenu: preventDefault // long taps would open menu on Chrome dev tools
			});
		},
	
	
		unbindHandlers: function() {
			this.stopListeningTo($(document));
	
			// unbind scroll listening
			unbindAnyScroll(this.handleTouchScrollProxy);
			if (this.scrollEl) {
				this.stopListeningTo(this.scrollEl, 'scroll');
			}
		},
	
	
		// Drag (high-level)
		// -----------------------------------------------------------------------------------------------------------------
	
	
		// extraOptions ignored if drag already started
		startDrag: function(ev, extraOptions) {
			this.startInteraction(ev, extraOptions); // ensure interaction began
	
			if (!this.isDragging) {
				this.isDragging = true;
				this.handleDragStart(ev);
			}
		},
	
	
		handleDragStart: function(ev) {
			this.trigger('dragStart', ev);
		},
	
	
		handleMove: function(ev) {
			var dx = getEvX(ev) - this.originX;
			var dy = getEvY(ev) - this.originY;
			var minDistance = this.minDistance;
			var distanceSq; // current distance from the origin, squared
	
			if (!this.isDistanceSurpassed) {
				distanceSq = dx * dx + dy * dy;
				if (distanceSq >= minDistance * minDistance) { // use pythagorean theorem
					this.handleDistanceSurpassed(ev);
				}
			}
	
			if (this.isDragging) {
				this.handleDrag(dx, dy, ev);
			}
		},
	
	
		// Called while the mouse is being moved and when we know a legitimate drag is taking place
		handleDrag: function(dx, dy, ev) {
			this.trigger('drag', dx, dy, ev);
			this.updateAutoScroll(ev); // will possibly cause scrolling
		},
	
	
		endDrag: function(ev) {
			if (this.isDragging) {
				this.isDragging = false;
				this.handleDragEnd(ev);
			}
		},
	
	
		handleDragEnd: function(ev) {
			this.trigger('dragEnd', ev);
		},
	
	
		// Delay
		// -----------------------------------------------------------------------------------------------------------------
	
	
		startDelay: function(initialEv) {
			var _this = this;
	
			if (this.delay) {
				this.delayTimeoutId = setTimeout(function() {
					_this.handleDelayEnd(initialEv);
				}, this.delay);
			}
			else {
				this.handleDelayEnd(initialEv);
			}
		},
	
	
		handleDelayEnd: function(initialEv) {
			this.isDelayEnded = true;
	
			if (this.isDistanceSurpassed) {
				this.startDrag(initialEv);
			}
		},
	
	
		// Distance
		// -----------------------------------------------------------------------------------------------------------------
	
	
		handleDistanceSurpassed: function(ev) {
			this.isDistanceSurpassed = true;
	
			if (this.isDelayEnded) {
				this.startDrag(ev);
			}
		},
	
	
		// Mouse / Touch
		// -----------------------------------------------------------------------------------------------------------------
	
	
		handleTouchMove: function(ev) {
			// prevent inertia and touchmove-scrolling while dragging
			if (this.isDragging) {
				ev.preventDefault();
			}
	
			this.handleMove(ev);
		},
	
	
		handleMouseMove: function(ev) {
			this.handleMove(ev);
		},
	
	
		// Scrolling (unrelated to auto-scroll)
		// -----------------------------------------------------------------------------------------------------------------
	
	
		handleTouchScroll: function(ev) {
			// if the drag is being initiated by touch, but a scroll happens before
			// the drag-initiating delay is over, cancel the drag
			if (!this.isDragging) {
				this.endInteraction(ev, true); // isCancelled=true
			}
		},
	
	
		// Utils
		// -----------------------------------------------------------------------------------------------------------------
	
	
		// Triggers a callback. Calls a function in the option hash of the same name.
		// Arguments beyond the first `name` are forwarded on.
		trigger: function(name) {
			if (this.options[name]) {
				this.options[name].apply(this, Array.prototype.slice.call(arguments, 1));
			}
			// makes _methods callable by event name. TODO: kill this
			if (this['_' + name]) {
				this['_' + name].apply(this, Array.prototype.slice.call(arguments, 1));
			}
		}
	
	
	});
	
	;;
	/*
	this.scrollEl is set in DragListener
	*/
	DragListener.mixin({
	
		isAutoScroll: false,
	
		scrollBounds: null, // { top, bottom, left, right }
		scrollTopVel: null, // pixels per second
		scrollLeftVel: null, // pixels per second
		scrollIntervalId: null, // ID of setTimeout for scrolling animation loop
	
		// defaults
		scrollSensitivity: 30, // pixels from edge for scrolling to start
		scrollSpeed: 200, // pixels per second, at maximum speed
		scrollIntervalMs: 50, // millisecond wait between scroll increment
	
	
		initAutoScroll: function() {
			var scrollEl = this.scrollEl;
	
			this.isAutoScroll =
				this.options.scroll &&
				scrollEl &&
				!scrollEl.is(window) &&
				!scrollEl.is(document);
	
			if (this.isAutoScroll) {
				// debounce makes sure rapid calls don't happen
				this.listenTo(scrollEl, 'scroll', debounce(this.handleDebouncedScroll, 100));
			}
		},
	
	
		destroyAutoScroll: function() {
			this.endAutoScroll(); // kill any animation loop
	
			// remove the scroll handler if there is a scrollEl
			if (this.isAutoScroll) {
				this.stopListeningTo(this.scrollEl, 'scroll'); // will probably get removed by unbindHandlers too :(
			}
		},
	
	
		// Computes and stores the bounding rectangle of scrollEl
		computeScrollBounds: function() {
			if (this.isAutoScroll) {
				this.scrollBounds = getOuterRect(this.scrollEl);
				// TODO: use getClientRect in future. but prevents auto scrolling when on top of scrollbars
			}
		},
	
	
		// Called when the dragging is in progress and scrolling should be updated
		updateAutoScroll: function(ev) {
			var sensitivity = this.scrollSensitivity;
			var bounds = this.scrollBounds;
			var topCloseness, bottomCloseness;
			var leftCloseness, rightCloseness;
			var topVel = 0;
			var leftVel = 0;
	
			if (bounds) { // only scroll if scrollEl exists
	
				// compute closeness to edges. valid range is from 0.0 - 1.0
				topCloseness = (sensitivity - (getEvY(ev) - bounds.top)) / sensitivity;
				bottomCloseness = (sensitivity - (bounds.bottom - getEvY(ev))) / sensitivity;
				leftCloseness = (sensitivity - (getEvX(ev) - bounds.left)) / sensitivity;
				rightCloseness = (sensitivity - (bounds.right - getEvX(ev))) / sensitivity;
	
				// translate vertical closeness into velocity.
				// mouse must be completely in bounds for velocity to happen.
				if (topCloseness >= 0 && topCloseness <= 1) {
					topVel = topCloseness * this.scrollSpeed * -1; // negative. for scrolling up
				}
				else if (bottomCloseness >= 0 && bottomCloseness <= 1) {
					topVel = bottomCloseness * this.scrollSpeed;
				}
	
				// translate horizontal closeness into velocity
				if (leftCloseness >= 0 && leftCloseness <= 1) {
					leftVel = leftCloseness * this.scrollSpeed * -1; // negative. for scrolling left
				}
				else if (rightCloseness >= 0 && rightCloseness <= 1) {
					leftVel = rightCloseness * this.scrollSpeed;
				}
			}
	
			this.setScrollVel(topVel, leftVel);
		},
	
	
		// Sets the speed-of-scrolling for the scrollEl
		setScrollVel: function(topVel, leftVel) {
	
			this.scrollTopVel = topVel;
			this.scrollLeftVel = leftVel;
	
			this.constrainScrollVel(); // massages into realistic values
	
			// if there is non-zero velocity, and an animation loop hasn't already started, then START
			if ((this.scrollTopVel || this.scrollLeftVel) && !this.scrollIntervalId) {
				this.scrollIntervalId = setInterval(
					proxy(this, 'scrollIntervalFunc'), // scope to `this`
					this.scrollIntervalMs
				);
			}
		},
	
	
		// Forces scrollTopVel and scrollLeftVel to be zero if scrolling has already gone all the way
		constrainScrollVel: function() {
			var el = this.scrollEl;
	
			if (this.scrollTopVel < 0) { // scrolling up?
				if (el.scrollTop() <= 0) { // already scrolled all the way up?
					this.scrollTopVel = 0;
				}
			}
			else if (this.scrollTopVel > 0) { // scrolling down?
				if (el.scrollTop() + el[0].clientHeight >= el[0].scrollHeight) { // already scrolled all the way down?
					this.scrollTopVel = 0;
				}
			}
	
			if (this.scrollLeftVel < 0) { // scrolling left?
				if (el.scrollLeft() <= 0) { // already scrolled all the left?
					this.scrollLeftVel = 0;
				}
			}
			else if (this.scrollLeftVel > 0) { // scrolling right?
				if (el.scrollLeft() + el[0].clientWidth >= el[0].scrollWidth) { // already scrolled all the way right?
					this.scrollLeftVel = 0;
				}
			}
		},
	
	
		// This function gets called during every iteration of the scrolling animation loop
		scrollIntervalFunc: function() {
			var el = this.scrollEl;
			var frac = this.scrollIntervalMs / 1000; // considering animation frequency, what the vel should be mult'd by
	
			// change the value of scrollEl's scroll
			if (this.scrollTopVel) {
				el.scrollTop(el.scrollTop() + this.scrollTopVel * frac);
			}
			if (this.scrollLeftVel) {
				el.scrollLeft(el.scrollLeft() + this.scrollLeftVel * frac);
			}
	
			this.constrainScrollVel(); // since the scroll values changed, recompute the velocities
	
			// if scrolled all the way, which causes the vels to be zero, stop the animation loop
			if (!this.scrollTopVel && !this.scrollLeftVel) {
				this.endAutoScroll();
			}
		},
	
	
		// Kills any existing scrolling animation loop
		endAutoScroll: function() {
			if (this.scrollIntervalId) {
				clearInterval(this.scrollIntervalId);
				this.scrollIntervalId = null;
	
				this.handleScrollEnd();
			}
		},
	
	
		// Get called when the scrollEl is scrolled (NOTE: this is delayed via debounce)
		handleDebouncedScroll: function() {
			// recompute all coordinates, but *only* if this is *not* part of our scrolling animation
			if (!this.scrollIntervalId) {
				this.handleScrollEnd();
			}
		},
	
	
		// Called when scrolling has stopped, whether through auto scroll, or the user scrolling
		handleScrollEnd: function() {
		}
	
	});
	;;
	
	/* Tracks mouse movements over a component and raises events about which hit the mouse is over.
	------------------------------------------------------------------------------------------------------------------------
	options:
	- subjectEl
	- subjectCenter
	*/
	
	var HitDragListener = DragListener.extend({
	
		component: null, // converts coordinates to hits
			// methods: prepareHits, releaseHits, queryHit
	
		origHit: null, // the hit the mouse was over when listening started
		hit: null, // the hit the mouse is over
		coordAdjust: null, // delta that will be added to the mouse coordinates when computing collisions
	
	
		constructor: function(component, options) {
			DragListener.call(this, options); // call the super-constructor
	
			this.component = component;
		},
	
	
		// Called when drag listening starts (but a real drag has not necessarily began).
		// ev might be undefined if dragging was started manually.
		handleInteractionStart: function(ev) {
			var subjectEl = this.subjectEl;
			var subjectRect;
			var origPoint;
			var point;
	
			this.computeCoords();
	
			if (ev) {
				origPoint = { left: getEvX(ev), top: getEvY(ev) };
				point = origPoint;
	
				// constrain the point to bounds of the element being dragged
				if (subjectEl) {
					subjectRect = getOuterRect(subjectEl); // used for centering as well
					point = constrainPoint(point, subjectRect);
				}
	
				this.origHit = this.queryHit(point.left, point.top);
	
				// treat the center of the subject as the collision point?
				if (subjectEl && this.options.subjectCenter) {
	
					// only consider the area the subject overlaps the hit. best for large subjects.
					// TODO: skip this if hit didn't supply left/right/top/bottom
					if (this.origHit) {
						subjectRect = intersectRects(this.origHit, subjectRect) ||
							subjectRect; // in case there is no intersection
					}
	
					point = getRectCenter(subjectRect);
				}
	
				this.coordAdjust = diffPoints(point, origPoint); // point - origPoint
			}
			else {
				this.origHit = null;
				this.coordAdjust = null;
			}
	
			// call the super-method. do it after origHit has been computed
			DragListener.prototype.handleInteractionStart.apply(this, arguments);
		},
	
	
		// Recomputes the drag-critical positions of elements
		computeCoords: function() {
			this.component.prepareHits();
			this.computeScrollBounds(); // why is this here??????
		},
	
	
		// Called when the actual drag has started
		handleDragStart: function(ev) {
			var hit;
	
			DragListener.prototype.handleDragStart.apply(this, arguments); // call the super-method
	
			// might be different from this.origHit if the min-distance is large
			hit = this.queryHit(getEvX(ev), getEvY(ev));
	
			// report the initial hit the mouse is over
			// especially important if no min-distance and drag starts immediately
			if (hit) {
				this.handleHitOver(hit);
			}
		},
	
	
		// Called when the drag moves
		handleDrag: function(dx, dy, ev) {
			var hit;
	
			DragListener.prototype.handleDrag.apply(this, arguments); // call the super-method
	
			hit = this.queryHit(getEvX(ev), getEvY(ev));
	
			if (!isHitsEqual(hit, this.hit)) { // a different hit than before?
				if (this.hit) {
					this.handleHitOut();
				}
				if (hit) {
					this.handleHitOver(hit);
				}
			}
		},
	
	
		// Called when dragging has been stopped
		handleDragEnd: function() {
			this.handleHitDone();
			DragListener.prototype.handleDragEnd.apply(this, arguments); // call the super-method
		},
	
	
		// Called when a the mouse has just moved over a new hit
		handleHitOver: function(hit) {
			var isOrig = isHitsEqual(hit, this.origHit);
	
			this.hit = hit;
	
			this.trigger('hitOver', this.hit, isOrig, this.origHit);
		},
	
	
		// Called when the mouse has just moved out of a hit
		handleHitOut: function() {
			if (this.hit) {
				this.trigger('hitOut', this.hit);
				this.handleHitDone();
				this.hit = null;
			}
		},
	
	
		// Called after a hitOut. Also called before a dragStop
		handleHitDone: function() {
			if (this.hit) {
				this.trigger('hitDone', this.hit);
			}
		},
	
	
		// Called when the interaction ends, whether there was a real drag or not
		handleInteractionEnd: function() {
			DragListener.prototype.handleInteractionEnd.apply(this, arguments); // call the super-method
	
			this.origHit = null;
			this.hit = null;
	
			this.component.releaseHits();
		},
	
	
		// Called when scrolling has stopped, whether through auto scroll, or the user scrolling
		handleScrollEnd: function() {
			DragListener.prototype.handleScrollEnd.apply(this, arguments); // call the super-method
	
			this.computeCoords(); // hits' absolute positions will be in new places. recompute
		},
	
	
		// Gets the hit underneath the coordinates for the given mouse event
		queryHit: function(left, top) {
	
			if (this.coordAdjust) {
				left += this.coordAdjust.left;
				top += this.coordAdjust.top;
			}
	
			return this.component.queryHit(left, top);
		}
	
	});
	
	
	// Returns `true` if the hits are identically equal. `false` otherwise. Must be from the same component.
	// Two null values will be considered equal, as two "out of the component" states are the same.
	function isHitsEqual(hit0, hit1) {
	
		if (!hit0 && !hit1) {
			return true;
		}
	
		if (hit0 && hit1) {
			return hit0.component === hit1.component &&
				isHitPropsWithin(hit0, hit1) &&
				isHitPropsWithin(hit1, hit0); // ensures all props are identical
		}
	
		return false;
	}
	
	
	// Returns true if all of subHit's non-standard properties are within superHit
	function isHitPropsWithin(subHit, superHit) {
		for (var propName in subHit) {
			if (!/^(component|left|right|top|bottom)$/.test(propName)) {
				if (subHit[propName] !== superHit[propName]) {
					return false;
				}
			}
		}
		return true;
	}
	
	;;
	
	/* Creates a clone of an element and lets it track the mouse as it moves
	----------------------------------------------------------------------------------------------------------------------*/
	
	var MouseFollower = Class.extend(ListenerMixin, {
	
		options: null,
	
		sourceEl: null, // the element that will be cloned and made to look like it is dragging
		el: null, // the clone of `sourceEl` that will track the mouse
		parentEl: null, // the element that `el` (the clone) will be attached to
	
		// the initial position of el, relative to the offset parent. made to match the initial offset of sourceEl
		top0: null,
		left0: null,
	
		// the absolute coordinates of the initiating touch/mouse action
		y0: null,
		x0: null,
	
		// the number of pixels the mouse has moved from its initial position
		topDelta: null,
		leftDelta: null,
	
		isFollowing: false,
		isHidden: false,
		isAnimating: false, // doing the revert animation?
	
		constructor: function(sourceEl, options) {
			this.options = options = options || {};
			this.sourceEl = sourceEl;
			this.parentEl = options.parentEl ? $(options.parentEl) : sourceEl.parent(); // default to sourceEl's parent
		},
	
	
		// Causes the element to start following the mouse
		start: function(ev) {
			if (!this.isFollowing) {
				this.isFollowing = true;
	
				this.y0 = getEvY(ev);
				this.x0 = getEvX(ev);
				this.topDelta = 0;
				this.leftDelta = 0;
	
				if (!this.isHidden) {
					this.updatePosition();
				}
	
				if (getEvIsTouch(ev)) {
					this.listenTo($(document), 'touchmove', this.handleMove);
				}
				else {
					this.listenTo($(document), 'mousemove', this.handleMove);
				}
			}
		},
	
	
		// Causes the element to stop following the mouse. If shouldRevert is true, will animate back to original position.
		// `callback` gets invoked when the animation is complete. If no animation, it is invoked immediately.
		stop: function(shouldRevert, callback) {
			var _this = this;
			var revertDuration = this.options.revertDuration;
	
			function complete() { // might be called by .animate(), which might change `this` context
				_this.isAnimating = false;
				_this.removeElement();
	
				_this.top0 = _this.left0 = null; // reset state for future updatePosition calls
	
				if (callback) {
					callback();
				}
			}
	
			if (this.isFollowing && !this.isAnimating) { // disallow more than one stop animation at a time
				this.isFollowing = false;
	
				this.stopListeningTo($(document));
	
				if (shouldRevert && revertDuration && !this.isHidden) { // do a revert animation?
					this.isAnimating = true;
					this.el.animate({
						top: this.top0,
						left: this.left0
					}, {
						duration: revertDuration,
						complete: complete
					});
				}
				else {
					complete();
				}
			}
		},
	
	
		// Gets the tracking element. Create it if necessary
		getEl: function() {
			var el = this.el;
	
			if (!el) {
				el = this.el = this.sourceEl.clone()
					.addClass(this.options.additionalClass || '')
					.css({
						position: 'absolute',
						visibility: '', // in case original element was hidden (commonly through hideEvents())
						display: this.isHidden ? 'none' : '', // for when initially hidden
						margin: 0,
						right: 'auto', // erase and set width instead
						bottom: 'auto', // erase and set height instead
						width: this.sourceEl.width(), // explicit height in case there was a 'right' value
						height: this.sourceEl.height(), // explicit width in case there was a 'bottom' value
						opacity: this.options.opacity || '',
						zIndex: this.options.zIndex
					});
	
				// we don't want long taps or any mouse interaction causing selection/menus.
				// would use preventSelection(), but that prevents selectstart, causing problems.
				el.addClass('fc-unselectable');
	
				el.appendTo(this.parentEl);
			}
	
			return el;
		},
	
	
		// Removes the tracking element if it has already been created
		removeElement: function() {
			if (this.el) {
				this.el.remove();
				this.el = null;
			}
		},
	
	
		// Update the CSS position of the tracking element
		updatePosition: function() {
			var sourceOffset;
			var origin;
	
			this.getEl(); // ensure this.el
	
			// make sure origin info was computed
			if (this.top0 === null) {
				sourceOffset = this.sourceEl.offset();
				origin = this.el.offsetParent().offset();
				this.top0 = sourceOffset.top - origin.top;
				this.left0 = sourceOffset.left - origin.left;
			}
	
			this.el.css({
				top: this.top0 + this.topDelta,
				left: this.left0 + this.leftDelta
			});
		},
	
	
		// Gets called when the user moves the mouse
		handleMove: function(ev) {
			this.topDelta = getEvY(ev) - this.y0;
			this.leftDelta = getEvX(ev) - this.x0;
	
			if (!this.isHidden) {
				this.updatePosition();
			}
		},
	
	
		// Temporarily makes the tracking element invisible. Can be called before following starts
		hide: function() {
			if (!this.isHidden) {
				this.isHidden = true;
				if (this.el) {
					this.el.hide();
				}
			}
		},
	
	
		// Show the tracking element after it has been temporarily hidden
		show: function() {
			if (this.isHidden) {
				this.isHidden = false;
				this.updatePosition();
				this.getEl().show();
			}
		}
	
	});
	
	;;
	
	/* An abstract class comprised of a "grid" of areas that each represent a specific datetime
	----------------------------------------------------------------------------------------------------------------------*/
	
	var Grid = FC.Grid = Class.extend(ListenerMixin, MouseIgnorerMixin, {
	
		// self-config, overridable by subclasses
		hasDayInteractions: true, // can user click/select ranges of time?
	
		view: null, // a View object
		isRTL: null, // shortcut to the view's isRTL option
	
		start: null,
		end: null,
	
		el: null, // the containing element
		elsByFill: null, // a hash of jQuery element sets used for rendering each fill. Keyed by fill name.
	
		// derived from options
		eventTimeFormat: null,
		displayEventTime: null,
		displayEventEnd: null,
	
		minResizeDuration: null, // TODO: hack. set by subclasses. minumum event resize duration
	
		// if defined, holds the unit identified (ex: "year" or "month") that determines the level of granularity
		// of the date areas. if not defined, assumes to be day and time granularity.
		// TODO: port isTimeScale into same system?
		largeUnit: null,
	
		dayDragListener: null,
		segDragListener: null,
		segResizeListener: null,
		externalDragListener: null,
	
	
		constructor: function(view) {
			this.view = view;
			this.isRTL = view.opt('isRTL');
			this.elsByFill = {};
	
			this.dayDragListener = this.buildDayDragListener();
			this.initMouseIgnoring();
		},
	
	
		/* Options
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Generates the format string used for event time text, if not explicitly defined by 'timeFormat'
		computeEventTimeFormat: function() {
			return this.view.opt('smallTimeFormat');
		},
	
	
		// Determines whether events should have their end times displayed, if not explicitly defined by 'displayEventTime'.
		// Only applies to non-all-day events.
		computeDisplayEventTime: function() {
			return true;
		},
	
	
		// Determines whether events should have their end times displayed, if not explicitly defined by 'displayEventEnd'
		computeDisplayEventEnd: function() {
			return true;
		},
	
	
		/* Dates
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Tells the grid about what period of time to display.
		// Any date-related internal data should be generated.
		setRange: function(range) {
			this.start = range.start.clone();
			this.end = range.end.clone();
	
			this.rangeUpdated();
			this.processRangeOptions();
		},
	
	
		// Called when internal variables that rely on the range should be updated
		rangeUpdated: function() {
		},
	
	
		// Updates values that rely on options and also relate to range
		processRangeOptions: function() {
			var view = this.view;
			var displayEventTime;
			var displayEventEnd;
	
			this.eventTimeFormat =
				view.opt('eventTimeFormat') ||
				view.opt('timeFormat') || // deprecated
				this.computeEventTimeFormat();
	
			displayEventTime = view.opt('displayEventTime');
			if (displayEventTime == null) {
				displayEventTime = this.computeDisplayEventTime(); // might be based off of range
			}
	
			displayEventEnd = view.opt('displayEventEnd');
			if (displayEventEnd == null) {
				displayEventEnd = this.computeDisplayEventEnd(); // might be based off of range
			}
	
			this.displayEventTime = displayEventTime;
			this.displayEventEnd = displayEventEnd;
		},
	
	
		// Converts a span (has unzoned start/end and any other grid-specific location information)
		// into an array of segments (pieces of events whose format is decided by the grid).
		spanToSegs: function(span) {
			// subclasses must implement
		},
	
	
		// Diffs the two dates, returning a duration, based on granularity of the grid
		// TODO: port isTimeScale into this system?
		diffDates: function(a, b) {
			if (this.largeUnit) {
				return diffByUnit(a, b, this.largeUnit);
			}
			else {
				return diffDayTime(a, b);
			}
		},
	
	
		/* Hit Area
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Called before one or more queryHit calls might happen. Should prepare any cached coordinates for queryHit
		prepareHits: function() {
		},
	
	
		// Called when queryHit calls have subsided. Good place to clear any coordinate caches.
		releaseHits: function() {
		},
	
	
		// Given coordinates from the topleft of the document, return data about the date-related area underneath.
		// Can return an object with arbitrary properties (although top/right/left/bottom are encouraged).
		// Must have a `grid` property, a reference to this current grid. TODO: avoid this
		// The returned object will be processed by getHitSpan and getHitEl.
		queryHit: function(leftOffset, topOffset) {
		},
	
	
		// Given position-level information about a date-related area within the grid,
		// should return an object with at least a start/end date. Can provide other information as well.
		getHitSpan: function(hit) {
		},
	
	
		// Given position-level information about a date-related area within the grid,
		// should return a jQuery element that best represents it. passed to dayClick callback.
		getHitEl: function(hit) {
		},
	
	
		/* Rendering
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Sets the container element that the grid should render inside of.
		// Does other DOM-related initializations.
		setElement: function(el) {
			this.el = el;
	
			if (this.hasDayInteractions) {
				preventSelection(el);
	
				this.bindDayHandler('touchstart', this.dayTouchStart);
				this.bindDayHandler('mousedown', this.dayMousedown);
			}
	
			// attach event-element-related handlers. in Grid.events
			// same garbage collection note as above.
			this.bindSegHandlers();
	
			this.bindGlobalHandlers();
		},
	
	
		bindDayHandler: function(name, handler) {
			var _this = this;
	
			// attach a handler to the grid's root element.
			// jQuery will take care of unregistering them when removeElement gets called.
			this.el.on(name, function(ev) {
				if (
					!$(ev.target).is(
						_this.segSelector + ',' + // directly on an event element
						_this.segSelector + ' *,' + // within an event element
						'.fc-more,' + // a "more.." link
						'a[data-goto]' // a clickable nav link
					)
				) {
					return handler.call(_this, ev);
				}
			});
		},
	
	
		// Removes the grid's container element from the DOM. Undoes any other DOM-related attachments.
		// DOES NOT remove any content beforehand (doesn't clear events or call unrenderDates), unlike View
		removeElement: function() {
			this.unbindGlobalHandlers();
			this.clearDragListeners();
	
			this.el.remove();
	
			// NOTE: we don't null-out this.el for the same reasons we don't do it within View::removeElement
		},
	
	
		// Renders the basic structure of grid view before any content is rendered
		renderSkeleton: function() {
			// subclasses should implement
		},
	
	
		// Renders the grid's date-related content (like areas that represent days/times).
		// Assumes setRange has already been called and the skeleton has already been rendered.
		renderDates: function() {
			// subclasses should implement
		},
	
	
		// Unrenders the grid's date-related content
		unrenderDates: function() {
			// subclasses should implement
		},
	
	
		/* Handlers
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Binds DOM handlers to elements that reside outside the grid, such as the document
		bindGlobalHandlers: function() {
			this.listenTo($(document), {
				dragstart: this.externalDragStart, // jqui
				sortstart: this.externalDragStart // jqui
			});
		},
	
	
		// Unbinds DOM handlers from elements that reside outside the grid
		unbindGlobalHandlers: function() {
			this.stopListeningTo($(document));
		},
	
	
		// Process a mousedown on an element that represents a day. For day clicking and selecting.
		dayMousedown: function(ev) {
			if (!this.isIgnoringMouse) {
				this.dayDragListener.startInteraction(ev, {
					//distance: 5, // needs more work if we want dayClick to fire correctly
				});
			}
		},
	
	
		dayTouchStart: function(ev) {
			var view = this.view;
			var selectLongPressDelay = view.opt('selectLongPressDelay');
	
			// HACK to prevent a user's clickaway for unselecting a range or an event
			// from causing a dayClick.
			if (view.isSelected || view.selectedEvent) {
				this.tempIgnoreMouse();
			}
	
			if (selectLongPressDelay == null) {
				selectLongPressDelay = view.opt('longPressDelay'); // fallback
			}
	
			this.dayDragListener.startInteraction(ev, {
				delay: selectLongPressDelay
			});
		},
	
	
		// Creates a listener that tracks the user's drag across day elements.
		// For day clicking and selecting.
		buildDayDragListener: function() {
			var _this = this;
			var view = this.view;
			var isSelectable = view.opt('selectable');
			var dayClickHit; // null if invalid dayClick
			var selectionSpan; // null if invalid selection
	
			// this listener tracks a mousedown on a day element, and a subsequent drag.
			// if the drag ends on the same day, it is a 'dayClick'.
			// if 'selectable' is enabled, this listener also detects selections.
			var dragListener = new HitDragListener(this, {
				scroll: view.opt('dragScroll'),
				interactionStart: function() {
					dayClickHit = dragListener.origHit; // for dayClick, where no dragging happens
					selectionSpan = null;
				},
				dragStart: function() {
					view.unselect(); // since we could be rendering a new selection, we want to clear any old one
				},
				hitOver: function(hit, isOrig, origHit) {
					if (origHit) { // click needs to have started on a hit
	
						// if user dragged to another cell at any point, it can no longer be a dayClick
						if (!isOrig) {
							dayClickHit = null;
						}
	
						if (isSelectable) {
							selectionSpan = _this.computeSelection(
								_this.getHitSpan(origHit),
								_this.getHitSpan(hit)
							);
							if (selectionSpan) {
								_this.renderSelection(selectionSpan);
							}
							else if (selectionSpan === false) {
								disableCursor();
							}
						}
					}
				},
				hitOut: function() { // called before mouse moves to a different hit OR moved out of all hits
					dayClickHit = null;
					selectionSpan = null;
					_this.unrenderSelection();
				},
				hitDone: function() { // called after a hitOut OR before a dragEnd
					enableCursor();
				},
				interactionEnd: function(ev, isCancelled) {
					if (!isCancelled) {
						if (
							dayClickHit &&
							!_this.isIgnoringMouse // see hack in dayTouchStart
						) {
							view.triggerDayClick(
								_this.getHitSpan(dayClickHit),
								_this.getHitEl(dayClickHit),
								ev
							);
						}
						if (selectionSpan) {
							// the selection will already have been rendered. just report it
							view.reportSelection(selectionSpan, ev);
						}
					}
				}
			});
	
			return dragListener;
		},
	
	
		// Kills all in-progress dragging.
		// Useful for when public API methods that result in re-rendering are invoked during a drag.
		// Also useful for when touch devices misbehave and don't fire their touchend.
		clearDragListeners: function() {
			this.dayDragListener.endInteraction();
	
			if (this.segDragListener) {
				this.segDragListener.endInteraction(); // will clear this.segDragListener
			}
			if (this.segResizeListener) {
				this.segResizeListener.endInteraction(); // will clear this.segResizeListener
			}
			if (this.externalDragListener) {
				this.externalDragListener.endInteraction(); // will clear this.externalDragListener
			}
		},
	
	
		/* Event Helper
		------------------------------------------------------------------------------------------------------------------*/
		// TODO: should probably move this to Grid.events, like we did event dragging / resizing
	
	
		// Renders a mock event at the given event location, which contains zoned start/end properties.
		// Returns all mock event elements.
		renderEventLocationHelper: function(eventLocation, sourceSeg) {
			var fakeEvent = this.fabricateHelperEvent(eventLocation, sourceSeg);
	
			return this.renderHelper(fakeEvent, sourceSeg); // do the actual rendering
		},
	
	
		// Builds a fake event given zoned event date properties and a segment is should be inspired from.
		// The range's end can be null, in which case the mock event that is rendered will have a null end time.
		// `sourceSeg` is the internal segment object involved in the drag. If null, something external is dragging.
		fabricateHelperEvent: function(eventLocation, sourceSeg) {
			var fakeEvent = sourceSeg ? createObject(sourceSeg.event) : {}; // mask the original event object if possible
	
			fakeEvent.start = eventLocation.start.clone();
			fakeEvent.end = eventLocation.end ? eventLocation.end.clone() : null;
			fakeEvent.allDay = null; // force it to be freshly computed by normalizeEventDates
			this.view.calendar.normalizeEventDates(fakeEvent);
	
			// this extra className will be useful for differentiating real events from mock events in CSS
			fakeEvent.className = (fakeEvent.className || []).concat('fc-helper');
	
			// if something external is being dragged in, don't render a resizer
			if (!sourceSeg) {
				fakeEvent.editable = false;
			}
	
			return fakeEvent;
		},
	
	
		// Renders a mock event. Given zoned event date properties.
		// Must return all mock event elements.
		renderHelper: function(eventLocation, sourceSeg) {
			// subclasses must implement
		},
	
	
		// Unrenders a mock event
		unrenderHelper: function() {
			// subclasses must implement
		},
	
	
		/* Selection
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Renders a visual indication of a selection. Will highlight by default but can be overridden by subclasses.
		// Given a span (unzoned start/end and other misc data)
		renderSelection: function(span) {
			this.renderHighlight(span);
		},
	
	
		// Unrenders any visual indications of a selection. Will unrender a highlight by default.
		unrenderSelection: function() {
			this.unrenderHighlight();
		},
	
	
		// Given the first and last date-spans of a selection, returns another date-span object.
		// Subclasses can override and provide additional data in the span object. Will be passed to renderSelection().
		// Will return false if the selection is invalid and this should be indicated to the user.
		// Will return null/undefined if a selection invalid but no error should be reported.
		computeSelection: function(span0, span1) {
			var span = this.computeSelectionSpan(span0, span1);
	
			if (span && !this.view.calendar.isSelectionSpanAllowed(span)) {
				return false;
			}
	
			return span;
		},
	
	
		// Given two spans, must return the combination of the two.
		// TODO: do this separation of concerns (combining VS validation) for event dnd/resize too.
		computeSelectionSpan: function(span0, span1) {
			var dates = [ span0.start, span0.end, span1.start, span1.end ];
	
			dates.sort(compareNumbers); // sorts chronologically. works with Moments
	
			return { start: dates[0].clone(), end: dates[3].clone() };
		},
	
	
		/* Highlight
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Renders an emphasis on the given date range. Given a span (unzoned start/end and other misc data)
		renderHighlight: function(span) {
			this.renderFill('highlight', this.spanToSegs(span));
		},
	
	
		// Unrenders the emphasis on a date range
		unrenderHighlight: function() {
			this.unrenderFill('highlight');
		},
	
	
		// Generates an array of classNames for rendering the highlight. Used by the fill system.
		highlightSegClasses: function() {
			return [ 'fc-highlight' ];
		},
	
	
		/* Business Hours
		------------------------------------------------------------------------------------------------------------------*/
	
	
		renderBusinessHours: function() {
		},
	
	
		unrenderBusinessHours: function() {
		},
	
	
		/* Now Indicator
		------------------------------------------------------------------------------------------------------------------*/
	
	
		getNowIndicatorUnit: function() {
		},
	
	
		renderNowIndicator: function(date) {
		},
	
	
		unrenderNowIndicator: function() {
		},
	
	
		/* Fill System (highlight, background events, business hours)
		--------------------------------------------------------------------------------------------------------------------
		TODO: remove this system. like we did in TimeGrid
		*/
	
	
		// Renders a set of rectangles over the given segments of time.
		// MUST RETURN a subset of segs, the segs that were actually rendered.
		// Responsible for populating this.elsByFill. TODO: better API for expressing this requirement
		renderFill: function(type, segs) {
			// subclasses must implement
		},
	
	
		// Unrenders a specific type of fill that is currently rendered on the grid
		unrenderFill: function(type) {
			var el = this.elsByFill[type];
	
			if (el) {
				el.remove();
				delete this.elsByFill[type];
			}
		},
	
	
		// Renders and assigns an `el` property for each fill segment. Generic enough to work with different types.
		// Only returns segments that successfully rendered.
		// To be harnessed by renderFill (implemented by subclasses).
		// Analagous to renderFgSegEls.
		renderFillSegEls: function(type, segs) {
			var _this = this;
			var segElMethod = this[type + 'SegEl'];
			var html = '';
			var renderedSegs = [];
			var i;
	
			if (segs.length) {
	
				// build a large concatenation of segment HTML
				for (i = 0; i < segs.length; i++) {
					html += this.fillSegHtml(type, segs[i]);
				}
	
				// Grab individual elements from the combined HTML string. Use each as the default rendering.
				// Then, compute the 'el' for each segment.
				$(html).each(function(i, node) {
					var seg = segs[i];
					var el = $(node);
	
					// allow custom filter methods per-type
					if (segElMethod) {
						el = segElMethod.call(_this, seg, el);
					}
	
					if (el) { // custom filters did not cancel the render
						el = $(el); // allow custom filter to return raw DOM node
	
						// correct element type? (would be bad if a non-TD were inserted into a table for example)
						if (el.is(_this.fillSegTag)) {
							seg.el = el;
							renderedSegs.push(seg);
						}
					}
				});
			}
	
			return renderedSegs;
		},
	
	
		fillSegTag: 'div', // subclasses can override
	
	
		// Builds the HTML needed for one fill segment. Generic enough to work with different types.
		fillSegHtml: function(type, seg) {
	
			// custom hooks per-type
			var classesMethod = this[type + 'SegClasses'];
			var cssMethod = this[type + 'SegCss'];
	
			var classes = classesMethod ? classesMethod.call(this, seg) : [];
			var css = cssToStr(cssMethod ? cssMethod.call(this, seg) : {});
	
			return '<' + this.fillSegTag +
				(classes.length ? ' class="' + classes.join(' ') + '"' : '') +
				(css ? ' style="' + css + '"' : '') +
				' />';
		},
	
	
	
		/* Generic rendering utilities for subclasses
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Computes HTML classNames for a single-day element
		getDayClasses: function(date, noThemeHighlight) {
			var view = this.view;
			var today = view.calendar.getNow();
			var classes = [ 'fc-' + dayIDs[date.day()] ];
	
			if (
				view.intervalDuration.as('months') == 1 &&
				date.month() != view.intervalStart.month()
			) {
				classes.push('fc-other-month');
			}
	
			if (date.isSame(today, 'day')) {
				classes.push('fc-today');
	
				if (noThemeHighlight !== true) {
					classes.push(view.highlightStateClass);
				}
			}
			else if (date < today) {
				classes.push('fc-past');
			}
			else {
				classes.push('fc-future');
			}
	
			return classes;
		}
	
	});
	
	;;
	
	/* Event-rendering and event-interaction methods for the abstract Grid class
	----------------------------------------------------------------------------------------------------------------------*/
	
	Grid.mixin({
	
		// self-config, overridable by subclasses
		segSelector: '.fc-event-container > *', // what constitutes an event element?
	
		mousedOverSeg: null, // the segment object the user's mouse is over. null if over nothing
		isDraggingSeg: false, // is a segment being dragged? boolean
		isResizingSeg: false, // is a segment being resized? boolean
		isDraggingExternal: false, // jqui-dragging an external element? boolean
		segs: null, // the *event* segments currently rendered in the grid. TODO: rename to `eventSegs`
	
	
		// Renders the given events onto the grid
		renderEvents: function(events) {
			var bgEvents = [];
			var fgEvents = [];
			var i;
	
			for (i = 0; i < events.length; i++) {
				(isBgEvent(events[i]) ? bgEvents : fgEvents).push(events[i]);
			}
	
			this.segs = [].concat( // record all segs
				this.renderBgEvents(bgEvents),
				this.renderFgEvents(fgEvents)
			);
		},
	
	
		renderBgEvents: function(events) {
			var segs = this.eventsToSegs(events);
	
			// renderBgSegs might return a subset of segs, segs that were actually rendered
			return this.renderBgSegs(segs) || segs;
		},
	
	
		renderFgEvents: function(events) {
			var segs = this.eventsToSegs(events);
	
			// renderFgSegs might return a subset of segs, segs that were actually rendered
			return this.renderFgSegs(segs) || segs;
		},
	
	
		// Unrenders all events currently rendered on the grid
		unrenderEvents: function() {
			this.handleSegMouseout(); // trigger an eventMouseout if user's mouse is over an event
			this.clearDragListeners();
	
			this.unrenderFgSegs();
			this.unrenderBgSegs();
	
			this.segs = null;
		},
	
	
		// Retrieves all rendered segment objects currently rendered on the grid
		getEventSegs: function() {
			return this.segs || [];
		},
	
	
		/* Foreground Segment Rendering
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Renders foreground event segments onto the grid. May return a subset of segs that were rendered.
		renderFgSegs: function(segs) {
			// subclasses must implement
		},
	
	
		// Unrenders all currently rendered foreground segments
		unrenderFgSegs: function() {
			// subclasses must implement
		},
	
	
		// Renders and assigns an `el` property for each foreground event segment.
		// Only returns segments that successfully rendered.
		// A utility that subclasses may use.
		renderFgSegEls: function(segs, disableResizing) {
			var view = this.view;
			var html = '';
			var renderedSegs = [];
			var i;
	
			if (segs.length) { // don't build an empty html string
	
				// build a large concatenation of event segment HTML
				for (i = 0; i < segs.length; i++) {
					html += this.fgSegHtml(segs[i], disableResizing);
				}
	
				// Grab individual elements from the combined HTML string. Use each as the default rendering.
				// Then, compute the 'el' for each segment. An el might be null if the eventRender callback returned false.
				$(html).each(function(i, node) {
					var seg = segs[i];
					var el = view.resolveEventEl(seg.event, $(node));
	
					if (el) {
						el.data('fc-seg', seg); // used by handlers
						seg.el = el;
						renderedSegs.push(seg);
					}
				});
			}
	
			return renderedSegs;
		},
	
	
		// Generates the HTML for the default rendering of a foreground event segment. Used by renderFgSegEls()
		fgSegHtml: function(seg, disableResizing) {
			// subclasses should implement
		},
	
	
		/* Background Segment Rendering
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Renders the given background event segments onto the grid.
		// Returns a subset of the segs that were actually rendered.
		renderBgSegs: function(segs) {
			return this.renderFill('bgEvent', segs);
		},
	
	
		// Unrenders all the currently rendered background event segments
		unrenderBgSegs: function() {
			this.unrenderFill('bgEvent');
		},
	
	
		// Renders a background event element, given the default rendering. Called by the fill system.
		bgEventSegEl: function(seg, el) {
			return this.view.resolveEventEl(seg.event, el); // will filter through eventRender
		},
	
	
		// Generates an array of classNames to be used for the default rendering of a background event.
		// Called by fillSegHtml.
		bgEventSegClasses: function(seg) {
			var event = seg.event;
			var source = event.source || {};
	
			return [ 'fc-bgevent' ].concat(
				event.className,
				source.className || []
			);
		},
	
	
		// Generates a semicolon-separated CSS string to be used for the default rendering of a background event.
		// Called by fillSegHtml.
		bgEventSegCss: function(seg) {
			return {
				'background-color': this.getSegSkinCss(seg)['background-color']
			};
		},
	
	
		// Generates an array of classNames to be used for the rendering business hours overlay. Called by the fill system.
		// Called by fillSegHtml.
		businessHoursSegClasses: function(seg) {
			return [ 'fc-nonbusiness', 'fc-bgevent' ];
		},
	
	
		/* Business Hours
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Compute business hour segs for the grid's current date range.
		// Caller must ask if whole-day business hours are needed.
		// If no `businessHours` configuration value is specified, assumes the calendar default.
		buildBusinessHourSegs: function(wholeDay, businessHours) {
			return this.eventsToSegs(
				this.buildBusinessHourEvents(wholeDay, businessHours)
			);
		},
	
	
		// Compute business hour *events* for the grid's current date range.
		// Caller must ask if whole-day business hours are needed.
		// If no `businessHours` configuration value is specified, assumes the calendar default.
		buildBusinessHourEvents: function(wholeDay, businessHours) {
			var calendar = this.view.calendar;
			var events;
	
			if (businessHours == null) {
				// fallback
				// access from calendawr. don't access from view. doesn't update with dynamic options.
				businessHours = calendar.options.businessHours;
			}
	
			events = calendar.computeBusinessHourEvents(wholeDay, businessHours);
	
			// HACK. Eventually refactor business hours "events" system.
			// If no events are given, but businessHours is activated, this means the entire visible range should be
			// marked as *not* business-hours, via inverse-background rendering.
			if (!events.length && businessHours) {
				events = [
					$.extend({}, BUSINESS_HOUR_EVENT_DEFAULTS, {
						start: this.view.end, // guaranteed out-of-range
						end: this.view.end,   // "
						dow: null
					})
				];
			}
	
			return events;
		},
	
	
		/* Handlers
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Attaches event-element-related handlers for *all* rendered event segments of the view.
		bindSegHandlers: function() {
			this.bindSegHandlersToEl(this.el);
		},
	
	
		// Attaches event-element-related handlers to an arbitrary container element. leverages bubbling.
		bindSegHandlersToEl: function(el) {
			this.bindSegHandlerToEl(el, 'touchstart', this.handleSegTouchStart);
			this.bindSegHandlerToEl(el, 'touchend', this.handleSegTouchEnd);
			this.bindSegHandlerToEl(el, 'mouseenter', this.handleSegMouseover);
			this.bindSegHandlerToEl(el, 'mouseleave', this.handleSegMouseout);
			this.bindSegHandlerToEl(el, 'mousedown', this.handleSegMousedown);
			this.bindSegHandlerToEl(el, 'click', this.handleSegClick);
		},
	
	
		// Executes a handler for any a user-interaction on a segment.
		// Handler gets called with (seg, ev), and with the `this` context of the Grid
		bindSegHandlerToEl: function(el, name, handler) {
			var _this = this;
	
			el.on(name, this.segSelector, function(ev) {
				var seg = $(this).data('fc-seg'); // grab segment data. put there by View::renderEvents
	
				// only call the handlers if there is not a drag/resize in progress
				if (seg && !_this.isDraggingSeg && !_this.isResizingSeg) {
					return handler.call(_this, seg, ev); // context will be the Grid
				}
			});
		},
	
	
		handleSegClick: function(seg, ev) {
			var res = this.view.publiclyTrigger('eventClick', seg.el[0], seg.event, ev); // can return `false` to cancel
			if (res === false) {
				ev.preventDefault();
			}
		},
	
	
		// Updates internal state and triggers handlers for when an event element is moused over
		handleSegMouseover: function(seg, ev) {
			if (
				!this.isIgnoringMouse &&
				!this.mousedOverSeg
			) {
				this.mousedOverSeg = seg;
				if (this.view.isEventResizable(seg.event)) {
					seg.el.addClass('fc-allow-mouse-resize');
				}
				this.view.publiclyTrigger('eventMouseover', seg.el[0], seg.event, ev);
			}
		},
	
	
		// Updates internal state and triggers handlers for when an event element is moused out.
		// Can be given no arguments, in which case it will mouseout the segment that was previously moused over.
		handleSegMouseout: function(seg, ev) {
			ev = ev || {}; // if given no args, make a mock mouse event
	
			if (this.mousedOverSeg) {
				seg = seg || this.mousedOverSeg; // if given no args, use the currently moused-over segment
				this.mousedOverSeg = null;
				if (this.view.isEventResizable(seg.event)) {
					seg.el.removeClass('fc-allow-mouse-resize');
				}
				this.view.publiclyTrigger('eventMouseout', seg.el[0], seg.event, ev);
			}
		},
	
	
		handleSegMousedown: function(seg, ev) {
			var isResizing = this.startSegResize(seg, ev, { distance: 5 });
	
			if (!isResizing && this.view.isEventDraggable(seg.event)) {
				this.buildSegDragListener(seg)
					.startInteraction(ev, {
						distance: 5
					});
			}
		},
	
	
		handleSegTouchStart: function(seg, ev) {
			var view = this.view;
			var event = seg.event;
			var isSelected = view.isEventSelected(event);
			var isDraggable = view.isEventDraggable(event);
			var isResizable = view.isEventResizable(event);
			var isResizing = false;
			var dragListener;
			var eventLongPressDelay;
	
			if (isSelected && isResizable) {
				// only allow resizing of the event is selected
				isResizing = this.startSegResize(seg, ev);
			}
	
			if (!isResizing && (isDraggable || isResizable)) { // allowed to be selected?
	
				eventLongPressDelay = view.opt('eventLongPressDelay');
				if (eventLongPressDelay == null) {
					eventLongPressDelay = view.opt('longPressDelay'); // fallback
				}
	
				dragListener = isDraggable ?
					this.buildSegDragListener(seg) :
					this.buildSegSelectListener(seg); // seg isn't draggable, but still needs to be selected
	
				dragListener.startInteraction(ev, { // won't start if already started
					delay: isSelected ? 0 : eventLongPressDelay // do delay if not already selected
				});
			}
	
			// a long tap simulates a mouseover. ignore this bogus mouseover.
			this.tempIgnoreMouse();
		},
	
	
		handleSegTouchEnd: function(seg, ev) {
			// touchstart+touchend = click, which simulates a mouseover.
			// ignore this bogus mouseover.
			this.tempIgnoreMouse();
		},
	
	
		// returns boolean whether resizing actually started or not.
		// assumes the seg allows resizing.
		// `dragOptions` are optional.
		startSegResize: function(seg, ev, dragOptions) {
			if ($(ev.target).is('.fc-resizer')) {
				this.buildSegResizeListener(seg, $(ev.target).is('.fc-start-resizer'))
					.startInteraction(ev, dragOptions);
				return true;
			}
			return false;
		},
	
	
	
		/* Event Dragging
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Builds a listener that will track user-dragging on an event segment.
		// Generic enough to work with any type of Grid.
		// Has side effect of setting/unsetting `segDragListener`
		buildSegDragListener: function(seg) {
			var _this = this;
			var view = this.view;
			var calendar = view.calendar;
			var el = seg.el;
			var event = seg.event;
			var isDragging;
			var mouseFollower; // A clone of the original element that will move with the mouse
			var dropLocation; // zoned event date properties
	
			if (this.segDragListener) {
				return this.segDragListener;
			}
	
			// Tracks mouse movement over the *view's* coordinate map. Allows dragging and dropping between subcomponents
			// of the view.
			var dragListener = this.segDragListener = new HitDragListener(view, {
				scroll: view.opt('dragScroll'),
				subjectEl: el,
				subjectCenter: true,
				interactionStart: function(ev) {
					seg.component = _this; // for renderDrag
					isDragging = false;
					mouseFollower = new MouseFollower(seg.el, {
						additionalClass: 'fc-dragging',
						parentEl: view.el,
						opacity: dragListener.isTouch ? null : view.opt('dragOpacity'),
						revertDuration: view.opt('dragRevertDuration'),
						zIndex: 2 // one above the .fc-view
					});
					mouseFollower.hide(); // don't show until we know this is a real drag
					mouseFollower.start(ev);
				},
				dragStart: function(ev) {
					if (dragListener.isTouch && !view.isEventSelected(event)) {
						// if not previously selected, will fire after a delay. then, select the event
						view.selectEvent(event);
					}
					isDragging = true;
					_this.handleSegMouseout(seg, ev); // ensure a mouseout on the manipulated event has been reported
					_this.segDragStart(seg, ev);
					view.hideEvent(event); // hide all event segments. our mouseFollower will take over
				},
				hitOver: function(hit, isOrig, origHit) {
					var dragHelperEls;
	
					// starting hit could be forced (DayGrid.limit)
					if (seg.hit) {
						origHit = seg.hit;
					}
	
					// since we are querying the parent view, might not belong to this grid
					dropLocation = _this.computeEventDrop(
						origHit.component.getHitSpan(origHit),
						hit.component.getHitSpan(hit),
						event
					);
	
					if (dropLocation && !calendar.isEventSpanAllowed(_this.eventToSpan(dropLocation), event)) {
						disableCursor();
						dropLocation = null;
					}
	
					// if a valid drop location, have the subclass render a visual indication
					if (dropLocation && (dragHelperEls = view.renderDrag(dropLocation, seg))) {
	
						dragHelperEls.addClass('fc-dragging');
						if (!dragListener.isTouch) {
							_this.applyDragOpacity(dragHelperEls);
						}
	
						mouseFollower.hide(); // if the subclass is already using a mock event "helper", hide our own
					}
					else {
						mouseFollower.show(); // otherwise, have the helper follow the mouse (no snapping)
					}
	
					if (isOrig) {
						dropLocation = null; // needs to have moved hits to be a valid drop
					}
				},
				hitOut: function() { // called before mouse moves to a different hit OR moved out of all hits
					view.unrenderDrag(); // unrender whatever was done in renderDrag
					mouseFollower.show(); // show in case we are moving out of all hits
					dropLocation = null;
				},
				hitDone: function() { // Called after a hitOut OR before a dragEnd
					enableCursor();
				},
				interactionEnd: function(ev) {
					delete seg.component; // prevent side effects
	
					// do revert animation if hasn't changed. calls a callback when finished (whether animation or not)
					mouseFollower.stop(!dropLocation, function() {
						if (isDragging) {
							view.unrenderDrag();
							_this.segDragStop(seg, ev);
						}
	
						if (dropLocation) {
							// no need to re-show original, will rerender all anyways. esp important if eventRenderWait
							view.reportEventDrop(event, dropLocation, _this.largeUnit, el, ev);
						}
						else {
							view.showEvent(event);
						}
					});
					_this.segDragListener = null;
				}
			});
	
			return dragListener;
		},
	
	
		// seg isn't draggable, but let's use a generic DragListener
		// simply for the delay, so it can be selected.
		// Has side effect of setting/unsetting `segDragListener`
		buildSegSelectListener: function(seg) {
			var _this = this;
			var view = this.view;
			var event = seg.event;
	
			if (this.segDragListener) {
				return this.segDragListener;
			}
	
			var dragListener = this.segDragListener = new DragListener({
				dragStart: function(ev) {
					if (dragListener.isTouch && !view.isEventSelected(event)) {
						// if not previously selected, will fire after a delay. then, select the event
						view.selectEvent(event);
					}
				},
				interactionEnd: function(ev) {
					_this.segDragListener = null;
				}
			});
	
			return dragListener;
		},
	
	
		// Called before event segment dragging starts
		segDragStart: function(seg, ev) {
			this.isDraggingSeg = true;
			this.view.publiclyTrigger('eventDragStart', seg.el[0], seg.event, ev, {}); // last argument is jqui dummy
		},
	
	
		// Called after event segment dragging stops
		segDragStop: function(seg, ev) {
			this.isDraggingSeg = false;
			this.view.publiclyTrigger('eventDragStop', seg.el[0], seg.event, ev, {}); // last argument is jqui dummy
		},
	
	
		// Given the spans an event drag began, and the span event was dropped, calculates the new zoned start/end/allDay
		// values for the event. Subclasses may override and set additional properties to be used by renderDrag.
		// A falsy returned value indicates an invalid drop.
		// DOES NOT consider overlap/constraint.
		computeEventDrop: function(startSpan, endSpan, event) {
			var calendar = this.view.calendar;
			var dragStart = startSpan.start;
			var dragEnd = endSpan.start;
			var delta;
			var dropLocation; // zoned event date properties
	
			if (dragStart.hasTime() === dragEnd.hasTime()) {
				delta = this.diffDates(dragEnd, dragStart);
	
				// if an all-day event was in a timed area and it was dragged to a different time,
				// guarantee an end and adjust start/end to have times
				if (event.allDay && durationHasTime(delta)) {
					dropLocation = {
						start: event.start.clone(),
						end: calendar.getEventEnd(event), // will be an ambig day
						allDay: false // for normalizeEventTimes
					};
					calendar.normalizeEventTimes(dropLocation);
				}
				// othewise, work off existing values
				else {
					dropLocation = pluckEventDateProps(event);
				}
	
				dropLocation.start.add(delta);
				if (dropLocation.end) {
					dropLocation.end.add(delta);
				}
			}
			else {
				// if switching from day <-> timed, start should be reset to the dropped date, and the end cleared
				dropLocation = {
					start: dragEnd.clone(),
					end: null, // end should be cleared
					allDay: !dragEnd.hasTime()
				};
			}
	
			return dropLocation;
		},
	
	
		// Utility for apply dragOpacity to a jQuery set
		applyDragOpacity: function(els) {
			var opacity = this.view.opt('dragOpacity');
	
			if (opacity != null) {
				els.css('opacity', opacity);
			}
		},
	
	
		/* External Element Dragging
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Called when a jQuery UI drag is initiated anywhere in the DOM
		externalDragStart: function(ev, ui) {
			var view = this.view;
			var el;
			var accept;
	
			if (view.opt('droppable')) { // only listen if this setting is on
				el = $((ui ? ui.item : null) || ev.target);
	
				// Test that the dragged element passes the dropAccept selector or filter function.
				// FYI, the default is "*" (matches all)
				accept = view.opt('dropAccept');
				if ($.isFunction(accept) ? accept.call(el[0], el) : el.is(accept)) {
					if (!this.isDraggingExternal) { // prevent double-listening if fired twice
						this.listenToExternalDrag(el, ev, ui);
					}
				}
			}
		},
	
	
		// Called when a jQuery UI drag starts and it needs to be monitored for dropping
		listenToExternalDrag: function(el, ev, ui) {
			var _this = this;
			var calendar = this.view.calendar;
			var meta = getDraggedElMeta(el); // extra data about event drop, including possible event to create
			var dropLocation; // a null value signals an unsuccessful drag
	
			// listener that tracks mouse movement over date-associated pixel regions
			var dragListener = _this.externalDragListener = new HitDragListener(this, {
				interactionStart: function() {
					_this.isDraggingExternal = true;
				},
				hitOver: function(hit) {
					dropLocation = _this.computeExternalDrop(
						hit.component.getHitSpan(hit), // since we are querying the parent view, might not belong to this grid
						meta
					);
	
					if ( // invalid hit?
						dropLocation &&
						!calendar.isExternalSpanAllowed(_this.eventToSpan(dropLocation), dropLocation, meta.eventProps)
					) {
						disableCursor();
						dropLocation = null;
					}
	
					if (dropLocation) {
						_this.renderDrag(dropLocation); // called without a seg parameter
					}
				},
				hitOut: function() {
					dropLocation = null; // signal unsuccessful
				},
				hitDone: function() { // Called after a hitOut OR before a dragEnd
					enableCursor();
					_this.unrenderDrag();
				},
				interactionEnd: function(ev) {
					if (dropLocation) { // element was dropped on a valid hit
						_this.view.reportExternalDrop(meta, dropLocation, el, ev, ui);
					}
					_this.isDraggingExternal = false;
					_this.externalDragListener = null;
				}
			});
	
			dragListener.startDrag(ev); // start listening immediately
		},
	
	
		// Given a hit to be dropped upon, and misc data associated with the jqui drag (guaranteed to be a plain object),
		// returns the zoned start/end dates for the event that would result from the hypothetical drop. end might be null.
		// Returning a null value signals an invalid drop hit.
		// DOES NOT consider overlap/constraint.
		computeExternalDrop: function(span, meta) {
			var calendar = this.view.calendar;
			var dropLocation = {
				start: calendar.applyTimezone(span.start), // simulate a zoned event start date
				end: null
			};
	
			// if dropped on an all-day span, and element's metadata specified a time, set it
			if (meta.startTime && !dropLocation.start.hasTime()) {
				dropLocation.start.time(meta.startTime);
			}
	
			if (meta.duration) {
				dropLocation.end = dropLocation.start.clone().add(meta.duration);
			}
	
			return dropLocation;
		},
	
	
	
		/* Drag Rendering (for both events and an external elements)
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Renders a visual indication of an event or external element being dragged.
		// `dropLocation` contains hypothetical start/end/allDay values the event would have if dropped. end can be null.
		// `seg` is the internal segment object that is being dragged. If dragging an external element, `seg` is null.
		// A truthy returned value indicates this method has rendered a helper element.
		// Must return elements used for any mock events.
		renderDrag: function(dropLocation, seg) {
			// subclasses must implement
		},
	
	
		// Unrenders a visual indication of an event or external element being dragged
		unrenderDrag: function() {
			// subclasses must implement
		},
	
	
		/* Resizing
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Creates a listener that tracks the user as they resize an event segment.
		// Generic enough to work with any type of Grid.
		buildSegResizeListener: function(seg, isStart) {
			var _this = this;
			var view = this.view;
			var calendar = view.calendar;
			var el = seg.el;
			var event = seg.event;
			var eventEnd = calendar.getEventEnd(event);
			var isDragging;
			var resizeLocation; // zoned event date properties. falsy if invalid resize
	
			// Tracks mouse movement over the *grid's* coordinate map
			var dragListener = this.segResizeListener = new HitDragListener(this, {
				scroll: view.opt('dragScroll'),
				subjectEl: el,
				interactionStart: function() {
					isDragging = false;
				},
				dragStart: function(ev) {
					isDragging = true;
					_this.handleSegMouseout(seg, ev); // ensure a mouseout on the manipulated event has been reported
					_this.segResizeStart(seg, ev);
				},
				hitOver: function(hit, isOrig, origHit) {
					var origHitSpan = _this.getHitSpan(origHit);
					var hitSpan = _this.getHitSpan(hit);
	
					resizeLocation = isStart ?
						_this.computeEventStartResize(origHitSpan, hitSpan, event) :
						_this.computeEventEndResize(origHitSpan, hitSpan, event);
	
					if (resizeLocation) {
						if (!calendar.isEventSpanAllowed(_this.eventToSpan(resizeLocation), event)) {
							disableCursor();
							resizeLocation = null;
						}
						// no change? (FYI, event dates might have zones)
						else if (
							resizeLocation.start.isSame(event.start.clone().stripZone()) &&
							resizeLocation.end.isSame(eventEnd.clone().stripZone())
						) {
							resizeLocation = null;
						}
					}
	
					if (resizeLocation) {
						view.hideEvent(event);
						_this.renderEventResize(resizeLocation, seg);
					}
				},
				hitOut: function() { // called before mouse moves to a different hit OR moved out of all hits
					resizeLocation = null;
					view.showEvent(event); // for when out-of-bounds. show original
				},
				hitDone: function() { // resets the rendering to show the original event
					_this.unrenderEventResize();
					enableCursor();
				},
				interactionEnd: function(ev) {
					if (isDragging) {
						_this.segResizeStop(seg, ev);
					}
	
					if (resizeLocation) { // valid date to resize to?
						// no need to re-show original, will rerender all anyways. esp important if eventRenderWait
						view.reportEventResize(event, resizeLocation, _this.largeUnit, el, ev);
					}
					else {
						view.showEvent(event);
					}
					_this.segResizeListener = null;
				}
			});
	
			return dragListener;
		},
	
	
		// Called before event segment resizing starts
		segResizeStart: function(seg, ev) {
			this.isResizingSeg = true;
			this.view.publiclyTrigger('eventResizeStart', seg.el[0], seg.event, ev, {}); // last argument is jqui dummy
		},
	
	
		// Called after event segment resizing stops
		segResizeStop: function(seg, ev) {
			this.isResizingSeg = false;
			this.view.publiclyTrigger('eventResizeStop', seg.el[0], seg.event, ev, {}); // last argument is jqui dummy
		},
	
	
		// Returns new date-information for an event segment being resized from its start
		computeEventStartResize: function(startSpan, endSpan, event) {
			return this.computeEventResize('start', startSpan, endSpan, event);
		},
	
	
		// Returns new date-information for an event segment being resized from its end
		computeEventEndResize: function(startSpan, endSpan, event) {
			return this.computeEventResize('end', startSpan, endSpan, event);
		},
	
	
		// Returns new zoned date information for an event segment being resized from its start OR end
		// `type` is either 'start' or 'end'.
		// DOES NOT consider overlap/constraint.
		computeEventResize: function(type, startSpan, endSpan, event) {
			var calendar = this.view.calendar;
			var delta = this.diffDates(endSpan[type], startSpan[type]);
			var resizeLocation; // zoned event date properties
			var defaultDuration;
	
			// build original values to work from, guaranteeing a start and end
			resizeLocation = {
				start: event.start.clone(),
				end: calendar.getEventEnd(event),
				allDay: event.allDay
			};
	
			// if an all-day event was in a timed area and was resized to a time, adjust start/end to have times
			if (resizeLocation.allDay && durationHasTime(delta)) {
				resizeLocation.allDay = false;
				calendar.normalizeEventTimes(resizeLocation);
			}
	
			resizeLocation[type].add(delta); // apply delta to start or end
	
			// if the event was compressed too small, find a new reasonable duration for it
			if (!resizeLocation.start.isBefore(resizeLocation.end)) {
	
				defaultDuration =
					this.minResizeDuration || // TODO: hack
					(event.allDay ?
						calendar.defaultAllDayEventDuration :
						calendar.defaultTimedEventDuration);
	
				if (type == 'start') { // resizing the start?
					resizeLocation.start = resizeLocation.end.clone().subtract(defaultDuration);
				}
				else { // resizing the end?
					resizeLocation.end = resizeLocation.start.clone().add(defaultDuration);
				}
			}
	
			return resizeLocation;
		},
	
	
		// Renders a visual indication of an event being resized.
		// `range` has the updated dates of the event. `seg` is the original segment object involved in the drag.
		// Must return elements used for any mock events.
		renderEventResize: function(range, seg) {
			// subclasses must implement
		},
	
	
		// Unrenders a visual indication of an event being resized.
		unrenderEventResize: function() {
			// subclasses must implement
		},
	
	
		/* Rendering Utils
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Compute the text that should be displayed on an event's element.
		// `range` can be the Event object itself, or something range-like, with at least a `start`.
		// If event times are disabled, or the event has no time, will return a blank string.
		// If not specified, formatStr will default to the eventTimeFormat setting,
		// and displayEnd will default to the displayEventEnd setting.
		getEventTimeText: function(range, formatStr, displayEnd) {
	
			if (formatStr == null) {
				formatStr = this.eventTimeFormat;
			}
	
			if (displayEnd == null) {
				displayEnd = this.displayEventEnd;
			}
	
			if (this.displayEventTime && range.start.hasTime()) {
				if (displayEnd && range.end) {
					return this.view.formatRange(range, formatStr);
				}
				else {
					return range.start.format(formatStr);
				}
			}
	
			return '';
		},
	
	
		// Generic utility for generating the HTML classNames for an event segment's element
		getSegClasses: function(seg, isDraggable, isResizable) {
			var view = this.view;
			var classes = [
				'fc-event',
				seg.isStart ? 'fc-start' : 'fc-not-start',
				seg.isEnd ? 'fc-end' : 'fc-not-end'
			].concat(this.getSegCustomClasses(seg));
	
			if (isDraggable) {
				classes.push('fc-draggable');
			}
			if (isResizable) {
				classes.push('fc-resizable');
			}
	
			// event is currently selected? attach a className.
			if (view.isEventSelected(seg.event)) {
				classes.push('fc-selected');
			}
	
			return classes;
		},
	
	
		// List of classes that were defined by the caller of the API in some way
		getSegCustomClasses: function(seg) {
			var event = seg.event;
	
			return [].concat(
				event.className, // guaranteed to be an array
				event.source ? event.source.className : []
			);
		},
	
	
		// Utility for generating event skin-related CSS properties
		getSegSkinCss: function(seg) {
			return {
				'background-color': this.getSegBackgroundColor(seg),
				'border-color': this.getSegBorderColor(seg),
				color: this.getSegTextColor(seg)
			};
		},
	
	
		// Queries for caller-specified color, then falls back to default
		getSegBackgroundColor: function(seg) {
			return seg.event.backgroundColor ||
				seg.event.color ||
				this.getSegDefaultBackgroundColor(seg);
		},
	
	
		getSegDefaultBackgroundColor: function(seg) {
			var source = seg.event.source || {};
	
			return source.backgroundColor ||
				source.color ||
				this.view.opt('eventBackgroundColor') ||
				this.view.opt('eventColor');
		},
	
	
		// Queries for caller-specified color, then falls back to default
		getSegBorderColor: function(seg) {
			return seg.event.borderColor ||
				seg.event.color ||
				this.getSegDefaultBorderColor(seg);
		},
	
	
		getSegDefaultBorderColor: function(seg) {
			var source = seg.event.source || {};
	
			return source.borderColor ||
				source.color ||
				this.view.opt('eventBorderColor') ||
				this.view.opt('eventColor');
		},
	
	
		// Queries for caller-specified color, then falls back to default
		getSegTextColor: function(seg) {
			return seg.event.textColor ||
				this.getSegDefaultTextColor(seg);
		},
	
	
		getSegDefaultTextColor: function(seg) {
			var source = seg.event.source || {};
	
			return source.textColor ||
				this.view.opt('eventTextColor');
		},
	
	
		/* Converting events -> eventRange -> eventSpan -> eventSegs
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Generates an array of segments for the given single event
		// Can accept an event "location" as well (which only has start/end and no allDay)
		eventToSegs: function(event) {
			return this.eventsToSegs([ event ]);
		},
	
	
		eventToSpan: function(event) {
			return this.eventToSpans(event)[0];
		},
	
	
		// Generates spans (always unzoned) for the given event.
		// Does not do any inverting for inverse-background events.
		// Can accept an event "location" as well (which only has start/end and no allDay)
		eventToSpans: function(event) {
			var range = this.eventToRange(event);
			return this.eventRangeToSpans(range, event);
		},
	
	
	
		// Converts an array of event objects into an array of event segment objects.
		// A custom `segSliceFunc` may be given for arbitrarily slicing up events.
		// Doesn't guarantee an order for the resulting array.
		eventsToSegs: function(allEvents, segSliceFunc) {
			var _this = this;
			var eventsById = groupEventsById(allEvents);
			var segs = [];
	
			$.each(eventsById, function(id, events) {
				var ranges = [];
				var i;
	
				for (i = 0; i < events.length; i++) {
					ranges.push(_this.eventToRange(events[i]));
				}
	
				// inverse-background events (utilize only the first event in calculations)
				if (isInverseBgEvent(events[0])) {
					ranges = _this.invertRanges(ranges);
	
					for (i = 0; i < ranges.length; i++) {
						segs.push.apply(segs, // append to
							_this.eventRangeToSegs(ranges[i], events[0], segSliceFunc));
					}
				}
				// normal event ranges
				else {
					for (i = 0; i < ranges.length; i++) {
						segs.push.apply(segs, // append to
							_this.eventRangeToSegs(ranges[i], events[i], segSliceFunc));
					}
				}
			});
	
			return segs;
		},
	
	
		// Generates the unzoned start/end dates an event appears to occupy
		// Can accept an event "location" as well (which only has start/end and no allDay)
		eventToRange: function(event) {
			var calendar = this.view.calendar;
			var start = event.start.clone().stripZone();
			var end = (
					event.end ?
						event.end.clone() :
						// derive the end from the start and allDay. compute allDay if necessary
						calendar.getDefaultEventEnd(
							event.allDay != null ?
								event.allDay :
								!event.start.hasTime(),
							event.start
						)
				).stripZone();
	
			// hack: dynamic locale change forgets to upate stored event localed
			calendar.localizeMoment(start);
			calendar.localizeMoment(end);
	
			return { start: start, end: end };
		},
	
	
		// Given an event's range (unzoned start/end), and the event itself,
		// slice into segments (using the segSliceFunc function if specified)
		eventRangeToSegs: function(range, event, segSliceFunc) {
			var spans = this.eventRangeToSpans(range, event);
			var segs = [];
			var i;
	
			for (i = 0; i < spans.length; i++) {
				segs.push.apply(segs, // append to
					this.eventSpanToSegs(spans[i], event, segSliceFunc));
			}
	
			return segs;
		},
	
	
		// Given an event's unzoned date range, return an array of "span" objects.
		// Subclasses can override.
		eventRangeToSpans: function(range, event) {
			return [ $.extend({}, range) ]; // copy into a single-item array
		},
	
	
		// Given an event's span (unzoned start/end and other misc data), and the event itself,
		// slices into segments and attaches event-derived properties to them.
		eventSpanToSegs: function(span, event, segSliceFunc) {
			var segs = segSliceFunc ? segSliceFunc(span) : this.spanToSegs(span);
			var i, seg;
	
			for (i = 0; i < segs.length; i++) {
				seg = segs[i];
				seg.event = event;
				seg.eventStartMS = +span.start; // TODO: not the best name after making spans unzoned
				seg.eventDurationMS = span.end - span.start;
			}
	
			return segs;
		},
	
	
		// Produces a new array of range objects that will cover all the time NOT covered by the given ranges.
		// SIDE EFFECT: will mutate the given array and will use its date references.
		invertRanges: function(ranges) {
			var view = this.view;
			var viewStart = view.start.clone(); // need a copy
			var viewEnd = view.end.clone(); // need a copy
			var inverseRanges = [];
			var start = viewStart; // the end of the previous range. the start of the new range
			var i, range;
	
			// ranges need to be in order. required for our date-walking algorithm
			ranges.sort(compareRanges);
	
			for (i = 0; i < ranges.length; i++) {
				range = ranges[i];
	
				// add the span of time before the event (if there is any)
				if (range.start > start) { // compare millisecond time (skip any ambig logic)
					inverseRanges.push({
						start: start,
						end: range.start
					});
				}
	
				start = range.end;
			}
	
			// add the span of time after the last event (if there is any)
			if (start < viewEnd) { // compare millisecond time (skip any ambig logic)
				inverseRanges.push({
					start: start,
					end: viewEnd
				});
			}
	
			return inverseRanges;
		},
	
	
		sortEventSegs: function(segs) {
			segs.sort(proxy(this, 'compareEventSegs'));
		},
	
	
		// A cmp function for determining which segments should take visual priority
		compareEventSegs: function(seg1, seg2) {
			return seg1.eventStartMS - seg2.eventStartMS || // earlier events go first
				seg2.eventDurationMS - seg1.eventDurationMS || // tie? longer events go first
				seg2.event.allDay - seg1.event.allDay || // tie? put all-day events first (booleans cast to 0/1)
				compareByFieldSpecs(seg1.event, seg2.event, this.view.eventOrderSpecs);
		}
	
	});
	
	
	/* Utilities
	----------------------------------------------------------------------------------------------------------------------*/
	
	
	function pluckEventDateProps(event) {
		return {
			start: event.start.clone(),
			end: event.end ? event.end.clone() : null,
			allDay: event.allDay // keep it the same
		};
	}
	FC.pluckEventDateProps = pluckEventDateProps;
	
	
	function isBgEvent(event) { // returns true if background OR inverse-background
		var rendering = getEventRendering(event);
		return rendering === 'background' || rendering === 'inverse-background';
	}
	FC.isBgEvent = isBgEvent; // export
	
	
	function isInverseBgEvent(event) {
		return getEventRendering(event) === 'inverse-background';
	}
	
	
	function getEventRendering(event) {
		return firstDefined((event.source || {}).rendering, event.rendering);
	}
	
	
	function groupEventsById(events) {
		var eventsById = {};
		var i, event;
	
		for (i = 0; i < events.length; i++) {
			event = events[i];
			(eventsById[event._id] || (eventsById[event._id] = [])).push(event);
		}
	
		return eventsById;
	}
	
	
	// A cmp function for determining which non-inverted "ranges" (see above) happen earlier
	function compareRanges(range1, range2) {
		return range1.start - range2.start; // earlier ranges go first
	}
	
	
	/* External-Dragging-Element Data
	----------------------------------------------------------------------------------------------------------------------*/
	
	// Require all HTML5 data-* attributes used by FullCalendar to have this prefix.
	// A value of '' will query attributes like data-event. A value of 'fc' will query attributes like data-fc-event.
	FC.dataAttrPrefix = '';
	
	// Given a jQuery element that might represent a dragged FullCalendar event, returns an intermediate data structure
	// to be used for Event Object creation.
	// A defined `.eventProps`, even when empty, indicates that an event should be created.
	function getDraggedElMeta(el) {
		var prefix = FC.dataAttrPrefix;
		var eventProps; // properties for creating the event, not related to date/time
		var startTime; // a Duration
		var duration;
		var stick;
	
		if (prefix) { prefix += '-'; }
		eventProps = el.data(prefix + 'event') || null;
	
		if (eventProps) {
			if (typeof eventProps === 'object') {
				eventProps = $.extend({}, eventProps); // make a copy
			}
			else { // something like 1 or true. still signal event creation
				eventProps = {};
			}
	
			// pluck special-cased date/time properties
			startTime = eventProps.start;
			if (startTime == null) { startTime = eventProps.time; } // accept 'time' as well
			duration = eventProps.duration;
			stick = eventProps.stick;
			delete eventProps.start;
			delete eventProps.time;
			delete eventProps.duration;
			delete eventProps.stick;
		}
	
		// fallback to standalone attribute values for each of the date/time properties
		if (startTime == null) { startTime = el.data(prefix + 'start'); }
		if (startTime == null) { startTime = el.data(prefix + 'time'); } // accept 'time' as well
		if (duration == null) { duration = el.data(prefix + 'duration'); }
		if (stick == null) { stick = el.data(prefix + 'stick'); }
	
		// massage into correct data types
		startTime = startTime != null ? moment.duration(startTime) : null;
		duration = duration != null ? moment.duration(duration) : null;
		stick = Boolean(stick);
	
		return { eventProps: eventProps, startTime: startTime, duration: duration, stick: stick };
	}
	
	
	;;
	
	/*
	A set of rendering and date-related methods for a visual component comprised of one or more rows of day columns.
	Prerequisite: the object being mixed into needs to be a *Grid*
	*/
	var DayTableMixin = FC.DayTableMixin = {
	
		breakOnWeeks: false, // should create a new row for each week?
		dayDates: null, // whole-day dates for each column. left to right
		dayIndices: null, // for each day from start, the offset
		daysPerRow: null,
		rowCnt: null,
		colCnt: null,
		colHeadFormat: null,
	
	
		// Populates internal variables used for date calculation and rendering
		updateDayTable: function() {
			var view = this.view;
			var date = this.start.clone();
			var dayIndex = -1;
			var dayIndices = [];
			var dayDates = [];
			var daysPerRow;
			var firstDay;
			var rowCnt;
	
			while (date.isBefore(this.end)) { // loop each day from start to end
				if (view.isHiddenDay(date)) {
					dayIndices.push(dayIndex + 0.5); // mark that it's between indices
				}
				else {
					dayIndex++;
					dayIndices.push(dayIndex);
					dayDates.push(date.clone());
				}
				date.add(1, 'days');
			}
	
			if (this.breakOnWeeks) {
				// count columns until the day-of-week repeats
				firstDay = dayDates[0].day();
				for (daysPerRow = 1; daysPerRow < dayDates.length; daysPerRow++) {
					if (dayDates[daysPerRow].day() == firstDay) {
						break;
					}
				}
				rowCnt = Math.ceil(dayDates.length / daysPerRow);
			}
			else {
				rowCnt = 1;
				daysPerRow = dayDates.length;
			}
	
			this.dayDates = dayDates;
			this.dayIndices = dayIndices;
			this.daysPerRow = daysPerRow;
			this.rowCnt = rowCnt;
	
			this.updateDayTableCols();
		},
	
	
		// Computes and assigned the colCnt property and updates any options that may be computed from it
		updateDayTableCols: function() {
			this.colCnt = this.computeColCnt();
			this.colHeadFormat = this.view.opt('columnFormat') || this.computeColHeadFormat();
		},
	
	
		// Determines how many columns there should be in the table
		computeColCnt: function() {
			return this.daysPerRow;
		},
	
	
		// Computes the ambiguously-timed moment for the given cell
		getCellDate: function(row, col) {
			return this.dayDates[
					this.getCellDayIndex(row, col)
				].clone();
		},
	
	
		// Computes the ambiguously-timed date range for the given cell
		getCellRange: function(row, col) {
			var start = this.getCellDate(row, col);
			var end = start.clone().add(1, 'days');
	
			return { start: start, end: end };
		},
	
	
		// Returns the number of day cells, chronologically, from the first of the grid (0-based)
		getCellDayIndex: function(row, col) {
			return row * this.daysPerRow + this.getColDayIndex(col);
		},
	
	
		// Returns the numner of day cells, chronologically, from the first cell in *any given row*
		getColDayIndex: function(col) {
			if (this.isRTL) {
				return this.colCnt - 1 - col;
			}
			else {
				return col;
			}
		},
	
	
		// Given a date, returns its chronolocial cell-index from the first cell of the grid.
		// If the date lies between cells (because of hiddenDays), returns a floating-point value between offsets.
		// If before the first offset, returns a negative number.
		// If after the last offset, returns an offset past the last cell offset.
		// Only works for *start* dates of cells. Will not work for exclusive end dates for cells.
		getDateDayIndex: function(date) {
			var dayIndices = this.dayIndices;
			var dayOffset = date.diff(this.start, 'days');
	
			if (dayOffset < 0) {
				return dayIndices[0] - 1;
			}
			else if (dayOffset >= dayIndices.length) {
				return dayIndices[dayIndices.length - 1] + 1;
			}
			else {
				return dayIndices[dayOffset];
			}
		},
	
	
		/* Options
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Computes a default column header formatting string if `colFormat` is not explicitly defined
		computeColHeadFormat: function() {
			// if more than one week row, or if there are a lot of columns with not much space,
			// put just the day numbers will be in each cell
			if (this.rowCnt > 1 || this.colCnt > 10) {
				return 'ddd'; // "Sat"
			}
			// multiple days, so full single date string WON'T be in title text
			else if (this.colCnt > 1) {
				return this.view.opt('dayOfMonthFormat'); // "Sat 12/10"
			}
			// single day, so full single date string will probably be in title text
			else {
				return 'dddd'; // "Saturday"
			}
		},
	
	
		/* Slicing
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Slices up a date range into a segment for every week-row it intersects with
		sliceRangeByRow: function(range) {
			var daysPerRow = this.daysPerRow;
			var normalRange = this.view.computeDayRange(range); // make whole-day range, considering nextDayThreshold
			var rangeFirst = this.getDateDayIndex(normalRange.start); // inclusive first index
			var rangeLast = this.getDateDayIndex(normalRange.end.clone().subtract(1, 'days')); // inclusive last index
			var segs = [];
			var row;
			var rowFirst, rowLast; // inclusive day-index range for current row
			var segFirst, segLast; // inclusive day-index range for segment
	
			for (row = 0; row < this.rowCnt; row++) {
				rowFirst = row * daysPerRow;
				rowLast = rowFirst + daysPerRow - 1;
	
				// intersect segment's offset range with the row's
				segFirst = Math.max(rangeFirst, rowFirst);
				segLast = Math.min(rangeLast, rowLast);
	
				// deal with in-between indices
				segFirst = Math.ceil(segFirst); // in-between starts round to next cell
				segLast = Math.floor(segLast); // in-between ends round to prev cell
	
				if (segFirst <= segLast) { // was there any intersection with the current row?
					segs.push({
						row: row,
	
						// normalize to start of row
						firstRowDayIndex: segFirst - rowFirst,
						lastRowDayIndex: segLast - rowFirst,
	
						// must be matching integers to be the segment's start/end
						isStart: segFirst === rangeFirst,
						isEnd: segLast === rangeLast
					});
				}
			}
	
			return segs;
		},
	
	
		// Slices up a date range into a segment for every day-cell it intersects with.
		// TODO: make more DRY with sliceRangeByRow somehow.
		sliceRangeByDay: function(range) {
			var daysPerRow = this.daysPerRow;
			var normalRange = this.view.computeDayRange(range); // make whole-day range, considering nextDayThreshold
			var rangeFirst = this.getDateDayIndex(normalRange.start); // inclusive first index
			var rangeLast = this.getDateDayIndex(normalRange.end.clone().subtract(1, 'days')); // inclusive last index
			var segs = [];
			var row;
			var rowFirst, rowLast; // inclusive day-index range for current row
			var i;
			var segFirst, segLast; // inclusive day-index range for segment
	
			for (row = 0; row < this.rowCnt; row++) {
				rowFirst = row * daysPerRow;
				rowLast = rowFirst + daysPerRow - 1;
	
				for (i = rowFirst; i <= rowLast; i++) {
	
					// intersect segment's offset range with the row's
					segFirst = Math.max(rangeFirst, i);
					segLast = Math.min(rangeLast, i);
	
					// deal with in-between indices
					segFirst = Math.ceil(segFirst); // in-between starts round to next cell
					segLast = Math.floor(segLast); // in-between ends round to prev cell
	
					if (segFirst <= segLast) { // was there any intersection with the current row?
						segs.push({
							row: row,
	
							// normalize to start of row
							firstRowDayIndex: segFirst - rowFirst,
							lastRowDayIndex: segLast - rowFirst,
	
							// must be matching integers to be the segment's start/end
							isStart: segFirst === rangeFirst,
							isEnd: segLast === rangeLast
						});
					}
				}
			}
	
			return segs;
		},
	
	
		/* Header Rendering
		------------------------------------------------------------------------------------------------------------------*/
	
	
		renderHeadHtml: function() {
			var view = this.view;
	
			return '' +
				'<div class="fc-row ' + view.widgetHeaderClass + '">' +
					'<table>' +
						'<thead>' +
							this.renderHeadTrHtml() +
						'</thead>' +
					'</table>' +
				'</div>';
		},
	
	
		renderHeadIntroHtml: function() {
			return this.renderIntroHtml(); // fall back to generic
		},
	
	
		renderHeadTrHtml: function() {
			return '' +
				'<tr>' +
					(this.isRTL ? '' : this.renderHeadIntroHtml()) +
					this.renderHeadDateCellsHtml() +
					(this.isRTL ? this.renderHeadIntroHtml() : '') +
				'</tr>';
		},
	
	
		renderHeadDateCellsHtml: function() {
			var htmls = [];
			var col, date;
	
			for (col = 0; col < this.colCnt; col++) {
				date = this.getCellDate(0, col);
				htmls.push(this.renderHeadDateCellHtml(date));
			}
	
			return htmls.join('');
		},
	
	
		// TODO: when internalApiVersion, accept an object for HTML attributes
		// (colspan should be no different)
		renderHeadDateCellHtml: function(date, colspan, otherAttrs) {
			var view = this.view;
			var classNames = [
				'fc-day-header',
				view.widgetHeaderClass
			];
	
			// if only one row of days, the classNames on the header can represent the specific days beneath
			if (this.rowCnt === 1) {
				classNames = classNames.concat(
					// includes the day-of-week class
					// noThemeHighlight=true (don't highlight the header)
					this.getDayClasses(date, true)
				);
			}
			else {
				classNames.push('fc-' + dayIDs[date.day()]); // only add the day-of-week class
			}
	
			return '' +
	            '<th class="' + classNames.join(' ') + '"' +
					(this.rowCnt === 1 ?
						' data-date="' + date.format('YYYY-MM-DD') + '"' :
						'') +
					(colspan > 1 ?
						' colspan="' + colspan + '"' :
						'') +
					(otherAttrs ?
						' ' + otherAttrs :
						'') +
					'>' +
					// don't make a link if the heading could represent multiple days, or if there's only one day (forceOff)
					view.buildGotoAnchorHtml(
						{ date: date, forceOff: this.rowCnt > 1 || this.colCnt === 1 },
						htmlEscape(date.format(this.colHeadFormat)) // inner HTML
					) +
				'</th>';
		},
	
	
		/* Background Rendering
		------------------------------------------------------------------------------------------------------------------*/
	
	
		renderBgTrHtml: function(row) {
			return '' +
				'<tr>' +
					(this.isRTL ? '' : this.renderBgIntroHtml(row)) +
					this.renderBgCellsHtml(row) +
					(this.isRTL ? this.renderBgIntroHtml(row) : '') +
				'</tr>';
		},
	
	
		renderBgIntroHtml: function(row) {
			return this.renderIntroHtml(); // fall back to generic
		},
	
	
		renderBgCellsHtml: function(row) {
			var htmls = [];
			var col, date;
	
			for (col = 0; col < this.colCnt; col++) {
				date = this.getCellDate(row, col);
				htmls.push(this.renderBgCellHtml(date));
			}
	
			return htmls.join('');
		},
	
	
		renderBgCellHtml: function(date, otherAttrs) {
			var view = this.view;
			var classes = this.getDayClasses(date);
	
			classes.unshift('fc-day', view.widgetContentClass);
	
			return '<td class="' + classes.join(' ') + '"' +
				' data-date="' + date.format('YYYY-MM-DD') + '"' + // if date has a time, won't format it
				(otherAttrs ?
					' ' + otherAttrs :
					'') +
				'></td>';
		},
	
	
		/* Generic
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Generates the default HTML intro for any row. User classes should override
		renderIntroHtml: function() {
		},
	
	
		// TODO: a generic method for dealing with <tr>, RTL, intro
		// when increment internalApiVersion
		// wrapTr (scheduler)
	
	
		/* Utils
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Applies the generic "intro" and "outro" HTML to the given cells.
		// Intro means the leftmost cell when the calendar is LTR and the rightmost cell when RTL. Vice-versa for outro.
		bookendCells: function(trEl) {
			var introHtml = this.renderIntroHtml();
	
			if (introHtml) {
				if (this.isRTL) {
					trEl.append(introHtml);
				}
				else {
					trEl.prepend(introHtml);
				}
			}
		}
	
	};
	
	;;
	
	/* A component that renders a grid of whole-days that runs horizontally. There can be multiple rows, one per week.
	----------------------------------------------------------------------------------------------------------------------*/
	
	var DayGrid = FC.DayGrid = Grid.extend(DayTableMixin, {
	
		numbersVisible: false, // should render a row for day/week numbers? set by outside view. TODO: make internal
		bottomCoordPadding: 0, // hack for extending the hit area for the last row of the coordinate grid
	
		rowEls: null, // set of fake row elements
		cellEls: null, // set of whole-day elements comprising the row's background
		helperEls: null, // set of cell skeleton elements for rendering the mock event "helper"
	
		rowCoordCache: null,
		colCoordCache: null,
	
	
		// Renders the rows and columns into the component's `this.el`, which should already be assigned.
		// isRigid determins whether the individual rows should ignore the contents and be a constant height.
		// Relies on the view's colCnt and rowCnt. In the future, this component should probably be self-sufficient.
		renderDates: function(isRigid) {
			var view = this.view;
			var rowCnt = this.rowCnt;
			var colCnt = this.colCnt;
			var html = '';
			var row;
			var col;
	
			for (row = 0; row < rowCnt; row++) {
				html += this.renderDayRowHtml(row, isRigid);
			}
			this.el.html(html);
	
			this.rowEls = this.el.find('.fc-row');
			this.cellEls = this.el.find('.fc-day');
	
			this.rowCoordCache = new CoordCache({
				els: this.rowEls,
				isVertical: true
			});
			this.colCoordCache = new CoordCache({
				els: this.cellEls.slice(0, this.colCnt), // only the first row
				isHorizontal: true
			});
	
			// trigger dayRender with each cell's element
			for (row = 0; row < rowCnt; row++) {
				for (col = 0; col < colCnt; col++) {
					view.publiclyTrigger(
						'dayRender',
						null,
						this.getCellDate(row, col),
						this.getCellEl(row, col)
					);
				}
			}
		},
	
	
		unrenderDates: function() {
			this.removeSegPopover();
		},
	
	
		renderBusinessHours: function() {
			var segs = this.buildBusinessHourSegs(true); // wholeDay=true
			this.renderFill('businessHours', segs, 'bgevent');
		},
	
	
		unrenderBusinessHours: function() {
			this.unrenderFill('businessHours');
		},
	
	
		// Generates the HTML for a single row, which is a div that wraps a table.
		// `row` is the row number.
		renderDayRowHtml: function(row, isRigid) {
			var view = this.view;
			var classes = [ 'fc-row', 'fc-week', view.widgetContentClass ];
	
			if (isRigid) {
				classes.push('fc-rigid');
			}
	
			return '' +
				'<div class="' + classes.join(' ') + '">' +
					'<div class="fc-bg">' +
						'<table>' +
							this.renderBgTrHtml(row) +
						'</table>' +
					'</div>' +
					'<div class="fc-content-skeleton">' +
						'<table>' +
							(this.numbersVisible ?
								'<thead>' +
									this.renderNumberTrHtml(row) +
								'</thead>' :
								''
								) +
						'</table>' +
					'</div>' +
				'</div>';
		},
	
	
		/* Grid Number Rendering
		------------------------------------------------------------------------------------------------------------------*/
	
	
		renderNumberTrHtml: function(row) {
			return '' +
				'<tr>' +
					(this.isRTL ? '' : this.renderNumberIntroHtml(row)) +
					this.renderNumberCellsHtml(row) +
					(this.isRTL ? this.renderNumberIntroHtml(row) : '') +
				'</tr>';
		},
	
	
		renderNumberIntroHtml: function(row) {
			return this.renderIntroHtml();
		},
	
	
		renderNumberCellsHtml: function(row) {
			var htmls = [];
			var col, date;
	
			for (col = 0; col < this.colCnt; col++) {
				date = this.getCellDate(row, col);
				htmls.push(this.renderNumberCellHtml(date));
			}
	
			return htmls.join('');
		},
	
	
		// Generates the HTML for the <td>s of the "number" row in the DayGrid's content skeleton.
		// The number row will only exist if either day numbers or week numbers are turned on.
		renderNumberCellHtml: function(date) {
			var html = '';
			var classes;
			var weekCalcFirstDoW;
	
			if (!this.view.dayNumbersVisible && !this.view.cellWeekNumbersVisible) {
				// no numbers in day cell (week number must be along the side)
				return '<td/>'; //  will create an empty space above events :(
			}
	
			classes = this.getDayClasses(date);
			classes.unshift('fc-day-top');
	
			if (this.view.cellWeekNumbersVisible) {
				// To determine the day of week number change under ISO, we cannot
				// rely on moment.js methods such as firstDayOfWeek() or weekday(),
				// because they rely on the locale's dow (possibly overridden by
				// our firstDay option), which may not be Monday. We cannot change
				// dow, because that would affect the calendar start day as well.
				if (date._locale._fullCalendar_weekCalc === 'ISO') {
					weekCalcFirstDoW = 1;  // Monday by ISO 8601 definition
				}
				else {
					weekCalcFirstDoW = date._locale.firstDayOfWeek();
				}
			}
	
			html += '<td class="' + classes.join(' ') + '" data-date="' + date.format() + '">';
	
			if (this.view.cellWeekNumbersVisible && (date.day() == weekCalcFirstDoW)) {
				html += this.view.buildGotoAnchorHtml(
					{ date: date, type: 'week' },
					{ 'class': 'fc-week-number' },
					date.format('w') // inner HTML
				);
			}
	
			if (this.view.dayNumbersVisible) {
				html += this.view.buildGotoAnchorHtml(
					date,
					{ 'class': 'fc-day-number' },
					date.date() // inner HTML
				);
			}
	
			html += '</td>';
	
			return html;
		},
	
	
		/* Options
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Computes a default event time formatting string if `timeFormat` is not explicitly defined
		computeEventTimeFormat: function() {
			return this.view.opt('extraSmallTimeFormat'); // like "6p" or "6:30p"
		},
	
	
		// Computes a default `displayEventEnd` value if one is not expliclty defined
		computeDisplayEventEnd: function() {
			return this.colCnt == 1; // we'll likely have space if there's only one day
		},
	
	
		/* Dates
		------------------------------------------------------------------------------------------------------------------*/
	
	
		rangeUpdated: function() {
			this.updateDayTable();
		},
	
	
		// Slices up the given span (unzoned start/end with other misc data) into an array of segments
		spanToSegs: function(span) {
			var segs = this.sliceRangeByRow(span);
			var i, seg;
	
			for (i = 0; i < segs.length; i++) {
				seg = segs[i];
				if (this.isRTL) {
					seg.leftCol = this.daysPerRow - 1 - seg.lastRowDayIndex;
					seg.rightCol = this.daysPerRow - 1 - seg.firstRowDayIndex;
				}
				else {
					seg.leftCol = seg.firstRowDayIndex;
					seg.rightCol = seg.lastRowDayIndex;
				}
			}
	
			return segs;
		},
	
	
		/* Hit System
		------------------------------------------------------------------------------------------------------------------*/
	
	
		prepareHits: function() {
			this.colCoordCache.build();
			this.rowCoordCache.build();
			this.rowCoordCache.bottoms[this.rowCnt - 1] += this.bottomCoordPadding; // hack
		},
	
	
		releaseHits: function() {
			this.colCoordCache.clear();
			this.rowCoordCache.clear();
		},
	
	
		queryHit: function(leftOffset, topOffset) {
			if (this.colCoordCache.isLeftInBounds(leftOffset) && this.rowCoordCache.isTopInBounds(topOffset)) {
				var col = this.colCoordCache.getHorizontalIndex(leftOffset);
				var row = this.rowCoordCache.getVerticalIndex(topOffset);
	
				if (row != null && col != null) {
					return this.getCellHit(row, col);
				}
			}
		},
	
	
		getHitSpan: function(hit) {
			return this.getCellRange(hit.row, hit.col);
		},
	
	
		getHitEl: function(hit) {
			return this.getCellEl(hit.row, hit.col);
		},
	
	
		/* Cell System
		------------------------------------------------------------------------------------------------------------------*/
		// FYI: the first column is the leftmost column, regardless of date
	
	
		getCellHit: function(row, col) {
			return {
				row: row,
				col: col,
				component: this, // needed unfortunately :(
				left: this.colCoordCache.getLeftOffset(col),
				right: this.colCoordCache.getRightOffset(col),
				top: this.rowCoordCache.getTopOffset(row),
				bottom: this.rowCoordCache.getBottomOffset(row)
			};
		},
	
	
		getCellEl: function(row, col) {
			return this.cellEls.eq(row * this.colCnt + col);
		},
	
	
		/* Event Drag Visualization
		------------------------------------------------------------------------------------------------------------------*/
		// TODO: move to DayGrid.event, similar to what we did with Grid's drag methods
	
	
		// Renders a visual indication of an event or external element being dragged.
		// `eventLocation` has zoned start and end (optional)
		renderDrag: function(eventLocation, seg) {
	
			// always render a highlight underneath
			this.renderHighlight(this.eventToSpan(eventLocation));
	
			// if a segment from the same calendar but another component is being dragged, render a helper event
			if (seg && seg.component !== this) {
				return this.renderEventLocationHelper(eventLocation, seg); // returns mock event elements
			}
		},
	
	
		// Unrenders any visual indication of a hovering event
		unrenderDrag: function() {
			this.unrenderHighlight();
			this.unrenderHelper();
		},
	
	
		/* Event Resize Visualization
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Renders a visual indication of an event being resized
		renderEventResize: function(eventLocation, seg) {
			this.renderHighlight(this.eventToSpan(eventLocation));
			return this.renderEventLocationHelper(eventLocation, seg); // returns mock event elements
		},
	
	
		// Unrenders a visual indication of an event being resized
		unrenderEventResize: function() {
			this.unrenderHighlight();
			this.unrenderHelper();
		},
	
	
		/* Event Helper
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Renders a mock "helper" event. `sourceSeg` is the associated internal segment object. It can be null.
		renderHelper: function(event, sourceSeg) {
			var helperNodes = [];
			var segs = this.eventToSegs(event);
			var rowStructs;
	
			segs = this.renderFgSegEls(segs); // assigns each seg's el and returns a subset of segs that were rendered
			rowStructs = this.renderSegRows(segs);
	
			// inject each new event skeleton into each associated row
			this.rowEls.each(function(row, rowNode) {
				var rowEl = $(rowNode); // the .fc-row
				var skeletonEl = $('<div class="fc-helper-skeleton"><table/></div>'); // will be absolutely positioned
				var skeletonTop;
	
				// If there is an original segment, match the top position. Otherwise, put it at the row's top level
				if (sourceSeg && sourceSeg.row === row) {
					skeletonTop = sourceSeg.el.position().top;
				}
				else {
					skeletonTop = rowEl.find('.fc-content-skeleton tbody').position().top;
				}
	
				skeletonEl.css('top', skeletonTop)
					.find('table')
						.append(rowStructs[row].tbodyEl);
	
				rowEl.append(skeletonEl);
				helperNodes.push(skeletonEl[0]);
			});
	
			return ( // must return the elements rendered
				this.helperEls = $(helperNodes) // array -> jQuery set
			);
		},
	
	
		// Unrenders any visual indication of a mock helper event
		unrenderHelper: function() {
			if (this.helperEls) {
				this.helperEls.remove();
				this.helperEls = null;
			}
		},
	
	
		/* Fill System (highlight, background events, business hours)
		------------------------------------------------------------------------------------------------------------------*/
	
	
		fillSegTag: 'td', // override the default tag name
	
	
		// Renders a set of rectangles over the given segments of days.
		// Only returns segments that successfully rendered.
		renderFill: function(type, segs, className) {
			var nodes = [];
			var i, seg;
			var skeletonEl;
	
			segs = this.renderFillSegEls(type, segs); // assignes `.el` to each seg. returns successfully rendered segs
	
			for (i = 0; i < segs.length; i++) {
				seg = segs[i];
				skeletonEl = this.renderFillRow(type, seg, className);
				this.rowEls.eq(seg.row).append(skeletonEl);
				nodes.push(skeletonEl[0]);
			}
	
			this.elsByFill[type] = $(nodes);
	
			return segs;
		},
	
	
		// Generates the HTML needed for one row of a fill. Requires the seg's el to be rendered.
		renderFillRow: function(type, seg, className) {
			var colCnt = this.colCnt;
			var startCol = seg.leftCol;
			var endCol = seg.rightCol + 1;
			var skeletonEl;
			var trEl;
	
			className = className || type.toLowerCase();
	
			skeletonEl = $(
				'<div class="fc-' + className + '-skeleton">' +
					'<table><tr/></table>' +
				'</div>'
			);
			trEl = skeletonEl.find('tr');
	
			if (startCol > 0) {
				trEl.append('<td colspan="' + startCol + '"/>');
			}
	
			trEl.append(
				seg.el.attr('colspan', endCol - startCol)
			);
	
			if (endCol < colCnt) {
				trEl.append('<td colspan="' + (colCnt - endCol) + '"/>');
			}
	
			this.bookendCells(trEl);
	
			return skeletonEl;
		}
	
	});
	
	;;
	
	/* Event-rendering methods for the DayGrid class
	----------------------------------------------------------------------------------------------------------------------*/
	
	DayGrid.mixin({
	
		rowStructs: null, // an array of objects, each holding information about a row's foreground event-rendering
	
	
		// Unrenders all events currently rendered on the grid
		unrenderEvents: function() {
			this.removeSegPopover(); // removes the "more.." events popover
			Grid.prototype.unrenderEvents.apply(this, arguments); // calls the super-method
		},
	
	
		// Retrieves all rendered segment objects currently rendered on the grid
		getEventSegs: function() {
			return Grid.prototype.getEventSegs.call(this) // get the segments from the super-method
				.concat(this.popoverSegs || []); // append the segments from the "more..." popover
		},
	
	
		// Renders the given background event segments onto the grid
		renderBgSegs: function(segs) {
	
			// don't render timed background events
			var allDaySegs = $.grep(segs, function(seg) {
				return seg.event.allDay;
			});
	
			return Grid.prototype.renderBgSegs.call(this, allDaySegs); // call the super-method
		},
	
	
		// Renders the given foreground event segments onto the grid
		renderFgSegs: function(segs) {
			var rowStructs;
	
			// render an `.el` on each seg
			// returns a subset of the segs. segs that were actually rendered
			segs = this.renderFgSegEls(segs);
	
			rowStructs = this.rowStructs = this.renderSegRows(segs);
	
			// append to each row's content skeleton
			this.rowEls.each(function(i, rowNode) {
				$(rowNode).find('.fc-content-skeleton > table').append(
					rowStructs[i].tbodyEl
				);
			});
	
			return segs; // return only the segs that were actually rendered
		},
	
	
		// Unrenders all currently rendered foreground event segments
		unrenderFgSegs: function() {
			var rowStructs = this.rowStructs || [];
			var rowStruct;
	
			while ((rowStruct = rowStructs.pop())) {
				rowStruct.tbodyEl.remove();
			}
	
			this.rowStructs = null;
		},
	
	
		// Uses the given events array to generate <tbody> elements that should be appended to each row's content skeleton.
		// Returns an array of rowStruct objects (see the bottom of `renderSegRow`).
		// PRECONDITION: each segment shoud already have a rendered and assigned `.el`
		renderSegRows: function(segs) {
			var rowStructs = [];
			var segRows;
			var row;
	
			segRows = this.groupSegRows(segs); // group into nested arrays
	
			// iterate each row of segment groupings
			for (row = 0; row < segRows.length; row++) {
				rowStructs.push(
					this.renderSegRow(row, segRows[row])
				);
			}
	
			return rowStructs;
		},
	
	
		// Builds the HTML to be used for the default element for an individual segment
		fgSegHtml: function(seg, disableResizing) {
			var view = this.view;
			var event = seg.event;
			var isDraggable = view.isEventDraggable(event);
			var isResizableFromStart = !disableResizing && event.allDay &&
				seg.isStart && view.isEventResizableFromStart(event);
			var isResizableFromEnd = !disableResizing && event.allDay &&
				seg.isEnd && view.isEventResizableFromEnd(event);
			var classes = this.getSegClasses(seg, isDraggable, isResizableFromStart || isResizableFromEnd);
			var skinCss = cssToStr(this.getSegSkinCss(seg));
			var timeHtml = '';
			var timeText;
			var titleHtml;
	
			classes.unshift('fc-day-grid-event', 'fc-h-event');
	
			// Only display a timed events time if it is the starting segment
			if (seg.isStart) {
				timeText = this.getEventTimeText(event);
				if (timeText) {
					timeHtml = '<span class="fc-time">' + htmlEscape(timeText) + '</span>';
				}
			}
	
			titleHtml =
				'<span class="fc-title">' +
					(htmlEscape(event.title || '') || '&nbsp;') + // we always want one line of height
				'</span>';
			
			return '<a class="' + classes.join(' ') + '"' +
					(event.url ?
						' href="' + htmlEscape(event.url) + '"' :
						''
						) +
					(skinCss ?
						' style="' + skinCss + '"' :
						''
						) +
				'>' +
					'<div class="fc-content">' +
						(this.isRTL ?
							titleHtml + ' ' + timeHtml : // put a natural space in between
							timeHtml + ' ' + titleHtml   //
							) +
					'</div>' +
					(isResizableFromStart ?
						'<div class="fc-resizer fc-start-resizer" />' :
						''
						) +
					(isResizableFromEnd ?
						'<div class="fc-resizer fc-end-resizer" />' :
						''
						) +
				'</a>';
		},
	
	
		// Given a row # and an array of segments all in the same row, render a <tbody> element, a skeleton that contains
		// the segments. Returns object with a bunch of internal data about how the render was calculated.
		// NOTE: modifies rowSegs
		renderSegRow: function(row, rowSegs) {
			var colCnt = this.colCnt;
			var segLevels = this.buildSegLevels(rowSegs); // group into sub-arrays of levels
			var levelCnt = Math.max(1, segLevels.length); // ensure at least one level
			var tbody = $('<tbody/>');
			var segMatrix = []; // lookup for which segments are rendered into which level+col cells
			var cellMatrix = []; // lookup for all <td> elements of the level+col matrix
			var loneCellMatrix = []; // lookup for <td> elements that only take up a single column
			var i, levelSegs;
			var col;
			var tr;
			var j, seg;
			var td;
	
			// populates empty cells from the current column (`col`) to `endCol`
			function emptyCellsUntil(endCol) {
				while (col < endCol) {
					// try to grab a cell from the level above and extend its rowspan. otherwise, create a fresh cell
					td = (loneCellMatrix[i - 1] || [])[col];
					if (td) {
						td.attr(
							'rowspan',
							parseInt(td.attr('rowspan') || 1, 10) + 1
						);
					}
					else {
						td = $('<td/>');
						tr.append(td);
					}
					cellMatrix[i][col] = td;
					loneCellMatrix[i][col] = td;
					col++;
				}
			}
	
			for (i = 0; i < levelCnt; i++) { // iterate through all levels
				levelSegs = segLevels[i];
				col = 0;
				tr = $('<tr/>');
	
				segMatrix.push([]);
				cellMatrix.push([]);
				loneCellMatrix.push([]);
	
				// levelCnt might be 1 even though there are no actual levels. protect against this.
				// this single empty row is useful for styling.
				if (levelSegs) {
					for (j = 0; j < levelSegs.length; j++) { // iterate through segments in level
						seg = levelSegs[j];
	
						emptyCellsUntil(seg.leftCol);
	
						// create a container that occupies or more columns. append the event element.
						td = $('<td class="fc-event-container"/>').append(seg.el);
						if (seg.leftCol != seg.rightCol) {
							td.attr('colspan', seg.rightCol - seg.leftCol + 1);
						}
						else { // a single-column segment
							loneCellMatrix[i][col] = td;
						}
	
						while (col <= seg.rightCol) {
							cellMatrix[i][col] = td;
							segMatrix[i][col] = seg;
							col++;
						}
	
						tr.append(td);
					}
				}
	
				emptyCellsUntil(colCnt); // finish off the row
				this.bookendCells(tr);
				tbody.append(tr);
			}
	
			return { // a "rowStruct"
				row: row, // the row number
				tbodyEl: tbody,
				cellMatrix: cellMatrix,
				segMatrix: segMatrix,
				segLevels: segLevels,
				segs: rowSegs
			};
		},
	
	
		// Stacks a flat array of segments, which are all assumed to be in the same row, into subarrays of vertical levels.
		// NOTE: modifies segs
		buildSegLevels: function(segs) {
			var levels = [];
			var i, seg;
			var j;
	
			// Give preference to elements with certain criteria, so they have
			// a chance to be closer to the top.
			this.sortEventSegs(segs);
			
			for (i = 0; i < segs.length; i++) {
				seg = segs[i];
	
				// loop through levels, starting with the topmost, until the segment doesn't collide with other segments
				for (j = 0; j < levels.length; j++) {
					if (!isDaySegCollision(seg, levels[j])) {
						break;
					}
				}
				// `j` now holds the desired subrow index
				seg.level = j;
	
				// create new level array if needed and append segment
				(levels[j] || (levels[j] = [])).push(seg);
			}
	
			// order segments left-to-right. very important if calendar is RTL
			for (j = 0; j < levels.length; j++) {
				levels[j].sort(compareDaySegCols);
			}
	
			return levels;
		},
	
	
		// Given a flat array of segments, return an array of sub-arrays, grouped by each segment's row
		groupSegRows: function(segs) {
			var segRows = [];
			var i;
	
			for (i = 0; i < this.rowCnt; i++) {
				segRows.push([]);
			}
	
			for (i = 0; i < segs.length; i++) {
				segRows[segs[i].row].push(segs[i]);
			}
	
			return segRows;
		}
	
	});
	
	
	// Computes whether two segments' columns collide. They are assumed to be in the same row.
	function isDaySegCollision(seg, otherSegs) {
		var i, otherSeg;
	
		for (i = 0; i < otherSegs.length; i++) {
			otherSeg = otherSegs[i];
	
			if (
				otherSeg.leftCol <= seg.rightCol &&
				otherSeg.rightCol >= seg.leftCol
			) {
				return true;
			}
		}
	
		return false;
	}
	
	
	// A cmp function for determining the leftmost event
	function compareDaySegCols(a, b) {
		return a.leftCol - b.leftCol;
	}
	
	;;
	
	/* Methods relate to limiting the number events for a given day on a DayGrid
	----------------------------------------------------------------------------------------------------------------------*/
	// NOTE: all the segs being passed around in here are foreground segs
	
	DayGrid.mixin({
	
		segPopover: null, // the Popover that holds events that can't fit in a cell. null when not visible
		popoverSegs: null, // an array of segment objects that the segPopover holds. null when not visible
	
	
		removeSegPopover: function() {
			if (this.segPopover) {
				this.segPopover.hide(); // in handler, will call segPopover's removeElement
			}
		},
	
	
		// Limits the number of "levels" (vertically stacking layers of events) for each row of the grid.
		// `levelLimit` can be false (don't limit), a number, or true (should be computed).
		limitRows: function(levelLimit) {
			var rowStructs = this.rowStructs || [];
			var row; // row #
			var rowLevelLimit;
	
			for (row = 0; row < rowStructs.length; row++) {
				this.unlimitRow(row);
	
				if (!levelLimit) {
					rowLevelLimit = false;
				}
				else if (typeof levelLimit === 'number') {
					rowLevelLimit = levelLimit;
				}
				else {
					rowLevelLimit = this.computeRowLevelLimit(row);
				}
	
				if (rowLevelLimit !== false) {
					this.limitRow(row, rowLevelLimit);
				}
			}
		},
	
	
		// Computes the number of levels a row will accomodate without going outside its bounds.
		// Assumes the row is "rigid" (maintains a constant height regardless of what is inside).
		// `row` is the row number.
		computeRowLevelLimit: function(row) {
			var rowEl = this.rowEls.eq(row); // the containing "fake" row div
			var rowHeight = rowEl.height(); // TODO: cache somehow?
			var trEls = this.rowStructs[row].tbodyEl.children();
			var i, trEl;
			var trHeight;
	
			function iterInnerHeights(i, childNode) {
				trHeight = Math.max(trHeight, $(childNode).outerHeight());
			}
	
			// Reveal one level <tr> at a time and stop when we find one out of bounds
			for (i = 0; i < trEls.length; i++) {
				trEl = trEls.eq(i).removeClass('fc-limited'); // reset to original state (reveal)
	
				// with rowspans>1 and IE8, trEl.outerHeight() would return the height of the largest cell,
				// so instead, find the tallest inner content element.
				trHeight = 0;
				trEl.find('> td > :first-child').each(iterInnerHeights);
	
				if (trEl.position().top + trHeight > rowHeight) {
					return i;
				}
			}
	
			return false; // should not limit at all
		},
	
	
		// Limits the given grid row to the maximum number of levels and injects "more" links if necessary.
		// `row` is the row number.
		// `levelLimit` is a number for the maximum (inclusive) number of levels allowed.
		limitRow: function(row, levelLimit) {
			var _this = this;
			var rowStruct = this.rowStructs[row];
			var moreNodes = []; // array of "more" <a> links and <td> DOM nodes
			var col = 0; // col #, left-to-right (not chronologically)
			var levelSegs; // array of segment objects in the last allowable level, ordered left-to-right
			var cellMatrix; // a matrix (by level, then column) of all <td> jQuery elements in the row
			var limitedNodes; // array of temporarily hidden level <tr> and segment <td> DOM nodes
			var i, seg;
			var segsBelow; // array of segment objects below `seg` in the current `col`
			var totalSegsBelow; // total number of segments below `seg` in any of the columns `seg` occupies
			var colSegsBelow; // array of segment arrays, below seg, one for each column (offset from segs's first column)
			var td, rowspan;
			var segMoreNodes; // array of "more" <td> cells that will stand-in for the current seg's cell
			var j;
			var moreTd, moreWrap, moreLink;
	
			// Iterates through empty level cells and places "more" links inside if need be
			function emptyCellsUntil(endCol) { // goes from current `col` to `endCol`
				while (col < endCol) {
					segsBelow = _this.getCellSegs(row, col, levelLimit);
					if (segsBelow.length) {
						td = cellMatrix[levelLimit - 1][col];
						moreLink = _this.renderMoreLink(row, col, segsBelow);
						moreWrap = $('<div/>').append(moreLink);
						td.append(moreWrap);
						moreNodes.push(moreWrap[0]);
					}
					col++;
				}
			}
	
			if (levelLimit && levelLimit < rowStruct.segLevels.length) { // is it actually over the limit?
				levelSegs = rowStruct.segLevels[levelLimit - 1];
				cellMatrix = rowStruct.cellMatrix;
	
				limitedNodes = rowStruct.tbodyEl.children().slice(levelLimit) // get level <tr> elements past the limit
					.addClass('fc-limited').get(); // hide elements and get a simple DOM-nodes array
	
				// iterate though segments in the last allowable level
				for (i = 0; i < levelSegs.length; i++) {
					seg = levelSegs[i];
					emptyCellsUntil(seg.leftCol); // process empty cells before the segment
	
					// determine *all* segments below `seg` that occupy the same columns
					colSegsBelow = [];
					totalSegsBelow = 0;
					while (col <= seg.rightCol) {
						segsBelow = this.getCellSegs(row, col, levelLimit);
						colSegsBelow.push(segsBelow);
						totalSegsBelow += segsBelow.length;
						col++;
					}
	
					if (totalSegsBelow) { // do we need to replace this segment with one or many "more" links?
						td = cellMatrix[levelLimit - 1][seg.leftCol]; // the segment's parent cell
						rowspan = td.attr('rowspan') || 1;
						segMoreNodes = [];
	
						// make a replacement <td> for each column the segment occupies. will be one for each colspan
						for (j = 0; j < colSegsBelow.length; j++) {
							moreTd = $('<td class="fc-more-cell"/>').attr('rowspan', rowspan);
							segsBelow = colSegsBelow[j];
							moreLink = this.renderMoreLink(
								row,
								seg.leftCol + j,
								[ seg ].concat(segsBelow) // count seg as hidden too
							);
							moreWrap = $('<div/>').append(moreLink);
							moreTd.append(moreWrap);
							segMoreNodes.push(moreTd[0]);
							moreNodes.push(moreTd[0]);
						}
	
						td.addClass('fc-limited').after($(segMoreNodes)); // hide original <td> and inject replacements
						limitedNodes.push(td[0]);
					}
				}
	
				emptyCellsUntil(this.colCnt); // finish off the level
				rowStruct.moreEls = $(moreNodes); // for easy undoing later
				rowStruct.limitedEls = $(limitedNodes); // for easy undoing later
			}
		},
	
	
		// Reveals all levels and removes all "more"-related elements for a grid's row.
		// `row` is a row number.
		unlimitRow: function(row) {
			var rowStruct = this.rowStructs[row];
	
			if (rowStruct.moreEls) {
				rowStruct.moreEls.remove();
				rowStruct.moreEls = null;
			}
	
			if (rowStruct.limitedEls) {
				rowStruct.limitedEls.removeClass('fc-limited');
				rowStruct.limitedEls = null;
			}
		},
	
	
		// Renders an <a> element that represents hidden event element for a cell.
		// Responsible for attaching click handler as well.
		renderMoreLink: function(row, col, hiddenSegs) {
			var _this = this;
			var view = this.view;
	
			return $('<a class="fc-more"/>')
				.text(
					this.getMoreLinkText(hiddenSegs.length)
				)
				.on('click', function(ev) {
					var clickOption = view.opt('eventLimitClick');
					var date = _this.getCellDate(row, col);
					var moreEl = $(this);
					var dayEl = _this.getCellEl(row, col);
					var allSegs = _this.getCellSegs(row, col);
	
					// rescope the segments to be within the cell's date
					var reslicedAllSegs = _this.resliceDaySegs(allSegs, date);
					var reslicedHiddenSegs = _this.resliceDaySegs(hiddenSegs, date);
	
					if (typeof clickOption === 'function') {
						// the returned value can be an atomic option
						clickOption = view.publiclyTrigger('eventLimitClick', null, {
							date: date,
							dayEl: dayEl,
							moreEl: moreEl,
							segs: reslicedAllSegs,
							hiddenSegs: reslicedHiddenSegs
						}, ev);
					}
	
					if (clickOption === 'popover') {
						_this.showSegPopover(row, col, moreEl, reslicedAllSegs);
					}
					else if (typeof clickOption === 'string') { // a view name
						view.calendar.zoomTo(date, clickOption);
					}
				});
		},
	
	
		// Reveals the popover that displays all events within a cell
		showSegPopover: function(row, col, moreLink, segs) {
			var _this = this;
			var view = this.view;
			var moreWrap = moreLink.parent(); // the <div> wrapper around the <a>
			var topEl; // the element we want to match the top coordinate of
			var options;
	
			if (this.rowCnt == 1) {
				topEl = view.el; // will cause the popover to cover any sort of header
			}
			else {
				topEl = this.rowEls.eq(row); // will align with top of row
			}
	
			options = {
				className: 'fc-more-popover',
				content: this.renderSegPopoverContent(row, col, segs),
				parentEl: this.view.el, // attach to root of view. guarantees outside of scrollbars.
				top: topEl.offset().top,
				autoHide: true, // when the user clicks elsewhere, hide the popover
				viewportConstrain: view.opt('popoverViewportConstrain'),
				hide: function() {
					// kill everything when the popover is hidden
					// notify events to be removed
					if (_this.popoverSegs) {
						var seg;
						for (var i = 0; i < _this.popoverSegs.length; ++i) {
							seg = _this.popoverSegs[i];
							view.publiclyTrigger('eventDestroy', seg.event, seg.event, seg.el);
						}
					}
					_this.segPopover.removeElement();
					_this.segPopover = null;
					_this.popoverSegs = null;
				}
			};
	
			// Determine horizontal coordinate.
			// We use the moreWrap instead of the <td> to avoid border confusion.
			if (this.isRTL) {
				options.right = moreWrap.offset().left + moreWrap.outerWidth() + 1; // +1 to be over cell border
			}
			else {
				options.left = moreWrap.offset().left - 1; // -1 to be over cell border
			}
	
			this.segPopover = new Popover(options);
			this.segPopover.show();
	
			// the popover doesn't live within the grid's container element, and thus won't get the event
			// delegated-handlers for free. attach event-related handlers to the popover.
			this.bindSegHandlersToEl(this.segPopover.el);
		},
	
	
		// Builds the inner DOM contents of the segment popover
		renderSegPopoverContent: function(row, col, segs) {
			var view = this.view;
			var isTheme = view.opt('theme');
			var title = this.getCellDate(row, col).format(view.opt('dayPopoverFormat'));
			var content = $(
				'<div class="fc-header ' + view.widgetHeaderClass + '">' +
					'<span class="fc-close ' +
						(isTheme ? 'ui-icon ui-icon-closethick' : 'fc-icon fc-icon-x') +
					'"></span>' +
					'<span class="fc-title">' +
						htmlEscape(title) +
					'</span>' +
					'<div class="fc-clear"/>' +
				'</div>' +
				'<div class="fc-body ' + view.widgetContentClass + '">' +
					'<div class="fc-event-container"></div>' +
				'</div>'
			);
			var segContainer = content.find('.fc-event-container');
			var i;
	
			// render each seg's `el` and only return the visible segs
			segs = this.renderFgSegEls(segs, true); // disableResizing=true
			this.popoverSegs = segs;
	
			for (i = 0; i < segs.length; i++) {
	
				// because segments in the popover are not part of a grid coordinate system, provide a hint to any
				// grids that want to do drag-n-drop about which cell it came from
				this.prepareHits();
				segs[i].hit = this.getCellHit(row, col);
				this.releaseHits();
	
				segContainer.append(segs[i].el);
			}
	
			return content;
		},
	
	
		// Given the events within an array of segment objects, reslice them to be in a single day
		resliceDaySegs: function(segs, dayDate) {
	
			// build an array of the original events
			var events = $.map(segs, function(seg) {
				return seg.event;
			});
	
			var dayStart = dayDate.clone();
			var dayEnd = dayStart.clone().add(1, 'days');
			var dayRange = { start: dayStart, end: dayEnd };
	
			// slice the events with a custom slicing function
			segs = this.eventsToSegs(
				events,
				function(range) {
					var seg = intersectRanges(range, dayRange); // undefind if no intersection
					return seg ? [ seg ] : []; // must return an array of segments
				}
			);
	
			// force an order because eventsToSegs doesn't guarantee one
			this.sortEventSegs(segs);
	
			return segs;
		},
	
	
		// Generates the text that should be inside a "more" link, given the number of events it represents
		getMoreLinkText: function(num) {
			var opt = this.view.opt('eventLimitText');
	
			if (typeof opt === 'function') {
				return opt(num);
			}
			else {
				return '+' + num + ' ' + opt;
			}
		},
	
	
		// Returns segments within a given cell.
		// If `startLevel` is specified, returns only events including and below that level. Otherwise returns all segs.
		getCellSegs: function(row, col, startLevel) {
			var segMatrix = this.rowStructs[row].segMatrix;
			var level = startLevel || 0;
			var segs = [];
			var seg;
	
			while (level < segMatrix.length) {
				seg = segMatrix[level][col];
				if (seg) {
					segs.push(seg);
				}
				level++;
			}
	
			return segs;
		}
	
	});
	
	;;
	
	/* A component that renders one or more columns of vertical time slots
	----------------------------------------------------------------------------------------------------------------------*/
	// We mixin DayTable, even though there is only a single row of days
	
	var TimeGrid = FC.TimeGrid = Grid.extend(DayTableMixin, {
	
		slotDuration: null, // duration of a "slot", a distinct time segment on given day, visualized by lines
		snapDuration: null, // granularity of time for dragging and selecting
		snapsPerSlot: null,
		minTime: null, // Duration object that denotes the first visible time of any given day
		maxTime: null, // Duration object that denotes the exclusive visible end time of any given day
		labelFormat: null, // formatting string for times running along vertical axis
		labelInterval: null, // duration of how often a label should be displayed for a slot
	
		colEls: null, // cells elements in the day-row background
		slatContainerEl: null, // div that wraps all the slat rows
		slatEls: null, // elements running horizontally across all columns
		nowIndicatorEls: null,
	
		colCoordCache: null,
		slatCoordCache: null,
	
	
		constructor: function() {
			Grid.apply(this, arguments); // call the super-constructor
	
			this.processOptions();
		},
	
	
		// Renders the time grid into `this.el`, which should already be assigned.
		// Relies on the view's colCnt. In the future, this component should probably be self-sufficient.
		renderDates: function() {
			this.el.html(this.renderHtml());
			this.colEls = this.el.find('.fc-day');
			this.slatContainerEl = this.el.find('.fc-slats');
			this.slatEls = this.slatContainerEl.find('tr');
	
			this.colCoordCache = new CoordCache({
				els: this.colEls,
				isHorizontal: true
			});
			this.slatCoordCache = new CoordCache({
				els: this.slatEls,
				isVertical: true
			});
	
			this.renderContentSkeleton();
		},
	
	
		// Renders the basic HTML skeleton for the grid
		renderHtml: function() {
			return '' +
				'<div class="fc-bg">' +
					'<table>' +
						this.renderBgTrHtml(0) + // row=0
					'</table>' +
				'</div>' +
				'<div class="fc-slats">' +
					'<table>' +
						this.renderSlatRowHtml() +
					'</table>' +
				'</div>';
		},
	
	
		// Generates the HTML for the horizontal "slats" that run width-wise. Has a time axis on a side. Depends on RTL.
		renderSlatRowHtml: function() {
			var view = this.view;
			var isRTL = this.isRTL;
			var html = '';
			var slotTime = moment.duration(+this.minTime); // wish there was .clone() for durations
			var slotDate; // will be on the view's first day, but we only care about its time
			var isLabeled;
			var axisHtml;
	
			// Calculate the time for each slot
			while (slotTime < this.maxTime) {
				slotDate = this.start.clone().time(slotTime);
				isLabeled = isInt(divideDurationByDuration(slotTime, this.labelInterval));
	
				axisHtml =
					'<td class="fc-axis fc-time ' + view.widgetContentClass + '" ' + view.axisStyleAttr() + '>' +
						(isLabeled ?
							'<span>' + // for matchCellWidths
								htmlEscape(slotDate.format(this.labelFormat)) +
							'</span>' :
							''
							) +
					'</td>';
	
				html +=
					'<tr data-time="' + slotDate.format('HH:mm:ss') + '"' +
						(isLabeled ? '' : ' class="fc-minor"') +
						'>' +
						(!isRTL ? axisHtml : '') +
						'<td class="' + view.widgetContentClass + '"/>' +
						(isRTL ? axisHtml : '') +
					"</tr>";
	
				slotTime.add(this.slotDuration);
			}
	
			return html;
		},
	
	
		/* Options
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Parses various options into properties of this object
		processOptions: function() {
			var view = this.view;
			var slotDuration = view.opt('slotDuration');
			var snapDuration = view.opt('snapDuration');
			var input;
	
			slotDuration = moment.duration(slotDuration);
			snapDuration = snapDuration ? moment.duration(snapDuration) : slotDuration;
	
			this.slotDuration = slotDuration;
			this.snapDuration = snapDuration;
			this.snapsPerSlot = slotDuration / snapDuration; // TODO: ensure an integer multiple?
	
			this.minResizeDuration = snapDuration; // hack
	
			this.minTime = moment.duration(view.opt('minTime'));
			this.maxTime = moment.duration(view.opt('maxTime'));
	
			// might be an array value (for TimelineView).
			// if so, getting the most granular entry (the last one probably).
			input = view.opt('slotLabelFormat');
			if ($.isArray(input)) {
				input = input[input.length - 1];
			}
	
			this.labelFormat =
				input ||
				view.opt('smallTimeFormat'); // the computed default
	
			input = view.opt('slotLabelInterval');
			this.labelInterval = input ?
				moment.duration(input) :
				this.computeLabelInterval(slotDuration);
		},
	
	
		// Computes an automatic value for slotLabelInterval
		computeLabelInterval: function(slotDuration) {
			var i;
			var labelInterval;
			var slotsPerLabel;
	
			// find the smallest stock label interval that results in more than one slots-per-label
			for (i = AGENDA_STOCK_SUB_DURATIONS.length - 1; i >= 0; i--) {
				labelInterval = moment.duration(AGENDA_STOCK_SUB_DURATIONS[i]);
				slotsPerLabel = divideDurationByDuration(labelInterval, slotDuration);
				if (isInt(slotsPerLabel) && slotsPerLabel > 1) {
					return labelInterval;
				}
			}
	
			return moment.duration(slotDuration); // fall back. clone
		},
	
	
		// Computes a default event time formatting string if `timeFormat` is not explicitly defined
		computeEventTimeFormat: function() {
			return this.view.opt('noMeridiemTimeFormat'); // like "6:30" (no AM/PM)
		},
	
	
		// Computes a default `displayEventEnd` value if one is not expliclty defined
		computeDisplayEventEnd: function() {
			return true;
		},
	
	
		/* Hit System
		------------------------------------------------------------------------------------------------------------------*/
	
	
		prepareHits: function() {
			this.colCoordCache.build();
			this.slatCoordCache.build();
		},
	
	
		releaseHits: function() {
			this.colCoordCache.clear();
			// NOTE: don't clear slatCoordCache because we rely on it for computeTimeTop
		},
	
	
		queryHit: function(leftOffset, topOffset) {
			var snapsPerSlot = this.snapsPerSlot;
			var colCoordCache = this.colCoordCache;
			var slatCoordCache = this.slatCoordCache;
	
			if (colCoordCache.isLeftInBounds(leftOffset) && slatCoordCache.isTopInBounds(topOffset)) {
				var colIndex = colCoordCache.getHorizontalIndex(leftOffset);
				var slatIndex = slatCoordCache.getVerticalIndex(topOffset);
	
				if (colIndex != null && slatIndex != null) {
					var slatTop = slatCoordCache.getTopOffset(slatIndex);
					var slatHeight = slatCoordCache.getHeight(slatIndex);
					var partial = (topOffset - slatTop) / slatHeight; // floating point number between 0 and 1
					var localSnapIndex = Math.floor(partial * snapsPerSlot); // the snap # relative to start of slat
					var snapIndex = slatIndex * snapsPerSlot + localSnapIndex;
					var snapTop = slatTop + (localSnapIndex / snapsPerSlot) * slatHeight;
					var snapBottom = slatTop + ((localSnapIndex + 1) / snapsPerSlot) * slatHeight;
	
					return {
						col: colIndex,
						snap: snapIndex,
						component: this, // needed unfortunately :(
						left: colCoordCache.getLeftOffset(colIndex),
						right: colCoordCache.getRightOffset(colIndex),
						top: snapTop,
						bottom: snapBottom
					};
				}
			}
		},
	
	
		getHitSpan: function(hit) {
			var start = this.getCellDate(0, hit.col); // row=0
			var time = this.computeSnapTime(hit.snap); // pass in the snap-index
			var end;
	
			start.time(time);
			end = start.clone().add(this.snapDuration);
	
			return { start: start, end: end };
		},
	
	
		getHitEl: function(hit) {
			return this.colEls.eq(hit.col);
		},
	
	
		/* Dates
		------------------------------------------------------------------------------------------------------------------*/
	
	
		rangeUpdated: function() {
			this.updateDayTable();
		},
	
	
		// Given a row number of the grid, representing a "snap", returns a time (Duration) from its start-of-day
		computeSnapTime: function(snapIndex) {
			return moment.duration(this.minTime + this.snapDuration * snapIndex);
		},
	
	
		// Slices up the given span (unzoned start/end with other misc data) into an array of segments
		spanToSegs: function(span) {
			var segs = this.sliceRangeByTimes(span);
			var i;
	
			for (i = 0; i < segs.length; i++) {
				if (this.isRTL) {
					segs[i].col = this.daysPerRow - 1 - segs[i].dayIndex;
				}
				else {
					segs[i].col = segs[i].dayIndex;
				}
			}
	
			return segs;
		},
	
	
		sliceRangeByTimes: function(range) {
			var segs = [];
			var seg;
			var dayIndex;
			var dayDate;
			var dayRange;
	
			for (dayIndex = 0; dayIndex < this.daysPerRow; dayIndex++) {
				dayDate = this.dayDates[dayIndex].clone(); // TODO: better API for this?
				dayRange = {
					start: dayDate.clone().time(this.minTime),
					end: dayDate.clone().time(this.maxTime)
				};
				seg = intersectRanges(range, dayRange); // both will be ambig timezone
				if (seg) {
					seg.dayIndex = dayIndex;
					segs.push(seg);
				}
			}
	
			return segs;
		},
	
	
		/* Coordinates
		------------------------------------------------------------------------------------------------------------------*/
	
	
		updateSize: function(isResize) { // NOT a standard Grid method
			this.slatCoordCache.build();
	
			if (isResize) {
				this.updateSegVerticals(
					[].concat(this.fgSegs || [], this.bgSegs || [], this.businessSegs || [])
				);
			}
		},
	
	
		getTotalSlatHeight: function() {
			return this.slatContainerEl.outerHeight();
		},
	
	
		// Computes the top coordinate, relative to the bounds of the grid, of the given date.
		// A `startOfDayDate` must be given for avoiding ambiguity over how to treat midnight.
		computeDateTop: function(date, startOfDayDate) {
			return this.computeTimeTop(
				moment.duration(
					date - startOfDayDate.clone().stripTime()
				)
			);
		},
	
	
		// Computes the top coordinate, relative to the bounds of the grid, of the given time (a Duration).
		computeTimeTop: function(time) {
			var len = this.slatEls.length;
			var slatCoverage = (time - this.minTime) / this.slotDuration; // floating-point value of # of slots covered
			var slatIndex;
			var slatRemainder;
	
			// compute a floating-point number for how many slats should be progressed through.
			// from 0 to number of slats (inclusive)
			// constrained because minTime/maxTime might be customized.
			slatCoverage = Math.max(0, slatCoverage);
			slatCoverage = Math.min(len, slatCoverage);
	
			// an integer index of the furthest whole slat
			// from 0 to number slats (*exclusive*, so len-1)
			slatIndex = Math.floor(slatCoverage);
			slatIndex = Math.min(slatIndex, len - 1);
	
			// how much further through the slatIndex slat (from 0.0-1.0) must be covered in addition.
			// could be 1.0 if slatCoverage is covering *all* the slots
			slatRemainder = slatCoverage - slatIndex;
	
			return this.slatCoordCache.getTopPosition(slatIndex) +
				this.slatCoordCache.getHeight(slatIndex) * slatRemainder;
		},
	
	
	
		/* Event Drag Visualization
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Renders a visual indication of an event being dragged over the specified date(s).
		// A returned value of `true` signals that a mock "helper" event has been rendered.
		renderDrag: function(eventLocation, seg) {
	
			if (seg) { // if there is event information for this drag, render a helper event
	
				// returns mock event elements
				// signal that a helper has been rendered
				return this.renderEventLocationHelper(eventLocation, seg);
			}
			else {
				// otherwise, just render a highlight
				this.renderHighlight(this.eventToSpan(eventLocation));
			}
		},
	
	
		// Unrenders any visual indication of an event being dragged
		unrenderDrag: function() {
			this.unrenderHelper();
			this.unrenderHighlight();
		},
	
	
		/* Event Resize Visualization
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Renders a visual indication of an event being resized
		renderEventResize: function(eventLocation, seg) {
			return this.renderEventLocationHelper(eventLocation, seg); // returns mock event elements
		},
	
	
		// Unrenders any visual indication of an event being resized
		unrenderEventResize: function() {
			this.unrenderHelper();
		},
	
	
		/* Event Helper
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Renders a mock "helper" event. `sourceSeg` is the original segment object and might be null (an external drag)
		renderHelper: function(event, sourceSeg) {
			return this.renderHelperSegs(this.eventToSegs(event), sourceSeg); // returns mock event elements
		},
	
	
		// Unrenders any mock helper event
		unrenderHelper: function() {
			this.unrenderHelperSegs();
		},
	
	
		/* Business Hours
		------------------------------------------------------------------------------------------------------------------*/
	
	
		renderBusinessHours: function() {
			this.renderBusinessSegs(
				this.buildBusinessHourSegs()
			);
		},
	
	
		unrenderBusinessHours: function() {
			this.unrenderBusinessSegs();
		},
	
	
		/* Now Indicator
		------------------------------------------------------------------------------------------------------------------*/
	
	
		getNowIndicatorUnit: function() {
			return 'minute'; // will refresh on the minute
		},
	
	
		renderNowIndicator: function(date) {
			// seg system might be overkill, but it handles scenario where line needs to be rendered
			//  more than once because of columns with the same date (resources columns for example)
			var segs = this.spanToSegs({ start: date, end: date });
			var top = this.computeDateTop(date, date);
			var nodes = [];
			var i;
	
			// render lines within the columns
			for (i = 0; i < segs.length; i++) {
				nodes.push($('<div class="fc-now-indicator fc-now-indicator-line"></div>')
					.css('top', top)
					.appendTo(this.colContainerEls.eq(segs[i].col))[0]);
			}
	
			// render an arrow over the axis
			if (segs.length > 0) { // is the current time in view?
				nodes.push($('<div class="fc-now-indicator fc-now-indicator-arrow"></div>')
					.css('top', top)
					.appendTo(this.el.find('.fc-content-skeleton'))[0]);
			}
	
			this.nowIndicatorEls = $(nodes);
		},
	
	
		unrenderNowIndicator: function() {
			if (this.nowIndicatorEls) {
				this.nowIndicatorEls.remove();
				this.nowIndicatorEls = null;
			}
		},
	
	
		/* Selection
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Renders a visual indication of a selection. Overrides the default, which was to simply render a highlight.
		renderSelection: function(span) {
			if (this.view.opt('selectHelper')) { // this setting signals that a mock helper event should be rendered
	
				// normally acceps an eventLocation, span has a start/end, which is good enough
				this.renderEventLocationHelper(span);
			}
			else {
				this.renderHighlight(span);
			}
		},
	
	
		// Unrenders any visual indication of a selection
		unrenderSelection: function() {
			this.unrenderHelper();
			this.unrenderHighlight();
		},
	
	
		/* Highlight
		------------------------------------------------------------------------------------------------------------------*/
	
	
		renderHighlight: function(span) {
			this.renderHighlightSegs(this.spanToSegs(span));
		},
	
	
		unrenderHighlight: function() {
			this.unrenderHighlightSegs();
		}
	
	});
	
	;;
	
	/* Methods for rendering SEGMENTS, pieces of content that live on the view
	 ( this file is no longer just for events )
	----------------------------------------------------------------------------------------------------------------------*/
	
	TimeGrid.mixin({
	
		colContainerEls: null, // containers for each column
	
		// inner-containers for each column where different types of segs live
		fgContainerEls: null,
		bgContainerEls: null,
		helperContainerEls: null,
		highlightContainerEls: null,
		businessContainerEls: null,
	
		// arrays of different types of displayed segments
		fgSegs: null,
		bgSegs: null,
		helperSegs: null,
		highlightSegs: null,
		businessSegs: null,
	
	
		// Renders the DOM that the view's content will live in
		renderContentSkeleton: function() {
			var cellHtml = '';
			var i;
			var skeletonEl;
	
			for (i = 0; i < this.colCnt; i++) {
				cellHtml +=
					'<td>' +
						'<div class="fc-content-col">' +
							'<div class="fc-event-container fc-helper-container"></div>' +
							'<div class="fc-event-container"></div>' +
							'<div class="fc-highlight-container"></div>' +
							'<div class="fc-bgevent-container"></div>' +
							'<div class="fc-business-container"></div>' +
						'</div>' +
					'</td>';
			}
	
			skeletonEl = $(
				'<div class="fc-content-skeleton">' +
					'<table>' +
						'<tr>' + cellHtml + '</tr>' +
					'</table>' +
				'</div>'
			);
	
			this.colContainerEls = skeletonEl.find('.fc-content-col');
			this.helperContainerEls = skeletonEl.find('.fc-helper-container');
			this.fgContainerEls = skeletonEl.find('.fc-event-container:not(.fc-helper-container)');
			this.bgContainerEls = skeletonEl.find('.fc-bgevent-container');
			this.highlightContainerEls = skeletonEl.find('.fc-highlight-container');
			this.businessContainerEls = skeletonEl.find('.fc-business-container');
	
			this.bookendCells(skeletonEl.find('tr')); // TODO: do this on string level
			this.el.append(skeletonEl);
		},
	
	
		/* Foreground Events
		------------------------------------------------------------------------------------------------------------------*/
	
	
		renderFgSegs: function(segs) {
			segs = this.renderFgSegsIntoContainers(segs, this.fgContainerEls);
			this.fgSegs = segs;
			return segs; // needed for Grid::renderEvents
		},
	
	
		unrenderFgSegs: function() {
			this.unrenderNamedSegs('fgSegs');
		},
	
	
		/* Foreground Helper Events
		------------------------------------------------------------------------------------------------------------------*/
	
	
		renderHelperSegs: function(segs, sourceSeg) {
			var helperEls = [];
			var i, seg;
			var sourceEl;
	
			segs = this.renderFgSegsIntoContainers(segs, this.helperContainerEls);
	
			// Try to make the segment that is in the same row as sourceSeg look the same
			for (i = 0; i < segs.length; i++) {
				seg = segs[i];
				if (sourceSeg && sourceSeg.col === seg.col) {
					sourceEl = sourceSeg.el;
					seg.el.css({
						left: sourceEl.css('left'),
						right: sourceEl.css('right'),
						'margin-left': sourceEl.css('margin-left'),
						'margin-right': sourceEl.css('margin-right')
					});
				}
				helperEls.push(seg.el[0]);
			}
	
			this.helperSegs = segs;
	
			return $(helperEls); // must return rendered helpers
		},
	
	
		unrenderHelperSegs: function() {
			this.unrenderNamedSegs('helperSegs');
		},
	
	
		/* Background Events
		------------------------------------------------------------------------------------------------------------------*/
	
	
		renderBgSegs: function(segs) {
			segs = this.renderFillSegEls('bgEvent', segs); // TODO: old fill system
			this.updateSegVerticals(segs);
			this.attachSegsByCol(this.groupSegsByCol(segs), this.bgContainerEls);
			this.bgSegs = segs;
			return segs; // needed for Grid::renderEvents
		},
	
	
		unrenderBgSegs: function() {
			this.unrenderNamedSegs('bgSegs');
		},
	
	
		/* Highlight
		------------------------------------------------------------------------------------------------------------------*/
	
	
		renderHighlightSegs: function(segs) {
			segs = this.renderFillSegEls('highlight', segs); // TODO: old fill system
			this.updateSegVerticals(segs);
			this.attachSegsByCol(this.groupSegsByCol(segs), this.highlightContainerEls);
			this.highlightSegs = segs;
		},
	
	
		unrenderHighlightSegs: function() {
			this.unrenderNamedSegs('highlightSegs');
		},
	
	
		/* Business Hours
		------------------------------------------------------------------------------------------------------------------*/
	
	
		renderBusinessSegs: function(segs) {
			segs = this.renderFillSegEls('businessHours', segs); // TODO: old fill system
			this.updateSegVerticals(segs);
			this.attachSegsByCol(this.groupSegsByCol(segs), this.businessContainerEls);
			this.businessSegs = segs;
		},
	
	
		unrenderBusinessSegs: function() {
			this.unrenderNamedSegs('businessSegs');
		},
	
	
		/* Seg Rendering Utils
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Given a flat array of segments, return an array of sub-arrays, grouped by each segment's col
		groupSegsByCol: function(segs) {
			var segsByCol = [];
			var i;
	
			for (i = 0; i < this.colCnt; i++) {
				segsByCol.push([]);
			}
	
			for (i = 0; i < segs.length; i++) {
				segsByCol[segs[i].col].push(segs[i]);
			}
	
			return segsByCol;
		},
	
	
		// Given segments grouped by column, insert the segments' elements into a parallel array of container
		// elements, each living within a column.
		attachSegsByCol: function(segsByCol, containerEls) {
			var col;
			var segs;
			var i;
	
			for (col = 0; col < this.colCnt; col++) { // iterate each column grouping
				segs = segsByCol[col];
	
				for (i = 0; i < segs.length; i++) {
					containerEls.eq(col).append(segs[i].el);
				}
			}
		},
	
	
		// Given the name of a property of `this` object, assumed to be an array of segments,
		// loops through each segment and removes from DOM. Will null-out the property afterwards.
		unrenderNamedSegs: function(propName) {
			var segs = this[propName];
			var i;
	
			if (segs) {
				for (i = 0; i < segs.length; i++) {
					segs[i].el.remove();
				}
				this[propName] = null;
			}
		},
	
	
	
		/* Foreground Event Rendering Utils
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Given an array of foreground segments, render a DOM element for each, computes position,
		// and attaches to the column inner-container elements.
		renderFgSegsIntoContainers: function(segs, containerEls) {
			var segsByCol;
			var col;
	
			segs = this.renderFgSegEls(segs); // will call fgSegHtml
			segsByCol = this.groupSegsByCol(segs);
	
			for (col = 0; col < this.colCnt; col++) {
				this.updateFgSegCoords(segsByCol[col]);
			}
	
			this.attachSegsByCol(segsByCol, containerEls);
	
			return segs;
		},
	
	
		// Renders the HTML for a single event segment's default rendering
		fgSegHtml: function(seg, disableResizing) {
			var view = this.view;
			var event = seg.event;
			var isDraggable = view.isEventDraggable(event);
			var isResizableFromStart = !disableResizing && seg.isStart && view.isEventResizableFromStart(event);
			var isResizableFromEnd = !disableResizing && seg.isEnd && view.isEventResizableFromEnd(event);
			var classes = this.getSegClasses(seg, isDraggable, isResizableFromStart || isResizableFromEnd);
			var skinCss = cssToStr(this.getSegSkinCss(seg));
			var timeText;
			var fullTimeText; // more verbose time text. for the print stylesheet
			var startTimeText; // just the start time text
	
			classes.unshift('fc-time-grid-event', 'fc-v-event');
	
			if (view.isMultiDayEvent(event)) { // if the event appears to span more than one day...
				// Don't display time text on segments that run entirely through a day.
				// That would appear as midnight-midnight and would look dumb.
				// Otherwise, display the time text for the *segment's* times (like 6pm-midnight or midnight-10am)
				if (seg.isStart || seg.isEnd) {
					timeText = this.getEventTimeText(seg);
					fullTimeText = this.getEventTimeText(seg, 'LT');
					startTimeText = this.getEventTimeText(seg, null, false); // displayEnd=false
				}
			} else {
				// Display the normal time text for the *event's* times
				timeText = this.getEventTimeText(event);
				fullTimeText = this.getEventTimeText(event, 'LT');
				startTimeText = this.getEventTimeText(event, null, false); // displayEnd=false
			}
	
			return '<a class="' + classes.join(' ') + '"' +
				(event.url ?
					' href="' + htmlEscape(event.url) + '"' :
					''
					) +
				(skinCss ?
					' style="' + skinCss + '"' :
					''
					) +
				'>' +
					'<div class="fc-content">' +
						(timeText ?
							'<div class="fc-time"' +
							' data-start="' + htmlEscape(startTimeText) + '"' +
							' data-full="' + htmlEscape(fullTimeText) + '"' +
							'>' +
								'<span>' + htmlEscape(timeText) + '</span>' +
							'</div>' :
							''
							) +
						(event.title ?
							'<div class="fc-title">' +
								htmlEscape(event.title) +
							'</div>' :
							''
							) +
					'</div>' +
					'<div class="fc-bg"/>' +
					/* TODO: write CSS for this
					(isResizableFromStart ?
						'<div class="fc-resizer fc-start-resizer" />' :
						''
						) +
					*/
					(isResizableFromEnd ?
						'<div class="fc-resizer fc-end-resizer" />' :
						''
						) +
				'</a>';
		},
	
	
		/* Seg Position Utils
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Refreshes the CSS top/bottom coordinates for each segment element.
		// Works when called after initial render, after a window resize/zoom for example.
		updateSegVerticals: function(segs) {
			this.computeSegVerticals(segs);
			this.assignSegVerticals(segs);
		},
	
	
		// For each segment in an array, computes and assigns its top and bottom properties
		computeSegVerticals: function(segs) {
			var i, seg;
	
			for (i = 0; i < segs.length; i++) {
				seg = segs[i];
				seg.top = this.computeDateTop(seg.start, seg.start);
				seg.bottom = this.computeDateTop(seg.end, seg.start);
			}
		},
	
	
		// Given segments that already have their top/bottom properties computed, applies those values to
		// the segments' elements.
		assignSegVerticals: function(segs) {
			var i, seg;
	
			for (i = 0; i < segs.length; i++) {
				seg = segs[i];
				seg.el.css(this.generateSegVerticalCss(seg));
			}
		},
	
	
		// Generates an object with CSS properties for the top/bottom coordinates of a segment element
		generateSegVerticalCss: function(seg) {
			return {
				top: seg.top,
				bottom: -seg.bottom // flipped because needs to be space beyond bottom edge of event container
			};
		},
	
	
		/* Foreground Event Positioning Utils
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Given segments that are assumed to all live in the *same column*,
		// compute their verical/horizontal coordinates and assign to their elements.
		updateFgSegCoords: function(segs) {
			this.computeSegVerticals(segs); // horizontals relies on this
			this.computeFgSegHorizontals(segs); // compute horizontal coordinates, z-index's, and reorder the array
			this.assignSegVerticals(segs);
			this.assignFgSegHorizontals(segs);
		},
	
	
		// Given an array of segments that are all in the same column, sets the backwardCoord and forwardCoord on each.
		// NOTE: Also reorders the given array by date!
		computeFgSegHorizontals: function(segs) {
			var levels;
			var level0;
			var i;
	
			this.sortEventSegs(segs); // order by certain criteria
			levels = buildSlotSegLevels(segs);
			computeForwardSlotSegs(levels);
	
			if ((level0 = levels[0])) {
	
				for (i = 0; i < level0.length; i++) {
					computeSlotSegPressures(level0[i]);
				}
	
				for (i = 0; i < level0.length; i++) {
					this.computeFgSegForwardBack(level0[i], 0, 0);
				}
			}
		},
	
	
		// Calculate seg.forwardCoord and seg.backwardCoord for the segment, where both values range
		// from 0 to 1. If the calendar is left-to-right, the seg.backwardCoord maps to "left" and
		// seg.forwardCoord maps to "right" (via percentage). Vice-versa if the calendar is right-to-left.
		//
		// The segment might be part of a "series", which means consecutive segments with the same pressure
		// who's width is unknown until an edge has been hit. `seriesBackwardPressure` is the number of
		// segments behind this one in the current series, and `seriesBackwardCoord` is the starting
		// coordinate of the first segment in the series.
		computeFgSegForwardBack: function(seg, seriesBackwardPressure, seriesBackwardCoord) {
			var forwardSegs = seg.forwardSegs;
			var i;
	
			if (seg.forwardCoord === undefined) { // not already computed
	
				if (!forwardSegs.length) {
	
					// if there are no forward segments, this segment should butt up against the edge
					seg.forwardCoord = 1;
				}
				else {
	
					// sort highest pressure first
					this.sortForwardSegs(forwardSegs);
	
					// this segment's forwardCoord will be calculated from the backwardCoord of the
					// highest-pressure forward segment.
					this.computeFgSegForwardBack(forwardSegs[0], seriesBackwardPressure + 1, seriesBackwardCoord);
					seg.forwardCoord = forwardSegs[0].backwardCoord;
				}
	
				// calculate the backwardCoord from the forwardCoord. consider the series
				seg.backwardCoord = seg.forwardCoord -
					(seg.forwardCoord - seriesBackwardCoord) / // available width for series
					(seriesBackwardPressure + 1); // # of segments in the series
	
				// use this segment's coordinates to computed the coordinates of the less-pressurized
				// forward segments
				for (i=0; i<forwardSegs.length; i++) {
					this.computeFgSegForwardBack(forwardSegs[i], 0, seg.forwardCoord);
				}
			}
		},
	
	
		sortForwardSegs: function(forwardSegs) {
			forwardSegs.sort(proxy(this, 'compareForwardSegs'));
		},
	
	
		// A cmp function for determining which forward segment to rely on more when computing coordinates.
		compareForwardSegs: function(seg1, seg2) {
			// put higher-pressure first
			return seg2.forwardPressure - seg1.forwardPressure ||
				// put segments that are closer to initial edge first (and favor ones with no coords yet)
				(seg1.backwardCoord || 0) - (seg2.backwardCoord || 0) ||
				// do normal sorting...
				this.compareEventSegs(seg1, seg2);
		},
	
	
		// Given foreground event segments that have already had their position coordinates computed,
		// assigns position-related CSS values to their elements.
		assignFgSegHorizontals: function(segs) {
			var i, seg;
	
			for (i = 0; i < segs.length; i++) {
				seg = segs[i];
				seg.el.css(this.generateFgSegHorizontalCss(seg));
	
				// if the height is short, add a className for alternate styling
				if (seg.bottom - seg.top < 30) {
					seg.el.addClass('fc-short');
				}
			}
		},
	
	
		// Generates an object with CSS properties/values that should be applied to an event segment element.
		// Contains important positioning-related properties that should be applied to any event element, customized or not.
		generateFgSegHorizontalCss: function(seg) {
			var shouldOverlap = this.view.opt('slotEventOverlap');
			var backwardCoord = seg.backwardCoord; // the left side if LTR. the right side if RTL. floating-point
			var forwardCoord = seg.forwardCoord; // the right side if LTR. the left side if RTL. floating-point
			var props = this.generateSegVerticalCss(seg); // get top/bottom first
			var left; // amount of space from left edge, a fraction of the total width
			var right; // amount of space from right edge, a fraction of the total width
	
			if (shouldOverlap) {
				// double the width, but don't go beyond the maximum forward coordinate (1.0)
				forwardCoord = Math.min(1, backwardCoord + (forwardCoord - backwardCoord) * 2);
			}
	
			if (this.isRTL) {
				left = 1 - forwardCoord;
				right = backwardCoord;
			}
			else {
				left = backwardCoord;
				right = 1 - forwardCoord;
			}
	
			props.zIndex = seg.level + 1; // convert from 0-base to 1-based
			props.left = left * 100 + '%';
			props.right = right * 100 + '%';
	
			if (shouldOverlap && seg.forwardPressure) {
				// add padding to the edge so that forward stacked events don't cover the resizer's icon
				props[this.isRTL ? 'marginLeft' : 'marginRight'] = 10 * 2; // 10 is a guesstimate of the icon's width
			}
	
			return props;
		}
	
	});
	
	
	// Builds an array of segments "levels". The first level will be the leftmost tier of segments if the calendar is
	// left-to-right, or the rightmost if the calendar is right-to-left. Assumes the segments are already ordered by date.
	function buildSlotSegLevels(segs) {
		var levels = [];
		var i, seg;
		var j;
	
		for (i=0; i<segs.length; i++) {
			seg = segs[i];
	
			// go through all the levels and stop on the first level where there are no collisions
			for (j=0; j<levels.length; j++) {
				if (!computeSlotSegCollisions(seg, levels[j]).length) {
					break;
				}
			}
	
			seg.level = j;
	
			(levels[j] || (levels[j] = [])).push(seg);
		}
	
		return levels;
	}
	
	
	// For every segment, figure out the other segments that are in subsequent
	// levels that also occupy the same vertical space. Accumulate in seg.forwardSegs
	function computeForwardSlotSegs(levels) {
		var i, level;
		var j, seg;
		var k;
	
		for (i=0; i<levels.length; i++) {
			level = levels[i];
	
			for (j=0; j<level.length; j++) {
				seg = level[j];
	
				seg.forwardSegs = [];
				for (k=i+1; k<levels.length; k++) {
					computeSlotSegCollisions(seg, levels[k], seg.forwardSegs);
				}
			}
		}
	}
	
	
	// Figure out which path forward (via seg.forwardSegs) results in the longest path until
	// the furthest edge is reached. The number of segments in this path will be seg.forwardPressure
	function computeSlotSegPressures(seg) {
		var forwardSegs = seg.forwardSegs;
		var forwardPressure = 0;
		var i, forwardSeg;
	
		if (seg.forwardPressure === undefined) { // not already computed
	
			for (i=0; i<forwardSegs.length; i++) {
				forwardSeg = forwardSegs[i];
	
				// figure out the child's maximum forward path
				computeSlotSegPressures(forwardSeg);
	
				// either use the existing maximum, or use the child's forward pressure
				// plus one (for the forwardSeg itself)
				forwardPressure = Math.max(
					forwardPressure,
					1 + forwardSeg.forwardPressure
				);
			}
	
			seg.forwardPressure = forwardPressure;
		}
	}
	
	
	// Find all the segments in `otherSegs` that vertically collide with `seg`.
	// Append into an optionally-supplied `results` array and return.
	function computeSlotSegCollisions(seg, otherSegs, results) {
		results = results || [];
	
		for (var i=0; i<otherSegs.length; i++) {
			if (isSlotSegCollision(seg, otherSegs[i])) {
				results.push(otherSegs[i]);
			}
		}
	
		return results;
	}
	
	
	// Do these segments occupy the same vertical space?
	function isSlotSegCollision(seg1, seg2) {
		return seg1.bottom > seg2.top && seg1.top < seg2.bottom;
	}
	
	;;
	
	/* An abstract class from which other views inherit from
	----------------------------------------------------------------------------------------------------------------------*/
	
	var View = FC.View = Class.extend(EmitterMixin, ListenerMixin, {
	
		type: null, // subclass' view name (string)
		name: null, // deprecated. use `type` instead
		title: null, // the text that will be displayed in the header's title
	
		calendar: null, // owner Calendar object
		options: null, // hash containing all options. already merged with view-specific-options
		el: null, // the view's containing element. set by Calendar
	
		isDateSet: false,
		isDateRendered: false,
		dateRenderQueue: null,
	
		isEventsBound: false,
		isEventsSet: false,
		isEventsRendered: false,
		eventRenderQueue: null,
	
		// range the view is actually displaying (moments)
		start: null,
		end: null, // exclusive
	
		// range the view is formally responsible for (moments)
		// may be different from start/end. for example, a month view might have 1st-31st, excluding padded dates
		intervalStart: null,
		intervalEnd: null, // exclusive
		intervalDuration: null,
		intervalUnit: null, // name of largest unit being displayed, like "month" or "week"
	
		isRTL: false,
		isSelected: false, // boolean whether a range of time is user-selected or not
		selectedEvent: null,
	
		eventOrderSpecs: null, // criteria for ordering events when they have same date/time
	
		// classNames styled by jqui themes
		widgetHeaderClass: null,
		widgetContentClass: null,
		highlightStateClass: null,
	
		// for date utils, computed from options
		nextDayThreshold: null,
		isHiddenDayHash: null,
	
		// now indicator
		isNowIndicatorRendered: null,
		initialNowDate: null, // result first getNow call
		initialNowQueriedMs: null, // ms time the getNow was called
		nowIndicatorTimeoutID: null, // for refresh timing of now indicator
		nowIndicatorIntervalID: null, // "
	
	
		constructor: function(calendar, type, options, intervalDuration) {
	
			this.calendar = calendar;
			this.type = this.name = type; // .name is deprecated
			this.options = options;
			this.intervalDuration = intervalDuration || moment.duration(1, 'day');
	
			this.nextDayThreshold = moment.duration(this.opt('nextDayThreshold'));
			this.initThemingProps();
			this.initHiddenDays();
			this.isRTL = this.opt('isRTL');
	
			this.eventOrderSpecs = parseFieldSpecs(this.opt('eventOrder'));
	
			this.dateRenderQueue = new TaskQueue();
			this.eventRenderQueue = new TaskQueue(this.opt('eventRenderWait'));
	
			this.initialize();
		},
	
	
		// A good place for subclasses to initialize member variables
		initialize: function() {
			// subclasses can implement
		},
	
	
		// Retrieves an option with the given name
		opt: function(name) {
			return this.options[name];
		},
	
	
		// Triggers handlers that are view-related. Modifies args before passing to calendar.
		publiclyTrigger: function(name, thisObj) { // arguments beyond thisObj are passed along
			var calendar = this.calendar;
	
			return calendar.publiclyTrigger.apply(
				calendar,
				[name, thisObj || this].concat(
					Array.prototype.slice.call(arguments, 2), // arguments beyond thisObj
					[ this ] // always make the last argument a reference to the view. TODO: deprecate
				)
			);
		},
	
	
		// Returns a proxy of the given promise that will be rejected if the given event fires
		// before the promise resolves.
		rejectOn: function(eventName, promise) {
			var _this = this;
	
			return new Promise(function(resolve, reject) {
				_this.one(eventName, reject);
	
				function cleanup() {
					_this.off(eventName, reject);
				}
	
				promise.then(function(res) { // success
					cleanup();
					resolve(res);
				}, function() { // failure
					cleanup();
					reject();
				});
			});
		},
	
	
		/* Date Computation
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Updates all internal dates for displaying the given unzoned range.
		setRange: function(range) {
			$.extend(this, range); // assigns every property to this object's member variables
			this.updateTitle();
		},
	
	
		// Given a single current unzoned date, produce information about what range to display.
		// Subclasses can override. Must return all properties.
		computeRange: function(date) {
			var intervalUnit = computeIntervalUnit(this.intervalDuration);
			var intervalStart = date.clone().startOf(intervalUnit);
			var intervalEnd = intervalStart.clone().add(this.intervalDuration);
			var start, end;
	
			// normalize the range's time-ambiguity
			if (/year|month|week|day/.test(intervalUnit)) { // whole-days?
				intervalStart.stripTime();
				intervalEnd.stripTime();
			}
			else { // needs to have a time?
				if (!intervalStart.hasTime()) {
					intervalStart = this.calendar.time(0); // give 00:00 time
				}
				if (!intervalEnd.hasTime()) {
					intervalEnd = this.calendar.time(0); // give 00:00 time
				}
			}
	
			start = intervalStart.clone();
			start = this.skipHiddenDays(start);
			end = intervalEnd.clone();
			end = this.skipHiddenDays(end, -1, true); // exclusively move backwards
	
			return {
				intervalUnit: intervalUnit,
				intervalStart: intervalStart,
				intervalEnd: intervalEnd,
				start: start,
				end: end
			};
		},
	
	
		// Computes the new date when the user hits the prev button, given the current date
		computePrevDate: function(date) {
			return this.massageCurrentDate(
				date.clone().startOf(this.intervalUnit).subtract(this.intervalDuration), -1
			);
		},
	
	
		// Computes the new date when the user hits the next button, given the current date
		computeNextDate: function(date) {
			return this.massageCurrentDate(
				date.clone().startOf(this.intervalUnit).add(this.intervalDuration)
			);
		},
	
	
		// Given an arbitrarily calculated current date of the calendar, returns a date that is ensured to be completely
		// visible. `direction` is optional and indicates which direction the current date was being
		// incremented or decremented (1 or -1).
		massageCurrentDate: function(date, direction) {
			if (this.intervalDuration.as('days') <= 1) { // if the view displays a single day or smaller
				if (this.isHiddenDay(date)) {
					date = this.skipHiddenDays(date, direction);
					date.startOf('day');
				}
			}
	
			return date;
		},
	
	
		/* Title and Date Formatting
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Sets the view's title property to the most updated computed value
		updateTitle: function() {
			this.title = this.computeTitle();
			this.calendar.setToolbarsTitle(this.title);
		},
	
	
		// Computes what the title at the top of the calendar should be for this view
		computeTitle: function() {
			return this.formatRange(
				{
					// in case intervalStart/End has a time, make sure timezone is correct
					start: this.calendar.applyTimezone(this.intervalStart),
					end: this.calendar.applyTimezone(this.intervalEnd)
				},
				this.opt('titleFormat') || this.computeTitleFormat(),
				this.opt('titleRangeSeparator')
			);
		},
	
	
		// Generates the format string that should be used to generate the title for the current date range.
		// Attempts to compute the most appropriate format if not explicitly specified with `titleFormat`.
		computeTitleFormat: function() {
			if (this.intervalUnit == 'year') {
				return 'YYYY';
			}
			else if (this.intervalUnit == 'month') {
				return this.opt('monthYearFormat'); // like "September 2014"
			}
			else if (this.intervalDuration.as('days') > 1) {
				return 'll'; // multi-day range. shorter, like "Sep 9 - 10 2014"
			}
			else {
				return 'LL'; // one day. longer, like "September 9 2014"
			}
		},
	
	
		// Utility for formatting a range. Accepts a range object, formatting string, and optional separator.
		// Displays all-day ranges naturally, with an inclusive end. Takes the current isRTL into account.
		// The timezones of the dates within `range` will be respected.
		formatRange: function(range, formatStr, separator) {
			var end = range.end;
	
			if (!end.hasTime()) { // all-day?
				end = end.clone().subtract(1); // convert to inclusive. last ms of previous day
			}
	
			return formatRange(range.start, end, formatStr, separator, this.opt('isRTL'));
		},
	
	
		getAllDayHtml: function() {
			return this.opt('allDayHtml') || htmlEscape(this.opt('allDayText'));
		},
	
	
		/* Navigation
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Generates HTML for an anchor to another view into the calendar.
		// Will either generate an <a> tag or a non-clickable <span> tag, depending on enabled settings.
		// `gotoOptions` can either be a moment input, or an object with the form:
		// { date, type, forceOff }
		// `type` is a view-type like "day" or "week". default value is "day".
		// `attrs` and `innerHtml` are use to generate the rest of the HTML tag.
		buildGotoAnchorHtml: function(gotoOptions, attrs, innerHtml) {
			var date, type, forceOff;
			var finalOptions;
	
			if ($.isPlainObject(gotoOptions)) {
				date = gotoOptions.date;
				type = gotoOptions.type;
				forceOff = gotoOptions.forceOff;
			}
			else {
				date = gotoOptions; // a single moment input
			}
			date = FC.moment(date); // if a string, parse it
	
			finalOptions = { // for serialization into the link
				date: date.format('YYYY-MM-DD'),
				type: type || 'day'
			};
	
			if (typeof attrs === 'string') {
				innerHtml = attrs;
				attrs = null;
			}
	
			attrs = attrs ? ' ' + attrsToStr(attrs) : ''; // will have a leading space
			innerHtml = innerHtml || '';
	
			if (!forceOff && this.opt('navLinks')) {
				return '<a' + attrs +
					' data-goto="' + htmlEscape(JSON.stringify(finalOptions)) + '">' +
					innerHtml +
					'</a>';
			}
			else {
				return '<span' + attrs + '>' +
					innerHtml +
					'</span>';
			}
		},
	
	
		// Rendering Non-date-related Content
		// -----------------------------------------------------------------------------------------------------------------
	
	
		// Sets the container element that the view should render inside of, does global DOM-related initializations,
		// and renders all the non-date-related content inside.
		setElement: function(el) {
			this.el = el;
			this.bindGlobalHandlers();
			this.renderSkeleton();
		},
	
	
		// Removes the view's container element from the DOM, clearing any content beforehand.
		// Undoes any other DOM-related attachments.
		removeElement: function() {
			this.unsetDate();
			this.unrenderSkeleton();
	
			this.unbindGlobalHandlers();
	
			this.el.remove();
			// NOTE: don't null-out this.el in case the View was destroyed within an API callback.
			// We don't null-out the View's other jQuery element references upon destroy,
			//  so we shouldn't kill this.el either.
		},
	
	
		// Renders the basic structure of the view before any content is rendered
		renderSkeleton: function() {
			// subclasses should implement
		},
	
	
		// Unrenders the basic structure of the view
		unrenderSkeleton: function() {
			// subclasses should implement
		},
	
	
		// Date Setting/Unsetting
		// -----------------------------------------------------------------------------------------------------------------
	
	
		setDate: function(date) {
			var isReset = this.isDateSet;
	
			this.isDateSet = true;
			this.handleDate(date, isReset);
			this.trigger(isReset ? 'dateReset' : 'dateSet', date);
		},
	
	
		unsetDate: function() {
			if (this.isDateSet) {
				this.isDateSet = false;
				this.handleDateUnset();
				this.trigger('dateUnset');
			}
		},
	
	
		// Date Handling
		// -----------------------------------------------------------------------------------------------------------------
	
	
		handleDate: function(date, isReset) {
			var _this = this;
	
			this.unbindEvents(); // will do nothing if not already bound
			this.requestDateRender(date).then(function() {
				// wish we could start earlier, but setRange/computeRange needs to execute first
				_this.bindEvents(); // will request events
			});
		},
	
	
		handleDateUnset: function() {
			this.unbindEvents();
			this.requestDateUnrender();
		},
	
	
		// Date Render Queuing
		// -----------------------------------------------------------------------------------------------------------------
	
	
		// if date not specified, uses current
		requestDateRender: function(date) {
			var _this = this;
	
			return this.dateRenderQueue.add(function() {
				return _this.executeDateRender(date);
			});
		},
	
	
		requestDateUnrender: function() {
			var _this = this;
	
			return this.dateRenderQueue.add(function() {
				return _this.executeDateUnrender();
			});
		},
	
	
		// Date High-level Rendering
		// -----------------------------------------------------------------------------------------------------------------
	
	
		// if date not specified, uses current
		executeDateRender: function(date) {
			var _this = this;
	
			// if rendering a new date, reset scroll to initial state (scrollTime)
			if (date) {
				this.captureInitialScroll();
			}
			else {
				this.captureScroll(); // a rerender of the current date
			}
	
			this.freezeHeight();
	
			return this.executeDateUnrender().then(function() {
	
				if (date) {
					_this.setRange(_this.computeRange(date));
				}
	
				if (_this.render) {
					_this.render(); // TODO: deprecate
				}
	
				_this.renderDates();
				_this.updateSize();
				_this.renderBusinessHours(); // might need coordinates, so should go after updateSize()
				_this.startNowIndicator();
	
				_this.thawHeight();
				_this.releaseScroll();
	
				_this.isDateRendered = true;
				_this.onDateRender();
				_this.trigger('dateRender');
			});
		},
	
	
		executeDateUnrender: function() {
			var _this = this;
	
			if (_this.isDateRendered) {
				return this.requestEventsUnrender().then(function() {
	
					_this.unselect();
					_this.stopNowIndicator();
					_this.triggerUnrender();
					_this.unrenderBusinessHours();
					_this.unrenderDates();
	
					if (_this.destroy) {
						_this.destroy(); // TODO: deprecate
					}
	
					_this.isDateRendered = false;
					_this.trigger('dateUnrender');
				});
			}
			else {
				return Promise.resolve();
			}
		},
	
	
		// Date Rendering Triggers
		// -----------------------------------------------------------------------------------------------------------------
	
	
		onDateRender: function() {
			this.triggerRender();
		},
	
	
		// Date Low-level Rendering
		// -----------------------------------------------------------------------------------------------------------------
	
	
		// date-cell content only
		renderDates: function() {
			// subclasses should implement
		},
	
	
		// date-cell content only
		unrenderDates: function() {
			// subclasses should override
		},
	
	
		// Misc view rendering utils
		// -------------------------
	
	
		// Signals that the view's content has been rendered
		triggerRender: function() {
			this.publiclyTrigger('viewRender', this, this, this.el);
		},
	
	
		// Signals that the view's content is about to be unrendered
		triggerUnrender: function() {
			this.publiclyTrigger('viewDestroy', this, this, this.el);
		},
	
	
		// Binds DOM handlers to elements that reside outside the view container, such as the document
		bindGlobalHandlers: function() {
			this.listenTo($(document), 'mousedown', this.handleDocumentMousedown);
			this.listenTo($(document), 'touchstart', this.processUnselect);
		},
	
	
		// Unbinds DOM handlers from elements that reside outside the view container
		unbindGlobalHandlers: function() {
			this.stopListeningTo($(document));
		},
	
	
		// Initializes internal variables related to theming
		initThemingProps: function() {
			var tm = this.opt('theme') ? 'ui' : 'fc';
	
			this.widgetHeaderClass = tm + '-widget-header';
			this.widgetContentClass = tm + '-widget-content';
			this.highlightStateClass = tm + '-state-highlight';
		},
	
	
		/* Business Hours
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Renders business-hours onto the view. Assumes updateSize has already been called.
		renderBusinessHours: function() {
			// subclasses should implement
		},
	
	
		// Unrenders previously-rendered business-hours
		unrenderBusinessHours: function() {
			// subclasses should implement
		},
	
	
		/* Now Indicator
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Immediately render the current time indicator and begins re-rendering it at an interval,
		// which is defined by this.getNowIndicatorUnit().
		// TODO: somehow do this for the current whole day's background too
		startNowIndicator: function() {
			var _this = this;
			var unit;
			var update;
			var delay; // ms wait value
	
			if (this.opt('nowIndicator')) {
				unit = this.getNowIndicatorUnit();
				if (unit) {
					update = proxy(this, 'updateNowIndicator'); // bind to `this`
	
					this.initialNowDate = this.calendar.getNow();
					this.initialNowQueriedMs = +new Date();
					this.renderNowIndicator(this.initialNowDate);
					this.isNowIndicatorRendered = true;
	
					// wait until the beginning of the next interval
					delay = this.initialNowDate.clone().startOf(unit).add(1, unit) - this.initialNowDate;
					this.nowIndicatorTimeoutID = setTimeout(function() {
						_this.nowIndicatorTimeoutID = null;
						update();
						delay = +moment.duration(1, unit);
						delay = Math.max(100, delay); // prevent too frequent
						_this.nowIndicatorIntervalID = setInterval(update, delay); // update every interval
					}, delay);
				}
			}
		},
	
	
		// rerenders the now indicator, computing the new current time from the amount of time that has passed
		// since the initial getNow call.
		updateNowIndicator: function() {
			if (this.isNowIndicatorRendered) {
				this.unrenderNowIndicator();
				this.renderNowIndicator(
					this.initialNowDate.clone().add(new Date() - this.initialNowQueriedMs) // add ms
				);
			}
		},
	
	
		// Immediately unrenders the view's current time indicator and stops any re-rendering timers.
		// Won't cause side effects if indicator isn't rendered.
		stopNowIndicator: function() {
			if (this.isNowIndicatorRendered) {
	
				if (this.nowIndicatorTimeoutID) {
					clearTimeout(this.nowIndicatorTimeoutID);
					this.nowIndicatorTimeoutID = null;
				}
				if (this.nowIndicatorIntervalID) {
					clearTimeout(this.nowIndicatorIntervalID);
					this.nowIndicatorIntervalID = null;
				}
	
				this.unrenderNowIndicator();
				this.isNowIndicatorRendered = false;
			}
		},
	
	
		// Returns a string unit, like 'second' or 'minute' that defined how often the current time indicator
		// should be refreshed. If something falsy is returned, no time indicator is rendered at all.
		getNowIndicatorUnit: function() {
			// subclasses should implement
		},
	
	
		// Renders a current time indicator at the given datetime
		renderNowIndicator: function(date) {
			// subclasses should implement
		},
	
	
		// Undoes the rendering actions from renderNowIndicator
		unrenderNowIndicator: function() {
			// subclasses should implement
		},
	
	
		/* Dimensions
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Refreshes anything dependant upon sizing of the container element of the grid
		updateSize: function(isResize) {
	
			if (isResize) {
				this.captureScroll();
			}
	
			this.updateHeight(isResize);
			this.updateWidth(isResize);
			this.updateNowIndicator();
	
			if (isResize) {
				this.releaseScroll();
			}
		},
	
	
		// Refreshes the horizontal dimensions of the calendar
		updateWidth: function(isResize) {
			// subclasses should implement
		},
	
	
		// Refreshes the vertical dimensions of the calendar
		updateHeight: function(isResize) {
			var calendar = this.calendar; // we poll the calendar for height information
	
			this.setHeight(
				calendar.getSuggestedViewHeight(),
				calendar.isHeightAuto()
			);
		},
	
	
		// Updates the vertical dimensions of the calendar to the specified height.
		// if `isAuto` is set to true, height becomes merely a suggestion and the view should use its "natural" height.
		setHeight: function(height, isAuto) {
			// subclasses should implement
		},
	
	
		/* Scroller
		------------------------------------------------------------------------------------------------------------------*/
	
	
		capturedScroll: null,
		capturedScrollDepth: 0,
	
	
		captureScroll: function() {
			if (!(this.capturedScrollDepth++)) {
				this.capturedScroll = this.isDateRendered ? this.queryScroll() : {}; // require a render first
				return true; // root?
			}
			return false;
		},
	
	
		captureInitialScroll: function(forcedScroll) {
			if (this.captureScroll()) { // root?
				this.capturedScroll.isInitial = true;
	
				if (forcedScroll) {
					$.extend(this.capturedScroll, forcedScroll);
				}
				else {
					this.capturedScroll.isComputed = true;
				}
			}
		},
	
	
		releaseScroll: function() {
			var scroll = this.capturedScroll;
			var isRoot = this.discardScroll();
	
			if (scroll.isComputed) {
				if (isRoot) {
					// only compute initial scroll if it will actually be used (is the root capture)
					$.extend(scroll, this.computeInitialScroll());
				}
				else {
					scroll = null; // scroll couldn't be computed. don't apply it to the DOM
				}
			}
	
			if (scroll) {
				// we act immediately on a releaseScroll operation, as opposed to captureScroll.
				// if capture/release wraps a render operation that screws up the scroll,
				// we still want to restore it a good state after, regardless of depth.
	
				if (scroll.isInitial) {
					this.hardSetScroll(scroll); // outsmart how browsers set scroll on initial DOM
				}
				else {
					this.setScroll(scroll);
				}
			}
		},
	
	
		discardScroll: function() {
			if (!(--this.capturedScrollDepth)) {
				this.capturedScroll = null;
				return true; // root?
			}
			return false;
		},
	
	
		computeInitialScroll: function() {
			return {};
		},
	
	
		queryScroll: function() {
			return {};
		},
	
	
		hardSetScroll: function(scroll) {
			var _this = this;
			var exec = function() { _this.setScroll(scroll); };
			exec();
			setTimeout(exec, 0); // to surely clear the browser's initial scroll for the DOM
		},
	
	
		setScroll: function(scroll) {
		},
	
	
		/* Height Freezing
		------------------------------------------------------------------------------------------------------------------*/
	
	
		freezeHeight: function() {
			this.calendar.freezeContentHeight();
		},
	
	
		thawHeight: function() {
			this.calendar.thawContentHeight();
		},
	
	
		// Event Binding/Unbinding
		// -----------------------------------------------------------------------------------------------------------------
	
	
		bindEvents: function() {
			var _this = this;
	
			if (!this.isEventsBound) {
				this.isEventsBound = true;
				this.rejectOn('eventsUnbind', this.requestEvents()).then(function(events) { // TODO: test rejection
					_this.listenTo(_this.calendar, 'eventsReset', _this.setEvents);
					_this.setEvents(events);
				});
			}
		},
	
	
		unbindEvents: function() {
			if (this.isEventsBound) {
				this.isEventsBound = false;
				this.stopListeningTo(this.calendar, 'eventsReset');
				this.unsetEvents();
				this.trigger('eventsUnbind');
			}
		},
	
	
		// Event Setting/Unsetting
		// -----------------------------------------------------------------------------------------------------------------
	
	
		setEvents: function(events) {
			var isReset = this.isEventSet;
	
			this.isEventsSet = true;
			this.handleEvents(events, isReset);
			this.trigger(isReset ? 'eventsReset' : 'eventsSet', events);
		},
	
	
		unsetEvents: function() {
			if (this.isEventsSet) {
				this.isEventsSet = false;
				this.handleEventsUnset();
				this.trigger('eventsUnset');
			}
		},
	
	
		whenEventsSet: function() {
			var _this = this;
	
			if (this.isEventsSet) {
				return Promise.resolve(this.getCurrentEvents());
			}
			else {
				return new Promise(function(resolve) {
					_this.one('eventsSet', resolve);
				});
			}
		},
	
	
		// Event Handling
		// -----------------------------------------------------------------------------------------------------------------
	
	
		handleEvents: function(events, isReset) {
			this.requestEventsRender(events);
		},
	
	
		handleEventsUnset: function() {
			this.requestEventsUnrender();
		},
	
	
		// Event Render Queuing
		// -----------------------------------------------------------------------------------------------------------------
	
	
		// assumes any previous event renders have been cleared already
		requestEventsRender: function(events) {
			var _this = this;
	
			return this.eventRenderQueue.add(function() { // might not return a promise if debounced!? bad
				return _this.executeEventsRender(events);
			});
		},
	
	
		requestEventsUnrender: function() {
			var _this = this;
	
			if (this.isEventsRendered) {
				return this.eventRenderQueue.addQuickly(function() {
					return _this.executeEventsUnrender();
				});
			}
			else {
				return Promise.resolve();
			}
		},
	
	
		requestCurrentEventsRender: function() {
			if (this.isEventsSet) {
				this.requestEventsRender(this.getCurrentEvents());
			}
			else {
				return Promise.reject();
			}
		},
	
	
		// Event High-level Rendering
		// -----------------------------------------------------------------------------------------------------------------
	
	
		executeEventsRender: function(events) {
			var _this = this;
	
			this.captureScroll();
			this.freezeHeight();
	
			return this.executeEventsUnrender().then(function() {
				_this.renderEvents(events);
	
				_this.thawHeight();
				_this.releaseScroll();
	
				_this.isEventsRendered = true;
				_this.onEventsRender();
				_this.trigger('eventsRender');
			});
		},
	
	
		executeEventsUnrender: function() {
			if (this.isEventsRendered) {
				this.onBeforeEventsUnrender();
	
				this.captureScroll();
				this.freezeHeight();
	
				if (this.destroyEvents) {
					this.destroyEvents(); // TODO: deprecate
				}
	
				this.unrenderEvents();
	
				this.thawHeight();
				this.releaseScroll();
	
				this.isEventsRendered = false;
				this.trigger('eventsUnrender');
			}
	
			return Promise.resolve(); // always synchronous
		},
	
	
		// Event Rendering Triggers
		// -----------------------------------------------------------------------------------------------------------------
	
	
		// Signals that all events have been rendered
		onEventsRender: function() {
			this.renderedEventSegEach(function(seg) {
				this.publiclyTrigger('eventAfterRender', seg.event, seg.event, seg.el);
			});
			this.publiclyTrigger('eventAfterAllRender');
		},
	
	
		// Signals that all event elements are about to be removed
		onBeforeEventsUnrender: function() {
			this.renderedEventSegEach(function(seg) {
				this.publiclyTrigger('eventDestroy', seg.event, seg.event, seg.el);
			});
		},
	
	
		// Event Low-level Rendering
		// -----------------------------------------------------------------------------------------------------------------
	
	
		// Renders the events onto the view.
		renderEvents: function(events) {
			// subclasses should implement
		},
	
	
		// Removes event elements from the view.
		unrenderEvents: function() {
			// subclasses should implement
		},
	
	
		// Event Data Access
		// -----------------------------------------------------------------------------------------------------------------
	
	
		requestEvents: function() {
			return this.calendar.requestEvents(this.start, this.end);
		},
	
	
		getCurrentEvents: function() {
			return this.calendar.getPrunedEventCache();
		},
	
	
		// Event Rendering Utils
		// -----------------------------------------------------------------------------------------------------------------
	
	
		// Given an event and the default element used for rendering, returns the element that should actually be used.
		// Basically runs events and elements through the eventRender hook.
		resolveEventEl: function(event, el) {
			var custom = this.publiclyTrigger('eventRender', event, event, el);
	
			if (custom === false) { // means don't render at all
				el = null;
			}
			else if (custom && custom !== true) {
				el = $(custom);
			}
	
			return el;
		},
	
	
		// Hides all rendered event segments linked to the given event
		showEvent: function(event) {
			this.renderedEventSegEach(function(seg) {
				seg.el.css('visibility', '');
			}, event);
		},
	
	
		// Shows all rendered event segments linked to the given event
		hideEvent: function(event) {
			this.renderedEventSegEach(function(seg) {
				seg.el.css('visibility', 'hidden');
			}, event);
		},
	
	
		// Iterates through event segments that have been rendered (have an el). Goes through all by default.
		// If the optional `event` argument is specified, only iterates through segments linked to that event.
		// The `this` value of the callback function will be the view.
		renderedEventSegEach: function(func, event) {
			var segs = this.getEventSegs();
			var i;
	
			for (i = 0; i < segs.length; i++) {
				if (!event || segs[i].event._id === event._id) {
					if (segs[i].el) {
						func.call(this, segs[i]);
					}
				}
			}
		},
	
	
		// Retrieves all the rendered segment objects for the view
		getEventSegs: function() {
			// subclasses must implement
			return [];
		},
	
	
		/* Event Drag-n-Drop
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Computes if the given event is allowed to be dragged by the user
		isEventDraggable: function(event) {
			return this.isEventStartEditable(event);
		},
	
	
		isEventStartEditable: function(event) {
			return firstDefined(
				event.startEditable,
				(event.source || {}).startEditable,
				this.opt('eventStartEditable'),
				this.isEventGenerallyEditable(event)
			);
		},
	
	
		isEventGenerallyEditable: function(event) {
			return firstDefined(
				event.editable,
				(event.source || {}).editable,
				this.opt('editable')
			);
		},
	
	
		// Must be called when an event in the view is dropped onto new location.
		// `dropLocation` is an object that contains the new zoned start/end/allDay values for the event.
		reportEventDrop: function(event, dropLocation, largeUnit, el, ev) {
			var calendar = this.calendar;
			var mutateResult = calendar.mutateEvent(event, dropLocation, largeUnit);
			var undoFunc = function() {
				mutateResult.undo();
				calendar.reportEventChange();
			};
	
			this.triggerEventDrop(event, mutateResult.dateDelta, undoFunc, el, ev);
			calendar.reportEventChange(); // will rerender events
		},
	
	
		// Triggers event-drop handlers that have subscribed via the API
		triggerEventDrop: function(event, dateDelta, undoFunc, el, ev) {
			this.publiclyTrigger('eventDrop', el[0], event, dateDelta, undoFunc, ev, {}); // {} = jqui dummy
		},
	
	
		/* External Element Drag-n-Drop
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Must be called when an external element, via jQuery UI, has been dropped onto the calendar.
		// `meta` is the parsed data that has been embedded into the dragging event.
		// `dropLocation` is an object that contains the new zoned start/end/allDay values for the event.
		reportExternalDrop: function(meta, dropLocation, el, ev, ui) {
			var eventProps = meta.eventProps;
			var eventInput;
			var event;
	
			// Try to build an event object and render it. TODO: decouple the two
			if (eventProps) {
				eventInput = $.extend({}, eventProps, dropLocation);
				event = this.calendar.renderEvent(eventInput, meta.stick)[0]; // renderEvent returns an array
			}
	
			this.triggerExternalDrop(event, dropLocation, el, ev, ui);
		},
	
	
		// Triggers external-drop handlers that have subscribed via the API
		triggerExternalDrop: function(event, dropLocation, el, ev, ui) {
	
			// trigger 'drop' regardless of whether element represents an event
			this.publiclyTrigger('drop', el[0], dropLocation.start, ev, ui);
	
			if (event) {
				this.publiclyTrigger('eventReceive', null, event); // signal an external event landed
			}
		},
	
	
		/* Drag-n-Drop Rendering (for both events and external elements)
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Renders a visual indication of a event or external-element drag over the given drop zone.
		// If an external-element, seg will be `null`.
		// Must return elements used for any mock events.
		renderDrag: function(dropLocation, seg) {
			// subclasses must implement
		},
	
	
		// Unrenders a visual indication of an event or external-element being dragged.
		unrenderDrag: function() {
			// subclasses must implement
		},
	
	
		/* Event Resizing
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Computes if the given event is allowed to be resized from its starting edge
		isEventResizableFromStart: function(event) {
			return this.opt('eventResizableFromStart') && this.isEventResizable(event);
		},
	
	
		// Computes if the given event is allowed to be resized from its ending edge
		isEventResizableFromEnd: function(event) {
			return this.isEventResizable(event);
		},
	
	
		// Computes if the given event is allowed to be resized by the user at all
		isEventResizable: function(event) {
			var source = event.source || {};
	
			return firstDefined(
				event.durationEditable,
				source.durationEditable,
				this.opt('eventDurationEditable'),
				event.editable,
				source.editable,
				this.opt('editable')
			);
		},
	
	
		// Must be called when an event in the view has been resized to a new length
		reportEventResize: function(event, resizeLocation, largeUnit, el, ev) {
			var calendar = this.calendar;
			var mutateResult = calendar.mutateEvent(event, resizeLocation, largeUnit);
			var undoFunc = function() {
				mutateResult.undo();
				calendar.reportEventChange();
			};
	
			this.triggerEventResize(event, mutateResult.durationDelta, undoFunc, el, ev);
			calendar.reportEventChange(); // will rerender events
		},
	
	
		// Triggers event-resize handlers that have subscribed via the API
		triggerEventResize: function(event, durationDelta, undoFunc, el, ev) {
			this.publiclyTrigger('eventResize', el[0], event, durationDelta, undoFunc, ev, {}); // {} = jqui dummy
		},
	
	
		/* Selection (time range)
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Selects a date span on the view. `start` and `end` are both Moments.
		// `ev` is the native mouse event that begin the interaction.
		select: function(span, ev) {
			this.unselect(ev);
			this.renderSelection(span);
			this.reportSelection(span, ev);
		},
	
	
		// Renders a visual indication of the selection
		renderSelection: function(span) {
			// subclasses should implement
		},
	
	
		// Called when a new selection is made. Updates internal state and triggers handlers.
		reportSelection: function(span, ev) {
			this.isSelected = true;
			this.triggerSelect(span, ev);
		},
	
	
		// Triggers handlers to 'select'
		triggerSelect: function(span, ev) {
			this.publiclyTrigger(
				'select',
				null,
				this.calendar.applyTimezone(span.start), // convert to calendar's tz for external API
				this.calendar.applyTimezone(span.end), // "
				ev
			);
		},
	
	
		// Undoes a selection. updates in the internal state and triggers handlers.
		// `ev` is the native mouse event that began the interaction.
		unselect: function(ev) {
			if (this.isSelected) {
				this.isSelected = false;
				if (this.destroySelection) {
					this.destroySelection(); // TODO: deprecate
				}
				this.unrenderSelection();
				this.publiclyTrigger('unselect', null, ev);
			}
		},
	
	
		// Unrenders a visual indication of selection
		unrenderSelection: function() {
			// subclasses should implement
		},
	
	
		/* Event Selection
		------------------------------------------------------------------------------------------------------------------*/
	
	
		selectEvent: function(event) {
			if (!this.selectedEvent || this.selectedEvent !== event) {
				this.unselectEvent();
				this.renderedEventSegEach(function(seg) {
					seg.el.addClass('fc-selected');
				}, event);
				this.selectedEvent = event;
			}
		},
	
	
		unselectEvent: function() {
			if (this.selectedEvent) {
				this.renderedEventSegEach(function(seg) {
					seg.el.removeClass('fc-selected');
				}, this.selectedEvent);
				this.selectedEvent = null;
			}
		},
	
	
		isEventSelected: function(event) {
			// event references might change on refetchEvents(), while selectedEvent doesn't,
			// so compare IDs
			return this.selectedEvent && this.selectedEvent._id === event._id;
		},
	
	
		/* Mouse / Touch Unselecting (time range & event unselection)
		------------------------------------------------------------------------------------------------------------------*/
		// TODO: move consistently to down/start or up/end?
		// TODO: don't kill previous selection if touch scrolling
	
	
		handleDocumentMousedown: function(ev) {
			if (isPrimaryMouseButton(ev)) {
				this.processUnselect(ev);
			}
		},
	
	
		processUnselect: function(ev) {
			this.processRangeUnselect(ev);
			this.processEventUnselect(ev);
		},
	
	
		processRangeUnselect: function(ev) {
			var ignore;
	
			// is there a time-range selection?
			if (this.isSelected && this.opt('unselectAuto')) {
				// only unselect if the clicked element is not identical to or inside of an 'unselectCancel' element
				ignore = this.opt('unselectCancel');
				if (!ignore || !$(ev.target).closest(ignore).length) {
					this.unselect(ev);
				}
			}
		},
	
	
		processEventUnselect: function(ev) {
			if (this.selectedEvent) {
				if (!$(ev.target).closest('.fc-selected').length) {
					this.unselectEvent();
				}
			}
		},
	
	
		/* Day Click
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Triggers handlers to 'dayClick'
		// Span has start/end of the clicked area. Only the start is useful.
		triggerDayClick: function(span, dayEl, ev) {
			this.publiclyTrigger(
				'dayClick',
				dayEl,
				this.calendar.applyTimezone(span.start), // convert to calendar's timezone for external API
				ev
			);
		},
	
	
		/* Date Utils
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Initializes internal variables related to calculating hidden days-of-week
		initHiddenDays: function() {
			var hiddenDays = this.opt('hiddenDays') || []; // array of day-of-week indices that are hidden
			var isHiddenDayHash = []; // is the day-of-week hidden? (hash with day-of-week-index -> bool)
			var dayCnt = 0;
			var i;
	
			if (this.opt('weekends') === false) {
				hiddenDays.push(0, 6); // 0=sunday, 6=saturday
			}
	
			for (i = 0; i < 7; i++) {
				if (
					!(isHiddenDayHash[i] = $.inArray(i, hiddenDays) !== -1)
				) {
					dayCnt++;
				}
			}
	
			if (!dayCnt) {
				throw 'invalid hiddenDays'; // all days were hidden? bad.
			}
	
			this.isHiddenDayHash = isHiddenDayHash;
		},
	
	
		// Is the current day hidden?
		// `day` is a day-of-week index (0-6), or a Moment
		isHiddenDay: function(day) {
			if (moment.isMoment(day)) {
				day = day.day();
			}
			return this.isHiddenDayHash[day];
		},
	
	
		// Incrementing the current day until it is no longer a hidden day, returning a copy.
		// If the initial value of `date` is not a hidden day, don't do anything.
		// Pass `isExclusive` as `true` if you are dealing with an end date.
		// `inc` defaults to `1` (increment one day forward each time)
		skipHiddenDays: function(date, inc, isExclusive) {
			var out = date.clone();
			inc = inc || 1;
			while (
				this.isHiddenDayHash[(out.day() + (isExclusive ? inc : 0) + 7) % 7]
			) {
				out.add(inc, 'days');
			}
			return out;
		},
	
	
		// Returns the date range of the full days the given range visually appears to occupy.
		// Returns a new range object.
		computeDayRange: function(range) {
			var startDay = range.start.clone().stripTime(); // the beginning of the day the range starts
			var end = range.end;
			var endDay = null;
			var endTimeMS;
	
			if (end) {
				endDay = end.clone().stripTime(); // the beginning of the day the range exclusively ends
				endTimeMS = +end.time(); // # of milliseconds into `endDay`
	
				// If the end time is actually inclusively part of the next day and is equal to or
				// beyond the next day threshold, adjust the end to be the exclusive end of `endDay`.
				// Otherwise, leaving it as inclusive will cause it to exclude `endDay`.
				if (endTimeMS && endTimeMS >= this.nextDayThreshold) {
					endDay.add(1, 'days');
				}
			}
	
			// If no end was specified, or if it is within `startDay` but not past nextDayThreshold,
			// assign the default duration of one day.
			if (!end || endDay <= startDay) {
				endDay = startDay.clone().add(1, 'days');
			}
	
			return { start: startDay, end: endDay };
		},
	
	
		// Does the given event visually appear to occupy more than one day?
		isMultiDayEvent: function(event) {
			var range = this.computeDayRange(event); // event is range-ish
	
			return range.end.diff(range.start, 'days') > 1;
		}
	
	});
	
	;;
	
	/*
	Embodies a div that has potential scrollbars
	*/
	var Scroller = FC.Scroller = Class.extend({
	
		el: null, // the guaranteed outer element
		scrollEl: null, // the element with the scrollbars
		overflowX: null,
		overflowY: null,
	
	
		constructor: function(options) {
			options = options || {};
			this.overflowX = options.overflowX || options.overflow || 'auto';
			this.overflowY = options.overflowY || options.overflow || 'auto';
		},
	
	
		render: function() {
			this.el = this.renderEl();
			this.applyOverflow();
		},
	
	
		renderEl: function() {
			return (this.scrollEl = $('<div class="fc-scroller"></div>'));
		},
	
	
		// sets to natural height, unlocks overflow
		clear: function() {
			this.setHeight('auto');
			this.applyOverflow();
		},
	
	
		destroy: function() {
			this.el.remove();
		},
	
	
		// Overflow
		// -----------------------------------------------------------------------------------------------------------------
	
	
		applyOverflow: function() {
			this.scrollEl.css({
				'overflow-x': this.overflowX,
				'overflow-y': this.overflowY
			});
		},
	
	
		// Causes any 'auto' overflow values to resolves to 'scroll' or 'hidden'.
		// Useful for preserving scrollbar widths regardless of future resizes.
		// Can pass in scrollbarWidths for optimization.
		lockOverflow: function(scrollbarWidths) {
			var overflowX = this.overflowX;
			var overflowY = this.overflowY;
	
			scrollbarWidths = scrollbarWidths || this.getScrollbarWidths();
	
			if (overflowX === 'auto') {
				overflowX = (
						scrollbarWidths.top || scrollbarWidths.bottom || // horizontal scrollbars?
						// OR scrolling pane with massless scrollbars?
						this.scrollEl[0].scrollWidth - 1 > this.scrollEl[0].clientWidth
							// subtract 1 because of IE off-by-one issue
					) ? 'scroll' : 'hidden';
			}
	
			if (overflowY === 'auto') {
				overflowY = (
						scrollbarWidths.left || scrollbarWidths.right || // vertical scrollbars?
						// OR scrolling pane with massless scrollbars?
						this.scrollEl[0].scrollHeight - 1 > this.scrollEl[0].clientHeight
							// subtract 1 because of IE off-by-one issue
					) ? 'scroll' : 'hidden';
			}
	
			this.scrollEl.css({ 'overflow-x': overflowX, 'overflow-y': overflowY });
		},
	
	
		// Getters / Setters
		// -----------------------------------------------------------------------------------------------------------------
	
	
		setHeight: function(height) {
			this.scrollEl.height(height);
		},
	
	
		getScrollTop: function() {
			return this.scrollEl.scrollTop();
		},
	
	
		setScrollTop: function(top) {
			this.scrollEl.scrollTop(top);
		},
	
	
		getClientWidth: function() {
			return this.scrollEl[0].clientWidth;
		},
	
	
		getClientHeight: function() {
			return this.scrollEl[0].clientHeight;
		},
	
	
		getScrollbarWidths: function() {
			return getScrollbarWidths(this.scrollEl);
		}
	
	});
	
	;;
	function Iterator(items) {
	    this.items = items || [];
	}
	
	
	/* Calls a method on every item passing the arguments through */
	Iterator.prototype.proxyCall = function(methodName) {
	    var args = Array.prototype.slice.call(arguments, 1);
	    var results = [];
	
	    this.items.forEach(function(item) {
	        results.push(item[methodName].apply(item, args));
	    });
	
	    return results;
	};
	
	;;
	
	/* Toolbar with buttons and title
	----------------------------------------------------------------------------------------------------------------------*/
	
	function Toolbar(calendar, toolbarOptions) {
		var t = this;
	
		// exports
		t.setToolbarOptions = setToolbarOptions;
		t.render = render;
		t.removeElement = removeElement;
		t.updateTitle = updateTitle;
		t.activateButton = activateButton;
		t.deactivateButton = deactivateButton;
		t.disableButton = disableButton;
		t.enableButton = enableButton;
		t.getViewsWithButtons = getViewsWithButtons;
		t.el = null; // mirrors local `el`
	
		// locals
		var el;
		var viewsWithButtons = [];
		var tm;
	
		// method to update toolbar-specific options, not calendar-wide options
		function setToolbarOptions(newToolbarOptions) {
			toolbarOptions = newToolbarOptions;
		}
	
		// can be called repeatedly and will rerender
		function render() {
			var sections = toolbarOptions.layout;
	
			tm = calendar.options.theme ? 'ui' : 'fc';
	
			if (sections) {
				if (!el) {
					el = this.el = $("<div class='fc-toolbar "+ toolbarOptions.extraClasses + "'/>");
				}
				else {
					el.empty();
				}
				el.append(renderSection('left'))
					.append(renderSection('right'))
					.append(renderSection('center'))
					.append('<div class="fc-clear"/>');
			}
			else {
				removeElement();
			}
		}
	
	
		function removeElement() {
			if (el) {
				el.remove();
				el = t.el = null;
			}
		}
	
	
		function renderSection(position) {
			var sectionEl = $('<div class="fc-' + position + '"/>');
			var buttonStr = toolbarOptions.layout[position];
	
			if (buttonStr) {
				$.each(buttonStr.split(' '), function(i) {
					var groupChildren = $();
					var isOnlyButtons = true;
					var groupEl;
	
					$.each(this.split(','), function(j, buttonName) {
						var customButtonProps;
						var viewSpec;
						var buttonClick;
						var overrideText; // text explicitly set by calendar's constructor options. overcomes icons
						var defaultText;
						var themeIcon;
						var normalIcon;
						var innerHtml;
						var classes;
						var button; // the element
	
						if (buttonName == 'title') {
							groupChildren = groupChildren.add($('<h2>&nbsp;</h2>')); // we always want it to take up height
							isOnlyButtons = false;
						}
						else {
							if ((customButtonProps = (calendar.options.customButtons || {})[buttonName])) {
								buttonClick = function(ev) {
									if (customButtonProps.click) {
										customButtonProps.click.call(button[0], ev);
									}
								};
								overrideText = ''; // icons will override text
								defaultText = customButtonProps.text;
							}
							else if ((viewSpec = calendar.getViewSpec(buttonName))) {
								buttonClick = function() {
									calendar.changeView(buttonName);
								};
								viewsWithButtons.push(buttonName);
								overrideText = viewSpec.buttonTextOverride;
								defaultText = viewSpec.buttonTextDefault;
							}
							else if (calendar[buttonName]) { // a calendar method
								buttonClick = function() {
									calendar[buttonName]();
								};
								overrideText = (calendar.overrides.buttonText || {})[buttonName];
								defaultText = calendar.options.buttonText[buttonName]; // everything else is considered default
							}
	
							if (buttonClick) {
	
								themeIcon =
									customButtonProps ?
										customButtonProps.themeIcon :
										calendar.options.themeButtonIcons[buttonName];
	
								normalIcon =
									customButtonProps ?
										customButtonProps.icon :
										calendar.options.buttonIcons[buttonName];
	
								if (overrideText) {
									innerHtml = htmlEscape(overrideText);
								}
								else if (themeIcon && calendar.options.theme) {
									innerHtml = "<span class='ui-icon ui-icon-" + themeIcon + "'></span>";
								}
								else if (normalIcon && !calendar.options.theme) {
									innerHtml = "<span class='fc-icon fc-icon-" + normalIcon + "'></span>";
								}
								else {
									innerHtml = htmlEscape(defaultText);
								}
	
								classes = [
									'fc-' + buttonName + '-button',
									tm + '-button',
									tm + '-state-default'
								];
	
								button = $( // type="button" so that it doesn't submit a form
									'<button type="button" class="' + classes.join(' ') + '">' +
										innerHtml +
									'</button>'
									)
									.click(function(ev) {
										// don't process clicks for disabled buttons
										if (!button.hasClass(tm + '-state-disabled')) {
	
											buttonClick(ev);
	
											// after the click action, if the button becomes the "active" tab, or disabled,
											// it should never have a hover class, so remove it now.
											if (
												button.hasClass(tm + '-state-active') ||
												button.hasClass(tm + '-state-disabled')
											) {
												button.removeClass(tm + '-state-hover');
											}
										}
									})
									.mousedown(function() {
										// the *down* effect (mouse pressed in).
										// only on buttons that are not the "active" tab, or disabled
										button
											.not('.' + tm + '-state-active')
											.not('.' + tm + '-state-disabled')
											.addClass(tm + '-state-down');
									})
									.mouseup(function() {
										// undo the *down* effect
										button.removeClass(tm + '-state-down');
									})
									.hover(
										function() {
											// the *hover* effect.
											// only on buttons that are not the "active" tab, or disabled
											button
												.not('.' + tm + '-state-active')
												.not('.' + tm + '-state-disabled')
												.addClass(tm + '-state-hover');
										},
										function() {
											// undo the *hover* effect
											button
												.removeClass(tm + '-state-hover')
												.removeClass(tm + '-state-down'); // if mouseleave happens before mouseup
										}
									);
	
								groupChildren = groupChildren.add(button);
							}
						}
					});
	
					if (isOnlyButtons) {
						groupChildren
							.first().addClass(tm + '-corner-left').end()
							.last().addClass(tm + '-corner-right').end();
					}
	
					if (groupChildren.length > 1) {
						groupEl = $('<div/>');
						if (isOnlyButtons) {
							groupEl.addClass('fc-button-group');
						}
						groupEl.append(groupChildren);
						sectionEl.append(groupEl);
					}
					else {
						sectionEl.append(groupChildren); // 1 or 0 children
					}
				});
			}
	
			return sectionEl;
		}
	
	
		function updateTitle(text) {
			if (el) {
				el.find('h2').text(text);
			}
		}
	
	
		function activateButton(buttonName) {
			if (el) {
				el.find('.fc-' + buttonName + '-button')
					.addClass(tm + '-state-active');
			}
		}
	
	
		function deactivateButton(buttonName) {
			if (el) {
				el.find('.fc-' + buttonName + '-button')
					.removeClass(tm + '-state-active');
			}
		}
	
	
		function disableButton(buttonName) {
			if (el) {
				el.find('.fc-' + buttonName + '-button')
					.prop('disabled', true)
					.addClass(tm + '-state-disabled');
			}
		}
	
	
		function enableButton(buttonName) {
			if (el) {
				el.find('.fc-' + buttonName + '-button')
					.prop('disabled', false)
					.removeClass(tm + '-state-disabled');
			}
		}
	
	
		function getViewsWithButtons() {
			return viewsWithButtons;
		}
	
	}
	
	;;
	
	var Calendar = FC.Calendar = Class.extend({
	
		dirDefaults: null, // option defaults related to LTR or RTL
		localeDefaults: null, // option defaults related to current locale
		overrides: null, // option overrides given to the fullCalendar constructor
		dynamicOverrides: null, // options set with dynamic setter method. higher precedence than view overrides.
		options: null, // all defaults combined with overrides
		viewSpecCache: null, // cache of view definitions
		view: null, // current View object
		header: null,
		footer: null,
		loadingLevel: 0, // number of simultaneous loading tasks
	
	
		// a lot of this class' OOP logic is scoped within this constructor function,
		// but in the future, write individual methods on the prototype.
		constructor: Calendar_constructor,
	
	
		// Subclasses can override this for initialization logic after the constructor has been called
		initialize: function() {
		},
	
	
		// Computes the flattened options hash for the calendar and assigns to `this.options`.
		// Assumes this.overrides and this.dynamicOverrides have already been initialized.
		populateOptionsHash: function() {
			var locale, localeDefaults;
			var isRTL, dirDefaults;
	
			locale = firstDefined( // explicit locale option given?
				this.dynamicOverrides.locale,
				this.overrides.locale
			);
			localeDefaults = localeOptionHash[locale];
			if (!localeDefaults) { // explicit locale option not given or invalid?
				locale = Calendar.defaults.locale;
				localeDefaults = localeOptionHash[locale] || {};
			}
	
			isRTL = firstDefined( // based on options computed so far, is direction RTL?
				this.dynamicOverrides.isRTL,
				this.overrides.isRTL,
				localeDefaults.isRTL,
				Calendar.defaults.isRTL
			);
			dirDefaults = isRTL ? Calendar.rtlDefaults : {};
	
			this.dirDefaults = dirDefaults;
			this.localeDefaults = localeDefaults;
			this.options = mergeOptions([ // merge defaults and overrides. lowest to highest precedence
				Calendar.defaults, // global defaults
				dirDefaults,
				localeDefaults,
				this.overrides,
				this.dynamicOverrides
			]);
			populateInstanceComputableOptions(this.options); // fill in gaps with computed options
		},
	
	
		// Gets information about how to create a view. Will use a cache.
		getViewSpec: function(viewType) {
			var cache = this.viewSpecCache;
	
			return cache[viewType] || (cache[viewType] = this.buildViewSpec(viewType));
		},
	
	
		// Given a duration singular unit, like "week" or "day", finds a matching view spec.
		// Preference is given to views that have corresponding buttons.
		getUnitViewSpec: function(unit) {
			var viewTypes;
			var i;
			var spec;
	
			if ($.inArray(unit, intervalUnits) != -1) {
	
				// put views that have buttons first. there will be duplicates, but oh well
				viewTypes = this.header.getViewsWithButtons(); // TODO: include footer as well?
				$.each(FC.views, function(viewType) { // all views
					viewTypes.push(viewType);
				});
	
				for (i = 0; i < viewTypes.length; i++) {
					spec = this.getViewSpec(viewTypes[i]);
					if (spec) {
						if (spec.singleUnit == unit) {
							return spec;
						}
					}
				}
			}
		},
	
	
		// Builds an object with information on how to create a given view
		buildViewSpec: function(requestedViewType) {
			var viewOverrides = this.overrides.views || {};
			var specChain = []; // for the view. lowest to highest priority
			var defaultsChain = []; // for the view. lowest to highest priority
			var overridesChain = []; // for the view. lowest to highest priority
			var viewType = requestedViewType;
			var spec; // for the view
			var overrides; // for the view
			var duration;
			var unit;
	
			// iterate from the specific view definition to a more general one until we hit an actual View class
			while (viewType) {
				spec = fcViews[viewType];
				overrides = viewOverrides[viewType];
				viewType = null; // clear. might repopulate for another iteration
	
				if (typeof spec === 'function') { // TODO: deprecate
					spec = { 'class': spec };
				}
	
				if (spec) {
					specChain.unshift(spec);
					defaultsChain.unshift(spec.defaults || {});
					duration = duration || spec.duration;
					viewType = viewType || spec.type;
				}
	
				if (overrides) {
					overridesChain.unshift(overrides); // view-specific option hashes have options at zero-level
					duration = duration || overrides.duration;
					viewType = viewType || overrides.type;
				}
			}
	
			spec = mergeProps(specChain);
			spec.type = requestedViewType;
			if (!spec['class']) {
				return false;
			}
	
			if (duration) {
				duration = moment.duration(duration);
				if (duration.valueOf()) { // valid?
					spec.duration = duration;
					unit = computeIntervalUnit(duration);
	
					// view is a single-unit duration, like "week" or "day"
					// incorporate options for this. lowest priority
					if (duration.as(unit) === 1) {
						spec.singleUnit = unit;
						overridesChain.unshift(viewOverrides[unit] || {});
					}
				}
			}
	
			spec.defaults = mergeOptions(defaultsChain);
			spec.overrides = mergeOptions(overridesChain);
	
			this.buildViewSpecOptions(spec);
			this.buildViewSpecButtonText(spec, requestedViewType);
	
			return spec;
		},
	
	
		// Builds and assigns a view spec's options object from its already-assigned defaults and overrides
		buildViewSpecOptions: function(spec) {
			spec.options = mergeOptions([ // lowest to highest priority
				Calendar.defaults, // global defaults
				spec.defaults, // view's defaults (from ViewSubclass.defaults)
				this.dirDefaults,
				this.localeDefaults, // locale and dir take precedence over view's defaults!
				this.overrides, // calendar's overrides (options given to constructor)
				spec.overrides, // view's overrides (view-specific options)
				this.dynamicOverrides // dynamically set via setter. highest precedence
			]);
			populateInstanceComputableOptions(spec.options);
		},
	
	
		// Computes and assigns a view spec's buttonText-related options
		buildViewSpecButtonText: function(spec, requestedViewType) {
	
			// given an options object with a possible `buttonText` hash, lookup the buttonText for the
			// requested view, falling back to a generic unit entry like "week" or "day"
			function queryButtonText(options) {
				var buttonText = options.buttonText || {};
				return buttonText[requestedViewType] ||
					// view can decide to look up a certain key
					(spec.buttonTextKey ? buttonText[spec.buttonTextKey] : null) ||
					// a key like "month"
					(spec.singleUnit ? buttonText[spec.singleUnit] : null);
			}
	
			// highest to lowest priority
			spec.buttonTextOverride =
				queryButtonText(this.dynamicOverrides) ||
				queryButtonText(this.overrides) || // constructor-specified buttonText lookup hash takes precedence
				spec.overrides.buttonText; // `buttonText` for view-specific options is a string
	
			// highest to lowest priority. mirrors buildViewSpecOptions
			spec.buttonTextDefault =
				queryButtonText(this.localeDefaults) ||
				queryButtonText(this.dirDefaults) ||
				spec.defaults.buttonText || // a single string. from ViewSubclass.defaults
				queryButtonText(Calendar.defaults) ||
				(spec.duration ? this.humanizeDuration(spec.duration) : null) || // like "3 days"
				requestedViewType; // fall back to given view name
		},
	
	
		// Given a view name for a custom view or a standard view, creates a ready-to-go View object
		instantiateView: function(viewType) {
			var spec = this.getViewSpec(viewType);
	
			return new spec['class'](this, viewType, spec.options, spec.duration);
		},
	
	
		// Returns a boolean about whether the view is okay to instantiate at some point
		isValidViewType: function(viewType) {
			return Boolean(this.getViewSpec(viewType));
		},
	
	
		// Should be called when any type of async data fetching begins
		pushLoading: function() {
			if (!(this.loadingLevel++)) {
				this.publiclyTrigger('loading', null, true, this.view);
			}
		},
	
	
		// Should be called when any type of async data fetching completes
		popLoading: function() {
			if (!(--this.loadingLevel)) {
				this.publiclyTrigger('loading', null, false, this.view);
			}
		},
	
	
		// Given arguments to the select method in the API, returns a span (unzoned start/end and other info)
		buildSelectSpan: function(zonedStartInput, zonedEndInput) {
			var start = this.moment(zonedStartInput).stripZone();
			var end;
	
			if (zonedEndInput) {
				end = this.moment(zonedEndInput).stripZone();
			}
			else if (start.hasTime()) {
				end = start.clone().add(this.defaultTimedEventDuration);
			}
			else {
				end = start.clone().add(this.defaultAllDayEventDuration);
			}
	
			return { start: start, end: end };
		}
	
	});
	
	
	Calendar.mixin(EmitterMixin);
	
	
	function Calendar_constructor(element, overrides) {
		var t = this;
	
	
		// Exports
		// -----------------------------------------------------------------------------------
	
		t.render = render;
		t.destroy = destroy;
		t.rerenderEvents = rerenderEvents;
		t.changeView = renderView; // `renderView` will switch to another view
		t.select = select;
		t.unselect = unselect;
		t.prev = prev;
		t.next = next;
		t.prevYear = prevYear;
		t.nextYear = nextYear;
		t.today = today;
		t.gotoDate = gotoDate;
		t.incrementDate = incrementDate;
		t.zoomTo = zoomTo;
		t.getDate = getDate;
		t.getCalendar = getCalendar;
		t.getView = getView;
		t.option = option; // getter/setter method
		t.publiclyTrigger = publiclyTrigger;
	
	
		// Options
		// -----------------------------------------------------------------------------------
	
		t.dynamicOverrides = {};
		t.viewSpecCache = {};
		t.optionHandlers = {}; // for Calendar.options.js
		t.overrides = $.extend({}, overrides); // make a copy
	
		t.populateOptionsHash(); // sets this.options
	
	
	
		// Locale-data Internals
		// -----------------------------------------------------------------------------------
		// Apply overrides to the current locale's data
	
		var localeData;
	
		// Called immediately, and when any of the options change.
		// Happens before any internal objects rebuild or rerender, because this is very core.
		t.bindOptions([
			'locale', 'monthNames', 'monthNamesShort', 'dayNames', 'dayNamesShort', 'firstDay', 'weekNumberCalculation'
		], function(locale, monthNames, monthNamesShort, dayNames, dayNamesShort, firstDay, weekNumberCalculation) {
	
			// normalize
			if (weekNumberCalculation === 'iso') {
				weekNumberCalculation = 'ISO'; // normalize
			}
	
			localeData = createObject( // make a cheap copy
				getMomentLocaleData(locale) // will fall back to en
			);
	
			if (monthNames) {
				localeData._months = monthNames;
			}
			if (monthNamesShort) {
				localeData._monthsShort = monthNamesShort;
			}
			if (dayNames) {
				localeData._weekdays = dayNames;
			}
			if (dayNamesShort) {
				localeData._weekdaysShort = dayNamesShort;
			}
	
			if (firstDay == null && weekNumberCalculation === 'ISO') {
				firstDay = 1;
			}
			if (firstDay != null) {
				var _week = createObject(localeData._week); // _week: { dow: # }
				_week.dow = firstDay;
				localeData._week = _week;
			}
	
			if ( // whitelist certain kinds of input
				weekNumberCalculation === 'ISO' ||
				weekNumberCalculation === 'local' ||
				typeof weekNumberCalculation === 'function'
			) {
				localeData._fullCalendar_weekCalc = weekNumberCalculation; // moment-ext will know what to do with it
			}
	
			// If the internal current date object already exists, move to new locale.
			// We do NOT need to do this technique for event dates, because this happens when converting to "segments".
			if (date) {
				localizeMoment(date); // sets to localeData
			}
		});
	
	
		// Calendar-specific Date Utilities
		// -----------------------------------------------------------------------------------
	
	
		t.defaultAllDayEventDuration = moment.duration(t.options.defaultAllDayEventDuration);
		t.defaultTimedEventDuration = moment.duration(t.options.defaultTimedEventDuration);
	
	
		// Builds a moment using the settings of the current calendar: timezone and locale.
		// Accepts anything the vanilla moment() constructor accepts.
		t.moment = function() {
			var mom;
	
			if (t.options.timezone === 'local') {
				mom = FC.moment.apply(null, arguments);
	
				// Force the moment to be local, because FC.moment doesn't guarantee it.
				if (mom.hasTime()) { // don't give ambiguously-timed moments a local zone
					mom.local();
				}
			}
			else if (t.options.timezone === 'UTC') {
				mom = FC.moment.utc.apply(null, arguments); // process as UTC
			}
			else {
				mom = FC.moment.parseZone.apply(null, arguments); // let the input decide the zone
			}
	
			localizeMoment(mom);
	
			return mom;
		};
	
	
		// Updates the given moment's locale settings to the current calendar locale settings.
		function localizeMoment(mom) {
			mom._locale = localeData;
		}
		t.localizeMoment = localizeMoment;
	
	
		// Returns a boolean about whether or not the calendar knows how to calculate
		// the timezone offset of arbitrary dates in the current timezone.
		t.getIsAmbigTimezone = function() {
			return t.options.timezone !== 'local' && t.options.timezone !== 'UTC';
		};
	
	
		// Returns a copy of the given date in the current timezone. Has no effect on dates without times.
		t.applyTimezone = function(date) {
			if (!date.hasTime()) {
				return date.clone();
			}
	
			var zonedDate = t.moment(date.toArray());
			var timeAdjust = date.time() - zonedDate.time();
			var adjustedZonedDate;
	
			// Safari sometimes has problems with this coersion when near DST. Adjust if necessary. (bug #2396)
			if (timeAdjust) { // is the time result different than expected?
				adjustedZonedDate = zonedDate.clone().add(timeAdjust); // add milliseconds
				if (date.time() - adjustedZonedDate.time() === 0) { // does it match perfectly now?
					zonedDate = adjustedZonedDate;
				}
			}
	
			return zonedDate;
		};
	
	
		// Returns a moment for the current date, as defined by the client's computer or from the `now` option.
		// Will return an moment with an ambiguous timezone.
		t.getNow = function() {
			var now = t.options.now;
			if (typeof now === 'function') {
				now = now();
			}
			return t.moment(now).stripZone();
		};
	
	
		// Get an event's normalized end date. If not present, calculate it from the defaults.
		t.getEventEnd = function(event) {
			if (event.end) {
				return event.end.clone();
			}
			else {
				return t.getDefaultEventEnd(event.allDay, event.start);
			}
		};
	
	
		// Given an event's allDay status and start date, return what its fallback end date should be.
		// TODO: rename to computeDefaultEventEnd
		t.getDefaultEventEnd = function(allDay, zonedStart) {
			var end = zonedStart.clone();
	
			if (allDay) {
				end.stripTime().add(t.defaultAllDayEventDuration);
			}
			else {
				end.add(t.defaultTimedEventDuration);
			}
	
			if (t.getIsAmbigTimezone()) {
				end.stripZone(); // we don't know what the tzo should be
			}
	
			return end;
		};
	
	
		// Produces a human-readable string for the given duration.
		// Side-effect: changes the locale of the given duration.
		t.humanizeDuration = function(duration) {
			return duration.locale(t.options.locale).humanize();
		};
	
	
	
		// Imports
		// -----------------------------------------------------------------------------------
	
	
		EventManager.call(t);
	
	
	
		// Locals
		// -----------------------------------------------------------------------------------
	
	
		var _element = element[0];
		var toolbarsManager;
		var header;
		var footer;
		var content;
		var tm; // for making theme classes
		var currentView; // NOTE: keep this in sync with this.view
		var viewsByType = {}; // holds all instantiated view instances, current or not
		var suggestedViewHeight;
		var windowResizeProxy; // wraps the windowResize function
		var ignoreWindowResize = 0;
		var date; // unzoned
	
	
	
		// Main Rendering
		// -----------------------------------------------------------------------------------
	
	
		// compute the initial ambig-timezone date
		if (t.options.defaultDate != null) {
			date = t.moment(t.options.defaultDate).stripZone();
		}
		else {
			date = t.getNow(); // getNow already returns unzoned
		}
	
	
		function render() {
			if (!content) {
				initialRender();
			}
			else if (elementVisible()) {
				// mainly for the public API
				calcSize();
				renderView();
			}
		}
	
	
		function initialRender() {
			element.addClass('fc');
	
			// event delegation for nav links
			element.on('click.fc', 'a[data-goto]', function(ev) {
				var anchorEl = $(this);
				var gotoOptions = anchorEl.data('goto'); // will automatically parse JSON
				var date = t.moment(gotoOptions.date);
				var viewType = gotoOptions.type;
	
				// property like "navLinkDayClick". might be a string or a function
				var customAction = currentView.opt('navLink' + capitaliseFirstLetter(viewType) + 'Click');
	
				if (typeof customAction === 'function') {
					customAction(date, ev);
				}
				else {
					if (typeof customAction === 'string') {
						viewType = customAction;
					}
					zoomTo(date, viewType);
				}
			});
	
			// called immediately, and upon option change
			t.bindOption('theme', function(theme) {
				tm = theme ? 'ui' : 'fc'; // affects a larger scope
				element.toggleClass('ui-widget', theme);
				element.toggleClass('fc-unthemed', !theme);
			});
	
			// called immediately, and upon option change.
			// HACK: locale often affects isRTL, so we explicitly listen to that too.
			t.bindOptions([ 'isRTL', 'locale' ], function(isRTL) {
				element.toggleClass('fc-ltr', !isRTL);
				element.toggleClass('fc-rtl', isRTL);
			});
	
			content = $("<div class='fc-view-container'/>").prependTo(element);
	
			var toolbars = buildToolbars();
			toolbarsManager = new Iterator(toolbars);
	
			header = t.header = toolbars[0];
			footer = t.footer = toolbars[1];
	
			renderHeader();
			renderFooter();
			renderView(t.options.defaultView);
	
			if (t.options.handleWindowResize) {
				windowResizeProxy = debounce(windowResize, t.options.windowResizeDelay); // prevents rapid calls
				$(window).resize(windowResizeProxy);
			}
		}
	
	
		function destroy() {
	
			if (currentView) {
				currentView.removeElement();
	
				// NOTE: don't null-out currentView/t.view in case API methods are called after destroy.
				// It is still the "current" view, just not rendered.
			}
	
			toolbarsManager.proxyCall('removeElement');
			content.remove();
			element.removeClass('fc fc-ltr fc-rtl fc-unthemed ui-widget');
	
			element.off('.fc'); // unbind nav link handlers
	
			if (windowResizeProxy) {
				$(window).unbind('resize', windowResizeProxy);
			}
		}
	
	
		function elementVisible() {
			return element.is(':visible');
		}
	
	
	
		// View Rendering
		// -----------------------------------------------------------------------------------
	
	
		// Renders a view because of a date change, view-type change, or for the first time.
		// If not given a viewType, keep the current view but render different dates.
		// Accepts an optional scroll state to restore to.
		function renderView(viewType, forcedScroll) {
			ignoreWindowResize++;
	
			var needsClearView = currentView && viewType && currentView.type !== viewType;
	
			// if viewType is changing, remove the old view's rendering
			if (needsClearView) {
				freezeContentHeight(); // prevent a scroll jump when view element is removed
				clearView();
			}
	
			// if viewType changed, or the view was never created, create a fresh view
			if (!currentView && viewType) {
				currentView = t.view =
					viewsByType[viewType] ||
					(viewsByType[viewType] = t.instantiateView(viewType));
	
				currentView.setElement(
					$("<div class='fc-view fc-" + viewType + "-view' />").appendTo(content)
				);
				toolbarsManager.proxyCall('activateButton', viewType);
			}
	
			if (currentView) {
	
				// in case the view should render a period of time that is completely hidden
				date = currentView.massageCurrentDate(date);
	
				// render or rerender the view
				if (
					!currentView.isDateSet ||
					!( // NOT within interval range signals an implicit date window change
						date >= currentView.intervalStart &&
						date < currentView.intervalEnd
					)
				) {
					if (elementVisible()) {
	
						if (forcedScroll) {
							currentView.captureInitialScroll(forcedScroll);
						}
	
						currentView.setDate(date, forcedScroll);
	
						if (forcedScroll) {
							currentView.releaseScroll();
						}
	
						// need to do this after View::render, so dates are calculated
						// NOTE: view updates title text proactively
						updateToolbarsTodayButton();
					}
				}
			}
	
			if (needsClearView) {
				thawContentHeight();
			}
	
			ignoreWindowResize--;
		}
	
	
		// Unrenders the current view and reflects this change in the Header.
		// Unregsiters the `currentView`, but does not remove from viewByType hash.
		function clearView() {
			toolbarsManager.proxyCall('deactivateButton', currentView.type);
			currentView.removeElement();
			currentView = t.view = null;
		}
	
	
		// Destroys the view, including the view object. Then, re-instantiates it and renders it.
		// Maintains the same scroll state.
		// TODO: maintain any other user-manipulated state.
		function reinitView() {
			ignoreWindowResize++;
			freezeContentHeight();
	
			var viewType = currentView.type;
			var scrollState = currentView.queryScroll();
			clearView();
			calcSize();
			renderView(viewType, scrollState);
	
			thawContentHeight();
			ignoreWindowResize--;
		}
	
	
	
		// Resizing
		// -----------------------------------------------------------------------------------
	
	
		t.getSuggestedViewHeight = function() {
			if (suggestedViewHeight === undefined) {
				calcSize();
			}
			return suggestedViewHeight;
		};
	
	
		t.isHeightAuto = function() {
			return t.options.contentHeight === 'auto' || t.options.height === 'auto';
		};
	
	
		function updateSize(shouldRecalc) {
			if (elementVisible()) {
	
				if (shouldRecalc) {
					_calcSize();
				}
	
				ignoreWindowResize++;
				currentView.updateSize(true); // isResize=true. will poll getSuggestedViewHeight() and isHeightAuto()
				ignoreWindowResize--;
	
				return true; // signal success
			}
		}
	
	
		function calcSize() {
			if (elementVisible()) {
				_calcSize();
			}
		}
	
	
		function _calcSize() { // assumes elementVisible
			var contentHeightInput = t.options.contentHeight;
			var heightInput = t.options.height;
	
			if (typeof contentHeightInput === 'number') { // exists and not 'auto'
				suggestedViewHeight = contentHeightInput;
			}
			else if (typeof contentHeightInput === 'function') { // exists and is a function
				suggestedViewHeight = contentHeightInput();
			}
			else if (typeof heightInput === 'number') { // exists and not 'auto'
				suggestedViewHeight = heightInput - queryToolbarsHeight();
			}
			else if (typeof heightInput === 'function') { // exists and is a function
				suggestedViewHeight = heightInput() - queryToolbarsHeight();
			}
			else if (heightInput === 'parent') { // set to height of parent element
				suggestedViewHeight = element.parent().height() - queryToolbarsHeight();
			}
			else {
				suggestedViewHeight = Math.round(content.width() / Math.max(t.options.aspectRatio, .5));
			}
		}
	
	
		function queryToolbarsHeight() {
			return toolbarsManager.items.reduce(function(accumulator, toolbar) {
				var toolbarHeight = toolbar.el ? toolbar.el.outerHeight(true) : 0; // includes margin
				return accumulator + toolbarHeight;
			}, 0);
		}
	
	
		function windowResize(ev) {
			if (
				!ignoreWindowResize &&
				ev.target === window && // so we don't process jqui "resize" events that have bubbled up
				currentView.start // view has already been rendered
			) {
				if (updateSize(true)) {
					currentView.publiclyTrigger('windowResize', _element);
				}
			}
		}
	
	
	
		/* Event Rendering
		-----------------------------------------------------------------------------*/
	
	
		function rerenderEvents() { // API method. destroys old events if previously rendered.
			if (elementVisible()) {
				t.reportEventChange(); // will re-trasmit events to the view, causing a rerender
			}
		}
	
	
	
		/* Toolbars
		-----------------------------------------------------------------------------*/
	
	
		function buildToolbars() {
			return [
				new Toolbar(t, computeHeaderOptions()),
				new Toolbar(t, computeFooterOptions())
			];
		}
	
	
		function computeHeaderOptions() {
			return {
				extraClasses: 'fc-header-toolbar',
				layout: t.options.header
			};
		}
	
	
		function computeFooterOptions() {
			return {
				extraClasses: 'fc-footer-toolbar',
				layout: t.options.footer
			};
		}
	
	
		// can be called repeatedly and Header will rerender
		function renderHeader() {
			header.setToolbarOptions(computeHeaderOptions());
			header.render();
			if (header.el) {
				element.prepend(header.el);
			}
		}
	
	
		// can be called repeatedly and Footer will rerender
		function renderFooter() {
			footer.setToolbarOptions(computeFooterOptions());
			footer.render();
			if (footer.el) {
				element.append(footer.el);
			}
		}
	
	
		t.setToolbarsTitle = function(title) {
			toolbarsManager.proxyCall('updateTitle', title);
		};
	
	
		function updateToolbarsTodayButton() {
			var now = t.getNow();
			if (now >= currentView.intervalStart && now < currentView.intervalEnd) {
				toolbarsManager.proxyCall('disableButton', 'today');
			}
			else {
				toolbarsManager.proxyCall('enableButton', 'today');
			}
		}
	
	
	
		/* Selection
		-----------------------------------------------------------------------------*/
	
	
		// this public method receives start/end dates in any format, with any timezone
		function select(zonedStartInput, zonedEndInput) {
			currentView.select(
				t.buildSelectSpan.apply(t, arguments)
			);
		}
	
	
		function unselect() { // safe to be called before renderView
			if (currentView) {
				currentView.unselect();
			}
		}
	
	
	
		/* Date
		-----------------------------------------------------------------------------*/
	
	
		function prev() {
			date = currentView.computePrevDate(date);
			renderView();
		}
	
	
		function next() {
			date = currentView.computeNextDate(date);
			renderView();
		}
	
	
		function prevYear() {
			date.add(-1, 'years');
			renderView();
		}
	
	
		function nextYear() {
			date.add(1, 'years');
			renderView();
		}
	
	
		function today() {
			date = t.getNow();
			renderView();
		}
	
	
		function gotoDate(zonedDateInput) {
			date = t.moment(zonedDateInput).stripZone();
			renderView();
		}
	
	
		function incrementDate(delta) {
			date.add(moment.duration(delta));
			renderView();
		}
	
	
		// Forces navigation to a view for the given date.
		// `viewType` can be a specific view name or a generic one like "week" or "day".
		function zoomTo(newDate, viewType) {
			var spec;
	
			viewType = viewType || 'day'; // day is default zoom
			spec = t.getViewSpec(viewType) || t.getUnitViewSpec(viewType);
	
			date = newDate.clone();
			renderView(spec ? spec.type : null);
		}
	
	
		// for external API
		function getDate() {
			return t.applyTimezone(date); // infuse the calendar's timezone
		}
	
	
	
		/* Height "Freezing"
		-----------------------------------------------------------------------------*/
	
	
		t.freezeContentHeight = freezeContentHeight;
		t.thawContentHeight = thawContentHeight;
	
		var freezeContentHeightDepth = 0;
	
	
		function freezeContentHeight() {
			if (!(freezeContentHeightDepth++)) {
				content.css({
					width: '100%',
					height: content.height(),
					overflow: 'hidden'
				});
			}
		}
	
	
		function thawContentHeight() {
			if (!(--freezeContentHeightDepth)) {
				content.css({
					width: '',
					height: '',
					overflow: ''
				});
			}
		}
	
	
	
		/* Misc
		-----------------------------------------------------------------------------*/
	
	
		function getCalendar() {
			return t;
		}
	
	
		function getView() {
			return currentView;
		}
	
	
		function option(name, value) {
			var newOptionHash;
	
			if (typeof name === 'string') {
				if (value === undefined) { // getter
					return t.options[name];
				}
				else { // setter for individual option
					newOptionHash = {};
					newOptionHash[name] = value;
					setOptions(newOptionHash);
				}
			}
			else if (typeof name === 'object') { // compound setter with object input
				setOptions(name);
			}
		}
	
	
		function setOptions(newOptionHash) {
			var optionCnt = 0;
			var optionName;
	
			for (optionName in newOptionHash) {
				t.dynamicOverrides[optionName] = newOptionHash[optionName];
			}
	
			t.viewSpecCache = {}; // the dynamic override invalidates the options in this cache, so just clear it
			t.populateOptionsHash(); // this.options needs to be recomputed after the dynamic override
	
			// trigger handlers after this.options has been updated
			for (optionName in newOptionHash) {
				t.triggerOptionHandlers(optionName); // recall bindOption/bindOptions
				optionCnt++;
			}
	
			// special-case handling of single option change.
			// if only one option change, `optionName` will be its name.
			if (optionCnt === 1) {
				if (optionName === 'height' || optionName === 'contentHeight' || optionName === 'aspectRatio') {
					updateSize(true); // true = allow recalculation of height
					return;
				}
				else if (optionName === 'defaultDate') {
					return; // can't change date this way. use gotoDate instead
				}
				else if (optionName === 'businessHours') {
					if (currentView) {
						currentView.unrenderBusinessHours();
						currentView.renderBusinessHours();
					}
					return;
				}
				else if (optionName === 'timezone') {
					t.rezoneArrayEventSources();
					t.refetchEvents();
					return;
				}
			}
	
			// catch-all. rerender the header and footer and rebuild/rerender the current view
			renderHeader();
			renderFooter();
			viewsByType = {}; // even non-current views will be affected by this option change. do before rerender
			reinitView();
		}
	
	
		function publiclyTrigger(name, thisObj) {
			var args = Array.prototype.slice.call(arguments, 2);
	
			thisObj = thisObj || _element;
			this.triggerWith(name, thisObj, args); // Emitter's method
	
			if (t.options[name]) {
				return t.options[name].apply(thisObj, args);
			}
		}
	
		t.initialize();
	}
	
	;;
	/*
	Options binding/triggering system.
	*/
	Calendar.mixin({
	
		// A map of option names to arrays of handler objects. Initialized to {} in Calendar.
		// Format for a handler object:
		// {
		//   func // callback function to be called upon change
		//   names // option names whose values should be given to func
		// }
		optionHandlers: null, 
	
		// Calls handlerFunc immediately, and when the given option has changed.
		// handlerFunc will be given the option value.
		bindOption: function(optionName, handlerFunc) {
			this.bindOptions([ optionName ], handlerFunc);
		},
	
		// Calls handlerFunc immediately, and when any of the given options change.
		// handlerFunc will be given each option value as ordered function arguments.
		bindOptions: function(optionNames, handlerFunc) {
			var handlerObj = { func: handlerFunc, names: optionNames };
			var i;
	
			for (i = 0; i < optionNames.length; i++) {
				this.registerOptionHandlerObj(optionNames[i], handlerObj);
			}
	
			this.triggerOptionHandlerObj(handlerObj);
		},
	
		// Puts the given handler object into the internal hash
		registerOptionHandlerObj: function(optionName, handlerObj) {
			(this.optionHandlers[optionName] || (this.optionHandlers[optionName] = []))
				.push(handlerObj);
		},
	
		// Reports that the given option has changed, and calls all appropriate handlers.
		triggerOptionHandlers: function(optionName) {
			var handlerObjs = this.optionHandlers[optionName] || [];
			var i;
	
			for (i = 0; i < handlerObjs.length; i++) {
				this.triggerOptionHandlerObj(handlerObjs[i]);
			}
		},
	
		// Calls the callback for a specific handler object, passing in the appropriate arguments.
		triggerOptionHandlerObj: function(handlerObj) {
			var optionNames = handlerObj.names;
			var optionValues = [];
			var i;
	
			for (i = 0; i < optionNames.length; i++) {
				optionValues.push(this.options[optionNames[i]]);
			}
	
			handlerObj.func.apply(this, optionValues); // maintain the Calendar's `this` context
		}
	
	});
	
	;;
	
	Calendar.defaults = {
	
		titleRangeSeparator: ' \u2013 ', // en dash
		monthYearFormat: 'MMMM YYYY', // required for en. other locales rely on datepicker computable option
	
		defaultTimedEventDuration: '02:00:00',
		defaultAllDayEventDuration: { days: 1 },
		forceEventDuration: false,
		nextDayThreshold: '09:00:00', // 9am
	
		// display
		defaultView: 'month',
		aspectRatio: 1.35,
		header: {
			left: 'title',
			center: '',
			right: 'today prev,next'
		},
		weekends: true,
		weekNumbers: false,
	
		weekNumberTitle: 'W',
		weekNumberCalculation: 'local',
		
		//editable: false,
	
		//nowIndicator: false,
	
		scrollTime: '06:00:00',
		
		// event ajax
		lazyFetching: true,
		startParam: 'start',
		endParam: 'end',
		timezoneParam: 'timezone',
	
		timezone: false,
	
		//allDayDefault: undefined,
	
		// locale
		isRTL: false,
		buttonText: {
			prev: "prev",
			next: "next",
			prevYear: "prev year",
			nextYear: "next year",
			year: 'year', // TODO: locale files need to specify this
			today: 'today',
			month: 'month',
			week: 'week',
			day: 'day'
		},
	
		buttonIcons: {
			prev: 'left-single-arrow',
			next: 'right-single-arrow',
			prevYear: 'left-double-arrow',
			nextYear: 'right-double-arrow'
		},
	
		allDayText: 'all-day',
		
		// jquery-ui theming
		theme: false,
		themeButtonIcons: {
			prev: 'circle-triangle-w',
			next: 'circle-triangle-e',
			prevYear: 'seek-prev',
			nextYear: 'seek-next'
		},
	
		//eventResizableFromStart: false,
		dragOpacity: .75,
		dragRevertDuration: 500,
		dragScroll: true,
		
		//selectable: false,
		unselectAuto: true,
		
		dropAccept: '*',
	
		eventOrder: 'title',
		//eventRenderWait: null,
	
		eventLimit: false,
		eventLimitText: 'more',
		eventLimitClick: 'popover',
		dayPopoverFormat: 'LL',
		
		handleWindowResize: true,
		windowResizeDelay: 100, // milliseconds before an updateSize happens
	
		longPressDelay: 1000
		
	};
	
	
	Calendar.englishDefaults = { // used by locale.js
		dayPopoverFormat: 'dddd, MMMM D'
	};
	
	
	Calendar.rtlDefaults = { // right-to-left defaults
		header: { // TODO: smarter solution (first/center/last ?)
			left: 'next,prev today',
			center: '',
			right: 'title'
		},
		buttonIcons: {
			prev: 'right-single-arrow',
			next: 'left-single-arrow',
			prevYear: 'right-double-arrow',
			nextYear: 'left-double-arrow'
		},
		themeButtonIcons: {
			prev: 'circle-triangle-e',
			next: 'circle-triangle-w',
			nextYear: 'seek-prev',
			prevYear: 'seek-next'
		}
	};
	
	;;
	
	var localeOptionHash = FC.locales = {}; // initialize and expose
	
	
	// TODO: document the structure and ordering of a FullCalendar locale file
	
	
	// Initialize jQuery UI datepicker translations while using some of the translations
	// Will set this as the default locales for datepicker.
	FC.datepickerLocale = function(localeCode, dpLocaleCode, dpOptions) {
	
		// get the FullCalendar internal option hash for this locale. create if necessary
		var fcOptions = localeOptionHash[localeCode] || (localeOptionHash[localeCode] = {});
	
		// transfer some simple options from datepicker to fc
		fcOptions.isRTL = dpOptions.isRTL;
		fcOptions.weekNumberTitle = dpOptions.weekHeader;
	
		// compute some more complex options from datepicker
		$.each(dpComputableOptions, function(name, func) {
			fcOptions[name] = func(dpOptions);
		});
	
		// is jQuery UI Datepicker is on the page?
		if ($.datepicker) {
	
			// Register the locale data.
			// FullCalendar and MomentJS use locale codes like "pt-br" but Datepicker
			// does it like "pt-BR" or if it doesn't have the locale, maybe just "pt".
			// Make an alias so the locale can be referenced either way.
			$.datepicker.regional[dpLocaleCode] =
				$.datepicker.regional[localeCode] = // alias
					dpOptions;
	
			// Alias 'en' to the default locale data. Do this every time.
			$.datepicker.regional.en = $.datepicker.regional[''];
	
			// Set as Datepicker's global defaults.
			$.datepicker.setDefaults(dpOptions);
		}
	};
	
	
	// Sets FullCalendar-specific translations. Will set the locales as the global default.
	FC.locale = function(localeCode, newFcOptions) {
		var fcOptions;
		var momOptions;
	
		// get the FullCalendar internal option hash for this locale. create if necessary
		fcOptions = localeOptionHash[localeCode] || (localeOptionHash[localeCode] = {});
	
		// provided new options for this locales? merge them in
		if (newFcOptions) {
			fcOptions = localeOptionHash[localeCode] = mergeOptions([ fcOptions, newFcOptions ]);
		}
	
		// compute locale options that weren't defined.
		// always do this. newFcOptions can be undefined when initializing from i18n file,
		// so no way to tell if this is an initialization or a default-setting.
		momOptions = getMomentLocaleData(localeCode); // will fall back to en
		$.each(momComputableOptions, function(name, func) {
			if (fcOptions[name] == null) {
				fcOptions[name] = func(momOptions, fcOptions);
			}
		});
	
		// set it as the default locale for FullCalendar
		Calendar.defaults.locale = localeCode;
	};
	
	
	// NOTE: can't guarantee any of these computations will run because not every locale has datepicker
	// configs, so make sure there are English fallbacks for these in the defaults file.
	var dpComputableOptions = {
	
		buttonText: function(dpOptions) {
			return {
				// the translations sometimes wrongly contain HTML entities
				prev: stripHtmlEntities(dpOptions.prevText),
				next: stripHtmlEntities(dpOptions.nextText),
				today: stripHtmlEntities(dpOptions.currentText)
			};
		},
	
		// Produces format strings like "MMMM YYYY" -> "September 2014"
		monthYearFormat: function(dpOptions) {
			return dpOptions.showMonthAfterYear ?
				'YYYY[' + dpOptions.yearSuffix + '] MMMM' :
				'MMMM YYYY[' + dpOptions.yearSuffix + ']';
		}
	
	};
	
	var momComputableOptions = {
	
		// Produces format strings like "ddd M/D" -> "Fri 9/15"
		dayOfMonthFormat: function(momOptions, fcOptions) {
			var format = momOptions.longDateFormat('l'); // for the format like "M/D/YYYY"
	
			// strip the year off the edge, as well as other misc non-whitespace chars
			format = format.replace(/^Y+[^\w\s]*|[^\w\s]*Y+$/g, '');
	
			if (fcOptions.isRTL) {
				format += ' ddd'; // for RTL, add day-of-week to end
			}
			else {
				format = 'ddd ' + format; // for LTR, add day-of-week to beginning
			}
			return format;
		},
	
		// Produces format strings like "h:mma" -> "6:00pm"
		mediumTimeFormat: function(momOptions) { // can't be called `timeFormat` because collides with option
			return momOptions.longDateFormat('LT')
				.replace(/\s*a$/i, 'a'); // convert AM/PM/am/pm to lowercase. remove any spaces beforehand
		},
	
		// Produces format strings like "h(:mm)a" -> "6pm" / "6:30pm"
		smallTimeFormat: function(momOptions) {
			return momOptions.longDateFormat('LT')
				.replace(':mm', '(:mm)')
				.replace(/(\Wmm)$/, '($1)') // like above, but for foreign locales
				.replace(/\s*a$/i, 'a'); // convert AM/PM/am/pm to lowercase. remove any spaces beforehand
		},
	
		// Produces format strings like "h(:mm)t" -> "6p" / "6:30p"
		extraSmallTimeFormat: function(momOptions) {
			return momOptions.longDateFormat('LT')
				.replace(':mm', '(:mm)')
				.replace(/(\Wmm)$/, '($1)') // like above, but for foreign locales
				.replace(/\s*a$/i, 't'); // convert to AM/PM/am/pm to lowercase one-letter. remove any spaces beforehand
		},
	
		// Produces format strings like "ha" / "H" -> "6pm" / "18"
		hourFormat: function(momOptions) {
			return momOptions.longDateFormat('LT')
				.replace(':mm', '')
				.replace(/(\Wmm)$/, '') // like above, but for foreign locales
				.replace(/\s*a$/i, 'a'); // convert AM/PM/am/pm to lowercase. remove any spaces beforehand
		},
	
		// Produces format strings like "h:mm" -> "6:30" (with no AM/PM)
		noMeridiemTimeFormat: function(momOptions) {
			return momOptions.longDateFormat('LT')
				.replace(/\s*a$/i, ''); // remove trailing AM/PM
		}
	
	};
	
	
	// options that should be computed off live calendar options (considers override options)
	// TODO: best place for this? related to locale?
	// TODO: flipping text based on isRTL is a bad idea because the CSS `direction` might want to handle it
	var instanceComputableOptions = {
	
		// Produces format strings for results like "Mo 16"
		smallDayDateFormat: function(options) {
			return options.isRTL ?
				'D dd' :
				'dd D';
		},
	
		// Produces format strings for results like "Wk 5"
		weekFormat: function(options) {
			return options.isRTL ?
				'w[ ' + options.weekNumberTitle + ']' :
				'[' + options.weekNumberTitle + ' ]w';
		},
	
		// Produces format strings for results like "Wk5"
		smallWeekFormat: function(options) {
			return options.isRTL ?
				'w[' + options.weekNumberTitle + ']' :
				'[' + options.weekNumberTitle + ']w';
		}
	
	};
	
	function populateInstanceComputableOptions(options) {
		$.each(instanceComputableOptions, function(name, func) {
			if (options[name] == null) {
				options[name] = func(options);
			}
		});
	}
	
	
	// Returns moment's internal locale data. If doesn't exist, returns English.
	function getMomentLocaleData(localeCode) {
		return moment.localeData(localeCode) || moment.localeData('en');
	}
	
	
	// Initialize English by forcing computation of moment-derived options.
	// Also, sets it as the default.
	FC.locale('en', Calendar.englishDefaults);
	
	;;
	
	FC.sourceNormalizers = [];
	FC.sourceFetchers = [];
	
	var ajaxDefaults = {
		dataType: 'json',
		cache: false
	};
	
	var eventGUID = 1;
	
	
	function EventManager() { // assumed to be a calendar
		var t = this;
	
	
		// exports
		t.requestEvents = requestEvents;
		t.reportEventChange = reportEventChange;
		t.isFetchNeeded = isFetchNeeded;
		t.fetchEvents = fetchEvents;
		t.fetchEventSources = fetchEventSources;
		t.refetchEvents = refetchEvents;
		t.refetchEventSources = refetchEventSources;
		t.getEventSources = getEventSources;
		t.getEventSourceById = getEventSourceById;
		t.addEventSource = addEventSource;
		t.removeEventSource = removeEventSource;
		t.removeEventSources = removeEventSources;
		t.updateEvent = updateEvent;
		t.updateEvents = updateEvents;
		t.renderEvent = renderEvent;
		t.renderEvents = renderEvents;
		t.removeEvents = removeEvents;
		t.clientEvents = clientEvents;
		t.mutateEvent = mutateEvent;
		t.normalizeEventDates = normalizeEventDates;
		t.normalizeEventTimes = normalizeEventTimes;
	
	
		// locals
		var stickySource = { events: [] };
		var sources = [ stickySource ];
		var rangeStart, rangeEnd;
		var pendingSourceCnt = 0; // outstanding fetch requests, max one per source
		var cache = []; // holds events that have already been expanded
		var prunedCache; // like cache, but only events that intersect with rangeStart/rangeEnd
	
	
		$.each(
			(t.options.events ? [ t.options.events ] : []).concat(t.options.eventSources || []),
			function(i, sourceInput) {
				var source = buildEventSource(sourceInput);
				if (source) {
					sources.push(source);
				}
			}
		);
	
	
	
		function requestEvents(start, end) {
			if (!t.options.lazyFetching || isFetchNeeded(start, end)) {
				return fetchEvents(start, end);
			}
			else {
				return Promise.resolve(prunedCache);
			}
		}
	
	
		function reportEventChange() {
			prunedCache = filterEventsWithinRange(cache);
			t.trigger('eventsReset', prunedCache);
		}
	
	
		function filterEventsWithinRange(events) {
			var filteredEvents = [];
			var i, event;
	
			for (i = 0; i < events.length; i++) {
				event = events[i];
	
				if (
					event.start.clone().stripZone() < rangeEnd &&
					t.getEventEnd(event).stripZone() > rangeStart
				) {
					filteredEvents.push(event);
				}
			}
	
			return filteredEvents;
		}
	
	
		t.getEventCache = function() {
			return cache;
		};
	
	
		t.getPrunedEventCache = function() {
			return prunedCache;
		};
	
	
	
		/* Fetching
		-----------------------------------------------------------------------------*/
	
	
		// start and end are assumed to be unzoned
		function isFetchNeeded(start, end) {
			return !rangeStart || // nothing has been fetched yet?
				start < rangeStart || end > rangeEnd; // is part of the new range outside of the old range?
		}
	
	
		function fetchEvents(start, end) {
			rangeStart = start;
			rangeEnd = end;
			return refetchEvents();
		}
	
	
		// poorly named. fetches all sources with current `rangeStart` and `rangeEnd`.
		function refetchEvents() {
			return fetchEventSources(sources, 'reset');
		}
	
	
		// poorly named. fetches a subset of event sources.
		function refetchEventSources(matchInputs) {
			return fetchEventSources(getEventSourcesByMatchArray(matchInputs));
		}
	
	
		// expects an array of event source objects (the originals, not copies)
		// `specialFetchType` is an optimization parameter that affects purging of the event cache.
		function fetchEventSources(specificSources, specialFetchType) {
			var i, source;
	
			if (specialFetchType === 'reset') {
				cache = [];
			}
			else if (specialFetchType !== 'add') {
				cache = excludeEventsBySources(cache, specificSources);
			}
	
			for (i = 0; i < specificSources.length; i++) {
				source = specificSources[i];
	
				// already-pending sources have already been accounted for in pendingSourceCnt
				if (source._status !== 'pending') {
					pendingSourceCnt++;
				}
	
				source._fetchId = (source._fetchId || 0) + 1;
				source._status = 'pending';
			}
	
			for (i = 0; i < specificSources.length; i++) {
				source = specificSources[i];
				tryFetchEventSource(source, source._fetchId);
			}
	
			if (pendingSourceCnt) {
				return new Promise(function(resolve) {
					t.one('eventsReceived', resolve); // will send prunedCache
				});
			}
			else { // executed all synchronously, or no sources at all
				return Promise.resolve(prunedCache);
			}
		}
	
	
		// fetches an event source and processes its result ONLY if it is still the current fetch.
		// caller is responsible for incrementing pendingSourceCnt first.
		function tryFetchEventSource(source, fetchId) {
			_fetchEventSource(source, function(eventInputs) {
				var isArraySource = $.isArray(source.events);
				var i, eventInput;
				var abstractEvent;
	
				if (
					// is this the source's most recent fetch?
					// if not, rely on an upcoming fetch of this source to decrement pendingSourceCnt
					fetchId === source._fetchId &&
					// event source no longer valid?
					source._status !== 'rejected'
				) {
					source._status = 'resolved';
	
					if (eventInputs) {
						for (i = 0; i < eventInputs.length; i++) {
							eventInput = eventInputs[i];
	
							if (isArraySource) { // array sources have already been convert to Event Objects
								abstractEvent = eventInput;
							}
							else {
								abstractEvent = buildEventFromInput(eventInput, source);
							}
	
							if (abstractEvent) { // not false (an invalid event)
								cache.push.apply( // append
									cache,
									expandEvent(abstractEvent) // add individual expanded events to the cache
								);
							}
						}
					}
	
					decrementPendingSourceCnt();
				}
			});
		}
	
	
		function rejectEventSource(source) {
			var wasPending = source._status === 'pending';
	
			source._status = 'rejected';
	
			if (wasPending) {
				decrementPendingSourceCnt();
			}
		}
	
	
		function decrementPendingSourceCnt() {
			pendingSourceCnt--;
			if (!pendingSourceCnt) {
				reportEventChange(cache); // updates prunedCache
				t.trigger('eventsReceived', prunedCache);
			}
		}
	
	
		function _fetchEventSource(source, callback) {
			var i;
			var fetchers = FC.sourceFetchers;
			var res;
	
			for (i=0; i<fetchers.length; i++) {
				res = fetchers[i].call(
					t, // this, the Calendar object
					source,
					rangeStart.clone(),
					rangeEnd.clone(),
					t.options.timezone,
					callback
				);
	
				if (res === true) {
					// the fetcher is in charge. made its own async request
					return;
				}
				else if (typeof res == 'object') {
					// the fetcher returned a new source. process it
					_fetchEventSource(res, callback);
					return;
				}
			}
	
			var events = source.events;
			if (events) {
				if ($.isFunction(events)) {
					t.pushLoading();
					events.call(
						t, // this, the Calendar object
						rangeStart.clone(),
						rangeEnd.clone(),
						t.options.timezone,
						function(events) {
							callback(events);
							t.popLoading();
						}
					);
				}
				else if ($.isArray(events)) {
					callback(events);
				}
				else {
					callback();
				}
			}else{
				var url = source.url;
				if (url) {
					var success = source.success;
					var error = source.error;
					var complete = source.complete;
	
					// retrieve any outbound GET/POST $.ajax data from the options
					var customData;
					if ($.isFunction(source.data)) {
						// supplied as a function that returns a key/value object
						customData = source.data();
					}
					else {
						// supplied as a straight key/value object
						customData = source.data;
					}
	
					// use a copy of the custom data so we can modify the parameters
					// and not affect the passed-in object.
					var data = $.extend({}, customData || {});
	
					var startParam = firstDefined(source.startParam, t.options.startParam);
					var endParam = firstDefined(source.endParam, t.options.endParam);
					var timezoneParam = firstDefined(source.timezoneParam, t.options.timezoneParam);
	
					if (startParam) {
						data[startParam] = rangeStart.format();
					}
					if (endParam) {
						data[endParam] = rangeEnd.format();
					}
					if (t.options.timezone && t.options.timezone != 'local') {
						data[timezoneParam] = t.options.timezone;
					}
	
					t.pushLoading();
					$.ajax($.extend({}, ajaxDefaults, source, {
						data: data,
						success: function(events) {
							events = events || [];
							var res = applyAll(success, this, arguments);
							if ($.isArray(res)) {
								events = res;
							}
							callback(events);
						},
						error: function() {
							applyAll(error, this, arguments);
							callback();
						},
						complete: function() {
							applyAll(complete, this, arguments);
							t.popLoading();
						}
					}));
				}else{
					callback();
				}
			}
		}
	
	
	
		/* Sources
		-----------------------------------------------------------------------------*/
	
	
		function addEventSource(sourceInput) {
			var source = buildEventSource(sourceInput);
			if (source) {
				sources.push(source);
				fetchEventSources([ source ], 'add'); // will eventually call reportEventChange
			}
		}
	
	
		function buildEventSource(sourceInput) { // will return undefined if invalid source
			var normalizers = FC.sourceNormalizers;
			var source;
			var i;
	
			if ($.isFunction(sourceInput) || $.isArray(sourceInput)) {
				source = { events: sourceInput };
			}
			else if (typeof sourceInput === 'string') {
				source = { url: sourceInput };
			}
			else if (typeof sourceInput === 'object') {
				source = $.extend({}, sourceInput); // shallow copy
			}
	
			if (source) {
	
				// TODO: repeat code, same code for event classNames
				if (source.className) {
					if (typeof source.className === 'string') {
						source.className = source.className.split(/\s+/);
					}
					// otherwise, assumed to be an array
				}
				else {
					source.className = [];
				}
	
				// for array sources, we convert to standard Event Objects up front
				if ($.isArray(source.events)) {
					source.origArray = source.events; // for removeEventSource
					source.events = $.map(source.events, function(eventInput) {
						return buildEventFromInput(eventInput, source);
					});
				}
	
				for (i=0; i<normalizers.length; i++) {
					normalizers[i].call(t, source);
				}
	
				return source;
			}
		}
	
	
		function removeEventSource(matchInput) {
			removeSpecificEventSources(
				getEventSourcesByMatch(matchInput)
			);
		}
	
	
		// if called with no arguments, removes all.
		function removeEventSources(matchInputs) {
			if (matchInputs == null) {
				removeSpecificEventSources(sources, true); // isAll=true
			}
			else {
				removeSpecificEventSources(
					getEventSourcesByMatchArray(matchInputs)
				);
			}
		}
	
	
		function removeSpecificEventSources(targetSources, isAll) {
			var i;
	
			// cancel pending requests
			for (i = 0; i < targetSources.length; i++) {
				rejectEventSource(targetSources[i]);
			}
	
			if (isAll) { // an optimization
				sources = [];
				cache = [];
			}
			else {
				// remove from persisted source list
				sources = $.grep(sources, function(source) {
					for (i = 0; i < targetSources.length; i++) {
						if (source === targetSources[i]) {
							return false; // exclude
						}
					}
					return true; // include
				});
	
				cache = excludeEventsBySources(cache, targetSources);
			}
	
			reportEventChange();
		}
	
	
		function getEventSources() {
			return sources.slice(1); // returns a shallow copy of sources with stickySource removed
		}
	
	
		function getEventSourceById(id) {
			return $.grep(sources, function(source) {
				return source.id && source.id === id;
			})[0];
		}
	
	
		// like getEventSourcesByMatch, but accepts multple match criteria (like multiple IDs)
		function getEventSourcesByMatchArray(matchInputs) {
	
			// coerce into an array
			if (!matchInputs) {
				matchInputs = [];
			}
			else if (!$.isArray(matchInputs)) {
				matchInputs = [ matchInputs ];
			}
	
			var matchingSources = [];
			var i;
	
			// resolve raw inputs to real event source objects
			for (i = 0; i < matchInputs.length; i++) {
				matchingSources.push.apply( // append
					matchingSources,
					getEventSourcesByMatch(matchInputs[i])
				);
			}
	
			return matchingSources;
		}
	
	
		// matchInput can either by a real event source object, an ID, or the function/URL for the source.
		// returns an array of matching source objects.
		function getEventSourcesByMatch(matchInput) {
			var i, source;
	
			// given an proper event source object
			for (i = 0; i < sources.length; i++) {
				source = sources[i];
				if (source === matchInput) {
					return [ source ];
				}
			}
	
			// an ID match
			source = getEventSourceById(matchInput);
			if (source) {
				return [ source ];
			}
	
			return $.grep(sources, function(source) {
				return isSourcesEquivalent(matchInput, source);
			});
		}
	
	
		function isSourcesEquivalent(source1, source2) {
			return source1 && source2 && getSourcePrimitive(source1) == getSourcePrimitive(source2);
		}
	
	
		function getSourcePrimitive(source) {
			return (
				(typeof source === 'object') ? // a normalized event source?
					(source.origArray || source.googleCalendarId || source.url || source.events) : // get the primitive
					null
			) ||
			source; // the given argument *is* the primitive
		}
	
	
		// util
		// returns a filtered array without events that are part of any of the given sources
		function excludeEventsBySources(specificEvents, specificSources) {
			return $.grep(specificEvents, function(event) {
				for (var i = 0; i < specificSources.length; i++) {
					if (event.source === specificSources[i]) {
						return false; // exclude
					}
				}
				return true; // keep
			});
		}
	
	
	
		/* Manipulation
		-----------------------------------------------------------------------------*/
	
	
		// Only ever called from the externally-facing API
		function updateEvent(event) {
			updateEvents([ event ]);
		}
	
	
		// Only ever called from the externally-facing API
		function updateEvents(events) {
			var i, event;
	
			for (i = 0; i < events.length; i++) {
				event = events[i];
	
				// massage start/end values, even if date string values
				event.start = t.moment(event.start);
				if (event.end) {
					event.end = t.moment(event.end);
				}
				else {
					event.end = null;
				}
	
				mutateEvent(event, getMiscEventProps(event)); // will handle start/end/allDay normalization
			}
	
			reportEventChange(); // reports event modifications (so we can redraw)
		}
	
	
		// Returns a hash of misc event properties that should be copied over to related events.
		function getMiscEventProps(event) {
			var props = {};
	
			$.each(event, function(name, val) {
				if (isMiscEventPropName(name)) {
					if (val !== undefined && isAtomic(val)) { // a defined non-object
						props[name] = val;
					}
				}
			});
	
			return props;
		}
	
		// non-date-related, non-id-related, non-secret
		function isMiscEventPropName(name) {
			return !/^_|^(id|allDay|start|end)$/.test(name);
		}
	
	
		// returns the expanded events that were created
		function renderEvent(eventInput, stick) {
			return renderEvents([ eventInput ], stick);
		}
	
	
		// returns the expanded events that were created
		function renderEvents(eventInputs, stick) {
			var renderedEvents = [];
			var renderableEvents;
			var abstractEvent;
			var i, j, event;
	
			for (i = 0; i < eventInputs.length; i++) {
				abstractEvent = buildEventFromInput(eventInputs[i]);
	
				if (abstractEvent) { // not false (a valid input)
					renderableEvents = expandEvent(abstractEvent);
	
					for (j = 0; j < renderableEvents.length; j++) {
						event = renderableEvents[j];
	
						if (!event.source) {
							if (stick) {
								stickySource.events.push(event);
								event.source = stickySource;
							}
							cache.push(event);
						}
					}
	
					renderedEvents = renderedEvents.concat(renderableEvents);
				}
			}
	
			if (renderedEvents.length) { // any new events rendered?
				reportEventChange();
			}
	
			return renderedEvents;
		}
	
	
		function removeEvents(filter) {
			var eventID;
			var i;
	
			if (filter == null) { // null or undefined. remove all events
				filter = function() { return true; }; // will always match
			}
			else if (!$.isFunction(filter)) { // an event ID
				eventID = filter + '';
				filter = function(event) {
					return event._id == eventID;
				};
			}
	
			// Purge event(s) from our local cache
			cache = $.grep(cache, filter, true); // inverse=true
	
			// Remove events from array sources.
			// This works because they have been converted to official Event Objects up front.
			// (and as a result, event._id has been calculated).
			for (i=0; i<sources.length; i++) {
				if ($.isArray(sources[i].events)) {
					sources[i].events = $.grep(sources[i].events, filter, true);
				}
			}
	
			reportEventChange();
		}
	
	
		function clientEvents(filter) {
			if ($.isFunction(filter)) {
				return $.grep(cache, filter);
			}
			else if (filter != null) { // not null, not undefined. an event ID
				filter += '';
				return $.grep(cache, function(e) {
					return e._id == filter;
				});
			}
			return cache; // else, return all
		}
	
	
		// Makes sure all array event sources have their internal event objects
		// converted over to the Calendar's current timezone.
		t.rezoneArrayEventSources = function() {
			var i;
			var events;
			var j;
	
			for (i = 0; i < sources.length; i++) {
				events = sources[i].events;
				if ($.isArray(events)) {
	
					for (j = 0; j < events.length; j++) {
						rezoneEventDates(events[j]);
					}
				}
			}
		};
	
		function rezoneEventDates(event) {
			event.start = t.moment(event.start);
			if (event.end) {
				event.end = t.moment(event.end);
			}
			backupEventDates(event);
		}
	
	
		/* Event Normalization
		-----------------------------------------------------------------------------*/
	
	
		// Given a raw object with key/value properties, returns an "abstract" Event object.
		// An "abstract" event is an event that, if recurring, will not have been expanded yet.
		// Will return `false` when input is invalid.
		// `source` is optional
		function buildEventFromInput(input, source) {
			var out = {};
			var start, end;
			var allDay;
	
			if (t.options.eventDataTransform) {
				input = t.options.eventDataTransform(input);
			}
			if (source && source.eventDataTransform) {
				input = source.eventDataTransform(input);
			}
	
			// Copy all properties over to the resulting object.
			// The special-case properties will be copied over afterwards.
			$.extend(out, input);
	
			if (source) {
				out.source = source;
			}
	
			out._id = input._id || (input.id === undefined ? '_fc' + eventGUID++ : input.id + '');
	
			if (input.className) {
				if (typeof input.className == 'string') {
					out.className = input.className.split(/\s+/);
				}
				else { // assumed to be an array
					out.className = input.className;
				}
			}
			else {
				out.className = [];
			}
	
			start = input.start || input.date; // "date" is an alias for "start"
			end = input.end;
	
			// parse as a time (Duration) if applicable
			if (isTimeString(start)) {
				start = moment.duration(start);
			}
			if (isTimeString(end)) {
				end = moment.duration(end);
			}
	
			if (input.dow || moment.isDuration(start) || moment.isDuration(end)) {
	
				// the event is "abstract" (recurring) so don't calculate exact start/end dates just yet
				out.start = start ? moment.duration(start) : null; // will be a Duration or null
				out.end = end ? moment.duration(end) : null; // will be a Duration or null
				out._recurring = true; // our internal marker
			}
			else {
	
				if (start) {
					start = t.moment(start);
					if (!start.isValid()) {
						return false;
					}
				}
	
				if (end) {
					end = t.moment(end);
					if (!end.isValid()) {
						end = null; // let defaults take over
					}
				}
	
				allDay = input.allDay;
				if (allDay === undefined) { // still undefined? fallback to default
					allDay = firstDefined(
						source ? source.allDayDefault : undefined,
						t.options.allDayDefault
					);
					// still undefined? normalizeEventDates will calculate it
				}
	
				assignDatesToEvent(start, end, allDay, out);
			}
	
			t.normalizeEvent(out); // hook for external use. a prototype method
	
			return out;
		}
		t.buildEventFromInput = buildEventFromInput;
	
	
		// Normalizes and assigns the given dates to the given partially-formed event object.
		// NOTE: mutates the given start/end moments. does not make a copy.
		function assignDatesToEvent(start, end, allDay, event) {
			event.start = start;
			event.end = end;
			event.allDay = allDay;
			normalizeEventDates(event);
			backupEventDates(event);
		}
	
	
		// Ensures proper values for allDay/start/end. Accepts an Event object, or a plain object with event-ish properties.
		// NOTE: Will modify the given object.
		function normalizeEventDates(eventProps) {
	
			normalizeEventTimes(eventProps);
	
			if (eventProps.end && !eventProps.end.isAfter(eventProps.start)) {
				eventProps.end = null;
			}
	
			if (!eventProps.end) {
				if (t.options.forceEventDuration) {
					eventProps.end = t.getDefaultEventEnd(eventProps.allDay, eventProps.start);
				}
				else {
					eventProps.end = null;
				}
			}
		}
	
	
		// Ensures the allDay property exists and the timeliness of the start/end dates are consistent
		function normalizeEventTimes(eventProps) {
			if (eventProps.allDay == null) {
				eventProps.allDay = !(eventProps.start.hasTime() || (eventProps.end && eventProps.end.hasTime()));
			}
	
			if (eventProps.allDay) {
				eventProps.start.stripTime();
				if (eventProps.end) {
					// TODO: consider nextDayThreshold here? If so, will require a lot of testing and adjustment
					eventProps.end.stripTime();
				}
			}
			else {
				if (!eventProps.start.hasTime()) {
					eventProps.start = t.applyTimezone(eventProps.start.time(0)); // will assign a 00:00 time
				}
				if (eventProps.end && !eventProps.end.hasTime()) {
					eventProps.end = t.applyTimezone(eventProps.end.time(0)); // will assign a 00:00 time
				}
			}
		}
	
	
		// If the given event is a recurring event, break it down into an array of individual instances.
		// If not a recurring event, return an array with the single original event.
		// If given a falsy input (probably because of a failed buildEventFromInput call), returns an empty array.
		// HACK: can override the recurring window by providing custom rangeStart/rangeEnd (for businessHours).
		function expandEvent(abstractEvent, _rangeStart, _rangeEnd) {
			var events = [];
			var dowHash;
			var dow;
			var i;
			var date;
			var startTime, endTime;
			var start, end;
			var event;
	
			_rangeStart = _rangeStart || rangeStart;
			_rangeEnd = _rangeEnd || rangeEnd;
	
			if (abstractEvent) {
				if (abstractEvent._recurring) {
	
					// make a boolean hash as to whether the event occurs on each day-of-week
					if ((dow = abstractEvent.dow)) {
						dowHash = {};
						for (i = 0; i < dow.length; i++) {
							dowHash[dow[i]] = true;
						}
					}
	
					// iterate through every day in the current range
					date = _rangeStart.clone().stripTime(); // holds the date of the current day
					while (date.isBefore(_rangeEnd)) {
	
						if (!dowHash || dowHash[date.day()]) { // if everyday, or this particular day-of-week
	
							startTime = abstractEvent.start; // the stored start and end properties are times (Durations)
							endTime = abstractEvent.end; // "
							start = date.clone();
							end = null;
	
							if (startTime) {
								start = start.time(startTime);
							}
							if (endTime) {
								end = date.clone().time(endTime);
							}
	
							event = $.extend({}, abstractEvent); // make a copy of the original
							assignDatesToEvent(
								start, end,
								!startTime && !endTime, // allDay?
								event
							);
							events.push(event);
						}
	
						date.add(1, 'days');
					}
				}
				else {
					events.push(abstractEvent); // return the original event. will be a one-item array
				}
			}
	
			return events;
		}
		t.expandEvent = expandEvent;
	
	
	
		/* Event Modification Math
		-----------------------------------------------------------------------------------------*/
	
	
		// Modifies an event and all related events by applying the given properties.
		// Special date-diffing logic is used for manipulation of dates.
		// If `props` does not contain start/end dates, the updated values are assumed to be the event's current start/end.
		// All date comparisons are done against the event's pristine _start and _end dates.
		// Returns an object with delta information and a function to undo all operations.
		// For making computations in a granularity greater than day/time, specify largeUnit.
		// NOTE: The given `newProps` might be mutated for normalization purposes.
		function mutateEvent(event, newProps, largeUnit) {
			var miscProps = {};
			var oldProps;
			var clearEnd;
			var startDelta;
			var endDelta;
			var durationDelta;
			var undoFunc;
	
			// diffs the dates in the appropriate way, returning a duration
			function diffDates(date1, date0) { // date1 - date0
				if (largeUnit) {
					return diffByUnit(date1, date0, largeUnit);
				}
				else if (newProps.allDay) {
					return diffDay(date1, date0);
				}
				else {
					return diffDayTime(date1, date0);
				}
			}
	
			newProps = newProps || {};
	
			// normalize new date-related properties
			if (!newProps.start) {
				newProps.start = event.start.clone();
			}
			if (newProps.end === undefined) {
				newProps.end = event.end ? event.end.clone() : null;
			}
			if (newProps.allDay == null) { // is null or undefined?
				newProps.allDay = event.allDay;
			}
			normalizeEventDates(newProps);
	
			// create normalized versions of the original props to compare against
			// need a real end value, for diffing
			oldProps = {
				start: event._start.clone(),
				end: event._end ? event._end.clone() : t.getDefaultEventEnd(event._allDay, event._start),
				allDay: newProps.allDay // normalize the dates in the same regard as the new properties
			};
			normalizeEventDates(oldProps);
	
			// need to clear the end date if explicitly changed to null
			clearEnd = event._end !== null && newProps.end === null;
	
			// compute the delta for moving the start date
			startDelta = diffDates(newProps.start, oldProps.start);
	
			// compute the delta for moving the end date
			if (newProps.end) {
				endDelta = diffDates(newProps.end, oldProps.end);
				durationDelta = endDelta.subtract(startDelta);
			}
			else {
				durationDelta = null;
			}
	
			// gather all non-date-related properties
			$.each(newProps, function(name, val) {
				if (isMiscEventPropName(name)) {
					if (val !== undefined) {
						miscProps[name] = val;
					}
				}
			});
	
			// apply the operations to the event and all related events
			undoFunc = mutateEvents(
				clientEvents(event._id), // get events with this ID
				clearEnd,
				newProps.allDay,
				startDelta,
				durationDelta,
				miscProps
			);
	
			return {
				dateDelta: startDelta,
				durationDelta: durationDelta,
				undo: undoFunc
			};
		}
	
	
		// Modifies an array of events in the following ways (operations are in order):
		// - clear the event's `end`
		// - convert the event to allDay
		// - add `dateDelta` to the start and end
		// - add `durationDelta` to the event's duration
		// - assign `miscProps` to the event
		//
		// Returns a function that can be called to undo all the operations.
		//
		// TODO: don't use so many closures. possible memory issues when lots of events with same ID.
		//
		function mutateEvents(events, clearEnd, allDay, dateDelta, durationDelta, miscProps) {
			var isAmbigTimezone = t.getIsAmbigTimezone();
			var undoFunctions = [];
	
			// normalize zero-length deltas to be null
			if (dateDelta && !dateDelta.valueOf()) { dateDelta = null; }
			if (durationDelta && !durationDelta.valueOf()) { durationDelta = null; }
	
			$.each(events, function(i, event) {
				var oldProps;
				var newProps;
	
				// build an object holding all the old values, both date-related and misc.
				// for the undo function.
				oldProps = {
					start: event.start.clone(),
					end: event.end ? event.end.clone() : null,
					allDay: event.allDay
				};
				$.each(miscProps, function(name) {
					oldProps[name] = event[name];
				});
	
				// new date-related properties. work off the original date snapshot.
				// ok to use references because they will be thrown away when backupEventDates is called.
				newProps = {
					start: event._start,
					end: event._end,
					allDay: allDay // normalize the dates in the same regard as the new properties
				};
				normalizeEventDates(newProps); // massages start/end/allDay
	
				// strip or ensure the end date
				if (clearEnd) {
					newProps.end = null;
				}
				else if (durationDelta && !newProps.end) { // the duration translation requires an end date
					newProps.end = t.getDefaultEventEnd(newProps.allDay, newProps.start);
				}
	
				if (dateDelta) {
					newProps.start.add(dateDelta);
					if (newProps.end) {
						newProps.end.add(dateDelta);
					}
				}
	
				if (durationDelta) {
					newProps.end.add(durationDelta); // end already ensured above
				}
	
				// if the dates have changed, and we know it is impossible to recompute the
				// timezone offsets, strip the zone.
				if (
					isAmbigTimezone &&
					!newProps.allDay &&
					(dateDelta || durationDelta)
				) {
					newProps.start.stripZone();
					if (newProps.end) {
						newProps.end.stripZone();
					}
				}
	
				$.extend(event, miscProps, newProps); // copy over misc props, then date-related props
				backupEventDates(event); // regenerate internal _start/_end/_allDay
	
				undoFunctions.push(function() {
					$.extend(event, oldProps);
					backupEventDates(event); // regenerate internal _start/_end/_allDay
				});
			});
	
			return function() {
				for (var i = 0; i < undoFunctions.length; i++) {
					undoFunctions[i]();
				}
			};
		}
	
	}
	
	
	// hook for external libs to manipulate event properties upon creation.
	// should manipulate the event in-place.
	Calendar.prototype.normalizeEvent = function(event) {
	};
	
	
	// Does the given span (start, end, and other location information)
	// fully contain the other?
	Calendar.prototype.spanContainsSpan = function(outerSpan, innerSpan) {
		var eventStart = outerSpan.start.clone().stripZone();
		var eventEnd = this.getEventEnd(outerSpan).stripZone();
	
		return innerSpan.start >= eventStart && innerSpan.end <= eventEnd;
	};
	
	
	// Returns a list of events that the given event should be compared against when being considered for a move to
	// the specified span. Attached to the Calendar's prototype because EventManager is a mixin for a Calendar.
	Calendar.prototype.getPeerEvents = function(span, event) {
		var cache = this.getEventCache();
		var peerEvents = [];
		var i, otherEvent;
	
		for (i = 0; i < cache.length; i++) {
			otherEvent = cache[i];
			if (
				!event ||
				event._id !== otherEvent._id // don't compare the event to itself or other related [repeating] events
			) {
				peerEvents.push(otherEvent);
			}
		}
	
		return peerEvents;
	};
	
	
	// updates the "backup" properties, which are preserved in order to compute diffs later on.
	function backupEventDates(event) {
		event._allDay = event.allDay;
		event._start = event.start.clone();
		event._end = event.end ? event.end.clone() : null;
	}
	
	
	/* Overlapping / Constraining
	-----------------------------------------------------------------------------------------*/
	
	
	// Determines if the given event can be relocated to the given span (unzoned start/end with other misc data)
	Calendar.prototype.isEventSpanAllowed = function(span, event) {
		var source = event.source || {};
	
		var constraint = firstDefined(
			event.constraint,
			source.constraint,
			this.options.eventConstraint
		);
	
		var overlap = firstDefined(
			event.overlap,
			source.overlap,
			this.options.eventOverlap
		);
	
		return this.isSpanAllowed(span, constraint, overlap, event) &&
			(!this.options.eventAllow || this.options.eventAllow(span, event) !== false);
	};
	
	
	// Determines if an external event can be relocated to the given span (unzoned start/end with other misc data)
	Calendar.prototype.isExternalSpanAllowed = function(eventSpan, eventLocation, eventProps) {
		var eventInput;
		var event;
	
		// note: very similar logic is in View's reportExternalDrop
		if (eventProps) {
			eventInput = $.extend({}, eventProps, eventLocation);
			event = this.expandEvent(
				this.buildEventFromInput(eventInput)
			)[0];
		}
	
		if (event) {
			return this.isEventSpanAllowed(eventSpan, event);
		}
		else { // treat it as a selection
	
			return this.isSelectionSpanAllowed(eventSpan);
		}
	};
	
	
	// Determines the given span (unzoned start/end with other misc data) can be selected.
	Calendar.prototype.isSelectionSpanAllowed = function(span) {
		return this.isSpanAllowed(span, this.options.selectConstraint, this.options.selectOverlap) &&
			(!this.options.selectAllow || this.options.selectAllow(span) !== false);
	};
	
	
	// Returns true if the given span (caused by an event drop/resize or a selection) is allowed to exist
	// according to the constraint/overlap settings.
	// `event` is not required if checking a selection.
	Calendar.prototype.isSpanAllowed = function(span, constraint, overlap, event) {
		var constraintEvents;
		var anyContainment;
		var peerEvents;
		var i, peerEvent;
		var peerOverlap;
	
		// the range must be fully contained by at least one of produced constraint events
		if (constraint != null) {
	
			// not treated as an event! intermediate data structure
			// TODO: use ranges in the future
			constraintEvents = this.constraintToEvents(constraint);
			if (constraintEvents) { // not invalid
	
				anyContainment = false;
				for (i = 0; i < constraintEvents.length; i++) {
					if (this.spanContainsSpan(constraintEvents[i], span)) {
						anyContainment = true;
						break;
					}
				}
	
				if (!anyContainment) {
					return false;
				}
			}
		}
	
		peerEvents = this.getPeerEvents(span, event);
	
		for (i = 0; i < peerEvents.length; i++)  {
			peerEvent = peerEvents[i];
	
			// there needs to be an actual intersection before disallowing anything
			if (this.eventIntersectsRange(peerEvent, span)) {
	
				// evaluate overlap for the given range and short-circuit if necessary
				if (overlap === false) {
					return false;
				}
				// if the event's overlap is a test function, pass the peer event in question as the first param
				else if (typeof overlap === 'function' && !overlap(peerEvent, event)) {
					return false;
				}
	
				// if we are computing if the given range is allowable for an event, consider the other event's
				// EventObject-specific or Source-specific `overlap` property
				if (event) {
					peerOverlap = firstDefined(
						peerEvent.overlap,
						(peerEvent.source || {}).overlap
						// we already considered the global `eventOverlap`
					);
					if (peerOverlap === false) {
						return false;
					}
					// if the peer event's overlap is a test function, pass the subject event as the first param
					if (typeof peerOverlap === 'function' && !peerOverlap(event, peerEvent)) {
						return false;
					}
				}
			}
		}
	
		return true;
	};
	
	
	// Given an event input from the API, produces an array of event objects. Possible event inputs:
	// 'businessHours'
	// An event ID (number or string)
	// An object with specific start/end dates or a recurring event (like what businessHours accepts)
	Calendar.prototype.constraintToEvents = function(constraintInput) {
	
		if (constraintInput === 'businessHours') {
			return this.getCurrentBusinessHourEvents();
		}
	
		if (typeof constraintInput === 'object') {
			if (constraintInput.start != null) { // needs to be event-like input
				return this.expandEvent(this.buildEventFromInput(constraintInput));
			}
			else {
				return null; // invalid
			}
		}
	
		return this.clientEvents(constraintInput); // probably an ID
	};
	
	
	// Does the event's date range intersect with the given range?
	// start/end already assumed to have stripped zones :(
	Calendar.prototype.eventIntersectsRange = function(event, range) {
		var eventStart = event.start.clone().stripZone();
		var eventEnd = this.getEventEnd(event).stripZone();
	
		return range.start < eventEnd && range.end > eventStart;
	};
	
	
	/* Business Hours
	-----------------------------------------------------------------------------------------*/
	
	var BUSINESS_HOUR_EVENT_DEFAULTS = {
		id: '_fcBusinessHours', // will relate events from different calls to expandEvent
		start: '09:00',
		end: '17:00',
		dow: [ 1, 2, 3, 4, 5 ], // monday - friday
		rendering: 'inverse-background'
		// classNames are defined in businessHoursSegClasses
	};
	
	// Return events objects for business hours within the current view.
	// Abuse of our event system :(
	Calendar.prototype.getCurrentBusinessHourEvents = function(wholeDay) {
		return this.computeBusinessHourEvents(wholeDay, this.options.businessHours);
	};
	
	// Given a raw input value from options, return events objects for business hours within the current view.
	Calendar.prototype.computeBusinessHourEvents = function(wholeDay, input) {
		if (input === true) {
			return this.expandBusinessHourEvents(wholeDay, [ {} ]);
		}
		else if ($.isPlainObject(input)) {
			return this.expandBusinessHourEvents(wholeDay, [ input ]);
		}
		else if ($.isArray(input)) {
			return this.expandBusinessHourEvents(wholeDay, input, true);
		}
		else {
			return [];
		}
	};
	
	// inputs expected to be an array of objects.
	// if ignoreNoDow is true, will ignore entries that don't specify a day-of-week (dow) key.
	Calendar.prototype.expandBusinessHourEvents = function(wholeDay, inputs, ignoreNoDow) {
		var view = this.getView();
		var events = [];
		var i, input;
	
		for (i = 0; i < inputs.length; i++) {
			input = inputs[i];
	
			if (ignoreNoDow && !input.dow) {
				continue;
			}
	
			// give defaults. will make a copy
			input = $.extend({}, BUSINESS_HOUR_EVENT_DEFAULTS, input);
	
			// if a whole-day series is requested, clear the start/end times
			if (wholeDay) {
				input.start = null;
				input.end = null;
			}
	
			events.push.apply(events, // append
				this.expandEvent(
					this.buildEventFromInput(input),
					view.start,
					view.end
				)
			);
		}
	
		return events;
	};
	
	;;
	
	/* An abstract class for the "basic" views, as well as month view. Renders one or more rows of day cells.
	----------------------------------------------------------------------------------------------------------------------*/
	// It is a manager for a DayGrid subcomponent, which does most of the heavy lifting.
	// It is responsible for managing width/height.
	
	var BasicView = FC.BasicView = View.extend({
	
		scroller: null,
	
		dayGridClass: DayGrid, // class the dayGrid will be instantiated from (overridable by subclasses)
		dayGrid: null, // the main subcomponent that does most of the heavy lifting
	
		dayNumbersVisible: false, // display day numbers on each day cell?
		colWeekNumbersVisible: false, // display week numbers along the side?
		cellWeekNumbersVisible: false, // display week numbers in day cell?
	
		weekNumberWidth: null, // width of all the week-number cells running down the side
	
		headContainerEl: null, // div that hold's the dayGrid's rendered date header
		headRowEl: null, // the fake row element of the day-of-week header
	
	
		initialize: function() {
			this.dayGrid = this.instantiateDayGrid();
	
			this.scroller = new Scroller({
				overflowX: 'hidden',
				overflowY: 'auto'
			});
		},
	
	
		// Generates the DayGrid object this view needs. Draws from this.dayGridClass
		instantiateDayGrid: function() {
			// generate a subclass on the fly with BasicView-specific behavior
			// TODO: cache this subclass
			var subclass = this.dayGridClass.extend(basicDayGridMethods);
	
			return new subclass(this);
		},
	
	
		// Sets the display range and computes all necessary dates
		setRange: function(range) {
			View.prototype.setRange.call(this, range); // call the super-method
	
			this.dayGrid.breakOnWeeks = /year|month|week/.test(this.intervalUnit); // do before setRange
			this.dayGrid.setRange(range);
		},
	
	
		// Compute the value to feed into setRange. Overrides superclass.
		computeRange: function(date) {
			var range = View.prototype.computeRange.call(this, date); // get value from the super-method
	
			// year and month views should be aligned with weeks. this is already done for week
			if (/year|month/.test(range.intervalUnit)) {
				range.start.startOf('week');
				range.start = this.skipHiddenDays(range.start);
	
				// make end-of-week if not already
				if (range.end.weekday()) {
					range.end.add(1, 'week').startOf('week');
					range.end = this.skipHiddenDays(range.end, -1, true); // exclusively move backwards
				}
			}
	
			return range;
		},
	
	
		// Renders the view into `this.el`, which should already be assigned
		renderDates: function() {
	
			this.dayNumbersVisible = this.dayGrid.rowCnt > 1; // TODO: make grid responsible
			if (this.opt('weekNumbers')) {
				if (this.opt('weekNumbersWithinDays')) {
					this.cellWeekNumbersVisible = true;
					this.colWeekNumbersVisible = false;
				}
				else {
					this.cellWeekNumbersVisible = false;
					this.colWeekNumbersVisible = true;
				};
			}
			this.dayGrid.numbersVisible = this.dayNumbersVisible ||
				this.cellWeekNumbersVisible || this.colWeekNumbersVisible;
	
			this.el.addClass('fc-basic-view').html(this.renderSkeletonHtml());
			this.renderHead();
	
			this.scroller.render();
			var dayGridContainerEl = this.scroller.el.addClass('fc-day-grid-container');
			var dayGridEl = $('<div class="fc-day-grid" />').appendTo(dayGridContainerEl);
			this.el.find('.fc-body > tr > td').append(dayGridContainerEl);
	
			this.dayGrid.setElement(dayGridEl);
			this.dayGrid.renderDates(this.hasRigidRows());
		},
	
	
		// render the day-of-week headers
		renderHead: function() {
			this.headContainerEl =
				this.el.find('.fc-head-container')
					.html(this.dayGrid.renderHeadHtml());
			this.headRowEl = this.headContainerEl.find('.fc-row');
		},
	
	
		// Unrenders the content of the view. Since we haven't separated skeleton rendering from date rendering,
		// always completely kill the dayGrid's rendering.
		unrenderDates: function() {
			this.dayGrid.unrenderDates();
			this.dayGrid.removeElement();
			this.scroller.destroy();
		},
	
	
		renderBusinessHours: function() {
			this.dayGrid.renderBusinessHours();
		},
	
	
		unrenderBusinessHours: function() {
			this.dayGrid.unrenderBusinessHours();
		},
	
	
		// Builds the HTML skeleton for the view.
		// The day-grid component will render inside of a container defined by this HTML.
		renderSkeletonHtml: function() {
			return '' +
				'<table>' +
					'<thead class="fc-head">' +
						'<tr>' +
							'<td class="fc-head-container ' + this.widgetHeaderClass + '"></td>' +
						'</tr>' +
					'</thead>' +
					'<tbody class="fc-body">' +
						'<tr>' +
							'<td class="' + this.widgetContentClass + '"></td>' +
						'</tr>' +
					'</tbody>' +
				'</table>';
		},
	
	
		// Generates an HTML attribute string for setting the width of the week number column, if it is known
		weekNumberStyleAttr: function() {
			if (this.weekNumberWidth !== null) {
				return 'style="width:' + this.weekNumberWidth + 'px"';
			}
			return '';
		},
	
	
		// Determines whether each row should have a constant height
		hasRigidRows: function() {
			var eventLimit = this.opt('eventLimit');
			return eventLimit && typeof eventLimit !== 'number';
		},
	
	
		/* Dimensions
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Refreshes the horizontal dimensions of the view
		updateWidth: function() {
			if (this.colWeekNumbersVisible) {
				// Make sure all week number cells running down the side have the same width.
				// Record the width for cells created later.
				this.weekNumberWidth = matchCellWidths(
					this.el.find('.fc-week-number')
				);
			}
		},
	
	
		// Adjusts the vertical dimensions of the view to the specified values
		setHeight: function(totalHeight, isAuto) {
			var eventLimit = this.opt('eventLimit');
			var scrollerHeight;
			var scrollbarWidths;
	
			// reset all heights to be natural
			this.scroller.clear();
			uncompensateScroll(this.headRowEl);
	
			this.dayGrid.removeSegPopover(); // kill the "more" popover if displayed
	
			// is the event limit a constant level number?
			if (eventLimit && typeof eventLimit === 'number') {
				this.dayGrid.limitRows(eventLimit); // limit the levels first so the height can redistribute after
			}
	
			// distribute the height to the rows
			// (totalHeight is a "recommended" value if isAuto)
			scrollerHeight = this.computeScrollerHeight(totalHeight);
			this.setGridHeight(scrollerHeight, isAuto);
	
			// is the event limit dynamically calculated?
			if (eventLimit && typeof eventLimit !== 'number') {
				this.dayGrid.limitRows(eventLimit); // limit the levels after the grid's row heights have been set
			}
	
			if (!isAuto) { // should we force dimensions of the scroll container?
	
				this.scroller.setHeight(scrollerHeight);
				scrollbarWidths = this.scroller.getScrollbarWidths();
	
				if (scrollbarWidths.left || scrollbarWidths.right) { // using scrollbars?
	
					compensateScroll(this.headRowEl, scrollbarWidths);
	
					// doing the scrollbar compensation might have created text overflow which created more height. redo
					scrollerHeight = this.computeScrollerHeight(totalHeight);
					this.scroller.setHeight(scrollerHeight);
				}
	
				// guarantees the same scrollbar widths
				this.scroller.lockOverflow(scrollbarWidths);
			}
		},
	
	
		// given a desired total height of the view, returns what the height of the scroller should be
		computeScrollerHeight: function(totalHeight) {
			return totalHeight -
				subtractInnerElHeight(this.el, this.scroller.el); // everything that's NOT the scroller
		},
	
	
		// Sets the height of just the DayGrid component in this view
		setGridHeight: function(height, isAuto) {
			if (isAuto) {
				undistributeHeight(this.dayGrid.rowEls); // let the rows be their natural height with no expanding
			}
			else {
				distributeHeight(this.dayGrid.rowEls, height, true); // true = compensate for height-hogging rows
			}
		},
	
	
		/* Scroll
		------------------------------------------------------------------------------------------------------------------*/
	
	
		computeInitialScroll: function() {
			return { top: 0 };
		},
	
	
		queryScroll: function() {
			return { top: this.scroller.getScrollTop() };
		},
	
	
		setScroll: function(scroll) {
			this.scroller.setScrollTop(scroll.top);
		},
	
	
		/* Hit Areas
		------------------------------------------------------------------------------------------------------------------*/
		// forward all hit-related method calls to dayGrid
	
	
		prepareHits: function() {
			this.dayGrid.prepareHits();
		},
	
	
		releaseHits: function() {
			this.dayGrid.releaseHits();
		},
	
	
		queryHit: function(left, top) {
			return this.dayGrid.queryHit(left, top);
		},
	
	
		getHitSpan: function(hit) {
			return this.dayGrid.getHitSpan(hit);
		},
	
	
		getHitEl: function(hit) {
			return this.dayGrid.getHitEl(hit);
		},
	
	
		/* Events
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Renders the given events onto the view and populates the segments array
		renderEvents: function(events) {
			this.dayGrid.renderEvents(events);
	
			this.updateHeight(); // must compensate for events that overflow the row
		},
	
	
		// Retrieves all segment objects that are rendered in the view
		getEventSegs: function() {
			return this.dayGrid.getEventSegs();
		},
	
	
		// Unrenders all event elements and clears internal segment data
		unrenderEvents: function() {
			this.dayGrid.unrenderEvents();
	
			// we DON'T need to call updateHeight() because
			// a renderEvents() call always happens after this, which will eventually call updateHeight()
		},
	
	
		/* Dragging (for both events and external elements)
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// A returned value of `true` signals that a mock "helper" event has been rendered.
		renderDrag: function(dropLocation, seg) {
			return this.dayGrid.renderDrag(dropLocation, seg);
		},
	
	
		unrenderDrag: function() {
			this.dayGrid.unrenderDrag();
		},
	
	
		/* Selection
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Renders a visual indication of a selection
		renderSelection: function(span) {
			this.dayGrid.renderSelection(span);
		},
	
	
		// Unrenders a visual indications of a selection
		unrenderSelection: function() {
			this.dayGrid.unrenderSelection();
		}
	
	});
	
	
	// Methods that will customize the rendering behavior of the BasicView's dayGrid
	var basicDayGridMethods = {
	
	
		// Generates the HTML that will go before the day-of week header cells
		renderHeadIntroHtml: function() {
			var view = this.view;
	
			if (view.colWeekNumbersVisible) {
				return '' +
					'<th class="fc-week-number ' + view.widgetHeaderClass + '" ' + view.weekNumberStyleAttr() + '>' +
						'<span>' + // needed for matchCellWidths
							htmlEscape(view.opt('weekNumberTitle')) +
						'</span>' +
					'</th>';
			}
	
			return '';
		},
	
	
		// Generates the HTML that will go before content-skeleton cells that display the day/week numbers
		renderNumberIntroHtml: function(row) {
			var view = this.view;
			var weekStart = this.getCellDate(row, 0);
	
			if (view.colWeekNumbersVisible) {
				return '' +
					'<td class="fc-week-number" ' + view.weekNumberStyleAttr() + '>' +
						view.buildGotoAnchorHtml( // aside from link, important for matchCellWidths
							{ date: weekStart, type: 'week', forceOff: this.colCnt === 1 },
							weekStart.format('w') // inner HTML
						) +
					'</td>';
			}
	
			return '';
		},
	
	
		// Generates the HTML that goes before the day bg cells for each day-row
		renderBgIntroHtml: function() {
			var view = this.view;
	
			if (view.colWeekNumbersVisible) {
				return '<td class="fc-week-number ' + view.widgetContentClass + '" ' +
					view.weekNumberStyleAttr() + '></td>';
			}
	
			return '';
		},
	
	
		// Generates the HTML that goes before every other type of row generated by DayGrid.
		// Affects helper-skeleton and highlight-skeleton rows.
		renderIntroHtml: function() {
			var view = this.view;
	
			if (view.colWeekNumbersVisible) {
				return '<td class="fc-week-number" ' + view.weekNumberStyleAttr() + '></td>';
			}
	
			return '';
		}
	
	};
	
	;;
	
	/* A month view with day cells running in rows (one-per-week) and columns
	----------------------------------------------------------------------------------------------------------------------*/
	
	var MonthView = FC.MonthView = BasicView.extend({
	
		// Produces information about what range to display
		computeRange: function(date) {
			var range = BasicView.prototype.computeRange.call(this, date); // get value from super-method
			var rowCnt;
	
			// ensure 6 weeks
			if (this.isFixedWeeks()) {
				rowCnt = Math.ceil(range.end.diff(range.start, 'weeks', true)); // could be partial weeks due to hiddenDays
				range.end.add(6 - rowCnt, 'weeks');
			}
	
			return range;
		},
	
	
		// Overrides the default BasicView behavior to have special multi-week auto-height logic
		setGridHeight: function(height, isAuto) {
	
			// if auto, make the height of each row the height that it would be if there were 6 weeks
			if (isAuto) {
				height *= this.rowCnt / 6;
			}
	
			distributeHeight(this.dayGrid.rowEls, height, !isAuto); // if auto, don't compensate for height-hogging rows
		},
	
	
		isFixedWeeks: function() {
			return this.opt('fixedWeekCount');
		}
	
	});
	
	;;
	
	fcViews.basic = {
		'class': BasicView
	};
	
	fcViews.basicDay = {
		type: 'basic',
		duration: { days: 1 }
	};
	
	fcViews.basicWeek = {
		type: 'basic',
		duration: { weeks: 1 }
	};
	
	fcViews.month = {
		'class': MonthView,
		duration: { months: 1 }, // important for prev/next
		defaults: {
			fixedWeekCount: true
		}
	};
	;;
	
	/* An abstract class for all agenda-related views. Displays one more columns with time slots running vertically.
	----------------------------------------------------------------------------------------------------------------------*/
	// Is a manager for the TimeGrid subcomponent and possibly the DayGrid subcomponent (if allDaySlot is on).
	// Responsible for managing width/height.
	
	var AgendaView = FC.AgendaView = View.extend({
	
		scroller: null,
	
		timeGridClass: TimeGrid, // class used to instantiate the timeGrid. subclasses can override
		timeGrid: null, // the main time-grid subcomponent of this view
	
		dayGridClass: DayGrid, // class used to instantiate the dayGrid. subclasses can override
		dayGrid: null, // the "all-day" subcomponent. if all-day is turned off, this will be null
	
		axisWidth: null, // the width of the time axis running down the side
	
		headContainerEl: null, // div that hold's the timeGrid's rendered date header
		noScrollRowEls: null, // set of fake row elements that must compensate when scroller has scrollbars
	
		// when the time-grid isn't tall enough to occupy the given height, we render an <hr> underneath
		bottomRuleEl: null,
	
	
		initialize: function() {
			this.timeGrid = this.instantiateTimeGrid();
	
			if (this.opt('allDaySlot')) { // should we display the "all-day" area?
				this.dayGrid = this.instantiateDayGrid(); // the all-day subcomponent of this view
			}
	
			this.scroller = new Scroller({
				overflowX: 'hidden',
				overflowY: 'auto'
			});
		},
	
	
		// Instantiates the TimeGrid object this view needs. Draws from this.timeGridClass
		instantiateTimeGrid: function() {
			var subclass = this.timeGridClass.extend(agendaTimeGridMethods);
	
			return new subclass(this);
		},
	
	
		// Instantiates the DayGrid object this view might need. Draws from this.dayGridClass
		instantiateDayGrid: function() {
			var subclass = this.dayGridClass.extend(agendaDayGridMethods);
	
			return new subclass(this);
		},
	
	
		/* Rendering
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Sets the display range and computes all necessary dates
		setRange: function(range) {
			View.prototype.setRange.call(this, range); // call the super-method
	
			this.timeGrid.setRange(range);
			if (this.dayGrid) {
				this.dayGrid.setRange(range);
			}
		},
	
	
		// Renders the view into `this.el`, which has already been assigned
		renderDates: function() {
	
			this.el.addClass('fc-agenda-view').html(this.renderSkeletonHtml());
			this.renderHead();
	
			this.scroller.render();
			var timeGridWrapEl = this.scroller.el.addClass('fc-time-grid-container');
			var timeGridEl = $('<div class="fc-time-grid" />').appendTo(timeGridWrapEl);
			this.el.find('.fc-body > tr > td').append(timeGridWrapEl);
	
			this.timeGrid.setElement(timeGridEl);
			this.timeGrid.renderDates();
	
			// the <hr> that sometimes displays under the time-grid
			this.bottomRuleEl = $('<hr class="fc-divider ' + this.widgetHeaderClass + '"/>')
				.appendTo(this.timeGrid.el); // inject it into the time-grid
	
			if (this.dayGrid) {
				this.dayGrid.setElement(this.el.find('.fc-day-grid'));
				this.dayGrid.renderDates();
	
				// have the day-grid extend it's coordinate area over the <hr> dividing the two grids
				this.dayGrid.bottomCoordPadding = this.dayGrid.el.next('hr').outerHeight();
			}
	
			this.noScrollRowEls = this.el.find('.fc-row:not(.fc-scroller *)'); // fake rows not within the scroller
		},
	
	
		// render the day-of-week headers
		renderHead: function() {
			this.headContainerEl =
				this.el.find('.fc-head-container')
					.html(this.timeGrid.renderHeadHtml());
		},
	
	
		// Unrenders the content of the view. Since we haven't separated skeleton rendering from date rendering,
		// always completely kill each grid's rendering.
		unrenderDates: function() {
			this.timeGrid.unrenderDates();
			this.timeGrid.removeElement();
	
			if (this.dayGrid) {
				this.dayGrid.unrenderDates();
				this.dayGrid.removeElement();
			}
	
			this.scroller.destroy();
		},
	
	
		// Builds the HTML skeleton for the view.
		// The day-grid and time-grid components will render inside containers defined by this HTML.
		renderSkeletonHtml: function() {
			return '' +
				'<table>' +
					'<thead class="fc-head">' +
						'<tr>' +
							'<td class="fc-head-container ' + this.widgetHeaderClass + '"></td>' +
						'</tr>' +
					'</thead>' +
					'<tbody class="fc-body">' +
						'<tr>' +
							'<td class="' + this.widgetContentClass + '">' +
								(this.dayGrid ?
									'<div class="fc-day-grid"/>' +
									'<hr class="fc-divider ' + this.widgetHeaderClass + '"/>' :
									''
									) +
							'</td>' +
						'</tr>' +
					'</tbody>' +
				'</table>';
		},
	
	
		// Generates an HTML attribute string for setting the width of the axis, if it is known
		axisStyleAttr: function() {
			if (this.axisWidth !== null) {
				 return 'style="width:' + this.axisWidth + 'px"';
			}
			return '';
		},
	
	
		/* Business Hours
		------------------------------------------------------------------------------------------------------------------*/
	
	
		renderBusinessHours: function() {
			this.timeGrid.renderBusinessHours();
	
			if (this.dayGrid) {
				this.dayGrid.renderBusinessHours();
			}
		},
	
	
		unrenderBusinessHours: function() {
			this.timeGrid.unrenderBusinessHours();
	
			if (this.dayGrid) {
				this.dayGrid.unrenderBusinessHours();
			}
		},
	
	
		/* Now Indicator
		------------------------------------------------------------------------------------------------------------------*/
	
	
		getNowIndicatorUnit: function() {
			return this.timeGrid.getNowIndicatorUnit();
		},
	
	
		renderNowIndicator: function(date) {
			this.timeGrid.renderNowIndicator(date);
		},
	
	
		unrenderNowIndicator: function() {
			this.timeGrid.unrenderNowIndicator();
		},
	
	
		/* Dimensions
		------------------------------------------------------------------------------------------------------------------*/
	
	
		updateSize: function(isResize) {
			this.timeGrid.updateSize(isResize);
	
			View.prototype.updateSize.call(this, isResize); // call the super-method
		},
	
	
		// Refreshes the horizontal dimensions of the view
		updateWidth: function() {
			// make all axis cells line up, and record the width so newly created axis cells will have it
			this.axisWidth = matchCellWidths(this.el.find('.fc-axis'));
		},
	
	
		// Adjusts the vertical dimensions of the view to the specified values
		setHeight: function(totalHeight, isAuto) {
			var eventLimit;
			var scrollerHeight;
			var scrollbarWidths;
	
			// reset all dimensions back to the original state
			this.bottomRuleEl.hide(); // .show() will be called later if this <hr> is necessary
			this.scroller.clear(); // sets height to 'auto' and clears overflow
			uncompensateScroll(this.noScrollRowEls);
	
			// limit number of events in the all-day area
			if (this.dayGrid) {
				this.dayGrid.removeSegPopover(); // kill the "more" popover if displayed
	
				eventLimit = this.opt('eventLimit');
				if (eventLimit && typeof eventLimit !== 'number') {
					eventLimit = AGENDA_ALL_DAY_EVENT_LIMIT; // make sure "auto" goes to a real number
				}
				if (eventLimit) {
					this.dayGrid.limitRows(eventLimit);
				}
			}
	
			if (!isAuto) { // should we force dimensions of the scroll container?
	
				scrollerHeight = this.computeScrollerHeight(totalHeight);
				this.scroller.setHeight(scrollerHeight);
				scrollbarWidths = this.scroller.getScrollbarWidths();
	
				if (scrollbarWidths.left || scrollbarWidths.right) { // using scrollbars?
	
					// make the all-day and header rows lines up
					compensateScroll(this.noScrollRowEls, scrollbarWidths);
	
					// the scrollbar compensation might have changed text flow, which might affect height, so recalculate
					// and reapply the desired height to the scroller.
					scrollerHeight = this.computeScrollerHeight(totalHeight);
					this.scroller.setHeight(scrollerHeight);
				}
	
				// guarantees the same scrollbar widths
				this.scroller.lockOverflow(scrollbarWidths);
	
				// if there's any space below the slats, show the horizontal rule.
				// this won't cause any new overflow, because lockOverflow already called.
				if (this.timeGrid.getTotalSlatHeight() < scrollerHeight) {
					this.bottomRuleEl.show();
				}
			}
		},
	
	
		// given a desired total height of the view, returns what the height of the scroller should be
		computeScrollerHeight: function(totalHeight) {
			return totalHeight -
				subtractInnerElHeight(this.el, this.scroller.el); // everything that's NOT the scroller
		},
	
	
		/* Scroll
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Computes the initial pre-configured scroll state prior to allowing the user to change it
		computeInitialScroll: function() {
			var scrollTime = moment.duration(this.opt('scrollTime'));
			var top = this.timeGrid.computeTimeTop(scrollTime);
	
			// zoom can give weird floating-point values. rather scroll a little bit further
			top = Math.ceil(top);
	
			if (top) {
				top++; // to overcome top border that slots beyond the first have. looks better
			}
	
			return { top: top };
		},
	
	
		queryScroll: function() {
			return { top: this.scroller.getScrollTop() };
		},
	
	
		setScroll: function(scroll) {
			this.scroller.setScrollTop(scroll.top);
		},
	
	
		/* Hit Areas
		------------------------------------------------------------------------------------------------------------------*/
		// forward all hit-related method calls to the grids (dayGrid might not be defined)
	
	
		prepareHits: function() {
			this.timeGrid.prepareHits();
			if (this.dayGrid) {
				this.dayGrid.prepareHits();
			}
		},
	
	
		releaseHits: function() {
			this.timeGrid.releaseHits();
			if (this.dayGrid) {
				this.dayGrid.releaseHits();
			}
		},
	
	
		queryHit: function(left, top) {
			var hit = this.timeGrid.queryHit(left, top);
	
			if (!hit && this.dayGrid) {
				hit = this.dayGrid.queryHit(left, top);
			}
	
			return hit;
		},
	
	
		getHitSpan: function(hit) {
			// TODO: hit.component is set as a hack to identify where the hit came from
			return hit.component.getHitSpan(hit);
		},
	
	
		getHitEl: function(hit) {
			// TODO: hit.component is set as a hack to identify where the hit came from
			return hit.component.getHitEl(hit);
		},
	
	
		/* Events
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Renders events onto the view and populates the View's segment array
		renderEvents: function(events) {
			var dayEvents = [];
			var timedEvents = [];
			var daySegs = [];
			var timedSegs;
			var i;
	
			// separate the events into all-day and timed
			for (i = 0; i < events.length; i++) {
				if (events[i].allDay) {
					dayEvents.push(events[i]);
				}
				else {
					timedEvents.push(events[i]);
				}
			}
	
			// render the events in the subcomponents
			timedSegs = this.timeGrid.renderEvents(timedEvents);
			if (this.dayGrid) {
				daySegs = this.dayGrid.renderEvents(dayEvents);
			}
	
			// the all-day area is flexible and might have a lot of events, so shift the height
			this.updateHeight();
		},
	
	
		// Retrieves all segment objects that are rendered in the view
		getEventSegs: function() {
			return this.timeGrid.getEventSegs().concat(
				this.dayGrid ? this.dayGrid.getEventSegs() : []
			);
		},
	
	
		// Unrenders all event elements and clears internal segment data
		unrenderEvents: function() {
	
			// unrender the events in the subcomponents
			this.timeGrid.unrenderEvents();
			if (this.dayGrid) {
				this.dayGrid.unrenderEvents();
			}
	
			// we DON'T need to call updateHeight() because
			// a renderEvents() call always happens after this, which will eventually call updateHeight()
		},
	
	
		/* Dragging (for events and external elements)
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// A returned value of `true` signals that a mock "helper" event has been rendered.
		renderDrag: function(dropLocation, seg) {
			if (dropLocation.start.hasTime()) {
				return this.timeGrid.renderDrag(dropLocation, seg);
			}
			else if (this.dayGrid) {
				return this.dayGrid.renderDrag(dropLocation, seg);
			}
		},
	
	
		unrenderDrag: function() {
			this.timeGrid.unrenderDrag();
			if (this.dayGrid) {
				this.dayGrid.unrenderDrag();
			}
		},
	
	
		/* Selection
		------------------------------------------------------------------------------------------------------------------*/
	
	
		// Renders a visual indication of a selection
		renderSelection: function(span) {
			if (span.start.hasTime() || span.end.hasTime()) {
				this.timeGrid.renderSelection(span);
			}
			else if (this.dayGrid) {
				this.dayGrid.renderSelection(span);
			}
		},
	
	
		// Unrenders a visual indications of a selection
		unrenderSelection: function() {
			this.timeGrid.unrenderSelection();
			if (this.dayGrid) {
				this.dayGrid.unrenderSelection();
			}
		}
	
	});
	
	
	// Methods that will customize the rendering behavior of the AgendaView's timeGrid
	// TODO: move into TimeGrid
	var agendaTimeGridMethods = {
	
	
		// Generates the HTML that will go before the day-of week header cells
		renderHeadIntroHtml: function() {
			var view = this.view;
			var weekText;
	
			if (view.opt('weekNumbers')) {
				weekText = this.start.format(view.opt('smallWeekFormat'));
	
				return '' +
					'<th class="fc-axis fc-week-number ' + view.widgetHeaderClass + '" ' + view.axisStyleAttr() + '>' +
						view.buildGotoAnchorHtml( // aside from link, important for matchCellWidths
							{ date: this.start, type: 'week', forceOff: this.colCnt > 1 },
							htmlEscape(weekText) // inner HTML
						) +
					'</th>';
			}
			else {
				return '<th class="fc-axis ' + view.widgetHeaderClass + '" ' + view.axisStyleAttr() + '></th>';
			}
		},
	
	
		// Generates the HTML that goes before the bg of the TimeGrid slot area. Long vertical column.
		renderBgIntroHtml: function() {
			var view = this.view;
	
			return '<td class="fc-axis ' + view.widgetContentClass + '" ' + view.axisStyleAttr() + '></td>';
		},
	
	
		// Generates the HTML that goes before all other types of cells.
		// Affects content-skeleton, helper-skeleton, highlight-skeleton for both the time-grid and day-grid.
		renderIntroHtml: function() {
			var view = this.view;
	
			return '<td class="fc-axis" ' + view.axisStyleAttr() + '></td>';
		}
	
	};
	
	
	// Methods that will customize the rendering behavior of the AgendaView's dayGrid
	var agendaDayGridMethods = {
	
	
		// Generates the HTML that goes before the all-day cells
		renderBgIntroHtml: function() {
			var view = this.view;
	
			return '' +
				'<td class="fc-axis ' + view.widgetContentClass + '" ' + view.axisStyleAttr() + '>' +
					'<span>' + // needed for matchCellWidths
						view.getAllDayHtml() +
					'</span>' +
				'</td>';
		},
	
	
		// Generates the HTML that goes before all other types of cells.
		// Affects content-skeleton, helper-skeleton, highlight-skeleton for both the time-grid and day-grid.
		renderIntroHtml: function() {
			var view = this.view;
	
			return '<td class="fc-axis" ' + view.axisStyleAttr() + '></td>';
		}
	
	};
	
	;;
	
	var AGENDA_ALL_DAY_EVENT_LIMIT = 5;
	
	// potential nice values for the slot-duration and interval-duration
	// from largest to smallest
	var AGENDA_STOCK_SUB_DURATIONS = [
		{ hours: 1 },
		{ minutes: 30 },
		{ minutes: 15 },
		{ seconds: 30 },
		{ seconds: 15 }
	];
	
	fcViews.agenda = {
		'class': AgendaView,
		defaults: {
			allDaySlot: true,
			slotDuration: '00:30:00',
			minTime: '00:00:00',
			maxTime: '24:00:00',
			slotEventOverlap: true // a bad name. confused with overlap/constraint system
		}
	};
	
	fcViews.agendaDay = {
		type: 'agenda',
		duration: { days: 1 }
	};
	
	fcViews.agendaWeek = {
		type: 'agenda',
		duration: { weeks: 1 }
	};
	;;
	
	/*
	Responsible for the scroller, and forwarding event-related actions into the "grid"
	*/
	var ListView = View.extend({
	
		grid: null,
		scroller: null,
	
		initialize: function() {
			this.grid = new ListViewGrid(this);
			this.scroller = new Scroller({
				overflowX: 'hidden',
				overflowY: 'auto'
			});
		},
	
		setRange: function(range) {
			View.prototype.setRange.call(this, range); // super
	
			this.grid.setRange(range); // needs to process range-related options
		},
	
		renderSkeleton: function() {
			this.el.addClass(
				'fc-list-view ' +
				this.widgetContentClass
			);
	
			this.scroller.render();
			this.scroller.el.appendTo(this.el);
	
			this.grid.setElement(this.scroller.scrollEl);
		},
	
		unrenderSkeleton: function() {
			this.scroller.destroy(); // will remove the Grid too
		},
	
		setHeight: function(totalHeight, isAuto) {
			this.scroller.setHeight(this.computeScrollerHeight(totalHeight));
		},
	
		computeScrollerHeight: function(totalHeight) {
			return totalHeight -
				subtractInnerElHeight(this.el, this.scroller.el); // everything that's NOT the scroller
		},
	
		renderEvents: function(events) {
			this.grid.renderEvents(events);
		},
	
		unrenderEvents: function() {
			this.grid.unrenderEvents();
		},
	
		isEventResizable: function(event) {
			return false;
		},
	
		isEventDraggable: function(event) {
			return false;
		}
	
	});
	
	/*
	Responsible for event rendering and user-interaction.
	Its "el" is the inner-content of the above view's scroller.
	*/
	var ListViewGrid = Grid.extend({
	
		segSelector: '.fc-list-item', // which elements accept event actions
		hasDayInteractions: false, // no day selection or day clicking
	
		// slices by day
		spanToSegs: function(span) {
			var view = this.view;
			var dayStart = view.start.clone().time(0); // timed, so segs get times!
			var dayIndex = 0;
			var seg;
			var segs = [];
	
			while (dayStart < view.end) {
	
				seg = intersectRanges(span, {
					start: dayStart,
					end: dayStart.clone().add(1, 'day')
				});
	
				if (seg) {
					seg.dayIndex = dayIndex;
					segs.push(seg);
				}
	
				dayStart.add(1, 'day');
				dayIndex++;
	
				// detect when span won't go fully into the next day,
				// and mutate the latest seg to the be the end.
				if (
					seg && !seg.isEnd && span.end.hasTime() &&
					span.end < dayStart.clone().add(this.view.nextDayThreshold)
				) {
					seg.end = span.end.clone();
					seg.isEnd = true;
					break;
				}
			}
	
			return segs;
		},
	
		// like "4:00am"
		computeEventTimeFormat: function() {
			return this.view.opt('mediumTimeFormat');
		},
	
		// for events with a url, the whole <tr> should be clickable,
		// but it's impossible to wrap with an <a> tag. simulate this.
		handleSegClick: function(seg, ev) {
			var url;
	
			Grid.prototype.handleSegClick.apply(this, arguments); // super. might prevent the default action
	
			// not clicking on or within an <a> with an href
			if (!$(ev.target).closest('a[href]').length) {
				url = seg.event.url;
				if (url && !ev.isDefaultPrevented()) { // jsEvent not cancelled in handler
					window.location.href = url; // simulate link click
				}
			}
		},
	
		// returns list of foreground segs that were actually rendered
		renderFgSegs: function(segs) {
			segs = this.renderFgSegEls(segs); // might filter away hidden events
	
			if (!segs.length) {
				this.renderEmptyMessage();
			}
			else {
				this.renderSegList(segs);
			}
	
			return segs;
		},
	
		renderEmptyMessage: function() {
			this.el.html(
				'<div class="fc-list-empty-wrap2">' + // TODO: try less wraps
				'<div class="fc-list-empty-wrap1">' +
				'<div class="fc-list-empty">' +
					htmlEscape(this.view.opt('noEventsMessage')) +
				'</div>' +
				'</div>' +
				'</div>'
			);
		},
	
		// render the event segments in the view
		renderSegList: function(allSegs) {
			var segsByDay = this.groupSegsByDay(allSegs); // sparse array
			var dayIndex;
			var daySegs;
			var i;
			var tableEl = $('<table class="fc-list-table"><tbody/></table>');
			var tbodyEl = tableEl.find('tbody');
	
			for (dayIndex = 0; dayIndex < segsByDay.length; dayIndex++) {
				daySegs = segsByDay[dayIndex];
				if (daySegs) { // sparse array, so might be undefined
	
					// append a day header
					tbodyEl.append(this.dayHeaderHtml(
						this.view.start.clone().add(dayIndex, 'days')
					));
	
					this.sortEventSegs(daySegs);
	
					for (i = 0; i < daySegs.length; i++) {
						tbodyEl.append(daySegs[i].el); // append event row
					}
				}
			}
	
			this.el.empty().append(tableEl);
		},
	
		// Returns a sparse array of arrays, segs grouped by their dayIndex
		groupSegsByDay: function(segs) {
			var segsByDay = []; // sparse array
			var i, seg;
	
			for (i = 0; i < segs.length; i++) {
				seg = segs[i];
				(segsByDay[seg.dayIndex] || (segsByDay[seg.dayIndex] = []))
					.push(seg);
			}
	
			return segsByDay;
		},
	
		// generates the HTML for the day headers that live amongst the event rows
		dayHeaderHtml: function(dayDate) {
			var view = this.view;
			var mainFormat = view.opt('listDayFormat');
			var altFormat = view.opt('listDayAltFormat');
	
			return '<tr class="fc-list-heading" data-date="' + dayDate.format('YYYY-MM-DD') + '">' +
				'<td class="' + view.widgetHeaderClass + '" colspan="3">' +
					(mainFormat ?
						view.buildGotoAnchorHtml(
							dayDate,
							{ 'class': 'fc-list-heading-main' },
							htmlEscape(dayDate.format(mainFormat)) // inner HTML
						) :
						'') +
					(altFormat ?
						view.buildGotoAnchorHtml(
							dayDate,
							{ 'class': 'fc-list-heading-alt' },
							htmlEscape(dayDate.format(altFormat)) // inner HTML
						) :
						'') +
				'</td>' +
			'</tr>';
		},
	
		// generates the HTML for a single event row
		fgSegHtml: function(seg) {
			var view = this.view;
			var classes = [ 'fc-list-item' ].concat(this.getSegCustomClasses(seg));
			var bgColor = this.getSegBackgroundColor(seg);
			var event = seg.event;
			var url = event.url;
			var timeHtml;
	
			if (event.allDay) {
				timeHtml = view.getAllDayHtml();
			}
			else if (view.isMultiDayEvent(event)) { // if the event appears to span more than one day
				if (seg.isStart || seg.isEnd) { // outer segment that probably lasts part of the day
					timeHtml = htmlEscape(this.getEventTimeText(seg));
				}
				else { // inner segment that lasts the whole day
					timeHtml = view.getAllDayHtml();
				}
			}
			else {
				// Display the normal time text for the *event's* times
				timeHtml = htmlEscape(this.getEventTimeText(event));
			}
	
			if (url) {
				classes.push('fc-has-url');
			}
	
			return '<tr class="' + classes.join(' ') + '">' +
				(this.displayEventTime ?
					'<td class="fc-list-item-time ' + view.widgetContentClass + '">' +
						(timeHtml || '') +
					'</td>' :
					'') +
				'<td class="fc-list-item-marker ' + view.widgetContentClass + '">' +
					'<span class="fc-event-dot"' +
					(bgColor ?
						' style="background-color:' + bgColor + '"' :
						'') +
					'></span>' +
				'</td>' +
				'<td class="fc-list-item-title ' + view.widgetContentClass + '">' +
					'<a' + (url ? ' href="' + htmlEscape(url) + '"' : '') + '>' +
						htmlEscape(seg.event.title || '') +
					'</a>' +
				'</td>' +
			'</tr>';
		}
	
	});
	
	;;
	
	fcViews.list = {
		'class': ListView,
		buttonTextKey: 'list', // what to lookup in locale files
		defaults: {
			buttonText: 'list', // text to display for English
			listDayFormat: 'LL', // like "January 1, 2016"
			noEventsMessage: 'No events to display'
		}
	};
	
	fcViews.listDay = {
		type: 'list',
		duration: { days: 1 },
		defaults: {
			listDayFormat: 'dddd' // day-of-week is all we need. full date is probably in header
		}
	};
	
	fcViews.listWeek = {
		type: 'list',
		duration: { weeks: 1 },
		defaults: {
			listDayFormat: 'dddd', // day-of-week is more important
			listDayAltFormat: 'LL'
		}
	};
	
	fcViews.listMonth = {
		type: 'list',
		duration: { month: 1 },
		defaults: {
			listDayAltFormat: 'dddd' // day-of-week is nice-to-have
		}
	};
	
	fcViews.listYear = {
		type: 'list',
		duration: { year: 1 },
		defaults: {
			listDayAltFormat: 'dddd' // day-of-week is nice-to-have
		}
	};
	
	;;
	
	return FC; // export for Node/CommonJS
	});

/***/ },
/* 587 */
/***/ function(module, exports) {

	module.exports = "<div class=\"row\">\r\n  <div class=\"col-sm-11\">\r\n    <div class=\"row\">\r\n      <!-- <div class=\"form-group\" [ngClass]=\"{'col-sm-3': isSharedVehicleGroupVisible, 'col-sm-4' : !isSharedVehicleGroupVisible }\">\r\n        <label>{{ 'LblFrom' | translate }}</label>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"input-group\">\r\n          <span class=\"input-group-addon\"><i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i></span>\r\n          <input class=\"form-control\" [Config]=\"flatPickrConfigFrom\" placeholder=\"{{ 'LblFrom' | translate }}\" name=\"StartDateTime\" [(ngModel)]=\"model.startDateTime\" flatpickr readonly>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'startDateTime' }}</span>\r\n      </div>\r\n      <div class=\"form-group\" [ngClass]=\"{'col-sm-3': isSharedVehicleGroupVisible, 'col-sm-4' : !isSharedVehicleGroupVisible }\">\r\n        <label>{{ 'LblTo' | translate }}</label>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"input-group\">\r\n          <span class=\"input-group-addon\"><i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i></span>\r\n          <input class=\"form-control\" [Config]=\"flatPickrConfigTo\" placeholder=\"{{ 'LblTo' | translate }}\" name=\"EndDateTime\" [(ngModel)]=\"model.endDateTime\" flatpickr readonly>\r\n        </div>\r\n      </div> -->\r\n      <div *ngIf=\"isSharedVehicleGroupVisible\" class=\"form-group col-sm-3\">\r\n        <label>{{ 'LblVehicleGroup' | translate }}</label>\r\n        <select [disabled]=\"isEditMode\" [(ngModel)]=\"model.sharedVehicleGroupHashId\" name=\"sharedVehicleGroupHashId\" class=\"form-control\" (change)=\"onChangeSelectedSVG($event.target.value)\">\r\n           <option  value='' [selected]='selected'>{{ 'LblAll' | translate }} </option>\r\n           <option *ngFor=\"let svg of sharedVehicleGroupList\"  [attr.value]='svg.keyHash' >{{svg.value}}</option>\r\n        </select>\r\n      </div>\r\n      <div class=\"form-group\" [ngClass]=\"{'col-sm-3': isSharedVehicleGroupVisible, 'col-sm-4' : !isSharedVehicleGroupVisible }\">\r\n        <label>{{ 'LblVehicle' | translate }}</label>\r\n        <select [disabled]=\"isEditMode\" [(ngModel)]=\"model.vehicleHashId\" name=\"vehicleHashId\" class=\"form-control\" (change)=\"onChangeSelectedVehicle($event.target.value)\">\r\n              <option  value='' [selected]='selected'>{{ 'LblAll' | translate }} </option>\r\n              <option *ngFor=\"let vehicle of VehicleList\"  [attr.value]='vehicle.keyHash' >{{vehicle.value}}</option>\r\n            </select>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  <div class=\"col-sm-1\">\r\n    <div class=\"row\">\r\n      <div class=\"form-group\">\r\n        <div class=\"input-group\" style=\"margin-top:5px;\">\r\n          <label></label>\r\n          <div class=\"clearfix\"></div>\r\n          <button class=\"btn btn-default\" (click)=\"OnSearchVehicleBooking($event)\"><i class=\"fa fa-search\" aria-hidden=\"true\"></i></button>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<div class=\"panel panel-default\">\r\n  <div class=\"panel-body\" style=\"padding: 15px 40px;\">\r\n    <div id=\"calendar\"></div>\r\n  </div>\r\n</div>\r\n\r\n<booking-info-popup #bookingInfoModel></booking-info-popup>";

/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var flatpickr_directive_1 = __webpack_require__(82);
	var auth_service_1 = __webpack_require__(58);
	var translate_service_1 = __webpack_require__(70);
	var flatpickr_model_1 = __webpack_require__(83);
	var config_1 = __webpack_require__(60);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var booking_service_1 = __webpack_require__(556);
	var search_booking_model_1 = __webpack_require__(574);
	var moment = __webpack_require__(84);
	var SearchBookingDriverComponent = (function () {
	    function SearchBookingDriverComponent(bookingService, translate, router, authService) {
	        this.bookingService = bookingService;
	        this.translate = translate;
	        this.router = router;
	        this.authService = authService;
	        this.onSearch = new core_1.EventEmitter();
	        this.model = new search_booking_model_1.SearchBookingModel();
	        this.isDashboard = false;
	        this.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
	    }
	    Object.defineProperty(SearchBookingDriverComponent.prototype, "IsDriverHashID", {
	        set: function (isDHashID) {
	            console.log(isDHashID);
	            if (isDHashID) {
	                //this.AllowTimeForBooking();
	                this.GetOrganizationList();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SearchBookingDriverComponent.prototype, "TimezoneStartDateTime", {
	        set: function (TimezoneStartDate) {
	            // this.model.startDateTime = TimezoneStartDate;
	            this.startDateTimeByTimeZone = TimezoneStartDate;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SearchBookingDriverComponent.prototype.ngOnChanges = function (changes) {
	        console.log('NG Chaneg');
	        console.log(changes);
	    };
	    SearchBookingDriverComponent.prototype.ngOnInit = function () {
	        this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigEnd = this.SetDefaultFlatPickrConfig(true);
	        this.flatPickrConfigFromSpl = this.SetDefaultSplPerFlatPickrConfig(true);
	        this.flatPickrConfigToSpl = this.SetDefaultSplPerFlatPickrConfig(true);
	        if (this.model) {
	            this.searchRetainModal = Object.assign({}, this.model);
	            this.OnOrganizationChange();
	        }
	    };
	    SearchBookingDriverComponent.prototype.OnOrganizationChange = function () {
	        if (this.model.organizationIdHashID) {
	            this.AllowTimeForBooking();
	            this.GetSpecialPeriodList();
	            // this.handleChange(true,'REGULAR','');
	            console.log(this.specialPeriodList);
	        }
	        // if (!this.isenableTime) {
	        //   this.model.startDateTime = moment()
	        //     .add('d', 1)
	        //     .format('DD-MM-YYYY 00:00');
	        //   this.model.endDateTime = moment(
	        //     this.model.startDateTime,
	        //     'DD-MM-YYYY 00:00'
	        //   )
	        //     .add('d', 1)
	        //     .format('DD-MM-YYYY 00:00');
	        // }
	    };
	    SearchBookingDriverComponent.prototype.GetSpecialPeriodList = function () {
	        var _this = this;
	        this.bookingService
	            .GetSpecialPeriodList(this.model.organizationIdHashID, this.model.driverHashId)
	            .subscribe(function (res) {
	            _this.specialPeriodList = res.data;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    SearchBookingDriverComponent.prototype.SetDefaultFlatPickrConfig = function (isDateOnly) {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = !isDateOnly ? true : false;
	        flatPickrConfig.time_24hr = true;
	        flatPickrConfig.minDate = new Date(new Date().setHours(0, 0, 0));
	        flatPickrConfig.dateFormat = this.dateFormat;
	        flatPickrConfig.minuteIncrement = 1;
	        return flatPickrConfig;
	    };
	    SearchBookingDriverComponent.prototype.SetDefaultSplPerFlatPickrConfig = function (
	        //isDaySpecialPeriod: boolean,
	        isDateOnly) {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = !isDateOnly ? true : false;
	        flatPickrConfig.time_24hr = true;
	        flatPickrConfig.minDate = new Date(new Date().setHours(0, 0, 0));
	        flatPickrConfig.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_FORMAT;
	        flatPickrConfig.minuteIncrement = 1;
	        // if (!isDaySpecialPeriod) {
	        //   flatPickrConfig.enable = [
	        //     (date: any) => {
	        //       // return true to disable
	        //       return date.getDay() === 5 || date.getDay() === 6;
	        //     }
	        //   ];
	        // } else {
	        //   flatPickrConfig.disable = [
	        //     (date: any) => {
	        //       // return true to disable
	        //       return date.getDay() === 5 || date.getDay() === 6;
	        //     }
	        //   ];
	        // }
	        return flatPickrConfig;
	    };
	    SearchBookingDriverComponent.prototype.GetOrganizationList = function () {
	        var _this = this;
	        this.bookingService.GetOrganizationList(this.model.driverHashId).subscribe(function (res) {
	            _this.model.organizationList = res.data;
	            if (_this.model &&
	                _this.model.organizationList &&
	                _this.model.organizationList.length == 1) {
	                _this.model.organizationIdHashID = _this.model.organizationList[0].organizationMasterHashId;
	                _this.OnOrganizationChange();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    SearchBookingDriverComponent.prototype.OnFromDateChange = function (value) {
	        console.log(value);
	        console.log(this.model.endDateTime);
	        if (value && this.model.isRegularbooking) {
	            var format = 'DD-MM-YYYY HH:mm';
	            var newDate = moment(value, format).toDate();
	            var endDate = moment(this.model.endDateTime, format).toDate();
	            var endDateVal = moment(value, format);
	            // let recurringEndDate = moment(this.model.endDateTime, format).toDate();
	            if (endDate <= newDate) {
	                if (this.isenableTime) {
	                    endDateVal = endDateVal.add('H', 1);
	                }
	                else {
	                    endDateVal = endDateVal.add('d', 1);
	                }
	                // recurringEndDate = endDateVal.toDate();
	                this.flatPickrConfigToDate.ChangeValue(endDateVal.format('DD-MM-YYYY HH:mm'));
	            }
	            this.flatPickrConfigToDate.SetOption('minDate', newDate);
	        }
	    };
	    SearchBookingDriverComponent.prototype.OnDayStartDateChange = function (value) {
	        console.log(value);
	        console.log(this.model.endDateTime);
	        if (value) {
	            var format = 'DD-MM-YYYY';
	            var newDate = moment(value, format).toDate();
	            var endDate = moment(this.model.endDateTime, format).toDate();
	            var endDateVal = moment(value, format);
	            if (endDate <= newDate) {
	                endDateVal = endDateVal.add('d', 1);
	                this.flatPickrConfigToDateSpl.ChangeValue(endDateVal.format('DD-MM-YYYY'));
	            }
	            this.flatPickrConfigToDateSpl.SetOption('minDate', newDate);
	        }
	        //this.ChangeDateTimeForInputModel();
	    };
	    SearchBookingDriverComponent.prototype.SetPickerValue = function (key, value) {
	        // if (key == "SEARCH_FROM") {
	        //   this.flatPickrConfigFromDate.ChangeValue(value);
	        // }
	        // if (key == "SEARCH_TO") {
	        //   this.flatPickrConfigToDate.ChangeValue(value);
	        // }
	    };
	    SearchBookingDriverComponent.prototype.ClearErrorModel = function () {
	        this.errorModel = [];
	    };
	    SearchBookingDriverComponent.prototype.OnSearch = function (forms) {
	        var _this = this;
	        // if (!this.geoLocation) {
	        //   this.geoLocationError = this.translate.instant('LblGeoLocationError');
	        // }
	        // else {
	        //this.geoLocationError = '';
	        var tempModel = Object.assign({}, this.model);
	        if (!tempModel.isRegularbooking) {
	            tempModel.startDateTime =
	                tempModel.startDateTime.length <= 10
	                    ? tempModel.startDateTime + ' 00:00'
	                    : tempModel.startDateTime;
	            tempModel.endDateTime =
	                tempModel.endDateTime.length <= 10
	                    ? tempModel.endDateTime + ' 00:00'
	                    : tempModel.endDateTime;
	        }
	        this.CalculateBookingDuration(tempModel);
	        tempModel.totalBookingDuration = this.model.totalBookingDuration;
	        this.message = '';
	        this.errorModel = null;
	        this.isLoading = true;
	        // if (!this.model.isRegularbooking) {
	        //   this.model.startDateTime = this.model.startDateTime + ' 00:00';
	        //   this.model.endDateTime = this.model.endDateTime + ' 00:00';
	        // }
	        this.bookingService.GetVehicleOverview(tempModel).subscribe(function (res) {
	            _this.isLoading = false;
	            if (!res.data) {
	                _this.errorModel = res.error;
	            }
	            else {
	                if (res.data.length > 0)
	                    _this.onSearch.emit({
	                        SearchModel: tempModel,
	                        VehicleOverview: res.data
	                    });
	                else {
	                    _this.message = res.error; //this.translate.instant('LblNoMatchingVehicle');
	                }
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	        //this.ChangeDateTimeForInputModel();
	        //}
	    };
	    SearchBookingDriverComponent.prototype.CalculateBookingDuration = function (searchModel) {
	        var format = 'DD-MM-YYYY HH:mm';
	        var stDate = moment(searchModel.startDateTime, format).toDate();
	        var enDate = moment(searchModel.endDateTime, format).toDate();
	        // if (searchModel.isRecurringBookingAllow && searchModel.recurringEndDateTime) {
	        //   enDate = moment(searchModel.recurringEndDateTime, format).toDate();
	        // }
	        var diffMs = enDate - stDate;
	        var diffDays = Math.floor(diffMs / 86400000); // days
	        var diffHrs = Math.floor((diffMs % 86400000) / 3600000);
	        var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000);
	        if (diffDays > 0) {
	            this.model.totalBookingDuration =
	                diffDays + ' Day ' + diffHrs + ' Hours ' + diffMins + ' Min';
	        }
	        else if (diffDays == 0 && diffHrs > 0) {
	            this.model.totalBookingDuration = diffHrs + ' Hours ' + diffMins + ' Min';
	        }
	        else if (diffDays == 0 && diffHrs == 0) {
	            this.model.totalBookingDuration = diffMins + ' Min';
	        }
	        console.log(this.model.totalBookingDuration);
	    };
	    // public GetAddress(place: Object) {
	    //   // this.geoLocation = place['address'] != '' ? true : false;
	    //   // this.model.companyGeoLocationLatitude = place['lat'];
	    //   // this.model.companyGeoLocationLatitude = place['log'];
	    //   this.model.sourceLocation = place['useraddressInput'];
	    // }
	    SearchBookingDriverComponent.prototype.SuccessSelectDriverModal = function ($event) {
	        this.model.driverHashId = $event.DriverHashID;
	        this.model.driverName = $event.DriverName;
	    };
	    SearchBookingDriverComponent.prototype.AllowTimeForBooking = function () {
	        var _this = this;
	        if (this.model.driverHashId) {
	            this.bookingService
	                .AllowTimeForBooking(this.model.driverHashId, this.model.organizationIdHashID)
	                .subscribe(function (res) {
	                _this.isenableTime = res.data;
	                console.log(_this.model);
	                // if (!this.isenableTime) {
	                //   this.model.startDateTime = moment()
	                //     .add('d', 1)
	                //     .format('DD-MM-YYYY 00:00');
	                //   this.model.endDateTime = moment(
	                //     this.model.startDateTime,
	                //     'DD-MM-YYYY 00:00'
	                //   )
	                //     .add('d', 1)
	                //     .format('DD-MM-YYYY 00:00');
	                //   this.model.recurringPeriod = 'WEEKLY';
	                // } else {
	                //   this.model.startDateTime = moment()
	                //     .add('m', 5)
	                //     .format('DD-MM-YYYY HH:mm');
	                //   this.model.endDateTime = moment()
	                //     .add('H', 1)
	                //     .add('m', 5)
	                //     .format('DD-MM-YYYY HH:mm');
	                //   this.model.recurringPeriod = 'DAILY';
	                // }
	                _this.model.startDateTime = _this.isenableTime
	                    ? moment(_this.startDateTimeByTimeZone, 'DD-MM-YYYY HH:mm')
	                        .add(5, 'minute')
	                        .format('DD-MM-YYYY HH:mm')
	                    : moment(_this.startDateTimeByTimeZone)
	                        .add(1, 'd')
	                        .format('DD-MM-YYYY 00:00');
	                _this.model.endDateTime = _this.isenableTime
	                    ? moment(_this.model.startDateTime, 'DD-MM-YYYY HH:mm')
	                        .add(1, 'hour')
	                        .format('DD-MM-YYYY HH:mm', 'DD-MM-YYYY HH:mm')
	                    : moment(_this.model.startDateTime)
	                        .add(1, 'd')
	                        .format('DD-MM-YYYY 00:00');
	                _this.model.recurringPeriod = _this.isenableTime ? 'DAILY' : 'WEEKLY';
	                if (_this.model.isRegularbooking) {
	                    _this.flatPickrConfigFromDate.ToggleTimePicker(_this.isenableTime);
	                    _this.flatPickrConfigToDate.ToggleTimePicker(_this.isenableTime);
	                }
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            }, function () {
	                console.log("this.searchRetainModal");
	                console.log(_this.searchRetainModal);
	                if (_this.searchRetainModal.startDateTime || _this.searchRetainModal.endDateTime) {
	                }
	                if (!_this.model.isRegularbooking) {
	                    _this.ClearTimeSpanForSpecialPeriod();
	                }
	            });
	        }
	    };
	    SearchBookingDriverComponent.prototype.PickupLocation = function ($event) {
	        this.model.pickupAddress = $event.address;
	        this.model.pickupLat = $event.lat;
	        this.model.pickupLong = $event.long;
	    };
	    SearchBookingDriverComponent.prototype.ResetLocationField = function () {
	        this.model.pickupAddress = '';
	        this.model.pickupLat = 0;
	        this.model.pickupLong = 0;
	    };
	    SearchBookingDriverComponent.prototype.handleChange = function (changeVal, periodType, contractTypeHashID) {
	        this.model.isRegularbooking = changeVal;
	        this.model.specialPeriodType = periodType;
	        this.model.contractTypeHashId = contractTypeHashID;
	        this.model.isRecurring = false;
	        this.model.recurringEndDateTime = '';
	        this.ChangeDateTimeForInputModel();
	        if (!this.model.isRegularbooking && this.flatPickrConfigToDateSpl) {
	            this.flatPickrConfigToDateSpl.ChangeValue(this.model.endDateTime);
	        }
	    };
	    SearchBookingDriverComponent.prototype.ChangeDateTimeForInputModel = function () {
	        if (!this.model.isRegularbooking) {
	            this.model.startDateTime = moment()
	                .add('d', 1)
	                .format('DD-MM-YYYY 00:00');
	            this.model.endDateTime = moment()
	                .add('d', 1)
	                .format('DD-MM-YYYY 00:00');
	            this.ClearTimeSpanForSpecialPeriod();
	        }
	        else {
	            if (!this.isenableTime) {
	                this.model.startDateTime = moment()
	                    .add('d', 1)
	                    .format('DD-MM-YYYY 00:00');
	                this.model.endDateTime = moment(this.model.startDateTime, 'DD-MM-YYYY 00:00')
	                    .add('d', 1)
	                    .format('DD-MM-YYYY 00:00');
	            }
	            else {
	                this.model.startDateTime = moment()
	                    .add('m', 5)
	                    .format('DD-MM-YYYY HH:mm');
	                this.model.endDateTime = moment()
	                    .add('H', 1)
	                    .add('m', 5)
	                    .format('DD-MM-YYYY HH:mm');
	            }
	        }
	    };
	    SearchBookingDriverComponent.prototype.ClearTimeSpanForSpecialPeriod = function () {
	        this.model.startDateTime = this.model.startDateTime.substring(0, 10);
	        this.model.endDateTime = this.model.endDateTime.substring(0, 10);
	    };
	    SearchBookingDriverComponent.prototype.ngAfterViewInit = function () {
	        //this.OnFromDateChange(this.model.startDateTime);
	    };
	    __decorate([
	        core_1.Output('OnSearch'), 
	        __metadata('design:type', Object)
	    ], SearchBookingDriverComponent.prototype, "onSearch", void 0);
	    __decorate([
	        core_1.Input('SearchBookingModel'), 
	        __metadata('design:type', (typeof (_a = typeof search_booking_model_1.SearchBookingModel !== 'undefined' && search_booking_model_1.SearchBookingModel) === 'function' && _a) || Object)
	    ], SearchBookingDriverComponent.prototype, "model", void 0);
	    __decorate([
	        core_1.Input('IsDashboard'), 
	        __metadata('design:type', Boolean)
	    ], SearchBookingDriverComponent.prototype, "isDashboard", void 0);
	    __decorate([
	        core_1.ViewChild('flatPickrConfigFromDate'), 
	        __metadata('design:type', (typeof (_b = typeof flatpickr_directive_1.FlatPickrDirective !== 'undefined' && flatpickr_directive_1.FlatPickrDirective) === 'function' && _b) || Object)
	    ], SearchBookingDriverComponent.prototype, "flatPickrConfigFromDate", void 0);
	    __decorate([
	        core_1.ViewChild('flatPickrConfigToDate'), 
	        __metadata('design:type', (typeof (_c = typeof flatpickr_directive_1.FlatPickrDirective !== 'undefined' && flatpickr_directive_1.FlatPickrDirective) === 'function' && _c) || Object)
	    ], SearchBookingDriverComponent.prototype, "flatPickrConfigToDate", void 0);
	    __decorate([
	        core_1.ViewChild('flatPickrConfigEndDate'), 
	        __metadata('design:type', (typeof (_d = typeof flatpickr_directive_1.FlatPickrDirective !== 'undefined' && flatpickr_directive_1.FlatPickrDirective) === 'function' && _d) || Object)
	    ], SearchBookingDriverComponent.prototype, "flatPickrConfigEndDate", void 0);
	    __decorate([
	        core_1.ViewChild('flatPickrConfigFromDateSpl'), 
	        __metadata('design:type', (typeof (_e = typeof flatpickr_directive_1.FlatPickrDirective !== 'undefined' && flatpickr_directive_1.FlatPickrDirective) === 'function' && _e) || Object)
	    ], SearchBookingDriverComponent.prototype, "flatPickrConfigFromDateSpl", void 0);
	    __decorate([
	        core_1.ViewChild('flatPickrConfigToDateSpl'), 
	        __metadata('design:type', (typeof (_f = typeof flatpickr_directive_1.FlatPickrDirective !== 'undefined' && flatpickr_directive_1.FlatPickrDirective) === 'function' && _f) || Object)
	    ], SearchBookingDriverComponent.prototype, "flatPickrConfigToDateSpl", void 0);
	    __decorate([
	        core_1.Input('IsDriverHashID'), 
	        __metadata('design:type', Boolean), 
	        __metadata('design:paramtypes', [Boolean])
	    ], SearchBookingDriverComponent.prototype, "IsDriverHashID", null);
	    __decorate([
	        core_1.Input('TimezoneStartDateTime'), 
	        __metadata('design:type', String), 
	        __metadata('design:paramtypes', [String])
	    ], SearchBookingDriverComponent.prototype, "TimezoneStartDateTime", null);
	    SearchBookingDriverComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-search-booking-driver',
	            template: __webpack_require__(589),
	            styles: [
	                "\n      .box.box-default {\n        border: 1px solid #ddd;\n        border-top: 3px solid #2ba2aa;\n      }\n      .box-body {\n        padding: 0px 10px 10px;\n      }\n      wego-geo-location-map {\n        color: #000;\n      }\n      input#search-input {\n        border: 1px solid #ccc;\n      }\n    "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_g = typeof booking_service_1.BookingService !== 'undefined' && booking_service_1.BookingService) === 'function' && _g) || Object, (typeof (_h = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _h) || Object, (typeof (_j = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _j) || Object, (typeof (_k = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _k) || Object])
	    ], SearchBookingDriverComponent);
	    return SearchBookingDriverComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
	}());
	exports.SearchBookingDriverComponent = SearchBookingDriverComponent;


/***/ },
/* 589 */
/***/ function(module, exports) {

	module.exports = "<div *ngIf=\"!isDashboard\" class=\"panel panel-default\">\r\n  <div class=\"panel-body\" style=\"display: block;\">\r\n    <form (ngSubmit)=\"OnSearch(searchForm.value)\" #searchForm=\"ngForm\">\r\n      <div class=\"row\">\r\n        <div *ngIf=\"model.isEditMode\" class=\"form-group col-md-8\">\r\n          <label>{{ 'LblLicenceTag' | translate }}</label>\r\n          <p>{{ model.vehicleLicenceTag }}</p>\r\n        </div>\r\n        <div *ngIf=\"!model.isEditMode\" class=\"form-group col-md-8\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblOrganization' | translate }}</label>\r\n          <select [(ngModel)]=\"model.organizationIdHashID\" class=\"form-control\" name=\"organizationHashId\" (change)=\"OnOrganizationChange()\">\r\n            <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblOrganization' | translate }}</option>\r\n            <option *ngFor=\"let item of model.organizationList\" [ngValue]=\"item.organizationMasterHashId\">{{ item.organizationName }}</option>\r\n          </select>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'OrganizationIdHashID' }}</span>\r\n        </div>\r\n        <div *ngIf=\"model.isEditMode\" class=\"form-group col-md-8\">\r\n          <label>{{ 'LblOrganization' | translate }}</label>\r\n          <p>{{ model.organizationName }}</p>\r\n        </div>\r\n        <div class=\"form-group col-md-8\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblPickupLocation' | translate }}</label>\r\n          <div class=\"input-group\">\r\n            <input [(ngModel)]=\"model.pickupAddress\" name=\"pickupAddress\" type=\"text\" class=\"form-control\" [attr.title]=\"model.pickupAddress\"\r\n              placeholder=\"{{ 'LblPickupLocation' | translate }}\" readonly>\r\n            <div class=\"input-group-btn\">\r\n              <button class=\"btn btn-default\" type=\"button\" (click)=\"geoLocationModal.show(model.pickupAddress, model.pickupLat, model.pickupLong)\">\r\n                <i class=\"fa fa-map-marker\" aria-hidden=\"true\"></i>\r\n              </button>\r\n              <button class=\"btn btn-default\" type=\"button\" (click)=\"ResetLocationField()\">\r\n                <i class=\"fa fa-eraser\" aria-hidden=\"true\"></i>\r\n              </button>\r\n            </div>\r\n          </div>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'pickupAddress' }}</span>\r\n        </div>\r\n        <div class=\"form-group col-md-8\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblBookingType' | translate }}</label>\r\n          <div *ngIf=\"!model.isEditMode\">\r\n            <div class=\"input-group\">\r\n              <div class=\"radio\">\r\n                <label>\r\n                  <input type=\"radio\" name=\"specialPeriodType\" value=\"REGULAR\" checked=\"model.isRegularbooking\" (change)=\"handleChange(true,'REGULAR','')\"> {{ 'LblRegular' | translate }}</label>\r\n              </div>\r\n            </div>\r\n            <label *ngIf=\"specialPeriodList && specialPeriodList.length > 0\">{{ 'LblSpecialRate' | translate }}</label>\r\n            <div class=\"radio\" *ngFor=\"let item of specialPeriodList\">\r\n              <label>\r\n                <input type=\"radio\" name=\"specialPeriodType\" [value]=\"item.contractTypeHashId\" [(ngModel)]=\"model.contractTypeHashId\" (change)=\"handleChange(false,item.contractTypeType,item.contractTypeHashId)\"> {{ item.contractName }}\r\n                <br/>{{item.freeTextSpecialPeriod}}</label>\r\n            </div>\r\n          </div>\r\n          <div *ngIf=\"model.isEditMode\">\r\n            <p *ngIf=\"!model.isRegularbooking\">{{ model.specialPeriodContractTypeName }}</p>\r\n            <p *ngIf=\"model.isRegularbooking\">{{ 'LblRegular' | translate }}</p>\r\n          </div>\r\n        </div>\r\n        <div [ngClass]=\" {'hidden':(!model.isRegularbooking)}\" *ngIf=\"model.isRegularbooking\">\r\n          <div class=\"form-group col-md-8\">\r\n            <label>\r\n              <span class=\"text text-danger\">*</span>{{ 'LblBookingStartDateTime' | translate }}</label>\r\n            <div class=\"input-group\">\r\n              <span class=\"input-group-addon\">\r\n                <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n              </span>\r\n              <input #flatPickrConfigFromDate=\"wego-flatpickr\" flatpickr readonly [Config]=\"flatPickrConfigFrom\" [(ngModel)]=\"model.startDateTime\"\r\n                name=\"startDateTime\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblBookingStartDateTime' | translate\r\n        }}\" (change)=\"OnFromDateChange($event.target.value)\">\r\n            </div>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'startDateTime' }}</span>\r\n          </div>\r\n          <div class=\"form-group col-md-8\">\r\n            <label>\r\n              <span class=\"text text-danger\">*</span>{{ 'LblBookingEndDateTime' | translate }}</label>\r\n            <div class=\"input-group\">\r\n              <span class=\"input-group-addon\">\r\n                <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n              </span>\r\n              <input #flatPickrConfigToDate=\"wego-flatpickr\" flatpickr readonly [Config]=\"flatPickrConfigTo\" [(ngModel)]=\"model.endDateTime\"\r\n                name=\"endDateTime\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblBookingEndDateTime' | translate }}\">\r\n            </div>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'endDateTime' }}</span>\r\n          </div>\r\n\r\n\r\n          <div class=\"form-group col-md-4\">\r\n            <label>&nbsp;</label>\r\n            <div *ngIf=\"!model.isEditMode  && model.isRecurringBookingAllow\" class=\"checkbox\">\r\n              <label>\r\n                <input [(ngModel)]=\"model.isRecurring\" type=\"checkbox\" name=\"isRecursive\">&nbsp;{{ 'LblRecurring' | translate }}</label>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-group col-md-8\">\r\n            <template [ngIf]=\"model.isRecurring && model.isRecurringBookingAllow\">\r\n              <label>\r\n                <span class=\"text text-danger\">*</span>{{ 'LblRecurrenceEndDate' | translate }}</label>\r\n              <div class=\"input-group\">\r\n                <span class=\"input-group-addon\">\r\n                  <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n                </span>\r\n                <input #flatPickrConfigEndDate=\"wego-flatpickr\" flatpickr readonly [Config]=\"flatPickrConfigEnd\" type=\"text\" [(ngModel)]=\"model.recurringEndDateTime\"\r\n                  name=\"recurringEndDateTime\" class=\"form-control\" placeholder=\"{{ 'LblRecurrenceEndDate' | translate }}\">\r\n              </div>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'RecurringEndDateTime' }}</span>\r\n            </template>\r\n          </div>\r\n          <div class=\"form-group col-md-4\">\r\n            <template [ngIf]=\"model.isRecurring && model.isRecurringBookingAllow\">\r\n              <div class=\"radio\" *ngIf=\"isenableTime\">\r\n                <label>\r\n                  <input type=\"radio\" name=\"recurringPeriod\" [(ngModel)]=\"model.recurringPeriod\" value=\"DAILY\">&nbsp;{{ 'LblDaily' | translate }}</label>\r\n              </div>\r\n              <div class=\"radio\">\r\n                <label>\r\n                  <input type=\"radio\" name=\"recurringPeriod\" [(ngModel)]=\"model.recurringPeriod\" value=\"WEEKLY\">&nbsp;{{ 'LblWeekly' | translate }}</label>\r\n              </div>\r\n              <div class=\"radio\">\r\n                <label>\r\n                  <input type=\"radio\" name=\"recurringPeriod\" [(ngModel)]=\"model.recurringPeriod\" value=\"MONTHLY\">&nbsp;{{ 'LblMonthly' | translate }}</label>\r\n              </div>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'RecurringPeriod' }}</span>\r\n            </template>\r\n          </div>\r\n\r\n        </div>\r\n        <div [ngClass]=\" {'hidden':(model.isRegularbooking)}\" *ngIf=\"!model.isRegularbooking\">\r\n          <div class=\"form-group col-md-8\" *ngIf=\"model.specialPeriodType=='DAY'\">\r\n            <label>\r\n              <span class=\"text text-danger\">*</span>{{ 'LblBookingStartDateTime' | translate }}</label>\r\n            <div class=\"input-group\">\r\n              <span class=\"input-group-addon\">\r\n                <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n              </span>\r\n              <input #flatPickrConfigFromDateSpl=\"wego-flatpickr\" flatpickr readonly [Config]=\"flatPickrConfigFromSpl\" [(ngModel)]=\"model.startDateTime\"\r\n                name=\"startDateTime\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblBookingStartDateTime' | translate }}\"\r\n                (change)=\"OnDayStartDateChange($event.target.value)\">\r\n            </div>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'startDateTime' }}</span>\r\n          </div>\r\n          <div class=\"form-group col-md-8\">\r\n            <label>\r\n              <span class=\"text text-danger\">*</span>{{ 'LblBookingEndDateTime' | translate }}</label>\r\n            <div class=\"input-group\">\r\n              <span class=\"input-group-addon\">\r\n                <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n              </span>\r\n              <input #flatPickrConfigToDateSpl=\"wego-flatpickr\" flatpickr readonly [Config]=\"flatPickrConfigToSpl\" [(ngModel)]=\"model.endDateTime\"\r\n                name=\"endDateTime\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblBookingEndDateTime' | translate }}\">\r\n            </div>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'endDateTime' }}</span>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <button class=\"btn btn-success\" type=\"submit\">\r\n            <span *ngIf=\"!model.isEditMode\">{{ 'LblSearch' | translate }}</span>\r\n            <span *ngIf=\"model.isEditMode\">{{ 'LblCheckAvailability' | translate }}</span>\r\n          </button>\r\n        </div>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <span class=\"text text-danger\">{{message}}</span>\r\n      </div>\r\n    </form>\r\n    <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n  </div>\r\n</div>\r\n<div *ngIf=\"isDashboard\">\r\n  <form (ngSubmit)=\"OnSearch(searchForm.value)\" #searchForm=\"ngForm\">\r\n    <div class=\"row\">\r\n      <div class=\"col-sm-10\">\r\n        <div class=\"row\">\r\n          <div class=\"form-group col-md-3\">\r\n            <label>\r\n              <span class=\"text text-danger\">*</span>{{ 'LblOrganization' | translate }}</label>\r\n            <select [(ngModel)]=\"model.organizationIdHashID\" class=\"form-control\" name=\"organizationHashId\" (change)=\"OnOrganizationChange()\">\r\n              <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblOrganization' | translate }}</option>\r\n              <option *ngFor=\"let item of model.organizationList\" [ngValue]=\"item.organizationMasterHashId\">{{ item.organizationName }}</option>\r\n            </select>\r\n            <span style=\"background-color:#dd4b39\" class=\"text-center\">{{ errorModel | serverErrorMessage : 'OrganizationIdHashID' }}</span>\r\n          </div>\r\n          <div class=\"form-group col-md-3\">\r\n            <label>\r\n              <span class=\"text text-danger\">*</span>{{ 'LblPickupLocation' | translate }}</label>\r\n            <div class=\"input-group\">\r\n              <input [(ngModel)]=\"model.pickupAddress\" name=\"pickupAddress\" type=\"text\" class=\"form-control\" [attr.title]=\"model.pickupAddress\"\r\n                placeholder=\"{{ 'LblPickupLocation' | translate }}\" readonly>\r\n              <div class=\"input-group-btn\">\r\n                <button class=\"btn btn-default\" type=\"button\" (click)=\"geoLocationModal.show(model.pickupAddress, model.pickupLat, model.pickupLong)\">\r\n                  <i class=\"fa fa-map-marker\" aria-hidden=\"true\"></i>\r\n                </button>\r\n              </div>\r\n            </div>\r\n            <span style=\"background-color:#dd4b39\" class=\"text-center\">{{ errorModel | serverErrorMessage : 'pickupAddress' }}</span>\r\n          </div>\r\n          <div class=\"form-group col-md-3\">\r\n            <label>\r\n              <span class=\"text text-danger\">*</span>{{ 'LblBookingType' | translate }}</label>\r\n            <div class=\"input-group\">\r\n              <div class=\"radio\">\r\n                <label>\r\n                  <input type=\"radio\" name=\"specialPeriodType\" value=\"REGULAR\" checked=\"model.isRegularbooking\" (change)=\"handleChange(true,'REGULAR','')\"> {{ 'LblRegular' | translate }}</label>\r\n              </div>\r\n            </div>\r\n            <label *ngIf=\"specialPeriodList && specialPeriodList.length > 0\">{{ 'LblSpecialRate' | translate }}</label>\r\n            <div class=\"radio\" *ngFor=\"let item of specialPeriodList\">\r\n              <label>\r\n                <input type=\"radio\" name=\"specialPeriodType\" [value]=\"item.contractTypeHashId\" [(ngModel)]=\"model.contractTypeHashId\" (change)=\"handleChange(false,item.contractTypeType,item.contractTypeHashId)\"> {{ item.contractName }}\r\n                <br/>{{item.freeTextSpecialPeriod}}</label>\r\n\r\n            </div>\r\n          </div>\r\n          <div [ngClass]=\"{'hidden':(!model.isRegularbooking)}\" *ngIf=\"model.isRegularbooking\">\r\n            <div class=\"form-group col-md-3\">\r\n              <label>\r\n                <span class=\"text text-danger\">*</span>{{ 'LblBookingStartDateTime' | translate }} </label>\r\n              <div class=\"input-group\">\r\n                <span class=\"input-group-addon\">\r\n                  <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n                </span>\r\n                <input #flatPickrConfigFromDate=\"wego-flatpickr\" flatpickr readonly [Config]=\"flatPickrConfigFrom\" [(ngModel)]=\"model.startDateTime\"\r\n                  name=\"startDateTime\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblBookingStartDateTime' | translate }}\"\r\n                  (change)=\"OnFromDateChange($event.target.value)\">\r\n              </div>\r\n              <span style=\"background-color:#dd4b39\" class=\"text-center\">{{ errorModel | serverErrorMessage : 'startDateTime' }}</span>\r\n            </div>\r\n            <div class=\"form-group col-md-3\">\r\n              <label>\r\n                <span class=\"text text-danger\">*</span>{{ 'LblBookingEndDateTime' | translate }}</label>\r\n              <div class=\"input-group\">\r\n                <span class=\"input-group-addon\">\r\n                  <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n                </span>\r\n                <input #flatPickrConfigToDate=\"wego-flatpickr\" flatpickr readonly [Config]=\"flatPickrConfigTo\" [(ngModel)]=\"model.endDateTime\"\r\n                  name=\"endDateTime\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblBookingEndDateTime' | translate }}\">\r\n              </div>\r\n              <span style=\"background-color:#dd4b39\" class=\"text-center\">{{ errorModel | serverErrorMessage : 'endDateTime' }}</span>\r\n            </div>\r\n          </div>\r\n          <div [ngClass]=\"{'hidden':(model.isRegularbooking)}\" *ngIf=\"!model.isRegularbooking\">\r\n            <div class=\"form-group col-md-3\" *ngIf=\"model.specialPeriodType=='DAY'\">\r\n              <label>\r\n                <span class=\"text text-danger\">*</span>{{ 'LblBookingStartDateTime' | translate }} </label>\r\n              <div class=\"input-group\">\r\n                <span class=\"input-group-addon\">\r\n                  <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n                </span>\r\n                <input #flatPickrConfigFromDateSpl=\"wego-flatpickr\" flatpickr readonly [Config]=\"flatPickrConfigFromSpl\" [(ngModel)]=\"model.startDateTime\"\r\n                  name=\"startDateTime\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblBookingStartDateTime' | translate }}\"\r\n                  (change)=\"OnDayStartDateChange($event.target.value)\">\r\n              </div>\r\n              <span style=\"background-color:#dd4b39\" class=\"text-center\">{{ errorModel | serverErrorMessage : 'startDateTime' }}</span>\r\n            </div>\r\n            <div class=\"form-group col-md-3\">\r\n              <label>\r\n                <span class=\"text text-danger\">*</span>{{ 'LblBookingEndDateTime' | translate }}</label>\r\n              <div class=\"input-group\">\r\n                <span class=\"input-group-addon\">\r\n                  <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n                </span>\r\n                <input #flatPickrConfigToDateSpl=\"wego-flatpickr\" flatpickr readonly [Config]=\"flatPickrConfigToSpl\" [(ngModel)]=\"model.endDateTime\"\r\n                  name=\"endDateTime\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblBookingEndDateTime' | translate }}\">\r\n              </div>\r\n\r\n              <span style=\"background-color:#dd4b39\" class=\"text-center\">{{ errorModel | serverErrorMessage : 'endDateTime' }}</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"row\" *ngIf=\"model.isRegularbooking\">\r\n          <div class=\"form-group col-md-2\">\r\n            <label>&nbsp;</label>\r\n            <div *ngIf=\"!model.isEditMode && model.isRecurringBookingAllow\" class=\"checkbox\" style=\"margin-top: 0px;\">\r\n              <label>\r\n                <input [(ngModel)]=\"model.isRecurring\" type=\"checkbox\" name=\"isRecursive\">&nbsp;{{ 'LblRecurring' | translate }}</label>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-group col-md-4\">\r\n            <template [ngIf]=\"model.isRecurring && model.isRecurringBookingAllow\">\r\n              <label>&nbsp;</label>\r\n              <div class=\"form-inline\">\r\n                <div class=\"radio\" *ngIf=\"isenableTime\">\r\n                  <label>\r\n                    <input type=\"radio\" name=\"recurringPeriod\" [(ngModel)]=\"model.recurringPeriod\" value=\"DAILY\">&nbsp;{{ 'LblDaily' | translate }}</label>\r\n                </div>\r\n                <div class=\"radio\">\r\n                  <label>\r\n                    <input type=\"radio\" name=\"recurringPeriod\" [(ngModel)]=\"model.recurringPeriod\" value=\"WEEKLY\">&nbsp;{{ 'LblWeekly' | translate }}</label>\r\n                </div>\r\n                <div class=\"radio\">\r\n                  <label>\r\n                    <input type=\"radio\" name=\"recurringPeriod\" [(ngModel)]=\"model.recurringPeriod\" value=\"MONTHLY\">&nbsp;{{ 'LblMonthly' | translate }}</label>\r\n                </div>\r\n                <span style=\"background-color:#dd4b39\" class=\"text-center\">{{ errorModel | serverErrorMessage : 'RecurringPeriod' }}</span>\r\n              </div>\r\n            </template>\r\n          </div>\r\n          <div class=\"form-group col-md-3\">\r\n            <template [ngIf]=\"model.isRecurring && model.isRecurringBookingAllow\">\r\n              <label>\r\n                <span class=\"text text-danger\">*</span>{{ 'LblRecurrenceEndDate' | translate }}</label>\r\n              <div class=\"input-group\">\r\n                <span class=\"input-group-addon\">\r\n                  <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n                </span>\r\n                <input #flatPickrConfigEndDate=\"wego-flatpickr\" flatpickr readonly [Config]=\"flatPickrConfigEnd\" type=\"text\" [(ngModel)]=\"model.recurringEndDateTime\"\r\n                  name=\"recurringEndDateTime\" class=\"form-control\" placeholder=\"{{ 'LblRecurrenceEndDate' | translate }}\">\r\n              </div>\r\n              <span style=\"background-color:#dd4b39\" class=\"text-center\">{{ errorModel | serverErrorMessage : 'RecurringEndDateTime' }}</span>\r\n            </template>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-sm-2\">\r\n        <div class=\"form-group\">\r\n          <div class=\"input-group\">\r\n            <label>&nbsp;</label>\r\n            <button class=\"btn btn-success\" type=\"submit\" style=\"margin-top: 25px;\">\r\n              {{ 'LblSearch' | translate }}\r\n            </button>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div *ngIf=\"message\" class=\"alert alert-danger\">\r\n      <p class=\"text-center\">\r\n        {{message}}\r\n      </p>\r\n    </div>\r\n\r\n  </form>\r\n  <wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n</div>\r\n\r\n<wego-geo-location-map #geoLocationModal (onConfirm)=\"PickupLocation($event)\" ></wego-geo-location-map>";

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var search_booking_component_1 = __webpack_require__(591);
	var auth_service_1 = __webpack_require__(58);
	var translate_service_1 = __webpack_require__(70);
	var driveradmin_service_1 = __webpack_require__(592);
	var router_1 = __webpack_require__(26);
	var core_1 = __webpack_require__(3);
	var config_1 = __webpack_require__(60);
	var booking_overview_model_1 = __webpack_require__(577);
	var search_booking_model_1 = __webpack_require__(574);
	var booking_service_1 = __webpack_require__(556);
	var vehicle_service_1 = __webpack_require__(530);
	var sharedvehiclegroup_service_1 = __webpack_require__(510);
	var moment = __webpack_require__(84);
	var BookingDriverComponent = (function () {
	    function BookingDriverComponent(bookingService, driverAdminService, translate, activeRoute, authService, router) {
	        this.bookingService = bookingService;
	        this.driverAdminService = driverAdminService;
	        this.translate = translate;
	        this.activeRoute = activeRoute;
	        this.authService = authService;
	        this.router = router;
	        this.isAllowInitialPaymentValue = false;
	        this.swithBookingOverview = 'CALENDAR';
	        this.isNotEditable = false;
	        this.isDriverHashID = false;
	        this.timezoneStartDateTime = '';
	        this.isSuccess = false;
	        this.BOOKINGSTEP = {
	            SEARCH: 1,
	            VEHICLE: 2,
	            CONFIRM: 3
	        };
	    }
	    Object.defineProperty(BookingDriverComponent.prototype, "IsVehicleAvailableForUpdate", {
	        get: function () {
	            var _this = this;
	            if (this.vehicleOverviewList &&
	                this.vehicleOverviewList.length > 0 &&
	                this.searchBookingModel.isEditMode) {
	                return this.vehicleOverviewList.some(function (item) {
	                    return _this.searchBookingModel.vehicleHashId == item.vehicleHashID &&
	                        _this.searchBookingModel.sharedVehicleGroupHashID ==
	                            item.sharedVehicleGroupHashID;
	                });
	            }
	            else {
	                return true;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BookingDriverComponent.prototype.ngOnInit = function () {
	        this.urlDriverUpdate = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DRIVER_PROFILE);
	        if (this.authService.searchBookingModel &&
	            this.authService.vehicleOverviewModel) {
	            this.searchBookingModel = this.authService.searchBookingModel;
	            this.vehicleOverviewList = this.authService.vehicleOverviewModel;
	            this.CURRENTSTEP = this.BOOKINGSTEP.VEHICLE;
	            this.authService.searchBookingModel = null;
	            this.authService.vehicleOverviewModel = null;
	        }
	        else {
	            this.searchBookingModel = new search_booking_model_1.SearchBookingModel();
	            this.searchBookingModel.startDateTime = moment()
	                .add('m', 5)
	                .format('DD-MM-YYYY HH:mm');
	            this.searchBookingModel.endDateTime = moment()
	                .add('H', 1)
	                .add('m', 5)
	                .format('DD-MM-YYYY HH:mm');
	            this.CURRENTSTEP = this.BOOKINGSTEP.SEARCH;
	            //this.CurrentDriverDetail();
	            this.HandleBookingEdit();
	        }
	    };
	    BookingDriverComponent.prototype.ngOnDestroy = function () {
	        if (this.sub) {
	            this.sub.unsubscribe();
	        }
	        this.successPopup.hide();
	    };
	    BookingDriverComponent.prototype.HandleBookingEdit = function () {
	        var _this = this;
	        this.sub = this.activeRoute.params.subscribe(function (params) {
	            _this.referenceID = params['ref'] || '';
	            var isRecurring = params['isRecurring'] || false;
	            var version = params['v'] || '';
	            _this.ReloadPage(version);
	            if (_this.referenceID) {
	                _this.isLoading = true;
	                _this.bookingService
	                    .EditBookingDetail(_this.referenceID, isRecurring)
	                    .subscribe(function (res) {
	                    _this.isLoading = false;
	                    if (res.data) {
	                        _this.searchBookingModel.isEditMode = true;
	                        _this.searchBookingModel = res.data;
	                        _this.searchBookingModel.isEditMode = true;
	                        _this.searchBookingModel.isSpecialPeriod =
	                            res.data.isSpecialPeriod;
	                        _this.searchBookingModel.isRecurring =
	                            isRecurring == 'true' ? true : false;
	                        _this.searchBookingModel.isSpecialPeriod =
	                            res.data.isSpecialPeriod;
	                        _this.searchBookingModel.isRegularbooking = res.data
	                            .contractTypeHashId
	                            ? false
	                            : true;
	                        _this.searchBookingModel.startDateTime = res.data.startDateTime;
	                        _this.searchBookingModel.endDateTime = res.data.endDateTime;
	                        console.log('this.searchBookingModel');
	                        console.log(_this.searchBookingModel);
	                    }
	                    else {
	                        _this.isNotEditable = true;
	                        _this.alertMsg = res.error;
	                    }
	                }, function (error) {
	                    _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	                    _this.isLoading = false;
	                });
	            }
	            if (_this.authService.IsDriver()) {
	                _this.CurrentDriverDetail();
	            }
	        });
	    };
	    BookingDriverComponent.prototype.ReloadPage = function (version) {
	        if (this.version != version) {
	            this.version = version;
	            this.searchBookingModel = new search_booking_model_1.SearchBookingModel();
	            this.searchBookingModel.startDateTime = moment()
	                .add('m', 5)
	                .format('DD-MM-YYYY HH:mm');
	            this.searchBookingModel.endDateTime = moment()
	                .add('H', 1)
	                .add('m', 5)
	                .format('DD-MM-YYYY HH:mm');
	            this.searchBookingModel.recurringEndDateTime = '';
	            if (this.searchBooking) {
	                this.searchBooking.SetPickerValue('SEARCH_FROM', this.searchBookingModel.startDateTime);
	                this.searchBooking.SetPickerValue('SEARCH_TO', this.searchBookingModel.endDateTime);
	                this.searchBooking.ClearErrorModel();
	            }
	            this.CURRENTSTEP = this.BOOKINGSTEP.SEARCH;
	            this.vehicleOverviewList = [];
	            this.filterVehicleOverviewList = [];
	            this.bookingOverviewModel = new booking_overview_model_1.BookingOverview();
	        }
	    };
	    BookingDriverComponent.prototype.CurrentDriverDetail = function () {
	        var _this = this;
	        this.driverAdminService.GetCurrentDriverDetail().subscribe(function (res) {
	            _this.isLoading = false;
	            if (res.data) {
	                _this.isBanned = res.data.isBanned;
	                _this.userBlockMessage = res.data.userBlockMessage;
	                _this.isLicenceRequired = res.data.isLicenceRequired;
	                _this.personMasterHashId = res.data.personMasterHashId;
	                _this.searchBookingModel.driverHashId = res.data.driverMasterHashId;
	                _this.searchBookingModel.isRecurringBookingAllow =
	                    res.data.isRecurringBookingAllow;
	                _this.searchBookingModel.startDateTime = res.data.startDateTime;
	                _this.timezoneStartDateTime = res.data.startDateTime;
	                _this.IsDriverHashID();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BookingDriverComponent.prototype.IsDriverHashID = function () {
	        this.isDriverHashID = this.searchBookingModel.driverHashId ? true : false;
	    };
	    BookingDriverComponent.prototype.AlertClose = function ($event) {
	        this.ClearBookingRecord();
	        var urlBookingOverview = this.authService.GetURL(config_1.ApplicationRouteURL.URL_BOOKING);
	        this.router.navigate([urlBookingOverview]);
	    };
	    BookingDriverComponent.prototype.ChangeStep = function (selected) {
	        if (selected < this.CURRENTSTEP)
	            this.CURRENTSTEP = selected;
	    };
	    BookingDriverComponent.prototype.OnSearchBooking = function ($event) {
	        this.scheduledBookingModel = $event.ScheduledBookingModel;
	        this.CURRENTSTEP = this.BOOKINGSTEP.SEARCH;
	    };
	    BookingDriverComponent.prototype.OnSearch = function ($event) {
	        this.searchBookingModel = $event.SearchModel;
	        this.vehicleOverviewList = $event.VehicleOverview;
	        this.CURRENTSTEP = this.BOOKINGSTEP.VEHICLE;
	    };
	    BookingDriverComponent.prototype.Proceed = function ($event) { };
	    BookingDriverComponent.prototype.OnUpdateVehicleOverView = function ($event) {
	        this.filterVehicleOverviewList = $event.FilterVehicleOverview;
	    };
	    BookingDriverComponent.prototype.OnBook = function ($event) {
	        this.searchBookingModel.sharedVehicleGroupHashID =
	            $event.SharedVehicleGroupHashID;
	        this.searchBookingModel.vehicleHashId = $event.VehicleHashID;
	        this.MakeProvisionalBooking();
	    };
	    BookingDriverComponent.prototype.OnConfirmBooking = function ($event) {
	        this.searchBookingModel.bookingRemarks = $event.BookingRemarks;
	        this.ConfirmProvisionalBooking();
	    };
	    BookingDriverComponent.prototype.GetInitialPaymentValue = function (isAllowInitialPayment) {
	        this.isAllowInitialPaymentValue = isAllowInitialPayment;
	    };
	    BookingDriverComponent.prototype.ConfirmInitialPayment = function () {
	        var _this = this;
	        this.isLoading = true;
	        if (this.isAllowInitialPaymentValue == false) {
	            this.isLoading = false;
	            var errorMessage = this.translate.instant('LblCheckAllowPayment');
	            this.errorMessage = errorMessage + ':' + Date.now().toString();
	        }
	        else {
	            this.searchBookingModel.isFromMobileSide = false;
	            this.bookingService
	                .StartInitialPayment(this.searchBookingModel)
	                .subscribe(function (res) {
	                if (res.data.redirectURL) {
	                    _this.isLoading = false;
	                    window.location.href = res.data.redirectURL;
	                }
	                else {
	                    _this.isLoading = false;
	                    _this.creditCardPaymentModal.hide();
	                    _this.popupMsg = res.error;
	                    _this.ShowSuccessPopup();
	                }
	            });
	        }
	    };
	    BookingDriverComponent.prototype.OnCancelBooking = function ($event) {
	        this.CancelProvisionalBooking();
	    };
	    BookingDriverComponent.prototype.OnCancelPayment = function ($event) {
	        this.CancelProvisionalBooking();
	        var urlData = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DASHBOARD_PAGE);
	        this.router.navigate([urlData]);
	    };
	    BookingDriverComponent.prototype.MakeProvisionalBooking = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.bookingService
	            .MakeProvisionalBooking(this.searchBookingModel)
	            .subscribe(function (res) {
	            _this.isLoading = false;
	            if (res.data) {
	                if (!_this.searchBookingModel.isRecurring)
	                    _this.searchBookingModel.bookingMasterHashId = res.data;
	                else
	                    _this.searchBookingModel.reccuringID = res.data;
	                _this.GetBookingOverview();
	            }
	            else {
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.alertMsg = res.error;
	                _this.ShowAlertPopup();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BookingDriverComponent.prototype.ConfirmProvisionalBookingWithoutRecurringPayment = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.bookingService
	            .ConfirmProvisionalBooking(this.searchBookingModel)
	            .subscribe(function (res) {
	            _this.isLoading = false;
	            if (res.data) {
	                _this.popupTitle = _this.translate.instant('LblSuccess');
	                _this.popupMsg = _this.translate.instant(res.data);
	                _this.isSuccess = true;
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.popupMsg = res.error;
	                _this.isSuccess = false;
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BookingDriverComponent.prototype.CalculateBookingDuration = function (searchModel) {
	        var format = 'DD-MM-YYYY HH:mm';
	        var stDate = moment(searchModel.booking.bookingStartDateTime, format).toDate();
	        var enDate = moment(searchModel.booking.bookingEndDateTime, format).toDate();
	        // if (searchModel.isRecurringBookingAllow && searchModel.recurringEndDateTime) {
	        //   enDate = moment(searchModel.recurringEndDateTime, format).toDate();
	        // }
	        var diffMs = enDate - stDate;
	        var diffDays = Math.floor(diffMs / 86400000); // days
	        var diffHrs = Math.floor((diffMs % 86400000) / 3600000);
	        var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000);
	        if (diffDays > 0) {
	            this.bookingOverviewModel.bookingDuration =
	                diffDays + ' Day ' + diffHrs + ' Hours ' + diffMins + ' Min';
	        }
	        else if (diffDays == 0 && diffHrs > 0) {
	            this.bookingOverviewModel.bookingDuration =
	                diffHrs + ' Hours ' + diffMins + ' Min';
	        }
	        else if (diffDays == 0 && diffHrs == 0) {
	            this.bookingOverviewModel.bookingDuration = diffMins + ' Min';
	        }
	        console.log(this.bookingOverviewModel.bookingDuration);
	    };
	    BookingDriverComponent.prototype.ConfirmProvisionalBooking = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.bookingService
	            .ConfirmRecurringPaymentBooking(this.searchBookingModel.bookingMasterHashId, this.searchBookingModel.reccuringID, this.referenceID)
	            .subscribe(function (res) {
	            _this.isLoading = false;
	            if (res.data) {
	                if (res.data.askForInitialPayment) {
	                    _this.popupDescription = _this.translate.instant('LblPaymentDescription', [res.data.initialPaymentAmount]);
	                    if (res.data.isPaymentSuccess || res.data.isFirstTimePayment) {
	                        _this.initialPaymentPopupTitle = _this.translate.instant('LblFirstBooking');
	                    }
	                    else {
	                        _this.initialPaymentPopupTitle = _this.translate.instant('LblPaymentFailed');
	                    }
	                    _this.creditCardPaymentModal.show();
	                }
	                else {
	                    _this.isLoading = true;
	                    _this.ConfirmProvisionalBookingWithoutRecurringPayment();
	                }
	            }
	            else {
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.popupMsg = res.error;
	                _this.isSuccess = false;
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BookingDriverComponent.prototype.CancelProvisionalBooking = function () {
	        var _this = this;
	        this.isLoading = true;
	        var referenceID = this.searchBookingModel.isRecurring
	            ? this.searchBookingModel.reccuringID
	            : this.searchBookingModel.bookingMasterHashId;
	        this.bookingService
	            .CancelProvisionalBooking(referenceID, this.searchBookingModel.isRecurring)
	            .subscribe(function (res) {
	            _this.isLoading = false;
	            _this.ClearBookingRecord();
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BookingDriverComponent.prototype.GetBookingOverview = function () {
	        var _this = this;
	        this.isLoading = true;
	        var referenceID = this.searchBookingModel.isRecurring
	            ? this.searchBookingModel.reccuringID
	            : this.searchBookingModel.bookingMasterHashId;
	        this.bookingService
	            .GetBookingOverview(referenceID, this.searchBookingModel.isRecurring)
	            .subscribe(function (res) {
	            _this.isLoading = false;
	            if (!res.error) {
	                _this.bookingOverviewModel = res.data;
	                if (_this.bookingOverviewModel.booking != null) {
	                    _this.CalculateBookingDuration(_this.bookingOverviewModel);
	                }
	                if (_this.bookingOverviewModel.reccuringBooking != null) {
	                    _this.bookingOverviewModel.bookingDuration = _this.searchBookingModel.totalBookingDuration;
	                }
	                _this.CURRENTSTEP = _this.BOOKINGSTEP.CONFIRM;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BookingDriverComponent.prototype.ClearBookingRecord = function () {
	        this.isLoading = false;
	        this.searchBookingModel = new search_booking_model_1.SearchBookingModel();
	        this.vehicleOverviewList = [];
	        this.filterVehicleOverviewList = [];
	        this.bookingOverviewModel = new booking_overview_model_1.BookingOverview();
	        this.CURRENTSTEP = this.BOOKINGSTEP.SEARCH;
	        if (!this.isSuccess && !this.isNotEditable) {
	            this.HandleBookingEdit();
	        }
	        else {
	            if (this.isSuccess) {
	                var urlBookingOverview = this.authService.GetURL(config_1.ApplicationRouteURL.URL_BOOKING_OVERVIEW);
	                this.router.navigate([urlBookingOverview]);
	            }
	            else {
	                var urlBookingOverview = this.authService.GetURL(config_1.ApplicationRouteURL.URL_BOOKING);
	                this.router.navigate([urlBookingOverview]);
	            }
	        }
	    };
	    BookingDriverComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    BookingDriverComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    BookingDriverComponent.prototype.ConfirmSuccessPopup = function () {
	        this.HideSuccessPopup();
	        this.ClearBookingRecord();
	    };
	    BookingDriverComponent.prototype.ShowAlertPopup = function () {
	        this.alertModal.show();
	    };
	    BookingDriverComponent.prototype.HideAlertPopup = function () {
	        this.alertModal.hide();
	    };
	    BookingDriverComponent.prototype.SuccessAlertModalClick = function () {
	        this.HideAlertPopup();
	    };
	    Object.defineProperty(BookingDriverComponent.prototype, "diagnostic", {
	        get: function () {
	            return JSON.stringify(this.scheduledBookingModel);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], BookingDriverComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild('creditCardPaymentModal'), 
	        __metadata('design:type', Object)
	    ], BookingDriverComponent.prototype, "creditCardPaymentModal", void 0);
	    __decorate([
	        core_1.ViewChild('alertModal'), 
	        __metadata('design:type', Object)
	    ], BookingDriverComponent.prototype, "alertModal", void 0);
	    __decorate([
	        core_1.ViewChild('searchBooking'), 
	        __metadata('design:type', (typeof (_a = typeof search_booking_component_1.SearchBookingComponent !== 'undefined' && search_booking_component_1.SearchBookingComponent) === 'function' && _a) || Object)
	    ], BookingDriverComponent.prototype, "searchBooking", void 0);
	    BookingDriverComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-booking-driver',
	            template: __webpack_require__(594),
	            styles: [__webpack_require__(595)],
	            providers: [
	                sharedvehiclegroup_service_1.SharedVehicleGroupService,
	                vehicle_service_1.VehicleService,
	                booking_service_1.BookingService,
	                driveradmin_service_1.DriverAdminService
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof booking_service_1.BookingService !== 'undefined' && booking_service_1.BookingService) === 'function' && _b) || Object, (typeof (_c = typeof driveradmin_service_1.DriverAdminService !== 'undefined' && driveradmin_service_1.DriverAdminService) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object, (typeof (_e = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _e) || Object, (typeof (_f = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _f) || Object, (typeof (_g = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _g) || Object])
	    ], BookingDriverComponent);
	    return BookingDriverComponent;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.BookingDriverComponent = BookingDriverComponent;


/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var flatpickr_directive_1 = __webpack_require__(82);
	var auth_service_1 = __webpack_require__(58);
	var translate_service_1 = __webpack_require__(70);
	var flatpickr_model_1 = __webpack_require__(83);
	var config_1 = __webpack_require__(60);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var booking_service_1 = __webpack_require__(556);
	var search_booking_model_1 = __webpack_require__(574);
	var driveradmin_service_1 = __webpack_require__(592);
	var moment = __webpack_require__(84);
	var SearchBookingComponent = (function () {
	    function SearchBookingComponent(bookingService, translate, router, authService, driverAdminService) {
	        this.bookingService = bookingService;
	        this.translate = translate;
	        this.router = router;
	        this.authService = authService;
	        this.driverAdminService = driverAdminService;
	        this.onSearch = new core_1.EventEmitter();
	        this.model = new search_booking_model_1.SearchBookingModel();
	        this.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
	        this.language = 'en';
	    }
	    SearchBookingComponent.prototype.ngOnInit = function () {
	        this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigEnd = this.SetDefaultFlatPickrConfig(true);
	        this.flatPickrConfigFromSpl = this.SetDefaultSplPerFlatPickrConfig(true);
	        this.flatPickrConfigToSpl = this.SetDefaultSplPerFlatPickrConfig(true);
	        if (this.model) {
	            this.searchRetainModal = Object.assign({}, this.model);
	            this.OnOrganizationChange();
	        }
	    };
	    SearchBookingComponent.prototype.ngOnChanges = function (changes) {
	        if ((changes && changes.model && changes.model.currentValue && !changes.model.currentValue.isRegularbooking)) {
	            this.ClearTimeSpanForSpecialPeriod();
	        }
	    };
	    SearchBookingComponent.prototype.SetDefaultFlatPickrConfig = function (isDateOnly) {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = !isDateOnly ? true : false;
	        flatPickrConfig.time_24hr = true;
	        flatPickrConfig.minDate = new Date(new Date().setHours(0, 0, 0));
	        flatPickrConfig.dateFormat = this.dateFormat;
	        flatPickrConfig.minuteIncrement = 1;
	        return flatPickrConfig;
	    };
	    SearchBookingComponent.prototype.SetDefaultSplPerFlatPickrConfig = function (
	        //isDaySpecialPeriod: boolean,
	        isDateOnly) {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = !isDateOnly ? true : false;
	        flatPickrConfig.time_24hr = true;
	        flatPickrConfig.minDate = new Date(new Date().setHours(0, 0, 0));
	        flatPickrConfig.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_FORMAT;
	        flatPickrConfig.minuteIncrement = 1;
	        // if (!isDaySpecialPeriod) {
	        //   flatPickrConfig.enable = [
	        //     (date: any) => {
	        //       // return true to disable
	        //       return date.getDay() === 6 || date.getDay() === 0;
	        //     }
	        //   ];
	        // } else {
	        //   flatPickrConfig.disable = [
	        //     (date: any) => {
	        //       // return true to disable
	        //       return date.getDay() === 6 || date.getDay() === 0;
	        //     }
	        //   ];
	        // }
	        return flatPickrConfig;
	    };
	    SearchBookingComponent.prototype.OnFromDateChange = function (value) {
	        console.log(value);
	        console.log(this.model.endDateTime);
	        if (value && this.model.isRegularbooking) {
	            var format = 'DD-MM-YYYY HH:mm';
	            var newDate = moment(value, format).toDate();
	            var endDate = moment(this.model.endDateTime, format).toDate();
	            var endDateVal = moment(value, format);
	            // let recurringEndDate = moment(this.model.endDateTime, format).toDate();
	            if (endDate <= newDate) {
	                if (this.isenableTime) {
	                    endDateVal = endDateVal.add('H', 1);
	                }
	                else {
	                    endDateVal = endDateVal.add('d', 1);
	                }
	                // recurringEndDate = endDateVal.toDate();
	                this.flatPickrConfigToDate.ChangeValue(endDateVal.format('DD-MM-YYYY HH:mm'));
	            }
	            this.flatPickrConfigToDate.SetOption('minDate', newDate);
	        }
	    };
	    SearchBookingComponent.prototype.OnDayStartDateChange = function (value) {
	        console.log(value);
	        console.log(this.model.endDateTime);
	        if (value) {
	            var format = 'DD-MM-YYYY';
	            var newDate = moment(value, format).toDate();
	            var endDate = moment(this.model.endDateTime, format).toDate();
	            var endDateVal = moment(value, format);
	            // let recurringEndDate = moment(this.model.endDateTime, format).toDate();
	            if (endDate <= newDate) {
	                endDateVal = endDateVal.add('d', 0);
	                // recurringEndDate = endDateVal.toDate();
	                this.flatPickrConfigToDateSpl.ChangeValue(endDateVal.format('DD-MM-YYYY'));
	            }
	            this.flatPickrConfigToDateSpl.SetOption('minDate', newDate);
	        }
	        //this.ChangeDateTimeForInputModel();
	    };
	    SearchBookingComponent.prototype.SetPickerValue = function (key, value) {
	        if (key == 'SEARCH_FROM') {
	            this.flatPickrConfigFromDate.ChangeValue(value);
	        }
	        if (key == 'SEARCH_TO') {
	            this.flatPickrConfigToDate.ChangeValue(value);
	        }
	    };
	    SearchBookingComponent.prototype.ClearErrorModel = function () {
	        this.errorModel = [];
	    };
	    SearchBookingComponent.prototype.ChangeDateTimeForInputModel = function () {
	        if (!this.model.isRegularbooking) {
	            this.model.startDateTime = moment()
	                .add('d', 1)
	                .format('DD-MM-YYYY 00:00');
	            this.model.endDateTime = moment()
	                .add('d', 1)
	                .format('DD-MM-YYYY 00:00');
	            this.ClearTimeSpanForSpecialPeriod();
	        }
	        else {
	            // if (!this.isenableTime) {
	            //   this.model.startDateTime = moment()
	            //     .add('d', 1)
	            //     .format('DD-MM-YYYY 00:00');
	            //   this.model.endDateTime = moment(
	            //     this.model.startDateTime,
	            //     'DD-MM-YYYY 00:00'
	            //   )
	            //     .add('d', 1)
	            //     .format('DD-MM-YYYY 00:00');
	            // } else {
	            //   this.model.startDateTime = moment()
	            //     .add('m', 5)
	            //     .format('DD-MM-YYYY HH:mm');
	            //   this.model.endDateTime = moment()
	            //     .add('H', 1)
	            //     .add('m', 5)
	            //     .format('DD-MM-YYYY HH:mm');
	            // }
	            this.model.startDateTime = this.isenableTime
	                ? moment(this.startDateTimeByTimeZone, 'DD-MM-YYYY HH:mm')
	                    .add(5, 'minute')
	                    .format('DD-MM-YYYY HH:mm')
	                : moment(this.startDateTimeByTimeZone)
	                    .add(1, 'd')
	                    .format('DD-MM-YYYY 00:00');
	            this.model.endDateTime = this.isenableTime
	                ? moment(this.model.startDateTime, 'DD-MM-YYYY HH:mm')
	                    .add(1, 'hour')
	                    .format('DD-MM-YYYY HH:mm', 'DD-MM-YYYY HH:mm')
	                : moment(this.model.startDateTime)
	                    .add(1, 'd')
	                    .format('DD-MM-YYYY 00:00');
	        }
	    };
	    SearchBookingComponent.prototype.ClearTimeSpanForSpecialPeriod = function () {
	        this.model.startDateTime = this.model.startDateTime.substring(0, 10);
	        this.model.endDateTime = this.model.endDateTime.substring(0, 10);
	    };
	    SearchBookingComponent.prototype.OnSearch = function (forms) {
	        // if (!this.geoLocation) {
	        //   this.geoLocationError = this.translate.instant('LblGeoLocationError');
	        // }
	        // else {
	        //this.geoLocationError = '';
	        var _this = this;
	        var tempModel = Object.assign({}, this.model);
	        if (!tempModel.isRegularbooking) {
	            tempModel.startDateTime =
	                tempModel.startDateTime.length <= 10
	                    ? tempModel.startDateTime + ' 00:00'
	                    : tempModel.startDateTime;
	            tempModel.endDateTime =
	                tempModel.endDateTime.length <= 10
	                    ? tempModel.endDateTime + ' 00:00'
	                    : tempModel.endDateTime;
	        }
	        this.CalculateBookingDuration(tempModel);
	        tempModel.totalBookingDuration = this.model.totalBookingDuration;
	        this.message = '';
	        this.errorModel = null;
	        this.isLoading = true;
	        this.bookingService.GetVehicleOverview(tempModel).subscribe(function (res) {
	            _this.isLoading = false;
	            if (!res.data) {
	                _this.errorModel = res.error;
	            }
	            else {
	                if (res.data.length > 0) {
	                    _this.onSearch.emit({
	                        SearchModel: tempModel,
	                        VehicleOverview: res.data
	                    });
	                }
	                else {
	                    _this.message = res.error; //this.translate.instant('LblNoMatchingVehicle');
	                }
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	            // if (!this.model.isRegularbooking) {
	            //   this.ClearTimeSpanForSpecialPeriod();
	            // }
	        });
	        //}
	    };
	    // public GetAddress(place: Object) {
	    //   // this.geoLocation = place['address'] != '' ? true : false;
	    //   // this.model.companyGeoLocationLatitude = place['lat'];
	    //   // this.model.companyGeoLocationLatitude = place['log'];
	    //   this.model.sourceLocation = place['useraddressInput'];
	    // }
	    SearchBookingComponent.prototype.CalculateBookingDuration = function (searchModel) {
	        var format = 'DD-MM-YYYY HH:mm';
	        var stDate = moment(searchModel.startDateTime, format).toDate();
	        var enDate = moment(searchModel.endDateTime, format).toDate();
	        // if (searchModel.isRecurringBookingAllow && searchModel.recurringEndDateTime) {
	        //   enDate = moment(searchModel.recurringEndDateTime, format).toDate();
	        // }
	        var diffMs = enDate - stDate;
	        var diffDays = Math.floor(diffMs / 86400000); // days
	        var diffHrs = Math.floor((diffMs % 86400000) / 3600000);
	        var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000);
	        if (diffDays > 0) {
	            this.model.totalBookingDuration =
	                diffDays + ' Day ' + diffHrs + ' Hours ' + diffMins + ' Min';
	        }
	        else if (diffDays == 0 && diffHrs > 0) {
	            this.model.totalBookingDuration = diffHrs + ' Hours ' + diffMins + ' Min';
	        }
	        else if (diffDays == 0 && diffHrs == 0) {
	            this.model.totalBookingDuration = diffMins + ' Min';
	        }
	        console.log(this.model.totalBookingDuration);
	    };
	    SearchBookingComponent.prototype.SuccessSelectDriverModal = function ($event) {
	        this.model.driverHashId = $event.DriverHashID;
	        this.model.driverName = $event.DriverName;
	        this.language = $event.instanceLanguage;
	        this.model.recurringEndDateTime = '';
	        this.GetOrganizationList();
	    };
	    SearchBookingComponent.prototype.OnOrganizationChange = function () {
	        if (this.model.organizationIdHashID) {
	            this.SelectedDriverDetail();
	            this.AllowRecurringBooking();
	            // this.AllowTimeForBooking();
	            this.GetSpecialPeriodList();
	            /// this.handleChange(true, 'REGULAR', '');
	            console.log(this.specialPeriodList);
	        }
	    };
	    SearchBookingComponent.prototype.SelectedDriverDetail = function () {
	        var _this = this;
	        this.driverAdminService.GetCurrentDriverDetailByDriverId(this.model.driverHashId).subscribe(function (res) {
	            // this.isLoading = false;
	            if (res.data) {
	                _this.startDateTimeByTimeZone = res.data.startDateTime;
	                _this.AllowTimeForBooking();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            // this.isLoading = false;
	        });
	    };
	    SearchBookingComponent.prototype.AllowRecurringBooking = function () {
	        var _this = this;
	        this.bookingService
	            .AllowRecurringBooking(this.model.driverHashId, this.model.organizationIdHashID)
	            .subscribe(function (res) {
	            _this.model.isRecurringBookingAllow = res.data;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    SearchBookingComponent.prototype.GetOrganizationList = function () {
	        var _this = this;
	        this.bookingService.GetOrganizationList(this.model.driverHashId).subscribe(function (res) {
	            _this.model.organizationList = res.data;
	            //this.model.organizationIdHashID = '';
	            if (_this.model &&
	                _this.model.organizationList &&
	                _this.model.organizationList.length == 1) {
	                _this.model.organizationIdHashID = _this.model.organizationList[0].organizationMasterHashId;
	                _this.OnOrganizationChange();
	            }
	            else {
	                _this.model.organizationIdHashID = '';
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    SearchBookingComponent.prototype.GetSpecialPeriodList = function () {
	        var _this = this;
	        this.bookingService
	            .GetSpecialPeriodList(this.model.organizationIdHashID, this.model.driverHashId)
	            .subscribe(function (res) {
	            _this.specialPeriodList = res.data;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        }, function () {
	            //   this.handleChange(true, 'REGULAR', '');
	        });
	    };
	    SearchBookingComponent.prototype.AllowTimeForBooking = function () {
	        var _this = this;
	        this.bookingService
	            .AllowTimeForBooking(this.model.driverHashId, this.model.organizationIdHashID)
	            .subscribe(function (res) {
	            _this.isenableTime = res.data;
	            // this.ChangeDateTimeForInputModel();
	            if (!_this.model.isRegularbooking) {
	                _this.model.startDateTime = moment()
	                    .add('d', 1)
	                    .format('DD-MM-YYYY 00:00');
	                _this.model.endDateTime = moment()
	                    .add('d', 1)
	                    .format('DD-MM-YYYY 00:00');
	                _this.ClearTimeSpanForSpecialPeriod();
	            }
	            else {
	                // if (!this.isenableTime) {
	                //   this.model.startDateTime = moment()
	                //     .add('d', 1)
	                //     .format('DD-MM-YYYY 00:00');
	                //   this.model.endDateTime = moment(
	                //     this.model.startDateTime,
	                //     'DD-MM-YYYY 00:00'
	                //   )
	                //     .add('d', 1)
	                //     .format('DD-MM-YYYY 00:00');
	                //   this.model.recurringPeriod = 'WEEKLY';
	                // } else {
	                //   this.model.startDateTime = moment()
	                //     .add('m', 5)
	                //     .format('DD-MM-YYYY HH:mm');
	                //   this.model.endDateTime = moment()
	                //     .add('H', 1)
	                //     .add('m', 5)
	                //     .format('DD-MM-YYYY HH:mm');
	                //   this.model.recurringPeriod = 'DAILY';
	                // }
	                console.log(_this.startDateTimeByTimeZone);
	                _this.model.startDateTime = _this.isenableTime
	                    ? moment(_this.startDateTimeByTimeZone, 'DD-MM-YYYY HH:mm')
	                        .add(5, 'minute')
	                        .format('DD-MM-YYYY HH:mm')
	                    : moment(_this.startDateTimeByTimeZone, 'DD-MM-YYYY HH:mm')
	                        .add(1, 'd')
	                        .format('DD-MM-YYYY 00:00');
	                _this.model.endDateTime = _this.isenableTime
	                    ? moment(_this.model.startDateTime, 'DD-MM-YYYY HH:mm')
	                        .add(1, 'hour')
	                        .format('DD-MM-YYYY HH:mm', 'DD-MM-YYYY HH:mm')
	                    : moment(_this.model.startDateTime, 'DD-MM-YYYY HH:mm')
	                        .add(1, 'd')
	                        .format('DD-MM-YYYY 00:00');
	                _this.model.recurringPeriod = _this.isenableTime ? 'DAILY' : 'WEEKLY';
	            }
	            if (_this.model.isRegularbooking) {
	                _this.flatPickrConfigFromDate.ToggleTimePicker(_this.isenableTime);
	                _this.flatPickrConfigToDate.ToggleTimePicker(_this.isenableTime);
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        }, function () {
	            if (_this.searchRetainModal) {
	            }
	            if (!_this.model.isRegularbooking) {
	                _this.ClearTimeSpanForSpecialPeriod();
	            }
	        });
	    };
	    SearchBookingComponent.prototype.PickupLocation = function ($event) {
	        this.model.pickupAddress = $event.address;
	        this.model.pickupLat = $event.lat;
	        this.model.pickupLong = $event.long;
	    };
	    SearchBookingComponent.prototype.ResetLocationField = function () {
	        this.model.pickupAddress = '';
	        this.model.pickupLat = 0;
	        this.model.pickupLong = 0;
	    };
	    SearchBookingComponent.prototype.handleChange = function (changeVal, periodType, contractTypeHashID) {
	        this.model.isRegularbooking = changeVal;
	        this.model.specialPeriodType = periodType;
	        this.model.contractTypeHashId = contractTypeHashID;
	        this.model.isRecurring = false;
	        this.model.recurringEndDateTime = '';
	        this.ChangeDateTimeForInputModel();
	        if (!this.model.isRegularbooking && this.flatPickrConfigToDateSpl) {
	            this.flatPickrConfigToDateSpl.ChangeValue(this.model.endDateTime);
	        }
	    };
	    SearchBookingComponent.prototype.ngAfterViewInit = function () {
	        //this.OnFromDateChange(this.model.startDateTime);
	    };
	    __decorate([
	        core_1.Output('OnSearch'), 
	        __metadata('design:type', Object)
	    ], SearchBookingComponent.prototype, "onSearch", void 0);
	    __decorate([
	        core_1.Input('SearchBookingModel'), 
	        __metadata('design:type', (typeof (_a = typeof search_booking_model_1.SearchBookingModel !== 'undefined' && search_booking_model_1.SearchBookingModel) === 'function' && _a) || Object)
	    ], SearchBookingComponent.prototype, "model", void 0);
	    __decorate([
	        core_1.ViewChild('flatPickrConfigFromDate'), 
	        __metadata('design:type', (typeof (_b = typeof flatpickr_directive_1.FlatPickrDirective !== 'undefined' && flatpickr_directive_1.FlatPickrDirective) === 'function' && _b) || Object)
	    ], SearchBookingComponent.prototype, "flatPickrConfigFromDate", void 0);
	    __decorate([
	        core_1.ViewChild('flatPickrConfigToDate'), 
	        __metadata('design:type', (typeof (_c = typeof flatpickr_directive_1.FlatPickrDirective !== 'undefined' && flatpickr_directive_1.FlatPickrDirective) === 'function' && _c) || Object)
	    ], SearchBookingComponent.prototype, "flatPickrConfigToDate", void 0);
	    __decorate([
	        core_1.ViewChild('flatPickrConfigEndDate'), 
	        __metadata('design:type', (typeof (_d = typeof flatpickr_directive_1.FlatPickrDirective !== 'undefined' && flatpickr_directive_1.FlatPickrDirective) === 'function' && _d) || Object)
	    ], SearchBookingComponent.prototype, "flatPickrConfigEndDate", void 0);
	    __decorate([
	        core_1.ViewChild('flatPickrConfigFromDateSpl'), 
	        __metadata('design:type', (typeof (_e = typeof flatpickr_directive_1.FlatPickrDirective !== 'undefined' && flatpickr_directive_1.FlatPickrDirective) === 'function' && _e) || Object)
	    ], SearchBookingComponent.prototype, "flatPickrConfigFromDateSpl", void 0);
	    __decorate([
	        core_1.ViewChild('flatPickrConfigToDateSpl'), 
	        __metadata('design:type', (typeof (_f = typeof flatpickr_directive_1.FlatPickrDirective !== 'undefined' && flatpickr_directive_1.FlatPickrDirective) === 'function' && _f) || Object)
	    ], SearchBookingComponent.prototype, "flatPickrConfigToDateSpl", void 0);
	    SearchBookingComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-search-booking',
	            template: __webpack_require__(593),
	            styles: [
	                "\n      .box-body {\n        padding: 0px 10px 10px;\n      }\n    "
	            ],
	            providers: [driveradmin_service_1.DriverAdminService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_g = typeof booking_service_1.BookingService !== 'undefined' && booking_service_1.BookingService) === 'function' && _g) || Object, (typeof (_h = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _h) || Object, (typeof (_j = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _j) || Object, (typeof (_k = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _k) || Object, (typeof (_l = typeof driveradmin_service_1.DriverAdminService !== 'undefined' && driveradmin_service_1.DriverAdminService) === 'function' && _l) || Object])
	    ], SearchBookingComponent);
	    return SearchBookingComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
	}());
	exports.SearchBookingComponent = SearchBookingComponent;


/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var DriverAdminService = (function () {
	    function DriverAdminService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    DriverAdminService.prototype.GetCurrentDriverDetail = function () {
	        var getDriverUrl = config_1.WeGoConfig.API_GET_CURRENT_DRIVER;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getDriverUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    DriverAdminService.prototype.GetCurrentDriverDetailByDriverId = function (driverHashId) {
	        var getDriverUrl = config_1.WeGoConfig.API_GET_SELECTED_DRIVER;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        getDriverUrl =
	            getDriverUrl +
	                '?driverHashId=' +
	                driverHashId;
	        return this.http.get(getDriverUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    DriverAdminService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], DriverAdminService);
	    return DriverAdminService;
	    var _a, _b;
	}());
	exports.DriverAdminService = DriverAdminService;


/***/ },
/* 593 */
/***/ function(module, exports) {

	module.exports = "<div class=\"box box-default\">\r\n  <div class=\"box-header with-border\">\r\n    <h3 class=\"box-title\">\r\n      <span *ngIf=\"!model.isEditMode\">{{ 'LblSearchForVehicle' | translate }}</span>\r\n      <span *ngIf=\"model.isEditMode\">{{ 'LblCurrentBookingDetail' | translate }}</span>\r\n    </h3>\r\n  </div>\r\n  <div class=\"box-body\" style=\"display: block;\">\r\n    <form (ngSubmit)=\"OnSearch(searchForm.value)\" #searchForm=\"ngForm\">\r\n      <div *ngIf=\"model.isEditMode\" class=\"form-group\">\r\n        <label>{{ 'LblLicenceTag' | translate }}</label>\r\n        <p>{{ model.vehicleLicenceTag }}</p>\r\n      </div>\r\n      <div *ngIf=\"!model.isEditMode && !authService.IsDriver()\" class=\"form-group\">\r\n        <label>\r\n          <span class=\"text text-danger\">*</span>{{ 'LblDriver' | translate }}</label>\r\n        <div class=\"input-group\">\r\n          <input [(ngModel)]=\"model.driverName\" name=\"driverName\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblDriver' | translate }}\"\r\n            readonly>\r\n          <div class=\"input-group-btn\">\r\n            <button class=\"btn btn-default\" type=\"button\" (click)=\"selectDriverModal.show()\">\r\n              <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\r\n            </button>\r\n          </div>\r\n        </div>\r\n        <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'driverHashId' }}</span>\r\n      </div>\r\n      <div *ngIf=\"!model.isEditMode\" class=\"form-group\">\r\n        <label>\r\n          <span class=\"text text-danger\">*</span>{{ 'LblOrganization' | translate }}</label>\r\n        <select [(ngModel)]=\"model.organizationIdHashID\" class=\"form-control\" name=\"organizationHashId\" (change)=\"OnOrganizationChange()\">\r\n          <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblOrganization' | translate }}</option>\r\n          <option *ngFor=\"let item of model.organizationList\" [ngValue]=\"item.organizationMasterHashId\">{{ item.organizationName }}</option>\r\n        </select>\r\n        <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'OrganizationIdHashID' }}</span>\r\n      </div>\r\n      <div *ngIf=\"model.isEditMode\" class=\"form-group\">\r\n        <label>{{ 'LblOrganization' | translate }}</label>\r\n        <p>{{ model.organizationName }}</p>\r\n      </div>\r\n      <div class=\"form-group\">\r\n        <label>\r\n          <span class=\"text text-danger\">*</span>{{ 'LblPickupLocation' | translate }}</label>\r\n        <div class=\"input-group\">\r\n          <input [(ngModel)]=\"model.pickupAddress\" name=\"pickupAddress\" type=\"text\" class=\"form-control\" [attr.title]=\"model.pickupAddress\"\r\n            placeholder=\"{{ 'LblPickupLocation' | translate }}\" readonly>\r\n          <div class=\"input-group-btn\">\r\n            <button class=\"btn btn-default\" type=\"button\" (click)=\"geoLocationModal.show(model.pickupAddress, model.pickupLat, model.pickupLong)\">\r\n              <i class=\"fa fa-map-marker\" aria-hidden=\"true\"></i>\r\n            </button>\r\n            <button class=\"btn btn-default\" type=\"button\" (click)=\"ResetLocationField()\">\r\n              <i class=\"fa fa-eraser\" aria-hidden=\"true\"></i>\r\n            </button>\r\n          </div>\r\n        </div>\r\n        <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'pickupAddress' }}</span>\r\n      </div>\r\n      <div *ngIf=\"!model.isEditMode\">\r\n        <div class=\"form-group\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblBookingType' | translate }}</label>\r\n          <div class=\"input-group\">\r\n            <div class=\"radio\">\r\n              <label>\r\n                <input type=\"radio\" name=\"specialPeriodType\" [value]=\"\" checked=\"model.isRegularbooking\" (change)=\"handleChange(true,'REGULAR','')\"> {{ 'LblRegular' | translate }}</label>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div *ngIf=\"model.isEditMode\" class=\"form-group\">\r\n        <label>{{ 'LblBookingType' | translate }}</label>\r\n        <p *ngIf=\"!model.isRegularbooking\">{{ 'LblSpecialRate' | translate }}</p>\r\n        <p *ngIf=\"!model.isRegularbooking\">{{ model.specialPeriodContractTypeName }}</p>\r\n        <p *ngIf=\"model.isRegularbooking\">{{ 'LblRegular' | translate }}</p>\r\n      </div>\r\n      <div [ngClass]=\" {'hidden':(!model.isRegularbooking)}\" *ngIf=\"model.isRegularbooking\">\r\n        <div class=\"form-group\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblBookingStartDateTime' | translate }}</label>\r\n          <div class=\"input-group\">\r\n            <span class=\"input-group-addon\">\r\n              <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n            </span>\r\n            <input #flatPickrConfigFromDate=\"wego-flatpickr\" flatpickr readonly [Config]=\"flatPickrConfigFrom\" [(ngModel)]=\"model.startDateTime\"\r\n              name=\"startDateTime\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblBookingStartDateTime' | translate\r\n        }}\" (change)=\"OnFromDateChange($event.target.value)\">\r\n          </div>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'startDateTime' }}</span>\r\n        </div>\r\n        <div class=\"form-group\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblBookingEndDateTime' | translate }}</label>\r\n          <div class=\"input-group\">\r\n            <span class=\"input-group-addon\">\r\n              <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n            </span>\r\n            <input #flatPickrConfigToDate=\"wego-flatpickr\" flatpickr readonly [Config]=\"flatPickrConfigTo\" [(ngModel)]=\"model.endDateTime\"\r\n              name=\"endDateTime\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblBookingEndDateTime' | translate }}\">\r\n          </div>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'endDateTime' }}</span>\r\n        </div>\r\n      </div>\r\n      <div [ngClass]=\" {'hidden':(model.isRegularbooking)}\" *ngIf=\"!model.isRegularbooking\">\r\n        <div class=\"form-group\" *ngIf=\"model.specialPeriodType=='DAY'\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblBookingStartDateTime' | translate }}</label>\r\n          <div class=\"input-group\">\r\n            <span class=\"input-group-addon\">\r\n              <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n            </span>\r\n            <input #flatPickrConfigFromDateSpl=\"wego-flatpickr\" flatpickr readonly [Config]=\"flatPickrConfigFromSpl\" [(ngModel)]=\"model.startDateTime\"\r\n              name=\"startDateTime\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblBookingStartDateTime' | translate\r\n        }}\" (change)=\"OnDayStartDateChange($event.target.value)\">\r\n          </div>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'startDateTime' }}</span>\r\n        </div>\r\n        <div class=\"form-group\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblBookingEndDateTime' | translate }}</label>\r\n          <div class=\"input-group\">\r\n            <span class=\"input-group-addon\">\r\n              <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n            </span>\r\n            <input #flatPickrConfigToDateSpl=\"wego-flatpickr\" flatpickr readonly [Config]=\"flatPickrConfigToSpl\" [(ngModel)]=\"model.endDateTime\"\r\n              name=\"endDateTime\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblBookingEndDateTime' | translate }}\">\r\n          </div>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'endDateTime' }}</span>\r\n        </div>\r\n      </div>\r\n      <!-- <pre>{{model.startDateTime}}</pre>\r\n      <pre>{{model.endDateTime}}</pre> -->\r\n      <div *ngIf=\"!model.isEditMode && model.isRecurringBookingAllow && model.isRegularbooking\" class=\"form-group\">\r\n        <div class=\"checkbox\">\r\n          <label>\r\n            <input [(ngModel)]=\"model.isRecurring\" type=\"checkbox\" name=\"isRecursive\">&nbsp;{{ 'LblRecurring' | translate }}</label>\r\n        </div>\r\n      </div>\r\n      <template [ngIf]=\"model.isRecurring && model.isRecurringBookingAllow && model.isRegularbooking\">\r\n        <div class=\"form-group\">\r\n          <div class=\"radio\" *ngIf=\"isenableTime\">\r\n            <label>\r\n              <input type=\"radio\" name=\"recurringPeriod\" [(ngModel)]=\"model.recurringPeriod\" value=\"DAILY\">&nbsp;{{ 'LblDaily' | translate }}</label>\r\n          </div>\r\n          <div class=\"radio\">\r\n            <label>\r\n              <input type=\"radio\" name=\"recurringPeriod\" [(ngModel)]=\"model.recurringPeriod\" value=\"WEEKLY\">&nbsp;{{ 'LblWeekly' | translate }}</label>\r\n          </div>\r\n          <div class=\"radio\">\r\n            <label>\r\n              <input type=\"radio\" name=\"recurringPeriod\" [(ngModel)]=\"model.recurringPeriod\" value=\"MONTHLY\">&nbsp;{{ 'LblMonthly' | translate }}</label>\r\n          </div>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'RecurringPeriod' }}</span>\r\n        </div>\r\n        <div class=\"form-group\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblRecurrenceEndDate' | translate }}</label>\r\n          <div class=\"input-group\">\r\n            <span class=\"input-group-addon\">\r\n              <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n            </span>\r\n            <input #flatPickrConfigEndDate=\"wego-flatpickr\" flatpickr readonly [Config]=\"flatPickrConfigEnd\" type=\"text\" [(ngModel)]=\"model.recurringEndDateTime\"\r\n              name=\"recurringEndDateTime\" class=\"form-control\" placeholder=\"{{ 'LblRecurrenceEndDate' | translate }}\">\r\n          </div>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'RecurringEndDateTime' }}</span>\r\n        </div>\r\n      </template>\r\n      <button class=\"btn btn-highlight\" type=\"submit\" style=\"padding: 3px 10px;\">\r\n        <span *ngIf=\"!model.isEditMode\">{{ 'LblSearch' | translate }}</span>\r\n        <span *ngIf=\"model.isEditMode\">{{ 'LblCheckAvailability' | translate }}</span>\r\n      </button>\r\n      <div class=\"form-group\">\r\n        <span class=\"text text-danger\">{{message}}</span>\r\n      </div>\r\n    </form>\r\n    <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n  </div>\r\n</div>\r\n\r\n\r\n<wego-select-driver-popup #selectDriverModal (OnSuccessSelect)=\"SuccessSelectDriverModal($event)\"></wego-select-driver-popup>\r\n<wego-geo-location-map #geoLocationModal (onConfirm)=\"PickupLocation($event)\" [Language] = \"language\"></wego-geo-location-map>";

/***/ },
/* 594 */
/***/ function(module, exports) {

	module.exports = "<section class=\"banner-img-in\">\r\n  <div class=\"banner-in\">\r\n    <div class=\"search-bg-in\">\r\n      <div class=\"container-fluid\">\r\n        <div class=\"row\" style=\"padding-right:15px;\">\r\n          <div class=\"col-md-3 col-sm-6\">\r\n            <h2 class=\"pagename\">{{ 'LblNormal' | translate }}</h2>\r\n          </div>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n<div class=\"clearfix\"></div>\r\n<section class=\"content\">\r\n  <div class=\"container-fluid\">\r\n    <div [hidden]=\"isBanned || isLicenceRequired\">\r\n      <div class=\"row\">\r\n        <div class=\"driver-booking-steps col-md-12\">\r\n          <ul class=\" nav3 nav-wizard \">\r\n            <li (click)=\"ChangeStep(BOOKINGSTEP.SEARCH) \" [ngClass]=\"{ 'active' : CURRENTSTEP==BOOKINGSTEP.SEARCH, 'disabled' : CURRENTSTEP < BOOKINGSTEP.SEARCH} \">\r\n              <a>\r\n                <i class=\"fa fa-search fa-fw \"></i>\r\n                <span *ngIf=\"!searchBookingModel.isEditMode\">&nbsp;{{ 'LblSearchForVehicle' | translate }}</span>\r\n                <span *ngIf=\"searchBookingModel.isEditMode\">&nbsp;{{ 'LblCurrentBookingDetail' | translate }}</span>\r\n              </a>\r\n            </li>\r\n            <li (click)=\"ChangeStep(BOOKINGSTEP.VEHICLE) \" [ngClass]=\"{ 'active' : CURRENTSTEP==BOOKINGSTEP.VEHICLE, 'disabled' : CURRENTSTEP < BOOKINGSTEP.VEHICLE} \">\r\n              <a>\r\n                <i class=\"fa fa-cab fa-fw \"></i>&nbsp;{{ 'LblVehicleOverview' | translate }}</a>\r\n            </li>\r\n            <li (click)=\"ChangeStep(BOOKINGSTEP.CONFIRM) \" [ngClass]=\"{ 'active' : CURRENTSTEP==BOOKINGSTEP.CONFIRM, 'disabled' : CURRENTSTEP < BOOKINGSTEP.CONFIRM} \">\r\n              <a>\r\n                <i class=\"fa fa-check fa-fw \"></i>&nbsp;{{ 'LblOverview' | translate }}</a>\r\n            </li>\r\n          </ul>\r\n        </div>\r\n      </div>\r\n      <div class=\"row \">\r\n        <div class=\"col-sm-12 \">\r\n          <alert *ngIf=\"isNotEditable \" (close)=\"AlertClose($event) \" type=\"danger \" dismissible=\"true \" dismissOnTimeout=\"3000 \">{{ alertMsg }}</alert>\r\n        </div>\r\n        <div class=\"col-sm-12\">\r\n          <alert *ngIf=\"!IsVehicleAvailableForUpdate && CURRENTSTEP==BOOKINGSTEP.VEHICLE\" class=\"text-center\" type=\"danger\">\r\n            {{ 'LblEditCarNotAvailable' | translate }}\r\n          </alert>\r\n        </div>\r\n        <div *ngIf=\"CURRENTSTEP==BOOKINGSTEP.SEARCH \" class=\"col-sm-4\">\r\n          <wego-search-booking-driver #searchBooking [SearchBookingModel]=\"searchBookingModel\" [IsDriverHashID]=\"isDriverHashID\" [TimezoneStartDateTime]=\"timezoneStartDateTime\" (OnSearch)=\"OnSearch($event) \"></wego-search-booking-driver>\r\n        </div>\r\n        <div *ngIf=\"CURRENTSTEP==BOOKINGSTEP.SEARCH \" class=\"col-sm-8\">\r\n          <wego-scheduler-booking-driver (OnSearch)=\"OnSearchBooking($event) \"></wego-scheduler-booking-driver>\r\n        </div>\r\n        <div *ngIf=\"CURRENTSTEP==BOOKINGSTEP.VEHICLE \" class=\"col-sm-3 nopad\">\r\n          <wego-filter-vehicle-overview-driver [VehicleOverviewList]=\"vehicleOverviewList \" (OnUpdateVehicleOverView)=\"OnUpdateVehicleOverView($event) \"></wego-filter-vehicle-overview-driver>\r\n        </div>\r\n        <div *ngIf=\"CURRENTSTEP==BOOKINGSTEP.VEHICLE \" class=\"col-sm-9 \">\r\n          <wego-vehicle-overview-driver [SearchBookingModel]=\"searchBookingModel \" [VehicleOverviewList]=\"filterVehicleOverviewList \"\r\n            (OnBook)=\"OnBook($event) \"></wego-vehicle-overview-driver>\r\n        </div>\r\n        <div *ngIf=\"CURRENTSTEP==BOOKINGSTEP.CONFIRM \" class=\"col-sm-12 \">\r\n          <wego-confirm-booking-driver [BookingOverview]=\"bookingOverviewModel \" [searchBookingModel]=\"searchBookingModel\" [BookingRemarks]=\"searchBookingModel.bookingRemarks \"\r\n            (OnConfirmBooking)=\"OnConfirmBooking($event) \" (OnCancelBooking)=\"OnCancelBooking($event) \"></wego-confirm-booking-driver>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div [hidden]=\"!isBanned \" class=\"nopad \">\r\n      <div class=\"alert alert-danger\">\r\n        <p class=\"text-center\">\r\n          {{ userBlockMessage }}\r\n        </p>\r\n      </div>\r\n    </div>\r\n    <div [hidden]=\"!isLicenceRequired\" class=\"nopad \">\r\n      <div class=\"alert alert-danger\">\r\n        <p class=\"text-center\">\r\n          {{ 'LblLicenceRequired1' | translate }}\r\n          <a class=\"\" style=\"color:#fff\" [routerLink]=\"[urlDriverUpdate,{personId:personMasterHashId}]\">\r\n            <u> {{ 'LblProfile' | translate }}</u>\r\n          </a> {{ 'LblLicenceRequired2' | translate }}</p>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n\r\n<wego-success-popup #alertModal [popupTitle]=\"popupTitle \" [popupMsg]=\"alertMsg \" (onConfirm)=\"SuccessAlertModalClick() \"></wego-success-popup>\r\n\r\n<wego-success-popup #successPopup [popupTitle]=\"popupTitle \" [popupMsg]=\"popupMsg \" (onConfirm)=\"ConfirmSuccessPopup() \"></wego-success-popup>\r\n\r\n<wego-credit-card-payment-popup #creditCardPaymentModal [popupDescription]=\"popupDescription\" [initialPaymentPopupTitle]=\"initialPaymentPopupTitle\"\r\n  [errorMessage]=\"errorMessage\" (isAllowInitialPayment)=\"GetInitialPaymentValue($event)\" (onProceed)=\"ConfirmInitialPayment($event)\"\r\n  (onCancel)=\"OnCancelPayment()\"></wego-credit-card-payment-popup>\r\n\r\n<wego-lodder [isLoading]=\"isLoading \"></wego-lodder>";

/***/ },
/* 595 */
/***/ function(module, exports) {

	module.exports = ".nav-wizard{\r\nmargin-bottom: 20px;\r\n    }\r\n.nav-wizard > li {\r\n  float: left;\r\n  width: 33.33%;\r\n  text-align: center;\r\n}\r\n.nav-wizard > li > a {\r\n  position: relative;\r\n  background-color: #eeeeee;\r\n  color: #2ba2aa;\r\n  cursor: pointer;\r\n}\r\n.nav-wizard > li > a .badge {\r\n  margin-left: 3px;\r\n  color: #eeeeee;\r\n  background-color: #2ba2aa;\r\n}\r\n.nav-wizard > li:not(:first-child) > a {\r\n  padding-left: 34px;\r\n}\r\n.nav-wizard > li:not(:first-child) > a:before {\r\n  width: 0px;\r\n  height: 0px;\r\n  border-top: 20px inset transparent;\r\n  border-bottom: 20px inset transparent;\r\n  border-left: 20px solid #ffffff;\r\n  position: absolute;\r\n  content: \"\";\r\n  top: 0;\r\n  left: 0;\r\n}\r\n.nav-wizard > li:not(:last-child) > a {\r\n  margin-right: 6px;\r\n}\r\n.nav-wizard > li:not(:last-child) > a:after {\r\n  width: 0px;\r\n  height: 0px;\r\n  border-top: 20px inset transparent;\r\n  border-bottom: 20px inset transparent;\r\n  border-left: 20px solid #eeeeee;\r\n  position: absolute;\r\n  content: \"\";\r\n  top: 0;\r\n  right: -20px;\r\n  z-index: 2;\r\n}\r\n.nav-wizard > li:first-child > a {\r\n  border-top-left-radius: 4px;\r\n  border-bottom-left-radius: 4px;\r\n}\r\n.nav-wizard > li:last-child > a {\r\n  border-top-right-radius: 4px;\r\n  border-bottom-right-radius: 4px;\r\n}\r\n.nav-wizard > li.done:hover > a,\r\n.nav-wizard > li:hover > a {\r\n  background-color: #d5d5d5;\r\n}\r\n.nav-wizard > li.done:hover > a:before,\r\n.nav-wizard > li:hover > a:before {\r\n  border-right-color: #d5d5d5;\r\n}\r\n.nav-wizard > li.done:hover > a:after,\r\n.nav-wizard > li:hover > a:after {\r\n  border-left-color: #d5d5d5;\r\n}\r\n.nav-wizard > li.done > a {\r\n  background-color: #e2e2e2;\r\n}\r\n.nav-wizard > li.done > a:before {\r\n  border-right-color: #e2e2e2;\r\n}\r\n.nav-wizard > li.done > a:after {\r\n  border-left-color: #e2e2e2;\r\n}\r\n.nav-wizard > li.active > a,\r\n.nav-wizard > li.active > a:hover,\r\n.nav-wizard > li.active > a:focus {\r\n  color: #ffffff;\r\n  background-color: #2ba2aa;\r\n}\r\n.nav-wizard > li.active > a:after {\r\n  border-left-color: #2ba2aa;\r\n}\r\n.nav-wizard > li.active > a .badge {\r\n  color: #2ba2aa;\r\n  background-color: #ffffff;\r\n}\r\n.nav-wizard > li.disabled > a {\r\n  color: #777777;\r\n  cursor: not-allowed;\r\n}\r\n.nav-wizard > li.disabled > a:hover,\r\n.nav-wizard > li.disabled > a:focus {\r\n  color: #777777;\r\n  text-decoration: none;\r\n  background-color: #eeeeee;\r\n  /*cursor: default;*/\r\n}\r\n.nav-wizard > li.disabled > a:before {\r\n  border-right-color: #eeeeee;\r\n}\r\n.nav-wizard > li.disabled > a:after {\r\n  border-left-color: #eeeeee;\r\n}\r\n.nav-wizard.nav-justified > li {\r\n  float: none;\r\n}\r\n.nav-wizard.nav-justified > li > a {\r\n  padding: 10px 15px;\r\n}\r\n@media (max-width: 768px) {\r\n  .nav-wizard.nav-justified > li > a {\r\n    border-radius: 4px;\r\n    margin-right: 0;\r\n  }\r\n  .nav-wizard.nav-justified > li > a:before,\r\n  .nav-wizard.nav-justified > li > a:after {\r\n    border: none !important;\r\n  }\r\n}"

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var userprofile_model_1 = __webpack_require__(597);
	var userprofile_service_1 = __webpack_require__(598);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var common_1 = __webpack_require__(22);
	var flatpickr_model_1 = __webpack_require__(83);
	var DriverProfile = (function () {
	    function DriverProfile(personService, activeRoute, router, authService, translate, locationService) {
	        this.personService = personService;
	        this.activeRoute = activeRoute;
	        this.router = router;
	        this.authService = authService;
	        this.translate = translate;
	        this.locationService = locationService;
	        this.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_FORMAT;
	        this.submitted = false;
	        this.isDateOfBirth = false;
	        this.IBANNumberMessage = false;
	        this.isCreditCard = false;
	    }
	    DriverProfile.prototype.ngOnInit = function () {
	        var _this = this;
	        this.module = this.translate.instant("LblProfile");
	        this.creditCardModule = this.translate.instant("LblCreditCardDetails");
	        this.flatPickrConfigDateOfBirth = this.SetDefaultFlatPickrConfig();
	        this.translate.setDetectedLang();
	        this.model = new userprofile_model_1.UserProfileModel();
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.GetTelephoneCountry();
	        this.sub = this.activeRoute.params.subscribe(function (params) {
	            _this.IBANNumberMessage = params["IBANNumberMessage"];
	            if (_this.IBANNumberMessage) {
	                _this.warningMessage = _this.translate.instant("LblIBANNumberRequired", [
	                    _this.module
	                ]);
	            }
	        });
	        this.GetPersonDetails();
	        this.GetPersonCountry();
	    };
	    DriverProfile.prototype.GetPersonDetails = function () {
	        var _this = this;
	        this.personService.GetUserByPersonHashId().subscribe(function (res) {
	            _this.model = res.data;
	            _this.isDateOfBirth = _this.model.dateOfBirth != "" ? true : false;
	            if (_this.model.liceanceNumberValidated) {
	                _this.flatPickrConfigDateOfBirth.clickOpens = false;
	            }
	            _this.GetCreditCardDetails();
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.message = error;
	        });
	    };
	    DriverProfile.prototype.GetPersonCountry = function () {
	        var _this = this;
	        this.authService.GetPersonCountry()
	            .subscribe(function (res) {
	            _this.personCountryList = res.data;
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    DriverProfile.prototype.GetCreditCardDetails = function () {
	        var _this = this;
	        this.personService.GetCreditCardDetailsByPersonHashId().subscribe(function (res) {
	            _this.model.CreditCardDetails = res.data;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.message = error;
	        });
	    };
	    DriverProfile.prototype.SetDefaultFlatPickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = false;
	        flatPickrConfig.time_24hr = false;
	        flatPickrConfig.dateFormat = this.dateFormat;
	        flatPickrConfig.maxDate = new Date(new Date());
	        return flatPickrConfig;
	    };
	    DriverProfile.prototype.onSubmit = function (forms) {
	        this.submitted = true;
	        this.UpdatePersonProfile();
	    };
	    DriverProfile.prototype.UpdatePersonProfile = function () {
	        var _this = this;
	        this.personService.UpdateUserProfile(this.model).subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant("LblRecordUpdatedSuccess", [
	                    _this.module
	                ]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    DriverProfile.prototype.GetTelephoneCountry = function () {
	        var _this = this;
	        this.authService.GetTelephoneCountry().subscribe(function (res) {
	            _this.countryList = res.data;
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    DriverProfile.prototype.ShowChangePasswordModal = function (personMasterHashId) {
	        this.changePasswordModal.personHashId = personMasterHashId;
	        this.changePasswordModal.show();
	    };
	    DriverProfile.prototype.ChangePasswordModal = function ($event) {
	        this.message = $event.SuccessMessage;
	    };
	    DriverProfile.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    DriverProfile.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	        if (this.isCreditCard == false) {
	            this.OnBackClick();
	        }
	    };
	    DriverProfile.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	        if (this.isCreditCard == false) {
	            this.OnBackClick();
	        }
	        else {
	            this.GetCreditCardDetails();
	        }
	    };
	    DriverProfile.prototype.OnBackClick = function () {
	        this.locationService.back();
	    };
	    DriverProfile.prototype.ShowDeleteConfirmModal = function (creditCardHashId) {
	        this.isLoading = false;
	        this.deleteMessage = this.translate.instant("LblRecordDeleteConfirmation", [
	            this.creditCardModule
	        ]);
	        this.deleteConfirmModal.show();
	        this.creditCardHashId = creditCardHashId;
	    };
	    DriverProfile.prototype.HideDeleteConfirmModal = function () {
	        this.deleteConfirmModal.hide();
	    };
	    DriverProfile.prototype.DeleteConfirmSuccessClick = function () {
	        this.deleteConfirmModal.hide();
	        this.OnDelete();
	    };
	    DriverProfile.prototype.OnDelete = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.personService.DeleteCreditCardDetails(this.creditCardHashId).subscribe(function (res) {
	            if (res.data) {
	                _this.isLoading = false;
	                _this.popupMsg = _this.translate.instant("LblRecordRemovedSuccess", [
	                    _this.creditCardModule
	                ]);
	                _this.isCreditCard = true;
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.isLoading = false;
	                _this.popupMsg = _this.translate.instant("LblInvoiceDeleteValidation");
	                _this.isLoading = false;
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    DriverProfile.prototype.ngOnDestroy = function () {
	        if (this.sub) {
	            this.sub.unsubscribe();
	        }
	    };
	    __decorate([
	        core_1.ViewChild("changePasswordModal"), 
	        __metadata('design:type', Object)
	    ], DriverProfile.prototype, "changePasswordModal", void 0);
	    __decorate([
	        core_1.ViewChild("successPopup"), 
	        __metadata('design:type', Object)
	    ], DriverProfile.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild("childModal"), 
	        __metadata('design:type', Object)
	    ], DriverProfile.prototype, "childModal", void 0);
	    __decorate([
	        core_1.ViewChild("deleteConfirmModal"), 
	        __metadata('design:type', Object)
	    ], DriverProfile.prototype, "deleteConfirmModal", void 0);
	    DriverProfile = __decorate([
	        core_1.Component({
	            selector: "wego-driver-profile",
	            template: __webpack_require__(599),
	            styles: [
	                "\n      .input-group.telephone-group .input-group-addon {\n        padding: 0px;\n        border: 0px;\n      }\n      .country-select {\n        width: 60px;\n        border: 1px solid #d2d6de;\n        padding: 3px;\n        border-bottom-left-radius: 3px;\n        border-top-left-radius: 3px;\n      }\n    "
	            ],
	            providers: [userprofile_service_1.UserProfileService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof userprofile_service_1.UserProfileService !== 'undefined' && userprofile_service_1.UserProfileService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _d) || Object, (typeof (_e = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _e) || Object, (typeof (_f = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _f) || Object])
	    ], DriverProfile);
	    return DriverProfile;
	    var _a, _b, _c, _d, _e, _f;
	}());
	exports.DriverProfile = DriverProfile;


/***/ },
/* 597 */
/***/ function(module, exports) {

	"use strict";
	var EmailAddressModel = (function () {
	    function EmailAddressModel() {
	    }
	    return EmailAddressModel;
	}());
	exports.EmailAddressModel = EmailAddressModel;
	var UserProfileAddressModel = (function () {
	    function UserProfileAddressModel() {
	    }
	    return UserProfileAddressModel;
	}());
	exports.UserProfileAddressModel = UserProfileAddressModel;
	var CreditCardDetails = (function () {
	    function CreditCardDetails() {
	    }
	    return CreditCardDetails;
	}());
	exports.CreditCardDetails = CreditCardDetails;
	var UserProfileModel = (function () {
	    function UserProfileModel() {
	        this.countryCode1 = "";
	        this.countryCode2 = "";
	        this.validateLiceanceNumber = false;
	        this.isnifEnabled = false;
	        this.sso = false;
	        this.personHomeAddressModel = new UserProfileAddressModel();
	        this.personWorkAddressModel = new UserProfileAddressModel();
	        this.emailAddressModel = new EmailAddressModel();
	    }
	    return UserProfileModel;
	}());
	exports.UserProfileModel = UserProfileModel;


/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var UserProfileService = (function () {
	    function UserProfileService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    UserProfileService.prototype.GetUserByPersonHashId = function () {
	        //let getPersonUrl = WeGoConfig.API_GET_PERSON_BY_HASH + "?personHashId=" + personHashId;
	        var getPersonUrl = config_1.WeGoConfig.API_GET_PROFILE_DETAIL;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getPersonUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    UserProfileService.prototype.GetCreditCardDetailsByPersonHashId = function () {
	        var getCredtiCardUrl = config_1.WeGoConfig.API_GET_CREDITCARD_DETAILS;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getCredtiCardUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    UserProfileService.prototype.UpdateUserProfile = function (personModel) {
	        var body = personModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_UserPROFILE_DETAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    UserProfileService.prototype.SubmitChangePassword = function (changepasswordModal) {
	        var body = changepasswordModal;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_CHANGEUSERPASSSWORD, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    UserProfileService.prototype.DeleteCreditCardDetails = function (creditCardHashId) {
	        var deleteCreditCardDetails = config_1.WeGoConfig.API_DELETE_CREDITCARD_DETAILS_BYHASHID +
	            "?creditCardHashId=" +
	            creditCardHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(deleteCreditCardDetails, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    UserProfileService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], UserProfileService);
	    return UserProfileService;
	    var _a, _b;
	}());
	exports.UserProfileService = UserProfileService;


/***/ },
/* 599 */
/***/ function(module, exports) {

	module.exports = "<section class=\"banner-img-in\">\r\n  <div class=\"banner-in\">\r\n    <div class=\"search-bg-in\">\r\n      <div class=\"container-fluid\">\r\n        <div class=\"row\" style=\"padding-right:15px;\">\r\n          <div class=\"col-sm-6\">\r\n            <h2 class=\"pagename\">{{ 'LblUpdateProfile' | translate }}</h2>\r\n          </div>\r\n          <div *ngIf=\"!model.sso\" class=\"col-sm-6\">\r\n            <div class=\"form-space-top pull-right\">\r\n              <button class=\"btn btn-success navbar-right\" (click)=\"ShowChangePasswordModal(model.personMasterHashId)\">{{'LblChangePassword'| translate}}</button>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n<div class=\"clearfix\"></div>\r\n<section class=\"content\">\r\n  <div class=\"container-fluid\">\r\n    <p class=\"text-success\">{{ message }}</p>\r\n    <p class=\"text-danger col-md-12\">{{ warningMessage }}</p>\r\n    <div class=\"nopad\">\r\n      <form (ngSubmit)=\"onSubmit(UpdatePersonProfile.value)\" #UpdatePersonProfile=\"ngForm\">\r\n        <input type=\"hidden\" class=\"form-control\" [(ngModel)]=\"model.personMasterHashId\" name=\"personMasterHashId\">\r\n        <input type=\"hidden\" class=\"form-control\" [(ngModel)]=\"model.isActive\" name=\"isActive\">\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblUserName' | translate }}\r\n          </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblUserName' | translate }}\" [ngModel]=\"model.userName\" name=\"UserName\"\r\n            maxlength=\"100\" readonly>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'userName' }}</span>\r\n        </div>\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblEmail' | translate }}\r\n          </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblEmail' | translate }}\" [(ngModel)]=\"model.emailAddressModel.email\"\r\n            name=\"Email\" maxlength=\"100\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'emailAddressModel.email' }}</span>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblFirstName' | translate }}\r\n          </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblFirstName' | translate }}\" [(ngModel)]=\"model.firstName\" name=\"FirstName\"\r\n            maxlength=\"100\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'firstName' }}</span>\r\n        </div>\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\"></span>{{ 'LblMiddleName' | translate }}\r\n          </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblMiddleName' | translate }}\" [(ngModel)]=\"model.middleName\" name=\"MiddleName\"\r\n            maxlength=\"100\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'middleName' }}</span>\r\n        </div>\r\n\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblLastName' | translate }}\r\n          </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblLastName' | translate }}\" [(ngModel)]=\"model.lastName\" name=\"LastName\"\r\n            maxlength=\"100\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'lastName' }}</span>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        \r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>  {{ 'LblCountry' | translate }}\r\n          </label>\r\n          <div class=\"form-group inline\">\r\n            <select name=\"model.countryCodeHashId\" [(ngModel)]=\"model.countryCodeHashId\" class=\"form-control inline\">\r\n              <option *ngFor=\"let item of personCountryList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\r\n            </select>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'countryCode' }}</span>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblMobileNumber' | translate }}\r\n          </label>\r\n          <div class=\"input-group telephone-group\">\r\n            <span class=\"input-group-addon\">\r\n              <select [(ngModel)]=\"model.countryCode1\" class=\"form-control country-select\" name=\"countryCode1\">\r\n                <option value=\"\">-</option>\r\n                <option *ngFor=\"let item of countryList\" [ngValue]=\"item.value\">{{ item.value }}</option>\r\n              </select>\r\n            </span>\r\n            <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblMobileNumber' | translate }}\" [(ngModel)]=\"model.telephone1\"\r\n              name=\"telephone1\" maxlength=\"20\">\r\n          </div>\r\n          <div class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'countryCode1' }}</div>\r\n          <div class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'telephone1' }}</div>\r\n        </div>\r\n\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            {{ 'LblPhoneNumber' | translate }}\r\n          </label>\r\n          <div class=\"input-group telephone-group\">\r\n            <span class=\"input-group-addon\">\r\n              <select [(ngModel)]=\"model.countryCode2\" class=\"form-control country-select\" name=\"countryCode2\">\r\n                <option value=\"\">-</option>\r\n                <option *ngFor=\"let item of countryList\" [ngValue]=\"item.value\">{{ item.value }}</option>\r\n              </select>\r\n            </span>\r\n            <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblPhoneNumber' | translate }}\" [(ngModel)]=\"model.telephone2\" name=\"telephone2\"\r\n              maxlength=\"20\">\r\n          </div>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'countryCode2' }}</span>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'telephone2' }}</span>\r\n        </div>\r\n        <div class=\"form-group col-md-4\" *ngIf=\"model.isnifEnabled\">\r\n          <label>\r\n            {{ 'LblNIFNumber' | translate }}\r\n          </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblNIFNumber' | translate }}\" [(ngModel)]=\"model.nifNumber\" name=\"nifNumber\"\r\n            maxlength=\"9\">\r\n          <div class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'nIFNumber' }}</div>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div *ngIf=\"model.validateLiceanceNumber\" class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblDateOfBirth' | translate }}</label>\r\n          <div class=\"input-group\">\r\n            <span class=\"input-group-addon\">\r\n              <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n            </span>\r\n            <input [disabled]=\"isDateOfBirth\" class=\"form-control\" [Config]=\"flatPickrConfigDateOfBirth\" placeholder=\"{{ 'LblDateOfBirth' | translate }}\"\r\n              [(ngModel)]=\"model.dateOfBirth\" name=\"dateOfBirth\" flatpickr readonly>\r\n          </div>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'dateOfBirth' }}</span>\r\n        </div>\r\n        <div *ngIf=\"model.validateLiceanceNumber\" class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span> {{ 'LblDriverLicenceNumber' | translate }}\r\n          </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblDriverLicenceNumber' | translate }}\" [(ngModel)]=\"model.driverLicenceNumber\"\r\n            name=\"driverLicenceNumber\" maxlength=\"20\" [attr.readonly]=\"!model.liceanceNumberValidated?null:''\">\r\n\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'driverLicenceNumber' }}</span>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div *ngIf=\"model.subjectToDirectDebit && model.directDebitFileEnabledOnInstance\" class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>\r\n            {{ 'LblIBANNumber' | translate }}\r\n          </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblIBANNumber' | translate }}\" [(ngModel)]=\"model.ibanNumber\" name=\"ibanNumber\"\r\n            maxlength=\"100\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'ibanNumber' }}</span>\r\n        </div>\r\n        <div *ngIf=\"model.subjectToDirectDebit && model.directDebitFileEnabledOnInstance\" class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>\r\n            {{ 'LblBICCode' | translate }}\r\n          </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblBICCode' | translate }}\" [(ngModel)]=\"model.bicCode\" name=\"bicCode\"\r\n            maxlength=\"100\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'bicCode' }}</span>\r\n        </div>\r\n\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"row col-md-12\">\r\n          <fieldset class=\"col-md-12\">\r\n            <legend class=\"legendStyle\">\r\n              {{ 'LblHomeAddress' | translate }}\r\n            </legend>\r\n            <div class=\"clearfix\"></div>\r\n            <div class=\"form-group col-md-4\">\r\n              <label>{{ 'LblStreetName' | translate }}</label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblStreetName' | translate }}\" [(ngModel)]=\"model.personHomeAddressModel.street\"\r\n                name=\"personHomeAddressModel.street\" maxlength=\"100\">\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'personHomeAddressModel.street' }}</span>\r\n            </div>\r\n            <div class=\"form-group col-md-4\">\r\n              <label>{{ 'LblHouseNo' | translate }}</label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblHouseNo' | translate }}\" [(ngModel)]=\"model.personHomeAddressModel.houseNo\"\r\n                name=\"personHomeAddressModel.houseNo\" maxlength=\"15\">\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'personHomeAddressModel.houseNo' }}</span>\r\n            </div>\r\n            <div class=\"form-group col-md-4\">\r\n              <label>{{ 'LblHouseExtention' | translate }}</label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblHouseExtention' | translate }}\" [(ngModel)]=\"model.personHomeAddressModel.houseExtention\"\r\n                name=\"personHomeAddressModel.houseExtention\" maxlength=\"25\">\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'personHomeAddressModel.houseExtention' }}</span>\r\n            </div>\r\n            <div class=\"clearfix\"></div>\r\n            <div class=\"form-group col-md-4\">\r\n              <label>{{ 'LblZipCode' | translate }}</label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblZipCode' | translate }}\" [(ngModel)]=\"model.personHomeAddressModel.zipCode\"\r\n                name=\"personHomeAddressModel.zipCode\" maxlength=\"10\">\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'personHomeAddressModel.zipCode' }}</span>\r\n            </div>\r\n            <div class=\"form-group col-md-4\">\r\n              <label>{{ 'LblCity' | translate }}</label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblCity' | translate }}\" [(ngModel)]=\"model.personHomeAddressModel.city\"\r\n                name=\"personHomeAddressModel.city\" maxlength=\"50\">\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'personHomeAddressModel.city' }}</span>\r\n            </div>\r\n\r\n          </fieldset>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"row col-md-12\" *ngIf=\"model.CreditCardDetails?.length > 0 \">\r\n          <fieldset class=\"col-md-12\">\r\n            <legend class=\"legendStyle\">\r\n              {{ 'LblCreditCardDetails' | translate }}\r\n            </legend>\r\n            <div class=\"clearfix\"></div>\r\n            <div class=\"table table-responsive mar_bot_ziro\" style=\"width: 30%\">\r\n              <table class=\"table table-bordered mar_bot_ziro\">\r\n                <tr>\r\n                  <th>{{ 'LblCreditCardNumber' | translate }}</th>\r\n                  <th>&nbsp;</th>\r\n                </tr>\r\n                <tr *ngFor=\"let cardDetails of model.CreditCardDetails\">\r\n                  <td>{{ cardDetails.creditCardNumber }}</td>\r\n                  <td>\r\n                    <button class=\"btn btn-default delete-icon\" type=\"button\" (click)=\"ShowDeleteConfirmModal(cardDetails.creditCardHashId)\">\r\n                      <i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i>\r\n                    </button>\r\n                  </td>\r\n                </tr>\r\n              </table>\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n\r\n        <div class=\"row no-margin\">\r\n          <div class=\"col-sm-12\">\r\n            <hr>\r\n            <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnBackClick()\">{{ 'LblCancel' | translate }}</a> &nbsp;&nbsp;\r\n            <button class=\"btn btn-green\" type=\"submit\">{{ 'LblSave' | translate }}</button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</section>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<wego-userprofile-changepassword #changePasswordModal (OnSuccessUpdatePassword)=\"ChangePasswordModal($event)\"></wego-userprofile-changepassword>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n\r\n<wego-confirm-popup #deleteConfirmModal [popupMsg]=\"deleteMessage\" (onConfirm)=\"DeleteConfirmSuccessClick()\" (onReject)=\"HideDeleteConfirmModal()\"></wego-confirm-popup>";

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var driveradmin_service_1 = __webpack_require__(592);
	var router_1 = __webpack_require__(26);
	var booking_service_1 = __webpack_require__(556);
	var search_booking_model_1 = __webpack_require__(574);
	var driver_model_1 = __webpack_require__(601);
	var driver_service_1 = __webpack_require__(570);
	var driver_dashboard_service_1 = __webpack_require__(602);
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var config_1 = __webpack_require__(60);
	var core_1 = __webpack_require__(3);
	var DriverDashboardComponent = (function () {
	    function DriverDashboardComponent(driverDashboardService, driverService, driverAdminService, translate, authService, router, bookingService) {
	        this.driverDashboardService = driverDashboardService;
	        this.driverService = driverService;
	        this.driverAdminService = driverAdminService;
	        this.translate = translate;
	        this.authService = authService;
	        this.router = router;
	        this.bookingService = bookingService;
	        this.isBanned = false;
	        this.isDriverHashID = false;
	        this.isAllowInitialPaymentValue = false;
	        this.timezoneStartDateTime = '';
	    }
	    DriverDashboardComponent.prototype.ngOnInit = function () {
	        this.activeSubscription = new driver_model_1.DriverSubscriptionModel();
	        this.searchBookingModel = new search_booking_model_1.SearchBookingModel();
	        this.urlDriverBookingInformation = this.authService.GetURL(config_1.ApplicationRouteURL.URL_BOOKING_INFORMATION_DRIVER);
	        this.CurrentDriverDetail();
	        this.GetUpcomingBooking();
	        //this.GetActiveSubscription();
	    };
	    DriverDashboardComponent.prototype.GetUpcomingBooking = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.itemsPerPage = 6;
	        this.driverDashboardService
	            .GetUpcomingBooking(this.DataListModel)
	            .subscribe(function (res) {
	            _this.bookingList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    DriverDashboardComponent.prototype.ConfirmSuccessPopup = function () {
	        location.reload();
	    };
	    // public GetActiveSubscription() {
	    //   this.isLoading = true;
	    //   this.driverService.GetDriversSubscriptionDetail()
	    //     .subscribe(
	    //     res => {
	    //       this.driverSubscriptionList = res.data;
	    //       this.driverSubscriptionList = this.driverSubscriptionList ? this.driverSubscriptionList.filter(x => x.isActive) : [];
	    //       if (this.driverSubscriptionList && this.driverSubscriptionList.length > 0)
	    //         this.activeSubscription = this.driverSubscriptionList[0];
	    //       this.isLoading = false;
	    //     },
	    //     error => {
	    //       this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
	    //       this.isLoading = false;
	    //     });
	    // }
	    DriverDashboardComponent.prototype.OnSearch = function ($event) {
	        this.searchBookingModel = $event.SearchModel;
	        this.vehicleOverviewList = $event.VehicleOverview;
	        this.authService.searchBookingModel = this.searchBookingModel;
	        this.authService.vehicleOverviewModel = this.vehicleOverviewList;
	        var url = this.authService.GetURL(config_1.ApplicationRouteURL.URL_BOOKING);
	        this.router.navigate([url]);
	    };
	    DriverDashboardComponent.prototype.CurrentDriverDetail = function () {
	        var _this = this;
	        this.driverAdminService.GetCurrentDriverDetail().subscribe(function (res) {
	            _this.isLoading = false;
	            if (res.data) {
	                _this.searchBookingModel.driverHashId = res.data.driverMasterHashId;
	                _this.isBanned = res.data.isBanned;
	                _this.isLicenceRequired = res.data.isLicenceRequired;
	                _this.searchBookingModel.isRecurringBookingAllow =
	                    res.data.isRecurringBookingAllow;
	                _this.timezoneStartDateTime = res.data.startDateTime;
	                _this.IsDriverHashID();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    DriverDashboardComponent.prototype.IsDriverHashID = function () {
	        this.isDriverHashID = this.searchBookingModel.driverHashId ? true : false;
	    };
	    DriverDashboardComponent.prototype.OnPayment = function (bookingHashId, recurringId) {
	        var _this = this;
	        this.isLoading = true;
	        this.bookingHashId = bookingHashId;
	        this.bookingService
	            .ConfirmRecurringPaymentBooking(bookingHashId, recurringId)
	            .subscribe(function (res) {
	            _this.isLoading = false;
	            if (res.data) {
	                if (res.data.askForInitialPayment) {
	                    _this.popupDescription = _this.translate.instant('LblPaymentDescription', [res.data.initialPaymentAmount]);
	                    if (res.data.isPaymentSuccess || res.data.isFirstTimePayment) {
	                        _this.initialPaymentPopupTitle = _this.translate.instant('LblFirstBooking');
	                    }
	                    else {
	                        _this.initialPaymentPopupTitle = _this.translate.instant('LblPaymentFailed');
	                    }
	                    _this.isAllowInitialPaymentValue = false;
	                    _this.creditCardPaymentModal.show();
	                }
	                else if (!res.data.askForInitialPayment &&
	                    res.data.isPaymentSuccess) {
	                    _this.isLoading = true;
	                    //call api
	                    _this.bookingService
	                        .UpdateBookingAfterSuccessfulPayment(_this.bookingHashId)
	                        .subscribe(function (res) {
	                        _this.isLoading = false;
	                        _this.popupMsg = res.data;
	                        _this.ShowSuccessPopup();
	                    });
	                }
	                else {
	                }
	            }
	            else {
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.popupMsg = res.error;
	                _this.isSuccess = false;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    DriverDashboardComponent.prototype.GetInitialPaymentValue = function (isAllowInitialPayment) {
	        this.isAllowInitialPaymentValue = isAllowInitialPayment;
	    };
	    DriverDashboardComponent.prototype.ConfirmInitialPayment = function () {
	        var _this = this;
	        this.isLoading = true;
	        if (this.isAllowInitialPaymentValue == false) {
	            this.isLoading = false;
	            var errorMessage = this.translate.instant('LblCheckAllowPayment');
	            this.errorMessage = errorMessage + ':' + Date.now().toString();
	        }
	        else {
	            this.searchBookingModel.bookingMasterHashId = this.bookingHashId;
	            this.searchBookingModel.isFromMobileSide = false;
	            this.bookingService
	                .StartInitialPayment(this.searchBookingModel)
	                .subscribe(function (res) {
	                if (res.data.redirectURL) {
	                    _this.isLoading = false;
	                    window.location.href = res.data.redirectURL;
	                }
	                else {
	                    _this.isLoading = false;
	                    _this.creditCardPaymentModal.hide();
	                    _this.popupMsg = res.error;
	                    _this.ShowSuccessPopup();
	                }
	            });
	        }
	    };
	    DriverDashboardComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    DriverDashboardComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    DriverDashboardComponent.prototype.GetImageURL = function (imagePath) {
	        return config_1.WeGoConfig.API_SERVER_URL + imagePath;
	    };
	    __decorate([
	        core_1.ViewChild('creditCardPaymentModal'), 
	        __metadata('design:type', Object)
	    ], DriverDashboardComponent.prototype, "creditCardPaymentModal", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], DriverDashboardComponent.prototype, "successPopup", void 0);
	    DriverDashboardComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-driver-dashboard',
	            template: __webpack_require__(603),
	            providers: [
	                driver_dashboard_service_1.DriverDashboardService,
	                driver_service_1.DriverService,
	                booking_service_1.BookingService,
	                driveradmin_service_1.DriverAdminService
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof driver_dashboard_service_1.DriverDashboardService !== 'undefined' && driver_dashboard_service_1.DriverDashboardService) === 'function' && _a) || Object, (typeof (_b = typeof driver_service_1.DriverService !== 'undefined' && driver_service_1.DriverService) === 'function' && _b) || Object, (typeof (_c = typeof driveradmin_service_1.DriverAdminService !== 'undefined' && driveradmin_service_1.DriverAdminService) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object, (typeof (_e = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _f) || Object, (typeof (_g = typeof booking_service_1.BookingService !== 'undefined' && booking_service_1.BookingService) === 'function' && _g) || Object])
	    ], DriverDashboardComponent);
	    return DriverDashboardComponent;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.DriverDashboardComponent = DriverDashboardComponent;


/***/ },
/* 601 */
/***/ function(module, exports) {

	"use strict";
	var DriverModel = (function () {
	    function DriverModel() {
	        this.isnifEnabled = false;
	        this.isDriverLicenseRemove = false;
	        this.instanceLanguage = 'en';
	    }
	    return DriverModel;
	}());
	exports.DriverModel = DriverModel;
	var DriverBlockModel = (function () {
	    function DriverBlockModel() {
	    }
	    return DriverBlockModel;
	}());
	exports.DriverBlockModel = DriverBlockModel;
	var DriverSubscriptionModel = (function () {
	    function DriverSubscriptionModel() {
	    }
	    return DriverSubscriptionModel;
	}());
	exports.DriverSubscriptionModel = DriverSubscriptionModel;
	var SVGdriverModel = (function () {
	    function SVGdriverModel() {
	    }
	    return SVGdriverModel;
	}());
	exports.SVGdriverModel = SVGdriverModel;
	var SharedVehicleGroupDriverModel = (function () {
	    function SharedVehicleGroupDriverModel() {
	    }
	    return SharedVehicleGroupDriverModel;
	}());
	exports.SharedVehicleGroupDriverModel = SharedVehicleGroupDriverModel;
	var SharedVehicleDriverSubscription = (function () {
	    function SharedVehicleDriverSubscription() {
	    }
	    return SharedVehicleDriverSubscription;
	}());
	exports.SharedVehicleDriverSubscription = SharedVehicleDriverSubscription;
	var SharedVehicleGroupDriverViewModel = (function () {
	    function SharedVehicleGroupDriverViewModel() {
	    }
	    return SharedVehicleGroupDriverViewModel;
	}());
	exports.SharedVehicleGroupDriverViewModel = SharedVehicleGroupDriverViewModel;


/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var DriverDashboardService = (function () {
	    function DriverDashboardService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    DriverDashboardService.prototype.GetUpcomingBooking = function (input) {
	        var getUpcomingBookingUrl = config_1.WeGoConfig.API_GET_UPCOMING_BOOKING_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getUpcomingBookingUrl = getUpcomingBookingUrl + "?" + queryString;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getUpcomingBookingUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    DriverDashboardService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], DriverDashboardService);
	    return DriverDashboardService;
	    var _a, _b;
	}());
	exports.DriverDashboardService = DriverDashboardService;


/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<section class=\"banner-img\">\r\n  <div class=\"banner\">\r\n    <div class=\"container\">\r\n      <div class=\"search-bg\" *ngIf=\"!isBanned && !isLicenceRequired\">\r\n        <div class=\"banner-info\">\r\n          <div class=\"row\">\r\n            <wego-search-booking-driver [IsDashboard]=\"true\" [SearchBookingModel]=\"searchBookingModel\" [IsDriverHashID]=\"isDriverHashID\" [TimezoneStartDateTime]=\"timezoneStartDateTime\"\r\n              (OnSearch)=\"OnSearch($event) \"></wego-search-booking-driver>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n<div class=\"clearfix\"></div>\r\n<section>\r\n  <div class=\"container-fluid\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\" style=\"margin-top: 20px;\">\r\n        <template [ngIf]=\"DataListModel.totalItems == 0 && !isLoading\">\r\n          <div class=\"alert alert-danger\">\r\n            <p class=\"text-center\">\r\n              {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n            </p>\r\n          </div>\r\n        </template>\r\n        <div class=\"row\">\r\n          <div class=\"col-md-5\" *ngFor=\"let bookings of bookingList\">\r\n            <div class=\"hp-listing\" style=\"word-break: break-word;\">\r\n              <div class=\"list\">\r\n                <div class=\"media no-border\">\r\n                  <div class=\"media-left\">\r\n                    <img *ngIf=\"bookings.vehicleImagePath\" class=\"media-object\" [src]=\"GetImageURL(bookings.vehicleImagePath)\" alt=\"No\" style=\"max-width: 100px; max-height: 100px;\">\r\n                    <img *ngIf=\"!bookings.vehicleImagePath\" class=\"media-object\" src=\"" + __webpack_require__(564) + "\" alt=\"No\"\r\n                      style=\"max-width: 100px; max-height: 100px;\">\r\n                  </div>\r\n                  <div class=\"media-body\">\r\n                    <div class=\"col-sm-12\">\r\n                      <div class=\"row\">\r\n                        <div class=\"col-sm-4\">\r\n                          <strong>{{ 'LblBookingReferenceId' | translate }} :</strong>\r\n                        </div>\r\n                        <div class=\"col-sm-6\">{{ bookings.bookingReferenceID }}</div>\r\n                        <div class=\"col-sm-2\">\r\n                          <a class=\"btn btn-xs btn-default cursor-pointer\" *ngIf=\"authService.IsDriver()\" [routerLink]=\"[urlDriverBookingInformation,{ bookingHashId : bookings.bookingHashId }]\">\r\n                            <i class=\"fa fa-eye fa-fw text-success\"></i>\r\n                          </a>\r\n                        </div>\r\n                      </div>\r\n                      <div class=\"row\">\r\n                        <div class=\"col-sm-4\">\r\n                          <strong>{{ 'LblVehicle' | translate }} :</strong>\r\n                        </div>\r\n                        <div class=\"col-sm-8\">{{ bookings.licenceTag }}</div>\r\n                      </div>\r\n                      <div class=\"row\">\r\n                        <div class=\"col-sm-4\">\r\n                          <strong>{{ 'LblStatus' | translate }} :</strong>\r\n                        </div>\r\n                        <div class=\"col-sm-5\">{{ bookings.translatedBookingStatus }}</div>\r\n                        <div class=\"col-md-2\">\r\n                          <button class=\"btn btn-success\" style=\"height: 19px; padding-top:0px; \" (click)=\"OnPayment(bookings.bookingHashId, bookings.reccuringID)\"\r\n                            *ngIf=\"bookings.bookingStatus == 'READYFORPAYMENT'\">\r\n                            {{ 'LblPay' | translate}}</button>\r\n                        </div>\r\n                      </div>\r\n                      <div class=\"row\">\r\n                        <div class=\"col-sm-4\">\r\n                          <strong>{{ 'LblFrom' | translate }} :</strong>\r\n                        </div>\r\n                        <div class=\"col-sm-8\">{{ bookings.startDateTime }}</div>\r\n                      </div>\r\n                      <div class=\"row\">\r\n                        <div class=\"col-sm-4\">\r\n                          <strong>{{ 'LblTo' | translate }} :</strong>\r\n                        </div>\r\n                        <div class=\"col-sm-8\">{{ bookings.endDateTime }}</div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n                <div class=\"clearfix\"></div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <!--<div class=\"col-md-3\">-->\r\n      <!-- Subscription ITEM -->\r\n      <!--<div class=\"panel price panel-red\">-->\r\n      <!--<div class=\"panel-body text-center mar-top\">\r\n            <img src=\"" + __webpack_require__(604) + "\" class=\"img-responsive center-block\"><strong>\r\n\t\t\t\t\t\t\t</strong>\r\n            <p style=\"font-size:25px;margin-top:5px;margin-bottom:0;\"><strong>{{ activeSubscription.subscriptionaName }}</strong></p>\r\n          </div>-->\r\n      <!--<ul class=\"list-group list-group-flush text-center\">-->\r\n      <!--<li class=\"list-group-item\"><strong>{{ 'LblSharedVehicleGroup' | translate }} :</strong> {{ activeSubscription.sharedVehiclegroup }}</li>\r\n            <li class=\"list-group-item\"><strong>{{ 'LblFreeKilometer' | translate }} :</strong> {{ activeSubscription.freeKilometer }} / <strong>{{ 'LblFreeMinute' | translate }} :</strong>{{ activeSubscription.freeMinute }}</li>\r\n            <li class=\"list-group-item\">\r\n              <strong>{{ 'LblSubscriptionStartDate' | translate }}:</strong> {{ activeSubscription.startDatetime }}\r\n              <div class=\"clearfix\"></div>\r\n              <strong *ngIf=\"activeSubscription.endDatetime\"> {{ 'LblsubscribeEndDate' | translate }}:</strong> {{ activeSubscription.endDatetime }}\r\n            </li>-->\r\n      <!--<li class=\"list-group-item\"><strong>{{ 'LblSharedVehicleGroup' | translate }} :</strong> {{ activeSubscription.sharedVehiclegroup }}</li>\r\n            <li class=\"list-group-item\">\r\n              <div><strong>{{ 'LblFreeKilometer' | translate }} </strong>/ {{ activeSubscription.freeKilometerInterval}}</div>\r\n              <div class=\"clearfix\"></div>\r\n              <div><strong>{{ 'LblTotalFreeKilometer' | translate }} : </strong> {{ activeSubscription.freeKilometer | decimalFormatter }}</div>\r\n              <div class=\"clearfix\"></div>\r\n              <div *ngIf=\"activeSubscription.prevFreeKMIntervalStartDate\"><strong>{{ 'LblPrevious' | translate }} ( {{ activeSubscription.prevFreeKMIntervalStartDate }} {{ 'LblTo' | translate }} {{ activeSubscription.prevFreeKMIntervalEndDate }} ) :</strong> {{ activeSubscription.prevRemainingFreeKilometer | decimalFormatter }}</div>\r\n              <div class=\"clearfix\"></div>\r\n              <div><strong>{{ 'LblCurrent' | translate }} ( {{ activeSubscription.curFreeKMIntervalStartDate }} {{ 'LblTo' | translate }} {{ activeSubscription.curFreeKMIntervalEndDate }} ) :</strong> {{ activeSubscription.curRemainingFreeKilometer | decimalFormatter }}</div>\r\n            </li>\r\n            <li class=\"list-group-item\">\r\n\r\n              <div><strong><strong>{{ 'LblFreeMinute' | translate }}</strong> </strong>/ {{ activeSubscription.freeMinuteInterval}}</div>\r\n              <div class=\"clearfix\"></div>\r\n              <div><strong>{{ 'LblTotalFreeMinute' | translate }} : </strong> {{ activeSubscription.freeMinute | decimalFormatter}}</div>\r\n              <div class=\"clearfix\"></div>\r\n              <div *ngIf=\"activeSubscription.prevFreeMinIntervalStartDate\"><strong>{{ 'LblPrevious' | translate }} ( {{ activeSubscription.prevFreeMinIntervalStartDate }} {{ 'LblTo' | translate }} {{ activeSubscription.prevFreeMinIntervalEndDate }} ) :</strong> {{ activeSubscription.prevRemainingFreeMinute | decimalFormatter }}</div>\r\n              <div class=\"clearfix\"></div>\r\n              <div><strong>{{ 'LblCurrent' | translate }} ( {{ activeSubscription.curFreeMinIntervalStartDate }} {{ 'LblTo' | translate }} {{ activeSubscription.curFreeMinIntervalEndDate }} ) :</strong> {{ activeSubscription.curRemainingFreeMinute | decimalFormatter }}</div>\r\n            </li>\r\n            <li class=\"list-group-item\">\r\n              <strong>{{ 'LblSubscriptionStartDate' | translate }}:</strong> {{ activeSubscription.startDatetime }}\r\n              <div class=\"clearfix\"></div>\r\n              <strong *ngIf=\"activeSubscription.endDatetime\"> {{ 'LblsubscribeEndDate' | translate }}:</strong> {{ activeSubscription.endDatetime }}\r\n            </li>\r\n          </ul>-->\r\n      <!--<div *ngIf=\"activeSubscription.isAmountVisible\" class=\"panel-footer\">\r\n            <p style=\"font-size:25px;margin-top:5px;margin-bottom:0; text-align: center;\">{{ activeSubscription.amount | decimalFormatter }}\r\n              <template [ngIf]=\"activeSubscription.subscriptionaName != 'NO_SUBSCRIPTION'\">\r\n                  / {{ activeSubscription.timeInterval }}\r\n                </template>\r\n            </p>\r\n          </div>-->\r\n      <!--</div>-->\r\n      <!-- /Subscription ITEM -->\r\n      <!--</div>-->\r\n    </div>\r\n    <!-- Row main -->\r\n  </div>\r\n  <!-- /.container -->\r\n</section>\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n\r\n<wego-credit-card-payment-popup #creditCardPaymentModal [initialPaymentPopupTitle]=\"initialPaymentPopupTitle\" [popupDescription]=\"popupDescription\"\r\n  [errorMessage]=\"errorMessage\" (isAllowInitialPayment)=\"GetInitialPaymentValue($event)\" (onProceed)=\"ConfirmInitialPayment()\"></wego-credit-card-payment-popup>";

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/sp-offer-1.0b68b61c4f3184401576d7fcee9a2354.jpg";

/***/ },
/* 605 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	var common_1 = __webpack_require__(22);
	var Popover_1 = __webpack_require__(606);
	var PopoverContent_1 = __webpack_require__(607);
	var core_1 = __webpack_require__(3);
	__export(__webpack_require__(606));
	__export(__webpack_require__(607));
	var PopoverModule = (function () {
	    function PopoverModule() {
	    }
	    PopoverModule.decorators = [
	        { type: core_1.NgModule, args: [{
	                    imports: [
	                        common_1.CommonModule
	                    ],
	                    declarations: [
	                        PopoverContent_1.PopoverContent,
	                        Popover_1.Popover,
	                    ],
	                    exports: [
	                        PopoverContent_1.PopoverContent,
	                        Popover_1.Popover,
	                    ],
	                    entryComponents: [
	                        PopoverContent_1.PopoverContent
	                    ]
	                },] },
	    ];
	    /** @nocollapse */
	    PopoverModule.ctorParameters = function () { return []; };
	    return PopoverModule;
	}());
	exports.PopoverModule = PopoverModule;
	//# sourceMappingURL=index.js.map

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var PopoverContent_1 = __webpack_require__(607);
	var Popover = (function () {
	    // -------------------------------------------------------------------------
	    // Constructor
	    // -------------------------------------------------------------------------
	    function Popover(viewContainerRef, resolver) {
	        this.viewContainerRef = viewContainerRef;
	        this.resolver = resolver;
	        // -------------------------------------------------------------------------
	        // Properties
	        // -------------------------------------------------------------------------
	        this.PopoverComponent = PopoverContent_1.PopoverContent;
	        this.popoverOnHover = false;
	        this.popoverDismissTimeout = 0;
	        this.onShown = new core_1.EventEmitter();
	        this.onHidden = new core_1.EventEmitter();
	    }
	    // -------------------------------------------------------------------------
	    // Event listeners
	    // -------------------------------------------------------------------------
	    Popover.prototype.showOrHideOnClick = function () {
	        if (this.popoverOnHover)
	            return;
	        if (this.popoverDisabled)
	            return;
	        this.toggle();
	    };
	    Popover.prototype.showOnHover = function () {
	        if (!this.popoverOnHover)
	            return;
	        if (this.popoverDisabled)
	            return;
	        this.show();
	    };
	    Popover.prototype.hideOnHover = function () {
	        if (this.popoverCloseOnMouseOutside)
	            return; // don't do anything since not we control this
	        if (!this.popoverOnHover)
	            return;
	        if (this.popoverDisabled)
	            return;
	        this.hide();
	    };
	    Popover.prototype.ngOnChanges = function (changes) {
	        if (changes["popoverDisabled"]) {
	            if (changes["popoverDisabled"].currentValue) {
	                this.hide();
	            }
	        }
	    };
	    // -------------------------------------------------------------------------
	    // Public Methods
	    // -------------------------------------------------------------------------
	    Popover.prototype.toggle = function () {
	        if (!this.visible) {
	            this.show();
	        }
	        else {
	            this.hide();
	        }
	    };
	    Popover.prototype.show = function () {
	        var _this = this;
	        if (this.visible)
	            return;
	        this.visible = true;
	        if (typeof this.content === "string") {
	            var factory = this.resolver.resolveComponentFactory(this.PopoverComponent);
	            if (!this.visible)
	                return;
	            this.popover = this.viewContainerRef.createComponent(factory);
	            var popover = this.popover.instance;
	            popover.popover = this;
	            popover.content = this.content;
	            if (this.popoverPlacement !== undefined)
	                popover.placement = this.popoverPlacement;
	            if (this.popoverAnimation !== undefined)
	                popover.animation = this.popoverAnimation;
	            if (this.popoverTitle !== undefined)
	                popover.title = this.popoverTitle;
	            if (this.popoverCloseOnClickOutside !== undefined)
	                popover.closeOnClickOutside = this.popoverCloseOnClickOutside;
	            if (this.popoverCloseOnMouseOutside !== undefined)
	                popover.closeOnMouseOutside = this.popoverCloseOnMouseOutside;
	            popover.onCloseFromOutside.subscribe(function () { return _this.hide(); });
	            // if dismissTimeout option is set, then this popover will be dismissed in dismissTimeout time
	            if (this.popoverDismissTimeout > 0)
	                setTimeout(function () { return _this.hide(); }, this.popoverDismissTimeout);
	        }
	        else {
	            var popover = this.content;
	            popover.popover = this;
	            if (this.popoverPlacement !== undefined)
	                popover.placement = this.popoverPlacement;
	            if (this.popoverAnimation !== undefined)
	                popover.animation = this.popoverAnimation;
	            if (this.popoverTitle !== undefined)
	                popover.title = this.popoverTitle;
	            if (this.popoverCloseOnClickOutside !== undefined)
	                popover.closeOnClickOutside = this.popoverCloseOnClickOutside;
	            if (this.popoverCloseOnMouseOutside !== undefined)
	                popover.closeOnMouseOutside = this.popoverCloseOnMouseOutside;
	            popover.onCloseFromOutside.subscribe(function () { return _this.hide(); });
	            // if dismissTimeout option is set, then this popover will be dismissed in dismissTimeout time
	            if (this.popoverDismissTimeout > 0)
	                setTimeout(function () { return _this.hide(); }, this.popoverDismissTimeout);
	            popover.show();
	        }
	        this.onShown.emit(this);
	    };
	    Popover.prototype.hide = function () {
	        if (!this.visible)
	            return;
	        this.visible = false;
	        if (this.popover)
	            this.popover.destroy();
	        if (this.content instanceof PopoverContent_1.PopoverContent)
	            this.content.hideFromPopover();
	        this.onHidden.emit(this);
	    };
	    Popover.prototype.getElement = function () {
	        return this.viewContainerRef.element.nativeElement;
	    };
	    Popover.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: "[popover]",
	                    exportAs: "popover"
	                },] },
	    ];
	    /** @nocollapse */
	    Popover.ctorParameters = function () { return [
	        { type: core_1.ViewContainerRef, },
	        { type: core_1.ComponentFactoryResolver, },
	    ]; };
	    Popover.propDecorators = {
	        'content': [{ type: core_1.Input, args: ["popover",] },],
	        'popoverDisabled': [{ type: core_1.Input },],
	        'popoverAnimation': [{ type: core_1.Input },],
	        'popoverPlacement': [{ type: core_1.Input },],
	        'popoverTitle': [{ type: core_1.Input },],
	        'popoverOnHover': [{ type: core_1.Input },],
	        'popoverCloseOnClickOutside': [{ type: core_1.Input },],
	        'popoverCloseOnMouseOutside': [{ type: core_1.Input },],
	        'popoverDismissTimeout': [{ type: core_1.Input },],
	        'onShown': [{ type: core_1.Output },],
	        'onHidden': [{ type: core_1.Output },],
	        'showOrHideOnClick': [{ type: core_1.HostListener, args: ["click",] },],
	        'showOnHover': [{ type: core_1.HostListener, args: ["focusin",] }, { type: core_1.HostListener, args: ["mouseenter",] },],
	        'hideOnHover': [{ type: core_1.HostListener, args: ["focusout",] }, { type: core_1.HostListener, args: ["mouseleave",] },],
	    };
	    return Popover;
	}());
	exports.Popover = Popover;
	//# sourceMappingURL=Popover.js.map

/***/ },
/* 607 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var PopoverContent = (function () {
	    // -------------------------------------------------------------------------
	    // Constructor
	    // -------------------------------------------------------------------------
	    function PopoverContent(element, cdr) {
	        var _this = this;
	        this.element = element;
	        this.cdr = cdr;
	        this.placement = "bottom";
	        this.animation = true;
	        this.closeOnClickOutside = false;
	        this.closeOnMouseOutside = false;
	        this.onCloseFromOutside = new core_1.EventEmitter();
	        this.top = -10000;
	        this.left = -10000;
	        this.isIn = false;
	        this.displayType = "none";
	        // -------------------------------------------------------------------------
	        // Anonymous 
	        // -------------------------------------------------------------------------
	        /**
	         * Closes dropdown if user clicks outside of this directive.
	         */
	        this.onDocumentMouseDown = function (event) {
	            var element = _this.element.nativeElement;
	            if (!element || !_this.popover)
	                return;
	            if (element.contains(event.target) || _this.popover.getElement().contains(event.target))
	                return;
	            _this.hide();
	            _this.onCloseFromOutside.emit(undefined);
	        };
	    }
	    // -------------------------------------------------------------------------
	    // Lifecycle callbacks
	    // -------------------------------------------------------------------------
	    PopoverContent.prototype.ngAfterViewInit = function () {
	        if (this.closeOnClickOutside)
	            document.addEventListener("mousedown", this.onDocumentMouseDown);
	        if (this.closeOnMouseOutside)
	            document.addEventListener("mouseover", this.onDocumentMouseDown);
	        this.show();
	        this.cdr.detectChanges();
	    };
	    PopoverContent.prototype.ngOnDestroy = function () {
	        if (this.closeOnClickOutside)
	            document.removeEventListener("mousedown", this.onDocumentMouseDown);
	        if (this.closeOnMouseOutside)
	            document.removeEventListener("mouseover", this.onDocumentMouseDown);
	    };
	    // -------------------------------------------------------------------------
	    // Public Methods
	    // -------------------------------------------------------------------------
	    PopoverContent.prototype.show = function () {
	        if (!this.popover || !this.popover.getElement())
	            return;
	        var p = this.positionElements(this.popover.getElement(), this.popoverDiv.nativeElement, this.placement);
	        this.displayType = "block";
	        this.top = p.top;
	        this.left = p.left;
	        this.isIn = true;
	    };
	    PopoverContent.prototype.hide = function () {
	        this.top = -10000;
	        this.left = -10000;
	        this.isIn = true;
	        this.popover.hide();
	    };
	    PopoverContent.prototype.hideFromPopover = function () {
	        this.top = -10000;
	        this.left = -10000;
	        this.isIn = true;
	    };
	    // -------------------------------------------------------------------------
	    // Protected Methods
	    // -------------------------------------------------------------------------
	    PopoverContent.prototype.positionElements = function (hostEl, targetEl, positionStr, appendToBody) {
	        if (appendToBody === void 0) { appendToBody = false; }
	        var positionStrParts = positionStr.split("-");
	        var pos0 = positionStrParts[0];
	        var pos1 = positionStrParts[1] || "center";
	        var hostElPos = appendToBody ? this.offset(hostEl) : this.position(hostEl);
	        var targetElWidth = targetEl.offsetWidth;
	        var targetElHeight = targetEl.offsetHeight;
	        this.effectivePlacement = pos0 = this.getEffectivePlacement(pos0, hostEl, targetEl);
	        var shiftWidth = {
	            center: function () {
	                return hostElPos.left + hostElPos.width / 2 - targetElWidth / 2;
	            },
	            left: function () {
	                return hostElPos.left;
	            },
	            right: function () {
	                return hostElPos.left + hostElPos.width;
	            }
	        };
	        var shiftHeight = {
	            center: function () {
	                return hostElPos.top + hostElPos.height / 2 - targetElHeight / 2;
	            },
	            top: function () {
	                return hostElPos.top;
	            },
	            bottom: function () {
	                return hostElPos.top + hostElPos.height;
	            }
	        };
	        var targetElPos;
	        switch (pos0) {
	            case "right":
	                targetElPos = {
	                    top: shiftHeight[pos1](),
	                    left: shiftWidth[pos0]()
	                };
	                break;
	            case "left":
	                targetElPos = {
	                    top: shiftHeight[pos1](),
	                    left: hostElPos.left - targetElWidth
	                };
	                break;
	            case "bottom":
	                targetElPos = {
	                    top: shiftHeight[pos0](),
	                    left: shiftWidth[pos1]()
	                };
	                break;
	            default:
	                targetElPos = {
	                    top: hostElPos.top - targetElHeight,
	                    left: shiftWidth[pos1]()
	                };
	                break;
	        }
	        return targetElPos;
	    };
	    PopoverContent.prototype.position = function (nativeEl) {
	        var offsetParentBCR = { top: 0, left: 0 };
	        var elBCR = this.offset(nativeEl);
	        var offsetParentEl = this.parentOffsetEl(nativeEl);
	        if (offsetParentEl !== window.document) {
	            offsetParentBCR = this.offset(offsetParentEl);
	            offsetParentBCR.top += offsetParentEl.clientTop - offsetParentEl.scrollTop;
	            offsetParentBCR.left += offsetParentEl.clientLeft - offsetParentEl.scrollLeft;
	        }
	        var boundingClientRect = nativeEl.getBoundingClientRect();
	        return {
	            width: boundingClientRect.width || nativeEl.offsetWidth,
	            height: boundingClientRect.height || nativeEl.offsetHeight,
	            top: elBCR.top - offsetParentBCR.top,
	            left: elBCR.left - offsetParentBCR.left
	        };
	    };
	    PopoverContent.prototype.offset = function (nativeEl) {
	        var boundingClientRect = nativeEl.getBoundingClientRect();
	        return {
	            width: boundingClientRect.width || nativeEl.offsetWidth,
	            height: boundingClientRect.height || nativeEl.offsetHeight,
	            top: boundingClientRect.top + (window.pageYOffset || window.document.documentElement.scrollTop),
	            left: boundingClientRect.left + (window.pageXOffset || window.document.documentElement.scrollLeft)
	        };
	    };
	    PopoverContent.prototype.getStyle = function (nativeEl, cssProp) {
	        if (nativeEl.currentStyle)
	            return nativeEl.currentStyle[cssProp];
	        if (window.getComputedStyle)
	            return window.getComputedStyle(nativeEl)[cssProp];
	        // finally try and get inline style
	        return nativeEl.style[cssProp];
	    };
	    PopoverContent.prototype.isStaticPositioned = function (nativeEl) {
	        return (this.getStyle(nativeEl, "position") || "static") === "static";
	    };
	    PopoverContent.prototype.parentOffsetEl = function (nativeEl) {
	        var offsetParent = nativeEl.offsetParent || window.document;
	        while (offsetParent && offsetParent !== window.document && this.isStaticPositioned(offsetParent)) {
	            offsetParent = offsetParent.offsetParent;
	        }
	        return offsetParent || window.document;
	    };
	    PopoverContent.prototype.getEffectivePlacement = function (placement, hostElement, targetElement) {
	        var placementParts = placement.split(" ");
	        if (placementParts[0] !== "auto") {
	            return placement;
	        }
	        var hostElBoundingRect = hostElement.getBoundingClientRect();
	        var desiredPlacement = placementParts[1] || "bottom";
	        if (desiredPlacement === "top" && hostElBoundingRect.top - targetElement.offsetHeight < 0) {
	            return "bottom";
	        }
	        if (desiredPlacement === "bottom" && hostElBoundingRect.bottom + targetElement.offsetHeight > window.innerHeight) {
	            return "top";
	        }
	        if (desiredPlacement === "left" && hostElBoundingRect.left - targetElement.offsetWidth < 0) {
	            return "right";
	        }
	        if (desiredPlacement === "right" && hostElBoundingRect.right + targetElement.offsetWidth > window.innerWidth) {
	            return "left";
	        }
	        return desiredPlacement;
	    };
	    PopoverContent.decorators = [
	        { type: core_1.Component, args: [{
	                    selector: "popover-content",
	                    template: "\n<div #popoverDiv class=\"popover {{ effectivePlacement }}\"\n     [style.top]=\"top + 'px'\"\n     [style.left]=\"left + 'px'\"\n     [class.in]=\"isIn\"\n     [class.fade]=\"animation\"\n     style=\"display: block\"\n     role=\"popover\">\n    <div [hidden]=\"!closeOnMouseOutside\" class=\"virtual-area\"></div>\n    <div class=\"arrow\"></div> \n    <h3 class=\"popover-title\" [hidden]=\"!title\">{{ title }}</h3>\n    <div class=\"popover-content\">\n        <ng-content></ng-content>\n        {{ content }}\n    </div> \n</div>\n",
	                    styles: ["\n.popover .virtual-area {\n    height: 11px;\n    width: 100%;\n    position: absolute;\n}\n.popover.top .virtual-area {\n    bottom: -11px; \n}\n.popover.bottom .virtual-area {\n    top: -11px; \n}\n.popover.left .virtual-area {\n    right: -11px; \n}\n.popover.right .virtual-area {\n    left: -11px; \n}\n"]
	                },] },
	    ];
	    /** @nocollapse */
	    PopoverContent.ctorParameters = function () { return [
	        { type: core_1.ElementRef, },
	        { type: core_1.ChangeDetectorRef, },
	    ]; };
	    PopoverContent.propDecorators = {
	        'content': [{ type: core_1.Input },],
	        'placement': [{ type: core_1.Input },],
	        'title': [{ type: core_1.Input },],
	        'animation': [{ type: core_1.Input },],
	        'closeOnClickOutside': [{ type: core_1.Input },],
	        'closeOnMouseOutside': [{ type: core_1.Input },],
	        'popoverDiv': [{ type: core_1.ViewChild, args: ["popoverDiv",] },],
	    };
	    return PopoverContent;
	}());
	exports.PopoverContent = PopoverContent;
	//# sourceMappingURL=PopoverContent.js.map

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var router_1 = __webpack_require__(26);
	var inbox_service_1 = __webpack_require__(609);
	var core_1 = __webpack_require__(3);
	var InboxDriverListComponent = (function () {
	    function InboxDriverListComponent(authService, router, activeRoute, translate, inboxService) {
	        this.authService = authService;
	        this.router = router;
	        this.activeRoute = activeRoute;
	        this.translate = translate;
	        this.inboxService = inboxService;
	    }
	    InboxDriverListComponent.prototype.ngOnInit = function () {
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = ["subject", "from"];
	        this.HandleRefresh();
	    };
	    InboxDriverListComponent.prototype.HandleRefresh = function () {
	        var _this = this;
	        this.sub = this.activeRoute
	            .params
	            .subscribe(function (params) {
	            _this.GetNotificationInboxList();
	        });
	    };
	    InboxDriverListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetNotificationInboxList();
	    };
	    InboxDriverListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetNotificationInboxList();
	    };
	    InboxDriverListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetNotificationInboxList();
	    };
	    InboxDriverListComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetNotificationInboxList();
	    };
	    InboxDriverListComponent.prototype.ShowNotification = function (notificationInboxHashID) {
	        if (this.inboxList && this.inboxList.length > 0) {
	            this.inboxList.forEach(function (x) { return x.isSelected = false; });
	            var record = this.inboxList.find(function (x) { return x.notificationInboxHashID == notificationInboxHashID; });
	            record.isRead = true;
	            record.isSelected = true;
	        }
	        this.notificationInboxHashID = notificationInboxHashID;
	    };
	    InboxDriverListComponent.prototype.GetNotificationInboxList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.inboxService.GetNotificationInboxList(this.DataListModel)
	            .subscribe(function (res) {
	            _this.inboxList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    InboxDriverListComponent.prototype.HandleErrorStatusCode = function (error) {
	        if (error && error == "401") {
	            this.router.navigate(['/Unauthorized']);
	        }
	        else if (error && error == "403") {
	            this.router.navigate(['/Unauthenticated']);
	        }
	        else {
	            this.apiErrorMsg = error;
	        }
	    };
	    InboxDriverListComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    InboxDriverListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-driver-inbox-list',
	            template: __webpack_require__(610),
	            styles: ["\n          .box.box-default{\n            border: 1px solid #ddd;\n            border-top: 3px solid #2BA2AA;\n          }\n          .box-body{\n            padding: 0px 10px 10px;\n          }\n          .maintext { \n            display:block;\n          }\n          .subtext {\n            font-size: smaller; \n          }\n          .unread{\n            font-weight: bold;\n          }\n          .fa-sm{\n            font-size: 0.7em;\n            line-height: 0.7em;\n            vertical-align: 20%;\n          }\n          "
	            ],
	            providers: [inbox_service_1.InboxService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object, (typeof (_e = typeof inbox_service_1.InboxService !== 'undefined' && inbox_service_1.InboxService) === 'function' && _e) || Object])
	    ], InboxDriverListComponent);
	    return InboxDriverListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.InboxDriverListComponent = InboxDriverListComponent;


/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var InboxService = (function () {
	    function InboxService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    InboxService.prototype.GetNotificationInboxList = function (input) {
	        var getNotificationInboxListUrl = config_1.WeGoConfig.API_GET_NOTIFICATION_INBOX_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getNotificationInboxListUrl = getNotificationInboxListUrl + "?" + queryString;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getNotificationInboxListUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InboxService.prototype.ShowNotification = function (hashID) {
	        var getNotificationInboxListUrl = config_1.WeGoConfig.API_GET_SHOW_NOTIFICATION + "?notificationInboxHashID=" + hashID;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getNotificationInboxListUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InboxService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], InboxService);
	    return InboxService;
	    var _a, _b;
	}());
	exports.InboxService = InboxService;


/***/ },
/* 610 */
/***/ function(module, exports) {

	module.exports = "<section class=\"banner-img-in\">\r\n  <div class=\"banner-in\">\r\n    <div class=\"search-bg-in\">\r\n      <div class=\"container-fluid\">\r\n        <div class=\"row\" style=\"padding-right:15px;\">\r\n          <div class=\"col-md-3\">\r\n            <h2 class=\"pagename\">{{ 'LblNotification' | translate }}</h2>\r\n          </div>\r\n          <div class=\"col-md-4 navbar-right\">\r\n            <div class=\"form-space-top pull-right\">\r\n              <wego-driver-search-list [IsExported]=\"false\" [SearchTerm]=\"DataListModel.searchTerm\" (OnSearch)=\"OnSearch($event)\" (OnPagingChange)=\"OnPagingChange($event)\"\r\n                [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-driver-search-list>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n<div class=\"clearfix\"></div>\r\n<section class=\"content\">\r\n  <div class=\"container-fluid\">\r\n    <div class=\"row\">\r\n      <div class=\"col-sm-4\">\r\n        <div class=\"box box-default\">\r\n          <div class=\"box-body\" style=\"display: block;\">\r\n            <div class=\"table table-responsive mar_bot_ziro\">\r\n              <table class=\"table table-hover table-striped\">\r\n                <thead>\r\n                  <tr>\r\n                    <th class=\"cursor-pointer\" (click)=\"OnSort('subject')\" style=\"width: 60%;\"> {{ 'LblSubject' | translate }}\r\n                      <wego-sort-list [FieldName]=\"'subject'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                    </th>\r\n                    <th class=\"cursor-pointer\" (click)=\"OnSort('notifyDateTime')\" style=\"width: 30%;\"> {{ 'LblDate' | translate }}\r\n                      <wego-sort-list [FieldName]=\"'notifyDateTime'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                    </th>\r\n                  </tr>\r\n                </thead>\r\n                <tbody>\r\n                  <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                    <tr class=\"cursor-pointer\" *ngFor=\"let item of inboxList\" [ngClass]=\"{'unread': !item.isRead, 'info': item.isSelected}\" (click)=\"ShowNotification(item.notificationInboxHashID)\">\r\n                      <td>\r\n                        <span class=\"maintext\">{{ item.subject }}</span>\r\n                        <span class=\"subtext\">{{ item.from }}</span>\r\n                      </td>\r\n                      <td>{{ item.notifyDateTime }}</td>\r\n                    </tr>\r\n                  </template>\r\n                  <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                    <td class=\"text-center text-danger\" colspan=\"7\">\r\n                      {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                    </td>\r\n                  </tr>\r\n                </tbody>\r\n              </table>\r\n            </div>\r\n            <div class=\"clearfix\"></div>\r\n            <div class=\"row\">\r\n              <div class=\"col-sm-12\">\r\n                <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                  [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                  lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n              </div>\r\n            </div>\r\n            <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-sm-8\">\r\n        <wego-inbox-view [NotificationInboxHashID]=\"notificationInboxHashID\"></wego-inbox-view>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>";

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var config_1 = __webpack_require__(60);
	var DriverSearchListComponent = (function () {
	    function DriverSearchListComponent() {
	        this.onSearch = new core_1.EventEmitter();
	        this.onExport = new core_1.EventEmitter();
	        this.onDeleteAll = new core_1.EventEmitter();
	        this.onCancelAll = new core_1.EventEmitter();
	        this.onAdd = new core_1.EventEmitter();
	        this.onPagingChange = new core_1.EventEmitter();
	        this.isExported = true;
	        this.isDeleted = false;
	        this.isDeleteEnabled = false;
	        this.isCancel = false;
	        this.isCancelEnabled = false;
	        this.isAdd = false;
	        this.isAddEnabled = false;
	        this.searchTerm = '';
	    }
	    DriverSearchListComponent.prototype.ngOnInit = function () {
	        this.itemPerPageList = config_1.WeGoConfig.GRID_PAGGING;
	        // let itemperPage = localStorage.getItem("itemsPerPage");
	        // if (itemperPage) {
	        //   this.itemPerPage = itemperPage
	        // }
	        // else {
	        //   this.itemPerPage = WeGoConfig.GRID_MAX_DATA_SIZE;
	        // }
	    };
	    DriverSearchListComponent.prototype.OnReset = function ($event) {
	        this.searchTerm = "";
	        this.onSearch.emit({ searchTerm: this.searchTerm, isReset: true });
	    };
	    DriverSearchListComponent.prototype.OnSearch = function () {
	        this.onSearch.emit({ searchTerm: this.searchTerm, isReset: false });
	    };
	    DriverSearchListComponent.prototype.OnExport = function ($event) {
	        this.onExport.emit($event);
	    };
	    DriverSearchListComponent.prototype.OnPagingChange = function ($event) {
	        this.onPagingChange.emit({ itemPerPage: $event });
	        // localStorage.setItem('itemsPerPage', $event);
	    };
	    DriverSearchListComponent.prototype.OnDeleteAll = function ($event) {
	        this.onDeleteAll.emit($event);
	    };
	    DriverSearchListComponent.prototype.OnCancelAll = function ($event) {
	        this.onCancelAll.emit($event);
	    };
	    DriverSearchListComponent.prototype.OnAdd = function ($event) {
	        this.onAdd.emit($event);
	    };
	    DriverSearchListComponent.prototype.ngOnDestroy = function () { };
	    __decorate([
	        core_1.Output('OnSearch'), 
	        __metadata('design:type', Object)
	    ], DriverSearchListComponent.prototype, "onSearch", void 0);
	    __decorate([
	        core_1.Output('OnExport'), 
	        __metadata('design:type', Object)
	    ], DriverSearchListComponent.prototype, "onExport", void 0);
	    __decorate([
	        core_1.Output('OnDeleteAll'), 
	        __metadata('design:type', Object)
	    ], DriverSearchListComponent.prototype, "onDeleteAll", void 0);
	    __decorate([
	        core_1.Output('OnCancelAll'), 
	        __metadata('design:type', Object)
	    ], DriverSearchListComponent.prototype, "onCancelAll", void 0);
	    __decorate([
	        core_1.Output('OnAdd'), 
	        __metadata('design:type', Object)
	    ], DriverSearchListComponent.prototype, "onAdd", void 0);
	    __decorate([
	        core_1.Output('OnPagingChange'), 
	        __metadata('design:type', Object)
	    ], DriverSearchListComponent.prototype, "onPagingChange", void 0);
	    __decorate([
	        core_1.Input('IsExported'), 
	        __metadata('design:type', Boolean)
	    ], DriverSearchListComponent.prototype, "isExported", void 0);
	    __decorate([
	        core_1.Input('IsDeleted'), 
	        __metadata('design:type', Boolean)
	    ], DriverSearchListComponent.prototype, "isDeleted", void 0);
	    __decorate([
	        core_1.Input('IsDeleteEnabled'), 
	        __metadata('design:type', Boolean)
	    ], DriverSearchListComponent.prototype, "isDeleteEnabled", void 0);
	    __decorate([
	        core_1.Input('IsCancel'), 
	        __metadata('design:type', Boolean)
	    ], DriverSearchListComponent.prototype, "isCancel", void 0);
	    __decorate([
	        core_1.Input('IsCancelEnabled'), 
	        __metadata('design:type', Boolean)
	    ], DriverSearchListComponent.prototype, "isCancelEnabled", void 0);
	    __decorate([
	        core_1.Input('IsAdd'), 
	        __metadata('design:type', Boolean)
	    ], DriverSearchListComponent.prototype, "isAdd", void 0);
	    __decorate([
	        core_1.Input('IsAddEnabled'), 
	        __metadata('design:type', Boolean)
	    ], DriverSearchListComponent.prototype, "isAddEnabled", void 0);
	    __decorate([
	        core_1.Input('SearchTerm'), 
	        __metadata('design:type', String)
	    ], DriverSearchListComponent.prototype, "searchTerm", void 0);
	    __decorate([
	        core_1.Input('ItemPerPage'), 
	        __metadata('design:type', Object)
	    ], DriverSearchListComponent.prototype, "itemPerPage", void 0);
	    DriverSearchListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-driver-search-list',
	            template: "\n  <form (ngSubmit)=\"OnSearch()\" class=\"form-inline mar_bot_10\">\n    <div class=\"form-group\">\n      <div class=\"input-group\">\n        <input type=\"text\" class=\"form-control\" [(ngModel)]=\"searchTerm\" name=\"searchTerm\" autocomplete=\"off\" maxlength=\"100\">\n          <div class=\"input-group-btn\">\n            <button class=\"btn btn-default\" type=\"submit\">\n              <i class=\"fa fa-search\" aria-hidden=\"true\"></i>\n            </button>\n          </div>\n        </div>\n      </div>\n    <div class=\"form-group\">\n      <button class=\"btn btn-success\" type=\"button\" (click)=\"OnReset($event)\">\n        <i class=\"fa fa-eraser\" aria-hidden=\"true\"></i>\n      </button>\n    </div>\n    <div *ngIf=\"isExported\" class=\"form-group\">\n      <button class=\"btn btn-success\" type=\"button\" (click)=\"OnExport($event)\" title=\"{{'LblExportAll(CSV)' | translate}}\">\n        <i class=\"fa fa-download\" aria-hidden=\"true\"></i>\n      </button>\n    </div>\n    <div *ngIf=\"isDeleted\" class=\"form-group\">\n      <button [disabled]=\"!isDeleteEnabled\" class=\"btn btn-success\" type=\"button\" (click)=\"OnDeleteAll($event)\" title=\"{{'LblDeleteAllSelectedRecords' | translate}}\">\n        <i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i>\n      </button>\n    </div>\n      <div *ngIf=\"isCancel\" class=\"form-group\">\n      <button [disabled]=\"!isCancelEnabled\" class=\"btn btn-success\" type=\"button\" (click)=\"OnCancelAll($event)\" title=\"{{'LblCancelAllSelectedRecords' | translate}}\">\n        <i class=\"fa fa-times\" aria-hidden=\"true\"></i>\n      </button>\n    </div>\n     <div *ngIf=\"isAdd\" class=\"form-group\">\n      <button [disabled]=\"!isAddEnabled\" class=\"btn btn-success\" type=\"button\" (click)=\"OnAdd($event)\" title=\"All Selected Record\">\n        <i class=\"fa fa-plus-square\" aria-hidden=\"true\"></i>\n      </button>\n    </div>\n    <div class=\"form-group\">\n      <select class=\"form-control\" title='Items Per Page'  [(ngModel)]=\"itemPerPage\"  name=\"itemPerPage\" (change)=\"OnPagingChange($event.target.value)\">\n         <option *ngFor=\"let item of itemPerPageList\"  [attr.value]='item.value' >{{ item }}</option>\n      </select>\n    </div>\n  </form>\n  ",
	            styles: [
	                "\n    .form-control{\n      border: none;\n      border-radius: 3px;\n    }\n    .btn-default{\n      height: 34px;\n      border-radius: 0;\n      border: 0;\n    }\n    .btn-success{\n      height: 34px;\n      border-radius: 0;\n    }\n    "
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], DriverSearchListComponent);
	    return DriverSearchListComponent;
	}());
	exports.DriverSearchListComponent = DriverSearchListComponent;


/***/ },
/* 612 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var auth_service_1 = __webpack_require__(58);
	var search_filter_model_1 = __webpack_require__(613);
	var instance_service_1 = __webpack_require__(500);
	var config_1 = __webpack_require__(60);
	var translate_service_1 = __webpack_require__(70);
	var company_service_1 = __webpack_require__(501);
	var organization_service_1 = __webpack_require__(614);
	var sharedvehiclegroup_service_1 = __webpack_require__(510);
	var terms_condition_model_1 = __webpack_require__(615);
	var SlimSelect = __webpack_require__(616);
	var SearchFilterComponent = (function () {
	    function SearchFilterComponent(authService, instanceService, translate, companyService, organizationService, sharedVehicleGroupService) {
	        this.authService = authService;
	        this.instanceService = instanceService;
	        this.translate = translate;
	        this.companyService = companyService;
	        this.organizationService = organizationService;
	        this.sharedVehicleGroupService = sharedVehicleGroupService;
	        this.model = new search_filter_model_1.SearchFilterModel();
	        this.roleLevel = config_1.RoleLevel;
	        this.isLoader = false;
	        this.OnDetailSearch = new core_1.EventEmitter();
	        this.OnAdvanceReset = new core_1.EventEmitter();
	    }
	    Object.defineProperty(SearchFilterComponent.prototype, "IsResetParameter", {
	        get: function () { return this._isReset; },
	        set: function (isResetFlag) {
	            this._isReset = isResetFlag;
	            if (this._isReset == true) {
	                this.ResetParameters();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SearchFilterComponent.prototype.ngOnInit = function () {
	        this.listOfTermsAndCondition = new terms_condition_model_1.TermsConditionModel();
	        this.pageName = "Terms_And_Condition";
	        this.LblSelect = this.translate.instant("LblSelect");
	        this.LblInstance = this.translate.instant("LblInstance");
	        this.LblCompany = this.translate.instant("LblCompany");
	        this.LblOrganization = this.translate.instant("LblOrganization");
	        this.LblSvg = this.translate.instant("LblSharedVehicleGroup");
	        this.tempmodel = this.authService.AssignFromStorage(this.constructor.name + "_model", this.tempmodel);
	        this.GetInstanceList();
	    };
	    SearchFilterComponent.prototype.GetInstanceList = function () {
	        var _this = this;
	        this.instanceService.GetDropdownInstanceList(this.pageName).subscribe(function (res) {
	            _this.instanceList = res.data;
	            if (_this.instanceList && _this.instanceList.length > 0) {
	                if (!_this.model.instanceHashId && _this.instanceList.length == 1) {
	                    _this.model.instanceHashId = _this.instanceList[0].keyHash;
	                    _this.model.InstanceHashIdList = [];
	                    _this.model.InstanceHashIdList.push(_this.instanceList[0].keyHash);
	                    _this.model.instanceHashId = _this.instanceList[0].keyHash;
	                }
	                _this.OnInstanceChange();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    SearchFilterComponent.prototype.OnInstanceChange = function () {
	        var _this = this;
	        this.isLoader = true;
	        setTimeout(function () {
	            if (_this.tempmodel && _this.tempmodel.InstanceHashIdList) {
	                _this.model.InstanceHashIdList = _this.tempmodel.InstanceHashIdList;
	                _this.instanceSelect.set(_this.tempmodel.InstanceHashIdList);
	                _this.tempmodel.InstanceHashIdList = null;
	                _this.setCompanyFilter();
	            }
	        }, 200);
	        if (this.model.InstanceHashIdList) {
	            this.OnDetailSearch.emit({
	                InstanceHashIdList: this.model.InstanceHashIdList,
	            });
	            this.GetCompanyList();
	            this.model.companyHashId = "";
	        }
	        else {
	            this.companyList = [];
	            this.model.companyHashId = "";
	        }
	    };
	    SearchFilterComponent.prototype.GetCompanyList = function () {
	        var _this = this;
	        if (!(this.authService.GetHighestRoleLevel() <= this.roleLevel.Instance)) {
	            this.model.InstanceHashIdList = this.instanceList.map(function (x) { return x.keyHash; });
	        }
	        this.companyService.GetDropdownCompanyListByInstanceIdList(this.pageName, config_1.PermissionType.VIEW, this.model.InstanceHashIdList).subscribe(function (res) {
	            _this.companyList = res.data;
	            if (_this.companyList && _this.companyList.length > 0) {
	                if (!_this.model.companyHashId && _this.companyList.length == 1) {
	                    _this.model.companyHashId = _this.companyList[0].keyHash;
	                    _this.model.CompanyHashIdList = [];
	                    _this.model.CompanyHashIdList.push(_this.companyList[0].keyHash);
	                    _this.model.companyHashId = _this.companyList[0].keyHash;
	                }
	                _this.OnCompanyChange();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    SearchFilterComponent.prototype.setCompanyFilter = function () {
	        var _this = this;
	        setTimeout(function () {
	            if (_this.tempmodel && _this.tempmodel.CompanyHashIdList) {
	                _this.model.CompanyHashIdList = _this.tempmodel.CompanyHashIdList;
	                _this.companySelect.set(_this.tempmodel.CompanyHashIdList);
	                _this.tempmodel.CompanyHashIdList = null;
	                _this.setOrganizationFilter();
	            }
	        }, 200);
	    };
	    SearchFilterComponent.prototype.setOrganizationFilter = function () {
	        var _this = this;
	        setTimeout(function () {
	            if (_this.tempmodel && _this.tempmodel.OrganizationHashIdList) {
	                _this.model.OrganizationHashIdList = _this.tempmodel.OrganizationHashIdList;
	                _this.organizationSelect.set(_this.tempmodel.OrganizationHashIdList);
	                _this.tempmodel.OrganizationHashIdList = null;
	                _this.setSVGFilter();
	            }
	        }, 200);
	    };
	    SearchFilterComponent.prototype.setSVGFilter = function () {
	        var _this = this;
	        setTimeout(function () {
	            if (_this.tempmodel && _this.tempmodel.SharedVehicleGroupHashIdList) {
	                _this.model.SharedVehicleGroupHashIdList = _this.tempmodel.SharedVehicleGroupHashIdList;
	                _this.svgSelect.set(_this.tempmodel.SharedVehicleGroupHashIdList);
	                _this.tempmodel.SharedVehicleGroupHashIdList = null;
	            }
	        }, 200);
	    };
	    SearchFilterComponent.prototype.OnCompanyChange = function () {
	        this.isLoader = true;
	        if (this.model.CompanyHashIdList) {
	            this.OnDetailSearch.emit({
	                CompanyHashIdList: this.model.CompanyHashIdList,
	            });
	            this.GetOrganizationList();
	            this.model.organizationHashId = "";
	        }
	        else {
	            this.organizationList = [];
	            this.model.organizationHashId = "";
	        }
	    };
	    SearchFilterComponent.prototype.OnOrganizationChange = function () {
	        this.isLoader = true;
	        if (this.model.OrganizationHashIdList) {
	            this.OnDetailSearch.emit({
	                OrganizationHashIdList: this.model.OrganizationHashIdList,
	            });
	            this.GetSVGList();
	            this.model.sharedVehicleGroupHashId = "";
	        }
	        else {
	            this.svgList = [];
	            this.model.sharedVehicleGroupHashId = "";
	        }
	    };
	    SearchFilterComponent.prototype.GetOrganizationList = function () {
	        var _this = this;
	        if (!(this.authService.GetHighestRoleLevel() <= this.roleLevel.Company)) {
	            this.model.CompanyHashIdList = this.companyList.map(function (x) { return x.keyHash; });
	        }
	        this.organizationService.GetDropdownOrganizationListByCompanyIdList(this.pageName, config_1.PermissionType.VIEW, this.model.CompanyHashIdList).subscribe(function (res) {
	            _this.organizationList = res.data;
	            if (_this.organizationList && _this.organizationList.length > 0) {
	                if (!_this.model.organizationHashId && _this.organizationList.length == 1) {
	                    _this.model.organizationHashId = _this.organizationList[0].keyHash;
	                    _this.model.OrganizationHashIdList = [];
	                    _this.model.OrganizationHashIdList.push(_this.organizationList[0].keyHash);
	                    _this.model.organizationHashId = _this.organizationList[0].keyHash;
	                }
	                _this.OnOrganizationChange();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    SearchFilterComponent.prototype.onSVGChange = function () {
	        if (this.model.SharedVehicleGroupHashIdList) {
	            this.OnDetailSearch.emit({
	                SharedVehicleGroupHashIdList: this.model.SharedVehicleGroupHashIdList,
	            });
	        }
	    };
	    SearchFilterComponent.prototype.GetSVGList = function () {
	        var _this = this;
	        if (!(this.authService.GetHighestRoleLevel() <= this.roleLevel.Organization)) {
	            this.model.OrganizationHashIdList = this.organizationList.map(function (x) { return x.keyHash; });
	        }
	        this.sharedVehicleGroupService.GetDropdownSharedVehicleGroupListByCompanyIdList(this.pageName, config_1.PermissionType.VIEW, this.model.OrganizationHashIdList).subscribe(function (res) {
	            _this.svgList = res.data;
	            if (_this.svgList && _this.svgList.length > 0) {
	                if (!_this.model.sharedVehicleGroupHashId && _this.svgList.length == 1) {
	                    _this.model.sharedVehicleGroupHashId = _this.svgList[0].keyHash;
	                }
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    SearchFilterComponent.prototype.ngAfterViewInit = function () {
	        var _this = this;
	        this.instanceSelect = new SlimSelect({
	            select: "#instanceName",
	            placeholder: this.LblSelect + " " + this.LblInstance,
	            showSearch: false,
	            onChange: function (info) {
	                _this.model.InstanceHashIdList = info.map(function (x) { return x.value; });
	            }
	        });
	        this.instanceSelect.set(this.model.InstanceHashIdList);
	        this.RenderCompany();
	    };
	    SearchFilterComponent.prototype.RenderCompany = function () {
	        var _this = this;
	        this.companySelect = new SlimSelect({
	            select: "#companyName",
	            placeholder: this.LblSelect + " " + this.LblCompany,
	            showSearch: false,
	            onChange: function (info) {
	                _this.model.CompanyHashIdList = info.map(function (x) { return x.value; });
	            }
	        });
	        this.companySelect.set(this.model.CompanyHashIdList);
	        this.RenderOrganization();
	    };
	    SearchFilterComponent.prototype.RenderOrganization = function () {
	        var _this = this;
	        this.organizationSelect = new SlimSelect({
	            select: "#organizationName",
	            placeholder: this.LblSelect + " " + this.LblOrganization,
	            showSearch: false,
	            onChange: function (info) {
	                _this.model.OrganizationHashIdList = info.map(function (x) { return x.value; });
	            }
	        });
	        this.organizationSelect.set(this.model.OrganizationHashIdList);
	        this.RenderSVg();
	    };
	    SearchFilterComponent.prototype.RenderSVg = function () {
	        var _this = this;
	        this.svgSelect = new SlimSelect({
	            select: "#svgName",
	            placeholder: this.LblSelect + " " + this.LblSvg,
	            showSearch: false,
	            onChange: function (info) {
	                _this.model.SharedVehicleGroupHashIdList = info.map(function (x) { return x.value; });
	            }
	        });
	        this.svgSelect.set(this.model.SharedVehicleGroupHashIdList);
	    };
	    SearchFilterComponent.prototype.ResetParameters = function () {
	        this.model.instanceHashId = '';
	        this.model.InstanceHashIdList = [];
	        this.instanceSelect.set(this.model.InstanceHashIdList);
	        this.model.companyHashId = '';
	        this.model.CompanyHashIdList = [];
	        this.companySelect.set(this.model.CompanyHashIdList);
	        this.model.organizationHashId = '';
	        this.model.OrganizationHashIdList = [];
	        this.organizationSelect.set(this.model.OrganizationHashIdList);
	        this.model.sharedVehicleGroupHashId = '';
	        this.model.SharedVehicleGroupHashIdList = [];
	        this.svgSelect.set(this.model.SharedVehicleGroupHashIdList);
	    };
	    SearchFilterComponent.prototype.ngOnDestroy = function () {
	        this.authService.SaveToStorage(this.constructor.name + "_model", this.model);
	    };
	    __decorate([
	        core_1.Output("OnDetailSearch"), 
	        __metadata('design:type', Object)
	    ], SearchFilterComponent.prototype, "OnDetailSearch", void 0);
	    __decorate([
	        core_1.Output("OnAdvanceReset"), 
	        __metadata('design:type', Object)
	    ], SearchFilterComponent.prototype, "OnAdvanceReset", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean), 
	        __metadata('design:paramtypes', [Boolean])
	    ], SearchFilterComponent.prototype, "IsResetParameter", null);
	    SearchFilterComponent = __decorate([
	        core_1.Component({
	            selector: "wego-termsandcondition-search-filter",
	            template: __webpack_require__(617),
	            providers: [
	                instance_service_1.InstanceService,
	                company_service_1.CompanyService,
	                organization_service_1.OrganizationService,
	                sharedvehiclegroup_service_1.SharedVehicleGroupService
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof instance_service_1.InstanceService !== 'undefined' && instance_service_1.InstanceService) === 'function' && _b) || Object, (typeof (_c = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _c) || Object, (typeof (_d = typeof company_service_1.CompanyService !== 'undefined' && company_service_1.CompanyService) === 'function' && _d) || Object, (typeof (_e = typeof organization_service_1.OrganizationService !== 'undefined' && organization_service_1.OrganizationService) === 'function' && _e) || Object, (typeof (_f = typeof sharedvehiclegroup_service_1.SharedVehicleGroupService !== 'undefined' && sharedvehiclegroup_service_1.SharedVehicleGroupService) === 'function' && _f) || Object])
	    ], SearchFilterComponent);
	    return SearchFilterComponent;
	    var _a, _b, _c, _d, _e, _f;
	}());
	exports.SearchFilterComponent = SearchFilterComponent;


/***/ },
/* 613 */
/***/ function(module, exports) {

	"use strict";
	var SearchFilterModel = (function () {
	    function SearchFilterModel() {
	        this.instanceHashId = '';
	        this.companyHashId = '';
	        this.organizationHashId = '';
	        this.sharedVehicleGroupHashId = '';
	        this.searchInstanceList = [];
	        this.searchCompanyList = [];
	        this.searchOrganizationList = [];
	        this.searchSharedVehicleGroupList = [];
	        this.InstanceHashIdList = [''];
	        this.CompanyHashIdList = [''];
	        this.OrganizationHashIdList = [''];
	        this.SharedVehicleGroupHashIdList = [''];
	        this.keyHash = [''];
	    }
	    return SearchFilterModel;
	}());
	exports.SearchFilterModel = SearchFilterModel;


/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var OrganizationService = (function () {
	    function OrganizationService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    OrganizationService.prototype.GetOrganizationList = function (input) {
	        var getOrganizationUrl = config_1.WeGoConfig.API_GET_ORGANIZATION_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getOrganizationUrl = getOrganizationUrl + '?' + queryString;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getOrganizationUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OrganizationService.prototype.ExportOrganizationList = function (input) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var getUrl = config_1.WeGoConfig.API_EXPORT_ORGANIZATION_LIST + '?' + queryString;
	        var headers = this.authService.GetHeader('text/csv');
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getUrl, options);
	    };
	    OrganizationService.prototype.GetOrganizationByHashId = function (organizationHashId) {
	        var getCompnayUrl = config_1.WeGoConfig.API_GET_ORGANIZATION_BY_HASH +
	            '?organizationHashId=' +
	            organizationHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getCompnayUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OrganizationService.prototype.GetOrganizationBasicDetail = function (organizationHashId) {
	        var getCompnayUrl = config_1.WeGoConfig.API_GET_ORGANIZATION_BASIC_DETAIL +
	            '?organizationHashId=' +
	            organizationHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getCompnayUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OrganizationService.prototype.AddOrganization = function (organizationModel) {
	        var body = organizationModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_ORGANIZATION_DETAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OrganizationService.prototype.DeleteOrganization = function (selectedOrganizationList) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_DELETE_ORGANIZATION, selectedOrganizationList, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OrganizationService.prototype.UpdateOrganizationContactPerson = function (organizationHashId, personHashId) {
	        var getOrganizationUrl = config_1.WeGoConfig.API_UPDATE_ORGANIZATION_CONTACT_PERSON +
	            '?organizationHashId=' +
	            organizationHashId +
	            '&personHashId=' +
	            personHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getOrganizationUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OrganizationService.prototype.GetPersonListForContactPerson = function (organizationMasterHashId, input) {
	        var getPersonUrl = config_1.WeGoConfig.API_GET_ORGANIZATION_CONATACT_PERSON_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getPersonUrl =
	                getPersonUrl +
	                    '?' +
	                    queryString +
	                    '&organizationHashId=' +
	                    organizationMasterHashId;
	        }
	        else {
	            getPersonUrl =
	                getPersonUrl + '?organizationHashId=' + organizationMasterHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getPersonUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OrganizationService.prototype.RemocveOrganizationContactPerson = function (organizationHashId) {
	        var getComapanyUrl = config_1.WeGoConfig.API_REMOVE_ORGANIZATION_CONTACT_PERSON +
	            '?organizationHashId=' +
	            organizationHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getComapanyUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OrganizationService.prototype.InActiveOrganizationAdmin = function (companyAdminHashId) {
	        var getInactiveCompanyAdminUrl = config_1.WeGoConfig.API_GET_INACTIVE_COMPANY_ADMIN +
	            '?companyAdminHashId=' +
	            companyAdminHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInactiveCompanyAdminUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OrganizationService.prototype.GetOrganizationDriverList = function (organizationHashId, input) {
	        var getOrganizationDriverList = config_1.WeGoConfig.API_GET_ORGANIZATION_DRIVER_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getOrganizationDriverList =
	                getOrganizationDriverList +
	                    '?' +
	                    queryString +
	                    '&organizationHashId=' +
	                    organizationHashId;
	        }
	        else {
	            getOrganizationDriverList =
	                getOrganizationDriverList + '?organizationHashId=' + organizationHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getOrganizationDriverList, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OrganizationService.prototype.ExportOrganizationDriverList = function (organizationHashId, input) {
	        input.currentPage = 0;
	        var getOrganizationDriverList = config_1.WeGoConfig.API_EXPORT_ORGANIZATION_DRIVER_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getOrganizationDriverList =
	                getOrganizationDriverList +
	                    '?' +
	                    queryString +
	                    '&organizationHashId=' +
	                    organizationHashId;
	        }
	        else {
	            getOrganizationDriverList =
	                getOrganizationDriverList + '?organizationHashId=' + organizationHashId;
	        }
	        var headers = this.authService.GetHeader('text/csv');
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getOrganizationDriverList, options);
	    };
	    // public GetOrganizationForBatchUpload(input?: DataListModel): Observable<IAPIResponse> {
	    //     let getOrganizationUrl = WeGoConfig.API_GET_ORGANIZATION_FOR_BATCH_UPLOAD;
	    //     let headers = this.authService.GetHeader();
	    //     let options = new RequestOptions({ headers: headers });
	    //     return this.http.get(getOrganizationUrl, options)
	    //         .map(this.authService.HandleAPIResponse)
	    //         .catch(this.authService.HandleAPIError);
	    // }
	    // public GetOrganizationListByInstance(instanceHashId: string): Observable<IAPIResponse> {
	    //     let getOrganizationUrl = WeGoConfig.API_GET_ORGANIZATION_LIST_BY_INSTANCE;
	    //     getOrganizationUrl = getOrganizationUrl + "?instanceHashId=" + instanceHashId;
	    //     let headers = this.authService.GetHeader();
	    //     let options = new RequestOptions({ headers: headers });
	    //     return this.http.get(getOrganizationUrl, options)
	    //         .map(this.authService.HandleAPIResponse)
	    //         .catch(this.authService.HandleAPIError);
	    // }
	    OrganizationService.prototype.GetOrganizationListDropdownForAddUpdatePage = function (pageName, permissionType, instanceHashId, companyHashId) {
	        var getOrganizationUrl;
	        switch (pageName) {
	            case 'SignupFormConfig':
	                getOrganizationUrl =
	                    config_1.WeGoConfig.API_GET_DROPDOWN_ORGANIZATION_LIST_SIGNUPCONFIG;
	                break;
	            case 'BatchUploadPerson':
	                getOrganizationUrl =
	                    config_1.WeGoConfig.API_GET_DROPDOWN_ORGANIZATION_LIST_BATCHUPLOADPERSON;
	                break;
	            case 'Template':
	                getOrganizationUrl =
	                    config_1.WeGoConfig.API_GET_DROPDOWN_ORGANIZATION_LIST_TEMPLATE;
	                break;
	            case 'Terms_And_Condition':
	                getOrganizationUrl =
	                    config_1.WeGoConfig.API_GET_DROPDOWN_ORGANIZATION_LIST_TERMS_AND_CONDITION;
	                break;
	            default:
	                getOrganizationUrl = config_1.WeGoConfig.API_GET_ORGANIZATION_LIST;
	                break;
	        }
	        if (permissionType) {
	            getOrganizationUrl =
	                getOrganizationUrl + '?permissionType=' + permissionType;
	        }
	        if (instanceHashId) {
	            getOrganizationUrl =
	                getOrganizationUrl + '&instanceHashId=' + instanceHashId;
	        }
	        if (companyHashId) {
	            getOrganizationUrl =
	                getOrganizationUrl + '&companyHashId=' + companyHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getOrganizationUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OrganizationService.prototype.GetDropdownOrganizationListByCompanyIdList = function (reportName, permissionType, companyHashIds) {
	        var getOrganizationUrl;
	        switch (reportName) {
	            case 'Terms_And_Condition':
	                getOrganizationUrl =
	                    config_1.WeGoConfig.API_GET_DROPDOWN_ORGANIZATION_LIST_BY_COMPANY_LIST_TERMS_AND_CONDITION;
	                break;
	        }
	        if (permissionType) {
	            getOrganizationUrl =
	                getOrganizationUrl + '?permissionType=' + permissionType;
	        }
	        var queryString = '';
	        companyHashIds.forEach(function (element) {
	            queryString += '&companyHashIdList=' + element;
	        });
	        getOrganizationUrl = getOrganizationUrl + queryString;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getOrganizationUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OrganizationService.prototype.GetCompanyList = function (input) {
	        var getCompanyUrl = config_1.WeGoConfig.API_GET_ORGANIZATION_COMPANY_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getCompanyUrl = getCompanyUrl + '?' + queryString;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getCompanyUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OrganizationService.prototype.GetSVGBaseOrganizationDropDown = function (pageName, instanceHashId, companyHashId, sharedVehicleGroupHashId) {
	        var getOrganizationUrl;
	        switch (pageName) {
	            case 'Kick_Back_Report':
	                getOrganizationUrl =
	                    config_1.WeGoConfig.API_GET_DROPDOWN_ORGANIZATION_LIST_BY_SVG_KICK_BACK_REPORT;
	                break;
	            case 'Cost_Center_Report':
	                getOrganizationUrl =
	                    config_1.WeGoConfig.API_GET_DROPDOWN_ORGANIZATION_LIST_COST_CENTER_REPORT;
	                break;
	            case 'TripData_Report':
	                getOrganizationUrl =
	                    config_1.WeGoConfig.API_GET_DROPDOWN_ORGANIZATION_LIST_BY_SVG_TRIP_DATA_REPORT;
	                break;
	            default:
	                getOrganizationUrl = config_1.WeGoConfig.API_GET_ORGANIZATION_LIST;
	                break;
	        }
	        if (instanceHashId) {
	            getOrganizationUrl =
	                getOrganizationUrl + '?instanceHashId=' + instanceHashId;
	        }
	        if (companyHashId) {
	            getOrganizationUrl =
	                getOrganizationUrl + '&companyHashId=' + companyHashId;
	        }
	        if (sharedVehicleGroupHashId) {
	            getOrganizationUrl =
	                getOrganizationUrl +
	                    '&sharedVehicleGroupHashId=' +
	                    sharedVehicleGroupHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getOrganizationUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OrganizationService.prototype.GetOrganizationGDPRSettings = function (organizationHashId) {
	        var getCompnayUrl = config_1.WeGoConfig.API_GET_ORGANIZATION_GDPR_SETTINGS +
	            '?organizationHashId=' +
	            organizationHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getCompnayUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OrganizationService.prototype.BlockUnblockOrganization = function (organizationBlockModel) {
	        var body = organizationBlockModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_ORGANIZATION_BLOCKUNBLOCK, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OrganizationService.prototype.ResetTwoFaCookies = function (OrganizationHashId) {
	        var getInstanceUrl = config_1.WeGoConfig.API_RESET_TWOFA_COOKIES_ORGANIZATION + "?OrganizationHashId=" + OrganizationHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInstanceUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OrganizationService.prototype.ResetTwoFaKeys = function (OrganizationHashId) {
	        var getInstanceUrl = config_1.WeGoConfig.API_RESET_TWOFA_KEYS_ORGANIZATION + "?OrganizationHashId=" + OrganizationHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInstanceUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OrganizationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], OrganizationService);
	    return OrganizationService;
	    var _a, _b;
	}());
	exports.OrganizationService = OrganizationService;


/***/ },
/* 615 */
/***/ function(module, exports) {

	"use strict";
	var TermsConditionModel = (function () {
	    function TermsConditionModel() {
	        this.instanceHashId = "";
	        this.type = "";
	        this.name = "";
	        this.version = 1.0;
	        this.termsAndConditionsHashId = "";
	        this.bodyHtml = "";
	        this.companyHashId = "";
	        this.organizationHashId = "";
	        this.sharedVehicleGroupHashId = "";
	        this.subscriptionHashId = "";
	        this.instanceName = "";
	        this.companyName = "";
	        this.organizationName = "";
	        this.sharedVehicleGroupName = "";
	        this.instanceHashIdList = [];
	        this.companyHashIdList = [];
	        this.organizationHashIdList = [];
	        this.sharedVehicleGroupHashIdList = [];
	        this.acceptanceMomentModel = new AcceptanceMomentModel();
	    }
	    Object.defineProperty(TermsConditionModel.prototype, "displayVersion", {
	        get: function () {
	            return this.version.toFixed(1);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return TermsConditionModel;
	}());
	exports.TermsConditionModel = TermsConditionModel;
	var AcceptanceMomentModel = (function () {
	    function AcceptanceMomentModel() {
	    }
	    return AcceptanceMomentModel;
	}());
	exports.AcceptanceMomentModel = AcceptanceMomentModel;
	var TermsConditionStatus = (function () {
	    function TermsConditionStatus() {
	    }
	    return TermsConditionStatus;
	}());
	exports.TermsConditionStatus = TermsConditionStatus;


/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define([],t):"object"==typeof exports?exports.SlimSelect=t():e.SlimSelect=t()}(this,function(){return function(e){function t(n){if(i[n])return i[n].exports;var s=i[n]={i:n,l:!1,exports:{}};return e[n].call(s.exports,s,s.exports,t),s.l=!0,s.exports}var i={};return t.m=e,t.c=i,t.d=function(e,i,n){t.o(e,i)||Object.defineProperty(e,i,{configurable:!1,enumerable:!0,get:n})},t.n=function(e){var i=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(i,"a",i),i},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="/",t(t.s=1)}([function(e,t,i){"use strict";function n(e,t){function i(e,t){return t&&e&&e.classList&&e.classList.contains(t)?e:null}function n(e,t){return e&&e!==document?i(e,t)?e:n(e.parentNode,t):null}return i(e,t)||n(e,t)}function s(e,t){var i=e.scrollTop+e.offsetTop,n=i+e.clientHeight,s=t.offsetTop,o=s+t.clientHeight;s<i?e.scrollTop-=i-s:o>n&&(e.scrollTop+=o-n)}function o(e,t,i){var n=e.offsetHeight,s=e.getBoundingClientRect(),o=i?s.top:s.top-n,a=i?s.bottom:s.bottom+n;return o<=0?"below":a>=window.innerHeight?"above":i?t:"below"}function a(e,t,i){void 0===t&&(t=100),void 0===i&&(i=!1);var n;return function(){var s=this,o=arguments,a=function(){n=null,i||e.apply(s,o)},l=i&&!n;clearTimeout(n),n=setTimeout(a,t),l&&e.apply(s,o)}}function l(e,t,i){if(!Array.isArray(e))return e[t]===i;for(var n=0;n<e.length;n++)if(e[n]&&e[n][t]&&e[n][t]===i)return!0;return!1}t.__esModule=!0,t.hasClassInTree=n,t.ensureElementInView=s,t.putContent=o,t.debounce=a,t.isValueInArrayOfObjects=l},function(e,t,i){"use strict";t.__esModule=!0,i(2),i(3);var n=i(4),s=i(0),o=i(5),a=i(6),l=i(7),r=function(){function e(e){var t=this;this.beforeOnChange=null,this.onChange=null,this.validate(e);var i="string"==typeof e.select?document.querySelector(e.select):e.select;this.config=new n.default({select:i,showSearch:e.showSearch,searchText:e.searchText,showContent:e.showContent,placeholderText:e.placeholder,isEnabled:e.isEnabled}),this.select=new o.default({select:i,main:this}),this.data=new a.default({main:this}),this.slim=new l.default({main:this}),this.select.element.parentNode.insertBefore(this.slim.container,this.select.element.nextSibling),e.data?this.setData(e.data):this.render(),document.addEventListener("click",function(e){s.hasClassInTree(e.target,t.config.id)||t.close()}),window.addEventListener("scroll",s.debounce(function(e){t.data.contentOpen&&"auto"===t.config.showContent&&("above"===s.putContent(t.slim.content,t.data.contentPosition,t.data.contentOpen)?t.moveContentAbove():t.moveContentBelow())}),!1),e.beforeOnChange&&(this.beforeOnChange=e.beforeOnChange),e.onChange&&(this.onChange=e.onChange)}return e.prototype.validate=function(e){var t="string"==typeof e.select?document.querySelector(e.select):e.select;if(!t)throw new Error("Could not find select element");if("SELECT"!==t.tagName)throw new Error("Element isnt of type select")},e.prototype.set=function(e,t,i){void 0===t&&(t="value"),void 0===i&&(i=!0),this.config.isMultiple&&!Array.isArray(e)?this.data.addToSelected(e,t):this.data.setSelected(e,t),this.render(),this.select.setValue(),i&&this.close()},e.prototype.setData=function(e){if(!a.validateData(e))return void console.error("Validation problem on: #"+this.select.element.id);var t=JSON.parse(JSON.stringify(e));this.select.create(t),this.data.parseSelectData(),this.data.setSelectedFromSelect(),this.render()},e.prototype.open=function(){this.config.isEnabled&&(this.slim.search.input.focus(),this.data.contentOpen||(this.config.isMultiple?this.slim.multiSelected.plus.classList.add("ss-cross"):(this.slim.singleSelected.arrowIcon.arrow.classList.remove("arrow-down"),this.slim.singleSelected.arrowIcon.arrow.classList.add("arrow-up")),this.slim[this.config.isMultiple?"multiSelected":"singleSelected"].container.classList.add("above"===this.data.contentPosition?this.config.openAbove:this.config.openBelow),this.slim.content.classList.add(this.config.open),"up"===this.config.showContent.toLowerCase()?this.moveContentAbove():"down"===this.config.showContent.toLowerCase()?this.moveContentBelow():"above"===s.putContent(this.slim.content,this.data.contentPosition,this.data.contentOpen)?this.moveContentAbove():this.moveContentBelow(),this.data.contentOpen=!0))},e.prototype.close=function(){var e=this;this.data.contentOpen&&(this.config.isMultiple?(this.slim.multiSelected.container.classList.remove(this.config.openAbove),this.slim.multiSelected.container.classList.remove(this.config.openBelow),this.slim.multiSelected.plus.classList.remove("ss-cross")):(this.slim.singleSelected.container.classList.remove(this.config.openAbove),this.slim.singleSelected.container.classList.remove(this.config.openBelow),this.slim.singleSelected.arrowIcon.arrow.classList.add("arrow-down"),this.slim.singleSelected.arrowIcon.arrow.classList.remove("arrow-up")),this.slim.content.classList.remove(this.config.open),this.data.contentOpen=!1,this.search(""),setTimeout(function(){e.slim.content.removeAttribute("style"),e.data.contentPosition="below",e.slim[e.config.isMultiple?"multiSelected":"singleSelected"].container.classList.remove(e.config.openAbove),e.slim[e.config.isMultiple?"multiSelected":"singleSelected"].container.classList.remove(e.config.openBelow)},300))},e.prototype.moveContentAbove=function(){var e=this.config.isMultiple?this.slim.multiSelected.container.offsetHeight:this.slim.singleSelected.container.offsetHeight,t=this.slim.content.offsetHeight,i=e+t-1;this.slim.content.style.margin="-"+i+"px 0 0 0",this.slim.content.style["transform-origin"]="center bottom",this.data.contentPosition="above",this.slim[this.config.isMultiple?"multiSelected":"singleSelected"].container.classList.remove(this.config.openBelow),this.slim[this.config.isMultiple?"multiSelected":"singleSelected"].container.classList.add(this.config.openAbove)},e.prototype.moveContentBelow=function(){this.slim.content.removeAttribute("style"),this.data.contentPosition="below",this.slim[this.config.isMultiple?"multiSelected":"singleSelected"].container.classList.remove(this.config.openAbove),this.slim[this.config.isMultiple?"multiSelected":"singleSelected"].container.classList.add(this.config.openBelow)},e.prototype.enable=function(){this.config.isEnabled=!0,this.config.isMultiple?this.slim.multiSelected.container.classList.remove(this.config.disabled):this.slim.singleSelected.container.classList.remove(this.config.disabled),this.select.disconnectMutationObserver(),this.select.element.disabled=!1,this.slim.search.input.disabled=!1,this.select.observeMutationObserver()},e.prototype.disable=function(){this.config.isEnabled=!1,this.config.isMultiple?this.slim.multiSelected.container.classList.add(this.config.disabled):this.slim.singleSelected.container.classList.add(this.config.disabled),this.select.disconnectMutationObserver(),this.select.element.disabled=!0,this.slim.search.input.disabled=!0,this.select.observeMutationObserver()},e.prototype.search=function(e){this.data.searchValue!==e&&(this.slim.search.input.value=e,this.data.search(e),this.render())},e.prototype.render=function(){this.config.isMultiple?this.slim.values():this.slim.placeholder(),this.slim.options()},e.prototype.destroy=function(){this.select.element.style.display="inline-block",this.slim.container.parentElement.removeChild(this.slim.container)},e}();t.default=r,e.exports=r},function(e,t){},function(e,t){try{var i=new window.CustomEvent("test");if(i.preventDefault(),!0!==i.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var n=function(e,t){var i,n;return t=t||{bubbles:!1,cancelable:!1,detail:void 0},i=document.createEvent("CustomEvent"),i.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),n=i.preventDefault,i.preventDefault=function(){n.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},i};n.prototype=window.Event.prototype,window.CustomEvent=n}},function(e,t,i){"use strict";t.__esModule=!0;var n=function(){function e(e){this.id="",this.isMultiple=!1,this.showSearch=!0,this.showContent="auto",this.searchText="No Results",this.placeholderText="Select Value",this.isEnabled=!0,this.main="ss-main",this.singleSelected="ss-single-selected",this.arrow="ss-arrow",this.multiSelected="ss-multi-selected",this.add="ss-add",this.plus="ss-plus",this.values="ss-values",this.value="ss-value",this.valueText="ss-value-text",this.valueDelete="ss-value-delete",this.content="ss-content",this.open="ss-open",this.openAbove="ss-open-above",this.openBelow="ss-open-below",this.search="ss-search",this.list="ss-list",this.optgroup="ss-optgroup",this.optgroupLabel="ss-optgroup-label",this.option="ss-option",this.highlighted="ss-highlighted",this.disabled="ss-disabled",this.hide="ss-hide",this.id="ss-"+Math.floor(1e5*Math.random()),this.style=e.select.style.cssText,this.class=e.select.classList,this.isMultiple=e.select.multiple,this.showSearch=!1!==e.showSearch,e.showContent&&(this.showContent=e.showContent),this.isEnabled=!1!==e.isEnabled,e.searchText&&(this.searchText=e.searchText),e.placeholderText&&(this.placeholderText=e.placeholderText)}return e}();t.default=n},function(e,t,i){"use strict";t.__esModule=!0;var n=function(){function e(e){this.element=e.select,this.main=e.main,this.element.disabled&&(this.main.config.isEnabled=!1),this.addAttributes(),this.addEventListeners(),this.addMutationObserver()}return e.prototype.setValue=function(){if(this.main.data.getSelected()){if(this.main.config.isMultiple)for(var e=this.main.data.getSelected(),t=this.element.options,i=0;i<t.length;i++){var n=t[i];n.selected=!1;for(var s=0;s<e.length;s++)e[s].value===n.value&&(n.selected=!0)}else{var e=this.main.data.getSelected();this.element.value=e?e.value:""}this.element.dispatchEvent(new CustomEvent("change"))}},e.prototype.addAttributes=function(){this.element.tabIndex=-1,this.element.style.display="none"},e.prototype.addEventListeners=function(){var e=this;this.element.addEventListener("change",function(t){e.main.data.setSelectedFromSelect(),e.main.render()})},e.prototype.addMutationObserver=function(){var e=this;this.mutationObserver=new MutationObserver(function(t){e.main.data.parseSelectData(),e.main.data.setSelectedFromSelect(),e.main.render()}),this.observeMutationObserver()},e.prototype.observeMutationObserver=function(){this.mutationObserver.observe(this.element,{attributes:!0,childList:!0,characterData:!0})},e.prototype.disconnectMutationObserver=function(){this.mutationObserver.disconnect()},e.prototype.create=function(e){this.element.innerHTML="";for(var t=0;t<e.length;t++)if(e[t].hasOwnProperty("options")){var i=e[t],n=document.createElement("optgroup");n.label=i.label;for(var s=0;s<i.options.length;s++)n.appendChild(this.createOption(i.options[s]));this.element.appendChild(n)}else this.element.appendChild(this.createOption(e[t]))},e.prototype.createOption=function(e){var t=document.createElement("option");return t.value=e.value||e.text,t.innerHTML=e.innerHTML||e.text,e.selected&&(t.selected=e.selected),e.disabled&&(t.disabled=!0),e.placeholder&&t.setAttribute("data-placeholder","true"),e.data&&"object"==typeof e.data&&Object.keys(e.data).forEach(function(i){t.setAttribute("data-"+i,e.data[i])}),t},e}();t.default=n},function(e,t,i){"use strict";function n(e){if(!e)return void console.error("Data must be an array of objects");for(var t=!1,i=0,n=0;n<e.length;n++)if(e[n].hasOwnProperty("label")){if(e[n].hasOwnProperty("options"))for(var o=e[n],a=o.options,n=0;n<a.length;n++)(t=s(a[n]))||i++}else{var l=e[n];t=s(l),t||i++}return 0===i}function s(e){return void 0!==e.text||(console.error("Data object option must have at least have a text value. Check object: "+JSON.stringify(e)),!1)}t.__esModule=!0;var o=function(){function e(e){this.contentOpen=!1,this.contentPosition="below",this.main=e.main,this.searchValue="",this.data=[],this.filtered=null,this.parseSelectData(),this.setSelectedFromSelect()}return e.prototype.parseSelectData=function(){this.data=[];for(var e=this.main.select.element,t=e.childNodes,i=0;i<t.length;i++)if("OPTGROUP"===t[i].nodeName){for(var n=t[i],s={label:n.label,options:[]},o=t[i].childNodes,a=0;a<o.length;a++)"OPTION"===o[a].nodeName&&s.options.push(this.pullOptionData(o[a]));this.data.push(s)}else"OPTION"===t[i].nodeName&&this.data.push(this.pullOptionData(t[i]))},e.prototype.pullOptionData=function(e){return{id:!!e.dataset&&e.dataset.id||String(Math.floor(1e8*Math.random())),value:e.value,text:e.text,innerHTML:e.innerHTML,selected:e.selected,disabled:e.disabled,placeholder:e.dataset.placeholder||null,data:e.dataset}},e.prototype.setSelectedFromSelect=function(){var e=this.main.select.element.options;if(this.main.config.isMultiple){for(var t=[],i=0;i<e.length;i++){var n=e[i];n.selected&&t.push(this.getObjectFromData(n.value,"value").id)}this.setSelected(t,"id")}else if(-1!==e.selectedIndex){var n=e[e.selectedIndex],s=n.value;this.setSelected(s,"value")}},e.prototype.setSelected=function(e,t){void 0===t&&(t="id");for(var i=0;i<this.data.length;i++)if(this.data[i].hasOwnProperty("label")){if(this.data[i].hasOwnProperty("options"))for(var n=this.data[i].options,s=0;s<n.length;s++)n[s].selected=this.shouldBeSelected(n[s],e,t)}else this.data[i].selected=this.shouldBeSelected(this.data[i],e,t);this.onDataChange()},e.prototype.shouldBeSelected=function(e,t,i){if(void 0===i&&(i="id"),Array.isArray(t)){for(var n=0;n<t.length;n++)if(String(e[i])===String(t[n]))return!0}else if(String(e[i])===String(t))return!0;return!1},e.prototype.getSelected=function(){for(var e=null,t=[],i=0;i<this.data.length;i++)if(this.data[i].hasOwnProperty("label")){if(this.data[i].hasOwnProperty("options"))for(var n=this.data[i].options,s=0;s<n.length;s++)n[s].selected&&(this.main.config.isMultiple?t.push(n[s]):e=n[s])}else this.data[i].selected&&(this.main.config.isMultiple?t.push(this.data[i]):e=this.data[i]);return this.main.config.isMultiple?t:e},e.prototype.addToSelected=function(e,t){if(void 0===t&&(t="id"),this.main.config.isMultiple){for(var i=[],n=this.getSelected(),s=0;s<n.length;s++)i.push(n[s][t]);i.push(e),this.setSelected(i,t)}},e.prototype.removeFromSelected=function(e,t){if(void 0===t&&(t="id"),this.main.config.isMultiple){for(var i=[],n=this.getSelected(),s=0;s<n.length;s++)String(n[s][t])!==String(e)&&i.push(n[s][t]);this.setSelected(i,t)}},e.prototype.onDataChange=function(){this.main.onChange&&this.main.onChange(JSON.parse(JSON.stringify(this.getSelected())))},e.prototype.getObjectFromData=function(e,t){void 0===t&&(t="id");for(var i=0;i<this.data.length;i++){if(t in this.data[i]&&String(this.data[i][t])===String(e))return this.data[i];if(this.data[i].hasOwnProperty("options"))for(var n=this.data[i],s=0;s<n.options.length;s++)if(String(n.options[s][t])===String(e))return n.options[s]}return null},e.prototype.search=function(e){if(this.searchValue=e,""===e.trim())return void(this.filtered=null);var t=this.data.slice(0);e=e.trim().toLowerCase();var i=t.map(function(t){if(t.hasOwnProperty("options")){var i=t,n=i.options.filter(function(t){return-1!==t.text.toLowerCase().indexOf(e)});if(0!==n.length){var s=Object.assign({},i);return s.options=n,s}}if(t.hasOwnProperty("text")){if(-1!==t.text.toLowerCase().indexOf(e))return t}return null});this.filtered=i.filter(function(e){return e})},e}();t.default=o,t.validateData=n,t.validateOption=s},function(e,t,i){"use strict";t.__esModule=!0;var n=i(0),s=function(){function e(e){this.main=e.main,this.container=this.containerDiv(),this.content=this.contentDiv(),this.search=this.searchDiv(),this.list=this.listDiv(),this.options(),this.main.config.isMultiple?(this.multiSelected=this.multiSelectedDiv(),this.container.appendChild(this.multiSelected.container),this.container.appendChild(this.content),this.content.appendChild(this.search.container),this.content.appendChild(this.list)):(this.singleSelected=this.singleSelectedDiv(),this.container.appendChild(this.singleSelected.container),this.container.appendChild(this.content),this.content.appendChild(this.search.container),this.content.appendChild(this.list))}return e.prototype.containerDiv=function(){var e=document.createElement("div");e.classList.add(this.main.config.id),e.classList.add(this.main.config.main),e.style.cssText=this.main.config.style;for(var t=0;t<this.main.config.class.length;t++)e.classList.add(this.main.config.class[t]);return e},e.prototype.singleSelectedDiv=function(){var e=this,t=document.createElement("div");t.classList.add(this.main.config.singleSelected);var i=document.createElement("span");i.classList.add("placeholder"),t.appendChild(i);var n=document.createElement("span");n.classList.add(this.main.config.arrow);var s=document.createElement("span");return s.classList.add("arrow-down"),n.appendChild(s),t.appendChild(n),t.onclick=function(){e.main.config.isEnabled&&(e.main.data.contentOpen?e.main.close():e.main.open())},{container:t,placeholder:i,arrowIcon:{container:n,arrow:s}}},e.prototype.placeholder=function(){var e=this.main.data.getSelected();if(e&&e.placeholder){var t=document.createElement("span");t.classList.add(this.main.config.disabled),t.innerHTML=this.main.config.placeholderText,this.singleSelected.placeholder.innerHTML=t.outerHTML}else this.singleSelected.placeholder.innerHTML=e?e.innerHTML||e.text:""},e.prototype.multiSelectedDiv=function(){var e=this,t=document.createElement("div");t.classList.add(this.main.config.multiSelected);var i=document.createElement("div");i.classList.add(this.main.config.values),t.appendChild(i);var n=document.createElement("div");n.classList.add(this.main.config.add);var s=document.createElement("span");return s.classList.add(this.main.config.plus),s.onclick=function(t){e.main.data.contentOpen&&(e.main.close(),t.stopPropagation())},n.appendChild(s),t.appendChild(n),t.onclick=function(t){if(e.main.config.isEnabled){t.target.classList.contains(e.main.config.valueDelete)||e.main.open()}},{container:t,values:i,add:n,plus:s}},e.prototype.values=function(){if(this.main.config.isMultiple){for(var e=this.multiSelected.values.childNodes,t=this.main.data.getSelected(),i=void 0,n=0;n<e.length;n++){i=!0;for(var s=e[n],o=0;o<t.length;o++)String(t[o].id)===String(s.dataset.id)&&(i=!1);if(i){var a=e[n];a.classList.add("ss-out"),this.multiSelected.values.removeChild(a)}}for(var o=0;o<t.length;o++){i=!1;for(var n=0;n<e.length;n++){var s=e[n];t[o].id===s.dataset.id&&(i=!0)}i||(0===e.length?this.multiSelected.values.appendChild(this.valueDiv(t[o])):0===o?this.multiSelected.values.insertBefore(this.valueDiv(t[o]),e[o]):e[o-1].insertAdjacentElement("afterend",this.valueDiv(t[o])))}if(0===t.length){var l=document.createElement("span");l.classList.add(this.main.config.disabled),l.innerHTML=this.main.config.placeholderText,this.multiSelected.values.innerHTML=l.outerHTML}}},e.prototype.valueDiv=function(e){var t=this,i=document.createElement("div");i.classList.add(this.main.config.value),i.dataset.id=e.id;var n=document.createElement("span");n.classList.add(this.main.config.valueText),n.innerHTML=e.text,i.appendChild(n);var s=document.createElement("span");return s.classList.add(this.main.config.valueDelete),s.innerHTML="x",s.onclick=function(i){if(t.main.config.isEnabled){if(t.main.beforeOnChange){for(var n=t.main.data.getSelected(),s=JSON.parse(JSON.stringify(n)),o=0;o<s.length;o++)s[o].id===e.id&&s.splice(o,1);!1!==t.main.beforeOnChange(s)&&(t.main.data.removeFromSelected(e.id,"id"),t.main.render(),t.main.select.setValue())}else t.main.data.removeFromSelected(e.id,"id"),t.main.render(),t.main.select.setValue();i.preventDefault()}},i.appendChild(s),i},e.prototype.contentDiv=function(){var e=document.createElement("div");return e.classList.add(this.main.config.content),e},e.prototype.searchDiv=function(){var e=this,t=document.createElement("div");t.classList.add(this.main.config.search),this.main.config.showSearch||(t.style.display="none");var i=document.createElement("input");return i.type="search",i.placeholder="Search",i.tabIndex=0,i.onclick=function(t){setTimeout(function(){""===t.target.value&&e.main.search("")},10)},i.onkeydown=function(t){"ArrowUp"===t.key?(e.highlightUp(),t.preventDefault()):"ArrowDown"===t.key?(e.highlightDown(),t.preventDefault()):"Tab"===t.key?e.main.close():"Enter"===t.key&&t.preventDefault()},i.onkeyup=function(t){var i=t.target;if("Enter"===t.key){var n=e.list.querySelector("."+e.main.config.highlighted);n&&n.click(),t.preventDefault()}else"ArrowUp"===t.key||"ArrowDown"===t.key||("Escape"===t.key?e.main.close():e.main.search(i.value));t.preventDefault()},i.onfocus=function(){e.main.open()},t.appendChild(i),{container:t,input:i}},e.prototype.highlightUp=function(){var e=this.list.querySelector("."+this.main.config.highlighted),t=null;if(e)t=e.previousSibling;else{var i=this.list.querySelectorAll("."+this.main.config.option+":not(."+this.main.config.disabled+")");t=i[i.length-1]}if(t&&t.classList.contains(this.main.config.optgroupLabel)&&(t=null),null===t){var s=e.parentNode;s.classList.contains(this.main.config.optgroup)&&s.previousSibling&&(t=s.previousSibling.childNodes[s.previousSibling.childNodes.length-1])}t&&(e&&e.classList.remove(this.main.config.highlighted),t.classList.add(this.main.config.highlighted),n.ensureElementInView(this.list,t))},e.prototype.highlightDown=function(){var e=this.list.querySelector("."+this.main.config.highlighted),t=e?e.nextSibling:this.list.querySelector("."+this.main.config.option+":not(."+this.main.config.disabled+")");if(null===t){var i=e.parentNode;if(i.classList.contains(this.main.config.optgroup)&&i.nextSibling){t=i.nextSibling.querySelector("."+this.main.config.option+":not(."+this.main.config.disabled+")")}}t&&(e&&e.classList.remove(this.main.config.highlighted),t.classList.add(this.main.config.highlighted),n.ensureElementInView(this.list,t))},e.prototype.listDiv=function(){var e=document.createElement("div");return e.classList.add(this.main.config.list),e.onmousewheel=function(t){var i=e.scrollTop,n=e.scrollHeight,s=e.offsetHeight,o="DOMMouseScroll"==t.type?-40*t.detail:t.wheelDelta,a=o>0,l=function(){return t.stopPropagation(),t.preventDefault(),t.returnValue=!1,!1};return!a&&-o>n-s-i?(e.scrollTop=n,l()):a&&o>i?(e.scrollTop=0,l()):void 0},e},e.prototype.options=function(){var e=this.main.data.filtered||this.main.data.data;if(this.list.innerHTML="",0===e.length){var t=document.createElement("div");return t.classList.add(this.main.config.option),t.classList.add(this.main.config.disabled),t.innerHTML=this.main.config.searchText,void this.list.appendChild(t)}for(var i=0;i<e.length;i++)if(e[i].hasOwnProperty("label")){var n=e[i],s=document.createElement("div");s.classList.add(this.main.config.optgroup);var o=document.createElement("div");o.classList.add(this.main.config.optgroupLabel),o.innerHTML=n.label,s.appendChild(o);for(var a=n.options,l=0;l<a.length;l++)s.appendChild(this.option(a[l]));this.list.appendChild(s)}else this.list.appendChild(this.option(e[i]))},e.prototype.option=function(e){if(e.placeholder){var t=document.createElement("div");return t.classList.add(this.main.config.option),t.classList.add(this.main.config.hide),t}var i=document.createElement("div");i.classList.add(this.main.config.option);var s=this.main.data.getSelected();i.dataset.id=e.id,i.innerHTML=e.innerHTML;var o=this;return i.onclick=function(){var e=this,t=e.dataset.id;if(o.main.beforeOnChange){var i=void 0,n=JSON.parse(JSON.stringify(o.main.data.getObjectFromData(t)));n.selected=!0,o.main.config.isMultiple?(i=JSON.parse(JSON.stringify(s)),i.push(n)):i=JSON.parse(JSON.stringify(n));!1!==o.main.beforeOnChange(i)&&o.main.set(t,"id")}else o.main.set(t,"id")},(e.disabled||s&&n.isValueInArrayOfObjects(s,"id",e.id))&&(i.onclick=null,i.classList.add(this.main.config.disabled)),i},e}();t.default=s}])});

/***/ },
/* 617 */
/***/ function(module, exports) {

	module.exports = "<form #searchForm=\"ngForm\">\r\n  <div class=\"row\">\r\n    <div [ngClass]=\" {'hidden':!(authService.GetHighestRoleLevel() <= roleLevel.Instance)}\" class=\"form-group col-md-3\">\r\n      <label>\r\n        {{ 'LblInstance' | translate }}\r\n      </label>\r\n      <select id=\"instanceName\" name=\"instanceName\" multiple (change)=\"OnInstanceChange()\">\r\n        <option *ngFor=\"let inst of instanceList\" [attr.value]='inst.keyHash'>{{inst.value}}</option>\r\n      </select>\r\n    </div>\r\n    <div [ngClass]=\" {'hidden':!(authService.GetHighestRoleLevel() <= roleLevel.Company)}\" class=\"form-group col-md-3\">\r\n      <label>\r\n        {{ 'LblCompany' | translate }}\r\n      </label>\r\n      <select id=\"companyName\" name=\"companyName\" multiple (change)=\"OnCompanyChange()\">\r\n        <option *ngFor=\"let company of companyList\" [attr.value]='company.keyHash'>{{company.value}}</option>\r\n      </select>\r\n    </div>\r\n    <div [ngClass]=\" {'hidden':(!(authService.GetHighestRoleLevel() <= roleLevel.Organization))}\" class=\"form-group col-md-3\">\r\n      <label>\r\n        {{ 'LblOrganization' | translate }}\r\n      </label>\r\n      <select id=\"organizationName\" name=\"organizationName\" multiple (change)=\"OnOrganizationChange()\">\r\n        <option *ngFor=\"let organization of organizationList\" [attr.value]='organization.keyHash'>{{organization.value}}</option>\r\n      </select>\r\n    </div>\r\n    <div [ngClass]=\" {'hidden':!(authService.GetHighestRoleLevel() <= roleLevel.SVG)}\"  class=\"form-group col-md-3\">\r\n      <label>\r\n        {{ 'LblSharedVehicleGroup' | translate }}\r\n      </label>\r\n      <select id=\"svgName\" name=\"svgName\" (change)=\"onSVGChange()\" multiple>\r\n        <option *ngFor=\"let svg of svgList\" [attr.value]='svg.keyHash'>{{svg.value}}</option>\r\n      </select>\r\n    </div>\r\n  </div>\r\n</form>";

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var core_1 = __webpack_require__(3);
	var DriverRoleComponent = (function () {
	    function DriverRoleComponent(translate) {
	        this.translate = translate;
	        this.menu = [
	            {
	                title: 'LblHome',
	                icon: 'fa fa-home fa-fw',
	                redirectPath: 'dashboard',
	            },
	            {
	                title: 'LblOverview',
	                icon: 'fa fa-list fa-fw',
	                redirectPath: 'booking/overview',
	            },
	            {
	                title: 'LblNormal',
	                icon: 'fa fa-calendar fa-fw',
	                redirectPath: 'booking',
	            },
	            {
	                title: 'LblHistory',
	                icon: 'fa fa-clock-o fa-fw',
	                redirectPath: 'booking/history',
	            },
	            {
	                title: 'LblTripHistory',
	                icon: 'fa fa-map fa-fw',
	                redirectPath: 'trip/history',
	            },
	            {
	                title: 'LblCostAndExpenses',
	                icon: 'fa fa-book fa-fw',
	                redirectPath: 'drivercostexpense/list',
	            },
	            {
	                title: 'LblSubscription',
	                icon: 'fa fa-tags fa-fw',
	                redirectPath: 'subscription/list',
	            }
	        ];
	    }
	    DriverRoleComponent.prototype.ngOnInit = function () {
	        this.translate.setDetectedLang();
	    };
	    DriverRoleComponent.prototype.ngOnDestroy = function () { };
	    DriverRoleComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-driver-role',
	            template: "\n  <div class=\"driver-role\">\n    <div class=\"wrapper\">\n      <wego-driver-navbar [menu]=\"menu\"></wego-driver-navbar>\n      <div class=\"page-content\">\n        <router-outlet></router-outlet>\n      </div>\n      <wego-driver-footer></wego-driver-footer>\n    </div>\n  </div>\n  "
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _a) || Object])
	    ], DriverRoleComponent);
	    return DriverRoleComponent;
	    var _a;
	}());
	exports.DriverRoleComponent = DriverRoleComponent;


/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var core_1 = __webpack_require__(3);
	var DriverNavBarComponent = (function () {
	    function DriverNavBarComponent(router, authService, translateService) {
	        this.router = router;
	        this.authService = authService;
	        this.translateService = translateService;
	        //selectedMenu: string;
	        this.unreadNotification = 0;
	    }
	    Object.defineProperty(DriverNavBarComponent.prototype, "selectedMenu", {
	        get: function () {
	            return window.location.hash.split(/[;#]/)[1];
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DriverNavBarComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.GetUserSetting();
	        this.urlDriverUpdate = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DRIVER_PROFILE);
	        this.urlTAndCActivityLog = this.authService.GetURL(config_1.ApplicationRouteURL.URL_TERMS_CONDITION_ACTIVITY_DRIVER);
	        this.urlInbox = this.authService.GetURL(config_1.ApplicationRouteURL.URL_INBOX_PAGE);
	        this.intervalHandler = setInterval(function () { return _this.GetNotificationCount(); }, (config_1.WeGoConfig.NOTIFICATION_REFRESH_INTERVAL_SEC * 1000));
	        this.GetNotificationCount();
	        this.language = this.translateService.currentLang == "en" ? "En" : this.translateService.currentLang == "de" ? "De" : this.translateService.currentLang == "pt" ? "Pt" : this.translateService.currentLang == "fr" ? "Fr" : this.translateService.currentLang == "pl" ? "Pl" : this.translateService.currentLang == "nl" ? "Du" : "Du";
	        this.languageLbl = this.translateService.currentLang == "en" ? "EN" : this.translateService.currentLang == "de" ? "DE" : this.translateService.currentLang == "pt" ? "PT" : this.translateService.currentLang == "fr" ? "FR" : this.translateService.currentLang == "pl" ? "PL" : this.translateService.currentLang == "nl" ? "NL" : "NL";
	        this.menuCollapse = "";
	    };
	    DriverNavBarComponent.prototype.GetUserSetting = function () {
	        var userSetting = this.authService.GetUserSetting();
	        if (userSetting) {
	            this.firstName = userSetting.firstName;
	            this.lastName = userSetting.lastName;
	            this.middleName = userSetting.middleName;
	        }
	        var userRole = this.authService.GetCurrentRole();
	        if (userRole) {
	            this.currentRole = userRole;
	        }
	        var personHashId = this.authService.GetPersonHashId();
	        if (personHashId) {
	            this.personHashId = personHashId;
	        }
	    };
	    DriverNavBarComponent.prototype.Logout = function () {
	        clearInterval(this.intervalHandler);
	        this.authService.Logout();
	        this.router.navigate(['/']);
	    };
	    DriverNavBarComponent.prototype.GetNotificationCount = function () {
	        var _this = this;
	        this.authService.GetNotificationCount()
	            .subscribe(function (res) {
	            _this.unreadNotification = res.data;
	        }, function (error) {
	            console.log(error);
	        });
	    };
	    DriverNavBarComponent.prototype.ResetNotificationCount = function () {
	        var _this = this;
	        this.authService.ResetNotificationCount()
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.unreadNotification = 0;
	            }
	            _this.router.navigate([_this.urlInbox, { v: Date.now() }]);
	        }, function (error) {
	            console.log(error);
	        });
	    };
	    DriverNavBarComponent.prototype.ChangeCurrentLanguage = function (language) {
	        var _this = this;
	        this.authService.UpdateUserLanguagePreference(language).subscribe(function (res) {
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	        }, function () {
	            localStorage.setItem("language", language);
	            //this.translateService.setDetectedLang();
	            _this.language = _this.translateService.currentLang == "en" ? "En" : _this.translateService.currentLang == "de" ? "De" : _this.translateService.currentLang == "pt" ? "Pt" : _this.translateService.currentLang == "fr" ? "Fr" : _this.translateService.currentLang == "pl" ? "Pl" : _this.translateService.currentLang == "nl" ? "Du" : "Du";
	            _this.languageLbl = _this.translateService.currentLang == "en" ? "EN" : _this.translateService.currentLang == "de" ? "DE" : _this.translateService.currentLang == "pt" ? "PT" : _this.translateService.currentLang == "fr" ? "FR" : _this.translateService.currentLang == "pl" ? "PL" : _this.translateService.currentLang == "nl" ? "NL" : "NL";
	            location.reload(true);
	        });
	    };
	    DriverNavBarComponent.prototype.ToggleCollapse = function () {
	        this.menuCollapse = this.menuCollapse == "" ? "in" : "";
	    };
	    DriverNavBarComponent.prototype.MenuSelected = function (selectedMenu) {
	        //localStorage.setItem("driverSelectedMenu", selectedMenu);
	    };
	    DriverNavBarComponent.prototype.GenerateDynamicURL = function (url) {
	        var urlData = this.authService.GetURL(url);
	        if (url == config_1.ApplicationRouteURL.URL_BOOKING)
	            this.router.navigate([urlData, { v: Date.now() }]);
	        else
	            this.router.navigate([urlData]);
	    };
	    DriverNavBarComponent.prototype.ngOnDestroy = function () {
	        clearInterval(this.intervalHandler);
	    };
	    __decorate([
	        core_1.Input('menu'), 
	        __metadata('design:type', String)
	    ], DriverNavBarComponent.prototype, "menu", void 0);
	    DriverNavBarComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-driver-navbar',
	            template: __webpack_require__(620),
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _c) || Object])
	    ], DriverNavBarComponent);
	    return DriverNavBarComponent;
	    var _a, _b, _c;
	}());
	exports.DriverNavBarComponent = DriverNavBarComponent;


/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"navbar-driver\">\r\n  <nav class=\"nav navbar navbar-default\">\r\n    <div class=\"container-fluid\" style=\"padding-left: 0px; padding-right: 0px;\">\r\n      <!-- Brand and toggle get grouped for better mobile display -->\r\n      <div class=\"navbar-header\">\r\n        <button type=\"button\" (click)=\"ToggleCollapse()\" class=\"navbar-toggle collapsed\" data-toggle=\"collapse\" data-target=\"#bs-example-navbar-collapse-1\" aria-expanded=\"false\">\r\n        <span class=\"sr-only\">Toggle navigation</span>\r\n        <span class=\"icon-bar\"></span>\r\n        <span class=\"icon-bar\"></span>\r\n        <span class=\"icon-bar\"></span>\r\n      </button>\r\n        <div class=\"logo-area\">\r\n          <a href=\"#\"><img src=\"" + __webpack_require__(621) + "\" class=\"logo\"></a>\r\n        </div>\r\n      </div>\r\n\r\n      <!-- Collect the nav links, forms, and other content for toggling -->\r\n      <div class=\"collapse navbar-collapse\" [ngClass]=\"menuCollapse\" id=\"bs-example-navbar-collapse-1\" style=\"padding-right: 0px;\">\r\n        <ul class=\"navbar-nav navbar-right\">\r\n          <li *ngFor=\"let menuItem of menu\" [ngClass]=\"{'active': selectedMenu == authService.GetURL(menuItem.redirectPath)}\">\r\n            <a class=\"cursor-pointer\" (click)=\"GenerateDynamicURL(menuItem.redirectPath);MenuSelected(menuItem.title);\"><i class=\"{{ menuItem.icon }}\"></i>{{ menuItem.title | translate }}</a>\r\n          </li>\r\n          <li [ngClass]=\"{'active': selectedMenu == urlInbox}\">\r\n            <a class=\"cursor-pointer\" (click)=\"MenuSelected('LblNotification'); ResetNotificationCount($event);\"><i class=\"fa fa-bell fa-fw\"></i>\r\n              <span *ngIf=\"unreadNotification > 0\">( {{ unreadNotification }} )</span>\r\n            </a>\r\n          </li>\r\n          <li class=\"dropdown\" dropdown>\r\n            <a class=\"dropdown-toggle cursor-pointer\" data-toggle=\"dropdown\" dropdownToggle style=\"min-width: auto;\">\r\n              <img *ngIf=\"language=='En'\" src=\"" + __webpack_require__(622) + "\" alt=\"English\" style=\"width: 18px;\">\r\n              <img *ngIf=\"language=='Du'\" src=\"" + __webpack_require__(623) + "\" alt=\"Dutch\" style=\"width: 18px;\">\r\n              <img *ngIf=\"language=='Fr'\" src=\"" + __webpack_require__(624) + "\" alt=\"French\" style=\"width: 18px;\">\r\n              <img *ngIf=\"language=='De'\" src=\"" + __webpack_require__(625) + "\" alt=\"German\" style=\"width: 18px;\">\r\n              <img *ngIf=\"language=='Pl'\" src=\"" + __webpack_require__(626) + "\" alt=\"Polish\" style=\"width: 18px;\">\r\n              <img *ngIf=\"language=='Pt'\" src=\"" + __webpack_require__(627) + "\" alt=\"Portugal\" style=\"width: 18px;\">\r\n              \r\n              <span class=\"light-blue-text text-darken-4\">{{languageLbl}}</span>\r\n              <i class=\"fa fa-angle-down\" aria-hidden=\"true\"></i>\r\n            </a>\r\n            <ul class=\"dropdown-menu\" dropdownMenu aria-labelledby=\"simple-dropdown\" style=\"min-width: auto;\">\r\n              <li *ngIf=\"language!='Du'\">\r\n                <a class=\"cursor-pointer\" (click)=\"ChangeCurrentLanguage('nl')\">\r\n                  <img src=\"" + __webpack_require__(623) + "\" alt=\"Dutch\" style=\"width: 18px;\">\r\n                  <span class=\"light-blue-text text-darken-4\">&nbsp;NL</span>\r\n                </a>\r\n              </li>\r\n              <li *ngIf=\"language!='En'\">\r\n                <a class=\"cursor-pointer\" (click)=\"ChangeCurrentLanguage('en')\">\r\n                  <img src=\"" + __webpack_require__(622) + "\" alt=\"English\" style=\"width: 18px;\">\r\n                  <span class=\"light-blue-text text-darken-4\">&nbsp;En</span>\r\n                </a>\r\n              </li>\r\n              <li *ngIf=\"language!='De'\">\r\n                <a class=\"cursor-pointer\" (click)=\"ChangeCurrentLanguage('de')\">\r\n                  <img src=\"" + __webpack_require__(625) + "\" alt=\"German\" style=\"width: 18px;\">\r\n                  <span class=\"light-blue-text text-darken-4\">&nbsp;DE</span>\r\n                </a>\r\n              </li>\r\n              <li *ngIf=\"language!='Fr'\">\r\n                <a class=\"cursor-pointer\" (click)=\"ChangeCurrentLanguage('fr')\">\r\n                  <img src=\"" + __webpack_require__(624) + "\" alt=\"French\" style=\"width: 18px;\">\r\n                  <span class=\"light-blue-text text-darken-4\">&nbsp;FR</span>\r\n                </a>\r\n              </li>\r\n              <li *ngIf=\"language!='Pl'\">\r\n                <a class=\"cursor-pointer\" (click)=\"ChangeCurrentLanguage('pl')\">\r\n                  <img src=\"" + __webpack_require__(626) + "\" alt=\"Polish\" style=\"width: 18px;\">\r\n                  <span class=\"light-blue-text text-darken-4\">&nbsp;PL</span>\r\n                </a>\r\n              </li>\r\n              <li *ngIf=\"language!='Pt'\">\r\n                <a class=\"cursor-pointer\" (click)=\"ChangeCurrentLanguage('pt')\">\r\n                  <img src=\"" + __webpack_require__(627) + "\" alt=\"Portuguese\" style=\"width: 18px;\">\r\n                  <span class=\"light-blue-text text-darken-4\">&nbsp;PT</span>\r\n                </a>\r\n              </li>\r\n            </ul>\r\n          </li>\r\n          <li class=\"dropdown user user-menu\" [ngClass]=\"{'active': selectedMenu == urlDriverUpdate}\" dropdown>\r\n            <a dropdownToggle class=\"dropdown-toggle user-admin-ex-width cursor-pointer\" data-toggle=\"dropdown\">\r\n              <i class=\"fa fa-user fa-fw\"></i> <span style=\"word-wrap: break-word;word-break: break-word;\"><strong>{{firstName}} {{ middleName }} {{lastName}}</strong> </span>\r\n              <span style=\"margin-left:10px;\"><i class=\"fa fa-angle-down\" aria-hidden=\"true\"></i></span>\r\n            </a>\r\n            <ul dropdownMenu class=\"dropdown-menu\" style=\"width: auto;\">\r\n              <li>\r\n                <a class=\"cursor-pointer\" [routerLink]=\"[urlDriverUpdate] \">{{'LblProfile' | translate }}</a>\r\n              </li>\r\n              <li>\r\n                <a class=\"cursor-pointer\" [routerLink]=\"[urlTAndCActivityLog] \">{{'LblTermsAndCondition' | translate }}</a>\r\n              </li>\r\n              <li>\r\n                <a class=\"cursor-pointer \" (click)=\"Logout() \">{{'LblSignOut' | translate }}</a>\r\n              </li>\r\n            </ul>\r\n          </li>\r\n        </ul>\r\n      </div>\r\n      <!-- /.navbar-collapse -->\r\n    </div>\r\n    <!-- /.container-fluid -->\r\n  </nav>\r\n</div>";

/***/ },
/* 621 */,
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/usa.feb6d1fda1963d1bafc6f7f3e3e1e90e.png";

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/dutch.2c1cf6e144a8264b88777bf738ba9cf1.png";

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/french.7a3a86e2d5b131c3c399bf050b12c309.png";

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/german.c90a449dc2dacaca7dc0394b2ee01067.png";

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/polish.232f6848ed2ed6df8c412778c954a941.png";

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/Portugese.dbc7d83b31b4c7978e97c6fb2b7284c0.png";

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var config_1 = __webpack_require__(60);
	var core_1 = __webpack_require__(3);
	var DriverFooterComponent = (function () {
	    function DriverFooterComponent() {
	    }
	    DriverFooterComponent.prototype.ngOnInit = function () {
	        this.versionNumber = config_1.WeGoConfig.APP_VERSION;
	        this.copyRightYear = (new Date()).getFullYear();
	    };
	    DriverFooterComponent.prototype.ngOnDestroy = function () {
	    };
	    DriverFooterComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-driver-footer',
	            template: __webpack_require__(629),
	        }), 
	        __metadata('design:paramtypes', [])
	    ], DriverFooterComponent);
	    return DriverFooterComponent;
	}());
	exports.DriverFooterComponent = DriverFooterComponent;


/***/ },
/* 629 */
/***/ function(module, exports) {

	module.exports = "<footer>\r\n  <div class=\"pull-right\">\r\n    <strong>{{ versionNumber }}</strong>\r\n  </div>\r\n  <strong>Copyright © {{copyRightYear}}  <a href=\"http://wegocarsharing.com/\" target=\"_blank\"> wegocarsharing.com </a></strong> All rights reserved.\r\n</footer>\n";

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var index_1 = __webpack_require__(631);
	var PersonProfileSuccessComponent = (function () {
	    function PersonProfileSuccessComponent(translate) {
	        this.translate = translate;
	    }
	    PersonProfileSuccessComponent.prototype.ngOnInit = function () {
	        this.translate.setDetectedLang();
	    };
	    PersonProfileSuccessComponent.prototype.ngOnDestroy = function () {
	        console.log("ngOnDestroy");
	    };
	    PersonProfileSuccessComponent = __decorate([
	        core_1.Component({
	            selector: "wego-personprofile-success",
	            template: __webpack_require__(633),
	            styles: [
	                ".headerror {\n                font-size: 150px !important;\n                font-weight: normal;\n                line-height: 100px;\n                margin-top: 50px;\n                color: #2ba2aa;\n          }"
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof index_1.TranslateService !== 'undefined' && index_1.TranslateService) === 'function' && _a) || Object])
	    ], PersonProfileSuccessComponent);
	    return PersonProfileSuccessComponent;
	    var _a;
	}());
	exports.PersonProfileSuccessComponent = PersonProfileSuccessComponent;


/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(70));
	__export(__webpack_require__(71));
	__export(__webpack_require__(632));


/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	// app/translate/translate.pipe.ts
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var translate_1 = __webpack_require__(631); // our translate service
	var TranslatePipe = (function () {
	    function TranslatePipe(_translate) {
	        this._translate = _translate;
	    }
	    TranslatePipe.prototype.transform = function (value, args) {
	        if (!value)
	            return;
	        return this._translate.instant(value, args);
	    };
	    TranslatePipe = __decorate([
	        // our translate service
	        core_1.Pipe({
	            name: 'translate',
	            pure: false // impure pipe, update value when we change language
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof translate_1.TranslateService !== 'undefined' && translate_1.TranslateService) === 'function' && _a) || Object])
	    ], TranslatePipe);
	    return TranslatePipe;
	    var _a;
	}());
	exports.TranslatePipe = TranslatePipe;


/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<section class=\"login-bg\">\r\n  <div class=\"wrapper\" style=\"background-color: transparent;\">\r\n    <div class=\"container\" style=\"margin-top:120px\">\r\n      <div class=\"row\">\r\n        <div class=\"col-sm-5 login-center\">\r\n          <div class=\"login-panel panel-default\">\r\n            <div>\r\n              <fieldset>\r\n                <div class=\"row\">\r\n                  <div class=\"center-block\">\r\n                    <img src=\"" + __webpack_require__(634) + "\" alt=\"\" class=\"img-responsive login-profile-img\">\r\n                    <h1 class=\"text-center login-text\" style=\"color:#fff;\">{{ 'LblSuccess' | translate }}</h1>\r\n                  </div>\r\n                </div>\r\n                <div class=\"row\">\r\n                  <div class=\"col-sm-12 col-md-10  col-md-offset-1 \">\r\n                    <div class=\"form-group\">\r\n                      <p style=\"color: white; padding: 5px;font-size:medium\" class=\"text-center\">\r\n                        {{ 'LblPersonProfileSuccessMessage' | translate }}\r\n                        <br/> {{ 'LblPlease' | translate }}\r\n                        <a routerLink=\"/\" style=\"color:#FF9933\"> {{ 'LblLogin' | translate }}</a> {{ 'LblHere' | translate }}.\r\n                      </p>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </fieldset>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>";

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/login-logo-icon.38534e5a790f3c6946f7aef526c2fba2.png";

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var PersonProfileFailurComponent = (function () {
	    function PersonProfileFailurComponent() {
	    }
	    PersonProfileFailurComponent.prototype.ngOnInit = function () {
	    };
	    PersonProfileFailurComponent.prototype.ngOnDestroy = function () { console.log('ngOnDestroy'); };
	    PersonProfileFailurComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-personprofile-failure',
	            template: "\n  <section class=\"content\">\n\t\t<div class=\"col-md-12 text-center\">\n        <p class=\"headerror\"> 404</p>\n          <h3><i class=\"fa fa-warning text-yellow\"></i> Oops! Link Expired.</h3>\n          <p>\n            This invite URL is  not valid anymore or expired.\n          </p>\n        Please  <a routerLink=\"/\">Login</a> here.\n\t\t</div>\n  </section>\n  ",
	            styles: [".headerror {\n                font-size: 150px !important;\n                font-weight: normal;\n                line-height: 100px;\n                margin-top: 50px;\n                color: #2ba2aa;\n          }"]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], PersonProfileFailurComponent);
	    return PersonProfileFailurComponent;
	}());
	exports.PersonProfileFailurComponent = PersonProfileFailurComponent;


/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var personprofile_model_1 = __webpack_require__(637);
	var personprofile_service_1 = __webpack_require__(638);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var flatpickr_model_1 = __webpack_require__(83);
	var terms_condition_popup_service_1 = __webpack_require__(639);
	var privacy_popup_service_1 = __webpack_require__(640);
	var PersonProfile = (function () {
	    function PersonProfile(personService, activeRoute, router, authService, translate, termsConditionPopup) {
	        this.personService = personService;
	        this.activeRoute = activeRoute;
	        this.router = router;
	        this.authService = authService;
	        this.translate = translate;
	        this.termsConditionPopup = termsConditionPopup;
	        this.allTNCList = [];
	        this.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_FORMAT;
	        this.submitted = false;
	        this.selectedInstance = "";
	        this.isDateOfBirth = false;
	        this.isLoading = false;
	    }
	    PersonProfile.prototype.ngOnInit = function () {
	        var _this = this;
	        // this.translate.setDetectedLang();
	        this.flatPickrConfigDateOfBirth = this.SetDefaultFlatPickrConfig();
	        this.model = new personprofile_model_1.PersonProfileModel();
	        this.GetTelephoneCountry();
	        this.sub = this.activeRoute.params.subscribe(function (params) {
	            _this.isEditMode = false;
	            _this.personHashId = params["activationCode"] || "";
	            if (_this.personHashId != "") {
	                _this.isLoading = true;
	                _this.isEditMode = true;
	                _this.personService
	                    .GetPersonByActivationCode(_this.personHashId)
	                    .subscribe(function (res) {
	                    if (!res.data) {
	                        _this.router.navigate(["/Linkexpired"]);
	                        _this.isDateOfBirth =
	                            _this.model.dateOfBirth != "" ? true : false;
	                    }
	                    _this.model = res.data;
	                    localStorage.setItem("language", _this.model.instanceLanguage);
	                    _this.translate.setDetectedLang();
	                    if (_this.model.liceanceNumberValidated) {
	                        _this.flatPickrConfigDateOfBirth.clickOpens = false;
	                    }
	                    ChangeBranding(res.data.personMasterHashId, "ADMIN");
	                    _this.isLoading = false;
	                }, function (error) {
	                    _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	                    _this.message = error;
	                    _this.isLoading = false;
	                });
	            }
	        });
	        this.GetTermsConditionByPersonActivationCode(this.personHashId);
	        this.GetPrivacyByPersonActivationCode(this.personHashId);
	        this.GetPersonCountry();
	    };
	    PersonProfile.prototype.SetDefaultFlatPickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = false;
	        flatPickrConfig.time_24hr = false;
	        flatPickrConfig.dateFormat = this.dateFormat;
	        flatPickrConfig.minuteIncrement = 1;
	        flatPickrConfig.maxDate = new Date();
	        return flatPickrConfig;
	    };
	    PersonProfile.prototype.onSubmit = function (forms) {
	        this.submitted = true;
	        this.UpdatePersonProfile();
	    };
	    PersonProfile.prototype.GetPersonCountry = function () {
	        var _this = this;
	        this.authService.GetPersonCountry()
	            .subscribe(function (res) {
	            _this.personCountryList = res.data;
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    PersonProfile.prototype.UpdatePersonProfile = function () {
	        var _this = this;
	        this.model.termsAndConditionsHashId = this.termsAndConditionHashId;
	        this.model.privacyHashId = this.privacyHashId;
	        this.model.allTermsConditionsList = this.allTNCList;
	        this.personService.UpdatePersonProfile(this.model).subscribe(function (res) {
	            if (res.data) {
	                window.location.href = config_1.WeGoConfig.CONFIRMED_URL;
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    PersonProfile.prototype.GetTelephoneCountry = function () {
	        var _this = this;
	        this.authService.GetTelephoneCountry().subscribe(function (res) {
	            _this.countryList = res.data;
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    PersonProfile.prototype.GetTermsConditionByPersonActivationCode = function (personActivationCode) {
	        var _this = this;
	        this.termsConditionPopup
	            .GetTermsAndConditionsByPersonActivationCode(personActivationCode)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.allTNCList = res.data;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    PersonProfile.prototype.GetPrivacyByPersonActivationCode = function (personActivationCode) {
	        var _this = this;
	        this.termsConditionPopup
	            .GetPrivacyByPersonActivationCode(personActivationCode)
	            .subscribe(function (res) {
	            if (res.data && res.data.content) {
	                _this.privacyBodyHTMLText = res.data.content;
	                if (res.data.content) {
	                    _this.isPrivacyBodyContent = true;
	                }
	                _this.privacyHashId = res.data.termsAndConditionsHashId;
	            }
	            else {
	                _this.errorMessage = res.error;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    PersonProfile.prototype.showTnC = function (bodyHTMLText) {
	        this.termsConditionModel.show(bodyHTMLText);
	    };
	    PersonProfile.prototype.showPrivacyStatement = function () {
	        this.privacyModel.show(this.privacyBodyHTMLText);
	    };
	    PersonProfile.prototype.ngOnDestroy = function () {
	        ChangeBranding();
	        if (this.sub) {
	            this.sub.unsubscribe();
	        }
	    };
	    __decorate([
	        core_1.ViewChild("childModal"), 
	        __metadata('design:type', Object)
	    ], PersonProfile.prototype, "childModal", void 0);
	    __decorate([
	        core_1.ViewChild("termsConditionModel"), 
	        __metadata('design:type', Object)
	    ], PersonProfile.prototype, "termsConditionModel", void 0);
	    __decorate([
	        core_1.ViewChild("privayStatementModel"), 
	        __metadata('design:type', Object)
	    ], PersonProfile.prototype, "privacyModel", void 0);
	    PersonProfile = __decorate([
	        core_1.Component({
	            selector: "wego-perosn",
	            template: __webpack_require__(641),
	            providers: [personprofile_service_1.PersonProfileService, terms_condition_popup_service_1.TermsConditionPopup, privacy_popup_service_1.PrivacyStatementPopup],
	            styles: [
	                "\n      .main-header {\n        margin-top: 0px !important;\n      }\n      .input-group.telephone-group .input-group-addon {\n        padding: 0px;\n        border: 0px;\n      }\n      .country-select {\n        width: 60px;\n        border: 1px solid #d2d6de;\n        padding: 3px;\n      }\n    "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof personprofile_service_1.PersonProfileService !== 'undefined' && personprofile_service_1.PersonProfileService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _d) || Object, (typeof (_e = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _e) || Object, (typeof (_f = typeof terms_condition_popup_service_1.TermsConditionPopup !== 'undefined' && terms_condition_popup_service_1.TermsConditionPopup) === 'function' && _f) || Object])
	    ], PersonProfile);
	    return PersonProfile;
	    var _a, _b, _c, _d, _e, _f;
	}());
	exports.PersonProfile = PersonProfile;


/***/ },
/* 637 */
/***/ function(module, exports) {

	"use strict";
	var PersonProfileModel = (function () {
	    function PersonProfileModel() {
	        this.countryCode1 = "";
	        this.countryCode2 = "";
	        this.validateLiceanceNumber = false;
	        this.isAccepted = false;
	        this.isPrivacyStatementAccepted = false;
	        this.allTermsConditionsList = [];
	        this.isnifEnabled = false;
	        this.personHomeAddressModel = new PersonProfileAddressModel();
	        this.personWorkAddressModel = new PersonProfileAddressModel();
	        this.emailAddressModel = new EmailAddressModel();
	        this.allTermsConditionsList = [];
	    }
	    return PersonProfileModel;
	}());
	exports.PersonProfileModel = PersonProfileModel;
	var EmailAddressModel = (function () {
	    function EmailAddressModel() {
	    }
	    return EmailAddressModel;
	}());
	exports.EmailAddressModel = EmailAddressModel;
	var PersonProfileAddressModel = (function () {
	    function PersonProfileAddressModel() {
	    }
	    return PersonProfileAddressModel;
	}());
	exports.PersonProfileAddressModel = PersonProfileAddressModel;


/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var PersonProfileService = (function () {
	    function PersonProfileService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    PersonProfileService.prototype.GetPersonByActivationCode = function (activationCode) {
	        var getPersonUrl = config_1.WeGoConfig.API_GET_PERSONPROFILE_BY_ACTIVATION_CODE + "?activationCode=" + activationCode;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getPersonUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    PersonProfileService.prototype.UpdatePersonProfile = function (personModel) {
	        var body = personModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_POST_PERSONPROFILE_DETAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    PersonProfileService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], PersonProfileService);
	    return PersonProfileService;
	    var _a, _b;
	}());
	exports.PersonProfileService = PersonProfileService;


/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var config_1 = __webpack_require__(60);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var enum_helper_1 = __webpack_require__(578);
	var TermsConditionPopup = (function () {
	    function TermsConditionPopup(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    TermsConditionPopup.prototype.GetTermsAndConditionsByIntanceHashId = function (instanceHashID) {
	        var getTermsConditionDetail = config_1.WeGoConfig.API_GET_TERMSANDCONDITION_BYINSTANCEHASH + "?instanceHashId=" + instanceHashID;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getTermsConditionDetail, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    TermsConditionPopup.prototype.GetTermsAndConditionsByActivationCode = function (activationCode) {
	        var getTermsConditionDetail = config_1.WeGoConfig.API_GET_TERMSANDCONDITION_BYACTIVATIONCODE + "?activationCode=" + activationCode;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getTermsConditionDetail, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    TermsConditionPopup.prototype.GetPrivacyStatementsByActivationCode = function (activationCode) {
	        var getTermsConditionDetail = config_1.WeGoConfig.API_GET_PRIVACYSTATEMENT_BYACTIVATIONCODE + "?activationCode=" + activationCode;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getTermsConditionDetail, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    TermsConditionPopup.prototype.GetTermsAndConditionsByPersonActivationCode = function (personActivationCode) {
	        var getTermsConditionDetail = config_1.WeGoConfig.API_GET_TERMSANDCONDITION_BYPERSONACTIVATIONCODE + "?personActivationCode=" + personActivationCode;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getTermsConditionDetail, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    TermsConditionPopup.prototype.GetPrivacyByPersonActivationCode = function (personActivationCode) {
	        var getTermsConditionDetail = config_1.WeGoConfig.API_GET_PRIVACYSTATEMENT_BYPERSONACTIVATIONCODE + "?personActivationCode=" + personActivationCode;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getTermsConditionDetail, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    TermsConditionPopup.prototype.GetTermsAndConditionsBySignupFormParam = function (signupFormParam) {
	        var getTermsConditionDetail = config_1.WeGoConfig.API_GET_TERMSANDCONDITION_BYSIGNUPPARAM + "?signupFormParam=" + signupFormParam + "&type=T&C";
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getTermsConditionDetail, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    TermsConditionPopup.prototype.UpdateTermsAndConditionsActivityLog = function (model) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_POST_TERMSANDCONDITION_ACTIVITYLOG, model, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    TermsConditionPopup.prototype.ActionOnAccountActivationTermsCondition = function (tncHashId, action, bookingHashId, ctgHashId, acceptanceMoment) {
	        if (bookingHashId === void 0) { bookingHashId = ''; }
	        if (ctgHashId === void 0) { ctgHashId = ''; }
	        if (acceptanceMoment === void 0) { acceptanceMoment = [enum_helper_1.TNCAcceptanceMoment.ACCOUNT_ACTIVATION]; }
	        var headers = this.authService.GetHeader();
	        var queryString = '';
	        acceptanceMoment.forEach(function (element) {
	            queryString += "&acceptanceMoment=" + element;
	        });
	        var getUrl = config_1.WeGoConfig.API_GET_ACTION_ON_ACCOUNT_ACTIVATION_TERMS_CONDITION +
	            '?' + 'tncHashId=' +
	            tncHashId +
	            '&action=' +
	            action +
	            '&bookingHashId=' +
	            bookingHashId +
	            '&ctgHashId=' +
	            ctgHashId;
	        getUrl = getUrl + queryString;
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    TermsConditionPopup.prototype.GetTermsAndConditionsActivityByHashId = function (termsAndConditionsActivityHashId) {
	        var getUrl = config_1.WeGoConfig.API_GET_TERMSANDCONDITIONS_ACTIVITY_BY_HASH + "?termsAndConditionActivityHashId=" + termsAndConditionsActivityHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    TermsConditionPopup.prototype.RevokeTermsAndConditions = function (termsAndConditionsActivityHashId) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_REVOKE_TERMSANDCONDITIONS + "?termsAndConditionsActivityHashId= " + termsAndConditionsActivityHashId, "", options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    TermsConditionPopup.prototype.GetTermsConditionForDriver = function (acceptanceMoment, bookingHashId, ctgHashId) {
	        if (bookingHashId === void 0) { bookingHashId = ''; }
	        if (ctgHashId === void 0) { ctgHashId = ''; }
	        var getTermsConditionDetail = config_1.WeGoConfig.API_GET_TERMSANDCONDITION_FOR_DRIVER + "?" + "bookingHashId=" + bookingHashId + "&ctgHashId=" + ctgHashId;
	        var queryString = '';
	        acceptanceMoment.forEach(function (element) {
	            queryString += "&acceptanceMoment=" + element;
	        });
	        getTermsConditionDetail = getTermsConditionDetail + queryString;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getTermsConditionDetail, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    TermsConditionPopup = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], TermsConditionPopup);
	    return TermsConditionPopup;
	    var _a, _b;
	}());
	exports.TermsConditionPopup = TermsConditionPopup;


/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var config_1 = __webpack_require__(60);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var PrivacyStatementPopup = (function () {
	    function PrivacyStatementPopup(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    PrivacyStatementPopup.prototype.GetPrivacyBySignUpFormParam = function (signupFormParam) {
	        var getPrivacyDetail = config_1.WeGoConfig.API_GET_PRIVACYSTATEMENTS_BYSIGNUPPARAM + "?signupFormParam=" + signupFormParam + "&type=Privacy";
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getPrivacyDetail, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    PrivacyStatementPopup.prototype.ActionOnAccountActivationTermsCondition = function (tncHashId, action) {
	        var headers = this.authService.GetHeader();
	        var getUrl = config_1.WeGoConfig.API_GET_ACTION_ON_ACCOUNT_ACTIVATION_TERMS_CONDITION +
	            '?tncHashId=' +
	            tncHashId +
	            '&action=' +
	            action;
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    PrivacyStatementPopup = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], PrivacyStatementPopup);
	    return PrivacyStatementPopup;
	    var _a, _b;
	}());
	exports.PrivacyStatementPopup = PrivacyStatementPopup;


/***/ },
/* 641 */
/***/ function(module, exports) {

	module.exports = "<div class=\"no-role\">\r\n  <div class=\"ui-skins sidebar-mini\">\r\n    <header class=\"main-header\">\r\n      <!-- Logo -->\r\n      <a href=\"javascript:void(0)\" class=\"logo\">\r\n        <!-- mini logo for sidebar mini 50x50 pixels -->\r\n        <div class=\"logo-mini\"></div>\r\n        <!-- logo for regular state and mobile devices -->\r\n        <div class=\"logo-lg\"></div>\r\n      </a>\r\n      <nav class=\"navbar navbar-static-top\">\r\n      </nav>\r\n    </header>\r\n    <div class=\"container\" style=\"margin-top: 60px;\">\r\n      <fieldset>\r\n        <section class=\"content\">\r\n          <p class=\"text-success\">{{ message }}</p>\r\n          <div class=\"nopad\">\r\n            <form (ngSubmit)=\"onSubmit(UpdatePersonProfile.value)\" #UpdatePersonProfile=\"ngForm\">\r\n              <input type=\"hidden\" class=\"form-control\" [(ngModel)]=\"model.personMasterHashId\" name=\"personMasterHashId\">\r\n              <input type=\"hidden\" class=\"form-control\" [(ngModel)]=\"model.isActive\" name=\"isActive\">\r\n\r\n              <div class=\"form-group col-md-4\">\r\n                <label>\r\n                  <span class=\"text text-danger\">*</span>{{ 'LblUserName' | translate }}\r\n                </label>\r\n                <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblUserName' | translate }}\" [ngModel]=\"model.userName\" name=\"UserName\"\r\n                  maxlength=\"100\" readonly>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'userName' }}</span>\r\n              </div>\r\n\r\n\r\n              <div class=\"form-group col-md-4\">\r\n                <label>\r\n                  <span class=\"text text-danger\">*</span>{{ 'LblPassword' | translate }}\r\n                </label>\r\n                <input type=\"password\" class=\"form-control\" placeholder=\"{{ 'LblPassword' | translate }}\" [(ngModel)]=\"model.personPassword\"\r\n                  name=\"PersonPassword\" maxlength=\"100\">\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'personPassword' }}</span>\r\n              </div>\r\n\r\n\r\n              <div class=\"form-group col-md-4\">\r\n                <label>\r\n                  <span class=\"text text-danger\">*</span>{{ 'LblConfirmPassword' | translate }}\r\n                </label>\r\n                <input type=\"password\" class=\"form-control\" placeholder=\"{{ 'LblConfirmPassword' | translate }}\" [(ngModel)]=\"model.personConfirmPassword\"\r\n                  name=\"PersonConfirmPassword\" maxlength=\"100\">\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'personConfirmPassword' }}</span>\r\n              </div>\r\n\r\n              <div class=\"clearfix\"></div>\r\n              <div *ngIf=\"!model.driverExternalId\">\r\n                <div class=\"form-group col-md-4\">\r\n                  <label>\r\n                    <span class=\"text text-danger\">*</span>{{ 'LblFirstName' | translate }}\r\n                  </label>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblFirstName' | translate }}\" [(ngModel)]=\"model.firstName\" name=\"FirstName\"\r\n                    maxlength=\"100\">\r\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'firstName' }}</span>\r\n                </div>\r\n\r\n                <div class=\"form-group col-md-4\">\r\n                  <label>\r\n                    <span class=\"text text-danger\"></span>{{ 'LblMiddleName' | translate }}\r\n                  </label>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblMiddleName' | translate }}\" [(ngModel)]=\"model.middleName\" name=\"MiddleName\"\r\n                    maxlength=\"100\">\r\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'middleName' }}</span>\r\n                </div>\r\n\r\n                <div class=\"form-group col-md-4\">\r\n                  <label>\r\n                    <span class=\"text text-danger\">*</span>{{ 'LblLastName' | translate }}\r\n                  </label>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblLastName' | translate }}\" [(ngModel)]=\"model.lastName\" name=\"LastName\"\r\n                    maxlength=\"100\">\r\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'lastName' }}</span>\r\n                </div>\r\n                <div class=\"clearfix\"></div>\r\n\r\n                <div class=\"form-group col-md-4\">\r\n                  <label>\r\n                    <span class=\"text text-danger\">*</span>{{ 'LblEmail' | translate }}\r\n                  </label>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblEmail' | translate }}\" [(ngModel)]=\"model.emailAddressModel.email\"\r\n                    name=\"Email\" maxlength=\"100\">\r\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'emailAddressModel.email' }}</span>\r\n                </div>\r\n\r\n                <div class=\"form-group col-md-4\">\r\n                  <label>\r\n                    <span class=\"text text-danger\">*</span>  {{ 'LblCountry' | translate }}\r\n                  </label>\r\n                  <div class=\"form-group inline\">\r\n                    <select name=\"model.countryCodeHashId\" [(ngModel)]=\"model.countryCodeHashId\" class=\"form-control inline\">\r\n                      <option *ngFor=\"let item of personCountryList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\r\n                    </select>\r\n                    <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'countryCode' }}</span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"clearfix\"></div>\r\n                <div class=\"form-group col-md-4\">\r\n                  <label>\r\n                    <span class=\"text text-danger\">*</span>{{ 'LblMobileNumber' | translate }}\r\n                  </label>\r\n                  <div class=\"input-group telephone-group\">\r\n                    <span class=\"input-group-addon\">\r\n                      <select [(ngModel)]=\"model.countryCode1\" class=\"form-control country-select\" name=\"countryCode1\">\r\n                        <option value=\"\">-</option>\r\n                        <option *ngFor=\"let item of countryList\" [ngValue]=\"item.value\">{{ item.value }}</option>\r\n                      </select>\r\n                    </span>\r\n                    <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblMobileNumber' | translate }}\" [(ngModel)]=\"model.telephone1\"\r\n                      name=\"telephone1\" maxlength=\"20\">\r\n                  </div>\r\n                  <div class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'countryCode1' }}</div>\r\n                  <div class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'telephone1' }}</div>\r\n                </div>\r\n\r\n                <div class=\"form-group col-md-4\">\r\n                  <label>\r\n                    {{ 'LblPhoneNumber' | translate }}\r\n                  </label>\r\n                  <div class=\"input-group telephone-group\">\r\n                    <span class=\"input-group-addon\">\r\n                      <select [(ngModel)]=\"model.countryCode2\" class=\"form-control country-select\" name=\"countryCode2\">\r\n                        <option value=\"\">-</option>\r\n                        <option *ngFor=\"let item of countryList\" [ngValue]=\"item.value\">{{ item.value }}</option>\r\n                      </select>\r\n                    </span>\r\n                    <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblPhoneNumber' | translate }}\" [(ngModel)]=\"model.telephone2\" name=\"telephone2\"\r\n                      maxlength=\"20\">\r\n                  </div>\r\n                  <div class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'countryCode2' }}</div>\r\n                  <div class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'telephone2' }}</div>\r\n                </div>\r\n                <div class=\"clearfix\"></div>\r\n                <div class=\"form-group col-md-4\" *ngIf=\"model.isnifEnabled\">\r\n                  <label>\r\n                    {{ 'LblNIFNumber' | translate }}\r\n                  </label>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblNIFNumber' | translate }}\" [(ngModel)]=\"model.nifNumber\" name=\"nifNumber\"\r\n                    maxlength=\"9\">\r\n                  <div class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'nIFNumber' }}</div>\r\n                </div>\r\n                <div class=\"clearfix\"></div>\r\n                <div *ngIf=\"model.validateLiceanceNumber\" class=\"form-group col-md-4\">\r\n                  <label>\r\n                    <span class=\"text text-danger\">*</span> {{ 'LblDateOfBirth' | translate }}</label>\r\n                  <div class=\"input-group\">\r\n                    <span class=\"input-group-addon\">\r\n                      <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n                    </span>\r\n                    <input [disabled]=\"isDateOfBirth\" class=\"form-control\" [Config]=\"flatPickrConfigDateOfBirth\" placeholder=\"{{ 'LblDateOfBirth' | translate }}\"\r\n                      [(ngModel)]=\"model.dateOfBirth\" name=\"dateOfBirth\" flatpickr readonly>\r\n                  </div>\r\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'dateOfBirth' }}</span>\r\n                </div>\r\n                <div *ngIf=\"model.validateLiceanceNumber\" class=\"form-group col-md-4\">\r\n                  <label>\r\n                    <span class=\"text text-danger\">*</span> {{ 'LblDriverLicenceNumber' | translate }}\r\n                  </label>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblDriverLicenceNumber' | translate }}\" [(ngModel)]=\"model.driverLicenceNumber\"\r\n                    name=\"driverLicenceNumber\" maxlength=\"20\" [attr.readonly]=\"!model.liceanceNumberValidated?null:''\">\r\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'driverLicenceNumber' }}</span>\r\n                </div>\r\n                <div class=\"clearfix\"></div>\r\n                <div class=\"row col-md-12\">\r\n                  <fieldset class=\"col-md-12\">\r\n                    <legend class=\"legendStyle\">\r\n                      {{ 'LblHomeAddress' | translate }}\r\n                    </legend>\r\n                    <div class=\"clearfix\"></div>\r\n                    <div class=\"form-group col-md-4\">\r\n                      <label>{{ 'LblStreetName' | translate }}</label>\r\n                      <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblStreetName' | translate }}\" [(ngModel)]=\"model.personHomeAddressModel.street\"\r\n                        name=\"personHomeAddressModel.street\" maxlength=\"100\">\r\n                      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'personHomeAddressModel.street' }}</span>\r\n                    </div>\r\n                    <div class=\"form-group col-md-4\">\r\n                      <label>{{ 'LblHouseNo' | translate }}</label>\r\n                      <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblHouseNo' | translate }}\" [(ngModel)]=\"model.personHomeAddressModel.houseNo\"\r\n                        name=\"personHomeAddressModel.houseNo\" maxlength=\"15\">\r\n                      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'personHomeAddressModel.houseNo' }}</span>\r\n                    </div>\r\n                    <div class=\"form-group col-md-4\">\r\n                      <label>{{ 'LblHouseExtention' | translate }}</label>\r\n                      <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblHouseExtention' | translate }}\" [(ngModel)]=\"model.personHomeAddressModel.houseExtention\"\r\n                        name=\"personHomeAddressModel.houseExtention\" maxlength=\"25\">\r\n                      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'personHomeAddressModel.houseExtention' }}</span>\r\n                    </div>\r\n                    <div class=\"clearfix\"></div>\r\n                    <div class=\"form-group col-md-4\">\r\n                      <label>{{ 'LblZipCode' | translate }}</label>\r\n                      <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblZipCode' | translate }}\" [(ngModel)]=\"model.personHomeAddressModel.zipCode\"\r\n                        name=\"personHomeAddressModel.zipCode\" maxlength=\"10\">\r\n                      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'personHomeAddressModel.zipCode' }}</span>\r\n                    </div>\r\n                    <div class=\"form-group col-md-4\">\r\n                      <label>{{ 'LblCity' | translate }}</label>\r\n                      <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblCity' | translate }}\" [(ngModel)]=\"model.personHomeAddressModel.city\"\r\n                        name=\"personHomeAddressModel.city\" maxlength=\"50\">\r\n                      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'personHomeAddressModel.city' }}</span>\r\n                    </div>\r\n                  </fieldset>\r\n                </div>\r\n                <div class=\"clearfix\"></div>\r\n              </div>\r\n              <!-- <div class=\"form-group col-md-4 checkbox\" *ngIf=\"isBodyContent\">\r\n                <span class=\"text text-danger\">*</span>\r\n                <label>\r\n                  <input type=\"checkbox\" name=\"model.isAccepted\" [(ngModel)]=\"model.isAccepted\">{{ 'LblReadAndAgree' | translate }}\r\n                </label>\r\n                <a class=\"cursor-pointer\" (click)=\"showTnC()\">{{ 'LblTermsAndCondition' | translate }}</a>\r\n                <br/>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'isAccepted' }}</span>\r\n              </div> -->\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'termsConditionError' }}</span>\r\n              <div *ngFor=\"let item of allTNCList\" class=\"row no-margin\">\r\n                <div class=\"col-md-12 form-group checkbox\">\r\n                  <span class=\"text text-danger\">*</span>\r\n                  <label>\r\n                    <input type=\"checkbox\" name=\"item.termsAndConditionHashId\" [(ngModel)]=\"item.accepted\">{{ 'LblReadAndAgree' | translate }}\r\n                  </label>\r\n                  <a class=\"cursor-pointer\" (click)=\"showTnC(item.content)\">{{ 'LblTermsAndCondition' | translate }}\r\n                    <span *ngIf=\"item.entityName\">({{ item.entityName }})</span>\r\n                  </a>\r\n                </div>\r\n              </div>\r\n              <div class=\"clearfix\"></div>\r\n              <div class=\"row no-margin\">\r\n                <div class=\"form-group col-md-4 checkbox\" *ngIf=\"isPrivacyBodyContent\">\r\n                  <span class=\"text text-danger\">*</span>\r\n                  <label>\r\n                    <input type=\"checkbox\" name=\"model.isPrivacyStatementAccepted\" [(ngModel)]=\"model.isPrivacyStatementAccepted\">{{ 'LblReadAndAgree' | translate }}\r\n                  </label>\r\n                  <a class=\"cursor-pointer\" (click)=\"showPrivacyStatement()\">{{ 'LblPrivacyStatements' | translate }}</a>\r\n                  <br/>\r\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'isPrivacyStatementAccepted' }}</span>\r\n                </div>\r\n              </div>\r\n              <div class=\"clearfix\"></div>\r\n              <div class=\"clearfix\"></div>\r\n              <div class=\"page-border-bottom mar_t_15\">Border bottom shadow</div>\r\n              <div class=\"clearfix\"></div>\r\n              <div class=\"container mar_t_25\">\r\n                <button class=\"btn btn-highlight mar_left_10\" type=\"submit\">{{ 'LblSave' | translate }}</button>\r\n              </div>\r\n            </form>\r\n          </div>\r\n        </section>\r\n      </fieldset>\r\n    </div>\r\n  </div>\r\n</div>\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n<wego-terms-condition-popup #termsConditionModel></wego-terms-condition-popup>\r\n<wego-privacy-popup #privayStatementModel></wego-privacy-popup>";

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var UnderConstructionComponent = (function () {
	    function UnderConstructionComponent() {
	    }
	    UnderConstructionComponent.prototype.ngOnInit = function () { };
	    UnderConstructionComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-underconstruction',
	            template: "\n  <section class=\"content\">\n\t\t<div class=\"col-md-12 text-center\">\n        <p class=\"headerror\"> 500</p>\n          <h3><i class=\"fa fa-warning text-danger\"></i> Oops! Page is Under Construction.</h3>\n          <p>\n            Please try after some time.\n          </p>\n\t\t</div>\n  </section>\n  ",
	            styles: [".headerror {\n                font-size: 150px !important;\n                font-weight: normal;\n                line-height: 100px;\n                margin-top: 50px;\n                color: #2ba2aa;\n          }"]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], UnderConstructionComponent);
	    return UnderConstructionComponent;
	}());
	exports.UnderConstructionComponent = UnderConstructionComponent;


/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var LinkExpiredComponent = (function () {
	    function LinkExpiredComponent() {
	    }
	    LinkExpiredComponent.prototype.ngOnInit = function () {
	    };
	    LinkExpiredComponent.prototype.ngOnDestroy = function () { console.log('ngOnDestroy'); };
	    LinkExpiredComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-personprofile-failure',
	            template: "\n  <section class=\"content\">\n\t\t<div class=\"col-md-12 text-center\">\n      <div class=\"panel panel-danger\">\n      <div class=\"panel-heading\">\n      {{ 'LblLinkExpired' | translate }}\n      </div>\n      <div class=\"panel-body\"><p>\n      {{ 'LblLinkExpiredMessage' | translate }}\n                 <a routerLink=\"/\">{{ 'LblHome' | translate }}</a> \n          </p></div>\n    </div>\n         \n\t\t</div>\n  </section>\n  ",
	            styles: [".headerror {\n                font-size: 150px !important;\n                font-weight: normal;\n                line-height: 100px;\n                margin-top: 50px;\n                color: #2ba2aa;\n          }"]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], LinkExpiredComponent);
	    return LinkExpiredComponent;
	}());
	exports.LinkExpiredComponent = LinkExpiredComponent;


/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var translate_service_1 = __webpack_require__(70);
	var core_1 = __webpack_require__(3);
	var forgotpassword_model_1 = __webpack_require__(645);
	var forgotpassword_service_1 = __webpack_require__(646);
	var ForgotPasswordComponent = (function () {
	    function ForgotPasswordComponent(forgotpasswordService, translate, authService) {
	        this.forgotpasswordService = forgotpasswordService;
	        this.translate = translate;
	        this.authService = authService;
	    }
	    ForgotPasswordComponent.prototype.ngOnInit = function () {
	        this.translate.setDetectedLang();
	        this.model = new forgotpassword_model_1.ForgotPasswordModel();
	    };
	    ForgotPasswordComponent.prototype.onSubmit = function (forms) {
	        this.SubmitUser();
	    };
	    ForgotPasswordComponent.prototype.SubmitUser = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.forgotpasswordService.SubmitUser(this.model).subscribe(function (res) {
	            if (res.data) {
	                _this.message =
	                    "We have sent a password reset link to your registered email address.";
	                _this.isLoading = false;
	                _this.model = new forgotpassword_model_1.ForgotPasswordModel();
	            }
	            else if (res.data == "") {
	                _this.message = "Please Enter User Name";
	                _this.isLoading = false;
	            }
	            else {
	                _this.message = res.error;
	                _this.isLoading = false;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    ForgotPasswordComponent.prototype.ngOnDestroy = function () { };
	    ForgotPasswordComponent = __decorate([
	        core_1.Component({
	            selector: "wego-forgotpassword",
	            template: __webpack_require__(647),
	            providers: [forgotpassword_service_1.ForgotPasswordService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof forgotpassword_service_1.ForgotPasswordService !== 'undefined' && forgotpassword_service_1.ForgotPasswordService) === 'function' && _a) || Object, (typeof (_b = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object])
	    ], ForgotPasswordComponent);
	    return ForgotPasswordComponent;
	    var _a, _b, _c;
	}());
	exports.ForgotPasswordComponent = ForgotPasswordComponent;


/***/ },
/* 645 */
/***/ function(module, exports) {

	"use strict";
	var ForgotPasswordModel = (function () {
	    function ForgotPasswordModel() {
	    }
	    return ForgotPasswordModel;
	}());
	exports.ForgotPasswordModel = ForgotPasswordModel;


/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var ForgotPasswordService = (function () {
	    function ForgotPasswordService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    ForgotPasswordService.prototype.CheckActivationCode = function (activationCode) {
	        var getActivationUrl = config_1.WeGoConfig.API_GET_CHECKACTIVATIONCODE + "?activationCode=" + activationCode;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getActivationUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    ForgotPasswordService.prototype.SubmitUser = function (forgotpasswordModal) {
	        var body = forgotpasswordModal;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_POST_FORGOTPASSSWORD, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    ForgotPasswordService.prototype.SubmitChangePassword = function (forgotpasswordModal) {
	        var body = forgotpasswordModal;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_POST_CHANGEPASSSWORD, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    ForgotPasswordService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], ForgotPasswordService);
	    return ForgotPasswordService;
	    var _a, _b;
	}());
	exports.ForgotPasswordService = ForgotPasswordService;


/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<section class=\"login-bg\">\r\n  <div class=\"wrapper\" style=\"background-color: transparent;\">\r\n    <div class=\"container\" style=\"margin-top:120px\">\r\n      <div class=\"row\">\r\n        <div class=\"col-sm-5 login-center\">\r\n          <div class=\"login-panel panel-default\">\r\n            <div>\r\n              <form (ngSubmit)=\"onSubmit()\" #ForgotPasswordForm=\"ngForm\" method=\"post\">\r\n                <fieldset>\r\n                  <div class=\"row\">\r\n                    <div class=\"center-block\">\r\n                      <img src=\"" + __webpack_require__(634) + "\" alt=\"\" class=\"img-responsive login-profile-img\">\r\n                      <h1 class=\"text-center login-text\" style=\"color:#fff;\">Forgot Password</h1>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class=\"col-sm-12 col-md-10  col-md-offset-1 \">\r\n                      <div class=\"form-group\">\r\n                        <p *ngIf=\"message\" style=\"background-color: #eb4b4b; color: white; padding: 5px;\" class=\"text-center\">\r\n                          {{ message }}\r\n                        </p>\r\n                      </div>\r\n                      <div class=\"form-group\">\r\n                        <div class=\"input-group\">\r\n                          <span class=\"input-group-addon\">\r\n\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"fa fa-key fa-fw\" aria-hidden=\"true\"></i>\r\n\t\t\t\t\t\t\t\t\t\t\t\t</span>\r\n                          <input [(ngModel)]=\"model.userName\" class=\"login-form-control\" placeholder=\"User Name\" name=\"userName\" type=\"text\" autofocus>\r\n                        </div>\r\n                      </div>\r\n                      <div class=\"form-group\">\r\n                        <button type=\"submit\" class=\"btn btn-lg login-submit-button btn-block\" (ngSubmit)=\"onSubmit()\">Submit</button>\r\n                      </div>\r\n                      <div class=\"form-group\">\r\n                        <a routerLink=\"/\" routerLinkActive=\"active\" style=\"text-align: center\">Back to Home</a>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </fieldset>\r\n              </form>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>";

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var ChangePasswordSuccessComponent = (function () {
	    function ChangePasswordSuccessComponent() {
	    }
	    ChangePasswordSuccessComponent.prototype.ngOnInit = function () {
	        var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
	        if (isMobile) {
	            // Redirect to deep link for mobile app
	            window.location.href = 'wego://carsharing/';
	        }
	    };
	    ChangePasswordSuccessComponent.prototype.ngOnDestroy = function () { console.log('ngOnDestroy'); };
	    ChangePasswordSuccessComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-forgotpassword',
	            template: __webpack_require__(649),
	            styles: [".headerror {\n                font-size: 150px !important;\n                font-weight: normal;\n                line-height: 100px;\n                margin-top: 50px;\n                color: #2ba2aa;\n          }"]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ChangePasswordSuccessComponent);
	    return ChangePasswordSuccessComponent;
	}());
	exports.ChangePasswordSuccessComponent = ChangePasswordSuccessComponent;


/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<section class=\"login-bg\">\r\n  <div class=\"wrapper\" style=\"background-color: transparent;\">\r\n    <div class=\"container\" style=\"margin-top:120px\">\r\n      <div class=\"row\">\r\n        <div class=\"col-sm-5 login-center\">\r\n          <div class=\"login-panel panel-default\">\r\n            <div>\r\n              <fieldset>\r\n                <div class=\"row\">\r\n                  <div class=\"center-block\">\r\n                    <img src=\"" + __webpack_require__(634) + "\" alt=\"\" class=\"img-responsive login-profile-img\">\r\n                    <h1 class=\"text-center login-text\" style=\"color:#fff;\">Success</h1>\r\n                  </div>\r\n                </div>\r\n                <div class=\"row\">\r\n                  <div class=\"col-sm-12 col-md-10  col-md-offset-1 \">\r\n                    <div class=\"form-group\">\r\n                      <p style=\"color: white; padding: 5px;font-size:medium;\" class=\"text-center\">\r\n                        Your password is changed successfully. <br/> Please <a routerLink=\"/\" style=\"color:#FF9933\"> Login</a>                        here.\r\n                      </p>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </fieldset>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>";

/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var translate_service_1 = __webpack_require__(70);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var router_2 = __webpack_require__(26);
	var forgotpassword_model_1 = __webpack_require__(645);
	var forgotpassword_service_1 = __webpack_require__(646);
	var ChangePasswordComponent = (function () {
	    function ChangePasswordComponent(forgotpasswordService, router, activeRoute, translate, authService) {
	        this.forgotpasswordService = forgotpasswordService;
	        this.router = router;
	        this.activeRoute = activeRoute;
	        this.translate = translate;
	        this.authService = authService;
	    }
	    ChangePasswordComponent.prototype.ngOnInit = function () {
	        this.translate.setDetectedLang();
	        this.model = new forgotpassword_model_1.ForgotPasswordModel;
	        this.GetPersonActivationCodeId();
	    };
	    ChangePasswordComponent.prototype.onSubmit = function (forms) {
	        this.SubmitChangePassword();
	    };
	    ChangePasswordComponent.prototype.GetPersonActivationCodeId = function () {
	        var _this = this;
	        this.sub = this.activeRoute
	            .params
	            .subscribe(function (params) {
	            if (params['activationLink'] != '') {
	                _this.forgotpasswordService.CheckActivationCode((params['activationLink']))
	                    .subscribe(function (res) {
	                    if (!res.data) {
	                        _this.router.navigate(['/Linkexpired']);
	                    }
	                    _this.model.personActivationLink = params['activationLink'];
	                }, function (error) {
	                    _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	                    _this.isLoading = false;
	                });
	            }
	        });
	    };
	    ChangePasswordComponent.prototype.SubmitChangePassword = function () {
	        var _this = this;
	        this.forgotpasswordService.SubmitChangePassword(this.model)
	            .subscribe(function (res) {
	            if (res.data == null) {
	                _this.router.navigate(['changepassword/success']);
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    ChangePasswordComponent.prototype.ngOnDestroy = function () { };
	    ChangePasswordComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-forgotpassword',
	            template: __webpack_require__(651),
	            providers: [forgotpassword_service_1.ForgotPasswordService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof forgotpassword_service_1.ForgotPasswordService !== 'undefined' && forgotpassword_service_1.ForgotPasswordService) === 'function' && _a) || Object, (typeof (_b = typeof router_2.Router !== 'undefined' && router_2.Router) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object, (typeof (_e = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _e) || Object])
	    ], ChangePasswordComponent);
	    return ChangePasswordComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.ChangePasswordComponent = ChangePasswordComponent;


/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<section class=\"login-bg\">\r\n  <div class=\"wrapper\" style=\"background-color: transparent;\">\r\n    <div class=\"container\" style=\"margin-top:120px\">\r\n      <div class=\"row\">\r\n        <div class=\"col-sm-5 login-center\">\r\n          <div class=\"login-panel panel-default\">\r\n            <div>\r\n              <form (ngSubmit)=\"onSubmit()\" #ForgotPasswordForm=\"ngForm\" method=\"post\">\r\n                <input type=\"hidden\" class=\"form-control\" [(ngModel)]=\"model.personActivationLink\" name=\"model.personActivationLink\">\r\n                <fieldset>\r\n                  <div class=\"row\">\r\n                    <div class=\"center-block\">\r\n                      <img src=\"" + __webpack_require__(634) + "\" alt=\"\" class=\"img-responsive login-profile-img\">\r\n                      <h1 class=\"text-center login-text\" style=\"color:#fff;\">Change Password</h1>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class=\"col-sm-12 col-md-10  col-md-offset-1 \">\r\n                      <div class=\"form-group\">\r\n                        <ul *ngIf=\"errorMessage || (errorModel | serverErrorMessage : 'password') || (errorModel | serverErrorMessage : 'confirmPassword')\"\r\n                          style=\"background-color: #eb4b4b; color: white; padding: 5px; list-style-type: none;\" class=\"text-center\">\r\n                          <li *ngIf=\"errorModel | serverErrorMessage : 'password'\">{{ errorModel | serverErrorMessage : 'password'}}</li>\r\n                          <li *ngIf=\"!(errorModel | serverErrorMessage : 'password') && errorModel | serverErrorMessage : 'confirmPassword'\">{{ errorModel | serverErrorMessage : 'confirmPassword' }}</li>\r\n                          <li *ngIf=\"!(errorModel | serverErrorMessage : 'password') && !(errorModel | serverErrorMessage : 'confirmPassword') && errorMessage\">{{ errorMessage }}</li>\r\n                        </ul>\r\n                      </div>\r\n                      <div class=\"form-group\">\r\n                        <div class=\"input-group  col-sm-12\">\r\n                          <label  style=\"color:#fff;\">\r\n                            {{ 'LblNewPassword' | translate }}\r\n                          </label>\r\n                        </div>\r\n                        <div class=\"input-group\">\r\n                          <span class=\"input-group-addon\">\r\n                            <i class=\"fa fa-key fa-fw\" aria-hidden=\"true\"></i>\r\n                          </span>\r\n                          <input [(ngModel)]=\"model.password\" class=\"login-form-control\" placeholder=\"Password\" name=\"password\" type=\"password\" autofocus>\r\n                        </div>\r\n                      </div>\r\n                      <div class=\"form-group\">\r\n                        <div class=\"input-group  col-sm-12\">\r\n                          <label  style=\"color:#fff;\">\r\n                            {{ 'LblConfirmPassword' | translate }}\r\n                          </label>\r\n                          <br/>\r\n                        </div>\r\n                        <div class=\"input-group\">\r\n                        <span class=\"input-group-addon\">\r\n                          <i class=\"fa fa-key fa-fw\" aria-hidden=\"true\"></i>\r\n                        </span>\r\n                        <input [(ngModel)]=\"model.confirmPassword\" class=\"login-form-control\" placeholder=\"{{ 'LblConfirmPassword' | translate }}\" name=\"confirmPassword\"\r\n                          type=\"password\" autofocus>\r\n                      </div>\r\n                    </div>\r\n                    <div class=\"form-group\">\r\n                      <button type=\"submit\" class=\"btn btn-lg login-submit-button btn-block\" (ngSubmit)=\"onSubmit()\">Submit</button>\r\n                    </div>\r\n                  </div>\r\n            </div>\r\n            </fieldset>\r\n            </form>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n  </div>\r\n</section>\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>";

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var core_1 = __webpack_require__(3);
	var auth_service_1 = __webpack_require__(58);
	var GAdminComponent = (function () {
	    function GAdminComponent(translate, authService) {
	        this.translate = translate;
	        this.authService = authService;
	        this.toggleClass = "ui-skins sidebar-mini";
	        this.menu = [];
	    }
	    GAdminComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.translate.setDetectedLang();
	        this.authService.GetBackOfficeMenu().subscribe(function (res) {
	            _this.menu = res.data;
	        }, function (error) {
	        });
	    };
	    GAdminComponent.prototype.ToggleMenuLocal = function () {
	        if (window.innerWidth > 767) {
	            if (this.toggleClass == "ui-skins sidebar-mini")
	                this.toggleClass = "ui-skins sidebar-mini sidebar-collapse";
	            else if (this.toggleClass == "ui-skins sidebar-mini sidebar-collapse" || this.toggleClass == "ui-skins sidebar-mini sidebar-open")
	                this.toggleClass = "ui-skins sidebar-mini";
	        }
	        else {
	            if (this.toggleClass == "ui-skins sidebar-mini")
	                this.toggleClass = "ui-skins sidebar-mini sidebar-open";
	            else if (this.toggleClass == "ui-skins sidebar-mini sidebar-open" || this.toggleClass == "ui-skins sidebar-mini sidebar-collapse")
	                this.toggleClass = "ui-skins sidebar-mini";
	        }
	    };
	    GAdminComponent.prototype.onResize = function (event) {
	    };
	    GAdminComponent.prototype.ngOnDestroy = function () { };
	    GAdminComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-gadmin',
	            template: "\n  <div class=\"admin-role\">\n    <div [class]=\"toggleClass\" (window:resize)=\"onResize($event)\" >\n      <wego-navbar (toggleMenu)=\"ToggleMenuLocal()\"></wego-navbar>\n      <wego-sidebar [menu]=\"menu\"></wego-sidebar>\n      <wego-content-wrapper></wego-content-wrapper>\n      <wego-footer></wego-footer>\n    </div>\n  </div>\n  ",
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object])
	    ], GAdminComponent);
	    return GAdminComponent;
	    var _a, _b;
	}());
	exports.GAdminComponent = GAdminComponent;


/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var core_1 = __webpack_require__(3);
	var auth_service_1 = __webpack_require__(58);
	var CAdminComponent = (function () {
	    function CAdminComponent(translate, authService) {
	        this.translate = translate;
	        this.authService = authService;
	        this.toggleClass = "ui-skins sidebar-mini";
	        this.menu = [];
	    }
	    CAdminComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.translate.setDetectedLang();
	        this.authService.GetBackOfficeMenu().subscribe(function (res) {
	            _this.menu = res.data;
	        }, function (error) {
	        });
	        ;
	    };
	    CAdminComponent.prototype.ToggleMenuLocal = function () {
	        if (window.innerWidth > 767) {
	            if (this.toggleClass == "ui-skins sidebar-mini")
	                this.toggleClass = "ui-skins sidebar-mini sidebar-collapse";
	            else if (this.toggleClass == "ui-skins sidebar-mini sidebar-collapse" || this.toggleClass == "ui-skins sidebar-mini sidebar-open")
	                this.toggleClass = "ui-skins sidebar-mini";
	        }
	        else {
	            if (this.toggleClass == "ui-skins sidebar-mini")
	                this.toggleClass = "ui-skins sidebar-mini sidebar-open";
	            else if (this.toggleClass == "ui-skins sidebar-mini sidebar-open" || this.toggleClass == "ui-skins sidebar-mini sidebar-collapse")
	                this.toggleClass = "ui-skins sidebar-mini";
	        }
	    };
	    CAdminComponent.prototype.onResize = function (event) {
	    };
	    CAdminComponent.prototype.ngOnDestroy = function () { };
	    CAdminComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-cadmin',
	            template: "\n  <div class=\"admin-role\">\n    <div [class]=\"toggleClass\" (window:resize)=\"onResize($event)\" >\n      <wego-navbar (toggleMenu)=\"ToggleMenuLocal()\"></wego-navbar>\n      <wego-sidebar [menu]=\"menu\"></wego-sidebar>\n      <wego-content-wrapper></wego-content-wrapper>\n      <wego-footer></wego-footer>\n    </div>\n  </div>\n  ",
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object])
	    ], CAdminComponent);
	    return CAdminComponent;
	    var _a, _b;
	}());
	exports.CAdminComponent = CAdminComponent;


/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var inbox_service_1 = __webpack_require__(609);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var InboxViewComponent = (function () {
	    function InboxViewComponent(authService, router, translate, inboxService) {
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.inboxService = inboxService;
	    }
	    InboxViewComponent.prototype.ngOnChanges = function (change) {
	        if (change.hashID.currentValue) {
	            this.ShowNotification();
	        }
	    };
	    InboxViewComponent.prototype.ngOnInit = function () {
	    };
	    InboxViewComponent.prototype.ShowNotification = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.inboxService.ShowNotification(this.hashID)
	            .subscribe(function (res) {
	            _this.model = res.data;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    __decorate([
	        core_1.Input('NotificationInboxHashID'), 
	        __metadata('design:type', String)
	    ], InboxViewComponent.prototype, "hashID", void 0);
	    InboxViewComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-inbox-view',
	            template: __webpack_require__(655),
	            styles: ["\n          .box-body{\n            padding: 0px 10px 10px;\n          }\n          .mailbox-read-message table tbody tr td\n          , .mailbox-read-message table tbody tr th {\n              padding: 5px;\n          }\n          "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _c) || Object, (typeof (_d = typeof inbox_service_1.InboxService !== 'undefined' && inbox_service_1.InboxService) === 'function' && _d) || Object])
	    ], InboxViewComponent);
	    return InboxViewComponent;
	    var _a, _b, _c, _d;
	}());
	exports.InboxViewComponent = InboxViewComponent;


/***/ },
/* 655 */
/***/ function(module, exports) {

	module.exports = "<div class=\"box box-default\">\r\n  <!--<div class=\"box-header with-border\">\r\n    <h3 class=\"box-title\">Read Notification</h3>\r\n  </div>-->\r\n  <div class=\"box-body\">\r\n    <template [ngIf]=\"model\">\r\n      <div class=\"mailbox-read-info\">\r\n        <h3><strong>{{ model?.subject }}</strong></h3>\r\n        <h5>{{ 'LblFrom' | translate }}: {{ model?.from }}\r\n          <span class=\"mailbox-read-time pull-right\">{{ model?.notifyDateTime }}</span>\r\n        </h5>\r\n      </div>\r\n      <div class=\"mailbox-read-message\" style=\"word-break: break-all\">\r\n        <div [innerHTML]=\"model?.body\"></div>\r\n      </div>\r\n    </template>\r\n    <template [ngIf]=\"!model\">\r\n      <br />\r\n      <p class=\"text-center\"><b>{{ 'LblWelcomeNotification' | translate }}</b></p>\r\n    </template>\r\n    <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n  </div>\r\n</div>";

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var router_1 = __webpack_require__(26);
	var inbox_service_1 = __webpack_require__(609);
	var core_1 = __webpack_require__(3);
	var InboxListComponent = (function () {
	    function InboxListComponent(authService, router, activeRoute, translate, inboxService) {
	        this.authService = authService;
	        this.router = router;
	        this.activeRoute = activeRoute;
	        this.translate = translate;
	        this.inboxService = inboxService;
	        this.showNotification = new core_1.EventEmitter();
	    }
	    InboxListComponent.prototype.ngOnInit = function () {
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = ["subject", "from"];
	        this.HandleRefresh();
	    };
	    InboxListComponent.prototype.HandleRefresh = function () {
	        var _this = this;
	        this.sub = this.activeRoute
	            .params
	            .subscribe(function (params) {
	            _this.GetNotificationInboxList();
	        });
	    };
	    InboxListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetNotificationInboxList();
	    };
	    InboxListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetNotificationInboxList();
	    };
	    InboxListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetNotificationInboxList();
	    };
	    InboxListComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetNotificationInboxList();
	    };
	    InboxListComponent.prototype.ShowNotification = function (notificationInboxHashID) {
	        if (this.inboxList && this.inboxList.length > 0) {
	            this.inboxList.forEach(function (x) { return x.isSelected = false; });
	            var record = this.inboxList.find(function (x) { return x.notificationInboxHashID == notificationInboxHashID; });
	            record.isRead = true;
	            record.isSelected = true;
	        }
	        this.showNotification.emit({ NotificationInboxHashID: notificationInboxHashID });
	    };
	    InboxListComponent.prototype.GetNotificationInboxList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.inboxService.GetNotificationInboxList(this.DataListModel)
	            .subscribe(function (res) {
	            _this.inboxList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    InboxListComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    __decorate([
	        core_1.Output('ShowNotification'), 
	        __metadata('design:type', Object)
	    ], InboxListComponent.prototype, "showNotification", void 0);
	    InboxListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-inbox-list',
	            template: __webpack_require__(657),
	            styles: ["\n          .box-body{\n            padding: 0px 10px 10px;\n          }\n          .maintext { \n            display:block;\n          }\n          .subtext {\n            font-size: smaller; \n          }\n          .unread{\n            font-weight: bold;\n          }\n          .fa-sm{\n            font-size: 0.7em;\n            line-height: 0.7em;\n            vertical-align: 20%;\n          }\n          "
	            ],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object, (typeof (_e = typeof inbox_service_1.InboxService !== 'undefined' && inbox_service_1.InboxService) === 'function' && _e) || Object])
	    ], InboxListComponent);
	    return InboxListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.InboxListComponent = InboxListComponent;


/***/ },
/* 657 */
/***/ function(module, exports) {

	module.exports = "<div class=\"box box-default\">\r\n  <div class=\"box-header with-border\">\r\n    <h3 class=\"box-title\">{{ 'LblNotification' | translate }}</h3>\r\n  </div>\r\n  <div class=\"box-body\" style=\"display: block;\">\r\n    <wego-search-list [IsExported]=\"false\" [SearchTerm]=\"DataListModel.searchTerm\" (OnSearch)=\"OnSearch($event)\" (OnPagingChange)=\"OnPagingChange($event)\"\r\n      [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n    <div class=\"table table-responsive mar_bot_ziro\">\r\n      <table class=\"table table-hover table-striped\">\r\n        <thead>\r\n          <tr>\r\n            <!--<th class=\"text-center parent-checkbox\">\r\n            <input type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\">\r\n          </th>-->\r\n            <th class=\"cursor-pointer\" (click)=\"OnSort('subject')\" style=\"width: 60%;\">\r\n              {{ 'LblSubject' | translate }}\r\n              <wego-sort-list [FieldName]=\"'subject'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n            </th>\r\n            <th class=\"cursor-pointer\" (click)=\"OnSort('notifyDateTime')\" style=\"width: 30%;\">\r\n              {{ 'LblDate' | translate }}\r\n              <wego-sort-list [FieldName]=\"'notifyDateTime'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n            </th>\r\n          </tr>\r\n        </thead>\r\n        <tbody>\r\n          <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n            <tr class=\"cursor-pointer\" *ngFor=\"let item of inboxList\" [ngClass]=\"{'unread': !item.isRead, 'info': item.isSelected}\" (click)=\"ShowNotification(item.notificationInboxHashID)\">\r\n              <!--<td class=\"text-center\">\r\n                <input type=\"checkbox\" name=\"isActive\" [(ngModel)]=\"item.isChecked\">\r\n                </td>-->\r\n              <td>\r\n                <span class=\"maintext\">{{ item.subject }}</span>\r\n                <span class=\"subtext\">{{ item.from }}</span>\r\n              </td>\r\n              <!--<td>\r\n                <i class=\"fa fa-circle fa-sm\" [ngClass]=\"{'text-success': !item.isRead }\" aria-hidden=\"true\"></i>\r\n              </td>-->\r\n              <td>{{ item.notifyDateTime }}</td>\r\n            </tr>\r\n          </template>\r\n          <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n            <td class=\"text-center text-danger\" colspan=\"7\">\r\n              {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n            </td>\r\n          </tr>\r\n        </tbody>\r\n      </table>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"row\">\r\n      <div class=\"col-sm-12\">\r\n        <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n          [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n          lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n      </div>\r\n    </div>\r\n    <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n  </div>\r\n</div>";

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var config_1 = __webpack_require__(60);
	var auth_service_1 = __webpack_require__(58);
	var translate_service_1 = __webpack_require__(70);
	var inbox_service_1 = __webpack_require__(609);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var InboxComponent = (function () {
	    function InboxComponent(router, authService, translate) {
	        this.router = router;
	        this.authService = authService;
	        this.translate = translate;
	    }
	    InboxComponent.prototype.ngOnInit = function () {
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	    };
	    InboxComponent.prototype.ShowNotification = function ($event) {
	        this.notificationInboxHashID = $event.NotificationInboxHashID;
	    };
	    InboxComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-inbox',
	            template: __webpack_require__(659),
	            providers: [inbox_service_1.InboxService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _c) || Object])
	    ], InboxComponent);
	    return InboxComponent;
	    var _a, _b, _c;
	}());
	exports.InboxComponent = InboxComponent;


/***/ },
/* 659 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\"> {{ 'LblNotification' | translate }}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li><a [routerLink]=\"urlDefaultPage\"><i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a></li>\r\n        <li class=\"active\"> {{ 'LblNotification' | translate }}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-sm-5\">\r\n        <wego-inbox-list (ShowNotification)=\"ShowNotification($event)\"></wego-inbox-list>\r\n      </div>\r\n      <div class=\"col-sm-7\">\r\n        <wego-inbox-view [NotificationInboxHashID]=\"notificationInboxHashID\"></wego-inbox-view>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>";

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var __param = (this && this.__param) || function (paramIndex, decorator) {
	    return function (target, key) { decorator(target, key, paramIndex); }
	};
	var core_1 = __webpack_require__(3);
	var TinymceEditorComponent = (function () {
	    // ngOnChanges(change) {
	    //   this.htmlContent = change.ngModel.currentValue;
	    //   if (tinymce.get(this.elementID))
	    //     tinymce.get(this.elementID).setContent(this.htmlContent);
	    // }
	    function TinymceEditorComponent(elementRef) {
	        this.MceHtmlOutput = new core_1.EventEmitter();
	        this.elementRef = elementRef;
	        var randLetter = String.fromCharCode(65 + Math.floor(Math.random() * 26));
	        var uniqid = randLetter + Date.now();
	        this.elementID = 'tinymce' + uniqid;
	        this.MceHtmlOutput = new core_1.EventEmitter();
	    }
	    Object.defineProperty(TinymceEditorComponent.prototype, "MceHtmlInput", {
	        //@Input() ngModel: string;
	        set: function (content) {
	            this.htmlContent = content;
	            console.log(content);
	            if (tinymce.get(this.elementID) && !this.isAlreadyChange && content) {
	                tinymce.get(this.elementID).setContent(content);
	                this.isAlreadyChange = true;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    TinymceEditorComponent.prototype.ngAfterViewInit = function () {
	        //Clone base textarea
	        var baseTextArea = this.elementRef.nativeElement.querySelector("#baseTextArea");
	        var clonedTextArea = baseTextArea.cloneNode(true);
	        clonedTextArea.id = this.elementID;
	        var formGroup = this.elementRef.nativeElement.querySelector("#tinyFormGroup");
	        formGroup.appendChild(clonedTextArea);
	        //Attach tinyMCE to cloned textarea
	        tinymce.init({
	            cleanup_on_startup: false,
	            trim_span_elements: false,
	            verify_html: false,
	            cleanup: false,
	            convert_urls: false,
	            relative_urls: false,
	            mode: 'exact',
	            height: 500,
	            theme: 'modern',
	            plugins: [
	                'table paste code link image'
	            ],
	            menu: {
	                //file: { title: 'File', items: 'newdocument' },
	                edit: { title: 'Edit', items: 'cut copy paste' },
	                //view: { title: 'View', items: 'visualaid' },
	                //format: { title: 'Format', items: 'bold italic underline strikethrough superscript subscript | formats | removeformat' },
	                table: { title: 'Table', items: 'inserttable tableprops deletetable | cell row column' },
	                tools: { title: 'Tools', items: 'code' }
	            },
	            toolbar: 'undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image',
	            elements: this.elementID,
	            setup: this.tinyMCESetup.bind(this)
	        });
	    };
	    TinymceEditorComponent.prototype.ngOnDestroy = function () {
	        //destroy cloned elements
	        tinymce.get(this.elementID).remove();
	        var elem = document.getElementById(this.elementID);
	        if (elem && elem.parentElement)
	            elem.parentElement.removeChild(elem);
	    };
	    TinymceEditorComponent.prototype.tinyMCESetup = function (ed) {
	        ed.on('KeyUp', this.tinyMCEOnKeyup.bind(this));
	        ed.on('ExecCommand', this.tinyMCEOnKeyup.bind(this));
	        ed.on('Change', this.tinyMCEOnKeyup.bind(this));
	        ed.on('Paste', this.tinyMCEOnKeyup.bind(this));
	    };
	    TinymceEditorComponent.prototype.tinyMCEOnKeyup = function (e) {
	        var content = tinymce.get(this.elementID).getContent();
	        //console.log(content);
	        this.MceHtmlOutput.emit(content);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String), 
	        __metadata('design:paramtypes', [String])
	    ], TinymceEditorComponent.prototype, "MceHtmlInput", null);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], TinymceEditorComponent.prototype, "MceHtmlOutput", void 0);
	    TinymceEditorComponent = __decorate([
	        core_1.Component({
	            selector: 'tinymce-editor',
	            template: "\n            <div id=\"tinyFormGroup\" class=\"form-group\">\n                <div class=\"hidden\">\n                    <textarea id=\"baseTextArea\">{{ htmlContent }}</textarea>\n                </div>\n            </div>"
	        }),
	        __param(0, core_1.Inject(core_1.ElementRef)), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof core_1.ElementRef !== 'undefined' && core_1.ElementRef) === 'function' && _a) || Object])
	    ], TinymceEditorComponent);
	    return TinymceEditorComponent;
	    var _a;
	}());
	exports.TinymceEditorComponent = TinymceEditorComponent;


/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var template_model_1 = __webpack_require__(662);
	var template_service_1 = __webpack_require__(663);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var common_1 = __webpack_require__(22);
	var instance_service_1 = __webpack_require__(500);
	var customer_service_1 = __webpack_require__(664);
	var company_service_1 = __webpack_require__(501);
	var organization_service_1 = __webpack_require__(614);
	var sharedvehiclegroup_service_1 = __webpack_require__(510);
	var TemplateUpdateComponent = (function () {
	    function TemplateUpdateComponent(templateService, activeRoute, router, authService, translate, locationService, customerService, instanceService, companyService, organizationService, sharedVehicleGroupService) {
	        this.templateService = templateService;
	        this.activeRoute = activeRoute;
	        this.router = router;
	        this.authService = authService;
	        this.translate = translate;
	        this.locationService = locationService;
	        this.customerService = customerService;
	        this.instanceService = instanceService;
	        this.companyService = companyService;
	        this.organizationService = organizationService;
	        this.sharedVehicleGroupService = sharedVehicleGroupService;
	        this.roleLevel = config_1.RoleLevel;
	        this.isLatexFileDownloadFail = false;
	    }
	    TemplateUpdateComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.pageName = "Template";
	        this.accessDeniedErrorCode = "412";
	        this.module = this.translate.instant("LblTemplate");
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlTemplateList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_TEMPLATE_LIST);
	        this.model = new template_model_1.TemplateModel();
	        this.isEditMode = false;
	        this.isLatexFileDownloadFail = false;
	        this.sub = this.activeRoute.params.subscribe(function (params) {
	            _this.templateHashId = params["id"] || "";
	            if (_this.templateHashId) {
	                _this.SuccessMsg = _this.translate.instant("LblRecordUpdatedSuccess", [
	                    _this.module
	                ]);
	                _this.permissionType = config_1.PermissionType.EDIT;
	            }
	            else {
	                _this.SuccessMsg = _this.translate.instant("LblRecordAddedSuccess", [
	                    _this.module
	                ]);
	                _this.permissionType = config_1.PermissionType.INSERT;
	            }
	            _this.GetCustomerListDropdown();
	        });
	        this.breadCrumbTitle = this.isEditMode
	            ? this.translate.instant("LblEditPage", [this.module])
	            : this.translate.instant("LblAddPage", [this.module]);
	        this.breadCrumbList = this.translate.instant("LblListPage", [this.module]);
	    };
	    TemplateUpdateComponent.prototype.OnSubmit = function (forms) {
	        var _this = this;
	        console.log(this.model);
	        this.templateService.UpdateTemplate(this.model).subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.SuccessMsg;
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    TemplateUpdateComponent.prototype.MceHtmlOutput = function ($event) {
	        //console.log($event);
	        this.model.bodyHTml = $event;
	    };
	    TemplateUpdateComponent.prototype.ConvertToSample = function () {
	        var _this = this;
	        this.isLatexFileDownloadFail = false;
	        this.sampleDate = this.model.bodyHTml;
	        if (this.model.emailTemplatePlaceHolder) {
	            this.model.emailTemplatePlaceHolder.forEach(function (element) {
	                if (element.placeHolder != "%ltx_logo%") {
	                    //this.sampleDate = this.sampleDate.replace(element.placeHolder, element.placeHolderValue);
	                    _this.sampleDate = _this.sampleDate.replace(new RegExp(element.placeHolder, "g"), element.placeHolderValue);
	                }
	            });
	        }
	    };
	    TemplateUpdateComponent.prototype.IsUsedInTemplate = function (placeholder) {
	        return this.model.bodyHTml.indexOf(placeholder) > -1;
	    };
	    TemplateUpdateComponent.prototype.IsUsedInSubject = function (placeholder) {
	        return this.model.subjectHTml.indexOf(placeholder) > -1;
	    };
	    TemplateUpdateComponent.prototype.Copy = function (className) {
	        var copyTextarea = document.querySelector(className);
	        copyTextarea.select();
	        try {
	            var successful = document.execCommand("copy");
	            var msg = successful ? "successful" : "unsuccessful";
	            console.log("Copying text command was " + msg);
	        }
	        catch (err) {
	            console.log("Oops, unable to copy");
	        }
	    };
	    TemplateUpdateComponent.prototype.SuccessModalClick = function () {
	        this.router.navigate([this.urlTemplateList]);
	    };
	    TemplateUpdateComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    TemplateUpdateComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    TemplateUpdateComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    TemplateUpdateComponent.prototype.OnBackClick = function () {
	        this.locationService.back();
	    };
	    TemplateUpdateComponent.prototype.GetTemplateByHashId = function () {
	        var _this = this;
	        if (this.templateHashId != "") {
	            this.isEditMode = true;
	            this.templateService.GetTemplateByHashId(this.templateHashId).subscribe(function (res) {
	                _this.model = res.data;
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            });
	        }
	    };
	    TemplateUpdateComponent.prototype.GetTemplateNames = function () {
	        var _this = this;
	        this.TemplateNameList = [];
	        if (!this.templateHashId && this.model.customerHashId) {
	            this.model.emailTemplateNameHashId = "";
	            this.templateService
	                .GetTemplateNameList(this.model.customerHashId, this.model.instanceHashId, this.model.companyHashId, this.model.organizationHashId, this.model.svgHashId)
	                .subscribe(function (res) {
	                _this.TemplateNameList = res.data;
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            });
	        }
	    };
	    TemplateUpdateComponent.prototype.GetCustomerListDropdown = function () {
	        var _this = this;
	        if (!this.templateHashId) {
	            this.customerService
	                .GetDropdownCustomerListForTemplate(this.permissionType)
	                .subscribe(function (res) {
	                _this.CustomerList = res.data;
	                if (_this.CustomerList != null && _this.CustomerList.length > 0) {
	                    if (!_this.model.customerHashId && _this.CustomerList.length == 1) {
	                        _this.model.customerHashId = _this.CustomerList[0].keyHash;
	                    }
	                    _this.GetTemplateNames();
	                    _this.OnCustomerChange();
	                }
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            });
	        }
	        else {
	            this.GetTemplateByHashId();
	        }
	    };
	    TemplateUpdateComponent.prototype.OnCustomerChange = function () {
	        this.model.instanceHashId = "";
	        this.InstanceList = [];
	        this.model.companyHashId = "";
	        this.CompanyList = [];
	        this.model.organizationHashId = "";
	        this.OrganizationList = [];
	        this.model.svgHashId = "";
	        this.SVGList = [];
	        this.GetInstanceListDropdown();
	    };
	    TemplateUpdateComponent.prototype.GetInstanceListDropdown = function () {
	        var _this = this;
	        if (!this.templateHashId && this.model.customerHashId) {
	            this.instanceService
	                .GetInstanceListDropdownForAddUpdatePage(this.pageName, this.permissionType, this.model.customerHashId)
	                .subscribe(function (res) {
	                _this.InstanceList = res.data;
	                if (_this.InstanceList != null && _this.InstanceList.length > 0) {
	                    if (!_this.model.instanceHashId && _this.InstanceList.length == 1) {
	                        _this.model.instanceHashId = _this.InstanceList[0].keyHash;
	                    }
	                    _this.GetTemplateNames();
	                    _this.OnInstanceChange();
	                }
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            });
	        }
	        else {
	            this.GetTemplateNames();
	        }
	    };
	    TemplateUpdateComponent.prototype.OnInstanceChange = function () {
	        this.model.companyHashId = "";
	        this.CompanyList = [];
	        this.model.organizationHashId = "";
	        this.OrganizationList = [];
	        this.model.svgHashId = "";
	        this.SVGList = [];
	        this.GetCompanyListDropdown();
	    };
	    TemplateUpdateComponent.prototype.GetCompanyListDropdown = function () {
	        var _this = this;
	        if (!this.templateHashId &&
	            this.model.customerHashId &&
	            this.model.instanceHashId) {
	            this.companyService
	                .GetCompanyListDropdownForAddUpdatePage(this.pageName, this.permissionType, this.model.instanceHashId)
	                .subscribe(function (res) {
	                _this.CompanyList = res.data;
	                if (_this.CompanyList != null && _this.CompanyList.length > 0) {
	                    if (!_this.model.companyHashId && _this.CompanyList.length == 1) {
	                        _this.model.companyHashId = _this.CompanyList[0].keyHash;
	                    }
	                    _this.GetTemplateNames();
	                    _this.OnCompanyChange();
	                }
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            });
	        }
	        else {
	            this.GetTemplateNames();
	        }
	    };
	    TemplateUpdateComponent.prototype.OnCompanyChange = function () {
	        this.model.organizationHashId = "";
	        this.OrganizationList = [];
	        this.model.svgHashId = "";
	        this.SVGList = [];
	        this.GetOrganizationListDropdown();
	    };
	    TemplateUpdateComponent.prototype.GetOrganizationListDropdown = function () {
	        var _this = this;
	        if (!this.templateHashId &&
	            ((this.model.customerHashId &&
	                this.model.instanceHashId &&
	                this.model.companyHashId)
	                || (this.CompanyList.length > 1 && (!(this.authService.GetHighestRoleLevel() <= this.roleLevel.Company))))) {
	            this.organizationService
	                .GetOrganizationListDropdownForAddUpdatePage(this.pageName, this.permissionType, null, this.model.companyHashId)
	                .subscribe(function (res) {
	                _this.OrganizationList = res.data;
	                if (_this.OrganizationList != null &&
	                    _this.OrganizationList.length > 0) {
	                    if (!_this.model.organizationHashId &&
	                        _this.OrganizationList.length == 1) {
	                        _this.model.organizationHashId = _this.OrganizationList[0].keyHash;
	                    }
	                    _this.GetTemplateNames();
	                    _this.OnOrganizationChange();
	                }
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            });
	        }
	        else {
	            this.GetTemplateNames();
	        }
	    };
	    TemplateUpdateComponent.prototype.OnOrganizationChange = function () {
	        this.model.svgHashId = "";
	        this.SVGList = [];
	        this.GetSVGListDropdown();
	    };
	    TemplateUpdateComponent.prototype.GetSVGListDropdown = function () {
	        var _this = this;
	        if (!this.templateHashId &&
	            ((this.model.customerHashId &&
	                this.model.instanceHashId &&
	                this.model.companyHashId) || !(this.authService.GetHighestRoleLevel() <= this.roleLevel.Company)) &&
	            this.model.organizationHashId) {
	            this.sharedVehicleGroupService
	                .GetSharedVehicleDropdownListByOrganization(this.pageName, this.permissionType, this.model.organizationHashId)
	                .subscribe(function (res) {
	                _this.SVGList = res.data;
	                if (_this.SVGList != null && _this.SVGList.length > 0) {
	                    if (!_this.model.svgHashId && _this.SVGList.length == 1) {
	                        _this.model.svgHashId = _this.SVGList[0].keyHash;
	                    }
	                    _this.GetTemplateNames();
	                }
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            });
	        }
	        else {
	            this.GetTemplateNames();
	        }
	    };
	    TemplateUpdateComponent.prototype.GeneratePdf = function () {
	        var _this = this;
	        this.templateService
	            .GenerateLatexSamplePDF(this.model.templateHashID, this.model.instanceHashId, this.sampleDate)
	            .subscribe(function (res) {
	            if (res && res.data) {
	                _this.DownloadPdf(res.data);
	            }
	            else {
	                _this.isLatexFileDownloadFail = true;
	            }
	        }, function (error) {
	            _this.isLatexFileDownloadFail = true;
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    TemplateUpdateComponent.prototype.DownloadPdf = function (fileName) {
	        var _this = this;
	        this.isLoading = true;
	        this.templateService.DownloadLatexSamplePDF(fileName).subscribe(function (res) {
	            if (res && res._body) {
	                var fileName_1 = "Sample" + new Date().toISOString() + ".pdf";
	                _this.authService.DownloadFile(fileName_1, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    TemplateUpdateComponent.prototype.OnTemplateNameChange = function () {
	        this.TemplateNameChange();
	    };
	    TemplateUpdateComponent.prototype.TemplateNameChange = function () {
	        var _this = this;
	        if (!this.isEditMode && this.model && this.model.emailTemplateNameHashId) {
	            this.templateService
	                .GetMasterTemplateByHashId(this.model.emailTemplateNameHashId)
	                .subscribe(function (res) {
	                var customerHashId = _this.model.customerHashId;
	                var instanceHashId = _this.model.instanceHashId;
	                var companyHashId = _this.model.companyHashId;
	                var organizationHashId = _this.model.organizationHashId;
	                var svgHashId = _this.model.svgHashId;
	                _this.model = res.data;
	                _this.model.templateHashID = "";
	                _this.model.customerHashId = customerHashId;
	                _this.model.instanceHashId = instanceHashId;
	                _this.model.companyHashId = companyHashId;
	                _this.model.organizationHashId = organizationHashId;
	                _this.model.svgHashId = svgHashId;
	                _this.GetGetTemplateRecipients();
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            });
	        }
	    };
	    TemplateUpdateComponent.prototype.GetGetTemplateRecipients = function () {
	        var _this = this;
	        if (this.model &&
	            this.model.emailTemplateNameHashId &&
	            this.model.customerHashId) {
	            this.templateService
	                .GetTemplateRecipients(this.model.customerHashId, this.model.emailTemplateNameHashId)
	                .subscribe(function (res) {
	                _this.model.emailRecipients = res.data;
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            });
	        }
	    };
	    TemplateUpdateComponent.prototype.ngOnDestroy = function () {
	        if (this.sub) {
	            this.sub.unsubscribe();
	        }
	    };
	    __decorate([
	        core_1.ViewChild("successPopup"), 
	        __metadata('design:type', Object)
	    ], TemplateUpdateComponent.prototype, "successPopup", void 0);
	    TemplateUpdateComponent = __decorate([
	        core_1.Component({
	            selector: "wego-template-update",
	            template: __webpack_require__(665),
	            providers: [
	                template_service_1.TemplateService,
	                customer_service_1.CustomerService,
	                instance_service_1.InstanceService,
	                company_service_1.CompanyService,
	                organization_service_1.OrganizationService,
	                sharedvehiclegroup_service_1.SharedVehicleGroupService
	            ],
	            styles: [
	                "\n    .list-group-item {\n      padding: 5px 15px;\n    }\n    .placeholder-list {\n      max-height: 1000px;\n      overflow-y: auto;\n    }\n  "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof template_service_1.TemplateService !== 'undefined' && template_service_1.TemplateService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _d) || Object, (typeof (_e = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _e) || Object, (typeof (_f = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _f) || Object, (typeof (_g = typeof customer_service_1.CustomerService !== 'undefined' && customer_service_1.CustomerService) === 'function' && _g) || Object, (typeof (_h = typeof instance_service_1.InstanceService !== 'undefined' && instance_service_1.InstanceService) === 'function' && _h) || Object, (typeof (_j = typeof company_service_1.CompanyService !== 'undefined' && company_service_1.CompanyService) === 'function' && _j) || Object, (typeof (_k = typeof organization_service_1.OrganizationService !== 'undefined' && organization_service_1.OrganizationService) === 'function' && _k) || Object, (typeof (_l = typeof sharedvehiclegroup_service_1.SharedVehicleGroupService !== 'undefined' && sharedvehiclegroup_service_1.SharedVehicleGroupService) === 'function' && _l) || Object])
	    ], TemplateUpdateComponent);
	    return TemplateUpdateComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
	}());
	exports.TemplateUpdateComponent = TemplateUpdateComponent;


/***/ },
/* 662 */
/***/ function(module, exports) {

	"use strict";
	var TemplateModel = (function () {
	    function TemplateModel() {
	        this.emailTemplateNameHashId = '';
	        this.customerHashId = '';
	        this.instanceHashId = '';
	        this.companyHashId = '';
	        this.organizationHashId = '';
	        this.svgHashId = '';
	        this.isActive = true;
	    }
	    return TemplateModel;
	}());
	exports.TemplateModel = TemplateModel;
	var EmailTemplatePlaceHolderModel = (function () {
	    function EmailTemplatePlaceHolderModel() {
	    }
	    return EmailTemplatePlaceHolderModel;
	}());
	exports.EmailTemplatePlaceHolderModel = EmailTemplatePlaceHolderModel;
	var EmailRecipientsModel = (function () {
	    function EmailRecipientsModel() {
	    }
	    return EmailRecipientsModel;
	}());
	exports.EmailRecipientsModel = EmailRecipientsModel;
	var EmailCustomRecipientsModel = (function () {
	    function EmailCustomRecipientsModel() {
	    }
	    return EmailCustomRecipientsModel;
	}());
	exports.EmailCustomRecipientsModel = EmailCustomRecipientsModel;


/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var template_model_1 = __webpack_require__(662);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var TemplateService = (function () {
	    function TemplateService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    TemplateService.prototype.GetTemplateList = function (input) {
	        var getTemplateListUrl = config_1.WeGoConfig.API_GET_TEMPLATE_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getTemplateListUrl = getTemplateListUrl + "?" + queryString;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getTemplateListUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    TemplateService.prototype.GetTemplateByHashId = function (templateHashId) {
	        var getInstanceUrl = config_1.WeGoConfig.API_GET_TEMPLATE_BY_HASH + "?templateHashId=" + templateHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getInstanceUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    TemplateService.prototype.GetSampleTemplateByHashId = function (templateHashId, bodyHtml) {
	        var getInstanceUrl = config_1.WeGoConfig.API_GET_SAMPLE_TEMPLATE_BY_HASH;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        var body = new template_model_1.TemplateModel();
	        body.templateHashID = templateHashId;
	        body.bodyHTml = bodyHtml;
	        return this.http.post(getInstanceUrl, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    TemplateService.prototype.UpdateTemplate = function (templateModel) {
	        var body = templateModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_POST_TEMPLATE_DETAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    TemplateService.prototype.GetTemplateNameList = function (customerHashId, instanceHashId, companyHashId, organizationHashId, svgHashId) {
	        var getTemplateNameListUrl = config_1.WeGoConfig.API_GET_TEMPLATE_NAME_LIST + "?customerHashId=" + customerHashId;
	        ;
	        if (instanceHashId) {
	            getTemplateNameListUrl = getTemplateNameListUrl + "&instanceHashId=" + instanceHashId;
	        }
	        if (companyHashId) {
	            getTemplateNameListUrl = getTemplateNameListUrl + "&companyHashId=" + companyHashId;
	        }
	        if (organizationHashId) {
	            getTemplateNameListUrl = getTemplateNameListUrl + "&organizationHashId=" + organizationHashId;
	        }
	        if (svgHashId) {
	            getTemplateNameListUrl = getTemplateNameListUrl + "&svgHashId=" + svgHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getTemplateNameListUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    TemplateService.prototype.GetMasterTemplateByHashId = function (templateNameHashId) {
	        var getInstanceUrl = config_1.WeGoConfig.API_GET_MASTER_TEMPLATE_BY_HASH + "?templateNameHashId=" + templateNameHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getInstanceUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    // public GetTemplateInstanceList(templateNameHashId: string): Observable<IAPIResponse> {
	    //   let getInstanceUrl = WeGoConfig.API_GET_UNUSED_INSTANCE_LIST_FOR_TEMPLATE + "?templateNameHashId=" + templateNameHashId;
	    //   let headers = this.authService.GetHeader();
	    //   let options = new RequestOptions({ headers: headers });
	    //   return this.http.get(getInstanceUrl, options)
	    //     .map(this.authService.HandleAPIResponse)
	    //     .catch(this.authService.HandleAPIError);
	    // }
	    TemplateService.prototype.DeleteTemplates = function (selectedTemplates) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_POST_DELETE_TEMPLATES, selectedTemplates, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    TemplateService.prototype.GenerateLatexSamplePDF = function (templateHashId, instanceHashId, bodyHtml) {
	        var getInstanceUrl = config_1.WeGoConfig.API_GENERATE_LATEX_PDF_BY_HASH;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        var body = new template_model_1.TemplateModel();
	        body.templateHashID = templateHashId;
	        body.instanceHashId = instanceHashId;
	        body.bodyHTml = bodyHtml;
	        return this.http.post(getInstanceUrl, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    TemplateService.prototype.DownloadLatexSamplePDF = function (FileName) {
	        var getInvoiceUrl = config_1.WeGoConfig.API_DOWNLAOD_LATEX_PDF_BY_HASH + "?FileName=" + FileName;
	        var headers = this.authService.GetHeader('application/pdf');
	        var options = new http_1.RequestOptions({ headers: headers, responseType: http_1.ResponseContentType.Blob });
	        return this.http.get(getInvoiceUrl, options);
	    };
	    TemplateService.prototype.GetTemplateRecipients = function (customerHashId, emailTemplateNameHashId) {
	        var getRecipientsUrl = config_1.WeGoConfig.API_GET_TEMPLATE_NAME_RECIPIENT_LIST + "?customerHashId=" + customerHashId + "&emailTemplateNameHashId=" + emailTemplateNameHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getRecipientsUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    TemplateService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], TemplateService);
	    return TemplateService;
	    var _a, _b;
	}());
	exports.TemplateService = TemplateService;


/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var config_1 = __webpack_require__(60);
	var http_1 = __webpack_require__(59);
	var core_1 = __webpack_require__(3);
	var auth_service_1 = __webpack_require__(58);
	var CustomerService = (function () {
	    function CustomerService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    CustomerService.prototype.GetCustomerList = function (input) {
	        var getCustomerListUrl = config_1.WeGoConfig.API_GET_CUSTOMER_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getCustomerListUrl = getCustomerListUrl + "?" + queryString;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getCustomerListUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CustomerService.prototype.GetCustomerByHashId = function (customerHashId) {
	        var getSignupConfigUrl = config_1.WeGoConfig.API_GET_CUSTOMER_BY_HASH + "?customerHashID=" + customerHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getSignupConfigUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CustomerService.prototype.GetCustomerBasicDetail = function (customerHashId) {
	        var getUrl = config_1.WeGoConfig.API_GET_CUSTOMER_BASIC_DETAIL +
	            "?customerHashID=" +
	            customerHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CustomerService.prototype.UpdateCustomer = function (customer) {
	        var body = customer;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_CUSTOMER_DETAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CustomerService.prototype.DeleteCustomers = function (customerHashId) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(config_1.WeGoConfig.API_POST_DELETE_CUSTOMER +
	            "?customerHashID=" +
	            customerHashId, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CustomerService.prototype.ExportCustomerList = function (input) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var getUrl = config_1.WeGoConfig.API_EXPORT_CUSTOMER_LIST + "?" + queryString;
	        var headers = this.authService.GetHeader("text/csv");
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getUrl, options);
	    };
	    CustomerService.prototype.GetCustomerDropdownList = function (input) {
	        var getCustomerListUrl = config_1.WeGoConfig.API_GET_DROPDOWN_CUSTOMER_LIST;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getCustomerListUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CustomerService.prototype.GetDropdownListCustomer = function (moduleName) {
	        var getCustomerUrl;
	        switch (moduleName) {
	            case "Kick_Back_Report":
	                getCustomerUrl =
	                    config_1.WeGoConfig.API_GET_DROPDOWN_CUSTOMER_LIST_FOR_KICK_BACK_REPORT;
	                break;
	            case "Cost_Center_Report":
	                getCustomerUrl =
	                    config_1.WeGoConfig.API_GET_DROPDOWN_CUSTOMER_LIST_FOR_COST_CENTER_REPORT;
	                break;
	            default:
	                getCustomerUrl = config_1.WeGoConfig.API_GET_DROPDOWN_CUSTOMER_LIST;
	                break;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getCustomerUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CustomerService.prototype.GetDropdownCustomerListForTemplate = function (permissionType, customerHashId) {
	        var getCustomerListUrl = config_1.WeGoConfig.API_GET_DROPDOWN_CUSTOMER_LIST_TEMPLATE;
	        if (permissionType) {
	            getCustomerListUrl =
	                getCustomerListUrl + "?permissionType=" + permissionType;
	        }
	        if (customerHashId) {
	            getCustomerListUrl =
	                getCustomerListUrl + "&customerHashId=" + customerHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getCustomerListUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CustomerService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], CustomerService);
	    return CustomerService;
	    var _a, _b;
	}());
	exports.CustomerService = CustomerService;


/***/ },
/* 665 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{breadCrumbTitle}}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"urlTemplateList\">\r\n            <i class=\"fa fa-file-code-o fa-fw\"></i>{{breadCrumbList}}</a>\r\n        </li>\r\n        <li class=\"active\">{{breadCrumbTitle}}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"nopad\">\r\n      <form (ngSubmit)=\"OnSubmit(templateForm.value)\" #templateForm=\"ngForm\">\r\n        <div class=\"form-group col-md-12 checkbox\">\r\n          <label>\r\n            <input type=\"checkbox\" name=\"templateIsActive\" [(ngModel)]=\"model.isActive\">{{ 'LblEnabled' | translate }}</label>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"form-group col-md-4\">\r\n          <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Customer\">\r\n            <label>\r\n              <span *ngIf=\"!isEditMode\" class=\"text text-danger\">*</span>&nbsp;{{'LblCustomer' | translate }}\r\n            </label>\r\n            <input *ngIf=\"isEditMode\" type=\"text\" class=\"form-control\" [ngModel]=\"model.customerName\" name=\"customerName\" disabled>\r\n            <select *ngIf=\"!isEditMode\" [(ngModel)]=\"model.customerHashId\" class=\"form-control\" name=\"customerHashId\" (change)=\"OnCustomerChange()\">\r\n              <option value=''>{{ 'LblSelect' | translate }} {{ 'LblCustomer' | translate }} </option>\r\n              <option *ngFor=\"let item of CustomerList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\r\n            </select>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'customerHashId' }}</span>\r\n            <div class=\"clearfix\"></div>\r\n            <div class=\"mar_t_15\"></div>\r\n          </div>\r\n\r\n          <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Instance\">\r\n            <span *ngIf=\"!isEditMode && !(authService.GetHighestRoleLevel() <= roleLevel.Customer)\" class=\"text text-danger\">*</span>&nbsp;\r\n            <label>{{'LblInstance' | translate }}</label>\r\n            <input *ngIf=\"isEditMode\" type=\"text\" class=\"form-control\" [ngModel]=\"model.instanceName\" name=\"insatnceName\" disabled>\r\n            <select *ngIf=\"!isEditMode\" [(ngModel)]=\"model.instanceHashId\" class=\"form-control\" name=\"instanceHashId\" (change)=\"OnInstanceChange()\">\r\n              <option value=''>{{ 'LblSelect' | translate }} {{ 'LblInstance' | translate }} </option>\r\n              <option *ngFor=\"let item of InstanceList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\r\n            </select>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'instanceHashId' }}</span>\r\n            <div class=\"clearfix\"></div>\r\n            <div class=\"mar_t_15\"></div>\r\n          </div>\r\n\r\n          <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Company\">\r\n            <span *ngIf=\"!isEditMode && !(authService.GetHighestRoleLevel() <= roleLevel.Instance)\" class=\"text text-danger\">*</span>&nbsp;\r\n            <label> {{'LblCompany' | translate }} </label>\r\n            <input *ngIf=\"isEditMode\" type=\"text\" class=\"form-control\" [ngModel]=\"model.companyName\" name=\"companyName\" disabled>\r\n            <select *ngIf=\"!isEditMode\" [(ngModel)]=\"model.companyHashId\" class=\"form-control\" name=\"companyHashId\" (change)=\"OnCompanyChange()\">\r\n              <option value=''>{{ 'LblSelect' | translate }} {{ 'LblCompany' | translate }} </option>\r\n              <option *ngFor=\"let item of CompanyList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\r\n            </select>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'companyHashId' }}</span>\r\n            <div class=\"clearfix\"></div>\r\n            <div class=\"mar_t_15\"></div>\r\n          </div>\r\n\r\n          <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Organization\">\r\n            <span *ngIf=\"!isEditMode && !(authService.GetHighestRoleLevel() <= roleLevel.Company)\" class=\"text text-danger\">*</span>&nbsp;\r\n            <label> {{'LblOrganization' | translate }} </label>\r\n            <input *ngIf=\"isEditMode\" type=\"text\" class=\"form-control\" [ngModel]=\"model.organizationName\" name=\"organizationName\" disabled>\r\n            <select *ngIf=\"!isEditMode\" [(ngModel)]=\"model.organizationHashId\" class=\"form-control\" name=\"organizationHashId\" (change)=\"OnOrganizationChange()\">\r\n              <option value=''>{{ 'LblSelect' | translate }} {{ 'LblOrganization' | translate }} </option>\r\n              <option *ngFor=\"let item of OrganizationList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\r\n            </select>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'organizationHashId' }}</span>\r\n            <div class=\"clearfix\"></div>\r\n            <div class=\"mar_t_15\"></div>\r\n          </div>\r\n\r\n          <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.SVG\">\r\n            <label> {{'LblSharedVehicleGroup' | translate }} </label>\r\n            <input *ngIf=\"isEditMode\" type=\"text\" class=\"form-control\" [ngModel]=\"model.sharedVehicleGroupName\" name=\"sharedVehicleGroupName\"\r\n              disabled>\r\n            <select *ngIf=\"!isEditMode\" [(ngModel)]=\"model.svgHashId\" class=\"form-control\" name=\"svgHashId\" (change)=\"GetTemplateNames()\">\r\n              <option value=''>{{ 'LblSelect' | translate }} {{ 'LblSharedVehicleGroup' | translate }} </option>\r\n              <option *ngFor=\"let item of SVGList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\r\n            </select>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'svgHashId' }}</span>\r\n            <div class=\"clearfix\"></div>\r\n            <div class=\"mar_t_15\"></div>\r\n          </div>\r\n\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>&nbsp;{{'LblTemplateName' | translate }}\r\n          </label>\r\n          <input *ngIf=\"isEditMode\" type=\"text\" class=\"form-control\" [ngModel]=\"model.templateName\" name=\"templateName\" disabled>\r\n          <select *ngIf=\"!isEditMode\" [(ngModel)]=\"model.emailTemplateNameHashId\" class=\"form-control\" name=\"templateName\" (change)=\"OnTemplateNameChange()\">\r\n            <option value='' [selected]='selected'>{{ 'LblSelect' | translate }} {{ 'LblTemplate' | translate }} </option>\r\n            <option *ngFor=\"let item of TemplateNameList\" [ngValue]=\"item.emailTemplateNameHashID\">{{ item.templateName }}</option>\r\n          </select>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'emailTemplateNameHashId' }}</span>\r\n          <div class=\"clearfix\"></div>\r\n          <div class=\"mar_t_15\"></div>\r\n          <!-- <label>\r\n            <span class=\"text text-danger\">*</span>&nbsp;{{'LblTemplateType' | translate }}\r\n          </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"Template Type\" [ngModel]=\"model.templateType\" name=\"templateType\" disabled>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'templateType' }}</span> -->\r\n\r\n          <div class=\"checkbox\">\r\n            <label>\r\n              <input type=\"checkbox\" name=\"isEmailTemplate\" [(ngModel)]=\"model.isEmailTemplate\">{{ 'LblEmailTemplate' | translate }}</label>\r\n            &nbsp;\r\n            <label>\r\n              <input type=\"checkbox\" name=\"isWebTemplate\" [(ngModel)]=\"model.isWebTemplate\">{{ 'LblWebTemplate' | translate }}</label>\r\n          </div>\r\n\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'templateName' }}</span>\r\n\r\n        </div>\r\n        <div *ngIf=\"model.emailTemplateNameHashId\" class=\"form-group col-md-4\">\r\n\r\n          <label>\r\n            {{'LblEmailAddresses' | translate }}\r\n          </label>\r\n\r\n          <textarea class=\"form-control\" placeholder=\"{{'LblEmailAddresses' | translate }}\" [(ngModel)]=\"model.emailAddresses\" maxlength=\"1000\"\r\n            name=\"model.emailAddresses\" style=\"height: 108px;\"></textarea>\r\n\r\n          <div style=\"color : #007777 \">{{ 'LblEmailAddressesEntryPattern' | translate }}</div>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'emailAddresses' }}</span>\r\n\r\n          <div class=\"mar_t_15\"></div>\r\n          <label>\r\n            {{'LblRecepients' | translate }}\r\n          </label>\r\n\r\n          <template [ngIf]=\"model.emailRecipients?.isRecipientsEnable\">\r\n            <div>\r\n              <div *ngIf=\"model.emailRecipients.isWegoAdmin\" class=\"checkbox\">\r\n                <label>\r\n                  <input type=\"checkbox\" [name]=\"'isWegoAdminTicked'+ 10\" [(ngModel)]=\"model.emailRecipients.isWegoAdminTicked\">{{ 'LblWegoAdmin' | translate }}</label>\r\n              </div>\r\n              <div *ngIf=\"model.emailRecipients.isDriver\" class=\"checkbox\">\r\n                <label>\r\n                  <input type=\"checkbox\" [name]=\"'isDriverTicked'+ 11\" [(ngModel)]=\"model.emailRecipients.isDriverTicked\">{{ 'LblCurrentDriver' | translate }}</label>\r\n              </div>\r\n              <div *ngIf=\"model.emailRecipients.isNextDriver\" class=\"checkbox\">\r\n                <label>\r\n                  <input type=\"checkbox\" [name]=\"'isDriverTicked'+ 12\" [(ngModel)]=\"model.emailRecipients.isNextDriverTicked\">{{'LblNextDriver' | translate}}</label>\r\n              </div>\r\n\r\n              <div *ngFor=\"let role of model.emailRecipients.customRecipientsModel; let i = index\" class=\"checkbox\">\r\n                <label>\r\n                  <input type=\"checkbox\" [name]=\"'CustomRole_'+ i\" [(ngModel)]=\"role.isTicked\">{{role.presentationName}}</label>\r\n              </div>\r\n            </div>\r\n          </template>\r\n\r\n          <template [ngIf]=\"!model.emailRecipients?.isRecipientsEnable\">\r\n            <div class=\"form-group text-danger\">\r\n              <ul style=\"padding-left: 15px;\">\r\n                <li>\r\n                  {{'LblNoRecipientWarning'| translate}}\r\n                </li>\r\n              </ul>\r\n            </div>\r\n          </template>\r\n\r\n          <!-- <input type=\"text\" class=\"form-control\" placeholder=\"{{'LblEmailAddresses' | translate }}\" [(ngModel)]=\"model.emailAddresses\" name=\"model.emalAddresses\"  maxlength=\"200\"> -->\r\n        </div>\r\n\r\n        <div *ngIf=\"model.emailTemplateNameHashId\" class=\"form-group col-md-4\">\r\n          <label>\r\n            {{'LblDescription' | translate }}\r\n          </label>\r\n          <textarea class=\"form-control\" placeholder=\"{{'LblDescription' | translate }}\" [(ngModel)]=\"model.description\" name=\"model.description\"\r\n            maxlength=\"1000\" style=\"height: 108px;\"></textarea>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'description' }}</span>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div *ngIf=\"model.emailTemplateNameHashId\" class=\"form-group col-md-8\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>&nbsp;{{'LblSubject' | translate }}\r\n          </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"Subject\" [(ngModel)]=\"model.subjectHTml\" name=\"subjectHTml\" maxlength=\"200\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'subjectHTml' }}</span>\r\n        </div>\r\n        <div *ngIf=\"model.subjectTemplatePlaceHolder && model.subjectTemplatePlaceHolder.length > 0\" class=\"form-group col-md-4\">\r\n          <div>\r\n            <label>\r\n              {{'LblPlaceHolder' | translate }}\r\n            </label>\r\n          </div>\r\n          <ul class=\"list-group\">\r\n            <li *ngFor=\"let item of model.subjectTemplatePlaceHolder\" class=\"list-group-item\" [ngClass]=\"{'list-group-item-success': IsUsedInSubject(item.placeHolder)}\">{{ item.placeHolder }}\r\n            </li>\r\n          </ul>\r\n        </div>\r\n        <div *ngIf=\"model.emailTemplateNameHashId\" class=\"form-group col-md-12 text-danger\">\r\n          <p>\r\n            {{'LblNote' | translate }}\r\n          </p>\r\n          <ul style=\"padding-left: 15px;\">\r\n            <li>\r\n              {{'LblTemplateNote1'| translate}}\r\n            </li>\r\n            <li>\r\n              {{'LblTemplateNote2' | translate}}\r\n            </li>\r\n            <li>\r\n              {{'LblTemplateNote3' | translate}}\r\n            </li>\r\n          </ul>\r\n        </div>\r\n        <div *ngIf=\"model.emailTemplateNameHashId\" class=\"row no-margin\">\r\n          <div *ngIf=\"model.editorType == 'HTML'\" class=\"form-group col-md-8\">\r\n            <label>\r\n              <span class=\"text text-danger\">*</span>&nbsp;{{'LblBody' | translate }}\r\n            </label>\r\n            <a class=\"btn btn-xs btn-green pull-right\" (click)=\"ConvertToSample(); sampleDataModal.show();\">{{ 'LblSampleTemplate' | translate }}</a>\r\n            <tinymce-editor [MceHtmlInput]=\"model.bodyHTml\" (MceHtmlOutput)=\"MceHtmlOutput($event)\" name=\"bodyHTml1\" style=\"height: 1000px;\"></tinymce-editor>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'bodyHTml' }}</span>\r\n          </div>\r\n          <div *ngIf=\"model.editorType == 'LATEX'\" class=\"form-group col-md-8\">\r\n            <label>\r\n              <span class=\"text text-danger\">*</span>&nbsp;{{'LblBody' | translate }}\r\n            </label>\r\n            <a class=\"btn btn-xs btn-green pull-right\" (click)=\"ConvertToSample(); sampleDataModal.show();\">{{ 'LblSampleTemplate' | translate }}</a>\r\n            <textarea class=\"form-control\" placeholder=\"{{'LblBody' | translate }}\" [(ngModel)]=\"model.bodyHTml\" name=\"bodyHTml1\" style=\"height: 1000px;\"></textarea>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'bodyHTml' }}</span>\r\n          </div>\r\n          <div *ngIf=\"model.emailTemplatePlaceHolder && model.emailTemplatePlaceHolder.length > 0\" class=\"form-group col-md-4\">\r\n            <div>\r\n              <label>\r\n                {{'LblPlaceHolder' | translate }}\r\n              </label>\r\n            </div>\r\n            <ul class=\"list-group\" [ngClass]=\"{ 'placeholder-list' : model.editorType == 'LATEX'}\">\r\n              <li *ngFor=\"let item of model.emailTemplatePlaceHolder\" class=\"list-group-item\" [ngClass]=\"{'list-group-item-success': IsUsedInTemplate(item.placeHolder)}\">{{ item.placeHolder }}\r\n              </li>\r\n            </ul>\r\n          </div>\r\n        </div>\r\n        <div class=\"row no-margin\">\r\n          <div class=\"col-sm-12\">\r\n            <hr>\r\n            <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnBackClick()\">{{ 'LblCancel' | translate }}</a> &nbsp;&nbsp;\r\n            <button class=\"btn btn-green\" type=\"submit\">{{ 'LblSave' | translate }}</button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessModalClick()\"></wego-success-popup>\r\n\r\n<div bsModal #sampleDataModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"sampleDataModal.hide()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblSampleTemplate' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <!--<div class=\"form-group no-margin text-right\">\r\n          <button class=\"btn btn-green btn-xs\" (click)=\"Copy('.copy-sample')\">Copy</button>\r\n        </div>-->\r\n        <div class=\"form-group no-margin text-right\">\r\n          <span *ngIf=\"isLatexFileDownloadFail\" class=\"text text-danger pull-left\">{{ 'LblLatexFileDownloadValidation' | translate }}</span>\r\n          <button *ngIf=\"model.editorType == 'LATEX'\" class=\"btn btn-green btn-xs\" (click)=\"GeneratePdf()\">\r\n            {{ 'LblDownload' | translate }}\r\n          </button>\r\n        </div>\r\n        <div class=\"form-group\">\r\n          <textarea *ngIf=\"model.editorType == 'LATEX'\" class=\"form-control copy-sample\" [ngModel]=\"sampleDate\" style=\"height: 500px;\"\r\n            readonly></textarea>\r\n          <div *ngIf=\"model.editorType == 'HTML'\" [innerHTML]=\"sampleDate | safeHtml\" class=\"form-control copy-sample mailbox-read-message\" style=\"height: 500px; overflow: auto;\"\r\n            readonly></div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var userprofile_model_1 = __webpack_require__(597);
	var userprofile_service_1 = __webpack_require__(598);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var common_1 = __webpack_require__(22);
	var flatpickr_model_1 = __webpack_require__(83);
	var UserProfile = (function () {
	    function UserProfile(personService, activeRoute, router, authService, translate, locationService) {
	        this.personService = personService;
	        this.activeRoute = activeRoute;
	        this.router = router;
	        this.authService = authService;
	        this.translate = translate;
	        this.locationService = locationService;
	        this.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_FORMAT;
	        this.submitted = false;
	        this.isDateOfBirth = false;
	    }
	    UserProfile.prototype.ngOnInit = function () {
	        var _this = this;
	        this.module = this.translate.instant('LblProfile');
	        this.flatPickrConfigDateOfBirth = this.SetDefaultFlatPickrConfig();
	        this.translate.setDetectedLang();
	        this.model = new userprofile_model_1.UserProfileModel();
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.GetTelephoneCountry();
	        this.sub = this.activeRoute
	            .params
	            .subscribe(function (params) {
	            _this.personService.GetUserByPersonHashId()
	                .subscribe(function (res) {
	                _this.model = res.data;
	                _this.isDateOfBirth = _this.model.dateOfBirth != '' ? true : false;
	                if (_this.model.liceanceNumberValidated) {
	                    _this.flatPickrConfigDateOfBirth.clickOpens = false;
	                }
	            }, function (error) {
	                _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	                _this.message = error;
	            });
	        });
	        this.GetPersonCountry();
	    };
	    UserProfile.prototype.SetDefaultFlatPickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = false;
	        flatPickrConfig.time_24hr = false;
	        flatPickrConfig.dateFormat = this.dateFormat;
	        flatPickrConfig.minuteIncrement = 1;
	        flatPickrConfig.maxDate = new Date(new Date());
	        return flatPickrConfig;
	    };
	    UserProfile.prototype.onSubmit = function (forms) {
	        this.submitted = true;
	        this.UpdatePersonProfile();
	    };
	    UserProfile.prototype.GetPersonCountry = function () {
	        var _this = this;
	        this.authService.GetPersonCountry()
	            .subscribe(function (res) {
	            _this.personCountryList = res.data;
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    UserProfile.prototype.UpdatePersonProfile = function () {
	        var _this = this;
	        this.personService.UpdateUserProfile(this.model)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblRecordUpdatedSuccess', [_this.module]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    UserProfile.prototype.GetTelephoneCountry = function () {
	        var _this = this;
	        this.authService.GetTelephoneCountry()
	            .subscribe(function (res) {
	            _this.countryList = res.data;
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    UserProfile.prototype.ShowChangePasswordModal = function (personMasterHashId) {
	        this.changePasswordModal.personHashId = personMasterHashId;
	        this.changePasswordModal.show();
	    };
	    UserProfile.prototype.ChangePasswordModal = function ($event) {
	        this.message = $event.SuccessMessage;
	    };
	    UserProfile.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    UserProfile.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    UserProfile.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    UserProfile.prototype.OnBackClick = function () {
	        this.locationService.back();
	    };
	    UserProfile.prototype.ngOnDestroy = function () {
	        if (this.sub) {
	            this.sub.unsubscribe();
	        }
	    };
	    __decorate([
	        core_1.ViewChild('changePasswordModal'), 
	        __metadata('design:type', Object)
	    ], UserProfile.prototype, "changePasswordModal", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], UserProfile.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild('childModal'), 
	        __metadata('design:type', Object)
	    ], UserProfile.prototype, "childModal", void 0);
	    UserProfile = __decorate([
	        core_1.Component({
	            selector: 'wego-userprofile',
	            template: __webpack_require__(667),
	            styles: [
	                "\n    .input-group.telephone-group .input-group-addon {\n      padding: 0px;\n      border: 0px;\n    }\n    .country-select {\n      width: 60px;\n      border: 1px solid #d2d6de;\n      padding: 3px;\n    }\n    "
	            ],
	            providers: [userprofile_service_1.UserProfileService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof userprofile_service_1.UserProfileService !== 'undefined' && userprofile_service_1.UserProfileService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _d) || Object, (typeof (_e = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _e) || Object, (typeof (_f = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _f) || Object])
	    ], UserProfile);
	    return UserProfile;
	    var _a, _b, _c, _d, _e, _f;
	}());
	exports.UserProfile = UserProfile;


/***/ },
/* 667 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ 'LblUpdateProfile' | translate }}</h1>\r\n    </div>\r\n    <div *ngIf=\"!model.sso\" class=\"col-md-3 col-sm-6\" style=\"margin-top: 12px;\">\r\n      <a class=\"btn btn-highlight navbar-right\" routerLinkActive=\"active\" (click)=\"ShowChangePasswordModal(model.personMasterHashId)\">{{'LblChangePassword'| translate}}</a>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <p class=\"text-success\">{{ message }}</p>\r\n    <div class=\"nopad\">\r\n      <form (ngSubmit)=\"onSubmit(UpdatePersonProfile.value)\" #UpdatePersonProfile=\"ngForm\">\r\n        <input type=\"hidden\" class=\"form-control\" [(ngModel)]=\"model.personMasterHashId\" name=\"personMasterHashId\">\r\n        <input type=\"hidden\" class=\"form-control\" [(ngModel)]=\"model.isActive\" name=\"isActive\">\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblUserName' | translate }}\r\n          </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblUserName' | translate }}\" [ngModel]=\"model.userName\" name=\"UserName\"\r\n            maxlength=\"100\" readonly>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'userName' }}</span>\r\n        </div>\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblEmail' | translate }}\r\n          </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblEmail' | translate }}\" [(ngModel)]=\"model.emailAddressModel.email\"\r\n            name=\"Email\" maxlength=\"100\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'emailAddressModel.email' }}</span>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblFirstName' | translate }}\r\n          </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblFirstName' | translate }}\" [(ngModel)]=\"model.firstName\" name=\"FirstName\"\r\n            maxlength=\"100\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'firstName' }}</span>\r\n        </div>\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\"></span>{{ 'LblMiddleName' | translate }}\r\n          </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblMiddleName' | translate }}\" [(ngModel)]=\"model.middleName\" name=\"MiddleName\"\r\n            maxlength=\"100\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'middleName' }}</span>\r\n        </div>\r\n\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblLastName' | translate }}\r\n          </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblLastName' | translate }}\" [(ngModel)]=\"model.lastName\" name=\"LastName\"\r\n            maxlength=\"100\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'lastName' }}</span>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        \r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>  {{ 'LblCountry' | translate }}\r\n          </label>\r\n          <div class=\"form-group inline\">\r\n            <select name=\"model.countryCodeHashId\" [(ngModel)]=\"model.countryCodeHashId\" class=\"form-control inline\">\r\n              <option *ngFor=\"let item of personCountryList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\r\n            </select>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'countryCode' }}</span>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblMobileNumber' | translate }}\r\n          </label>\r\n          <div class=\"input-group telephone-group\">\r\n            <span class=\"input-group-addon\">\r\n              <select [(ngModel)]=\"model.countryCode1\" class=\"form-control country-select\" name=\"countryCode1\">\r\n                <option value=\"\">-</option>\r\n                <option *ngFor=\"let item of countryList\" [ngValue]=\"item.value\">{{ item.value }}</option>\r\n              </select>\r\n            </span>\r\n            <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblMobileNumber' | translate }}\" [(ngModel)]=\"model.telephone1\"\r\n              name=\"telephone1\" maxlength=\"20\">\r\n          </div>\r\n          <div class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'countryCode1' }}</div>\r\n          <div class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'telephone1' }}</div>\r\n        </div>\r\n\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            {{ 'LblPhoneNumber' | translate }}\r\n          </label>\r\n          <div class=\"input-group telephone-group\">\r\n            <span class=\"input-group-addon\">\r\n              <select [(ngModel)]=\"model.countryCode2\" class=\"form-control country-select\" name=\"countryCode2\">\r\n                <option value=\"\">-</option>\r\n                <option *ngFor=\"let item of countryList\" [ngValue]=\"item.value\">{{ item.value }}</option>\r\n              </select>\r\n            </span>\r\n\r\n            <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblPhoneNumber' | translate }}\" [(ngModel)]=\"model.telephone2\" name=\"telephone2\"\r\n              maxlength=\"20\">\r\n          </div>\r\n          <div class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'countryCode2' }}</div>\r\n          <div class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'telephone2' }}</div>\r\n        </div>\r\n\r\n       \r\n\r\n        <div class=\"form-group col-md-4\" *ngIf=\"model.isnifEnabled\">\r\n          <label>\r\n            {{ 'LblNIFNumber' | translate }}\r\n          </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblNIFNumber' | translate }}\" [(ngModel)]=\"model.nifNumber\" name=\"nifNumber\"\r\n            maxlength=\"9\">\r\n          <div class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'nIFNumber' }}</div>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div *ngIf=\"model.validateLiceanceNumber\" class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblDateOfBirth' | translate }}</label>\r\n          <div class=\"input-group\">\r\n            <span class=\"input-group-addon\">\r\n              <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n            </span>\r\n            <input [disabled]=\"isDateOfBirth\" class=\"form-control\" [Config]=\"flatPickrConfigDateOfBirth\" placeholder=\"{{ 'LblDateOfBirth' | translate }}\"\r\n              [(ngModel)]=\"model.dateOfBirth\" name=\"dateOfBirth\" flatpickr readonly>\r\n          </div>\r\n          <span class=\"text text-danger \">{{ errorModel | serverErrorMessage : 'dateOfBirth' }}</span>\r\n        </div>\r\n        <div *ngIf=\"model.validateLiceanceNumber \" class=\"form-group col-md-4 \">\r\n          <label>\r\n            <span class=\"text text-danger \">*</span> {{ 'LblDriverLicenceNumber' | translate }}\r\n          </label>\r\n          <input type=\"text \" class=\"form-control \" placeholder=\"{{ 'LblDriverLicenceNumber' | translate }} \" [(ngModel)]=\"model.driverLicenceNumber \"\r\n            name=\"driverLicenceNumber \" maxlength=\"20 \" [attr.readonly]=\"!model.liceanceNumberValidated?null:''\">\r\n\r\n          <span class=\"text text-danger \">{{ errorModel | serverErrorMessage : 'driverLicenceNumber' }}</span>\r\n        </div>\r\n        <div class=\"clearfix \"></div>\r\n        <div class=\"row col-md-12\">\r\n          <fieldset class=\"col-md-12\">\r\n            <legend class=\"legendStyle \">\r\n              {{ 'LblHomeAddress' | translate }}\r\n            </legend>\r\n            <div class=\"clearfix \"></div>\r\n            <div class=\"form-group col-md-4 \">\r\n              <label>{{ 'LblStreetName' | translate }}</label>\r\n              <input type=\"text \" class=\"form-control \" placeholder=\"{{ 'LblStreetName' | translate }} \" [(ngModel)]=\"model.personHomeAddressModel.street \"\r\n                name=\"personHomeAddressModel.street \" maxlength=\"100 \">\r\n              <span class=\"text text-danger \">{{ errorModel | serverErrorMessage : 'personHomeAddressModel.street' }}</span>\r\n            </div>\r\n            <div class=\"form-group col-md-4 \">\r\n              <label>{{ 'LblHouseNo' | translate }}</label>\r\n              <input type=\"text \" class=\"form-control \" placeholder=\"{{ 'LblHouseNo' | translate }} \" [(ngModel)]=\"model.personHomeAddressModel.houseNo \"\r\n                name=\"personHomeAddressModel.houseNo \" maxlength=\"15 \">\r\n              <span class=\"text text-danger \">{{ errorModel | serverErrorMessage : 'personHomeAddressModel.houseNo' }}</span>\r\n            </div>\r\n            <div class=\"form-group col-md-4 \">\r\n              <label>{{ 'LblHouseExtention' | translate }}</label>\r\n              <input type=\"text \" class=\"form-control \" placeholder=\"{{ 'LblHouseExtention' | translate }} \" [(ngModel)]=\"model.personHomeAddressModel.houseExtention \"\r\n                name=\"personHomeAddressModel.houseExtention \" maxlength=\"25 \">\r\n              <span class=\"text text-danger \">{{ errorModel | serverErrorMessage : 'personHomeAddressModel.houseExtention' }}</span>\r\n            </div>\r\n            <div class=\"clearfix \"></div>\r\n            <div class=\"form-group col-md-4 \">\r\n              <label>{{ 'LblZipCode' | translate }}</label>\r\n              <input type=\"text \" class=\"form-control \" placeholder=\"{{ 'LblZipCode' | translate }} \" [(ngModel)]=\"model.personHomeAddressModel.zipCode \"\r\n                name=\"personHomeAddressModel.zipCode \" maxlength=\"10 \">\r\n              <span class=\"text text-danger \">{{ errorModel | serverErrorMessage : 'personHomeAddressModel.zipCode' }}</span>\r\n            </div>\r\n            <div class=\"form-group col-md-4 \">\r\n              <label>{{ 'LblCity' | translate }}</label>\r\n              <input type=\"text \" class=\"form-control \" placeholder=\"{{ 'LblCity' | translate }} \" [(ngModel)]=\"model.personHomeAddressModel.city \"\r\n                name=\"personHomeAddressModel.city \" maxlength=\"50 \">\r\n              <span class=\"text text-danger \">{{ errorModel | serverErrorMessage : 'personHomeAddressModel.city' }}</span>\r\n            </div>\r\n\r\n          </fieldset>\r\n        </div>\r\n\r\n        <div class=\"row no-margin \">\r\n          <div class=\"col-sm-12 \">\r\n            <hr>\r\n            <a class=\"btn btn-gray cursor-pointer \" (click)=\"OnBackClick() \">{{ 'LblCancel' | translate }}</a> &nbsp;&nbsp;\r\n            <button class=\"btn btn-green \" type=\"submit \">{{ 'LblSave' | translate }}</button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading \"></wego-lodder>\r\n\r\n<wego-userprofile-changepassword #changePasswordModal (OnSuccessUpdatePassword)=\"ChangePasswordModal($event) \"></wego-userprofile-changepassword>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg \" (onConfirm)=\"ConfirmSuccessPopup() \"></wego-success-popup>";

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var userprofile_service_1 = __webpack_require__(598);
	var changepassword_model_1 = __webpack_require__(669);
	var ChangePasswordPopupComponent = (function () {
	    function ChangePasswordPopupComponent(personService, authService, router, translate) {
	        this.personService = personService;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.onSuccessSelect = new core_1.EventEmitter();
	    }
	    ChangePasswordPopupComponent.prototype.ngOnInit = function () {
	        this.translate.setDetectedLang();
	        this.DataListModel = new config_1.DataListModel();
	        this.urlPersonUpdate = this.authService.GetURL(config_1.ApplicationRouteURL.URL_PERSON_UPDATE);
	        this.model = new changepassword_model_1.ChangePasswordModel();
	        this.model.personHashId = this.personHashId;
	    };
	    ChangePasswordPopupComponent.prototype.onSubmit = function (forms) {
	        console.log(this.model);
	        console.log(this.personHashId);
	        this.model.personHashId = this.personHashId;
	        this.SubmitChangePassword();
	    };
	    ChangePasswordPopupComponent.prototype.show = function () {
	        this.changePasswordModal.show();
	    };
	    ChangePasswordPopupComponent.prototype.hide = function () {
	        this.changePasswordModal.hide();
	        this.model = new changepassword_model_1.ChangePasswordModel();
	        this.errorMessage = '';
	        this.message = '';
	        this.errorModel = null;
	    };
	    ChangePasswordPopupComponent.prototype.SubmitChangePassword = function () {
	        var _this = this;
	        this.personService.SubmitChangePassword(this.model)
	            .subscribe(function (res) {
	            if (res.data == null) {
	                _this.message = _this.translate.instant('LblPasswordChangedSucessFully');
	                _this.OnSuccessUpdatePassword();
	                _this.hide();
	            }
	            else {
	                _this.errorMessage = res.data;
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    ChangePasswordPopupComponent.prototype.OnSuccessUpdatePassword = function () {
	        this.onSuccessSelect.emit({ SuccessMessage: this.message });
	    };
	    __decorate([
	        core_1.Output('OnSuccessUpdatePassword'), 
	        __metadata('design:type', Object)
	    ], ChangePasswordPopupComponent.prototype, "onSuccessSelect", void 0);
	    __decorate([
	        core_1.ViewChild('changePasswordModal'), 
	        __metadata('design:type', Object)
	    ], ChangePasswordPopupComponent.prototype, "changePasswordModal", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], ChangePasswordPopupComponent.prototype, "successPopup", void 0);
	    ChangePasswordPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-userprofile-changepassword',
	            template: __webpack_require__(670),
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof userprofile_service_1.UserProfileService !== 'undefined' && userprofile_service_1.UserProfileService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object])
	    ], ChangePasswordPopupComponent);
	    return ChangePasswordPopupComponent;
	    var _a, _b, _c, _d;
	}());
	exports.ChangePasswordPopupComponent = ChangePasswordPopupComponent;


/***/ },
/* 669 */
/***/ function(module, exports) {

	"use strict";
	var ChangePasswordModel = (function () {
	    function ChangePasswordModel() {
	    }
	    return ChangePasswordModel;
	}());
	exports.ChangePasswordModel = ChangePasswordModel;


/***/ },
/* 670 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #changePasswordModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-sm\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n                    <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblChangePassword' | translate }} </h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <p class=\"text text-danger\">{{ errorMessage }}</p>\r\n        <form (ngSubmit)=\"onSubmit()\" #ChangePasswordModelForm=\"ngForm\" method=\"post\">\r\n          <div class=\"form-group col-sm-12\">\r\n            <label>\r\n                  <span class=\"text text-danger\">*</span>{{ 'LblOldPassword' | translate }}\r\n               </label>\r\n            <input type=\"password\" class=\"form-control\" placeholder=\"{{ 'LblOldPassword' | translate }}\" [(ngModel)]=\"model.oldPassword\" name=\"PersonPassword\" maxlength=\"100\">\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'oldPassword' }}</span>\r\n          </div>\r\n          <div class=\"clearfix\"></div>\r\n          <div class=\"form-group col-sm-12\">\r\n            <label>\r\n                  <span class=\"text text-danger\">*</span>{{ 'LblNewPassword' | translate }}\r\n              </label>\r\n            <input type=\"password\" class=\"form-control\" placeholder=\"{{ 'LblNewPassword' | translate }}\" [(ngModel)]=\"model.newPassword\" name=\"PersonConfirmPassword\" maxlength=\"100\">\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'newPassword' }}</span>\r\n          </div>\r\n          <div class=\"clearfix\"></div>\r\n          <div class=\"form-group col-sm-12\">\r\n            <label>\r\n              <span class=\"text text-danger\">*</span>{{ 'LblConfirmPassword' | translate }}\r\n              </label>\r\n            <input type=\"password\" class=\"form-control\" placeholder=\"{{ 'LblConfirmPassword' | translate }}\" [(ngModel)]=\"model.confirmPassword\" name=\"PersonConfirmPassword\" maxlength=\"100\">\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'confirmPassword' }}</span>\r\n          </div>\r\n          <div class=\"clearfix\"></div>\r\n          <div class=\"form-group col-sm-12 text-center\">\r\n            <button class=\"btn btn-green\" type=\"submit\">{{ 'LblChangePassword' | translate }}</button>\r\n          </div>\r\n          <div class=\"clearfix\"></div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var bar_component_1 = __webpack_require__(672);
	exports.BarComponent = bar_component_1.BarComponent;
	var progress_directive_1 = __webpack_require__(673);
	exports.ProgressDirective = progress_directive_1.ProgressDirective;
	var progressbar_component_1 = __webpack_require__(674);
	exports.ProgressbarComponent = progressbar_component_1.ProgressbarComponent;
	var progressbar_module_1 = __webpack_require__(675);
	exports.ProgressbarModule = progressbar_module_1.ProgressbarModule;


/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var progress_directive_1 = __webpack_require__(673);
	// todo: number pipe
	// todo: use query from progress?
	var BarComponent = (function () {
	    function BarComponent(progress) {
	        this.percent = 0;
	        this.progress = progress;
	    }
	    Object.defineProperty(BarComponent.prototype, "value", {
	        get: function () {
	            return this._value;
	        },
	        set: function (v) {
	            if (!v && v !== 0) {
	                return;
	            }
	            this._value = v;
	            this.recalculatePercentage();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BarComponent.prototype.ngOnInit = function () {
	        this.progress.addBar(this);
	    };
	    BarComponent.prototype.ngOnDestroy = function () {
	        this.progress.removeBar(this);
	    };
	    BarComponent.prototype.recalculatePercentage = function () {
	        this.percent = +(100 * this.value / this.progress.max).toFixed(2);
	        var totalPercentage = this.progress.bars.reduce(function (total, bar) {
	            return total + bar.percent;
	        }, 0);
	        if (totalPercentage > 100) {
	            this.percent -= totalPercentage - 100;
	        }
	    };
	    BarComponent.decorators = [
	        { type: core_1.Component, args: [{
	                    selector: 'bar',
	                    template: "\n  <div class=\"progress-bar\"\n    style=\"min-width: 0;\"\n    role=\"progressbar\"\n    [ngClass]=\"type && 'progress-bar-' + type\"\n    [ngStyle]=\"{width: (percent < 100 ? percent : 100) + '%', transition: transition}\"\n    aria-valuemin=\"0\"\n    [attr.aria-valuenow]=\"value\"\n    [attr.aria-valuetext]=\"percent.toFixed(0) + '%'\"\n    [attr.aria-valuemax]=\"max\"><ng-content></ng-content></div>\n"
	                },] },
	    ];
	    /** @nocollapse */
	    BarComponent.ctorParameters = [
	        { type: progress_directive_1.ProgressDirective, decorators: [{ type: core_1.Host },] },
	    ];
	    BarComponent.propDecorators = {
	        'type': [{ type: core_1.Input },],
	        'value': [{ type: core_1.Input },],
	    };
	    return BarComponent;
	}());
	exports.BarComponent = BarComponent;


/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var progressConfig = {
	    animate: true,
	    max: 100
	};
	// todo: progress element conflict with bootstrap.css
	// todo: need hack: replace host element with div
	/* tslint:disable */
	/* tslint:enable */
	var ProgressDirective = (function () {
	    function ProgressDirective() {
	        this.addClass = true;
	        this.bars = [];
	    }
	    Object.defineProperty(ProgressDirective.prototype, "max", {
	        get: function () {
	            return this._max;
	        },
	        set: function (v) {
	            this._max = v;
	            this.bars.forEach(function (bar) {
	                bar.recalculatePercentage();
	            });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ProgressDirective.prototype.ngOnInit = function () {
	        this.animate = this.animate !== false;
	        this.max = typeof this.max === 'number' ? this.max : progressConfig.max;
	    };
	    ProgressDirective.prototype.addBar = function (bar) {
	        if (!this.animate) {
	            bar.transition = 'none';
	        }
	        this.bars.push(bar);
	    };
	    ProgressDirective.prototype.removeBar = function (bar) {
	        this.bars.splice(this.bars.indexOf(bar), 1);
	    };
	    ProgressDirective.decorators = [
	        { type: core_1.Directive, args: [{ selector: 'bs-progress, [progress]' },] },
	    ];
	    /** @nocollapse */
	    ProgressDirective.ctorParameters = [];
	    ProgressDirective.propDecorators = {
	        'animate': [{ type: core_1.Input },],
	        'max': [{ type: core_1.HostBinding, args: ['attr.max',] }, { type: core_1.Input },],
	        'addClass': [{ type: core_1.HostBinding, args: ['class.progress',] },],
	    };
	    return ProgressDirective;
	}());
	exports.ProgressDirective = ProgressDirective;


/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var ProgressbarComponent = (function () {
	    function ProgressbarComponent() {
	    }
	    ProgressbarComponent.decorators = [
	        { type: core_1.Component, args: [{
	                    selector: 'progressbar',
	                    template: "\n    <div progress [animate]=\"animate\" [max]=\"max\">\n      <bar [type]=\"type\" [value]=\"value\">\n          <ng-content></ng-content>\n      </bar>\n    </div>\n  "
	                },] },
	    ];
	    /** @nocollapse */
	    ProgressbarComponent.ctorParameters = [];
	    ProgressbarComponent.propDecorators = {
	        'animate': [{ type: core_1.Input },],
	        'max': [{ type: core_1.Input },],
	        'type': [{ type: core_1.Input },],
	        'value': [{ type: core_1.Input },],
	    };
	    return ProgressbarComponent;
	}());
	exports.ProgressbarComponent = ProgressbarComponent;


/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var common_1 = __webpack_require__(22);
	var core_1 = __webpack_require__(3);
	var bar_component_1 = __webpack_require__(672);
	var progress_directive_1 = __webpack_require__(673);
	var progressbar_component_1 = __webpack_require__(674);
	var ProgressbarModule = (function () {
	    function ProgressbarModule() {
	    }
	    ProgressbarModule.decorators = [
	        { type: core_1.NgModule, args: [{
	                    imports: [common_1.CommonModule],
	                    declarations: [progress_directive_1.ProgressDirective, bar_component_1.BarComponent, progressbar_component_1.ProgressbarComponent],
	                    exports: [progress_directive_1.ProgressDirective, bar_component_1.BarComponent, progressbar_component_1.ProgressbarComponent]
	                },] },
	    ];
	    /** @nocollapse */
	    ProgressbarModule.ctorParameters = [];
	    return ProgressbarModule;
	}());
	exports.ProgressbarModule = ProgressbarModule;


/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var alert_component_1 = __webpack_require__(677);
	exports.AlertComponent = alert_component_1.AlertComponent;
	var alert_module_1 = __webpack_require__(678);
	exports.AlertModule = alert_module_1.AlertModule;


/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var ALERT_TEMPLATE = "\n  <div class=\"alert\" role=\"alert\" [ngClass]=\"classes\" *ngIf=\"!closed\">\n    <button *ngIf=\"dismissible\" type=\"button\" class=\"close\" (click)=\"onClose()\" (touch)=\"onClose()\">\n      <span aria-hidden=\"true\">&times;</span>\n      <span class=\"sr-only\">Close</span>\n    </button>\n    <ng-content></ng-content>\n  </div>\n  ";
	// TODO: templateUrl
	var AlertComponent = (function () {
	    function AlertComponent() {
	        this.type = 'warning';
	        this.close = new core_1.EventEmitter(false);
	        this.classes = [];
	    }
	    AlertComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.classes[0] = "alert-" + this.type;
	        if (this.dismissible) {
	            this.classes[1] = 'alert-dismissible';
	        }
	        else {
	            this.classes.length = 1;
	        }
	        if (this.dismissOnTimeout) {
	            setTimeout(function () { return _this.onClose(); }, this.dismissOnTimeout);
	        }
	    };
	    // todo: mouse event + touch + pointer
	    AlertComponent.prototype.onClose = function () {
	        this.closed = true;
	        this.close.emit(this);
	    };
	    AlertComponent.decorators = [
	        { type: core_1.Component, args: [{
	                    selector: 'alert',
	                    template: ALERT_TEMPLATE
	                },] },
	    ];
	    /** @nocollapse */
	    AlertComponent.ctorParameters = [];
	    AlertComponent.propDecorators = {
	        'type': [{ type: core_1.Input },],
	        'dismissible': [{ type: core_1.Input },],
	        'dismissOnTimeout': [{ type: core_1.Input },],
	        'close': [{ type: core_1.Output },],
	    };
	    return AlertComponent;
	}());
	exports.AlertComponent = AlertComponent;


/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var common_1 = __webpack_require__(22);
	var core_1 = __webpack_require__(3);
	var alert_component_1 = __webpack_require__(677);
	var AlertModule = (function () {
	    function AlertModule() {
	    }
	    AlertModule.decorators = [
	        { type: core_1.NgModule, args: [{
	                    imports: [common_1.CommonModule],
	                    declarations: [alert_component_1.AlertComponent],
	                    exports: [alert_component_1.AlertComponent]
	                },] },
	    ];
	    /** @nocollapse */
	    AlertModule.ctorParameters = [];
	    return AlertModule;
	}());
	exports.AlertModule = AlertModule;


/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var decimal_formatter_service_1 = __webpack_require__(69);
	var translate_service_1 = __webpack_require__(70);
	var config_1 = __webpack_require__(60);
	var search_booking_model_1 = __webpack_require__(574);
	var core_1 = __webpack_require__(3);
	var booking_service_1 = __webpack_require__(556);
	var moment = __webpack_require__(84);
	var $ = __webpack_require__(68);
	var VehicleOverviewComponent = (function () {
	    function VehicleOverviewComponent(translate, bookingService, decimalFormatter) {
	        this.translate = translate;
	        this.bookingService = bookingService;
	        this.decimalFormatter = decimalFormatter;
	        this.onBook = new core_1.EventEmitter();
	        this.SortByDistance = true;
	    }
	    VehicleOverviewComponent.prototype.ngOnChanges = function (change) { };
	    VehicleOverviewComponent.prototype.ngOnInit = function () {
	        this.LblKM = this.translate.instant('LblKM');
	        this.LblLocationUnavailable = this.translate.instant('LblLocationUnavailable');
	        this.LblAvailibilityCalander = this.translate.instant('LblAvailabilityCalander');
	        this.SortList();
	    };
	    VehicleOverviewComponent.prototype.BookVehicle = function (sharedVehicleGroupHashID, vehicleHashID, contractTypeHashId) {
	        console.log(contractTypeHashId);
	        this.onBook.emit({
	            SharedVehicleGroupHashID: sharedVehicleGroupHashID,
	            VehicleHashID: vehicleHashID,
	            ContractTypeHashId: contractTypeHashId
	        });
	    };
	    VehicleOverviewComponent.prototype.GetImageURL = function (imagePath) {
	        return config_1.WeGoConfig.API_SERVER_URL + imagePath;
	    };
	    VehicleOverviewComponent.prototype.GroupByCategory = function (vehicleAttributeList) {
	        if (vehicleAttributeList) {
	            var prop_1 = 'vehicleAttributeCategoryName';
	            return vehicleAttributeList.reduce(function (groups, item) {
	                var val = item[prop_1];
	                groups[val] = groups[val] || [];
	                groups[val].push(item);
	                groups[val] = groups[val].sort(function (obj1, obj2) {
	                    if (obj1.attributeName > obj2.attributeName) {
	                        return 1;
	                    }
	                    if (obj1.attributeName < obj2.attributeName) {
	                        return -1;
	                    }
	                    return 0;
	                });
	                return groups;
	            }, {});
	        }
	        else {
	            return {};
	        }
	    };
	    VehicleOverviewComponent.prototype.KeyOfObject = function (obj) {
	        return Object.keys(obj);
	    };
	    VehicleOverviewComponent.prototype.OnSort = function () {
	        if ($('#sortByDDL').val() == 'avaibility') {
	            this.SortByDistance = false;
	            this.SortList();
	        }
	        else if ($('#sortByDDL').val() == 'distance')
	            this.SortByDistance = true;
	        this.SortList();
	    };
	    VehicleOverviewComponent.prototype.SortList = function () {
	        var _this = this;
	        this.vehicleOverviewList = this.vehicleOverviewList.sort(function (x, y) {
	            return _this.HandleSorting(x, y);
	        });
	        console.log(this.vehicleOverviewList);
	    };
	    VehicleOverviewComponent.prototype.HandleSorting = function (obj1, obj2) {
	        var val1 = this.SortByDistance
	            ? obj1.distance == 'NaN'
	                ? Infinity
	                : obj1.distance
	            : obj1.nextAvailableFromTime
	                ? moment(obj1.nextAvailableFromTime, 'DD-MM-YYYY HH:mm')
	                : moment('01-01-1900 00:00');
	        var val2 = this.SortByDistance
	            ? obj2.distance == 'NaN'
	                ? Infinity
	                : obj2.distance
	            : obj2.nextAvailableFromTime
	                ? moment(obj2.nextAvailableFromTime, 'DD-MM-YYYY HH:mm')
	                : moment('01-01-1900 00:00');
	        if (val1 < val2) {
	            return -1;
	        }
	        else if (val1 > val2) {
	            return 1;
	        }
	        else {
	            return 0;
	        }
	    };
	    VehicleOverviewComponent.prototype.PrintLocation = function (item) {
	        if (item.address && item.lat != 0 && item.long != 0) {
	            return (item.address +
	                ' (' +
	                this.decimalFormatter.transform(item.distance) +
	                ' ' +
	                this.LblKM +
	                ')');
	        }
	        else {
	            return this.LblLocationUnavailable;
	        }
	    };
	    VehicleOverviewComponent.prototype.OpenAvailabilityCalander = function (vehcleHashId, licenceTag) {
	        var _this = this;
	        this.isLoading = true;
	        this.bookingService
	            .GetAquiredTimeSlots(vehcleHashId, this.searchBookingModel.driverHashId, this.searchBookingModel.organizationIdHashID)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.calanderpopup.occupiedTime = res.data;
	                _this.calanderpopup.licenceTag = licenceTag;
	                res.data.forEach(function (x) {
	                    _this.calanderpopup.driverName = x.driverName;
	                    _this.calanderpopup.email = x.email;
	                    _this.calanderpopup.mobileNumber = x.mobile;
	                });
	                _this.calanderpopup.popupTitle = _this.LblAvailibilityCalander;
	                _this.calanderpopup.show();
	                _this.isLoading = false;
	            }
	        }, function (error) {
	            _this.isLoading = false;
	        });
	    };
	    __decorate([
	        core_1.Output('OnBook'), 
	        __metadata('design:type', Object)
	    ], VehicleOverviewComponent.prototype, "onBook", void 0);
	    __decorate([
	        core_1.Input('VehicleOverviewList'), 
	        __metadata('design:type', Array)
	    ], VehicleOverviewComponent.prototype, "vehicleOverviewList", void 0);
	    __decorate([
	        core_1.Input('SearchBookingModel'), 
	        __metadata('design:type', (typeof (_a = typeof search_booking_model_1.SearchBookingModel !== 'undefined' && search_booking_model_1.SearchBookingModel) === 'function' && _a) || Object)
	    ], VehicleOverviewComponent.prototype, "searchBookingModel", void 0);
	    __decorate([
	        core_1.ViewChild('calanderpopup'), 
	        __metadata('design:type', Object)
	    ], VehicleOverviewComponent.prototype, "calanderpopup", void 0);
	    VehicleOverviewComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-vehicle-overview',
	            template: __webpack_require__(680),
	            styles: [
	                "\n      .media {\n        padding: 10px;\n        border: 1px solid #ddd;\n        margin-top: 7px;\n      }\n\n      span.label.label-default {\n        font-size: 13px;\n        line-height: 35px;\n        background-color: #eeeeee;\n        color: #2ba2aa;\n        margin-right: 5px;\n      }\n\n      span.label.label-default.text-success {\n        color: #3c763d;\n      }\n\n      span.label.label-default.text-danger {\n        color: #a94442;\n      }\n\n      .progress-bar-success {\n        background-color: #2ba2aa;\n      }\n      .dropdown {\n        position: relative;\n        display: inline-block;\n      }\n\n      .dropdown-content {\n        display: none;\n        position: absolute;\n        background-color: #f9f9f9;\n        min-width: 105px;\n        box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n        padding: 12px 16px;\n        z-index: 1;\n      }\n\n      .dropdown:hover .dropdown-content {\n        display: block;\n      }\n    "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _b) || Object, (typeof (_c = typeof booking_service_1.BookingService !== 'undefined' && booking_service_1.BookingService) === 'function' && _c) || Object, (typeof (_d = typeof decimal_formatter_service_1.DecimalFormatterService !== 'undefined' && decimal_formatter_service_1.DecimalFormatterService) === 'function' && _d) || Object])
	    ], VehicleOverviewComponent);
	    return VehicleOverviewComponent;
	    var _a, _b, _c, _d;
	}());
	exports.VehicleOverviewComponent = VehicleOverviewComponent;


/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<p *ngIf=\"vehicleOverviewList.length == 0\" class=\"text-center text-danger\">\r\n  {{ 'LblNoMatchingVehicle' | translate }}\r\n</p>\r\n\r\n<div class=\"row\">\r\n  <div class=\"col-md-12\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-10\">\r\n        <div style=\"margin-top: 5px;\" class=\"pull-right\">{{'LblSortBy' | translate}} : </div>\r\n      </div>\r\n      <div class=\"col-md-2\">\r\n        <select class=\"form-control\" id=\"sortByDDL\" (change)=\"OnSort()\">\r\n          <option selected value=\"distance\">{{ 'LblDistance' | translate }}</option>\r\n          <option value=\"avaibility\">{{ 'LblAvaibility' | translate }} </option>\r\n        </select>\r\n      </div>\r\n\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"media\" *ngFor=\"let item of vehicleOverviewList\">\r\n  <div class=\"media-left\">\r\n    <!--<svg *ngIf=\"!item.vehicleImagePath\" height=\"50\" width=\"150\">\r\n      <rect height=\"44\" rx=\"0\" ry=\"0\" style=\"stroke: #695206; fill: #695206;\" width=\"150\" x=\"0\" y=\"0\"></rect>\r\n      <rect height=\"40\" style=\"fill: #2664A3;\" width=\"30\" x=\"2\" y=\"2\"></rect>\r\n      <rect height=\"40\" style=\"fill: #F4BE04;\" width=\"118\" x=\"30\" y=\"2\"></rect>\r\n      <circle cx=\"17\" cy=\"17\" r=\"7\" stroke=\"#747C47\" stroke-dasharray=\"2\" stroke-width=\"3\" style=\"fill: #2664A3;\"></circle>\r\n      <text fill=\"white\" style=\"font-size: 10;\" x=\"12\" y=\"38\">NL</text>\r\n      <text fill=\"black\" style=\"font-size: 24;\" x=\"37\" y=\"30\">{{ item.licenceTag }}</text>\r\n      </svg>\r\n    <img *ngIf=\"item.vehicleImagePath\" src=\"{{item.vehicleImagePath}}\" style=\"height:100px\" />-->\r\n    <img *ngIf=\"!item.vehicleImagePath\" src=\"" + __webpack_require__(564) + "\" alt=\"No\" style=\"max-width: 150px; max-height: 100px;\">\r\n    <img *ngIf=\"item.vehicleImagePath\" [src]=\"GetImageURL(item.vehicleImagePath)\" style=\"max-width: 150px; max-height: 100px;\"\r\n    />\r\n    <br />\r\n    <progressbar class=\"cursor-pointer\" [popover]=\"availableSlots\" *ngIf=\"searchBookingModel.isRecurring\" [value]=\"item.availabilityPercentage\"\r\n      type=\"success\" title=\"Availability Percentage\">{{ item.availabilityPercentage }} %</progressbar>\r\n    <popover-content #availableSlots title=\" {{ 'LblUnAvailableSlots' | translate }} \" placement=\"bottom\" [animation]=\"true \"\r\n      [closeOnClickOutside]=\"true \">\r\n      <table class=\"table table-bordered mar_bot_ziro \">\r\n        <thead>\r\n          <tr>\r\n            <th class=\"text-center \">{{ 'LblFrom' | translate }}</th>\r\n            <th class=\"text-center \"> {{'LblTo' | translate}} </th>\r\n          </tr>\r\n        </thead>\r\n        <tbody>\r\n          <tr *ngFor=\"let unAvailabileSlots of item.unAvailabileSlots \">\r\n            <td>{{ unAvailabileSlots.stDate }}</td>\r\n            <td>{{ unAvailabileSlots.enDate }}</td>\r\n          </tr>\r\n          <tr *ngIf=\"item.unAvailabileSlots==0 \">\r\n            <td class=\"text-center text-danger \" colspan=\"2 \">\r\n              {{ 'LblAvailableForAllSlots' | translate }}\r\n            </td>\r\n          </tr>\r\n        </tbody>\r\n      </table>\r\n    </popover-content>\r\n  </div>\r\n  <div class=\"media-body\">\r\n    <h4 class=\"media-heading row\">\r\n      <div class=\"col-sm-9 col-xs-12\">\r\n        <label>{{ 'LblVehicleOwner' | translate }} :</label> {{ item.vehicleOwner }}</div>\r\n      <div class=\"col-sm-3 col-xs-12 text-center\">\r\n        <template [ngIf]=\"item.available\">\r\n          <button (click)=\"BookVehicle(item.sharedVehicleGroupHashID, item.vehicleHashID,item.contractTypeHashId)\" class=\"btn btn-highlight\">\r\n            <span *ngIf=\"!(searchBookingModel?.isEditMode && searchBookingModel?.vehicleHashId == item.vehicleHashID && searchBookingModel?.sharedVehicleGroupHashID == item.sharedVehicleGroupHashID)\">{{ 'LblBookNow' | translate }}</span>\r\n            <span *ngIf=\"searchBookingModel?.isEditMode && searchBookingModel?.vehicleHashId == item.vehicleHashID && searchBookingModel?.sharedVehicleGroupHashID == item.sharedVehicleGroupHashID\">{{ 'LblUpdateBooking' | translate }}</span>\r\n          </button>\r\n        </template>\r\n      </div>\r\n      <div class=\"col-sm-3 col-xs-12 text-center\">\r\n        <template [ngIf]=\"!item.available\">\r\n          <span class=\"btn btn-highlight\">{{ 'LblUnAvailable' | translate }}</span>\r\n        </template>\r\n      </div>\r\n    </h4>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"row\">\r\n      <div class=\"col-sm-9 col-xs-12\">\r\n        <label>{{ 'LblLocation' | translate }} :</label> {{ PrintLocation(item) }}\r\n      </div>\r\n      <div *ngIf=\"item.showChargeLevel\" class=\"col-sm-3 col-xs-12 text-center\">\r\n        <span>\r\n          <label>{{ 'LblChargeLevel' | translate }} :</label> {{item.chargeLevel |decimalFormatter }}</span>\r\n      </div>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col-sm-9 col-xs-12\" style=\"padding: 0px;\">\r\n        <div class=\"col-sm-6 col-xs-6\">\r\n          <label>{{ 'LblLicenceTag' | translate }} :</label> {{ item.licenceTag}}\r\n        </div>\r\n        <div *ngIf=\"item.sharedVehicleGroup\" class=\"col-sm-6 col-xs-6\">\r\n          <label>{{ 'LblSharedVehicleGroup' | translate }} :</label> {{ item.sharedVehicleGroup }}\r\n        </div>\r\n        <div *ngIf=\"item.brand\" class=\"col-sm-6 col-xs-6\">\r\n          <label>{{ 'LblBrand' | translate }} :</label> {{ item.brand }}\r\n        </div>\r\n        <div *ngIf=\"item.type\" class=\"col-sm-6 col-xs-6\">\r\n          <label>{{ 'LblType' | translate }} :</label> {{ item.type }}\r\n        </div>\r\n        <div *ngIf=\"item.color\" class=\"col-sm-6 col-xs-6\">\r\n          <label>{{ 'LblColor' | translate }} :</label> {{ item.color }}\r\n        </div>\r\n        <div *ngIf=\"item.vehicleClass\" class=\"col-sm-6 col-xs-6\">\r\n          <label>{{ 'LblVehicleClass' | translate }} :</label> {{ item.vehicleClass }}\r\n        </div>\r\n        <div *ngIf=\"item.pricingCategory\" class=\"col-sm-6 col-xs-6\">\r\n          <label>{{ 'LblPricingCategory' | translate }} :</label> {{ item.pricingCategory }}\r\n        </div>\r\n        <div *ngIf=\"item.bodyStyle\" class=\"col-sm-6 col-xs-6\">\r\n          <label>{{ 'LblBodyStyle' | translate }} :</label> {{ item.bodyStyle }}\r\n        </div>\r\n        <div *ngIf=\"item.fuelType\" class=\"col-sm-6 col-xs-6\">\r\n          <label>{{ 'LblFuelType' | translate }} :</label> {{ item.fuelType }}\r\n        </div>\r\n      </div>\r\n      <div *ngIf=\"!item.available\" class=\"col-sm-3 col-xs-12 text-center\">\r\n        <span>{{ 'LblAvailableOn' | translate }}</span>\r\n        <br>\r\n        <span>{{item.nextAvailableFromTime}}</span>\r\n        <br>\r\n        <!--<span>{{ 'LblTo' | translate }}</span><br>\r\n        <span>{{item.nextAvailableToTime}}</span><br>-->\r\n        <a (click)=\"OpenAvailabilityCalander(item.vehicleHashID,item.licenceTag)\" class=\"cursor-pointer\">\r\n          <u>{{ 'LblAvailabilityCalander' | translate }}</u>\r\n        </a>\r\n      </div>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col-sm-12\" *ngFor=\"let cat of KeyOfObject(GroupByCategory(item.attributeList))\">\r\n        <label>{{ cat }} : </label>\r\n        <span *ngFor=\"let attribute of GroupByCategory(item.attributeList)[cat]\" class=\"label label-default\">\r\n          <i class=\"fa fa-tag fa-lg\" aria-hidden=\"true\"></i>&nbsp;{{ attribute.attributeName }}\r\n        </span>\r\n      </div>\r\n    </div>\r\n    <!-- <div class=\"row\">\r\n      <div class=\"col-sm-12\">\r\n        <span *ngIf=\"item.airco\" class=\"label label-default\" [ngClass]=\"{ 'text-success' : item.airco, 'text-danger' : !item.airco }\">\r\n          <i *ngIf=\"item.airco\" class=\"fa fa-check fa-lg\" aria-hidden=\"true\"></i>\r\n          <i *ngIf=\"!item.airco\" class=\"fa fa-times fa-lg\" aria-hidden=\"true\"></i>\r\n          &nbsp;{{ 'LblAirco' | translate }}\r\n        </span>\r\n        <span *ngIf=\"item.towbar\" class=\"label label-default\" [ngClass]=\"{ 'text-success' : item.towbar, 'text-danger' : !item.towbar }\">\r\n          <i *ngIf=\"item.towbar\" class=\"fa fa-check fa-lg\" aria-hidden=\"true\"></i>\r\n          <i *ngIf=\"!item.towbar\" class=\"fa fa-times fa-lg\" aria-hidden=\"true\"></i>\r\n          &nbsp;{{ 'LblTowbar' | translate }} \r\n        </span>\r\n      </div>\r\n    </div> -->\r\n  </div>\r\n</div>\r\n<wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n<wego-calander-popup #calanderpopup></wego-calander-popup>";

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var translate_service_1 = __webpack_require__(70);
	var flatpickr_model_1 = __webpack_require__(83);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var booking_service_1 = __webpack_require__(556);
	var vehicle_service_1 = __webpack_require__(530);
	var sharedvehiclegroup_service_1 = __webpack_require__(510);
	var schedular_booking_model_1 = __webpack_require__(585);
	var core_1 = __webpack_require__(3);
	var $ = __webpack_require__(68);
	var moment = __webpack_require__(84);
	var fullCalendar = __webpack_require__(586);
	//declare var fullCalendar: any;
	var SchedularBookingComponent = (function () {
	    function SchedularBookingComponent(authService, bookigService, sharedVehicleGroupService, vehicleService, router, translate) {
	        this.authService = authService;
	        this.bookigService = bookigService;
	        this.sharedVehicleGroupService = sharedVehicleGroupService;
	        this.vehicleService = vehicleService;
	        this.router = router;
	        this.translate = translate;
	        this.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
	        this.isSharedVehicleGroupVisible = true;
	    }
	    SchedularBookingComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
	        this.model = new schedular_booking_model_1.SchedulerBookingModel();
	        this.model.startDateTime = moment().utc().format('DD-MM-YYYY HH:mm');
	        this.model.endDateTime = moment().utc().add(1, 'M').format('DD-MM-YYYY HH:mm');
	        this.DataListModel = new config_1.DataListModel();
	        this.GetSharedVehicleGroupList();
	        this.GetVehicleList();
	        //this.GetScheduledBookingList();
	        var currentLang = this.translate.currentLang;
	        var LblWeekdays = this.translate.instant('LblWeekdays');
	        var LblMonths = this.translate.instant('LblMonths');
	        var LblButtonText = this.translate.instant('LblButtonText');
	        $('#calendar').fullCalendar({
	            header: {
	                left: 'prev,today,next ',
	                center: 'title',
	                right: 'month,agendaWeek,agendaDay'
	            },
	            displayEventEnd: {
	                month: true,
	                basicWeek: true,
	                default: true
	            },
	            eventRender: function (event, element) {
	                element.attr('href', 'javascript:void(0);');
	                element.click(function () {
	                    _this.bookingInfoModel.bookingInfo = event;
	                    _this.bookingInfoModel.show();
	                });
	            },
	            viewRender: function (view, element) {
	                if (_this.model) {
	                    _this.model.startDateTime = view.start.format('DD-MM-YYYY HH:mm');
	                    _this.model.endDateTime = view.end.format('DD-MM-YYYY HH:mm');
	                    _this.OnSearchVehicleBooking();
	                }
	            },
	            // eventAfterAllRender: (view: any) => {
	            //   this.ChangeEventColor();
	            // },
	            //locale: currentLang,
	            buttonText: LblButtonText,
	            monthNames: LblMonths.longhand,
	            monthNamesShort: LblMonths.shorthand,
	            dayNames: LblWeekdays.longhand,
	            dayNamesShort: LblWeekdays.shorthand,
	            navLinks: true,
	            editable: false,
	            eventLimit: true,
	        });
	    };
	    SchedularBookingComponent.prototype.SetDefaultFlatPickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = true;
	        flatPickrConfig.time_24hr = true;
	        //flatPickrConfig.enableSeconds = true;
	        flatPickrConfig.dateFormat = this.dateFormat;
	        flatPickrConfig.minuteIncrement = 1;
	        return flatPickrConfig;
	    };
	    SchedularBookingComponent.prototype.GetSharedVehicleGroupList = function () {
	        var _this = this;
	        this.sharedVehicleGroupService.GetSharedVehicleDropdownList()
	            .subscribe(function (res) {
	            _this.sharedVehicleGroupList = res.data;
	            if (_this.sharedVehicleGroupList.length > 0) {
	                _this.model.sharedVehicleGroupHashId = _this.model.sharedVehicleGroupHashId || _this.sharedVehicleGroupList.length > 1 ? '' : _this.sharedVehicleGroupList[0].keyHash;
	                if (_this.sharedVehicleGroupList.length > 1) {
	                    _this.isSharedVehicleGroupVisible = true;
	                }
	                else {
	                    _this.isSharedVehicleGroupVisible = false;
	                    _this.GetVehicleList();
	                }
	            }
	            else {
	                _this.isSharedVehicleGroupVisible = false;
	            }
	        }, function (error) {
	            _this.errorMessage = error;
	        });
	    };
	    SchedularBookingComponent.prototype.GetVehicleList = function () {
	        var _this = this;
	        this.vehicleService.GetVehicleDropdownListBySVGID(this.model.sharedVehicleGroupHashId)
	            .subscribe(function (res) {
	            _this.VehicleList = res.data;
	            _this.model.vehicleHashId = _this.model.vehicleHashId || _this.VehicleList.length > 0 ? '' : '';
	        }, function (error) {
	            _this.errorMessage = error;
	        });
	    };
	    SchedularBookingComponent.prototype.onChangeSelectedSVG = function (selectedField) {
	        this.model.sharedVehicleGroupHashId = selectedField;
	        this.GetVehicleList();
	        console.log(this.model.sharedVehicleGroupHashId);
	    };
	    SchedularBookingComponent.prototype.onChangeSelectedVehicle = function (selectedField) {
	        this.model.vehicleHashId = selectedField;
	        console.log(this.model.vehicleHashId);
	    };
	    SchedularBookingComponent.prototype.OnSearchVehicleBooking = function () {
	        console.log(this.model);
	        this.GetScheduledBookingList();
	    };
	    SchedularBookingComponent.prototype.GetScheduledBookingList = function () {
	        var _this = this;
	        this.bookigService.GetScheduledBookingList(this.model)
	            .subscribe(function (res) {
	            if (!res.data) {
	                _this.errorModel = res.error;
	            }
	            else {
	                _this.bookingList = res.data;
	                $('#calendar').fullCalendar('removeEvents');
	                //$('#calendar').fullCalendar('refetchEvents');
	                $('#calendar').fullCalendar('addEventSource', { events: _this.bookingList });
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    __decorate([
	        core_1.ViewChild('bookingInfoModel'), 
	        __metadata('design:type', Object)
	    ], SchedularBookingComponent.prototype, "bookingInfoModel", void 0);
	    SchedularBookingComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-scheduler-booking',
	            template: __webpack_require__(682),
	            styles: ["\n          .box-body{\n            padding: 0px 10px 10px;\n          }\n          "
	            ],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof booking_service_1.BookingService !== 'undefined' && booking_service_1.BookingService) === 'function' && _b) || Object, (typeof (_c = typeof sharedvehiclegroup_service_1.SharedVehicleGroupService !== 'undefined' && sharedvehiclegroup_service_1.SharedVehicleGroupService) === 'function' && _c) || Object, (typeof (_d = typeof vehicle_service_1.VehicleService !== 'undefined' && vehicle_service_1.VehicleService) === 'function' && _d) || Object, (typeof (_e = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _e) || Object, (typeof (_f = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _f) || Object])
	    ], SchedularBookingComponent);
	    return SchedularBookingComponent;
	    var _a, _b, _c, _d, _e, _f;
	}());
	exports.SchedularBookingComponent = SchedularBookingComponent;


/***/ },
/* 682 */
/***/ function(module, exports) {

	module.exports = "<div class=\"box box-default\">\r\n  <div class=\"box-header with-border\">\r\n    <h3 class=\"box-title\">{{ 'LblOverview' | translate }}</h3>\r\n  </div>\r\n  <div class=\"box-body\" style=\"display: block;\">\r\n    <div class=\"row\">\r\n      <div class=\"col-sm-11\">\r\n        <div class=\"row\">\r\n          <!-- <div class=\"form-group\" [ngClass]=\"{'col-sm-3': isSharedVehicleGroupVisible, 'col-sm-4' : !isSharedVehicleGroupVisible }\">\r\n            <label>{{ 'LblFrom' | translate }}</label>\r\n            <div class=\"clearfix\"></div>\r\n            <div class=\"input-group\">\r\n              <span class=\"input-group-addon\"><i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i></span>\r\n              <input class=\"form-control\" [Config]=\"flatPickrConfigFrom\" placeholder=\"{{ 'LblFrom' | translate }}\" name=\"StartDateTime\"\r\n                [(ngModel)]=\"model.startDateTime\" flatpickr readonly>\r\n            </div>\r\n            <div class=\"clearfix\"></div>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'startDateTime' }}</span>\r\n          </div>\r\n\r\n          <div class=\"form-group\" [ngClass]=\"{'col-sm-3': isSharedVehicleGroupVisible, 'col-sm-4' : !isSharedVehicleGroupVisible }\">\r\n            <label>{{ 'LblTo' | translate }}</label>\r\n            <div class=\"clearfix\"></div>\r\n            <div class=\"input-group\">\r\n              <span class=\"input-group-addon\"><i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i></span>\r\n              <input class=\"form-control\" [Config]=\"flatPickrConfigTo\" placeholder=\"{{ 'LblTo' | translate }}\" name=\"EndDateTime\" [(ngModel)]=\"model.endDateTime\"\r\n                flatpickr readonly>\r\n            </div>\r\n          </div> -->\r\n          <div *ngIf=\"isSharedVehicleGroupVisible\" class=\"form-group col-sm-3\">\r\n            <label>{{ 'LblSharedVehicleGroup' | translate }}</label>\r\n            <select [disabled]=\"isEditMode\" [(ngModel)]=\"model.sharedVehicleGroupHashId\" name=\"sharedVehicleGroupHashId\" class=\"form-control\"\r\n              (change)=\"onChangeSelectedSVG($event.target.value)\">\r\n                          <option  value='' [selected]='selected'>{{ 'LblAll' | translate }} </option>\r\n                          <option *ngFor=\"let svg of sharedVehicleGroupList\"  [attr.value]='svg.keyHash' >{{svg.value}}</option>\r\n                    </select>\r\n          </div>\r\n          <div class=\"form-group\" [ngClass]=\"{'col-sm-3': isSharedVehicleGroupVisible, 'col-sm-4' : !isSharedVehicleGroupVisible }\">\r\n            <label>{{ 'LblVehicle' | translate }}</label>\r\n            <select [disabled]=\"isEditMode\" [(ngModel)]=\"model.vehicleHashId\" name=\"vehicleHashId\" class=\"form-control\" (change)=\"onChangeSelectedVehicle($event.target.value)\">\r\n              <option  value='' [selected]='selected'>{{ 'LblAll' | translate }} </option>\r\n              <option *ngFor=\"let vehicle of VehicleList\"  [attr.value]='vehicle.keyHash' >{{vehicle.value}}</option>\r\n            </select>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-sm-1\">\r\n        <div class=\"row\">\r\n          <div class=\"form-group\">\r\n            <div class=\"input-group\" style=\"margin-top:5px;\">\r\n              <label></label>\r\n              <div class=\"clearfix\"></div>\r\n              <button class=\"btn btn-default\" (click)=\"OnSearchVehicleBooking($event)\"><i class=\"fa fa-search\" aria-hidden=\"true\"></i></button>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <hr/>\r\n    <div class=\"clearfix\"></div>\r\n\r\n    <div class=\"row\">\r\n      <div class=\"col-sm-12\" style=\"padding: 0px 50px;\">\r\n        <div id=\"calendar\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<booking-info-popup #bookingInfoModel></booking-info-popup>";

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var jquery_helper_service_1 = __webpack_require__(67);
	var core_1 = __webpack_require__(3);
	var FilterVehicleOverviewComponent = (function () {
	    // selAirco: boolean = false;
	    // selTowbar: boolean = false;
	    function FilterVehicleOverviewComponent() {
	        this.onUpdateVehicleOverView = new core_1.EventEmitter();
	        this.JQueryHelper = new jquery_helper_service_1.JQueryHelperService();
	        this.additionalAttribute = [];
	        this.selBrandList = [];
	        this.selTypeList = [];
	        this.selFuleTypeList = [];
	        this.selBodyStyleList = [];
	        this.selPriceingCategoryList = [];
	        this.seladditionalAttribute = [];
	    }
	    FilterVehicleOverviewComponent.prototype.ngOnChanges = function (change) {
	        console.log(change);
	        this.UpdateFilter();
	    };
	    FilterVehicleOverviewComponent.prototype.ngOnInit = function () {
	    };
	    FilterVehicleOverviewComponent.prototype.UpdateFilter = function () {
	        this.filterVehicleOverviewList = this.vehicleOverviewList;
	        this.BrandFilter();
	        this.TypeFilter();
	        this.FuleFilter();
	        this.BodyStyleFilter();
	        this.PriceingCategoryFilter();
	        this.AdditionalAttributeFilter();
	        this.UpdateVehicleOverView();
	    };
	    FilterVehicleOverviewComponent.prototype.AdditionalAttributeFilter = function () {
	        // let additionalAttribute = this.vehicleOverviewList.filter(x => this.HasValue(x.attributeList) && x.attributeList.length > 0).map(x => x.attributeList.map((y: any) => y.attributeName)).sort();
	        // additionalAttribute.forEach(element => {
	        //   element.forEach((element: any) => {
	        //     this.additionalAttribute.push(element);
	        //   });
	        // });
	        // this.additionalAttribute = this.JQueryHelper.Unique(this.additionalAttribute);
	        var _this = this;
	        var additionalAttribute = this.vehicleOverviewList.filter(function (x) { return _this.HasValue(x.attributeList) && x.attributeList.length > 0; }).map(function (x) { return x.attributeList; }).sort();
	        var place = [];
	        additionalAttribute.forEach(function (element) {
	            element.forEach(function (element) {
	                place.push(element);
	            });
	        });
	        var flags = {};
	        this.additionalAttribute = place.filter(function (entry) {
	            if (flags[entry.attributeName]) {
	                return false;
	            }
	            flags[entry.attributeName] = true;
	            return true;
	        });
	        console.log(this.additionalAttribute);
	    };
	    FilterVehicleOverviewComponent.prototype.BrandFilter = function () {
	        var _this = this;
	        var brand = this.vehicleOverviewList.filter(function (x) { return _this.HasValue(x.brand); }).map(function (x) { return x.brand; }).sort();
	        this.brandList = this.JQueryHelper.Unique(brand);
	    };
	    FilterVehicleOverviewComponent.prototype.TypeFilter = function () {
	        var _this = this;
	        var type = this.vehicleOverviewList.filter(function (x) { return _this.HasValue(x.type); }).map(function (x) { return x.type; }).sort();
	        this.typeList = this.JQueryHelper.Unique(type);
	    };
	    FilterVehicleOverviewComponent.prototype.FuleFilter = function () {
	        var _this = this;
	        var fuelType = this.vehicleOverviewList.filter(function (x) { return _this.HasValue(x.fuelType); }).map(function (x) { return x.fuelType; }).sort();
	        this.fuleTypeList = this.JQueryHelper.Unique(fuelType);
	    };
	    FilterVehicleOverviewComponent.prototype.BodyStyleFilter = function () {
	        var _this = this;
	        var bodyStyle = this.vehicleOverviewList.filter(function (x) { return _this.HasValue(x.bodyStyle); }).map(function (x) { return x.bodyStyle; }).sort();
	        this.bodyStyleList = this.JQueryHelper.Unique(bodyStyle);
	    };
	    FilterVehicleOverviewComponent.prototype.PriceingCategoryFilter = function () {
	        var _this = this;
	        var pricingCategory = this.vehicleOverviewList.filter(function (x) { return _this.HasValue(x.pricingCategory); }).map(function (x) { return x.pricingCategory; }).sort();
	        this.priceingCategoryList = this.JQueryHelper.Unique(pricingCategory);
	    };
	    FilterVehicleOverviewComponent.prototype.HasValue = function (input) {
	        if (input)
	            return true;
	        else
	            return false;
	    };
	    FilterVehicleOverviewComponent.prototype.OnFilter = function (filterName, item, isChekced) {
	        if (filterName == 'brand') {
	            if (isChekced) {
	                if (!(this.selBrandList.indexOf(item) > -1)) {
	                    this.selBrandList.push(item);
	                }
	            }
	            else {
	                this.selBrandList = this.JQueryHelper.RemoveFromArray(this.selBrandList, item);
	            }
	        }
	        else if (filterName == 'type') {
	            if (isChekced) {
	                if (!(this.selTypeList.indexOf(item) > -1)) {
	                    this.selTypeList.push(item);
	                }
	            }
	            else {
	                this.selTypeList = this.JQueryHelper.RemoveFromArray(this.selTypeList, item);
	            }
	        }
	        else if (filterName == 'fuletype') {
	            if (isChekced) {
	                if (!(this.selFuleTypeList.indexOf(item) > -1)) {
	                    this.selFuleTypeList.push(item);
	                }
	            }
	            else {
	                this.selFuleTypeList = this.JQueryHelper.RemoveFromArray(this.selFuleTypeList, item);
	            }
	        }
	        else if (filterName == 'bodystyle') {
	            if (isChekced) {
	                if (!(this.selBodyStyleList.indexOf(item) > -1)) {
	                    this.selBodyStyleList.push(item);
	                }
	            }
	            else {
	                this.selBodyStyleList = this.JQueryHelper.RemoveFromArray(this.selBodyStyleList, item);
	            }
	        }
	        else if (filterName == 'pricingcategory') {
	            if (isChekced) {
	                if (!(this.selPriceingCategoryList.indexOf(item) > -1)) {
	                    this.selPriceingCategoryList.push(item);
	                }
	            }
	            else {
	                this.selPriceingCategoryList = this.JQueryHelper.RemoveFromArray(this.selPriceingCategoryList, item);
	            }
	        }
	        else if (filterName == 'additionalAttribute') {
	            if (isChekced) {
	                if (!(this.seladditionalAttribute.indexOf(item) > -1)) {
	                    this.seladditionalAttribute.push(item);
	                }
	            }
	            else {
	                this.seladditionalAttribute = this.JQueryHelper.RemoveFromArray(this.seladditionalAttribute, item);
	            }
	        }
	        this.UpdateVehicleOverView();
	    };
	    FilterVehicleOverviewComponent.prototype.UpdateVehicleOverView = function () {
	        var _this = this;
	        var localList = this.vehicleOverviewList;
	        localList = localList.filter(function (x) { return _this.selBrandList.length == 0
	            || _this.selBrandList.indexOf(x.brand) > -1; })
	            .filter(function (x) { return _this.selTypeList.length == 0
	            || _this.selTypeList.indexOf(x.type) > -1; })
	            .filter(function (x) { return _this.selFuleTypeList.length == 0
	            || _this.selFuleTypeList.indexOf(x.fuelType) > -1; })
	            .filter(function (x) { return _this.selBodyStyleList.length == 0
	            || _this.selBodyStyleList.indexOf(x.bodyStyle) > -1; })
	            .filter(function (x) { return _this.selPriceingCategoryList.length == 0
	            || _this.selPriceingCategoryList.indexOf(x.pricingCategory) > -1; })
	            .filter(function (x) { return _this.seladditionalAttribute.length == 0
	            || _this.ArrayContainsArray(x.attributeList.map(function (y) { return y.attributeName; }), _this.seladditionalAttribute); });
	        // .filter(x => this.selAirco == false || x.airco == this.selAirco)
	        // .filter(x => this.selTowbar == false || x.towbar == this.selTowbar)
	        this.onUpdateVehicleOverView.emit({ FilterVehicleOverview: localList });
	    };
	    FilterVehicleOverviewComponent.prototype.OnSearch = function ($event) {
	    };
	    FilterVehicleOverviewComponent.prototype.intersect = function (a, b) {
	        var t;
	        if (b.length > a.length)
	            t = b, b = a, a = t; // indexOf to loop over shorter
	        return a.filter(function (e) {
	            if (b.indexOf(e) !== -1)
	                return true;
	        });
	    };
	    FilterVehicleOverviewComponent.prototype.ArrayContainsArray = function (superset, subset) {
	        if (0 == subset.length) {
	            return true;
	        }
	        var retVal = subset.every(function (value) {
	            return (superset.indexOf(value) >= 0);
	        });
	        return retVal;
	    };
	    FilterVehicleOverviewComponent.prototype.GroupByCategory = function (vehicleAttributeList) {
	        if (vehicleAttributeList) {
	            var prop_1 = 'vehicleAttributeCategoryName';
	            return vehicleAttributeList.reduce(function (groups, item) {
	                var val = item[prop_1];
	                groups[val] = groups[val] || [];
	                groups[val].push(item);
	                groups[val] = groups[val].sort(function (obj1, obj2) {
	                    if (obj1.attributeName > obj2.attributeName) {
	                        return 1;
	                    }
	                    if (obj1.attributeName < obj2.attributeName) {
	                        return -1;
	                    }
	                    return 0;
	                });
	                return groups;
	            }, {});
	        }
	        else {
	            return {};
	        }
	    };
	    FilterVehicleOverviewComponent.prototype.KeyOfObject = function (obj) {
	        return Object.keys(obj);
	    };
	    __decorate([
	        core_1.Output('OnUpdateVehicleOverView'), 
	        __metadata('design:type', Object)
	    ], FilterVehicleOverviewComponent.prototype, "onUpdateVehicleOverView", void 0);
	    __decorate([
	        core_1.Input('VehicleOverviewList'), 
	        __metadata('design:type', Array)
	    ], FilterVehicleOverviewComponent.prototype, "vehicleOverviewList", void 0);
	    FilterVehicleOverviewComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-filter-vehicle-overview',
	            template: __webpack_require__(684),
	            styles: ["\n          .box-body{\n            padding: 0px 10px;\n          }\n          "
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], FilterVehicleOverviewComponent);
	    return FilterVehicleOverviewComponent;
	}());
	exports.FilterVehicleOverviewComponent = FilterVehicleOverviewComponent;


/***/ },
/* 684 */
/***/ function(module, exports) {

	module.exports = "<div *ngIf=\"brandList.length > 0\" class=\"box box-default\">\r\n  <div class=\"box-header with-border\">\r\n    <h3 class=\"box-title\">{{ 'LblBrand' | translate }}</h3>\r\n  </div>\r\n  <div class=\"box-body\" style=\"display: block;\">\r\n    <div class=\"checkbox\" *ngFor=\"let item of brandList\">\r\n      <label>\r\n        <input type=\"checkbox\" (change)=\"OnFilter('brand', item, $event.target.checked)\">\r\n        {{ item }}\r\n      </label>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div *ngIf=\"typeList.length > 0\" class=\"box box-default\">\r\n  <div class=\"box-header with-border\">\r\n    <h3 class=\"box-title\"> {{ 'LblType' | translate }} </h3>\r\n  </div>\r\n  <div class=\"box-body\" style=\"display: block;\">\r\n    <div class=\"checkbox\" *ngFor=\"let item of typeList\">\r\n      <label>\r\n        <input type=\"checkbox\" (change)=\"OnFilter('type', item, $event.target.checked)\">\r\n        {{ item }}\r\n      </label>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div *ngIf=\"fuleTypeList.length > 0\" class=\"box box-default\">\r\n  <div class=\"box-header with-border\">\r\n    <h3 class=\"box-title\">{{ 'LblFuelType' | translate }}</h3>\r\n  </div>\r\n  <div class=\"box-body\" style=\"display: block;\">\r\n    <div class=\"checkbox\" *ngFor=\"let item of fuleTypeList\">\r\n      <label>\r\n        <input type=\"checkbox\" (change)=\"OnFilter('fuletype', item, $event.target.checked)\">\r\n        {{ item }}\r\n      </label>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div *ngIf=\"bodyStyleList.length > 0\" class=\"box box-default\">\r\n  <div class=\"box-header with-border\">\r\n    <h3 class=\"box-title\">{{ 'LblBodyStyle' | translate }}</h3>\r\n  </div>\r\n  <div class=\"box-body\" style=\"display: block;\">\r\n    <div class=\"checkbox\" *ngFor=\"let item of bodyStyleList\">\r\n      <label>\r\n        <input type=\"checkbox\" (change)=\"OnFilter('bodystyle', item, $event.target.checked)\">\r\n        {{ item }}\r\n      </label>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div *ngIf=\"priceingCategoryList.length > 0\" class=\"box box-default\">\r\n  <div class=\"box-header with-border\">\r\n    <h3 class=\"box-title\">{{ 'LblPricingCategory' | translate }}</h3>\r\n  </div>\r\n  <div class=\"box-body\" style=\"display: block;\">\r\n    <div class=\"checkbox\" *ngFor=\"let item of priceingCategoryList\">\r\n      <label>\r\n        <input type=\"checkbox\" (change)=\"OnFilter('pricingcategory', item, $event.target.checked)\">\r\n        {{ item }}\r\n      </label>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<!-- <div class=\"box box-default\">\r\n  <div class=\"box-header with-border\">\r\n    <h3 class=\"box-title\">{{ 'LblFeatures' | translate }}</h3>\r\n  </div>\r\n  <div class=\"box-body\" style=\"display: block;\">\r\n    <div class=\"checkbox\">\r\n      <label>\r\n        <input type=\"checkbox\" [ngModel]=\"selAirco\" (ngModelChange)=\"selAirco = !selAirco; UpdateVehicleOverView();\">\r\n        {{ 'LblAirco' | translate }}\r\n      </label>\r\n    </div>\r\n    <div class=\"checkbox\">\r\n      <label>\r\n        <input type=\"checkbox\" [ngModel]=\"selTowbar\" (ngModelChange)=\"selTowbar = !selTowbar; UpdateVehicleOverView();\">\r\n        {{ 'LblTowbar' | translate }}\r\n      </label>\r\n    </div>\r\n  </div>\r\n</div> -->\r\n\r\n<div *ngIf=\"additionalAttribute.length > 0\" class=\"box box-default\">\r\n  <div class=\"box-header with-border\">\r\n    <h3 class=\"box-title\">{{ 'LbAdditionallVehicleAttribute' | translate }}</h3>\r\n  </div>\r\n  <div class=\"box-body\" style=\"display: block;\">\r\n    <div *ngFor=\"let cat of KeyOfObject(GroupByCategory(additionalAttribute))\">\r\n      <label>{{ cat }}</label>\r\n      <div class=\"checkbox\" *ngFor=\"let item of GroupByCategory(additionalAttribute)[cat]\">\r\n        <label>\r\n        <input type=\"checkbox\" (change)=\"OnFilter('additionalAttribute', item.attributeName, $event.target.checked)\">\r\n        {{ item.attributeName }}\r\n      </label>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var booking_service_1 = __webpack_require__(556);
	var driver_service_1 = __webpack_require__(570);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var SelectDriverPopupComponent = (function () {
	    function SelectDriverPopupComponent(driverService, bookingService, authService, router, translate) {
	        this.driverService = driverService;
	        this.bookingService = bookingService;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.onSuccessSelect = new core_1.EventEmitter();
	    }
	    SelectDriverPopupComponent.prototype.ngOnInit = function () {
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.searchField = ["driverName", "firstName", "lastName"];
	    };
	    SelectDriverPopupComponent.prototype.ngOnChanges = function (change) {
	        console.log(change);
	    };
	    SelectDriverPopupComponent.prototype.show = function () {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.sortType = "";
	        this.DataListModel.sortReverse = null;
	        this.DataListModel.searchTerm = "";
	        this.DataListModel.infoMessage = "";
	        this.GetDriverList();
	        this.driverModal.show();
	    };
	    SelectDriverPopupComponent.prototype.hide = function () {
	        this.driverModal.hide();
	    };
	    SelectDriverPopupComponent.prototype.GetDriverList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.bookingService.GetActiveDriverList(this.DataListModel, this.CompanyHashId)
	            .subscribe(function (res) {
	            _this.driverList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SelectDriverPopupComponent.prototype.select = function (driver) {
	        this.isLoading = true;
	        this.onSuccessSelect.emit({ DriverHashID: driver.driverMasterHashId, DriverName: driver.driverName, instanceLanguage: driver.instanceLanguage });
	        this.isLoading = false;
	        this.hide();
	    };
	    SelectDriverPopupComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetDriverList();
	    };
	    SelectDriverPopupComponent.prototype.OnSearch = function (event) {
	        this.DataListModel.searchTerm = event.searchTerm;
	        this.DataListModel.currentPage = 1;
	        this.GetDriverList();
	    };
	    SelectDriverPopupComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetDriverList();
	    };
	    ;
	    SelectDriverPopupComponent.prototype.OnPagingChange = function (event) {
	        console.log(this.DataListModel);
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetDriverList();
	    };
	    SelectDriverPopupComponent.prototype.OnSuccessSelect = function () {
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String)
	    ], SelectDriverPopupComponent.prototype, "CompanyHashId", void 0);
	    __decorate([
	        core_1.Output('OnSuccessSelect'), 
	        __metadata('design:type', Object)
	    ], SelectDriverPopupComponent.prototype, "onSuccessSelect", void 0);
	    __decorate([
	        core_1.ViewChild('driverModal'), 
	        __metadata('design:type', Object)
	    ], SelectDriverPopupComponent.prototype, "driverModal", void 0);
	    SelectDriverPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-select-driver-popup',
	            template: __webpack_require__(686),
	            providers: [driver_service_1.DriverService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof driver_service_1.DriverService !== 'undefined' && driver_service_1.DriverService) === 'function' && _a) || Object, (typeof (_b = typeof booking_service_1.BookingService !== 'undefined' && booking_service_1.BookingService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _e) || Object])
	    ], SelectDriverPopupComponent);
	    return SelectDriverPopupComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.SelectDriverPopupComponent = SelectDriverPopupComponent;


/***/ },
/* 686 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #driverModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n                    <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblSelect' | translate }} {{ 'LblDriver' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <wego-search-list [IsExported]=\"false\" [SearchTerm]=\"DataListModel.searchTerm\" (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center\">\r\n                  {{ 'LblSelect' | translate }}\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('firstName')\">\r\n                  {{ 'LblFirstName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'firstName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('lastName')\">\r\n                  {{ 'LblLastName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'lastName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('driverName')\">\r\n                  {{ 'LblDriver' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'driverName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let driver of driverList\">\r\n                  <td class=\"text-center\">\r\n                    <a class=\"cursor-pointer\" (click)=\"select(driver)\">\r\n                      <i class=\"fa fa-plus-square\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td>{{ driver.firstName }}</td>\r\n                  <td>{{ driver.lastName }}</td>\r\n                  <td>{{ driver.driverName }}</td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0\">\r\n                <td class=\"text-center text-danger\" colspan=\"4\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\" [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\"\r\n                firstText=\"&laquo;\" lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var booking_overview_model_1 = __webpack_require__(577);
	var core_1 = __webpack_require__(3);
	var common_1 = __webpack_require__(22);
	var ConfirmBookingComponent = (function () {
	    //bookingRemarks: string;
	    function ConfirmBookingComponent(locationService) {
	        this.locationService = locationService;
	        this.onConfirmBooking = new core_1.EventEmitter();
	        this.onCancelBooking = new core_1.EventEmitter();
	    }
	    ConfirmBookingComponent.prototype.ngOnInit = function () { };
	    ConfirmBookingComponent.prototype.OnConfirmBooking = function ($event) {
	        this.onConfirmBooking.emit({ BookingRemarks: this.bookingRemarks });
	    };
	    ConfirmBookingComponent.prototype.OnCancelBooking = function ($event) {
	        this.onCancelBooking.emit($event);
	    };
	    ConfirmBookingComponent.prototype.GroupByCategory = function (vehicleAttributeList) {
	        if (vehicleAttributeList) {
	            var prop_1 = 'vehicleAttributeCategoryName';
	            return vehicleAttributeList.reduce(function (groups, item) {
	                var val = item[prop_1];
	                groups[val] = groups[val] || [];
	                groups[val].push(item);
	                groups[val] = groups[val].sort(function (obj1, obj2) {
	                    if (obj1.attributeName > obj2.attributeName) {
	                        return 1;
	                    }
	                    if (obj1.attributeName < obj2.attributeName) {
	                        return -1;
	                    }
	                    return 0;
	                });
	                return groups;
	            }, {});
	        }
	        else {
	            return {};
	        }
	    };
	    ConfirmBookingComponent.prototype.KeyOfObject = function (obj) {
	        return Object.keys(obj);
	    };
	    __decorate([
	        core_1.Input('BookingOverview'), 
	        __metadata('design:type', (typeof (_a = typeof booking_overview_model_1.BookingOverview !== 'undefined' && booking_overview_model_1.BookingOverview) === 'function' && _a) || Object)
	    ], ConfirmBookingComponent.prototype, "bookingOverview", void 0);
	    __decorate([
	        core_1.Input('BookingRemarks'), 
	        __metadata('design:type', String)
	    ], ConfirmBookingComponent.prototype, "bookingRemarks", void 0);
	    __decorate([
	        core_1.Output('OnConfirmBooking'), 
	        __metadata('design:type', Object)
	    ], ConfirmBookingComponent.prototype, "onConfirmBooking", void 0);
	    __decorate([
	        core_1.Output('OnCancelBooking'), 
	        __metadata('design:type', Object)
	    ], ConfirmBookingComponent.prototype, "onCancelBooking", void 0);
	    ConfirmBookingComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-confirm-booking',
	            template: __webpack_require__(688),
	            styles: ["\n    span.label.label-default{\n      font-size: 13px;\n      line-height: 35px;\n      background-color: #eeeeee;\n      color: #2BA2AA;\n      margin-right: 5px;\n    }\n    \n    span.label.label-default.text-success{\n      color: #3c763d;\n    }\n    \n    span.label.label-default.text-danger{\n      color: #a94442;\n    }\n          "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _b) || Object])
	    ], ConfirmBookingComponent);
	    return ConfirmBookingComponent;
	    var _a, _b;
	}());
	exports.ConfirmBookingComponent = ConfirmBookingComponent;


/***/ },
/* 688 */
/***/ function(module, exports) {

	module.exports = "<fieldset>\r\n  <legend class=\"legendStyle\">\r\n    {{ 'LblDriverDetail' | translate }}\r\n  </legend>\r\n  <div class=\"clearfix\"></div>\r\n  <div class=\"row\">\r\n    <div *ngIf=\"bookingOverview?.driver.licenceNumber\" class=\"col-sm-4 col-xs-6\">\r\n      <label>{{ 'LblLicenceNumber' | translate }} :</label> {{ bookingOverview?.driver.licenceNumber }}\r\n    </div>\r\n    <div *ngIf=\"bookingOverview?.driver.driverName\" class=\"col-sm-4 col-xs-6\">\r\n      <label>{{ 'LblDriverName' | translate }} :</label> {{ bookingOverview?.driver.driverName }}\r\n    </div>\r\n    <div *ngIf=\"bookingOverview?.driver.email\" class=\"col-sm-4 col-xs-6\">\r\n      <label>{{ 'LblEmail' | translate }} :</label> {{ bookingOverview?.driver.email }}\r\n    </div>\r\n  </div>\r\n</fieldset>\r\n<br />\r\n<fieldset>\r\n  <legend class=\"legendStyle\">\r\n    {{ 'LblBookingDetail' | translate }}\r\n  </legend>\r\n  <div class=\"clearfix\"></div>\r\n  <div *ngIf=\"bookingOverview?.booking\" class=\"row\">\r\n    <div *ngIf=\"bookingOverview?.booking.bookingStartDateTime\" class=\"col-sm-4 col-xs-6\"><label>{{ 'LblBookingStartDateTime' | translate }} :</label> {{ bookingOverview?.booking.bookingStartDateTime }}</div>\r\n    <div *ngIf=\"bookingOverview?.booking.bookingEndDateTime\" class=\"col-sm-4 col-xs-6\"><label>{{ 'LblBookingEndDateTime' | translate }} :</label> {{ bookingOverview?.booking.bookingEndDateTime }}</div>\r\n    <div *ngIf=\"bookingOverview?.booking.bookingType\" class=\"col-sm-4 col-xs-6\"><label>{{ 'LblBookingType' | translate }} :</label> {{ bookingOverview?.booking.translatedBookingType }}</div>\r\n  </div>\r\n  <template [ngIf]=\"bookingOverview?.reccuringBooking\">\r\n    <div *ngFor=\"let item of bookingOverview?.reccuringBooking\" class=\"row\">\r\n      <div *ngIf=\"item.bookingStartDateTime\" class=\"col-sm-4 col-xs-6\"><label>{{ 'LblBookingStartDateTime' | translate }} :</label> {{ item.bookingStartDateTime }}</div>\r\n      <div *ngIf=\"item.bookingEndDateTime\" class=\"col-sm-4 col-xs-6\"><label>{{ 'LblBookingEndDateTime' | translate }} :</label> {{ item.bookingEndDateTime }}</div>\r\n    </div>\r\n  </template>\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-4 col-xs-6\"><label>{{ 'LblToalBookingDuration' | translate }} :</label> {{ bookingOverview?.bookingDuration }}</div>\r\n    <div *ngIf=\"bookingOverview?.booking\" class=\"col-sm-4 col-xs-4\"><label>{{ 'LblPickupLocation' | translate }} :</label> {{ bookingOverview?.booking.pickupAddress }}</div>\r\n    <div *ngIf=\"bookingOverview?.reccuringBooking && bookingOverview?.reccuringBooking.length>0\" class=\"col-sm-4 col-xs-4\"><label>{{ 'LblPickupLocation' | translate }} :</label> {{ bookingOverview?.reccuringBooking[0].pickupAddress }}</div>\r\n  </div>\r\n</fieldset>\r\n<br />\r\n<fieldset>\r\n  <legend class=\"legendStyle\">\r\n    {{ 'LblVehicleDetail' | translate }}\r\n  </legend>\r\n  <div class=\"clearfix\"></div>\r\n  <div class=\"row\">\r\n    <div *ngIf=\"bookingOverview?.vehicle.licenceTag\" class=\"col-sm-4 col-xs-6\">\r\n      <label>{{ 'LblLicenceTag' | translate }} :</label> {{ bookingOverview?.vehicle.licenceTag }}\r\n    </div>\r\n    <div *ngIf=\"bookingOverview?.vehicle.organizationName\" class=\"col-sm-4 col-xs-6\">\r\n      <label>{{ 'LblOrganization' | translate }} :</label> {{ bookingOverview?.vehicle.organizationName }}\r\n    </div>\r\n    <div *ngIf=\"bookingOverview?.vehicle.sharedVehicleGroup\" class=\"col-sm-4 col-xs-6\">\r\n      <label>{{ 'LblSharedVehicleGroup' | translate }} :</label> {{ bookingOverview?.vehicle.sharedVehicleGroup }}\r\n    </div>\r\n    <div *ngIf=\"bookingOverview?.vehicle.brand\" class=\"col-sm-4 col-xs-6\">\r\n      <label>{{ 'LblBrand' | translate }} :</label> {{ bookingOverview?.vehicle.brand }}\r\n    </div>\r\n    <div *ngIf=\"bookingOverview?.vehicle.type\" class=\"col-sm-4 col-xs-6\">\r\n      <label>{{ 'LblType' | translate }} :</label> {{ bookingOverview?.vehicle.type }}\r\n    </div>\r\n    <div *ngIf=\"bookingOverview?.vehicle.color\" class=\"col-sm-4 col-xs-6\">\r\n      <label>{{ 'LblColor' | translate }} :</label> {{ bookingOverview?.vehicle.color }}\r\n    </div>\r\n    <div *ngIf=\"bookingOverview?.vehicle.vehicleClass\" class=\"col-sm-4 col-xs-6\">\r\n      <label>{{ 'LblVehicleClass' | translate }} :</label> {{ bookingOverview?.vehicle.vehicleClass }}\r\n    </div>\r\n    <div *ngIf=\"bookingOverview?.vehicle.pricingCategory\" class=\"col-sm-4 col-xs-6\">\r\n      <label>{{ 'LblPricingCategory' | translate }} :</label> {{ bookingOverview?.vehicle.pricingCategory }}\r\n    </div>\r\n    <div *ngIf=\"bookingOverview?.vehicle.bodyStyle\" class=\"col-sm-4 col-xs-6\">\r\n      <label>{{ 'LblBodyStyle' | translate }} :</label> {{ bookingOverview?.vehicle.bodyStyle }}\r\n    </div>\r\n    <div *ngIf=\"bookingOverview?.vehicle.fuelType\" class=\"col-sm-4 col-xs-6\">\r\n      <label>{{ 'LblFuelType' | translate }} :</label> {{ bookingOverview?.vehicle.fuelType }}\r\n    </div>\r\n  </div>\r\n  <div class=\"row\">\r\n    <div class=\"col-sm-12\" *ngFor=\"let cat of KeyOfObject(GroupByCategory(bookingOverview?.vehicle.attributeList))\">\r\n      <label>{{ cat }} : </label>\r\n      <span *ngFor=\"let attribute of GroupByCategory(bookingOverview?.vehicle.attributeList)[cat]\" class=\"label label-default\">\r\n          <i class=\"fa fa-tag fa-lg\" aria-hidden=\"true\"></i>&nbsp;{{ attribute.attributeName }}\r\n      </span>\r\n    </div>\r\n  </div>\r\n  <!-- <div class=\"row\">\r\n    <div class=\"col-sm-12\">\r\n      <span class=\"label label-default\" [ngClass]=\"{ 'text-success' : bookingOverview?.vehicle.airco, 'text-danger' : !bookingOverview?.vehicle.airco }\">\r\n          <i *ngIf=\"bookingOverview?.vehicle.airco\" class=\"fa fa-check fa-lg\" aria-hidden=\"true\"></i>\r\n          <i *ngIf=\"!bookingOverview?.vehicle.airco\" class=\"fa fa-times fa-lg\" aria-hidden=\"true\"></i>\r\n          &nbsp;{{ 'LblAirco' | translate }}\r\n        </span>\r\n      <span class=\"label label-default\" [ngClass]=\"{ 'text-success' : bookingOverview?.vehicle.towbar, 'text-danger' : !bookingOverview?.vehicle.towbar }\">\r\n          <i *ngIf=\"bookingOverview?.vehicle.towbar\" class=\"fa fa-check fa-lg\" aria-hidden=\"true\"></i>\r\n          <i *ngIf=\"!bookingOverview?.vehicle.towbar\" class=\"fa fa-times fa-lg\" aria-hidden=\"true\"></i>\r\n          &nbsp;{{ 'LblTowbar' | translate }}\r\n        </span>\r\n    </div>\r\n  </div> -->\r\n</fieldset>\r\n<br/>\r\n<div class=\"form-group \">\r\n  <label>{{ 'LblBookingRemarks' | translate }}</label>\r\n  <div class=\"input-group col-sm-4 col-xs-6\">\r\n    <textarea class=\"form-control\" id=\"BookingRemarks\" [(ngModel)]=\"bookingRemarks\" name=\"BookingRemarks\" placeholder=\"{{ 'LblBookingRemarks' | translate }}\"></textarea>\r\n    <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'BookingRemarks' }}</span>\r\n  </div>\r\n</div>\r\n\r\n<div class=\"row no-margin\">\r\n  <div class=\"col-sm-12\">\r\n    <hr>\r\n    <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnCancelBooking($event)\">{{ 'LblCancel' | translate }}</a> &nbsp;&nbsp;\r\n    <button class=\"btn btn-green\" (click)=\"OnConfirmBooking($event)\" type=\"submit\">{{ 'LblConfirm' | translate }}</button>\r\n  </div>\r\n</div>";

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var flatpickr_model_1 = __webpack_require__(83);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var booking_service_1 = __webpack_require__(556);
	var booking_overviewlist_model_1 = __webpack_require__(573);
	var config_2 = __webpack_require__(60);
	var $ = __webpack_require__(68);
	var moment = __webpack_require__(84);
	var SlimSelect = __webpack_require__(616);
	var BookingOverviewComponent = (function () {
	    // get isDeleteAccess(): boolean {
	    //   if (this.bookingList) {
	    //     return this.bookingList.some
	    //             (
	    //               y =>
	    //               y.isBookingCancel
	    //                 // y.isDeletable &&
	    //                 // (y.bookingStatus == BookingStatus.CONFIRMED ||
	    //                 //   y.bookingStatus == BookingStatus.PENDING) &&
	    //                 // // && y.bookingType == BookingType.NORMAL
	    //                 // y.startDateTime >
	    //                 //   moment()
	    //                 //     .utc()
	    //                 //     .format("DD-MM-YYYY HH:mm")
	    //             );
	    //   } else {
	    //     return false;
	    //   }
	    // }
	    function BookingOverviewComponent(authService, bookigService, router, translate) {
	        this.authService = authService;
	        this.bookigService = bookigService;
	        this.router = router;
	        this.translate = translate;
	        this.dateFormat = config_2.WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
	        this.model = new booking_overviewlist_model_1.BookingOverviewList();
	        this.remarkslength = 15;
	        this.NormalBookingView = true;
	        this.dropdownSettings = {};
	    }
	    Object.defineProperty(BookingOverviewComponent.prototype, "isAnyChecked", {
	        get: function () {
	            if (this.bookingList) {
	                var isCheck = this.bookingList.some(function (x) { return x.isChecked == true; });
	                if (isCheck) {
	                    if (this.bookingList
	                        .filter(function (y) { return y.isBookingCancel; })
	                        .every(function (x) { return x.isChecked == true; }))
	                        this.isParentCheck = true;
	                    else
	                        this.isParentCheck = false;
	                }
	                else {
	                    this.isParentCheck = false;
	                }
	                return isCheck;
	            }
	            else {
	                this.isParentCheck = false;
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BookingOverviewComponent.prototype.ngOnInit = function () {
	        this.module = this.translate.instant("LblBooking");
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        if (this.authService.IsDriver()) {
	            this.DataListModel.searchField = [
	                "licenceTag",
	                "translatedBookingType",
	                "reccuringID",
	                "translatedBookingStatus",
	                "bookingReferenceID",
	                "adminRemarks",
	                "driverRemarks",
	                "sharedVehicleGroup"
	            ];
	        }
	        else {
	        }
	        this.model = new booking_overviewlist_model_1.BookingOverviewList();
	        this.model.startDateTime = moment().format("DD-MM-YYYY 00:00");
	        this.model.endDateTime = moment()
	            .format("DD-MM-YYYY 23:59");
	        this.BookingTypeList = [
	            {
	                Key: this.translate.instant("LblNORMALBOOKINGTYPE"),
	                Value: "NORMAL"
	            },
	            {
	                Key: this.translate.instant("LblMAINTENANCEBOOKINGTYPE"),
	                Value: "MAINTENANCE"
	            },
	            {
	                Key: this.translate.instant("LblUNAVAILABLEBOOKINGTYPE"),
	                Value: "UNAVAILABLE"
	            }
	        ];
	        this.BookingStatusAll = [
	            {
	                Key: this.translate.instant("LblABORTED"),
	                Value: "ABORTED"
	            },
	            {
	                Key: this.translate.instant("LblCANCELLED"),
	                Value: "CANCELLED"
	            },
	            {
	                Key: this.translate.instant("LblCONFIRMED"),
	                Value: "CONFIRMED"
	            },
	            {
	                Key: this.translate.instant("LblFINISHED"),
	                Value: "FINISHED"
	            },
	            {
	                Key: this.translate.instant("LblNOSHOW"),
	                Value: "NOSHOW"
	            },
	            {
	                Key: this.translate.instant("LblPENDING"),
	                Value: "PENDING"
	            },
	            {
	                Key: this.translate.instant("LblREVOKED"),
	                Value: "REVOKED"
	            },
	            {
	                Key: this.translate.instant("LblRUNNING"),
	                Value: "RUNNING"
	            },
	            {
	                Key: this.translate.instant("LblREADYFORPAYMENT"),
	                Value: "READYFORPAYMENT"
	            }
	        ];
	        this.BookingStatusSpecialBooking = [
	            {
	                Key: "CANCELLED",
	                Value: "CANCELLED"
	            },
	            {
	                Key: "CONFIRMED",
	                Value: "CONFIRMED"
	            },
	            {
	                Key: "FINISHED",
	                Value: "FINISHED"
	            }
	        ];
	        this.BookingStatus = this.BookingStatusAll;
	        this.model.bookingTypeList = this.BookingTypeList.map(function (x) { return x.Value; });
	        this.model.bookingStatusList = this.BookingStatus.map(function (x) { return x.Value; });
	        console.log(this.model);
	        this.model = this.authService.AssignFromStorage(this.constructor.name + "_model", this.model);
	        this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
	        this.urlBooking = this.authService.GetURL(config_2.ApplicationRouteURL.URL_BOOKING);
	        this.urlDefaultPage = this.authService.GetURL(config_2.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlBooking = this.authService.GetURL(config_2.ApplicationRouteURL.URL_BOOKING);
	        this.urlBookingInformation = this.authService.GetURL(config_2.ApplicationRouteURL.URL_BOOKING_INFORMATION);
	        this.urlDriverBookingInformation = this.authService.GetURL(config_2.ApplicationRouteURL.URL_BOOKING_INFORMATION_DRIVER);
	        this.urlVehicleInfo = this.authService.GetURL(config_2.ApplicationRouteURL.URL_VEHICLE_INFO);
	        this.urlDriverInfo = this.authService.GetURL(config_2.ApplicationRouteURL.URL_PERSON_UPDATE);
	        this.urlSVGInfo = this.authService.GetURL(config_2.ApplicationRouteURL.URL_SVG_UPDATE);
	        this.LblSelect = this.translate.instant("LblSelect");
	        this.LblBookingType = this.translate.instant("LblBookingType");
	        this.LblStatus = this.translate.instant("LblStatus");
	        this.permission = config_1.Permission.PR_BOOKINGS_OVERVIEW;
	        this.searchLicenceTag = this.model.searchLicenceTagList.join();
	        this.searchDriverName = this.model.searchDriverNameList.join();
	        this.searchSVGName = this.model.searchSVGNameList.join();
	        this.itemPerPageList = config_2.WeGoConfig.GRID_PAGGING;
	        this.DataListModel.itemsPerPage = 10;
	        this.GetBookingOverview();
	        //  $('#selectbookingType').multiselect();
	    };
	    BookingOverviewComponent.prototype.SetDefaultFlatPickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = true;
	        flatPickrConfig.time_24hr = true;
	        //flatPickrConfig.enableSeconds = true;
	        flatPickrConfig.dateFormat = this.dateFormat;
	        flatPickrConfig.minuteIncrement = 1;
	        return flatPickrConfig;
	    };
	    BookingOverviewComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetBookingOverview();
	    };
	    BookingOverviewComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetBookingOverview();
	    };
	    BookingOverviewComponent.prototype.OnAdvancedSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, "", event.isReset);
	        this.GetBookingOverview();
	    };
	    BookingOverviewComponent.prototype.OnDateSearch = function () {
	        this.GetBookingOverview();
	    };
	    BookingOverviewComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        //this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetBookingOverview();
	    };
	    BookingOverviewComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.bookigService
	            .ExportBokingList(this.model, this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "Booking" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BookingOverviewComponent.prototype.GetBookingOverview = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.model.remarks = null;
	        this.model.bookingHashId = "";
	        this.model.bookingStatus = "";
	        this.model.bookingType = "";
	        this.bookigService
	            .GetBookingOverviewList(this.model, this.DataListModel)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.bookingList = res.data;
	                _this.isParentCheckEnable =
	                    _this.bookingList.filter(function (x) { return x.isBookingCancel; }).length > 0
	                        ? true
	                        : false;
	                _this.DataListModel.totalItems = res.totalRecords;
	                _this.DataListModel.infoMessage = res.error;
	                _this.isLoading = false;
	                _this.errorModel = null;
	            }
	            else {
	                _this.DataListModel.totalItems = res.totalRecords;
	                _this.DataListModel.infoMessage = _this.translate.instant("LblNoRecords");
	                _this.errorModel = res.error;
	                _this.isLoading = false;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BookingOverviewComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetBookingOverview();
	    };
	    BookingOverviewComponent.prototype.OnParentCheck = function (isChecked) {
	        this.bookingList
	            .filter(function (y) { return y.isBookingCancel; })
	            .forEach(function (x) { return (x.isChecked = isChecked); });
	    };
	    BookingOverviewComponent.prototype.onSubmit = function (forms) {
	        if (!this.SingleCancel) {
	            this.model.listOfBookingHashId = this.bookingList
	                .filter(function (x) { return x.isChecked; })
	                .map(function (x) { return x.bookingHashId; });
	            this.CancelBookings(JSON.stringify(this.model));
	        }
	        else {
	            this.CancelBookings(JSON.stringify(this.model));
	        }
	    };
	    BookingOverviewComponent.prototype.CancelBookings = function (formData) {
	        var _this = this;
	        this.isLoading = true;
	        this.bookigService.CancelBookings(formData).subscribe(function (res) {
	            if (res.data) {
	                _this.DataListModel.currentPage = 1;
	                _this.GetBookingOverview();
	                _this.cancelModal.hide();
	                _this.isLoading = false;
	                _this.popupMsg = _this.translate.instant("LblBookingCancelSuccess", [
	                    _this.module
	                ]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.errorModel = res.error;
	                _this.isLoading = false;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BookingOverviewComponent.prototype.ShowCancelModal = function () {
	        this.SingleCancel = false;
	        this.model.remarks = null;
	        this.errorModel = null;
	        this.cancelModal.show();
	    };
	    BookingOverviewComponent.prototype.HideCancelModal = function () {
	        this.cancelModal.hide();
	    };
	    BookingOverviewComponent.prototype.SuccessCancelModalClick = function () {
	        this.cancelModal.hide();
	    };
	    BookingOverviewComponent.prototype.onSubmitAbortRevoke = function (forms) {
	        this.RevokeAbortBooking(JSON.stringify(this.model));
	    };
	    BookingOverviewComponent.prototype.RevokeAbortBooking = function (formData) {
	        var _this = this;
	        this.isLoading = true;
	        this.bookigService.RevokeOrAbortBookings(formData).subscribe(function (res) {
	            if (res.data) {
	                _this.DataListModel.currentPage = 1;
	                _this.GetBookingOverview();
	                _this.revokeAborkModal.hide();
	                _this.isLoading = false;
	                _this.popupMsg =
	                    _this.popupMessage == config_2.BookingStatus.ABORTED
	                        ? _this.translate.instant("LblBookingAbortSuccess")
	                        : _this.translate.instant("LblBookingRevokeSuccess");
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.errorModel = res.error;
	                _this.isLoading = false;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BookingOverviewComponent.prototype.ShowAbort = function (bookingHashId, bookingStatus, localTimeZone) {
	        this.model.remarks = null;
	        this.model.bookingHashId = bookingHashId;
	        this.model.bookingStatus = config_2.BookingStatus.ABORTED;
	        this.model.localTimeZone = localTimeZone;
	        this.popupMessage = config_2.BookingStatus.ABORTED;
	        this.errorModel = null;
	        this.revokeAborkModal.show();
	    };
	    BookingOverviewComponent.prototype.ShowCancel = function (bookingHashId, bookingStatus) {
	        this.SingleCancel = true;
	        this.model.remarks = null;
	        this.errorModel = null;
	        this.model.listOfBookingHashId = [bookingHashId];
	        this.cancelModal.show();
	    };
	    BookingOverviewComponent.prototype.ShowRevoke = function (bookingHashId, bookingStatus) {
	        this.model.remarks = null;
	        this.model.bookingHashId = bookingHashId;
	        this.model.bookingStatus = config_2.BookingStatus.REVOKED;
	        this.popupMessage = config_2.BookingStatus.REVOKED;
	        this.errorModel = null;
	        this.revokeAborkModal.show();
	    };
	    BookingOverviewComponent.prototype.HideRevokeAbortModal = function () {
	        this.revokeAborkModal.hide();
	    };
	    BookingOverviewComponent.prototype.SuccessRevokeAbortModal = function () {
	        this.revokeAborkModal.hide();
	    };
	    //Addedd for remarksModal
	    BookingOverviewComponent.prototype.ShowRemakrsModal = function (remarks) {
	        this.remarks = remarks;
	        this.remarksModal.show();
	    };
	    BookingOverviewComponent.prototype.HideRemarksModal = function () {
	        this.remarks = null;
	        this.remarksModal.hide();
	    };
	    //Addedd for edit recurringbooking
	    BookingOverviewComponent.prototype.ShowBookingModal = function (isRecurringSeriesEditable, bookingHashId, recurringID) {
	        if (isRecurringSeriesEditable) {
	            if (bookingHashId)
	                this.bookingHashId = bookingHashId;
	            if (recurringID)
	                this.recurringId = recurringID;
	            this.editBookingModal.show();
	        }
	        else {
	            if (bookingHashId)
	                this.bookingHashId = bookingHashId;
	            this.router.navigate([this.urlBooking, { ref: this.bookingHashId }]);
	        }
	    };
	    BookingOverviewComponent.prototype.SuccessSingleBooking = function () {
	        this.editBookingModal.hide();
	        this.router.navigate([
	            this.urlBooking,
	            { ref: this.bookingHashId, isRecurring: false }
	        ]);
	    };
	    BookingOverviewComponent.prototype.SuccessRecurringBooking = function () {
	        this.editBookingModal.hide();
	        this.router.navigate([
	            this.urlBooking,
	            { ref: this.recurringId, isRecurring: true }
	        ]);
	    };
	    BookingOverviewComponent.prototype.HideBookingModal = function () {
	        this.editBookingModal.hide();
	    };
	    BookingOverviewComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    BookingOverviewComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    BookingOverviewComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    BookingOverviewComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	        this.authService.SaveToStorage(this.constructor.name + "_model", this.model);
	    };
	    BookingOverviewComponent.prototype.OnAdvancedReset = function (event) {
	        console.log($("#bookingType").val());
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, "", event.isReset);
	        this.model.searchDriverNameList = [];
	        this.searchDriverName = "";
	        this.model.driverHashId = "";
	        this.model.searchLicenceTagList = [];
	        this.searchLicenceTag = "";
	        this.model.vehicleHashId = "";
	        this.model.searchSVGNameList = [];
	        this.searchSVGName = "";
	        this.model.sharedVehicleGroupHashId = "";
	        this.model.startDateTime = moment().format("DD-MM-YYYY 00:00");
	        this.model.endDateTime = moment()
	            .add(+1, "M")
	            .format("DD-MM-YYYY 00:00");
	        this.model.bookingReferenceId = "";
	        this.model.bookingStatus = "";
	        this.model.bookingType = "";
	        this.model.searchDriverNameList = [];
	        this.searchDriverName = "";
	        this.model.searchLicenceTagList = [];
	        this.searchLicenceTag = "";
	        this.model.searchSVGNameList = [];
	        this.searchSVGName = "";
	        this.model.sharedVehicleGroupHashIdList = [];
	        this.model.vehicleHashIdList = [];
	        this.model.driverHashIdList = [];
	        this.model.bookingTypeList = this.BookingTypeList.map(function (x) { return x.Value; });
	        this.model.bookingStatusList = this.BookingStatus.map(function (x) { return x.Value; });
	        this.bookingTypeSelect.set(this.model.bookingTypeList);
	        this.bookingStatusSelect.set(this.model.bookingStatusList);
	        //this.bookingStatusSpecialSelect.set(this.model.bookingStatusList);
	        this.NormalBookingView = true;
	        this.GetBookingOverview();
	    };
	    BookingOverviewComponent.prototype.BookingTypeChange = function () {
	        if (!(this.model.bookingType == "" || this.model.bookingType == "NORMAL")) {
	            if (this.model.vehicleHashId != "") {
	                this.model.searchLicenceTagList = [];
	                this.searchLicenceTag = "";
	                this.model.vehicleHashId = "";
	            }
	            this.model.searchSVGNameList = [];
	            this.searchSVGName = "";
	            this.model.sharedVehicleGroupHashId = "";
	            this.NormalBookingView = false;
	            this.BookingStatus = this.BookingStatusSpecialBooking;
	            this.model.bookingStatus = "";
	        }
	        else {
	            this.BookingStatus = this.BookingStatusAll;
	            this.model.bookingStatus = "";
	            this.NormalBookingView = true;
	        }
	    };
	    BookingOverviewComponent.prototype.BookingTypeChangeMultiSelect = function () {
	        // if (this.model.bookingTypeList.indexOf("") > -1) {
	        //   this.model.bookingTypeList = this.BookingTypeList.map(x => x.Value);
	        // }
	        if (this.bookingStatusSelect) {
	            if (this.model.bookingTypeList.indexOf("NORMAL") > -1) {
	                this.NormalBookingView = true;
	            }
	            else {
	                this.NormalBookingView = false;
	            }
	        }
	        // this.bookingStatusSelect.render();
	        // this.bookingStatusSelect.setData(this.BookingStatus.map((x: any) => {
	        //   return {
	        //     text: x.Key,
	        //     value: x.Value,
	        //   };
	        // }));
	    };
	    BookingOverviewComponent.prototype.BookingStatusChanged = function () {
	        // if (this.model.bookingStatusList.indexOf("") > -1) {
	        //   this.model.bookingStatusList = this.BookingStatus.map(x => x.Value);
	        // }
	    };
	    BookingOverviewComponent.prototype.SuccessSelectVehicleModal = function ($event) {
	        this.model.searchLicenceTagList = $event.LicenceTage;
	        this.searchLicenceTag = this.model.searchLicenceTagList.join();
	        this.model.vehicleHashIdList = $event.VehicleMasterHashID;
	    };
	    BookingOverviewComponent.prototype.SuccessSelectDriverModal = function ($event) {
	        this.model.searchDriverNameList = $event.DriverName;
	        this.searchDriverName = this.model.searchDriverNameList.join();
	        this.model.driverHashIdList = $event.DriverHashID;
	    };
	    BookingOverviewComponent.prototype.SuccessSelectSvgModal = function ($event) {
	        this.model.searchSVGNameList = $event.SvgName;
	        this.searchSVGName = this.model.searchSVGNameList.join();
	        this.model.sharedVehicleGroupHashIdList = $event.SvgMasterHashID;
	    };
	    BookingOverviewComponent.prototype.ClearDriver = function () {
	        this.model.searchDriverNameList = [];
	        this.searchDriverName = "";
	        this.model.driverHashId = "";
	        this.model.driverHashIdList = [];
	    };
	    BookingOverviewComponent.prototype.ClearVehicle = function () {
	        this.model.searchLicenceTagList = [];
	        this.searchLicenceTag = "";
	        this.model.vehicleHashId = "";
	        this.model.vehicleHashIdList = [];
	    };
	    BookingOverviewComponent.prototype.ClearSvg = function () {
	        this.model.searchSVGNameList = [];
	        this.searchSVGName = "";
	        this.model.sharedVehicleGroupHashId = "";
	        this.model.sharedVehicleGroupHashIdList = [];
	    };
	    BookingOverviewComponent.prototype.ngAfterViewInit = function () {
	        var _this = this;
	        this.bookingTypeSelect = new SlimSelect({
	            select: "#bookingType",
	            placeholder: this.LblSelect + " " + this.LblBookingType,
	            showSearch: false,
	            onChange: function (info) {
	                _this.model.bookingTypeList = info.map(function (x) { return x.value; });
	                //console.log(info);
	            }
	        });
	        this.bookingTypeSelect.set(this.model.bookingTypeList);
	        this.RenderBookingStatus();
	        this.bookingStatusSelect.set(this.model.bookingStatusList);
	        //this.bookingStatusSpecialSelect.set(this.model.bookingStatusList);
	        // $('.' + this.bookingStatusSpecialSelect.config.id).css('display', 'none');
	        // $('.' + this.bookingStatusSelect.config.id).css('display', 'block');
	    };
	    BookingOverviewComponent.prototype.RenderBookingStatus = function () {
	        var _this = this;
	        // if (this.NormalBookingView) {
	        this.bookingStatusSelect = new SlimSelect({
	            select: "#bookingStatus",
	            placeholder: this.LblSelect + " " + this.LblStatus,
	            showSearch: false,
	            showContent: "down",
	            onChange: function (info) {
	                // if (this.NormalBookingView) {
	                _this.model.bookingStatusList = info.map(function (x) { return x.value; });
	                // }
	                //console.log(info);
	            }
	        });
	        // } else {
	        // this.bookingStatusSpecialSelect = new SlimSelect({
	        //   select: '#bookingStatusSpecial',
	        //   placeholder: this.LblSelect + " " + this.LblStatus,
	        //   showSearch: false,
	        //   onChange: (info: any) => {
	        //     if (!this.NormalBookingView) {
	        //       this.model.bookingStatusList = info.map((x: any) => x.value)
	        //     }
	        //     //console.log(info);
	        //   }
	        //   //showContent:'down'
	        // });
	        // }
	    };
	    __decorate([
	        core_1.ViewChild("cancelModal"), 
	        __metadata('design:type', Object)
	    ], BookingOverviewComponent.prototype, "cancelModal", void 0);
	    __decorate([
	        core_1.ViewChild("revokeAborkModal"), 
	        __metadata('design:type', Object)
	    ], BookingOverviewComponent.prototype, "revokeAborkModal", void 0);
	    __decorate([
	        core_1.ViewChild("remarksModal"), 
	        __metadata('design:type', Object)
	    ], BookingOverviewComponent.prototype, "remarksModal", void 0);
	    __decorate([
	        core_1.ViewChild("EditBookingModal"), 
	        __metadata('design:type', Object)
	    ], BookingOverviewComponent.prototype, "editBookingModal", void 0);
	    __decorate([
	        core_1.ViewChild("successPopup"), 
	        __metadata('design:type', Object)
	    ], BookingOverviewComponent.prototype, "successPopup", void 0);
	    BookingOverviewComponent = __decorate([
	        core_1.Component({
	            selector: "wego-booking-overview",
	            template: __webpack_require__(690),
	            providers: [booking_service_1.BookingService],
	            styles: [
	                "\n    .search-icon {\n        color:#2ba2aa;\n    }\n    .reset-icon {\n        color:#DD9933;\n    }\n    .export-icon {\n        color:#01A2D9;\n    }\n    .delete-icon {\n        color:#f00;\n    }\n    .cancel-icon {\n        color:#f00;\n    }\n    .add-icon {\n        color:#080;\n    }\n    .nopad-left{\n      padding-left: 0px;\n    }\n    "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof booking_service_1.BookingService !== 'undefined' && booking_service_1.BookingService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object])
	    ], BookingOverviewComponent);
	    return BookingOverviewComponent;
	    var _a, _b, _c, _d;
	}());
	exports.BookingOverviewComponent = BookingOverviewComponent;


/***/ },
/* 690 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ 'LblOverviewList' | translate }}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li class=\"active\">{{ 'LblOverviewList' | translate }}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25\">\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <p class=\"text-success\">{{ message }} </p>\r\n        <form (ngSubmit)=\"OnAdvancedSearch($event)\">\r\n          <div class=\"row\">\r\n\r\n            <div class=\"form-group col-md-2\">\r\n              <label>{{ 'LblBookingType' | translate }} </label>\r\n              <select id=\"bookingType\" name=\"bookingType\" (change)=\"BookingTypeChangeMultiSelect()\" multiple>\r\n                <option *ngFor=\"let item of BookingTypeList\" [attr.value]='item.Value'>{{item.Key}}</option>\r\n              </select>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'bookingType' }}</span>\r\n            </div>\r\n\r\n            <div class=\"form-group col-md-3 nopad-left\">\r\n              <label>{{ 'LblStatus' | translate }} </label>\r\n              <select id=\"bookingStatus\" name=\"bookingStatus\" (change)=\"BookingStatusChanged()\" multiple>\r\n                <option *ngFor=\"let item of BookingStatusAll\" [attr.value]='item.Value'>{{item.Key}}</option>\r\n              </select>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'bookingStatus' }}</span>\r\n            </div>\r\n\r\n            <div class=\"form-group col-md-1 nopad\">\r\n              &nbsp;\r\n              <div class=\"clearfix\"></div>\r\n              <div class=\"input-group\">\r\n                <label class=\"checkbox-inline\">\r\n                  <input type=\"checkbox\" [(ngModel)]=\"model.applyDateFilter\" name=\"applyDateFilter\"> {{ 'LblApplyDateFilter' | translate }}\r\n                </label>\r\n              </div>\r\n            </div>\r\n\r\n            <div *ngIf=\"model.applyDateFilter\" class=\"form-group col-md-2 nopad-left\">\r\n              <label>{{ 'LblFrom' | translate }}</label>\r\n              <div class=\"clearfix\"></div>\r\n              <div class=\"input-group\">\r\n                <span class=\"input-group-addon\">\r\n                  <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n                </span>\r\n                <input flatpickr readonly [Config]=\"flatPickrConfigFrom\" [(ngModel)]=\"model.startDateTime\" name=\"TimeBlockStartDate\" type=\"text\"\r\n                  class=\"form-control\" placeholder=\"{{ 'LblFrom' | translate }}\">\r\n              </div>\r\n            </div>\r\n            <div *ngIf=\"model.applyDateFilter\" class=\"form-group col-md-2 nopad-left\">\r\n              <label>{{ 'LblTo' | translate }}</label>\r\n              <div class=\"clearfix \"></div>\r\n              <div class=\"input-group\">\r\n                <span class=\"input-group-addon\">\r\n                  <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n                </span>\r\n                <input flatpickr readonly [Config]=\"flatPickrConfigTo\" [(ngModel)]=\"model.endDateTime\" name=\"TimeBlockEndtDate\" type=\"text\"\r\n                  class=\"form-control\" placeholder=\"{{ 'LblTo' | translate }}\">\r\n              </div>\r\n            </div>\r\n            <div class=\"form-group col-md-2 nopad-left\">\r\n              <label>{{ 'LblBookingReferenceId' | translate }}</label>\r\n              <div class=\"input-group\">\r\n                <input type=\"text\" class=\"form-control\" [(ngModel)]=\"model.bookingReferenceId\" name=\"bookingReferenceId\" autocomplete=\"off\"\r\n                  maxlength=\"100\">\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"clearfix\"></div>\r\n            <div *ngIf=\"NormalBookingView\" class=\"form-group col-md-4\">\r\n              <label>{{ 'LblSharedVehicleGroup' | translate }}</label>\r\n              <div class=\"input-group\">\r\n                <input [(ngModel)]=\"searchSVGName\" [attr.title]=\"searchSVGName\" name=\"sharedVehicleGroupHashId\" type=\"text\" class=\"form-control\"\r\n                  placeholder=\"{{ 'LblAll' | translate }} {{ 'LblSharedVehicleGroup' | translate }}\" readonly>\r\n                <div class=\"input-group-btn\">\r\n                  <button class=\"btn btn-default\" type=\"button\" (click)=\"selectSvgModal.show(model.sharedVehicleGroupHashIdList,model.searchSVGNameList,'', permission)\">\r\n                    <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\r\n                  </button>\r\n                  <button class=\"btn btn-default\" type=\"button\" (click)=\"ClearSvg()\">\r\n                    <i class=\"fa fa-eraser\" aria-hidden=\"true\"></i>\r\n                  </button>\r\n                </div>\r\n              </div>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'sharedVehicleGroupHashId' }}</span>\r\n            </div>\r\n            <div class=\"form-group\" [ngClass]=\"{'col-md-2 nopad-left': NormalBookingView , 'col-md-3': !NormalBookingView}\">\r\n              <label>\r\n                {{ 'LblVehicle' | translate }} </label>\r\n              <div class=\"input-group\">\r\n                <input [(ngModel)]=\"searchLicenceTag\" [attr.title]=\"searchLicenceTag\" name=\"vehicleHashId\" type=\"text\" class=\"form-control\"\r\n                  placeholder=\"{{ 'LblAll' | translate }} {{ 'LblVehicle' | translate }}\" readonly>\r\n                <div class=\"input-group-btn\">\r\n                  <button class=\"btn btn-default\" type=\"button\" (click)=\"selectVehicleModal.show(model.sharedVehicleGroupHashId,model.vehicleHashIdList,model.searchLicenceTagList)\">\r\n                    <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\r\n                  </button>\r\n                  <button class=\"btn btn-default\" type=\"button\" (click)=\"ClearVehicle()\">\r\n                    <i class=\"fa fa-eraser\" aria-hidden=\"true\"></i>\r\n                  </button>\r\n                </div>\r\n              </div>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'VehicleHashId' }}</span>\r\n            </div>\r\n            <div class=\"form-group nopad-left\" [ngClass]=\"{'col-md-2': NormalBookingView , 'col-md-3': !NormalBookingView}\">\r\n              <label>{{ 'LblDriver' | translate }}</label>\r\n              <div class=\"input-group\">\r\n                <input [(ngModel)]=\"searchDriverName\" [attr.title]=\"searchDriverName\" name=\"driverName\" type=\"text\" class=\"form-control\"\r\n                  placeholder=\"{{ 'LblAll' | translate }} {{ 'LblDriver' | translate }}\" readonly>\r\n                <div class=\"input-group-btn\">\r\n                  <button class=\"btn btn-default\" type=\"button\" (click)=\"selectDriverModal.show(model.driverHashIdList,model.searchDriverNameList)\">\r\n                    <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\r\n                  </button>\r\n                  <button class=\"btn btn-default\" type=\"button\" (click)=\"ClearDriver()\">\r\n                    <i class=\"fa fa-eraser\" aria-hidden=\"true\"></i>\r\n                  </button>\r\n                </div>\r\n              </div>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'DriverHashId' }}</span>\r\n            </div>\r\n\r\n            <div class=\"form-group col-md-4 nopad-left\" [ngClass]=\"{'col-md-offset-2 ': !NormalBookingView,'':NormalBookingView}\">\r\n              <div class=\"form-group col-md-9 nopad\">\r\n                <label>&nbsp;</label>\r\n                <div class=\"clearfix\"></div>\r\n                <button type=\"submit\" class=\"btn btn-default search-icon\">\r\n                  <i class=\"fa fa-search\" aria-hidden=\"true\"></i>\r\n                </button>\r\n                <button class=\"btn btn-default reset-icon\" type=\"button\" (click)=\"OnAdvancedReset($event)\">\r\n                  <i class=\"fa fa-eraser\" aria-hidden=\"true\"></i>\r\n                </button>\r\n                <button class=\"btn btn-default export-icon\" type=\"button\" (click)=\"OnExport($event)\" title=\"{{'LblExportAll(CSV)' | translate}}\">\r\n                  <i class=\"fa fa-download\" aria-hidden=\"true\"></i>\r\n                </button>\r\n                <!-- *ngIf=\"isDeleteAccess\" -->\r\n                <button [disabled]=\"!isAnyChecked\" class=\"btn btn-default cancel-icon\" type=\"button\" (click)=\"ShowCancelModal()\"\r\n                  title=\"{{'LblDeleteAllSelectedRecords' | translate}}\">\r\n                  <i class=\"fa fa-times\" aria-hidden=\"true\"></i>\r\n                </button>\r\n              </div>\r\n              <div class=\"form-group col-md-3 nopad\">\r\n                <label>&nbsp;</label>\r\n                <select class=\"form-control\" title='Items Per Page' [(ngModel)]=\"DataListModel.itemsPerPage\" name=\"itemPerPage\" (change)=\"OnPagingChange($event.target.value)\">\r\n                  <option *ngFor=\"let item of itemPerPageList\" [attr.value]='item.value'>{{ item }}</option>\r\n                </select>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </form>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                  <!-- *ngIf=\"isDeleteAccess\" -->\r\n                <th class=\"text-center parent-checkbox\">\r\n                  <input type=\"checkbox\" [(ngModel)]=\"isParentCheck\" [disabled]=\"!isParentCheckEnable\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\">\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('BookingReferenceId')\">\r\n                  {{ 'LblBookingReferenceId' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'BookingReferenceId'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('startDateTimeUTC')\">\r\n                  {{ 'LblFrom' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'startDateTimeUTC'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('endDateTimeUTC')\">\r\n                  {{ 'LblTo' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'endDateTimeUTC'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('translatedBookingStatus')\">\r\n                  {{ 'LblStatus' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'translatedBookingStatus'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('licenceTag')\">\r\n                  {{ 'LblVehicle' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'licenceTag'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th *ngIf=\"!authService.IsDriver()\" class=\"cursor-pointer\" (click)=\"OnSort('driver')\">\r\n                  {{ 'LblDriver' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'driver'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th *ngIf=\"!authService.IsDriver()\" class=\"cursor-pointer\" (click)=\"OnSort('sharedVehicleGroup')\">\r\n                  {{ 'LblSharedVehicleGroup' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'sharedVehicleGroup'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th *ngIf=\"!authService.IsDriver()\" class=\"cursor-pointer\" (click)=\"OnSort('translatedBookingType')\">\r\n                  {{ 'LblType' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'translatedBookingType'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th *ngIf=\"!authService.IsDriver()\" class=\"text-center\">{{ 'LblCancel' | translate }}\\{{ 'LblAbort' | translate }}</th>\r\n                <th *ngIf=\"!authService.IsDriver()\" class=\"text-center\">{{ 'LblRevoke' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblEdit' | translate }}</th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let bookings of bookingList\">\r\n                    <!-- *ngIf=\"isDeleteAccess\" -->\r\n                  <td class=\"text-center\">\r\n                    <input [disabled]=\"!bookings.isBookingCancel\" type=\"checkbox\" name=\"isActive\" [(ngModel)]=\"bookings.isChecked\">\r\n                  </td>\r\n                  <td>\r\n                    <span>\r\n                      <!--<i *ngIf=\"bookings.reccuringID\" class=\"fa fa-refresh fa-fw text-success\"></i>-->\r\n                      <a [routerLink]=\"urlBookingInformation+'/'+ bookings.bookingHashId\">\r\n                        {{ bookings.bookingReferenceID }}\r\n                      </a>\r\n                    </span>\r\n                  </td>\r\n                  <td>{{ bookings.startDateTime}}</td>\r\n                  <td>{{ bookings.endDateTime }}</td>\r\n                  <td>{{ bookings.translatedBookingStatus }}</td>\r\n                  <!--<td>{{ bookings.reccuringID }}</td>-->\r\n                  <td>\r\n                    <template [ngIf]=\"!bookings.isVehicleDeleted && bookings.isVehicleEdit\">\r\n                      <span>\r\n                        <a [routerLink]=\"urlVehicleInfo +'/'+ bookings.vehicleHashId\">\r\n                          {{ bookings.licenceTag }}\r\n                        </a>\r\n                      </span>\r\n                    </template>\r\n                    <template [ngIf]=\"bookings.isVehicleDeleted  || !bookings.isVehicleEdit\">\r\n                      {{ bookings.licenceTag }}\r\n                    </template>\r\n                  </td>\r\n                  <td>\r\n                    <template [ngIf]=\"!bookings.isPersonDeleted && bookings.isDriverEdit\">\r\n                      <a [routerLink]=\"urlDriverInfo+'/'+ bookings.driverHashId\">\r\n                        {{ bookings.driver }}\r\n                      </a>\r\n                    </template>\r\n                    <template [ngIf]=\"bookings.isPersonDeleted || !bookings.isDriverEdit\">\r\n                      {{ bookings.driver }}\r\n                    </template>\r\n                  </td>\r\n                  <td *ngIf=\"!authService.IsDriver()\">\r\n                    <template [ngIf]=\"!bookings.isSharedVehicleGroupDeleted && bookings.isSvgEdit\">\r\n                      <a [routerLink]=\"urlSVGInfo+'/'+ bookings.sharedVehicleGroupHashId\">\r\n                        {{ bookings.sharedVehicleGroup }}\r\n                      </a>\r\n                    </template>\r\n                    <template [ngIf]=\"bookings.isSharedVehicleGroupDeleted || !bookings.isSvgEdit\">\r\n                      {{ bookings.sharedVehicleGroup }}\r\n                    </template>\r\n                  </td>\r\n                  <td *ngIf=\"!authService.IsDriver()\">{{ bookings.translatedBookingType }}</td>\r\n                  <template [ngIf]=\"!authService.IsDriver()\">\r\n                    <td class=\"text-center\">\r\n                      <button *ngIf=\"bookings.isBookingAbort\" class=\"btn btn-info btn-xs\" (click)=\"ShowAbort(bookings.bookingHashId,bookings.bookingStatus,bookings.localTimeZone)\">{{ 'LblAbort' | translate }}</button>\r\n                      <button *ngIf=\"!bookings.isBookingAbort && bookings.isBookingCancel\" class=\"btn btn-danger btn-xs\" (click)=\"ShowCancel(bookings.bookingHashId,bookings.bookingStatus)\">{{ 'LblCancel' | translate }}</button>\r\n                    </td>\r\n                    <td class=\"text-center\">\r\n                      <button *ngIf=\"bookings.isBookingRevoke\" class=\"btn btn-info btn-xs\" (click)=\"ShowRevoke(bookings.bookingHashId,bookings.bookingStatus)\">{{ 'LblRevoke' | translate }}</button>\r\n                    </td>\r\n\r\n                  </template>\r\n                  <td *ngIf=\"bookings.reccuringID==null\" class=\"text-center\">\r\n                    <a *ngIf=\"bookings.isBookingEditable && bookings.bookingType=='NORMAL'\" [routerLink]=\"[urlBooking,{ ref : bookings.bookingHashId }]\">\r\n                      <i class=\"fa fa-pencil-square-o fa-fw\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td *ngIf=\"bookings.reccuringID!=null\" class=\"text-center\">\r\n                    <a class=\"cursor-pointer\" *ngIf=\"bookings.isBookingEditable && bookings.bookingType=='NORMAL'\" (click)=\"ShowBookingModal(bookings.isRecurringSeriesEditable,bookings.bookingHashId, bookings.reccuringID)\">\r\n                      <i class=\"fa fa-pencil-square-o fa-fw\"></i>\r\n                    </a>\r\n                  </td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"12\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div> \r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<div bsModal #cancelModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\"\r\n  [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-sm\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"HideCancelModal()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblConfirm' | translate }}</h4>\r\n      </div>\r\n      <form (ngSubmit)=\"onSubmit(CancelBookingForm.value)\" #CancelBookingForm=\"ngForm\">\r\n        <div class=\"modal-body\">\r\n          <div class=\"row\">\r\n            <div class=\"col-xs-12 form-group\">\r\n              {{ 'LblConfirmMessage' | translate }} {{ 'LblCancel' | translate }} {{ 'LblBooking' | translate }}?\r\n            </div>\r\n            <div class=\"col-xs-12 form-group\">\r\n              <textarea class=\"form-control\" id=\"comment\" [(ngModel)]=\"model.remarks\" name=\"remarks\" placeholder=\"{{ 'LblRemarks' | translate }}\"></textarea>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'remarks' }}</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"modal-footer\">\r\n          <button type=\"submit\" class=\"btn btn-primary\">{{ 'LblYes' | translate }}</button>\r\n          <button type=\"button\" class=\"btn btn-default\" (click)=\"HideCancelModal()\">{{ 'LblNo' | translate }}</button>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div bsModal #revokeAborkModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-sm\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"HideRevokeAbortModal()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblConfirm' | translate }}</h4>\r\n      </div>\r\n      <form (ngSubmit)=\"onSubmitAbortRevoke(revokeAbortBookingForm.value)\" #revokeAbortBookingForm=\"ngForm\">\r\n        <div class=\"modal-body\">\r\n          <div class=\"row\">\r\n            <div class=\"col-xs-12 form-group\">\r\n              {{ 'LblConfirmMessage' | translate }} {{ popupMessage}} {{ 'LblBooking' | translate }}?\r\n            </div>\r\n            <div class=\"col-xs-12 form-group\">\r\n              <textarea class=\"form-control\" id=\"comment\" [(ngModel)]=\"model.remarks\" name=\"remarks\" placeholder=\"{{ 'LblRemarks' | translate }}\"></textarea>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'remarks' }}</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"modal-footer\">\r\n          <button type=\"submit\" class=\"btn btn-green cursor-pointer\">{{ 'LblYes' | translate }}</button>\r\n          <button type=\"button\" class=\"btn btn-gray cursor-pointer\" (click)=\"HideRevokeAbortModal()\">{{ 'LblNo' | translate }}</button>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div bsModal #remarksModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-sm\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"HideRemarksModal()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{'LblRemarks'| translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        {{remarks}}\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div bsModal #EditBookingModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-sm\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"HideBookingModal()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblEdit' | translate }} {{ 'LblBooking' | translate }} </h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <div class=\"row mar_bot_10\">\r\n          <div class=\"col-xs-12\">\r\n            <button type=\"button\" class=\"btn btn-primary col-xs-12\" (click)=\"SuccessSingleBooking()\"> {{ 'LblSingle' | translate }} {{ 'LblBooking' | translate }}</button>\r\n          </div>\r\n        </div>\r\n        <div class=\"row\">\r\n          <div class=\"col-xs-12\">\r\n            <button type=\"button\" class=\"btn btn-primary col-xs-12\" (click)=\"SuccessRecurringBooking()\">{{ 'LblSeries' | translate }} {{ 'LblBooking' | translate }}</button>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n<wego-booking-driver-popup #selectDriverModal (OnSuccessSelect)=\"SuccessSelectDriverModal($event)\"></wego-booking-driver-popup>\r\n<wego-booking-vehicle-popup #selectVehicleModal (OnSuccessSelect)=\"SuccessSelectVehicleModal($event)\"></wego-booking-vehicle-popup>\r\n<wego-booking-svg-popup #selectSvgModal (OnSuccessSelect)=\"SuccessSelectSvgModal($event)\"></wego-booking-svg-popup>";

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var flatpickr_model_1 = __webpack_require__(83);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var booking_service_1 = __webpack_require__(556);
	var booking_overviewlist_model_1 = __webpack_require__(573);
	var config_1 = __webpack_require__(60);
	var booking_approve_model_1 = __webpack_require__(692);
	var $ = __webpack_require__(68);
	var moment = __webpack_require__(84);
	var SlimSelect = __webpack_require__(616);
	var BookingRequestComponent = (function () {
	    function BookingRequestComponent(authService, bookigService, router, translate) {
	        this.authService = authService;
	        this.bookigService = bookigService;
	        this.router = router;
	        this.translate = translate;
	        this.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
	        this.model = new booking_overviewlist_model_1.BookingOverviewList();
	        this.remarkslength = 15;
	        this.NormalBookingView = true;
	        this.dropdownSettings = {};
	    }
	    Object.defineProperty(BookingRequestComponent.prototype, "isAnyChecked", {
	        get: function () {
	            if (this.bookingList) {
	                var isCheck = this.bookingList.some(function (x) { return x.isChecked == true; });
	                if (isCheck) {
	                    if (this.bookingList
	                        .filter(function (y) { return y.isBookingCancel; })
	                        .every(function (x) { return x.isChecked == true; }))
	                        this.isParentCheck = true;
	                    else
	                        this.isParentCheck = false;
	                }
	                else {
	                    this.isParentCheck = false;
	                }
	                return isCheck;
	            }
	            else {
	                this.isParentCheck = false;
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BookingRequestComponent.prototype.ngOnInit = function () {
	        this.module = this.translate.instant('LblBooking');
	        //this.urlPersonInfo = 
	        this.approvedSuccessPopupMsg = this.translate.instant('LblBookingApprovedSuccessMsg');
	        this.rejectedSuccessPopupMsg = this.translate.instant('LblBookingRejectedSuccessMsg');
	        this.bookingApproveModel = new booking_approve_model_1.BookingApproveModel();
	        this.LblSelectionRequired = this.translate.instant('LblSelectionRequired');
	        this.SelectionRequiredMsg = this.translate.instant('SelectionRequiredMsg');
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        if (this.authService.IsDriver()) {
	            this.DataListModel.searchField = [
	                'licenceTag',
	                'reccuringID',
	                'bookingStatus',
	                'bookingReferenceID',
	                'adminRemarks',
	                'driverRemarks',
	                'sharedVehicleGroup'
	            ];
	        }
	        else {
	        }
	        this.model = new booking_overviewlist_model_1.BookingOverviewList();
	        this.model.startDateTime = moment().format('DD-MM-YYYY 00:00');
	        this.model.endDateTime = moment()
	            .add(+1, 'M')
	            .format('DD-MM-YYYY 00:00');
	        this.BookingStatusAll = [
	            {
	                Key: this.translate.instant("LblAPPROVEDBOOKINGREQUEST"),
	                Value: 'CONFIRMED'
	            },
	            {
	                Key: this.translate.instant("LblREJECTEDBOOKINGREQUEST"),
	                Value: 'CANCELLED'
	            },
	            {
	                Key: this.translate.instant("LblPENDINGBOOKINGREQUEST"),
	                Value: 'PENDING'
	            }
	        ];
	        this.BookingStatus = this.BookingStatusAll;
	        this.model.bookingStatusList = this.BookingStatus.map(function (x) { return x.Value; });
	        console.log(this.model);
	        this.model = this.authService.AssignFromStorage(this.constructor.name + '_model', this.model);
	        this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
	        this.urlBooking = this.authService.GetURL(config_1.ApplicationRouteURL.URL_BOOKING);
	        this.urlPersonInfo = this.authService.GetURL(config_1.ApplicationRouteURL.URL_PERSON_UPDATE);
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlBooking = this.authService.GetURL(config_1.ApplicationRouteURL.URL_BOOKING);
	        this.urlBookingInformation = this.authService.GetURL(config_1.ApplicationRouteURL.URL_BOOKING_INFORMATION);
	        this.urlDriverBookingInformation = this.authService.GetURL(config_1.ApplicationRouteURL.URL_BOOKING_INFORMATION_DRIVER);
	        this.urlVehicleInfo = this.authService.GetURL(config_1.ApplicationRouteURL.URL_VEHICLE_INFO);
	        this.urlDriverInfo = this.authService.GetURL(config_1.ApplicationRouteURL.URL_PERSON_UPDATE);
	        this.urlSVGInfo = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SVG_UPDATE);
	        this.LblSelect = this.translate.instant('LblSelect');
	        this.LblStatus = this.translate.instant('LblStatus');
	        this.searchLicenceTag = this.model.searchLicenceTagList.join();
	        this.searchAdminName = this.model.searchAdminNameList.join();
	        this.searchSVGName = this.model.searchSVGNameList.join();
	        this.itemPerPageList = config_1.WeGoConfig.GRID_PAGGING;
	        this.DataListModel.itemsPerPage = 10;
	        this.GetBookingRequestList();
	    };
	    BookingRequestComponent.prototype.SetDefaultFlatPickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = true;
	        flatPickrConfig.time_24hr = true;
	        //flatPickrConfig.enableSeconds = true;
	        flatPickrConfig.dateFormat = this.dateFormat;
	        flatPickrConfig.minuteIncrement = 1;
	        return flatPickrConfig;
	    };
	    BookingRequestComponent.prototype.ApproveRejectMultipleBookingRequest = function () {
	        var _this = this;
	        this.HideApproveConfirnmationModel();
	        this.bookigService
	            .ApproveRejectMultipleBookingRequest(this.bookingApproveModel)
	            .subscribe(function (res) {
	            if (res.data) {
	                if (_this.bookingApproveModel.isApproved)
	                    _this.successpopupMsg = _this.approvedSuccessPopupMsg;
	                else
	                    _this.successpopupMsg = _this.rejectedSuccessPopupMsg;
	                _this.HideRejectReasonModel();
	                _this.ShowSuccessPopup();
	                _this.GetBookingRequestList();
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    BookingRequestComponent.prototype.HideApproveConfirnmationModel = function () {
	        this.approveConfirnmationModal.hide();
	    };
	    BookingRequestComponent.prototype.HideRejectReasonModel = function () {
	        this.bookingApproveModel.adminRemarks = '';
	        this.rejectReasonModal.hide();
	    };
	    BookingRequestComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetBookingRequestList();
	    };
	    BookingRequestComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetBookingRequestList();
	    };
	    BookingRequestComponent.prototype.OnAdvancedSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, '', event.isReset);
	        this.GetBookingRequestList();
	    };
	    BookingRequestComponent.prototype.OnDateSearch = function () {
	        this.GetBookingRequestList();
	    };
	    BookingRequestComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        //this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetBookingRequestList();
	    };
	    BookingRequestComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.bookigService
	            .ExportBokingRequestList(this.model, this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = 'Booking Request' + new Date().toISOString() + '.csv';
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BookingRequestComponent.prototype.GetBookingRequestList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.model.remarks = null;
	        this.model.bookingHashId = '';
	        this.model.bookingStatus = '';
	        this.bookigService
	            .GetBookingRequestList(this.model, this.DataListModel)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.bookingList = res.data;
	                _this.isParentCheckEnable =
	                    _this.bookingList.filter(function (x) { return x.isApproverejectEnable; }).length > 0
	                        ? true
	                        : false;
	                _this.DataListModel.totalItems = res.totalRecords;
	                _this.DataListModel.infoMessage = res.error;
	                _this.isLoading = false;
	                _this.errorModel = null;
	            }
	            else {
	                _this.DataListModel.totalItems = res.totalRecords;
	                _this.DataListModel.infoMessage = _this.translate.instant('LblNoRecords');
	                _this.errorModel = res.error;
	                _this.isLoading = false;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BookingRequestComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetBookingRequestList();
	    };
	    BookingRequestComponent.prototype.OnParentCheck = function (isChecked) {
	        this.bookingList
	            .filter(function (y) { return y.isApproverejectEnable; })
	            .forEach(function (x) { return (x.isChecked = isChecked); });
	    };
	    BookingRequestComponent.prototype.onSubmitClick = function (isApprove) {
	        this.bookingApproveModel.bookingMasterHashIds = this.bookingList
	            .filter(function (x) { return x.isChecked; })
	            .map(function (x) { return x.bookingHashId; });
	        if (this.bookingApproveModel.bookingMasterHashIds.length == 0) {
	            this.selectionRequiredPopup.show();
	            return false;
	        }
	        this.bookingApproveModel.isApproved = isApprove == 1 ? true : false;
	        if (this.bookingApproveModel.isApproved)
	            this.approveConfirnmationModal.show();
	        else
	            this.rejectReasonModal.show();
	    };
	    //Addedd for remarksModal
	    BookingRequestComponent.prototype.ShowRemakrsModal = function (remarks) {
	        this.remarks = remarks;
	        this.remarksModal.show();
	    };
	    BookingRequestComponent.prototype.HideRemarksModal = function () {
	        this.remarks = null;
	        this.remarksModal.hide();
	    };
	    BookingRequestComponent.prototype.SuccessSingleBooking = function () {
	        this.editBookingModal.hide();
	        this.router.navigate([
	            this.urlBooking,
	            { ref: this.bookingHashId, isRecurring: false }
	        ]);
	    };
	    BookingRequestComponent.prototype.SuccessRecurringBooking = function () {
	        this.editBookingModal.hide();
	        this.router.navigate([
	            this.urlBooking,
	            { ref: this.recurringId, isRecurring: true }
	        ]);
	    };
	    BookingRequestComponent.prototype.HideBookingModal = function () {
	        this.editBookingModal.hide();
	    };
	    BookingRequestComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    BookingRequestComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    BookingRequestComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    BookingRequestComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	        this.authService.SaveToStorage(this.constructor.name + '_model', this.model);
	    };
	    BookingRequestComponent.prototype.OnAdvancedReset = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, '', event.isReset);
	        this.model.searchAdminNameList = [];
	        this.searchAdminName = '';
	        this.model.adminHashIdList = [];
	        this.searchDriverName = '';
	        this.model.driverHashId = '';
	        this.model.adminHashId = '';
	        this.model.searchLicenceTagList = [];
	        this.searchLicenceTag = '';
	        this.model.vehicleHashId = '';
	        this.model.searchSVGNameList = [];
	        this.searchSVGName = '';
	        this.model.sharedVehicleGroupHashId = '';
	        this.model.startDateTime = moment().format('DD-MM-YYYY 00:00');
	        this.model.endDateTime = moment()
	            .add(+1, 'M')
	            .format('DD-MM-YYYY 00:00');
	        this.model.bookingReferenceId = '';
	        this.model.bookingStatus = '';
	        this.model.searchAdminNameList = [];
	        this.searchDriverName = '';
	        this.model.searchLicenceTagList = [];
	        this.searchLicenceTag = '';
	        this.model.searchSVGNameList = [];
	        this.searchSVGName = '';
	        this.model.sharedVehicleGroupHashIdList = [];
	        this.model.vehicleHashIdList = [];
	        this.model.driverHashIdList = [];
	        this.model.bookingStatusList = this.BookingStatus.map(function (x) { return x.Value; });
	        this.bookingStatusSelect.set(this.model.bookingStatusList);
	        this.NormalBookingView = true;
	        this.GetBookingRequestList();
	    };
	    BookingRequestComponent.prototype.BookingStatusChanged = function () { };
	    BookingRequestComponent.prototype.SuccessSelectVehicleModal = function ($event) {
	        this.model.searchLicenceTagList = $event.LicenceTage;
	        this.searchLicenceTag = this.model.searchLicenceTagList.join();
	        this.model.vehicleHashIdList = $event.VehicleMasterHashID;
	    };
	    BookingRequestComponent.prototype.SuccessSelectAdminModal = function ($event) {
	        this.model.searchAdminNameList = $event.UserName;
	        this.searchAdminName = this.model.searchAdminNameList.join();
	        this.model.adminHashIdList = $event.PersonHashID;
	    };
	    BookingRequestComponent.prototype.SuccessSelectDriverModal = function ($event) {
	        this.model.searchDriverNameList = $event.DriverName;
	        this.searchDriverName = this.model.searchDriverNameList.join();
	        this.model.driverHashIdList = $event.DriverHashID;
	    };
	    BookingRequestComponent.prototype.SuccessSelectSvgModal = function ($event) {
	        this.model.searchSVGNameList = $event.SvgName;
	        this.searchSVGName = this.model.searchSVGNameList.join();
	        this.model.sharedVehicleGroupHashIdList = $event.SvgMasterHashID;
	    };
	    BookingRequestComponent.prototype.ClearDriver = function () {
	        this.model.searchDriverNameList = [];
	        this.searchDriverName = '';
	        this.model.driverHashId = '';
	        this.model.driverHashIdList = [];
	    };
	    BookingRequestComponent.prototype.ClearAdmin = function () {
	        this.model.searchAdminNameList = [];
	        this.searchAdminName = '';
	        this.model.adminHashId = '';
	        this.model.adminHashIdList = [];
	    };
	    BookingRequestComponent.prototype.ClearVehicle = function () {
	        this.model.searchLicenceTagList = [];
	        this.searchLicenceTag = '';
	        this.model.vehicleHashId = '';
	        this.model.vehicleHashIdList = [];
	    };
	    BookingRequestComponent.prototype.ClearSvg = function () {
	        this.model.searchSVGNameList = [];
	        this.searchSVGName = '';
	        this.model.sharedVehicleGroupHashId = '';
	        this.model.sharedVehicleGroupHashIdList = [];
	    };
	    BookingRequestComponent.prototype.ngAfterViewInit = function () {
	        this.RenderBookingStatus();
	        this.bookingStatusSelect.set(this.model.bookingStatusList);
	    };
	    BookingRequestComponent.prototype.RenderBookingStatus = function () {
	        var _this = this;
	        this.bookingStatusSelect = new SlimSelect({
	            select: '#bookingStatus',
	            placeholder: this.LblSelect + ' ' + this.LblStatus,
	            showSearch: false,
	            showContent: 'down',
	            onChange: function (info) {
	                _this.model.bookingStatusList = info.map(function (x) { return x.value; });
	            }
	        });
	    };
	    __decorate([
	        core_1.ViewChild('remarksModal'), 
	        __metadata('design:type', Object)
	    ], BookingRequestComponent.prototype, "remarksModal", void 0);
	    __decorate([
	        core_1.ViewChild('EditBookingModal'), 
	        __metadata('design:type', Object)
	    ], BookingRequestComponent.prototype, "editBookingModal", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], BookingRequestComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild('selectionRequiredPopup'), 
	        __metadata('design:type', Object)
	    ], BookingRequestComponent.prototype, "selectionRequiredPopup", void 0);
	    __decorate([
	        core_1.ViewChild('approveConfirnmationModal'), 
	        __metadata('design:type', Object)
	    ], BookingRequestComponent.prototype, "approveConfirnmationModal", void 0);
	    __decorate([
	        core_1.ViewChild('rejectReasonModal'), 
	        __metadata('design:type', Object)
	    ], BookingRequestComponent.prototype, "rejectReasonModal", void 0);
	    BookingRequestComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-request-overview',
	            template: __webpack_require__(693),
	            providers: [booking_service_1.BookingService],
	            styles: [
	                "\n    .search-icon {\n        color:#2ba2aa;\n    }\n    .reset-icon {\n        color:#DD9933;\n    }\n    .export-icon {\n        color:#01A2D9;\n    }\n    .delete-icon {\n        color:#f00;\n    }\n    .cancel-icon {\n        color:#f00;\n    }\n    .add-icon {\n        color:#080;\n    }\n    .nopad-left{\n      padding-left: 0px;\n    }\n    "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof booking_service_1.BookingService !== 'undefined' && booking_service_1.BookingService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object])
	    ], BookingRequestComponent);
	    return BookingRequestComponent;
	    var _a, _b, _c, _d;
	}());
	exports.BookingRequestComponent = BookingRequestComponent;


/***/ },
/* 692 */
/***/ function(module, exports) {

	"use strict";
	var BookingApproveModel = (function () {
	    function BookingApproveModel() {
	        this.bookingMasterHashIds = [];
	        this.isApproved = true;
	        this.isReccuring = false;
	    }
	    return BookingApproveModel;
	}());
	exports.BookingApproveModel = BookingApproveModel;


/***/ },
/* 693 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n    <section class=\"content-header\">\r\n        <div class=\"col-md-9 col-sm-6\">\r\n            <h1 class=\"pagename\">{{ 'LblBookingRequestList' | translate }}</h1>\r\n            <ol class=\"breadcrumb\">\r\n                <li>\r\n                    <a [routerLink]=\"urlDefaultPage\">\r\n                        <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n                </li>\r\n                <li class=\"active\">{{ 'LblBookingRequestList' | translate }}</li>\r\n            </ol>\r\n        </div>\r\n        <div class=\"col-md-3 col-sm-6 mar_t_25\">\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n        <div class=\"clearfix\"></div>\r\n    </section>\r\n    <section class=\"content\">\r\n        <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n                <p class=\"text-success\">{{ message }} </p>\r\n                <form (ngSubmit)=\"OnAdvancedSearch($event)\">\r\n                    <div class=\"row\">\r\n                        <div class=\"form-group col-md-3\">\r\n                            <label>{{ 'LblStatus' | translate }} </label>\r\n                            <select id=\"bookingStatus\" name=\"bookingStatus\" (change)=\"BookingStatusChanged()\" multiple>\r\n                                <option *ngFor=\"let item of BookingStatusAll\" [attr.value]='item.Value'>{{item.Key}}</option>\r\n                            </select>\r\n                            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'bookingStatus' }}</span>\r\n                        </div>\r\n\r\n                        <div class=\"form-group col-md-1 nopad\">\r\n                            &nbsp;\r\n                            <div class=\"clearfix\"></div>\r\n                            <div class=\"input-group\">\r\n                                <label class=\"checkbox-inline\">\r\n                                    <input type=\"checkbox\" [(ngModel)]=\"model.applyDateFilter\" name=\"applyDateFilter\"> {{ 'LblApplyDateFilter' | translate }}\r\n                                </label>\r\n                            </div>\r\n                        </div>\r\n\r\n                        <div *ngIf=\"model.applyDateFilter\" class=\"form-group col-md-2 nopad-left\">\r\n                            <label>{{ 'LblFrom' | translate }}</label>\r\n                            <div class=\"clearfix\"></div>\r\n                            <div class=\"input-group\">\r\n                                <span class=\"input-group-addon\">\r\n                                    <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n                                </span>\r\n                                <input flatpickr readonly [Config]=\"flatPickrConfigFrom\" [(ngModel)]=\"model.startDateTime\" name=\"TimeBlockStartDate\" type=\"text\"\r\n                                    class=\"form-control\" placeholder=\"{{ 'LblFrom' | translate }}\">\r\n                            </div>\r\n                        </div>\r\n                        <div *ngIf=\"model.applyDateFilter\" class=\"form-group col-md-2 nopad-left\">\r\n                            <label>{{ 'LblTo' | translate }}</label>\r\n                            <div class=\"clearfix \"></div>\r\n                            <div class=\"input-group\">\r\n                                <span class=\"input-group-addon\">\r\n                                    <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n                                </span>\r\n                                <input flatpickr readonly [Config]=\"flatPickrConfigTo\" [(ngModel)]=\"model.endDateTime\" name=\"TimeBlockEndtDate\" type=\"text\"\r\n                                    class=\"form-control\" placeholder=\"{{ 'LblTo' | translate }}\">\r\n                            </div>\r\n                        </div>\r\n                        <div class=\"form-group col-md-2 nopad-left\">\r\n                            <label>{{ 'LblBookingReferenceId' | translate }}</label>\r\n                            <div class=\"input-group\">\r\n                                <input type=\"text\" class=\"form-control\" [(ngModel)]=\"model.bookingReferenceId\" name=\"bookingReferenceId\" autocomplete=\"off\"\r\n                                    maxlength=\"100\">\r\n                            </div>\r\n                        </div>\r\n\r\n\r\n                        <div class=\"form-group nopad-left\" [ngClass]=\"{'col-md-2': NormalBookingView , 'col-md-3': !NormalBookingView}\">\r\n                            <label>Admin</label>\r\n                            <div class=\"input-group\">\r\n                                <input [(ngModel)]=\"searchAdminName\" [attr.title]=\"searchAdminName\" name=\"userName\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblAll' | translate }} Admin\"\r\n                                    readonly>\r\n                                <div class=\"input-group-btn\">\r\n                                    <button class=\"btn btn-default\" type=\"button\" (click)=\"selectadminModal.show(model.adminHashIdList,model.searchAdminNameList)\">\r\n                                        <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\r\n                                    </button>\r\n                                    <button class=\"btn btn-default\" type=\"button\" (click)=\"ClearAdmin()\">\r\n                                        <i class=\"fa fa-eraser\" aria-hidden=\"true\"></i>\r\n                                    </button>\r\n                                </div>\r\n                            </div>\r\n                            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'DriverHashId' }}</span>\r\n                        </div>\r\n\r\n                        <div class=\"clearfix\"></div>\r\n                        <div *ngIf=\"NormalBookingView\" class=\"form-group col-md-4\">\r\n                            <label>{{ 'LblSharedVehicleGroup' | translate }}</label>\r\n                            <div class=\"input-group\">\r\n                                <input [(ngModel)]=\"searchSVGName\" [attr.title]=\"searchSVGName\" name=\"sharedVehicleGroupHashId\" type=\"text\" class=\"form-control\"\r\n                                    placeholder=\"{{ 'LblAll' | translate }} {{ 'LblSharedVehicleGroup' | translate }}\" readonly>\r\n                                <div class=\"input-group-btn\">\r\n                                    <button class=\"btn btn-default\" type=\"button\" (click)=\"selectSvgModal.show(model.sharedVehicleGroupHashIdList,model.searchSVGNameList)\">\r\n                                        <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\r\n                                    </button>\r\n                                    <button class=\"btn btn-default\" type=\"button\" (click)=\"ClearSvg()\">\r\n                                        <i class=\"fa fa-eraser\" aria-hidden=\"true\"></i>\r\n                                    </button>\r\n                                </div>\r\n                            </div>\r\n                            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'sharedVehicleGroupHashId' }}</span>\r\n                        </div>\r\n                        <div class=\"form-group\" [ngClass]=\"{'col-md-2 nopad-left': NormalBookingView , 'col-md-3': !NormalBookingView}\">\r\n                            <label>\r\n                                {{ 'LblVehicle' | translate }} </label>\r\n                            <div class=\"input-group\">\r\n                                <input [(ngModel)]=\"searchLicenceTag\" [attr.title]=\"searchLicenceTag\" name=\"vehicleHashId\" type=\"text\" class=\"form-control\"\r\n                                    placeholder=\"{{ 'LblAll' | translate }} {{ 'LblVehicle' | translate }}\" readonly>\r\n                                <div class=\"input-group-btn\">\r\n                                    <button class=\"btn btn-default\" type=\"button\" (click)=\"selectVehicleModal.show(model.sharedVehicleGroupHashId,model.vehicleHashIdList,model.searchLicenceTagList)\">\r\n                                        <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\r\n                                    </button>\r\n                                    <button class=\"btn btn-default\" type=\"button\" (click)=\"ClearVehicle()\">\r\n                                        <i class=\"fa fa-eraser\" aria-hidden=\"true\"></i>\r\n                                    </button>\r\n                                </div>\r\n                            </div>\r\n                            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'VehicleHashId' }}</span>\r\n                        </div>\r\n                        <div class=\"form-group nopad-left\" [ngClass]=\"{'col-md-2': NormalBookingView , 'col-md-3': !NormalBookingView}\">\r\n                            <label>{{ 'LblDriver' | translate }}</label>\r\n                            <div class=\"input-group\">\r\n                                <input [(ngModel)]=\"searchDriverName\" [attr.title]=\"searchDriverName\" name=\"driverName\" type=\"text\" class=\"form-control\"\r\n                                    placeholder=\"{{ 'LblAll' | translate }} {{ 'LblDriver' | translate }}\" readonly>\r\n                                <div class=\"input-group-btn\">\r\n                                    <button class=\"btn btn-default\" type=\"button\" (click)=\"selectDriverModal.show(model.driverHashIdList,model.searchDriverNameList)\">\r\n                                        <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\r\n                                    </button>\r\n                                    <button class=\"btn btn-default\" type=\"button\" (click)=\"ClearDriver()\">\r\n                                        <i class=\"fa fa-eraser\" aria-hidden=\"true\"></i>\r\n                                    </button>\r\n                                </div>\r\n                            </div>\r\n                            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'DriverHashId' }}</span>\r\n                        </div>\r\n\r\n                        <div class=\"form-group col-md-4 nopad-left\" [ngClass]=\"{'col-md-offset-2 ': !NormalBookingView,'':NormalBookingView}\">\r\n                            <div class=\"form-group col-md-9 nopad\">\r\n                                <label>&nbsp;</label>\r\n                                <div class=\"clearfix\"></div>\r\n                                <button type=\"submit\" class=\"btn btn-default search-icon\">\r\n                                    <i class=\"fa fa-search\" aria-hidden=\"true\"></i>\r\n                                </button>\r\n                                <button class=\"btn btn-default reset-icon\" type=\"button\" (click)=\"OnAdvancedReset($event)\">\r\n                                    <i class=\"fa fa-eraser\" aria-hidden=\"true\"></i>\r\n                                </button>\r\n                                <button class=\"btn btn-default export-icon\" type=\"button\" (click)=\"OnExport($event)\" title=\"{{'LblExportAll(CSV)' | translate}}\">\r\n                                    <i class=\"fa fa-download\" aria-hidden=\"true\"></i>\r\n                                </button>\r\n                            </div>\r\n                            <div class=\"form-group col-md-3 nopad\">\r\n                                <label>&nbsp;</label>\r\n                                <select class=\"form-control\" title='Items Per Page' [(ngModel)]=\"DataListModel.itemsPerPage\" name=\"itemPerPage\" (change)=\"OnPagingChange($event.target.value)\">\r\n                                    <option *ngFor=\"let item of itemPerPageList\" [attr.value]='item.value'>{{ item }}</option>\r\n                                </select>\r\n                            </div>\r\n                        </div>\r\n\r\n                    </div>\r\n                </form>\r\n                <div class=\"table table-responsive mar_bot_ziro\">\r\n                    <table class=\"table table-bordered mar_bot_ziro\">\r\n                        <thead>\r\n                            <tr>\r\n                                <!-- *ngIf=\"isDeleteAccess\" -->\r\n                                <th class=\"text-center parent-checkbox\">\r\n                                    <input type=\"checkbox\" [(ngModel)]=\"isParentCheck\" [disabled]=\"!isParentCheckEnable\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\">\r\n                                </th>\r\n                                <th class=\"cursor-pointer\" (click)=\"OnSort('BookingReferenceId')\">\r\n                                    {{ 'LblBookingReferenceId' | translate }}\r\n                                    <wego-sort-list [FieldName]=\"'BookingReferenceId'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                                </th>\r\n                                <th class=\"cursor-pointer\" (click)=\"OnSort('startDateTimeUTC')\">\r\n                                    {{ 'LblFrom' | translate }}\r\n                                    <wego-sort-list [FieldName]=\"'startDateTimeUTC'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                                </th>\r\n                                <th class=\"cursor-pointer\" (click)=\"OnSort('endDateTimeUTC')\">\r\n                                    {{ 'LblTo' | translate }}\r\n                                    <wego-sort-list [FieldName]=\"'endDateTimeUTC'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                                </th>\r\n                                <th class=\"cursor-pointer\" (click)=\"OnSort('translatedBookingStatus')\">\r\n                                    {{ 'LblStatus' | translate }}\r\n                                    <wego-sort-list [FieldName]=\"'translatedBookingStatus'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                                </th>\r\n                                <th class=\"cursor-pointer\" (click)=\"OnSort('licenceTag')\">\r\n                                    {{ 'LblVehicle' | translate }}\r\n                                    <wego-sort-list [FieldName]=\"'licenceTag'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                                </th>\r\n                                <th *ngIf=\"!authService.IsDriver()\" class=\"cursor-pointer\" (click)=\"OnSort('driver')\">\r\n                                    {{ 'LblDriver' | translate }}\r\n                                    <wego-sort-list [FieldName]=\"'driver'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                                </th>\r\n                                <th *ngIf=\"!authService.IsDriver()\" class=\"cursor-pointer\" (click)=\"OnSort('sharedVehicleGroup')\">\r\n                                    {{ 'LblSharedVehicleGroup' | translate }}\r\n                                    <wego-sort-list [FieldName]=\"'sharedVehicleGroup'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                                </th>\r\n                                <th class=\"text-center\">{{ 'LblApprovedRejectedby' | translate }}</th>\r\n                                <th class=\"text-center\">{{ 'LblName' | translate }}</th>\r\n                            </tr>\r\n                        </thead>\r\n                        <tbody>\r\n                            <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                                <tr *ngFor=\"let bookings of bookingList\">\r\n                                    <td class=\"text-center\">\r\n                                        <input [disabled]=\"!bookings.isApproverejectEnable\" type=\"checkbox\" name=\"isActive\" [(ngModel)]=\"bookings.isChecked\">\r\n                                    </td>\r\n                                    <td>\r\n                                        <span>\r\n                                            <a [routerLink]=\"urlBookingInformation+'/'+ bookings.bookingHashId\">\r\n                                                {{ bookings.bookingReferenceID }}\r\n                                            </a>\r\n                                        </span>\r\n                                    </td>\r\n                                    <td>{{ bookings.startDateTime}}</td>\r\n                                    <td>{{ bookings.endDateTime }}</td>\r\n                                    <td> {{ bookings.translatedBookingStatus }}</td>\r\n                                    <td>\r\n                                        <template [ngIf]=\"!bookings.isVehicleDeleted && bookings.isVehicleEdit\">\r\n                                            <span>\r\n                                                <a [routerLink]=\"urlVehicleInfo +'/'+ bookings.vehicleHashId\">\r\n                                                    {{ bookings.licenceTag }}\r\n                                                </a>\r\n                                            </span>\r\n                                        </template>\r\n                                        <template [ngIf]=\"bookings.isVehicleDeleted  || !bookings.isVehicleEdit\">\r\n                                            {{ bookings.licenceTag }}\r\n                                        </template>\r\n                                    </td>\r\n                                    <td>\r\n                                        <template [ngIf]=\"!bookings.isPersonDeleted && bookings.isDriverEdit\">\r\n                                            <a [routerLink]=\"urlDriverInfo+'/'+ bookings.driverHashId\">\r\n                                                {{ bookings.driver }}\r\n                                            </a>\r\n                                        </template>\r\n                                        <template [ngIf]=\"bookings.isPersonDeleted || !bookings.isDriverEdit\">\r\n                                            {{ bookings.driver }}\r\n                                        </template>\r\n                                    </td>\r\n                                    <td *ngIf=\"!authService.IsDriver()\">\r\n                                        <template [ngIf]=\"!bookings.isSharedVehicleGroupDeleted && bookings.isSvgEdit\">\r\n                                            <a [routerLink]=\"urlSVGInfo+'/'+ bookings.sharedVehicleGroupHashId\">\r\n                                                {{ bookings.sharedVehicleGroup }}\r\n                                            </a>\r\n                                        </template>\r\n                                        <template [ngIf]=\"bookings.isSharedVehicleGroupDeleted || !bookings.isSvgEdit\">\r\n                                            {{ bookings.sharedVehicleGroup }}\r\n                                        </template>\r\n                                    </td>\r\n\r\n                                    <td style=\"text-align: center;\">\r\n                                        <template [ngIf]=\"bookings.isApprovalPersonLinkEditable\">\r\n                                            <a [routerLink]=\"urlPersonInfo+'/'+ bookings.approvalAdminHashId\">\r\n                                                {{ bookings.approvalAdmin }}\r\n                                            </a>\r\n                                        </template>\r\n                                        <template [ngIf]=\"!bookings.isApprovalPersonLinkEditable\">\r\n                                            {{ bookings.approvalAdmin }}\r\n                                        </template>\r\n                                    </td>\r\n                                    <td style=\"text-align: center;\">{{bookings.approvalAdminFullName}}</td>\r\n                                </tr>\r\n                            </template>\r\n                            <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                                <td class=\"text-center text-danger\" colspan=\"12\">\r\n                                    {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                                </td>\r\n                            </tr>\r\n                        </tbody>\r\n                    </table>\r\n                </div>\r\n                <div class=\"clearfix\"></div>\r\n                <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n                    <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n                        <div class=\"col-md-12\">\r\n                            <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\"\r\n                                firstText=\"&laquo;\" lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n            <div *ngIf=\"DataListModel.totalItems != 0 && bookingList[0].isApprovalPermissionEnable\" class=\"form-group col-md-12\" style=\"margin-top:  11px;\">\r\n                <div class=\"col-md-8\"></div>\r\n                <div class=\"col-md-4\" style=\"padding:  0px;align-items:  right;\">\r\n                    <div class=\"pull-right\">\r\n                        <button class=\"btn btn-green\" (click)=\"onSubmitClick(1)\" style=\"margin-right: 12px;\">{{'LblApproveBookingRequest'| translate }}</button>\r\n                        <button class=\"btn btn-green\" (click)=\"onSubmitClick(2)\">{{'LblRejectBookingRequest'| translate }}</button>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </section>\r\n</div>\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<div bsModal #remarksModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n    aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n    <div class=\"modal-dialog modal-sm\">\r\n        <div class=\"modal-content\">\r\n            <div class=\"modal-header\">\r\n                <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"HideRemarksModal()\">\r\n                    <span aria-hidden=\"true\">&times;</span>\r\n                </button>\r\n                <h4 class=\"modal-title\">{{'LblRemarks'| translate }}</h4>\r\n            </div>\r\n            <div class=\"modal-body\">\r\n                {{remarks}}\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n<div bsModal #EditBookingModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n    aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n    <div class=\"modal-dialog modal-sm\">\r\n        <div class=\"modal-content\">\r\n            <div class=\"modal-header\">\r\n                <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"HideBookingModal()\">\r\n                    <span aria-hidden=\"true\">&times;</span>\r\n                </button>\r\n                <h4 class=\"modal-title\">{{ 'LblEdit' | translate }} {{ 'LblBooking' | translate }} </h4>\r\n            </div>\r\n            <div class=\"modal-body\">\r\n                <div class=\"row mar_bot_10\">\r\n                    <div class=\"col-xs-12\">\r\n                        <button type=\"button\" class=\"btn btn-primary col-xs-12\" (click)=\"SuccessSingleBooking()\"> {{ 'LblSingle' | translate }} {{ 'LblBooking' | translate }}</button>\r\n                    </div>\r\n                </div>\r\n                <div class=\"row\">\r\n                    <div class=\"col-xs-12\">\r\n                        <button type=\"button\" class=\"btn btn-primary col-xs-12\" (click)=\"SuccessRecurringBooking()\">{{ 'LblSeries' | translate }} {{ 'LblBooking' | translate }}</button>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</div>\r\n<div bsModal #approveConfirnmationModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n    aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n    <div class=\"modal-dialog modal-sm\">\r\n        <div class=\"modal-content\">\r\n            <div class=\"modal-header\">\r\n                <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"approveConfirnmationModal.hide();\">\r\n                    <span aria-hidden=\"true\">&times;</span>\r\n                </button>\r\n                <h4 class=\"modal-title\">{{ 'LblConfirm' | translate }}</h4>\r\n            </div>\r\n            <form>\r\n                <div class=\"modal-body\">\r\n                    <div class=\"row\">\r\n                        <div class=\"col-xs-12 form-group\">\r\n                            {{'LblApproveConfirmationMsg' | translate }}\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"modal-footer\">\r\n                    <button type=\"submit\" class=\"btn btn-green cursor-pointer\" (click)=\"ApproveRejectMultipleBookingRequest();\">{{ 'LblYes' | translate }}</button>\r\n                    <button type=\"button\" class=\"btn btn-gray cursor-pointer\" (click)=\"approveConfirnmationModal.hide();\">{{ 'LblNo' | translate }}</button>\r\n                </div>\r\n            </form>\r\n        </div>\r\n    </div>\r\n</div>\r\n\r\n\r\n\r\n<div bsModal #rejectReasonModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n    aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n    <div class=\"modal-dialog modal-sm\">\r\n        <div class=\"modal-content\">\r\n            <div class=\"modal-header\">\r\n                <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"HideRejectReasonModel()\">\r\n                    <span aria-hidden=\"true\">&times;</span>\r\n                </button>\r\n                <h4 class=\"modal-title\">{{ 'LblRejection' | translate }}</h4>\r\n            </div>\r\n            <form>\r\n                <div class=\"modal-body\">\r\n                    <div class=\"row\">\r\n                        <div class=\"col-xs-12 form-group\">\r\n                            {{'LblrejectionReasonMsg' | translate }}\r\n                        </div>\r\n                        <div class=\"col-xs-12 form-group\">\r\n                            <textarea class=\"form-control\" id=\"comment\" [(ngModel)]=\"bookingApproveModel.adminRemarks\" name=\"remarks\" placeholder=\"{{ 'LblRemarks' | translate }}\"></textarea>\r\n                            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'adminRemarks' }}</span>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n                <div class=\"modal-footer\">\r\n                    <button type=\"submit\" class=\"btn btn-green cursor-pointer\" (click)=\"ApproveRejectMultipleBookingRequest();\">{{ 'LblConfirm' | translate }}</button>\r\n                    <button type=\"button\" class=\"btn btn-gray cursor-pointer\" (click)=\"HideRejectReasonModel()\">{{ 'LblCancel' | translate }}</button>\r\n                </div>\r\n            </form>\r\n        </div>\r\n    </div>\r\n</div>\r\n<wego-success-popup #successPopup [popupMsg]=\"successpopupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n<wego-booking-driver-popup #selectDriverModal (OnSuccessSelect)=\"SuccessSelectDriverModal($event)\"></wego-booking-driver-popup>\r\n<wego-booking-request-admin-popup #selectadminModal (OnSuccessSelect)=\"SuccessSelectAdminModal($event)\"></wego-booking-request-admin-popup>\r\n<wego-booking-vehicle-popup #selectVehicleModal (OnSuccessSelect)=\"SuccessSelectVehicleModal($event)\"></wego-booking-vehicle-popup>\r\n<wego-booking-svg-popup #selectSvgModal (OnSuccessSelect)=\"SuccessSelectSvgModal($event)\"></wego-booking-svg-popup>\r\n<wego-success-popup #selectionRequiredPopup [popupTitle]=\"LblSelectionRequired\" [popupMsg]=\"SelectionRequiredMsg\" (onConfirm)=\"selectionRequiredPopup.hide();\"></wego-success-popup>";

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var translate_service_1 = __webpack_require__(70);
	var flatpickr_model_1 = __webpack_require__(83);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var booking_service_1 = __webpack_require__(556);
	var booking_overviewlist_model_1 = __webpack_require__(573);
	var config_1 = __webpack_require__(60);
	var moment = __webpack_require__(84);
	var BookingHistoryComponent = (function () {
	    function BookingHistoryComponent(authService, bookigService, router, translate) {
	        this.authService = authService;
	        this.bookigService = bookigService;
	        this.router = router;
	        this.translate = translate;
	        this.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
	        this.model = new booking_overviewlist_model_1.BookingOverviewList();
	        this.remarkslength = 15;
	    }
	    Object.defineProperty(BookingHistoryComponent.prototype, "isAnyChecked", {
	        get: function () {
	            if (this.bookingList) {
	                var isCheck = this.bookingList.some(function (x) { return x.isChecked == true; });
	                if (isCheck) {
	                    if (this.bookingList.every(function (x) { return x.isChecked == true; }))
	                        this.isParentCheck = true;
	                    else
	                        this.isParentCheck = false;
	                }
	                else {
	                    this.isParentCheck = false;
	                }
	                return isCheck;
	            }
	            else {
	                this.isParentCheck = false;
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BookingHistoryComponent.prototype.ngOnInit = function () {
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = ["licenceTag", "bookingReference", "translatedBookingStatus"];
	        this.model = new booking_overviewlist_model_1.BookingOverviewList();
	        this.model.startDateTime = moment().utc().format('DD-MM-YYYY HH:mm');
	        this.model.endDateTime = moment().utc().add(+1, 'M').format('DD-MM-YYYY HH:mm');
	        this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
	        this.urlBooking = this.authService.GetURL(config_1.ApplicationRouteURL.URL_BOOKING);
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlDriverBookingInformation = this.authService.GetURL(config_1.ApplicationRouteURL.URL_BOOKING_INFORMATION_DRIVER);
	        this.urlSnailTrailDriver = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SNAIL_TRAIL_DRIVER);
	        this.GetBookingHistory();
	    };
	    BookingHistoryComponent.prototype.SetDefaultFlatPickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = true;
	        flatPickrConfig.time_24hr = true;
	        flatPickrConfig.enableSeconds = true;
	        flatPickrConfig.dateFormat = this.dateFormat;
	        flatPickrConfig.minuteIncrement = 1;
	        return flatPickrConfig;
	    };
	    BookingHistoryComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetBookingHistory();
	    };
	    BookingHistoryComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetBookingHistory();
	    };
	    BookingHistoryComponent.prototype.OnDateSearch = function () {
	        this.GetBookingHistory();
	    };
	    BookingHistoryComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.bookigService.ExportBokingHistoryList(this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "Booking" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	        ;
	    };
	    BookingHistoryComponent.prototype.GetBookingHistory = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.bookigService.GetBookingHistoryList(this.DataListModel)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.bookingList = res.data;
	                _this.DataListModel.totalItems = res.totalRecords;
	                _this.DataListModel.infoMessage = res.error;
	                _this.isLoading = false;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BookingHistoryComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetBookingHistory();
	    };
	    BookingHistoryComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetBookingHistory();
	    };
	    BookingHistoryComponent.prototype.OnParentCheck = function (isChecked) {
	        this.bookingList.filter(function (y) { return y.bookingStatus == config_1.BookingStatus.CONFIRMED && y.startDateTime > moment().utc().format('DD-MM-YYYY HH:mm:ss'); }).forEach(function (x) { return x.isChecked = isChecked; });
	    };
	    //Addedd for remarksModal
	    BookingHistoryComponent.prototype.ShowRemakrsModal = function (remarks) {
	        this.remarks = remarks;
	        this.remarksModal.show();
	    };
	    BookingHistoryComponent.prototype.HideRemarksModal = function () {
	        this.remarks = null;
	        this.remarksModal.hide();
	    };
	    BookingHistoryComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    __decorate([
	        core_1.ViewChild('cancelModal'), 
	        __metadata('design:type', Object)
	    ], BookingHistoryComponent.prototype, "cancelModal", void 0);
	    __decorate([
	        core_1.ViewChild('revokeAborkModal'), 
	        __metadata('design:type', Object)
	    ], BookingHistoryComponent.prototype, "revokeAborkModal", void 0);
	    __decorate([
	        core_1.ViewChild('remarksModal'), 
	        __metadata('design:type', Object)
	    ], BookingHistoryComponent.prototype, "remarksModal", void 0);
	    BookingHistoryComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-booking-history',
	            template: __webpack_require__(695),
	            providers: [booking_service_1.BookingService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof booking_service_1.BookingService !== 'undefined' && booking_service_1.BookingService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object])
	    ], BookingHistoryComponent);
	    return BookingHistoryComponent;
	    var _a, _b, _c, _d;
	}());
	exports.BookingHistoryComponent = BookingHistoryComponent;


/***/ },
/* 695 */
/***/ function(module, exports) {

	module.exports = "<section class=\"banner-img-in\">\r\n  <div class=\"banner-in\">\r\n    <div class=\"search-bg-in\">\r\n      <div class=\"container-fluid\">\r\n        <div class=\"row\" style=\"padding-right:15px;\">\r\n          <div class=\"col-md-3 col-sm-6\">\r\n            <h2 class=\"pagename\">{{ 'LblHistory' | translate }}</h2>\r\n          </div>\r\n          <div class=\"col-md-4 navbar-right\">\r\n            <div class=\"form-space-top pull-right\">\r\n              <wego-driver-search-list (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\"\r\n                [SearchTerm]=\"DataListModel.searchTerm\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-driver-search-list>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n<div class=\"clearfix\"></div>\r\n<section class=\"content\">\r\n  <div class=\"container-fluid mar-top-25\">\r\n    <div class=\"table-responsive\">\r\n      <table class=\"table table-bordered mar_bot_ziro\">\r\n        <thead>\r\n          <tr>\r\n            <th class=\"cursor-pointer\" (click)=\"OnSort('bookingReference')\">\r\n              {{ 'LblBookingReferenceId' | translate }}\r\n              <wego-sort-list [FieldName]=\"'bookingReference'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n            </th>\r\n            <th class=\"cursor-pointer\" (click)=\"OnSort('licenceTag')\">\r\n              {{ 'LblVehicle' | translate }}\r\n              <wego-sort-list [FieldName]=\"'licenceTag'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n            </th>\r\n            <th class=\"cursor-pointer\" (click)=\"OnSort('translatedBookingStatus')\">\r\n              {{ 'LblBookingStatus' | translate }}\r\n              <wego-sort-list [FieldName]=\"'translatedBookingStatus'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n            </th>\r\n            <th class=\"cursor-pointer\" (click)=\"OnSort('startDateTimeUTC')\">\r\n              {{ 'LblFrom' | translate }}\r\n              <wego-sort-list [FieldName]=\"'startDateTimeUTC'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n            </th>\r\n            <th class=\"cursor-pointer\" (click)=\"OnSort('endDateTimeUTC')\">\r\n              {{ 'LblTo' | translate }}\r\n              <wego-sort-list [FieldName]=\"'endDateTimeUTC'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n            </th>\r\n            <th class=\"cursor-pointer\" (click)=\"OnSort('totalExpense')\">\r\n              {{ 'LblTotalExpense' | translate }}\r\n              <wego-sort-list [FieldName]=\"'totalExpense'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n            </th>\r\n            <th class=\"cursor-pointer\" (click)=\"OnSort('totalKm')\">\r\n              {{ 'LblTotalKm' | translate }}\r\n              <wego-sort-list [FieldName]=\"'totalKm'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n            </th>\r\n            <th class=\"text-center\">{{ 'LblInformation' | translate }}</th>\r\n            <th class=\"text-center\">{{ 'LblSnailTrailReport' | translate }}</th>\r\n          </tr>\r\n        </thead>\r\n        <tbody>\r\n          <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n            <tr *ngFor=\"let bookings of bookingList\">\r\n              <td>{{ bookings.bookingReference }}</td>\r\n              <td>{{ bookings.licenceTag }}</td>\r\n              <td>{{ bookings.translatedBookingStatus }}</td>\r\n              <td>{{ bookings.bookingStartDateTime}}</td>\r\n              <td>{{ bookings.bookingEndDateTime }}</td>\r\n              <td>{{ bookings.totalExpense }}</td>\r\n              <td>{{ bookings.totalKm }}</td>\r\n              <td class=\"text-center\">\r\n                <a class=\"cursor-pointer\" title=\"{{'LblInformation' | translate}}\" [routerLink]=\"[ urlDriverBookingInformation, { bookingHashId :bookings.bookingIdHashId }]\">\r\n                      <i class=\"fa fa-eye fa-fw\"></i>\r\n                    </a>\r\n              </td>\r\n              <td class=\"text-center\">\r\n                <a *ngIf=\"bookings.bookingStatus=='FINISHED' || bookings.bookingStatus=='ABORTED' \" class=\"cursor-pointer\" title=\"{{'LblSnailTrailReport' | translate}}\" [routerLink]=\"[ urlSnailTrailDriver, { bookingHashId :bookings.bookingIdHashId }]\">\r\n                      <i class=\"fa fa-car fa-fw\"></i>\r\n                    </a>\r\n              </td>\r\n            </tr>\r\n          </template>\r\n          <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n            <td class=\"text-center text-danger\" colspan=\"14\">\r\n              {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n            </td>\r\n          </tr>\r\n        </tbody>\r\n      </table>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n      <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n        <div class=\"col-md-12\">\r\n          <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n            [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n            lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>";

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var booking_overview_model_1 = __webpack_require__(577);
	var booking_approve_model_1 = __webpack_require__(692);
	var core_1 = __webpack_require__(3);
	var booking_service_1 = __webpack_require__(556);
	var router_1 = __webpack_require__(26);
	var common_1 = __webpack_require__(22);
	var BookingApproveComponent = (function () {
	    function BookingApproveComponent(authService, bookigService, router, translate, activeRoute, locationService) {
	        this.authService = authService;
	        this.bookigService = bookigService;
	        this.router = router;
	        this.translate = translate;
	        this.activeRoute = activeRoute;
	        this.locationService = locationService;
	        this.isPending = false;
	        this.isReccuring = false;
	    }
	    BookingApproveComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        if (this.authService.isLoggedIn()) {
	            this.translate.setDetectedLang();
	            this.lblApprove = this.translate.instant('LblApprove');
	            this.lblReject = this.translate.instant('LblReject');
	            this.module = this.translate.instant('LblBooking');
	            this.bookingOverview = new booking_overview_model_1.BookingOverview();
	            this.bookingApproveModel = new booking_approve_model_1.BookingApproveModel();
	            this.sub = this.activeRoute.params.subscribe(function (params) {
	                _this.bookingMasterHashId = params['bookingHashId'] || '';
	                _this.isReccuring = params['isReccuring'] || '';
	                _this.bookingApproveModel.isReccuring = _this.isReccuring;
	                _this.GetBookingDetails();
	            });
	            this.bookingApproveModel.bookingMasterHashId = this.bookingMasterHashId;
	        }
	        else {
	            this.authService.Logout();
	            this.authService.redirectMsg = "";
	            this.router.navigate(["/"]);
	        }
	    };
	    BookingApproveComponent.prototype.OnConfirmBooking = function ($event) {
	        //this.successPopup.show();
	        console.log(this.bookingApproveModel);
	        this.lblApproveReject = this.bookingApproveModel.isApproved
	            ? this.lblApprove
	            : this.lblReject;
	        this.ApproveBookingRequest();
	    };
	    BookingApproveComponent.prototype.OnCancelBooking = function ($event) {
	        this.router.navigate(["/admin/dashboard"]);
	        window.close();
	    };
	    BookingApproveComponent.prototype.GetBookingDetails = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.bookigService
	            .GetBookingDetails(this.bookingMasterHashId, this.isReccuring)
	            .subscribe(function (res) {
	            _this.isLoading = false;
	            if (res.data) {
	                _this.bookingOverview = res.data;
	                _this.isPending = true;
	            }
	            else {
	                _this.infoMsg = res.error;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BookingApproveComponent.prototype.ApproveBookingRequest = function () {
	        var _this = this;
	        this.bookigService
	            .ApproveBookingRequest(this.bookingApproveModel)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblBookingApproveRejectSuccess', [_this.module, _this.lblApproveReject]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    BookingApproveComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    BookingApproveComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    BookingApproveComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	        window.close();
	        this.router.navigate(["/admin/dashboard"]);
	    };
	    BookingApproveComponent.prototype.CloseWindow = function () {
	        window.close();
	    };
	    BookingApproveComponent.prototype.GroupByCategory = function (vehicleAttributeList) {
	        if (vehicleAttributeList) {
	            var prop_1 = 'vehicleAttributeCategoryName';
	            return vehicleAttributeList.reduce(function (groups, item) {
	                var val = item[prop_1];
	                groups[val] = groups[val] || [];
	                groups[val].push(item);
	                groups[val] = groups[val].sort(function (obj1, obj2) {
	                    if (obj1.attributeName > obj2.attributeName) {
	                        return 1;
	                    }
	                    if (obj1.attributeName < obj2.attributeName) {
	                        return -1;
	                    }
	                    return 0;
	                });
	                return groups;
	            }, {});
	        }
	        else {
	            return {};
	        }
	    };
	    BookingApproveComponent.prototype.KeyOfObject = function (obj) {
	        return Object.keys(obj);
	    };
	    __decorate([
	        core_1.ViewChild('childModal'), 
	        __metadata('design:type', Object)
	    ], BookingApproveComponent.prototype, "childModal", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], BookingApproveComponent.prototype, "successPopup", void 0);
	    BookingApproveComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-approve-booking',
	            template: __webpack_require__(697),
	            providers: [booking_service_1.BookingService, auth_service_1.AuthService, translate_service_1.TranslateService],
	            styles: [
	                "\n      span.label.label-default {\n        font-size: 13px;\n        line-height: 35px;\n        background-color: #eeeeee;\n        color: #2ba2aa;\n        margin-right: 5px;\n      }\n\n      span.label.label-default.text-success {\n        color: #3c763d;\n      }\n\n      span.label.label-default.text-danger {\n        color: #a94442;\n      }\n    "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof booking_service_1.BookingService !== 'undefined' && booking_service_1.BookingService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object, (typeof (_e = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _e) || Object, (typeof (_f = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _f) || Object])
	    ], BookingApproveComponent);
	    return BookingApproveComponent;
	    var _a, _b, _c, _d, _e, _f;
	}());
	exports.BookingApproveComponent = BookingApproveComponent;


/***/ },
/* 697 */
/***/ function(module, exports) {

	module.exports = "<div class=\"container\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-12  text-center\">\r\n      <h1 class=\"pagename\">{{ 'LblApproveBooking' | translate }}</h1>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25\">\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <template [ngIf]=\"isPending\">\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <fieldset>\r\n            <legend class=\"legendStyle\">\r\n              {{ 'LblDriverDetail' | translate }}\r\n            </legend>\r\n            <div class=\"clearfix\"></div>\r\n            <div *ngIf=\"bookingOverview?.driver\" class=\"row\">\r\n              <div *ngIf=\"bookingOverview?.driver.driverName\" class=\"col-sm-4 col-xs-6\">\r\n                <label>{{ 'LblDriverName' | translate }} :</label> {{ bookingOverview?.driver.driverName }}\r\n              </div>\r\n              <div *ngIf=\"bookingOverview?.driver.email\" class=\"col-sm-4 col-xs-6\">\r\n                <label>{{ 'LblEmail' | translate }} :</label> {{ bookingOverview?.driver.email }}\r\n              </div>\r\n            </div>\r\n          </fieldset>\r\n          <br />\r\n          <fieldset>\r\n            <legend class=\"legendStyle\">\r\n              {{ 'LblBookingDetail' | translate }}\r\n            </legend>\r\n            <div class=\"clearfix\"></div>\r\n            <div *ngIf=\"bookingOverview?.booking\" class=\"row\">\r\n              <div *ngIf=\"bookingOverview?.booking.bookingStartDateTime\" class=\"col-sm-4 col-xs-6\"><label>{{ 'LblBookingStartDateTime' | translate }} :</label> {{ bookingOverview?.booking.bookingStartDateTime }} </div>\r\n              <div *ngIf=\"bookingOverview?.booking.bookingEndDateTime\" class=\"col-sm-4 col-xs-6\"><label>{{ 'LblBookingEndDateTime' | translate }} :</label> {{ bookingOverview?.booking.bookingEndDateTime }}</div>\r\n\r\n              <div *ngIf=\"bookingOverview?.booking.pickupAddress\" class=\"col-sm-4 col-xs-6\"><label>{{ 'LblPickupLocation' | translate }} :</label> {{ bookingOverview?.booking.pickupAddress }}</div>\r\n             \r\n            </div>\r\n            <template [ngIf]=\"bookingOverview?.reccuringBooking\">\r\n              <div *ngFor=\"let item of bookingOverview?.reccuringBooking\" class=\"row\">\r\n                <div *ngIf=\"item.bookingStartDateTime\" class=\"col-sm-4 col-xs-6\"><label>{{ 'LblBookingStartDateTime' | translate }} :</label> {{ item.bookingStartDateTime }}</div>\r\n                <div *ngIf=\"item.bookingEndDateTime\" class=\"col-sm-4 col-xs-6\"><label>{{ 'LblBookingEndDateTime' | translate }} :</label> {{ item.bookingEndDateTime }}</div>\r\n              </div>\r\n            </template>\r\n          </fieldset>\r\n          <br />\r\n          <fieldset *ngIf=\"bookingOverview?.vehicle\">\r\n            <legend class=\"legendStyle\">\r\n              {{ 'LblVehicleDetail' | translate }}\r\n            </legend>\r\n            <div class=\"clearfix\"></div>\r\n            <div class=\"row\">\r\n              <div *ngIf=\"bookingOverview?.vehicle.licenceTag\" class=\"col-sm-4 col-xs-6\">\r\n                <label>{{ 'LblLicenceTag' | translate }} :</label> {{ bookingOverview?.vehicle.licenceTag }}\r\n              </div>\r\n              <div *ngIf=\"bookingOverview?.vehicle.sharedVehicleGroup\" class=\"col-sm-4 col-xs-6\">\r\n                <label>{{ 'LblSharedVehicleGroup' | translate }} :</label> {{ bookingOverview?.vehicle.sharedVehicleGroup\r\n                }}\r\n              </div>\r\n              <div *ngIf=\"bookingOverview?.vehicle.brand\" class=\"col-sm-4 col-xs-6\">\r\n                <label>{{ 'LblBrand' | translate }} :</label> {{ bookingOverview?.vehicle.brand }}\r\n              </div>\r\n              <div *ngIf=\"bookingOverview?.vehicle.type\" class=\"col-sm-4 col-xs-6\">\r\n                <label>{{ 'LblType' | translate }} :</label> {{ bookingOverview?.vehicle.type }}\r\n              </div>\r\n              <div *ngIf=\"bookingOverview?.vehicle.color\" class=\"col-sm-4 col-xs-6\">\r\n                <label>{{ 'LblColor' | translate }} :</label> {{ bookingOverview?.vehicle.color }}\r\n              </div>\r\n              <div *ngIf=\"bookingOverview?.vehicle.vehicleClass\" class=\"col-sm-4 col-xs-6\">\r\n                <label>{{ 'LblVehicleClass' | translate }} :</label> {{ bookingOverview?.vehicle.vehicleClass }}\r\n              </div>\r\n              <div *ngIf=\"bookingOverview?.vehicle.pricingCategory\" class=\"col-sm-4 col-xs-6\">\r\n                <label>{{ 'LblPricingCategory' | translate }} :</label> {{ bookingOverview?.vehicle.pricingCategory }}\r\n              </div>\r\n              <div *ngIf=\"bookingOverview?.vehicle.bodyStyle\" class=\"col-sm-4 col-xs-6\">\r\n                <label>{{ 'LblBodyStyle' | translate }} :</label> {{ bookingOverview?.vehicle.bodyStyle }}\r\n              </div>\r\n              <div *ngIf=\"bookingOverview?.vehicle.fuelType\" class=\"col-sm-4 col-xs-6\">\r\n                <label>{{ 'LblFuelType' | translate }} :</label> {{ bookingOverview?.vehicle.fuelType }}\r\n              </div>\r\n            </div>\r\n            <div class=\"row\">\r\n              <div class=\"col-sm-12\" *ngFor=\"let cat of KeyOfObject(GroupByCategory(bookingOverview?.vehicle.attributeList))\">\r\n                <label>{{ cat }} : </label>\r\n                <span *ngFor=\"let attribute of GroupByCategory(bookingOverview?.vehicle.attributeList)[cat]\" class=\"label label-default\">\r\n                  <i class=\"fa fa-tag fa-lg\" aria-hidden=\"true\"></i>&nbsp;{{ attribute.attributeName }}\r\n                </span>\r\n              </div>\r\n            </div>\r\n            <!-- <div class=\"row\">\r\n              <div class=\"col-sm-12\">\r\n                <span class=\"label label-default\" [ngClass]=\"{ 'text-success' : bookingOverview?.vehicle.airco, 'text-danger' : !bookingOverview?.vehicle.airco }\">\r\n                  <i *ngIf=\"bookingOverview?.vehicle.airco\" class=\"fa fa-check fa-lg\" aria-hidden=\"true\"></i>\r\n                  <i *ngIf=\"!bookingOverview?.vehicle.airco\" class=\"fa fa-times fa-lg\" aria-hidden=\"true\"></i>\r\n                  &nbsp;{{ 'LblAirco' | translate }}\r\n              </span>\r\n                <span class=\"label label-default\" [ngClass]=\"{ 'text-success' : bookingOverview?.vehicle.towbar, 'text-danger' : !bookingOverview?.vehicle.towbar }\">\r\n                <i *ngIf=\"bookingOverview?.vehicle.towbar\" class=\"fa fa-check fa-lg\" aria-hidden=\"true\"></i>\r\n                <i *ngIf=\"!bookingOverview?.vehicle.towbar\" class=\"fa fa-times fa-lg\" aria-hidden=\"true\"></i>\r\n                &nbsp;{{ 'LblTowbar' | translate }}\r\n              </span>\r\n              </div>\r\n            </div> -->\r\n          </fieldset>\r\n          <br />\r\n          <fieldset *ngIf=\"bookingOverview?.vehicle\">\r\n            <legend class=\"legendStyle\">\r\n              {{ 'LblBookingRequest' | translate }}\r\n            </legend>\r\n            <div class=\"clearfix\"></div>\r\n            <div class=\"row\">\r\n              <div class=\"col-sm-12\">\r\n                <div class=\"clearfix\"></div>\r\n                <label class=\"radio-inline\"><input type=\"radio\" [(ngModel)]=\"bookingApproveModel.isApproved\" name=\"Accepted\" [value]=\"true\">{{ 'LblApprove' | translate }}</label>\r\n                <label class=\"radio-inline\"><input type=\"radio\" [(ngModel)]=\"bookingApproveModel.isApproved\" name=\"Accepted\" [value]=\"false\">{{ 'LblReject' | translate }}</label>\r\n              </div>\r\n            </div>\r\n            <br/>\r\n            <div *ngIf=\"!bookingApproveModel.isApproved\" class=\"row\">\r\n              <div class=\"col-xs-3 form-group\">\r\n                <textarea class=\"form-control\" id=\"AdminRemarks\" [(ngModel)]=\"bookingApproveModel.adminRemarks\" name=\"adminRemark\" placeholder=\"{{ 'LblAdminRemarks' | translate }}\"></textarea>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'AdminRemarks' }}</span>\r\n              </div>\r\n            </div>\r\n          </fieldset>\r\n          <hr />\r\n          <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnCancelBooking($event)\">{{ 'LblCancel' | translate }}</a>\r\n          <button class=\"btn btn-green\" (click)=\"OnConfirmBooking($event)\">{{ 'LblConfirm' | translate }}</button>\r\n        </div>\r\n      </div>\r\n    </template>\r\n    <template [ngIf]=\"!isPending && !isLoading\">\r\n      <div class=\"row \">\r\n        <div class=\"col-md-12 text-center\">\r\n          <h3><i class=\"fa fa-warning text-yellow\"></i> Link Expired.</h3>\r\n          <p>\r\n            {{infoMsg}}\r\n          </p>\r\n          <a (click)=\"CloseWindow()\" style=\"cursor:pointer\">Close</a>\r\n        </div>\r\n      </div>\r\n    </template>\r\n  </section>\r\n</div>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>";

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var search_booking_component_1 = __webpack_require__(591);
	var auth_service_1 = __webpack_require__(58);
	var translate_service_1 = __webpack_require__(70);
	var driveradmin_service_1 = __webpack_require__(592);
	var router_1 = __webpack_require__(26);
	var core_1 = __webpack_require__(3);
	var config_1 = __webpack_require__(60);
	var booking_overview_model_1 = __webpack_require__(577);
	var search_booking_model_1 = __webpack_require__(574);
	var booking_service_1 = __webpack_require__(556);
	var vehicle_service_1 = __webpack_require__(530);
	var sharedvehiclegroup_service_1 = __webpack_require__(510);
	var moment = __webpack_require__(84);
	var BookingComponent = (function () {
	    function BookingComponent(bookingService, driverAdminService, translate, activeRoute, authService, router) {
	        this.bookingService = bookingService;
	        this.driverAdminService = driverAdminService;
	        this.translate = translate;
	        this.activeRoute = activeRoute;
	        this.authService = authService;
	        this.router = router;
	        this.swithBookingOverview = 'CALENDAR';
	        this.isNotEditable = false;
	        this.isSuccess = false;
	        this.BOOKINGSTEP = {
	            SEARCH: 1,
	            VEHICLE: 2,
	            CONFIRM: 3
	        };
	    }
	    Object.defineProperty(BookingComponent.prototype, "IsVehicleAvailableForUpdate", {
	        get: function () {
	            var _this = this;
	            if (this.vehicleOverviewList &&
	                this.vehicleOverviewList.length > 0 &&
	                this.searchBookingModel.isEditMode) {
	                return this.vehicleOverviewList.some(function (item) {
	                    return _this.searchBookingModel.vehicleHashId == item.vehicleHashID &&
	                        _this.searchBookingModel.sharedVehicleGroupHashID ==
	                            item.sharedVehicleGroupHashID;
	                });
	            }
	            else {
	                return true;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BookingComponent.prototype.ngOnInit = function () {
	        this.searchBookingModel = new search_booking_model_1.SearchBookingModel();
	        this.searchBookingModel.startDateTime = moment()
	            .add('m', 5)
	            .format('DD-MM-YYYY HH:mm');
	        this.searchBookingModel.endDateTime = moment()
	            .add('H', 1)
	            .add('m', 5)
	            .format('DD-MM-YYYY HH:mm');
	        this.CURRENTSTEP = this.BOOKINGSTEP.SEARCH;
	        //this.CurrentDriverDetail();
	        this.HandleBookingEdit();
	    };
	    BookingComponent.prototype.ngOnDestroy = function () {
	        if (this.sub) {
	            this.sub.unsubscribe();
	        }
	        this.successPopup.hide();
	    };
	    BookingComponent.prototype.HandleBookingEdit = function () {
	        var _this = this;
	        this.sub = this.activeRoute.params.subscribe(function (params) {
	            _this.referenceID = params['ref'] || '';
	            var isRecurring = params['isRecurring'] || false;
	            var version = params['v'] || '';
	            _this.ReloadPage(version);
	            if (_this.referenceID) {
	                _this.isLoading = true;
	                _this.bookingService
	                    .EditBookingDetail(_this.referenceID, isRecurring)
	                    .subscribe(function (res) {
	                    _this.isLoading = false;
	                    if (res.data) {
	                        _this.searchBookingModel.isEditMode = true;
	                        _this.searchBookingModel = res.data;
	                        _this.searchBookingModel.isEditMode = true;
	                        _this.searchBookingModel.isSpecialPeriod =
	                            res.data.isSpecialPeriod;
	                        _this.searchBookingModel.isRecurring =
	                            isRecurring == 'true' ? true : false;
	                        _this.searchBookingModel.isRegularbooking = res.data
	                            .contractTypeHashId
	                            ? false
	                            : true;
	                        _this.searchBookingModel.startDateTime = res.data.startDateTime;
	                        _this.searchBookingModel.endDateTime = res.data.endDateTime;
	                        console.log('this.searchBookingModel');
	                        console.log(_this.searchBookingModel);
	                    }
	                    else {
	                        _this.isNotEditable = true;
	                        _this.alertMsg = res.error;
	                    }
	                }, function (error) {
	                    _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	                    _this.isLoading = false;
	                });
	            }
	            if (_this.authService.IsDriver()) {
	                _this.CurrentDriverDetail();
	            }
	        });
	    };
	    BookingComponent.prototype.ReloadPage = function (version) {
	        if (this.version != version) {
	            this.version = version;
	            this.searchBookingModel = new search_booking_model_1.SearchBookingModel();
	            this.searchBookingModel.startDateTime = moment()
	                .add('m', 5)
	                .format('DD-MM-YYYY HH:mm');
	            this.searchBookingModel.endDateTime = moment()
	                .add('H', 1)
	                .add('m', 5)
	                .format('DD-MM-YYYY HH:mm');
	            this.searchBookingModel.recurringEndDateTime = '';
	            this.searchBookingModel.pickupAddress = '';
	            if (this.searchBooking) {
	                this.searchBooking.SetPickerValue('SEARCH_FROM', this.searchBookingModel.startDateTime);
	                this.searchBooking.SetPickerValue('SEARCH_TO', this.searchBookingModel.endDateTime);
	                this.searchBooking.ClearErrorModel();
	            }
	            this.CURRENTSTEP = this.BOOKINGSTEP.SEARCH;
	            this.vehicleOverviewList = [];
	            this.filterVehicleOverviewList = [];
	            this.bookingOverviewModel = new booking_overview_model_1.BookingOverview();
	        }
	    };
	    BookingComponent.prototype.CurrentDriverDetail = function () {
	        var _this = this;
	        this.driverAdminService.GetCurrentDriverDetail().subscribe(function (res) {
	            _this.isLoading = false;
	            if (res.data) {
	                _this.isBanned = res.data.isBanned;
	                _this.userBlockMessage = res.data.userBlockMessage;
	                _this.searchBookingModel.driverHashId = res.data.driverMasterHashId;
	                _this.searchBookingModel.startDateTime = res.data.startDateTime;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BookingComponent.prototype.AlertClose = function ($event) {
	        this.ClearBookingRecord();
	        var urlBookingOverview = this.authService.GetURL(config_1.ApplicationRouteURL.URL_BOOKING);
	        this.router.navigate([urlBookingOverview]);
	    };
	    BookingComponent.prototype.ChangeStep = function (selected) {
	        if (selected < this.CURRENTSTEP)
	            this.CURRENTSTEP = selected;
	    };
	    BookingComponent.prototype.OnSearchBooking = function ($event) {
	        this.scheduledBookingModel = $event.ScheduledBookingModel;
	        this.CURRENTSTEP = this.BOOKINGSTEP.SEARCH;
	    };
	    BookingComponent.prototype.OnSearch = function ($event) {
	        this.searchBookingModel = $event.SearchModel;
	        this.vehicleOverviewList = $event.VehicleOverview;
	        this.CURRENTSTEP = this.BOOKINGSTEP.VEHICLE;
	        console.log('OnSearch');
	        console.log(this.searchBookingModel);
	    };
	    BookingComponent.prototype.OnUpdateVehicleOverView = function ($event) {
	        this.filterVehicleOverviewList = $event.FilterVehicleOverview;
	    };
	    BookingComponent.prototype.OnBook = function ($event) {
	        this.searchBookingModel.sharedVehicleGroupHashID =
	            $event.SharedVehicleGroupHashID;
	        this.searchBookingModel.vehicleHashId = $event.VehicleHashID;
	        this.searchBookingModel.contractTypeHashId = $event.ContractTypeHashId;
	        console.log('OnBook');
	        console.log(this.searchBookingModel);
	        this.MakeProvisionalBooking();
	    };
	    BookingComponent.prototype.OnConfirmBooking = function ($event) {
	        this.searchBookingModel.bookingRemarks = $event.BookingRemarks;
	        this.ConfirmRecurringProvisionalBooking();
	        //this.ConfirmProvisionalBooking();
	    };
	    BookingComponent.prototype.ConfirmRecurringProvisionalBooking = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.bookingService
	            .ConfirmRecurringPaymentBooking(this.searchBookingModel.bookingMasterHashId, this.searchBookingModel.reccuringID, this.referenceID)
	            .subscribe(function (res) {
	            _this.isLoading = false;
	            if (res.data) {
	                if (res.data.askForInitialPayment) {
	                    if (!res.data.isPaymentSuccess || !res.data.IsFirstTimePayment) {
	                        _this.popupConfirmMsg = _this.translate.instant('LblAdminPaymentConfirmation');
	                        _this.resetPasswordModal.show();
	                    }
	                }
	                else {
	                    _this.isLoading = true;
	                    _this.ConfirmProvisionalBooking();
	                }
	            }
	            else {
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.popupMsg = res.error;
	                _this.isSuccess = false;
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BookingComponent.prototype.OnConfirmProvisionalBooking = function () {
	        this.resetPasswordModal.hide();
	        this.ConfirmProvisionalBooking();
	    };
	    BookingComponent.prototype.OnCancelProvisionalBooking = function () {
	        this.resetPasswordModal.hide();
	        this.CancelProvisionalBooking();
	        var urlData = this.authService.GetURL(config_1.ApplicationRouteURL.URL_BOOKING);
	        this.router.navigate([urlData, { v: Date.now() }]);
	        this.HandleBookingEdit();
	    };
	    BookingComponent.prototype.OnCancelBooking = function ($event) {
	        this.CancelProvisionalBooking();
	        var urlData = this.authService.GetURL(config_1.ApplicationRouteURL.URL_BOOKING);
	        this.router.navigate([urlData, { v: Date.now() }]);
	    };
	    BookingComponent.prototype.MakeProvisionalBooking = function () {
	        var _this = this;
	        this.isLoading = true;
	        if (!this.searchBookingModel.isRegularbooking) {
	            this.searchBookingModel.startDateTime =
	                this.searchBookingModel.startDateTime.length <= 10
	                    ? this.searchBookingModel.startDateTime + ' 00:00'
	                    : this.searchBookingModel.startDateTime;
	            this.searchBookingModel.endDateTime =
	                this.searchBookingModel.endDateTime.length <= 10
	                    ? this.searchBookingModel.endDateTime + ' 00:00'
	                    : this.searchBookingModel.endDateTime;
	        }
	        this.bookingService
	            .MakeProvisionalBooking(this.searchBookingModel)
	            .subscribe(function (res) {
	            _this.isLoading = false;
	            if (res.data) {
	                if (!_this.searchBookingModel.isRecurring)
	                    _this.searchBookingModel.bookingMasterHashId = res.data;
	                else
	                    _this.searchBookingModel.reccuringID = res.data;
	                _this.GetBookingOverview();
	            }
	            else {
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.alertMsg = res.error;
	                _this.ShowAlertPopup();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BookingComponent.prototype.ConfirmProvisionalBooking = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.bookingService
	            .ConfirmProvisionalBooking(this.searchBookingModel)
	            .subscribe(function (res) {
	            _this.isLoading = false;
	            if (res.data) {
	                _this.popupTitle = _this.translate.instant('LblSuccess');
	                _this.popupMsg = res.data;
	                _this.isSuccess = true;
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.popupMsg = res.error;
	                _this.isSuccess = false;
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BookingComponent.prototype.CancelProvisionalBooking = function () {
	        var _this = this;
	        this.isLoading = true;
	        var referenceID = this.searchBookingModel.isRecurring
	            ? this.searchBookingModel.reccuringID
	            : this.searchBookingModel.bookingMasterHashId;
	        this.bookingService
	            .CancelProvisionalBooking(referenceID, this.searchBookingModel.isRecurring)
	            .subscribe(function (res) {
	            _this.isLoading = false;
	            _this.ClearBookingRecord();
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BookingComponent.prototype.GetBookingOverview = function () {
	        var _this = this;
	        this.isLoading = true;
	        var referenceID = this.searchBookingModel.isRecurring
	            ? this.searchBookingModel.reccuringID
	            : this.searchBookingModel.bookingMasterHashId;
	        this.bookingService
	            .GetBookingOverview(referenceID, this.searchBookingModel.isRecurring)
	            .subscribe(function (res) {
	            _this.isLoading = false;
	            if (!res.error) {
	                _this.bookingOverviewModel = res.data;
	                if (_this.bookingOverviewModel.booking != null) {
	                    _this.CalculateBookingDuration(_this.bookingOverviewModel);
	                }
	                if (_this.bookingOverviewModel.reccuringBooking != null) {
	                    _this.bookingOverviewModel.bookingDuration = _this.searchBookingModel.totalBookingDuration;
	                }
	                console.log('Booking OverView');
	                console.log(_this.bookingOverviewModel);
	                _this.CURRENTSTEP = _this.BOOKINGSTEP.CONFIRM;
	            }
	            else {
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BookingComponent.prototype.CalculateBookingDuration = function (searchModel) {
	        var format = 'DD-MM-YYYY HH:mm';
	        var stDate = moment(searchModel.booking.bookingStartDateTime, format).toDate();
	        var enDate = moment(searchModel.booking.bookingEndDateTime, format).toDate();
	        // if (searchModel.isRecurringBookingAllow && searchModel.recurringEndDateTime) {
	        //   enDate = moment(searchModel.recurringEndDateTime, format).toDate();
	        // }
	        var diffMs = enDate - stDate;
	        var diffDays = Math.floor(diffMs / 86400000); // days
	        var diffHrs = Math.floor((diffMs % 86400000) / 3600000);
	        var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000);
	        if (diffDays > 0) {
	            this.bookingOverviewModel.bookingDuration =
	                diffDays + ' Day ' + diffHrs + ' Hours ' + diffMins + ' Min';
	        }
	        else if (diffDays == 0 && diffHrs > 0) {
	            this.bookingOverviewModel.bookingDuration =
	                diffHrs + ' Hours ' + diffMins + ' Min';
	        }
	        else if (diffDays == 0 && diffHrs == 0) {
	            this.bookingOverviewModel.bookingDuration = diffMins + ' Min';
	        }
	        console.log(this.bookingOverviewModel.bookingDuration);
	    };
	    BookingComponent.prototype.ClearBookingRecord = function () {
	        this.isLoading = false;
	        this.searchBookingModel = new search_booking_model_1.SearchBookingModel();
	        this.vehicleOverviewList = [];
	        this.filterVehicleOverviewList = [];
	        this.bookingOverviewModel = new booking_overview_model_1.BookingOverview();
	        this.CURRENTSTEP = this.BOOKINGSTEP.SEARCH;
	        if (!this.isSuccess && !this.isNotEditable) {
	            this.HandleBookingEdit();
	        }
	        else {
	            if (this.isSuccess) {
	                var urlBookingOverview = this.authService.GetURL(config_1.ApplicationRouteURL.URL_BOOKING_OVERVIEW);
	                this.router.navigate([urlBookingOverview]);
	            }
	            else {
	                var urlBookingOverview = this.authService.GetURL(config_1.ApplicationRouteURL.URL_BOOKING);
	                this.router.navigate([urlBookingOverview]);
	            }
	        }
	    };
	    BookingComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    BookingComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    BookingComponent.prototype.ConfirmSuccessPopup = function () {
	        this.HideSuccessPopup();
	        this.ClearBookingRecord();
	    };
	    BookingComponent.prototype.ShowAlertPopup = function () {
	        this.alertModal.show();
	    };
	    BookingComponent.prototype.HideAlertPopup = function () {
	        this.alertModal.hide();
	    };
	    BookingComponent.prototype.SuccessAlertModalClick = function () {
	        this.HideAlertPopup();
	    };
	    Object.defineProperty(BookingComponent.prototype, "diagnostic", {
	        get: function () {
	            return JSON.stringify(this.scheduledBookingModel);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], BookingComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild('resetPasswordModal'), 
	        __metadata('design:type', Object)
	    ], BookingComponent.prototype, "resetPasswordModal", void 0);
	    __decorate([
	        core_1.ViewChild('alertModal'), 
	        __metadata('design:type', Object)
	    ], BookingComponent.prototype, "alertModal", void 0);
	    __decorate([
	        core_1.ViewChild('searchBooking'), 
	        __metadata('design:type', (typeof (_a = typeof search_booking_component_1.SearchBookingComponent !== 'undefined' && search_booking_component_1.SearchBookingComponent) === 'function' && _a) || Object)
	    ], BookingComponent.prototype, "searchBooking", void 0);
	    BookingComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-booking',
	            template: __webpack_require__(699),
	            styles: [__webpack_require__(595)],
	            providers: [
	                sharedvehiclegroup_service_1.SharedVehicleGroupService,
	                vehicle_service_1.VehicleService,
	                booking_service_1.BookingService,
	                driveradmin_service_1.DriverAdminService
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof booking_service_1.BookingService !== 'undefined' && booking_service_1.BookingService) === 'function' && _b) || Object, (typeof (_c = typeof driveradmin_service_1.DriverAdminService !== 'undefined' && driveradmin_service_1.DriverAdminService) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object, (typeof (_e = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _e) || Object, (typeof (_f = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _f) || Object, (typeof (_g = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _g) || Object])
	    ], BookingComponent);
	    return BookingComponent;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.BookingComponent = BookingComponent;


/***/ },
/* 699 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content\">\r\n    <div [hidden]=\"isBanned\" class=\"nopad\">\r\n      <ul class=\"nav nav-wizard\">\r\n        <li (click)=\"ChangeStep(BOOKINGSTEP.SEARCH)\" [ngClass]=\"{'active' : CURRENTSTEP == BOOKINGSTEP.SEARCH, 'disabled' : CURRENTSTEP < BOOKINGSTEP.SEARCH}\"><a><i class=\"fa fa-search fa-fw\"></i>\r\n        <span *ngIf=\"!searchBookingModel.isEditMode\">&nbsp;{{ 'LblSearchForVehicle' | translate }}</span>\r\n        <span *ngIf=\"searchBookingModel.isEditMode\">&nbsp;{{ 'LblCurrentBookingDetail' | translate }}</span>\r\n        </a>\r\n        </li>\r\n        <li (click)=\"ChangeStep(BOOKINGSTEP.VEHICLE)\" [ngClass]=\"{'active' : CURRENTSTEP == BOOKINGSTEP.VEHICLE, 'disabled' : CURRENTSTEP < BOOKINGSTEP.VEHICLE}\"><a><i class=\"fa fa-cab fa-fw\"></i>&nbsp;{{ 'LblVehicleOverview' | translate }}</a></li>\r\n        <li (click)=\"ChangeStep(BOOKINGSTEP.CONFIRM)\" [ngClass]=\"{'active' : CURRENTSTEP == BOOKINGSTEP.CONFIRM, 'disabled' : CURRENTSTEP < BOOKINGSTEP.CONFIRM}\"><a><i class=\"fa fa-check fa-fw\"></i>&nbsp;{{ 'LblOverview' | translate }}</a></li>\r\n      </ul>\r\n      <div class=\"row\">\r\n\r\n        <div class=\"col-sm-12\">\r\n          <alert *ngIf=\"isNotEditable\" (close)=\"AlertClose($event)\" type=\"danger\" dismissible=\"true\" dismissOnTimeout=\"3000\">{{ alertMsg }}</alert>\r\n        </div>\r\n        <div class=\"col-sm-12\">\r\n          <alert *ngIf=\"!IsVehicleAvailableForUpdate && CURRENTSTEP==BOOKINGSTEP.VEHICLE\" class=\"text-center\" type=\"danger\">\r\n            {{ 'LblEditCarNotAvailable' | translate }}\r\n          </alert>\r\n        </div>\r\n        <div *ngIf=\"CURRENTSTEP == BOOKINGSTEP.SEARCH\" class=\"col-sm-3\">\r\n          <wego-search-booking #searchBooking [SearchBookingModel]=\"searchBookingModel\" (OnSearch)=\"OnSearch($event)\"></wego-search-booking>\r\n        </div>\r\n        <div *ngIf=\"CURRENTSTEP == BOOKINGSTEP.SEARCH\" class=\"col-sm-9\">\r\n          <wego-scheduler-booking (OnSearch)=\"OnSearchBooking($event)\"></wego-scheduler-booking>\r\n        </div>\r\n        <div *ngIf=\"CURRENTSTEP == BOOKINGSTEP.VEHICLE\" class=\"col-sm-3\">\r\n          <wego-filter-vehicle-overview [VehicleOverviewList]=\"vehicleOverviewList\" (OnUpdateVehicleOverView)=\"OnUpdateVehicleOverView($event)\"></wego-filter-vehicle-overview>\r\n        </div>\r\n        <div *ngIf=\"CURRENTSTEP == BOOKINGSTEP.VEHICLE\" class=\"col-sm-9\">\r\n          <wego-vehicle-overview [SearchBookingModel]=\"searchBookingModel\" [VehicleOverviewList]=\"filterVehicleOverviewList\" (OnBook)=\"OnBook($event)\"></wego-vehicle-overview>\r\n        </div>\r\n        <div *ngIf=\"CURRENTSTEP == BOOKINGSTEP.CONFIRM\" class=\"col-sm-12\">\r\n          <wego-confirm-booking [BookingOverview]=\"bookingOverviewModel\" [BookingRemarks]=\"searchBookingModel.bookingRemarks\" (OnConfirmBooking)=\"OnConfirmBooking($event)\" (OnCancelBooking)=\"OnCancelBooking($event)\"></wego-confirm-booking>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div [hidden]=\"!isBanned\" class=\"nopad\">\r\n      <p class=\"text-danger text-center\">\r\n        {{ userBlockMessage }}\r\n      </p>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-success-popup #alertModal [popupTitle]=\"popupTitle\" [popupMsg]=\"alertMsg\" (onConfirm)=\"SuccessAlertModalClick()\"></wego-success-popup>\r\n\r\n<wego-success-popup #successPopup [popupTitle]=\"popupTitle\" [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<wego-confirm-popup #resetPasswordModal [popupMsg]=\"popupConfirmMsg\" (onConfirm)=\"OnConfirmProvisionalBooking()\" (onReject)=\"OnCancelProvisionalBooking()\"></wego-confirm-popup>";

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var EndRide_1 = __webpack_require__(701);
	var unlock_service_1 = __webpack_require__(702);
	var StartRide_1 = __webpack_require__(703);
	var lockunlock_model_1 = __webpack_require__(704);
	var vehicle_service_1 = __webpack_require__(530);
	var booking_information_model_1 = __webpack_require__(705);
	var auth_service_1 = __webpack_require__(58);
	var translate_service_1 = __webpack_require__(70);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var booking_service_1 = __webpack_require__(556);
	var config_2 = __webpack_require__(60);
	var common_1 = __webpack_require__(22);
	var moment = __webpack_require__(84);
	var BookingInformationComponent = (function () {
	    function BookingInformationComponent(authService, bookigService, unlockService, router, translate, activeRoute, locationService, vehicleService) {
	        this.authService = authService;
	        this.bookigService = bookigService;
	        this.unlockService = unlockService;
	        this.router = router;
	        this.translate = translate;
	        this.activeRoute = activeRoute;
	        this.locationService = locationService;
	        this.vehicleService = vehicleService;
	        this.withVehicleInfo = false;
	        this.roleLevel = config_1.RoleLevel;
	    }
	    BookingInformationComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.model = new booking_information_model_1.BookingInformation();
	        this.lockunlock = new lockunlock_model_1.LockUnlock();
	        this.startride = new StartRide_1.StartRide();
	        this.endride = new EndRide_1.EndRide();
	        this.urlDefaultPage = this.authService.GetURL(config_2.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlBooking = this.authService.GetURL(config_2.ApplicationRouteURL.URL_BOOKING);
	        this.urlBookingTrips = this.authService.GetURL(config_2.ApplicationRouteURL.URL_BOOKING_INFORMATION2);
	        this.urlCostsSummary = this.authService.GetURL(config_2.ApplicationRouteURL.URL_BOOKING_INFORMATION3);
	        this.urlBookingOverView = this.authService.GetURL(config_2.ApplicationRouteURL.URL_BOOKING_OVERVIEW);
	        this.urlVehicleInfo = this.authService.GetURL(config_2.ApplicationRouteURL.URL_VEHICLE_INFO);
	        this.urlSVGInfo = this.authService.GetURL(config_2.ApplicationRouteURL.URL_SVG_UPDATE);
	        this.urlVtsTroubleShoot = this.authService.GetURL(config_2.ApplicationRouteURL.URL_VTS_TROUBLESHOOT);
	        this.urlEventViewer = this.authService.GetURL(config_2.ApplicationRouteURL.URL_EVENT_VIEWER_LIST);
	        this.activeRoute.queryParams.subscribe(function (queryParams) {
	            _this.withVehicleInfo = queryParams['vehicleInfo'] == 'true';
	            _this.sub = _this.activeRoute.params.subscribe(function (params) {
	                _this.bookingHashId = params["id"] || "";
	                if (_this.bookingHashId != "") {
	                    _this.GetBookingInformation();
	                }
	            });
	        });
	    };
	    BookingInformationComponent.prototype.GetContactTypeGroup = function () {
	        var _this = this;
	        this.unlockService.GetContactTypeGroupList(this.bookingHashId).subscribe(function (res) {
	            console.log(res.data);
	            _this.contacttpyegroupList = res.data;
	            if (_this.contacttpyegroupList.length > 0) {
	                if (_this.contacttpyegroupList &&
	                    _this.contacttpyegroupList.length > 1) {
	                    _this.contacttypegroupid = _this.contacttpyegroupList.filter(function (x) { return x.isSelected; })[0].contactTypeGroupId;
	                    console.log(_this.contacttypegroupid);
	                    _this.isContractTypeGroupAvailable = true;
	                }
	                else {
	                    _this.contacttypegroupid = _this.contacttpyegroupList[0].contactTypeGroupId;
	                    _this.isContractTypeGroupAvailable = false;
	                }
	            }
	        }, function (error) { });
	    };
	    BookingInformationComponent.prototype.GetBookingInformation = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.bookigService
	            .GetBookingInformationByHashId(this.bookingHashId, 'page1')
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.model = res.data;
	                _this.vtsTroubleShootLink = new config_1.WeGoAuthorizedLink(_this.urlVtsTroubleShoot + "/" + _this.model.vehicleHashId, config_1.Permission.PR_VTS_TROUBLESHOOT, config_1.PermissionType.VIEW, "", "LblTroubleShootVTS", "", "", false, "fa fa-wrench");
	                _this.viewVehicleLink = new config_1.WeGoAuthorizedLink(_this.urlVehicleInfo + "/" + _this.model.vehicleHashId, config_1.Permission.PR_VEHICLES_OVERVIEW, config_1.PermissionType.VIEW, "", _this.model.licenceTag, "", "", true);
	                _this.updateSvgLink = new config_1.WeGoAuthorizedLink(_this.urlSVGInfo + "/" + _this.model.sharedVehicleGroupHashId, config_1.Permission.PR_SHARED_VEHICLE_GROUP_OVERVIEW, config_1.PermissionType.EDIT, "", _this.model.sharedVehicleGroup, config_1.Entity.SVG, _this.model.sharedVehicleGroupHashId, true);
	                _this.viewEventViewerLink = new config_1.WeGoAuthorizedLink(_this.urlEventViewer +
	                    "?filter ='BOOKING'& searchTerm= " +
	                    _this.model.bookingReferenceID, config_1.Permission.PR_EVENT_VIEWER, config_1.PermissionType.VIEW, "", "LblEventViewer", "", "", false);
	                _this.isLoading = false;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        }, function () { return (_this.contacttpyegroupList = _this.GetContactTypeGroup()); });
	    };
	    BookingInformationComponent.prototype.CheckBookingExtendTime = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.bookigService.CheckBookingExtendTime(this.bookingHashId).subscribe(function (res) {
	            if (res.data > 0) {
	                _this.availableBookingExtandTime = res.data;
	                _this.bookingExtandInfoMsg = _this.translate.instant("LblExtendInfoMsg", _this.availableBookingExtandTime.toString());
	            }
	            else {
	                _this.bookingExtandInfoMsg = _this.translate.instant("LblExtendValidationMsg");
	            }
	            _this.ShowAlertModal();
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BookingInformationComponent.prototype.OnBackClick = function () {
	        this.router.navigate([this.urlBookingOverView]);
	    };
	    BookingInformationComponent.prototype.OnTripsClick = function (bookingIdHashId) {
	        var url = this.urlBookingTrips + '/' + bookingIdHashId;
	        this.router.navigateByUrl(url);
	    };
	    BookingInformationComponent.prototype.OnCostsSummaryClick = function (bookingIdHashId) {
	        var url = this.urlCostsSummary + '/' + bookingIdHashId;
	        this.router.navigateByUrl(url);
	    };
	    BookingInformationComponent.prototype.StartBooking = function (bookingExternalId) {
	        var _this = this;
	        this.isLoading = true;
	        this.bookigService.StartBooking(bookingExternalId).subscribe(function (res) {
	            if (res.bookingStatus == 'running') {
	                _this.message = _this.translate.instant("LblBookingStarted");
	                _this.popupTitle = _this.translate.instant("LblSuccess");
	                _this.validationModal.show();
	                setTimeout(function () { window.location.reload(); }, 1000);
	            }
	            else {
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.bookingExtandInfoMsg = _this.translate.instant('LblCouldnotStartBooking');
	            }
	            _this.ShowAlertModal();
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BookingInformationComponent.prototype.StopBooking = function (bookingExternalId) {
	        var _this = this;
	        this.isLoading = true;
	        this.bookigService.StopBooking(bookingExternalId).subscribe(function (res) {
	            if (res.bookingStatus == 'stopped') {
	                _this.message = _this.translate.instant("LblBookingStopped");
	                _this.popupTitle = _this.translate.instant("LblSuccess");
	                _this.validationModal.show();
	                setTimeout(function () { window.location.reload(); }, 1000);
	            }
	            else {
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.bookingExtandInfoMsg = _this.translate.instant('LblCouldnotStopBooking');
	            }
	            _this.ShowAlertModal();
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BookingInformationComponent.prototype.LockVTSVehicle = function (locationDataExchangeHashId) {
	        var _this = this;
	        this.isLoading = true;
	        this.vehicleService.LockVTSVehicle(locationDataExchangeHashId, false)
	            .subscribe(function (res) {
	            _this.isLoading = false;
	            if (res.data) {
	                _this.message = _this.translate.instant("LblLockSuccessfully");
	                _this.popupTitle = _this.translate.instant("LblSuccess");
	                _this.validationModal.show();
	            }
	            else {
	                if (res.error.toUpperCase() == "ACTION ABORTED, ENGINE STILL RUNNING") {
	                    _this.popupMsg = _this.translate.instant("LblEngineStillRunning");
	                    _this.popupTitle = _this.translate.instant("LblWarning");
	                }
	                else {
	                    _this.popupMsg = _this.translate.instant('LbllockProblem');
	                    _this.popupTitle = _this.translate.instant('LblWarning');
	                }
	                _this.validationModal.show();
	            }
	        }, function (error) {
	            _this.isLoading = false;
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    BookingInformationComponent.prototype.UnLockVTSVehicle = function (locationDataExchangeHashId) {
	        var _this = this;
	        this.isLoading = true;
	        this.vehicleService.UnLockVTSVehicle(locationDataExchangeHashId, false)
	            .subscribe(function (res) {
	            _this.isLoading = false;
	            if (res.data) {
	                _this.message = _this.translate.instant("LblUnLockSuccessfully");
	                _this.popupTitle = _this.translate.instant("LblSuccess");
	                _this.validationModal.show();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblUnlockProblem');
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.validationModal.show();
	            }
	        }, function (error) {
	            _this.isLoading = false;
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    BookingInformationComponent.prototype.ShowAlertModal = function () {
	        this.bookingExtensionValidation = "";
	        this.alertModal.show();
	    };
	    BookingInformationComponent.prototype.HideAlertModal = function () {
	        this.bookingExtensionValidation = "";
	        this.bookingExtendTime = null;
	        this.alertModal.hide();
	    };
	    BookingInformationComponent.prototype.SuccessAlertModalClick = function () {
	        if (this.availableBookingExtandTime > 0) {
	            if (this.bookingExtendTime && this.bookingExtendTime > 0) {
	                if (this.bookingExtendTime > this.availableBookingExtandTime) {
	                    this.bookingExtensionValidation = this.translate.instant("LblOverExtendValidationMsg", this.availableBookingExtandTime.toString());
	                }
	                else {
	                    this.bookingExtensionValidation = "";
	                    this.ExtendOnGoingBooking();
	                    this.HideAlertModal();
	                }
	            }
	            else {
	                this.bookingExtensionValidation = this.translate.instant("LblExtendRequire");
	            }
	        }
	        else {
	            this.bookingExtensionValidation = "";
	            this.HideAlertModal();
	        }
	    };
	    BookingInformationComponent.prototype.ExtendOnGoingBooking = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.bookigService
	            .ExtendOnGoingBooking(this.bookingHashId, this.bookingExtendTime)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant("LblBookingExtendedSuccess");
	                _this.isLoading = false;
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BookingInformationComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    BookingInformationComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    BookingInformationComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	        this.router.navigate([this.urlBookingOverView]);
	    };
	    BookingInformationComponent.prototype.HideValidationModal = function () {
	        this.validationModal.hide();
	    };
	    BookingInformationComponent.prototype.UnlockVehicle = function (bookingIdHashId, vehicleExchangeHashId) {
	        var _this = this;
	        this.lockunlock.bookingMasterHashId = bookingIdHashId;
	        this.lockunlock.contractTypeGroupId = this.contacttypegroupid;
	        this.lockunlock.locationDataExchangeHashId = vehicleExchangeHashId;
	        this.lockunlock.isMobileRequest = false;
	        if (this.contacttpyegroupList && this.contacttpyegroupList.length > 0) {
	            this.isLoading = true;
	            this.unlockService.UnlockVehicle(this.lockunlock).subscribe(function (res) {
	                if (res.data) {
	                    _this.lockunlockresult = res.data;
	                    if (_this.lockunlockresult.isTripCalculatingInProgress) {
	                        _this.isLoading = false;
	                        _this.message = _this.translate.instant("LblTripCalculationInProgress");
	                        _this.popupTitle = _this.translate.instant("LblWarning");
	                        _this.validationModal.show();
	                    }
	                    else if (_this.lockunlockresult.isBookingExpired) {
	                        _this.isLoading = false;
	                        _this.message = _this.translate.instant("LblBookingExpired");
	                        _this.popupTitle = _this.translate.instant("LblWarning");
	                        _this.validationModal.show();
	                    }
	                    else if (_this.lockunlockresult.isSameCommandInProgress) {
	                        _this.isLoading = false;
	                        _this.message = _this.translate.instant("LblSameVTSCommand");
	                        _this.popupTitle = _this.translate.instant("LblWarning");
	                        _this.validationModal.show();
	                    }
	                    else if (_this.lockunlockresult.isDoorStatusOpened) {
	                        _this.isLoading = false;
	                        _this.popupMsg = _this.translate.instant("LblUnLockSuccessfully");
	                        _this.ShowSuccessPopup();
	                    }
	                    else if (!_this.lockunlockresult.isUnlock &&
	                        !_this.lockunlockresult.isTripCalculatingInProgress &&
	                        !_this.lockunlockresult.isSameCommandInProgress) {
	                        _this.isLoading = false;
	                        _this.message = _this.translate.instant("LblUnlockProblem");
	                        _this.popupTitle = _this.translate.instant("LblWarning");
	                        _this.validationModal.show();
	                    }
	                    else if (_this.lockunlockresult.isUnlock) {
	                        //this.GetStartRideSubmit();
	                        _this.isLoading = false;
	                        _this.popupMsg = _this.translate.instant("LblUnLockSuccessfully");
	                        _this.ShowSuccessPopup();
	                    }
	                }
	            }, function (error) {
	                _this.isLoading = false;
	            });
	        }
	        else {
	            this.message = this.translate.instant("LblUnlockErrorMessage");
	            this.popupTitle = this.translate.instant("LblWarning");
	            this.validationModal.show();
	        }
	    };
	    // public GetStartRideSubmit() {
	    //   this.isLoading = true;
	    //   this.startride.contractTypeGroupId = this.contacttypegroupid;
	    //   this.startride.startDateTime = this.lockunlockresult.startDateTime;
	    //   this.startride.startLatitude = this.lockunlockresult.startLat;
	    //   this.startride.startLongitude = this.lockunlockresult.startLog;
	    //   this.startride.startMileage = this.lockunlockresult.startMilege;
	    //   this.startride.bookingHashId = this.bookingHashId;
	    //   this.startride.locationExchangeHashId = this.lockunlock.locationDataExchangeHashId;
	    //   this.startride.bookingTripSummaryId = this.lockunlockresult.bookingTripSummaryId;
	    //   let tripcommandproblem = this.translate.instant('LblProblemTrip');
	    //   this.unlockService.StartTrip(this.startride)
	    //     .subscribe(
	    //     res => {
	    //       if (res.data) {
	    //         this.triphashId = res.data;
	    //         this.isLoading = false;
	    //         this.popupMsg = this.translate.instant('LblUnLockSuccessfully');
	    //         this.ShowSuccessPopup();
	    //       }
	    //       else {
	    //         this.isLoading = false;
	    //       }
	    //     },
	    //     error => {
	    //       this.isLoading = false;
	    //     });
	    // }
	    BookingInformationComponent.prototype.LockVehicle = function (bookingIdHashId, vehicleExchangeHashId) {
	        var _this = this;
	        this.lockunlock.bookingMasterHashId = bookingIdHashId;
	        this.lockunlock.locationDataExchangeHashId = vehicleExchangeHashId;
	        this.lockunlock.isMobileRequest = false;
	        this.isLoading = true;
	        this.unlockService.LockVehicle(this.lockunlock).subscribe(function (res) {
	            if (res.data) {
	                _this.lockunlockresult = res.data;
	                if (_this.lockunlockresult.isBookingExpired) {
	                    _this.isLoading = false;
	                    _this.message = _this.translate.instant("LblBookingExpired");
	                    _this.popupTitle = _this.translate.instant("LblWarning");
	                    _this.validationModal.show();
	                }
	                else if (_this.lockunlockresult.isSameCommandInProgress) {
	                    _this.isLoading = false;
	                    _this.message = _this.translate.instant("LblSameVTSCommand");
	                    _this.popupTitle = _this.translate.instant("LblWarning");
	                    _this.validationModal.show();
	                }
	                else if (_this.lockunlockresult.isDoorStatusClosed) {
	                    _this.popupMsg = _this.translate.instant("LblLockCompletelySuccessfully");
	                    _this.isLoading = false;
	                    _this.ShowSuccessPopup();
	                }
	                else if (!_this.lockunlockresult.isLock &&
	                    !_this.lockunlockresult.isSameCommandInProgress) {
	                    _this.isLoading = false;
	                    _this.message = _this.translate.instant("LbllockProblem");
	                    _this.popupTitle = _this.translate.instant("LblWarning");
	                    _this.validationModal.show();
	                }
	                else {
	                    //this.GetEndRideSubmit(bookingIdHashId, vehicleExchangeHashId);
	                    _this.popupMsg = _this.translate.instant("LblLockCompletelySuccessfully");
	                    _this.isLoading = false;
	                    _this.ShowSuccessPopup();
	                }
	            }
	            else {
	            }
	        }, function (error) {
	            _this.isLoading = false;
	        });
	    };
	    BookingInformationComponent.prototype.PartialockResult = function (bookingIdHashId, vehicleExchangeHashId) {
	        var _this = this;
	        this.lockunlock.bookingMasterHashId = bookingIdHashId;
	        this.lockunlock.locationDataExchangeHashId = vehicleExchangeHashId;
	        this.lockunlock.tripHashId = this.triphashId
	            ? this.triphashId.toString()
	            : "0";
	        this.lockunlock.isMobileRequest = false;
	        this.isLoading = true;
	        this.unlockService.PartialLock(this.lockunlock).subscribe(function (res) {
	            if (res.data) {
	                _this.lockunlockresult = res.data;
	                if (_this.lockunlockresult.isBookingExpired) {
	                    _this.isLoading = false;
	                    _this.message = _this.translate.instant("LblBookingExpired");
	                    _this.popupTitle = _this.translate.instant("LblWarning");
	                    _this.validationModal.show();
	                }
	                else if (_this.lockunlockresult.isSameCommandInProgress) {
	                    _this.isLoading = false;
	                    _this.message = _this.translate.instant("LblSameVTSCommand");
	                    _this.popupTitle = _this.translate.instant("LblWarning");
	                    _this.validationModal.show();
	                }
	                else if (_this.lockunlockresult.isDoorStatusClosed) {
	                    _this.popupMsg = _this.translate.instant("LblLockCompletelySuccessfully");
	                    _this.isLoading = false;
	                    _this.ShowSuccessPopup();
	                }
	                else if (_this.lockunlockresult.engineStillRunning) {
	                    _this.isLoading = false;
	                    _this.message = _this.translate.instant("LblEngineStillRunning");
	                    _this.popupTitle = _this.translate.instant("LblWarning");
	                    _this.validationModal.show();
	                }
	                else if (!_this.lockunlockresult.isLock) {
	                    _this.isLoading = false;
	                    _this.message = _this.translate.instant("LbllockProblem");
	                    _this.popupTitle = _this.translate.instant("LblWarning");
	                    _this.validationModal.show();
	                }
	                else {
	                    _this.popupMsg = _this.translate.instant("LblLockSuccessfully");
	                    _this.isLoading = false;
	                    _this.ShowSuccessPopup();
	                }
	            }
	        }, function (error) {
	            _this.isLoading = false;
	        });
	    };
	    // public GetEndRideSubmit(bookingIdHashId: string, vehicleExchangeHashId: string) {
	    //   this.endride.bookingHashId = bookingIdHashId;
	    //   this.endride.tripHashId = this.triphashId ? this.triphashId.toString() : '0';
	    //   this.endride.locationExchangeHashId = vehicleExchangeHashId;
	    //   this.unlockService.EndTrip(this.endride)
	    //     .subscribe(
	    //     res => {
	    //       if (res.data) {
	    //         this.lockunlockresult = res.data;
	    //       }
	    //       else {
	    //       }
	    //     },
	    //     error => {
	    //     });
	    // }
	    BookingInformationComponent.prototype.ReportDamage = function (bookingHashId) {
	        this.reportDamageModal.model.bookingHashId = bookingHashId;
	        this.reportDamageModal.model.vehicleHashId = this.model.vehicleHashId;
	        this.reportDamageModal.show();
	    };
	    BookingInformationComponent.prototype.FreeBooking = function (bookingHashId) {
	        this.freebookingModal.model.bookingHashId = bookingHashId;
	        this.freebookingModal.show();
	    };
	    BookingInformationComponent.prototype.SuccessReportDamage = function (successMsg) {
	        this.popupMsg = successMsg;
	        this.ShowSuccessPopup();
	    };
	    BookingInformationComponent.prototype.SuccessSave = function (successMsg) {
	        this.popupMsg = successMsg;
	        this.ShowUpdateSuccessPopup();
	        this.GetBookingInformation();
	    };
	    BookingInformationComponent.prototype.AddTripDetail = function () {
	        this.bookingTripDetailModal.model = new booking_information_model_1.BookingTripDetail();
	        this.bookingTripDetailModal.show();
	    };
	    BookingInformationComponent.prototype.EditTripDetail = function (bookingtrip) {
	        this.bookingTripDetailModal.model = JSON.parse(JSON.stringify(bookingtrip));
	        this.bookingTripDetailModal.show();
	    };
	    BookingInformationComponent.prototype.ShowConfirmModal = function (bookingtripHashId) {
	        this.isLoading = false;
	        this.deleteMessage = this.translate.instant("LblRecordDeleteConfirmation", this.translate.instant("LblBookingTripDetail"));
	        this.confirmModal.show();
	        this.bookingtripHashId = bookingtripHashId;
	    };
	    BookingInformationComponent.prototype.HideConfirmModal = function () {
	        this.confirmModal.hide();
	    };
	    BookingInformationComponent.prototype.ConfirmSuccessClick = function () {
	        this.confirmModal.hide();
	        //this.DeleteBookingTrip();
	    };
	    // public DeleteBookingTrip() {
	    //   this.isLoading = true;
	    //   this.bookigService.DeleteBookingTrip(this.bookingtripHashId)
	    //     .subscribe(
	    //     (res: any) => {
	    //       if (res.data) {
	    //         this.GetBookingInformation();
	    //         this.popupMsg = this.translate.instant('LblRecordRemovedSuccess', this.translate.instant('LblBookingTripDetail'));
	    //         this.ShowUpdateSuccessPopup();
	    //       }
	    //       else {
	    //         this.popupMsg = res.error;
	    //         this.isLoading = false;
	    //         this.ShowUpdateSuccessPopup();
	    //       }
	    //     },
	    //     (error: any) => {
	    //       this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
	    //       this.isLoading = false;
	    //     });
	    // }
	    BookingInformationComponent.prototype.ShowUpdateSuccessPopup = function () {
	        this.updateSuccessPopup.show();
	    };
	    BookingInformationComponent.prototype.HideUpdateSuccessPopup = function () {
	        this.updateSuccessPopup.hide();
	    };
	    BookingInformationComponent.prototype.ConfirmUpdateSuccessPopup = function () {
	        this.updateSuccessPopup.hide();
	    };
	    BookingInformationComponent.prototype.EditExpenseDetail = function (bookingexpense) {
	        this.bookingExpenseModel.model = JSON.parse(JSON.stringify(bookingexpense));
	        this.bookingExpenseModel.show();
	    };
	    BookingInformationComponent.prototype.ShowReceipt = function (imagepath) {
	        this.receiptImagePopup.imagepath = config_2.WeGoConfig.API_SERVER_URL + imagepath;
	        this.receiptImagePopup.show();
	    };
	    BookingInformationComponent.prototype.GroupByCategory = function (vehicleAttributeList) {
	        if (vehicleAttributeList) {
	            var prop_1 = "vehicleAttributeCategoryName";
	            return vehicleAttributeList.reduce(function (groups, item) {
	                var val = item[prop_1];
	                groups[val] = groups[val] || [];
	                groups[val].push(item);
	                groups[val] = groups[val].sort(function (obj1, obj2) {
	                    if (obj1.attributeName > obj2.attributeName) {
	                        return 1;
	                    }
	                    if (obj1.attributeName < obj2.attributeName) {
	                        return -1;
	                    }
	                    return 0;
	                });
	                return groups;
	            }, {});
	        }
	        else {
	            return {};
	        }
	    };
	    BookingInformationComponent.prototype.KeyOfObject = function (obj) {
	        return Object.keys(obj);
	    };
	    BookingInformationComponent.prototype.CalculateTripCost = function (dataArray, propName) {
	        var total = 0;
	        for (var n = 0; n < dataArray.length; n++) {
	            total += dataArray[n][propName];
	        }
	        return Math.round(total * 100) / 100;
	    };
	    __decorate([
	        core_1.ViewChild("alertModal"), 
	        __metadata('design:type', Object)
	    ], BookingInformationComponent.prototype, "alertModal", void 0);
	    __decorate([
	        core_1.ViewChild("successPopup"), 
	        __metadata('design:type', Object)
	    ], BookingInformationComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild("validationModal"), 
	        __metadata('design:type', Object)
	    ], BookingInformationComponent.prototype, "validationModal", void 0);
	    __decorate([
	        core_1.ViewChild("reportDamageModal"), 
	        __metadata('design:type', Object)
	    ], BookingInformationComponent.prototype, "reportDamageModal", void 0);
	    __decorate([
	        core_1.ViewChild("bookingTripDetailModal"), 
	        __metadata('design:type', Object)
	    ], BookingInformationComponent.prototype, "bookingTripDetailModal", void 0);
	    __decorate([
	        core_1.ViewChild("confirmModal"), 
	        __metadata('design:type', Object)
	    ], BookingInformationComponent.prototype, "confirmModal", void 0);
	    __decorate([
	        core_1.ViewChild("updateSuccessPopup"), 
	        __metadata('design:type', Object)
	    ], BookingInformationComponent.prototype, "updateSuccessPopup", void 0);
	    __decorate([
	        core_1.ViewChild("bookingExpenseModel"), 
	        __metadata('design:type', Object)
	    ], BookingInformationComponent.prototype, "bookingExpenseModel", void 0);
	    __decorate([
	        core_1.ViewChild("receiptImagePopup"), 
	        __metadata('design:type', Object)
	    ], BookingInformationComponent.prototype, "receiptImagePopup", void 0);
	    __decorate([
	        core_1.ViewChild("freebookingModal"), 
	        __metadata('design:type', Object)
	    ], BookingInformationComponent.prototype, "freebookingModal", void 0);
	    BookingInformationComponent = __decorate([
	        core_1.Component({
	            selector: "wego-booking-information",
	            template: __webpack_require__(706),
	            styles: [
	                "\n      span.label.label-default {\n        font-size: 13px;\n        line-height: 35px;\n        background-color: #eeeeee;\n        color: #2ba2aa;\n        margin-right: 5px;\n      }\n\n      span.label.label-default.text-success {\n        color: #3c763d;\n      }\n\n      span.label.label-default.text-danger {\n        color: #a94442;\n      }\n\n      .line {\n        border-top: 1px solid #000;\n      }\n    "
	            ],
	            providers: [booking_service_1.BookingService, unlock_service_1.UnlockService, vehicle_service_1.VehicleService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof booking_service_1.BookingService !== 'undefined' && booking_service_1.BookingService) === 'function' && _b) || Object, (typeof (_c = typeof unlock_service_1.UnlockService !== 'undefined' && unlock_service_1.UnlockService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _f) || Object, (typeof (_g = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _g) || Object, (typeof (_h = typeof vehicle_service_1.VehicleService !== 'undefined' && vehicle_service_1.VehicleService) === 'function' && _h) || Object])
	    ], BookingInformationComponent);
	    return BookingInformationComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h;
	}());
	exports.BookingInformationComponent = BookingInformationComponent;


/***/ },
/* 701 */
/***/ function(module, exports) {

	"use strict";
	var EndRide = (function () {
	    function EndRide() {
	    }
	    return EndRide;
	}());
	exports.EndRide = EndRide;


/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var jquery_helper_service_1 = __webpack_require__(67);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var UnlockService = (function () {
	    function UnlockService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	        this.JQueryHelper = new jquery_helper_service_1.JQueryHelperService();
	    }
	    UnlockService.prototype.UnlockVehicle = function (lockUnlock) {
	        var body = lockUnlock;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_UnLOCK, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    UnlockService.prototype.StartTrip = function (startride) {
	        var body = startride;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_STARTRIDE, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    UnlockService.prototype.GetContactTypeGroupList = function (bookingHashId) {
	        var getcontacttypegrouplist = config_1.WeGoConfig.API_CONTACTYPE_LIST + "?bookingHashId=" + bookingHashId;
	        var queryString = this.authService.HandleAPIListInput();
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getcontacttypegrouplist, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    UnlockService.prototype.PartialLock = function (lockUnlock) {
	        var body = lockUnlock;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_PARTIALLOCK, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    UnlockService.prototype.LockVehicle = function (lockUnlock) {
	        var body = lockUnlock;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_LOCK, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    UnlockService.prototype.EndTrip = function (endride) {
	        var body = endride;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_ENDRIDE, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    UnlockService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], UnlockService);
	    return UnlockService;
	    var _a, _b;
	}());
	exports.UnlockService = UnlockService;


/***/ },
/* 703 */
/***/ function(module, exports) {

	"use strict";
	var StartRide = (function () {
	    function StartRide() {
	    }
	    return StartRide;
	}());
	exports.StartRide = StartRide;


/***/ },
/* 704 */
/***/ function(module, exports) {

	"use strict";
	var LockUnlock = (function () {
	    function LockUnlock() {
	        this.isMobileRequest = false;
	    }
	    return LockUnlock;
	}());
	exports.LockUnlock = LockUnlock;


/***/ },
/* 705 */
/***/ function(module, exports) {

	"use strict";
	var BookingInformation = (function () {
	    function BookingInformation() {
	        this.invoiceDetail = new InvoiceDetail();
	    }
	    return BookingInformation;
	}());
	exports.BookingInformation = BookingInformation;
	var PrePostTripDetails = (function () {
	    function PrePostTripDetails() {
	    }
	    return PrePostTripDetails;
	}());
	exports.PrePostTripDetails = PrePostTripDetails;
	var InvoiceDetail = (function () {
	    function InvoiceDetail() {
	    }
	    return InvoiceDetail;
	}());
	exports.InvoiceDetail = InvoiceDetail;
	var BookingTripDetail = (function () {
	    function BookingTripDetail() {
	        this.contractTypeGroupHashId = "";
	    }
	    return BookingTripDetail;
	}());
	exports.BookingTripDetail = BookingTripDetail;
	var VehicleRequest = (function () {
	    function VehicleRequest() {
	    }
	    return VehicleRequest;
	}());
	exports.VehicleRequest = VehicleRequest;
	var Expense = (function () {
	    function Expense() {
	    }
	    return Expense;
	}());
	exports.Expense = Expense;


/***/ },
/* 706 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ 'LblOverview' | translate }}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"urlBookingOverView\">\r\n            <i class=\"fa fa-calendar fa-fw\"></i>{{ 'LblOverviewList' | translate }}</a>\r\n        </li>\r\n        <li> {{ 'LblOverview' | translate }} </li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25\">\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"col-sm-12\">\r\n      <fieldset *ngIf=\"model.bookingType == 'NORMAL'\">\r\n        <legend class=\"legendStyle\">\r\n          {{ 'LblDriverDetail' | translate }}\r\n        </legend>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"row\">\r\n          <div class=\"col-sm-4 col-xs-6\">\r\n            <label>{{ 'LblDriverName' | translate }} :</label> {{ model.driverName }}\r\n          </div>\r\n          <div *ngIf=\"model.email\" class=\"col-sm-4 col-xs-6\">\r\n            <label>{{ 'LblEmail' | translate }} :</label> {{ model.email }}\r\n          </div>\r\n          <div *ngIf=\"model.sharedVehicleGroup\" class=\"col-sm-4 col-xs-6\">\r\n            <label>{{ 'LblSharedVehicleGroup' | translate }} :</label>\r\n            <span>\r\n              <!-- <a [routerLink]=\"[urlSVGInfo,{ sharedvehiclegroupHashId : model.sharedVehicleGroupHashId }]\">\r\n                {{ model.sharedVehicleGroup }}\r\n              </a> -->\r\n              <wego-authorized-link *ngIf=\"!model.isSharedVehicleGroupDeleted\" [LinkModel]=\"updateSvgLink\"></wego-authorized-link>              \r\n            </span>\r\n            <span *ngIf=\"model.isSharedVehicleGroupDeleted\"> {{ model.sharedVehicleGroup }} </span>\r\n          </div>\r\n        </div>\r\n        <div class=\"row\">\r\n          <div class=\"col-sm-4 col-xs-6\">\r\n            <label>{{ 'LblOrganization' | translate }} :</label> {{ model.organizationName }}\r\n          </div>\r\n        </div>\r\n      </fieldset>\r\n      <br />\r\n      <fieldset>\r\n        <legend class=\"legendStyle\">\r\n          {{ 'LblBookingDetail' | translate }}\r\n        </legend>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"row\">\r\n          <div style=\"word-wrap: break-word;\" class=\"col-sm-4 col-xs-4\">\r\n            <label>{{ 'LblBookingReferenceId' | translate }} :</label> {{ model.bookingReferenceID }}&nbsp;\r\n            <a *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.WeGo\" [routerLink]=\"[urlEventViewer, {filter :'BOOKING', searchTerm : model.bookingReferenceID }]\">{{ 'LblEventViewer' | translate }}</a>\r\n            <!-- <wego-authorized-link *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.WeGo\" [LinkModel]=\"viewEventViewerLink\"></wego-authorized-link> -->\r\n          </div>\r\n          <div *ngIf=\"model.recurringID\" class=\"col-sm-4 col-xs-4\">\r\n            <label>{{ 'LblRecurring' | translate }} :</label> {{ model.recurringID }}</div>\r\n          <div class=\"col-sm-4 col-xs-4\">\r\n            <label>{{ 'LblBookingStartDateTime' | translate }} :</label> {{ model.startDateTime }}</div>\r\n          <div class=\"col-sm-4 col-xs-4\">\r\n            <label>{{ 'LblBookingEndDateTime' | translate }} :</label> {{ model.endDateTime }}</div>\r\n          <div class=\"col-sm-4 col-xs-4\">\r\n            <label>{{ 'LblBookingStatus' | translate }} :</label> {{ model.translatedBookingStatus }}</div>\r\n          <div class=\"col-sm-4 col-xs-4\">\r\n            <label>{{ 'LblBookingType' | translate }} :</label> {{ model.translatedBookingType }}</div>\r\n          <div *ngIf=\"model.bookingType == 'NORMAL' && model.bookingRemarks\" class=\"col-sm-4 col-xs-4\" style=\"word-break: break-all\">\r\n            <label>{{ 'LblBookingRemarks' | translate }} :</label> {{ model.bookingRemarks }}</div>\r\n          <div *ngIf=\"model.bookingType == 'NORMAL' && model.driverRemarks\" class=\"col-sm-4 col-xs-4\" style=\"word-break: break-all\">\r\n            <label>{{ 'LblDriverRemarks' | translate }} :</label> {{ model.driverRemarks }}</div>\r\n          <div *ngIf=\"model.bookingType != 'NORMAL' && model.adminRemarks\" class=\"col-sm-4 col-xs-4\" style=\"word-break: break-all\">\r\n            <label>{{ 'LblAdminRemarks' | translate }} :</label> {{ model.adminRemarks }}</div>\r\n          <div *ngIf=\"model.bookingType != 'NORMAL' && model.comment\" class=\"col-sm-4 col-xs-4\" style=\"word-break: break-all\">\r\n            <label>{{ 'LblComment' | translate }} :</label> {{ model.comment }}</div>\r\n          <div *ngIf=\"model.isLock && isContractTypeGroupAvailable\" class=\"col-sm-4 col-xs-4\">\r\n            <label>{{ 'LblContractTypeGroup' | translate }} :</label>\r\n            <select [(ngModel)]=\"contacttypegroupid\" name=\"contacttypegroupid\" class=\"form-control\">\r\n              <option *ngFor=\"let item of contacttpyegroupList\" [ngValue]='item.contactTypeGroupId'>{{item.contactTypeGroupName}}</option>\r\n            </select>\r\n          </div>\r\n          <div *ngIf=\"model.pickupAddress\" class=\"col-sm-4 col-xs-4\">\r\n            <label>{{ 'LblPickupLocation' | translate }} :</label> {{ model.pickupAddress }}</div>\r\n          <div class=\"clearfix\"></div>\r\n        </div>\r\n      </fieldset>\r\n      <br />\r\n      <fieldset>\r\n        <legend class=\"legendStyle\">\r\n          {{ 'LblVehicleDetail' | translate }}\r\n        </legend>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"row\">\r\n          <div style=\"word-wrap: break-word;\" *ngIf=\"model.licenceTag\" class=\"col-sm-4 col-xs-6\">\r\n            <label>{{ 'LblLicenceTag' | translate }} :</label>\r\n            <span *ngIf=\"!model.isVehicleDeleted\">\r\n              <wego-authorized-link [LinkModel]=\"viewVehicleLink\"></wego-authorized-link>\r\n              &nbsp;\r\n              <wego-authorized-link [LinkModel]=\"vtsTroubleShootLink\"></wego-authorized-link>\r\n            </span>\r\n            <span *ngIf=\"model.isVehicleDeleted\"> {{ model.licenceTag }} </span>\r\n          </div>\r\n          <!--<div *ngIf=\"model.sharedVehicleGroup\" class=\"col-sm-4 col-xs-6\">\r\n            <label>{{ 'LblSharedVehicleGroup' | translate }} :</label>\r\n            <a [routerLink]=\"[urlSVGInfo,{ sharedvehiclegroupHashId : model.sharedVehicleGroupHashId }]\">                    \r\n                  {{ model.sharedVehicleGroup }}\r\n                     </a>\r\n          </div>-->\r\n          <div *ngIf=\"model.brand\" class=\"col-sm-4 col-xs-6\">\r\n            <label>{{ 'LblBrand' | translate }} :</label> {{ model.brand }}\r\n          </div>\r\n          <div *ngIf=\"model.type\" class=\"col-sm-4 col-xs-6\">\r\n            <label>{{ 'LblType' | translate }} :</label> {{ model.type }}\r\n          </div>\r\n          <div *ngIf=\"model.color\" class=\"col-sm-4 col-xs-6\">\r\n            <label>{{ 'LblColor' | translate }} :</label> {{ model.color }}\r\n          </div>\r\n          <div *ngIf=\"model.vehicleClass\" class=\"col-sm-4 col-xs-6\">\r\n            <label>{{ 'LblVehicleClass' | translate }} :</label> {{ model.vehicleClass }}\r\n          </div>\r\n          <div *ngIf=\"model.pricingCategory\" class=\"col-sm-4 col-xs-6\">\r\n            <label>{{ 'LblPricingCategory' | translate }} :</label> {{ model.pricingCategory }}\r\n          </div>\r\n          <div *ngIf=\"model.bodyStyle\" class=\"col-sm-4 col-xs-6\">\r\n            <label>{{ 'LblBodyStyle' | translate }} :</label> {{model.bodyStyle }}\r\n          </div>\r\n          <div *ngIf=\"model.fuelType\" class=\"col-sm-4 col-xs-6\">\r\n            <label>{{ 'LblFuelType' | translate }} :</label> {{ model.fuelType }}\r\n          </div>\r\n          <div *ngIf=\"model.vehicleStatus\" class=\"col-sm-4 col-xs-6\">\r\n            <label>{{ 'LblVehicleStatus' | translate }} :</label> {{ model.vehicleStatus }}\r\n          </div>\r\n\r\n\r\n          <div *ngIf=\"model.bookingStatus == 'RUNNING' && model.brand != 'AXA'\" class=\"col-sm-12 col-xs-12\" style=\"margin-top: 40px;\">\r\n            \r\n            <a class=\"btn btn-green cursor-pointer\" style=\"min-width: 160px;\" (click)=\"UnLockVTSVehicle(model.vehicleExchangeHashId)\">\r\n              <i class=\"fa fa-unlock-alt\"></i>&nbsp;{{ 'LblUnLock' | translate }}</a>\r\n\r\n            <a class=\"btn btn-danger cursor-pointer\" style=\"min-width: 160px;\" (click)=\"LockVTSVehicle(model.vehicleExchangeHashId)\">\r\n              <i class=\"fa fa-lock\"></i>&nbsp;{{ 'LblLock' | translate }}</a>\r\n          </div>\r\n\r\n          \r\n        </div>\r\n        <div class=\"row\">\r\n          <div class=\"col-sm-12\" *ngFor=\"let cat of KeyOfObject(GroupByCategory(model.attributeList))\">\r\n            <label>{{ cat }} : </label>\r\n            <span *ngFor=\"let attribute of GroupByCategory(model.attributeList)[cat]\" class=\"label label-default\">\r\n              <i class=\"fa fa-tag fa-lg\" aria-hidden=\"true\"></i>&nbsp;{{ attribute.attributeName }}\r\n            </span>\r\n          </div>\r\n        </div>\r\n        <!-- <div class=\"row\">\r\n          <div class=\"col-sm-12\">\r\n            <span *ngIf=\"model.airco\" class=\"label label-default\" [ngClass]=\"{ 'text-success' : model.airco, 'text-danger' : !model.airco }\">\r\n                        <i *ngIf=\"model.airco\" class=\"fa fa-check fa-lg\" aria-hidden=\"true\"></i>\r\n                        <i *ngIf=\"!model.airco\" class=\"fa fa-times fa-lg\" aria-hidden=\"true\"></i>\r\n                        &nbsp;{{ 'LblAirco' | translate }}\r\n                    </span>\r\n            <span *ngIf=\"model.towbar\" class=\"label label-default\" [ngClass]=\"{ 'text-success' : model.towbar, 'text-danger' : !model.towbar }\">\r\n                        <i *ngIf=\"model.towbar\" class=\"fa fa-check fa-lg\" aria-hidden=\"true\"></i>\r\n                        <i *ngIf=\"!model.towbar\" class=\"fa fa-times fa-lg\" aria-hidden=\"true\"></i>\r\n                        &nbsp;{{ 'LblTowbar' | translate }}\r\n                    </span>\r\n          </div>\r\n        </div> -->\r\n\r\n      </fieldset>\r\n      <br />\r\n      <!-- prepost trip details -->\r\n      <fieldset *ngIf=\"model.prePostTripInformation && model.prePostTripInformation.length > 0\">\r\n        <legend class=\"legendStyle\">\r\n          {{ 'LblPrePostTripQuestion' | translate }}\r\n        </legend>\r\n        <div class=\"table table-responsive mar_bot_ziro borderless\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th>\r\n                  {{ 'LblQuestion' | translate }}\r\n                </th>\r\n                <th>\r\n                  {{ 'LblType' | translate }}\r\n                </th>\r\n                <th>\r\n                  {{ 'LblTimeStamp' | translate }}\r\n                </th>\r\n                <th>\r\n                  {{ 'LblAnswer' | translate }}\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <tr *ngFor=\"let prePostAnswer of model.prePostTripInformation\">\r\n                <td>\r\n                  {{ prePostAnswer.question }}\r\n                </td>\r\n                <td>\r\n                  {{ prePostAnswer.questionType }}\r\n                </td>\r\n                <td>\r\n                  {{ prePostAnswer.answerDateTime }}\r\n                </td>\r\n                <td>\r\n                  {{ prePostAnswer.answer }} &nbsp;&nbsp;\r\n                  <a class=\"cursor-pointer\" popover-placement=\"top\" popover=\"{{ prePostAnswer.remarks }}\" *ngIf=\"prePostAnswer.remarks\">\r\n                    <span>\r\n                      <i class=\"fa fa-search\" aria-hidden=\"true\"></i>\r\n                    </span>\r\n                  </a>\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n      </fieldset>\r\n      <!-- End prepost trip details -->\r\n      <br/>\r\n      <fieldset *ngIf=\"model.listOfBookingTrip && model.listOfBookingTrip.length > 0\">\r\n        <!-- Removed in context of WEGO2DEV-359  -->\r\n        <!-- <legend class=\"legendStyle\">\r\n          {{ 'LblBookingTripDetail' | translate }}\r\n          <a *ngIf=\"!model.invoiceDetail || (model.invoiceDetail?.status!='CALCULATED' && model.invoiceDetail?.status!='SENT')\" style=\"margin-top: -4px; margin-right: 1px;\"\r\n            class=\"btn btn-highlight navbar-right\" (click)=\"AddTripDetail()\">{{ 'LblAddNewTrip' | translate }}</a>\r\n        </legend>\r\n        <div class=\"clearfix\"></div> -->\r\n        <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n\r\n        <div class=\"clearfix\"></div>\r\n\r\n        <div class=\"row\" style=\"margin-left: 1px;margin-right:1px\">\r\n          <div class=\"table table-responsive mar_bot_ziro borderless\">\r\n            <table class=\"table table-bordered mar_bot_ziro\">\r\n              <thead>\r\n                <tr>\r\n                  <th>\r\n                    {{ 'LblContractTypeGroup' | translate }}\r\n                  </th>\r\n                  <th>\r\n                    {{ 'LblStartDateTime' | translate }}\r\n                  </th>\r\n                  <th>\r\n                    {{ 'LblEndDateTime' | translate }}\r\n                  </th>\r\n                  <th>\r\n                    {{ 'LblDistance' | translate }}\r\n                  </th>\r\n                  <th *ngIf=\"!model.invoiceDetail || (model.invoiceDetail?.status!='CALCULATED' && model.invoiceDetail?.status!='SENT')\" class=\"text-center\">{{ 'LblEdit' | translate }}</th>\r\n                  <!--<th class=\"text-center\">{{ 'LblDelete' | translate }}</th>-->\r\n                </tr>\r\n              </thead>\r\n              <tbody>\r\n                <tr *ngFor=\"let bookingTrip of model.listOfBookingTrip\">\r\n                  <td class=\"wordwrap\">{{ bookingTrip.contractTypeGroup }}</td>\r\n                  <td>{{ bookingTrip.startDateTime }}</td>\r\n                  <td>{{ bookingTrip.endDateTime }}</td>\r\n                  <td>{{ bookingTrip.distance }}</td>\r\n                  <td *ngIf=\"!model.invoiceDetail || (model.invoiceDetail?.status!='CALCULATED' && model.invoiceDetail?.status!='SENT')\" class=\"text-center\">\r\n                    <a *ngIf=\"(authService.GetHighestRoleLevel() <= roleLevel.Instance || !bookingTrip.isGroupedTrip)\" (click)=\"EditTripDetail(bookingTrip)\"\r\n                      class=\"cursor-pointer\">\r\n                      <i class=\"fa fa-pencil-square-o fa-fw\"></i>\r\n                    </a>\r\n                  </td>\r\n                </tr>\r\n              </tbody>\r\n            </table>\r\n\r\n          </div>\r\n        </div>\r\n      </fieldset>\r\n      <br />\r\n      <fieldset *ngIf=\"model.bookingType == 'NORMAL' && model.listOfBookingExpense && model.listOfBookingExpense.length > 0\">\r\n        <legend class=\"legendStyle\">\r\n          {{ 'LblBookingExpenseDetail' | translate }}\r\n        </legend>\r\n        <div class=\"clearfix\"></div>\r\n\r\n        <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n\r\n        <div class=\"clearfix\"></div>\r\n\r\n        <div class=\"row\" style=\"margin-left: 1px;margin-right:1px\">\r\n          <div class=\"table table-responsive mar_bot_ziro borderless\">\r\n            <table class=\"table table-bordered mar_bot_ziro\">\r\n              <thead>\r\n                <tr>\r\n                  <th> {{ 'LblCostType' | translate }}</th>\r\n                  <th> {{ 'LblExpenseAmount' | translate }}</th>\r\n                  <th> {{ 'LblExpenseAmountVat' | translate }}</th>\r\n                  <th> {{ 'LblDescription' | translate }}</th>\r\n                  <th class=\"text-center\">{{ 'LblReceipt' | translate }}</th>\r\n                  <th class=\"text-center\">{{ 'LblEdit' | translate }}</th>\r\n                </tr>\r\n              </thead>\r\n              <tbody>\r\n                <tr *ngFor=\"let bookingExpense of model.listOfBookingExpense\">\r\n                  <td class=\"wordwrap\"> {{bookingExpense.costTypeName}} </td>\r\n                  <td>\r\n                    {{ bookingExpense.reportedAmountExVatFormat | currencyFormatter : bookingExpense.currencySymbol : bookingExpense.isCurrencySymbolBefore}}\r\n                  </td>\r\n                  <td>\r\n                    {{ bookingExpense.reportedAmountVatFormat | currencyFormatter : bookingExpense.currencySymbol : bookingExpense.isCurrencySymbolBefore}}\r\n                  </td>\r\n                  <td> {{bookingExpense.description}} </td>\r\n                  <td class=\"text-center\">\r\n                    <a class=\"cursor-pointer\" title=\"{{'LblReceipt' | translate}}\" (click)=\"ShowReceipt(bookingExpense.receiptPath)\">\r\n                      <i class=\"fa fa-file-picture-o  fa-fw\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a (click)=\"EditExpenseDetail(bookingExpense)\" class=\"cursor-pointer\">\r\n                      <i class=\"fa fa-pencil-square-o fa-fw\"></i>\r\n                    </a>\r\n                  </td>\r\n                </tr>\r\n              </tbody>\r\n            </table>\r\n          </div>\r\n        </div>\r\n      </fieldset>\r\n      <br/>\r\n\r\n      <fieldset *ngIf=\"!(model.bookingTripCostModel && model.bookingTripCostModel.length>0) &&  model.bookingType == 'NORMAL' && (model.invoiceDetail?.status=='CALCULATED'||model.invoiceDetail?.status=='SENT')\">\r\n        <legend class=\"legendStyle\">\r\n          {{ 'LblInvoiceDetail' | translate }}\r\n        </legend>\r\n        <div class=\"row\" *ngIf=\"model.invoiceDetail?.invoiceNumber && model.isDriverInvoiceVisible\">\r\n          <div class=\"col-sm-6 col-xs-6\">\r\n            <label>{{ 'LblDriver' | translate }} {{ 'LblInvoiceNumber' | translate }} :</label> {{ model.invoiceDetail?.invoiceNumber\r\n            }}\r\n          </div>\r\n          <div class=\"col-sm-6 col-xs-6\">\r\n            <label>{{ 'LblDriver' | translate }} {{ 'LblInvoiceDateTime' | translate }} :</label> {{ model.invoiceDetail?.invoiceDate\r\n            }}\r\n          </div>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"row\" *ngIf=\"model.invoiceDetail?.organizationInvoiceNumber && model.isOrganizationInvoiceVisible\">\r\n          <div class=\"col-sm-6 col-xs-6\">\r\n            <label>{{ 'LblOrganization' | translate }} {{ 'LblInvoiceNumber' | translate }} :</label> {{ model.invoiceDetail?.organizationInvoiceNumber\r\n            }}\r\n          </div>\r\n          <div class=\"col-sm-6 col-xs-6\">\r\n            <label>{{ 'LblOrganization' | translate }} {{ 'LblInvoiceDateTime' | translate }} :</label> {{ model.invoiceDetail?.organizationInvoiceDate\r\n            }}\r\n          </div>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"row\">\r\n          <div class=\"col-sm-3 col-xs-3\">\r\n            <label>{{ 'LblDistance' | translate }} ({{ 'LblKilometers' | translate }}) :</label> {{ model.invoiceDetail?.totalKm\r\n            }}\r\n          </div>\r\n          <div class=\"col-sm-3 col-xs-3\">\r\n            <label>{{ 'LblFreeKilometer' | translate }} :</label> {{ model.invoiceDetail?.freeKm }}</div>\r\n          <div class=\"col-sm-3 col-xs-3\">\r\n            <label> {{ 'LblAdditional' | translate }} {{ 'LblFreeKilometer' | translate }} :</label> {{ model.invoiceDetail?.additionalFreeKm\r\n            }}\r\n          </div>\r\n          <div class=\"col-sm-3 col-xs-3\">\r\n            <label>{{ 'LblMileageRate' | translate }} :</label>\r\n            {{ model.invoiceDetail?.mileageRate | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore\r\n            }}\r\n          </div>\r\n          <div class=\"col-sm-3 col-xs-3\">\r\n            <label>{{ 'LblDriveHours' | translate }} :</label> {{ model.invoiceDetail?.totalHoursFormat }}</div>\r\n          <div class=\"col-sm-3 col-xs-3\">\r\n            <label>{{ 'LblFreeHours' | translate }} :</label> {{ model.invoiceDetail?.freeHoursFormat }}</div>\r\n          <div class=\"col-sm-3 col-xs-3\">\r\n            <label>{{ 'LblAdditional' | translate }} {{ 'LblFreeHours' | translate }} :</label> {{ model.invoiceDetail?.additionalFreeHoursFormat\r\n            }}\r\n          </div>\r\n          <div class=\"col-sm-3 col-xs-3\">\r\n            <label>{{ 'LblHourlyRate' | translate }} :</label>\r\n            {{ model.invoiceDetail?.hourlyRate | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\r\n          </div>\r\n          <div class=\"col-sm-3 col-xs-3\">\r\n            <label>{{ 'LblFixedFee' | translate }} :</label>\r\n            {{ model.invoiceDetail?.fixedFree | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\r\n          </div>\r\n          <div *ngIf=\"model.invoiceDetail && model.invoiceDetail?.processingFree>0\" class=\"col-sm-3 col-xs-3\">\r\n            <label>{{ 'LblProcessingFee' | translate }} :</label>\r\n            {{ model.invoiceDetail?.processingFree | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\r\n          </div>\r\n          <div *ngIf=\"model.invoiceDetail && model.invoiceDetail?.plateFormCostUsage>0\" class=\"col-sm-3 col-xs-3\">\r\n            <label>{{ 'LblPlateformUsageCost' | translate }} :</label>\r\n            {{ model.invoiceDetail?.plateFormCostUsage | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\r\n          </div>\r\n          <div class=\"col-sm-3 col-xs-3\">\r\n            <label>{{ 'LblVat' | translate }} :</label>\r\n            {{ model.invoiceDetail?.vat | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\r\n          </div>\r\n          <div class=\"col-sm-3 col-xs-3\">\r\n            <label>{{ 'LblPenaltyRate' | translate }} :</label>\r\n            {{ model.invoiceDetail?.penaltyRate | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\r\n          </div>\r\n          <div *ngIf=\"model.bookingCustomFee==null\" class=\"col-sm-3 col-xs-3\">\r\n            <label>{{ 'LblTotal' | translate }} :</label>\r\n            {{ model.invoiceDetail?.grandTotal | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\r\n          </div>\r\n          <div *ngIf=\"model.bookingCustomFee!=null\" class=\"col-sm-3 col-xs-3\">\r\n            <label>{{ 'LblTotal' | translate }} :</label>\r\n            <del> {{ model.invoiceDetail?.grandTotal | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}</del>\r\n            <br/>\r\n            <p class=\"col-sm-5 col-xs-5 \"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{ model.bookingCustomFee | currencyFormatter : model.invoiceDetail?.currencySymbol\r\n              : model.invoiceDetail?.isCurrencySymbolBefore}}\r\n            </p>\r\n          </div>\r\n        </div>\r\n      </fieldset>\r\n      <fieldset *ngIf=\"(model.bookingTripCostModel && model.bookingTripCostModel.length>0)   && model.bookingType == 'NORMAL' && (model.invoiceDetail?.status=='CALCULATED'||model.invoiceDetail?.status=='SENT')\">\r\n        <legend class=\"legendStyle\">\r\n          {{ 'LblBookingCostSummary' | translate }}\r\n        </legend>\r\n        <h4>\r\n          <label>{{ 'LblTimeCost' | translate }}</label>\r\n        </h4>\r\n\r\n        <div class=\"row\">\r\n          <div class=\"col-sm-3\">\r\n            <label>{{ 'LblTotalTime' | translate }}</label> :\r\n          </div>\r\n          <div class=\"col-sm-9\">\r\n            {{ model.invoiceDetail?.totalHoursFormat }} ({{ model.startDateTime }} {{ 'LblTo' | translate }} {{ model.endDateTime }})\r\n          </div>\r\n        </div>\r\n        <div *ngIf=\"model.invoiceDetail?.invoiceNumber && model.isDriverInvoiceVisible\" class=\"row\">\r\n          <div class=\"col-sm-3\">\r\n            <label>{{ 'LblDriver' | translate }} {{ 'LblInvoiceNumber' | translate }}</label> :\r\n          </div>\r\n          <div class=\"col-sm-9\">\r\n            {{ model.invoiceDetail?.invoiceNumber }} ({{ model.invoiceDetail?.invoiceDate}})\r\n          </div>\r\n        </div>\r\n        <div *ngIf=\"model.invoiceDetail?.organizationInvoiceNumber && model.isOrganizationInvoiceVisible\" class=\"row\">\r\n          <div class=\"col-sm-3\">\r\n            <label>{{ 'LblOrganization' | translate }} {{ 'LblInvoiceNumber' | translate }}</label> :\r\n          </div>\r\n          <div class=\"col-sm-9\">\r\n            {{ model.invoiceDetail?.organizationInvoiceNumber }} ({{ model.invoiceDetail?.organizationInvoiceDate}})\r\n          </div>\r\n        </div>\r\n        <br>\r\n        <div class=\"row\">\r\n          <div class=\"col-sm-2\"></div>\r\n          <div class=\"col-sm-2\">\r\n            <label>{{ 'LblTime' | translate }}</label>\r\n          </div>\r\n          <div class=\"col-sm-2 text-right\">\r\n            <label>{{ 'LblFreeTime' | translate }}</label>\r\n          </div>\r\n          <div class=\"col-sm-2\">\r\n            <label>{{ 'LblRate' | translate }}</label>\r\n          </div>\r\n          <div class=\"col-sm-2 text-right\">\r\n            <label>{{ 'LblExVat' | translate }}</label>\r\n          </div>\r\n          <div class=\"col-sm-2 text-right\">\r\n            <label>{{ 'LblInclVat' | translate }}</label>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"row\" *ngFor=\"let timeCost of model.bookingTripCostModel\">\r\n          <fieldset *ngIf=\"timeCost.specialTripCategory!=3\">\r\n            <div class=\"col-sm-2 wordwrap\">{{timeCost.contractTypeGroup}}({{ timeCost.contractType }}) </div>\r\n            <div class=\"col-sm-2\">{{ timeCost.totalHoursFormat }}</div>\r\n            <div class=\"col-sm-2 text-right\">{{ timeCost.freeHoursFormat }}</div>\r\n            <div class=\"col-sm-2\">{{ timeCost.ratePerHour }} {{ 'LblPer' | translate }} {{ timeCost.hourlyRateUnit }}</div>\r\n            <div class=\"col-sm-2 text-right\">\r\n              {{ timeCost.hourlyRateWithoutVat | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\r\n            </div>\r\n            <div class=\"col-sm-2 text-right\">\r\n              {{ timeCost.hourlyRate | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n        <div *ngIf=\"model.bookingContractTypeGroupCostModel\" class=\"row\">\r\n          <fieldset>\r\n            <div class=\"col-sm-2 wordwrap\">{{ 'LblPenalty' | translate }}({{ model.bookingContractTypeGroupCostModel.contractTypeGroup }}) </div>\r\n            <div class=\"col-sm-2\">{{ model.bookingContractTypeGroupCostModel.penaltyHoursFormat }}</div>\r\n            <div class=\"col-sm-2\"></div>\r\n            <div class=\"col-sm-2\">{{ model.bookingContractTypeGroupCostModel.penaltyPerHour }} {{ 'LblPer' | translate }} {{ model.bookingContractTypeGroupCostModel.penaltyHourlyRateUnit\r\n              }}\r\n            </div>\r\n            <div class=\"col-sm-2 text-right\">\r\n              {{ model.bookingContractTypeGroupCostModel.penaltyRateWithoutVat | currencyFormatter : model.invoiceDetail?.currencySymbol\r\n              : model.invoiceDetail?.isCurrencySymbolBefore}}\r\n            </div>\r\n            <div class=\"col-sm-2 text-right\">\r\n              {{ model.bookingContractTypeGroupCostModel.penaltyRate | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n        <div class=\"row\">\r\n          <div class=\"col-sm-8\">\r\n          </div>\r\n          <div class=\"col-sm-4\">\r\n            <div class=\"line\"></div>\r\n          </div>\r\n        </div>\r\n        <div class=\"row\">\r\n          <div class=\"col-sm-6\">\r\n          </div>\r\n          <div class=\"col-sm-2 text-right\">\r\n            <label>{{ 'LblTotal' | translate }}</label>\r\n          </div>\r\n          <div class=\"col-sm-2 text-right\">\r\n            <label>\r\n              {{ model.invoiceDetail?.totalTimeCostWithoutVat | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\r\n            </label>\r\n          </div>\r\n          <div class=\"col-sm-2 text-right\">\r\n            <label>\r\n              {{ model.invoiceDetail?.totalTimeCostWithVat | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\r\n            </label>\r\n          </div>\r\n        </div>\r\n\r\n        <h4>\r\n          <label>{{ 'LblKilometerCost' | translate }}</label>\r\n        </h4>\r\n        <div class=\"clearfix\"></div>\r\n\r\n        <div class=\"row\">\r\n          <div class=\"col-sm-2\"></div>\r\n          <div class=\"col-sm-2 text-right\">\r\n            <label>{{ 'LblKmDriven' | translate }}</label>\r\n          </div>\r\n          <div class=\"col-sm-2 text-right\">\r\n            <label>{{ 'LblFreeKms' | translate }}</label>\r\n          </div>\r\n          <div class=\"col-sm-2\">\r\n            <label>{{ 'LblRate' | translate }}</label>\r\n          </div>\r\n          <div class=\"col-sm-2 text-right\">\r\n            <label>{{ 'LblExVat' | translate }}</label>\r\n          </div>\r\n          <div class=\"col-sm-2 text-right\">\r\n            <label>{{ 'LblInclVat' | translate }}</label>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"row\" *ngFor=\"let timeCost of model.bookingTripCostModel\">\r\n          <fieldset *ngIf=\"timeCost.specialTripCategory!=2\">\r\n            <div class=\"col-sm-2 wordwrap\">{{timeCost.contractTypeGroup}}({{ timeCost.contractType }}) </div>\r\n            <div class=\"col-sm-2 text-right\">{{ timeCost.totalKm }}</div>\r\n            <div class=\"col-sm-2 text-right\">{{ timeCost.freeKm }}</div>\r\n            <div class=\"col-sm-2 \">{{ timeCost.ratePerKm }} {{ 'LblUnitPerKm' | translate }}</div>\r\n            <div class=\"col-sm-2 text-right\">\r\n              {{ timeCost.mileageRateWithoutVat | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\r\n            </div>\r\n            <div class=\"col-sm-2 text-right\">\r\n              {{ timeCost.mileageRate | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n          <div class=\"col-sm-2\">\r\n          </div>\r\n          <div class=\"col-sm-2\">\r\n            <div class=\"line\"></div>\r\n          </div>\r\n          <div class=\"col-sm-4\">\r\n          </div>\r\n          <div class=\"col-sm-4\">\r\n            <div class=\"line\"></div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n          <div class=\"col-sm-2 text-right\"></div>\r\n          <div class=\"col-sm-2 text-right\">\r\n            <label>{{ model.invoiceDetail?.totalKm }} </label>\r\n          </div>\r\n          <div class=\"col-sm-2 text-right\"> </div>\r\n          <div class=\"col-sm-2 text-right\">\r\n            <label>{{ 'LblTotal' | translate }}</label>\r\n          </div>\r\n          <div class=\"col-sm-2 text-right\">\r\n            <label>\r\n              {{ model.invoiceDetail?.totalMilageCostWithoutVat | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\r\n            </label>\r\n          </div>\r\n          <div class=\"col-sm-2 text-right\">\r\n            <label>\r\n              {{ model.invoiceDetail?.totalMilageCostWithVat | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\r\n            </label>\r\n          </div>\r\n        </div>\r\n\r\n        <h4>\r\n          <label>{{ 'LblFixedCost' | translate }}</label>\r\n        </h4>\r\n        <div class=\"clearfix\"></div>\r\n\r\n        <div class=\"row\">\r\n          <div class=\"col-sm-2\"></div>\r\n          <div class=\"col-sm-1 text-right\">\r\n            <label></label>\r\n          </div>\r\n          <div class=\"col-sm-1\">\r\n            <label>{{ 'LblRate' | translate }}</label>\r\n          </div>\r\n          <div class=\"col-sm-4\"></div>\r\n          <div class=\"col-sm-2 text-right\">\r\n            <label>{{ 'LblExVat' | translate }}</label>\r\n          </div>\r\n          <div class=\"col-sm-2 text-right\">\r\n            <label>{{ 'LblInclVat' | translate }}</label>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"row\" *ngFor=\"let timeCost of model.bookingTripCostModel\">\r\n          <fieldset *ngIf=\"timeCost.specialTripCategory!=3\">\r\n            <div class=\"col-sm-2 wordwrap\">{{timeCost.contractTypeGroup}}({{ timeCost.contractType }})</div>\r\n            <div class=\"col-sm-1 text-right\"></div>\r\n            <div class=\"col-sm-2\">{{ timeCost.fixedCostRate }} {{ 'LblUnitPerBooking' | translate }}</div>\r\n            <div class=\"col-sm-4\"></div>\r\n            <div class=\"col-sm-1 text-right\">\r\n              {{ timeCost.fixedFeeWithoutVat | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\r\n            </div>\r\n            <div class=\"col-sm-2 text-right\">\r\n              {{ timeCost.fixedFee | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n        <div class=\"row\">\r\n          <div class=\"col-sm-8\">\r\n          </div>\r\n          <div class=\"col-sm-4\">\r\n            <div class=\"line\"></div>\r\n          </div>\r\n        </div>\r\n        <div class=\"row\">\r\n          <div class=\"col-sm-6\"></div>\r\n          <div class=\"col-sm-2 text-right\">\r\n            <label>{{ 'LblTotal' | translate }}</label>\r\n          </div>\r\n          <div class=\"col-sm-2 text-right\">\r\n            <label>\r\n              {{ model.invoiceDetail?.totalFixedCostWithoutVat | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\r\n            </label>\r\n          </div>\r\n          <div class=\"col-sm-2 text-right\">\r\n            <label>\r\n              {{ model.invoiceDetail?.totalFixedCostWithVat | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\r\n            </label>\r\n          </div>\r\n        </div>\r\n        <br>\r\n        <div class=\"row\">\r\n          <div class=\"col-sm-8\"></div>\r\n          <div class=\"col-sm-4\">\r\n            <label>{{ 'LblTotals' | translate }}</label>\r\n          </div>\r\n        </div>\r\n        <div class=\"row\">\r\n          <div class=\"col-sm-8\">\r\n          </div>\r\n          <div class=\"col-sm-4\">\r\n            <div class=\"line\"></div>\r\n          </div>\r\n        </div>\r\n        <div *ngIf=\"model.invoiceDetail && model.invoiceDetail?.processingFree>0\" class=\"row\">\r\n          <div class=\"col-sm-8\"></div>\r\n          <div class=\"col-sm-2 text-right\">\r\n            <label>{{ 'LblProcessingFee' | translate }}</label>\r\n          </div>\r\n          <div class=\"col-sm-2 text-right\">\r\n            <label>\r\n              {{ model.invoiceDetail?.processingFree | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\r\n            </label>\r\n          </div>\r\n        </div>\r\n\r\n        <div *ngIf=\"model.invoiceDetail && model.invoiceDetail?.plateFormCostUsage>0\" class=\"row\">\r\n          <div class=\"col-sm-8\"></div>\r\n          <div class=\"col-sm-2 text-right\">\r\n            <label>{{ 'LblPlateformUsageCost' | translate }}</label>\r\n          </div>\r\n          <div class=\"col-sm-2 text-right\">\r\n            <label>\r\n              {{ model.invoiceDetail?.plateFormCostUsage | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\r\n            </label>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n          <div class=\"col-sm-8\"></div>\r\n          <div class=\"col-sm-2 text-right\">\r\n            <label>{{ 'LblTotalExVat' | translate }}</label>\r\n          </div>\r\n          <div class=\"col-sm-2 text-right\">\r\n            <label>\r\n              {{ model.invoiceDetail?.totalWithoutVat | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\r\n            </label>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n          <div class=\"col-sm-8\"></div>\r\n          <div class=\"col-sm-2 text-right\">\r\n            <label>{{ 'LblTotalVat' | translate }}</label>\r\n          </div>\r\n          <div class=\"col-sm-2 text-right\">\r\n            <label>\r\n              {{ model.invoiceDetail?.vatWithPenaltyVat | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\r\n            </label>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n          <div class=\"col-sm-8\"></div>\r\n          <div class=\"col-sm-2 text-right\">\r\n            <label>{{ 'LblTotalInclVat' | translate }}</label>\r\n          </div>\r\n          <div class=\"col-sm-2 text-right\">\r\n            <label>\r\n              {{ model.invoiceDetail?.grandTotal | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\r\n            </label>\r\n          </div>\r\n        </div>\r\n\r\n      </fieldset>\r\n      <br/>\r\n      <fieldset *ngIf=\"model.listOfVehicleRequest && model.listOfVehicleRequest.length > 0\">\r\n        <legend class=\"legendStyle\">\r\n          {{ 'LblVTSReqLogDetail' | translate }}\r\n        </legend>\r\n        <div class=\"row\" style=\"margin-left: 1px;margin-right:1px\">\r\n          <div class=\"table table-responsive mar_bot_ziro borderless\">\r\n            <table class=\"table table-bordered mar_bot_ziro\">\r\n              <thead>\r\n                <tr>\r\n                  <th>{{ 'LblVTSReqDateTime' | translate }}</th>\r\n                  <th>{{ 'LblVTSReqType' | translate }}</th>\r\n                  <th>{{ 'LblVTSProcessTime' | translate }}</th>\r\n                  <th>{{ 'LblVTSResTime' | translate }}</th>\r\n                  <th>{{ 'LblVTSResult' | translate }}</th>\r\n                </tr>\r\n              </thead>\r\n              <tbody>\r\n                <tr *ngFor=\"let vehicleRequestLog of model.listOfVehicleRequest\">\r\n                  <td>{{vehicleRequestLog.requestDateTime}}</td>\r\n                  <td>{{ vehicleRequestLog.requestType }}</td>\r\n                  <td>{{ vehicleRequestLog.processDateTime }}</td>\r\n                  <td>{{ vehicleRequestLog.resultDateTime }}</td>\r\n                  <td>{{ vehicleRequestLog.result }}</td>\r\n                </tr>\r\n              </tbody>\r\n            </table>\r\n          </div>\r\n        </div>\r\n      </fieldset>\r\n    </div>\r\n  </section>\r\n  <div class=\"row no-margin\">\r\n    <div class=\"col-sm-12\">\r\n      <hr>\r\n      <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnBackClick()\">{{ 'LblBack' | translate }}</a>\r\n      <a *ngIf=\"model.bookingStatus == 'RUNNING'\" class=\"btn btn-green cursor-pointer\" (click)=\"CheckBookingExtendTime()\">{{ 'LblExtend' | translate }}</a>\r\n      \r\n      \r\n      <a class=\"btn btn-green cursor-pointer\" (click)=\"ReportDamage(model.bookingIdHashId)\">\r\n        <i class=\"fa fa-car\"></i>&nbsp;{{ 'LblReportDamage' | translate }}</a>\r\n\r\n      <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnTripsClick(model.bookingIdHashId)\"><i class=\"fa fa-random\"></i>&nbsp;{{ 'LblTrips' | translate }}</a>\r\n      <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnCostsSummaryClick(model.bookingIdHashId)\"><i class=\"fa fa-book\"></i>&nbsp;{{ 'LblCostsSummary' | translate }}</a>\r\n\r\n\r\n      <a class=\"btn btn-green cursor-pointer\" (click)=\"StartBooking(model.externalId)\" *ngIf=\"model.bookingStatus == 'CONFIRMED'\">&nbsp;{{ 'LblStartBooking' | translate }}</a>\r\n      <a class=\"btn btn-danger cursor-pointer\" (click)=\"StopBooking(model.externalId)\" *ngIf=\"model.bookingStatus == 'RUNNING'\">&nbsp;{{ 'LblStopBooking' | translate }}</a>\r\n\r\n    </div>\r\n  </div>\r\n</div>\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n\r\n<div bsModal #alertModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\"\r\n  [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-sm\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"HideAlertModal()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblExtendBooking' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <div *ngIf=\"availableBookingExtandTime && availableBookingExtandTime > 0\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblBookingExtensionTime' | translate }}</label>\r\n          <div class=\"input-group col-md-12\">\r\n            <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblBookingExtensionTime' | translate }}\" [(ngModel)]=\"bookingExtendTime\"\r\n              name=\"bookingExtensionTime\">\r\n            <span class=\"text text-danger\">{{ bookingExtensionValidation }}</span>\r\n          </div>\r\n        </div>\r\n        <br/>\r\n        <div>\r\n          <span>{{ bookingExtandInfoMsg }}</span>\r\n        </div>\r\n      </div>\r\n      <div class=\"modal-footer\">\r\n        <button type=\"button\" class=\"btn btn-green\" (click)=\"SuccessAlertModalClick()\">{{ 'LblOK' | translate }}</button>\r\n        <button type=\"button\" class=\"btn btn-gray cursor-pointer\" (click)=\"HideAlertModal()\">{{ 'LblCancel' | translate }}</button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<wego-success-popup #validationModal [popupTitle]=\"popupTitle\" [popupMsg]=\"message\" (onConfirm)=\"HideValidationModal()\"></wego-success-popup>\r\n<wego-report-damage-popup #reportDamageModal (OnSuccessSelect)=\"SuccessReportDamage($event.SuccessMessage)\"></wego-report-damage-popup>\r\n<wego-bookingtrip-detail-popup #bookingTripDetailModal (OnSuccessSave)=\"SuccessSave($event.SuccessMessage)\" [BookingInfoModel]=\"model\"\r\n  [BookingHashId]=\"bookingHashId\"></wego-bookingtrip-detail-popup>\r\n<wego-confirm-popup #confirmModal [popupMsg]=\"deleteMessage\" (onConfirm)=\"ConfirmSuccessClick()\" (onReject)=\"HideConfirmModal()\"></wego-confirm-popup>\r\n<wego-success-popup #updateSuccessPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmUpdateSuccessPopup()\"></wego-success-popup>\r\n<wego-booking-expense-popup #bookingExpenseModel (OnSuccessSave)=\"SuccessSave($event.SuccessMessage)\" [BookingInfoModel]=\"model\"\r\n  [BookingHashId]=\"bookingHashId\"></wego-booking-expense-popup>\r\n<wego-image-popup #receiptImagePopup></wego-image-popup>\r\n<wego-free-booking-popup #freebookingModal (OnSuccessSave)=\"SuccessSave($event.SuccessMessage)\"></wego-free-booking-popup>";

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var EndRide_1 = __webpack_require__(701);
	var unlock_service_1 = __webpack_require__(702);
	var StartRide_1 = __webpack_require__(703);
	var lockunlock_model_1 = __webpack_require__(704);
	var booking_information_model_1 = __webpack_require__(705);
	var auth_service_1 = __webpack_require__(58);
	var translate_service_1 = __webpack_require__(70);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var booking_service_1 = __webpack_require__(556);
	var config_2 = __webpack_require__(60);
	var common_1 = __webpack_require__(22);
	var moment = __webpack_require__(84);
	var BookingInformationComponent2 = (function () {
	    function BookingInformationComponent2(authService, bookigService, unlockService, router, translate, activeRoute, locationService) {
	        this.authService = authService;
	        this.bookigService = bookigService;
	        this.unlockService = unlockService;
	        this.router = router;
	        this.translate = translate;
	        this.activeRoute = activeRoute;
	        this.locationService = locationService;
	        this.withVehicleInfo = false;
	        this.roleLevel = config_1.RoleLevel;
	    }
	    BookingInformationComponent2.prototype.ngOnInit = function () {
	        var _this = this;
	        this.model = new booking_information_model_1.BookingInformation();
	        this.lockunlock = new lockunlock_model_1.LockUnlock();
	        this.startride = new StartRide_1.StartRide();
	        this.endride = new EndRide_1.EndRide();
	        this.urlDefaultPage = this.authService.GetURL(config_2.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlBooking = this.authService.GetURL(config_2.ApplicationRouteURL.URL_BOOKING);
	        this.urlBookingPage = this.authService.GetURL(config_2.ApplicationRouteURL.URL_BOOKING_INFORMATION);
	        this.urlBookingTrips = this.authService.GetURL(config_2.ApplicationRouteURL.URL_BOOKING_INFORMATION2);
	        this.urlCostsSummary = this.authService.GetURL(config_2.ApplicationRouteURL.URL_BOOKING_INFORMATION3);
	        this.urlBookingOverView = this.authService.GetURL(config_2.ApplicationRouteURL.URL_BOOKING_OVERVIEW);
	        this.urlVehicleInfo = this.authService.GetURL(config_2.ApplicationRouteURL.URL_VEHICLE_INFO);
	        this.urlSVGInfo = this.authService.GetURL(config_2.ApplicationRouteURL.URL_SVG_UPDATE);
	        this.urlVtsTroubleShoot = this.authService.GetURL(config_2.ApplicationRouteURL.URL_VTS_TROUBLESHOOT);
	        this.urlEventViewer = this.authService.GetURL(config_2.ApplicationRouteURL.URL_EVENT_VIEWER_LIST);
	        this.activeRoute.queryParams.subscribe(function (queryParams) {
	            _this.withVehicleInfo = queryParams['vehicleInfo'] == 'true';
	            _this.sub = _this.activeRoute.params.subscribe(function (params) {
	                _this.bookingHashId = params["id"] || "";
	                if (_this.bookingHashId != "") {
	                    _this.GetBookingInformation();
	                }
	            });
	        });
	    };
	    BookingInformationComponent2.prototype.GetContactTypeGroup = function () {
	        var _this = this;
	        this.unlockService.GetContactTypeGroupList(this.bookingHashId).subscribe(function (res) {
	            console.log(res.data);
	            _this.contacttpyegroupList = res.data;
	            if (_this.contacttpyegroupList.length > 0) {
	                if (_this.contacttpyegroupList &&
	                    _this.contacttpyegroupList.length > 1) {
	                    _this.contacttypegroupid = _this.contacttpyegroupList.filter(function (x) { return x.isSelected; })[0].contactTypeGroupId;
	                    console.log(_this.contacttypegroupid);
	                    _this.isContractTypeGroupAvailable = true;
	                }
	                else {
	                    _this.contacttypegroupid = _this.contacttpyegroupList[0].contactTypeGroupId;
	                    _this.isContractTypeGroupAvailable = false;
	                }
	            }
	        }, function (error) { });
	    };
	    BookingInformationComponent2.prototype.GetBookingInformation = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.bookigService
	            .GetBookingInformationByHashId(this.bookingHashId, 'page2')
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.model = res.data;
	                _this.vtsTroubleShootLink = new config_1.WeGoAuthorizedLink(_this.urlVtsTroubleShoot + "/" + _this.model.vehicleHashId, config_1.Permission.PR_VTS_TROUBLESHOOT, config_1.PermissionType.VIEW, "", "LblTroubleShootVTS", "", "", false, "fa fa-wrench");
	                _this.viewVehicleLink = new config_1.WeGoAuthorizedLink(_this.urlVehicleInfo + "/" + _this.model.vehicleHashId, config_1.Permission.PR_VEHICLES_OVERVIEW, config_1.PermissionType.VIEW, "", _this.model.licenceTag, "", "", true);
	                _this.updateSvgLink = new config_1.WeGoAuthorizedLink(_this.urlSVGInfo + "/" + _this.model.sharedVehicleGroupHashId, config_1.Permission.PR_SHARED_VEHICLE_GROUP_OVERVIEW, config_1.PermissionType.EDIT, "", _this.model.sharedVehicleGroup, config_1.Entity.SVG, _this.model.sharedVehicleGroupHashId, true);
	                _this.viewEventViewerLink = new config_1.WeGoAuthorizedLink(_this.urlEventViewer +
	                    "?filter ='BOOKING'& searchTerm= " +
	                    _this.model.bookingReferenceID, config_1.Permission.PR_EVENT_VIEWER, config_1.PermissionType.VIEW, "", "LblEventViewer", "", "", false);
	                _this.isLoading = false;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        }, function () { return (_this.contacttpyegroupList = _this.GetContactTypeGroup()); });
	    };
	    BookingInformationComponent2.prototype.CheckBookingExtendTime = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.bookigService.CheckBookingExtendTime(this.bookingHashId).subscribe(function (res) {
	            if (res.data > 0) {
	                _this.availableBookingExtandTime = res.data;
	                _this.bookingExtandInfoMsg = _this.translate.instant("LblExtendInfoMsg", _this.availableBookingExtandTime.toString());
	            }
	            else {
	                _this.bookingExtandInfoMsg = _this.translate.instant("LblExtendValidationMsg");
	            }
	            _this.ShowAlertModal();
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BookingInformationComponent2.prototype.OnBackClick = function (bookingIdHashId) {
	        var url = this.urlBookingPage + '/' + bookingIdHashId;
	        this.router.navigateByUrl(url);
	    };
	    BookingInformationComponent2.prototype.OnTripsClick = function (bookingIdHashId) {
	        var url = this.urlBookingTrips + '/' + bookingIdHashId;
	        this.router.navigateByUrl(url);
	    };
	    BookingInformationComponent2.prototype.OnCostsSummaryClick = function (bookingIdHashId) {
	        var url = this.urlCostsSummary + '/' + bookingIdHashId;
	        this.router.navigateByUrl(url);
	    };
	    BookingInformationComponent2.prototype.ShowAlertModal = function () {
	        this.bookingExtensionValidation = "";
	        this.alertModal.show();
	    };
	    BookingInformationComponent2.prototype.HideAlertModal = function () {
	        this.bookingExtensionValidation = "";
	        this.bookingExtendTime = null;
	        this.alertModal.hide();
	    };
	    BookingInformationComponent2.prototype.SuccessAlertModalClick = function () {
	        if (this.availableBookingExtandTime > 0) {
	            if (this.bookingExtendTime && this.bookingExtendTime > 0) {
	                if (this.bookingExtendTime > this.availableBookingExtandTime) {
	                    this.bookingExtensionValidation = this.translate.instant("LblOverExtendValidationMsg", this.availableBookingExtandTime.toString());
	                }
	                else {
	                    this.bookingExtensionValidation = "";
	                    this.ExtendOnGoingBooking();
	                    this.HideAlertModal();
	                }
	            }
	            else {
	                this.bookingExtensionValidation = this.translate.instant("LblExtendRequire");
	            }
	        }
	        else {
	            this.bookingExtensionValidation = "";
	            this.HideAlertModal();
	        }
	    };
	    BookingInformationComponent2.prototype.ExtendOnGoingBooking = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.bookigService
	            .ExtendOnGoingBooking(this.bookingHashId, this.bookingExtendTime)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant("LblBookingExtendedSuccess");
	                _this.isLoading = false;
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BookingInformationComponent2.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    BookingInformationComponent2.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    BookingInformationComponent2.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	        this.router.navigate([this.urlBookingOverView]);
	    };
	    BookingInformationComponent2.prototype.HideValidationModal = function () {
	        this.validationModal.hide();
	    };
	    BookingInformationComponent2.prototype.UnlockVehicle = function (bookingIdHashId, vehicleExchangeHashId) {
	        var _this = this;
	        this.lockunlock.bookingMasterHashId = bookingIdHashId;
	        this.lockunlock.contractTypeGroupId = this.contacttypegroupid;
	        this.lockunlock.locationDataExchangeHashId = vehicleExchangeHashId;
	        this.lockunlock.isMobileRequest = false;
	        if (this.contacttpyegroupList && this.contacttpyegroupList.length > 0) {
	            this.isLoading = true;
	            this.unlockService.UnlockVehicle(this.lockunlock).subscribe(function (res) {
	                if (res.data) {
	                    _this.lockunlockresult = res.data;
	                    if (_this.lockunlockresult.isTripCalculatingInProgress) {
	                        _this.isLoading = false;
	                        _this.message = _this.translate.instant("LblTripCalculationInProgress");
	                        _this.popupTitle = _this.translate.instant("LblWarning");
	                        _this.validationModal.show();
	                    }
	                    else if (_this.lockunlockresult.isBookingExpired) {
	                        _this.isLoading = false;
	                        _this.message = _this.translate.instant("LblBookingExpired");
	                        _this.popupTitle = _this.translate.instant("LblWarning");
	                        _this.validationModal.show();
	                    }
	                    else if (_this.lockunlockresult.isSameCommandInProgress) {
	                        _this.isLoading = false;
	                        _this.message = _this.translate.instant("LblSameVTSCommand");
	                        _this.popupTitle = _this.translate.instant("LblWarning");
	                        _this.validationModal.show();
	                    }
	                    else if (_this.lockunlockresult.isDoorStatusOpened) {
	                        _this.isLoading = false;
	                        _this.popupMsg = _this.translate.instant("LblUnLockSuccessfully");
	                        _this.ShowSuccessPopup();
	                    }
	                    else if (!_this.lockunlockresult.isUnlock &&
	                        !_this.lockunlockresult.isTripCalculatingInProgress &&
	                        !_this.lockunlockresult.isSameCommandInProgress) {
	                        _this.isLoading = false;
	                        _this.message = _this.translate.instant("LblUnlockProblem");
	                        _this.popupTitle = _this.translate.instant("LblWarning");
	                        _this.validationModal.show();
	                    }
	                    else if (_this.lockunlockresult.isUnlock) {
	                        //this.GetStartRideSubmit();
	                        _this.isLoading = false;
	                        _this.popupMsg = _this.translate.instant("LblUnLockSuccessfully");
	                        _this.ShowSuccessPopup();
	                    }
	                }
	            }, function (error) {
	                _this.isLoading = false;
	            });
	        }
	        else {
	            this.message = this.translate.instant("LblUnlockErrorMessage");
	            this.popupTitle = this.translate.instant("LblWarning");
	            this.validationModal.show();
	        }
	    };
	    // public GetStartRideSubmit() {
	    //   this.isLoading = true;
	    //   this.startride.contractTypeGroupId = this.contacttypegroupid;
	    //   this.startride.startDateTime = this.lockunlockresult.startDateTime;
	    //   this.startride.startLatitude = this.lockunlockresult.startLat;
	    //   this.startride.startLongitude = this.lockunlockresult.startLog;
	    //   this.startride.startMileage = this.lockunlockresult.startMilege;
	    //   this.startride.bookingHashId = this.bookingHashId;
	    //   this.startride.locationExchangeHashId = this.lockunlock.locationDataExchangeHashId;
	    //   this.startride.bookingTripSummaryId = this.lockunlockresult.bookingTripSummaryId;
	    //   let tripcommandproblem = this.translate.instant('LblProblemTrip');
	    //   this.unlockService.StartTrip(this.startride)
	    //     .subscribe(
	    //     res => {
	    //       if (res.data) {
	    //         this.triphashId = res.data;
	    //         this.isLoading = false;
	    //         this.popupMsg = this.translate.instant('LblUnLockSuccessfully');
	    //         this.ShowSuccessPopup();
	    //       }
	    //       else {
	    //         this.isLoading = false;
	    //       }
	    //     },
	    //     error => {
	    //       this.isLoading = false;
	    //     });
	    // }
	    BookingInformationComponent2.prototype.LockVehicle = function (bookingIdHashId, vehicleExchangeHashId) {
	        var _this = this;
	        this.lockunlock.bookingMasterHashId = bookingIdHashId;
	        this.lockunlock.locationDataExchangeHashId = vehicleExchangeHashId;
	        this.lockunlock.isMobileRequest = false;
	        this.isLoading = true;
	        this.unlockService.LockVehicle(this.lockunlock).subscribe(function (res) {
	            if (res.data) {
	                _this.lockunlockresult = res.data;
	                if (_this.lockunlockresult.isBookingExpired) {
	                    _this.isLoading = false;
	                    _this.message = _this.translate.instant("LblBookingExpired");
	                    _this.popupTitle = _this.translate.instant("LblWarning");
	                    _this.validationModal.show();
	                }
	                else if (_this.lockunlockresult.isSameCommandInProgress) {
	                    _this.isLoading = false;
	                    _this.message = _this.translate.instant("LblSameVTSCommand");
	                    _this.popupTitle = _this.translate.instant("LblWarning");
	                    _this.validationModal.show();
	                }
	                else if (_this.lockunlockresult.isDoorStatusClosed) {
	                    _this.popupMsg = _this.translate.instant("LblLockCompletelySuccessfully");
	                    _this.isLoading = false;
	                    _this.ShowSuccessPopup();
	                }
	                else if (!_this.lockunlockresult.isLock &&
	                    !_this.lockunlockresult.isSameCommandInProgress) {
	                    _this.isLoading = false;
	                    _this.message = _this.translate.instant("LbllockProblem");
	                    _this.popupTitle = _this.translate.instant("LblWarning");
	                    _this.validationModal.show();
	                }
	                else {
	                    //this.GetEndRideSubmit(bookingIdHashId, vehicleExchangeHashId);
	                    _this.popupMsg = _this.translate.instant("LblLockCompletelySuccessfully");
	                    _this.isLoading = false;
	                    _this.ShowSuccessPopup();
	                }
	            }
	            else {
	            }
	        }, function (error) {
	            _this.isLoading = false;
	        });
	    };
	    BookingInformationComponent2.prototype.PartialockResult = function (bookingIdHashId, vehicleExchangeHashId) {
	        var _this = this;
	        this.lockunlock.bookingMasterHashId = bookingIdHashId;
	        this.lockunlock.locationDataExchangeHashId = vehicleExchangeHashId;
	        this.lockunlock.tripHashId = this.triphashId
	            ? this.triphashId.toString()
	            : "0";
	        this.lockunlock.isMobileRequest = false;
	        this.isLoading = true;
	        this.unlockService.PartialLock(this.lockunlock).subscribe(function (res) {
	            if (res.data) {
	                _this.lockunlockresult = res.data;
	                if (_this.lockunlockresult.isBookingExpired) {
	                    _this.isLoading = false;
	                    _this.message = _this.translate.instant("LblBookingExpired");
	                    _this.popupTitle = _this.translate.instant("LblWarning");
	                    _this.validationModal.show();
	                }
	                else if (_this.lockunlockresult.isSameCommandInProgress) {
	                    _this.isLoading = false;
	                    _this.message = _this.translate.instant("LblSameVTSCommand");
	                    _this.popupTitle = _this.translate.instant("LblWarning");
	                    _this.validationModal.show();
	                }
	                else if (_this.lockunlockresult.isDoorStatusClosed) {
	                    _this.popupMsg = _this.translate.instant("LblLockCompletelySuccessfully");
	                    _this.isLoading = false;
	                    _this.ShowSuccessPopup();
	                }
	                else if (_this.lockunlockresult.engineStillRunning) {
	                    _this.isLoading = false;
	                    _this.message = _this.translate.instant("LblEngineStillRunning");
	                    _this.popupTitle = _this.translate.instant("LblWarning");
	                    _this.validationModal.show();
	                }
	                else if (!_this.lockunlockresult.isLock) {
	                    _this.isLoading = false;
	                    _this.message = _this.translate.instant("LbllockProblem");
	                    _this.popupTitle = _this.translate.instant("LblWarning");
	                    _this.validationModal.show();
	                }
	                else {
	                    _this.popupMsg = _this.translate.instant("LblLockSuccessfully");
	                    _this.isLoading = false;
	                    _this.ShowSuccessPopup();
	                }
	            }
	        }, function (error) {
	            _this.isLoading = false;
	        });
	    };
	    // public GetEndRideSubmit(bookingIdHashId: string, vehicleExchangeHashId: string) {
	    //   this.endride.bookingHashId = bookingIdHashId;
	    //   this.endride.tripHashId = this.triphashId ? this.triphashId.toString() : '0';
	    //   this.endride.locationExchangeHashId = vehicleExchangeHashId;
	    //   this.unlockService.EndTrip(this.endride)
	    //     .subscribe(
	    //     res => {
	    //       if (res.data) {
	    //         this.lockunlockresult = res.data;
	    //       }
	    //       else {
	    //       }
	    //     },
	    //     error => {
	    //     });
	    // }
	    BookingInformationComponent2.prototype.ReportDamage = function (bookingHashId) {
	        this.reportDamageModal.model.bookingHashId = bookingHashId;
	        this.reportDamageModal.model.vehicleHashId = this.model.vehicleHashId;
	        this.reportDamageModal.show();
	    };
	    BookingInformationComponent2.prototype.FreeBooking = function (bookingHashId) {
	        this.freebookingModal.model.bookingHashId = bookingHashId;
	        this.freebookingModal.show();
	    };
	    BookingInformationComponent2.prototype.SuccessReportDamage = function (successMsg) {
	        this.popupMsg = successMsg;
	        this.ShowSuccessPopup();
	    };
	    BookingInformationComponent2.prototype.SuccessSave = function (successMsg) {
	        this.popupMsg = successMsg;
	        this.ShowUpdateSuccessPopup();
	        this.GetBookingInformation();
	    };
	    BookingInformationComponent2.prototype.AddTripDetail = function () {
	        this.bookingTripDetailModal.model = new booking_information_model_1.BookingTripDetail();
	        this.bookingTripDetailModal.show();
	    };
	    BookingInformationComponent2.prototype.EditTripDetail = function (bookingtrip) {
	        this.bookingTripDetailModal.model = JSON.parse(JSON.stringify(bookingtrip));
	        this.bookingTripDetailModal.show();
	    };
	    BookingInformationComponent2.prototype.ShowConfirmModal = function (bookingtripHashId) {
	        this.isLoading = false;
	        this.deleteMessage = this.translate.instant("LblRecordDeleteConfirmation", this.translate.instant("LblBookingTripDetail"));
	        this.confirmModal.show();
	        this.bookingtripHashId = bookingtripHashId;
	    };
	    BookingInformationComponent2.prototype.HideConfirmModal = function () {
	        this.confirmModal.hide();
	    };
	    BookingInformationComponent2.prototype.ConfirmSuccessClick = function () {
	        this.confirmModal.hide();
	        //this.DeleteBookingTrip();
	    };
	    // public DeleteBookingTrip() {
	    //   this.isLoading = true;
	    //   this.bookigService.DeleteBookingTrip(this.bookingtripHashId)
	    //     .subscribe(
	    //     (res: any) => {
	    //       if (res.data) {
	    //         this.GetBookingInformation();
	    //         this.popupMsg = this.translate.instant('LblRecordRemovedSuccess', this.translate.instant('LblBookingTripDetail'));
	    //         this.ShowUpdateSuccessPopup();
	    //       }
	    //       else {
	    //         this.popupMsg = res.error;
	    //         this.isLoading = false;
	    //         this.ShowUpdateSuccessPopup();
	    //       }
	    //     },
	    //     (error: any) => {
	    //       this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
	    //       this.isLoading = false;
	    //     });
	    // }
	    BookingInformationComponent2.prototype.ShowUpdateSuccessPopup = function () {
	        this.updateSuccessPopup.show();
	    };
	    BookingInformationComponent2.prototype.HideUpdateSuccessPopup = function () {
	        this.updateSuccessPopup.hide();
	    };
	    BookingInformationComponent2.prototype.ConfirmUpdateSuccessPopup = function () {
	        this.updateSuccessPopup.hide();
	    };
	    BookingInformationComponent2.prototype.EditExpenseDetail = function (bookingexpense) {
	        this.bookingExpenseModel.model = JSON.parse(JSON.stringify(bookingexpense));
	        this.bookingExpenseModel.show();
	    };
	    BookingInformationComponent2.prototype.ShowReceipt = function (imagepath) {
	        this.receiptImagePopup.imagepath = config_2.WeGoConfig.API_SERVER_URL + imagepath;
	        this.receiptImagePopup.show();
	    };
	    BookingInformationComponent2.prototype.GroupByCategory = function (vehicleAttributeList) {
	        if (vehicleAttributeList) {
	            var prop_1 = "vehicleAttributeCategoryName";
	            return vehicleAttributeList.reduce(function (groups, item) {
	                var val = item[prop_1];
	                groups[val] = groups[val] || [];
	                groups[val].push(item);
	                groups[val] = groups[val].sort(function (obj1, obj2) {
	                    if (obj1.attributeName > obj2.attributeName) {
	                        return 1;
	                    }
	                    if (obj1.attributeName < obj2.attributeName) {
	                        return -1;
	                    }
	                    return 0;
	                });
	                return groups;
	            }, {});
	        }
	        else {
	            return {};
	        }
	    };
	    BookingInformationComponent2.prototype.KeyOfObject = function (obj) {
	        return Object.keys(obj);
	    };
	    BookingInformationComponent2.prototype.CalculateTripCost = function (dataArray, propName) {
	        var total = 0;
	        for (var n = 0; n < dataArray.length; n++) {
	            total += dataArray[n][propName];
	        }
	        return Math.round(total * 100) / 100;
	    };
	    __decorate([
	        core_1.ViewChild("alertModal"), 
	        __metadata('design:type', Object)
	    ], BookingInformationComponent2.prototype, "alertModal", void 0);
	    __decorate([
	        core_1.ViewChild("successPopup"), 
	        __metadata('design:type', Object)
	    ], BookingInformationComponent2.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild("validationModal"), 
	        __metadata('design:type', Object)
	    ], BookingInformationComponent2.prototype, "validationModal", void 0);
	    __decorate([
	        core_1.ViewChild("reportDamageModal"), 
	        __metadata('design:type', Object)
	    ], BookingInformationComponent2.prototype, "reportDamageModal", void 0);
	    __decorate([
	        core_1.ViewChild("bookingTripDetailModal"), 
	        __metadata('design:type', Object)
	    ], BookingInformationComponent2.prototype, "bookingTripDetailModal", void 0);
	    __decorate([
	        core_1.ViewChild("confirmModal"), 
	        __metadata('design:type', Object)
	    ], BookingInformationComponent2.prototype, "confirmModal", void 0);
	    __decorate([
	        core_1.ViewChild("updateSuccessPopup"), 
	        __metadata('design:type', Object)
	    ], BookingInformationComponent2.prototype, "updateSuccessPopup", void 0);
	    __decorate([
	        core_1.ViewChild("bookingExpenseModel"), 
	        __metadata('design:type', Object)
	    ], BookingInformationComponent2.prototype, "bookingExpenseModel", void 0);
	    __decorate([
	        core_1.ViewChild("receiptImagePopup"), 
	        __metadata('design:type', Object)
	    ], BookingInformationComponent2.prototype, "receiptImagePopup", void 0);
	    __decorate([
	        core_1.ViewChild("freebookingModal"), 
	        __metadata('design:type', Object)
	    ], BookingInformationComponent2.prototype, "freebookingModal", void 0);
	    BookingInformationComponent2 = __decorate([
	        core_1.Component({
	            selector: "wego-booking-information",
	            template: __webpack_require__(708),
	            styles: [
	                "\n      span.label.label-default {\n        font-size: 13px;\n        line-height: 35px;\n        background-color: #eeeeee;\n        color: #2ba2aa;\n        margin-right: 5px;\n      }\n\n      span.label.label-default.text-success {\n        color: #3c763d;\n      }\n\n      span.label.label-default.text-danger {\n        color: #a94442;\n      }\n\n      .line {\n        border-top: 1px solid #000;\n      }\n    "
	            ],
	            providers: [booking_service_1.BookingService, unlock_service_1.UnlockService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof booking_service_1.BookingService !== 'undefined' && booking_service_1.BookingService) === 'function' && _b) || Object, (typeof (_c = typeof unlock_service_1.UnlockService !== 'undefined' && unlock_service_1.UnlockService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _f) || Object, (typeof (_g = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _g) || Object])
	    ], BookingInformationComponent2);
	    return BookingInformationComponent2;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.BookingInformationComponent2 = BookingInformationComponent2;


/***/ },
/* 708 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\n    <section class=\"content-header\">\n      <div class=\"col-md-9 col-sm-6\">\n        <h1 class=\"pagename\">{{ 'LblOverview' | translate }}</h1>\n        <ol class=\"breadcrumb\">\n          <li>\n            <a [routerLink]=\"urlDefaultPage\">\n              <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\n          </li>\n          <li>\n            <a [routerLink]=\"urlBookingOverView\">\n              <i class=\"fa fa-calendar fa-fw\"></i>{{ 'LblOverviewList' | translate }}</a>\n          </li>\n          <li> {{ 'LblOverview' | translate }} </li>\n        </ol>\n      </div>\n      <div class=\"col-md-3 col-sm-6 mar_t_25\">\n      </div>\n      <div class=\"clearfix\"></div>\n      <div class=\"page-border-bottom\">Border bottom shadow</div>\n      <div class=\"clearfix\"></div>\n    </section>\n    <section class=\"content\">\n      <div class=\"col-sm-12\">\n    \n\n\n\n\n        <br/>\n        <fieldset *ngIf=\"model.listOfBookingTrip && model.listOfBookingTrip.length > 0\">\n          <!-- Removed in context of WEGO2DEV-359  -->\n          <!-- <legend class=\"legendStyle\">\n            {{ 'LblBookingTripDetail' | translate }}\n            <a *ngIf=\"!model.invoiceDetail || (model.invoiceDetail?.status!='CALCULATED' && model.invoiceDetail?.status!='SENT')\" style=\"margin-top: -4px; margin-right: 1px;\"\n              class=\"btn btn-highlight navbar-right\" (click)=\"AddTripDetail()\">{{ 'LblAddNewTrip' | translate }}</a>\n          </legend>\n          <div class=\"clearfix\"></div> -->\n          <div class=\"page-border-bottom\">Border bottom shadow</div>\n  \n          <div class=\"clearfix\"></div>\n  \n          <div class=\"row\" style=\"margin-left: 1px;margin-right:1px\">\n            <div class=\"table table-responsive mar_bot_ziro borderless\">\n              <table class=\"table table-bordered mar_bot_ziro\">\n                <thead>\n                  <tr>\n                    <th>\n                      {{ 'LblContractTypeGroup' | translate }}\n                    </th>\n                    <th>\n                      {{ 'LblStartDateTime' | translate }}\n                    </th>\n                    <th>\n                      {{ 'LblEndDateTime' | translate }}\n                    </th>\n                    <th>\n                      {{ 'LblDistance' | translate }}\n                    </th>\n                </thead>\n                <tbody>\n                  <tr *ngFor=\"let bookingTrip of model.listOfBookingTrip\">\n                    <td class=\"wordwrap\">{{ bookingTrip.contractTypeGroup }}</td>\n                    <td>{{ bookingTrip.startDateTime }}</td>\n                    <td>{{ bookingTrip.endDateTime }}</td>\n                    <td>{{ bookingTrip.distance }}</td>\n                  </tr>\n                </tbody>\n              </table>\n  \n            </div>\n          </div>\n        </fieldset>\n\n        \n\n\n\n\n\n\n\n\n\n      </div>\n    </section>\n    <div class=\"row no-margin\">\n      <div class=\"col-sm-12\">\n        <hr>\n        <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnBackClick(model.bookingIdHashId)\">{{ 'LblBack' | translate }}</a>\n\n\n\n          \n  \n        <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnTripsClick(model.bookingIdHashId)\" disabled=\"disabled\"><i class=\"fa fa-random\"></i>&nbsp;{{ 'LblTrips' | translate }}</a>\n        <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnCostsSummaryClick(model.bookingIdHashId)\"><i class=\"fa fa-book\"></i>&nbsp;{{ 'LblCostsSummary' | translate }}</a>\n\n  \n      </div>\n    </div>\n  </div>\n  <wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\n  \n  <wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\n  \n  <wego-success-popup #validationModal [popupTitle]=\"popupTitle\" [popupMsg]=\"message\" (onConfirm)=\"HideValidationModal()\"></wego-success-popup>\n  <wego-report-damage-popup #reportDamageModal (OnSuccessSelect)=\"SuccessReportDamage($event.SuccessMessage)\"></wego-report-damage-popup>\n  <wego-bookingtrip-detail-popup #bookingTripDetailModal (OnSuccessSave)=\"SuccessSave($event.SuccessMessage)\" [BookingInfoModel]=\"model\"\n    [BookingHashId]=\"bookingHashId\"></wego-bookingtrip-detail-popup>\n  <wego-confirm-popup #confirmModal [popupMsg]=\"deleteMessage\" (onConfirm)=\"ConfirmSuccessClick()\" (onReject)=\"HideConfirmModal()\"></wego-confirm-popup>\n  <wego-success-popup #updateSuccessPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmUpdateSuccessPopup()\"></wego-success-popup>\n  <wego-booking-expense-popup #bookingExpenseModel (OnSuccessSave)=\"SuccessSave($event.SuccessMessage)\" [BookingInfoModel]=\"model\"\n    [BookingHashId]=\"bookingHashId\"></wego-booking-expense-popup>\n  <wego-image-popup #receiptImagePopup></wego-image-popup>\n  <wego-free-booking-popup #freebookingModal (OnSuccessSave)=\"SuccessSave($event.SuccessMessage)\"></wego-free-booking-popup>";

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var EndRide_1 = __webpack_require__(701);
	var unlock_service_1 = __webpack_require__(702);
	var StartRide_1 = __webpack_require__(703);
	var lockunlock_model_1 = __webpack_require__(704);
	var booking_information_model_1 = __webpack_require__(705);
	var auth_service_1 = __webpack_require__(58);
	var translate_service_1 = __webpack_require__(70);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var booking_service_1 = __webpack_require__(556);
	var config_2 = __webpack_require__(60);
	var common_1 = __webpack_require__(22);
	var moment = __webpack_require__(84);
	var BookingInformationComponent3 = (function () {
	    function BookingInformationComponent3(authService, bookigService, unlockService, router, translate, activeRoute, locationService) {
	        this.authService = authService;
	        this.bookigService = bookigService;
	        this.unlockService = unlockService;
	        this.router = router;
	        this.translate = translate;
	        this.activeRoute = activeRoute;
	        this.locationService = locationService;
	        this.withVehicleInfo = false;
	        this.roleLevel = config_1.RoleLevel;
	    }
	    BookingInformationComponent3.prototype.ngOnInit = function () {
	        var _this = this;
	        this.model = new booking_information_model_1.BookingInformation();
	        this.lockunlock = new lockunlock_model_1.LockUnlock();
	        this.startride = new StartRide_1.StartRide();
	        this.endride = new EndRide_1.EndRide();
	        this.urlDefaultPage = this.authService.GetURL(config_2.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlBooking = this.authService.GetURL(config_2.ApplicationRouteURL.URL_BOOKING);
	        this.urlBookingPage = this.authService.GetURL(config_2.ApplicationRouteURL.URL_BOOKING_INFORMATION);
	        this.urlBookingTrips = this.authService.GetURL(config_2.ApplicationRouteURL.URL_BOOKING_INFORMATION2);
	        this.urlCostsSummary = this.authService.GetURL(config_2.ApplicationRouteURL.URL_BOOKING_INFORMATION3);
	        this.urlBookingOverView = this.authService.GetURL(config_2.ApplicationRouteURL.URL_BOOKING_OVERVIEW);
	        this.urlVehicleInfo = this.authService.GetURL(config_2.ApplicationRouteURL.URL_VEHICLE_INFO);
	        this.urlSVGInfo = this.authService.GetURL(config_2.ApplicationRouteURL.URL_SVG_UPDATE);
	        this.urlVtsTroubleShoot = this.authService.GetURL(config_2.ApplicationRouteURL.URL_VTS_TROUBLESHOOT);
	        this.urlEventViewer = this.authService.GetURL(config_2.ApplicationRouteURL.URL_EVENT_VIEWER_LIST);
	        this.activeRoute.queryParams.subscribe(function (queryParams) {
	            _this.withVehicleInfo = queryParams['vehicleInfo'] == 'true';
	            _this.sub = _this.activeRoute.params.subscribe(function (params) {
	                _this.bookingHashId = params["id"] || "";
	                if (_this.bookingHashId != "") {
	                    _this.GetBookingInformation();
	                }
	            });
	        });
	    };
	    BookingInformationComponent3.prototype.GetContactTypeGroup = function () {
	        var _this = this;
	        this.unlockService.GetContactTypeGroupList(this.bookingHashId).subscribe(function (res) {
	            console.log(res.data);
	            _this.contacttpyegroupList = res.data;
	            if (_this.contacttpyegroupList.length > 0) {
	                if (_this.contacttpyegroupList &&
	                    _this.contacttpyegroupList.length > 1) {
	                    _this.contacttypegroupid = _this.contacttpyegroupList.filter(function (x) { return x.isSelected; })[0].contactTypeGroupId;
	                    console.log(_this.contacttypegroupid);
	                    _this.isContractTypeGroupAvailable = true;
	                }
	                else {
	                    _this.contacttypegroupid = _this.contacttpyegroupList[0].contactTypeGroupId;
	                    _this.isContractTypeGroupAvailable = false;
	                }
	            }
	        }, function (error) { });
	    };
	    BookingInformationComponent3.prototype.GetBookingInformation = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.bookigService
	            .GetBookingInformationByHashId(this.bookingHashId, 'page3')
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.model = res.data;
	                _this.vtsTroubleShootLink = new config_1.WeGoAuthorizedLink(_this.urlVtsTroubleShoot + "/" + _this.model.vehicleHashId, config_1.Permission.PR_VTS_TROUBLESHOOT, config_1.PermissionType.VIEW, "", "LblTroubleShootVTS", "", "", false, "fa fa-wrench");
	                _this.viewVehicleLink = new config_1.WeGoAuthorizedLink(_this.urlVehicleInfo + "/" + _this.model.vehicleHashId, config_1.Permission.PR_VEHICLES_OVERVIEW, config_1.PermissionType.VIEW, "", _this.model.licenceTag, "", "", true);
	                _this.updateSvgLink = new config_1.WeGoAuthorizedLink(_this.urlSVGInfo + "/" + _this.model.sharedVehicleGroupHashId, config_1.Permission.PR_SHARED_VEHICLE_GROUP_OVERVIEW, config_1.PermissionType.EDIT, "", _this.model.sharedVehicleGroup, config_1.Entity.SVG, _this.model.sharedVehicleGroupHashId, true);
	                _this.viewEventViewerLink = new config_1.WeGoAuthorizedLink(_this.urlEventViewer +
	                    "?filter ='BOOKING'& searchTerm= " +
	                    _this.model.bookingReferenceID, config_1.Permission.PR_EVENT_VIEWER, config_1.PermissionType.VIEW, "", "LblEventViewer", "", "", false);
	                _this.isLoading = false;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        }, function () { return (_this.contacttpyegroupList = _this.GetContactTypeGroup()); });
	    };
	    BookingInformationComponent3.prototype.CheckBookingExtendTime = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.bookigService.CheckBookingExtendTime(this.bookingHashId).subscribe(function (res) {
	            if (res.data > 0) {
	                _this.availableBookingExtandTime = res.data;
	                _this.bookingExtandInfoMsg = _this.translate.instant("LblExtendInfoMsg", _this.availableBookingExtandTime.toString());
	            }
	            else {
	                _this.bookingExtandInfoMsg = _this.translate.instant("LblExtendValidationMsg");
	            }
	            _this.ShowAlertModal();
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BookingInformationComponent3.prototype.OnBackClick = function (bookingIdHashId) {
	        var url = this.urlBookingPage + '/' + bookingIdHashId;
	        this.router.navigateByUrl(url);
	    };
	    BookingInformationComponent3.prototype.OnTripsClick = function (bookingIdHashId) {
	        var url = this.urlBookingTrips + '/' + bookingIdHashId;
	        this.router.navigateByUrl(url);
	    };
	    BookingInformationComponent3.prototype.OnCostsSummaryClick = function (bookingIdHashId) {
	        var url = this.urlCostsSummary + '/' + bookingIdHashId;
	        this.router.navigateByUrl(url);
	    };
	    BookingInformationComponent3.prototype.ShowAlertModal = function () {
	        this.bookingExtensionValidation = "";
	        this.alertModal.show();
	    };
	    BookingInformationComponent3.prototype.HideAlertModal = function () {
	        this.bookingExtensionValidation = "";
	        this.bookingExtendTime = null;
	        this.alertModal.hide();
	    };
	    BookingInformationComponent3.prototype.SuccessAlertModalClick = function () {
	        if (this.availableBookingExtandTime > 0) {
	            if (this.bookingExtendTime && this.bookingExtendTime > 0) {
	                if (this.bookingExtendTime > this.availableBookingExtandTime) {
	                    this.bookingExtensionValidation = this.translate.instant("LblOverExtendValidationMsg", this.availableBookingExtandTime.toString());
	                }
	                else {
	                    this.bookingExtensionValidation = "";
	                    this.ExtendOnGoingBooking();
	                    this.HideAlertModal();
	                }
	            }
	            else {
	                this.bookingExtensionValidation = this.translate.instant("LblExtendRequire");
	            }
	        }
	        else {
	            this.bookingExtensionValidation = "";
	            this.HideAlertModal();
	        }
	    };
	    BookingInformationComponent3.prototype.ExtendOnGoingBooking = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.bookigService
	            .ExtendOnGoingBooking(this.bookingHashId, this.bookingExtendTime)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant("LblBookingExtendedSuccess");
	                _this.isLoading = false;
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BookingInformationComponent3.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    BookingInformationComponent3.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    BookingInformationComponent3.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	        this.router.navigate([this.urlBookingOverView]);
	    };
	    BookingInformationComponent3.prototype.HideValidationModal = function () {
	        this.validationModal.hide();
	    };
	    BookingInformationComponent3.prototype.UnlockVehicle = function (bookingIdHashId, vehicleExchangeHashId) {
	        var _this = this;
	        this.lockunlock.bookingMasterHashId = bookingIdHashId;
	        this.lockunlock.contractTypeGroupId = this.contacttypegroupid;
	        this.lockunlock.locationDataExchangeHashId = vehicleExchangeHashId;
	        this.lockunlock.isMobileRequest = false;
	        if (this.contacttpyegroupList && this.contacttpyegroupList.length > 0) {
	            this.isLoading = true;
	            this.unlockService.UnlockVehicle(this.lockunlock).subscribe(function (res) {
	                if (res.data) {
	                    _this.lockunlockresult = res.data;
	                    if (_this.lockunlockresult.isTripCalculatingInProgress) {
	                        _this.isLoading = false;
	                        _this.message = _this.translate.instant("LblTripCalculationInProgress");
	                        _this.popupTitle = _this.translate.instant("LblWarning");
	                        _this.validationModal.show();
	                    }
	                    else if (_this.lockunlockresult.isBookingExpired) {
	                        _this.isLoading = false;
	                        _this.message = _this.translate.instant("LblBookingExpired");
	                        _this.popupTitle = _this.translate.instant("LblWarning");
	                        _this.validationModal.show();
	                    }
	                    else if (_this.lockunlockresult.isSameCommandInProgress) {
	                        _this.isLoading = false;
	                        _this.message = _this.translate.instant("LblSameVTSCommand");
	                        _this.popupTitle = _this.translate.instant("LblWarning");
	                        _this.validationModal.show();
	                    }
	                    else if (_this.lockunlockresult.isDoorStatusOpened) {
	                        _this.isLoading = false;
	                        _this.popupMsg = _this.translate.instant("LblUnLockSuccessfully");
	                        _this.ShowSuccessPopup();
	                    }
	                    else if (!_this.lockunlockresult.isUnlock &&
	                        !_this.lockunlockresult.isTripCalculatingInProgress &&
	                        !_this.lockunlockresult.isSameCommandInProgress) {
	                        _this.isLoading = false;
	                        _this.message = _this.translate.instant("LblUnlockProblem");
	                        _this.popupTitle = _this.translate.instant("LblWarning");
	                        _this.validationModal.show();
	                    }
	                    else if (_this.lockunlockresult.isUnlock) {
	                        //this.GetStartRideSubmit();
	                        _this.isLoading = false;
	                        _this.popupMsg = _this.translate.instant("LblUnLockSuccessfully");
	                        _this.ShowSuccessPopup();
	                    }
	                }
	            }, function (error) {
	                _this.isLoading = false;
	            });
	        }
	        else {
	            this.message = this.translate.instant("LblUnlockErrorMessage");
	            this.popupTitle = this.translate.instant("LblWarning");
	            this.validationModal.show();
	        }
	    };
	    // public GetStartRideSubmit() {
	    //   this.isLoading = true;
	    //   this.startride.contractTypeGroupId = this.contacttypegroupid;
	    //   this.startride.startDateTime = this.lockunlockresult.startDateTime;
	    //   this.startride.startLatitude = this.lockunlockresult.startLat;
	    //   this.startride.startLongitude = this.lockunlockresult.startLog;
	    //   this.startride.startMileage = this.lockunlockresult.startMilege;
	    //   this.startride.bookingHashId = this.bookingHashId;
	    //   this.startride.locationExchangeHashId = this.lockunlock.locationDataExchangeHashId;
	    //   this.startride.bookingTripSummaryId = this.lockunlockresult.bookingTripSummaryId;
	    //   let tripcommandproblem = this.translate.instant('LblProblemTrip');
	    //   this.unlockService.StartTrip(this.startride)
	    //     .subscribe(
	    //     res => {
	    //       if (res.data) {
	    //         this.triphashId = res.data;
	    //         this.isLoading = false;
	    //         this.popupMsg = this.translate.instant('LblUnLockSuccessfully');
	    //         this.ShowSuccessPopup();
	    //       }
	    //       else {
	    //         this.isLoading = false;
	    //       }
	    //     },
	    //     error => {
	    //       this.isLoading = false;
	    //     });
	    // }
	    BookingInformationComponent3.prototype.LockVehicle = function (bookingIdHashId, vehicleExchangeHashId) {
	        var _this = this;
	        this.lockunlock.bookingMasterHashId = bookingIdHashId;
	        this.lockunlock.locationDataExchangeHashId = vehicleExchangeHashId;
	        this.lockunlock.isMobileRequest = false;
	        this.isLoading = true;
	        this.unlockService.LockVehicle(this.lockunlock).subscribe(function (res) {
	            if (res.data) {
	                _this.lockunlockresult = res.data;
	                if (_this.lockunlockresult.isBookingExpired) {
	                    _this.isLoading = false;
	                    _this.message = _this.translate.instant("LblBookingExpired");
	                    _this.popupTitle = _this.translate.instant("LblWarning");
	                    _this.validationModal.show();
	                }
	                else if (_this.lockunlockresult.isSameCommandInProgress) {
	                    _this.isLoading = false;
	                    _this.message = _this.translate.instant("LblSameVTSCommand");
	                    _this.popupTitle = _this.translate.instant("LblWarning");
	                    _this.validationModal.show();
	                }
	                else if (_this.lockunlockresult.isDoorStatusClosed) {
	                    _this.popupMsg = _this.translate.instant("LblLockCompletelySuccessfully");
	                    _this.isLoading = false;
	                    _this.ShowSuccessPopup();
	                }
	                else if (!_this.lockunlockresult.isLock &&
	                    !_this.lockunlockresult.isSameCommandInProgress) {
	                    _this.isLoading = false;
	                    _this.message = _this.translate.instant("LbllockProblem");
	                    _this.popupTitle = _this.translate.instant("LblWarning");
	                    _this.validationModal.show();
	                }
	                else {
	                    //this.GetEndRideSubmit(bookingIdHashId, vehicleExchangeHashId);
	                    _this.popupMsg = _this.translate.instant("LblLockCompletelySuccessfully");
	                    _this.isLoading = false;
	                    _this.ShowSuccessPopup();
	                }
	            }
	            else {
	            }
	        }, function (error) {
	            _this.isLoading = false;
	        });
	    };
	    BookingInformationComponent3.prototype.PartialockResult = function (bookingIdHashId, vehicleExchangeHashId) {
	        var _this = this;
	        this.lockunlock.bookingMasterHashId = bookingIdHashId;
	        this.lockunlock.locationDataExchangeHashId = vehicleExchangeHashId;
	        this.lockunlock.tripHashId = this.triphashId
	            ? this.triphashId.toString()
	            : "0";
	        this.lockunlock.isMobileRequest = false;
	        this.isLoading = true;
	        this.unlockService.PartialLock(this.lockunlock).subscribe(function (res) {
	            if (res.data) {
	                _this.lockunlockresult = res.data;
	                if (_this.lockunlockresult.isBookingExpired) {
	                    _this.isLoading = false;
	                    _this.message = _this.translate.instant("LblBookingExpired");
	                    _this.popupTitle = _this.translate.instant("LblWarning");
	                    _this.validationModal.show();
	                }
	                else if (_this.lockunlockresult.isSameCommandInProgress) {
	                    _this.isLoading = false;
	                    _this.message = _this.translate.instant("LblSameVTSCommand");
	                    _this.popupTitle = _this.translate.instant("LblWarning");
	                    _this.validationModal.show();
	                }
	                else if (_this.lockunlockresult.isDoorStatusClosed) {
	                    _this.popupMsg = _this.translate.instant("LblLockCompletelySuccessfully");
	                    _this.isLoading = false;
	                    _this.ShowSuccessPopup();
	                }
	                else if (_this.lockunlockresult.engineStillRunning) {
	                    _this.isLoading = false;
	                    _this.message = _this.translate.instant("LblEngineStillRunning");
	                    _this.popupTitle = _this.translate.instant("LblWarning");
	                    _this.validationModal.show();
	                }
	                else if (!_this.lockunlockresult.isLock) {
	                    _this.isLoading = false;
	                    _this.message = _this.translate.instant("LbllockProblem");
	                    _this.popupTitle = _this.translate.instant("LblWarning");
	                    _this.validationModal.show();
	                }
	                else {
	                    _this.popupMsg = _this.translate.instant("LblLockSuccessfully");
	                    _this.isLoading = false;
	                    _this.ShowSuccessPopup();
	                }
	            }
	        }, function (error) {
	            _this.isLoading = false;
	        });
	    };
	    // public GetEndRideSubmit(bookingIdHashId: string, vehicleExchangeHashId: string) {
	    //   this.endride.bookingHashId = bookingIdHashId;
	    //   this.endride.tripHashId = this.triphashId ? this.triphashId.toString() : '0';
	    //   this.endride.locationExchangeHashId = vehicleExchangeHashId;
	    //   this.unlockService.EndTrip(this.endride)
	    //     .subscribe(
	    //     res => {
	    //       if (res.data) {
	    //         this.lockunlockresult = res.data;
	    //       }
	    //       else {
	    //       }
	    //     },
	    //     error => {
	    //     });
	    // }
	    BookingInformationComponent3.prototype.ReportDamage = function (bookingHashId) {
	        this.reportDamageModal.model.bookingHashId = bookingHashId;
	        this.reportDamageModal.model.vehicleHashId = this.model.vehicleHashId;
	        this.reportDamageModal.show();
	    };
	    BookingInformationComponent3.prototype.FreeBooking = function (bookingHashId) {
	        this.freebookingModal.model.bookingHashId = bookingHashId;
	        this.freebookingModal.show();
	    };
	    BookingInformationComponent3.prototype.SuccessReportDamage = function (successMsg) {
	        this.popupMsg = successMsg;
	        this.ShowSuccessPopup();
	    };
	    BookingInformationComponent3.prototype.SuccessSave = function (successMsg) {
	        this.popupMsg = successMsg;
	        this.ShowUpdateSuccessPopup();
	        this.GetBookingInformation();
	    };
	    BookingInformationComponent3.prototype.AddTripDetail = function () {
	        this.bookingTripDetailModal.model = new booking_information_model_1.BookingTripDetail();
	        this.bookingTripDetailModal.show();
	    };
	    BookingInformationComponent3.prototype.EditTripDetail = function (bookingtrip) {
	        this.bookingTripDetailModal.model = JSON.parse(JSON.stringify(bookingtrip));
	        this.bookingTripDetailModal.show();
	    };
	    BookingInformationComponent3.prototype.ShowConfirmModal = function (bookingtripHashId) {
	        this.isLoading = false;
	        this.deleteMessage = this.translate.instant("LblRecordDeleteConfirmation", this.translate.instant("LblBookingTripDetail"));
	        this.confirmModal.show();
	        this.bookingtripHashId = bookingtripHashId;
	    };
	    BookingInformationComponent3.prototype.HideConfirmModal = function () {
	        this.confirmModal.hide();
	    };
	    BookingInformationComponent3.prototype.ConfirmSuccessClick = function () {
	        this.confirmModal.hide();
	        //this.DeleteBookingTrip();
	    };
	    // public DeleteBookingTrip() {
	    //   this.isLoading = true;
	    //   this.bookigService.DeleteBookingTrip(this.bookingtripHashId)
	    //     .subscribe(
	    //     (res: any) => {
	    //       if (res.data) {
	    //         this.GetBookingInformation();
	    //         this.popupMsg = this.translate.instant('LblRecordRemovedSuccess', this.translate.instant('LblBookingTripDetail'));
	    //         this.ShowUpdateSuccessPopup();
	    //       }
	    //       else {
	    //         this.popupMsg = res.error;
	    //         this.isLoading = false;
	    //         this.ShowUpdateSuccessPopup();
	    //       }
	    //     },
	    //     (error: any) => {
	    //       this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
	    //       this.isLoading = false;
	    //     });
	    // }
	    BookingInformationComponent3.prototype.ShowUpdateSuccessPopup = function () {
	        this.updateSuccessPopup.show();
	    };
	    BookingInformationComponent3.prototype.HideUpdateSuccessPopup = function () {
	        this.updateSuccessPopup.hide();
	    };
	    BookingInformationComponent3.prototype.ConfirmUpdateSuccessPopup = function () {
	        this.updateSuccessPopup.hide();
	    };
	    BookingInformationComponent3.prototype.EditExpenseDetail = function (bookingexpense) {
	        this.bookingExpenseModel.model = JSON.parse(JSON.stringify(bookingexpense));
	        this.bookingExpenseModel.show();
	    };
	    BookingInformationComponent3.prototype.ShowReceipt = function (imagepath) {
	        this.receiptImagePopup.imagepath = config_2.WeGoConfig.API_SERVER_URL + imagepath;
	        this.receiptImagePopup.show();
	    };
	    BookingInformationComponent3.prototype.GroupByCategory = function (vehicleAttributeList) {
	        if (vehicleAttributeList) {
	            var prop_1 = "vehicleAttributeCategoryName";
	            return vehicleAttributeList.reduce(function (groups, item) {
	                var val = item[prop_1];
	                groups[val] = groups[val] || [];
	                groups[val].push(item);
	                groups[val] = groups[val].sort(function (obj1, obj2) {
	                    if (obj1.attributeName > obj2.attributeName) {
	                        return 1;
	                    }
	                    if (obj1.attributeName < obj2.attributeName) {
	                        return -1;
	                    }
	                    return 0;
	                });
	                return groups;
	            }, {});
	        }
	        else {
	            return {};
	        }
	    };
	    BookingInformationComponent3.prototype.KeyOfObject = function (obj) {
	        return Object.keys(obj);
	    };
	    BookingInformationComponent3.prototype.CalculateTripCost = function (dataArray, propName) {
	        var total = 0;
	        for (var n = 0; n < dataArray.length; n++) {
	            total += dataArray[n][propName];
	        }
	        return Math.round(total * 100) / 100;
	    };
	    __decorate([
	        core_1.ViewChild("alertModal"), 
	        __metadata('design:type', Object)
	    ], BookingInformationComponent3.prototype, "alertModal", void 0);
	    __decorate([
	        core_1.ViewChild("successPopup"), 
	        __metadata('design:type', Object)
	    ], BookingInformationComponent3.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild("validationModal"), 
	        __metadata('design:type', Object)
	    ], BookingInformationComponent3.prototype, "validationModal", void 0);
	    __decorate([
	        core_1.ViewChild("reportDamageModal"), 
	        __metadata('design:type', Object)
	    ], BookingInformationComponent3.prototype, "reportDamageModal", void 0);
	    __decorate([
	        core_1.ViewChild("bookingTripDetailModal"), 
	        __metadata('design:type', Object)
	    ], BookingInformationComponent3.prototype, "bookingTripDetailModal", void 0);
	    __decorate([
	        core_1.ViewChild("confirmModal"), 
	        __metadata('design:type', Object)
	    ], BookingInformationComponent3.prototype, "confirmModal", void 0);
	    __decorate([
	        core_1.ViewChild("updateSuccessPopup"), 
	        __metadata('design:type', Object)
	    ], BookingInformationComponent3.prototype, "updateSuccessPopup", void 0);
	    __decorate([
	        core_1.ViewChild("bookingExpenseModel"), 
	        __metadata('design:type', Object)
	    ], BookingInformationComponent3.prototype, "bookingExpenseModel", void 0);
	    __decorate([
	        core_1.ViewChild("receiptImagePopup"), 
	        __metadata('design:type', Object)
	    ], BookingInformationComponent3.prototype, "receiptImagePopup", void 0);
	    __decorate([
	        core_1.ViewChild("freebookingModal"), 
	        __metadata('design:type', Object)
	    ], BookingInformationComponent3.prototype, "freebookingModal", void 0);
	    BookingInformationComponent3 = __decorate([
	        core_1.Component({
	            selector: "wego-booking-information",
	            template: __webpack_require__(710),
	            styles: [
	                "\n      span.label.label-default {\n        font-size: 13px;\n        line-height: 35px;\n        background-color: #eeeeee;\n        color: #2ba2aa;\n        margin-right: 5px;\n      }\n\n      span.label.label-default.text-success {\n        color: #3c763d;\n      }\n\n      span.label.label-default.text-danger {\n        color: #a94442;\n      }\n\n      .line {\n        border-top: 1px solid #000;\n      }\n    "
	            ],
	            providers: [booking_service_1.BookingService, unlock_service_1.UnlockService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof booking_service_1.BookingService !== 'undefined' && booking_service_1.BookingService) === 'function' && _b) || Object, (typeof (_c = typeof unlock_service_1.UnlockService !== 'undefined' && unlock_service_1.UnlockService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _f) || Object, (typeof (_g = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _g) || Object])
	    ], BookingInformationComponent3);
	    return BookingInformationComponent3;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.BookingInformationComponent3 = BookingInformationComponent3;


/***/ },
/* 710 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\n    <section class=\"content-header\">\n      <div class=\"col-md-9 col-sm-6\">\n        <h1 class=\"pagename\">{{ 'LblOverview' | translate }}</h1>\n        <ol class=\"breadcrumb\">\n          <li>\n            <a [routerLink]=\"urlDefaultPage\">\n              <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\n          </li>\n          <li>\n            <a [routerLink]=\"urlBookingOverView\">\n              <i class=\"fa fa-calendar fa-fw\"></i>{{ 'LblOverviewList' | translate }}</a>\n          </li>\n          <li> {{ 'LblOverview' | translate }} </li>\n        </ol>\n      </div>\n      <div class=\"col-md-3 col-sm-6 mar_t_25\">\n      </div>\n      <div class=\"clearfix\"></div>\n      <div class=\"page-border-bottom\">Border bottom shadow</div>\n      <div class=\"clearfix\"></div>\n    </section>\n    <section class=\"content\">\n      <div class=\"col-sm-12\">\n    \n\n\n\n\n      <br/>\n\n\n        <fieldset *ngIf=\"model.bookingType == 'NORMAL' && model.listOfBookingExpense && model.listOfBookingExpense.length > 0\">\n          <legend class=\"legendStyle\">\n            {{ 'LblBookingExpenseDetail' | translate }}\n          </legend>\n          <div class=\"clearfix\"></div>\n  \n          <div class=\"page-border-bottom\">Border bottom shadow</div>\n  \n          <div class=\"clearfix\"></div>\n  \n          <div class=\"row\" style=\"margin-left: 1px;margin-right:1px\">\n            <div class=\"table table-responsive mar_bot_ziro borderless\">\n              <table class=\"table table-bordered mar_bot_ziro\">\n                <thead>\n                  <tr>\n                    <th> {{ 'LblCostType' | translate }}</th>\n                    <th> {{ 'LblExpenseAmount' | translate }}</th>\n                    <th> {{ 'LblExpenseAmountVat' | translate }}</th>\n                    <th> {{ 'LblDescription' | translate }}</th>\n                    <th class=\"text-center\">{{ 'LblReceipt' | translate }}</th>\n                    <th class=\"text-center\">{{ 'LblEdit' | translate }}</th>\n                  </tr>\n                </thead>\n                <tbody>\n                  <tr *ngFor=\"let bookingExpense of model.listOfBookingExpense\">\n                    <td class=\"wordwrap\"> {{bookingExpense.costTypeName}} </td>\n                    <td>\n                      {{ bookingExpense.reportedAmountExVatFormat | currencyFormatter : bookingExpense.currencySymbol : bookingExpense.isCurrencySymbolBefore}}\n                    </td>\n                    <td>\n                      {{ bookingExpense.reportedAmountVatFormat | currencyFormatter : bookingExpense.currencySymbol : bookingExpense.isCurrencySymbolBefore}}\n                    </td>\n                    <td> {{bookingExpense.description}} </td>\n                    <td class=\"text-center\">\n                      <a class=\"cursor-pointer\" title=\"{{'LblReceipt' | translate}}\" (click)=\"ShowReceipt(bookingExpense.receiptPath)\">\n                        <i class=\"fa fa-file-picture-o  fa-fw\"></i>\n                      </a>\n                    </td>\n                    <td class=\"text-center\">\n                      <a (click)=\"EditExpenseDetail(bookingExpense)\" class=\"cursor-pointer\">\n                        <i class=\"fa fa-pencil-square-o fa-fw\"></i>\n                      </a>\n                    </td>\n                  </tr>\n                </tbody>\n              </table>\n            </div>\n          </div>\n        </fieldset>\n\n        <br />\n        <fieldset *ngIf=\"model.bookingType == 'NORMAL' && model.listOfBookingExpense && model.listOfBookingExpense.length > 0\">\n          <legend class=\"legendStyle\">\n            {{ 'LblBookingExpenseDetail' | translate }}\n          </legend>\n          <div class=\"clearfix\"></div>\n  \n          <div class=\"page-border-bottom\">Border bottom shadow</div>\n  \n          <div class=\"clearfix\"></div>\n  \n          <div class=\"row\" style=\"margin-left: 1px;margin-right:1px\">\n            <div class=\"table table-responsive mar_bot_ziro borderless\">\n              <table class=\"table table-bordered mar_bot_ziro\">\n                <thead>\n                  <tr>\n                    <th> {{ 'LblCostType' | translate }}</th>\n                    <th> {{ 'LblExpenseAmount' | translate }}</th>\n                    <th> {{ 'LblExpenseAmountVat' | translate }}</th>\n                    <th> {{ 'LblDescription' | translate }}</th>\n                    <th class=\"text-center\">{{ 'LblReceipt' | translate }}</th>\n                    <th class=\"text-center\">{{ 'LblEdit' | translate }}</th>\n                  </tr>\n                </thead>\n                <tbody>\n                  <tr *ngFor=\"let bookingExpense of model.listOfBookingExpense\">\n                    <td class=\"wordwrap\"> {{bookingExpense.costTypeName}} </td>\n                    <td>\n                      {{ bookingExpense.reportedAmountExVatFormat | currencyFormatter : bookingExpense.currencySymbol : bookingExpense.isCurrencySymbolBefore}}\n                    </td>\n                    <td>\n                      {{ bookingExpense.reportedAmountVatFormat | currencyFormatter : bookingExpense.currencySymbol : bookingExpense.isCurrencySymbolBefore}}\n                    </td>\n                    <td> {{bookingExpense.description}} </td>\n                    <td class=\"text-center\">\n                      <a class=\"cursor-pointer\" title=\"{{'LblReceipt' | translate}}\" (click)=\"ShowReceipt(bookingExpense.receiptPath)\">\n                        <i class=\"fa fa-file-picture-o  fa-fw\"></i>\n                      </a>\n                    </td>\n                    <td class=\"text-center\">\n                      <a (click)=\"EditExpenseDetail(bookingExpense)\" class=\"cursor-pointer\">\n                        <i class=\"fa fa-pencil-square-o fa-fw\"></i>\n                      </a>\n                    </td>\n                  </tr>\n                </tbody>\n              </table>\n            </div>\n          </div>\n        </fieldset>\n        <br/>\n  \n        <fieldset *ngIf=\"!(model.bookingTripCostModel && model.bookingTripCostModel.length>0) &&  model.bookingType == 'NORMAL' && (model.invoiceDetail?.status=='CALCULATED'||model.invoiceDetail?.status=='SENT')\">\n          <legend class=\"legendStyle\">\n            {{ 'LblInvoiceDetail' | translate }}\n          </legend>\n          <div class=\"row\" *ngIf=\"model.invoiceDetail?.invoiceNumber && model.isDriverInvoiceVisible\">\n            <div class=\"col-sm-6 col-xs-6\">\n              <label>{{ 'LblDriver' | translate }} {{ 'LblInvoiceNumber' | translate }} :</label> {{ model.invoiceDetail?.invoiceNumber\n              }}\n            </div>\n            <div class=\"col-sm-6 col-xs-6\">\n              <label>{{ 'LblDriver' | translate }} {{ 'LblInvoiceDateTime' | translate }} :</label> {{ model.invoiceDetail?.invoiceDate\n              }}\n            </div>\n          </div>\n          <div class=\"clearfix\"></div>\n          <div class=\"row\" *ngIf=\"model.invoiceDetail?.organizationInvoiceNumber && model.isOrganizationInvoiceVisible\">\n            <div class=\"col-sm-6 col-xs-6\">\n              <label>{{ 'LblOrganization' | translate }} {{ 'LblInvoiceNumber' | translate }} :</label> {{ model.invoiceDetail?.organizationInvoiceNumber\n              }}\n            </div>\n            <div class=\"col-sm-6 col-xs-6\">\n              <label>{{ 'LblOrganization' | translate }} {{ 'LblInvoiceDateTime' | translate }} :</label> {{ model.invoiceDetail?.organizationInvoiceDate\n              }}\n            </div>\n          </div>\n          <div class=\"clearfix\"></div>\n          <div class=\"row\">\n            <div class=\"col-sm-3 col-xs-3\">\n              <label>{{ 'LblDistance' | translate }} ({{ 'LblKilometers' | translate }}) :</label> {{ model.invoiceDetail?.totalKm\n              }}\n            </div>\n            <div class=\"col-sm-3 col-xs-3\">\n              <label>{{ 'LblFreeKilometer' | translate }} :</label> {{ model.invoiceDetail?.freeKm }}</div>\n            <div class=\"col-sm-3 col-xs-3\">\n              <label> {{ 'LblAdditional' | translate }} {{ 'LblFreeKilometer' | translate }} :</label> {{ model.invoiceDetail?.additionalFreeKm\n              }}\n            </div>\n            <div class=\"col-sm-3 col-xs-3\">\n              <label>{{ 'LblMileageRate' | translate }} :</label>\n              {{ model.invoiceDetail?.mileageRate | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore\n              }}\n            </div>\n            <div class=\"col-sm-3 col-xs-3\">\n              <label>{{ 'LblDriveHours' | translate }} :</label> {{ model.invoiceDetail?.totalHoursFormat }}</div>\n            <div class=\"col-sm-3 col-xs-3\">\n              <label>{{ 'LblFreeHours' | translate }} :</label> {{ model.invoiceDetail?.freeHoursFormat }}</div>\n            <div class=\"col-sm-3 col-xs-3\">\n              <label>{{ 'LblAdditional' | translate }} {{ 'LblFreeHours' | translate }} :</label> {{ model.invoiceDetail?.additionalFreeHoursFormat\n              }}\n            </div>\n            <div class=\"col-sm-3 col-xs-3\">\n              <label>{{ 'LblHourlyRate' | translate }} :</label>\n              {{ model.invoiceDetail?.hourlyRate | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\n            </div>\n            <div class=\"col-sm-3 col-xs-3\">\n            </div>\n            <div *ngIf=\"model.invoiceDetail && model.invoiceDetail?.processingFree>0\" class=\"col-sm-3 col-xs-3\">\n              <label>{{ 'LblProcessingFee' | translate }} :</label>\n              {{ model.invoiceDetail?.processingFree | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\n            </div>\n            <div *ngIf=\"model.invoiceDetail && model.invoiceDetail?.plateFormCostUsage>0\" class=\"col-sm-3 col-xs-3\">\n              <label>{{ 'LblPlateformUsageCost' | translate }} :</label>\n              {{ model.invoiceDetail?.plateFormCostUsage | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\n            </div>\n            <div class=\"col-sm-3 col-xs-3\">\n              <label>{{ 'LblVat' | translate }} :</label>\n              {{ model.invoiceDetail?.vat | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\n            </div>\n            <div class=\"col-sm-3 col-xs-3\">\n              <label>{{ 'LblPenaltyRate' | translate }} :</label>\n              {{ model.invoiceDetail?.penaltyRate | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\n            </div>\n            <div *ngIf=\"model.bookingCustomFee==null\" class=\"col-sm-3 col-xs-3\">\n              <label>{{ 'LblTotal' | translate }} :</label>\n              {{ model.invoiceDetail?.grandTotal | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\n            </div>\n            <div *ngIf=\"model.bookingCustomFee!=null\" class=\"col-sm-3 col-xs-3\">\n              <label>{{ 'LblTotal' | translate }} :</label>\n              <del> {{ model.invoiceDetail?.grandTotal | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}</del>\n              <br/>\n              <p class=\"col-sm-5 col-xs-5 \"> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{ model.bookingCustomFee | currencyFormatter : model.invoiceDetail?.currencySymbol\n                : model.invoiceDetail?.isCurrencySymbolBefore}}\n              </p>\n            </div>\n          </div>\n        </fieldset>\n\n\n        <fieldset *ngIf=\"(model.bookingTripCostModel && model.bookingTripCostModel.length>0)   && model.bookingType == 'NORMAL' && (model.invoiceDetail?.status=='CALCULATED'||model.invoiceDetail?.status=='SENT')\">\n          <legend class=\"legendStyle\">\n            {{ 'LblBookingCostSummary' | translate }}\n          </legend>\n          <h4>\n            <label>{{ 'LblTimeCost' | translate }}</label>\n          </h4>\n  \n          <div class=\"row\">\n            <div class=\"col-sm-3\">\n              <label>{{ 'LblTotalTime' | translate }}</label> :\n            </div>\n            <div class=\"col-sm-9\">\n              {{ model.invoiceDetail?.totalHoursFormat }} ({{ model.startDateTime }} {{ 'LblTo' | translate }} {{ model.endDateTime }})\n            </div>\n          </div>\n          <div *ngIf=\"model.invoiceDetail?.invoiceNumber && model.isDriverInvoiceVisible\" class=\"row\">\n            <div class=\"col-sm-3\">\n              <label>{{ 'LblDriver' | translate }} {{ 'LblInvoiceNumber' | translate }}</label> :\n            </div>\n            <div class=\"col-sm-9\">\n              {{ model.invoiceDetail?.invoiceNumber }} ({{ model.invoiceDetail?.invoiceDate}})\n            </div>\n          </div>\n          <div *ngIf=\"model.invoiceDetail?.organizationInvoiceNumber && model.isOrganizationInvoiceVisible\" class=\"row\">\n            <div class=\"col-sm-3\">\n              <label>{{ 'LblOrganization' | translate }} {{ 'LblInvoiceNumber' | translate }}</label> :\n            </div>\n            <div class=\"col-sm-9\">\n              {{ model.invoiceDetail?.organizationInvoiceNumber }} ({{ model.invoiceDetail?.organizationInvoiceDate}})\n            </div>\n          </div>\n          <br>\n          <div class=\"row\">\n            <div class=\"col-sm-2\"></div>\n            <div class=\"col-sm-2\">\n              <label>{{ 'LblCostRateUnits' | translate }}</label>\n            </div>\n            <div class=\"col-sm-2 text-right\">\n              <label>{{ 'LblFreeKms' | translate }}</label>\n            </div>\n            <div class=\"col-sm-2\">\n              <label>{{ 'LblCostType' | translate }}</label>\n            </div>\n            <div class=\"col-sm-2 text-right\">\n              <label>{{ 'LblExVat' | translate }}</label>\n            </div>\n            <div class=\"col-sm-2 text-right\">\n              <label>{{ 'LblInclVat' | translate }}</label>\n            </div>\n          </div>\n  \n          <div class=\"row\" *ngFor=\"let timeCost of model.bookingTripCostModel\">\n            <fieldset *ngIf=\"timeCost.specialTripCategory!=3\">\n              <div class=\"col-sm-2 wordwrap\">{{timeCost.contractTypeGroup}}({{ timeCost.contractType }}) </div>\n              <div class=\"col-sm-2\">{{timeCost.hourlyRateWithoutVat}} ({{ timeCost.totalHours }} * {{ timeCost.hourlyRateMinute }})</div>\n              <div class=\"col-sm-2 text-right\">{{ timeCost.freeHoursFormat | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}</div>\n              <div class=\"col-sm-2\">{{ timeCost.totalHoursFormat }}</div>\n              <div class=\"col-sm-2 text-right\">\n                {{ timeCost.hourlyRateWithoutVat | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\n              </div>\n              <div class=\"col-sm-2 text-right\">\n                {{ timeCost.hourlyRate | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}} ({{ timeCost.vat }}%)\n              </div>\n            </fieldset>\n          </div>\n  \n          <h4>\n          </h4>\n          <div class=\"clearfix\"></div>\n  \n          <br>\n          <div class=\"row\">\n            <div class=\"col-sm-8\"></div>\n            <div class=\"col-sm-4\">\n              <label>{{ 'LblTotals' | translate }}</label>\n            </div>\n          </div>\n          <div class=\"row\">\n            <div class=\"col-sm-8\">\n            </div>\n            <div class=\"col-sm-4\">\n              <div class=\"line\"></div>\n            </div>\n          </div>\n          <div *ngIf=\"model.invoiceDetail && model.invoiceDetail?.processingFree>0\" class=\"row\">\n            <div class=\"col-sm-8\"></div>\n            <div class=\"col-sm-2 text-right\">\n              <label>{{ 'LblProcessingFee' | translate }}</label>\n            </div>\n            <div class=\"col-sm-2 text-right\">\n              <label>\n                {{ model.invoiceDetail?.processingFree | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\n              </label>\n            </div>\n          </div>\n  \n          <div *ngIf=\"model.invoiceDetail && model.invoiceDetail?.plateFormCostUsage>0\" class=\"row\">\n            <div class=\"col-sm-8\"></div>\n            <div class=\"col-sm-2 text-right\">\n              <label>{{ 'LblPlateformUsageCost' | translate }}</label>\n            </div>\n            <div class=\"col-sm-2 text-right\">\n              <label>\n                {{ model.invoiceDetail?.plateFormCostUsage | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\n              </label>\n            </div>\n          </div>\n  \n          <div class=\"row\">\n            <div class=\"col-sm-8\"></div>\n            <div class=\"col-sm-2 text-right\">\n              <label>{{ 'LblTotalExVat' | translate }}</label>\n            </div>\n            <div class=\"col-sm-2 text-right\">\n              <label>\n                {{ model.invoiceDetail?.totalWithoutVat | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\n              </label>\n            </div>\n          </div>\n            <div class=\"row\">\n                <div class=\"col-sm-8\"></div>\n                <div class=\"col-sm-2 text-right\">\n                    <label>{{ 'LblTotalVat' | translate }}</label>\n                </div>\n                <div class=\"col-sm-2 text-right\">\n                    <label>\n                        {{ model.invoiceDetail?.vatWithPenaltyVat | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\n                    </label>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-sm-8\"></div>\n                <div class=\"col-sm-2 text-right\">\n                    <label>{{ 'LblTotalInclVat' | translate }}</label>\n                </div>\n                <div class=\"col-sm-2 text-right\">\n                    <label>\n                        {{ model.invoiceDetail?.totalFixedCostWithVat | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\n                    </label>\n                </div>\n            </div>\n            <div class=\"row\">\n                <div class=\"col-sm-8\"></div>\n                <div class=\"col-sm-2 text-right\">\n                    <label>{{ 'LblFreeKms' | translate }}</label>\n                </div>\n                <div class=\"col-sm-2 text-right\">\n                    <label>\n                        -{{ model.invoiceDetail?.freeKm | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\n                    </label>\n                </div>\n            </div>\n          <div class=\"row\">\n            <div class=\"col-sm-8\"></div>\n            <div class=\"col-sm-2 text-right\">\n              <label>{{ 'LblTotalAmount' | translate }}</label>\n            </div>\n            <div class=\"col-sm-2 text-right\">\n              <label>\n                {{ model.invoiceDetail?.grandTotal | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\n              </label>\n            </div>\n          </div>\n  \n        </fieldset>\n\n\n\n\n\n\n\n\n\n\n\n\n      </div>\n    </section>\n    <div class=\"row no-margin\">\n      <div class=\"col-sm-12\">\n        <hr>\n        <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnBackClick(model.bookingIdHashId)\">{{ 'LblBack' | translate }}</a>\n\n\n\n          \n  \n        <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnTripsClick(model.bookingIdHashId)\"><i class=\"fa fa-random\"></i>&nbsp;{{ 'LblTrips' | translate }}</a>\n        <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnCostsSummaryClick(model.bookingIdHashId)\" disabled=\"disabled\"><i class=\"fa fa-book\"></i>&nbsp;{{ 'LblCostsSummary' | translate }}</a>\n\n  \n      </div>\n    </div>\n  </div>\n  <wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\n  \n  <wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\n  \n  <wego-success-popup #validationModal [popupTitle]=\"popupTitle\" [popupMsg]=\"message\" (onConfirm)=\"HideValidationModal()\"></wego-success-popup>\n  <wego-report-damage-popup #reportDamageModal (OnSuccessSelect)=\"SuccessReportDamage($event.SuccessMessage)\"></wego-report-damage-popup>\n  <wego-bookingtrip-detail-popup #bookingTripDetailModal (OnSuccessSave)=\"SuccessSave($event.SuccessMessage)\" [BookingInfoModel]=\"model\"\n    [BookingHashId]=\"bookingHashId\"></wego-bookingtrip-detail-popup>\n  <wego-confirm-popup #confirmModal [popupMsg]=\"deleteMessage\" (onConfirm)=\"ConfirmSuccessClick()\" (onReject)=\"HideConfirmModal()\"></wego-confirm-popup>\n  <wego-success-popup #updateSuccessPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmUpdateSuccessPopup()\"></wego-success-popup>\n  <wego-booking-expense-popup #bookingExpenseModel (OnSuccessSave)=\"SuccessSave($event.SuccessMessage)\" [BookingInfoModel]=\"model\"\n    [BookingHashId]=\"bookingHashId\"></wego-booking-expense-popup>\n  <wego-image-popup #receiptImagePopup></wego-image-popup>\n  <wego-free-booking-popup #freebookingModal (OnSuccessSave)=\"SuccessSave($event.SuccessMessage)\"></wego-free-booking-popup>";

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var booking_information_model_1 = __webpack_require__(705);
	var auth_service_1 = __webpack_require__(58);
	var translate_service_1 = __webpack_require__(70);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var booking_service_1 = __webpack_require__(556);
	var config_1 = __webpack_require__(60);
	var common_1 = __webpack_require__(22);
	var moment = __webpack_require__(84);
	var DriverBookingInformationComponent = (function () {
	    function DriverBookingInformationComponent(authService, bookingService, router, translate, activeRoute, locationService) {
	        this.authService = authService;
	        this.bookingService = bookingService;
	        this.router = router;
	        this.translate = translate;
	        this.activeRoute = activeRoute;
	        this.locationService = locationService;
	        this.retrieveVehicleInfo = false;
	    }
	    DriverBookingInformationComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.model = new booking_information_model_1.BookingInformation();
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlBooking = this.authService.GetURL(config_1.ApplicationRouteURL.URL_BOOKING);
	        this.urlBookingOverView = this.authService.GetURL(config_1.ApplicationRouteURL.URL_BOOKING_OVERVIEW);
	        this.sub = this.activeRoute.params.subscribe(function (params) {
	            _this.bookingHashId = params['bookingHashId'] || '';
	            if (_this.bookingHashId != '') {
	                _this.GetBookingInformation();
	            }
	        });
	    };
	    DriverBookingInformationComponent.prototype.GetBookingInformation = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.bookingService
	            .GetBookingInformationByHashId(this.bookingHashId, 'page1')
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.model = res.data;
	                _this.isLoading = false;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    DriverBookingInformationComponent.prototype.OnBackClick = function () {
	        this.locationService.back();
	    };
	    DriverBookingInformationComponent.prototype.GetImageURL = function (imagePath) {
	        return config_1.WeGoConfig.API_SERVER_URL + imagePath;
	    };
	    DriverBookingInformationComponent.prototype.GroupByCategory = function (vehicleAttributeList) {
	        if (vehicleAttributeList) {
	            var prop_1 = 'vehicleAttributeCategoryName';
	            return vehicleAttributeList.reduce(function (groups, item) {
	                var val = item[prop_1];
	                groups[val] = groups[val] || [];
	                groups[val].push(item);
	                groups[val] = groups[val].sort(function (obj1, obj2) {
	                    if (obj1.attributeName > obj2.attributeName) {
	                        return 1;
	                    }
	                    if (obj1.attributeName < obj2.attributeName) {
	                        return -1;
	                    }
	                    return 0;
	                });
	                return groups;
	            }, {});
	        }
	        else {
	            return {};
	        }
	    };
	    DriverBookingInformationComponent.prototype.ConfirmSuccessPopup = function () {
	        this.router.navigate([this.urlBookingOverView]);
	    };
	    DriverBookingInformationComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    DriverBookingInformationComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    DriverBookingInformationComponent.prototype.KeyOfObject = function (obj) {
	        return Object.keys(obj);
	    };
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], DriverBookingInformationComponent.prototype, "successPopup", void 0);
	    DriverBookingInformationComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-driver-bookinginformation',
	            template: __webpack_require__(712),
	            styles: [
	                "\n      span.label.label-default {\n        font-size: 13px;\n        line-height: 35px;\n        background-color: #eeeeee;\n        color: #2ba2aa;\n        margin-right: 5px;\n      }\n\n      span.label.label-default.text-success {\n        color: #3c763d;\n      }\n\n      span.label.label-default.text-danger {\n        color: #a94442;\n      }\n\n      .invoice_longcols {\n        padding-right: 0px;\n      }\n    "
	            ],
	            providers: [booking_service_1.BookingService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof booking_service_1.BookingService !== 'undefined' && booking_service_1.BookingService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object, (typeof (_e = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _e) || Object, (typeof (_f = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _f) || Object])
	    ], DriverBookingInformationComponent);
	    return DriverBookingInformationComponent;
	    var _a, _b, _c, _d, _e, _f;
	}());
	exports.DriverBookingInformationComponent = DriverBookingInformationComponent;


/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<section class=\"banner-img-in\">\r\n  <div class=\"banner-in\">\r\n    <div class=\"search-bg-in\">\r\n      <div class=\"container-fluid\">\r\n        <div class=\"row\" style=\"padding-right:15px;\">\r\n          <div class=\"col-md-3 col-sm-6\">\r\n            <h2 class=\"pagename\">{{ 'LblOverview' | translate }}</h2>\r\n          </div>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n<div>\r\n  <div class=\"clearfix\"></div>\r\n  <br/>\r\n  <section>\r\n    <div class=\"container-fluid\" style=\"word-break: break-all;\">\r\n      <div class=\"row\">\r\n        <div class=\"col-md-5\">\r\n          <div class=\"row\">\r\n            <!--Driver Information-->\r\n            <!-- <div class=\"col-md-12\">\r\n              <div class=\"hp-listing\">\r\n                <div class=\"list-box\" style=\"padding: 25px;\">\r\n                  <div class=\"media\">\r\n                    <div class=\"media-body\">\r\n                      <fieldset>\r\n                        <legend class=\"legendStyle\">\r\n                          {{ 'LblDriverDetail' | translate }}\r\n                        </legend>\r\n                        <div class=\"clearfix\"></div>\r\n                        <div class=\"row\">\r\n                          <div *ngIf=\"model.licenceNumber\" class=\"col-sm-6\">\r\n                            <label>{{ 'LblLicenceNumber' | translate }} :</label> {{ model.licenceNumber }}\r\n                          </div>\r\n                          <div *ngIf=\"model.driverName\" class=\"col-sm-6\">\r\n                            <label>{{ 'LblDriverName' | translate }} :</label> {{ model.driverName }}\r\n                          </div>\r\n                          <div *ngIf=\"model.email\" class=\"col-sm-6\">\r\n                            <label>{{ 'LblEmail' | translate }} :</label> {{ model.email }}\r\n                          </div>\r\n                          <div *ngIf=\"model.sharedVehicleGroup\" class=\"col-sm-6\">\r\n                            <label>{{ 'LblSharedVehicleGroup' | translate }} :</label> {{ model.sharedVehicleGroup }}\r\n                          </div>\r\n                          <div *ngIf=\"model.organizationName\" class=\"col-sm-6\">\r\n                            <label>{{ 'LblOrganization' | translate }} :</label> {{ model.organizationName }}\r\n                          </div>\r\n                        </div>\r\n                      </fieldset>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div> -->\r\n\r\n            <!--Booking Information-->\r\n            <div class=\"col-md-12\">\r\n              <div class=\"hp-listing\">\r\n                <div class=\"list-box\" style=\"padding: 25px;\">\r\n                  <div class=\"media\">\r\n                    <div class=\"media-body\">\r\n                      <fieldset>\r\n                        <legend class=\"legendStyle\">\r\n                          {{ 'LblBookingDetail' | translate }}\r\n                        </legend>\r\n                        <div class=\"clearfix\"></div>\r\n                        <div class=\"row\">\r\n                          <div class=\"col-sm-4\">\r\n                            <strong>{{ 'LblBookingReferenceId' | translate }} :</strong>\r\n                          </div>\r\n                          <div class=\"col-sm-8\">\r\n                            {{ model.bookingReferenceID }}\r\n                          </div>\r\n                        </div>\r\n                        <div *ngIf=\"model.recurringID\" class=\"row\">\r\n                          <div class=\"col-sm-4\">\r\n                            <strong>{{ 'LblRecurringId' | translate }} :</strong>\r\n                          </div>\r\n                          <div class=\"col-sm-8\">\r\n                            {{ model.recurringID }}\r\n                          </div>\r\n                        </div>\r\n                        <div class=\"row\">\r\n                          <div class=\"col-sm-4\">\r\n                            <strong>{{ 'LblFrom' | translate }} :</strong>\r\n                          </div>\r\n                          <div class=\"col-sm-8\">\r\n                            {{ model.startDateTime }}\r\n                          </div>\r\n                        </div>\r\n                        <div class=\"row\">\r\n                          <div class=\"col-sm-4\">\r\n                            <strong>{{ 'LblTo' | translate }} :</strong>\r\n                          </div>\r\n                          <div class=\"col-sm-8\">\r\n                            {{ model.endDateTime }}\r\n                          </div>\r\n                        </div>\r\n                        <div class=\"row\">\r\n                          <div class=\"col-sm-4\">\r\n                            <strong>{{ 'LblBookingStatus' | translate }} :</strong>\r\n                          </div>\r\n                          <div class=\"col-sm-8\">\r\n                            {{ model.translatedBookingStatus }}\r\n                          </div>\r\n                        </div>\r\n                        <div *ngIf=\"model.adminRemarks\" class=\"row\">\r\n                          <div class=\"col-sm-4\">\r\n                            <strong>{{ 'LblAdminRemarks' | translate }} :</strong>\r\n                          </div>\r\n                          <div class=\"col-sm-8\">\r\n                            {{ model.adminRemarks }}\r\n                          </div>\r\n                        </div>\r\n                        <div *ngIf=\"model.driverRemarks\" class=\"row\">\r\n                          <div class=\"col-sm-4\">\r\n                            <strong>{{ 'LblDriverRemarks' | translate }} :</strong>\r\n                          </div>\r\n                          <div class=\"col-sm-8\">\r\n                            {{ model.driverRemarks }}\r\n                          </div>\r\n                        </div>\r\n                        <div *ngIf=\"model.bookingRemarks\" class=\"row\">\r\n                          <div class=\"col-sm-4\">\r\n                            <strong>{{ 'LblBookingRemarks' | translate }} :</strong>\r\n                          </div>\r\n                          <div class=\"col-sm-8\">\r\n                            {{ model.bookingRemarks }}\r\n                          </div>\r\n                        </div>\r\n                        <div *ngIf=\"model.pickupAddress\" class=\"row\">\r\n                          <div class=\"col-sm-4\">\r\n                            <strong>{{ 'LblPickupLocation' | translate }} :</strong>\r\n                          </div>\r\n                          <div class=\"col-sm-8\">\r\n                            {{ model.pickupAddress }}\r\n                          </div>\r\n                        </div>\r\n                      </fieldset>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <!--Booking Trip Detail-->\r\n            <!-- <div class=\"col-md-12\" *ngIf=\"model.bookingType == 'NORMAL' && model.listOfBookingTrip && model.listOfBookingTrip.length > 0\">\r\n              <div class=\"hp-listing\">\r\n                <div class=\"list-box\" style=\"padding: 25px;\">\r\n                  <div class=\"media\">\r\n                    <div class=\"media-body\">\r\n                      <fieldset>\r\n                        <legend class=\"legendStyle\">\r\n                          {{ 'LblBookingTripDetail' | translate }}\r\n                        </legend>\r\n                        <div class=\"clearfix\"></div>\r\n                        <div class=\"table table-responsive mar_bot_ziro borderless\">\r\n                          <table class=\"table table-bordered mar_bot_ziro\">\r\n                            <thead>\r\n                              <tr>\r\n                                <th>\r\n                                  {{ 'LblContractTypeGroup' | translate }}\r\n                                </th>\r\n                                <th>\r\n                                  {{ 'LblStartDateTime' | translate }}\r\n                                </th>\r\n                                <th>\r\n                                  {{ 'LblEndDateTime' | translate }}\r\n                                </th>\r\n                                <th>\r\n                                  {{ 'LblDistance' | translate }}\r\n                                </th>\r\n                              </tr>\r\n                            </thead>\r\n                            <tbody>\r\n                              <tr *ngFor=\"let bookingTrip of model.listOfBookingTrip\">\r\n                                <td>{{ bookingTrip.contractTypeGroup }}</td>\r\n                                <td>{{ bookingTrip.startDateTime }}</td>\r\n                                <td>{{ bookingTrip.endDateTime }}</td>\r\n                                <td>{{ bookingTrip.distance }}</td>\r\n                              </tr>\r\n                            </tbody>\r\n                          </table>\r\n                        </div>\r\n                      </fieldset>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div> -->\r\n\r\n            <!--Booking Expense Detail-->\r\n            <div class=\"col-md-12\" *ngIf=\"model.bookingType == 'NORMAL' && model.listOfBookingExpense && model.listOfBookingExpense.length > 0\">\r\n              <div class=\"hp-listing\">\r\n                <div class=\"list-box\" style=\"padding: 25px;\">\r\n                  <div class=\"media\">\r\n                    <div class=\"media-body\">\r\n                      <fieldset>\r\n                        <legend class=\"legendStyle\">\r\n                          {{ 'LblBookingExpenseDetail' | translate }}\r\n                        </legend>\r\n                        <div class=\"clearfix\"></div>\r\n                        <div class=\"table table-responsive mar_bot_ziro borderless\">\r\n                          <table class=\"table table-bordered mar_bot_ziro\">\r\n                            <thead>\r\n                              <tr>\r\n                                <th> {{ 'LblExpenseName' | translate }}</th>\r\n                                <th> {{ 'LblExpenseAmount' | translate }}</th>\r\n                                <th> {{ 'LblDescription' | translate }}</th>\r\n                              </tr>\r\n                            </thead>\r\n                            <tbody>\r\n                              <tr *ngFor=\"let bookingExpense of model.listOfBookingExpense\">\r\n                                <td> {{bookingExpense.expenseName}} </td>\r\n                                <td>\r\n                                  {{ bookingExpense.amountFormat | currencyFormatter : bookingExpense.currencySymbol : bookingExpense.isCurrencySymbolBefore}}\r\n                                </td>\r\n                                <td> {{bookingExpense.description}} </td>\r\n                              </tr>\r\n                            </tbody>\r\n                          </table>\r\n                        </div>\r\n                      </fieldset>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"col-md-7\">\r\n          <!--Vehicle Information-->\r\n          <div class=\"hp-listing\">\r\n            <div class=\"list-box\" style=\"padding: 25px;\">\r\n              <div class=\"media\">\r\n                <fieldset>\r\n                  <legend class=\"legendStyle\">\r\n                    {{ 'LblVehicleDetail' | translate }}\r\n                  </legend>\r\n                  <div class=\"clearfix\"></div>\r\n                  <div class=\"media-left\">\r\n                    <img *ngIf=\"model.vehicleImagePath\" class=\"media-object\" [src]=\"GetImageURL(model.vehicleImagePath)\" style=\"max-width: 150px;  max-height: 100px;\">\r\n                    <img *ngIf=\"!model.vehicleImagePath\" class=\"media-object\" src=\"" + __webpack_require__(564) + "\" alt=\"No\"\r\n                      style=\"max-width: 150px;  max-height: 100px;\">\r\n                  </div>\r\n                  <div class=\"media-body\">\r\n                    <div class=\"row\">\r\n                      <div class=\"col-md-12\">\r\n                        <div class=\"row\">\r\n                          <div class=\"col-sm-4\">\r\n                            <strong>{{ 'LblLicenceTag' | translate }} :</strong>\r\n                          </div>\r\n                          <div class=\"col-sm-8\">\r\n                            {{ model.licenceTag }}\r\n                          </div>\r\n                        </div>\r\n                        <div *ngIf=\"model.brand\" class=\"row\">\r\n                          <div class=\"col-sm-4\">\r\n                            <strong>{{ 'LblBrand' | translate }} :</strong>\r\n                          </div>\r\n                          <div class=\"col-sm-8\">\r\n                            {{ model.brand }}\r\n                          </div>\r\n                        </div>\r\n                        <div *ngIf=\"model.color\" class=\"row\">\r\n                          <div class=\"col-sm-4\">\r\n                            <strong>{{ 'LblColor' | translate }} :</strong>\r\n                          </div>\r\n                          <div class=\"col-sm-8\">\r\n                            {{ model.color }}\r\n                          </div>\r\n                        </div>\r\n                        <div *ngIf=\"model.vehicleClass\" class=\"row\">\r\n                          <div class=\"col-sm-4\">\r\n                            <strong>{{ 'LblVehicleClass' | translate }} :</strong>\r\n                          </div>\r\n                          <div class=\"col-sm-8\">\r\n                            {{ model.vehicleClass }}\r\n                          </div>\r\n                        </div>\r\n                        <div *ngIf=\"model.pricingCategory\" class=\"row\">\r\n                          <div class=\"col-sm-4\">\r\n                            <strong>{{ 'LblBrand' | translate }} :</strong>\r\n                          </div>\r\n                          <div class=\"col-sm-8\">\r\n                            {{ model.pricingCategory }}\r\n                          </div>\r\n                        </div>\r\n                        <div *ngIf=\"model.bodyStyle\" class=\"row\">\r\n                          <div class=\"col-sm-4\">\r\n                            <strong>{{ 'LblBodyStyle' | translate }} :</strong>\r\n                          </div>\r\n                          <div class=\"col-sm-8\">\r\n                            {{ model.bodyStyle }}\r\n                          </div>\r\n                        </div>\r\n                        <div *ngIf=\"model.fuelType\" class=\"row\">\r\n                          <div class=\"col-sm-4\">\r\n                            <strong>{{ 'LblFuelType' | translate }} :</strong>\r\n                          </div>\r\n                          <div class=\"col-sm-8\">\r\n                            {{ model.fuelType }}\r\n                          </div>\r\n                        </div>\r\n                      </div>\r\n                      <div class=\"clearfix\"></div>\r\n                      <div class=\"col-sm-12\" *ngFor=\"let cat of KeyOfObject(GroupByCategory(model.attributeList))\">\r\n                        <label>{{ cat }} : </label>\r\n                        <span *ngFor=\"let attribute of GroupByCategory(model.attributeList)[cat]\" class=\"label label-default\">\r\n                          <i class=\"fa fa-tag fa-lg\" aria-hidden=\"true\"></i>&nbsp;{{ attribute.attributeName }}\r\n                        </span>\r\n                      </div>\r\n                      <!-- <div class=\"col-sm-12\">\r\n                        <span *ngIf=\"model.airco\" class=\"label label-default\">\r\n                          <i class=\"fa fa-tag fa-lg\" aria-hidden=\"true\"></i>\r\n                          &nbsp;{{ 'LblAirco' | translate }}\r\n                        </span>\r\n                        <span *ngIf=\"model.towbar\" class=\"label label-default\">\r\n                          <i class=\"fa fa-tag fa-lg\" aria-hidden=\"true\"></i>\r\n                          &nbsp;{{ 'LblTowbar' | translate }}\r\n                        </span>\r\n                      </div> -->\r\n\r\n                    </div>\r\n                  </div>\r\n                </fieldset>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <!--Invoice Details-->\r\n\r\n          <!-- <div *ngIf=\"model.bookingType == 'NORMAL' && (model.invoiceDetail?.status=='CALCULATED'||model.invoiceDetail?.status=='SENT')\"\r\n            class=\"hp-listing\">\r\n            <div class=\"list-box\" style=\"padding: 25px;\">\r\n              <div class=\"media\">\r\n                <div class=\"media-body\">\r\n                  <fieldset>\r\n                    <legend class=\"legendStyle\">\r\n                      {{ 'LblInvoiceDetail' | translate }}\r\n                    </legend>\r\n                    <div class=\"clearfix\"></div>\r\n                    <div class=\"row\" *ngIf=\"model.invoiceDetail?.invoiceNumber\">\r\n                      <div class=\"col-sm-3\">\r\n                        <strong>{{ 'LblInvoiceNumber' | translate }} :</strong>\r\n                      </div>\r\n                      <div class=\"col-sm-3\">\r\n                        {{ model.invoiceDetail?.invoiceNumber }}\r\n                      </div>\r\n                      <div class=\"col-sm-3 invoice_longcols\">\r\n                        <strong>{{ 'LblInvoiceDateTime' | translate }} :</strong>\r\n                      </div>\r\n                      <div class=\"col-sm-3\">\r\n                        {{ model.invoiceDetail?.invoiceDate }}\r\n                      </div>\r\n                    </div>\r\n                    <div class=\"row\">\r\n                      <div class=\"col-sm-3\">\r\n                        <strong>{{ 'LblDriveHours' | translate }} :</strong>\r\n                      </div>\r\n                      <div class=\"col-sm-3\">\r\n                        {{ model.invoiceDetail?.totalHoursFormat }}\r\n                      </div>\r\n                      <div class=\"col-sm-3 invoice_longcols\">\r\n                        <strong>{{ 'LblDistance' | translate }} ({{ 'LblKilometers' | translate }}) :</strong>\r\n                      </div>\r\n                      <div class=\"col-sm-3\">\r\n                        {{ model.invoiceDetail?.totalKm }}\r\n                      </div>\r\n                    </div>\r\n                    <div class=\"row\">\r\n                      <div class=\"col-sm-3\">\r\n                        <strong>{{ 'LblFreeHours' | translate }} :</strong>\r\n                      </div>\r\n                      <div class=\"col-sm-3\">\r\n                        {{ model.invoiceDetail?.freeHoursFormat }}\r\n                      </div>\r\n                      <div class=\"col-sm-3 invoice_longcols\">\r\n                        <strong>{{ 'LblFreeKilometer' | translate }} :</strong>\r\n                      </div>\r\n                      <div class=\"col-sm-3\">\r\n                        {{ model.invoiceDetail?.freeKm }}\r\n                      </div>\r\n                    </div>\r\n                    <div class=\"row\">\r\n                      <div class=\"col-sm-3\">\r\n                        <strong>{{ 'LblAdditional' | translate }} {{ 'LblFreeHours' | translate }} :</strong>\r\n                      </div>\r\n                      <div class=\"col-sm-3\">\r\n                        {{ model.invoiceDetail?.additionalFreeHoursFormat }}\r\n                      </div>\r\n                      <div class=\"col-sm-3 invoice_longcols\">\r\n                        <strong>{{ 'LblAdditional' | translate }} {{ 'LblFreeKilometer' | translate }} :</strong>\r\n                      </div>\r\n                      <div class=\"col-sm-3\">\r\n                        {{ model.invoiceDetail?.additionalFreeKm }}\r\n                      </div>\r\n                    </div>\r\n                    <div class=\"row\">\r\n                      <div class=\"col-sm-3\">\r\n                        <strong>{{ 'LblHourlyRate' | translate }} :</strong>\r\n                      </div>\r\n                      <div class=\"col-sm-3\">\r\n                        {{ model.invoiceDetail?.hourlyRate | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\r\n                      </div>\r\n                      <div class=\"col-sm-3 invoice_longcols\">\r\n                        <strong>{{ 'LblMileageRate' | translate }} :</strong>\r\n                      </div>\r\n                      <div class=\"col-sm-3\">\r\n                        {{ model.invoiceDetail?.mileageRate | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\r\n                      </div>\r\n                    </div>\r\n                    <div class=\"row\">\r\n                      <div class=\"col-sm-3\">\r\n                        <strong>{{ 'LblFixedFee' | translate }} :</strong>\r\n                      </div>\r\n                      <div class=\"col-sm-3\">\r\n                        {{ model.invoiceDetail?.fixedFree | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\r\n                      </div>\r\n                      <div *ngIf=\"model.invoiceDetail && model.invoiceDetail?.processingFree>0\" class=\"col-sm-3 invoice_longcols\">\r\n                        <strong>{{ 'LblProcessingFee' | translate }} :</strong>\r\n                      </div>\r\n                      <div *ngIf=\"model.invoiceDetail && model.invoiceDetail?.processingFree>0\" class=\"col-sm-3\">\r\n                        {{ model.invoiceDetail?.processingFree | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\r\n                      </div>\r\n                    </div>\r\n                    <div class=\"row\">\r\n                      <div *ngIf=\"model.invoiceDetail && model.invoiceDetail?.plateFormCostUsage>0\" class=\"col-sm-3\">\r\n                        <strong>{{ 'LblPlateformUsageCost' | translate }} :</strong>\r\n                      </div>\r\n                      <div *ngIf=\"model.invoiceDetail && model.invoiceDetail?.plateFormCostUsage>0\" class=\"col-sm-3\">\r\n                        {{ model.invoiceDetail?.plateFormCostUsage | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\r\n                      </div>\r\n                      <div class=\"col-sm-3 invoice_longcols\">\r\n                        <strong>{{ 'LblVat' | translate }} :</strong>\r\n                      </div>\r\n                      <div class=\"col-sm-3\">\r\n                        {{ model.invoiceDetail?.vat | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\r\n                      </div>\r\n                    </div>\r\n                    <div class=\"row\">\r\n                      <div class=\"col-sm-3\">\r\n                        <strong>{{ 'LblPenaltyRate' | translate }} :</strong>\r\n                      </div>\r\n                      <div class=\"col-sm-3\">\r\n                        {{ model.invoiceDetail?.penaltyRate | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\r\n                      </div>\r\n                      <div class=\"col-sm-3\">\r\n                        <strong>{{ 'LblTotal' | translate }} :</strong>\r\n                      </div>\r\n                      <div *ngIf=\"model.bookingCustomFee == null\" class=\"col-sm-3\">\r\n                        {{ model.invoiceDetail?.grandTotal | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\r\n                      </div>\r\n                      <div *ngIf=\"model.bookingCustomFee != null\" class=\"col-sm-3\">\r\n                        <del>\r\n                          {{ model.invoiceDetail?.grandTotal | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\r\n                        </del>\r\n                        {{ model.bookingCustomFee | currencyFormatter : model.invoiceDetail?.currencySymbol : model.invoiceDetail?.isCurrencySymbolBefore}}\r\n                      </div>\r\n                    </div>\r\n                  </fieldset>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div> -->\r\n        </div>\r\n      </div>\r\n      <hr>\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <a class=\"btn btn-gray cursor-pointer btn-md mar-right-5\" (click)=\"OnBackClick()\">{{ 'LblBack' | translate }}</a> &nbsp;&nbsp;\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n\r\n  <wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n  <wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>";

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var booking_service_1 = __webpack_require__(556);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var SelectVehiclePopupComponent = (function () {
	    function SelectVehiclePopupComponent(bookingService, authService, router, translate) {
	        this.bookingService = bookingService;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.onSuccessSelect = new core_1.EventEmitter();
	    }
	    SelectVehiclePopupComponent.prototype.ngOnInit = function () {
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.searchField = ["licenceTag"];
	    };
	    SelectVehiclePopupComponent.prototype.ngOnChanges = function (change) {
	        console.log(change);
	    };
	    SelectVehiclePopupComponent.prototype.show = function () {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.sortType = "";
	        this.DataListModel.sortReverse = null;
	        this.DataListModel.searchTerm = "";
	        this.DataListModel.infoMessage = "";
	        this.GetVehicleList();
	        this.vehicleModal.show();
	    };
	    SelectVehiclePopupComponent.prototype.hide = function () {
	        this.vehicleModal.hide();
	    };
	    SelectVehiclePopupComponent.prototype.GetVehicleList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.bookingService.GetVehicleList(this.DataListModel)
	            .subscribe(function (res) {
	            _this.vehicleList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SelectVehiclePopupComponent.prototype.select = function (vehicle) {
	        this.isLoading = true;
	        this.onSuccessSelect.emit({ VehicleMasterHashID: vehicle.vehicleMasterHashId, LicenceTage: vehicle.licenceTag, OwnerCompanyHashId: vehicle.ownerCompanyHashID });
	        this.isLoading = false;
	        this.hide();
	    };
	    SelectVehiclePopupComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetVehicleList();
	    };
	    SelectVehiclePopupComponent.prototype.OnSearch = function (event) {
	        this.DataListModel.searchTerm = event.searchTerm;
	        this.DataListModel.currentPage = 1;
	        this.GetVehicleList();
	    };
	    SelectVehiclePopupComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetVehicleList();
	    };
	    ;
	    SelectVehiclePopupComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetVehicleList();
	    };
	    SelectVehiclePopupComponent.prototype.OnSuccessSelect = function () {
	    };
	    __decorate([
	        core_1.Output('OnSuccessSelect'), 
	        __metadata('design:type', Object)
	    ], SelectVehiclePopupComponent.prototype, "onSuccessSelect", void 0);
	    __decorate([
	        core_1.ViewChild('vehicleModal'), 
	        __metadata('design:type', Object)
	    ], SelectVehiclePopupComponent.prototype, "vehicleModal", void 0);
	    SelectVehiclePopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-select-vehicle-popup',
	            template: __webpack_require__(714),
	            providers: [booking_service_1.BookingService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof booking_service_1.BookingService !== 'undefined' && booking_service_1.BookingService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object])
	    ], SelectVehiclePopupComponent);
	    return SelectVehiclePopupComponent;
	    var _a, _b, _c, _d;
	}());
	exports.SelectVehiclePopupComponent = SelectVehiclePopupComponent;


/***/ },
/* 714 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #vehicleModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n                    <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblSelect' | translate }} {{ 'LblVehicle' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <wego-search-list [IsExported]=\"false\" [SearchTerm]=\"DataListModel.searchTerm\" (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center\">\r\n                  {{ 'LblSelect' | translate }}\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('licenceTag')\">\r\n                  {{ 'LblLicenceTag' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'licenceTag'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('ownerName')\">\r\n                  {{ 'LblVehicleOwner' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'ownerName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('brand')\">\r\n                  {{ 'LblBrand' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'brand'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('type')\">\r\n                  {{ 'LblType' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'type'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('vehicleClass')\">\r\n                  {{ 'LblVehicleClass' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'vehicleClass'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('color')\">\r\n                  {{ 'LblColor' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'color'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let vehicle of vehicleList\">\r\n                  <td class=\"text-center\">\r\n                    <a class=\"cursor-pointer\" (click)=\"select(vehicle)\">\r\n                      <i class=\"fa fa-plus-square\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td>{{ vehicle.licenceTag }}</td>\r\n                  <td>{{vehicle.ownerName}}</td>\r\n                  <td>{{vehicle.brand}}</td>\r\n                  <td>{{vehicle.type}}</td>\r\n                  <td>{{vehicle.vehicleClass}}</td>\r\n                  <td>{{vehicle.color}}</td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0\">\r\n                <td class=\"text-center text-danger\" colspan=\"10\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\" [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\"\r\n                firstText=\"&laquo;\" lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var flatpickr_model_1 = __webpack_require__(83);
	var booking_service_1 = __webpack_require__(556);
	var translate_service_1 = __webpack_require__(70);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var special_booking_model_1 = __webpack_require__(716);
	var auth_service_1 = __webpack_require__(58);
	var moment = __webpack_require__(84);
	var SpecialBookingComponent = (function () {
	    function SpecialBookingComponent(bookigService, translate, authService, router) {
	        this.bookigService = bookigService;
	        this.translate = translate;
	        this.authService = authService;
	        this.router = router;
	        this.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
	        this.isInit = true;
	        this.isConfirmBooking = true;
	    }
	    SpecialBookingComponent.prototype.ngOnInit = function () {
	        this.module = this.translate.instant('LblSpecialBooking');
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.initiateModel();
	    };
	    SpecialBookingComponent.prototype.initiateModel = function () {
	        this.specialBookingTypeList = [
	            {
	                Key: 'MAINTENANCE',
	                Value: 'MAINTENANCE'
	            },
	            {
	                Key: 'UNAVAILABLE',
	                Value: 'UNAVAILABLE'
	            }
	        ];
	        this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigEnd = this.SetDefaultFlatPickrConfig();
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.searchField = ["bookingReferenceID", "driverName"];
	        this.model = new special_booking_model_1.SpecialBookingModel();
	        // this.model.startDateTime = moment().add('m', 5).format('DD-MM-YYYY HH:mm');
	        // this.model.endDateTime = moment().add('H', 1).add('m', 5).format('DD-MM-YYYY HH:mm');
	        this.model.specialBookingType = this.specialBookingTypeList[0].Value;
	        this.searchModel = new special_booking_model_1.SpecialBookingModel();
	        console.log(this.DataListModel);
	    };
	    SpecialBookingComponent.prototype.ResetPage = function () {
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.searchField = ["bookingReferenceID", "driverName"];
	        this.model = new special_booking_model_1.SpecialBookingModel();
	        // this.model.startDateTime = moment().add('m', 5).format('DD-MM-YYYY HH:mm');
	        // this.model.endDateTime = moment().add('H', 1).add('m', 5).format('DD-MM-YYYY HH:mm');
	        this.model.specialBookingType = this.specialBookingTypeList[0].Value;
	        this.searchModel = new special_booking_model_1.SpecialBookingModel();
	    };
	    SpecialBookingComponent.prototype.SetDefaultFlatPickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = true;
	        flatPickrConfig.time_24hr = true;
	        flatPickrConfig.minDate = new Date(new Date().setHours(0, 0, 0));
	        flatPickrConfig.dateFormat = this.dateFormat;
	        flatPickrConfig.minuteIncrement = 1;
	        return flatPickrConfig;
	    };
	    SpecialBookingComponent.prototype.onChangeSelectedBT = function (selectedField) {
	        this.model.specialBookingType = selectedField;
	        console.log(this.model.specialBookingType);
	    };
	    SpecialBookingComponent.prototype.OnConfirmBooking = function ($event) {
	        this.ShowChildModal();
	    };
	    SpecialBookingComponent.prototype.OnSearch = function (forms) {
	        console.log(this.model);
	        this.DataListModel.currentPage = 0;
	        Object.assign(this.searchModel, this.model);
	        console.log(this.DataListModel);
	        this.GetAffectedBookings();
	    };
	    SpecialBookingComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetAffectedBookings();
	    };
	    SpecialBookingComponent.prototype.OnSearchAffectedBooking = function (event) {
	        this.DataListModel.searchTerm = event.searchTerm;
	        this.DataListModel.currentPage = 0;
	        Object.assign(this.searchModel, this.model);
	        this.GetAffectedBookings();
	    };
	    SpecialBookingComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetAffectedBookings();
	    };
	    ;
	    SpecialBookingComponent.prototype.ShowChildModal = function () {
	        if (this.affectedBookingList != undefined) {
	            this.confirmMessage = this.translate.instant('LblSpecialBookingConfiramtionmsg');
	            ;
	            this.childModal.show();
	        }
	    };
	    SpecialBookingComponent.prototype.HideChildModal = function () {
	        this.affectedBookingMasterHashId = "";
	        this.model.adminRemarks = null;
	        this.model.isConfirmed = false;
	        this.isInit = true;
	        this.childModal.hide();
	    };
	    SpecialBookingComponent.prototype.SuccessModalClick = function () {
	        this.childModal.hide();
	    };
	    SpecialBookingComponent.prototype.MakeSpecialBooking = function () {
	        var _this = this;
	        this.bookigService.MakeSpecialBooking(this.model)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.DataListModel.currentPage = 1;
	                _this.HideChildModal();
	                _this.popupMsg = _this.translate.instant('LblRecordAddedSuccess', [_this.module]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    SpecialBookingComponent.prototype.SuccessSelectVehicleModal = function ($event) {
	        this.model.vehicleHashId = $event.VehicleMasterHashID;
	        this.model.licenceTag = $event.LicenceTage;
	        this.VehicleCompanyHashId = $event.OwnerCompanyHashId;
	        console.log(this.model);
	        console.log($event);
	    };
	    SpecialBookingComponent.prototype.SuccessSelectDriverModal = function ($event) {
	        this.model.driverHashId = $event.DriverHashID;
	        this.model.driverName = $event.DriverName;
	        this.GetSharedVehicleGroupList();
	    };
	    SpecialBookingComponent.prototype.GetSharedVehicleGroupList = function () {
	        var _this = this;
	        this.bookigService.GetSharedVehicleGroupListForSpecialBooking(this.model.driverHashId, this.VehicleCompanyHashId).subscribe(function (res) {
	            _this.sharedVehicleGroupList = res.data;
	            if (_this.sharedVehicleGroupList &&
	                _this.sharedVehicleGroupList.length == 1) {
	                _this.model.sharedVehicleGroupHashID = _this.sharedVehicleGroupList[0].keyHash;
	                _this.GetOrganizationList();
	            }
	            else {
	                _this.model.sharedVehicleGroupHashID = '';
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    SpecialBookingComponent.prototype.OnSharedVehicleGroupChange = function () {
	        this.GetOrganizationList();
	    };
	    SpecialBookingComponent.prototype.GetOrganizationList = function () {
	        var _this = this;
	        this.bookigService.GetOrganizationList(this.model.driverHashId, this.model.sharedVehicleGroupHashID).subscribe(function (res) {
	            _this.organizationList = res.data;
	            if (_this.organizationList &&
	                _this.organizationList.length == 1) {
	                _this.model.organizationHashID = _this.organizationList[0].organizationMasterHashId;
	            }
	            else {
	                _this.model.organizationHashID = '';
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    SpecialBookingComponent.prototype.GetAffectedBookings = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.bookigService.GetAffectedBookingList(this.searchModel, this.DataListModel)
	            .subscribe(function (res) {
	            if (!res.data) {
	                _this.errorModel = res.error;
	                _this.isLoading = false;
	            }
	            else {
	                _this.errorModel = null;
	                _this.affectedBookingList = res.data;
	                _this.DataListModel.totalItems = res.totalRecords;
	                _this.DataListModel.infoMessage = res.error;
	                _this.isInit = false;
	                _this.isConfirmBooking = res.status.isSpecialBookingExist ? false : true;
	                _this.isLoading = false;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SpecialBookingComponent.prototype.onSubmit = function (forms) {
	        var cancelAffectedBookingList;
	        cancelAffectedBookingList = this.affectedBookingList.map(function (x) { return x.bookingMasterHashId; });
	        this.model.affectedBookingList = cancelAffectedBookingList;
	        this.model.isConfirmed = true;
	        this.MakeSpecialBooking();
	    };
	    SpecialBookingComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    SpecialBookingComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    SpecialBookingComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	        this.ResetPage();
	    };
	    __decorate([
	        core_1.ViewChild('childModal'), 
	        __metadata('design:type', Object)
	    ], SpecialBookingComponent.prototype, "childModal", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], SpecialBookingComponent.prototype, "successPopup", void 0);
	    SpecialBookingComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-special-booking',
	            template: __webpack_require__(717),
	            providers: [booking_service_1.BookingService, translate_service_1.TranslateService],
	            styles: ["\n          .box-body{\n            padding: 0px 10px 10px;\n          }\n          .checkbox-inline{\n            padding-left: 0px !important;\n          }\n          .box-body{\n            padding:10px 10px 10px 10px;\n          }\n          .search\n          {\n            margin-top:5px;\n          }\n          "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof booking_service_1.BookingService !== 'undefined' && booking_service_1.BookingService) === 'function' && _a) || Object, (typeof (_b = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object])
	    ], SpecialBookingComponent);
	    return SpecialBookingComponent;
	    var _a, _b, _c, _d;
	}());
	exports.SpecialBookingComponent = SpecialBookingComponent;


/***/ },
/* 716 */
/***/ function(module, exports) {

	"use strict";
	var SpecialBookingModel = (function () {
	    function SpecialBookingModel() {
	        this.sharedVehicleGroupHashID = '';
	        this.isConfirmed = false;
	        this.isRecurring = false;
	        this.recurringPeriod = "DAILY";
	        this.organizationHashID = '';
	    }
	    return SpecialBookingModel;
	}());
	exports.SpecialBookingModel = SpecialBookingModel;


/***/ },
/* 717 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ 'LblSpecialBooking' | translate }}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li><a [routerLink]=\"urlDefaultPage\"><i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a></li>\r\n        <li class=\"active\">{{ 'LblSpecialBooking' | translate }}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <div class=\"box box-default\">\r\n          <div class=\"box-header with-border\">\r\n            <h3 class=\"box-title\">{{ 'LblSearch' | translate }} {{ 'LblAffectedBooking' | translate }}</h3>\r\n          </div>\r\n          <div class=\"box-body\" style=\"display: block;\">\r\n            <div class=\"row\">\r\n              <div class=\"col-sm-11\">\r\n                <form (ngSubmit)=\"OnSearch(searchForm.value)\" #searchForm=\"ngForm\">\r\n                  <div class=\"row\">\r\n                    <div class=\"form-group col-md-3\">\r\n                      <div class=\"form-group\">\r\n                        <label><span class=\"text text-danger\">*</span>{{ 'LblVehicle' | translate }}</label>\r\n                        <div class=\"input-group\">\r\n                          <input [(ngModel)]=\"model.licenceTag\" name=\"LicenceTag\" type=\"text\" class=\"form-control\"\r\n                            placeholder=\"{{ 'LblSelect' | translate }} {{ 'LblVehicle' | translate }}\" readonly>\r\n                          <div class=\"input-group-btn\">\r\n                            <button class=\"btn btn-default\" type=\"button\" (click)=\"selectVehicleModal.show()\"><i class=\"fa fa-plus\"\r\n                                aria-hidden=\"true\"></i></button>\r\n                          </div>\r\n                        </div>\r\n                        <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'VehicleHashId' }}</span>\r\n                      </div>\r\n\r\n                    </div>\r\n\r\n                    <div class=\"form-group col-md-3\">\r\n                      <label><span class=\"text text-danger\">*</span>{{ 'LblDriver' | translate }}</label>\r\n                      <div class=\"input-group\">\r\n                        <input [(ngModel)]=\"model.driverName\" name=\"driverName\" type=\"text\" class=\"form-control\"\r\n                          placeholder=\"{{ 'LblDriver' | translate }}\" readonly>\r\n                        <div class=\"input-group-btn\">\r\n                          <button class=\"btn btn-default\" type=\"button\" (click)=\"selectDriverModal.show()\">\r\n                            <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\r\n                          </button>\r\n                        </div>\r\n                      </div>\r\n                      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'driverHashId' }}</span>\r\n                    </div>\r\n\r\n                    <div class=\"form-group col-md-3\">\r\n                      <label>\r\n                        <span class=\"text text-danger\">*</span>{{ 'LblSharedVehicleGroup' | translate }}</label>\r\n                      <select [(ngModel)]=\"model.sharedVehicleGroupHashID\" class=\"form-control\" name=\"sharedVehicleGroupHashID\"\r\n                        (change)=\"OnSharedVehicleGroupChange()\">\r\n                        <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblSharedVehicleGroup' | translate }}</option>\r\n                        <option *ngFor=\"let item of sharedVehicleGroupList\" [ngValue]=\"item.keyHash\">{{\r\n                          item.value }}</option>\r\n                      </select>\r\n                      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'sharedVehicleGroupHashID' }}</span>\r\n                    </div>\r\n\r\n                    <div class=\"form-group col-md-3\">\r\n                      <label>\r\n                        <span class=\"text text-danger\">*</span>{{ 'LblOrganization' | translate }}</label>\r\n                      <select [(ngModel)]=\"model.organizationHashID\" class=\"form-control\" name=\"organizationHashId\">\r\n                        <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblOrganization' | translate }}</option>\r\n                        <option *ngFor=\"let item of organizationList\" [ngValue]=\"item.organizationMasterHashId\">{{\r\n                          item.organizationName }}</option>\r\n                      </select>\r\n                      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'organizationHashID' }}</span>\r\n                    </div>\r\n                    <div class=\"clearfix\"></div>\r\n                    <div class=\"form-group col-md-3\">\r\n                      <label><span class=\"text text-danger\">*</span>{{ 'LblSpecialBookingType' | translate }}</label>\r\n                      <select [(ngModel)]=\"model.specialBookingType\" name=\"specialBookingType\" class=\"form-control\">\r\n                        <option *ngFor=\"let item of specialBookingTypeList\" [ngValue]='item.Value'>{{item.Key}}</option>\r\n                      </select>\r\n                      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'SpecialBookingType' }}</span>\r\n                    </div>\r\n                    <!--<div class=\"clearfix\"></div>-->\r\n                    <div class=\"form-group col-md-3\">\r\n                      <div class=\"form-group\">\r\n\r\n                        <label><span class=\"text text-danger\">*</span>{{ 'LblBookingStartDateTime' | translate }}</label>\r\n                        <div class=\"input-group\">\r\n                          <span class=\"input-group-addon\"><i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i></span>\r\n                          <input flatpickr readonly [Config]=\"flatPickrConfigFrom\" [(ngModel)]=\"model.startDateTime\"\r\n                            name=\"startDateTime\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblBookingStartDateTime' | translate }}\">\r\n                        </div>\r\n                        <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'StartDateTime' }}</span>\r\n                      </div>\r\n                    </div>\r\n                    <div class=\"form-group col-md-3\">\r\n                      <div class=\"form-group\">\r\n                        <label><span class=\"text text-danger\">*</span>{{ 'LblBookingEndDateTime' | translate }}</label>\r\n                        <div class=\"input-group\">\r\n                          <span class=\"input-group-addon\"><i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i></span>\r\n                          <input flatpickr readonly [Config]=\"flatPickrConfigTo\" [(ngModel)]=\"model.endDateTime\" name=\"endDateTime\"\r\n                            type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblBookingEndDateTime' | translate }}\">\r\n                        </div>\r\n                        <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'EndDateTime' }}</span>\r\n                      </div>\r\n                    </div>\r\n\r\n                    <div class=\"form-group col-md-3\">\r\n                      <div class=\"form-group\">\r\n                        <label>{{ 'LblComment' | translate }}</label>\r\n                        <textarea class=\"form-control\" id=\"Comment\" [(ngModel)]=\"model.comment\" name=\"comment\"\r\n                          placeholder=\"{{'LblComment' | translate}}\" maxlength=\"200\"></textarea>\r\n                        <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'Comment' }}</span>\r\n                      </div>\r\n                    </div>\r\n\r\n                    <!-- <div class=\"form-group col-md-1\">\r\n                      <div class=\"input-group\">\r\n                        <label></label>                       \r\n                        <button class=\"btn btn-default search\" type=\"button\" (click)=\"OnSearch($event)\"><i class=\"fa fa-search\"\r\n                            aria-hidden=\"true\"></i></button>\r\n                      </div>\r\n                    </div> -->\r\n                    <div class=\"clearfix\"></div>\r\n                    <div class=\"form-group col-md-3\">\r\n                      <div class=\"checkbox\">\r\n                        <label><input [(ngModel)]=\"model.isRecurring\" type=\"checkbox\" name=\"isRecursive\">{{\r\n                          'LblRecurring' | translate }}</label>\r\n                      </div>\r\n                    </div>\r\n                    <template [ngIf]=\"model.isRecurring\">\r\n                      <div class=\"form-group col-md-3\">\r\n                        <div class=\"radio\"><label><input type=\"radio\" name=\"recurringPeriod\" [(ngModel)]=\"model.recurringPeriod\"\r\n                              value=\"DAILY\"> {{ 'LblDaily' | translate }}</label></div>\r\n                        <div class=\"radio\"><label><input type=\"radio\" name=\"recurringPeriod\" [(ngModel)]=\"model.recurringPeriod\"\r\n                              value=\"WEEKLY\"> {{ 'LblWeekly' | translate }}</label></div>\r\n                        <div class=\"radio\"><label><input type=\"radio\" name=\"recurringPeriod\" [(ngModel)]=\"model.recurringPeriod\"\r\n                              value=\"MONTHLY\"> {{ 'LblMonthly' | translate }}</label></div>\r\n                        <div class=\"clearfix\"></div><span class=\"text text-danger\">{{ errorModel | serverErrorMessage :\r\n                          'RecurringPeriod' }}</span>\r\n                      </div>\r\n                      <div class=\"form-group col-md-3\">\r\n                        <label><span class=\"text text-danger\">*</span>{{ 'LblEndDate' | translate }}</label>\r\n                        <div class=\"input-group\">\r\n                          <span class=\"input-group-addon\"><i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i></span>\r\n                          <input flatpickr readonly [Config]=\"flatPickrConfigEnd\" type=\"text\" [(ngModel)]=\"model.recurringEndDateTime\"\r\n                            name=\"recurringEndDateTime\" class=\"form-control\" placeholder=\"{{ 'LblEndDate' | translate }}\">\r\n                        </div>\r\n                        <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'RecurringEndDateTime' }}</span>\r\n                      </div>\r\n                    </template>\r\n                  \r\n                  </div>\r\n                </form>\r\n              </div>\r\n              <div class=\"col-sm-1\">\r\n                <div class=\"row\">\r\n                  <div class=\"form-group\">\r\n                    <div class=\"input-group\">\r\n                      <label></label>\r\n                      <div class=\"clearfix\"></div>\r\n                      <button class=\"btn btn-default search\" type=\"button\" (click)=\"OnSearch($event)\"><i class=\"fa fa-search\"\r\n                          aria-hidden=\"true\"></i></button>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <template [ngIf]=\"!isInit\">\r\n          <div class=\"row\">\r\n            <fieldset class=\"col-md-12\">\r\n              <legend class=\"legendStyle\">\r\n                <span class=\"text text-danger\"></span>{{ 'LblAffectedBooking' | translate }} {{ 'LblList' | translate\r\n                }}\r\n              </legend>\r\n              <div class=\"clearfix\"></div>\r\n              <div class=\"row\">\r\n                <div class=\"col-sm-12\">\r\n                  <wego-search-list [IsExported]=\"false\" [SearchTerm]=\"DataListModel.searchTerm\" (OnSearch)=\"OnSearchAffectedBooking($event)\"\r\n                    [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n                  <div class=\"table table-responsive mar_bot_ziro\">\r\n                    <table class=\"table table-bordered mar_bot_ziro\">\r\n                      <thead>\r\n                        <tr>\r\n                          <th class=\"cursor-pointer\" (click)=\"OnSort('bookingReferenceID')\">{{ 'LblBookingReferenceId'\r\n                            | translate }}\r\n                            <wego-sort-list [FieldName]=\"'bookingReferenceID'\" [SortType]=\"DataListModel.sortType\"\r\n                              [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                          </th>\r\n                          <th class=\"cursor-pointer\" (click)=\"OnSort('startDateTime')\">{{ 'LblBookingStartDateTime' |\r\n                            translate }}\r\n                            <wego-sort-list [FieldName]=\"'startDateTime'\" [SortType]=\"DataListModel.sortType\"\r\n                              [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                          </th>\r\n                          <th class=\"cursor-pointer\" (click)=\"OnSort('endDateTime')\"> {{ 'LblBookingEndDateTime' |\r\n                            translate }}\r\n                            <wego-sort-list [FieldName]=\"'endDateTime'\" [SortType]=\"DataListModel.sortType\"\r\n                              [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                          </th>\r\n                          <th class=\"cursor-pointer\" (click)=\"OnSort('driverName')\"> {{ 'LblDriverName' | translate }}\r\n                            <wego-sort-list [FieldName]=\"'driverName'\" [SortType]=\"DataListModel.sortType\"\r\n                              [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                          </th>\r\n                        </tr>\r\n                      </thead>\r\n                      <tbody>\r\n                        <template [ngIf]=\"DataListModel.totalItems != 0 && !isLoading\">\r\n                          <tr *ngFor=\"let booking of affectedBookingList\">\r\n                            <td>{{ booking.bookingReferenceID }} </td>\r\n                            <td>{{ booking.startDateTime }}</td>\r\n                            <td>{{ booking.endDateTime }}</td>\r\n                            <td>{{ booking.driverName }}</td>\r\n                          </tr>\r\n                        </template>\r\n                        <tr *ngIf=\"DataListModel.totalItems == 0\">\r\n                          <td class=\"text-center text-danger\" colspan=\"6\">\r\n                            {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                          </td>\r\n                        </tr>\r\n                      </tbody>\r\n                    </table>\r\n                  </div>\r\n                  <div class=\"clearfix\"></div>\r\n                </div>\r\n              </div>\r\n            </fieldset>\r\n          </div>\r\n\r\n          <div class=\"clearfix\"></div>\r\n          <hr />\r\n          <button class=\"btn btn-green\" [disabled]=\"!isConfirmBooking\" (click)=\"OnConfirmBooking($event)\">{{\r\n            'LblConfirmBooking' | translate }}</button>\r\n        </template>\r\n      </div>\r\n    </div>\r\n  </section>\r\n\r\n  <wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n  <div bsModal #childModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n    aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n    <div class=\"modal-dialog modal-sm\">\r\n      <div class=\"modal-content\">\r\n        <div class=\"modal-header\">\r\n          <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"HideChildModal()\">\r\n            <span aria-hidden=\"true\">&times;</span></button>\r\n          <h4 class=\"modal-title\">{{'LblConfirm' | translate}}</h4>\r\n        </div>\r\n        <form (ngSubmit)=\"onSubmit(ConfirmSpecialBookingForm.value)\" #ConfirmSpecialBookingForm=\"ngForm\">\r\n          <div class=\"modal-body\">\r\n            <div class=\"row\">\r\n              <div class=\"col-xs-12 form-group\">\r\n                {{ confirmMessage }}\r\n              </div>\r\n              <div class=\"col-xs-12 form-group\" *ngIf=\"!blockFlag\">\r\n                <textarea class=\"form-control\" id=\"AdminRemarks\" [(ngModel)]=\"model.adminRemarks\" name=\"adminRemark\"\r\n                  placeholder=\"Admin Remarks\"></textarea>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'AdminRemarks' }}</span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <div class=\"modal-footer\">\r\n            <button type=\"submit\" class=\"btn btn-green\">{{'LblYes' | translate}}</button>\r\n            <button type=\"button\" class=\"btn btn-gray cursor-pointer\" (click)=\"HideChildModal()\">{{'LblNo' |\r\n              translate}}</button>\r\n          </div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<wego-select-vehicle-popup #selectVehicleModal (OnSuccessSelect)=\"SuccessSelectVehicleModal($event)\"></wego-select-vehicle-popup>\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n<wego-select-driver-popup #selectDriverModal [CompanyHashId]=\"VehicleCompanyHashId\" (OnSuccessSelect)=\"SuccessSelectDriverModal($event)\"></wego-select-driver-popup>";

/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var translate_service_1 = __webpack_require__(70);
	var core_1 = __webpack_require__(3);
	var invoice_model_1 = __webpack_require__(719);
	var legacy_invoice_service_1 = __webpack_require__(720);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var jquery_helper_service_1 = __webpack_require__(67);
	var flatpickr_model_1 = __webpack_require__(83);
	var $ = __webpack_require__(68);
	var SlimSelect = __webpack_require__(616);
	var InvoiceLegacyListComponent = (function () {
	    function InvoiceLegacyListComponent(invoiceService, translate, authService, router, jQueryHelperService) {
	        this.invoiceService = invoiceService;
	        this.translate = translate;
	        this.authService = authService;
	        this.router = router;
	        this.jQueryHelperService = jQueryHelperService;
	        this.invoiceModel = new invoice_model_1.InvoiceModel();
	        this.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_FORMAT;
	        this.dateTimeFormat = config_1.WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
	        this.itemPerPageList = config_1.WeGoConfig.GRID_PAGGING;
	        this.selectedFormat = 'default';
	        this.LEGACY_API_BASE_URL = config_1.WeGoConfig.LEGACY_API_BASE_URL;
	    }
	    InvoiceLegacyListComponent.prototype.ngOnInit = function () {
	        this.module = this.translate.instant('LblBookingInvoice');
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = [
	            'translatedStatus',
	            'invoiceNumber',
	            'sharedVehicleGroup',
	            'addressee',
	            'invoiceType'
	        ];
	        this.InvoiceStatusAll = [
	            {
	                Key: this.translate.instant("LblOPEN"),
	                Value: 'OPEN'
	            },
	            {
	                Key: this.translate.instant("LblSENT"),
	                Value: 'SENT'
	            },
	            {
	                Key: this.translate.instant("LblCLOSED"),
	                Value: 'CLOSED'
	            },
	            {
	                Key: this.translate.instant("LblREQUESTFORPAYMENT"),
	                Value: 'REQUESTFORPAYMENT'
	            },
	            {
	                Key: this.translate.instant("LblREOPEN"),
	                Value: 'REOPEN'
	            }
	        ];
	        this.InvoiceStatus = this.InvoiceStatusAll;
	        this.invoiceModel.invoiceStatusList = this.InvoiceStatus.map(function (x) { return x.Value; });
	        this.invoiceModel.status = '';
	        //this.invoiceStatusSelect.set(this.invoiceModel.invoiceStatusList);
	        this.LblSelect = this.translate.instant('LblSelect');
	        this.LblStatus = this.translate.instant('LblStatus');
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlDriverInfo = this.authService.GetURL(config_1.ApplicationRouteURL.URL_PERSON_UPDATE);
	        this.urlOrganizationInfo = this.authService.GetURL(config_1.ApplicationRouteURL.URL_ORGANIZATION_UPDATE);
	        this.urlInvoice = this.authService.GetURL(config_1.ApplicationRouteURL.URL_INVOICE_UPDATE);
	        this.urlPaymentHistory = this.authService.GetURL(config_1.ApplicationRouteURL.URL_PAYMENT_HISTORY);
	        this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigDueDate = this.SetFlatPickrConfigForDueDate();
	        this.addInvoiceLink = new config_1.WeGoAuthorizedLink(this.urlInvoice, config_1.Permission.PR_INVOICE, config_1.PermissionType.INSERT, 'btn btn-highlight navbar-right', 'LblAddNew');
	        this.invoiceStatusUpdateModel = new invoice_model_1.InvoiceStatusUpdateModel();
	        if (this.itemPerPageList.indexOf(500) < 0) {
	            this.itemPerPageList.push(500);
	            this.itemPerPageList.push(1000);
	        }
	        this.GetIvoiceList();
	    };
	    InvoiceLegacyListComponent.prototype.ngAfterViewInit = function () {
	        this.RenderBookingStatus();
	        this.invoiceStatusSelect.set(this.invoiceModel.invoiceStatusList);
	    };
	    InvoiceLegacyListComponent.prototype.SetDefaultFlatPickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = false;
	        flatPickrConfig.time_24hr = true;
	        flatPickrConfig.dateFormat = this.dateFormat;
	        flatPickrConfig.minuteIncrement = 1;
	        return flatPickrConfig;
	    };
	    InvoiceLegacyListComponent.prototype.SetFlatPickrConfigForDueDate = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = false;
	        flatPickrConfig.minDate = new Date(new Date().setHours(0, 0, 0));
	        flatPickrConfig.dateFormat = this.dateTimeFormat;
	        flatPickrConfig.minuteIncrement = 1;
	        return flatPickrConfig;
	    };
	    InvoiceLegacyListComponent.prototype.ShowDeleteConfirmModal = function (invoiceHashId) {
	        this.isLoading = false;
	        this.deleteMessage = this.translate.instant('LblRecordDeleteConfirmation', [
	            this.module
	        ]);
	        this.deleteConfirmModal.show();
	        this.invoiceHashId = invoiceHashId;
	    };
	    InvoiceLegacyListComponent.prototype.HideDeleteConfirmModal = function () {
	        this.deleteConfirmModal.hide();
	    };
	    InvoiceLegacyListComponent.prototype.DeleteConfirmSuccessClick = function () {
	        this.deleteConfirmModal.hide();
	        this.DeleteInvoice();
	    };
	    InvoiceLegacyListComponent.prototype.DeleteInvoice = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.invoiceService.DeleteInvoice(this.invoiceHashId).subscribe(function (res) {
	            if (res.data) {
	                _this.DataListModel.currentPage = 1;
	                _this.GetIvoiceList();
	                _this.popupMsg = _this.translate.instant('LblRecordRemovedSuccess', [
	                    _this.module
	                ]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblInvoiceDeleteValidation');
	                _this.isLoading = false;
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    InvoiceLegacyListComponent.prototype.OnDateSearch = function () {
	        this.GetIvoiceList();
	    };
	    InvoiceLegacyListComponent.prototype.GetIvoiceList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.invoiceService
	            .GetInvoiceList(this.DataListModel, this.invoiceModel)
	            .subscribe(function (res) {
	            _this.invoiceList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.isLoading = false;
	            _this.errorModel = [];
	            if (typeof res.error == 'string') {
	                _this.DataListModel.infoMessage = res.error;
	            }
	            else if (res.error) {
	                _this.errorModel = res.error;
	                _this.DataListModel.infoMessage = _this.translate.instant('LblNoDataFound');
	            }
	            _this.IsDirectDebitEnabled();
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    InvoiceLegacyListComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetIvoiceList();
	    };
	    InvoiceLegacyListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetIvoiceList();
	    };
	    InvoiceLegacyListComponent.prototype.OnSearch = function (event) {
	        if (event.isReset) {
	            this.invoiceModel.startDateTime = '';
	            this.invoiceModel.endDateTime = '';
	        }
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetIvoiceList();
	    };
	    InvoiceLegacyListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetIvoiceList();
	    };
	    InvoiceLegacyListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.invoiceService
	            .ExportInvoiceList(this.DataListModel, this.invoiceModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = 'Invoice' + new Date().toISOString() + '.csv';
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    InvoiceLegacyListComponent.prototype.DownloadInvoice = function (invoiceNumber) {
	        var _this = this;
	        this.isLoading = true;
	        this.invoiceService.DownloadInvoice(invoiceNumber).subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = 'Invoice' + new Date().toISOString() + '.pdf';
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    InvoiceLegacyListComponent.prototype.DownloadOfflineInvoicePDF = function (invoiceNumber) {
	        var _this = this;
	        this.isLoading = true;
	        this.invoiceService.DownloadInvoicePDF(invoiceNumber).subscribe(function (res) {
	            if (res.data) {
	                var linkSource = 'data:application/pdf;base64,' + res.data;
	                var downloadLink_1 = document.createElement("a");
	                var fileName = invoiceNumber + ".pdf";
	                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
	                    var byteCharacters = window.atob(res.data);
	                    var byteNumbers = new Array(byteCharacters.length);
	                    for (var i = 0; i < byteCharacters.length; i++) {
	                        byteNumbers[i] = byteCharacters.charCodeAt(i);
	                    }
	                    var byteArray = new Uint8Array(byteNumbers);
	                    var blob = new Blob([byteArray], { type: 'application/pdf' });
	                    window.navigator.msSaveOrOpenBlob(blob, fileName);
	                }
	                else {
	                    downloadLink_1.href = linkSource;
	                    downloadLink_1.download = fileName;
	                    downloadLink_1.click();
	                    setTimeout(function () {
	                        downloadLink_1.remove();
	                    }, 5000);
	                }
	            }
	            else if (res.error) {
	                _this.errorPopupMsg = _this.translate.instant('LblFileNotFound');
	                _this.errorPopupTitle = _this.translate.instant('LblError');
	                _this.errorPopup.show();
	            }
	            else {
	                _this.errorPopupMsg = _this.translate.instant('LblNoDataFound');
	                _this.errorPopupTitle = _this.translate.instant('LblError');
	                _this.errorPopup.show();
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    InvoiceLegacyListComponent.prototype.IsDirectDebitEnabled = function () {
	        var _this = this;
	        this.invoiceService.IsDirectDebitEnabled().subscribe(function (res) {
	            if (res) {
	                _this.isDirectDebitEnabled = res.data;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    InvoiceLegacyListComponent.prototype.ShowResendConfirmModal = function (invoiceNumber) {
	        this.invoiceNumber = invoiceNumber;
	        this.isLoading = false;
	        this.confirmMsg = this.translate.instant('LblResendInvoiceConfirm', [
	            this.module
	        ]);
	        this.resendConfirmModal.show();
	    };
	    InvoiceLegacyListComponent.prototype.ShowPaymentLink = function (paymentLink) {
	        this.popupMsg =
	            paymentLink && paymentLink.trim()
	                ? paymentLink
	                : this.translate.instant('LblNoPaymentLinkGenerated');
	        this.successPopup.popupTitle = this.translate.instant('LblPaymentLink');
	        this.successPopup.show(false);
	    };
	    InvoiceLegacyListComponent.prototype.ShowDueDateEditModal = function (paymentLink) {
	        this.popupMsg =
	            paymentLink && paymentLink.trim()
	                ? paymentLink
	                : this.translate.instant('LblNoPaymentLinkGenerated');
	        this.successPopup.popupTitle = this.translate.instant('LblPaymentLink');
	        this.successPopup.show(false);
	    };
	    InvoiceLegacyListComponent.prototype.SuccessConfirmModalClick = function () {
	        this.resendConfirmModal.hide();
	        this.ResendInvoice();
	    };
	    InvoiceLegacyListComponent.prototype.HideConfirmModal = function () {
	        this.resendConfirmModal.hide();
	    };
	    InvoiceLegacyListComponent.prototype.ResendInvoice = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.invoiceService.ResendBookingInvoice(this.invoiceNumber).subscribe(function (res) {
	            _this.isLoading = false;
	            _this.popupMsg = _this.translate.instant('LblinvoiceResendSuccess', [
	                _this.module
	            ]);
	            _this.ShowSuccessPopup();
	            _this.GetIvoiceList();
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    InvoiceLegacyListComponent.prototype.CheckEmptyIBAN = function () {
	        var mylist = [];
	        this.missingABANNumber.model = this.invoiceList
	            .filter(function (x) { return !x.ibanAvailable && x.isChecked && x.includeinDirectDebit; })
	            .map(function (y) {
	            if (mylist.indexOf(y.driverName + y.instanceName) < 0) {
	                var returnObj = {};
	                returnObj['driverName'] = y.driverName;
	                returnObj['instanceName'] = y.instanceName;
	                mylist.push(y.driverName + y.instanceName);
	                return returnObj;
	            }
	        })
	            .filter(function (x) { return x != null; });
	        if (this.missingABANNumber.model.length > 0) {
	            this.missingABANNumber.show();
	        }
	        else {
	            this.popupMsg = this.translate.instant('LblNoEmptyIBANFound', [
	                this.module
	            ]);
	            this.ShowSuccessPopup();
	        }
	    };
	    InvoiceLegacyListComponent.prototype.CreateDirectDebitFile = function ($event) {
	        var _this = this;
	        if ($event != undefined) {
	            this.SetDirectDebitSearchData($event);
	            this.createDirectDebitModel.isDirectDebitClick = false;
	        }
	        else {
	            this.createDirectDebitModel.isDirectDebitClick = true;
	        }
	        this.invoiceService
	            .GetDirectDebitFile(this.selectedFormat, this.invoiceList)
	            .subscribe(function (res) {
	            _this._directDebitFileXML = res.data;
	            if (_this._directDebitFileXML.length > 0) {
	                _this.createDirectDebitModel.companyDDModel = _this._directDebitFileXML;
	                _this.createDirectDebitModel.model = _this._directDebitFileXML;
	                if ($event == undefined) {
	                    _this.createDirectDebitModel.show();
	                }
	            }
	            else {
	                _this.successPopup.popupTitle = _this.translate.instant('LblWarning');
	                _this.popupMsg = _this.translate.instant('LblNoInvoiceSelected', [
	                    _this.module
	                ]);
	                _this.successPopup.show();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    Object.defineProperty(InvoiceLegacyListComponent.prototype, "isPaymentHistoryAccess", {
	        get: function () {
	            if (this.invoiceList) {
	                return this.invoiceList.some(function (x) { return x.isPaymentHistoryView; });
	            }
	            else {
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(InvoiceLegacyListComponent.prototype, "isInvoiceEditAccess", {
	        get: function () {
	            if (this.invoiceList) {
	                return this.invoiceList.some(function (x) { return x.isEditable; });
	            }
	            else {
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    InvoiceLegacyListComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.popupTitle = this.translate.instant('LblSuccess');
	        this.successPopup.show();
	    };
	    InvoiceLegacyListComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    InvoiceLegacyListComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    InvoiceLegacyListComponent.prototype.OnDownloadDirectDebitSaved = function () {
	        this.GetIvoiceList();
	    };
	    InvoiceLegacyListComponent.prototype.SetDirectDebitSearchData = function ($event) {
	        this.selectedFormat = $event.format;
	    };
	    InvoiceLegacyListComponent.prototype.ShowAddManualInvoiceModal = function () {
	        this.manualInvoicePopup.model = new invoice_model_1.InvoiceModel();
	        this.manualInvoicePopup.show();
	    };
	    InvoiceLegacyListComponent.prototype.ShowDueDateChangeModal = function (invoiceHashId) {
	        this.errorModel = [];
	        this.invoiceHashId = invoiceHashId;
	        this.dueDateUpdatedDate = '';
	        this.dueDateValidationMessage = '';
	        this.editDueDateModal.show();
	    };
	    InvoiceLegacyListComponent.prototype.HideDueDateChangeModal = function () {
	        this.editDueDateModal.hide();
	    };
	    InvoiceLegacyListComponent.prototype.SuccessDueDateChangeModalClick = function () {
	        var _this = this;
	        if (this.dueDateUpdatedDate) {
	            this.invoiceService
	                .UpdateDueDateForInvoice(this.invoiceHashId, this.dueDateUpdatedDate)
	                .subscribe(function (res) {
	                if (res.data) {
	                    _this.editDueDateModal.hide();
	                    _this.DataListModel.currentPage = 1;
	                    _this.GetIvoiceList();
	                    _this.popupMsg = _this.translate.instant('LblDueDateUpdateSuccess');
	                    _this.ShowSuccessPopup();
	                }
	                else {
	                    _this.dueDateValidationMessage = '';
	                    _this.errorModel = res.error;
	                }
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	                _this.isLoading = false;
	            });
	        }
	        else {
	            this.dueDateValidationMessage = this.translate.instant('LblDueDateRequiredError');
	        }
	    };
	    InvoiceLegacyListComponent.prototype.ShowInvoiceStatusUpdateModal = function (invoiceHashId, invoiceStatus) {
	        this.isLoading = false;
	        if (invoiceStatus == 'CLOSED') {
	            this.statusUpdateModalMsg = this.translate.instant('LblConfirmCloseInvoice');
	        }
	        else {
	            this.statusUpdateModalMsg = this.translate.instant('LblConfirmReOpenInvoice');
	        }
	        this.invoiceStatusUpdateModel = new invoice_model_1.InvoiceStatusUpdateModel();
	        this.errorModel = [];
	        this.GetInvoiceReopenClosedReasons(invoiceStatus);
	        this.invoiceStatusUpdateModal.show();
	        this.invoiceStatusUpdateModel.invoiceHashId = invoiceHashId;
	        this.invoiceStatusUpdateModel.status = invoiceStatus;
	    };
	    InvoiceLegacyListComponent.prototype.HideInvoiceStatusUpdateModal = function () {
	        this.invoiceStatusUpdateModal.hide();
	    };
	    InvoiceLegacyListComponent.prototype.SuccessInvoiceStatusUpdateConfirmModalClick = function () {
	        this.UpdateInvoiceStatus();
	    };
	    InvoiceLegacyListComponent.prototype.GetInvoiceReopenClosedReasons = function (invoiceStatus) {
	        var _this = this;
	        this.invoiceService.GetInvoiceReopenClosedReasons(invoiceStatus).subscribe(function (res) {
	            _this.invoiceOpenCloseReasonList = res.data;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    InvoiceLegacyListComponent.prototype.UpdateInvoiceStatus = function () {
	        var _this = this;
	        this.invoiceService
	            .UpdateInvoiceStatus(this.invoiceStatusUpdateModel)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.invoiceStatusUpdateModal.hide();
	                _this.DataListModel.currentPage = 1;
	                _this.GetIvoiceList();
	                _this.popupMsg = _this.translate.instant('LblInvoiceOpenCloseSuccess', [
	                    _this.invoiceStatusUpdateModel.status == 'CLOSED'
	                        ? (_this.popupMsg = _this.translate.instant('LblClosed'))
	                        : (_this.popupMsg = _this.translate.instant('LblReOpen'))
	                ]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    InvoiceLegacyListComponent.prototype.RenderBookingStatus = function () {
	        var _this = this;
	        // if (this.NormalBookingView) {
	        this.invoiceStatusSelect = new SlimSelect({
	            select: '#invoiceStatus',
	            placeholder: this.LblSelect + ' ' + this.LblStatus,
	            showSearch: false,
	            showContent: 'down',
	            onChange: function (info) {
	                // if (this.NormalBookingView) {
	                _this.invoiceModel.invoiceStatusList = info.map(function (x) { return x.value; });
	                // }
	                //console.log(info);
	            }
	        });
	    };
	    InvoiceLegacyListComponent.prototype.SuccessSelectDriverModal = function ($event) {
	        this.invoiceModel.searchDriverNameList = $event.DriverName;
	        this.searchDriverName = this.invoiceModel.searchDriverNameList.join();
	        this.invoiceModel.driverHashIdList = $event.DriverHashID;
	    };
	    InvoiceLegacyListComponent.prototype.ClearDriver = function () {
	        this.invoiceModel.searchDriverNameList = [];
	        this.searchDriverName = "";
	        this.invoiceModel.driverHashId = "";
	        this.invoiceModel.driverHashIdList = [];
	    };
	    InvoiceLegacyListComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    __decorate([
	        core_1.ViewChild('editDueDateModal'), 
	        __metadata('design:type', Object)
	    ], InvoiceLegacyListComponent.prototype, "editDueDateModal", void 0);
	    __decorate([
	        core_1.ViewChild('resendConfirmModal'), 
	        __metadata('design:type', Object)
	    ], InvoiceLegacyListComponent.prototype, "resendConfirmModal", void 0);
	    __decorate([
	        core_1.ViewChild('deleteConfirmModal'), 
	        __metadata('design:type', Object)
	    ], InvoiceLegacyListComponent.prototype, "deleteConfirmModal", void 0);
	    __decorate([
	        core_1.ViewChild('manualCloseInvoiceConfirmModal'), 
	        __metadata('design:type', Object)
	    ], InvoiceLegacyListComponent.prototype, "manualCloseInvoiceModal", void 0);
	    __decorate([
	        core_1.ViewChild('invoiceStatusUpdateModal'), 
	        __metadata('design:type', Object)
	    ], InvoiceLegacyListComponent.prototype, "invoiceStatusUpdateModal", void 0);
	    __decorate([
	        core_1.ViewChild('reOpenInvoiceConfirmModal'), 
	        __metadata('design:type', Object)
	    ], InvoiceLegacyListComponent.prototype, "reOpenInvoiceModal", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], InvoiceLegacyListComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild('errorPopup'), 
	        __metadata('design:type', Object)
	    ], InvoiceLegacyListComponent.prototype, "errorPopup", void 0);
	    __decorate([
	        core_1.ViewChild('missingABANNumber'), 
	        __metadata('design:type', Object)
	    ], InvoiceLegacyListComponent.prototype, "missingABANNumber", void 0);
	    __decorate([
	        core_1.ViewChild('createDirectDebitModel'), 
	        __metadata('design:type', Object)
	    ], InvoiceLegacyListComponent.prototype, "createDirectDebitModel", void 0);
	    __decorate([
	        core_1.ViewChild('manualInvoicePopup'), 
	        __metadata('design:type', Object)
	    ], InvoiceLegacyListComponent.prototype, "manualInvoicePopup", void 0);
	    InvoiceLegacyListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-invoice-legacy-list',
	            template: __webpack_require__(721),
	            providers: [legacy_invoice_service_1.LegacyInvoiceService, jquery_helper_service_1.JQueryHelperService],
	            styles: [
	                "\n      .invoiceLinkDisabled {\n        cursor: not-allowed;\n      }\n\n      .inputWidth-100-Percent {\n        width: 100%;\n      }\n\n      .modal-body {\n        word-wrap: break-word;\n      }\n    "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof legacy_invoice_service_1.LegacyInvoiceService !== 'undefined' && legacy_invoice_service_1.LegacyInvoiceService) === 'function' && _a) || Object, (typeof (_b = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof jquery_helper_service_1.JQueryHelperService !== 'undefined' && jquery_helper_service_1.JQueryHelperService) === 'function' && _e) || Object])
	    ], InvoiceLegacyListComponent);
	    return InvoiceLegacyListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.InvoiceLegacyListComponent = InvoiceLegacyListComponent;


/***/ },
/* 719 */
/***/ function(module, exports) {

	"use strict";
	var InvoiceModel = (function () {
	    function InvoiceModel() {
	        this.status = 'OPEN';
	        this.sharedVehicleGroupDriverHashId = '';
	        this.translatedStatus = 'OPEN';
	        this.startDateTime = '';
	        this.endDateTime = '';
	        this.senderInstanceHashId = '';
	        this.senderCompanyHashId = '';
	        this.addresseeType = 'DRIVER';
	        this.organizationName = '';
	        this.driverHashId = '';
	        this.organizationHashId = '';
	        this.isSenderInstance = false;
	        this.costAndExpenseList = [];
	        // public totalAmountExVatFormat: string;
	        // public totalAmountInVatFormat: string;
	        // public totalVatAmountFormat: string;
	        this.invoiceType = '';
	        this.paymentLink = '';
	        this.invoiceCloseReason = '';
	        this.invoiceReopenReason = '';
	        this.isDueDateChangeEnable = false;
	        this.invoiceStatusList = [''];
	        this.searchDriverNameList = [];
	        this.driverHashIdList = [];
	    }
	    return InvoiceModel;
	}());
	exports.InvoiceModel = InvoiceModel;
	var PaymentHistoryModel = (function () {
	    function PaymentHistoryModel() {
	        this.startDateTime = '';
	        this.endDateTime = '';
	    }
	    return PaymentHistoryModel;
	}());
	exports.PaymentHistoryModel = PaymentHistoryModel;
	var InvoiceStatusUpdateModel = (function () {
	    function InvoiceStatusUpdateModel() {
	        this.reason = '';
	    }
	    return InvoiceStatusUpdateModel;
	}());
	exports.InvoiceStatusUpdateModel = InvoiceStatusUpdateModel;
	var InvoiceBasicDetails = (function () {
	    function InvoiceBasicDetails() {
	        this.currencySymbol = '';
	    }
	    return InvoiceBasicDetails;
	}());
	exports.InvoiceBasicDetails = InvoiceBasicDetails;


/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var Observable_1 = __webpack_require__(5);
	var config_1 = __webpack_require__(60);
	var jquery_helper_service_1 = __webpack_require__(67);
	var LegacyInvoiceService = (function () {
	    function LegacyInvoiceService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	        this.JQueryHelper = new jquery_helper_service_1.JQueryHelperService();
	    }
	    LegacyInvoiceService.prototype.GetInvoiceList = function (input, invoicemodel) {
	        var getInvoiceUrl = config_1.WeGoConfig.API_GET_BOOKING_INVOICE_LIST_LEGACY;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var queryStringinvoicemodel = this.JQueryHelper.Param(invoicemodel);
	        if (queryString) {
	            getInvoiceUrl = getInvoiceUrl + "?" + queryString;
	        }
	        getInvoiceUrl =
	            getInvoiceUrl + "&" + decodeURIComponent(queryStringinvoicemodel);
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInvoiceUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    LegacyInvoiceService.prototype.ExportInvoiceList = function (input, invoicemodel) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var getInvoiceUrl = config_1.WeGoConfig.API_EXPORT_BOOKING_INVOICE_LIST_LEGACY + "?" + queryString;
	        var queryStringinvoicemodel = this.JQueryHelper.Param(invoicemodel);
	        getInvoiceUrl =
	            getInvoiceUrl + "&" + decodeURIComponent(queryStringinvoicemodel);
	        var headers = this.authService.GetHeader("text/csv");
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getInvoiceUrl, options);
	    };
	    LegacyInvoiceService.prototype.DeleteInvoice = function (invoiceHashId) {
	        var deleteInvoiceUrl = config_1.WeGoConfig.API_DELETE_INVOICE + "?invoiceHashId=" + invoiceHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(deleteInvoiceUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    LegacyInvoiceService.prototype.ResendBookingInvoice = function (invoiceNumber) {
	        var getInvoiceUrl = config_1.WeGoConfig.API_RESEND_BOOKING_INVOICE_LEGACY + "?invoiceNumber=" + invoiceNumber;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInvoiceUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    LegacyInvoiceService.prototype.DownloadInvoice = function (invoiceNumber) {
	        var getInvoiceUrl = config_1.WeGoConfig.API_DOWNLOAD_BOOKING_INVOICE_LEGACY +
	            "?invoiceNumber=" +
	            invoiceNumber;
	        var headers = this.authService.GetHeader("application/pdf");
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getInvoiceUrl, options);
	    };
	    LegacyInvoiceService.prototype.DownloadInvoicePDF = function (invoiceNumber) {
	        var getInvoiceUrl = config_1.WeGoConfig.API_DOWNLOAD_BOOKING_INVOICE_OFFLINE_PDF_LEGACY +
	            "?invoiceNumber=" +
	            invoiceNumber;
	        var body = "";
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(getInvoiceUrl, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    LegacyInvoiceService.prototype.GetDirectDebitFileList = function (input, directdebitmodel) {
	        var getInvoiceUrl = config_1.WeGoConfig.API_GET_DIRECT_DEBIT_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var queryStringinvoicemodel = this.JQueryHelper.Param(directdebitmodel);
	        if (queryString) {
	            getInvoiceUrl = getInvoiceUrl + "?" + queryString;
	        }
	        getInvoiceUrl =
	            getInvoiceUrl + "&" + decodeURIComponent(queryStringinvoicemodel);
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInvoiceUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    LegacyInvoiceService.prototype.ExportDirectDebitFileList = function (input, directdebitmodel) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var getInvoiceUrl = config_1.WeGoConfig.API_EXPORT_DIRECT_DEBIT_LIST + "?" + queryString;
	        var queryStringinvoicemodel = this.JQueryHelper.Param(directdebitmodel);
	        getInvoiceUrl =
	            getInvoiceUrl + "&" + decodeURIComponent(queryStringinvoicemodel);
	        var headers = this.authService.GetHeader("text/csv");
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getInvoiceUrl, options);
	    };
	    LegacyInvoiceService.prototype.GetDirectDebitFile = function (format, invoicemodel) {
	        var getInvoiceUrl = config_1.WeGoConfig.API_GET_DIRECTDEBIT + "?selectedFormat=" + format;
	        var body = invoicemodel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(getInvoiceUrl, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    LegacyInvoiceService.prototype.DownloadDirectDebitFile = function (input, DirectDebitDate, SelectedFormat) {
	        var getInvoiceUrl = config_1.WeGoConfig.API_CREATE_DIRECT_DEBIT_FOR_COMPANY +
	            "?RequestedCollectionDate=" +
	            DirectDebitDate +
	            "&SelectedFormat=" +
	            SelectedFormat;
	        var body = input;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(getInvoiceUrl, body, options);
	    };
	    LegacyInvoiceService.prototype.ReCreateDirectDebitFile = function (directDebitFileHashId) {
	        var getInvoiceUrl = config_1.WeGoConfig.API_RECREATE_DIRECT_DEBIT_FOR_COMPANY +
	            "?directDebitFileHashId=" +
	            directDebitFileHashId;
	        var body = "";
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(getInvoiceUrl, body, options);
	    };
	    LegacyInvoiceService.prototype.IsDirectDebitEnabled = function () {
	        var getDirectDebitFileConfigStatus = config_1.WeGoConfig.API_GET_IS_DIRECTDEBIT_ENABLED_LEGACY;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getDirectDebitFileConfigStatus, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    LegacyInvoiceService.prototype.GetDriverList = function (InstancehashId, input, CompanyHashId) {
	        var getDriverUrl = config_1.WeGoConfig.API_GET_DRIVER_LIST_INVOICE;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getDriverUrl =
	                getDriverUrl +
	                    "?" +
	                    queryString +
	                    "&instanceHashId= " +
	                    InstancehashId +
	                    "&companyHashId=" +
	                    CompanyHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getDriverUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    LegacyInvoiceService.prototype.GetOrganizationList = function (InstancehashId, input, CompanyHashId) {
	        var getDriverUrl = config_1.WeGoConfig.API_GET_ORGANIZATION_LIST_INVOICE;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getDriverUrl =
	                getDriverUrl +
	                    "?" +
	                    queryString +
	                    "&instanceHashId= " +
	                    InstancehashId +
	                    "&companyHashId=" +
	                    CompanyHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getDriverUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    LegacyInvoiceService.prototype.UpdateManualInvoice = function (invoiceModel, sendInvoice) {
	        if (sendInvoice === void 0) { sendInvoice = false; }
	        var body = invoiceModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        var updateManualInvoiceUrl = config_1.WeGoConfig.API_POST_MANUAL_INVOICE_LEGACY + "?sendInvoice=" + sendInvoice;
	        return this.http
	            .post(updateManualInvoiceUrl, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    LegacyInvoiceService.prototype.GetInvoiceNumber = function () {
	        var getDirectDebitFileConfigStatus = config_1.WeGoConfig.API_GET_INVOICE_NUMBER;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getDirectDebitFileConfigStatus, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    LegacyInvoiceService.prototype.GetManualInvoiceByHashId = function (invoiceHashId) {
	        var getInvoicedetailUrl = config_1.WeGoConfig.API_GET_INVOICE_BY_HASH + "?invoiceHashId=" + invoiceHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInvoicedetailUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    LegacyInvoiceService.prototype.GetCompanyAddress = function (companyHashId) {
	        var getDirectDebitFileConfigStatus = config_1.WeGoConfig.API_GET_COMPANY_ADDRESS + "?companyHashId=" + companyHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getDirectDebitFileConfigStatus, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    LegacyInvoiceService.prototype.GetDriverAddress = function (driverHashId) {
	        var getDirectDebitFileConfigStatus = config_1.WeGoConfig.API_GET_DRIVER_ADDRESS + "?driverHashId=" + driverHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getDirectDebitFileConfigStatus, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    LegacyInvoiceService.prototype.GetOrganizationAddress = function (organizationHashId) {
	        var getDirectDebitFileConfigStatus = config_1.WeGoConfig.API_GET_ORGANIZATION_ADDRESS +
	            "?organizationHashId=" +
	            organizationHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getDirectDebitFileConfigStatus, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    LegacyInvoiceService.prototype.GetDropdownBookingList = function (sharedVehicleDriverHashId, organizationHashId) {
	        var getCostTypeUrl;
	        getCostTypeUrl = config_1.WeGoConfig.API_GET_DROPDOWN_MANUAL_INVOICE_BOOKING_LIST;
	        getCostTypeUrl =
	            getCostTypeUrl +
	                "?sharedVehicleDriverHashId=" +
	                sharedVehicleDriverHashId +
	                "&organizationHashId=" +
	                organizationHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getCostTypeUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    LegacyInvoiceService.prototype.RemoveCostAndExpenses = function (costandExpensesHashId) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        var postRemoveCostAndExpensesFromInvoice = config_1.WeGoConfig.API_POST_REMOVE_COSTANDEXPENSE_FROM_INVOICE +
	            "?costAndExpenseHashId=" +
	            costandExpensesHashId;
	        return this.http
	            .post(postRemoveCostAndExpensesFromInvoice, "", options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    LegacyInvoiceService.prototype.GetInvoicePaymentHistory = function (paymentHistoryModel, input) {
	        var getPaymentHistoryListUrl = config_1.WeGoConfig.API_INVOICE_PAYMENT_HISTORY_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var queryStringInvoiceHistoryModel = this.JQueryHelper.Param(paymentHistoryModel);
	        if (queryString) {
	            getPaymentHistoryListUrl = getPaymentHistoryListUrl + "?" + queryString;
	        }
	        getPaymentHistoryListUrl =
	            getPaymentHistoryListUrl +
	                "&" +
	                decodeURIComponent(queryStringInvoiceHistoryModel);
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getPaymentHistoryListUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    LegacyInvoiceService.prototype.GetBookingInvoiceBasicDetails = function (invoiceHashId) {
	        var getCompnayUrl = config_1.WeGoConfig.API_GET_INVOICE_BASIC_DETAILS_LEGACY +
	            "?invoiceHashId=" +
	            invoiceHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getCompnayUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    LegacyInvoiceService.prototype.UpdateCostAndExpenses = function (formData, moduleName) {
	        var _this = this;
	        var Apiurl = "";
	        if (moduleName == "INVOICE") {
	            Apiurl = config_1.WeGoConfig.API_POST_UPDATE_COSTANDEXPENSE_MANUALINVOICE;
	        }
	        else {
	            Apiurl = config_1.WeGoConfig.API_POST_UPDATE_COSTANDEXPENSE;
	        }
	        return Observable_1.Observable.create(function (observer) {
	            var url = Apiurl;
	            var xhr = new XMLHttpRequest();
	            var header = _this.authService.GetHeaderForFile();
	            xhr.onreadystatechange = function () {
	                if (xhr.readyState === 4) {
	                    if (xhr.status === 200) {
	                        console.log(xhr.response);
	                        observer.next(JSON.parse(xhr.response));
	                        observer.complete();
	                    }
	                    else {
	                        observer.error(xhr.status);
	                    }
	                }
	            };
	            xhr.open("POST", url, true);
	            for (var i = 0; i < header.length; i++) {
	                xhr.setRequestHeader(header[i]["name"], header[i]["value"]);
	            }
	            xhr.send(formData);
	        });
	    };
	    LegacyInvoiceService.prototype.ExportInvoicePaymentHistory = function (paymentHistoryModel, input) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var exportPaymentHistoryUrl = config_1.WeGoConfig.API_EXPORT_INVOICE_PAYMENT_HISTORY;
	        var queryStringinvoicemodel = this.JQueryHelper.Param(paymentHistoryModel);
	        exportPaymentHistoryUrl =
	            exportPaymentHistoryUrl +
	                "?" +
	                decodeURIComponent(queryStringinvoicemodel);
	        var headers = this.authService.GetHeader("text/csv");
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(exportPaymentHistoryUrl, options);
	    };
	    LegacyInvoiceService.prototype.UpdateDueDateForInvoice = function (invoiceHashId, updatedDueDate) {
	        var getUpdateDueDateUrl = config_1.WeGoConfig.API_GET_UPDATE_DUE_DATE_FOR_INVOICE_LEGACY +
	            "?invoiceHashId=" +
	            invoiceHashId +
	            "&updatedDueDate=" +
	            updatedDueDate;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getUpdateDueDateUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    LegacyInvoiceService.prototype.UpdateInvoiceStatus = function (invoiceStatusUpdateModel) {
	        var getUpdateInvoiceStatusUrl = config_1.WeGoConfig.API_POST_UPDATE_INVOICE_STATUS_LEGACY;
	        var body = invoiceStatusUpdateModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(getUpdateInvoiceStatusUrl, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    LegacyInvoiceService.prototype.GetInvoiceReopenClosedReasons = function (invoiceStatus) {
	        var getCostTypeUrl;
	        getCostTypeUrl =
	            invoiceStatus == "CLOSED"
	                ? config_1.WeGoConfig.API_GET_INVOICE_CLOSED_REASON_DROPDOWN_URL
	                : config_1.WeGoConfig.API_GET_INVOICE_REOPEN_REASON_DROPDOWN_URL;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getCostTypeUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    LegacyInvoiceService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], LegacyInvoiceService);
	    return LegacyInvoiceService;
	    var _a, _b;
	}());
	exports.LegacyInvoiceService = LegacyInvoiceService;


/***/ },
/* 721 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\n  <section class=\"content-header\">\n    <div class=\"col-md-9 col-sm-6\">\n      <h1 class=\"pagename\">{{ 'LblBookingInvoice' | translate }} {{ 'LblList' | translate }} </h1>\n      <ol class=\"breadcrumb\">\n        <li>\n          <a [routerLink]=\"urlDefaultPage\">\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\n        </li>\n        <li class=\"active\"> {{ 'LblBookingInvoice' | translate }} {{ 'LblList' | translate }}</li>\n      </ol>\n    </div>\n    <div class=\"clearfix\"></div>\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\n    <div class=\"clearfix\"></div>\n  </section>\n  <section class=\"content\">\n    <div class=\"row\">\n      <div class=\"col-md-12\">\n        <div class=\"row\">\n          <div class=\"form-group col-md-2\">\n            <label>{{ 'LblFrom' | translate }}</label>\n            <div class=\"clearfix\"></div>\n            <div class=\"input-group\">\n              <span class=\"input-group-addon\">\n                <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\n              </span>\n              <input flatpickr readonly [Config]=\"flatPickrConfigFrom\" [(ngModel)]=\"invoiceModel.startDateTime\" name=\"TimeBlockStartDate\"\n                type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblFrom' | translate }}\">\n            </div>\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'startDateTime' }}</span>\n          </div>\n          <div class=\"form-group col-md-2\">\n            <label>{{ 'LblTo' | translate }}</label>\n            <div class=\"clearfix \"></div>\n            <div class=\"input-group\">\n              <span class=\"input-group-addon\">\n                <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\n              </span>\n              <input flatpickr readonly [Config]=\"flatPickrConfigTo\" [(ngModel)]=\"invoiceModel.endDateTime\" name=\"TimeBlockStartDate\" type=\"text\"\n                class=\"form-control\" placeholder=\"{{ 'LblTo' | translate }}\">\n            </div>\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'endDateTime' }}</span>\n          </div>\n          <div class=\"form-group col-md-3 nopad-left\">\n            <label>{{ 'LblStatus' | translate }} </label>\n            <select id=\"invoiceStatus\" name=\"invoiceStatus\" multiple>\n              <!-- <option value=\"\">{{ 'LblAll' | translate }} {{ 'LblStatus' | translate }}</option> -->\n              <option *ngFor=\"let item of InvoiceStatusAll\" [attr.value]='item.Value'>{{item.Key}}</option>\n            </select>\n\n            <!-- <select    id =\"bookingStatusSpecial\" name=\"bookingStatusSpecial\" (change)=\"BookingStatusChanged()\" \n            multiple>              \n            <option  *ngFor=\"let item of BookingStatusSpecialBooking\"  [attr.value]='item.Value'>{{item.Key}}</option>\n          </select> -->\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'invoiceStatus' }}</span>\n          </div>\n          <div class=\"form-group nopad-left col-md-3\">\n            <label>{{ 'LblDriver' | translate }}</label>\n            <div class=\"input-group\">\n              <input [(ngModel)]=\"searchDriverName\" [attr.title]=\"searchDriverName\" name=\"driverName\" type=\"text\" class=\"form-control\"\n                placeholder=\"{{ 'LblAll' | translate }} {{ 'LblDriver' | translate }}\" readonly>\n              <div class=\"input-group-btn\">\n                <button class=\"btn btn-default\" type=\"button\" (click)=\"selectDriverModal.show(invoiceModel.driverHashIdList,invoiceModel.searchDriverNameList)\">\n                  <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\n                </button>\n                <button class=\"btn btn-default\" type=\"button\" (click)=\"ClearDriver()\">\n                  <i class=\"fa fa-eraser\" aria-hidden=\"true\"></i>\n                </button>\n              </div>\n            </div>\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'DriverHashId' }}</span>\n          </div>\n          <div class=\"form-group col-md-1\">\n            <label>\n              <span class=\"text text-danger\"></span>\n            </label>\n            <div class=\"clearfix\"></div>\n            <button class=\"btn btn-default navbar-left mar_t_5\" (click)=\"OnDateSearch()\">{{ 'LblSearch' | translate}}</button>\n          </div>\n        </div>\n        <wego-search-list (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\"\n          [ItemPerPage]=\"DataListModel.itemsPerPage\" [itemPerPageList]=\"itemPerPageList\"></wego-search-list>\n        <div *ngIf=\"isDirectDebitEnabled\" class=\"form-group nopad col-md-12\">\n          <button class=\"btn btn-default\" (click)=\"CreateDirectDebitFile()\">{{ 'LblCreateDirectDebitFile' | translate }}</button> &nbsp;&nbsp;\n          <button class=\"btn btn-default\" (click)=\"CheckEmptyIBAN()\">{{ 'LblCheckEmptyIbanNumber' | translate }}</button>\n        </div>\n        <div class=\"clearfix\"></div>\n        <div class=\"table table-responsive mar_bot_ziro\" style=\"width: 101%;overflow-x: scroll;\">\n          <table class=\"table table-bordered mar_bot_ziro\" style=\"width: 101%;overflow-x: scroll;max-width: 101%;\">\n            <thead>\n              <tr>\n                <th class=\"cursor-pointer\" (click)=\"OnSort('invoiceNumber')\">\n                  {{ 'LblInvoiceNumber' | translate }}\n                  <wego-sort-list [FieldName]=\"'invoiceNumber'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\n                </th>\n                <th style=\"width: 50px;\" class=\"cursor-pointer\" (click)=\"OnSort('InvoiceSendDateTimeUTC')\">\n                  {{ 'LblDate' | translate }}\n                  <wego-sort-list [FieldName]=\"'InvoiceSendDateTimeUTC'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\n                </th>\n                <th class=\"cursor-pointer\" (click)=\"OnSort('invoiceDueDateTimeUTC')\">\n                  {{ 'LblDueDate' | translate }}\n                  <wego-sort-list [FieldName]=\"'invoiceDueDateTimeUTC'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\n                </th>\n                <th class=\"cursor-pointer\" (click)=\"OnSort('translatedStatus')\">\n                  {{ 'LblInvoiceStatus' | translate }}\n                  <wego-sort-list [FieldName]=\"'translatedStatus'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\n                </th>\n                <!-- <th class=\"cursor-pointer\" (click)=\"OnSort('driverName')\">\n                  {{ 'LblDriverName' | translate }}\n                  <wego-sort-list [FieldName]=\"'driverName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\n                </th>\n                <th class=\"cursor-pointer\" (click)=\"OnSort('organizationName')\">\n                  {{'LblOrganization' | translate}}\n                  <wego-sort-list [FieldName]=\"'organizationName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\n                </th> -->\n                <th class=\"cursor-pointer\" (click)=\"OnSort('addressee')\">\n                  {{ 'LblAddressee' | translate }}\n                  <wego-sort-list [FieldName]=\"'addressee'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\n                </th>\n                <th class=\"cursor-pointer\" (click)=\"OnSort('sharedVehicleGroup')\">\n                  {{ 'LblSharedVehicleGroup' | translate }}\n                  <wego-sort-list [FieldName]=\"'sharedVehicleGroup'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\n                </th>\n                <!-- Check Payment History Right -->\n                <th *ngIf=\"isPaymentHistoryAccess\">\n                  {{ 'LblPaymentHistory' | translate }}\n                </th>\n                <th>\n                  {{ 'LblPaymentLink' | translate }}\n                </th>\n\n                <!-- <th class=\"cursor-pointer\" (click)=\"OnSort('company')\">\n                  {{ 'LblCompany' | translate }}\n                  <wego-sort-list [FieldName]=\"'company'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\n                </th> -->\n                <th class=\"cursor-pointer\" (click)=\"OnSort('totalAmount')\">\n                  {{'LblTotal' | translate}}\n                  <wego-sort-list [FieldName]=\"'totalAmount'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\n                </th>\n                <th *ngIf=\"isDirectDebitEnabled\" class=\"cursor-pointer text-center\"> {{'LblIncludeInDirectDebit' | translate}}</th>\n                <th *ngIf=\"isDirectDebitEnabled\" class=\"cursor-pointer text-center\"> {{'LblDirectDebitFileDate' | translate}}</th>\n\n                <th class=\"cursor-pointer\" (click)=\"OnSort('invoiceType')\">\n                  {{'LblInvoiceType' | translate}}\n                  <wego-sort-list [FieldName]=\"'invoiceType'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\n                </th>\n\n                <th class=\"cursor-pointer text-center\">\n                  {{'LblReOpenClose' | translate}}\n                </th>\n\n                <th class=\"cursor-pointer text-center\"> {{'LblResend' | translate}}</th>\n\n                <th class=\"cursor-pointer text-center\"> {{'LblDownload' | translate}}</th>\n                <th class=\"text-center\">{{ 'LblDelete' | translate }}</th>\n              </tr>\n            </thead>\n            <tbody>\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\n                <tr *ngFor=\"let invoice of invoiceList\">\n                  <td *ngIf=\"invoice.invoiceType == 'MANUAL' && invoice.isEditable\">\n                    <a [routerLink]=\"urlInvoice + '/' + invoice.invoiceHashId\">\n                      {{ invoice.invoiceNumber }}\n                    </a>\n                  </td>\n                  <td *ngIf=\"invoice.invoiceType !='MANUAL' || !invoice.isEditable \">\n                    {{ invoice.invoiceNumber }}\n                  </td>\n                  <td>\n                    <label  *ngIf=\"invoice.status !='OPEN'\">\n                      {{ invoice.invoiceSendDateTime }} </label>\n                  </td>\n                  <td *ngIf=\"isInvoiceEditAccess\">{{ invoice.invoiceDueDateTime }}\n                    <a *ngIf=\"(invoice.status=='REOPEN' || invoice.status=='REQUESTFORPAYMENT') && invoice.invoiceDueDateTime && invoice.isEditable && invoice.isDueDateChangeEnable\"\n                      class=\"cursor-pointer \" (click)=\"ShowDueDateChangeModal(invoice.invoiceHashId)\">\n                      <i class=\"fa fa-edit\"></i>\n                    </a>\n                  </td>\n                  <td *ngIf=\"!isInvoiceEditAccess\">{{ \"\" }}\n                  </td>\n                  <td>{{ invoice.translatedStatus  }}</td>\n                  <td>\n                    <template [ngIf]=\"invoice.isDriverEdit && !invoice.isPersonDeleted && !invoice.organizationHashId\">\n                      <!-- TODO COMMENT THIS LINE START\n                      [routerLink]=\"[urlDriverInfo,{ personId : invoice.sharedVehicleGroupDriverHashId }]\"\n                      TODO COMMENT THIS LINE END -->\n                      <template [ngIf]=\"invoice.sharedVehicleGroupDriverHashId\">\n                        <a [routerLink]=\"urlDriverInfo + '/' + invoice.sharedVehicleGroupDriverHashId\">\n                          {{ invoice.addressee }}\n                        </a>\n                      </template>\n                      <template [ngIf]=\"!invoice.sharedVehicleGroupDriverHashId && invoice.driverHashId\">\n                        <a [routerLink]=\"urlDriverInfo + '/' + invoice.driverPersonHashId\">\n                          {{ invoice.addressee }}\n                        </a>\n                      </template>\n                    </template>\n                    <template [ngIf]=\"(invoice.isPersonDeleted || !invoice.isDriverEdit) && !invoice.organizationHashId\">\n                      {{ invoice.addressee }}\n                    </template>\n                    <template [ngIf]=\"invoice.isOrganizationEdit && !invoice.IsOrganizationDeleted && invoice.organizationHashId\">\n                      <a [routerLink]=\"urlOrganizationInfo + '/' + invoice.organizationHashId\">\n                        {{ invoice.addressee }}\n                      </a>\n                    </template>\n                    <template [ngIf]=\"(!invoice.isOrganizationEdit || invoice.IsOrganizationDeleted) && invoice.organizationHashId\">\n                      {{ invoice.addressee }}\n                    </template>\n                  </td>\n                  <!-- <td>\n                    {{ invoice.driver }}\n                  </td> -->\n                  <!-- <td>{{ invoice.organizationName }}</td> -->\n                  <!-- <td>{{ invoice.addressee }}</td> -->\n                  <td>{{ invoice.sharedVehicleGroup }}</td>\n                  <!-- Check Payment History Right -->\n                  <td *ngIf=\"isPaymentHistoryAccess\" class=\"text-center \">\n                  </td>\n                  <td class=\"text-center \">\n                  </td>\n                  <!-- <td>{{ invoice.company }}</td> -->\n                  <td>{{ invoice.total }}</td>\n                  <td *ngIf=\"isDirectDebitEnabled \" class=\"text-center \">\n                    <input type=\"checkbox\"\n                      name=\"includeinDirectDebit \" [attr.name]=\"invoice.invoiceNumber \" [(ngModel)]=\"invoice.isChecked \">\n                  </td>\n\n                  <td *ngIf=\"isDirectDebitEnabled \">{{ invoice.directDebitFileDate }}</td>\n                  <td>{{ invoice.invoiceType }}</td>\n\n                  <td *ngIf=\"isInvoiceEditAccess\" class=\"text-center \">\n                    <a *ngIf=\"(invoice.status=='REOPEN' || invoice.status=='REQUESTFORPAYMENT' || invoice.status=='SENT') && invoice.isEditable\"\n                      class=\"cursor-pointer \" (click)=\"ShowInvoiceStatusUpdateModal(invoice.invoiceHashId,'CLOSED')\">\n                      <i class=\"fa fa-window-close fa-fw\"></i>\n                    </a>\n                    <a *ngIf=\"invoice.status=='CLOSED' && invoice.invoiceCloseReason=='ManuallyClosed' && invoice.isEditable\" class=\"cursor-pointer \"\n                      (click)=\"ShowInvoiceStatusUpdateModal(invoice.invoiceHashId,'REOPEN')\">\n                      <i class=\"fa fa-retweet fa-fw\"></i>\n                    </a>\n                  </td>\n                  <td *ngIf=\"!isInvoiceEditAccess\" class=\"text-center \">\n                    {{\"\"}}\n                  </td>\n                  <td class=\"text-center \">\n                    <div *ngIf=\"invoice.status=='OPEN'\" class=\"invoiceLinkDisabled\">\n                      <i class=\"fa fa-envelope fa-fw\"></i>\n                    </div>\n                    <a *ngIf=\"invoice.status!='OPEN'\" class=\"cursor-pointer\" (click)=\"ShowResendConfirmModal(invoice.invoiceNumber) \">\n                      <i class=\"fa fa-envelope fa-fw \"></i>\n                    </a>\n                  </td>\n                  <td class=\"text-center \">\n                    <div *ngIf=\"invoice.status=='OPEN'\" class=\"invoiceLinkDisabled\">\n                      <i class=\"fa fa-download fa-fw\"></i>\n                    </div>\n                    <a *ngIf=\"invoice.status!='OPEN'\" href=\"javascript:void(0);\" (click)=\"DownloadOfflineInvoicePDF(invoice.invoiceNumber)\">\n                      <!--<a class=\"cursor-pointer \" (click)=\"DownloadInvoice(invoice.invoiceNumber) \">-->\n                      <i class=\"fa fa-download fa-fw \"></i>\n                    </a>\n                  </td>\n                  <!-- <td class=\"text-center\">\n                    <a *ngIf=\"invoice.isDeletable\" class=\"cursor-pointer\" (click)=\"ShowDeleteConfirmModal(invoice.invoiceHashId)\">\n                      <i class=\"fa fa-trash-o fa-fw text-danger\"></i>\n                    </a>\n                  </td> -->\n\n                  <td class=\"text-center \">\n                    <div *ngIf=\"invoice.isDeletable\">\n                      <div class=\"invoiceLinkDisabled\" *ngIf=\"!(invoice.invoiceType == 'MANUAL' && invoice.status =='OPEN')\">\n                        <i class=\"fa fa-trash-o fa-fw text-danger\"></i>\n                      </div>\n                      <a *ngIf=\"invoice.invoiceType == 'MANUAL' && invoice.status =='OPEN'\" class=\"cursor-pointer\" (click)=\"ShowDeleteConfirmModal(invoice.invoiceHashId)\">\n                        <!--<a class=\"cursor-pointer \" (click)=\"DownloadInvoice(invoice.invoiceNumber) \">-->\n                        <i class=\"fa fa-trash-o fa-fw text-danger\"></i>\n                      </a>\n                    </div>\n                  </td>\n\n                </tr>\n              </template>\n              <tr *ngIf=\"DataListModel.totalItems==0 && !isLoading \">\n                <td class=\"text-center text-danger \" colspan=\"20 \">\n                  {{ DataListModel.infoMessage }}\n                </td>\n              </tr>\n            </tbody>\n          </table>\n        </div>\n        <div class=\"clearfix \"></div>\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro \">\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad \">\n            <div class=\"col-md-12 \">\n              <pagination class=\"pull-right \" [totalItems]=\"DataListModel.totalItems \" [itemsPerPage]=\"DataListModel.itemsPerPage\n                      \" [(ngModel)]=\"DataListModel.currentPage \" [maxSize]=\"DataListModel.maxSize \" [boundaryLinks]=\"true \"\n                previousText=\"&lsaquo; \" nextText=\"&rsaquo;\n                      \" firstText=\"&laquo; \" lastText=\"&raquo; \" [rotate]=\"false \" (pageChanged)=\"OnPageChanged($event) \"></pagination>\n            </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </section>\n</div>\n\n<div bsModal #editDueDateModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\n  <div class=\"modal-dialog modal-sm\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"HideDueDateChangeModal()\">\n          <span aria-hidden=\"true\">&times;</span>\n        </button>\n        <h4 class=\"modal-title\">{{ 'LblConfirm' | translate }}</h4>\n      </div>\n      <div class=\"modal-body\">\n        {{ 'LblConfirmDuedatechange' | translate }}\n        <br/>\n        <br/>\n        <div class=\"input-group\">\n          <span class=\"input-group-addon\">\n            <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\n          </span>\n          <input flatpickr readonly [Config]=\"flatPickrConfigDueDate\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblDueDate' | translate }}\"\n            [(ngModel)]=\"dueDateUpdatedDate\" name=\"dayEndTime\" maxlength=\"100\">\n        </div>\n        <span class=\"text text-danger\">{{ dueDateValidationMessage }}</span>\n        <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'dueDateValidationMessage' }}</span>\n      </div>\n      <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-green\" (click)=\"SuccessDueDateChangeModalClick()\">{{ 'LblYes' | translate }}</button>\n        <button type=\"button\" class=\"btn btn-gray cursor-pointer\" (click)=\"HideDueDateChangeModal()\">{{ 'LblNo' | translate }}</button>\n      </div>\n    </div>\n  </div>\n</div>\n\n<div bsModal #invoiceStatusUpdateModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\n  <div class=\"modal-dialog modal-sm\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"HideInvoiceStatusUpdateModal()\">\n          <span aria-hidden=\"true\">&times;</span>\n        </button>\n        <h4 class=\"modal-title\">{{ 'LblConfirm' | translate }}</h4>\n      </div>\n      <div class=\"modal-body\">\n        {{ statusUpdateModalMsg }}\n        <br/>\n        <br/>\n        <div class=\"form-group\">\n          <label>\n            <span class=\"text text-danger\">*</span>&nbsp;{{'LblReason' | translate }}\n          </label>\n          <select [(ngModel)]=\"invoiceStatusUpdateModel.reason\" class=\"form-control\" name=\"customerHashId\">\n            <option value=''>{{ 'LblSelect' | translate }} {{ 'LblReason' | translate }} </option>\n            <option *ngFor=\"let item of invoiceOpenCloseReasonList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\n          </select>\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'reason' }}</span>\n        </div>\n      </div>\n      <div class=\"modal-footer\">\n        <button type=\"button\" class=\"btn btn-green\" (click)=\"SuccessInvoiceStatusUpdateConfirmModalClick()\">{{ 'LblYes' | translate }}</button>\n        <button type=\"button\" class=\"btn btn-gray cursor-pointer\" (click)=\"HideInvoiceStatusUpdateModal()\">{{ 'LblNo' | translate }}</button>\n      </div>\n    </div>\n  </div>\n</div>\n\n<wego-lodder [isLoading]=\"isLoading \"></wego-lodder>\n\n<wego-confirm-popup #resendConfirmModal [popupMsg]=\"confirmMsg \" (onConfirm)=\"SuccessConfirmModalClick() \" (onReject)=\"HideConfirmModal() \"></wego-confirm-popup>\n\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup() \"></wego-success-popup>\n\n<missing-iban-popup #missingABANNumber></missing-iban-popup>\n\n<create-directdebit-file-popup #createDirectDebitModel (OnFormatChange)=\"CreateDirectDebitFile($event)\n                      \" (OnSuccessSave)=\"OnDownloadDirectDebitSaved() \"></create-directdebit-file-popup>\n\n<wego-confirm-popup #deleteConfirmModal [popupMsg]=\"deleteMessage\" (onConfirm)=\"DeleteConfirmSuccessClick()\" (onReject)=\"HideDeleteConfirmModal()\"></wego-confirm-popup>\n\n<wego-booking-driver-popup #selectDriverModal (OnSuccessSelect)=\"SuccessSelectDriverModal($event)\"></wego-booking-driver-popup>\n\n<wego-success-popup #errorPopup [popupMsg]=\"errorPopupMsg\" [popupTitle]=\"errorPopupTitle\"></wego-success-popup>\n";

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var translate_service_1 = __webpack_require__(70);
	var core_1 = __webpack_require__(3);
	var invoice_model_1 = __webpack_require__(719);
	var invoice_service_1 = __webpack_require__(723);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var jquery_helper_service_1 = __webpack_require__(67);
	var flatpickr_model_1 = __webpack_require__(83);
	var $ = __webpack_require__(68);
	var SlimSelect = __webpack_require__(616);
	var InvoiceListComponent = (function () {
	    function InvoiceListComponent(invoiceService, translate, authService, router, jQueryHelperService) {
	        this.invoiceService = invoiceService;
	        this.translate = translate;
	        this.authService = authService;
	        this.router = router;
	        this.jQueryHelperService = jQueryHelperService;
	        this.invoiceModel = new invoice_model_1.InvoiceModel();
	        this.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_FORMAT;
	        this.dateTimeFormat = config_1.WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
	        this.itemPerPageList = config_1.WeGoConfig.GRID_PAGGING;
	        this.selectedFormat = 'default';
	        this.LEGACY_API_BASE_URL = config_1.WeGoConfig.LEGACY_API_BASE_URL;
	    }
	    InvoiceListComponent.prototype.ngOnInit = function () {
	        this.module = this.translate.instant('LblBookingInvoice');
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = [
	            'translatedStatus',
	            'invoiceNumber',
	            'sharedVehicleGroup',
	            'addressee',
	            'invoiceType'
	        ];
	        this.InvoiceStatusAll = [
	            {
	                Key: this.translate.instant("LblOPEN"),
	                Value: 'OPEN'
	            },
	            {
	                Key: this.translate.instant("LblSENT"),
	                Value: 'SENT'
	            },
	            {
	                Key: this.translate.instant("LblCLOSED"),
	                Value: 'CLOSED'
	            },
	            {
	                Key: this.translate.instant("LblREQUESTFORPAYMENT"),
	                Value: 'REQUESTFORPAYMENT'
	            },
	            {
	                Key: this.translate.instant("LblREOPEN"),
	                Value: 'REOPEN'
	            }
	        ];
	        this.InvoiceStatus = this.InvoiceStatusAll;
	        this.invoiceModel.invoiceStatusList = this.InvoiceStatus.map(function (x) { return x.Value; });
	        this.invoiceModel.status = '';
	        //this.invoiceStatusSelect.set(this.invoiceModel.invoiceStatusList);
	        this.LblSelect = this.translate.instant('LblSelect');
	        this.LblStatus = this.translate.instant('LblStatus');
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlDriverInfo = this.authService.GetURL(config_1.ApplicationRouteURL.URL_PERSON_UPDATE);
	        this.urlOrganizationInfo = this.authService.GetURL(config_1.ApplicationRouteURL.URL_ORGANIZATION_UPDATE);
	        this.urlInvoice = this.authService.GetURL(config_1.ApplicationRouteURL.URL_INVOICE_UPDATE);
	        this.urlPaymentHistory = this.authService.GetURL(config_1.ApplicationRouteURL.URL_PAYMENT_HISTORY);
	        this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigDueDate = this.SetFlatPickrConfigForDueDate();
	        this.addInvoiceLink = new config_1.WeGoAuthorizedLink(this.urlInvoice, config_1.Permission.PR_INVOICE, config_1.PermissionType.INSERT, 'btn btn-highlight navbar-right', 'LblAddNew');
	        this.invoiceStatusUpdateModel = new invoice_model_1.InvoiceStatusUpdateModel();
	        if (this.itemPerPageList.indexOf(500) < 0) {
	            this.itemPerPageList.push(500);
	            this.itemPerPageList.push(1000);
	        }
	        this.GetIvoiceList();
	    };
	    InvoiceListComponent.prototype.ngAfterViewInit = function () {
	        this.RenderBookingStatus();
	        this.invoiceStatusSelect.set(this.invoiceModel.invoiceStatusList);
	    };
	    InvoiceListComponent.prototype.SetDefaultFlatPickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = false;
	        flatPickrConfig.time_24hr = true;
	        flatPickrConfig.dateFormat = this.dateFormat;
	        flatPickrConfig.minuteIncrement = 1;
	        return flatPickrConfig;
	    };
	    InvoiceListComponent.prototype.SetFlatPickrConfigForDueDate = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = false;
	        flatPickrConfig.minDate = new Date(new Date().setHours(0, 0, 0));
	        flatPickrConfig.dateFormat = this.dateTimeFormat;
	        flatPickrConfig.minuteIncrement = 1;
	        return flatPickrConfig;
	    };
	    InvoiceListComponent.prototype.ShowDeleteConfirmModal = function (invoiceHashId) {
	        this.isLoading = false;
	        this.deleteMessage = this.translate.instant('LblRecordDeleteConfirmation', [
	            this.module
	        ]);
	        this.deleteConfirmModal.show();
	        this.invoiceHashId = invoiceHashId;
	    };
	    InvoiceListComponent.prototype.HideDeleteConfirmModal = function () {
	        this.deleteConfirmModal.hide();
	    };
	    InvoiceListComponent.prototype.DeleteConfirmSuccessClick = function () {
	        this.deleteConfirmModal.hide();
	        this.DeleteInvoice();
	    };
	    InvoiceListComponent.prototype.DeleteInvoice = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.invoiceService.DeleteInvoice(this.invoiceHashId).subscribe(function (res) {
	            if (res.data) {
	                _this.DataListModel.currentPage = 1;
	                _this.GetIvoiceList();
	                _this.popupMsg = _this.translate.instant('LblRecordRemovedSuccess', [
	                    _this.module
	                ]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblInvoiceDeleteValidation');
	                _this.isLoading = false;
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    InvoiceListComponent.prototype.OnDateSearch = function () {
	        this.GetIvoiceList();
	    };
	    InvoiceListComponent.prototype.GetIvoiceList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.invoiceService
	            .GetInvoiceList(this.DataListModel, this.invoiceModel)
	            .subscribe(function (res) {
	            _this.invoiceList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.isLoading = false;
	            _this.errorModel = [];
	            if (typeof res.error == 'string') {
	                _this.DataListModel.infoMessage = res.error;
	            }
	            else if (res.error) {
	                _this.errorModel = res.error;
	                _this.DataListModel.infoMessage = _this.translate.instant('LblNoDataFound');
	            }
	            _this.IsDirectDebitEnabled();
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    InvoiceListComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetIvoiceList();
	    };
	    InvoiceListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetIvoiceList();
	    };
	    InvoiceListComponent.prototype.OnSearch = function (event) {
	        if (event.isReset) {
	            this.invoiceModel.startDateTime = '';
	            this.invoiceModel.endDateTime = '';
	        }
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetIvoiceList();
	    };
	    InvoiceListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetIvoiceList();
	    };
	    InvoiceListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.invoiceService
	            .ExportInvoiceList(this.DataListModel, this.invoiceModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = 'Invoice' + new Date().toISOString() + '.csv';
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    InvoiceListComponent.prototype.DownloadInvoice = function (invoiceNumber) {
	        var _this = this;
	        this.isLoading = true;
	        this.invoiceService.DownloadInvoice(invoiceNumber).subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = 'Invoice' + new Date().toISOString() + '.pdf';
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    InvoiceListComponent.prototype.DownloadOfflineInvoicePDF = function (invoiceNumber) {
	        var _this = this;
	        this.isLoading = true;
	        this.invoiceService.DownloadInvoicePDF(invoiceNumber).subscribe(function (res) {
	            if (res.data) {
	                var linkSource = 'data:application/pdf;base64,' + res.data;
	                var downloadLink_1 = document.createElement("a");
	                var fileName = invoiceNumber + ".pdf";
	                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
	                    var byteCharacters = window.atob(res.data);
	                    var byteNumbers = new Array(byteCharacters.length);
	                    for (var i = 0; i < byteCharacters.length; i++) {
	                        byteNumbers[i] = byteCharacters.charCodeAt(i);
	                    }
	                    var byteArray = new Uint8Array(byteNumbers);
	                    var blob = new Blob([byteArray], { type: 'application/pdf' });
	                    window.navigator.msSaveOrOpenBlob(blob, fileName);
	                }
	                else {
	                    downloadLink_1.href = linkSource;
	                    downloadLink_1.download = fileName;
	                    downloadLink_1.click();
	                    setTimeout(function () {
	                        downloadLink_1.remove();
	                    }, 5000);
	                }
	            }
	            else if (res.error) {
	                _this.errorPopupMsg = _this.translate.instant('LblFileNotFound');
	                _this.errorPopupTitle = _this.translate.instant('LblError');
	                _this.errorPopup.show();
	            }
	            else {
	                _this.errorPopupMsg = _this.translate.instant('LblNoDataFound');
	                _this.errorPopupTitle = _this.translate.instant('LblError');
	                _this.errorPopup.show();
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    InvoiceListComponent.prototype.IsDirectDebitEnabled = function () {
	        var _this = this;
	        this.invoiceService.IsDirectDebitEnabled().subscribe(function (res) {
	            if (res) {
	                _this.isDirectDebitEnabled = res.data;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    InvoiceListComponent.prototype.ShowResendConfirmModal = function (invoiceNumber) {
	        this.invoiceNumber = invoiceNumber;
	        this.isLoading = false;
	        this.confirmMsg = this.translate.instant('LblResendInvoiceConfirm', [
	            this.module
	        ]);
	        this.resendConfirmModal.show();
	    };
	    InvoiceListComponent.prototype.ShowPaymentLink = function (paymentLink) {
	        this.popupMsg =
	            paymentLink && paymentLink.trim()
	                ? paymentLink
	                : this.translate.instant('LblNoPaymentLinkGenerated');
	        this.successPopup.popupTitle = this.translate.instant('LblPaymentLink');
	        this.successPopup.show(false);
	    };
	    InvoiceListComponent.prototype.ShowDueDateEditModal = function (paymentLink) {
	        this.popupMsg =
	            paymentLink && paymentLink.trim()
	                ? paymentLink
	                : this.translate.instant('LblNoPaymentLinkGenerated');
	        this.successPopup.popupTitle = this.translate.instant('LblPaymentLink');
	        this.successPopup.show(false);
	    };
	    InvoiceListComponent.prototype.SuccessConfirmModalClick = function () {
	        this.resendConfirmModal.hide();
	        this.ResendInvoice();
	    };
	    InvoiceListComponent.prototype.HideConfirmModal = function () {
	        this.resendConfirmModal.hide();
	    };
	    InvoiceListComponent.prototype.ResendInvoice = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.invoiceService.ResendBookingInvoice(this.invoiceNumber).subscribe(function (res) {
	            _this.isLoading = false;
	            _this.popupMsg = _this.translate.instant('LblinvoiceResendSuccess', [
	                _this.module
	            ]);
	            _this.ShowSuccessPopup();
	            _this.GetIvoiceList();
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    InvoiceListComponent.prototype.CheckEmptyIBAN = function () {
	        var mylist = [];
	        this.missingABANNumber.model = this.invoiceList
	            .filter(function (x) { return !x.ibanAvailable && x.isChecked && x.includeinDirectDebit; })
	            .map(function (y) {
	            if (mylist.indexOf(y.driverName + y.instanceName) < 0) {
	                var returnObj = {};
	                returnObj['driverName'] = y.driverName;
	                returnObj['instanceName'] = y.instanceName;
	                mylist.push(y.driverName + y.instanceName);
	                return returnObj;
	            }
	        })
	            .filter(function (x) { return x != null; });
	        if (this.missingABANNumber.model.length > 0) {
	            this.missingABANNumber.show();
	        }
	        else {
	            this.popupMsg = this.translate.instant('LblNoEmptyIBANFound', [
	                this.module
	            ]);
	            this.ShowSuccessPopup();
	        }
	    };
	    InvoiceListComponent.prototype.CreateDirectDebitFile = function ($event) {
	        var _this = this;
	        if ($event != undefined) {
	            this.SetDirectDebitSearchData($event);
	            this.createDirectDebitModel.isDirectDebitClick = false;
	        }
	        else {
	            this.createDirectDebitModel.isDirectDebitClick = true;
	        }
	        this.invoiceService
	            .GetDirectDebitFile(this.selectedFormat, this.invoiceList)
	            .subscribe(function (res) {
	            _this._directDebitFileXML = res.data;
	            if (_this._directDebitFileXML.length > 0) {
	                _this.createDirectDebitModel.companyDDModel = _this._directDebitFileXML;
	                _this.createDirectDebitModel.model = _this._directDebitFileXML;
	                if ($event == undefined) {
	                    _this.createDirectDebitModel.show();
	                }
	            }
	            else {
	                _this.successPopup.popupTitle = _this.translate.instant('LblWarning');
	                _this.popupMsg = _this.translate.instant('LblNoInvoiceSelected', [
	                    _this.module
	                ]);
	                _this.successPopup.show();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    Object.defineProperty(InvoiceListComponent.prototype, "isPaymentHistoryAccess", {
	        get: function () {
	            if (this.invoiceList) {
	                return this.invoiceList.some(function (x) { return x.isPaymentHistoryView; });
	            }
	            else {
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(InvoiceListComponent.prototype, "isInvoiceEditAccess", {
	        get: function () {
	            if (this.invoiceList) {
	                return this.invoiceList.some(function (x) { return x.isEditable; });
	            }
	            else {
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    InvoiceListComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.popupTitle = this.translate.instant('LblSuccess');
	        this.successPopup.show();
	    };
	    InvoiceListComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    InvoiceListComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    InvoiceListComponent.prototype.OnDownloadDirectDebitSaved = function () {
	        this.GetIvoiceList();
	    };
	    InvoiceListComponent.prototype.SetDirectDebitSearchData = function ($event) {
	        this.selectedFormat = $event.format;
	    };
	    InvoiceListComponent.prototype.ShowAddManualInvoiceModal = function () {
	        this.manualInvoicePopup.model = new invoice_model_1.InvoiceModel();
	        this.manualInvoicePopup.show();
	    };
	    InvoiceListComponent.prototype.ShowDueDateChangeModal = function (invoiceHashId) {
	        this.errorModel = [];
	        this.invoiceHashId = invoiceHashId;
	        this.dueDateUpdatedDate = '';
	        this.dueDateValidationMessage = '';
	        this.editDueDateModal.show();
	    };
	    InvoiceListComponent.prototype.HideDueDateChangeModal = function () {
	        this.editDueDateModal.hide();
	    };
	    InvoiceListComponent.prototype.SuccessDueDateChangeModalClick = function () {
	        var _this = this;
	        if (this.dueDateUpdatedDate) {
	            this.invoiceService
	                .UpdateDueDateForInvoice(this.invoiceHashId, this.dueDateUpdatedDate)
	                .subscribe(function (res) {
	                if (res.data) {
	                    _this.editDueDateModal.hide();
	                    _this.DataListModel.currentPage = 1;
	                    _this.GetIvoiceList();
	                    _this.popupMsg = _this.translate.instant('LblDueDateUpdateSuccess');
	                    _this.ShowSuccessPopup();
	                }
	                else {
	                    _this.dueDateValidationMessage = '';
	                    _this.errorModel = res.error;
	                }
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	                _this.isLoading = false;
	            });
	        }
	        else {
	            this.dueDateValidationMessage = this.translate.instant('LblDueDateRequiredError');
	        }
	    };
	    InvoiceListComponent.prototype.ShowInvoiceStatusUpdateModal = function (invoiceHashId, invoiceStatus) {
	        this.isLoading = false;
	        if (invoiceStatus == 'CLOSED') {
	            this.statusUpdateModalMsg = this.translate.instant('LblConfirmCloseInvoice');
	        }
	        else {
	            this.statusUpdateModalMsg = this.translate.instant('LblConfirmReOpenInvoice');
	        }
	        this.invoiceStatusUpdateModel = new invoice_model_1.InvoiceStatusUpdateModel();
	        this.errorModel = [];
	        this.GetInvoiceReopenClosedReasons(invoiceStatus);
	        this.invoiceStatusUpdateModal.show();
	        this.invoiceStatusUpdateModel.invoiceHashId = invoiceHashId;
	        this.invoiceStatusUpdateModel.status = invoiceStatus;
	    };
	    InvoiceListComponent.prototype.HideInvoiceStatusUpdateModal = function () {
	        this.invoiceStatusUpdateModal.hide();
	    };
	    InvoiceListComponent.prototype.SuccessInvoiceStatusUpdateConfirmModalClick = function () {
	        this.UpdateInvoiceStatus();
	    };
	    InvoiceListComponent.prototype.GetInvoiceReopenClosedReasons = function (invoiceStatus) {
	        var _this = this;
	        this.invoiceService.GetInvoiceReopenClosedReasons(invoiceStatus).subscribe(function (res) {
	            _this.invoiceOpenCloseReasonList = res.data;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    InvoiceListComponent.prototype.UpdateInvoiceStatus = function () {
	        var _this = this;
	        this.invoiceService
	            .UpdateInvoiceStatus(this.invoiceStatusUpdateModel)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.invoiceStatusUpdateModal.hide();
	                _this.DataListModel.currentPage = 1;
	                _this.GetIvoiceList();
	                _this.popupMsg = _this.translate.instant('LblInvoiceOpenCloseSuccess', [
	                    _this.invoiceStatusUpdateModel.status == 'CLOSED'
	                        ? (_this.popupMsg = _this.translate.instant('LblClosed'))
	                        : (_this.popupMsg = _this.translate.instant('LblReOpen'))
	                ]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    InvoiceListComponent.prototype.RenderBookingStatus = function () {
	        var _this = this;
	        // if (this.NormalBookingView) {
	        this.invoiceStatusSelect = new SlimSelect({
	            select: '#invoiceStatus',
	            placeholder: this.LblSelect + ' ' + this.LblStatus,
	            showSearch: false,
	            showContent: 'down',
	            onChange: function (info) {
	                // if (this.NormalBookingView) {
	                _this.invoiceModel.invoiceStatusList = info.map(function (x) { return x.value; });
	                // }
	                //console.log(info);
	            }
	        });
	    };
	    InvoiceListComponent.prototype.SuccessSelectDriverModal = function ($event) {
	        this.invoiceModel.searchDriverNameList = $event.DriverName;
	        this.searchDriverName = this.invoiceModel.searchDriverNameList.join();
	        this.invoiceModel.driverHashIdList = $event.DriverHashID;
	    };
	    InvoiceListComponent.prototype.ClearDriver = function () {
	        this.invoiceModel.searchDriverNameList = [];
	        this.searchDriverName = "";
	        this.invoiceModel.driverHashId = "";
	        this.invoiceModel.driverHashIdList = [];
	    };
	    InvoiceListComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    __decorate([
	        core_1.ViewChild('editDueDateModal'), 
	        __metadata('design:type', Object)
	    ], InvoiceListComponent.prototype, "editDueDateModal", void 0);
	    __decorate([
	        core_1.ViewChild('resendConfirmModal'), 
	        __metadata('design:type', Object)
	    ], InvoiceListComponent.prototype, "resendConfirmModal", void 0);
	    __decorate([
	        core_1.ViewChild('deleteConfirmModal'), 
	        __metadata('design:type', Object)
	    ], InvoiceListComponent.prototype, "deleteConfirmModal", void 0);
	    __decorate([
	        core_1.ViewChild('manualCloseInvoiceConfirmModal'), 
	        __metadata('design:type', Object)
	    ], InvoiceListComponent.prototype, "manualCloseInvoiceModal", void 0);
	    __decorate([
	        core_1.ViewChild('invoiceStatusUpdateModal'), 
	        __metadata('design:type', Object)
	    ], InvoiceListComponent.prototype, "invoiceStatusUpdateModal", void 0);
	    __decorate([
	        core_1.ViewChild('reOpenInvoiceConfirmModal'), 
	        __metadata('design:type', Object)
	    ], InvoiceListComponent.prototype, "reOpenInvoiceModal", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], InvoiceListComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild('errorPopup'), 
	        __metadata('design:type', Object)
	    ], InvoiceListComponent.prototype, "errorPopup", void 0);
	    __decorate([
	        core_1.ViewChild('missingABANNumber'), 
	        __metadata('design:type', Object)
	    ], InvoiceListComponent.prototype, "missingABANNumber", void 0);
	    __decorate([
	        core_1.ViewChild('createDirectDebitModel'), 
	        __metadata('design:type', Object)
	    ], InvoiceListComponent.prototype, "createDirectDebitModel", void 0);
	    __decorate([
	        core_1.ViewChild('manualInvoicePopup'), 
	        __metadata('design:type', Object)
	    ], InvoiceListComponent.prototype, "manualInvoicePopup", void 0);
	    InvoiceListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-invoice-list',
	            template: __webpack_require__(724),
	            providers: [invoice_service_1.InvoiceService, jquery_helper_service_1.JQueryHelperService],
	            styles: [
	                "\n      .invoiceLinkDisabled {\n        cursor: not-allowed;\n      }\n\n      .inputWidth-100-Percent {\n        width: 100%;\n      }\n\n      .modal-body {\n        word-wrap: break-word;\n      }\n    "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof invoice_service_1.InvoiceService !== 'undefined' && invoice_service_1.InvoiceService) === 'function' && _a) || Object, (typeof (_b = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof jquery_helper_service_1.JQueryHelperService !== 'undefined' && jquery_helper_service_1.JQueryHelperService) === 'function' && _e) || Object])
	    ], InvoiceListComponent);
	    return InvoiceListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.InvoiceListComponent = InvoiceListComponent;


/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var Observable_1 = __webpack_require__(5);
	var config_1 = __webpack_require__(60);
	var jquery_helper_service_1 = __webpack_require__(67);
	var InvoiceService = (function () {
	    function InvoiceService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	        this.JQueryHelper = new jquery_helper_service_1.JQueryHelperService();
	    }
	    InvoiceService.prototype.GetInvoiceList = function (input, invoicemodel) {
	        var getInvoiceUrl = config_1.WeGoConfig.API_GET_BOOKING_INVOICE_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var queryStringinvoicemodel = this.JQueryHelper.Param(invoicemodel);
	        if (queryString) {
	            getInvoiceUrl = getInvoiceUrl + "?" + queryString;
	        }
	        getInvoiceUrl =
	            getInvoiceUrl + "&" + decodeURIComponent(queryStringinvoicemodel);
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInvoiceUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InvoiceService.prototype.ExportInvoiceList = function (input, invoicemodel) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var getInvoiceUrl = config_1.WeGoConfig.API_EXPORT_BOOKING_INVOICE_LIST + "?" + queryString;
	        var queryStringinvoicemodel = this.JQueryHelper.Param(invoicemodel);
	        getInvoiceUrl =
	            getInvoiceUrl + "&" + decodeURIComponent(queryStringinvoicemodel);
	        var headers = this.authService.GetHeader("text/csv");
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getInvoiceUrl, options);
	    };
	    InvoiceService.prototype.DeleteInvoice = function (invoiceHashId) {
	        var deleteInvoiceUrl = config_1.WeGoConfig.API_DELETE_INVOICE + "?invoiceHashId=" + invoiceHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(deleteInvoiceUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InvoiceService.prototype.ResendBookingInvoice = function (invoiceNumber) {
	        var getInvoiceUrl = config_1.WeGoConfig.API_RESEND_BOOKING_INVOICE + "?invoiceNumber=" + invoiceNumber;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInvoiceUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InvoiceService.prototype.DownloadInvoice = function (invoiceNumber) {
	        var getInvoiceUrl = config_1.WeGoConfig.API_DOWNLOAD_BOOKING_INVOICE +
	            "?invoiceNumber=" +
	            invoiceNumber;
	        var headers = this.authService.GetHeader("application/pdf");
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getInvoiceUrl, options);
	    };
	    InvoiceService.prototype.DownloadInvoicePDF = function (invoiceNumber) {
	        var getInvoiceUrl = config_1.WeGoConfig.API_DOWNLOAD_BOOKING_INVOICE_OFFLINE_PDF +
	            "?invoiceNumber=" +
	            invoiceNumber;
	        var body = "";
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(getInvoiceUrl, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InvoiceService.prototype.GetDirectDebitFileList = function (input, directdebitmodel) {
	        var getInvoiceUrl = config_1.WeGoConfig.API_GET_DIRECT_DEBIT_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var queryStringinvoicemodel = this.JQueryHelper.Param(directdebitmodel);
	        if (queryString) {
	            getInvoiceUrl = getInvoiceUrl + "?" + queryString;
	        }
	        getInvoiceUrl =
	            getInvoiceUrl + "&" + decodeURIComponent(queryStringinvoicemodel);
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInvoiceUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InvoiceService.prototype.ExportDirectDebitFileList = function (input, directdebitmodel) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var getInvoiceUrl = config_1.WeGoConfig.API_EXPORT_DIRECT_DEBIT_LIST + "?" + queryString;
	        var queryStringinvoicemodel = this.JQueryHelper.Param(directdebitmodel);
	        getInvoiceUrl =
	            getInvoiceUrl + "&" + decodeURIComponent(queryStringinvoicemodel);
	        var headers = this.authService.GetHeader("text/csv");
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getInvoiceUrl, options);
	    };
	    InvoiceService.prototype.GetDirectDebitFile = function (format, invoicemodel) {
	        var getInvoiceUrl = config_1.WeGoConfig.API_GET_DIRECTDEBIT + "?selectedFormat=" + format;
	        var body = invoicemodel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(getInvoiceUrl, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InvoiceService.prototype.DownloadDirectDebitFile = function (input, DirectDebitDate, SelectedFormat) {
	        var getInvoiceUrl = config_1.WeGoConfig.API_CREATE_DIRECT_DEBIT_FOR_COMPANY +
	            "?RequestedCollectionDate=" +
	            DirectDebitDate +
	            "&SelectedFormat=" +
	            SelectedFormat;
	        var body = input;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(getInvoiceUrl, body, options);
	    };
	    InvoiceService.prototype.ReCreateDirectDebitFile = function (directDebitFileHashId) {
	        var getInvoiceUrl = config_1.WeGoConfig.API_RECREATE_DIRECT_DEBIT_FOR_COMPANY +
	            "?directDebitFileHashId=" +
	            directDebitFileHashId;
	        var body = "";
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(getInvoiceUrl, body, options);
	    };
	    InvoiceService.prototype.IsDirectDebitEnabled = function () {
	        var getDirectDebitFileConfigStatus = config_1.WeGoConfig.API_GET_IS_DIRECTDEBIT_ENABLED;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getDirectDebitFileConfigStatus, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InvoiceService.prototype.GetDriverList = function (InstancehashId, input, CompanyHashId) {
	        var getDriverUrl = config_1.WeGoConfig.API_GET_DRIVER_LIST_INVOICE;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getDriverUrl =
	                getDriverUrl +
	                    "?" +
	                    queryString +
	                    "&instanceHashId= " +
	                    InstancehashId +
	                    "&companyHashId=" +
	                    CompanyHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getDriverUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InvoiceService.prototype.GetOrganizationList = function (InstancehashId, input, CompanyHashId) {
	        var getDriverUrl = config_1.WeGoConfig.API_GET_ORGANIZATION_LIST_INVOICE;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getDriverUrl =
	                getDriverUrl +
	                    "?" +
	                    queryString +
	                    "&instanceHashId= " +
	                    InstancehashId +
	                    "&companyHashId=" +
	                    CompanyHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getDriverUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InvoiceService.prototype.UpdateManualInvoice = function (invoiceModel, sendInvoice) {
	        if (sendInvoice === void 0) { sendInvoice = false; }
	        var body = invoiceModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        var updateManualInvoiceUrl = config_1.WeGoConfig.API_POST_MANUAL_INVOICE + "?sendInvoice=" + sendInvoice;
	        return this.http
	            .post(updateManualInvoiceUrl, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InvoiceService.prototype.GetInvoiceNumber = function () {
	        var getDirectDebitFileConfigStatus = config_1.WeGoConfig.API_GET_INVOICE_NUMBER;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getDirectDebitFileConfigStatus, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InvoiceService.prototype.GetManualInvoiceByHashId = function (invoiceHashId) {
	        var getInvoicedetailUrl = config_1.WeGoConfig.API_GET_INVOICE_BY_HASH + "?invoiceHashId=" + invoiceHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInvoicedetailUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InvoiceService.prototype.GetCompanyAddress = function (companyHashId) {
	        var getDirectDebitFileConfigStatus = config_1.WeGoConfig.API_GET_COMPANY_ADDRESS + "?companyHashId=" + companyHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getDirectDebitFileConfigStatus, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InvoiceService.prototype.GetDriverAddress = function (driverHashId) {
	        var getDirectDebitFileConfigStatus = config_1.WeGoConfig.API_GET_DRIVER_ADDRESS + "?driverHashId=" + driverHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getDirectDebitFileConfigStatus, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InvoiceService.prototype.GetOrganizationAddress = function (organizationHashId) {
	        var getDirectDebitFileConfigStatus = config_1.WeGoConfig.API_GET_ORGANIZATION_ADDRESS +
	            "?organizationHashId=" +
	            organizationHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getDirectDebitFileConfigStatus, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InvoiceService.prototype.GetDropdownBookingList = function (sharedVehicleDriverHashId, organizationHashId) {
	        var getCostTypeUrl;
	        getCostTypeUrl = config_1.WeGoConfig.API_GET_DROPDOWN_MANUAL_INVOICE_BOOKING_LIST;
	        getCostTypeUrl =
	            getCostTypeUrl +
	                "?sharedVehicleDriverHashId=" +
	                sharedVehicleDriverHashId +
	                "&organizationHashId=" +
	                organizationHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getCostTypeUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InvoiceService.prototype.RemoveCostAndExpenses = function (costandExpensesHashId) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        var postRemoveCostAndExpensesFromInvoice = config_1.WeGoConfig.API_POST_REMOVE_COSTANDEXPENSE_FROM_INVOICE +
	            "?costAndExpenseHashId=" +
	            costandExpensesHashId;
	        return this.http
	            .post(postRemoveCostAndExpensesFromInvoice, "", options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InvoiceService.prototype.GetInvoicePaymentHistory = function (paymentHistoryModel, input) {
	        var getPaymentHistoryListUrl = config_1.WeGoConfig.API_INVOICE_PAYMENT_HISTORY_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var queryStringInvoiceHistoryModel = this.JQueryHelper.Param(paymentHistoryModel);
	        if (queryString) {
	            getPaymentHistoryListUrl = getPaymentHistoryListUrl + "?" + queryString;
	        }
	        getPaymentHistoryListUrl =
	            getPaymentHistoryListUrl +
	                "&" +
	                decodeURIComponent(queryStringInvoiceHistoryModel);
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getPaymentHistoryListUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InvoiceService.prototype.GetBookingInvoiceBasicDetails = function (invoiceHashId) {
	        var getCompnayUrl = config_1.WeGoConfig.API_GET_INVOICE_BASIC_DETAILS +
	            "?invoiceHashId=" +
	            invoiceHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getCompnayUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InvoiceService.prototype.UpdateCostAndExpenses = function (formData, moduleName) {
	        var _this = this;
	        var Apiurl = "";
	        if (moduleName == "INVOICE") {
	            Apiurl = config_1.WeGoConfig.API_POST_UPDATE_COSTANDEXPENSE_MANUALINVOICE;
	        }
	        else {
	            Apiurl = config_1.WeGoConfig.API_POST_UPDATE_COSTANDEXPENSE;
	        }
	        return Observable_1.Observable.create(function (observer) {
	            var url = Apiurl;
	            var xhr = new XMLHttpRequest();
	            var header = _this.authService.GetHeaderForFile();
	            xhr.onreadystatechange = function () {
	                if (xhr.readyState === 4) {
	                    if (xhr.status === 200) {
	                        console.log(xhr.response);
	                        observer.next(JSON.parse(xhr.response));
	                        observer.complete();
	                    }
	                    else {
	                        observer.error(xhr.status);
	                    }
	                }
	            };
	            xhr.open("POST", url, true);
	            for (var i = 0; i < header.length; i++) {
	                xhr.setRequestHeader(header[i]["name"], header[i]["value"]);
	            }
	            xhr.send(formData);
	        });
	    };
	    InvoiceService.prototype.ExportInvoicePaymentHistory = function (paymentHistoryModel, input) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var exportPaymentHistoryUrl = config_1.WeGoConfig.API_EXPORT_INVOICE_PAYMENT_HISTORY;
	        var queryStringinvoicemodel = this.JQueryHelper.Param(paymentHistoryModel);
	        exportPaymentHistoryUrl =
	            exportPaymentHistoryUrl +
	                "?" +
	                decodeURIComponent(queryStringinvoicemodel);
	        var headers = this.authService.GetHeader("text/csv");
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(exportPaymentHistoryUrl, options);
	    };
	    InvoiceService.prototype.UpdateDueDateForInvoice = function (invoiceHashId, updatedDueDate) {
	        var getUpdateDueDateUrl = config_1.WeGoConfig.API_GET_UPDATE_DUE_DATE_FOR_INVOICE +
	            "?invoiceHashId=" +
	            invoiceHashId +
	            "&updatedDueDate=" +
	            updatedDueDate;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getUpdateDueDateUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InvoiceService.prototype.UpdateInvoiceStatus = function (invoiceStatusUpdateModel) {
	        var getUpdateInvoiceStatusUrl = config_1.WeGoConfig.API_POST_UPDATE_INVOICE_STATUS;
	        var body = invoiceStatusUpdateModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(getUpdateInvoiceStatusUrl, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InvoiceService.prototype.GetInvoiceReopenClosedReasons = function (invoiceStatus) {
	        var getCostTypeUrl;
	        getCostTypeUrl =
	            invoiceStatus == "CLOSED"
	                ? config_1.WeGoConfig.API_GET_INVOICE_CLOSED_REASON_DROPDOWN_URL
	                : config_1.WeGoConfig.API_GET_INVOICE_REOPEN_REASON_DROPDOWN_URL;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getCostTypeUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InvoiceService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], InvoiceService);
	    return InvoiceService;
	    var _a, _b;
	}());
	exports.InvoiceService = InvoiceService;


/***/ },
/* 724 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ 'LblBookingInvoice' | translate }} {{ 'LblList' | translate }} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li class=\"active\"> {{ 'LblBookingInvoice' | translate }} {{ 'LblList' | translate }}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25\">\r\n      <wego-authorized-link [LinkModel]=\"addInvoiceLink\" (onClick)=\"ShowAddManualInvoiceModal()\"></wego-authorized-link>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <div class=\"row\">\r\n          <div class=\"form-group col-md-2\">\r\n            <label>{{ 'LblFrom' | translate }}</label>\r\n            <div class=\"clearfix\"></div>\r\n            <div class=\"input-group\">\r\n              <span class=\"input-group-addon\">\r\n                <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n              </span>\r\n              <input flatpickr readonly [Config]=\"flatPickrConfigFrom\" [(ngModel)]=\"invoiceModel.startDateTime\" name=\"TimeBlockStartDate\"\r\n                type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblFrom' | translate }}\">\r\n            </div>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'startDateTime' }}</span>\r\n          </div>\r\n          <div class=\"form-group col-md-2\">\r\n            <label>{{ 'LblTo' | translate }}</label>\r\n            <div class=\"clearfix \"></div>\r\n            <div class=\"input-group\">\r\n              <span class=\"input-group-addon\">\r\n                <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n              </span>\r\n              <input flatpickr readonly [Config]=\"flatPickrConfigTo\" [(ngModel)]=\"invoiceModel.endDateTime\" name=\"TimeBlockStartDate\" type=\"text\"\r\n                class=\"form-control\" placeholder=\"{{ 'LblTo' | translate }}\">\r\n            </div>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'endDateTime' }}</span>\r\n          </div>\r\n          <div class=\"form-group col-md-3 nopad-left\">\r\n            <label>{{ 'LblStatus' | translate }} </label>\r\n            <select id=\"invoiceStatus\" name=\"invoiceStatus\" multiple>\r\n              <!-- <option value=\"\">{{ 'LblAll' | translate }} {{ 'LblStatus' | translate }}</option> -->\r\n              <option *ngFor=\"let item of InvoiceStatusAll\" [attr.value]='item.Value'>{{item.Key}}</option>\r\n            </select>\r\n\r\n            <!-- <select    id =\"bookingStatusSpecial\" name=\"bookingStatusSpecial\" (change)=\"BookingStatusChanged()\" \r\n            multiple>              \r\n            <option  *ngFor=\"let item of BookingStatusSpecialBooking\"  [attr.value]='item.Value'>{{item.Key}}</option>\r\n          </select> -->\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'invoiceStatus' }}</span>\r\n          </div>\r\n          <div class=\"form-group nopad-left col-md-3\">\r\n            <label>{{ 'LblDriver' | translate }}</label>\r\n            <div class=\"input-group\">\r\n              <input [(ngModel)]=\"searchDriverName\" [attr.title]=\"searchDriverName\" name=\"driverName\" type=\"text\" class=\"form-control\"\r\n                placeholder=\"{{ 'LblAll' | translate }} {{ 'LblDriver' | translate }}\" readonly>\r\n              <div class=\"input-group-btn\">\r\n                <button class=\"btn btn-default\" type=\"button\" (click)=\"selectDriverModal.show(invoiceModel.driverHashIdList,invoiceModel.searchDriverNameList)\">\r\n                  <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\r\n                </button>\r\n                <button class=\"btn btn-default\" type=\"button\" (click)=\"ClearDriver()\">\r\n                  <i class=\"fa fa-eraser\" aria-hidden=\"true\"></i>\r\n                </button>\r\n              </div>\r\n            </div>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'DriverHashId' }}</span>\r\n          </div>\r\n          <div class=\"form-group col-md-1\">\r\n            <label>\r\n              <span class=\"text text-danger\"></span>\r\n            </label>\r\n            <div class=\"clearfix\"></div>\r\n            <button class=\"btn btn-default navbar-left mar_t_5\" (click)=\"OnDateSearch()\">{{ 'LblSearch' | translate}}</button>\r\n          </div>\r\n        </div>\r\n        <wego-search-list (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\"\r\n          [ItemPerPage]=\"DataListModel.itemsPerPage\" [itemPerPageList]=\"itemPerPageList\"></wego-search-list>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"table table-responsive mar_bot_ziro\" style=\"width: 101%;overflow-x: scroll;\">\r\n          <table class=\"table table-bordered mar_bot_ziro\" style=\"width: 101%;overflow-x: scroll;max-width: 101%;\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('invoiceNumber')\">\r\n                  {{ 'LblInvoiceNumber' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'invoiceNumber'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th style=\"width: 50px;\" class=\"cursor-pointer\" (click)=\"OnSort('InvoiceSendDateTimeUTC')\">\r\n                  {{ 'LblDate' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'InvoiceSendDateTimeUTC'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('invoiceDueDateTimeUTC')\">\r\n                  {{ 'LblDueDate' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'invoiceDueDateTimeUTC'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('translatedStatus')\">\r\n                  {{ 'LblInvoiceStatus' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'translatedStatus'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <!-- <th class=\"cursor-pointer\" (click)=\"OnSort('driverName')\">\r\n                  {{ 'LblDriverName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'driverName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('organizationName')\">\r\n                  {{'LblOrganization' | translate}}\r\n                  <wego-sort-list [FieldName]=\"'organizationName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th> -->\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('addressee')\">\r\n                  {{ 'LblAddressee' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'addressee'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('sharedVehicleGroup')\">\r\n                  {{ 'LblSharedVehicleGroup' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'sharedVehicleGroup'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <!-- Check Payment History Right -->\r\n                <th *ngIf=\"isPaymentHistoryAccess\">\r\n                  {{ 'LblPaymentHistory' | translate }}\r\n                </th>\r\n                <th>\r\n                  {{ 'LblPaymentLink' | translate }}\r\n                </th>\r\n\r\n                <!-- <th class=\"cursor-pointer\" (click)=\"OnSort('company')\">\r\n                  {{ 'LblCompany' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'company'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th> -->\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('totalAmount')\">\r\n                  {{'LblTotal' | translate}}\r\n                  <wego-sort-list [FieldName]=\"'totalAmount'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('invoiceType')\">\r\n                  {{'LblInvoiceType' | translate}}\r\n                  <wego-sort-list [FieldName]=\"'invoiceType'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n\r\n                <th class=\"cursor-pointer text-center\">\r\n                  {{'LblReOpenClose' | translate}}\r\n                </th>\r\n\r\n                <th class=\"cursor-pointer text-center\"> {{'LblResend' | translate}}</th>\r\n\r\n                <th class=\"cursor-pointer text-center\"> {{'LblDownload' | translate}}</th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let invoice of invoiceList\">\r\n                  <td *ngIf=\"invoice.invoiceType == 'MANUAL' && invoice.isEditable\">\r\n                    <a [routerLink]=\"urlInvoice + '/' + invoice.invoiceHashId\">\r\n                      {{ invoice.invoiceNumber }}\r\n                    </a>\r\n                  </td>\r\n                  <td *ngIf=\"invoice.invoiceType !='MANUAL' || !invoice.isEditable \">\r\n                    {{ invoice.invoiceNumber }}\r\n                  </td>\r\n                  <td>\r\n                    <label  *ngIf=\"invoice.status !='OPEN'\">\r\n                      {{ invoice.invoiceSendDateTime }} </label>\r\n                  </td>\r\n                  <td *ngIf=\"isInvoiceEditAccess\">{{ invoice.invoiceDueDateTime }}\r\n                    <a *ngIf=\"(invoice.status=='REOPEN' || invoice.status=='REQUESTFORPAYMENT') && invoice.invoiceDueDateTime && invoice.isEditable && invoice.isDueDateChangeEnable\"\r\n                      class=\"cursor-pointer \" (click)=\"ShowDueDateChangeModal(invoice.invoiceHashId)\">\r\n                      <i class=\"fa fa-edit\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td *ngIf=\"!isInvoiceEditAccess\">{{ \"\" }}\r\n                  </td>\r\n                  <td>{{ invoice.translatedStatus  }}</td>\r\n                  <td>\r\n                    <template [ngIf]=\"invoice.isDriverEdit && !invoice.isPersonDeleted && !invoice.organizationHashId\">\r\n                      <!-- TODO COMMENT THIS LINE START\r\n                      [routerLink]=\"[urlDriverInfo,{ personId : invoice.sharedVehicleGroupDriverHashId }]\"\r\n                      TODO COMMENT THIS LINE END -->\r\n                      <template [ngIf]=\"invoice.sharedVehicleGroupDriverHashId\">\r\n                        <a [routerLink]=\"urlDriverInfo + '/' + invoice.sharedVehicleGroupDriverHashId\">\r\n                          {{ invoice.addressee }}\r\n                        </a>\r\n                      </template>\r\n                      <template [ngIf]=\"!invoice.sharedVehicleGroupDriverHashId && invoice.driverHashId\">\r\n                        <a [routerLink]=\"urlDriverInfo + '/' + invoice.driverPersonHashId\">\r\n                          {{ invoice.addressee }}\r\n                        </a>\r\n                      </template>\r\n                    </template>\r\n                    <template [ngIf]=\"(invoice.isPersonDeleted || !invoice.isDriverEdit) && !invoice.organizationHashId\">\r\n                      {{ invoice.addressee }}\r\n                    </template>\r\n                    <template [ngIf]=\"invoice.isOrganizationEdit && !invoice.IsOrganizationDeleted && invoice.organizationHashId\">\r\n                      <a [routerLink]=\"urlOrganizationInfo + '/' + invoice.organizationHashId\">\r\n                        {{ invoice.addressee }}\r\n                      </a>\r\n                    </template>\r\n                    <template [ngIf]=\"(!invoice.isOrganizationEdit || invoice.IsOrganizationDeleted) && invoice.organizationHashId\">\r\n                      {{ invoice.addressee }}\r\n                    </template>\r\n                  </td>\r\n                  <!-- <td>\r\n                    {{ invoice.driver }}\r\n                  </td> -->\r\n                  <!-- <td>{{ invoice.organizationName }}</td> -->\r\n                  <!-- <td>{{ invoice.addressee }}</td> -->\r\n                  <td>{{ invoice.sharedVehicleGroup }}</td>\r\n                  <!-- Check Payment History Right -->\r\n                  <td *ngIf=\"isPaymentHistoryAccess\" class=\"text-center \">\r\n                    <a [routerLink]=\"urlPaymentHistory + '/' + invoice.invoiceHashId\">\r\n                      <!-- {{ invoice.invoiceNumber }} -->\r\n                      <i class=\"fa fa-book\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center \">\r\n                    <a *ngIf=\"(invoice.status=='REOPEN' || invoice.status=='REQUESTFORPAYMENT') && invoice.paymentLink\" class=\"cursor-pointer \"\r\n                      (click)=\"ShowPaymentLink(invoice.paymentLink)\">\r\n                      <i class=\"fa fa-credit-card \"></i>\r\n                    </a>\r\n                  </td>\r\n                  <!-- <td>{{ invoice.company }}</td> -->\r\n                  <td>{{ invoice.total }}</td>\r\n                  <td>{{ invoice.invoiceType }}</td>\r\n                  <td *ngIf=\"isInvoiceEditAccess\" class=\"text-center \">\r\n                    <a *ngIf=\"(invoice.status=='REOPEN' || invoice.status=='REQUESTFORPAYMENT' || invoice.status=='OPEN/SENT') && invoice.isEditable\"\r\n                      class=\"cursor-pointer \" (click)=\"ShowInvoiceStatusUpdateModal(invoice.invoiceHashId,'CLOSED')\">\r\n                      <i class=\"fa fa-window-close fa-fw\"></i>\r\n                    </a>\r\n                    <a *ngIf=\"invoice.status=='CLOSED' && invoice.invoiceCloseReason=='ManuallyClosed' && invoice.isEditable\" class=\"cursor-pointer \"\r\n                      (click)=\"ShowInvoiceStatusUpdateModal(invoice.invoiceHashId,'REOPEN')\">\r\n                      <i class=\"fa fa-retweet fa-fw\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td *ngIf=\"!isInvoiceEditAccess\" class=\"text-center \">\r\n                    {{\"\"}}\r\n                  </td>\r\n                  <td class=\"text-center \">\r\n                    <div *ngIf=\"invoice.status=='OPEN'\" class=\"invoiceLinkDisabled\">\r\n                      <i class=\"fa fa-envelope fa-fw\"></i>\r\n                    </div>\r\n                    <a *ngIf=\"invoice.status!='OPEN'\" class=\"cursor-pointer\" (click)=\"ShowResendConfirmModal(invoice.invoiceNumber) \">\r\n                      <i class=\"fa fa-envelope fa-fw \"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center \">\r\n                    <div *ngIf=\"invoice.status=='OPEN'\" class=\"invoiceLinkDisabled\">\r\n                      <i class=\"fa fa-download fa-fw\"></i>\r\n                    </div>\r\n                    <a *ngIf=\"invoice.status!='OPEN'\" href=\"javascript:void(0);\" (click)=\"DownloadOfflineInvoicePDF(invoice.invoiceNumber)\">\r\n                      <!--<a class=\"cursor-pointer \" (click)=\"DownloadInvoice(invoice.invoiceNumber) \">-->\r\n                      <i class=\"fa fa-download fa-fw \"></i>\r\n                    </a>\r\n                  </td>\r\n                  <!-- <td class=\"text-center\">\r\n                    <a *ngIf=\"invoice.isDeletable\" class=\"cursor-pointer\" (click)=\"ShowDeleteConfirmModal(invoice.invoiceHashId)\">\r\n                      <i class=\"fa fa-trash-o fa-fw text-danger\"></i>\r\n                    </a>\r\n                  </td> -->\r\n\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems==0 && !isLoading \">\r\n                <td class=\"text-center text-danger \" colspan=\"20 \">\r\n                  {{ DataListModel.infoMessage }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix \"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro \">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad \">\r\n            <div class=\"col-md-12 \">\r\n              <pagination class=\"pull-right \" [totalItems]=\"DataListModel.totalItems \" [itemsPerPage]=\"DataListModel.itemsPerPage\r\n                      \" [(ngModel)]=\"DataListModel.currentPage \" [maxSize]=\"DataListModel.maxSize \" [boundaryLinks]=\"true \"\r\n                previousText=\"&lsaquo; \" nextText=\"&rsaquo;\r\n                      \" firstText=\"&laquo; \" lastText=\"&raquo; \" [rotate]=\"false \" (pageChanged)=\"OnPageChanged($event) \"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<div bsModal #editDueDateModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-sm\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"HideDueDateChangeModal()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblConfirm' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        {{ 'LblConfirmDuedatechange' | translate }}\r\n        <br/>\r\n        <br/>\r\n        <div class=\"input-group\">\r\n          <span class=\"input-group-addon\">\r\n            <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n          </span>\r\n          <input flatpickr readonly [Config]=\"flatPickrConfigDueDate\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblDueDate' | translate }}\"\r\n            [(ngModel)]=\"dueDateUpdatedDate\" name=\"dayEndTime\" maxlength=\"100\">\r\n        </div>\r\n        <span class=\"text text-danger\">{{ dueDateValidationMessage }}</span>\r\n        <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'dueDateValidationMessage' }}</span>\r\n      </div>\r\n      <div class=\"modal-footer\">\r\n        <button type=\"button\" class=\"btn btn-green\" (click)=\"SuccessDueDateChangeModalClick()\">{{ 'LblYes' | translate }}</button>\r\n        <button type=\"button\" class=\"btn btn-gray cursor-pointer\" (click)=\"HideDueDateChangeModal()\">{{ 'LblNo' | translate }}</button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<div bsModal #invoiceStatusUpdateModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-sm\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"HideInvoiceStatusUpdateModal()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblConfirm' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        {{ statusUpdateModalMsg }}\r\n        <br/>\r\n        <br/>\r\n        <div class=\"form-group\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>&nbsp;{{'LblReason' | translate }}\r\n          </label>\r\n          <select [(ngModel)]=\"invoiceStatusUpdateModel.reason\" class=\"form-control\" name=\"customerHashId\">\r\n            <option value=''>{{ 'LblSelect' | translate }} {{ 'LblReason' | translate }} </option>\r\n            <option *ngFor=\"let item of invoiceOpenCloseReasonList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\r\n          </select>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'reason' }}</span>\r\n        </div>\r\n      </div>\r\n      <div class=\"modal-footer\">\r\n        <button type=\"button\" class=\"btn btn-green\" (click)=\"SuccessInvoiceStatusUpdateConfirmModalClick()\">{{ 'LblYes' | translate }}</button>\r\n        <button type=\"button\" class=\"btn btn-gray cursor-pointer\" (click)=\"HideInvoiceStatusUpdateModal()\">{{ 'LblNo' | translate }}</button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading \"></wego-lodder>\r\n\r\n<wego-confirm-popup #resendConfirmModal [popupMsg]=\"confirmMsg \" (onConfirm)=\"SuccessConfirmModalClick() \" (onReject)=\"HideConfirmModal() \"></wego-confirm-popup>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup() \"></wego-success-popup>\r\n<wego-confirm-popup #deleteConfirmModal [popupMsg]=\"deleteMessage\" (onConfirm)=\"DeleteConfirmSuccessClick()\" (onReject)=\"HideDeleteConfirmModal()\"></wego-confirm-popup>\r\n\r\n<wego-booking-driver-popup #selectDriverModal (OnSuccessSelect)=\"SuccessSelectDriverModal($event)\"></wego-booking-driver-popup>\r\n\r\n<wego-success-popup #errorPopup [popupMsg]=\"errorPopupMsg\" [popupTitle]=\"errorPopupTitle\"></wego-success-popup>\r\n";

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var contractType_service_1 = __webpack_require__(726);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var ContractTypeHistoryComponent = (function () {
	    function ContractTypeHistoryComponent(contractTypeService, activeRoute, authService, router, translate) {
	        this.contractTypeService = contractTypeService;
	        this.activeRoute = activeRoute;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	    }
	    ContractTypeHistoryComponent.prototype.ngOnInit = function () {
	        this.DataListModel = new config_1.DataListModel();
	    };
	    ContractTypeHistoryComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetContractTypeHistory();
	    };
	    ContractTypeHistoryComponent.prototype.OnSearch = function (event) {
	        this.DataListModel.searchTerm = event.searchTerm;
	        this.DataListModel.currentPage = 1;
	        this.GetContractTypeHistory();
	    };
	    ContractTypeHistoryComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetContractTypeHistory();
	    };
	    ;
	    ContractTypeHistoryComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetContractTypeHistory();
	    };
	    ContractTypeHistoryComponent.prototype.GetContractTypeHistory = function () {
	        var _this = this;
	        console.log('this.versionId');
	        console.log(this.versionId);
	        this.isLoading = true;
	        this.contractTypeService.GetContractTypeHistory(this.versionId, this.DataListModel)
	            .subscribe(function (res) {
	            _this.contractTypeList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    ContractTypeHistoryComponent.prototype.show = function () {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.sortType = "";
	        this.DataListModel.sortReverse = null;
	        this.DataListModel.searchTerm = "";
	        this.DataListModel.infoMessage = "";
	        this.GetContractTypeHistory();
	        this.ContractTypeHistoryModal.show();
	    };
	    ContractTypeHistoryComponent.prototype.hide = function () {
	        this.ContractTypeHistoryModal.hide();
	    };
	    __decorate([
	        core_1.ViewChild('ContractTypeHistoryModal'), 
	        __metadata('design:type', Object)
	    ], ContractTypeHistoryComponent.prototype, "ContractTypeHistoryModal", void 0);
	    ContractTypeHistoryComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-contractType-history',
	            template: __webpack_require__(727),
	            providers: [contractType_service_1.ContractTypeService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof contractType_service_1.ContractTypeService !== 'undefined' && contractType_service_1.ContractTypeService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _e) || Object])
	    ], ContractTypeHistoryComponent);
	    return ContractTypeHistoryComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.ContractTypeHistoryComponent = ContractTypeHistoryComponent;


/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var ContractTypeService = (function () {
	    function ContractTypeService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    ContractTypeService.prototype.GetContractTypeList = function (contractTypeGroupHashId, input) {
	        var personHashId = this.authService.GetPersonHashId();
	        var getContractTypeUrl = config_1.WeGoConfig.API_GET_CONTRACT_TYPE_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getContractTypeUrl = getContractTypeUrl + "?" + queryString + "&contractTypeGroupHashId=" + contractTypeGroupHashId;
	        }
	        else {
	            getContractTypeUrl = getContractTypeUrl + "?contractTypeGroupHashId=" + contractTypeGroupHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getContractTypeUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    ContractTypeService.prototype.GetContractTypeByHashId = function (contractTypeHashId) {
	        var getContractTypeUrl = config_1.WeGoConfig.API_GET_CONTRACT_TYPE_BY_HASH + "?contractTypeHashId=" + contractTypeHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getContractTypeUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    ContractTypeService.prototype.AddContractType = function (contractTypeModel) {
	        var body = contractTypeModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_POST_CONTRACT_TYPE_DETAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    ContractTypeService.prototype.DeleteContractType = function (selectedcontractTypeHashId, contractTypeGroupHashId) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        var getContractTypeUrl = config_1.WeGoConfig.API_POST_DELETE_CONTRACT_TYPE;
	        getContractTypeUrl = getContractTypeUrl + "?contractTypeGroupHashId=" + contractTypeGroupHashId;
	        return this.http.post(getContractTypeUrl, selectedcontractTypeHashId, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    ContractTypeService.prototype.ExportContractTypeList = function (contractTypeGroupHashId, input) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var getContractUrl = config_1.WeGoConfig.API_EXPORT_CONTRACT_TYPE_LIST;
	        if (queryString) {
	            getContractUrl = getContractUrl + "?" + queryString + "&contractTypeGroupHashId=" + contractTypeGroupHashId;
	        }
	        else {
	            getContractUrl = getContractUrl + "?contractTypeGroupHashId=" + contractTypeGroupHashId;
	        }
	        var headers = this.authService.GetHeader('text/csv');
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getContractUrl, options);
	    };
	    ContractTypeService.prototype.GetContractTypeHistory = function (versionId, input) {
	        var personHashId = this.authService.GetPersonHashId();
	        var getContractTypeUrl = config_1.WeGoConfig.API_GET_CONTRACT_TYPE_HISTORY;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getContractTypeUrl = getContractTypeUrl + "?" + queryString + "&versionId=" + versionId;
	        }
	        else {
	            getContractTypeUrl = getContractTypeUrl + "?versionId=" + versionId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getContractTypeUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    ContractTypeService.prototype.GetSpecialPeriods = function (sharedVehicleGroupHashId, input) {
	        var getContractTypeUrl = config_1.WeGoConfig.API_GET_SPECIAL_PERIOD_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getContractTypeUrl = getContractTypeUrl + "?" + queryString + "&sharedVehicleGroupHashId=" + sharedVehicleGroupHashId;
	        }
	        else {
	            getContractTypeUrl = getContractTypeUrl + "?sharedVehicleGroupHashId=" + sharedVehicleGroupHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getContractTypeUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    ContractTypeService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], ContractTypeService);
	    return ContractTypeService;
	    var _a, _b;
	}());
	exports.ContractTypeService = ContractTypeService;


/***/ },
/* 727 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #ContractTypeHistoryModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblContractType' | translate }} {{ 'LblContractTypeHistory' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th>\r\n                  {{ 'LblContractName' | translate }}\r\n                </th>\r\n                <th>\r\n                  {{ 'LblContractTypeType' | translate }}\r\n                </th>\r\n                <th>\r\n                  {{ 'LblSMo' | translate }}\r\n                </th>\r\n                <th>\r\n                  {{ 'LblSTu' | translate }}\r\n                </th>\r\n                <th>\r\n                  {{ 'LblSWe' | translate }}\r\n                </th>\r\n                <th>\r\n                  {{ 'LblSTh' | translate }}\r\n                </th>\r\n                <th>\r\n                  {{ 'LblSFr' | translate }}\r\n                </th>\r\n                <th>\r\n                  {{ 'LblSSa' | translate }}\r\n                </th>\r\n                <th>\r\n                  {{ 'LblSSu' | translate }}\r\n                </th>\r\n                <th>\r\n                  {{ 'LblFrom' | translate }}\r\n                </th>\r\n                <th>\r\n                  {{ 'LblTo' | translate }}\r\n                </th>\r\n                <th>\r\n                  {{ 'LblPeriodRate' | translate }}\r\n                </th>\r\n                <th>\r\n                  {{ 'LblTimeRate' | translate }}\r\n                </th>\r\n                <th>\r\n                  {{ 'LblMileageRate' | translate }}\r\n                </th>\r\n                <th>\r\n                  {{ 'LblFixedFee' | translate }}\r\n                </th>\r\n                <th>\r\n                  {{'LblModifiedDate' | translate}}\r\n                </th>\r\n                <th>\r\n                  {{'LblModifiedBy' | translate}}\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"totalItems != 0\">\r\n                <tr *ngFor=\"let contractType of contractTypeList\">\r\n                  <td>{{ contractType.contractName }}</td>\r\n                  <td>{{ contractType.contractTypeType }}</td>\r\n                  <!-- <td class=\"text-center\">\r\n                    <i class=\"fa fa-fw\" [ngClass]=\"{'fa-check-square-o': contractType.monFlag, 'fa-square-o': !contractType.monFlag}\"></i>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <i class=\"fa fa-fw\" [ngClass]=\"{'fa-check-square-o': contractType.tueFlag, 'fa-square-o': !contractType.tueFlag}\"></i>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <i class=\"fa fa-fw\" [ngClass]=\"{'fa-check-square-o': contractType.wedFlag, 'fa-square-o': !contractType.wedFlag}\"></i>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <i class=\"fa fa-fw\" [ngClass]=\"{'fa-check-square-o': contractType.thuFlag, 'fa-square-o': !contractType.thuFlag}\"></i>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <i class=\"fa fa-fw\" [ngClass]=\"{'fa-check-square-o': contractType.friFlag, 'fa-square-o': !contractType.friFlag}\"></i>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <i class=\"fa fa-fw\" [ngClass]=\"{'fa-check-square-o': contractType.satFlag, 'fa-square-o': !contractType.satFlag}\"></i>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <i class=\"fa fa-fw\" [ngClass]=\"{'fa-check-square-o': contractType.sunFlag, 'fa-square-o': !contractType.sunFlag}\"></i>\r\n                  </td>\r\n                  <td>\r\n                    {{ contractType.dayStartTime }}\r\n                  </td>\r\n                  <td>\r\n                    {{ contractType.dayEndTime }}\r\n                  </td> -->\r\n                  <td class=\"text-center\">\r\n                    <i *ngIf=\"contractType.contractTypeType == 'REGULAR'\" class=\"fa fa-fw\" [ngClass]=\"{'fa-check-square-o': contractType.monFlag, 'fa-square-o': !contractType.monFlag}\"></i>\r\n                    <span *ngIf=\"contractType.contractTypeType != 'REGULAR'\">-</span>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <i *ngIf=\"contractType.contractTypeType == 'REGULAR'\" class=\"fa fa-fw\" [ngClass]=\"{'fa-check-square-o': contractType.tueFlag, 'fa-square-o': !contractType.tueFlag}\"></i>\r\n                    <span *ngIf=\"contractType.contractTypeType != 'REGULAR'\">-</span>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <i *ngIf=\"contractType.contractTypeType == 'REGULAR'\" class=\"fa fa-fw\" [ngClass]=\"{'fa-check-square-o': contractType.wedFlag, 'fa-square-o': !contractType.wedFlag}\"></i>\r\n                    <span *ngIf=\"contractType.contractTypeType != 'REGULAR'\">-</span>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <i *ngIf=\"contractType.contractTypeType == 'REGULAR'\" class=\"fa fa-fw\" [ngClass]=\"{'fa-check-square-o': contractType.thuFlag, 'fa-square-o': !contractType.thuFlag}\"></i>\r\n                    <span *ngIf=\"contractType.contractTypeType != 'REGULAR'\">-</span>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <i *ngIf=\"contractType.contractTypeType == 'REGULAR'\" class=\"fa fa-fw\" [ngClass]=\"{'fa-check-square-o': contractType.friFlag, 'fa-square-o': !contractType.friFlag}\"></i>\r\n                    <span *ngIf=\"contractType.contractTypeType != 'REGULAR'\">-</span>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <i *ngIf=\"contractType.contractTypeType == 'REGULAR'\" class=\"fa fa-fw\" [ngClass]=\"{'fa-check-square-o': contractType.satFlag, 'fa-square-o': !contractType.satFlag}\"></i>\r\n                    <span *ngIf=\"contractType.contractTypeType != 'REGULAR'\">-</span>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <i *ngIf=\"contractType.contractTypeType == 'REGULAR'\" class=\"fa fa-fw\" [ngClass]=\"{'fa-check-square-o': contractType.sunFlag, 'fa-square-o': !contractType.sunFlag}\"></i>\r\n                    <span *ngIf=\"contractType.contractTypeType != 'REGULAR'\">-</span>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <span *ngIf=\"contractType.contractTypeType == 'REGULAR'\"> {{ contractType.dayStartTime }}</span>\r\n                    <span *ngIf=\"contractType.contractTypeType != 'REGULAR'\">-</span>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <span *ngIf=\"contractType.contractTypeType == 'REGULAR'\"> {{ contractType.dayEndTime }}</span>\r\n                    <span *ngIf=\"contractType.contractTypeType != 'REGULAR'\">-</span>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <span *ngIf=\"contractType.contractTypeType != 'REGULAR'\">{{ contractType.periodRateDisplay}}</span>\r\n                    <span *ngIf=\"contractType.contractTypeType == 'REGULAR'\">-</span>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <span *ngIf=\"contractType.contractTypeType == 'REGULAR'\">{{ contractType.hourlyRateDisplay}}</span>\r\n                    <span *ngIf=\"contractType.contractTypeType != 'REGULAR'\">-</span>\r\n                  </td>\r\n                  <td>\r\n                    {{ contractType.mileageRateDisplay}}\r\n                  </td>\r\n                  <td>\r\n                    {{ contractType.fixedFeeDisplay}}\r\n                  </td>\r\n                  <td>\r\n                    {{contractType.contractEndDateTime}}\r\n                  </td>\r\n                  <td>\r\n                    {{contractType.modifiedBy}}\r\n                  </td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"17\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>";

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var config_1 = __webpack_require__(60);
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var contractType_model_1 = __webpack_require__(729);
	var contractType_service_1 = __webpack_require__(726);
	var contracttypegroup_service_1 = __webpack_require__(730);
	var sharedvehiclegroup_service_1 = __webpack_require__(510);
	var router_1 = __webpack_require__(26);
	var config_2 = __webpack_require__(60);
	var ContractTypeUpdateComponent = (function () {
	    function ContractTypeUpdateComponent(contractTypeService, svgService, contracttypegroupService, activeRoute, authService, router, translate) {
	        this.contractTypeService = contractTypeService;
	        this.svgService = svgService;
	        this.contracttypegroupService = contracttypegroupService;
	        this.activeRoute = activeRoute;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.dateFormat = config_2.WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
	        this.timeFormat = config_2.WeGoConfig.FLATPICKR_TIME_FORMAT;
	        this.submitted = false;
	    }
	    ContractTypeUpdateComponent.prototype.ngOnInit = function () {
	        this.contractTypeTypeList = [
	            {
	                Key: this.translate.instant("LblRegular"),
	                Value: "REGULAR"
	            },
	            {
	                Key: this.translate.instant("LblWeekEnd"),
	                Value: "WEEKEND"
	            },
	            {
	                Key: this.translate.instant("LblDayCT"),
	                Value: "DAY"
	            }
	        ];
	        this.module = this.translate.instant("LblContractType");
	        this.sharedvehicleGroup = this.translate.instant("LblListPage", [
	            this.translate.instant("LblSharedVehicleGroup")
	        ]);
	        this.contractTypeGroup = this.translate.instant("LblListPage", [
	            this.translate.instant("LblContractTypeGroup")
	        ]);
	        this.DataListModel = new config_1.DataListModel();
	        this.contractTypePeriodList = [
	            {
	                Key: "Select Contract Type Period",
	                Value: ""
	            },
	            {
	                Key: "NORMAL",
	                Value: "NORMAL"
	            },
	            {
	                Key: "SPECIAL",
	                Value: "SPECIAL"
	            }
	        ];
	        this.urlDefaultPage = this.authService.GetURL(config_2.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlContractTypeList = this.authService.GetURL(config_2.ApplicationRouteURL.URL_CONTRACT_TYPE_LIST);
	        this.urlSVGList = this.authService.GetURL(config_2.ApplicationRouteURL.URL_SVG_LIST);
	        this.urlContractTypeGroupList = this.authService.GetURL(config_2.ApplicationRouteURL.URL_CONTRACT_TYPE_GROUP_LIST);
	        this.GetContractTypeDetails();
	        this.GetSpecialPeriodsBySharedVehicleGroup();
	    };
	    ContractTypeUpdateComponent.prototype.onSubmit = function (forms) {
	        console.log("ADD");
	        this.submitted = true;
	        console.log(this.model);
	        this.AddNewContractType();
	    };
	    ContractTypeUpdateComponent.prototype.GetContractTypeDetails = function () {
	        var _this = this;
	        this.model = new contractType_model_1.ContractTypeModel();
	        this.model.contractTypeType = this.contractTypeTypeList[0].Value;
	        this.isEditMode = false;
	        this.sub = this.activeRoute.params.subscribe(function (params) {
	            var contractTypeHashId = params["contractTypeHashId"] || "";
	            _this.sharedVehicleGroupHashId = params["sharedVehicleGroupHashId"] || "";
	            _this.contractTypeGroupHashId = params["contractTypeGroupHashId"] || "";
	            _this.model.contractTypeGroupHashId = _this.contractTypeGroupHashId;
	            _this.GetVatSettingDropdownList();
	            if (contractTypeHashId != "") {
	                _this.isEditMode = true;
	                _this.isContractPeriod = true;
	                _this.contractTypeService
	                    .GetContractTypeByHashId(contractTypeHashId)
	                    .subscribe(function (res) {
	                    _this.model = res.data;
	                    _this.model.contractTypeGroupHashId = _this.contractTypeGroupHashId;
	                }, function (error) {
	                    _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	                    _this.isLoading = false;
	                });
	            }
	            else {
	                _this.GetCurrencyByGroup();
	            }
	        });
	        this.breadCrumbTitle = this.isEditMode
	            ? this.translate.instant("LblEditPage", [this.module])
	            : this.translate.instant("LblAddPage", [this.module]);
	        this.breadCrumbList = this.translate.instant("LblListPage", [this.module]);
	    };
	    ContractTypeUpdateComponent.prototype.GetCurrencyByGroup = function () {
	        var _this = this;
	        this.contracttypegroupService
	            .GetCurrencyByGroup(this.sharedVehicleGroupHashId)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.model.currencySymbol = res.data.currencySymbol;
	                _this.model.isCurrencySymbolBefore =
	                    res.data.currencySignBeforeAmount;
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    ContractTypeUpdateComponent.prototype.GetSpecialPeriodsBySharedVehicleGroup = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.contractTypeService
	            .GetSpecialPeriods(this.sharedVehicleGroupHashId)
	            .subscribe(function (res) {
	            _this.specialPeriodList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	            if (res.totalRecords == 0) {
	                _this.model.contractTypePeriod = _this.contractTypePeriodList[1].Value;
	                _this.isContractPeriod = true;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    ContractTypeUpdateComponent.prototype.AddNewContractType = function () {
	        var _this = this;
	        this.contractTypeService.AddContractType(this.model).subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.isEditMode
	                    ? _this.translate.instant("LblRecordUpdatedSuccess", [_this.module])
	                    : _this.translate.instant("LblRecordAddedSuccess", [_this.module]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    ContractTypeUpdateComponent.prototype.GetVatSettingDropdownList = function () {
	        var _this = this;
	        this.contracttypegroupService
	            .GetVatSettingDropdownList(this.sharedVehicleGroupHashId)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.vatSettingList = res.data;
	                if (!_this.isEditMode) {
	                    _this.GetVatSettingDefaultValues();
	                }
	            }
	            else {
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    ContractTypeUpdateComponent.prototype.GetVatSettingDefaultValues = function () {
	        var _this = this;
	        this.contracttypegroupService
	            .GetVatSettingDefaultValues(this.sharedVehicleGroupHashId)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.vatSettingDefaultValues = res.data;
	                _this.model.hourlyRateVat = _this.vatSettingDefaultValues.defaultVatTimeRates;
	                _this.model.mileageRateVat = _this.vatSettingDefaultValues.defaultVatDistanceRates;
	                _this.model.vatSettingDefaultCost = _this.vatSettingDefaultValues.vatSettingDefaultCost;
	                _this.model.fixedFeeVat = _this.vatSettingDefaultValues.defaultVatFixedRates;
	                _this.model.periodRateVat = _this.vatSettingDefaultValues.defaultVatPeriodRates;
	                _this.model.catAPricingModel.hourlyRateVat = _this.vatSettingDefaultValues.defaultVatTimeRates;
	                _this.model.catAPricingModel.mileageRateVat = _this.vatSettingDefaultValues.defaultVatDistanceRates;
	                _this.model.catAPricingModel.fixedFeeVat = _this.vatSettingDefaultValues.defaultVatFixedRates;
	                _this.model.catAPricingModel.periodRateVat = _this.vatSettingDefaultValues.defaultVatPeriodRates;
	                _this.model.catBPricingModel.hourlyRateVat = _this.vatSettingDefaultValues.defaultVatTimeRates;
	                _this.model.catBPricingModel.mileageRateVat = _this.vatSettingDefaultValues.defaultVatDistanceRates;
	                _this.model.catBPricingModel.fixedFeeVat = _this.vatSettingDefaultValues.defaultVatFixedRates;
	                _this.model.catBPricingModel.periodRateVat = _this.vatSettingDefaultValues.defaultVatPeriodRates;
	                _this.model.catCPricingModel.hourlyRateVat = _this.vatSettingDefaultValues.defaultVatTimeRates;
	                _this.model.catCPricingModel.mileageRateVat = _this.vatSettingDefaultValues.defaultVatDistanceRates;
	                _this.model.catCPricingModel.fixedFeeVat = _this.vatSettingDefaultValues.defaultVatFixedRates;
	                _this.model.catCPricingModel.periodRateVat = _this.vatSettingDefaultValues.defaultVatPeriodRates;
	                _this.model.catDPricingModel.hourlyRateVat = _this.vatSettingDefaultValues.defaultVatTimeRates;
	                _this.model.catDPricingModel.mileageRateVat = _this.vatSettingDefaultValues.defaultVatDistanceRates;
	                _this.model.catDPricingModel.fixedFeeVat = _this.vatSettingDefaultValues.defaultVatFixedRates;
	                _this.model.catDPricingModel.periodRateVat = _this.vatSettingDefaultValues.defaultVatPeriodRates;
	                _this.model.catEPricingModel.hourlyRateVat = _this.vatSettingDefaultValues.defaultVatTimeRates;
	                _this.model.catEPricingModel.mileageRateVat = _this.vatSettingDefaultValues.defaultVatDistanceRates;
	                _this.model.catEPricingModel.fixedFeeVat = _this.vatSettingDefaultValues.defaultVatFixedRates;
	                _this.model.catEPricingModel.periodRateVat = _this.vatSettingDefaultValues.defaultVatPeriodRates;
	                _this.model.catFPricingModel.hourlyRateVat = _this.vatSettingDefaultValues.defaultVatTimeRates;
	                _this.model.catFPricingModel.mileageRateVat = _this.vatSettingDefaultValues.defaultVatDistanceRates;
	                _this.model.catFPricingModel.fixedFeeVat = _this.vatSettingDefaultValues.defaultVatFixedRates;
	                _this.model.catFPricingModel.periodRateVat = _this.vatSettingDefaultValues.defaultVatPeriodRates;
	                _this.model.catGPricingModel.hourlyRateVat = _this.vatSettingDefaultValues.defaultVatTimeRates;
	                _this.model.catGPricingModel.mileageRateVat = _this.vatSettingDefaultValues.defaultVatDistanceRates;
	                _this.model.catGPricingModel.fixedFeeVat = _this.vatSettingDefaultValues.defaultVatFixedRates;
	                _this.model.catGPricingModel.periodRateVat = _this.vatSettingDefaultValues.defaultVatPeriodRates;
	                _this.model.catHPricingModel.hourlyRateVat = _this.vatSettingDefaultValues.defaultVatTimeRates;
	                _this.model.catHPricingModel.mileageRateVat = _this.vatSettingDefaultValues.defaultVatDistanceRates;
	                _this.model.catHPricingModel.fixedFeeVat = _this.vatSettingDefaultValues.defaultVatFixedRates;
	                _this.model.catHPricingModel.periodRateVat = _this.vatSettingDefaultValues.defaultVatPeriodRates;
	            }
	            else {
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    ContractTypeUpdateComponent.prototype.ShowAlertModal = function () {
	        this.alertModal.show();
	    };
	    ContractTypeUpdateComponent.prototype.HideAlertModal = function () {
	        this.alertModal.hide();
	        this.router.navigate([this.urlContractTypeList]);
	    };
	    ContractTypeUpdateComponent.prototype.SuccessAlertModalClick = function () {
	        this.alertModal.hide();
	        this.router.navigate([
	            this.urlContractTypeList,
	            {
	                sharedVehicleGroupHashId: this.sharedVehicleGroupHashId,
	                contractTypeGroupHashId: this.contractTypeGroupHashId
	            }
	        ]);
	    };
	    ContractTypeUpdateComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    ContractTypeUpdateComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    ContractTypeUpdateComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	        this.router.navigate([
	            this.urlContractTypeList,
	            {
	                sharedVehicleGroupHashId: this.sharedVehicleGroupHashId,
	                contractTypeGroupHashId: this.contractTypeGroupHashId
	            }
	        ]);
	    };
	    ContractTypeUpdateComponent.prototype.SetVatDefaultCost = function (vatSettingDefaultCost) {
	        return vatSettingDefaultCost
	            ? this.translate.instant("LblExcludingVat")
	            : this.translate.instant("LblIncludingVat");
	    };
	    ContractTypeUpdateComponent.prototype.ngOnDestroy = function () {
	        if (this.sub) {
	            this.sub.unsubscribe();
	        }
	    };
	    __decorate([
	        core_1.ViewChild("alertModal"), 
	        __metadata('design:type', Object)
	    ], ContractTypeUpdateComponent.prototype, "alertModal", void 0);
	    __decorate([
	        core_1.ViewChild("successPopup"), 
	        __metadata('design:type', Object)
	    ], ContractTypeUpdateComponent.prototype, "successPopup", void 0);
	    ContractTypeUpdateComponent = __decorate([
	        core_1.Component({
	            selector: "wego-contractType",
	            template: __webpack_require__(731),
	            providers: [
	                contractType_service_1.ContractTypeService,
	                sharedvehiclegroup_service_1.SharedVehicleGroupService,
	                contracttypegroup_service_1.ContractTypeGroupService
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof contractType_service_1.ContractTypeService !== 'undefined' && contractType_service_1.ContractTypeService) === 'function' && _a) || Object, (typeof (_b = typeof sharedvehiclegroup_service_1.SharedVehicleGroupService !== 'undefined' && sharedvehiclegroup_service_1.SharedVehicleGroupService) === 'function' && _b) || Object, (typeof (_c = typeof contracttypegroup_service_1.ContractTypeGroupService !== 'undefined' && contracttypegroup_service_1.ContractTypeGroupService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object, (typeof (_e = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _f) || Object, (typeof (_g = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _g) || Object])
	    ], ContractTypeUpdateComponent);
	    return ContractTypeUpdateComponent;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.ContractTypeUpdateComponent = ContractTypeUpdateComponent;


/***/ },
/* 729 */
/***/ function(module, exports) {

	"use strict";
	var PericingCategoryModel = (function () {
	    function PericingCategoryModel() {
	        this.MileageRate = 0;
	    }
	    return PericingCategoryModel;
	}());
	exports.PericingCategoryModel = PericingCategoryModel;
	var ContractTypeModel = (function () {
	    function ContractTypeModel() {
	        this.isHourlyRate = false;
	        this.sunFlag = true;
	        this.monFlag = true;
	        this.tueFlag = true;
	        this.wedFlag = true;
	        this.thuFlag = true;
	        this.friFlag = true;
	        this.satFlag = true;
	        this.contractTypePeriod = '';
	        this.specialPeriodHashID = '';
	        this.freeTextSpecialPeriod = "";
	        this.periodRate = 0;
	        this.periodRateVat = '0';
	        this.hourlyRate = 0;
	        this.hourlyRateVat = '0';
	        this.mileageRate = 0;
	        this.mileageRateVat = '0';
	        this.fixedFee = 0;
	        this.fixedFeeVat = '0';
	        this.isCurrencySymbolBefore = true;
	        this.fixedFeeDisplay = '0';
	        this.vatSettingDefaultCost = true;
	        this.catAPricingModel = new PericingCategoryModel();
	        this.catBPricingModel = new PericingCategoryModel();
	        this.catCPricingModel = new PericingCategoryModel();
	        this.catDPricingModel = new PericingCategoryModel();
	        this.catEPricingModel = new PericingCategoryModel();
	        this.catFPricingModel = new PericingCategoryModel();
	        this.catGPricingModel = new PericingCategoryModel();
	        this.catHPricingModel = new PericingCategoryModel();
	    }
	    return ContractTypeModel;
	}());
	exports.ContractTypeModel = ContractTypeModel;


/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var ContractTypeGroupService = (function () {
	    function ContractTypeGroupService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    ContractTypeGroupService.prototype.GetContractTypeGroupBySharedVehicleGroup = function (sharedVehicleGroupHashId, input) {
	        var getContractTypeGroup = config_1.WeGoConfig.API_GET_CONTRACT_TYPE_GROUP_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getContractTypeGroup =
	                getContractTypeGroup +
	                    "?" +
	                    queryString +
	                    "&sharedVehicleGroupHashId=" +
	                    sharedVehicleGroupHashId;
	        }
	        else {
	            getContractTypeGroup =
	                getContractTypeGroup +
	                    "?sharedVehicleGroupHashId=" +
	                    sharedVehicleGroupHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getContractTypeGroup, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    ContractTypeGroupService.prototype.ExportContractTypeGroupBySharedVehicleGroup = function (sharedVehicleGroupHashId, input) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var getCompanyAdminUrl = config_1.WeGoConfig.API_EXPORT_CONTRACT_TYPE_GROUP_LIST +
	            "?" +
	            queryString +
	            "&sharedVehicleGroupHashId=" +
	            sharedVehicleGroupHashId;
	        var headers = this.authService.GetHeader("text/csv");
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getCompanyAdminUrl, options);
	    };
	    ContractTypeGroupService.prototype.AssignContractGroupToSharedVehicleGroup = function (contractTypeGroupModel) {
	        var body = contractTypeGroupModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_ASSIGN_CONTRACT_TYPE_GROUP, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    ContractTypeGroupService.prototype.GetContractTypeGroupByHashId = function (contractTypeGroupHashId) {
	        var getUrl = config_1.WeGoConfig.API_GET_CONTRACT_TYPE_GROUP_DETAIL +
	            "?contractTypeGroupHashId=" +
	            contractTypeGroupHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    ContractTypeGroupService.prototype.GetContractTypeGroupBasicDetail = function (contractTypeGroupHashId) {
	        var getcontractTypeGroupUrl = config_1.WeGoConfig.API_GET_CONTRACTTYPEGROUP_BASIC_DETAIL +
	            "?contractTypeGroupHashId=" +
	            contractTypeGroupHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getcontractTypeGroupUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    ContractTypeGroupService.prototype.AddContractType = function (contractTypeGroupModel) {
	        var body = contractTypeGroupModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_CONTRACT_TYPE_GROUP_DETAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    ContractTypeGroupService.prototype.GetInActiveReasonByHashId = function (contractTypeGroupHashId) {
	        var getUrl = config_1.WeGoConfig.API_GET_INACTIVE_REASON +
	            "?contractTypeGroupHashId=" +
	            contractTypeGroupHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    ContractTypeGroupService.prototype.GetCurrencyByGroup = function (sharedVehicleGroupHashId) {
	        var getUrl = config_1.WeGoConfig.API_GET_INSTANCE_BY_GROUP +
	            "?sharedVehicleGroupHashId=" +
	            sharedVehicleGroupHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    ContractTypeGroupService.prototype.DeleteContractTypeGroup = function (contractypegroupHashId) {
	        var getUrl = config_1.WeGoConfig.API_GET_DELETE_GROUP +
	            "?contractypegroupHashId=" +
	            contractypegroupHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    ContractTypeGroupService.prototype.GetVatSettingDropdownList = function (sharedVehicleGroupHashId) {
	        var getUrl = config_1.WeGoConfig.API_GET_DROPDOWN_VATSETTING_LIST +
	            "?sharedVehicleGroupHashId=" +
	            sharedVehicleGroupHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    ContractTypeGroupService.prototype.GetVatSettingDefaultValues = function (sharedVehicleGroupHashId) {
	        var getUrl = config_1.WeGoConfig.API_GET_VATSETTING_DEFAULT_VALUES +
	            "?sharedVehicleGroupHashId=" +
	            sharedVehicleGroupHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    ContractTypeGroupService.prototype.GetContractTypeBySVGHashId = function (sharedVehicleGroupHashId) {
	        var getUrl = config_1.WeGoConfig.API_GET_CONTRACT_TYPE_BY_SVGHASHID +
	            "?sharedVehicleGroupHashId=" +
	            sharedVehicleGroupHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    ContractTypeGroupService.prototype.GetDropdownListCTGBySVG = function (pageName, instanceHashId, companyHashId, sharedVehicleGroupHashId, subscriptionHashId) {
	        var getCTGUrl;
	        switch (pageName) {
	            case "Kick_Back_Report":
	                getCTGUrl =
	                    config_1.WeGoConfig.API_GET_DROPDOWN_CTG_LIST_BY_SVG_KICK_BACK_REPORT;
	                break;
	            case "Terms_And_Condition":
	                getCTGUrl =
	                    config_1.WeGoConfig.API_GET_DROPDOWN_CTG_LIST_BY_SVG_TERMS_AND_CONDITION;
	                break;
	            default:
	                getCTGUrl = config_1.WeGoConfig.API_GET_CONTRACT_TYPE_BY_SVGHASHID;
	                break;
	        }
	        if (instanceHashId) {
	            getCTGUrl = getCTGUrl + "?instanceHashId=" + instanceHashId;
	        }
	        if (companyHashId) {
	            getCTGUrl = getCTGUrl + "&companyHashId=" + companyHashId;
	        }
	        if (sharedVehicleGroupHashId) {
	            getCTGUrl =
	                getCTGUrl + "&sharedVehicleGroupHashId=" + sharedVehicleGroupHashId;
	        }
	        if (subscriptionHashId) {
	            getCTGUrl =
	                getCTGUrl + "&SubscriptionHshId=" + subscriptionHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getCTGUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    ContractTypeGroupService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], ContractTypeGroupService);
	    return ContractTypeGroupService;
	    var _a, _b;
	}());
	exports.ContractTypeGroupService = ContractTypeGroupService;


/***/ },
/* 731 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{breadCrumbTitle}}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"urlSVGList\">\r\n            <i class=\"fa fa-group fa-fw\"></i> {{ sharedvehicleGroup }}</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"[urlContractTypeGroupList, { sharedVehicleGroupHashId: sharedVehicleGroupHashId }]\">\r\n            <i class=\"fa fa-eur fa-fw\"></i> {{ contractTypeGroup }}</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"[urlContractTypeList, { sharedVehicleGroupHashId: sharedVehicleGroupHashId, contractTypeGroupHashId: contractTypeGroupHashId }]\">\r\n            <i class=\"fa fa-money fa-fw\"></i>{{ breadCrumbList }}</a>\r\n        </li>\r\n        <li class=\"active\">{{breadCrumbTitle}}</li>\r\n      </ol>\r\n    </div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"nopad\">\r\n      <form (ngSubmit)=\"onSubmit(AddContractTypeForm.value)\" #AddContractTypeForm=\"ngForm\">\r\n        <input type=\"hidden\" class=\"form-control\" [(ngModel)]=\"model.contractTypeHashId\" name=\"contractTypeHashId\">\r\n        <div class=\"form-group col-md-4\">\r\n          <label><span class=\"text text-danger\">*</span> {{ 'LblContractTypeType' | translate }}</label>\r\n          <select [(ngModel)]=\"model.contractTypeType\" class=\"form-control\" name=\"contractTypeType\">\r\n                <option *ngFor=\"let item of contractTypeTypeList\" [ngValue]=\"item.Value\">{{ item.Key }}</option>\r\n          </select>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'ContractTypeType' }}</span>\r\n        </div>\r\n           <div class=\"clearfix\"></div>\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span> {{ 'LblContractName' | translate }}\r\n          </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblContractName' | translate }}\" [(ngModel)]=\"model.contractName\"\r\n            name=\"ContractName\" maxlength=\"100\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'ContractName' }}</span>\r\n        </div>\r\n\r\n        <div class=\"form-group col-md-4\" [hidden]=\"isContractPeriod\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span> {{'LblContractTypPeriod' | translate}}</label>\r\n          <select [(ngModel)]=\"model.contractTypePeriod\" class=\"form-control\" name=\"specialPeriodType\">\r\n            <option *ngFor=\"let item of contractTypePeriodList\" [ngValue]=\"item.Value\">{{ item.Key }}</option>\r\n          </select>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'ContractTypePeriod' }}</span>\r\n        </div>\r\n\r\n        <div class=\"form-group col-md-4\">\r\n          <label>{{ 'LblComment' | translate }}</label>\r\n          <textarea rows=\"2\" cols=\"50\" class=\"form-control\" placeholder=\"{{ 'LblComment' | translate }}\" [(ngModel)]=\"model.comment\"\r\n            name=\"comment\" maxlength=\"500\"></textarea>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'comment' }}</span>\r\n        </div>\r\n\r\n        <div class=\"form-group col-md-4\" *ngIf=\"model.contractTypeType == 'REGULAR'\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span> {{ 'LblBookingIntervalRate' | translate }}</label>\r\n          <div class=\"clearfix\"></div>\r\n          <label class=\"radio-inline\">\r\n            <input type=\"radio\" [(ngModel)]=\"model.isHourlyRate\" name=\"IsHourlyRate\" [value]=\"true\">{{ 'LblPerHour' | translate }}</label>\r\n          <label class=\"radio-inline\">\r\n            <input type=\"radio\" [(ngModel)]=\"model.isHourlyRate\" name=\"IsHourlyRate\" [value]=\"false\">{{ 'LblPerBookingIntarval' | translate }}</label>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <template [ngIf]=\"model.contractTypeType == 'WEEKEND' || model.contractTypeType == 'DAY'\">\r\n          <fieldset class=\"col-md-12\">\r\n            <legend class=\"legendStyle\">\r\n              {{ 'LblSpecialPeriod' | translate }}\r\n            </legend>\r\n            <div class=\"clearfix\"></div>\r\n            <div class=\"form-group col-md-4\" *ngIf=\"model.contractTypeType == 'WEEKEND'\"> \r\n              <label>\r\n                {{ 'LblExtraTimeBefore' | translate }}</label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblExtraTimeBefore' | translate }}\" [(ngModel)]=\"model.extraTimeBefore\"\r\n                name=\"model.extraTimeBefore\" maxlength=\"5\" max=\"1439\">\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'ExtraTimeBefore' }}</span>\r\n            </div>\r\n            <div class=\"form-group col-md-4\" *ngIf=\"model.contractTypeType == 'WEEKEND'\">\r\n              <label>\r\n                {{ 'LblExtraTimeAfter' | translate }}</label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblExtraTimeAfter' | translate }}\" [(ngModel)]=\"model.extraTimeAfter\"\r\n                name=\"model.extraTimeAfter\" maxlength=\"5\" max=\"1439\">\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'ExtraTimeAfter' }}</span>\r\n            </div>\r\n            <div class=\"form-group col-md-4\">\r\n              <label>\r\n                {{ 'LblFreeTextDescription' | translate }}</label>\r\n              <textarea class=\"form-control\" placeholder=\"{{ 'LblFreeTextDescription' | translate }}\" [(ngModel)]=\"model.freeTextSpecialPeriod\"\r\n                name=\"model.freeTextSpecialPeriod\" cols=\"2\"></textarea>\r\n            </div>\r\n          </fieldset>\r\n        </template>\r\n\r\n        <template [ngIf]=\"model.contractTypePeriod == 'NORMAL'  && model.contractTypeType == 'REGULAR'\">\r\n          <fieldset class=\"col-md-12\">\r\n            <legend class=\"legendStyle\">\r\n              <span class=\"text text-danger\">* </span>{{ 'LblApplicableDays' | translate }}</legend>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'applicateDays' }}</span>\r\n            <div class=\"clearfix\"></div>\r\n            <div class=\"form-group\">\r\n              <div class=\"col-sm-3\">\r\n                <div class=\"checkbox\">\r\n                  <label>\r\n                    <input type=\"checkbox\" [checked]=\"model.sunFlag\" (change)=\"model.sunFlag = $event.target.checked\">{{ 'LblSunday' | translate }}</label>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"col-sm-3\">\r\n                <div class=\"checkbox\">\r\n                  <label>\r\n                    <input type=\"checkbox\" [checked]=\"model.monFlag\" (change)=\"model.monFlag = $event.target.checked\">{{ 'LblMonday' | translate }}</label>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"col-sm-3\">\r\n                <div class=\"checkbox\">\r\n                  <label>\r\n                    <input type=\"checkbox\" [checked]=\"model.tueFlag\" (change)=\"model.tueFlag = $event.target.checked\">{{ 'LblTuesday' | translate }}</label>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"col-sm-3\">\r\n                <div class=\"checkbox\">\r\n                  <label>\r\n                    <input type=\"checkbox\" [checked]=\"model.wedFlag\" (change)=\"model.wedFlag = $event.target.checked\">{{ 'LblWednesday' | translate }}</label>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"col-sm-3\">\r\n                <div class=\"checkbox\">\r\n                  <label>\r\n                    <input type=\"checkbox\" [checked]=\"model.thuFlag\" (change)=\"model.thuFlag = $event.target.checked\">{{ 'LblThursday' | translate }}</label>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"col-sm-3\">\r\n                <div class=\"checkbox\">\r\n                  <label>\r\n                    <input type=\"checkbox\" [checked]=\"model.friFlag\" (change)=\"model.friFlag = $event.target.checked\">{{ 'LblFriday' | translate }}</label>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"col-sm-3\">\r\n                <div class=\"checkbox\">\r\n                  <label>\r\n                    <input type=\"checkbox\" [checked]=\"model.satFlag\" (change)=\"model.satFlag = $event.target.checked\">{{ 'LblSaturday' | translate }}</label>\r\n                </div>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-group col-md-4\">\r\n              <label>\r\n                <span class=\"text text-danger\">*</span> {{ 'LblApplicableStartTime' | translate }}\r\n              </label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblApplicableStartTime' | translate }}\" [(ngModel)]=\"model.dayStartTime\"\r\n                name=\"dayStartTime\" maxlength=\"100\">\r\n              <!--<input flatpickr readonly [Config]=\"flatPickrConfigTimeFrom\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblDAYStartTime' | translate }}\"\r\n\t\t\t\t\t\t\t\t[(ngModel)]=\"model.dayStartTime\" name=\"dayStartTime\" maxlength=\"100\">-->\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'dayStartTime' }}</span>\r\n            </div>\r\n\r\n            <div class=\"form-group col-md-4\">\r\n              <label>\r\n                <span class=\"text text-danger\">*</span> {{ 'LblApplicableEndTime' | translate }}</label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblApplicableEndTime' | translate }}\" [(ngModel)]=\"model.dayEndTime\"\r\n                name=\"dayEndTime\" maxlength=\"100\">\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'dayEndTime' }}</span>\r\n            </div>\r\n\r\n          </fieldset>\r\n        </template>\r\n\r\n        <template [ngIf]=\"model.contractTypePeriod == 'SPECIAL'  && model.contractTypeType == 'REGULAR'\">\r\n          <div class=\"form-group col-md-4\">\r\n            <label>\r\n              <span class=\"text text-danger\">*</span> {{'LblSpecialPeriod' | translate}}</label>\r\n            <select [(ngModel)]=\"model.specialPeriodHashID\" class=\"form-control\" [disabled]=\"isEditMode\" name=\"specialPeriod\">\r\n              <option value='' [selected]='selected'>Select Special Period</option>\r\n              <option *ngFor=\"let item of specialPeriodList\" [ngValue]=\"item.specialPeriodHashId\">{{ item.specialPeriodName }}</option>\r\n            </select>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'SpecialPeriodHashId' }}</span>\r\n          </div>\r\n        </template>\r\n        <fieldset class=\"col-md-12\">\r\n          <legend class=\"legendStyle\">{{ 'LblPricingModel' | translate }} ({{ SetVatDefaultCost(model.vatSettingDefaultCost) }})</legend>\r\n          <div class=\"clearfix\"></div>\r\n          <div class=\"col-xs-2\" *ngIf=\"model.contractTypeType == 'WEEKEND' || model.contractTypeType == 'DAY'\">\r\n              <div class=\"form-group row-md-2\">\r\n                  <label><span class=\"text text-danger\">*</span> {{ 'LblPeriodRate' | translate }}</label>\r\n                  <div class=\"input-group\">\r\n                      <span *ngIf=\"model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                      <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblPeriodRate' | translate }}\" [(ngModel)]=\"model.periodRate\" name=\"model.periodRate\"\r\n                             maxlength=\"6\">\r\n                      <span *ngIf=\"!model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                  </div>\r\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'periodRate' }}</span></div>\r\n              <div class=\"form-group row-md-2\">\r\n                  <label>\r\n                      <span class=\"text text-danger\">*</span> {{ 'LblPeriodRateVat' | translate }}</label>\r\n                  <select [(ngModel)]=\"model.periodRateVat\" name=\"periodRateVat\" class=\"form-control\">\r\n                      <option *ngFor=\"let item of vatSettingList\" [value]='item.value'>{{item.data}}</option>\r\n                  </select>\r\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'periodRateVat' }}</span>\r\n              </div>\r\n          </div>\r\n          \r\n          <div class=\"col-xs-2\" *ngIf=\"model.contractTypeType != 'WEEKEND' && model.contractTypeType != 'DAY'\">\r\n              <div class=\"form-group row-md-2\">\r\n                  <label>\r\n                      <span class=\"text text-danger\">*</span> {{ 'LblTimeRate' | translate }}</label>\r\n                  <div class=\"input-group\">\r\n                      <span *ngIf=\"model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                      <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblTimeRate' | translate }}\" [(ngModel)]=\"model.hourlyRate\" name=\"model.HourlyRate\"\r\n                             maxlength=\"6\">\r\n                      <span *ngIf=\"!model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                  </div>\r\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'hourlyRate' }}</span>\r\n              </div>\r\n              <div class=\"form-group row-md-2\">\r\n                  <label>\r\n                      <span class=\"text text-danger\">*</span> {{ 'LblTimeRateVat' | translate }}</label>\r\n                  <select [(ngModel)]=\"model.hourlyRateVat\" name=\"hourlyRateVat\" class=\"form-control\">\r\n                      <option *ngFor=\"let item of vatSettingList\" [value]='item.value'>{{item.data}}</option>\r\n                  </select>\r\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'hourlyRateVat' }}</span>\r\n              </div>\r\n          </div>\r\n          <div class=\"col-xs-2\" *ngIf=\"model.contractTypeType != 'WEEKEND' && model.contractTypeType != 'DAY'\">\r\n              <div class=\"form-group row-md-2\">\r\n                  <label>\r\n                      <span class=\"text text-danger\">*</span> {{ 'LblMileageRate' | translate }}</label>\r\n                  <div class=\"input-group\">\r\n                      <span *ngIf=\"model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                      <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblMileageRate' | translate }}\" [(ngModel)]=\"model.mileageRate\"\r\n                             name=\"model.MileageRate\" maxlength=\"6\">\r\n                      <span *ngIf=\"!model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                  </div>\r\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'mileageRate' }}</span>\r\n              </div>\r\n              <div class=\"form-group row-md-2\">\r\n                  <label>\r\n                      <span class=\"text text-danger\">*</span> {{ 'LblMileageRateVat' | translate }}</label>\r\n                  <select [(ngModel)]=\"model.mileageRateVat\" name=\"mileageRateVat\" class=\"form-control\">\r\n                      <option *ngFor=\"let item of vatSettingList\" [value]='item.value'>{{item.data}}</option>\r\n                  </select>\r\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'mileageRateVat' }}</span>\r\n              </div>\r\n          </div>\r\n          <div class=\"clearfix\"></div>\r\n          <div class=\"row col-md-12\">\r\n            <div class=\"col-xs-12 col-sm-12\">\r\n              <label> {{ 'LblCatA' | translate }}</label>\r\n              <div class=\"clearfix\"></div>\r\n              <div class=\"form-group col-xs-2\" *ngIf=\"model.contractTypeType == 'WEEKEND' || model.contractTypeType == 'DAY'\">\r\n                <label> {{ 'LblPeriodRate' | translate }}</label>\r\n                <div class=\"input-group\">\r\n                  <span *ngIf=\"model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblPeriodRate' | translate }}\" [(ngModel)]=\"model.catAPricingModel.periodRate\"\r\n                    name=\"model.catAPricingModel.PeriodRate\" maxlength=\"6\">\r\n                  <span *ngIf=\"!model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                </div>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'catAPricingModel.periodRate' }}</span>\r\n              </div>\r\n              <div class=\"form-group col-xs-2\" *ngIf=\"model.contractTypeType != 'WEEKEND' && model.contractTypeType != 'DAY'\">\r\n                <label> {{ 'LblTimeRate' | translate }}</label>\r\n                <div class=\"input-group\">\r\n                  <span *ngIf=\"model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblTimeRate' | translate }}\" [(ngModel)]=\"model.catAPricingModel.hourlyRate\"\r\n                    name=\"model.catAPricingModel.HourlyRate\" maxlength=\"6\">\r\n                  <span *ngIf=\"!model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                </div>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'catAPricingModel.hourlyRate' }}</span>\r\n              </div>\r\n              <div class=\"form-group col-xs-2\" *ngIf=\"model.contractTypeType != 'WEEKEND' && model.contractTypeType != 'DAY'\">\r\n                <label> {{ 'LblMileageRate' | translate }}</label>\r\n                <div class=\"input-group\">\r\n                  <span *ngIf=\"model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblMileageRate' | translate }}\" [(ngModel)]=\"model.catAPricingModel.mileageRate\"\r\n                    name=\"model.catAPricingModel.MileageRate\" maxlength=\"6\">\r\n                  <span *ngIf=\"!model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                </div>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'catAPricingModel.mileageRate' }}</span>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-xs-12 col-sm-12\">\r\n              <label> {{ 'LblCatB' | translate }}</label>\r\n              <div class=\"clearfix\"></div>\r\n              <div class=\"form-group col-xs-2\" *ngIf=\"model.contractTypeType == 'WEEKEND' || model.contractTypeType == 'DAY'\">\r\n                <label> {{ 'LblPeriodRate' | translate }}</label>\r\n                <div class=\"input-group\">\r\n                  <span *ngIf=\"model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblPeriodRate' | translate }}\" [(ngModel)]=\"model.catBPricingModel.periodRate\"\r\n                    name=\"model.catBPricingModel.PeriodRate\" maxlength=\"6\">\r\n                  <span *ngIf=\"!model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                </div>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'catBPricingModel.periodRate' }}</span>\r\n              </div>\r\n              <div class=\"form-group col-xs-2\" *ngIf=\"model.contractTypeType != 'WEEKEND' && model.contractTypeType != 'DAY'\">\r\n                <label> {{ 'LblTimeRate' | translate }}</label>\r\n                <div class=\"input-group\">\r\n                  <span *ngIf=\"model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblTimeRate' | translate }}\" [(ngModel)]=\"model.catBPricingModel.hourlyRate\"\r\n                    name=\"catBHourlyRate\" maxlength=\"6\">\r\n                  <span *ngIf=\"!model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                </div>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'catBPricingModel.hourlyRate' }}</span>\r\n              </div>\r\n              <div class=\"form-group col-xs-2\" *ngIf=\"model.contractTypeType != 'WEEKEND' && model.contractTypeType != 'DAY'\">\r\n                <label> {{ 'LblMileageRate' | translate }}</label>\r\n                <div class=\"input-group\">\r\n                  <span *ngIf=\"model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblMileageRate' | translate }}\" [(ngModel)]=\"model.catBPricingModel.mileageRate\"\r\n                    name=\"catBMileageRate\" maxlength=\"6\">\r\n                  <span *ngIf=\"!model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                </div>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'catBPricingModel.mileageRate' }}</span>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-xs-12 col-sm-12\">\r\n              <label> {{ 'LblCatC' | translate }}</label>\r\n              <div class=\"clearfix\"></div>\r\n              <div class=\"form-group col-xs-2\" *ngIf=\"model.contractTypeType == 'WEEKEND' || model.contractTypeType == 'DAY'\">\r\n                <label> {{ 'LblPeriodRate' | translate }}</label>\r\n                <div class=\"input-group\">\r\n                  <span *ngIf=\"model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblPeriodRate' | translate }}\" [(ngModel)]=\"model.catCPricingModel.periodRate\"\r\n                    name=\"model.catCPricingModel.PeriodRate\" maxlength=\"6\">\r\n                  <span *ngIf=\"!model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                </div>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'catCPricingModel.periodRate' }}</span>\r\n              </div>\r\n              <div class=\"form-group col-xs-2\" *ngIf=\"model.contractTypeType != 'WEEKEND' && model.contractTypeType != 'DAY'\">\r\n                <label> {{ 'LblTimeRate' | translate }}</label>\r\n                <div class=\"input-group\">\r\n                  <span *ngIf=\"model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblTimeRate' | translate }}\" [(ngModel)]=\"model.catCPricingModel.hourlyRate\"\r\n                    name=\"catCHourlyRate\" maxlength=\"6\">\r\n                  <span *ngIf=\"!model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                </div>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'catCPricingModel.hourlyRate' }}</span>\r\n              </div>\r\n              <div class=\"form-group col-xs-2\" *ngIf=\"model.contractTypeType != 'WEEKEND' && model.contractTypeType != 'DAY'\">\r\n                <label> {{ 'LblMileageRate' | translate }}</label>\r\n                <div class=\"input-group\">\r\n                  <span *ngIf=\"model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblMileageRate' | translate }}\" [(ngModel)]=\"model.catCPricingModel.mileageRate\"\r\n                    name=\"catCMileageRate\" maxlength=\"6\">\r\n                  <span *ngIf=\"!model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                </div>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'catCPricingModel.mileageRate' }}</span>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-xs-12 col-sm-12\">\r\n              <label> {{ 'LblCatD' | translate }}</label>\r\n              <div class=\"clearfix\"></div>\r\n              <div class=\"form-group col-xs-2\" *ngIf=\"model.contractTypeType == 'WEEKEND' || model.contractTypeType == 'DAY'\">\r\n                <label> {{ 'LblPeriodRate' | translate }}</label>\r\n                <div class=\"input-group\">\r\n                  <span *ngIf=\"model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblPeriodRate' | translate }}\" [(ngModel)]=\"model.catDPricingModel.periodRate\"\r\n                    name=\"model.catDPricingModel.PeriodRate\" maxlength=\"6\">\r\n                  <span *ngIf=\"!model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                </div>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'catDPricingModel.periodRate' }}</span>\r\n              </div>\r\n              <div class=\"form-group col-xs-2\" *ngIf=\"model.contractTypeType != 'WEEKEND' && model.contractTypeType != 'DAY'\">\r\n                <label> {{ 'LblTimeRate' | translate }}</label>\r\n                <div class=\"input-group\">\r\n                  <span *ngIf=\"model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblTimeRate' | translate }}\" [(ngModel)]=\"model.catDPricingModel.hourlyRate\"\r\n                    name=\"catDHourlyRate\" maxlength=\"6\">\r\n                  <span *ngIf=\"!model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                </div>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'catDPricingModel.hourlyRate' }}</span>\r\n              </div>\r\n              <div class=\"form-group col-xs-2\" *ngIf=\"model.contractTypeType != 'WEEKEND' && model.contractTypeType != 'DAY'\">\r\n                <label> {{ 'LblMileageRate' | translate }}</label>\r\n                <div class=\"input-group\">\r\n                  <span *ngIf=\"model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblMileageRate' | translate }}\" [(ngModel)]=\"model.catDPricingModel.mileageRate\"\r\n                    name=\"catDMileageRate\" maxlength=\"6\">\r\n                  <span *ngIf=\"!model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                </div>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'catDPricingModel.mileageRate' }}</span>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-xs-12 col-sm-12\">\r\n              <label> {{ 'LblCatE' | translate }}</label>\r\n              <div class=\"clearfix\"></div>\r\n              <div class=\"form-group col-xs-2\" *ngIf=\"model.contractTypeType == 'WEEKEND' || model.contractTypeType == 'DAY'\">\r\n                <label> {{ 'LblPeriodRate' | translate }}</label>\r\n                <div class=\"input-group\">\r\n                  <span *ngIf=\"model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblPeriodRate' | translate }}\" [(ngModel)]=\"model.catEPricingModel.periodRate\"\r\n                    name=\"model.catEPricingModel.PeriodRate\" maxlength=\"6\">\r\n                  <span *ngIf=\"!model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                </div>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'catEPricingModel.periodRate' }}</span>\r\n              </div>\r\n              <div class=\"form-group col-xs-2\" *ngIf=\"model.contractTypeType != 'WEEKEND' && model.contractTypeType != 'DAY'\">\r\n                <label> {{ 'LblTimeRate' | translate }}</label>\r\n                <div class=\"input-group\">\r\n                  <span *ngIf=\"model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblTimeRate' | translate }}\" [(ngModel)]=\"model.catEPricingModel.hourlyRate\"\r\n                    name=\"catEHourlyRate\" maxlength=\"6\">\r\n                  <span *ngIf=\"!model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                </div>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'catEPricingModel.hourlyRate' }}</span>\r\n              </div>\r\n              <div class=\"form-group col-xs-2\" *ngIf=\"model.contractTypeType != 'WEEKEND' && model.contractTypeType != 'DAY'\">\r\n                <label> {{ 'LblMileageRate' | translate }}</label>\r\n                <div class=\"input-group\">\r\n                  <span *ngIf=\"model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblMileageRate' | translate }}\" [(ngModel)]=\"model.catEPricingModel.mileageRate\"\r\n                    name=\"catEMileageRate\" maxlength=\"6\">\r\n                  <span *ngIf=\"!model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                </div>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'catEPricingModel.mileageRate' }}</span>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-xs-12 col-sm-12\">\r\n              <label> {{ 'LblCatF' | translate }}</label>\r\n              <div class=\"clearfix\"></div>\r\n              <div class=\"form-group col-xs-2\" *ngIf=\"model.contractTypeType == 'WEEKEND' || model.contractTypeType == 'DAY'\">\r\n                <label> {{ 'LblPeriodRate' | translate }}</label>\r\n                <div class=\"input-group\">\r\n                  <span *ngIf=\"model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblPeriodRate' | translate }}\" [(ngModel)]=\"model.catFPricingModel.periodRate\"\r\n                    name=\"model.catFPricingModel.PeriodRate\" maxlength=\"6\">\r\n                  <span *ngIf=\"!model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                </div>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'catFPricingModel.periodRate' }}</span>\r\n              </div>\r\n              <div class=\"form-group col-xs-2\" *ngIf=\"model.contractTypeType != 'WEEKEND' && model.contractTypeType != 'DAY'\">\r\n                <label> {{ 'LblTimeRate' | translate }}</label>\r\n                <div class=\"input-group\">\r\n                  <span *ngIf=\"model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblTimeRate' | translate }}\" [(ngModel)]=\"model.catFPricingModel.hourlyRate\"\r\n                    name=\"catCHourlyRate\" maxlength=\"6\">\r\n                  <span *ngIf=\"!model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                </div>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'catFPricingModel.hourlyRate' }}</span>\r\n              </div>\r\n              <div class=\"form-group col-xs-2\" *ngIf=\"model.contractTypeType != 'WEEKEND' && model.contractTypeType != 'DAY'\">\r\n                <label> {{ 'LblMileageRate' | translate }}</label>\r\n                <div class=\"input-group\">\r\n                  <span *ngIf=\"model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblMileageRate' | translate }}\" [(ngModel)]=\"model.catFPricingModel.mileageRate\"\r\n                    name=\"catFMileageRate\" maxlength=\"6\">\r\n                  <span *ngIf=\"!model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                </div>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'catFPricingModel.mileageRate' }}</span>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-xs-12 col-sm-12\">\r\n              <label> {{ 'LblCatG' | translate }}</label>\r\n              <div class=\"clearfix\"></div>\r\n              <div class=\"form-group col-xs-2\" *ngIf=\"model.contractTypeType == 'WEEKEND' || model.contractTypeType == 'DAY'\">\r\n                <label> {{ 'LblPeriodRate' | translate }}</label>\r\n                <div class=\"input-group\">\r\n                  <span *ngIf=\"model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblPeriodRate' | translate }}\" [(ngModel)]=\"model.catGPricingModel.periodRate\"\r\n                    name=\"model.catGPricingModel.PeriodRate\" maxlength=\"6\">\r\n                  <span *ngIf=\"!model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                </div>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'catGPricingModel.periodRate' }}</span>\r\n              </div>\r\n              <div class=\"form-group col-xs-2\" *ngIf=\"model.contractTypeType != 'WEEKEND' && model.contractTypeType != 'DAY'\">\r\n                <label> {{ 'LblTimeRate' | translate }}</label>\r\n                <div class=\"input-group\">\r\n                  <span *ngIf=\"model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblTimeRate' | translate }}\" [(ngModel)]=\"model.catGPricingModel.hourlyRate\"\r\n                    name=\"catGHourlyRate\" maxlength=\"6\">\r\n                  <span *ngIf=\"!model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                </div>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'catGPricingModel.hourlyRate' }}</span>\r\n              </div>\r\n              <div class=\"form-group col-xs-2\" *ngIf=\"model.contractTypeType != 'WEEKEND' && model.contractTypeType != 'DAY'\">\r\n                <label> {{ 'LblMileageRate' | translate }}</label>\r\n                <div class=\"input-group\">\r\n                  <span *ngIf=\"model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblMileageRate' | translate }}\" [(ngModel)]=\"model.catGPricingModel.mileageRate\"\r\n                    name=\"catGMileageRate \" maxlength=\"6\">\r\n                  <span *ngIf=\"!model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                </div>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'catGPricingModel.mileageRate' }}</span>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-xs-12 col-sm-12\">\r\n              <label> {{ 'LblCatH' | translate }}</label>\r\n              <div class=\"clearfix\"></div>\r\n              <div class=\"form-group col-xs-2\" *ngIf=\"model.contractTypeType == 'WEEKEND' || model.contractTypeType == 'DAY'\">\r\n                <label> {{ 'LblPeriodRate' | translate }}</label>\r\n                <div class=\"input-group\">\r\n                  <span *ngIf=\"model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblPeriodRate' | translate }}\" [(ngModel)]=\"model.catHPricingModel.periodRate\"\r\n                    name=\"model.catHPricingModel.PeriodRate\" maxlength=\"6\">\r\n                  <span *ngIf=\"!model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                </div>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'catHPricingModel.periodRate' }}</span>\r\n              </div>\r\n              <div class=\"form-group col-xs-2\" *ngIf=\"model.contractTypeType != 'WEEKEND' && model.contractTypeType != 'DAY'\">\r\n                <label> {{ 'LblTimeRate' | translate }}</label>\r\n                <div class=\"input-group\">\r\n                  <span *ngIf=\"model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblTimeRate' | translate }}\" [(ngModel)]=\"model.catHPricingModel.hourlyRate\"\r\n                    name=\"catHHourlyRate\" maxlength=\"6\">\r\n                  <span *ngIf=\"!model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                </div>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'catHPricingModel.hourlyRate' }}</span>\r\n              </div>\r\n              <div class=\"form-group col-xs-2\" *ngIf=\"model.contractTypeType != 'WEEKEND' && model.contractTypeType != 'DAY'\">\r\n                <label> {{ 'LblMileageRate' | translate }}</label>\r\n                <div class=\"input-group\">\r\n                  <span *ngIf=\"model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblMileageRate' | translate }}\" [(ngModel)]=\"model.catHPricingModel.mileageRate\"\r\n                    name=\"catHMileageRate\" maxlength=\"6\">\r\n                  <span *ngIf=\"!model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n                </div>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'catHPricingModel.mileageRate' }}</span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </fieldset>\r\n        <div class=\"row no-margin\">\r\n          <div class=\"col-sm-12\">\r\n            <hr>\r\n            <a class=\"btn btn-gray cursor-pointer\" [routerLink]=\"[urlContractTypeList, { sharedVehicleGroupHashId: sharedVehicleGroupHashId, contractTypeGroupHashId: contractTypeGroupHashId }]\">{{ 'LblCancel' | translate }}</a> &nbsp;&nbsp;\r\n            <button class=\"btn btn-green\" type=\"submit\">{{ 'LblSave' | translate }}</button>\r\n          </div>\r\n        </div>\r\n\r\n      </form>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>";

/***/ },
/* 732 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var config_1 = __webpack_require__(60);
	var contracttypegroup_service_1 = __webpack_require__(730);
	var core_1 = __webpack_require__(3);
	var contractType_service_1 = __webpack_require__(726);
	var router_1 = __webpack_require__(26);
	var config_2 = __webpack_require__(60);
	var ContractTypeListComponent = (function () {
	    function ContractTypeListComponent(contractTypeService, contractTypeGroupService, activeRoute, authService, router, translate) {
	        this.contractTypeService = contractTypeService;
	        this.contractTypeGroupService = contractTypeGroupService;
	        this.activeRoute = activeRoute;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	    }
	    Object.defineProperty(ContractTypeListComponent.prototype, "isAnyChecked", {
	        get: function () {
	            if (this.contractTypeList) {
	                var isCheck = this.contractTypeList.some(function (x) { return x.isChecked == true; });
	                if (isCheck) {
	                    if (this.contractTypeList.every(function (x) { return x.isChecked == true; }))
	                        this.isParentCheck = true;
	                    else
	                        this.isParentCheck = false;
	                }
	                else {
	                    this.isParentCheck = false;
	                }
	                return isCheck;
	            }
	            else {
	                this.isParentCheck = false;
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ContractTypeListComponent.prototype, "isDeleteAccess", {
	        get: function () {
	            if (this.contractTypeList) {
	                return this.contractTypeList.some(function (x) { return x.isDeletable; });
	            }
	            else {
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ContractTypeListComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.module = this.translate.instant('LblContractType');
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	        this.sharedvehicleGroup = this.translate.instant('LblListPage', [this.translate.instant('LblSharedVehicleGroup')]);
	        this.contractTypeGroup = this.translate.instant('LblListPage', [this.translate.instant('LblContractTypeGroup')]);
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = ["contractName", "sunFlag", "monFlag", "tueFlag", "wedFlag", "thuFlag", "friFlag", "satFlag", "contractTypeType"];
	        this.urlDefaultPage = this.authService.GetURL(config_2.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlContractTypeList = this.authService.GetURL(config_2.ApplicationRouteURL.URL_CONTRACT_TYPE_LIST);
	        this.urlContractTypeUpdate = this.authService.GetURL(config_2.ApplicationRouteURL.URL_CONTRACT_TYPE_UPDATE);
	        this.urlContractTypeAdd = this.authService.GetURL(config_2.ApplicationRouteURL.URL_CONTRACT_TYPE_ADD);
	        this.urlSVGList = this.authService.GetURL(config_2.ApplicationRouteURL.URL_SVG_LIST);
	        this.urlContractTypeGroupList = this.authService.GetURL(config_2.ApplicationRouteURL.URL_CONTRACT_TYPE_GROUP_LIST);
	        this.activeRoute
	            .params
	            .subscribe(function (params) {
	            _this.contractTypeGroupHashId = params['contractTypeGroupHashId'] || '';
	            _this.sharedVehicleGroupHashId = params['sharedVehicleGroupHashId'] || '';
	            if (_this.contractTypeGroupHashId) {
	                _this.GetContractTypeGroupDetailsByHashId();
	                _this.addContractTypeLink = new config_1.WeGoAuthorizedLink(_this.urlContractTypeAdd + '/' + _this.sharedVehicleGroupHashId + '/' + _this.contractTypeGroupHashId, config_1.Permission.PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_OVERVIEW, config_1.PermissionType.INSERT, 'btn btn-highlight navbar-right', 'LblAddNew', config_1.Entity.SVG, _this.sharedVehicleGroupHashId);
	                _this.GetContractTypeList();
	            }
	        });
	    };
	    ContractTypeListComponent.prototype.GetContractTypeGroupDetailsByHashId = function () {
	        var _this = this;
	        this.contractTypeGroupService.GetContractTypeGroupBasicDetail(this.contractTypeGroupHashId)
	            .subscribe(function (res) {
	            if (res.data)
	                _this.contractGroupName = res.data.entityName;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    ContractTypeListComponent.prototype.GetContractTypeList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.contractTypeService.GetContractTypeList(this.contractTypeGroupHashId, this.DataListModel)
	            .subscribe(function (res) {
	            _this.contractTypeList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    ContractTypeListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetContractTypeList();
	    };
	    ContractTypeListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetContractTypeList();
	    };
	    ContractTypeListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetContractTypeList();
	    };
	    ;
	    ContractTypeListComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetContractTypeList();
	    };
	    ContractTypeListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.contractTypeService.ExportContractTypeList(this.contractTypeGroupHashId, this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "ContractType" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	        ;
	    };
	    ContractTypeListComponent.prototype.OnParentCheck = function (isChecked) {
	        this.contractTypeList.filter(function (x) { return x.isDeletable; }).forEach(function (x) { return x.isChecked = isChecked; });
	    };
	    ContractTypeListComponent.prototype.DeleteContractType = function (deleteContractTypeHashId) {
	        var _this = this;
	        this.isLoading = true;
	        this.contractTypeService.DeleteContractType(deleteContractTypeHashId, this.contractTypeGroupHashId)
	            .subscribe(function (res) {
	            _this.DataListModel.currentPage = 1;
	            _this.GetContractTypeList();
	            _this.popupMsg = _this.translate.instant('LblRecordRemovedSuccess', [_this.module]);
	            _this.ShowSuccessPopup();
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    ContractTypeListComponent.prototype.ShowAlertModal = function (contractTypeHashId) {
	        if (contractTypeHashId) {
	            this.popupMsg = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
	            this.isMultipleDelete = false;
	            this.deletecontractTypeHashId = contractTypeHashId;
	        }
	        else {
	            this.popupMsg = this.translate.instant('LblRecordMultiplDeleteConfirmation', [this.module]);
	            this.isMultipleDelete = true;
	        }
	        this.alertModal.show();
	    };
	    ContractTypeListComponent.prototype.HideAlertModal = function () {
	        this.deletecontractTypeHashId = "";
	        this.alertModal.hide();
	    };
	    ContractTypeListComponent.prototype.SuccessAlertModalClick = function () {
	        var deleteContractTypeList;
	        if (this.isMultipleDelete)
	            deleteContractTypeList = this.contractTypeList.filter(function (x) { return x.isChecked; }).map(function (x) { return x.contractTypeHashId; });
	        else
	            deleteContractTypeList.push(this.deletecontractTypeHashId);
	        this.DeleteContractType(deleteContractTypeList);
	        this.alertModal.hide();
	    };
	    ContractTypeListComponent.prototype.ShowContractTypeHistory = function (versionId) {
	        this.historyModal.versionId = versionId;
	        this.historyModal.show();
	    };
	    ContractTypeListComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    ContractTypeListComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    ContractTypeListComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    ContractTypeListComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    __decorate([
	        core_1.ViewChild('alertModal'), 
	        __metadata('design:type', Object)
	    ], ContractTypeListComponent.prototype, "alertModal", void 0);
	    __decorate([
	        core_1.ViewChild('historyModal'), 
	        __metadata('design:type', Object)
	    ], ContractTypeListComponent.prototype, "historyModal", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], ContractTypeListComponent.prototype, "successPopup", void 0);
	    ContractTypeListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-contracttype-list',
	            template: __webpack_require__(733),
	            providers: [contractType_service_1.ContractTypeService, contracttypegroup_service_1.ContractTypeGroupService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof contractType_service_1.ContractTypeService !== 'undefined' && contractType_service_1.ContractTypeService) === 'function' && _a) || Object, (typeof (_b = typeof contracttypegroup_service_1.ContractTypeGroupService !== 'undefined' && contracttypegroup_service_1.ContractTypeGroupService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _d) || Object, (typeof (_e = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _e) || Object, (typeof (_f = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _f) || Object])
	    ], ContractTypeListComponent);
	    return ContractTypeListComponent;
	    var _a, _b, _c, _d, _e, _f;
	}());
	exports.ContractTypeListComponent = ContractTypeListComponent;


/***/ },
/* 733 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ breadCrumbList}} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"urlSVGList\">\r\n            <i class=\"fa fa-group fa-fw\"></i> {{ sharedvehicleGroup }}</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"[urlContractTypeGroupList, { sharedVehicleGroupHashId: sharedVehicleGroupHashId }]\">\r\n            <i class=\"fa fa-eur fa-fw\"></i> {{ contractTypeGroup }}</a>\r\n        </li>\r\n        <li class=\"active\"> {{ breadCrumbList}} </li>\r\n\r\n      </ol>\r\n    </div>\r\n\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25 \">\r\n      <!-- <a class=\"btn btn-highlight navbar-right\" [routerLink]=\"[urlContractTypeUpdate, { sharedVehicleGroupHashId: sharedVehicleGroupHashId, contractTypeGroupHashId: contractTypeGroupHashId}]\">{{ 'LblAddNew' | translate }}</a> -->\r\n      <wego-authorized-link [LinkModel]=\"addContractTypeLink\"></wego-authorized-link>\r\n    </div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <h4>\r\n          <label>{{ 'LblContractTypeGroup' | translate }} : </label> {{ contractGroupName }}</h4>\r\n        <p class=\"text-success\">{{message}}</p>\r\n        <wego-search-list [IsDeleted]=\"isDeleteAccess\" [IsDeleteEnabled]=\"isAnyChecked && isDeleteAccess\" (OnDeleteAll)=\"ShowAlertModal()\"\r\n          (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\"\r\n          [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center parent-checkbox\">\r\n                  <input [disabled]=\"!isDeleteAccess\" type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\">\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('contractName')\"> {{ 'LblContractName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'contractName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('contractTypeType')\"> {{ 'LblContractTypeType' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'contractTypeType'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('monFlag')\">\r\n                  {{ 'LblSMo' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'monFlag'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('tueFlag')\">\r\n                  {{ 'LblSTu' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'tueFlag'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('wedFlag')\">\r\n                  {{ 'LblSWe' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'wedFlag'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('thuFlag')\">\r\n                  {{ 'LblSTh' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'thuFlag'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('friFlag')\">\r\n                  {{ 'LblSFr' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'friFlag'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('satFlag')\">\r\n                  {{ 'LblSSa' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'satFlag'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('sunFlag')\">\r\n                  {{ 'LblSSu' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'sunFlag'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('dayStartTimeSpan')\">\r\n                  {{ 'LblFrom' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'dayStartTimeSpan'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('dayEndTimeSpan')\">\r\n                  {{ 'LblTo' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'dayEndTimeSpan'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('periodRateDisplay')\">\r\n                  {{ 'LblPeriodRate' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'periodRateDisplay'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('hourlyRate')\">\r\n                  {{ 'LblTimeRate' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'hourlyRate'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('mileageRate')\">\r\n                  {{ 'LblMileageRate' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'mileageRate'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"text-center\">{{ 'LblContractTypeHistory' | translate }}</th>\r\n\r\n                <th class=\"text-center\">{{ 'LblEdit' | translate }}</th>\r\n                <!--<th class=\"text-center\">{{ 'LblDelete' | translate }}</th>-->\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"totalItems != 0\">\r\n                <tr *ngFor=\"let contractType of contractTypeList\">\r\n                  <td class=\"text-center\">\r\n                    <input *ngIf=\"!contractType.isDeletable\" disabled type=\"checkbox\" name=\"isActive\">\r\n                    <input *ngIf=\"contractType.isDeletable\" type=\"checkbox\" name=\"isActive\" [(ngModel)]=\"contractType.isChecked\">\r\n                  </td>\r\n                  <td>\r\n                    <i *ngIf=\"contractType.contractTypePeriod == 'SPECIAL'\" title=\"Special Contract Type\" class=\"fa fa-star fa-fw text-success\"></i> {{ contractType.contractName }}</td>\r\n                  <td class=\"text-center\">\r\n                    {{ contractType.contractTypeType }}\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <i *ngIf=\"contractType.contractTypeType == 'REGULAR'\" class=\"fa fa-fw\" [ngClass]=\"{'fa-check-square-o': contractType.monFlag, 'fa-square-o': !contractType.monFlag}\"></i>\r\n                    <span *ngIf=\"contractType.contractTypeType != 'REGULAR'\">-</span>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <i *ngIf=\"contractType.contractTypeType == 'REGULAR'\" class=\"fa fa-fw\" [ngClass]=\"{'fa-check-square-o': contractType.tueFlag, 'fa-square-o': !contractType.tueFlag}\"></i>\r\n                    <span *ngIf=\"contractType.contractTypeType != 'REGULAR'\">-</span>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <i *ngIf=\"contractType.contractTypeType == 'REGULAR'\" class=\"fa fa-fw\" [ngClass]=\"{'fa-check-square-o': contractType.wedFlag, 'fa-square-o': !contractType.wedFlag}\"></i>\r\n                    <span *ngIf=\"contractType.contractTypeType != 'REGULAR'\">-</span>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <i *ngIf=\"contractType.contractTypeType == 'REGULAR'\" class=\"fa fa-fw\" [ngClass]=\"{'fa-check-square-o': contractType.thuFlag, 'fa-square-o': !contractType.thuFlag}\"></i>\r\n                    <span *ngIf=\"contractType.contractTypeType != 'REGULAR'\">-</span>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <i *ngIf=\"contractType.contractTypeType == 'REGULAR'\" class=\"fa fa-fw\" [ngClass]=\"{'fa-check-square-o': contractType.friFlag, 'fa-square-o': !contractType.friFlag}\"></i>\r\n                    <span *ngIf=\"contractType.contractTypeType != 'REGULAR'\">-</span>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <i *ngIf=\"contractType.contractTypeType == 'REGULAR'\" class=\"fa fa-fw\" [ngClass]=\"{'fa-check-square-o': contractType.satFlag, 'fa-square-o': !contractType.satFlag}\"></i>\r\n                    <span *ngIf=\"contractType.contractTypeType != 'REGULAR'\">-</span>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <i *ngIf=\"contractType.contractTypeType == 'REGULAR'\" class=\"fa fa-fw\" [ngClass]=\"{'fa-check-square-o': contractType.sunFlag, 'fa-square-o': !contractType.sunFlag}\"></i>\r\n                    <span *ngIf=\"contractType.contractTypeType != 'REGULAR'\">-</span>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <span *ngIf=\"contractType.contractTypeType == 'REGULAR'\"> {{ contractType.dayStartTime }}</span>\r\n                    <span *ngIf=\"contractType.contractTypeType != 'REGULAR'\">-</span>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <span *ngIf=\"contractType.contractTypeType == 'REGULAR'\"> {{ contractType.dayEndTime }}</span>\r\n                    <span *ngIf=\"contractType.contractTypeType != 'REGULAR'\">-</span>\r\n                  </td>\r\n                  <td *ngIf=\"contractType.contractTypeType == 'REGULAR'\" class=\"text-center\">\r\n                    -\r\n                  </td>\r\n                  <td class=\"text-center\" *ngIf=\"contractType.contractTypeType == 'WEEKEND' || contractType.contractTypeType == 'DAY'\">\r\n                    {{ contractType.periodRateDisplay }}\r\n                  </td>\r\n                  <td *ngIf=\"contractType.contractTypeType == 'REGULAR'\" class=\"text-center\">\r\n                    {{ contractType.hourlyRateDisplay }}\r\n                  </td>\r\n                  <td class=\"text-center\" *ngIf=\"contractType.contractTypeType == 'WEEKEND' || contractType.contractTypeType == 'DAY'\">\r\n                    -\r\n                  </td>\r\n                    <td class=\"text-center\" *ngIf=\"contractType.contractTypeType == 'REGULAR'\">\r\n                        {{ contractType.mileageRateDisplay }}\r\n                    </td>\r\n                    <td class=\"text-center\" *ngIf=\"contractType.contractTypeType == 'WEEKEND' || contractType.contractTypeType == 'DAY'\">\r\n                        -\r\n                    </td>\r\n                  <td class=\"text-center\">\r\n                    <a class=\"cursor-pointer\" (click)=\"ShowContractTypeHistory(contractType.versionId)\">\r\n                      <i class=\"fa fa-clock-o fa-fw\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <!-- [routerLink]=\"[urlContractTypeUpdate, { sharedVehicleGroupHashId: sharedVehicleGroupHashId, contractTypeGroupHashId : contractTypeGroupHashId, contractTypeHashId : contractType.contractTypeHashId }]\" -->\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"contractType.isEditable\" [routerLink]=\"urlContractTypeUpdate + '/' + sharedVehicleGroupHashId + '/' + contractTypeGroupHashId + '/' + contractType.contractTypeHashId\">\r\n                      <i class=\"fa fa-pencil-square-o fa-fw\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <!--<td class=\"text-center\">\r\n                  <a class=\"cursor-pointer\">\r\n                    <i class=\"fa fa-trash-o fa-fw text-danger\" (click)=\"ShowAlertModal(contractType.contractTypeHashId)\"></i>\r\n                  </a>\r\n                </td>-->\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"16\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<wego-contractType-history #historyModal></wego-contractType-history>\r\n\r\n<wego-confirm-popup #alertModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessAlertModalClick()\" (onReject)=\"HideAlertModal()\"></wego-confirm-popup>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>";

/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var contracttypegroup_service_1 = __webpack_require__(730);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var InActiveContractTypeGroupPopupComponent = (function () {
	    function InActiveContractTypeGroupPopupComponent(contractTypeGroupService, authService, activeRoute, router, translate) {
	        this.contractTypeGroupService = contractTypeGroupService;
	        this.authService = authService;
	        this.activeRoute = activeRoute;
	        this.router = router;
	        this.translate = translate;
	    }
	    InActiveContractTypeGroupPopupComponent.prototype.ngOnInit = function () {
	    };
	    InActiveContractTypeGroupPopupComponent.prototype.show = function () {
	        console.log(this.contractTypeGroupHashId);
	        this.GetInActiveReason();
	        this.contractGroupModal.show();
	    };
	    InActiveContractTypeGroupPopupComponent.prototype.hide = function () {
	        this.contractGroupModal.hide();
	    };
	    InActiveContractTypeGroupPopupComponent.prototype.GetInActiveReason = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.contractTypeGroupService.GetInActiveReasonByHashId(this.contractTypeGroupHashId)
	            .subscribe(function (res) {
	            _this.reasonList = res.data;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    __decorate([
	        core_1.ViewChild('contractGroupModal'), 
	        __metadata('design:type', Object)
	    ], InActiveContractTypeGroupPopupComponent.prototype, "contractGroupModal", void 0);
	    InActiveContractTypeGroupPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-inactive-contracttypegroup-popup',
	            template: __webpack_require__(735),
	            styles: ["\n  fieldset{\n    margin-bottom: 10px;\n  }\n\n  legend{\n    margin-bottom: 8px;\n    font-size: 16px;\n  }\n  "]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof contracttypegroup_service_1.ContractTypeGroupService !== 'undefined' && contracttypegroup_service_1.ContractTypeGroupService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _e) || Object])
	    ], InActiveContractTypeGroupPopupComponent);
	    return InActiveContractTypeGroupPopupComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.InActiveContractTypeGroupPopupComponent = InActiveContractTypeGroupPopupComponent;


/***/ },
/* 735 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #contractGroupModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n                    <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblInactiveContractTypeGroupReason' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <div class=\"row\">\r\n          <div class=\"col-sm-12\">\r\n            <p>{{ 'LblContractSlotisnotdefined' | translate }}</p>\r\n          </div>\r\n          <fieldset *ngFor=\"let item of reasonList\" class=\"col-md-12\">\r\n            <legend class=\"legendStyle\"><strong>{{ item.day }}</strong></legend>\r\n            <div *ngFor=\"let freeSlot of item.freeSlot\" class=\"col-sm-3\">\r\n              {{ freeSlot }}\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var contracttypegroup_model_1 = __webpack_require__(737);
	var contracttypegroup_service_1 = __webpack_require__(730);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var common_1 = __webpack_require__(22);
	var ContractTypeGroupUpdateComponent = (function () {
	    function ContractTypeGroupUpdateComponent(contracttypegroupService, activeRoute, router, authService, translate, locationService) {
	        this.contracttypegroupService = contracttypegroupService;
	        this.activeRoute = activeRoute;
	        this.router = router;
	        this.authService = authService;
	        this.translate = translate;
	        this.locationService = locationService;
	        this.submitted = false;
	        this.roleLevel = config_1.RoleLevel;
	    }
	    ContractTypeGroupUpdateComponent.prototype.ngOnInit = function () {
	        this.penaltyTimeInterval = [
	            {
	                Key: 'Per 5 Minute',
	                Value: '5'
	            },
	            {
	                Key: 'Per 10 Minute',
	                Value: '10'
	            },
	            {
	                Key: 'Per 15 Minute',
	                Value: '15'
	            }
	        ];
	        this.module = this.translate.instant('LblContractTypeGroup');
	        this.sharedvehicleGroup = this.translate.instant('LblListPage', [
	            this.translate.instant('LblSharedVehicleGroup')
	        ]);
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlcontractTypeGroupList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_CONTRACT_TYPE_GROUP_LIST);
	        this.urlSVGList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SVG_LIST);
	        this.model = new contracttypegroup_model_1.ContractTypeGroupModel();
	        this.GetContractTypeGroupDetails();
	    };
	    ContractTypeGroupUpdateComponent.prototype.GetContractTypeGroupDetails = function () {
	        var _this = this;
	        this.sub = this.activeRoute.params.subscribe(function (params) {
	            _this.contractTypeGroupHashId = params['ctgHashId'] || ''; // contractTypeGroupHashId
	            _this.sharedVehicleGroupHashId = params['svgHashId'] || '';
	            _this.GetVatSettingDropdownList();
	            if (_this.contractTypeGroupHashId != '') {
	                _this.isEditMode = true;
	                _this.contracttypegroupService
	                    .GetContractTypeGroupByHashId(_this.contractTypeGroupHashId)
	                    .subscribe(function (res) {
	                    (_this.model = res.data),
	                        (_this.sharedVehicleGroupHashId = _this.model.sharedVehicleGroupHashId);
	                    _this.model.penaltyTimeInterval = _this.model.penaltyTimeInterval
	                        ? _this.model.penaltyTimeInterval
	                        : _this.penaltyTimeInterval[0].Value;
	                }, function (error) {
	                    _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	                });
	            }
	            else {
	                _this.isEditMode = false;
	                _this.model = new contracttypegroup_model_1.ContractTypeGroupModel();
	                _this.model.sharedVehicleGroupHashId = _this.sharedVehicleGroupHashId;
	                _this.model.penaltyTimeInterval = _this.penaltyTimeInterval[0].Value;
	                _this.GetCurrencyByGroup();
	            }
	        });
	        this.breadCrumbTitle = this.isEditMode
	            ? this.translate.instant('LblEditPage', [this.module])
	            : this.translate.instant('LblAddPage', [this.module]);
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	    };
	    ContractTypeGroupUpdateComponent.prototype.onSubmit = function (forms) {
	        this.submitted = true;
	        this.AddNewContractTypGroup();
	    };
	    ContractTypeGroupUpdateComponent.prototype.GetCurrencyByGroup = function () {
	        var _this = this;
	        this.contracttypegroupService
	            .GetCurrencyByGroup(this.sharedVehicleGroupHashId)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.model.currencySymbol = res.data.currencySymbol;
	                _this.model.isCurrencySymbolBefore =
	                    res.data.currencySignBeforeAmount;
	            }
	            else {
	                _this.errorMessage = res.error;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    ContractTypeGroupUpdateComponent.prototype.AddNewContractTypGroup = function () {
	        var _this = this;
	        this.contracttypegroupService.AddContractType(this.model).subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.isEditMode
	                    ? _this.translate.instant('LblRecordUpdatedSuccess', [_this.module])
	                    : _this.translate.instant('LblRecordAddedSuccess', [_this.module]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    ContractTypeGroupUpdateComponent.prototype.GetVatSettingDefaultValues = function () {
	        var _this = this;
	        this.contracttypegroupService
	            .GetVatSettingDefaultValues(this.sharedVehicleGroupHashId)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.vatSettingDefaultValues = res.data;
	                _this.model.penaltyVat = _this.vatSettingDefaultValues.defaultVatPenaltyCost;
	                _this.model.vatSettingDefaultCost = _this.vatSettingDefaultValues.vatSettingDefaultCost;
	            }
	            else {
	                _this.errorMessage = res.error;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    ContractTypeGroupUpdateComponent.prototype.GetVatSettingDropdownList = function () {
	        var _this = this;
	        this.contracttypegroupService
	            .GetVatSettingDropdownList(this.sharedVehicleGroupHashId)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.vatSettingList = res.data;
	                if (!_this.isEditMode)
	                    _this.GetVatSettingDefaultValues();
	            }
	            else {
	                _this.errorMessage = res.error;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    ContractTypeGroupUpdateComponent.prototype.onChangePenaltyInterval = function (value) {
	        this.model.penaltyTimeInterval = value;
	    };
	    ContractTypeGroupUpdateComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    ContractTypeGroupUpdateComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    ContractTypeGroupUpdateComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    ContractTypeGroupUpdateComponent.prototype.OnBackClick = function () {
	        this.locationService.back();
	    };
	    ContractTypeGroupUpdateComponent.prototype.SetVatDefaultCost = function (vatSettingDefaultCost) {
	        return vatSettingDefaultCost
	            ? this.translate.instant('LblExcludingVat')
	            : this.translate.instant('LblIncludingVat');
	    };
	    ContractTypeGroupUpdateComponent.prototype.ngOnDestroy = function () {
	        if (this.sub) {
	            this.sub.unsubscribe();
	        }
	    };
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], ContractTypeGroupUpdateComponent.prototype, "successPopup", void 0);
	    ContractTypeGroupUpdateComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-contracttypegroup-update',
	            template: __webpack_require__(738),
	            providers: [contracttypegroup_service_1.ContractTypeGroupService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof contracttypegroup_service_1.ContractTypeGroupService !== 'undefined' && contracttypegroup_service_1.ContractTypeGroupService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _d) || Object, (typeof (_e = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _e) || Object, (typeof (_f = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _f) || Object])
	    ], ContractTypeGroupUpdateComponent);
	    return ContractTypeGroupUpdateComponent;
	    var _a, _b, _c, _d, _e, _f;
	}());
	exports.ContractTypeGroupUpdateComponent = ContractTypeGroupUpdateComponent;


/***/ },
/* 737 */
/***/ function(module, exports) {

	"use strict";
	var ContractTypeGroupModel = (function () {
	    function ContractTypeGroupModel() {
	        this.isPenaltyEnabled = false;
	        this.isGroupTripEnabled = false;
	        this.bearer = 1;
	        this.isCurrencySymbolBefore = true;
	        this.vatSettingDefaultCost = true;
	    }
	    return ContractTypeGroupModel;
	}());
	exports.ContractTypeGroupModel = ContractTypeGroupModel;


/***/ },
/* 738 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{breadCrumbTitle}}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"urlSVGList\">\r\n            <i class=\"fa fa-group fa-fw\"></i>{{sharedvehicleGroup}}</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"[urlcontractTypeGroupList , { sharedVehicleGroupHashId: sharedVehicleGroupHashId}]\">\r\n            <i class=\"fa fa-eur fa-fw\"></i> {{breadCrumbList}}</a>\r\n        </li>\r\n        <li class=\"active\">{{breadCrumbTitle}}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"nopad\">\r\n      <form (ngSubmit)=\"onSubmit(AddContractTypeGroupForm.value)\" #AddContractTypeGroupForm=\"ngForm\">\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblContractTypeGroupName' | translate }}\r\n          </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblContractTypeGroupName' | translate }}\" [(ngModel)]=\"model.contractTypGroupName\"\r\n            name=\"ContractTypGroupName\" maxlength=\"100\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'contractTypGroupName' }}</span>\r\n        </div>\r\n        <!-- <div class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblProcessingFee' | translate }}\r\n                    </label>\r\n          <div class=\"input-group\">\r\n            <span class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n            <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblProcessingFee' | translate }}\" [(ngModel)]=\"model.processingFee\" name=\"model.processingFee\" maxlength=\"6\">\r\n          </div>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'processingFee' }}</span>\r\n        </div>\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblPlateformUsageCost' | translate }}\r\n                    </label>\r\n          <div class=\"input-group\">\r\n            <span class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n            <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblPlateformUsageCost' | translate }}\" [(ngModel)]=\"model.plateformUsageCost\" name=\"PlateformUsageCost\" maxlength=\"6\">\r\n          </div>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'plateformUsageCost' }}</span>\r\n        </div>\r\n        <div class=\"clearfix\"></div> -->\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblBearer' | translate }}</label>\r\n          <div class=\"clearfix\"></div>\r\n          <label class=\"radio-inline\">\r\n            <input type=\"radio\" [(ngModel)]=\"model.bearer\" name=\"bearer\" [value]=\"1\">{{ 'LblDriver' | translate }}</label>\r\n          <label class=\"radio-inline\">\r\n            <input type=\"radio\" [(ngModel)]=\"model.bearer\" name=\"bearer\" [value]=\"2\">{{ 'LblOrganization' | translate }}</label>\r\n        </div>\r\n\r\n        <!-- <div class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblVatPercentage' | translate }}\r\n                    </label>\r\n          <div class=\"input-group\">\r\n            <span class=\"input-group-addon\">%</span>\r\n            <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblVatPercentage' | translate }}\" [(ngModel)]=\"model.vatPercentage\" name=\"VatPercentage\" maxlength=\"3\">\r\n          </div>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'vatPercentage' }}</span>\r\n        </div> -->\r\n        <div class=\"clearfix\"></div>\r\n        <!-- <div class=\"clearfix\"></div> -->\r\n        <div class=\"form-group col-md-3\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span> {{ 'LblIsPenaltyEnabled' | translate }}</label>\r\n          <div class=\"clearfix\"></div>\r\n          <label class=\"radio-inline\">\r\n            <input type=\"radio\" [(ngModel)]=\"model.isPenaltyEnabled\" name=\"isPenaltyEnabled\" [value]=\"true\">{{ 'LblYes' | translate }}</label>\r\n          <label class=\"radio-inline\">\r\n            <input type=\"radio\" [(ngModel)]=\"model.isPenaltyEnabled\" name=\"isPenaltyEnabled\" [value]=\"false\">{{ 'LblNo' | translate }}</label>\r\n        </div>\r\n        <div [hidden]=\"!model.isPenaltyEnabled\" class=\"form-group col-md-3\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblPenaltyAmount' | translate }}({{ SetVatDefaultCost(model.vatSettingDefaultCost) }})\r\n          </label>\r\n          <div class=\"input-group\">\r\n            <span *ngIf=\"model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n            <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblPenaltyAmount' | translate }}\" [(ngModel)]=\"model.penaltyAmount\"\r\n              name=\"penaltyAmount\" maxlength=\"6\">\r\n            <span *ngIf=\"!model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n          </div>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'penaltyAmount' }}</span>\r\n        </div>\r\n        <div [hidden]=\"!model.isPenaltyEnabled\" class=\"form-group col-md-3\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblPenaltyVat' | translate }} \r\n          </label>\r\n          <select [(ngModel)]=\"model.penaltyVat\" name=\"penaltyVat\" class=\"form-control\">\r\n            <option *ngFor=\"let item of vatSettingList\" [value]='item.value'>{{item.data}}</option>\r\n          </select>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'penaltyVat' }}</span>\r\n        </div>\r\n        <div [hidden]=\"!model.isPenaltyEnabled\" class=\"form-group col-md-3\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblPenaltyTimeInterval' | translate }}\r\n          </label>\r\n          <!--<select [(ngModel)]=\"model.penaltyTimeInterval\" class=\"form-control\" name=\"penaltyTimeInterval\" (change)=\"onChangePenaltyInterval($event.target.value)\">\r\n            <option *ngFor=\"let item of penaltyTimeInterval\" [ngValue]=\"item.Value\">{{ item.Key }}</option>\r\n          </select>-->\r\n          <select [(ngModel)]=\"model.penaltyTimeInterval\" name=\"penaltyTimeInterval\" class=\"form-control\" (change)=\"onChangePenaltyInterval($event.target.value)\">\r\n            <option *ngFor=\"let item of penaltyTimeInterval\" [attr.value]='item.Value'>{{item.Key}}</option>\r\n          </select>\r\n\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'penaltyTimeInterval' }}</span>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Instance\" class=\"col-md-4\" style=\"width: auto;\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span> {{ 'LblTripDisplayType' | translate }} </label>\r\n          <div class=\"radio\" style=\"margin-top: 0px;\">\r\n            <label>\r\n              <input type=\"radio\" [(ngModel)]=\"model.isGroupTripEnabled\" name=\"isGroupTripEnabled\" [value]=\"false\">{{ 'LblAllTripsIndividually' | translate }}</label>\r\n          </div>\r\n          <div class=\"radio\">\r\n            <label>\r\n              <input type=\"radio\" [(ngModel)]=\"model.isGroupTripEnabled\" name=\"isGroupTripEnabled\" [value]=\"true\">{{ 'LblAllTripsGrouped' | translate }}</label>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"row no-margin\">\r\n          <div class=\"col-sm-12\">\r\n            <hr>\r\n            <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnBackClick()\">{{ 'LblCancel' | translate }}</a> &nbsp;&nbsp;\r\n            <button class=\"btn btn-green\" type=\"submit\">{{ 'LblSave' | translate }}</button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>";

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var translate_service_1 = __webpack_require__(70);
	var sharedvehiclegroup_service_1 = __webpack_require__(510);
	var contracttypegroup_service_1 = __webpack_require__(730);
	var config_1 = __webpack_require__(60);
	var router_1 = __webpack_require__(26);
	var core_1 = __webpack_require__(3);
	var ContractTypeGroupListComponent = (function () {
	    function ContractTypeGroupListComponent(contractTypeGroupService, translateService, sharedvehiclegroupService, activeRoute, authService, router) {
	        this.contractTypeGroupService = contractTypeGroupService;
	        this.translateService = translateService;
	        this.sharedvehiclegroupService = sharedvehiclegroupService;
	        this.activeRoute = activeRoute;
	        this.authService = authService;
	        this.router = router;
	    }
	    ContractTypeGroupListComponent.prototype.ngOnInit = function () {
	        this.lblActive = this.translateService.instant('LblActive');
	        this.lblInactive = this.translateService.instant('LblInactive');
	        this.module = this.translateService.instant('LblContractTypeGroup');
	        this.breadCrumbList = this.translateService.instant('LblListPage', [this.module]);
	        this.sharedvehicleGroup = this.translateService.instant('LblListPage', [this.translateService.instant('LblSharedVehicleGroup')]);
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = ["contractTypGroupName"];
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlContractTypeGroupAdd = this.authService.GetURL(config_1.ApplicationRouteURL.URL_CONTRACT_TYPE__GROUP_ADD);
	        this.urlContractTypeGroupUpdate = this.authService.GetURL(config_1.ApplicationRouteURL.URL_CONTRACT_TYPE__GROUP_UPDATE);
	        this.urlContractTypeList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_CONTRACT_TYPE_LIST);
	        this.urlSVGList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SVG_LIST);
	        this.HandleSubscription();
	    };
	    ContractTypeGroupListComponent.prototype.HandleSubscription = function () {
	        var _this = this;
	        this.sub = this.activeRoute
	            .params
	            .subscribe(function (params) {
	            _this.sharedVehicleGroupHashId = params['sharedVehicleGroupHashId'] || '';
	            if (_this.sharedVehicleGroupHashId) {
	                _this.GetSharedVehicleGroupDetailsByHashId();
	                _this.addContractTypeGroupLink = new config_1.WeGoAuthorizedLink(_this.urlContractTypeGroupAdd + '/' + _this.sharedVehicleGroupHashId, config_1.Permission.PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_GROUP_OVERVIEW, config_1.PermissionType.INSERT, 'btn btn-highlight navbar-right', 'LblAddNew', config_1.Entity.SVG, _this.sharedVehicleGroupHashId);
	                _this.GetContractTypeGroupBySharedVehicleGroup();
	            }
	        });
	    };
	    ContractTypeGroupListComponent.prototype.GetSharedVehicleGroupDetailsByHashId = function () {
	        var _this = this;
	        this.sharedvehiclegroupService.GetSharedVehicleGroupBasicDetail(this.sharedVehicleGroupHashId)
	            .subscribe(function (res) {
	            if (res.data)
	                _this.groupName = res.data.entityName;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    ContractTypeGroupListComponent.prototype.GetContractTypeGroupBySharedVehicleGroup = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.contractTypeGroupService.GetContractTypeGroupBySharedVehicleGroup(this.sharedVehicleGroupHashId, this.DataListModel)
	            .subscribe(function (res) {
	            _this.contractTypeGroupList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    ContractTypeGroupListComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetContractTypeGroupBySharedVehicleGroup();
	    };
	    ContractTypeGroupListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetContractTypeGroupBySharedVehicleGroup();
	    };
	    ContractTypeGroupListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetContractTypeGroupBySharedVehicleGroup();
	    };
	    ContractTypeGroupListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetContractTypeGroupBySharedVehicleGroup();
	    };
	    ;
	    ContractTypeGroupListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.contractTypeGroupService.ExportContractTypeGroupBySharedVehicleGroup(this.sharedVehicleGroupHashId, this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "ContractTypeGroup" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	        ;
	    };
	    ContractTypeGroupListComponent.prototype.DeleteContractTypeGroup = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.contractTypeGroupService.DeleteContractTypeGroup(this.contractypegroupHashId)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.DataListModel.currentPage = 1;
	                _this.GetContractTypeGroupBySharedVehicleGroup();
	                _this.popupMsg = _this.translateService.instant('LblRecordRemovedSuccess', [_this.module]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupMsg = _this.translateService.instant('LblContractTypeDeleteValidation');
	                _this.isLoading = false;
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    ContractTypeGroupListComponent.prototype.ShowInactiveContractTypeGroupModal = function (contractTypeGroupHashId) {
	        this.inactiveContractTypeGroupModal.contractTypeGroupHashId = contractTypeGroupHashId;
	        this.inactiveContractTypeGroupModal.show();
	    };
	    // public SuccessAddContractTypeGroupModal($event: any) {
	    //   this.GetContractTypeGroupBySharedVehicleGroup();
	    //   this.message = $event.SuccessMessage;
	    // }
	    ContractTypeGroupListComponent.prototype.SuccessAlertModalClick = function () {
	        this.alertModal.hide();
	        this.DeleteContractTypeGroup();
	    };
	    ContractTypeGroupListComponent.prototype.ShowAlertModal = function (contractypegroupHashId) {
	        this.isLoading = false;
	        this.popupMsg = this.translateService.instant('LblRecordDeleteConfirmation', [this.module]);
	        this.alertModal.show();
	        this.contractypegroupHashId = contractypegroupHashId;
	    };
	    ContractTypeGroupListComponent.prototype.HideAlertModal = function () {
	        this.alertModal.hide();
	    };
	    ContractTypeGroupListComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    ContractTypeGroupListComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    ContractTypeGroupListComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    ContractTypeGroupListComponent.prototype.ngOnDestroy = function () {
	        if (this.sub) {
	            this.sub.unsubscribe();
	        }
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    __decorate([
	        core_1.ViewChild('inactiveContractTypeGroupModal'), 
	        __metadata('design:type', Object)
	    ], ContractTypeGroupListComponent.prototype, "inactiveContractTypeGroupModal", void 0);
	    __decorate([
	        core_1.ViewChild('alertModal'), 
	        __metadata('design:type', Object)
	    ], ContractTypeGroupListComponent.prototype, "alertModal", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], ContractTypeGroupListComponent.prototype, "successPopup", void 0);
	    ContractTypeGroupListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-contracttypegroup-list',
	            template: __webpack_require__(740),
	            providers: [contracttypegroup_service_1.ContractTypeGroupService, sharedvehiclegroup_service_1.SharedVehicleGroupService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof contracttypegroup_service_1.ContractTypeGroupService !== 'undefined' && contracttypegroup_service_1.ContractTypeGroupService) === 'function' && _a) || Object, (typeof (_b = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _b) || Object, (typeof (_c = typeof sharedvehiclegroup_service_1.SharedVehicleGroupService !== 'undefined' && sharedvehiclegroup_service_1.SharedVehicleGroupService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object, (typeof (_e = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _f) || Object])
	    ], ContractTypeGroupListComponent);
	    return ContractTypeGroupListComponent;
	    var _a, _b, _c, _d, _e, _f;
	}());
	exports.ContractTypeGroupListComponent = ContractTypeGroupListComponent;


/***/ },
/* 740 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ breadCrumbList}} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"urlSVGList\">\r\n            <i class=\"fa fa-group fa-fw\"></i> {{ sharedvehicleGroup }}</a>\r\n        </li>\r\n        <li class=\"active\"> {{ breadCrumbList}} </li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25 \">\r\n      <!-- <a class=\"btn btn-highlight navbar-right\" [routerLink]=\"[urlContractTypeGroupUpdate , { sharedVehicleGroupHashId: sharedVehicleGroupHashId}]\"\r\n        routerLinkActive=\"active\">{{ 'LblAddNew' | translate }}</a> -->\r\n      <!-- [queryParams]=\"{ sharedVehicleGroupHashId: sharedVehicleGroupHashId }\" -->\r\n      <wego-authorized-link [LinkModel]=\"addContractTypeGroupLink\"></wego-authorized-link>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <h4>\r\n          <label>{{ 'LblSharedVehicleGroup' | translate }} : </label> {{groupName}}</h4>\r\n        <wego-search-list (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\"\r\n          [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('contractTypGroupName')\">\r\n                  {{ 'LblContractTypeGroup' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'contractTypGroupName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <!-- <th class=\"cursor-pointer\" (click)=\"OnSort('plateformUsageCost')\">\r\n                  {{ 'LblPlateformUsageCost' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'plateformUsageCost'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('processingFee')\">\r\n                  {{ 'LblProcessingFee' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'processingFee'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th> -->\r\n                <!-- <th class=\"cursor-pointer\" (click)=\"OnSort('vatPercentage')\">\r\n                  {{ 'LblVatPercentage' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'vatPercentage'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th> -->\r\n                <th class=\"text-center\">\r\n                  {{ 'LblNumberOfContactType' | translate }}</th>\r\n                <th class=\"text-center\">\r\n                  {{ 'LblEdit' | translate }}\r\n                </th>\r\n                <th class=\"text-center\">\r\n                  {{ 'LblActiveInactive' | translate }}\r\n                </th>\r\n                <th class=\"text-center\">{{ 'LblDelete' | translate }}</th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let item of contractTypeGroupList\">\r\n                  <td>{{ item.contractTypGroupName }}</td>\r\n                  <!-- <td>{{ item.plateformUsageCostDisplay | decimalFormatter }}</td>\r\n                  <td>{{ item.processingFeeDisplay | decimalFormatter }}</td> -->\r\n                  <!-- <td>{{ item.vatPercentage | decimalFormatter }}</td> -->\r\n                  <td class=\"text-center\">\r\n                    <!-- [routerLink]=\"[urlContractTypeList, { sharedVehicleGroupHashId: sharedVehicleGroupHashId,  contractTypeGroupHashId : item.contractTypeGroupHashId }]\" -->\r\n                    <!-- [routerLink]=\"urlContractTypeList + '/' + item.contractTypeGroupHashId\" [queryParams]=\"{ sharedVehicleGroupHashId: sharedVehicleGroupHashId }\" -->\r\n                    <a *ngIf=\"item.isTotalContractType\" class=\"btn btn-primary cursor-pointer link-style\" [routerLink]=\"[urlContractTypeList, { sharedVehicleGroupHashId: sharedVehicleGroupHashId,  contractTypeGroupHashId : item.contractTypeGroupHashId }]\">\r\n                      <span class=\"badge link-text\">{{ item.totalContractType }}</span>\r\n                    </a>\r\n\r\n                    <a *ngIf=\"!item.isTotalContractType\" class=\"btn btn-primary link-style\" disabled>\r\n                      <span class=\"badge link-text\">{{ item.totalContractType }}</span>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"item.isEditable\" [routerLink]=\"urlContractTypeGroupUpdate + '/' + sharedVehicleGroupHashId + '/' + item.contractTypeGroupHashId\">\r\n                      <i class=\"fa fa-pencil-square-o fa-fw\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <template [ngIf]=\"!item.isActive\">\r\n                      <a class=\"cursor-pointer btn btn-xs btn-default\" (click)=\"ShowInactiveContractTypeGroupModal(item.contractTypeGroupHashId, item.isActive)\">\r\n                        {{ 'LblInactiveReason' | translate}} </a>\r\n                    </template>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"item.isDeletable\" class=\"cursor-pointer\" (click)=\"ShowAlertModal(item.contractTypeGroupHashId)\">\r\n                      <i class=\"fa fa-trash-o fa-fw text-danger\"></i>\r\n                    </a>\r\n                  </td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"9\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-inactive-contracttypegroup-popup #inactiveContractTypeGroupModal></wego-inactive-contracttypegroup-popup>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<wego-confirm-popup #alertModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessAlertModalClick()\" (onReject)=\"HideAlertModal()\"></wego-confirm-popup>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>";

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var translate_service_1 = __webpack_require__(70);
	var flatpickr_model_1 = __webpack_require__(83);
	var config_1 = __webpack_require__(60);
	var core_1 = __webpack_require__(3);
	var sharedvehiclegroup_model_1 = __webpack_require__(742);
	var sharedvehiclegroup_service_1 = __webpack_require__(510);
	var router_1 = __webpack_require__(26);
	var config_2 = __webpack_require__(60);
	var company_service_1 = __webpack_require__(501);
	var common_1 = __webpack_require__(22);
	var pre_post_trip_question_component_1 = __webpack_require__(743);
	var validate_license_24idcheck_option_1 = __webpack_require__(749);
	var instance_service_1 = __webpack_require__(500);
	var SharedVehicleGroupUpdateComponent = (function () {
	    function SharedVehicleGroupUpdateComponent(sharedvehiclegroupService, companyService, instanceService, authService, activeRoute, translate, router, locationService) {
	        this.sharedvehiclegroupService = sharedvehiclegroupService;
	        this.companyService = companyService;
	        this.instanceService = instanceService;
	        this.authService = authService;
	        this.activeRoute = activeRoute;
	        this.translate = translate;
	        this.router = router;
	        this.locationService = locationService;
	        this.timeFormat = config_1.WeGoConfig.FLATPICKR_TIME_FORMAT;
	        this.submitted = false;
	        //WEGO2DEV-325(Settings for Dashboard statuses)
	        //timeIntervalList : any;
	        //bookedBeforeTimeIntervalList : any;
	        this.roleLevel = config_1.RoleLevel;
	        this.selectedCompany = "";
	        this.language = 'en';
	        this.showIdCheckConfig = false;
	    }
	    SharedVehicleGroupUpdateComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.accessDeniedErrorCode = "412";
	        this.pageName = "SharedVehicleGroup";
	        this.module = this.translate.instant("LblSharedVehicleGroup");
	        this.flatPickrConfigTimeFrom = this.SetDefaultFlatTimePickrConfig();
	        this.flatPickrConfigTimeTo = this.SetDefaultFlatTimePickrConfig();
	        this.urlDefaultPage = this.authService.GetURL(config_2.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlSVGList = this.authService.GetURL(config_2.ApplicationRouteURL.URL_SVG_LIST);
	        this.model = new sharedvehiclegroup_model_1.SharedVehicleGroupModel();
	        this.sub = this.activeRoute.params.subscribe(function (params) {
	            _this.sharedvehiclegroupHashId = params["id"] || "";
	            if (_this.sharedvehiclegroupHashId != "") {
	                _this.GetCompanyListDropdown(config_2.PermissionType.EDIT);
	            }
	            else {
	                _this.GetCompanyListDropdown(config_2.PermissionType.INSERT);
	            }
	        });
	        this.IsAuthorizedForPrePostTripQuestion();
	    };
	    SharedVehicleGroupUpdateComponent.prototype.ngAfterViewInit = function () {
	        // viewChild is set after the view has been initialized
	        //
	    };
	    SharedVehicleGroupUpdateComponent.prototype.SetDefaultFlatTimePickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = true;
	        flatPickrConfig.time_24hr = true;
	        flatPickrConfig.noCalendar = true;
	        flatPickrConfig.dateFormat = this.timeFormat;
	        return flatPickrConfig;
	    };
	    SharedVehicleGroupUpdateComponent.prototype.onSubmit = function (forms) {
	        this.submitted = true;
	        this.AddNewSharedVehicleGroup();
	    };
	    SharedVehicleGroupUpdateComponent.prototype.GetSharedVehicleGroupDetails = function () {
	        var _this = this;
	        //this.sub = this.activeRoute.params.subscribe(params => {
	        // this.sharedvehiclegroupHashId = params["id"] || "";
	        if (this.sharedvehiclegroupHashId != "") {
	            this.isEditMode = true;
	            this.sharedvehiclegroupService
	                .GetSharedVehicleGroupHashId(this.sharedvehiclegroupHashId)
	                .subscribe(function (res) {
	                _this.model = res.data;
	                _this.language = _this.model.instanceLanguage;
	                _this.GetTwoFaEnabled();
	                _this.GetInstanceDetails();
	            }, function (error) {
	                _this.message = _this.authService.HandleErrorStatusCode(error);
	            }, function () { return console.log(_this.model); });
	        }
	        else {
	            this.isEditMode = false;
	        }
	        //});
	        this.breadCrumbTitle = this.isEditMode
	            ? this.translate.instant("LblEditPage", [this.module])
	            : this.translate.instant("LblAddPage", [this.module]);
	        this.breadCrumbList = this.translate.instant("LblListPage", [this.module]);
	    };
	    SharedVehicleGroupUpdateComponent.prototype.GetCompanyListDropdown = function (permissionType) {
	        var _this = this;
	        this.companyService
	            .GetCompanyListDropdownForAddUpdatePage(this.pageName, permissionType)
	            .subscribe(function (res) {
	            _this.companyList = res.data;
	            _this.model.companyMasterHashId =
	                _this.model.companyMasterHashId || _this.companyList.length > 0
	                    ? ""
	                    : "";
	            if (_this.companyList.length == 0) {
	                _this.authService.HandleErrorStatusCode(_this.accessDeniedErrorCode);
	            }
	            if (_this.companyList && _this.companyList.length > 0) {
	                if (!_this.model.companyMasterHashId &&
	                    _this.companyList.length == 1) {
	                    _this.model.companyMasterHashId = _this.companyList[0].keyHash;
	                }
	            }
	        }, function (error) {
	            _this.errorMessage = error;
	        }, function () { return _this.GetSharedVehicleGroupDetails(); });
	    };
	    SharedVehicleGroupUpdateComponent.prototype.AddNewSharedVehicleGroup = function () {
	        var _this = this;
	        this.sharedvehiclegroupService
	            .AddSharedVehicleGroupModel(this.model)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.isEditMode
	                    ? _this.translate.instant("LblRecordUpdatedSuccess", [_this.module])
	                    : _this.translate.instant("LblRecordAddedSuccess", [_this.module]);
	                _this.popupTitle = _this.translate.instant('LblSuccess');
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    SharedVehicleGroupUpdateComponent.prototype.Geofence = function () {
	        var _this = this;
	        this.companyService
	            .IsGeofenceEnables(this.model.companyMasterHashId)
	            .subscribe(function (res) {
	            _this.model.isGefenceEnabled = res.data;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    SharedVehicleGroupUpdateComponent.prototype.GetLocationMode = function () {
	        var _this = this;
	        this.companyService
	            .GetLocationMode(this.model.companyMasterHashId)
	            .subscribe(function (res) {
	            _this.model.isHomeLocationEnabled = res.data;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    SharedVehicleGroupUpdateComponent.prototype.OdometerConfig = function () {
	        var _this = this;
	        this.companyService
	            .IsOdometerConfigEnabled(this.model.companyMasterHashId)
	            .subscribe(function (res) {
	            _this.model.isOdometerConfiguration = res.data;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    SharedVehicleGroupUpdateComponent.prototype.onChangeSelectedField = function (selectedCompany) {
	        this.IsAuthorizedForPrePostTripQuestion();
	        this.model.companyMasterHashId = selectedCompany;
	        this.Geofence();
	        this.GetLocationMode();
	        this.OdometerConfig();
	        this.GetInstanceLaguage();
	        this.GetTwoFaEnabled();
	        this.GetInstanceDetails();
	    };
	    SharedVehicleGroupUpdateComponent.prototype.GetInstanceDetails = function () {
	        var _this = this;
	        if (this.model && this.model.companyMasterHashId) {
	            this.instanceService
	                .GetInstanceByCompanyHashId(this.model.companyMasterHashId)
	                .subscribe(function (res) {
	                _this.showIdCheckConfig = res.data.validateLicense24IDCheck == validate_license_24idcheck_option_1.ValidateLicense24IdCheckOption.Optional;
	            });
	        }
	    };
	    SharedVehicleGroupUpdateComponent.prototype.GetInstanceLaguage = function () {
	        var _this = this;
	        this.companyService
	            .GetInstanceLanguage(this.model.companyMasterHashId)
	            .subscribe(function (res) {
	            _this.language = res.data;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    SharedVehicleGroupUpdateComponent.prototype.GetTwoFaEnabled = function () {
	        var _this = this;
	        if (this.model && this.model.companyMasterHashId) {
	            this.companyService
	                .IsTwoFaEnabled(this.model.companyMasterHashId)
	                .subscribe(function (res) {
	                _this.TwoFaEnabled = res.data;
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            });
	        }
	        else {
	            this.TwoFaEnabled = false;
	        }
	    };
	    SharedVehicleGroupUpdateComponent.prototype.ngOnDestroy = function () {
	        if (this.sub) {
	            this.sub.unsubscribe();
	        }
	    };
	    SharedVehicleGroupUpdateComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    SharedVehicleGroupUpdateComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    SharedVehicleGroupUpdateComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    SharedVehicleGroupUpdateComponent.prototype.OnBackClick = function () {
	        this.locationService.back();
	    };
	    SharedVehicleGroupUpdateComponent.prototype.GetGeoLocation = function (event) {
	        if (this.model) {
	            var locationData = event.GeoLocationData;
	            this.model.geofenceAttributeModel.address = locationData.label;
	            this.model.geofenceAttributeModel.latitude = locationData.lat;
	            this.model.geofenceAttributeModel.longitude = locationData.lng;
	        }
	    };
	    SharedVehicleGroupUpdateComponent.prototype.GetAddress = function (place) {
	        this.model.geofenceAttributeModel.address = place["address"];
	        this.model.geofenceAttributeModel.latitude = place["lat"];
	        this.model.geofenceAttributeModel.longitude = place["log"];
	        this.model.geofenceAttributeModel.address = place["useraddressInput"];
	    };
	    // public onConfirmHomeAddress(event: any) {
	    //   if (this.model) {
	    //     let locationData = event;
	    //     this.model.homeLocationModel.address = locationData.address;
	    //     this.model.homeLocationModel.latitude = locationData.lat;
	    //     this.model.homeLocationModel.longitude = locationData.long;
	    //   }
	    // }
	    //  public GetHomeAddress(place: Object) {
	    //     this.model.homeLocationModel.address = place['address'];
	    //     this.model.homeLocationModel.latitude = place['lat'];
	    //     this.model.homeLocationModel.longitude = place['lng'];
	    //   }
	    SharedVehicleGroupUpdateComponent.prototype.GeofenceLocation = function () {
	        this.locationModelField = "geofence";
	        this.geoLocationModal.show(this.model.geofenceAttributeModel.address, this.model.geofenceAttributeModel.latitude, this.model.geofenceAttributeModel.longitude);
	    };
	    SharedVehicleGroupUpdateComponent.prototype.ResetLocationField = function (locationModelField) {
	        if (locationModelField == "home") {
	            this.model.homeLocationModel.address = "";
	            this.model.homeLocationModel.latitude = "0";
	            this.model.homeLocationModel.longitude = "0";
	        }
	        else {
	            this.model.geofenceAttributeModel.address = "";
	            this.model.geofenceAttributeModel.latitude = "0";
	            this.model.geofenceAttributeModel.longitude = "0";
	        }
	    };
	    SharedVehicleGroupUpdateComponent.prototype.SearchHomeAddress = function () {
	        this.locationModelField = "home";
	        this.geoLocationModal.show(this.model.homeLocationModel.address, this.model.homeLocationModel.latitude, this.model.homeLocationModel.longitude);
	    };
	    SharedVehicleGroupUpdateComponent.prototype.onConfirm = function ($event) {
	        if (this.locationModelField == "home") {
	            this.model.homeLocationModel.address = $event.address;
	            this.model.homeLocationModel.latitude = $event.lat;
	            this.model.homeLocationModel.longitude = $event.long;
	        }
	        else {
	            this.model.geofenceAttributeModel.address = $event.address;
	            this.model.geofenceAttributeModel.latitude = $event.lat;
	            this.model.geofenceAttributeModel.longitude = $event.long;
	        }
	    };
	    SharedVehicleGroupUpdateComponent.prototype.changeOfOdometerTimeInterval = function () {
	        if (this.model.odometerConfigurationModel.timeInterval == "PERBOOKING")
	            this.model.odometerConfigurationModel.frequency = "";
	    };
	    SharedVehicleGroupUpdateComponent.prototype.ResetCookies = function () {
	        var _this = this;
	        this.sharedvehiclegroupService.ResetTwoFaCookies(this.sharedvehiclegroupHashId)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblCookieResetSuccess', [_this.module]);
	                _this.popupTitle = _this.translate.instant('LblSuccess');
	                _this.ShowTwoFaPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblCookieResetFailed');
	                _this.popupTitle = _this.translate.instant('LblError');
	                _this.ShowTwoFaPopup();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    SharedVehicleGroupUpdateComponent.prototype.ResetTwoFA = function () {
	        var _this = this;
	        this.sharedvehiclegroupService.ResetTwoFaKeys(this.sharedvehiclegroupHashId)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblKeyResetSuccess', [_this.module]);
	                _this.popupTitle = _this.translate.instant('LblSuccess');
	                _this.ShowTwoFaPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblKeyResetFailed');
	                _this.popupTitle = _this.translate.instant('LblError');
	                _this.ShowTwoFaPopup();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    SharedVehicleGroupUpdateComponent.prototype.ShowTwoFaPopup = function () {
	        this.TwoFasuccessPopup.show();
	    };
	    SharedVehicleGroupUpdateComponent.prototype.ConfirmTwoFaPopup = function () {
	        this.TwoFasuccessPopup.hide();
	    };
	    SharedVehicleGroupUpdateComponent.prototype.OnPrePostTripQuestionSetting = function ($event) {
	        this.model.customTripQuestionList = $event.customTripQuestionList;
	    };
	    SharedVehicleGroupUpdateComponent.prototype.IsAuthorizedForPrePostTripQuestion = function () {
	        var _this = this;
	        var primaryPermissionType;
	        var entity = '';
	        var entityHashId = '';
	        if (this.sharedvehiclegroupHashId && this.sharedvehiclegroupHashId != "") {
	            primaryPermissionType = config_2.PermissionType.EDIT;
	            entity = config_1.Entity.SVG;
	            entityHashId = this.sharedvehiclegroupHashId;
	        }
	        else {
	            primaryPermissionType = config_2.PermissionType.INSERT;
	            entity = config_1.Entity.COMPANY;
	            entityHashId = this.model.companyMasterHashId;
	        }
	        this.authService
	            .IsAuthorizedForPrePostQuestion(config_1.Permission.PR_SHARED_VEHICLE_GROUP_OVERVIEW, primaryPermissionType, config_1.Permission.PR_PREPOST_TRIP_QUESTIONS_UPDATE, config_2.PermissionType.VIEW, entity, entityHashId)
	            .subscribe(function (res) {
	            _this.isAuthorizedForPrePostTrip = res.data.view;
	            _this.basePermissionModel = res.data;
	            console.log(_this.prePostTripQuestionSection);
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	        }, function () {
	            setTimeout(function () {
	                if (_this.isAuthorizedForPrePostTrip) {
	                    _this.prePostTripQuestionSection.GetPrePostTripQuestionList(null, _this.sharedvehiclegroupHashId ? null : _this.model.companyMasterHashId, _this.sharedvehiclegroupHashId, null, _this.basePermissionModel, !_this.sharedvehiclegroupHashId);
	                }
	            }, 1000);
	        });
	    };
	    SharedVehicleGroupUpdateComponent.prototype.LicenseCheckChange = function () {
	        if (this.model.licenseCheckEnabled == false) {
	            this.model.bookingLicenseCheckEnabled = false;
	        }
	    };
	    SharedVehicleGroupUpdateComponent.prototype.TrackAndTraceChange = function () {
	        if (this.model.trackAndTraceEnabled == true) {
	            this.model.createBookingDisabled = true;
	            this.model.editBookingDisabled = true;
	        }
	    };
	    __decorate([
	        core_1.ViewChild("successPopup"), 
	        __metadata('design:type', Object)
	    ], SharedVehicleGroupUpdateComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild('TwoFasuccessPopup'), 
	        __metadata('design:type', Object)
	    ], SharedVehicleGroupUpdateComponent.prototype, "TwoFasuccessPopup", void 0);
	    __decorate([
	        core_1.ViewChild("googleMapComp"), 
	        __metadata('design:type', Object)
	    ], SharedVehicleGroupUpdateComponent.prototype, "googleMapComp", void 0);
	    __decorate([
	        core_1.ViewChild("geoLocationModal"), 
	        __metadata('design:type', Object)
	    ], SharedVehicleGroupUpdateComponent.prototype, "geoLocationModal", void 0);
	    __decorate([
	        core_1.ViewChild("prePostTripQuestionSection"), 
	        __metadata('design:type', (typeof (_a = typeof pre_post_trip_question_component_1.PrePostTripQuestionComponent !== 'undefined' && pre_post_trip_question_component_1.PrePostTripQuestionComponent) === 'function' && _a) || Object)
	    ], SharedVehicleGroupUpdateComponent.prototype, "prePostTripQuestionSection", void 0);
	    SharedVehicleGroupUpdateComponent = __decorate([
	        core_1.Component({
	            selector: "wego-SharedVehicleGroup",
	            template: __webpack_require__(750),
	            providers: [sharedvehiclegroup_service_1.SharedVehicleGroupService, company_service_1.CompanyService, instance_service_1.InstanceService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof sharedvehiclegroup_service_1.SharedVehicleGroupService !== 'undefined' && sharedvehiclegroup_service_1.SharedVehicleGroupService) === 'function' && _b) || Object, (typeof (_c = typeof company_service_1.CompanyService !== 'undefined' && company_service_1.CompanyService) === 'function' && _c) || Object, (typeof (_d = typeof instance_service_1.InstanceService !== 'undefined' && instance_service_1.InstanceService) === 'function' && _d) || Object, (typeof (_e = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _f) || Object, (typeof (_g = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _g) || Object, (typeof (_h = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _h) || Object, (typeof (_j = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _j) || Object])
	    ], SharedVehicleGroupUpdateComponent);
	    return SharedVehicleGroupUpdateComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
	}());
	exports.SharedVehicleGroupUpdateComponent = SharedVehicleGroupUpdateComponent;


/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var instance_model_1 = __webpack_require__(513);
	var SharedVehicleGroupModel = (function () {
	    function SharedVehicleGroupModel() {
	        this.isBookingIntervalAlignToCalendar = false;
	        this.isGefenceEnabled = false;
	        this.isOdometerConfiguration = false;
	        this.showVehicleChargeLevel = "NO";
	        this.instanceLanguage = 'en';
	        this.isAccessCardsEnabled = false;
	        this.geofenceAttributeModel = new GeofenceAttributeModel();
	        this.homeLocationModel = new HomeLocationModel();
	        this.odometerConfigurationModel = new instance_model_1.OdometerConfigurationModel();
	        this.bookingRunningNotification = new BookingRunningNotification();
	        this.customTripQuestionList = new Array();
	        this.twoFAConfig = new instance_model_1.TwoFAConfigModel();
	    }
	    return SharedVehicleGroupModel;
	}());
	exports.SharedVehicleGroupModel = SharedVehicleGroupModel;
	var SharedVehicleSubscription = (function () {
	    function SharedVehicleSubscription() {
	    }
	    return SharedVehicleSubscription;
	}());
	exports.SharedVehicleSubscription = SharedVehicleSubscription;
	var GeofenceAttributeModel = (function () {
	    function GeofenceAttributeModel() {
	    }
	    return GeofenceAttributeModel;
	}());
	exports.GeofenceAttributeModel = GeofenceAttributeModel;
	var HomeLocationModel = (function () {
	    function HomeLocationModel() {
	    }
	    return HomeLocationModel;
	}());
	exports.HomeLocationModel = HomeLocationModel;
	var BookingRunningNotification = (function () {
	    function BookingRunningNotification() {
	        this.enableNotification = false;
	    }
	    return BookingRunningNotification;
	}());
	exports.BookingRunningNotification = BookingRunningNotification;


/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var auth_service_1 = __webpack_require__(58);
	var pre_post_trip_question_model_1 = __webpack_require__(744);
	var pre_post_trip_question_service_1 = __webpack_require__(746);
	var vehicle_service_1 = __webpack_require__(530);
	var translate_service_1 = __webpack_require__(70);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var common_1 = __webpack_require__(22);
	var instance_service_1 = __webpack_require__(500);
	var company_service_1 = __webpack_require__(501);
	var sharedvehiclegroup_service_1 = __webpack_require__(510);
	var custom_question_model_1 = __webpack_require__(747);
	var moment = __webpack_require__(84);
	var PrePostTripQuestionComponent = (function () {
	    //customeTripQuestionList = new Array<CustomeTripQuestion>();
	    function PrePostTripQuestionComponent(activeRoute, router, authService, prePostTripQuestionService, instanceService, companyService, sharedVehicleGroupService, vehicleService, locationService, translate) {
	        this.activeRoute = activeRoute;
	        this.router = router;
	        this.authService = authService;
	        this.prePostTripQuestionService = prePostTripQuestionService;
	        this.instanceService = instanceService;
	        this.companyService = companyService;
	        this.sharedVehicleGroupService = sharedVehicleGroupService;
	        this.vehicleService = vehicleService;
	        this.locationService = locationService;
	        this.translate = translate;
	        this.TotalcountBeforeRequired = [];
	        this.countRemainigBeforeRequired = [];
	        this.postTripQuestionList = [];
	        this.preTripQuestionList = [];
	        this.fazTripQuestionList = [];
	        this.prePostTripQuestionList = [];
	        this.countBeforeRequired = 0;
	        this.countBeforeOptional = 0;
	        this.countAfterRequired = 0;
	        this.countAfterOptional = 0;
	        this.countIsRequired = 0;
	        this.countIsOptional = 0;
	        this.countFazRequired = 0;
	        this.countFazOptional = 0;
	        this.roleLevel = config_1.RoleLevel;
	        this.customTripQuestionList = [];
	        this.onPrePostTripQuestionSetting = new core_1.EventEmitter();
	        this.VehicleView = false;
	        this.InstanceView = false;
	    }
	    Object.defineProperty(PrePostTripQuestionComponent.prototype, "PreTripBeforeRequired", {
	        // errorModel: IKeyValueInterface[];
	        get: function () {
	            return this.ChangeOrderSequence(true, true, 'PREBEFORE');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(PrePostTripQuestionComponent.prototype, "PreTripBeforeOptional", {
	        get: function () {
	            return this.ChangeOrderSequence(true, false, 'PREBEFORE');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(PrePostTripQuestionComponent.prototype, "PreTripAfterRequired", {
	        get: function () {
	            return this.ChangeOrderSequence(true, true, 'PREAFTER');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(PrePostTripQuestionComponent.prototype, "PreTripAfterOptional", {
	        get: function () {
	            return this.ChangeOrderSequence(true, false, 'PREAFTER');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(PrePostTripQuestionComponent.prototype, "PostTripRequired", {
	        get: function () {
	            return this.ChangeOrderSequenceForPost(true, true, 'POST');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(PrePostTripQuestionComponent.prototype, "PostTripOptional", {
	        get: function () {
	            return this.ChangeOrderSequenceForPost(true, false, 'POST');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(PrePostTripQuestionComponent.prototype, "FazTripRequired", {
	        get: function () {
	            return this.ChangeOrderSequenceForFaz(true, true, 'FAZ');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(PrePostTripQuestionComponent.prototype, "FazTripOptional", {
	        get: function () {
	            return this.ChangeOrderSequenceForFaz(true, false, 'FAZ');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    PrePostTripQuestionComponent.prototype.ngOnInit = function () {
	        this.model = new pre_post_trip_question_model_1.PrePostTripQuestionModel();
	        this.modelCustomTripQuestion = new custom_question_model_1.CustomeTripQuestion();
	        this.pageName = 'Pre Post Trip Question';
	        this.module = this.translate.instant('LblPrePostTripQuestion');
	        this.DataListModel = new config_1.DataListModel();
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlPrePostQuestionList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_PRE_POST_QUESTION);
	        this.addpreposttripQuestionLink = new config_1.WeGoAuthorizedLink('', config_1.Permission.PR_PREPOST_TRIP_QUESTIONS_UPDATE, config_1.PermissionType.INSERT, 'fa fa-plus-square', '');
	        if (this.prePostQuestionHashId) {
	            this.permissionType = config_1.PermissionType.EDIT;
	        }
	        else {
	            this.permissionType = config_1.PermissionType.INSERT;
	        }
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	    };
	    PrePostTripQuestionComponent.prototype.GetPrePostTripQuestionList = function (instanceHashId, companyHashId, svgHashId, vehicleHashId, basePermissionModel, isInsert, isInstance) {
	        var _this = this;
	        if (isInsert === void 0) { isInsert = false; }
	        if (isInstance === void 0) { isInstance = false; }
	        this.model.instanceHashId = instanceHashId;
	        this.model.companyHashId = companyHashId;
	        this.model.svgHashId = svgHashId;
	        this.model.vehicleHashId = vehicleHashId;
	        this.model.basePermissionModel = basePermissionModel;
	        this.model.isInsert = isInsert;
	        this.model.isInstance = isInstance;
	        this.sub = this.activeRoute.params.subscribe(function (params) {
	            _this.isEditMode = true;
	            _this.prePostTripQuestionService
	                .GetPrePostQuestionById(_this.model)
	                .subscribe(function (res) {
	                _this.modelCustomTripQuestion = res.data;
	                _this.prePostTripQuestionList = res.data;
	                _this.customTripQuestionList = _this.prePostTripQuestionList;
	                _this.onPrePostTripQuestionSetting.emit({
	                    customTripQuestionList: _this.customTripQuestionList
	                });
	                _this.preTripQuestionList = _this.prePostTripQuestionList.filter(function (x) { return x.questionType == 'PREBEFORE' || x.questionType == 'PREAFTER'; });
	                _this.postTripQuestionList = _this.prePostTripQuestionList.filter(function (x) { return x.questionType == 'POST'; });
	                _this.fazTripQuestionList = _this.prePostTripQuestionList.filter(function (x) { return x.questionType == 'FAZ'; });
	                _this.countBeforeRequired = _this.preTripQuestionList.filter(function (x) {
	                    return x.isActive == true &&
	                        x.questionType == 'PREBEFORE' &&
	                        x.isRequired == true;
	                }).length;
	                _this.countBeforeOptional = _this.preTripQuestionList.filter(function (x) {
	                    return x.isActive == true &&
	                        x.questionType == 'PREBEFORE' &&
	                        x.isRequired == false;
	                }).length;
	                _this.countAfterRequired = _this.preTripQuestionList.filter(function (x) {
	                    return x.isActive == true &&
	                        x.questionType == 'PREAFTER' &&
	                        x.isRequired == true;
	                }).length;
	                _this.countAfterOptional = _this.preTripQuestionList.filter(function (x) {
	                    return x.isActive == true &&
	                        x.questionType == 'PREAFTER' &&
	                        x.isRequired == false;
	                }).length;
	                _this.countIsRequired = _this.postTripQuestionList.filter(function (x) { return x.isActive && x.isRequired == true; }).length;
	                _this.countIsOptional = _this.postTripQuestionList.filter(function (x) { return x.isActive && x.isRequired == false; }).length;
	                _this.countFazRequired = _this.fazTripQuestionList.filter(function (x) { return x.isActive && x.isRequired == true; }).length;
	                _this.countFazOptional = _this.fazTripQuestionList.filter(function (x) { return x.isActive && x.isRequired == false; }).length;
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            });
	        });
	    };
	    PrePostTripQuestionComponent.prototype.inhertChanged = function ($event, item) {
	        if (!item.isInherit) {
	            this.restoreItem = item;
	            this.inheritRestoreMessage = this.translate.instant('LblRestoreInheritConfirmation', [this.module]);
	            this.alertInheritModal.show();
	        }
	    };
	    PrePostTripQuestionComponent.prototype.SuccessAlertRestoreModalClick = function () {
	        this.RestorePrePostQuestion(this.restoreItem.originalParentQuestionhashId);
	    };
	    PrePostTripQuestionComponent.prototype.HideRestoreAlertModal = function () {
	        this.restoreItem.isInherit = false;
	        this.alertInheritModal.hide();
	    };
	    PrePostTripQuestionComponent.prototype.RestorePrePostQuestion = function (prePostQuestionHashId) {
	        var _this = this;
	        this.sub = this.activeRoute.params.subscribe(function (params) {
	            _this.isEditMode = false;
	            //prePostQuestionHashId = params["id"] || "";
	            if (prePostQuestionHashId != '') {
	                _this.isEditMode = true;
	                _this.prePostTripQuestionService
	                    .GetPrePostTripQuestionByHashId(prePostQuestionHashId)
	                    .subscribe(function (res) {
	                    if (res.data) {
	                        _this.restoreItem.isRequired = res.data.isRequired;
	                        _this.restoreItem.isActive = res.data.isActive;
	                        _this.restoreItem.isRequired = res.data.isRequired;
	                        _this.restoreItem.orderNo = res.data.orderNo;
	                        _this.restoreItem.questionType = res.data.questionType;
	                    }
	                    _this.alertInheritModal.hide();
	                }, function (error) {
	                    _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	                    _this.alertInheritModal.hide();
	                });
	            }
	        });
	    };
	    PrePostTripQuestionComponent.prototype.ChangeOrderSequence = function (isActive, isRequired, questionType) {
	        var _this = this;
	        if (this.preTripQuestionList) {
	            var selectedValueArray = this.preTripQuestionList
	                .filter(function (x) {
	                return x.isActive == isActive &&
	                    x.questionType == questionType &&
	                    x.isRequired == isRequired;
	            })
	                .map(function (x) { return parseInt(x.orderNo.toString()); });
	            var intermidiateArray = this.convertLengthToArray(selectedValueArray.length);
	            var dropDownArray = this.filterUniqueValue(intermidiateArray, selectedValueArray);
	            dropDownArray.push(0);
	            this.customTripQuestionList = [];
	            this.preTripQuestionList.forEach(function (x) {
	                _this.customTripQuestionList.push(x);
	            });
	            this.postTripQuestionList.forEach(function (x) {
	                _this.customTripQuestionList.push(x);
	            });
	            this.fazTripQuestionList.forEach(function (x) {
	                _this.customTripQuestionList.push(x);
	            });
	            this.onPrePostTripQuestionSetting.emit({
	                customTripQuestionList: this.customTripQuestionList
	            });
	            return dropDownArray.sort(function (a, b) {
	                return a - b;
	            });
	        }
	        return [0];
	    };
	    PrePostTripQuestionComponent.prototype.ChangeOrderSequenceForPost = function (isActive, isRequired, questionType) {
	        var _this = this;
	        if (this.postTripQuestionList) {
	            var selectedValueArray = this.postTripQuestionList
	                .filter(function (x) {
	                return x.isActive == isActive &&
	                    x.questionType == questionType &&
	                    x.isRequired == isRequired;
	            })
	                .map(function (x) { return parseInt(x.orderNo.toString()); });
	            var intermidiateArray = this.convertLengthToArray(selectedValueArray.length);
	            var dropDownArray = this.filterUniqueValue(intermidiateArray, selectedValueArray);
	            dropDownArray.push(0);
	            this.customTripQuestionList = [];
	            this.preTripQuestionList.forEach(function (x) {
	                _this.customTripQuestionList.push(x);
	            });
	            this.postTripQuestionList.forEach(function (x) {
	                _this.customTripQuestionList.push(x);
	            });
	            this.fazTripQuestionList.forEach(function (x) {
	                _this.customTripQuestionList.push(x);
	            });
	            this.onPrePostTripQuestionSetting.emit({
	                customTripQuestionList: this.customTripQuestionList
	            });
	            return dropDownArray.sort(function (a, b) {
	                return a - b;
	            });
	        }
	        return [0];
	    };
	    PrePostTripQuestionComponent.prototype.ChangeOrderSequenceForFaz = function (isActive, isRequired, questionType) {
	        var _this = this;
	        if (this.fazTripQuestionList) {
	            var selectedValueArray = this.fazTripQuestionList
	                .filter(function (x) {
	                return x.isActive == isActive &&
	                    x.questionType == questionType &&
	                    x.isRequired == isRequired;
	            })
	                .map(function (x) { return parseInt(x.orderNo.toString()); });
	            var intermidiateArray = this.convertLengthToArray(selectedValueArray.length);
	            var dropDownArray = this.filterUniqueValue(intermidiateArray, selectedValueArray);
	            dropDownArray.push(0);
	            this.customTripQuestionList = [];
	            this.preTripQuestionList.forEach(function (x) {
	                _this.customTripQuestionList.push(x);
	            });
	            this.postTripQuestionList.forEach(function (x) {
	                _this.customTripQuestionList.push(x);
	            });
	            this.fazTripQuestionList.forEach(function (x) {
	                _this.customTripQuestionList.push(x);
	            });
	            this.onPrePostTripQuestionSetting.emit({
	                customTripQuestionList: this.customTripQuestionList
	            });
	            return dropDownArray.sort(function (a, b) {
	                return a - b;
	            });
	        }
	        return [0];
	    };
	    PrePostTripQuestionComponent.prototype.getCount = function ($event, item) {
	        if (item.isPreQuestion) {
	            if ($event.currentTarget.checked == true &&
	                item.questionType == 'PREBEFORE') {
	                this.countBeforeRequired += 1;
	                this.countBeforeOptional -= 1;
	                item.orderNo = 0;
	                this.ChangeOrderSequence(true, true, 'PREBEFORE');
	            }
	            else if ($event.currentTarget.checked == false &&
	                item.questionType == 'PREBEFORE') {
	                this.countBeforeRequired -= 1;
	                this.countBeforeOptional += 1;
	                item.orderNo = 0;
	                this.ChangeOrderSequence(true, false, 'PREBEFORE');
	            }
	            if ($event.currentTarget.checked == false &&
	                item.questionType == 'PREAFTER') {
	                this.countAfterOptional += 1;
	                this.countAfterRequired -= 1;
	                item.orderNo = 0;
	                this.ChangeOrderSequence(true, false, 'PREAFTER');
	            }
	            else if ($event.currentTarget.checked == true &&
	                item.questionType == 'PREAFTER') {
	                this.countAfterOptional -= 1;
	                this.countAfterRequired += 1;
	                item.orderNo = 0;
	                this.ChangeOrderSequence(true, true, 'PREAFTER');
	            }
	            else {
	            }
	        }
	        else if (item.isFazQuestion) {
	            if ($event.currentTarget.checked == false) {
	                this.countFazRequired -= 1;
	                this.countFazOptional += 1;
	                item.orderNo = 0;
	                this.ChangeOrderSequenceForFaz(true, false, 'FAZ');
	            }
	            else {
	                this.countFazRequired += 1;
	                this.countFazOptional -= 1;
	                item.orderNo = 0;
	                this.ChangeOrderSequenceForFaz(true, true, 'FAZ');
	            }
	        }
	        else {
	            if ($event.currentTarget.checked == false) {
	                this.countIsRequired -= 1;
	                this.countIsOptional += 1;
	                item.orderNo = 0;
	                this.ChangeOrderSequenceForPost(true, false, 'POST');
	            }
	            else {
	                this.countIsRequired += 1;
	                this.countIsOptional -= 1;
	                item.orderNo = 0;
	                this.ChangeOrderSequenceForPost(true, true, 'POST');
	            }
	        }
	    };
	    PrePostTripQuestionComponent.prototype.convertLengthToArray = function (countIsBeforeRequired) {
	        var finalValue = [];
	        for (var i = 1; i <= countIsBeforeRequired; i++) {
	            finalValue.push(i);
	        }
	        return finalValue;
	    };
	    PrePostTripQuestionComponent.prototype.filterUniqueValue = function (TotalCount, selectedCount) {
	        var res = TotalCount.filter(function (v) {
	            return selectedCount.indexOf(v) == -1;
	        });
	        return res;
	    };
	    PrePostTripQuestionComponent.prototype.AddCurrentSelectedValue = function (FinalSeletedValue, currentOrderNo) {
	        FinalSeletedValue.push(currentOrderNo);
	        return FinalSeletedValue;
	    };
	    PrePostTripQuestionComponent.prototype.counter = function (i) {
	        // /this.GetRemainingCount()
	        return new Array(i);
	    };
	    PrePostTripQuestionComponent.prototype.ShowAddPrePostQuestion = function (questionType, prePostQuestion, iitem, isEditMode) {
	        if (isEditMode === void 0) { isEditMode = true; }
	        if (!prePostQuestion) {
	            prePostQuestion = new custom_question_model_1.CustomeTripQuestion();
	            prePostQuestion.questionType = questionType;
	            prePostQuestion.orderNo = 0;
	            prePostQuestion.isEditable = true;
	            prePostQuestion.isDeletable = true;
	            prePostQuestion.isActive = true;
	        }
	        this.updatePrePostTripQuestion.show(questionType, prePostQuestion, iitem, isEditMode);
	    };
	    PrePostTripQuestionComponent.prototype.onClose = function ($event) {
	        if (!$event.isEditMode) {
	            this.customTripQuestionList.push($event.model);
	        }
	        this.preTripQuestionList = this.customTripQuestionList.filter(function (x) { return x.questionType == 'PREBEFORE' || x.questionType == 'PREAFTER'; });
	        this.postTripQuestionList = this.customTripQuestionList.filter(function (x) { return x.questionType == 'POST'; });
	        this.fazTripQuestionList = this.customTripQuestionList.filter(function (x) { return x.questionType == 'FAZ'; });
	        this.onPrePostTripQuestionSetting.emit({
	            customTripQuestionList: this.customTripQuestionList
	        });
	    };
	    PrePostTripQuestionComponent.prototype.OnBackClick = function () {
	        this.locationService.back();
	    };
	    PrePostTripQuestionComponent.prototype.OnSubmit = function (forms) {
	        var _this = this;
	        this.isLoading = true;
	        this.preTripQuestionList.forEach(function (x) {
	            _this.model.customeTripQuestion.push(x);
	        });
	        this.postTripQuestionList.forEach(function (x) {
	            _this.model.customeTripQuestion.push(x);
	        });
	        this.fazTripQuestionList.forEach(function (x) {
	            _this.model.customeTripQuestion.push(x);
	        });
	        this.prePostTripQuestionService
	            .UpdatePrePostTripQuestion(this.model)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.SuccessMsg;
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    PrePostTripQuestionComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    PrePostTripQuestionComponent.prototype.SuccessModalClick = function () {
	        this.router.navigate([this.urlPrePostQuestionList]);
	    };
	    PrePostTripQuestionComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    PrePostTripQuestionComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    PrePostTripQuestionComponent.prototype.ShowAlertModal = function (index, questionType) {
	        var prePostQuestionList;
	        if (questionType == 'PRE') {
	            prePostQuestionList = this.preTripQuestionList.filter(function (x) { return x.prePostEndDate == null; });
	        }
	        else if (questionType == 'FAZ') {
	            prePostQuestionList = this.fazTripQuestionList.filter(function (x) { return x.prePostEndDate == null; });
	        }
	        else {
	            prePostQuestionList = this.postTripQuestionList.filter(function (x) { return x.prePostEndDate == null; });
	        }
	        if (prePostQuestionList[index].prePostQuestionHashId) {
	            this.deleteMessage = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
	            this.preQuestionListIndex = index;
	            this.prepostQuestionList = prePostQuestionList;
	            this.alertModal.show();
	        }
	        else {
	            if (questionType == 'PRE') {
	                this.preTripQuestionList.splice(index, 1);
	            }
	            else if (questionType == 'FAZ') {
	                this.fazTripQuestionList.splice(index, 1);
	            }
	            else {
	                this.postTripQuestionList.splice(index, 1);
	            }
	        }
	    };
	    PrePostTripQuestionComponent.prototype.SuccessAlertModalClick = function () {
	        this.removePreQuestionDetail(this.preQuestionListIndex, this.prepostQuestionList);
	        this.alertModal.hide();
	    };
	    PrePostTripQuestionComponent.prototype.removePreQuestionDetail = function (index, prepostQuestionList) {
	        //let abc = this.preTripQuestionList.filter(x => x.prePostEndDate == null);
	        if (prepostQuestionList[index].prePostQuestionHashId) {
	            prepostQuestionList[index].prePostEndDate = moment()
	                .utc()
	                .format('DD-MM-YYYY HH:mm');
	        }
	        this.preQuestionListIndex = null;
	    };
	    PrePostTripQuestionComponent.prototype.GetPrePostQuestions = function (preTripQuestionList) {
	        return preTripQuestionList.filter(function (x) { return x.prePostEndDate == null; });
	    };
	    PrePostTripQuestionComponent.prototype.HideAlertModal = function () {
	        this.alertModal.hide();
	    };
	    PrePostTripQuestionComponent.prototype.ngOnDestroy = function () {
	        if (this.sub) {
	            this.sub.unsubscribe();
	        }
	    };
	    __decorate([
	        core_1.Input('ErrorModel'), 
	        __metadata('design:type', Array)
	    ], PrePostTripQuestionComponent.prototype, "errorModel", void 0);
	    __decorate([
	        core_1.Input('CustomTripQuestionList'), 
	        __metadata('design:type', Object)
	    ], PrePostTripQuestionComponent.prototype, "customTripQuestionList", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], PrePostTripQuestionComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild('UpdatePrePostTripQuestion'), 
	        __metadata('design:type', Object)
	    ], PrePostTripQuestionComponent.prototype, "updatePrePostTripQuestion", void 0);
	    __decorate([
	        core_1.Output('OnPrePostTripQuestionSetting'), 
	        __metadata('design:type', Object)
	    ], PrePostTripQuestionComponent.prototype, "onPrePostTripQuestionSetting", void 0);
	    __decorate([
	        core_1.ViewChild('alertModal'), 
	        __metadata('design:type', Object)
	    ], PrePostTripQuestionComponent.prototype, "alertModal", void 0);
	    __decorate([
	        core_1.ViewChild('alertInheritModal'), 
	        __metadata('design:type', Object)
	    ], PrePostTripQuestionComponent.prototype, "alertInheritModal", void 0);
	    __decorate([
	        core_1.Input('VehicleView'), 
	        __metadata('design:type', Boolean)
	    ], PrePostTripQuestionComponent.prototype, "VehicleView", void 0);
	    __decorate([
	        core_1.Input('InstanceView'), 
	        __metadata('design:type', Boolean)
	    ], PrePostTripQuestionComponent.prototype, "InstanceView", void 0);
	    PrePostTripQuestionComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-pre-post-trip-question',
	            template: __webpack_require__(748),
	            providers: [
	                pre_post_trip_question_service_1.PrePostTripQuestionService,
	                instance_service_1.InstanceService,
	                company_service_1.CompanyService,
	                sharedvehiclegroup_service_1.SharedVehicleGroupService,
	                vehicle_service_1.VehicleService
	            ],
	            styles: [
	                "\n      .toggle-border {\n        border: red 1px solid;\n      }\n    "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof pre_post_trip_question_service_1.PrePostTripQuestionService !== 'undefined' && pre_post_trip_question_service_1.PrePostTripQuestionService) === 'function' && _d) || Object, (typeof (_e = typeof instance_service_1.InstanceService !== 'undefined' && instance_service_1.InstanceService) === 'function' && _e) || Object, (typeof (_f = typeof company_service_1.CompanyService !== 'undefined' && company_service_1.CompanyService) === 'function' && _f) || Object, (typeof (_g = typeof sharedvehiclegroup_service_1.SharedVehicleGroupService !== 'undefined' && sharedvehiclegroup_service_1.SharedVehicleGroupService) === 'function' && _g) || Object, (typeof (_h = typeof vehicle_service_1.VehicleService !== 'undefined' && vehicle_service_1.VehicleService) === 'function' && _h) || Object, (typeof (_j = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _j) || Object, (typeof (_k = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _k) || Object])
	    ], PrePostTripQuestionComponent);
	    return PrePostTripQuestionComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
	}());
	exports.PrePostTripQuestionComponent = PrePostTripQuestionComponent;


/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var base_permission_model_1 = __webpack_require__(745);
	var PrePostTripQuestionModel = (function () {
	    function PrePostTripQuestionModel() {
	        this.companyHashId = "";
	        this.vehicleHashId = "";
	        this.svgHashId = "";
	        this.instanceHashId = "";
	        this.questionType = "";
	        this.customeTripQuestion = Array();
	        this.basePermissionModel = new base_permission_model_1.BasePermissionModel();
	    }
	    return PrePostTripQuestionModel;
	}());
	exports.PrePostTripQuestionModel = PrePostTripQuestionModel;


/***/ },
/* 745 */
/***/ function(module, exports) {

	"use strict";
	var BasePermissionModel = (function () {
	    function BasePermissionModel() {
	    }
	    return BasePermissionModel;
	}());
	exports.BasePermissionModel = BasePermissionModel;


/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var jquery_helper_service_1 = __webpack_require__(67);
	var PrePostTripQuestionService = (function () {
	    function PrePostTripQuestionService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	        this.JQueryHelper = new jquery_helper_service_1.JQueryHelperService();
	    }
	    PrePostTripQuestionService.prototype.GetPrePostQuestionsList = function (input) {
	        var getPrePostQuestionListUrl = config_1.WeGoConfig.API_PRE_POST_TRIP_QUESTION_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getPrePostQuestionListUrl = getPrePostQuestionListUrl + "?" + queryString;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getPrePostQuestionListUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    PrePostTripQuestionService.prototype.GetPrePostTripQuestionList = function (prePostTripQuestionModel, input) {
	        var url = config_1.WeGoConfig.API_PRE_POST_TRIP_QUESTION_DETAILS;
	        var queryStringDataListModel = this.authService.HandleAPIListInput(input);
	        var queryStringPrePostTripQuestionModel = this.JQueryHelper.Param(prePostTripQuestionModel);
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        url =
	            url +
	                "?" +
	                queryStringDataListModel +
	                "&" +
	                decodeURIComponent(queryStringPrePostTripQuestionModel);
	        return this.http
	            .get(url, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    PrePostTripQuestionService.prototype.CheckCustomTripQuestion = function (customTripQuestionModel) {
	        var body = customTripQuestionModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_PRE_POST_TRIP_QUESTION_CUSTOM, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    PrePostTripQuestionService.prototype.UpdatePrePostTripQuestion = function (prePostTripQuestion) {
	        var body = prePostTripQuestion;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_PRE_POST_TRIP_QUESTION_UPDATE, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    PrePostTripQuestionService.prototype.GetPrePostTripQuestionByHashId = function (prePostQuestionHashId) {
	        var getUrl = config_1.WeGoConfig.API_PRE_POST_TRIP_QUESTION_BY_HASHID +
	            "?prePostQuestionHashId=" +
	            prePostQuestionHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    PrePostTripQuestionService.prototype.GetPrePostQuestionById = function (prePostTripQuestionModel) {
	        var url = config_1.WeGoConfig.API_PRE_POST_TRIP_QUESTION_BY_INSTANCEHASHID;
	        var queryStringPrePostTripQuestionModel = this.JQueryHelper.Param(prePostTripQuestionModel);
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        url = url + "?" + decodeURIComponent(queryStringPrePostTripQuestionModel);
	        return this.http
	            .get(url, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    PrePostTripQuestionService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], PrePostTripQuestionService);
	    return PrePostTripQuestionService;
	    var _a, _b;
	}());
	exports.PrePostTripQuestionService = PrePostTripQuestionService;


/***/ },
/* 747 */
/***/ function(module, exports) {

	"use strict";
	var CustomeTripQuestion = (function () {
	    function CustomeTripQuestion() {
	        this.name = "";
	        this.isRequired = false;
	        this.answerType = "";
	        this.question = "";
	        this.prePostQuestionHashId = "";
	        this.isActive = false;
	        this.defaultLanguage = '';
	        this.prepostQuestionsByLangList = [];
	    }
	    return CustomeTripQuestion;
	}());
	exports.CustomeTripQuestion = CustomeTripQuestion;
	var PrepostQuestionsByLang = (function () {
	    function PrepostQuestionsByLang() {
	    }
	    return PrepostQuestionsByLang;
	}());
	exports.PrepostQuestionsByLang = PrepostQuestionsByLang;


/***/ },
/* 748 */
/***/ function(module, exports) {

	module.exports = "<div class=\"form-group col-md-12\">\r\n  <section>\r\n    <div class=\"row\">\r\n      <div>\r\n        <div class=\"col-md-4\" style=\"padding-left: 0px\">\r\n          <label>{{ 'LblPreTripQuestion' | translate }}</label>\r\n        </div>\r\n        <div class=\"pull-right\">\r\n          <a *ngIf=\"model.basePermissionModel?.insert\" class=\"cursor-pointer\" (click)=\"ShowAddPrePostQuestion('PREBEFORE', '', 0, false)\">\r\n            <i class=\"fa fa-plus-square\"></i>\r\n          </a>\r\n        </div>\r\n      </div>\r\n      <div>\r\n        <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'customTripQuestionList' }}</span>\r\n      </div>\r\n      <div>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th>\r\n                  &nbsp;\r\n                </th>\r\n                <th>\r\n                  {{ 'LblEnabled' | translate }}\r\n                </th>\r\n                <th>{{ 'LblName' | translate }} </th>\r\n                <th *ngIf=\"!InstanceView\">{{ 'LblInherit' | translate }} </th>\r\n                <th>{{ 'LblRequired' | translate }} </th>\r\n                <th>{{ 'LblOrder' | translate }} </th>\r\n                <th>{{ 'LblBeforeOpeningTheVehicle' | translate }} </th>\r\n                <th>{{ 'LblAfterOpeningTheVehicle' | translate }} </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <tr *ngFor=\"let item of GetPrePostQuestions(preTripQuestionList);let iitem = index\">\r\n                <td class=\"text-center\" style=\"width: 5%\">\r\n                  <a *ngIf=\"!item.PrePostEndDate && !item.isDefault && item.isDeletable && !item.prePostQuestionparentHashId\"\r\n                    href=\"javascript:\" (click)=\"ShowAlertModal(iitem, 'PRE')\">X</a>\r\n                </td>\r\n                <td class=\"text-center\" style=\"width: 5%\">\r\n                  <input type=\"checkbox\" [disabled]=\"!item.isEditable || item.isInherit \" name=\"isActive\" [(ngModel)]=\"item.isActive\"\r\n                    (click)=\"getCount($event, item)\">\r\n                </td>\r\n                <td style=\"width:400px; word-wrap:break-word;\">\r\n                  <label *ngIf=\"item.isDefault || !item.isEditable || item.prePostQuestionparentHashId\" name=\"Questionname\">{{\r\n                    item.name}} {{VehicleView? '- ' + item.svgName: ''}}</label>\r\n                  <a *ngIf=\"!item.isDefault && item.isEditable && !item.prePostQuestionparentHashId\" name=\"Questionname\"\r\n                    class=\"cursor-pointer\" (click)=\"ShowAddPrePostQuestion('PREBEFORE', item, iitem)\">{{ item.name}}</a>\r\n                </td>\r\n                <td *ngIf=\"!InstanceView\" class=\"text-center\" style=\"width: 5%\">\r\n                  <input [disabled]=\"!item.isEditable || !item.prePostQuestionparentHashId\" type=\"checkbox\" name=\"item.isInherit\"\r\n                    [(ngModel)]=\"item.isInherit\" (click)=\"inhertChanged($event, item)\">\r\n                </td>\r\n                <td class=\"text-center\">\r\n                  <input [disabled]=\"!item.isEditable || !item.isActive || item.isInherit\" type=\"checkbox\" name=\"{{'isRequired' + iitem}}\"\r\n                    [(ngModel)]=\"item.isRequired\" (click)=\"getCount($event, item)\">\r\n                </td>\r\n                <td>\r\n                  <select [disabled]=\"!item.isEditable || !item.isActive || item.isInherit\" [(ngModel)]=\"item.orderNo\"\r\n                    name=\"{{'BeforeRequiredOrderNo' + iitem}}\" *ngIf=\"item.isRequired == true && item.questionType == 'PREBEFORE'\">\r\n                    <option *ngIf=\"item.orderNo != 0\" [value]='item.orderNo'>{{ item.orderNo }}</option>\r\n                    <option *ngFor='let in of PreTripBeforeRequired' [value]='in'>{{ in }}</option>\r\n                  </select>\r\n                  <select [disabled]=\"!item.isEditable || !item.isActive || item.isInherit\" [(ngModel)]=\"item.orderNo\"\r\n                    name=\"{{'BeforeOptionalOrderNo' + iitem}}\" *ngIf=\"item.isRequired == false && item.questionType == 'PREBEFORE'\">\r\n                    <option *ngIf=\"item.orderNo != 0\" [value]='item.orderNo'>{{ item.orderNo }}</option>\r\n                    <option *ngFor='let in of PreTripBeforeOptional' [value]='in'>{{ in }}</option>\r\n                  </select>\r\n                  <select [disabled]=\"!item.isEditable || !item.isActive || item.isInherit\" [(ngModel)]=\"item.orderNo\"\r\n                    name=\"{{'AfterRequiredOrderNo' + iitem}}\" *ngIf=\"item.isRequired == true  && item.questionType == 'PREAFTER'\">\r\n                    <option *ngIf=\"item.orderNo != 0\" [value]='item.orderNo'>{{ item.orderNo }}</option>\r\n                    <option *ngFor='let in of PreTripAfterRequired' [value]='in'>{{ in }}</option>\r\n                  </select>\r\n                  <select [disabled]=\"!item.isEditable || !item.isActive || item.isInherit\" [(ngModel)]=\"item.orderNo\"\r\n                    name=\"{{'AfterOptionOrderNo' + iitem}}\" *ngIf=\"item.isRequired == false && item.questionType == 'PREAFTER'\">\r\n                    <option *ngIf=\"item.orderNo != 0\" [value]='item.orderNo'>{{ item.orderNo }}</option>\r\n                    <option *ngFor='let in of PreTripAfterOptional' [value]='in'>{{ in }}</option>\r\n                  </select>\r\n                </td>\r\n                <td class=\"text-center\">\r\n                  <input [disabled]=\"!item.isEditable || !item.isActive || item.isInherit\" type=\"radio\" name=\"{{'Before' + iitem}}\"\r\n                    data-col=\"1\" [(ngModel)]=\"item.questionType\" value=\"PREBEFORE\" (click)=\"getCount($event, item)\">\r\n                </td>\r\n                <td class=\"text-center\">\r\n                  <input [disabled]=\"!item.isEditable || !item.isActive || item.isInherit\" type=\"radio\" name=\"{{'After' + iitem}}\"\r\n                    data-col=\"2\" [(ngModel)]=\"item.questionType\" value=\"PREAFTER\" (click)=\"getCount($event, item)\">\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n            <tbody *ngIf=\"preTripQuestionList.length == 0\">\r\n              <tr>\r\n                <td colspan=\"8\" class=\"text-center\">\r\n                  No Data found\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n  <br />\r\n  <br />\r\n  <section>\r\n    <div class=\"row\">\r\n      <div>\r\n        <div class=\"col-md-4\" style=\"padding-left: 0px\">\r\n          <label>{{ 'LblPostTripQuestion' | translate }}</label>\r\n        </div>\r\n        <div class=\"pull-right\">\r\n          <a *ngIf=\"model.basePermissionModel?.insert\" class=\"cursor-pointer\" (click)=\"ShowAddPrePostQuestion('POST', '', 0,false)\">\r\n            <i class=\"fa fa-plus-square\"></i>\r\n          </a>\r\n        </div>\r\n      </div>\r\n      <div>\r\n        <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'CustomTripQuestionListPost' }}</span>\r\n      </div>\r\n      <div>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th>\r\n                  &nbsp;\r\n                </th>\r\n                <th>\r\n                  {{ 'LblEnabled' | translate }}\r\n                </th>\r\n                <th>{{ 'LblName' | translate }} </th>\r\n                <th *ngIf=\"!InstanceView\">{{ 'LblInherit' | translate }} </th>\r\n                <th class=\"text-center\">{{ 'LblRequired' | translate }} </th>\r\n                <th>{{ 'LblOrder' | translate }} </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <tr *ngFor=\"let postTripItem of GetPrePostQuestions(postTripQuestionList) ;let iitem = index\">\r\n                <td class=\"text-center\" style=\"width: 5%\">\r\n                  <a *ngIf=\"!postTripItem.PrePostEndDate  && !postTripItem.isDefault  && postTripItem.isDeletable &&  !postTripItem.prePostQuestionparentHashId\"\r\n                    href=\"javascript:\" (click)=\"ShowAlertModal(iitem, 'POST')\">X</a>\r\n                </td>\r\n                <td class=\"text-center\" style=\"width: 5%\">\r\n                  <input [disabled]=\"!postTripItem.isEditable  || postTripItem.isInherit\" type=\"checkbox\" name=\"postTripItem.isActive\"\r\n                    [(ngModel)]=\"postTripItem.isActive\" (click)=\"getCount($event, postTripItem)\">\r\n                </td>\r\n                <td style=\"width:500px; word-wrap:break-word;\">\r\n                  <label *ngIf=\"postTripItem.isDefault || !postTripItem.isEditable || postTripItem.prePostQuestionparentHashId\"\r\n                    name=\"Questionname\">{{ postTripItem.name}} {{VehicleView? '- ' + postTripItem.svgName :''}}</label>\r\n                  <a *ngIf=\"!postTripItem.isDefault && postTripItem.isEditable && !postTripItem.prePostQuestionparentHashId\"\r\n                    name=\"Questionname\" class=\"cursor-pointer\" (click)=\"ShowAddPrePostQuestion('POST', postTripItem, iitem)\">{{\r\n                    postTripItem.name}}</a>\r\n                </td>\r\n                <td *ngIf=\"!InstanceView\" class=\"text-center\" style=\"width: 5%\">\r\n                  <input [disabled]=\"!postTripItem.isEditable || !postTripItem.prePostQuestionparentHashId \" type=\"checkbox\"\r\n                    name=\"postTripItem.isInherit\" [(ngModel)]=\"postTripItem.isInherit\" (click)=\"inhertChanged($event, postTripItem)\">\r\n                </td>\r\n                <td class=\"text-center\">\r\n                  <input [disabled]=\"!postTripItem.isEditable  || !postTripItem.isActive || postTripItem.isInherit\"\r\n                    type=\"checkbox\" name=\"{{'isRequiredPost' + iitem}}\" (click)=\"getCount($event, postTripItem)\"\r\n                    [(ngModel)]=\"postTripItem.isRequired\">\r\n                </td>\r\n                <td>\r\n                  <select [disabled]=\"!postTripItem.isEditable  || !postTripItem.isActive || postTripItem.isInherit\"\r\n                    [(ngModel)]=\"postTripItem.orderNo\" name=\"{{'OrderNoPostRequired' + iitem}}\" *ngIf=\"postTripItem.isRequired\">\r\n                    <option *ngIf=\"postTripItem.orderNo != 0\" [value]='postTripItem.orderNo'>{{ postTripItem.orderNo }}</option>\r\n                    <option *ngFor='let in of PostTripRequired' [value]='in'>{{ in }}</option>\r\n                  </select>\r\n                  <select [disabled]=\"!postTripItem.isEditable  || !postTripItem.isActive || postTripItem.isInherit\"\r\n                    [(ngModel)]=\"postTripItem.orderNo\" name=\"{{'OrderNoPostOptional' + iitem}}\" *ngIf=\"!postTripItem.isRequired\">\r\n                    <option *ngIf=\"postTripItem.orderNo != 0\" [value]='postTripItem.orderNo'>{{ postTripItem.orderNo }}</option>\r\n                    <option *ngFor='let in of PostTripOptional' [value]='in'>{{ in }}</option>\r\n                  </select>\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n            <tbody *ngIf=\"postTripQuestionList.length == 0\">\r\n              <tr>\r\n                <td colspan=\"6\" class=\"text-center\">\r\n                  No Data found\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n  <br />\r\n  <br />\r\n\r\n  <section>\r\n    <div class=\"row\">\r\n      <div>\r\n        <div class=\"col-md-4\" style=\"padding-left: 0px\">\r\n          <label>{{ 'LblFazTripQuestionAfterClosingTheVehicle' | translate }}</label>\r\n        </div>\r\n        <div class=\"pull-right\">\r\n          <a *ngIf=\"model.basePermissionModel?.insert\" class=\"cursor-pointer\" (click)=\"ShowAddPrePostQuestion('FAZ', '', 0, false)\">\r\n            <i class=\"fa fa-plus-square\"></i>\r\n          </a>\r\n        </div>\r\n      </div>\r\n      <div>\r\n        <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'FazTripQuestionListPost' }}</span>\r\n      </div>\r\n      <div>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th>\r\n                  &nbsp;\r\n                </th>\r\n                <th>\r\n                  {{ 'LblEnabled' | translate }}\r\n                </th>\r\n                <th>{{ 'LblName' | translate }} </th>\r\n                <th *ngIf=\"!InstanceView\">{{ 'LblInherit' | translate }} </th>\r\n                <th class=\"text-center\">{{ 'LblRequired' | translate }} </th>\r\n                <th>{{ 'LblOrder' | translate }} </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <tr *ngFor=\"let fazTripItem of GetPrePostQuestions(fazTripQuestionList); let iitem = index\">\r\n                <td class=\"text-center\" style=\"width: 5%\">\r\n                  <a *ngIf=\"!fazTripItem.PrePostEndDate && !fazTripItem.isDefault && fazTripItem.isDeletable && !fazTripItem.prePostQuestionparentHashId\"\r\n                    href=\"javascript:\" (click)=\"ShowAlertModal(iitem, 'FAZ')\">X</a>\r\n                </td>\r\n                <td class=\"text-center\" style=\"width: 5%\">\r\n                  <input [disabled]=\"!fazTripItem.isEditable || fazTripItem.isInherit\" type=\"checkbox\" name=\"fazTripItem.isActive\"\r\n                    [(ngModel)]=\"fazTripItem.isActive\" (click)=\"getCount($event, fazTripItem)\">\r\n                </td>\r\n                <td style=\"width:500px; word-wrap:break-word;\">\r\n                  <label *ngIf=\"fazTripItem.isDefault || !fazTripItem.isEditable || fazTripItem.prePostQuestionparentHashId\"\r\n                    name=\"Questionname\">{{ fazTripItem.name}} {{VehicleView? '- ' + fazTripItem.svgName :''}}</label>\r\n                  <a *ngIf=\"!fazTripItem.isDefault && fazTripItem.isEditable && !fazTripItem.prePostQuestionparentHashId\"\r\n                    name=\"Questionname\" class=\"cursor-pointer\" (click)=\"ShowAddPrePostQuestion('FAZ', fazTripItem, iitem)\">{{\r\n                      fazTripItem.name}}</a>\r\n                </td>\r\n                <td *ngIf=\"!InstanceView\" class=\"text-center\" style=\"width: 5%\">\r\n                  <input [disabled]=\"!fazTripItem.isEditable || !fazTripItem.prePostQuestionparentHashId \" type=\"checkbox\"\r\n                    name=\"fazTripItem.isInherit\" [(ngModel)]=\"fazTripItem.isInherit\" (click)=\"inhertChanged($event, fazTripItem)\">\r\n                </td>\r\n                <td class=\"text-center\">\r\n                  <input [disabled]=\"true\"\r\n                    type=\"checkbox\" name=\"{{'isRequiredFaz' + iitem}}\" (click)=\"getCount($event, fazTripItem)\"\r\n                    [(ngModel)]=\"fazTripItem.isRequired\">\r\n                </td>\r\n                <td>\r\n                  <select [disabled]=\"!fazTripItem.isEditable || !fazTripItem.isActive || fazTripItem.isInherit\"\r\n                    [(ngModel)]=\"fazTripItem.orderNo\" name=\"{{'OrderNoFazRequired' + iitem}}\" *ngIf=\"fazTripItem.isRequired\">\r\n                    <option *ngIf=\"fazTripItem.orderNo != 0\" [value]='fazTripItem.orderNo'>{{ fazTripItem.orderNo }}</option>\r\n                    <option *ngFor='let in of FazTripRequired' [value]='in'>{{ in }}</option>\r\n                  </select>\r\n                  <select [disabled]=\"!fazTripItem.isEditable || !fazTripItem.isActive || fazTripItem.isInherit\"\r\n                    [(ngModel)]=\"fazTripItem.orderNo\" name=\"{{'OrderNoFazOptional' + iitem}}\" *ngIf=\"!fazTripItem.isRequired\">\r\n                    <option *ngIf=\"fazTripItem.orderNo != 0\" [value]='fazTripItem.orderNo'>{{ postTripItem.orderNo }}</option>\r\n                    <option *ngFor='let in of FazTripOptional' [value]='in'>{{ in }}</option>\r\n                  </select>\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n            <tbody *ngIf=\"fazTripQuestionList.length == 0\">\r\n              <tr>\r\n                <td colspan=\"6\" class=\"text-center\">\r\n                  No Data found\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n  <br />\r\n</div>\r\n\r\n<wego-update-pre-post-trip-question #UpdatePrePostTripQuestion (OnClose)=\"onClose($event)\"></wego-update-pre-post-trip-question>\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n<wego-confirm-popup #alertModal [popupMsg]=\"deleteMessage\" (onConfirm)=\"SuccessAlertModalClick()\" (onReject)=\"HideAlertModal()\"></wego-confirm-popup>\r\n<wego-confirm-popup #alertInheritModal [popupMsg]=\"inheritRestoreMessage\" (onConfirm)=\"SuccessAlertRestoreModalClick()\"\r\n  (onReject)=\"HideRestoreAlertModal()\"></wego-confirm-popup>";

/***/ },
/* 749 */
/***/ function(module, exports) {

	"use strict";
	(function (ValidateLicense24IdCheckOption) {
	    ValidateLicense24IdCheckOption[ValidateLicense24IdCheckOption["On"] = 0] = "On";
	    ValidateLicense24IdCheckOption[ValidateLicense24IdCheckOption["Optional"] = 1] = "Optional";
	    ValidateLicense24IdCheckOption[ValidateLicense24IdCheckOption["Off"] = 2] = "Off";
	})(exports.ValidateLicense24IdCheckOption || (exports.ValidateLicense24IdCheckOption = {}));
	var ValidateLicense24IdCheckOption = exports.ValidateLicense24IdCheckOption;


/***/ },
/* 750 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{breadCrumbTitle}}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li><a [routerLink]=\"urlDefaultPage\"><i class=\"fa fa-dashboard\"></i>{{ 'LblHome' | translate }}</a></li>\r\n        <li><a [routerLink]=\"urlSVGList\"><i class=\"fa fa-group fa-fw\"></i>{{breadCrumbList}}</a></li>\r\n        <li class=\"active\">{{breadCrumbTitle}}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n\r\n  <section class=\"content\">\r\n    <div class=\"nopad\">\r\n      <!--<pre> {{ model | json }} </pre>-->\r\n      <form (ngSubmit)=\"onSubmit(AddSharedVehicleGroupForm.value)\" #AddSharedVehicleGroupForm=\"ngForm\">\r\n        <input type=\"hidden\" class=\"form-control\" [(ngModel)]=\"model.sharedVehicleGroupHashId\" name=\"sharedVehicleGroupHashId\">\r\n        <input type=\"hidden\" class=\"form-control\" [(ngModel)]=\"model.companyMasterHashId\" name=\"companyMasterHashId\">\r\n\r\n        <div class=\"form-group col-md-4\">\r\n          <label><span class=\"text text-danger\">*</span>{{ 'LblSharedVehicleGroup' | translate }}</label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblSharedVehicleGroup' | translate }}\" [(ngModel)]=\"model.groupName\" name=\"GroupName\" maxlength=\"255\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'groupName' }}</span>\r\n        </div>\r\n\r\n        <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Company\" class=\"form-group col-md-4\">\r\n          <label><span class=\"text text-danger\">*</span>{{ 'LblCompany' | translate }}</label>\r\n          <select [disabled]=\"isEditMode\" [(ngModel)]=\"model.companyMasterHashId\" name=\"company\" class=\"form-control\" (change)=\"onChangeSelectedField($event.target.value)\">\r\n            <template [ngIf]=\"isEditMode\">\r\n              <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblCompany' | translate }}</option>\r\n            </template>\r\n            <template [ngIf]=\"!isEditMode\">\r\n              <option value=\"\" [selected]=\"selected\">{{ 'LblSelect' | translate }} {{ 'LblCompany' | translate }}</option>\r\n            </template>\r\n            <option *ngFor=\"let comp of companyList\" [attr.value]='comp.keyHash'>{{comp.value}}</option>\r\n          </select>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'CompanyMasterHashId' }}</span>\r\n        </div>\r\n\r\n        <input type=\"hidden\" class=\"form-control\" [(ngModel)]=\"model.companyMasterHashId\" name=\"company\">\r\n\r\n        <div class=\"form-group col-md-4\">\r\n          <label><span class=\"text text-danger\">*</span>{{ 'LblBookingInterval' | translate }}</label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblBookingInterval' | translate }}\" [(ngModel)]=\"model.bookingInterval\" name=\"bookingInterval\" maxlength=\"4\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'bookingInterval' }}</span>\r\n        </div>\r\n        \r\n        <div class=\"clearfix\"></div>\r\n\r\n        <div class=\"form-group col-md-4\">\r\n          <label><span class=\"text text-danger\">*</span> {{ 'LblBookingMinDuration' | translate }}</label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblBookingMinDuration' | translate }}\" [(ngModel)]=\"model.bookingMinDuration\" name=\"bookingMinDuration\" maxlength=\"4\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'bookingMinDuration' }}</span>\r\n        </div>\r\n\r\n        <div class=\"form-group col-md-4\">\r\n          <label>{{ 'LblBookingMaxDuration' | translate }}</label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblBookingMaxDuration' | translate }}\" [(ngModel)]=\"model.bookingMaxDuration\" name=\"bookingMaxDuration\" maxlength=\"5\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'bookingMaxDuration' }}</span>\r\n        </div>\r\n\r\n        <div class=\"form-group col-md-4\">\r\n          <label><span class=\"text text-danger\">*</span> {{ 'LblMaxRecurringBooking' | translate }}</label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblMaxRecurringBooking' | translate }}\" [(ngModel)]=\"model.maxRecurringBooking\" name=\"maxRecurringBooking\" maxlength=\"3\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'maxRecurringBooking' }}</span>\r\n        </div>\r\n\r\n        <div class=\"clearfix\"></div>\r\n\r\n        <div class=\"form-group col-md-4\">\r\n          <label><span class=\"text text-danger\">*</span> {{ 'LblPreBookingInterval' | translate }}</label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblPreBookingInterval' | translate }}\" [(ngModel)]=\"model.preBookingInterval\" name=\"preBookingInterval\" maxlength=\"4\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'preBookingInterval' }}</span>\r\n        </div>\r\n\r\n        <div class=\"form-group col-md-4\">\r\n          <label><span class=\"text text-danger\">*</span> {{ 'LblPostBookingInterval' | translate }}</label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblPostBookingInterval' | translate }}\" [(ngModel)]=\"model.postBookingInterval\" name=\"postBookingInterval\" maxlength=\"4\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'postBookingInterval' }}</span>\r\n        </div>\r\n\r\n        <div class=\"form-group col-md-4\">\r\n          <label><span class=\"text text-danger\">*</span> {{ 'LblBookingExtensionTime' | translate }}</label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblBookingExtensionTime' | translate }}\" [(ngModel)]=\"model.bookingExtensionTime\" name=\"bookingExtensionTime\" maxlength=\"4\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'bookingExtensionTime' }}</span>\r\n        </div>\r\n\r\n        <div class=\"clearfix\"></div>\r\n\r\n        <div class=\"form-group col-md-4\">\r\n          <label><span class=\"text text-danger\">*</span> {{ 'LblEarlyOpenInterval' | translate }}</label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblEarlyOpenInterval' | translate }}\" [(ngModel)]=\"model.earlyOpenInterval\" name=\"earlyOpenInterval\" maxlength=\"4\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'earlyOpenInterval' }}</span>\r\n        </div>\r\n\r\n        <div class=\"form-group col-md-4\">\r\n          <label><span class=\"text text-danger\">*</span>{{ 'LblIsBookingIntervalAlignToCalendar' | translate }}</label>\r\n          <div>\r\n            <label class=\"radio-inline\">\r\n              <input type=\"radio\" [(ngModel)]=\"model.isBookingIntervalAlignToCalendar\" name=\"IsBookingIntervalAlignToCalendar\" [value]=\"true\">{{ 'LblYes' | translate }}\r\n            </label>\r\n            <label class=\"radio-inline\">\r\n              <input type=\"radio\" [(ngModel)]=\"model.isBookingIntervalAlignToCalendar\" name=\"IsBookingIntervalAlignToCalendar\" [value]=\"false\">{{ 'LblNo' | translate }}\r\n            </label>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"form-group col-md-4\">\r\n          <label><span class=\"text text-danger\">*</span>{{ 'LblShowVehicleChargeLevel' | translate }}</label>\r\n          <div>\r\n            <label class=\"radio-inline\">\r\n              <input type=\"radio\" [(ngModel)]=\"model.showVehicleChargeLevel\" name=\"showVehicleChargeLevel\" value=\"YES\">{{ 'LblYes' | translate }}\r\n            </label>\r\n            <label class=\"radio-inline\">\r\n              <input type=\"radio\" [(ngModel)]=\"model.showVehicleChargeLevel\" name=\"showVehicleChargeLevel\" value=\"NO\">{{ 'LblNo' | translate }}\r\n            </label>\r\n          </div>\r\n        </div>\r\n\r\n        <!-- WEGO2DEV-325(Settings for Dashboard statuses) -->\r\n        <!-- <div class=\"clearfix\"></div>\r\n         <div class=\"form-group col-md-3\">\r\n          <label><span class=\"text text-danger\">*</span>{{ 'LblVehicleOnSameLocationTime' | translate }}</label>\r\n          <input type=\"text\" maxlength=\"6\" class=\"form-control\" placeholder=\"{{ 'LblVehicleOnSameLocationTime' | translate }}\" [(ngModel)]=\"model.locationVehicleTime\"\r\n            name=\"locationVehicleTime\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'locationVehicleTime' }}</span>\r\n        </div>\r\n        <div class=\"form-group col-md-3\">\r\n          <label><span class=\"text text-danger\">*</span>{{'LblVehicleOnSameLocationTimeInterval' | translate}}</label>\r\n          <select [(ngModel)]=\"model.locationTimeInterval\" class=\"form-control\" name=\"LocationTimeInterval\">\r\n          <option *ngFor=\"let item of timeIntervalList\" [ngValue]=\"item.Value\">{{ item.Key }}</option>\r\n         </select>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'LocationTimeInterval' }}</span>\r\n        </div>\r\n        <div class=\"form-group col-md-3\">\r\n          <label><span class=\"text text-danger\">*</span>{{'LblVehicleBookedBeforeTime' | translate}}</label>\r\n          <input type=\"text\" maxlength=\"6\" class=\"form-control\" placeholder=\"{{ 'LblVehicleBookedBeforeTime' | translate }}\" [(ngModel)]=\"model.bookedBeforeTime\"\r\n            name=\"bookedBeforeTime\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'bookedBeforeTime' }}</span>\r\n        </div>\r\n        <div class=\"form-group col-md-3\">\r\n          <label><span class=\"text text-danger\">*</span>{{'LblVehicleBookedBeforeInterval' | translate}}</label>\r\n          <select [(ngModel)]=\"model.bookedBeforeInterval\" class=\"form-control\" name=\"BookedBeforeInterval\">\r\n          <option *ngFor=\"let item of bookedBeforeTimeIntervalList\" [ngValue]=\"item.Value\">{{ item.Key }}</option>\r\n         </select>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'BookedBeforeInterval' }}</span>\r\n        </div> -->\r\n        <!--<div class=\"form-group col-md-4\">\r\n          <label>{{ 'LblBookAheadTime' | translate }}</label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblBookAheadTime' | translate }}\" [(ngModel)]=\"model.bookAheadTime\" name=\"bookAheadTime\" maxlength=\"4\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'bookAheadTime' }}</span>\r\n        </div>-->\r\n\r\n        <div class=\"clearfix\"></div>\r\n\r\n        <!--<div class=\"form-group col-md-12\">\r\n          <label> <span class=\"text text-danger\">*</span>{{ 'LblGeoLocation' | translate }} </label>\r\n          <input class=\"form-control\" type=\"text\" name=\"groupGeoLocationAddress\" [(ngModel)]=\"model.groupGeoLocationAddress\" (setAddress)=\"GetAddress($event)\" googleplace />-->\r\n        <!--<div class=\"input-group\">\r\n            <div class=\"input-group-btn\">\r\n              <button class=\"btn btn-default\" type=\"button\" (click)=\"geoLocationModal.show()\">\r\n                  <i class=\"fa fa-map-marker\" aria-hidden=\"true\"></i>\r\n                </button>\r\n            </div>\r\n          </div>-->\r\n        <!--<span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'groupGeoLocationAddress' }}</span>\r\n        </div>-->\r\n\r\n        <!--Addedd-->\r\n        <div *ngIf=\"model.isGefenceEnabled\" class=\"form-group col-md-6\">\r\n          <label> {{ 'LblGeofenceLocation' | translate }}</label>\r\n          <div class=\"input-group\">\r\n            <input class=\"form-control\" type=\"text\" placeholder=\"{{ 'LblGeofenceLocation' | translate }}\" name=\"address\" [(ngModel)]=\"model.geofenceAttributeModel.address\" readonly />\r\n            <div class=\"input-group-btn\">\r\n              <button class=\"btn btn-default\" type=\"button\" (click)=\"GeofenceLocation()\">\r\n                <i class=\"fa fa-map-marker\" aria-hidden=\"true\"></i>\r\n              </button>\r\n              <button class=\"btn btn-default\" type=\"button\" (click)=\"ResetLocationField('geofence')\">\r\n                <i class=\"fa fa-eraser\" aria-hidden=\"true\"></i>\r\n              </button>\r\n            </div>\r\n          </div>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'GeofenceAttributeModel.Address' }}</span>\r\n        </div>\r\n\r\n        <div *ngIf=\"model.isGefenceEnabled\" class=\"form-group col-md-3\">\r\n          <label> {{ 'LblRadius' | translate }} ({{'LblMeter' | translate}})</label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblRadius' | translate }}\" [(ngModel)]=\"model.geofenceAttributeModel.radiusInMtr\" name=\"radiusInMtr\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'GeofenceAttributeModel.RadiusInMtr' }}</span>\r\n        </div>\r\n\r\n        <div class=\"clearfix\"></div>\r\n\r\n        <div *ngIf=\"model.isHomeLocationEnabled\" class=\"form-group col-md-6\">\r\n          <label><span class=\"text text-danger\">*</span> {{ 'LblHomeLocation' | translate }}</label>\r\n          <div class=\"input-group\">\r\n            <input readonly placeholder=\"{{ 'LblHomeLocation' | translate }}\" class=\"form-control\" type=\"text\" name=\"homeaddress\" [(ngModel)]=\"model.homeLocationModel.address\" />\r\n            <div class=\"input-group-btn\">\r\n              <button class=\"btn btn-default icon-map-marker\" type=\"button\" (click)=\"SearchHomeAddress()\">\r\n                <i class=\"fa fa-map-marker\" aria-hidden=\"true\"></i>\r\n              </button>\r\n              <button class=\"btn btn-default\" type=\"button\" (click)=\"ResetLocationField('home')\">\r\n                <i class=\"fa fa-eraser\" aria-hidden=\"true\"></i>\r\n              </button>\r\n            </div>\r\n          </div>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'HomeLocationModel.Address' }}</span>\r\n        </div>\r\n\r\n        <div *ngIf=\"model.isHomeLocationEnabled\" class=\"form-group col-md-3\">\r\n          <label><span class=\"text text-danger\">*</span> {{ 'LblRadius' | translate }} ({{ 'LblMeter' | translate }})</label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblRadius' | translate }}\" [(ngModel)]=\"model.homeLocationModel.radiusInMtr\" name=\"homeRadiusInMtr\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'HomeLocationModel.RadiusInMtr' }}</span>\r\n        </div>\r\n\r\n        <div class=\"row col-md-12 mar_t_20 mar_bot_20\">\r\n\r\n          <div class=\"clearfix\"></div>\r\n\r\n          <fieldset class=\"col-md-12\">\r\n            <legend class=\"legendStyle\"><span class=\"text text-danger\"></span> {{ 'LblFeatureFlags' | translate }}</legend>\r\n\r\n            <div class=\"row\">\r\n\r\n              <div class=\"form-group col-md-3\">\r\n                <label>{{ 'LblCreateBooking' | translate }}</label>\r\n                <div>\r\n                  <label class=\"radio-inline\">\r\n                    <input type=\"radio\" [(ngModel)]=\"model.createBookingDisabled\" [disabled]=\"this.model.trackAndTraceEnabled == true\" name=\"CreateBooking\" [value]=\"false\">\r\n                    {{ 'LblEnabled' | translate }}\r\n                  </label>\r\n                  <label class=\"radio-inline\">\r\n                    <input type=\"radio\" [(ngModel)]=\"model.createBookingDisabled\" [disabled]=\"this.model.trackAndTraceEnabled == true\" name=\"CreateBooking\" [value]=\"true\">\r\n                    {{ 'LblDisabled' | translate }}\r\n                  </label>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"form-group col-md-3\">\r\n                <label>{{ 'LblEditBooking' | translate }}</label>\r\n                <div>\r\n                  <label class=\"radio-inline\">\r\n                    <input type=\"radio\" [(ngModel)]=\"model.editBookingDisabled\" [disabled]=\"this.model.trackAndTraceEnabled == true\" name=\"EditBooking\" [value]=\"false\">\r\n                    {{ 'LblEnabled' | translate }}\r\n                  </label>\r\n                  <label class=\"radio-inline\">\r\n                    <input type=\"radio\" [(ngModel)]=\"model.editBookingDisabled\" [disabled]=\"this.model.trackAndTraceEnabled == true\" name=\"EditBooking\" [value]=\"true\">\r\n                    {{ 'LblDisabled' | translate }}\r\n                  </label>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"form-group col-md-3\">\r\n                <label>{{ 'LblTrackAndTrace' | translate }}</label>\r\n                <div>\r\n                  <label class=\"radio-inline\">\r\n                    <input type=\"radio\" [(ngModel)]=\"model.trackAndTraceEnabled\" name=\"TrackAndTrace\" [value]=\"true\" (change)=\"TrackAndTraceChange()\">\r\n                    {{ 'LblEnabled' | translate }}\r\n                  </label>\r\n                  <label class=\"radio-inline\">\r\n                    <input type=\"radio\" [(ngModel)]=\"model.trackAndTraceEnabled\" name=\"TrackAndTrace\" [value]=\"false\" (change)=\"TrackAndTraceChange()\">\r\n                    {{ 'LblDisabled' | translate }}\r\n                  </label>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"form-group col-md-3\" *ngIf=\"showIdCheckConfig\">\r\n                <label>{{ 'LblLicenseCheck' | translate }}</label>\r\n                <div >\r\n                  <label class=\"radio-inline\">\r\n                    <input type=\"radio\" [(ngModel)]=\"model.licenseCheckEnabled\" name=\"LicenseCheck\" [value]=\"true\" (change)=\"LicenseCheckChange();\">\r\n                    {{ 'LblEnabled' | translate }}\r\n                  </label>\r\n                  <label class=\"radio-inline\">\r\n                    <input type=\"radio\" [(ngModel)]=\"model.licenseCheckEnabled\" name=\"LicenseCheck\" [value]=\"false\" (change)=\"LicenseCheckChange();\">\r\n                    {{ 'LblDisabled' | translate }}\r\n                  </label>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"form-group col-md-3\" *ngIf=\"model.licenseCheckEnabled == true && showIdCheckConfig\">\r\n                <label>{{ 'LblBookingLicenseCheck' | translate }}</label>\r\n                <div>\r\n                  <label class=\"radio-inline\">\r\n                    <input type=\"radio\" [(ngModel)]=\"model.bookingLicenseCheckEnabled\" name=\"BookingLicenseCheck\" [value]=\"true\">\r\n                    {{ 'LblEnabled' | translate }}\r\n                  </label>\r\n                  <label class=\"radio-inline\">\r\n                    <input type=\"radio\" [(ngModel)]=\"model.bookingLicenseCheckEnabled\" name=\"BookingLicenseCheck\" [value]=\"false\">\r\n                    {{ 'LblDisabled' | translate }}\r\n                  </label>\r\n                </div>\r\n              </div>\r\n\r\n              <div class=\"form-group col-md-3\">\r\n                <label>{{ 'LblAccessCardsEnabled' | translate }}</label>\r\n                <div >\r\n                  <label class=\"radio-inline\">\r\n                    <input type=\"radio\" [(ngModel)]=\"model.isAccessCardsEnabled\" [disabled]=\"this.model.trackAndTraceEnabled == true\" name=\"accessCardsEnabled\" [value]=\"true\" (change)=\"AccessCardsEnabledChange();\">\r\n                    {{ 'LblEnabled' | translate }}\r\n                  </label>\r\n                  <label class=\"radio-inline\">\r\n                    <input type=\"radio\" [(ngModel)]=\"model.isAccessCardsEnabled\" [disabled]=\"this.model.trackAndTraceEnabled == true\" name=\"accessCardsEnabled\" [value]=\"false\" (change)=\"AccessCardsEnabledChange();\">\r\n                    {{ 'LblDisabled' | translate }}\r\n                  </label>\r\n                </div>\r\n              </div>\r\n\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n\r\n        <div class=\"row col-md-12 mar_bot_20\" *ngIf=\"TwoFaEnabled\">\r\n          <div class=\"clearfix\"></div>\r\n\r\n          <fieldset class=\"col-md-6\">\r\n            <legend class=\"legendStyle\"><span class=\"text text-danger\">*</span> {{ 'LblTwoFaConfig' | translate }}</legend>\r\n            <div class=\"form-group col-md-12\">\r\n              <label>{{ 'LblEnableTwoFa' | translate }}</label>\r\n              <div>\r\n                <label class=\"radio-inline\">\r\n                  <input type=\"radio\" [(ngModel)]=\"model.twoFAConfig.enabled\" name=\"EnableTwoFa\" value=\"YES\">\r\n                  {{ 'LblYes' | translate }}\r\n                </label>\r\n                <label class=\"radio-inline\">\r\n                  <input type=\"radio\" [(ngModel)]=\"model.twoFAConfig.enabled\" name=\"EnableTwoFa\" value=\"NO\">\r\n                  {{ 'LblNo' | translate }}\r\n                </label>\r\n                <label class=\"radio-inline\">\r\n                  <input type=\"radio\" [(ngModel)]=\"model.twoFAConfig.enabled\" name=\"EnableTwoFa\" value=\"INHERIT\">\r\n                  {{ 'LblInherit' | translate }}\r\n                </label>\r\n              </div>\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n\r\n        <div class=\"row col-md-12 mar_bot_20\">\r\n          <!--Odometer Configuration-->\r\n          <fieldset class=\"col-md-6\" *ngIf=\"model.odometerConfigurationModel && model.isOdometerConfiguration\">\r\n            <legend class=\"legendStyle\"><span class=\"text text-danger\">*</span> {{ 'LblodometerConfiguration' | translate }}</legend>\r\n            <div class=\"row\">\r\n\r\n              <div class=\"form-group col-md-6\">\r\n                <label>{{ 'LbLOdometerEnabled' | translate }}</label>\r\n                <div class=\"clearfix\"></div>\r\n                <label class=\"radio-inline\">\r\n                  <input type=\"radio\" [(ngModel)]=\"model.odometerConfigurationModel.enabled\" name=\"odometerConfigurationModelenabled\" value=\"YES\">\r\n                  {{ 'LblYes' | translate }}\r\n                </label>\r\n                <label class=\"radio-inline\">\r\n                  <input type=\"radio\" [(ngModel)]=\"model.odometerConfigurationModel.enabled\" name=\"odometerConfigurationModelenabled\" value=\"NO\">\r\n                  {{ 'LblNo' | translate }}\r\n                </label>\r\n                <label class=\"radio-inline\">\r\n                  <input type=\"radio\" [(ngModel)]=\"model.odometerConfigurationModel.enabled\" name=\"odometerConfigurationModelenabled\" value=\"INHERIT\">\r\n                  {{ 'LblInherit' | translate }}\r\n                </label>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'OdometerConfigurationModel.Enabled' }}</span>\r\n              </div>\r\n\r\n              <div *ngIf=\"model.odometerConfigurationModel.enabled=='YES'\" class=\"form-group col-md-6\">\r\n                <label>{{ 'LblEnableOnApp' | translate }}</label>\r\n                <div class=\"clearfix\"></div>\r\n                <label class=\"radio-inline\">\r\n                  <input type=\"radio\" [(ngModel)]=\"model.odometerConfigurationModel.enabledOnApp\" name=\"enabledOnApp\" [value]=\"true\">\r\n                  {{ 'LblYes' | translate }}\r\n                </label>\r\n                <label class=\"radio-inline\">\r\n                  <input type=\"radio\" [(ngModel)]=\"model.odometerConfigurationModel.enabledOnApp\" name=\"enabledOnApp\" [value]=\"false\">\r\n                  {{ 'LblNo' | translate }}\r\n                </label>\r\n\r\n                <div class=\"clearfix\"></div>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'OdometerConfigurationModel.EnabledOnApp' }}</span>\r\n              </div>\r\n            \r\n            </div>\r\n\r\n            <div *ngIf=\"model.odometerConfigurationModel.enabled=='YES' && model.odometerConfigurationModel.enabledOnApp\">\r\n              <div class=\"row\">\r\n\r\n                <div class=\"form-group col-md-4\">\r\n                  <label>{{'LblWarningPer' | translate}}</label>\r\n                  <div class=\"clearfix\"></div>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblWarningPer' | translate }}\" [(ngModel)]=\"model.odometerConfigurationModel.warningPercentage\" name=\"warningPercentage\">\r\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'OdometerConfigurationModel.WarningPercentage' }}</span>\r\n                </div>\r\n\r\n                <div class=\"form-group col-md-3\">\r\n                  <label>{{ 'LblFrequency' | translate }}</label>\r\n                  <div class=\"clearfix\"></div>\r\n                  <template [ngIf]=\"model.odometerConfigurationModel.timeInterval == 'PERBOOKING'\">\r\n                    <input disabled type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblFrequency' | translate }}\" name=\"frequency\" maxlength=\"15\">\r\n                  </template>\r\n\r\n                  <template [ngIf]=\"model.odometerConfigurationModel.timeInterval != 'PERBOOKING'\">\r\n                    <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblFrequency' | translate }}\" [(ngModel)]=\"model.odometerConfigurationModel.frequency\" name=\"frequency\" maxlength=\"15\">\r\n                    <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'OdometerConfigurationModel.Frequency' }}</span>\r\n                  </template>\r\n                </div>\r\n\r\n                <div class=\"form-group col-md-5\">\r\n                  <label>{{ 'LblTimeInterval' | translate }}</label>\r\n                  <div class=\"clearfix\"></div>\r\n                  <select [(ngModel)]=\"model.odometerConfigurationModel.timeInterval\" class=\"form-control\" name=\"odometerTimeInterval\" (change)=\"changeOfOdometerTimeInterval()\">\r\n                    <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblTimeInterval' | translate }} </option>\r\n                    <option value=\"DAY\">{{ 'LblDay' | translate }}</option>\r\n                    <option value=\"WEEK\">{{ 'LblWeek' | translate }}</option>\r\n                    <option value=\"MONTH\">{{ 'LblMonth' | translate }}</option>\r\n                    <option value=\"PERBOOKING\">{{ 'lblPerBooking' | translate }}</option>\r\n                  </select>\r\n                  <div class=\"clearfix\"></div>\r\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'OdometerConfigurationModel.TimeInterval' }}</span>\r\n                </div>\r\n\r\n              </div>\r\n            </div>\r\n          </fieldset>\r\n\r\n          <!-- Booking running notification start -->\r\n          <fieldset class=\"col-md-6 mar_bot_20\">\r\n            <legend class=\"legendStyle\"><span class=\"text text-danger\">*</span> {{ 'LblBookingrunningNotification' | translate }}</legend>\r\n            <div class=\"row\">\r\n\r\n              <div class=\"form-group col-md-12\">\r\n                <label>{{ 'LbLEnableBookingStillRunning' | translate }}</label>\r\n                <div class=\"clearfix\"></div>\r\n                <label class=\"radio-inline\">\r\n                  <input type=\"radio\" [(ngModel)]=\"model.bookingRunningNotification.enableNotification\" name=\"bookingRunningNotificationenableNotification\" [value]=\"true\">\r\n                  {{ 'LblYes' | translate }}\r\n                </label>\r\n                <label class=\"radio-inline\">\r\n                  <input type=\"radio\" [(ngModel)]=\"model.bookingRunningNotification.enableNotification\" name=\"bookingRunningNotificationenableNotification\" [value]=\"false\">\r\n                  {{ 'LblNo' | translate }}\r\n                </label>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'bookingRunningNotification.enableNotification' }}</span>\r\n              </div>\r\n\r\n              <div *ngIf=\"model.bookingRunningNotification.enableNotification\" class=\"form-group col-md-12\">\r\n                <div class=\"row\">\r\n\r\n                  <div class=\"form-group col-md-12\">\r\n                    <label>{{'LblMinutesAfterBookingEndTime' | translate}}</label>\r\n                    <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblNotifyAfterMinutes' | translate }}\" [(ngModel)]=\"model.bookingRunningNotification.notifyAfterMinutes\" name=\"notifyAfterMinutes\" maxlength=\"4\" style=\"width:50%\">\r\n                    <div class=\"clearfix\"></div>\r\n                    <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'bookingRunningNotification.notifyAfterMinutes' }}</span>\r\n                  </div>\r\n\r\n                  <div class=\"clearfix\"></div>\r\n\r\n                  <div class=\"form-group col-md-12\">\r\n                    <label>{{'LblResendNotoficationEvery' | translate}}</label>\r\n                    <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblNotificationInterval' | translate }}\" [(ngModel)]=\"model.bookingRunningNotification.notificationInterval\" name=\"notificationInterval\" maxlength=\"4\" style=\"width:50%\">\r\n                    <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'bookingRunningNotification.notificationInterval' }}</span>\r\n                  </div>\r\n\r\n                </div>\r\n              </div>\r\n\r\n            </div>\r\n          </fieldset>\r\n\r\n          <!-- Pre Post trip Question at instance level -->\r\n          <div *ngIf=\"isAuthorizedForPrePostTrip\" class=\"row col-md-12\">\r\n            <fieldset class=\"col-md-12\">\r\n              <legend class=\"legendStyle\">{{ 'LblPrePostTripQuestions' | translate }}</legend>\r\n              <wego-pre-post-trip-question #prePostTripQuestionSection [ErrorModel]=\"errorModel\" [CustomTripQuestionList]=\"model.customTripQuestionList\" (OnPrePostTripQuestionSetting)=\"OnPrePostTripQuestionSetting($event)\"></wego-pre-post-trip-question>\r\n            </fieldset>\r\n          </div>\r\n\r\n        </div>\r\n\r\n        <div class=\"row no-margin\">\r\n          <div class=\"col-sm-12\">\r\n            <hr>\r\n            <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnBackClick()\">{{ 'LblCancel' | translate }}</a>\r\n            &nbsp;&nbsp;\r\n            <button class=\"btn btn-green\" type=\"submit\">{{ 'LblSave' | translate }}</button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n<wego-geo-location-map #geoLocationModal (onConfirm)=\"onConfirm($event)\" [Language]=\"language\"></wego-geo-location-map>\r\n<wego-success-popup #TwoFasuccessPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmTwoFaPopup()\"></wego-success-popup>\r\n<!--<wego-geolocation-popup #geoLocationModal [markerInfo]=\"markerInfo\" (onConfirm)=\"GetGeoLocation($event)\"></wego-geolocation-popup>-->\r\n";

/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var contracttypegroup_service_1 = __webpack_require__(730);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var sharedvehiclegroupsubscription_model_1 = __webpack_require__(752);
	var sharedvehiclegroupsubscription_service_1 = __webpack_require__(753);
	var sharedvehiclegroup_service_1 = __webpack_require__(510);
	var config_1 = __webpack_require__(60);
	var common_1 = __webpack_require__(22);
	var SubscriptionUpdateComponent = (function () {
	    function SubscriptionUpdateComponent(subscriptionService, sharedVehicleGroupService, contractTypeGroupService, activeRoute, router, authService, translate, locationService) {
	        this.subscriptionService = subscriptionService;
	        this.sharedVehicleGroupService = sharedVehicleGroupService;
	        this.contractTypeGroupService = contractTypeGroupService;
	        this.activeRoute = activeRoute;
	        this.router = router;
	        this.authService = authService;
	        this.translate = translate;
	        this.locationService = locationService;
	    }
	    SubscriptionUpdateComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.module = this.translate.instant('LblSubscription');
	        //Invoice Moment day of week list
	        this.dayofWeekList = [
	            {
	                Key: this.translate.instant('LblSelectDayOfWeek'),
	                Value: ''
	            },
	            {
	                Key: this.translate.instant('LblSunday'),
	                Value: '0'
	            },
	            {
	                Key: this.translate.instant('LblMonday'),
	                Value: '1'
	            },
	            {
	                Key: this.translate.instant('LblTuesday'),
	                Value: '2'
	            },
	            {
	                Key: this.translate.instant('LblWednesday'),
	                Value: '3'
	            },
	            {
	                Key: this.translate.instant('LblThursday'),
	                Value: '4'
	            },
	            {
	                Key: this.translate.instant('LblFriday'),
	                Value: '5'
	            },
	            {
	                Key: this.translate.instant('LblSaturday'),
	                Value: '6'
	            }
	        ];
	        //Subsctiption Time Interval
	        this.timeIntervalList = [
	            {
	                Key: this.translate.instant('LblSelectSubscriptionInterval'),
	                Value: '',
	                Amount: 0
	            },
	            {
	                Key: this.translate.instant('LblWeeklySub'),
	                Value: 'WEEKLY',
	                Amount: 7
	            },
	            {
	                Key: this.translate.instant('LblMonthlySub'),
	                Value: 'MONTHLY',
	                Amount: 30
	            },
	            {
	                Key: this.translate.instant('LblYearlySub'),
	                Value: 'YEARLY',
	                Amount: 365
	            }
	        ];
	        this.InitiateIntervalList();
	        this.sharedvehicleGroup = this.translate.instant('LblListPage', this.translate.instant('LblSharedVehicleGroup'));
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlSubscriptionList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SUBSCRIPTION_LIST);
	        this.urlSVGList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SVG_LIST);
	        this.model = new sharedvehiclegroupsubscription_model_1.SubscriptionModel();
	        this.isEditMode = false;
	        this.sub = this.activeRoute.params.subscribe(function (params) {
	            _this.subscriptionHashId = params['subscriptionHashId'] || '';
	            _this.sharedVehicleGroupHashID = params['sharedVehicleGroupHashId'] || '';
	            _this.GetVatSettingDropdownList();
	            _this.model.sharedVehicleGroupHashId = _this.sharedVehicleGroupHashID;
	            if (_this.subscriptionHashId != '') {
	                _this.HandleEditMode();
	            }
	            else {
	                _this.GetCurrencyByGroup();
	                _this.GetContractTypeGroupList();
	            }
	        });
	        console.log(this.model);
	        this.breadCrumbTitle = this.isEditMode
	            ? this.translate.instant('LblEditPage', [this.module])
	            : this.translate.instant('LblAddPage', [this.module]);
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	    };
	    SubscriptionUpdateComponent.prototype.HandleEditMode = function () {
	        var _this = this;
	        this.isEditMode = true;
	        this.subscriptionService
	            .GetSubscriptionByHashId(this.subscriptionHashId)
	            .subscribe(function (res) {
	            _this.LoadIntervalList();
	            _this.model = res.data;
	            if (res.data.defaultContractTypeGroupHashId == null) {
	                _this.model.defaultContractTypeGroupHashId = '';
	                _this.model.freeItemCTGHashId = '';
	            }
	            _this.model.invoiceMomentDayOfWeek = res.data.invoiceMomentDayOfWeek;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        }, function () {
	            _this.GetContractTypeGroupList();
	        });
	    };
	    SubscriptionUpdateComponent.prototype.GetCurrencyByGroup = function () {
	        var _this = this;
	        this.contractTypeGroupService
	            .GetCurrencyByGroup(this.sharedVehicleGroupHashID)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.model.currencySymbol = res.data.currencySymbol;
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    SubscriptionUpdateComponent.prototype.OnContactTypeGroupChecked = function () {
	        var _this = this;
	        this.defaultContractypeGroupList = this.contractTypeGroupList.filter(function (x) { return x.isChecked; });
	        if (!this.defaultContractypeGroupList.some(function (item) {
	            return item.contractTypeGroupHashId ==
	                _this.model.defaultContractTypeGroupHashId;
	        })) {
	            this.model.defaultContractTypeGroupHashId = '';
	        }
	    };
	    SubscriptionUpdateComponent.prototype.OnSubmit = function (forms) {
	        var _this = this;
	        this.model.contractTypeGroupList = this.contractTypeGroupList
	            .filter(function (x) { return x.isChecked; })
	            .map(function (x) { return x.contractTypeGroupHashId; });
	        this.subscriptionService.AddNewSubscription(this.model).subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.isEditMode
	                    ? _this.translate.instant('LblRecordUpdatedSuccess', [_this.module])
	                    : _this.translate.instant('LblRecordAddedSuccess', [_this.module]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    SubscriptionUpdateComponent.prototype.GetContractTypeGroupList = function () {
	        var _this = this;
	        this.contractTypeGroupService
	            .GetContractTypeGroupBySharedVehicleGroup(this.sharedVehicleGroupHashID, this.DataListModel)
	            .subscribe(function (res) {
	            _this.contractTypeGroupList = res.data;
	            if (_this.isEditMode) {
	                _this.contractTypeGroupList
	                    .filter(function (x) {
	                    return _this.model.contractTypeGroupList.indexOf(x.contractTypeGroupHashId) > -1;
	                })
	                    .forEach(function (x) { return (x.isChecked = true); });
	            }
	            _this.defaultContractypeGroupList = _this.contractTypeGroupList.filter(function (x) { return x.isChecked; });
	            console.log('contractTypeGroupList');
	            console.log(_this.contractTypeGroupList);
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    SubscriptionUpdateComponent.prototype.GetVatSettingDropdownList = function () {
	        var _this = this;
	        this.contractTypeGroupService
	            .GetVatSettingDropdownList(this.sharedVehicleGroupHashID)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.vatSettingList = res.data;
	                if (!_this.isEditMode)
	                    _this.GetVatSettingDefaultValues();
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    SubscriptionUpdateComponent.prototype.GetVatSettingDefaultValues = function () {
	        var _this = this;
	        this.contractTypeGroupService
	            .GetVatSettingDefaultValues(this.sharedVehicleGroupHashID)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.vatSettingDefaultValues = res.data;
	                _this.model.vatPercentage = _this.vatSettingDefaultValues.defaultVatSubscriptionCost;
	                _this.model.vatSettingDefaultCost = _this.vatSettingDefaultValues.vatSettingDefaultCost;
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    SubscriptionUpdateComponent.prototype.SuccessModalClick = function () {
	        this.router.navigate([
	            this.urlSubscriptionList,
	            { sharedVehicleGroupHashId: this.sharedVehicleGroupHashID }
	        ]);
	    };
	    SubscriptionUpdateComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    SubscriptionUpdateComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    SubscriptionUpdateComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    SubscriptionUpdateComponent.prototype.OnBackClick = function () {
	        this.locationService.back();
	    };
	    SubscriptionUpdateComponent.prototype.SubscriptionOnChange = function () {
	        var _this = this;
	        if (this.model.timeInterval != '') {
	            this.LoadIntervalList();
	            var subscriptionInterval = this.timeIntervalList.find(function (time) { return time.Value === _this.model.timeInterval; });
	            this.paymentIntervalList = this.paymentIntervalList.filter(function (x) {
	                return _this.HandleValidationInterval(x.Amount, subscriptionInterval.Amount);
	            });
	            this.invoiceIntervalList = this.invoiceIntervalList.filter(function (x) {
	                return _this.HandleValidationInterval(x.Amount, subscriptionInterval.Amount);
	            });
	            this.freeKiloMetersIntervalList = this.freeKiloMetersIntervalList.filter(function (x) {
	                return _this.HandleValidationInterval(x.Amount, subscriptionInterval.Amount);
	            });
	            this.freeMinutIntervalList = this.freeMinutIntervalList.filter(function (x) {
	                return _this.HandleValidationInterval(x.Amount, subscriptionInterval.Amount);
	            });
	            // if (!this.invoiceIntervalList.some((item: any) => item.Value == this.model.invoiceInterval)) {
	            //   this.model.invoiceInterval = '';
	            // }
	            this.ResetInterval();
	        }
	        else {
	            this.InitiateIntervalList();
	            this.ResetInterval();
	        }
	    };
	    SubscriptionUpdateComponent.prototype.PaymentIntervalOnChange = function () {
	        var _this = this;
	        if (this.model.paymentInterval != '') {
	            this.LoadInvoiceInterval();
	            var subscriptionInterval = this.timeIntervalList.find(function (time) { return time.Value === _this.model.timeInterval; });
	            this.invoiceIntervalList = this.invoiceIntervalList.filter(function (x) {
	                return _this.HandleValidationInterval(x.Amount, subscriptionInterval.Amount);
	            });
	            this.paymentIntervalList = this.paymentIntervalList.filter(function (x) {
	                return _this.HandleValidationInterval(x.Amount, subscriptionInterval.Amount);
	            });
	            var paymentInterval = this.paymentIntervalList.find(function (time) { return time.Value === _this.model.paymentInterval; });
	            if (this.model.paymentInterval == 'PERBOOKING') {
	                this.invoiceIntervalList = this.invoiceIntervalList.filter(function (x) {
	                    return _this.HandleInvoiceInterval(x.Amount, paymentInterval.Amount);
	                });
	            }
	            else {
	                this.invoiceIntervalList = this.invoiceIntervalList.filter(function (x) {
	                    return _this.HandleInvoiceInterval(x.Amount, subscriptionInterval.Amount);
	                });
	            }
	            this.model.invoiceInterval = '';
	        }
	        else {
	            //Invoice Interval List
	            this.invoiceIntervalList = [
	                {
	                    Key: this.translate.instant('LblSelectInvoiceInterval'),
	                    Value: '',
	                    Amount: 0
	                }
	            ];
	            this.model.invoiceInterval = '';
	        }
	    };
	    SubscriptionUpdateComponent.prototype.HandleValidationInterval = function (intervalAmount, subscriptionIntervalAmount) {
	        return ((subscriptionIntervalAmount != 7 &&
	            (intervalAmount <= subscriptionIntervalAmount &&
	                intervalAmount != 7)) ||
	            (subscriptionIntervalAmount == 7 &&
	                (intervalAmount == 7 || intervalAmount == 0 || intervalAmount == 0.5)));
	    };
	    SubscriptionUpdateComponent.prototype.HandleInvoiceInterval = function (intervalAmount, paymentIntervalAmount) {
	        return ((paymentIntervalAmount != 0.5 &&
	            (intervalAmount <= paymentIntervalAmount && intervalAmount != 0.5)) ||
	            (paymentIntervalAmount == 0.5 &&
	                (intervalAmount == 0.5 || intervalAmount == 0)));
	    };
	    //Initiate interval lists with default elements
	    SubscriptionUpdateComponent.prototype.InitiateIntervalList = function () {
	        //Payment Interval List
	        this.paymentIntervalList = [
	            {
	                Key: this.translate.instant('LblSelectPaymentInterval'),
	                Value: '',
	                Amount: 0
	            }
	        ];
	        //Invoice Interval List
	        this.invoiceIntervalList = [
	            {
	                Key: this.translate.instant('LblSelectInvoiceInterval'),
	                Value: '',
	                Amount: 0
	            }
	        ];
	        //Free KM Interval List
	        this.freeKiloMetersIntervalList = [
	            {
	                Key: this.translate.instant('LblSelectFreeKMInterval'),
	                Value: '',
	                Amount: 0
	            }
	        ];
	        //Free Min Interval List
	        this.freeMinutIntervalList = [
	            {
	                Key: this.translate.instant('LblSelectFreeMinInterval'),
	                Value: '',
	                Amount: 0
	            }
	        ];
	    };
	    //Load interval list with all elemnets
	    SubscriptionUpdateComponent.prototype.LoadIntervalList = function () {
	        //Payment Interval
	        this.paymentIntervalList = [
	            {
	                Key: this.translate.instant('LblSelectPaymentInterval'),
	                Value: '',
	                Amount: 0
	            },
	            {
	                Key: this.translate.instant('LblPerBooking'),
	                Value: 'PERBOOKING',
	                Amount: 0.5
	            },
	            {
	                Key: this.translate.instant('LblWeeklySub'),
	                Value: 'WEEKLY',
	                Amount: 7
	            },
	            {
	                Key: this.translate.instant('LblMonthlySub'),
	                Value: 'MONTHLY',
	                Amount: 30
	            },
	            {
	                Key: this.translate.instant('LblYearlySub'),
	                Value: 'YEARLY',
	                Amount: 365
	            }
	        ];
	        //Invoice Interval List
	        this.invoiceIntervalList = [
	            {
	                Key: this.translate.instant('LblSelectInvoiceInterval'),
	                Value: '',
	                Amount: 0
	            },
	            {
	                Key: this.translate.instant('LblPerBooking'),
	                Value: 'PERBOOKING',
	                Amount: 0.5
	            },
	            {
	                Key: this.translate.instant('LblWeeklySub'),
	                Value: 'WEEKLY',
	                Amount: 7
	            },
	            {
	                Key: this.translate.instant('LblMonthlySub'),
	                Value: 'MONTHLY',
	                Amount: 30
	            },
	            {
	                Key: this.translate.instant('LblYearlySub'),
	                Value: 'YEARLY',
	                Amount: 365
	            }
	        ];
	        //Free KM Interval List
	        this.freeKiloMetersIntervalList = [
	            {
	                Key: this.translate.instant('LblSelectFreeKMInterval'),
	                Value: '',
	                Amount: 0
	            },
	            {
	                Key: 'PER DAY',
	                Value: 'DAILY',
	                Amount: 1
	            },
	            {
	                Key: this.translate.instant('LblFreePerWeek'),
	                Value: 'WEEKLY',
	                Amount: 7
	            },
	            {
	                Key: this.translate.instant('LblFreePerMonth'),
	                Value: 'MONTHLY',
	                Amount: 30
	            },
	            {
	                Key: this.translate.instant('LblFreePerTriMonth'),
	                Value: 'TRIMONTHLY',
	                Amount: 91
	            },
	            {
	                Key: this.translate.instant('LblFreePerBiannual'),
	                Value: 'BIANNUALLY',
	                Amount: 182
	            },
	            {
	                Key: this.translate.instant('LblFreePerYear'),
	                Value: 'YEARLY',
	                Amount: 365
	            },
	            {
	                Key: this.translate.instant('LblFreePerBookingInterval'),
	                Value: 'BOOKING_INTERVAL',
	                Amount: 0.5
	            }
	        ];
	        //Free Min Interval List
	        this.freeMinutIntervalList = [
	            {
	                Key: this.translate.instant('LblSelectFreeMinInterval'),
	                Value: '',
	                Amount: 0
	            },
	            {
	                Key: 'PER DAY',
	                Value: 'DAILY',
	                Amount: 1
	            },
	            {
	                Key: this.translate.instant('LblFreePerWeek'),
	                Value: 'WEEKLY',
	                Amount: 7
	            },
	            {
	                Key: this.translate.instant('LblFreePerMonth'),
	                Value: 'MONTHLY',
	                Amount: 30
	            },
	            {
	                Key: this.translate.instant('LblFreePerTriMonth'),
	                Value: 'TRIMONTHLY',
	                Amount: 91
	            },
	            {
	                Key: this.translate.instant('LblFreePerBiannual'),
	                Value: 'BIANNUALLY',
	                Amount: 182
	            },
	            {
	                Key: this.translate.instant('LblFreePerYear'),
	                Value: 'YEARLY',
	                Amount: 365
	            },
	            {
	                Key: this.translate.instant('LblFreePerBookingInterval'),
	                Value: 'BOOKING_INTERVAL',
	                Amount: 0.5
	            }
	        ];
	    };
	    //Reset Intervals
	    SubscriptionUpdateComponent.prototype.ResetInterval = function () {
	        this.model.invoiceInterval = '';
	        this.model.paymentInterval = '';
	        this.model.freeKilometerInterval = '';
	        this.model.freeMinuteInterval = '';
	    };
	    SubscriptionUpdateComponent.prototype.LoadInvoiceInterval = function () {
	        this.invoiceIntervalList = [
	            {
	                Key: this.translate.instant('LblSelectInvoiceInterval'),
	                Value: '',
	                Amount: 0
	            },
	            {
	                Key: this.translate.instant('LblPerBooking'),
	                Value: 'PERBOOKING',
	                Amount: 0.5
	            },
	            {
	                Key: this.translate.instant('LblWeeklySub'),
	                Value: 'WEEKLY',
	                Amount: 7
	            },
	            {
	                Key: this.translate.instant('LblMonthlySub'),
	                Value: 'MONTHLY',
	                Amount: 30
	            },
	            {
	                Key: this.translate.instant('LblYearlySub'),
	                Value: 'YEARLY',
	                Amount: 365
	            }
	        ];
	    };
	    SubscriptionUpdateComponent.prototype.InitializePymentInterval = function () {
	        this.paymentIntervalList = [
	            {
	                Key: this.translate.instant('LblSelectPaymentInterval'),
	                Value: '',
	                Amount: 0
	            }
	        ];
	        //Invoice Interval List
	        this.invoiceIntervalList = [
	            {
	                Key: this.translate.instant('LblSelectInvoiceInterval'),
	                Value: '',
	                Amount: 0
	            }
	        ];
	    };
	    SubscriptionUpdateComponent.prototype.SetVatDefaultCost = function (vatSettingDefaultCost) {
	        return vatSettingDefaultCost
	            ? this.translate.instant('LblExcludingVat')
	            : this.translate.instant('LblIncludingVat');
	    };
	    // TODO: Remove this when we're done
	    // get diagnostic() { return JSON.stringify(this.model); }
	    SubscriptionUpdateComponent.prototype.ngOnDestroy = function () {
	        if (this.sub) {
	            this.sub.unsubscribe();
	        }
	    };
	    __decorate([
	        core_1.ViewChild('sucessModal'), 
	        __metadata('design:type', Object)
	    ], SubscriptionUpdateComponent.prototype, "sucessModal", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], SubscriptionUpdateComponent.prototype, "successPopup", void 0);
	    SubscriptionUpdateComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-subscription-update',
	            template: __webpack_require__(754),
	            providers: [
	                sharedvehiclegroupsubscription_service_1.SubscriptionService,
	                sharedvehiclegroup_service_1.SharedVehicleGroupService,
	                contracttypegroup_service_1.ContractTypeGroupService
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof sharedvehiclegroupsubscription_service_1.SubscriptionService !== 'undefined' && sharedvehiclegroupsubscription_service_1.SubscriptionService) === 'function' && _a) || Object, (typeof (_b = typeof sharedvehiclegroup_service_1.SharedVehicleGroupService !== 'undefined' && sharedvehiclegroup_service_1.SharedVehicleGroupService) === 'function' && _b) || Object, (typeof (_c = typeof contracttypegroup_service_1.ContractTypeGroupService !== 'undefined' && contracttypegroup_service_1.ContractTypeGroupService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object, (typeof (_e = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _e) || Object, (typeof (_f = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _f) || Object, (typeof (_g = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _g) || Object, (typeof (_h = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _h) || Object])
	    ], SubscriptionUpdateComponent);
	    return SubscriptionUpdateComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h;
	}());
	exports.SubscriptionUpdateComponent = SubscriptionUpdateComponent;


/***/ },
/* 752 */
/***/ function(module, exports) {

	"use strict";
	var SubscriptionModel = (function () {
	    function SubscriptionModel() {
	        this.timeInterval = '';
	        this.freeMinute = '0';
	        this.sharedVehicleGroupHashId = '';
	        this.contractTypeGroupList = [];
	        this.vatSettingDefaultCost = true;
	        this.vatIncludedInPrice = true;
	        this.paymentInterval = '';
	        this.invoiceInterval = '';
	        this.freeKilometerInterval = 'MONTHLY';
	        this.freeMinuteInterval = 'MONTHLY';
	        this.invoiceMomentDayOfWeek = '';
	        this.defaultContractTypeGroupHashId = '';
	        this.sendInvoiceToDriver = "INHERIT";
	        this.sendInvoiceToOrganization = "INHERIT";
	        this.bookAheadTime = "0";
	        this.bookingHorizon = "";
	        this.bearer = 1;
	        this.freeItemCTGHashId = "";
	        this.isCurrencySymbolBefore = true;
	    }
	    return SubscriptionModel;
	}());
	exports.SubscriptionModel = SubscriptionModel;


/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var SubscriptionService = (function () {
	    function SubscriptionService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    SubscriptionService.prototype.GetSubscriptionList = function (sharedVehicleGroupHashId, input) {
	        var getsubscriptionUrl = config_1.WeGoConfig.API_GET_SUBSCRIPTION_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getsubscriptionUrl = getsubscriptionUrl + "?" + queryString + "&sharedVehicleGroupHashId=" + sharedVehicleGroupHashId;
	        }
	        else {
	            getsubscriptionUrl = getsubscriptionUrl + "?sharedVehicleGroupHashId=" + sharedVehicleGroupHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getsubscriptionUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SubscriptionService.prototype.ExportSubscriptionList = function (sharedVehicleGroupHashId, input) {
	        input.currentPage = 0;
	        var getsubscriptionUrl = config_1.WeGoConfig.API_EXPORT_SUBSCRIPTION_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getsubscriptionUrl = getsubscriptionUrl + "?" + queryString + "&sharedVehicleGroupHashId=" + sharedVehicleGroupHashId;
	        }
	        else {
	            getsubscriptionUrl = getsubscriptionUrl + "?sharedVehicleGroupHashId=" + sharedVehicleGroupHashId;
	        }
	        var headers = this.authService.GetHeader('text/csv');
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getsubscriptionUrl, options);
	    };
	    SubscriptionService.prototype.AddNewSubscription = function (subscriptionModel) {
	        subscriptionModel.freeKilometerInterval = 'MONTHLY';
	        subscriptionModel.freeMinuteInterval = 'MONTHLY';
	        var body = subscriptionModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_POST_SUBSCRIPTION_DETAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SubscriptionService.prototype.GetSubscriptionByHashId = function (subscriptionHashId) {
	        var getsubscriptionUrl = config_1.WeGoConfig.API_GET_SUBSCRIPTION_BY_HASH + "?subscriptionHashId=" + subscriptionHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getsubscriptionUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SubscriptionService.prototype.GetSubscriptionBasicDetail = function (subscriptionHashId) {
	        var getsubscriptionBasicDetailUrl = config_1.WeGoConfig.API_GET_SUBSCRIPTION_BASIC_DETAIL +
	            "?subscriptionHashId=" +
	            subscriptionHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getsubscriptionBasicDetailUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SubscriptionService.prototype.DeleteSubsription = function (subscriptionHashId) {
	        var getInstanceUrl = config_1.WeGoConfig.API_POST_DELETE_SUBSCRIPTION + "?subscriptionHashId=" + subscriptionHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getInstanceUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SubscriptionService.prototype.GetSubscriptionAvailability = function (sharedVehicleGroupSubscriptionHashId, input) {
	        var getsubscriptionUrl = config_1.WeGoConfig.API_GET_SUBSCRIPTION_AVAILABILITY;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getsubscriptionUrl = getsubscriptionUrl + "?" + queryString + "&sharedVehicleGroupSubscriptionHashId=" + sharedVehicleGroupSubscriptionHashId;
	        }
	        else {
	            getsubscriptionUrl = getsubscriptionUrl + "?sharedVehicleGroupSubscriptionHashId=" + sharedVehicleGroupSubscriptionHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getsubscriptionUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SubscriptionService.prototype.AddSubscriptionAvailability = function (subscriptionAvailabilityModel) {
	        var body = subscriptionAvailabilityModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_POST_SUBSCRIPTION_AVAILABILITY, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SubscriptionService.prototype.DeleteAvailabilityRestriction = function (selectedIds) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_DELETE_SUBSCRIPTION_AVAILABILITY, selectedIds, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SubscriptionService.prototype.GetSubscriptionAvailabilityRestrictionByHashId = function (availabilityRestriction) {
	        var getsubscriptionUrl = config_1.WeGoConfig.API_GET_SUBSCRIPTION_AVAILABILITY_BY_HASH + "?availabilityRestrictionHashId=" + availabilityRestriction;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getsubscriptionUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SubscriptionService.prototype.ExportAvailabilityRestrriction = function (sharedVehicleGroupSubscriptionHashId, input) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var getCompanyAdminUrl = config_1.WeGoConfig.API_EXPORT_SUBSCRIPTION_AVAILABILITY_LIST + "?" + queryString + "&sharedVehicleGroupSubscriptionHashId=" + sharedVehicleGroupSubscriptionHashId;
	        var headers = this.authService.GetHeader('text/csv');
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getCompanyAdminUrl, options);
	    };
	    SubscriptionService.prototype.GetSubscriptionDropdownList = function (permissionType, organizationHashId, sharedVehicleGroupHashId) {
	        var getSVGListUrl = config_1.WeGoConfig.API_GET_DROPDOWN_SUBSCRIPTION_LIST_TEMPLATE;
	        if (permissionType) {
	            getSVGListUrl = getSVGListUrl + '?permissionType=' + permissionType;
	        }
	        if (organizationHashId && sharedVehicleGroupHashId) {
	            getSVGListUrl = getSVGListUrl + "&organizationHashId=" + organizationHashId + "&sharedVehicleGroupHashId= " + sharedVehicleGroupHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getSVGListUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SubscriptionService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], SubscriptionService);
	    return SubscriptionService;
	    var _a, _b;
	}());
	exports.SubscriptionService = SubscriptionService;


/***/ },
/* 754 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{breadCrumbTitle}}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"urlSVGList\">\r\n            <i class=\"fa fa-group fa-fw\"></i> {{ sharedvehicleGroup }}</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"urlSubscriptionList + '/' + sharedVehicleGroupHashID\">\r\n            <i class=\"fa fa-envelope fa-fw\"></i>{{ breadCrumbList }}</a>\r\n        </li>\r\n\r\n\r\n        <li class=\"active\">{{breadCrumbTitle}}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25 \">\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <!--<pre>\r\n\t\t{{ model | json }}\r\n\t  </pre>-->\r\n    <div class=\"nopad\">\r\n      <form (ngSubmit)=\"OnSubmit(AddSubscriptionForm.value)\" #AddSubscriptionForm=\"ngForm\">\r\n        <input type=\"hidden\" class=\"form-control\" [(ngModel)]=\"model.subscriptionHashId\" name=\"subscriptionHashId\">\r\n\r\n        <div class=\"form-group col-md-3\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblSubscriptionName' | translate }}\r\n          </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblSubscriptionName' | translate }}\" [(ngModel)]=\"model.name\" name=\"SubscriptionName\"\r\n            maxlength=\"30\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'Name' }}</span>\r\n        </div>\r\n        <div class=\"form-group col-md-3\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblBearer' | translate }}</label>\r\n          <div class=\"clearfix\"></div>\r\n          <label class=\"radio-inline\">\r\n            <input type=\"radio\" [(ngModel)]=\"model.bearer\" name=\"bearer\" [value]=\"1\">{{ 'LblDriver' | translate }}</label>\r\n          <label class=\"radio-inline\">\r\n            <input type=\"radio\" [(ngModel)]=\"model.bearer\" name=\"bearer\" [value]=\"2\">{{ 'LblOrganization' | translate }}</label>\r\n          <div class=\"clearfix\"></div>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'bearer' }}</span>\r\n        </div>\r\n        <div class=\"form-group col-md-3\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblAmount' | translate }}({{ SetVatDefaultCost(model.vatSettingDefaultCost) }})\r\n          </label>\r\n          <div class=\"input-group\">\r\n            <span *ngIf=\"model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n            <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblAmount' | translate }}\" [(ngModel)]=\"model.amount\" name=\"Amount\"\r\n              maxlength=\"7\">\r\n              <span *ngIf=\"!model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n          </div>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'Amount' }}</span>\r\n        </div>\r\n        <div class=\"form-group col-md-3\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblVatPercentage' | translate }} \r\n          </label>\r\n          <div>\r\n            <select [(ngModel)]=\"model.vatPercentage\" name=\"vatPercentage\" class=\"form-control\">\r\n              <option *ngFor=\"let item of vatSettingList\" [value]='item.value'>{{item.data}}</option>\r\n            </select>\r\n          </div>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'vatPercentage' }}</span>\r\n        </div>\r\n        <!-- <div class=\"clearfix\"></div>\r\n        <div class=\"form-group col-md-3\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblVatIncludedInPrice' | translate }}</label>\r\n          <div class=\"clearfix\"></div>\r\n          <label class=\"radio-inline\">\r\n            <input type=\"radio\" [(ngModel)]=\"model.vatIncludedInPrice\" name=\"VatIncludedInPrice\" [value]=\"true\">{{ 'LblYes' | translate }}</label>\r\n          <label class=\"radio-inline\">\r\n            <input type=\"radio\" [(ngModel)]=\"model.vatIncludedInPrice\" name=\"VatIncludedInPrice\" [value]=\"false\">{{ 'LblNo' | translate }}</label>\r\n        </div> -->\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"form-group col-md-3\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{'LblSubscriptionInterval' | translate}}</label>\r\n          <select [(ngModel)]=\"model.timeInterval\" class=\"form-control\" name=\"timeInterval\" (change)=\"SubscriptionOnChange()\" [disabled]=\"isEditMode\">\r\n            <option *ngFor=\"let item of timeIntervalList\" [ngValue]=\"item.Value\">{{ item.Key }}</option>\r\n          </select>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'timeInterval' }}</span>\r\n        </div>\r\n        <div class=\"form-group col-md-3\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{'LblPaymentInterval' | translate}}</label>\r\n          <select [(ngModel)]=\"model.paymentInterval\" class=\"form-control\" name=\"paymentInterval\" (change)=\"PaymentIntervalOnChange()\"\r\n            [disabled]=\"isEditMode\">\r\n            <option *ngFor=\"let item of paymentIntervalList\" [ngValue]=\"item.Value\">{{ item.Key }}</option>\r\n          </select>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'paymentInterval' }}</span>\r\n        </div>\r\n        <div class=\"form-group col-md-3\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{'LblInvoicInterval' | translate}}</label>\r\n          <select [(ngModel)]=\"model.invoiceInterval\" class=\"form-control\" name=\"invoiceInterval\" [disabled]=\"isEditMode\">\r\n            <option *ngFor=\"let item of invoiceIntervalList\" [ngValue]=\"item.Value\">{{ item.Key }}</option>\r\n          </select>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'invoiceInterval' }}</span>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"form-group col-md-3\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblSendInvoiceToDriver' | translate }}</label>\r\n          <div class=\"clearfix\"></div>\r\n          <label class=\"radio-inline\">\r\n            <input type=\"radio\" [(ngModel)]=\"model.sendInvoiceToDriver\" name=\"sendInvoiceToDriver\" value=\"YES\">{{ 'LblYes' | translate }}</label>\r\n          <label class=\"radio-inline\">\r\n            <input type=\"radio\" [(ngModel)]=\"model.sendInvoiceToDriver\" name=\"sendInvoiceToDriver\" value=\"NO\">{{ 'LblNo' | translate }}</label>\r\n          <label class=\"radio-inline\">\r\n            <input type=\"radio\" [(ngModel)]=\"model.sendInvoiceToDriver\" name=\"sendInvoiceToDriver\" value=\"INHERIT\">{{ 'LblInherit' | translate }}</label>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'SendInvoiceToDriver' }}</span>\r\n        </div>\r\n        <div class=\"form-group col-md-3\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblSendInvoiceToOrganization' | translate }}</label>\r\n          <div class=\"clearfix\"></div>\r\n          <label class=\"radio-inline\">\r\n            <input type=\"radio\" [(ngModel)]=\"model.sendInvoiceToOrganization\" name=\"sendInvoiceToOrganization\" value=\"YES\">{{ 'LblYes' | translate }}</label>\r\n          <label class=\"radio-inline\">\r\n            <input type=\"radio\" [(ngModel)]=\"model.sendInvoiceToOrganization\" name=\"sendInvoiceToOrganization\" value=\"NO\">{{ 'LblNo' | translate }}</label>\r\n          <label class=\"radio-inline\">\r\n            <input type=\"radio\" [(ngModel)]=\"model.sendInvoiceToOrganization\" name=\"sendInvoiceToOrganization\" value=\"INHERIT\">{{ 'LblInherit' | translate }}</label>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'SendInvoiceToOrganization' }}</span>\r\n        </div>\r\n\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"form-group col-md-3\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblFreeKilometer' | translate }}\r\n          </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblFreeKilometer' | translate }}\" [(ngModel)]=\"model.freeKilometer\"\r\n            name=\"FreeKilometer\" maxlength=\"6\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'FreeKilometer' }}</span>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"form-group col-md-3\">\r\n          <label>{{'LblDescription' | translate }}</label>\r\n          <textarea class=\"form-control\" placeholder=\"{{'LblDescription' | translate }}\" [(ngModel)]=\"model.description\" name=\"model.description\"\r\n            maxlength=\"100\"></textarea>\r\n        </div>\r\n        <div class=\"form-group col-md-3\">\r\n          <label>{{ 'LblBookAheadTime' | translate }}</label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblBookAheadTime' | translate }}\" [(ngModel)]=\"model.bookAheadTime\"\r\n            name=\"bookAheadTime\" maxlength=\"4\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'bookAheadTime' }}</span>\r\n        </div>\r\n        <div class=\"form-group col-md-3\">\r\n          <label>{{ 'LblBookingHorizon' | translate }} ({{ 'LblDay' | translate }})</label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblBookingHorizon' | translate }}\" [(ngModel)]=\"model.bookingHorizon\"\r\n            name=\"bookingHorizon\" maxlength=\"4\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'bookingHorizon' }}</span>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"form-group col-md-3\" *ngIf=\"isEditMode\">\r\n          <label>{{'LblInvoiceMomentDay' | translate}}</label>\r\n          <select [(ngModel)]=\"model.invoiceMomentDayOfWeek\" class=\"form-control\" name=\"invoiceMomentDayOfWeek\" [disabled]=\"isEditMode\">\r\n            <option *ngFor=\"let item of dayofWeekList\" [ngValue]=\"item.Value\">{{ item.Key }}</option>\r\n          </select>\r\n        </div>\r\n        <div class=\"form-group col-md-3\" *ngIf=\"isEditMode\">\r\n          <label>{{ 'LblInvoiceMomentMonth' | translate }}</label>\r\n          <input type=\"text\" readonly class=\"form-control\" placeholder=\"{{ 'LblInvoiceMomentMonth' | translate }}\" [(ngModel)]=\"model.invoiceMomentMonth\"\r\n            name=\"InvoiceMomentMonth\" maxlength=\"30\">\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"row col-md-12\">\r\n          <fieldset class=\"col-md-12\">\r\n            <legend class=\"legendStyle\">\r\n              <span class=\"text text-danger\">*</span>{{ 'LblContractTypeGroup' | translate }}</legend>\r\n            <div class=\"form-group col-md-8 row nopad\">\r\n              <div class=\"checkbox-inline\" *ngFor=\"let contractTypeGroup of contractTypeGroupList; let i = index\">\r\n                <label class=\"checkbox-inline\">\r\n                  <input type=\"checkbox\" [checked]=\"contractTypeGroup.isChecked\" (change)=\"contractTypeGroup.isChecked = $event.target.checked; OnContactTypeGroupChecked();\">{{ contractTypeGroupList[i].contractTypGroupName }}</label>\r\n              </div>\r\n              <div class=\"clearfix\"></div>\r\n              <span class=\"text text-danger\" style=\"padding-left: 20px;\">{{ errorModel | serverErrorMessage : 'contracttypeGroupList' }}</span>\r\n            </div>\r\n            <div class=\"form-group col-md-4\">\r\n              <label>{{'LblDefaultContractTypeGroup' | translate}}</label>\r\n              <select [(ngModel)]=\"model.defaultContractTypeGroupHashId\" class=\"form-control\" name=\"defaultContractTypeGroup\">\r\n                <option value=\"\" [selected]=\"selected\">{{ 'LblSelectDefaultContractTypeGroup' | translate }} </option>\r\n                <option *ngFor=\"let item of defaultContractypeGroupList\" [ngValue]=\"item.contractTypeGroupHashId\">{{ item.contractTypGroupName }}</option>\r\n              </select>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'DefaultContractTypeGroupHashId' }}</span>\r\n            </div>\r\n\r\n            <div class=\"form-group col-md-8 row nopad\">\r\n              <label>{{'LblWhoBenifitFreeItem' | translate}}</label>\r\n              <div class=\"clearfix\"></div>\r\n              <label class=\"checkbox-inline\">\r\n                <input type=\"radio\" name=\"freeItemCTGHashId\" [(ngModel)]=\"model.freeItemCTGHashId\" value=\"\">{{ 'LblNoDistinction' | translate }}</label>\r\n              <div class=\"radio-inline\" *ngFor=\"let item of defaultContractypeGroupList\">\r\n                <label class=\"radio-inline\">\r\n                  <input type=\"radio\" name=\"freeItemCTGHashId\" [(ngModel)]=\"model.freeItemCTGHashId\" [value]=\"item.contractTypeGroupHashId\">{{item.contractTypGroupName }}</label>\r\n              </div>\r\n              <div class=\"clearfix\"></div>\r\n              <span class=\"text text-danger\" style=\"padding-left: 20px;\">{{ errorModel | serverErrorMessage : 'FreeItemCTGHashId' }}</span>\r\n            </div>\r\n\r\n          </fieldset>\r\n        </div>\r\n        <div class=\"row no-margin\">\r\n          <div class=\"col-sm-12\">\r\n            <hr>\r\n            <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnBackClick()\">{{ 'LblCancel' | translate }}</a> &nbsp;&nbsp;\r\n            <button class=\"btn btn-green\" type=\"submit\">{{ 'LblSave' | translate }}</button>\r\n          </div>\r\n        </div>\r\n\r\n      </form>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>";

/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var translate_service_1 = __webpack_require__(70);
	var contracttypegroup_service_1 = __webpack_require__(730);
	var core_1 = __webpack_require__(3);
	var sharedvehiclegroupsubscription_service_1 = __webpack_require__(753);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var sharedvehiclegroup_service_1 = __webpack_require__(510);
	var SubscriptionListComponent = (function () {
	    function SubscriptionListComponent(subscriptionService, translate, contractTypeGroupService, authService, activeRoute, sharedvehiclegroupService, router) {
	        this.subscriptionService = subscriptionService;
	        this.translate = translate;
	        this.contractTypeGroupService = contractTypeGroupService;
	        this.authService = authService;
	        this.activeRoute = activeRoute;
	        this.sharedvehiclegroupService = sharedvehiclegroupService;
	        this.router = router;
	        this.sharedVehicleGroupHashId = "";
	        this.roleLevel = config_1.RoleLevel;
	    }
	    SubscriptionListComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.module = this.translate.instant('LblSubscription', [this.module]);
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	        this.sharedvehicleGroup = this.translate.instant('LblListPage', this.translate.instant('LblSharedVehicleGroup'));
	        this.module = this.translate.instant('LblSubscription', [this.module]);
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	        this.sharedvehicleGroup = this.translate.instant('LblListPage', this.translate.instant('LblSharedVehicleGroup'));
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = ["name", "timeInterval", "description"];
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlSVGList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SVG_LIST);
	        this.urlSubscriptionUpdate = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SUBSCRIPTION_UPDATE);
	        this.urlSubscriptionAdd = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SUBSCRIPTION_ADD);
	        this.urlSubscriptionAvailability = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SUBSCRIPTIONAVAILABILITY_LIST);
	        //this.GetSubscriptionList();
	        this.activeRoute
	            .params
	            .subscribe(function (params) {
	            var sharedVehicleGroupHashId = params['id'] || '';
	            if (sharedVehicleGroupHashId != '') {
	                _this.sharedVehicleGroupHashId = sharedVehicleGroupHashId;
	                _this.GetSharedVehicleGroupDetailsByHashId();
	                _this.GetSubscriptionList();
	                _this.addSVGSubscriptionLink = new config_1.WeGoAuthorizedLink("", config_1.Permission.PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW, config_1.PermissionType.INSERT, 'btn btn-highlight navbar-right', 'LblAddNew', config_1.Entity.SVG, _this.sharedVehicleGroupHashId);
	            }
	        });
	    };
	    SubscriptionListComponent.prototype.AddNewSubscription = function (sharedVehicleGroupHashId) {
	        console.log(sharedVehicleGroupHashId);
	        this.sharedVehicleGroupHashId = sharedVehicleGroupHashId;
	        this.GetContractTypeGroupList();
	    };
	    SubscriptionListComponent.prototype.GetContractTypeGroupList = function () {
	        var _this = this;
	        this.contractTypeGroupService.GetContractTypeGroupBySharedVehicleGroup(this.sharedVehicleGroupHashId, this.DataListModel)
	            .subscribe(function (res) {
	            _this.apiResponse = res;
	            _this.contractTypeGroupList = res.data;
	            if (res.data.length > 0) {
	                _this.router.navigate([_this.urlSubscriptionAdd, { 'sharedVehicleGroupHashId': _this.sharedVehicleGroupHashId }]);
	            }
	            else {
	                _this.ShowAlertModal();
	            }
	            console.log('contractTypeGroupList');
	            console.log(_this.contractTypeGroupList);
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SubscriptionListComponent.prototype.GetSubscriptionList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.subscriptionService.GetSubscriptionList(this.sharedVehicleGroupHashId, this.DataListModel)
	            .subscribe(function (res) {
	            _this.subscriptionList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SubscriptionListComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetSubscriptionList();
	    };
	    SubscriptionListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetSubscriptionList();
	    };
	    SubscriptionListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetSubscriptionList();
	    };
	    SubscriptionListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetSubscriptionList();
	    };
	    ;
	    SubscriptionListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.subscriptionService.ExportSubscriptionList(this.sharedVehicleGroupHashId, this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "Subscription" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	        ;
	    };
	    SubscriptionListComponent.prototype.GetSharedVehicleGroupDetailsByHashId = function () {
	        var _this = this;
	        this.sharedvehiclegroupService.GetSharedVehicleGroupBasicDetail(this.sharedVehicleGroupHashId)
	            .subscribe(function (res) {
	            if (res.data)
	                _this.groupName = res.data.entityName;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SubscriptionListComponent.prototype.ShowAlertModal = function () {
	        this.isLoading = false;
	        this.alertMsg = this.translate.instant('LblContractTypeGroupAvailableForSubscription', [this.module]);
	        this.popupTitle = this.translate.instant('LblWarning');
	        this.alertModal.show();
	    };
	    SubscriptionListComponent.prototype.HideAlertModal = function () {
	        this.alertModal.hide();
	    };
	    SubscriptionListComponent.prototype.OnParentCheck = function (isChecked) {
	        this.subscriptionList.forEach(function (x) { return x.isChecked = isChecked; });
	    };
	    SubscriptionListComponent.prototype.ConfirmSuccessClick = function () {
	        this.confirmModal.hide();
	        this.DeleteSubsription();
	    };
	    SubscriptionListComponent.prototype.ShowConfirmModal = function (subscriptionHashId) {
	        this.isLoading = false;
	        this.popupMsg = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
	        this.confirmModal.show();
	        this.deleteSubscriptionHashId = subscriptionHashId;
	    };
	    SubscriptionListComponent.prototype.HideConfirmModal = function () {
	        this.confirmModal.hide();
	    };
	    SubscriptionListComponent.prototype.DeleteSubsription = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.subscriptionService.DeleteSubsription(this.deleteSubscriptionHashId)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.DataListModel.currentPage = 1;
	                _this.GetSubscriptionList();
	                _this.popupTitle = _this.translate.instant('LblSuccess');
	                _this.popupMsg = _this.translate.instant('LblRecordRemovedSuccess', [_this.module]);
	                _this.ShowSuccessPopup();
	            }
	            if (res.error) {
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.popupMsg = res.error;
	                _this.isLoading = false;
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SubscriptionListComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    SubscriptionListComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    SubscriptionListComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    SubscriptionListComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    __decorate([
	        core_1.ViewChild('alertModal'), 
	        __metadata('design:type', Object)
	    ], SubscriptionListComponent.prototype, "alertModal", void 0);
	    __decorate([
	        core_1.ViewChild('confirmModal'), 
	        __metadata('design:type', Object)
	    ], SubscriptionListComponent.prototype, "confirmModal", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], SubscriptionListComponent.prototype, "successPopup", void 0);
	    SubscriptionListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-subscription-list',
	            template: __webpack_require__(756),
	            providers: [sharedvehiclegroupsubscription_service_1.SubscriptionService, contracttypegroup_service_1.ContractTypeGroupService, sharedvehiclegroup_service_1.SharedVehicleGroupService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof sharedvehiclegroupsubscription_service_1.SubscriptionService !== 'undefined' && sharedvehiclegroupsubscription_service_1.SubscriptionService) === 'function' && _a) || Object, (typeof (_b = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _b) || Object, (typeof (_c = typeof contracttypegroup_service_1.ContractTypeGroupService !== 'undefined' && contracttypegroup_service_1.ContractTypeGroupService) === 'function' && _c) || Object, (typeof (_d = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _d) || Object, (typeof (_e = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _e) || Object, (typeof (_f = typeof sharedvehiclegroup_service_1.SharedVehicleGroupService !== 'undefined' && sharedvehiclegroup_service_1.SharedVehicleGroupService) === 'function' && _f) || Object, (typeof (_g = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _g) || Object])
	    ], SubscriptionListComponent);
	    return SubscriptionListComponent;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.SubscriptionListComponent = SubscriptionListComponent;


/***/ },
/* 756 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ breadCrumbList}} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li><a [routerLink]=\"urlDefaultPage\"><i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a></li>\r\n        <li><a [routerLink]=\"urlSVGList\"><i class=\"fa fa-group fa-fw\"></i> {{ sharedvehicleGroup }}</a></li>\r\n        <li class=\"active\"> {{ breadCrumbList}} </li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25 \">     \r\n        <wego-authorized-link  [LinkModel]=\"addSVGSubscriptionLink\" (onClick)=\"AddNewSubscription(sharedVehicleGroupHashId)\"></wego-authorized-link>\r\n\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <h4><label>{{ 'LblSharedVehicleGroup' | translate }} : </label> {{groupName}}</h4>\r\n        <wego-search-list (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\"\r\n          [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('name')\">\r\n                  {{ 'LblSubscriptionName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'name'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('amount')\">\r\n                  {{ 'LblAmount' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'amount'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('timeInterval')\">\r\n                  {{'LblSubscriptionInterval' | translate}}\r\n                  <wego-sort-list [FieldName]=\"'timeInterval'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('freeKilometer')\">\r\n                  {{'LblFreeKilometer' | translate}}\r\n                  <wego-sort-list [FieldName]=\"'freeKilometer'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('description')\">\r\n                  {{'LblDescription' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'description'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"text-center\"> {{'LblRestriction' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblEdit' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblDelete' | translate }}</th>\r\n\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let subscription of subscriptionList\">\r\n                  <td>{{ subscription.name }}</td>\r\n                  <td>{{ subscription.amountDisplay }}</td>\r\n                  <td>{{ subscription.timeInterval }}</td>\r\n                  <td>{{ subscription.freeKilometer }}</td>\r\n                  <td class=\"word-wrap\">{{ subscription.description }}</td>\r\n                  \r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"!subscription.isRestrictionCount\" class=\"btn btn-primary link-style\" disabled>\r\n                      <span class=\"badge link-text\">{{ subscription.totalAvailabilityRestriction }}</span>\r\n                    </a>\r\n                    <a *ngIf=\"subscription.isRestrictionCount\" class=\"btn btn-primary cursor-pointer link-style\"[routerLink]=\"urlSubscriptionAvailability + '/' + subscription.sharedVehicleSubscriptionHashId\">\r\n                      <span class=\"badge link-text\">{{ subscription.totalAvailabilityRestriction }}</span>\r\n                    </a>\r\n                  </td>\r\n\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"subscription.isEditable\" [routerLink]=\"urlSubscriptionUpdate + '/' +subscription.sharedVehicleGroupHashId + '/'+subscription.sharedVehicleSubscriptionHashId\">\r\n                      <i class=\"fa fa-pencil-square-o fa-fw\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a class=\"cursor-pointer\" *ngIf=\"subscription.isDeletable\" (click)=\"ShowConfirmModal(subscription.sharedVehicleSubscriptionHashId)\">\r\n                      <i class=\"fa fa-trash-o fa-fw text-danger\"></i>\r\n                    </a>\r\n                  </td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"8\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<wego-confirm-popup #confirmModal [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessClick()\" (onReject)=\"HideConfirmModal()\"></wego-confirm-popup>\r\n\r\n<wego-success-popup #successPopup [popupTitle]=\"popupTitle\" [popupMsg]=\"popupMsg\" (onConfirm)=\"HideChildModal()\"></wego-success-popup>\r\n\r\n<wego-success-popup #alertModal [popupTitle]=\"popupTitle\" [popupMsg]=\"alertMsg\" (onConfirm)=\"HideAlertModal()\"></wego-success-popup>";

/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var sharedvehiclegroupsubscription_service_1 = __webpack_require__(753);
	var auth_service_1 = __webpack_require__(58);
	var translate_service_1 = __webpack_require__(70);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var SubscriptionAvailabilityListComponent = (function () {
	    function SubscriptionAvailabilityListComponent(subscriptionService, translate, authService, activeRoute, router) {
	        this.subscriptionService = subscriptionService;
	        this.translate = translate;
	        this.authService = authService;
	        this.activeRoute = activeRoute;
	        this.router = router;
	    }
	    Object.defineProperty(SubscriptionAvailabilityListComponent.prototype, "isAnyChecked", {
	        get: function () {
	            if (this.subscriptionAvailabilityModelList) {
	                var isCheck = this.subscriptionAvailabilityModelList.some(function (x) { return x.isChecked == true; });
	                if (isCheck) {
	                    if (this.subscriptionAvailabilityModelList.every(function (x) { return x.isChecked == true; }))
	                        this.isParentCheck = true;
	                    else
	                        this.isParentCheck = false;
	                }
	                else {
	                    this.isParentCheck = false;
	                }
	                return isCheck;
	            }
	            else {
	                this.isParentCheck = false;
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SubscriptionAvailabilityListComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.module = this.translate.instant('LblSubscriptionAvailabilityRestriction', [this.module]);
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	        this.subscriptionList = this.translate.instant('LblListPage', this.translate.instant('LblSubscription'));
	        this.sharedvehicleGroup = this.translate.instant('LblListPage', [this.translate.instant('LblSharedVehicleGroup')]);
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlSubscriptionList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SUBSCRIPTION_LIST);
	        this.urlSubscriptionAvaibilityUpdate = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SUBSCRIPTIONAVAILABILITY_UPDATE);
	        this.urlSubscriptionAvaibilityADD = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SUBSCRIPTIONAVAILABILITY_ADD);
	        this.urlSVGList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SVG_LIST);
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = ["startDayName", "endDayName"];
	        this.activeRoute
	            .params
	            .subscribe(function (params) {
	            var sharedVehicleGroupSubscriptionHashId = params['id'] || '';
	            _this.sharedVehicleGroupSubscriptionHashId = sharedVehicleGroupSubscriptionHashId;
	            if (sharedVehicleGroupSubscriptionHashId != '') {
	                _this.sharedVehicleGroupSubscriptionHashId = sharedVehicleGroupSubscriptionHashId;
	                _this.GetSubscriptionName();
	                _this.GetSubscriptionAvailabilityRestrictionList();
	            }
	        });
	    };
	    Object.defineProperty(SubscriptionAvailabilityListComponent.prototype, "isDeleteAccess", {
	        get: function () {
	            if (this.subscriptionAvailabilityModelList) {
	                return this.subscriptionAvailabilityModelList.some(function (x) { return x.isDeletable; });
	            }
	            else {
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SubscriptionAvailabilityListComponent.prototype.GetSubscriptionName = function () {
	        var _this = this;
	        this.subscriptionService.GetSubscriptionBasicDetail(this.sharedVehicleGroupSubscriptionHashId)
	            .subscribe(function (res) {
	            if (res.data)
	                _this.subscriptionName = res.data.entityName;
	            _this.sharedVehicleGroupHashId = res.data.entityHashId;
	            _this.addSVGSubscriptionRestrictionLink = new config_1.WeGoAuthorizedLink(_this.urlSubscriptionAvaibilityADD + '/' + _this.sharedVehicleGroupSubscriptionHashId + '/' + _this.sharedVehicleGroupHashId, config_1.Permission.PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_AVAILIBILTY_RESTRICTION_OVERVIEW, config_1.PermissionType.INSERT, 'btn btn-highlight navbar-right', 'LblAddNew', config_1.Entity.SVG, _this.sharedVehicleGroupHashId);
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SubscriptionAvailabilityListComponent.prototype.GetSubscriptionAvailabilityRestrictionList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.subscriptionService.GetSubscriptionAvailability(this.sharedVehicleGroupSubscriptionHashId, this.DataListModel)
	            .subscribe(function (res) {
	            _this.subscriptionAvailabilityModelList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	            _this.subscriptionAvailabilityModelList = [];
	            _this.DataListModel.infoMessage = error;
	        });
	    };
	    SubscriptionAvailabilityListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.subscriptionService.ExportAvailabilityRestrriction(this.sharedVehicleGroupSubscriptionHashId, this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "AvailabilityRestriction" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	        ;
	    };
	    SubscriptionAvailabilityListComponent.prototype.OnParentCheck = function (isChecked) {
	        this.subscriptionAvailabilityModelList.filter(function (x) { return x.isDeletable; }).forEach(function (x) { return x.isChecked = isChecked; });
	    };
	    SubscriptionAvailabilityListComponent.prototype.ShowChildModal = function (availbilityHashId) {
	        if (availbilityHashId) {
	            this.popupMsg = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
	            this.isMultipleDelete = false;
	            this.deleteSubscriptionAvailabilityHashId = availbilityHashId;
	        }
	        else {
	            this.popupMsg = this.translate.instant('LblRecordMultiplDeleteConfirmation', [this.module]);
	            this.isMultipleDelete = true;
	        }
	        this.childModal.show();
	    };
	    SubscriptionAvailabilityListComponent.prototype.HideChildModal = function () {
	        this.deleteSubscriptionAvailabilityHashId = "";
	        this.childModal.hide();
	    };
	    SubscriptionAvailabilityListComponent.prototype.SuccessModalClick = function () {
	        var deletedAvailabilityist;
	        if (this.isMultipleDelete)
	            deletedAvailabilityist = this.subscriptionAvailabilityModelList.filter(function (x) { return x.isChecked; }).map(function (x) { return x.subscriptionAvailabiltiyHashId; });
	        else
	            deletedAvailabilityist.push(this.deleteSubscriptionAvailabilityHashId);
	        this.DeleteRestriction(deletedAvailabilityist);
	        this.childModal.hide();
	    };
	    SubscriptionAvailabilityListComponent.prototype.DeleteRestriction = function (deletedAvailabilityist) {
	        var _this = this;
	        this.isLoading = true;
	        this.subscriptionService.DeleteAvailabilityRestriction(deletedAvailabilityist)
	            .subscribe(function (res) {
	            _this.DataListModel.currentPage = 1;
	            _this.GetSubscriptionAvailabilityRestrictionList();
	            _this.popupMsg = _this.translate.instant('LblRecordRemovedSuccess', [_this.module]);
	            _this.ShowSuccessPopup();
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SubscriptionAvailabilityListComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetSubscriptionAvailabilityRestrictionList();
	    };
	    SubscriptionAvailabilityListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetSubscriptionAvailabilityRestrictionList();
	    };
	    SubscriptionAvailabilityListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetSubscriptionAvailabilityRestrictionList();
	    };
	    SubscriptionAvailabilityListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetSubscriptionAvailabilityRestrictionList();
	    };
	    ;
	    SubscriptionAvailabilityListComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    SubscriptionAvailabilityListComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    SubscriptionAvailabilityListComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    SubscriptionAvailabilityListComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], SubscriptionAvailabilityListComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild('childModal'), 
	        __metadata('design:type', Object)
	    ], SubscriptionAvailabilityListComponent.prototype, "childModal", void 0);
	    SubscriptionAvailabilityListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-subscriptionavailabilityrestriction-list',
	            template: __webpack_require__(758),
	            providers: [sharedvehiclegroupsubscription_service_1.SubscriptionService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof sharedvehiclegroupsubscription_service_1.SubscriptionService !== 'undefined' && sharedvehiclegroupsubscription_service_1.SubscriptionService) === 'function' && _a) || Object, (typeof (_b = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object, (typeof (_e = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _e) || Object])
	    ], SubscriptionAvailabilityListComponent);
	    return SubscriptionAvailabilityListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.SubscriptionAvailabilityListComponent = SubscriptionAvailabilityListComponent;


/***/ },
/* 758 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ breadCrumbList}} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li><a [routerLink]=\"urlDefaultPage\"><i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a></li>\r\n        <li><a [routerLink]=\"urlSVGList\"><i class=\"fa fa-group fa-fw\"></i> {{ sharedvehicleGroup }}</a></li>\r\n\r\n        <li><a [routerLink]=\"urlSubscriptionList + '/' + sharedVehicleGroupHashId\"><i class=\"fa fa-envelope fa-fw\"></i> {{subscriptionList }}</a></li>\r\n        <li class=\"active\"> {{ breadCrumbList}} </li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25 \">\r\n\r\n      <wego-authorized-link [LinkModel]=\"addSVGSubscriptionRestrictionLink\"></wego-authorized-link>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <h4><label>{{ 'LblSubscription' | translate }} : </label> {{subscriptionName}}</h4>\r\n        <wego-search-list [IsDeleted]=\"isDeleteAccess\" [IsDeleteEnabled]=\"isAnyChecked\" (OnDeleteAll)=\"ShowChildModal()\" (OnSearch)=\"OnSearch($event)\"\r\n          (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center parent-checkbox\"><input type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\"></th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('startDay')\">\r\n                  {{ 'LblStartDay' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'startDay'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('bookingStartTimespan')\">\r\n                  {{ 'LblStartTime' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'bookingStartTimespan'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('endDay')\">\r\n                  {{ 'LblEndDay' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'endDay'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('bookingEndTimespan')\">\r\n                  {{ 'LblEndTime' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'bookingEndTimespan'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"text-center\">{{ 'LblEdit' | translate }}</th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let subscriptionAvailability of subscriptionAvailabilityModelList\">\r\n                  <td class=\"text-center\">\r\n                    <input disabled *ngIf =\"!subscriptionAvailability.isDeletable\"  type=\"checkbox\" name=\"isActive\" [(ngModel)]=\"subscriptionAvailability.isChecked\">\r\n                    <input *ngIf =\"subscriptionAvailability.isDeletable\" type=\"checkbox\" name=\"isActive\" [(ngModel)]=\"subscriptionAvailability.isChecked\">\r\n                  </td>\r\n                  <td>{{ subscriptionAvailability.startDayName }}</td>\r\n                  <td>{{ subscriptionAvailability.bookingStartTime }}</td>\r\n                  <td>{{ subscriptionAvailability.endDayName }}</td>\r\n                  <td>{{ subscriptionAvailability.bookingEndTime }}</td>\r\n                  <td class=\"text-center\">\r\n\r\n                    <a *ngIf=\"subscriptionAvailability.isEditable\" [routerLink]=\"urlSubscriptionAvaibilityUpdate + '/' + sharedVehicleGroupSubscriptionHashId + '/' + subscriptionAvailability.subscriptionAvailabiltiyHashId + '/'+sharedVehicleGroupHashId\">\r\n                      <i class=\"fa fa-pencil-square-o fa-fw\"></i>\r\n                    </a>\r\n                  </td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"6\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n<wego-confirm-popup #childModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessModalClick()\" (onReject)=\"HideChildModal()\"></wego-confirm-popup>\r\n<wego-success-popup #successPopup [popupTitle]=\"popupTitle\" [popupMsg]=\"popupMsg\" (onConfirm)=\"HideChildModal()\"></wego-success-popup>";

/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var subscriptionavailabilityrestriction_model_1 = __webpack_require__(760);
	var sharedvehiclegroupsubscription_service_1 = __webpack_require__(753);
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var common_1 = __webpack_require__(22);
	var SubscriptionaAvailabilityUpdateComponent = (function () {
	    function SubscriptionaAvailabilityUpdateComponent(subscriptionService, activeRoute, router, authService, translate, locationService) {
	        this.subscriptionService = subscriptionService;
	        this.activeRoute = activeRoute;
	        this.router = router;
	        this.authService = authService;
	        this.translate = translate;
	        this.locationService = locationService;
	    }
	    SubscriptionaAvailabilityUpdateComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.dayofWeekList = [
	            {
	                Key: 'Sunday',
	                Value: '0',
	            },
	            {
	                Key: 'Monday',
	                Value: '1',
	            },
	            {
	                Key: 'Tuesday',
	                Value: '2',
	            },
	            {
	                Key: 'Wednesday',
	                Value: '3',
	            },
	            {
	                Key: 'Thursday',
	                Value: '4',
	            },
	            {
	                Key: 'Friday',
	                Value: '5',
	            },
	            {
	                Key: 'Saturday',
	                Value: this.translate.instant('6'),
	            }];
	        this.module = this.translate.instant('LblSubscriptionAvailabilityRestriction');
	        this.sharedvehicleGroup = this.translate.instant('LblListPage', this.translate.instant('LblSharedVehicleGroup'));
	        this.subscriptionList = this.translate.instant('LblListPage', this.translate.instant('LblSubscription'));
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlSubscriptionAvailabilityList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SUBSCRIPTIONAVAILABILITY_LIST);
	        this.urlSVGList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SVG_LIST);
	        this.urlSubscriptionList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SUBSCRIPTION_LIST);
	        this.model = new subscriptionavailabilityrestriction_model_1.SubscriptionAvailabilityModel();
	        this.isEditMode = false;
	        this.sub = this.activeRoute
	            .params
	            .subscribe(function (params) {
	            _this.subscriptionHashId = params['sharedVehicleGroupSubscriptionHashId'] || '';
	            _this.subscriptionAvailabilityHashId = params['subscriptionAvailabiltiyHashId'] || '';
	            _this.sharedVehicleGroupHashId = params['sharedVehicleGroupHashId'];
	            if (_this.subscriptionAvailabilityHashId != '') {
	                _this.GetSubscriptionAvailabilityByHashId();
	            }
	            if (_this.subscriptionHashId != '') {
	                _this.model.sharedVehicleSubscriptionHashId = _this.subscriptionHashId;
	                _this.model.startDay = _this.dayofWeekList[0].Value;
	                _this.model.endDay = _this.dayofWeekList[0].Value;
	            }
	        });
	        this.breadCrumbTitle = this.isEditMode ? this.translate.instant('LblEditPage', [this.module]) : this.translate.instant('LblAddPage', [this.module]);
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	    };
	    SubscriptionaAvailabilityUpdateComponent.prototype.onSubmit = function (forms) {
	        console.log(this.model);
	        this.AddSubScriptionAvailability();
	    };
	    SubscriptionaAvailabilityUpdateComponent.prototype.AddSubScriptionAvailability = function () {
	        var _this = this;
	        this.subscriptionService.AddSubscriptionAvailability(this.model)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.isEditMode ? _this.translate.instant('LblRecordUpdatedSuccess', [_this.module]) : _this.translate.instant('LblRecordAddedSuccess', [_this.module]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    SubscriptionaAvailabilityUpdateComponent.prototype.GetSubscriptionAvailabilityByHashId = function () {
	        var _this = this;
	        if (this.subscriptionAvailabilityHashId != '') {
	            this.isEditMode = true;
	            this.subscriptionService.GetSubscriptionAvailabilityRestrictionByHashId(this.subscriptionAvailabilityHashId)
	                .subscribe(function (res) {
	                _this.model = res.data;
	            }, function (error) {
	                _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            });
	        }
	    };
	    SubscriptionaAvailabilityUpdateComponent.prototype.SuccessModalClick = function () {
	        this.successPopup.hide();
	    };
	    SubscriptionaAvailabilityUpdateComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    SubscriptionaAvailabilityUpdateComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    SubscriptionaAvailabilityUpdateComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    SubscriptionaAvailabilityUpdateComponent.prototype.OnBackClick = function () {
	        this.locationService.back();
	    };
	    SubscriptionaAvailabilityUpdateComponent.prototype.ngOnDestroy = function () {
	        if (this.sub) {
	            this.sub.unsubscribe();
	        }
	    };
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], SubscriptionaAvailabilityUpdateComponent.prototype, "successPopup", void 0);
	    SubscriptionaAvailabilityUpdateComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-subscriptionavailabilityrestriction-update',
	            template: __webpack_require__(761),
	            providers: [sharedvehiclegroupsubscription_service_1.SubscriptionService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof sharedvehiclegroupsubscription_service_1.SubscriptionService !== 'undefined' && sharedvehiclegroupsubscription_service_1.SubscriptionService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _d) || Object, (typeof (_e = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _e) || Object, (typeof (_f = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _f) || Object])
	    ], SubscriptionaAvailabilityUpdateComponent);
	    return SubscriptionaAvailabilityUpdateComponent;
	    var _a, _b, _c, _d, _e, _f;
	}());
	exports.SubscriptionaAvailabilityUpdateComponent = SubscriptionaAvailabilityUpdateComponent;


/***/ },
/* 760 */
/***/ function(module, exports) {

	"use strict";
	var SubscriptionAvailabilityModel = (function () {
	    function SubscriptionAvailabilityModel() {
	    }
	    return SubscriptionAvailabilityModel;
	}());
	exports.SubscriptionAvailabilityModel = SubscriptionAvailabilityModel;


/***/ },
/* 761 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-12 col-sm-6\">\r\n      <h1 class=\"pagename\">{{breadCrumbTitle}}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li><a [routerLink]=\"urlDefaultPage\"><i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a></li>\r\n        <li><a [routerLink]=\"urlSVGList\"><i class=\"fa fa-group fa-fw\"></i> {{ sharedvehicleGroup }}</a></li>\r\n        <li><a [routerLink]=\"urlSubscriptionList + '/' +  sharedVehicleGroupHashId\" routerLinkActive=\"active\"><i class=\"fa fa-envelope fa-fw\"></i>{{subscriptionList}}</a></li>\r\n        <li><a [routerLink]=\"urlSubscriptionAvailabilityList + '/'+  subscriptionHashId\" routerLinkActive=\"active\"><i class=\"fa fa-times-circle-o\"></i>{{breadCrumbList}}</a></li>\r\n        <li class=\"active\">{{breadCrumbTitle}}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"nopad\">\r\n      <form (ngSubmit)=\"onSubmit(AddSubscriptionAvailabilityForm.value)\" #AddSubscriptionAvailabilityForm=\"ngForm\">\r\n        <div class=\"form-group col-md-3\">\r\n          <label><span class=\"text text-danger\">*</span> {{ 'LblStartDay' | translate }} </label>\r\n          <select [(ngModel)]=\"model.startDay\" name=\"startDay\" class=\"form-control\">\r\n              <option *ngFor=\"let item of dayofWeekList\"  [attr.value]='item.Value' >{{item.Key}}</option>\r\n          </select>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'startDay' }}</span>\r\n        </div>\r\n        <div class=\"form-group col-md-3\">\r\n          <label><span class=\"text text-danger\">*</span> {{ 'LblStartTime' | translate }} </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblStartTime' | translate }}\" [(ngModel)]=\"model.bookingStartTime\" name=\"bookingStartTime\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'bookingStartTime' }}</span>\r\n        </div>\r\n        <div class=\"form-group col-md-3\">\r\n          <label><span class=\"text text-danger\">*</span> {{ 'LblEndDay' | translate }} </label>\r\n          <select [(ngModel)]=\"model.endDay\" name=\"endDay\" class=\"form-control\">\r\n              <option *ngFor=\"let item of dayofWeekList\"  [attr.value]='item.Value' >{{item.Key}}</option>\r\n          </select>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'endDay' }}</span>\r\n        </div>\r\n        <div class=\"form-group col-md-3\">\r\n          <label><span class=\"text text-danger\">*</span> {{ 'LblEndTime' | translate }}</label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblEndTime' | translate }}\" [(ngModel)]=\"model.bookingEndTime\" name=\"bookingEndTime\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'bookingEndTime' }}</span>\r\n        </div>\r\n\r\n        <div class=\"row no-margin\">\r\n          <div class=\"col-sm-12\">\r\n            <hr>\r\n            <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnBackClick()\">{{ 'LblCancel' | translate }}</a> &nbsp;&nbsp;\r\n            <button class=\"btn btn-green\" type=\"submit\">{{ 'LblSave' | translate }}</button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>";

/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var config_1 = __webpack_require__(60);
	var core_1 = __webpack_require__(3);
	var vehicle_service_1 = __webpack_require__(530);
	var sharedvehiclegroup_service_1 = __webpack_require__(510);
	var router_1 = __webpack_require__(26);
	var config_2 = __webpack_require__(60);
	var common_1 = __webpack_require__(22);
	var SVGVehicleComponent = (function () {
	    function SVGVehicleComponent(sharedVehicleService, vehicleService, activeRoute, router, authService, translate, locationService) {
	        this.sharedVehicleService = sharedVehicleService;
	        this.vehicleService = vehicleService;
	        this.activeRoute = activeRoute;
	        this.router = router;
	        this.authService = authService;
	        this.translate = translate;
	        this.locationService = locationService;
	        this.sharedVehicleGroupHashId = "";
	        this.companyHashID = "";
	    }
	    Object.defineProperty(SVGVehicleComponent.prototype, "isAnyChecked", {
	        get: function () {
	            if (this.vehicleList) {
	                var isCheck = this.vehicleList.some(function (x) { return x.isChecked == true; });
	                if (isCheck) {
	                    if (this.vehicleList.every(function (x) { return x.isChecked == true; }))
	                        this.isParentCheck = true;
	                    else
	                        this.isParentCheck = false;
	                }
	                else {
	                    this.isParentCheck = false;
	                }
	                return isCheck;
	            }
	            else {
	                this.isParentCheck = false;
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SVGVehicleComponent.prototype, "isDeleteAccess", {
	        get: function () {
	            if (this.vehicleList) {
	                return this.vehicleList.some(function (x) { return x.isDeletable; });
	            }
	            else {
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SVGVehicleComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.module = this.translate.instant("LblVehicle");
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = [
	            "licenceTag",
	            "ownerName",
	            "brand",
	            "type",
	            "vehicleClass",
	            "color"
	        ];
	        this.urlDefaultPage = this.authService.GetURL(config_2.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlSVGList = this.authService.GetURL(config_2.ApplicationRouteURL.URL_SVG_LIST);
	        this.urlVehicleInfo = this.authService.GetURL(config_2.ApplicationRouteURL.URL_VEHICLE_INFO);
	        this.urlVehicleUpdate = this.authService.GetURL(config_2.ApplicationRouteURL.URL_VEHICLE_UPDATE);
	        this.activeRoute.params.subscribe(function (params) {
	            var sharedVehicleGroupHashId = params["sharedVehicleGroupHashId"] || "";
	            if (sharedVehicleGroupHashId != "") {
	                _this.sharedVehicleGroupHashId = sharedVehicleGroupHashId;
	                _this.GetSharedVehicleGropuDetailsByHashId();
	                _this.addSVGVehicleLink = new config_1.WeGoAuthorizedLink("", config_1.Permission.PR_SHARED_VEHICLE_GROUP_VEHICLE_OVERVIEW, config_1.PermissionType.INSERT, "btn btn-highlight navbar-right", "LblAddNew", config_1.Entity.SVG, _this.sharedVehicleGroupHashId);
	                _this.GetGroupVehicleList();
	            }
	        });
	    };
	    SVGVehicleComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        // this.vehicleService.ExportVehicleList(null, this.sharedVehicleGroupHashId, this.DataListModel)
	        this.vehicleService
	            .ExportVehicleList(this.DataListModel, null, this.sharedVehicleGroupHashId)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "GroupVehicles" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SVGVehicleComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetGroupVehicleList();
	    };
	    SVGVehicleComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetGroupVehicleList();
	    };
	    SVGVehicleComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetGroupVehicleList();
	    };
	    SVGVehicleComponent.prototype.OnPagingChange = function (event) {
	        console.log(this.DataListModel);
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetGroupVehicleList();
	    };
	    SVGVehicleComponent.prototype.OnParentCheck = function (isChecked) {
	        this.vehicleList.forEach(function (x) { return (x.isChecked = isChecked); });
	    };
	    SVGVehicleComponent.prototype.DeleteSharedVehicleGroupMapping = function (deletevehiclegroupmappingHashId) {
	        var _this = this;
	        this.isLoading = true;
	        this.sharedVehicleService
	            .DeleteVehicleSVG(deletevehiclegroupmappingHashId)
	            .subscribe(function (res) {
	            _this.apiResponse = res;
	            _this.DataListModel.currentPage = 1;
	            _this.GetGroupVehicleList();
	            _this.popupMsg = _this.translate.instant("LblRecordRemovedSuccess", [
	                _this.module
	            ]);
	            _this.ShowSuccessPopup();
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SVGVehicleComponent.prototype.ShowDeleteModal = function () {
	        this.popupMsg = this.translate.instant("LblRecordMultiplDeleteConfirmation", [this.module]);
	        this.deleteModal.show();
	    };
	    SVGVehicleComponent.prototype.HideDeleteModal = function () {
	        this.deletevehiclegroupmappingHashId = "";
	        this.deleteModal.hide();
	    };
	    SVGVehicleComponent.prototype.SuccessModalClick = function () {
	        var deletSharedVehiclegroupmappingIds;
	        deletSharedVehiclegroupmappingIds = this.vehicleList
	            .filter(function (x) { return x.isChecked; })
	            .map(function (x) { return x.vehicleGroupMappingHashId; });
	        this.DeleteSharedVehicleGroupMapping(deletSharedVehiclegroupmappingIds);
	        this.deleteModal.hide();
	    };
	    SVGVehicleComponent.prototype.GetGroupVehicleList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.sharedVehicleService
	            .GetSVGVehicleList(this.sharedVehicleGroupHashId, this.DataListModel)
	            .subscribe(function (res) {
	            _this.vehicleList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SVGVehicleComponent.prototype.GetSharedVehicleGropuDetailsByHashId = function () {
	        var _this = this;
	        this.sharedVehicleService
	            .GetSharedVehicleGroupBasicDetail(this.sharedVehicleGroupHashId)
	            .subscribe(function (res) {
	            _this.groupName = res.data.entityName;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SVGVehicleComponent.prototype.ShowAssignVehicleGroupModal = function () {
	        this.assignGroupVehicleModal.sharedVehicleGroupHashId = this.sharedVehicleGroupHashId;
	        this.assignGroupVehicleModal.show();
	    };
	    SVGVehicleComponent.prototype.SuccessAssignVehicleGroupModal = function ($event) {
	        this.GetGroupVehicleList();
	        this.popupMsg = this.translate.instant("LblRecordAddedSuccess", [
	            this.module
	        ]); //$event.SuccessMessage;
	        this.ShowSuccessPopup();
	    };
	    SVGVehicleComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    SVGVehicleComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    SVGVehicleComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    SVGVehicleComponent.prototype.OnBackClick = function () {
	        this.locationService.back();
	    };
	    SVGVehicleComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    __decorate([
	        core_1.ViewChild("deleteModal"), 
	        __metadata('design:type', Object)
	    ], SVGVehicleComponent.prototype, "deleteModal", void 0);
	    __decorate([
	        core_1.ViewChild("assignGroupVehicleModal"), 
	        __metadata('design:type', Object)
	    ], SVGVehicleComponent.prototype, "assignGroupVehicleModal", void 0);
	    __decorate([
	        core_1.ViewChild("successPopup"), 
	        __metadata('design:type', Object)
	    ], SVGVehicleComponent.prototype, "successPopup", void 0);
	    SVGVehicleComponent = __decorate([
	        core_1.Component({
	            selector: "wego-svgvehicle",
	            template: __webpack_require__(763),
	            providers: [sharedvehiclegroup_service_1.SharedVehicleGroupService, vehicle_service_1.VehicleService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof sharedvehiclegroup_service_1.SharedVehicleGroupService !== 'undefined' && sharedvehiclegroup_service_1.SharedVehicleGroupService) === 'function' && _a) || Object, (typeof (_b = typeof vehicle_service_1.VehicleService !== 'undefined' && vehicle_service_1.VehicleService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _e) || Object, (typeof (_f = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _f) || Object, (typeof (_g = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _g) || Object])
	    ], SVGVehicleComponent);
	    return SVGVehicleComponent;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.SVGVehicleComponent = SVGVehicleComponent;


/***/ },
/* 763 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ 'LblVehicle' | translate }} {{ 'LblList' | translate }} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i>{{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"urlSVGList\">\r\n            <i class=\"fa fa-group fa-fw\"></i> {{ 'LblSharedVehicleGroup' | translate }} {{ 'LblList' | translate }}</a>\r\n        </li>\r\n        <li class=\"active\"> {{ 'LblVehicle' | translate }} {{ 'LblList' | translate }}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25 \">\r\n      <!-- <a class=\"btn btn-highlight navbar-right\" (click)=\"ShowAssignVehicleGroupModal()\">{{ 'LblAddNew' | translate }}</a> -->\r\n      <wego-authorized-link  [LinkModel]=\"addSVGVehicleLink\" (onClick)=\"ShowAssignVehicleGroupModal()\"></wego-authorized-link>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <h4>\r\n          <label>{{ 'LblSharedVehicleGroup' | translate }} : </label> {{groupName}}</h4>\r\n        <p class=\"text-success\">{{ message }}</p>\r\n        <wego-search-list [IsDeleted]=\"isDeleteAccess\" [IsDeleteEnabled]=\"isAnyChecked && isDeleteAccess\" (OnDeleteAll)=\"ShowDeleteModal()\" (OnSearch)=\"OnSearch($event)\"\r\n          (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center parent-checkbox\">\r\n                  <input [disabled]=\"!isDeleteAccess\" type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\">\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('licenceTag')\">\r\n                  {{ 'LblLicenceTag' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'licenceTag'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('ownerName')\">\r\n                  {{ 'LblVehicleOwner' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'ownerName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('brand')\">\r\n                  {{ 'LblBrand' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'brand'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('type')\">\r\n                  {{ 'LblType' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'type'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('vehicleClass')\">\r\n                  {{ 'LblVehicleClass' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'vehicleClass'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('color')\">\r\n                  {{ 'LblColor' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'color'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"text-center\">{{ 'LblEdit' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblStatus' | translate }}</th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let vehicle of vehicleList\">\r\n                  <td class=\"text-center\">\r\n                    <input *ngIf=\"!vehicle.isDeletable\" disabled type=\"checkbox\" name=\"isActive\">\r\n                    <input *ngIf=\"vehicle.isDeletable\" type=\"checkbox\" name=\"isActive\" [(ngModel)]=\"vehicle.isChecked\">\r\n                  </td>\r\n                  <td>{{vehicle.licenceTag}}</td>\r\n                  <td>{{vehicle.ownerName}}</td>\r\n                  <td>{{vehicle.brand}}</td>\r\n                  <td>{{vehicle.type}}</td>\r\n                  <td>{{vehicle.vehicleClass}}</td>\r\n                  <td>{{vehicle.color}}</td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"vehicle.isEditable\" class=\"cursor-pointer\" [routerLink]=\"urlVehicleUpdate + '/' + vehicle.vehicleMasterHashId\">\r\n                      <i class=\"fa fa-pencil-square-o fa-fw\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"vehicle.isViewable\" class=\"cursor-pointer\" title=\"{{ 'LblStatus' | translate}}\" [routerLink]=\"urlVehicleInfo + '/' + vehicle.vehicleMasterHashId\">\r\n                      <i class=\"fa fa-eye fa-fw\"></i>\r\n                    </a>\r\n                  </td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"8\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<div [hidden]=\"!isLoading\" class=\"my-loading\">\r\n  <div class=\"dimmer\"></div>\r\n  <div class=\"loading-bg\">\r\n    <i class=\"fa fa-refresh fa-spin fa-3x fa-fw\"></i>\r\n  </div>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<wego-confirm-popup #deleteModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessModalClick()\" (onReject)=\"HideDeleteModal()\"></wego-confirm-popup>\r\n\r\n<wego-add-groupvehicle-popup #assignGroupVehicleModal (OnSuccessSelect)=\"SuccessAssignVehicleGroupModal($event)\"></wego-add-groupvehicle-popup>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>";

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var vehicle_model_1 = __webpack_require__(553);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var sharedvehiclegroup_service_1 = __webpack_require__(510);
	var AddGroupVehiclePopupComponent = (function () {
	    function AddGroupVehiclePopupComponent(sharedVehicleGroupService, authService, router, translate) {
	        this.sharedVehicleGroupService = sharedVehicleGroupService;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.onSuccessSelect = new core_1.EventEmitter();
	    }
	    Object.defineProperty(AddGroupVehiclePopupComponent.prototype, "isAnyChecked", {
	        get: function () {
	            if (this.vehicleList) {
	                var isCheck = this.vehicleList.some(function (x) { return x.isChecked == true; });
	                if (isCheck) {
	                    if (this.vehicleList.every(function (x) { return x.isChecked == true; }))
	                        this.isParentCheck = true;
	                    else
	                        this.isParentCheck = false;
	                }
	                else {
	                    this.isParentCheck = false;
	                }
	                return isCheck;
	            }
	            else {
	                this.isParentCheck = false;
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    AddGroupVehiclePopupComponent.prototype.ngOnInit = function () {
	        this.LblAssignVehicle = this.translate.instant('LblAssign') + this.translate.instant('LblVehicle');
	        this.LblIcon = 'fa fa-plus-square';
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.searchField = ["licenceTag", "ownerName", "brand", "type", "vehicleClass",
	            "color"];
	    };
	    AddGroupVehiclePopupComponent.prototype.ngOnChanges = function (change) {
	        console.log(change);
	    };
	    AddGroupVehiclePopupComponent.prototype.show = function () {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.sortType = "";
	        this.DataListModel.sortReverse = null;
	        this.DataListModel.searchTerm = "";
	        this.DataListModel.infoMessage = "";
	        this.GetVehicleForGroup();
	        this.vehicleModal.show();
	    };
	    AddGroupVehiclePopupComponent.prototype.hide = function () {
	        this.vehicleModal.hide();
	    };
	    AddGroupVehiclePopupComponent.prototype.GetVehicleForGroup = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.sharedVehicleGroupService.GetVehicleListForGroup(this.sharedVehicleGroupHashId, this.DataListModel)
	            .subscribe(function (res) {
	            _this.vehicleList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AddGroupVehiclePopupComponent.prototype.OnParentCheck = function (isChecked) {
	        this.vehicleList.forEach(function (x) { return x.isChecked = isChecked; });
	    };
	    AddGroupVehiclePopupComponent.prototype.select = function (vehicleMasterHashId) {
	        var _this = this;
	        this.isLoading = true;
	        var model = new vehicle_model_1.SVGVehicleModel();
	        model.vehicleHashId = vehicleMasterHashId;
	        model.sharedvehiclegroupHashId = this.sharedVehicleGroupHashId;
	        this.sharedVehicleGroupService.AssignGroupVehicle(model)
	            .subscribe(function (res) {
	            _this.message = _this.translate.instant('LblRecordSavedSuccess');
	            _this.OnSuccessSelect();
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        }, function () {
	            _this.vehicleModal.hide();
	            _this.isLoading = false;
	        });
	    };
	    AddGroupVehiclePopupComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetVehicleForGroup();
	    };
	    AddGroupVehiclePopupComponent.prototype.OnSearch = function (event) {
	        this.DataListModel.searchTerm = event.searchTerm;
	        this.DataListModel.currentPage = 1;
	        this.GetVehicleForGroup();
	    };
	    AddGroupVehiclePopupComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetVehicleForGroup();
	    };
	    ;
	    AddGroupVehiclePopupComponent.prototype.OnPagingChange = function (event) {
	        console.log(this.DataListModel);
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetVehicleForGroup();
	    };
	    AddGroupVehiclePopupComponent.prototype.OnSuccessSelect = function () {
	        this.onSuccessSelect.emit({ SuccessMessage: this.message });
	    };
	    AddGroupVehiclePopupComponent.prototype.OnAdd = function (event) {
	        var _this = this;
	        var vehicleHashIdList;
	        vehicleHashIdList = this.vehicleList.filter(function (x) { return x.isChecked; }).map(function (x) { return x.vehicleMasterHashId; });
	        this.isLoading = true;
	        var model = new vehicle_model_1.SVGVehicleModel();
	        model.listOfVehicleHashId = vehicleHashIdList;
	        model.sharedvehiclegroupHashId = this.sharedVehicleGroupHashId;
	        this.sharedVehicleGroupService.AssignGroupVehicle(model)
	            .subscribe(function (res) {
	            _this.message = _this.translate.instant('LblRecordSavedSuccess');
	            _this.OnSuccessSelect();
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        }, function () {
	            _this.vehicleModal.hide();
	            _this.isLoading = false;
	        });
	    };
	    __decorate([
	        core_1.Output('OnSuccessSelect'), 
	        __metadata('design:type', Object)
	    ], AddGroupVehiclePopupComponent.prototype, "onSuccessSelect", void 0);
	    __decorate([
	        core_1.ViewChild('vehicleModal'), 
	        __metadata('design:type', Object)
	    ], AddGroupVehiclePopupComponent.prototype, "vehicleModal", void 0);
	    AddGroupVehiclePopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-add-groupvehicle-popup',
	            template: __webpack_require__(765),
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof sharedvehiclegroup_service_1.SharedVehicleGroupService !== 'undefined' && sharedvehiclegroup_service_1.SharedVehicleGroupService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object])
	    ], AddGroupVehiclePopupComponent);
	    return AddGroupVehiclePopupComponent;
	    var _a, _b, _c, _d;
	}());
	exports.AddGroupVehiclePopupComponent = AddGroupVehiclePopupComponent;


/***/ },
/* 765 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #vehicleModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n                    <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblAssign' | translate }} {{ 'LblVehicle' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <wego-search-list [IsExported]=\"false\" [SearchTerm]=\"DataListModel.searchTerm\" [CustomeIcon]=\"LblIcon\" [IsCustomButton]='true'\r\n          [Title]=\"LblAssignVehicle\" [IsCustomButtonEnabled]=\"isAnyChecked\" (OnCustomeButton)=\"OnAdd($event)\" (OnSearch)=\"OnSearch($event)\"\r\n          (OnPagingChange)=\"OnPagingChange($event)\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center parent-checkbox\"><input type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\"></th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('licenceTag')\">\r\n                  {{ 'LblLicenceTag' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'licenceTag'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('ownerName')\">\r\n                  {{ 'LblVehicleOwner' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'ownerName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('brand')\">\r\n                  {{ 'LblBrand' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'brand'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('type')\">\r\n                  {{ 'LblType' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'type'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('vehicleClass')\">\r\n                  {{ 'LblVehicleClass' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'vehicleClass'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('color')\">\r\n                  {{ 'LblColor' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'color'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let vehicle of vehicleList\">\r\n                  <td class=\"text-center\"><input type=\"checkbox\" name=\"isActive\" [(ngModel)]=\"vehicle.isChecked\"></td>\r\n                  <td>{{vehicle.licenceTag}}</td>\r\n                  <td>{{vehicle.ownerName}}</td>\r\n                  <td>{{vehicle.brand}}</td>\r\n                  <td>{{vehicle.type}}</td>\r\n                  <td>{{vehicle.vehicleClass}}</td>\r\n                  <td>{{vehicle.color}}</td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"10\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n          <div class=\"clearfix\"></div>\r\n          <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n            <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n              <div class=\"col-md-12\">\r\n                <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                  [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                  lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>";

/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var sharedvehiclegroupadmin_model_1 = __webpack_require__(767);
	var sharedvehiclegroupadmin_service_1 = __webpack_require__(768);
	var AddSharedVehicleGroupAdminPopupComponent = (function () {
	    function AddSharedVehicleGroupAdminPopupComponent(sharedVehicleGroupAdminService, authService, router, translate) {
	        this.sharedVehicleGroupAdminService = sharedVehicleGroupAdminService;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.onSuccessSelect = new core_1.EventEmitter();
	    }
	    AddSharedVehicleGroupAdminPopupComponent.prototype.ngOnInit = function () {
	        this.module = this.translate.instant('LblSharedVehicleGroupAdmin');
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.searchField = ["userName", "firstName", "lastName"];
	        this.urlPersonUpdate = this.authService.GetURL(config_1.ApplicationRouteURL.URL_PERSON_UPDATE);
	        this.breadCrumbTitle = this.translate.instant('LblAddPage', [this.module]);
	    };
	    AddSharedVehicleGroupAdminPopupComponent.prototype.ngOnChanges = function (change) {
	        console.log(change);
	    };
	    AddSharedVehicleGroupAdminPopupComponent.prototype.show = function () {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.sortType = "";
	        this.DataListModel.sortReverse = null;
	        this.DataListModel.searchTerm = "";
	        this.DataListModel.infoMessage = "";
	        this.GetShredVehicleGroupAdminPersonList();
	        this.shredVehicleAdminModal.show();
	    };
	    AddSharedVehicleGroupAdminPopupComponent.prototype.hide = function () {
	        this.shredVehicleAdminModal.hide();
	    };
	    AddSharedVehicleGroupAdminPopupComponent.prototype.GetShredVehicleGroupAdminPersonList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.sharedVehicleGroupAdminService.GetPersonListBySharedVehicleGroupId(this.sharedVehicleGroupHashId, this.DataListModel)
	            .subscribe(function (res) {
	            _this.personList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AddSharedVehicleGroupAdminPopupComponent.prototype.select = function (personMasterHashId) {
	        var _this = this;
	        this.isLoading = true;
	        var model = new sharedvehiclegroupadmin_model_1.SharedVehicleGroupAdminModel();
	        model.personHashID = personMasterHashId;
	        model.sharedVehicleGroupHashId = this.sharedVehicleGroupHashId;
	        this.sharedVehicleGroupAdminService.AddNewSharedVehicleGroupAdmin(model)
	            .subscribe(function (res) {
	            _this.message = _this.translate.instant('LblRecordSavedSuccess');
	            _this.OnSuccessSelect();
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        }, function () {
	            _this.shredVehicleAdminModal.hide();
	            _this.isLoading = false;
	        });
	    };
	    AddSharedVehicleGroupAdminPopupComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetShredVehicleGroupAdminPersonList();
	    };
	    AddSharedVehicleGroupAdminPopupComponent.prototype.OnSearch = function (event) {
	        this.DataListModel.searchTerm = event.searchTerm;
	        this.DataListModel.currentPage = 1;
	        this.GetShredVehicleGroupAdminPersonList();
	    };
	    AddSharedVehicleGroupAdminPopupComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetShredVehicleGroupAdminPersonList();
	    };
	    ;
	    AddSharedVehicleGroupAdminPopupComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetShredVehicleGroupAdminPersonList();
	    };
	    AddSharedVehicleGroupAdminPopupComponent.prototype.OnSuccessSelect = function () {
	        this.onSuccessSelect.emit({ SuccessMessage: this.message });
	    };
	    __decorate([
	        core_1.Output('OnSuccessSelect'), 
	        __metadata('design:type', Object)
	    ], AddSharedVehicleGroupAdminPopupComponent.prototype, "onSuccessSelect", void 0);
	    __decorate([
	        core_1.ViewChild('shredVehicleAdminModal'), 
	        __metadata('design:type', Object)
	    ], AddSharedVehicleGroupAdminPopupComponent.prototype, "shredVehicleAdminModal", void 0);
	    AddSharedVehicleGroupAdminPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-add-shredvehiclegroup-admin',
	            template: __webpack_require__(769),
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof sharedvehiclegroupadmin_service_1.SharedVehicleGroupAdminService !== 'undefined' && sharedvehiclegroupadmin_service_1.SharedVehicleGroupAdminService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object])
	    ], AddSharedVehicleGroupAdminPopupComponent);
	    return AddSharedVehicleGroupAdminPopupComponent;
	    var _a, _b, _c, _d;
	}());
	exports.AddSharedVehicleGroupAdminPopupComponent = AddSharedVehicleGroupAdminPopupComponent;


/***/ },
/* 767 */
/***/ function(module, exports) {

	"use strict";
	var SharedVehicleGroupAdminModel = (function () {
	    function SharedVehicleGroupAdminModel() {
	    }
	    return SharedVehicleGroupAdminModel;
	}());
	exports.SharedVehicleGroupAdminModel = SharedVehicleGroupAdminModel;


/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var SharedVehicleGroupAdminService = (function () {
	    function SharedVehicleGroupAdminService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    SharedVehicleGroupAdminService.prototype.GetSharedVehicleGroupAdminList = function (sharedVehicleGroupHashId, input) {
	        var getSharedVehicleGroupAdminUrl = config_1.WeGoConfig.API_GET_SHAREDVEHICLEGROUPADMIN_DETAIL;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getSharedVehicleGroupAdminUrl = getSharedVehicleGroupAdminUrl + "?" + queryString + "&sharedVehicleGroupHashID=" + sharedVehicleGroupHashId;
	        }
	        else {
	            getSharedVehicleGroupAdminUrl = getSharedVehicleGroupAdminUrl + "?sharedVehicleGroupHashID=" + sharedVehicleGroupHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getSharedVehicleGroupAdminUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SharedVehicleGroupAdminService.prototype.ExportSharedVehicleGroupAdminList = function (sharedVehicleGroupHashId, input) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var getShareVehicleGroupAdminUrl = config_1.WeGoConfig.API_EXPORT_SHAREDVEHICLEGROUPADMIN_LIST + "?" + queryString + "&sharedVehicleGroupHashID=" + sharedVehicleGroupHashId;
	        ;
	        var headers = this.authService.GetHeader('text/csv');
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getShareVehicleGroupAdminUrl, options);
	    };
	    SharedVehicleGroupAdminService.prototype.GetPersonListBySharedVehicleGroupId = function (sharedVehicleGroupHashId, input) {
	        var getPersonUrl = config_1.WeGoConfig.API_GET_PERSON_LIST_BY_SHAREDVEHICLEGROUP_ID;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getPersonUrl = getPersonUrl + "?" + queryString + "&sharedVehicleGroupHashId=" + sharedVehicleGroupHashId;
	        }
	        else {
	            getPersonUrl = getPersonUrl + "?sharedVehicleGroupHashId=" + sharedVehicleGroupHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getPersonUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SharedVehicleGroupAdminService.prototype.DeleteSharedVehilceGroupAdmin = function (selectedsharedVehicleGroupAdminHashId) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_POST_DELETE_SHAREDVEHICLEGROUP_ADMIN, selectedsharedVehicleGroupAdminHashId, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SharedVehicleGroupAdminService.prototype.AddNewSharedVehicleGroupAdmin = function (sharedVehicleGroupAdminModel) {
	        var body = sharedVehicleGroupAdminModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_POST_SHAREDVEHICLEGROUP_ADMIN_DETAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SharedVehicleGroupAdminService.prototype.InActiveSharedVehicleGroupAdmin = function (svgAdminHashId) {
	        var getInactiveCompanyAdminUrl = config_1.WeGoConfig.API_GET_INACTIVE_SHAREDVEHICLEGROUP_ADMIN + "?sharedVehicleGroupAdminHashId=" + svgAdminHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getInactiveCompanyAdminUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SharedVehicleGroupAdminService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], SharedVehicleGroupAdminService);
	    return SharedVehicleGroupAdminService;
	    var _a, _b;
	}());
	exports.SharedVehicleGroupAdminService = SharedVehicleGroupAdminService;


/***/ },
/* 769 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #shredVehicleAdminModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n                    <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ breadCrumbTitle }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <wego-search-list [IsExported]=\"false\" [SearchTerm]=\"DataListModel.searchTerm\" (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center\">\r\n                  {{ 'LblSelect' | translate }}\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('firstName')\">\r\n                  {{ 'LblFirstName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'firstName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('lastName')\">\r\n                  {{ 'LblLastName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'lastName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('userName')\">\r\n                  {{ 'LblUserName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'userName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let person of personList\">\r\n                  <td class=\"text-center\">\r\n                    <a class=\"cursor-pointer\" (click)=\"select(person.personMasterHashId)\">\r\n                      <i class=\"fa fa-plus-square\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td>{{ person.firstName }}</td>\r\n                  <td>{{ person.lastName }} </td>\r\n                  <td>{{ person.userName }}</td>                 \r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0\">\r\n                <td class=\"text-center text-danger\" colspan=\"4\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\" [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\"\r\n                firstText=\"&laquo;\" lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>";

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var sharedvehiclegroupadmin_service_1 = __webpack_require__(768);
	var person_service_1 = __webpack_require__(771);
	var sharedvehiclegroup_service_1 = __webpack_require__(510);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var common_1 = __webpack_require__(22);
	var SharedVehicleGroupAdminListComponent = (function () {
	    function SharedVehicleGroupAdminListComponent(sharedVehicleGroupAdminService, personService, sharedvehiclegroupService, authService, activeRoute, router, translate, locationService) {
	        this.sharedVehicleGroupAdminService = sharedVehicleGroupAdminService;
	        this.personService = personService;
	        this.sharedvehiclegroupService = sharedvehiclegroupService;
	        this.authService = authService;
	        this.activeRoute = activeRoute;
	        this.router = router;
	        this.translate = translate;
	        this.locationService = locationService;
	    }
	    Object.defineProperty(SharedVehicleGroupAdminListComponent.prototype, "isAnyChecked", {
	        get: function () {
	            if (this.sharedVehicleGroupAdminList) {
	                var isCheck = this.sharedVehicleGroupAdminList.filter(function (x) { return x.isUserGroupAdmin == false; }).some(function (x) { return x.isChecked == true; });
	                if (isCheck) {
	                    if (this.sharedVehicleGroupAdminList.filter(function (x) { return x.isUserGroupAdmin == false; }).every(function (x) { return x.isChecked == true; }))
	                        this.isParentCheck = true;
	                    else
	                        this.isParentCheck = false;
	                }
	                else {
	                    this.isParentCheck = false;
	                }
	                return isCheck;
	            }
	            else {
	                this.isParentCheck = false;
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SharedVehicleGroupAdminListComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.lblActive = this.translate.instant('LblActive');
	        this.lblInactive = this.translate.instant('LblInactive');
	        this.module = this.translate.instant('LblSharedVehicleGroupAdmin');
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	        this.sharedvehiclegroupList = this.translate.instant('LblListPage', [this.translate.instant('LblSharedVehicleGroup')]);
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = ["userName", "firstName", "lastName"];
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlSVGList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SVG_LIST);
	        this.sub = this.activeRoute
	            .params
	            .subscribe(function (params) {
	            _this.sharedVehicleGroupHashId = params['sharedvehiclegroupHashId'] || '';
	            if (_this.sharedVehicleGroupHashId != '') {
	                _this.GetSharedVehicleGroupAdminList();
	                _this.GetSharedVehicleGropuDetailsByHashId();
	            }
	        });
	    };
	    SharedVehicleGroupAdminListComponent.prototype.GetSharedVehicleGropuDetailsByHashId = function () {
	        var _this = this;
	        this.sharedvehiclegroupService.GetSharedVehicleGroupBasicDetail(this.sharedVehicleGroupHashId)
	            .subscribe(function (res) {
	            _this.groupName = res.data.entityName;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SharedVehicleGroupAdminListComponent.prototype.GetSharedVehicleGroupAdminList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.sharedVehicleGroupAdminService.GetSharedVehicleGroupAdminList(this.sharedVehicleGroupHashId, this.DataListModel)
	            .subscribe(function (res) {
	            _this.sharedVehicleGroupAdminList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SharedVehicleGroupAdminListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetSharedVehicleGroupAdminList();
	    };
	    SharedVehicleGroupAdminListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetSharedVehicleGroupAdminList();
	    };
	    SharedVehicleGroupAdminListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetSharedVehicleGroupAdminList();
	    };
	    ;
	    SharedVehicleGroupAdminListComponent.prototype.OnPagingChange = function (event) {
	        console.log(this.DataListModel);
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetSharedVehicleGroupAdminList();
	    };
	    SharedVehicleGroupAdminListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.sharedVehicleGroupAdminService.ExportSharedVehicleGroupAdminList(this.sharedVehicleGroupHashId, this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "SharedVehicleGroupAdminList" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	        ;
	    };
	    SharedVehicleGroupAdminListComponent.prototype.OnParentCheck = function (isChecked) {
	        this.sharedVehicleGroupAdminList.filter(function (x) { return x.isUserGroupAdmin == false; }).forEach(function (x) { return x.isChecked = isChecked; });
	    };
	    // Delete shared vehicle group admin
	    SharedVehicleGroupAdminListComponent.prototype.DeleteSharedVehicleGroupAdmin = function (deleteSharedVehicleGroupAdminList) {
	        var _this = this;
	        this.isLoading = true;
	        this.sharedVehicleGroupAdminService.DeleteSharedVehilceGroupAdmin(deleteSharedVehicleGroupAdminList)
	            .subscribe(function (res) {
	            _this.DataListModel.currentPage = 1;
	            _this.GetSharedVehicleGroupAdminList();
	            _this.popupMsg = _this.translate.instant('LblRecordRemovedSuccess', [_this.module]);
	            _this.ShowSuccessPopup();
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SharedVehicleGroupAdminListComponent.prototype.ShowAlertModal = function (sharedVehicleGroupAdminHashId) {
	        if (sharedVehicleGroupAdminHashId) {
	            this.popupMsg = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
	            this.isMultipleDelete = false;
	            this.deleteSharedVehicleGroupAdminHashId = sharedVehicleGroupAdminHashId;
	        }
	        else {
	            this.popupMsg = this.translate.instant('LblRecordMultiplDeleteConfirmation', [this.module]);
	            this.isMultipleDelete = true;
	        }
	        this.alertModal.show();
	    };
	    SharedVehicleGroupAdminListComponent.prototype.HideAlertModal = function () {
	        this.deleteSharedVehicleGroupAdminHashId = "";
	        this.deleteMessage = "";
	        this.alertModal.hide();
	    };
	    SharedVehicleGroupAdminListComponent.prototype.SuccessAlertModalClick = function () {
	        var deleteSharedVehicleGroupAdminList;
	        if (this.isMultipleDelete)
	            deleteSharedVehicleGroupAdminList = this.sharedVehicleGroupAdminList.filter(function (x) { return x.isChecked; }).map(function (x) { return x.shareVehicleGroupAdminHashID; });
	        else
	            deleteSharedVehicleGroupAdminList.push(this.deleteSharedVehicleGroupAdminHashId);
	        this.DeleteSharedVehicleGroupAdmin(deleteSharedVehicleGroupAdminList);
	        this.alertModal.hide();
	    };
	    // Add shred vehicle group admin popup
	    SharedVehicleGroupAdminListComponent.prototype.ShowAddGroupAdminModal = function () {
	        this.addSharedVehicleGroupAdminModal.sharedVehicleGroupHashId = this.sharedVehicleGroupHashId;
	        this.addSharedVehicleGroupAdminModal.show();
	    };
	    SharedVehicleGroupAdminListComponent.prototype.SuccessAddGroupAdminModal = function ($event) {
	        this.GetSharedVehicleGroupAdminList();
	        this.popupMsg = this.translate.instant('LblRecordAddedSuccess', [this.module]); //$event.SuccessMessage;
	        this.ShowSuccessPopup();
	    };
	    //Reset group admin password
	    SharedVehicleGroupAdminListComponent.prototype.ResetPersonPassword = function (personHashID) {
	        var _this = this;
	        this.personService.ResetPersonPassword(personHashID)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblResetPasswordSuccess');
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblResetPasswordFailure');
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SharedVehicleGroupAdminListComponent.prototype.ShowResetPasswordModal = function (personHashID) {
	        this.resetPasswordPersonHashId = personHashID;
	        this.popupMsg = this.translate.instant('LblResetPasswordConfirmation');
	        this.resetPasswordModal.show();
	    };
	    SharedVehicleGroupAdminListComponent.prototype.HideResetPasswordModal = function () {
	        this.resetPasswordPersonHashId = "";
	        this.resetPasswordModal.hide();
	    };
	    SharedVehicleGroupAdminListComponent.prototype.SuccessResetPasswordModalClick = function () {
	        this.resetPasswordModal.hide();
	        this.ResetPersonPassword(this.resetPasswordPersonHashId);
	    };
	    SharedVehicleGroupAdminListComponent.prototype.ActiveInactiveSVGAdmin = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.sharedVehicleGroupAdminService.InActiveSharedVehicleGroupAdmin(this.blockUnblockSVGAdminHashId)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.inActiveModal.hide();
	                _this.DataListModel.currentPage = 1;
	                _this.GetSharedVehicleGroupAdminList();
	                _this.popupMsg = _this.translate.instant('LblRecordActiveInActiveSuccess', [_this.module, _this.blockMsg]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.isLoading = false;
	                _this.popupMsg = res.error;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SharedVehicleGroupAdminListComponent.prototype.ShowInActiveModal = function (svgAdminHashId, isActive) {
	        this.blockUnblockSVGAdminHashId = svgAdminHashId;
	        this.blockMsg = isActive ? this.translate.instant('LblInactive') : this.translate.instant('LblActive');
	        var roleType = this.translate.instant('LblSharedVehicleGroupAdmin');
	        this.popupMsg = this.translate.instant('LblBlockUnblockConfirm', [this.blockMsg, roleType]);
	        this.inActiveModal.show();
	    };
	    SharedVehicleGroupAdminListComponent.prototype.HideInActiveModal = function () {
	        this.inActiveModal.hide();
	    };
	    SharedVehicleGroupAdminListComponent.prototype.SuccessInActiveModalClick = function () {
	        this.ActiveInactiveSVGAdmin();
	        this.inActiveModal.hide();
	    };
	    SharedVehicleGroupAdminListComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    SharedVehicleGroupAdminListComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    SharedVehicleGroupAdminListComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    SharedVehicleGroupAdminListComponent.prototype.OnBackClick = function () {
	        this.locationService.back();
	    };
	    SharedVehicleGroupAdminListComponent.prototype.ResendActivationMail = function (personHashID) {
	        var _this = this;
	        this.resetPasswordPersonHashId = personHashID;
	        this.personService.ReSendActivationMail(personHashID)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblResendActivationMailSuccess');
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblResendActivationMailFailure');
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SharedVehicleGroupAdminListComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    __decorate([
	        core_1.ViewChild('alertModal'), 
	        __metadata('design:type', Object)
	    ], SharedVehicleGroupAdminListComponent.prototype, "alertModal", void 0);
	    __decorate([
	        core_1.ViewChild('addSharedVehicleGroupAdminModal'), 
	        __metadata('design:type', Object)
	    ], SharedVehicleGroupAdminListComponent.prototype, "addSharedVehicleGroupAdminModal", void 0);
	    __decorate([
	        core_1.ViewChild('resetPasswordModal'), 
	        __metadata('design:type', Object)
	    ], SharedVehicleGroupAdminListComponent.prototype, "resetPasswordModal", void 0);
	    __decorate([
	        core_1.ViewChild('inActiveModal'), 
	        __metadata('design:type', Object)
	    ], SharedVehicleGroupAdminListComponent.prototype, "inActiveModal", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], SharedVehicleGroupAdminListComponent.prototype, "successPopup", void 0);
	    SharedVehicleGroupAdminListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-sharedvehiclegroupadmin-list',
	            template: __webpack_require__(772),
	            providers: [sharedvehiclegroupadmin_service_1.SharedVehicleGroupAdminService, person_service_1.PersonService, sharedvehiclegroup_service_1.SharedVehicleGroupService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof sharedvehiclegroupadmin_service_1.SharedVehicleGroupAdminService !== 'undefined' && sharedvehiclegroupadmin_service_1.SharedVehicleGroupAdminService) === 'function' && _a) || Object, (typeof (_b = typeof person_service_1.PersonService !== 'undefined' && person_service_1.PersonService) === 'function' && _b) || Object, (typeof (_c = typeof sharedvehiclegroup_service_1.SharedVehicleGroupService !== 'undefined' && sharedvehiclegroup_service_1.SharedVehicleGroupService) === 'function' && _c) || Object, (typeof (_d = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _d) || Object, (typeof (_e = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _e) || Object, (typeof (_f = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _f) || Object, (typeof (_g = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _g) || Object, (typeof (_h = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _h) || Object])
	    ], SharedVehicleGroupAdminListComponent);
	    return SharedVehicleGroupAdminListComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h;
	}());
	exports.SharedVehicleGroupAdminListComponent = SharedVehicleGroupAdminListComponent;


/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var PersonService = (function () {
	    function PersonService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    PersonService.prototype.GetPersonList = function (input) {
	        var getPersonUrl = config_1.WeGoConfig.API_GET_PERSON_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getPersonUrl = getPersonUrl + "?" + queryString;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getPersonUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    PersonService.prototype.GetPersonListByAccessRight = function (input, pageName) {
	        var getPersonUrl = "";
	        switch (pageName) {
	            case "COST_EXPENSE_LIST":
	                getPersonUrl = config_1.WeGoConfig.API_GET_PERSON_LIST_FOR_COST_EXPENSE_LIST;
	                break;
	            default:
	                getPersonUrl = config_1.WeGoConfig.API_GET_PERSON_LIST_FOR_COST_EXPENSE_LIST;
	                break;
	        }
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getPersonUrl = getPersonUrl + "?" + queryString;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getPersonUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    PersonService.prototype.ExportPersonList = function (input) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var getUrl = config_1.WeGoConfig.API_EXPORT_PERSON_LIST + "?" + queryString;
	        var headers = this.authService.GetHeader("text/csv");
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getUrl, options);
	    };
	    PersonService.prototype.GetPersonByHashId = function (personHashId) {
	        var getPersonUrl = config_1.WeGoConfig.API_GET_PERSON_BY_HASH + "?personHashId=" + personHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getPersonUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    PersonService.prototype.GetAdminList = function (input, permissionName) {
	        var getAdminUrl = config_1.WeGoConfig.API_GET_ADMIN_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getAdminUrl = getAdminUrl + "?" + queryString;
	            getAdminUrl = getAdminUrl + "&permissionName" + permissionName;
	        }
	        else {
	            getAdminUrl = getAdminUrl + "?permissionName" + permissionName;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getAdminUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    PersonService.prototype.AddPerson = function (personModel) {
	        var body = personModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_PERSON_DETAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    PersonService.prototype.DeletePerson = function (PersonDeleteModel) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        var body = PersonDeleteModel;
	        return this.http
	            .post(config_1.WeGoConfig.API_DELETE_PERSON, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    PersonService.prototype.ResetPersonPassword = function (personHashId) {
	        var getPersonUrl = config_1.WeGoConfig.API_RESET_PASSWORD_PERSON + "?personHashId=" + personHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getPersonUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    PersonService.prototype.ImportPersonRecord = function (personModel) {
	        var body = personModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_IMPORT_PERSON_CSV, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    PersonService.prototype.ReSendActivationMail = function (personHashId, organizationHashId) {
	        if (organizationHashId === void 0) { organizationHashId = ""; }
	        var getPersonUrl = config_1.WeGoConfig.API_RESEND_ACTIVATION_MAIL_URL +
	            "?personHashId=" +
	            personHashId + "&organizationHashId=" + organizationHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getPersonUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    PersonService.prototype.UpdatePersonRemovalDate = function (personRemoveModel) {
	        var body = personRemoveModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_UPDATE_PERSON_REMOVAL_DATE_URL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    PersonService.prototype.ActivatePerson = function (personHashId) {
	        var getPersonUrl = config_1.WeGoConfig.API_ACTIVATE_PERSON_URL +
	            "?personHashId=" +
	            personHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getPersonUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    PersonService.prototype.ResetTwoFaCookie = function (personHashId) {
	        var getPersonUrl = config_1.WeGoConfig.API_RESET_TWOFA_COOKIE_PERSON +
	            "?personHashId=" +
	            personHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getPersonUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    PersonService.prototype.ResetTwoFaKey = function (personHashId) {
	        var getPersonUrl = config_1.WeGoConfig.API_RESET_TWOFA_KEY_PERSON +
	            "?personHashId=" +
	            personHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getPersonUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    PersonService.prototype.CorrectTag = function (rfidTagId) {
	        var getCorrectTagUrl = config_1.WeGoConfig.API_CORRECT_TAG + "?rfidTagId=" + rfidTagId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getCorrectTagUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    PersonService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], PersonService);
	    return PersonService;
	    var _a, _b;
	}());
	exports.PersonService = PersonService;


/***/ },
/* 772 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ breadCrumbList}} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li><a [routerLink]=\"urlDefaultPage\"><i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a></li>\r\n        <li><a [routerLink]=\"urlSVGList\"><i class=\"fa fa-group fa-fw\"></i> {{ sharedvehiclegroupList }}</a></li>\r\n        <li class=\"active\"> {{ breadCrumbList}} </li>\r\n      </ol>\r\n    </div>\r\n\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25 \">\r\n      <a class=\"btn btn-highlight navbar-right\" (click)=\"ShowAddGroupAdminModal()\">{{ 'LblAddNew' | translate }}</a>\r\n    </div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <h4><label>{{ 'LblSharedVehicleGroup' | translate }} : </label> {{groupName}}</h4>\r\n        <p class=\"text-success\">{{ message }}</p>\r\n        <wego-search-list [IsDeleted]=\"true\" [IsDeleteEnabled]=\"isAnyChecked\" (OnDeleteAll)=\"ShowAlertModal()\" (OnSearch)=\"OnSearch($event)\"\r\n          (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center parent-checkbox\"><input type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\"></th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('firstName')\">\r\n                  {{ 'LblFirstName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'firstName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('lastName')\">\r\n                  {{ 'LblLastName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'lastName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('userName')\">\r\n                  {{ 'LblUserName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'userName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"text-center\">{{ 'LblResendActivationMail' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblResetPassword' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblActiveInactive' | translate }}</th>\r\n                <!--<th class=\"text-center\">{{ 'LblDelete' | translate }}</th>-->\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let sharedVehicleGroupAdmin of sharedVehicleGroupAdminList\">\r\n                  <td class=\"text-center\"><input type=\"checkbox\" name=\"isActive\" [disabled]=\"sharedVehicleGroupAdmin.isUserGroupAdmin\" [(ngModel)]=\"sharedVehicleGroupAdmin.isChecked\"></td>\r\n                  <td>{{ sharedVehicleGroupAdmin.firstName }}</td>\r\n                  <td>{{ sharedVehicleGroupAdmin.lastName }}</td>\r\n                  <td>{{ sharedVehicleGroupAdmin.userName }}</td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"sharedVehicleGroupAdmin.personNotActive\"  class=\"btn btn-green btn-xs cursor-pointer\" (click)=\"ResendActivationMail(sharedVehicleGroupAdmin.personHashID)\">\r\n                       {{ 'LblReSend' | translate}}\r\n                    </a>\r\n                  </td>\r\n                  <template [ngIf]=\"sharedVehicleGroupAdmin.isUserGroupAdmin\">\r\n                    <td class=\"text-center\">\r\n                      <a>\r\n                      <i class=\"fa fa-refresh fa-fw text-success\"></i>\r\n                    </a>\r\n                    </td>\r\n                  </template>\r\n                  <template [ngIf]=\"!sharedVehicleGroupAdmin.isUserGroupAdmin\">\r\n                    <td class=\"text-center\">\r\n                      <a class=\"cursor-pointer\">\r\n                      <i class=\"fa fa-refresh fa-fw text-success\" (click)=\"ShowResetPasswordModal(sharedVehicleGroupAdmin.personHashID)\"></i>\r\n                    </a>\r\n                    </td>\r\n                  </template>\r\n                  <template [ngIf]=\"!sharedVehicleGroupAdmin.isUserGroupAdmin\">\r\n                    <td class=\"text-center\">\r\n                      <a class=\"cursor-pointer btn btn-xs btn-active-inactive\" [ngClass]=\"{'btn-active': !sharedVehicleGroupAdmin.isActive, 'btn-inactive': sharedVehicleGroupAdmin.isActive}\"\r\n                        (click)=\"ShowInActiveModal(sharedVehicleGroupAdmin.shareVehicleGroupAdminHashID, sharedVehicleGroupAdmin.isActive)\">\r\n                        <template [ngIf]=\"!sharedVehicleGroupAdmin.isActive\"> {{ 'LblActive' | translate}} </template>\r\n                        <template [ngIf]=\"sharedVehicleGroupAdmin.isActive\"> {{ 'LblInactive' | translate}} </template>\r\n                      </a>\r\n                      <!--<a class=\"cursor-pointer\" (click)=\"ShowInActiveModal(sharedVehicleGroupAdmin.shareVehicleGroupAdminHashID, sharedVehicleGroupAdmin.isActive)\">\r\n\t\t\t\t\t\t\t\t\t\t\t<i class=\"fa fa-ban fa-fw\" [ngClass]=\"{'text-success': sharedVehicleGroupAdmin.isActive, 'text-danger': !sharedVehicleGroupAdmin.isActive}\"></i>\r\n\t\t\t\t\t\t\t\t\t\t</a>-->\r\n                    </td>\r\n                  </template>\r\n                  <template [ngIf]=\"sharedVehicleGroupAdmin.isUserGroupAdmin\">\r\n                    <td class=\"text-center\">\r\n                      <a disabled=\"true\" class=\"cursor-pointer btn btn-xs btn-active-inactive\" [ngClass]=\"{'btn-active': !sharedVehicleGroupAdmin.isActive, 'btn-inactive': sharedVehicleGroupAdmin.isActive}\"\r\n                        (click)=\"ShowInActiveModal(sharedVehicleGroupAdmin.shareVehicleGroupAdminHashID, sharedVehicleGroupAdmin.isActive)\">\r\n                        <template [ngIf]=\"!sharedVehicleGroupAdmin.isActive\"> {{ 'LblActive' | translate}} </template>\r\n                        <template [ngIf]=\"sharedVehicleGroupAdmin.isActive\"> {{ 'LblInactive' | translate}} </template>\r\n                      </a>\r\n                      <!--<a class=\"cursor-pointer\" (click)=\"ShowInActiveModal(sharedVehicleGroupAdmin.shareVehicleGroupAdminHashID, sharedVehicleGroupAdmin.isActive)\">\r\n\t\t\t\t\t\t\t\t\t\t\t<i class=\"fa fa-ban fa-fw\" [ngClass]=\"{'text-success': sharedVehicleGroupAdmin.isActive, 'text-danger': !sharedVehicleGroupAdmin.isActive}\"></i>\r\n\t\t\t\t\t\t\t\t\t\t</a>-->\r\n                    </td>\r\n                  </template>\r\n                  <!--<td class=\"text-center\">\r\n                  <a class=\"cursor-pointer\">\r\n                    <i class=\"fa fa-trash-o fa-fw text-danger\" (click)=\"ShowAlertModal(sharedVehicleGroupAdmin.shareVehicleGroupAdminHashID)\"></i>\r\n                  </a>\r\n                </td>-->\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"6\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<wego-add-shredvehiclegroup-admin #addSharedVehicleGroupAdminModal (OnSuccessSelect)=\"SuccessAddGroupAdminModal($event)\"></wego-add-shredvehiclegroup-admin>\r\n\r\n<wego-confirm-popup #inActiveModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessInActiveModalClick()\" (onReject)=\"HideInActiveModal()\"></wego-confirm-popup>\r\n\r\n<wego-confirm-popup #resetPasswordModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessResetPasswordModalClick()\" (onReject)=\"HideResetPasswordModal()\"></wego-confirm-popup>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" [popupTitle]=\"popupTitle\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n\r\n<wego-confirm-popup #alertModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessAlertModalClick()\" (onReject)=\"HideAlertModal()\"></wego-confirm-popup>";

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var driver_service_1 = __webpack_require__(570);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var DriverSubscriptionListComponent = (function () {
	    function DriverSubscriptionListComponent(driverService, router, authService, translate) {
	        this.driverService = driverService;
	        this.router = router;
	        this.authService = authService;
	        this.translate = translate;
	    }
	    DriverSubscriptionListComponent.prototype.ngOnInit = function () {
	        this.module = this.translate.instant('LblSubscription');
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = ["sharedVehiclegroup", "subscriptionName", "timeInterval"];
	        this.GetDriverSubscriptionList();
	    };
	    DriverSubscriptionListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetDriverSubscriptionList();
	    };
	    DriverSubscriptionListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetDriverSubscriptionList();
	    };
	    DriverSubscriptionListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetDriverSubscriptionList();
	    };
	    ;
	    DriverSubscriptionListComponent.prototype.OnPagingChange = function (event) {
	        console.log(this.DataListModel);
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetDriverSubscriptionList();
	    };
	    DriverSubscriptionListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.driverService.ExportDriverSubscriptionList(this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "Driver_Subscription" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	        ;
	    };
	    DriverSubscriptionListComponent.prototype.GetDriverSubscriptionList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.driverService.GetDriversSubscriptionDetail(this.DataListModel)
	            .subscribe(function (res) {
	            _this.driverSubscriptionList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    DriverSubscriptionListComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    DriverSubscriptionListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-driver-subscription-list',
	            template: __webpack_require__(774),
	            styles: [".clear-div {\n    clear: both;\n  } "],
	            providers: [driver_service_1.DriverService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof driver_service_1.DriverService !== 'undefined' && driver_service_1.DriverService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object])
	    ], DriverSubscriptionListComponent);
	    return DriverSubscriptionListComponent;
	    var _a, _b, _c, _d;
	}());
	exports.DriverSubscriptionListComponent = DriverSubscriptionListComponent;


/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<section class=\"banner-img-in\">\r\n  <div class=\"banner-in\">\r\n    <div class=\"search-bg-in\">\r\n      <div class=\"container-fluid\">\r\n        <div class=\"row\" style=\"padding-right:15px;\">\r\n          <div class=\"col-md-3 col-sm-6\">\r\n            <h2 class=\"pagename\">{{ breadCrumbList }}</h2>\r\n          </div>\r\n          <div class=\"col-md-4 navbar-right\">\r\n            <div class=\"form-space-top pull-right\">\r\n              <wego-driver-search-list [IsExported]=\"false\" (OnSearch)=\"OnSearch($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\"\r\n                [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-driver-search-list>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n<div class=\"clearfix\"></div>\r\n<section class=\"content\">\r\n  <div class=\"container-fluid mar-top-25\">\r\n    <div class=\"row\">\r\n      <template [ngIf]=\"DataListModel.totalItems == 0 && !isLoading\">\r\n        <div class=\"alert alert-danger\">\r\n          <p class=\"text-center\">\r\n            {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n          </p>\r\n        </div>\r\n      </template>\r\n      <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n        <div class=\"col-md-3\" *ngFor=\"let item of driverSubscriptionList;let i = index\" [ngClass]=\"{'clear-div': i % 4 == 0}\">\r\n          <div class=\"panel price\" [ngClass]=\"{'panel-red': item.isActive, 'panel-grey': !item.isActive}\">\r\n            <div class=\"panel-body text-center mar-top\">\r\n              <img src=\"" + __webpack_require__(604) + "\" class=\"img-responsive center-block\"><strong>\r\n\t\t\t\t\t\t\t</strong>\r\n              <p style=\"font-size:25px;margin-top:5px;margin-bottom:0;\"><strong>{{ item.subscriptionaName }}</strong></p>\r\n            </div>\r\n            <ul class=\"list-group list-group-flush text-center\">\r\n              <li class=\"list-group-item\"><strong>{{ 'LblSharedVehicleGroup' | translate }} :</strong> {{ item.sharedVehiclegroup }}</li>\r\n              <li class=\"list-group-item\">\r\n                <div><strong>{{ 'LblFreeKilometer' | translate }} </strong>/ {{ item.freeKilometerInterval}}</div>\r\n                <div class=\"clearfix\"></div>\r\n                <div><strong>{{ 'LblTotalFreeKilometer' | translate }} : </strong> {{ item.freeKilometer }}</div>\r\n                <div class=\"clearfix\"></div>\r\n                <div *ngIf=\"item.prevFreeKMIntervalStartDate\"><strong>{{ 'LblPrevious' | translate }} ( {{ item.prevFreeKMIntervalStartDate }} {{ 'LblTo' | translate }} {{ item.prevFreeKMIntervalEndDate }} ) :</strong> {{ item.prevRemainingFreeKilometer }}</div>\r\n                <div class=\"clearfix\"></div>\r\n                <div><strong>{{ 'LblCurrent' | translate }} ( {{ item.curFreeKMIntervalStartDate }} {{ 'LblTo' | translate }} {{ item.curFreeKMIntervalEndDate }} ) :</strong> {{ item.curRemainingFreeKilometer }}</div>\r\n              </li>\r\n              <li class=\"list-group-item\">\r\n\r\n                <div><strong><strong>{{ 'LblFreeMinute' | translate }}</strong> </strong>/ {{ item.freeMinuteInterval}}</div>\r\n                <div class=\"clearfix\"></div>\r\n                <div><strong>{{ 'LblTotalFreeMinute' | translate }} : </strong> {{ item.freeMinute}}</div>\r\n                <div class=\"clearfix\"></div>\r\n                <div *ngIf=\"item.prevFreeMinIntervalStartDate\"><strong>{{ 'LblPrevious' | translate }} ( {{ item.prevFreeMinIntervalStartDate }} {{ 'LblTo' | translate }} {{ item.prevFreeMinIntervalEndDate }} ) :</strong>{{ item.prevRemainingFreeMinute }}</div>\r\n                <div class=\"clearfix\"></div>\r\n                <div><strong>{{ 'LblCurrent' | translate }} ( {{ item.curFreeMinIntervalStartDate }} {{ 'LblTo' | translate }} {{ item.curFreeMinIntervalEndDate }} ) :</strong>{{ item.curRemainingFreeMinute }}</div>\r\n              </li>\r\n              <li class=\"list-group-item\">\r\n                <strong>{{ 'LblSubscriptionStartDate' | translate }}:</strong> {{ item.startDatetime }}\r\n                <div class=\"clearfix\"></div>\r\n                <strong *ngIf=\"item.endDatetime\"> {{ 'LblsubscribeEndDate' | translate }}:</strong> {{ item.endDatetime }}\r\n              </li>\r\n            </ul>\r\n            <div *ngIf=\"item.isAmountVisible\" class=\"panel-footer\">\r\n              <p style=\"font-size:25px;margin-top:5px;margin-bottom:0; text-align: center;\">{{ item.amount}}\r\n                <template [ngIf]=\"item.subscriptionaName != 'NO_SUBSCRIPTION'\">\r\n                  / {{ item.timeInterval }}\r\n                </template>\r\n              </p>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </template>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n          [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n          lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>";

/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var flatpickr_model_1 = __webpack_require__(83);
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var driver_service_1 = __webpack_require__(570);
	var sharedvehiclegroup_service_1 = __webpack_require__(510);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var moment = __webpack_require__(84);
	var DriverSVGListComponent = (function () {
	    function DriverSVGListComponent(driverService, router, activeRoute, SVGService, authService, translate) {
	        this.driverService = driverService;
	        this.router = router;
	        this.activeRoute = activeRoute;
	        this.SVGService = SVGService;
	        this.authService = authService;
	        this.translate = translate;
	        this.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
	    }
	    DriverSVGListComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.module = this.translate.instant('LblDriverSVG');
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	        this.diverList = this.translate.instant('LblListPage', [this.translate.instant('LblDriver')]);
	        this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = ["groupName", "organizationName", "subScription"];
	        this.DataListBooking = new config_1.DataListModel();
	        this.DataListBooking.searchField = ["licenceTag", "bookingReferenceID", "driver", "translatedBookingType", "translatedBookingStatus"];
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlDriverSVGList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DRIVER_SVG_LIST);
	        this.urlDriverList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DRIVER_LIST);
	        this.urlSubscriptionUpdate = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SUBSCRIPTION_UPDATE);
	        this.bookingStillRunningMessage = this.translate.instant('LblSubscriptionEndOnBookingEnd');
	        this.sub = this.activeRoute
	            .params
	            .subscribe(function (params) {
	            _this.driverMasterHashId = params['id'] || '';
	            if (_this.driverMasterHashId != '') {
	                _this.GetDriverSVGList();
	            }
	        });
	        this.GetDriverName();
	        this.addSubscriptionLink = new config_1.WeGoAuthorizedLink("", config_1.Permission.PR_DRIVER_SHARED_VEHICLE_GROUP_OVERVIEW, config_1.PermissionType.INSERT, 'btn btn-highlight navbar-right', 'LblAddNew');
	    };
	    DriverSVGListComponent.prototype.SetDefaultFlatPickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.minDate = new Date(new Date().setHours(0, 0, 0));
	        flatPickrConfig.dateFormat = this.dateFormat;
	        flatPickrConfig.minuteIncrement = 1;
	        return flatPickrConfig;
	    };
	    DriverSVGListComponent.prototype.GetDriverSVGList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.driverService.GetDriverSVGList(this.driverMasterHashId, this.DataListModel)
	            .subscribe(function (res) {
	            _this.driverSVGList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    DriverSVGListComponent.prototype.GetDriverName = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.driverService.GetDriverByHashId(this.driverMasterHashId)
	            .subscribe(function (res) {
	            _this.driverFName = res.data.firstName;
	            _this.driverLName = res.data.lastName;
	            _this.driverName = res.data.driverName;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    DriverSVGListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetDriverSVGList();
	    };
	    DriverSVGListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetDriverSVGList();
	    };
	    DriverSVGListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetDriverSVGList();
	    };
	    ;
	    DriverSVGListComponent.prototype.OnPagingChange = function (event) {
	        console.log(this.DataListModel);
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetDriverSVGList();
	    };
	    DriverSVGListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.driverService.ExportDriverSVGList(this.driverMasterHashId)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "Driver_SVG" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    DriverSVGListComponent.prototype.UnsubscribeDriverSVG = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.driverService.UnsubscribeDriverSVG(this.sharedvehiclegroupDriverHashId, this.subScriptionEndDate)
	            .subscribe(function (res) {
	            _this.DataListModel.currentPage = 1;
	            _this.GetDriverSVGList();
	            _this.popupMsg = _this.translate.instant('LblUnscubscribeSuccess');
	            _this.ShowSuccessPopup();
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    DriverSVGListComponent.prototype.OnSortBooking = function (sortName) {
	        this.DataListBooking.sortType = sortName;
	        this.DataListBooking.sortReverse = !this.DataListBooking.sortReverse;
	        this.GetAffectedSubscriptionBookingListForSearch();
	    };
	    DriverSVGListComponent.prototype.OnSearchBooking = function (event) {
	        this.DataListBooking.searchTerm = event.searchTerm;
	        this.DataListBooking.currentPage = 1;
	        this.GetAffectedSubscriptionBookingListForSearch();
	    };
	    DriverSVGListComponent.prototype.OnPageChangedBooking = function (event) {
	        this.DataListBooking.currentPage = event.page;
	        this.GetAffectedSubscriptionBookingListForSearch();
	    };
	    ;
	    DriverSVGListComponent.prototype.CheckBookingInRunningStage = function (sharedvehiclegroupHashId) {
	        var _this = this;
	        this.driverService.CheckBookingInRunningStage(sharedvehiclegroupHashId, this.driverMasterHashId)
	            .subscribe(function (res) {
	            if (res.totalRecords == 0 && res.data == false) {
	                _this.alertModal.show();
	            }
	            else {
	                _this.confirmRunningModal.show();
	            }
	        });
	    };
	    DriverSVGListComponent.prototype.ConfirmDeleteModalClick = function () {
	        this.subScriptionEndDate = moment().format('DD-MM-YYYY HH:mm');
	        this.HideDeleteModalClick();
	        this.GetAffectedSubscriptionBookingList();
	    };
	    DriverSVGListComponent.prototype.HideDeleteModalClick = function () {
	        this.confirmRunningModal.hide();
	    };
	    DriverSVGListComponent.prototype.GetAffectedSubscriptionBookingList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.driverService.GetAffectedSubscriptionBookingList(this.sharedvehiclegroupDriverHashId, this.subScriptionEndDate, this.DataListBooking)
	            .subscribe(function (res) {
	            if (res.totalRecords > 0) {
	                _this.bookingList = res.data;
	                _this.DataListBooking.totalItems = res.totalRecords;
	                _this.DataListBooking.infoMessage = res.error;
	                _this.affectedbookingModal.show();
	                _this.isLoading = false;
	            }
	            else {
	                // this.alertModal.show();
	                _this.UnsubscribeDriverSVG();
	                _this.isLoading = false;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    DriverSVGListComponent.prototype.OnConfirm = function () {
	        this.UnsubscribeDriverSVG();
	        this.affectedbookingModal.hide();
	    };
	    DriverSVGListComponent.prototype.ShowAlertModal = function (sharedvehiclegroupDriverHashId, sharedvehiclegroupHashId) {
	        this.sharedvehiclegroupDriverHashId = sharedvehiclegroupDriverHashId;
	        this.subScriptionEndDate = '';
	        this.subscriptionvalidationMessage = '';
	        this.CheckBookingInRunningStage(sharedvehiclegroupHashId);
	    };
	    DriverSVGListComponent.prototype.HideAlertModal = function () {
	        this.alertModal.hide();
	    };
	    DriverSVGListComponent.prototype.SuccessAlertModalClick = function () {
	        if (this.subScriptionEndDate) {
	            this.GetAffectedSubscriptionBookingList();
	            this.alertModal.hide();
	        }
	        else {
	            this.subscriptionvalidationMessage = this.translate.instant('LblSubscriptionEndDateError');
	        }
	    };
	    DriverSVGListComponent.prototype.ShowSubscriptionDetailModal = function (sharedvehiclegroupDriverHashId) {
	        this.sharedvehiclegroupDriverHashId = sharedvehiclegroupDriverHashId;
	        this.GetDriverSubscriptionDetail();
	        this.subscriptionDetailModal.show();
	    };
	    DriverSVGListComponent.prototype.HideSubscriptionDetailModal = function () {
	        this.subscriptionDetailModal.hide();
	    };
	    DriverSVGListComponent.prototype.GetDriverSubscriptionDetail = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.driverService.GetDriverSubscriptionDetail(this.sharedvehiclegroupDriverHashId)
	            .subscribe(function (res) {
	            _this.driverSubscription = res.data;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    // Assign shred vehicle group to driver
	    DriverSVGListComponent.prototype.ShowAssignDriverGroupModal = function () {
	        this.assignDriverGroupModal.driverMasterHashId = this.driverMasterHashId;
	        this.assignDriverGroupModal.show();
	    };
	    DriverSVGListComponent.prototype.SuccessAssignDriverGroupModal = function ($event) {
	        this.GetDriverSVGList();
	        this.popupMsg = this.translate.instant('LblRecordAddedSuccess', [this.module]); //$event.SuccessMessage;
	        this.ShowSuccessPopup();
	    };
	    DriverSVGListComponent.prototype.OnCancel = function () {
	        this.affectedbookingModal.hide();
	    };
	    DriverSVGListComponent.prototype.OnCancelSubscriptionInformation = function () {
	        this.subscriptionDetailModal.hide();
	    };
	    DriverSVGListComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    DriverSVGListComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    DriverSVGListComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    DriverSVGListComponent.prototype.GetAffectedSubscriptionBookingListForSearch = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.driverService.GetAffectedSubscriptionBookingList(this.sharedvehiclegroupDriverHashId, this.subScriptionEndDate, this.DataListBooking)
	            .subscribe(function (res) {
	            _this.bookingList = res.data;
	            _this.DataListBooking.totalItems = res.totalRecords;
	            _this.DataListBooking.infoMessage = res.error;
	            _this.affectedbookingModal.show();
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    DriverSVGListComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    __decorate([
	        core_1.ViewChild('alertModal'), 
	        __metadata('design:type', Object)
	    ], DriverSVGListComponent.prototype, "alertModal", void 0);
	    __decorate([
	        core_1.ViewChild('assignDriverGroupModal'), 
	        __metadata('design:type', Object)
	    ], DriverSVGListComponent.prototype, "assignDriverGroupModal", void 0);
	    __decorate([
	        core_1.ViewChild('affectedbookingModal'), 
	        __metadata('design:type', Object)
	    ], DriverSVGListComponent.prototype, "affectedbookingModal", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], DriverSVGListComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild('subscriptionDetailModal'), 
	        __metadata('design:type', Object)
	    ], DriverSVGListComponent.prototype, "subscriptionDetailModal", void 0);
	    __decorate([
	        core_1.ViewChild('ConfirmRunningModal'), 
	        __metadata('design:type', Object)
	    ], DriverSVGListComponent.prototype, "confirmRunningModal", void 0);
	    DriverSVGListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-driver-svg-list',
	            template: __webpack_require__(776),
	            providers: [driver_service_1.DriverService, sharedvehiclegroup_service_1.SharedVehicleGroupService],
	            styles: ["\n\n        .mynewclassclose {\n            position: absolute;\n            top: -4px;\n            right: -4px;\n            opacity: 1;\n        }\n        .mynewclassclose:hover {\n            opacity: 1;\n        }\n        .disCard {\n            box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);\n            transition: 0.3s;\n            width: 100%;\n            margin-bottom: 10px;\n        }\n        \n        .disCard:hover {\n            box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);\n        }\n                \n        .disCard .titleBox {\n            background-color: #2ba2aa;\n            color: #ffffff;\n            padding: 15px 15px;\n            text-align: center;\n        }\n        .disCard .titleBox h1 {\n            font-size: 28px;\n            font-style: normal;\n            font-weight: 600;\n        }"]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof driver_service_1.DriverService !== 'undefined' && driver_service_1.DriverService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof sharedvehiclegroup_service_1.SharedVehicleGroupService !== 'undefined' && sharedvehiclegroup_service_1.SharedVehicleGroupService) === 'function' && _d) || Object, (typeof (_e = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _e) || Object, (typeof (_f = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _f) || Object])
	    ], DriverSVGListComponent);
	    return DriverSVGListComponent;
	    var _a, _b, _c, _d, _e, _f;
	}());
	exports.DriverSVGListComponent = DriverSVGListComponent;


/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ breadCrumbList}} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"urlDriverList\">\r\n            <i class=\"fa fa-male fa-fw\"></i> {{ diverList }}</a>\r\n        </li>\r\n        <li class=\"active\"> {{ breadCrumbList}} </li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25 \">\r\n      <wego-authorized-link [LinkModel]=\"addSubscriptionLink\" (onClick)=\"ShowAssignDriverGroupModal()\"></wego-authorized-link>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <h4>\r\n          <label>{{ 'LblDriver' | translate }} : </label>\r\n          <label> {{driverName}} </label>\r\n        </h4>\r\n        <p class=\"text-success\">{{ message }}</p>\r\n        <wego-search-list (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('organizationName')\">\r\n                  {{ 'LblOrganizationName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'organizationName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('groupName')\">\r\n                  {{ 'LblSharedVehicleGroup' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'groupName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('subScription')\">\r\n                  {{ 'LblSubscription' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'subScription'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('subscriptionStartDateTimeUTC')\">\r\n                  {{ 'LblSubscriptionStartDate' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'subscriptionStartDateTimeUTC'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('subscriptionEndDatetimeUTC')\">\r\n                  {{ 'LblsubscribeEndDate' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'subscriptionEndDatetimeUTC'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"text-center\">\r\n                  {{ 'LblUnsubscribe' | translate }}\r\n                </th>\r\n                <th class=\"text-center\">{{ 'LblInformation' | translate }}</th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let driverSVGList of driverSVGList\">\r\n                  <td>{{ driverSVGList.organizationName }}</td>\r\n                  <td>{{ driverSVGList.groupName }}</td>\r\n                  <td>\r\n                    <span *ngIf=\"!driverSVGList.isSubscriptionEditEnable || !driverSVGList.issvgSubscriptionAccess\">\r\n                      {{ driverSVGList.subScription }}\r\n                    </span>\r\n                    <a *ngIf=\"driverSVGList.isSubscriptionEditEnable && driverSVGList.issvgSubscriptionAccess\" [routerLink]=\"[urlSubscriptionUpdate, { subscriptionHashId : driverSVGList.sharedVehicleSubscriptionHashId ,sharedVehicleGroupHashId : driverSVGList.sharedvehiclegroupHashId}]\">\r\n                      {{ driverSVGList.subScription }}\r\n                    </a>\r\n                  </td>\r\n                  <td>{{ driverSVGList.subscriptionStartDatetime }}</td>\r\n                  <td *ngIf=\"!driverSVGList.markedForDeletion  || driverSVGList.subscriptionEndDatetime \">{{ driverSVGList.subscriptionEndDatetime }}</td>\r\n                  <td *ngIf=\"driverSVGList.markedForDeletion && !driverSVGList.subscriptionEndDatetime\">{{ 'LblMarkedForDeletion' | translate }}</td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"driverSVGList.isSubscriptionDeletable && !driverSVGList.subscriptionEndDatetime && !driverSVGList.markedForDeletion\" class=\"cursor-pointer btn btn-xs\" [ngClass]=\"{'btn-active': driverSVGList.subscriptionEndDatetime, 'btn-inactive': !driverSVGList.subscriptionEndDatetime}\"\r\n                      (click)=\"ShowAlertModal(driverSVGList.sharedVehicleGroupDriverHashId, driverSVGList.sharedvehiclegroupHashId)\">\r\n                      {{ 'LblUnsubscribe' | translate}}</a>\r\n                  </td>\r\n                  <td class=\"text-center\" *ngIf=\"driverSVGList.issvgSubscriptionAccess\">\r\n                    <a class=\"cursor-pointer\" title=\"{{'LblSubscriptionInfo' | translate}}\" (click)=\"ShowSubscriptionDetailModal(driverSVGList.sharedVehicleGroupDriverHashId)\">\r\n                      <i class=\"fa fa-eye fa-fw\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\" *ngIf=\"!driverSVGList.issvgSubscriptionAccess\"></td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"7\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<div bsModal #alertModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\"\r\n  [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-sm\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"HideAlertModal()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblConfirm' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        {{ 'LblConfirmUnsubscribe' | translate }}\r\n        <br/>\r\n        <br/>\r\n        <div class=\"input-group\">\r\n          <span class=\"input-group-addon\">\r\n            <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n          </span>\r\n          <input flatpickr readonly [Config]=\"flatPickrConfigFrom\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblsubscribeEndDate' | translate }}\"\r\n            [(ngModel)]=\"subScriptionEndDate\" name=\"dayEndTime\" maxlength=\"100\">\r\n        </div>\r\n        <span class=\"text text-danger\">{{ subscriptionvalidationMessage }}</span>\r\n        <span *ngIf=\"BookingRunning\" class=\"text text-danger\">{{ 'LblSubscriptionEndOnBookingEnd' | translate }}</span>\r\n\r\n      </div>\r\n      <div class=\"modal-footer\">\r\n        <button type=\"button\" class=\"btn btn-green\" (click)=\"SuccessAlertModalClick()\">{{ 'LblYes' | translate }}</button>\r\n        <button type=\"button\" class=\"btn btn-gray cursor-pointer\" (click)=\"HideAlertModal()\">{{ 'LblNo' | translate }}</button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<!--Added for affectedbooking-->\r\n<div bsModal #affectedbookingModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"OnCancel()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\"> {{ 'LblAffectedBookingList' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <wego-search-list (OnSearch)=\"OnSearchBooking($event)\" [IsExported]=\"false\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSortBooking('BookingReferenceId')\">\r\n                  {{ 'LblReference' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'BookingReferenceId'\" [SortType]=\"DataListBooking.sortType\" [SortReverse]=\"DataListBooking.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSortBooking('licenceTag')\">\r\n                  {{ 'LblVehicle' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'licenceTag'\" [SortType]=\"DataListBooking.sortType\" [SortReverse]=\"DataListBooking.sortReverse\"></wego-sort-list>\r\n                </th>\r\n\r\n                <th class=\"cursor-pointer\" (click)=\"OnSortBooking('translatedBookingStatus')\">\r\n                  {{ 'LblStatus' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'translatedBookingStatus'\" [SortType]=\"DataListBooking.sortType\" [SortReverse]=\"DataListBooking.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSortBooking('translatedBookingType')\">\r\n                  {{ 'LblType' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'translatedBookingType'\" [SortType]=\"DataListBooking.sortType\" [SortReverse]=\"DataListBooking.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSortBooking('startDateTimeUTC')\">\r\n                  {{ 'LblFrom' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'startDateTime'\" [SortType]=\"DataListBooking.sortType\" [SortReverse]=\"DataListBooking.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSortBooking('endDateTimeUTC')\">\r\n                  {{ 'LblTo' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'endDateTime'\" [SortType]=\"DataListBooking.sortType\" [SortReverse]=\"DataListBooking.sortReverse\"></wego-sort-list>\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListBooking.totalItems != 0\">\r\n                <tr *ngFor=\"let bookings of bookingList\">\r\n                  <td>{{ bookings.bookingReferenceID }}</td>\r\n                  <td>{{ bookings.licenceTag }}</td>\r\n                  <td>{{ bookings.translatedBookingStatus }}</td>\r\n                  <td>{{ bookings.translatedBookingType }}</td>\r\n                  <td>{{ bookings.startDateTime}}</td>\r\n                  <td>{{ bookings.endDateTime }}</td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListBooking.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"6\">\r\n                  {{ DataListBooking.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListBooking.totalItems\" [itemsPerPage]=\"DataListBooking.itemsPerPage\" [(ngModel)]=\"DataListBooking.currentPage\"\r\n                [maxSize]=\"DataListBooking.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChangedBooking($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n      </div>\r\n      <div class=\"modal-footer\">\r\n        <button type=\"button\" (click)=\"OnCancel()\" class=\"btn btn-gray cursor-pointer\" data-dismiss=\"modal\">{{ 'LblCancel' | translate }}</button>\r\n        <button type=\"button\" (click)=\"OnConfirm()\" class=\"btn btn-green\"> {{'LblConfirm' | translate}}</button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<!--end-->\r\n\r\n<!--Dilog box for Subscription Details-->\r\n<div bsModal #subscriptionDetailModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-sm\">\r\n    <div class=\"modal-content disCard\">\r\n      <div>\r\n        <button type=\"button\" class=\"close mynewclassclose\" data-dismiss=\"modal\" aria-hidden=\"true\" (click)=\"HideSubscriptionDetailModal()\">\r\n          <i class=\"fa fa-times-circle\" aria-hidden=\"true\" style=\"color: white;\"></i>\r\n        </button>\r\n      </div>\r\n      <div class=\"panel price panel-red\">\r\n        <div class=\"titleBox text-center\">\r\n          <img src=\"" + __webpack_require__(604) + "\" class=\"img-responsive center-block\">\r\n          <strong></strong>\r\n          <h1>{{ driverSubscription?.subscriptionaName }}</h1>\r\n        </div>\r\n\r\n        <ul class=\"list-group list-group-flush text-center\">\r\n          <li class=\"list-group-item\">\r\n            <strong>{{ 'LblSharedVehicleGroup' | translate }} :</strong> {{ driverSubscription?.sharedVehiclegroup }}</li>\r\n          <li class=\"list-group-item\">\r\n            <div>\r\n              <strong>{{ 'LblFreeKilometer' | translate }} </strong>/ {{ driverSubscription?.freeKilometerInterval }}</div>\r\n            <div class=\"clearfix\"></div>\r\n            <div>\r\n              <strong>{{ 'LblTotalFreeKilometer' | translate }} : </strong> {{ driverSubscription?.freeKilometer | decimalFormatter\r\n              }}\r\n            </div>\r\n            <div class=\"clearfix\"></div>\r\n            <div *ngIf=\"driverSubscription?.prevFreeKMIntervalStartDate\">\r\n              <strong>{{ 'LblPrevious' | translate }} ( {{ driverSubscription?.prevFreeKMIntervalStartDate }} {{ 'LblTo' | translate\r\n                }} {{ driverSubscription?.prevFreeKMIntervalEndDate }} ) :</strong> {{ driverSubscription?.prevRemainingFreeKilometer\r\n              | decimalFormatter }}\r\n            </div>\r\n            <div class=\"clearfix\"></div>\r\n            <div>\r\n              <strong>{{ 'LblCurrent' | translate }} ( {{ driverSubscription?.curFreeKMIntervalStartDate }} {{ 'LblTo' | translate\r\n                }} {{ driverSubscription?.curFreeKMIntervalEndDate }} ) :</strong> {{ driverSubscription?.curRemainingFreeKilometer\r\n              | decimalFormatter }}\r\n            </div>\r\n          </li>\r\n          <li class=\"list-group-item\">\r\n\r\n            <div>\r\n              <strong>\r\n                <strong>{{ 'LblFreeMinute' | translate }}</strong>\r\n              </strong>/ {{ driverSubscription?.freeMinuteInterval }}\r\n            </div>\r\n            <div class=\"clearfix\"></div>\r\n            <div>\r\n              <strong>{{ 'LblTotalFreeMinute' | translate }} : </strong> {{ driverSubscription?.freeMinute | decimalFormatter }}\r\n            </div>\r\n            <div class=\"clearfix\"></div>\r\n            <div *ngIf=\"driverSubscription?.prevFreeMinIntervalStartDate\">\r\n              <strong>{{ 'LblPrevious' | translate }} ( {{ driverSubscription?.prevFreeMinIntervalStartDate }} {{ 'LblTo' | translate\r\n                }} {{ driverSubscription?.prevFreeMinIntervalEndDate }} ) :</strong> {{ driverSubscription?.prevRemainingFreeMinute\r\n              | decimalFormatter }}\r\n            </div>\r\n            <div class=\"clearfix\"></div>\r\n            <div>\r\n              <strong>{{ 'LblCurrent' | translate }} ( {{ driverSubscription?.curFreeMinIntervalStartDate }} {{ 'LblTo' | translate\r\n                }} {{ driverSubscription?.curFreeMinIntervalEndDate }} ) :</strong> {{ driverSubscription?.curRemainingFreeMinute\r\n              | decimalFormatter }}\r\n            </div>\r\n          </li>\r\n          <li class=\"list-group-item\">\r\n            <strong>{{ 'LblSubscriptionStartDate' | translate }}:</strong> {{ driverSubscription?.startDatetime }}\r\n            <div class=\"clearfix\"></div>\r\n            <strong *ngIf=\"driverSubscription?.endDatetime\"> {{ 'LblsubscribeEndDate' | translate }}:</strong> {{ driverSubscription?.endDatetime }}\r\n          </li>\r\n        </ul>\r\n\r\n        <div class=\"panel-footer\">\r\n          <p style=\"font-size:25px;margin-top:5px;margin-bottom:0; text-align: center;\">{{ driverSubscription?.amount | decimalFormatter }}\r\n            <template [ngIf]=\"driverSubscription?.subscriptionaName != 'NO_SUBSCRIPTION'\">/ {{ driverSubscription?.timeInterval }}</template>\r\n          </p>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<!--end-->\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<wego-assign-driver-group-popup #assignDriverGroupModal (OnSuccessSelect)=\"SuccessAssignDriverGroupModal($event)\"></wego-assign-driver-group-popup>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n<wego-confirm-popup #ConfirmRunningModal [popupMsg]=\"bookingStillRunningMessage\" (onConfirm)=\"ConfirmDeleteModalClick()\"\r\n  (onReject)=\"HideDeleteModalClick()\"></wego-confirm-popup>";

/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var driver_model_1 = __webpack_require__(601);
	var translate_service_1 = __webpack_require__(70);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var driver_service_1 = __webpack_require__(570);
	var sharedvehiclegroup_service_1 = __webpack_require__(510);
	var AssignDriverGroupPopupComponent = (function () {
	    function AssignDriverGroupPopupComponent(driverService, SVGService, router, translate, authService) {
	        this.driverService = driverService;
	        this.SVGService = SVGService;
	        this.router = router;
	        this.translate = translate;
	        this.authService = authService;
	        this.onSuccessSelect = new core_1.EventEmitter();
	    }
	    AssignDriverGroupPopupComponent.prototype.ngOnInit = function () {
	        this.module = this.translate.instant('LblSharedVehicleGroup');
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.searchField = ["groupName", "organizationName"];
	    };
	    AssignDriverGroupPopupComponent.prototype.ngOnChanges = function (change) {
	        console.log(change);
	    };
	    AssignDriverGroupPopupComponent.prototype.show = function () {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.sortType = "";
	        this.DataListModel.sortReverse = null;
	        this.DataListModel.searchTerm = "";
	        this.DataListModel.infoMessage = "";
	        this.GetSVGListForDrivers();
	        this.driverModal.show();
	        this.subscriptionHashId = '';
	    };
	    AssignDriverGroupPopupComponent.prototype.hide = function () {
	        this.driverModal.hide();
	    };
	    AssignDriverGroupPopupComponent.prototype.GetSVGListForDrivers = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.SVGService.GetSVGListForDrivers(this.driverMasterHashId, this.DataListModel)
	            .subscribe(function (res) {
	            _this.sharedVehicleGroupList = res.data;
	            _this.sharedVehicleGroupList.forEach(function (x) {
	                x.selectedOrganizationSubscription = x.listOfSubscription[0].organizationSubscriptionHashId;
	            });
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AssignDriverGroupPopupComponent.prototype.select = function (sharedvehiclegroupHashId, organizationHashId) {
	        var _this = this;
	        this.isLoading = true;
	        var model = new driver_model_1.SVGdriverModel();
	        model.driverHashId = this.driverMasterHashId;
	        model.sharedvehiclegroupHashId = sharedvehiclegroupHashId;
	        var subsModel = this.sharedVehicleGroupList.find(function (x) { return x.organizationMasterHashId == organizationHashId && x.sharedvehiclegroupHashId == sharedvehiclegroupHashId; });
	        model.organizationSubscriptionHashId = subsModel.selectedOrganizationSubscription;
	        this.driverService.AssignSVGToDriver(model)
	            .subscribe(function (res) {
	            _this.popupMsg = _this.translate.instant('LblRecordAddedSuccess', [_this.module]);
	            _this.OnSuccessSelect();
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        }, function () {
	            _this.driverModal.hide();
	            _this.isLoading = false;
	        });
	    };
	    AssignDriverGroupPopupComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetSVGListForDrivers();
	    };
	    AssignDriverGroupPopupComponent.prototype.OnSearch = function (event) {
	        this.DataListModel.searchTerm = event.searchTerm;
	        this.DataListModel.currentPage = 1;
	        this.GetSVGListForDrivers();
	    };
	    AssignDriverGroupPopupComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetSVGListForDrivers();
	    };
	    ;
	    AssignDriverGroupPopupComponent.prototype.OnPagingChange = function (event) {
	        console.log(this.DataListModel);
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetSVGListForDrivers();
	    };
	    AssignDriverGroupPopupComponent.prototype.OnSuccessSelect = function () {
	        this.onSuccessSelect.emit({ SuccessMessage: this.popupMsg });
	    };
	    AssignDriverGroupPopupComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    AssignDriverGroupPopupComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    AssignDriverGroupPopupComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    __decorate([
	        core_1.Output('OnSuccessSelect'), 
	        __metadata('design:type', Object)
	    ], AssignDriverGroupPopupComponent.prototype, "onSuccessSelect", void 0);
	    __decorate([
	        core_1.ViewChild('driverModal'), 
	        __metadata('design:type', Object)
	    ], AssignDriverGroupPopupComponent.prototype, "driverModal", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], AssignDriverGroupPopupComponent.prototype, "successPopup", void 0);
	    AssignDriverGroupPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-assign-driver-group-popup',
	            template: __webpack_require__(778),
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof driver_service_1.DriverService !== 'undefined' && driver_service_1.DriverService) === 'function' && _a) || Object, (typeof (_b = typeof sharedvehiclegroup_service_1.SharedVehicleGroupService !== 'undefined' && sharedvehiclegroup_service_1.SharedVehicleGroupService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object, (typeof (_e = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _e) || Object])
	    ], AssignDriverGroupPopupComponent);
	    return AssignDriverGroupPopupComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.AssignDriverGroupPopupComponent = AssignDriverGroupPopupComponent;


/***/ },
/* 778 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #driverModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\"\r\n  [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblAssign' | translate }} {{ 'LblSharedVehicleGroup' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <wego-search-list [IsExported]=\"false\" [SearchTerm]=\"DataListModel.searchTerm\" (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\"\r\n          (OnPagingChange)=\"OnPagingChange($event)\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center\">\r\n                  {{ 'LblSelect' | translate }}\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('organizationName')\">\r\n                  {{ 'LblOrganization' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'organizationName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('groupName')\">\r\n                  {{ 'LblSharedVehicleGroup' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'groupName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th>\r\n                  {{ 'LblSubscription' | translate }}\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let driverSVGList of sharedVehicleGroupList\">\r\n                  <td class=\"text-center\">\r\n                    <a class=\"cursor-pointer\" (click)=\"select(driverSVGList.sharedvehiclegroupHashId,driverSVGList.organizationMasterHashId)\">\r\n                      <i class=\"fa fa-plus-square\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td>{{ driverSVGList.organizationName }}</td>\r\n                  <td>{{ driverSVGList.groupName }}</td>\r\n                  <td>\r\n                    <select class=\"form-control\" name=\"subscriptionHash\" [(ngModel)]=\"driverSVGList.selectedOrganizationSubscription\">\r\n                      <option *ngFor=\"let item of driverSVGList.listOfSubscription\" [ngValue]=\"item.organizationSubscriptionHashId\">{{ item.name }}</option>\r\n                    </select>\r\n                  </td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0\">\r\n                <td class=\"text-center text-danger\" colspan=\"4\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>";

/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var translate_service_1 = __webpack_require__(70);
	var router_1 = __webpack_require__(26);
	var core_1 = __webpack_require__(3);
	var config_1 = __webpack_require__(60);
	var template_service_1 = __webpack_require__(663);
	var config_2 = __webpack_require__(60);
	var TemplateListComponent = (function () {
	    function TemplateListComponent(templateService, translateService, authService, router) {
	        this.templateService = templateService;
	        this.translateService = translateService;
	        this.authService = authService;
	        this.router = router;
	        this.roleLevel = config_2.RoleLevel;
	    }
	    Object.defineProperty(TemplateListComponent.prototype, "isAnyChecked", {
	        get: function () {
	            if (this.templateList) {
	                var isCheck = this.templateList.some(function (x) { return x.isChecked == true; });
	                if (isCheck) {
	                    if (this.templateList.every(function (x) { return x.isChecked == true || (x.customerHashId ? true : false) == false; }))
	                        this.isParentCheck = true;
	                    else
	                        this.isParentCheck = false;
	                }
	                else {
	                    this.isParentCheck = false;
	                }
	                return isCheck;
	            }
	            else {
	                this.isParentCheck = false;
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TemplateListComponent.prototype, "isAnyDeletable", {
	        get: function () {
	            if (this.templateList) {
	                return this.templateList.some(function (x) { return (x.customerHashId ? true : false) == true; });
	            }
	            return false;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TemplateListComponent.prototype, "isDeleteAccess", {
	        get: function () {
	            if (this.templateList) {
	                return this.templateList.some(function (x) { return x.isDeletable; });
	            }
	            else {
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    TemplateListComponent.prototype.ngOnInit = function () {
	        this.module = this.translateService.instant('LblTemplate');
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        if (this.authService.GetHighestRoleLevel() <= this.roleLevel.Customer) {
	            this.DataListModel.searchField = ["templateName", "subjectHTml", "instanceName", "customerName", "companyName", "sharedVehicleGroupName", "organizationName"];
	        }
	        else if (this.authService.GetHighestRoleLevel() <= this.roleLevel.Instance) {
	            this.DataListModel.searchField = ["templateName", "subjectHTml", "instanceName", "companyName", "sharedVehicleGroupName", "organizationName"];
	        }
	        else if (this.authService.GetHighestRoleLevel() <= this.roleLevel.Company) {
	            this.DataListModel.searchField = ["templateName", "subjectHTml", "companyName", "sharedVehicleGroupName", "organizationName"];
	        }
	        else if (this.authService.GetHighestRoleLevel() <= this.roleLevel.Organization) {
	            this.DataListModel.searchField = ["templateName", "subjectHTml", "organizationName"];
	        }
	        else {
	            this.DataListModel.searchField = ["templateName", "subjectHTml", "sharedVehicleGroupName", "organizationName"];
	        }
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlTemplateUpdatePage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_TEMPLATE_UPDATE);
	        this.urlTemplateADDPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_TEMPLATE_ADD);
	        this.GetTemplateList();
	        this.addTemplateLink = new config_1.WeGoAuthorizedLink(this.urlTemplateADDPage, config_1.Permission.PR_TEMPLATES, config_1.PermissionType.INSERT, 'btn btn-highlight navbar-right', 'LblAddNew');
	    };
	    TemplateListComponent.prototype.GetTemplateList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.templateService.GetTemplateList(this.DataListModel)
	            .subscribe(function (res) {
	            _this.templateList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	            _this.templateList = [];
	        });
	    };
	    TemplateListComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetTemplateList();
	    };
	    TemplateListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetTemplateList();
	    };
	    TemplateListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetTemplateList();
	    };
	    TemplateListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetTemplateList();
	    };
	    ;
	    TemplateListComponent.prototype.OnExport = function (event) {
	        // this.isLoading = true;
	        // this.templateService.ExportInstanceList(this.DataListModel)
	        //   .subscribe(
	        //   res => {
	        //     if (res && res._body) {
	        //       let fileName = "Template" + new Date().toISOString() + ".csv";
	        //       this.authService.DownloadFile(fileName, res._body);
	        //     }
	        //     this.isLoading = false;
	        //   },
	        //   error => {
	        //     this.HandleErrorStatusCode(error);
	        //     this.isLoading = false;
	        //   });
	    };
	    TemplateListComponent.prototype.OnParentCheck = function (isChecked) {
	        this.templateList.filter(function (x) { return x.isDeletable; }).forEach(function (x) { return x.isChecked = (isChecked && x.instanceHashId ? true : false); });
	    };
	    TemplateListComponent.prototype.ShowChildModal = function (templateHashId) {
	        if (templateHashId) {
	            this.popupMsg = this.translateService.instant('LblRecordDeleteConfirmation', [this.module]);
	            this.isMultipleDelete = false;
	            this.deleteVehicleMasterHashId = templateHashId;
	        }
	        else {
	            this.popupMsg = this.translateService.instant('LblRecordMultiplDeleteConfirmation', [this.module]);
	            this.isMultipleDelete = true;
	        }
	        this.childModal.show();
	    };
	    TemplateListComponent.prototype.HideChildModal = function () {
	        this.deleteVehicleMasterHashId = "";
	        this.childModal.hide();
	    };
	    TemplateListComponent.prototype.SuccessModalClick = function () {
	        var deletedVehicleList;
	        if (this.isMultipleDelete)
	            deletedVehicleList = this.templateList.filter(function (x) { return x.isChecked; }).map(function (x) { return x.templateHashID; });
	        else
	            deletedVehicleList.push(this.deleteVehicleMasterHashId);
	        this.DeleteTemplate(deletedVehicleList);
	        this.childModal.hide();
	    };
	    TemplateListComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    TemplateListComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    TemplateListComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    TemplateListComponent.prototype.DeleteTemplate = function (deletedTemplateList) {
	        var _this = this;
	        this.isLoading = true;
	        this.templateService.DeleteTemplates(deletedTemplateList)
	            .subscribe(function (res) {
	            _this.DataListModel.currentPage = 1;
	            _this.GetTemplateList();
	            _this.popupMsg = _this.translateService.instant('LblRecordRemovedSuccess', [_this.module]);
	            _this.ShowSuccessPopup();
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    TemplateListComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], TemplateListComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild('childModal'), 
	        __metadata('design:type', Object)
	    ], TemplateListComponent.prototype, "childModal", void 0);
	    TemplateListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-template-list',
	            template: __webpack_require__(780),
	            providers: [template_service_1.TemplateService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof template_service_1.TemplateService !== 'undefined' && template_service_1.TemplateService) === 'function' && _a) || Object, (typeof (_b = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object])
	    ], TemplateListComponent);
	    return TemplateListComponent;
	    var _a, _b, _c, _d;
	}());
	exports.TemplateListComponent = TemplateListComponent;


/***/ },
/* 780 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{'LblTemplateList' | translate }}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li><a [routerLink]=\"urlDefaultPage\"><i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a></li>\r\n        <li class=\"active\">{{'LblTemplateList' | translate }}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-12 mar_t_25 \">\r\n      <wego-authorized-link [LinkModel]=\"addTemplateLink\"></wego-authorized-link>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <wego-search-list (OnSearch)=\"OnSearch($event)\" [IsExported]=\"false\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\"\r\n          [SearchTerm]=\"DataListModel.searchTerm\" [ItemPerPage]=\"DataListModel.itemsPerPage\" [IsDeleted]=\"isDeleteAccess\" [IsDeleteEnabled]=\"isAnyChecked\"\r\n          (OnDeleteAll)=\"ShowChildModal()\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center parent-checkbox\">\r\n                  <input [disabled]=\"!isAnyDeletable\" type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\"></th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('templateName')\">\r\n                  {{'LblTemplateName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'templateName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n\r\n                <!-- <th class=\"cursor-pointer\" (click)=\"OnSort('templateType')\">\r\n                  {{'LblTemplateType' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'templateType'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th> -->\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('subjectHTml')\">\r\n                  {{'LblSubject' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'subjectHTml'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                \r\n                <th *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Customer\" class=\"cursor-pointer\" (click)=\"OnSort('customerName')\">\r\n                  {{'LblCustomer' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'customerName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n\r\n                <th *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Instance\" class=\"cursor-pointer\" (click)=\"OnSort('instanceName')\">\r\n                  {{'LblInstance' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'instanceName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n\r\n                <th *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Company\" class=\"cursor-pointer\" (click)=\"OnSort('companyName')\">\r\n                  {{'LblCompany' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'companyName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                \r\n                <th *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.SVG\" class=\"cursor-pointer\" (click)=\"OnSort('sharedVehicleGroupName')\">\r\n                  {{'LblSharedVehicleGroup' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'sharedVehicleGroupName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                \r\n                <th *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Organization\" class=\"cursor-pointer\" (click)=\"OnSort('organizationName')\">\r\n                  {{'LblOrganization' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'organizationName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"text-center\">{{ 'LblIsEmailTemplate' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblIsWebTemplate' | translate }}</th>\r\n\r\n                <th class=\"text-center\">{{ 'LblActiveInactive' | translate }}</th>\r\n\r\n                <th class=\"text-center\">{{ 'LblEdit' | translate }}</th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let item of templateList\">\r\n                  <td class=\"text-center\">\r\n                    <input disabled *ngIf=\"!item.isDeletable || !item.instanceHashId\" type=\"checkbox\" name=\"isActive\" [(ngModel)]=\"item.isChecked\">\r\n                    <input *ngIf=\"item.isDeletable && item.instanceHashId\" type=\"checkbox\" name=\"isActive\" [(ngModel)]=\"item.isChecked\">\r\n                  </td>\r\n                  <td>{{ item.templateName }}</td>\r\n                  <!-- <td>{{ item.templateType }}</td> -->\r\n                  <td>{{ item.subjectHTml }}</td>\r\n\r\n                  <td *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Customer\" class=\"word-wrap\">{{ item.customerName }}</td>\r\n                  <td *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Instance\" class=\"word-wrap\">{{ item.instanceName }}</td>\r\n                  <td *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Company\" class=\"word-wrap\">{{ item.companyName }}</td>\r\n                  <td *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.SVG\" class=\"word-wrap\">{{ item.sharedVehicleGroupName }}</td>\r\n                  <td *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Organization\" class=\"word-wrap\">{{ item.organizationName }}</td>\r\n                  <td class=\"text-center\">\r\n                    <i class=\"fa fa-fw\" [ngClass]=\"{'fa-check-square-o': item.isEmailTemplate, 'fa-square-o': !item.isEmailTemplate}\"></i>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <i class=\"fa fa-fw\" [ngClass]=\"{'fa-check-square-o': item.isWebTemplate, 'fa-square-o': !item.isWebTemplate}\"></i>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <i class=\"fa fa-fw\" [ngClass]=\"{'fa-check-square-o': item.isActive, 'fa-square-o': !item.isActive}\"></i>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"item.isEditable\" [routerLink]=\"urlTemplateUpdatePage + '/' + item.templateHashID\">\r\n                      <i class=\"fa fa-pencil-square-o fa-fw\"></i>\r\n                    </a>\r\n                  </td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"12\">\r\n                  {{ DataListModel.infoMessage }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<wego-confirm-popup #childModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessModalClick()\" (onReject)=\"HideChildModal()\"></wego-confirm-popup>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>";

/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var wegoadmin_service_1 = __webpack_require__(782);
	var AddWegoAdminPopupComponent = (function () {
	    function AddWegoAdminPopupComponent(wegoAdminService, authService, router, translate) {
	        this.wegoAdminService = wegoAdminService;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.onSuccessSelect = new core_1.EventEmitter();
	    }
	    AddWegoAdminPopupComponent.prototype.ngOnInit = function () {
	        this.module = this.translate.instant('LblWegoAdmin');
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.searchField = ["userName", "firstName", "lastName"];
	        this.breadCrumbTitle = this.translate.instant('LblAddPage', [this.module]);
	    };
	    AddWegoAdminPopupComponent.prototype.ngOnChanges = function (change) {
	        console.log(change);
	    };
	    AddWegoAdminPopupComponent.prototype.show = function () {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.sortType = "";
	        this.DataListModel.sortReverse = null;
	        this.DataListModel.searchTerm = "";
	        this.DataListModel.infoMessage = "";
	        this.GetPersonList();
	        this.wegoAdminModal.show();
	    };
	    AddWegoAdminPopupComponent.prototype.hide = function () {
	        this.wegoAdminModal.hide();
	    };
	    AddWegoAdminPopupComponent.prototype.GetPersonList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.wegoAdminService.GetPersonList(this.DataListModel)
	            .subscribe(function (res) {
	            _this.personList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AddWegoAdminPopupComponent.prototype.select = function (personMasterHashId) {
	        var _this = this;
	        this.isLoading = true;
	        this.wegoAdminService.AddWegoAdmin(personMasterHashId)
	            .subscribe(function (res) {
	            _this.popupMsg = _this.translate.instant('LblRecordAddedSuccess', [_this.module]);
	            _this.OnSuccessSelect();
	            _this.isLoading = false;
	            //this.wegoAdminModal.hide();
	            //this.ShowSuccessPopup();
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        }, function () {
	            _this.wegoAdminModal.hide();
	            _this.isLoading = false;
	        });
	    };
	    AddWegoAdminPopupComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetPersonList();
	    };
	    AddWegoAdminPopupComponent.prototype.OnSearch = function (event) {
	        this.DataListModel.searchTerm = event.searchTerm;
	        this.DataListModel.currentPage = 1;
	        this.GetPersonList();
	    };
	    AddWegoAdminPopupComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetPersonList();
	    };
	    ;
	    AddWegoAdminPopupComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetPersonList();
	    };
	    AddWegoAdminPopupComponent.prototype.OnSuccessSelect = function () {
	        this.onSuccessSelect.emit({ SuccessMessage: this.popupMsg });
	    };
	    AddWegoAdminPopupComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    AddWegoAdminPopupComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    AddWegoAdminPopupComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    __decorate([
	        core_1.Output('OnSuccessSelect'), 
	        __metadata('design:type', Object)
	    ], AddWegoAdminPopupComponent.prototype, "onSuccessSelect", void 0);
	    __decorate([
	        core_1.ViewChild('wegoAdminModal'), 
	        __metadata('design:type', Object)
	    ], AddWegoAdminPopupComponent.prototype, "wegoAdminModal", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], AddWegoAdminPopupComponent.prototype, "successPopup", void 0);
	    AddWegoAdminPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-add-wegoadmin-popup',
	            template: __webpack_require__(783),
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof wegoadmin_service_1.WegoAdminService !== 'undefined' && wegoadmin_service_1.WegoAdminService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object])
	    ], AddWegoAdminPopupComponent);
	    return AddWegoAdminPopupComponent;
	    var _a, _b, _c, _d;
	}());
	exports.AddWegoAdminPopupComponent = AddWegoAdminPopupComponent;


/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var WegoAdminService = (function () {
	    function WegoAdminService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    WegoAdminService.prototype.GetPersonList = function (input) {
	        var getWegoAdminUrl = config_1.WeGoConfig.API_GET_WEGOADMIN_PERSON_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getWegoAdminUrl = getWegoAdminUrl + "?" + queryString;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getWegoAdminUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    WegoAdminService.prototype.GetWegoAdminList = function (input) {
	        var getWegoAdminUrl = config_1.WeGoConfig.API_GET_WEGOADMIN_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getWegoAdminUrl = getWegoAdminUrl + "?" + queryString;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getWegoAdminUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    WegoAdminService.prototype.AddWegoAdmin = function (personHashId) {
	        var getWegoAdminUrl = config_1.WeGoConfig.API_GET_WEGOADMIN + "?personHashId=" + personHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getWegoAdminUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    WegoAdminService.prototype.DeleteWegoAdmin = function (selectedwegoAdminList) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_DELETE_WEGOADMIN, selectedwegoAdminList, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    WegoAdminService.prototype.ExportWegoAdminList = function (input) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var getWegoAdminUrl = config_1.WeGoConfig.API_EXPORT_WEGOADMIN_LIST + "?" + queryString;
	        var headers = this.authService.GetHeader('text/csv');
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getWegoAdminUrl, options);
	    };
	    WegoAdminService.prototype.InActiveWegoAdmin = function (wegoAdminHashId) {
	        var getWegoAdminUrl = config_1.WeGoConfig.API_GET_INACTIVEWEGOADMIN + "?wegoAdminHashId=" + wegoAdminHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getWegoAdminUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    WegoAdminService.prototype.ResetTwoFaCookies = function () {
	        var getInstanceUrl = config_1.WeGoConfig.API_RESET_TWOFA_COOKIES_WEGOADMIN;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInstanceUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    WegoAdminService.prototype.ResetTwoFaKeys = function () {
	        var getInstanceUrl = config_1.WeGoConfig.API_RESET_TWOFA_KEYS_WEGOADMIN;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInstanceUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    WegoAdminService.prototype.GetTwoFAValidityDays = function () {
	        var getInstanceUrl = config_1.WeGoConfig.API_GET_TWOFA_KEYS_WEGOADMIN;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInstanceUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    WegoAdminService.prototype.UpdateTwoFAValidityDays = function (Days) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_UPDATE_WEGOADMIN_TWOFA_VALIDITY + "?Days=" + Days, null, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    WegoAdminService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], WegoAdminService);
	    return WegoAdminService;
	    var _a, _b;
	}());
	exports.WegoAdminService = WegoAdminService;


/***/ },
/* 783 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #wegoAdminModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n                    <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{breadCrumbTitle}} </h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <wego-search-list [IsExported]=\"false\" [SearchTerm]=\"DataListModel.searchTerm\" (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center\">\r\n                  {{ 'LblSelect' | translate }}\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('firstName')\">\r\n                  {{ 'LblFirstName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'firstName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('lastName')\">\r\n                  {{ 'LblLastName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'lastName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('userName')\">\r\n                  {{ 'LblUserName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'userName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let person of personList\">\r\n                  <td class=\"text-center\">\r\n                    <a class=\"cursor-pointer\" (click)=\"select(person.personMasterHashId)\">\r\n                      <i class=\"fa fa-plus-square\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td>{{ person.firstName }}</td>\r\n                  <td>{{ person.lastName }} </td>\r\n                  <td>{{ person.userName }}</td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0\">\r\n                <td class=\"text-center text-danger\" colspan=\"4\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\" [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\"\r\n                firstText=\"&laquo;\" lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>";

/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var person_service_1 = __webpack_require__(771);
	var core_1 = __webpack_require__(3);
	var wegoadmin_service_1 = __webpack_require__(782);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var WegoAdminListComponent = (function () {
	    function WegoAdminListComponent(wegoadminService, authService, personService, router, translate) {
	        this.wegoadminService = wegoadminService;
	        this.authService = authService;
	        this.personService = personService;
	        this.router = router;
	        this.translate = translate;
	        this.expirationDays = "";
	    }
	    Object.defineProperty(WegoAdminListComponent.prototype, "isAnyChecked", {
	        get: function () {
	            if (this.WegoAdminList) {
	                var isCheck = this.WegoAdminList.some(function (x) { return x.isChecked == true; });
	                if (isCheck) {
	                    if (this.WegoAdminList.every(function (x) { return x.isChecked == true; }))
	                        this.isParentCheck = true;
	                    else
	                        this.isParentCheck = false;
	                }
	                else {
	                    this.isParentCheck = false;
	                }
	                return isCheck;
	            }
	            else {
	                this.isParentCheck = false;
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    WegoAdminListComponent.prototype.ngOnInit = function () {
	        this.wegoadminUser = config_1.WeGoConfig.WEGOADMIN_USER;
	        this.lblBlock = this.translate.instant('LblBlock');
	        this.lblUnblock = this.translate.instant('LblUnblock');
	        this.module = this.translate.instant('LblWegoAdmin');
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = [
	            'userName',
	            'instanceName',
	            'firstName',
	            'lastName',
	            'telephone1'
	        ];
	        this.adminDependencyModelTitle = this.translate.instant('LblAdminDependencyAlert');
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlPersonUpdate = this.authService.GetURL(config_1.ApplicationRouteURL.URL_PERSON_UPDATE);
	        this.GetWegoAdminist();
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	        this.GetTwoFAValidityDays();
	    };
	    WegoAdminListComponent.prototype.SuccessAdminDependencyModalClick = function () {
	        this.adminDependencyModal.hide();
	    };
	    WegoAdminListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetWegoAdminist();
	    };
	    WegoAdminListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetWegoAdminist();
	    };
	    WegoAdminListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetWegoAdminist();
	    };
	    WegoAdminListComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetWegoAdminist();
	    };
	    WegoAdminListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.wegoadminService.ExportWegoAdminList(this.DataListModel).subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = 'WegoAdmin' + new Date().toISOString() + '.csv';
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    WegoAdminListComponent.prototype.OnParentCheck = function (isChecked) {
	        this.WegoAdminList.forEach(function (x) { return (x.isChecked = isChecked); });
	    };
	    WegoAdminListComponent.prototype.DeleteWegoAdmin = function (deletewegoAdminList) {
	        var _this = this;
	        this.isLoading = true;
	        this.wegoadminService.DeleteWegoAdmin(deletewegoAdminList).subscribe(function (res) {
	            if (!res.data) {
	                _this.adminDependencyvalidationMessage = _this.translate.instant('LblWegoAdminDependencyValidation');
	                _this.adminDependencyModal.show();
	                _this.isLoading = false;
	            }
	            else {
	                _this.DataListModel.currentPage = 1;
	                _this.GetWegoAdminist();
	                _this.popupMsg = _this.translate.instant('LblRecordRemovedSuccess', [
	                    _this.module
	                ]);
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    WegoAdminListComponent.prototype.GetWegoAdminist = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.wegoadminService.GetWegoAdminList(this.DataListModel).subscribe(function (res) {
	            _this.WegoAdminList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    WegoAdminListComponent.prototype.InActiveWegoAdmin = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.wegoadminService.InActiveWegoAdmin(this.wegoAdminHashId).subscribe(function (res) {
	            if (res.data) {
	                _this.inActiveModal.hide();
	                _this.DataListModel.currentPage = 1;
	                _this.GetWegoAdminist();
	                _this.popupMsg = _this.translate.instant('LblRecordBlokUnBlockSuccess', [_this.module, _this.inActiveMessage]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.isLoading = false;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    //Reset wego admin password
	    WegoAdminListComponent.prototype.ResetPersonPassword = function (personHashID) {
	        var _this = this;
	        this.personService.ResetPersonPassword(personHashID).subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblResetPasswordSuccess');
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblResetPasswordFailure');
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    WegoAdminListComponent.prototype.ShowResetPasswordModal = function (personHashID) {
	        this.resetPersonHashId = personHashID;
	        this.popupMsg = this.translate.instant('LblResetPasswordConfirmation');
	        this.resetPasswordModal.show();
	    };
	    WegoAdminListComponent.prototype.ResendActivationMail = function (personHashID) {
	        var _this = this;
	        this.resetPersonHashId = personHashID;
	        this.personService.ReSendActivationMail(personHashID).subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblResendActivationMailSuccess');
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblResendActivationMailFailure');
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    WegoAdminListComponent.prototype.HideResetPasswordModal = function () {
	        this.resetPersonHashId = '';
	        this.resetPasswordModal.hide();
	    };
	    WegoAdminListComponent.prototype.SuccessResetPasswordModalClick = function () {
	        this.resetPasswordModal.hide();
	        this.ResetPersonPassword(this.resetPersonHashId);
	    };
	    WegoAdminListComponent.prototype.ShowAlertModal = function () {
	        this.popupMsg = this.translate.instant('LblRecordDeleteConfirmation', [
	            this.module
	        ]);
	        this.alertModal.show();
	    };
	    WegoAdminListComponent.prototype.HideAlertModal = function () {
	        this.alertModal.hide();
	    };
	    WegoAdminListComponent.prototype.SuccessAlertModalClick = function () {
	        var deletewegoAdminList;
	        deletewegoAdminList = this.WegoAdminList.filter(function (x) { return x.isChecked; }).map(function (x) { return x.wegoAdminHashId; });
	        this.DeleteWegoAdmin(deletewegoAdminList);
	        this.alertModal.hide();
	    };
	    WegoAdminListComponent.prototype.ShowWegoAdminModal = function () {
	        this.wegoAdminModal.show();
	    };
	    WegoAdminListComponent.prototype.SuccessWegoAdminModal = function ($event) {
	        this.GetWegoAdminist();
	        this.popupMsg = $event.SuccessMessage;
	        this.ShowSuccessPopup();
	    };
	    WegoAdminListComponent.prototype.ShowInActiveModal = function (wegoAdminHashId, isActive) {
	        this.wegoAdminHashId = wegoAdminHashId;
	        this.activeFlag = isActive;
	        this.inActiveMessage = isActive
	            ? this.translate.instant('LblBlock')
	            : this.translate.instant('LblUnblock');
	        this.popupMsg = this.translate.instant('LblBlockUnblockConfirm', [
	            this.inActiveMessage,
	            this.module
	        ]);
	        this.inActiveModal.show(this.popupMsg);
	    };
	    WegoAdminListComponent.prototype.ResetCookies = function () {
	        var _this = this;
	        this.wegoadminService.ResetTwoFaCookies()
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupTitle = _this.translate.instant('LblSuccess');
	                _this.popupMsg = _this.translate.instant('LblCookieResetSuccess', [_this.module]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupTitle = _this.translate.instant('LblError');
	                _this.popupMsg = _this.translate.instant('LblCookieResetFailed');
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    WegoAdminListComponent.prototype.ResetTwoFA = function () {
	        var _this = this;
	        this.wegoadminService.ResetTwoFaKeys()
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupTitle = _this.translate.instant('LblSuccess');
	                _this.popupMsg = _this.translate.instant('LblKeyResetSuccess', [_this.module]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupTitle = _this.translate.instant('LblError');
	                _this.popupMsg = _this.translate.instant('LblKeyResetFailed');
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    WegoAdminListComponent.prototype.SaveTwoFA = function () {
	        var _this = this;
	        this.wegoadminService.UpdateTwoFAValidityDays(this.expirationDays)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupTitle = _this.translate.instant('LblSuccess');
	                _this.popupMsg = _this.translate.instant('LblRecordSavedSuccess', [_this.module]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupTitle = _this.translate.instant('LblError');
	                _this.popupMsg = res.error;
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    WegoAdminListComponent.prototype.GetTwoFAValidityDays = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.wegoadminService.GetTwoFAValidityDays().subscribe(function (res) {
	            _this.expirationDays = res.data;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    WegoAdminListComponent.prototype.ResetPersonCookies = function (personHashId) {
	        var _this = this;
	        this.resetPersonHashId = personHashId;
	        this.personService.ResetTwoFaCookie(personHashId).subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblCookieResetSuccess');
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupTitle = _this.translate.instant('LblError');
	                _this.popupMsg = _this.translate.instant('LblCookieResetFailed');
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    WegoAdminListComponent.prototype.ResetPersonTwoFA = function (personHashId) {
	        var _this = this;
	        this.resetPersonHashId = personHashId;
	        this.personService.ResetTwoFaKey(personHashId).subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblKeyResetSuccess');
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblKeyResetFailed');
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    WegoAdminListComponent.prototype.HideInActiveModal = function () {
	        this.wegoAdminHashId = '';
	        this.inActiveModal.hide();
	    };
	    WegoAdminListComponent.prototype.SuccessInActiveModalClick = function () {
	        this.InActiveWegoAdmin();
	        this.inActiveModal.hide();
	    };
	    WegoAdminListComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    WegoAdminListComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    WegoAdminListComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    WegoAdminListComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], WegoAdminListComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild('wegoAdminModal'), 
	        __metadata('design:type', Object)
	    ], WegoAdminListComponent.prototype, "wegoAdminModal", void 0);
	    __decorate([
	        core_1.ViewChild('alertModal'), 
	        __metadata('design:type', Object)
	    ], WegoAdminListComponent.prototype, "alertModal", void 0);
	    __decorate([
	        core_1.ViewChild('inActiveModal'), 
	        __metadata('design:type', Object)
	    ], WegoAdminListComponent.prototype, "inActiveModal", void 0);
	    __decorate([
	        core_1.ViewChild('resetPasswordModal'), 
	        __metadata('design:type', Object)
	    ], WegoAdminListComponent.prototype, "resetPasswordModal", void 0);
	    __decorate([
	        core_1.ViewChild('adminDependencyModal'), 
	        __metadata('design:type', Object)
	    ], WegoAdminListComponent.prototype, "adminDependencyModal", void 0);
	    WegoAdminListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-wegoadminlist-list',
	            template: __webpack_require__(785),
	            providers: [wegoadmin_service_1.WegoAdminService, person_service_1.PersonService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof wegoadmin_service_1.WegoAdminService !== 'undefined' && wegoadmin_service_1.WegoAdminService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof person_service_1.PersonService !== 'undefined' && person_service_1.PersonService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _e) || Object])
	    ], WegoAdminListComponent);
	    return WegoAdminListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.WegoAdminListComponent = WegoAdminListComponent;


/***/ },
/* 785 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-3 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ breadCrumbList}} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li><a [routerLink]=\"urlDefaultPage\"><i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a></li>\r\n        <li class=\"active\"> {{ breadCrumbList}} </li>\r\n      </ol>\r\n    </div>\r\n\r\n    <div class=\"row col-md-7\">\r\n      <div class=\"clearfix\"></div>\r\n      <fieldset class=\"col-md-12\">\r\n        <legend class=\"legendStyle\">\r\n          <span class=\"text text-danger\">*</span> {{ 'LblTwoFaConfig' | translate }}\r\n        </legend>\r\n        <div class=\"form-group col-md-6\">\r\n          <label>{{ 'LblExpirationDays' | translate }}</label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblExpirationDays' | translate }}\" [(ngModel)]=\"expirationDays\"\r\n            name=\"ExpirationDays\" maxlength=\"3\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'ExpirationDays' }}</span>\r\n        </div>\r\n        <div class=\"form-group col-md-6 mar_t_25\">\r\n          <label>&nbsp;</label>\r\n          <a class=\"btn btn-highlight navbar-left\" (click)=\"SaveTwoFA()\">{{\r\n            'LblSave' | translate }}</a>\r\n        </div>\r\n        <div class=\"form-group col-md-12\">\r\n          <a class=\"btn btn-highlight navbar-left  mar_t_5\" (click)=\"ResetCookies()\">{{\r\n            'LblResetCookiesForAllAdmin' | translate }}</a>\r\n          &nbsp;&nbsp;\r\n          <a class=\"btn btn-highlight navbar-left mar_t_5\" style=\"margin-left: 10px;\" (click)=\"ResetTwoFA()\">{{\r\n            'LblReset2FaForAllAdmin' | translate }}</a>\r\n        </div>\r\n      </fieldset>\r\n    </div>\r\n\r\n    <div class=\"col-md-2 col-sm-6 mar_t_25 \">\r\n      <a class=\"btn btn-highlight navbar-right\" (click)=\"ShowWegoAdminModal()\">{{ 'LblAddNew' | translate }}</a>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <wego-search-list [IsDeleted]=\"true\" [IsDeleteEnabled]=\"isAnyChecked\" (OnDeleteAll)=\"ShowAlertModal()\"\r\n          (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\"\r\n          [SearchTerm]=\"DataListModel.searchTerm\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center parent-checkbox\"><input type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\"\r\n                    (change)=\"OnParentCheck($event.target.checked)\"></th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('firstName')\">\r\n                  {{ 'LblFirstName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'firstName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('lastName')\">\r\n                  {{ 'LblLastName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'lastName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('userName')\">\r\n                  {{ 'LblUserName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'userName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('telephone1')\">\r\n                  {{ 'LblMobileNumber' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'telephone1'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"text-center\">{{ 'LblResetCookie' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblResetTwoFA' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblResendActivationMail' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblResetPassword' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblEdit' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblBlockUnBlock' | translate }}</th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let wegoadmin of WegoAdminList\">\r\n                  <td class=\"text-center\"><input *ngIf=\"wegoadmin.userName.toLowerCase() != wegoadminUser\" type=\"checkbox\"\r\n                      name=\"isActive\" [(ngModel)]=\"wegoadmin.isChecked\"></td>\r\n                  <td>{{ wegoadmin.firstName }}</td>\r\n                  <td>{{ wegoadmin.lastName }}</td>\r\n                  <td>{{ wegoadmin.userName }}</td>\r\n                  <td>{{ wegoadmin.telephone1 }}</td>\r\n\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"!wegoadmin.twoFaDisabled\" class=\"btn btn-green btn-xs cursor-pointer\" (click)=\"ResetPersonCookies(wegoadmin.personMasterHashId)\">\r\n                      {{ 'LblResetCookie' | translate}}\r\n                    </a>\r\n                  </td>\r\n\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"wegoadmin.resetKeyEnabled\" class=\"btn btn-green btn-xs cursor-pointer\" (click)=\"ResetPersonTwoFA(wegoadmin.personMasterHashId)\">\r\n                      {{ 'LblResetTwoFA' | translate}}\r\n                    </a>\r\n                  </td>\r\n\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"wegoadmin.personNotActive\" class=\"btn btn-green btn-xs cursor-pointer\" (click)=\"ResendActivationMail(wegoadmin.personMasterHashId)\">\r\n                      {{ 'LblReSend' | translate}}\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a class=\"cursor-pointer\">\r\n                      <i class=\"fa fa-refresh fa-fw text-success\" (click)=\"ShowResetPasswordModal(wegoadmin.personMasterHashId)\"></i>\r\n                    </a>\r\n                  </td>\r\n\r\n                  <td class=\"text-center\">\r\n\r\n                    <a class=\"cursor-pointer\" [routerLink]=\"urlPersonUpdate + '/' + wegoadmin.personMasterHashId\">\r\n                      <i class=\"fa fa-pencil-square-o fa-fw\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"wegoadmin.userName.toLowerCase() != wegoadminUser\" class=\"cursor-pointer btn btn-xs btn-active-inactive\"\r\n                      [ngClass]=\"{'btn-active': !wegoadmin.isActive, 'btn-inactive': wegoadmin.isActive}\" (click)=\"ShowInActiveModal(wegoadmin.wegoAdminHashId, wegoadmin.isActive)\">\r\n                      <template [ngIf]=\"!wegoadmin.isActive\"> {{ 'LblUnblock' | translate}} </template>\r\n                      <template [ngIf]=\"wegoadmin.isActive\"> {{ 'LblBlock' | translate}} </template>\r\n                    </a>\r\n                  </td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"11\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\"\r\n                [(ngModel)]=\"DataListModel.currentPage\" [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\"\r\n                previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\" lastText=\"&raquo;\" [rotate]=\"false\"\r\n                (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<wego-add-wegoadmin-popup #wegoAdminModal (OnSuccessSelect)=\"SuccessWegoAdminModal($event)\"></wego-add-wegoadmin-popup>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" [popupTitle]=\"popupTitle\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n\r\n<wego-confirm-popup #alertModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessAlertModalClick()\" (onReject)=\"HideAlertModal()\"></wego-confirm-popup>\r\n\r\n<wego-confirm-popup #inActiveModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessInActiveModalClick()\" (onReject)=\"HideInActiveModal()\"></wego-confirm-popup>\r\n\r\n<wego-confirm-popup #resetPasswordModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessResetPasswordModalClick()\" (onReject)=\"HideResetPasswordModal()\"></wego-confirm-popup>\r\n<wego-success-popup #adminDependencyModal [popupTitle]=\"adminDependencyModelTitle\" [popupMsg]=\"adminDependencyvalidationMessage\"\r\n  (onConfirm)=\"SuccessAdminDependencyModalClick()\"></wego-success-popup>";

/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var driver_model_1 = __webpack_require__(601);
	var driver_service_1 = __webpack_require__(570);
	var AddDriverPopupComponent = (function () {
	    function AddDriverPopupComponent(driverService, authService, router, translate) {
	        this.driverService = driverService;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.onSuccessSelect = new core_1.EventEmitter();
	    }
	    AddDriverPopupComponent.prototype.ngOnInit = function () {
	        this.module = this.translate.instant('LblDriver');
	        this.breadCrumbTitle = this.translate.instant('LblAddPage', [this.module]);
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.searchField = ["userName", "firstName", "lastName"];
	        this.urlPersonUpdate = this.authService.GetURL(config_1.ApplicationRouteURL.URL_PERSON_UPDATE);
	        this.model = new driver_model_1.DriverModel();
	    };
	    AddDriverPopupComponent.prototype.ngOnChanges = function (change) {
	        console.log(change);
	    };
	    AddDriverPopupComponent.prototype.show = function () {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.sortType = "";
	        this.DataListModel.sortReverse = null;
	        this.DataListModel.searchTerm = "";
	        this.DataListModel.infoMessage = "";
	        this.GetPersonListForDrivers();
	        this.driverModal.show();
	        this.validationMessage = '';
	    };
	    AddDriverPopupComponent.prototype.hide = function () {
	        this.driverModal.hide();
	    };
	    AddDriverPopupComponent.prototype.GetPersonListForDrivers = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.driverService.GetPersonListForDrivers(this.DataListModel)
	            .subscribe(function (res) {
	            _this.personList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AddDriverPopupComponent.prototype.select = function (personMasterHashId) {
	        var _this = this;
	        this.isLoading = true;
	        this.model.personMasterHashId = personMasterHashId;
	        this.model.isBanned = true;
	        this.driverService.AddNewDriver(this.model)
	            .subscribe(function (res) {
	            _this.popupMsg = _this.translate.instant('LblRecordAddedSuccess', [_this.module]); //this.translate.instant('LblRecordSavedSuccess');
	            _this.OnSuccessSelect();
	            _this.isLoading = false;
	            //this.ShowSuccessPopup();
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        }, function () {
	            _this.driverModal.hide();
	            _this.isLoading = false;
	        });
	    };
	    AddDriverPopupComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetPersonListForDrivers();
	    };
	    AddDriverPopupComponent.prototype.OnSearch = function (event) {
	        this.DataListModel.searchTerm = event.searchTerm;
	        this.DataListModel.currentPage = 1;
	        this.GetPersonListForDrivers();
	    };
	    AddDriverPopupComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetPersonListForDrivers();
	    };
	    ;
	    AddDriverPopupComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetPersonListForDrivers();
	    };
	    AddDriverPopupComponent.prototype.OnSuccessSelect = function () {
	        this.onSuccessSelect.emit({ SuccessMessage: this.popupMsg });
	    };
	    AddDriverPopupComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    AddDriverPopupComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    AddDriverPopupComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    __decorate([
	        core_1.Output('OnSuccessSelect'), 
	        __metadata('design:type', Object)
	    ], AddDriverPopupComponent.prototype, "onSuccessSelect", void 0);
	    __decorate([
	        core_1.ViewChild('driverModal'), 
	        __metadata('design:type', Object)
	    ], AddDriverPopupComponent.prototype, "driverModal", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], AddDriverPopupComponent.prototype, "successPopup", void 0);
	    AddDriverPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-add-driver-popup',
	            template: __webpack_require__(787),
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof driver_service_1.DriverService !== 'undefined' && driver_service_1.DriverService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object])
	    ], AddDriverPopupComponent);
	    return AddDriverPopupComponent;
	    var _a, _b, _c, _d;
	}());
	exports.AddDriverPopupComponent = AddDriverPopupComponent;


/***/ },
/* 787 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #driverModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\"\r\n  [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n                    <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ breadCrumbTitle }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <wego-search-list [IsExported]=\"false\" [SearchTerm]=\"DataListModel.searchTerm\" (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\"\r\n          (OnPagingChange)=\"OnPagingChange($event)\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center\">\r\n                  {{ 'LblSelect' | translate }}\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('firstName')\">\r\n                  {{ 'LblFirstName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'firstName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('lastName')\">\r\n                  {{ 'LblLastName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'lastName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('userName')\">\r\n                  {{ 'LblUserName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'userName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let person of personList\">\r\n                  <td class=\"text-center\">\r\n                    <a class=\"cursor-pointer\" (click)=\"select(person.personMasterHashId)\">\r\n                      <i class=\"fa fa-plus-square\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td>{{ person.firstName }}</td>\r\n                  <td>{{ person.lastName }} </td>\r\n                  <td>{{ person.userName }}</td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0\">\r\n                <td class=\"text-center text-danger\" colspan=\"4\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>";

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var sharedvehiclegroup_service_1 = __webpack_require__(510);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var SharedVehicleGroupListComponent = (function () {
	    function SharedVehicleGroupListComponent(sharedVehicleGroupService, activeRoute, authService, router, translate) {
	        this.sharedVehicleGroupService = sharedVehicleGroupService;
	        this.activeRoute = activeRoute;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.companyHashID = "";
	        this.roleLevel = config_1.RoleLevel;
	    }
	    Object.defineProperty(SharedVehicleGroupListComponent.prototype, "isAnyChecked", {
	        get: function () {
	            if (this.sharedVehicleGroupList) {
	                var isCheck = this.sharedVehicleGroupList.some(function (x) { return x.isChecked == true; });
	                if (isCheck) {
	                    if (this.sharedVehicleGroupList.every(function (x) { return x.isChecked == true; }))
	                        this.isParentCheck = true;
	                    else
	                        this.isParentCheck = false;
	                }
	                else {
	                    this.isParentCheck = false;
	                }
	                return isCheck;
	            }
	            else {
	                this.isParentCheck = false;
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SharedVehicleGroupListComponent.prototype, "isDeleteAccess", {
	        get: function () {
	            if (this.sharedVehicleGroupList) {
	                return this.sharedVehicleGroupList.some(function (x) { return x.isDeletable; });
	            }
	            else {
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SharedVehicleGroupListComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.module = this.translate.instant('LblSharedVehicleGroup');
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	        console.log('ngOnInit');
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        if (this.authService.GetHighestRoleLevel() <= this.roleLevel.Company) {
	            this.DataListModel.searchField = ["groupName", "companyName"];
	        }
	        else {
	            this.DataListModel.searchField = ["groupName"];
	        }
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlSVGAdd = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SVG_ADD);
	        this.urlSVGUpdate = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SVG_UPDATE);
	        this.urlSVGAdminList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SVGADMIN_LIST);
	        this.urlSubscriptionList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SUBSCRIPTION_LIST);
	        this.urlVehicleList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SVGVEHICLE_LIST);
	        this.urlDriverList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SVGDRIVER_LIST);
	        this.urlContractTypeGroupList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_CONTRACT_TYPE_GROUP_LIST);
	        this.urlVehicleMasterList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_VEHICLE_LIST);
	        this.urlAdminList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_ADMIN_OF_SHAREDVEHICLEGROUP_LIST);
	        this.activeRoute
	            .params
	            .subscribe(function (params) {
	            var companyHashID = params['companyHashId'] || '';
	            if (companyHashID != '')
	                _this.companyHashID = companyHashID;
	            else
	                _this.companyHashID = "";
	            var vehicleHashId = params['vehicleHashId'] || '';
	            if (vehicleHashId != '')
	                _this.vehicleHashId = vehicleHashId;
	            else
	                _this.vehicleHashId = "";
	            _this.GetSharedVehicleGroupList();
	        });
	        this.addSharedVehicleGroupLink = new config_1.WeGoAuthorizedLink(this.urlSVGAdd, config_1.Permission.PR_SHARED_VEHICLE_GROUP_OVERVIEW, config_1.PermissionType.INSERT, 'btn btn-highlight navbar-right', 'LblAddNew');
	    };
	    SharedVehicleGroupListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetSharedVehicleGroupList();
	    };
	    SharedVehicleGroupListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetSharedVehicleGroupList();
	    };
	    SharedVehicleGroupListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetSharedVehicleGroupList();
	    };
	    ;
	    SharedVehicleGroupListComponent.prototype.OnPagingChange = function (event) {
	        console.log(this.DataListModel);
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetSharedVehicleGroupList();
	    };
	    SharedVehicleGroupListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.sharedVehicleGroupService.ExportSharedVehicleGroupList(this.companyHashID, this.vehicleHashId, this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "SVG" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SharedVehicleGroupListComponent.prototype.GetSharedVehicleGroupList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.sharedVehicleGroupService.GetSharedVehicleGroupList(this.DataListModel, '', this.companyHashID, this.vehicleHashId)
	            .subscribe(function (res) {
	            _this.sharedVehicleGroupList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SharedVehicleGroupListComponent.prototype.OnParentCheck = function (isChecked) {
	        this.sharedVehicleGroupList.filter(function (x) { return x.isDeletable; }).forEach(function (x) { return x.isChecked = isChecked; });
	    };
	    SharedVehicleGroupListComponent.prototype.DeleteSharedVehicleGroup = function (deletecontractTypeHashId) {
	        var _this = this;
	        this.isLoading = true;
	        this.sharedVehicleGroupService.DeleteSharedVehicleGroup(deletecontractTypeHashId)
	            .subscribe(function (res) {
	            _this.apiResponse = res;
	            _this.DataListModel.currentPage = 1;
	            _this.GetSharedVehicleGroupList();
	            _this.popupMsg = _this.translate.instant('LblRecordRemovedSuccess', [_this.module]);
	            _this.ShowSuccessPopup();
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SharedVehicleGroupListComponent.prototype.ShowDeleteModal = function (sharedVehicleGroupHashId) {
	        if (sharedVehicleGroupHashId) {
	            this.popupMsg = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
	            this.isMultipleDelete = false;
	            this.deleteSharedVehicleGroupHashId = sharedVehicleGroupHashId;
	        }
	        else {
	            this.popupMsg = this.translate.instant('LblRecordMultiplDeleteConfirmation', [this.module]);
	            this.isMultipleDelete = true;
	        }
	        this.deleteModal.show();
	    };
	    SharedVehicleGroupListComponent.prototype.HideDeleteModal = function () {
	        this.deleteSharedVehicleGroupHashId = "";
	        this.deleteModal.hide();
	    };
	    SharedVehicleGroupListComponent.prototype.SuccessModalClick = function () {
	        var deleteContractTypeList;
	        if (this.isMultipleDelete)
	            deleteContractTypeList = this.sharedVehicleGroupList.filter(function (x) { return x.isChecked; }).map(function (x) { return x.sharedvehiclegroupHashId; });
	        else
	            deleteContractTypeList.push(this.deleteSharedVehicleGroupHashId);
	        this.DeleteSharedVehicleGroup(deleteContractTypeList);
	        this.deleteModal.hide();
	    };
	    SharedVehicleGroupListComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    SharedVehicleGroupListComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    SharedVehicleGroupListComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    SharedVehicleGroupListComponent.prototype.ActiveInactiveSVG = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.sharedVehicleGroupService.InActiveSharedVehicleGroup(this.blockUnblockSVGHashId)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.inActiveModal.hide();
	                _this.DataListModel.currentPage = 1;
	                _this.GetSharedVehicleGroupList();
	                _this.popupMsg = _this.translate.instant('LblRecordActiveInActiveSuccess', [_this.module, _this.blockMsg]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.isLoading = false;
	                _this.popupMsg = res.error;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SharedVehicleGroupListComponent.prototype.ShowInActiveModal = function (svgHashId, isActive) {
	        this.blockUnblockSVGHashId = svgHashId;
	        this.blockMsg = isActive ? this.translate.instant('LblInactive') : this.translate.instant('LblActive');
	        var roleType = this.translate.instant('LblSharedVehicleGroup');
	        this.popupMsg = this.translate.instant('LblBlockUnblockConfirm', [this.blockMsg, roleType]);
	        this.inActiveModal.show();
	    };
	    SharedVehicleGroupListComponent.prototype.HideInActiveModal = function () {
	        this.inActiveModal.hide();
	    };
	    SharedVehicleGroupListComponent.prototype.SuccessInActiveModalClick = function () {
	        this.ActiveInactiveSVG();
	        this.inActiveModal.hide();
	    };
	    SharedVehicleGroupListComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    __decorate([
	        core_1.ViewChild('deleteModal'), 
	        __metadata('design:type', Object)
	    ], SharedVehicleGroupListComponent.prototype, "deleteModal", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], SharedVehicleGroupListComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild('inActiveModal'), 
	        __metadata('design:type', Object)
	    ], SharedVehicleGroupListComponent.prototype, "inActiveModal", void 0);
	    SharedVehicleGroupListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-sharedvehiclegroup-list',
	            template: __webpack_require__(789),
	            providers: [sharedvehiclegroup_service_1.SharedVehicleGroupService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof sharedvehiclegroup_service_1.SharedVehicleGroupService !== 'undefined' && sharedvehiclegroup_service_1.SharedVehicleGroupService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _e) || Object])
	    ], SharedVehicleGroupListComponent);
	    return SharedVehicleGroupListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.SharedVehicleGroupListComponent = SharedVehicleGroupListComponent;


/***/ },
/* 789 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ breadCrumbList}} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li *ngIf=\"vehicleHashId\">\r\n          <a [routerLink]=\"urlVehicleMasterList\">\r\n            <i class=\"fa fa-cab\"></i> {{ 'LblVehicle' | translate }} {{'LblList' | translate}} </a>\r\n        </li>\r\n        <li class=\"active\"> {{ breadCrumbList}} </li>\r\n      </ol>\r\n    </div>\r\n\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25 \">\r\n      <!-- <a class=\"btn btn-highlight navbar-right\" [routerLink]=\"[urlSVGUpdate]\" routerLinkActive=\"active\">{{ 'LblAddNew' | translate }}</a> -->\r\n      <wego-authorized-link [LinkModel]=\"addSharedVehicleGroupLink\"></wego-authorized-link>\r\n    </div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <wego-search-list [IsDeleted]=\"isDeleteAccess\" [IsDeleteEnabled]=\"isAnyChecked && isDeleteAccess\" (OnDeleteAll)=\"ShowDeleteModal()\"\r\n          (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\"\r\n          [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <p class=\"text-success\">{{ message }}</p>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center parent-checkbox\">\r\n                  <input [disabled]=\"!isDeleteAccess\" type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\">\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('groupName')\">\r\n                  {{ 'LblSharedVehicleGroup' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'groupName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Company\" class=\"cursor-pointer\" (click)=\"OnSort('companyName')\">\r\n                  {{ 'LblCompanyName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'companyName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <!-- <th class=\"text-center\">{{'LblSharedVehicleGroupAdmin' | translate}}</th> -->\r\n                <th class=\"text-center\">{{ 'LblAdmin' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblNoOfVegicles' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblNoOfDrivers' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblNumberOfContactTypeGroup' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblNumberOfSubscription' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblActiveInactive' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblEdit' | translate }}</th>\r\n                <!--<th class=\"text-center\">{{ 'LblDelete' | translate }}</th>-->\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let sharedVehicleGroup of sharedVehicleGroupList\">\r\n                  <td class=\"text-center\">\r\n                    <input *ngIf=\"!sharedVehicleGroup.isDeletable\" disabled type=\"checkbox\" name=\"isActive\">\r\n                    <input *ngIf=\"sharedVehicleGroup.isDeletable\" type=\"checkbox\" name=\"isActive\" [(ngModel)]=\"sharedVehicleGroup.isChecked\">\r\n                  </td>\r\n                  <td>{{ sharedVehicleGroup.groupName }}</td>\r\n                  <td *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Company\">{{ sharedVehicleGroup.companyName }}</td>\r\n                  <!-- <td class=\"text-center\">\r\n                    <a class=\"btn btn-primary cursor-pointer link-style\" [routerLink]=\"[urlSVGAdminList, { sharedvehiclegroupHashId : sharedVehicleGroup.sharedvehiclegroupHashId }]\">\r\n                      <span class=\"badge link-text\">{{ sharedVehicleGroup.totalSharedVehicleGroupAdmin }}</span>\r\n                    </a>\r\n                  </td> -->\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"!sharedVehicleGroup.isAdminCount\" class=\"btn btn-primary link-style\" disabled>\r\n                      <span class=\"badge link-text\">{{ sharedVehicleGroup.adminCount }}</span>\r\n                    </a>\r\n\r\n                    <a *ngIf=\"sharedVehicleGroup.isAdminCount\" class=\"btn btn-primary cursor-pointer link-style\" [routerLink]=\"urlAdminList +'/'+sharedVehicleGroup.sharedvehiclegroupHashId\">\r\n                      <span class=\"badge link-text\">{{ sharedVehicleGroup.adminCount }}</span>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"!sharedVehicleGroup.isVehicleCount\" class=\"btn btn-primary link-style\" disabled>\r\n                      <span class=\"badge link-text\">{{ sharedVehicleGroup.totalVehicles }}</span>\r\n                    </a>\r\n\r\n                    <a *ngIf=\"sharedVehicleGroup.isVehicleCount\" class=\"btn btn-primary cursor-pointer link-style\" [routerLink]=\"[urlVehicleList, { sharedVehicleGroupHashId : sharedVehicleGroup.sharedvehiclegroupHashId }]\">\r\n                      <span class=\"badge link-text\">{{ sharedVehicleGroup.totalVehicles }}</span>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"!sharedVehicleGroup.isDriverCount\" class=\"btn btn-primary link-style\" disabled>\r\n                      <span class=\"badge link-text\">{{ sharedVehicleGroup.totalDrivers }}</span>\r\n                    </a>\r\n\r\n                    <a *ngIf=\"sharedVehicleGroup.isDriverCount\" class=\"btn btn-primary cursor-pointer link-style\" [routerLink]=\"[urlDriverList, { sharedVehicleGroupHashId : sharedVehicleGroup.sharedvehiclegroupHashId }]\">\r\n                      <span class=\"badge link-text\">{{ sharedVehicleGroup.totalDrivers }}</span>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"!sharedVehicleGroup.isContractTypeGroupCount\" class=\"btn btn-primary link-style\" disabled>\r\n                      <span class=\"badge link-text\">{{ sharedVehicleGroup.totalContractGroups }}</span>\r\n                    </a>\r\n\r\n                    <a *ngIf=\"sharedVehicleGroup.isContractTypeGroupCount\" class=\"btn btn-primary cursor-pointer link-style\" [routerLink]=\"[urlContractTypeGroupList, { sharedVehicleGroupHashId : sharedVehicleGroup.sharedvehiclegroupHashId }]\">\r\n                      <span class=\"badge link-text\">{{ sharedVehicleGroup.totalContractGroups }}</span>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"!sharedVehicleGroup.isSubscriptionCount\" class=\"btn btn-primary link-style\" disabled>\r\n                      <span class=\"badge link-text\">{{ sharedVehicleGroup.totalSubscriptions }}</span>\r\n                    </a>\r\n\r\n                    <a *ngIf=\"sharedVehicleGroup.isSubscriptionCount\" class=\"btn btn-primary cursor-pointer link-style\" [routerLink]=\"urlSubscriptionList + '/' + sharedVehicleGroup.sharedvehiclegroupHashId\">\r\n                      <span class=\"badge link-text\">{{ sharedVehicleGroup.totalSubscriptions }}</span>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a class=\"cursor-pointer btn btn-xs btn-active-inactive\" [ngClass]=\"{'btn-active': !sharedVehicleGroup.isActive, 'btn-inactive': sharedVehicleGroup.isActive}\"\r\n                      (click)=\"ShowInActiveModal(sharedVehicleGroup.sharedvehiclegroupHashId, sharedVehicleGroup.isActive)\">\r\n                      <template [ngIf]=\"!sharedVehicleGroup.isActive\"> {{ 'LblActive' | translate}} </template>\r\n                      <template [ngIf]=\"sharedVehicleGroup.isActive\"> {{ 'LblInactive' | translate}} </template>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <!-- \"[urlSVGUpdate, { sharedvehiclegroupHashId : sharedVehicleGroup.sharedvehiclegroupHashId }]\" -->\r\n                    <a *ngIf=\"sharedVehicleGroup.isEditable\" [routerLink]=\"urlSVGUpdate + '/' + sharedVehicleGroup.sharedvehiclegroupHashId\">\r\n                      <i class=\"fa fa-pencil-square-o fa-fw\"></i>\r\n                    </a>\r\n                  </td>\r\n\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"10\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<wego-confirm-popup #deleteModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessModalClick()\" (onReject)=\"HideDeleteModal()\"></wego-confirm-popup>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n\r\n<wego-confirm-popup #inActiveModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessInActiveModalClick()\" (onReject)=\"HideInActiveModal()\"></wego-confirm-popup>";

/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var driver_model_1 = __webpack_require__(601);
	var driver_service_1 = __webpack_require__(570);
	var person_service_1 = __webpack_require__(771);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var instance_service_1 = __webpack_require__(500);
	var DriverListComponent = (function () {
	    function DriverListComponent(driverService, router, authService, personService, translate, instanceService) {
	        this.driverService = driverService;
	        this.router = router;
	        this.authService = authService;
	        this.personService = personService;
	        this.translate = translate;
	        this.instanceService = instanceService;
	        this.isAllowToBatchUploadPerson = false;
	    }
	    Object.defineProperty(DriverListComponent.prototype, "isAnyChecked", {
	        get: function () {
	            if (this.driverList) {
	                var isCheck = this.driverList.some(function (x) { return x.isChecked == true; });
	                if (isCheck) {
	                    if (this.driverList.every(function (x) { return x.isChecked == true; }))
	                        this.isParentCheck = true;
	                    else
	                        this.isParentCheck = false;
	                }
	                else {
	                    this.isParentCheck = false;
	                }
	                return isCheck;
	            }
	            else {
	                this.isParentCheck = false;
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DriverListComponent.prototype.ngOnInit = function () {
	        this.module = this.translate.instant('LblDriver');
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = ["driverName", "firstName", "lastName"];
	        this.model = new driver_model_1.DriverBlockModel();
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlDriverSVGList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DRIVER_SVG_LIST);
	        this.urlDriverUpdate = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DRIVER_UPDATE);
	        this.urlPersonUpdate = this.authService.GetURL(config_1.ApplicationRouteURL.URL_PERSON_UPDATE);
	        this.urlBatchUpload = this.authService.GetURL(config_1.ApplicationRouteURL.URL_BATCHUPLOADPERSON);
	        this.CheckIsAllowToBatchUploadPerson();
	        this.GetDriverList();
	    };
	    DriverListComponent.prototype.onSubmit = function (forms) {
	        this.model.activeFlag = this.activeFlag;
	        this.model.driverHashId = this.inActiveDriverHashId;
	        this.InActiveDriver(JSON.stringify(this.model));
	    };
	    DriverListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetDriverList();
	    };
	    DriverListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetDriverList();
	    };
	    DriverListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetDriverList();
	    };
	    ;
	    DriverListComponent.prototype.OnPagingChange = function (event) {
	        console.log(this.DataListModel);
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetDriverList();
	    };
	    DriverListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.driverService.ExportDriverList(this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "Driver" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	        ;
	    };
	    DriverListComponent.prototype.GetDriverList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.driverService.GetDriverList(this.DataListModel)
	            .subscribe(function (res) {
	            _this.driverList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    // public DeleteDriver(deleteDriverList: string[]) {
	    //   this.isLoading = true;
	    //   this.driverService.DeleteDriver(deleteDriverList)
	    //     .subscribe(
	    //     res => {
	    //       this.DataListModel.currentPage = 1;
	    //       this.GetDriverList();
	    //       this.popupMsg = this.translate.instant('LblRecordRemovedSuccess', [this.module]);
	    //       this.ShowSuccessPopup();
	    //     },
	    //     error => {
	    //       this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
	    //       this.isLoading = false;
	    //     });
	    // }
	    DriverListComponent.prototype.OnParentCheck = function (isChecked) {
	        this.driverList.forEach(function (x) { return x.isChecked = isChecked; });
	    };
	    DriverListComponent.prototype.ShowChildModal = function (driverHashId) {
	        if (driverHashId) {
	            this.popupMsg = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
	            this.isMultipleDelete = false;
	            this.deleteDriverHashId = driverHashId;
	        }
	        else {
	            this.popupMsg = this.translate.instant('LblRecordMultiplDeleteConfirmation', [this.module]);
	            this.isMultipleDelete = true;
	        }
	        this.childModal.show();
	    };
	    // public HideChildModal(): void {
	    //   this.deleteDriverHashId = "";
	    //   this.childModal.hide();
	    // }
	    // public SuccessModalClick(): void {
	    //   this.childModal.hide();
	    //   let deleteDiriverList: any[];
	    //   if (this.isMultipleDelete)
	    //     deleteDiriverList = this.driverList.filter(x => x.isChecked).map(x => x.driverMasterHashId);
	    //   else
	    //     deleteDiriverList.push(this.deleteDriverHashId);
	    //   this.DeleteDriver(deleteDiriverList);
	    //   this.childModal.hide();
	    // }
	    DriverListComponent.prototype.InActiveDriver = function (formData) {
	        var _this = this;
	        this.isLoading = true;
	        this.driverService.InActiveDriver(formData)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.inActiveModal.hide();
	                _this.DataListModel.currentPage = 1;
	                _this.GetDriverList();
	                _this.popupMsg = _this.translate.instant('LblRecordBlokUnBlockSuccess', [_this.module, _this.inActiveMessage]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.isLoading = false;
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    DriverListComponent.prototype.RemoveDriverLicenseBirthDate = function (formData) {
	        var _this = this;
	        this.isLoading = true;
	        this.driverService.RemoveDriverLicenseBirthDate(formData)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.removeLicenseModel.hide();
	                _this.DataListModel.currentPage = 1;
	                _this.GetDriverList();
	                _this.popupMsg = _this.translate.instant('LblRecordRemovedSuccess', [_this.removeLicenseNumber]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.isLoading = false;
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    DriverListComponent.prototype.ShowInActiveModal = function (vehicleMasterHashId, isActive) {
	        this.inActiveDriverHashId = vehicleMasterHashId;
	        this.activeFlag = !isActive;
	        this.inActiveMessage = !isActive ? this.translate.instant('LblBlock') : this.translate.instant('LblUnblock');
	        this.model.reason = null;
	        this.errorModel = null;
	        this.popupMsg = this.translate.instant('LblBlockUnblockConfirm', [this.inActiveMessage, this.module]);
	        this.inActiveModal.show(this.message);
	    };
	    DriverListComponent.prototype.ShowRemoveLicenseDetails = function (driverMasterHashId, licenceNumber) {
	        this.inActiveDriverHashId = driverMasterHashId;
	        this.licenseNumber = licenceNumber;
	        this.model.reason = null;
	        this.errorModel = null;
	        this.removeLicenseNumber = this.translate.instant('LblLicenseBirthDate');
	        this.popupMsg = this.translate.instant('LblRecordDeleteConfirmation', [this.removeLicenseNumber]);
	        this.removeLicenseModel.show(this.message);
	    };
	    DriverListComponent.prototype.HideInActiveModal = function () {
	        this.inActiveDriverHashId = "";
	        this.inActiveModal.hide();
	    };
	    DriverListComponent.prototype.SuccessInActiveModalClick = function () {
	        this.inActiveModal.hide();
	    };
	    DriverListComponent.prototype.SuccessRemoveLicenseBirthDateClick = function () {
	        this.removeLicenseModel.hide();
	        this.model.driverHashId = this.inActiveDriverHashId;
	        this.RemoveDriverLicenseBirthDate(this.model);
	    };
	    DriverListComponent.prototype.HideRemoveLicenseBirthDateClick = function () {
	        this.inActiveDriverHashId = "";
	        this.removeLicenseModel.hide();
	    };
	    // Add new driver
	    DriverListComponent.prototype.ShowAddDriverModal = function () {
	        this.addDriverModal.show();
	    };
	    DriverListComponent.prototype.SuccessAddDriverModal = function ($event) {
	        this.GetDriverList();
	        this.popupMsg = $event.SuccessMessage;
	        this.ShowSuccessPopup();
	    };
	    //Reset group admin password
	    DriverListComponent.prototype.ResetPersonPassword = function (personHashID) {
	        var _this = this;
	        this.personService.ResetPersonPassword(personHashID)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblResetPasswordSuccess');
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblResetPasswordFailure');
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    DriverListComponent.prototype.ShowResetPasswordModal = function (personHashID) {
	        this.resetPasswordPersonHashId = personHashID;
	        this.popupMsg = this.translate.instant('LblResetPasswordConfirmation');
	        this.resetPasswordModal.show();
	    };
	    DriverListComponent.prototype.HideResetPasswordModal = function () {
	        this.resetPasswordPersonHashId = "";
	        this.resetPasswordModal.hide();
	    };
	    DriverListComponent.prototype.SuccessResetPasswordModalClick = function () {
	        this.resetPasswordModal.hide();
	        this.ResetPersonPassword(this.resetPasswordPersonHashId);
	    };
	    DriverListComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    DriverListComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    DriverListComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    DriverListComponent.prototype.RedirectoPerson = function (personHashId) {
	        this.router.navigate([this.urlPersonUpdate + '/' + personHashId]);
	    };
	    DriverListComponent.prototype.ResendActivationMail = function (personHashID) {
	        var _this = this;
	        this.resetPasswordPersonHashId = personHashID;
	        this.personService.ReSendActivationMail(personHashID)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblResendActivationMailSuccess');
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblResendActivationMailFailure');
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    DriverListComponent.prototype.CheckIsAllowToBatchUploadPerson = function () {
	        var _this = this;
	        if (this.authService.IsGroupAdmin()) {
	            this.instanceService.CheckIsAllowToBatchUploadPerson()
	                .subscribe(function (res) {
	                _this.isAllowToBatchUploadPerson = res.data;
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            });
	        }
	    };
	    DriverListComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    __decorate([
	        core_1.ViewChild('childModal'), 
	        __metadata('design:type', Object)
	    ], DriverListComponent.prototype, "childModal", void 0);
	    __decorate([
	        core_1.ViewChild('inActiveModal'), 
	        __metadata('design:type', Object)
	    ], DriverListComponent.prototype, "inActiveModal", void 0);
	    __decorate([
	        core_1.ViewChild('addDriverModal'), 
	        __metadata('design:type', Object)
	    ], DriverListComponent.prototype, "addDriverModal", void 0);
	    __decorate([
	        core_1.ViewChild('resetPasswordModal'), 
	        __metadata('design:type', Object)
	    ], DriverListComponent.prototype, "resetPasswordModal", void 0);
	    __decorate([
	        core_1.ViewChild('removeLicenseModel'), 
	        __metadata('design:type', Object)
	    ], DriverListComponent.prototype, "removeLicenseModel", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], DriverListComponent.prototype, "successPopup", void 0);
	    DriverListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-driver-list',
	            template: __webpack_require__(791),
	            providers: [driver_service_1.DriverService, person_service_1.PersonService, instance_service_1.InstanceService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof driver_service_1.DriverService !== 'undefined' && driver_service_1.DriverService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof person_service_1.PersonService !== 'undefined' && person_service_1.PersonService) === 'function' && _d) || Object, (typeof (_e = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _e) || Object, (typeof (_f = typeof instance_service_1.InstanceService !== 'undefined' && instance_service_1.InstanceService) === 'function' && _f) || Object])
	    ], DriverListComponent);
	    return DriverListComponent;
	    var _a, _b, _c, _d, _e, _f;
	}());
	exports.DriverListComponent = DriverListComponent;


/***/ },
/* 791 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-8 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ breadCrumbList}} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li class=\"active\"> {{ breadCrumbList}} </li>\r\n      </ol>\r\n    </div>\r\n\r\n    <div class=\"col-md-4 col-sm-6 mar_t_25 \">\r\n      <!-- <a class=\"btn btn-highlight navbar-right\" (click)=\"ShowAddDriverModal()\">{{ 'LblAddNew' | translate }}</a> -->\r\n      <a *ngIf=\"isAllowToBatchUploadPerson\" class=\"btn btn-highlight navbar-right\" [routerLink]=\"[urlBatchUpload]\" routerLinkActive=\"active\"\r\n        style=\"margin-right: 15px;\">{{ 'LblBatchUpload' | translate }}</a>\r\n    </div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <!-- [IsDeleted]=\"true\" [IsDeleteEnabled]=\"isAnyChecked\" (OnDeleteAll)=\"ShowChildModal()\" -->\r\n        <wego-search-list (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\"\r\n          [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <!-- <th class=\"text-center parent-checkbox\"><input type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\"></th> -->\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('firstName')\">\r\n                  {{ 'LblFirstName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'firstName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('lastName')\">\r\n                  {{ 'LblLastName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'lastName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('driverName')\">\r\n                  {{ 'LblDriver' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'driverName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th>{{ 'LblReason' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblSharedVehicleGroup' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblResendActivationMail' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblResetPassword' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblEdit' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblBlockUnBlock' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblRemove' | translate }}</th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let driver of driverList\">\r\n                  <!-- <td class=\"text-center\"><input type=\"checkbox\" name=\"isActive\" [(ngModel)]=\"driver.isChecked\"></td> -->\r\n                  <td>{{ driver.firstName }}</td>\r\n                  <td>{{ driver.lastName }}</td>\r\n                  <td>{{ driver.driverName }}</td>\r\n                  <td>{{ driver.driverBlockReason }}</td>\r\n                  <td class=\"text-center\">\r\n                    <a disabled *ngIf=\"!driver.isDriverSubsctriptionEnable\"  class=\"btn btn-primary cursor-pointer link-style\">\r\n                      <span class=\"badge link-text\">{{ driver.totalSharedVehicleGroupDrivers }}</span>\r\n                    </a>\r\n                    <a *ngIf=\"driver.isDriverSubsctriptionEnable\" class=\"btn btn-primary cursor-pointer link-style\" [routerLink]=\"urlDriverSVGList+ '/'+  driver.driverMasterHashId \">\r\n                      <span class=\"badge link-text\">{{ driver.totalSharedVehicleGroupDrivers }}</span>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"driver.personNotActive\" class=\"btn btn-green btn-xs cursor-pointer\" (click)=\"ResendActivationMail(driver.personMasterHashId)\">\r\n                      {{ 'LblReSend' | translate}}\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a class=\"cursor-pointer\">\r\n                      <i class=\"fa fa-refresh fa-fw text-success\" (click)=\"ShowResetPasswordModal(driver.personMasterHashId)\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"driver.isEditable\" class=\"cursor-pointer\" (click)=\"RedirectoPerson(driver.personMasterHashId)\">\r\n                      <i class=\"fa fa-pencil-square-o fa-fw\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a class=\"cursor-pointer btn btn-xs btn-active-inactive\" [ngClass]=\"{'btn-active': driver.isBanned, 'btn-inactive': !driver.isBanned}\"\r\n                      (click)=\"ShowInActiveModal(driver.driverMasterHashId, driver.isBanned)\">\r\n                      <template [ngIf]=\"driver.isBanned\"> {{ 'LblUnblock' | translate}} </template>\r\n                      <template [ngIf]=\"!driver.isBanned\"> {{ 'LblBlock' | translate}} </template>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\"style=\"width: 7%;\">\r\n                    <a *ngIf=\"driver.licenceNumber && driver.isDriverLicenseRemove\" title=\"{{ 'LblRemoveLicenseBirthDate' | translate }}\" class=\"cursor-pointer btn btn-xs btn-active-inactive\" [ngClass]=\"{'btn-active': driver.licenceNumber, 'btn-inactive': !driver.licenceNumber}\"\r\n                      (click)=\"ShowRemoveLicenseDetails(driver.driverMasterHashId, driver.licenceNumber)\">\r\n                      <template [ngIf]=\"driver.licenceNumber\"> {{ 'LblRemove' | translate}} </template>\r\n                    </a>\r\n                  </td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"9\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<div bsModal #inActiveModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-sm\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"HideInActiveModal()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblConfirm' | translate }}</h4>\r\n      </div>\r\n\r\n      <form (ngSubmit)=\"onSubmit(ActivePrsonForm.value)\" #ActivePrsonForm=\"ngForm\">\r\n        <div class=\"modal-body\">\r\n          <div class=\"row\">\r\n            <div class=\"col-xs-12 form-group\">\r\n              {{ popupMsg }}\r\n            </div>\r\n            <div class=\"col-xs-12 form-group\" *ngIf=\"activeFlag\">\r\n\r\n              <textarea class=\"form-control\" rows=\"2\" id=\"comment\" [(ngModel)]=\"model.reason\" name=\"reason\" placeholder=\"{{ 'LblReasonDriver' | translate }}\"></textarea>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'reason' }}</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"modal-footer\">\r\n          <button type=\"submit\" class=\"btn btn-green\">{{ 'LblYes' | translate }}</button>\r\n          <button type=\"button\" class=\"btn btn-gray cursor-pointer\" (click)=\"HideInActiveModal()\">{{ 'LblNo' | translate }}</button>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<!-- <wego-add-driver-popup #addDriverModal (OnSuccessSelect)=\"SuccessAddDriverModal($event)\"></wego-add-driver-popup> -->\r\n\r\n<wego-confirm-popup #removeLicenseModel [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessRemoveLicenseBirthDateClick()\" (onReject)=\"HideRemoveLicenseBirthDateClick()\"></wego-confirm-popup>  \r\n\r\n<wego-confirm-popup #resetPasswordModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessResetPasswordModalClick()\" (onReject)=\"HideResetPasswordModal()\"></wego-confirm-popup>\r\n\r\n<!--<wego-confirm-popup #inActiveModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessInActiveModalClick()\" (onReject)=\"HideInActiveModal()\"></wego-confirm-popup>-->\r\n\r\n<!-- <wego-confirm-popup #childModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessModalClick()\" (onReject)=\"HideChildModal()\"></wego-confirm-popup> -->\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" [popupTitle]=\"popupTitle\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>";

/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var flatpickr_model_1 = __webpack_require__(83);
	var core_1 = __webpack_require__(3);
	var specialperiod_model_1 = __webpack_require__(793);
	var specialperiod_service_1 = __webpack_require__(794);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var common_1 = __webpack_require__(22);
	var SpecialPeriodUpdateComponent = (function () {
	    function SpecialPeriodUpdateComponent(specialperiodService, activeRoute, router, authService, translate, locationService) {
	        this.specialperiodService = specialperiodService;
	        this.activeRoute = activeRoute;
	        this.router = router;
	        this.authService = authService;
	        this.translate = translate;
	        this.locationService = locationService;
	        this.timeFormat = config_1.WeGoConfig.FLATPICKR_TIME_FORMAT;
	        this.submitted = false;
	    }
	    SpecialPeriodUpdateComponent.prototype.ngOnInit = function () {
	        this.module = this.translate.instant('LblSpecialPeriod');
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlSPecialPeriodList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SPECIAL_PERIOD_LIST);
	        this.model = new specialperiod_model_1.SpecialPeriodModel();
	        this.flatPickrConfigTimeFrom = this.SetDefaultFlatTimePickrConfig();
	        this.flatPickrConfigTimeTo = this.SetDefaultFlatTimePickrConfig();
	        this.GetSpecialPeriodDetails();
	    };
	    SpecialPeriodUpdateComponent.prototype.SetDefaultFlatTimePickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = true;
	        flatPickrConfig.time_24hr = true;
	        flatPickrConfig.noCalendar = true;
	        flatPickrConfig.dateFormat = this.timeFormat;
	        return flatPickrConfig;
	    };
	    SpecialPeriodUpdateComponent.prototype.GetSpecialPeriodDetails = function () {
	        var _this = this;
	        this.sub = this.activeRoute
	            .params
	            .subscribe(function (params) {
	            _this.specialPeriodHashId = params['specialPeriodHashId'] || '';
	            if (_this.specialPeriodHashId != '') {
	                _this.isEditMode = true;
	                _this.specialperiodService.GetSpecialPerionByHashId(_this.specialPeriodHashId)
	                    .subscribe(function (res) { return _this.model = res.data; }, function (error) {
	                    _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	                });
	            }
	        });
	        this.breadCrumbTitle = this.isEditMode ? this.translate.instant('LblEditPage', [this.module]) : this.translate.instant('LblAddPage', [this.module]);
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	    };
	    SpecialPeriodUpdateComponent.prototype.onSubmit = function (forms) {
	        this.AddNewSpecialPeriod();
	    };
	    SpecialPeriodUpdateComponent.prototype.AddNewSpecialPeriod = function () {
	        var _this = this;
	        this.specialperiodService.UpdateSpecialPeriod(this.model)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblRecordUpdatedSuccess', [_this.module]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    SpecialPeriodUpdateComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    SpecialPeriodUpdateComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    SpecialPeriodUpdateComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    SpecialPeriodUpdateComponent.prototype.OnBackClick = function () {
	        this.locationService.back();
	    };
	    SpecialPeriodUpdateComponent.prototype.ngOnDestroy = function () {
	        if (this.sub) {
	            this.sub.unsubscribe();
	        }
	    };
	    __decorate([
	        core_1.ViewChild('alertModal'), 
	        __metadata('design:type', Object)
	    ], SpecialPeriodUpdateComponent.prototype, "alertModal", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], SpecialPeriodUpdateComponent.prototype, "successPopup", void 0);
	    SpecialPeriodUpdateComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-specialperiod-update',
	            template: __webpack_require__(795),
	            providers: [specialperiod_service_1.SpecialPeriodService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof specialperiod_service_1.SpecialPeriodService !== 'undefined' && specialperiod_service_1.SpecialPeriodService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _d) || Object, (typeof (_e = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _e) || Object, (typeof (_f = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _f) || Object])
	    ], SpecialPeriodUpdateComponent);
	    return SpecialPeriodUpdateComponent;
	    var _a, _b, _c, _d, _e, _f;
	}());
	exports.SpecialPeriodUpdateComponent = SpecialPeriodUpdateComponent;


/***/ },
/* 793 */
/***/ function(module, exports) {

	"use strict";
	var SpecialPeriodModel = (function () {
	    function SpecialPeriodModel() {
	        this.sunFlag = false;
	        this.monFlag = true;
	        this.tueFlag = true;
	        this.wedFlag = true;
	        this.thuFlag = true;
	        this.friFlag = true;
	        this.satFlag = false;
	    }
	    return SpecialPeriodModel;
	}());
	exports.SpecialPeriodModel = SpecialPeriodModel;


/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var SpecialPeriodService = (function () {
	    function SpecialPeriodService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    SpecialPeriodService.prototype.GetSpecialPeriodList = function (input) {
	        var getSpecialPeriodUrl = config_1.WeGoConfig.API_GET_SPECIALPERIOD_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getSpecialPeriodUrl = getSpecialPeriodUrl + "?" + queryString;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getSpecialPeriodUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SpecialPeriodService.prototype.UpdateSpecialPeriod = function (specialperiod) {
	        var body = specialperiod;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_POST_SPECIAL_PERIOD_DETAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SpecialPeriodService.prototype.GetSpecialPerionByHashId = function (specialPeriondHashId) {
	        var getTimeBlockUrl = config_1.WeGoConfig.API_GET_SPECIAL_PERIOD_BY_HASH + "?specialPeriondHashId=" + specialPeriondHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getTimeBlockUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SpecialPeriodService.prototype.ExportSpecialPeriodList = function (input) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var getAttributeListUrl = config_1.WeGoConfig.API_EXPORT_SPECIAL_PERIOD_LIST + "?" + queryString;
	        var headers = this.authService.GetHeader('text/csv');
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getAttributeListUrl, options);
	    };
	    SpecialPeriodService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], SpecialPeriodService);
	    return SpecialPeriodService;
	    var _a, _b;
	}());
	exports.SpecialPeriodService = SpecialPeriodService;


/***/ },
/* 795 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{breadCrumbTitle}}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li><a [routerLink]=\"urlDefaultPage\"><i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a></li>\r\n        <li><a [routerLink]=\"urlSPecialPeriodList\"><i class=\"fa fa-clock-o\"></i>{{breadCrumbList}}</a></li>\r\n        <li class=\"active\">{{breadCrumbTitle}}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"nopad\">\r\n      <form (ngSubmit)=\"onSubmit(AddSpecialPeriodForm.value)\" #AddSpecialPeriodForm=\"ngForm\">\r\n        <div class=\"form-group col-md-4\">\r\n          <label> <span class=\"text text-danger\">*</span>\r\n            {{ 'LblspecialPeriodName' | translate }}\r\n          </label>\r\n          <input [disabled]=\"isEditMode\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblspecialPeriodName' | translate }}\" [(ngModel)]=\"model.specialPeriodName\"\r\n            name=\"SpecialPeriodName\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'specialPeriodName' }}</span>\r\n        </div>\r\n        <div class=\"form-group col-md-4\">\r\n          <label> <span class=\"text text-danger\">*</span>{{ 'LblSpecialPeriodStartTime' | translate }} </label>\r\n\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblSpecialPeriodStartTime' | translate }}\" [(ngModel)]=\"model.specialPeriodStartTime\"\r\n            name=\"SpecialPeriodStartTime\">\r\n\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'specialPeriodStartTime' }}</span>\r\n        </div>\r\n        <div class=\"form-group col-md-4\">\r\n          <label> <span class=\"text text-danger\">*</span> {{ 'LblSpecialPeriodEndTime' | translate }}</label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblSpecialPeriodEndTime' | translate }}\" [(ngModel)]=\"model.specialPeriodEndTime\"\r\n            name=\"SpecialPeriodEndTime\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'specialPeriodEndTime' }}</span>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <fieldset class=\"col-md-12\">\r\n          <legend class=\"legendStyle\">{{ 'LblSpecialPeriodWeekDays' | translate }}</legend>\r\n          <div class=\"form-group\">\r\n            <div class=\"col-sm-3\">\r\n              <div class=\"checkbox\">\r\n                <label><input type=\"checkbox\" [checked]=\"model.sunFlag\" (change)=\"model.sunFlag = $event.target.checked\">{{ 'LblSunday' | translate }}</label>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-sm-3\">\r\n              <div class=\"checkbox\">\r\n                <label><input type=\"checkbox\" [checked]=\"model.monFlag\" (change)=\"model.monFlag = $event.target.checked\">{{ 'LblMonday' | translate }}</label>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-sm-3\">\r\n              <div class=\"checkbox\">\r\n                <label><input type=\"checkbox\" [checked]=\"model.tueFlag\" (change)=\"model.tueFlag = $event.target.checked\">{{ 'LblTuesday' | translate }}</label>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-sm-3\">\r\n              <div class=\"checkbox\">\r\n                <label><input type=\"checkbox\" [checked]=\"model.wedFlag\" (change)=\"model.wedFlag = $event.target.checked\">{{ 'LblWednesday' | translate }}</label>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-sm-3\">\r\n              <div class=\"checkbox\">\r\n                <label><input type=\"checkbox\" [checked]=\"model.thuFlag\" (change)=\"model.thuFlag = $event.target.checked\">{{ 'LblThursday'  | translate }}</label>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-sm-3\">\r\n              <div class=\"checkbox\">\r\n                <label><input type=\"checkbox\" [checked]=\"model.friFlag\" (change)=\"model.friFlag = $event.target.checked\">{{ 'LblFriday' | translate }}</label>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-sm-3\">\r\n              <div class=\"checkbox\">\r\n                <label><input type=\"checkbox\" [checked]=\"model.satFlag\" (change)=\"model.satFlag = $event.target.checked\">{{ 'LblSaturday'  | translate }}</label>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </fieldset>\r\n        <div class=\"row no-margin\">\r\n          <div class=\"col-sm-12\">\r\n            <hr>\r\n            <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnBackClick()\">{{ 'LblCancel' | translate }}</a> &nbsp;&nbsp;\r\n            <button class=\"btn btn-green\" type=\"submit\">{{ 'LblSave' | translate }}</button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n";

/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var specialperiod_service_1 = __webpack_require__(794);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var SpecialPeriodListComponent = (function () {
	    function SpecialPeriodListComponent(specialPeriodService, authService, router, translate) {
	        this.specialPeriodService = specialPeriodService;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	    }
	    SpecialPeriodListComponent.prototype.ngOnInit = function () {
	        this.module = this.translate.instant('LblSpecialPeriod');
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = ["specialPeriodName", "sunFlag", "monFlag", "tueFlag", "wedFlag", "thuFlag", "friFlag", "satFlag"];
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlSpecialPeriodpdate = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SPECIAL_PERIOD_UPDATE);
	        this.GetSpecialPeriodList();
	    };
	    SpecialPeriodListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetSpecialPeriodList();
	    };
	    SpecialPeriodListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetSpecialPeriodList();
	    };
	    SpecialPeriodListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetSpecialPeriodList();
	    };
	    ;
	    SpecialPeriodListComponent.prototype.OnPagingChange = function (event) {
	        console.log(this.DataListModel);
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetSpecialPeriodList();
	    };
	    SpecialPeriodListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.specialPeriodService.ExportSpecialPeriodList(this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "SpecialPeriodList" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SpecialPeriodListComponent.prototype.GetSpecialPeriodList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.specialPeriodService.GetSpecialPeriodList(this.DataListModel)
	            .subscribe(function (res) {
	            _this.specialPeriodServiceList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SpecialPeriodListComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    SpecialPeriodListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-specialperiod-list',
	            template: __webpack_require__(797),
	            providers: [specialperiod_service_1.SpecialPeriodService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof specialperiod_service_1.SpecialPeriodService !== 'undefined' && specialperiod_service_1.SpecialPeriodService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object])
	    ], SpecialPeriodListComponent);
	    return SpecialPeriodListComponent;
	    var _a, _b, _c, _d;
	}());
	exports.SpecialPeriodListComponent = SpecialPeriodListComponent;


/***/ },
/* 797 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ breadCrumbList}} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li><a [routerLink]=\"urlDefaultPage\"><i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a></li>\r\n        <li class=\"active\"> {{ breadCrumbList}} </li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <p class=\"text-success\">{{ message }}</p>\r\n        <wego-search-list (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\"\r\n          [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('specialPeriodName')\">\r\n                  {{ 'LblspecialPeriodName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'specialPeriodName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('specialPeriodStartTimeSpan')\">\r\n                  {{ 'LblSpecialPeriodStartTime' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'specialPeriodStartTime'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('specialPeriodEndTimeSpan')\">\r\n                  {{ 'LblSpecialPeriodEndTime' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'specialPeriodEndTime'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('monFlag')\">\r\n                  {{ 'LblSMo' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'monFlag'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('tueFlag')\">\r\n                  {{ 'LblSTu' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'tueFlag'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('wedFlag')\">\r\n                  {{ 'LblSWe' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'wedFlag'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('thuFlag')\">\r\n                  {{ 'LblSTh' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'thuFlag'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('friFlag')\">\r\n                  {{ 'LblSFr' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'friFlag'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('satFlag')\">\r\n                  {{ 'LblSSa' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'satFlag'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('sunFlag')\">\r\n                  {{ 'LblSSu' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'sunFlag'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"text-center\">\r\n                  {{'LblEdit' | translate }}\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems  != 0\">\r\n                <tr *ngFor=\"let item of specialPeriodServiceList\">\r\n                  <td>{{ item.specialPeriodName }}</td>\r\n                  <td>{{item.specialPeriodStartTime}}</td>\r\n                  <td>{{item.specialPeriodEndTime}}</td>\r\n                  <td class=\"text-center\">\r\n                    <i class=\"fa fa-fw\" [ngClass]=\"{'fa-check-square-o': item.monFlag, 'fa-square-o': !item.monFlag}\"></i>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <i class=\"fa fa-fw\" [ngClass]=\"{'fa-check-square-o': item.tueFlag, 'fa-square-o': !item.tueFlag}\"></i>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <i class=\"fa fa-fw\" [ngClass]=\"{'fa-check-square-o': item.wedFlag, 'fa-square-o': !item.wedFlag}\"></i>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <i class=\"fa fa-fw\" [ngClass]=\"{'fa-check-square-o': item.thuFlag, 'fa-square-o': !item.thuFlag}\"></i>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <i class=\"fa fa-fw\" [ngClass]=\"{'fa-check-square-o': item.friFlag, 'fa-square-o': !item.friFlag}\"></i>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <i class=\"fa fa-fw\" [ngClass]=\"{'fa-check-square-o': item.satFlag, 'fa-square-o': !item.satFlag}\"></i>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <i class=\"fa fa-fw\" [ngClass]=\"{'fa-check-square-o': item.sunFlag, 'fa-square-o': !item.sunFlag}\"></i>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a [routerLink]=\"[urlSpecialPeriodpdate, { specialPeriodHashId : item.specialPeriodHashId }]\">\r\n                      <i class=\"fa fa-pencil-square-o fa-fw\"></i>\r\n                    </a>\r\n                  </td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems  == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"11\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>";

/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var vehicleattributecategory_service_1 = __webpack_require__(799);
	var config_1 = __webpack_require__(60);
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var instance_service_1 = __webpack_require__(500);
	var core_1 = __webpack_require__(3);
	var vehicleattribute_model_1 = __webpack_require__(800);
	var vehicleattribute_service_1 = __webpack_require__(561);
	var router_1 = __webpack_require__(26);
	var config_2 = __webpack_require__(60);
	var common_1 = __webpack_require__(22);
	var VehicleAttributeUpdateComponent = (function () {
	    function VehicleAttributeUpdateComponent(vehicleAttributeService, vehicleAttributeCategoryService, activeRoute, router, authService, translate, instanceService, locationService) {
	        this.vehicleAttributeService = vehicleAttributeService;
	        this.vehicleAttributeCategoryService = vehicleAttributeCategoryService;
	        this.activeRoute = activeRoute;
	        this.router = router;
	        this.authService = authService;
	        this.translate = translate;
	        this.instanceService = instanceService;
	        this.locationService = locationService;
	        this.submitted = false;
	        this.roleLevel = config_1.RoleLevel;
	    }
	    VehicleAttributeUpdateComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.accessDeniedErrorCode = "412";
	        this.pageName = "Vehicle_Attribute";
	        this.module = this.translate.instant("LblVehicleAttributes");
	        this.urlDefaultPage = this.authService.GetURL(config_2.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlVehicleAttributeList = this.authService.GetURL(config_2.ApplicationRouteURL.URL_VEHICLEATTRIBUTE_LIST);
	        this.model = new vehicleattribute_model_1.VehicleAttributeModel();
	        this.sub = this.activeRoute.params.subscribe(function (params) {
	            var categryAttributeHashId = params["id"] || "";
	            if (categryAttributeHashId != "") {
	                _this.GetInstanceListDropdown(config_2.PermissionType.EDIT);
	            }
	            else {
	                _this.GetInstanceListDropdown(config_2.PermissionType.INSERT);
	            }
	        });
	    };
	    VehicleAttributeUpdateComponent.prototype.GetVehicleAttributeDetails = function () {
	        var _this = this;
	        this.sub = this.activeRoute.params.subscribe(function (params) {
	            _this.vehicleAttributeHashId = params["id"] || "";
	            if (_this.vehicleAttributeHashId != "") {
	                _this.isEditMode = true;
	                _this.vehicleAttributeService
	                    .GetVehicleAttributeByHashId(_this.vehicleAttributeHashId)
	                    .subscribe(function (res) { return (_this.model = res.data); }, function (error) {
	                    _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	                }, function () {
	                    _this.GetVehicleAttributeCategoryListByInstance(_this.model.instanceHashId, _this.model.vehicleAttributeCategoryHashId);
	                });
	            }
	            else {
	                _this.isEditMode = false;
	            }
	        });
	        this.breadCrumbTitle = this.isEditMode
	            ? this.translate.instant("LblEditPage", [this.module])
	            : this.translate.instant("LblAddPage", [this.module]);
	        this.breadCrumbList = this.translate.instant("LblListPage", [this.module]);
	    };
	    VehicleAttributeUpdateComponent.prototype.GetVehicleAttributeCategoryList = function () {
	        var _this = this;
	        this.vehicleAttributeCategoryService
	            .GetVehicleAttributeCategoryList()
	            .subscribe(function (res) {
	            _this.apiResponse = res;
	            _this.vehicleAttributeCategoryList = res.data;
	            // this.model.vehicleAttributeCategoryHashId = this.model.vehicleAttributeCategoryHashId || this.vehicleAttributeCategoryList[0].vehicleAttributeCategoryHashId;
	        }, function (error) {
	            _this.errorMessage = error;
	        }, function () { return _this.GetVehicleAttributeDetails(); });
	    };
	    VehicleAttributeUpdateComponent.prototype.GetVehicleAttributeCategoryListByInstance = function (instanceHashId, vehicleAttributeCategoryHashId) {
	        var _this = this;
	        this.vehicleAttributeCategoryService
	            .GetVehicleAttributeCategoryByInstance(instanceHashId)
	            .subscribe(function (res) {
	            _this.apiResponse = res;
	            _this.vehicleAttributeCategoryList = res.data;
	        }, function (error) {
	            _this.errorMessage = error;
	        });
	    };
	    VehicleAttributeUpdateComponent.prototype.onSubmit = function (forms) {
	        this.submitted = true;
	        this.AddNewVehicleAttribute(JSON.stringify(this.model));
	    };
	    VehicleAttributeUpdateComponent.prototype.AddNewVehicleAttribute = function (formData) {
	        var _this = this;
	        this.vehicleAttributeService.AddNewVehicleAttribute(formData).subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.isEditMode
	                    ? _this.translate.instant("LblRecordUpdatedSuccess", [_this.module])
	                    : _this.translate.instant("LblRecordAddedSuccess", [_this.module]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    VehicleAttributeUpdateComponent.prototype.GetInstanceListDropdown = function (permissionType) {
	        var _this = this;
	        this.instanceService.GetInstanceListDropdownForAddUpdatePage(this.pageName, permissionType).subscribe(function (res) {
	            _this.apiResponse = res;
	            _this.instanceList = res.data;
	            if (_this.instanceList.length == 0) {
	                _this.authService.HandleErrorStatusCode(_this.accessDeniedErrorCode);
	            }
	            if (_this.instanceList && _this.instanceList.length > 0) {
	                if (!_this.model.instanceHashId && _this.instanceList.length == 1) {
	                    _this.model.instanceHashId = _this.instanceList[0].keyHash;
	                    _this.onChangeSelectedInstance(_this.model.instanceHashId);
	                }
	            }
	        }, function (error) {
	            _this.errorMessage = error;
	        }, function () { return _this.GetVehicleAttributeDetails(); });
	    };
	    VehicleAttributeUpdateComponent.prototype.onChangeSelectedInstance = function (instanceHashId) {
	        this.vehicleAttributeCategoryList = [];
	        this.model.vehicleAttributeCategoryHashId = "";
	        this.GetVehicleAttributeCategoryListByInstance(instanceHashId);
	    };
	    VehicleAttributeUpdateComponent.prototype.ShowAlertModal = function () {
	        this.alertModal.show();
	    };
	    VehicleAttributeUpdateComponent.prototype.HideAlertModal = function () {
	        this.alertModal.hide();
	    };
	    VehicleAttributeUpdateComponent.prototype.onChangeSelectedField = function (value) {
	        this.model.vehicleAttributeCategoryHashId = value;
	    };
	    VehicleAttributeUpdateComponent.prototype.SuccessAlertModalClick = function () {
	        this.alertModal.hide();
	        this.router.navigate([this.urlVehicleAttributeList]);
	    };
	    VehicleAttributeUpdateComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    VehicleAttributeUpdateComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    VehicleAttributeUpdateComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    VehicleAttributeUpdateComponent.prototype.OnBackClick = function () {
	        this.locationService.back();
	    };
	    VehicleAttributeUpdateComponent.prototype.ngOnDestroy = function () {
	        if (this.sub) {
	            this.sub.unsubscribe();
	        }
	    };
	    __decorate([
	        core_1.ViewChild("alertModal"), 
	        __metadata('design:type', Object)
	    ], VehicleAttributeUpdateComponent.prototype, "alertModal", void 0);
	    __decorate([
	        core_1.ViewChild("successPopup"), 
	        __metadata('design:type', Object)
	    ], VehicleAttributeUpdateComponent.prototype, "successPopup", void 0);
	    VehicleAttributeUpdateComponent = __decorate([
	        core_1.Component({
	            selector: "wego-vehicleattribute-list",
	            template: __webpack_require__(801),
	            providers: [
	                vehicleattributecategory_service_1.VehicleAttributeCategoryService,
	                vehicleattribute_service_1.VehicleAttributeService,
	                instance_service_1.InstanceService
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof vehicleattribute_service_1.VehicleAttributeService !== 'undefined' && vehicleattribute_service_1.VehicleAttributeService) === 'function' && _a) || Object, (typeof (_b = typeof vehicleattributecategory_service_1.VehicleAttributeCategoryService !== 'undefined' && vehicleattributecategory_service_1.VehicleAttributeCategoryService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _e) || Object, (typeof (_f = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _f) || Object, (typeof (_g = typeof instance_service_1.InstanceService !== 'undefined' && instance_service_1.InstanceService) === 'function' && _g) || Object, (typeof (_h = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _h) || Object])
	    ], VehicleAttributeUpdateComponent);
	    return VehicleAttributeUpdateComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h;
	}());
	exports.VehicleAttributeUpdateComponent = VehicleAttributeUpdateComponent;


/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var VehicleAttributeCategoryService = (function () {
	    function VehicleAttributeCategoryService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    VehicleAttributeCategoryService.prototype.GetVehicleAttributeCategoryList = function (input) {
	        var geteVehicleAttributeUrl = config_1.WeGoConfig.API_GET_VEHICLEATTRIBUTECATEGORY_DETAIL;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            geteVehicleAttributeUrl = geteVehicleAttributeUrl + "?" + queryString;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(geteVehicleAttributeUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    VehicleAttributeCategoryService.prototype.ExportVehicleAttributeCategoryList = function (input) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var geteVehicleAttributeUrl = config_1.WeGoConfig.API_EXPORT_VEHICLEATTRIBUTECATEGORY_LIST + "?" + queryString;
	        var headers = this.authService.GetHeader('text/csv');
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(geteVehicleAttributeUrl, options);
	    };
	    VehicleAttributeCategoryService.prototype.GetVehicleAttributeCategoryByHashId = function (vehicleAttributeCategoryHashId) {
	        var getvehicleAttributeUrl = config_1.WeGoConfig.API_GET_VEHICLEATTRIBUTE_CATEGORY_BY_HASH + "?vehicleAttributeCategoryHashID=" + vehicleAttributeCategoryHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getvehicleAttributeUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    VehicleAttributeCategoryService.prototype.AddNewVehicleAttributeCategory = function (vehicleAttributeCategoryModel) {
	        var body = vehicleAttributeCategoryModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_POST_VEHICLEATTRIBUTE_CATEGORY_DETAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    VehicleAttributeCategoryService.prototype.GetVehicleAttributeCategoryByInstance = function (instanceHashId) {
	        var getvehicleAttributeUrl = config_1.WeGoConfig.API_GET_VEHICLEATTRIBUTECATEGORY_BY_INSTANCE + "?instanceHashId=" + instanceHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getvehicleAttributeUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    VehicleAttributeCategoryService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], VehicleAttributeCategoryService);
	    return VehicleAttributeCategoryService;
	    var _a, _b;
	}());
	exports.VehicleAttributeCategoryService = VehicleAttributeCategoryService;


/***/ },
/* 800 */
/***/ function(module, exports) {

	"use strict";
	var VehicleAttributeModel = (function () {
	    function VehicleAttributeModel() {
	        this.vehicleAttributeCategoryHashId = '';
	        this.instanceHashId = '';
	    }
	    return VehicleAttributeModel;
	}());
	exports.VehicleAttributeModel = VehicleAttributeModel;


/***/ },
/* 801 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{breadCrumbTitle}}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"urlVehicleAttributeList\">\r\n            <i class=\"fa fa-tags fa-fw\"></i>{{breadCrumbList}}</a>\r\n        </li>\r\n        <li class=\"active\">{{breadCrumbTitle}}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"nopad\">\r\n      <form (ngSubmit)=\"onSubmit(AddVehicleAttributeForm.value)\" #AddVehicleAttributeForm=\"ngForm\">\r\n        <input type=\"hidden\" class=\"form-control\" [(ngModel)]=\"model.vehicleAttributeHashId\" name=\"vehicleAttributeHashId\">\r\n        <input type=\"hidden\" class=\"form-control\" [(ngModel)]=\"model.vehicleAttributeCategoryHashId\" name=\"vehicleAttributeCategoryHashId\">\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblVehicleAttributeName' | translate }}\r\n          </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblVehicleAttributeName' | translate }}\" [(ngModel)]=\"model.attributeName\"\r\n            name=\"AttributeName\" maxlength=\"100\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'attributeName' }}</span>\r\n        </div>        \r\n        <!-- <div *ngIf=\"instanceList && instanceList.length > 1\" class=\"form-group col-md-4\"> -->\r\n        <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Instance\" class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblInstance' | translate }}</label>\r\n          <select [disabled]=\"isEditMode\" [(ngModel)]=\"model.instanceHashId\" class=\"form-control\" name=\"instanceHashId\" (change)=\"onChangeSelectedInstance($event.target.value)\">\r\n            <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblInstance' | translate }}</option>\r\n            <option *ngFor=\"let item of instanceList\" [attr.value]=\"item.keyHash\">{{ item.value }}</option>\r\n          </select>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'instanceHashId' }}</span>\r\n        </div>\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblVehicleAttributeCategory' | translate }}\r\n          </label>\r\n          <select [(ngModel)]=\"model.vehicleAttributeCategoryHashId\" class=\"form-control\" name=\"vehicleAttributeCategoryHashId\">\r\n            <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblVehicleAttributeCategory' | translate }}</option>\r\n            <option *ngFor=\"let item of vehicleAttributeCategoryList\" [ngValue]=\"item.vehicleAttributeCategoryHashId\">{{ item.vehicleAttributeCategoryName }}</option>\r\n          </select>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'vehicleAttributeCategoryHashId' }}</span>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            {{ 'LblVehicleAttributeDesc' | translate }}\r\n          </label>\r\n          <textarea class=\"form-control\" placeholder=\"{{ 'LblVehicleAttributeDesc' | translate }}\" [(ngModel)]=\"model.attributeDesc\"\r\n            name=\"AttributeDesc\" maxlength=\"200\"></textarea>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'attributeDesc' }}</span>\r\n        </div>\r\n\r\n        <div class=\"row no-margin\">\r\n          <div class=\"col-sm-12\">\r\n            <hr>\r\n            <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnBackClick()\">{{ 'LblCancel' | translate }}</a> &nbsp;&nbsp;\r\n            <button class=\"btn btn-green\" type=\"submit\">{{ 'LblSave' | translate }}</button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>";

/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var vehicleattribute_service_1 = __webpack_require__(561);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var VehicleAttributeListComponent = (function () {
	    function VehicleAttributeListComponent(vehicleattributeService, authService, router, translate) {
	        this.vehicleattributeService = vehicleattributeService;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.roleLevel = config_1.RoleLevel;
	    }
	    VehicleAttributeListComponent.prototype.ngOnInit = function () {
	        this.module = this.translate.instant('LblVehicleAttribute');
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        if (this.authService.GetHighestRoleLevel() <= this.roleLevel.Instance) {
	            this.DataListModel.searchField = ["attributeName", "instanceName", "vehicleAttributeCategoryName", "attributeDesc"];
	        }
	        else {
	            this.DataListModel.searchField = ["attributeName", "vehicleAttributeCategoryName", "attributeDesc"];
	        }
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlVehicleAttributeAdd = this.authService.GetURL(config_1.ApplicationRouteURL.URL_VEHICLEATTRIBUTE_ADD);
	        this.urlVehicleAttributeUpdate = this.authService.GetURL(config_1.ApplicationRouteURL.URL_VEHICLEATTRIBUTE_UPDATE);
	        this.GetVehicleAttributeList();
	        this.addVehicleAttributeLink = new config_1.WeGoAuthorizedLink(this.urlVehicleAttributeAdd, config_1.Permission.PR_VEHICLE_ATTRIBUTE, config_1.PermissionType.INSERT, 'btn btn-highlight navbar-right', 'LblAddNew');
	    };
	    VehicleAttributeListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetVehicleAttributeList();
	    };
	    VehicleAttributeListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetVehicleAttributeList();
	    };
	    VehicleAttributeListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetVehicleAttributeList();
	    };
	    ;
	    VehicleAttributeListComponent.prototype.OnPagingChange = function (event) {
	        console.log(this.DataListModel);
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetVehicleAttributeList();
	    };
	    VehicleAttributeListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.vehicleattributeService.ExportVehicleAttributeList(this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "VehicleAttributeList" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    VehicleAttributeListComponent.prototype.GetVehicleAttributeList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.vehicleattributeService.GetVehicleAttributeList(this.DataListModel)
	            .subscribe(function (res) {
	            _this.vehicleattributeList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    VehicleAttributeListComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    VehicleAttributeListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-vehicleattribute',
	            template: __webpack_require__(803),
	            providers: [vehicleattribute_service_1.VehicleAttributeService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof vehicleattribute_service_1.VehicleAttributeService !== 'undefined' && vehicleattribute_service_1.VehicleAttributeService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object])
	    ], VehicleAttributeListComponent);
	    return VehicleAttributeListComponent;
	    var _a, _b, _c, _d;
	}());
	exports.VehicleAttributeListComponent = VehicleAttributeListComponent;


/***/ },
/* 803 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n    <section class=\"content-header\">\r\n        <div class=\"col-md-9 col-sm-6\">\r\n            <h1 class=\"pagename\">{{ breadCrumbList}} </h1>\r\n            <ol class=\"breadcrumb\">\r\n                <li>\r\n                    <a [routerLink]=\"urlDefaultPage\">\r\n                        <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n                </li>\r\n                <li class=\"active\"> {{ breadCrumbList}} </li>\r\n            </ol>\r\n        </div>\r\n        <div class=\"col-md-3 col-sm-6 mar_t_25 \">\r\n            <wego-authorized-link [LinkModel]=\"addVehicleAttributeLink\"></wego-authorized-link>\r\n            <!-- <a class=\"btn btn-highlight navbar-right\" [routerLink]=\"[urlVehicleAttributeUpdate]\">{{'LblAddNew' | translate}}</a> -->\r\n        </div>\r\n\r\n        <div class=\"clearfix\"></div>\r\n\r\n        <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n\r\n        <div class=\"clearfix\"></div>\r\n    </section>\r\n    <section class=\"content\">\r\n        <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n                <p class=\"text-success\">{{ message }}</p>\r\n                <wego-search-list (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\"\r\n                    [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n                <div class=\"table table-responsive mar_bot_ziro\">\r\n                    <table class=\"table table-bordered mar_bot_ziro\">\r\n                        <thead>\r\n                            <tr>\r\n                                <th class=\"cursor-pointer\" (click)=\"OnSort('attributeName')\">\r\n                                    {{ 'LblVehicleAttributeName' | translate }}\r\n                                    <wego-sort-list [FieldName]=\"'attributeName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                                </th>\r\n                                <th *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Instance\" class=\"cursor-pointer\" (click)=\"OnSort('intanceName')\">\r\n                                    {{ 'LblInstanceName' | translate }}\r\n                                    <wego-sort-list [FieldName]=\"'intanceName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                                </th>\r\n                                <th class=\"cursor-pointer\" (click)=\"OnSort('vehicleAttributeCategoryName')\">\r\n                                    {{ 'LblVehicleAttributeCategory' | translate }}\r\n                                    <wego-sort-list [FieldName]=\"'vehicleAttributeCategoryName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                                </th>\r\n                                <th class=\"cursor-pointer\" (click)=\"OnSort('attributeDesc')\">\r\n                                    {{ 'LblVehicleAttributeDesc' | translate }}\r\n                                    <wego-sort-list [FieldName]=\"'attributeDesc'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                                </th>\r\n                                <th class=\"text-center\">\r\n                                    {{'LblEdit' | translate }}\r\n                                </th>\r\n                            </tr>\r\n                        </thead>\r\n                        <tbody>\r\n                            <template [ngIf]=\"DataListModel.totalItems  != 0\">\r\n                                <tr *ngFor=\"let vehicleattribute of vehicleattributeList\">\r\n                                    <td>{{ vehicleattribute.attributeName }}</td>\r\n                                    <td *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Instance\">{{ vehicleattribute.instanceName }}</td>\r\n                                    <td>{{ vehicleattribute.vehicleAttributeCategoryName }}</td>\r\n                                    <td class=\"word-wrap\">{{ vehicleattribute.attributeDesc }}</td>\r\n                                    <td class=\"text-center\">\r\n                                        <a *ngIf=\"vehicleattribute.isEditable\" [routerLink]=\"urlVehicleAttributeUpdate + '/'+ vehicleattribute.vehicleAttributeHashId\">\r\n                                            <i class=\"fa fa-pencil-square-o fa-fw\"></i>\r\n                                        </a>\r\n                                    </td>\r\n                                </tr>\r\n                            </template>\r\n                            <tr *ngIf=\"DataListModel.totalItems  == 0 && !isLoading\">\r\n                                <td class=\"text-center text-danger\" colspan=\"6\">\r\n                                    {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                                </td>\r\n                            </tr>\r\n                        </tbody>\r\n                    </table>\r\n                </div>\r\n                <div class=\"clearfix\"></div>\r\n                <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n                    <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n                        <div class=\"col-md-12\">\r\n                            <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\"\r\n                                firstText=\"&laquo;\" lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>";

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var config_1 = __webpack_require__(60);
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var vehicleattributecategory_model_1 = __webpack_require__(805);
	var vehicleattributecategory_service_1 = __webpack_require__(799);
	var instance_service_1 = __webpack_require__(500);
	var router_1 = __webpack_require__(26);
	var config_2 = __webpack_require__(60);
	var common_1 = __webpack_require__(22);
	var VehicleAttributeCategoryUpdateComponent = (function () {
	    function VehicleAttributeCategoryUpdateComponent(vehicleAttributeCategoryService, instanceService, activeRoute, router, authService, translate, locationService) {
	        this.vehicleAttributeCategoryService = vehicleAttributeCategoryService;
	        this.instanceService = instanceService;
	        this.activeRoute = activeRoute;
	        this.router = router;
	        this.authService = authService;
	        this.translate = translate;
	        this.locationService = locationService;
	        this.submitted = false;
	        this.roleLevel = config_1.RoleLevel;
	    }
	    VehicleAttributeCategoryUpdateComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.pageName = "Vehicle_Attribute_Category";
	        this.accessDeniedErrorCode = "412";
	        this.module = this.translate.instant("LblVehicleAttributeCategory");
	        this.urlDefaultPage = this.authService.GetURL(config_2.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlVehicleAttributeCategoryList = this.authService.GetURL(config_2.ApplicationRouteURL.URL_VEHICLEATTRIBUTE_CATEGORY_LIST);
	        this.model = new vehicleattributecategory_model_1.VehicleAttributeCategoryModel();
	        this.breadCrumbList = this.translate.instant("LblListPage", [this.module]);
	        this.sub = this.activeRoute.params.subscribe(function (params) {
	            var vehicleAttributeCategryHashId = params["id"] || "";
	            if (vehicleAttributeCategryHashId != "") {
	                _this.GetInstanceListDropdown(config_2.PermissionType.EDIT);
	            }
	            else {
	                _this.GetInstanceListDropdown(config_2.PermissionType.INSERT);
	            }
	        });
	    };
	    VehicleAttributeCategoryUpdateComponent.prototype.GetVehicleAttributeCategoryDetails = function () {
	        var _this = this;
	        this.sub = this.activeRoute.params.subscribe(function (params) {
	            _this.vehicleAttributeCategoryHashId = params["id"] || "";
	            if (_this.vehicleAttributeCategoryHashId != "") {
	                _this.isEditMode = true;
	                _this.vehicleAttributeCategoryService
	                    .GetVehicleAttributeCategoryByHashId(_this.vehicleAttributeCategoryHashId)
	                    .subscribe(function (res) { return (_this.model = res.data); }, function (error) {
	                    _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	                });
	            }
	            else {
	                _this.isEditMode = false;
	            }
	            _this.breadCrumbTitle = _this.isEditMode
	                ? _this.translate.instant("LblEditPage", [_this.module])
	                : _this.translate.instant("LblAddPage", [_this.module]);
	        });
	    };
	    VehicleAttributeCategoryUpdateComponent.prototype.onSubmit = function (forms) {
	        this.submitted = true;
	        this.AddNewVehicleCategoryAttribute(JSON.stringify(this.model));
	    };
	    VehicleAttributeCategoryUpdateComponent.prototype.GetInstanceListDropdown = function (permissionType) {
	        var _this = this;
	        this.instanceService
	            .GetInstanceListDropdownForAddUpdatePage(this.pageName, permissionType)
	            .subscribe(function (res) {
	            _this.apiResponse = res;
	            _this.instanceList = res.data;
	            if (_this.instanceList.length == 0) {
	                _this.authService.HandleErrorStatusCode(_this.accessDeniedErrorCode);
	            }
	            if (_this.instanceList && _this.instanceList.length > 0) {
	                if (!_this.model.instanceHashId && _this.instanceList.length == 1) {
	                    _this.model.instanceHashId = _this.instanceList[0].keyHash;
	                }
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        }, function () { return _this.GetVehicleAttributeCategoryDetails(); });
	    };
	    VehicleAttributeCategoryUpdateComponent.prototype.AddNewVehicleCategoryAttribute = function (formData) {
	        var _this = this;
	        this.vehicleAttributeCategoryService
	            .AddNewVehicleAttributeCategory(formData)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.isEditMode
	                    ? _this.translate.instant("LblRecordUpdatedSuccess", [_this.module])
	                    : _this.translate.instant("LblRecordAddedSuccess", [_this.module]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    VehicleAttributeCategoryUpdateComponent.prototype.onChangeSelectedField = function (value) {
	        this.model.instanceHashId = value;
	    };
	    VehicleAttributeCategoryUpdateComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    VehicleAttributeCategoryUpdateComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    VehicleAttributeCategoryUpdateComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    VehicleAttributeCategoryUpdateComponent.prototype.OnBackClick = function () {
	        this.locationService.back();
	    };
	    VehicleAttributeCategoryUpdateComponent.prototype.ngOnDestroy = function () {
	        if (this.sub) {
	            this.sub.unsubscribe();
	        }
	    };
	    __decorate([
	        core_1.ViewChild("alertModal"), 
	        __metadata('design:type', Object)
	    ], VehicleAttributeCategoryUpdateComponent.prototype, "alertModal", void 0);
	    __decorate([
	        core_1.ViewChild("successPopup"), 
	        __metadata('design:type', Object)
	    ], VehicleAttributeCategoryUpdateComponent.prototype, "successPopup", void 0);
	    VehicleAttributeCategoryUpdateComponent = __decorate([
	        core_1.Component({
	            selector: "wego-vehicleattributecategory-update",
	            template: __webpack_require__(806),
	            providers: [vehicleattributecategory_service_1.VehicleAttributeCategoryService, instance_service_1.InstanceService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof vehicleattributecategory_service_1.VehicleAttributeCategoryService !== 'undefined' && vehicleattributecategory_service_1.VehicleAttributeCategoryService) === 'function' && _a) || Object, (typeof (_b = typeof instance_service_1.InstanceService !== 'undefined' && instance_service_1.InstanceService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _e) || Object, (typeof (_f = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _f) || Object, (typeof (_g = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _g) || Object])
	    ], VehicleAttributeCategoryUpdateComponent);
	    return VehicleAttributeCategoryUpdateComponent;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.VehicleAttributeCategoryUpdateComponent = VehicleAttributeCategoryUpdateComponent;


/***/ },
/* 805 */
/***/ function(module, exports) {

	"use strict";
	var VehicleAttributeCategoryModel = (function () {
	    function VehicleAttributeCategoryModel() {
	        this.instanceHashId = "";
	    }
	    return VehicleAttributeCategoryModel;
	}());
	exports.VehicleAttributeCategoryModel = VehicleAttributeCategoryModel;


/***/ },
/* 806 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{breadCrumbTitle}}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"urlVehicleAttributeCategoryList\">\r\n            <i class=\"fa fa-object-group fa-fw\"></i>{{breadCrumbList}}</a>\r\n        </li>\r\n        <li class=\"active\">{{breadCrumbTitle}}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"nopad\">\r\n      <form (ngSubmit)=\"onSubmit(AddVehicleAttributeCategoryForm.value)\" #AddVehicleAttributeCategoryForm=\"ngForm\">\r\n        <input type=\"hidden\" class=\"form-control\" [(ngModel)]=\"model.instanceHashId\" name=\"instanceHashId\">\r\n        <input type=\"hidden\" class=\"form-control\" [(ngModel)]=\"model.vehicleAttributeCategoryHashId\" name=\"vehicleAttributeCategoryHashId\">\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblVehicleAttributeCategory' | translate }}\r\n          </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblVehicleAttributeCategory' | translate }}\" [(ngModel)]=\"model.vehicleAttributeCategoryName\"\r\n            name=\"VehicleAttributeCategoryName\" maxlength=\"100\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'vehicleAttributeCategoryName' }}</span>\r\n        </div>\r\n\r\n        <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Instance\" class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblInstance' | translate }}\r\n          </label>\r\n          <select [disabled]=\"isEditMode\" [(ngModel)]=\"model.instanceHashId\" class=\"form-control\" name=\"instanceHashId\">\r\n            <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblInstance' | translate }}</option>\r\n            <option *ngFor=\"let item of instanceList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\r\n          </select>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'instanceHashId' }}</span>\r\n        </div>\r\n\r\n        <div class=\"row no-margin\">\r\n          <div class=\"col-sm-12\">\r\n            <hr>\r\n            <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnBackClick()\">{{ 'LblCancel' | translate }}</a> &nbsp;&nbsp;\r\n            <button class=\"btn btn-green\" type=\"submit\">{{ 'LblSave' | translate }}</button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>";

/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var vehicleattributecategory_service_1 = __webpack_require__(799);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var VehicleAttributeCategoryListComponent = (function () {
	    function VehicleAttributeCategoryListComponent(vehicleattributeCategoryService, authService, router, translate) {
	        this.vehicleattributeCategoryService = vehicleattributeCategoryService;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.roleLevel = config_1.RoleLevel;
	    }
	    VehicleAttributeCategoryListComponent.prototype.ngOnInit = function () {
	        this.breadCrumbList = this.translate.instant('LblVehicleAttributeCategory', [this.module]);
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        if (this.authService.GetHighestRoleLevel() <= this.roleLevel.Instance) {
	            this.DataListModel.searchField = ["instanceName", "vehicleAttributeCategoryName"];
	        }
	        else {
	            this.DataListModel.searchField = ["vehicleAttributeCategoryName"];
	        }
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlVehicleAttributeCategoryAdd = this.authService.GetURL(config_1.ApplicationRouteURL.URL_VEHICLEATTRIBUTE_CATEGORY_ADD);
	        this.urlVehicleAttributeCategoryUpdate = this.authService.GetURL(config_1.ApplicationRouteURL.URL_VEHICLEATTRIBUTE_CATEGORY_UPDATE);
	        this.GetVehicleAttributeCategoryList();
	        this.addVehicleAttributeCategoryLink = new config_1.WeGoAuthorizedLink(this.urlVehicleAttributeCategoryAdd, config_1.Permission.PR_VEHICLE_ATTRIBUTE_CATEGORIES, config_1.PermissionType.INSERT, 'btn btn-highlight navbar-right', 'LblAddNew');
	    };
	    VehicleAttributeCategoryListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetVehicleAttributeCategoryList();
	    };
	    VehicleAttributeCategoryListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetVehicleAttributeCategoryList();
	    };
	    VehicleAttributeCategoryListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetVehicleAttributeCategoryList();
	    };
	    ;
	    VehicleAttributeCategoryListComponent.prototype.OnPagingChange = function (event) {
	        console.log(this.DataListModel);
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetVehicleAttributeCategoryList();
	    };
	    VehicleAttributeCategoryListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.vehicleattributeCategoryService.ExportVehicleAttributeCategoryList(this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "VehicleAttribute" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	        ;
	    };
	    VehicleAttributeCategoryListComponent.prototype.GetVehicleAttributeCategoryList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.vehicleattributeCategoryService.GetVehicleAttributeCategoryList(this.DataListModel)
	            .subscribe(function (res) {
	            _this.vehicleattributeCategoryList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    VehicleAttributeCategoryListComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    VehicleAttributeCategoryListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-vehicleattributecategory-list',
	            template: __webpack_require__(808),
	            providers: [vehicleattributecategory_service_1.VehicleAttributeCategoryService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof vehicleattributecategory_service_1.VehicleAttributeCategoryService !== 'undefined' && vehicleattributecategory_service_1.VehicleAttributeCategoryService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object])
	    ], VehicleAttributeCategoryListComponent);
	    return VehicleAttributeCategoryListComponent;
	    var _a, _b, _c, _d;
	}());
	exports.VehicleAttributeCategoryListComponent = VehicleAttributeCategoryListComponent;


/***/ },
/* 808 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ breadCrumbList}} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li class=\"active\"> {{ breadCrumbList}} </li>\r\n      </ol>\r\n    </div>\r\n\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25 \">\r\n      <wego-authorized-link [LinkModel]=\"addVehicleAttributeCategoryLink\"></wego-authorized-link>\r\n      <!-- <a class=\"btn btn-highlight navbar-right\" [routerLink]=\"[urlVehicleAttributeCategoryUpdate]\">{{'LblAddNew' | translate}}</a> -->\r\n    </div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <p class=\"text-success\">{{ message }}</p>\r\n        <wego-search-list (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\"\r\n          [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('vehicleAttributeCategoryName')\">\r\n                  {{ 'LblVehicleAttributeCategory' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'vehicleAttributeCategoryName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Instance\" class=\"cursor-pointer\" (click)=\"OnSort('instanceName')\">\r\n                  {{'LblInstanceName' | translate}}\r\n                  <wego-sort-list [FieldName]=\"'instanceName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"text-center\">\r\n                  {{'LblEdit' | translate }}\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let vehicleattributeCategory of vehicleattributeCategoryList\">\r\n                  <td>{{ vehicleattributeCategory.vehicleAttributeCategoryName }}</td>\r\n                  <td *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Instance\">{{ vehicleattributeCategory.instanceName }}</td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"vehicleattributeCategory.isEditable\" [routerLink]=\"[urlVehicleAttributeCategoryUpdate + '/' +  vehicleattributeCategory.vehicleAttributeCategoryHashId]\">\r\n                      <i class=\"fa fa-pencil-square-o fa-fw\"></i>\r\n                    </a>\r\n                  </td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"5\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>";

/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var http_1 = __webpack_require__(59);
	var flatpickr_model_1 = __webpack_require__(83);
	var vehicleattribute_service_1 = __webpack_require__(561);
	var config_1 = __webpack_require__(60);
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var vehicle_model_1 = __webpack_require__(553);
	var vehicle_service_1 = __webpack_require__(530);
	var company_service_1 = __webpack_require__(501);
	var router_1 = __webpack_require__(26);
	var config_2 = __webpack_require__(60);
	var common_1 = __webpack_require__(22);
	var ng2_file_upload_1 = __webpack_require__(810);
	var pre_post_trip_question_component_1 = __webpack_require__(743);
	var VehicleUpdateComponent = (function () {
	    function VehicleUpdateComponent(vehicleService, vehicleAttributeSerive, companyService, activeRoute, authService, translate, router, http, locationService) {
	        this.vehicleService = vehicleService;
	        this.vehicleAttributeSerive = vehicleAttributeSerive;
	        this.companyService = companyService;
	        this.activeRoute = activeRoute;
	        this.authService = authService;
	        this.translate = translate;
	        this.router = router;
	        this.http = http;
	        this.locationService = locationService;
	        this.dateFormat = config_2.WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
	        this.submitted = false;
	        this.vehicleAttributeList = [];
	        this.roleLevel = config_2.RoleLevel;
	        this.headers = this.authService.GetHeaderForFile();
	        this.uploader = new ng2_file_upload_1.FileUploader({
	            url: config_2.WeGoConfig.API_POST_VEHICLE_DETAIL,
	            headers: this.headers
	        });
	        this.hasBaseDropZoneOver = false;
	        this.hasAnotherDropZoneOver = false;
	        this.language = 'en';
	        this.fileListQuer = [];
	    }
	    VehicleUpdateComponent.prototype.OnLicencePlatChange = function (newValue) {
	        var ltag;
	        ltag = this.formatLicenceTag(newValue);
	        console.log(newValue, this.model.licenceTag);
	        this.model.licenceTag = ltag;
	    };
	    // eventHandler(event: any) {
	    //   console.log(event, event.keyCode, event.keyIdentifier);
	    //   var regex = new RegExp("^[0-9a-zA-Z \b]+$");
	    //   var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
	    //   if (!regex.test(key)) {
	    //     event.preventDefault();
	    //     return false;
	    //   }
	    // }
	    // onBlurLicenceTag() {
	    //   var regex = new RegExp("/^[a-z\d]+[-a-z\d]+[a-z\d]+$/");
	    //   if (regex.test(this.model.licenceTag)) {
	    //     this.model.licenceTag = '';
	    //   }
	    // }
	    VehicleUpdateComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.uploader.onAfterAddingFile = function (fileItem) {
	            if (_this.uploader.queue.length > 1) {
	                _this.uploader.queue.forEach(function (element) {
	                    element.remove();
	                });
	            }
	        };
	        this.pricingCategoryList = [
	            {
	                Key: this.translate.instant("LblSelectPricingCatagory"),
	                Value: ""
	            },
	            {
	                Key: "A",
	                Value: "A"
	            },
	            {
	                Key: "B",
	                Value: "B"
	            },
	            {
	                Key: "C",
	                Value: "C"
	            },
	            {
	                Key: "D",
	                Value: "D"
	            },
	            {
	                Key: "E",
	                Value: "E"
	            },
	            {
	                Key: "F",
	                Value: "F"
	            },
	            {
	                Key: "G",
	                Value: "G"
	            },
	            {
	                Key: "H",
	                Value: "H"
	            }
	        ];
	        this.vehicletypeList = [
	            {
	                Key: this.translate.instant("LblSelectVehicletype"),
	                Value: ""
	            },
	            {
	                Key: "CAR",
	                Value: "C"
	            }, {
	                Key: "BIKE",
	                Value: "B"
	            }, {
	                Key: "SCOOTER",
	                Value: "S"
	            }, {
	                Key: "OTHER",
	                Value: "O"
	            }
	        ];
	        this.licenseList = [
	            {
	                Key: "AM",
	                Value: "AM"
	            },
	            {
	                Key: "A",
	                Value: "A"
	            },
	            {
	                Key: "B",
	                Value: "B"
	            },
	            {
	                Key: "C",
	                Value: "C"
	            },
	            {
	                Key: "C1",
	                Value: "C1"
	            },
	            {
	                Key: "D",
	                Value: "D"
	            },
	            {
	                Key: "T",
	                Value: "T"
	            }
	        ];
	        this.fuelTypeList = [
	            {
	                Key: this.translate.instant("LblSelectFuelType"),
	                Value: ""
	            },
	            {
	                Key: "PETROL (E5/E10)",
	                Value: "PETROL (E5/E10)"
	            },
	            {
	                Key: "DIESEL (B7/B10)",
	                Value: "DIESEL (B7/B10)"
	            },
	            {
	                Key: "GAS (LPG)",
	                Value: "GAS (LPG)"
	            },
	            {
	                Key: "ELECTRIC (EV)",
	                Value: "ELECTRIC (EV)"
	            },
	            {
	                Key: "HYBRID (PHEV)",
	                Value: "HYBRID (PHEV)"
	            }
	        ];
	        this.bodyStyleList = [
	            {
	                Key: this.translate.instant("LblSelectBodyStyle"),
	                Value: ""
	            },
	            {
	                Key: "HATCHBACK",
	                Value: "HATCHBACK"
	            },
	            {
	                Key: "SEDAN",
	                Value: "SEDAN"
	            },
	            {
	                Key: "CONVERTIBLE",
	                Value: "CONVERTIBLE"
	            },
	            {
	                Key: "WAGON",
	                Value: "WAGON"
	            }
	        ];
	        this.vehicleClassList = [
	            {
	                Key: this.translate.instant("LblSelectVehicleClass"),
	                Value: ""
	            },
	            {
	                Key: "MINICOMPACT",
	                Value: "MINICOMPACT"
	            },
	            {
	                Key: "SUBCOMPACT",
	                Value: "SUBCOMPACT"
	            },
	            {
	                Key: "COMPACT",
	                Value: "COMPACT"
	            },
	            {
	                Key: "SUV",
	                Value: "SUV"
	            },
	            {
	                Key: "VAN",
	                Value: "VAN"
	            }
	        ];
	        //WEGO2DEV-325(Settings for Dashboard statuses)
	        // this.timeIntervalList = [
	        //   {
	        //     Key: this.translate.instant('LblSelectTimeInterval'),
	        //     Value: ''
	        //   },
	        //   {
	        //     Key: this.translate.instant('LblHour'),
	        //     Value: 'HOUR'
	        //   },
	        //   {
	        //     Key: this.translate.instant('LblDay'),
	        //     Value: 'DAY'
	        //   },
	        //   {
	        //     Key: this.translate.instant('LblWeek'),
	        //     Value: 'WEEK'
	        //   },
	        //   {
	        //     Key: this.translate.instant('LblMonth'),
	        //     Value: 'MONTH'
	        //   }
	        // ];
	        // this.bookedBeforeTimeIntervalList = [
	        //   {
	        //     Key: this.translate.instant('LblSelectBookedBeforeInterval'),
	        //     Value: ''
	        //   },
	        //   {
	        //     Key: this.translate.instant('LblHour'),
	        //     Value: 'HOUR'
	        //   },
	        //   {
	        //     Key: this.translate.instant('LblDay'),
	        //     Value: 'DAY'
	        //   },
	        //   {
	        //     Key: this.translate.instant('LblWeek'),
	        //     Value: 'WEEK'
	        //   },
	        //   {
	        //     Key: this.translate.instant('LblMonth'),
	        //     Value: 'MONTH'
	        //   }
	        // ];
	        this.module = this.translate.instant("LblVehicle");
	        this.vtsConfirmMsg = this.translate.instant("LblLocationDataExchangeNotAssign");
	        this.LblWarning = this.translate.instant("LblWarning");
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = [
	            "licenceTag",
	            "bookingReferenceID",
	            "driver",
	            "translatedBookingStatus",
	            "translatedBookingType"
	        ];
	        this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
	        this.flatePickerApkExiprationDate = this.SetApkExirationFlatPickrConfig();
	        this.urlDefaultPage = this.authService.GetURL(config_2.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlVehicleList = this.authService.GetURL(config_2.ApplicationRouteURL.URL_VEHICLE_LIST);
	        this.urlCompanyInformation = this.authService.GetURL(config_2.ApplicationRouteURL.URL_COMPANY_UPDATE);
	        this.sub = this.activeRoute.params.subscribe(function (params) {
	            _this.vehicleMasterHashId = params["id"] || "";
	            _this.isCloneMode = params["isCloneMode"] || "";
	        });
	        this.model = new vehicle_model_1.VehicleModel();
	        if (this.authService.GetHighestRoleLevel() == this.roleLevel.WeGo) {
	            this.GetVTSVehicleList();
	        }
	        else {
	            this.GetVehicleDetails();
	        }
	    };
	    VehicleUpdateComponent.prototype.ngAfterViewInit = function () {
	        // viewChild is set after the view has been initialized
	        // this.prePostTripQuestionSection.GetPrePostTripQuestionList(
	        //   null,
	        //   null,
	        //   null,
	        //   this.vehicleMasterHashId
	        // );
	    };
	    VehicleUpdateComponent.prototype.SetDefaultFlatPickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = true;
	        flatPickrConfig.time_24hr = true;
	        flatPickrConfig.dateFormat = this.dateFormat;
	        flatPickrConfig.minuteIncrement = 1;
	        return flatPickrConfig;
	    };
	    VehicleUpdateComponent.prototype.SetApkExirationFlatPickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = false;
	        flatPickrConfig.time_24hr = true;
	        flatPickrConfig.dateFormat = this.dateFormat;
	        flatPickrConfig.minuteIncrement = 1;
	        return flatPickrConfig;
	    };
	    VehicleUpdateComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetBookingOverList();
	    };
	    VehicleUpdateComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetBookingOverList();
	    };
	    VehicleUpdateComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetBookingOverList();
	    };
	    VehicleUpdateComponent.prototype.fileOverBase = function (e) {
	        this.hasBaseDropZoneOver = e;
	    };
	    VehicleUpdateComponent.prototype.fileOverAnother = function (e) {
	        this.hasAnotherDropZoneOver = e;
	    };
	    VehicleUpdateComponent.prototype.beforeUpload = function ($event) {
	        this.uploader.clearQueue();
	    };
	    VehicleUpdateComponent.prototype.onSubmit = function (forms) {
	        if (this.model.locationDataExchangeHashId == "" &&
	            this.authService.GetHighestRoleLevel() == this.roleLevel.WeGo) {
	            this.warningPopup.show(false);
	        }
	        else {
	            this.UpdateVehicle();
	        }
	    };
	    VehicleUpdateComponent.prototype.ClearFileInput = function () {
	        console.log(this.logoFile);
	        if (this.logoFile.nativeElement) {
	            console.log(this.logoFile.nativeElement.value);
	            this.logoFile.nativeElement.value = "";
	            this.uploader.clearQueue();
	        }
	    };
	    VehicleUpdateComponent.prototype.UpdateVehicle = function () {
	        var _this = this;
	        this.model.attributeList = this.vehicleAttributeList
	            .filter(function (x) { return x.isChecked; })
	            .map(function (x) { return x.vehicleAttributeHashId; });
	        if (this.uploader.queue && this.uploader.queue.length > 0) {
	            this.vehicleService
	                .GetBookingOverviewList(this.model, this.DataListModel)
	                .subscribe(function (res) {
	                if (res.error) {
	                    _this.errorModel = res.error;
	                }
	                else if (res.totalRecords == 0) {
	                    _this.uploader.onBuildItemForm = function (fileItem, Form) {
	                        console.log(_this.model);
	                        // console.log(JSON.stringify(this.model));
	                        Form.append("vehicleFormData", JSON.stringify(_this.model));
	                        console.log("form built");
	                    };
	                    var apiresponse;
	                    var status;
	                    _this.uploader.onCompleteItem = function (item, response, status, headers) {
	                        apiresponse = JSON.parse(response);
	                        console.log(apiresponse.error);
	                        if (status == 200) {
	                            if (apiresponse.data == true) {
	                                _this.popupMsg = _this.isEditMode
	                                    ? _this.translate.instant("LblRecordUpdatedSuccess", [
	                                        _this.module
	                                    ])
	                                    : _this.translate.instant("LblRecordAddedSuccess", [
	                                        _this.module
	                                    ]);
	                                _this.ShowSuccessPopup();
	                            }
	                            else {
	                                _this.errorModel = apiresponse.error;
	                                _this.ClearFileInput();
	                            }
	                        }
	                    };
	                    _this.uploader.uploadAll();
	                }
	                else if (res.totalRecords > 0) {
	                    _this.bookingList = res.data;
	                    _this.DataListModel.totalItems = res.totalRecords;
	                    _this.DataListModel.infoMessage = res.error;
	                    _this.affectedbookingModal.show();
	                }
	            }, function (error) {
	                _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	                _this.isLoading = false;
	            });
	        }
	        else {
	            this.model.attributeList = this.vehicleAttributeList
	                .filter(function (x) { return x.isChecked; })
	                .map(function (x) { return x.vehicleAttributeHashId; });
	            this.vehicleService
	                .GetBookingOverviewList(this.model, this.DataListModel)
	                .subscribe(function (res) {
	                if (res.error) {
	                    _this.errorModel = res.error;
	                }
	                else if (res.totalRecords == 0) {
	                    _this.vehicleService
	                        .UpdateVehicleMaster("vehicleFormData=" +
	                        encodeURIComponent(JSON.stringify(_this.model)))
	                        .subscribe(function (res) {
	                        if (res.data) {
	                            _this.popupMsg = _this.isEditMode
	                                ? _this.translate.instant("LblRecordUpdatedSuccess", [
	                                    _this.module
	                                ])
	                                : _this.translate.instant("LblRecordAddedSuccess", [
	                                    _this.module
	                                ]);
	                            _this.ShowSuccessPopup();
	                        }
	                        else {
	                            _this.errorModel = res.error;
	                        }
	                    }, function (error) {
	                        _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	                        _this.isLoading = false;
	                    });
	                }
	                else if (res.totalRecords > 0) {
	                    _this.bookingList = res.data;
	                    _this.DataListModel.totalItems = res.totalRecords;
	                    _this.DataListModel.infoMessage = res.error;
	                    _this.affectedbookingModal.show();
	                }
	            }, function (error) {
	                _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	                _this.isLoading = false;
	            });
	        }
	    };
	    VehicleUpdateComponent.prototype.OnChangeVin = function () {
	        this.model.vin = this.model.vin.toUpperCase();
	        var vnumber = this.model.vin;
	        var isValid = this.ValidateVin(vnumber);
	        if (vnumber.length == 0)
	            isValid = true;
	        if (!isValid) {
	            alert(this.translate.instant("LblWrongVinNumber"));
	        }
	    };
	    VehicleUpdateComponent.prototype.ValidateVin = function (vin) {
	        return this.validate(vin);
	    };
	    VehicleUpdateComponent.prototype.Transliterate = function (c) {
	        return '0123456789.ABCDEFGH..JKLMN.P.R..STUVWXYZ'.indexOf(c) % 10;
	    };
	    VehicleUpdateComponent.prototype.getCheckDigit = function (vin) {
	        var map = '0123456789X';
	        var weights = '8765432X098765432';
	        var sum = 0;
	        for (var i = 0; i < 17; ++i)
	            sum += this.Transliterate(vin[i]) * map.indexOf(weights[i]);
	        return map[sum % 11];
	    };
	    VehicleUpdateComponent.prototype.validate = function (vin) {
	        if (vin.length !== 17)
	            return false;
	        return this.getCheckDigit(vin) === vin[8];
	    };
	    VehicleUpdateComponent.prototype.formatLicenceTag = function (newVal) {
	        var outputString = "";
	        var chars = newVal.replace(/-/g, "").split("");
	        if (!(chars.length > 0))
	            return outputString;
	        if (chars.length == 1)
	            return chars[0];
	        for (var i = 1; i < chars.length; i++) {
	            outputString += chars[i - 1];
	            if (chars[i - 1] == "-" || chars[i] == "-") {
	                continue;
	            }
	            if (isNaN(chars[i - 1]) != isNaN(chars[i])) {
	                outputString += "-";
	            }
	            if (i == chars.length - 1) {
	                outputString += chars[i];
	            }
	        }
	        console.log(outputString);
	        return outputString;
	    };
	    VehicleUpdateComponent.prototype.GetBookingOverList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.vehicleService
	            .GetBookingOverviewList(this.model, this.DataListModel)
	            .subscribe(function (res) {
	            _this.bookingList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.affectedbookingModal.show();
	            _this.isLoading = false;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    VehicleUpdateComponent.prototype.AddNewVehicle = function (formData) {
	        var _this = this;
	        this.vehicleService
	            .GetBookingOverviewList(this.model, this.DataListModel)
	            .subscribe(function (res) {
	            if (res.error) {
	                _this.errorModel = res.error;
	            }
	            else if (res.totalRecords == 0) {
	                _this.vehicleService.AddNewVehicle(formData).subscribe(function (anv) {
	                    if (anv.data) {
	                        _this.popupMsg = _this.isEditMode
	                            ? _this.translate.instant("LblRecordUpdatedSuccess", [
	                                _this.module
	                            ])
	                            : _this.translate.instant("LblRecordAddedSuccess", [
	                                _this.module
	                            ]);
	                        _this.ShowSuccessPopup();
	                    }
	                    else {
	                        _this.errorModel = anv.error;
	                    }
	                }, function (adverror) {
	                    _this.errorMessage = _this.authService.HandleErrorStatusCode(adverror);
	                    _this.isLoading = false;
	                });
	            }
	            else if (res.totalRecords > 0) {
	                _this.bookingList = res.data;
	                _this.DataListModel.totalItems = res.totalRecords;
	                _this.DataListModel.infoMessage = res.error;
	                _this.affectedbookingModal.show();
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    VehicleUpdateComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    VehicleUpdateComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    VehicleUpdateComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    VehicleUpdateComponent.prototype.OnBackClick = function () {
	        this.locationService.back();
	    };
	    VehicleUpdateComponent.prototype.OnCancel = function () {
	        this.affectedbookingModal.hide();
	        this.router.navigate([this.urlVehicleList]);
	    };
	    VehicleUpdateComponent.prototype.OnConfirm = function () {
	        var _this = this;
	        this.affectedbookingModal.hide();
	        // this.vehicleService.AddNewVehicle(this.model)
	        //   .subscribe(
	        //   res => {
	        //     if (res.data) {
	        //       this.popupMsg = this.isEditMode ? this.translate.instant('LblRecordUpdatedSuccess', [this.module]) : this.translate.instant
	        // ('LblRecordAddedSuccess', [this.module]);
	        //       this.ShowSuccessPopup();
	        //     }
	        //     else {
	        //       this.errorModel = res.error;
	        //     }
	        //   },
	        //   error => {
	        //     this.errorMessage = this.authService.HandleErrorStatusCode(error);
	        //     this.isLoading = false;
	        //   });
	        if (this.uploader.queue && this.uploader.queue.length > 0) {
	            this.model.attributeList = this.vehicleAttributeList
	                .filter(function (x) { return x.isChecked; })
	                .map(function (x) { return x.vehicleAttributeHashId; });
	            this.uploader.onBuildItemForm = function (fileItem, Form) {
	                Form.append("vehicleFormData", JSON.stringify(_this.model));
	            };
	            var apiresponse;
	            var status;
	            this.uploader.onCompleteItem = function (item, confirmResponse, status, headers) {
	                apiresponse = JSON.parse(confirmResponse);
	                console.log(apiresponse.error);
	                if (status == 200) {
	                    if (apiresponse.data == true) {
	                        _this.popupMsg = _this.isEditMode
	                            ? _this.translate.instant("LblRecordUpdatedSuccess", [_this.module])
	                            : _this.translate.instant("LblRecordAddedSuccess", [_this.module]);
	                        _this.ShowSuccessPopup();
	                    }
	                    else {
	                        _this.errorModel = apiresponse.error;
	                    }
	                }
	            };
	            this.uploader.uploadAll();
	        }
	        else {
	            this.model.attributeList = this.vehicleAttributeList
	                .filter(function (x) { return x.isChecked; })
	                .map(function (x) { return x.vehicleAttributeHashId; });
	            this.vehicleService
	                .UpdateVehicleMaster("vehicleFormData=" + encodeURIComponent(JSON.stringify(this.model)))
	                .subscribe(function (veh) {
	                if (veh.data) {
	                    _this.popupMsg = _this.isEditMode
	                        ? _this.translate.instant("LblRecordUpdatedSuccess", [
	                            _this.module
	                        ])
	                        : _this.translate.instant("LblRecordAddedSuccess", [
	                            _this.module
	                        ]);
	                    _this.ShowSuccessPopup();
	                }
	                else {
	                    _this.errorModel = veh.error;
	                }
	            }, function (error) {
	                _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	                _this.isLoading = false;
	            });
	        }
	    };
	    VehicleUpdateComponent.prototype.GetCompanyList = function () {
	        var _this = this;
	        var permissionType = "";
	        if (this.isEditMode) {
	            permissionType = config_1.PermissionType.EDIT;
	        }
	        else {
	            permissionType = config_1.PermissionType.INSERT;
	        }
	        this.companyService
	            .GetCompanyListDropdownForAddUpdatePage("Vehicle", permissionType)
	            .subscribe(function (res) {
	            _this.apiResponse = res;
	            _this.companyList = res.data;
	            // this.model.pricingCategory = this.pricingCategoryList.length > 0 ? this.pricingCategoryList[0].Value : '';
	            // this.model.bodyStyle = this.bodyStyleList.length > 0 ? this.bodyStyleList[0].Value : '';
	            // this.model.fuelType = this.fuelTypeList.length > 0 ? this.fuelTypeList[0].Value : '';
	            // this.model.vehicleClass = this.vehicleClassList.length > 0 ? this.vehicleClassList[0].Value : '';
	            // this.isLoading = false;
	            _this.IsAuthorizedForPrePostTripQuestion();
	            console.log(_this.model);
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            // this.isLoading = false;
	        }, function () {
	            _this.isLoading = false;
	        });
	    };
	    VehicleUpdateComponent.prototype.GetVehicleAttributeList = function () {
	        var _this = this;
	        this.vehicleAttributeSerive.GetVehicleAttributeList().subscribe(function (res) {
	            _this.apiResponse = res;
	            _this.vehicleAttributeList = res.data;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        }, function () { return _this.GetVehicleDetails(); });
	    };
	    VehicleUpdateComponent.prototype.GetVehicleAttributeForCompany = function (ownerCompanyHashID) {
	        var _this = this;
	        this.vehicleAttributeSerive
	            .GetVehicleAttributeForCompany(ownerCompanyHashID)
	            .subscribe(function (res) {
	            _this.apiResponse = res;
	            _this.vehicleAttributeList = res.data;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        }, function () {
	            if (_this.isEditMode || _this.isCloneMode) {
	                _this.vehicleAttributeList
	                    .filter(function (x) {
	                    return _this.model.attributeList &&
	                        _this.model.attributeList.indexOf(x.vehicleAttributeHashId) >
	                            -1;
	                })
	                    .forEach(function (x) { return (x.isChecked = true); });
	            }
	        });
	    };
	    VehicleUpdateComponent.prototype.GetVehicleDetails = function () {
	        var _this = this;
	        this.isLoading = true;
	        if (this.vehicleMasterHashId != "") {
	            this.isEditMode = true;
	            this.vehicleService
	                .GetVehicleByHashId(this.vehicleMasterHashId, true && (!this.isCloneMode))
	                .subscribe(function (res) {
	                _this.model = res.data;
	                _this.language = _this.model.instanceLanguage;
	                if (_this.isCloneMode) {
	                    _this.isEditMode = false;
	                    _this.model.vehicleMasterHashId = "";
	                    _this.model.licenceTag = "";
	                    _this.model.locationDataExchangeHashId = "";
	                }
	                // if (this.model.vehicleGeoLocationAddress) {
	                //   this.markerInfo = {
	                //     draggable: false,
	                //     lat: this.model.vehicleGeoLocationLatitude,
	                //     lng: this.model.vehicleGeoLocationLongitude,
	                //     label: this.model.vehicleGeoLocationAddress,
	                //     isOpen: true
	                //   }
	                // }
	                _this.vehicleAttributeList
	                    .filter(function (x) {
	                    return _this.model.attributeList &&
	                        _this.model.attributeList.indexOf(x.vehicleAttributeHashId) >
	                            -1;
	                })
	                    .forEach(function (x) { return (x.isChecked = true); });
	                _this.GetVehicleAttributeForCompany(_this.model.ownerCompanyHashID);
	                _this.GetCompanyList();
	            }, function (error) {
	                _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	                _this.isLoading = false;
	            });
	        }
	        else {
	            this.isEditMode = false;
	            this.model.pricingCategory =
	                this.pricingCategoryList.length > 0
	                    ? this.pricingCategoryList[0].Value
	                    : "";
	            this.model.vehicletypeList =
	                this.vehicletypeList.length > 0
	                    ? this.vehicletypeList[3].Value
	                    : "";
	            this.model.bodyStyle =
	                this.bodyStyleList.length > 0 ? this.bodyStyleList[0].Value : "";
	            this.model.fuelType =
	                this.fuelTypeList.length > 0 ? this.fuelTypeList[0].Value : "";
	            this.model.vehicleClass =
	                this.vehicleClassList.length > 0 ? this.vehicleClassList[0].Value : "";
	            this.GetCompanyList();
	        }
	        if (this.isCloneMode) {
	            this.breadCrumbTitle = this.translate.instant("LblCloneVehicle", [
	                this.module
	            ]);
	        }
	        else {
	            this.breadCrumbTitle = this.isEditMode
	                ? this.translate.instant("LblEditPage", [this.module])
	                : this.translate.instant("LblAddPage", [this.module]);
	        }
	        this.breadCrumbList = this.translate.instant("LblListPage", [this.module]);
	    };
	    VehicleUpdateComponent.prototype.Geofence = function () {
	        var _this = this;
	        this.companyService
	            .IsGeofenceEnables(this.model.ownerCompanyHashID)
	            .subscribe(function (res) {
	            _this.model.isGefenceEnabled = res.data;
	        });
	    };
	    VehicleUpdateComponent.prototype.GetLocationMode = function () {
	        var _this = this;
	        this.companyService
	            .GetLocationMode(this.model.ownerCompanyHashID)
	            .subscribe(function (res) {
	            _this.model.isHomeLocationEnabled = res.data;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    VehicleUpdateComponent.prototype.onChangeSelectedCompany = function (selectedField) {
	        //this.model.ownerCompanyHashID = selectedField;
	        this.IsAuthorizedForPrePostTripQuestion();
	        this.model.attributeList = [];
	        this.GetVehicleAttributeForCompany(this.model.ownerCompanyHashID);
	        this.Geofence();
	        this.GetLocationMode();
	        this.GetInstanceLaguage();
	    };
	    VehicleUpdateComponent.prototype.GetInstanceLaguage = function () {
	        var _this = this;
	        this.companyService
	            .GetInstanceLanguage(this.model.ownerCompanyHashID)
	            .subscribe(function (res) {
	            _this.language = res.data;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    VehicleUpdateComponent.prototype.GeofenceLocation = function () {
	        this.locationModelField = "geofence";
	        this.geoLocationModal.show(this.model.geofenceAttributeModel.address, this.model.geofenceAttributeModel.latitude, this.model.geofenceAttributeModel.longitude);
	    };
	    VehicleUpdateComponent.prototype.SearchHomeAddress = function () {
	        this.locationModelField = "home";
	        this.geoLocationModal.show(this.model.homeLocationModel.address, this.model.homeLocationModel.latitude, this.model.homeLocationModel.longitude);
	    };
	    VehicleUpdateComponent.prototype.onConfirm = function ($event) {
	        if (this.locationModelField == "home") {
	            this.model.homeLocationModel.address = $event.address;
	            this.model.homeLocationModel.latitude = $event.lat;
	            this.model.homeLocationModel.longitude = $event.long;
	        }
	        else {
	            this.model.geofenceAttributeModel.address = $event.address;
	            this.model.geofenceAttributeModel.latitude = $event.lat;
	            this.model.geofenceAttributeModel.longitude = $event.long;
	        }
	    };
	    VehicleUpdateComponent.prototype.ResetLocationField = function (locationModelField) {
	        if (locationModelField == "home") {
	            this.model.homeLocationModel.address = "";
	            this.model.homeLocationModel.latitude = "0";
	            this.model.homeLocationModel.longitude = "0";
	        }
	        else {
	            this.model.geofenceAttributeModel.address = "";
	            this.model.geofenceAttributeModel.latitude = "0";
	            this.model.geofenceAttributeModel.longitude = "0";
	        }
	    };
	    VehicleUpdateComponent.prototype.GetVTSVehicleList = function () {
	        var _this = this;
	        this.vehicleService.GetVTSVehicleList().subscribe(function (res) {
	            _this.apiResponse = res;
	            _this.VTSVehicleList = res.data;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        }, function () { return _this.GetVehicleDetails(); });
	    };
	    VehicleUpdateComponent.prototype.SetLowBatteryFlag = function () {
	        if (this.model.lowBatteryFlagRaised != null &&
	            this.model.lowBatteryFlagRaised != "") {
	            this.model.lowBatteryFlagClear =
	                this.model.lowBatteryFlagClear == null ||
	                    this.model.lowBatteryFlagClear == ""
	                    ? "0"
	                    : this.model.lowBatteryFlagClear;
	        }
	        else {
	            this.model.lowBatteryFlagClear =
	                this.model.lowBatteryFlagClear == null ||
	                    this.model.lowBatteryFlagClear == ""
	                    ? ""
	                    : this.model.lowBatteryFlagClear;
	        }
	    };
	    VehicleUpdateComponent.prototype.UpdateVTSData = function () {
	        // let vtsData = this.VTSVehicleList.find(x => x.locationDataExchangeHashId == this.model.locationDataExchangeHashId);
	        // if (vtsData) {
	        //   this.model.brand = vtsData.brand;
	        //   this.model.type = vtsData.type;
	        //   this.model.color = vtsData.color;
	        // }
	    };
	    VehicleUpdateComponent.prototype.GetImageURL = function (imagePath) {
	        return config_2.WeGoConfig.API_SERVER_URL + imagePath;
	    };
	    VehicleUpdateComponent.prototype.GroupByCategory = function () {
	        var prop = "vehicleAttributeCategoryName";
	        if (this.vehicleAttributeList == null ||
	            this.vehicleAttributeList.length == 0)
	            return null;
	        else
	            return this.vehicleAttributeList.reduce(function (groups, item) {
	                var val = item[prop];
	                groups[val] = groups[val] || [];
	                groups[val].push(item);
	                groups[val] = groups[val].sort(function (obj1, obj2) {
	                    if (obj1.attributeName > obj2.attributeName) {
	                        return 1;
	                    }
	                    if (obj1.attributeName < obj2.attributeName) {
	                        return -1;
	                    }
	                    return 0;
	                });
	                return groups;
	            }, {});
	    };
	    VehicleUpdateComponent.prototype.KeyOfObject = function (obj) {
	        return Object.keys(obj);
	    };
	    VehicleUpdateComponent.prototype.OnPrePostTripQuestionSetting = function ($event) {
	        this.model.customTripQuestionList = $event.customTripQuestionList;
	    };
	    VehicleUpdateComponent.prototype.IsAuthorizedForPrePostTripQuestion = function () {
	        var _this = this;
	        var primaryPermissionType;
	        if (this.vehicleMasterHashId != "") {
	            primaryPermissionType = config_1.PermissionType.EDIT;
	        }
	        else {
	            primaryPermissionType = config_1.PermissionType.INSERT;
	        }
	        this.authService
	            .IsAuthorizedForPrePostQuestion(config_1.Permission.PR_VEHICLES_OVERVIEW, primaryPermissionType, config_1.Permission.PR_PREPOST_TRIP_QUESTIONS_UPDATE, config_1.PermissionType.VIEW, config_1.Entity.COMPANY, this.model.ownerCompanyHashID)
	            .subscribe(function (res) {
	            _this.isAuthorizedForPrePostTrip = res.data.view;
	            _this.basePermissionModel = res.data;
	            console.log(_this.prePostTripQuestionSection);
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	        }, function () {
	            setTimeout(function () {
	                if (_this.isAuthorizedForPrePostTrip && _this.isEditMode) {
	                    _this.prePostTripQuestionSection.GetPrePostTripQuestionList(null, null, null, _this.vehicleMasterHashId, _this.basePermissionModel, !_this.vehicleMasterHashId);
	                }
	            }, 1000);
	        });
	    };
	    VehicleUpdateComponent.prototype.ngOnDestroy = function () {
	        if (this.sub) {
	            this.sub.unsubscribe();
	        }
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    __decorate([
	        core_1.ViewChild("affectedbookingModal"), 
	        __metadata('design:type', Object)
	    ], VehicleUpdateComponent.prototype, "affectedbookingModal", void 0);
	    __decorate([
	        core_1.ViewChild("successPopup"), 
	        __metadata('design:type', Object)
	    ], VehicleUpdateComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild("warningPopup"), 
	        __metadata('design:type', Object)
	    ], VehicleUpdateComponent.prototype, "warningPopup", void 0);
	    __decorate([
	        core_1.ViewChild("geoLocationModal"), 
	        __metadata('design:type', Object)
	    ], VehicleUpdateComponent.prototype, "geoLocationModal", void 0);
	    __decorate([
	        core_1.ViewChild("prePostTripQuestionSection"), 
	        __metadata('design:type', (typeof (_a = typeof pre_post_trip_question_component_1.PrePostTripQuestionComponent !== 'undefined' && pre_post_trip_question_component_1.PrePostTripQuestionComponent) === 'function' && _a) || Object)
	    ], VehicleUpdateComponent.prototype, "prePostTripQuestionSection", void 0);
	    __decorate([
	        core_1.ViewChild("logoFile"), 
	        __metadata('design:type', Object)
	    ], VehicleUpdateComponent.prototype, "logoFile", void 0);
	    VehicleUpdateComponent = __decorate([
	        core_1.Component({
	            selector: "wego-vehicle-update",
	            template: __webpack_require__(811),
	            providers: [vehicle_service_1.VehicleService, company_service_1.CompanyService, vehicleattribute_service_1.VehicleAttributeService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof vehicle_service_1.VehicleService !== 'undefined' && vehicle_service_1.VehicleService) === 'function' && _b) || Object, (typeof (_c = typeof vehicleattribute_service_1.VehicleAttributeService !== 'undefined' && vehicleattribute_service_1.VehicleAttributeService) === 'function' && _c) || Object, (typeof (_d = typeof company_service_1.CompanyService !== 'undefined' && company_service_1.CompanyService) === 'function' && _d) || Object, (typeof (_e = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _e) || Object, (typeof (_f = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _f) || Object, (typeof (_g = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _g) || Object, (typeof (_h = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _h) || Object, (typeof (_j = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _j) || Object, (typeof (_k = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _k) || Object])
	    ], VehicleUpdateComponent);
	    return VehicleUpdateComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
	}());
	exports.VehicleUpdateComponent = VehicleUpdateComponent;


/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(22), __webpack_require__(3));
		else if(typeof define === 'function' && define.amd)
			define(["@angular/common", "@angular/core"], factory);
		else if(typeof exports === 'object')
			exports["ng2-file-upload.umd"] = factory(require("@angular/common"), require("@angular/core"));
		else
			root["ng2-file-upload.umd"] = factory(root["@angular/common"], root["@angular/core"]);
	})(this, function(__WEBPACK_EXTERNAL_MODULE_8__, __WEBPACK_EXTERNAL_MODULE_1__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	/******/
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	/******/
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	/******/
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			i: moduleId,
	/******/ 			l: false,
	/******/ 			exports: {}
	/******/ 		};
	/******/
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	/******/
	/******/ 		// Flag the module as loaded
	/******/ 		module.l = true;
	/******/
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	/******/
	/******/
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	/******/
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	/******/
	/******/ 	// identity function for calling harmory imports with the correct context
	/******/ 	__webpack_require__.i = function(value) { return value; };
	/******/
	/******/ 	// define getter function for harmory exports
	/******/ 	__webpack_require__.d = function(exports, name, getter) {
	/******/ 		Object.defineProperty(exports, name, {
	/******/ 			configurable: false,
	/******/ 			enumerable: true,
	/******/ 			get: getter
	/******/ 		});
	/******/ 	};
	/******/
	/******/ 	// getDefaultExport function for compatibility with non-harmony modules
	/******/ 	__webpack_require__.n = function(module) {
	/******/ 		var getter = module && module.__esModule ?
	/******/ 			function getDefault() { return module['default']; } :
	/******/ 			function getModuleExports() { return module; };
	/******/ 		__webpack_require__.d(getter, 'a', getter);
	/******/ 		return getter;
	/******/ 	};
	/******/
	/******/ 	// Object.prototype.hasOwnProperty.call
	/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
	/******/
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "/";
	/******/
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(__webpack_require__.s = 9);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	"use strict";
	var file_like_object_class_1 = __webpack_require__(4);
	var file_item_class_1 = __webpack_require__(6);
	var file_type_class_1 = __webpack_require__(7);
	function isFile(value) {
	    return (File && value instanceof File);
	}
	var FileUploader = (function () {
	    function FileUploader(options) {
	        this.isUploading = false;
	        this.queue = [];
	        this.progress = 0;
	        this._nextIndex = 0;
	        this.options = {
	            autoUpload: false,
	            isHTML5: true,
	            filters: [],
	            removeAfterUpload: false,
	            disableMultipart: false
	        };
	        this.setOptions(options);
	    }
	    FileUploader.prototype.setOptions = function (options) {
	        this.options = Object.assign(this.options, options);
	        this.authToken = options.authToken;
	        this.authTokenHeader = options.authTokenHeader || 'Authorization';
	        this.autoUpload = options.autoUpload;
	        this.options.filters.unshift({ name: 'queueLimit', fn: this._queueLimitFilter });
	        if (this.options.maxFileSize) {
	            this.options.filters.unshift({ name: 'fileSize', fn: this._fileSizeFilter });
	        }
	        if (this.options.allowedFileType) {
	            this.options.filters.unshift({ name: 'fileType', fn: this._fileTypeFilter });
	        }
	        if (this.options.allowedMimeType) {
	            this.options.filters.unshift({ name: 'mimeType', fn: this._mimeTypeFilter });
	        }
	        for (var i = 0; i < this.queue.length; i++) {
	            this.queue[i].url = this.options.url;
	        }
	        // this.options.filters.unshift({name: 'folder', fn: this._folderFilter});
	    };
	    FileUploader.prototype.addToQueue = function (files, options, filters) {
	        var _this = this;
	        var list = [];
	        for (var _i = 0, files_1 = files; _i < files_1.length; _i++) {
	            var file = files_1[_i];
	            list.push(file);
	        }
	        var arrayOfFilters = this._getFilters(filters);
	        var count = this.queue.length;
	        var addedFileItems = [];
	        list.map(function (some) {
	            if (!options) {
	                options = _this.options;
	            }
	            var temp = new file_like_object_class_1.FileLikeObject(some);
	            if (_this._isValidFile(temp, arrayOfFilters, options)) {
	                var fileItem = new file_item_class_1.FileItem(_this, some, options);
	                addedFileItems.push(fileItem);
	                _this.queue.push(fileItem);
	                _this._onAfterAddingFile(fileItem);
	            }
	            else {
	                var filter = arrayOfFilters[_this._failFilterIndex];
	                _this._onWhenAddingFileFailed(temp, filter, options);
	            }
	        });
	        if (this.queue.length !== count) {
	            this._onAfterAddingAll(addedFileItems);
	            this.progress = this._getTotalProgress();
	        }
	        this._render();
	        if (this.options.autoUpload) {
	            this.uploadAll();
	        }
	    };
	    FileUploader.prototype.removeFromQueue = function (value) {
	        var index = this.getIndexOfItem(value);
	        var item = this.queue[index];
	        if (item.isUploading) {
	            item.cancel();
	        }
	        this.queue.splice(index, 1);
	        this.progress = this._getTotalProgress();
	    };
	    FileUploader.prototype.clearQueue = function () {
	        while (this.queue.length) {
	            this.queue[0].remove();
	        }
	        this.progress = 0;
	    };
	    FileUploader.prototype.uploadItem = function (value) {
	        var index = this.getIndexOfItem(value);
	        var item = this.queue[index];
	        var transport = this.options.isHTML5 ? '_xhrTransport' : '_iframeTransport';
	        item._prepareToUploading();
	        if (this.isUploading) {
	            return;
	        }
	        this.isUploading = true;
	        this[transport](item);
	    };
	    FileUploader.prototype.cancelItem = function (value) {
	        var index = this.getIndexOfItem(value);
	        var item = this.queue[index];
	        var prop = this.options.isHTML5 ? item._xhr : item._form;
	        if (item && item.isUploading) {
	            prop.abort();
	        }
	    };
	    FileUploader.prototype.uploadAll = function () {
	        var items = this.getNotUploadedItems().filter(function (item) { return !item.isUploading; });
	        if (!items.length) {
	            return;
	        }
	        items.map(function (item) { return item._prepareToUploading(); });
	        items[0].upload();
	    };
	    FileUploader.prototype.cancelAll = function () {
	        var items = this.getNotUploadedItems();
	        items.map(function (item) { return item.cancel(); });
	    };
	    FileUploader.prototype.isFile = function (value) {
	        return isFile(value);
	    };
	    FileUploader.prototype.isFileLikeObject = function (value) {
	        return value instanceof file_like_object_class_1.FileLikeObject;
	    };
	    FileUploader.prototype.getIndexOfItem = function (value) {
	        return typeof value === 'number' ? value : this.queue.indexOf(value);
	    };
	    FileUploader.prototype.getNotUploadedItems = function () {
	        return this.queue.filter(function (item) { return !item.isUploaded; });
	    };
	    FileUploader.prototype.getReadyItems = function () {
	        return this.queue
	            .filter(function (item) { return (item.isReady && !item.isUploading); })
	            .sort(function (item1, item2) { return item1.index - item2.index; });
	    };
	    FileUploader.prototype.destroy = function () {
	        return void 0;
	        /*forEach(this._directives, (key) => {
	         forEach(this._directives[key], (object) => {
	         object.destroy();
	         });
	         });*/
	    };
	    FileUploader.prototype.onAfterAddingAll = function (fileItems) {
	        return { fileItems: fileItems };
	    };
	    FileUploader.prototype.onBuildItemForm = function (fileItem, form) {
	        return { fileItem: fileItem, form: form };
	    };
	    FileUploader.prototype.onAfterAddingFile = function (fileItem) {
	        return { fileItem: fileItem };
	    };
	    FileUploader.prototype.onWhenAddingFileFailed = function (item, filter, options) {
	        return { item: item, filter: filter, options: options };
	    };
	    FileUploader.prototype.onBeforeUploadItem = function (fileItem) {
	        return { fileItem: fileItem };
	    };
	    FileUploader.prototype.onProgressItem = function (fileItem, progress) {
	        return { fileItem: fileItem, progress: progress };
	    };
	    FileUploader.prototype.onProgressAll = function (progress) {
	        return { progress: progress };
	    };
	    FileUploader.prototype.onSuccessItem = function (item, response, status, headers) {
	        return { item: item, response: response, status: status, headers: headers };
	    };
	    FileUploader.prototype.onErrorItem = function (item, response, status, headers) {
	        return { item: item, response: response, status: status, headers: headers };
	    };
	    FileUploader.prototype.onCancelItem = function (item, response, status, headers) {
	        return { item: item, response: response, status: status, headers: headers };
	    };
	    FileUploader.prototype.onCompleteItem = function (item, response, status, headers) {
	        return { item: item, response: response, status: status, headers: headers };
	    };
	    FileUploader.prototype.onCompleteAll = function () {
	        return void 0;
	    };
	    FileUploader.prototype._mimeTypeFilter = function (item) {
	        return !(this.options.allowedMimeType && this.options.allowedMimeType.indexOf(item.type) === -1);
	    };
	    FileUploader.prototype._fileSizeFilter = function (item) {
	        return !(this.options.maxFileSize && item.size > this.options.maxFileSize);
	    };
	    FileUploader.prototype._fileTypeFilter = function (item) {
	        return !(this.options.allowedFileType &&
	            this.options.allowedFileType.indexOf(file_type_class_1.FileType.getMimeClass(item)) === -1);
	    };
	    FileUploader.prototype._onErrorItem = function (item, response, status, headers) {
	        item._onError(response, status, headers);
	        this.onErrorItem(item, response, status, headers);
	    };
	    FileUploader.prototype._onCompleteItem = function (item, response, status, headers) {
	        item._onComplete(response, status, headers);
	        this.onCompleteItem(item, response, status, headers);
	        var nextItem = this.getReadyItems()[0];
	        this.isUploading = false;
	        if (nextItem) {
	            nextItem.upload();
	            return;
	        }
	        this.onCompleteAll();
	        this.progress = this._getTotalProgress();
	        this._render();
	    };
	    FileUploader.prototype._headersGetter = function (parsedHeaders) {
	        return function (name) {
	            if (name) {
	                return parsedHeaders[name.toLowerCase()] || void 0;
	            }
	            return parsedHeaders;
	        };
	    };
	    FileUploader.prototype._xhrTransport = function (item) {
	        var _this = this;
	        var xhr = item._xhr = new XMLHttpRequest();
	        var sendable;
	        this._onBeforeUploadItem(item);
	        // todo
	        /*item.formData.map(obj => {
	         obj.map((value, key) => {
	         form.append(key, value);
	         });
	         });*/
	        if (typeof item._file.size !== 'number') {
	            throw new TypeError('The file specified is no longer valid');
	        }
	        if (!this.options.disableMultipart) {
	            sendable = new FormData();
	            this._onBuildItemForm(item, sendable);
	            sendable.append(item.alias, item._file, item.file.name);
	        }
	        else {
	            sendable = item._file;
	        }
	        xhr.upload.onprogress = function (event) {
	            var progress = Math.round(event.lengthComputable ? event.loaded * 100 / event.total : 0);
	            _this._onProgressItem(item, progress);
	        };
	        xhr.onload = function () {
	            var headers = _this._parseHeaders(xhr.getAllResponseHeaders());
	            var response = _this._transformResponse(xhr.response, headers);
	            var gist = _this._isSuccessCode(xhr.status) ? 'Success' : 'Error';
	            var method = '_on' + gist + 'Item';
	            _this[method](item, response, xhr.status, headers);
	            _this._onCompleteItem(item, response, xhr.status, headers);
	        };
	        xhr.onerror = function () {
	            var headers = _this._parseHeaders(xhr.getAllResponseHeaders());
	            var response = _this._transformResponse(xhr.response, headers);
	            _this._onErrorItem(item, response, xhr.status, headers);
	            _this._onCompleteItem(item, response, xhr.status, headers);
	        };
	        xhr.onabort = function () {
	            var headers = _this._parseHeaders(xhr.getAllResponseHeaders());
	            var response = _this._transformResponse(xhr.response, headers);
	            _this._onCancelItem(item, response, xhr.status, headers);
	            _this._onCompleteItem(item, response, xhr.status, headers);
	        };
	        xhr.open(item.method, item.url, true);
	        xhr.withCredentials = item.withCredentials;
	        // todo
	        /*item.headers.map((value, name) => {
	         xhr.setRequestHeader(name, value);
	         });*/
	        if (this.options.headers) {
	            for (var _i = 0, _a = this.options.headers; _i < _a.length; _i++) {
	                var header = _a[_i];
	                xhr.setRequestHeader(header.name, header.value);
	            }
	        }
	        if (this.authToken) {
	            xhr.setRequestHeader(this.authTokenHeader, this.authToken);
	        }
	        xhr.send(sendable);
	        this._render();
	    };
	    FileUploader.prototype._getTotalProgress = function (value) {
	        if (value === void 0) { value = 0; }
	        if (this.options.removeAfterUpload) {
	            return value;
	        }
	        var notUploaded = this.getNotUploadedItems().length;
	        var uploaded = notUploaded ? this.queue.length - notUploaded : this.queue.length;
	        var ratio = 100 / this.queue.length;
	        var current = value * ratio / 100;
	        return Math.round(uploaded * ratio + current);
	    };
	    FileUploader.prototype._getFilters = function (filters) {
	        if (!filters) {
	            return this.options.filters;
	        }
	        if (Array.isArray(filters)) {
	            return filters;
	        }
	        if (typeof filters === 'string') {
	            var names_1 = filters.match(/[^\s,]+/g);
	            return this.options.filters
	                .filter(function (filter) { return names_1.indexOf(filter.name) !== -1; });
	        }
	        return this.options.filters;
	    };
	    FileUploader.prototype._render = function () {
	        return void 0;
	        // todo: ?
	    };
	    // private _folderFilter(item:FileItem):boolean {
	    //   return !!(item.size || item.type);
	    // }
	    FileUploader.prototype._queueLimitFilter = function () {
	        return this.options.queueLimit === undefined || this.queue.length < this.options.queueLimit;
	    };
	    FileUploader.prototype._isValidFile = function (file, filters, options) {
	        var _this = this;
	        this._failFilterIndex = -1;
	        return !filters.length ? true : filters.every(function (filter) {
	            _this._failFilterIndex++;
	            return filter.fn.call(_this, file, options);
	        });
	    };
	    FileUploader.prototype._isSuccessCode = function (status) {
	        return (status >= 200 && status < 300) || status === 304;
	    };
	    /* tslint:disable */
	    FileUploader.prototype._transformResponse = function (response, headers) {
	        // todo: ?
	        /*var headersGetter = this._headersGetter(headers);
	         forEach($http.defaults.transformResponse, (transformFn) => {
	         response = transformFn(response, headersGetter);
	         });*/
	        return response;
	    };
	    /* tslint:enable */
	    FileUploader.prototype._parseHeaders = function (headers) {
	        var parsed = {};
	        var key;
	        var val;
	        var i;
	        if (!headers) {
	            return parsed;
	        }
	        headers.split('\n').map(function (line) {
	            i = line.indexOf(':');
	            key = line.slice(0, i).trim().toLowerCase();
	            val = line.slice(i + 1).trim();
	            if (key) {
	                parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	            }
	        });
	        return parsed;
	    };
	    /*private _iframeTransport(item:FileItem) {
	     // todo: implement it later
	     }*/
	    FileUploader.prototype._onWhenAddingFileFailed = function (item, filter, options) {
	        this.onWhenAddingFileFailed(item, filter, options);
	    };
	    FileUploader.prototype._onAfterAddingFile = function (item) {
	        this.onAfterAddingFile(item);
	    };
	    FileUploader.prototype._onAfterAddingAll = function (items) {
	        this.onAfterAddingAll(items);
	    };
	    FileUploader.prototype._onBeforeUploadItem = function (item) {
	        item._onBeforeUpload();
	        this.onBeforeUploadItem(item);
	    };
	    FileUploader.prototype._onBuildItemForm = function (item, form) {
	        item._onBuildForm(form);
	        this.onBuildItemForm(item, form);
	    };
	    FileUploader.prototype._onProgressItem = function (item, progress) {
	        var total = this._getTotalProgress(progress);
	        this.progress = total;
	        item._onProgress(progress);
	        this.onProgressItem(item, progress);
	        this.onProgressAll(total);
	        this._render();
	    };
	    /* tslint:disable */
	    FileUploader.prototype._onSuccessItem = function (item, response, status, headers) {
	        item._onSuccess(response, status, headers);
	        this.onSuccessItem(item, response, status, headers);
	    };
	    /* tslint:enable */
	    FileUploader.prototype._onCancelItem = function (item, response, status, headers) {
	        item._onCancel(response, status, headers);
	        this.onCancelItem(item, response, status, headers);
	    };
	    return FileUploader;
	}());
	exports.FileUploader = FileUploader;
	
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
	
	/***/ },
	/* 2 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var file_uploader_class_1 = __webpack_require__(0);
	var FileDropDirective = (function () {
	    function FileDropDirective(element) {
	        this.fileOver = new core_1.EventEmitter();
	        this.onFileDrop = new core_1.EventEmitter();
	        this.element = element;
	    }
	    FileDropDirective.prototype.getOptions = function () {
	        return this.uploader.options;
	    };
	    FileDropDirective.prototype.getFilters = function () {
	        return {};
	    };
	    FileDropDirective.prototype.onDrop = function (event) {
	        var transfer = this._getTransfer(event);
	        if (!transfer) {
	            return;
	        }
	        var options = this.getOptions();
	        var filters = this.getFilters();
	        this._preventAndStop(event);
	        this.uploader.addToQueue(transfer.files, options, filters);
	        this.fileOver.emit(false);
	        this.onFileDrop.emit(transfer.files);
	    };
	    FileDropDirective.prototype.onDragOver = function (event) {
	        var transfer = this._getTransfer(event);
	        if (!this._haveFiles(transfer.types)) {
	            return;
	        }
	        transfer.dropEffect = 'copy';
	        this._preventAndStop(event);
	        this.fileOver.emit(true);
	    };
	    FileDropDirective.prototype.onDragLeave = function (event) {
	        if (event.currentTarget === this.element[0]) {
	            return;
	        }
	        this._preventAndStop(event);
	        this.fileOver.emit(false);
	    };
	    FileDropDirective.prototype._getTransfer = function (event) {
	        return event.dataTransfer ? event.dataTransfer : event.originalEvent.dataTransfer; // jQuery fix;
	    };
	    FileDropDirective.prototype._preventAndStop = function (event) {
	        event.preventDefault();
	        event.stopPropagation();
	    };
	    FileDropDirective.prototype._haveFiles = function (types) {
	        if (!types) {
	            return false;
	        }
	        if (types.indexOf) {
	            return types.indexOf('Files') !== -1;
	        }
	        else if (types.contains) {
	            return types.contains('Files');
	        }
	        else {
	            return false;
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof file_uploader_class_1.FileUploader !== 'undefined' && file_uploader_class_1.FileUploader) === 'function' && _a) || Object)
	    ], FileDropDirective.prototype, "uploader", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', (typeof (_b = typeof core_1.EventEmitter !== 'undefined' && core_1.EventEmitter) === 'function' && _b) || Object)
	    ], FileDropDirective.prototype, "fileOver", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', (typeof (_c = typeof core_1.EventEmitter !== 'undefined' && core_1.EventEmitter) === 'function' && _c) || Object)
	    ], FileDropDirective.prototype, "onFileDrop", void 0);
	    __decorate([
	        core_1.HostListener('drop', ['$event']), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', [Object]), 
	        __metadata('design:returntype', void 0)
	    ], FileDropDirective.prototype, "onDrop", null);
	    __decorate([
	        core_1.HostListener('dragover', ['$event']), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', [Object]), 
	        __metadata('design:returntype', void 0)
	    ], FileDropDirective.prototype, "onDragOver", null);
	    __decorate([
	        core_1.HostListener('dragleave', ['$event']), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', [Object]), 
	        __metadata('design:returntype', Object)
	    ], FileDropDirective.prototype, "onDragLeave", null);
	    FileDropDirective = __decorate([
	        core_1.Directive({ selector: '[ng2FileDrop]' }), 
	        __metadata('design:paramtypes', [(typeof (_d = typeof core_1.ElementRef !== 'undefined' && core_1.ElementRef) === 'function' && _d) || Object])
	    ], FileDropDirective);
	    return FileDropDirective;
	    var _a, _b, _c, _d;
	}());
	exports.FileDropDirective = FileDropDirective;
	
	
	/***/ },
	/* 3 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(1);
	var file_uploader_class_1 = __webpack_require__(0);
	// todo: filters
	var FileSelectDirective = (function () {
	    function FileSelectDirective(element) {
	        this.element = element;
	    }
	    FileSelectDirective.prototype.getOptions = function () {
	        return this.uploader.options;
	    };
	    FileSelectDirective.prototype.getFilters = function () {
	        return void 0;
	    };
	    FileSelectDirective.prototype.isEmptyAfterSelection = function () {
	        return !!this.element.nativeElement.attributes.multiple;
	    };
	    FileSelectDirective.prototype.onChange = function () {
	        // let files = this.uploader.isHTML5 ? this.element.nativeElement[0].files : this.element.nativeElement[0];
	        var files = this.element.nativeElement.files;
	        var options = this.getOptions();
	        var filters = this.getFilters();
	        // if(!this.uploader.isHTML5) this.destroy();
	        this.uploader.addToQueue(files, options, filters);
	        if (this.isEmptyAfterSelection()) {
	        }
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof file_uploader_class_1.FileUploader !== 'undefined' && file_uploader_class_1.FileUploader) === 'function' && _a) || Object)
	    ], FileSelectDirective.prototype, "uploader", void 0);
	    __decorate([
	        core_1.HostListener('change'), 
	        __metadata('design:type', Function), 
	        __metadata('design:paramtypes', []), 
	        __metadata('design:returntype', Object)
	    ], FileSelectDirective.prototype, "onChange", null);
	    FileSelectDirective = __decorate([
	        core_1.Directive({ selector: '[ng2FileSelect]' }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof core_1.ElementRef !== 'undefined' && core_1.ElementRef) === 'function' && _b) || Object])
	    ], FileSelectDirective);
	    return FileSelectDirective;
	    var _a, _b;
	}());
	exports.FileSelectDirective = FileSelectDirective;
	
	
	/***/ },
	/* 4 */
	/***/ function(module, exports) {
	
	"use strict";
	"use strict";
	function isElement(node) {
	    return !!(node && (node.nodeName || node.prop && node.attr && node.find));
	}
	var FileLikeObject = (function () {
	    function FileLikeObject(fileOrInput) {
	        var isInput = isElement(fileOrInput);
	        var fakePathOrObject = isInput ? fileOrInput.value : fileOrInput;
	        var postfix = typeof fakePathOrObject === 'string' ? 'FakePath' : 'Object';
	        var method = '_createFrom' + postfix;
	        this[method](fakePathOrObject);
	    }
	    FileLikeObject.prototype._createFromFakePath = function (path) {
	        this.lastModifiedDate = void 0;
	        this.size = void 0;
	        this.type = 'like/' + path.slice(path.lastIndexOf('.') + 1).toLowerCase();
	        this.name = path.slice(path.lastIndexOf('/') + path.lastIndexOf('\\') + 2);
	    };
	    FileLikeObject.prototype._createFromObject = function (object) {
	        // this.lastModifiedDate = copy(object.lastModifiedDate);
	        this.size = object.size;
	        this.type = object.type;
	        this.name = object.name;
	    };
	    return FileLikeObject;
	}());
	exports.FileLikeObject = FileLikeObject;
	
	
	/***/ },
	/* 5 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var common_1 = __webpack_require__(8);
	var core_1 = __webpack_require__(1);
	var file_drop_directive_1 = __webpack_require__(2);
	var file_select_directive_1 = __webpack_require__(3);
	var FileUploadModule = (function () {
	    function FileUploadModule() {
	    }
	    FileUploadModule = __decorate([
	        core_1.NgModule({
	            imports: [common_1.CommonModule],
	            declarations: [file_drop_directive_1.FileDropDirective, file_select_directive_1.FileSelectDirective],
	            exports: [file_drop_directive_1.FileDropDirective, file_select_directive_1.FileSelectDirective]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], FileUploadModule);
	    return FileUploadModule;
	}());
	exports.FileUploadModule = FileUploadModule;
	
	
	/***/ },
	/* 6 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	"use strict";
	var file_like_object_class_1 = __webpack_require__(4);
	var FileItem = (function () {
	    function FileItem(uploader, some, options) {
	        this.url = '/';
	        this.headers = [];
	        this.withCredentials = true;
	        this.formData = [];
	        this.isReady = false;
	        this.isUploading = false;
	        this.isUploaded = false;
	        this.isSuccess = false;
	        this.isCancel = false;
	        this.isError = false;
	        this.progress = 0;
	        this.index = void 0;
	        this.uploader = uploader;
	        this.some = some;
	        this.options = options;
	        this.file = new file_like_object_class_1.FileLikeObject(some);
	        this._file = some;
	        if (uploader.options) {
	            this.method = uploader.options.method || 'POST';
	            this.alias = uploader.options.itemAlias || 'file';
	        }
	        this.url = uploader.options.url;
	    }
	    FileItem.prototype.upload = function () {
	        try {
	            this.uploader.uploadItem(this);
	        }
	        catch (e) {
	            this.uploader._onCompleteItem(this, '', 0, {});
	            this.uploader._onErrorItem(this, '', 0, {});
	        }
	    };
	    FileItem.prototype.cancel = function () {
	        this.uploader.cancelItem(this);
	    };
	    FileItem.prototype.remove = function () {
	        this.uploader.removeFromQueue(this);
	    };
	    FileItem.prototype.onBeforeUpload = function () {
	        return void 0;
	    };
	    FileItem.prototype.onBuildForm = function (form) {
	        return { form: form };
	    };
	    FileItem.prototype.onProgress = function (progress) {
	        return { progress: progress };
	    };
	    FileItem.prototype.onSuccess = function (response, status, headers) {
	        return { response: response, status: status, headers: headers };
	    };
	    FileItem.prototype.onError = function (response, status, headers) {
	        return { response: response, status: status, headers: headers };
	    };
	    FileItem.prototype.onCancel = function (response, status, headers) {
	        return { response: response, status: status, headers: headers };
	    };
	    FileItem.prototype.onComplete = function (response, status, headers) {
	        return { response: response, status: status, headers: headers };
	    };
	    FileItem.prototype._onBeforeUpload = function () {
	        this.isReady = true;
	        this.isUploading = true;
	        this.isUploaded = false;
	        this.isSuccess = false;
	        this.isCancel = false;
	        this.isError = false;
	        this.progress = 0;
	        this.onBeforeUpload();
	    };
	    FileItem.prototype._onBuildForm = function (form) {
	        this.onBuildForm(form);
	    };
	    FileItem.prototype._onProgress = function (progress) {
	        this.progress = progress;
	        this.onProgress(progress);
	    };
	    FileItem.prototype._onSuccess = function (response, status, headers) {
	        this.isReady = false;
	        this.isUploading = false;
	        this.isUploaded = true;
	        this.isSuccess = true;
	        this.isCancel = false;
	        this.isError = false;
	        this.progress = 100;
	        this.index = void 0;
	        this.onSuccess(response, status, headers);
	    };
	    FileItem.prototype._onError = function (response, status, headers) {
	        this.isReady = false;
	        this.isUploading = false;
	        this.isUploaded = true;
	        this.isSuccess = false;
	        this.isCancel = false;
	        this.isError = true;
	        this.progress = 0;
	        this.index = void 0;
	        this.onError(response, status, headers);
	    };
	    FileItem.prototype._onCancel = function (response, status, headers) {
	        this.isReady = false;
	        this.isUploading = false;
	        this.isUploaded = false;
	        this.isSuccess = false;
	        this.isCancel = true;
	        this.isError = false;
	        this.progress = 0;
	        this.index = void 0;
	        this.onCancel(response, status, headers);
	    };
	    FileItem.prototype._onComplete = function (response, status, headers) {
	        this.onComplete(response, status, headers);
	        if (this.uploader.options.removeAfterUpload) {
	            this.remove();
	        }
	    };
	    FileItem.prototype._prepareToUploading = function () {
	        this.index = this.index || ++this.uploader._nextIndex;
	        this.isReady = true;
	    };
	    return FileItem;
	}());
	exports.FileItem = FileItem;
	
	
	/***/ },
	/* 7 */
	/***/ function(module, exports) {
	
	"use strict";
	"use strict";
	var FileType = (function () {
	    function FileType() {
	    }
	    FileType.getMimeClass = function (file) {
	        var mimeClass = 'application';
	        if (this.mime_psd.indexOf(file.type) !== -1) {
	            mimeClass = 'image';
	        }
	        else if (file.type.match('image.*')) {
	            mimeClass = 'image';
	        }
	        else if (file.type.match('video.*')) {
	            mimeClass = 'video';
	        }
	        else if (file.type.match('audio.*')) {
	            mimeClass = 'audio';
	        }
	        else if (file.type === 'application/pdf') {
	            mimeClass = 'pdf';
	        }
	        else if (this.mime_compress.indexOf(file.type) !== -1) {
	            mimeClass = 'compress';
	        }
	        else if (this.mime_doc.indexOf(file.type) !== -1) {
	            mimeClass = 'doc';
	        }
	        else if (this.mime_xsl.indexOf(file.type) !== -1) {
	            mimeClass = 'xls';
	        }
	        else if (this.mime_ppt.indexOf(file.type) !== -1) {
	            mimeClass = 'ppt';
	        }
	        if (mimeClass === 'application') {
	            mimeClass = this.fileTypeDetection(file.name);
	        }
	        return mimeClass;
	    };
	    FileType.fileTypeDetection = function (inputFilename) {
	        var types = {
	            'jpg': 'image',
	            'jpeg': 'image',
	            'tif': 'image',
	            'psd': 'image',
	            'bmp': 'image',
	            'png': 'image',
	            'nef': 'image',
	            'tiff': 'image',
	            'cr2': 'image',
	            'dwg': 'image',
	            'cdr': 'image',
	            'ai': 'image',
	            'indd': 'image',
	            'pin': 'image',
	            'cdp': 'image',
	            'skp': 'image',
	            'stp': 'image',
	            '3dm': 'image',
	            'mp3': 'audio',
	            'wav': 'audio',
	            'wma': 'audio',
	            'mod': 'audio',
	            'm4a': 'audio',
	            'compress': 'compress',
	            'rar': 'compress',
	            '7z': 'compress',
	            'lz': 'compress',
	            'z01': 'compress',
	            'pdf': 'pdf',
	            'xls': 'xls',
	            'xlsx': 'xls',
	            'ods': 'xls',
	            'mp4': 'video',
	            'avi': 'video',
	            'wmv': 'video',
	            'mpg': 'video',
	            'mts': 'video',
	            'flv': 'video',
	            '3gp': 'video',
	            'vob': 'video',
	            'm4v': 'video',
	            'mpeg': 'video',
	            'm2ts': 'video',
	            'mov': 'video',
	            'doc': 'doc',
	            'docx': 'doc',
	            'eps': 'doc',
	            'txt': 'doc',
	            'odt': 'doc',
	            'rtf': 'doc',
	            'ppt': 'ppt',
	            'pptx': 'ppt',
	            'pps': 'ppt',
	            'ppsx': 'ppt',
	            'odp': 'ppt'
	        };
	        var chunks = inputFilename.split('.');
	        if (chunks.length < 2) {
	            return 'application';
	        }
	        var extension = chunks[chunks.length - 1].toLowerCase();
	        if (types[extension] === undefined) {
	            return 'application';
	        }
	        else {
	            return types[extension];
	        }
	    };
	    /*  MS office  */
	    FileType.mime_doc = [
	        'application/msword',
	        'application/msword',
	        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
	        'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
	        'application/vnd.ms-word.document.macroEnabled.12',
	        'application/vnd.ms-word.template.macroEnabled.12'
	    ];
	    FileType.mime_xsl = [
	        'application/vnd.ms-excel',
	        'application/vnd.ms-excel',
	        'application/vnd.ms-excel',
	        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	        'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
	        'application/vnd.ms-excel.sheet.macroEnabled.12',
	        'application/vnd.ms-excel.template.macroEnabled.12',
	        'application/vnd.ms-excel.addin.macroEnabled.12',
	        'application/vnd.ms-excel.sheet.binary.macroEnabled.12'
	    ];
	    FileType.mime_ppt = [
	        'application/vnd.ms-powerpoint',
	        'application/vnd.ms-powerpoint',
	        'application/vnd.ms-powerpoint',
	        'application/vnd.ms-powerpoint',
	        'application/vnd.openxmlformats-officedocument.presentationml.presentation',
	        'application/vnd.openxmlformats-officedocument.presentationml.template',
	        'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
	        'application/vnd.ms-powerpoint.addin.macroEnabled.12',
	        'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
	        'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
	        'application/vnd.ms-powerpoint.slideshow.macroEnabled.12'
	    ];
	    /* PSD */
	    FileType.mime_psd = [
	        'image/photoshop',
	        'image/x-photoshop',
	        'image/psd',
	        'application/photoshop',
	        'application/psd',
	        'zz-application/zz-winassoc-psd'
	    ];
	    /* Compressed files */
	    FileType.mime_compress = [
	        'application/x-gtar',
	        'application/x-gcompress',
	        'application/compress',
	        'application/x-tar',
	        'application/x-rar-compressed',
	        'application/octet-stream'
	    ];
	    return FileType;
	}());
	exports.FileType = FileType;
	
	
	/***/ },
	/* 8 */
	/***/ function(module, exports) {
	
	module.exports = __WEBPACK_EXTERNAL_MODULE_8__;
	
	/***/ },
	/* 9 */
	/***/ function(module, exports, __webpack_require__) {
	
	"use strict";
	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(3));
	__export(__webpack_require__(2));
	__export(__webpack_require__(0));
	var file_upload_module_1 = __webpack_require__(5);
	exports.FileUploadModule = file_upload_module_1.FileUploadModule;
	
	
	/***/ }
	/******/ ])
	});
	;
	//# sourceMappingURL=ng2-file-upload.umd.js.map

/***/ },
/* 811 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{breadCrumbTitle}}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li><a [routerLink]=\"urlDefaultPage\"><i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a></li>\r\n        <li><a [routerLink]=\"urlVehicleList\"><i class=\"fa fa-cab\"></i>{{breadCrumbList}}</a></li>\r\n        <li class=\"active\">{{breadCrumbTitle}}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25 \"></div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n\r\n  <section class=\"content\">\r\n    <div class=\"nopad\">\r\n      <!--<pre> {{ model | json }} </pre>-->\r\n      <form (ngSubmit)=\"onSubmit(AddVehicleForm.value)\" #AddVehicleForm=\"ngForm\">\r\n        <input type=\"hidden\" class=\"form-control\" [(ngModel)]=\"model.vehicleMasterHashId\" name=\"vehicleMasterHashId\">\r\n\r\n        <fieldset [disabled]=\"authService.IsGroupAdmin()\">\r\n\r\n          <!--Basic Information-->\r\n          <fieldset class=\"row col-md-12 mar_bot_20\">\r\n\r\n            <div class=\"form-group col-md-4\">\r\n              <label><span class=\"text text-danger\">*</span>{{ 'LblLicenceTag' | translate }}</label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblLicenceTag' | translate }}\" [(ngModel)]=\"model.licenceTag\" name=\"LicenceTag\" maxlength=\"15\">\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'LicenceTag' }}</span>\r\n            </div>\r\n\r\n            <div class=\"form-group col-md-4\">\r\n              <label><span class=\"text text-danger\">*</span>{{ 'LblVehicleOwner' | translate }}</label>\r\n              <div [class.input-group]=\"isEditMode && model.isCompanyEditable\">\r\n                <select *ngIf=\"!isEditMode\" [(ngModel)]=\"model.ownerCompanyHashID\" name=\"ownerCompanyID\" class=\"form-control\" (change)=\"onChangeSelectedCompany($event.target.value)\">\r\n                  <option value=''>{{ 'LblSelect' | translate }} {{ 'LblVehicleOwner' | translate }} </option>\r\n                  <option *ngFor=\"let company of companyList\" [ngValue]='company.keyHash'>{{company.value}}</option>\r\n                </select>\r\n                <input *ngIf=\" isEditMode\" readonly type=\"text\" class=\"form-control\" [ngModel]=\"model.ownerName\" name=\"ownerCompanyID\">\r\n                <div *ngIf=\"isEditMode && model.isCompanyEditable\" class=\"input-group-btn\">\r\n                  <button class=\"btn btn-default search-icon\" [routerLink]=\"urlCompanyInformation +'/' + model.ownerCompanyHashID\" title=\"{{ 'LblVehicleOwner' | translate }}\">\r\n                    <i class=\"fa fa-building-o fa-fw\" aria-hidden=\"true\"></i>\r\n                  </button>\r\n                </div>\r\n              </div>\r\n\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'ownerCompanyHashID' }}</span>\r\n            </div>\r\n\r\n            <div class=\"form-group col-md-4\">\r\n              <label>{{ 'LblVTSVehicle' | translate }}</label>\r\n              <select *ngIf=\"authService.GetHighestRoleLevel() == roleLevel.WeGo\" [(ngModel)]=\"model.locationDataExchangeHashId\" (ngModelChange)=\"UpdateVTSData()\" class=\"form-control\" name=\"locationDataExchangeHashId\">\r\n                <option value=\"\" [selected]=\"selected\">{{ 'LblSelect' | translate }} {{ 'LblVTSVehicle' | translate }}</option>\r\n                <option *ngFor=\"let item of VTSVehicleList\" [ngValue]=\"item.locationDataExchangeHashId\">{{ item.licenceTag }}</option>\r\n              </select>\r\n              <input *ngIf=\"authService.GetHighestRoleLevel() != roleLevel.WeGo\" disabled type=\"text\" class=\"form-control\" [ngModel]=\"model.vtsLicenceNamePlate\" name=\"vtsLicenceNamePlate\">\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'locationDataExchangeHashId' }}</span>\r\n            </div>\r\n\r\n            <div class=\"clearfix\"></div>\r\n\r\n            <div class=\"form-group col-md-4\">\r\n              <label>{{ 'LblBrand' | translate }}</label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblBrand' | translate }}\" [(ngModel)]=\"model.brand\" name=\"Brand\" maxlength=\"50\">\r\n            </div>\r\n\r\n            <div class=\"form-group col-md-4\">\r\n              <label>{{ 'LblType' | translate }}</label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblType' | translate }}\" [(ngModel)]=\"model.type\" name=\"Type\" maxlength=\"20\">\r\n            </div>\r\n\r\n            <div class=\"form-group col-md-4\">\r\n              <label>{{ 'LblColor' | translate }}</label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblColor' | translate }}\" [(ngModel)]=\"model.color\" name=\"Color\" maxlength=\"20\">\r\n            </div>\r\n\r\n            <div class=\"clearfix\"></div>\r\n\r\n            <div class=\"form-group col-md-4\">\r\n              <label>{{ 'LblVehicleClass' | translate }}</label>\r\n              <select [(ngModel)]=\"model.vehicleClass\" class=\"form-control\" name=\"vehicleClass\">\r\n                <option *ngFor=\"let item of vehicleClassList\" [ngValue]=\"item.Value\">{{ item.Key }}</option>\r\n              </select>\r\n            </div>\r\n\r\n            <div class=\"form-group col-md-4\">\r\n              <label>{{ 'LblBodyStyle' | translate }}</label>\r\n              <select [(ngModel)]=\"model.bodyStyle\" class=\"form-control\" name=\"bodyStyle\">\r\n                <option *ngFor=\"let item of bodyStyleList\" [ngValue]=\"item.Value\">{{ item.Key }}</option>\r\n              </select>\r\n            </div>\r\n\r\n            <div class=\"form-group col-md-4\">\r\n              <label>{{ 'LblPricingCategory' | translate }}</label>\r\n              <select [(ngModel)]=\"model.pricingCategory\" class=\"form-control\" name=\"pricingCategory\">\r\n                <option *ngFor=\"let item of pricingCategoryList\" [ngValue]=\"item.Value\">{{ item.Key }}</option>\r\n              </select>\r\n            </div>\r\n\r\n            <div class=\"form-group col-md-4\">\r\n              <label>{{ 'LblVINnumber' | translate }}</label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblVINnumber' | translate }}\" [(ngModel)]=\"model.vin\"\r\n                name=\"vin\" maxlength=\"17\" (change)=\"OnChangeVin()\">\r\n            </div>\r\n\r\n            <div class=\"form-group col-md-4\">\r\n              <label>{{ 'LblVehicletype' | translate }}</label>\r\n              <select [(ngModel)]=\"model.vehicletype\" class=\"form-control\" name=\"vehicletype\">\r\n                <option *ngFor=\"let item of vehicletypeList\" [ngValue]=\"item.Value\">{{ item.Key }}</option>\r\n              </select>\r\n            </div>\r\n\r\n            <div class=\"clearfix\"></div>\r\n\r\n            <div class=\"form-group col-md-4\">\r\n              <label>{{ 'LblVehicleImage' | translate }}</label>\r\n              <input #logoFile type=\"file\" id=\"fileLoader\" accept=\"image/x-png,image/png,image/gif,image/jpeg\" ng2FileSelect [uploader]=\"uploader\" name=\"files\" [ngClass]=\"{'nv-file-over': hasBaseDropZoneOver}\" title=\"Load File\" />\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'file' }}</span>\r\n            </div>\r\n\r\n            <div *ngIf=\"model.vehicleImagePath!=null\" class=\"form-group col-md-4\">\r\n              <img [src]=\"GetImageURL(model.vehicleImagePath)\" class=\"img-thumbnail\" style=\"height: 100px\">\r\n            </div>\r\n          </fieldset>\r\n\r\n          <div class=\"clearfix\"></div>\r\n\r\n          <!--Fuel details-->\r\n          <fieldset class=\"col-md-12 mar_bot_20\">\r\n            <legend class=\"legendStyle\">{{ 'LblFuel' | translate }}</legend>\r\n            <div class=\"row form-group col-md-4\">\r\n              <label>{{ 'LblFuelType' | translate }}</label>\r\n              <select [(ngModel)]=\"model.fuelType\" class=\"form-control\" name=\"fuelType\">\r\n                <option *ngFor=\"let item of fuelTypeList\" [ngValue]=\"item.Value\">{{ item.Key }}</option>\r\n              </select>\r\n            </div>\r\n            <div class=\"form-group col-md-4\">\r\n              <label>{{ 'LblFuelCardPinCode' | translate }}</label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblFuelCardPinCode' | translate }}\" [(ngModel)]=\"model.fuelCardPinCode\" name=\"fuelCardPinCode\" maxlength=\"20\">\r\n            </div>\r\n            <div class=\"form-group col-md-4\">&nbsp;</div>\r\n          </fieldset>\r\n\r\n          <!--Additional attribute-->\r\n          <fieldset class=\"col-md-12 mar_bot_20\" *ngIf=\"GroupByCategory()!=null\">\r\n            <legend class=\"legendStyle\" style=\"margin-bottom: 10px;\">{{ 'LblVehicleAttribute' | translate }}</legend>\r\n            <div class=\"col-md-12\" *ngFor=\"let cat of KeyOfObject(GroupByCategory()); let i = index\">\r\n              <div><label>{{ cat }}</label></div>\r\n              <div class=\"col-md-3\" *ngFor=\"let vehicleattriute of GroupByCategory()[cat]; let i = index\">\r\n                <div class=\"checkbox\">\r\n                  <label>\r\n                    <input type=\"checkbox\" [checked]=\"vehicleattriute.isChecked\" (change)=\"vehicleattriute.isChecked = $event.target.checked\">\r\n                    {{ vehicleattriute.attributeName }}\r\n                  </label>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </fieldset>\r\n\r\n          <div class=\"clearfix\"></div>\r\n\r\n          <!--Vehicle details-->\r\n          <fieldset class=\"col-md-12 mar_bot_20\">\r\n            <legend class=\"legendStyle\">{{ 'LblVehicleDetails' | translate }}</legend>\r\n\r\n            <div class=\"row\">\r\n\r\n              <div class=\"form-group col-md-4\">\r\n                <label>{{ 'LblDoors' | translate }}</label>\r\n                <input type=\"number\" class=\"form-control\" placeholder=\"{{ 'LblDoors' | translate }}\" [(ngModel)]=\"model.doors\" name=\"doors\" maxlength=\"1\">\r\n              </div>\r\n\r\n              <div class=\"form-group col-md-4\">\r\n                <label>{{ 'LblWeight' | translate }}</label>\r\n                <input type=\"number\" class=\"form-control\" placeholder=\"{{ 'LblWeight' | translate }}\" [(ngModel)]=\"model.weight\" name=\"weight\" maxlength=\"4\">\r\n              </div>\r\n\r\n              <div class=\"form-group col-md-4\">\r\n                <label>{{ 'LblTrunkSpace' | translate }}</label>\r\n                <input type=\"number\" class=\"form-control\" placeholder=\"{{ 'LblTrunkSpace' | translate }}\" [(ngModel)]=\"model.trunkSpace\" name=\"trunkSpace\" maxlength=\"4\">\r\n              </div>\r\n\r\n              <div class=\"form-group col-md-4\">\r\n                <label>{{ 'LblGears' | translate }}</label>\r\n                <input type=\"number\" class=\"form-control\" placeholder=\"{{ 'LblGears' | translate }}\" [(ngModel)]=\"model.gears\" name=\"gears\" maxlength=\"1\">\r\n              </div>\r\n\r\n              <div class=\"form-group col-md-4\">\r\n                <label>{{ 'LblEngineHorsepower' | translate }}</label>\r\n                <input type=\"number\" class=\"form-control\" placeholder=\"{{ 'LblEngineHorsepower' | translate }}\" [(ngModel)]=\"model.engineHorsepower\" name=\"engineHorsepower\" maxlength=\"3\">\r\n              </div>\r\n\r\n              <div class=\"form-group col-md-4\">\r\n                <label>{{ 'LblFuelConsumption' | translate }}</label>\r\n                <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblFuelConsumption' | translate }}\" [(ngModel)]=\"model.fuelConsumption\" name=\"fuelConsumption\" maxlength=\"10\">\r\n              </div>\r\n\r\n              <div class=\"form-group col-md-4\">\r\n                <label>{{ 'LblSeats' | translate }}</label>\r\n                <input type=\"number\" class=\"form-control\" placeholder=\"{{ 'LblSeats' | translate }}\" [(ngModel)]=\"model.seats\" name=\"seats\" maxlength=\"2\">\r\n              </div>\r\n\r\n              <div class=\"form-group col-md-4\">\r\n                <label>{{ 'LblDimensions' | translate }}</label>\r\n                <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblDimensions' | translate }}\" [(ngModel)]=\"model.dimensions\" name=\"dimensions\" maxlength=\"100\">\r\n              </div>\r\n\r\n              <div class=\"form-group col-md-4\">\r\n                <label>{{ 'LblTransmissionType' | translate }}</label>\r\n                <div class=\"clearfix\"></div>\r\n                <label class=\"radio-inline\">\r\n                  <input type=\"radio\" [(ngModel)]=\"model.transmissionType\" name=\"transmissionType\" value=\"\">{{ 'LblTransmissionUnknown' | translate }}\r\n                </label>\r\n                <label class=\"radio-inline\">\r\n                  <input type=\"radio\" [(ngModel)]=\"model.transmissionType\" name=\"transmissionType\" value=\"M\">{{ 'LblManualTransmission' | translate }}\r\n                </label>\r\n                <label class=\"radio-inline\">\r\n                  <input type=\"radio\" [(ngModel)]=\"model.transmissionType\" name=\"transmissionType\" value=\"A\">{{ 'LblAutomaticTransmission' | translate }}\r\n                </label>\r\n              </div>\r\n            </div>\r\n          </fieldset>\r\n\r\n          <div class=\"clearfix\"></div>\r\n\r\n          <!--Licenses and certificates-->\r\n          <fieldset class=\"col-md-12 mar_bot_20\">\r\n            <legend class=\"legendStyle\">{{ 'LblDriversLicenseAndCertificates' | translate }}</legend>\r\n  \r\n            <div class=\"row\">\r\n              <div class=\"form-group col-md-4\">\r\n                <label>{{ 'LblLicense' | translate }}</label>\r\n                <select [(ngModel)]=\"model.license\" class=\"form-control\" name=\"license\">\r\n                  <option *ngFor=\"let item of licenseList\" [ngValue]=\"item.Value\">{{ item.Key }}</option>\r\n                </select>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"row\">\r\n              <div class=\"form-group col-md-4\">\r\n                <label>{{ 'LblCertificates' | translate }}</label>\r\n                <textarea class=\"form-control\" placeholder=\"{{ 'LblCertificates' | translate }}\" [(ngModel)]=\"model.certificates\" name=\"certificates\" maxlength=\"500\"></textarea>\r\n              </div>\r\n            </div>\r\n          </fieldset> \r\n\r\n          <!--Avability-->\r\n          <fieldset class=\"col-md-12 mar_bot_20\">\r\n            <legend class=\"legendStyle\">{{ 'LblAvailability' | translate }}</legend>\r\n\r\n            <div class=\"row\">\r\n\r\n              <div class=\"form-group col-md-4\">\r\n                <label>\r\n                  <span class=\"text text-danger\">*</span>{{ 'LblAvailable' | translate }}</label>\r\n                <div class=\"clearfix\"></div>\r\n                <label class=\"radio-inline\">\r\n                  <input type=\"radio\" [(ngModel)]=\"model.available\" name=\"Available\" [value]=\"true\">{{ 'LblAvailable' | translate }}\r\n                </label>\r\n                <label class=\"radio-inline\">\r\n                  <input type=\"radio\" [(ngModel)]=\"model.available\" name=\"Available\" [value]=\"false\">{{ 'LblUnAvailable' | translate }}\r\n                </label>\r\n              </div>\r\n\r\n              <div [hidden]=\"!model.available\" class=\"form-group col-md-4\">\r\n                <label>{{ 'LblAvailableFrom' | translate }}</label>\r\n                <div class=\"input-group\">\r\n                  <span class=\"input-group-addon\">\r\n                    <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n                  </span>\r\n                  <input class=\"form-control\" placeholder=\"{{ 'LblAvailableFrom' | translate }}\" [(ngModel)]=\"model.availableFromDatetime\" name=\"AvailableFrom\" [Config]=\"flatPickrConfigFrom\" flatpickr readonly>\r\n                  <span class=\"input-group-addon cursor-pointer\" (click)=\"model.availableFromDatetime = ''\">\r\n                    <i aria-hidden=\"true\" class=\"fa fa-eraser fa-fw\"></i>\r\n                  </span>\r\n                </div>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'AvailableFromDatetime' }}</span>\r\n              </div>\r\n\r\n              <div [hidden]=\"!model.available\" class=\"form-group col-md-4\">\r\n                <label>{{ 'LblAvailableTo' | translate }}</label>\r\n                <div class=\"input-group\">\r\n                  <span class=\"input-group-addon\">\r\n                    <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n                  </span>\r\n                  <input class=\"form-control\" [Config]=\"flatPickrConfigTo\" placeholder=\"{{ 'LblAvailableTo' | translate }}\" [(ngModel)]=\"model.availableToDatetime\" name=\"AvailableTo\" flatpickr readonly>\r\n                  <span class=\"input-group-addon cursor-pointer\" (click)=\"model.availableToDatetime = ''\">\r\n                    <i aria-hidden=\"true\" class=\"fa fa-eraser fa-fw\"></i>\r\n                  </span>\r\n                </div>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'AvailableToDatetime' }}</span>\r\n              </div>\r\n\r\n              <div [hidden]=\"model.available\" class=\"form-group col-md-4\">\r\n                <label> {{ 'LbLReasonVehicle' | translate }} </label>\r\n                <textarea class=\"form-control\" [(ngModel)]=\"model.reason\" name=\"reason\" placeholder=\"{{ 'LbLReasonVehicle' | translate }}\"></textarea>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'reason' }}</span>\r\n              </div>\r\n\r\n            </div>\r\n          </fieldset>\r\n\r\n          <!--Track and Trace Panel-->\r\n          <fieldset class=\"col-md-12 mar_bot_20\">\r\n            <legend class=\"legendStyle\">{{ 'LblTrackAndTrace' | translate }}</legend>\r\n\r\n            <div class=\"row\">\r\n\r\n              <div class=\"form-group col-md-4\">\r\n                <label>{{ 'LblTrackAndTrace' | translate }}</label>\r\n                <div class=\"clearfix\"></div>\r\n                <label class=\"radio-inline\">\r\n                  <input type=\"radio\" [(ngModel)]=\"model.tagAccessDisabled\" name=\"TnTAvailable\" [value]=\"false\">{{ 'LblAvailable' | translate }}\r\n                </label>\r\n                <label class=\"radio-inline\">\r\n                  <input type=\"radio\" [(ngModel)]=\"model.tagAccessDisabled\" name=\"TnTAvailable\" [value]=\"true\">{{ 'LblUnAvailable' | translate }}\r\n                </label>\r\n              </div>\r\n            </div>\r\n\r\n          </fieldset>\r\n\r\n          <!--Setting Panel-->\r\n          <fieldset class=\"col-md-12 mar_bot_20\">\r\n            <legend class=\"legendStyle\">{{ 'LblSettings' | translate }}</legend>\r\n\r\n            <div class=\"row\">\r\n\r\n              <div class=\"form-group col-md-4\">\r\n                <label>{{ 'LblPreBookingInterval' | translate }}</label>\r\n                <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblPreBookingInterval' | translate }}\"\r\n                  [(ngModel)]=\"model.minBookingTimeBefore\" name=\"MinBookingTimeBefore\" maxlength=\"4\">\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'MinBookingTimeBefore' }}</span>\r\n              </div>\r\n\r\n              <div class=\"form-group col-md-4\">\r\n                <label>{{ 'LblPostBookingInterval' | translate }}</label>\r\n                <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblPostBookingInterval' | translate }}\"\r\n                  [(ngModel)]=\"model.minBookingTimeAfter\" name=\"Min Booking Time After\" maxlength=\"4\">\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'MinBookingTimeAfter' }}</span>\r\n              </div>\r\n\r\n              <div class=\"form-group col-md-4\">\r\n                <label>{{ 'LblEarlyOpenInterval' | translate }}</label>\r\n                <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblEarlyOpenInterval' | translate }}\"\r\n                  [(ngModel)]=\"model.earlyOpenInterval\" name=\"earlyOpenInterval\" maxlength=\"4\">\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'earlyOpenInterval' }}</span>\r\n              </div>\r\n\r\n              <div class=\"clearfix\"></div>\r\n\r\n              <div class=\"form-group col-md-4\">\r\n                <label>{{ 'LblApkExpirationDateCet' | translate }}</label>\r\n                <div class=\"input-group\">\r\n                  <span class=\"input-group-addon\">\r\n                    <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n                  </span>\r\n                  <input class=\"form-control\" placeholder=\"{{ 'LblApkExpirationDateCet' | translate }}\" [(ngModel)]=\"model.apkExpirationDate\" name=\"apkExpirationDateCetDateTime\" [Config]=\"flatePickerApkExiprationDate\" flatpickr readonly>\r\n                </div>\r\n              </div>\r\n\r\n              <div *ngIf=\"!isEditMode\" class=\"form-group col-md-4\">\r\n                <label>\r\n                  <span class=\"text text-danger\">*</span> {{ 'LblIntialOdometerValue' | translate }}\r\n                </label>\r\n                <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblIntialOdometerValue' | translate }}\" [(ngModel)]=\"model.userProvidedOdometerValueInKm\" name=\"userProvidedOdometerValueInKm\">\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'userProvidedOdometerValueInKm' }}</span>\r\n              </div>\r\n\r\n              <div class=\"form-group col-md-4\">\r\n                <label>{{ 'LblShowVehicleChargeLevel' | translate }}</label>\r\n                <div>\r\n                  <label class=\"radio-inline\">\r\n                    <input type=\"radio\" [(ngModel)]=\"model.showVehicleChargeLevel\" name=\"showVehicleChargeLevel\" value=\"YES\">\r\n                    {{ 'LblYes' | translate }}\r\n                  </label>\r\n                  <label class=\"radio-inline\">\r\n                    <input type=\"radio\" [(ngModel)]=\"model.showVehicleChargeLevel\" name=\"showVehicleChargeLevel\" value=\"NO\">\r\n                    {{ 'LblNo' | translate }}\r\n                  </label>\r\n                  <label class=\"radio-inline\">\r\n                    <input type=\"radio\" [(ngModel)]=\"model.showVehicleChargeLevel\" name=\"showVehicleChargeLevel\" value=\"INHERIT\">\r\n                    {{ 'LblInherit' | translate }}\r\n                  </label>\r\n                </div>\r\n              </div>\r\n\r\n            <!-- WEGO2DEV-325(Settings for Dashboard statuses) -->\r\n            <!-- <div class=\"clearfix\"></div>\r\n            <div class=\"form-group col-md-3\">\r\n              <label>{{ 'LblVehicleOnSameLocationTime' | translate }}</label>\r\n              <input type=\"text\" maxlength=\"6\" class=\"form-control\" placeholder=\"{{ 'LblVehicleOnSameLocationTime' | translate }}\" [(ngModel)]=\"model.locationVehicleTime\"\r\n                name=\"locationVehicleTime\">\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'locationVehicleTime' }}</span>\r\n            </div>\r\n            <div class=\"form-group col-md-3\">\r\n              <label>{{'LblVehicleOnSameLocationTimeInterval' | translate}}</label>\r\n              <select [(ngModel)]=\"model.locationTimeInterval\" class=\"form-control\" name=\"LocationTimeInterval\">\r\n              <option *ngFor=\"let item of timeIntervalList\" [ngValue]=\"item.Value\">{{ item.Key }}</option>\r\n             </select>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'LocationTimeInterval' }}</span>\r\n            </div>\r\n            <div class=\"form-group col-md-3\">\r\n              <label>{{'LblVehicleBookedBeforeTime' | translate}}</label>\r\n              <input type=\"text\" maxlength=\"6\" class=\"form-control\" placeholder=\"{{ 'LblVehicleBookedBeforeTime' | translate }}\" [(ngModel)]=\"model.bookedBeforeTime\"\r\n                name=\"bookedBeforeTime\">\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'bookedBeforeTime' }}</span>\r\n            </div>\r\n            <div class=\"form-group col-md-3\">\r\n              <label>{{'LblVehicleBookedBeforeInterval' | translate}}</label>\r\n              <select [(ngModel)]=\"model.bookedBeforeInterval\" class=\"form-control\" name=\"BookedBeforeInterval\">\r\n              <option *ngFor=\"let item of bookedBeforeTimeIntervalList\" [ngValue]=\"item.Value\">{{ item.Key }}</option>\r\n             </select>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'BookedBeforeInterval' }}</span>\r\n            </div> -->\r\n\r\n              <div class=\"clearfix\"></div>\r\n\r\n              <div *ngIf=\"model.isGefenceEnabled\" class=\"form-group col-md-6\">\r\n                <label> {{ 'LblGeofenceLocation' | translate }}</label>\r\n                <div class=\"input-group\">\r\n                  <input class=\"form-control\" type=\"text\" placeholder=\"{{ 'LblGeofenceLocation' | translate }}\" name=\"geofenceAttributeModel.address\" [(ngModel)]=\"model.geofenceAttributeModel.address\" readonly />\r\n                  <div class=\"input-group-btn\">\r\n                    <button class=\"btn btn-default\" type=\"button\" (click)=\"GeofenceLocation()\">\r\n                      <i class=\"fa fa-map-marker\" aria-hidden=\"true\"></i>\r\n                    </button>\r\n                    <button class=\"btn btn-default\" type=\"button\" (click)=\"ResetLocationField('geofence')\">\r\n                      <i class=\"fa fa-eraser\" aria-hidden=\"true\"></i>\r\n                    </button>\r\n                  </div>\r\n                </div>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'GeofenceAttributeModel.Address' }}</span>\r\n              </div>\r\n\r\n              <div *ngIf=\"model.isGefenceEnabled\" class=\"form-group col-md-3\">\r\n                <label> {{ 'LblRadius' | translate }} ({{'LblMeter' | translate}})</label>\r\n                <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblRadius' | translate }} \" [(ngModel)]=\"model.geofenceAttributeModel.radiusInMtr\" name=\"geofenceAttributeModel.radiusInMtr\">\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'GeofenceAttributeModel.RadiusInMtr' }}</span>\r\n              </div>\r\n\r\n              <div class=\"clearfix\"></div>\r\n\r\n              <div *ngIf=\"model.isHomeLocationEnabled\" class=\"form-group col-md-6\">\r\n                <label>{{ 'LblHomeLocation' | translate }}</label>\r\n                <div class=\"input-group\">\r\n                  <input readonly class=\"form-control\" placeholder=\"{{ 'LblHomeLocation' | translate }} \" type=\"text\" name=\"homeLocationModel.address\" [(ngModel)]=\"model.homeLocationModel.address\" />\r\n                  <div class=\"input-group-btn\">\r\n                    <button class=\"btn btn-default icon-map-marker\" type=\"button\" (click)=\"SearchHomeAddress()\">\r\n                      <i class=\"fa fa-map-marker\" aria-hidden=\"true\"></i>\r\n                    </button>\r\n                    <button class=\"btn btn-default\" type=\"button\" (click)=\"ResetLocationField('home')\">\r\n                      <i class=\"fa fa-eraser\" aria-hidden=\"true\"></i>\r\n                    </button>\r\n                  </div>\r\n                </div>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'homeLocationModel.address' }}</span>\r\n              </div>\r\n\r\n              <div *ngIf=\"model.isHomeLocationEnabled\" class=\"form-group col-md-3\">\r\n                <label>{{ 'LblRadius' | translate }} ({{ 'LblMeter' | translate }})</label>\r\n                <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblRadius' | translate }}\" [(ngModel)]=\"model.homeLocationModel.radiusInMtr\" name=\"homeLocationModel.radiusInMtr\">\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'homeLocationModel.radiusInMtr' }}</span>\r\n              </div>\r\n\r\n            </div>\r\n          </fieldset>\r\n\r\n          <!-- Pre Post trip Question at instance level -->\r\n          <fieldset *ngIf=\"isAuthorizedForPrePostTrip && isEditMode\" class=\"col-md-12 mar_bot_20\">\r\n            <legend class=\"legendStyle\">{{ 'LblPrePostTripQuestions' | translate }}</legend>\r\n            <wego-pre-post-trip-question #prePostTripQuestionSection [VehicleView]=\"true\" [ErrorModel]=\"errorModel\"\r\n              [CustomTripQuestionList]=\"model.customTripQuestionList\" (OnPrePostTripQuestionSetting)=\"OnPrePostTripQuestionSetting($event)\"></wego-pre-post-trip-question>\r\n          </fieldset>\r\n\r\n          <!-- Default Vehicle Setting -->\r\n          <fieldset class=\"col-md-12 mar_bot_20\">\r\n            <legend class=\"legendStyle\">{{ 'LblDefaultVehicleSetting' | translate }}</legend>\r\n\r\n            <div class=\"row\">\r\n\r\n              <div class=\"form-group col-md-4\">\r\n                <label>{{ 'LblLowBatteryFlagRaised' | translate }}</label>\r\n                <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblLowBatteryFlagRaised' | translate }}\" name=\"lowBatteryFlagRaised\" maxlength=\"4\" [(ngModel)]=\"model.lowBatteryFlagRaised\" (change)=\"SetLowBatteryFlag();\">\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'lowBatteryFlagRaised' }}</span>\r\n              </div>\r\n\r\n              <div class=\"form-group col-md-4\">\r\n                <label>{{ 'LblLowBatteryFlagClear' | translate }}</label>\r\n                <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblLowBatteryFlagClear' | translate }}\" name=\"lowBatteryFlagClear\" maxlength=\"4\" [(ngModel)]=\"model.lowBatteryFlagClear\">\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'lowBatteryFlagClear' }}</span>\r\n              </div>\r\n\r\n              <div class=\"clearfix\"></div>\r\n\r\n            </div>\r\n          </fieldset>\r\n\r\n        </fieldset>\r\n\r\n        <!--Button Panel-->\r\n        <div class=\"row no-margin\">\r\n          <div class=\"col-sm-12\">\r\n            <hr>\r\n            <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnBackClick()\">{{ 'LblCancel' | translate }}</a>\r\n            &nbsp;&nbsp;\r\n            <button class=\"btn btn-green\" type=\"submit\">{{ 'LblSave' | translate }}</button>\r\n          </div>\r\n        </div>\r\n\r\n      </form>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<!--Added for affectedbooking-->\r\n<div bsModal #affectedbookingModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"OnCancel()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\"> {{ 'LblAffectedBookingList' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <wego-search-list (OnSearch)=\"OnSearch($event)\" [IsExported]=\"false\" [SearchTerm]=\"DataListModel.searchTerm\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('BookingReferenceId')\">\r\n                  {{ 'LblReference' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'BookingReferenceId'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('licenceTag')\">\r\n                  {{ 'LblVehicle' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'licenceTag'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('driver')\">\r\n                  {{ 'LblDriver' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'driver'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('translatedBookingStatus')\">\r\n                  {{ 'LblStatus' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'translatedBookingStatus'\" [SortType]=\"DataListModel.sortType\"\r\n                    [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('translatedBookingType')\">\r\n                  {{ 'LblType' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'translatedBookingType'\" [SortType]=\"DataListModel.sortType\"\r\n                    [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('startDateTimeUTC')\">\r\n                  {{ 'LblFrom' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'startDateTimeUTC'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('endDateTimeUTC')\">\r\n                  {{ 'LblTo' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'endDateTimeUTC'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let bookings of bookingList\">\r\n                  <td>{{ bookings.bookingReferenceID }}</td>\r\n                  <td>{{ bookings.licenceTag }}</td>\r\n                  <td>{{ bookings.driver }}</td>\r\n                  <td>{{ bookings.translatedBookingStatus }}</td>\r\n                  <td>{{ bookings.translatedBookingType }}</td>\r\n                  <td>{{ bookings.startDateTime}}</td>\r\n                  <td>{{ bookings.endDateTime }}</td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"14\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\"\r\n                [(ngModel)]=\"DataListModel.currentPage\" [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\"\r\n                previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\" lastText=\"&raquo;\" [rotate]=\"false\"\r\n                (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n      </div>\r\n      <div class=\"modal-footer\">\r\n        <button type=\"button\" (click)=\"OnCancel()\" class=\"btn btn-default\" data-dismiss=\"modal\">\r\n          {{ 'LblCancel' | translate }}\r\n        </button>\r\n        <button type=\"button\" (click)=\"OnConfirm()\" class=\"btn btn-primary\">\r\n          {{'LblConfirm' | translate}}\r\n        </button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<!--end-->\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n<wego-confirm-popup #warningPopup [popupTitle]=\"LblWarning\" [popupMsg]=\"vtsConfirmMsg\" (onConfirm)=\"warningPopup.hide(); UpdateVehicle()\"\r\n  (onReject)=\"warningPopup.hide()\"></wego-confirm-popup>\r\n<wego-geo-location-map #geoLocationModal (onConfirm)=\"onConfirm($event)\" [Language] = \"language\"></wego-geo-location-map>\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n<!--<wego-geolocation-popup #geoLocationModal [markerInfo]=\"markerInfo\" (onConfirm)=\"GetGeoLocation($event)\"></wego-geolocation-popup>-->";

/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var config_1 = __webpack_require__(60);
	var core_1 = __webpack_require__(3);
	var vehicle_model_1 = __webpack_require__(553);
	var vehicle_service_1 = __webpack_require__(530);
	var router_1 = __webpack_require__(26);
	var config_2 = __webpack_require__(60);
	var VehicleListComponent = (function () {
	    function VehicleListComponent(vehicleService, activeRoute, router, authService, translate) {
	        this.vehicleService = vehicleService;
	        this.activeRoute = activeRoute;
	        this.router = router;
	        this.authService = authService;
	        this.translate = translate;
	        this.ownerCompanyHashID = "";
	        this.sharedVehicleGroupHashId = "";
	        // list page filter variable
	        this.chkCleanRequireFilter = false;
	        this.chkFuelRequireFilter = false;
	        this.chkDamageFilter = false;
	    }
	    Object.defineProperty(VehicleListComponent.prototype, "isAnyChecked", {
	        get: function () {
	            if (this.vehicleList) {
	                var isCheck = this.vehicleList.some(function (x) { return x.isChecked == true; });
	                if (isCheck) {
	                    if (this.vehicleList.every(function (x) { return x.isChecked == true; }))
	                        this.isParentCheck = true;
	                    else
	                        this.isParentCheck = false;
	                }
	                else {
	                    this.isParentCheck = false;
	                }
	                return isCheck;
	            }
	            else {
	                this.isParentCheck = false;
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(VehicleListComponent.prototype, "isDeleteAccess", {
	        get: function () {
	            if (this.vehicleList) {
	                return this.vehicleList.some(function (x) { return x.isDeletable; });
	            }
	            else {
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    VehicleListComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.lblAvailable = this.translate.instant("LblAvailable");
	        this.lblUnavailable = this.translate.instant("LblUnAvailable");
	        this.LblFualNotRequire = this.translate.instant("LblFualNotRequire");
	        this.LblFualRequire = this.translate.instant("LblFualRequire");
	        this.LblCleanNotRequire = this.translate.instant("LblCleanNotRequire");
	        this.LblCleanRequire = this.translate.instant("LblCleanRequire");
	        this.LblVehiclDamaged = this.translate.instant("LblVehiclDamaged");
	        this.LblVehicleNotDamaged = this.translate.instant("LblVehicleNotDamaged");
	        this.module = this.translate.instant("LblVehicle");
	        this.breadCrumbList = this.translate.instant("LblListPage", [this.module]);
	        this.urlSharedVehicleGroupList = this.authService.GetURL(config_2.ApplicationRouteURL.URL_SVG_LIST);
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.model = new vehicle_model_1.VehicleBlockModel();
	        this.DataListModel.searchField = [
	            "licenceTag",
	            "ownerName",
	            "brand",
	            "type",
	            "vehicleClass",
	            "color"
	        ];
	        this.urlDefaultPage = this.authService.GetURL(config_2.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlVehicleAdd = this.authService.GetURL(config_2.ApplicationRouteURL.URL_VEHICLE_ADD);
	        this.urlVehicleUpdate = this.authService.GetURL(config_2.ApplicationRouteURL.URL_VEHICLE_UPDATE);
	        // this.urlVehicleSVGList = this.authService.GetURL(
	        //   ApplicationRouteURL.URL_VEHICLE_SVG_LIST
	        // );
	        this.urlVehicleInfo = this.authService.GetURL(config_2.ApplicationRouteURL.URL_VEHICLE_INFO);
	        this.urlVehicleFutureBookingList = this.authService.GetURL(config_2.ApplicationRouteURL.URL_VEHICLE_FUTURE_BOOKING_LIST);
	        this.activeRoute.params.subscribe(function (params) {
	            var ownerCompanyHashID = params["ownerCompanyHashID"] || "";
	            var sharedVehicleGroupHashId = params["sharedVehicleGroupHashId"] || "";
	            if (ownerCompanyHashID != "")
	                _this.ownerCompanyHashID = ownerCompanyHashID;
	            else
	                _this.ownerCompanyHashID = "";
	            if (sharedVehicleGroupHashId != "")
	                _this.sharedVehicleGroupHashId = sharedVehicleGroupHashId;
	            else
	                _this.sharedVehicleGroupHashId = "";
	            _this.GetVehicleList();
	        });
	        this.addVehicleLink = new config_1.WeGoAuthorizedLink(this.urlVehicleAdd, config_1.Permission.PR_VEHICLES_OVERVIEW, config_1.PermissionType.INSERT, "btn btn-highlight navbar-right", "LblAddNew");
	    };
	    VehicleListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetVehicleList();
	    };
	    VehicleListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetVehicleList();
	    };
	    VehicleListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetVehicleList();
	    };
	    VehicleListComponent.prototype.OnPagingChange = function (event) {
	        console.log(this.DataListModel);
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetVehicleList();
	    };
	    VehicleListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.vehicleService
	            .ExportVehicleList(this.DataListModel, this.ownerCompanyHashID, this.sharedVehicleGroupHashId, null, false, this.chkCleanRequireFilter, this.chkFuelRequireFilter, this.chkDamageFilter)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "Vehicle" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    VehicleListComponent.prototype.GetFilterData = function () {
	        this.DataListModel.currentPage = 1;
	        this.GetVehicleList();
	    };
	    VehicleListComponent.prototype.GetVehicleList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.vehicleService.GetVehicleList();
	        this.vehicleService
	            .GetVehicleList(this.DataListModel, this.ownerCompanyHashID, this.sharedVehicleGroupHashId, null, false, this.chkCleanRequireFilter, this.chkFuelRequireFilter, this.chkDamageFilter)
	            .subscribe(function (res) {
	            _this.vehicleList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    VehicleListComponent.prototype.DeleteVehicle = function (deletedVehicleList) {
	        var _this = this;
	        this.isLoading = true;
	        this.vehicleService.DeleteVehicle(deletedVehicleList).subscribe(function (res) {
	            _this.DataListModel.currentPage = 1;
	            _this.GetVehicleList();
	            _this.popupMsg = _this.translate.instant("LblRecordRemovedSuccess", [
	                _this.module
	            ]);
	            _this.ShowSuccessPopup();
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    VehicleListComponent.prototype.OnParentCheck = function (isChecked) {
	        this.vehicleList
	            .filter(function (x) { return x.isDeletable; })
	            .forEach(function (x) { return (x.isChecked = isChecked); });
	    };
	    VehicleListComponent.prototype.ShowChildModal = function (vehicleMasterHashId) {
	        if (vehicleMasterHashId) {
	            this.popupMsg = this.translate.instant("LblRecordDeleteConfirmation", [
	                this.module
	            ]);
	            this.isMultipleDelete = false;
	            this.deleteVehicleMasterHashId = vehicleMasterHashId;
	        }
	        else {
	            this.popupMsg = this.translate.instant("LblRecordMultiplDeleteConfirmation", [this.module]);
	            this.isMultipleDelete = true;
	        }
	        this.childModal.show();
	    };
	    VehicleListComponent.prototype.HideChildModal = function () {
	        this.deleteVehicleMasterHashId = "";
	        this.childModal.hide();
	    };
	    VehicleListComponent.prototype.SuccessModalClick = function () {
	        var deletedVehicleList;
	        if (this.isMultipleDelete)
	            deletedVehicleList = this.vehicleList
	                .filter(function (x) { return x.isChecked; })
	                .map(function (x) { return x.vehicleMasterHashId; });
	        else
	            deletedVehicleList.push(this.deleteVehicleMasterHashId);
	        this.DeleteVehicle(deletedVehicleList);
	        this.childModal.hide();
	    };
	    VehicleListComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    VehicleListComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    VehicleListComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    VehicleListComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    __decorate([
	        core_1.ViewChild("successPopup"), 
	        __metadata('design:type', Object)
	    ], VehicleListComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild("childModal"), 
	        __metadata('design:type', Object)
	    ], VehicleListComponent.prototype, "childModal", void 0);
	    __decorate([
	        core_1.ViewChild("blockModal"), 
	        __metadata('design:type', Object)
	    ], VehicleListComponent.prototype, "blockModal", void 0);
	    VehicleListComponent = __decorate([
	        core_1.Component({
	            selector: "wego-vehicle",
	            template: __webpack_require__(813),
	            providers: [vehicle_service_1.VehicleService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof vehicle_service_1.VehicleService !== 'undefined' && vehicle_service_1.VehicleService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _d) || Object, (typeof (_e = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _e) || Object])
	    ], VehicleListComponent);
	    return VehicleListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.VehicleListComponent = VehicleListComponent;


/***/ },
/* 813 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ breadCrumbList}} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li class=\"active\"> {{ breadCrumbList}} </li>\r\n\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25 \">\r\n      <!-- <a class=\"btn btn-highlight navbar-right\" [routerLink]=\"[urlVehicleUpdate]\" routerLinkActive=\"active\">{{ 'LblAddNew' | translate }}</a> -->\r\n      <wego-authorized-link [LinkModel]=\"addVehicleLink\"></wego-authorized-link>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <p class=\"text-success\">{{ message }}</p>\r\n        <wego-search-list [IsDeleted]=\"isDeleteAccess\" [IsDeleteEnabled]=\"isAnyChecked\" (OnDeleteAll)=\"ShowChildModal()\" (OnSearch)=\"OnSearch($event)\"\r\n          (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n\r\n        <div class=\"checkbox\">\r\n          <label>\r\n            <input [(ngModel)]=\"chkCleanRequireFilter\" type=\"checkbox\" name=\"chkCleanRequireFilter\" (change)=\"GetFilterData()\">{{ 'LblCleanRequire' | translate }}</label>\r\n          <label>\r\n            <input [(ngModel)]=\"chkFuelRequireFilter\" type=\"checkbox\" name=\"chkFuelRequireFilter\" (change)=\"GetFilterData()\">{{ 'LblFualRequire' | translate }}</label>\r\n          <label>\r\n            <input [(ngModel)]=\"chkDamageFilter\" type=\"checkbox\" name=\"chkDamageFilter\" (change)=\"GetFilterData()\">{{ 'LblDamage' | translate }}</label>\r\n        </div>\r\n\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center parent-checkbox\">\r\n                  <input [disabled]=\"!isDeleteAccess\" type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\">\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('licenceTag')\">\r\n                  {{ 'LblLicenceTag' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'licenceTag'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('ownerName')\">\r\n                  {{ 'LblVehicleOwner' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'ownerName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('brand')\">\r\n                  {{ 'LblBrand' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'brand'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('type')\">\r\n                  {{ 'LblType' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'type'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('vehicleClass')\">\r\n                  {{ 'LblVehicleClass' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'vehicleClass'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('color')\">\r\n                  {{ 'LblColor' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'color'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"text-center cursor-pointer\" (click)=\"OnSort('isCleaningRequire')\">\r\n                  {{ 'LblCleanRequire' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'isCleaningRequire'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"text-center cursor-pointer\" (click)=\"OnSort('isFuelRequire')\">\r\n                  {{ 'LblFualRequire' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'isFuelRequire'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"text-center cursor-pointer\" (click)=\"OnSort('isVehicleDamage')\">\r\n                  {{ 'LblDamage' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'isVehicleDamage'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"text-center\">{{ 'LblInvalidTagUsed' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblNoOfSharedVehicleGroups' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblEdit' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblClone' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblStatus' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblFutureBooking' | translate }}</th>\r\n                <!--<th class=\"text-center\">{{ 'LblDelete' | translate }}</th>-->\r\n                <!--<th class=\"text-center\">{{ 'LblAvailableUnAvailable' | translate }}</th>-->\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let vehicle of vehicleList\">\r\n                  <td class=\"text-center\">\r\n                    <input [disabled]=\"!vehicle.isDeletable\" type=\"checkbox\" name=\"isActive\" [(ngModel)]=\"vehicle.isChecked\">\r\n                  </td>\r\n                  <td>{{vehicle.licenceTag}}</td>\r\n                  <td>{{vehicle.ownerName}}</td>\r\n                  <td>{{vehicle.brand}}</td>\r\n                  <td>{{vehicle.type}}</td>\r\n                  <td>{{vehicle.vehicleClass}}</td>\r\n                  <td>{{vehicle.color}}</td>\r\n                  <td class=\"text-center\">\r\n                    <!--<i class=\"fa fa-exclamation-triangle fa-fw\" [ngClass]=\"{ 'text-success': !vehicle.isCleaningRequire, 'text-danger': vehicle.isCleaningRequire}\" [attr.title]=\"vehicle.isCleaningRequire ? 'Cleaning Require' : 'Cleaning Not Require'\"></i>-->\r\n                    <i class=\"fa fa-fw\" [ngClass]=\"{ 'fa-thumbs-up text-active': !vehicle.isCleaningRequire, 'fa-exclamation-triangle text-exlamation': vehicle.isCleaningRequire}\"\r\n                      [attr.title]=\"vehicle.isCleaningRequire ? LblCleanRequire : LblCleanNotRequire\"></i>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <!--<i class=\"fa fa-tint fa-fw\" [ngClass]=\"{ 'text-success': !vehicle.isFuelRequire, 'text-danger': vehicle.isFuelRequire}\" [attr.title]=\"vehicle.isFuelRequire ? 'Fual Require' : 'Fual Not Require'\"></i>-->\r\n                    <i class=\"fa fa-fw\" [ngClass]=\"{ 'fa-thumbs-up text-active': !vehicle.isFuelRequire, 'fa-exclamation-triangle text-exlamation': vehicle.isFuelRequire}\"\r\n                      [attr.title]=\"vehicle.isFuelRequire ? LblFualRequire : LblFualNotRequire\"></i>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <i class=\"fa  fa-fw\" [ngClass]=\"{ 'fa-thumbs-up text-active': !vehicle.isVehicleDamage, 'fa-exclamation-triangle text-exlamation': vehicle.isVehicleDamage}\"\r\n                      [attr.title]=\"vehicle.isVehicleDamage ? LblVehiclDamaged : LblVehicleNotDamaged\"></i>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <i class=\"fa  fa-fw\" [ngClass]=\"{ 'fa-thumbs-up text-active': !vehicle.invalidTagUsed, 'fa-exclamation-triangle text-exlamation': vehicle.invalidTagUsed}\"\r\n                      [attr.title]=\"vehicle.invalidTagUsed ? LblInvalidTagUsed : LblNotInvalidTagUsed\"></i>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"!vehicle.isViewSVGAccess\" class=\"btn btn-primary cursor-pointer link-style\" disabled>\r\n                      <span class=\"badge link-text\">{{ vehicle.totalSharedVehicleGroup }}</span>\r\n                    </a>\r\n                    <a *ngIf=\"vehicle.isViewSVGAccess\" class=\"btn btn-primary cursor-pointer link-style\" [routerLink]=\"[urlSharedVehicleGroupList, { vehicleHashId : vehicle.vehicleMasterHashId }]\">\r\n                      <span class=\"badge link-text\">{{ vehicle.totalSharedVehicleGroup }}</span>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"vehicle.isEditable\" class=\"cursor-pointer\" [routerLink]=\"urlVehicleUpdate +'/'+ vehicle.vehicleMasterHashId \">\r\n                      <i class=\"fa fa-pencil-square-o fa-fw\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"vehicle.isAddNewAccess\" class=\"cursor-pointer\" title=\"{{'LblClone' | translate}}\" [routerLink]=\"urlVehicleUpdate+'/' + vehicle.vehicleMasterHashId +'/'+ true\">\r\n                      <i class=\"fa fa-clone fa-fw\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a class=\"cursor-pointer\" title=\"{{'LblStatus' | translate}}\" [routerLink]=\"urlVehicleInfo+'/'+ vehicle.vehicleMasterHashId\">\r\n                      <i class=\"fa fa-eye fa-fw\"></i>\r\n                    </a>\r\n                  </td>\r\n\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"vehicle.isViewBookingAccess\" class=\"cursor-pointer\" title=\"{{'LblFutureBooking' | translate}}\" [routerLink]=\"[urlVehicleFutureBookingList, { vehicleHashId : vehicle.vehicleMasterHashId }]\">\r\n                      <i class=\"fa fa-calendar fa-fw\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <!--<td class=\"text-center\">\r\n                  <a class=\"cursor-pointer\" (click)=\"ShowChildModal(vehicle.vehicleMasterHashId)\">\r\n                    <i class=\"fa fa-trash-o fa-fw text-danger\"></i>\r\n                  </a>\r\n                </td>-->\r\n                  <!--<td class=\"text-center\">\r\n                  <a *ngIf=\"!vehicle.available\" class=\"cursor-pointer\" (click)=\"ShowBlockModal(vehicle.vehicleMasterHashId,'UnBlock','1')\"><i class=\"fa fa-ban fa-fw text-danger\"></i></a>\r\n                  <a *ngIf=\"vehicle.available\" class=\"cursor-pointer\" (click)=\"ShowBlockModal(vehicle.vehicleMasterHashId,'Block','0')\"><i class=\"fa fa-ban fa-fw text-success\"></i></a>\r\n                </td>-->\r\n                  <!--<td class=\"text-center\">\r\n                      <template [ngIf]=\"!vehicle.available\"> {{ 'LblUnAvailable' | translate}} </template>\r\n              <template [ngIf]=\"vehicle.available\"> {{ 'LblAvailable' | translate}} </template>\r\n              </td>-->\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"15\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n<div [hidden]=\"!isLoading\" class=\"my-loading\">\r\n  <div class=\"dimmer\"></div>\r\n  <div class=\"loading-bg\">\r\n    <i class=\"fa fa-refresh fa-spin fa-3x fa-fw\"></i>\r\n  </div>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<wego-confirm-popup #childModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessModalClick()\" (onReject)=\"HideChildModal()\"></wego-confirm-popup>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>";

/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var vehicle_model_1 = __webpack_require__(553);
	var http_1 = __webpack_require__(59);
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var vehicle_service_1 = __webpack_require__(530);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var common_1 = __webpack_require__(22);
	var VtsVehicleUpdateComponent = (function () {
	    function VtsVehicleUpdateComponent(vehicleService, activeRoute, authService, translate, router, http, locationService) {
	        this.vehicleService = vehicleService;
	        this.activeRoute = activeRoute;
	        this.authService = authService;
	        this.translate = translate;
	        this.router = router;
	        this.http = http;
	        this.locationService = locationService;
	        this.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
	        this.submitted = false;
	        this.fileListQuer = [];
	    }
	    VtsVehicleUpdateComponent.prototype.OnLicencePlatChange = function (newValue) {
	        var ltag;
	        ltag = this.formatLicenceTag(newValue);
	        console.log(newValue, this.model.licenceTag);
	        this.model.licenceTag = ltag;
	    };
	    VtsVehicleUpdateComponent.prototype.OnPhoneNumberChange = function (newValue) {
	        var regex = new RegExp("^[+]((?!(0))[0-9]{0,15})$");
	        if (!regex.test(newValue)) {
	            this.message = this.translate.instant('ValidatePhoneNumberVts');
	            return false;
	        }
	        this.message = '';
	    };
	    VtsVehicleUpdateComponent.prototype.eventHandler = function (event) {
	        console.log(event, event.keyCode, event.keyIdentifier);
	        var regex = new RegExp("^[0-9a-zA-Z \b]+$");
	        var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
	        if (!regex.test(key)) {
	            event.preventDefault();
	            return false;
	        }
	    };
	    VtsVehicleUpdateComponent.prototype.ngOnInit = function () {
	        this.module = this.translate.instant('LblVtsVehicle');
	        this.obuTypeList = [
	            {
	                Key: this.translate.instant('LblSelectObuType'),
	                Value: '' // Value is send to api
	            },
	            {
	                Key: 'Invers',
	                Value: 'Invers'
	            },
	            {
	                Key: 'BMW',
	                Value: 'Bmw'
	            },
	            {
	                Key: 'AXA',
	                Value: 'Axa'
	            }, {
	                Key: 'Teltonika',
	                Value: 'Teltonika'
	            }];
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlVehicleList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_VTSVEHICLE_LIST);
	        this.model = new vehicle_model_1.VTSVehicleModel();
	        this.model.obuType = this.obuTypeList[0].Value;
	        this.GetVehicleDetails();
	    };
	    VtsVehicleUpdateComponent.prototype.onSubmit = function (forms) {
	        var _this = this;
	        this.isLoading = true;
	        this.vehicleService.AddNewVtsVehicle(this.model)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.isEditMode ? _this.translate.instant('LblRecordUpdatedSuccess', [_this.module]) : _this.translate.instant('LblRecordAddedSuccess', [_this.module]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    VtsVehicleUpdateComponent.prototype.formatLicenceTag = function (newVal) {
	        var outputString = '';
	        var chars = newVal.replace(/-/g, '').split('');
	        if (!(chars.length > 0))
	            return outputString;
	        if (chars.length == 1)
	            return chars[0];
	        for (var i = 1; i < chars.length; i++) {
	            outputString += chars[i - 1];
	            if (chars[i - 1] == "-" || chars[i] == "-") {
	                continue;
	            }
	            if (isNaN(chars[i - 1]) != isNaN(chars[i])) {
	                outputString += "-";
	            }
	            if (i == chars.length - 1) {
	                outputString += chars[i];
	            }
	        }
	        console.log(outputString);
	        return outputString;
	    };
	    VtsVehicleUpdateComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    VtsVehicleUpdateComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    VtsVehicleUpdateComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    VtsVehicleUpdateComponent.prototype.OnBackClick = function () {
	        this.locationService.back();
	    };
	    VtsVehicleUpdateComponent.prototype.GetVehicleDetails = function () {
	        var _this = this;
	        this.sub = this.activeRoute
	            .params
	            .subscribe(function (params) {
	            _this.vehicleMasterHashId = params['id'] || '';
	            if (_this.vehicleMasterHashId != '') {
	                _this.isEditMode = true;
	                _this.isLoading = true;
	                _this.vehicleService.GetVtsVehicleByHashId(_this.vehicleMasterHashId)
	                    .subscribe(function (res) {
	                    _this.model = res.data;
	                    _this.isLoading = false;
	                }, function (error) {
	                    _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	                    _this.isLoading = false;
	                });
	            }
	        });
	        this.breadCrumbTitle = this.isEditMode ? this.translate.instant('LblEditPage', [this.module]) : this.translate.instant('LblAddPage', [this.module]);
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	    };
	    VtsVehicleUpdateComponent.prototype.ngOnDestroy = function () {
	        if (this.sub) {
	            this.sub.unsubscribe();
	        }
	    };
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], VtsVehicleUpdateComponent.prototype, "successPopup", void 0);
	    VtsVehicleUpdateComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-vtsvehicle-update',
	            template: __webpack_require__(815),
	            providers: [vehicle_service_1.VehicleService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof vehicle_service_1.VehicleService !== 'undefined' && vehicle_service_1.VehicleService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object, (typeof (_e = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _e) || Object, (typeof (_f = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _f) || Object, (typeof (_g = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _g) || Object])
	    ], VtsVehicleUpdateComponent);
	    return VtsVehicleUpdateComponent;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.VtsVehicleUpdateComponent = VtsVehicleUpdateComponent;


/***/ },
/* 815 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{breadCrumbTitle}}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li><a [routerLink]=\"urlDefaultPage\"><i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a></li>\r\n        <li><a [routerLink]=\"urlVehicleList\"><i class=\"fa fa-cab\"></i>{{breadCrumbList}}</a></li>\r\n        <li class=\"active\">{{breadCrumbTitle}}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25 \">\r\n    </div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"nopad\">\r\n      <form (ngSubmit)=\"onSubmit(AddVtsVehicleForm.value)\" #AddVtsVehicleForm=\"ngForm\">\r\n        <input type=\"hidden\" class=\"form-control\" [(ngModel)]=\"model.vehicleMasterHashId\" name=\"vehicleMasterHashId\">\r\n        <div class=\"form-group col-md-12\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'ExtraMsg' }}</span>\r\n        </div>\r\n\r\n        <div class=\"form-group col-md-4\">\r\n          <label><span class=\"text text-danger\">*</span>{{ 'LblObuType' | translate }}</label>\r\n          <select [disabled]=\"isEditMode\" [(ngModel)]=\"model.obuType\" class=\"form-control\" name=\"obuType\">\r\n               <option *ngFor=\"let item of obuTypeList\" [ngValue]=\"item.Value\">{{ item.Key }}</option>\r\n          </select>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'ObuType' }}</span>\r\n        </div>\r\n        <div class=\"clearfix\">\r\n        </div>\r\n        <div class=\"form-group col-md-4\">\r\n          <label><span class=\"text text-danger\">*</span>{{ 'LblLicenceTag' | translate }}</label>\r\n          <!--<input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblLicenceTag' | translate }}\" [ngModel]=\"model.licenceTag\" name=\"LicenceTag\" maxlength=\"8\" (ngModelChange)=\"OnLicencePlatChange($event)\" (keypress)=\"eventHandler($event)\">-->\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblLicenceTag' | translate }}\" [(ngModel)]=\"model.licenceTag\" name=\"LicenceTag\" maxlength=\"15\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'LicenceTag' }}</span>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <template [ngIf]=\"model.obuType=='Renault' || model.obuType.toLowerCase() == 'bmw'\">\r\n          <div class=\"form-group col-md-4\">\r\n            <label><span class=\"text text-danger\">*</span>{{ 'LblFleetId' | translate }}</label>\r\n            <input [disabled]=\"isEditMode\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblFleetId' | translate }}\" [(ngModel)]=\"model.fleetId\" name=\"fleetId\" maxlength=\"50\">\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'FleetId' }}</span>\r\n          </div>\r\n\r\n          <div class=\"form-group col-md-4\">\r\n            <label><span class=\"text text-danger\">*</span>{{ 'LblContractId' | translate }}</label>\r\n            <input [disabled]=\"isEditMode\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblContractId' | translate }}\" [(ngModel)]=\"model.contractId\" name=\"contractId\" maxlength=\"50\">\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'ContractId' }}</span>\r\n          </div>\r\n\r\n          <div class=\"form-group col-md-4\">\r\n            <label><span class=\"text text-danger\">*</span>{{ 'LblVIN' | translate }}</label>\r\n            <input [disabled]=\"isEditMode\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblVIN' | translate }}\" [(ngModel)]=\"model.vin\" name=\"vin\" maxlength=\"17\">\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'VIN' }}</span>\r\n          </div>\r\n        </template>\r\n        <div class=\"clearfix\"></div>\r\n        <template [ngIf]=\"model.obuType.toLowerCase() == 'teltonika'\">\r\n           <div class=\"form-group col-md-4\">\r\n            <label><span class=\"text text-danger\">*</span>{{ 'LblPhoneNumber' | translate }}</label>\r\n            <input [disabled]=\"isEditMode && !model.isEditable\"  type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblPhoneNumber' | translate }}\" [(ngModel)]=\"model.phoneNumber\" name=\"phoneNumber\" maxlength=\"16\" (ngModelChange)=\"OnPhoneNumberChange($event)\">\r\n            <span class=\"text text-danger\">{{ message }}</span>\r\n          </div>\r\n        </template>\r\n\r\n        <template [ngIf]=\"model.obuType.toLowerCase() == 'invers' || model.obuType.toLowerCase() == 'axa' || model.obuType.toLowerCase() == 'teltonika'\">\r\n          <div class=\"form-group col-md-4\">\r\n            <label><span class=\"text text-danger\">*</span>{{ 'LblDeviceId' | translate }}</label>\r\n            <input [disabled]=\"isEditMode && !model.isEditable\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblDeviceId' | translate }}\" [(ngModel)]=\"model.deviceId\" name=\"deviceId\" maxlength=\"50\">\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'deviceId' }}</span>\r\n          </div>\r\n        </template>\r\n\r\n        <template [ngIf]=\"model.obuType.toLowerCase() =='axa'\">\r\n          <div class=\"form-group col-md-4\">\r\n            <label><span class=\"text text-danger\">*</span>{{ 'LblClaimCode' | translate }}</label>\r\n            <input [disabled]=\"isEditMode && !model.isEditable\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblClaimCode' | translate }}\" [(ngModel)]=\"model.claimCode\" name=\"claimCode\" maxlength=\"50\">\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'claimCode' }}</span>\r\n          </div>\r\n        </template>\r\n\r\n        <div class=\"row no-margin\">\r\n          <div class=\"col-sm-12\">\r\n            <hr>\r\n            <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnBackClick()\">{{ 'LblCancel' | translate }}</a> &nbsp;&nbsp;\r\n            <button class=\"btn btn-green\" type=\"submit\">{{ 'LblSave' | translate }}</button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </section>\r\n</div>\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n";

/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var config_1 = __webpack_require__(60);
	var core_1 = __webpack_require__(3);
	var vehicle_model_1 = __webpack_require__(553);
	var vehicle_service_1 = __webpack_require__(530);
	var router_1 = __webpack_require__(26);
	var config_2 = __webpack_require__(60);
	var VtsVehicleListComponent = (function () {
	    //urlVehicleSVGList: string;
	    function VtsVehicleListComponent(vehicleService, activeRoute, router, authService, translate) {
	        this.vehicleService = vehicleService;
	        this.activeRoute = activeRoute;
	        this.router = router;
	        this.authService = authService;
	        this.translate = translate;
	        this.ownerCompanyHashID = "";
	        this.sharedVehicleGroupHashId = "";
	    }
	    VtsVehicleListComponent.prototype.ngOnInit = function () {
	        this.module = this.translate.instant('LblVtsVehicle');
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.model = new vehicle_model_1.VehicleBlockModel();
	        //this.DataListModel.searchField = ["fleetId", "contractId", "vin", "licenceTag", "brand", "type", "color"];
	        this.DataListModel.searchField = ["obuType", "vin", "deviceId", "licenceTag"];
	        this.urlDefaultPage = this.authService.GetURL(config_2.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlVehicleUpdate = this.authService.GetURL(config_2.ApplicationRouteURL.URL_VTSVEHICLE_UPDATE);
	        this.urlVTSVehicleAdd = this.authService.GetURL(config_2.ApplicationRouteURL.URL_VTSVEHICLE_ADD);
	        this.GetVehicleList();
	        this.addVTSVehicleLink = new config_1.WeGoAuthorizedLink(this.urlVTSVehicleAdd, config_1.Permission.PR_VTS_VEHICLE_LIST, config_1.PermissionType.INSERT, 'btn btn-highlight navbar-right', 'LblAddNew');
	    };
	    VtsVehicleListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetVehicleList();
	    };
	    VtsVehicleListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetVehicleList();
	    };
	    VtsVehicleListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetVehicleList();
	    };
	    ;
	    VtsVehicleListComponent.prototype.OnPagingChange = function (event) {
	        console.log(this.DataListModel);
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetVehicleList();
	    };
	    VtsVehicleListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.vehicleService.ExportVTSVehicleList(this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "VTS_Vehicle" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    VtsVehicleListComponent.prototype.GetVehicleList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.vehicleService.GetAllVtsVehicleList(this.DataListModel)
	            .subscribe(function (res) {
	            _this.vehicleList = res.data;
	            _this.vehicleList.forEach(function (v) {
	                if (v.obuType.toLowerCase() === 'teltonika') {
	                    v.link = config_2.WeGoConfig.TELTONIKA_CONFIG_BASE_URL + "?access_token=" + _this.authService.accessToken();
	                }
	                else if (v.obuType.toLowerCase() === 'invers') {
	                    v.link = config_2.WeGoConfig.INVERS_CONFIG_BASE_URL + v.deviceId;
	                }
	            });
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    VtsVehicleListComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], VtsVehicleListComponent.prototype, "successPopup", void 0);
	    VtsVehicleListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-vehicle',
	            template: __webpack_require__(817),
	            providers: [vehicle_service_1.VehicleService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof vehicle_service_1.VehicleService !== 'undefined' && vehicle_service_1.VehicleService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _d) || Object, (typeof (_e = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _e) || Object])
	    ], VtsVehicleListComponent);
	    return VtsVehicleListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.VtsVehicleListComponent = VtsVehicleListComponent;


/***/ },
/* 817 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ breadCrumbList}} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li class=\"active\"> {{ breadCrumbList}} </li>\r\n\r\n      </ol>\r\n    </div>\r\n    <!-- <div class=\"col-md-3 col-sm-6 mar_t_25 \">\r\n      <a class=\"btn btn-highlight navbar-right\" [routerLink]=\"[urlVehicleUpdate]\" routerLinkActive=\"active\">{{ 'LblAddNew' | translate }}</a>\r\n    </div> -->\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25\">\r\n      <wego-authorized-link [LinkModel]=\"addVTSVehicleLink\"></wego-authorized-link>\r\n      <!-- <a class=\"btn btn-highlight navbar-right\" [routerLink]=\"[urlOrganizationUpdate]\" routerLinkActive=\"active\">{{ 'LblAddNew' | translate }}</a> -->\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <wego-search-list (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\"\r\n          [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <!--<th class=\"cursor-pointer\" (click)=\"OnSort('fleetId')\">\r\n                  {{ 'LblFleetId' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'fleetId'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('contractId')\">\r\n                  {{ 'LblContractId' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'contractId'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>-->\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('obuType')\">\r\n                  {{ 'LblObuType' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'obuType'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('deviceId')\">\r\n                  {{ 'LblDeviceId' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'deviceId'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('vin')\">\r\n                  {{ 'LblVIN' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'vin'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('licenceTag')\">\r\n                  {{ 'LblLicenceTag' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'licenceTag'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <!-- <th class=\"cursor-pointer\" (click)=\"OnSort('brand')\">\r\n                  {{ 'LblBrand' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'brand'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('type')\">\r\n                  {{ 'LblType' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'type'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('color')\">\r\n                  {{ 'LblColor' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'color'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th> -->\r\n                <th class=\"text-center\">{{ 'LblEdit' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblInfo' | translate }}</th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let vehicle of vehicleList\">\r\n                  <!--<td>{{vehicle.fleetId}}</td>\r\n                  <td>{{vehicle.contractId}}</td>-->\r\n                  <td>{{vehicle.obuType}}</td>\r\n                  <td>{{vehicle.deviceId}}</td>\r\n                  <td>{{vehicle.vin}}</td>\r\n                  <td>{{vehicle.licenceTag}}</td>\r\n                  <!-- <td>{{vehicle.brand}}</td>\r\n                  <td>{{vehicle.type}}</td>\r\n                  <td>{{vehicle.color}}</td> -->\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"vehicle.isEditable\" class=\"cursor-pointer\" [routerLink]=\"urlVehicleUpdate+'/'+vehicle.vehicleMasterHashId\">\r\n                      <i class=\"fa fa-pencil-square-o fa-fw\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"vehicle.link\" class=\"cursor-pointer\" [href]=\"vehicle.link\" target=\"_blank\" rel=\"noopener noreferrer\">\r\n                      <i class=\"fa fa-external-link fa-fw\" aria-hidden=\"true\"></i>\r\n                    </a>\r\n                  </td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"8\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n<div [hidden]=\"!isLoading\" class=\"my-loading\">\r\n  <div class=\"dimmer\"></div>\r\n  <div class=\"loading-bg\">\r\n    <i class=\"fa fa-refresh fa-spin fa-3x fa-fw\"></i>\r\n  </div>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>";

/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var companyAdmin_service_1 = __webpack_require__(819);
	var companyAdmin_model_1 = __webpack_require__(820);
	var company_service_1 = __webpack_require__(501);
	var AddCompanyAdminPopupComponent = (function () {
	    function AddCompanyAdminPopupComponent(companyAdminService, companyService, authService, router, translate) {
	        this.companyAdminService = companyAdminService;
	        this.companyService = companyService;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.onSuccessSelect = new core_1.EventEmitter();
	    }
	    AddCompanyAdminPopupComponent.prototype.ngOnInit = function () {
	        this.module = this.translate.instant('LblCompanyAdmin');
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.searchField = ["userName", "firstName", "lastName"];
	        this.urlPersonUpdate = this.authService.GetURL(config_1.ApplicationRouteURL.URL_PERSON_UPDATE);
	        this.breadCrumbTitle = this.translate.instant('LblAddPage', [this.module]);
	    };
	    AddCompanyAdminPopupComponent.prototype.ngOnChanges = function (change) {
	        console.log(change);
	    };
	    AddCompanyAdminPopupComponent.prototype.show = function () {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.sortType = "";
	        this.DataListModel.sortReverse = null;
	        this.DataListModel.searchTerm = "";
	        this.DataListModel.infoMessage = "";
	        this.GetCompanyAdminPersonList();
	        this.companyAdminModal.show();
	    };
	    AddCompanyAdminPopupComponent.prototype.hide = function () {
	        this.companyAdminModal.hide();
	    };
	    AddCompanyAdminPopupComponent.prototype.GetCompanyAdminPersonList = function () {
	        var _this = this;
	        this.isLoading = true;
	        console.log(this.companyMasterHashId);
	        this.companyService.GetPersonListByCompanyId(this.companyMasterHashId, this.DataListModel)
	            .subscribe(function (res) {
	            _this.personList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AddCompanyAdminPopupComponent.prototype.select = function (personMasterHashId) {
	        var _this = this;
	        this.isLoading = true;
	        var model = new companyAdmin_model_1.CompanyAdminModel();
	        model.personHashID = personMasterHashId;
	        model.companyMasterHashId = this.companyMasterHashId;
	        this.companyAdminService.AddNewCompanyAdmin(model)
	            .subscribe(function (res) {
	            _this.popupMsg = _this.translate.instant('LblRecordAddedSuccess', [_this.module]);
	            ;
	            _this.OnSuccessSelect();
	            _this.isLoading = false;
	            _this.ShowSuccessPopup();
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        }, function () {
	            _this.companyAdminModal.hide();
	            _this.isLoading = false;
	        });
	    };
	    AddCompanyAdminPopupComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetCompanyAdminPersonList();
	    };
	    AddCompanyAdminPopupComponent.prototype.OnSearch = function (event) {
	        this.DataListModel.searchTerm = event.searchTerm;
	        this.DataListModel.currentPage = 1;
	        this.GetCompanyAdminPersonList();
	    };
	    AddCompanyAdminPopupComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetCompanyAdminPersonList();
	    };
	    ;
	    AddCompanyAdminPopupComponent.prototype.OnPagingChange = function (event) {
	        console.log(this.DataListModel);
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetCompanyAdminPersonList();
	    };
	    AddCompanyAdminPopupComponent.prototype.OnSuccessSelect = function () {
	        this.onSuccessSelect.emit({ SuccessMessage: this.message });
	    };
	    AddCompanyAdminPopupComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    AddCompanyAdminPopupComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    AddCompanyAdminPopupComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    __decorate([
	        core_1.Output('OnSuccessSelect'), 
	        __metadata('design:type', Object)
	    ], AddCompanyAdminPopupComponent.prototype, "onSuccessSelect", void 0);
	    __decorate([
	        core_1.ViewChild('companyAdminModal'), 
	        __metadata('design:type', Object)
	    ], AddCompanyAdminPopupComponent.prototype, "companyAdminModal", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], AddCompanyAdminPopupComponent.prototype, "successPopup", void 0);
	    AddCompanyAdminPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-add-company-admin',
	            template: __webpack_require__(821),
	            styles: [".my-loading {\n      position: absolute;\n      top: 0;\n      left: 0;\n      bottom: 0%;\n      right: 0%;\n      text-align: center;\n      z-index: 9999;\n    }\n    \n    .my-loading .dimmer {\n      position: absolute;\n      top: 0;\n      left: 0;\n      background-color: #000;\n      opacity: 0.5;\n      width: 100%;\n      height: 100%;\n    }\n    \n    .my-loading .loading-bg {\n      position: absolute;\n      display: inline-block;\n      top: 50%;\n      left: -webkit-calc(50% - 40px);\n      left: -moz-calc(50% - 40px);\n      left: calc(50% - 40px);\n      transform: translateY(-50%);\n      padding: 22px;\n      background-color: #fff;\n      border-radius: 15px;\n      text-align: center;\n    }"]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof companyAdmin_service_1.CompanyAdminService !== 'undefined' && companyAdmin_service_1.CompanyAdminService) === 'function' && _a) || Object, (typeof (_b = typeof company_service_1.CompanyService !== 'undefined' && company_service_1.CompanyService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _e) || Object])
	    ], AddCompanyAdminPopupComponent);
	    return AddCompanyAdminPopupComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.AddCompanyAdminPopupComponent = AddCompanyAdminPopupComponent;


/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var CompanyAdminService = (function () {
	    function CompanyAdminService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    CompanyAdminService.prototype.GetCompanyAdminList = function (companyMasterHashID, input) {
	        var getComapanyAdminUrl = config_1.WeGoConfig.API_GET_COMPANY_ADMIN_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getComapanyAdminUrl = getComapanyAdminUrl + "?" + queryString + "&companyHashID=" + companyMasterHashID;
	        }
	        else {
	            getComapanyAdminUrl = getComapanyAdminUrl + "?companyHashID=" + companyMasterHashID;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getComapanyAdminUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CompanyAdminService.prototype.ExportCompanyAdminList = function (companyMasterHashID, input) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var getCompanyAdminUrl = config_1.WeGoConfig.API_EXPORT_COMPANY_ADMIN_LIST + "?" + queryString + "&companyHashID=" + companyMasterHashID;
	        var headers = this.authService.GetHeader('text/csv');
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getCompanyAdminUrl, options);
	    };
	    CompanyAdminService.prototype.GetPersonListByCompanyId = function (pageNo, searchField, searchTerm, companyMasterHashId) {
	        var getPersonUrl = config_1.WeGoConfig.API_GET_PERSON_LIST_BY_COMPANY_ID + "?pageNo=" + pageNo + "&record=" + config_1.WeGoConfig.GRID_MAX_DATA_SIZE + "&searchField=" + searchField + "&searchTerm=" + searchTerm + "&companyMasterHashId=" + companyMasterHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getPersonUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CompanyAdminService.prototype.AddNewCompanyAdmin = function (companyAdminModel) {
	        var body = companyAdminModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_POST_COMPANY_ADMIN_DETAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CompanyAdminService.prototype.DeleteCompanyAdmin = function (selectedCompanyAdminList) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_POST_DELETE_COMPANY_ADMIN, selectedCompanyAdminList, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CompanyAdminService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], CompanyAdminService);
	    return CompanyAdminService;
	    var _a, _b;
	}());
	exports.CompanyAdminService = CompanyAdminService;


/***/ },
/* 820 */
/***/ function(module, exports) {

	"use strict";
	var CompanyAdminModel = (function () {
	    function CompanyAdminModel() {
	    }
	    return CompanyAdminModel;
	}());
	exports.CompanyAdminModel = CompanyAdminModel;


/***/ },
/* 821 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #companyAdminModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n                    <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ breadCrumbTitle }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <wego-search-list [IsExported]=\"false\" [SearchTerm]=\"DataListModel.searchTerm\" (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center\">\r\n                  {{ 'LblSelect' | translate }}\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('firstName')\">\r\n                  {{ 'LblFirstName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'firstName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('lastName')\">\r\n                  {{ 'LblLastName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'lastName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('userName')\">\r\n                  {{ 'LblUserName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'userName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let person of personList\">\r\n                  <td class=\"text-center\">\r\n                    <a class=\"cursor-pointer\" (click)=\"select(person.personMasterHashId)\">\r\n                      <i class=\"fa fa-plus-square\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td>{{ person.firstName }}</td>\r\n                  <td>{{ person.lastName }} </td>\r\n                  <td>{{ person.userName }}</td>               \r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0\">\r\n                <td class=\"text-center text-danger\" colspan=\"4\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\" [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\"\r\n                firstText=\"&laquo;\" lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>";

/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var companyAdmin_service_1 = __webpack_require__(819);
	var person_service_1 = __webpack_require__(771);
	var company_service_1 = __webpack_require__(501);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var CompanyAdminListComponent = (function () {
	    function CompanyAdminListComponent(companyAdminService, personService, companyService, activeRoute, authService, router, translate) {
	        this.companyAdminService = companyAdminService;
	        this.personService = personService;
	        this.companyService = companyService;
	        this.activeRoute = activeRoute;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	    }
	    Object.defineProperty(CompanyAdminListComponent.prototype, "isAnyChecked", {
	        get: function () {
	            if (this.companyAdminList) {
	                var isCheck = this.companyAdminList.filter(function (x) { return x.isUserCompanyAdmin == false; }).some(function (x) { return x.isChecked == true; });
	                if (isCheck) {
	                    if (this.companyAdminList.filter(function (x) { return x.isUserCompanyAdmin == false; }).every(function (x) { return x.isChecked == true; }))
	                        this.isParentCheck = true;
	                    else
	                        this.isParentCheck = false;
	                }
	                else {
	                    this.isParentCheck = false;
	                }
	                return isCheck;
	            }
	            else {
	                this.isParentCheck = false;
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    CompanyAdminListComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.module = this.translate.instant('LblCompanyAdmin');
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	        this.companyList = this.translate.instant('LblListPage', [this.translate.instant('LblCompany')]);
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = ["userName", "firstName", "lastName"];
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlCompanyList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_COMPANY_LIST);
	        this.sub = this.activeRoute
	            .params
	            .subscribe(function (params) {
	            _this.companyMasterHashId = params['companyHashId'] || '';
	            if (_this.companyMasterHashId != '') {
	                _this.GetCompanyAdminList();
	                _this.GetCompanyDetailsByCompanyId(_this.companyMasterHashId);
	            }
	        });
	    };
	    CompanyAdminListComponent.prototype.GetCompanyDetailsByCompanyId = function (companyMasterHashId) {
	        var _this = this;
	        this.companyService.GetCompanyBasicDetail(companyMasterHashId)
	            .subscribe(function (res) {
	            _this.companyName = res.data.entityName;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    CompanyAdminListComponent.prototype.GetCompanyAdminList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.companyAdminService.GetCompanyAdminList(this.companyMasterHashId, this.DataListModel)
	            .subscribe(function (res) {
	            _this.companyAdminList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    CompanyAdminListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetCompanyAdminList();
	    };
	    CompanyAdminListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetCompanyAdminList();
	    };
	    CompanyAdminListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetCompanyAdminList();
	    };
	    ;
	    CompanyAdminListComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetCompanyAdminList();
	    };
	    CompanyAdminListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.companyAdminService.ExportCompanyAdminList(this.companyMasterHashId, this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "CompanyAdmin" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	        ;
	    };
	    CompanyAdminListComponent.prototype.DeleteCompanyAdmin = function (deleteCompanyAdminList) {
	        var _this = this;
	        this.isLoading = true;
	        this.companyAdminService.DeleteCompanyAdmin(deleteCompanyAdminList)
	            .subscribe(function (res) {
	            _this.DataListModel.currentPage = 1;
	            _this.GetCompanyAdminList();
	            _this.popupMsg = _this.translate.instant('LblRecordRemovedSuccess', [_this.module]);
	            _this.ShowSuccessPopup();
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    CompanyAdminListComponent.prototype.OnParentCheck = function (isChecked) {
	        this.companyAdminList.filter(function (x) { return x.isUserCompanyAdmin == false; }).forEach(function (x) { return x.isChecked = isChecked; });
	    };
	    CompanyAdminListComponent.prototype.ShowAlertModal = function (deleteCompanyAdminMasterHashId) {
	        if (deleteCompanyAdminMasterHashId) {
	            this.deleteMessage = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
	            this.isMultipleDelete = false;
	            this.deleteCompanyAdminMasterHashId = deleteCompanyAdminMasterHashId;
	        }
	        else {
	            this.deleteMessage = this.translate.instant('LblRecordMultiplDeleteConfirmation', [this.module]);
	            this.isMultipleDelete = true;
	        }
	        this.alertModal.show();
	    };
	    CompanyAdminListComponent.prototype.HideAlertModal = function () {
	        this.deleteCompanyAdminMasterHashId = "";
	        this.alertModal.hide();
	    };
	    CompanyAdminListComponent.prototype.SuccessAlertModalClick = function () {
	        var deleteCompanyAdminList;
	        if (this.isMultipleDelete)
	            deleteCompanyAdminList = this.companyAdminList.filter(function (x) { return x.isChecked; }).map(function (x) { return x.companyAdminHashId; });
	        else
	            deleteCompanyAdminList.push(this.deleteCompanyAdminMasterHashId);
	        this.DeleteCompanyAdmin(deleteCompanyAdminList);
	        this.alertModal.hide();
	    };
	    // Add company admin popup
	    CompanyAdminListComponent.prototype.ShowAddCompanyAdminModal = function () {
	        this.addCompanyAdminModal.companyMasterHashId = this.companyMasterHashId;
	        this.addCompanyAdminModal.show();
	    };
	    CompanyAdminListComponent.prototype.SuccessAddCompanyAdminModal = function ($event) {
	        this.GetCompanyAdminList();
	        this.message = $event.SuccessMessage;
	    };
	    //Reset company admin password
	    CompanyAdminListComponent.prototype.ResetPersonPassword = function (personHashID) {
	        var _this = this;
	        this.personService.ResetPersonPassword(personHashID)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblResetPasswordSuccess');
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblResetPasswordFailure');
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    CompanyAdminListComponent.prototype.ShowResetPasswordModal = function (personHashID) {
	        this.resetPasswordPersonHashId = personHashID;
	        this.popupMsg = this.translate.instant('LblResetPasswordConfirmation');
	        this.resetPasswordModal.show();
	    };
	    CompanyAdminListComponent.prototype.HideResetPasswordModal = function () {
	        this.resetPasswordPersonHashId = "";
	        this.resetPasswordModal.hide();
	    };
	    CompanyAdminListComponent.prototype.InActiveCompanyAdmin = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.companyService.InActiveCompanyAdmin(this.blockUnblockCompanyAdminHashId)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.inActiveModal.hide();
	                _this.DataListModel.currentPage = 1;
	                _this.GetCompanyAdminList();
	                _this.popupMsg = _this.translate.instant('LblRecordBlokUnBlockSuccess', [_this.module, _this.blockMsg]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.isLoading = false;
	                _this.popupMsg = res.error;
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    CompanyAdminListComponent.prototype.ShowInActiveModal = function (companyAdminHashId, isActive) {
	        this.blockUnblockCompanyAdminHashId = companyAdminHashId;
	        this.blockMsg = isActive ? this.translate.instant('LblInactive') : this.translate.instant('LblActive');
	        var roleType = this.translate.instant('LblCompanyAdmin');
	        this.blockUnblockMsg = this.translate.instant('LblBlockUnblockConfirm', [this.blockMsg, roleType]);
	        this.inActiveModal.show();
	    };
	    CompanyAdminListComponent.prototype.HideInActiveModal = function () {
	        this.inActiveModal.hide();
	    };
	    CompanyAdminListComponent.prototype.SuccessInActiveModalClick = function () {
	        this.InActiveCompanyAdmin();
	        this.inActiveModal.hide();
	    };
	    CompanyAdminListComponent.prototype.SuccessResetPasswordModalClick = function () {
	        this.resetPasswordModal.hide();
	        console.log(this.resetPasswordPersonHashId);
	        this.ResetPersonPassword(this.resetPasswordPersonHashId);
	    };
	    CompanyAdminListComponent.prototype.ResendActivationMail = function (personHashID) {
	        var _this = this;
	        this.resetPasswordPersonHashId = personHashID;
	        this.personService.ReSendActivationMail(personHashID)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblResendActivationMailSuccess');
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblResendActivationMailFailure');
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    CompanyAdminListComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    CompanyAdminListComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    CompanyAdminListComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    __decorate([
	        core_1.ViewChild('alertModal'), 
	        __metadata('design:type', Object)
	    ], CompanyAdminListComponent.prototype, "alertModal", void 0);
	    __decorate([
	        core_1.ViewChild('addCompanyAdminModal'), 
	        __metadata('design:type', Object)
	    ], CompanyAdminListComponent.prototype, "addCompanyAdminModal", void 0);
	    __decorate([
	        core_1.ViewChild('resetPasswordModal'), 
	        __metadata('design:type', Object)
	    ], CompanyAdminListComponent.prototype, "resetPasswordModal", void 0);
	    __decorate([
	        core_1.ViewChild('inActiveModal'), 
	        __metadata('design:type', Object)
	    ], CompanyAdminListComponent.prototype, "inActiveModal", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], CompanyAdminListComponent.prototype, "successPopup", void 0);
	    CompanyAdminListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-company-admin',
	            template: __webpack_require__(823),
	            providers: [companyAdmin_service_1.CompanyAdminService, person_service_1.PersonService, company_service_1.CompanyService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof companyAdmin_service_1.CompanyAdminService !== 'undefined' && companyAdmin_service_1.CompanyAdminService) === 'function' && _a) || Object, (typeof (_b = typeof person_service_1.PersonService !== 'undefined' && person_service_1.PersonService) === 'function' && _b) || Object, (typeof (_c = typeof company_service_1.CompanyService !== 'undefined' && company_service_1.CompanyService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object, (typeof (_e = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _f) || Object, (typeof (_g = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _g) || Object])
	    ], CompanyAdminListComponent);
	    return CompanyAdminListComponent;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.CompanyAdminListComponent = CompanyAdminListComponent;


/***/ },
/* 823 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ breadCrumbList}} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li><a [routerLink]=\"urlDefaultPage\"><i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a></li>\r\n        <li><a [routerLink]=\"urlCompanyList\"><i class=\"fa fa-building-o fa-fw\"></i> {{companyList }}</a></li>\r\n        <li class=\"active\"> {{ breadCrumbList}} </li>\r\n\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25 \">\r\n      <a class=\"btn btn-highlight navbar-right\" (click)=\"ShowAddCompanyAdminModal()\">{{ 'LblAddNew' | translate }}</a>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <h4><label>{{ 'LblCompany' | translate }} : </label> {{companyName}}</h4>\r\n        <p class=\"text-success\">{{ message }}</p>\r\n        <wego-search-list [IsDeleted]=\"true\" [IsDeleteEnabled]=\"isAnyChecked\" (OnDeleteAll)=\"ShowAlertModal()\" (OnSearch)=\"OnSearch($event)\"\r\n          (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center parent-checkbox\"><input type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\"></th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('firstName')\">\r\n                  {{ 'LblFirstName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'firstName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('lastName')\">\r\n                  {{ 'LblLastName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'lastName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('userName')\">\r\n                  {{ 'LblUserName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'userName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"text-center\">{{ 'LblResendActivationMail' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblResetPassword' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblActiveInactive' | translate }}</th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let companyAdmin of companyAdminList\">\r\n                  <td class=\"text-center\"><input type=\"checkbox\" [disabled]=\"companyAdmin.isUserCompanyAdmin\" name=\"isActive\" [(ngModel)]=\"companyAdmin.isChecked\"></td>\r\n                  <td>{{ companyAdmin.firstName }}</td>\r\n                  <td>{{ companyAdmin.lastName }}</td>\r\n                  <td>{{ companyAdmin.userName }}</td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"companyAdmin.personNotActive\" class=\"btn btn-green btn-xs cursor-pointer\" (click)=\"ResendActivationMail(companyAdmin.personHashID)\">\r\n                         {{ 'LblReSend' | translate}}\r\n                    </a>\r\n                  </td>\r\n                  <template [ngIf]=\"companyAdmin.isUserCompanyAdmin\">\r\n                    <td class=\"text-center\">\r\n                      <a>\r\n                      <i class=\"fa fa-refresh fa-fw text-success\"></i>\r\n                    </a>\r\n                    </td>\r\n                  </template>                  \r\n                  <template [ngIf]=\"!companyAdmin.isUserCompanyAdmin\">\r\n                    <td class=\"text-center\">\r\n                      <a class=\"cursor-pointer\">\r\n                      <i class=\"fa fa-refresh fa-fw text-success\" (click)=\"ShowResetPasswordModal(companyAdmin.personHashID)\"></i>\r\n                    </a>\r\n                    </td>\r\n                  </template>\r\n                  <!--<td class=\"text-center\">\r\n                  <a class=\"cursor-pointer\">\r\n                    <i class=\"fa fa-trash-o fa-fw text-danger\" (click)=\"ShowAlertModal(companyAdmin.companyAdminHashId)\"></i>\r\n                  </a>\r\n                </td>-->\r\n                  <template [ngIf]=\"companyAdmin.isUserCompanyAdmin\">\r\n                    <td class=\"text-center\">\r\n                      <a disabled=\"true\" class=\"cursor-pointer btn btn-xs btn-active-inactive\" [ngClass]=\"{'btn-active': !companyAdmin.isActive, 'btn-inactive': companyAdmin.isActive}\"\r\n                        (click)=\"ShowInActiveModal(companyAdmin.companyAdminHashId, companyAdmin.isActive)\">\r\n                        <template [ngIf]=\"!companyAdmin.isActive\"> {{ 'LblActive' | translate}} </template>\r\n                        <template [ngIf]=\"companyAdmin.isActive\"> {{ 'LblInactive' | translate}} </template>\r\n                      </a>\r\n                    </td>\r\n                  </template>\r\n                  <template [ngIf]=\"!companyAdmin.isUserCompanyAdmin\">\r\n                    <td class=\"text-center\">\r\n                      <a class=\"cursor-pointer btn btn-xs btn-active-inactive\" [ngClass]=\"{'btn-active': !companyAdmin.isActive, 'btn-inactive': companyAdmin.isActive}\"\r\n                        (click)=\"ShowInActiveModal(companyAdmin.companyAdminHashId, companyAdmin.isActive)\">\r\n                        <template [ngIf]=\"!companyAdmin.isActive\"> {{ 'LblActive' | translate}} </template>\r\n                        <template [ngIf]=\"companyAdmin.isActive\"> {{ 'LblInactive' | translate}} </template>\r\n                      </a>\r\n                    </td>\r\n                  </template>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"7\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n\r\n\r\n<wego-confirm-popup #alertModal [popupMsg]=\"deleteMessage\" (onConfirm)=\"SuccessAlertModalClick()\" (onReject)=\"HideAlertModal()\"></wego-confirm-popup>\r\n\r\n<wego-confirm-popup #resetPasswordModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessResetPasswordModalClick()\" (onReject)=\"HideResetPasswordModal()\"></wego-confirm-popup>\r\n\r\n<wego-confirm-popup #inActiveModal [popupMsg]=\"blockUnblockMsg\" (onConfirm)=\"SuccessInActiveModalClick()\" (onReject)=\"HideInActiveModal()\"></wego-confirm-popup>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" [popupTitle]=\"popupTitle\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n\r\n<wego-add-company-admin #addCompanyAdminModal (OnSuccessSelect)=\"SuccessAddCompanyAdminModal($event)\"></wego-add-company-admin>";

/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var google_address_autocomplete_1 = __webpack_require__(825);
	var config_1 = __webpack_require__(60);
	var auth_service_1 = __webpack_require__(58);
	var translate_service_1 = __webpack_require__(70);
	var core_1 = __webpack_require__(3);
	var company_model_1 = __webpack_require__(827);
	var company_service_1 = __webpack_require__(501);
	var person_service_1 = __webpack_require__(771);
	var instance_service_1 = __webpack_require__(500);
	var router_1 = __webpack_require__(26);
	var config_2 = __webpack_require__(60);
	var common_1 = __webpack_require__(22);
	var pre_post_trip_question_component_1 = __webpack_require__(743);
	var payment_provider_1 = __webpack_require__(829);
	var country_1 = __webpack_require__(830);
	var CompanyUpdateComponent = (function () {
	    function CompanyUpdateComponent(companyService, personService, instanceService, translate, activeRoute, authService, router, locationService) {
	        this.companyService = companyService;
	        this.personService = personService;
	        this.instanceService = instanceService;
	        this.translate = translate;
	        this.activeRoute = activeRoute;
	        this.authService = authService;
	        this.router = router;
	        this.locationService = locationService;
	        this.totalItems = 0;
	        this.currentPage = 1;
	        this.maxSize = config_2.WeGoConfig.GRID_MAX_PAGE_SIZE;
	        this.itemsPerPage = config_2.WeGoConfig.GRID_MAX_DATA_SIZE;
	        this.showIdCheckConfig = false;
	        this.searchField = '';
	        this.searchTerm = '';
	        this.selectedInstance = '';
	        this.roleLevel = config_1.RoleLevel;
	        this.parentCompany = '';
	        this.onParentCompanyChange = new core_1.EventEmitter();
	        this.PaymentProvider = payment_provider_1.PaymentProvider;
	        this.Country = country_1.Country;
	        this.paymentMethods = [
	            { name: "Ideal", value: 'ideal', checked: false },
	            { name: "BCMC", value: 'bcmc', checked: false },
	            { name: "Sepa", value: 'sepa', checked: false },
	            //{name: "Paypal", value:'paypal-pc', checked: false},
	            //{name: "Mandate", value:'mandate', checked: false},
	            //{name: "Credit card", value:'creditcard', checked: false},
	            { name: "MyBank", value: 'mybank', checked: false },
	        ];
	    }
	    Object.defineProperty(CompanyUpdateComponent.prototype, "combinedCompanyAddress", {
	        get: function () {
	            var combinedAddress = '';
	            combinedAddress =
	                (this.model.companyAddressModel.houseNo &&
	                    this.model.companyAddressModel.houseNo.trim()
	                    ? this.model.companyAddressModel.houseNo + ', '
	                    : '') +
	                    (this.model.companyAddressModel.houseExtention &&
	                        this.model.companyAddressModel.houseExtention.trim()
	                        ? this.model.companyAddressModel.houseExtention + ', '
	                        : '') +
	                    (this.model.companyAddressModel.street &&
	                        this.model.companyAddressModel.street.trim()
	                        ? this.model.companyAddressModel.street + ', '
	                        : '') +
	                    (this.model.companyAddressModel.city &&
	                        this.model.companyAddressModel.city.trim()
	                        ? this.model.companyAddressModel.city + ', '
	                        : '') +
	                    (this.model.companyAddressModel.zipCode &&
	                        this.model.companyAddressModel.zipCode.trim()
	                        ? this.model.companyAddressModel.zipCode + ', '
	                        : '');
	            combinedAddress = combinedAddress.trim();
	            if (combinedAddress != null &&
	                combinedAddress.length > 0 &&
	                combinedAddress.charAt(combinedAddress.length - 1) == ',') {
	                combinedAddress = combinedAddress.substring(0, combinedAddress.length - 1);
	            }
	            return combinedAddress;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    CompanyUpdateComponent.prototype.ngOnInit = function () {
	        this.module = this.translate.instant('LblCompany');
	        this.urlDefaultPage = this.authService.GetURL(config_2.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlCompanyList = this.authService.GetURL(config_2.ApplicationRouteURL.URL_COMPANY_LIST);
	        this.model = new company_model_1.CompanyModel();
	        this.GetCompanyDetails();
	        this.IsAuthorizedForPrePostTripQuestion();
	    };
	    CompanyUpdateComponent.prototype.ngAfterViewInit = function () {
	        // viewChild is set after the view has been initialized
	        // this.prePostTripQuestionSection.GetPrePostTripQuestionList(
	        //   null,
	        //   this.companyMasterHashId,
	        //   null,
	        //   null
	        // );
	    };
	    CompanyUpdateComponent.prototype.GetCompanyDetails = function () {
	        var _this = this;
	        this.sub = this.activeRoute.params.subscribe(function (params) {
	            _this.companyMasterHashId = params['id'] || '';
	            if (_this.companyMasterHashId != '') {
	                _this.isEditMode = true;
	                _this.GetInstanceList();
	                _this.companyService
	                    .GetCompanyByHashId(_this.companyMasterHashId)
	                    .subscribe(function (res) {
	                    _this.model = res.data;
	                    _this.SetSelectedPaymentMethods();
	                    // this.GetInstanceList();
	                    _this.InstanceUpdate();
	                }, function (error) {
	                    _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	                });
	            }
	            else {
	                _this.isEditMode = false;
	                _this.model = new company_model_1.CompanyModel();
	                _this.GetInstanceList();
	            }
	        });
	        this.breadCrumbTitle = this.isEditMode
	            ? this.translate.instant('LblEditPage', [this.module])
	            : this.translate.instant('LblAddPage', [this.module]);
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	    };
	    CompanyUpdateComponent.prototype.onSubmit = function (forms) {
	        console.log(this.model);
	        this.model.paymentSettingModel.paymentMethodList = this.selectedPaymentMethods;
	        this.AddCompany();
	    };
	    CompanyUpdateComponent.prototype.AddCompany = function () {
	        var _this = this;
	        this.companyService.AddCompany(this.model).subscribe(function (res) {
	            if (res.data) {
	                _this.popupTitle = _this.translate.instant('LblSuccess');
	                _this.popupMsg = _this.isEditMode
	                    ? _this.translate.instant('LblRecordUpdatedSuccess', [_this.module])
	                    : _this.translate.instant('LblRecordAddedSuccess', [_this.module]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    CompanyUpdateComponent.prototype.GetInstanceList = function () {
	        var _this = this;
	        var permissionType = '';
	        if (this.isEditMode) {
	            permissionType = config_1.PermissionType.EDIT;
	        }
	        else {
	            permissionType = config_1.PermissionType.INSERT;
	        }
	        this.instanceService
	            .GetInstanceListDropdownForAddUpdatePage('company', permissionType)
	            .subscribe(function (res) {
	            _this.apiResponse = res;
	            _this.instanceList = res.data;
	            //this.model.instanceId = this.instanceList[0].instanceId;
	            if (_this.instanceList && _this.instanceList.length > 0) {
	                if (!_this.isEditMode &&
	                    !_this.model.instanceHashId &&
	                    _this.instanceList.length == 1) {
	                    _this.model.instanceHashId = _this.instanceList[0].keyHash;
	                }
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    CompanyUpdateComponent.prototype.InstanceUpdate = function () {
	        var _this = this;
	        this.IsAuthorizedForPrePostTripQuestion();
	        if (this.model.instanceHashId) {
	            this.instanceService
	                .IsOdometerEnabled(this.model.instanceHashId)
	                .subscribe(function (res) {
	                _this.apiResponse = res;
	                var odometerenabled = res.data;
	                if (odometerenabled) {
	                    _this.model.isInstanceOdometerConfiguration = true;
	                }
	                else {
	                    _this.model.isInstanceOdometerConfiguration = false;
	                }
	            }, function (error) {
	                _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            });
	            this.instanceService
	                .IsDirectDebitEnabledForCompany(this.model.instanceHashId)
	                .subscribe(function (res) {
	                _this.apiResponse = res;
	                var directDebitEnabled = res.data;
	                if (directDebitEnabled) {
	                    _this.model.directDebitFileEnabledOnInstance = true;
	                }
	                else {
	                    _this.model.directDebitFileEnabledOnInstance = false;
	                }
	            }, function (error) {
	                _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            });
	            this.instanceService
	                .PaymentSettingRequiredOnInstance(this.model.instanceHashId)
	                .subscribe(function (res) {
	                _this.apiResponse = res;
	                var paymentSettingEnabled = res.data;
	                if (paymentSettingEnabled) {
	                    _this.model.paymentSettingRequiredOnInstance = true;
	                }
	                else {
	                    _this.model.paymentSettingRequiredOnInstance = false;
	                }
	            }, function (error) {
	                _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            });
	            this.instanceService
	                .IsTwoFaEnabled(this.model.instanceHashId)
	                .subscribe(function (res) {
	                _this.TwoFaEnabled = res.data;
	            }, function (error) {
	                _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            });
	        }
	    };
	    CompanyUpdateComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    CompanyUpdateComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    CompanyUpdateComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    CompanyUpdateComponent.prototype.ShowTwoFaPopup = function () {
	        this.TwoFasuccessPopup.show();
	    };
	    // public GetGeoLocation(event: any) {
	    //   if (this.model) {
	    //     let locationData = event.GeoLocationData;
	    //     this.model.displaycompanyGeoLocationAddress = locationData.label;
	    //     this.model.companyGeoLocationLatitude = locationData.lat;
	    //     this.model.companyGeoLocationLongitude = locationData.lng;
	    //   }
	    // }
	    CompanyUpdateComponent.prototype.ConfirmTwoFaPopup = function () {
	        this.TwoFasuccessPopup.hide();
	    };
	    //  public GetAddress(place: Object) {
	    //         this.model.displaycompanyGeoLocationAddress = place['address'];
	    //         this.model.companyGeoLocationLatitude = place['lat'];
	    //         this.model.companyGeoLocationLongitude = place['log'];
	    //         this.model.companyGeoLocationAddress = place['useraddressInput'];
	    //     }
	    CompanyUpdateComponent.prototype.OnBackClick = function () {
	        this.locationService.back();
	    };
	    CompanyUpdateComponent.prototype.changeOfOdometerTimeInterval = function () {
	        if (this.model.odometerConfigurationModel.timeInterval == 'PERBOOKING')
	            this.model.odometerConfigurationModel.frequency = '';
	    };
	    CompanyUpdateComponent.prototype.InitialPaymentChange = function () {
	        if (!this.model.paymentSettingModel.initialPayment) {
	            this.model.paymentSettingModel.createBookingPayment = false;
	            this.model.paymentSettingModel.startBookingPayment = false;
	        }
	    };
	    CompanyUpdateComponent.prototype.ResetCookies = function () {
	        var _this = this;
	        this.companyService.ResetTwoFaCookies(this.companyMasterHashId)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupTitle = _this.translate.instant('LblSuccess');
	                _this.popupMsg = _this.translate.instant('LblCookieResetSuccess', [_this.module]);
	                _this.ShowTwoFaPopup();
	            }
	            else {
	                _this.popupTitle = _this.translate.instant('LblError');
	                _this.popupMsg = _this.translate.instant('LblCookieResetFailed');
	                _this.ShowTwoFaPopup();
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    CompanyUpdateComponent.prototype.ResetTwoFA = function () {
	        var _this = this;
	        this.companyService.ResetTwoFaKeys(this.companyMasterHashId)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupTitle = _this.translate.instant('LblSuccess');
	                _this.popupMsg = _this.translate.instant('LblKeyResetSuccess', [_this.module]);
	                _this.ShowTwoFaPopup();
	            }
	            else {
	                _this.popupTitle = _this.translate.instant('LblError');
	                _this.popupMsg = _this.translate.instant('LblKeyResetFailed');
	                _this.ShowTwoFaPopup();
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    CompanyUpdateComponent.prototype.ngOnDestroy = function () {
	        if (this.sub) {
	            this.sub.unsubscribe();
	        }
	    };
	    CompanyUpdateComponent.prototype.OnVatSetting = function ($event) {
	        this.model.vatSettingsList = $event.vatSettingsList;
	        this.model.vatSettingDefaultCost = $event.vatSettingDefaultCost;
	    };
	    CompanyUpdateComponent.prototype.OnPrePostTripQuestionSetting = function ($event) {
	        this.model.customTripQuestionList = $event.customTripQuestionList;
	    };
	    CompanyUpdateComponent.prototype.IsAuthorizedForPrePostTripQuestion = function () {
	        var _this = this;
	        var primaryPermissionType;
	        var entity = '';
	        var entityHashId = '';
	        if (this.companyMasterHashId && this.companyMasterHashId != '') {
	            primaryPermissionType = config_1.PermissionType.EDIT;
	            entity = config_1.Entity.COMPANY;
	            entityHashId = this.companyMasterHashId;
	        }
	        else {
	            primaryPermissionType = config_1.PermissionType.INSERT;
	            entity = config_1.Entity.INSTANCE;
	            entityHashId = this.model.instanceHashId;
	        }
	        this.authService
	            .IsAuthorizedForPrePostQuestion(config_1.Permission.PR_COMPANY_OVERVIEW, primaryPermissionType, config_1.Permission.PR_PREPOST_TRIP_QUESTIONS_UPDATE, config_1.PermissionType.VIEW, entity, entityHashId)
	            .subscribe(function (res) {
	            _this.isAuthorizedForPrePostTrip = res.data.view;
	            _this.basePermissionModel = res.data;
	            console.log(_this.prePostTripQuestionSection);
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	        }, function () {
	            setTimeout(function () {
	                if (_this.isAuthorizedForPrePostTrip) {
	                    _this.prePostTripQuestionSection.GetPrePostTripQuestionList(_this.companyMasterHashId ? null : _this.model.instanceHashId, _this.companyMasterHashId, null, null, _this.basePermissionModel, !_this.companyMasterHashId);
	                }
	            }, 1000);
	        });
	    };
	    CompanyUpdateComponent.prototype.NavigateToPaymentConfigurationPage = function (e) {
	        e.preventDefault();
	        window.open(this.model.paymentSettingModel.overviewUrl, "_blank");
	    };
	    CompanyUpdateComponent.prototype.SetSelectedPaymentMethods = function () {
	        var _this = this;
	        var modelPaymentMethods = this.model.paymentSettingModel.paymentMethodList;
	        if (modelPaymentMethods && modelPaymentMethods.length > 0) {
	            modelPaymentMethods.forEach(function (modelPaymentMethod) {
	                _this.paymentMethods.forEach(function (paymentMethod, paymentMethodIndex) {
	                    if (modelPaymentMethod == paymentMethod.value) {
	                        _this.paymentMethods[paymentMethodIndex].checked = true;
	                    }
	                });
	            });
	        }
	    };
	    Object.defineProperty(CompanyUpdateComponent.prototype, "selectedPaymentMethods", {
	        get: function () {
	            return this.paymentMethods
	                .filter(function (paymentMethod) { return paymentMethod.checked; })
	                .map(function (paymentMethod) { return paymentMethod.value; });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    CompanyUpdateComponent.prototype.OnChangePaymentMethod = function (paymentMethod, isChecked) {
	        paymentMethod.checked = isChecked;
	    };
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], CompanyUpdateComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild('TwoFasuccessPopup'), 
	        __metadata('design:type', Object)
	    ], CompanyUpdateComponent.prototype, "TwoFasuccessPopup", void 0);
	    __decorate([
	        core_1.ViewChild('googleMapComp'), 
	        __metadata('design:type', Object)
	    ], CompanyUpdateComponent.prototype, "googleMapComp", void 0);
	    __decorate([
	        core_1.ViewChild('prePostTripQuestionSection'), 
	        __metadata('design:type', (typeof (_a = typeof pre_post_trip_question_component_1.PrePostTripQuestionComponent !== 'undefined' && pre_post_trip_question_component_1.PrePostTripQuestionComponent) === 'function' && _a) || Object)
	    ], CompanyUpdateComponent.prototype, "prePostTripQuestionSection", void 0);
	    __decorate([
	        core_1.Output('OnParentCompanyChange'), 
	        __metadata('design:type', Object)
	    ], CompanyUpdateComponent.prototype, "onParentCompanyChange", void 0);
	    CompanyUpdateComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-company',
	            template: __webpack_require__(831),
	            providers: [
	                company_service_1.CompanyService,
	                person_service_1.PersonService,
	                instance_service_1.InstanceService,
	                google_address_autocomplete_1.GoogleplaceDirective
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof company_service_1.CompanyService !== 'undefined' && company_service_1.CompanyService) === 'function' && _b) || Object, (typeof (_c = typeof person_service_1.PersonService !== 'undefined' && person_service_1.PersonService) === 'function' && _c) || Object, (typeof (_d = typeof instance_service_1.InstanceService !== 'undefined' && instance_service_1.InstanceService) === 'function' && _d) || Object, (typeof (_e = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _f) || Object, (typeof (_g = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _g) || Object, (typeof (_h = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _h) || Object, (typeof (_j = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _j) || Object])
	    ], CompanyUpdateComponent);
	    return CompanyUpdateComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
	}());
	exports.CompanyUpdateComponent = CompanyUpdateComponent;


/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(826);
	var GoogleplaceDirective = (function () {
	    function GoogleplaceDirective(el, model) {
	        var _this = this;
	        this.model = model;
	        this.setAddress = new core_1.EventEmitter();
	        this.setInputAddressValue = new core_1.EventEmitter();
	        this._el = el.nativeElement;
	        this.modelValue = this.model;
	        var input = this._el;
	        var options = {
	            componentRestrictions: { country: "nl" }
	        };
	        this.autocomplete = new google.maps.places.Autocomplete(input, options);
	        // el.nativeElement.trigger("blur");
	        google.maps.event.addListener(this.autocomplete, 'place_changed', function () {
	            _this.location_being_changed = false;
	            // this.autocomplete.addListener('place_changed', () => {
	            console.log(el.nativeElement.value);
	            var place = _this.autocomplete.getPlace();
	            var address = { lat: 0, log: 0, address: '', isAdddressfound: false, useraddressInput: '' };
	            address.useraddressInput = el.nativeElement.value;
	            if (place) {
	                var location = place['geometry']['location'];
	                address.address = el.nativeElement.value;
	                if (location) {
	                    //  this.model.vehicleGeoLocationAddress = place['formatted_address'];
	                    address.lat = location.lat();
	                    address.log = location.lng();
	                    address.isAdddressfound = true;
	                }
	                else {
	                    address.lat = 0;
	                    address.log = 0;
	                    address.isAdddressfound = false;
	                }
	            }
	            else {
	                address.lat = 0;
	                address.log = 0;
	                address.isAdddressfound = false;
	            }
	            console.log("autocomplete value", address);
	            _this.invokeEvent(address);
	        });
	    }
	    GoogleplaceDirective.prototype.invokeEvent = function (address) {
	        this.setAddress.emit(address);
	    };
	    GoogleplaceDirective.prototype.onInputChange = function () {
	        this.autocomplete.set('place', null);
	        google.maps.event.trigger(this.autocomplete, 'place_changed');
	    };
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', (typeof (_a = typeof core_1.EventEmitter !== 'undefined' && core_1.EventEmitter) === 'function' && _a) || Object)
	    ], GoogleplaceDirective.prototype, "setAddress", void 0);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', (typeof (_b = typeof core_1.EventEmitter !== 'undefined' && core_1.EventEmitter) === 'function' && _b) || Object)
	    ], GoogleplaceDirective.prototype, "setInputAddressValue", void 0);
	    GoogleplaceDirective = __decorate([
	        core_1.Directive({
	            selector: '[googleplace]',
	            exportAs: 'wego-googleplace',
	            providers: [forms_1.NgModel],
	            host: {
	                '(input)': 'onInputChange()'
	            }
	        }), 
	        __metadata('design:paramtypes', [(typeof (_c = typeof core_1.ElementRef !== 'undefined' && core_1.ElementRef) === 'function' && _c) || Object, (typeof (_d = typeof forms_1.NgModel !== 'undefined' && forms_1.NgModel) === 'function' && _d) || Object])
	    ], GoogleplaceDirective);
	    return GoogleplaceDirective;
	    var _a, _b, _c, _d;
	}());
	exports.GoogleplaceDirective = GoogleplaceDirective;


/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @license Angular v2.2.4
	 * (c) 2010-2016 Google, Inc. https://angular.io/
	 * License: MIT
	 */
	(function (global, factory) {
	     true ? factory(exports, __webpack_require__(3), __webpack_require__(473), __webpack_require__(4), __webpack_require__(5), __webpack_require__(55)) :
	    typeof define === 'function' && define.amd ? define(['exports', '@angular/core', 'rxjs/operator/toPromise', 'rxjs/Subject', 'rxjs/Observable', 'rxjs/observable/fromPromise'], factory) :
	    (factory((global.ng = global.ng || {}, global.ng.forms = global.ng.forms || {}),global.ng.core,global.Rx.Observable.prototype,global.Rx,global.Rx,global.Rx.Observable));
	}(this, function (exports,_angular_core,rxjs_operator_toPromise,rxjs_Subject,rxjs_Observable,rxjs_observable_fromPromise) { 'use strict';
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    /**
	     * Base class for control directives.
	     *
	     * Only used internally in the forms module.
	     *
	     * @stable
	     */
	    var AbstractControlDirective = (function () {
	        function AbstractControlDirective() {
	        }
	        Object.defineProperty(AbstractControlDirective.prototype, "control", {
	            get: function () { throw new Error('unimplemented'); },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "value", {
	            get: function () { return this.control ? this.control.value : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "valid", {
	            get: function () { return this.control ? this.control.valid : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "invalid", {
	            get: function () { return this.control ? this.control.invalid : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "pending", {
	            get: function () { return this.control ? this.control.pending : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "errors", {
	            get: function () { return this.control ? this.control.errors : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "pristine", {
	            get: function () { return this.control ? this.control.pristine : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "dirty", {
	            get: function () { return this.control ? this.control.dirty : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "touched", {
	            get: function () { return this.control ? this.control.touched : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "untouched", {
	            get: function () { return this.control ? this.control.untouched : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "disabled", {
	            get: function () { return this.control ? this.control.disabled : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "enabled", {
	            get: function () { return this.control ? this.control.enabled : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "statusChanges", {
	            get: function () { return this.control ? this.control.statusChanges : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "valueChanges", {
	            get: function () { return this.control ? this.control.valueChanges : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlDirective.prototype, "path", {
	            get: function () { return null; },
	            enumerable: true,
	            configurable: true
	        });
	        AbstractControlDirective.prototype.reset = function (value) {
	            if (value === void 0) { value = undefined; }
	            if (this.control)
	                this.control.reset(value);
	        };
	        AbstractControlDirective.prototype.hasError = function (errorCode, path) {
	            if (path === void 0) { path = null; }
	            return this.control ? this.control.hasError(errorCode, path) : false;
	        };
	        AbstractControlDirective.prototype.getError = function (errorCode, path) {
	            if (path === void 0) { path = null; }
	            return this.control ? this.control.getError(errorCode, path) : null;
	        };
	        return AbstractControlDirective;
	    }());
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$1 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    /**
	     * A directive that contains multiple {@link NgControl}s.
	     *
	     * Only used by the forms module.
	     *
	     * @stable
	     */
	    var ControlContainer = (function (_super) {
	        __extends$1(ControlContainer, _super);
	        function ControlContainer() {
	            _super.apply(this, arguments);
	        }
	        Object.defineProperty(ControlContainer.prototype, "formDirective", {
	            /**
	             * Get the form to which this container belongs.
	             */
	            get: function () { return null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(ControlContainer.prototype, "path", {
	            /**
	             * Get the path to this container.
	             */
	            get: function () { return null; },
	            enumerable: true,
	            configurable: true
	        });
	        return ControlContainer;
	    }(AbstractControlDirective));
	
	    function isPresent(obj) {
	        return obj != null;
	    }
	    function isBlank(obj) {
	        return obj == null;
	    }
	    // JS has NaN !== NaN
	    function looseIdentical(a, b) {
	        return a === b || typeof a === 'number' && typeof b === 'number' && isNaN(a) && isNaN(b);
	    }
	    function isJsObject(o) {
	        return o !== null && (typeof o === 'function' || typeof o === 'object');
	    }
	    function isPrimitive(obj) {
	        return !isJsObject(obj);
	    }
	
	    /**
	     * Wraps Javascript Objects
	     */
	    var StringMapWrapper = (function () {
	        function StringMapWrapper() {
	        }
	        StringMapWrapper.merge = function (m1, m2) {
	            var m = {};
	            for (var _i = 0, _a = Object.keys(m1); _i < _a.length; _i++) {
	                var k = _a[_i];
	                m[k] = m1[k];
	            }
	            for (var _b = 0, _c = Object.keys(m2); _b < _c.length; _b++) {
	                var k = _c[_b];
	                m[k] = m2[k];
	            }
	            return m;
	        };
	        StringMapWrapper.equals = function (m1, m2) {
	            var k1 = Object.keys(m1);
	            var k2 = Object.keys(m2);
	            if (k1.length != k2.length) {
	                return false;
	            }
	            for (var i = 0; i < k1.length; i++) {
	                var key = k1[i];
	                if (m1[key] !== m2[key]) {
	                    return false;
	                }
	            }
	            return true;
	        };
	        return StringMapWrapper;
	    }());
	    var ListWrapper = (function () {
	        function ListWrapper() {
	        }
	        ListWrapper.removeAll = function (list, items) {
	            for (var i = 0; i < items.length; ++i) {
	                var index = list.indexOf(items[i]);
	                if (index > -1) {
	                    list.splice(index, 1);
	                }
	            }
	        };
	        ListWrapper.remove = function (list, el) {
	            var index = list.indexOf(el);
	            if (index > -1) {
	                list.splice(index, 1);
	                return true;
	            }
	            return false;
	        };
	        ListWrapper.equals = function (a, b) {
	            if (a.length != b.length)
	                return false;
	            for (var i = 0; i < a.length; ++i) {
	                if (a[i] !== b[i])
	                    return false;
	            }
	            return true;
	        };
	        ListWrapper.flatten = function (list) {
	            return list.reduce(function (flat, item) {
	                var flatItem = Array.isArray(item) ? ListWrapper.flatten(item) : item;
	                return flat.concat(flatItem);
	            }, []);
	        };
	        return ListWrapper;
	    }());
	
	    var isPromise = _angular_core.__core_private__.isPromise;
	
	    function isEmptyInputValue(value) {
	        return value == null || typeof value === 'string' && value.length === 0;
	    }
	    /**
	     * Providers for validators to be used for {@link FormControl}s in a form.
	     *
	     * Provide this using `multi: true` to add validators.
	     *
	     * ### Example
	     *
	     * {@example core/forms/ts/ng_validators/ng_validators.ts region='ng_validators'}
	     * @stable
	     */
	    var NG_VALIDATORS = new _angular_core.OpaqueToken('NgValidators');
	    /**
	     * Providers for asynchronous validators to be used for {@link FormControl}s
	     * in a form.
	     *
	     * Provide this using `multi: true` to add validators.
	     *
	     * See {@link NG_VALIDATORS} for more details.
	     *
	     * @stable
	     */
	    var NG_ASYNC_VALIDATORS = new _angular_core.OpaqueToken('NgAsyncValidators');
	    /**
	     * Provides a set of validators used by form controls.
	     *
	     * A validator is a function that processes a {@link FormControl} or collection of
	     * controls and returns a map of errors. A null map means that validation has passed.
	     *
	     * ### Example
	     *
	     * ```typescript
	     * var loginControl = new FormControl("", Validators.required)
	     * ```
	     *
	     * @stable
	     */
	    var Validators = (function () {
	        function Validators() {
	        }
	        /**
	         * Validator that requires controls to have a non-empty value.
	         */
	        Validators.required = function (control) {
	            return isEmptyInputValue(control.value) ? { 'required': true } : null;
	        };
	        /**
	         * Validator that requires controls to have a value of a minimum length.
	         */
	        Validators.minLength = function (minLength) {
	            return function (control) {
	                if (isEmptyInputValue(control.value)) {
	                    return null; // don't validate empty values to allow optional controls
	                }
	                var length = typeof control.value === 'string' ? control.value.length : 0;
	                return length < minLength ?
	                    { 'minlength': { 'requiredLength': minLength, 'actualLength': length } } :
	                    null;
	            };
	        };
	        /**
	         * Validator that requires controls to have a value of a maximum length.
	         */
	        Validators.maxLength = function (maxLength) {
	            return function (control) {
	                var length = typeof control.value === 'string' ? control.value.length : 0;
	                return length > maxLength ?
	                    { 'maxlength': { 'requiredLength': maxLength, 'actualLength': length } } :
	                    null;
	            };
	        };
	        /**
	         * Validator that requires a control to match a regex to its value.
	         */
	        Validators.pattern = function (pattern) {
	            if (!pattern)
	                return Validators.nullValidator;
	            var regex;
	            var regexStr;
	            if (typeof pattern === 'string') {
	                regexStr = "^" + pattern + "$";
	                regex = new RegExp(regexStr);
	            }
	            else {
	                regexStr = pattern.toString();
	                regex = pattern;
	            }
	            return function (control) {
	                if (isEmptyInputValue(control.value)) {
	                    return null; // don't validate empty values to allow optional controls
	                }
	                var value = control.value;
	                return regex.test(value) ? null :
	                    { 'pattern': { 'requiredPattern': regexStr, 'actualValue': value } };
	            };
	        };
	        /**
	         * No-op validator.
	         */
	        Validators.nullValidator = function (c) { return null; };
	        /**
	         * Compose multiple validators into a single function that returns the union
	         * of the individual error maps.
	         */
	        Validators.compose = function (validators) {
	            if (!validators)
	                return null;
	            var presentValidators = validators.filter(isPresent);
	            if (presentValidators.length == 0)
	                return null;
	            return function (control) {
	                return _mergeErrors(_executeValidators(control, presentValidators));
	            };
	        };
	        Validators.composeAsync = function (validators) {
	            if (!validators)
	                return null;
	            var presentValidators = validators.filter(isPresent);
	            if (presentValidators.length == 0)
	                return null;
	            return function (control) {
	                var promises = _executeAsyncValidators(control, presentValidators).map(_convertToPromise);
	                return Promise.all(promises).then(_mergeErrors);
	            };
	        };
	        return Validators;
	    }());
	    function _convertToPromise(obj) {
	        return isPromise(obj) ? obj : rxjs_operator_toPromise.toPromise.call(obj);
	    }
	    function _executeValidators(control, validators) {
	        return validators.map(function (v) { return v(control); });
	    }
	    function _executeAsyncValidators(control, validators) {
	        return validators.map(function (v) { return v(control); });
	    }
	    function _mergeErrors(arrayOfErrors) {
	        var res = arrayOfErrors.reduce(function (res, errors) {
	            return isPresent(errors) ? StringMapWrapper.merge(res, errors) : res;
	        }, {});
	        return Object.keys(res).length === 0 ? null : res;
	    }
	
	    /**
	     * Used to provide a {@link ControlValueAccessor} for form controls.
	     *
	     * See {@link DefaultValueAccessor} for how to implement one.
	     * @stable
	     */
	    var NG_VALUE_ACCESSOR = new _angular_core.OpaqueToken('NgValueAccessor');
	
	    var CHECKBOX_VALUE_ACCESSOR = {
	        provide: NG_VALUE_ACCESSOR,
	        useExisting: _angular_core.forwardRef(function () { return CheckboxControlValueAccessor; }),
	        multi: true,
	    };
	    /**
	     * The accessor for writing a value and listening to changes on a checkbox input element.
	     *
	     *  ### Example
	     *  ```
	     *  <input type="checkbox" name="rememberLogin" ngModel>
	     *  ```
	     *
	     *  @stable
	     */
	    var CheckboxControlValueAccessor = (function () {
	        function CheckboxControlValueAccessor(_renderer, _elementRef) {
	            this._renderer = _renderer;
	            this._elementRef = _elementRef;
	            this.onChange = function (_) { };
	            this.onTouched = function () { };
	        }
	        CheckboxControlValueAccessor.prototype.writeValue = function (value) {
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'checked', value);
	        };
	        CheckboxControlValueAccessor.prototype.registerOnChange = function (fn) { this.onChange = fn; };
	        CheckboxControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	        CheckboxControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
	        };
	        CheckboxControlValueAccessor.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: 'input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]',
	                        host: { '(change)': 'onChange($event.target.checked)', '(blur)': 'onTouched()' },
	                        providers: [CHECKBOX_VALUE_ACCESSOR]
	                    },] },
	        ];
	        /** @nocollapse */
	        CheckboxControlValueAccessor.ctorParameters = [
	            { type: _angular_core.Renderer, },
	            { type: _angular_core.ElementRef, },
	        ];
	        return CheckboxControlValueAccessor;
	    }());
	
	    var DEFAULT_VALUE_ACCESSOR = {
	        provide: NG_VALUE_ACCESSOR,
	        useExisting: _angular_core.forwardRef(function () { return DefaultValueAccessor; }),
	        multi: true
	    };
	    /**
	     * The default accessor for writing a value and listening to changes that is used by the
	     * {@link NgModel}, {@link FormControlDirective}, and {@link FormControlName} directives.
	     *
	     *  ### Example
	     *  ```
	     *  <input type="text" name="searchQuery" ngModel>
	     *  ```
	     *
	     *  @stable
	     */
	    var DefaultValueAccessor = (function () {
	        function DefaultValueAccessor(_renderer, _elementRef) {
	            this._renderer = _renderer;
	            this._elementRef = _elementRef;
	            this.onChange = function (_) { };
	            this.onTouched = function () { };
	        }
	        DefaultValueAccessor.prototype.writeValue = function (value) {
	            var normalizedValue = value == null ? '' : value;
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', normalizedValue);
	        };
	        DefaultValueAccessor.prototype.registerOnChange = function (fn) { this.onChange = fn; };
	        DefaultValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	        DefaultValueAccessor.prototype.setDisabledState = function (isDisabled) {
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
	        };
	        DefaultValueAccessor.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: 'input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]',
	                        // TODO: vsavkin replace the above selector with the one below it once
	                        // https://github.com/angular/angular/issues/3011 is implemented
	                        // selector: '[ngControl],[ngModel],[ngFormControl]',
	                        host: { '(input)': 'onChange($event.target.value)', '(blur)': 'onTouched()' },
	                        providers: [DEFAULT_VALUE_ACCESSOR]
	                    },] },
	        ];
	        /** @nocollapse */
	        DefaultValueAccessor.ctorParameters = [
	            { type: _angular_core.Renderer, },
	            { type: _angular_core.ElementRef, },
	        ];
	        return DefaultValueAccessor;
	    }());
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    function normalizeValidator(validator) {
	        if (validator.validate) {
	            return function (c) { return validator.validate(c); };
	        }
	        else {
	            return validator;
	        }
	    }
	    function normalizeAsyncValidator(validator) {
	        if (validator.validate) {
	            return function (c) { return validator.validate(c); };
	        }
	        else {
	            return validator;
	        }
	    }
	
	    var NUMBER_VALUE_ACCESSOR = {
	        provide: NG_VALUE_ACCESSOR,
	        useExisting: _angular_core.forwardRef(function () { return NumberValueAccessor; }),
	        multi: true
	    };
	    /**
	     * The accessor for writing a number value and listening to changes that is used by the
	     * {@link NgModel}, {@link FormControlDirective}, and {@link FormControlName} directives.
	     *
	     *  ### Example
	     *  ```
	     *  <input type="number" [(ngModel)]="age">
	     *  ```
	     */
	    var NumberValueAccessor = (function () {
	        function NumberValueAccessor(_renderer, _elementRef) {
	            this._renderer = _renderer;
	            this._elementRef = _elementRef;
	            this.onChange = function (_) { };
	            this.onTouched = function () { };
	        }
	        NumberValueAccessor.prototype.writeValue = function (value) {
	            // The value needs to be normalized for IE9, otherwise it is set to 'null' when null
	            var normalizedValue = value == null ? '' : value;
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', normalizedValue);
	        };
	        NumberValueAccessor.prototype.registerOnChange = function (fn) {
	            this.onChange = function (value) { fn(value == '' ? null : parseFloat(value)); };
	        };
	        NumberValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	        NumberValueAccessor.prototype.setDisabledState = function (isDisabled) {
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
	        };
	        NumberValueAccessor.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: 'input[type=number][formControlName],input[type=number][formControl],input[type=number][ngModel]',
	                        host: {
	                            '(change)': 'onChange($event.target.value)',
	                            '(input)': 'onChange($event.target.value)',
	                            '(blur)': 'onTouched()'
	                        },
	                        providers: [NUMBER_VALUE_ACCESSOR]
	                    },] },
	        ];
	        /** @nocollapse */
	        NumberValueAccessor.ctorParameters = [
	            { type: _angular_core.Renderer, },
	            { type: _angular_core.ElementRef, },
	        ];
	        return NumberValueAccessor;
	    }());
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$2 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    function unimplemented() {
	        throw new Error('unimplemented');
	    }
	    /**
	     * A base class that all control directive extend.
	     * It binds a {@link FormControl} object to a DOM element.
	     *
	     * Used internally by Angular forms.
	     *
	     * @stable
	     */
	    var NgControl = (function (_super) {
	        __extends$2(NgControl, _super);
	        function NgControl() {
	            _super.apply(this, arguments);
	            /** @internal */
	            this._parent = null;
	            this.name = null;
	            this.valueAccessor = null;
	            /** @internal */
	            this._rawValidators = [];
	            /** @internal */
	            this._rawAsyncValidators = [];
	        }
	        Object.defineProperty(NgControl.prototype, "validator", {
	            get: function () { return unimplemented(); },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(NgControl.prototype, "asyncValidator", {
	            get: function () { return unimplemented(); },
	            enumerable: true,
	            configurable: true
	        });
	        return NgControl;
	    }(AbstractControlDirective));
	
	    var RADIO_VALUE_ACCESSOR = {
	        provide: NG_VALUE_ACCESSOR,
	        useExisting: _angular_core.forwardRef(function () { return RadioControlValueAccessor; }),
	        multi: true
	    };
	    /**
	     * Internal class used by Angular to uncheck radio buttons with the matching name.
	     */
	    var RadioControlRegistry = (function () {
	        function RadioControlRegistry() {
	            this._accessors = [];
	        }
	        RadioControlRegistry.prototype.add = function (control, accessor) {
	            this._accessors.push([control, accessor]);
	        };
	        RadioControlRegistry.prototype.remove = function (accessor) {
	            for (var i = this._accessors.length - 1; i >= 0; --i) {
	                if (this._accessors[i][1] === accessor) {
	                    this._accessors.splice(i, 1);
	                    return;
	                }
	            }
	        };
	        RadioControlRegistry.prototype.select = function (accessor) {
	            var _this = this;
	            this._accessors.forEach(function (c) {
	                if (_this._isSameGroup(c, accessor) && c[1] !== accessor) {
	                    c[1].fireUncheck(accessor.value);
	                }
	            });
	        };
	        RadioControlRegistry.prototype._isSameGroup = function (controlPair, accessor) {
	            if (!controlPair[0].control)
	                return false;
	            return controlPair[0]._parent === accessor._control._parent &&
	                controlPair[1].name === accessor.name;
	        };
	        RadioControlRegistry.decorators = [
	            { type: _angular_core.Injectable },
	        ];
	        /** @nocollapse */
	        RadioControlRegistry.ctorParameters = [];
	        return RadioControlRegistry;
	    }());
	    /**
	     * @whatItDoes  Writes radio control values and listens to radio control changes.
	     *
	     * Used by {@link NgModel}, {@link FormControlDirective}, and {@link FormControlName}
	     * to keep the view synced with the {@link FormControl} model.
	     *
	     * @howToUse
	     *
	     * If you have imported the {@link FormsModule} or the {@link ReactiveFormsModule}, this
	     * value accessor will be active on any radio control that has a form directive. You do
	     * **not** need to add a special selector to activate it.
	     *
	     * ### How to use radio buttons with form directives
	     *
	     * To use radio buttons in a template-driven form, you'll want to ensure that radio buttons
	     * in the same group have the same `name` attribute.  Radio buttons with different `name`
	     * attributes do not affect each other.
	     *
	     * {@example forms/ts/radioButtons/radio_button_example.ts region='TemplateDriven'}
	     *
	     * When using radio buttons in a reactive form, radio buttons in the same group should have the
	     * same `formControlName`. You can also add a `name` attribute, but it's optional.
	     *
	     * {@example forms/ts/reactiveRadioButtons/reactive_radio_button_example.ts region='Reactive'}
	     *
	     *  * **npm package**: `@angular/forms`
	     *
	     *  @stable
	     */
	    var RadioControlValueAccessor = (function () {
	        function RadioControlValueAccessor(_renderer, _elementRef, _registry, _injector) {
	            this._renderer = _renderer;
	            this._elementRef = _elementRef;
	            this._registry = _registry;
	            this._injector = _injector;
	            this.onChange = function () { };
	            this.onTouched = function () { };
	        }
	        RadioControlValueAccessor.prototype.ngOnInit = function () {
	            this._control = this._injector.get(NgControl);
	            this._checkName();
	            this._registry.add(this._control, this);
	        };
	        RadioControlValueAccessor.prototype.ngOnDestroy = function () { this._registry.remove(this); };
	        RadioControlValueAccessor.prototype.writeValue = function (value) {
	            this._state = value === this.value;
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'checked', this._state);
	        };
	        RadioControlValueAccessor.prototype.registerOnChange = function (fn) {
	            var _this = this;
	            this._fn = fn;
	            this.onChange = function () {
	                fn(_this.value);
	                _this._registry.select(_this);
	            };
	        };
	        RadioControlValueAccessor.prototype.fireUncheck = function (value) { this.writeValue(value); };
	        RadioControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	        RadioControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
	        };
	        RadioControlValueAccessor.prototype._checkName = function () {
	            if (this.name && this.formControlName && this.name !== this.formControlName) {
	                this._throwNameError();
	            }
	            if (!this.name && this.formControlName)
	                this.name = this.formControlName;
	        };
	        RadioControlValueAccessor.prototype._throwNameError = function () {
	            throw new Error("\n      If you define both a name and a formControlName attribute on your radio button, their values\n      must match. Ex: <input type=\"radio\" formControlName=\"food\" name=\"food\">\n    ");
	        };
	        RadioControlValueAccessor.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: 'input[type=radio][formControlName],input[type=radio][formControl],input[type=radio][ngModel]',
	                        host: { '(change)': 'onChange()', '(blur)': 'onTouched()' },
	                        providers: [RADIO_VALUE_ACCESSOR]
	                    },] },
	        ];
	        /** @nocollapse */
	        RadioControlValueAccessor.ctorParameters = [
	            { type: _angular_core.Renderer, },
	            { type: _angular_core.ElementRef, },
	            { type: RadioControlRegistry, },
	            { type: _angular_core.Injector, },
	        ];
	        RadioControlValueAccessor.propDecorators = {
	            'name': [{ type: _angular_core.Input },],
	            'formControlName': [{ type: _angular_core.Input },],
	            'value': [{ type: _angular_core.Input },],
	        };
	        return RadioControlValueAccessor;
	    }());
	
	    var RANGE_VALUE_ACCESSOR = {
	        provide: NG_VALUE_ACCESSOR,
	        useExisting: _angular_core.forwardRef(function () { return RangeValueAccessor; }),
	        multi: true
	    };
	    /**
	     * The accessor for writing a range value and listening to changes that is used by the
	     * {@link NgModel}, {@link FormControlDirective}, and {@link FormControlName} directives.
	     *
	     *  ### Example
	     *  ```
	     *  <input type="range" [(ngModel)]="age" >
	     *  ```
	     */
	    var RangeValueAccessor = (function () {
	        function RangeValueAccessor(_renderer, _elementRef) {
	            this._renderer = _renderer;
	            this._elementRef = _elementRef;
	            this.onChange = function (_) { };
	            this.onTouched = function () { };
	        }
	        RangeValueAccessor.prototype.writeValue = function (value) {
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', parseFloat(value));
	        };
	        RangeValueAccessor.prototype.registerOnChange = function (fn) {
	            this.onChange = function (value) { fn(value == '' ? null : parseFloat(value)); };
	        };
	        RangeValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	        RangeValueAccessor.prototype.setDisabledState = function (isDisabled) {
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
	        };
	        RangeValueAccessor.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: 'input[type=range][formControlName],input[type=range][formControl],input[type=range][ngModel]',
	                        host: {
	                            '(change)': 'onChange($event.target.value)',
	                            '(input)': 'onChange($event.target.value)',
	                            '(blur)': 'onTouched()'
	                        },
	                        providers: [RANGE_VALUE_ACCESSOR]
	                    },] },
	        ];
	        /** @nocollapse */
	        RangeValueAccessor.ctorParameters = [
	            { type: _angular_core.Renderer, },
	            { type: _angular_core.ElementRef, },
	        ];
	        return RangeValueAccessor;
	    }());
	
	    var SELECT_VALUE_ACCESSOR = {
	        provide: NG_VALUE_ACCESSOR,
	        useExisting: _angular_core.forwardRef(function () { return SelectControlValueAccessor; }),
	        multi: true
	    };
	    function _buildValueString(id, value) {
	        if (id == null)
	            return "" + value;
	        if (!isPrimitive(value))
	            value = 'Object';
	        return (id + ": " + value).slice(0, 50);
	    }
	    function _extractId(valueString) {
	        return valueString.split(':')[0];
	    }
	    /**
	     * @whatItDoes Writes values and listens to changes on a select element.
	     *
	     * Used by {@link NgModel}, {@link FormControlDirective}, and {@link FormControlName}
	     * to keep the view synced with the {@link FormControl} model.
	     *
	     * @howToUse
	     *
	     * If you have imported the {@link FormsModule} or the {@link ReactiveFormsModule}, this
	     * value accessor will be active on any select control that has a form directive. You do
	     * **not** need to add a special selector to activate it.
	     *
	     * ### How to use select controls with form directives
	     *
	     * To use a select in a template-driven form, simply add an `ngModel` and a `name`
	     * attribute to the main `<select>` tag.
	     *
	     * If your option values are simple strings, you can bind to the normal `value` property
	     * on the option.  If your option values happen to be objects (and you'd like to save the
	     * selection in your form as an object), use `ngValue` instead:
	     *
	     * {@example forms/ts/selectControl/select_control_example.ts region='Component'}
	     *
	     * In reactive forms, you'll also want to add your form directive (`formControlName` or
	     * `formControl`) on the main `<select>` tag. Like in the former example, you have the
	     * choice of binding to the  `value` or `ngValue` property on the select's options.
	     *
	     * {@example forms/ts/reactiveSelectControl/reactive_select_control_example.ts region='Component'}
	     *
	     * Note: We listen to the 'change' event because 'input' events aren't fired
	     * for selects in Firefox and IE:
	     * https://bugzilla.mozilla.org/show_bug.cgi?id=1024350
	     * https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/4660045/
	     *
	     * * **npm package**: `@angular/forms`
	     *
	     * @stable
	     */
	    var SelectControlValueAccessor = (function () {
	        function SelectControlValueAccessor(_renderer, _elementRef) {
	            this._renderer = _renderer;
	            this._elementRef = _elementRef;
	            /** @internal */
	            this._optionMap = new Map();
	            /** @internal */
	            this._idCounter = 0;
	            this.onChange = function (_) { };
	            this.onTouched = function () { };
	        }
	        SelectControlValueAccessor.prototype.writeValue = function (value) {
	            this.value = value;
	            var valueString = _buildValueString(this._getOptionId(value), value);
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'value', valueString);
	        };
	        SelectControlValueAccessor.prototype.registerOnChange = function (fn) {
	            var _this = this;
	            this.onChange = function (valueString) {
	                _this.value = valueString;
	                fn(_this._getOptionValue(valueString));
	            };
	        };
	        SelectControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	        SelectControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
	        };
	        /** @internal */
	        SelectControlValueAccessor.prototype._registerOption = function () { return (this._idCounter++).toString(); };
	        /** @internal */
	        SelectControlValueAccessor.prototype._getOptionId = function (value) {
	            for (var _i = 0, _a = Array.from(this._optionMap.keys()); _i < _a.length; _i++) {
	                var id = _a[_i];
	                if (looseIdentical(this._optionMap.get(id), value))
	                    return id;
	            }
	            return null;
	        };
	        /** @internal */
	        SelectControlValueAccessor.prototype._getOptionValue = function (valueString) {
	            var id = _extractId(valueString);
	            return this._optionMap.has(id) ? this._optionMap.get(id) : valueString;
	        };
	        SelectControlValueAccessor.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: 'select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]',
	                        host: { '(change)': 'onChange($event.target.value)', '(blur)': 'onTouched()' },
	                        providers: [SELECT_VALUE_ACCESSOR]
	                    },] },
	        ];
	        /** @nocollapse */
	        SelectControlValueAccessor.ctorParameters = [
	            { type: _angular_core.Renderer, },
	            { type: _angular_core.ElementRef, },
	        ];
	        return SelectControlValueAccessor;
	    }());
	    /**
	     * @whatItDoes Marks `<option>` as dynamic, so Angular can be notified when options change.
	     *
	     * @howToUse
	     *
	     * See docs for {@link SelectControlValueAccessor} for usage examples.
	     *
	     * @stable
	     */
	    var NgSelectOption = (function () {
	        function NgSelectOption(_element, _renderer, _select) {
	            this._element = _element;
	            this._renderer = _renderer;
	            this._select = _select;
	            if (this._select)
	                this.id = this._select._registerOption();
	        }
	        Object.defineProperty(NgSelectOption.prototype, "ngValue", {
	            set: function (value) {
	                if (this._select == null)
	                    return;
	                this._select._optionMap.set(this.id, value);
	                this._setElementValue(_buildValueString(this.id, value));
	                this._select.writeValue(this._select.value);
	            },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(NgSelectOption.prototype, "value", {
	            set: function (value) {
	                this._setElementValue(value);
	                if (this._select)
	                    this._select.writeValue(this._select.value);
	            },
	            enumerable: true,
	            configurable: true
	        });
	        /** @internal */
	        NgSelectOption.prototype._setElementValue = function (value) {
	            this._renderer.setElementProperty(this._element.nativeElement, 'value', value);
	        };
	        NgSelectOption.prototype.ngOnDestroy = function () {
	            if (this._select) {
	                this._select._optionMap.delete(this.id);
	                this._select.writeValue(this._select.value);
	            }
	        };
	        NgSelectOption.decorators = [
	            { type: _angular_core.Directive, args: [{ selector: 'option' },] },
	        ];
	        /** @nocollapse */
	        NgSelectOption.ctorParameters = [
	            { type: _angular_core.ElementRef, },
	            { type: _angular_core.Renderer, },
	            { type: SelectControlValueAccessor, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Host },] },
	        ];
	        NgSelectOption.propDecorators = {
	            'ngValue': [{ type: _angular_core.Input, args: ['ngValue',] },],
	            'value': [{ type: _angular_core.Input, args: ['value',] },],
	        };
	        return NgSelectOption;
	    }());
	
	    var SELECT_MULTIPLE_VALUE_ACCESSOR = {
	        provide: NG_VALUE_ACCESSOR,
	        useExisting: _angular_core.forwardRef(function () { return SelectMultipleControlValueAccessor; }),
	        multi: true
	    };
	    function _buildValueString$1(id, value) {
	        if (id == null)
	            return "" + value;
	        if (typeof value === 'string')
	            value = "'" + value + "'";
	        if (!isPrimitive(value))
	            value = 'Object';
	        return (id + ": " + value).slice(0, 50);
	    }
	    function _extractId$1(valueString) {
	        return valueString.split(':')[0];
	    }
	    /**
	     * The accessor for writing a value and listening to changes on a select element.
	     *
	     * @stable
	     */
	    var SelectMultipleControlValueAccessor = (function () {
	        function SelectMultipleControlValueAccessor(_renderer, _elementRef) {
	            this._renderer = _renderer;
	            this._elementRef = _elementRef;
	            /** @internal */
	            this._optionMap = new Map();
	            /** @internal */
	            this._idCounter = 0;
	            this.onChange = function (_) { };
	            this.onTouched = function () { };
	        }
	        SelectMultipleControlValueAccessor.prototype.writeValue = function (value) {
	            var _this = this;
	            this.value = value;
	            if (value == null)
	                return;
	            var values = value;
	            // convert values to ids
	            var ids = values.map(function (v) { return _this._getOptionId(v); });
	            this._optionMap.forEach(function (opt, o) { opt._setSelected(ids.indexOf(o.toString()) > -1); });
	        };
	        SelectMultipleControlValueAccessor.prototype.registerOnChange = function (fn) {
	            var _this = this;
	            this.onChange = function (_) {
	                var selected = [];
	                if (_.hasOwnProperty('selectedOptions')) {
	                    var options = _.selectedOptions;
	                    for (var i = 0; i < options.length; i++) {
	                        var opt = options.item(i);
	                        var val = _this._getOptionValue(opt.value);
	                        selected.push(val);
	                    }
	                }
	                else {
	                    var options = _.options;
	                    for (var i = 0; i < options.length; i++) {
	                        var opt = options.item(i);
	                        if (opt.selected) {
	                            var val = _this._getOptionValue(opt.value);
	                            selected.push(val);
	                        }
	                    }
	                }
	                fn(selected);
	            };
	        };
	        SelectMultipleControlValueAccessor.prototype.registerOnTouched = function (fn) { this.onTouched = fn; };
	        SelectMultipleControlValueAccessor.prototype.setDisabledState = function (isDisabled) {
	            this._renderer.setElementProperty(this._elementRef.nativeElement, 'disabled', isDisabled);
	        };
	        /** @internal */
	        SelectMultipleControlValueAccessor.prototype._registerOption = function (value) {
	            var id = (this._idCounter++).toString();
	            this._optionMap.set(id, value);
	            return id;
	        };
	        /** @internal */
	        SelectMultipleControlValueAccessor.prototype._getOptionId = function (value) {
	            for (var _i = 0, _a = Array.from(this._optionMap.keys()); _i < _a.length; _i++) {
	                var id = _a[_i];
	                if (looseIdentical(this._optionMap.get(id)._value, value))
	                    return id;
	            }
	            return null;
	        };
	        /** @internal */
	        SelectMultipleControlValueAccessor.prototype._getOptionValue = function (valueString) {
	            var id = _extractId$1(valueString);
	            return this._optionMap.has(id) ? this._optionMap.get(id)._value : valueString;
	        };
	        SelectMultipleControlValueAccessor.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: 'select[multiple][formControlName],select[multiple][formControl],select[multiple][ngModel]',
	                        host: { '(change)': 'onChange($event.target)', '(blur)': 'onTouched()' },
	                        providers: [SELECT_MULTIPLE_VALUE_ACCESSOR]
	                    },] },
	        ];
	        /** @nocollapse */
	        SelectMultipleControlValueAccessor.ctorParameters = [
	            { type: _angular_core.Renderer, },
	            { type: _angular_core.ElementRef, },
	        ];
	        return SelectMultipleControlValueAccessor;
	    }());
	    /**
	     * Marks `<option>` as dynamic, so Angular can be notified when options change.
	     *
	     * ### Example
	     *
	     * ```
	     * <select multiple name="city" ngModel>
	     *   <option *ngFor="let c of cities" [value]="c"></option>
	     * </select>
	     * ```
	     */
	    var NgSelectMultipleOption = (function () {
	        function NgSelectMultipleOption(_element, _renderer, _select) {
	            this._element = _element;
	            this._renderer = _renderer;
	            this._select = _select;
	            if (this._select) {
	                this.id = this._select._registerOption(this);
	            }
	        }
	        Object.defineProperty(NgSelectMultipleOption.prototype, "ngValue", {
	            set: function (value) {
	                if (this._select == null)
	                    return;
	                this._value = value;
	                this._setElementValue(_buildValueString$1(this.id, value));
	                this._select.writeValue(this._select.value);
	            },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(NgSelectMultipleOption.prototype, "value", {
	            set: function (value) {
	                if (this._select) {
	                    this._value = value;
	                    this._setElementValue(_buildValueString$1(this.id, value));
	                    this._select.writeValue(this._select.value);
	                }
	                else {
	                    this._setElementValue(value);
	                }
	            },
	            enumerable: true,
	            configurable: true
	        });
	        /** @internal */
	        NgSelectMultipleOption.prototype._setElementValue = function (value) {
	            this._renderer.setElementProperty(this._element.nativeElement, 'value', value);
	        };
	        /** @internal */
	        NgSelectMultipleOption.prototype._setSelected = function (selected) {
	            this._renderer.setElementProperty(this._element.nativeElement, 'selected', selected);
	        };
	        NgSelectMultipleOption.prototype.ngOnDestroy = function () {
	            if (this._select) {
	                this._select._optionMap.delete(this.id);
	                this._select.writeValue(this._select.value);
	            }
	        };
	        NgSelectMultipleOption.decorators = [
	            { type: _angular_core.Directive, args: [{ selector: 'option' },] },
	        ];
	        /** @nocollapse */
	        NgSelectMultipleOption.ctorParameters = [
	            { type: _angular_core.ElementRef, },
	            { type: _angular_core.Renderer, },
	            { type: SelectMultipleControlValueAccessor, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Host },] },
	        ];
	        NgSelectMultipleOption.propDecorators = {
	            'ngValue': [{ type: _angular_core.Input, args: ['ngValue',] },],
	            'value': [{ type: _angular_core.Input, args: ['value',] },],
	        };
	        return NgSelectMultipleOption;
	    }());
	
	    function controlPath(name, parent) {
	        return parent.path.concat([name]);
	    }
	    function setUpControl(control, dir) {
	        if (!control)
	            _throwError(dir, 'Cannot find control with');
	        if (!dir.valueAccessor)
	            _throwError(dir, 'No value accessor for form control with');
	        control.validator = Validators.compose([control.validator, dir.validator]);
	        control.asyncValidator = Validators.composeAsync([control.asyncValidator, dir.asyncValidator]);
	        dir.valueAccessor.writeValue(control.value);
	        // view -> model
	        dir.valueAccessor.registerOnChange(function (newValue) {
	            dir.viewToModelUpdate(newValue);
	            control.markAsDirty();
	            control.setValue(newValue, { emitModelToViewChange: false });
	        });
	        // touched
	        dir.valueAccessor.registerOnTouched(function () { return control.markAsTouched(); });
	        control.registerOnChange(function (newValue, emitModelEvent) {
	            // control -> view
	            dir.valueAccessor.writeValue(newValue);
	            // control -> ngModel
	            if (emitModelEvent)
	                dir.viewToModelUpdate(newValue);
	        });
	        if (dir.valueAccessor.setDisabledState) {
	            control.registerOnDisabledChange(function (isDisabled) { dir.valueAccessor.setDisabledState(isDisabled); });
	        }
	        // re-run validation when validator binding changes, e.g. minlength=3 -> minlength=4
	        dir._rawValidators.forEach(function (validator) {
	            if (validator.registerOnValidatorChange)
	                validator.registerOnValidatorChange(function () { return control.updateValueAndValidity(); });
	        });
	        dir._rawAsyncValidators.forEach(function (validator) {
	            if (validator.registerOnValidatorChange)
	                validator.registerOnValidatorChange(function () { return control.updateValueAndValidity(); });
	        });
	    }
	    function cleanUpControl(control, dir) {
	        dir.valueAccessor.registerOnChange(function () { return _noControlError(dir); });
	        dir.valueAccessor.registerOnTouched(function () { return _noControlError(dir); });
	        dir._rawValidators.forEach(function (validator) {
	            if (validator.registerOnValidatorChange) {
	                validator.registerOnValidatorChange(null);
	            }
	        });
	        dir._rawAsyncValidators.forEach(function (validator) {
	            if (validator.registerOnValidatorChange) {
	                validator.registerOnValidatorChange(null);
	            }
	        });
	        if (control)
	            control._clearChangeFns();
	    }
	    function setUpFormContainer(control, dir) {
	        if (isBlank(control))
	            _throwError(dir, 'Cannot find control with');
	        control.validator = Validators.compose([control.validator, dir.validator]);
	        control.asyncValidator = Validators.composeAsync([control.asyncValidator, dir.asyncValidator]);
	    }
	    function _noControlError(dir) {
	        return _throwError(dir, 'There is no FormControl instance attached to form control element with');
	    }
	    function _throwError(dir, message) {
	        var messageEnd;
	        if (dir.path.length > 1) {
	            messageEnd = "path: '" + dir.path.join(' -> ') + "'";
	        }
	        else if (dir.path[0]) {
	            messageEnd = "name: '" + dir.path + "'";
	        }
	        else {
	            messageEnd = 'unspecified name attribute';
	        }
	        throw new Error(message + " " + messageEnd);
	    }
	    function composeValidators(validators) {
	        return isPresent(validators) ? Validators.compose(validators.map(normalizeValidator)) : null;
	    }
	    function composeAsyncValidators(validators) {
	        return isPresent(validators) ? Validators.composeAsync(validators.map(normalizeAsyncValidator)) :
	            null;
	    }
	    function isPropertyUpdated(changes, viewModel) {
	        if (!changes.hasOwnProperty('model'))
	            return false;
	        var change = changes['model'];
	        if (change.isFirstChange())
	            return true;
	        return !looseIdentical(viewModel, change.currentValue);
	    }
	    var BUILTIN_ACCESSORS = [
	        CheckboxControlValueAccessor,
	        RangeValueAccessor,
	        NumberValueAccessor,
	        SelectControlValueAccessor,
	        SelectMultipleControlValueAccessor,
	        RadioControlValueAccessor,
	    ];
	    function isBuiltInAccessor(valueAccessor) {
	        return BUILTIN_ACCESSORS.some(function (a) { return valueAccessor.constructor === a; });
	    }
	    // TODO: vsavkin remove it once https://github.com/angular/angular/issues/3011 is implemented
	    function selectValueAccessor(dir, valueAccessors) {
	        if (!valueAccessors)
	            return null;
	        var defaultAccessor;
	        var builtinAccessor;
	        var customAccessor;
	        valueAccessors.forEach(function (v) {
	            if (v.constructor === DefaultValueAccessor) {
	                defaultAccessor = v;
	            }
	            else if (isBuiltInAccessor(v)) {
	                if (builtinAccessor)
	                    _throwError(dir, 'More than one built-in value accessor matches form control with');
	                builtinAccessor = v;
	            }
	            else {
	                if (customAccessor)
	                    _throwError(dir, 'More than one custom value accessor matches form control with');
	                customAccessor = v;
	            }
	        });
	        if (customAccessor)
	            return customAccessor;
	        if (builtinAccessor)
	            return builtinAccessor;
	        if (defaultAccessor)
	            return defaultAccessor;
	        _throwError(dir, 'No valid value accessor for form control with');
	        return null;
	    }
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    /**
	     * This is a base class for code shared between {@link NgModelGroup} and {@link FormGroupName}.
	     *
	     * @stable
	     */
	    var AbstractFormGroupDirective = (function (_super) {
	        __extends(AbstractFormGroupDirective, _super);
	        function AbstractFormGroupDirective() {
	            _super.apply(this, arguments);
	        }
	        AbstractFormGroupDirective.prototype.ngOnInit = function () {
	            this._checkParentType();
	            this.formDirective.addFormGroup(this);
	        };
	        AbstractFormGroupDirective.prototype.ngOnDestroy = function () {
	            if (this.formDirective) {
	                this.formDirective.removeFormGroup(this);
	            }
	        };
	        Object.defineProperty(AbstractFormGroupDirective.prototype, "control", {
	            /**
	             * Get the {@link FormGroup} backing this binding.
	             */
	            get: function () { return this.formDirective.getFormGroup(this); },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractFormGroupDirective.prototype, "path", {
	            /**
	             * Get the path to this control group.
	             */
	            get: function () { return controlPath(this.name, this._parent); },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractFormGroupDirective.prototype, "formDirective", {
	            /**
	             * Get the {@link Form} to which this group belongs.
	             */
	            get: function () { return this._parent ? this._parent.formDirective : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractFormGroupDirective.prototype, "validator", {
	            get: function () { return composeValidators(this._validators); },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractFormGroupDirective.prototype, "asyncValidator", {
	            get: function () { return composeAsyncValidators(this._asyncValidators); },
	            enumerable: true,
	            configurable: true
	        });
	        /** @internal */
	        AbstractFormGroupDirective.prototype._checkParentType = function () { };
	        return AbstractFormGroupDirective;
	    }(ControlContainer));
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$3 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    var AbstractControlStatus = (function () {
	        function AbstractControlStatus(cd) {
	            this._cd = cd;
	        }
	        Object.defineProperty(AbstractControlStatus.prototype, "ngClassUntouched", {
	            get: function () { return this._cd.control ? this._cd.control.untouched : false; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlStatus.prototype, "ngClassTouched", {
	            get: function () { return this._cd.control ? this._cd.control.touched : false; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlStatus.prototype, "ngClassPristine", {
	            get: function () { return this._cd.control ? this._cd.control.pristine : false; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlStatus.prototype, "ngClassDirty", {
	            get: function () { return this._cd.control ? this._cd.control.dirty : false; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlStatus.prototype, "ngClassValid", {
	            get: function () { return this._cd.control ? this._cd.control.valid : false; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlStatus.prototype, "ngClassInvalid", {
	            get: function () { return this._cd.control ? this._cd.control.invalid : false; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControlStatus.prototype, "ngClassPending", {
	            get: function () { return this._cd.control ? this._cd.control.pending : false; },
	            enumerable: true,
	            configurable: true
	        });
	        return AbstractControlStatus;
	    }());
	    var ngControlStatusHost = {
	        '[class.ng-untouched]': 'ngClassUntouched',
	        '[class.ng-touched]': 'ngClassTouched',
	        '[class.ng-pristine]': 'ngClassPristine',
	        '[class.ng-dirty]': 'ngClassDirty',
	        '[class.ng-valid]': 'ngClassValid',
	        '[class.ng-invalid]': 'ngClassInvalid',
	        '[class.ng-pending]': 'ngClassPending',
	    };
	    /**
	     * Directive automatically applied to Angular form controls that sets CSS classes
	     * based on control status (valid/invalid/dirty/etc).
	     *
	     * @stable
	     */
	    var NgControlStatus = (function (_super) {
	        __extends$3(NgControlStatus, _super);
	        function NgControlStatus(cd) {
	            _super.call(this, cd);
	        }
	        NgControlStatus.decorators = [
	            { type: _angular_core.Directive, args: [{ selector: '[formControlName],[ngModel],[formControl]', host: ngControlStatusHost },] },
	        ];
	        /** @nocollapse */
	        NgControlStatus.ctorParameters = [
	            { type: NgControl, decorators: [{ type: _angular_core.Self },] },
	        ];
	        return NgControlStatus;
	    }(AbstractControlStatus));
	    /**
	     * Directive automatically applied to Angular form groups that sets CSS classes
	     * based on control status (valid/invalid/dirty/etc).
	     *
	     * @stable
	     */
	    var NgControlStatusGroup = (function (_super) {
	        __extends$3(NgControlStatusGroup, _super);
	        function NgControlStatusGroup(cd) {
	            _super.call(this, cd);
	        }
	        NgControlStatusGroup.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: '[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]',
	                        host: ngControlStatusHost
	                    },] },
	        ];
	        /** @nocollapse */
	        NgControlStatusGroup.ctorParameters = [
	            { type: ControlContainer, decorators: [{ type: _angular_core.Self },] },
	        ];
	        return NgControlStatusGroup;
	    }(AbstractControlStatus));
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$5 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    /**
	     * Use by directives and components to emit custom Events.
	     *
	     * ### Examples
	     *
	     * In the following example, `Zippy` alternatively emits `open` and `close` events when its
	     * title gets clicked:
	     *
	     * ```
	     * @Component({
	     *   selector: 'zippy',
	     *   template: `
	     *   <div class="zippy">
	     *     <div (click)="toggle()">Toggle</div>
	     *     <div [hidden]="!visible">
	     *       <ng-content></ng-content>
	     *     </div>
	     *  </div>`})
	     * export class Zippy {
	     *   visible: boolean = true;
	     *   @Output() open: EventEmitter<any> = new EventEmitter();
	     *   @Output() close: EventEmitter<any> = new EventEmitter();
	     *
	     *   toggle() {
	     *     this.visible = !this.visible;
	     *     if (this.visible) {
	     *       this.open.emit(null);
	     *     } else {
	     *       this.close.emit(null);
	     *     }
	     *   }
	     * }
	     * ```
	     *
	     * The events payload can be accessed by the parameter `$event` on the components output event
	     * handler:
	     *
	     * ```
	     * <zippy (open)="onOpen($event)" (close)="onClose($event)"></zippy>
	     * ```
	     *
	     * Uses Rx.Observable but provides an adapter to make it work as specified here:
	     * https://github.com/jhusain/observable-spec
	     *
	     * Once a reference implementation of the spec is available, switch to it.
	     * @stable
	     */
	    var EventEmitter = (function (_super) {
	        __extends$5(EventEmitter, _super);
	        /**
	         * Creates an instance of [EventEmitter], which depending on [isAsync],
	         * delivers events synchronously or asynchronously.
	         */
	        function EventEmitter(isAsync) {
	            if (isAsync === void 0) { isAsync = false; }
	            _super.call(this);
	            this.__isAsync = isAsync;
	        }
	        EventEmitter.prototype.emit = function (value) { _super.prototype.next.call(this, value); };
	        EventEmitter.prototype.subscribe = function (generatorOrNext, error, complete) {
	            var schedulerFn;
	            var errorFn = function (err) { return null; };
	            var completeFn = function () { return null; };
	            if (generatorOrNext && typeof generatorOrNext === 'object') {
	                schedulerFn = this.__isAsync ? function (value) {
	                    setTimeout(function () { return generatorOrNext.next(value); });
	                } : function (value) { generatorOrNext.next(value); };
	                if (generatorOrNext.error) {
	                    errorFn = this.__isAsync ? function (err) { setTimeout(function () { return generatorOrNext.error(err); }); } :
	                        function (err) { generatorOrNext.error(err); };
	                }
	                if (generatorOrNext.complete) {
	                    completeFn = this.__isAsync ? function () { setTimeout(function () { return generatorOrNext.complete(); }); } :
	                        function () { generatorOrNext.complete(); };
	                }
	            }
	            else {
	                schedulerFn = this.__isAsync ? function (value) { setTimeout(function () { return generatorOrNext(value); }); } :
	                    function (value) { generatorOrNext(value); };
	                if (error) {
	                    errorFn =
	                        this.__isAsync ? function (err) { setTimeout(function () { return error(err); }); } : function (err) { error(err); };
	                }
	                if (complete) {
	                    completeFn =
	                        this.__isAsync ? function () { setTimeout(function () { return complete(); }); } : function () { complete(); };
	                }
	            }
	            return _super.prototype.subscribe.call(this, schedulerFn, errorFn, completeFn);
	        };
	        return EventEmitter;
	    }(rxjs_Subject.Subject));
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$6 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    /**
	     * Indicates that a FormControl is valid, i.e. that no errors exist in the input value.
	     */
	    var VALID = 'VALID';
	    /**
	     * Indicates that a FormControl is invalid, i.e. that an error exists in the input value.
	     */
	    var INVALID = 'INVALID';
	    /**
	     * Indicates that a FormControl is pending, i.e. that async validation is occurring and
	     * errors are not yet available for the input value.
	     */
	    var PENDING = 'PENDING';
	    /**
	     * Indicates that a FormControl is disabled, i.e. that the control is exempt from ancestor
	     * calculations of validity or value.
	     */
	    var DISABLED = 'DISABLED';
	    function _find(control, path, delimiter) {
	        if (path == null)
	            return null;
	        if (!(path instanceof Array)) {
	            path = path.split(delimiter);
	        }
	        if (path instanceof Array && (path.length === 0))
	            return null;
	        return path.reduce(function (v, name) {
	            if (v instanceof FormGroup) {
	                return v.controls[name] || null;
	            }
	            if (v instanceof FormArray) {
	                return v.at(name) || null;
	            }
	            return null;
	        }, control);
	    }
	    function toObservable(r) {
	        return isPromise(r) ? rxjs_observable_fromPromise.fromPromise(r) : r;
	    }
	    function coerceToValidator(validator) {
	        return Array.isArray(validator) ? composeValidators(validator) : validator;
	    }
	    function coerceToAsyncValidator(asyncValidator) {
	        return Array.isArray(asyncValidator) ? composeAsyncValidators(asyncValidator) : asyncValidator;
	    }
	    /**
	     * @whatItDoes This is the base class for {@link FormControl}, {@link FormGroup}, and
	     * {@link FormArray}.
	     *
	     * It provides some of the shared behavior that all controls and groups of controls have, like
	     * running validators, calculating status, and resetting state. It also defines the properties
	     * that are shared between all sub-classes, like `value`, `valid`, and `dirty`. It shouldn't be
	     * instantiated directly.
	     *
	     * @stable
	     */
	    var AbstractControl = (function () {
	        function AbstractControl(validator, asyncValidator) {
	            this.validator = validator;
	            this.asyncValidator = asyncValidator;
	            /** @internal */
	            this._onCollectionChange = function () { };
	            this._pristine = true;
	            this._touched = false;
	            /** @internal */
	            this._onDisabledChange = [];
	        }
	        Object.defineProperty(AbstractControl.prototype, "value", {
	            /**
	             * The value of the control.
	             */
	            get: function () { return this._value; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "parent", {
	            /**
	             * The parent control.
	             */
	            get: function () { return this._parent; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "status", {
	            /**
	             * The validation status of the control. There are four possible
	             * validation statuses:
	             *
	             * * **VALID**:  control has passed all validation checks
	             * * **INVALID**: control has failed at least one validation check
	             * * **PENDING**: control is in the midst of conducting a validation check
	             * * **DISABLED**: control is exempt from validation checks
	             *
	             * These statuses are mutually exclusive, so a control cannot be
	             * both valid AND invalid or invalid AND disabled.
	             */
	            get: function () { return this._status; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "valid", {
	            /**
	             * A control is `valid` when its `status === VALID`.
	             *
	             * In order to have this status, the control must have passed all its
	             * validation checks.
	             */
	            get: function () { return this._status === VALID; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "invalid", {
	            /**
	             * A control is `invalid` when its `status === INVALID`.
	             *
	             * In order to have this status, the control must have failed
	             * at least one of its validation checks.
	             */
	            get: function () { return this._status === INVALID; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "pending", {
	            /**
	             * A control is `pending` when its `status === PENDING`.
	             *
	             * In order to have this status, the control must be in the
	             * middle of conducting a validation check.
	             */
	            get: function () { return this._status == PENDING; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "disabled", {
	            /**
	             * A control is `disabled` when its `status === DISABLED`.
	             *
	             * Disabled controls are exempt from validation checks and
	             * are not included in the aggregate value of their ancestor
	             * controls.
	             */
	            get: function () { return this._status === DISABLED; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "enabled", {
	            /**
	             * A control is `enabled` as long as its `status !== DISABLED`.
	             *
	             * In other words, it has a status of `VALID`, `INVALID`, or
	             * `PENDING`.
	             */
	            get: function () { return this._status !== DISABLED; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "errors", {
	            /**
	             * Returns any errors generated by failing validation. If there
	             * are no errors, it will return null.
	             */
	            get: function () { return this._errors; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "pristine", {
	            /**
	             * A control is `pristine` if the user has not yet changed
	             * the value in the UI.
	             *
	             * Note that programmatic changes to a control's value will
	             * *not* mark it dirty.
	             */
	            get: function () { return this._pristine; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "dirty", {
	            /**
	             * A control is `dirty` if the user has changed the value
	             * in the UI.
	             *
	             * Note that programmatic changes to a control's value will
	             * *not* mark it dirty.
	             */
	            get: function () { return !this.pristine; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "touched", {
	            /**
	            * A control is marked `touched` once the user has triggered
	            * a `blur` event on it.
	            */
	            get: function () { return this._touched; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "untouched", {
	            /**
	             * A control is `untouched` if the user has not yet triggered
	             * a `blur` event on it.
	             */
	            get: function () { return !this._touched; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "valueChanges", {
	            /**
	             * Emits an event every time the value of the control changes, in
	             * the UI or programmatically.
	             */
	            get: function () { return this._valueChanges; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(AbstractControl.prototype, "statusChanges", {
	            /**
	             * Emits an event every time the validation status of the control
	             * is re-calculated.
	             */
	            get: function () { return this._statusChanges; },
	            enumerable: true,
	            configurable: true
	        });
	        /**
	         * Sets the synchronous validators that are active on this control.  Calling
	         * this will overwrite any existing sync validators.
	         */
	        AbstractControl.prototype.setValidators = function (newValidator) {
	            this.validator = coerceToValidator(newValidator);
	        };
	        /**
	         * Sets the async validators that are active on this control. Calling this
	         * will overwrite any existing async validators.
	         */
	        AbstractControl.prototype.setAsyncValidators = function (newValidator) {
	            this.asyncValidator = coerceToAsyncValidator(newValidator);
	        };
	        /**
	         * Empties out the sync validator list.
	         */
	        AbstractControl.prototype.clearValidators = function () { this.validator = null; };
	        /**
	         * Empties out the async validator list.
	         */
	        AbstractControl.prototype.clearAsyncValidators = function () { this.asyncValidator = null; };
	        /**
	         * Marks the control as `touched`.
	         *
	         * This will also mark all direct ancestors as `touched` to maintain
	         * the model.
	         */
	        AbstractControl.prototype.markAsTouched = function (_a) {
	            var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
	            this._touched = true;
	            if (this._parent && !onlySelf) {
	                this._parent.markAsTouched({ onlySelf: onlySelf });
	            }
	        };
	        /**
	         * Marks the control as `untouched`.
	         *
	         * If the control has any children, it will also mark all children as `untouched`
	         * to maintain the model, and re-calculate the `touched` status of all parent
	         * controls.
	         */
	        AbstractControl.prototype.markAsUntouched = function (_a) {
	            var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
	            this._touched = false;
	            this._forEachChild(function (control) { control.markAsUntouched({ onlySelf: true }); });
	            if (this._parent && !onlySelf) {
	                this._parent._updateTouched({ onlySelf: onlySelf });
	            }
	        };
	        /**
	         * Marks the control as `dirty`.
	         *
	         * This will also mark all direct ancestors as `dirty` to maintain
	         * the model.
	         */
	        AbstractControl.prototype.markAsDirty = function (_a) {
	            var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
	            this._pristine = false;
	            if (this._parent && !onlySelf) {
	                this._parent.markAsDirty({ onlySelf: onlySelf });
	            }
	        };
	        /**
	         * Marks the control as `pristine`.
	         *
	         * If the control has any children, it will also mark all children as `pristine`
	         * to maintain the model, and re-calculate the `pristine` status of all parent
	         * controls.
	         */
	        AbstractControl.prototype.markAsPristine = function (_a) {
	            var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
	            this._pristine = true;
	            this._forEachChild(function (control) { control.markAsPristine({ onlySelf: true }); });
	            if (this._parent && !onlySelf) {
	                this._parent._updatePristine({ onlySelf: onlySelf });
	            }
	        };
	        /**
	         * Marks the control as `pending`.
	         */
	        AbstractControl.prototype.markAsPending = function (_a) {
	            var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
	            this._status = PENDING;
	            if (this._parent && !onlySelf) {
	                this._parent.markAsPending({ onlySelf: onlySelf });
	            }
	        };
	        /**
	         * Disables the control. This means the control will be exempt from validation checks and
	         * excluded from the aggregate value of any parent. Its status is `DISABLED`.
	         *
	         * If the control has children, all children will be disabled to maintain the model.
	         */
	        AbstractControl.prototype.disable = function (_a) {
	            var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
	            this._status = DISABLED;
	            this._errors = null;
	            this._forEachChild(function (control) { control.disable({ onlySelf: true }); });
	            this._updateValue();
	            if (emitEvent !== false) {
	                this._valueChanges.emit(this._value);
	                this._statusChanges.emit(this._status);
	            }
	            this._updateAncestors(onlySelf);
	            this._onDisabledChange.forEach(function (changeFn) { return changeFn(true); });
	        };
	        /**
	         * Enables the control. This means the control will be included in validation checks and
	         * the aggregate value of its parent. Its status is re-calculated based on its value and
	         * its validators.
	         *
	         * If the control has children, all children will be enabled.
	         */
	        AbstractControl.prototype.enable = function (_a) {
	            var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
	            this._status = VALID;
	            this._forEachChild(function (control) { control.enable({ onlySelf: true }); });
	            this.updateValueAndValidity({ onlySelf: true, emitEvent: emitEvent });
	            this._updateAncestors(onlySelf);
	            this._onDisabledChange.forEach(function (changeFn) { return changeFn(false); });
	        };
	        AbstractControl.prototype._updateAncestors = function (onlySelf) {
	            if (this._parent && !onlySelf) {
	                this._parent.updateValueAndValidity();
	                this._parent._updatePristine();
	                this._parent._updateTouched();
	            }
	        };
	        AbstractControl.prototype.setParent = function (parent) { this._parent = parent; };
	        /**
	         * Re-calculates the value and validation status of the control.
	         *
	         * By default, it will also update the value and validity of its ancestors.
	         */
	        AbstractControl.prototype.updateValueAndValidity = function (_a) {
	            var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
	            this._setInitialStatus();
	            this._updateValue();
	            if (this.enabled) {
	                this._errors = this._runValidator();
	                this._status = this._calculateStatus();
	                if (this._status === VALID || this._status === PENDING) {
	                    this._runAsyncValidator(emitEvent);
	                }
	            }
	            if (emitEvent !== false) {
	                this._valueChanges.emit(this._value);
	                this._statusChanges.emit(this._status);
	            }
	            if (this._parent && !onlySelf) {
	                this._parent.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
	            }
	        };
	        /** @internal */
	        AbstractControl.prototype._updateTreeValidity = function (_a) {
	            var emitEvent = (_a === void 0 ? { emitEvent: true } : _a).emitEvent;
	            this._forEachChild(function (ctrl) { return ctrl._updateTreeValidity({ emitEvent: emitEvent }); });
	            this.updateValueAndValidity({ onlySelf: true, emitEvent: emitEvent });
	        };
	        AbstractControl.prototype._setInitialStatus = function () { this._status = this._allControlsDisabled() ? DISABLED : VALID; };
	        AbstractControl.prototype._runValidator = function () {
	            return this.validator ? this.validator(this) : null;
	        };
	        AbstractControl.prototype._runAsyncValidator = function (emitEvent) {
	            var _this = this;
	            if (this.asyncValidator) {
	                this._status = PENDING;
	                this._cancelExistingSubscription();
	                var obs = toObservable(this.asyncValidator(this));
	                this._asyncValidationSubscription =
	                    obs.subscribe({ next: function (res) { return _this.setErrors(res, { emitEvent: emitEvent }); } });
	            }
	        };
	        AbstractControl.prototype._cancelExistingSubscription = function () {
	            if (this._asyncValidationSubscription) {
	                this._asyncValidationSubscription.unsubscribe();
	            }
	        };
	        /**
	         * Sets errors on a form control.
	         *
	         * This is used when validations are run manually by the user, rather than automatically.
	         *
	         * Calling `setErrors` will also update the validity of the parent control.
	         *
	         * ### Example
	         *
	         * ```
	         * const login = new FormControl("someLogin");
	         * login.setErrors({
	         *   "notUnique": true
	         * });
	         *
	         * expect(login.valid).toEqual(false);
	         * expect(login.errors).toEqual({"notUnique": true});
	         *
	         * login.setValue("someOtherLogin");
	         *
	         * expect(login.valid).toEqual(true);
	         * ```
	         */
	        AbstractControl.prototype.setErrors = function (errors, _a) {
	            var emitEvent = (_a === void 0 ? {} : _a).emitEvent;
	            this._errors = errors;
	            this._updateControlsErrors(emitEvent !== false);
	        };
	        /**
	         * Retrieves a child control given the control's name or path.
	         *
	         * Paths can be passed in as an array or a string delimited by a dot.
	         *
	         * To get a control nested within a `person` sub-group:
	         *
	         * * `this.form.get('person.name');`
	         *
	         * -OR-
	         *
	         * * `this.form.get(['person', 'name']);`
	         */
	        AbstractControl.prototype.get = function (path) { return _find(this, path, '.'); };
	        /**
	         * Returns true if the control with the given path has the error specified. Otherwise
	         * returns null or undefined.
	         *
	         * If no path is given, it checks for the error on the present control.
	         */
	        AbstractControl.prototype.getError = function (errorCode, path) {
	            if (path === void 0) { path = null; }
	            var control = path ? this.get(path) : this;
	            return control && control._errors ? control._errors[errorCode] : null;
	        };
	        /**
	         * Returns true if the control with the given path has the error specified. Otherwise
	         * returns false.
	         *
	         * If no path is given, it checks for the error on the present control.
	         */
	        AbstractControl.prototype.hasError = function (errorCode, path) {
	            if (path === void 0) { path = null; }
	            return !!this.getError(errorCode, path);
	        };
	        Object.defineProperty(AbstractControl.prototype, "root", {
	            /**
	             * Retrieves the top-level ancestor of this control.
	             */
	            get: function () {
	                var x = this;
	                while (x._parent) {
	                    x = x._parent;
	                }
	                return x;
	            },
	            enumerable: true,
	            configurable: true
	        });
	        /** @internal */
	        AbstractControl.prototype._updateControlsErrors = function (emitEvent) {
	            this._status = this._calculateStatus();
	            if (emitEvent) {
	                this._statusChanges.emit(this._status);
	            }
	            if (this._parent) {
	                this._parent._updateControlsErrors(emitEvent);
	            }
	        };
	        /** @internal */
	        AbstractControl.prototype._initObservables = function () {
	            this._valueChanges = new EventEmitter();
	            this._statusChanges = new EventEmitter();
	        };
	        AbstractControl.prototype._calculateStatus = function () {
	            if (this._allControlsDisabled())
	                return DISABLED;
	            if (this._errors)
	                return INVALID;
	            if (this._anyControlsHaveStatus(PENDING))
	                return PENDING;
	            if (this._anyControlsHaveStatus(INVALID))
	                return INVALID;
	            return VALID;
	        };
	        /** @internal */
	        AbstractControl.prototype._anyControlsHaveStatus = function (status) {
	            return this._anyControls(function (control) { return control.status === status; });
	        };
	        /** @internal */
	        AbstractControl.prototype._anyControlsDirty = function () {
	            return this._anyControls(function (control) { return control.dirty; });
	        };
	        /** @internal */
	        AbstractControl.prototype._anyControlsTouched = function () {
	            return this._anyControls(function (control) { return control.touched; });
	        };
	        /** @internal */
	        AbstractControl.prototype._updatePristine = function (_a) {
	            var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
	            this._pristine = !this._anyControlsDirty();
	            if (this._parent && !onlySelf) {
	                this._parent._updatePristine({ onlySelf: onlySelf });
	            }
	        };
	        /** @internal */
	        AbstractControl.prototype._updateTouched = function (_a) {
	            var onlySelf = (_a === void 0 ? {} : _a).onlySelf;
	            this._touched = this._anyControlsTouched();
	            if (this._parent && !onlySelf) {
	                this._parent._updateTouched({ onlySelf: onlySelf });
	            }
	        };
	        /** @internal */
	        AbstractControl.prototype._isBoxedValue = function (formState) {
	            return typeof formState === 'object' && formState !== null &&
	                Object.keys(formState).length === 2 && 'value' in formState && 'disabled' in formState;
	        };
	        /** @internal */
	        AbstractControl.prototype._registerOnCollectionChange = function (fn) { this._onCollectionChange = fn; };
	        return AbstractControl;
	    }());
	    /**
	     * @whatItDoes Tracks the value and validation status of an individual form control.
	     *
	     * It is one of the three fundamental building blocks of Angular forms, along with
	     * {@link FormGroup} and {@link FormArray}.
	     *
	     * @howToUse
	     *
	     * When instantiating a {@link FormControl}, you can pass in an initial value as the
	     * first argument. Example:
	     *
	     * ```ts
	     * const ctrl = new FormControl('some value');
	     * console.log(ctrl.value);     // 'some value'
	     *```
	     *
	     * You can also initialize the control with a form state object on instantiation,
	     * which includes both the value and whether or not the control is disabled.
	     * You can't use the value key without the disabled key; both are required
	     * to use this way of initialization.
	     *
	     * ```ts
	     * const ctrl = new FormControl({value: 'n/a', disabled: true});
	     * console.log(ctrl.value);     // 'n/a'
	     * console.log(ctrl.status);   // 'DISABLED'
	     * ```
	     *
	     * To include a sync validator (or an array of sync validators) with the control,
	     * pass it in as the second argument. Async validators are also supported, but
	     * have to be passed in separately as the third arg.
	     *
	     * ```ts
	     * const ctrl = new FormControl('', Validators.required);
	     * console.log(ctrl.value);     // ''
	     * console.log(ctrl.status);   // 'INVALID'
	     * ```
	     *
	     * See its superclass, {@link AbstractControl}, for more properties and methods.
	     *
	     * * **npm package**: `@angular/forms`
	     *
	     * @stable
	     */
	    var FormControl = (function (_super) {
	        __extends$6(FormControl, _super);
	        function FormControl(formState, validator, asyncValidator) {
	            if (formState === void 0) { formState = null; }
	            if (validator === void 0) { validator = null; }
	            if (asyncValidator === void 0) { asyncValidator = null; }
	            _super.call(this, coerceToValidator(validator), coerceToAsyncValidator(asyncValidator));
	            /** @internal */
	            this._onChange = [];
	            this._applyFormState(formState);
	            this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
	            this._initObservables();
	        }
	        /**
	         * Set the value of the form control to `value`.
	         *
	         * If `onlySelf` is `true`, this change will only affect the validation of this `FormControl`
	         * and not its parent component. This defaults to false.
	         *
	         * If `emitEvent` is `true`, this
	         * change will cause a `valueChanges` event on the `FormControl` to be emitted. This defaults
	         * to true (as it falls through to `updateValueAndValidity`).
	         *
	         * If `emitModelToViewChange` is `true`, the view will be notified about the new value
	         * via an `onChange` event. This is the default behavior if `emitModelToViewChange` is not
	         * specified.
	         *
	         * If `emitViewToModelChange` is `true`, an ngModelChange event will be fired to update the
	         * model.  This is the default behavior if `emitViewToModelChange` is not specified.
	         */
	        FormControl.prototype.setValue = function (value, _a) {
	            var _this = this;
	            var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent, emitModelToViewChange = _b.emitModelToViewChange, emitViewToModelChange = _b.emitViewToModelChange;
	            this._value = value;
	            if (this._onChange.length && emitModelToViewChange !== false) {
	                this._onChange.forEach(function (changeFn) { return changeFn(_this._value, emitViewToModelChange !== false); });
	            }
	            this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
	        };
	        /**
	         * Patches the value of a control.
	         *
	         * This function is functionally the same as {@link FormControl.setValue} at this level.
	         * It exists for symmetry with {@link FormGroup.patchValue} on `FormGroups` and `FormArrays`,
	         * where it does behave differently.
	         */
	        FormControl.prototype.patchValue = function (value, options) {
	            if (options === void 0) { options = {}; }
	            this.setValue(value, options);
	        };
	        /**
	         * Resets the form control. This means by default:
	         *
	         * * it is marked as `pristine`
	         * * it is marked as `untouched`
	         * * value is set to null
	         *
	         * You can also reset to a specific form state by passing through a standalone
	         * value or a form state object that contains both a value and a disabled state
	         * (these are the only two properties that cannot be calculated).
	         *
	         * Ex:
	         *
	         * ```ts
	         * this.control.reset('Nancy');
	         *
	         * console.log(this.control.value);  // 'Nancy'
	         * ```
	         *
	         * OR
	         *
	         * ```
	         * this.control.reset({value: 'Nancy', disabled: true});
	         *
	         * console.log(this.control.value);  // 'Nancy'
	         * console.log(this.control.status);  // 'DISABLED'
	         * ```
	         */
	        FormControl.prototype.reset = function (formState, _a) {
	            if (formState === void 0) { formState = null; }
	            var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
	            this._applyFormState(formState);
	            this.markAsPristine({ onlySelf: onlySelf });
	            this.markAsUntouched({ onlySelf: onlySelf });
	            this.setValue(this._value, { onlySelf: onlySelf, emitEvent: emitEvent });
	        };
	        /**
	         * @internal
	         */
	        FormControl.prototype._updateValue = function () { };
	        /**
	         * @internal
	         */
	        FormControl.prototype._anyControls = function (condition) { return false; };
	        /**
	         * @internal
	         */
	        FormControl.prototype._allControlsDisabled = function () { return this.disabled; };
	        /**
	         * Register a listener for change events.
	         */
	        FormControl.prototype.registerOnChange = function (fn) { this._onChange.push(fn); };
	        /**
	         * @internal
	         */
	        FormControl.prototype._clearChangeFns = function () {
	            this._onChange = [];
	            this._onDisabledChange = [];
	            this._onCollectionChange = function () { };
	        };
	        /**
	         * Register a listener for disabled events.
	         */
	        FormControl.prototype.registerOnDisabledChange = function (fn) {
	            this._onDisabledChange.push(fn);
	        };
	        /**
	         * @internal
	         */
	        FormControl.prototype._forEachChild = function (cb) { };
	        FormControl.prototype._applyFormState = function (formState) {
	            if (this._isBoxedValue(formState)) {
	                this._value = formState.value;
	                formState.disabled ? this.disable({ onlySelf: true, emitEvent: false }) :
	                    this.enable({ onlySelf: true, emitEvent: false });
	            }
	            else {
	                this._value = formState;
	            }
	        };
	        return FormControl;
	    }(AbstractControl));
	    /**
	     * @whatItDoes Tracks the value and validity state of a group of {@link FormControl}
	     * instances.
	     *
	     * A `FormGroup` aggregates the values of each child {@link FormControl} into one object,
	     * with each control name as the key.  It calculates its status by reducing the statuses
	     * of its children. For example, if one of the controls in a group is invalid, the entire
	     * group becomes invalid.
	     *
	     * `FormGroup` is one of the three fundamental building blocks used to define forms in Angular,
	     * along with {@link FormControl} and {@link FormArray}.
	     *
	     * @howToUse
	     *
	     * When instantiating a {@link FormGroup}, pass in a collection of child controls as the first
	     * argument. The key for each child will be the name under which it is registered.
	     *
	     * ### Example
	     *
	     * ```
	     * const form = new FormGroup({
	     *   first: new FormControl('Nancy', Validators.minLength(2)),
	     *   last: new FormControl('Drew'),
	     * });
	     *
	     * console.log(form.value);   // {first: 'Nancy', last; 'Drew'}
	     * console.log(form.status);  // 'VALID'
	     * ```
	     *
	     * You can also include group-level validators as the second arg, or group-level async
	     * validators as the third arg. These come in handy when you want to perform validation
	     * that considers the value of more than one child control.
	     *
	     * ### Example
	     *
	     * ```
	     * const form = new FormGroup({
	     *   password: new FormControl('', Validators.minLength(2)),
	     *   passwordConfirm: new FormControl('', Validators.minLength(2)),
	     * }, passwordMatchValidator);
	     *
	     *
	     * function passwordMatchValidator(g: FormGroup) {
	     *    return g.get('password').value === g.get('passwordConfirm').value
	     *       ? null : {'mismatch': true};
	     * }
	     * ```
	     *
	     * * **npm package**: `@angular/forms`
	     *
	     * @stable
	     */
	    var FormGroup = (function (_super) {
	        __extends$6(FormGroup, _super);
	        function FormGroup(controls, validator, asyncValidator) {
	            if (validator === void 0) { validator = null; }
	            if (asyncValidator === void 0) { asyncValidator = null; }
	            _super.call(this, validator, asyncValidator);
	            this.controls = controls;
	            this._initObservables();
	            this._setUpControls();
	            this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
	        }
	        /**
	         * Registers a control with the group's list of controls.
	         *
	         * This method does not update value or validity of the control, so for
	         * most cases you'll want to use {@link FormGroup.addControl} instead.
	         */
	        FormGroup.prototype.registerControl = function (name, control) {
	            if (this.controls[name])
	                return this.controls[name];
	            this.controls[name] = control;
	            control.setParent(this);
	            control._registerOnCollectionChange(this._onCollectionChange);
	            return control;
	        };
	        /**
	         * Add a control to this group.
	         */
	        FormGroup.prototype.addControl = function (name, control) {
	            this.registerControl(name, control);
	            this.updateValueAndValidity();
	            this._onCollectionChange();
	        };
	        /**
	         * Remove a control from this group.
	         */
	        FormGroup.prototype.removeControl = function (name) {
	            if (this.controls[name])
	                this.controls[name]._registerOnCollectionChange(function () { });
	            delete (this.controls[name]);
	            this.updateValueAndValidity();
	            this._onCollectionChange();
	        };
	        /**
	         * Replace an existing control.
	         */
	        FormGroup.prototype.setControl = function (name, control) {
	            if (this.controls[name])
	                this.controls[name]._registerOnCollectionChange(function () { });
	            delete (this.controls[name]);
	            if (control)
	                this.registerControl(name, control);
	            this.updateValueAndValidity();
	            this._onCollectionChange();
	        };
	        /**
	         * Check whether there is an enabled control with the given name in the group.
	         *
	         * It will return false for disabled controls. If you'd like to check for
	         * existence in the group only, use {@link AbstractControl.get} instead.
	         */
	        FormGroup.prototype.contains = function (controlName) {
	            return this.controls.hasOwnProperty(controlName) && this.controls[controlName].enabled;
	        };
	        /**
	         *  Sets the value of the {@link FormGroup}. It accepts an object that matches
	         *  the structure of the group, with control names as keys.
	         *
	         * This method performs strict checks, so it will throw an error if you try
	         * to set the value of a control that doesn't exist or if you exclude the
	         * value of a control.
	         *
	         *  ### Example
	         *
	         *  ```
	         *  const form = new FormGroup({
	         *     first: new FormControl(),
	         *     last: new FormControl()
	         *  });
	         *  console.log(form.value);   // {first: null, last: null}
	         *
	         *  form.setValue({first: 'Nancy', last: 'Drew'});
	         *  console.log(form.value);   // {first: 'Nancy', last: 'Drew'}
	         *
	         *  ```
	         */
	        FormGroup.prototype.setValue = function (value, _a) {
	            var _this = this;
	            var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
	            this._checkAllValuesPresent(value);
	            Object.keys(value).forEach(function (name) {
	                _this._throwIfControlMissing(name);
	                _this.controls[name].setValue(value[name], { onlySelf: true, emitEvent: emitEvent });
	            });
	            this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
	        };
	        /**
	         *  Patches the value of the {@link FormGroup}. It accepts an object with control
	         *  names as keys, and will do its best to match the values to the correct controls
	         *  in the group.
	         *
	         *  It accepts both super-sets and sub-sets of the group without throwing an error.
	         *
	         *  ### Example
	         *
	         *  ```
	         *  const form = new FormGroup({
	         *     first: new FormControl(),
	         *     last: new FormControl()
	         *  });
	         *  console.log(form.value);   // {first: null, last: null}
	         *
	         *  form.patchValue({first: 'Nancy'});
	         *  console.log(form.value);   // {first: 'Nancy', last: null}
	         *
	         *  ```
	         */
	        FormGroup.prototype.patchValue = function (value, _a) {
	            var _this = this;
	            var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
	            Object.keys(value).forEach(function (name) {
	                if (_this.controls[name]) {
	                    _this.controls[name].patchValue(value[name], { onlySelf: true, emitEvent: emitEvent });
	                }
	            });
	            this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
	        };
	        /**
	         * Resets the {@link FormGroup}. This means by default:
	         *
	         * * The group and all descendants are marked `pristine`
	         * * The group and all descendants are marked `untouched`
	         * * The value of all descendants will be null or null maps
	         *
	         * You can also reset to a specific form state by passing in a map of states
	         * that matches the structure of your form, with control names as keys. The state
	         * can be a standalone value or a form state object with both a value and a disabled
	         * status.
	         *
	         * ### Example
	         *
	         * ```ts
	         * this.form.reset({first: 'name', last: 'last name'});
	         *
	         * console.log(this.form.value);  // {first: 'name', last: 'last name'}
	         * ```
	         *
	         * - OR -
	         *
	         * ```
	         * this.form.reset({
	         *   first: {value: 'name', disabled: true},
	         *   last: 'last'
	         * });
	         *
	         * console.log(this.form.value);  // {first: 'name', last: 'last name'}
	         * console.log(this.form.get('first').status);  // 'DISABLED'
	         * ```
	         */
	        FormGroup.prototype.reset = function (value, _a) {
	            if (value === void 0) { value = {}; }
	            var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
	            this._forEachChild(function (control, name) {
	                control.reset(value[name], { onlySelf: true, emitEvent: emitEvent });
	            });
	            this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
	            this._updatePristine({ onlySelf: onlySelf });
	            this._updateTouched({ onlySelf: onlySelf });
	        };
	        /**
	         * The aggregate value of the {@link FormGroup}, including any disabled controls.
	         *
	         * If you'd like to include all values regardless of disabled status, use this method.
	         * Otherwise, the `value` property is the best way to get the value of the group.
	         */
	        FormGroup.prototype.getRawValue = function () {
	            return this._reduceChildren({}, function (acc, control, name) {
	                acc[name] = control.value;
	                return acc;
	            });
	        };
	        /** @internal */
	        FormGroup.prototype._throwIfControlMissing = function (name) {
	            if (!Object.keys(this.controls).length) {
	                throw new Error("\n        There are no form controls registered with this group yet.  If you're using ngModel,\n        you may want to check next tick (e.g. use setTimeout).\n      ");
	            }
	            if (!this.controls[name]) {
	                throw new Error("Cannot find form control with name: " + name + ".");
	            }
	        };
	        /** @internal */
	        FormGroup.prototype._forEachChild = function (cb) {
	            var _this = this;
	            Object.keys(this.controls).forEach(function (k) { return cb(_this.controls[k], k); });
	        };
	        /** @internal */
	        FormGroup.prototype._setUpControls = function () {
	            var _this = this;
	            this._forEachChild(function (control) {
	                control.setParent(_this);
	                control._registerOnCollectionChange(_this._onCollectionChange);
	            });
	        };
	        /** @internal */
	        FormGroup.prototype._updateValue = function () { this._value = this._reduceValue(); };
	        /** @internal */
	        FormGroup.prototype._anyControls = function (condition) {
	            var _this = this;
	            var res = false;
	            this._forEachChild(function (control, name) {
	                res = res || (_this.contains(name) && condition(control));
	            });
	            return res;
	        };
	        /** @internal */
	        FormGroup.prototype._reduceValue = function () {
	            var _this = this;
	            return this._reduceChildren({}, function (acc, control, name) {
	                if (control.enabled || _this.disabled) {
	                    acc[name] = control.value;
	                }
	                return acc;
	            });
	        };
	        /** @internal */
	        FormGroup.prototype._reduceChildren = function (initValue, fn) {
	            var res = initValue;
	            this._forEachChild(function (control, name) { res = fn(res, control, name); });
	            return res;
	        };
	        /** @internal */
	        FormGroup.prototype._allControlsDisabled = function () {
	            for (var _i = 0, _a = Object.keys(this.controls); _i < _a.length; _i++) {
	                var controlName = _a[_i];
	                if (this.controls[controlName].enabled) {
	                    return false;
	                }
	            }
	            return Object.keys(this.controls).length > 0 || this.disabled;
	        };
	        /** @internal */
	        FormGroup.prototype._checkAllValuesPresent = function (value) {
	            this._forEachChild(function (control, name) {
	                if (value[name] === undefined) {
	                    throw new Error("Must supply a value for form control with name: '" + name + "'.");
	                }
	            });
	        };
	        return FormGroup;
	    }(AbstractControl));
	    /**
	     * @whatItDoes Tracks the value and validity state of an array of {@link FormControl}
	     * instances.
	     *
	     * A `FormArray` aggregates the values of each child {@link FormControl} into an array.
	     * It calculates its status by reducing the statuses of its children. For example, if one of
	     * the controls in a `FormArray` is invalid, the entire array becomes invalid.
	     *
	     * `FormArray` is one of the three fundamental building blocks used to define forms in Angular,
	     * along with {@link FormControl} and {@link FormGroup}.
	     *
	     * @howToUse
	     *
	     * When instantiating a {@link FormArray}, pass in an array of child controls as the first
	     * argument.
	     *
	     * ### Example
	     *
	     * ```
	     * const arr = new FormArray([
	     *   new FormControl('Nancy', Validators.minLength(2)),
	     *   new FormControl('Drew'),
	     * ]);
	     *
	     * console.log(arr.value);   // ['Nancy', 'Drew']
	     * console.log(arr.status);  // 'VALID'
	     * ```
	     *
	     * You can also include array-level validators as the second arg, or array-level async
	     * validators as the third arg. These come in handy when you want to perform validation
	     * that considers the value of more than one child control.
	     *
	     * ### Adding or removing controls
	     *
	     * To change the controls in the array, use the `push`, `insert`, or `removeAt` methods
	     * in `FormArray` itself. These methods ensure the controls are properly tracked in the
	     * form's hierarchy. Do not modify the array of `AbstractControl`s used to instantiate
	     * the `FormArray` directly, as that will result in strange and unexpected behavior such
	     * as broken change detection.
	     *
	     * * **npm package**: `@angular/forms`
	     *
	     * @stable
	     */
	    var FormArray = (function (_super) {
	        __extends$6(FormArray, _super);
	        function FormArray(controls, validator, asyncValidator) {
	            if (validator === void 0) { validator = null; }
	            if (asyncValidator === void 0) { asyncValidator = null; }
	            _super.call(this, validator, asyncValidator);
	            this.controls = controls;
	            this._initObservables();
	            this._setUpControls();
	            this.updateValueAndValidity({ onlySelf: true, emitEvent: false });
	        }
	        /**
	         * Get the {@link AbstractControl} at the given `index` in the array.
	         */
	        FormArray.prototype.at = function (index) { return this.controls[index]; };
	        /**
	         * Insert a new {@link AbstractControl} at the end of the array.
	         */
	        FormArray.prototype.push = function (control) {
	            this.controls.push(control);
	            this._registerControl(control);
	            this.updateValueAndValidity();
	            this._onCollectionChange();
	        };
	        /**
	         * Insert a new {@link AbstractControl} at the given `index` in the array.
	         */
	        FormArray.prototype.insert = function (index, control) {
	            this.controls.splice(index, 0, control);
	            this._registerControl(control);
	            this.updateValueAndValidity();
	            this._onCollectionChange();
	        };
	        /**
	         * Remove the control at the given `index` in the array.
	         */
	        FormArray.prototype.removeAt = function (index) {
	            if (this.controls[index])
	                this.controls[index]._registerOnCollectionChange(function () { });
	            this.controls.splice(index, 1);
	            this.updateValueAndValidity();
	            this._onCollectionChange();
	        };
	        /**
	         * Replace an existing control.
	         */
	        FormArray.prototype.setControl = function (index, control) {
	            if (this.controls[index])
	                this.controls[index]._registerOnCollectionChange(function () { });
	            this.controls.splice(index, 1);
	            if (control) {
	                this.controls.splice(index, 0, control);
	                this._registerControl(control);
	            }
	            this.updateValueAndValidity();
	            this._onCollectionChange();
	        };
	        Object.defineProperty(FormArray.prototype, "length", {
	            /**
	             * Length of the control array.
	             */
	            get: function () { return this.controls.length; },
	            enumerable: true,
	            configurable: true
	        });
	        /**
	         *  Sets the value of the {@link FormArray}. It accepts an array that matches
	         *  the structure of the control.
	         *
	         * This method performs strict checks, so it will throw an error if you try
	         * to set the value of a control that doesn't exist or if you exclude the
	         * value of a control.
	         *
	         *  ### Example
	         *
	         *  ```
	         *  const arr = new FormArray([
	         *     new FormControl(),
	         *     new FormControl()
	         *  ]);
	         *  console.log(arr.value);   // [null, null]
	         *
	         *  arr.setValue(['Nancy', 'Drew']);
	         *  console.log(arr.value);   // ['Nancy', 'Drew']
	         *  ```
	         */
	        FormArray.prototype.setValue = function (value, _a) {
	            var _this = this;
	            var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
	            this._checkAllValuesPresent(value);
	            value.forEach(function (newValue, index) {
	                _this._throwIfControlMissing(index);
	                _this.at(index).setValue(newValue, { onlySelf: true, emitEvent: emitEvent });
	            });
	            this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
	        };
	        /**
	         *  Patches the value of the {@link FormArray}. It accepts an array that matches the
	         *  structure of the control, and will do its best to match the values to the correct
	         *  controls in the group.
	         *
	         *  It accepts both super-sets and sub-sets of the array without throwing an error.
	         *
	         *  ### Example
	         *
	         *  ```
	         *  const arr = new FormArray([
	         *     new FormControl(),
	         *     new FormControl()
	         *  ]);
	         *  console.log(arr.value);   // [null, null]
	         *
	         *  arr.patchValue(['Nancy']);
	         *  console.log(arr.value);   // ['Nancy', null]
	         *  ```
	         */
	        FormArray.prototype.patchValue = function (value, _a) {
	            var _this = this;
	            var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
	            value.forEach(function (newValue, index) {
	                if (_this.at(index)) {
	                    _this.at(index).patchValue(newValue, { onlySelf: true, emitEvent: emitEvent });
	                }
	            });
	            this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
	        };
	        /**
	         * Resets the {@link FormArray}. This means by default:
	         *
	         * * The array and all descendants are marked `pristine`
	         * * The array and all descendants are marked `untouched`
	         * * The value of all descendants will be null or null maps
	         *
	         * You can also reset to a specific form state by passing in an array of states
	         * that matches the structure of the control. The state can be a standalone value
	         * or a form state object with both a value and a disabled status.
	         *
	         * ### Example
	         *
	         * ```ts
	         * this.arr.reset(['name', 'last name']);
	         *
	         * console.log(this.arr.value);  // ['name', 'last name']
	         * ```
	         *
	         * - OR -
	         *
	         * ```
	         * this.arr.reset([
	         *   {value: 'name', disabled: true},
	         *   'last'
	         * ]);
	         *
	         * console.log(this.arr.value);  // ['name', 'last name']
	         * console.log(this.arr.get(0).status);  // 'DISABLED'
	         * ```
	         */
	        FormArray.prototype.reset = function (value, _a) {
	            if (value === void 0) { value = []; }
	            var _b = _a === void 0 ? {} : _a, onlySelf = _b.onlySelf, emitEvent = _b.emitEvent;
	            this._forEachChild(function (control, index) {
	                control.reset(value[index], { onlySelf: true, emitEvent: emitEvent });
	            });
	            this.updateValueAndValidity({ onlySelf: onlySelf, emitEvent: emitEvent });
	            this._updatePristine({ onlySelf: onlySelf });
	            this._updateTouched({ onlySelf: onlySelf });
	        };
	        /**
	         * The aggregate value of the array, including any disabled controls.
	         *
	         * If you'd like to include all values regardless of disabled status, use this method.
	         * Otherwise, the `value` property is the best way to get the value of the array.
	         */
	        FormArray.prototype.getRawValue = function () { return this.controls.map(function (control) { return control.value; }); };
	        /** @internal */
	        FormArray.prototype._throwIfControlMissing = function (index) {
	            if (!this.controls.length) {
	                throw new Error("\n        There are no form controls registered with this array yet.  If you're using ngModel,\n        you may want to check next tick (e.g. use setTimeout).\n      ");
	            }
	            if (!this.at(index)) {
	                throw new Error("Cannot find form control at index " + index);
	            }
	        };
	        /** @internal */
	        FormArray.prototype._forEachChild = function (cb) {
	            this.controls.forEach(function (control, index) { cb(control, index); });
	        };
	        /** @internal */
	        FormArray.prototype._updateValue = function () {
	            var _this = this;
	            this._value = this.controls.filter(function (control) { return control.enabled || _this.disabled; })
	                .map(function (control) { return control.value; });
	        };
	        /** @internal */
	        FormArray.prototype._anyControls = function (condition) {
	            return this.controls.some(function (control) { return control.enabled && condition(control); });
	        };
	        /** @internal */
	        FormArray.prototype._setUpControls = function () {
	            var _this = this;
	            this._forEachChild(function (control) { return _this._registerControl(control); });
	        };
	        /** @internal */
	        FormArray.prototype._checkAllValuesPresent = function (value) {
	            this._forEachChild(function (control, i) {
	                if (value[i] === undefined) {
	                    throw new Error("Must supply a value for form control at index: " + i + ".");
	                }
	            });
	        };
	        /** @internal */
	        FormArray.prototype._allControlsDisabled = function () {
	            for (var _i = 0, _a = this.controls; _i < _a.length; _i++) {
	                var control = _a[_i];
	                if (control.enabled)
	                    return false;
	            }
	            return this.controls.length > 0 || this.disabled;
	        };
	        FormArray.prototype._registerControl = function (control) {
	            control.setParent(this);
	            control._registerOnCollectionChange(this._onCollectionChange);
	        };
	        return FormArray;
	    }(AbstractControl));
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$4 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    var formDirectiveProvider = {
	        provide: ControlContainer,
	        useExisting: _angular_core.forwardRef(function () { return NgForm; })
	    };
	    var resolvedPromise = Promise.resolve(null);
	    /**
	     * @whatItDoes Creates a top-level {@link FormGroup} instance and binds it to a form
	     * to track aggregate form value and validation status.
	     *
	     * @howToUse
	     *
	     * As soon as you import the `FormsModule`, this directive becomes active by default on
	     * all `<form>` tags.  You don't need to add a special selector.
	     *
	     * You can export the directive into a local template variable using `ngForm` as the key
	     * (ex: `#myForm="ngForm"`). This is optional, but useful.  Many properties from the underlying
	     * {@link FormGroup} instance are duplicated on the directive itself, so a reference to it
	     * will give you access to the aggregate value and validity status of the form, as well as
	     * user interaction properties like `dirty` and `touched`.
	     *
	     * To register child controls with the form, you'll want to use {@link NgModel} with a
	     * `name` attribute.  You can also use {@link NgModelGroup} if you'd like to create
	     * sub-groups within the form.
	     *
	     * You can listen to the directive's `ngSubmit` event to be notified when the user has
	     * triggered a form submission. The `ngSubmit` event will be emitted with the original form
	     * submission event.
	     *
	     * {@example forms/ts/simpleForm/simple_form_example.ts region='Component'}
	     *
	     * * **npm package**: `@angular/forms`
	     *
	     * * **NgModule**: `FormsModule`
	     *
	     *  @stable
	     */
	    var NgForm = (function (_super) {
	        __extends$4(NgForm, _super);
	        function NgForm(validators, asyncValidators) {
	            _super.call(this);
	            this._submitted = false;
	            this.ngSubmit = new EventEmitter();
	            this.form =
	                new FormGroup({}, composeValidators(validators), composeAsyncValidators(asyncValidators));
	        }
	        Object.defineProperty(NgForm.prototype, "submitted", {
	            get: function () { return this._submitted; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(NgForm.prototype, "formDirective", {
	            get: function () { return this; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(NgForm.prototype, "control", {
	            get: function () { return this.form; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(NgForm.prototype, "path", {
	            get: function () { return []; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(NgForm.prototype, "controls", {
	            get: function () { return this.form.controls; },
	            enumerable: true,
	            configurable: true
	        });
	        NgForm.prototype.addControl = function (dir) {
	            var _this = this;
	            resolvedPromise.then(function () {
	                var container = _this._findContainer(dir.path);
	                dir._control = container.registerControl(dir.name, dir.control);
	                setUpControl(dir.control, dir);
	                dir.control.updateValueAndValidity({ emitEvent: false });
	            });
	        };
	        NgForm.prototype.getControl = function (dir) { return this.form.get(dir.path); };
	        NgForm.prototype.removeControl = function (dir) {
	            var _this = this;
	            resolvedPromise.then(function () {
	                var container = _this._findContainer(dir.path);
	                if (container) {
	                    container.removeControl(dir.name);
	                }
	            });
	        };
	        NgForm.prototype.addFormGroup = function (dir) {
	            var _this = this;
	            resolvedPromise.then(function () {
	                var container = _this._findContainer(dir.path);
	                var group = new FormGroup({});
	                setUpFormContainer(group, dir);
	                container.registerControl(dir.name, group);
	                group.updateValueAndValidity({ emitEvent: false });
	            });
	        };
	        NgForm.prototype.removeFormGroup = function (dir) {
	            var _this = this;
	            resolvedPromise.then(function () {
	                var container = _this._findContainer(dir.path);
	                if (container) {
	                    container.removeControl(dir.name);
	                }
	            });
	        };
	        NgForm.prototype.getFormGroup = function (dir) { return this.form.get(dir.path); };
	        NgForm.prototype.updateModel = function (dir, value) {
	            var _this = this;
	            resolvedPromise.then(function () {
	                var ctrl = _this.form.get(dir.path);
	                ctrl.setValue(value);
	            });
	        };
	        NgForm.prototype.setValue = function (value) { this.control.setValue(value); };
	        NgForm.prototype.onSubmit = function ($event) {
	            this._submitted = true;
	            this.ngSubmit.emit($event);
	            return false;
	        };
	        NgForm.prototype.onReset = function () { this.resetForm(); };
	        NgForm.prototype.resetForm = function (value) {
	            if (value === void 0) { value = undefined; }
	            this.form.reset(value);
	            this._submitted = false;
	        };
	        /** @internal */
	        NgForm.prototype._findContainer = function (path) {
	            path.pop();
	            return path.length ? this.form.get(path) : this.form;
	        };
	        NgForm.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: 'form:not([ngNoForm]):not([formGroup]),ngForm,[ngForm]',
	                        providers: [formDirectiveProvider],
	                        host: { '(submit)': 'onSubmit($event)', '(reset)': 'onReset()' },
	                        outputs: ['ngSubmit'],
	                        exportAs: 'ngForm'
	                    },] },
	        ];
	        /** @nocollapse */
	        NgForm.ctorParameters = [
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALIDATORS,] },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_ASYNC_VALIDATORS,] },] },
	        ];
	        return NgForm;
	    }(ControlContainer));
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var Examples = {
	        formControlName: "\n    <div [formGroup]=\"myGroup\">\n      <input formControlName=\"firstName\">\n    </div>\n\n    In your class:\n\n    this.myGroup = new FormGroup({\n       firstName: new FormControl()\n    });",
	        formGroupName: "\n    <div [formGroup]=\"myGroup\">\n       <div formGroupName=\"person\">\n          <input formControlName=\"firstName\">\n       </div>\n    </div>\n\n    In your class:\n\n    this.myGroup = new FormGroup({\n       person: new FormGroup({ firstName: new FormControl() })\n    });",
	        formArrayName: "\n    <div [formGroup]=\"myGroup\">\n      <div formArrayName=\"cities\">\n        <div *ngFor=\"let city of cityArray.controls; let i=index\">\n          <input [formControlName]=\"i\">\n        </div>\n      </div>\n    </div>\n\n    In your class:\n\n    this.cityArray = new FormArray([new FormControl('SF')]);\n    this.myGroup = new FormGroup({\n      cities: this.cityArray\n    });",
	        ngModelGroup: "\n    <form>\n       <div ngModelGroup=\"person\">\n          <input [(ngModel)]=\"person.name\" name=\"firstName\">\n       </div>\n    </form>",
	        ngModelWithFormGroup: "\n    <div [formGroup]=\"myGroup\">\n       <input formControlName=\"firstName\">\n       <input [(ngModel)]=\"showMoreControls\" [ngModelOptions]=\"{standalone: true}\">\n    </div>\n  "
	    };
	
	    var TemplateDrivenErrors = (function () {
	        function TemplateDrivenErrors() {
	        }
	        TemplateDrivenErrors.modelParentException = function () {
	            throw new Error("\n      ngModel cannot be used to register form controls with a parent formGroup directive.  Try using\n      formGroup's partner directive \"formControlName\" instead.  Example:\n\n      " + Examples.formControlName + "\n\n      Or, if you'd like to avoid registering this form control, indicate that it's standalone in ngModelOptions:\n\n      Example:\n\n      " + Examples.ngModelWithFormGroup);
	        };
	        TemplateDrivenErrors.formGroupNameException = function () {
	            throw new Error("\n      ngModel cannot be used to register form controls with a parent formGroupName or formArrayName directive.\n\n      Option 1: Use formControlName instead of ngModel (reactive strategy):\n\n      " + Examples.formGroupName + "\n\n      Option 2:  Update ngModel's parent be ngModelGroup (template-driven strategy):\n\n      " + Examples.ngModelGroup);
	        };
	        TemplateDrivenErrors.missingNameException = function () {
	            throw new Error("If ngModel is used within a form tag, either the name attribute must be set or the form\n      control must be defined as 'standalone' in ngModelOptions.\n\n      Example 1: <input [(ngModel)]=\"person.firstName\" name=\"first\">\n      Example 2: <input [(ngModel)]=\"person.firstName\" [ngModelOptions]=\"{standalone: true}\">");
	        };
	        TemplateDrivenErrors.modelGroupParentException = function () {
	            throw new Error("\n      ngModelGroup cannot be used with a parent formGroup directive.\n\n      Option 1: Use formGroupName instead of ngModelGroup (reactive strategy):\n\n      " + Examples.formGroupName + "\n\n      Option 2:  Use a regular form tag instead of the formGroup directive (template-driven strategy):\n\n      " + Examples.ngModelGroup);
	        };
	        return TemplateDrivenErrors;
	    }());
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$8 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    var modelGroupProvider = {
	        provide: ControlContainer,
	        useExisting: _angular_core.forwardRef(function () { return NgModelGroup; })
	    };
	    /**
	     * @whatItDoes Creates and binds a {@link FormGroup} instance to a DOM element.
	     *
	     * @howToUse
	     *
	     * This directive can only be used as a child of {@link NgForm} (or in other words,
	     * within `<form>` tags).
	     *
	     * Use this directive if you'd like to create a sub-group within a form. This can
	     * come in handy if you want to validate a sub-group of your form separately from
	     * the rest of your form, or if some values in your domain model make more sense to
	     * consume together in a nested object.
	     *
	     * Pass in the name you'd like this sub-group to have and it will become the key
	     * for the sub-group in the form's full value. You can also export the directive into
	     * a local template variable using `ngModelGroup` (ex: `#myGroup="ngModelGroup"`).
	     *
	     * {@example forms/ts/ngModelGroup/ng_model_group_example.ts region='Component'}
	     *
	     * * **npm package**: `@angular/forms`
	     *
	     * * **NgModule**: `FormsModule`
	     *
	     * @stable
	     */
	    var NgModelGroup = (function (_super) {
	        __extends$8(NgModelGroup, _super);
	        function NgModelGroup(parent, validators, asyncValidators) {
	            _super.call(this);
	            this._parent = parent;
	            this._validators = validators;
	            this._asyncValidators = asyncValidators;
	        }
	        /** @internal */
	        NgModelGroup.prototype._checkParentType = function () {
	            if (!(this._parent instanceof NgModelGroup) && !(this._parent instanceof NgForm)) {
	                TemplateDrivenErrors.modelGroupParentException();
	            }
	        };
	        NgModelGroup.decorators = [
	            { type: _angular_core.Directive, args: [{ selector: '[ngModelGroup]', providers: [modelGroupProvider], exportAs: 'ngModelGroup' },] },
	        ];
	        /** @nocollapse */
	        NgModelGroup.ctorParameters = [
	            { type: ControlContainer, decorators: [{ type: _angular_core.Host }, { type: _angular_core.SkipSelf },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALIDATORS,] },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_ASYNC_VALIDATORS,] },] },
	        ];
	        NgModelGroup.propDecorators = {
	            'name': [{ type: _angular_core.Input, args: ['ngModelGroup',] },],
	        };
	        return NgModelGroup;
	    }(AbstractFormGroupDirective));
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$7 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    var formControlBinding = {
	        provide: NgControl,
	        useExisting: _angular_core.forwardRef(function () { return NgModel; })
	    };
	    /**
	     * `ngModel` forces an additional change detection run when its inputs change:
	     * E.g.:
	     * ```
	     * <div>{{myModel.valid}}</div>
	     * <input [(ngModel)]="myValue" #myModel="ngModel">
	     * ```
	     * I.e. `ngModel` can export itself on the element and then be used in the template.
	     * Normally, this would result in expressions before the `input` that use the exported directive
	     * to have and old value as they have been
	     * dirty checked before. As this is a very common case for `ngModel`, we added this second change
	     * detection run.
	     *
	     * Notes:
	     * - this is just one extra run no matter how many `ngModel` have been changed.
	     * - this is a general problem when using `exportAs` for directives!
	     */
	    var resolvedPromise$1 = Promise.resolve(null);
	    /**
	     * @whatItDoes Creates a {@link FormControl} instance from a domain model and binds it
	     * to a form control element.
	     *
	     * The {@link FormControl} instance will track the value, user interaction, and
	     * validation status of the control and keep the view synced with the model. If used
	     * within a parent form, the directive will also register itself with the form as a child
	     * control.
	     *
	     * @howToUse
	     *
	     * This directive can be used by itself or as part of a larger form. All you need is the
	     * `ngModel` selector to activate it.
	     *
	     * It accepts a domain model as an optional {@link @Input}. If you have a one-way binding
	     * to `ngModel` with `[]` syntax, changing the value of the domain model in the component
	     * class will set the value in the view. If you have a two-way binding with `[()]` syntax
	     * (also known as 'banana-box syntax'), the value in the UI will always be synced back to
	     * the domain model in your class as well.
	     *
	     * If you wish to inspect the properties of the associated {@link FormControl} (like
	     * validity state), you can also export the directive into a local template variable using
	     * `ngModel` as the key (ex: `#myVar="ngModel"`). You can then access the control using the
	     * directive's `control` property, but most properties you'll need (like `valid` and `dirty`)
	     * will fall through to the control anyway, so you can access them directly. You can see a
	     * full list of properties directly available in {@link AbstractControlDirective}.
	     *
	     * The following is an example of a simple standalone control using `ngModel`:
	     *
	     * {@example forms/ts/simpleNgModel/simple_ng_model_example.ts region='Component'}
	     *
	     * When using the `ngModel` within `<form>` tags, you'll also need to supply a `name` attribute
	     * so that the control can be registered with the parent form under that name.
	     *
	     * It's worth noting that in the context of a parent form, you often can skip one-way or
	     * two-way binding because the parent form will sync the value for you. You can access
	     * its properties by exporting it into a local template variable using `ngForm` (ex:
	     * `#f="ngForm"`). Then you can pass it where it needs to go on submit.
	     *
	     * If you do need to populate initial values into your form, using a one-way binding for
	     * `ngModel` tends to be sufficient as long as you use the exported form's value rather
	     * than the domain model's value on submit.
	     *
	     * Take a look at an example of using `ngModel` within a form:
	     *
	     * {@example forms/ts/simpleForm/simple_form_example.ts region='Component'}
	     *
	     * To see `ngModel` examples with different form control types, see:
	     *
	     * * Radio buttons: {@link RadioControlValueAccessor}
	     * * Selects: {@link SelectControlValueAccessor}
	     *
	     * **npm package**: `@angular/forms`
	     *
	     * **NgModule**: `FormsModule`
	     *
	     *  @stable
	     */
	    var NgModel = (function (_super) {
	        __extends$7(NgModel, _super);
	        function NgModel(parent, validators, asyncValidators, valueAccessors) {
	            _super.call(this);
	            /** @internal */
	            this._control = new FormControl();
	            /** @internal */
	            this._registered = false;
	            this.update = new EventEmitter();
	            this._parent = parent;
	            this._rawValidators = validators || [];
	            this._rawAsyncValidators = asyncValidators || [];
	            this.valueAccessor = selectValueAccessor(this, valueAccessors);
	        }
	        NgModel.prototype.ngOnChanges = function (changes) {
	            this._checkForErrors();
	            if (!this._registered)
	                this._setUpControl();
	            if ('isDisabled' in changes) {
	                this._updateDisabled(changes);
	            }
	            if (isPropertyUpdated(changes, this.viewModel)) {
	                this._updateValue(this.model);
	                this.viewModel = this.model;
	            }
	        };
	        NgModel.prototype.ngOnDestroy = function () { this.formDirective && this.formDirective.removeControl(this); };
	        Object.defineProperty(NgModel.prototype, "control", {
	            get: function () { return this._control; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(NgModel.prototype, "path", {
	            get: function () {
	                return this._parent ? controlPath(this.name, this._parent) : [this.name];
	            },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(NgModel.prototype, "formDirective", {
	            get: function () { return this._parent ? this._parent.formDirective : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(NgModel.prototype, "validator", {
	            get: function () { return composeValidators(this._rawValidators); },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(NgModel.prototype, "asyncValidator", {
	            get: function () {
	                return composeAsyncValidators(this._rawAsyncValidators);
	            },
	            enumerable: true,
	            configurable: true
	        });
	        NgModel.prototype.viewToModelUpdate = function (newValue) {
	            this.viewModel = newValue;
	            this.update.emit(newValue);
	        };
	        NgModel.prototype._setUpControl = function () {
	            this._isStandalone() ? this._setUpStandalone() :
	                this.formDirective.addControl(this);
	            this._registered = true;
	        };
	        NgModel.prototype._isStandalone = function () {
	            return !this._parent || (this.options && this.options.standalone);
	        };
	        NgModel.prototype._setUpStandalone = function () {
	            setUpControl(this._control, this);
	            this._control.updateValueAndValidity({ emitEvent: false });
	        };
	        NgModel.prototype._checkForErrors = function () {
	            if (!this._isStandalone()) {
	                this._checkParentType();
	            }
	            this._checkName();
	        };
	        NgModel.prototype._checkParentType = function () {
	            if (!(this._parent instanceof NgModelGroup) &&
	                this._parent instanceof AbstractFormGroupDirective) {
	                TemplateDrivenErrors.formGroupNameException();
	            }
	            else if (!(this._parent instanceof NgModelGroup) && !(this._parent instanceof NgForm)) {
	                TemplateDrivenErrors.modelParentException();
	            }
	        };
	        NgModel.prototype._checkName = function () {
	            if (this.options && this.options.name)
	                this.name = this.options.name;
	            if (!this._isStandalone() && !this.name) {
	                TemplateDrivenErrors.missingNameException();
	            }
	        };
	        NgModel.prototype._updateValue = function (value) {
	            var _this = this;
	            resolvedPromise$1.then(function () { _this.control.setValue(value, { emitViewToModelChange: false }); });
	        };
	        NgModel.prototype._updateDisabled = function (changes) {
	            var _this = this;
	            var disabledValue = changes['isDisabled'].currentValue;
	            var isDisabled = disabledValue === '' || (disabledValue && disabledValue !== 'false');
	            resolvedPromise$1.then(function () {
	                if (isDisabled && !_this.control.disabled) {
	                    _this.control.disable();
	                }
	                else if (!isDisabled && _this.control.disabled) {
	                    _this.control.enable();
	                }
	            });
	        };
	        NgModel.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: '[ngModel]:not([formControlName]):not([formControl])',
	                        providers: [formControlBinding],
	                        exportAs: 'ngModel'
	                    },] },
	        ];
	        /** @nocollapse */
	        NgModel.ctorParameters = [
	            { type: ControlContainer, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Host },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALIDATORS,] },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_ASYNC_VALIDATORS,] },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALUE_ACCESSOR,] },] },
	        ];
	        NgModel.propDecorators = {
	            'name': [{ type: _angular_core.Input },],
	            'isDisabled': [{ type: _angular_core.Input, args: ['disabled',] },],
	            'model': [{ type: _angular_core.Input, args: ['ngModel',] },],
	            'options': [{ type: _angular_core.Input, args: ['ngModelOptions',] },],
	            'update': [{ type: _angular_core.Output, args: ['ngModelChange',] },],
	        };
	        return NgModel;
	    }(NgControl));
	
	    var ReactiveErrors = (function () {
	        function ReactiveErrors() {
	        }
	        ReactiveErrors.controlParentException = function () {
	            throw new Error("formControlName must be used with a parent formGroup directive.  You'll want to add a formGroup\n       directive and pass it an existing FormGroup instance (you can create one in your class).\n\n      Example:\n\n      " + Examples.formControlName);
	        };
	        ReactiveErrors.ngModelGroupException = function () {
	            throw new Error("formControlName cannot be used with an ngModelGroup parent. It is only compatible with parents\n       that also have a \"form\" prefix: formGroupName, formArrayName, or formGroup.\n\n       Option 1:  Update the parent to be formGroupName (reactive form strategy)\n\n        " + Examples.formGroupName + "\n\n        Option 2: Use ngModel instead of formControlName (template-driven strategy)\n\n        " + Examples.ngModelGroup);
	        };
	        ReactiveErrors.missingFormException = function () {
	            throw new Error("formGroup expects a FormGroup instance. Please pass one in.\n\n       Example:\n\n       " + Examples.formControlName);
	        };
	        ReactiveErrors.groupParentException = function () {
	            throw new Error("formGroupName must be used with a parent formGroup directive.  You'll want to add a formGroup\n      directive and pass it an existing FormGroup instance (you can create one in your class).\n\n      Example:\n\n      " + Examples.formGroupName);
	        };
	        ReactiveErrors.arrayParentException = function () {
	            throw new Error("formArrayName must be used with a parent formGroup directive.  You'll want to add a formGroup\n       directive and pass it an existing FormGroup instance (you can create one in your class).\n\n        Example:\n\n        " + Examples.formArrayName);
	        };
	        ReactiveErrors.disabledAttrWarning = function () {
	            console.warn("\n      It looks like you're using the disabled attribute with a reactive form directive. If you set disabled to true\n      when you set up this control in your component class, the disabled attribute will actually be set in the DOM for\n      you. We recommend using this approach to avoid 'changed after checked' errors.\n       \n      Example: \n      form = new FormGroup({\n        first: new FormControl({value: 'Nancy', disabled: true}, Validators.required),\n        last: new FormControl('Drew', Validators.required)\n      });\n    ");
	        };
	        return ReactiveErrors;
	    }());
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$9 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    var formControlBinding$1 = {
	        provide: NgControl,
	        useExisting: _angular_core.forwardRef(function () { return FormControlDirective; })
	    };
	    /**
	     * @whatItDoes Syncs a standalone {@link FormControl} instance to a form control element.
	     *
	     * In other words, this directive ensures that any values written to the {@link FormControl}
	     * instance programmatically will be written to the DOM element (model -> view). Conversely,
	     * any values written to the DOM element through user input will be reflected in the
	     * {@link FormControl} instance (view -> model).
	     *
	     * @howToUse
	     *
	     * Use this directive if you'd like to create and manage a {@link FormControl} instance directly.
	     * Simply create a {@link FormControl}, save it to your component class, and pass it into the
	     * {@link FormControlDirective}.
	     *
	     * This directive is designed to be used as a standalone control.  Unlike {@link FormControlName},
	     * it does not require that your {@link FormControl} instance be part of any parent
	     * {@link FormGroup}, and it won't be registered to any {@link FormGroupDirective} that
	     * exists above it.
	     *
	     * **Get the value**: the `value` property is always synced and available on the
	     * {@link FormControl} instance. See a full list of available properties in
	     * {@link AbstractControl}.
	     *
	     * **Set the value**: You can pass in an initial value when instantiating the {@link FormControl},
	     * or you can set it programmatically later using {@link AbstractControl.setValue} or
	     * {@link AbstractControl.patchValue}.
	     *
	     * **Listen to value**: If you want to listen to changes in the value of the control, you can
	     * subscribe to the {@link AbstractControl.valueChanges} event.  You can also listen to
	     * {@link AbstractControl.statusChanges} to be notified when the validation status is
	     * re-calculated.
	     *
	     * ### Example
	     *
	     * {@example forms/ts/simpleFormControl/simple_form_control_example.ts region='Component'}
	     *
	     * * **npm package**: `@angular/forms`
	     *
	     * * **NgModule**: `ReactiveFormsModule`
	     *
	     *  @stable
	     */
	    var FormControlDirective = (function (_super) {
	        __extends$9(FormControlDirective, _super);
	        function FormControlDirective(validators, asyncValidators, valueAccessors) {
	            _super.call(this);
	            this.update = new EventEmitter();
	            this._rawValidators = validators || [];
	            this._rawAsyncValidators = asyncValidators || [];
	            this.valueAccessor = selectValueAccessor(this, valueAccessors);
	        }
	        Object.defineProperty(FormControlDirective.prototype, "isDisabled", {
	            set: function (isDisabled) { ReactiveErrors.disabledAttrWarning(); },
	            enumerable: true,
	            configurable: true
	        });
	        FormControlDirective.prototype.ngOnChanges = function (changes) {
	            if (this._isControlChanged(changes)) {
	                setUpControl(this.form, this);
	                if (this.control.disabled && this.valueAccessor.setDisabledState) {
	                    this.valueAccessor.setDisabledState(true);
	                }
	                this.form.updateValueAndValidity({ emitEvent: false });
	            }
	            if (isPropertyUpdated(changes, this.viewModel)) {
	                this.form.setValue(this.model);
	                this.viewModel = this.model;
	            }
	        };
	        Object.defineProperty(FormControlDirective.prototype, "path", {
	            get: function () { return []; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormControlDirective.prototype, "validator", {
	            get: function () { return composeValidators(this._rawValidators); },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormControlDirective.prototype, "asyncValidator", {
	            get: function () {
	                return composeAsyncValidators(this._rawAsyncValidators);
	            },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormControlDirective.prototype, "control", {
	            get: function () { return this.form; },
	            enumerable: true,
	            configurable: true
	        });
	        FormControlDirective.prototype.viewToModelUpdate = function (newValue) {
	            this.viewModel = newValue;
	            this.update.emit(newValue);
	        };
	        FormControlDirective.prototype._isControlChanged = function (changes) {
	            return changes.hasOwnProperty('form');
	        };
	        FormControlDirective.decorators = [
	            { type: _angular_core.Directive, args: [{ selector: '[formControl]', providers: [formControlBinding$1], exportAs: 'ngForm' },] },
	        ];
	        /** @nocollapse */
	        FormControlDirective.ctorParameters = [
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALIDATORS,] },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_ASYNC_VALIDATORS,] },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALUE_ACCESSOR,] },] },
	        ];
	        FormControlDirective.propDecorators = {
	            'form': [{ type: _angular_core.Input, args: ['formControl',] },],
	            'model': [{ type: _angular_core.Input, args: ['ngModel',] },],
	            'update': [{ type: _angular_core.Output, args: ['ngModelChange',] },],
	            'isDisabled': [{ type: _angular_core.Input, args: ['disabled',] },],
	        };
	        return FormControlDirective;
	    }(NgControl));
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$11 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    var formDirectiveProvider$1 = {
	        provide: ControlContainer,
	        useExisting: _angular_core.forwardRef(function () { return FormGroupDirective; })
	    };
	    /**
	     * @whatItDoes Binds an existing {@link FormGroup} to a DOM element.
	     *
	     * @howToUse
	     *
	     * This directive accepts an existing {@link FormGroup} instance. It will then use this
	     * {@link FormGroup} instance to match any child {@link FormControl}, {@link FormGroup},
	     * and {@link FormArray} instances to child {@link FormControlName}, {@link FormGroupName},
	     * and {@link FormArrayName} directives.
	     *
	     * **Set value**: You can set the form's initial value when instantiating the
	     * {@link FormGroup}, or you can set it programmatically later using the {@link FormGroup}'s
	     * {@link AbstractControl.setValue} or {@link AbstractControl.patchValue} methods.
	     *
	     * **Listen to value**: If you want to listen to changes in the value of the form, you can subscribe
	     * to the {@link FormGroup}'s {@link AbstractControl.valueChanges} event.  You can also listen to
	     * its {@link AbstractControl.statusChanges} event to be notified when the validation status is
	     * re-calculated.
	     *
	     * Furthermore, you can listen to the directive's `ngSubmit` event to be notified when the user has
	     * triggered a form submission. The `ngSubmit` event will be emitted with the original form
	     * submission event.
	     *
	     * ### Example
	     *
	     * In this example, we create form controls for first name and last name.
	     *
	     * {@example forms/ts/simpleFormGroup/simple_form_group_example.ts region='Component'}
	     *
	     * **npm package**: `@angular/forms`
	     *
	     * **NgModule**: {@link ReactiveFormsModule}
	     *
	     *  @stable
	     */
	    var FormGroupDirective = (function (_super) {
	        __extends$11(FormGroupDirective, _super);
	        function FormGroupDirective(_validators, _asyncValidators) {
	            _super.call(this);
	            this._validators = _validators;
	            this._asyncValidators = _asyncValidators;
	            this._submitted = false;
	            this.directives = [];
	            this.form = null;
	            this.ngSubmit = new EventEmitter();
	        }
	        FormGroupDirective.prototype.ngOnChanges = function (changes) {
	            this._checkFormPresent();
	            if (changes.hasOwnProperty('form')) {
	                this._updateValidators();
	                this._updateDomValue();
	                this._updateRegistrations();
	            }
	        };
	        Object.defineProperty(FormGroupDirective.prototype, "submitted", {
	            get: function () { return this._submitted; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormGroupDirective.prototype, "formDirective", {
	            get: function () { return this; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormGroupDirective.prototype, "control", {
	            get: function () { return this.form; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormGroupDirective.prototype, "path", {
	            get: function () { return []; },
	            enumerable: true,
	            configurable: true
	        });
	        FormGroupDirective.prototype.addControl = function (dir) {
	            var ctrl = this.form.get(dir.path);
	            setUpControl(ctrl, dir);
	            ctrl.updateValueAndValidity({ emitEvent: false });
	            this.directives.push(dir);
	            return ctrl;
	        };
	        FormGroupDirective.prototype.getControl = function (dir) { return this.form.get(dir.path); };
	        FormGroupDirective.prototype.removeControl = function (dir) { ListWrapper.remove(this.directives, dir); };
	        FormGroupDirective.prototype.addFormGroup = function (dir) {
	            var ctrl = this.form.get(dir.path);
	            setUpFormContainer(ctrl, dir);
	            ctrl.updateValueAndValidity({ emitEvent: false });
	        };
	        FormGroupDirective.prototype.removeFormGroup = function (dir) { };
	        FormGroupDirective.prototype.getFormGroup = function (dir) { return this.form.get(dir.path); };
	        FormGroupDirective.prototype.addFormArray = function (dir) {
	            var ctrl = this.form.get(dir.path);
	            setUpFormContainer(ctrl, dir);
	            ctrl.updateValueAndValidity({ emitEvent: false });
	        };
	        FormGroupDirective.prototype.removeFormArray = function (dir) { };
	        FormGroupDirective.prototype.getFormArray = function (dir) { return this.form.get(dir.path); };
	        FormGroupDirective.prototype.updateModel = function (dir, value) {
	            var ctrl = this.form.get(dir.path);
	            ctrl.setValue(value);
	        };
	        FormGroupDirective.prototype.onSubmit = function ($event) {
	            this._submitted = true;
	            this.ngSubmit.emit($event);
	            return false;
	        };
	        FormGroupDirective.prototype.onReset = function () { this.resetForm(); };
	        FormGroupDirective.prototype.resetForm = function (value) {
	            if (value === void 0) { value = undefined; }
	            this.form.reset(value);
	            this._submitted = false;
	        };
	        /** @internal */
	        FormGroupDirective.prototype._updateDomValue = function () {
	            var _this = this;
	            this.directives.forEach(function (dir) {
	                var newCtrl = _this.form.get(dir.path);
	                if (dir._control !== newCtrl) {
	                    cleanUpControl(dir._control, dir);
	                    if (newCtrl)
	                        setUpControl(newCtrl, dir);
	                    dir._control = newCtrl;
	                }
	            });
	            this.form._updateTreeValidity({ emitEvent: false });
	        };
	        FormGroupDirective.prototype._updateRegistrations = function () {
	            var _this = this;
	            this.form._registerOnCollectionChange(function () { return _this._updateDomValue(); });
	            if (this._oldForm)
	                this._oldForm._registerOnCollectionChange(function () { });
	            this._oldForm = this.form;
	        };
	        FormGroupDirective.prototype._updateValidators = function () {
	            var sync = composeValidators(this._validators);
	            this.form.validator = Validators.compose([this.form.validator, sync]);
	            var async = composeAsyncValidators(this._asyncValidators);
	            this.form.asyncValidator = Validators.composeAsync([this.form.asyncValidator, async]);
	        };
	        FormGroupDirective.prototype._checkFormPresent = function () {
	            if (!this.form) {
	                ReactiveErrors.missingFormException();
	            }
	        };
	        FormGroupDirective.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: '[formGroup]',
	                        providers: [formDirectiveProvider$1],
	                        host: { '(submit)': 'onSubmit($event)', '(reset)': 'onReset()' },
	                        exportAs: 'ngForm'
	                    },] },
	        ];
	        /** @nocollapse */
	        FormGroupDirective.ctorParameters = [
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALIDATORS,] },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_ASYNC_VALIDATORS,] },] },
	        ];
	        FormGroupDirective.propDecorators = {
	            'form': [{ type: _angular_core.Input, args: ['formGroup',] },],
	            'ngSubmit': [{ type: _angular_core.Output },],
	        };
	        return FormGroupDirective;
	    }(ControlContainer));
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$12 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    var formGroupNameProvider = {
	        provide: ControlContainer,
	        useExisting: _angular_core.forwardRef(function () { return FormGroupName; })
	    };
	    /**
	     * @whatItDoes Syncs a nested {@link FormGroup} to a DOM element.
	     *
	     * @howToUse
	     *
	     * This directive can only be used with a parent {@link FormGroupDirective} (selector:
	     * `[formGroup]`).
	     *
	     * It accepts the string name of the nested {@link FormGroup} you want to link, and
	     * will look for a {@link FormGroup} registered with that name in the parent
	     * {@link FormGroup} instance you passed into {@link FormGroupDirective}.
	     *
	     * Nested form groups can come in handy when you want to validate a sub-group of a
	     * form separately from the rest or when you'd like to group the values of certain
	     * controls into their own nested object.
	     *
	     * **Access the group**: You can access the associated {@link FormGroup} using the
	     * {@link AbstractControl.get} method. Ex: `this.form.get('name')`.
	     *
	     * You can also access individual controls within the group using dot syntax.
	     * Ex: `this.form.get('name.first')`
	     *
	     * **Get the value**: the `value` property is always synced and available on the
	     * {@link FormGroup}. See a full list of available properties in {@link AbstractControl}.
	     *
	     * **Set the value**: You can set an initial value for each child control when instantiating
	     * the {@link FormGroup}, or you can set it programmatically later using
	     * {@link AbstractControl.setValue} or {@link AbstractControl.patchValue}.
	     *
	     * **Listen to value**: If you want to listen to changes in the value of the group, you can
	     * subscribe to the {@link AbstractControl.valueChanges} event.  You can also listen to
	     * {@link AbstractControl.statusChanges} to be notified when the validation status is
	     * re-calculated.
	     *
	     * ### Example
	     *
	     * {@example forms/ts/nestedFormGroup/nested_form_group_example.ts region='Component'}
	     *
	     * * **npm package**: `@angular/forms`
	     *
	     * * **NgModule**: `ReactiveFormsModule`
	     *
	     * @stable
	     */
	    var FormGroupName = (function (_super) {
	        __extends$12(FormGroupName, _super);
	        function FormGroupName(parent, validators, asyncValidators) {
	            _super.call(this);
	            this._parent = parent;
	            this._validators = validators;
	            this._asyncValidators = asyncValidators;
	        }
	        /** @internal */
	        FormGroupName.prototype._checkParentType = function () {
	            if (_hasInvalidParent(this._parent)) {
	                ReactiveErrors.groupParentException();
	            }
	        };
	        FormGroupName.decorators = [
	            { type: _angular_core.Directive, args: [{ selector: '[formGroupName]', providers: [formGroupNameProvider] },] },
	        ];
	        /** @nocollapse */
	        FormGroupName.ctorParameters = [
	            { type: ControlContainer, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Host }, { type: _angular_core.SkipSelf },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALIDATORS,] },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_ASYNC_VALIDATORS,] },] },
	        ];
	        FormGroupName.propDecorators = {
	            'name': [{ type: _angular_core.Input, args: ['formGroupName',] },],
	        };
	        return FormGroupName;
	    }(AbstractFormGroupDirective));
	    var formArrayNameProvider = {
	        provide: ControlContainer,
	        useExisting: _angular_core.forwardRef(function () { return FormArrayName; })
	    };
	    /**
	     * @whatItDoes Syncs a nested {@link FormArray} to a DOM element.
	     *
	     * @howToUse
	     *
	     * This directive is designed to be used with a parent {@link FormGroupDirective} (selector:
	     * `[formGroup]`).
	     *
	     * It accepts the string name of the nested {@link FormArray} you want to link, and
	     * will look for a {@link FormArray} registered with that name in the parent
	     * {@link FormGroup} instance you passed into {@link FormGroupDirective}.
	     *
	     * Nested form arrays can come in handy when you have a group of form controls but
	     * you're not sure how many there will be. Form arrays allow you to create new
	     * form controls dynamically.
	     *
	     * **Access the array**: You can access the associated {@link FormArray} using the
	     * {@link AbstractControl.get} method on the parent {@link FormGroup}.
	     * Ex: `this.form.get('cities')`.
	     *
	     * **Get the value**: the `value` property is always synced and available on the
	     * {@link FormArray}. See a full list of available properties in {@link AbstractControl}.
	     *
	     * **Set the value**: You can set an initial value for each child control when instantiating
	     * the {@link FormArray}, or you can set the value programmatically later using the
	     * {@link FormArray}'s {@link AbstractControl.setValue} or {@link AbstractControl.patchValue}
	     * methods.
	     *
	     * **Listen to value**: If you want to listen to changes in the value of the array, you can
	     * subscribe to the {@link FormArray}'s {@link AbstractControl.valueChanges} event.  You can also
	     * listen to its {@link AbstractControl.statusChanges} event to be notified when the validation
	     * status is re-calculated.
	     *
	     * **Add new controls**: You can add new controls to the {@link FormArray} dynamically by
	     * calling its {@link FormArray.push} method.
	     *  Ex: `this.form.get('cities').push(new FormControl());`
	     *
	     * ### Example
	     *
	     * {@example forms/ts/nestedFormArray/nested_form_array_example.ts region='Component'}
	     *
	     * * **npm package**: `@angular/forms`
	     *
	     * * **NgModule**: `ReactiveFormsModule`
	     *
	     * @stable
	     */
	    var FormArrayName = (function (_super) {
	        __extends$12(FormArrayName, _super);
	        function FormArrayName(parent, validators, asyncValidators) {
	            _super.call(this);
	            this._parent = parent;
	            this._validators = validators;
	            this._asyncValidators = asyncValidators;
	        }
	        FormArrayName.prototype.ngOnInit = function () {
	            this._checkParentType();
	            this.formDirective.addFormArray(this);
	        };
	        FormArrayName.prototype.ngOnDestroy = function () {
	            if (this.formDirective) {
	                this.formDirective.removeFormArray(this);
	            }
	        };
	        Object.defineProperty(FormArrayName.prototype, "control", {
	            get: function () { return this.formDirective.getFormArray(this); },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormArrayName.prototype, "formDirective", {
	            get: function () {
	                return this._parent ? this._parent.formDirective : null;
	            },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormArrayName.prototype, "path", {
	            get: function () { return controlPath(this.name, this._parent); },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormArrayName.prototype, "validator", {
	            get: function () { return composeValidators(this._validators); },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormArrayName.prototype, "asyncValidator", {
	            get: function () { return composeAsyncValidators(this._asyncValidators); },
	            enumerable: true,
	            configurable: true
	        });
	        FormArrayName.prototype._checkParentType = function () {
	            if (_hasInvalidParent(this._parent)) {
	                ReactiveErrors.arrayParentException();
	            }
	        };
	        FormArrayName.decorators = [
	            { type: _angular_core.Directive, args: [{ selector: '[formArrayName]', providers: [formArrayNameProvider] },] },
	        ];
	        /** @nocollapse */
	        FormArrayName.ctorParameters = [
	            { type: ControlContainer, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Host }, { type: _angular_core.SkipSelf },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALIDATORS,] },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_ASYNC_VALIDATORS,] },] },
	        ];
	        FormArrayName.propDecorators = {
	            'name': [{ type: _angular_core.Input, args: ['formArrayName',] },],
	        };
	        return FormArrayName;
	    }(ControlContainer));
	    function _hasInvalidParent(parent) {
	        return !(parent instanceof FormGroupName) && !(parent instanceof FormGroupDirective) &&
	            !(parent instanceof FormArrayName);
	    }
	
	    /**
	     * @license
	     * Copyright Google Inc. All Rights Reserved.
	     *
	     * Use of this source code is governed by an MIT-style license that can be
	     * found in the LICENSE file at https://angular.io/license
	     */
	    var __extends$10 = (this && this.__extends) || function (d, b) {
	        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	        function __() { this.constructor = d; }
	        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	    };
	    var controlNameBinding = {
	        provide: NgControl,
	        useExisting: _angular_core.forwardRef(function () { return FormControlName; })
	    };
	    /**
	     * @whatItDoes  Syncs a {@link FormControl} in an existing {@link FormGroup} to a form control
	     * element by name.
	     *
	     * In other words, this directive ensures that any values written to the {@link FormControl}
	     * instance programmatically will be written to the DOM element (model -> view). Conversely,
	     * any values written to the DOM element through user input will be reflected in the
	     * {@link FormControl} instance (view -> model).
	     *
	     * @howToUse
	     *
	     * This directive is designed to be used with a parent {@link FormGroupDirective} (selector:
	     * `[formGroup]`).
	     *
	     * It accepts the string name of the {@link FormControl} instance you want to
	     * link, and will look for a {@link FormControl} registered with that name in the
	     * closest {@link FormGroup} or {@link FormArray} above it.
	     *
	     * **Access the control**: You can access the {@link FormControl} associated with
	     * this directive by using the {@link AbstractControl.get} method.
	     * Ex: `this.form.get('first');`
	     *
	     * **Get value**: the `value` property is always synced and available on the {@link FormControl}.
	     * See a full list of available properties in {@link AbstractControl}.
	     *
	     *  **Set value**: You can set an initial value for the control when instantiating the
	     *  {@link FormControl}, or you can set it programmatically later using
	     *  {@link AbstractControl.setValue} or {@link AbstractControl.patchValue}.
	     *
	     * **Listen to value**: If you want to listen to changes in the value of the control, you can
	     * subscribe to the {@link AbstractControl.valueChanges} event.  You can also listen to
	     * {@link AbstractControl.statusChanges} to be notified when the validation status is
	     * re-calculated.
	     *
	     * ### Example
	     *
	     * In this example, we create form controls for first name and last name.
	     *
	     * {@example forms/ts/simpleFormGroup/simple_form_group_example.ts region='Component'}
	     *
	     * To see `formControlName` examples with different form control types, see:
	     *
	     * * Radio buttons: {@link RadioControlValueAccessor}
	     * * Selects: {@link SelectControlValueAccessor}
	     *
	     * **npm package**: `@angular/forms`
	     *
	     * **NgModule**: {@link ReactiveFormsModule}
	     *
	     *  @stable
	     */
	    var FormControlName = (function (_super) {
	        __extends$10(FormControlName, _super);
	        function FormControlName(parent, validators, asyncValidators, valueAccessors) {
	            _super.call(this);
	            this._added = false;
	            this.update = new EventEmitter();
	            this._parent = parent;
	            this._rawValidators = validators || [];
	            this._rawAsyncValidators = asyncValidators || [];
	            this.valueAccessor = selectValueAccessor(this, valueAccessors);
	        }
	        Object.defineProperty(FormControlName.prototype, "isDisabled", {
	            set: function (isDisabled) { ReactiveErrors.disabledAttrWarning(); },
	            enumerable: true,
	            configurable: true
	        });
	        FormControlName.prototype.ngOnChanges = function (changes) {
	            if (!this._added)
	                this._setUpControl();
	            if (isPropertyUpdated(changes, this.viewModel)) {
	                this.viewModel = this.model;
	                this.formDirective.updateModel(this, this.model);
	            }
	        };
	        FormControlName.prototype.ngOnDestroy = function () {
	            if (this.formDirective) {
	                this.formDirective.removeControl(this);
	            }
	        };
	        FormControlName.prototype.viewToModelUpdate = function (newValue) {
	            this.viewModel = newValue;
	            this.update.emit(newValue);
	        };
	        Object.defineProperty(FormControlName.prototype, "path", {
	            get: function () { return controlPath(this.name, this._parent); },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormControlName.prototype, "formDirective", {
	            get: function () { return this._parent ? this._parent.formDirective : null; },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormControlName.prototype, "validator", {
	            get: function () { return composeValidators(this._rawValidators); },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormControlName.prototype, "asyncValidator", {
	            get: function () {
	                return composeAsyncValidators(this._rawAsyncValidators);
	            },
	            enumerable: true,
	            configurable: true
	        });
	        Object.defineProperty(FormControlName.prototype, "control", {
	            get: function () { return this._control; },
	            enumerable: true,
	            configurable: true
	        });
	        FormControlName.prototype._checkParentType = function () {
	            if (!(this._parent instanceof FormGroupName) &&
	                this._parent instanceof AbstractFormGroupDirective) {
	                ReactiveErrors.ngModelGroupException();
	            }
	            else if (!(this._parent instanceof FormGroupName) && !(this._parent instanceof FormGroupDirective) &&
	                !(this._parent instanceof FormArrayName)) {
	                ReactiveErrors.controlParentException();
	            }
	        };
	        FormControlName.prototype._setUpControl = function () {
	            this._checkParentType();
	            this._control = this.formDirective.addControl(this);
	            if (this.control.disabled && this.valueAccessor.setDisabledState) {
	                this.valueAccessor.setDisabledState(true);
	            }
	            this._added = true;
	        };
	        FormControlName.decorators = [
	            { type: _angular_core.Directive, args: [{ selector: '[formControlName]', providers: [controlNameBinding] },] },
	        ];
	        /** @nocollapse */
	        FormControlName.ctorParameters = [
	            { type: ControlContainer, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Host }, { type: _angular_core.SkipSelf },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALIDATORS,] },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_ASYNC_VALIDATORS,] },] },
	            { type: Array, decorators: [{ type: _angular_core.Optional }, { type: _angular_core.Self }, { type: _angular_core.Inject, args: [NG_VALUE_ACCESSOR,] },] },
	        ];
	        FormControlName.propDecorators = {
	            'name': [{ type: _angular_core.Input, args: ['formControlName',] },],
	            'model': [{ type: _angular_core.Input, args: ['ngModel',] },],
	            'update': [{ type: _angular_core.Output, args: ['ngModelChange',] },],
	            'isDisabled': [{ type: _angular_core.Input, args: ['disabled',] },],
	        };
	        return FormControlName;
	    }(NgControl));
	
	    var REQUIRED_VALIDATOR = {
	        provide: NG_VALIDATORS,
	        useExisting: _angular_core.forwardRef(function () { return RequiredValidator; }),
	        multi: true
	    };
	    /**
	     * A Directive that adds the `required` validator to any controls marked with the
	     * `required` attribute, via the {@link NG_VALIDATORS} binding.
	     *
	     * ### Example
	     *
	     * ```
	     * <input name="fullName" ngModel required>
	     * ```
	     *
	     * @stable
	     */
	    var RequiredValidator = (function () {
	        function RequiredValidator() {
	        }
	        Object.defineProperty(RequiredValidator.prototype, "required", {
	            get: function () { return this._required; },
	            set: function (value) {
	                this._required = value != null && value !== false && "" + value !== 'false';
	                if (this._onChange)
	                    this._onChange();
	            },
	            enumerable: true,
	            configurable: true
	        });
	        RequiredValidator.prototype.validate = function (c) {
	            return this.required ? Validators.required(c) : null;
	        };
	        RequiredValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
	        RequiredValidator.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: '[required][formControlName],[required][formControl],[required][ngModel]',
	                        providers: [REQUIRED_VALIDATOR],
	                        host: { '[attr.required]': 'required ? "" : null' }
	                    },] },
	        ];
	        /** @nocollapse */
	        RequiredValidator.ctorParameters = [];
	        RequiredValidator.propDecorators = {
	            'required': [{ type: _angular_core.Input },],
	        };
	        return RequiredValidator;
	    }());
	    /**
	     * Provider which adds {@link MinLengthValidator} to {@link NG_VALIDATORS}.
	     *
	     * ## Example:
	     *
	     * {@example common/forms/ts/validators/validators.ts region='min'}
	     */
	    var MIN_LENGTH_VALIDATOR = {
	        provide: NG_VALIDATORS,
	        useExisting: _angular_core.forwardRef(function () { return MinLengthValidator; }),
	        multi: true
	    };
	    /**
	     * A directive which installs the {@link MinLengthValidator} for any `formControlName`,
	     * `formControl`, or control with `ngModel` that also has a `minlength` attribute.
	     *
	     * @stable
	     */
	    var MinLengthValidator = (function () {
	        function MinLengthValidator() {
	        }
	        MinLengthValidator.prototype.ngOnChanges = function (changes) {
	            if ('minlength' in changes) {
	                this._createValidator();
	                if (this._onChange)
	                    this._onChange();
	            }
	        };
	        MinLengthValidator.prototype.validate = function (c) {
	            return this.minlength == null ? null : this._validator(c);
	        };
	        MinLengthValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
	        MinLengthValidator.prototype._createValidator = function () {
	            this._validator = Validators.minLength(parseInt(this.minlength, 10));
	        };
	        MinLengthValidator.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: '[minlength][formControlName],[minlength][formControl],[minlength][ngModel]',
	                        providers: [MIN_LENGTH_VALIDATOR],
	                        host: { '[attr.minlength]': 'minlength ? minlength : null' }
	                    },] },
	        ];
	        /** @nocollapse */
	        MinLengthValidator.ctorParameters = [];
	        MinLengthValidator.propDecorators = {
	            'minlength': [{ type: _angular_core.Input },],
	        };
	        return MinLengthValidator;
	    }());
	    /**
	     * Provider which adds {@link MaxLengthValidator} to {@link NG_VALIDATORS}.
	     *
	     * ## Example:
	     *
	     * {@example common/forms/ts/validators/validators.ts region='max'}
	     */
	    var MAX_LENGTH_VALIDATOR = {
	        provide: NG_VALIDATORS,
	        useExisting: _angular_core.forwardRef(function () { return MaxLengthValidator; }),
	        multi: true
	    };
	    /**
	     * A directive which installs the {@link MaxLengthValidator} for any `formControlName,
	     * `formControl`,
	     * or control with `ngModel` that also has a `maxlength` attribute.
	     *
	     * @stable
	     */
	    var MaxLengthValidator = (function () {
	        function MaxLengthValidator() {
	        }
	        MaxLengthValidator.prototype.ngOnChanges = function (changes) {
	            if ('maxlength' in changes) {
	                this._createValidator();
	                if (this._onChange)
	                    this._onChange();
	            }
	        };
	        MaxLengthValidator.prototype.validate = function (c) {
	            return this.maxlength != null ? this._validator(c) : null;
	        };
	        MaxLengthValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
	        MaxLengthValidator.prototype._createValidator = function () {
	            this._validator = Validators.maxLength(parseInt(this.maxlength, 10));
	        };
	        MaxLengthValidator.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: '[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]',
	                        providers: [MAX_LENGTH_VALIDATOR],
	                        host: { '[attr.maxlength]': 'maxlength ? maxlength : null' }
	                    },] },
	        ];
	        /** @nocollapse */
	        MaxLengthValidator.ctorParameters = [];
	        MaxLengthValidator.propDecorators = {
	            'maxlength': [{ type: _angular_core.Input },],
	        };
	        return MaxLengthValidator;
	    }());
	    var PATTERN_VALIDATOR = {
	        provide: NG_VALIDATORS,
	        useExisting: _angular_core.forwardRef(function () { return PatternValidator; }),
	        multi: true
	    };
	    /**
	     * A Directive that adds the `pattern` validator to any controls marked with the
	     * `pattern` attribute, via the {@link NG_VALIDATORS} binding. Uses attribute value
	     * as the regex to validate Control value against.  Follows pattern attribute
	     * semantics; i.e. regex must match entire Control value.
	     *
	     * ### Example
	     *
	     * ```
	     * <input [name]="fullName" pattern="[a-zA-Z ]*" ngModel>
	     * ```
	     * @stable
	     */
	    var PatternValidator = (function () {
	        function PatternValidator() {
	        }
	        PatternValidator.prototype.ngOnChanges = function (changes) {
	            if ('pattern' in changes) {
	                this._createValidator();
	                if (this._onChange)
	                    this._onChange();
	            }
	        };
	        PatternValidator.prototype.validate = function (c) { return this._validator(c); };
	        PatternValidator.prototype.registerOnValidatorChange = function (fn) { this._onChange = fn; };
	        PatternValidator.prototype._createValidator = function () { this._validator = Validators.pattern(this.pattern); };
	        PatternValidator.decorators = [
	            { type: _angular_core.Directive, args: [{
	                        selector: '[pattern][formControlName],[pattern][formControl],[pattern][ngModel]',
	                        providers: [PATTERN_VALIDATOR],
	                        host: { '[attr.pattern]': 'pattern ? pattern : null' }
	                    },] },
	        ];
	        /** @nocollapse */
	        PatternValidator.ctorParameters = [];
	        PatternValidator.propDecorators = {
	            'pattern': [{ type: _angular_core.Input },],
	        };
	        return PatternValidator;
	    }());
	
	    /**
	     * @whatItDoes Creates an {@link AbstractControl} from a user-specified configuration.
	     *
	     * It is essentially syntactic sugar that shortens the `new FormGroup()`,
	     * `new FormControl()`, and `new FormArray()` boilerplate that can build up in larger
	     * forms.
	     *
	     * @howToUse
	     *
	     * To use, inject `FormBuilder` into your component class. You can then call its methods
	     * directly.
	     *
	     * {@example forms/ts/formBuilder/form_builder_example.ts region='Component'}
	     *
	     *  * **npm package**: `@angular/forms`
	     *
	     *  * **NgModule**: {@link ReactiveFormsModule}
	     *
	     * @stable
	     */
	    var FormBuilder = (function () {
	        function FormBuilder() {
	        }
	        /**
	         * Construct a new {@link FormGroup} with the given map of configuration.
	         * Valid keys for the `extra` parameter map are `validator` and `asyncValidator`.
	         *
	         * See the {@link FormGroup} constructor for more details.
	         */
	        FormBuilder.prototype.group = function (controlsConfig, extra) {
	            if (extra === void 0) { extra = null; }
	            var controls = this._reduceControls(controlsConfig);
	            var validator = isPresent(extra) ? extra['validator'] : null;
	            var asyncValidator = isPresent(extra) ? extra['asyncValidator'] : null;
	            return new FormGroup(controls, validator, asyncValidator);
	        };
	        /**
	         * Construct a new {@link FormControl} with the given `formState`,`validator`, and
	         * `asyncValidator`.
	         *
	         * `formState` can either be a standalone value for the form control or an object
	         * that contains both a value and a disabled status.
	         *
	         */
	        FormBuilder.prototype.control = function (formState, validator, asyncValidator) {
	            if (validator === void 0) { validator = null; }
	            if (asyncValidator === void 0) { asyncValidator = null; }
	            return new FormControl(formState, validator, asyncValidator);
	        };
	        /**
	         * Construct a {@link FormArray} from the given `controlsConfig` array of
	         * configuration, with the given optional `validator` and `asyncValidator`.
	         */
	        FormBuilder.prototype.array = function (controlsConfig, validator, asyncValidator) {
	            var _this = this;
	            if (validator === void 0) { validator = null; }
	            if (asyncValidator === void 0) { asyncValidator = null; }
	            var controls = controlsConfig.map(function (c) { return _this._createControl(c); });
	            return new FormArray(controls, validator, asyncValidator);
	        };
	        /** @internal */
	        FormBuilder.prototype._reduceControls = function (controlsConfig) {
	            var _this = this;
	            var controls = {};
	            Object.keys(controlsConfig).forEach(function (controlName) {
	                controls[controlName] = _this._createControl(controlsConfig[controlName]);
	            });
	            return controls;
	        };
	        /** @internal */
	        FormBuilder.prototype._createControl = function (controlConfig) {
	            if (controlConfig instanceof FormControl || controlConfig instanceof FormGroup ||
	                controlConfig instanceof FormArray) {
	                return controlConfig;
	            }
	            else if (Array.isArray(controlConfig)) {
	                var value = controlConfig[0];
	                var validator = controlConfig.length > 1 ? controlConfig[1] : null;
	                var asyncValidator = controlConfig.length > 2 ? controlConfig[2] : null;
	                return this.control(value, validator, asyncValidator);
	            }
	            else {
	                return this.control(controlConfig);
	            }
	        };
	        FormBuilder.decorators = [
	            { type: _angular_core.Injectable },
	        ];
	        /** @nocollapse */
	        FormBuilder.ctorParameters = [];
	        return FormBuilder;
	    }());
	
	    var SHARED_FORM_DIRECTIVES = [
	        NgSelectOption, NgSelectMultipleOption, DefaultValueAccessor, NumberValueAccessor,
	        RangeValueAccessor, CheckboxControlValueAccessor, SelectControlValueAccessor,
	        SelectMultipleControlValueAccessor, RadioControlValueAccessor, NgControlStatus,
	        NgControlStatusGroup, RequiredValidator, MinLengthValidator, MaxLengthValidator, PatternValidator
	    ];
	    var TEMPLATE_DRIVEN_DIRECTIVES = [NgModel, NgModelGroup, NgForm];
	    var REACTIVE_DRIVEN_DIRECTIVES = [FormControlDirective, FormGroupDirective, FormControlName, FormGroupName, FormArrayName];
	    /**
	     * Internal module used for sharing directives between FormsModule and ReactiveFormsModule
	     */
	    var InternalFormsSharedModule = (function () {
	        function InternalFormsSharedModule() {
	        }
	        InternalFormsSharedModule.decorators = [
	            { type: _angular_core.NgModule, args: [{
	                        declarations: SHARED_FORM_DIRECTIVES,
	                        exports: SHARED_FORM_DIRECTIVES,
	                    },] },
	        ];
	        /** @nocollapse */
	        InternalFormsSharedModule.ctorParameters = [];
	        return InternalFormsSharedModule;
	    }());
	
	    /**
	     * The ng module for forms.
	     * @stable
	     */
	    var FormsModule = (function () {
	        function FormsModule() {
	        }
	        FormsModule.decorators = [
	            { type: _angular_core.NgModule, args: [{
	                        declarations: TEMPLATE_DRIVEN_DIRECTIVES,
	                        providers: [RadioControlRegistry],
	                        exports: [InternalFormsSharedModule, TEMPLATE_DRIVEN_DIRECTIVES]
	                    },] },
	        ];
	        /** @nocollapse */
	        FormsModule.ctorParameters = [];
	        return FormsModule;
	    }());
	    /**
	     * The ng module for reactive forms.
	     * @stable
	     */
	    var ReactiveFormsModule = (function () {
	        function ReactiveFormsModule() {
	        }
	        ReactiveFormsModule.decorators = [
	            { type: _angular_core.NgModule, args: [{
	                        declarations: [REACTIVE_DRIVEN_DIRECTIVES],
	                        providers: [FormBuilder, RadioControlRegistry],
	                        exports: [InternalFormsSharedModule, REACTIVE_DRIVEN_DIRECTIVES]
	                    },] },
	        ];
	        /** @nocollapse */
	        ReactiveFormsModule.ctorParameters = [];
	        return ReactiveFormsModule;
	    }());
	
	    exports.AbstractControlDirective = AbstractControlDirective;
	    exports.AbstractFormGroupDirective = AbstractFormGroupDirective;
	    exports.CheckboxControlValueAccessor = CheckboxControlValueAccessor;
	    exports.ControlContainer = ControlContainer;
	    exports.NG_VALUE_ACCESSOR = NG_VALUE_ACCESSOR;
	    exports.DefaultValueAccessor = DefaultValueAccessor;
	    exports.NgControl = NgControl;
	    exports.NgControlStatus = NgControlStatus;
	    exports.NgControlStatusGroup = NgControlStatusGroup;
	    exports.NgForm = NgForm;
	    exports.NgModel = NgModel;
	    exports.NgModelGroup = NgModelGroup;
	    exports.RadioControlValueAccessor = RadioControlValueAccessor;
	    exports.FormControlDirective = FormControlDirective;
	    exports.FormControlName = FormControlName;
	    exports.FormGroupDirective = FormGroupDirective;
	    exports.FormArrayName = FormArrayName;
	    exports.FormGroupName = FormGroupName;
	    exports.NgSelectOption = NgSelectOption;
	    exports.SelectControlValueAccessor = SelectControlValueAccessor;
	    exports.SelectMultipleControlValueAccessor = SelectMultipleControlValueAccessor;
	    exports.MaxLengthValidator = MaxLengthValidator;
	    exports.MinLengthValidator = MinLengthValidator;
	    exports.PatternValidator = PatternValidator;
	    exports.RequiredValidator = RequiredValidator;
	    exports.FormBuilder = FormBuilder;
	    exports.AbstractControl = AbstractControl;
	    exports.FormArray = FormArray;
	    exports.FormControl = FormControl;
	    exports.FormGroup = FormGroup;
	    exports.NG_ASYNC_VALIDATORS = NG_ASYNC_VALIDATORS;
	    exports.NG_VALIDATORS = NG_VALIDATORS;
	    exports.Validators = Validators;
	    exports.FormsModule = FormsModule;
	    exports.ReactiveFormsModule = ReactiveFormsModule;
	
	}));

/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var instance_model_1 = __webpack_require__(513);
	var direct_debitfile_config_model_1 = __webpack_require__(514);
	var vat_settings_model_1 = __webpack_require__(515);
	var invoicing_setting_model_1 = __webpack_require__(828);
	var CompanyModel = (function () {
	    function CompanyModel() {
	        this.instanceHashId = "";
	        this.isInstanceOdometerConfiguration = false;
	        this.lowBatteryFlagRaised = "11.50";
	        this.lowBatteryFlagClear = "12.0";
	        this.isVatSettingAvailable = false;
	        this.vatSettingDefaultCost = true;
	        this.parentCompanyName = "";
	        this.isPaymentEnabled = false;
	        this.userBlockMessage = "";
	        this.instanceName = "";
	        this.companyAddressModel = new CompanyAddressModel();
	        this.companyNotificationRecepientsModel = new CompanyNotificationRecepientsModel();
	        this.odometerConfigurationModel = new instance_model_1.OdometerConfigurationModel();
	        this.directDebitfileConfigModel = new direct_debitfile_config_model_1.DirectDebitfileConfigModel();
	        this.bookingDelayConfig = new instance_model_1.BookingDelayConfigurationModel();
	        this.bookingDelayConfig.enabled = "INHERIT";
	        this.vatSettingsList = new Array();
	        this.invoiceSettings = new invoicing_setting_model_1.InvoiceSettingModel();
	        this.vatDefaultRate = new vat_settings_model_1.VatDefaultModel();
	        this.paymentSettingModel = new PaymentSettingModel();
	        this.parentCompanyName = "";
	        this.customTripQuestionList = new Array();
	        this.twoFAConfig = new instance_model_1.TwoFAConfigModel();
	    }
	    return CompanyModel;
	}());
	exports.CompanyModel = CompanyModel;
	var CompanyAddressModel = (function () {
	    function CompanyAddressModel() {
	    }
	    return CompanyAddressModel;
	}());
	exports.CompanyAddressModel = CompanyAddressModel;
	var CompanyNotificationRecepientsModel = (function () {
	    function CompanyNotificationRecepientsModel() {
	        this.isNotificationEnabled = true;
	        this.isEmailEnabled = true;
	    }
	    return CompanyNotificationRecepientsModel;
	}());
	exports.CompanyNotificationRecepientsModel = CompanyNotificationRecepientsModel;
	var PaymentSettingModel = (function () {
	    function PaymentSettingModel() {
	        this.creditCardPayment = false;
	        this.initialPayment = false;
	        this.createBookingPayment = false;
	        this.startBookingPayment = false;
	    }
	    return PaymentSettingModel;
	}());
	exports.PaymentSettingModel = PaymentSettingModel;


/***/ },
/* 828 */
/***/ function(module, exports) {

	"use strict";
	var InvoiceSettingModel = (function () {
	    function InvoiceSettingModel() {
	    }
	    return InvoiceSettingModel;
	}());
	exports.InvoiceSettingModel = InvoiceSettingModel;


/***/ },
/* 829 */
/***/ function(module, exports) {

	"use strict";
	(function (PaymentProvider) {
	    PaymentProvider[PaymentProvider["OnlineBetaalplatform"] = 0] = "OnlineBetaalplatform";
	})(exports.PaymentProvider || (exports.PaymentProvider = {}));
	var PaymentProvider = exports.PaymentProvider;
	var PaymentProvider;
	(function (PaymentProvider) {
	    function values() {
	        return Object.keys(PaymentProvider).filter(function (type) { return isNaN(type) && type !== 'values'; });
	    }
	    PaymentProvider.values = values;
	})(PaymentProvider = exports.PaymentProvider || (exports.PaymentProvider = {}));


/***/ },
/* 830 */
/***/ function(module, exports) {

	"use strict";
	(function (Country) {
	    Country[Country["NLD"] = 0] = "NLD";
	    Country[Country["DE"] = 1] = "DE";
	    Country[Country["UK"] = 2] = "UK";
	})(exports.Country || (exports.Country = {}));
	var Country = exports.Country;
	var Country;
	(function (Country) {
	    function values() {
	        return Object.keys(Country).filter(function (type) { return isNaN(type) && type !== 'values'; });
	    }
	    Country.values = values;
	})(Country = exports.Country || (exports.Country = {}));


/***/ },
/* 831 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n    <section class=\"content-header\">\r\n        <div class=\"col-md-9 col-sm-6\">\r\n            <h1 class=\"pagename\">{{breadCrumbTitle}}</h1>\r\n            <ol class=\"breadcrumb\">\r\n                <li><a [routerLink]=\"urlDefaultPage\"><i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a></li>\r\n                <li><a [routerLink]=\"urlCompanyList\"><i class=\"fa fa-building-o fa-fw\"></i>{{breadCrumbList}}</a></li>\r\n                <li class=\"active\">{{breadCrumbTitle}}</li>\r\n            </ol>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n        <div class=\"clearfix\"></div>\r\n    </section>\r\n\r\n    <section class=\"content\">\r\n        <div class=\"nopad\">\r\n            <form #AddCompanyForm=\"ngForm\" (ngSubmit)=\"onSubmit(AddCompanyForm.value)\">\r\n                <input [(ngModel)]=\"model.companyMasterHashId\" class=\"form-control\" name=\"companyMasterHashId\" type=\"hidden\">\r\n                <input [(ngModel)]=\"model.isActive\" class=\"form-control\" name=\"isActive\" type=\"hidden\">\r\n\r\n                <div class=\"form-group col-md-4\">\r\n                    <label><span class=\"text text-danger\">*</span> {{ 'LblCompanyName' | translate }}</label>\r\n                    <input #parentCompanyName [(ngModel)]=\"model.companyName\" class=\"form-control\" maxlength=\"100\" name=\"CompanyName\" placeholder=\"{{ 'LblCompanyName' | translate }}\" type=\"text\">\r\n                    <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'companyName' }}</span>\r\n                </div>\r\n\r\n                <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Instance\" class=\"form-group col-md-4\">\r\n                    <label><span class=\"text text-danger\">*</span>{{ 'LblInstance' | translate }}</label>\r\n                    <select (ngModelChange)=\"InstanceUpdate()\" *ngIf=\"!isEditMode\" [(ngModel)]=\"model.instanceHashId\" class=\"form-control\" name=\"instance\">\r\n                        <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblInstance' | translate }}</option>\r\n                        <option *ngFor=\"let inst of instanceList\" [ngValue]='inst.keyHash'>{{inst.value}}</option>\r\n                    </select>\r\n                    <select *ngIf=\"isEditMode\" [ngModel]=\"model.instanceHashId\" class=\"form-control\" disabled=\"disabled\" name=\"instance\">\r\n                        <option *ngFor=\"let inst of instanceList\" [ngValue]='inst.keyHash'>{{ inst.value }}</option>\r\n                    </select>\r\n                    <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'InstanceHashId' }}</span>\r\n                </div>\r\n\r\n                <div class=\"form-group col-md-4\">\r\n                </div>\r\n                <div class=\"clearfix\"></div>\r\n\r\n                <div class=\"form-group col-md-4\">\r\n                    <label><span class=\"text text-danger\">*</span>{{ 'LblOfficeStartTime' | translate }} </label>\r\n                    <input [(ngModel)]=\"model.officeStartTime\" class=\"form-control\" maxlength=\"6\" name=\"officeStartTime\" placeholder=\"{{ 'LblOfficeStartTime' | translate }}\" type=\"text\">\r\n                    <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'officeStartTime' }}</span>\r\n                </div>\r\n\r\n                <div class=\"form-group col-md-4\">\r\n                    <label><span class=\"text text-danger\">*</span> {{ 'LblOfficeEndTime' | translate }}</label>\r\n                    <input [(ngModel)]=\"model.officeEndTime\" class=\"form-control\" maxlength=\"6\" name=\"officeEndTime\" placeholder=\"{{ 'LblOfficeEndTime' | translate }}\" type=\"text\">\r\n                    <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'officeEndTime' }}</span>\r\n                </div>\r\n\r\n                <template [ngIf]=\"model.contactPersonName != null\">\r\n                    <div class=\"form-group col-md-4\">\r\n                        <label>{{ 'LblContactPerson' | translate }}</label>\r\n                        <input [(ngModel)]=\"model.contactPersonName\" class=\"form-control\" name=\"ContactPerson\" placeholder=\"Contact Person\" readonly=\"readonly\" type=\"text\">\r\n                    </div>\r\n                </template>\r\n\r\n                <div class=\"row col-md-12 mar_t_20 mar_bot_20\">\r\n                    <fieldset class=\"col-md-12\">\r\n                        <legend class=\"legendStyle\"><span class=\"text text-danger\">*</span> {{ 'LblCompanyAddress' | translate }}</legend>\r\n                        <div class=\"clearfix\"></div>\r\n\r\n                        <div class=\"row\">\r\n\r\n                            <div class=\"form-group col-md-4\">\r\n                                <label>{{ 'LblHouseNo' | translate }}</label>\r\n                                <input [(ngModel)]=\"model.companyAddressModel.houseNo\" class=\"form-control\" maxlength=\"15\" name=\"personWorkAddressModel.houseNo\" placeholder=\"{{ 'LblHouseNo' | translate }}\" type=\"text\">\r\n                                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'CompanyAddressModel.HouseNo' }}</span>\r\n                            </div>\r\n\r\n                            <div class=\"form-group col-md-4\">\r\n                                <label>{{ 'LblHouseExtention' | translate }}</label>\r\n                                <input [(ngModel)]=\"model.companyAddressModel.houseExtention\" class=\"form-control\" maxlength=\"25\" name=\"personWorkAddressModel.houseExtention\" placeholder=\"{{ 'LblHouseExtention' | translate }}\" type=\"text\">\r\n                                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'CompanyAddressModel.houseExtention' }}</span>\r\n                            </div>\r\n\r\n                            <div class=\"form-group col-md-4\">\r\n                                <label> {{ 'LblStreetName' | translate }} </label>\r\n                                <input [(ngModel)]=\"model.companyAddressModel.street\" class=\"form-control\" maxlength=\"100\" name=\"personWorkAddressModel.street\" placeholder=\"{{ 'LblStreetName' | translate }}\" type=\"text\">\r\n                                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'CompanyAddressModel.Street' }}</span>\r\n                            </div>\r\n\r\n                            <div class=\"clearfix\"></div>\r\n\r\n                            <div class=\"form-group col-md-4\">\r\n                                <label>{{ 'LblCity' | translate }}</label>\r\n                                <input [(ngModel)]=\"model.companyAddressModel.city\" class=\"form-control\" maxlength=\"50\" name=\"personWorkAddressModel.city\" placeholder=\"{{ 'LblCity' | translate }}\" type=\"text\">\r\n                                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'CompanyAddressModel.City' }}</span>\r\n                            </div>\r\n\r\n                            <div class=\"form-group col-md-4\">\r\n                                <label> {{ 'LblZipCode' | translate }}</label>\r\n                                <input [(ngModel)]=\"model.companyAddressModel.zipCode\" class=\"form-control\" maxlength=\"10\" name=\"personWorkAddressModel.zipCode\" placeholder=\"{{ 'LblZipCode' | translate }}\" type=\"text\">\r\n                                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'CompanyAddressModel.ZipCode' }}</span>\r\n                            </div>\r\n\r\n                            <div class=\"clearfix\"></div>\r\n                            <!-- <div class=\"form-group col-md-12\">\r\n                            <label> {{ 'LblGeoLocation' | translate }}</label>\r\n                            <input class=\"form-control\" type=\"text\" name=\"displaycompanyGeoLocationAddress\" [(ngModel)]=\"model.displaycompanyGeoLocationAddress\" (setAddress)=\"GetAddress($event)\" googleplace />\r\n                            <div class=\"input-group\">\r\n                                <div class=\"input-group-btn\">\r\n                                <button class=\"btn btn-default\" type=\"button\" (click)=\"geoLocationModal.show()\">\r\n                                    <i class=\"fa fa-map-marker\" aria-hidden=\"true\"></i>\r\n                                </button>\r\n                                </div>\r\n                            </div>\r\n                            </div>-->\r\n                        </div>\r\n                    </fieldset>\r\n                </div>\r\n\r\n                <div class=\"row col-md-12 mar_bot_20\">\r\n                    <fieldset class=\"col-md-12\">\r\n                        <legend class=\"legendStyle\"><span class=\"text text-danger\">*</span> {{ 'LblApkExiprationSetting' | translate }}</legend>\r\n\r\n                        <div class=\"row\">\r\n                            <div class=\"col-md-5\">\r\n                                <div class=\"row\">\r\n                                    <div class=\"col-md-12 form-group\">\r\n                                        <label>{{ 'LblIsEmailEnabled' | translate }}</label>\r\n                                        <div class=\"clearfix\"></div>\r\n                                        <label class=\"radio-inline\">\r\n                                            <input [(ngModel)]=\"model.companyNotificationRecepientsModel.isEmailEnabled\" [value]=\"true\" name=\"emailnotification\" type=\"radio\">\r\n                                            {{ 'LblEnabled' | translate }}\r\n                                        </label>\r\n                                        <label class=\"radio-inline\">\r\n                                            <input [(ngModel)]=\"model.companyNotificationRecepientsModel.isEmailEnabled\" [value]=\"false\" name=\"emailnotification\" type=\"radio\">\r\n                                            {{ 'LblDisabled' | translate }}\r\n                                        </label>\r\n                                    </div>\r\n                                </div>\r\n                            </div>\r\n\r\n                            <div *ngIf=\"model.companyNotificationRecepientsModel.isEmailEnabled\" class=\"col-md-8\">\r\n                                <div class=\"row\">\r\n\r\n                                    <div class=\"form-group col-md-5\">\r\n                                        <label>{{ 'LblNotificationFrequency' | translate }}</label>\r\n                                        <input [(ngModel)]=\"model.companyNotificationRecepientsModel.frequency\" class=\"form-control\" maxlength=\"15\" name=\"frequency\" placeholder=\"{{ 'LblNotificationFrequency' | translate }}\" type=\"text\">\r\n                                        <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'CompanyNotificationRecepientsModel.Frequency' }}</span>\r\n                                    </div>\r\n\r\n                                    <div class=\"form-group col-md-5\">\r\n                                        <label>{{ 'LblApkTimeInterval' | translate }}</label>\r\n                                        <div class=\"clearfix\"></div>\r\n                                        <label class=\"radio-inline\">\r\n                                            <input [(ngModel)]=\"model.companyNotificationRecepientsModel.timeInterval\" name=\"timeInterval \" type=\"radio\" value=\"DAY \">\r\n                                            &nbsp;{{ 'LblDay' | translate }}\r\n                                        </label>\r\n                                        <label class=\"radio-inline\">\r\n                                            <input [(ngModel)]=\"model.companyNotificationRecepientsModel.timeInterval\" name=\"timeInterval \" type=\"radio\" value=\"WEEK \">\r\n                                            &nbsp;{{ 'LblWeek' | translate }}\r\n                                        </label>\r\n                                        <label class=\"radio-inline\">\r\n                                            <input [(ngModel)]=\"model.companyNotificationRecepientsModel.timeInterval\" name=\"timeInterval \" type=\"radio\" value=\"MONTH \">\r\n                                            &nbsp;{{ 'LblMonth' | translate }}\r\n                                        </label>\r\n                                        <div class=\"clearfix\"></div>\r\n                                        <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'CompanyNotificationRecepientsModel.TimeInterval' }}</span>\r\n                                    </div>\r\n\r\n                                    <div class=\"clearfix\"></div>\r\n\r\n                                    <div class=\"form-group col-md-5\">\r\n                                        <label>{{ 'lblThresholdFrequency' | translate }}</label>\r\n                                        <input [(ngModel)]=\"model.thresholdFrequency\" class=\"form-control\" maxlength=\"15\" name=\"thresholdFrequency\" placeholder=\"{{ 'lblThresholdFrequency' | translate }}\" type=\"text\">\r\n                                        <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'ThresholdFrequency' }}</span>\r\n                                    </div>\r\n\r\n                                    <div class=\"form-group col-md-7\">\r\n                                        <label>{{ 'lblThresholdTimeInterval' | translate }}</label>\r\n                                        <div class=\"clearfix\"></div>\r\n                                        <label class=\"radio-inline\">\r\n                                            <input [(ngModel)]=\"model.thresholdTimeInterval \" name=\"ThresholdTimeInterval\" type=\"radio\" value=\"DAY\">\r\n                                            &nbsp;{{ 'LblDay' | translate }}\r\n                                        </label>\r\n                                        <label class=\"radio-inline\">\r\n                                            <input [(ngModel)]=\"model.thresholdTimeInterval\" name=\"ThresholdTimeInterval\" type=\"radio\" value=\"WEEK\">\r\n                                            &nbsp;{{ 'LblWeek' | translate }}\r\n                                        </label>\r\n                                        <label class=\"radio-inline\">\r\n                                            <input [(ngModel)]=\"model.thresholdTimeInterval\" name=\"ThresholdTimeInterval \" type=\"radio\" value=\"MONTH\">\r\n                                            &nbsp;{{ 'LblMonth' | translate }}\r\n                                        </label>\r\n                                        <div class=\"clearfix\"></div>\r\n                                        <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'ThresholdTimeInterval' }}</span>\r\n                                    </div>\r\n\r\n                                </div>                                    \r\n                            </div>\r\n                        </div>\r\n                    </fieldset>\r\n                </div>\r\n\r\n                <div class=\"row col-md-12 mar_bot_20\">\r\n                    <fieldset *ngIf=\"model.odometerConfigurationModel && model.isInstanceOdometerConfiguration\" class=\"col-md-6\">\r\n                        <legend class=\"legendStyle\"><span class=\"text text-danger\">*</span> {{ 'LblodometerConfiguration' | translate }}</legend>\r\n                        \r\n                        <div class=\"row\">\r\n                            <div class=\"form-group col-md-6\">\r\n                                <label>{{ 'LbLOdometerEnabled' | translate }}</label>\r\n                                <div class=\"clearfix\"></div>\r\n                                <label class=\"radio-inline\">\r\n                                    <input [(ngModel)]=\"model.odometerConfigurationModel.enabled\" name=\"odometerConfigurationModelenabled\" type=\"radio\" value=\"YES\">\r\n                                    {{ 'LblYes' | translate }}\r\n                                </label>\r\n                                <label class=\"radio-inline\">\r\n                                    <input [(ngModel)]=\"model.odometerConfigurationModel.enabled\" name=\"odometerConfigurationModelenabled\" type=\"radio\" value=\"NO\">\r\n                                    {{ 'LblNo' | translate }}\r\n                                </label>\r\n                                <label class=\"radio-inline\">\r\n                                    <input [(ngModel)]=\"model.odometerConfigurationModel.enabled\" name=\"odometerConfigurationModelenabled\" type=\"radio\" value=\"INHERIT\">\r\n                                    {{ 'LblInherit' | translate }}\r\n                                </label>\r\n                                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'OdometerConfigurationModel.Enabled' }}</span>\r\n                            </div>\r\n\r\n                            <div *ngIf=\"model.odometerConfigurationModel.enabled=='YES'\" class=\"form-group col-md-6\">\r\n                                <label>{{ 'LblEnableOnApp' | translate }}</label>\r\n                                <div class=\"clearfix\"></div>\r\n                                <label class=\"radio-inline\">\r\n                                    <input [(ngModel)]=\"model.odometerConfigurationModel.enabledOnApp\" [value]=\"true\" name=\"enabledOnApp\" type=\"radio\">\r\n                                    {{ 'LblYes' | translate }}\r\n                                </label>\r\n                                <label class=\"radio-inline\">\r\n                                    <input [(ngModel)]=\"model.odometerConfigurationModel.enabledOnApp\" [value]=\"false\" name=\"enabledOnApp\" type=\"radio\">\r\n                                    {{ 'LblNo' | translate }}\r\n                                </label>\r\n                                <div class=\"clearfix\"></div>\r\n                                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'OdometerConfigurationModel.EnabledOnApp' }}</span>\r\n                            </div>\r\n\r\n                            <div *ngIf=\"model.odometerConfigurationModel.enabled=='YES' && model.odometerConfigurationModel.enabledOnApp\">\r\n                                <div class=\"form-group col-md-4\">\r\n                                    <label>{{'LblWarningPer' | translate}}</label>\r\n                                    <div class=\"clearfix\"></div>\r\n                                    <input [(ngModel)]=\"model.odometerConfigurationModel.warningPercentage\" class=\"form-control\" name=\"warningPercentage\" placeholder=\"{{ 'LblWarningPer' | translate }}\" type=\"text\">\r\n                                    <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'OdometerConfigurationModel.WarningPercentage' }}</span>\r\n                                </div>\r\n\r\n                                <div class=\"form-group col-md-3\" >\r\n                                    <label>{{ 'LblFrequency' | translate }}</label>\r\n                                    <div class=\"clearfix\"></div>\r\n                                    <template [ngIf]=\"model.odometerConfigurationModel.timeInterval == 'PERBOOKING'\">\r\n                                        <input class=\"form-control\" disabled maxlength=\"15\" name=\"frequency\" placeholder=\"{{ 'LblFrequency' | translate }}\" type=\"text\">\r\n                                    </template>\r\n                                    <template [ngIf]=\"model.odometerConfigurationModel.timeInterval != 'PERBOOKING'\">\r\n                                        <input [(ngModel)]=\"model.odometerConfigurationModel.frequency\" class=\"form-control\" maxlength=\"15\" name=\"frequency\" placeholder=\"{{ 'LblFrequency' | translate }}\" type=\"text\">\r\n                                        <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'OdometerConfigurationModel.Frequency' }}</span>\r\n                                    </template>\r\n                                </div>\r\n\r\n                                <div class=\"form-group col-md-5\">\r\n                                    <label>{{ 'LblTimeInterval' | translate }}</label>\r\n                                    <div class=\"clearfix\"></div>\r\n                                    <select (change)=\"changeOfOdometerTimeInterval()\" [(ngModel)]=\"model.odometerConfigurationModel.timeInterval\" class=\"form-control\" name=\"odometerTimeInterval\">\r\n                                        <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblTimeInterval' | translate }} </option>\r\n                                        <option value=\"DAY\">{{ 'LblDay' | translate }}</option>\r\n                                        <option value=\"WEEK\">{{ 'LblWeek' | translate }}</option>\r\n                                        <option value=\"MONTH\">{{ 'LblMonth' | translate }}</option>\r\n                                        <option value=\"PERBOOKING\">{{ 'lblPerBooking' | translate }}</option>\r\n                                    </select>\r\n                                    <div class=\"clearfix\"></div>\r\n                                    <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'OdometerConfigurationModel.TimeInterval' }}</span>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </fieldset>\r\n\r\n                    <fieldset *ngIf=\"model.directDebitFileEnabledOnInstance\" class=\"col-md-6\">\r\n                        <legend class=\"legendStyle\">{{ 'LblDirectDebitConfiguration' | translate }}</legend>\r\n                        <div class=\"row\">\r\n\r\n                            <template [ngIf]=\"model.directDebitfileConfigModel\">\r\n                                <div>\r\n                                    <div class=\"form-group col-md-6\">\r\n                                        <label>{{ 'LbLDirectDebitEnabled' | translate }}</label>\r\n                                        <div class=\"clearfix\"></div>\r\n                                        <label class=\"radio-inline\">\r\n                                            <input [(ngModel)]=\"model.directDebitfileConfigModel.enableFileGeneration\" [value]=\"true\" name=\"directDebitfileConfigModelenabled\" type=\"radio\">\r\n                                            {{ 'LblYes' | translate }}\r\n                                        </label>\r\n                                        <label class=\"radio-inline\">\r\n                                            <input [(ngModel)]=\"model.directDebitfileConfigModel.enableFileGeneration\" [value]=\"false\" name=\"directDebitfileConfigModelenabled\" type=\"radio\">\r\n                                            {{ 'LblNo' | translate }}\r\n                                        </label>\r\n                                        <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'enableFileGeneration' }}</span>\r\n                                    </div>\r\n                                </div>\r\n\r\n                                <div *ngIf=\"model.directDebitfileConfigModel.enableFileGeneration\">\r\n                                    <div class=\"col-md-12\">\r\n                                        <h4>\r\n                                            <span class=\"text text-danger\">*</span>\r\n                                            <label>{{ 'LbLBillingInformation' | translate }}</label>\r\n                                        </h4>\r\n                                    </div>\r\n                                    \r\n                                    <div class=\"form-group col-md-6\">\r\n                                        <label>{{ 'LblCompanyName' | translate }}</label>\r\n                                        <input [(ngModel)]=\"model.directDebitfileConfigModel.companyName\" class=\"form-control\" maxlength=\"100\" name=\"companyName\" placeholder=\"{{ 'LblCompanyName' | translate }}\" type=\"text\">\r\n                                        <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'directDebitfileConfigModel.companyName' }}</span>\r\n                                    </div>\r\n\r\n                                    <div class=\"form-group col-md-6\">\r\n                                        <label>{{ 'LblAddress' | translate }}</label>\r\n                                        <input [(ngModel)]=\"model.directDebitfileConfigModel.address\" class=\"form-control\" maxlength=\"200\" name=\"address\" placeholder=\"{{ 'LblAddress' | translate }}\" type=\"text\">\r\n                                        <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'directDebitfileConfigModel.address' }}</span>\r\n                                    </div>\r\n\r\n                                    <div class=\"form-group col-md-6\">\r\n                                        <label>{{ 'LblIBANNumber' | translate }}</label>\r\n                                        <input [(ngModel)]=\"model.directDebitfileConfigModel.ibanNumber\" class=\"form-control\" maxlength=\"100\" name=\"ibanNumber\" placeholder=\"{{ 'LblIBANNumber' | translate }}\" type=\"text\">\r\n                                        <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'directDebitfileConfigModel.iBANNumber' }}</span>\r\n                                    </div>\r\n\r\n                                    <div class=\"form-group col-md-6\">\r\n                                        <label>{{ 'LblBICCode' | translate }}</label>\r\n                                        <input [(ngModel)]=\"model.directDebitfileConfigModel.bicCode\" class=\"form-control\" maxlength=\"100\" name=\"bicCode\" placeholder=\"{{ 'LblBICCode' | translate }}\" type=\"text\">\r\n                                        <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'directDebitfileConfigModel.bicCode' }}</span>\r\n                                    </div>\r\n\r\n                                    <div class=\"clearfix\"></div>\r\n\r\n                                    <div class=\"form-group col-md-6\">\r\n                                        <label>{{ 'LblCountryCode' | translate }}</label>\r\n                                        <input [(ngModel)]=\"model.directDebitfileConfigModel.countryCode\" class=\"form-control\" maxlength=\"20\" name=\"address\" placeholder=\"{{ 'LblCountryCode' | translate }}\" type=\"text\">\r\n                                        <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'directDebitfileConfigModel.countryCode' }}</span>\r\n                                    </div>\r\n\r\n                                    <div class=\"clearfix\"></div>\r\n\r\n                                </div>\r\n                            </template>\r\n\r\n                        </div>\r\n                    </fieldset>\r\n\r\n                    <fieldset class=\"col-md-6\">\r\n                        <legend class=\"legendStyle\">{{ 'LblDefaultVehicleSetting' | translate }}</legend>\r\n                        <div class=\"row\">\r\n\r\n                            <div class=\"form-group col-md-6\">\r\n                                <label><span class=\"text text-danger\">*</span>{{ 'LblLowBatteryFlagRaised' | translate }}</label>\r\n                                <input [(ngModel)]=\"model.lowBatteryFlagRaised\" class=\"form-control\" maxlength=\"4\" name=\"LowBatteryFlagRaised\" placeholder=\"{{ 'LblLowBatteryFlagRaised' | translate }}\" type=\"text\">\r\n                                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'lowBatteryFlagRaised' }}</span>\r\n                            </div>\r\n\r\n                            <div class=\"form-group col-md-6\">\r\n                                <label><span class=\"text text-danger\">*</span>{{ 'LblLowBatteryFlagClear' | translate }}</label>\r\n                                <input [(ngModel)]=\"model.lowBatteryFlagClear\" class=\"form-control\" maxlength=\"4\" name=\"LowBatteryFlagClear\" placeholder=\"{{ 'LblLowBatteryFlagClear' | translate }}\" type=\"text\">\r\n                                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'lowBatteryFlagClear' }}</span>\r\n                            </div>\r\n                            <div class=\"clearfix\"></div>\r\n                        </div>\r\n                    </fieldset>\r\n\r\n                    <!--Start Booking Delay Configuration-->\r\n                    <fieldset *ngIf=\"model.bookingDelayConfigurationEnabledOnInstance\" class=\"col-md-6\">\r\n                        <legend class=\"legendStyle\"><span class=\"text text-danger\">*</span> {{ 'LblBookingDelayConfig' | translate }}</legend>\r\n                        <div class=\"row\">\r\n\r\n                            <div class=\"form-group col-md-12\">\r\n                                <label>{{ 'LblBookingDelayConfigEnabled' | translate }}</label>\r\n                                <div>\r\n                                    <label class=\"radio-inline\">\r\n                                        <input [(ngModel)]=\"model.bookingDelayConfig.enabled\" name=\"BookingDelayConfigEnabled\" type=\"radio\" value=\"YES\">\r\n                                        {{ 'LblYes' | translate }}\r\n                                    </label>\r\n                                    <label class=\"radio-inline\">\r\n                                        <input [(ngModel)]=\"model.bookingDelayConfig.enabled\" name=\"BookingDelayConfigEnabled\" type=\"radio\" value=\"NO\">\r\n                                        {{ 'LblNo' | translate }}\r\n                                    </label>\r\n                                    <label class=\"radio-inline\">\r\n                                        <input [(ngModel)]=\"model.bookingDelayConfig.enabled\" name=\"BookingDelayConfigEnabled\" type=\"radio\" value=\"INHERIT\">\r\n                                        {{ 'LblInherit' | translate }}\r\n                                    </label>\r\n                                </div>\r\n                            </div>\r\n                            <div class=\"clearfix\"></div>\r\n\r\n                        </div>\r\n                    </fieldset>\r\n                </div>\r\n\r\n                <div class=\"row col-md-12 mar_bot_20\">\r\n                    <fieldset class=\"col-md-6\">\r\n                        <legend class=\"legendStyle\">{{ 'LblVatSettings' | translate }}</legend>\r\n                        <div class=\"row\">\r\n\r\n                            <div class=\"form-group col-md-12\">\r\n                                <label class=\"radio-inline\">\r\n                                    <input [(ngModel)]=\"model.isVatSettingAvailable\" [value]=\"true\" name=\"enableVatSetting\" type=\"radio\">\r\n                                    {{ 'LblYes' | translate }}\r\n                                </label>\r\n                                <label class=\"radio-inline\">\r\n                                    <input [(ngModel)]=\"model.isVatSettingAvailable\" [value]=\"false\" name=\"enableVatSetting\" type=\"radio\">\r\n                                    {{ 'LblInherit' | translate }}\r\n                                </label>\r\n                            </div>\r\n\r\n                            <div class=\"clearfix\"></div>\r\n                            <wego-vat-setting (OnVatSetting)=\"OnVatSetting($event)\" *ngIf=\"model.isVatSettingAvailable\" [ErrorModel]=\"errorModel\" [VatDefaultRate]=\"model.vatDefaultRate\" [VatSettingDefaultCost]=\"model.vatSettingDefaultCost\" [VatSettingsList]=\"model.vatSettingsList\"></wego-vat-setting>\r\n                        </div>\r\n                    </fieldset>\r\n\r\n                    <fieldset *ngIf=\"!model.companyMasterHashId\" class=\"col-md-6 mar_t_20\">\r\n                        <legend class=\"legendStyle\">{{ 'LblInvoicingSettings' | translate }}</legend>\r\n\r\n                        <div class=\"row\">\r\n                            <wego-invoicing-setting [ErrorModel]=\"errorModel\" [InvoiceSettings]=\"model.invoiceSettings\" [childCompanyName]=\"parentCompanyName.value\" [companyAddress]=\"combinedCompanyAddress\"></wego-invoicing-setting>\r\n                        </div>\r\n                    </fieldset>\r\n\r\n                    <div class=\"clearfix\"></div>\r\n\r\n                    <fieldset *ngIf=\"TwoFaEnabled\" class=\"col-md-6 mar_t_20\">\r\n                        <legend class=\"legendStyle\"><span class=\"text text-danger\">*</span> {{ 'LblTwoFaConfig' | translate }}</legend>\r\n\r\n                        <div class=\"row\">\r\n                            <div class=\"form-group col-md-12\">\r\n                                <label><span class=\"text text-danger\">*</span> {{ 'LblEnableTwoFa' | translate }}</label>\r\n                                <div>\r\n                                    <label class=\"radio-inline\">\r\n                                        <input [(ngModel)]=\"model.twoFAConfig.enabled\" name=\"EnableTwoFa\" type=\"radio\" value=\"YES\">\r\n                                        {{ 'LblYes' | translate }}\r\n                                    </label>\r\n                                    <label class=\"radio-inline\">\r\n                                        <input [(ngModel)]=\"model.twoFAConfig.enabled\" name=\"EnableTwoFa\" type=\"radio\" value=\"NO\">\r\n                                        {{ 'LblNo' | translate }}\r\n                                    </label>\r\n                                    <label class=\"radio-inline\">\r\n                                        <input [(ngModel)]=\"model.twoFAConfig.enabled\" name=\"EnableTwoFa\" type=\"radio\" value=\"INHERIT\">\r\n                                        {{ 'LblInherit' | translate }}\r\n                                    </label>\r\n                                </div>\r\n                            </div>\r\n\r\n                            <div *ngIf=\"model.twoFAConfig.enabled=='YES'\" class=\"form-group col-md-6\">\r\n                                <label>{{ 'LblExpirationDays' | translate }}</label>\r\n                                <input [(ngModel)]=\"model.twoFAConfig.expirationDays\" class=\"form-control\" maxlength=\"3\" name=\"ExpirationDays\" placeholder=\"{{ 'LblExpirationDays' | translate }}\" type=\"text\">\r\n                                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'TwoFAConfig.ExpirationDays' }}</span>\r\n                            </div>\r\n\r\n                            <div *ngIf=\"model.twoFAConfig.enabled!='NO'\" class=\"form-group col-md-12\">\r\n                                <a (click)=\"ResetCookies()\" *ngIf=\"model.twoFAConfig.enableResetCookie\" class=\"btn btn-highlight navbar-left\">\r\n                                    {{ 'LblResetCookiesForAllAdmin' | translate }}\r\n                                </a>\r\n                                <div class=\"clearfix\"></div>\r\n                                <a (click)=\"ResetTwoFA()\" *ngIf=\"model.twoFAConfig.enableResetKey\" class=\"btn btn-highlight navbar-left mar_t_5\">\r\n                                    {{ 'LblReset2FaForAllAdmin' | translate }}\r\n                                </a>\r\n                            </div>\r\n                        </div>\r\n                    </fieldset>\r\n\r\n                    <fieldset *ngIf=\"model.companyMasterHashId\" class=\"col-md-6\">\r\n                        <legend class=\"legendStyle\">{{ 'LblInvoicingSettings' | translate }}</legend>\r\n                        <div class=\"row\">\r\n                            <wego-invoicing-setting [ErrorModel]=\"errorModel\" [InvoiceSettings]=\"model.invoiceSettings\" [childCompanyName]=\"model.invoiceSettings.companyName\" [companyAddress]=\"model.invoiceSettings.address\"></wego-invoicing-setting>\r\n                        </div>\r\n                    </fieldset>\r\n                </div>\r\n\r\n                <div *ngIf=\"model.paymentSettingRequiredOnInstance\" class=\"row col-md-12 mar_bot_20\">\r\n                    <fieldset class=\"col-md-12\">\r\n                        <legend class=\"legendStyle\"><span class=\"text text-danger\">*</span> {{ 'LblPaymentSetting' | translate }}</legend>\r\n                        <div class=\"row\">\r\n\r\n                            <div class=\"form-group col-md-12\">\r\n                                <label class=\"radio-inline\">\r\n                                    <input [(ngModel)]=\"model.isPaymentEnabled\" [value]=\"true\" name=\"isPaymentEnable\" type=\"radio\">\r\n                                    {{ 'LblYes' | translate }}\r\n                                </label>\r\n                                <label class=\"radio-inline\">\r\n                                    <input [(ngModel)]=\"model.isPaymentEnabled\" [value]=\"false\" name=\"isPaymentEnable\" type=\"radio\">\r\n                                    {{ 'LblNo' | translate }}\r\n                                </label>\r\n                            </div>\r\n\r\n                            <div *ngIf=\"model.isPaymentEnabled\" class=\"col-md-12\">\r\n                                <div *ngIf=\"!model.paymentSettingModel.overviewUrl\">\r\n                                    <div class=\"row\">\r\n\r\n                                        <div class=\"form-group col-md-3\">\r\n                                            <label>{{'LblPaymentProvider' | translate}}</label>\r\n                                            <div class=\"clearfix\"></div>\r\n\r\n                                            <select [(ngModel)]=\"model.paymentSettingModel.paymentProvider\" class=\"form-control\" name=\"paymentProvider\">\r\n                                                <option *ngFor=\"let provider of PaymentProvider.values()\">\r\n                                                    {{provider}}\r\n                                                </option>\r\n                                            </select>\r\n                                            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'paymentSettingModel.paymentProvider'}}</span>\r\n                                        </div>\r\n\r\n                                        <div class=\"form-group col-md-3\">\r\n                                            <label>{{ 'LblChamberOfCommerce' | translate }}</label>\r\n                                            <input [(ngModel)]=\"model.paymentSettingModel.chamberOfCommerce\" class=\"form-control\" maxlength=\"100\" name=\"chamberOfCommerce\" placeholder=\"{{ 'LblChamberOfCommerce' | translate }}\" type=\"text\">\r\n                                            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'paymentSettingModel.chamberOfCommerce' }}</span>\r\n                                        </div>\r\n\r\n                                        <div class=\"form-group col-md-3\">\r\n                                            <label>{{ 'LblEmailAddress' | translate }}</label>\r\n                                            <input [(ngModel)]=\"model.paymentSettingModel.emailAddress\" class=\"form-control\" maxlength=\"100\" name=\"lblEmailAddress\" placeholder=\"{{ 'LblEmailAddress' | translate }}\" type=\"email\">\r\n                                            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'paymentSettingModel.emailaddress' }}</span>\r\n                                        </div>\r\n\r\n                                        <div class=\"form-group col-md-3\">\r\n                                            <label>{{ 'LblPhoneNumber' | translate }}</label>\r\n                                            <input [(ngModel)]=\"model.paymentSettingModel.phoneNumber\" class=\"form-control\" maxlength=\"x100\" name=\"LblPhoneNumber\" placeholder=\"{{ 'LblPhoneNumber' | translate }}\" type=\"tel\">\r\n                                            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'paymentSettingModel.phoneNumber' }}</span>\r\n                                        </div>\r\n\r\n                                        <div class=\"form-group col-md-3\">\r\n                                            <label>{{'LblCountry' | translate}}</label>\r\n                                            <div class=\"clearfix\"></div>\r\n\r\n                                            <select [(ngModel)]=\"model.paymentSettingModel.country\" class=\"form-control\" name=\"country\">\r\n                                                <option *ngFor=\"let country of Country.values()\">\r\n                                                    {{country}}\r\n                                                </option>\r\n                                            </select>\r\n                                            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'paymentSettingModel.country'}}</span>\r\n                                        </div>\r\n\r\n                                    </div>\r\n                                </div>\r\n\r\n                                <div class=\"form-group col-md-3\">\r\n                                    <label>{{'LblInvoicePaymentTermDays' | translate}}</label>\r\n                                    <div class=\"clearfix\"></div>\r\n\r\n                                    <input [(ngModel)]=\"model.paymentSettingModel.invoicePaymentTermDays\" class=\"form-control\" maxlength=\"5\" name=\"paymentInvoicePaymentTermDays\" placeholder=\"{{ 'LblInvoicePaymentTermDays' | translate }}\" type=\"text\">\r\n                                    <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'paymentSettingModel.invoicePaymentTermDays' }}</span>\r\n                                </div>\r\n\r\n                                <div class=\"form-group col-md-3\">\r\n                                    <label>{{'LblLinkValidityDays' | translate}}</label>\r\n                                    <div class=\"clearfix\"></div>\r\n\r\n                                    <input [(ngModel)]=\"model.paymentSettingModel.paymentLinkValidityDays\" class=\"form-control\" maxlength=\"5\" name=\"paymentLinkValidityDays\" placeholder=\"{{ 'LblLinkValidityDays' | translate }}\" type=\"text\">\r\n                                    <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'paymentSettingModel.paymentLinkValidityDays' }}</span>\r\n                                </div>\r\n                            </div>\r\n\r\n                            <div *ngIf=\"model.isPaymentEnabled\" class=\"col-md-12\">\r\n                                <div class=\"form-group\">\r\n                                    <label>{{ 'LblPaymentMethods' | translate }}</label>\r\n                                    <div class=\"clearfix\"></div>\r\n                                    <label *ngFor=\"let paymentMethod of paymentMethods\" class=\"checkbox-inline\" style=\"margin-left: 0px; margin-right: 10px;\">\r\n                                        <input [checked]=\"paymentMethod.checked\" name=\"paymentMethods\" type=\"checkbox\" (change)=\"OnChangePaymentMethod(paymentMethod, $event.target.checked)\"/>\r\n                                        {{paymentMethod.name }}\r\n                                    </label>\r\n                                </div>\r\n                            </div>\r\n\r\n                            <!--<div class=\"form-group col-md-4\">\r\n                                <span class=\"text text-danger\">*</span>\r\n                                <label>{{ 'LblDamageImageExtentions' | translate }}</label>\r\n                                <div class=\"clearfix\"></div>\r\n                                <label class=\"checkbox-inline\" *ngFor=\"let imageExtention of damageImageExtentions\" style=\"margin-left: 0px; margin-right: 10px;\">\r\n                                    <input type=\"checkbox\" (change)=\"OnChangeDamageImageExtension(imageExtention, $event.target.checked)\" value=\"imageExtention.value\"\r\n                                        [checked]=\"imageExtention.IsChecked\" /> {{imageExtention.Key}}\r\n                                </label>\r\n                                <div class=\"clearfix\"></div>\r\n                                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'damageImageExtensions' }}</span>\r\n                            </div>-->\r\n\r\n                            <div *ngIf=\"model.paymentSettingModel.overviewUrl\" class=\"form-group col-md-3\">\r\n                                <button (click)=\"NavigateToPaymentConfigurationPage($event)\" class=\"btn btn-green\">{{ 'LblPaymentConfigButton' | translate }}</button>\r\n                            </div>\r\n                        </div>\r\n                    </fieldset>\r\n                </div>\r\n\r\n                <!-- Pre Post trip Question at instance level -->\r\n                <div *ngIf=\"isAuthorizedForPrePostTrip\" class=\"row col-md-12 mar_bot_20\">\r\n                    <fieldset class=\"col-md-12\">\r\n                        <legend class=\"legendStyle\">\r\n                            {{ 'LblPrePostTripQuestions' | translate }}\r\n                        </legend>\r\n                        <wego-pre-post-trip-question #prePostTripQuestionSection (OnPrePostTripQuestionSetting)=\"OnPrePostTripQuestionSetting($event)\" [CustomTripQuestionList]=\"model.customTripQuestionList\" [ErrorModel]=\"errorModel\"></wego-pre-post-trip-question>\r\n                    </fieldset>\r\n                </div>\r\n\r\n                <div class=\"row col-md-12 mar_bot_20\">\r\n                    <fieldset class=\"col-md-6\">\r\n                        <legend class=\"legendStyle\">{{ 'LblUserBlockMessage' | translate }}</legend>\r\n\r\n                        <div class=\"row\">\r\n                            <div class=\"form-group col-md-12\">\r\n                                <label>{{ 'LblUserBlockMessage' | translate }}</label>\r\n                                <div>\r\n                                    <input [(ngModel)]=\"model.userBlockMessage\" class=\"form-control\" maxlength=\"500\" name=\"userBlockMessage\" placeholder=\"{{ 'LblUserBlockMessage' | translate }}\" type=\"text\">\r\n                                    <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'userBlockMessage' }}</span>\r\n                                </div>\r\n                            </div>\r\n                        </div>\r\n                    </fieldset>\r\n                </div>\r\n\r\n                <div class=\"row no-margin\">\r\n                    <div class=\"col-sm-12\">\r\n                        <hr>\r\n                        <a (click)=\"OnBackClick()\" class=\"btn btn-gray cursor-pointer\">{{ 'LblCancel' | translate }}</a>\r\n                        &nbsp;&nbsp;\r\n                        <button class=\"btn btn-green\" type=\"submit\">{{ 'LblSave' | translate }}</button>\r\n                    </div>\r\n                </div>\r\n            </form>\r\n        </div>\r\n    </section>\r\n</div>\r\n<wego-success-popup #successPopup (onConfirm)=\"ConfirmSuccessPopup()\" [popupMsg]=\"popupMsg\"></wego-success-popup>\r\n<wego-vat-setting-popup #vatSettingsPopup (onVatConfirm)=\"onVatConfirm($event)\"></wego-vat-setting-popup>\r\n<wego-success-popup #TwoFasuccessPopup (onConfirm)=\"ConfirmTwoFaPopup()\" [popupMsg]=\"popupMsg\"></wego-success-popup>\r\n<!--<wego-geolocation-popup #geoLocationModal [markerInfo]=\"markerInfo\" (onConfirm)=\"GetGeoLocation($event)\"></wego-geolocation-popup>-->\r\n";

/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var company_service_1 = __webpack_require__(501);
	var CompanyContactPopupComponent = (function () {
	    function CompanyContactPopupComponent(companyService, authService, router) {
	        this.companyService = companyService;
	        this.authService = authService;
	        this.router = router;
	        this.onSuccessSelect = new core_1.EventEmitter();
	    }
	    CompanyContactPopupComponent.prototype.ngOnInit = function () {
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.searchField = ["userName", "firstName", "lastName"];
	        this.urlPersonUpdate = this.authService.GetURL(config_1.ApplicationRouteURL.URL_PERSON_UPDATE);
	    };
	    CompanyContactPopupComponent.prototype.ngOnChanges = function (change) {
	        console.log(change);
	    };
	    CompanyContactPopupComponent.prototype.show = function () {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.sortType = "";
	        this.DataListModel.sortReverse = null;
	        this.DataListModel.searchTerm = "";
	        this.DataListModel.infoMessage = "";
	        this.GetContactPersonList();
	        this.contactPersonModal.show();
	    };
	    CompanyContactPopupComponent.prototype.hide = function () {
	        this.contactPersonModal.hide();
	    };
	    CompanyContactPopupComponent.prototype.GetContactPersonList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.companyService.GetPersonListForContactPerson(this.companyMasterHashId, this.DataListModel)
	            .subscribe(function (res) {
	            _this.personList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    CompanyContactPopupComponent.prototype.select = function (hashId) {
	        var _this = this;
	        this.isLoading = true;
	        this.companyService.UpdateCompanyContactPerson(this.companyMasterHashId, hashId)
	            .subscribe(function (res) {
	            _this.message = "Record Saved successfully.";
	            _this.OnSuccessSelect();
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        }, function () {
	            _this.contactPersonModal.hide();
	            _this.isLoading = false;
	        });
	    };
	    CompanyContactPopupComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetContactPersonList();
	    };
	    CompanyContactPopupComponent.prototype.OnSearch = function (event) {
	        this.DataListModel.searchTerm = event.searchTerm;
	        this.DataListModel.currentPage = 1;
	        this.GetContactPersonList();
	    };
	    CompanyContactPopupComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetContactPersonList();
	    };
	    ;
	    CompanyContactPopupComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetContactPersonList();
	    };
	    CompanyContactPopupComponent.prototype.OnSuccessSelect = function () {
	        this.onSuccessSelect.emit({ SuccessMessage: this.message });
	    };
	    __decorate([
	        core_1.Output('OnSuccessSelect'), 
	        __metadata('design:type', Object)
	    ], CompanyContactPopupComponent.prototype, "onSuccessSelect", void 0);
	    __decorate([
	        core_1.ViewChild('contactPersonModal'), 
	        __metadata('design:type', Object)
	    ], CompanyContactPopupComponent.prototype, "contactPersonModal", void 0);
	    CompanyContactPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-company-contact-person',
	            template: __webpack_require__(833),
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof company_service_1.CompanyService !== 'undefined' && company_service_1.CompanyService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object])
	    ], CompanyContactPopupComponent);
	    return CompanyContactPopupComponent;
	    var _a, _b, _c;
	}());
	exports.CompanyContactPopupComponent = CompanyContactPopupComponent;


/***/ },
/* 833 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #contactPersonModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n               <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblAddNew' | translate }} {{ 'LblContactPerson' | translate }} </h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <wego-search-list [IsExported]=\"false\" [SearchTerm]=\"DataListModel.searchTerm\" (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center\">\r\n                  {{ 'LblSelect' | translate }}\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('firstName')\">\r\n                  {{ 'LblFirstName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'firstName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('lastName')\">\r\n                  {{ 'LblLastName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'lastName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('userName')\">\r\n                  {{ 'LblUserName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'userName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let person of personList\">\r\n                    <td class=\"text-center\">\r\n                        <a class=\"cursor-pointer\" (click)=\"select(person.personMasterHashId)\">\r\n                            <i class=\"fa fa-plus-square\"></i>\r\n                        </a>\r\n                    </td>\r\n                    <td>{{ person.firstName }}</td>\r\n                    <td>{{ person.lastName }} </td>\r\n                    <td>{{ person.userName }}</td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0\">\r\n                <td class=\"text-center text-danger\" colspan=\"4\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\" [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\"\r\n                firstText=\"&laquo;\" lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var company_service_1 = __webpack_require__(501);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var CompanyListComponent = (function () {
	    function CompanyListComponent(companyService, authService, router, translate) {
	        this.companyService = companyService;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.roleLevel = config_1.RoleLevel;
	    }
	    Object.defineProperty(CompanyListComponent.prototype, "isAnyChecked", {
	        get: function () {
	            if (this.companyList) {
	                var isCheck = this.companyList.some(function (x) { return x.isChecked == true; });
	                if (isCheck) {
	                    if (this.companyList.every(function (x) { return x.isChecked == true; }))
	                        this.isParentCheck = true;
	                    else
	                        this.isParentCheck = false;
	                }
	                else {
	                    this.isParentCheck = false;
	                }
	                return isCheck;
	            }
	            else {
	                this.isParentCheck = false;
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    CompanyListComponent.prototype.ngOnInit = function () {
	        this.module = this.translate.instant('LblCompany');
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        if (this.authService.GetHighestRoleLevel() <= this.roleLevel.Instance) {
	            this.DataListModel.searchField = ["companyName", "contactPersonName", "instanceName"];
	        }
	        else {
	            this.DataListModel.searchField = ["companyName", "contactPersonName"];
	        }
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlCompanyAdd = this.authService.GetURL(config_1.ApplicationRouteURL.URL_COMPANY_ADD);
	        this.urlCompanyUpdate = this.authService.GetURL(config_1.ApplicationRouteURL.URL_COMPANY_UPDATE);
	        this.urlCompanyAdmin = this.authService.GetURL(config_1.ApplicationRouteURL.URL_COMPANYADMIN_LIST);
	        this.urlVehicleList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_VEHICLE_LIST);
	        this.urlSharedVehicleGroupList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SVG_LIST);
	        this.urlAdminOfCompanyList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_ADMIN_OF_COMPANY_LIST);
	        this.GetCompanyList();
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	        this.addCompanyLink = new config_1.WeGoAuthorizedLink(this.urlCompanyAdd, config_1.Permission.PR_COMPANY_OVERVIEW, config_1.PermissionType.INSERT, 'btn btn-highlight navbar-right', 'LblAddNew');
	    };
	    CompanyListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetCompanyList();
	    };
	    Object.defineProperty(CompanyListComponent.prototype, "isDeleteAccess", {
	        get: function () {
	            if (this.companyList) {
	                return this.companyList.some(function (x) { return x.isDeletable; });
	            }
	            else {
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    CompanyListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetCompanyList();
	    };
	    CompanyListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetCompanyList();
	    };
	    ;
	    CompanyListComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetCompanyList();
	    };
	    CompanyListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.companyService.ExportCompanyList(this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "Company" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    CompanyListComponent.prototype.GetCompanyList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.companyService.GetCompanyList(this.DataListModel)
	            .subscribe(function (res) {
	            _this.companyList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    CompanyListComponent.prototype.ShowContactPersonModal = function (companyMasterHashId) {
	        this.companyContactPersonModal.companyMasterHashId = companyMasterHashId;
	        this.companyContactPersonModal.show();
	    };
	    CompanyListComponent.prototype.SuccessContactPersonModal = function ($event) {
	        this.GetCompanyList();
	        this.popupMsg = this.translate.instant('LblContactPersonAddedSuccess'); //$event.SuccessMessage;
	        this.ShowSuccessPopup();
	    };
	    CompanyListComponent.prototype.DeleteCompany = function (deleteCompanyList) {
	        var _this = this;
	        this.isLoading = true;
	        this.companyService.DeleteCompany(deleteCompanyList)
	            .subscribe(function (res) {
	            _this.DataListModel.currentPage = 1;
	            _this.GetCompanyList();
	            _this.popupMsg = _this.translate.instant('LblRecordRemovedSuccess', [_this.module]);
	            _this.ShowSuccessPopup();
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    CompanyListComponent.prototype.OnParentCheck = function (isChecked) {
	        this.companyList.filter(function (x) { return x.isDeletable; }).forEach(function (x) { return x.isChecked = isChecked; });
	    };
	    CompanyListComponent.prototype.ShowChildModal = function (companyMasterHashId) {
	        this.deleteCompanyMasterHashId = companyMasterHashId;
	        if (companyMasterHashId) {
	            this.popupMsg = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
	            this.isMultipleDelete = false;
	            this.deleteCompanyMasterHashId = companyMasterHashId;
	        }
	        else {
	            this.popupMsg = this.translate.instant('LblRecordMultiplDeleteConfirmation', [this.module]);
	            this.isMultipleDelete = true;
	        }
	        this.childModal.show();
	    };
	    CompanyListComponent.prototype.HideChildModal = function () {
	        this.deleteCompanyMasterHashId = "";
	        this.childModal.hide();
	    };
	    CompanyListComponent.prototype.SuccessModalClick = function () {
	        var deleteCompanyList;
	        if (this.isMultipleDelete)
	            deleteCompanyList = this.companyList.filter(function (x) { return x.isChecked; }).map(function (x) { return x.companyMasterHashId; });
	        else
	            deleteCompanyList.push(this.deleteCompanyMasterHashId);
	        this.DeleteCompany(deleteCompanyList);
	        this.childModal.hide();
	    };
	    CompanyListComponent.prototype.ShowRemoveContactPersonModal = function (companyMasterHashId) {
	        this.removeContactPersonCompanyHashId = companyMasterHashId;
	        this.popupMsg = this.translate.instant('LblRemoveContactPersonConfirm');
	        this.removeContactPersonModal.show();
	    };
	    CompanyListComponent.prototype.HideRemoveContactPersonModal = function () {
	        this.removeContactPersonCompanyHashId = "";
	        this.removeContactPersonModal.hide();
	    };
	    CompanyListComponent.prototype.SuccessModalRemoveContactPersonClick = function () {
	        this.RemoveCompanyContactPerson();
	        console.log(this.removeContactPersonCompanyHashId);
	        this.removeContactPersonModal.hide();
	    };
	    CompanyListComponent.prototype.RemoveCompanyContactPerson = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.companyService.RemocveCompanyContactPerson(this.removeContactPersonCompanyHashId)
	            .subscribe(function (res) {
	            _this.popupMsg = _this.translate.instant('LblContactPersonRemoveSuccess');
	            _this.GetCompanyList();
	            _this.isLoading = false;
	            _this.ShowSuccessPopup();
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        }, function () {
	            _this.removeContactPersonModal.hide();
	            _this.isLoading = false;
	        });
	    };
	    CompanyListComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    CompanyListComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    CompanyListComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    CompanyListComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    __decorate([
	        core_1.ViewChild('companyContactPersonModal'), 
	        __metadata('design:type', Object)
	    ], CompanyListComponent.prototype, "companyContactPersonModal", void 0);
	    __decorate([
	        core_1.ViewChild('childModal'), 
	        __metadata('design:type', Object)
	    ], CompanyListComponent.prototype, "childModal", void 0);
	    __decorate([
	        core_1.ViewChild('removeContactPersonModal'), 
	        __metadata('design:type', Object)
	    ], CompanyListComponent.prototype, "removeContactPersonModal", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], CompanyListComponent.prototype, "successPopup", void 0);
	    CompanyListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-company',
	            template: __webpack_require__(835) + config_1.WeGoConfig.APP_VERSION,
	            providers: [company_service_1.CompanyService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof company_service_1.CompanyService !== 'undefined' && company_service_1.CompanyService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object])
	    ], CompanyListComponent);
	    return CompanyListComponent;
	    var _a, _b, _c, _d;
	}());
	exports.CompanyListComponent = CompanyListComponent;


/***/ },
/* 835 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ breadCrumbList}} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li class=\"active\"> {{ breadCrumbList}} </li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25\">\r\n      <wego-authorized-link [LinkModel]=\"addCompanyLink\"></wego-authorized-link>\r\n    </div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <p class=\"text-success\">{{ message }}</p>\r\n        <wego-search-list [IsDeleted]=\"isDeleteAccess\" [IsDeleteEnabled]=\"isAnyChecked\" (OnDeleteAll)=\"ShowChildModal()\" (OnSearch)=\"OnSearch($event)\"\r\n          (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th *ngIf=\"isDeleteAccess\" class=\"text-center parent-checkbox\">\r\n                  <input type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\">\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('companyName')\">\r\n                  {{ 'LblCompanyName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'companyName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Instance\" class=\"cursor-pointer\" (click)=\"OnSort('instanceName')\">\r\n                  {{ 'LblInstance' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'instanceName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('contactPersonName')\">\r\n                  {{ 'LblContactPerson' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'contactPersonName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"text-center\">{{ 'LblAdmin' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblNoOfVegicles' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblNoOfSharedVehicleGroups' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblEdit' | translate }}</th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let company of companyList\">\r\n                  <td *ngIf=\"isDeleteAccess\" class=\"text-center\">\r\n                    <input *ngIf=\"!company.isDeletable\" disabled type=\"checkbox\" name=\"isActive\">\r\n                    <input *ngIf=\"company.isDeletable\" type=\"checkbox\" name=\"isActive\" [(ngModel)]=\"company.isChecked\">\r\n                  </td>\r\n                  <td>{{ company.companyName }}</td>\r\n                  <td *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Instance\">{{company.instanceName}}</td>\r\n                  <td>\r\n                    <span *ngIf=\"(company.isContactPersonAdd && !company.contactPersonHashID) || (company.isContactPersonEdit && company.contactPersonHashID)\"\r\n                      title=\"{{'LblAddContactPerson' | translate}}\">\r\n                      <a class=\"cursor-pointer\" (click)=\"ShowContactPersonModal(company.companyMasterHashId)\">\r\n                        <i class=\"fa fa-phone-square fa-fw\"></i>\r\n                      </a>\r\n                    </span>\r\n                    <span *ngIf=\"company.isContactPersonView\">{{ company.contactPersonName }}</span>\r\n                    <span class=\"pull-right\" *ngIf=\"company.isContactPersonDelete && company.contactPersonHashID\" title=\"{{'LblRemoveContactPerson' | translate}}\">\r\n                      <a class=\"cursor-pointer\" (click)=\"ShowRemoveContactPersonModal(company.companyMasterHashId)\">\r\n                        <i class=\"fa fa-times fa-fw text-danger\"></i>\r\n                      </a>\r\n                    </span>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"!company.isAdminCount\" class=\"btn btn-primary cursor-pointer link-style\" disabled>\r\n                      <span class=\"badge link-text\">{{ company.adminCount }}</span>\r\n                    </a>\r\n                    <a *ngIf=\"company.isAdminCount\" class=\"btn btn-primary cursor-pointer link-style\" [routerLink]=\"urlAdminOfCompanyList+ '/' + company.companyMasterHashId\">\r\n                      <span class=\"badge link-text\">{{ company.adminCount }}</span>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"!company.isVehicleCount\" class=\"btn btn-primary cursor-pointer link-style\" disabled>\r\n                      <span class=\"badge link-text\">{{ company.totalVehicles }}</span>\r\n                    </a>\r\n                    <a *ngIf=\"company.isVehicleCount\" class=\"btn btn-primary cursor-pointer link-style\" [routerLink]=\"[urlVehicleList, { ownerCompanyHashID : company.companyMasterHashId }]\">\r\n                      <span class=\"badge link-text\">{{ company.totalVehicles }}</span>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"!company.isSVGCount\" class=\"btn btn-primary cursor-pointer link-style\" disabled>\r\n                      <span class=\"badge link-text\">{{ company.totalSharedVehicleGroups }}</span>\r\n                    </a>\r\n                    <a *ngIf=\"company.isSVGCount\" class=\"btn btn-primary cursor-pointer link-style\" [routerLink]=\"[urlSharedVehicleGroupList, { companyHashId : company.companyMasterHashId }]\">\r\n                      <span class=\"badge link-text\">{{ company.totalSharedVehicleGroups }}</span>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"company.isEditable\" [routerLink]=\"urlCompanyUpdate + '/' + company.companyMasterHashId\">\r\n                      <i class=\"fa fa-pencil-square-o fa-fw\"></i>\r\n                    </a>\r\n                  </td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"8\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<wego-company-contact-person #companyContactPersonModal (OnSuccessSelect)=\"SuccessContactPersonModal($event)\"></wego-company-contact-person>\r\n\r\n<wego-confirm-popup #childModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessModalClick()\" (onReject)=\"HideChildModal()\"></wego-confirm-popup>\r\n\r\n<wego-confirm-popup #removeContactPersonModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessModalRemoveContactPersonClick()\"\r\n  (onReject)=\"HideRemoveContactPersonModal()\"></wego-confirm-popup>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>";

/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var person_model_1 = __webpack_require__(837);
	var person_service_1 = __webpack_require__(771);
	var instance_service_1 = __webpack_require__(500);
	var router_1 = __webpack_require__(26);
	var common_1 = __webpack_require__(22);
	var config_1 = __webpack_require__(60);
	var organization_service_1 = __webpack_require__(614);
	var flatpickr_directive_1 = __webpack_require__(82);
	var flatpickr_model_1 = __webpack_require__(83);
	var PersonUpdateComponent = (function () {
	    function PersonUpdateComponent(organizationService, personService, instanceService, activeRoute, router, authService, translate, locationService) {
	        this.organizationService = organizationService;
	        this.personService = personService;
	        this.instanceService = instanceService;
	        this.activeRoute = activeRoute;
	        this.router = router;
	        this.authService = authService;
	        this.translate = translate;
	        this.locationService = locationService;
	        this.selectedInstance = "";
	        this.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
	        this.roleLevel = config_1.RoleLevel;
	    }
	    PersonUpdateComponent.prototype.ngOnInit = function () {
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlPersonList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_PERSON_LIST);
	        this.urlDriverList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DRIVER_LIST);
	        this.licenseTypeArray = [];
	        this.module = this.translate.instant("LblPerson");
	        this.model = new person_model_1.PersonModel();
	        this.model.organizationHashId = "";
	        this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
	        this.licenseTypes = [
	            {
	                Key: "AM",
	                Value: "AM",
	                IsChecked: false
	            },
	            {
	                Key: "A",
	                Value: "A",
	                IsChecked: false
	            },
	            {
	                Key: "B",
	                Value: "B",
	                IsChecked: false
	            },
	            {
	                Key: "C",
	                Value: "C",
	                IsChecked: false
	            },
	            {
	                Key: "C1",
	                Value: "C1",
	                IsChecked: false
	            },
	            {
	                Key: "D",
	                Value: "D",
	                IsChecked: false
	            },
	            {
	                Key: "T",
	                Value: "T",
	                IsChecked: false
	            }
	        ];
	        this.preferredlanguage = [
	            {
	                Key: "English",
	                Value: "en_US"
	            },
	            {
	                Key: "French",
	                Value: "fr_FR"
	            },
	            {
	                Key: "Dutch",
	                Value: "nl_NL"
	            },
	            {
	                Key: "German",
	                Value: "de_DE"
	            },
	            {
	                Key: "Polish",
	                Value: "pl_PL"
	            },
	            {
	                Key: "Spanish",
	                Value: "es_ES"
	            }
	        ];
	        this.GetTelephoneCountry();
	        this.GerPersonDetail();
	        this.GetPersonCountry();
	    };
	    PersonUpdateComponent.prototype.GetTelephoneCountry = function () {
	        var _this = this;
	        this.authService.GetTelephoneCountry()
	            .subscribe(function (res) {
	            _this.countryList = res.data;
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    PersonUpdateComponent.prototype.OnChangeLicenseType = function (licenseType, isChecked) {
	        var objIndex = this.licenseTypes.findIndex(function (x) { return x.Value == licenseType.Value; });
	        if (isChecked) {
	            this.licenseTypeArray.push(licenseType.Value);
	        }
	        else {
	            var index = this.licenseTypeArray.indexOf(licenseType.Value);
	            if (index > -1) {
	                this.licenseTypeArray.splice(index, 1);
	            }
	        }
	        this.licenseTypes[objIndex].IsChecked = isChecked;
	    };
	    PersonUpdateComponent.prototype.SetDriverLicenseOnEdit = function () {
	        if (this.model.licenseTypes != null && this.model.licenseTypes.length > 0) {
	            var LicenseArray = this.model.licenseTypes.split(",");
	            var _loop_1 = function(i) {
	                objIndex = this_1.licenseTypes.findIndex(function (x) { return x.Value == LicenseArray[i]; });
	                this_1.licenseTypes[objIndex].IsChecked = true;
	                this_1.licenseTypeArray.push(this_1.licenseTypes[objIndex].Value);
	            };
	            var this_1 = this;
	            var objIndex;
	            for (var i = 0; i < LicenseArray.length; i++) {
	                _loop_1(i);
	            }
	        }
	    };
	    PersonUpdateComponent.prototype.JoinAllDriverLicenses = function () {
	        if (this.licenseTypeArray != null && this.licenseTypeArray.length > 0)
	            this.model.licenseTypes = this.licenseTypeArray.join(",");
	        else
	            this.model.licenseTypes = "";
	    };
	    PersonUpdateComponent.prototype.GetPersonCountry = function () {
	        var _this = this;
	        this.authService.GetPersonCountry()
	            .subscribe(function (res) {
	            _this.personCountryList = res.data;
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    PersonUpdateComponent.prototype.GerPersonDetail = function () {
	        var _this = this;
	        this.sub = this.activeRoute.params.subscribe(function (params) {
	            _this.isEditMode = false;
	            _this.personHashId = params["id"] || "";
	            if (_this.personHashId != "") {
	                _this.isEditMode = true;
	                _this.personService.GetPersonByHashId(_this.personHashId).subscribe(function (res) {
	                    _this.model = res.data;
	                    _this.GetInstanceList();
	                    if (_this.model != null &&
	                        _this.model.licenseTypes != null) {
	                        _this.SetDriverLicenseOnEdit();
	                    }
	                }, function (error) {
	                    _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	                });
	            }
	            else {
	                _this.model.preferredlanguage =
	                    _this.preferredlanguage.length > 0
	                        ? _this.preferredlanguage[0].Value
	                        : "";
	                _this.GetInstanceList();
	            }
	        });
	        this.breadCrumbTitle = this.isEditMode
	            ? this.translate.instant("LblEditPage", [this.module])
	            : this.translate.instant("LblAddPage", [this.module]);
	        this.breadCrumbList = this.translate.instant("LblListPage", [this.module]);
	    };
	    PersonUpdateComponent.prototype.SetDefaultFlatPickrConfig = function (isDateOnly) {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = !isDateOnly ? true : false;
	        flatPickrConfig.time_24hr = true;
	        flatPickrConfig.dateFormat = this.dateFormat;
	        flatPickrConfig.minuteIncrement = 1;
	        flatPickrConfig.maxDate = new Date();
	        return flatPickrConfig;
	    };
	    PersonUpdateComponent.prototype.onSubmit = function (forms) {
	        this.AddNewPerson();
	    };
	    PersonUpdateComponent.prototype.GetInstanceList = function () {
	        var _this = this;
	        var permissionType = "";
	        if (this.isEditMode) {
	            permissionType = config_1.PermissionType.EDIT;
	        }
	        else {
	            permissionType = config_1.PermissionType.INSERT;
	        }
	        this.instanceService
	            .GetInstanceListDropdownForAddUpdatePage("person", permissionType)
	            .subscribe(function (res) {
	            _this.apiResponse = res;
	            _this.instanceList = res.data;
	            if (_this.instanceList.length == 1) {
	                //this.model.instanceId = this.instanceList[0].;
	                _this.model.instanceHashId = _this.instanceList[0].keyHash;
	                _this.InstanceUpdate();
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    // public GetOrganizationList() {
	    //   this.organizationService.GetOrganizationList()
	    //     .subscribe(
	    //     res => {
	    //       this.organizationList = res.data;
	    //       if (this.organizationList.length == 1) {
	    //         this.model.organizationHashId = this.organizationList[0].organizationMasterHashId;
	    //       }
	    //     },
	    //     error => {
	    //       this.errorMessage = this.authService.HandleErrorStatusCode(error);
	    //     },
	    //     () => this.GerPersonDetail()
	    //     );
	    // }
	    PersonUpdateComponent.prototype.InstanceUpdate = function () {
	        var _this = this;
	        if (this.model.instanceHashId) {
	            this.instanceService
	                .IsNIFNumberEnabled(this.model.instanceHashId)
	                .subscribe(function (res) {
	                _this.apiResponse = res;
	                var nifNumberEnabled = res.data;
	                if (nifNumberEnabled) {
	                    _this.model.isnifEnabled = true;
	                }
	                else {
	                    _this.model.isnifEnabled = false;
	                }
	            }, function (error) {
	                _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            });
	            this.instanceService
	                .GetCountryCode(this.model.instanceHashId)
	                .subscribe(function (res) {
	                _this.apiResponse = res;
	                var countryCode = res.data;
	                if (countryCode) {
	                    _this.model.countryCode1 = countryCode;
	                    _this.model.countryCode2 = countryCode;
	                }
	            }, function (error) {
	                _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            });
	            this.instanceService
	                .IsDirectDebitEnabled(this.model.instanceHashId)
	                .subscribe(function (res) {
	                _this.apiResponse = res;
	                var directDebitEnabled = res.data;
	                if (!_this.personHashId) {
	                    if (directDebitEnabled) {
	                        _this.model.directDebitFileEnabledOnInstance = true;
	                        _this.model.subjectToDirectDebit = true;
	                    }
	                    else {
	                        _this.model.directDebitFileEnabledOnInstance = false;
	                        _this.model.subjectToDirectDebit = false;
	                    }
	                }
	            }, function (error) {
	                _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            });
	            this.instanceService
	                .IsTwoFaEnabled(this.model.instanceHashId)
	                .subscribe(function (res) {
	                _this.model.isInstanceTwofaEnabled = res.data;
	                ;
	            }, function (error) {
	                _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            });
	        }
	    };
	    PersonUpdateComponent.prototype.AddNewPerson = function () {
	        var _this = this;
	        this.JoinAllDriverLicenses();
	        this.personService.AddPerson(this.model).subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.isEditMode
	                    ? _this.translate.instant("LblRecordUpdatedSuccess", [_this.module])
	                    : _this.translate.instant("LblRecordAddedSuccess", [_this.module]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    PersonUpdateComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    PersonUpdateComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    PersonUpdateComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    PersonUpdateComponent.prototype.OnBackClick = function () {
	        this.locationService.back();
	    };
	    PersonUpdateComponent.prototype.ngOnDestroy = function () {
	        if (this.sub) {
	            this.sub.unsubscribe();
	        }
	    };
	    PersonUpdateComponent.prototype.fixRfid = function () {
	        if (this.model.rfidTagId) {
	            var tag = this.model.rfidTagId.toUpperCase();
	            this.CorrectTag(tag);
	        }
	    };
	    PersonUpdateComponent.prototype.CorrectTag = function (rfidTagId) {
	        var _this = this;
	        this.personService.CorrectTag(rfidTagId)
	            .subscribe(function (res) {
	            _this.fixRfidMsg = "";
	            if (res.data && !res.error) {
	                _this.model.rfidTagId = res.data;
	            }
	            else {
	                _this.fixRfidMsg = res.error[0].value;
	            }
	        }, function (error) {
	            _this.fixRfidMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    __decorate([
	        core_1.ViewChild("successPopup"), 
	        __metadata('design:type', Object)
	    ], PersonUpdateComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild("flatPickrConfigFromDate"), 
	        __metadata('design:type', (typeof (_a = typeof flatpickr_directive_1.FlatPickrDirective !== 'undefined' && flatpickr_directive_1.FlatPickrDirective) === 'function' && _a) || Object)
	    ], PersonUpdateComponent.prototype, "flatPickrConfigFromDate", void 0);
	    PersonUpdateComponent = __decorate([
	        core_1.Component({
	            selector: "wego-perosn",
	            template: __webpack_require__(838),
	            providers: [person_service_1.PersonService, instance_service_1.InstanceService, organization_service_1.OrganizationService],
	            styles: [
	                "\n    .personRole {\n      display: inline;\n    }\n    .input-group.telephone-group .input-group-addon {\n      padding: 0px;\n      border: 0px;\n    }\n    .country-select {\n      width: 60px;\n      border: 1px solid #d2d6de;\n      padding: 3px;\n    }\n  "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof organization_service_1.OrganizationService !== 'undefined' && organization_service_1.OrganizationService) === 'function' && _b) || Object, (typeof (_c = typeof person_service_1.PersonService !== 'undefined' && person_service_1.PersonService) === 'function' && _c) || Object, (typeof (_d = typeof instance_service_1.InstanceService !== 'undefined' && instance_service_1.InstanceService) === 'function' && _d) || Object, (typeof (_e = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _e) || Object, (typeof (_f = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _f) || Object, (typeof (_g = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _g) || Object, (typeof (_h = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _h) || Object, (typeof (_j = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _j) || Object])
	    ], PersonUpdateComponent);
	    return PersonUpdateComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
	}());
	exports.PersonUpdateComponent = PersonUpdateComponent;


/***/ },
/* 837 */
/***/ function(module, exports) {

	"use strict";
	var PersonModel = (function () {
	    function PersonModel() {
	        this.countryCode1 = '';
	        this.countryCode2 = '';
	        this.instanceHashId = '';
	        this.personRole = [];
	        this.contactPerson = [];
	        this.directDebitFileEnabledOnInstance = false;
	        this.isAmmandment = false;
	        this.enableLogin = true;
	        this.enableErrorEscalation = true;
	        this.isnifEnabled = false;
	        this.isInstanceTwofaEnabled = false;
	        this.licenseTypes = "";
	        this.personHomeAddressModel = new PersonAddressModel();
	        this.personWorkAddressModel = new PersonAddressModel();
	        this.emailAddressModel = new EmailAddressModel();
	    }
	    PersonModel.prototype.driverMasterHashId = function (arg0) {
	        throw new Error('Method not implemented.');
	    };
	    PersonModel.prototype.driverName = function (arg0) {
	        throw new Error('Method not implemented.');
	    };
	    return PersonModel;
	}());
	exports.PersonModel = PersonModel;
	var EmailAddressModel = (function () {
	    function EmailAddressModel() {
	    }
	    return EmailAddressModel;
	}());
	exports.EmailAddressModel = EmailAddressModel;
	var PersonAddressModel = (function () {
	    function PersonAddressModel() {
	    }
	    return PersonAddressModel;
	}());
	exports.PersonAddressModel = PersonAddressModel;
	var PersonDeleteModel = (function () {
	    function PersonDeleteModel() {
	    }
	    return PersonDeleteModel;
	}());
	exports.PersonDeleteModel = PersonDeleteModel;
	var PersonRemoveModel = (function () {
	    function PersonRemoveModel() {
	    }
	    return PersonRemoveModel;
	}());
	exports.PersonRemoveModel = PersonRemoveModel;


/***/ },
/* 838 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{breadCrumbTitle}}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"urlPersonList\">\r\n            <i class=\"fa fa-user fa-fw\"></i>{{breadCrumbList}}</a>\r\n        </li>\r\n        <li class=\"active\">{{breadCrumbTitle}}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25 \">\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"nopad\">\r\n      <form (ngSubmit)=\"onSubmit(AddPersonForm.value)\" #AddPersonForm=\"ngForm\">\r\n        <input type=\"hidden\" class=\"form-control\" [(ngModel)]=\"model.personMasterHashId\" name=\"personMasterHashId\">\r\n        <input type=\"hidden\" class=\"form-control\" [(ngModel)]=\"model.isActive\" name=\"isActive\">\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblUserName' | translate }}\r\n          </label>\r\n          <input *ngIf=\"!isEditMode\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblUserName' | translate }}\"\r\n            [(ngModel)]=\"model.userName\" name=\"UserName\" maxlength=\"100\">\r\n          <input readonly *ngIf=\"isEditMode\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblUserName' | translate }}\"\r\n            [ngModel]=\"model.userName\" name=\"UserName\" maxlength=\"100\">\r\n\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'userName' }}</span>\r\n        </div>\r\n\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblEmail' | translate }}\r\n          </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblEmail' | translate }}\" [(ngModel)]=\"model.emailAddressModel.email\"\r\n            name=\"Email\" maxlength=\"100\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'emailAddressModel.email' }}</span>\r\n        </div>\r\n\r\n        <!-- <fieldset *ngIf=\"authService.IsOrganizationAdmin() && organizationList && organizationList.length>1\" class=\"col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblOrganization' | translate }}\r\n          </label>\r\n          <select [disabled]=\"isEditMode\" [(ngModel)]=\"model.organizationHashId\" class=\"form-control\" name=\"organizationHashId\">\r\n            <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblOrganization' | translate }}</option>\r\n            <option *ngFor=\"let item of organizationList\" [ngValue]=\"item.organizationMasterHashId\">{{ item.organizationName }}</option>\r\n          </select>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'OrganizationHashId' }}</span>\r\n          <div class=\"clearfix\"></div>\r\n        </fieldset> -->\r\n\r\n        <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Instance\" class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\" *ngIf=\"authService.GetHighestRoleLevel() >= roleLevel.Instance\">*</span>{{\r\n            'LblInstance' | translate }}\r\n          </label>\r\n          <select [disabled]=\"isEditMode\" [(ngModel)]=\"model.instanceHashId\" class=\"form-control\" name=\"instanceHashId\"\r\n            (ngModelChange)=\"InstanceUpdate()\">\r\n            <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblInstance' | translate }}</option>\r\n            <option *ngFor=\"let item of instanceList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\r\n          </select>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'InstanceHashId' }}</span>\r\n        </div>\r\n        <template>\r\n          <input type=\"hidden\" class=\"form-control\" [(ngModel)]=\"model.instanceId\" name=\"instance\">\r\n        </template>\r\n        <div class=\"clearfix\"></div>\r\n\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            {{ 'LblFirstName' | translate }}\r\n          </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblFirstName' | translate }}\" [(ngModel)]=\"model.firstName\"\r\n            name=\"FirstName\" maxlength=\"100\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'firstName' }}</span>\r\n        </div>\r\n\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            {{ 'LblMiddleName' | translate }}\r\n          </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblMiddleName' | translate }}\" [(ngModel)]=\"model.middleName\"\r\n            name=\"MiddleName\" maxlength=\"100\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'middleName' }}</span>\r\n        </div>\r\n\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            {{ 'LblLastName' | translate }}\r\n          </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblLastName' | translate }}\" [(ngModel)]=\"model.lastName\"\r\n            name=\"LastName\" maxlength=\"100\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'lastName' }}</span>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>  {{ 'LblCountry' | translate }}\r\n          </label>\r\n          <div class=\"form-group inline\">\r\n            <select name=\"model.countryCodeHashId\" [(ngModel)]=\"model.countryCodeHashId\" class=\"form-control inline\">\r\n              <option *ngFor=\"let item of personCountryList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\r\n            </select>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'countryCode' }}</span>\r\n          </div>\r\n        </div>\r\n\r\n\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            {{ 'LblMobileNumber' | translate }}\r\n          </label>\r\n          <div class=\"input-group telephone-group\">\r\n            <span class=\"input-group-addon\">\r\n              <select [(ngModel)]=\"model.countryCode1\" class=\"form-control country-select\" name=\"countryCode1\">\r\n                <option value=\"\">-</option>\r\n                <option *ngFor=\"let item of countryList\" [ngValue]=\"item.value\">{{ item.value }}</option>\r\n              </select>\r\n            </span>\r\n            <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblMobileNumber' | translate }}\" [(ngModel)]=\"model.telephone1\"\r\n              name=\"telephone1\" maxlength=\"20\">\r\n          </div>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'countryCode1' }}</span>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'telephone1' }}</span>\r\n        </div>\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            {{ 'LblPhoneNumber' | translate }}\r\n          </label>\r\n          <div class=\"input-group telephone-group\">\r\n            <span class=\"input-group-addon\">\r\n              <select [(ngModel)]=\"model.countryCode2\" class=\"form-control country-select\" name=\"countryCode2\">\r\n                <option value=\"\">-</option>\r\n                <option *ngFor=\"let item of countryList\" [ngValue]=\"item.value\">{{ item.value }}</option>\r\n              </select>\r\n            </span>\r\n            <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblPhoneNumber' | translate }}\" [(ngModel)]=\"model.telephone2\"\r\n              name=\"telephone2\" maxlength=\"20\">\r\n          </div>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'countryCode2' }}</span>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'telephone2' }}</span>\r\n        </div>\r\n        <div class=\"form-group col-md-4\" *ngIf=\"model.isnifEnabled\">\r\n          <label>\r\n            {{ 'LblNIFNumber' | translate }}\r\n          </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblNIFNumber' | translate }}\" [(ngModel)]=\"model.nifNumber\"\r\n            name=\"nifNumber\" maxlength=\"9\">\r\n          <div class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'nIFNumber' }}</div>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n\r\n        <div *ngIf=\"isEditMode && model.isWeGoAdmin\" class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span> {{ 'LblEnableLogin' | translate }}\r\n          </label>\r\n          <div class=\"clearfix\"></div>\r\n          <label class=\"radio-inline\">\r\n            <input type=\"radio\" [(ngModel)]=\"model.enableLogin\" name=\"enableLogin\" [value]=\"true\">{{ 'LblYes' |\r\n            translate }}</label>\r\n          <label class=\"radio-inline\">\r\n            <input type=\"radio\" [(ngModel)]=\"model.enableLogin\" name=\"enableLogin\" [value]=\"false\">{{ 'LblNo' |\r\n            translate }}</label>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'enableLogin' }}</span>\r\n        </div>\r\n\r\n\r\n        <div *ngIf=\"isEditMode && model.isWeGoAdmin\" class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span> {{ 'LblEnableErrorEscalation' | translate }}\r\n          </label>\r\n          <div class=\"clearfix\"></div>\r\n          <label class=\"radio-inline\">\r\n            <input type=\"radio\" [(ngModel)]=\"model.enableErrorEscalation\" name=\"enableErrorEscalation\" [value]=\"true\">{{\r\n            'LblYes' | translate }}</label>\r\n          <label class=\"radio-inline\">\r\n            <input type=\"radio\" [(ngModel)]=\"model.enableErrorEscalation\" name=\"enableErrorEscalation\" [value]=\"false\">{{\r\n            'LblNo' | translate }}</label>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'enableLogin' }}</span>\r\n        </div>\r\n        <div *ngIf=\"isEditMode && model.isWeGoAdmin\" class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>\r\n            {{ 'LblErrorEscalationMinutes' | translate }}\r\n          </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblErrorEscalationMinutes' | translate }}\"\r\n            [(ngModel)]=\"model.errorEscalationMinutes\" name=\"errorEscalationMinutes\" maxlength=\"5\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'errorEscalationMinutes' }}</span>\r\n        </div>\r\n\r\n        <div *ngIf=\"!model.isActive\" class=\"form-group col-md-4\">\r\n          <label>\r\n            {{ 'LblInActiveReason' | translate }}\r\n          </label>\r\n          <input readonly *ngIf=\"isEditMode\" type=\"text\" class=\"form-control\" [ngModel]=\"model.inActiveReason\" name=\"inActiveReason\">\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n\r\n\r\n\r\n        <div class=\"row col-md-12 mb-4\">\r\n          <fieldset class=\"col-md-12\">\r\n            <legend class=\"legendStyle\">\r\n              {{ 'LblDriversLicenseAndCertificates' | translate }}\r\n            </legend>\r\n\r\n            <div class=\"row\">\r\n              <div class=\"form-group col-md-6\">\r\n                <label>{{ 'LblLicense' | translate }}</label>\r\n\r\n                <div class=\"row\">\r\n                  \r\n\r\n                  <div class=\"col-md-4\" *ngFor=\"let ltype of licenseTypes\">\r\n                    <label class=\"checkbox-inline\" style=\"margin-left: 0px; margin-right: 10px;\">\r\n                      <input type=\"checkbox\" (change)=\"OnChangeLicenseType(ltype, $event.target.checked)\" value=\"ltype.Value\"\r\n                        [checked]=\"ltype.IsChecked\" /> {{ltype.Key}}\r\n                    </label>\r\n                  </div>\r\n\r\n                </div>\r\n\r\n              </div>\r\n            </div>\r\n            <div class=\"row\">\r\n              <div class=\"form-group col-md-6\">\r\n                <label>{{ 'LblCertificates' | translate }}</label>\r\n                <textarea class=\"form-control\" placeholder=\"{{ 'LblCertificates' | translate }}\" [(ngModel)]=\"model.certificates\" name=\"certificates\" maxlength=\"500\"></textarea>\r\n              </div>\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n\r\n\r\n\r\n        <div class=\"clearfix\"></div>\r\n\r\n\r\n\r\n        <div class=\"row col-md-12\">\r\n          <fieldset class=\"col-md-12\">\r\n            <legend class=\"legendStyle\">\r\n              {{ 'LblTrackAndTrace' | translate }}\r\n            </legend>\r\n\r\n\r\n\r\n            <div class=\"clearfix\"></div>\r\n\r\n\r\n\r\n\r\n            <div class=\"form-group col-md-3\">\r\n              <label>{{ 'LblRfidTagId' | translate }}</label>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'rfidTagId' }}</span>\r\n  \r\n              <div class=\"row\">\r\n                <div class=\"col-xs-9\">\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblRfidTagId' | translate }}\" [(ngModel)]=\"model.rfidTagId\" name=\"rfidtagid\" maxlength=\"50\">\r\n                </div>\r\n                <div class=\"col-xs-3\">\r\n                  <input type=\"button\" value=\"Fix tag\" (click)=\"fixRfid()\" class=\"btn btn-green\" />\r\n                </div>\r\n              </div>\r\n              <span class=\"text text-danger\">{{ fixRfidMsg }}</span>\r\n            </div>\r\n\r\n            <div class=\"form-group col-md-3\">\r\n              <label>{{ 'LblAccessCardId' | translate }}</label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblAccessCardId' | translate }}\" [(ngModel)]=\"model.accessCardId\" name=\"accesscardid\" maxlength=\"50\">\r\n              <!--<span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'accesscardid' }}</span>-->\r\n            </div>\r\n\r\n            <div class=\"form-group col-md-3\">\r\n              <label>{{ 'LblEmployeeNumber' | translate }}</label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblEmployeeNumber' | translate }}\" [(ngModel)]=\"model.employeeNumber\"\r\n                     name=\"employeenumber\" maxlength=\"50\">\r\n              <!--<span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'employeeNumber' }}</span>-->\r\n            </div>\r\n\r\n          </fieldset>\r\n        </div>\r\n\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"row col-md-12\">\r\n          <fieldset class=\"col-md-6\">\r\n            <legend class=\"legendStyle\">\r\n              {{ 'LblHomeAddress' | translate }}\r\n            </legend>\r\n            <div class=\"clearfix\"></div>\r\n\r\n            <div class=\"form-group col-md-6\">\r\n              <label>{{ 'LblStreetName' | translate }}</label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblStreetName' | translate }}\" [(ngModel)]=\"model.personHomeAddressModel.street\"\r\n                name=\"personHomeAddressModel.street\" maxlength=\"100\">\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'personHomeAddressModel.street' }}</span>\r\n            </div>\r\n            <div class=\"form-group col-md-6\">\r\n              <label>{{ 'LblHouseNo' | translate }}</label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblHouseNo' | translate }}\" [(ngModel)]=\"model.personHomeAddressModel.houseNo\"\r\n                name=\"personHomeAddressModel.houseNo\" maxlength=\"15\">\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'personHomeAddressModel.houseNo' }}</span>\r\n            </div>\r\n            <div class=\"form-group col-md-6\">\r\n              <label>{{ 'LblHouseExtention' | translate }}</label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblHouseExtention' | translate }}\" [(ngModel)]=\"model.personHomeAddressModel.houseExtention\"\r\n                name=\"personHomeAddressModel.houseExtention\" maxlength=\"25\">\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage :\r\n                'personHomeAddressModel.houseExtention' }}</span>\r\n            </div>\r\n            <div class=\"form-group col-md-6\">\r\n              <label>{{ 'LblZipCode' | translate }}</label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblZipCode' | translate }}\" [(ngModel)]=\"model.personHomeAddressModel.zipCode\"\r\n                name=\"personHomeAddressModel.zipCode\" maxlength=\"10\">\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'personHomeAddressModel.zipCode' }}</span>\r\n            </div>\r\n            <div class=\"clearfix\"></div>\r\n            <div class=\"form-group col-md-6\">\r\n              <label>{{ 'LblCity' | translate }}</label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblCity' | translate }}\" [(ngModel)]=\"model.personHomeAddressModel.city\"\r\n                name=\"personHomeAddressModel.city\" maxlength=\"50\">\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'personHomeAddressModel.city' }}</span>\r\n            </div>\r\n          </fieldset>\r\n\r\n          <fieldset *ngIf=\"isEditMode && model.personRole.length>0\" class=\"col-md-6\">\r\n            <legend class=\"legendStyle\">\r\n              {{ 'LblRole' | translate }}\r\n            </legend>\r\n            <div *ngFor=\"let role of model.personRole\">\r\n              <li>\r\n                <ul class=\"personRole\">{{role}}</ul>\r\n              </li>\r\n            </div>\r\n\r\n            <div class=\"clearfix\"></div>\r\n            <div class=\"clearfix\"></div>\r\n            <div class=\"row col-md-12\" *ngIf=\"model.isInstanceTwofaEnabled\">\r\n              <legend class=\"legendStyle\">\r\n                {{ 'LblTwoFaConfig' | translate }}\r\n              </legend>\r\n              <div class=\"clearfix\"></div>\r\n              <div class=\"form-group col-md-4\">\r\n                <label>\r\n                  <span class=\"text text-danger\">*</span> {{ 'LblDisableTwoFA' | translate }}\r\n                </label>\r\n                <div class=\"clearfix\"></div>\r\n                <label class=\"radio-inline\">\r\n                  <input type=\"radio\" [(ngModel)]=\"model.twoFaDisabled\" name=\"TwoFaDisabled\" [value]=\"true\">{{ 'LblYes'\r\n                  |\r\n                  translate }}</label>\r\n                <label class=\"radio-inline\">\r\n                  <input type=\"radio\" [(ngModel)]=\"model.twoFaDisabled\" name=\"TwoFaDisabled\" [value]=\"false\">{{ 'LblNo'\r\n                  |\r\n                  translate }}</label>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'TwoFaDisabled' }}</span>\r\n              </div>\r\n\r\n              <div *ngIf=\"!model.twoFaDisabled\" class=\"form-group col-md-4\">\r\n                <label>\r\n                  <span class=\"text text-danger\">*</span> {{ 'LblTwoFaMethod' | translate }}</label>\r\n                <div class=\"clearfix\"></div>\r\n                <div class=\"form-group inline\">\r\n                  <select name=\"model.selectedTwoFa\" [(ngModel)]=\"model.selectedTwoFa\" class=\"form-control inline\">\r\n                    <option value='0'>{{ 'LblAll' | translate }}</option>\r\n                    <option value='1'>{{'LblEmail' | translate}}</option>\r\n                    <option value='2'>{{'LblGoogleAuthenticator' | translate}} </option>\r\n                  </select>\r\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'selectedTwoFa' }}</span>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </fieldset>\r\n          <fieldset *ngIf=\"isEditMode && model.contactPerson.length>0\" class=\"col-md-6\">\r\n            <legend class=\"legendStyle\">\r\n              {{ 'LblContactPerson' | translate }}\r\n            </legend>\r\n            <div *ngFor=\"let company of model.contactPerson\">\r\n              <li>\r\n                <ul class=\"personRole\">{{company}}</ul>\r\n              </li>\r\n            </div>\r\n            <div class=\"clearfix\"></div>\r\n          </fieldset>\r\n        </div>\r\n        <fieldset *ngIf=\"model.directDebitFileEnabledOnInstance\" class=\"col-md-12\">\r\n          <legend class=\"legendStyle\">\r\n            {{ 'LblInvoicingDetails' | translate }}\r\n          </legend>\r\n          <div class=\"form-group col-md-4\">\r\n            <label>{{ 'LbLSubjectToDirectDebit' | translate }}</label>\r\n            <div class=\"clearfix\"></div>\r\n            <label class=\"radio-inline\">\r\n              <input type=\"radio\" [(ngModel)]=\"model.subjectToDirectDebit\" name=\"subjectToDirectDebit\" [value]=\"true\">{{\r\n              'LblYes' | translate }}</label>\r\n            <label class=\"radio-inline\">\r\n              <input type=\"radio\" [(ngModel)]=\"model.subjectToDirectDebit\" name=\"subjectToDirectDebit\" [value]=\"false\">{{\r\n              'LblNo' | translate }}</label>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'enableFileGeneration' }}</span>\r\n          </div>\r\n          <div class=\"form-group col-md-4\">\r\n            <label>\r\n              <span *ngIf=\"model.subjectToDirectDebit\" class=\"text text-danger\">*</span>\r\n              {{ 'LblIBANNumber' | translate }}\r\n            </label>\r\n            <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblIBANNumber' | translate }}\" [(ngModel)]=\"model.ibanNumber\"\r\n              name=\"ibanNumber\" maxlength=\"100\">\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'ibanNumber' }}</span>\r\n          </div>\r\n          <div class=\"form-group col-md-4\">\r\n            <label>\r\n              <span *ngIf=\"model.subjectToDirectDebit\" class=\"text text-danger\">*</span>\r\n              {{ 'LblBICCode' | translate }}\r\n            </label>\r\n            <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblBICCode' | translate }}\" [(ngModel)]=\"model.bicCode\"\r\n              name=\"bicCode\" maxlength=\"100\">\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'bicCode' }}</span>\r\n          </div>\r\n          <div class=\"clearfix\"></div>\r\n          <div class=\"form-group col-md-4\">\r\n            <label>\r\n              <span class=\"text text-danger\"></span>\r\n              {{ 'LblMandateId' | translate }}\r\n            </label>\r\n            <input type=\"text\" maxlength=\"11\" class=\"form-control\" placeholder=\"{{ 'LblMandateId' | translate }}\"\r\n              [(ngModel)]=\"model.mandateId\" name=\"mandateId\">\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'mandateId' }}</span>\r\n          </div>\r\n          <div class=\"form-group col-md-4\">\r\n            <label>\r\n              <span class=\"text text-danger\"></span>{{ 'LblMandateSignatureDate' | translate }}</label>\r\n            <div class=\"input-group\">\r\n              <span class=\"input-group-addon\">\r\n                <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n              </span>\r\n              <input #flatPickrConfigFromDate=\"wego-flatpickr\" flatpickr readonly [Config]=\"flatPickrConfigFrom\"\r\n                [(ngModel)]=\"model.mandateSignatureDate\" name=\"mandateSignatureDate\" type=\"text\" class=\"form-control\"\r\n                placeholder=\"{{ 'LblMandateSignatureDate' | translate\r\n            }}\">\r\n            </div>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'mandateSignatureDate' }}</span>\r\n          </div>\r\n          <div class=\"form-group col-md-4\">\r\n            <label>\r\n              <span class=\"text text-danger\">*</span>\r\n              {{ 'LblIsAmmandment'| translate }}\r\n            </label>\r\n            <div class=\"clearfix\"></div>\r\n            <label class=\"radio-inline\">\r\n              <input type=\"radio\" [(ngModel)]=\"model.isAmmandment\" name=\"isAmmandment\" [value]=\"true\">{{ 'LblYes' |\r\n              translate }}</label>\r\n            <label class=\"radio-inline\">\r\n              <input type=\"radio\" [(ngModel)]=\"model.isAmmandment\" name=\"isAmmandment\" [value]=\"false\">{{ 'LblNo' |\r\n              translate }}</label>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'isAmmandment' }}</span>\r\n          </div>\r\n        </fieldset>\r\n\r\n        <fieldset class=\"col-md-6\">\r\n          <legend class=\"legendStyle\">\r\n            {{ 'LblDropoffMessage' | translate }}\r\n          </legend>\r\n          <div class=\"clearfix\"></div>\r\n          <div class=\"form-group col-md-6\">\r\n            <label>{{ 'LblPreferredlanguage' | translate }}</label>\r\n            <select [(ngModel)]=\"model.preferredlanguage\" class=\"form-control\" name=\"preferredlanguage\">\r\n              <option *ngFor=\"let item of preferredlanguage\" [ngValue]=\"item.Value\">{{ item.Key }}</option>\r\n            </select>\r\n          </div>\r\n          <div class=\"form-group col-md-6\">\r\n            <label>{{ 'LblDebtornr' | translate }}</label>\r\n            <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblDebtornr' | translate }}\" [(ngModel)]=\"model.debtornr\"\r\n              name=\"debtornr\" maxlength=\"64\">\r\n          </div>\r\n\r\n        </fieldset>\r\n\r\n        <div class=\"row no-margin\">\r\n          <div class=\"col-sm-12\">\r\n            <hr>\r\n            <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnBackClick()\">{{ 'LblCancel' | translate }}</a>\r\n            &nbsp;&nbsp;\r\n            <button class=\"btn btn-green\" type=\"submit\">{{ 'LblSave' | translate }}</button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n";

/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var instance_service_1 = __webpack_require__(500);
	var modal_1 = __webpack_require__(537);
	var auth_service_1 = __webpack_require__(58);
	var translate_service_1 = __webpack_require__(70);
	var core_1 = __webpack_require__(3);
	var person_model_1 = __webpack_require__(837);
	var person_service_1 = __webpack_require__(771);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var flatpickr_directive_1 = __webpack_require__(82);
	var flatpickr_model_1 = __webpack_require__(83);
	var moment = __webpack_require__(84);
	var PersonListComponent = (function () {
	    function PersonListComponent(personService, instanceService, authService, router, translate) {
	        this.personService = personService;
	        this.instanceService = instanceService;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.isDelete = false;
	        this.isAllowToImport = false;
	        this.isAllowToBatchUploadPerson = false;
	        this.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_FORMAT;
	        this.roleLevel = config_1.RoleLevel;
	    }
	    PersonListComponent.prototype.ngOnInit = function () {
	        this.wegoadminUser = config_1.WeGoConfig.WEGOADMIN_USER;
	        this.module = this.translate.instant("LblPerson");
	        this.model = new person_model_1.PersonDeleteModel();
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig(true);
	        if (this.authService.GetHighestRoleLevel() <= this.roleLevel.Instance) {
	            this.DataListModel.searchField = [
	                "userName",
	                "firstName",
	                "instanceName",
	                "lastName",
	                "telephone1"
	            ];
	        }
	        else {
	            this.DataListModel.searchField = [
	                "userName",
	                "firstName",
	                "lastName",
	                "telephone1"
	            ];
	        }
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlPersonAdd = this.authService.GetURL(config_1.ApplicationRouteURL.URL_PERSON_ADD);
	        this.urlPersonUpdate = this.authService.GetURL(config_1.ApplicationRouteURL.URL_PERSON_UPDATE);
	        this.urlImportPerson = this.authService.GetURL(config_1.ApplicationRouteURL.URL_IMPORT_PERSON);
	        this.urlBatchUpload = this.authService.GetURL(config_1.ApplicationRouteURL.URL_BATCHUPLOADPERSON);
	        this.CheckIsAllowToImport();
	        this.GetPersonList();
	        this.breadCrumbList = this.translate.instant("LblListPage", [this.module]);
	        this.addPersonLink = new config_1.WeGoAuthorizedLink(this.urlPersonAdd, config_1.Permission.PR_PERSON_OVERVIEW, config_1.PermissionType.INSERT, "btn btn-highlight navbar-right", "LblAddNew");
	        this.importPersonLink = new config_1.WeGoAuthorizedLink(this.urlImportPerson, config_1.Permission.PR_IMPORT_PERSON, config_1.PermissionType.INSERT, "btn btn-highlight pull-right mar_right_10", "LblImportPerson");
	        this.batchUploadPersonLink = new config_1.WeGoAuthorizedLink(this.urlBatchUpload, config_1.Permission.PR_BATCH_UPLOAD_PERSON, config_1.PermissionType.INSERT, "btn btn-highlight pull-right mar_right_10", "LblBatchUpload");
	    };
	    PersonListComponent.prototype.SetDefaultFlatPickrConfig = function (isDateOnly) {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = !isDateOnly ? true : false;
	        flatPickrConfig.time_24hr = true;
	        flatPickrConfig.dateFormat = this.dateFormat;
	        flatPickrConfig.minuteIncrement = 1;
	        flatPickrConfig.minDate = (new Date()).setDate((new Date()).getDate() + 1);
	        flatPickrConfig.maxDate = (new Date()).setFullYear((new Date()).getFullYear() + 1);
	        return flatPickrConfig;
	    };
	    Object.defineProperty(PersonListComponent.prototype, "isDeleteAccess", {
	        get: function () {
	            if (this.personList) {
	                return this.personList.some(function (x) { return x.isDeletable; });
	            }
	            else {
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(PersonListComponent.prototype, "isEditAccess", {
	        get: function () {
	            if (this.personList) {
	                return this.personList.some(function (x) { return x.isEditable; });
	            }
	            else {
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    PersonListComponent.prototype.CheckIsAllowToImport = function () {
	        var _this = this;
	        this.instanceService.CheckIsAllowToImportPerson().subscribe(function (res) {
	            _this.isAllowToImport = res.data;
	            //this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            //this.isLoading = false;
	        });
	        this.instanceService.CheckIsAllowToBatchUploadPerson().subscribe(function (res) {
	            _this.isAllowToBatchUploadPerson = res.data;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    PersonListComponent.prototype.GetPersonList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.personService.GetPersonList(this.DataListModel).subscribe(function (res) {
	            _this.personList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    PersonListComponent.prototype.ShowChangeRemovalDatePopup = function (person) {
	        this.removalDateTime = person.removalDateTime;
	        this.removalDatePersonHashId = person.personMasterHashId;
	        this.errorModel = [];
	        this.errorMsg = '';
	        this.personRemovalDateModal.show();
	    };
	    PersonListComponent.prototype.UpdatePersonRemovalDate = function () {
	        var _this = this;
	        this.isLoading = true;
	        var personRemoveModel = new person_model_1.PersonRemoveModel();
	        personRemoveModel.personMasterHashId = this.removalDatePersonHashId;
	        personRemoveModel.removalDateTime = this.removalDateTime;
	        this.personService.UpdatePersonRemovalDate(personRemoveModel).subscribe(function (res) {
	            _this.isLoading = false;
	            if (res.data) {
	                _this.GetPersonList();
	                _this.personRemovalDateModal.hide();
	            }
	            else {
	                _this.errorModel = res.error;
	                _this.errorMsg = res.error;
	            }
	        }, function (error) {
	            _this.personRemovalDateModal.hide();
	            _this.errorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    PersonListComponent.prototype.ActivatePerson = function (personHashId) {
	        var _this = this;
	        this.isLoading = true;
	        this.personService.ActivatePerson(personHashId).subscribe(function (res) {
	            _this.isLoading = false;
	            if (res.data) {
	                _this.GetPersonList();
	                _this.popupMsg = _this.translate.instant("LblPersonActiveSuccess", [
	                    _this.module
	                ]);
	                _this.popupTitle = _this.translate.instant('LblSuccess');
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.errorModel = res.error;
	                _this.errorMsg = res.error;
	            }
	        }, function (error) {
	            _this.errorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    PersonListComponent.prototype.DeletePerson = function (formData) {
	        var _this = this;
	        this.isLoading = true;
	        this.personService.DeletePerson(formData).subscribe(function (res) {
	            _this.deletePersonModal.hide();
	            _this.DataListModel.currentPage = 1;
	            _this.GetPersonList();
	            if (res && res.error != "") {
	                _this.validationMessage = res.error;
	                _this.deletePersonModal.hide();
	                _this.popupTitle = _this.translate.instant("LblWarning");
	                _this.ShowAlertModal();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant("LblRecordRemovedSuccess", [
	                    _this.module
	                ]);
	                _this.popupTitle = _this.translate.instant('LblSuccess');
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    PersonListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetPersonList();
	    };
	    PersonListComponent.prototype.onSubmit = function (forms) {
	        this.model.personMasterHashId = this.deletePersonHashId;
	        this.DeletePerson(JSON.stringify(this.model));
	    };
	    PersonListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetPersonList();
	    };
	    PersonListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetPersonList();
	    };
	    PersonListComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetPersonList();
	    };
	    PersonListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.personService.ExportPersonList(this.DataListModel).subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "Person" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    PersonListComponent.prototype.ShowConfirmModal = function (personHashId) {
	        this.isLoading = false;
	        this.deletePersonHashId = personHashId;
	        this.errorModel = null;
	        this.model.personMasterHashId = personHashId;
	        this.model.isDelete = false;
	        this.popupMsg = this.translate.instant("LblRecordDeleteConfirmation", [
	            this.module
	        ]);
	        this.deletePersonModal.show(this.message);
	    };
	    PersonListComponent.prototype.HideConfirmModal = function () {
	        this.deletePersonHashId = "";
	        this.deletePersonModal.hide();
	    };
	    PersonListComponent.prototype.SuccessAlertModalClick = function () {
	        this.alertModal.hide();
	        this.deletePersonModal.hide();
	    };
	    PersonListComponent.prototype.ShowAlertModal = function () {
	        this.isLoading = false;
	        this.alertModal.show();
	    };
	    PersonListComponent.prototype.HideAlertModal = function () {
	        this.alertModal.hide();
	    };
	    PersonListComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    PersonListComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	        this.deletePersonModal.hide();
	    };
	    PersonListComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    PersonListComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    __decorate([
	        core_1.ViewChild("alertModal"), 
	        __metadata('design:type', (typeof (_a = typeof modal_1.ModalDirective !== 'undefined' && modal_1.ModalDirective) === 'function' && _a) || Object)
	    ], PersonListComponent.prototype, "alertModal", void 0);
	    __decorate([
	        core_1.ViewChild("confirmModal"), 
	        __metadata('design:type', Object)
	    ], PersonListComponent.prototype, "confirmModal", void 0);
	    __decorate([
	        core_1.ViewChild("successPopup"), 
	        __metadata('design:type', Object)
	    ], PersonListComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild('deletePersonModal'), 
	        __metadata('design:type', Object)
	    ], PersonListComponent.prototype, "deletePersonModal", void 0);
	    __decorate([
	        core_1.ViewChild('personRemovalDateModal'), 
	        __metadata('design:type', Object)
	    ], PersonListComponent.prototype, "personRemovalDateModal", void 0);
	    __decorate([
	        core_1.ViewChild("flatPickrConfigRemovalDate"), 
	        __metadata('design:type', (typeof (_b = typeof flatpickr_directive_1.FlatPickrDirective !== 'undefined' && flatpickr_directive_1.FlatPickrDirective) === 'function' && _b) || Object)
	    ], PersonListComponent.prototype, "flatPickrConfigRemovalDate", void 0);
	    PersonListComponent = __decorate([
	        core_1.Component({
	            selector: "wego-person",
	            template: __webpack_require__(840),
	            providers: [person_service_1.PersonService, instance_service_1.InstanceService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_c = typeof person_service_1.PersonService !== 'undefined' && person_service_1.PersonService) === 'function' && _c) || Object, (typeof (_d = typeof instance_service_1.InstanceService !== 'undefined' && instance_service_1.InstanceService) === 'function' && _d) || Object, (typeof (_e = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _f) || Object, (typeof (_g = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _g) || Object])
	    ], PersonListComponent);
	    return PersonListComponent;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.PersonListComponent = PersonListComponent;


/***/ },
/* 840 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-4 col-sm-4\">\r\n      <h1 class=\"pagename\">{{ breadCrumbList}} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li class=\"active\"> {{ breadCrumbList}} </li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-8 col-sm-8 mar_t_25 \">\r\n      <wego-authorized-link [LinkModel]=\"addPersonLink\"></wego-authorized-link>\r\n      <template [ngIf]=\"isAllowToImport\">\r\n        <wego-authorized-link [LinkModel]=\"importPersonLink\"></wego-authorized-link>\r\n      </template>\r\n      <template [ngIf]=\"isAllowToBatchUploadPerson\">\r\n        <wego-authorized-link [LinkModel]=\"batchUploadPersonLink\"></wego-authorized-link>\r\n      </template>\r\n    </div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <p class=\"text-success\">{{ message }}</p>\r\n        <wego-search-list (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\"\r\n          [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('firstName')\">\r\n                  {{ 'LblFirstName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'firstName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('lastName')\">\r\n                  {{ 'LblLastName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'lastName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('userName')\">\r\n                  {{ 'LblUserName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'userName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer text-center\">\r\n                  {{ 'LblRole' | translate }}\r\n                </th>\r\n                <th *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Instance\" class=\"cursor-pointer\" (click)=\"OnSort('instanceName')\">\r\n                  {{ 'LblInstanceName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'instanceName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('telephone1')\">\r\n                  {{ 'LblMobileNumber' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'telephone1'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th *ngIf=\"isEditAccess\" class=\"text-center\">{{ 'LblEdit' | translate }}</th>\r\n                <th *ngIf=\"isDeleteAccess\" class=\"text-center\">{{ 'LblDelete' | translate }}</th>\r\n                <th>{{ 'LblRemovalDate' | translate }}</th>\r\n                <th>{{ 'LblActivate' | translate }}</th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let person of personList\">\r\n                  <td>{{ person.firstName }}</td>\r\n                  <td>{{ person.lastName }} </td>\r\n                  <td>{{ person.userName }}</td>\r\n                  <td class=\"text-center\">\r\n                    <span class=\"label label-default\">{{ person.totalPersonRole }}</span>\r\n                  </td>\r\n                  <td *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Instance\">{{ person.instanceName }}</td>\r\n                  <td>{{ person.telephone1 }}</td>\r\n                  <td *ngIf=\"isEditAccess\" class=\"text-center\">\r\n                    <a *ngIf=\"person.isEditable\" [routerLink]=\"urlPersonUpdate + '/' + person.personMasterHashId\">\r\n                      <i class=\"fa fa-pencil-square-o fa-fw\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td *ngIf=\"isDeleteAccess\" class=\"text-center\">\r\n                    <a *ngIf=\"person.isDeletable\" class=\"cursor-pointer\" (click)=\"ShowConfirmModal(person.personMasterHashId)\">\r\n                      <i class=\"fa fa-trash-o fa-fw text-danger\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td>\r\n                    <a class=\"cursor-pointer\" (click)=\"ShowChangeRemovalDatePopup(person)\">\r\n                      {{ person.removalDateTime }}\r\n                    </a>\r\n                  </td>\r\n                  <td>\r\n                    <a *ngIf=\"!person.isActive && person.allowActivate\" class=\"cursor-pointer\" (click)=\"ActivatePerson(person.personMasterHashId)\">\r\n                      {{ 'LblActivate' | translate }}\r\n                    </a>\r\n                  </td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"8\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n  <div class=\"clearfix\"></div>\r\n</div>\r\n\r\n<div bsModal #deletePersonModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-sm\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"HideConfirmModal()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblConfirm' | translate }}</h4>\r\n      </div>\r\n\r\n      <form (ngSubmit)=\"onSubmit(DeleteUserForm.value)\" #DeleteUserForm=\"ngForm\">\r\n        <div class=\"modal-body\">\r\n          <div class=\"row\">\r\n            <div class=\"col-xs-12 form-group\">\r\n              {{ popupMsg }}\r\n              {{ 'LblDeletePersonNote' | translate}}\r\n            </div>\r\n            <div class=\"col-xs-12 form-group\">\r\n              <input type=\"checkbox\" id=\"chkPermanentDelete\" name=\"isDelete\" [(ngModel)]=\"model.isDelete\">&nbsp;&nbsp;{{ 'LblRemovePersonDetails' | translate }}\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'isDelete' }}</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"modal-footer\">\r\n          <button type=\"submit\" class=\"btn btn-green\">{{ 'LblYes' | translate }}</button>\r\n          <button type=\"button\" class=\"btn btn-gray cursor-pointer\" (click)=\"HideConfirmModal()\">{{ 'LblNo' | translate }}</button>\r\n        </div>\r\n      </form>\r\n\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n\r\n<div bsModal #personRemovalDateModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-sm\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"personRemovalDateModal.hide()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblRemovalDate' | translate }}</h4>\r\n      </div>\r\n\r\n      <form (ngSubmit)=\"onSubmit(personRemovalDateForm.value)\" #personRemovalDateForm=\"ngForm\">\r\n        <div class=\"modal-body\">\r\n          <div class=\"form-group\">\r\n            <label>{{ 'LblRemovePersonOn' | translate }}</label>\r\n            <div class=\"clearfix\"></div>\r\n            <div class=\"col-xs-9  input-group text-center\">\r\n              <span class=\"input-group-addon\">\r\n                <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n              </span>\r\n              <input #flatPickrConfigRemovalDate=\"wego-flatpickr\" flatpickr readonly [Config]=\"flatPickrConfigFrom\" [(ngModel)]=\"removalDateTime\"\r\n                name=\"removalDate\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblRemovalDate' | translate }}\">\r\n            </div>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'RemovalDateTime' }}</span>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"modal-footer\">\r\n          <button type=\"button\" (click)=\"UpdatePersonRemovalDate()\" class=\"btn btn-green\">{{ 'LblOK' | translate }}</button>\r\n          <button type=\"button\" class=\"btn btn-gray cursor-pointer\" (click)=\"personRemovalDateModal.hide()\">{{ 'LblCancel' | translate }}</button>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<wego-success-popup #alertModal [popupTitle]=\"popupTitle\" [popupMsg]=\"validationMessage\" (onConfirm)=\"SuccessAlertModalClick()\"></wego-success-popup>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>";

/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var instance_model_1 = __webpack_require__(513);
	var instance_service_1 = __webpack_require__(500);
	var customer_service_1 = __webpack_require__(664);
	var config_1 = __webpack_require__(60);
	var common_1 = __webpack_require__(22);
	var ng2_file_upload_1 = __webpack_require__(810);
	var pre_post_trip_question_component_1 = __webpack_require__(743);
	var validate_license_24idcheck_option_1 = __webpack_require__(749);
	var import_connectiontype_option_1 = __webpack_require__(846);
	var InstanceUpdateComponent = (function () {
	    function InstanceUpdateComponent(instanceService, translate, activeRoute, router, authService, locationService, customerService) {
	        this.instanceService = instanceService;
	        this.translate = translate;
	        this.activeRoute = activeRoute;
	        this.router = router;
	        this.authService = authService;
	        this.locationService = locationService;
	        this.customerService = customerService;
	        this.headers = this.authService.GetHeaderForFile();
	        this.uploader = new ng2_file_upload_1.FileUploader({
	            url: config_1.WeGoConfig.API_POST_INSTANCE_DETAIL,
	            headers: this.headers
	        });
	        this.roleLevel = config_1.RoleLevel;
	        this.preferredLanguage = config_1.PreferredLanguage;
	        this.isSvgSelected = false;
	        this.isOrgSelected = false;
	        this.validateLicense24IdCheckOption = validate_license_24idcheck_option_1.ValidateLicense24IdCheckOption;
	        this.validateLicense24IdCheckOptionKeys = Object.keys(validate_license_24idcheck_option_1.ValidateLicense24IdCheckOption).filter(function (type) { return isNaN(type) && type !== 'values'; });
	        this.importConnectionTypeOption = import_connectiontype_option_1.ImportConnectionTypeOption;
	        this.importConnectionTypeOptionKeys = Object.keys(import_connectiontype_option_1.ImportConnectionTypeOption).filter(function (type) { return isNaN(type) && type !== 'values'; });
	    }
	    InstanceUpdateComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.dayofWeekList = [
	            {
	                Key: this.translate.instant("LblSelectDayOfWeek"),
	                Value: ""
	            },
	            {
	                Key: this.translate.instant("LblSunday"),
	                Value: "0"
	            },
	            {
	                Key: this.translate.instant("LblMonday"),
	                Value: "1"
	            },
	            {
	                Key: this.translate.instant("LblTuesday"),
	                Value: "2"
	            },
	            {
	                Key: this.translate.instant("LblWednesday"),
	                Value: "3"
	            },
	            {
	                Key: this.translate.instant("LblThursday"),
	                Value: "4"
	            },
	            {
	                Key: this.translate.instant("LblFriday"),
	                Value: "5"
	            },
	            {
	                Key: this.translate.instant("LblSaturday"),
	                Value: "6"
	            }
	        ];
	        this.damageImageExtentions = [
	            {
	                Key: "JPG",
	                Value: ".JPG",
	                IsChecked: false
	            },
	            {
	                Key: "GIF",
	                Value: ".GIF",
	                IsChecked: false
	            },
	            {
	                Key: "PNG",
	                Value: ".PNG",
	                IsChecked: false
	            },
	            {
	                Key: "JPEG",
	                Value: ".JPEG",
	                IsChecked: false
	            },
	            {
	                Key: "MAC",
	                Value: ".MAC",
	                IsChecked: false
	            },
	            {
	                Key: "PBM",
	                Value: ".PBM",
	                IsChecked: false
	            },
	            {
	                Key: "PCD",
	                Value: ".PCD",
	                IsChecked: false
	            }
	        ];
	        this.currencyAbbreviationList = config_1.WeGoConfig.CURRENCY_ABBREVIATION;
	        this.preferredLanguageList = config_1.WeGoConfig.PREFERRED_LANGUAGE; // this.preferredLanguage;
	        this.GetTimeZoneList();
	        this.GetTelephoneCountry();
	        this.module = this.translate.instant("LblInstance");
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlInstanceList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_INSTANCE_LIST);
	        this.ImageExtArray = [];
	        this.model = new instance_model_1.InstanceModel();
	        this.sub = this.activeRoute.params.subscribe(function (params) {
	            _this.instanceHashId = params["id"] || "";
	            if (_this.instanceHashId != "") {
	                _this.isEditMode = true;
	                _this.instanceService.GetInstanceByHashId(_this.instanceHashId).subscribe(function (res) {
	                    _this.model = res.data;
	                    if (_this.model != null &&
	                        _this.model.damageImageExtensions != null) {
	                        _this.SetImageExtensionOnEdit();
	                    }
	                    if (_this.model.afasToken != null) {
	                        _this.model.afasToken = _this.Base64Decode(_this.model.afasToken);
	                    }
	                    _this.GetSharedVehicleGroupList();
	                    _this.GetOrganizationList();
	                    _this.GetSubscriptionList();
	                }, function (error) {
	                    _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	                });
	            }
	            else {
	                _this.isEditMode = false;
	                _this.SetImageExtensionOnAdd();
	                _this.model = new instance_model_1.InstanceModel();
	                _this.model.odometerConfigurationModel.enabled = "NO";
	                _this.model.twoFAConfig.enabled = "NO";
	            }
	            _this.GetCustomerList();
	        });
	        this.breadCrumbTitle = this.isEditMode
	            ? this.translate.instant("LblEditPage", [this.module])
	            : this.translate.instant("LblAddPage", [this.module]);
	        this.breadCrumbList = this.translate.instant("LblListPage", [this.module]);
	        this.IsAuthorizedForPrePostTripQuestion();
	    };
	    InstanceUpdateComponent.prototype.ngAfterViewInit = function () {
	        // viewChild is set after the view has been initialized
	        // this.prePostTripQuestionSection.GetPrePostTripQuestionList(
	        //   this.instanceHashId,
	        //   null,
	        //   null,
	        //   null
	        // );
	    };
	    InstanceUpdateComponent.prototype.show = function () {
	        this.apiSvgErrorMsg = '';
	        this.apiOrgErrorMsg = '';
	        this.apiSubErrorMsg = '';
	    };
	    InstanceUpdateComponent.prototype.SetImageExtensionOnEdit = function () {
	        var extensionArray = this.model.damageImageExtensions.split(",");
	        var _loop_1 = function(i) {
	            objIndex = this_1.damageImageExtentions.findIndex(function (x) { return x.Value == extensionArray[i]; });
	            this_1.damageImageExtentions[objIndex].IsChecked = true;
	            this_1.ImageExtArray.push(this_1.damageImageExtentions[objIndex].Value);
	        };
	        var this_1 = this;
	        var objIndex;
	        for (var i = 0; i < extensionArray.length; i++) {
	            _loop_1(i);
	        }
	    };
	    InstanceUpdateComponent.prototype.SetImageExtensionOnAdd = function () {
	        this.ImageExtArray.push(".JPG");
	        this.ImageExtArray.push(".JPEG");
	        this.ImageExtArray.push(".PNG");
	        var jpegobjIndex = this.damageImageExtentions.findIndex(function (x) { return x.Value == ".JPEG"; });
	        var jpgobjIndex = this.damageImageExtentions.findIndex(function (x) { return x.Value == ".JPG"; });
	        var pngobjIndex = this.damageImageExtentions.findIndex(function (x) { return x.Value == ".PNG"; });
	        this.damageImageExtentions[jpegobjIndex].IsChecked = true;
	        this.damageImageExtentions[jpgobjIndex].IsChecked = true;
	        this.damageImageExtentions[pngobjIndex].IsChecked = true;
	    };
	    InstanceUpdateComponent.prototype.OnChangeDamageImageExtension = function (imageExtension, isChecked) {
	        var objIndex = this.damageImageExtentions.findIndex(function (x) { return x.Value == imageExtension.Value; });
	        if (isChecked) {
	            this.ImageExtArray.push(imageExtension.Value);
	        }
	        else {
	            var index = this.ImageExtArray.indexOf(imageExtension.Value);
	            if (index > -1) {
	                this.ImageExtArray.splice(index, 1);
	            }
	        }
	        this.damageImageExtentions[objIndex].IsChecked = isChecked;
	    };
	    InstanceUpdateComponent.prototype.JoinAllImageExtension = function () {
	        if (this.ImageExtArray != null && this.ImageExtArray.length > 0)
	            this.model.damageImageExtensions = this.ImageExtArray.join(",");
	        else
	            this.model.damageImageExtensions = "";
	    };
	    InstanceUpdateComponent.prototype.OnSubmit = function (forms) {
	        var _this = this;
	        this.isLoading = true;
	        if (this.uploader.queue && this.uploader.queue.length > 0) {
	            this.uploader.onBuildItemForm = function (fileItem, Form) {
	                Form.append("instanceFormData", JSON.stringify(_this.model));
	            };
	            var apiresponse;
	            var status;
	            this.uploader.onCompleteItem = function (item, response, status, headers) {
	                apiresponse = JSON.parse(response);
	                console.log(apiresponse.error);
	                _this.isLoading = false;
	                if (status == 200) {
	                    if (apiresponse.data == true) {
	                        _this.popupTitle = _this.translate.instant('LblSuccess');
	                        _this.popupMsg = _this.isEditMode
	                            ? _this.translate.instant("LblRecordUpdatedSuccess", [_this.module])
	                            : _this.translate.instant("LblRecordAddedSuccess", [_this.module]);
	                        _this.ShowSuccessPopup();
	                    }
	                    else {
	                        _this.errorModel = apiresponse.error;
	                        _this.ClearFileInput();
	                    }
	                }
	            };
	            this.uploader.uploadAll();
	        }
	        else {
	            this.JoinAllImageExtension();
	            if (this.model.afasToken != null) {
	                this.model.afasToken = this.Base64Encode(this.model.afasToken);
	            }
	            this.instanceService
	                .AddNewInstance("instanceFormData=" + encodeURIComponent(JSON.stringify(this.model)))
	                .subscribe(function (res) {
	                if (res.data) {
	                    _this.popupMsg = _this.isEditMode
	                        ? _this.translate.instant("LblRecordUpdatedSuccess", [
	                            _this.module
	                        ])
	                        : _this.translate.instant("LblRecordAddedSuccess", [
	                            _this.module
	                        ]);
	                    _this.popupTitle = _this.translate.instant('LblSuccess');
	                    _this.ShowSuccessPopup();
	                    _this.isLoading = false;
	                }
	                else {
	                    _this.errorModel = res.error;
	                    _this.isLoading = false;
	                }
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	                _this.isLoading = false;
	            });
	        }
	    };
	    InstanceUpdateComponent.prototype.HasModelError = function (key) {
	        if (this.errorModel != undefined) {
	            var errorMsg = this.errorModel.find(function (item) { return item.key.toLowerCase() == key.toLowerCase(); });
	            if (errorMsg) {
	                return true;
	            }
	            else {
	                return false;
	            }
	        }
	        return false;
	    };
	    InstanceUpdateComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    InstanceUpdateComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    InstanceUpdateComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    InstanceUpdateComponent.prototype.ShowTwoFaPopup = function () {
	        this.TwoFasuccessPopup.show();
	    };
	    InstanceUpdateComponent.prototype.ConfirmTwoFaPopup = function () {
	        this.TwoFasuccessPopup.hide();
	    };
	    InstanceUpdateComponent.prototype.OnBackClick = function () {
	        this.locationService.back();
	    };
	    InstanceUpdateComponent.prototype.onConfirm = function ($event) {
	        this.model.geofenceAttributeModel.address = $event.address;
	        this.model.geofenceAttributeModel.latitude = $event.lat;
	        this.model.geofenceAttributeModel.longitude = $event.long;
	    };
	    InstanceUpdateComponent.prototype.ResetLocationField = function () {
	        this.model.geofenceAttributeModel.address = "";
	        this.model.geofenceAttributeModel.latitude = "0";
	        this.model.geofenceAttributeModel.longitude = "0";
	    };
	    Object.defineProperty(InstanceUpdateComponent.prototype, "diagnostic", {
	        // TODO: Remove this when we're done
	        get: function () {
	            return JSON.stringify(this.model);
	        },
	        enumerable: true,
	        configurable: true
	    });
	    InstanceUpdateComponent.prototype.GetImageURL = function (imagePath) {
	        return config_1.WeGoConfig.API_SERVER_URL + imagePath;
	    };
	    InstanceUpdateComponent.prototype.GetCustomerList = function () {
	        var _this = this;
	        this.customerService.GetCustomerDropdownList().subscribe(function (res) {
	            _this.apiResponse = res;
	            _this.customerList = res.data;
	            if (_this.customerList && _this.customerList.length > 0) {
	                if (!_this.model.customerMasterHashId &&
	                    _this.customerList.length == 1) {
	                    _this.model.customerMasterHashId = _this.customerList[0].keyHash;
	                }
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    InstanceUpdateComponent.prototype.GetTimeZoneList = function () {
	        var _this = this;
	        this.instanceService.GetDropdownTimeZoneList().subscribe(function (res) {
	            _this.timeZoneList = res.data;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    InstanceUpdateComponent.prototype.GetTelephoneCountry = function () {
	        var _this = this;
	        this.authService.GetTelephoneCountry().subscribe(function (res) {
	            _this.countryList = res.data;
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    InstanceUpdateComponent.prototype.ClearFileInput = function () {
	        console.log(this.logoFile);
	        if (this.logoFile.nativeElement) {
	            console.log(this.logoFile.nativeElement.value);
	            this.logoFile.nativeElement.value = "";
	            this.uploader.clearQueue();
	        }
	    };
	    // Dashboard configuration function
	    InstanceUpdateComponent.prototype.DashboardEnableCurrentLocationChange = function () {
	        if (!this.model.dashboardConfigModel.enableCurrentLocation) {
	            this.model.dashboardConfigModel.defaultLocation = "HOME";
	            this.model.dashboardConfigModel.enableAutoUpdate = false;
	            this.DashboardEnableAutoUpdateChange();
	        }
	    };
	    InstanceUpdateComponent.prototype.DashboardEnableAutoUpdateChange = function () {
	        if (!this.model.dashboardConfigModel.enableAutoUpdate) {
	            this.model.dashboardConfigModel.updateIntervalInSecond = "";
	        }
	        else {
	            this.model.dashboardConfigModel.updateIntervalInSecond = "15";
	        }
	    };
	    InstanceUpdateComponent.prototype.BatchUploadValidateLicenceChange = function () {
	        if (this.model.validateLiceanceNumber) {
	            this.model.batchUploadPersonConfigurationModel.sendActivationMail = true;
	            this.model.batchUploadPersonConfigurationModel.generateRandom_UseUploadedPassword = true;
	            this.model.batchUploadPersonConfigurationModel.fieldPassword = false;
	            this.BatchUploadSendActivationMail();
	        }
	    };
	    InstanceUpdateComponent.prototype.ValidateLicense24IDCheckChange = function () {
	        if (this.model.validateLicense24IDCheck != validate_license_24idcheck_option_1.ValidateLicense24IdCheckOption.On) {
	            this.model.validateLicenseCheckForBooking = false;
	        }
	    };
	    InstanceUpdateComponent.prototype.BatchUploadSendActivationMail = function () {
	        if (this.model.batchUploadPersonConfigurationModel.sendActivationMail) {
	            this.model.batchUploadPersonConfigurationModel.generateRandom_UseUploadedPassword = true;
	            this.model.batchUploadPersonConfigurationModel.fieldPassword = false;
	        }
	    };
	    InstanceUpdateComponent.prototype.UpdatePriorityNA = function (issueType) {
	        switch (issueType) {
	            case "DamageReported":
	                this.ResetNotificationModel(this.model.reportDamageNotificationModel);
	                break;
	            case "APKMaintananceScheduled":
	                this.ResetNotificationModel(this.model.apkMaintenanceNotificationModel);
	                break;
	            case "OutSideGeofence":
	                this.ResetNotificationModel(this.model.geofenceNotificationModel);
	                break;
	            case "VehicleSamePosition":
	                this.ResetNotificationModel(this.model.vehicleSameLocationNotificationModel);
	                break;
	            case "VehicleNotReturn":
	                this.ResetNotificationModel(this.model.vehicleNotReturnNotificationModel);
	                break;
	            case "VehicleNotBooked":
	                this.ResetNotificationModel(this.model.vehicleNotBookedNotificationModel);
	                break;
	            case "CleaningRequired":
	                this.ResetNotificationModel(this.model.cleaningRequiredNotificationModel);
	                break;
	            case "RefuelingRequired":
	                this.ResetNotificationModel(this.model.refuelingRequiredNotificationModel);
	                break;
	            case "LowBattery":
	                this.ResetNotificationModel(this.model.lowBatteryNotificationModel);
	                break;
	            case "LowCharge":
	                this.ResetNotificationModel(this.model.lowChargeNotificationModel);
	                break;
	            case "CommunicationProblem":
	                this.ResetNotificationModel(this.model.communicationProblemNotificationModel);
	                break;
	            case "InvalidTagUsed":
	                this.ResetNotificationModel(this.model.invalidTagScansNotificationModel);
	                break;
	            default:
	                break;
	        }
	    };
	    InstanceUpdateComponent.prototype.ResetNotificationModel = function (notificationModel) {
	        notificationModel.isEmailEnabled = false;
	        notificationModel.isNotificationEnabled = false;
	        // notificationModel.weGoAdmin = false;
	        // notificationModel.companyAdmin = false;
	        // notificationModel.groupAdmin = false;
	        // notificationModel.currentDriver = false;
	        // notificationModel.nextDriver = false;
	    };
	    Object.defineProperty(InstanceUpdateComponent.prototype, "isGeofenceNotificationDisable", {
	        get: function () {
	            if (!this.model.isGefenceEnabled) {
	                this.model.geofenceNotificationModel.priority = "NA";
	                this.UpdatePriorityNA("OutSideGeofence");
	                return true;
	            }
	            return false;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(InstanceUpdateComponent.prototype, "isReturnToHomeNotificationDisable", {
	        get: function () {
	            if (!(this.model.locationMode == "HOME")) {
	                this.model.vehicleNotReturnNotificationModel.priority = "NA";
	                this.UpdatePriorityNA("VehicleNotReturn");
	                return true;
	            }
	            return false;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    InstanceUpdateComponent.prototype.ngOnDestroy = function () {
	        if (this.sub) {
	            this.sub.unsubscribe();
	        }
	    };
	    InstanceUpdateComponent.prototype.onlyNumberKey = function (event) {
	        return event.charCode == 8 || event.charCode == 0
	            ? null
	            : event.charCode >= 48 && event.charCode <= 57;
	    };
	    InstanceUpdateComponent.prototype.changeOfOdometerTimeInterval = function () {
	        if (this.model.odometerConfigurationModel.timeInterval == "PERBOOKING")
	            this.model.odometerConfigurationModel.frequency = "";
	    };
	    InstanceUpdateComponent.prototype.OnVatSetting = function ($event) {
	        this.model.vatSettingsList = $event.vatSettingsList;
	        this.model.vatSettingDefaultCost = $event.vatSettingDefaultCost;
	    };
	    InstanceUpdateComponent.prototype.OnPrePostTripQuestionSetting = function ($event) {
	        this.model.customTripQuestionList = $event.customTripQuestionList;
	    };
	    InstanceUpdateComponent.prototype.ResetCookies = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.instanceService.ResetTwoFaCookies(this.instanceHashId)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupTitle = _this.translate.instant('LblSuccess');
	                _this.popupMsg = _this.translate.instant('LblCookieResetSuccess', [_this.module]);
	                _this.isLoading = false;
	                _this.ShowTwoFaPopup();
	            }
	            else {
	                _this.popupTitle = _this.translate.instant('LblError');
	                _this.popupMsg = _this.translate.instant('LblCookieResetFailed');
	                _this.isLoading = false;
	                _this.ShowTwoFaPopup();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    InstanceUpdateComponent.prototype.ResetTwoFA = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.instanceService.ResetTwoFaKeys(this.instanceHashId)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupTitle = _this.translate.instant('LblSuccess');
	                _this.popupMsg = _this.translate.instant('LblKeyResetSuccess', [_this.module]);
	                _this.isLoading = false;
	                _this.ShowTwoFaPopup();
	            }
	            else {
	                _this.popupTitle = _this.translate.instant('LblError');
	                _this.popupMsg = _this.translate.instant('LblKeyResetFailed');
	                _this.isLoading = false;
	                _this.ShowTwoFaPopup();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    InstanceUpdateComponent.prototype.IsAuthorizedForPrePostTripQuestion = function () {
	        var _this = this;
	        var primaryPermissionType;
	        var entity = '';
	        var entityHashId = '';
	        var permissionType = '';
	        if (this.instanceHashId != "") {
	            primaryPermissionType = config_1.PermissionType.EDIT;
	            entity = config_1.Entity.INSTANCE;
	            entityHashId = this.instanceHashId;
	        }
	        else {
	            primaryPermissionType = config_1.PermissionType.INSERT;
	            entity = config_1.Entity.CUSTOMER;
	            entityHashId = this.model.customerMasterHashId;
	        }
	        this.authService
	            .IsAuthorizedForPrePostQuestion(config_1.Permission.PR_INSTANCE, primaryPermissionType, config_1.Permission.PR_PREPOST_TRIP_QUESTIONS_UPDATE, config_1.PermissionType.VIEW, entity, entityHashId)
	            .subscribe(function (res) {
	            _this.isAuthorizedForPrePostTrip = res.data.view;
	            _this.basePermissionModel = res.data;
	            console.log(_this.prePostTripQuestionSection);
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	        }, function () {
	            setTimeout(function () {
	                if (_this.isAuthorizedForPrePostTrip) {
	                    _this.prePostTripQuestionSection.GetPrePostTripQuestionList(_this.instanceHashId, null, null, null, _this.basePermissionModel, !_this.instanceHashId, true);
	                }
	            }, 1000);
	        });
	    };
	    InstanceUpdateComponent.prototype.onChangeSelectedSVG = function (selectedSvg) {
	        this.model.defaultSsoSharedVehicleGroupHashId = selectedSvg;
	        this.GetOrganizationList();
	    };
	    InstanceUpdateComponent.prototype.onChangeSelectedOrg = function (selectedOrg) {
	        this.model.defaultSsoOrganizationHashId = selectedOrg;
	        this.GetSubscriptionList();
	    };
	    InstanceUpdateComponent.prototype.GetSharedVehicleGroupList = function () {
	        var _this = this;
	        if (this.instanceHashId) {
	            this.instanceService.GetSharedVehicleGroupList(this.instanceHashId).subscribe(function (res) {
	                _this.sharedVehicleGroupList = res.data;
	                _this.isSvgSelected = _this.sharedVehicleGroupList && _this.sharedVehicleGroupList.length > 0;
	                if (res.error) {
	                    _this.apiSvgErrorMsg = res.error;
	                    _this.isSvgSelected = false;
	                }
	                else {
	                    _this.apiSvgErrorMsg = '';
	                }
	            }, function (error) {
	                _this.apiSvgErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            });
	        }
	        else {
	            this.model.defaultSsoSharedVehicleGroupHashId = '';
	            this.onChangeSelectedSVG(this.model.defaultSsoSharedVehicleGroupHashId);
	            this.isSvgSelected = false;
	        }
	    };
	    InstanceUpdateComponent.prototype.GetOrganizationList = function () {
	        var _this = this;
	        if (this.instanceHashId && this.model.defaultSsoSharedVehicleGroupHashId) {
	            this.instanceService.GetOrganizationListBySharedVehicleGroup(this.instanceHashId, this.model.defaultSsoSharedVehicleGroupHashId).subscribe(function (res) {
	                _this.organizationList = res.data;
	                if (_this.organizationList && _this.organizationList.length > 0) {
	                    _this.isOrgSelected = true;
	                    if (_this.organizationList.length == 1) {
	                        _this.organizationHashID = _this.organizationList[0].keyHash;
	                        _this.onChangeSelectedOrg(_this.organizationHashID);
	                    }
	                    else {
	                        _this.organizationHashID = '';
	                    }
	                }
	                else {
	                    _this.isOrgSelected = false;
	                    _this.organizationHashID = '';
	                }
	                if (res.error) {
	                    _this.apiOrgErrorMsg = res.error;
	                    _this.isOrgSelected = false;
	                }
	                else {
	                    _this.apiOrgErrorMsg = '';
	                }
	            }, function (error) {
	                _this.apiOrgErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            });
	        }
	        else {
	            this.model.defaultSsoOrganizationHashId = '';
	            this.onChangeSelectedOrg(this.model.defaultSsoOrganizationHashId);
	            this.isOrgSelected = false;
	        }
	    };
	    InstanceUpdateComponent.prototype.GetSubscriptionList = function () {
	        var _this = this;
	        if (this.model.defaultSsoOrganizationHashId) {
	            this.instanceService.GetSubscriptionListByOrganization(this.model.defaultSsoOrganizationHashId).subscribe(function (res) {
	                _this.subscriptionList = res.data;
	                if (_this.subscriptionList && _this.subscriptionList.length > 0) {
	                    _this.subscriptionList.length == 1 ? _this.subscriptionHashID = _this.subscriptionList[0].subscriptionMapHashId : _this.subscriptionHashID = '';
	                }
	                res.error ? _this.apiSubErrorMsg = res.error : _this.apiSubErrorMsg = '';
	            }, function (error) {
	                _this.apiSubErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            });
	        }
	        else {
	            this.model.defaultSsoSubscriptionHashId = '';
	        }
	    };
	    InstanceUpdateComponent.prototype.Base64Encode = function (input) {
	        var encode = Buffer.from(input, 'binary').toString('base64');
	        return encode;
	    };
	    InstanceUpdateComponent.prototype.Base64Decode = function (input) {
	        var decode = Buffer.from(input, 'base64').toString('binary');
	        return decode;
	    };
	    InstanceUpdateComponent.prototype.onSubmitClick = function () {
	        if (this.model.importConnectionType == 1) {
	            // Afas
	            var isValid = true;
	            var afasClientIdValue = document.getElementById("afasClientId").value;
	            if (!afasClientIdValue) {
	                isValid = false;
	                document.getElementById("afasClientIdError").innerText = this.translate.instant('LblAfasClientIdError');
	            }
	            var afasConnectorNameValue = document.getElementById("afasConnectorName").value;
	            if (!afasConnectorNameValue) {
	                isValid = false;
	                document.getElementById("afasConnectorNameError").innerText = this.translate.instant('LblAfasConnectorNameError');
	            }
	            var afasConnectionTypeValue = document.getElementById("afasConnectionType").value;
	            if (!afasConnectionTypeValue) {
	                isValid = false;
	                document.getElementById("afasConnectionTypeError").innerText = this.translate.instant('LblAfasConnectionTypeError');
	            }
	            var afasTokenValue = document.getElementById("afasToken").value;
	            if (!afasTokenValue) {
	                isValid = false;
	                document.getElementById("afasTokenError").innerText = this.translate.instant('LblAfasTokenError');
	            }
	            return isValid;
	        }
	        else if (this.model.importConnectionType == 2) {
	            // Azure
	            var isValid = true;
	            var azureTenantIdValue = document.getElementById("azureTenantId").value;
	            if (!azureTenantIdValue) {
	                isValid = false;
	                document.getElementById("azureTenantIdError").innerText = this.translate.instant('LblAzureTenantIdError');
	            }
	            var azureClientIdValue = document.getElementById("azureClientId").value;
	            if (!azureClientIdValue) {
	                isValid = false;
	                document.getElementById("azureClientIdError").innerText = this.translate.instant('LblAzureClientIdError');
	            }
	            var azureClientSecretValue = document.getElementById("azureClientSecret").value;
	            if (!azureClientSecretValue) {
	                isValid = false;
	                document.getElementById("azureClientSecretError").innerText = this.translate.instant('LblAzureClientSecretError');
	                return false;
	            }
	            return isValid;
	        }
	    };
	    __decorate([
	        core_1.ViewChild("logoFile"), 
	        __metadata('design:type', Object)
	    ], InstanceUpdateComponent.prototype, "logoFile", void 0);
	    __decorate([
	        core_1.ViewChild("successPopup"), 
	        __metadata('design:type', Object)
	    ], InstanceUpdateComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild("TwoFasuccessPopup"), 
	        __metadata('design:type', Object)
	    ], InstanceUpdateComponent.prototype, "TwoFasuccessPopup", void 0);
	    __decorate([
	        core_1.ViewChild("geoLocationModal"), 
	        __metadata('design:type', Object)
	    ], InstanceUpdateComponent.prototype, "geoLocationModal", void 0);
	    __decorate([
	        core_1.ViewChild("prePostTripQuestionSection"), 
	        __metadata('design:type', (typeof (_a = typeof pre_post_trip_question_component_1.PrePostTripQuestionComponent !== 'undefined' && pre_post_trip_question_component_1.PrePostTripQuestionComponent) === 'function' && _a) || Object)
	    ], InstanceUpdateComponent.prototype, "prePostTripQuestionSection", void 0);
	    InstanceUpdateComponent = __decorate([
	        core_1.Component({
	            selector: "wego-instance",
	            template: __webpack_require__(847),
	            providers: [instance_service_1.InstanceService, customer_service_1.CustomerService],
	            styles: [
	                "\n  .batchuploadpadding{\n    padding-left: 35px;\n    margin-top:10px;\n  }\n\n  .bookingDelaymargintop\n  {\n    margin-top: 15px;\n  }\n\n  "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof instance_service_1.InstanceService !== 'undefined' && instance_service_1.InstanceService) === 'function' && _b) || Object, (typeof (_c = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object, (typeof (_e = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _e) || Object, (typeof (_f = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _f) || Object, (typeof (_g = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _g) || Object, (typeof (_h = typeof customer_service_1.CustomerService !== 'undefined' && customer_service_1.CustomerService) === 'function' && _h) || Object])
	    ], InstanceUpdateComponent);
	    return InstanceUpdateComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h;
	}());
	exports.InstanceUpdateComponent = InstanceUpdateComponent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(842).Buffer))

/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(843)
	var ieee754 = __webpack_require__(844)
	var isArray = __webpack_require__(845)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 843 */
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	// Support decoding URL-safe base64 strings, as Node.js does.
	// See: https://en.wikipedia.org/wiki/Base64#URL_applications
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function getLens (b64) {
	  var len = b64.length
	
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // Trim off extra bytes after placeholder bytes are found
	  // See: https://github.com/beatgammit/base64-js/issues/42
	  var validLen = b64.indexOf('=')
	  if (validLen === -1) validLen = len
	
	  var placeHoldersLen = validLen === len
	    ? 0
	    : 4 - (validLen % 4)
	
	  return [validLen, placeHoldersLen]
	}
	
	// base64 is 4/3 + up to two characters of the original data
	function byteLength (b64) {
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function _byteLength (b64, validLen, placeHoldersLen) {
	  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
	}
	
	function toByteArray (b64) {
	  var tmp
	  var lens = getLens(b64)
	  var validLen = lens[0]
	  var placeHoldersLen = lens[1]
	
	  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))
	
	  var curByte = 0
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  var len = placeHoldersLen > 0
	    ? validLen - 4
	    : validLen
	
	  var i
	  for (i = 0; i < len; i += 4) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 18) |
	      (revLookup[b64.charCodeAt(i + 1)] << 12) |
	      (revLookup[b64.charCodeAt(i + 2)] << 6) |
	      revLookup[b64.charCodeAt(i + 3)]
	    arr[curByte++] = (tmp >> 16) & 0xFF
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 2) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 2) |
	      (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  if (placeHoldersLen === 1) {
	    tmp =
	      (revLookup[b64.charCodeAt(i)] << 10) |
	      (revLookup[b64.charCodeAt(i + 1)] << 4) |
	      (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[curByte++] = (tmp >> 8) & 0xFF
	    arr[curByte++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] +
	    lookup[num >> 12 & 0x3F] +
	    lookup[num >> 6 & 0x3F] +
	    lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp =
	      ((uint8[i] << 16) & 0xFF0000) +
	      ((uint8[i + 1] << 8) & 0xFF00) +
	      (uint8[i + 2] & 0xFF)
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 2] +
	      lookup[(tmp << 4) & 0x3F] +
	      '=='
	    )
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
	    parts.push(
	      lookup[tmp >> 10] +
	      lookup[(tmp >> 4) & 0x3F] +
	      lookup[(tmp << 2) & 0x3F] +
	      '='
	    )
	  }
	
	  return parts.join('')
	}


/***/ },
/* 844 */
/***/ function(module, exports) {

	/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = (nBytes * 8) - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = ((value * c) - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 845 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 846 */
/***/ function(module, exports) {

	"use strict";
	(function (ImportConnectionTypeOption) {
	    ImportConnectionTypeOption[ImportConnectionTypeOption["Afas"] = 1] = "Afas";
	    ImportConnectionTypeOption[ImportConnectionTypeOption["Azure"] = 2] = "Azure";
	    ImportConnectionTypeOption[ImportConnectionTypeOption["Off"] = 0] = "Off";
	})(exports.ImportConnectionTypeOption || (exports.ImportConnectionTypeOption = {}));
	var ImportConnectionTypeOption = exports.ImportConnectionTypeOption;


/***/ },
/* 847 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\n  <section class=\"content-header\">\n    <div class=\"col-md-9 col-sm-6\">\n      <h1 class=\"pagename\">{{breadCrumbTitle}}</h1>\n      <ol class=\"breadcrumb\">\n        <li>\n          <a [routerLink]=\"urlDefaultPage\">\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\n        </li>\n        <li>\n          <a [routerLink]=\"urlInstanceList\">\n            <i class=\"fa fa-bolt fa-fw\"></i>{{breadCrumbList}}</a>\n        </li>\n        <li class=\"active\">{{breadCrumbTitle}}</li>\n      </ol>\n    </div>\n    <div class=\"col-md-3 col-sm-6 mar_t_25 \">\n    </div>\n    <div class=\"clearfix\"></div>\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\n    <div class=\"clearfix\"></div>\n  </section>\n  <section class=\"content\">\n    <!-- <pre>{{ model | json }}</pre> -->\n    <div class=\"nopad\">\n      <form (ngSubmit)=\"OnSubmit(AddInstanceForm.value)\" #AddInstanceForm=\"ngForm\">\n        <input type=\"hidden\" class=\"form-control\" [(ngModel)]=\"model.instanceHashId\" name=\"instanceHashId\">\n        <div class=\"form-group col-md-4\">\n          <label>\n            <span class=\"text text-danger\">*</span> {{ 'LblInstanceName' | translate }}\n          </label>\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblInstanceName' | translate }}\" [(ngModel)]=\"model.instanceName\"\n            name=\"InstanceName\" maxlength=\"30\">\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'instanceName' }}</span>\n        </div>\n        <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Customer\" class=\"form-group col-md-4\">\n          <span class=\"text text-danger\">*</span>\n          <label>{{'LblCustomer' | translate }}</label>\n          <select *ngIf=\"!isEditMode\" [(ngModel)]=\"model.customerMasterHashId\" (change)=\"IsAuthorizedForPrePostTripQuestion()\"\n            name=\"customer\" class=\"form-control\">\n            <option value=\"\" [selected]=\"selected\">{{ 'LblSelect' | translate }} {{ 'LblCustomer' | translate }}</option>\n            <option *ngFor=\"let cust of customerList\" [attr.value]='cust.keyHash'>{{cust.value}}</option>\n          </select>\n          <input *ngIf=\"isEditMode\" type=\"text\" class=\"form-control\" [(ngModel)]=\"model.customerName\" name=\"customerName\"\n            readonly=\"readonly\">\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'CustomerMasterHashId' }}</span>\n        </div>\n        <div class=\"form-group col-md-4\">\n          <label>{{'LblDescription' | translate }}</label>\n          <textarea class=\"form-control\" placeholder=\"{{'LblDescription' | translate }}\" [(ngModel)]=\"model.description\"\n            name=\"model.description\" maxlength=\"100\"></textarea>\n        </div>\n        <div class=\"clearfix\"></div>\n        <div class=\"form-group col-md-4\">\n          <label>\n            <span class=\"text text-danger\">*</span> {{ 'LblPreferredLanguage' | translate }}\n          </label>\n          <select [(ngModel)]=\"model.preferredLanguage\" name=\"PreferredLanguage\" class=\"form-control\">\n            <option value=\"\" [selected]=\"selected\">{{ 'LblSelect' | translate }} {{ 'LblPreferredLanguage' | translate\n              }}</option>\n            <option *ngFor=\"let preferredLanguage of preferredLanguageList\" [attr.value]='preferredLanguage'>{{preferredLanguage}}</option>\n          </select>\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'preferredLanguage' }}</span>\n        </div>\n        <div class=\"form-group col-md-4\">\n          <label>\n            <span class=\"text text-danger\">*</span> {{ 'LblTimeZone' | translate }}\n          </label>\n          <select [disabled]=\"isEditMode\" [(ngModel)]=\"model.timeZone\" name=\"TimeZone\" class=\"form-control\">\n            <option value=\"\" [selected]=\"selected\">{{ 'LblSelect' | translate }} {{ 'LblTimeZone' | translate }}</option>\n            <option *ngFor=\"let timeZone of timeZoneList\" [attr.value]='timeZone.value'>{{timeZone.data}}</option>\n          </select>\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'timeZone' }}</span>\n        </div>\n        <div class=\"form-group col-md-4\">\n          <label>\n            <span class=\"text text-danger\">*</span> {{ 'LblCountryCode' | translate }}\n          </label>\n          <select [(ngModel)]=\"model.countryCode\" class=\"form-control country-select\" name=\"countryCode\">\n            <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblCountryCode' | translate }}</option>\n            <option *ngFor=\"let item of countryList\" [ngValue]=\"item.value\">{{ item.value }}</option>\n          </select>\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'countryCode' }}</span>\n        </div>\n        <div class=\"clearfix\"></div>\n        <div class=\"form-group col-md-4\">\n          <!-- <div class=\"form-group col-md-12\"> -->\n            <label>\n              <span class=\"text text-danger\">*</span> {{ 'LblHelpdeskNo' | translate }}</label>\n            <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblHelpdeskNo' | translate }}\" [(ngModel)]=\"model.helpdeskNo\"\n              name=\"helpdeskNo\" maxlength=\"20\">\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'helpdeskNo' }}</span>\n          <!-- </div> -->\n        </div>\n        <!-- <div class=\"form-group col-md-4\">\n          <label>\n            <span class=\"text text-danger\">*</span> {{ 'LblCurrencySymbol' | translate }}\n          </label>\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblCurrencySymbol' | translate }}\" [(ngModel)]=\"model.currencySymbol\"\n            name=\"CurrencySymbol\" maxlength=\"1\">\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'currencySymbol' }}</span>\n        </div>\n        <div class=\"form-group col-md-4\">\n          <label>\n            <span class=\"text text-danger\">*</span> {{ 'LblCurrencyAbbreviation' | translate }}\n          </label>\n          <select [(ngModel)]=\"model.currencyAbbreviation\" name=\"CurrencyAbbreviation\" class=\"form-control\">\n            <option value=\"\" [selected]=\"selected\">{{ 'LblSelect' | translate }} {{ 'LblCurrencyAbbreviation' | translate }}</option>\n            <option *ngFor=\"let currencyAbbreviation of currencyAbbreviationList\" [attr.value]='currencyAbbreviation'>{{currencyAbbreviation}}</option>\n          </select>\n\n        </div> \n        <div class=\"clearfix\"></div>-->\n        <div class=\"form-group col-md-4\">\n          <label>\n            {{ 'LblIsBookingApprovalReq' | translate }}</label>\n          <div>\n            <label class=\"radio-inline\">\n              <input type=\"radio\" [(ngModel)]=\"model.isBookingApprovalReq\" name=\"IsBookingApprovalReq\" [value]=\"true\">{{\n              'LblYes' | translate }}</label>\n            <label class=\"radio-inline\">\n              <input type=\"radio\" [(ngModel)]=\"model.isBookingApprovalReq\" name=\"IsBookingApprovalReq\" [value]=\"false\">{{\n              'LblNo' | translate }}</label>\n          </div>\n        </div>\n\n        <div class=\"form-group col-md-4\">\n          <label>\n            <span class=\"text text-danger\">*</span> {{ 'LblIsImportPersonAllow' | translate }}</label>\n          <div>\n            <label class=\"radio-inline\">\n              <input type=\"radio\" [(ngModel)]=\"model.isImportPersonAllow\" name=\"IsImportPersonAllow\" [value]=\"true\">{{\n              'LblYes' | translate }}</label>\n            <label class=\"radio-inline\">\n              <input type=\"radio\" [(ngModel)]=\"model.isImportPersonAllow\" name=\"IsImportPersonAllow\" [value]=\"false\">{{\n              'LblNo' | translate }}</label>\n          </div>\n        </div>\n        <div class=\"form-group col-md-4\">\n          <label>\n            <span class=\"text text-danger\">*</span> {{ 'LblEnableNIFNumber' | translate }}</label>\n          <div>\n            <label class=\"radio-inline\">\n              <input type=\"radio\" [(ngModel)]=\"model.enableNIFNumber\" name=\"EnableNIFNumber\" [value]=\"true\">{{ 'LblYes'\n                    | translate }}</label>\n            <label class=\"radio-inline\">\n              <input type=\"radio\" [(ngModel)]=\"model.enableNIFNumber\" name=\"EnableNIFNumber\" [value]=\"false\">{{ 'LblNo'\n                    | translate }}</label>\n          </div>\n        </div>\n        <div class=\"form-group col-md-4\">\n          <label>\n            <span class=\"text text-danger\">*</span> {{ 'LblEnableSnauilTrail' | translate }}</label>\n          <div class=\"clearfix\"></div>\n          <label class=\"radio-inline\">\n            <input type=\"radio\" [(ngModel)]=\"model.enableSnailTrail\" name=\"enableSnailTrail\" [value]=\"true\">{{ 'LblYes'\n                  | translate }}</label>\n          <label class=\"radio-inline\">\n            <input type=\"radio\" [(ngModel)]=\"model.enableSnailTrail\" name=\"enableSnailTrail\" [value]=\"false\">{{ 'LblNo'\n                  | translate }}</label>\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'EnableSnailTrail' }}</span>\n        </div>\n        <div class=\"clearfix\"></div>\n        <div class=\"form-group col-md-2\">\n          <label>\n            <span class=\"text text-danger\">*</span> {{ 'LblSendInvoiceToDriver' | translate }}</label>\n          <div class=\"clearfix\"></div>\n          <label class=\"radio-inline\">\n            <input type=\"radio\" [(ngModel)]=\"model.sendInvoiceToDriver\" name=\"sendInvoiceToDriver\" value=\"YES\">{{\n            'LblYes' | translate }}</label>\n          <label class=\"radio-inline\">\n            <input type=\"radio\" [(ngModel)]=\"model.sendInvoiceToDriver\" name=\"sendInvoiceToDriver\" value=\"NO\">{{\n            'LblNo' | translate }}</label>\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'SendInvoiceToDriver' }}</span>\n        </div>\n\n        <div class=\"form-group col-md-2\">\n          <label>\n            <span class=\"text text-danger\">*</span> {{ 'LblSendInvoiceToOrganization' | translate }}</label>\n          <div class=\"clearfix\"></div>\n          <label class=\"radio-inline\">\n            <input type=\"radio\" [(ngModel)]=\"model.sendInvoiceToOrganization\" name=\"sendInvoiceToOrganization\" value=\"YES\">{{\n            'LblYes' | translate }}</label>\n          <label class=\"radio-inline\">\n            <input type=\"radio\" [(ngModel)]=\"model.sendInvoiceToOrganization\" name=\"sendInvoiceToOrganization\" value=\"NO\">{{\n            'LblNo' | translate }}</label>\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'SendInvoiceToOrganization' }}</span>\n        </div>\n\n        <!-- start Organization setting -->\n        <!-- <div class=\"form-group col-md-4\">\n          <label>\n            <span class=\"text text-danger\">*</span> {{ 'LblCreateOrganization' | translate }}</label>\n          <div class=\"clearfix\"></div>\n          <label class=\"radio-inline\">\n            <input type=\"radio\" [(ngModel)]=\"model.isCreateOrganizationEnabled\" name=\"isCreateOrganizationEnabled\" [value]=\"true\">{{ 'LblYes' | translate }}</label>\n          <label class=\"radio-inline\">\n            <input type=\"radio\" [(ngModel)]=\"model.isCreateOrganizationEnabled\" name=\"isCreateOrganizationEnabled\" [value]=\"false\">{{ 'LblNo' | translate }}</label>\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'IsCreateOrganizationEnabled' }}</span>\n        </div> -->\n        <!-- End Organization setting -->\n        <!-- start AppSupportTo setting -->\n        <!-- <div class=\"form-group col-md-4\">\n          <label>\n            <span class=\"text text-danger\">*</span> {{ 'LblAppSupportTo' | translate }}</label>\n          <div class=\"clearfix\"></div>\n          <div class=\"form-group inline\">\n            <select name=\"model.appSupportTo\" [(ngModel)]=\"model.appSupportTo\" class=\"form-control inline\">\n              <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblAppSupportTo' | translate }} </option>\n              <option value=\"NO_RESTRICTION\">{{'LblNoRestriction' | translate}}</option>\n              <option value=\"CUSTOM_APP_AND_TEST_APP\">{{'LblCustomAppTestApp' | translate}}</option>\n              <option value=\"CUSTOM_APP_ONLY\">{{'LblCustomAppOnly' | translate}}</option>\n            </select>\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'appSupportTo' }}</span>\n          </div>\n        </div> -->\n        <!-- End AppSupportTo setting -->\n        <div class=\"clearfix\"></div>\n        <div class=\"form-group col-md-4\">\n          <label>{{ 'LblInstanceLogo' | translate }}</label>\n          <div>\n            <input #logoFile type=\"file\" id=\"fileLoader\" accept=\"image/x-png,image/png,image/gif,image/jpeg\"\n              ng2FileSelect [uploader]=\"uploader\" name=\"files\" [ngClass]=\"{'nv-file-over': hasBaseDropZoneOver}\" title=\"Load File\" />\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'file' }}</span>\n          </div>\n        </div>\n        <div *ngIf=\"model.instanceLogoPath!=null\" class=\"form-group col-md-4\">\n          <img [src]=\"GetImageURL(model.instanceLogoPath)\" class=\"img-thumbnail\" style=\"max-height: 120px;\">\n        </div>\n        <div class=\"form-group col-md-4\">\n          <span class=\"text text-danger\">*</span>\n          <label>{{ 'LblDamageImageExtentions' | translate }}</label>\n          <div class=\"clearfix\"></div>\n          <label class=\"checkbox-inline\" *ngFor=\"let imageExtention of damageImageExtentions\" style=\"margin-left: 0px; margin-right: 10px;\">\n            <input type=\"checkbox\" (change)=\"OnChangeDamageImageExtension(imageExtention, $event.target.checked)\" value=\"imageExtention.value\"\n              [checked]=\"imageExtention.IsChecked\" /> {{imageExtention.Key}}\n          </label>\n          <div class=\"clearfix\"></div>\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'damageImageExtensions' }}</span>\n        </div>\n\n        <div class=\"row col-md-12\">\n          <fieldset class=\"col-md-6\">\n            <legend class=\"legendStyle\">\n              <span class=\"text text-danger\">*</span>\n              {{ 'LblLicenseCheckConfiguration' | translate }}\n            </legend>\n            <div class=\"clearfix\"></div>\n            <div class=\"form-group col-md-4\">\n              <label>\n                <span class=\"text text-danger\">*</span> {{ 'LblValidateLicenseA2SP' | translate }}</label>\n              <div>\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" [(ngModel)]=\"model.validateLiceanceNumber\" name=\"ValidateLicenseA2SP\" [value]=\"true\"\n                        (change)=\"BatchUploadValidateLicenceChange();\">{{ 'LblYes' | translate }}</label>\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" [(ngModel)]=\"model.validateLiceanceNumber\" name=\"ValidateLicenseA2SP\" [value]=\"false\"\n                        (change)=\"BatchUploadValidateLicenceChange();\">{{ 'LblNo' | translate }}</label>\n              </div>\n            </div>\n            <div class=\"form-group col-md-4\" >\n              <label>\n                <span class=\"text text-danger\">*</span> {{ 'LblValidateLicense24IDCheck' | translate }}</label>\n                <div>\n                <label class=\"radio-inline\" *ngFor=\"let optionKey of validateLicense24IdCheckOptionKeys\">\n                  <input type=\"radio\" [(ngModel)]=\"model.validateLicense24IDCheck\" name=\"ValidateLicense24IDCheck\" [value]=\"validateLicense24IdCheckOption[optionKey]\"\n                        (change)=\"ValidateLicense24IDCheckChange();\">{{ 'Lbl'+optionKey | translate }}\n                </label>\n                </div>\n            </div>\n            <div class=\"form-group col-md-4\" *ngIf=\"model.validateLicense24IDCheck == validateLicense24IdCheckOption.On\">\n              <label>\n                <span class=\"text text-danger\">*</span> {{ 'LblValidateLicenseCheckForBooking' | translate }}</label>\n              <div>\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" [(ngModel)]=\"model.validateLicenseCheckForBooking\" name=\"ValidateLicenseCheckForBooking\" [value]=\"true\">{{ 'LblYes' | translate }}</label>\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" [(ngModel)]=\"model.validateLicenseCheckForBooking\" name=\"ValidateLicenseCheckForBooking\" [value]=\"false\">{{ 'LblNo' | translate }}</label>\n              </div>\n            </div>\n          </fieldset>\n\n          <fieldset class=\"col-md-6\">\n            <legend class=\"legendStyle\">\n              {{ 'LblImportConfiguration' | translate }}\n            </legend>\n\n            <div class=\"clearfix\"></div>\n            <div class=\"form-group col-md-12\">             \n              <label>\n                {{ 'LblImportConnectionType' | translate }}\n              </label>\n              <div>\n                <label class=\"radio-inline\" *ngFor=\"let optionKey of importConnectionTypeOptionKeys\">\n                  <input type=\"radio\" [(checked)]=\"model.importConnectionType==importConnectionTypeOption[optionKey]\" [(ngModel)]=\"model.importConnectionType\" name=\"ImportConnectionType\" [value]=\"importConnectionTypeOption[optionKey]\">\n                  {{ 'Lbl'+optionKey | translate }}\n                </label>\n              </div>\n            </div>\n\n            <div class=\"afas\" *ngIf=\"model.importConnectionType == importConnectionTypeOption.Afas\">\n              <div class=\"form-group col-md-6\">\n                <label>\n                  <span class=\"text text-danger\" *ngIf=\"model.importConnectionType == importConnectionTypeOption.Afas\">*</span> {{ 'LblAfasClientId' | translate }}\n                </label>\n                <div>\n                  <input class=\"form-control\" placeholder=\"{{ 'LblAfasClientId' | translate }}\" type=\"text\" id=\"afasClientId\" name=\"afasClientId\" [(ngModel)]=\"model.afasClientId\" [(required)]=\"model.importConnectionType==importConnectionTypeOption.Afas\">\n                  <span class=\"text text-danger\" id=\"afasClientIdError\"></span>\n                </div>\n              </div>\n              <div class=\"form-group col-md-6\">\n                <label>\n                  <span class=\"text text-danger\" *ngIf=\"model.importConnectionType == importConnectionTypeOption.Afas\">*</span> {{ 'LblAfasConnectorName' | translate }}\n                </label>\n                <div>\n                  <input class=\"form-control\" placeholder=\"{{ 'LblAfasConnectorName' | translate }}\" type=\"text\" id=\"afasConnectorName\" name=\"afasConnectorName\" [(ngModel)]=\"model.afasConnectorName\" [(required)]=\"model.importConnectionType==importConnectionTypeOption.Afas\">\n                  <span class=\"text text-danger\" id=\"afasConnectorNameError\"></span>\n                </div>\n              </div>\n              <div class=\"form-group col-md-6\">\n                <label>\n                  <span class=\"text text-danger\" *ngIf=\"model.importConnectionType == importConnectionTypeOption.Afas\">*</span> {{ 'LblAfasConnectionType' | translate }}\n                </label>\n                <div>\n                  <label class=\"radio-inline\">\n                    <input type=\"radio\" [(ngModel)]=\"model.afasConnectionType\" id=\"afasConnectionType\" name=\"afasConnectionType\" value=\"Test\" [(required)]=\"model.importConnectionType==importConnectionTypeOption.Afas\">{{ 'LblAfasTest' | translate }}</label>\n                  <label class=\"radio-inline\">\n                      <input type=\"radio\" [(ngModel)]=\"model.afasConnectionType\" name=\"afasConnectionType\" value=\"Accept\">{{ 'LblAfasAccept' | translate }}</label>                  \n                  <label class=\"radio-inline\">\n                    <input type=\"radio\" [(ngModel)]=\"model.afasConnectionType\" name=\"afasConnectionType\" value=\"Production\">{{ 'LblAfasProduction' | translate }}</label>\n                </div>\n              </div>\n              <div class=\"form-group col-md-6\">\n                <label>\n                  <span class=\"text text-danger\" *ngIf=\"model.importConnectionType == importConnectionTypeOption.Afas\">*</span> {{ 'LblAfasToken' | translate }}\n                </label>\n                <div>\n                  <textarea class=\"form-control\" rows=\"2\" placeholder=\"{{ 'LblAfasToken' | translate }}\" id=\"afasToken\" name=\"afasToken\" [(ngModel)]=\"model.afasToken\" maxlength=\"500\" [(required)]=\"model.importConnectionType==importConnectionTypeOption.Afas\"></textarea>\n                  <span class=\"text text-danger\" id=\"afasTokenError\"></span>\n                </div>\n              </div>\n            </div>\n\n            <div class=\"azure\" *ngIf=\"model.importConnectionType == importConnectionTypeOption.Azure\">\n              <div class=\"form-group col-md-6\">\n                <label>\n                  <span class=\"text text-danger\" *ngIf=\"model.importConnectionType == importConnectionTypeOption.Azure\">*</span> {{ 'LblAzureTenantId' | translate }}\n                </label>\n                <div>\n                  <input class=\"form-control\" placeholder=\"{{ 'LblAzureTenantId' | translate }}\" type=\"text\" id=\"azureTenantId\" name=\"azureTenantId\" [(ngModel)]=\"model.azureTenantId\" [(required)]=\"model.importConnectionType==importConnectionTypeOption.Azure\">\n                  <span class=\"text text-danger\" id=\"azureTenantIdError\"></span>\n                </div>\n              </div>              \n              <div class=\"form-group col-md-6\">\n                <label>\n                  <span class=\"text text-danger\" *ngIf=\"model.importConnectionType == importConnectionTypeOption.Azure\">*</span> {{ 'LblAzureClientId' | translate }}\n                </label>\n                <div>\n                  <input class=\"form-control\" placeholder=\"{{ 'LblAzureClientId' | translate }}\" type=\"text\" id=\"azureClientId\" name=\"azureClientId\" [(ngModel)]=\"model.azureClientId\" [(required)]=\"model.importConnectionType==importConnectionTypeOption.Azure\">\n                  <span class=\"text text-danger\" id=\"azureClientIdError\"></span>\n                </div>\n              </div>\n              <div class=\"form-group col-md-6\">             \n                <label>\n                  <span class=\"text text-danger\" *ngIf=\"model.importConnectionType == importConnectionTypeOption.Azure\">*</span> {{ 'LblAzureClientSecret' | translate }}\n                </label>\n                <div>\n                  <input class=\"form-control\" placeholder=\"{{ 'LblAzureClientSecret' | translate }}\" type=\"text\" id=\"azureClientSecret\" name=\"azureClientSecret\" [(ngModel)]=\"model.azureClientSecret\" [(required)]=\"model.importConnectionType==importConnectionTypeOption.Azure\">\n                  <span class=\"text text-danger\" id=\"azureClientSecretError\"></span>\n                </div>\n              </div>\n            </div>\n          </fieldset>\n        </div>\n\n        <div class=\"row col-md-12\">\n          <fieldset class=\"col-md-12\">\n            <legend class=\"legendStyle\">\n              <span class=\"text text-danger\">*</span>\n              {{ 'LblMobileAppConfiguration' | translate }}\n            </legend>\n            <div class=\"clearfix\"></div>\n            <div class=\"form-group col-md-4\">\n              <label>\n                <span class=\"text text-danger\">*</span> {{ 'LblEnableNewBooking' | translate }}</label>\n              <div>\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" [(ngModel)]=\"model.enableNewBooking\" name=\"enableNewBooking\" [value]=\"true\">{{\n                  'LblYes' | translate }}</label>\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" [(ngModel)]=\"model.enableNewBooking\" name=\"enableNewBooking\" [value]=\"false\">{{\n                  'LblNo' | translate }}</label>\n              </div>\n            </div>\n            <div class=\"form-group col-md-4\">\n              <label>\n                <span class=\"text text-danger\">*</span> {{ 'LblEnableBookingCalender' | translate }}</label>\n              <div>\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" [(ngModel)]=\"model.enableBookingCalender\" name=\"enableBookingCalender\" [value]=\"true\">{{\n                  'LblYes' | translate }}</label>\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" [(ngModel)]=\"model.enableBookingCalender\" name=\"enableBookingCalender\" [value]=\"false\">{{\n                  'LblNo' | translate }}</label>\n              </div>\n            </div>\n            <div class=\"form-group col-md-4\">\n              <label>\n                <span class=\"text text-danger\">*</span> {{ 'LblEnableSubscription' | translate }}</label>\n              <div>\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" [(ngModel)]=\"model.enableSubscription\" name=\"enableSubscription\" [value]=\"true\">{{\n                  'LblYes' | translate }}</label>\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" [(ngModel)]=\"model.enableSubscription\" name=\"enableSubscription\" [value]=\"false\">{{\n                  'LblNo' | translate }}</label>\n              </div>\n            </div>\n            <div class=\"clearfix\"></div>\n            <div class=\"form-group col-md-4\">\n              <label>\n                <span class=\"text text-danger\">*</span> {{ 'LblEnableUpdateProfile' | translate }}</label>\n              <div>\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" [(ngModel)]=\"model.enableUpdateProfile\" name=\"enableUpdateProfile\" [value]=\"true\">{{\n                  'LblYes' | translate }}</label>\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" [(ngModel)]=\"model.enableUpdateProfile\" name=\"enableUpdateProfile\" [value]=\"false\">{{\n                  'LblNo' | translate }}</label>\n              </div>\n            </div>\n\n            <div class=\"form-group col-md-4\">\n              <label>\n                <span class=\"text text-danger\">*</span> {{ 'LblEnableNotification' | translate }}</label>\n              <div>\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" [(ngModel)]=\"model.enableNotification\" name=\"enableNotification\" [value]=\"true\">{{\n                  'LblYes' | translate }}</label>\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" [(ngModel)]=\"model.enableNotification\" name=\"enableNotification\" [value]=\"false\">{{\n                  'LblNo' | translate }}</label>\n              </div>\n            </div>\n            <div class=\"form-group col-md-4\">\n              <label>\n                <span class=\"text text-danger\">*</span> {{ 'LblEnableChangeBooking' | translate }}</label>\n              <div>\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" [(ngModel)]=\"model.enableChangeBooking\" name=\"enableChangeBooking\" [value]=\"true\">{{\n                  'LblYes' | translate }}</label>\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" [(ngModel)]=\"model.enableChangeBooking\" name=\"enableChangeBooking\" [value]=\"false\">{{\n                  'LblNo' | translate }}</label>\n              </div>\n            </div>\n            <div class=\"clearfix\"></div>\n            <div class=\"form-group col-md-4\">\n              <label>\n                <span class=\"text text-danger\">*</span> {{ 'LblEnableAddExpenseMenu' | translate }}</label>\n              <div>\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" [(ngModel)]=\"model.enableAddExpenseMenu\" name=\"enableAddExpenseMenu\" [value]=\"true\">{{\n                  'LblYes' | translate }}</label>\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" [(ngModel)]=\"model.enableAddExpenseMenu\" name=\"enableAddExpenseMenu\" [value]=\"false\">{{\n                  'LblNo' | translate }}</label>\n              </div>\n            </div>\n\n            <div class=\"form-group col-md-4\">\n              <label>\n                <span class=\"text text-danger\">*</span> {{ 'LblAppSupportTo' | translate }}</label>\n              <div class=\"clearfix\"></div>\n              <div class=\"form-group inline\">\n                <select name=\"model.appSupportTo\" [(ngModel)]=\"model.appSupportTo\" class=\"form-control inline\">\n                  <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblAppSupportTo' | translate }} </option>\n                  <option value=\"NO_RESTRICTION\">{{'LblNoRestriction' | translate}}</option>\n                  <option value=\"CUSTOM_APP_AND_TEST_APP\">{{'LblCustomAppTestApp' | translate}}</option>\n                  <option value=\"CUSTOM_APP_ONLY\">{{'LblCustomAppOnly' | translate}}</option>\n                </select>\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'appSupportTo' }}</span>\n              </div>\n            </div>\n            <div class=\"form-group col-md-4\">\n              <label>{{ 'LblMobileAppLink' | translate }}</label>\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblMobileAppLink' | translate }}\" [(ngModel)]=\"model.mobileAppLink\"\n                name=\"mobileAppLink\" maxlength=\"500\">\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'mobileAppLink' }}</span>\n            </div>\n          </fieldset>\n        </div>\n\n        <!--Instance and Email Configuration-->\n        <div class=\"row col-md-12\">\n          <!--Instance Configuration-->\n          <fieldset class=\"col-md-6\">\n            <legend class=\"legendStyle\">\n              <span class=\"text text-danger\">*</span> {{ 'LblInstanceConfiguration' | translate }}\n            </legend>\n            <div class=\"clearfix\"></div>\n            <div class=\"form-group col-md-6\">\n              <label>{{ 'LblBookingCancelTime' | translate }}</label>\n              <div class=\"input-group\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblInSeconds' | translate }}\" [(ngModel)]=\"model.bookingCancelTime\"\n                  name=\"bookingCancelTime\" maxlength=\"6\">\n                <span class=\"input-group-addon\" id=\"basic-addon2\">\n                  <i class=\"fa fa-info-circle\" aria-hidden=\"true\" title=\"{{ 'LblBookingCancelTimeMessage' | translate }}\"></i>\n                </span>\n              </div>\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'bookingCancelTime' }}</span>\n            </div>\n\n            <div class=\"form-group col-md-6\">\n              <label>{{ 'LblBookingTemporaryTime' | translate }}</label>\n              <div class=\"input-group\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblInSeconds' | translate }}\" [(ngModel)]=\"model.bookingTemporaryTime\"\n                  name=\"bookingTemporaryTime\" maxlength=\"6\">\n                <span class=\"input-group-addon\" id=\"basic-addon2\">\n                  <i class=\"fa fa-info-circle\" aria-hidden=\"true\" title=\"{{ 'LblBookingTemporaryTimeMessage' | translate }}\"></i>\n                </span>\n              </div>\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'bookingTemporaryTime' }}</span>\n\n            </div>\n            <div class=\"clearfix\"></div>\n            <div class=\"form-group col-md-6\">\n              <label>{{ 'LblVtsRequestTimeout' | translate }}</label>\n              <div class=\"input-group\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblInSeconds' | translate }}\" [(ngModel)]=\"model.vtsRequestTimeout\"\n                  name=\"vtsRequestTimeout\" maxlength=\"6\">\n                <span class=\"input-group-addon\" id=\"basic-addon2\">\n                  <i class=\"fa fa-info-circle\" aria-hidden=\"true\" title=\"{{ 'LblVtSRequestTimeoutMessage' | translate }}\"></i>\n                </span>\n              </div>\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'vtsRequestTimeout' }}</span>\n            </div>\n\n            <div class=\"form-group col-md-6\">\n              <label>{{ 'LblVtsTripLogTimeout' | translate }}</label>\n              <div class=\"input-group\">\n                <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblInSeconds' | translate }}\" [(ngModel)]=\"model.vtsTriplogTimeout\"\n                  name=\"vtsTriplogTimeout\" maxlength=\"6\">\n                <span class=\"input-group-addon\" id=\"basic-addon2\">\n                  <i class=\"fa fa-info-circle\" aria-hidden=\"true\" title=\"{{ 'LblVtsTriplogTimeoutMessage' | translate }}\"></i>\n                </span>\n              </div>\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'vtsTriplogTimeout' }}</span>\n            </div>\n\n          </fieldset>\n          <!--End Instance Configuration-->\n          <!--Email Configuration-->\n          <fieldset class=\"col-md-6\">\n            <legend class=\"legendStyle\">\n              <span class=\"text text-danger\">*</span> {{ 'LblEmailConfiguration' | translate }}\n            </legend>\n            <div class=\"clearfix\"></div>\n            <label class=\"container\">\n              <input\n                      type=\"checkbox\"\n                      [checked]=\"model.defaultEmailConfig\"\n                      (change)=\"model.defaultEmailConfig = !model.defaultEmailConfig\"/>\n              Use default email configuration\n            </label>\n            <div class=\"form-group col-md-6\">\n              <label>{{ 'LblHost' | translate }}</label>\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblHost' | translate }}\" [(ngModel)]=\"model.host\"\n                name=\"host\" maxlength=\"50\" [disabled]=\"model.defaultEmailConfig\">\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'host' }}</span>\n            </div>\n            <div class=\"form-group col-md-6\">\n              <label>{{ 'LblSmtpEmail' | translate }}</label>\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblSmtpEmail' | translate }}\" [(ngModel)]=\"model.userName\"\n                name=\"userName\" maxlength=\"100\" [disabled]=\"model.defaultEmailConfig\">\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'userName' }}</span>\n            </div>\n            <div class=\"clearfix\"></div>\n            <div class=\"form-group col-md-6\">\n              <label>{{ 'LblFromEmail' | translate }}</label>\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblFromEmail' | translate }}\" [(ngModel)]=\"model.fromEmail\"\n                name=\"fromEmail\" maxlength=\"100\" [disabled]=\"model.defaultEmailConfig\">\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'fromEmail' }}</span>\n            </div>\n            <div class=\"form-group col-md-6\">\n              <label>{{ 'LblPassword' | translate }}</label>\n              <input type=\"password\" class=\"form-control\" placeholder=\"{{ 'LblPassword' | translate }}\" [(ngModel)]=\"model.password\"\n                name=\"password\" maxlength=\"150\" [disabled]=\"model.defaultEmailConfig\">\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'password' }}</span>\n            </div>\n            <div class=\"clearfix\"></div>\n            <div class=\"form-group col-md-6\">\n              <label>{{ 'LblPort' | translate }}</label>\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblPort' | translate }}\" [(ngModel)]=\"model.port\"\n                name=\"port\" maxlength=\"25\" [disabled]=\"model.defaultEmailConfig\">\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'port' }}</span>\n            </div>\n            <div class=\"form-group col-md-6\">\n              <label>{{ 'LblEnableSsl' | translate }}</label>\n              <div>\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" [(ngModel)]=\"model.enablessl\" name=\"enablessl\" [value]=\"true\" [disabled]=\"model.defaultEmailConfig\">{{ 'LblYes' |\n                  translate }}</label>\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" [(ngModel)]=\"model.enablessl\" name=\"enablessl\" [value]=\"false\" [disabled]=\"model.defaultEmailConfig\">{{ 'LblNo' |\n                  translate }}</label>\n              </div>\n            </div>\n            <div class=\"clearfix\"></div>\n          </fieldset>\n          <!--End Email Configuration-->\n        </div>\n        <!--End Instance and Email Configuration-->\n\n        <!--Invoice Moment and Home Location Configuration-->\n        <div class=\"row col-md-12\">\n          <!--Invoice Moment Configuration-->\n          <fieldset class=\"col-md-6\">\n            <legend class=\"legendStyle\">\n              <span class=\"text text-danger\">*</span> {{ 'LblInvoiceMoment' | translate }}\n            </legend>\n            <div class=\"form-group col-md-6\">\n              <label>{{ 'LblDayOfMonth' | translate }}</label>\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblDayOfMonth' | translate }}\" [(ngModel)]=\"model.dayOfMonth\"\n                name=\"dayOfMonth\" maxlength=\"2\">\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'dayOfMonth' }}</span>\n            </div>\n            <div class=\"form-group col-md-6\">\n              <label>{{'LblDayOfWeek' | translate}}</label>\n              <select [(ngModel)]=\"model.dayOfWeek\" class=\"form-control\" name=\"DayOfWeek\">\n                <option *ngFor=\"let item of dayofWeekList\" [ngValue]=\"item.Value\">{{ item.Key }}</option>\n              </select>\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'dayOfWeek' }}</span>\n            </div>\n            <div class=\"form-group col-md-6\">\n              <label>{{ 'LblInvoicePreFix' | translate }}</label>\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblInvoicePreFix' | translate }}\" [(ngModel)]=\"model.invoicePreFix\"\n                name=\"invoicePreFix\" maxlength=\"20\">\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'invoicePreFix' }}</span>\n            </div>\n          </fieldset>\n          <!--End Invoice Moment Configuration-->\n          <!--Home Location Configuration-->\n          <fieldset class=\"col-md-6\">\n            <legend class=\"legendStyle\">\n              <span class=\"text text-danger\">*</span> {{ 'LblHomeLocation' | translate }}\n            </legend>\n            <div class=\"form-group col-md-6\">\n              <label>{{ 'LblLocationMode' | translate }}</label>\n              <div>\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" [(ngModel)]=\"model.locationMode\" name=\"LocationMode\" value=\"HOME\">{{ 'LblHome' |\n                  translate }}</label>\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" [(ngModel)]=\"model.locationMode\" name=\"LocationMode\" value=\"CURRENT\">{{\n                  'LblCurrent' | translate }}</label>\n              </div>\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'LocationMode' }}</span>\n            </div>\n            <div class=\"clearfix\"></div>\n          </fieldset>\n          <!--End Home Location Configuration-->\n        </div>\n        <!--End Invoice Moment and Home Location Configuration-->\n\n        <!--Geofence and Odometer Configuration-->\n        <div class=\"row col-md-12\">\n          <!--Geofence Configuration-->\n          <fieldset class=\"col-md-6\">\n            <legend class=\"legendStyle\">\n              <span class=\"text text-danger\">*</span> {{ 'LblGeofenceLocation' | translate }}\n            </legend>\n            <div class=\"form-group col-md-12\">\n              <label>{{ 'LblGeofenceEnabled' | translate }}</label>\n              <div>\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" [(ngModel)]=\"model.isGefenceEnabled\" name=\"isGefenceEnabled\" [value]=\"true\">{{\n                  'LblYes' | translate }}</label>\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" [(ngModel)]=\"model.isGefenceEnabled\" name=\"isGefenceEnabled\" [value]=\"false\">{{\n                  'LblNo' | translate }}</label>\n              </div>\n            </div>\n            <div class=\"clearfix\"></div>\n            <template [ngIf]=\"model.isGefenceEnabled\">\n              <div class=\"form-group col-md-7\">\n                <label>{{ 'LblGeofenceLocation' | translate }}</label>\n                <div class=\"input-group\">\n                  <input class=\"form-control\" type=\"text\" name=\"address\" [(ngModel)]=\"model.geofenceAttributeModel.address\"\n                    placeholder=\"{{ 'LblGeofenceLocation' | translate }}\" readonly />\n                  <div class=\"input-group-btn\">\n                    <button class=\"btn btn-default\" type=\"button\" (click)=\"geoLocationModal.show(model.geofenceAttributeModel.address, model.geofenceAttributeModel.latitude, model.geofenceAttributeModel.longitude)\">\n                      <i class=\"fa fa-map-marker\" aria-hidden=\"true\"></i>\n                    </button>\n                    <button class=\"btn btn-default\" type=\"button\" (click)=\"ResetLocationField()\">\n                      <i class=\"fa fa-eraser\" aria-hidden=\"true\"></i>\n                    </button>\n                  </div>\n                </div>\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'Address' }}</span>\n              </div>\n              <div class=\"form-group col-md-5\">\n                <label>{{'LblRadius' | translate}} ({{'LblMeter' | translate}})</label>\n                <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblRadius' | translate }}\" [(ngModel)]=\"model.geofenceAttributeModel.radiusInMtr\"\n                  name=\"radiusInMtr\">\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'RadiusInMtr' }}</span>\n              </div>\n            </template>\n          </fieldset>\n          <!--End Geofence Configuration-->\n\n          <!--Odometer Configuration-->\n          <fieldset class=\"col-md-6\">\n            <legend class=\"legendStyle\">\n              <span class=\"text text-danger\">*</span> {{ 'LblodometerConfiguration' | translate }}\n            </legend>\n            <template [ngIf]=\"model.odometerConfigurationModel\">\n              <div>\n                <div class=\"form-group col-md-6\">\n                  <label>{{ 'LbLOdometerEnabled' | translate }}</label>\n                  <div class=\"clearfix\"></div>\n                  <label class=\"radio-inline\">\n                    <input type=\"radio\" [(ngModel)]=\"model.odometerConfigurationModel.enabled\" name=\"odometerConfigurationModelenabled\"\n                      value=\"YES\">{{ 'LblYes' | translate }}</label>\n                  <label class=\"radio-inline\">\n                    <input type=\"radio\" [(ngModel)]=\"model.odometerConfigurationModel.enabled\" name=\"odometerConfigurationModelenabled\"\n                      value=\"NO\">{{ 'LblNo' | translate }}</label>\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'Enabled' }}</span>\n                </div>\n                <div *ngIf=\"model.odometerConfigurationModel.enabled=='YES'\" class=\"form-group col-md-6\">\n                  <label>{{ 'LblEnableOnApp' | translate }}</label>\n                  <div class=\"clearfix\"></div>\n                  <label class=\"radio-inline\">\n                    <input type=\"radio\" [(ngModel)]=\"model.odometerConfigurationModel.enabledOnApp\" name=\"enabledOnApp\"\n                      [value]=\"true\">{{ 'LblYes' | translate }}</label>\n                  <label class=\"radio-inline\">\n                    <input type=\"radio\" [(ngModel)]=\"model.odometerConfigurationModel.enabledOnApp\" name=\"enabledOnApp\"\n                      [value]=\"false\">{{ 'LblNo' | translate }}</label>\n                  <div class=\"clearfix\"></div>\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'EnabledOnApp' }}</span>\n                </div>\n              </div>\n              <div *ngIf=\"model.odometerConfigurationModel.enabled=='YES' && model.odometerConfigurationModel.enabledOnApp\">\n                <div class=\"form-group col-md-4\">\n                  <label>{{'LblWarningPer' | translate}}</label>\n                  <div class=\"clearfix\"></div>\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblWarningPer' | translate }}\" [(ngModel)]=\"model.odometerConfigurationModel.warningPercentage\"\n                    name=\"warningPercentage\">\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'WarningPercentage' }}</span>\n                </div>\n                <div class=\"form-group col-md-4\">\n                  <label>{{ 'LblFrequency' | translate }} {{ 'LblInterval' | translate }}</label>\n                  <div class=\"clearfix\"></div>\n                  <template [ngIf]=\"model.odometerConfigurationModel.timeInterval == 'PERBOOKING'\">\n                    <input disabled type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblFrequency' | translate }} {{ 'LblInterval' | translate }}\"\n                      name=\"frequency\" maxlength=\"15\">\n                  </template>\n\n                  <template [ngIf]=\"model.odometerConfigurationModel.timeInterval != 'PERBOOKING'\">\n                    <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblFrequency' | translate }} {{ 'LblInterval' | translate }}\"\n                      [(ngModel)]=\"model.odometerConfigurationModel.frequency\" name=\"frequency\" maxlength=\"15\">\n                    <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'Frequency' }}</span>\n                  </template>\n                </div>\n                <div class=\"form-group col-md-4\">\n                  <label>{{ 'LblFrequency' | translate }}</label>\n                  <div class=\"clearfix\"></div>\n                  <select [(ngModel)]=\"model.odometerConfigurationModel.timeInterval\" class=\"form-control\" name=\"odometerTimeInterval\"\n                    style=\"padding: 6px 0px 6px 11px;\" (change)=\"changeOfOdometerTimeInterval()\">\n                    <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblFrequency' | translate }} </option>\n                    <option value=\"DAY\">{{ 'LblDay' | translate }}</option>\n                    <option value=\"WEEK\">{{ 'LblWeek' | translate }}</option>\n                    <option value=\"MONTH\">{{ 'LblMonth' | translate }}</option>\n                    <option value=\"PERBOOKING\">{{ 'lblPerBooking' | translate }}</option>\n                  </select>\n                  <div class=\"clearfix\"></div>\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'TimeInterval' }}</span>\n                </div>\n              </div>\n            </template>\n          </fieldset>\n          <!--End Odometer Configuration-->\n        </div>\n        <!--End Geofence and Odometer Configuration-->\n\n        <!--Booking Calender and Batch Upload Setting-->\n        <div class=\"row col-md-12\">\n          <!--Booking Calender Setting-->\n          <fieldset class=\"col-md-6\">\n            <legend class=\"legendStyle\">\n              <span class=\"text text-danger\">*</span> {{ 'LblBookingCalanderSettings' | translate }}\n            </legend>\n            <div class=\"form-group col-md-12\">\n              <label>{{ 'LblShowDriverInfo' | translate }}</label>\n              <div>\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" [(ngModel)]=\"model.enableBookingCalendarInfo\" name=\"enableBookingCalendarInfo\"\n                    [value]=\"true\">{{ 'LblYes' | translate }}</label>\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" [(ngModel)]=\"model.enableBookingCalendarInfo\" name=\"enableBookingCalendarInfo\"\n                    [value]=\"false\">{{ 'LblNo' | translate }}</label>\n              </div>\n            </div>\n            <div class=\"clearfix\"></div>\n            <template [ngIf]=\"model.enableBookingCalendarInfo\">\n              <div class=\"form-group col-md-12\">\n                <label>{{ 'LblAvailableTo' | translate }}</label>\n                <div class=\"clearfix\"></div>\n                <!-- <div class=\"checkbox\">\n                  <label>\n                    <input type=\"checkbox\" name=\"model.bookingCalendarSettingModel.companyAdmin\" [(ngModel)]=\"model.bookingCalendarSettingModel.companyAdmin\">{{ 'LblCompanyAdmin' | translate }}</label>\n                </div> -->\n                <!-- <div class=\"checkbox\">\n                  <label>\n                    <input type=\"checkbox\" name=\"model.bookingCalendarSettingModel.groupAdmin\" [(ngModel)]=\"model.bookingCalendarSettingModel.groupAdmin\">{{ 'LblSharedVehicleGroupAdmin' | translate }}</label>\n                </div> -->\n                <!-- <div  class=\"checkbox\">\n                  <label><input type=\"checkbox\" name=\"model.bookingCalendarSettingModel.organizationAdmin\" [(ngModel)]=\"model.bookingCalendarSettingModel.organizationAdmin\">{{ 'LblOrganizationAdmin' | translate }}</label>\n                </div> -->\n                <div class=\"checkbox\">\n                  <label>\n                    <input type=\"checkbox\" name=\"model.bookingCalendarSettingModel.driver\" [(ngModel)]=\"model.bookingCalendarSettingModel.driver\">{{\n                    'LblDriver' | translate }}</label>\n                </div>\n                <div class=\"clearfix\"></div>\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage :\n                  'bookingCalendarSettingModel.bookingCalendarAvailableTo' }}</span>\n              </div>\n\n              <div class=\"form-group col-md-12\">\n                <label>{{ 'LblDriverInfoToShow' | translate }}</label>\n                <div class=\"clearfix\"></div>\n                <div class=\"checkbox\">\n                  <label>\n                    <input type=\"checkbox\" name=\"model.bookingCalendarSettingModel.firstName\" [(ngModel)]=\"model.bookingCalendarSettingModel.firstName\">{{\n                    'LblFirstName' | translate }}</label>\n                </div>\n                <div class=\"checkbox\">\n                  <label>\n                    <input type=\"checkbox\" name=\"model.bookingCalendarSettingModel.lastName\" [(ngModel)]=\"model.bookingCalendarSettingModel.lastName\">{{\n                    'LblLastName' | translate }}</label>\n                </div>\n                <div class=\"checkbox\">\n                  <label>\n                    <input type=\"checkbox\" name=\"model.bookingCalendarSettingModel.mobile\" [(ngModel)]=\"model.bookingCalendarSettingModel.mobile\">{{\n                    'LblMobileNumber' | translate }}</label>\n                </div>\n                <div class=\"checkbox\">\n                  <label>\n                    <input type=\"checkbox\" name=\"model.bookingCalendarSettingModel.email\" [(ngModel)]=\"model.bookingCalendarSettingModel.email\">{{\n                    'LblEmail' | translate }}</label>\n                </div>\n                <div class=\"clearfix\"></div>\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage :\n                  'bookingCalendarSettingModel.bookingCalendarSettingModel' }}</span>\n              </div>\n            </template>\n          </fieldset>\n          <!--End Booking Calander Setting-->\n\n          <!--Batch import Configuration-->\n          <fieldset class=\"col-md-6\">\n            <legend class=\"legendStyle\">\n              {{ 'LblBatchUploadPersonSetting' | translate }}\n            </legend>\n            <div class=\"form-group col-md-6\">\n              <label>{{ 'LblShowBatchUploadInfo' | translate }}</label>\n              <div>\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" [(ngModel)]=\"model.enableBatchUploadPersonInfo\" name=\"enableBatchUploadPersonInfo\"\n                    [value]=\"true\">{{ 'LblYes' | translate }}</label>\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" [(ngModel)]=\"model.enableBatchUploadPersonInfo\" name=\"enableBatchUploadPersonInfo\"\n                    [value]=\"false\">{{ 'LblNo' | translate }}</label>\n              </div>\n            </div>\n            <div class=\"clearfix\"></div>\n            <template [ngIf]=\"model.enableBatchUploadPersonInfo\">\n              <!-- <div class=\"form-group col-md-12\">\n                <div class=\"col-md-12 nopadding\">\n                  <label>{{ 'LblAllowBatchUpload' | translate }}</label>\n                </div>\n                <div class=\"clearfix\"></div>\n                <div class=\"col-md-5 nopadding\">\n                  {{ 'LblCompanyAdmin' | translate }}\n                </div>\n                <div class=\"col-md-7\">\n                  <label class=\"radio-inline\">\n                    <input type=\"radio\" [(ngModel)]=\"model.batchUploadPersonConfigurationModel.companyAdmin\" name=\"batchUploadPersonConfigurationModelCompanyAdmin\"\n                      [value]=\"true\">{{ 'LblYes' | translate }}</label>\n                  <label class=\"radio-inline\">\n                    <input type=\"radio\" [(ngModel)]=\"model.batchUploadPersonConfigurationModel.companyAdmin\" name=\"batchUploadPersonConfigurationModelCompanyAdmin\"\n                      [value]=\"false\">{{ 'LblNo' | translate }}</label>\n                </div>\n                <div class=\"clearfix\"></div>\n                <div class=\"col-md-5 nopadding\">\n                  {{ 'LblSharedVehicleGroupAdmin' | translate }}\n                </div>\n                <div class=\"col-md-7\">\n                  <label class=\"radio-inline\">\n                    <input type=\"radio\" [(ngModel)]=\"model.batchUploadPersonConfigurationModel.groupAdmin\" name=\"batchUploadPersonConfigurationModelGroupAdmin\"\n                      [value]=\"true\">{{ 'LblYes' | translate }}</label>\n                  <label class=\"radio-inline\">\n                    <input type=\"radio\" [(ngModel)]=\"model.batchUploadPersonConfigurationModel.groupAdmin\" name=\"batchUploadPersonConfigurationModelGroupAdmin\"\n                      [value]=\"false\">{{ 'LblNo' | translate }}</label>\n                </div>\n                <div class=\"clearfix\"></div>\n                <div class=\"col-md-5 nopadding\">\n                  {{ 'LblOrganizationAdmin' | translate }}\n                </div>\n                <div class=\"col-md-7\">\n                  <label class=\"radio-inline\">\n                    <input type=\"radio\" [(ngModel)]=\"model.batchUploadPersonConfigurationModel.organizationAdmin\" name=\"batchUploadPersonConfigurationModelOrganizationAdmin\"\n                      [value]=\"true\">{{ 'LblYes' | translate }}</label>\n                  <label class=\"radio-inline\">\n                    <input type=\"radio\" [(ngModel)]=\"model.batchUploadPersonConfigurationModel.organizationAdmin\" name=\"batchUploadPersonConfigurationModelOrganizationAdmin\"\n                      [value]=\"false\">{{ 'LblNo' | translate }}</label>\n                </div>\n              </div> -->\n              <div class=\"form-group col-md-4\">\n                <label>{{ 'LblAllowActivationMail' | translate }}</label>\n                <div class=\"form-group\">\n                  <label class=\"radio-inline\">\n                    <input type=\"radio\" [disabled]=\"model.validateLiceanceNumber\" [(ngModel)]=\"model.batchUploadPersonConfigurationModel.sendActivationMail\"\n                      name=\"batchUploadPersonConfigurationModelSendActivationMail1\" [value]=\"true\" (change)=\"BatchUploadSendActivationMail();\">{{\n                    'LblYes' | translate }}</label>\n                  <label class=\"radio-inline\">\n                    <input type=\"radio\" [disabled]=\"model.validateLiceanceNumber\" [(ngModel)]=\"model.batchUploadPersonConfigurationModel.sendActivationMail\"\n                      name=\"batchUploadPersonConfigurationModelSendActivationMail2\" [value]=\"false\" (change)=\"BatchUploadSendActivationMail();\">{{\n                    'LblNo' | translate }}</label>\n                </div>\n                <div>\n                  <div>\n                    <label class=\"radio-inline\">\n                      <input [disabled]=\"model.batchUploadPersonConfigurationModel.sendActivationMail\" type=\"radio\"\n                        [(ngModel)]=\"model.batchUploadPersonConfigurationModel.generateRandom_UseUploadedPassword\" name=\"batchUploadPersonConfigurationModelPasswordGeneration1\"\n                        (change)=\"model.batchUploadPersonConfigurationModel.fieldPassword = false;\" [value]=\"true\">{{\n                      'LblGenerateRandomPassword' | translate }}</label>\n                  </div>\n                  <div>\n                    <label class=\"radio-inline\">\n                      <input [disabled]=\"model.batchUploadPersonConfigurationModel.sendActivationMail\" type=\"radio\"\n                        [(ngModel)]=\"model.batchUploadPersonConfigurationModel.generateRandom_UseUploadedPassword\" name=\"batchUploadPersonConfigurationModelPasswordGeneration2\"\n                        (change)=\"model.batchUploadPersonConfigurationModel.fieldPassword = $event.target.checked;\"\n                        [value]=\"false\">{{ 'LblUserUploadPassword' | translate }}</label>\n                  </div>\n                </div>\n              </div>\n              <div class=\"form-group col-md-8\">\n                <div class=\"row\">\n                  <div class=\"col-md-12\">\n                    <label>{{ 'LblFieldToUploadedOrValidated' | translate }}</label>\n                  </div>\n                  <div class=\"col-md-6\">\n                    <div class=\"checkbox\">\n                      <label>\n                        <input disabled type=\"checkbox\" checked=\"checked\">{{ 'LblUserName' | translate }}</label>\n                    </div>\n                    <div class=\"checkbox\">\n                      <label>\n                        <input disabled type=\"checkbox\" checked=\"checked\">{{ 'LblEmail' | translate }}</label>\n                    </div>\n                    <div class=\"checkbox\">\n                      <label>\n                        <input disabled type=\"checkbox\" name=\"model.batchUploadPersonConfigurationModel.fieldPassword\"\n                          [(ngModel)]=\"model.batchUploadPersonConfigurationModel.fieldPassword\">{{ 'LblPassword' |\n                        translate }}</label>\n                    </div>\n                    <div class=\"checkbox\">\n                      <label>\n                        <input type=\"checkbox\" name=\"model.batchUploadPersonConfigurationModel.fieldFirstName\" [(ngModel)]=\"model.batchUploadPersonConfigurationModel.fieldFirstName\">{{\n                        'LblFirstName' | translate }}</label>\n                    </div>\n                    <div class=\"checkbox\">\n                      <label>\n                        <input type=\"checkbox\" name=\"model.batchUploadPersonConfigurationModel.fieldMiddleName\" [(ngModel)]=\"model.batchUploadPersonConfigurationModel.fieldMiddleName\">{{\n                        'LblMiddleName' | translate }}</label>\n                    </div>\n                    <div class=\"checkbox\">\n                      <label>\n                        <input type=\"checkbox\" name=\"model.batchUploadPersonConfigurationModel.fieldLastName\" [(ngModel)]=\"model.batchUploadPersonConfigurationModel.fieldLastName\">{{\n                        'LblLastName' | translate }}</label>\n                    </div>\n                    <div class=\"checkbox\">\n                      <label>\n                        <input type=\"checkbox\" name=\"model.batchUploadPersonConfigurationModel.fieldMobileNumber\"\n                          [(ngModel)]=\"model.batchUploadPersonConfigurationModel.fieldMobileNumber\">{{ 'LblMobileNumber' |\n                        translate }}</label>\n                    </div>\n                    <div class=\"checkbox\">\n                      <label>\n                        <input type=\"checkbox\" name=\"model.batchUploadPersonConfigurationModel.fieldPhoneNumber\"\n                          [(ngModel)]=\"model.batchUploadPersonConfigurationModel.fieldPhoneNumber\">{{ 'LblPhoneNumber' |\n                        translate }}</label>\n                    </div>\n                    <div class=\"checkbox\">\n                      <label>\n                        <input type=\"checkbox\" name=\"model.batchUploadPersonConfigurationModel.fieldHomeAddress\"\n                          [(ngModel)]=\"model.batchUploadPersonConfigurationModel.fieldHomeAddress\">{{ 'LblHomeAddress' |\n                        translate }}</label>\n                    </div>\n                    <div class=\"checkbox\">\n                      <label>\n                        <input type=\"checkbox\" name=\"model.batchUploadPersonConfigurationModel.fieldCountryCode\"\n                          [(ngModel)]=\"model.batchUploadPersonConfigurationModel.fieldCountryCode\">{{ 'LblCountry' |\n                        translate }}</label>\n                    </div>\n                  </div>\n\n                  <div class=\"col-md-6\">\n                    <div class=\"checkbox\">\n                      <label>\n                        <input type=\"checkbox\" name=\"model.batchUploadPersonConfigurationModel.fieldRfidTagId\"\n                              [(ngModel)]=\"model.batchUploadPersonConfigurationModel.fieldRfidTagId\">{{ 'LblRfidTagId' |\n                              translate }}</label>\n                    </div>\n                    <div class=\"checkbox\">\n                      <label>\n                        <input type=\"checkbox\" name=\"model.batchUploadPersonConfigurationModel.fieldLicenseTypes\"\n                              [(ngModel)]=\"model.batchUploadPersonConfigurationModel.fieldLicenseTypes\">{{ 'LblLicense' | translate }}</label>\n                    </div>\n                    <div class=\"checkbox\">\n                      <label>\n                        <input type=\"checkbox\" name=\"model.batchUploadPersonConfigurationModel.fieldCertificates\"\n                              [(ngModel)]=\"model.batchUploadPersonConfigurationModel.fieldCertificates\">{{ 'LblCertificates' | translate }}</label>\n                    </div>\n                    <div class=\"checkbox\">\n                      <label>\n                        <input type=\"checkbox\" name=\"model.batchUploadPersonConfigurationModel.fieldEmployeeNumber\"\n                              [(ngModel)]=\"model.batchUploadPersonConfigurationModel.fieldEmployeeNumber\">{{ 'LblEmployeeNumber' |\n                              translate }}</label>\n                    </div>                \n                    <div class=\"checkbox\">\n                      <label>\n                        <input type=\"checkbox\" name=\"model.batchUploadPersonConfigurationModel.fieldAccessCardId\"\n                              [(ngModel)]=\"model.batchUploadPersonConfigurationModel.fieldAccessCardId\">{{ 'LblAccessCardId' |\n                              translate }}</label>\n                    </div>\n                    <div class=\"checkbox\">\n                      <label>\n                        <input type=\"checkbox\" name=\"model.batchUploadPersonConfigurationModel.fieldIBANNumber\"\n                              [(ngModel)]=\"model.batchUploadPersonConfigurationModel.fieldIBANNumber\">{{ 'LblIBANNumber' |\n                              translate }}</label>\n                    </div>\n                    <div class=\"checkbox\">\n                      <label>\n                        <input type=\"checkbox\" name=\"model.batchUploadPersonConfigurationModel.fieldBICCode\"\n                              [(ngModel)]=\"model.batchUploadPersonConfigurationModel.fieldBICCode\">{{ 'LblBICCode' |\n                              translate }}</label>\n                    </div>\n                    <div class=\"checkbox\">\n                      <label>\n                        <input type=\"checkbox\" name=\"model.batchUploadPersonConfigurationModel.fieldMandateId\"\n                              [(ngModel)]=\"model.batchUploadPersonConfigurationModel.fieldMandateId\">{{ 'LblMandateId' |\n                              translate }}</label>\n                    </div>\n                    <div class=\"checkbox\">\n                      <label>\n                        <input type=\"checkbox\" name=\"model.batchUploadPersonConfigurationModel.fieldMandateSignatureDate\"\n                              [(ngModel)]=\"model.batchUploadPersonConfigurationModel.fieldMandateSignatureDate\">{{ 'LblMandateSignatureDate' |\n                              translate }}</label>\n                    </div>\n                    <div class=\"checkbox\">\n                      <label>\n                        <input type=\"checkbox\" name=\"model.batchUploadPersonConfigurationModel.fieldIsAmmandment\"\n                              [(ngModel)]=\"model.batchUploadPersonConfigurationModel.fieldIsAmmandment\">{{ 'LblIsAmmandment' |\n                              translate }}</label>\n                    </div>\n    \n                    <!-- <div class=\"checkbox\">\n                      <label>\n                        <input type=\"checkbox\" name=\"model.batchUploadPersonConfigurationModel.fieldWorkAddress\" [(ngModel)]=\"model.batchUploadPersonConfigurationModel.fieldWorkAddress\">{{ 'LblWorkAddress' | translate }}</label>\n                    </div> -->                  \n                  </div>\n                </div>\n              </div>\n            </template>\n          </fieldset>\n          <!--End Batch import Configuration-->\n        </div>\n        <!--End Booking Calander and Batch Upload Setting-->\n\n\n        <div class=\"row col-md-12\">\n          <!--Direct Debit Configuration-->\n          <fieldset class=\"col-md-6\">\n            <legend class=\"legendStyle\">\n              {{ 'LblDirectDebitConfiguration' | translate }}\n            </legend>\n            <template [ngIf]=\"model.directDebitfileConfigModel\">\n              <div>\n                <div class=\"form-group col-md-6\">\n                  <label>{{ 'LbLDirectDebitEnabled' | translate }}</label>\n                  <div class=\"clearfix\"></div>\n                  <label class=\"radio-inline\">\n                    <input type=\"radio\" [(ngModel)]=\"model.directDebitfileConfigModel.enableFileGeneration\" name=\"directDebitfileConfigModelenabled\"\n                      [value]=\"true\">{{ 'LblYes' | translate }}</label>\n                  <label class=\"radio-inline\">\n                    <input type=\"radio\" [(ngModel)]=\"model.directDebitfileConfigModel.enableFileGeneration\" name=\"directDebitfileConfigModelenabled\"\n                      [value]=\"false\">{{ 'LblNo' | translate }}</label>\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'enableFileGeneration' }}</span>\n                </div>\n                <div *ngIf=\"model.directDebitfileConfigModel.enableFileGeneration\" class=\"form-group col-md-6\">\n                  <label>{{ 'LblDirectDebitEnableper' | translate }}</label>\n                  <div class=\"clearfix\"></div>\n                  <label class=\"radio-inline\">\n                    <input type=\"radio\" [(ngModel)]=\"model.directDebitfileConfigModel.fileLevel\" name=\"fileLevel\" value=\"INSTANCE\">{{\n                    'LblInstance' | translate }}</label>\n                  <label class=\"radio-inline\">\n                    <input type=\"radio\" [(ngModel)]=\"model.directDebitfileConfigModel.fileLevel\" name=\"fileLevel\" value=\"COMPANY\">{{\n                    'LblCompany' | translate }}</label>\n                  <div class=\"clearfix\"></div>\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'fileLevel' }}</span>\n                </div>\n              </div>\n              <div *ngIf=\"model.directDebitfileConfigModel.enableFileGeneration\">\n                <div class=\"col-md-12\">\n                  <h4>\n                    <span *ngIf=\"model.directDebitfileConfigModel.fileLevel=='INSTANCE'\" class=\"text text-danger\">*</span>\n                    <label>{{ 'LbLCreditorDetails' | translate }}</label>\n                  </h4>\n                </div>\n                <div class=\"form-group col-md-6\">\n                  <label>{{ 'LblCompanyName' | translate }}</label>\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblCompanyName' | translate }}\" [(ngModel)]=\"model.directDebitfileConfigModel.companyName\"\n                    name=\"companyName\" maxlength=\"100\">\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'companyName' }}</span>\n                </div>\n                <div class=\"form-group col-md-6\">\n                  <label>{{ 'LblAddress' | translate }}</label>\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblAddress' | translate }}\" [(ngModel)]=\"model.directDebitfileConfigModel.address\"\n                    name=\"address\" maxlength=\"200\">\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'address' }}</span>\n                </div>\n                <div class=\"form-group col-md-6\">\n                  <label>{{ 'LblIBANNumber' | translate }}</label>\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblIBANNumber' | translate }}\" [(ngModel)]=\"model.directDebitfileConfigModel.ibanNumber\"\n                    name=\"ibanNumber\" maxlength=\"100\">\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'iBANNumber' }}</span>\n                </div>\n\n                <div class=\"form-group col-md-6\">\n                  <label>{{ 'LblBICCode' | translate }}</label>\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblBICCode' | translate }}\" [(ngModel)]=\"model.directDebitfileConfigModel.bicCode\"\n                    name=\"bicCode\" maxlength=\"100\">\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'bicCode' }}</span>\n                </div>\n                <div class=\"clearfix\"></div>\n\n                <div class=\"form-group col-md-6\">\n                  <label>{{ 'LblCountryCode' | translate }}</label>\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblCountryCode' | translate }}\" [(ngModel)]=\"model.directDebitfileConfigModel.countryCode\"\n                    name=\"address\" maxlength=\"50\">\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'countryCode' }}</span>\n                </div>\n                <div class=\"clearfix\"></div>\n              </div>\n            </template>\n          </fieldset>\n          <!--End Direct Debit Configuration-->\n\n          <!--Dashboard Configuration-->\n          <fieldset class=\"col-md-6\">\n            <legend class=\"legendStyle\">\n              <span class=\"text text-danger\">*</span> {{ 'LblDashboardConfiguration' | translate }}\n            </legend>\n            <div>\n              <div class=\"form-group col-md-6\">\n                <label>{{ 'LblEnableCurrentLocation' | translate }}</label>\n                <div class=\"clearfix\"></div>\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" [(ngModel)]=\"model.dashboardConfigModel.enableCurrentLocation\" name=\"dashboardConfigModel.enableCurrentLocation\"\n                    [value]=\"true\" (change)=\"DashboardEnableCurrentLocationChange()\">{{ 'LblYes' | translate }}</label>\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" [(ngModel)]=\"model.dashboardConfigModel.enableCurrentLocation\" name=\"dashboardConfigModel.enableCurrentLocation\"\n                    [value]=\"false\" (change)=\"DashboardEnableCurrentLocationChange()\">{{ 'LblNo' | translate }}</label>\n              </div>\n              <div class=\"form-group col-md-6\">\n                <label>{{ 'LblDefaultStatus' | translate }}</label>\n                <select class=\"form-control\" [(ngModel)]=\"model.dashboardConfigModel.defaultStatus\" name=\"dashboardConfigModel.defaultStatus\">\n                  <option value=\"ALL\">{{ 'LblAll' | translate }}</option>\n                  <option value=\"AVAILABLE\">{{ 'LblAvailable' | translate }}</option>\n                  <option value=\"UNAVAILABLE\">{{ 'LblUnAvailable' | translate }}</option>\n                  <option value=\"INUSE\">{{ 'LblInuse' | translate }}</option>\n                  <option value=\"PRIORITY1\">{{ 'LblPriority' | translate }} 1</option>\n                  <option value=\"PRIORITY2\">{{ 'LblPriority' | translate }} 2</option>\n                </select>\n              </div>\n              <div *ngIf=\"model.dashboardConfigModel.enableCurrentLocation\">\n                <div class=\"form-group col-md-6\">\n                  <label>{{ 'LblEnableAutoUpdate' | translate }}</label>\n                  <div class=\"clearfix\"></div>\n                  <label class=\"radio-inline\">\n                    <input type=\"radio\" [(ngModel)]=\"model.dashboardConfigModel.enableAutoUpdate\" name=\"dashboardConfigModel.enableAutoUpdate\"\n                      [value]=\"true\" (change)=\"DashboardEnableAutoUpdateChange()\">{{ 'LblYes' | translate }}</label>\n                  <label class=\"radio-inline\">\n                    <input type=\"radio\" [(ngModel)]=\"model.dashboardConfigModel.enableAutoUpdate\" name=\"dashboardConfigModel.enableAutoUpdate\"\n                      [value]=\"false\" (change)=\"DashboardEnableAutoUpdateChange()\">{{ 'LblNo' | translate }}</label>\n                </div>\n                <div class=\"form-group col-md-6\">\n                  <label>{{ 'LblDefaultLocation' | translate }}</label>\n                  <div class=\"clearfix\"></div>\n                  <label class=\"radio-inline\">\n                    <input type=\"radio\" [(ngModel)]=\"model.dashboardConfigModel.defaultLocation\" name=\"dashboardConfigModel.defaultLocation\"\n                      value=\"HOME\"> {{ 'LblHome' | translate }}</label>\n                  <label class=\"radio-inline\">\n                    <input type=\"radio\" [(ngModel)]=\"model.dashboardConfigModel.defaultLocation\" name=\"dashboardConfigModel.defaultLocation\"\n                      value=\"CURRENT\">{{ 'LblCurrent' | translate }}</label>\n                </div>\n                <div *ngIf=\"model.dashboardConfigModel.enableAutoUpdate\" class=\"form-group col-md-6\">\n                  <label>{{ 'LblTimeInterval' | translate }} ({{ 'LblSecond' | translate }})</label>\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblTimeInterval' | translate }} ({{ 'LblSecond' | translate }})\"\n                    [(ngModel)]=\"model.dashboardConfigModel.updateIntervalInSecond\" name=\"dashboardConfigModel.updateIntervalInSecond\">\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'UpdateIntervalInSecond' }}</span>\n                </div>\n              </div>\n            </div>\n          </fieldset>\n          <!--End Dashboard Configuration-->\n        </div>\n\n        <!--Vehicle Priority and Email Configuration-->\n        <div class=\"row col-md-12\">\n          <fieldset class=\"col-md-12\">\n            <legend class=\"legendStyle\">\n              {{ 'LblPriorityNotificationSetting' | translate }}\n            </legend>\n            <div class=\"table table-responsive\">\n              <table class=\"table table-bordered mar_bot_ziro\">\n                <thead>\n                  <tr>\n                    <th style=\"width:460px\">{{ 'LblNotification' | translate }}</th>\n                    <th class=\"text-center\" style=\"width: 150px;\">{{ 'LblPriority' | translate }}</th>\n                  </tr>\n                </thead>\n                <tbody>\n                  <!--DamageReported-->\n                  <tr>\n                    <td>{{ 'LblTypeDamage' | translate }}</td>\n                    <td class=\"text-center\">\n                      <label class=\"radio-inline\">\n                        <input type=\"radio\" [(ngModel)]=\"model.reportDamageNotificationModel.priority\" name=\"model.reportDamageNotificationModel.priority1\"\n                          value=\"PRIORITY1\"> 1 </label>\n                      <label class=\"radio-inline\">\n                        <input type=\"radio\" [(ngModel)]=\"model.reportDamageNotificationModel.priority\" name=\"model.reportDamageNotificationModel.priority2\"\n                          value=\"PRIORITY2\"> 2 </label>\n                      <label class=\"radio-inline\">\n                        <input type=\"radio\" [(ngModel)]=\"model.reportDamageNotificationModel.priority\" name=\"model.reportDamageNotificationModel.priorityNA\"\n                          value=\"NA\" (change)=\"UpdatePriorityNA('DamageReported')\"> {{ 'LblNA' | translate }} </label>\n                    </td>\n                  </tr>\n                  <!--APKMaintenance-->\n                  <tr>\n                    <td>{{ 'LblTypeMaintenance' | translate }}</td>\n                    <td class=\"text-center\">\n                      <label class=\"radio-inline\">\n                        <input type=\"radio\" [(ngModel)]=\"model.apkMaintenanceNotificationModel.priority\" name=\"model.apkMaintenanceNotificationModel.priority1\"\n                          value=\"PRIORITY1\"> 1 </label>\n                      <label class=\"radio-inline\">\n                        <input type=\"radio\" [(ngModel)]=\"model.apkMaintenanceNotificationModel.priority\" name=\"model.apkMaintenanceNotificationModel.priority2\"\n                          value=\"PRIORITY2\"> 2 </label>\n                      <label class=\"radio-inline\">\n                        <input type=\"radio\" [(ngModel)]=\"model.apkMaintenanceNotificationModel.priority\" name=\"model.apkMaintenanceNotificationModel.priorityNA\"\n                          value=\"NA\" (change)=\"UpdatePriorityNA('APKMaintananceScheduled')\"> {{ 'LblNA' | translate }}\n                      </label>\n                    </td>\n                    <!-- <td class=\"text-center\" colspan=\"7\">  \n                      {{ 'LblInstanceNotificationNote1' | translate }}\n                    </td> -->\n\n                  </tr>\n                  <!--OutSideGeofence-->\n                  <tr>\n                    <td>{{ 'LblOutsideGeofence' | translate }}</td>\n                    <td class=\"text-center\">\n                      <label class=\"radio-inline\">\n                        <input type=\"radio\" [(ngModel)]=\"model.geofenceNotificationModel.priority\" name=\"model.geofenceNotificationModel.priority1\"\n                          value=\"PRIORITY1\" [disabled]=\"isGeofenceNotificationDisable\"> 1 </label>\n                      <label class=\"radio-inline\">\n                        <input type=\"radio\" [(ngModel)]=\"model.geofenceNotificationModel.priority\" name=\"model.geofenceNotificationModel.priority2\"\n                          value=\"PRIORITY2\" [disabled]=\"isGeofenceNotificationDisable\"> 2 </label>\n                      <label class=\"radio-inline\">\n                        <input type=\"radio\" [(ngModel)]=\"model.geofenceNotificationModel.priority\" name=\"model.geofenceNotificationModel.priorityNA\"\n                          value=\"NA\" [disabled]=\"isGeofenceNotificationDisable\"> {{ 'LblNA' | translate }} </label>\n                    </td>\n\n                  </tr>\n                  <!--OnSamePosition-->\n                  <tr>\n                    <td>\n                      <div style=\"padding-left: 0px;\">\n                        {{ 'LblVehicleOnSameLocationTime' | translate }}\n                        <!-- {{ 'LblTypeOnSamePosition' | translate:\"X\" }} -->\n                        <template [ngIf]=\"model.vehicleSameLocationNotificationModel.priority != 'NA'\">\n                          <div class=\"form-group inline\" [ngClass]=\"{'has-error': HasModelError('vehicleAtSameLocationTime')}\">\n                            <input name=\"model.vehicleAtSameLocationTime\" [(ngModel)]=\"model.vehicleAtSameLocationTime\"\n                              class=\"form-control inline input-sm\" maxlength=\"5\" (keypress)=\"onlyNumberKey($event)\"\n                              type=\"text\" style=\"width: 55px;\">\n                          </div>\n                          <div class=\"form-group inline\" [ngClass]=\"{'has-error': HasModelError('vehicleAtSameLocationTimeInterval')}\">\n                            <select class=\"form-control inline input-sm text-transform-uppercase\" style=\"width: 90px;\"\n                              name=\"model.vehicleAtSameLocationTimeInterval\" [(ngModel)]=\"model.vehicleAtSameLocationTimeInterval\">\n                              <option value=\"\" selected>{{'LblSelect' | translate}}</option>\n                              <option value=\"HOUR\">{{'lblHour' | translate}}</option>\n                              <option value=\"DAY\">{{'LblDay' | translate}}</option>\n                              <option value=\"WEEK\">{{'LblWeek' | translate}}</option>\n                              <option value=\"MONTH\">{{'LblMonth' | translate}}</option>\n                            </select>\n                          </div>\n                        </template>\n\n                        <template [ngIf]=\"model.vehicleSameLocationNotificationModel.priority == 'NA'\">\n                          <div class=\"form-group inline\">\n                            <input class=\"form-control inline input-sm\" type=\"text\" style=\"width: 55px;\" disabled>\n                          </div>\n                          <div class=\"form-group inline\">\n                            <select class=\"form-control inline input-sm text-transform-uppercase\" style=\"width: 90px;\"\n                              name=\"model.vehicleAtSameLocationTimeInterval\" [(ngModel)]=\"model.vehicleAtSameLocationTimeInterval\"\n                              disabled>\n                              <option value=\"\" selected>{{'LblSelect' | translate}}</option>\n                            </select>\n                          </div>\n                        </template>\n                      </div>\n                    </td>\n                    <td class=\"text-center\">\n                      <label class=\"radio-inline\">\n                        <input type=\"radio\" [(ngModel)]=\"model.vehicleSameLocationNotificationModel.priority\" name=\"model.vehicleSameLocationNotificationModel.priority1\"\n                          value=\"PRIORITY1\"> 1 </label>\n                      <label class=\"radio-inline\">\n                        <input type=\"radio\" [(ngModel)]=\"model.vehicleSameLocationNotificationModel.priority\" name=\"model.vehicleSameLocationNotificationModel.priority2\"\n                          value=\"PRIORITY2\"> 2 </label>\n                      <label class=\"radio-inline\">\n                        <input type=\"radio\" [(ngModel)]=\"model.vehicleSameLocationNotificationModel.priority\" name=\"model.vehicleSameLocationNotificationModel.priorityNA\"\n                          value=\"NA\" (change)=\"UpdatePriorityNA('VehicleSamePosition')\"> {{ 'LblNA' | translate }}\n                      </label>\n                    </td>\n\n                  </tr>\n\n                  <!-- <tr>\n                    <td>{{ 'LblTypeOnSamePosition' | translate:\"X\" }}</td>\n                    \n                  </tr> -->\n                  <!--NotReturn-->\n                  <tr>\n                    <td>{{ 'LblTypeNotReturn' | translate }}</td>\n                    <td class=\"text-center\">\n                      <label class=\"radio-inline\">\n                        <input type=\"radio\" [(ngModel)]=\"model.vehicleNotReturnNotificationModel.priority\" name=\"model.vehicleNotReturnNotificationModel.priority1\"\n                          value=\"PRIORITY1\" [disabled]=\"isReturnToHomeNotificationDisable\"> 1 </label>\n                      <label class=\"radio-inline\">\n                        <input type=\"radio\" [(ngModel)]=\"model.vehicleNotReturnNotificationModel.priority\" name=\"model.vehicleNotReturnNotificationModel.priority2\"\n                          value=\"PRIORITY2\" [disabled]=\"isReturnToHomeNotificationDisable\"> 2 </label>\n                      <label class=\"radio-inline\">\n                        <input type=\"radio\" [(ngModel)]=\"model.vehicleNotReturnNotificationModel.priority\" name=\"model.vehicleNotReturnNotificationModel.priorityNA\"\n                          value=\"NA\" [disabled]=\"isReturnToHomeNotificationDisable\" (change)=\"UpdatePriorityNA('VehicleNotReturn')\">\n                        {{ 'LblNA' | translate }} </label>\n                    </td>\n\n                  </tr>\n                  <!--NotBooked-->\n                  <tr>\n                    <td>\n                      <div style=\"padding-left: 0px;\">\n                        <!-- {{ 'LblTypeNotBooked' | translate: \"X\" }} -->\n                        {{ 'LblNoBookingIn' | translate }}\n                        <template [ngIf]=\"model.vehicleNotBookedNotificationModel.priority != 'NA'\">\n                          <div class=\"form-group inline\" [ngClass]=\"{'has-error': HasModelError('noBookingInTime')}\">\n                            <input class=\"form-control inline input-sm\" type=\"text\" style=\"margin-left: 35px;width: 55px;\"\n                              name=\"model.noBookingInTime\" maxlength=\"5\" (keypress)=\"onlyNumberKey($event)\" [(ngModel)]=\"model.noBookingInTime\">\n                          </div>\n                          <div class=\"form-group inline\" [ngClass]=\"{'has-error': HasModelError('noBookingInTimeInterval')}\">\n                            <select name=\"model.noBookingInTimeInterval\" [(ngModel)]=\"model.noBookingInTimeInterval\"\n                              class=\"form-control inline input-sm text-transform-uppercase\" style=\"width: 90px;\">\n                              <option value=\"\" selected>{{'LblSelect' | translate}}</option>\n                              <option value=\"HOUR\">{{'lblHour' | translate}}</option>\n                              <option value=\"DAY\">{{'LblDay' | translate}}</option>\n                              <option value=\"WEEK\">{{'LblWeek' | translate}}</option>\n                              <option value=\"MONTH\">{{'LblMonth' | translate}}</option>\n                            </select>\n                          </div>\n                        </template>\n\n                        <template [ngIf]=\"model.vehicleNotBookedNotificationModel.priority == 'NA'\">\n                          <div class=\"form-group inline\">\n                            <input class=\"form-control inline input-sm\" type=\"text\" style=\"margin-left: 35px;width: 55px;\"\n                              disabled>\n                          </div>\n                          <div class=\"form-group inline\">\n                            <select name=\"model.noBookingInTimeInterval\" [(ngModel)]=\"model.noBookingInTimeInterval\"\n                              class=\"form-control inline input-sm text-transform-uppercase\" style=\"width: 90px;\"\n                              disabled>\n                              <option value=\"\" selected>{{'LblSelect' | translate}}</option>\n                            </select>\n                          </div>\n                        </template>\n                      </div>\n                    </td>\n                    <td class=\"text-center\">\n                      <label class=\"radio-inline\">\n                        <input type=\"radio\" [(ngModel)]=\"model.vehicleNotBookedNotificationModel.priority\" name=\"model.vehicleNotBookedNotificationModel.priority1\"\n                          value=\"PRIORITY1\"> 1 </label>\n                      <label class=\"radio-inline\">\n                        <input type=\"radio\" [(ngModel)]=\"model.vehicleNotBookedNotificationModel.priority\" name=\"model.vehicleNotBookedNotificationModel.priority2\"\n                          value=\"PRIORITY2\"> 2 </label>\n                      <label class=\"radio-inline\">\n                        <input type=\"radio\" [(ngModel)]=\"model.vehicleNotBookedNotificationModel.priority\" name=\"model.vehicleNotBookedNotificationModel.priorityNA\"\n                          value=\"NA\" (change)=\"UpdatePriorityNA('VehicleNotBooked')\"> {{ 'LblNA' | translate }} </label>\n                    </td>\n\n                  </tr>\n\n                  <!-- <tr>\n                    <td>{{ 'LblTypeNotBooked' | translate: \"X\" }}</td>\n                  </tr> -->\n                  <!--Cleaning-->\n                  <tr>\n                    <td>{{ 'LblCleaning' | translate }}</td>\n                    <td class=\"text-center\">\n                      <label class=\"radio-inline\">\n                        <input type=\"radio\" [(ngModel)]=\"model.cleaningRequiredNotificationModel.priority\" name=\"model.cleaningRequiredNotificationModel.priority1\"\n                          value=\"PRIORITY1\"> 1 </label>\n                      <label class=\"radio-inline\">\n                        <input type=\"radio\" [(ngModel)]=\"model.cleaningRequiredNotificationModel.priority\" name=\"model.cleaningRequiredNotificationModel.priority2\"\n                          value=\"PRIORITY2\"> 2 </label>\n                      <label class=\"radio-inline\">\n                        <input type=\"radio\" [(ngModel)]=\"model.cleaningRequiredNotificationModel.priority\" name=\"model.cleaningRequiredNotificationModel.priorityNA\"\n                          value=\"NA\" (change)=\"UpdatePriorityNA('CleaningRequired')\"> {{ 'LblNA' | translate }} </label>\n                    </td>\n\n                  </tr>\n                  <!--Refueling-->\n                  <tr>\n                    <td>{{ 'LblRefueling' | translate }}</td>\n                    <td class=\"text-center\">\n                      <label class=\"radio-inline\">\n                        <input type=\"radio\" [(ngModel)]=\"model.refuelingRequiredNotificationModel.priority\" name=\"model.refuelingRequiredNotificationModel.priority1\"\n                          value=\"PRIORITY1\"> 1 </label>\n                      <label class=\"radio-inline\">\n                        <input type=\"radio\" [(ngModel)]=\"model.refuelingRequiredNotificationModel.priority\" name=\"model.refuelingRequiredNotificationModel.priority2\"\n                          value=\"PRIORITY2\"> 2 </label>\n                      <label class=\"radio-inline\">\n                        <input type=\"radio\" [(ngModel)]=\"model.refuelingRequiredNotificationModel.priority\" name=\"model.refuelingRequiredNotificationModel.priorityNA\"\n                          value=\"NA\" (change)=\"UpdatePriorityNA('RefuelingRequired')\"> {{ 'LblNA' | translate }}\n                      </label>\n                    </td>\n\n                  </tr>\n                  <!--LowBattery-->\n                  <tr>\n                    <td>{{ 'LblLowBattery' | translate }}</td>\n                    <td class=\"text-center\">\n                      <label class=\"radio-inline\">\n                        <input type=\"radio\" [(ngModel)]=\"model.lowBatteryNotificationModel.priority\" name=\"model.lowBatteryNotificationModel.priority1\"\n                          value=\"PRIORITY1\"> 1 </label>\n                      <label class=\"radio-inline\">\n                        <input type=\"radio\" [(ngModel)]=\"model.lowBatteryNotificationModel.priority\" name=\"model.lowBatteryNotificationModel.priority2\"\n                          value=\"PRIORITY2\"> 2 </label>\n                      <label class=\"radio-inline\">\n                        <input type=\"radio\" [(ngModel)]=\"model.lowBatteryNotificationModel.priority\" name=\"model.lowBatteryNotificationModel.priorityNA\"\n                          value=\"NA\" (change)=\"UpdatePriorityNA('LowBattery')\"> {{ 'LblNA' | translate }} </label>\n                    </td>\n\n                  </tr>\n                  <!--LowCharge-->\n                  <tr>\n                    <td>{{ 'LblLowCharge' | translate }}</td>\n                    <td class=\"text-center\">\n                      <label class=\"radio-inline\">\n                        <input type=\"radio\" [(ngModel)]=\"model.lowChargeNotificationModel.priority\" name=\"model.lowChargeNotificationModel.priority1\"\n                          value=\"PRIORITY1\"> 1 </label>\n                      <label class=\"radio-inline\">\n                        <input type=\"radio\" [(ngModel)]=\"model.lowChargeNotificationModel.priority\" name=\"model.lowChargeNotificationModel.priority2\"\n                          value=\"PRIORITY2\"> 2 </label>\n                      <label class=\"radio-inline\">\n                        <input type=\"radio\" [(ngModel)]=\"model.lowChargeNotificationModel.priority\" name=\"model.lowChargeNotificationModel.priorityNA\"\n                          value=\"NA\" (change)=\"UpdatePriorityNA('LowCharge')\"> {{ 'LblNA' | translate }} </label>\n                    </td>\n\n                  </tr>\n                  <!--CommunicationProblem-->\n                  <tr>\n                    <td>{{ 'LblCommunicationProblem' | translate }}</td>\n                    <td class=\"text-center\">\n                      <label class=\"radio-inline\">\n                        <input type=\"radio\" [(ngModel)]=\"model.communicationProblemNotificationModel.priority\" name=\"model.communicationProblemNotificationModel.priority1\"\n                          value=\"PRIORITY1\"> 1 </label>\n                      <label class=\"radio-inline\">\n                        <input type=\"radio\" [(ngModel)]=\"model.communicationProblemNotificationModel.priority\" name=\"model.communicationProblemNotificationModel.priority2\"\n                          value=\"PRIORITY2\"> 2 </label>\n                      <label class=\"radio-inline\">\n                        <input type=\"radio\" [(ngModel)]=\"model.communicationProblemNotificationModel.priority\" name=\"model.communicationProblemNotificationModel.priorityNA\"\n                          value=\"NA\" (change)=\"UpdatePriorityNA('CommunicationProblem')\"> {{ 'LblNA' | translate }}\n                      </label>\n                    </td>\n                  </tr>\n\n                  <!--InvalidTagScans-->\n                  <tr>\n                    <td>{{ 'LblInvalidTagUsed' | translate }}</td>\n                    <td class=\"text-center\">\n                      <label class=\"radio-inline\">\n                        <input type=\"radio\" [(ngModel)]=\"model.invalidTagScansNotificationModel.priority\" name=\"model.invalidTagScansNotificationModel.priority1\"\n                          value=\"PRIORITY1\"> 1 </label>\n                      <label class=\"radio-inline\">\n                        <input type=\"radio\" [(ngModel)]=\"model.invalidTagScansNotificationModel.priority\" name=\"model.invalidTagScansNotificationModel.priority2\"\n                          value=\"PRIORITY2\"> 2 </label>\n                      <label class=\"radio-inline\">\n                        <input type=\"radio\" [(ngModel)]=\"model.invalidTagScansNotificationModel.priority\" name=\"model.invalidTagScansNotificationModel.priorityNA\"\n                          value=\"NA\" (change)=\"UpdatePriorityNA('InvalidTagScans')\"> {{ 'LblNA' | translate }} </label>\n                    </td>\n                  </tr>\n\n                </tbody>\n              </table>\n            </div>\n          </fieldset>\n        </div>\n        <!--End Vehicle Priority and Email Configuration-->\n\n        <div class=\"row col-md-12\">\n          <!-- start Module rights configuration -->\n          <fieldset class=\"col-md-6\">\n            <!-- Removing below legend as we introduce new permission in permission matrix -->\n            <!-- <legend class=\"legendStyle\">\n              {{ 'LblModuleRights' | translate }}\n            </legend>\n            <div class=\"table table-responsive mar_bot_ziro\">\n              <table class=\"table table-bordered mar_bot_ziro\">\n                <thead>\n                  <tr>\n                    <th>{{ 'LblModuleName' | translate }}</th>\n                    <th class=\"text-center\">{{ 'LblCompanyAdmin' | translate }}</th>\n                    <th class=\"text-center\">{{ 'LblGroupAdmin' | translate }}</th>\n                  </tr>\n                </thead>\n                <tbody>\n                  <tr>\n                    <td>{{ 'LblVehicleOccupancyReport' | translate }}</td>\n                    <td class=\"text-center\">\n                      <input type=\"checkbox\" name=\"model.vehicleOccupencyReportModulerightsModel.companyAdmin\" [(ngModel)]=\"model.vehicleOccupencyReportModulerightsModel.companyAdmin\">\n                    </td>\n                    <td class=\"text-center\">\n                      <input type=\"checkbox\" name=\"model.vehicleOccupencyReportModulerightsModel.groupAdmin\" [(ngModel)]=\"model.vehicleOccupencyReportModulerightsModel.groupAdmin\">\n                    </td>\n                  </tr>\n                  <tr>\n                    <td>{{ 'LblRevenuePerVehicleReport' | translate }}</td>\n                    <td class=\"text-center\">\n                      <input type=\"checkbox\" name=\"model.revenuePerVehicleReportModulerightsModel.companyAdmin\" [(ngModel)]=\"model.revenuePerVehicleReportModulerightsModel.companyAdmin\">\n                    </td>\n                    <td class=\"text-center\">\n                      <input type=\"checkbox\" name=\"model.revenuePerVehicleReportModulerightsModel.groupAdmin\" [(ngModel)]=\"model.revenuePerVehicleReportModulerightsModel.groupAdmin\">\n                    </td>\n                  </tr>\n                  <tr>\n                    <td>{{ 'LblTripDataReport' | translate }}</td>\n                    <td class=\"text-center\">\n                      <input type=\"checkbox\" name=\"model.tripDataReportReportModulerightsModel.companyAdmin\" [(ngModel)]=\"model.tripDataReportReportModulerightsModel.companyAdmin\">\n                    </td>\n                    <td class=\"text-center\">\n                      <input type=\"checkbox\" name=\"model.tripDataReportReportModulerightsModel.groupAdmin\" [(ngModel)]=\"model.tripDataReportReportModulerightsModel.groupAdmin\">\n                    </td>\n                  </tr>\n                  <tr>\n                    <td>{{ 'LblMaintenancePlanningreport' | translate }}</td>\n                    <td class=\"text-center\">\n                      <input type=\"checkbox\" name=\"model.maintanancePlanningReportModulerightsModel.companyAdmin\" [(ngModel)]=\"model.maintanancePlanningReportModulerightsModel.companyAdmin\">\n                    </td>\n                    <td class=\"text-center\">\n                      <input type=\"checkbox\" name=\"model.maintanancePlanningReportModulerightsModel.groupAdmin\" [(ngModel)]=\"model.maintanancePlanningReportModulerightsModel.groupAdmin\">\n                    </td>\n                  </tr>\n                </tbody>\n              </table>\n            </div>\n            <div class=\"clearfix\"></div> -->\n            <legend class=\"legendStyle bookingDelaymargintop\">\n              <span class=\"text text-danger\">*</span> {{ 'LblBookingDelayConfig' | translate }}\n            </legend>\n            <div class=\"form-group col-md-12\">\n              <label>{{ 'LblBookingDelayConfigEnabled' | translate }}</label>\n              <div>\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" [(ngModel)]=\"model.bookingDelayConfig.enabled\" name=\"BookingDelayConfigEnabled\"\n                    value=\"YES\">{{ 'LblYes' | translate }}</label>\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" [(ngModel)]=\"model.bookingDelayConfig.enabled\" name=\"BookingDelayConfigEnabled\"\n                    value=\"NO\">{{ 'LblNo' | translate }}</label>\n              </div>\n            </div>\n            <div class=\"clearfix\"></div>\n            <legend class=\"legendStyle bookingDelaymargintop\">\n              <span class=\"text text-danger\">*</span> {{ 'LblCarwiseConfiguration' | translate }}\n            </legend>\n            <div class=\"row\">\n              <div class=\"form-group col-md-12\">\n                <div class=\"form-group col-md-6\">\n                  <span class=\"text text-danger\">*</span>\n                  <label>{{ 'LblCarwiseEnable' | translate }}</label>\n                  <div>\n                    <label class=\"radio-inline\">\n                      <input type=\"radio\" [(ngModel)]=\"model.carwiseConfigurationModel.isCarwiseEnabled\" name=\"IsCarwiseEnabled\"\n                        [value]=\"true\">{{ 'LblYes' | translate }}</label>\n                    <label class=\"radio-inline\">\n                      <input type=\"radio\" [(ngModel)]=\"model.carwiseConfigurationModel.isCarwiseEnabled\" name=\"IsCarwiseEnabled\"\n                        [value]=\"false\">{{ 'LblNo' | translate }}</label>\n                  </div>\n                </div>\n                <div *ngIf=\"model.carwiseConfigurationModel.isCarwiseEnabled\" class=\"form-group col-md-6\">\n                  <span class=\"text text-danger\">*</span>\n                  <label>{{ 'LblCarwiseConnectionUrl' | translate }}</label>\n                  <div>\n                    <input class=\"form-control\" placeholder=\"{{ 'LblCarwiseConnectionUrl' | translate }}\" type=\"text\"\n                      name=\"connectionUrl\" [(ngModel)]=\"model.carwiseConfigurationModel.carwiseConnectionUrl\">\n                    <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'carwiseConnectionUrl' }}</span>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class=\"row\">\n              <div *ngIf=\"model.carwiseConfigurationModel.isCarwiseEnabled\" class=\"form-group col-md-12\">\n                <div class=\"form-group col-md-6\">\n                  <span class=\"text text-danger\"></span>\n                  <label>{{ 'LblCarwiseConnectionUsername' | translate }}</label>\n                  <div>\n                    <input class=\"form-control\" placeholder=\"{{ 'LblCarwiseConnectionUsername' | translate }}\" type=\"text\"\n                      name=\"connectionUsername\" [(ngModel)]=\"model.carwiseConfigurationModel.carwiseConnectionUsername\">\n                    <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'carwiseConnectionUsername' }}</span>\n                  </div>\n                </div>\n                <div class=\"form-group col-md-6\">\n                  <span class=\"text text-danger\"></span>\n                  <label>{{ 'LblCarwiseConnectionPassword' | translate }}</label>\n                  <div>\n                    <input type=\"password\" class=\"form-control\" placeholder=\"{{ 'LblCarwiseConnectionPassword' | translate }}\"\n                      name=\"connectionPassword\" [(ngModel)]=\"model.carwiseConfigurationModel.carwiseConnectionPassword\">\n                    <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'carwiseConnectionPassword' }}</span>\n                  </div>\n                </div>\n              </div>\n            </div>\n            <div class=\"row\">\n              <div *ngIf=\"model.carwiseConfigurationModel.isCarwiseEnabled\" class=\"form-group col-md-12\">\n                <div class=\"form-group col-md-6\">\n                  <span class=\"text text-danger\">*</span>\n                  <label>{{ 'LblCarwiseAutoDeleteFrequencyInDays' | translate }}</label>\n                  <div>\n                    <input class=\"form-control\" placeholder=\"{{ 'LblCarwiseAutoDeleteFrequencyInDays' | translate }}\"\n                      type=\"text\" name=\"autoDeleteFrequencyInDays\" [(ngModel)]=\"model.carwiseConfigurationModel.carwiseAutoDeleteFrequencyInDays\">\n                    <span class=\"text text-danger\">{{ errorModel | serverErrorMessage :\n                      'carwiseAutoDeleteFrequencyInDays' }}</span>\n                  </div>\n                </div>\n\n                <!-- <div class=\"col-md-6\">\n                  <span class=\"text text-danger\">*</span>\n                  <label>{{ 'LblDamageImageExtentions' | translate }}</label>\n                  <div class=\"checkbox\" *ngFor=\"let imageExtention of damageImageExtentions\">\n                    <label>\n                      <input type=\"checkbox\" (change)=\"OnChangeDamageImageExtension(imageExtention, $event.target.checked)\" value=\"imageExtention.value\"\n                        [checked]=\"imageExtention.IsChecked\" /> {{imageExtention.Key}}\n                    </label>\n                  </div>\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'damageImageExtensions' }}</span>\n                </div> -->\n              </div>\n            </div>\n\n          </fieldset>\n          <!-- End Module rights configuration -->\n\n          <!--Branding and Template Configuration-->\n          <fieldset class=\"col-md-6\">\n            <legend class=\"legendStyle\">\n              <span class=\"text text-danger\">*</span> {{ 'LblBrandingTemplateConfiguration' | translate }}\n            </legend>\n            <div>\n              <div class=\"form-group col-md-12\">\n                <label>{{ 'LblAppWebUI' | translate }}</label>\n                <div class=\"clearfix\"></div>\n                <div class=\"radio\">\n                  <label>\n                    <input type=\"radio\" [(ngModel)]=\"model.brandingTemplateConfig.ui\" name=\"brandingTemplateConfig.ui\"\n                      value=\"INSTANCE\">{{ 'LblInstanceBranding' | translate }}</label>\n                </div>\n                <div class=\"radio\">\n                  <label>\n                    <input type=\"radio\" [(ngModel)]=\"model.brandingTemplateConfig.ui\" name=\"brandingTemplateConfig.ui\"\n                      value=\"COMPANY\">{{ 'LblCompanyBranding' | translate }}</label>\n                </div>\n              </div>\n              <div class=\"form-group col-md-12\">\n                <label>{{ 'LblNonBookingCommunication' | translate }}</label>\n                <div class=\"clearfix\"></div>\n                <div class=\"radio\">\n                  <label>\n                    <input type=\"radio\" [(ngModel)]=\"model.brandingTemplateConfig.nonBooking\" name=\"brandingTemplateConfig.nonBooking\"\n                      value=\"INSTANCE\">{{ 'LblInstanceBranding' | translate }}</label>\n                </div>\n                <div class=\"radio\">\n                  <label>\n                    <input type=\"radio\" [(ngModel)]=\"model.brandingTemplateConfig.nonBooking\" name=\"brandingTemplateConfig.nonBooking\"\n                      value=\"COMPANY\">{{ 'LblCompanyBranding' | translate }}</label>\n                </div>\n              </div>\n              <div class=\"form-group col-md-12\">\n                <label>{{ 'LblBookingCommunication' | translate }}</label>\n                <div class=\"clearfix\"></div>\n                <div class=\"radio\">\n                  <label>\n                    <input type=\"radio\" [(ngModel)]=\"model.brandingTemplateConfig.booking\" name=\"brandingTemplateConfig.booking\"\n                      value=\"INSTANCE\">{{ 'LblInstanceBranding' | translate }}</label>\n                </div>\n                <div class=\"radio\">\n                  <label>\n                    <input type=\"radio\" [(ngModel)]=\"model.brandingTemplateConfig.booking\" name=\"brandingTemplateConfig.booking\"\n                      value=\"COMPANY\">{{ 'LblCompanyBranding' | translate }}</label>\n                </div>\n              </div>\n              <div class=\"form-group col-md-12\">\n                <label>{{ 'LblInvoices' | translate }}</label>\n                <div class=\"clearfix\"></div>\n                <div class=\"radio\">\n                  <label>\n                    <input type=\"radio\" [(ngModel)]=\"model.brandingTemplateConfig.invoice\" name=\"brandingTemplateConfig.invoice\"\n                      value=\"INSTANCE\">{{ 'LblInstanceBranding' | translate }}</label>\n                </div>\n                <div class=\"radio\">\n                  <label>\n                    <input type=\"radio\" [(ngModel)]=\"model.brandingTemplateConfig.invoice\" name=\"brandingTemplateConfig.invoice\"\n                      value=\"COMPANY\">{{ 'LblCompanyBranding' | translate }}</label>\n                </div>\n              </div>\n            </div>\n          </fieldset>\n          <!--End Branding and Template Configuration-->\n\n          <!--Start Booking Delay Configuration-->\n\n          <!--End Booking Delay Configuration-->\n        </div>\n        <div class=\"row col-md-12\">\n          <fieldset class=\"col-md-6\">\n            <legend class=\"legendStyle\">\n              <span class=\"text text-danger\">*</span> {{ 'LblVatSettings' | translate }}\n            </legend>\n            <wego-vat-setting [VatSettingsList]=\"model.vatSettingsList\" [VatSettingDefaultCost]=\"model.vatSettingDefaultCost\"\n              [VatDefaultRate]=\"model.vatDefaultRate\" [ErrorModel]=\"errorModel\" (OnVatSetting)=\"OnVatSetting($event)\"></wego-vat-setting>\n          </fieldset>\n          <fieldset class=\"col-md-6\">\n            <legend class=\"legendStyle\">\n              <span class=\"text text-danger\">*</span> {{ 'LblAllowPaymentConfiguration' | translate }}\n            </legend>\n            <div class=\"form-group col-md-12\">\n              <label>{{ 'LblAllowPayment' | translate }}</label>\n              <div>\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" [(ngModel)]=\"model.isPaymentRequired\" name=\"IsPaymentRequired\" [value]=\"true\">{{\n                  'LblYes' | translate }}</label>\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" [(ngModel)]=\"model.isPaymentRequired\" name=\"IsPaymentRequired\" [value]=\"false\">{{\n                  'LblNo' | translate }}</label>\n              </div>\n            </div>\n          </fieldset>\n        </div>\n        <!-- Pre Post trip Question at instance level -->\n        <div *ngIf=\"isAuthorizedForPrePostTrip\" class=\"row col-md-12\">\n          <fieldset class=\"col-md-12\">\n            <legend class=\"legendStyle\">\n              {{ 'LblPrePostTripQuestions' | translate }}\n            </legend>\n            <wego-pre-post-trip-question #prePostTripQuestionSection [ErrorModel]=\"errorModel\" [CustomTripQuestionList]=\"model.customTripQuestionList\"\n              [InstanceView]='true' (OnPrePostTripQuestionSetting)=\"OnPrePostTripQuestionSetting($event)\"></wego-pre-post-trip-question>\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'defaultLanguageQuestionNotDefined' }}</span>\n          </fieldset>\n        </div>\n        <!-- End Pre Post trip Question at instance level -->\n        <div class=\"row col-md-12\">\n          <fieldset class=\"col-md-6\">\n            <legend class=\"legendStyle\">\n              <span class=\"text text-danger\">*</span> {{ 'LblUserBlockMessage' | translate }}\n            </legend>\n            <div class=\"form-group col-md-12\">\n              <label>{{ 'LblUserBlockMessage' | translate }}</label>\n              <div>\n                <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblUserBlockMessage' | translate }}\"\n                  [(ngModel)]=\"model.userBlockMessage\" name=\"userBlockMessage\" maxlength=\"500\">\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'userBlockMessage' }}</span>\n              </div>\n            </div>\n          </fieldset>\n\n\n          <fieldset class=\"col-md-6\" *ngIf=\"model && model.gdprSettingsModel\">\n            <legend class=\"legendStyle\">\n              <span class=\"text text-danger\">*</span> {{ 'LblGdprSettings' | translate }}\n            </legend>\n            <div class=\"form-group col-md-6\">\n              <label>{{ 'LblInactiveAfterDays' | translate }}</label>\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblInactiveAfterDays' | translate }}\"\n                [(ngModel)]=\"model.gdprSettingsModel.inactiveAfterDays\" name=\"InactiveAfterDays\" maxlength=\"3\">\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'InactiveAfterDays' }}</span>\n            </div>\n            <div class=\"form-group col-md-6\">\n              <label>{{ 'LblMarkDeleteAfterDays' | translate }}</label>\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblMarkDeleteAfterDays' | translate }}\"\n                [(ngModel)]=\"model.gdprSettingsModel.markDeleteAfterDays\" name=\"MarkDeleteAfterDays\" maxlength=\"3\">\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'MarkDeleteAfterDays' }}</span>\n            </div>\n            <div class=\"clearfix\"></div>\n            <div class=\"form-group col-md-6\">\n              <label>{{ 'LblNotifyAdminBeforeDays' | translate }}</label>\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblNotifyAdminBeforeDays' | translate }}\"\n                [(ngModel)]=\"model.gdprSettingsModel.notifyAdminBeforeDays\" name=\"NotifyAdminBeforeDays\" maxlength=\"2\">\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'NotifyAdminBeforeDays' }}</span>\n            </div>\n          </fieldset>\n\n        </div>\n        <div class=\"row col-md-12\">\n          <fieldset class=\"col-md-6\">\n            <legend class=\"legendStyle\">\n              <span class=\"text text-danger\">*</span> {{ 'LblCurrencyConfiguration' | translate }}\n            </legend>\n            <div class=\"form-group col-md-6\">\n              <label>\n                <span class=\"text text-danger\">*</span> {{ 'LblName' | translate }}</label>\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblName' | translate }}\" [(ngModel)]=\"model.currencyConfigurationModel.currencyName\"\n                name=\"currencyConfigurationModel.currencyName\" maxlength=\"100\">\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'currencyName' }}</span>\n            </div>\n            <div class=\"form-group col-md-6\">\n              <label>\n                <span class=\"text text-danger\">*</span> {{ 'LblCurrencyAbbreviation' | translate }}</label>\n              <select [(ngModel)]=\"model.currencyConfigurationModel.currencyAbbreviation\" name=\"CurrencyAbbreviation\"\n                class=\"form-control\">\n                <option value=\"\" [selected]=\"selected\">{{ 'LblSelect' | translate }} {{ 'LblCurrencyAbbreviation' |\n                  translate }}</option>\n                <option *ngFor=\"let currencyAbbreviation of currencyAbbreviationList\" [attr.value]='currencyAbbreviation'>{{currencyAbbreviation}}</option>\n              </select>\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'currencyAbbreviation' }}</span>\n            </div>\n            <div class=\"clearfix\"></div>\n            <div class=\"form-group col-md-6\">\n              <label>\n                <span class=\"text text-danger\">*</span> {{ 'LblNameSingular' | translate }}</label>\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblNameSingular' | translate }}\" [(ngModel)]=\"model.currencyConfigurationModel.currencyNameSingular\"\n                name=\"currencyConfigurationModel.currencyNameSingular\" maxlength=\"100\">\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'currencyNameSingular' }}</span>\n            </div>\n            <div class=\"form-group col-md-6\">\n              <label>\n                <span class=\"text text-danger\">*</span> {{ 'LblNamePlural' | translate }}</label>\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblNamePlural' | translate }}\" [(ngModel)]=\"model.currencyConfigurationModel.currencyNamePlural\"\n                name=\"currencyConfigurationModel.currencyNamePlural\" maxlength=\"100\">\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'currencyNamePlural' }}</span>\n            </div>\n            <div class=\"clearfix\"></div>\n            <div class=\"form-group col-md-6\">\n              <label>\n                <span class=\"text text-danger\">*</span> {{ 'LblCurrencySymbol' | translate }}\n              </label>\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblCurrencySymbol' | translate }}\" [(ngModel)]=\"model.currencyConfigurationModel.currencySymbol\"\n                name=\"CurrencySymbol\" maxlength=\"5\">\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'currencySymbol' }}</span>\n            </div>\n            <div class=\"form-group col-md-6\">\n              <div class=\"checkbox\">\n                <label>\n                  <input type=\"checkbox\" name=\"model.currencyConfigurationModel.currencySignBeforeAmount\" [(ngModel)]=\"model.currencyConfigurationModel.currencySignBeforeAmount\">{{\n                  'LblSignBeforeAmount' | translate }}</label>\n              </div>\n            </div>\n          </fieldset>\n\n          <fieldset class=\"col-md-6\" *ngIf=\"model.twoFAConfig\">\n            <legend class=\"legendStyle\">\n              <span class=\"text text-danger\">*</span> {{ 'LblTwoFaConfig' | translate }}\n            </legend>\n            <div class=\"form-group col-md-12\">\n              <label>\n                <span class=\"text text-danger\">*</span> {{ 'LblEnableTwoFa' | translate }}</label>\n              <div>\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" [(ngModel)]=\"model.twoFAConfig.enabled\" name=\"EnableTwoFa\" value=\"YES\">\n                  {{ 'LblYes' | translate }}</label>\n                <label class=\"radio-inline\">\n                  <input type=\"radio\" [(ngModel)]=\"model.twoFAConfig.enabled\" name=\"EnableTwoFa\" value=\"NO\">\n                  {{ 'LblNo' | translate }}</label>\n              </div>\n            </div>\n            <div *ngIf=\"model.twoFAConfig.enabled=='YES'\" class=\"form-group col-md-6\">\n              <label>{{ 'LblExpirationDays' | translate }}</label>\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblExpirationDays' | translate }}\" [(ngModel)]=\"model.twoFAConfig.expirationDays\"\n                name=\"ExpirationDays\" maxlength=\"3\">\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'ExpirationDays' }}</span>\n            </div>\n\n            <div class=\"form-group col-md-12\">\n              <a *ngIf=\"model.twoFAConfig.enableResetCookie\" class=\"btn btn-highlight navbar-left\" (click)=\"ResetCookies()\">{{\n                'LblResetCookiesForAllAdmin' | translate }}</a>\n              <div class=\"clearfix\"></div>\n              <a *ngIf=\"model.twoFAConfig.enableResetKey\" class=\"btn btn-highlight navbar-left mar_t_5\" (click)=\"ResetTwoFA()\">{{\n                'LblReset2FaForAllAdmin' | translate }}</a>\n            </div>\n\n          </fieldset>\n\n        </div>\n\n        <!-- SSO -->\n        <div class=\"row col-md-12 mt-2\">\n          <fieldset class=\"col-md-12\">\n            <legend class=\"legendStyle\">\n              {{ 'LblSsoConfiguration' | translate }}\n            </legend>\n            <div class=\"clearfix\"></div>\n            <div class=\"form-group col-md-4\">\n              <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.SVG\">\n                <label>\n                  {{ 'LblDefaultSsoSharedVehicleGroup' | translate }}\n                </label>\n                <select [disabled]=\"!isEditMode\" [(ngModel)]=\"model.defaultSsoSharedVehicleGroupHashId\" name=\"defaultSsoSharedVehicleGroupHashId\" class=\"form-control\" (change)=\"onChangeSelectedSVG($event.target.value)\">\n                  <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblSharedVehicleGroup' | translate }}</option>\n                  <option *ngFor=\"let svg of sharedVehicleGroupList\" [attr.value]=\"svg.sharedvehiclegroupHashId\" [selected]=\"svg.sharedvehiclegroupHashId==model.defaultSsoSharedVehicleGroupHashId\">{{svg.groupName}}</option>\n                </select>\n              </div>\n            </div>\n            <div class=\"form-group col-md-4\">\n              <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Organization\">\n                <label>\n                  {{ 'LblDefaultSsoOrganization' | translate }}\n                </label>\n                <select [disabled]=\"!isSvgSelected\" [(ngModel)]=\"model.defaultSsoOrganizationHashId\" name=\"defaultSsoOrganizationHashId\" class=\"form-control\" (change)=\"onChangeSelectedOrg($event.target.value)\">\n                  <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblOrganization' | translate }}</option>\n                  <option *ngFor=\"let org of organizationList\" [attr.value]=\"org.keyHash\" [selected]=\"org.keyHash==model.defaultSsoOrganizationHashId\">{{org.value}}</option>\n                </select>\n              </div>\n              <span class=\"text text-danger\">{{ apiOrgErrorMsg }}</span>\n            </div>\n            <div class=\"form-group col-md-4\">\n              <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Organization\">\n                <label>\n                  {{ 'LblDefaultSsoSubscription' | translate }}\n                </label>\n                <select [disabled]=\"!isOrgSelected\" [(ngModel)]=\"model.defaultSsoSubscriptionHashId\" name=\"defaultSsoSubscriptionHashId\" class=\"form-control\" >\n                  <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblSubscription' | translate }}</option>\n                  <option *ngFor=\"let sub of subscriptionList\" [attr.value]='sub.subscriptionMapHashId' [selected]=\"sub.subscriptionMapHashId==model.defaultSsoSubscriptionHashId\">{{sub.name}}</option>\n                </select>\n              </div>\n              <span class=\"text text-danger\">{{ apiSubErrorMsg }}</span>\n            </div>\n\n          </fieldset>\n        </div>\n\n        <!-- Dropoff Message -->\n        <div class=\"row col-md-12 mt-2\">\n          <fieldset class=\"col-md-12\">\n            <legend class=\"legendStyle\">\n              {{ 'LblDropoffMessageConfiguration' | translate }}\n            </legend>\n            <div class=\"clearfix\"></div>\n            <div class=\"form-group col-md-2\">\n              <div>\n                <label>\n                  {{ 'LblDropoffMessageActive' | translate }}\n                </label>\n                <div>\n                  <label class=\"radio-inline\">\n                    <input type=\"radio\" [(ngModel)]=\"model.dropOffActive\" name=\"dropOffActive\" [value]=\"true\">\n                    {{ 'LblYes' | translate }}</label>\n                  <label class=\"radio-inline\">\n                    <input type=\"radio\" [(ngModel)]=\"model.dropOffActive\" name=\"dropOffActive\" [value]=\"false\">\n                    {{ 'LblNo' | translate }}</label>\n                </div>\n              </div>\n            </div>           \n            <div class=\"form-group col-md-4\">\n              <div>\n                <label>\n                  {{ 'LblDropoffMessageExternalUrl' | translate }}\n                </label>\n                <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblDropoffMessageExternalUrl' | translate }}\" [(ngModel)]=\"model.dropOffExternalUrl\"\n                name=\"dropOffExternalUrl\" maxlength=\"256\">\n              </div>\n            </div>\n            <div class=\"form-group col-md-4\">\n              <div>\n                <label>\n                  {{ 'LblDropoffMessageApiKey' | translate }}\n                </label>\n                <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblDropoffMessageApiKey' | translate }}\" [(ngModel)]=\"model.dropOffApiKey\"\n                name=\"dropOffApiKey\">\n              </div>\n              <span class=\"text text-danger\">{{ apiOrgErrorMsg }}</span>\n            </div>\n          </fieldset>\n        </div>        \n\n        <div class=\"row no-margin\">\n          <div class=\"col-sm-12\">\n            <hr>\n            <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnBackClick()\">{{ 'LblCancel' | translate }}</a>\n            &nbsp;&nbsp;\n            <button class=\"btn btn-green\" type=\"submit\" (click)=\"onSubmitClick()\">{{ 'LblSave' | translate }}</button>\n          </div>\n        </div>\n      </form>\n    </div>\n  </section>\n</div>\n\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\n<wego-success-popup #TwoFasuccessPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmTwoFaPopup()\"></wego-success-popup>\n<wego-geo-location-map #geoLocationModal (onConfirm)=\"onConfirm($event)\" [Language]=\"model.preferredLanguage\"></wego-geo-location-map>\n";

/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var ReadMorePipe = (function () {
	    function ReadMorePipe() {
	    }
	    ReadMorePipe.prototype.transform = function (data, length) {
	        if (data && data.length > length) {
	            var readMore = data.substring(0, length);
	            return readMore;
	        }
	        return data;
	    };
	    ReadMorePipe = __decorate([
	        core_1.Pipe({
	            name: 'readMorePipe'
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ReadMorePipe);
	    return ReadMorePipe;
	}());
	exports.ReadMorePipe = ReadMorePipe;


/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var ServerErrorMessagePipe = (function () {
	    function ServerErrorMessagePipe() {
	    }
	    ServerErrorMessagePipe.prototype.transform = function (keyValuePair, key) {
	        if (keyValuePair) {
	            var error = keyValuePair.find(function (item) { return item.key.toLowerCase() == key.toLowerCase(); });
	            if (error)
	                return error.value;
	        }
	        return '';
	    };
	    ServerErrorMessagePipe = __decorate([
	        core_1.Pipe({
	            name: 'serverErrorMessage'
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ServerErrorMessagePipe);
	    return ServerErrorMessagePipe;
	}());
	exports.ServerErrorMessagePipe = ServerErrorMessagePipe;


/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var modal_1 = __webpack_require__(537);
	var core_1 = __webpack_require__(3);
	var translate_1 = __webpack_require__(631);
	var ConfirmPopupComponent = (function () {
	    function ConfirmPopupComponent(translate) {
	        this.translate = translate;
	        this._popupTitle = this.translate.instant('LblConfirm');
	        this._popupMsg = this.translate.instant('LblRecordDeleteConfirmation');
	        this.onConfirm = new core_1.EventEmitter();
	        this.onReject = new core_1.EventEmitter();
	    }
	    Object.defineProperty(ConfirmPopupComponent.prototype, "popupMsg", {
	        get: function () { return this._popupMsg; },
	        set: function (popupMsg) {
	            this._popupMsg = (popupMsg && popupMsg.trim()) || this.translate.instant('LblRecordDeleteConfirmation');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ConfirmPopupComponent.prototype, "popupTitle", {
	        get: function () { return this._popupTitle; },
	        set: function (popupTitle) {
	            this._popupTitle = (popupTitle && popupTitle.trim()) || this.translate.instant('LblConfirm');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ConfirmPopupComponent.prototype.ngOnInit = function () {
	    };
	    ConfirmPopupComponent.prototype.show = function () {
	        this.confirmModal.show();
	    };
	    ConfirmPopupComponent.prototype.hide = function () {
	        this.confirmModal.hide();
	    };
	    ConfirmPopupComponent.prototype.Confirm = function ($event) {
	        this.onConfirm.emit($event);
	    };
	    ConfirmPopupComponent.prototype.Reject = function ($event) {
	        this.onReject.emit($event);
	    };
	    ConfirmPopupComponent.prototype.ngOnDestroy = function () {
	    };
	    __decorate([
	        core_1.ViewChild('confirmModal'), 
	        __metadata('design:type', (typeof (_a = typeof modal_1.ModalDirective !== 'undefined' && modal_1.ModalDirective) === 'function' && _a) || Object)
	    ], ConfirmPopupComponent.prototype, "confirmModal", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String), 
	        __metadata('design:paramtypes', [String])
	    ], ConfirmPopupComponent.prototype, "popupMsg", null);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String), 
	        __metadata('design:paramtypes', [String])
	    ], ConfirmPopupComponent.prototype, "popupTitle", null);
	    __decorate([
	        core_1.Output('onConfirm'), 
	        __metadata('design:type', Object)
	    ], ConfirmPopupComponent.prototype, "onConfirm", void 0);
	    __decorate([
	        core_1.Output('onReject'), 
	        __metadata('design:type', Object)
	    ], ConfirmPopupComponent.prototype, "onReject", void 0);
	    ConfirmPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-confirm-popup',
	            template: "\n  <div bsModal #confirmModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" \n  aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\n    <div class=\"modal-dialog modal-sm\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\n                    <span aria-hidden=\"true\">&times;</span></button>\n                <h4 class=\"modal-title\">{{ popupTitle }}</h4>\n            </div>\n            <div class=\"modal-body\">\n                {{ popupMsg }}\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-green\" (click)=\"Confirm($event)\">{{ 'LblYes' | translate }}</button>\n                <button type=\"button\" class=\"btn btn-gray\" (click)=\"Reject($event)\">{{ 'LblNo' | translate }}</button>\n            </div>\n        </div>\n    </div>\n  </div>"
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof translate_1.TranslateService !== 'undefined' && translate_1.TranslateService) === 'function' && _b) || Object])
	    ], ConfirmPopupComponent);
	    return ConfirmPopupComponent;
	    var _a, _b;
	}());
	exports.ConfirmPopupComponent = ConfirmPopupComponent;


/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var modal_1 = __webpack_require__(537);
	var core_1 = __webpack_require__(3);
	var translate_1 = __webpack_require__(631);
	var SuccessPopupComponent = (function () {
	    function SuccessPopupComponent(translate) {
	        this.translate = translate;
	        this._popupTitle = this.translate.instant('LblSuccess');
	        this._popupMsg = this.translate.instant('LblRecordSavedSuccess');
	        this.onConfirm = new core_1.EventEmitter();
	    }
	    Object.defineProperty(SuccessPopupComponent.prototype, "popupMsg", {
	        get: function () { return this._popupMsg; },
	        set: function (popupMsg) {
	            this._popupMsg = (popupMsg && popupMsg.trim()) || this.translate.instant('LblRecordSavedSuccess');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SuccessPopupComponent.prototype, "popupTitle", {
	        get: function () { return this._popupTitle; },
	        set: function (popupTitle) {
	            this._popupTitle = (popupTitle && popupTitle.trim()) || this.translate.instant('LblSuccess');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SuccessPopupComponent.prototype.ngOnInit = function () {
	    };
	    SuccessPopupComponent.prototype.show = function (autoConfirm) {
	        var _this = this;
	        if (autoConfirm === void 0) { autoConfirm = true; }
	        this.successModal.show();
	        if (autoConfirm) {
	            setTimeout(function () { return _this.Confirm(null); }, 3000);
	        }
	    };
	    SuccessPopupComponent.prototype.hide = function () {
	        this.successModal.hide();
	    };
	    SuccessPopupComponent.prototype.Confirm = function ($event) {
	        this.hide();
	        this.onConfirm.emit($event);
	    };
	    SuccessPopupComponent.prototype.ngOnDestroy = function () {
	    };
	    __decorate([
	        core_1.ViewChild('successModal'), 
	        __metadata('design:type', (typeof (_a = typeof modal_1.ModalDirective !== 'undefined' && modal_1.ModalDirective) === 'function' && _a) || Object)
	    ], SuccessPopupComponent.prototype, "successModal", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String), 
	        __metadata('design:paramtypes', [String])
	    ], SuccessPopupComponent.prototype, "popupMsg", null);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String), 
	        __metadata('design:paramtypes', [String])
	    ], SuccessPopupComponent.prototype, "popupTitle", null);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], SuccessPopupComponent.prototype, "onConfirm", void 0);
	    SuccessPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-success-popup',
	            template: "\n  <div bsModal #successModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" \n  aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\n    <div class=\"modal-dialog modal-sm\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\">\n                <h4 class=\"modal-title\">{{ popupTitle }}</h4>\n            </div>\n            <div class=\"modal-body\" style=\"word-wrap: break-word;\">\n                {{ popupMsg }}\n            </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-green\" (click)=\"Confirm($event)\">{{ 'LblOK' |  translate }}</button>\n            </div>\n        </div>\n    </div>\n  </div>",
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof translate_1.TranslateService !== 'undefined' && translate_1.TranslateService) === 'function' && _b) || Object])
	    ], SuccessPopupComponent);
	    return SuccessPopupComponent;
	    var _a, _b;
	}());
	exports.SuccessPopupComponent = SuccessPopupComponent;


/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var auth_service_1 = __webpack_require__(58);
	var config_1 = __webpack_require__(60);
	var DriverAdminAuthGuard = (function () {
	    function DriverAdminAuthGuard(authService, router) {
	        this.authService = authService;
	        this.router = router;
	    }
	    DriverAdminAuthGuard.prototype.canActivate = function (route, state) {
	        if (this.authService.isAuthorized(config_1.UserRoles.DRIVER)) {
	            return true;
	        }
	        // Store the attempted URL for redirecting 
	        //this.authService.redirectUrl = state.url;
	        // Navigate to the login page
	        this.router.navigate(['/Unauthorized']);
	        return false;
	    };
	    DriverAdminAuthGuard = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object])
	    ], DriverAdminAuthGuard);
	    return DriverAdminAuthGuard;
	    var _a, _b;
	}());
	exports.DriverAdminAuthGuard = DriverAdminAuthGuard;


/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var auth_service_1 = __webpack_require__(58);
	var config_1 = __webpack_require__(60);
	var GAdminAuthGuard = (function () {
	    function GAdminAuthGuard(authService, router) {
	        this.authService = authService;
	        this.router = router;
	    }
	    GAdminAuthGuard.prototype.canActivate = function (route, state) {
	        if (this.authService.isAuthorized(config_1.UserRoles.GROUPADMIN)) {
	            var urlBatchUpload = this.authService.GetURL(config_1.ApplicationRouteURL.URL_BATCHUPLOADPERSON);
	            var urlOrganizationUpdate = this.authService.GetURL(config_1.ApplicationRouteURL.URL_ORGANIZATION_UPDATE);
	            var urlTripDataReport = this.authService.GetURL(config_1.ApplicationRouteURL.URL_TRIPDATA_REPORT);
	            var urlVehicleOccupancyReport = this.authService.GetURL(config_1.ApplicationRouteURL.URL_VEHICLE_OCCUPANCY_REPORT);
	            var urlMaintenancePlanningReport = this.authService.GetURL(config_1.ApplicationRouteURL.URL_MAINTENANCE_PLANNING_REPORT);
	            var urlRevenuePerVehicleReport = this.authService.GetURL(config_1.ApplicationRouteURL.URL_REVENUE_PER_VEHICLE_REPORT);
	            var urlSnailTrailReport = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SNAIL_TRAIL_REPORT);
	            if (state.url == urlBatchUpload) {
	                return this.IsAuthorizeFor(this.authService.MODULE_NAME.PersonBatchUpload);
	            }
	            else if (state.url == urlOrganizationUpdate) {
	                return this.IsAuthorizeFor(this.authService.MODULE_NAME.CreateOrganization);
	            }
	            else if (state.url == urlTripDataReport) {
	                return this.IsAuthorizeFor(this.authService.MODULE_NAME.TRIP_DATA_REPORT);
	            }
	            else if (state.url == urlVehicleOccupancyReport) {
	                return this.IsAuthorizeFor(this.authService.MODULE_NAME.VEHICLE_OCCUPENCY_REPORT);
	            }
	            else if (state.url == urlMaintenancePlanningReport) {
	                return this.IsAuthorizeFor(this.authService.MODULE_NAME.MAINTAINANCE_PLANNING_REPORT);
	            }
	            else if (state.url == urlRevenuePerVehicleReport) {
	                return this.IsAuthorizeFor(this.authService.MODULE_NAME.REVENUE_PER_VEHICLE_REPORT);
	            }
	            else if (state.url == urlSnailTrailReport) {
	                return this.IsAuthorizeFor(this.authService.MODULE_NAME.SnailTrailReport);
	            }
	            else {
	                return true;
	            }
	        }
	        else {
	            // Navigate to the login page
	            this.router.navigate(['/Unauthorized']);
	            return false;
	        }
	        // Store the attempted URL for redirecting 
	        //this.authService.redirectUrl = state.url;
	    };
	    GAdminAuthGuard.prototype.IsAuthorizeFor = function (moduleName) {
	        var _this = this;
	        return this.authService.IsAuthorizeFor(moduleName)
	            .map(function (res) {
	            if (!res.data) {
	                _this.router.navigate(['/NotFound']);
	            }
	            return res.data;
	        });
	    };
	    GAdminAuthGuard = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object])
	    ], GAdminAuthGuard);
	    return GAdminAuthGuard;
	    var _a, _b;
	}());
	exports.GAdminAuthGuard = GAdminAuthGuard;


/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var auth_service_1 = __webpack_require__(58);
	var config_1 = __webpack_require__(60);
	var CAdminAuthGuard = (function () {
	    function CAdminAuthGuard(authService, router) {
	        this.authService = authService;
	        this.router = router;
	    }
	    CAdminAuthGuard.prototype.canActivate = function (route, state) {
	        if (this.authService.isAuthorized(config_1.UserRoles.COMPANYADMIN)) {
	            var urlBatchUpload = this.authService.GetURL(config_1.ApplicationRouteURL.URL_BATCHUPLOADPERSON);
	            var urlDirectDebit = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DIRECTDEBIT_LIST);
	            var urlOrganizationUpdate = this.authService.GetURL(config_1.ApplicationRouteURL.URL_ORGANIZATION_UPDATE);
	            var urlTripDataReport = this.authService.GetURL(config_1.ApplicationRouteURL.URL_TRIPDATA_REPORT);
	            var urlVehicleOccupancyReport = this.authService.GetURL(config_1.ApplicationRouteURL.URL_VEHICLE_OCCUPANCY_REPORT);
	            var urlMaintenancePlanningReport = this.authService.GetURL(config_1.ApplicationRouteURL.URL_MAINTENANCE_PLANNING_REPORT);
	            var urlRevenuePerVehicleReport = this.authService.GetURL(config_1.ApplicationRouteURL.URL_REVENUE_PER_VEHICLE_REPORT);
	            var urlSnailTrailReport = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SNAIL_TRAIL_REPORT);
	            if (state.url == urlBatchUpload) {
	                return this.IsAuthorizeFor(this.authService.MODULE_NAME.PersonBatchUpload);
	            }
	            else if (state.url == urlDirectDebit) {
	                return this.IsAuthorizeFor(this.authService.MODULE_NAME.DirectDebitFile);
	            }
	            else if (state.url == urlOrganizationUpdate) {
	                return this.IsAuthorizeFor(this.authService.MODULE_NAME.CreateOrganization);
	            }
	            else if (state.url == urlTripDataReport) {
	                return this.IsAuthorizeFor(this.authService.MODULE_NAME.TRIP_DATA_REPORT);
	            }
	            else if (state.url == urlVehicleOccupancyReport) {
	                return this.IsAuthorizeFor(this.authService.MODULE_NAME.VEHICLE_OCCUPENCY_REPORT);
	            }
	            else if (state.url == urlMaintenancePlanningReport) {
	                return this.IsAuthorizeFor(this.authService.MODULE_NAME.MAINTAINANCE_PLANNING_REPORT);
	            }
	            else if (state.url == urlRevenuePerVehicleReport) {
	                return this.IsAuthorizeFor(this.authService.MODULE_NAME.REVENUE_PER_VEHICLE_REPORT);
	            }
	            else if (state.url == urlSnailTrailReport) {
	                return this.IsAuthorizeFor(this.authService.MODULE_NAME.SnailTrailReport);
	            }
	            else {
	                return true;
	            }
	        }
	        else {
	            // Navigate to the login page
	            this.router.navigate(['/Unauthorized']);
	            return false;
	        }
	        // Store the attempted URL for redirecting 
	        //this.authService.redirectUrl = state.url;
	    };
	    CAdminAuthGuard.prototype.IsAuthorizeFor = function (moduleName) {
	        var _this = this;
	        return this.authService.IsAuthorizeFor(moduleName)
	            .map(function (res) {
	            if (!res.data) {
	                _this.router.navigate(['/NotFound']);
	            }
	            return res.data;
	        });
	    };
	    CAdminAuthGuard = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object])
	    ], CAdminAuthGuard);
	    return CAdminAuthGuard;
	    var _a, _b;
	}());
	exports.CAdminAuthGuard = CAdminAuthGuard;


/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var auth_service_1 = __webpack_require__(58);
	var config_1 = __webpack_require__(60);
	var WAdminAuthGuard = (function () {
	    function WAdminAuthGuard(authService, router) {
	        this.authService = authService;
	        this.router = router;
	    }
	    WAdminAuthGuard.prototype.canActivate = function (route, state) {
	        if (this.authService.isAuthorized(config_1.UserRoles.WEGOADMIN)) {
	            return true;
	        }
	        // Store the attempted URL for redirecting 
	        //this.authService.redirectUrl = state.url;
	        // Navigate to the login page
	        this.router.navigate(['/Unauthorized']);
	        return false;
	    };
	    WAdminAuthGuard = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object])
	    ], WAdminAuthGuard);
	    return WAdminAuthGuard;
	    var _a, _b;
	}());
	exports.WAdminAuthGuard = WAdminAuthGuard;


/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var auth_service_1 = __webpack_require__(58);
	var AuthGuard = (function () {
	    function AuthGuard(authService, router) {
	        this.authService = authService;
	        this.router = router;
	    }
	    AuthGuard.prototype.canActivate = function (route, state) {
	        if (this.authService.isLoggedIn()) {
	            return true;
	        }
	        // Store the attempted URL for redirecting 
	        this.authService.redirectUrl = state.url;
	        //this.authService.redirectMsg = "Session is expired. Please login again.";
	        // Navigate to the login page
	        this.router.navigate(['/Unauthenticated']);
	        return false;
	    };
	    AuthGuard = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object])
	    ], AuthGuard);
	    return AuthGuard;
	    var _a, _b;
	}());
	exports.AuthGuard = AuthGuard;


/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var ContentWrapperComponent = (function () {
	    function ContentWrapperComponent() {
	    }
	    ContentWrapperComponent.prototype.ngOnInit = function () { };
	    ContentWrapperComponent.prototype.ngOnDestroy = function () { };
	    ContentWrapperComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-content-wrapper',
	            template: '<router-outlet></router-outlet>',
	        }), 
	        __metadata('design:paramtypes', [])
	    ], ContentWrapperComponent);
	    return ContentWrapperComponent;
	}());
	exports.ContentWrapperComponent = ContentWrapperComponent;


/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var translate_service_1 = __webpack_require__(70);
	var core_1 = __webpack_require__(3);
	var WegoAdminComponent = (function () {
	    function WegoAdminComponent(translate, authService, renderer) {
	        this.translate = translate;
	        this.authService = authService;
	        this.renderer = renderer;
	        this.toggleClass = "ui-skins sidebar-mini";
	        this.menu = [
	            {
	                title: 'LblDashboard',
	                icon: 'fa fa-tachometer fa-fw',
	                redirectPath: 'dashboard',
	            },
	            {
	                title: 'LblCustomer',
	                icon: 'fa fa-user-circle fa-fw',
	                redirectPath: 'customer/list',
	            },
	            {
	                title: 'LblRoleManagement',
	                icon: 'fa fa-cogs fa-fw',
	                redirectPath: 'role/list',
	            },
	            {
	                title: 'LblInstance',
	                icon: 'fa fa-bolt fa-fw',
	                redirectPath: 'instance/list',
	            },
	            {
	                title: 'LblBranding',
	                icon: 'fa fa-tag fa-fw',
	                redirectPath: 'branding',
	            },
	            {
	                title: 'LblPersons',
	                icon: 'fa fa-user fa-fw',
	                redirectPath: 'person/list',
	                items: [{
	                        title: 'LblPersonOverview',
	                        icon: '',
	                        redirectPath: 'person/list',
	                    },
	                    {
	                        title: 'LblWegoAdmins',
	                        icon: '',
	                        redirectPath: 'wegoadminlist/list',
	                    }
	                ]
	            },
	            {
	                title: 'LblCompanies',
	                icon: 'fa fa-building-o fa-fw',
	                redirectPath: 'company/list',
	            },
	            {
	                title: 'LblOrganization',
	                icon: 'fa fa-sitemap fa-fw',
	                redirectPath: 'organization/list',
	            },
	            {
	                title: 'LblVehicles',
	                icon: 'fa fa-cab fa-fw',
	                redirectPath: 'vehicle/list',
	                items: [{
	                        title: 'LblVehicleOverview',
	                        icon: '',
	                        redirectPath: 'vehicle/list',
	                    },
	                    {
	                        title: 'LblVTSVehicleList',
	                        icon: '',
	                        redirectPath: 'vtsvehicle/list',
	                    },
	                    {
	                        title: 'LblTroubleShootVTS',
	                        icon: '',
	                        redirectPath: 'vtstroubleshoot',
	                    },
	                    {
	                        title: 'LblVehicleAttributeCategories',
	                        icon: '',
	                        redirectPath: 'vehicleattributecategory/list',
	                    }, {
	                        title: 'LblVehicleAttributes',
	                        icon: '',
	                        redirectPath: 'vehicleattribute/list',
	                    },
	                    {
	                        title: 'LblOdometerLogTrail',
	                        icon: '',
	                        redirectPath: 'odometerlogtrail/list',
	                    }
	                ]
	            },
	            {
	                title: 'LblSharedVehicleGroups',
	                icon: 'fa fa-group fa-fw',
	                redirectPath: 'sharedvehiclegroup/list',
	                items: [{
	                        title: 'LblSharedVehicleGroupOverview',
	                        icon: '',
	                        redirectPath: 'sharedvehiclegroup/list',
	                    },
	                    {
	                        title: 'LblSpecialPeriods',
	                        icon: '',
	                        redirectPath: 'specialperiod/list',
	                    }
	                ]
	            },
	            {
	                title: 'LblDrivers',
	                icon: 'fa fa-male fa-fw',
	                redirectPath: 'driver/list',
	            },
	            // {
	            //   title: 'LblContractType',
	            //   icon: 'fa fa-money fa-fw',
	            //   redirectPath: 'contractType/list',
	            // },
	            {
	                title: 'LblBookings',
	                icon: 'fa fa-calendar fa-fw',
	                redirectPath: 'booking',
	                items: [
	                    {
	                        title: 'LblBookingsOverview',
	                        icon: '',
	                        redirectPath: 'booking/overview',
	                    },
	                    {
	                        title: 'LblNormal',
	                        icon: '',
	                        redirectPath: 'booking',
	                    },
	                    {
	                        title: 'LblSpecial',
	                        icon: '',
	                        redirectPath: 'specialbooking',
	                    },
	                    {
	                        title: 'LblTripSimulator',
	                        icon: '',
	                        redirectPath: 'bookingtriptest',
	                    },
	                ]
	            },
	            {
	                title: 'LblInvoicing',
	                icon: 'fa fa-file-text fa-fw',
	                redirectPath: 'invoice',
	                items: [{
	                        title: 'LblInvoices',
	                        icon: '',
	                        redirectPath: 'invoice/list',
	                    },
	                    {
	                        title: 'LblAdditionalFreeItemsMenu',
	                        icon: '',
	                        redirectPath: 'additionalfreeitem/list',
	                    }]
	            },
	            // {
	            //   title: 'LblServiceOffer',
	            //   icon: 'fa fa-star fa-fw',
	            //   redirectPath: 'serviceoffer/list',
	            // },
	            {
	                title: 'LblReports',
	                icon: 'fa fa-file-o fa-fw',
	                redirectPath: 'tripdetailreport',
	                items: [{
	                        title: 'LblVehicleOccupancyReport',
	                        icon: '',
	                        redirectPath: 'report/vehicleoccupancy',
	                    },
	                    {
	                        title: 'LblRevenuePerVehicleReport',
	                        icon: '',
	                        redirectPath: 'report/revenuepervehiclereport',
	                    },
	                    {
	                        title: 'LblTripDataReport',
	                        icon: '',
	                        redirectPath: 'tripdatareport/tripdatareport',
	                    }, {
	                        title: 'LblMaintenancePlanningreport',
	                        icon: '',
	                        redirectPath: 'report/maintenanceplanningreport',
	                    }, {
	                        title: 'LblSnailTrailReport',
	                        icon: '',
	                        redirectPath: 'report/snailtrail',
	                    }, {
	                        title: 'LblKickbackReport',
	                        icon: '',
	                        redirectPath: 'report/kickback',
	                    },
	                    {
	                        title: 'LblCostCenterReport',
	                        icon: '',
	                        redirectPath: 'report/costcenterreport'
	                    }]
	            },
	            {
	                title: 'LblTemplates',
	                icon: 'fa fa-file-code-o fa-fw',
	                redirectPath: 'template/list',
	            },
	            {
	                title: 'LblSignupForms',
	                icon: 'fa fa-pencil-square-o fa-fw',
	                redirectPath: 'signupform/list',
	                items: [{
	                        title: 'LblSignupFormsOverview',
	                        icon: '',
	                        redirectPath: 'signupform/list',
	                    },
	                    {
	                        title: 'LblSignupsOverView',
	                        icon: '',
	                        redirectPath: 'signup/list',
	                    }]
	            },
	            {
	                title: 'LblEventViewer',
	                icon: 'fa fa-file-text-o fa-fw',
	                redirectPath: 'eventviewer',
	            },
	            {
	                title: 'LblPrePostTripSetting',
	                icon: '',
	                redirectPath: 'preposttripquestion'
	            }
	        ];
	    }
	    WegoAdminComponent.prototype.ngOnInit = function () {
	        this.translate.setDetectedLang();
	    };
	    WegoAdminComponent.prototype.ToggleMenuLocal = function () {
	        if (window.innerWidth > 767) {
	            if (this.toggleClass == "ui-skins sidebar-mini")
	                this.toggleClass = "ui-skins sidebar-mini sidebar-collapse";
	            else if (this.toggleClass == "ui-skins sidebar-mini sidebar-collapse" || this.toggleClass == "ui-skins sidebar-mini sidebar-open")
	                this.toggleClass = "ui-skins sidebar-mini";
	        }
	        else {
	            if (this.toggleClass == "ui-skins sidebar-mini")
	                this.toggleClass = "ui-skins sidebar-mini sidebar-open";
	            else if (this.toggleClass == "ui-skins sidebar-mini sidebar-open" || this.toggleClass == "ui-skins sidebar-mini sidebar-collapse")
	                this.toggleClass = "ui-skins sidebar-mini";
	        }
	        // this.ApplyActiveMenuStyle();
	        // setTimeout(() => this.ApplyActiveMenuStyle(), 1000);
	    };
	    WegoAdminComponent.prototype.onResize = function (event) {
	        // console.log(event);
	        // console.log("width:" + event.target.innerWidth);
	        // console.log("height:" + event.target.innerHeight);
	    };
	    // private ApplyActiveMenuStyle() {
	    //   let isReset = this.toggleClass == "ui-skins sidebar-mini sidebar-collapse" ? false : true;
	    //   let defaultBackgroundColor: string = isReset ? null : "#303F9F";
	    //   let defaultTextColor: string = isReset ? null : "#FE4080";
	    //   let listToggle = document.querySelectorAll('.sidebar-menu>li>a>span:not(.pull-right)');
	    //   if (listToggle) {
	    //     for (var i = 0; i < listToggle.length; i++) {
	    //       this.renderer.setElementStyle(listToggle[i], 'background-color', defaultBackgroundColor);
	    //       this.renderer.setElementStyle(listToggle[i], 'color', defaultTextColor);
	    //     }
	    //   }
	    //   let listTreeViewMenu = document.querySelectorAll('.sidebar-menu>li>.treeview-menu');
	    //   if (listTreeViewMenu) {
	    //     for (var i = 0; i < listTreeViewMenu.length; i++) {
	    //       this.renderer.setElementStyle(listTreeViewMenu[i], 'background-color', defaultBackgroundColor);
	    //       // this.renderer.setElementStyle(listTreeViewMenu[i], 'color', defaultTextColor);
	    //     }
	    //   }
	    //   let listTreeViewMenuAnchorText = document.querySelectorAll('.sidebar-menu>li>.treeview-menu li a');
	    //   if (listTreeViewMenuAnchorText) {
	    //     for (var i = 0; i < listTreeViewMenuAnchorText.length; i++) {
	    //       //this.renderer.setElementStyle(listTreeViewMenuAnchorText[i], 'background-color', defaultBackgroundColor);
	    //       this.renderer.setElementStyle(listTreeViewMenuAnchorText[i], 'color', defaultTextColor);
	    //     }
	    //   }
	    // }
	    WegoAdminComponent.prototype.ngOnDestroy = function () { };
	    WegoAdminComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-admin',
	            template: "\n  <div class=\"admin-role\">\n    <div [class]=\"toggleClass\" (window:resize)=\"onResize($event)\" >\n      <wego-navbar (toggleMenu)=\"ToggleMenuLocal()\"></wego-navbar>\n      <wego-sidebar [menu]=\"menu\"></wego-sidebar>\n      <wego-content-wrapper></wego-content-wrapper>\n      <wego-footer></wego-footer>\n    </div>\n  </div>\n  ",
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof core_1.Renderer !== 'undefined' && core_1.Renderer) === 'function' && _c) || Object])
	    ], WegoAdminComponent);
	    return WegoAdminComponent;
	    var _a, _b, _c;
	}());
	exports.WegoAdminComponent = WegoAdminComponent;


/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var instance_model_1 = __webpack_require__(513);
	var instance_service_1 = __webpack_require__(500);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var cloneentity_model_1 = __webpack_require__(860);
	var InstanceListComponent = (function () {
	    function InstanceListComponent(instanceService, translate, authService, router, activeRoute) {
	        this.instanceService = instanceService;
	        this.translate = translate;
	        this.authService = authService;
	        this.router = router;
	        this.activeRoute = activeRoute;
	        this.isWegoAdmin = false;
	        //apiCloneErrorMsg: string='';
	        this.isCloneError = false;
	        this.customerHashID = "";
	        this.cloneNewInstanceName = '';
	        this.roleLevel = config_1.RoleLevel;
	        this.cloneExistingInstanceHashId = '';
	        this.cloneResult = false;
	    }
	    InstanceListComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.instanceModel = new instance_model_1.InstanceModel();
	        this.urlInstanceAdd = this.authService.GetURL(config_1.ApplicationRouteURL.URL_INSTANCE_ADD);
	        this.cloneEntityModel = new cloneentity_model_1.CloneEntityModel();
	        this.module = this.translate.instant('LblInstance');
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        if (this.authService.GetHighestRoleLevel() <= this.roleLevel.Customer) {
	            this.DataListModel.searchField = ["instanceName", "currencySymbol", "currencyAbbreviation", "description", "customerName"];
	        }
	        else {
	            this.DataListModel.searchField = ["instanceName", "currencySymbol", "currencyAbbreviation", "description"];
	        }
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlInstanceUpdate = this.authService.GetURL(config_1.ApplicationRouteURL.URL_INSTANCE_UPDATE);
	        this.urlInstanceAdminList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_ADMIN_OF_INSTANCE_LIST);
	        this.activeRoute
	            .params
	            .subscribe(function (params) {
	            var customerHashID = params['customerHashId'] || '';
	            if (customerHashID != '') {
	                _this.customerHashID = customerHashID;
	            }
	            else {
	                _this.customerHashID = "";
	            }
	            _this.GetInstanceList();
	        });
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	        this.addInstanceLink = new config_1.WeGoAuthorizedLink(this.urlInstanceAdd, config_1.Permission.PR_INSTANCE, config_1.PermissionType.INSERT, 'btn btn-highlight navbar-right', 'LblAddNew');
	    };
	    InstanceListComponent.prototype.GetInstanceList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.instanceService.GetInstanceList(this.DataListModel, this.customerHashID)
	            .subscribe(function (res) {
	            _this.instanceList = res.data;
	            _this.isWegoAdmin = _this.instanceList.length > 0 ? _this.instanceList[0].isWegoAdmin : false;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    InstanceListComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetInstanceList();
	    };
	    InstanceListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetInstanceList();
	    };
	    InstanceListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetInstanceList();
	    };
	    InstanceListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetInstanceList();
	    };
	    ;
	    InstanceListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.instanceService.ExportInstanceList(this.DataListModel, this.customerHashID)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "Instance" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    InstanceListComponent.prototype.DeleteInstance = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.instanceService.DeleteInstance(this.instanceHashId)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.DataListModel.currentPage = 1;
	                _this.GetInstanceList();
	                _this.popupMsg = _this.translate.instant('LblRecordRemovedSuccess', [_this.module]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblInstanceDeleteValidation');
	                _this.isLoading = false;
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	        //);
	    };
	    InstanceListComponent.prototype.onSubmitClone = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.isCloneError = false;
	        var formData = this.cloneEntityModel;
	        this.instanceService.CloneInstance(formData).subscribe(function (res) {
	            if (res.data) {
	                _this.cloneResult = true;
	                _this.cloneEntityList = res.data;
	                _this.isLoading = false;
	            }
	            else {
	                _this.isLoading = false;
	                if (res.error == null)
	                    _this.isCloneError = true;
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            //this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
	            _this.isCloneError = true;
	            _this.isLoading = false;
	        });
	    };
	    InstanceListComponent.prototype.cloneSuccessClick = function () {
	        this.cloneModel.hide();
	        this.GetInstanceList();
	    };
	    InstanceListComponent.prototype.ConfirmSuccessClick = function () {
	        this.confirmModal.hide();
	        this.DeleteInstance();
	    };
	    InstanceListComponent.prototype.ShowConfirmModal = function (instanceHashId) {
	        this.isLoading = false;
	        this.deleteMessage = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
	        this.confirmModal.show();
	        this.instanceHashId = instanceHashId;
	    };
	    InstanceListComponent.prototype.HideConfirmModal = function () {
	        this.confirmModal.hide();
	    };
	    InstanceListComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    InstanceListComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    InstanceListComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    InstanceListComponent.prototype.ShowCloneModal = function (cloneInstanceHashId) {
	        this.errorModel = [];
	        this.cloneEntityModel.newInstanceName = '';
	        this.cloneResult = false;
	        this.isCloneError = false;
	        this.cloneEntityModel.exstingInstanceHashId = cloneInstanceHashId;
	        this.cloneModel.show();
	    };
	    InstanceListComponent.prototype.HideCloneModal = function () {
	        this.cloneEntityModel.newInstanceName = '';
	        this.cloneModel.hide();
	    };
	    InstanceListComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    __decorate([
	        core_1.ViewChild('confirmModal'), 
	        __metadata('design:type', Object)
	    ], InstanceListComponent.prototype, "confirmModal", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], InstanceListComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild('cloneModel'), 
	        __metadata('design:type', Object)
	    ], InstanceListComponent.prototype, "cloneModel", void 0);
	    InstanceListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-instance',
	            template: __webpack_require__(861),
	            providers: [instance_service_1.InstanceService],
	            styles: [
	                ".modelCloneCustomClass {\n        width:85%;\n      }\n      .modelResultCustomClass {\n        \n      }\n      .cloneResultTableRow{\n        text-align: left;\n      }\n      .cloneResultDivClass{\n        width: 100%;\n        overflow:auto;\n        max-height: 274px;\n        margin-top:  15px;\n      }\n    "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof instance_service_1.InstanceService !== 'undefined' && instance_service_1.InstanceService) === 'function' && _a) || Object, (typeof (_b = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _e) || Object])
	    ], InstanceListComponent);
	    return InstanceListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.InstanceListComponent = InstanceListComponent;


/***/ },
/* 860 */
/***/ function(module, exports) {

	"use strict";
	var CloneEntityModel = (function () {
	    function CloneEntityModel() {
	    }
	    return CloneEntityModel;
	}());
	exports.CloneEntityModel = CloneEntityModel;


/***/ },
/* 861 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ breadCrumbList}} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li class=\"active\"> {{ breadCrumbList}} </li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25 \">      \r\n      <wego-authorized-link [LinkModel]=\"addInstanceLink\"></wego-authorized-link>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <wego-search-list (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\"\r\n          [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <p class=\"text-success\">{{ message }}</p>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('instanceName')\">\r\n                  {{ 'LblInstanceName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'instanceName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Customer\"  class=\"cursor-pointer\" (click)=\"OnSort('customerName')\">\r\n                  {{ 'LblCustomerName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'customerName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('currencySymbol')\">\r\n                  {{'LblCurrencySymbol' | translate}}\r\n                  <wego-sort-list [FieldName]=\"'currencySymbol'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('currencyAbbreviation')\">\r\n                  {{'LblCurrencyAbbreviation' | translate}}\r\n                  <wego-sort-list [FieldName]=\"'currencyAbbreviation'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('description')\">\r\n                  {{'LblDescription' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'description'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"text-center\">{{ 'LblAdmin' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblEdit' | translate }}</th>\r\n                <th *ngIf=\"isWegoAdmin\" class=\"text-center\">{{ 'LblClone' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblDelete' | translate }}</th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let instance of instanceList\">\r\n                  <td>{{ instance.instanceName }}</td>\r\n                  <td *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Customer\">{{ instance.customerName }}</td>\r\n                  <td>{{ instance.currencySymbol }}</td>\r\n                  <td>{{ instance.currencyAbbreviation }}</td>\r\n                  <td class=\"word-wrap\">{{ instance.description }}</td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"instance.isAdminCount\" class=\"btn btn-primary cursor-pointer link-style\" [routerLink]=\"urlInstanceAdminList +'/' +  instance.instanceHashId\">\r\n                      <span class=\"badge link-text\">{{ instance.adminCount }}</span>\r\n                    </a>\r\n\r\n                    <a *ngIf=\"!instance.isAdminCount\" class=\"btn btn-primary link-style\" disabled>\r\n                      <span class=\"badge link-text\">{{ instance.adminCount }}</span>\r\n                    </a>\r\n                  </td>\r\n                  <!-- [routerLink]=\"[urlInstanceUpdate, { instanceHashId : instance.instanceHashId }]\" -->\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"instance.isEditable\" [routerLink]=\"urlInstanceUpdate + '/' + instance.instanceHashId\">\r\n                      <i class=\"fa fa-pencil-square-o fa-fw\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td *ngIf=\"isWegoAdmin\" class=\"text-center\">\r\n                    <a class=\"cursor-pointer\" title=\"{{'LblClone' | translate}}\" (click)=\"ShowCloneModal(instance.instanceHashId)\">\r\n                      <i class=\"fa fa-clone fa-fw\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"instance.isDeletable\" class=\"cursor-pointer\" (click)=\"ShowConfirmModal(instance.instanceHashId)\">\r\n                      <i class=\"fa fa-trash-o fa-fw text-danger\"></i>\r\n                    </a>\r\n                  </td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"8\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n\r\n\r\n<div bsModal #cloneModel=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\"\r\n  [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div style=\"width: 45%;height: 90%;\" class=\"modal-dialog modal-sm\">\r\n    <div class=\"modal-content\" [ngClass]=\"{'modelResultCustomClass': cloneResult , 'modelCloneCustomClass': !cloneResult}\">\r\n      <div *ngIf=!cloneResult>\r\n        <div class=\"modal-header\">\r\n          <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"HideCloneModal()\">\r\n            <span aria-hidden=\"true\">&times;</span>\r\n          </button>\r\n          <h4 class=\"modal-title\">{{ 'LblInstanceClone' | translate }}</h4>\r\n        </div>\r\n        <form #cloneInstanceForm=\"ngForm\" (ngSubmit)=\"onSubmitClone()\">\r\n          <div class=\"modal-body\">\r\n            <div class=\"row\">\r\n              <div class=\"col-xs-12 form-group\">\r\n                {{ 'LblNewInstanceName' | translate }}\r\n                <div class=\"clearfix\"></div>\r\n                <input type=\"text\" style=\"margin-top: 6px\" class=\"form-control\" id=\"cloneInstance\" name=\"cloneInstance\" [(ngModel)]=\"cloneEntityModel.newInstanceName\"\r\n                placeholder=\"New Instance\" />\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'newInstanceName' }}</span>\r\n              </div>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"modal-footer\">\r\n            <div class=\"row\">\r\n              <div class=\"col-xs-8 form-group\">\r\n                <button type=\"submit\" class=\"btn btn-green pull-left\">{{ 'LblClone' | translate }}</button>\r\n              </div>\r\n              <div class=\"clearfix\"></div>\r\n              <div *ngIf=\"isCloneError\">\r\n              <div class=\"form-Group col-md-12\" style=\"text-align:  left;\">\r\n                {{'LblCloneStatus' | translate}} :\r\n                <b style=\"color: #994545;\"> Error</b>\r\n              </div>\r\n\r\n              <div class=\"clearfix\"></div>\r\n              <div class=\"form-Group col-md-12\" style=\"margin-top:  6px;text-align:  left;color: #994545;\">\r\n               {{'CloneError' | translate }} \r\n              </div>\r\n            </div>\r\n            </div>\r\n          </div>\r\n        </form>\r\n      </div>\r\n      <div *ngIf=\"cloneResult\">\r\n        <div class=\"modal-header\">\r\n          <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"HideCloneModal()\">\r\n            <span aria-hidden=\"true\">&times;</span>\r\n          </button>\r\n          <h4 class=\"modal-title\">{{ 'LblCloneResult' | translate }}</h4>\r\n        </div>\r\n        <div class=\"modal-body\">\r\n          <div class=\"row\">\r\n            <div class=\"col-md-12\" style=\"margin-left: 15px;\">\r\n              {{'LblCloneStatus' | translate}} :<b style=color:green;> Success</b>\r\n            </div>\r\n          </div>\r\n          <div class=\"row\" class=\"cloneResultDivClass\">\r\n            <div class=\"col-md-12\">\r\n              <table class=\"table table-responsive table-hover\" style=\"width: 100%;\">\r\n                <thead>\r\n                </thead>\r\n                <tbody>\r\n                  <template [ngIf]=\"cloneEntityList.length != 0\">\r\n                    <tr *ngFor=\"let cloneResult of cloneEntityList\" class=\"cloneResultTableRow\">\r\n                      <td style=\"text-transform: capitalize\">{{cloneResult.clonedEntityResultSting}} </td>\r\n                      <td>\r\n                        <span class=\"badge badge-secondary\">{{cloneResult.totalClonedEntity}}</span>\r\n                      </td>\r\n                    </tr>\r\n                  </template>\r\n                </tbody>\r\n              </table>\r\n            </div>\r\n          </div>\r\n\r\n        </div>\r\n        <div class=\"modal-footer\">\r\n          <div class=\"row\">\r\n            <div class=\"col-xs-12 form-group\">\r\n              <button type=\"button\" (click)=\"cloneSuccessClick()\" class=\"btn btn-green pull-right\" style=\"margin-right: 25px;\">{{'LblOK'|translate}}</button>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<wego-confirm-popup #confirmModal [popupMsg]=\"deleteMessage\" (onConfirm)=\"ConfirmSuccessClick()\" (onReject)=\"HideConfirmModal()\"></wego-confirm-popup>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>";

/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var config_1 = __webpack_require__(60);
	var SearchListComponent = (function () {
	    function SearchListComponent() {
	        this.onSearch = new core_1.EventEmitter();
	        this.onExport = new core_1.EventEmitter();
	        this.onDeleteAll = new core_1.EventEmitter();
	        this.onCancelAll = new core_1.EventEmitter();
	        this.onCustomeButton = new core_1.EventEmitter();
	        this.onPagingChange = new core_1.EventEmitter();
	        this.isExported = true;
	        this.isDeleted = false;
	        this.isDeleteEnabled = false;
	        this.isCancel = false;
	        this.isCancelEnabled = false;
	        this.isCustomButton = false;
	        this.isCustomButtonEnabled = false;
	        this.searchTerm = '';
	    }
	    SearchListComponent.prototype.ngOnInit = function () {
	        this.itemPerPageList = config_1.WeGoConfig.GRID_PAGGING;
	        // let itemperPage = localStorage.getItem("itemsPerPage");
	        // if (itemperPage) {
	        //   this.itemPerPage = itemperPage
	        // }
	        // else {
	        // this.itemPerPage = WeGoConfig.GRID_MAX_DATA_SIZE;
	        // }
	    };
	    SearchListComponent.prototype.OnReset = function ($event) {
	        this.searchTerm = "";
	        this.onSearch.emit({ searchTerm: this.searchTerm, isReset: true });
	    };
	    SearchListComponent.prototype.OnSearch = function () {
	        this.onSearch.emit({ searchTerm: this.searchTerm, isReset: false });
	    };
	    SearchListComponent.prototype.OnExport = function ($event) {
	        this.onExport.emit($event);
	    };
	    SearchListComponent.prototype.OnPagingChange = function ($event) {
	        this.onPagingChange.emit({ itemPerPage: $event });
	        // localStorage.setItem('itemsPerPage', $event);
	    };
	    SearchListComponent.prototype.OnDeleteAll = function ($event) {
	        this.onDeleteAll.emit($event);
	    };
	    SearchListComponent.prototype.OnCancelAll = function ($event) {
	        this.onCancelAll.emit($event);
	    };
	    SearchListComponent.prototype.OnCustomeButton = function ($event) {
	        this.onCustomeButton.emit($event);
	    };
	    SearchListComponent.prototype.ngOnDestroy = function () { };
	    __decorate([
	        core_1.Output('OnSearch'), 
	        __metadata('design:type', Object)
	    ], SearchListComponent.prototype, "onSearch", void 0);
	    __decorate([
	        core_1.Output('OnExport'), 
	        __metadata('design:type', Object)
	    ], SearchListComponent.prototype, "onExport", void 0);
	    __decorate([
	        core_1.Output('OnDeleteAll'), 
	        __metadata('design:type', Object)
	    ], SearchListComponent.prototype, "onDeleteAll", void 0);
	    __decorate([
	        core_1.Output('OnCancelAll'), 
	        __metadata('design:type', Object)
	    ], SearchListComponent.prototype, "onCancelAll", void 0);
	    __decorate([
	        core_1.Output('OnCustomeButton'), 
	        __metadata('design:type', Object)
	    ], SearchListComponent.prototype, "onCustomeButton", void 0);
	    __decorate([
	        core_1.Output('OnPagingChange'), 
	        __metadata('design:type', Object)
	    ], SearchListComponent.prototype, "onPagingChange", void 0);
	    __decorate([
	        core_1.Input('IsExported'), 
	        __metadata('design:type', Boolean)
	    ], SearchListComponent.prototype, "isExported", void 0);
	    __decorate([
	        core_1.Input('IsDeleted'), 
	        __metadata('design:type', Boolean)
	    ], SearchListComponent.prototype, "isDeleted", void 0);
	    __decorate([
	        core_1.Input('IsDeleteEnabled'), 
	        __metadata('design:type', Boolean)
	    ], SearchListComponent.prototype, "isDeleteEnabled", void 0);
	    __decorate([
	        core_1.Input('IsCancel'), 
	        __metadata('design:type', Boolean)
	    ], SearchListComponent.prototype, "isCancel", void 0);
	    __decorate([
	        core_1.Input('IsCancelEnabled'), 
	        __metadata('design:type', Boolean)
	    ], SearchListComponent.prototype, "isCancelEnabled", void 0);
	    __decorate([
	        core_1.Input('IsCustomButton'), 
	        __metadata('design:type', Boolean)
	    ], SearchListComponent.prototype, "isCustomButton", void 0);
	    __decorate([
	        core_1.Input('IsCustomButtonEnabled'), 
	        __metadata('design:type', Boolean)
	    ], SearchListComponent.prototype, "isCustomButtonEnabled", void 0);
	    __decorate([
	        core_1.Input('Title'), 
	        __metadata('design:type', String)
	    ], SearchListComponent.prototype, "title", void 0);
	    __decorate([
	        core_1.Input('CustomeIcon'), 
	        __metadata('design:type', String)
	    ], SearchListComponent.prototype, "customIcon", void 0);
	    __decorate([
	        core_1.Input('SearchTerm'), 
	        __metadata('design:type', String)
	    ], SearchListComponent.prototype, "searchTerm", void 0);
	    __decorate([
	        core_1.Input('itemPerPageList'), 
	        __metadata('design:type', Object)
	    ], SearchListComponent.prototype, "itemPerPageList", void 0);
	    __decorate([
	        core_1.Input('ItemPerPage'), 
	        __metadata('design:type', Object)
	    ], SearchListComponent.prototype, "itemPerPage", void 0);
	    SearchListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-search-list',
	            template: "\n  <form (ngSubmit)=\"OnSearch()\" class=\"form-inline mar_bot_10\">\n    <div class=\"form-group\">\n      <div class=\"input-group\">\n        <input type=\"text\" class=\"form-control\" [(ngModel)]=\"searchTerm\" name=\"searchTerm\" autocomplete=\"off\" maxlength=\"100\">\n          <div class=\"input-group-btn\">\n            <button class=\"btn btn-default search-icon\" type=\"submit\">\n              <i class=\"fa fa-search\" aria-hidden=\"true\"></i>\n            </button>\n          </div>\n        </div>\n      </div>\n    <div class=\"form-group\">\n      <button class=\"btn btn-default reset-icon\" type=\"button\" (click)=\"OnReset($event)\">\n        <i class=\"fa fa-eraser\" aria-hidden=\"true\"></i>\n      </button>\n    </div>\n    <div *ngIf=\"isExported\" class=\"form-group\">\n      <button class=\"btn btn-default export-icon\" type=\"button\" (click)=\"OnExport($event)\" title=\"{{'LblExportAll(CSV)' | translate}}\">\n        <i class=\"fa fa-download\" aria-hidden=\"true\"></i>\n      </button>\n    </div>\n    <div *ngIf=\"isDeleted\" class=\"form-group\">\n      <button [disabled]=\"!isDeleteEnabled\" class=\"btn btn-default delete-icon\" type=\"button\" (click)=\"OnDeleteAll($event)\" title=\"{{'LblDeleteAllSelectedRecords' | translate}}\">\n        <i class=\"fa fa-trash-o\" aria-hidden=\"true\"></i>\n      </button>\n    </div>\n      <div *ngIf=\"isCancel\" class=\"form-group\">\n      <button [disabled]=\"!isCancelEnabled\" class=\"btn btn-default cancel-icon\" type=\"button\" (click)=\"OnCancelAll($event)\" title=\"{{'LblCancelAllSelectedRecords' | translate}}\">\n        <i class=\"fa fa-times\" aria-hidden=\"true\"></i>\n      </button>\n    </div>\n     <div *ngIf=\"isCustomButton\" class=\"form-group\">\n      <button [disabled]=\"!isCustomButtonEnabled\" class=\"btn btn-default add-icon\" type=\"button\" (click)=\"OnCustomeButton($event)\" [attr.title]=\"title\">\n        <i [ngClass]=\"customIcon\" aria-hidden=\"true\"></i>\n      </button>\n    </div>\n    <div class=\"form-group pull-right\">\n      <select class=\"form-control\" title='Items Per Page'  [(ngModel)]=\"itemPerPage\"  name=\"itemPerPage\" (change)=\"OnPagingChange($event.target.value)\">\n         <option *ngFor=\"let item of itemPerPageList\"  [attr.value]='item.value' >{{ item }}</option>\n      </select>\n    </div>\n  </form>\n  ",
	            styles: [
	                "\n    .search-icon {\n        color:#2ba2aa;\n    }\n    .reset-icon {\n        color:#DD9933;\n    }\n    .export-icon {\n        color:#01A2D9;\n    }\n    .delete-icon {\n        color:#f00;\n    }\n    .cancel-icon {\n        color:#f00;\n    }\n    .add-icon {\n        color:#080;\n    }\n    "
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], SearchListComponent);
	    return SearchListComponent;
	}());
	exports.SearchListComponent = SearchListComponent;


/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var SortListComponent = (function () {
	    function SortListComponent() {
	    }
	    SortListComponent.prototype.ngOnInit = function () {
	    };
	    SortListComponent.prototype.ngOnDestroy = function () { };
	    __decorate([
	        core_1.Input('SortType'), 
	        __metadata('design:type', Object)
	    ], SortListComponent.prototype, "sortType", void 0);
	    __decorate([
	        core_1.Input('SortReverse'), 
	        __metadata('design:type', Object)
	    ], SortListComponent.prototype, "sortReverse", void 0);
	    __decorate([
	        core_1.Input('FieldName'), 
	        __metadata('design:type', Object)
	    ], SortListComponent.prototype, "fieldName", void 0);
	    SortListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-sort-list',
	            styles: ["\n    .sort-icon {\n      float: right;\n      line-height: 22px;\n    }\n  "],
	            template: "\n  <span [hidden]=\"sortType == fieldName\" class=\"fa fa-sort fa-fw sort-icon\" style=\"color: #888;\"></span>\n  <span [hidden]=\"!(sortType == fieldName && !sortReverse)\" class=\"fa fa-sort-desc fa-fw sort-icon\"></span>\n  <span [hidden]=\"!(sortType == fieldName && sortReverse)\" class=\"fa fa-sort-asc fa-fw sort-icon\"></span>\n  ",
	        }), 
	        __metadata('design:paramtypes', [])
	    ], SortListComponent);
	    return SortListComponent;
	}());
	exports.SortListComponent = SortListComponent;


/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var backoffice_service_1 = __webpack_require__(865);
	var config_1 = __webpack_require__(60);
	var BackofficeComponent = (function () {
	    function BackofficeComponent(backOfficeService, router, authService) {
	        this.backOfficeService = backOfficeService;
	        this.router = router;
	        this.authService = authService;
	        this.roleList = [];
	    }
	    BackofficeComponent.prototype.ngOnInit = function () {
	        this.isLoading = true;
	        this.GetUserSettingByPersonHashID();
	    };
	    BackofficeComponent.prototype.GetUserSettingByPersonHashID = function () {
	        var _this = this;
	        this.backOfficeService.GetUserSettingByPersonHashID().subscribe(function (res) {
	            if (res.data) {
	                var userSetting = {
	                    firstName: res.data.firstName,
	                    lastName: res.data.lastName,
	                    middleName: res.data.middleName,
	                    highestEntityLevelRole: res.data.highestEntityLevelRole,
	                    instanceLanguage: res.data.instanceLanguage
	                };
	                _this.isTwoFaRequired = res.data.isTwoFaRequired;
	                localStorage.setItem('user_setting', JSON.stringify(userSetting));
	                localStorage.setItem('language', res.data.language);
	                localStorage.setItem('highest_role_level', res.data.highestRoleLevel);
	                localStorage.setItem('home_URL', res.data.adminHomeURL);
	                localStorage.setItem('TwoFa_method', res.data.selectedTwoFa);
	                localStorage.setItem('computerId', res.data.userComputerId);
	                _this.roleList = res.data.role;
	                _this.isDiverLicenceRequire =
	                    res.data.validateDriverLicence == 'REQUIRED' ? true : false;
	                _this.isValidateDriverIBAN = res.data.validateDriverIBAN;
	                _this.errorMessage = res.error;
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        }, function () {
	            if (_this.roleList) {
	                if (_this.roleList.length == 1) {
	                    _this.NavigateTo(_this.roleList[0]);
	                }
	            }
	            else {
	                _this.router.navigate(['/NotFound']);
	            }
	        });
	    };
	    BackofficeComponent.prototype.CheckAccountActivationTermsConditionStatus = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.authService.CheckAccountActivationTermsConditionStatus().subscribe(function (res) {
	            var isAccepted = res.data.accepted;
	            if (!isAccepted) {
	                var urlTermsAndConditions = config_1.ApplicationRouteURL.URL_TERMS_AND_CONDITION_POPUP;
	                _this.router.navigate([urlTermsAndConditions]);
	            }
	            else {
	                _this.CheckAccountActivationPrivacyStatementStatus();
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BackofficeComponent.prototype.CheckAccountActivationPrivacyStatementStatus = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.authService.CheckAccountActivationPrivacyStatus().subscribe(function (res) {
	            var isAccepted = res.data.accepted;
	            if (!isAccepted) {
	                var urlPrivacyStatement = config_1.ApplicationRouteURL.URL_PRIVACY_STATEMENT_POPUP;
	                _this.router.navigate([urlPrivacyStatement]);
	            }
	            else {
	                _this.HandleDriverNavigation();
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BackofficeComponent.prototype.NavigateTo = function (role) {
	        localStorage.setItem('current_role', role);
	        ChangeBranding();
	        if (role.toUpperCase() == 'WEGOADMIN') {
	            if (this.isTwoFaRequired) {
	                this.router.navigate([config_1.ApplicationRouteURL.URL_TWO_FA_SELECTION]);
	            }
	            else {
	                this.router.navigate(['/wegoadmin']);
	            }
	        }
	        else if (role.toUpperCase() == 'ADMIN') {
	            if (this.isTwoFaRequired) {
	                this.router.navigate([config_1.ApplicationRouteURL.URL_TWO_FA_SELECTION]);
	            }
	            else {
	                this.router.navigate(['/admin']);
	            }
	        }
	        else if (role.toUpperCase() == 'DRIVER') {
	            window.location.href = 'https://driver-portal.wego.app/login';
	        }
	        else {
	            this.router.navigate(['/underconstruction']);
	            localStorage.removeItem('current_role');
	        }
	    };
	    BackofficeComponent.prototype.HandleDriverNavigation = function () {
	        if (this.isDiverLicenceRequire) {
	            localStorage.removeItem('current_role');
	            this.router.navigate(['/validatedriverlicence/driverlicencedetail']);
	        }
	        else if (this.isValidateDriverIBAN) {
	            this.router.navigate([
	                '/driver/profile',
	                {
	                    personId: localStorage.getItem('personMasterHashId'),
	                    IBANNumberMessage: true
	                }
	            ]);
	        }
	        else {
	            this.router.navigate(['/driver']);
	        }
	    };
	    BackofficeComponent.prototype.ngOnDestroy = function () {
	        console.log('ngOnDestroy');
	    };
	    BackofficeComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-backoffice',
	            template: __webpack_require__(866),
	            providers: [backoffice_service_1.BackofficeService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof backoffice_service_1.BackofficeService !== 'undefined' && backoffice_service_1.BackofficeService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object])
	    ], BackofficeComponent);
	    return BackofficeComponent;
	    var _a, _b, _c;
	}());
	exports.BackofficeComponent = BackofficeComponent;


/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var config_1 = __webpack_require__(60);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var BackofficeService = (function () {
	    function BackofficeService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    BackofficeService.prototype.GetUserSettingByPersonHashID = function () {
	        var getRolesUrl = config_1.WeGoConfig.API_GET_USER_SETTING_BY_PERSON;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getRolesUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    BackofficeService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], BackofficeService);
	    return BackofficeService;
	    var _a, _b;
	}());
	exports.BackofficeService = BackofficeService;


/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div *ngIf=\"roleList && roleList.length > 1\">\r\n  <section class=\"login-bg\">\r\n    <div class=\"wrapper\" style=\"background-color: transparent;\">\r\n      <div class=\"container\" style=\"margin-top:120px\">\r\n        <div class=\"row\">\r\n          <div class=\"col-sm-5 login-center\">\r\n            <div class=\"login-panel panel-default\">\r\n              <div>\r\n                <form (ngSubmit)=\"onSubmit()\" #loginForm=\"ngForm\" method=\"post\">\r\n                  <fieldset>\r\n                    <div class=\"row\">\r\n                      <div class=\"center-block\">\r\n                        <img src=\"" + __webpack_require__(634) + "\" alt=\"\" class=\"img-responsive login-profile-img\">\r\n                        <h1 class=\"text-center login-text\" style=\"color:#fff;\">Login As</h1>\r\n                      </div>\r\n                    </div>\r\n                    <div class=\"row\">\r\n                      <div class=\"col-xs-12 col-sm-8 col-sm-offset-2\">\r\n                        <!-- <div>\r\n                        <a class=\"col-xs-12 btn btn-sm login-submit-button\" role=\"button\" (click)=\"NavigateTo('WEGOADMIN')\" style=\"padding: 3px 10px; font-size: 16px;\">\r\n                          Wego Admin Temp\r\n                        </a>\r\n                      </div> -->\r\n                       \r\n                        <div *ngFor=\"let item of roleList\">\r\n                          <a class=\"col-xs-12 btn btn-sm login-submit-button\" role=\"button\" (click)=\"NavigateTo(item)\" style=\"padding: 3px 10px; font-size: 16px;\">\r\n                          {{ item }}\r\n                        </a>\r\n                       \r\n                        </div>\r\n                        <template [ngIf]=\"roleList.length == 0\">\r\n                          <p class=\"text-center\" style=\"color: white;\">\r\n                            Currently you are not assigned with any role. Please go back to\r\n                            <a class=\"cursor-pointer\" routerLink=\"/\">Login</a> page.\r\n                          </p>\r\n                        </template>\r\n                      </div>\r\n                    </div>\r\n                  </fieldset>\r\n                </form>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>";

/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var translate_service_1 = __webpack_require__(70);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var trip_service_1 = __webpack_require__(868);
	var trip_overviewlist_model_1 = __webpack_require__(869);
	var config_1 = __webpack_require__(60);
	var moment = __webpack_require__(84);
	var TripHistoryComponent = (function () {
	    function TripHistoryComponent(authService, tripService, router, translate) {
	        this.authService = authService;
	        this.tripService = tripService;
	        this.router = router;
	        this.translate = translate;
	        this.model = new trip_overviewlist_model_1.TripOverviewList();
	    }
	    TripHistoryComponent.prototype.ngOnInit = function () {
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlDriverTripInformation = this.authService.GetURL(config_1.ApplicationRouteURL.URL_TRIP_INFORMATION_DRIVER);
	        this.GetTripHistory();
	    };
	    TripHistoryComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetTripHistory();
	    };
	    TripHistoryComponent.prototype.GetTripHistory = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.tripService
	            .GetTripHistoryList(this.DataListModel)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.tripList = res.data;
	                _this.DataListModel.totalItems = res.totalRecords;
	                _this.DataListModel.infoMessage = res.error;
	                _this.isLoading = false;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    TripHistoryComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetTripHistory();
	    };
	    TripHistoryComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetTripHistory();
	    };
	    TripHistoryComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    TripHistoryComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-trip-history',
	            template: __webpack_require__(870),
	            providers: [trip_service_1.TripService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof trip_service_1.TripService !== 'undefined' && trip_service_1.TripService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object])
	    ], TripHistoryComponent);
	    return TripHistoryComponent;
	    var _a, _b, _c, _d;
	}());
	exports.TripHistoryComponent = TripHistoryComponent;


/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var TripService = (function () {
	    function TripService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    TripService.prototype.GetTripHistoryList = function (input) {
	        var getTripHistoryUrl = config_1.WeGoConfig.API_GET_TRIP_HISTORY_LIST;
	        var queryStringDataListModel = this.authService.HandleAPIListInput(input);
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        getTripHistoryUrl =
	            getTripHistoryUrl + '?' + queryStringDataListModel;
	        return this.http
	            .get(getTripHistoryUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    TripService.prototype.GetTripInformationByHashId = function (tripHashId) {
	        var gettripUrl = config_1.WeGoConfig.API_GET_TRIP_INFORMATION + '?tripHashId=' + tripHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(gettripUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    TripService.prototype.SaveTripAnswer = function (prePostTripDetails) {
	        var body = prePostTripDetails;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_TRIP_ANSWER, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    TripService.prototype.GetHeaderX = function (accept, content) {
	        var acceptType = accept || "application/json";
	        var contentType = content || "application/json";
	        var access_token = localStorage.getItem("access_token");
	        var authorization = access_token ? "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0ZW5hbnRJZCI6IjI4MGJiYmZlLTY1NjUtMTFlYi04YjlkLTJmYzEzOWRhOWE3MyIsInVzZXJJZCI6ImJiZDhmMzJiLTI0OTctNDVkMi05ZjZmLWFiMzZiZTY3MmY2NiIsImJhY2tvZmZpY2VJZCI6IjE1OTkwIiwicGVybWlzc2lvbnMiOiJBZGFwdGVyR2F0ZXdheS5MaXN0QWRhcHRlcnMsQm9va2luZy5DcmVhdGVCb29raW5nLERhbWFnZS5SZXBvcnREYW1hZ2UsRGFtYWdlLkdldERhbWFnZSxEYW1hZ2UuTGlzdERhbWFnZXMsQm9va2luZy5TdGFydEJvb2tpbmciLCJiYWNrb2ZmaWNlUm9sZUlkcyI6IiIsIm5iZiI6MTY0MTIxODA1NCwiZXhwIjoxNjQxMjQ2ODU0LCJpYXQiOjE2NDEyMTgwNTR9.PH0vGsVCjwu3ndy029pjnFK0z8H23_5ZHEyrvClMse4" : "";
	        var language = localStorage.getItem("language");
	        var accept_language = language ? language : "en";
	        var refresh = localStorage.getItem("refresh_token");
	        var refresh_token = refresh ? refresh : "";
	        var currentRole = localStorage.getItem("current_role");
	        var current_role = currentRole ? currentRole : "";
	        var computerId = localStorage.getItem("computerId");
	        var headers = new http_1.Headers({
	            "Content-Type": contentType,
	            Accept: acceptType,
	            Authorization: authorization,
	            "Accept-Language": accept_language,
	            RefreshToken: refresh_token,
	            CurrentRole: current_role,
	            ComputerId: computerId
	        });
	        return headers;
	    };
	    TripService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], TripService);
	    return TripService;
	    var _a, _b;
	}());
	exports.TripService = TripService;


/***/ },
/* 869 */
/***/ function(module, exports) {

	"use strict";
	var TripOverviewList = (function () {
	    function TripOverviewList() {
	    }
	    return TripOverviewList;
	}());
	exports.TripOverviewList = TripOverviewList;


/***/ },
/* 870 */
/***/ function(module, exports) {

	module.exports = "<section class=\"banner-img-in\">\n  <div class=\"banner-in\">\n    <div class=\"search-bg-in\">\n      <div class=\"container-fluid\">\n        <div class=\"row\" style=\"padding-right:15px;\">\n          <div class=\"col-md-3 col-sm-6\">\n            <h2 class=\"pagename\">{{ 'LblTripHistory' | translate }}</h2>\n          </div>\n        </div>\n        <div class=\"clearfix\"></div>\n      </div>\n    </div>\n  </div>\n</section>\n<div class=\"clearfix\"></div>\n<section class=\"content\">\n  <div class=\"container-fluid mar-top-25\">\n    <div class=\"table-responsive\">\n      <table class=\"table table-bordered mar_bot_ziro\">\n        <thead>\n          <tr>\n            <th class=\"cursor-pointer\" (click)=\"OnSort('isQuestionAnswered')\">\n              &nbsp;\n            </th>\n            <th class=\"cursor-pointer\" (click)=\"OnSort('licenceTag')\">\n              {{ 'LblVehicle' | translate }}\n              <wego-sort-list [FieldName]=\"'licenceTag'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\n            </th>\n            <th class=\"cursor-pointer\" (click)=\"OnSort('startDateTime')\">\n              {{ 'LblFrom' | translate }}\n              <wego-sort-list [FieldName]=\"'startDateTime'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\n            </th>\n            <th class=\"cursor-pointer\" (click)=\"OnSort('endDateTime')\">\n              {{ 'LblTo' | translate }}\n              <wego-sort-list [FieldName]=\"'endDateTime'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\n            </th>\n            <th class=\"cursor-pointer\" (click)=\"OnSort('distanceInMeters')\">\n              {{ 'LblTotalKm' | translate }}\n              <wego-sort-list [FieldName]=\"'distanceInMeters'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\n            </th>\n          </tr>\n        </thead>\n        <tbody>\n          <template [ngIf]=\"DataListModel.totalItems != 0\">\n            <tr *ngFor=\"let trip of tripList\">\n              <td class=\"text-center\">\n                <i *ngIf=\"!trip.isAnswered\" class=\"fa fa-times fa-fw red\" title=\"{{ trip.nrOpenAnswers }} {{ 'LblUnansweredQuestions' | translate }}\"></i>\n                <i *ngIf=\"trip.isAnswered\" class=\"fa fa-check fa-fw green\" title=\"{{ 'LblNoUnansweredQuestions' | translate }}\"></i>\n              </td>\n              <td>{{ trip.licensePlate }}</td>\n              <td>{{ trip.startDateTime | date: 'dd-MM-yyyy HH:mm' }}</td>\n              <td>{{ trip.endDateTime | date: 'dd-MM-yyyy HH:mm' }}</td>\n              <td>{{ trip.distanceInMeters/1000 | number : '1.2-2' }}</td>\n              <td class=\"text-center\">\n                <a class=\"cursor-pointer\" title=\"{{'LblTripDetails' | translate}}\" [routerLink]=\"[ urlDriverTripInformation, { tripHashId:trip.tripHashId }]\">\n                  <i *ngIf=\"!trip.isAnswered\" class=\"fa fa-edit fa-fw\"></i>\n                  <i *ngIf=\"trip.isAnswered\" class=\"fa fa-eye fa-fw\"></i>\n                </a>\n              </td>\n            </tr>\n          </template>\n          <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\n            <td class=\"text-center text-danger\" colspan=\"6\">\n              {{ 'LblNoTripsFound' | translate }}\n            </td>\n          </tr>\n        </tbody>\n      </table>\n    </div>\n    <div class=\"clearfix\"></div>\n    <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\n      <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\n        <div class=\"col-md-12\">\n          <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\n            [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\n            lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\n        </div>\n      </div>\n    </div>\n  </div>\n</section>\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>";

/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var trip_information_model_1 = __webpack_require__(872);
	var auth_service_1 = __webpack_require__(58);
	var translate_service_1 = __webpack_require__(70);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var trip_service_1 = __webpack_require__(868);
	var common_1 = __webpack_require__(22);
	var DriverTripInformationComponent = (function () {
	    function DriverTripInformationComponent(authService, tripService, translate, activeRoute, locationService) {
	        this.authService = authService;
	        this.tripService = tripService;
	        this.translate = translate;
	        this.activeRoute = activeRoute;
	        this.locationService = locationService;
	        this.submitted = false;
	    }
	    DriverTripInformationComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.model = new trip_information_model_1.TripInformation();
	        this.sub = this.activeRoute.params.subscribe(function (params) {
	            _this.tripHashId = params['tripHashId'] || '';
	            if (_this.tripHashId != '') {
	                _this.GetTripInformation();
	            }
	        });
	    };
	    DriverTripInformationComponent.prototype.GetTripInformation = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.tripService
	            .GetTripInformationByHashId(this.tripHashId)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.model = res.data;
	                _this.isLoading = false;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    DriverTripInformationComponent.prototype.OnBackClick = function () {
	        this.locationService.back();
	    };
	    DriverTripInformationComponent.prototype.SaveTripAnswerClick = function (PrePostTripDetails) {
	        var _this = this;
	        if (PrePostTripDetails.answer == undefined ||
	            PrePostTripDetails.answer == null ||
	            PrePostTripDetails.answer.length == 0) {
	            this.popupTitle = this.translate.instant('LblWarning');
	            this.popupMsg = this.translate.instant('LblAnswerEmptyError');
	            this.ShowValidationModal();
	            return;
	        }
	        this.tripService.SaveTripAnswer(PrePostTripDetails)
	            .subscribe(function (res) {
	            _this.popupTitle = _this.translate.instant('LblSuccess');
	            _this.popupMsg = _this.translate.instant('LblAnswerSaved');
	            _this.ShowSuccessPopup();
	        }, function (error) {
	            _this.popupTitle = _this.translate.instant('LblWarning');
	            _this.popupMsg = _this.translate.instant('LblAnswerSavedError');
	            _this.ShowSuccessPopup();
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    DriverTripInformationComponent.prototype.ConfirmSuccessPopup = function () {
	        if (this.tripHashId != '') {
	            this.GetTripInformation();
	        }
	    };
	    DriverTripInformationComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    DriverTripInformationComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    DriverTripInformationComponent.prototype.ShowValidationModal = function () {
	        this.validationModal.show();
	    };
	    DriverTripInformationComponent.prototype.HideValidationModal = function () {
	        this.validationModal.hide();
	    };
	    DriverTripInformationComponent.prototype.KeyOfObject = function (obj) {
	        return Object.keys(obj);
	    };
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], DriverTripInformationComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild('validationModal'), 
	        __metadata('design:type', Object)
	    ], DriverTripInformationComponent.prototype, "validationModal", void 0);
	    DriverTripInformationComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-driver-tripinformation',
	            template: __webpack_require__(873),
	            providers: [trip_service_1.TripService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof trip_service_1.TripService !== 'undefined' && trip_service_1.TripService) === 'function' && _b) || Object, (typeof (_c = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object, (typeof (_e = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _e) || Object])
	    ], DriverTripInformationComponent);
	    return DriverTripInformationComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.DriverTripInformationComponent = DriverTripInformationComponent;


/***/ },
/* 872 */
/***/ function(module, exports) {

	"use strict";
	var TripInformation = (function () {
	    function TripInformation() {
	    }
	    return TripInformation;
	}());
	exports.TripInformation = TripInformation;
	var PrePostTripDetails = (function () {
	    function PrePostTripDetails() {
	    }
	    return PrePostTripDetails;
	}());
	exports.PrePostTripDetails = PrePostTripDetails;


/***/ },
/* 873 */
/***/ function(module, exports) {

	module.exports = "\n  <section class=\"banner-img-in\">\n    <div class=\"banner-in\">\n      <div class=\"search-bg-in\">\n        <div class=\"container-fluid\">\n          <div class=\"row\" style=\"padding-right:15px;\">\n            <div class=\"col-md-3 col-sm-6\">\n              <h2 class=\"pagename\">{{ 'LblTripHistory' | translate }}</h2>\n            </div>\n          </div>\n          <div class=\"clearfix\"></div>\n        </div>\n      </div>\n    </div>\n  </section>\n\n  <div class=\"clearfix\"></div>\n\n  <section class=\"content\">\n    <div class=\"container-fluid mar-top-25\">\n      <fieldset>\n        <legend class=\"legendStyle\">\n          {{ 'LblTripDetail' | translate }}\n        </legend>\n        <div class=\"clearfix\"></div>\n        <div class=\"row\">\n          <div class=\"col-sm-4 col-xs-4\">\n            <label>{{ 'LblVehicle' | translate }} :</label> {{ model.licensePlate }}\n          </div>\n          <div class=\"col-sm-8 col-xs-8\">\n            <label>{{ 'LblTripStartDateTime' | translate }} :</label> {{ model.startDateTime | date: 'dd-MM-yyyy HH:mm' }}\n          </div>\n          <div class=\"col-sm-4 col-xs-4\">\n            <label>{{ 'LblTotalKm' | translate }} :</label> {{ model.distanceInMeters/1000 | number : '1.2-2' }}\n          </div>\n          <div class=\"col-sm-8 col-xs-8\">\n            <label>{{ 'LblTripEndDateTime' | translate }} :</label> {{ model.endDateTime | date: 'dd-MM-yyyy HH:mm' }}\n          </div>\n        </div>\n      </fieldset>\n      <br />\n      <!-- prepost trip details -->\n      <fieldset>\n        <legend class=\"legendStyle\">\n          {{ 'LblFaZTripQuestions' | translate }}\n        </legend>\n        <div class=\"table table-responsive mar_bot_ziro borderless\">\n          <table class=\"table table-bordered mar_bot_ziro answers\">\n            <thead>\n              <tr>\n                <th>\n                  {{ 'LblQuestion' | translate }}\n                </th>\n                <th>\n                  {{ 'LblAnswer' | translate }}\n                </th>\n              </tr>\n            </thead>\n            <tbody *ngIf=\"model.prePostTripInformation && model.prePostTripInformation.length > 0\">\n              <tr *ngFor=\"let prePostAnswer of model.prePostTripInformation\">\n                <td>\n                  {{ prePostAnswer.question }}\n                </td>\n                <td>\n                  <div class=\"form-group\">\n                    <div class=\"col-sm-10\">\n                      <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblAnswer' | translate }}\" [(ngModel)]=\"prePostAnswer.answer\"\n                        name=\"answer\" [disabled]=\"prePostAnswer.isAnswered\">\n                    </div>\n                    <a class=\"btn btn-default btn-save cursor-pointer\" (click)=\"SaveTripAnswerClick(prePostAnswer)\" *ngIf=\"!prePostAnswer.isAnswered\">\n                      <span><i class=\"fa fa-floppy-o fa-lg\" aria-hidden=\"true\" title=\"{{ 'LblSave' | translate }}\"></i></span>\n                    </a>\n                    <a class=\"btn btn-default cursor-pointer remark\" title=\"{{ 'LblRemarks' | translate }}\" popover-placement=\"top\" popover=\"{{ prePostAnswer.remarks }}\" *ngIf=\"prePostAnswer.remarks\">\n                      <span><i class=\"fa fa-search fa-lg\" aria-hidden=\"true\" title=\"{{ 'LblRemarks' | translate }}\"></i></span>\n                    </a>\n                  </div>\n                </td>\n              </tr>\n            </tbody>\n            <tbody *ngIf=\"model.prePostTripInformation && model.prePostTripInformation.length == 0\">\n              <tr>\n                <td class=\"text-center text-danger\" colspan=\"2\">{{ 'LblNoQuestionsFound' | translate }}</td>\n              </tr>\n            </tbody>\n          </table>\n        </div>\n      </fieldset>\n      <!-- End prepost trip details -->\n    </div>\n  </section>\n\n  <div class=\"row no-margin\">\n    <div class=\"col-sm-12\">\n      <hr>\n      <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnBackClick()\">{{ 'LblBack' | translate }}</a>\n    </div>\n  </div>\n\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\n\n<wego-success-popup #successPopup [popupTitle]=\"popupTitle\" [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\n\n<wego-success-popup #validationModal [popupTitle]=\"popupTitle\" [popupMsg]=\"popupMsg\" (onConfirm)=\"HideValidationModal()\"></wego-success-popup>\n\n<wego-success-popup #errorPopup [popupTitle]=\"popupTitle\" [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmErrorPopup()\"></wego-success-popup>\n";

/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var LodderComponent = (function () {
	    function LodderComponent() {
	    }
	    LodderComponent.prototype.ngOnInit = function () { };
	    __decorate([
	        core_1.Input('isLoading'), 
	        __metadata('design:type', Boolean)
	    ], LodderComponent.prototype, "isLoading", void 0);
	    LodderComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-lodder',
	            template: "<div [hidden]=\"!isLoading\" class=\"my-loading\">\n                <div class=\"dimmer\"></div>\n                <div class=\"loading-bg\">\n                    <i class=\"fa fa-refresh fa-spin fa-3x fa-fw\" style=\"color: #000;\"></i>\n                </div>\n             </div>",
	            styles: ["\n    .my-loading {\n      position: fixed;\n      top: 0;\n      left: 0;\n      bottom: 0%;\n      right: 0%;\n      text-align: center;\n      z-index: 9999;\n    }\n    \n    .my-loading .dimmer {\n      position: absolute;\n      top: 0;\n      left: 0;\n      background-color: #000;\n      opacity: 0.5;\n      width: 100%;\n      height: 100%;\n    }\n    \n    .my-loading .loading-bg {\n      position: absolute;\n      display: inline-block;\n      top: 50%;\n      left: -webkit-calc(50% - 40px);\n      left: -moz-calc(50% - 40px);\n      left: calc(50% - 40px);\n      transform: translateY(-50%);\n      padding: 22px;\n      background-color: #fff;\n      border-radius: 15px;\n      text-align: center;\n    }\n  "]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], LodderComponent);
	    return LodderComponent;
	}());
	exports.LodderComponent = LodderComponent;


/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var PopupLodderComponent = (function () {
	    function PopupLodderComponent() {
	    }
	    PopupLodderComponent.prototype.ngOnInit = function () { };
	    __decorate([
	        core_1.Input('isLoading'), 
	        __metadata('design:type', Boolean)
	    ], PopupLodderComponent.prototype, "isLoading", void 0);
	    PopupLodderComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-popup-lodder',
	            template: "<div [hidden]=\"!isLoading\" class=\"my-loading\">\n                <div class=\"dimmer\"></div>\n                <div class=\"loading-bg\">\n                    <i class=\"fa fa-refresh fa-spin fa-3x fa-fw\" style=\"color: #000;\"></i>\n                </div>\n             </div>",
	            styles: ["\n    .my-loading {\n      position: absolute;\n      top: 0;\n      left: 0;\n      bottom: 0%;\n      right: 0%;\n      text-align: center;\n      z-index: 9999;\n    }\n    \n    .my-loading .dimmer {\n      position: absolute;\n      top: 0;\n      left: 0;\n      background-color: #000;\n      opacity: 0.5;\n      width: 100%;\n      height: 100%;\n    }\n    \n    .my-loading .loading-bg {\n      position: absolute;\n      display: inline-block;\n      top: 50%;\n      left: -webkit-calc(50% - 40px);\n      left: -moz-calc(50% - 40px);\n      left: calc(50% - 40px);\n      transform: translateY(-50%);\n      padding: 22px;\n      background-color: #fff;\n      border-radius: 15px;\n      text-align: center;\n    }\n  "]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], PopupLodderComponent);
	    return PopupLodderComponent;
	}());
	exports.PopupLodderComponent = PopupLodderComponent;


/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var config_1 = __webpack_require__(60);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var NotFoundComponent = (function () {
	    function NotFoundComponent(authService) {
	        this.authService = authService;
	    }
	    NotFoundComponent.prototype.ngOnInit = function () {
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	    };
	    NotFoundComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-notfound',
	            template: "\n  <section class=\"content\">\n  <div class=\"col-md-12 text-center\">\n\t\t<div class=\"panel panel-danger\">\n      <div class=\"panel-heading\">\n      Page not found\n      </div>\n      <div class=\"panel-body\"><p>\n          Page not found!! We are unable to find the page you are looking for. \n          Please navigate to the <a [routerLink]=\"urlDefaultPage\">Home</a> page.\n          </p></div>\n    </div>\n    </div>\n  </section>\n  ",
	            styles: [".headerror {\n                font-size: 150px !important;\n                font-weight: normal;\n                line-height: 100px;\n                margin-top: 50px;\n                color: #2ba2aa;\n          }"]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], NotFoundComponent);
	    return NotFoundComponent;
	    var _a;
	}());
	exports.NotFoundComponent = NotFoundComponent;


/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var config_1 = __webpack_require__(60);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var PrivacyNotAllowComponent = (function () {
	    function PrivacyNotAllowComponent(authService) {
	        this.authService = authService;
	    }
	    PrivacyNotAllowComponent.prototype.ngOnInit = function () {
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	    };
	    PrivacyNotAllowComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-privacy-not-allow',
	            template: "\n  <section class=\"content\">\n  <div class=\"col-md-12 text-center\">\n    <div class=\"panel panel-danger\">\n      <div class=\"panel-heading\">\n      {{ 'LblPrivacyError' | translate }}\n      </div>\n      <div class=\"panel-body\">\n        <p>\n        {{ 'LblPrivacyErrorMessage' | translate }}\n        {{ 'LblPrivacyNavigate' | translate }}&nbsp;<a [routerLink]=\"urlDefaultPage\">{{ 'LblHome' | translate }}</a> page.\n        </p>\n      </div>\n    </div>\n    </div>\n  </section>\n  ",
	            styles: [".headerror {\n                font-size: 150px !important;\n                font-weight: normal;\n                line-height: 100px;\n                margin-top: 50px;\n                color: #2ba2aa;\n          }"]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], PrivacyNotAllowComponent);
	    return PrivacyNotAllowComponent;
	    var _a;
	}());
	exports.PrivacyNotAllowComponent = PrivacyNotAllowComponent;


/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var auth_service_1 = __webpack_require__(58);
	var UnAuthenticatedComponent = (function () {
	    function UnAuthenticatedComponent(authService) {
	        this.authService = authService;
	    }
	    UnAuthenticatedComponent.prototype.ngOnInit = function () {
	        this.authService.Logout();
	    };
	    UnAuthenticatedComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-unauthenticated',
	            template: "\n  <section class=\"content\">\n  <div class=\"col-md-12 text-center\">\n\t<div class=\"panel panel-danger\">\n      <div class=\"panel-heading\">\n      Session Timeout\n      </div>\n      <div class=\"panel-body\"><p>\n           Your session has expired due to no activities on website. Please\n            <a routerLink=\"/\">Login</a> again.\n          </p></div>\n    </div>\n    </div>\n  </section>\n  ",
	            styles: [".headerror {\n                font-size: 150px !important;\n                font-weight: normal;\n                line-height: 100px;\n                margin-top: 50px;\n                color: #2ba2aa;\n          }"]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object])
	    ], UnAuthenticatedComponent);
	    return UnAuthenticatedComponent;
	    var _a;
	}());
	exports.UnAuthenticatedComponent = UnAuthenticatedComponent;


/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var UnAuthorizedComponent = (function () {
	    function UnAuthorizedComponent() {
	    }
	    UnAuthorizedComponent.prototype.ngOnInit = function () { };
	    UnAuthorizedComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-unauthorized',
	            template: "\n  <section class=\"content\">\n    <div class=\"col-md-12 text-center\">\n\t<div class=\"panel panel-danger\">\n      <div class=\"panel-heading\">\n      Access Denied\n      </div>\n      <div class=\"panel-body\"> <p>\n           You don\u2019t have an access to this page. Please try again with different user Role. Thank you!!\n            <a routerLink=\"/\">Login</a> again.\n          </p>\n    </div>\n    </div>\n    </div>\n  </section>\n  ",
	            styles: [".headerror {\n                font-size: 150px !important;\n                font-weight: normal;\n                line-height: 100px;\n                margin-top: 50px;\n                color: #2ba2aa;\n          }"]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], UnAuthorizedComponent);
	    return UnAuthorizedComponent;
	}());
	exports.UnAuthorizedComponent = UnAuthorizedComponent;


/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_guard_admin_service_1 = __webpack_require__(25);
	var snail_trail_component_1 = __webpack_require__(64);
	var branding_component_1 = __webpack_require__(199);
	var terms_condition_list_component_1 = __webpack_require__(881);
	var vehicle_occupancy_component_1 = __webpack_require__(503);
	var admin_dashboard_component_1 = __webpack_require__(512);
	var odometerlogtrail_update_component_1 = __webpack_require__(527);
	var odometerlogtrail_list_component_1 = __webpack_require__(532);
	var language_herlper_component_1 = __webpack_require__(535);
	var vtshistory_list_component_1 = __webpack_require__(545);
	var event_viewer_component_1 = __webpack_require__(548);
	var vehiclefuturebooking_list_component_1 = __webpack_require__(552);
	var tripdetailreport_components_1 = __webpack_require__(555);
	var import_person_csv_component_1 = __webpack_require__(884);
	var vehicle_information_component_1 = __webpack_require__(560);
	var svgdriver_list_component_1 = __webpack_require__(569);
	var booking_overview_driver_component_1 = __webpack_require__(572);
	var booking_driver_component_1 = __webpack_require__(590);
	var driver_profile_component_1 = __webpack_require__(596);
	var driver_dashboard_component_1 = __webpack_require__(600);
	var inbox_driver_component_1 = __webpack_require__(608);
	var driver_role_component_1 = __webpack_require__(618);
	var personprofilesuccess_componets_1 = __webpack_require__(630);
	var personprofile_componets_1 = __webpack_require__(636);
	var link_expired_compontnet_1 = __webpack_require__(643);
	var underconstruction_component_1 = __webpack_require__(642);
	var booking_approve_component_1 = __webpack_require__(696);
	var changepasswordsuccess_component_1 = __webpack_require__(648);
	var changepassword_component_1 = __webpack_require__(650);
	var forgotpassword_component_1 = __webpack_require__(644);
	// import { VehicleSVGListComponent } from "./vehicle/components/vehicle-svg-list.component";
	var auth_guard_cadmin_service_1 = __webpack_require__(854);
	var auth_guard_gadmin_service_1 = __webpack_require__(853);
	var auth_guard_driveradmin_service_1 = __webpack_require__(852);
	var inbox_component_1 = __webpack_require__(658);
	var booking_history_component_1 = __webpack_require__(694);
	var booking_information_component_1 = __webpack_require__(700);
	var booking_information2_component_1 = __webpack_require__(707);
	var booking_information3_component_1 = __webpack_require__(709);
	var driver_bookinginformation_component_1 = __webpack_require__(711);
	var gadmin_component_1 = __webpack_require__(652);
	var cadmin_component_1 = __webpack_require__(653);
	var template_update_component_1 = __webpack_require__(661);
	var userprofile_componets_1 = __webpack_require__(666);
	var booking_overview_component_1 = __webpack_require__(689);
	var booking_request_component_1 = __webpack_require__(691);
	var booking_component_1 = __webpack_require__(698);
	var special_booking_component_1 = __webpack_require__(715);
	var invoice_list_component_1 = __webpack_require__(722);
	var invoice_legacy_list_component_1 = __webpack_require__(718);
	var contractType_update_component_1 = __webpack_require__(728);
	var contractType_list_component_1 = __webpack_require__(732);
	var contracttypegroup_update_component_1 = __webpack_require__(736);
	var contracttypegroup_list_component_1 = __webpack_require__(739);
	var sharedvehiclegroup_update_component_1 = __webpack_require__(741);
	var sharedvehicelsubscription_update_component_1 = __webpack_require__(751);
	var sharedvehiclesubscription_list_component_1 = __webpack_require__(755);
	var subscriptionavailabilityrestriction_list_component_1 = __webpack_require__(757);
	var subscriptionavailabilityrestriction_update_component_1 = __webpack_require__(759);
	var svgvehicle_list_component_1 = __webpack_require__(762);
	var sharedvehiclegroupadmin_list_component_1 = __webpack_require__(770);
	var driversubscription_list_component_1 = __webpack_require__(773);
	var driverSVG_list_component_1 = __webpack_require__(775);
	var additionalfreeitems_update_component_1 = __webpack_require__(886);
	var additionalfreeitems_list_component_1 = __webpack_require__(890);
	var template_list_component_1 = __webpack_require__(779);
	var wegoadmin_list_component_1 = __webpack_require__(784);
	var sharedvehiclegroup_list_component_1 = __webpack_require__(788);
	var driver_list_component_1 = __webpack_require__(790);
	var specialperiod_update_component_1 = __webpack_require__(792);
	var specialperiod_list_component_1 = __webpack_require__(796);
	var vehicleattributecategory_update_component_1 = __webpack_require__(804);
	var vehicleattributecategory_list_component_1 = __webpack_require__(807);
	var vehicleattribute_update_component_1 = __webpack_require__(798);
	var vehicleattribute_list_component_1 = __webpack_require__(802);
	var vehicle_update_component_1 = __webpack_require__(809);
	var vtsvehicle_update_component_1 = __webpack_require__(814);
	var vtsvehicle_list_component_1 = __webpack_require__(816);
	var vehicle_list_component_1 = __webpack_require__(812);
	var trip_history_component_1 = __webpack_require__(867);
	var driver_tripinformation_component_1 = __webpack_require__(871);
	var config_1 = __webpack_require__(60);
	var companyAdmin_list_component_1 = __webpack_require__(822);
	var company_update_component_1 = __webpack_require__(824);
	var company_list_component_1 = __webpack_require__(834);
	var person_update_component_1 = __webpack_require__(836);
	var person_list_component_1 = __webpack_require__(839);
	var instance_update_component_1 = __webpack_require__(841);
	var instance_list_component_1 = __webpack_require__(859);
	var auth_guard_wadmin_service_1 = __webpack_require__(855);
	var auth_guard_service_1 = __webpack_require__(856);
	var wegoadmin_component_1 = __webpack_require__(858);
	var backoffice_component_1 = __webpack_require__(864);
	var driverlicencedetail_component_1 = __webpack_require__(892);
	var unauthorized_component_1 = __webpack_require__(879);
	var unauthenticated_component_1 = __webpack_require__(878);
	var notfound_component_1 = __webpack_require__(876);
	var login_component_1 = __webpack_require__(896);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var vts_troubleshoot_component_1 = __webpack_require__(899);
	var signup_component_1 = __webpack_require__(902);
	var signupformconfig_update_compnent_1 = __webpack_require__(908);
	var signupformconfig_list_component_1 = __webpack_require__(910);
	var signup_list_component_1 = __webpack_require__(912);
	var language_herlper_api_component_1 = __webpack_require__(526);
	var directdebit_file_list_component_1 = __webpack_require__(916);
	var batch_upload_person_component_1 = __webpack_require__(919);
	var maintenance_planning_component_1 = __webpack_require__(922);
	var revenue_per_vehicle_component_1 = __webpack_require__(925);
	var tripdatareport_component_1 = __webpack_require__(928);
	var organization_update_component_1 = __webpack_require__(934);
	var organization_list_component_1 = __webpack_require__(937);
	var organizationAdmin_list_component_1 = __webpack_require__(939);
	var orgadmin_component_1 = __webpack_require__(942);
	var auth_guard_orgadmin_service_1 = __webpack_require__(943);
	var organizationdriver_list_component_1 = __webpack_require__(944);
	var privacy_not_allow_component_1 = __webpack_require__(877);
	var customer_list_component_1 = __webpack_require__(946);
	var customer_update_component_1 = __webpack_require__(948);
	var role_list_component_1 = __webpack_require__(951);
	var role_update_component_1 = __webpack_require__(954);
	var roleavailability_list_component_1 = __webpack_require__(957);
	var admin_of_customer_list_component_1 = __webpack_require__(961);
	var admin_of_instance_list_component_1 = __webpack_require__(965);
	var admin_invitation_component_1 = __webpack_require__(968);
	var admin_invitation_accept_component_1 = __webpack_require__(972);
	var admin_invitation_reject_component_1 = __webpack_require__(973);
	var admin_of_comapny_list_component_1 = __webpack_require__(974);
	var admin_of_sharedvehiclegroup_list_component_1 = __webpack_require__(977);
	var admin_of_organization_list_component_1 = __webpack_require__(980);
	var organization_subscription_list_component_1 = __webpack_require__(983);
	var organization_driver_list_component_1 = __webpack_require__(986);
	var admin_component_1 = __webpack_require__(989);
	var auth_guard_home_page_service_1 = __webpack_require__(990);
	var errorlog_list_component_1 = __webpack_require__(991);
	var errorescalation_list_component_1 = __webpack_require__(995);
	var interfacestatus_list_component_1 = __webpack_require__(999);
	var errorescalation_update_component_1 = __webpack_require__(1003);
	var invoice_update_component_1 = __webpack_require__(1005);
	var cost_expenses_list_components_1 = __webpack_require__(1009);
	var kickback_component_1 = __webpack_require__(1012);
	var cost_expenses_driver_list_components_1 = __webpack_require__(1015);
	var invoice_payment_history_component_1 = __webpack_require__(1017);
	var terms_condition_update_component_1 = __webpack_require__(1019);
	var terms_condition_popup_component_1 = __webpack_require__(1021);
	var cost_center_report_component_1 = __webpack_require__(1024);
	var snail_trail_driver_component_1 = __webpack_require__(1028);
	var tc_activity_log_driver_component_1 = __webpack_require__(1032);
	var pre_post_trip_question_component_1 = __webpack_require__(743);
	var pre_post_trip_question_overview_components_1 = __webpack_require__(1034);
	var privacy_statement_popup_component_1 = __webpack_require__(1038);
	var creditcard_payment_success_component_1 = __webpack_require__(1040);
	var creditcard_payment_failure_component_1 = __webpack_require__(1043);
	var two_fa_selection_1 = __webpack_require__(1045);
	var two_fa_google_setup_1 = __webpack_require__(1048);
	var two_fa_email_otp_1 = __webpack_require__(1050);
	var routes = [
	    {
	        path: "",
	        component: login_component_1.LoginComponent
	    },
	    {
	        path: "backoffice",
	        component: backoffice_component_1.BackofficeComponent
	    },
	    {
	        path: "twofaselection",
	        component: two_fa_selection_1.TwoFASelectionPopupComponent
	    },
	    {
	        path: "twofagooglesetup",
	        component: two_fa_google_setup_1.TwoFAGoogleSetupPopupComponent
	    },
	    {
	        path: "twofaemailotp",
	        component: two_fa_email_otp_1.TwoFAEmailOTPPopupComponent
	    },
	    {
	        path: "termsconditionpopup/popup",
	        component: terms_condition_popup_component_1.ViewTermsAndConditionPopupComponent
	    },
	    {
	        path: "privacystatement/popup",
	        component: privacy_statement_popup_component_1.ViewPrivacyStatementPopupComponent
	    },
	    {
	        path: "validatedriverlicence/driverlicencedetail",
	        component: driverlicencedetail_component_1.DriverLicenceComponent
	    },
	    {
	        path: "NotFound",
	        component: notfound_component_1.NotFoundComponent
	    },
	    {
	        path: "Unauthenticated",
	        component: unauthenticated_component_1.UnAuthenticatedComponent
	    },
	    {
	        path: "Unauthorized",
	        component: unauthorized_component_1.UnAuthorizedComponent
	    },
	    {
	        path: "admin",
	        component: admin_component_1.AdminComponent,
	        canActivate: [auth_guard_service_1.AuthGuard],
	        children: [
	            {
	                path: "",
	                // redirectTo: ApplicationRouteURL.URL_DASHBOARD_PAGE,
	                // canActivate: [AuthGuard]
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_home_page_service_1.HomePageAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_DASHBOARD_PAGE,
	                component: admin_dashboard_component_1.AdminDashboardComponent,
	                data: {
	                    permission: config_1.Permission.PR_DASHBOARD,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ORGANIZATION_LIST,
	                component: organization_list_component_1.OrganizationListComponent,
	                data: {
	                    permission: config_1.Permission.PR_ORGANIZATION_OVERVIEW,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ORGANIZATION_ADD,
	                data: {
	                    permission: config_1.Permission.PR_ORGANIZATION_OVERVIEW,
	                    permissionType: config_1.PermissionType.INSERT
	                },
	                component: organization_update_component_1.OrganizationUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ORGANIZATION_UPDATE + "/:id",
	                data: {
	                    permission: config_1.Permission.PR_ORGANIZATION_OVERVIEW,
	                    permissionType: config_1.PermissionType.EDIT
	                },
	                component: organization_update_component_1.OrganizationUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_COMPANY_LIST,
	                component: company_list_component_1.CompanyListComponent,
	                data: {
	                    permission: config_1.Permission.PR_COMPANY_OVERVIEW,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_COMPANY_ADD,
	                data: {
	                    permission: config_1.Permission.PR_COMPANY_OVERVIEW,
	                    permissionType: config_1.PermissionType.INSERT
	                },
	                component: company_update_component_1.CompanyUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_COMPANY_UPDATE + "/:id",
	                data: {
	                    permission: config_1.Permission.PR_COMPANY_OVERVIEW,
	                    permissionType: config_1.PermissionType.EDIT
	                },
	                component: company_update_component_1.CompanyUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SVG_LIST,
	                component: sharedvehiclegroup_list_component_1.SharedVehicleGroupListComponent,
	                data: {
	                    permission: config_1.Permission.PR_SHARED_VEHICLE_GROUP_OVERVIEW,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SVG_ADD,
	                data: {
	                    permission: config_1.Permission.PR_SHARED_VEHICLE_GROUP_OVERVIEW,
	                    permissionType: config_1.PermissionType.INSERT
	                },
	                component: sharedvehiclegroup_update_component_1.SharedVehicleGroupUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SVG_UPDATE + "/:id",
	                data: {
	                    permission: config_1.Permission.PR_SHARED_VEHICLE_GROUP_OVERVIEW,
	                    permissionType: config_1.PermissionType.EDIT
	                },
	                component: sharedvehiclegroup_update_component_1.SharedVehicleGroupUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ADMIN_OF_COMPANY_LIST + "/:id",
	                data: {
	                    permission: config_1.Permission.PR_COMPANY_ADMIN,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: admin_of_comapny_list_component_1.AdminOfCompanyListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_CUSTOMER_LIST,
	                component: customer_list_component_1.CustomerListComponent,
	                data: {
	                    permission: config_1.Permission.PR_CUSTOMER_OVERVIEW,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_CUSTOMER_ADD,
	                data: {
	                    permission: config_1.Permission.PR_CUSTOMER_OVERVIEW,
	                    permissionType: config_1.PermissionType.INSERT
	                },
	                component: customer_update_component_1.CustomerUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_CUSTOMER_UPDATE + "/:id",
	                data: {
	                    permission: config_1.Permission.PR_CUSTOMER_OVERVIEW,
	                    permissionType: config_1.PermissionType.EDIT
	                },
	                component: customer_update_component_1.CustomerUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ADMIN_OF_INSTANCE_LIST + "/:id",
	                data: {
	                    permission: config_1.Permission.PR_INSTANCE_ADMIN_OVERVIEW,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: admin_of_instance_list_component_1.AdminOfInstanceListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_INSTANCE_LIST,
	                data: {
	                    permission: config_1.Permission.PR_INSTANCE,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: instance_list_component_1.InstanceListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_INSTANCE_UPDATE + "/:id",
	                data: {
	                    permission: config_1.Permission.PR_INSTANCE,
	                    permissionType: config_1.PermissionType.EDIT
	                },
	                component: instance_update_component_1.InstanceUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_INSTANCE_ADD,
	                data: {
	                    permission: config_1.Permission.PR_INSTANCE,
	                    permissionType: config_1.PermissionType.INSERT
	                },
	                component: instance_update_component_1.InstanceUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ADMIN_OF_CUSTOMER_LIST + "/:id",
	                data: {
	                    permission: config_1.Permission.PR_CUSTOMER_ADMIN_OVERVIEW,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: admin_of_customer_list_component_1.AdminOfCustomerListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ADMIN_OF_ORGANIZATION_LIST + "/:id",
	                data: {
	                    permission: config_1.Permission.PR_ORGANIZATION_ADMIN_OVERVIEW,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: admin_of_organization_list_component_1.AdminOfOrganizationListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ADMIN_OF_SHAREDVEHICLEGROUP_LIST + "/:id",
	                data: {
	                    permission: config_1.Permission.PR_SHARED_VEHICLE_GROUP_ADMIN_OVERVIEW,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: admin_of_sharedvehiclegroup_list_component_1.AdminOfsharedVehicleGroupListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_PERSON_LIST,
	                data: {
	                    permission: config_1.Permission.PR_PERSON_OVERVIEW,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: person_list_component_1.PersonListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_PERSON_ADD,
	                data: {
	                    permission: config_1.Permission.PR_PERSON_OVERVIEW,
	                    permissionType: config_1.PermissionType.INSERT
	                },
	                component: person_update_component_1.PersonUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_PERSON_UPDATE + "/:id",
	                data: {
	                    permission: config_1.Permission.PR_PERSON_OVERVIEW,
	                    permissionType: config_1.PermissionType.EDIT
	                },
	                component: person_update_component_1.PersonUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ORGANIZATION_TO_SUBSCRIPTION_LIST + "/:id",
	                data: {
	                    permission: config_1.Permission.PR_ORGANIZATION_SUBSCRIPTION_OVERVIEW,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: organization_subscription_list_component_1.OrganizationSubscriptionComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VTSVEHICLE_LIST,
	                data: {
	                    permission: config_1.Permission.PR_VTS_VEHICLE_LIST,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: vtsvehicle_list_component_1.VtsVehicleListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VTSVEHICLE_ADD,
	                data: {
	                    permission: config_1.Permission.PR_VTS_VEHICLE_LIST,
	                    permissionType: config_1.PermissionType.INSERT
	                },
	                component: vtsvehicle_update_component_1.VtsVehicleUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VTSVEHICLE_UPDATE + "/:id",
	                data: {
	                    permission: config_1.Permission.PR_VTS_VEHICLE_LIST,
	                    permissionType: config_1.PermissionType.EDIT
	                },
	                component: vtsvehicle_update_component_1.VtsVehicleUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ORGANIZATION_TO_DRIVER_LIST + "/:id",
	                data: {
	                    permission: config_1.Permission.PR_ORGANIZATION_DRIVER_OVERVIEW,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: organization_driver_list_component_1.OrganizationDriverListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VEHICLE_LIST,
	                data: {
	                    permission: config_1.Permission.PR_VEHICLES_OVERVIEW,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: vehicle_list_component_1.VehicleListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VEHICLE_INFO + "/:id",
	                data: {
	                    permission: config_1.Permission.PR_VEHICLES_OVERVIEW,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: vehicle_information_component_1.VehicleInformationComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VEHICLE_ADD,
	                data: {
	                    permission: config_1.Permission.PR_VEHICLES_OVERVIEW,
	                    permissionType: config_1.PermissionType.INSERT
	                },
	                component: vehicle_update_component_1.VehicleUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VEHICLE_UPDATE + "/:id",
	                data: {
	                    permission: config_1.Permission.PR_VEHICLES_OVERVIEW,
	                    permissionType: config_1.PermissionType.EDIT
	                },
	                component: vehicle_update_component_1.VehicleUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VEHICLE_UPDATE + "/:id/:isCloneMode",
	                data: {
	                    permission: config_1.Permission.PR_VEHICLES_OVERVIEW,
	                    permissionType: config_1.PermissionType.INSERT
	                },
	                component: vehicle_update_component_1.VehicleUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SUBSCRIPTION_LIST + "/:id",
	                data: {
	                    permission: config_1.Permission.PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: sharedvehiclesubscription_list_component_1.SubscriptionListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SUBSCRIPTION_UPDATE +
	                    "/:sharedVehicleGroupHashId/:subscriptionHashId",
	                data: {
	                    permission: config_1.Permission.PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW,
	                    permissionType: config_1.PermissionType.INSERT
	                },
	                component: sharedvehicelsubscription_update_component_1.SubscriptionUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SUBSCRIPTION_ADD,
	                data: {
	                    permission: config_1.Permission.PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW,
	                    permissionType: config_1.PermissionType.INSERT
	                },
	                component: sharedvehicelsubscription_update_component_1.SubscriptionUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ERRORLOG_List,
	                component: errorlog_list_component_1.ErrorLogListComponent,
	                data: {
	                    permission: config_1.Permission.PR_ERRORLOG,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ERROR_ESCALATION_LIST,
	                component: errorescalation_list_component_1.ErrorEscalationComponent,
	                data: {
	                    permission: config_1.Permission.PR_ERRORESCALATION_OVERVIEW,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ERROR_ESCALATION_UPDATE + "/:id",
	                component: errorescalation_update_component_1.ErrorEscalationUpdateComponent,
	                data: {
	                    permission: config_1.Permission.PR_ERRORESCALATION_OVERVIEW,
	                    permissionType: config_1.PermissionType.EDIT
	                },
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ERROR_ESCALATION_ADD,
	                component: errorescalation_update_component_1.ErrorEscalationUpdateComponent,
	                data: {
	                    permission: config_1.Permission.PR_ERRORESCALATION_OVERVIEW,
	                    permissionType: config_1.PermissionType.INSERT
	                },
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_INTERFACESTATUS_List,
	                component: interfacestatus_list_component_1.InterfaceStatusListComponent,
	                data: {
	                    permission: config_1.Permission.PR_INTERFACE_STATUS,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VEHICLEATTRIBUTE_LIST,
	                data: {
	                    permission: config_1.Permission.PR_VEHICLE_ATTRIBUTE,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: vehicleattribute_list_component_1.VehicleAttributeListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VEHICLEATTRIBUTE_UPDATE + "/:id",
	                data: {
	                    permission: config_1.Permission.PR_VEHICLE_ATTRIBUTE,
	                    permissionType: config_1.PermissionType.EDIT
	                },
	                component: vehicleattribute_update_component_1.VehicleAttributeUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VEHICLEATTRIBUTE_ADD,
	                data: {
	                    permission: config_1.Permission.PR_VEHICLE_ATTRIBUTE,
	                    permissionType: config_1.PermissionType.INSERT
	                },
	                component: vehicleattribute_update_component_1.VehicleAttributeUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VEHICLEATTRIBUTE_CATEGORY_LIST,
	                data: {
	                    permission: config_1.Permission.PR_VEHICLE_ATTRIBUTE_CATEGORIES,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: vehicleattributecategory_list_component_1.VehicleAttributeCategoryListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VEHICLEATTRIBUTE_CATEGORY_ADD,
	                data: {
	                    permission: config_1.Permission.PR_VEHICLE_ATTRIBUTE_CATEGORIES,
	                    permissionType: config_1.PermissionType.INSERT
	                },
	                component: vehicleattributecategory_update_component_1.VehicleAttributeCategoryUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VEHICLEATTRIBUTE_CATEGORY_UPDATE + "/:id",
	                data: {
	                    permission: config_1.Permission.PR_VEHICLE_ATTRIBUTE_CATEGORIES,
	                    permissionType: config_1.PermissionType.EDIT
	                },
	                component: vehicleattributecategory_update_component_1.VehicleAttributeCategoryUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ADDITIONALFREEITEM_LIST,
	                data: {
	                    permission: config_1.Permission.PR_ADDITIONAL_FREE_ITEMS,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: additionalfreeitems_list_component_1.AdditionalFreeItemListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ADDITIONALFREEITEM_ADD,
	                data: {
	                    permission: config_1.Permission.PR_ADDITIONAL_FREE_ITEMS,
	                    permissionType: config_1.PermissionType.INSERT
	                },
	                component: additionalfreeitems_update_component_1.AdditionalFreeItemsUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VTS_TROUBLESHOOT,
	                data: {
	                    permission: config_1.Permission.PR_VTS_TROUBLESHOOT,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: vts_troubleshoot_component_1.VTSTroubleshootComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VTS_TROUBLESHOOT + "/:id",
	                data: {
	                    permission: config_1.Permission.PR_VTS_TROUBLESHOOT,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: vts_troubleshoot_component_1.VTSTroubleshootComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VTS_HISTORY_LIST,
	                data: {
	                    permission: config_1.Permission.PR_VTS_TROUBLESHOOT,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: vtshistory_list_component_1.VTSHistoryListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SUBSCRIPTIONAVAILABILITY_LIST + "/:id",
	                data: {
	                    permission: config_1.Permission.PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_AVAILIBILTY_RESTRICTION_OVERVIEW,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: subscriptionavailabilityrestriction_list_component_1.SubscriptionAvailabilityListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SUBSCRIPTIONAVAILABILITY_UPDATE +
	                    "/:sharedVehicleGroupSubscriptionHashId/:subscriptionAvailabiltiyHashId/:sharedVehicleGroupHashId",
	                data: {
	                    permission: config_1.Permission.PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_AVAILIBILTY_RESTRICTION_OVERVIEW,
	                    permissionType: config_1.PermissionType.EDIT
	                },
	                component: subscriptionavailabilityrestriction_update_component_1.SubscriptionaAvailabilityUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SUBSCRIPTIONAVAILABILITY_ADD +
	                    "/:sharedVehicleGroupSubscriptionHashId/:sharedVehicleGroupHashId",
	                data: {
	                    permission: config_1.Permission.PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_AVAILIBILTY_RESTRICTION_OVERVIEW,
	                    permissionType: config_1.PermissionType.INSERT
	                },
	                component: subscriptionavailabilityrestriction_update_component_1.SubscriptionaAvailabilityUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_TEMPLATE_LIST,
	                data: {
	                    permission: config_1.Permission.PR_TEMPLATES,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: template_list_component_1.TemplateListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_TEMPLATE_UPDATE + "/:id",
	                data: {
	                    permission: config_1.Permission.PR_TEMPLATES,
	                    permissionType: config_1.PermissionType.EDIT
	                },
	                component: template_update_component_1.TemplateUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_TEMPLATE_ADD,
	                data: {
	                    permission: config_1.Permission.PR_TEMPLATES,
	                    permissionType: config_1.PermissionType.INSERT
	                },
	                component: template_update_component_1.TemplateUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_TERMS_AND_CONDITION_UPDATE + "/:id",
	                data: {
	                    permission: config_1.Permission.PR_TERMS_AND_CONDITION,
	                    permissionType: config_1.PermissionType.EDIT
	                },
	                component: terms_condition_update_component_1.TermsAndConditionAddUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_TERMS_AND_CONDITION_ADD,
	                data: {
	                    permission: config_1.Permission.PR_TERMS_AND_CONDITION,
	                    permissionType: config_1.PermissionType.INSERT
	                },
	                component: terms_condition_update_component_1.TermsAndConditionAddUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BOOKING_INVOICE_LIST,
	                data: {
	                    permission: config_1.Permission.PR_INVOICE,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: invoice_list_component_1.InvoiceListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BOOKING_INVOICE_LEGACY_LIST,
	                data: {
	                    permission: config_1.Permission.PR_INVOICE,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: invoice_legacy_list_component_1.InvoiceLegacyListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_DIRECTDEBIT_LIST,
	                data: {
	                    permission: config_1.Permission.PR_DIRECT_DEBIT_FILE,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: directdebit_file_list_component_1.DirectDebitFileListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ODOMETERLOGTRAIL_LIST,
	                data: {
	                    permission: config_1.Permission.PR_ODOMETER_LOG_TRAIL,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: odometerlogtrail_list_component_1.OdometerLogTrailListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ODOMETERLOGTRAIL_ADD,
	                data: {
	                    permission: config_1.Permission.PR_ODOMETER_LOG_TRAIL,
	                    permissionType: config_1.PermissionType.INSERT
	                },
	                component: odometerlogtrail_update_component_1.OdometerLogTrailUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ODOMETERLOGTRAIL_UPDATE + "/:id",
	                data: {
	                    permission: config_1.Permission.PR_ODOMETER_LOG_TRAIL,
	                    permissionType: config_1.PermissionType.EDIT
	                },
	                component: odometerlogtrail_update_component_1.OdometerLogTrailUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SIGNUPFORM_LIST,
	                data: {
	                    permission: config_1.Permission.PR_SIGNUP_FORMS_OVERVIEW,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: signupformconfig_list_component_1.SignupFormConfigListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SIGNUPFORM_UPDATE + "/:id",
	                data: {
	                    permission: config_1.Permission.PR_SIGNUP_FORMS_OVERVIEW,
	                    permissionType: config_1.PermissionType.EDIT
	                },
	                component: signupformconfig_update_compnent_1.SignupFormConfigUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SIGNUPFORM_ADD,
	                data: {
	                    permission: config_1.Permission.PR_SIGNUP_FORMS_OVERVIEW,
	                    permissionType: config_1.PermissionType.INSERT
	                },
	                component: signupformconfig_update_compnent_1.SignupFormConfigUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_DRIVER_LIST,
	                data: {
	                    permission: config_1.Permission.PR_DRIVER_OVERVIEW,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: driver_list_component_1.DriverListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BOOKING_OVERVIEW,
	                data: {
	                    permission: config_1.Permission.PR_BOOKINGS_OVERVIEW,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: booking_overview_component_1.BookingOverviewComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BOOKING_REQUEST,
	                data: {
	                    permission: config_1.Permission.PR_BOOKINGS_REQUEST,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: booking_request_component_1.BookingRequestComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SVGVEHICLE_LIST,
	                data: {
	                    permission: config_1.Permission.PR_SHARED_VEHICLE_GROUP_VEHICLE_OVERVIEW,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: svgvehicle_list_component_1.SVGVehicleComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SIGNUP_LIST,
	                data: {
	                    permission: config_1.Permission.PR_SIGNUPS_OVERVIEW,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: signup_list_component_1.SignupListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_CONTRACT_TYPE_GROUP_LIST,
	                data: {
	                    permission: config_1.Permission.PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_GROUP_OVERVIEW,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: contracttypegroup_list_component_1.ContractTypeGroupListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_CONTRACT_TYPE__GROUP_ADD + "/:svgHashId",
	                data: {
	                    permission: config_1.Permission.PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_GROUP_OVERVIEW,
	                    permissionType: config_1.PermissionType.INSERT
	                },
	                component: contracttypegroup_update_component_1.ContractTypeGroupUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_CONTRACT_TYPE__GROUP_UPDATE +
	                    "/:svgHashId/:ctgHashId",
	                data: {
	                    permission: config_1.Permission.PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_GROUP_OVERVIEW,
	                    permissionType: config_1.PermissionType.EDIT
	                },
	                component: contracttypegroup_update_component_1.ContractTypeGroupUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_CONTRACT_TYPE_LIST,
	                data: {
	                    permission: config_1.Permission.PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_OVERVIEW,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: contractType_list_component_1.ContractTypeListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_CONTRACT_TYPE_ADD +
	                    "/:sharedVehicleGroupHashId" +
	                    "/:contractTypeGroupHashId",
	                data: {
	                    permission: config_1.Permission.PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_OVERVIEW,
	                    permissionType: config_1.PermissionType.INSERT
	                },
	                component: contractType_update_component_1.ContractTypeUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_CONTRACT_TYPE_UPDATE +
	                    "/:sharedVehicleGroupHashId" +
	                    "/:contractTypeGroupHashId" +
	                    "/:contractTypeHashId",
	                data: {
	                    permission: config_1.Permission.PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_OVERVIEW,
	                    permissionType: config_1.PermissionType.EDIT
	                },
	                component: contractType_update_component_1.ContractTypeUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_DRIVER_SVG_LIST + "/:id",
	                data: {
	                    permission: config_1.Permission.PR_DRIVER_SHARED_VEHICLE_GROUP_OVERVIEW,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: driverSVG_list_component_1.DriverSVGListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_MAINTENANCE_PLANNING_REPORT,
	                data: {
	                    permission: config_1.Permission.PR_MAINTENANCE_PLANNING_REPORT,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: maintenance_planning_component_1.MaintenancePlanningReportComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_REVENUE_PER_VEHICLE_REPORT,
	                data: {
	                    permission: config_1.Permission.PR_REVENUE_PER_VEHICLE_REPORT,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: revenue_per_vehicle_component_1.RevenuepervehicleReportComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_TRIPDATA_REPORT,
	                data: {
	                    permission: config_1.Permission.PR_TRIP_DATA_REPORT,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: tripdatareport_component_1.TripDataReportComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VEHICLE_OCCUPANCY_REPORT,
	                data: {
	                    permission: config_1.Permission.PR_VEHICLE_OCCUPANCY_REPORT,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: vehicle_occupancy_component_1.VehicleOccupancy,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SNAIL_TRAIL_REPORT,
	                data: {
	                    permission: config_1.Permission.PR_SANIL_TRAIL_REPORT,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: snail_trail_component_1.SnailTrailComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_COST_CENTER_REPORT,
	                data: {
	                    permission: config_1.Permission.PR_COST_CENTER_REPORT,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: cost_center_report_component_1.CostCenterReportComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_KICKBACK_REPORT,
	                data: {
	                    permission: config_1.Permission.PR_KICKBACK_REPORT,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: kickback_component_1.KickbackComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BOOKING_INFORMATION + "/:id",
	                data: {
	                    permission: config_1.Permission.PR_NORMAL_BOOKING,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: booking_information_component_1.BookingInformationComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BOOKING_INFORMATION2 + "/:id",
	                data: {
	                    permission: config_1.Permission.PR_NORMAL_BOOKING,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: booking_information2_component_1.BookingInformationComponent2,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BOOKING_INFORMATION3 + "/:id",
	                data: {
	                    permission: config_1.Permission.PR_NORMAL_BOOKING,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: booking_information3_component_1.BookingInformationComponent3,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BOOKING,
	                data: {
	                    permission: config_1.Permission.PR_NORMAL_BOOKING,
	                    permissionType: config_1.PermissionType.INSERT
	                },
	                component: booking_component_1.BookingComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ROLE_LIST,
	                data: {
	                    permission: config_1.Permission.PR_ROLE_OVERVIEW,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: role_list_component_1.RoleListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ROLE_UPDATE + "/:id",
	                data: {
	                    permission: config_1.Permission.PR_ROLE_OVERVIEW,
	                    permissionType: config_1.PermissionType.EDIT
	                },
	                component: role_update_component_1.RoleUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ROLE_UPDATE,
	                data: {
	                    permission: config_1.Permission.PR_ROLE_OVERVIEW,
	                    permissionType: config_1.PermissionType.INSERT
	                },
	                component: role_update_component_1.RoleUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SPECIAL_BOOKING,
	                data: {
	                    permission: config_1.Permission.PR_SPECIAL_BOOKING,
	                    permissionType: config_1.PermissionType.INSERT
	                },
	                component: special_booking_component_1.SpecialBookingComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BATCHUPLOADPERSON,
	                data: {
	                    permission: config_1.Permission.PR_BATCH_UPLOAD_PERSON,
	                    permissionType: config_1.PermissionType.INSERT
	                },
	                component: batch_upload_person_component_1.BatchUploadPersonComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_IMPORT_PERSON,
	                data: {
	                    permission: config_1.Permission.PR_IMPORT_PERSON,
	                    permissionType: config_1.PermissionType.INSERT
	                },
	                component: import_person_csv_component_1.ImportPersonCsvComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BRANDING_PAGE,
	                data: {
	                    permission: config_1.Permission.PR_BRANDING,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: branding_component_1.BrandingComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_TERMS_CONDITION_PAGE,
	                data: {
	                    permission: config_1.Permission.PR_TERMS_AND_CONDITION,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: terms_condition_list_component_1.TermsAndConditionComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ROLE_LIST,
	                data: {
	                    permission: config_1.Permission.PR_ROLE_OVERVIEW,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: role_list_component_1.RoleListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ROLE_UPDATE,
	                data: {
	                    permission: config_1.Permission.PR_ROLE_OVERVIEW,
	                    permissionType: config_1.PermissionType.INSERT
	                },
	                component: role_update_component_1.RoleUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_WEGOADMIN_LIST,
	                data: {
	                    permission: config_1.Permission.PR_WEGO_ADMINS,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: wegoadmin_list_component_1.WegoAdminListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ROLEAVAILABILITY_LIST,
	                data: {
	                    permission: config_1.Permission.PR_ROLE_ASSIGN,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: roleavailability_list_component_1.RoleAvailabilityListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_EVENT_VIEWER_LIST,
	                data: {
	                    permission: config_1.Permission.PR_EVENT_VIEWER,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: event_viewer_component_1.EventViewerComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_PRE_POST_QUESTION_UPDATE,
	                data: {
	                    permission: config_1.Permission.PR_PRE_POST_TRIP_SETTING,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: pre_post_trip_question_component_1.PrePostTripQuestionComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_PRE_POST_TRIP_QUESTION_OVERVIEW,
	                data: {
	                    permission: config_1.Permission.PR_PRE_POST_TRIP_QUESTIONS,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: pre_post_trip_question_overview_components_1.PrePostQuestionsOverviewComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_PRE_POST_QUESTION_ADD,
	                data: {
	                    permission: config_1.Permission.PR_PRE_POST_TRIP_SETTING,
	                    permissionType: config_1.PermissionType.INSERT
	                },
	                component: pre_post_trip_question_component_1.PrePostTripQuestionComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SVGDRIVER_LIST,
	                data: {
	                    permission: config_1.Permission.PR_SHARED_VEHICLE_GROUP_DRIVER_OVERVIEW,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: svgdriver_list_component_1.SVGDriverComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_USER_PROFILE_UPDATE,
	                // data: { permission: Permission.PR_USER_PROFILE, permissionType: PermissionType.VIEW },
	                component: userprofile_componets_1.UserProfile,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VEHICLE_FUTURE_BOOKING_LIST,
	                data: {
	                    permission: config_1.Permission.PR_VEHICLE_FUTURE_BOOKINGS,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: vehiclefuturebooking_list_component_1.VehicleFutureBookingListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_INBOX_PAGE,
	                component: inbox_component_1.InboxComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_COSTANDEXPENSE_LIST,
	                data: {
	                    permission: config_1.Permission.PR_COSTANDEXPENSES_LIST,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: cost_expenses_list_components_1.CostAndExpenseListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_INVOICE_UPDATE + "/:id",
	                data: {
	                    permission: config_1.Permission.PR_INVOICE,
	                    permissionType: config_1.PermissionType.EDIT
	                },
	                component: invoice_update_component_1.InvoiceUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_INVOICE_UPDATE,
	                data: {
	                    permission: config_1.Permission.PR_INVOICE,
	                    permissionType: config_1.PermissionType.INSERT
	                },
	                component: invoice_update_component_1.InvoiceUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_PAYMENT_HISTORY + "/:invoiceHashId",
	                data: {
	                    permission: config_1.Permission.PR_INVOICE_PAYMENT_HISTORY_LIST,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: invoice_payment_history_component_1.InvoicePaymentHistoryListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            }
	        ]
	    },
	    {
	        path: "wegoadmin",
	        component: wegoadmin_component_1.WegoAdminComponent,
	        canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard],
	        children: [
	            {
	                path: "",
	                redirectTo: config_1.ApplicationRouteURL.URL_DASHBOARD_PAGE,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_DASHBOARD_PAGE,
	                component: admin_dashboard_component_1.AdminDashboardComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BRANDING_PAGE,
	                component: branding_component_1.BrandingComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_TERMS_CONDITION_PAGE,
	                component: terms_condition_list_component_1.TermsAndConditionComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_INSTANCE_LIST,
	                component: instance_list_component_1.InstanceListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_INSTANCE_UPDATE + "/:id",
	                component: instance_update_component_1.InstanceUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_PERSON_LIST,
	                component: person_list_component_1.PersonListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_PERSON_UPDATE + "/:id",
	                component: person_update_component_1.PersonUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_COMPANY_LIST,
	                component: company_list_component_1.CompanyListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_COMPANY_UPDATE,
	                component: company_update_component_1.CompanyUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_COMPANYADMIN_LIST,
	                component: companyAdmin_list_component_1.CompanyAdminListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VEHICLE_LIST,
	                component: vehicle_list_component_1.VehicleListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VEHICLE_UPDATE,
	                component: vehicle_update_component_1.VehicleUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VTSVEHICLE_UPDATE,
	                component: vtsvehicle_update_component_1.VtsVehicleUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VTSVEHICLE_LIST,
	                component: vtsvehicle_list_component_1.VtsVehicleListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VTS_TROUBLESHOOT,
	                component: vts_troubleshoot_component_1.VTSTroubleshootComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VEHICLEATTRIBUTE_LIST,
	                component: vehicleattribute_list_component_1.VehicleAttributeListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VEHICLEATTRIBUTE_UPDATE,
	                component: vehicleattribute_update_component_1.VehicleAttributeUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VEHICLEATTRIBUTE_ADD,
	                component: vehicleattribute_update_component_1.VehicleAttributeUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VEHICLEATTRIBUTE_CATEGORY_LIST,
	                component: vehicleattributecategory_list_component_1.VehicleAttributeCategoryListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VEHICLEATTRIBUTE_CATEGORY_ADD,
	                component: vehicleattributecategory_update_component_1.VehicleAttributeCategoryUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VEHICLEATTRIBUTE_CATEGORY_UPDATE + "/:id",
	                component: vehicleattributecategory_update_component_1.VehicleAttributeCategoryUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SPECIAL_PERIOD_LIST,
	                component: specialperiod_list_component_1.SpecialPeriodListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SPECIAL_PERIOD_UPDATE,
	                component: specialperiod_update_component_1.SpecialPeriodUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_DRIVER_LIST,
	                component: driver_list_component_1.DriverListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SVG_LIST,
	                component: sharedvehiclegroup_list_component_1.SharedVehicleGroupListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SVG_UPDATE + "/:id",
	                component: sharedvehiclegroup_update_component_1.SharedVehicleGroupUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SVG_ADD,
	                component: sharedvehiclegroup_update_component_1.SharedVehicleGroupUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_WEGOADMIN_LIST,
	                component: wegoadmin_list_component_1.WegoAdminListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_TEMPLATE_LIST,
	                component: template_list_component_1.TemplateListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_TEMPLATE_UPDATE + "/:id",
	                component: template_update_component_1.TemplateUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_TEMPLATE_ADD,
	                component: template_update_component_1.TemplateUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_TERMS_AND_CONDITION_UPDATE + "/:id",
	                component: terms_condition_update_component_1.TermsAndConditionAddUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_TERMS_AND_CONDITION_ADD,
	                component: terms_condition_update_component_1.TermsAndConditionAddUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_DRIVER_SVG_LIST,
	                component: driverSVG_list_component_1.DriverSVGListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SVGADMIN_LIST,
	                component: sharedvehiclegroupadmin_list_component_1.SharedVehicleGroupAdminListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SVGVEHICLE_LIST,
	                component: svgvehicle_list_component_1.SVGVehicleComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SUBSCRIPTION_LIST + "/:id",
	                component: sharedvehiclesubscription_list_component_1.SubscriptionListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SUBSCRIPTION_UPDATE +
	                    "/:sharedVehicleGroupHashId/:subscriptionHashId",
	                component: sharedvehicelsubscription_update_component_1.SubscriptionUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_CONTRACT_TYPE_GROUP_LIST,
	                component: contracttypegroup_list_component_1.ContractTypeGroupListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_CONTRACT_TYPE__GROUP_UPDATE,
	                component: contracttypegroup_update_component_1.ContractTypeGroupUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_CONTRACT_TYPE_LIST,
	                component: contractType_list_component_1.ContractTypeListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_CONTRACT_TYPE_UPDATE,
	                component: contractType_update_component_1.ContractTypeUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BOOKING_INVOICE_LIST,
	                component: invoice_list_component_1.InvoiceListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BOOKING_INVOICE_LEGACY_LIST,
	                component: invoice_legacy_list_component_1.InvoiceLegacyListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SPECIAL_BOOKING,
	                component: special_booking_component_1.SpecialBookingComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BOOKING,
	                component: booking_component_1.BookingComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BOOKING_OVERVIEW,
	                component: booking_overview_component_1.BookingOverviewComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BOOKING_INFORMATION,
	                component: booking_information_component_1.BookingInformationComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BOOKING_INFORMATION2,
	                component: booking_information2_component_1.BookingInformationComponent2,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BOOKING_INFORMATION3,
	                component: booking_information3_component_1.BookingInformationComponent3,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_USER_PROFILE_UPDATE,
	                component: userprofile_componets_1.UserProfile,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_INBOX_PAGE,
	                component: inbox_component_1.InboxComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SVGDRIVER_LIST,
	                component: svgdriver_list_component_1.SVGDriverComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VEHICLE_INFO,
	                component: vehicle_information_component_1.VehicleInformationComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_IMPORT_PERSON,
	                component: import_person_csv_component_1.ImportPersonCsvComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            // {
	            //   path: ApplicationRouteURL.URL_VEHICLE_SVG_LIST,
	            //   component: VehicleSVGListComponent,
	            //   canActivate: [AuthGuard, WAdminAuthGuard]
	            // },
	            {
	                path: config_1.ApplicationRouteURL.URL_SUBSCRIPTIONAVAILABILITY_LIST + "/:id",
	                component: subscriptionavailabilityrestriction_list_component_1.SubscriptionAvailabilityListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SUBSCRIPTIONAVAILABILITY_UPDATE +
	                    "/:sharedVehicleGroupSubscriptionHashId/:subscriptionAvailabiltiyHashId/:sharedVehicleGroupHashId",
	                component: subscriptionavailabilityrestriction_update_component_1.SubscriptionaAvailabilityUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SUBSCRIPTIONAVAILABILITY_ADD +
	                    "/:sharedVehicleGroupSubscriptionHashId/:sharedVehicleGroupHashId",
	                component: subscriptionavailabilityrestriction_update_component_1.SubscriptionaAvailabilityUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ADDITIONALFREEITEM_UPDATE,
	                component: additionalfreeitems_update_component_1.AdditionalFreeItemsUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ADDITIONALFREEITEM_LIST,
	                component: additionalfreeitems_list_component_1.AdditionalFreeItemListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_TRIP_DETAIL_REPORT,
	                component: tripdetailreport_components_1.TripDetailReportComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_EVENT_VIEWER_LIST,
	                component: event_viewer_component_1.EventViewerComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_PRE_POST_TRIP_QUESTION_OVERVIEW,
	                component: pre_post_trip_question_overview_components_1.PrePostQuestionsOverviewComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VEHICLE_FUTURE_BOOKING_LIST,
	                component: vehiclefuturebooking_list_component_1.VehicleFutureBookingListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VTS_HISTORY_LIST,
	                component: vtshistory_list_component_1.VTSHistoryListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VEHICLE_OCCUPANCY_REPORT,
	                component: vehicle_occupancy_component_1.VehicleOccupancy,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ODOMETERLOGTRAIL_LIST,
	                component: odometerlogtrail_list_component_1.OdometerLogTrailListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ODOMETERLOGTRAIL_UPDATE,
	                component: odometerlogtrail_update_component_1.OdometerLogTrailUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SIGNUPFORM_LIST,
	                component: signupformconfig_list_component_1.SignupFormConfigListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SIGNUPFORM_UPDATE + "/:id",
	                component: signupformconfig_update_compnent_1.SignupFormConfigUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SIGNUPFORM_ADD,
	                component: signupformconfig_update_compnent_1.SignupFormConfigUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SIGNUP_LIST,
	                component: signup_list_component_1.SignupListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_DIRECTDEBIT_LIST,
	                component: directdebit_file_list_component_1.DirectDebitFileListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BATCHUPLOADPERSON,
	                component: batch_upload_person_component_1.BatchUploadPersonComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_MAINTENANCE_PLANNING_REPORT,
	                component: maintenance_planning_component_1.MaintenancePlanningReportComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_REVENUE_PER_VEHICLE_REPORT,
	                component: revenue_per_vehicle_component_1.RevenuepervehicleReportComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_TRIPDATA_REPORT,
	                component: tripdatareport_component_1.TripDataReportComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ORGANIZATION_ADD,
	                component: organization_update_component_1.OrganizationUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ORGANIZATION_UPDATE + "/:id",
	                component: organization_update_component_1.OrganizationUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ORGANIZATION_LIST,
	                component: organization_list_component_1.OrganizationListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ORGANIZATION_ADMIN_LIST,
	                component: organizationAdmin_list_component_1.OrganizationAdminListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ORGANIZATION_DRIVER_LIST,
	                component: organizationdriver_list_component_1.OrganizationDriverComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SNAIL_TRAIL_REPORT,
	                component: snail_trail_component_1.SnailTrailComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_CUSTOMER_LIST,
	                component: customer_list_component_1.CustomerListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_CUSTOMER_UPDATE,
	                component: customer_update_component_1.CustomerUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ROLE_LIST,
	                component: role_list_component_1.RoleListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ROLE_UPDATE,
	                component: role_update_component_1.RoleUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ROLEAVAILABILITY_LIST,
	                component: roleavailability_list_component_1.RoleAvailabilityListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ADMIN_OF_CUSTOMER_LIST,
	                component: admin_of_customer_list_component_1.AdminOfCustomerListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ADMIN_OF_INSTANCE_LIST,
	                component: admin_of_instance_list_component_1.AdminOfInstanceListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ADMIN_OF_COMPANY_LIST,
	                component: admin_of_comapny_list_component_1.AdminOfCompanyListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ADMIN_OF_SHAREDVEHICLEGROUP_LIST,
	                component: admin_of_sharedvehiclegroup_list_component_1.AdminOfsharedVehicleGroupListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ADMIN_OF_ORGANIZATION_LIST,
	                component: admin_of_organization_list_component_1.AdminOfOrganizationListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ORGANIZATION_TO_SUBSCRIPTION_LIST,
	                component: organization_subscription_list_component_1.OrganizationSubscriptionComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ORGANIZATION_TO_DRIVER_LIST + "/:id",
	                component: organization_driver_list_component_1.OrganizationDriverListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SUBSCRIPTION_ADD,
	                component: sharedvehicelsubscription_update_component_1.SubscriptionUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_PAYMENT_HISTORY + "/:invoiceHashId",
	                data: {
	                    permission: config_1.Permission.PR_INVOICE_PAYMENT_HISTORY,
	                    permissionType: config_1.PermissionType.VIEW
	                },
	                component: invoice_payment_history_component_1.InvoicePaymentHistoryListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_admin_service_1.AdminAuthGuard]
	            }
	        ]
	    },
	    {
	        path: "cadmin",
	        component: cadmin_component_1.CAdminComponent,
	        canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard],
	        children: [
	            {
	                path: "",
	                redirectTo: config_1.ApplicationRouteURL.URL_DASHBOARD_PAGE,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_DASHBOARD_PAGE,
	                component: admin_dashboard_component_1.AdminDashboardComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BRANDING_PAGE,
	                component: branding_component_1.BrandingComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_TERMS_CONDITION_PAGE,
	                component: terms_condition_list_component_1.TermsAndConditionComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_PERSON_LIST,
	                component: person_list_component_1.PersonListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_PERSON_UPDATE,
	                component: person_update_component_1.PersonUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_COMPANY_LIST,
	                component: company_list_component_1.CompanyListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_COMPANY_UPDATE,
	                component: company_update_component_1.CompanyUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_INBOX_PAGE,
	                component: inbox_component_1.InboxComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_COMPANYADMIN_LIST,
	                component: companyAdmin_list_component_1.CompanyAdminListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SVG_LIST,
	                component: sharedvehiclegroup_list_component_1.SharedVehicleGroupListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SVG_UPDATE,
	                component: sharedvehiclegroup_update_component_1.SharedVehicleGroupUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SVGVEHICLE_LIST,
	                component: svgvehicle_list_component_1.SVGVehicleComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SVGADMIN_LIST,
	                component: sharedvehiclegroupadmin_list_component_1.SharedVehicleGroupAdminListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VEHICLE_LIST,
	                component: vehicle_list_component_1.VehicleListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VEHICLE_UPDATE,
	                component: vehicle_update_component_1.VehicleUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VTSVEHICLE_UPDATE,
	                component: vtsvehicle_update_component_1.VtsVehicleUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VTSVEHICLE_LIST,
	                component: vtsvehicle_list_component_1.VtsVehicleListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            // {
	            //   path: ApplicationRouteURL.URL_VEHICLE_SVG_LIST,
	            //   component: VehicleSVGListComponent,
	            //   canActivate: [AuthGuard, CAdminAuthGuard]
	            // },
	            {
	                path: config_1.ApplicationRouteURL.URL_DRIVER_LIST,
	                component: driver_list_component_1.DriverListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_DRIVER_SVG_LIST,
	                component: driverSVG_list_component_1.DriverSVGListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_CONTRACT_TYPE_LIST,
	                component: contractType_list_component_1.ContractTypeListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_CONTRACT_TYPE_UPDATE,
	                component: contractType_update_component_1.ContractTypeUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_CONTRACT_TYPE_GROUP_LIST,
	                component: contracttypegroup_list_component_1.ContractTypeGroupListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_CONTRACT_TYPE__GROUP_UPDATE,
	                component: contracttypegroup_update_component_1.ContractTypeGroupUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VEHICLEATTRIBUTE_UPDATE,
	                component: vehicleattribute_update_component_1.VehicleAttributeUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VEHICLEATTRIBUTE_LIST,
	                component: vehicleattribute_list_component_1.VehicleAttributeListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BOOKING,
	                component: booking_component_1.BookingComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BOOKING_OVERVIEW,
	                component: booking_overview_component_1.BookingOverviewComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SPECIAL_BOOKING,
	                component: special_booking_component_1.SpecialBookingComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_USER_PROFILE_UPDATE,
	                component: userprofile_componets_1.UserProfile,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SUBSCRIPTION_LIST,
	                component: sharedvehiclesubscription_list_component_1.SubscriptionListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SUBSCRIPTION_UPDATE,
	                component: sharedvehicelsubscription_update_component_1.SubscriptionUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SVGDRIVER_LIST,
	                component: svgdriver_list_component_1.SVGDriverComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BOOKING_INFORMATION,
	                component: booking_information_component_1.BookingInformationComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BOOKING_INFORMATION2,
	                component: booking_information2_component_1.BookingInformationComponent2,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BOOKING_INFORMATION3,
	                component: booking_information3_component_1.BookingInformationComponent3,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VEHICLE_INFO,
	                component: vehicle_information_component_1.VehicleInformationComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_IMPORT_PERSON,
	                component: import_person_csv_component_1.ImportPersonCsvComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ADDITIONALFREEITEM_UPDATE,
	                component: additionalfreeitems_update_component_1.AdditionalFreeItemsUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ADDITIONALFREEITEM_LIST,
	                component: additionalfreeitems_list_component_1.AdditionalFreeItemListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SUBSCRIPTIONAVAILABILITY_LIST,
	                component: subscriptionavailabilityrestriction_list_component_1.SubscriptionAvailabilityListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SUBSCRIPTIONAVAILABILITY_UPDATE,
	                component: subscriptionavailabilityrestriction_update_component_1.SubscriptionaAvailabilityUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VEHICLE_FUTURE_BOOKING_LIST,
	                component: vehiclefuturebooking_list_component_1.VehicleFutureBookingListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VTS_HISTORY_LIST,
	                component: vtshistory_list_component_1.VTSHistoryListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_TRIP_DETAIL_REPORT,
	                component: tripdetailreport_components_1.TripDetailReportComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VTS_TROUBLESHOOT,
	                component: vts_troubleshoot_component_1.VTSTroubleshootComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BOOKING_INVOICE_LIST,
	                component: invoice_list_component_1.InvoiceListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BOOKING_INVOICE_LEGACY_LIST,
	                component: invoice_legacy_list_component_1.InvoiceLegacyListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VEHICLE_OCCUPANCY_REPORT,
	                component: vehicle_occupancy_component_1.VehicleOccupancy,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ODOMETERLOGTRAIL_LIST,
	                component: odometerlogtrail_list_component_1.OdometerLogTrailListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ODOMETERLOGTRAIL_UPDATE,
	                component: odometerlogtrail_update_component_1.OdometerLogTrailUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SIGNUP_LIST,
	                component: signup_list_component_1.SignupListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BATCHUPLOADPERSON,
	                component: batch_upload_person_component_1.BatchUploadPersonComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_DIRECTDEBIT_LIST,
	                component: directdebit_file_list_component_1.DirectDebitFileListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_REVENUE_PER_VEHICLE_REPORT,
	                component: revenue_per_vehicle_component_1.RevenuepervehicleReportComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_MAINTENANCE_PLANNING_REPORT,
	                component: maintenance_planning_component_1.MaintenancePlanningReportComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_TRIPDATA_REPORT,
	                component: tripdatareport_component_1.TripDataReportComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ORGANIZATION_UPDATE,
	                component: organization_update_component_1.OrganizationUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ORGANIZATION_LIST,
	                component: organization_list_component_1.OrganizationListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ORGANIZATION_ADMIN_LIST,
	                component: organizationAdmin_list_component_1.OrganizationAdminListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ORGANIZATION_DRIVER_LIST,
	                component: organizationdriver_list_component_1.OrganizationDriverComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SNAIL_TRAIL_REPORT,
	                component: snail_trail_component_1.SnailTrailComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_cadmin_service_1.CAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ORGANIZATION_TO_SUBSCRIPTION_LIST,
	                component: organization_subscription_list_component_1.OrganizationSubscriptionComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_wadmin_service_1.WAdminAuthGuard]
	            }
	        ]
	    },
	    {
	        path: "gadmin",
	        component: gadmin_component_1.GAdminComponent,
	        canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard],
	        children: [
	            {
	                path: "",
	                redirectTo: config_1.ApplicationRouteURL.URL_DASHBOARD_PAGE,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_DASHBOARD_PAGE,
	                component: admin_dashboard_component_1.AdminDashboardComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_INBOX_PAGE,
	                component: inbox_component_1.InboxComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_DRIVER_LIST,
	                component: driver_list_component_1.DriverListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_DRIVER_SVG_LIST,
	                component: driverSVG_list_component_1.DriverSVGListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SVG_LIST,
	                component: sharedvehiclegroup_list_component_1.SharedVehicleGroupListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SVG_UPDATE,
	                component: sharedvehiclegroup_update_component_1.SharedVehicleGroupUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SVGVEHICLE_LIST,
	                component: svgvehicle_list_component_1.SVGVehicleComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SVGADMIN_LIST,
	                component: sharedvehiclegroupadmin_list_component_1.SharedVehicleGroupAdminListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_CONTRACT_TYPE_LIST,
	                component: contractType_list_component_1.ContractTypeListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_CONTRACT_TYPE_UPDATE,
	                component: contractType_update_component_1.ContractTypeUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_CONTRACT_TYPE_GROUP_LIST,
	                component: contracttypegroup_list_component_1.ContractTypeGroupListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_CONTRACT_TYPE__GROUP_UPDATE,
	                component: contracttypegroup_update_component_1.ContractTypeGroupUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BOOKING,
	                component: booking_component_1.BookingComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BOOKING_OVERVIEW,
	                component: booking_overview_component_1.BookingOverviewComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SPECIAL_BOOKING,
	                component: special_booking_component_1.SpecialBookingComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_USER_PROFILE_UPDATE,
	                component: userprofile_componets_1.UserProfile,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SUBSCRIPTION_LIST,
	                component: sharedvehiclesubscription_list_component_1.SubscriptionListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SUBSCRIPTION_UPDATE,
	                component: sharedvehicelsubscription_update_component_1.SubscriptionUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SVGDRIVER_LIST,
	                component: svgdriver_list_component_1.SVGDriverComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BOOKING_INFORMATION,
	                component: booking_information_component_1.BookingInformationComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BOOKING_INFORMATION2,
	                component: booking_information2_component_1.BookingInformationComponent2,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BOOKING_INFORMATION3,
	                component: booking_information3_component_1.BookingInformationComponent3,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ADDITIONALFREEITEM_UPDATE,
	                component: additionalfreeitems_update_component_1.AdditionalFreeItemsUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ADDITIONALFREEITEM_LIST,
	                component: additionalfreeitems_list_component_1.AdditionalFreeItemListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SUBSCRIPTIONAVAILABILITY_LIST,
	                component: subscriptionavailabilityrestriction_list_component_1.SubscriptionAvailabilityListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SUBSCRIPTIONAVAILABILITY_UPDATE,
	                component: subscriptionavailabilityrestriction_update_component_1.SubscriptionaAvailabilityUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VEHICLE_UPDATE,
	                component: vehicle_update_component_1.VehicleUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VEHICLE_INFO,
	                component: vehicle_information_component_1.VehicleInformationComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_VEHICLE_OCCUPANCY_REPORT,
	                component: vehicle_occupancy_component_1.VehicleOccupancy,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ODOMETERLOGTRAIL_LIST,
	                component: odometerlogtrail_list_component_1.OdometerLogTrailListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ODOMETERLOGTRAIL_UPDATE,
	                component: odometerlogtrail_update_component_1.OdometerLogTrailUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SIGNUP_LIST,
	                component: signup_list_component_1.SignupListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BATCHUPLOADPERSON,
	                component: batch_upload_person_component_1.BatchUploadPersonComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_REVENUE_PER_VEHICLE_REPORT,
	                component: revenue_per_vehicle_component_1.RevenuepervehicleReportComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_MAINTENANCE_PLANNING_REPORT,
	                component: maintenance_planning_component_1.MaintenancePlanningReportComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_TRIPDATA_REPORT,
	                component: tripdatareport_component_1.TripDataReportComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ORGANIZATION_UPDATE,
	                component: organization_update_component_1.OrganizationUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ORGANIZATION_LIST,
	                component: organization_list_component_1.OrganizationListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ORGANIZATION_ADMIN_LIST,
	                component: organizationAdmin_list_component_1.OrganizationAdminListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ORGANIZATION_DRIVER_LIST,
	                component: organizationdriver_list_component_1.OrganizationDriverComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_PERSON_UPDATE,
	                component: person_update_component_1.PersonUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SNAIL_TRAIL_REPORT,
	                component: snail_trail_component_1.SnailTrailComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_gadmin_service_1.GAdminAuthGuard]
	            }
	        ]
	    },
	    {
	        path: "driver",
	        component: driver_role_component_1.DriverRoleComponent,
	        canActivate: [auth_guard_service_1.AuthGuard, auth_guard_driveradmin_service_1.DriverAdminAuthGuard],
	        children: [
	            {
	                path: "",
	                redirectTo: config_1.ApplicationRouteURL.URL_DASHBOARD_PAGE,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_driveradmin_service_1.DriverAdminAuthGuard]
	            },
	            {
	                path: "creditCardPayment/success",
	                component: creditcard_payment_success_component_1.CreditCardPaymentSuccessComponent,
	            },
	            {
	                path: "creditCardPayment/failure",
	                component: creditcard_payment_failure_component_1.CreditCardPaymentFailureComponent,
	            },
	            // {
	            //   path: ApplicationRouteURL.URL_TERMS_AND_CONDITION_POPUP,
	            //   component: ViewTermsAndConditionPopupComponent,
	            //   canActivate: [AuthGuard]
	            // },
	            {
	                path: config_1.ApplicationRouteURL.URL_DASHBOARD_PAGE,
	                component: driver_dashboard_component_1.DriverDashboardComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_driveradmin_service_1.DriverAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_INBOX_PAGE,
	                component: inbox_driver_component_1.InboxDriverListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_driveradmin_service_1.DriverAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BOOKING,
	                component: booking_driver_component_1.BookingDriverComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_driveradmin_service_1.DriverAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BOOKING_OVERVIEW,
	                component: booking_overview_driver_component_1.BookingOverviewDriverComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_driveradmin_service_1.DriverAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BOOKING_HISTORY,
	                component: booking_history_component_1.BookingHistoryComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_driveradmin_service_1.DriverAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_COST_EXPENSE_DRIVER_LIST,
	                component: cost_expenses_driver_list_components_1.CostAndExpenseListDriverComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_driveradmin_service_1.DriverAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_USER_PROFILE_UPDATE,
	                component: userprofile_componets_1.UserProfile,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_driveradmin_service_1.DriverAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SUBSCRIPTION_LIST,
	                component: driversubscription_list_component_1.DriverSubscriptionListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_driveradmin_service_1.DriverAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BOOKING_INFORMATION_DRIVER,
	                component: driver_bookinginformation_component_1.DriverBookingInformationComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_driveradmin_service_1.DriverAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_DRIVER_PROFILE,
	                component: driver_profile_component_1.DriverProfile,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_driveradmin_service_1.DriverAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_TERMS_CONDITION_ACTIVITY_DRIVER,
	                component: tc_activity_log_driver_component_1.TCActivityLogDriverComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_driveradmin_service_1.DriverAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SNAIL_TRAIL_DRIVER,
	                component: snail_trail_driver_component_1.SnailTrailDriverComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_driveradmin_service_1.DriverAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_TRIP_HISTORY,
	                component: trip_history_component_1.TripHistoryComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_driveradmin_service_1.DriverAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_TRIP_INFORMATION_DRIVER,
	                component: driver_tripinformation_component_1.DriverTripInformationComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_driveradmin_service_1.DriverAdminAuthGuard]
	            },
	        ]
	    },
	    {
	        path: "orgadmin",
	        component: orgadmin_component_1.OrgAdminComponent,
	        canActivate: [auth_guard_service_1.AuthGuard, auth_guard_orgadmin_service_1.OrgAdminAuthGuard],
	        children: [
	            {
	                path: "",
	                redirectTo: config_1.ApplicationRouteURL.URL_DASHBOARD_PAGE,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_orgadmin_service_1.OrgAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_DASHBOARD_PAGE,
	                component: admin_dashboard_component_1.AdminDashboardComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_orgadmin_service_1.OrgAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SVG_LIST,
	                component: sharedvehiclegroup_list_component_1.SharedVehicleGroupListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_orgadmin_service_1.OrgAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SVG_UPDATE,
	                component: sharedvehiclegroup_update_component_1.SharedVehicleGroupUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_orgadmin_service_1.OrgAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SVGVEHICLE_LIST,
	                component: svgvehicle_list_component_1.SVGVehicleComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_orgadmin_service_1.OrgAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_DRIVER_LIST,
	                component: driver_list_component_1.DriverListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_orgadmin_service_1.OrgAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BOOKING,
	                component: booking_component_1.BookingComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_orgadmin_service_1.OrgAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BOOKING_OVERVIEW,
	                component: booking_overview_component_1.BookingOverviewComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_orgadmin_service_1.OrgAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BOOKING_INFORMATION,
	                component: booking_information_component_1.BookingInformationComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_orgadmin_service_1.OrgAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BOOKING_INFORMATION2,
	                component: booking_information2_component_1.BookingInformationComponent2,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_orgadmin_service_1.OrgAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BOOKING_INFORMATION3,
	                component: booking_information3_component_1.BookingInformationComponent3,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_orgadmin_service_1.OrgAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_PERSON_LIST,
	                component: person_list_component_1.PersonListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_orgadmin_service_1.OrgAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_PERSON_UPDATE,
	                component: person_update_component_1.PersonUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_orgadmin_service_1.OrgAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_DRIVER_SVG_LIST,
	                component: driverSVG_list_component_1.DriverSVGListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_orgadmin_service_1.OrgAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SUBSCRIPTION_LIST,
	                component: driversubscription_list_component_1.DriverSubscriptionListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_orgadmin_service_1.OrgAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ORGANIZATION_UPDATE,
	                component: organization_update_component_1.OrganizationUpdateComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_orgadmin_service_1.OrgAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ORGANIZATION_LIST,
	                component: organization_list_component_1.OrganizationListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_orgadmin_service_1.OrgAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BOOKING_INVOICE_LIST,
	                component: invoice_list_component_1.InvoiceListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_orgadmin_service_1.OrgAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BOOKING_INVOICE_LEGACY_LIST,
	                component: invoice_legacy_list_component_1.InvoiceLegacyListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_orgadmin_service_1.OrgAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ORGANIZATION_ADMIN_LIST,
	                component: organizationAdmin_list_component_1.OrganizationAdminListComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_orgadmin_service_1.OrgAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_ORGANIZATION_DRIVER_LIST,
	                component: organizationdriver_list_component_1.OrganizationDriverComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_orgadmin_service_1.OrgAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_SVGDRIVER_LIST,
	                component: svgdriver_list_component_1.SVGDriverComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_orgadmin_service_1.OrgAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_BATCHUPLOADPERSON,
	                component: batch_upload_person_component_1.BatchUploadPersonComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_orgadmin_service_1.OrgAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_USER_PROFILE_UPDATE,
	                component: userprofile_componets_1.UserProfile,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_orgadmin_service_1.OrgAdminAuthGuard]
	            },
	            {
	                path: config_1.ApplicationRouteURL.URL_INBOX_PAGE,
	                component: inbox_component_1.InboxComponent,
	                canActivate: [auth_guard_service_1.AuthGuard, auth_guard_orgadmin_service_1.OrgAdminAuthGuard]
	            }
	        ]
	    },
	    {
	        path: "",
	        component: login_component_1.LoginComponent
	    },
	    {
	        path: "backoffice",
	        component: backoffice_component_1.BackofficeComponent
	    },
	    {
	        path: "validatedriverlicence/driverlicencedetail",
	        component: driverlicencedetail_component_1.DriverLicenceComponent
	    },
	    {
	        path: "personprofile",
	        component: personprofile_componets_1.PersonProfile
	    },
	    {
	        path: "invitation",
	        component: admin_invitation_component_1.AdminInvitationComponent
	    },
	    {
	        path: "invitationaccept",
	        component: admin_invitation_accept_component_1.AdminInvitationAcceptComponent
	    },
	    {
	        path: "invitationreject",
	        component: admin_invitation_reject_component_1.AdminInvitationRejectComponent
	    },
	    {
	        path: "personprofile/success",
	        component: personprofilesuccess_componets_1.PersonProfileSuccessComponent
	    },
	    {
	        path: "Linkexpired",
	        component: link_expired_compontnet_1.LinkExpiredComponent
	    },
	    {
	        path: "forgotpassword",
	        component: forgotpassword_component_1.ForgotPasswordComponent
	    },
	    {
	        path: "changepassword",
	        component: changepassword_component_1.ChangePasswordComponent
	    },
	    {
	        path: "changepassword/success",
	        component: changepasswordsuccess_component_1.ChangePasswordSuccessComponent
	    },
	    {
	        path: "underconstruction",
	        component: underconstruction_component_1.UnderConstructionComponent
	    },
	    {
	        path: "NotFound",
	        component: notfound_component_1.NotFoundComponent
	    },
	    {
	        path: "privacy-not-allow",
	        component: privacy_not_allow_component_1.PrivacyNotAllowComponent
	    },
	    {
	        path: "Unauthenticated",
	        component: unauthenticated_component_1.UnAuthenticatedComponent
	    },
	    {
	        path: "Unauthorized",
	        component: unauthorized_component_1.UnAuthorizedComponent
	    },
	    {
	        path: "language-helper",
	        component: language_herlper_component_1.LanguageHelperComponent
	    },
	    {
	        path: "language-helper-api",
	        component: language_herlper_api_component_1.LanguageHelperAPIComponent
	    },
	    {
	        path: "booking/approve",
	        component: booking_approve_component_1.BookingApproveComponent,
	    },
	    {
	        path: "signup/:id",
	        component: signup_component_1.SignUpComponent
	    },
	    {
	        path: "**",
	        redirectTo: "/NotFound"
	    }
	];
	var AppRoutingModule = (function () {
	    function AppRoutingModule() {
	    }
	    AppRoutingModule = __decorate([
	        core_1.NgModule({
	            imports: [router_1.RouterModule.forRoot(routes, { useHash: true })],
	            exports: [router_1.RouterModule]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], AppRoutingModule);
	    return AppRoutingModule;
	}());
	exports.AppRoutingModule = AppRoutingModule;


/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var config_1 = __webpack_require__(60);
	var terms_condition_model_1 = __webpack_require__(615);
	var terms_conditions_service_1 = __webpack_require__(882);
	var config_2 = __webpack_require__(60);
	var translate_service_1 = __webpack_require__(70);
	var TermsAndConditionComponent = (function () {
	    function TermsAndConditionComponent(authService, termsAndConditionsService, translate) {
	        this.authService = authService;
	        this.termsAndConditionsService = termsAndConditionsService;
	        this.translate = translate;
	        this.isLoading = false;
	        this.roleLevel = config_2.RoleLevel;
	    }
	    Object.defineProperty(TermsAndConditionComponent.prototype, "isAnyChecked", {
	        get: function () {
	            if (this.termsConditionList) {
	                var isCheck = this.termsConditionList.some(function (x) { return x.isChecked == true; });
	                if (isCheck) {
	                    if (this.termsConditionList.every(function (x) { return x.isChecked == true; }))
	                        this.isParentCheck = true;
	                    else
	                        this.isParentCheck = false;
	                }
	                else {
	                    this.isParentCheck = false;
	                }
	                return isCheck;
	            }
	            else {
	                this.isParentCheck = false;
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TermsAndConditionComponent.prototype, "isAnyDeletable", {
	        get: function () {
	            if (this.termsConditionList) {
	                return this.termsConditionList.some(function (x) { return (x.termsAndConditionsHashId ? true : false) == true; });
	            }
	            return false;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TermsAndConditionComponent.prototype, "isDeleteAccess", {
	        get: function () {
	            if (this.termsConditionList) {
	                return this.termsConditionList.some(function (x) { return x.isDeletable; });
	            }
	            else {
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    // get isResetParameters(): boolean {
	    //   return this.isResetFlag;
	    // }
	    TermsAndConditionComponent.prototype.ngOnInit = function () {
	        this.model = new terms_condition_model_1.TermsConditionModel();
	        this.DataListModel = new config_1.DataListModel();
	        this.module = this.translate.instant("LblTermsConditionPrivacy");
	        this.urlTermsAndConditionAdd = this.authService.GetURL(config_1.ApplicationRouteURL.URL_TERMS_AND_CONDITION_ADD);
	        this.urlTermsAndConditionUpdate = this.authService.GetURL(config_1.ApplicationRouteURL.URL_TERMS_AND_CONDITION_UPDATE);
	        this.addTermsAndConditionLink = new config_1.WeGoAuthorizedLink(this.urlTermsAndConditionAdd, config_1.Permission.PR_TERMS_AND_CONDITION, config_1.PermissionType.INSERT, "btn btn-highlight navbar-right", "LblAddNew");
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.model = this.authService.AssignFromStorage(this.constructor.name + "_model", this.model);
	        this.DataListModel.searchField = ["name", "type", 'version'];
	        if (this.authService.GetHighestRoleLevel() <= this.roleLevel.Instance) {
	            this.DataListModel.searchField.push("instanceName");
	        }
	        if (this.authService.GetHighestRoleLevel() <= this.roleLevel.Company) {
	            this.DataListModel.searchField.push("companyName");
	        }
	        if (this.authService.GetHighestRoleLevel() <= this.roleLevel.Organization) {
	            this.DataListModel.searchField.push("organizationName");
	        }
	        if (this.authService.GetHighestRoleLevel() <= this.roleLevel.SVG) {
	            this.DataListModel.searchField.push("sharedVehicleGroupName");
	            this.DataListModel.searchField.push("subscriptionName");
	        }
	        this.GetTermsAndConditionsList();
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	    };
	    TermsAndConditionComponent.prototype.OnPageChanged = function (event) {
	        this.isLoading = true;
	        this.DataListModel.currentPage = event.page;
	        this.GetTermsAndConditionsList();
	    };
	    ;
	    TermsAndConditionComponent.prototype.OnSearch = function (event) {
	        if (event.isReset == false) {
	            this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	            this.IsResetParameter = false;
	            this.GetTermsAndConditionsList();
	        }
	        else {
	            this.OnAdvanceReset(event);
	        }
	    };
	    TermsAndConditionComponent.prototype.OnPagingChange = function (event) {
	        console.log(this.DataListModel);
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetTermsAndConditionsList();
	    };
	    TermsAndConditionComponent.prototype.OnParentCheck = function (isChecked) {
	        this.termsConditionList.filter(function (x) { return x.isDeletable; }).forEach(function (x) { return x.isChecked = (isChecked && x.termsAndConditionsHashId ? true : false); });
	    };
	    TermsAndConditionComponent.prototype.OnDetailSearch = function ($event) {
	        if ($event.InstanceHashIdList) {
	            this.model.instanceHashIdList = $event.InstanceHashIdList;
	        }
	        if ($event.CompanyHashIdList) {
	            this.model.companyHashIdList = $event.CompanyHashIdList;
	        }
	        if ($event.OrganizationHashIdList) {
	            this.model.organizationHashIdList = $event.OrganizationHashIdList;
	        }
	        if ($event.SharedVehicleGroupHashIdList) {
	            this.model.sharedVehicleGroupHashIdList = $event.SharedVehicleGroupHashIdList;
	        }
	    };
	    TermsAndConditionComponent.prototype.GetTermsAndConditionsList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.termsAndConditionsService.GetTermsAndConditionList(this.model, this.DataListModel)
	            .subscribe(function (res) {
	            _this.termsConditionList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	            _this.termsConditionList = [];
	        });
	    };
	    TermsAndConditionComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.termsAndConditionsService
	            .ExportTermsAndConditionList(this.model, this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "TermsAndConditions" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    TermsAndConditionComponent.prototype.ShowChildModal = function (termsAndConditionsHashId) {
	        if (termsAndConditionsHashId) {
	            this.popupMsg = this.translate.instant("LblRecordDeleteConfirmation", [
	                this.module
	            ]);
	            this.isMultipleDelete = false;
	            this.deleteTermsAndConditionsHashId = termsAndConditionsHashId;
	        }
	        else {
	            this.popupMsg = this.translate.instant("LblRecordMultiplDeleteConfirmation", [this.module]);
	            this.isMultipleDelete = true;
	        }
	        this.childModal.show();
	    };
	    TermsAndConditionComponent.prototype.SuccessModalClick = function () {
	        var deletedTermsAndConditionsList;
	        if (this.isMultipleDelete)
	            deletedTermsAndConditionsList = this.termsConditionList
	                .filter(function (x) { return x.isChecked; })
	                .map(function (x) { return x.termsAndConditionsHashId; });
	        else
	            deletedTermsAndConditionsList.push(this.deleteTermsAndConditionsHashId);
	        this.DeleteTermsAndConditions(deletedTermsAndConditionsList);
	        this.childModal.hide();
	    };
	    TermsAndConditionComponent.prototype.HideChildModal = function () {
	        this.deleteTermsAndConditionsHashId = "";
	        this.childModal.hide();
	    };
	    TermsAndConditionComponent.prototype.DeleteTermsAndConditions = function (deletedTermsAndConditionsList) {
	        var _this = this;
	        this.isLoading = true;
	        this.termsAndConditionsService.DeleteTermsAndConditions(deletedTermsAndConditionsList).subscribe(function (res) {
	            _this.DataListModel.currentPage = 1;
	            _this.GetTermsAndConditionsList();
	            _this.popupMsg = _this.translate.instant("LblRecordRemovedSuccess", [
	                _this.module
	            ]);
	            _this.ShowSuccessPopup();
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    TermsAndConditionComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    TermsAndConditionComponent.prototype.OnAdvanceReset = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, "", event.isReset);
	        this.IsResetParameter = true;
	        this.model.instanceHashIdList = [];
	        this.model.instanceHashId = '';
	        this.model.companyHashId = '';
	        this.model.companyHashIdList = [];
	        this.model.organizationHashId = '';
	        this.model.organizationHashIdList = [];
	        this.model.sharedVehicleGroupHashId = '';
	        this.model.sharedVehicleGroupHashIdList = [];
	        this.GetTermsAndConditionsList();
	    };
	    TermsAndConditionComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetTermsAndConditionsList();
	    };
	    TermsAndConditionComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	        this.authService.SaveToStorage(this.constructor.name + "_model", this.model);
	    };
	    __decorate([
	        core_1.ViewChild("childModal"), 
	        __metadata('design:type', Object)
	    ], TermsAndConditionComponent.prototype, "childModal", void 0);
	    __decorate([
	        core_1.ViewChild("successPopup"), 
	        __metadata('design:type', Object)
	    ], TermsAndConditionComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild("searchForm"), 
	        __metadata('design:type', Object)
	    ], TermsAndConditionComponent.prototype, "searchForm", void 0);
	    TermsAndConditionComponent = __decorate([
	        core_1.Component({
	            selector: "Wego-terms-condition-list",
	            template: __webpack_require__(883),
	            providers: [terms_conditions_service_1.TermsAndConditionsService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof terms_conditions_service_1.TermsAndConditionsService !== 'undefined' && terms_conditions_service_1.TermsAndConditionsService) === 'function' && _b) || Object, (typeof (_c = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _c) || Object])
	    ], TermsAndConditionComponent);
	    return TermsAndConditionComponent;
	    var _a, _b, _c;
	}());
	exports.TermsAndConditionComponent = TermsAndConditionComponent;


/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var jquery_helper_service_1 = __webpack_require__(67);
	var TermsAndConditionsService = (function () {
	    function TermsAndConditionsService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	        this.JQueryHelper = new jquery_helper_service_1.JQueryHelperService();
	    }
	    TermsAndConditionsService.prototype.GetTermsAndConditionList = function (termsAndConditionSearchList, input) {
	        var getTermsAndConditionListUrl = config_1.WeGoConfig.API_GET_TERMSANDCONDITIONS_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var queryStringTermsAndConditionModel = this.JQueryHelper.Param(termsAndConditionSearchList);
	        getTermsAndConditionListUrl = getTermsAndConditionListUrl + "?" + queryString + "&" + decodeURIComponent(queryStringTermsAndConditionModel);
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getTermsAndConditionListUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    TermsAndConditionsService.prototype.ExportTermsAndConditionList = function (termsAndConditionSearchList, input) {
	        var getUrl = config_1.WeGoConfig.API_EXPORT_TERMSANDCONDITIONS_LIST;
	        input.currentPage = 0;
	        var queryStringDataListModel = this.authService.HandleAPIListInput(input);
	        var queryStringTermsConditionModel = this.JQueryHelper.Param(termsAndConditionSearchList);
	        var headers = this.authService.GetHeader('text/csv');
	        var options = new http_1.RequestOptions({ headers: headers });
	        getUrl = getUrl + "?" + queryStringDataListModel + "&" + decodeURIComponent(queryStringTermsConditionModel);
	        return this.http.get(getUrl, options);
	    };
	    TermsAndConditionsService.prototype.UpdateTermsAndConditions = function (termsAndConditionSearchList) {
	        var body = termsAndConditionSearchList;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_POST_TERMSANDCONDITIONS_DETAILS, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    TermsAndConditionsService.prototype.GetTermsAndConditionsByHashId = function (termsAndConditionsHashId) {
	        var getUrl = config_1.WeGoConfig.API_GET_TERMSANDCONDITIONS_BY_HASH + "?termsAndConditionHashId=" + termsAndConditionsHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    TermsAndConditionsService.prototype.GetInstanceListDropdownList = function (permissionType, termsAndConditionsHashId, pageName) {
	        var getTermsConditionUrl;
	        getTermsConditionUrl = config_1.WeGoConfig.API_GET_DROPDOWN_INSTANCE_LIST_TERMSANDCONDITIONS;
	        getTermsConditionUrl = getTermsConditionUrl + "?permissionType=" + permissionType + "&termsAndConditionsHashId=" + termsAndConditionsHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getTermsConditionUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    TermsAndConditionsService.prototype.DeleteTermsAndConditions = function (selectedTermsAndConditions) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_DELETE_TERMSANDCONDITIONS, selectedTermsAndConditions, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    TermsAndConditionsService.prototype.GetTermsAndConditionActivityList = function (termsAndConditionsHashId, input) {
	        var getTermsAndConditionListUrl = config_1.WeGoConfig.API_GET_TERMSANDCONDITIONS_ACTIVITY_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        getTermsAndConditionListUrl = getTermsAndConditionListUrl + "?" + queryString + "&termsAndConditionHashId=" + termsAndConditionsHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getTermsAndConditionListUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    TermsAndConditionsService.prototype.GetTermsAndConditionActivityListDriver = function (input) {
	        var getTermsAndConditionListUrl = config_1.WeGoConfig.API_GET_TERMSANDCONDITIONS_ACTIVITY_LIST_DRIVER;
	        var queryString = this.authService.HandleAPIListInput(input);
	        getTermsAndConditionListUrl = getTermsAndConditionListUrl + "?" + queryString;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getTermsAndConditionListUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    TermsAndConditionsService.prototype.ExportTermsAndConditionActivityList = function (termsAndConditionsHashId, input) {
	        var getUrl = config_1.WeGoConfig.API_EXPORT_TERMSANDCONDITIONS_ACTIVITY_LIST;
	        input.currentPage = 0;
	        var queryStringDataListModel = this.authService.HandleAPIListInput(input);
	        var headers = this.authService.GetHeader('text/csv');
	        var options = new http_1.RequestOptions({ headers: headers });
	        getUrl = getUrl + "?" + queryStringDataListModel + "&termsAndConditionHashId=" + termsAndConditionsHashId;
	        return this.http.get(getUrl, options);
	    };
	    TermsAndConditionsService.prototype.ExportTermsAndConditionActivityListDriver = function (input) {
	        var getUrl = config_1.WeGoConfig.API_EXPORT_TERMSANDCONDITIONS_ACTIVITY_LIST_DRIVER;
	        input.currentPage = 0;
	        var queryStringDataListModel = this.authService.HandleAPIListInput(input);
	        var headers = this.authService.GetHeader('text/csv');
	        var options = new http_1.RequestOptions({ headers: headers });
	        getUrl = getUrl + "?" + queryStringDataListModel;
	        return this.http.get(getUrl, options);
	    };
	    TermsAndConditionsService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], TermsAndConditionsService);
	    return TermsAndConditionsService;
	    var _a, _b;
	}());
	exports.TermsAndConditionsService = TermsAndConditionsService;


/***/ },
/* 883 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ 'LblTermsAndConditionList' | translate }}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}\r\n          </a>\r\n        </li>\r\n        <li class=\"active\">\r\n          {{ 'LblTermsAndConditionList' | translate }}\r\n        </li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25\">\r\n      <wego-authorized-link [LinkModel]=\"addTermsAndConditionLink\"></wego-authorized-link>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n\r\n    <section class=\"content\">\r\n      <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n          <p class=\"text-success\">{{ message }} </p>\r\n          <wego-termsandcondition-search-filter #searchForm (OnDetailSearch)=\"OnDetailSearch($event)\" [IsResetParameter]=\"IsResetParameter\"></wego-termsandcondition-search-filter>\r\n          <wego-search-list [IsDeleted]=\"isDeleteAccess\" [IsDeleteEnabled]=\"isAnyChecked\" (OnDeleteAll)=\"ShowChildModal()\" (OnSearch)=\"OnSearch($event)\"\r\n            (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\"\r\n            [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n          <div class=\"table table-responsive mar_bot_ziro\">\r\n            <table class=\"table table-bordered mar_bot_ziro\">\r\n              <thead>\r\n                <tr>\r\n                  <th class=\"text-center parent-checkbox\">\r\n                    <input [disabled]=\"!isAnyDeletable\" type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\">\r\n                  </th>\r\n                  <th class=\"cursor-pointer\" (click)=\"OnSort('name')\">\r\n                    {{ 'LblName' | translate }}\r\n                    <wego-sort-list [FieldName]=\"'name'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                  </th>\r\n                  <th class=\"cursor-pointer\" (click)=\"OnSort('type')\">\r\n                    {{ 'LblType' | translate }}\r\n                    <wego-sort-list [FieldName]=\"'type'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                  </th>\r\n                  <th class=\"cursor-pointer\" (click)=\"OnSort('startDatetimeUTC')\">\r\n                    {{ 'LblDate' | translate }}\r\n                    <wego-sort-list [FieldName]=\"'startDatetimeUTC'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                  </th>\r\n                  <th class=\"cursor-pointer\" (click)=\"OnSort('version')\">\r\n                    {{ 'LblVersion' | translate }}\r\n                    <wego-sort-list [FieldName]=\"'version'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                  </th>\r\n                  <th class=\"cursor-pointer\" *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Instance\" (click)=\"OnSort('instanceName')\">\r\n                    {{ 'LblInstance' | translate }}\r\n                    <wego-sort-list [FieldName]=\"'instanceName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                  </th>\r\n                  <th class=\"cursor-pointer\" *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Company\" (click)=\"OnSort('companyName')\">\r\n                    {{ 'LblCompany' | translate }}\r\n                    <wego-sort-list [FieldName]=\"'companyName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                  </th>\r\n                  <th class=\"cursor-pointer\" *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Organization\" (click)=\"OnSort('organizationName')\">\r\n                    {{ 'LblOrganization' | translate }}\r\n                    <wego-sort-list [FieldName]=\"'organizationName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                  </th>\r\n                  <th class=\"cursor-pointer\" *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.SVG\" (click)=\"OnSort('sharedVehicleGroupName')\">\r\n                    {{ 'LblSharedVehicleGroup' | translate }}\r\n                    <wego-sort-list [FieldName]=\"'sharedVehicleGroupName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                  </th>\r\n                  <th class=\"cursor-pointer\" *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.SVG\" (click)=\"OnSort('subscriptionName')\">\r\n                    {{ 'LblSubscription' | translate }}\r\n                    <wego-sort-list [FieldName]=\"'subscriptionName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                  </th>\r\n                  <th class=\"text-center\">\r\n                    {{ 'LblActivityLog' | translate }}\r\n                  </th>\r\n                  <th class=\"text-center\">\r\n                    {{ 'LblEdit' | translate }}\r\n                  </th>\r\n                </tr>\r\n              </thead>\r\n              <tbody>\r\n                <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                  <tr *ngFor=\"let item of termsConditionList\">\r\n                    <td class=\"text-center\">\r\n                      <input disabled *ngIf=\"!item.isDeletable\" type=\"checkbox\" name=\"isActive\" [(ngModel)]=\"item.isChecked\">\r\n                      <input *ngIf=\"item.isDeletable\" type=\"checkbox\" name=\"isActive\" [(ngModel)]=\"item.isChecked\">\r\n                    </td>\r\n                    <td class=\"word-wrap\">{{ item.name }}</td>\r\n                    <td>{{ item.type }}</td>\r\n                    <td>{{ item.startDatetime }}</td>\r\n                    <td>{{ item.version | number:'1.1' }}</td>\r\n                    <td *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Instance\" class=\"word-wrap\">{{ item.instanceName }}</td>\r\n                    <td *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Company\" class=\"word-wrap\">{{ item.companyName }}</td>\r\n                    <td *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Organization\" class=\"word-wrap\">{{ item.organizationName }}</td>\r\n                    <td *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.SVG\" class=\"word-wrap\">{{ item.sharedVehicleGroupName }}</td>\r\n                    <td *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.SVG\" class=\"word-wrap\">{{ item.subscriptionName }}</td>\r\n                    <td class=\"text-center cursor-pointer\">\r\n                      <a (click)=\"activityModel.show(item.termsAndConditionsHashId,item.name)\">\r\n                        <i class=\"fa fa-eye fa-fw\"></i>\r\n                      </a>\r\n                    </td>\r\n                    <td class=\"text-center cursor-pointer\">\r\n                      <a *ngIf=\"item.isEditable\" [routerLink]=\"urlTermsAndConditionUpdate + '/' + item.termsAndConditionsHashId\">\r\n                        <i class=\"fa fa-pencil-square-o fa-fw\"></i>\r\n                      </a>\r\n                    </td>\r\n                  </tr>\r\n                </template>\r\n                <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                  <td class=\"text-center text-danger\" colspan=\"12\">\r\n                    {{ DataListModel.infoMessage }}\r\n                  </td>\r\n                </tr>\r\n              </tbody>\r\n            </table>\r\n          </div>\r\n          <div class=\"clearfix\"></div>\r\n          <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n            <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n              <div class=\"col-md-12\">\r\n                <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                  [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                  lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </section>\r\n  </section>\r\n</div>\r\n\r\n<wego-confirm-popup #childModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessModalClick()\" (onReject)=\"HideChildModal()\"></wego-confirm-popup>\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n<wego-tc-activity-popup #activityModel></wego-tc-activity-popup>";

/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var instance_service_1 = __webpack_require__(500);
	var translate_service_1 = __webpack_require__(70);
	var person_service_1 = __webpack_require__(771);
	var auth_service_1 = __webpack_require__(58);
	var config_1 = __webpack_require__(60);
	var core_1 = __webpack_require__(3);
	var ng2_file_upload_1 = __webpack_require__(810);
	var ImportPersonCsvComponent = (function () {
	    function ImportPersonCsvComponent(authService, personService, instanceService, translate) {
	        this.authService = authService;
	        this.personService = personService;
	        this.instanceService = instanceService;
	        this.translate = translate;
	        this.instanceHashId = "";
	        this.roleLevel = config_1.RoleLevel;
	    }
	    ImportPersonCsvComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlPersonList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_PERSON_LIST);
	        this.module = this.translate.instant("LblPerson");
	        this.breadCrumbList = this.translate.instant("LblListPage", [this.module]);
	        this.ResetPaging();
	        this.headers = this.authService.GetHeaderForFile();
	        this.uploader = new ng2_file_upload_1.FileUploader({
	            url: config_1.WeGoConfig.API_VALIDATE_PERSON_CSV,
	            headers: this.headers
	        });
	        this.uploader.onAfterAddingFile = function (fileItem) {
	            return _this.HandleOnAfterAddingFile(fileItem);
	        };
	        this.uploader.onBuildItemForm = function (fileItem, Form) {
	            return _this.HandleOnBuildItemForm(fileItem, Form);
	        };
	        this.uploader.onCompleteItem = function (item, response, status, headers) {
	            return _this.HandleOnCompleteItem(item, response, status, headers);
	        };
	        this.GetInstanceList();
	    };
	    Object.defineProperty(ImportPersonCsvComponent.prototype, "ValidFormData", {
	        get: function () {
	            if (this.uploader.queue.length > 0 && this.instanceHashId != "")
	                return true;
	            else
	                return false;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ImportPersonCsvComponent.prototype, "ValidImportRecord", {
	        get: function () {
	            if (this.listOfRecord &&
	                this.listOfRecord.length > 0 &&
	                this.listOfRecord.filter(function (x) { return x.isValidRecord; }).length > 0)
	                return true;
	            else
	                return false;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ImportPersonCsvComponent.prototype, "isAnyChecked", {
	        get: function () {
	            if (this.listOfRecord) {
	                var isCheck = this.listOfRecord
	                    .filter(function (x) { return x.isValidRecord; })
	                    .some(function (x) { return x.sendActivationLinkToImportedPerson == true; });
	                if (isCheck) {
	                    if (this.listOfRecord
	                        .filter(function (x) { return x.isValidRecord; })
	                        .every(function (x) { return x.sendActivationLinkToImportedPerson == true; }))
	                        this.isParentCheck = true;
	                    else
	                        this.isParentCheck = false;
	                }
	                else {
	                    this.isParentCheck = false;
	                }
	                return isCheck;
	            }
	            else {
	                this.isParentCheck = false;
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ImportPersonCsvComponent.prototype.OnParentCheck = function (isChecked) {
	        this.listOfRecord
	            .filter(function (x) { return x.isValidRecord; })
	            .forEach(function (x) { return (x.sendActivationLinkToImportedPerson = isChecked); });
	    };
	    ImportPersonCsvComponent.prototype.GetInstanceList = function () {
	        var _this = this;
	        this.instanceService.GetImportAllowedInstance().subscribe(function (res) {
	            _this.instanceList = res.data;
	            // this.instanceHashId = this.instanceList && this.instanceList.length > 0 ?
	            //                       this.instanceList[0].instanceHashId : '';
	            if (_this.instanceList && _this.instanceList.length > 0) {
	                if (!_this.instanceHashId && _this.instanceList.length == 1) {
	                    _this.instanceHashId = _this.instanceList[0].keyHash;
	                }
	            }
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    ImportPersonCsvComponent.prototype.ValidateCSV = function () {
	        this.isLoading = true;
	        this.uploader.uploadAll();
	    };
	    ImportPersonCsvComponent.prototype.ImportCSV = function () {
	        this.isLoading = true;
	        this.ImportPersonRecord();
	    };
	    ImportPersonCsvComponent.prototype.ImportPersonRecord = function () {
	        var _this = this;
	        var validPersonList = this.listOfRecord.filter(function (x) { return x.isValidRecord; });
	        this.personService.ImportPersonRecord(validPersonList).subscribe(function (res) {
	            console.log(res);
	            if (res.data) {
	                var module = _this.translate.instant("LblPerson");
	                _this.popupMsg = _this.translate.instant("LblRecordImportedSuccess", [
	                    module
	                ]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.csvValidationMsg = res.error;
	            }
	            _this.listOfRecord = [];
	            _this.instanceHashId = "";
	            _this.isLoading = false;
	            _this.ResetPaging();
	        }, function (error) {
	            _this.csvValidationMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.listOfRecord = [];
	            _this.instanceHashId = "";
	            _this.isLoading = false;
	            _this.ResetPaging();
	        });
	    };
	    ImportPersonCsvComponent.prototype.OnInstanceTypeChange = function () {
	        // this.ClearFileInput();
	        this.listOfRecord = [];
	        this.ResetPaging();
	    };
	    ImportPersonCsvComponent.prototype.ClearFileInput = function () {
	        console.log(this.csvFile);
	        if (this.csvFile.nativeElement) {
	            console.log(this.csvFile.nativeElement.value);
	            this.csvFile.nativeElement.value = "";
	            this.uploader.clearQueue();
	        }
	    };
	    ImportPersonCsvComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.FilterList();
	    };
	    ImportPersonCsvComponent.prototype.FilterList = function () {
	        var start = this.DataListModel.itemsPerPage * (this.DataListModel.currentPage - 1);
	        var end = start + this.DataListModel.itemsPerPage;
	        this.listOfFilterRecord = this.listOfRecord.slice(start, end);
	    };
	    ImportPersonCsvComponent.prototype.ResetPaging = function () {
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.itemsPerPage = 100;
	    };
	    ImportPersonCsvComponent.prototype.HandleOnAfterAddingFile = function (fileItem) {
	        if (this.uploader.queue.length > 1) {
	            this.uploader.queue.forEach(function (element) {
	                element.remove();
	            });
	        }
	    };
	    ImportPersonCsvComponent.prototype.HandleOnBuildItemForm = function (fileItem, Form) {
	        Form.append("instanceHashId", this.instanceHashId);
	    };
	    ImportPersonCsvComponent.prototype.HandleOnCompleteItem = function (item, response, status, headers) {
	        //following method redirect to error page if error
	        this.authService.HandleErrorStatusCode(status);
	        this.ResetPaging();
	        var apiresponse = JSON.parse(response);
	        if (status == 200) {
	            if (!apiresponse.error) {
	                this.csvValidationMsg = "";
	                this.listOfRecord = apiresponse.data;
	                this.DataListModel.totalItems = apiresponse.totalRecords;
	                this.FilterList();
	            }
	            else {
	                this.csvValidationMsg = apiresponse.error;
	                this.listOfRecord = [];
	            }
	        }
	        this.isLoading = false;
	        this.ClearFileInput();
	    };
	    ImportPersonCsvComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    ImportPersonCsvComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    ImportPersonCsvComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    __decorate([
	        core_1.ViewChild("csvFile"), 
	        __metadata('design:type', Object)
	    ], ImportPersonCsvComponent.prototype, "csvFile", void 0);
	    __decorate([
	        core_1.ViewChild("successPopup"), 
	        __metadata('design:type', Object)
	    ], ImportPersonCsvComponent.prototype, "successPopup", void 0);
	    ImportPersonCsvComponent = __decorate([
	        core_1.Component({
	            selector: "wego-import-person-csv",
	            template: __webpack_require__(885),
	            providers: [person_service_1.PersonService, instance_service_1.InstanceService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof person_service_1.PersonService !== 'undefined' && person_service_1.PersonService) === 'function' && _b) || Object, (typeof (_c = typeof instance_service_1.InstanceService !== 'undefined' && instance_service_1.InstanceService) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object])
	    ], ImportPersonCsvComponent);
	    return ImportPersonCsvComponent;
	    var _a, _b, _c, _d;
	}());
	exports.ImportPersonCsvComponent = ImportPersonCsvComponent;


/***/ },
/* 885 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ 'LblImportPerson' | translate }}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"urlPersonList\">\r\n            <i class=\"fa fa-user fa-fw\"></i>{{ breadCrumbList }}</a>\r\n        </li>\r\n        <li class=\"active\">{{ 'LblImportPerson' | translate }}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25 \">\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <!--<pre> {{ model | json }}</pre>-->\r\n    <div class=\"nopad\">\r\n      <form (ngSubmit)=\"ValidateCSV()\" class=\"mar_bot_10\">\r\n        <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Instance\" class=\"form-group col-sm-3\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblInstance' | translate }}</label>\r\n          <select [(ngModel)]=\"instanceHashId\" class=\"form-control\" name=\"instanceHashId\" (change)=\"OnInstanceTypeChange()\">\r\n            <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblInstance' | translate }}</option>\r\n            <option *ngFor=\"let item of instanceList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\r\n          </select>\r\n        </div>\r\n        <div class=\"form-group col-sm-3\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblCSVFile' | translate }}</label>\r\n          <input #csvFile type=\"file\" accept=\".csv\" ng2FileSelect [uploader]=\"uploader\" style=\"width: 100%;\" />\r\n        </div>\r\n        <div class=\"form-group col-sm-6\">\r\n          <br>\r\n          <button *ngIf=\"ValidFormData\" class=\"btn btn-gray\" type=\"submit\">\r\n            {{ 'LblValidateCSV' | translate }}\r\n          </button>\r\n          <button *ngIf=\"ValidImportRecord\" class=\"btn btn-green\" type=\"button\" (click)=\"ImportCSV()\">\r\n            <span>\r\n              {{ 'LblImportValidPerson' | translate }}\r\n            </span>\r\n          </button>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"col-sm-12\">\r\n          <p class=\"text-danger\">\r\n            {{ csvValidationMsg }}\r\n          </p>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"col-sm-12\">\r\n        </div>\r\n      </form>\r\n      <hr>\r\n      <!--<pre> {{ listOfFilterRecord | json }} </pre>-->\r\n      <div class=\"table table-responsive mar_bot_ziro\">\r\n        <table *ngIf=\"listOfRecord && listOfRecord.length > 0\" class=\"table table-bordered mar_bot_ziro\">\r\n          <thead>\r\n            <tr>\r\n              <th colspan=\"9\"></th>\r\n              <!--<th colspan=\"5\">{{ 'LblHomeAddress' | translate }}</th>-->\r\n              <th colspan=\"5\">{{ 'LblWorkAddress' | translate }}</th>\r\n            </tr>\r\n            <tr>\r\n              <!--<th class=\"text-center parent-checkbox\">\r\n                <input type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\">\r\n              </th>-->\r\n              <th>\r\n              </th>\r\n              <th>\r\n                {{ 'LblUserName' | translate }}\r\n              </th>\r\n              <th>\r\n                {{ 'LblFirstName' | translate }}\r\n              </th>\r\n              <th>\r\n                {{ 'LblMiddleName' | translate }}\r\n              </th>\r\n              <th>\r\n                {{ 'LblLastName' | translate }}\r\n              </th>\r\n              <th>\r\n                {{ 'LblDateOfBirth' | translate }}\r\n              </th>\r\n              <th>\r\n                {{ 'LblEmail' | translate }}\r\n              </th>\r\n              <th>\r\n                {{ 'LblMobileNumber' | translate }}\r\n              </th>\r\n              <th>\r\n                {{ 'LblPhoneNumber' | translate }}\r\n              </th>\r\n              <!--<th>\r\n                {{ 'LblInstance' | translate }}\r\n              </th>\r\n\r\n              <th>\r\n                {{ 'LblStreetName' | translate }}\r\n              </th>\r\n              <th>\r\n                {{ 'LblHouseNo' | translate }}\r\n              </th>\r\n              <th>\r\n                {{ 'LblHouseExtention' | translate }}\r\n              </th>\r\n              <th>\r\n                {{ 'LblZipCode' | translate }}\r\n              </th>\r\n              <th>\r\n                {{ 'LblCity' | translate }}\r\n              </th>-->\r\n\r\n              <th>\r\n                {{ 'LblStreetName' | translate }}\r\n              </th>\r\n              <th>\r\n                {{ 'LblHouseNo' | translate }}\r\n              </th>\r\n              <th>\r\n                {{ 'LblHouseExtention' | translate }}\r\n              </th>\r\n              <th>\r\n                {{ 'LblZipCode' | translate }}\r\n              </th>\r\n              <th>\r\n                {{ 'LblCity' | translate }}\r\n              </th>\r\n            </tr>\r\n          </thead>\r\n          <tbody>\r\n            <tr *ngFor=\"let person of listOfFilterRecord\">\r\n              <!--<td class=\"text-center\"><input *ngIf=\"person.isValidRecord\" type=\"checkbox\" name=\"isActive\" [(ngModel)]=\"person.sendActivationLinkToImportedPerson\"></td>-->\r\n              <td>\r\n                <i *ngIf=\"person.isValidRecord\" class=\"fa fa-thumbs-up text-success fa-fw\" aria-hidden=\"true\"></i>\r\n                <i *ngIf=\"!person.isValidRecord\" class=\"fa fa-thumbs-down text-danger fa-fw cursor-pointer\" [popover]=\"invalidReason\" aria-hidden=\"true\"></i>\r\n                <popover-content #invalidReason [hidden]=\"person.isValidRecord\" title=\"{{ 'LblInvalidReason' | translate }}\" placement=\"bottom\"\r\n                  [animation]=\"true\" [closeOnClickOutside]=\"true\">\r\n                  <table class=\"table table-bordered mar_bot_ziro\" style=\"border: 1px solid #E0E0E0;\">\r\n                    <tbody>\r\n                      <tr *ngFor=\"let errorData of person.errorModel\">\r\n                        <!--<td>{{ errorData.key }}</td>-->\r\n                        <td class=\"error-td\">{{ errorData.value }}</td>\r\n                      </tr>\r\n                    </tbody>\r\n                  </table>\r\n                </popover-content>\r\n              </td>\r\n              <td>{{ person.userName }}</td>\r\n              <td>{{ person.firstName }}</td>\r\n              <td>{{ person.middleName }}</td>\r\n              <td>{{ person.lastName }} </td>\r\n              <td>{{ person.dateOfBirth }} </td>\r\n              <td>{{ person.emailAddressModel.email }} </td>\r\n              <td>{{ person.telephone1 }}</td>\r\n              <td>{{ person.telephone2 }}</td>\r\n              <!--\r\n              <td>{{ person.instanceName }}</td>\r\n\r\n              <td>{{ person.personHomeAddressModel?.street }}</td>\r\n              <td>{{ person.personHomeAddressModel?.houseNo }}</td>\r\n              <td>{{ person.personHomeAddressModel?.houseExtention }}</td>\r\n              <td>{{ person.personHomeAddressModel?.zipCode }}</td>\r\n              <td>{{ person.personHomeAddressModel?.city }}</td>\r\n              -->\r\n\r\n              <td>{{ person.personWorkAddressModel?.street }}</td>\r\n              <td>{{ person.personWorkAddressModel?.houseNo }}</td>\r\n              <td>{{ person.personWorkAddressModel?.houseExtention }}</td>\r\n              <td>{{ person.personWorkAddressModel?.zipCode }}</td>\r\n              <td>{{ person.personWorkAddressModel?.city }}</td>\r\n            </tr>\r\n          </tbody>\r\n        </table>\r\n        <div *ngIf=\"DataListModel.totalItems > 0\" class=\"col-sm-12\">\r\n          <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n            [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n            lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>";

/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var common_1 = __webpack_require__(22);
	var additionalfreeitems_service_1 = __webpack_require__(887);
	var additionalfreeitems_model_1 = __webpack_require__(888);
	var flatpickr_model_1 = __webpack_require__(83);
	var AdditionalFreeItemsUpdateComponent = (function () {
	    function AdditionalFreeItemsUpdateComponent(addtionaleFreeItemsService, translate, activeRoute, router, authService, locationService) {
	        this.addtionaleFreeItemsService = addtionaleFreeItemsService;
	        this.translate = translate;
	        this.activeRoute = activeRoute;
	        this.router = router;
	        this.authService = authService;
	        this.locationService = locationService;
	        this.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
	    }
	    AdditionalFreeItemsUpdateComponent.prototype.ngOnInit = function () {
	        this.typeList = [
	            {
	                Key: 'MINUTES',
	                Value: 'MINUTES'
	            },
	            {
	                Key: 'MILEAGE',
	                Value: 'MILEAGE'
	            }];
	        this.module = this.translate.instant('LblAdditionalFreeItems');
	        this.breadCrumbTitle = this.isEditMode ? this.translate.instant('LblEditPage', [this.module]) : this.translate.instant('LblAddPage', [this.module]);
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	        this.urlAdditionalItemList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_ADDITIONALFREEITEM_LIST);
	        this.flatPickrConfigDate = this.SetDefaultFlatPickrConfig();
	        this.model = new additionalfreeitems_model_1.AddtionalFreeItemModel();
	        this.GetAdditionalDetails();
	    };
	    AdditionalFreeItemsUpdateComponent.prototype.SetDefaultFlatPickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = true;
	        flatPickrConfig.time_24hr = true;
	        flatPickrConfig.dateFormat = this.dateFormat;
	        flatPickrConfig.minuteIncrement = 1;
	        flatPickrConfig.minDate = new Date(new Date().setHours(0, 0, 0));
	        return flatPickrConfig;
	    };
	    AdditionalFreeItemsUpdateComponent.prototype.SuccessSelectDriverSubscriptionModal = function ($event) {
	        this.model.sharedVehicleDriverHashId = $event.sharedVehicleDriverHashId;
	        this.model.driverName = $event.driverName;
	    };
	    AdditionalFreeItemsUpdateComponent.prototype.onSubmit = function (forms) {
	        this.model.type = "MILEAGE";
	        console.log(this.model);
	        this.AddAdditionalFreeItems();
	    };
	    AdditionalFreeItemsUpdateComponent.prototype.GetAdditionalDetails = function () {
	        var _this = this;
	        this.sub = this.activeRoute
	            .params
	            .subscribe(function (params) {
	            _this.additionalFreeItemHashId = params['additionalFreeItemHashId'] || '';
	            if (_this.additionalFreeItemHashId != '') {
	                _this.isEditMode = true;
	                _this.addtionaleFreeItemsService.GetAdditionalFreeItemByHashId(_this.additionalFreeItemHashId)
	                    .subscribe(function (res) {
	                    _this.model = res.data;
	                    _this.typeValue = _this.model.type == "MINUTES" ? "(Minute)" : "(Kilometer)";
	                }, function (error) {
	                    _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	                });
	            }
	            else {
	                _this.isEditMode = false;
	                _this.model = new additionalfreeitems_model_1.AddtionalFreeItemModel();
	                _this.model.type = _this.typeList[1].Value;
	                _this.typeValue = _this.model.type == "MINUTES" ? "(Minute)" : "(Kilometer)";
	            }
	        });
	        this.breadCrumbTitle = this.isEditMode ? this.translate.instant('LblEditPage', [this.module]) : this.translate.instant('LblAddPage', [this.module]);
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	    };
	    AdditionalFreeItemsUpdateComponent.prototype.AddAdditionalFreeItems = function () {
	        var _this = this;
	        this.addtionaleFreeItemsService.AddNewDriverSubscription(this.model)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.isEditMode ? _this.translate.instant('LblRecordUpdatedSuccess', [_this.module]) : _this.translate.instant('LblRecordAddedSuccess', [_this.module]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    AdditionalFreeItemsUpdateComponent.prototype.OnChangeType = function () {
	        this.typeValue = this.model.type == "MINUTES" ? "(Minute)" : "(Kilometer)";
	    };
	    AdditionalFreeItemsUpdateComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    AdditionalFreeItemsUpdateComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    AdditionalFreeItemsUpdateComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    AdditionalFreeItemsUpdateComponent.prototype.OnBackClick = function () {
	        this.locationService.back();
	    };
	    Object.defineProperty(AdditionalFreeItemsUpdateComponent.prototype, "diagnostic", {
	        // TODO: Remove this when we're done
	        get: function () { return JSON.stringify(this.model); },
	        enumerable: true,
	        configurable: true
	    });
	    AdditionalFreeItemsUpdateComponent.prototype.GetImageURL = function (imagePath) {
	        return config_1.WeGoConfig.API_SERVER_URL + imagePath;
	    };
	    AdditionalFreeItemsUpdateComponent.prototype.ngOnDestroy = function () {
	        if (this.sub) {
	            this.sub.unsubscribe();
	        }
	    };
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], AdditionalFreeItemsUpdateComponent.prototype, "successPopup", void 0);
	    AdditionalFreeItemsUpdateComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-additionalfreeitems',
	            template: __webpack_require__(889),
	            providers: [additionalfreeitems_service_1.AdditionalFreeItemService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof additionalfreeitems_service_1.AdditionalFreeItemService !== 'undefined' && additionalfreeitems_service_1.AdditionalFreeItemService) === 'function' && _a) || Object, (typeof (_b = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _e) || Object, (typeof (_f = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _f) || Object])
	    ], AdditionalFreeItemsUpdateComponent);
	    return AdditionalFreeItemsUpdateComponent;
	    var _a, _b, _c, _d, _e, _f;
	}());
	exports.AdditionalFreeItemsUpdateComponent = AdditionalFreeItemsUpdateComponent;


/***/ },
/* 887 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var AdditionalFreeItemService = (function () {
	    function AdditionalFreeItemService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    AdditionalFreeItemService.prototype.GetAdditionalFreeItemsList = function (input) {
	        var getUrl = config_1.WeGoConfig.API_GET_ADDITIONAL_FREEITEMS;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getUrl = getUrl + "?" + queryString;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdditionalFreeItemService.prototype.ExportAdditionalFreeItemsList = function (input) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var getUrl = config_1.WeGoConfig.API_EXPORT_DRIVERSUBSCRIPTION + "?" + queryString;
	        var headers = this.authService.GetHeader('text/csv');
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getUrl, options);
	    };
	    AdditionalFreeItemService.prototype.DeleteAdditionalFreeItemList = function (deleteAdditionalFreeItemList) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_POST_DELETE_DRIVERSUBSCRIPTION, deleteAdditionalFreeItemList, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdditionalFreeItemService.prototype.GetDriverSubscriptionList = function (input) {
	        var getUrl = config_1.WeGoConfig.API_GET_DRIVERSUBSCRIPTION_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getUrl = getUrl + "?" + queryString;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdditionalFreeItemService.prototype.GetAdditionalFreeItemByHashId = function (additionalFreeItemHashId) {
	        var getUrl = config_1.WeGoConfig.API_GET_ADDITIONALFREEITEM_BY_HASH + "?additionalFreeItemHashId=" + additionalFreeItemHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdditionalFreeItemService.prototype.AddNewDriverSubscription = function (addtionalFreeItemModel) {
	        var body = addtionalFreeItemModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_POST_DRIVERSUBSCRIPTION, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdditionalFreeItemService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], AdditionalFreeItemService);
	    return AdditionalFreeItemService;
	    var _a, _b;
	}());
	exports.AdditionalFreeItemService = AdditionalFreeItemService;


/***/ },
/* 888 */
/***/ function(module, exports) {

	"use strict";
	var AddtionalFreeItemModel = (function () {
	    function AddtionalFreeItemModel() {
	    }
	    return AddtionalFreeItemModel;
	}());
	exports.AddtionalFreeItemModel = AddtionalFreeItemModel;


/***/ },
/* 889 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{breadCrumbTitle}}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li><a [routerLink]=\"urlDefaultPage\"><i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a></li>\r\n        <li><a [routerLink]=\"urlAdditionalItemList\"><i class=\"fa fa-tags fa-fw\"></i>{{breadCrumbList}}</a></li>\r\n        <li class=\"active\">{{breadCrumbTitle}}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25 \">\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <!--<pre>{{ model | json }}</pre>-->\r\n    <div class=\"nopad\">\r\n      <form (ngSubmit)=\"OnSubmit(AddAddtionalFreeItemorm.value)\" #AddAddtionalFreeItem=\"ngForm\">\r\n\r\n        <div *ngIf=\"!model.isEditMode && !authService.IsDriver()\" class=\"form-group col-md-4\">\r\n          <label><span class=\"text text-danger\">*</span>{{ 'LblDriver' | translate }}</label>\r\n          <div class=\"input-group\">\r\n            <input [disabled]=\"isEditMode\" [(ngModel)]=\"model.driverName\" name=\"driverName\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblDriver' | translate }}\" readonly>\r\n            <div class=\"input-group-btn\">\r\n              <button [disabled]=\"isEditMode\" class=\"btn btn-default\" type=\"button\" (click)=\"selectDriverSubscriptionModal.show()\">\r\n              <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\r\n            </button>\r\n            </div>\r\n          </div>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'SharedVehicleDriverHashId' }}</span>\r\n        </div>\r\n        <div class=\"form-group col-md-4\">\r\n          <label><span class=\"text text-danger\">*</span>{{ 'LblAmount' | translate }}\r\n          </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblAmount' | translate }}\" [(ngModel)]=\"model.amount\" name=\"amount\" maxlength=\"6\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'amount' }}</span>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"form-group col-md-4\">\r\n          <label><span class=\"text text-danger\">*</span>{{ 'LblDateAwared' | translate }}</label>\r\n          <div class=\"input-group\">\r\n            <span class=\"input-group-addon\"><i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i></span>\r\n            <input class=\"form-control\" placeholder=\"{{ 'LblDateAwared' | translate }}\" [(ngModel)]=\"model.dateAwaredDatetime\" name=\"dateAwaredDatetime\" [Config]=\"flatPickrConfigDate\" flatpickr readonly>\r\n          </div>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'dateAwaredDatetime' }}</span>\r\n        </div>\r\n        <div class=\"row no-margin\">\r\n          <div class=\"col-sm-12\">\r\n            <hr>\r\n            <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnBackClick()\">{{ 'LblCancel' | translate }}</a> &nbsp;&nbsp;\r\n            <button class=\"btn btn-green\" type=\"button\" (click)=\"onSubmit()\">{{ 'LblSave' | translate }}</button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </section>\r\n</div>\r\n<wego-select-driver-subscription-popup #selectDriverSubscriptionModal (OnSuccessSelect)=\"SuccessSelectDriverSubscriptionModal($event)\"></wego-select-driver-subscription-popup>\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>";

/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var config_1 = __webpack_require__(60);
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_2 = __webpack_require__(60);
	var additionalfreeitems_service_1 = __webpack_require__(887);
	var AdditionalFreeItemListComponent = (function () {
	    function AdditionalFreeItemListComponent(additionalFreeItemService, authService, router, translate) {
	        this.additionalFreeItemService = additionalFreeItemService;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	    }
	    Object.defineProperty(AdditionalFreeItemListComponent.prototype, "isAnyChecked", {
	        get: function () {
	            if (this.additionalFreeItemList) {
	                var isCheck = this.additionalFreeItemList.some(function (x) { return x.isChecked == true; });
	                if (isCheck) {
	                    if (this.additionalFreeItemList.every(function (x) { return x.isChecked == true; }))
	                        this.isParentCheck = true;
	                    else
	                        this.isParentCheck = false;
	                }
	                else {
	                    this.isParentCheck = false;
	                }
	                return isCheck;
	            }
	            else {
	                this.isParentCheck = false;
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    AdditionalFreeItemListComponent.prototype.ngOnInit = function () {
	        this.module = this.translate.instant('LblAdditionalFreeItems');
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = ["driverName", "subscriptionName", "sharedVehicleGroup", "dateAwaredDatetimeUTC", "createdDatetimeUTC", "createdBy", "type", "amount", "organizationName"];
	        this.urlDefaultPage = this.authService.GetURL(config_2.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlAdditionalFreeItemsUpdate = this.authService.GetURL(config_2.ApplicationRouteURL.URL_ADDITIONALFREEITEM_UPDATE);
	        this.urlAdditionalFreeItemsAdd = this.authService.GetURL(config_2.ApplicationRouteURL.URL_ADDITIONALFREEITEM_ADD);
	        this.GetAdditionalFreeItemList();
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	        this.addAdditionFreeItemsLink = new config_1.WeGoAuthorizedLink(this.urlAdditionalFreeItemsAdd, config_1.Permission.PR_ADDITIONAL_FREE_ITEMS, config_1.PermissionType.INSERT, 'btn btn-highlight navbar-right', 'LblAddNew');
	    };
	    AdditionalFreeItemListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetAdditionalFreeItemList();
	    };
	    AdditionalFreeItemListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetAdditionalFreeItemList();
	    };
	    AdditionalFreeItemListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetAdditionalFreeItemList();
	    };
	    ;
	    AdditionalFreeItemListComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetAdditionalFreeItemList();
	    };
	    AdditionalFreeItemListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.additionalFreeItemService.ExportAdditionalFreeItemsList(this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "AdditionalFreeItems" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AdditionalFreeItemListComponent.prototype.GetAdditionalFreeItemList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.additionalFreeItemService.GetAdditionalFreeItemsList(this.DataListModel)
	            .subscribe(function (res) {
	            _this.additionalFreeItemList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AdditionalFreeItemListComponent.prototype.OnParentCheck = function (isChecked) {
	        this.additionalFreeItemList.forEach(function (x) { return x.isChecked = isChecked; });
	    };
	    AdditionalFreeItemListComponent.prototype.DeleteAdditionalFreeItems = function (deleteAdditionalFreeItemsList) {
	        var _this = this;
	        this.isLoading = true;
	        this.additionalFreeItemService.DeleteAdditionalFreeItemList(deleteAdditionalFreeItemsList)
	            .subscribe(function (res) {
	            _this.DataListModel.currentPage = 1;
	            _this.GetAdditionalFreeItemList();
	            _this.popupMsg = _this.translate.instant('LblRecordRemovedSuccess', [_this.module]);
	            _this.ShowSuccessPopup();
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AdditionalFreeItemListComponent.prototype.ShowChildModal = function (additionalFreeItemHashId) {
	        if (additionalFreeItemHashId) {
	            this.popupMsg = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
	            this.isMultipleDelete = false;
	            this.additionalFreeItemMasterHashId = additionalFreeItemHashId;
	        }
	        else {
	            this.popupMsg = this.translate.instant('LblRecordMultiplDeleteConfirmation', [this.module]);
	            this.isMultipleDelete = true;
	        }
	        this.childModal.show();
	    };
	    AdditionalFreeItemListComponent.prototype.HideChildModal = function () {
	        this.childModal.hide();
	    };
	    AdditionalFreeItemListComponent.prototype.SuccessModalClick = function () {
	        var deleteAdditinalFreeItemsList;
	        if (this.isMultipleDelete)
	            deleteAdditinalFreeItemsList = this.additionalFreeItemList.filter(function (x) { return x.isChecked; }).map(function (x) { return x.additionalFreeItemMasterHashId; });
	        else
	            deleteAdditinalFreeItemsList.push(this.additionalFreeItemMasterHashId);
	        this.DeleteAdditionalFreeItems(deleteAdditinalFreeItemsList);
	        this.childModal.hide();
	    };
	    AdditionalFreeItemListComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    AdditionalFreeItemListComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    AdditionalFreeItemListComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    AdditionalFreeItemListComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], AdditionalFreeItemListComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild('childModal'), 
	        __metadata('design:type', Object)
	    ], AdditionalFreeItemListComponent.prototype, "childModal", void 0);
	    AdditionalFreeItemListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-additionalfreeitems-list',
	            template: __webpack_require__(891),
	            providers: [additionalfreeitems_service_1.AdditionalFreeItemService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof additionalfreeitems_service_1.AdditionalFreeItemService !== 'undefined' && additionalfreeitems_service_1.AdditionalFreeItemService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object])
	    ], AdditionalFreeItemListComponent);
	    return AdditionalFreeItemListComponent;
	    var _a, _b, _c, _d;
	}());
	exports.AdditionalFreeItemListComponent = AdditionalFreeItemListComponent;


/***/ },
/* 891 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ breadCrumbList}} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li><a [routerLink]=\"urlDefaultPage\"><i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a></li>\r\n        <li class=\"active\"> {{ breadCrumbList}} </li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25\">\r\n        <wego-authorized-link [LinkModel]=\"addAdditionFreeItemsLink\"></wego-authorized-link>\r\n      <!-- <a class=\"btn btn-highlight navbar-right\" [routerLink]=\"[urlAdditionalFreeItemsUpdate]\" routerLinkActive=\"active\">{{ 'LblAddNew' | translate }}</a> -->\r\n    </div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <p class=\"text-success\">{{ message }}</p>\r\n        <wego-search-list [IsDeleted]=\"false\" [IsDeleteEnabled]=\"isAnyChecked\" (OnDeleteAll)=\"ShowChildModal()\" (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <!--<th class=\"text-center parent-checkbox\"><input type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\"></th>-->\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('driverName')\">\r\n                  {{ 'LblDriver' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'driverName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('organizationName')\">\r\n                  {{ 'LblOrganization' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'organizationName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('subscriptionName')\">\r\n                  {{ 'LblSubscription' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'subscriptionName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('sharedVehicleGroup')\">\r\n                  {{ 'LblSharedVehicleGroup' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'sharedVehicleGroup'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('dateAwaredDatetimeUTC')\">\r\n                  {{ 'LblDateAwared' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'dateAwaredDatetimeUTC'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('createdDatetimeUTC')\">\r\n                  {{ 'LblCrearedDate' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'createdDatetimeUTC'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('createdBy')\">\r\n                  {{ 'LblCreatedBy' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'createdBy'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('amount')\">\r\n                  {{ 'LblAmount' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'amount'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <!--<th class=\"text-center\">{{ 'LblEdit' | translate }}</th>-->\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let freeitems of additionalFreeItemList\">\r\n                  <!--<td class=\"text-center\"><input type=\"checkbox\" name=\"isActive\" [(ngModel)]=\"freeitems.isChecked\"></td>-->\r\n                  <td>{{ freeitems.driverName }}</td>\r\n                  <td>{{ freeitems.organizationName }}</td>\r\n                  <td>{{ freeitems.subscriptionName }}</td>\r\n                  <td>{{ freeitems.sharedVehicleGroup }}</td>\r\n                  <td>{{ freeitems.dateAwaredDatetime }}</td>\r\n                  <td>{{ freeitems.createdDatetime }}</td>\r\n                  <td>{{ freeitems.createdBy }}</td>\r\n                  <td>{{ freeitems.amount }}</td>\r\n                  <!--<td class=\"text-center\">\r\n                    <a [routerLink]=\"[urlAdditionalFreeItemsUpdate, { additionalFreeItemHashId : freeitems.additionalFreeItemMasterHashId }]\">\r\n                      <i class=\"fa fa-pencil-square-o fa-fw\"></i>\r\n                    </a>\r\n                  </td>-->\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"9\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\" [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\"\r\n                firstText=\"&laquo;\" lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n<wego-confirm-popup #childModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessModalClick()\" (onReject)=\"HideChildModal()\"></wego-confirm-popup>";

/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var flatpickr_model_1 = __webpack_require__(83);
	var driverlicencedetail_service_1 = __webpack_require__(893);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var driverlicencedetail_model_1 = __webpack_require__(894);
	var config_1 = __webpack_require__(60);
	var DriverLicenceComponent = (function () {
	    function DriverLicenceComponent(driverLicenceService, router, authService) {
	        this.driverLicenceService = driverLicenceService;
	        this.router = router;
	        this.authService = authService;
	        this.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_FORMAT;
	    }
	    DriverLicenceComponent.prototype.ngOnInit = function () {
	        this.isLoading = true;
	        this.flatPickrConfigDateOfBirth = this.SetDefaultFlatPickrConfig();
	        this.model = new driverlicencedetail_model_1.DriverLicenceModel();
	        this.isLoading = false;
	    };
	    DriverLicenceComponent.prototype.SetDefaultFlatPickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = false;
	        flatPickrConfig.time_24hr = false;
	        flatPickrConfig.dateFormat = this.dateFormat;
	        flatPickrConfig.minuteIncrement = 1;
	        flatPickrConfig.maxDate = new Date(new Date());
	        return flatPickrConfig;
	    };
	    DriverLicenceComponent.prototype.DriverLicenceDetail = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.driverLicenceService.AddDriverLicenceDetail(this.model)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.isLoading = false;
	                localStorage.setItem('current_role', 'DRIVER');
	                _this.router.navigate(['/driver']);
	            }
	            else {
	                _this.errorModel = res.error;
	                _this.isLoading = false;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    DriverLicenceComponent.prototype.Login = function () {
	        this.authService.Logout();
	        this.router.navigate(['/']);
	    };
	    DriverLicenceComponent.prototype.ngOnDestroy = function () { console.log('ngOnDestroy'); };
	    DriverLicenceComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-backoffice',
	            template: __webpack_require__(895),
	            providers: [driverlicencedetail_service_1.DriverLicenceService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof driverlicencedetail_service_1.DriverLicenceService !== 'undefined' && driverlicencedetail_service_1.DriverLicenceService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object])
	    ], DriverLicenceComponent);
	    return DriverLicenceComponent;
	    var _a, _b, _c;
	}());
	exports.DriverLicenceComponent = DriverLicenceComponent;


/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var config_1 = __webpack_require__(60);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var DriverLicenceService = (function () {
	    function DriverLicenceService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    DriverLicenceService.prototype.AddDriverLicenceDetail = function (driverlicencedetail) {
	        var body = driverlicencedetail;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_POST_DRIVER_LICENCE_DETAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    DriverLicenceService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], DriverLicenceService);
	    return DriverLicenceService;
	    var _a, _b;
	}());
	exports.DriverLicenceService = DriverLicenceService;


/***/ },
/* 894 */
/***/ function(module, exports) {

	"use strict";
	var DriverLicenceModel = (function () {
	    function DriverLicenceModel() {
	    }
	    return DriverLicenceModel;
	}());
	exports.DriverLicenceModel = DriverLicenceModel;


/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<section class=\"login-bg\">\r\n  <div class=\"wrapper\" style=\"background-color: transparent;\">\r\n    <div class=\"container\" style=\"margin-top:120px\">\r\n      <div class=\"row\">\r\n        <div class=\"col-sm-4 login-center\">\r\n          <div class=\"login-panel panel-default\">\r\n            <div>\r\n              <form>\r\n                <fieldset>\r\n                  <div class=\"row\">\r\n                    <div class=\"center-block\">\r\n                      <img src=\"" + __webpack_require__(634) + "\" alt=\"\" class=\"img-responsive login-profile-img\">\r\n                      <h4 class=\"text-center login-text\" style=\"color:#fff;\">{{ 'LblValidateLiceanceNumberMessage' | translate }}</h4>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class=\"col-xs-12\">\r\n                      <div>\r\n                        <div class=\"form-group col-md-12\">\r\n                          <label><font color=\"white\">{{ 'LblDateOfBirth' | translate }}</font></label>\r\n                          <<input class=\"form-control\" [Config]=\"flatPickrConfigDateOfBirth\" placeholder=\"{{ 'LblDateOfBirth' | translate }}\" [(ngModel)]=\"model.dateOfBirth\" name=\"dateOfBirth\" flatpickr readonly/>\r\n                          <span class=\"text-center\" style=\"background-color:#dd4b39\"><font color=\"white\">{{ errorModel | serverErrorMessage : 'dateOfBirth' }}</font></span>\r\n                        </div>\r\n                        <div class=\"clearfix\"></div>\r\n                        <div class=\"form-group col-md-12\">\r\n                          <label><font color=\"white\"> {{ 'LblDriverLicenceNumber' | translate }} </font></label>\r\n                          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblDriverLicenceNumber' | translate }}\" [(ngModel)]=\"model.DriverLicenceNumber\" name=\"DriverLicenceNumber\" maxlength=\"25\">\r\n                          <span class=\"text-center\" style=\"background-color:#dd4b39\"><font color=\"white\">{{ errorModel | serverErrorMessage : 'DriverLicenceNumber' }}</font></span>\r\n                        </div>\r\n                        <div class=\"clearfix\"></div>\r\n                        <input type=\"button\" value=\"{{'LblValidate' | translate}}\" class=\"col-xs-12 btn btn-sm login-submit-button\" (click)=\"DriverLicenceDetail()\" style=\"padding: 3px 10px; font-size: 16px;\" />\r\n                        <input type=\"button\" value=\"{{'LblBack' | translate}}\" class=\"col-xs-12 btn btn-sm login-submit-button\" (click)=\"Login()\" style=\"padding: 3px 10px; font-size: 16px;\" />\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </fieldset>\r\n              </form>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>";

/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var login_model_1 = __webpack_require__(897);
	var config_1 = __webpack_require__(60);
	var LoginComponent = (function () {
	    function LoginComponent(router, route, authService, activeRoute, translateService) {
	        this.router = router;
	        this.route = route;
	        this.authService = authService;
	        this.activeRoute = activeRoute;
	        this.translateService = translateService;
	        this.tenantid = "";
	        this.subdomain = "";
	    }
	    LoginComponent.prototype.ngOnInit = function () {
	        this.translateService.setDefaultLang("en");
	        this.translateService.setDetectedLang();
	        this.model = new login_model_1.LoginModel("", "");
	        this.subdomain = window.location.host.toLocaleLowerCase().split('.')[1] ? window.location.host.toLocaleLowerCase().split('.')[0] : "";
	        if (this.subdomain.length > 0 && this.subdomain != 'bo') {
	            this.SsoStep1();
	            this.SsoStep2();
	        }
	    };
	    LoginComponent.prototype.OnSubmitSso = function () {
	        this.isLoading = true;
	        var tempVal = localStorage.getItem("computerId");
	        localStorage.clear();
	        localStorage.setItem("computerId", tempVal);
	        var url = config_1.WeGoConfig.API_GET_INITIATE_SSO + this.tenantid + '?backoffice=true';
	        window.location.href = url;
	    };
	    LoginComponent.prototype.OnSubmit = function () {
	        var _this = this;
	        this.isLoading = true;
	        var tempVal = localStorage.getItem("computerId");
	        localStorage.clear();
	        localStorage.setItem("computerId", tempVal);
	        this.authService.Login(this.model.userName, this.model.password).subscribe(function (res) {
	            _this.isLoading = false;
	        }, function (error) {
	            console.log(error);
	            if (error.status == 401) {
	                _this.errorMessage = _this.translateService.instant("LblLoginCredentialsError");
	            }
	            else {
	                _this.errorMessage = _this.translateService.instant("LblLoginError");
	            }
	            _this.isLoading = false;
	        }, function () {
	            if (_this.authService.isLoggedIn()) {
	                _this.router.navigate(["/backoffice"]);
	            }
	            else {
	                console.log("Unauthorized");
	            }
	        });
	    };
	    LoginComponent.prototype.CheckIsAlreadyLoggedIn = function () {
	        if (this.authService.isLoggedIn()) {
	            if (this.authService.IsAdmin()) {
	                this.router.navigate(["/admin"]);
	            }
	            else if (this.authService.IsDriver()) {
	                this.router.navigate(["/driver"]);
	            }
	            else {
	                this.router.navigate(["/underconstruction"]);
	                this.authService.Logout();
	            }
	        }
	    };
	    // Get tenantId by subdomain from ssoconfig settings
	    LoginComponent.prototype.SsoStep1 = function () {
	        var _this = this;
	        this.authService.GetSsoConfig(this.subdomain).subscribe(function (res) {
	            if (res) {
	                _this.tenantid = res.data.tenantId;
	            }
	        }, function (error) {
	            console.log(error);
	        }, function () {
	            if (_this.tenantid) {
	                localStorage.removeItem("access_token");
	                localStorage.removeItem("refresh_token");
	                localStorage.removeItem("current_role");
	                localStorage.removeItem("user_setting");
	                localStorage.removeItem("personMasterHashId");
	                localStorage.removeItem("itemsPerPage");
	                localStorage.removeItem("language");
	                localStorage.removeItem("driverSelectedMenu");
	                _this.isSSO = true;
	            }
	            else {
	                _this.CheckIsAlreadyLoggedIn();
	            }
	        });
	    };
	    LoginComponent.prototype.SsoStep2 = function () {
	        var _this = this;
	        var saml = this.route.snapshot.queryParams["saml"];
	        if (saml != null) {
	            this.authService.GetSsoTokenAssertion(saml).subscribe(function (res) {
	                _this.isLoading = false;
	            }, function (error) {
	                console.log(error);
	                if (error.status == 401) {
	                    _this.errorMessage = _this.translateService.instant("LblLoginCredentialsError");
	                }
	                else {
	                    _this.errorMessage = _this.translateService.instant("LblLoginError");
	                }
	                _this.isLoading = false;
	            }, function () {
	                if (_this.authService.isLoggedIn()) {
	                    _this.router.navigate(["/backoffice"]);
	                }
	                else {
	                    console.log("Unauthorized");
	                }
	            });
	        }
	    };
	    LoginComponent = __decorate([
	        core_1.Component({
	            selector: "wego-login",
	            template: __webpack_require__(898),
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _a) || Object, (typeof (_b = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object, (typeof (_e = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _e) || Object])
	    ], LoginComponent);
	    return LoginComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.LoginComponent = LoginComponent;


/***/ },
/* 897 */
/***/ function(module, exports) {

	"use strict";
	var LoginModel = (function () {
	    function LoginModel(userName, password) {
	        this.userName = userName;
	        this.password = password;
	    }
	    return LoginModel;
	}());
	exports.LoginModel = LoginModel;


/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<section class=\"login-bg\">\r\n  <div class=\"wrapper\" style=\"background-color: transparent;\">\r\n    <div class=\"container\" style=\"margin-top:120px\">\r\n      <div class=\"row\">\r\n        <div class=\"col-sm-5 login-center\">\r\n          <div class=\"login-panel panel-default\">\r\n            <div>\r\n              <form (ngSubmit)=\"OnSubmit()\" #loginForm=\"ngForm\" method=\"post\" *ngIf=\"!isSSO\">\r\n                <fieldset>\r\n                  <div class=\"row\">\r\n                    <div class=\"center-block\">\r\n                      <img src=\"" + __webpack_require__(634) + "\" alt=\"\" class=\"img-responsive login-profile-img\">\r\n                      <h1 class=\"text-center login-text\" style=\"color:#fff;\">Login</h1>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class=\"col-sm-12 col-md-10  col-md-offset-1 \">\r\n                      <div class=\"form-group\">\r\n                        <p *ngIf=\"errorMessage\" style=\"background-color: #eb4b4b; color: white; padding: 5px;\" class=\"text-center\">\r\n                          {{ errorMessage }}\r\n                        </p>\r\n                      </div>\r\n                      <div class=\"form-group\">\r\n                        <div class=\"input-group\">\r\n                          <span class=\"input-group-addon\">\r\n                            <i class=\"fa fa-user fa-fw\" aria-hidden=\"true\"></i>\r\n                          </span>\r\n                          <input [(ngModel)]=\"model.userName\" class=\"login-form-control\" placeholder=\"Username\" name=\"userName\" type=\"text\" autofocus>\r\n                        </div>\r\n                      </div>\r\n                      <div class=\"form-group\">\r\n                        <div class=\"input-group\">\r\n                          <span class=\"input-group-addon\">\r\n                            <i class=\"fa fa-key fa-fw\" aria-hidden=\"true\"></i>\r\n                          </span>\r\n                          <input [(ngModel)]=\"model.password\" class=\"login-form-control\" placeholder=\"Password\" name=\"password\" type=\"password\">\r\n                        </div>\r\n                      </div>\r\n                      <div class=\"form-group\">\r\n                        <button type=\"submit\" class=\"btn btn-lg login-submit-button btn-block\">Sign In</button>\r\n                      </div>\r\n                      <div class=\"form-group\">\r\n                        <a href=\"/#/forgotpassword\" routerLinkActive=\"active\" style=\"text-align: center\">Forgot Password?</a>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </fieldset>\r\n              </form>\r\n              \r\n              <form (ngSubmit)=\"OnSubmitSso()\" #loginForm=\"ngForm\" method=\"post\" *ngIf=\"isSSO\">\r\n                <fieldset>\r\n                  <div class=\"row\">\r\n                    <div class=\"center-block\">\r\n                      <img src=\"" + __webpack_require__(634) + "\" alt=\"\" class=\"img-responsive login-profile-img\">\r\n                      <h1 class=\"text-center login-text\" style=\"color:#fff;\">Login</h1>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class=\"col-sm-12 col-md-10  col-md-offset-1 \">\r\n                      <div class=\"form-group\">\r\n                        <button type=\"submit\" class=\"btn btn-lg login-submit-button btn-block\">SSO Login</button>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </fieldset>\r\n              </form>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>";

/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var vehicletroubleshoot_service_1 = __webpack_require__(900);
	var vehicle_service_1 = __webpack_require__(530);
	var VTSTroubleshootComponent = (function () {
	    function VTSTroubleshootComponent(vtsTroubleshootService, translate, authService, activeRoute, router, vehicleService) {
	        this.vtsTroubleshootService = vtsTroubleshootService;
	        this.translate = translate;
	        this.authService = authService;
	        this.activeRoute = activeRoute;
	        this.router = router;
	        this.vehicleService = vehicleService;
	    }
	    VTSTroubleshootComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.module = this.translate.instant('LblTroubleShootVTS');
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = ["LicenceTag", "VTSDoorStatus", "VTSLastLatitude", "VTSLastLongitude"];
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	        this.urlVtsHistory = this.authService.GetURL(config_1.ApplicationRouteURL.URL_VTS_HISTORY_LIST);
	        this.urlVehicleInfo = this.authService.GetURL(config_1.ApplicationRouteURL.URL_VEHICLE_INFO);
	        this.urlVtsVehicleUpdate = this.authService.GetURL(config_1.ApplicationRouteURL.URL_VTSVEHICLE_UPDATE);
	        this.activeRoute
	            .params
	            .subscribe(function (params) {
	            _this.vehicleHashId = params['id'] ? params['id'] : params['vehicleHashId'];
	            _this.GetVehicleObuStatus();
	            _this.GetServiceStatus();
	        });
	    };
	    VTSTroubleshootComponent.prototype.GetServiceStatus = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.vtsTroubleshootService.GetVTSStatus()
	            .subscribe(function (res1) {
	            _this.serviceStatus = res1.data;
	            _this.isLoading = false;
	        }, function (error1) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error1);
	            _this.isLoading = false;
	        });
	    };
	    VTSTroubleshootComponent.prototype.GetVehicleObuStatus = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.vtsTroubleshootService.GetVehicleObuStatus(this.DataListModel, this.vehicleHashId)
	            .subscribe(function (res) {
	            _this.VehicleObuStatusList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    VTSTroubleshootComponent.prototype.LockVTSVehicle = function (locationDataExchangeHashId) {
	        var _this = this;
	        this.isLoading = true;
	        this.vehicleService.LockVTSVehicle(locationDataExchangeHashId, false)
	            .subscribe(function (res) {
	            _this.isLoading = false;
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblLockSuccessfully');
	                _this.ShowSuccessPopup();
	            }
	            else {
	                if (res.error.toUpperCase() == "ACTION ABORTED, ENGINE STILL RUNNING") {
	                    _this.popupMsg = _this.translate.instant("LblEngineStillRunning");
	                    _this.popupTitle = _this.translate.instant("LblWarning");
	                }
	                else {
	                    _this.popupMsg = _this.translate.instant('LbllockProblem');
	                    _this.popupTitle = _this.translate.instant('LblWarning');
	                }
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.isLoading = false;
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    VTSTroubleshootComponent.prototype.UnLockVTSVehicle = function (locationDataExchangeHashId) {
	        var _this = this;
	        this.isLoading = true;
	        this.vehicleService.UnLockVTSVehicle(locationDataExchangeHashId, false)
	            .subscribe(function (res) {
	            _this.isLoading = false;
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblUnLockSuccessfully');
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblUnlockProblem');
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.isLoading = false;
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    VTSTroubleshootComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.popupTitle = this.popupTitle;
	        this.successPopup.popupMsg = this.popupMsg;
	        this.successPopup.show();
	    };
	    VTSTroubleshootComponent.prototype.ConfirmSuccessPopup = function () {
	        this.GetVehicleObuStatus();
	    };
	    VTSTroubleshootComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetVehicleObuStatus();
	    };
	    VTSTroubleshootComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetVehicleObuStatus();
	    };
	    VTSTroubleshootComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetVehicleObuStatus();
	    };
	    VTSTroubleshootComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetVehicleObuStatus();
	    };
	    ;
	    VTSTroubleshootComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.vtsTroubleshootService.ExportVehicleObuStatus(this.DataListModel, this.vehicleHashId)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "VehcleObuStatus" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    VTSTroubleshootComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], VTSTroubleshootComponent.prototype, "successPopup", void 0);
	    VTSTroubleshootComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-vts-troubleshoot',
	            template: __webpack_require__(901),
	            providers: [vehicletroubleshoot_service_1.VTSTroubleshootService, vehicle_service_1.VehicleService],
	            styles: [
	                "\n    .alert{\n      margin-bottom: 0px;\n    }\n    .alert-default{\n      background-color: #2BA2AA;\n    }\n    "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof vehicletroubleshoot_service_1.VTSTroubleshootService !== 'undefined' && vehicletroubleshoot_service_1.VTSTroubleshootService) === 'function' && _a) || Object, (typeof (_b = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object, (typeof (_e = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _e) || Object, (typeof (_f = typeof vehicle_service_1.VehicleService !== 'undefined' && vehicle_service_1.VehicleService) === 'function' && _f) || Object])
	    ], VTSTroubleshootComponent);
	    return VTSTroubleshootComponent;
	    var _a, _b, _c, _d, _e, _f;
	}());
	exports.VTSTroubleshootComponent = VTSTroubleshootComponent;


/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var jquery_helper_service_1 = __webpack_require__(67);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var VTSTroubleshootService = (function () {
	    function VTSTroubleshootService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	        this.JQueryHelper = new jquery_helper_service_1.JQueryHelperService();
	    }
	    VTSTroubleshootService.prototype.GetVTSStatus = function () {
	        var getDriverUrl = config_1.WeGoConfig.API_VTS_TROUBLESHOOT_GETVTSSTATUS_URL;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getDriverUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    VTSTroubleshootService.prototype.GetVehicleObuStatus = function (input, vehicleHashId) {
	        var getVehicleUrl = config_1.WeGoConfig.API_VTS_TROUBLESHOOT_GETOBUSTATUS_URL;
	        var queryString = this.authService.HandleAPIListInput(input);
	        getVehicleUrl = getVehicleUrl + "?" + queryString;
	        if (vehicleHashId) {
	            getVehicleUrl = getVehicleUrl + "&vehicleHashId=" + vehicleHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getVehicleUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    VTSTroubleshootService.prototype.ExportVehicleObuStatus = function (input, vehicleHashId) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var getVehicleExportUrl = config_1.WeGoConfig.API_VTS_TROUBLESHOOT_EXPORTOBUSTATUS_URL;
	        getVehicleExportUrl = getVehicleExportUrl + "?" + queryString;
	        if (vehicleHashId) {
	            getVehicleExportUrl = getVehicleExportUrl + "&vehicleHashId=" + vehicleHashId;
	        }
	        var headers = this.authService.GetHeader('text/csv');
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getVehicleExportUrl, options);
	    };
	    VTSTroubleshootService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], VTSTroubleshootService);
	    return VTSTroubleshootService;
	    var _a, _b;
	}());
	exports.VTSTroubleshootService = VTSTroubleshootService;


/***/ },
/* 901 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n    <section class=\"content-header\">\r\n        <div class=\"col-md-9 col-sm-6\">\r\n            <h1 class=\"pagename\">{{ breadCrumbList}} </h1>\r\n            <ol class=\"breadcrumb\">\r\n                <li>\r\n                    <a [routerLink]=\"urlDefaultPage\">\r\n                        <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n                </li>\r\n                <li class=\"active\"> {{ breadCrumbList}} </li>\r\n            </ol>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n        <div class=\"clearfix\"></div>\r\n    </section>\r\n    <section class=\"content\">\r\n        <div class=\"row\">\r\n            <div class=\"col-md-12\">\r\n                <div *ngIf=\"serviceStatus\" class=\"alert alert-default\">\r\n                    <strong>{{ 'LblVtsServiceStatus' | translate }}:</strong> {{serviceStatus?.serviceStatus}}\r\n                    <br>\r\n                    <strong>{{ 'LblLastReceivedTime' | translate }}:</strong> {{serviceStatus?.lastStatusReceivedTime}}\r\n                </div>\r\n                <!--<div style=\"padding-left: 0px;\" class=\"panel form-group col-md-4\">\r\n          <div class=\"panel panel-primary\">\r\n            <div class=\"panel-heading\"> {{ 'LblVtsServiceStatus' | translate }}</div>\r\n            <div class=\"panel-body\">\r\n              <div *ngIf=\"serviceStatus\">\r\n                <b>{{ 'LblStatus' | translate }}:</b> {{serviceStatus.serviceStatus}}<br/>\r\n                <b>{{ 'LblLastReceivedTime' | translate }}:</b> {{serviceStatus.lastStatusReceivedTime}}\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>-->\r\n            </div>\r\n        </div>\r\n        <h3 class=\"box-title\">{{ 'LblVehicleObuStatus' | translate }}</h3>\r\n        <wego-search-list (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\"\r\n            [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <p class=\"text-success\">{{ message }}</p>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n            <table class=\"table table-bordered mar_bot_ziro\">\r\n                <thead>\r\n                    <tr>\r\n                        <th class=\"cursor-pointer\" (click)=\"OnSort('LicenceTag')\">\r\n                            {{ 'LblLicenceTag' | translate }}\r\n                            <wego-sort-list [FieldName]=\"'LicenceTag'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                        </th>\r\n                        <th class=\"cursor-pointer\" (click)=\"OnSort('VTSLicenseTag')\">\r\n                            {{ 'LblVtsLicencetag' | translate }}\r\n                            <wego-sort-list [FieldName]=\"'VTSLicenseTag'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                        </th>\r\n                        <th class=\"cursor-pointer\" (click)=\"OnSort('VTSLastLatitude')\">\r\n                            {{'LblVehicleLocation' | translate }}\r\n                            <wego-sort-list [FieldName]=\"'VTSLastLatitude'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                        </th>\r\n                        <th class=\"cursor-pointer\" (click)=\"OnSort('VTSDoorStatus')\">\r\n                            {{'LblVtsDoorStatus' | translate}}\r\n                            <wego-sort-list [FieldName]=\"'VTSDoorStatus'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                        </th>\r\n                        <th class=\"text-center cursor-pointer\" (click)=\"OnSort('VTSIssueCommand')\">\r\n                            {{'LblVtsIssueCommand' | translate }}\r\n                            <wego-sort-list [FieldName]=\"'VTSIssueCommand'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                        </th>\r\n                        <th class=\"text-center\">\r\n                            {{'LblEventHistory' | translate }}\r\n                        </th>\r\n                    </tr>\r\n                </thead>\r\n                <tbody>\r\n                    <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                        <tr *ngFor=\"let vehicle of VehicleObuStatusList\">\r\n                            <td>\r\n\r\n                                <span *ngIf=\"!vehicle.isVehicleStatus\">\r\n                                    {{ vehicle.licenceTag }}\r\n                                </span>\r\n\r\n                                <a *ngIf=\"vehicle.isVehicleStatus\" [routerLink]=\"urlVehicleInfo +'/'+ vehicle.wegoVehicleHashId\">\r\n                                    {{ vehicle.licenceTag }}\r\n                                </a>\r\n                            </td>\r\n                            <td>\r\n                                <span *ngIf=\"!vehicle.isvtsVehicle\">\r\n                                    {{vehicle.vtsLicenseTag }}\r\n                                </span>\r\n                                <a *ngIf=\"vehicle.isvtsVehicle\" [routerLink]=\"urlVtsVehicleUpdate + '/'+ vehicle.vtsVehicleHashId\">\r\n                                    {{vehicle.vtsLicenseTag }}\r\n                                </a>\r\n                            </td>\r\n                            <td>\r\n                                <span *ngIf=\"vehicle.vtsLicenseTag\">{{vehicle.vtsLocation }}</span>\r\n                            </td>\r\n                            <td>{{vehicle.vtsDoorStatus }}</td>\r\n                            <td class=\"text-center\">\r\n                                <div *ngIf=\"vehicle.brand != 'AXA' && vehicle.obuType != 'Axa'\">\r\n                                    <a *ngIf=\"vehicle.vtsIssueCommand=='UNLOCK' || vehicle.vtsIssueCommand=='LOCK'\" class=\"btn btn-danger btn-xs cursor-pointer\" title=\"{{'LblLock' | translate}}\"\r\n                                        (click)=\"LockVTSVehicle(vehicle.locationDataExchangeHashId)\">\r\n                                        <i class=\"fa fa-lock\"></i>&nbsp;{{ 'LblLock' | translate }}\r\n                                    </a>\r\n                                    <a *ngIf=\"vehicle.vtsIssueCommand=='UNLOCK' || vehicle.vtsIssueCommand=='LOCK'\" class=\"btn btn-green btn-xs cursor-pointer\" title=\"{{'LblUnLock' | translate}}\"\r\n                                        (click)=\"UnLockVTSVehicle(vehicle.locationDataExchangeHashId)\">\r\n                                        <i class=\"fa fa-unlock\"></i>&nbsp;{{ 'LblUnLock' | translate }}\r\n                                    </a>\r\n                                    <span *ngIf=\"vehicle.vtsDoorStatus && vehicle.vtsIssueCommand!='LOCK' && vehicle.vtsIssueCommand!='UNLOCK'\">{{ 'LblVehicleNotInitialized' | translate }}</span>\r\n                                </div>\r\n                            </td>\r\n                            <td class=\"text-center\">\r\n\r\n                                <a *ngIf=\"vehicle.vtsLicenseTag && !vehicle.isvtsVehicleEventHitory\" disabled>\r\n                                    <i class=\"fa fa-history\"></i>\r\n                                </a>\r\n                                <a *ngIf=\"vehicle.vtsLicenseTag && vehicle.isvtsVehicleEventHitory\" [routerLink]=\"[urlVtsHistory ,{ vehicleMasterHashId : vehicle.vtsVehicleHashId }]\">\r\n                                    <i class=\"fa fa-history\"></i>\r\n                                </a>\r\n                            </td>\r\n                        </tr>\r\n                    </template>\r\n                    <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                        <td class=\"text-center text-danger\" colspan=\"6\">\r\n                            {{ DataListModel.infoMessage }}\r\n                        </td>\r\n                    </tr>\r\n                </tbody>\r\n            </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n            <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n                <div class=\"col-md-12\">\r\n                    <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                        [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\"\r\n                        firstText=\"&laquo;\" lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </section>\r\n</div>\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n";

/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var translate_service_1 = __webpack_require__(70);
	var router_1 = __webpack_require__(26);
	var signupfromconfig_service_1 = __webpack_require__(903);
	var signupformconfig_model_1 = __webpack_require__(904);
	var config_1 = __webpack_require__(60);
	var auth_service_1 = __webpack_require__(58);
	var common_1 = __webpack_require__(22);
	var signup_service_1 = __webpack_require__(905);
	var signup_model_1 = __webpack_require__(906);
	var terms_condition_popup_service_1 = __webpack_require__(639);
	var privacy_popup_service_1 = __webpack_require__(640);
	var SignUpComponent = (function () {
	    function SignUpComponent(signupConfigService, signupService, router, activeRoute, translate, authService, locationService, termsConditionPopup, privacyPopup) {
	        this.signupConfigService = signupConfigService;
	        this.signupService = signupService;
	        this.router = router;
	        this.activeRoute = activeRoute;
	        this.translate = translate;
	        this.authService = authService;
	        this.locationService = locationService;
	        this.termsConditionPopup = termsConditionPopup;
	        this.privacyPopup = privacyPopup;
	        this.isLoading = false;
	        this.languageLbl = 'en';
	        this.roleLevel = config_1.RoleLevel;
	    }
	    SignUpComponent.prototype.ngOnInit = function () {
	        this.translate.setDetectedLang();
	        this.signUpConfigModel = new signupformconfig_model_1.SignupFormConfigModel();
	        this.model = new signup_model_1.SignupModel();
	        this.module = this.translate.instant('LblSignup');
	        this.GetTelephoneCountry();
	        this.GerSignUpDetail();
	        this.languageLbl = ['en', 'nl', 'de', 'fr', 'pl', 'pt'].indexOf(this.translate.currentLang) >= 0 ? this.translate.currentLang : 'de';
	        this.GetTermsAndConditionsBySignupFormParam(this.signupParam);
	        this.GetPrivacyBySignUpFormParam(this.signupParam);
	        this.GetPersonCountry();
	    };
	    SignUpComponent.prototype.GetTelephoneCountry = function () {
	        var _this = this;
	        this.authService.GetTelephoneCountry()
	            .subscribe(function (res) {
	            _this.countryList = res.data;
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    SignUpComponent.prototype.GetPersonCountry = function () {
	        var _this = this;
	        this.authService.GetPersonCountry()
	            .subscribe(function (res) {
	            _this.personCountryList = res.data;
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    SignUpComponent.prototype.GerSignUpDetail = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.sub = this.activeRoute
	            .params
	            .subscribe(function (params) {
	            _this.signupParam = params['id'] || 'NA'; //'_Bx9u3eZsUw$';
	            _this.signupConfigService.GetSignupFormDetails(_this.signupParam)
	                .subscribe(function (res) {
	                _this.signUpConfigModel = res.data;
	                _this.model.countryCode1 = _this.signUpConfigModel.countryCode1;
	                _this.model.countryCode2 = _this.signUpConfigModel.countryCode2;
	                _this.model.countryCodeHashId = _this.signUpConfigModel.defaultCountryHashId;
	                _this.isLoading = false;
	                console.log(_this.signUpConfigModel);
	            }, function (error) {
	                _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	                _this.isLoading = false;
	            });
	        });
	    };
	    SignUpComponent.prototype.onSubmit = function (forms) {
	        this.SignUp();
	    };
	    SignUpComponent.prototype.SignUp = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.model.signupParam = this.signupParam;
	        this.model.acceptedTermsAndConditionsHashIdList = this.termsAndConditionList.filter(function (b) { return b.accepted; }).map(function (a) { return a.termsAndConditionsHashId; });
	        this.model.privacyHashId = this.privacyHashId;
	        this.model.svgWiseSubscriptionList = this.signUpConfigModel.svgWiseSubscriptionList;
	        var lang = this.translate.currentLang;
	        this.signupService.SignUp(this.model, lang)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblRecordAddedSuccess', [_this.module]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                if (typeof res.error != "string") {
	                    _this.errorModel = res.error;
	                }
	                else {
	                    _this.errorMessage = res.error;
	                }
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SignUpComponent.prototype.OnSubscriptionCheck = function (selectedSubscriptionHashId, svgHashId) {
	        var svgWiseSubscription = this.signUpConfigModel.svgWiseSubscriptionList.filter(function (b) { return b.svgHashId == svgHashId; })[0].subscriptiopnListForSignupForm.filter(function (n) { return n.organizationSubscriptionHashId != selectedSubscriptionHashId; });
	        var selectedsvgWiseSubscription = this.signUpConfigModel.svgWiseSubscriptionList.filter(function (b) { return b.svgHashId == svgHashId; })[0].subscriptiopnListForSignupForm.filter(function (n) { return n.organizationSubscriptionHashId == selectedSubscriptionHashId; });
	        selectedsvgWiseSubscription[0].isChecked = true;
	        for (var _i = 0, svgWiseSubscription_1 = svgWiseSubscription; _i < svgWiseSubscription_1.length; _i++) {
	            var objSubscription = svgWiseSubscription_1[_i];
	            objSubscription.isChecked = false;
	        }
	    };
	    SignUpComponent.prototype.GetSubscriptionChecked = function (SubscriptionHashId, svgHashId) {
	        if (this.signUpConfigModel && this.signUpConfigModel.svgWiseSubscriptionList) {
	            var selectedsvgWiseSubscription = this.signUpConfigModel.svgWiseSubscriptionList.filter(function (b) { return b.svgHashId == svgHashId; })[0].subscriptiopnListForSignupForm.filter(function (n) { return n.sharedVehicleGroupSubscriptionHashId == SubscriptionHashId; });
	            if (selectedsvgWiseSubscription && selectedsvgWiseSubscription.length > 0) {
	                return selectedsvgWiseSubscription[0].isChecked;
	            }
	        }
	        return false;
	    };
	    SignUpComponent.prototype.ChangeCurrentLanguage = function (lang) {
	        this.languageLbl = lang;
	        localStorage.setItem("language", this.languageLbl);
	        location.reload(true);
	    };
	    SignUpComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    SignUpComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	        window.location.href = this.signUpConfigModel.successURL;
	    };
	    SignUpComponent.prototype.GetImageURL = function (imagePath) {
	        return config_1.WeGoConfig.API_SERVER_URL + imagePath;
	    };
	    SignUpComponent.prototype.OnBackClick = function () {
	        this.locationService.back();
	    };
	    SignUpComponent.prototype.showTnC = function (termsAndConditionsHashId) {
	        var tnc = this.termsAndConditionList.filter(function (x) { return x.termsAndConditionsHashId == termsAndConditionsHashId; })[0];
	        if (tnc != null) {
	            this.bodyHTMLText = tnc.content;
	        }
	        this.termsConditionModel.show(this.bodyHTMLText);
	    };
	    SignUpComponent.prototype.showPrivacyStatement = function () {
	        this.privacyModel.show(this.privacyBodyHTMLText);
	    };
	    SignUpComponent.prototype.GetTermsAndConditionsBySignupFormParam = function (signupFormParam) {
	        var _this = this;
	        this.termsConditionPopup.GetTermsAndConditionsBySignupFormParam(signupFormParam)
	            .subscribe(function (res) {
	            if (res.data) {
	                // this.bodyHTMLText = res.data.content;
	                // if (res.data.content) {
	                //   this.isBodyContent = true;
	                // }
	                // this.termsAndConditionHashId = res.data.termsAndConditionsHashId;
	                _this.termsAndConditionList = res.data;
	            }
	            else {
	                _this.errorMessage = res.error;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    SignUpComponent.prototype.GetPrivacyBySignUpFormParam = function (signupFormParam) {
	        var _this = this;
	        this.privacyPopup.GetPrivacyBySignUpFormParam(signupFormParam)
	            .subscribe(function (res) {
	            if (res.data && res.data.content) {
	                _this.privacyBodyHTMLText = res.data.content;
	                if (res.data.content) {
	                    _this.isPrivacyBodyContent = true;
	                }
	                _this.privacyHashId = res.data.termsAndConditionsHashId;
	            }
	            else {
	                _this.errorMessage = res.error;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    SignUpComponent.prototype.ngOnDestroy = function () {
	        if (this.sub) {
	            this.sub.unsubscribe();
	        }
	    };
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], SignUpComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild("termsConditionModel"), 
	        __metadata('design:type', Object)
	    ], SignUpComponent.prototype, "termsConditionModel", void 0);
	    __decorate([
	        core_1.ViewChild("privayStatementModel"), 
	        __metadata('design:type', Object)
	    ], SignUpComponent.prototype, "privacyModel", void 0);
	    SignUpComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-signup',
	            template: __webpack_require__(907),
	            providers: [signupfromconfig_service_1.SignupFormConfigService, signup_service_1.SignupService, terms_condition_popup_service_1.TermsConditionPopup, privacy_popup_service_1.PrivacyStatementPopup],
	            styles: ["\n    .logo img\n    {\n      height: 100px;\n      float: right;\n    }\n\n    .scroll-bar\n    {\n        overflow:auto;\n        height: 200px;    \n    }\n\n    .signupFormTitle\n    {\n      font-size: 35px;\n      text-align: center;\n      position:absolute;\n      color: #3c8dbc;\n      left:0px;\n      right:0px;\n    }\n\n    .signupFormFooter\n    {\n      font-size: 20px;\n      text-align: center;\n      position:absolute;\n      color: #3c8dbc;\n      left:0px;\n      right:0px;\n    }\n\n    .nav-pills > li {\n      margin: 0;\n    }\n\n    .nav-pills > li > a {\n      border-top: 0;\n      background-color: #d7d7d7;\n    }\n    .nav-pills > li > a:hover,\n    .nav-pills > li > a:focus{\n      border-top: 0;\n      background-color: #ddd;\n    }\n\n    .input-group.telephone-group .input-group-addon {\n      padding: 0px;\n      border: 0px;\n    }\n    .country-select {\n      width: 60px;\n      border: 1px solid #d2d6de;\n      padding: 3px;\n    }\n  "]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof signupfromconfig_service_1.SignupFormConfigService !== 'undefined' && signupfromconfig_service_1.SignupFormConfigService) === 'function' && _a) || Object, (typeof (_b = typeof signup_service_1.SignupService !== 'undefined' && signup_service_1.SignupService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object, (typeof (_e = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _e) || Object, (typeof (_f = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _f) || Object, (typeof (_g = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _g) || Object, (typeof (_h = typeof terms_condition_popup_service_1.TermsConditionPopup !== 'undefined' && terms_condition_popup_service_1.TermsConditionPopup) === 'function' && _h) || Object, (typeof (_j = typeof privacy_popup_service_1.PrivacyStatementPopup !== 'undefined' && privacy_popup_service_1.PrivacyStatementPopup) === 'function' && _j) || Object])
	    ], SignUpComponent);
	    return SignUpComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
	}());
	exports.SignUpComponent = SignUpComponent;


/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var SignupFormConfigService = (function () {
	    function SignupFormConfigService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    SignupFormConfigService.prototype.GetSignupFormList = function (input) {
	        var getSignupConfigUrl = config_1.WeGoConfig.API_GET_SIGNUP_CONFIG_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getSignupConfigUrl = getSignupConfigUrl + "?" + queryString;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getSignupConfigUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SignupFormConfigService.prototype.GetSignupFormByHashId = function (instanceHashId) {
	        var getSignupConfigUrl = config_1.WeGoConfig.API_GET_SIGNUP_CONFIG_BY_HASH +
	            "?signupFormConfigHashID=" +
	            instanceHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getSignupConfigUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SignupFormConfigService.prototype.UpdateSignupFormConfig = function (bodyData) {
	        var body = bodyData;
	        var headers = this.authService.GetHeader("application/json", "application/x-www-form-urlencoded");
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_SIGNUP_CONFIG_DETAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SignupFormConfigService.prototype.DeleteSignupFormConfig = function (selectedTemplates) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_DELETE_SIGNUP_CONFIG, selectedTemplates, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SignupFormConfigService.prototype.GetSignupFormDetails = function (signupParam) {
	        var getSignupConfigUrl = config_1.WeGoConfig.API_GET_SIGNUP_CONFIG_DETAILS +
	            "?signupFormParam=" +
	            signupParam;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getSignupConfigUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SignupFormConfigService.prototype.GetSubscriptionList = function (organizationHashId, signupFormConfigHashId) {
	        var getSubscriptionListUrl = config_1.WeGoConfig.API_GET_SUBSCRIPTION_LIST_SIGNUP;
	        getSubscriptionListUrl =
	            getSubscriptionListUrl +
	                "?organizationHashId=" +
	                organizationHashId +
	                "&SignupFormConfigHashId=" +
	                signupFormConfigHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getSubscriptionListUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SignupFormConfigService.prototype.ExportSignupConfigList = function (input) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var getSignupFormListUrl = config_1.WeGoConfig.API_EXPORT_SIGNUP_CONFIG;
	        if (queryString) {
	            getSignupFormListUrl = getSignupFormListUrl + "?" + queryString;
	        }
	        var headers = this.authService.GetHeader("text/csv");
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getSignupFormListUrl, options);
	    };
	    SignupFormConfigService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], SignupFormConfigService);
	    return SignupFormConfigService;
	    var _a, _b;
	}());
	exports.SignupFormConfigService = SignupFormConfigService;


/***/ },
/* 904 */
/***/ function(module, exports) {

	"use strict";
	var SignupFormConfigModel = (function () {
	    function SignupFormConfigModel() {
	        this.instanceHashId = '';
	        this.title = '';
	        this.description = '';
	        this.formLogoPath = '';
	        this.footerText = '';
	        this.successURL = 'https://bo.wego.app/';
	        this.sendActivationMail = false;
	        this.sendConfirmationMail = false;
	        this.adminApprovalRequired = false;
	        this.canApprovedByCompanyAdmin = false;
	        this.canApprovedByGroupAdmin = false;
	        this.canApprovedByOrganizationAdmin = false;
	        this.validEmailDomain = '';
	        this.fieldPassword = true;
	        this.fieldFirstName = false;
	        this.fieldMiddleName = false;
	        this.fieldLastName = false;
	        this.fieldMobileNumber = false;
	        this.fieldPhoneNumber = false;
	        this.fieldHomeAddress = false;
	        this.fieldNIFNumber = false;
	        this.instanceName = '';
	        this.svgFilter = '';
	        this.subscriptionListsortType = "";
	        this.organizationHashId = '';
	        this.countryCode1 = '';
	        this.countryCode2 = '';
	        this.isnifEnabled = false;
	    }
	    return SignupFormConfigModel;
	}());
	exports.SignupFormConfigModel = SignupFormConfigModel;
	var SubscriptionForSignupForm = (function () {
	    function SubscriptionForSignupForm() {
	    }
	    return SubscriptionForSignupForm;
	}());
	exports.SubscriptionForSignupForm = SubscriptionForSignupForm;


/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var config_1 = __webpack_require__(60);
	var http_1 = __webpack_require__(59);
	var core_1 = __webpack_require__(3);
	var auth_service_1 = __webpack_require__(58);
	var SignupService = (function () {
	    function SignupService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    SignupService.prototype.SignUp = function (signUpModel, lang) {
	        var body = signUpModel;
	        var headers = new http_1.Headers({
	            'Content-Type': 'application/json',
	            'Accept': 'application/json',
	            'Accept-Language': lang ? lang : 'en'
	        });
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_POST_SIGNUP_DETAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SignupService.prototype.ImportPersonRecord = function (batchUploadPersonModel) {
	        var body = batchUploadPersonModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_IMPORT_BATCH_UPLOAD_CSV, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SignupService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], SignupService);
	    return SignupService;
	    var _a, _b;
	}());
	exports.SignupService = SignupService;


/***/ },
/* 906 */
/***/ function(module, exports) {

	"use strict";
	var SignupModel = (function () {
	    function SignupModel() {
	        this.countryCode1 = '';
	        this.countryCode2 = '';
	        this.instanceHashId = '';
	        this.personRole = [];
	        this.isAccepted = false;
	        this.isPrivacyStatementAccepted = false;
	        this.isnifEnabled = false;
	        this.personHomeAddressModel = new PersonAddressModel();
	        this.personWorkAddressModel = new PersonAddressModel();
	    }
	    return SignupModel;
	}());
	exports.SignupModel = SignupModel;
	var PersonAddressModel = (function () {
	    function PersonAddressModel() {
	    }
	    return PersonAddressModel;
	}());
	exports.PersonAddressModel = PersonAddressModel;


/***/ },
/* 907 */
/***/ function(module, exports) {

	module.exports = "<div class=\"container\" style=\"margin: 15px auto;\">\r\n  <div class=\"row\">\r\n    <div class=\"col-md-4 pull-right\" style=\"margin-bottom: 10px;\">\r\n      <ul class=\"nav nav-pills pull-right\">\r\n        <li [ngClass]=\"{'active': languageLbl == 'en' }\" (click)=\"ChangeCurrentLanguage('en')\">\r\n          <a class=\"cursor-pointer\">EN</a>\r\n        </li>\r\n        <li [ngClass]=\"{'active': languageLbl == 'nl' }\" (click)=\"ChangeCurrentLanguage('nl')\">\r\n          <a class=\"cursor-pointer\">NL</a>\r\n        </li>\r\n        <li [ngClass]=\"{'active': languageLbl == 'de' }\" (click)=\"ChangeCurrentLanguage('de')\">\r\n          <a class=\"cursor-pointer\">DE</a>\r\n        </li>\r\n        <li [ngClass]=\"{'active': languageLbl == 'fr' }\" (click)=\"ChangeCurrentLanguage('fr')\">\r\n          <a class=\"cursor-pointer\">FR</a>\r\n        </li>\r\n        <li [ngClass]=\"{'active': languageLbl == 'pl' }\" (click)=\"ChangeCurrentLanguage('pl')\">\r\n          <a class=\"cursor-pointer\">PL</a>\r\n        </li>\r\n        <li [ngClass]=\"{'active': languageLbl == 'pt' }\" (click)=\"ChangeCurrentLanguage('pt')\">\r\n          <a class=\"cursor-pointer\">PT</a>\r\n        </li>\r\n      </ul>\r\n    </div>\r\n  </div>\r\n  <div class=\"header clearfix\">\r\n    <nav>\r\n      <ul class=\"nav nav-pills pull-right\">\r\n        <li *ngIf=\"signUpConfigModel.formLogoPath\">\r\n          <img [src]=\"GetImageURL(signUpConfigModel.formLogoPath)\" style=\"max-height: 100px;\">\r\n        </li>\r\n      </ul>\r\n    </nav>\r\n    <h1 class=\"text-muted text-center\" style=\"color: #2BA2AA;\">{{ signUpConfigModel.title }}</h1>\r\n  </div>\r\n  <section class=\"content\">\r\n    <div class=\"nopad\">\r\n      <p class=\"text-danger text-center\">{{ errorMessage }}</p>\r\n      <form (ngSubmit)=\"onSubmit(SignUpForm.value)\" #SignUpForm=\"ngForm\">\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblUserName' | translate }}\r\n          </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblUserName' | translate }}\" name=\"UserName\" [(ngModel)]=\"model.userName\"\r\n            maxlength=\"100\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'userName' }}</span>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblEmail' | translate }}\r\n          </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblEmail' | translate }}\" [(ngModel)]=\"model.email\" name=\"Email\"\r\n            maxlength=\"100\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'email' }}</span>\r\n        </div>        \r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblConfirmEmail' | translate }}\r\n          </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblConfirmEmail' | translate }}\" [(ngModel)]=\"model.ConfirmEmail\"\r\n            name=\"ConfirmEmail\" maxlength=\"100\">\r\n\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'confirmEmail' }}</span>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div *ngIf=\"signUpConfigModel.fieldPassword\">\r\n          <div class=\"form-group col-md-4\">\r\n            <label>\r\n              <span class=\"text text-danger\">*</span>{{ 'LblPassword' | translate }}\r\n            </label>\r\n            <input type=\"password\" class=\"form-control\" placeholder=\"{{ 'LblPassword' | translate }}\" [(ngModel)]=\"model.password\" name=\"Password\"\r\n              maxlength=\"100\">\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'password' }}</span>\r\n          </div>\r\n          <div class=\"form-group col-md-4\">\r\n            <label>\r\n              <span class=\"text text-danger\">*</span>{{ 'LblConfirmPassword' | translate }}\r\n            </label>\r\n            <input type=\"password\" class=\"form-control\" placeholder=\"{{ 'LblConfirmPassword' | translate }}\" [(ngModel)]=\"model.ConfirmPassword\"\r\n              name=\"ConfirmPassword\" maxlength=\"100\">\r\n\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'confirmPassword' }}</span>\r\n          </div>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div *ngIf=\"signUpConfigModel.fieldFirstName\">\r\n          <div class=\"form-group col-md-4\">\r\n            <label>\r\n              <span class=\"text text-danger\">*</span>{{ 'LblFirstName' | translate }}\r\n            </label>\r\n            <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblFirstName' | translate }}\" [(ngModel)]=\"model.firstName\" name=\"FirstName\"\r\n              maxlength=\"100\">\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'firstName' }}</span>\r\n          </div>\r\n        </div>\r\n        <div *ngIf=\"signUpConfigModel.fieldMiddleName\">\r\n          <div class=\"form-group col-md-4\">\r\n            <label>\r\n              <!-- <span class=\"text text-danger\">*</span> -->\r\n              {{ 'LblMiddleName' | translate }}\r\n            </label>\r\n            <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblMiddleName' | translate }}\" name=\"MiddleName\" [(ngModel)]=\"model.middleName\"\r\n              maxlength=\"100\">\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'middleName' }}</span>\r\n          </div>\r\n        </div>\r\n        <div *ngIf=\"signUpConfigModel.fieldLastName\">\r\n          <div class=\"form-group col-md-4\">\r\n            <label>\r\n              <span class=\"text text-danger\">*</span>{{ 'LblLastName' | translate }}\r\n            </label>\r\n            <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblLastName' | translate }}\" [(ngModel)]=\"model.lastName\" name=\"LastName\"\r\n              maxlength=\"100\">\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'lastName' }}</span>\r\n          </div>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span> {{ 'LblCountry' | translate }}\r\n          </label>\r\n          <div class=\"form-group inline\">\r\n            <select name=\"model.countryCodeHashId\" [(ngModel)]=\"model.countryCodeHashId\" class=\"form-control inline\">\r\n              <option *ngFor=\"let item of personCountryList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\r\n            </select>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'countryCode' }}</span>\r\n          </div>\r\n        </div>\r\n\r\n        <div *ngIf=\"signUpConfigModel.fieldMobileNumber\">\r\n          <div class=\"form-group col-md-4\">\r\n            <label>\r\n              <span class=\"text text-danger\">*</span>{{ 'LblMobileNumber' | translate }}\r\n            </label>\r\n            <div class=\"input-group telephone-group\">\r\n              <span class=\"input-group-addon\">\r\n                <select [(ngModel)]=\"model.countryCode1\" class=\"form-control country-select\" name=\"countryCode1\">\r\n                  <option value=\"\">-</option>\r\n                  <option *ngFor=\"let item of countryList\" [ngValue]=\"item.value\">{{ item.value }}</option>\r\n                </select>\r\n              </span>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblMobileNumber' | translate }}\" [(ngModel)]=\"model.telephone1\"\r\n                name=\"telephone1\" maxlength=\"20\">\r\n            </div>\r\n            <div class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'countryCode1' }}</div>\r\n            <div class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'telephone1' }}</div>\r\n          </div>\r\n        </div>\r\n        <div *ngIf=\"signUpConfigModel.fieldPhoneNumber\">\r\n          <div class=\"form-group col-md-4\">\r\n            <label>\r\n              <span class=\"text text-danger\">*</span>{{ 'LblPhoneNumber' | translate }}\r\n            </label>\r\n            <div class=\"input-group telephone-group\">\r\n              <span class=\"input-group-addon\">\r\n                <select [(ngModel)]=\"model.countryCode2\" class=\"form-control country-select\" name=\"countryCode2\">\r\n                  <option value=\"\">-</option>\r\n                  <option *ngFor=\"let item of countryList\" [ngValue]=\"item.value\">{{ item.value }}</option>\r\n                </select>\r\n              </span>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblPhoneNumber' | translate }}\" [(ngModel)]=\"model.telephone2\" name=\"telephone2\"\r\n                maxlength=\"20\">\r\n            </div>\r\n            <div class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'countryCode2' }}</div>\r\n            <div class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'telephone2' }}</div>\r\n          </div>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div *ngIf=\"signUpConfigModel.fieldNIFNumber\">\r\n          <div class=\"form-group col-md-4\">\r\n            <label>\r\n              {{ 'LblNIFNumber' | translate }}\r\n            </label>\r\n            <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblNIFNumber' | translate }}\" [(ngModel)]=\"model.nifNumber\"\r\n              name=\"nIFNumber\" maxlength=\"9\">\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'nIFNumber' }}</span>\r\n          </div>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <!--Address-->\r\n        <div class=\"row col-md-12\">\r\n          <!--Home Address-->\r\n          <fieldset class=\"col-md-12\" *ngIf=\"signUpConfigModel.fieldHomeAddress\">\r\n            <legend class=\"legendStyle\">\r\n              {{ 'LblHomeAddress' | translate }}\r\n            </legend>\r\n            <div class=\"clearfix\"></div>\r\n            <div class=\"form-group col-md-4\">\r\n              <label>\r\n                <span class=\"text text-danger\">*</span>{{ 'LblStreetName' | translate }}</label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblStreetName' | translate }}\" [(ngModel)]=\"model.personHomeAddressModel.street\"\r\n                name=\"personHomeAddressModel.street\" maxlength=\"100\">\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'personHomeAddressModel.street' }}</span>\r\n            </div>\r\n            <div class=\"form-group col-md-4\">\r\n              <label>\r\n                <span class=\"text text-danger\">*</span>{{ 'LblHouseNo' | translate }}</label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblHouseNo' | translate }}\" name=\"personHomeAddressModel.houseNo\"\r\n                [(ngModel)]=\"model.personHomeAddressModel.houseNo\" maxlength=\"15\">\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'personHomeAddressModel.houseNo' }}</span>\r\n            </div>\r\n            <div class=\"form-group col-md-4\">\r\n              <label>{{ 'LblHouseExtention' | translate }}</label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblHouseExtention' | translate }}\" name=\"personHomeAddressModel.houseExtention\"\r\n                [(ngModel)]=\"model.personHomeAddressModel.houseExtention\" maxlength=\"25\">\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'personHomeAddressModel.houseExtention' }}</span>\r\n            </div>\r\n            <div class=\"clearfix\"></div>\r\n            <div class=\"form-group col-md-4\">\r\n              <label>\r\n                <span class=\"text text-danger\">*</span>{{ 'LblZipCode' | translate }}</label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblZipCode' | translate }}\" name=\"personHomeAddressModel.zipCode\"\r\n                [(ngModel)]=\"model.personHomeAddressModel.zipCode\" maxlength=\"10\">\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'personHomeAddressModel.zipCode' }}</span>\r\n            </div>\r\n            <div class=\"form-group col-md-4\">\r\n              <label>\r\n                <span class=\"text text-danger\">*</span>{{ 'LblCity' | translate }}</label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblCity' | translate }}\" name=\"personHomeAddressModel.city\" maxlength=\"50\"\r\n                [(ngModel)]=\"model.personHomeAddressModel.city\">\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'personHomeAddressModel.city' }}</span>\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n\r\n        <div class=\"col-sm-12\" *ngIf=\"signUpConfigModel != undefined && signUpConfigModel != null && signUpConfigModel.svgWiseSubscriptionList != undefined &&  signUpConfigModel.svgWiseSubscriptionList.length > 0\">\r\n          <legend class=\"legendStyle\">\r\n            <span class=\"text text-danger\">*</span>{{ 'LblSubscription' | translate }}\r\n          </legend>\r\n          <div class=\"col-sm-12\" *ngFor=\"let svgWiseSubscription of signUpConfigModel.svgWiseSubscriptionList\">\r\n            <div class=\"row\">\r\n              <div class=\"col-sm-12\">\r\n                <label>{{ svgWiseSubscription.svgName }}</label>\r\n              </div>\r\n            </div>\r\n            <div class=\"row\">\r\n              <div class=\"col-sm-3\" *ngFor=\"let subscription of svgWiseSubscription.subscriptiopnListForSignupForm\">\r\n                <div class=\"radio\">\r\n                  <!-- <label><input type=\"radio\" name=\"optradio\">Option 1</label> -->\r\n                  <label>\r\n                    <input [(checked)]=\"subscription.isChecked\" type=\"radio\" [name]=\"svgWiseSubscription.svgName\" [value]=\"subscription.subscriptionHashId\"\r\n                      (change)=\"OnSubscriptionCheck(subscription.organizationSubscriptionHashId,subscription.sharedVehicleGroupHashId);\">{{ subscription.subscriptionName }}\r\n                  </label>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <span style=\"margin-left: 16px;\" class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'subscription' }}</span>\r\n        </div>\r\n        <div *ngFor=\"let tnc of termsAndConditionList\" class=\"row no-margin\">\r\n          <div *ngIf=\"!tnc.sharedVehicleGroupSubscriptionHashId || GetSubscriptionChecked(tnc.sharedVehicleGroupSubscriptionHashId,tnc.sharedVehicleGroupHashId)\">\r\n            <div class=\"form-group col-md-12 checkbox\">\r\n              <span class=\"text text-danger\">*</span>\r\n              <label>\r\n                <input type=\"checkbox\" name=\"tnc.termsAndConditionsHashId\" [(ngModel)]=\"tnc.accepted\">{{ 'LblReadAndAgree' | translate }}\r\n              </label>\r\n              <a class=\"cursor-pointer\" (click)=\"showTnC(tnc.termsAndConditionsHashId)\">{{ 'LblTermsAndCondition' | translate }}\r\n                <span *ngIf=\"tnc.entityName\">({{tnc.entityName}})</span>\r\n              </a>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <span class=\"text text-danger form-group col-md-12\">{{ errorModel | serverErrorMessage : 'isAccepted' }}</span>\r\n        <div class=\"row no-margin\">\r\n          <div class=\"form-group col-md-4 checkbox\" *ngIf=\"isPrivacyBodyContent\">\r\n            <span class=\"text text-danger\">*</span>\r\n            <label>\r\n              <input type=\"checkbox\" name=\"model.isPrivacyStatementAccepted\" [(ngModel)]=\"model.isPrivacyStatementAccepted\">{{ 'LblReadAndAgree' | translate }}\r\n            </label>\r\n            <a class=\"cursor-pointer\" (click)=\"showPrivacyStatement()\">{{ 'LblPrivacyStatements' | translate }}</a>\r\n            <br/>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'isPrivacyStatementAccepted' }}</span>\r\n          </div>\r\n        </div>\r\n        <div class=\"row col-md-12\">\r\n          <p class=\"text-muted text-center\" style=\"color: #2BA2AA;\">{{ signUpConfigModel.footerText }}</p>\r\n        </div>\r\n\r\n        <div class=\"row no-margin\">\r\n          <div class=\"col-sm-12 text-right\">\r\n            <hr>\r\n            <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnBackClick()\">{{ 'LblCancel' | translate }}</a> &nbsp;&nbsp;\r\n            <button class=\"btn btn-green\" type=\"submit\">{{ 'LblSave' | translate }}</button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n<wego-terms-condition-popup #termsConditionModel></wego-terms-condition-popup>\r\n<wego-privacy-popup #privayStatementModel></wego-privacy-popup>";

/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var common_1 = __webpack_require__(22);
	var ng2_file_upload_1 = __webpack_require__(810);
	var signupformconfig_model_1 = __webpack_require__(904);
	var signupfromconfig_service_1 = __webpack_require__(903);
	var instance_service_1 = __webpack_require__(500);
	var organization_service_1 = __webpack_require__(614);
	//const $ = require("jquery");
	var SignupFormConfigUpdateComponent = (function () {
	    function SignupFormConfigUpdateComponent(translate, activeRoute, router, authService, signupFormService, locationService, instanceService, organizationService) {
	        this.translate = translate;
	        this.activeRoute = activeRoute;
	        this.router = router;
	        this.authService = authService;
	        this.signupFormService = signupFormService;
	        this.locationService = locationService;
	        this.instanceService = instanceService;
	        this.organizationService = organizationService;
	        this.roleLevel = config_1.RoleLevel;
	        this.headers = this.authService.GetHeaderForFile();
	        this.uploader = new ng2_file_upload_1.FileUploader({
	            url: config_1.WeGoConfig.API_POST_SIGNUP_CONFIG_DETAIL,
	            headers: this.headers
	        });
	        this.oganizationList = [];
	    }
	    SignupFormConfigUpdateComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.accessDeniedErrorCode = '412';
	        this.pageName = 'SignupFormConfig';
	        this.module = this.translate.instant('LblSignupForms');
	        this.urlSignupFormConfigList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SIGNUPFORM_LIST);
	        this.urlSVGInfo = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SVG_UPDATE);
	        this.baseURL = window.location.origin + '/#/';
	        this.signupUrl = window.location.origin + '/#/signup/';
	        this.svgFilter = '';
	        this.sub = this.activeRoute.params.subscribe(function (params) {
	            _this.SignupFormConfigHashId = params['id'] || '';
	            if (_this.SignupFormConfigHashId != '') {
	                _this.isEditMode = true;
	                _this.GetSignupFormDetailByHashId();
	            }
	            else {
	                _this.isEditMode = false;
	                _this.GetInstanceDropDownList(config_1.PermissionType.INSERT);
	                _this.model = new signupformconfig_model_1.SignupFormConfigModel();
	            }
	        });
	        this.breadCrumbTitle = this.isEditMode
	            ? this.translate.instant('LblEditPage', [this.module])
	            : this.translate.instant('LblAddPage', [this.module]);
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	    };
	    SignupFormConfigUpdateComponent.prototype.GetInstanceDropDownList = function (permissionType) {
	        var _this = this;
	        this.instanceService
	            .GetInstanceListDropdownForAddUpdatePage(this.pageName, permissionType)
	            .subscribe(function (res) {
	            _this.InstanceList = res.data;
	            if (_this.InstanceList.length == 0) {
	                _this.authService.HandleErrorStatusCode(_this.accessDeniedErrorCode);
	            }
	            if (_this.InstanceList && _this.InstanceList.length > 0) {
	                if (!_this.model.instanceHashId && _this.InstanceList.length == 1) {
	                    _this.model.instanceHashId = _this.InstanceList[0].keyHash;
	                }
	                _this.GetOrganizationDropDownList();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    SignupFormConfigUpdateComponent.prototype.GetSignupFormDetailByHashId = function () {
	        var _this = this;
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlSignupFormList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SIGNUPFORM_LIST);
	        this.model = new signupformconfig_model_1.SignupFormConfigModel();
	        this.signupFormService
	            .GetSignupFormByHashId(this.SignupFormConfigHashId)
	            .subscribe(function (res) {
	            _this.model = res.data;
	            _this.InitSubscriptionArrays();
	            console.log(_this.model.subscriptionList);
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    SignupFormConfigUpdateComponent.prototype.GetInstanceDetailByHashId = function () {
	        var _this = this;
	        this.instanceService
	            .IsNIFNumberEnabled(this.model.instanceHashId)
	            .subscribe(function (res) {
	            _this.apiResponse = res;
	            var nifNumberEnabled = res.data;
	            if (nifNumberEnabled) {
	                _this.model.isnifEnabled = true;
	            }
	            else {
	                _this.model.isnifEnabled = false;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    SignupFormConfigUpdateComponent.prototype.GetOrganizationDropDownList = function () {
	        var _this = this;
	        if (this.model.instanceHashId) {
	            this.GetInstanceDetailByHashId();
	            this.organizationService
	                .GetOrganizationListDropdownForAddUpdatePage(this.pageName, config_1.PermissionType.INSERT, this.model.instanceHashId)
	                .subscribe(function (res) {
	                _this.oganizationList = res.data;
	                _this.model.organizationHashId = '';
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            });
	        }
	        else {
	            this.oganizationList = [];
	            this.model.organizationHashId = '';
	        }
	    };
	    SignupFormConfigUpdateComponent.prototype.GetSubscriptionList = function () {
	        var _this = this;
	        this.signupFormService
	            .GetSubscriptionList(this.model.organizationHashId, this.model.signupFormConfigHashId)
	            .subscribe(function (res) {
	            _this.model.subscriptionList = res.data;
	            _this.InitSubscriptionArrays();
	            var SelectedInstance = _this.InstanceList.find(function (x) { return x.keyHash == _this.model.instanceHashId; });
	            if (SelectedInstance.data.validateLiceanceNumber) {
	                _this.model.validateLiceanceNumber = true;
	                _this.model.sendActivationMail = true;
	                _this.model.fieldPassword = false;
	            }
	            else {
	                _this.model.validateLiceanceNumber = false;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    SignupFormConfigUpdateComponent.prototype.InitSubscriptionArrays = function () {
	        var _this = this;
	        this.svgFilter = '';
	        this.SvgList = [];
	        this.model.subscriptionList.forEach(function (x) {
	            x.hide = false;
	            if (_this.SvgList.indexOf(x.svgName) < 0) {
	                _this.SvgList.push(x.svgName);
	            }
	        });
	    };
	    SignupFormConfigUpdateComponent.prototype.SVGFilterChanged = function () {
	        var _this = this;
	        if (this.SvgList.indexOf(this.svgFilter) >= 0) {
	            this.model.subscriptionList.forEach(function (x) {
	                if (!(_this.svgFilter == x.svgName)) {
	                    x.hide = true;
	                }
	                else {
	                    x.hide = false;
	                }
	            });
	        }
	        else {
	            this.model.subscriptionList.forEach(function (x) {
	                x.hide = false;
	            });
	        }
	    };
	    // OnSubsriptionSort(fieldName: string) {
	    //     this.model.subscriptionListSortReverse = !this.model.subscriptionListSortReverse;
	    //     this.model.subscriptionList = this.model.subscriptionList.sort((a: SubscriptionForSignupForm, b: SubscriptionForSignupForm) => {
	    //         let retval = 0;
	    //         let val1 = "";
	    //         let val2 = "";
	    //         if (fieldName == "subscriptionName") {
	    //             val1 = a.subscriptionName;
	    //             val2 = b.subscriptionName;
	    //         } else if (fieldName == "statusString") {
	    //             val1 = a.statusString;
	    //             val2 = b.statusString;
	    //         } else if (fieldName == "svgName") {
	    //             val1 = a.svgName;
	    //             val2 = b.svgName;
	    //         }
	    //         if (val1 < val2) {
	    //             //a is the Object and args is the orderBy condition (data.likes.count in this case)
	    //             retval = - 1;
	    //         } else if (val1 > val2) {
	    //             retval = 1;
	    //         } else {
	    //             retval = 0;
	    //         }
	    //         if (!this.model.subscriptionListSortReverse) {
	    //             return retval * -1;
	    //         }
	    //         else {
	    //             return retval;
	    //         }
	    //     }
	    //     );
	    // }
	    SignupFormConfigUpdateComponent.prototype.OnSubscriptionCheck = function (event, data, list) {
	        if (event.currentTarget['checked']) {
	            this.model.subscriptionList
	                .filter(function (x) {
	                return x.isChecked &&
	                    data.svgName == x.svgName &&
	                    !(data.subscriptionHashId == x.subscriptionHashId);
	            })
	                .forEach(function (x) { return (x.isChecked = false); });
	        }
	    };
	    SignupFormConfigUpdateComponent.prototype.OnSubmit = function (forms) {
	        var _this = this;
	        this.isLoading = true;
	        if (!this.model.sendActivationMail) {
	            this.model.fieldPassword = true;
	        }
	        else {
	            this.model.fieldPassword = false;
	        }
	        if (this.uploader.queue && this.uploader.queue.length > 0) {
	            this.uploader.onBuildItemForm = function (fileItem, Form) {
	                console.log(JSON.stringify(_this.model));
	                Form.append('signupFormData', JSON.stringify(_this.model));
	            };
	            var apiresponse;
	            var status;
	            this.uploader.onCompleteItem = function (item, response, status, headers) {
	                _this.isLoading = false;
	                if (status == 200) {
	                    apiresponse = JSON.parse(response);
	                    console.log(apiresponse.error);
	                    if (apiresponse.data == true) {
	                        _this.popupMsg = _this.isEditMode
	                            ? _this.translate.instant('LblRecordUpdatedSuccess', [_this.module])
	                            : _this.translate.instant('LblRecordAddedSuccess', [_this.module]);
	                        _this.ShowSuccessPopup();
	                    }
	                    else {
	                        _this.errorModel = apiresponse.error;
	                        _this.ClearFileInput();
	                    }
	                }
	            };
	            this.uploader.uploadAll();
	        }
	        else {
	            this.signupFormService
	                .UpdateSignupFormConfig('signupFormData=' + encodeURIComponent(JSON.stringify(this.model)))
	                .subscribe(function (res) {
	                if (res.data) {
	                    _this.popupMsg = _this.isEditMode
	                        ? _this.translate.instant('LblRecordUpdatedSuccess', [
	                            _this.module
	                        ])
	                        : _this.translate.instant('LblRecordAddedSuccess', [
	                            _this.module
	                        ]);
	                    _this.ShowSuccessPopup();
	                    _this.isLoading = false;
	                }
	                else {
	                    _this.errorModel = res.error;
	                    _this.isLoading = false;
	                }
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	                _this.isLoading = false;
	            });
	        }
	    };
	    SignupFormConfigUpdateComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    SignupFormConfigUpdateComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    SignupFormConfigUpdateComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    SignupFormConfigUpdateComponent.prototype.OnBackClick = function () {
	        this.locationService.back();
	    };
	    SignupFormConfigUpdateComponent.prototype.GetImageURL = function (imagePath) {
	        return config_1.WeGoConfig.API_SERVER_URL + imagePath;
	    };
	    SignupFormConfigUpdateComponent.prototype.ClearFileInput = function () {
	        console.log(this.logoFile);
	        if (this.logoFile.nativeElement) {
	            console.log(this.logoFile.nativeElement.value);
	            this.logoFile.nativeElement.value = '';
	            this.uploader.clearQueue();
	        }
	    };
	    SignupFormConfigUpdateComponent.prototype.ngOnDestroy = function () {
	        if (this.sub) {
	            this.sub.unsubscribe();
	        }
	    };
	    __decorate([
	        core_1.ViewChild('logoFile'), 
	        __metadata('design:type', Object)
	    ], SignupFormConfigUpdateComponent.prototype, "logoFile", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], SignupFormConfigUpdateComponent.prototype, "successPopup", void 0);
	    SignupFormConfigUpdateComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-signupFormConfig',
	            template: __webpack_require__(909),
	            providers: [signupfromconfig_service_1.SignupFormConfigService, instance_service_1.InstanceService, organization_service_1.OrganizationService],
	            styles: [
	                "\n      .scroll-bar {\n        overflow: auto;\n        height: 200px;\n      }\n\n      .padding-left {\n        padding-left: 0px;\n      }\n    "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _d) || Object, (typeof (_e = typeof signupfromconfig_service_1.SignupFormConfigService !== 'undefined' && signupfromconfig_service_1.SignupFormConfigService) === 'function' && _e) || Object, (typeof (_f = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _f) || Object, (typeof (_g = typeof instance_service_1.InstanceService !== 'undefined' && instance_service_1.InstanceService) === 'function' && _g) || Object, (typeof (_h = typeof organization_service_1.OrganizationService !== 'undefined' && organization_service_1.OrganizationService) === 'function' && _h) || Object])
	    ], SignupFormConfigUpdateComponent);
	    return SignupFormConfigUpdateComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h;
	}());
	exports.SignupFormConfigUpdateComponent = SignupFormConfigUpdateComponent;


/***/ },
/* 909 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{breadCrumbTitle}}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"urlSignupFormConfigList\">\r\n            <i class=\"fa fa-bolt fa-fw\"></i>{{breadCrumbList}}</a>\r\n        </li>\r\n        <li class=\"active\">{{breadCrumbTitle}}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25 \">\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"nopad\">\r\n      <form (ngSubmit)=\"OnSubmit(SignupFormConfigForm.value)\" #SignupFormConfigForm=\"ngForm\">\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblTitle' | translate }}</label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblTitle' | translate }}\" [(ngModel)]=\"model.title\" name=\"title\"\r\n            maxlength=\"100\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'title' }}</span>\r\n        </div>\r\n        <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Instance\" class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{'LblInstance' | translate }} </label>\r\n          <input *ngIf=\"isEditMode\" type=\"text\" class=\"form-control\" [ngModel]=\"model.instanceName\" name=\"insatnceName\" disabled>\r\n          <select *ngIf=\"!isEditMode\" [(ngModel)]=\"model.instanceHashId\" class=\"form-control\" name=\"instanceHashId\" (change)=\"GetOrganizationDropDownList()\">\r\n            <option value='' [selected]='selected'>{{ 'LblSelect' | translate }} {{ 'LblInstance' | translate }} </option>\r\n            <option *ngFor=\"let item of InstanceList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\r\n          </select>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'instanceHashId' }}</span>\r\n        </div>\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{'LblOrganization' | translate }} </label>\r\n          <input *ngIf=\"isEditMode\" type=\"text\" class=\"form-control\" [ngModel]=\"model.organizationName\" name=\"organizationName\" disabled>\r\n          <select *ngIf=\"!isEditMode\" [(ngModel)]=\"model.organizationHashId\" class=\"form-control\" name=\"organizationHashId\" (change)=\"GetSubscriptionList()\">\r\n            <option value='' [selected]='selected'>{{ 'LblSelect' | translate }} {{ 'LblOrganization' | translate }} </option>\r\n            <option *ngFor=\"let item of oganizationList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\r\n          </select>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'organizationHashId' }}</span>\r\n        </div>\r\n        <div class=\"form-group col-md-12\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblDescription' | translate }}</label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblDescription' | translate }}\" [(ngModel)]=\"model.description\"\r\n            name=\"description\" maxlength=\"200\" />\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'description' }}</span>\r\n        </div>\r\n        <div class=\"row col-md-12\">\r\n          <div class=\"form-group col-md-4\">\r\n            <label>\r\n              <span class=\"text text-danger\">*</span>{{ 'LblSignupFormLogo' | translate }}</label>\r\n            <input #logoFile type=\"file\" id=\"fileLoader\" accept=\"image/x-png,image/png,image/gif,image/jpeg\" ng2FileSelect [uploader]=\"uploader\"\r\n              name=\"files\" [ngClass]=\"{'nv-file-over': hasBaseDropZoneOver}\" />\r\n            <span class=\"text text-danger\">{{errorModel | serverErrorMessage : 'file' }}</span>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'formLogoPath' }}</span>\r\n          </div>\r\n          <div *ngIf=\"model.formLogoPath\" class=\"form-group col-md-4\">\r\n            <img [src]=\"GetImageURL(model.formLogoPath)\" class=\"img-thumbnail\" style=\"height: 100px\">\r\n          </div>\r\n        </div>\r\n        <div class=\"form-group col-md-12\">\r\n          <label>{{ 'LblFooterText' | translate }}</label>\r\n          <textarea type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblFooterText' | translate }}\" [(ngModel)]=\"model.footerText\"\r\n            name=\"footerText\" maxlength=\"500\" style=\"height: 108px;\"></textarea>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'footerText' }}</span>\r\n        </div>\r\n        <div class=\"form-group col-md-12\">\r\n          <label>{{ 'LblvalidEmailDomain' | translate }}</label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblvalidEmailDomain' | translate }}\" [(ngModel)]=\"model.validEmailDomain\"\r\n            name=\"validEmailDomain\" maxlength=\"200\">\r\n          <span class=\"text text-danger \">{{ errorModel | serverErrorMessage : 'validEmailDomain' }}</span>\r\n          <div class=\"clearfix\"></div>\r\n          <div class=\"text-right\" style=\"color : #007777 \"> {{ 'DomainNameString'| translate }} </div>\r\n        </div>\r\n\r\n        <fieldset class=\"col-md-6\">\r\n          <legend class=\"legendStyle\">\r\n            <span class=\"text text-danger\">*</span> {{ 'LblURLSettings' | translate }}\r\n          </legend>\r\n          <div class=\"clearfix\"></div>\r\n          <div class=\"form-group col-md-12\">\r\n            <label>{{ 'LblSuccessUrl' | translate }}</label>\r\n            <div class=\"clearfix\"></div>\r\n            <div class=\"col-md-12 padding-left\">\r\n              <input class=\"col-md-3\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblSuccessUrl' | translate }}\" [(ngModel)]=\"model.successURL\"\r\n                name=\"successURL\" maxlength=\"100\">\r\n            </div>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'successURL' }}</span>\r\n          </div>\r\n          <div class=\"form-group col-md-12\">\r\n            <label>\r\n              <span class=\"text text-danger\">*</span>{{ 'LblSignupParameter' | translate }}</label>\r\n            <div class=\"clearfix\"></div>\r\n            <div *ngIf=\"!isEditMode\" class=\"col-md-7 padding-left\">\r\n              {{signupUrl}}\r\n            </div>\r\n            <div *ngIf=\"!isEditMode\" class=\"col-md-5\">\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblSignupParameterText' | translate }}\" [(ngModel)]=\"model.signupParameter\"\r\n                name=\"signupParameter\" maxlength=\"100\">\r\n            </div>\r\n            <a *ngIf=\"isEditMode\" [attr.href]=\"signupUrl+model.signupParameter\">{{signupUrl}}{{model.signupParameter}}</a>\r\n            <div class=\"col-md-12 text-right\">\r\n              <span class=\"text text-danger \">{{ errorModel | serverErrorMessage : 'signupParameter' }}</span>\r\n            </div>\r\n            <div class=\"clearfix\"></div>\r\n            <div class=\"col-md-12 text-right\" style=\"color : #007777 \" *ngIf=\"!isEditMode\"> {{'SignupParameterString' | translate }} </div>\r\n          </div>\r\n        </fieldset>\r\n        <fieldset class=\"col-md-6\">\r\n          <legend class=\"legendStyle\">\r\n            <span class=\"text text-danger\">*</span> {{ 'LblEmailSettings' | translate }}\r\n          </legend>\r\n          <div class=\"form-group col-md-12\">\r\n            <label>{{ 'LblSendActivationEmail' | translate }}</label>\r\n            <div>\r\n              <label class=\"radio-inline\">\r\n                <input [disabled]='this.model.validateLiceanceNumber' type=\"radio\" [(ngModel)]=\"model.sendActivationMail\" name=\"sendActivationMail\"\r\n                  [value]=\"true\">{{ 'LblYes' | translate }}</label>\r\n              <label class=\"radio-inline\">\r\n                <input [disabled]='this.model.validateLiceanceNumber' type=\"radio\" [(ngModel)]=\"model.sendActivationMail\" name=\"sendActivationMail\"\r\n                  [value]=\"false\">{{ 'LblNo' | translate }}</label>\r\n            </div>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'sendActivationMail' }}</span>\r\n          </div>\r\n          <legend class=\"legendStyle\">\r\n            <span class=\"text text-danger\">*</span> {{ 'LblRequireAdminApprovel' | translate }}\r\n          </legend>\r\n          <div class=\"form-group col-md-12\">\r\n            <label>{{ 'LblRequireAdminApprovel' | translate }}</label>\r\n            <div>\r\n              <label class=\"radio-inline\">\r\n                <input type=\"radio\" [(ngModel)]=\"model.adminApprovalRequired\" name=\"adminApprovalRequired\" [value]=\"true\">{{ 'LblYes' | translate }}</label>\r\n              <label class=\"radio-inline\">\r\n                <input type=\"radio\" [(ngModel)]=\"model.adminApprovalRequired\" name=\"adminApprovalRequired\" [value]=\"false\">{{ 'LblNo' | translate }}</label>\r\n            </div>\r\n          </div>\r\n          <div class=\"clearfix\"></div>\r\n          <!-- <template [ngIf]=\"model.adminApprovalRequired\">\r\n            <div class=\"form-group col-md-12\">\r\n              <label>{{ 'LblWhoCanApprove' | translate }}</label>\r\n              <div class=\"clearfix\"></div>\r\n              <div class=\"checkbox\">\r\n                <label>\r\n                  <input type=\"checkbox\" name=\"model.canApprovedByCompanyAdmin\" [(ngModel)]=\"model.canApprovedByCompanyAdmin\">{{ 'LblCompanyAdmin' | translate }}</label>\r\n              </div>\r\n              <div class=\"checkbox\">\r\n                <label>\r\n                  <input type=\"checkbox\" name=\"model.canApprovedByGroupAdmin\" [(ngModel)]=\"model.canApprovedByGroupAdmin\">{{ 'LblSharedVehicleGroupAdmin' | translate }}</label>\r\n              </div>\r\n              <div class=\"clearfix\"></div>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'canApprovedBy' }}</span>\r\n            </div>\r\n          </template> -->\r\n          <!-- <div class=\"clearfix\"></div>\r\n          <div class=\"form-group col-md-6\">\r\n            <label>{{ 'LblSendConfirmationEmail' | translate }}</label>\r\n            <div>\r\n              <label class=\"radio-inline\"><input type=\"radio\" [(ngModel)]=\"model.sendConfirmationMail\" name=\"sendConfirmationMail\" [value]=\"true\">{{ 'LblYes' | translate }}</label>\r\n              <label class=\"radio-inline\"><input type=\"radio\" [(ngModel)]=\"model.sendConfirmationMail\" name=\"sendConfirmationMail\" [value]=\"false\">{{ 'LblNo' | translate }}</label>\r\n            </div>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'sendConfirmationMail' }}</span>\r\n          </div> -->\r\n        </fieldset>\r\n        <div class=\"clearfix\"></div>\r\n        <fieldset class=\"col-md-6\">\r\n          <legend class=\"legendStyle\">\r\n            <span class=\"text text-danger\">*</span> {{ 'LblChooseSubscription' | translate }}\r\n          </legend>\r\n          <div class=\"form-group col-md-12\">\r\n            <label> {{'LblSharedVehicleGroup' | translate }}</label>\r\n            <select [(ngModel)]=\"svgFilter\" class=\"form-control\" name=\"svgFilter\" (change)=\"SVGFilterChanged()\">\r\n              <option selected value='' [selected]='selected'>{{ 'LblAll' | translate }} {{ 'LblSharedVehicleGroup' | translate }} </option>\r\n              <option *ngFor=\"let item of SvgList\" [ngValue]=\"item\">{{ item }}</option>\r\n            </select>\r\n          </div>\r\n          <div *ngIf=\"model.subscriptionList\" class=\"form-group col-md-12 scroll-bar\">\r\n\r\n            <table class=\"table table-bordered mar_bot_ziro\">\r\n              <thead>\r\n                <tr>\r\n                  <th class=\"text-center\">\r\n                    {{ 'LblSelect' | translate }}\r\n                  </th>\r\n                  <th class=\"cursor-pointer\" (click)=\"OnSubsriptionSort('svgName')\">\r\n                    {{ 'LblSharedVehicleGroup' | translate }}\r\n                  </th>\r\n                  <th class=\"cursor-pointer\" (click)=\"OnSubsriptionSort('subscriptionName')\">\r\n                    {{ 'LblSubscription' | translate }}\r\n                  </th>\r\n                  <th class=\"cursor-pointer\" (click)=\"OnSubsriptionSort('statusString')\">\r\n                    {{ 'LblStatus' | translate }}\r\n                  </th>\r\n                </tr>\r\n              </thead>\r\n              <tbody>\r\n\r\n                <tr *ngFor=\"let subscription of model.subscriptionList\" [ngClass]=\"{'hide': subscription.hide }\">\r\n                  <td class=\"text-center\">\r\n                    <input [disabled]=\"!subscription.status\" class=\"checkbox-inline\" type=\"checkbox\" [name]=\"subscription.svgName\" [(checked)]=\"subscription.isChecked\"\r\n                      [value]=\"subscription.organizationSubscriptionHashId\" (change)=\"subscription.isChecked = $event.target.checked;\">\r\n                  </td>\r\n                  <td *ngIf=\"subscription.status\">\r\n                    {{ subscription.svgName }}\r\n                  </td>\r\n                  <td *ngIf=\"!subscription.status\">\r\n                    <a [routerLink]=\"urlSVGInfo +'/'+ subscription.sharedVehicleGroupHashId\">\r\n                      {{ subscription.svgName }}\r\n                    </a>\r\n                  </td>\r\n                  <td>{{ subscription.subscriptionName }}</td>\r\n                  <td>{{ subscription.statusString }}</td>\r\n                </tr>\r\n\r\n              </tbody>\r\n            </table>\r\n          </div>\r\n        </fieldset>\r\n        <fieldset class=\"col-md-6\">\r\n          <legend class=\"legendStyle\">\r\n            {{ 'LblDriverInformationToBeInclude' | translate }}\r\n          </legend>\r\n          <div class=\"clearfix\"></div>\r\n          <div class=\"form-group col-md-12\">\r\n            <div class=\"checkbox\">\r\n              <label>\r\n                <input disabled type=\"checkbox\" checked=\"checked\">{{ 'LblUserName' | translate }}</label>\r\n            </div>\r\n            <div class=\"checkbox\">\r\n              <label>\r\n                <input disabled type=\"checkbox\" checked=\"checked\">{{ 'LblEmail' | translate }}</label>\r\n            </div>\r\n\r\n            <div class=\"checkbox\">\r\n              <label>\r\n                <input disabled type=\"checkbox\" checked=\"checked\">{{ 'LblCountry' | translate }}</label>\r\n            </div>\r\n\r\n            <div class=\"checkbox\">\r\n              <label>\r\n                <input disabled type=\"checkbox\" [checked]='!model.sendActivationMail' name=\"model.fieldPassword\" [(ngModel)]=\"model.fieldPassword\">{{ 'LblPassword' | translate }}</label>\r\n            </div>\r\n            <div class=\"checkbox\">\r\n              <label>\r\n                <input type=\"checkbox\" name=\"model.fieldFirstName\" [(ngModel)]=\"model.fieldFirstName\">{{ 'LblFirstName' | translate }}</label>\r\n            </div>\r\n            <div class=\"checkbox\">\r\n              <label>\r\n                <input type=\"checkbox\" name=\"model.fieldMiddleName\" [(ngModel)]=\"model.fieldMiddleName\">{{ 'LblMiddleName' | translate }}</label>\r\n            </div>\r\n            <div class=\"checkbox\">\r\n              <label>\r\n                <input type=\"checkbox\" name=\"model.fieldLastName\" [(ngModel)]=\"model.fieldLastName\">{{ 'LblLastName' | translate }}</label>\r\n            </div>\r\n            <div class=\"checkbox\">\r\n              <label>\r\n                <input type=\"checkbox\" name=\"model.fieldMobileNumber\" [(ngModel)]=\"model.fieldMobileNumber\">{{ 'LblMobileNumber' | translate }}</label>\r\n            </div>\r\n            <div class=\"checkbox\">\r\n              <label>\r\n                <input type=\"checkbox\" name=\"model.fieldPhoneNumber\" [(ngModel)]=\"model.fieldPhoneNumber\">{{ 'LblPhoneNumber' | translate }}</label>\r\n            </div>\r\n            <div class=\"checkbox\">\r\n              <label>\r\n                <input type=\"checkbox\" name=\"model.fieldHomeAddress\" [(ngModel)]=\"model.fieldHomeAddress\">{{ 'LblHomeAddress' | translate }}</label>\r\n            </div>\r\n            <div class=\"checkbox\" *ngIf=\"model.isnifEnabled\">\r\n              <label>\r\n                <input type=\"checkbox\" name=\"model.fieldNIFNumber\" [(ngModel)]=\"model.fieldNIFNumber\">{{ 'LblNIFNumber' | translate }}</label>\r\n            </div>\r\n            <div class=\"clearfix\"></div>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'fieldsToBeInclude' }}</span>\r\n          </div>\r\n        </fieldset>\r\n        <div class=\"clearfix\"></div>\r\n        <fieldset class=\"col-md-6\">\r\n\r\n        </fieldset>\r\n        <div class=\"row no-margin\">\r\n          <div class=\"col-sm-12\">\r\n            <hr>\r\n            <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnBackClick()\">{{ 'LblCancel' | translate }}</a>&nbsp;&nbsp;\r\n            <button class=\"btn btn-green\" type=\"submit\">{{ 'LblSave' | translate }}</button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </section>\r\n</div>\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n<wego-geo-location-map #geoLocationModal (onConfirm)=\"onConfirm($event)\"></wego-geo-location-map>";

/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var translate_service_1 = __webpack_require__(70);
	var router_1 = __webpack_require__(26);
	var core_1 = __webpack_require__(3);
	var config_1 = __webpack_require__(60);
	var signupfromconfig_service_1 = __webpack_require__(903);
	var SignupFormConfigListComponent = (function () {
	    function SignupFormConfigListComponent(signupFormConfigService, translateService, authService, router) {
	        this.signupFormConfigService = signupFormConfigService;
	        this.translateService = translateService;
	        this.authService = authService;
	        this.router = router;
	        this.roleLevel = config_1.RoleLevel;
	    }
	    Object.defineProperty(SignupFormConfigListComponent.prototype, "isAnyChecked", {
	        get: function () {
	            if (this.signupConfigList) {
	                var isCheck = this.signupConfigList.some(function (x) { return x.isChecked == true; });
	                if (isCheck) {
	                    if (this.signupConfigList.every(function (x) { return x.isChecked == true; }))
	                        this.isParentCheck = true;
	                    else
	                        this.isParentCheck = false;
	                }
	                else {
	                    this.isParentCheck = false;
	                }
	                return isCheck;
	            }
	            else {
	                this.isParentCheck = false;
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SignupFormConfigListComponent.prototype.ngOnInit = function () {
	        this.signupUrl = window.location.origin + "/#/signup/";
	        this.module = this.translateService.instant('LblSignUpForm');
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        if (this.authService.GetHighestRoleLevel() <= this.roleLevel.Instance) {
	            this.DataListModel.searchField = ["instanceName", "organizationName", "title", "description"];
	        }
	        else {
	            this.DataListModel.searchField = ["organizationName", "title", "description"];
	        }
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlsignupformconfigUpdatePage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SIGNUPFORM_UPDATE);
	        this.urlsignupformconfigAddPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SIGNUPFORM_ADD);
	        this.addSignUpFormLink = new config_1.WeGoAuthorizedLink(this.urlsignupformconfigAddPage, config_1.Permission.PR_SIGNUP_FORMS_OVERVIEW, config_1.PermissionType.INSERT, 'btn btn-highlight navbar-right', 'LblAddNew');
	        this.GetTemplateList();
	    };
	    Object.defineProperty(SignupFormConfigListComponent.prototype, "isDeleteAccess", {
	        get: function () {
	            if (this.signupConfigList) {
	                return this.signupConfigList.some(function (x) { return x.isDeletable; });
	            }
	            else {
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SignupFormConfigListComponent.prototype.GetTemplateList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.signupFormConfigService.GetSignupFormList(this.DataListModel)
	            .subscribe(function (res) {
	            _this.signupConfigList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SignupFormConfigListComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetTemplateList();
	    };
	    SignupFormConfigListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetTemplateList();
	    };
	    SignupFormConfigListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetTemplateList();
	    };
	    SignupFormConfigListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetTemplateList();
	    };
	    ;
	    SignupFormConfigListComponent.prototype.OnParentCheck = function (isChecked) {
	        this.signupConfigList.filter(function (x) { return x.isDeletable; }).forEach(function (x) { return x.isChecked = (isChecked && x.instanceHashId ? true : false); });
	    };
	    SignupFormConfigListComponent.prototype.ShowChildModal = function (templateHashId) {
	        if (templateHashId) {
	            this.popupMsg = this.translateService.instant('LblRecordDeleteConfirmation', [this.module]);
	            this.isMultipleDelete = false;
	            this.deleteSignupFormConfigHashId = templateHashId;
	        }
	        else {
	            this.popupMsg = this.translateService.instant('LblRecordMultiplDeleteConfirmation', [this.module]);
	            this.isMultipleDelete = true;
	        }
	        this.childModal.show();
	    };
	    SignupFormConfigListComponent.prototype.HideChildModal = function () {
	        this.deleteSignupFormConfigHashId = "";
	        this.childModal.hide();
	    };
	    SignupFormConfigListComponent.prototype.SuccessModalClick = function () {
	        var deletedSignupFormList;
	        if (this.isMultipleDelete)
	            deletedSignupFormList = this.signupConfigList.filter(function (x) { return x.isChecked; }).map(function (x) { return x.signupFormConfigHashId; });
	        else
	            deletedSignupFormList.push(this.deleteSignupFormConfigHashId);
	        this.DeleteSignupConfig(deletedSignupFormList);
	        this.childModal.hide();
	    };
	    SignupFormConfigListComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    SignupFormConfigListComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    SignupFormConfigListComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    SignupFormConfigListComponent.prototype.DeleteSignupConfig = function (deletedSignupFormList) {
	        var _this = this;
	        this.isLoading = true;
	        this.signupFormConfigService.DeleteSignupFormConfig(deletedSignupFormList)
	            .subscribe(function (res) {
	            _this.DataListModel.currentPage = 1;
	            _this.GetTemplateList();
	            _this.popupMsg = _this.translateService.instant('LblRecordRemovedSuccess', [_this.module]);
	            _this.ShowSuccessPopup();
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SignupFormConfigListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.signupFormConfigService.ExportSignupConfigList(this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "SignupFormConfig" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SignupFormConfigListComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], SignupFormConfigListComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild('childModal'), 
	        __metadata('design:type', Object)
	    ], SignupFormConfigListComponent.prototype, "childModal", void 0);
	    SignupFormConfigListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-signupConfig-list',
	            template: __webpack_require__(911),
	            providers: [signupfromconfig_service_1.SignupFormConfigService],
	            styles: [
	                "\n      .truncate-event-data{\n        max-width: 0;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }\n    "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof signupfromconfig_service_1.SignupFormConfigService !== 'undefined' && signupfromconfig_service_1.SignupFormConfigService) === 'function' && _a) || Object, (typeof (_b = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object])
	    ], SignupFormConfigListComponent);
	    return SignupFormConfigListComponent;
	    var _a, _b, _c, _d;
	}());
	exports.SignupFormConfigListComponent = SignupFormConfigListComponent;


/***/ },
/* 911 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{'LblSignupForms' | translate }}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li class=\"active\">{{'LblSignupForms' | translate }}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-12 mar_t_25 \">\r\n      <wego-authorized-link [LinkModel]=\"addSignUpFormLink\"></wego-authorized-link>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <wego-search-list (OnSearch)=\"OnSearch($event)\" [IsExported]=\"true\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\"\r\n          [ItemPerPage]=\"DataListModel.itemsPerPage\" [IsDeleted]=\"isDeleteAccess\" [IsDeleteEnabled]=\"isAnyChecked\" (OnExport)=\"OnExport($event)\"\r\n          (OnDeleteAll)=\"ShowChildModal()\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center parent-checkbox\">\r\n                  <input type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\">\r\n                </th>\r\n                <th *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Instance\" class=\"cursor-pointer\" (click)=\"OnSort('instanceName')\">\r\n                  {{'LblInstance' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'instanceName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('organizationName')\">\r\n                  {{'LblOrganization' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'organizationName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('title')\">\r\n                  {{'LblTitle' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'title'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('description')\">\r\n                  {{'LblDescription' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'description'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"text-center\">{{ 'LblEdit' | translate }}</th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let item of signupConfigList\">\r\n                  <td class=\"text-center\">\r\n                    <input *ngIf=\"!item.isDeletable || !item.instanceHashId\" disabled type=\"checkbox\" name=\"isActive\" [(ngModel)]=\"item.isChecked\">\r\n                    <input *ngIf=\"item.isDeletable\" type=\"checkbox\" name=\"isActive\" [(ngModel)]=\"item.isChecked\">\r\n                  </td>\r\n                  <td *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Instance\" class=\"word-wrap\">{{ item.instanceName }}</td>\r\n                  <td class=\"word-wrap\">{{ item.organizationName }}</td>\r\n                  <td>\r\n                    <a target=\"_blank\" [attr.href]=\"signupUrl+item.signupParameter\">\r\n                      {{ item.title }}\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"truncate-event-data\">{{ item.description }}</td>\r\n\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"item.isEditable\" [routerLink]=\"urlsignupformconfigUpdatePage + '/' + item.signupFormConfigHashId\">\r\n                      <i class=\"fa fa-pencil-square-o fa-fw\"></i>\r\n                    </a>\r\n\r\n                  </td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"6\">\r\n                  {{ DataListModel.infoMessage }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<wego-confirm-popup #childModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessModalClick()\" (onReject)=\"HideChildModal()\"></wego-confirm-popup>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>";

/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var translate_service_1 = __webpack_require__(70);
	var router_1 = __webpack_require__(26);
	var core_1 = __webpack_require__(3);
	var config_1 = __webpack_require__(60);
	var signup_list_service_1 = __webpack_require__(913);
	var signup_list_model_1 = __webpack_require__(914);
	var flatpickr_model_1 = __webpack_require__(83);
	var SignupListComponent = (function () {
	    function SignupListComponent(signupListService, translateService, authService, router) {
	        this.signupListService = signupListService;
	        this.translateService = translateService;
	        this.authService = authService;
	        this.router = router;
	        this.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
	        this.signupOverviewList = new signup_list_model_1.SignupOverviewList();
	    }
	    SignupListComponent.prototype.SetDefaultFlatPickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = true;
	        flatPickrConfig.time_24hr = true;
	        flatPickrConfig.dateFormat = this.dateFormat;
	        flatPickrConfig.minuteIncrement = 1;
	        return flatPickrConfig;
	    };
	    SignupListComponent.prototype.ngOnInit = function () {
	        this.module = this.translateService.instant('LblSignupForm');
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = ["instanceName", "organizationName", "userName", "email", "signupFormDescription", "statusFormatted"];
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlsignupformconfigUpdatePage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SIGNUPFORM_UPDATE);
	        this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
	        this.GetSignupList();
	    };
	    SignupListComponent.prototype.GetSignupList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.signupListService.GetSignupList(this.signupOverviewList, this.DataListModel)
	            .subscribe(function (res) {
	            _this.signupList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.isLoading = false;
	            _this.errorModel = [];
	            if (typeof res.error == "string") {
	                _this.DataListModel.infoMessage = res.error;
	            }
	            else if (res.error) {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SignupListComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetSignupList();
	    };
	    SignupListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetSignupList();
	    };
	    SignupListComponent.prototype.OnDateSearch = function () {
	        this.GetSignupList();
	    };
	    SignupListComponent.prototype.OnSearch = function (event) {
	        if (event.isReset) {
	            this.signupOverviewList.startDateTime = '';
	            this.signupOverviewList.endDateTime = '';
	        }
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetSignupList();
	    };
	    SignupListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetSignupList();
	    };
	    ;
	    SignupListComponent.prototype.ShowAcceptrejectmodel = function (signupoverviewModel) {
	        this.confirmSignupModal.model = signupoverviewModel;
	        this.confirmSignupModal.show();
	    };
	    SignupListComponent.prototype.GetStatusText = function (status) {
	        if (status == 'PENDING_APPROVAL') {
	            return "Pending Approval";
	        }
	        else if (status == 'APPROVED') {
	            return "Approved";
	        }
	        else if (status == 'REJECTED') {
	            return "Rejected";
	        }
	    };
	    SignupListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.signupListService.ExportSignupList(this.signupOverviewList, this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "SignupForms" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SignupListComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    __decorate([
	        core_1.ViewChild('confirmSignupModal'), 
	        __metadata('design:type', Object)
	    ], SignupListComponent.prototype, "confirmSignupModal", void 0);
	    SignupListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-signup-list',
	            template: __webpack_require__(915),
	            providers: [signup_list_service_1.SignupListService],
	            styles: [".truncate-event-data{\n        max-width: 0;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }"
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof signup_list_service_1.SignupListService !== 'undefined' && signup_list_service_1.SignupListService) === 'function' && _a) || Object, (typeof (_b = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object])
	    ], SignupListComponent);
	    return SignupListComponent;
	    var _a, _b, _c, _d;
	}());
	exports.SignupListComponent = SignupListComponent;


/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var jquery_helper_service_1 = __webpack_require__(67);
	var SignupListService = (function () {
	    function SignupListService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	        this.JQueryHelper = new jquery_helper_service_1.JQueryHelperService();
	    }
	    SignupListService.prototype.GetSignupList = function (signupOverviewList, input) {
	        var url = config_1.WeGoConfig.API_GET_SIGNUP_LIST;
	        var queryStringDataListModel = this.authService.HandleAPIListInput(input);
	        var queryStringBookingOverviewModel = this.JQueryHelper.Param(signupOverviewList);
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        url = url + "?" + queryStringDataListModel + "&" + decodeURIComponent(queryStringBookingOverviewModel);
	        return this.http.get(url, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SignupListService.prototype.ExportSignupList = function (signupOverviewList, input) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var url = config_1.WeGoConfig.API_EXPORT_SIGNUP_LIST;
	        var queryStringBookingOverviewModel = this.JQueryHelper.Param(signupOverviewList);
	        url = url + "?" + queryString + "&" + decodeURIComponent(queryStringBookingOverviewModel);
	        var headers = this.authService.GetHeader('text/csv');
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(url, options);
	    };
	    SignupListService.prototype.AcceptRejectSignup = function (signupOverviewList, Accept, Reject) {
	        var url = config_1.WeGoConfig.API_ACCEPT_REJECT_SIGNUP;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        url = url + "?Accept=" + Accept + "&Reject=" + Reject;
	        return this.http.post(url, signupOverviewList, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SignupListService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], SignupListService);
	    return SignupListService;
	    var _a, _b;
	}());
	exports.SignupListService = SignupListService;


/***/ },
/* 914 */
/***/ function(module, exports) {

	"use strict";
	var SignupOverviewList = (function () {
	    function SignupOverviewList() {
	        this.signupFormHashId = '';
	        this.signupFormConfigHashId = '';
	        this.startDateTime = '';
	        this.endDateTime = '';
	        this.signupDateTime = '';
	        this.instanceName = '';
	        this.userName = '';
	        this.email = '';
	        this.signupFormDescription = '';
	        this.status = '';
	    }
	    return SignupOverviewList;
	}());
	exports.SignupOverviewList = SignupOverviewList;


/***/ },
/* 915 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{'LblSignupsOverView' | translate }}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li class=\"active\">{{'LblSignupsOverView' | translate }}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <div class=\"row\">\r\n          <div class=\"form-group col-md-3\">\r\n            <label>{{ 'LblFrom' | translate }}</label>\r\n            <div class=\"clearfix\"></div>\r\n            <div class=\"input-group\">\r\n              <span class=\"input-group-addon\">\r\n                <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n              </span>\r\n              <input flatpickr readonly [Config]=\"flatPickrConfigFrom\" [(ngModel)]=\"signupOverviewList.startDateTime\" name=\"TimeBlockStartDate\"\r\n                type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblFrom' | translate }}\">\r\n            </div>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'startDateTime' }}</span>\r\n          </div>\r\n          <div class=\"form-group col-md-3\">\r\n            <label>{{ 'LblTo' | translate }}</label>\r\n            <div class=\"clearfix \"></div>\r\n            <div class=\"input-group\">\r\n              <span class=\"input-group-addon\">\r\n                <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n              </span>\r\n              <input flatpickr readonly [Config]=\"flatPickrConfigTo\" [(ngModel)]=\"signupOverviewList.endDateTime\" name=\"TimeBlockStartDate\"\r\n                type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblTo' | translate }}\">\r\n            </div>\r\n          </div>\r\n          <div class=\"form-group col-md-2\">\r\n            <label>\r\n              <span class=\"text text-danger\"></span>\r\n            </label>\r\n            <div class=\"clearfix\"></div>\r\n            <button class=\"btn btn-default navbar-left mar_t_5\" (click)=\"OnDateSearch()\">{{ 'LblSearch' | translate}}</button>\r\n          </div>\r\n        </div>\r\n        <wego-search-list (OnSearch)=\"OnSearch($event)\" [IsExported]=\"true\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\"\r\n          (OnExport)=\"OnExport($event)\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('signupDateTimeUTC')\">\r\n                  {{'LblDate' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'signupDateTime'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('instanceName')\">\r\n                  {{'LblInstance' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'instanceName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('organizationName')\">\r\n                  {{'LblOrganization' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'organizationName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('userName')\">\r\n                  {{'LblUserName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'userName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('email')\">\r\n                  {{'LblEmail' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'email'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('signupFormdescription')\">\r\n                  {{'LblSignupFormDescription' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'signupFormdescription'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('statusFormatted')\">\r\n                  {{'LblStatus' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'statusFormatted'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let item of signupList\">\r\n                  <td>{{ item.signupDateTime }}</td>\r\n                  <td class=\"word-wrap\">{{ item.instanceName }}</td>\r\n                  <td class=\"word-wrap\">{{ item.organizationName }}</td>\r\n                  <td>{{ item.userName }}</td>\r\n                  <td>{{ item.email }}</td>\r\n                  <td class=\"truncate-event-data\">\r\n                    <a *ngIf=\"item.isEditable\" [routerLink]=\"urlsignupformconfigUpdatePage + '/'+  item.signupFormConfigHashId\">\r\n                      {{ item.signupFormDescription }}\r\n                    </a>\r\n                    <span *ngIf=\"!item.isEditable\">{{item.signupFormDescription}}</span>\r\n                  </td>\r\n                  <td>\r\n\r\n                    <div *ngIf='item.enableApprove'>\r\n                      <a class=\"cursor-pointer\" *ngIf=\"item.status=='PENDING_APPROVAL'\" (click)=\"ShowAcceptrejectmodel(item)\">\r\n                        {{item.statusFormatted }} </a>\r\n                      <span *ngIf=\"item.status!='PENDING_APPROVAL'\">{{item.statusFormatted}}</span>\r\n                    </div>\r\n                  </td>\r\n\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"7\">\r\n                  {{ DataListModel.infoMessage }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n<confirm-signup-popup #confirmSignupModal (OnSuccessSave)=\"GetSignupList()\"></confirm-signup-popup>";

/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var translate_service_1 = __webpack_require__(70);
	var router_1 = __webpack_require__(26);
	var core_1 = __webpack_require__(3);
	var config_1 = __webpack_require__(60);
	var flatpickr_model_1 = __webpack_require__(83);
	var invoice_service_1 = __webpack_require__(723);
	var direct_debit_file_model_1 = __webpack_require__(917);
	var DirectDebitFileListComponent = (function () {
	    function DirectDebitFileListComponent(invoiceService, translateService, authService, router) {
	        this.invoiceService = invoiceService;
	        this.translateService = translateService;
	        this.authService = authService;
	        this.router = router;
	        this.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_FORMAT;
	        this.directDebitFileModel = new direct_debit_file_model_1.DirectDebitFile();
	    }
	    DirectDebitFileListComponent.prototype.SetDefaultFlatPickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = false;
	        flatPickrConfig.time_24hr = true;
	        flatPickrConfig.dateFormat = this.dateFormat;
	        flatPickrConfig.minuteIncrement = 1;
	        return flatPickrConfig;
	    };
	    DirectDebitFileListComponent.prototype.ngOnInit = function () {
	        this.module = this.translateService.instant('LblDirectDebitFile');
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = ['id', 'companyName'];
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlsignupformconfigUpdatePage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SIGNUPFORM_UPDATE);
	        this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
	        this.GetDirectDebitFileList();
	    };
	    DirectDebitFileListComponent.prototype.GetDirectDebitFileList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.invoiceService.GetDirectDebitFileList(this.DataListModel, this.directDebitFileModel)
	            .subscribe(function (res) {
	            _this.directDebitFile = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.isLoading = false;
	            _this.errorModel = [];
	            if (typeof res.error == "string") {
	                _this.DataListModel.infoMessage = res.error;
	            }
	            else if (res.error) {
	                _this.errorModel = res.error;
	                _this.DataListModel.infoMessage = _this.translateService.instant('LblNoDataFound');
	            }
	            _this.IsDirectDebitEnabled();
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    DirectDebitFileListComponent.prototype.IsDirectDebitEnabled = function () {
	        var _this = this;
	        this.invoiceService.IsDirectDebitEnabled()
	            .subscribe(function (res) {
	            if (res) {
	                _this.isDirectDebitEnabled = res.data;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    DirectDebitFileListComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetDirectDebitFileList();
	    };
	    DirectDebitFileListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetDirectDebitFileList();
	    };
	    DirectDebitFileListComponent.prototype.OnDateSearch = function () {
	        this.GetDirectDebitFileList();
	    };
	    DirectDebitFileListComponent.prototype.OnSearch = function (event) {
	        if (event.isReset) {
	            this.directDebitFileModel.startDateTime = '';
	            this.directDebitFileModel.endDateTime = '';
	        }
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetDirectDebitFileList();
	    };
	    DirectDebitFileListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetDirectDebitFileList();
	    };
	    ;
	    DirectDebitFileListComponent.prototype.GetStatusText = function (status) {
	        if (status == 'PENDING_APPROVAL') {
	            return "Pending Approval";
	        }
	        else if (status == 'APPROVED') {
	            return "Approved";
	        }
	        else if (status == 'REJECTED') {
	            return "Rejected";
	        }
	    };
	    DirectDebitFileListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.invoiceService.ExportDirectDebitFileList(this.DataListModel, this.directDebitFileModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "DirectDebitFile" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    DirectDebitFileListComponent.prototype.OnReCreate = function (directDebitFileHashId) {
	        var _this = this;
	        this.invoiceService.ReCreateDirectDebitFile(directDebitFileHashId).subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "directDebitFile" + new Date().toISOString() + ".xml";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    DirectDebitFileListComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    __decorate([
	        core_1.ViewChild('confirmSignupModal'), 
	        __metadata('design:type', Object)
	    ], DirectDebitFileListComponent.prototype, "confirmSignupModal", void 0);
	    DirectDebitFileListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-directdebit-file-list',
	            template: __webpack_require__(918),
	            providers: [invoice_service_1.InvoiceService],
	            styles: [".truncate-event-data{\n        max-width: 0;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n      }"
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof invoice_service_1.InvoiceService !== 'undefined' && invoice_service_1.InvoiceService) === 'function' && _a) || Object, (typeof (_b = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object])
	    ], DirectDebitFileListComponent);
	    return DirectDebitFileListComponent;
	    var _a, _b, _c, _d;
	}());
	exports.DirectDebitFileListComponent = DirectDebitFileListComponent;


/***/ },
/* 917 */
/***/ function(module, exports) {

	"use strict";
	var DirectDebitFile = (function () {
	    function DirectDebitFile() {
	    }
	    return DirectDebitFile;
	}());
	exports.DirectDebitFile = DirectDebitFile;
	var DirectDebitFileXML = (function () {
	    function DirectDebitFileXML() {
	    }
	    return DirectDebitFileXML;
	}());
	exports.DirectDebitFileXML = DirectDebitFileXML;


/***/ },
/* 918 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{'LblDirectDebitFile' | translate }}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li><a [routerLink]=\"urlDefaultPage\"><i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a></li>\r\n        <li class=\"active\">{{'LblDirectDebitFile' | translate }}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <div class=\"row\">\r\n          <div class=\"form-group col-md-3\">\r\n            <label>{{ 'LblFrom' | translate }}</label>\r\n            <div class=\"clearfix\"></div>\r\n            <div class=\"input-group\">\r\n              <span class=\"input-group-addon\"><i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i></span>\r\n              <input flatpickr readonly [Config]=\"flatPickrConfigFrom\" [(ngModel)]=\"directDebitFileModel.startDateTime\" name=\"TimeBlockStartDate\"\r\n                type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblFrom' | translate }}\">\r\n            </div>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'startDateTime' }}</span>\r\n          </div>\r\n          <div class=\"form-group col-md-3\">\r\n            <label>{{ 'LblTo' | translate }}</label>\r\n            <div class=\"clearfix \"></div>\r\n            <div class=\"input-group\">\r\n              <span class=\"input-group-addon\"><i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i></span>\r\n              <input flatpickr readonly [Config]=\"flatPickrConfigTo\" [(ngModel)]=\"directDebitFileModel.endDateTime\" name=\"TimeBlockStartDate\"\r\n                type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblTo' | translate }}\">\r\n            </div>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'endDateTime' }}</span>\r\n          </div>\r\n          <div class=\"form-group col-md-2\">\r\n            <label><span class=\"text text-danger\"></span></label>\r\n            <div class=\"clearfix\"></div>\r\n            <button class=\"btn btn-default navbar-left mar_t_5\" (click)=\"OnDateSearch()\">{{ 'LblSearch' | translate}}</button>\r\n          </div>\r\n        </div>\r\n        <wego-search-list (OnSearch)=\"OnSearch($event)\" [IsExported]=\"true\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\"\r\n          (OnExport)=\"OnExport($event)\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('id')\">\r\n                  {{ 'LblDirectDebitFileId' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'id'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('directDebitFileDateUTC')\">\r\n                  {{ 'LblDirectDebitFileDate' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'directDebitFileDateUTC'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('totalAmount')\">\r\n                  {{ 'LblTotalAmount' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'totalAmount'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('companyName')\">\r\n                  {{ 'LblCompanyName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'companyName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th *ngIf=\"isDirectDebitEnabled\" class=\"cursor-pointer text-center\"> {{'LblReCreate' | translate}}</th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let directDebitfile of directDebitFile\">\r\n                  <td>{{ directDebitfile.id }}</td>\r\n                  <td>{{ directDebitfile.directDebitFileDate }}</td>\r\n                  <td>{{ directDebitfile.amount }}</td>\r\n                  <td>{{ directDebitfile.companyName }}</td>\r\n                  <td *ngIf=\"isDirectDebitEnabled\" class=\"text-center cursor-pointer\">\r\n                    <a  target='_blank' (click)=\"OnReCreate(directDebitfile.directDebitfileHashId)\" >                      \r\n                          <i class=\"fa fa-download fa-fw\"></i>\r\n                        </a>\r\n                  </td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"20\">\r\n                  {{ DataListModel.infoMessage }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>";

/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var translate_service_1 = __webpack_require__(70);
	var config_1 = __webpack_require__(60);
	var auth_service_1 = __webpack_require__(58);
	var instance_service_1 = __webpack_require__(500);
	var instance_model_1 = __webpack_require__(513);
	var router_1 = __webpack_require__(26);
	var ng2_file_upload_1 = __webpack_require__(810);
	var signup_service_1 = __webpack_require__(905);
	var batch_upload_person_model_1 = __webpack_require__(920);
	var organization_service_1 = __webpack_require__(614);
	var BatchUploadPersonComponent = (function () {
	    function BatchUploadPersonComponent(translate, authService, instanceService, organizationService, activeRoute, signupService) {
	        this.translate = translate;
	        this.authService = authService;
	        this.instanceService = instanceService;
	        this.organizationService = organizationService;
	        this.activeRoute = activeRoute;
	        this.signupService = signupService;
	        this.instanceHashId = "";
	        this.importDriverRole = false;
	        this.importUserAssigedToSVG = true;
	        this.isInit = false;
	        this.organizationMasterHashId = "";
	        this.isMultipleOrganization = false;
	        this.roleLevel = config_1.RoleLevel;
	    }
	    BatchUploadPersonComponent.prototype.ngOnInit = function () {
	        this.InitBatchUpload();
	    };
	    BatchUploadPersonComponent.prototype.InitBatchUpload = function () {
	        var _this = this;
	        this.pageName = "BatchUploadPerson";
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlPersonList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_PERSON_LIST);
	        this.urlDriverList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DRIVER_LIST);
	        this.batchUploadPersonModel = new batch_upload_person_model_1.BatchUploadPersonModel();
	        this.importDriverRole = true;
	        this.module = this.translate.instant("LblPerson");
	        this.breadCrumbList = this.translate.instant("LblListPage", [this.module]);
	        this.ResetPaging();
	        this.headers = this.authService.GetHeaderForFile();
	        this.uploader = new ng2_file_upload_1.FileUploader({
	            url: config_1.WeGoConfig.API_VALIDATE_BATCH_UPLOAD_PERSON_CSV,
	            headers: this.headers
	        });
	        this.uploader.onAfterAddingFile = function (fileItem) {
	            return _this.HandleOnAfterAddingFile(fileItem);
	        };
	        this.uploader.onBuildItemForm = function (fileItem, Form) {
	            return _this.HandleOnBuildItemForm(fileItem, Form);
	        };
	        this.uploader.onCompleteItem = function (item, response, status, headers) {
	            return _this.HandleOnCompleteItem(item, response, status, headers);
	        };
	        this.instanceModel = new instance_model_1.InstanceModel();
	        this.GetInstanceList();
	        //this.GetOrganizationList();
	        this.isInit = true;
	    };
	    BatchUploadPersonComponent.prototype.GetInstanceList = function () {
	        var _this = this;
	        this.instanceService.GetInstanceForBatchUpload().subscribe(function (res) {
	            _this.instanceList = res.data.sort(function (a, b) {
	                var textA = a.instanceName.toUpperCase();
	                var textB = b.instanceName.toUpperCase();
	                return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
	            });
	            ;
	            if (_this.instanceList && _this.instanceList.length > 0) {
	                if (!_this.instanceHashId && _this.instanceList.length == 1) {
	                    _this.instanceHashId = _this.instanceList[0].instanceHashId;
	                    _this.GetOrganizationList();
	                }
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    // public GetOrganizationList() {
	    //   this.organizationService.GetOrganizationForBatchUpload()
	    //     .subscribe(
	    //     res => {
	    //       this.organizationList = res.data;
	    //       this.isMultipleOrganization = true;
	    //       if (this.organizationList.length == 1) {
	    //         this.isMultipleOrganization = false;
	    //         this.organizationMasterHashId = this.organizationList[0].organizationMasterHashId;
	    //       }
	    //     },
	    //     error => {
	    //       this.errorMessage = this.authService.HandleErrorStatusCode(error);
	    //     });
	    // }
	    BatchUploadPersonComponent.prototype.HandleOnAfterAddingFile = function (fileItem) {
	        if (this.uploader.queue.length > 1) {
	            this.uploader.queue.forEach(function (element) {
	                element.remove();
	            });
	        }
	    };
	    BatchUploadPersonComponent.prototype.FilterList = function () {
	        var start = this.DataListModel.itemsPerPage * (this.DataListModel.currentPage - 1);
	        var end = start + this.DataListModel.itemsPerPage;
	        this.listOfFilterRecord = this.listOfRecord.slice(start, end);
	    };
	    BatchUploadPersonComponent.prototype.HandleOnCompleteItem = function (item, response, status, headers) {
	        //For successful result  method simply return error
	        //For Failed result error code will be handled in following
	        this.authService.HandleErrorStatusCode(status);
	        /////
	        this.ResetPaging();
	        var apiresponse = JSON.parse(response);
	        if (status == 200) {
	            if (!apiresponse.error) {
	                this.csvValidationMsg = "";
	                this.listOfRecord = apiresponse.data;
	                this.DataListModel.totalItems = apiresponse.totalRecords;
	                this.FilterList();
	            }
	            else {
	                this.csvValidationMsg = apiresponse.error;
	                this.listOfRecord = [];
	            }
	        }
	        this.isLoading = false;
	        this.ClearFileInput();
	    };
	    BatchUploadPersonComponent.prototype.OnInstanceTypeChange = function () {
	        var _this = this;
	        this.sub = this.activeRoute.params.subscribe(function (params) {
	            if (_this.instanceHashId) {
	                _this.instanceService
	                    .GetBatchUploadDetailByHashId(_this.instanceHashId)
	                    .subscribe(function (res) {
	                    _this.instanceModel = res.data;
	                    _this.GetOrganizationList();
	                }, function (error) {
	                    _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	                });
	            }
	        });
	    };
	    BatchUploadPersonComponent.prototype.GetOrganizationList = function () {
	        var _this = this;
	        this.organizationService
	            .GetOrganizationListDropdownForAddUpdatePage(this.pageName, config_1.PermissionType.INSERT, this.instanceHashId)
	            .subscribe(function (res) {
	            _this.organizationList = res.data;
	            _this.organizationMasterHashId = "";
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    BatchUploadPersonComponent.prototype.HandleOnBuildItemForm = function (fileItem, Form) {
	        Form.append("instanceHashId", this.instanceHashId);
	    };
	    BatchUploadPersonComponent.prototype.ShowAssignToSVGModal = function () {
	        this.assignToSVGModal.instanceHashId = this.instanceHashId;
	        this.assignToSVGModal.organizationMasterHashId = this.organizationMasterHashId;
	        this.assignToSVGModal.sVGModel = this.sVGModelList;
	        this.assignToSVGModal.show();
	    };
	    BatchUploadPersonComponent.prototype.SuccessAssignToSVGModal = function ($event) {
	        this.sVGModelList = $event.SVGModel;
	        this.batchUploadPersonModel.sVGModel = $event.SVGModel;
	        this.importUserAssigedToSVG = $event.SVGModel.length > 0 ? false : true;
	    };
	    Object.defineProperty(BatchUploadPersonComponent.prototype, "ValidFormData", {
	        get: function () {
	            if (this.uploader.queue.length > 0 && this.instanceHashId != "")
	                return true;
	            else
	                return false;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BatchUploadPersonComponent.prototype.ValidateCSV = function () {
	        this.isLoading = true;
	        this.uploader.uploadAll();
	    };
	    BatchUploadPersonComponent.prototype.ImportCSV = function () {
	        this.isLoading = true;
	        this.ImportPersonRecord();
	    };
	    BatchUploadPersonComponent.prototype.ImportPersonRecord = function () {
	        var _this = this;
	        var validPersonList = this.listOfRecord.filter(function (x) { return x.isValidRecord; });
	        this.batchUploadPersonModel.signupModel = validPersonList;
	        this.batchUploadPersonModel.assignToDriver = this.importDriverRole;
	        this.batchUploadPersonModel.organizationMasterHashId = this.organizationMasterHashId;
	        this.signupService
	            .ImportPersonRecord(this.batchUploadPersonModel)
	            .subscribe(function (res) {
	            if (res.data) {
	                var module = _this.translate.instant("LblPerson");
	                _this.popupMsg = _this.translate.instant("LblRecordImportedSuccess", [
	                    module
	                ]);
	                _this.ShowSuccessPopup();
	                _this.listOfRecord = [];
	                _this.errorModel = [];
	                _this.instanceHashId = "";
	                _this.instanceModel = new instance_model_1.InstanceModel();
	                _this.importDriverRole = false;
	                _this.importUserAssigedToSVG = true;
	                _this.ResetPaging();
	                _this.batchUploadPersonModel = new batch_upload_person_model_1.BatchUploadPersonModel();
	                _this.organizationMasterHashId = "";
	                _this.organizationList = [];
	                _this.OnInstanceTypeChange();
	                _this.ClearSVGs();
	            }
	            else {
	                if (res.error instanceof Array) {
	                    _this.errorModel = res.error;
	                }
	                else {
	                    _this.csvValidationMsg = res.error;
	                }
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.csvValidationMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.listOfRecord = [];
	            _this.instanceHashId = "";
	            _this.isLoading = false;
	            _this.instanceModel = new instance_model_1.InstanceModel();
	            _this.importDriverRole = false;
	            _this.importUserAssigedToSVG = true;
	            _this.ResetPaging();
	            _this.ClearSVGs();
	            _this.batchUploadPersonModel = new batch_upload_person_model_1.BatchUploadPersonModel();
	            _this.organizationMasterHashId = "";
	            _this.GetOrganizationList();
	        });
	    };
	    Object.defineProperty(BatchUploadPersonComponent.prototype, "ValidImportRecord", {
	        get: function () {
	            if (this.listOfRecord &&
	                this.listOfRecord.length > 0 &&
	                this.listOfRecord.filter(function (x) { return x.isValidRecord; }).length > 0)
	                return true;
	            else
	                return false;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BatchUploadPersonComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.FilterList();
	    };
	    BatchUploadPersonComponent.prototype.DownloadTemplate = function () {
	        var url = "/csv_templates/Batch_Upload_Format_WeGo.csv";
	        window.location.href = url;
	    };
	    BatchUploadPersonComponent.prototype.ClearSVGs = function () {
	        this.sVGModelList = null;
	        this.batchUploadPersonModel.sVGModel = new Array();
	    };
	    BatchUploadPersonComponent.prototype.ClearFileInput = function () {
	        if (this.csvFile.nativeElement) {
	            this.csvFile.nativeElement.value = "";
	            this.uploader.clearQueue();
	        }
	    };
	    BatchUploadPersonComponent.prototype.ResetPaging = function () {
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.itemsPerPage = 100;
	    };
	    BatchUploadPersonComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    BatchUploadPersonComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    BatchUploadPersonComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    __decorate([
	        core_1.ViewChild("assignToSVGModal"), 
	        __metadata('design:type', Object)
	    ], BatchUploadPersonComponent.prototype, "assignToSVGModal", void 0);
	    __decorate([
	        core_1.ViewChild("csvFile"), 
	        __metadata('design:type', Object)
	    ], BatchUploadPersonComponent.prototype, "csvFile", void 0);
	    __decorate([
	        core_1.ViewChild("successPopup"), 
	        __metadata('design:type', Object)
	    ], BatchUploadPersonComponent.prototype, "successPopup", void 0);
	    BatchUploadPersonComponent = __decorate([
	        core_1.Component({
	            selector: "wego-batch-upload-person",
	            providers: [signup_service_1.SignupService, instance_service_1.InstanceService, organization_service_1.OrganizationService],
	            template: __webpack_require__(921),
	            styles: [
	                "\n    .setmargin\n    {\n        margin-top:10px;\n    }\n    .error-td\n    {\n      word-wrap: break-word;\n      word-break: break-word;\n      max-width: 300px;\n    }\n    "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof instance_service_1.InstanceService !== 'undefined' && instance_service_1.InstanceService) === 'function' && _c) || Object, (typeof (_d = typeof organization_service_1.OrganizationService !== 'undefined' && organization_service_1.OrganizationService) === 'function' && _d) || Object, (typeof (_e = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _e) || Object, (typeof (_f = typeof signup_service_1.SignupService !== 'undefined' && signup_service_1.SignupService) === 'function' && _f) || Object])
	    ], BatchUploadPersonComponent);
	    return BatchUploadPersonComponent;
	    var _a, _b, _c, _d, _e, _f;
	}());
	exports.BatchUploadPersonComponent = BatchUploadPersonComponent;


/***/ },
/* 920 */
/***/ function(module, exports) {

	"use strict";
	var BatchUploadPersonModel = (function () {
	    function BatchUploadPersonModel() {
	        this.sVGModel = new Array();
	        this.signupModel = new Array();
	    }
	    return BatchUploadPersonModel;
	}());
	exports.BatchUploadPersonModel = BatchUploadPersonModel;
	var SVGModel = (function () {
	    function SVGModel() {
	    }
	    return SVGModel;
	}());
	exports.SVGModel = SVGModel;


/***/ },
/* 921 */
/***/ function(module, exports) {

	module.exports = "<div *ngIf=\"isInit\" class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ 'LblBatchUploadPerson' | translate }}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"urlPersonList\">\r\n            <i class=\"fa fa-user fa-fw\"></i>{{ breadCrumbList }}</a>\r\n        </li>\r\n        <!-- <li>\r\n          <a [routerLink]=\"urlDriverList\">\r\n            <i class=\"fa fa-user fa-fw\"></i>{{ breadCrumbList }}</a>\r\n        </li> -->\r\n        <li class=\"active\">{{ 'LblBatchUploadPerson' | translate }}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25 \">\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"nopad\">\r\n      <form (ngSubmit)=\"ValidateCSV()\" class=\"mar_bot_10\">\r\n        <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Instance\" class=\"form-group col-sm-3\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblInstance' | translate }}</label>\r\n          <select [(ngModel)]=\"instanceHashId\" class=\"form-control\" name=\"instanceHashId\" (change)=\"OnInstanceTypeChange()\">\r\n            <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblInstance' | translate }}</option>\r\n            <option *ngFor=\"let item of instanceList\" [ngValue]=\"item.instanceHashId\">{{ item.instanceName }}</option>\r\n          </select>\r\n        </div>\r\n        <div class=\"form-group col-sm-3\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblCSVFile' | translate }}</label>\r\n          <input #csvFile type=\"file\" accept=\".csv\" ng2FileSelect [uploader]=\"uploader\" style=\"width: 100%;\" />\r\n          <div style=\"margin-top:5px\">\r\n            <a class=\"cursor-pointer\" target=\"_self\" (click)=\"DownloadTemplate()\">{{ 'LblDownloadTemplate' | translate }}</a>\r\n          </div>\r\n        </div>\r\n        <div class=\"form-group col-sm-6\">\r\n          <br>  \r\n          <button *ngIf=\"ValidFormData\" class=\"btn btn-gray\" type=\"submit\">\r\n            {{ 'LblValidateCSV' | translate }}\r\n          </button>\r\n          <button *ngIf=\"ValidImportRecord\" class=\"btn btn-green\" type=\"button\" (click)=\"ImportCSV()\">\r\n            <span>\r\n              {{ 'LblImportValidPerson' | translate }}\r\n            </span>\r\n          </button>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"col-sm-12\">\r\n          <p class=\"text-danger\">\r\n            {{ csvValidationMsg }}\r\n          </p>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"form-group col-sm-3\">\r\n          <label>{{ 'LblFieldToUploadedOrValidated' | translate }}</label>\r\n          <div class=\"checkbox\">\r\n            <label>\r\n              <input disabled type=\"checkbox\" checked=\"checked\">{{ 'LblUserName' | translate }}</label>\r\n          </div>\r\n          <div class=\"checkbox\">\r\n            <label>\r\n              <input disabled type=\"checkbox\" checked=\"checked\">{{ 'LblEmail' | translate }}</label>\r\n          </div>\r\n          <div class=\"checkbox\">\r\n            <label>\r\n              <input disabled type=\"checkbox\" name=\"instanceModel.batchUploadPersonConfigurationModel.fieldPassword\" [(ngModel)]=\"instanceModel.batchUploadPersonConfigurationModel.fieldPassword\">{{ 'LblPassword' | translate }}</label>\r\n          </div>\r\n          <div class=\"checkbox\">\r\n            <label>\r\n              <input disabled type=\"checkbox\" name=\"instanceModel.batchUploadPersonConfigurationModel.fieldFirstName\" [(ngModel)]=\"instanceModel.batchUploadPersonConfigurationModel.fieldFirstName\">{{ 'LblFirstName' | translate }}</label>\r\n          </div>\r\n          <div class=\"checkbox\">\r\n            <label>\r\n              <input disabled type=\"checkbox\" name=\"instanceModel.batchUploadPersonConfigurationModel.fieldMiddleName\" [(ngModel)]=\"instanceModel.batchUploadPersonConfigurationModel.fieldMiddleName\">{{ 'LblMiddleName' | translate }}</label>\r\n          </div>\r\n          <div class=\"checkbox\">\r\n            <label>\r\n              <input disabled type=\"checkbox\" name=\"instanceModel.batchUploadPersonConfigurationModel.fieldLastName\" [(ngModel)]=\"instanceModel.batchUploadPersonConfigurationModel.fieldLastName\">{{ 'LblLastName' | translate }}</label>\r\n          </div>\r\n          <div class=\"checkbox\">\r\n            <label>\r\n              <input disabled type=\"checkbox\" name=\"instanceModel.batchUploadPersonConfigurationModel.fieldMobileNumber\" [(ngModel)]=\"instanceModel.batchUploadPersonConfigurationModel.fieldMobileNumber\">{{ 'LblMobileNumber' | translate }}</label>\r\n          </div>\r\n          <div class=\"checkbox\">\r\n            <label>\r\n              <input disabled type=\"checkbox\" name=\"instanceModel.batchUploadPersonConfigurationModel.fieldPhoneNumber\" [(ngModel)]=\"instanceModel.batchUploadPersonConfigurationModel.fieldPhoneNumber\">{{ 'LblPhoneNumber' | translate }}</label>\r\n          </div>\r\n          <div class=\"checkbox\">\r\n            <label>\r\n              <input disabled type=\"checkbox\" name=\"instanceModel.batchUploadPersonConfigurationModel.fieldHomeAddress\" [(ngModel)]=\"instanceModel.batchUploadPersonConfigurationModel.fieldHomeAddress\">{{ 'LblHomeAddress' | translate }}</label>\r\n          </div>          \r\n          <div class=\"checkbox\">\r\n            <label>\r\n              <input disabled type=\"checkbox\" name=\"instanceModel.batchUploadPersonConfigurationModel.fieldCountryCode\" [(ngModel)]=\"instanceModel.batchUploadPersonConfigurationModel.fieldCountryCode\">{{ 'LblCountry' | translate }}</label>\r\n          </div>\r\n          <div class=\"checkbox\">\r\n            <label>\r\n              <input disabled type=\"checkbox\" name=\"instanceModel.batchUploadPersonConfigurationModel.fieldRfidTagId\" [(ngModel)]=\"instanceModel.batchUploadPersonConfigurationModel.fieldRfidTagId\">{{ 'LblRfidTagId' | translate }}</label>\r\n          </div>\r\n          <div class=\"checkbox\">\r\n            <label>\r\n              <input disabled type=\"checkbox\" name=\"instanceModel.batchUploadPersonConfigurationModel.fieldLicenseTypes\" [(ngModel)]=\"instanceModel.batchUploadPersonConfigurationModel.fieldLicenseTypes\">{{ 'LblLicense' | translate }}</label>\r\n          </div>\r\n          <div class=\"checkbox\">\r\n            <label>\r\n              <input disabled type=\"checkbox\" name=\"instanceModel.batchUploadPersonConfigurationModel.fieldCertificates\" [(ngModel)]=\"instanceModel.batchUploadPersonConfigurationModel.fieldCertificates\">{{ 'LblCertificates' | translate }}</label>\r\n          </div>\r\n          <div class=\"checkbox\">\r\n            <label>\r\n              <input disabled type=\"checkbox\" name=\"instanceModel.batchUploadPersonConfigurationModel.fieldEmployeeNumber\" [(ngModel)]=\"instanceModel.batchUploadPersonConfigurationModel.fieldEmployeeNumber\">{{ 'LblEmployeeNumber' | translate }}</label>\r\n          </div>          \r\n          <div class=\"checkbox\">\r\n            <label>\r\n              <input disabled type=\"checkbox\" name=\"instanceModel.batchUploadPersonConfigurationModel.fieldAccessCardId\" [(ngModel)]=\"instanceModel.batchUploadPersonConfigurationModel.fieldAccessCardId\">{{ 'LblAccessCardId' | translate }}</label>\r\n          </div>\r\n          <div class=\"checkbox\">\r\n            <label>\r\n              <input disabled type=\"checkbox\" name=\"instanceModel.batchUploadPersonConfigurationModel.fieldIBANNumber\" [(ngModel)]=\"instanceModel.batchUploadPersonConfigurationModel.fieldIBANNumber\">{{ 'LblIBANNumber' | translate }}</label>\r\n          </div>\r\n          <div class=\"checkbox\">\r\n            <label>\r\n              <input disabled type=\"checkbox\" name=\"instanceModel.batchUploadPersonConfigurationModel.fieldBICCode\" [(ngModel)]=\"instanceModel.batchUploadPersonConfigurationModel.fieldBICCode\">{{ 'LblBICCode' | translate }}</label>\r\n          </div>\r\n          <div class=\"checkbox\">\r\n            <label>\r\n              <input disabled type=\"checkbox\" name=\"instanceModel.batchUploadPersonConfigurationModel.fieldMandateId\" [(ngModel)]=\"instanceModel.batchUploadPersonConfigurationModel.fieldMandateId\">{{ 'LblMandateId' | translate }}</label>\r\n          </div>\r\n          <div class=\"checkbox\">\r\n            <label>\r\n              <input disabled type=\"checkbox\" name=\"instanceModel.batchUploadPersonConfigurationModel.fieldMandateSignatureDate\" [(ngModel)]=\"instanceModel.batchUploadPersonConfigurationModel.fieldMandateSignatureDate\">{{ 'LblMandateSignatureDate' | translate }}</label>\r\n          </div>\r\n          <div class=\"checkbox\">\r\n            <label>\r\n              <input disabled type=\"checkbox\" name=\"instanceModel.batchUploadPersonConfigurationModel.fieldIsAmmandment\" [(ngModel)]=\"instanceModel.batchUploadPersonConfigurationModel.fieldIsAmmandment\">{{ 'LblIsAmmandment' | translate }}</label>\r\n          </div>\r\n        </div>\r\n        <div class=\"form-group col-sm-4\">\r\n          <label>{{ 'LblImportDriverRole' | translate }}</label>\r\n          <div class=\"clearfix\" ></div>\r\n          <label class=\"radio-inline\">\r\n            <input type=\"radio\" [(ngModel)]=\"importDriverRole\" name=\"importDriverRole\" [value]=\"true\">{{ 'LblYes' | translate }}</label>\r\n          <label class=\"radio-inline\">\r\n            <input type=\"radio\" [(ngModel)]=\"importDriverRole\" name=\"importDriverRole\" [value]=\"false\" (change)=\"organizationMasterHashId='';ClearSVGs()\">{{ 'LblNo' | translate }}</label>\r\n          <div class=\"setmargin\">\r\n            <label>\r\n              <span class=\"text text-danger\">*</span>{{ 'LblOrganization' | translate }}</label>\r\n            <select [(ngModel)]=\"organizationMasterHashId\" class=\"form-control\" name=\"organizationMasterHashId\" (change)=\"ClearSVGs()\">\r\n              <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblOrganization' | translate }}</option>\r\n              <option *ngFor=\"let item of organizationList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\r\n            </select>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'OrganizationMaterhashId' }}</span>\r\n          </div>\r\n          <div class=\"setmargin\">\r\n            <button [disabled]=\"organizationMasterHashId==''\" class=\"btn btn-gray\" type=\"button\" (click)=\"ShowAssignToSVGModal()\">{{ 'LblAssignToSVG' | translate }}</button>\r\n            <div *ngIf=\"importUserAssigedToSVG\" class=\"text-left\" style=\"color : #007777 \"> {{ 'LblUserAssignSVGMessage'| translate }} </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"form-group col-sm-5\" *ngIf=\"sVGModelList && sVGModelList.length > 0\">\r\n          <label>{{ 'LblSelectedSVGs' | translate }}</label>\r\n          <div class=\"pull-right\">\r\n            <a class=\"cursor-pointer\" target=\"_self\" (click)=\"ClearSVGs()\">{{ 'LblClear' | translate }}</a>\r\n          </div>\r\n          <div class=\"table table-responsive mar_bot_ziro\">\r\n            <table class=\"table table-bordered mar_bot_ziro\">\r\n              <thead>\r\n                <tr>\r\n                  <th class=\"cursor-pointer\">\r\n                    {{ 'LblSVG' | translate }}\r\n                  </th>\r\n                  <th class=\"cursor-pointer\">\r\n                    {{ 'LblSubscription' | translate }}\r\n                  </th>\r\n                </tr>\r\n              </thead>\r\n              <tbody>\r\n                <!--<template [ngIf]=\"sVGModelList.length > 0\">-->\r\n                <tr *ngFor=\"let sharedVehicleGroup of sVGModelList\">\r\n                  <td>{{ sharedVehicleGroup.groupName }}</td>\r\n                  <td>{{ sharedVehicleGroup.subscriptionName }}</td>\r\n                </tr>\r\n                <!--</template>-->\r\n              </tbody>\r\n            </table>\r\n            <div class=\"clearfix\"></div>\r\n          </div>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n      </form>\r\n      <hr>\r\n      <div class=\"table table-responsive mar_bot_ziro\">\r\n        <table *ngIf=\"listOfRecord && listOfRecord.length > 0\" class=\"table table-bordered mar_bot_ziro\">\r\n          <thead>\r\n            <tr>\r\n              <th colspan=\"8\"></th>\r\n              <th colspan=\"5\">{{ 'LblHomeAddress' | translate }}</th>\r\n            </tr>\r\n            <tr>\r\n              <th>\r\n              </th>\r\n              <th>\r\n                {{ 'LblUserName' | translate }}\r\n              </th>\r\n              <th>\r\n                {{ 'LblEmail' | translate }}\r\n              </th>\r\n              <!--<th>\r\n                {{ 'LblPassword' | translate }}\r\n              </th>-->\r\n              <th>\r\n                {{ 'LblFirstName' | translate }}\r\n              </th>\r\n              <th>\r\n                {{ 'LblMiddleName' | translate }}\r\n              </th>\r\n              <th>\r\n                {{ 'LblLastName' | translate }}\r\n              </th>\r\n              <th>\r\n                {{ 'LblMobileNumber' | translate }}\r\n              </th>\r\n              <th>\r\n                {{ 'LblPhoneNumber' | translate }}\r\n              </th>\r\n              <th>\r\n                {{ 'LblStreetName' | translate }}\r\n              </th>\r\n              <th>\r\n                {{ 'LblHouseNo' | translate }}\r\n              </th>\r\n              <th>\r\n                {{ 'LblHouseExtention' | translate }}\r\n              </th>\r\n              <th>\r\n                {{ 'LblZipCode' | translate }}\r\n              </th>\r\n              <th>\r\n                {{ 'LblCity' | translate }}\r\n              </th>\r\n              <th>\r\n                {{ 'LblRfidTagId' | translate }}\r\n              </th>\r\n              <th>\r\n                {{ 'LblLicense' | translate }}\r\n              </th>\r\n              <th>\r\n                {{ 'LblCertificates' | translate }}\r\n              </th>\r\n              <th>\r\n                {{ 'LblEmployeeNumber' | translate }}\r\n              </th>              \r\n              <th>\r\n                {{ 'LblAccessCardId' | translate }}\r\n              </th>\r\n              <th>\r\n                {{ 'LblIBANNumber' | translate }}\r\n              </th>\r\n              <th>\r\n                {{ 'LblBICCode' | translate }}\r\n              </th>\r\n              <th>\r\n                {{ 'LblMandateId' | translate }}\r\n              </th>\r\n              <th>\r\n                {{ 'LblMandateSignatureDate' | translate }}\r\n              </th>\r\n              <th>\r\n                {{ 'LblIsAmmandment' | translate }}\r\n              </th>\r\n            </tr>\r\n          </thead>\r\n          <tbody>\r\n            <tr *ngFor=\"let person of listOfFilterRecord\">\r\n              <td>\r\n                <i *ngIf=\"person.isValidRecord\" class=\"fa fa-thumbs-up text-success fa-fw\" aria-hidden=\"true\"></i>\r\n                <i *ngIf=\"!person.isValidRecord\" class=\"fa fa-thumbs-down text-danger fa-fw cursor-pointer\" [popover]=\"invalidReason\" aria-hidden=\"true\"></i>\r\n                <popover-content #invalidReason [hidden]=\"person.isValidRecord\" title=\"{{ 'LblInvalidRecordReason' | translate }}\" placement=\"bottom\"\r\n                  [animation]=\"true\" [closeOnClickOutside]=\"true\">\r\n                  <table class=\"table table-bordered mar_bot_ziro\" style=\"border: 1px solid #E0E0E0;\">\r\n                    <tbody>\r\n                      <tr *ngFor=\"let errorData of person.errorModel\">\r\n                        <td class=\"error-td\">{{ errorData.value }}</td>\r\n                      </tr>\r\n                    </tbody>\r\n                  </table>\r\n                </popover-content>\r\n              </td>\r\n              <td>{{ person.userName }}</td>\r\n              <td>{{ person.email }}</td>\r\n              <!--<td>{{ person.password }}</td>-->\r\n              <td>{{ person.firstName }}</td>\r\n              <td>{{ person.middleName }}</td>\r\n              <td>{{ person.lastName }} </td>\r\n              <td>{{ person.telephone1 }}</td>\r\n              <td>{{ person.telephone2 }}</td>\r\n              <td>{{ person.personHomeAddressModel?.street }}</td>\r\n              <td>{{ person.personHomeAddressModel?.houseNo }}</td>\r\n              <td>{{ person.personHomeAddressModel?.houseExtention }}</td>\r\n              <td>{{ person.personHomeAddressModel?.zipCode }}</td>\r\n              <td>{{ person.personHomeAddressModel?.city }}</td>\r\n              <td>{{ person.rfidTagId }}</td>\r\n              <td>{{ person.licenseTypes }}</td>\r\n              <td>{{ person.certificates }}</td>\r\n              <td>{{ person.employeeNumber }}</td>\r\n              <td>{{ person.accessCardId }}</td>\r\n              <td>{{ person.ibanNumber }}</td>\r\n              <td>{{ person.bicCode }}</td>\r\n              <td>{{ person.mandateId }}</td>\r\n              <td>{{ person.mandateSignatureDate }}</td>\r\n              <td>{{ person.isAmmandment }}</td>\r\n            </tr>\r\n          </tbody>\r\n        </table>\r\n        <div *ngIf=\"DataListModel.totalItems > 0\" class=\"col-sm-12\">\r\n          <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n            [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n            lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n<wego-assign-svg-popup #assignToSVGModal (OnSuccessSelect)=\"SuccessAssignToSVGModal($event)\"></wego-assign-svg-popup>\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n";

/***/ },
/* 922 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var config_1 = __webpack_require__(60);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var maintenance_planning_service_1 = __webpack_require__(923);
	var MaintenancePlanningReportComponent = (function () {
	    function MaintenancePlanningReportComponent(authService, maintenancePlanningReportService) {
	        this.authService = authService;
	        this.maintenancePlanningReportService = maintenancePlanningReportService;
	        this.isValidSearch = false;
	        this.roleLevel = config_1.RoleLevel;
	    }
	    MaintenancePlanningReportComponent.prototype.ngOnInit = function () {
	        this.reportName = "Maintenance_Planning_Report";
	        this.itemPerPageList = config_1.WeGoConfig.GRID_PAGGING;
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.DataListModel = new config_1.DataListModel();
	    };
	    MaintenancePlanningReportComponent.prototype.OnSearch = function ($event) {
	        var _this = this;
	        this.isLoading = true;
	        var model = $event.model;
	        this.maintenancePlanningReportService.GetOdometerValuePerVehicleList(model).subscribe(function (res) {
	            if (res && res.data) {
	                _this.isValidSearch = res.data.length > 0 ? true : false;
	                _this.maintenancePlanningVehicleList = res.data;
	                _this.DataListModel.totalItems = res.totalRecords;
	                _this.DataListModel.infoMessage = res.error;
	                _this.errorModel = [];
	            }
	            else {
	                // Handle No Data
	                _this.maintenancePlanningVehicleList = [];
	                _this.isValidSearch = false;
	                _this.errorModel = res.error;
	            }
	            _this.FilterList();
	            _this.isLoading = false;
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    MaintenancePlanningReportComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.itemsPerPage = parseInt(event);
	        this.FilterList();
	    };
	    MaintenancePlanningReportComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.FilterList();
	    };
	    MaintenancePlanningReportComponent.prototype.FilterList = function () {
	        var start = this.DataListModel.itemsPerPage * (this.DataListModel.currentPage - 1);
	        var end = start + (this.DataListModel.itemsPerPage);
	        this.listOfFilterRecord = this.maintenancePlanningVehicleList.slice(start, end);
	    };
	    MaintenancePlanningReportComponent.prototype.ResetPaging = function () {
	        this.maintenancePlanningVehicleList = [];
	        this.listOfFilterRecord = [];
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.itemsPerPage = 10;
	    };
	    MaintenancePlanningReportComponent.prototype.ResetValidSearch = function ($event) {
	        var isValidSearch = $event.isValidSearch;
	        this.isValidSearch = isValidSearch;
	        this.maintenancePlanningVehicleList = [];
	        this.listOfFilterRecord = [];
	        this.DataListModel.totalItems = 0;
	    };
	    MaintenancePlanningReportComponent.prototype.OnExportExcel = function ($event) {
	        var _this = this;
	        this.isLoading = true;
	        this.isLoading = true;
	        var model = $event.model;
	        this.maintenancePlanningReportService.ExportOdometerValuePerVehicleReportExcel(model)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "MaintenencePlanning" + new Date().toISOString() + ".xlsx";
	                _this.authService.DownloadXlsFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    MaintenancePlanningReportComponent.prototype.OnExportPDF = function ($event) {
	        var _this = this;
	        this.isLoading = true;
	        var model = $event.model;
	        this.maintenancePlanningReportService.ExportOdometerValuePerVehicleReportPDF(model)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "MaintenencePlanning" + new Date().toISOString() + ".pdf";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    MaintenancePlanningReportComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-maintainace-planning-report',
	            template: __webpack_require__(924),
	            providers: [maintenance_planning_service_1.MaintenancePlanningReportService],
	            styles: ["\n          .box-body{\n            padding: 0px 10px 10px;\n          }\n          .checkbox-inline{\n            padding-left: 0px !important;\n          }         \n          "
	            ] }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof maintenance_planning_service_1.MaintenancePlanningReportService !== 'undefined' && maintenance_planning_service_1.MaintenancePlanningReportService) === 'function' && _b) || Object])
	    ], MaintenancePlanningReportComponent);
	    return MaintenancePlanningReportComponent;
	    var _a, _b;
	}());
	exports.MaintenancePlanningReportComponent = MaintenancePlanningReportComponent;


/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var jquery_helper_service_1 = __webpack_require__(67);
	var MaintenancePlanningReportService = (function () {
	    function MaintenancePlanningReportService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	        this.JQueryHelper = new jquery_helper_service_1.JQueryHelperService();
	    }
	    MaintenancePlanningReportService.prototype.GetOdometerValuePerVehicleList = function (model) {
	        var getUrl = config_1.WeGoConfig.API_GET_MAINTENANCE_PLANNING_VEHICLE_LIST;
	        var queryStringReportFilterModel = this.JQueryHelper.Param(model);
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        getUrl = getUrl + "?" + decodeURIComponent(queryStringReportFilterModel);
	        return this.http.get(getUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    MaintenancePlanningReportService.prototype.ExportOdometerValuePerVehicleReportPDF = function (model) {
	        var getUrl = config_1.WeGoConfig.API_GET_MAINTENANCE_PLANNING_VEHICLE_LIST_PDF;
	        var queryStringReportFilterModel = this.JQueryHelper.Param(model);
	        getUrl = getUrl + "?" + decodeURIComponent(queryStringReportFilterModel);
	        var headers = this.authService.GetHeader('application/pdf');
	        var options = new http_1.RequestOptions({ headers: headers, responseType: http_1.ResponseContentType.Blob });
	        return this.http.get(getUrl, options);
	    };
	    MaintenancePlanningReportService.prototype.ExportOdometerValuePerVehicleReportExcel = function (model) {
	        var getUrl = config_1.WeGoConfig.API_GET_MAINTENANCE_PLANNING_VEHICLE_LIST_XLS;
	        var queryStringReportFilterModel = this.JQueryHelper.Param(model);
	        getUrl = getUrl + "?" + decodeURIComponent(queryStringReportFilterModel);
	        var headers = this.authService.GetHeader('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
	        var options = new http_1.RequestOptions({ headers: headers, responseType: http_1.ResponseContentType.Blob });
	        return this.http.get(getUrl, options);
	    };
	    MaintenancePlanningReportService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], MaintenancePlanningReportService);
	    return MaintenancePlanningReportService;
	    var _a, _b;
	}());
	exports.MaintenancePlanningReportService = MaintenancePlanningReportService;


/***/ },
/* 924 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ 'LblMaintenancePlanningreport' | translate }}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li class=\"active\">{{ 'LblMaintenancePlanningreport' | translate }}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <div class=\"box box-default\">\r\n          <div class=\"box-body\" style=\"display: block;\">\r\n            <!--Filter-->\r\n            <div class=\"row\" style=\"margin-top:10px;\">\r\n              <div class=\"col-md-12\">\r\n                <wego-report-filter [IsValidSearch]=\"isValidSearch\" [ErrorModel]=\"errorModel\" [ReportName]=\"reportName\" (OnSearch)=\"OnSearch($event)\"\r\n                  (OnExportPDF)=\"OnExportPDF($event)\" (OnExportExcel)=\"OnExportExcel($event)\" (ResetValidSearch)=\"ResetValidSearch($event)\"></wego-report-filter>\r\n              </div>\r\n            </div>\r\n            <!--No record found-->\r\n            <div class=\"row\">\r\n              <div class=\"col-sm-12 text-danger text-center\">\r\n                <div *ngIf=\"DataListModel.totalItems == 0\">\r\n                  {{ DataListModel.infoMessage }}\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Trip detail table-->\r\n            <div class=\"row\" *ngIf=\"listOfFilterRecord && listOfFilterRecord.length > 0\">\r\n              <fieldset class=\"col-md-12\">\r\n                <legend class=\"legendStyle\">\r\n                  <div class=\"form-inline\" style=\"padding-bottom: 5px;\">\r\n                    <div class=\"form-group\">\r\n                      {{ 'LblMaintenancePlanningList' | translate }}\r\n                    </div>\r\n                    <div class=\"form-group pull-right\">\r\n                      <select class=\"form-control\" title='Items Per Page' [(ngModel)]=\"DataListModel.itemsPerPage\" name=\"itemPerPage\" (change)=\"OnPagingChange($event.target.value)\">\r\n                        <option *ngFor=\"let item of itemPerPageList\" [attr.value]='item.value'>{{ item }}</option>\r\n                      </select>\r\n                    </div>\r\n                  </div>\r\n                </legend>\r\n                <div class=\"clearfix\"></div>\r\n                <div class=\"row\">\r\n                  <div class=\"col-sm-12\">\r\n                    <div class=\"table table-responsive mar_bot_ziro\">\r\n                      <table class=\"table table-bordered mar_bot_ziro\">\r\n                        <thead>\r\n                          <tr>\r\n                            <th>{{ 'LblLicenceTag' | translate }}\r\n                            </th>\r\n                            <th>{{ 'LblOdometerValue' | translate }}\r\n                            </th>\r\n                            <th>{{ 'LblOdometerRegistered' | translate }}\r\n                            </th>\r\n                            <th>{{ 'LblSharedVehicleGroup' | translate }}\r\n                            </th>\r\n                            <th *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Company\">{{ 'LblCompany' | translate }}\r\n                            </th>\r\n                          </tr>\r\n                        </thead>\r\n                        <tbody>\r\n                          <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                            <tr *ngFor=\"let vehicle of listOfFilterRecord\">\r\n                              <td>{{ vehicle.licencePlate}}</td>\r\n                              <td>{{ vehicle.formattedOdometerValue}}</td>\r\n                              <td>{{ vehicle.odometerUpdatedDateTime}}</td>\r\n                              <td>{{ vehicle.svg}}</td>\r\n                              <td *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Company\">{{ vehicle.company}}</td>\r\n\r\n                            </tr>\r\n                          </template>\r\n                          <tr *ngIf=\"DataListModel.totalItems == 0\">\r\n                            <td class=\"text-center text-danger\" colspan=\"6\">\r\n                              {{ DataListModel.infoMessage }}\r\n                            </td>\r\n                          </tr>\r\n                        </tbody>\r\n                      </table>\r\n                      <div *ngIf=\"DataListModel.totalItems > 0\" class=\"col-sm-12\">\r\n                        <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                          [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\"\r\n                          firstText=\"&laquo;\" lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n                      </div>\r\n                    </div>\r\n                    <div class=\"clearfix\"></div>\r\n                  </div>\r\n                </div>\r\n              </fieldset>\r\n            </div>\r\n\r\n\r\n          </div>\r\n\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n\r\n  <wego-lodder [isLoading]=\"isLoading\"></wego-lodder>";

/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var config_1 = __webpack_require__(60);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var revenue_per_vehicle_service_1 = __webpack_require__(926);
	var RevenuepervehicleReportComponent = (function () {
	    function RevenuepervehicleReportComponent(authService, revenuePerVehicleReportService) {
	        this.authService = authService;
	        this.revenuePerVehicleReportService = revenuePerVehicleReportService;
	        this.isValidSearch = false;
	        this.roleLevel = config_1.RoleLevel;
	    }
	    RevenuepervehicleReportComponent.prototype.ngOnInit = function () {
	        this.reportName = "Revenue_Per_Vehicle_Report";
	        this.itemPerPageList = config_1.WeGoConfig.GRID_PAGGING;
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.DataListModel = new config_1.DataListModel();
	    };
	    RevenuepervehicleReportComponent.prototype.OnSearch = function ($event) {
	        var _this = this;
	        this.ResetPaging();
	        this.isLoading = true;
	        var model = $event.model;
	        this.revenuePerVehicleReportService.GetRevenuePerVehicleList(model).subscribe(function (res) {
	            if (res && res.data) {
	                _this.isValidSearch = res.data.length > 0 ? true : false;
	                _this.revenuPerVehicleList = res.data;
	                _this.DataListModel.totalItems = res.totalRecords;
	                _this.DataListModel.infoMessage = res.error;
	                _this.errorModel = [];
	            }
	            else {
	                // Handle No Data
	                _this.revenuPerVehicleList = [];
	                _this.isValidSearch = false;
	                _this.errorModel = res.error;
	            }
	            _this.FilterList();
	            _this.isLoading = false;
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    RevenuepervehicleReportComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.itemsPerPage = parseInt(event);
	        this.FilterList();
	    };
	    RevenuepervehicleReportComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.FilterList();
	    };
	    RevenuepervehicleReportComponent.prototype.FilterList = function () {
	        var start = this.DataListModel.itemsPerPage * (this.DataListModel.currentPage - 1);
	        var end = start + (this.DataListModel.itemsPerPage);
	        this.listOfFilterRecord = this.revenuPerVehicleList.slice(start, end);
	    };
	    RevenuepervehicleReportComponent.prototype.ResetPaging = function () {
	        this.revenuPerVehicleList = [];
	        this.listOfFilterRecord = [];
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.itemsPerPage = 10;
	    };
	    RevenuepervehicleReportComponent.prototype.ResetValidSearch = function ($event) {
	        var isValidSearch = $event.isValidSearch;
	        this.isValidSearch = isValidSearch;
	        this.revenuPerVehicleList = [];
	        this.listOfFilterRecord = [];
	        this.DataListModel.totalItems = 0;
	    };
	    RevenuepervehicleReportComponent.prototype.OnExportExcel = function ($event) {
	        var _this = this;
	        this.isLoading = true;
	        this.isLoading = true;
	        var model = $event.model;
	        this.revenuePerVehicleReportService.ExportRevenuePerVehicleReportExcel(model)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "RevenuePerVehicle" + new Date().toISOString() + ".xlsx";
	                _this.authService.DownloadXlsFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    RevenuepervehicleReportComponent.prototype.OnExportPDF = function ($event) {
	        var _this = this;
	        this.isLoading = true;
	        var model = $event.model;
	        this.revenuePerVehicleReportService.ExportRevenuePerVehicleReportPDF(model)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "RevenuePerVehicle" + new Date().toISOString() + ".pdf";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    RevenuepervehicleReportComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-revenue-per-vehicle-report',
	            template: __webpack_require__(927),
	            providers: [revenue_per_vehicle_service_1.RevenuePerVehicleReportService],
	            styles: ["\n          .box-body{\n            padding: 0px 10px 10px;\n          }\n          .checkbox-inline{\n            padding-left: 0px !important;\n          }         \n          "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof revenue_per_vehicle_service_1.RevenuePerVehicleReportService !== 'undefined' && revenue_per_vehicle_service_1.RevenuePerVehicleReportService) === 'function' && _b) || Object])
	    ], RevenuepervehicleReportComponent);
	    return RevenuepervehicleReportComponent;
	    var _a, _b;
	}());
	exports.RevenuepervehicleReportComponent = RevenuepervehicleReportComponent;


/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var jquery_helper_service_1 = __webpack_require__(67);
	var RevenuePerVehicleReportService = (function () {
	    function RevenuePerVehicleReportService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	        this.JQueryHelper = new jquery_helper_service_1.JQueryHelperService();
	    }
	    RevenuePerVehicleReportService.prototype.GetRevenuePerVehicleList = function (model) {
	        var getUrl = config_1.WeGoConfig.API_GET_REVENUE_PER_VEHICLE_LIST;
	        var queryStringReportFilterModel = this.JQueryHelper.Param(model);
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        getUrl = getUrl + "?" + decodeURIComponent(queryStringReportFilterModel);
	        return this.http.get(getUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    RevenuePerVehicleReportService.prototype.ExportRevenuePerVehicleReportPDF = function (model) {
	        var getUrl = config_1.WeGoConfig.API_EXPORT_REVENUE_PER_VEHICLE_LIST_PDF;
	        var queryStringReportFilterModel = this.JQueryHelper.Param(model);
	        getUrl = getUrl + "?" + decodeURIComponent(queryStringReportFilterModel);
	        var headers = this.authService.GetHeader('application/pdf');
	        var options = new http_1.RequestOptions({ headers: headers, responseType: http_1.ResponseContentType.Blob });
	        return this.http.get(getUrl, options);
	    };
	    RevenuePerVehicleReportService.prototype.ExportRevenuePerVehicleReportExcel = function (model) {
	        var getUrl = config_1.WeGoConfig.API_EXPORT_REVENUE_PER_VEHICLE_LIST_XLS;
	        var queryStringReportFilterModel = this.JQueryHelper.Param(model);
	        getUrl = getUrl + "?" + decodeURIComponent(queryStringReportFilterModel);
	        var headers = this.authService.GetHeader('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
	        var options = new http_1.RequestOptions({ headers: headers, responseType: http_1.ResponseContentType.Blob });
	        return this.http.get(getUrl, options);
	    };
	    RevenuePerVehicleReportService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], RevenuePerVehicleReportService);
	    return RevenuePerVehicleReportService;
	    var _a, _b;
	}());
	exports.RevenuePerVehicleReportService = RevenuePerVehicleReportService;


/***/ },
/* 927 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ 'LblRevenuePerVehicleReport' | translate }}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li class=\"active\">{{ 'LblRevenuePerVehicleReport' | translate }}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <div class=\"box box-default\">\r\n          <div class=\"box-body\" style=\"display: block;\">\r\n            <!--Filter-->\r\n            <div class=\"row\" style=\"margin-top:10px;\">\r\n              <div class=\"col-md-12\">\r\n                <wego-report-filter [IsValidSearch]=\"isValidSearch\" [ErrorModel]=\"errorModel\" [ReportName]=\"reportName\" (OnSearch)=\"OnSearch($event)\" (OnExportPDF)=\"OnExportPDF($event)\"\r\n                  (OnExportExcel)=\"OnExportExcel($event)\" (ResetValidSearch)=\"ResetValidSearch($event)\"></wego-report-filter>\r\n              </div>\r\n            </div>\r\n            <!--No record found-->\r\n            <div class=\"row\">\r\n              <div class=\"col-sm-12 text-danger text-center\">\r\n                <div *ngIf=\"DataListModel.totalItems == 0\">\r\n                  {{ DataListModel.infoMessage }}\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Trip detail table-->\r\n            <div class=\"row\" *ngIf=\"listOfFilterRecord && listOfFilterRecord.length > 0\">\r\n              <fieldset class=\"col-md-12\">\r\n                <legend class=\"legendStyle\">\r\n                  <div class=\"form-inline\" style=\"padding-bottom: 5px;\">\r\n                    <div class=\"form-group\">\r\n                      {{ 'LblRevenuePerVehicleList' | translate }}\r\n                    </div>\r\n                    <div class=\"form-group pull-right\">\r\n                      <select class=\"form-control\" title='Items Per Page' [(ngModel)]=\"DataListModel.itemsPerPage\" name=\"itemPerPage\" (change)=\"OnPagingChange($event.target.value)\">\r\n                        <option *ngFor=\"let item of itemPerPageList\" [attr.value]='item.value'>{{ item }}</option>\r\n                      </select>\r\n                    </div>\r\n                  </div>\r\n                </legend>\r\n                <div class=\"clearfix\"></div>\r\n                <div class=\"row\">\r\n                  <div class=\"col-sm-12\">\r\n                    <div class=\"table table-responsive mar_bot_ziro\">\r\n                      <table class=\"table table-bordered mar_bot_ziro\">\r\n                        <thead>\r\n                          <tr>\r\n                            <th>{{ 'LblLicenceTag' | translate }}\r\n                            </th>\r\n                            <th>{{ 'LblRevenue' | translate }}\r\n                            </th>\r\n                            <th>{{ 'LblSharedVehicleGroup' | translate }}\r\n                            </th>\r\n                            <th *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Company\">{{ 'LblCompany' | translate }}\r\n                            </th>\r\n                          </tr>\r\n                        </thead>\r\n                        <tbody>\r\n                          <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                            <tr *ngFor=\"let vehicle of listOfFilterRecord\">\r\n                              <td>{{ vehicle.licencePlate}}</td>\r\n                              <td>{{ vehicle.formattedRevenue }}</td>\r\n                              <td>{{ vehicle.svg}}</td>\r\n                              <td *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Company\">{{ vehicle.company}}</td>\r\n\r\n                            </tr>\r\n                          </template>\r\n                          <tr *ngIf=\"DataListModel.totalItems == 0\">\r\n                            <td class=\"text-center text-danger\" colspan=\"6\">\r\n                              {{ DataListModel.infoMessage }}\r\n                            </td>\r\n                          </tr>\r\n                        </tbody>\r\n                      </table>\r\n                      <div *ngIf=\"DataListModel.totalItems > 0\" class=\"col-sm-12\">\r\n                        <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                          [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\"\r\n                          firstText=\"&laquo;\" lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n                      </div>\r\n                    </div>\r\n                    <div class=\"clearfix\"></div>\r\n                  </div>\r\n                </div>\r\n              </fieldset>\r\n            </div>\r\n\r\n\r\n          </div>\r\n\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n\r\n  <wego-lodder [isLoading]=\"isLoading\"></wego-lodder>";

/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var report_filter_service_1 = __webpack_require__(929);
	var vehicle_service_1 = __webpack_require__(530);
	var flatpickr_directive_1 = __webpack_require__(82);
	var flatpickr_model_1 = __webpack_require__(83);
	var translate_service_1 = __webpack_require__(70);
	var tripdatareport_service_1 = __webpack_require__(930);
	var tripdatareport_model_1 = __webpack_require__(931);
	var instance_service_1 = __webpack_require__(500);
	var company_service_1 = __webpack_require__(501);
	var sharedvehiclegroup_service_1 = __webpack_require__(510);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var organization_service_1 = __webpack_require__(614);
	var tripcomment_service_1 = __webpack_require__(932);
	var moment = __webpack_require__(84);
	var TripDataReportComponent = (function () {
	    function TripDataReportComponent(tripdatareportservice, translate, authService, organizationService, instanceService, companyService, reportFilterService, vehicleService, sharedVehicleGroupService, router, tripCommentService) {
	        this.tripdatareportservice = tripdatareportservice;
	        this.translate = translate;
	        this.authService = authService;
	        this.organizationService = organizationService;
	        this.instanceService = instanceService;
	        this.companyService = companyService;
	        this.reportFilterService = reportFilterService;
	        this.vehicleService = vehicleService;
	        this.sharedVehicleGroupService = sharedVehicleGroupService;
	        this.router = router;
	        this.tripCommentService = tripCommentService;
	        this.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
	        this.isInit = true;
	        this.isExport = false;
	        this.roleLevel = config_1.RoleLevel;
	    }
	    TripDataReportComponent.prototype.ngOnInit = function () {
	        this.reportName = "TripData_Report";
	        this.itemPerPageList = config_1.WeGoConfig.GRID_PAGGING;
	        this.ResetPaging();
	        this.DataListModel = new config_1.DataListModel();
	        this.module = this.translate.instant("LblTripDetailReport");
	        this.model = new tripdatareport_model_1.TripDataReportModel();
	        // this.model.startDateTime = moment().add(-2, 'M').format('DD-MM-YYYY HH:mm');
	        // this.model.endDateTime = moment().format('DD-MM-YYYY HH:mm');
	        this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigTo.defaultDate = "23:59";
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.InitReportFilter();
	    };
	    TripDataReportComponent.prototype.SetDefaultFlatPickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = true;
	        flatPickrConfig.time_24hr = true;
	        flatPickrConfig.dateFormat = this.dateFormat;
	        flatPickrConfig.minuteIncrement = 1;
	        return flatPickrConfig;
	    };
	    TripDataReportComponent.prototype.OnFromDateChange = function (value) {
	        if (value) {
	            var format = "DD-MM-YYYY HH:mm";
	            var newDate = moment(value, format).toDate();
	            var endDate = moment(this.model.endDateTime, format).toDate();
	            if (endDate < newDate) {
	                var endDateVal = moment(value, format).add("H", 1);
	                this.flatPickrConfigToDate.ChangeValue(endDateVal.format("DD-MM-YYYY HH:mm"));
	            }
	            this.flatPickrConfigToDate.SetOption("minDate", newDate);
	        }
	    };
	    TripDataReportComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.itemsPerPage = event;
	        this.FilterList();
	    };
	    TripDataReportComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.FilterList();
	    };
	    TripDataReportComponent.prototype.FilterList = function () {
	        var start = this.DataListModel.itemsPerPage * (this.DataListModel.currentPage - 1);
	        var end = start + this.DataListModel.itemsPerPage;
	        this.listOfFilterRecord = this.tripDatalList.slice(start, end);
	    };
	    TripDataReportComponent.prototype.ResetPaging = function () {
	        this.tripDatalList = [];
	        this.listOfFilterRecord = [];
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.itemsPerPage = 10;
	    };
	    TripDataReportComponent.prototype.OnSearchTrips = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.tripdatareportservice.GetTripData(this.model).subscribe(function (res) {
	            if (!res.data) {
	                _this.errorModel = res.error;
	                _this.isLoading = false;
	                _this.isExport = false;
	            }
	            else {
	                _this.errorModel = null;
	                _this.tripDatalList = res.data;
	                _this.DataListModel.totalItems = res.data.length;
	                _this.DataListModel.infoMessage = res.error;
	                _this.FilterList();
	                _this.isExport = true;
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    TripDataReportComponent.prototype.InitReportFilter = function () {
	        this.GetAllInstanceList();
	    };
	    TripDataReportComponent.prototype.GetAllInstanceList = function () {
	        var _this = this;
	        this.instanceService.GetDropdownInstanceList(this.reportName).subscribe(function (res) {
	            _this.instanceList = res.data;
	            if (_this.instanceList && _this.instanceList.length > 0) {
	                if (!_this.model.instanceHashId && _this.instanceList.length == 1) {
	                    _this.model.instanceHashId = _this.instanceList[0].keyHash;
	                }
	                _this.onInstanceChange();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    TripDataReportComponent.prototype.GetAllCompanyList = function () {
	        var _this = this;
	        this.companyService
	            .GetDropdownCompanyList(this.reportName, this.model.instanceHashId)
	            .subscribe(function (res) {
	            _this.companyList = res.data;
	            if (_this.companyList && _this.companyList.length > 0) {
	                // if (!this.model.companyHashId && this.companyList.length == 1) {
	                //   this.model.companyHashId = this.companyList[0].keyHash;
	                // }
	                _this.OnCompanyChange();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    TripDataReportComponent.prototype.GetCompanyByInstance = function (instanceHashId) {
	        var _this = this;
	        this.isLoading = true;
	        this.companyService.GetCompanybyInstance(instanceHashId).subscribe(function (res) {
	            _this.companyList = res.data;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    TripDataReportComponent.prototype.GetAllSVGList = function () {
	        var _this = this;
	        //this.reportFilterService.GetSharedVehicleGroupList(null, companyHashId, null, instanceHashId)
	        this.sharedVehicleGroupService
	            .GetDropdownSVGList(this.reportName, this.model.companyHashId, this.model.instanceHashId)
	            .subscribe(function (res) {
	            _this.sharedVehicleGroupList = res.data;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    TripDataReportComponent.prototype.GetVehicleBySVG = function () {
	        var _this = this;
	        // instanceHashId: string, companyHashId: string, sVGHashId: string
	        //let company = sVGHashId != "" ? "" : companyHashId;
	        //this.vehicleService.GetVehicleList(null, company, sVGHashId, instanceHashId)
	        this.vehicleService
	            .GetDropdownVehicleList(this.reportName, this.model.instanceHashId, this.model.companyHashId, this.model.sharedVehicleGroupHashId)
	            .subscribe(function (res) {
	            _this.vehicleList = res.data;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    TripDataReportComponent.prototype.GetGroupDriverList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.sharedVehicleGroupService
	            .GetDropdownDriverList(this.model.sharedVehicleGroupHashId, this.model.organizationHashId, this.model.instanceHashId, this.model.companyHashId, null)
	            .subscribe(function (res) {
	            _this.driverList = res.data;
	            if (res.data == undefined ||
	                res.data == null ||
	                res.data.length == 0) {
	                _this.model.driverHashId = "";
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    TripDataReportComponent.prototype.GetVehicleForGroup = function () {
	        var _this = this;
	        this.isLoading = true;
	        //this.sharedVehicleGroupService.GetSVGVehicleList(this.model.sharedVehicleGroupHashId)
	        this.vehicleService
	            .GetDropdownVehicleList(this.reportName, this.model.instanceHashId, this.model.companyHashId, this.model.sharedVehicleGroupHashId)
	            .subscribe(function (res) {
	            _this.vehicleList = res.data;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    TripDataReportComponent.prototype.onInstanceChange = function () {
	        this.isExport = false;
	        this.companyList = null;
	        this.sharedVehicleGroupList = null;
	        this.organizationList = null;
	        this.vehicleList = null;
	        this.driverList = null;
	        this.model.companyHashId = "";
	        this.model.sharedVehicleGroupHashId = "";
	        this.model.driverHashId = "";
	        this.model.vehicleHashId = "";
	        if (this.model.instanceHashId) {
	            //this.GetCompanyByInstance(this.model.instanceHashId);
	            this.GetAllCompanyList();
	            this.model.companyHashId = "";
	        }
	        else {
	            this.companyList = [];
	            this.sharedVehicleGroupList = [];
	            this.vehicleList = [];
	            this.organizationList = [];
	            this.model.companyHashId = "";
	            this.model.sharedVehicleGroupHashId = "";
	            this.model.vehicleHashId = "";
	            this.model.organizationHashId = "";
	        }
	    };
	    TripDataReportComponent.prototype.OnCompanyChange = function () {
	        this.ResetPaging();
	        //this.GetAllSVGList(this.model.companyHashId, this.model.instanceHashId);
	        this.GetAllSVGList();
	        this.model.sharedVehicleGroupHashId = "";
	        this.OnSVGChange();
	    };
	    TripDataReportComponent.prototype.OnSVGChange = function () {
	        this.ResetPaging();
	        //this.GetVehicleBySVG(this.model.instanceHashId, this.model.companyHashId, this.model.sharedVehicleGroupHashId);
	        this.model.organizationHashId = "";
	        this.GetVehicleBySVG();
	        this.GetGroupDriverList();
	        this.model.vehicleHashId = "";
	        this.GetSVGBaseOrganizationDropDown();
	    };
	    TripDataReportComponent.prototype.OnOrganizationChange = function () {
	        this.ResetPaging();
	        this.GetGroupDriverList();
	    };
	    TripDataReportComponent.prototype.GetSVGBaseOrganizationDropDown = function () {
	        var _this = this;
	        // instanceHashId: string, companyMasterHashId: string, sVGHashId: string
	        // let company = sVGHashId != "" ? "" : companyMasterHashId;
	        this.organizationService
	            .GetSVGBaseOrganizationDropDown(this.reportName, this.model.instanceHashId, this.model.companyHashId, this.model.sharedVehicleGroupHashId)
	            .subscribe(function (res) {
	            _this.organizationList = res.data;
	            if (_this.organizationList && _this.organizationList.length > 0) {
	                if (!_this.model.organizationHashId &&
	                    _this.organizationList.length == 1) {
	                    _this.model.organizationHashId = _this.organizationList[0].keyHash;
	                }
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    TripDataReportComponent.prototype.onVehicleChange = function (selectedVehicle) {
	        this.isExport = false;
	        this.model.vehicleHashId = selectedVehicle;
	        this.ResetPaging();
	    };
	    TripDataReportComponent.prototype.onDriverChange = function (selectedDriver) {
	        this.isExport = false;
	        this.model.driverHashId = selectedDriver;
	        this.ResetPaging();
	    };
	    TripDataReportComponent.prototype.OnSearchChange = function () {
	        this.isExport = false;
	        this.ResetPaging();
	    };
	    TripDataReportComponent.prototype.OnFromDateChanged = function () {
	        this.isExport = false;
	        this.ResetPaging();
	    };
	    TripDataReportComponent.prototype.OnToDateChange = function () {
	        this.isExport = false;
	        this.ResetPaging();
	    };
	    TripDataReportComponent.prototype.OnExportPdf = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.tripdatareportservice.ExportTripDataReportPDF(this.model).subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "TripDataReport" + new Date().toISOString() + ".pdf";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    TripDataReportComponent.prototype.OnExportExcel = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.tripdatareportservice.ExportTripDataReportCsv(this.model).subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "TripData" + new Date().toISOString() + ".xlsx";
	                _this.authService.DownloadXlsFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    TripDataReportComponent.prototype.TripComment = function (TripId) {
	        var _this = this;
	        this.tripCommentService.GetTripComment(TripId)
	            .subscribe(function (res) {
	            _this.tripCommentModal.model.tripId = TripId;
	            _this.tripCommentModal.model.tripComment = res.tripComment;
	            _this.tripCommentModal.model.tripCommentBy = res.tripCommentBy;
	            _this.tripCommentModal.model.tripCommentByFullname = res.tripCommentByFullname;
	            _this.tripCommentModal.model.tripCommentOn = res.tripCommentOn;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.tripCommentModal.errorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	        this.tripCommentModal.show();
	    };
	    __decorate([
	        core_1.ViewChild("flatPickrConfigFromDate"), 
	        __metadata('design:type', (typeof (_a = typeof flatpickr_directive_1.FlatPickrDirective !== 'undefined' && flatpickr_directive_1.FlatPickrDirective) === 'function' && _a) || Object)
	    ], TripDataReportComponent.prototype, "flatPickrConfigFromDate", void 0);
	    __decorate([
	        core_1.ViewChild("flatPickrConfigToDate"), 
	        __metadata('design:type', (typeof (_b = typeof flatpickr_directive_1.FlatPickrDirective !== 'undefined' && flatpickr_directive_1.FlatPickrDirective) === 'function' && _b) || Object)
	    ], TripDataReportComponent.prototype, "flatPickrConfigToDate", void 0);
	    __decorate([
	        core_1.ViewChild("tripCommentModal"), 
	        __metadata('design:type', Object)
	    ], TripDataReportComponent.prototype, "tripCommentModal", void 0);
	    TripDataReportComponent = __decorate([
	        core_1.Component({
	            selector: "wego-tripdatareport",
	            template: __webpack_require__(933),
	            providers: [
	                tripdatareport_service_1.TripDataReportService,
	                instance_service_1.InstanceService,
	                company_service_1.CompanyService,
	                sharedvehiclegroup_service_1.SharedVehicleGroupService,
	                organization_service_1.OrganizationService,
	                vehicle_service_1.VehicleService,
	                report_filter_service_1.ReportFilterService,
	                tripcomment_service_1.TripCommentService
	            ],
	            styles: [
	                "\n          .box-body{\n            padding: 0px 10px 10px;\n          }\n          .checkbox-inline{\n            padding-left: 0px !important;\n          }\n          .box-body{\n            padding:10px 10px 10px 10px;\n          }\n          .search\n          {\n            margin-top:5px;\n          }\n          "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_c = typeof tripdatareport_service_1.TripDataReportService !== 'undefined' && tripdatareport_service_1.TripDataReportService) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object, (typeof (_e = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _e) || Object, (typeof (_f = typeof organization_service_1.OrganizationService !== 'undefined' && organization_service_1.OrganizationService) === 'function' && _f) || Object, (typeof (_g = typeof instance_service_1.InstanceService !== 'undefined' && instance_service_1.InstanceService) === 'function' && _g) || Object, (typeof (_h = typeof company_service_1.CompanyService !== 'undefined' && company_service_1.CompanyService) === 'function' && _h) || Object, (typeof (_j = typeof report_filter_service_1.ReportFilterService !== 'undefined' && report_filter_service_1.ReportFilterService) === 'function' && _j) || Object, (typeof (_k = typeof vehicle_service_1.VehicleService !== 'undefined' && vehicle_service_1.VehicleService) === 'function' && _k) || Object, (typeof (_l = typeof sharedvehiclegroup_service_1.SharedVehicleGroupService !== 'undefined' && sharedvehiclegroup_service_1.SharedVehicleGroupService) === 'function' && _l) || Object, (typeof (_m = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _m) || Object, (typeof (_o = typeof tripcomment_service_1.TripCommentService !== 'undefined' && tripcomment_service_1.TripCommentService) === 'function' && _o) || Object])
	    ], TripDataReportComponent);
	    return TripDataReportComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
	}());
	exports.TripDataReportComponent = TripDataReportComponent;


/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var jquery_helper_service_1 = __webpack_require__(67);
	var ReportFilterService = (function () {
	    function ReportFilterService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	        this.JQueryHelper = new jquery_helper_service_1.JQueryHelperService();
	    }
	    ReportFilterService.prototype.GetSharedVehicleGroupList = function (input, companyHashId, vehicleHashId, instanceHashId) {
	        var getSVGUrl = config_1.WeGoConfig.API_GET_SHAREDVEHICLEGROUP_DETAIL;
	        var queryString = this.authService.HandleAPIListInput(input);
	        getSVGUrl = getSVGUrl + "?" + queryString;
	        if (companyHashId) {
	            getSVGUrl = getSVGUrl + "&companyHashId=" + companyHashId;
	        }
	        if (vehicleHashId) {
	            getSVGUrl = getSVGUrl + "&vehicleHashId=" + vehicleHashId;
	        }
	        if (instanceHashId) {
	            getSVGUrl = getSVGUrl + "&instanceHashId=" + instanceHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getSVGUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    ReportFilterService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], ReportFilterService);
	    return ReportFilterService;
	    var _a, _b;
	}());
	exports.ReportFilterService = ReportFilterService;


/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var jquery_helper_service_1 = __webpack_require__(67);
	var TripDataReportService = (function () {
	    function TripDataReportService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	        this.JQueryHelper = new jquery_helper_service_1.JQueryHelperService();
	    }
	    TripDataReportService.prototype.GetTripData = function (input) {
	        var body = input;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_GET_TRIP_DATA_LIST, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    TripDataReportService.prototype.ExportTripDataReportPDF = function (input) {
	        var queryString = "InstanceHashId=" + input.instanceHashId + "&CompanyHashId=" + input.companyHashId + "&SharedVehicleGroupHashId=" + input.sharedVehicleGroupHashId + "&DriverHashId=" + input.driverHashId + "&VehicleHashId=" + input.vehicleHashId +
	            "&StartDateTime=" + input.startDateTime + "&EndDateTime=" + input.endDateTime + "&isDriverSearch=" + input.isDriverSearch + "&OrganizationHashId=" + input.organizationHashId;
	        var getTripDataUrl = config_1.WeGoConfig.API_EXPORT_TRIP_DATA_REPORT_PDF + "?" + queryString;
	        var headers = this.authService.GetHeader('application/pdf');
	        var options = new http_1.RequestOptions({ headers: headers, responseType: http_1.ResponseContentType.Blob });
	        return this.http.get(getTripDataUrl, options);
	    };
	    TripDataReportService.prototype.ExportTripDataReportCsv = function (input) {
	        var queryString = "InstanceHashId=" + input.instanceHashId + "&CompanyHashId=" + input.companyHashId + "&SharedVehicleGroupHashId=" + input.sharedVehicleGroupHashId + "&DriverHashId=" + input.driverHashId + "&VehicleHashId=" + input.vehicleHashId +
	            "&StartDateTime=" + input.startDateTime + "&EndDateTime=" + input.endDateTime + "&isDriverSearch=" + input.isDriverSearch + "&OrganizationHashId=" + input.organizationHashId;
	        var getTripDataUrl = config_1.WeGoConfig.API_EXPORT_TRIP_DATA_REPORT_CSV + "?" + queryString;
	        var headers = this.authService.GetHeader('text/csv');
	        var options = new http_1.RequestOptions({ headers: headers, responseType: http_1.ResponseContentType.Blob });
	        return this.http.get(getTripDataUrl, options);
	    };
	    TripDataReportService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], TripDataReportService);
	    return TripDataReportService;
	    var _a, _b;
	}());
	exports.TripDataReportService = TripDataReportService;


/***/ },
/* 931 */
/***/ function(module, exports) {

	"use strict";
	var TripDataReportModel = (function () {
	    function TripDataReportModel() {
	        this.instanceHashId = '';
	        this.companyHashId = '';
	        this.sharedVehicleGroupHashId = '';
	        this.driverHashId = '';
	        this.organizationHashId = '';
	        this.vehicleHashId = '';
	        this.isDriverSearch = true;
	    }
	    return TripDataReportModel;
	}());
	exports.TripDataReportModel = TripDataReportModel;


/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var Observable_1 = __webpack_require__(5);
	var config_1 = __webpack_require__(60);
	var jquery_helper_service_1 = __webpack_require__(67);
	var TripCommentService = (function () {
	    function TripCommentService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	        this.JQueryHelper = new jquery_helper_service_1.JQueryHelperService();
	    }
	    TripCommentService.prototype.AddTripComment = function (formData) {
	        var _this = this;
	        return Observable_1.Observable.create(function (observer) {
	            var url = config_1.WeGoConfig.API_SET_TRIP_COMMENT;
	            var xhr = new XMLHttpRequest();
	            var header = _this.authService.GetHeaderForFile();
	            xhr.onreadystatechange = function () {
	                if (xhr.readyState === 4) {
	                    if (xhr.status === 200) {
	                        observer.next(JSON.parse(xhr.response));
	                        observer.complete();
	                    }
	                    else {
	                        observer.error(xhr.status);
	                    }
	                }
	            };
	            xhr.open("POST", url, true);
	            for (var i = 0; i < header.length; i++) {
	                xhr.setRequestHeader(header[i]["name"], header[i]["value"]);
	            }
	            xhr.send(formData);
	        });
	    };
	    TripCommentService.prototype.GetTripComment = function (tripId) {
	        if (tripId != "") {
	            var getGetTripCommentUrl = config_1.WeGoConfig.API_GET_TRIP_COMMENT + "?tripId=" + tripId;
	            var headers = this.authService.GetHeader();
	            var options = new http_1.RequestOptions({ headers: headers });
	            return this.http
	                .get(getGetTripCommentUrl, options)
	                .map(this.authService.HandleAPIResponse)
	                .catch(this.authService.HandleAPIError);
	        }
	    };
	    TripCommentService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], TripCommentService);
	    return TripCommentService;
	    var _a, _b;
	}());
	exports.TripCommentService = TripCommentService;


/***/ },
/* 933 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ 'LblTripDataReport' | translate }}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li class=\"active\">{{ 'LblTripDataReport' | translate }}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <div class=\"box box-default\">\r\n          <div class=\"box-body\" style=\"display: block;\">\r\n            <!--Filter-->\r\n            <div class=\"row\">\r\n              <div class=\"col-md-12\">\r\n                <div class=\"form-group col-md-4\">\r\n                  <label>{{ 'LblSearch' | translate }}</label>\r\n                  <div class=\"clearfix\"></div>\r\n                  <label class=\"radio-inline\">\r\n                    <input type=\"radio\" [(ngModel)]=\"model.isDriverSearch\" name=\"isDriverSearch\" (change)=\"OnSearchChange()\" [value]=\"true\">{{ 'LblByDriver' | translate}}</label>\r\n                  <label class=\"radio-inline\">\r\n                    <input type=\"radio\" [(ngModel)]=\"model.isDriverSearch\" name=\"isDriverSearch\" (change)=\"OnSearchChange()\" [value]=\"false\">{{ 'LblByVehicle' | translate}}</label>\r\n                </div>\r\n                <div class=\"clearfix\"> </div>\r\n                <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Instance\" class=\"form-group col-md-3\">\r\n                  <label>\r\n                    <span class=\"text text-danger\">*</span> {{ 'LblInstance' | translate }}\r\n                  </label>\r\n\r\n                  <select [(ngModel)]=\"model.instanceHashId\" name=\"instance\" class=\"form-control\" (change)=\"onInstanceChange()\">\r\n                    <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblInstance' | translate }}</option>\r\n                    <option *ngFor=\"let inst of instanceList\" [attr.value]='inst.keyHash'>{{inst.value}}</option>\r\n                  </select>\r\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'instanceHashId' }}</span>\r\n                </div>\r\n                <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Company\" class=\"form-group col-md-3\">\r\n                  <label>{{ 'LblCompany' | translate }}\r\n                  </label>\r\n                  <select [(ngModel)]=\"model.companyHashId\" name=\"company\" class=\"form-control\" (change)=\"OnCompanyChange()\">\r\n                    <option value=\"\">{{ 'LblAll' | translate }} {{ 'LblCompany' | translate }}</option>\r\n                    <option *ngFor=\"let comp of companyList\" [attr.value]='comp.keyHash'>{{comp.value}}</option>\r\n                  </select>\r\n                </div>\r\n                <div class=\"form-group col-md-3\" *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.SVG\">\r\n                  <label>\r\n                    {{ 'LblSharedVehicleGroup' | translate }}\r\n                  </label>\r\n                  <select [(ngModel)]=\"model.sharedVehicleGroupHashId\" name=\"sharedvehiclegroup\" class=\"form-control\" (change)=\"OnSVGChange()\">\r\n                    <option value=\"\">{{ 'LblAll' | translate }} {{ 'LblSharedVehicleGroup' | translate }}</option>\r\n                    <option *ngFor=\"let svg of sharedVehicleGroupList\" [attr.value]='svg.keyHash'>{{svg.value}}</option>\r\n                  </select>\r\n                </div>\r\n                <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Organization\" class=\"form-group col-md-3\">\r\n                  <label> {{'LblOrganization' | translate }} </label>\r\n                  <select [(ngModel)]=\"model.organizationHashId\" class=\"form-control\" name=\"organizationHashId\" (change)=\"OnOrganizationChange()\">\r\n                    <option value=''>{{ 'LblAll' | translate }} {{ 'LblOrganization' | translate }} </option>\r\n                    <option *ngFor=\"let item of organizationList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\r\n                  </select>\r\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'organizationHashId' }}</span>\r\n                </div>\r\n\r\n                <div class=\"clearfix\"></div>\r\n                <div *ngIf=\"model.isDriverSearch\" class=\"form-group col-md-3\">\r\n                  <label>\r\n                    {{ 'LblDriver' | translate }}\r\n                  </label>\r\n                  <select [(ngModel)]=\"model.driverHashId\" name=\"driver\" class=\"form-control\" (change)=\"onDriverChange($event.target.value)\">\r\n                    <option value=\"\">{{ 'LblAll' | translate }} {{ 'LblDriver' | translate }}</option>\r\n                    <option *ngFor=\"let driver of driverList\" [attr.value]='driver.keyHash'>{{driver.value}}</option>\r\n                  </select>\r\n                </div>\r\n                <div *ngIf=\"!model.isDriverSearch\" class=\"form-group col-md-3\">\r\n                  <label>\r\n                    {{ 'LblVehicle' | translate }}\r\n                  </label>\r\n                  <select [(ngModel)]=\"model.vehicleHashId\" name=\"driver\" class=\"form-control\" (change)=\"onVehicleChange($event.target.value)\">\r\n                    <option value=\"\">{{ 'LblAll' | translate }} {{ 'LblVehicle' | translate }}</option>\r\n                    <option *ngFor=\"let vehicle of vehicleList\" [attr.value]='vehicle.keyHash'>{{vehicle.value}}</option>\r\n                  </select>\r\n                </div>\r\n                <div class=\"form-group col-md-3\">\r\n                  <label>\r\n                    <span class=\"text text-danger\">*</span>{{ 'LblFrom' | translate }}</label>\r\n                  <div class=\"clearfix\"></div>\r\n                  <div class=\"input-group\">\r\n                    <span class=\"input-group-addon\">\r\n                      <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n                    </span>\r\n                    <input #flatPickrConfigFromDate=\"wego-flatpickr\" flatpickr readonly [Config]=\"flatPickrConfigFrom\" [(ngModel)]=\"model.startDateTime\"\r\n                      name=\"startDateTime\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblFrom' | translate}}\" (change)=\"OnFromDateChanged()\">\r\n                  </div>\r\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'StartDateTime' }}</span>\r\n                </div>\r\n                <div class=\"form-group col-md-3\">\r\n                  <label>\r\n                    <span class=\"text text-danger\">*</span>{{ 'LblTo' | translate }}</label>\r\n                  <div class=\"clearfix \"></div>\r\n                  <div class=\"input-group\">\r\n                    <span class=\"input-group-addon\">\r\n                      <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n                    </span>\r\n                    <input #flatPickrConfigToDate=\"wego-flatpickr\" flatpickr readonly [Config]=\"flatPickrConfigTo\" [(ngModel)]=\"model.endDateTime\"\r\n                      name=\"endDateTime\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblTo' | translate }}\" (change)=\"OnToDateChange()\">\r\n                  </div>\r\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'EndDateTime' }}</span>\r\n                </div>\r\n                <div class=\"form-group col-md-3\">\r\n                  <div class=\"input-group\">\r\n                    <label>&nbsp;</label>\r\n                    <div class=\"clearfix\"></div>\r\n                    <button class=\"btn btn-default\" (click)=\"OnSearchTrips($event)\">\r\n                      <i class=\"fa fa-search\" aria-hidden=\"true\"></i>\r\n                    </button>&nbsp;\r\n                    <button *ngIf=\"isExport && (listOfFilterRecord && listOfFilterRecord.length > 0)\" class=\"btn btn-default\" (click)=\"OnExportPdf($event)\">\r\n                      <i class=\"fa fa-file-pdf-o\" aria-hidden=\"true\"></i>\r\n                    </button>&nbsp;\r\n                    <button *ngIf=\"isExport &&(listOfFilterRecord && listOfFilterRecord.length > 0)\" class=\"btn btn-default\" (click)=\"OnExportExcel($event)\">\r\n                      <i class=\"fa fa-file-excel-o\" aria-hidden=\"true\"></i>\r\n                    </button>\r\n                  </div>\r\n                </div>\r\n\r\n                <!--<div class=\"row\">\r\n                  <div class=\"form-group col-md-3\">\r\n                    <div class=\"input-group\">\r\n                      <label>&nbsp;</label>\r\n                      <div class=\"clearfix\"></div>\r\n                      <button class=\"btn btn-default\" (click)=\"OnSearchTrips($event)\"><i class=\"fa fa-search\" aria-hidden=\"true\"></i></button>&nbsp;\r\n                      <button *ngIf=\"listOfFilterRecord && listOfFilterRecord.length > 0\" class=\"btn btn-default\" type=\"button\" (click)=\"OnExportPdf($event)\" title=\"{{'LblExportReport' | translate}}\">\r\n                        <i class=\"fa fa-file-pdf-o\" aria-hidden=\"true\"></i> </button>\r\n                      <button *ngIf=\"listOfFilterRecord && listOfFilterRecord.length > 0\" class=\"btn btn-default\" (click)=\"OnExportExcel($event)\" title=\"{{'LblExportReport' | translate}}\">\r\n                          <i class=\"fa fa-file-excel-o\" aria-hidden=\"true\"></i></button>\r\n                    </div>\r\n                  </div>\r\n                </div>-->\r\n              </div>\r\n            </div>\r\n\r\n            <!--Trip detail table-->\r\n            <!--No record found-->\r\n            <div class=\"row\">\r\n              <div class=\"col-sm-12 text-danger text-center\">\r\n                <div *ngIf=\"DataListModel.totalItems == 0\">\r\n                  {{ DataListModel.infoMessage }}\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!--Trip detail table-->\r\n            <div class=\"row\" *ngIf=\"listOfFilterRecord && listOfFilterRecord.length > 0\">\r\n              <fieldset class=\"col-md-12\">\r\n                <legend class=\"legendStyle\">\r\n                  <div class=\"form-inline\" style=\"padding-bottom: 5px;\">\r\n                    <div class=\"form-group\">\r\n                      {{ 'LblTripDataReport' | translate }}\r\n                    </div>\r\n                    <div class=\"form-group pull-right\">\r\n                      <select class=\"form-control\" title='Items Per Page' [(ngModel)]=\"DataListModel.itemsPerPage\" name=\"itemPerPage\" (change)=\"OnPagingChange($event.target.value)\">\r\n                        <option *ngFor=\"let item of itemPerPageList\" [attr.value]='item.value'>{{ item }}</option>\r\n                      </select>\r\n                    </div>\r\n                  </div>\r\n                </legend>\r\n                <div class=\"clearfix\"></div>\r\n                <div class=\"row\">\r\n                  <div class=\"col-sm-12\">\r\n                    <div class=\"table table-responsive mar_bot_ziro\">\r\n                      <table class=\"table table-bordered mar_bot_ziro\">\r\n                        <thead>\r\n                          <tr>\r\n                            <th>{{ 'LblStartDateTime' | translate }}\r\n                            </th>\r\n                            <th> {{ 'LblEndDateTime' | translate }}\r\n                            </th>\r\n                            <th> {{ 'LblFromOdometer' | translate }}\r\n                            </th>\r\n                            <th>{{ 'LblToOdometer' | translate }}\r\n                            </th>\r\n                            <th>{{ 'LblDistance' | translate }}\r\n                            </th>\r\n                            <th>{{ 'LblVehicle' | translate }}\r\n                            </th>\r\n                            <th>{{ 'LblDriver' | translate }}\r\n                            </th>\r\n                            <th>{{ 'LblContractTypeGroup' | translate }}\r\n                            </th>\r\n                            <th>{{ 'LblSharedVehicleGroup' | translate }}\r\n                            </th>\r\n                            <th>{{ 'LblCompany' | translate }}\r\n                            </th>\r\n                            <th>{{ 'LblOrganization' | translate }}\r\n                            </th>                                                    \r\n                          </tr>\r\n                        </thead>\r\n                        <tbody>\r\n                          <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                            <tr *ngFor=\"let trip of listOfFilterRecord\">\r\n                              <td>{{ trip.startDateTime }}</td>\r\n                              <td>{{ trip.endDateTime }}</td>\r\n                              <td>{{ trip.fromOdometerFormated}}</td>\r\n                              <td>{{ trip.toOdometerFormated}}</td>\r\n                              <td>{{ trip.distanceFormated}}</td>\r\n                              <td>{{ trip.licenseTag }}</td>\r\n                              <td>{{ trip.driverName }}</td>\r\n                              <td>{{ trip.contractTypeGroup }}</td>\r\n                              <td>{{ trip.groupName }}</td>\r\n                              <td>{{ trip.companyName }}</td>\r\n                              <td>{{ trip.organizationName }}</td>\r\n                              <td class=\"text-center\">\r\n                                <div *ngIf=\"trip.tripComment == ''\">\r\n                                  <a class=\"cursor-pointer mar_left_5 mar_right_5\" (click)=\"TripComment(trip.tripId)\" title=\"{{ 'LblAddTripComment' | translate }}\">\r\n                                    <i class=\"fa fa-edit fa-md text-primary\"></i>\r\n                                  </a>\r\n                                </div>\r\n                                <div *ngIf=\"trip.tripComment != ''\">\r\n                                  <a class=\"cursor-pointer mar_left_5 mar_right_5\" (click)=\"TripComment(trip.tripId)\" title=\"{{ 'LblShowTripComment' | translate }}\">\r\n                                    <i class=\"fa fa-search fa-md text-primary\"></i>\r\n                                  </a>\r\n                                </div>\r\n                              </td>                              \r\n                            </tr>\r\n                            <wego-tripcomment-popup #tripCommentModal (onCommentConfirm)=\"onCommentConfirm($event)\"></wego-tripcomment-popup>\r\n                          </template>\r\n                          <tr *ngIf=\"DataListModel.totalItems == 0\">\r\n                            <td class=\"text-center text-danger\" colspan=\"6\">\r\n                              {{ DataListModel.infoMessage }}\r\n                            </td>\r\n                          </tr>\r\n                        </tbody>\r\n                      </table>\r\n                      <div *ngIf=\"DataListModel.totalItems > 0\" class=\"col-sm-12\">\r\n                        <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                          [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\"\r\n                          firstText=\"&laquo;\" lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n                      </div>\r\n                    </div>\r\n                    <div class=\"clearfix\"></div>\r\n                  </div>\r\n                </div>\r\n              </fieldset>\r\n            </div>\r\n            <!--end-->\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n  <wego-lodder [isLoading]=\"isLoading\"></wego-lodder>";

/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var google_address_autocomplete_1 = __webpack_require__(825);
	var config_1 = __webpack_require__(60);
	var auth_service_1 = __webpack_require__(58);
	var translate_service_1 = __webpack_require__(70);
	var core_1 = __webpack_require__(3);
	var organization_model_1 = __webpack_require__(935);
	var organization_service_1 = __webpack_require__(614);
	var person_service_1 = __webpack_require__(771);
	var instance_service_1 = __webpack_require__(500);
	var router_1 = __webpack_require__(26);
	var config_2 = __webpack_require__(60);
	var common_1 = __webpack_require__(22);
	var company_service_1 = __webpack_require__(501);
	var flatpickr_directive_1 = __webpack_require__(82);
	var flatpickr_model_1 = __webpack_require__(83);
	var instance_model_1 = __webpack_require__(513);
	var OrganizationUpdateComponent = (function () {
	    function OrganizationUpdateComponent(organizationService, personService, instanceService, companyService, translate, activeRoute, authService, router, locationService) {
	        this.organizationService = organizationService;
	        this.personService = personService;
	        this.instanceService = instanceService;
	        this.companyService = companyService;
	        this.translate = translate;
	        this.activeRoute = activeRoute;
	        this.authService = authService;
	        this.router = router;
	        this.locationService = locationService;
	        this.totalItems = 0;
	        this.currentPage = 1;
	        this.maxSize = config_2.WeGoConfig.GRID_MAX_PAGE_SIZE;
	        this.itemsPerPage = config_2.WeGoConfig.GRID_MAX_DATA_SIZE;
	        this.gdprSettingsModel = new instance_model_1.GdprSettingsModel();
	        this.dateFormat = config_2.WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
	        this.searchField = "";
	        this.searchTerm = "";
	        this.selectedInstance = "";
	        this.language = 'en';
	        this.roleLevel = config_1.RoleLevel;
	    }
	    OrganizationUpdateComponent.prototype.ngOnInit = function () {
	        this.accessDeniedErrorCode = "412";
	        this.pageName = "Organization";
	        this.module = this.translate.instant('LblOrganization');
	        this.urlDefaultPage = this.authService.GetURL(config_2.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlOrganizationList = this.authService.GetURL(config_2.ApplicationRouteURL.URL_ORGANIZATION_LIST);
	        this.companyList = [];
	        this.isEditMode = false;
	        this.preferredlanguage = [
	            {
	                Key: "English",
	                Value: "en_US"
	            },
	            {
	                Key: "French",
	                Value: "fr_FR"
	            },
	            {
	                Key: "Dutch",
	                Value: "nl_NL"
	            },
	            {
	                Key: "German",
	                Value: "de_DE"
	            },
	            {
	                Key: "Polish",
	                Value: "pl_PL"
	            },
	            {
	                Key: "Spanish",
	                Value: "es_ES"
	            }
	        ];
	        this.dayofWeekList = [
	            {
	                Key: this.translate.instant('LblSelectDayOfWeek'),
	                Value: ''
	            },
	            {
	                Key: this.translate.instant('LblSunday'),
	                Value: '0'
	            },
	            {
	                Key: this.translate.instant('LblMonday'),
	                Value: '1'
	            },
	            {
	                Key: this.translate.instant('LblTuesday'),
	                Value: '2'
	            },
	            {
	                Key: this.translate.instant('LblWednesday'),
	                Value: '3'
	            },
	            {
	                Key: this.translate.instant('LblThursday'),
	                Value: '4'
	            },
	            {
	                Key: this.translate.instant('LblFriday'),
	                Value: '5'
	            },
	            {
	                Key: this.translate.instant('LblSaturday'),
	                Value: '6'
	            }];
	        this.timeIntervalList = [
	            {
	                Key: this.translate.instant('LblSelectInvoiceInterval'),
	                Value: '',
	                Amount: 0
	            },
	            {
	                Key: this.translate.instant('LblWeeklySub'),
	                Value: 'WEEKLY',
	                Amount: 7,
	            },
	            {
	                Key: this.translate.instant('LblMonthlySub'),
	                Value: 'MONTHLY',
	                Amount: 30
	            },
	            {
	                Key: this.translate.instant('LblYearlySub'),
	                Value: 'YEARLY',
	                Amount: 365
	            }
	        ];
	        this.model = new organization_model_1.OrganizationModel();
	        this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
	        this.GetOrganizationDetails();
	    };
	    OrganizationUpdateComponent.prototype.SetDefaultFlatPickrConfig = function (isDateOnly) {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = !isDateOnly ? true : false;
	        flatPickrConfig.time_24hr = true;
	        flatPickrConfig.dateFormat = this.dateFormat;
	        flatPickrConfig.minuteIncrement = 1;
	        flatPickrConfig.maxDate = new Date();
	        return flatPickrConfig;
	    };
	    OrganizationUpdateComponent.prototype.GetOrganizationDetails = function () {
	        var _this = this;
	        this.sub = this.activeRoute
	            .params
	            .subscribe(function (params) {
	            _this.organizationMasterHashId = params['id'] || '';
	            if (_this.organizationMasterHashId != '') {
	                _this.isEditMode = true;
	                _this.organizationService.GetOrganizationByHashId(_this.organizationMasterHashId)
	                    .subscribe(function (res) {
	                    _this.model = res.data;
	                    _this.model.invoiceMomentDayOfWeek = res.data.invoiceMomentDayOfWeek;
	                    _this.language = res.data.instanceLanguage;
	                    if (_this.model.displayorganizationGeoLocationAddress) {
	                        _this.markerInfo = {
	                            draggable: false,
	                            lat: _this.model.organizationGeoLocationLatitude,
	                            lng: _this.model.organizationGeoLocationLongitude,
	                            label: _this.model.displayorganizationGeoLocationAddress,
	                            isOpen: true
	                        };
	                    }
	                    _this.onChangeSelectedField(_this.model.companyMasterHashId);
	                    _this.GetGDPRSettings();
	                }, function (error) {
	                    _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	                });
	            }
	            else {
	                _this.model.preferredlanguage =
	                    _this.preferredlanguage.length > 0
	                        ? _this.preferredlanguage[0].Value
	                        : "";
	                _this.GetInstanceDropDownList(config_2.PermissionType.INSERT);
	            }
	        });
	        this.breadCrumbTitle = this.isEditMode ? this.translate.instant('LblEditPage', [this.module]) : this.translate.instant('LblAddPage', [this.module]);
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	    };
	    OrganizationUpdateComponent.prototype.onSubmit = function (forms) {
	        console.log(this.model);
	        this.AddOrganization();
	    };
	    OrganizationUpdateComponent.prototype.AddOrganization = function () {
	        var _this = this;
	        this.organizationService.AddOrganization(this.model)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupTitle = _this.translate.instant('LblSuccess');
	                _this.popupMsg = _this.isEditMode ? _this.translate.instant('LblRecordUpdatedSuccess', [_this.module]) : _this.translate.instant('LblRecordAddedSuccess', [_this.module]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    OrganizationUpdateComponent.prototype.GetInstanceDropDownList = function (permissionType) {
	        var _this = this;
	        this.instanceService.GetInstanceListDropdownForAddUpdatePage(this.pageName, permissionType)
	            .subscribe(function (res) {
	            _this.apiResponse = res;
	            _this.instanceList = res.data;
	            _this.model.companyMasterHashId = '';
	            if (_this.instanceList && _this.instanceList.length > 0) {
	                if (!_this.model.instanceHashId && _this.instanceList.length == 1) {
	                    _this.model.instanceHashId = _this.instanceList[0].keyHash;
	                }
	                _this.InstanceUpdate();
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    OrganizationUpdateComponent.prototype.GetGDPRSettings = function () {
	        var _this = this;
	        this.organizationService.GetOrganizationGDPRSettings(this.organizationMasterHashId)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.gdprSettingsModel = res.data;
	            }
	            else {
	                _this.errorMessage = res.error;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    OrganizationUpdateComponent.prototype.GetCompanyDropDownList = function (permissionType) {
	        var _this = this;
	        this.companyService.GetCompanyListDropdownForAddUpdatePage(this.pageName, permissionType, this.model.instanceHashId)
	            .subscribe(function (res) {
	            _this.companyList = res.data;
	            _this.model.companyMasterHashId = _this.model.companyMasterHashId || _this.companyList.length > 0 ? '' : '';
	            if (_this.companyList && _this.companyList.length > 0) {
	                if (!_this.model.companyMasterHashId && _this.companyList.length == 1) {
	                    _this.model.companyMasterHashId = _this.companyList[0].keyHash;
	                }
	            }
	        }, function (error) {
	            _this.errorMessage = error;
	        });
	    };
	    OrganizationUpdateComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    OrganizationUpdateComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    OrganizationUpdateComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    OrganizationUpdateComponent.prototype.GetGeoLocation = function (event) {
	        if (this.model) {
	            var locationData = event.GeoLocationData;
	            this.model.orgnizationGeoLocationAddress = locationData.label;
	            this.model.organizationGeoLocationLatitude = locationData.lat;
	            this.model.organizationGeoLocationLongitude = locationData.lng;
	        }
	    };
	    OrganizationUpdateComponent.prototype.InstanceUpdate = function () {
	        var _this = this;
	        if (this.model.instanceHashId) {
	            this.GetCompanyDropDownList(config_2.PermissionType.INSERT);
	            this.instanceService
	                .GetInstanceLanguage(this.model.instanceHashId)
	                .subscribe(function (res) {
	                _this.language = res.data;
	            }, function (error) {
	                _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            });
	            this.instanceService
	                .IsDirectDebitEnabled(this.model.instanceHashId)
	                .subscribe(function (res) {
	                _this.apiResponse = res;
	                var directDebitEnabled = res.data;
	                if (directDebitEnabled) {
	                    _this.model.directDebitBillingInfoModel.directDebitFileEnabledOnInstance = true;
	                    _this.model.directDebitBillingInfoModel.subjectToDirectDebit = true;
	                }
	                else {
	                    _this.model.directDebitBillingInfoModel.directDebitFileEnabledOnInstance = false;
	                    _this.model.directDebitBillingInfoModel.subjectToDirectDebit = false;
	                }
	            }, function (error) {
	                _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            });
	        }
	        else {
	            this.companyList = [];
	            this.model.companyMasterHashId = "";
	        }
	    };
	    OrganizationUpdateComponent.prototype.OnBackClick = function () {
	        this.locationService.back();
	    };
	    OrganizationUpdateComponent.prototype.GetAddress = function (place) {
	        this.model.displayorganizationGeoLocationAddress = place['address'];
	        this.model.organizationGeoLocationLatitude = place['lat'];
	        this.model.organizationGeoLocationLongitude = place['log'];
	        this.model.orgnizationGeoLocationAddress = place['useraddressInput'];
	    };
	    OrganizationUpdateComponent.prototype.SearchHomeAddress = function () {
	        this.geoLocationModal.show(this.model.displayorganizationGeoLocationAddress, this.model.organizationGeoLocationLatitude, this.model.organizationGeoLocationLongitude);
	    };
	    OrganizationUpdateComponent.prototype.ResetLocationField = function (locationModelField) {
	        this.model.displayorganizationGeoLocationAddress = '';
	        this.model.organizationGeoLocationLatitude = 0;
	        this.model.organizationGeoLocationLongitude = 0;
	    };
	    OrganizationUpdateComponent.prototype.onConfirm = function ($event) {
	        this.model.displayorganizationGeoLocationAddress = $event.address;
	        this.model.organizationGeoLocationLatitude = $event.lat;
	        this.model.organizationGeoLocationLongitude = $event.long;
	    };
	    OrganizationUpdateComponent.prototype.ResetCookies = function () {
	        var _this = this;
	        this.organizationService.ResetTwoFaCookies(this.organizationMasterHashId)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupTitle = _this.translate.instant('LblSuccess');
	                _this.popupMsg = _this.translate.instant('LblCookieResetSuccess', [_this.module]);
	                _this.ShowTwoFaPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblCookieResetFailed');
	                _this.popupTitle = _this.translate.instant('LblError');
	                _this.ShowTwoFaPopup();
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    OrganizationUpdateComponent.prototype.ResetTwoFA = function () {
	        var _this = this;
	        this.organizationService.ResetTwoFaKeys(this.organizationMasterHashId)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupTitle = _this.translate.instant('LblSuccess');
	                _this.popupMsg = _this.translate.instant('LblKeyResetSuccess', [_this.module]);
	                _this.ShowTwoFaPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblKeyResetFailed');
	                _this.popupTitle = _this.translate.instant('LblError');
	                _this.ShowTwoFaPopup();
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    OrganizationUpdateComponent.prototype.ShowTwoFaPopup = function () {
	        this.TwoFasuccessPopup.show();
	    };
	    OrganizationUpdateComponent.prototype.ConfirmTwoFaPopup = function () {
	        this.TwoFasuccessPopup.hide();
	    };
	    OrganizationUpdateComponent.prototype.onChangeSelectedField = function (selectedCompany) {
	        var _this = this;
	        if (selectedCompany) {
	            this.companyService
	                .IsTwoFaEnabled(selectedCompany)
	                .subscribe(function (res) {
	                _this.TwoFaEnabled = res.data;
	            }, function (error) {
	                _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            });
	        }
	        else {
	            this.TwoFaEnabled = false;
	        }
	    };
	    OrganizationUpdateComponent.prototype.ngOnDestroy = function () {
	        if (this.sub) {
	            this.sub.unsubscribe();
	        }
	    };
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], OrganizationUpdateComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild('TwoFasuccessPopup'), 
	        __metadata('design:type', Object)
	    ], OrganizationUpdateComponent.prototype, "TwoFasuccessPopup", void 0);
	    __decorate([
	        core_1.ViewChild('googleMapComp'), 
	        __metadata('design:type', Object)
	    ], OrganizationUpdateComponent.prototype, "googleMapComp", void 0);
	    __decorate([
	        core_1.ViewChild('geoLocationModal'), 
	        __metadata('design:type', Object)
	    ], OrganizationUpdateComponent.prototype, "geoLocationModal", void 0);
	    __decorate([
	        core_1.ViewChild("flatPickrConfigFromDate"), 
	        __metadata('design:type', (typeof (_a = typeof flatpickr_directive_1.FlatPickrDirective !== 'undefined' && flatpickr_directive_1.FlatPickrDirective) === 'function' && _a) || Object)
	    ], OrganizationUpdateComponent.prototype, "flatPickrConfigFromDate", void 0);
	    OrganizationUpdateComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-organization',
	            template: __webpack_require__(936),
	            providers: [organization_service_1.OrganizationService, person_service_1.PersonService, instance_service_1.InstanceService, company_service_1.CompanyService, google_address_autocomplete_1.GoogleplaceDirective],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof organization_service_1.OrganizationService !== 'undefined' && organization_service_1.OrganizationService) === 'function' && _b) || Object, (typeof (_c = typeof person_service_1.PersonService !== 'undefined' && person_service_1.PersonService) === 'function' && _c) || Object, (typeof (_d = typeof instance_service_1.InstanceService !== 'undefined' && instance_service_1.InstanceService) === 'function' && _d) || Object, (typeof (_e = typeof company_service_1.CompanyService !== 'undefined' && company_service_1.CompanyService) === 'function' && _e) || Object, (typeof (_f = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _f) || Object, (typeof (_g = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _g) || Object, (typeof (_h = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _h) || Object, (typeof (_j = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _j) || Object, (typeof (_k = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _k) || Object])
	    ], OrganizationUpdateComponent);
	    return OrganizationUpdateComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
	}());
	exports.OrganizationUpdateComponent = OrganizationUpdateComponent;


/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var instance_model_1 = __webpack_require__(513);
	var OrganizationModel = (function () {
	    function OrganizationModel() {
	        this.companyName = "";
	        this.instanceName = "";
	        this.invoiceInterval = 'YEARLY';
	        this.sendInvoiceToDriver = "INHERIT";
	        this.sendInvoiceToOrganization = "INHERIT";
	        this.userBlockMessage = '';
	        this.organizationAddressModel = new OrganizationAddressModel();
	        this.directDebitBillingInfoModel = new DirectDebitBillingInfoModel();
	        this.twoFAConfig = new instance_model_1.TwoFAConfigModel();
	    }
	    return OrganizationModel;
	}());
	exports.OrganizationModel = OrganizationModel;
	var DirectDebitBillingInfoModel = (function () {
	    function DirectDebitBillingInfoModel() {
	        this.directDebitFileEnabledOnInstance = false;
	        this.subjectToDirectDebit = false;
	        this.isAmendment = false;
	    }
	    return DirectDebitBillingInfoModel;
	}());
	exports.DirectDebitBillingInfoModel = DirectDebitBillingInfoModel;
	var OrganizationAddressModel = (function () {
	    function OrganizationAddressModel() {
	    }
	    return OrganizationAddressModel;
	}());
	exports.OrganizationAddressModel = OrganizationAddressModel;
	var OrganizationDropDownModel = (function () {
	    function OrganizationDropDownModel() {
	    }
	    return OrganizationDropDownModel;
	}());
	exports.OrganizationDropDownModel = OrganizationDropDownModel;
	var OrganizationBlockModel = (function () {
	    function OrganizationBlockModel() {
	    }
	    return OrganizationBlockModel;
	}());
	exports.OrganizationBlockModel = OrganizationBlockModel;


/***/ },
/* 936 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{breadCrumbTitle}}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"urlOrganizationList\">\r\n            <i class=\"fa fa-sitemap\"></i>{{breadCrumbList}}</a>\r\n        </li>\r\n        <li class=\"active\">{{breadCrumbTitle}}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"nopad\">\r\n      <form (ngSubmit)=\"onSubmit(AddOrganizationForm.value)\" #AddOrganizationForm=\"ngForm\">\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span> {{ 'LblOrganizationName' | translate }}</label>\r\n          <input [disabled]=\"authService.IsOrganizationAdmin()\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblOrganizationName' | translate }}\"\r\n            [(ngModel)]=\"model.organizationName\" name=\"OrganizationName\" maxlength=\"100\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'organizationName' }}</span>\r\n        </div>\r\n        <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Instance\" class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblInstance' | translate }}\r\n          </label>\r\n          <select *ngIf=\"!isEditMode\" [(ngModel)]=\"model.instanceHashId\" (ngModelChange)=\"InstanceUpdate()\" name=\"instance\"\r\n            class=\"form-control\">\r\n            <option value=\"\" [selected]=\"selected\">{{ 'LblSelect' | translate }} {{ 'LblInstance' | translate }}</option>\r\n            <option *ngFor=\"let inst of instanceList\" [attr.value]='inst.keyHash'>{{inst.value}}</option>\r\n          </select>\r\n          <input *ngIf=\"isEditMode\" type=\"text\" class=\"form-control\" [(ngModel)]=\"model.instanceName\" name=\"instanceName\"\r\n            readonly=\"readonly\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'InstanceHashId' }}</span>\r\n        </div>\r\n        <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Company\" class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblCompany' | translate }}\r\n          </label>\r\n          <select *ngIf=\"!isEditMode\" [(ngModel)]=\"model.companyMasterHashId\" name=\"company\" class=\"form-control\"\r\n            (change)=\"onChangeSelectedField($event.target.value)\">\r\n            <!-- <template [ngIf]=\"isEditMode\">\r\n            <option value=\"\" >{{ 'LblSelect' | translate }} {{ 'LblCompany' | translate }}</option> \r\n          </template> -->\r\n            <!-- <template > -->\r\n            <option value=\"\" [selected]=\"selected\">{{ 'LblSelect' | translate }} {{ 'LblCompany' | translate }}</option>\r\n            <!-- </template> -->\r\n            <option *ngFor=\"let comp of companyList\" [attr.value]='comp.keyHash'>{{comp.value}}</option>\r\n          </select>\r\n          <input *ngIf=\"isEditMode\" type=\"text\" class=\"form-control\" [(ngModel)]=\"model.companyName\" name=\"companyName\"\r\n            readonly=\"readonly\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'CompanyMasterHashId' }}</span>\r\n        </div>\r\n\r\n        <div class=\"clearfix\"></div>\r\n        <input type=\"hidden\" class=\"form-control\" [(ngModel)]=\"model.instanceId\" name=\"instance\">\r\n        <template [ngIf]=\"model.contactPersonName != null\">\r\n          <div class=\"form-group col-md-4\">\r\n            <label>\r\n              {{ 'LblContactPerson' | translate }}\r\n            </label>\r\n            <input type=\"text\" class=\"form-control\" placeholder=\"Contact Person\" [(ngModel)]=\"model.contactPersonName\"\r\n              name=\"ContactPerson\" readonly=\"readonly\">\r\n          </div>\r\n        </template>\r\n        <div class=\"row col-md-12\">\r\n          <fieldset class=\"col-md-12\">\r\n            <legend class=\"legendStyle\">\r\n              <span class=\"text text-danger\">*</span>{{ 'LblOrganizationAddress' | translate }}\r\n            </legend>\r\n            <div class=\"clearfix\"></div>\r\n\r\n            <div class=\"form-group col-md-4\">\r\n              <label>{{ 'LblHouseNo' | translate }}</label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblHouseNo' | translate }}\" [(ngModel)]=\"model.organizationAddressModel.houseNo\"\r\n                name=\"organizationAddressModel.houseNo\" maxlength=\"15\">\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'OrganizationAddressModel.HouseNo' }}</span>\r\n            </div>\r\n\r\n            <div class=\"form-group col-md-4\">\r\n              <label>{{ 'LblHouseExtention' | translate }}</label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblHouseExtention' | translate }}\" [(ngModel)]=\"model.organizationAddressModel.houseExtention\"\r\n                name=\"organizationAddressModel.houseExtention\" maxlength=\"25\">\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage :\r\n                'OrganizationAddressModel.houseExtention' }}</span>\r\n            </div>\r\n            <div class=\"form-group col-md-4\">\r\n              <label> {{ 'LblStreetName' | translate }} </label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblStreetName' | translate }}\" [(ngModel)]=\"model.organizationAddressModel.street\"\r\n                name=\"organizationAddressModel.street\" maxlength=\"100\">\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'OrganizationAddressModel.Street' }}</span>\r\n            </div>\r\n            <div class=\"clearfix\"></div>\r\n            <div class=\"form-group col-md-4\">\r\n              <label>{{ 'LblCity' | translate }}</label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblCity' | translate }}\" [(ngModel)]=\"model.organizationAddressModel.city\"\r\n                name=\"organizationAddressModel.city\" maxlength=\"50\">\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'OrganizationAddressModel.City' }}</span>\r\n            </div>\r\n            <div class=\"form-group col-md-4\">\r\n              <label> {{ 'LblZipCode' | translate }}</label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblZipCode' | translate }}\" [(ngModel)]=\"model.organizationAddressModel.zipCode\"\r\n                name=\"organizationAddressModel.zipCode\" maxlength=\"10\">\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'OrganizationAddressModel.ZipCode' }}</span>\r\n            </div>\r\n            <div class=\"clearfix\"></div>\r\n            <div class=\"form-group col-md-6\">\r\n              <label> {{ 'LblGeoLocation' | translate }}</label>\r\n              <div class=\"input-group\">\r\n                <input readonly class=\"form-control\" type=\"text\" name=\"displayorganizationGeoLocationAddress\"\r\n                  [(ngModel)]=\"model.displayorganizationGeoLocationAddress\" />\r\n                <div class=\"input-group-btn\">\r\n                  <button class=\"btn btn-default icon-map-marker\" type=\"button\" (click)=\"SearchHomeAddress()\">\r\n                    <i class=\"fa fa-map-marker\" aria-hidden=\"true\"></i>\r\n                  </button>\r\n                  <button class=\"btn btn-default\" type=\"button\" (click)=\"ResetLocationField('home')\">\r\n                    <i class=\"fa fa-eraser\" aria-hidden=\"true\"></i>\r\n                  </button>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n        <div class=\"row col-md-12\" *ngIf=\"TwoFaEnabled\">\r\n          <div class=\"clearfix\"></div>\r\n          <fieldset class=\"col-md-6\">\r\n            <legend class=\"legendStyle\">\r\n              <span class=\"text text-danger\">*</span> {{ 'LblTwoFaConfig' | translate }}\r\n            </legend>\r\n            <div class=\"form-group col-md-12\">\r\n              <label>\r\n                <span class=\"text text-danger\">*</span> {{ 'LblEnableTwoFa' | translate }}</label>\r\n              <div>\r\n                <label class=\"radio-inline\">\r\n                  <input type=\"radio\" [(ngModel)]=\"model.twoFAConfig.enabled\" name=\"EnableTwoFa\" value=\"YES\">\r\n                  {{ 'LblYes' | translate }}</label>\r\n                <label class=\"radio-inline\">\r\n                  <input type=\"radio\" [(ngModel)]=\"model.twoFAConfig.enabled\" name=\"EnableTwoFa\" value=\"NO\">\r\n                  {{ 'LblNo' | translate }}</label>\r\n                <label class=\"radio-inline\">\r\n                  <input type=\"radio\" [(ngModel)]=\"model.twoFAConfig.enabled\" name=\"EnableTwoFa\" value=\"INHERIT\">\r\n                  {{ 'LblInherit' | translate }}</label>\r\n              </div>\r\n            </div>\r\n            <div *ngIf=\"model.twoFAConfig.enabled=='YES'\" class=\"form-group col-md-6\">\r\n              <label>{{ 'LblExpirationDays' | translate }}</label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblExpirationDays' | translate }}\" [(ngModel)]=\"model.twoFAConfig.expirationDays\"\r\n                name=\"ExpirationDays\" maxlength=\"3\">\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'TwoFAConfig.ExpirationDays' }}</span>\r\n            </div>\r\n            <div *ngIf=\"model.twoFAConfig.enabled!='NO'\" class=\"form-group col-md-12\">\r\n              <a *ngIf=\"model.twoFAConfig.enableResetCookie\" class=\"btn btn-highlight navbar-left\" (click)=\"ResetCookies()\">{{\r\n                'LblResetCookiesForAllAdmin' | translate }}</a>\r\n              <div class=\"clearfix\"></div>\r\n              <a *ngIf=\"model.twoFAConfig.enableResetKey\" class=\"btn btn-highlight navbar-left mar_t_5\" (click)=\"ResetTwoFA()\">{{\r\n                'LblReset2FaForAllAdmin' | translate }}</a>\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n        <div class=\"row col-md-12\">\r\n          <fieldset class=\"col-md-6\" *ngIf=\"gdprSettingsModel\">\r\n            <legend class=\"legendStyle\">\r\n              <span class=\"text text-danger\">*</span> {{ 'LblGdprSettings' | translate }}\r\n            </legend>\r\n            <div class=\"form-group col-md-6\">\r\n              <label>{{ 'LblInactiveAfterDays' | translate }}</label>\r\n              <input readonly type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblInactiveAfterDays' | translate }}\"\r\n                [(ngModel)]=\"gdprSettingsModel.inactiveAfterDays\" name=\"InactiveAfterDays\" maxlength=\"3\">\r\n            </div>\r\n            <div class=\"form-group col-md-6\">\r\n              <label>{{ 'LblMarkDeleteAfterDays' | translate }}</label>\r\n              <input readonly type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblMarkDeleteAfterDays' | translate }}\"\r\n                [(ngModel)]=\"gdprSettingsModel.markDeleteAfterDays\" name=\"MarkDeleteAfterDays\" maxlength=\"3\">\r\n            </div>\r\n            <div class=\"clearfix\"></div>\r\n            <div class=\"form-group col-md-6\">\r\n              <label>{{ 'LblNotifyAdminBeforeDays' | translate }}</label>\r\n              <input readonly type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblNotifyAdminBeforeDays' | translate }}\"\r\n                [(ngModel)]=\"gdprSettingsModel.notifyAdminBeforeDays\" name=\"NotifyAdminBeforeDays\" maxlength=\"2\">\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n        <div class=\"row col-md-12\">\r\n\r\n          <fieldset class=\"col-md-6\">\r\n            <legend class=\"legendStyle\">\r\n              {{ 'LblDropoffMessage' | translate }}\r\n            </legend>\r\n            <div class=\"clearfix\"></div>\r\n            <div class=\"form-group col-md-6\">\r\n              <label>{{ 'LblPreferredlanguage' | translate }}</label>\r\n              <select [(ngModel)]=\"model.preferredlanguage\" class=\"form-control\" name=\"preferredlanguage\">\r\n                <option *ngFor=\"let item of preferredlanguage\" [ngValue]=\"item.Value\">{{ item.Key }}</option>\r\n              </select>\r\n            </div>\r\n            <div class=\"form-group col-md-6\">\r\n              <label>{{ 'LblDebtornr' | translate }}</label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblDebtornr' | translate }}\" [(ngModel)]=\"model.debtornr\"\r\n                name=\"debtornr\" maxlength=\"64\">\r\n            </div>\r\n            <div class=\"form-group col-md-6\">\r\n              <label>{{ 'LblVatNumber' | translate }}</label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblVatNumber' | translate }}\" [(ngModel)]=\"model.vatnr\"\r\n                name=\"vatnr\" maxlength=\"64\">\r\n            </div>\r\n  \r\n          </fieldset>\r\n\r\n\r\n        </div>\r\n        <div class=\"row col-md-12\">\r\n          <fieldset class=\"col-md-6\">\r\n            <legend class=\"legendStyle\">\r\n              {{ 'LblUserBlockMessage' | translate }}\r\n            </legend>\r\n            <div class=\"form-group col-md-12\">\r\n              <label>{{ 'LblUserBlockMessage' | translate }}</label>\r\n              <div>\r\n                <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblUserBlockMessage' | translate }}\"\r\n                  [(ngModel)]=\"model.userBlockMessage\" name=\"userBlockMessage\" maxlength=\"500\">\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'userBlockMessage' }}</span>\r\n              </div>\r\n            </div>\r\n          </fieldset>\r\n        </div>\r\n        <div class=\"row no-margin\">\r\n          <div class=\"col-sm-12\">\r\n            <hr>\r\n            <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnBackClick()\">{{ 'LblCancel' | translate }}</a>\r\n            &nbsp;&nbsp;\r\n            <button class=\"btn btn-green\" type=\"submit\">{{ 'LblSave' | translate }}</button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n<wego-geo-location-map #geoLocationModal (onConfirm)=\"onConfirm($event)\" [Language]=\"language\"></wego-geo-location-map>\r\n<wego-success-popup #TwoFasuccessPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmTwoFaPopup()\"></wego-success-popup>\r\n<!--<wego-geolocation-popup #geoLocationModal [markerInfo]=\"markerInfo\" (onConfirm)=\"GetGeoLocation($event)\"></wego-geolocation-popup>-->";

/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var config_1 = __webpack_require__(60);
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var organization_model_1 = __webpack_require__(935);
	var organization_service_1 = __webpack_require__(614);
	var router_1 = __webpack_require__(26);
	var config_2 = __webpack_require__(60);
	// export declare class test {
	//   constructor(private authService: AuthService){}
	//   public IsAuthorizeLink(permissionName: string, permissionType: string) {
	//     return this.authService.IsAuthorizeURL(permissionName, permissionType).map((res: any) => {
	//       console.log(res);
	//       return res.data;
	//     });
	//   }
	// }
	var OrganizationListComponent = (function () {
	    function OrganizationListComponent(organizationService, authService, router, translate) {
	        this.organizationService = organizationService;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.roleLevel = config_1.RoleLevel;
	    }
	    Object.defineProperty(OrganizationListComponent.prototype, "isAnyChecked", {
	        get: function () {
	            if (this.organizationList) {
	                var isCheck = this.organizationList.some(function (x) { return x.isChecked == true; });
	                if (isCheck) {
	                    if (this.organizationList.every(function (x) { return x.isChecked == true; }))
	                        this.isParentCheck = true;
	                    else
	                        this.isParentCheck = false;
	                }
	                else {
	                    this.isParentCheck = false;
	                }
	                return isCheck;
	            }
	            else {
	                this.isParentCheck = false;
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(OrganizationListComponent.prototype, "isDeleteAccess", {
	        get: function () {
	            if (this.organizationList) {
	                return this.organizationList.some(function (x) { return x.isDeletable; });
	            }
	            else {
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    OrganizationListComponent.prototype.ngOnInit = function () {
	        this.module = this.translate.instant('LblOrganization');
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.model = new organization_model_1.OrganizationBlockModel();
	        if (this.authService.GetHighestRoleLevel() <= this.roleLevel.Instance) {
	            this.DataListModel.searchField = ["organizationName", "contactPersonName", "instanceName"];
	        }
	        else {
	            this.DataListModel.searchField = ["organizationName", "contactPersonName"];
	        }
	        this.urlDefaultPage = this.authService.GetURL(config_2.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlOrganizationAdd = this.authService.GetURL(config_2.ApplicationRouteURL.URL_ORGANIZATION_ADD);
	        this.urlOrganizationUpdate = this.authService.GetURL(config_2.ApplicationRouteURL.URL_ORGANIZATION_UPDATE);
	        this.urlOrganizationAdmin = this.authService.GetURL(config_2.ApplicationRouteURL.URL_ORGANIZATION_ADMIN_LIST);
	        this.urlOrganizationDrivers = this.authService.GetURL(config_2.ApplicationRouteURL.URL_ORGANIZATION_DRIVER_LIST);
	        this.urlAdminOfOrganizationList = this.authService.GetURL(config_2.ApplicationRouteURL.URL_ADMIN_OF_ORGANIZATION_LIST);
	        this.urlOrganizationSubscription = this.authService.GetURL(config_2.ApplicationRouteURL.URL_ORGANIZATION_TO_SUBSCRIPTION_LIST);
	        this.urlOrganizationDriverList = this.authService.GetURL(config_2.ApplicationRouteURL.URL_ORGANIZATION_TO_DRIVER_LIST);
	        this.GetOrganizationList();
	        // this.IsAddOrganizationEnabled();
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	        this.addOrganizationLink = new config_1.WeGoAuthorizedLink(this.urlOrganizationAdd, config_1.Permission.PR_ORGANIZATION_OVERVIEW, config_1.PermissionType.INSERT, 'btn btn-highlight navbar-right', 'LblAddNew');
	    };
	    OrganizationListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetOrganizationList();
	    };
	    OrganizationListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetOrganizationList();
	    };
	    OrganizationListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetOrganizationList();
	    };
	    ;
	    OrganizationListComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetOrganizationList();
	    };
	    OrganizationListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.organizationService.ExportOrganizationList(this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "Organization" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    OrganizationListComponent.prototype.GetOrganizationList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.organizationService.GetOrganizationList(this.DataListModel)
	            .subscribe(function (res) {
	            _this.organizationList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    OrganizationListComponent.prototype.ShowContactPersonModal = function (organizationMasterHashId) {
	        this.organizationContactPersonModal.organizationMasterHashId = organizationMasterHashId;
	        this.organizationContactPersonModal.show();
	    };
	    OrganizationListComponent.prototype.SuccessContactPersonModal = function ($event) {
	        this.GetOrganizationList();
	        this.popupMsg = this.translate.instant('LblContactPersonAddedSuccess'); //$event.SuccessMessage;
	        this.ShowSuccessPopup();
	    };
	    OrganizationListComponent.prototype.DeleteOrganization = function (deleteOrganizationList) {
	        var _this = this;
	        this.isLoading = true;
	        this.organizationService.DeleteOrganization(deleteOrganizationList)
	            .subscribe(function (res) {
	            _this.DataListModel.currentPage = 1;
	            _this.GetOrganizationList();
	            _this.popupMsg = _this.translate.instant('LblRecordRemovedSuccess', [_this.module]);
	            _this.ShowSuccessPopup();
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    OrganizationListComponent.prototype.OnParentCheck = function (isChecked) {
	        this.organizationList.filter(function (x) { return x.isDeletable; }).forEach(function (x) { return x.isChecked = isChecked; });
	    };
	    OrganizationListComponent.prototype.ShowChildModal = function (organizationMasterHashId) {
	        this.deleteorganizationHashId = organizationMasterHashId;
	        if (organizationMasterHashId) {
	            this.popupMsg = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
	            this.isMultipleDelete = false;
	            this.deleteorganizationHashId = organizationMasterHashId;
	        }
	        else {
	            this.popupMsg = this.translate.instant('LblRecordMultiplDeleteConfirmation', [this.module]);
	            this.isMultipleDelete = true;
	        }
	        this.childModal.show();
	    };
	    OrganizationListComponent.prototype.HideChildModal = function () {
	        this.deleteorganizationHashId = "";
	        this.childModal.hide();
	    };
	    OrganizationListComponent.prototype.SuccessModalClick = function () {
	        var deleteOrganizationList;
	        if (this.isMultipleDelete)
	            deleteOrganizationList = this.organizationList.filter(function (x) { return x.isChecked; }).map(function (x) { return x.organizationMasterHashId; });
	        else
	            deleteOrganizationList.push(this.deleteorganizationHashId);
	        this.DeleteOrganization(deleteOrganizationList);
	        this.childModal.hide();
	    };
	    OrganizationListComponent.prototype.ShowRemoveContactPersonModal = function (organizationMasterHashId) {
	        this.removeContactPersonorganizationHashId = organizationMasterHashId;
	        this.popupMsg = this.translate.instant('LblRemoveContactPersonConfirm');
	        this.removeContactPersonModal.show();
	    };
	    OrganizationListComponent.prototype.HideRemoveContactPersonModal = function () {
	        this.removeContactPersonorganizationHashId = "";
	        this.removeContactPersonModal.hide();
	    };
	    OrganizationListComponent.prototype.SuccessModalRemoveContactPersonClick = function () {
	        this.RemoveOrganizationContactPerson();
	        this.removeContactPersonModal.hide();
	    };
	    OrganizationListComponent.prototype.RemoveOrganizationContactPerson = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.organizationService.RemocveOrganizationContactPerson(this.removeContactPersonorganizationHashId)
	            .subscribe(function (res) {
	            _this.popupMsg = _this.translate.instant('LblContactPersonRemoveSuccess');
	            _this.GetOrganizationList();
	            _this.isLoading = false;
	            _this.ShowSuccessPopup();
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        }, function () {
	            _this.removeContactPersonModal.hide();
	            _this.isLoading = false;
	        });
	    };
	    // public IsAddOrganizationEnabled() {
	    //   this.organizationService.IsAddOrganizationEnabled()
	    //     .subscribe(
	    //     res => {
	    //       if (res.data) {
	    //         this.AddOrganizationEnabled = res.data;
	    //       }
	    //       else {
	    //         this.AddOrganizationEnabled = false;
	    //       }
	    //     },
	    //     error => {
	    //       this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
	    //     });
	    // }
	    OrganizationListComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    OrganizationListComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    OrganizationListComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    OrganizationListComponent.prototype.onSubmit = function (forms) {
	        this.model.activeFlag = this.activeFlag;
	        this.model.organizationMasterHashId = this.isBlockedOrganizationHashId;
	        this.BlockUnblockOrganization(JSON.stringify(this.model));
	    };
	    OrganizationListComponent.prototype.BlockUnblockOrganization = function (formData) {
	        var _this = this;
	        this.isLoading = true;
	        this.organizationService.BlockUnblockOrganization(formData)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.isBlockModal.hide();
	                _this.DataListModel.currentPage = 1;
	                _this.GetOrganizationList();
	                _this.popupMsg = _this.translate.instant('LblRecordBlokUnBlockSuccess', [_this.module, _this.inActiveMessage]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.isLoading = false;
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    OrganizationListComponent.prototype.ShowInActiveModal = function (organizationMasterHashId, isActive) {
	        this.isBlockedOrganizationHashId = organizationMasterHashId;
	        this.activeFlag = !isActive;
	        this.inActiveMessage = !isActive ? this.translate.instant('LblBlock') : this.translate.instant('LblUnblock');
	        this.model.reason = null;
	        this.errorModel = null;
	        this.popupMsg = this.translate.instant('LblBlockUnblockConfirm', [this.inActiveMessage, this.module]);
	        this.isBlockModal.show(this.message);
	    };
	    OrganizationListComponent.prototype.HideInActiveModal = function () {
	        this.isBlockedOrganizationHashId = "";
	        this.isBlockModal.hide();
	    };
	    OrganizationListComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    __decorate([
	        core_1.ViewChild('organizationContactPersonModal'), 
	        __metadata('design:type', Object)
	    ], OrganizationListComponent.prototype, "organizationContactPersonModal", void 0);
	    __decorate([
	        core_1.ViewChild('childModal'), 
	        __metadata('design:type', Object)
	    ], OrganizationListComponent.prototype, "childModal", void 0);
	    __decorate([
	        core_1.ViewChild('removeContactPersonModal'), 
	        __metadata('design:type', Object)
	    ], OrganizationListComponent.prototype, "removeContactPersonModal", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], OrganizationListComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild('isBlockModal'), 
	        __metadata('design:type', Object)
	    ], OrganizationListComponent.prototype, "isBlockModal", void 0);
	    OrganizationListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-organization',
	            template: __webpack_require__(938),
	            providers: [organization_service_1.OrganizationService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof organization_service_1.OrganizationService !== 'undefined' && organization_service_1.OrganizationService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object])
	    ], OrganizationListComponent);
	    return OrganizationListComponent;
	    var _a, _b, _c, _d;
	}());
	exports.OrganizationListComponent = OrganizationListComponent;


/***/ },
/* 938 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ breadCrumbList}} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li class=\"active\"> {{ breadCrumbList}} </li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25\">\r\n      <wego-authorized-link [LinkModel]=\"addOrganizationLink\"></wego-authorized-link>\r\n      <!-- <a class=\"btn btn-highlight navbar-right\" [routerLink]=\"[urlOrganizationUpdate]\" routerLinkActive=\"active\">{{ 'LblAddNew' | translate }}</a> -->\r\n    </div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <p class=\"text-success\">{{ message }}</p>\r\n        <wego-search-list [IsDeleted]=\"isDeleteAccess\" [IsDeleteEnabled]=\"isAnyChecked && isDeleteAccess\" (OnDeleteAll)=\"ShowChildModal()\"\r\n          (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\"\r\n          [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center parent-checkbox\">\r\n                  <input [disabled]=\"!isDeleteAccess\" type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\">\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('organizationName')\">\r\n                  {{ 'LblOrganizationName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'organizationName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Instance\" class=\"cursor-pointer\" (click)=\"OnSort('instanceName')\">\r\n                  {{ 'LblInstance' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'instanceName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('contactPersonName')\">\r\n                  {{ 'LblContactPerson' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'contactPersonName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"text-center\">{{ 'LblAdmin' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblDrivers' | translate }}</th>\r\n                <!-- <th class=\"text-center\">{{ 'LblOrganizationAdmin' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblDrivers' | translate }}</th> -->\r\n                <th class=\"text-center\">{{ 'LblSubscription' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblEdit' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblBlockUnBlock' | translate }}</th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let organization of organizationList\">\r\n                  <td class=\"text-center\">\r\n                    <!-- [disabled]=\"!(organization.isDeletable)\" -->\r\n                    <input *ngIf=\"!organization.isDeletable\" disabled type=\"checkbox\" name=\"isActive\">\r\n                    <input *ngIf=\"organization.isDeletable\" type=\"checkbox\" name=\"isActive\" [(ngModel)]=\"organization.isChecked\">\r\n                  </td>\r\n                  <td>{{ organization.organizationName }}</td>\r\n                  <td *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Instance\">{{organization.instanceName}}</td>\r\n                  <td>\r\n                    <span *ngIf=\"(organization.isContactPersonAdd && !organization.contactPersonHashID) || (organization.isContactPersonEdit && organization.contactPersonHashID)\"\r\n                      title=\"{{'LblAddContactPerson' | translate}}\">\r\n                      <a class=\"cursor-pointer\" (click)=\"ShowContactPersonModal(organization.organizationMasterHashId)\">\r\n                        <i class=\"fa fa-phone-square fa-fw\"></i>\r\n                      </a>\r\n                    </span>\r\n                    <span *ngIf=\"organization.isContactPersonView\">{{ organization.contactPersonName }}</span>\r\n                    <span class=\"pull-right\" *ngIf=\"organization.isContactPersonDelete && organization.contactPersonHashID\" title=\"{{'LblRemoveContactPerson' | translate}}\">\r\n                      <a class=\"cursor-pointer\" (click)=\"ShowRemoveContactPersonModal(organization.organizationMasterHashId)\">\r\n                        <i class=\"fa fa-times fa-fw text-danger\"></i>\r\n                      </a>\r\n                    </span>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"!organization.isAdminCount\" class=\"btn btn-primary link-style\" disabled>\r\n                      <span class=\"badge link-text\">{{ organization.adminCount }}</span>\r\n                    </a>\r\n                    <a *ngIf=\"organization.isAdminCount\" class=\"btn btn-primary cursor-pointer link-style\" [routerLink]=\"urlAdminOfOrganizationList + '/' + organization.organizationMasterHashId\">\r\n                      <span class=\"badge link-text\">{{ organization.adminCount }}</span>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"!organization.isDriverCount\" class=\"btn btn-primary link-style\" disabled>\r\n                      <span class=\"badge link-text\">{{ organization.driverCount }}</span>\r\n                    </a>\r\n                    <a *ngIf=\"organization.isDriverCount\" class=\"btn btn-primary cursor-pointer link-style\" [routerLink]=\"urlOrganizationDriverList+ '/' + organization.organizationMasterHashId\">\r\n                      <span class=\"badge link-text\">{{ organization.driverCount }}</span>\r\n                    </a>\r\n                  </td>\r\n                  <!-- <td class=\"text-center\">\r\n                    <a class=\"btn btn-primary cursor-pointer link-style\" [routerLink]=\"[urlOrganizationAdmin, { organizationHashId : organization.organizationMasterHashId }]\">\r\n                      <span class=\"badge link-text\">{{ organization.totalOrganizationAdmins }}</span>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a class=\"btn btn-primary cursor-pointer link-style\" [routerLink]=\"[urlOrganizationDrivers, { organizationHashId : organization.organizationMasterHashId }]\">\r\n                      <span class=\"badge link-text\">{{ organization.totalDrivers }}</span>\r\n                    </a>\r\n                  </td> -->\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"!organization.isSubscriptionCount\" class=\"btn btn-primary link-style\" disabled>\r\n                      <span class=\"badge link-text\">{{ organization.subscriptionCount }}</span>\r\n                    </a>\r\n                    <!-- [routerLink]=\"[urlOrganizationSubscription, { organizationHashId : organization.organizationMasterHashId }]\" -->\r\n                    <a *ngIf=\"organization.isSubscriptionCount\" class=\"btn btn-primary cursor-pointer link-style\" [routerLink]=\"urlOrganizationSubscription + '/' + organization.organizationMasterHashId\">\r\n                      <span class=\"badge link-text\">{{ organization.subscriptionCount }}</span>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"organization.isEditable\" [routerLink]=\"urlOrganizationUpdate + '/' + organization.organizationMasterHashId\">\r\n                      <i class=\"fa fa-pencil-square-o fa-fw\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf= \"organization.isBlockUnBlockOrganization\"  class=\"cursor-pointer btn btn-xs btn-active-inactive\" [ngClass]=\"{'btn-active': organization.isBlocked, 'btn-inactive': !organization.isBlocked}\"\r\n                       (click)=\"ShowInActiveModal(organization.organizationMasterHashId, organization.isBlocked)\" >\r\n                      <template [ngIf]=\"organization.isBlocked\"> {{ 'LblUnblock' | translate}} </template>\r\n                      <template [ngIf]=\"!organization.isBlocked\"> {{ 'LblBlock' | translate}} </template>\r\n                    </a>\r\n                  </td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"8\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n<div bsModal #isBlockModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-sm\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"HideInActiveModal()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblConfirm' | translate }}</h4>\r\n      </div>\r\n\r\n      <form (ngSubmit)=\"onSubmit(ActiveOrganizationForm.value)\" #ActiveOrganizationForm=\"ngForm\">\r\n        <div class=\"modal-body\">\r\n          <div class=\"row\">\r\n            <div class=\"col-xs-12 form-group\">\r\n              {{ popupMsg }}\r\n            </div>\r\n            <div class=\"col-xs-12 form-group\" *ngIf=\"activeFlag\">\r\n\r\n              <textarea class=\"form-control\" rows=\"2\" id=\"comment\" [(ngModel)]=\"model.reason\" name=\"reason\" placeholder=\"{{ 'LblReasonOrganization' | translate }}\"></textarea>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'reason' }}</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n\r\n        <div class=\"modal-footer\">\r\n          <button type=\"submit\" class=\"btn btn-green\">{{ 'LblYes' | translate }}</button>\r\n          <button type=\"button\" class=\"btn btn-gray cursor-pointer\" (click)=\"HideInActiveModal()\">{{ 'LblNo' | translate }}</button>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<wego-organization-contact-person #organizationContactPersonModal (OnSuccessSelect)=\"SuccessContactPersonModal($event)\"></wego-organization-contact-person>\r\n\r\n<wego-confirm-popup #childModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessModalClick()\" (onReject)=\"HideChildModal()\"></wego-confirm-popup>\r\n\r\n<wego-confirm-popup #removeContactPersonModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessModalRemoveContactPersonClick()\"\r\n  (onReject)=\"HideRemoveContactPersonModal()\"></wego-confirm-popup>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>";

/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var organizationAdmin_service_1 = __webpack_require__(940);
	var person_service_1 = __webpack_require__(771);
	var organization_service_1 = __webpack_require__(614);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var OrganizationAdminListComponent = (function () {
	    function OrganizationAdminListComponent(organizationAdminService, personService, organizationService, activeRoute, authService, router, translate) {
	        this.organizationAdminService = organizationAdminService;
	        this.personService = personService;
	        this.organizationService = organizationService;
	        this.activeRoute = activeRoute;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	    }
	    Object.defineProperty(OrganizationAdminListComponent.prototype, "isAnyChecked", {
	        get: function () {
	            if (this.organizationAdminList) {
	                var isCheck = this.organizationAdminList.filter(function (x) { return x.isUserOrganizationAdmin == false; }).some(function (x) { return x.isChecked == true; });
	                if (isCheck) {
	                    if (this.organizationAdminList.filter(function (x) { return x.isUserOrganizationAdmin == false; }).every(function (x) { return x.isChecked == true; }))
	                        this.isParentCheck = true;
	                    else
	                        this.isParentCheck = false;
	                }
	                else {
	                    this.isParentCheck = false;
	                }
	                return isCheck;
	            }
	            else {
	                this.isParentCheck = false;
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    OrganizationAdminListComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.module = this.translate.instant('LblOrganizationAdmin');
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	        this.organizationList = this.translate.instant('LblListPage', [this.translate.instant('LblOrganization')]);
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = ["userName", "firstName", "lastName"];
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlOrganizationList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_ORGANIZATION_LIST);
	        this.sub = this.activeRoute
	            .params
	            .subscribe(function (params) {
	            _this.organizationMasterHashId = params['organizationHashId'] || '';
	            if (_this.organizationMasterHashId != '') {
	                _this.GetOrganizationAdminList();
	                _this.GetOrganizationDetailsByCompanyId(_this.organizationMasterHashId);
	            }
	        });
	    };
	    OrganizationAdminListComponent.prototype.GetOrganizationDetailsByCompanyId = function (organizationMasterHashId) {
	        var _this = this;
	        this.organizationService.GetOrganizationBasicDetail(organizationMasterHashId)
	            .subscribe(function (res) {
	            _this.organizationName = res.data.entityName;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    OrganizationAdminListComponent.prototype.GetOrganizationAdminList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.organizationAdminService.GetOrganizationAdminList(this.organizationMasterHashId, this.DataListModel)
	            .subscribe(function (res) {
	            _this.organizationAdminList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    OrganizationAdminListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetOrganizationAdminList();
	    };
	    OrganizationAdminListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetOrganizationAdminList();
	    };
	    OrganizationAdminListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetOrganizationAdminList();
	    };
	    ;
	    OrganizationAdminListComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetOrganizationAdminList();
	    };
	    OrganizationAdminListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.organizationAdminService.ExportOrganizationAdminList(this.organizationMasterHashId, this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "OrganizationAdmin" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	        ;
	    };
	    OrganizationAdminListComponent.prototype.DeleteCompanyAdmin = function (deleteOrganizationAdminList) {
	        var _this = this;
	        this.isLoading = true;
	        this.organizationAdminService.DeleteOrganizationAdmin(deleteOrganizationAdminList)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.DataListModel.currentPage = 1;
	                _this.GetOrganizationAdminList();
	                _this.popupMsg = _this.translate.instant('LblRecordRemovedSuccess', [_this.module]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupMsg = res.error;
	                _this.ShowAlertPopup();
	                _this.isLoading = false;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    OrganizationAdminListComponent.prototype.OnParentCheck = function (isChecked) {
	        this.organizationAdminList.filter(function (x) { return x.isUserOrganizationAdmin == false && x.canRemove; }).forEach(function (x) { return x.isChecked = isChecked; });
	    };
	    OrganizationAdminListComponent.prototype.ShowAlertModal = function (deleteOrganizationAdminMasterHashId) {
	        if (deleteOrganizationAdminMasterHashId) {
	            this.deleteMessage = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
	            this.isMultipleDelete = false;
	            this.deleteOrganizationAdminMasterHashId = deleteOrganizationAdminMasterHashId;
	        }
	        else {
	            this.deleteMessage = this.translate.instant('LblRecordMultiplDeleteConfirmation', [this.module]);
	            this.isMultipleDelete = true;
	        }
	        this.alertModal.show();
	    };
	    OrganizationAdminListComponent.prototype.HideAlertModal = function () {
	        this.deleteOrganizationAdminMasterHashId = "";
	        this.alertModal.hide();
	    };
	    OrganizationAdminListComponent.prototype.SuccessAlertModalClick = function () {
	        var deleteOrganizationAdminList;
	        if (this.isMultipleDelete)
	            deleteOrganizationAdminList = this.organizationAdminList.filter(function (x) { return x.isChecked; }).map(function (x) { return x.organizationAdminHashId; });
	        else
	            deleteOrganizationAdminList.push(this.deleteOrganizationAdminMasterHashId);
	        this.DeleteCompanyAdmin(deleteOrganizationAdminList);
	        this.alertModal.hide();
	    };
	    OrganizationAdminListComponent.prototype.ShowAddOrganizationAdminModal = function () {
	        this.addOrganizationAdminModal.organizationMasterHashId = this.organizationMasterHashId;
	        this.addOrganizationAdminModal.show();
	    };
	    OrganizationAdminListComponent.prototype.SuccessAddOrganizationAdminModal = function ($event) {
	        this.GetOrganizationAdminList();
	        this.message = $event.SuccessMessage;
	    };
	    OrganizationAdminListComponent.prototype.ResetPersonPassword = function (personHashID) {
	        var _this = this;
	        this.personService.ResetPersonPassword(personHashID)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblResetPasswordSuccess');
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblResetPasswordFailure');
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    OrganizationAdminListComponent.prototype.ShowResetPasswordModal = function (personHashID) {
	        this.resetPasswordPersonHashId = personHashID;
	        this.popupMsg = this.translate.instant('LblResetPasswordConfirmation');
	        this.resetPasswordModal.show();
	    };
	    OrganizationAdminListComponent.prototype.HideResetPasswordModal = function () {
	        this.resetPasswordPersonHashId = "";
	        this.resetPasswordModal.hide();
	    };
	    OrganizationAdminListComponent.prototype.InActiveCompanyAdmin = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.organizationAdminService.InActiveOrganizationAdmin(this.blockUnblockOrganizationAdminHashId)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.inActiveModal.hide();
	                _this.DataListModel.currentPage = 1;
	                _this.GetOrganizationAdminList();
	                _this.popupMsg = _this.translate.instant('LblRecordBlokUnBlockSuccess', [_this.module, _this.blockMsg]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.isLoading = false;
	                _this.popupMsg = res.error;
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    OrganizationAdminListComponent.prototype.ShowInActiveModal = function (organizationAdminHashId, isActive) {
	        this.blockUnblockOrganizationAdminHashId = organizationAdminHashId;
	        this.blockMsg = isActive ? this.translate.instant('LblInactive') : this.translate.instant('LblActive');
	        var roleType = this.translate.instant('LblOrganizationAdmin');
	        this.blockUnblockMsg = this.translate.instant('LblBlockUnblockConfirm', [this.blockMsg, roleType]);
	        this.inActiveModal.show();
	    };
	    OrganizationAdminListComponent.prototype.HideInActiveModal = function () {
	        this.inActiveModal.hide();
	    };
	    OrganizationAdminListComponent.prototype.SuccessInActiveModalClick = function () {
	        this.InActiveCompanyAdmin();
	        this.inActiveModal.hide();
	    };
	    OrganizationAdminListComponent.prototype.SuccessResetPasswordModalClick = function () {
	        this.resetPasswordModal.hide();
	        console.log(this.resetPasswordPersonHashId);
	        this.ResetPersonPassword(this.resetPasswordPersonHashId);
	    };
	    OrganizationAdminListComponent.prototype.ShowAlertPopup = function () {
	        this.popupTitle = this.translate.instant('LblWarning');
	        this.successPopup.show();
	    };
	    OrganizationAdminListComponent.prototype.ShowSuccessPopup = function () {
	        this.popupTitle = this.translate.instant('LblSuccess');
	        this.successPopup.show();
	    };
	    OrganizationAdminListComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    OrganizationAdminListComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    __decorate([
	        core_1.ViewChild('alertModal'), 
	        __metadata('design:type', Object)
	    ], OrganizationAdminListComponent.prototype, "alertModal", void 0);
	    __decorate([
	        core_1.ViewChild('addOrganizationAdminModal'), 
	        __metadata('design:type', Object)
	    ], OrganizationAdminListComponent.prototype, "addOrganizationAdminModal", void 0);
	    __decorate([
	        core_1.ViewChild('resetPasswordModal'), 
	        __metadata('design:type', Object)
	    ], OrganizationAdminListComponent.prototype, "resetPasswordModal", void 0);
	    __decorate([
	        core_1.ViewChild('inActiveModal'), 
	        __metadata('design:type', Object)
	    ], OrganizationAdminListComponent.prototype, "inActiveModal", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], OrganizationAdminListComponent.prototype, "successPopup", void 0);
	    OrganizationAdminListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-organizationadmin',
	            template: __webpack_require__(941),
	            providers: [organization_service_1.OrganizationService, person_service_1.PersonService, organizationAdmin_service_1.OrganizationAdminService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof organizationAdmin_service_1.OrganizationAdminService !== 'undefined' && organizationAdmin_service_1.OrganizationAdminService) === 'function' && _a) || Object, (typeof (_b = typeof person_service_1.PersonService !== 'undefined' && person_service_1.PersonService) === 'function' && _b) || Object, (typeof (_c = typeof organization_service_1.OrganizationService !== 'undefined' && organization_service_1.OrganizationService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object, (typeof (_e = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _f) || Object, (typeof (_g = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _g) || Object])
	    ], OrganizationAdminListComponent);
	    return OrganizationAdminListComponent;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.OrganizationAdminListComponent = OrganizationAdminListComponent;


/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var OrganizationAdminService = (function () {
	    function OrganizationAdminService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    OrganizationAdminService.prototype.GetOrganizationAdminList = function (organizationMasterHashID, input) {
	        var getOrganizationAdminUrl = config_1.WeGoConfig.API_GET_ORGANIZATION_ADMIN_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getOrganizationAdminUrl = getOrganizationAdminUrl + "?" + queryString + "&organizationHashID=" + organizationMasterHashID;
	        }
	        else {
	            getOrganizationAdminUrl = getOrganizationAdminUrl + "?organizationHashID=" + organizationMasterHashID;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getOrganizationAdminUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OrganizationAdminService.prototype.ExportOrganizationAdminList = function (organizationMasterHashID, input) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var getOrganizationAdminUrl = config_1.WeGoConfig.API_EXPORT_ORGANIZATIONY_ADMIN_LIST + "?" + queryString + "&organizationHashID=" + organizationMasterHashID;
	        var headers = this.authService.GetHeader('text/csv');
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getOrganizationAdminUrl, options);
	    };
	    OrganizationAdminService.prototype.GetPersonListByOrganizationId = function (organizationMasterHashId, input) {
	        var getPersonUrl = config_1.WeGoConfig.API_GET_PERSON_LIST_BY_ORGANIZATION_ID;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getPersonUrl = getPersonUrl + "?" + queryString + "&organizationMasterHashId=" + organizationMasterHashId;
	        }
	        else {
	            getPersonUrl = getPersonUrl + "?organizationMasterHashId=" + organizationMasterHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getPersonUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OrganizationAdminService.prototype.AddNewOrganizationAdmin = function (organizationAdminModel) {
	        var body = organizationAdminModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_POST_ORGANIZATION_ADMIN_DETAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OrganizationAdminService.prototype.DeleteOrganizationAdmin = function (selectedOrganizationAdminList) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_POST_DELETE_ORGANIZATION_ADMIN, selectedOrganizationAdminList, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OrganizationAdminService.prototype.InActiveOrganizationAdmin = function (organizationAdminHashId) {
	        var getInactiveOrganizationAdminUrl = config_1.WeGoConfig.API_GET_INACTIVE_ORGANIZATION_ADMIN + "?organizationAdminHashId=" + organizationAdminHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getInactiveOrganizationAdminUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OrganizationAdminService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], OrganizationAdminService);
	    return OrganizationAdminService;
	    var _a, _b;
	}());
	exports.OrganizationAdminService = OrganizationAdminService;


/***/ },
/* 941 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ breadCrumbList}} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li><a [routerLink]=\"urlDefaultPage\"><i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a></li>\r\n        <li><a [routerLink]=\"urlOrganizationList\"><i class=\"fa fa-sitemap\"></i> {{organizationList }}</a></li>\r\n        <li class=\"active\"> {{ breadCrumbList}} </li>\r\n\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25 \">\r\n      <a class=\"btn btn-highlight navbar-right\" (click)=\"ShowAddOrganizationAdminModal()\">{{ 'LblAddNew' | translate }}</a>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <h4><label>{{ 'LblOrganization' | translate }} : </label> {{organizationName}}</h4>\r\n        <p class=\"text-success\">{{ message }}</p>\r\n        <p class=\"text-red\">{{ errorMessage }}</p>\r\n        <wego-search-list [IsDeleted]=\"true\" [IsDeleteEnabled]=\"isAnyChecked\" (OnDeleteAll)=\"ShowAlertModal()\" (OnSearch)=\"OnSearch($event)\"\r\n          (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center parent-checkbox\"><input type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\"></th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('firstName')\">\r\n                  {{ 'LblFirstName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'firstName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('lastName')\">\r\n                  {{ 'LblLastName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'lastName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('userName')\">\r\n                  {{ 'LblUserName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'userName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"text-center\">{{ 'LblResetPassword' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblActiveInactive' | translate }}</th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let organizationAdmin of organizationAdminList\">                  \r\n                  <td class=\"text-center\"><input type=\"checkbox\" [disabled]=\"organizationAdmin.isUserOrganizationAdmin || (!organizationAdmin.canRemove)\" name=\"isActive\" [(ngModel)]=\"organizationAdmin.isChecked\"></td>\r\n                  <td>{{ organizationAdmin.firstName }}</td>\r\n                  <td>{{ organizationAdmin.lastName }}</td>\r\n                  <td>{{ organizationAdmin.userName }}</td>\r\n                  <template [ngIf]=\"organizationAdmin.isUserOrganizationAdmin\">\r\n                    <td class=\"text-center\">\r\n                      <a>\r\n                      <i class=\"fa fa-refresh fa-fw text-success\"></i>\r\n                    </a>\r\n                    </td>\r\n                  </template>\r\n                  <template [ngIf]=\"!organizationAdmin.isUserOrganizationAdmin\">\r\n                    <td class=\"text-center\">\r\n                      <a class=\"cursor-pointer\">\r\n                      <i class=\"fa fa-refresh fa-fw text-success\" (click)=\"ShowResetPasswordModal(organizationAdmin.personHashID)\"></i>\r\n                    </a>\r\n                    </td>\r\n                  </template>                  \r\n                  <template [ngIf]=\"organizationAdmin.isUserOrganizationAdmin\">                    \r\n                    <td class=\"text-center\">\r\n                      <a disabled=\"true\" class=\"cursor-pointer btn btn-xs btn-active-inactive\" [ngClass]=\"{'btn-success': !organizationAdmin.isActive, 'btn-danger': organizationAdmin.isActive}\"\r\n                        (click)=\"ShowInActiveModal(organizationAdmin.organizationAdminHashId, organizationAdmin.isActive)\">\r\n                        <template [ngIf]=\"!organizationAdmin.isActive\"> {{ 'LblActive' | translate}} </template>\r\n                        <template [ngIf]=\"organizationAdmin.isActive\"> {{ 'LblInactive' | translate}} </template>\r\n                      </a>\r\n                    </td>\r\n                  </template>\r\n                  <template [ngIf]=\"!organizationAdmin.isUserOrganizationAdmin\">\r\n                    <td class=\"text-center\">\r\n                      <a class=\"cursor-pointer btn btn-xs btn-active-inactive\" [ngClass]=\"{'btn-active': !organizationAdmin.isActive, 'btn-inactive': organizationAdmin.isActive}\"\r\n                        (click)=\"ShowInActiveModal(organizationAdmin.organizationAdminHashId, organizationAdmin.isActive)\">\r\n                        <template [ngIf]=\"!organizationAdmin.isActive\"> {{ 'LblActive' | translate}} </template>\r\n                        <template [ngIf]=\"organizationAdmin.isActive\"> {{ 'LblInactive' | translate}} </template>\r\n                      </a>\r\n                    </td>\r\n                  </template>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"6\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n\r\n\r\n<wego-confirm-popup #alertModal [popupMsg]=\"deleteMessage\" (onConfirm)=\"SuccessAlertModalClick()\" (onReject)=\"HideAlertModal()\"></wego-confirm-popup>\r\n\r\n<wego-confirm-popup #resetPasswordModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessResetPasswordModalClick()\" (onReject)=\"HideResetPasswordModal()\"></wego-confirm-popup>\r\n\r\n<wego-confirm-popup #inActiveModal [popupMsg]=\"blockUnblockMsg\" (onConfirm)=\"SuccessInActiveModalClick()\" (onReject)=\"HideInActiveModal()\"></wego-confirm-popup>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" [popupTitle]=\"popupTitle\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n\r\n<wego-add-organizationadmin #addOrganizationAdminModal (OnSuccessSelect)=\"SuccessAddOrganizationAdminModal($event)\"></wego-add-organizationadmin>";

/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var core_1 = __webpack_require__(3);
	var auth_service_1 = __webpack_require__(58);
	var OrgAdminComponent = (function () {
	    function OrgAdminComponent(translate, authService) {
	        this.translate = translate;
	        this.authService = authService;
	        this.toggleClass = "ui-skins sidebar-mini";
	        this.menu = [
	            {
	                title: 'LblDashboard',
	                icon: 'fa fa-tachometer fa-fw',
	                redirectPath: 'dashboard',
	            }, {
	                title: 'LblOrganization',
	                icon: 'fa fa-sitemap fa-fw',
	                redirectPath: 'organization/list',
	            }, {
	                title: 'LblPersons',
	                icon: 'fa fa-user fa-fw',
	                redirectPath: 'person/list',
	                items: [{
	                        title: 'LblPersonOverview',
	                        icon: '',
	                        redirectPath: 'person/list',
	                    }]
	            },
	            {
	                title: 'LblSharedVehicleGroups',
	                icon: 'fa fa-group fa-fw',
	                redirectPath: 'sharedvehiclegroup/list',
	                items: [{
	                        title: 'LblSharedVehicleGroupOverview',
	                        icon: '',
	                        redirectPath: 'sharedvehiclegroup/list',
	                    }]
	            },
	            {
	                title: 'LblDrivers',
	                icon: 'fa fa-male fa-fw',
	                redirectPath: 'driver/list',
	            },
	            {
	                title: 'LblBookings',
	                icon: 'fa fa-calendar fa-fw',
	                redirectPath: 'booking',
	                items: [
	                    {
	                        title: 'LblBookingsOverview',
	                        icon: '',
	                        redirectPath: 'booking/overview',
	                    },
	                    {
	                        title: 'LblNormal',
	                        icon: '',
	                        redirectPath: 'booking',
	                    }
	                ]
	            },
	            {
	                title: 'LblInvoicing',
	                icon: 'fa fa-file-text fa-fw',
	                redirectPath: 'invoice',
	                items: [{
	                        title: 'LblInvoices',
	                        icon: '',
	                        redirectPath: 'invoice/list',
	                    }]
	            }
	        ];
	    }
	    OrgAdminComponent.prototype.ngOnInit = function () {
	        this.translate.setDetectedLang();
	    };
	    OrgAdminComponent.prototype.ToggleMenuLocal = function () {
	        if (window.innerWidth > 767) {
	            if (this.toggleClass == "ui-skins sidebar-mini")
	                this.toggleClass = "ui-skins sidebar-mini sidebar-collapse";
	            else if (this.toggleClass == "ui-skins sidebar-mini sidebar-collapse" || this.toggleClass == "ui-skins sidebar-mini sidebar-open")
	                this.toggleClass = "ui-skins sidebar-mini";
	        }
	        else {
	            if (this.toggleClass == "ui-skins sidebar-mini")
	                this.toggleClass = "ui-skins sidebar-mini sidebar-open";
	            else if (this.toggleClass == "ui-skins sidebar-mini sidebar-open" || this.toggleClass == "ui-skins sidebar-mini sidebar-collapse")
	                this.toggleClass = "ui-skins sidebar-mini";
	        }
	    };
	    OrgAdminComponent.prototype.onResize = function (event) {
	    };
	    OrgAdminComponent.prototype.ngOnDestroy = function () { };
	    OrgAdminComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-orgadmin',
	            template: "\n  <div class=\"admin-role\">\n    <div [class]=\"toggleClass\" (window:resize)=\"onResize($event)\" >\n      <wego-navbar (toggleMenu)=\"ToggleMenuLocal()\"></wego-navbar>\n      <wego-sidebar [menu]=\"menu\"></wego-sidebar>\n      <wego-content-wrapper></wego-content-wrapper>\n      <wego-footer></wego-footer>\n    </div>\n  </div>\n  ",
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object])
	    ], OrgAdminComponent);
	    return OrgAdminComponent;
	    var _a, _b;
	}());
	exports.OrgAdminComponent = OrgAdminComponent;


/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var auth_service_1 = __webpack_require__(58);
	var config_1 = __webpack_require__(60);
	var OrgAdminAuthGuard = (function () {
	    function OrgAdminAuthGuard(authService, router) {
	        this.authService = authService;
	        this.router = router;
	    }
	    OrgAdminAuthGuard.prototype.canActivate = function (route, state) {
	        if (this.authService.isAuthorized(config_1.UserRoles.ORGANIZATIONADMIN)) {
	            var urlBatchUpload = this.authService.GetURL(config_1.ApplicationRouteURL.URL_BATCHUPLOADPERSON);
	            var urlOrganizationUpdate = this.authService.GetURL(config_1.ApplicationRouteURL.URL_ORGANIZATION_UPDATE);
	            if (state.url == urlBatchUpload) {
	                return this.IsAuthorizeFor(this.authService.MODULE_NAME.PersonBatchUpload);
	            }
	            else if (state.url == urlOrganizationUpdate) {
	                return this.IsAuthorizeFor(this.authService.MODULE_NAME.CreateOrganization);
	            }
	            else {
	                return true;
	            }
	        }
	        else {
	            // Navigate to the login page
	            this.router.navigate(['/Unauthorized']);
	            return false;
	        }
	        // Store the attempted URL for redirecting 
	        //this.authService.redirectUrl = state.url;
	    };
	    OrgAdminAuthGuard.prototype.IsAuthorizeFor = function (moduleName) {
	        var _this = this;
	        return this.authService.IsAuthorizeFor(moduleName)
	            .map(function (res) {
	            if (!res.data) {
	                _this.router.navigate(['/NotFound']);
	            }
	            return res.data;
	        });
	    };
	    OrgAdminAuthGuard = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object])
	    ], OrgAdminAuthGuard);
	    return OrgAdminAuthGuard;
	    var _a, _b;
	}());
	exports.OrgAdminAuthGuard = OrgAdminAuthGuard;


/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var driver_service_1 = __webpack_require__(570);
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var common_1 = __webpack_require__(22);
	var organization_service_1 = __webpack_require__(614);
	var OrganizationDriverComponent = (function () {
	    function OrganizationDriverComponent(organizationService, driverService, activeRoute, router, authService, translate, locationService) {
	        this.organizationService = organizationService;
	        this.driverService = driverService;
	        this.activeRoute = activeRoute;
	        this.router = router;
	        this.authService = authService;
	        this.translate = translate;
	        this.locationService = locationService;
	    }
	    Object.defineProperty(OrganizationDriverComponent.prototype, "isAnyChecked", {
	        get: function () {
	            if (this.driverList) {
	                var isCheck = this.driverList.some(function (x) { return x.isChecked == true; });
	                if (isCheck) {
	                    if (this.driverList.every(function (x) { return x.isChecked == true; }))
	                        this.isParentCheck = true;
	                    else
	                        this.isParentCheck = false;
	                }
	                else {
	                    this.isParentCheck = false;
	                }
	                return isCheck;
	            }
	            else {
	                this.isParentCheck = false;
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    OrganizationDriverComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.module = this.translate.instant('LblDriver');
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = ["driverName", "firstName", "lastName"];
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlOrganizationList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_ORGANIZATION_LIST);
	        this.urlPersonUpdate = this.authService.GetURL(config_1.ApplicationRouteURL.URL_PERSON_UPDATE);
	        this.activeRoute
	            .params
	            .subscribe(function (params) {
	            var organizationHashId = params['organizationHashId'] || '';
	            if (organizationHashId != '') {
	                _this.organizationHashId = organizationHashId;
	                _this.GetOrganizationDriverList();
	                _this.GetOrganizationByHashId();
	            }
	        });
	    };
	    OrganizationDriverComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.organizationService.ExportOrganizationDriverList(this.organizationHashId, this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "OrganizationDrivers" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	        ;
	    };
	    OrganizationDriverComponent.prototype.RedirectoPerson = function (personHashId) {
	        this.router.navigate([this.urlPersonUpdate, { personId: personHashId }]);
	    };
	    OrganizationDriverComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetOrganizationDriverList();
	    };
	    OrganizationDriverComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetOrganizationDriverList();
	    };
	    OrganizationDriverComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetOrganizationDriverList();
	    };
	    ;
	    OrganizationDriverComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetOrganizationDriverList();
	    };
	    OrganizationDriverComponent.prototype.OnParentCheck = function (isChecked) {
	        this.driverList.forEach(function (x) { return x.isChecked = isChecked; });
	    };
	    OrganizationDriverComponent.prototype.GetOrganizationDriverList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.organizationService.GetOrganizationDriverList(this.organizationHashId, this.DataListModel)
	            .subscribe(function (res) {
	            _this.driverList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    OrganizationDriverComponent.prototype.GetOrganizationByHashId = function () {
	        var _this = this;
	        this.organizationService.GetOrganizationBasicDetail(this.organizationHashId)
	            .subscribe(function (res) {
	            _this.organizationName = res.data.entityName;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    OrganizationDriverComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    OrganizationDriverComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-Orgdriver-list',
	            template: __webpack_require__(945),
	            providers: [driver_service_1.DriverService, organization_service_1.OrganizationService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof organization_service_1.OrganizationService !== 'undefined' && organization_service_1.OrganizationService) === 'function' && _a) || Object, (typeof (_b = typeof driver_service_1.DriverService !== 'undefined' && driver_service_1.DriverService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _e) || Object, (typeof (_f = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _f) || Object, (typeof (_g = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _g) || Object])
	    ], OrganizationDriverComponent);
	    return OrganizationDriverComponent;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.OrganizationDriverComponent = OrganizationDriverComponent;


/***/ },
/* 945 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ 'LblOrganizationDriversList' | translate }} {{ 'LblList' | translate }} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li><a [routerLink]=\"urlDefaultPage\"><i class=\"fa fa-dashboard\"></i>{{ 'LblHome' | translate }}</a></li>\r\n        <li><a [routerLink]=\"urlOrganizationList\"><i class=\"fa fa-group fa-fw\"></i> {{ 'LblOrganization' | translate }} {{ 'LblList' | translate }}</a></li>\r\n        <li class=\"active\"> {{ 'LblOrganizationDriversList' | translate }} {{ 'LblList' | translate }}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <h4><label>{{ 'LblOrganization' | translate }} : </label> {{organizationName}}</h4>\r\n        <wego-search-list [IsDeleted]=\"false\" [IsExported]=\"false\"\r\n          (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\"\r\n          [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('firstName')\">\r\n                  {{ 'LblFirstName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'firstName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('lastName')\">\r\n                  {{ 'LblLastName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'lastName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('driverName')\">\r\n                  {{ 'LblDriver' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'driverName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"text-center\">{{ 'LblEdit' | translate }}</th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let driver of driverList\">\r\n                  <td>{{ driver.firstName }}</td>\r\n                  <td>{{ driver.lastName }}</td>\r\n                  <td>{{ driver.driverName }}</td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"driver.allowEditForGroupAdmin\" class=\"cursor-pointer\" (click)=\"RedirectoPerson(driver.personMasterHashId)\">\r\n                        <i class=\"fa fa-pencil-square-o fa-fw\"></i>\r\n                      </a>\r\n                  </td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"4\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<div [hidden]=\"!isLoading\" class=\"my-loading\">\r\n  <div class=\"dimmer\"></div>\r\n  <div class=\"loading-bg\">\r\n    <i class=\"fa fa-refresh fa-spin fa-3x fa-fw\"></i>\r\n  </div>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>";

/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var customer_service_1 = __webpack_require__(664);
	var config_1 = __webpack_require__(60);
	var modal_1 = __webpack_require__(537);
	var CustomerListComponent = (function () {
	    function CustomerListComponent(customerService, authService, translate) {
	        this.customerService = customerService;
	        this.authService = authService;
	        this.translate = translate;
	    }
	    CustomerListComponent.prototype.ngOnInit = function () {
	        this.module = this.translate.instant('LblCustomer');
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = ["customerName", "description"];
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlCustomerAdd = this.authService.GetURL(config_1.ApplicationRouteURL.URL_CUSTOMER_ADD);
	        this.urlCustomerUpdate = this.authService.GetURL(config_1.ApplicationRouteURL.URL_CUSTOMER_UPDATE);
	        this.urlRoleAvailability = this.authService.GetURL(config_1.ApplicationRouteURL.URL_ROLEAVAILABILITY_LIST);
	        this.urlInstanceList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_INSTANCE_LIST);
	        this.urlAdminList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_ADMIN_OF_CUSTOMER_LIST);
	        this.CustomerList();
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	        this.addCustomerLink = new config_1.WeGoAuthorizedLink(this.urlCustomerAdd, config_1.Permission.PR_CUSTOMER_OVERVIEW, config_1.PermissionType.INSERT, 'btn btn-highlight navbar-right', 'LblAddNew');
	    };
	    CustomerListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.CustomerList();
	    };
	    CustomerListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.CustomerList();
	    };
	    CustomerListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.CustomerList();
	    };
	    ;
	    CustomerListComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.CustomerList();
	    };
	    CustomerListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.customerService.ExportCustomerList(this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "Customer" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    CustomerListComponent.prototype.CustomerList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.customerService.GetCustomerList(this.DataListModel)
	            .subscribe(function (res) {
	            _this.customerList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    CustomerListComponent.prototype.DeleteCustomer = function (deleteCustomer) {
	        var _this = this;
	        this.isLoading = true;
	        this.customerService.DeleteCustomers(deleteCustomer)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.DataListModel.currentPage = 1;
	                _this.CustomerList();
	                _this.popupMsg = _this.translate.instant('LblRecordRemovedSuccess', [_this.module]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.validationMessage = res.error;
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.ShowAlertModal();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    CustomerListComponent.prototype.ShowConfirmModal = function (customerMasterHashId) {
	        this.customerHashId = customerMasterHashId;
	        this.popupMsg = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
	        this.customerHashId = customerMasterHashId;
	        this.confirmModal.show();
	    };
	    CustomerListComponent.prototype.HideConfirmModal = function () {
	        this.customerHashId = "";
	        this.confirmModal.hide();
	    };
	    CustomerListComponent.prototype.SuccessModalClick = function () {
	        this.DeleteCustomer(this.customerHashId);
	        this.confirmModal.hide();
	    };
	    CustomerListComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    CustomerListComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    CustomerListComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    CustomerListComponent.prototype.SuccessAlertModalClick = function () {
	        this.alertModal.hide();
	    };
	    CustomerListComponent.prototype.ShowAlertModal = function () {
	        this.isLoading = false;
	        this.alertModal.show();
	    };
	    CustomerListComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    __decorate([
	        core_1.ViewChild('confirmModal'), 
	        __metadata('design:type', Object)
	    ], CustomerListComponent.prototype, "confirmModal", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], CustomerListComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild('alertModal'), 
	        __metadata('design:type', (typeof (_a = typeof modal_1.ModalDirective !== 'undefined' && modal_1.ModalDirective) === 'function' && _a) || Object)
	    ], CustomerListComponent.prototype, "alertModal", void 0);
	    CustomerListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-customer',
	            template: __webpack_require__(947),
	            providers: [customer_service_1.CustomerService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof customer_service_1.CustomerService !== 'undefined' && customer_service_1.CustomerService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object])
	    ], CustomerListComponent);
	    return CustomerListComponent;
	    var _a, _b, _c, _d;
	}());
	exports.CustomerListComponent = CustomerListComponent;


/***/ },
/* 947 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ breadCrumbList}} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li class=\"active\"> {{ breadCrumbList}} </li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25\">\r\n      <!-- <a class=\"btn btn-highlight navbar-right\" [routerLink]=\"[urlCustomerUpdate]\" routerLinkActive=\"active\">{{ 'LblAddNew' | translate }}</a> -->\r\n      <wego-authorized-link [LinkModel]=\"addCustomerLink\"></wego-authorized-link>\r\n    </div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <p class=\"text-success\">{{ message }}</p>\r\n        <wego-search-list (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\"\r\n          [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('customerName')\">\r\n                  {{ 'LblCustomerName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'customerName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('description')\">\r\n                  {{ 'LblDescription' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'description'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"text-center\">{{ 'LblAdmin' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblInstance' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblRole' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblEdit' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblDelete' | translate }}</th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let customer of customerList\">\r\n                  <td>{{customer.customerName }}</td>\r\n                  <td>{{customer.description}}</td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"!customer.isAdminCount\" class=\"btn btn-primary link-style\">\r\n                      <span class=\"badge link-text\">{{ customer.adminCount }}</span>\r\n                    </a>\r\n                    <a *ngIf=\"customer.isAdminCount\" class=\"btn btn-primary cursor-pointer link-style\" [routerLink]=\"urlAdminList+'/'+customer.customerHashId\">\r\n                      <span class=\"badge link-text\">{{ customer.adminCount }}</span>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"!customer.isInstanceCount\" class=\"btn btn-primary link-style\">\r\n                      <span class=\"badge link-text\">{{ customer.instanceCount }}</span>\r\n                    </a>\r\n                    <a *ngIf=\"customer.isInstanceCount\" class=\"btn btn-primary cursor-pointer link-style\" [routerLink]=\"[urlInstanceList, { customerHashId : customer.customerHashId }]\">\r\n                      <span class=\"badge link-text\">{{ customer.instanceCount }}</span>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"!customer.isWegoAdmin\"  class=\"btn btn-primary link-style\" disabled>\r\n                      <span class=\"badge link-text\">{{ customer.roleCount }}</span>\r\n                    </a>\r\n                    <a *ngIf=\"customer.isWegoAdmin\" class=\"btn btn-primary cursor-pointer link-style\" [routerLink]=\"[urlRoleAvailability, { customerHashId : customer.customerHashId }]\">\r\n                      <span class=\"badge link-text\">{{ customer.roleCount }}</span>\r\n                    </a>\r\n                      \r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"customer.isEditable\" class=\"cursor-pointer\" [routerLink]=\"urlCustomerUpdate + '/' + customer.customerHashId\">\r\n                      <i class=\"fa fa-pencil-square-o fa-fw\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"customer.isDeletable\" class=\"cursor-pointer\" (click)=\"ShowConfirmModal(customer.customerHashId)\">\r\n                      <i class=\"fa fa-trash-o fa-fw text-danger\"></i>\r\n                    </a>\r\n                  </td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"7\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n<wego-confirm-popup #confirmModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessModalClick()\" (onReject)=\"HideConfirmModal()\"></wego-confirm-popup>\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n<wego-success-popup #alertModal [popupTitle]=\"popupTitle\" [popupMsg]=\"validationMessage\" (onConfirm)=\"SuccessAlertModalClick()\"></wego-success-popup>";

/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var translate_service_1 = __webpack_require__(70);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var common_1 = __webpack_require__(22);
	var customer_service_1 = __webpack_require__(664);
	var customer_model_1 = __webpack_require__(949);
	var CustomerUpdateComponent = (function () {
	    function CustomerUpdateComponent(customerService, translate, activeRoute, authService, locationService) {
	        this.customerService = customerService;
	        this.translate = translate;
	        this.activeRoute = activeRoute;
	        this.authService = authService;
	        this.locationService = locationService;
	        this.searchField = "";
	        this.searchTerm = "";
	        this.selectedInstance = "";
	    }
	    CustomerUpdateComponent.prototype.ngOnInit = function () {
	        this.module = this.translate.instant('LblCustomer');
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlCustomerList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_CUSTOMER_LIST);
	        this.isEditMode = false;
	        this.model = new customer_model_1.CustomerModel();
	        this.GetCustomerDetails();
	    };
	    CustomerUpdateComponent.prototype.GetCustomerDetails = function () {
	        var _this = this;
	        this.sub = this.activeRoute
	            .params
	            .subscribe(function (params) {
	            _this.customerHashId = params['id'] || '';
	            if (_this.customerHashId != '') {
	                _this.isEditMode = true;
	                _this.customerService.GetCustomerByHashId(_this.customerHashId)
	                    .subscribe(function (res) {
	                    _this.model = res.data;
	                }, function (error) {
	                    _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	                });
	            }
	        });
	        this.breadCrumbTitle = this.isEditMode ? this.translate.instant('LblEditPage', [this.module]) : this.translate.instant('LblAddPage', [this.module]);
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	    };
	    CustomerUpdateComponent.prototype.UpdateCustomer = function () {
	        var _this = this;
	        this.customerService.UpdateCustomer(this.model)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.isEditMode ? _this.translate.instant('LblRecordUpdatedSuccess', [_this.module]) : _this.translate.instant('LblRecordAddedSuccess', [_this.module]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    CustomerUpdateComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    CustomerUpdateComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    CustomerUpdateComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    CustomerUpdateComponent.prototype.OnBackClick = function () {
	        this.locationService.back();
	    };
	    CustomerUpdateComponent.prototype.ngOnDestroy = function () {
	        if (this.sub) {
	            this.sub.unsubscribe();
	        }
	    };
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], CustomerUpdateComponent.prototype, "successPopup", void 0);
	    CustomerUpdateComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-customer',
	            template: __webpack_require__(950),
	            providers: [customer_service_1.CustomerService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof customer_service_1.CustomerService !== 'undefined' && customer_service_1.CustomerService) === 'function' && _a) || Object, (typeof (_b = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _d) || Object, (typeof (_e = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _e) || Object])
	    ], CustomerUpdateComponent);
	    return CustomerUpdateComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.CustomerUpdateComponent = CustomerUpdateComponent;


/***/ },
/* 949 */
/***/ function(module, exports) {

	"use strict";
	var CustomerModel = (function () {
	    function CustomerModel() {
	    }
	    return CustomerModel;
	}());
	exports.CustomerModel = CustomerModel;


/***/ },
/* 950 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{breadCrumbTitle}}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"urlCustomerList\">\r\n            <i class=\"fa fa-user-circle\"></i>{{breadCrumbList}}</a>\r\n        </li>\r\n        <li class=\"active\">{{breadCrumbTitle}}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"nopad\">\r\n      <form (ngSubmit)=\"UpdateCustomer()\" #updateCustomerForm=\"ngForm\">\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span> {{ 'LblCustomerName' | translate }}</label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblCustomerName' | translate }}\"\r\n            [(ngModel)]=\"model.customerName\" name=\"customerName\" maxlength=\"50\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'customerName' }}</span>\r\n        </div>\r\n\r\n        <div class=\"form-group col-md-4\">\r\n          <label>{{ 'LblDescription' | translate }}</label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblDescription' | translate }}\" [(ngModel)]=\"model.description\"\r\n            name=\"description\" maxlength=\"200\">\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'description' }}</span>\r\n        </div>\r\n\r\n        <div class=\"clearfix\"></div>\r\n\r\n        <div class=\"row no-margin\">\r\n          <div class=\"col-sm-12\">\r\n            <hr>\r\n            <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnBackClick()\">{{ 'LblCancel' | translate }}</a> &nbsp;&nbsp;\r\n            <button class=\"btn btn-green\" type=\"submit\">{{ 'LblSave' | translate }}</button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n\r\n";

/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var role_service_1 = __webpack_require__(952);
	var auth_service_1 = __webpack_require__(58);
	var index_1 = __webpack_require__(631);
	var modal_1 = __webpack_require__(537);
	var RoleListComponent = (function () {
	    function RoleListComponent(roleService, authService, router, translate) {
	        this.roleService = roleService;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	    }
	    RoleListComponent.prototype.ngOnInit = function () {
	        this.module = this.translate.instant("LblRoleManagement");
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = ["roleName", "entity", "roleType"];
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlRoleUpdate = this.authService.GetURL(config_1.ApplicationRouteURL.URL_ROLE_UPDATE);
	        this.GetRoleList();
	        this.breadCrumbList = this.translate.instant("LblListPage", [this.module]);
	    };
	    RoleListComponent.prototype.GetRoleList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.roleService.GetRoleList(this.DataListModel).subscribe(function (res) {
	            _this.roleList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    RoleListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.roleService.ExportRoleList(this.DataListModel).subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "Role" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    RoleListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetRoleList();
	    };
	    RoleListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetRoleList();
	    };
	    RoleListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetRoleList();
	    };
	    RoleListComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetRoleList();
	    };
	    RoleListComponent.prototype.ShowConfirmModal = function (roleHashId) {
	        this.deleteRoleHashId = roleHashId;
	        this.popupMsg = this.translate.instant("LblRecordDeleteConfirmation", [
	            this.module
	        ]);
	        this.deleteRoleHashId = roleHashId;
	        this.confirmModal.show();
	    };
	    RoleListComponent.prototype.HideConfirmModal = function () {
	        this.deleteRoleHashId = "";
	        this.confirmModal.hide();
	    };
	    RoleListComponent.prototype.SuccessModalClick = function () {
	        this.DeleteRole(this.deleteRoleHashId);
	        this.confirmModal.hide();
	    };
	    RoleListComponent.prototype.DeleteRole = function (deleteRole) {
	        var _this = this;
	        this.isLoading = true;
	        this.roleService.DeleteRole(deleteRole).subscribe(function (res) {
	            if (res.data) {
	                _this.DataListModel.currentPage = 1;
	                _this.GetRoleList();
	                _this.popupMsg = _this.translate.instant("LblRecordRemovedSuccess", [
	                    _this.module
	                ]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.validationMessage = res.error;
	                _this.popupTitle = _this.translate.instant("LblWarning");
	                _this.ShowAlertModal();
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    RoleListComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    RoleListComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    RoleListComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    RoleListComponent.prototype.SuccessAlertModalClick = function () {
	        this.alertModal.hide();
	    };
	    RoleListComponent.prototype.ShowAlertModal = function () {
	        this.isLoading = false;
	        this.alertModal.show();
	    };
	    RoleListComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    __decorate([
	        core_1.ViewChild("confirmModal"), 
	        __metadata('design:type', Object)
	    ], RoleListComponent.prototype, "confirmModal", void 0);
	    __decorate([
	        core_1.ViewChild("successPopup"), 
	        __metadata('design:type', Object)
	    ], RoleListComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild("alertModal"), 
	        __metadata('design:type', (typeof (_a = typeof modal_1.ModalDirective !== 'undefined' && modal_1.ModalDirective) === 'function' && _a) || Object)
	    ], RoleListComponent.prototype, "alertModal", void 0);
	    RoleListComponent = __decorate([
	        core_1.Component({
	            selector: "wego-role",
	            template: __webpack_require__(953) + config_1.WeGoConfig.APP_VERSION,
	            providers: [role_service_1.RoleService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof role_service_1.RoleService !== 'undefined' && role_service_1.RoleService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof index_1.TranslateService !== 'undefined' && index_1.TranslateService) === 'function' && _e) || Object])
	    ], RoleListComponent);
	    return RoleListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.RoleListComponent = RoleListComponent;


/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var auth_service_1 = __webpack_require__(58);
	var config_1 = __webpack_require__(60);
	var RoleService = (function () {
	    function RoleService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    RoleService.prototype.GetRoleList = function (input) {
	        var getRoleUrl = config_1.WeGoConfig.API_GET_ROLE_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getRoleUrl = getRoleUrl + "?" + queryString;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getRoleUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    RoleService.prototype.ExportRoleList = function (input) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var getUrl = config_1.WeGoConfig.API_EXPORT_ROLE_LIST + "?" + queryString;
	        var headers = this.authService.GetHeader("text/csv");
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getUrl, options);
	    };
	    RoleService.prototype.GetRoleByHashId = function (roleHashId) {
	        var getRoleUrl = config_1.WeGoConfig.API_GET_ROLE_BY_HASH + "?roleHashId=" + roleHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getRoleUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    RoleService.prototype.AddRole = function (roleModel) {
	        var body = roleModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_ROLE_DETAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    RoleService.prototype.GetEntityDropdownList = function (input) {
	        var getUrl = config_1.WeGoConfig.API_GET_ENTITY_LIST;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    RoleService.prototype.GetRoleDropdownListByEntity = function (entity) {
	        var getUrl = config_1.WeGoConfig.API_GET_ROLE_LIST_BY_ENTITY + "?entity=" + entity;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    RoleService.prototype.GetAccessibilityMatrixByRoleHashId = function (roleHashId) {
	        var getUrl = config_1.WeGoConfig.API_GET_ACCESSIBILITY_BY_HASH + "?roleHashId=" + roleHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    RoleService.prototype.DeleteRole = function (roleHashId) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(config_1.WeGoConfig.API_POST_DELETE_ROLE + "?roleHashId=" + roleHashId, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    RoleService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], RoleService);
	    return RoleService;
	    var _a, _b;
	}());
	exports.RoleService = RoleService;


/***/ },
/* 953 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ breadCrumbList}} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li class=\"active\"> {{ breadCrumbList}} </li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25\">\r\n      <a class=\"btn btn-highlight navbar-right\" [routerLink]=\"[urlRoleUpdate]\" routerLinkActive=\"active\">{{ 'LblAddNew' | translate }}</a>\r\n    </div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <p class=\"text-success\">{{ message }}</p>\r\n        <wego-search-list (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\"\r\n          [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <!-- <th class=\"text-center parent-checkbox\"><input type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\"></th> -->\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('roleName')\">\r\n                  {{ 'LblRoleName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'roleName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('entity')\">\r\n                  {{ 'LblEntityName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'entity'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('roleType')\">\r\n                  {{ 'LblRoleType' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'roleType'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"text-center\">{{ 'LblEdit' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblDelete' | translate }}</th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let role of roleList\">\r\n                  <!-- <td  class=\"text-center\"><input type=\"checkbox\" name=\"isActive\" [(ngModel)]=\"role.isChecked\"></td> -->\r\n                  <td>{{ role.roleName }}</td>\r\n                  <td>{{role.entity}}</td>\r\n                  <td>{{role.roleType}}</td>\r\n                  <td class=\"text-center\">\r\n                    <a [routerLink]=\"urlRoleUpdate +'/'+ role.roleHashId\">\r\n                      <i class=\"fa fa-pencil-square-o fa-fw\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"!role.isDefault\" class=\"cursor-pointer\" (click)=\"ShowConfirmModal(role.roleHashId)\">\r\n                      <i class=\"fa fa-trash-o fa-fw text-danger\"></i>\r\n                    </a>\r\n                  </td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"5\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<!-- <wego-confirm-popup #childModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessModalClick()\" (onReject)=\"HideChildModal()\"></wego-confirm-popup> -->\r\n<wego-confirm-popup #confirmModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessModalClick()\" (onReject)=\"HideConfirmModal()\"></wego-confirm-popup>\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n<wego-success-popup #alertModal [popupTitle]=\"popupTitle\" [popupMsg]=\"validationMessage\" (onConfirm)=\"SuccessAlertModalClick()\"></wego-success-popup>";

/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var common_1 = __webpack_require__(22);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var role_model_1 = __webpack_require__(955);
	var index_1 = __webpack_require__(631);
	var role_service_1 = __webpack_require__(952);
	var auth_service_1 = __webpack_require__(58);
	var RoleUpdateComponent = (function () {
	    function RoleUpdateComponent(roleService, translate, activeRoute, authService, router, locationService) {
	        this.roleService = roleService;
	        this.translate = translate;
	        this.activeRoute = activeRoute;
	        this.authService = authService;
	        this.router = router;
	        this.locationService = locationService;
	        this.totalItems = 0;
	        this.currentPage = 1;
	        this.maxSize = config_1.WeGoConfig.GRID_MAX_PAGE_SIZE;
	        this.itemsPerPage = config_1.WeGoConfig.GRID_MAX_DATA_SIZE;
	        this.searchField = "";
	        this.searchTerm = "";
	    }
	    RoleUpdateComponent.prototype.ngOnInit = function () {
	        this.module = this.translate.instant("LblRoleManagement");
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlRoleList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_ROLE_LIST);
	        this.model = new role_model_1.RoleModel();
	        this.GetEntityDropdownList();
	        this.GetRoleDetails();
	    };
	    RoleUpdateComponent.prototype.GetRoleDetails = function () {
	        var _this = this;
	        this.sub = this.activeRoute.params.subscribe(function (params) {
	            _this.roleHashId = params["id"] || "";
	            if (_this.roleHashId != "") {
	                _this.isLoading = true;
	                _this.isEditMode = true;
	                _this.roleService.GetRoleByHashId(_this.roleHashId).subscribe(function (res) {
	                    _this.model = res.data;
	                    _this.accessibilityMatrixList = _this.model.accessList;
	                    _this.isLoading = false;
	                }, function (error) {
	                    _this.isLoading = false;
	                    _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	                });
	            }
	            else {
	                _this.isEditMode = false;
	                _this.model = new role_model_1.RoleModel();
	                _this.model.entity = "";
	            }
	        });
	        this.breadCrumbTitle = this.isEditMode
	            ? this.translate.instant("LblEditPage", [this.module])
	            : this.translate.instant("LblAddPage", [this.module]);
	        this.breadCrumbList = this.translate.instant("LblListPage", [this.module]);
	    };
	    RoleUpdateComponent.prototype.GetEntityDropdownList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.roleService.GetEntityDropdownList().subscribe(function (res) {
	            _this.entityList = res.data;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    RoleUpdateComponent.prototype.OnViewCheckBoxChange = function (item, isChecked) {
	        if (!isChecked) {
	            item.insert = false;
	            item.edit = false;
	            item.delete = false;
	        }
	    };
	    RoleUpdateComponent.prototype.UpdateAccessMatrix = function () {
	        var _this = this;
	        if (this.model.entity != null && this.model.entity.length > 0) {
	            var selectedDefaultRole = this.entityList.find(function (x) { return x.entity === _this.model.entity; });
	            if (selectedDefaultRole != null) {
	                this.isLoading = true;
	                this.roleService
	                    .GetAccessibilityMatrixByRoleHashId(selectedDefaultRole.roleHashId)
	                    .subscribe(function (res) {
	                    _this.accessibilityMatrixList = res.data;
	                    _this.isLoading = false;
	                }, function (error) {
	                    _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	                    _this.isLoading = false;
	                });
	            }
	        }
	        else {
	            this.accessibilityMatrixList = [];
	        }
	    };
	    RoleUpdateComponent.prototype.CopyRoleAccessMatrix = function ($event) {
	        var copyAccess = $event.accessibilityMatrixList;
	        this.accessibilityMatrixList.forEach(function (x) {
	            var updatedAccess = copyAccess.find(function (y) { return y.permissionHashId == x.permissionHashId; });
	            if (updatedAccess) {
	                x.view = updatedAccess.view;
	                x.insert = updatedAccess.insert;
	                x.edit = updatedAccess.edit;
	                x.delete = updatedAccess.delete;
	            }
	        });
	    };
	    RoleUpdateComponent.prototype.onSubmit = function (forms) {
	        this.model.accessList = this.accessibilityMatrixList;
	        this.AddNewRole();
	    };
	    RoleUpdateComponent.prototype.AddNewRole = function () {
	        var _this = this;
	        this.roleService.AddRole(this.model).subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.isEditMode
	                    ? _this.translate.instant("LblRecordUpdatedSuccess", [_this.module])
	                    : _this.translate.instant("LblRecordAddedSuccess", [_this.module]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    RoleUpdateComponent.prototype.CopyRolePopup = function () {
	        this.copyRoleModal.selectedRoleEntity = this.model;
	        this.copyRoleModal.show();
	    };
	    RoleUpdateComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    RoleUpdateComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    RoleUpdateComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    RoleUpdateComponent.prototype.OnBackClick = function () {
	        this.locationService.back();
	    };
	    RoleUpdateComponent.prototype.ngOnDestroy = function () {
	        if (this.sub) {
	            this.sub.unsubscribe();
	        }
	    };
	    __decorate([
	        core_1.ViewChild("successPopup"), 
	        __metadata('design:type', Object)
	    ], RoleUpdateComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild("copyRoleModal"), 
	        __metadata('design:type', Object)
	    ], RoleUpdateComponent.prototype, "copyRoleModal", void 0);
	    RoleUpdateComponent = __decorate([
	        core_1.Component({
	            selector: "wego-role",
	            template: __webpack_require__(956),
	            providers: [role_service_1.RoleService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof role_service_1.RoleService !== 'undefined' && role_service_1.RoleService) === 'function' && _a) || Object, (typeof (_b = typeof index_1.TranslateService !== 'undefined' && index_1.TranslateService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _d) || Object, (typeof (_e = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _e) || Object, (typeof (_f = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _f) || Object])
	    ], RoleUpdateComponent);
	    return RoleUpdateComponent;
	    var _a, _b, _c, _d, _e, _f;
	}());
	exports.RoleUpdateComponent = RoleUpdateComponent;


/***/ },
/* 955 */
/***/ function(module, exports) {

	"use strict";
	var RoleModel = (function () {
	    function RoleModel() {
	    }
	    return RoleModel;
	}());
	exports.RoleModel = RoleModel;


/***/ },
/* 956 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{breadCrumbTitle}}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"urlRoleList\">\r\n            <i class=\"fa fa-cogs fa-fw\"></i>{{breadCrumbList}}</a>\r\n        </li>\r\n        <li class=\"active\">{{breadCrumbTitle}}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25 \">\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"nopad\">\r\n      <form (ngSubmit)=\"onSubmit(AddRoleForm.value)\" #AddRoleForm=\"ngForm\">\r\n        <input type=\"hidden\" class=\"form-control\" [(ngModel)]=\"model.roleHashId\" name=\"roleHashId\">\r\n        <input type=\"hidden\" class=\"form-control\" [(ngModel)]=\"model.isDefault\" name=\"isDefault\">\r\n\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblRoleName' | translate }}\r\n          </label>\r\n          <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblRoleName' | translate }}\" [(ngModel)]=\"model.roleName\" name=\"RoleName\"\r\n            maxlength=\"50\">\r\n\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'roleName' }}</span>\r\n        </div>\r\n\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblEntityName' | translate }}\r\n          </label>\r\n          <select [disabled]=\"isEditMode\" [(ngModel)]=\"model.entity\" class=\"form-control\" name=\"entity\" (ngModelChange)=\"UpdateAccessMatrix()\">\r\n            <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblEntityName' | translate }}</option>\r\n            <option *ngFor=\"let item of entityList\" [ngValue]=\"item.entity\">{{ item.entity }}</option>\r\n          </select>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'entity' }}</span>\r\n        </div>\r\n\r\n        <div class=\"col-md-4\"></div>\r\n\r\n        <div class=\"clearfix\"></div>\r\n\r\n        <div *ngIf=\"model.isDefault\" class=\"col-md-12 text-danger\">\r\n          <ul style=\"padding-left: 15px;\">\r\n            <li>\r\n              {{ 'LblDefaultRoleModifyWarning' | translate }}\r\n            </li>\r\n          </ul>\r\n        </div>\r\n\r\n        <template [ngIf]=\"model.entity != null && model.entity.length > 0\">\r\n          <div class=\"row col-md-12\">\r\n            <fieldset class=\"col-md-12\">\r\n              <legend class=\"legendStyle\">\r\n                <div class=\"pull-left\">\r\n                  {{ 'LblAccessibilityMatrix' | translate }}\r\n                </div>\r\n\r\n                <div class=\"col-md-2 pull-right mar_bot_5 text-right\" style=\"padding-right: 0;\">\r\n                  <button class=\"btn btn-sm btn-green\" type=\"button\" (click)=\"CopyRolePopup()\" routerLinkActive=\"active\">{{ 'LblCopy' | translate }}</button>\r\n                  <button class=\"btn btn-sm btn-green\" type=\"button\" (click)=\"UpdateAccessMatrix()\">{{ 'LblReset' | translate }}</button>\r\n                </div>\r\n              </legend>\r\n\r\n              <div class=\"clearfix\"></div>\r\n\r\n              <div class=\"table table-responsive mar_bot_ziro\">\r\n                <table class=\"table table-bordered mar_bot_ziro\">\r\n                  <thead>\r\n                    <tr>\r\n                      <th>{{ 'LblAccess' | translate }}</th>\r\n                      <th class=\"text-center\">{{ 'LblView' | translate }}</th>\r\n                      <th class=\"text-center\">{{ 'LblAdd' | translate }}</th>\r\n                      <th class=\"text-center\">{{ 'LblUpdate' | translate }}</th>\r\n                      <th class=\"text-center\">{{ 'LblDelete' | translate }}</th>\r\n                    </tr>\r\n                  </thead>\r\n                  <tbody>\r\n\r\n                    <template ngFor let-item [ngForOf]=\"accessibilityMatrixList\" let-i=\"index\">\r\n\r\n                      <template [ngIf]=\"i == 0 || item.logicalGroupName != accessibilityMatrixList[i-1].logicalGroupName\">\r\n                        <tr>\r\n                          <td colspan=\"5\">\r\n                            <b>{{item.logicalGroupName | translate }}</b>\r\n                          </td>\r\n                        </tr>\r\n                      </template>\r\n\r\n                      <tr>\r\n                        <td>{{item.permissionName | translate }} </td>\r\n                        <td class=\"text-center\">\r\n                          <input type=\"checkbox\" [name]=\"i + '_view'\" [(ngModel)]=\"item.view\" (change) = \"OnViewCheckBoxChange(item,$event.target.checked)\">\r\n                        </td>\r\n                        <td class=\"text-center\">\r\n                          <input type=\"checkbox\" [name]=\"i + '_insert'\" [(ngModel)]=\"item.insert\" [disabled]=\"!item.view\">\r\n                        </td>\r\n                        <td class=\"text-center\">\r\n                          <input type=\"checkbox\" [name]=\"i + '_edit'\" [(ngModel)]=\"item.edit\" [disabled]=\"!item.view\">\r\n                        </td>\r\n                        <td class=\"text-center\">\r\n                          <input type=\"checkbox\" [name]=\"i + '_delete'\" [(ngModel)]=\"item.delete\" [disabled]=\"!item.view\">\r\n                        </td>\r\n                      </tr>\r\n                    </template>\r\n                  </tbody>\r\n                </table>\r\n              </div>\r\n            </fieldset>\r\n          </div>\r\n          <div class=\"clearfix\"></div>\r\n        </template>\r\n\r\n        <!-- save & cancel -->\r\n        <div class=\"row no-margin\">\r\n          <div class=\"col-sm-12\">\r\n            <hr>\r\n            <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnBackClick()\">{{ 'LblCancel' | translate }}</a> &nbsp;&nbsp;\r\n            <button class=\"btn btn-green\" type=\"submit\">{{ 'LblSave' | translate }}</button>\r\n          </div>\r\n        </div>\r\n\r\n      </form>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<wego-copy-role-popup #copyRoleModal (OnSuccessSelect)=\"CopyRoleAccessMatrix($event)\"></wego-copy-role-popup>";

/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var modal_1 = __webpack_require__(537);
	var roleavailability_service_1 = __webpack_require__(958);
	var roleavailability_model_1 = __webpack_require__(959);
	var customer_service_1 = __webpack_require__(664);
	var RoleAvailabilityListComponent = (function () {
	    function RoleAvailabilityListComponent(roleAvailabilityService, customerService, authService, activeRoute, translate) {
	        this.roleAvailabilityService = roleAvailabilityService;
	        this.customerService = customerService;
	        this.authService = authService;
	        this.activeRoute = activeRoute;
	        this.translate = translate;
	    }
	    RoleAvailabilityListComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.listModule = this.translate.instant('LblCustomer');
	        this.module = this.translate.instant('LblRoleAvailability');
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = ["internalRoleName", "entity", "roleType", "presentationName"];
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlCustomer = this.authService.GetURL(config_1.ApplicationRouteURL.URL_CUSTOMER_LIST);
	        this.breadCrumbTitle = this.translate.instant('LblListPage', [this.module]);
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.listModule]);
	        this.sub = this.activeRoute
	            .params
	            .subscribe(function (params) {
	            _this.customerHashId = params['customerHashId'] || '';
	            _this.GetCustomerDetails();
	        });
	    };
	    RoleAvailabilityListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.RoleAvailabilityList();
	    };
	    RoleAvailabilityListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.RoleAvailabilityList();
	    };
	    RoleAvailabilityListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.RoleAvailabilityList();
	    };
	    RoleAvailabilityListComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.RoleAvailabilityList();
	    };
	    RoleAvailabilityListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.roleAvailabilityService.ExportRoleAvailability(this.DataListModel, this.customerHashId)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "RoleAvailability" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    RoleAvailabilityListComponent.prototype.RoleAvailabilityList = function () {
	        var _this = this;
	        this.isLoading = true;
	        if (this.customerHashId) {
	            this.roleAvailabilityService.GetAllRoleAvailability(this.DataListModel, this.customerHashId)
	                .subscribe(function (res) {
	                _this.roleAvailabilityList = res.data;
	                _this.DataListModel.totalItems = res.totalRecords;
	                _this.DataListModel.infoMessage = res.error;
	                _this.isLoading = false;
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	                _this.isLoading = false;
	            });
	        }
	    };
	    RoleAvailabilityListComponent.prototype.GetCustomerDetails = function () {
	        var _this = this;
	        if (this.customerHashId) {
	            this.isLoading = true;
	            this.customerService.GetCustomerBasicDetail(this.customerHashId)
	                .subscribe(function (res) {
	                if (res.data) {
	                    _this.customerName = res.data.entityName;
	                    _this.RoleAvailabilityList();
	                }
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	                _this.isLoading = false;
	            });
	        }
	    };
	    RoleAvailabilityListComponent.prototype.DeleteRoleAvailability = function (roleAvailabilityHashId) {
	        var _this = this;
	        this.isLoading = true;
	        this.roleAvailabilityService.DeleteRoleAvailability(roleAvailabilityHashId)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.DataListModel.currentPage = 1;
	                _this.RoleAvailabilityList();
	                _this.popupMsg = _this.translate.instant('LblRecordRemovedSuccess', [_this.module]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.validationMessage = res.error;
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.ShowAlertModal();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    RoleAvailabilityListComponent.prototype.ShowConfirmModel = function (roleAvailabilityHashId) {
	        this.popupMsg = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
	        this.roleAvailabilityHashId = roleAvailabilityHashId;
	        this.confirmModel.show();
	    };
	    RoleAvailabilityListComponent.prototype.HideConfirmModel = function () {
	        this.roleAvailabilityHashId = "";
	        this.confirmModel.hide();
	    };
	    RoleAvailabilityListComponent.prototype.SuccessModalClick = function () {
	        this.DeleteRoleAvailability(this.roleAvailabilityHashId);
	        this.HideConfirmModel();
	    };
	    RoleAvailabilityListComponent.prototype.UpdateRoleAvailability = function (roleavailability) {
	        this.roleAvailabilityModal.model = JSON.parse(JSON.stringify(roleavailability));
	        this.roleAvailabilityModal.errorModel = [];
	        this.roleAvailabilityModal.show();
	    };
	    RoleAvailabilityListComponent.prototype.SuccessUpdateRoleAvailability = function ($event) {
	        this.popupMsg = this.translate.instant('LblRecordUpdatedSuccess', [this.module]);
	        this.ShowSuccessPopup();
	        this.RoleAvailabilityList();
	    };
	    RoleAvailabilityListComponent.prototype.HideUpdateRoleAvailability = function () {
	        this.roleAvailabilityModal.hide();
	    };
	    RoleAvailabilityListComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    RoleAvailabilityListComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    RoleAvailabilityListComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    RoleAvailabilityListComponent.prototype.SuccessAlertModalClick = function () {
	        this.alertModal.hide();
	    };
	    RoleAvailabilityListComponent.prototype.ShowAlertModal = function () {
	        this.isLoading = false;
	        this.alertModal.show();
	    };
	    RoleAvailabilityListComponent.prototype.ShowAssignRoleAvailability = function () {
	        this.AssignRole.show();
	    };
	    RoleAvailabilityListComponent.prototype.SuccessAddRoleModalClick = function ($event) {
	        var _this = this;
	        var selectedRoleList = $event.RoleModelList;
	        if (selectedRoleList && selectedRoleList.length > 0) {
	            var roleAvailabiltyList = selectedRoleList.map(function (x) {
	                var roleAvailability = new roleavailability_model_1.RoleAvailabilityModel();
	                roleAvailability.internalRoleName = x.roleName;
	                roleAvailability.presentationName = x.roleName;
	                roleAvailability.entity = x.entity;
	                roleAvailability.isDefault = x.isDefault;
	                roleAvailability.roleType = x.roleType;
	                roleAvailability.customerHashId = _this.customerHashId;
	                roleAvailability.roleHashId = x.roleHashId;
	                return roleAvailability;
	            });
	            this.SaveRoleAvailability(roleAvailabiltyList);
	        }
	    };
	    RoleAvailabilityListComponent.prototype.SaveRoleAvailability = function (roleavailabilityList) {
	        this.saveRoleAvailabilityModal.model = roleavailabilityList;
	        this.saveRoleAvailabilityModal.show();
	    };
	    RoleAvailabilityListComponent.prototype.SuccessSaveRoleAvailability = function () {
	        this.popupMsg = this.translate.instant('LblRecordAddedSuccess', [this.module]);
	        this.ShowSuccessPopup();
	        this.RoleAvailabilityList();
	    };
	    RoleAvailabilityListComponent.prototype.HideSaveRoleAvailability = function () {
	        this.saveRoleAvailabilityModal.hide();
	    };
	    RoleAvailabilityListComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    __decorate([
	        core_1.ViewChild('confirmModel'), 
	        __metadata('design:type', Object)
	    ], RoleAvailabilityListComponent.prototype, "confirmModel", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], RoleAvailabilityListComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild('roleAvailabilityModal'), 
	        __metadata('design:type', Object)
	    ], RoleAvailabilityListComponent.prototype, "roleAvailabilityModal", void 0);
	    __decorate([
	        core_1.ViewChild('alertModal'), 
	        __metadata('design:type', (typeof (_a = typeof modal_1.ModalDirective !== 'undefined' && modal_1.ModalDirective) === 'function' && _a) || Object)
	    ], RoleAvailabilityListComponent.prototype, "alertModal", void 0);
	    __decorate([
	        core_1.ViewChild('AssignRole'), 
	        __metadata('design:type', (typeof (_b = typeof modal_1.ModalDirective !== 'undefined' && modal_1.ModalDirective) === 'function' && _b) || Object)
	    ], RoleAvailabilityListComponent.prototype, "AssignRole", void 0);
	    __decorate([
	        core_1.ViewChild('saveRoleAvailabilityModal'), 
	        __metadata('design:type', Object)
	    ], RoleAvailabilityListComponent.prototype, "saveRoleAvailabilityModal", void 0);
	    RoleAvailabilityListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-roleavailability',
	            template: __webpack_require__(960),
	            providers: [roleavailability_service_1.RoleAvailabilityService, customer_service_1.CustomerService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_c = typeof roleavailability_service_1.RoleAvailabilityService !== 'undefined' && roleavailability_service_1.RoleAvailabilityService) === 'function' && _c) || Object, (typeof (_d = typeof customer_service_1.CustomerService !== 'undefined' && customer_service_1.CustomerService) === 'function' && _d) || Object, (typeof (_e = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _f) || Object, (typeof (_g = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _g) || Object])
	    ], RoleAvailabilityListComponent);
	    return RoleAvailabilityListComponent;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.RoleAvailabilityListComponent = RoleAvailabilityListComponent;


/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var config_1 = __webpack_require__(60);
	var http_1 = __webpack_require__(59);
	var core_1 = __webpack_require__(3);
	var auth_service_1 = __webpack_require__(58);
	var RoleAvailabilityService = (function () {
	    function RoleAvailabilityService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    RoleAvailabilityService.prototype.GetAllRoleAvailability = function (input, customerHashId) {
	        var getRoleAvailabilityListUrl = config_1.WeGoConfig.API_GET_ROLEAVAILABILITY_LIST + "?customerHashID=" + customerHashId;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getRoleAvailabilityListUrl = getRoleAvailabilityListUrl + "&" + queryString;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getRoleAvailabilityListUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    RoleAvailabilityService.prototype.GetRoleAvailabilityByHashId = function (roleAvailabilityHashID) {
	        var getRoleAvailabilityUrl = config_1.WeGoConfig.API_GET_ROLEAVAILABILITY_BY_HASH + "?roleAvailabilityHashID=" + roleAvailabilityHashID;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getRoleAvailabilityUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    RoleAvailabilityService.prototype.UpdateRoleAvailability = function (roleAvailability) {
	        var body = roleAvailability;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_POST_ROLEAVAILABILITY_DETAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    RoleAvailabilityService.prototype.DeleteRoleAvailability = function (roleAvailabilityHashId) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(config_1.WeGoConfig.API_POST_DELETE_ROLEAVAILABILITY + "?roleAvailabilityHashIds=" + roleAvailabilityHashId, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    RoleAvailabilityService.prototype.ExportRoleAvailability = function (input, customerHashId) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var getUrl = config_1.WeGoConfig.API_EXPORT_ROLEAVAILABILITY_LIST + "?customerHashID=" + customerHashId + "&" + queryString;
	        var headers = this.authService.GetHeader('text/csv');
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getUrl, options);
	    };
	    RoleAvailabilityService.prototype.GetRoleForAssignToCustomer = function (input, customerHashId) {
	        var getRoleToAssignListUrl = config_1.WeGoConfig.API_GET_ROLE_FOR_ASSIGN_TO_CUSTOMER_LIST + "?customerHashID=" + customerHashId;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getRoleToAssignListUrl = getRoleToAssignListUrl + "&" + queryString;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getRoleToAssignListUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    RoleAvailabilityService.prototype.AddRoleAvailability = function (roleAvailabilityList) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_POST_ADD_ROLEAVAILABILITY, roleAvailabilityList, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    RoleAvailabilityService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], RoleAvailabilityService);
	    return RoleAvailabilityService;
	    var _a, _b;
	}());
	exports.RoleAvailabilityService = RoleAvailabilityService;


/***/ },
/* 959 */
/***/ function(module, exports) {

	"use strict";
	var RoleAvailabilityModel = (function () {
	    function RoleAvailabilityModel() {
	        this.isChecked = false;
	    }
	    return RoleAvailabilityModel;
	}());
	exports.RoleAvailabilityModel = RoleAvailabilityModel;


/***/ },
/* 960 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ breadCrumbTitle}} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"urlCustomer\">\r\n            <i class=\"fa fa-user-circle fa-fw\"></i>{{breadCrumbList}}</a>\r\n        </li>\r\n        <li class=\"active\">{{breadCrumbTitle}}</li>\r\n      </ol>\r\n    </div>   \r\n    <div class=\"col-md-3 col-sm-6 mar_t_25\">\r\n        <a class=\"btn btn-highlight navbar-right\" (click)=\"ShowAssignRoleAvailability()\" routerLinkActive=\"active\">{{ 'LblAddRole' | translate }}</a>\r\n      </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <h4>\r\n          <label>{{ 'LblCustomer' | translate }} : </label> {{customerName}}</h4>\r\n        <p class=\"text-success\">{{ message }}</p>\r\n        <wego-search-list (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\"\r\n          [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('internalRoleName')\">\r\n                  {{ 'LblInternalRoleName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'internalRoleName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('entity')\">\r\n                  {{ 'LblEntityName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'entity'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('presentationName')\">\r\n                  {{ 'LblPresentationName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'presentationName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th>{{ 'LblRoleType' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblEdit' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblDelete' | translate }}</th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let roleAvailability of roleAvailabilityList\">\r\n                  <td>{{roleAvailability.internalRoleName }}</td>\r\n                  <td>{{roleAvailability.entity }}</td>\r\n                  <td>{{roleAvailability.presentationName}}</td>\r\n                  <td>{{roleAvailability.roleType}}</td>\r\n                  <td class=\"text-center\">\r\n                    <a class=\"cursor-pointer\" (click)=\"UpdateRoleAvailability(roleAvailability)\">\r\n                      <i class=\"fa fa-pencil-square-o fa-fw\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a class=\"cursor-pointer\" (click)=\"ShowConfirmModel(roleAvailability.roleAvailabilityHashId)\">\r\n                      <i class=\"fa fa-trash-o fa-fw text-danger\"></i>\r\n                    </a>\r\n                  </td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"6\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n<wego-confirm-popup #confirmModel [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessModalClick()\" (onReject)=\"HideConfirmModel()\"></wego-confirm-popup>\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n<wego-success-popup #alertModal [popupTitle]=\"popupTitle\" [popupMsg]=\"validationMessage\" (onConfirm)=\"SuccessAlertModalClick()\"></wego-success-popup>\r\n<wego-roleavailability-update-popup #roleAvailabilityModal (onConfirm)=\"SuccessUpdateRoleAvailability($event)\"></wego-roleavailability-update-popup>\r\n<wego-assign-role-to-customer-popup #AssignRole [customerHashId]='customerHashId' (onConfirm)=\"SuccessAddRoleModalClick($event)\"></wego-assign-role-to-customer-popup>\r\n<wego-save-roleavailability-popup #saveRoleAvailabilityModal (onConfirm)=\"SuccessSaveRoleAvailability($event)\"></wego-save-roleavailability-popup>";

/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var admin_of_customer_service_1 = __webpack_require__(962);
	var person_service_1 = __webpack_require__(771);
	var customer_service_1 = __webpack_require__(664);
	var admin_to_invite_model_1 = __webpack_require__(963);
	var AdminOfCustomerListComponent = (function () {
	    function AdminOfCustomerListComponent(adminOfCustomerService, personService, customerService, activeRoute, authService, router, translate) {
	        this.adminOfCustomerService = adminOfCustomerService;
	        this.personService = personService;
	        this.customerService = customerService;
	        this.activeRoute = activeRoute;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.roleColumns = 0;
	    }
	    Object.defineProperty(AdminOfCustomerListComponent.prototype, "isAnyChecked", {
	        get: function () {
	            if (this.customerAdminList) {
	                var isCheck = this.customerAdminList.some(function (x) { return x.isChecked == true; });
	                if (isCheck) {
	                    if (this.customerAdminList.every(function (x) { return x.isChecked == true; }))
	                        this.isParentCheck = true;
	                    else
	                        this.isParentCheck = false;
	                }
	                else {
	                    this.isParentCheck = false;
	                }
	                return isCheck;
	            }
	            else {
	                this.isParentCheck = false;
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AdminOfCustomerListComponent.prototype, "isDeleteAccess", {
	        get: function () {
	            if (this.customerAdminList) {
	                return this.customerAdminList.some(function (x) { return x.isDeletable; });
	            }
	            else {
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    AdminOfCustomerListComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.module = this.translate.instant('LblCustomerAdmin');
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	        this.customerList = this.translate.instant('LblListPage', [
	            this.translate.instant('LblCustomer')
	        ]);
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = ['userName', 'firstName', 'lastName'];
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlCustomerList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_CUSTOMER_LIST);
	        this.inviteTitle =
	            this.translate.instant('LblInvite') +
	                ' ' +
	                this.translate.instant('LblCustomerAdmin');
	        this.adminDependencyModelTitle = this.translate.instant('LblAdminDependencyAlert');
	        this.adminDependencyvalidationMessage = this.translate.instant('LblAdminDependencyValidation');
	        this.sub = this.activeRoute.params.subscribe(function (params) {
	            _this.customerHashId = params['id'] || '';
	            if (_this.customerHashId != '') {
	                _this.addCustomerAdminLink = new config_1.WeGoAuthorizedLink('', config_1.Permission.PR_CUSTOMER_ADMIN_OVERVIEW, config_1.PermissionType.INSERT, 'btn btn-highlight navbar-right', 'LblInvite', config_1.Entity.CUSTOMER, _this.customerHashId);
	                _this.GetCustomerDetails();
	            }
	        });
	    };
	    AdminOfCustomerListComponent.prototype.SuccessAdminDependencyModalClick = function () {
	        this.adminDependencyModal.hide();
	    };
	    AdminOfCustomerListComponent.prototype.RoleAvailabilityList = function () {
	        var _this = this;
	        this.isLoading = true;
	        if (this.customerHashId) {
	            this.adminOfCustomerService
	                .GetAllRoleAvailability(new config_1.DataListModel(), this.customerHashId)
	                .subscribe(function (res) {
	                _this.roleAvailabilityList = res.data;
	                _this.roleColumns = _this.roleAvailabilityList.length;
	                _this.GetAdminOfCustomerList();
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	                _this.isLoading = false;
	            });
	        }
	    };
	    AdminOfCustomerListComponent.prototype.GetCustomerDetails = function () {
	        var _this = this;
	        if (this.customerHashId) {
	            this.isLoading = true;
	            this.customerService
	                .GetCustomerBasicDetail(this.customerHashId)
	                .subscribe(function (res) {
	                if (res.data) {
	                    _this.customerName = res.data.entityName;
	                    _this.RoleAvailabilityList();
	                }
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	                _this.isLoading = false;
	            });
	        }
	    };
	    AdminOfCustomerListComponent.prototype.GetAdminOfCustomerList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.adminOfCustomerService
	            .GetAdminOfCustomerList(this.customerHashId, this.DataListModel)
	            .subscribe(function (res) {
	            _this.customerAdminList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.customerAdminList = [];
	            _this.DataListModel.infoMessage = error;
	            _this.isLoading = false;
	        });
	    };
	    AdminOfCustomerListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetAdminOfCustomerList();
	    };
	    AdminOfCustomerListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetAdminOfCustomerList();
	    };
	    AdminOfCustomerListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetAdminOfCustomerList();
	    };
	    AdminOfCustomerListComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetAdminOfCustomerList();
	    };
	    AdminOfCustomerListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.adminOfCustomerService
	            .ExportAdminOfCustomerList(this.customerHashId, this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = 'CustomerAdmin' + new Date().toISOString() + '.csv';
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AdminOfCustomerListComponent.prototype.DeleteAdminOfCustomer = function (deleteAdminOfCustomerList) {
	        var _this = this;
	        this.isLoading = true;
	        this.adminOfCustomerService
	            .DeleteAdminOfCustomer(this.customerHashId, deleteAdminOfCustomerList)
	            .subscribe(function (res) {
	            if (!res.data) {
	                _this.adminDependencyvalidationMessage = _this.translate.instant('LblAdminDependencyValidationOnDelete');
	                _this.adminDependencyModal.show();
	                _this.isLoading = false;
	            }
	            else {
	                _this.DataListModel.currentPage = 1;
	                _this.GetAdminOfCustomerList();
	                _this.popupMsg = _this.translate.instant('LblRecordRemovedSuccess', [
	                    _this.module
	                ]);
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AdminOfCustomerListComponent.prototype.OnParentCheck = function (isChecked) {
	        this.customerAdminList
	            .filter(function (x) { return x.isDeletable; })
	            .forEach(function (x) { return (x.isChecked = isChecked); });
	    };
	    AdminOfCustomerListComponent.prototype.ShowAlertModal = function (deletePersonMasterHashId) {
	        if (deletePersonMasterHashId) {
	            this.deleteMessage = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
	            this.isMultipleDelete = false;
	            this.deletePersonMasterHashId = deletePersonMasterHashId;
	        }
	        else {
	            this.deleteMessage = this.translate.instant('LblRecordMultiplDeleteConfirmation', [this.module]);
	            this.isMultipleDelete = true;
	        }
	        this.alertModal.show();
	    };
	    AdminOfCustomerListComponent.prototype.HideAlertModal = function () {
	        this.deletePersonMasterHashId = '';
	        this.alertModal.hide();
	    };
	    AdminOfCustomerListComponent.prototype.SuccessAlertModalClick = function () {
	        var deleteAdminOfCustomerList;
	        if (this.isMultipleDelete)
	            deleteAdminOfCustomerList = this.customerAdminList
	                .filter(function (x) { return x.isChecked; })
	                .map(function (x) { return x.personMasterHashId; });
	        else
	            deleteAdminOfCustomerList.push(this.deletePersonMasterHashId);
	        this.DeleteAdminOfCustomer(deleteAdminOfCustomerList);
	        this.alertModal.hide();
	    };
	    // Add Customer admin popup
	    AdminOfCustomerListComponent.prototype.ShowAddAdminOfCustomerModal = function () {
	        this.ShowInviteAdminModal();
	    };
	    AdminOfCustomerListComponent.prototype.ToggleRoleAvailability = function (personHashID, roleHashId, personRolesHashIds, roleName, userName) {
	        this.ToggleRolePersonHashID = personHashID;
	        this.ToggleRoleHashId = roleHashId;
	        this.ToggleUserName = userName;
	        this.ToggleRoleName = roleName;
	        if (this.CheckRole(personRolesHashIds, roleHashId)) {
	            this.toggleRoleMsg = this.translate.instant('LblDoYouWantToRemove', [
	                userName,
	                roleName
	            ]);
	            this.ToggleAddRole = false;
	            this.ShowToggleRolePopup();
	        }
	        else {
	            this.toggleRoleMsg = this.translate.instant('LblDoYouWantToAdd', [
	                userName,
	                roleName
	            ]);
	            this.ToggleAddRole = true;
	            this.ShowToggleRolePopup();
	        }
	    };
	    AdminOfCustomerListComponent.prototype.ShowToggleRolePopup = function () {
	        this.toggleRolePopup.show();
	    };
	    AdminOfCustomerListComponent.prototype.HideToggleRolePopup = function () {
	        this.ToggleRolePersonHashID = '';
	        this.ToggleRoleHashId = '';
	        this.ToggleUserName = '';
	        this.ToggleRoleName = '';
	        this.toggleRolePopup.hide();
	    };
	    AdminOfCustomerListComponent.prototype.ConfirmToggleRolePopup = function () {
	        var _this = this;
	        if (this.ToggleAddRole) {
	            this.adminOfCustomerService
	                .AddAdminOfCustomerRole(this.customerHashId, this.ToggleRolePersonHashID, this.ToggleRoleHashId)
	                .subscribe(function (res) {
	                _this.GetAdminOfCustomerList();
	                _this.popupMsg = _this.translate.instant('LblRoleAddedSuccess', [
	                    _this.ToggleUserName,
	                    _this.ToggleRoleName
	                ]);
	                _this.HideToggleRolePopup();
	                _this.ShowSuccessPopup();
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	                _this.isLoading = false;
	                _this.HideToggleRolePopup();
	            });
	        }
	        else {
	            this.adminOfCustomerService
	                .DeleteAdminOfCustomerRole(this.customerHashId, this.ToggleRolePersonHashID, this.ToggleRoleHashId)
	                .subscribe(function (res) {
	                if (!res.data) {
	                    _this.HideToggleRolePopup();
	                    _this.adminDependencyvalidationMessage = _this.translate.instant('LblAdminDependencyValidation');
	                    _this.adminDependencyModal.show();
	                }
	                else {
	                    _this.GetAdminOfCustomerList();
	                    _this.popupMsg = _this.translate.instant('LblRoleDeletedSuccess', [
	                        _this.ToggleUserName,
	                        _this.ToggleRoleName
	                    ]);
	                    _this.HideToggleRolePopup();
	                    _this.ShowSuccessPopup();
	                }
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	                _this.isLoading = false;
	                _this.HideToggleRolePopup();
	            });
	        }
	    };
	    //Reset company admin password
	    AdminOfCustomerListComponent.prototype.ResetPersonPassword = function (personHashID) {
	        var _this = this;
	        this.personService.ResetPersonPassword(personHashID).subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblResetPasswordSuccess');
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblResetPasswordFailure');
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AdminOfCustomerListComponent.prototype.ShowResetPasswordModal = function (personHashID) {
	        this.resetPasswordPersonHashId = personHashID;
	        this.popupMsg = this.translate.instant('LblResetPasswordConfirmation');
	        this.resetPasswordModal.show();
	    };
	    AdminOfCustomerListComponent.prototype.HideResetPasswordModal = function () {
	        this.resetPasswordPersonHashId = '';
	        this.resetPasswordModal.hide();
	    };
	    AdminOfCustomerListComponent.prototype.SuccessResetPasswordModalClick = function () {
	        this.resetPasswordModal.hide();
	        this.ResetPersonPassword(this.resetPasswordPersonHashId);
	    };
	    AdminOfCustomerListComponent.prototype.ResendActivationMail = function (personHashID) {
	        var _this = this;
	        this.resetPasswordPersonHashId = personHashID;
	        this.personService.ReSendActivationMail(personHashID).subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblResendActivationMailSuccess');
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblResendActivationMailFailure');
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AdminOfCustomerListComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    AdminOfCustomerListComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    AdminOfCustomerListComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	        this.toggleRolePopup.hide();
	    };
	    AdminOfCustomerListComponent.prototype.ShowInviteAdminModal = function () {
	        this.inviteAdminModal.availableRoles = JSON.parse(JSON.stringify(this.roleAvailabilityList));
	        this.inviteAdminModal.availablePersons = '';
	        this.inviteAdminModal.show();
	    };
	    AdminOfCustomerListComponent.prototype.HideInviteAdminModal = function () {
	        this.inviteAdminModal.hide();
	    };
	    AdminOfCustomerListComponent.prototype.SuccessInviteAdminModalClick = function ($event) {
	        var _this = this;
	        console.log($event);
	        var adminInvitation = new admin_to_invite_model_1.CustomerAdminInvitationModel();
	        adminInvitation.emailAddress = $event.emailAddress;
	        adminInvitation.personHashId = $event.personHashId;
	        adminInvitation.roleHashIdList = $event.roleHashIdList;
	        adminInvitation.customerHashId = this.customerHashId;
	        this.adminOfCustomerService
	            .InviteAdminOfCustomer(adminInvitation)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblInvitationMailSuccess');
	                _this.HideInviteAdminModal();
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.inviteAdminModal.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	            _this.HideInviteAdminModal();
	        });
	    };
	    AdminOfCustomerListComponent.prototype.SearchEmailAddress = function ($event) {
	        var _this = this;
	        var emailAddress = $event.emailAddress;
	        this.isLoading = true;
	        this.adminOfCustomerService
	            .GetPersonListToInvite(this.customerHashId, emailAddress)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.inviteAdminModal.availablePersons = res.data;
	                _this.inviteAdminModal.errorModel = [];
	            }
	            else {
	                _this.inviteAdminModal.errorModel = res.error;
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AdminOfCustomerListComponent.prototype.CheckRole = function (existingArray, currentRole) {
	        return existingArray.some(function (x) { return x == currentRole; });
	    };
	    __decorate([
	        core_1.ViewChild('alertModal'), 
	        __metadata('design:type', Object)
	    ], AdminOfCustomerListComponent.prototype, "alertModal", void 0);
	    __decorate([
	        core_1.ViewChild('resetPasswordModal'), 
	        __metadata('design:type', Object)
	    ], AdminOfCustomerListComponent.prototype, "resetPasswordModal", void 0);
	    __decorate([
	        core_1.ViewChild('inActiveModal'), 
	        __metadata('design:type', Object)
	    ], AdminOfCustomerListComponent.prototype, "inActiveModal", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], AdminOfCustomerListComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild('toggleRolePopup'), 
	        __metadata('design:type', Object)
	    ], AdminOfCustomerListComponent.prototype, "toggleRolePopup", void 0);
	    __decorate([
	        core_1.ViewChild('inviteAdminModal'), 
	        __metadata('design:type', Object)
	    ], AdminOfCustomerListComponent.prototype, "inviteAdminModal", void 0);
	    __decorate([
	        core_1.ViewChild('adminDependencyModal'), 
	        __metadata('design:type', Object)
	    ], AdminOfCustomerListComponent.prototype, "adminDependencyModal", void 0);
	    AdminOfCustomerListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-admin-of-customer',
	            template: __webpack_require__(964),
	            providers: [admin_of_customer_service_1.AdminOfCustomerService, person_service_1.PersonService, customer_service_1.CustomerService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof admin_of_customer_service_1.AdminOfCustomerService !== 'undefined' && admin_of_customer_service_1.AdminOfCustomerService) === 'function' && _a) || Object, (typeof (_b = typeof person_service_1.PersonService !== 'undefined' && person_service_1.PersonService) === 'function' && _b) || Object, (typeof (_c = typeof customer_service_1.CustomerService !== 'undefined' && customer_service_1.CustomerService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object, (typeof (_e = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _f) || Object, (typeof (_g = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _g) || Object])
	    ], AdminOfCustomerListComponent);
	    return AdminOfCustomerListComponent;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.AdminOfCustomerListComponent = AdminOfCustomerListComponent;


/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var jquery_helper_service_1 = __webpack_require__(67);
	var AdminOfCustomerService = (function () {
	    function AdminOfCustomerService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	        this.JQueryHelper = new jquery_helper_service_1.JQueryHelperService();
	    }
	    AdminOfCustomerService.prototype.GetAdminOfCustomerList = function (customerHashID, input) {
	        var getComapanyAdminUrl = config_1.WeGoConfig.API_GET_ADMIN_OF_CUSTOMER_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getComapanyAdminUrl = getComapanyAdminUrl + "?" + queryString + "&customerHashID=" + customerHashID;
	        }
	        else {
	            getComapanyAdminUrl = getComapanyAdminUrl + "?customerHashID=" + customerHashID;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getComapanyAdminUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminOfCustomerService.prototype.ExportAdminOfCustomerList = function (customerHashId, input) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var getCompanyAdminUrl = config_1.WeGoConfig.API_EXPORT_ADMIN_OF_CUSTOMER_LIST + "?" + queryString + "&customerHashId=" + customerHashId;
	        var headers = this.authService.GetHeader('text/csv');
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getCompanyAdminUrl, options);
	    };
	    AdminOfCustomerService.prototype.DeleteAdminOfCustomer = function (customerHashId, selectedAdminOfCustomerList) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        var urlDeleteAdminOfCustomer = config_1.WeGoConfig.API_POST_DELETE_ADMIN_OF_CUSTOMER + "?customerHashId=" + customerHashId;
	        return this.http.post(urlDeleteAdminOfCustomer, selectedAdminOfCustomerList, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminOfCustomerService.prototype.GetAllRoleAvailability = function (input, customerHashId) {
	        var getRoleAvailabilityListUrl = config_1.WeGoConfig.API_GET_CUSTOMER_ROLEAVAILABILITY_LIST + "?customerHashID=" + customerHashId;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getRoleAvailabilityListUrl = getRoleAvailabilityListUrl + "&" + queryString;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getRoleAvailabilityListUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminOfCustomerService.prototype.DeleteAdminOfCustomerRole = function (customerHashId, personHashId, roleHashId) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        var urlDeleteAdminOfCustomer = config_1.WeGoConfig.API_POST_DELETE_ADMIN_OF_CUSTOMER_ROLE + "?customerHashId=" + customerHashId + "&personHashId=" + personHashId + "&roleHashId=" + roleHashId;
	        return this.http.get(urlDeleteAdminOfCustomer, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminOfCustomerService.prototype.AddAdminOfCustomerRole = function (customerHashId, personHashId, roleHashId) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        var urlAddAdminOfCustomer = config_1.WeGoConfig.API_POST_ADD_ADMIN_OF_CUSTOMER_ROLE + "?customerHashId=" + customerHashId + "&personHashId=" + personHashId + "&roleHashId=" + roleHashId;
	        ;
	        return this.http.get(urlAddAdminOfCustomer, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminOfCustomerService.prototype.GetPersonListToInvite = function (customerHashID, emailAddress) {
	        var getComapanyAdminUrl = config_1.WeGoConfig.API_GET_CUSTOMER_PERSON_TO_INVITE_LIST;
	        getComapanyAdminUrl = getComapanyAdminUrl + "?customerHashID=" + customerHashID + "&emailAddress=" + emailAddress;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getComapanyAdminUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminOfCustomerService.prototype.InviteAdminOfCustomer = function (customerAdminInvitationModel) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        var urlInviteAdminOfCustomer = config_1.WeGoConfig.API_POST_INVITE_ADMIN_OF_CUSTOMER;
	        return this.http.post(urlInviteAdminOfCustomer, customerAdminInvitationModel, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminOfCustomerService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], AdminOfCustomerService);
	    return AdminOfCustomerService;
	    var _a, _b;
	}());
	exports.AdminOfCustomerService = AdminOfCustomerService;


/***/ },
/* 963 */
/***/ function(module, exports) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var InvitePersonModel = (function () {
	    function InvitePersonModel() {
	    }
	    return InvitePersonModel;
	}());
	exports.InvitePersonModel = InvitePersonModel;
	var AdminInvitationModel = (function () {
	    function AdminInvitationModel() {
	    }
	    return AdminInvitationModel;
	}());
	exports.AdminInvitationModel = AdminInvitationModel;
	var CustomerAdminInvitationModel = (function (_super) {
	    __extends(CustomerAdminInvitationModel, _super);
	    function CustomerAdminInvitationModel() {
	        _super.apply(this, arguments);
	    }
	    return CustomerAdminInvitationModel;
	}(AdminInvitationModel));
	exports.CustomerAdminInvitationModel = CustomerAdminInvitationModel;
	var InstanceAdminInvitationModel = (function (_super) {
	    __extends(InstanceAdminInvitationModel, _super);
	    function InstanceAdminInvitationModel() {
	        _super.apply(this, arguments);
	    }
	    return InstanceAdminInvitationModel;
	}(AdminInvitationModel));
	exports.InstanceAdminInvitationModel = InstanceAdminInvitationModel;
	var CompanyAdminInvitationModel = (function (_super) {
	    __extends(CompanyAdminInvitationModel, _super);
	    function CompanyAdminInvitationModel() {
	        _super.apply(this, arguments);
	    }
	    return CompanyAdminInvitationModel;
	}(AdminInvitationModel));
	exports.CompanyAdminInvitationModel = CompanyAdminInvitationModel;
	var SharedVehicleGroupAdminInvitationModel = (function (_super) {
	    __extends(SharedVehicleGroupAdminInvitationModel, _super);
	    function SharedVehicleGroupAdminInvitationModel() {
	        _super.apply(this, arguments);
	    }
	    return SharedVehicleGroupAdminInvitationModel;
	}(AdminInvitationModel));
	exports.SharedVehicleGroupAdminInvitationModel = SharedVehicleGroupAdminInvitationModel;
	var OrganizationAdminInvitationModel = (function (_super) {
	    __extends(OrganizationAdminInvitationModel, _super);
	    function OrganizationAdminInvitationModel() {
	        _super.apply(this, arguments);
	    }
	    return OrganizationAdminInvitationModel;
	}(AdminInvitationModel));
	exports.OrganizationAdminInvitationModel = OrganizationAdminInvitationModel;
	var OrganizationDriverInvitationModel = (function (_super) {
	    __extends(OrganizationDriverInvitationModel, _super);
	    function OrganizationDriverInvitationModel() {
	        _super.apply(this, arguments);
	    }
	    return OrganizationDriverInvitationModel;
	}(AdminInvitationModel));
	exports.OrganizationDriverInvitationModel = OrganizationDriverInvitationModel;


/***/ },
/* 964 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ breadCrumbList}} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"urlCustomerList\">\r\n            <i class=\"fa fa-user-circle fa-fw\"></i> {{customerList }}</a>\r\n        </li>\r\n        <li class=\"active\"> {{ breadCrumbList}} </li>\r\n\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25 \">\r\n      <!-- <a class=\"btn btn-highlight navbar-right\" (click)=\"ShowAddAdminOfCustomerModal()\">{{ 'LblInvite' | translate }}</a> -->\r\n      <wego-authorized-link [LinkModel]=\"addCustomerAdminLink\" (onClick)=\"ShowAddAdminOfCustomerModal()\"></wego-authorized-link>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <h4>\r\n          <label>{{ 'LblCustomer' | translate }} : </label> {{customerName}}</h4>\r\n        <p class=\"text-success\">{{ message }}</p>\r\n        <wego-search-list [IsDeleted]=\"isDeleteAccess\" [IsDeleteEnabled]=\"isAnyChecked\" (OnDeleteAll)=\"ShowAlertModal()\" (OnSearch)=\"OnSearch($event)\"\r\n          (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center parent-checkbox\">\r\n                  <input [disabled]=\"!isDeleteAccess\" type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\">\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('firstName')\">\r\n                  {{ 'LblFirstName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'firstName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('lastName')\">\r\n                  {{ 'LblLastName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'lastName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('userName')\">\r\n                  {{ 'LblUserName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'userName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <!-- <th class=\"text-center\">{{ 'LblResendActivationMail' | translate }}</th> -->\r\n                <th class=\"text-center\">{{ 'LblResetPassword' | translate }}</th>\r\n                <th *ngFor=\"let role of roleAvailabilityList\" class=\"text-center\">\r\n                  {{role.presentationName}}\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let customerAdmin of customerAdminList\">\r\n                  <td class=\"text-center\">\r\n                    <input *ngIf=\"!customerAdmin.isDeletable\" type=\"checkbox\" name=\"isActive\" [(ngModel)]=\"customerAdmin.isChecked\" disabled>\r\n                    <input *ngIf=\"customerAdmin.isDeletable\" type=\"checkbox\" name=\"isActive\" [(ngModel)]=\"customerAdmin.isChecked\">\r\n                  </td>\r\n                  <td>{{ customerAdmin.firstName }}</td>\r\n                  <td>{{ customerAdmin.lastName }}</td>\r\n                  <td>{{ customerAdmin.userName }}</td>\r\n                  <!-- <td class=\"text-center\">\r\n                    <a *ngIf=\"customerAdmin.personNotActive\" class=\"btn btn-green btn-xs cursor-pointer\" (click)=\"ResendActivationMail(customerAdmin.personMasterHashId)\">\r\n                      {{ 'LblReSend' | translate}}\r\n                    </a>\r\n                  </td> -->\r\n                  <td class=\"text-center\">\r\n                    <a class=\"cursor-pointer\">\r\n                      <i class=\"fa fa-refresh fa-fw text-success\" (click)=\"ShowResetPasswordModal(customerAdmin.personMasterHashId)\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td *ngFor=\"let role of roleAvailabilityList\" class=\"text-center\">\r\n                    <a [ngClass]=\"{ 'cursor-pointer': customerAdmin.isEditable }\">\r\n                      <i *ngIf=\"!customerAdmin.isEditable\" class=\"fa fa-fw\" [ngClass]=\"{ 'fa-check text-success': CheckRole(customerAdmin.rolesHashIds, role.roleHashId), \r\n                    'fa-times text-danger' : !CheckRole(customerAdmin.rolesHashIds, role.roleHashId) }\"></i>\r\n                      <i *ngIf=\"customerAdmin.isEditable\" class=\"fa fa-fw\" (click)=\"ToggleRoleAvailability(customerAdmin.personMasterHashId,role.roleHashId,customerAdmin.rolesHashIds,role.presentationName,customerAdmin.userName)\"\r\n                        [ngClass]=\"{ 'fa-check text-success': CheckRole(customerAdmin.rolesHashIds, role.roleHashId), \r\n                    'fa-times text-danger' : !CheckRole(customerAdmin.rolesHashIds, role.roleHashId) }\"></i>\r\n                    </a>\r\n                  </td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" [attr.colspan]=\"5+roleColumns\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<wego-confirm-popup #alertModal [popupMsg]=\"deleteMessage\" (onConfirm)=\"SuccessAlertModalClick()\" (onReject)=\"HideAlertModal()\"></wego-confirm-popup>\r\n\r\n<wego-confirm-popup #resetPasswordModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessResetPasswordModalClick()\" (onReject)=\"HideResetPasswordModal()\"></wego-confirm-popup>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" [popupTitle]=\"popupTitle\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n\r\n<wego-confirm-popup #toggleRolePopup [popupMsg]=\"toggleRoleMsg\" (onConfirm)=\"ConfirmToggleRolePopup()\" (onReject)=\"HideToggleRolePopup()\"></wego-confirm-popup>\r\n\r\n<wego-invite-admin-popup #inviteAdminModal [popupTitle]=\"inviteTitle\" (onEmailSearch)=\"SearchEmailAddress($event)\" (onConfirm)=\"SuccessInviteAdminModalClick($event)\"\r\n  (onReject)=\"HideInviteAdminModal()\"></wego-invite-admin-popup>\r\n  <wego-success-popup #adminDependencyModal [popupTitle]=\"adminDependencyModelTitle\" [popupMsg]=\"adminDependencyvalidationMessage\" (onConfirm)=\"SuccessAdminDependencyModalClick()\"></wego-success-popup>";

/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var admin_of_instance_service_1 = __webpack_require__(966);
	var person_service_1 = __webpack_require__(771);
	var instance_service_1 = __webpack_require__(500);
	var admin_to_invite_model_1 = __webpack_require__(963);
	var AdminOfInstanceListComponent = (function () {
	    function AdminOfInstanceListComponent(adminOfInstanceService, personService, instanceService, activeRoute, authService, router, translate) {
	        this.adminOfInstanceService = adminOfInstanceService;
	        this.personService = personService;
	        this.instanceService = instanceService;
	        this.activeRoute = activeRoute;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.roleColumns = 0;
	    }
	    Object.defineProperty(AdminOfInstanceListComponent.prototype, "isAnyChecked", {
	        get: function () {
	            if (this.instanceAdminList) {
	                var isCheck = this.instanceAdminList.some(function (x) { return x.isChecked == true; });
	                if (isCheck) {
	                    if (this.instanceAdminList.every(function (x) { return x.isChecked == true; }))
	                        this.isParentCheck = true;
	                    else
	                        this.isParentCheck = false;
	                }
	                else {
	                    this.isParentCheck = false;
	                }
	                return isCheck;
	            }
	            else {
	                this.isParentCheck = false;
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AdminOfInstanceListComponent.prototype, "isDeleteAccess", {
	        get: function () {
	            if (this.instanceAdminList) {
	                return this.instanceAdminList.some(function (x) { return x.isDeletable; });
	            }
	            else {
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    AdminOfInstanceListComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.module = this.translate.instant('LblInstanceAdmin');
	        this.adminDependencyModelTitle = this.translate.instant('LblAdminDependencyAlert');
	        this.adminDependencyvalidationMessage = this.translate.instant('LblAdminDependencyValidation');
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	        this.instanceList = this.translate.instant('LblListPage', [
	            this.translate.instant('LblInstance')
	        ]);
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = ['userName', 'firstName', 'lastName'];
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlInstanceList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_INSTANCE_LIST);
	        this.inviteTitle =
	            this.translate.instant('LblInvite') +
	                ' ' +
	                this.translate.instant('LblInstanceAdmin');
	        this.sub = this.activeRoute.params.subscribe(function (params) {
	            _this.instanceHashId = params['id'] || '';
	            if (_this.instanceHashId != '') {
	                _this.addInstanceAdminLink = new config_1.WeGoAuthorizedLink('', config_1.Permission.PR_INSTANCE_ADMIN_OVERVIEW, config_1.PermissionType.INSERT, 'btn btn-highlight navbar-right', 'LblInvite', config_1.Entity.INSTANCE, _this.instanceHashId);
	                _this.GetInstanceDetails();
	            }
	        });
	    };
	    AdminOfInstanceListComponent.prototype.SuccessAdminDependencyModalClick = function () {
	        this.adminDependencyModal.hide();
	    };
	    AdminOfInstanceListComponent.prototype.RoleAvailabilityList = function () {
	        var _this = this;
	        this.isLoading = true;
	        if (this.instanceHashId) {
	            this.adminOfInstanceService
	                .GetAllRoleAvailability(new config_1.DataListModel(), this.instanceHashId)
	                .subscribe(function (res) {
	                _this.roleAvailabilityList = res.data;
	                _this.roleColumns = _this.roleAvailabilityList.length;
	                _this.GetAdminOfInstanceList();
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	                _this.isLoading = false;
	            });
	        }
	    };
	    AdminOfInstanceListComponent.prototype.GetInstanceDetails = function () {
	        var _this = this;
	        if (this.instanceHashId) {
	            this.isLoading = true;
	            this.instanceService
	                .GetInstanceBasicDetail(this.instanceHashId)
	                .subscribe(function (res) {
	                if (res.data) {
	                    _this.instanceName = res.data.entityName;
	                    _this.RoleAvailabilityList();
	                }
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	                _this.isLoading = false;
	            });
	        }
	    };
	    AdminOfInstanceListComponent.prototype.GetAdminOfInstanceList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.adminOfInstanceService
	            .GetAdminOfInstanceList(this.instanceHashId, this.DataListModel)
	            .subscribe(function (res) {
	            _this.instanceAdminList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.instanceAdminList = [];
	            _this.DataListModel.infoMessage = error;
	            _this.isLoading = false;
	        });
	    };
	    AdminOfInstanceListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetAdminOfInstanceList();
	    };
	    AdminOfInstanceListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetAdminOfInstanceList();
	    };
	    AdminOfInstanceListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetAdminOfInstanceList();
	    };
	    AdminOfInstanceListComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetAdminOfInstanceList();
	    };
	    AdminOfInstanceListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.adminOfInstanceService
	            .ExportAdminOfInstanceList(this.instanceHashId, this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = 'InstanceAdmin' + new Date().toISOString() + '.csv';
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AdminOfInstanceListComponent.prototype.DeleteAdminOfInstance = function (deleteInstanceAdminList) {
	        var _this = this;
	        this.isLoading = true;
	        this.adminOfInstanceService
	            .DeleteAdminOfInstance(this.instanceHashId, deleteInstanceAdminList)
	            .subscribe(function (res) {
	            if (!res.data) {
	                _this.adminDependencyvalidationMessage = _this.translate.instant('LblAdminDependencyValidationOnDelete');
	                _this.adminDependencyModal.show();
	                _this.isLoading = false;
	            }
	            else {
	                _this.DataListModel.currentPage = 1;
	                _this.GetAdminOfInstanceList();
	                _this.popupMsg = _this.translate.instant('LblRecordRemovedSuccess', [
	                    _this.module
	                ]);
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AdminOfInstanceListComponent.prototype.OnParentCheck = function (isChecked) {
	        this.instanceAdminList
	            .filter(function (x) { return x.isDeletable; })
	            .forEach(function (x) { return (x.isChecked = isChecked); });
	    };
	    AdminOfInstanceListComponent.prototype.ShowAlertModal = function (deletePersonMasterHashId) {
	        if (deletePersonMasterHashId) {
	            this.deleteMessage = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
	            this.isMultipleDelete = false;
	            this.deletePersonMasterHashId = deletePersonMasterHashId;
	        }
	        else {
	            this.deleteMessage = this.translate.instant('LblRecordMultiplDeleteConfirmation', [this.module]);
	            this.isMultipleDelete = true;
	        }
	        this.alertModal.show();
	    };
	    AdminOfInstanceListComponent.prototype.HideAlertModal = function () {
	        this.deletePersonMasterHashId = '';
	        this.alertModal.hide();
	    };
	    AdminOfInstanceListComponent.prototype.SuccessAlertModalClick = function () {
	        var deleteAdminOfInstanceList;
	        if (this.isMultipleDelete)
	            deleteAdminOfInstanceList = this.instanceAdminList
	                .filter(function (x) { return x.isChecked; })
	                .map(function (x) { return x.personMasterHashId; });
	        else
	            deleteAdminOfInstanceList.push(this.deletePersonMasterHashId);
	        this.DeleteAdminOfInstance(deleteAdminOfInstanceList);
	        this.alertModal.hide();
	    };
	    // Add Instance admin popup
	    AdminOfInstanceListComponent.prototype.ShowAddInstanceAdminModal = function () {
	        this.ShowInviteAdminModal();
	    };
	    AdminOfInstanceListComponent.prototype.ToggleRoleAvailibility = function (personHashID, roleHashId, personRolesHashIds, roleName, userName) {
	        this.ToggleRolePersonHashID = personHashID;
	        this.ToggleRoleHashId = roleHashId;
	        this.ToggleUserName = userName;
	        this.ToggleRoleName = roleName;
	        if (this.CheckRole(personRolesHashIds, roleHashId)) {
	            this.toggleRoleMsg = this.translate.instant('LblDoYouWantToRemove', [
	                userName,
	                roleName
	            ]);
	            this.ToggleAddRole = false;
	            this.ShowToggleRolePopup();
	        }
	        else {
	            this.toggleRoleMsg = this.translate.instant('LblDoYouWantToAdd', [
	                userName,
	                roleName
	            ]);
	            this.ToggleAddRole = true;
	            this.ShowToggleRolePopup();
	        }
	    };
	    AdminOfInstanceListComponent.prototype.ShowToggleRolePopup = function () {
	        this.toggleRolePopup.show();
	    };
	    AdminOfInstanceListComponent.prototype.HideToggleRolePopup = function () {
	        this.ToggleRolePersonHashID = '';
	        this.ToggleRoleHashId = '';
	        this.ToggleUserName = '';
	        this.ToggleRoleName = '';
	        this.toggleRolePopup.hide();
	    };
	    AdminOfInstanceListComponent.prototype.ConfirmToggleRolePopup = function () {
	        var _this = this;
	        if (this.ToggleAddRole) {
	            this.adminOfInstanceService
	                .AddAdminOfInstanceRole(this.instanceHashId, this.ToggleRolePersonHashID, this.ToggleRoleHashId)
	                .subscribe(function (res) {
	                _this.GetAdminOfInstanceList();
	                _this.popupMsg = _this.translate.instant('LblRoleAddedSuccess', [
	                    _this.ToggleUserName,
	                    _this.ToggleRoleName
	                ]);
	                _this.HideToggleRolePopup();
	                _this.ShowSuccessPopup();
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	                _this.isLoading = false;
	                _this.HideToggleRolePopup();
	            });
	        }
	        else {
	            this.adminOfInstanceService
	                .DeleteAdminOfInstanceRole(this.instanceHashId, this.ToggleRolePersonHashID, this.ToggleRoleHashId)
	                .subscribe(function (res) {
	                if (!res.data) {
	                    _this.HideToggleRolePopup();
	                    _this.adminDependencyvalidationMessage = _this.translate.instant('LblAdminDependencyValidation');
	                    _this.adminDependencyModal.show();
	                }
	                else {
	                    _this.GetAdminOfInstanceList();
	                    _this.popupMsg = _this.translate.instant('LblRoleDeletedSuccess', [
	                        _this.ToggleUserName,
	                        _this.ToggleRoleName
	                    ]);
	                    _this.HideToggleRolePopup();
	                    _this.ShowSuccessPopup();
	                }
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	                _this.isLoading = false;
	                _this.HideToggleRolePopup();
	            });
	        }
	    };
	    //Reset company admin password
	    AdminOfInstanceListComponent.prototype.ResetPersonPassword = function (personHashID) {
	        var _this = this;
	        this.personService.ResetPersonPassword(personHashID).subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblResetPasswordSuccess');
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblResetPasswordFailure');
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AdminOfInstanceListComponent.prototype.ShowResetPasswordModal = function (personHashID) {
	        this.resetPasswordPersonHashId = personHashID;
	        this.popupMsg = this.translate.instant('LblResetPasswordConfirmation');
	        this.resetPasswordModal.show();
	    };
	    AdminOfInstanceListComponent.prototype.HideResetPasswordModal = function () {
	        this.resetPasswordPersonHashId = '';
	        this.resetPasswordModal.hide();
	    };
	    AdminOfInstanceListComponent.prototype.SuccessResetPasswordModalClick = function () {
	        this.resetPasswordModal.hide();
	        console.log(this.resetPasswordPersonHashId);
	        this.ResetPersonPassword(this.resetPasswordPersonHashId);
	    };
	    AdminOfInstanceListComponent.prototype.ResendActivationMail = function (personHashID) {
	        var _this = this;
	        this.resetPasswordPersonHashId = personHashID;
	        this.personService.ReSendActivationMail(personHashID).subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblResendActivationMailSuccess');
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblResendActivationMailFailure');
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AdminOfInstanceListComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    AdminOfInstanceListComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    AdminOfInstanceListComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    AdminOfInstanceListComponent.prototype.ShowInviteAdminModal = function () {
	        this.inviteAdminModal.availableRoles = JSON.parse(JSON.stringify(this.roleAvailabilityList));
	        this.inviteAdminModal.availablePersons = '';
	        this.inviteAdminModal.show();
	    };
	    AdminOfInstanceListComponent.prototype.HideInviteAdminModal = function () {
	        this.inviteAdminModal.hide();
	    };
	    AdminOfInstanceListComponent.prototype.SuccessInviteAdminModalClick = function ($event) {
	        var _this = this;
	        var adminInvitation = new admin_to_invite_model_1.InstanceAdminInvitationModel();
	        adminInvitation.emailAddress = $event.emailAddress;
	        adminInvitation.personHashId = $event.personHashId;
	        adminInvitation.roleHashIdList = $event.roleHashIdList;
	        adminInvitation.instanceHashId = this.instanceHashId;
	        this.adminOfInstanceService
	            .InviteAdminOfInstance(adminInvitation)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblInvitationMailSuccess');
	                _this.HideInviteAdminModal();
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.inviteAdminModal.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	            _this.HideInviteAdminModal();
	        });
	    };
	    AdminOfInstanceListComponent.prototype.SearchEmailAddress = function ($event) {
	        var _this = this;
	        var emailAddress = $event.emailAddress;
	        this.isLoading = true;
	        this.adminOfInstanceService
	            .GetPersonListToInvite(this.instanceHashId, emailAddress)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.inviteAdminModal.availablePersons = res.data;
	                _this.inviteAdminModal.errorModel = [];
	            }
	            else {
	                _this.inviteAdminModal.errorModel = res.error;
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AdminOfInstanceListComponent.prototype.CheckRole = function (existingArray, currentRole) {
	        return existingArray.some(function (x) { return x == currentRole; });
	    };
	    Object.defineProperty(AdminOfInstanceListComponent.prototype, "isResetCookieAccess", {
	        get: function () {
	            if (this.instanceAdminList) {
	                return this.instanceAdminList.some(function (x) { return !x.twoFaDisabled; });
	            }
	            else {
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AdminOfInstanceListComponent.prototype, "isTwoFaResetKeyAccess", {
	        get: function () {
	            if (this.instanceAdminList) {
	                return this.instanceAdminList.some(function (x) { return x.resetKeyEnabled; });
	            }
	            else {
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    AdminOfInstanceListComponent.prototype.ResetPersonCookies = function (personHashID) {
	        var _this = this;
	        ;
	        this.personService.ResetTwoFaCookie(personHashID).subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblCookieResetSuccess');
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblCookieResetFailed');
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AdminOfInstanceListComponent.prototype.ResetPersonTwoFA = function (personHashID) {
	        var _this = this;
	        this.personService.ResetTwoFaKey(personHashID).subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblKeyResetSuccess');
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblKeyResetFailed');
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    __decorate([
	        core_1.ViewChild('alertModal'), 
	        __metadata('design:type', Object)
	    ], AdminOfInstanceListComponent.prototype, "alertModal", void 0);
	    __decorate([
	        core_1.ViewChild('adminDependencyModal'), 
	        __metadata('design:type', Object)
	    ], AdminOfInstanceListComponent.prototype, "adminDependencyModal", void 0);
	    __decorate([
	        core_1.ViewChild('adminDependencyValidationModal'), 
	        __metadata('design:type', Object)
	    ], AdminOfInstanceListComponent.prototype, "AdminDependencyValidationModal", void 0);
	    __decorate([
	        core_1.ViewChild('resetPasswordModal'), 
	        __metadata('design:type', Object)
	    ], AdminOfInstanceListComponent.prototype, "resetPasswordModal", void 0);
	    __decorate([
	        core_1.ViewChild('inActiveModal'), 
	        __metadata('design:type', Object)
	    ], AdminOfInstanceListComponent.prototype, "inActiveModal", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], AdminOfInstanceListComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild('toggleRolePopup'), 
	        __metadata('design:type', Object)
	    ], AdminOfInstanceListComponent.prototype, "toggleRolePopup", void 0);
	    __decorate([
	        core_1.ViewChild('inviteAdminModal'), 
	        __metadata('design:type', Object)
	    ], AdminOfInstanceListComponent.prototype, "inviteAdminModal", void 0);
	    AdminOfInstanceListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-admin-of-instance',
	            template: __webpack_require__(967),
	            providers: [admin_of_instance_service_1.AdminOfInstanceService, person_service_1.PersonService, instance_service_1.InstanceService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof admin_of_instance_service_1.AdminOfInstanceService !== 'undefined' && admin_of_instance_service_1.AdminOfInstanceService) === 'function' && _a) || Object, (typeof (_b = typeof person_service_1.PersonService !== 'undefined' && person_service_1.PersonService) === 'function' && _b) || Object, (typeof (_c = typeof instance_service_1.InstanceService !== 'undefined' && instance_service_1.InstanceService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object, (typeof (_e = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _f) || Object, (typeof (_g = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _g) || Object])
	    ], AdminOfInstanceListComponent);
	    return AdminOfInstanceListComponent;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.AdminOfInstanceListComponent = AdminOfInstanceListComponent;


/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var jquery_helper_service_1 = __webpack_require__(67);
	var AdminOfInstanceService = (function () {
	    function AdminOfInstanceService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	        this.JQueryHelper = new jquery_helper_service_1.JQueryHelperService();
	    }
	    AdminOfInstanceService.prototype.GetAdminOfInstanceList = function (instanceHashID, input) {
	        var getInstanceAdminUrl = config_1.WeGoConfig.API_GET_ADMIN_OF_INSTANCE_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getInstanceAdminUrl = getInstanceAdminUrl + "?" + queryString + "&instanceHashID=" + instanceHashID;
	        }
	        else {
	            getInstanceAdminUrl = getInstanceAdminUrl + "?instanceHashID=" + instanceHashID;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getInstanceAdminUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminOfInstanceService.prototype.DeleteAdminOfInstance = function (instanceHashID, selectedAdminOfCustomerList) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        var urlDeleteAdminOfInstance = config_1.WeGoConfig.API_POST_DELETE_ADMIN_OF_INSTANCE + "?instanceHashId=" + instanceHashID;
	        return this.http.post(urlDeleteAdminOfInstance, selectedAdminOfCustomerList, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminOfInstanceService.prototype.ExportAdminOfInstanceList = function (instanceHashID, input) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var exportToCSVInstanceAdminUrl = config_1.WeGoConfig.API_EXPORT_ADMIN_OF_INSTANCE_LIST + "?" + queryString + "&instanceHashID=" + instanceHashID;
	        var headers = this.authService.GetHeader('text/csv');
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(exportToCSVInstanceAdminUrl, options);
	    };
	    AdminOfInstanceService.prototype.GetAllRoleAvailability = function (input, instanceHashID) {
	        var getRoleAvailabilityListUrl = config_1.WeGoConfig.API_GET_INSTANCE_ROLEAVAILABILITY_LIST + "?instanceHashID=" + instanceHashID;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getRoleAvailabilityListUrl = getRoleAvailabilityListUrl + "&" + queryString;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getRoleAvailabilityListUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminOfInstanceService.prototype.DeleteAdminOfInstanceRole = function (instanceHashID, personHashId, roleHashId) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        var urlDeleteAdminOfInstance = config_1.WeGoConfig.API_POST_DELETE_ADMIN_OF_INSTANCE_ROLE + "?instanceHashID=" + instanceHashID + "&personHashId=" + personHashId + "&roleHashId=" + roleHashId;
	        return this.http.get(urlDeleteAdminOfInstance, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminOfInstanceService.prototype.AddAdminOfInstanceRole = function (instanceHashID, personHashId, roleHashId) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        var urlAddAdminOfInstance = config_1.WeGoConfig.API_POST_ADD_ADMIN_OF_INSTANCE_ROLE + "?instanceHashID=" + instanceHashID + "&personHashId=" + personHashId + "&roleHashId=" + roleHashId;
	        ;
	        return this.http.get(urlAddAdminOfInstance, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminOfInstanceService.prototype.GetPersonListToInvite = function (instanceHashID, emailAddress) {
	        var getComapanyAdminUrl = config_1.WeGoConfig.API_GET_INSTANCE_PERSON_TO_INVITE_LIST;
	        getComapanyAdminUrl = getComapanyAdminUrl + "?instanceHashID=" + instanceHashID + "&emailAddress=" + emailAddress;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getComapanyAdminUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminOfInstanceService.prototype.InviteAdminOfInstance = function (customerAdminInvitationModel) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        var urlInviteAdminOfCustomer = config_1.WeGoConfig.API_POST_INVITE_ADMIN_OF_INSTANCE;
	        return this.http.post(urlInviteAdminOfCustomer, customerAdminInvitationModel, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminOfInstanceService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], AdminOfInstanceService);
	    return AdminOfInstanceService;
	    var _a, _b;
	}());
	exports.AdminOfInstanceService = AdminOfInstanceService;


/***/ },
/* 967 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ breadCrumbList}} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"urlInstanceList\">\r\n            <i class=\"fa fa-user-circle fa-fw\"></i> {{instanceList }}</a>\r\n        </li>\r\n        <li class=\"active\"> {{ breadCrumbList}} </li>\r\n\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25 \">\r\n      <!-- <a class=\"btn btn-highlight navbar-right\" (click)=\"ShowAddInstanceAdminModal()\">{{ 'LblInvite' | translate }}</a> -->\r\n      <wego-authorized-link [LinkModel]=\"addInstanceAdminLink\" (onClick)=\"ShowAddInstanceAdminModal()\"></wego-authorized-link>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <h4>\r\n          <label>{{ 'LblInstance' | translate }} : </label> {{instanceName}}</h4>\r\n        <p class=\"text-success\">{{ message }}</p>\r\n        <wego-search-list [IsDeleted]=\"isDeleteAccess\" [IsDeleteEnabled]=\"isAnyChecked\" (OnDeleteAll)=\"ShowAlertModal()\"\r\n          (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\"\r\n          [SearchTerm]=\"DataListModel.searchTerm\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center parent-checkbox\">\r\n                  <input [disabled]=\"!isDeleteAccess\" type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\"\r\n                    (change)=\"OnParentCheck($event.target.checked)\">\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('firstName')\">\r\n                  {{ 'LblFirstName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'firstName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('lastName')\">\r\n                  {{ 'LblLastName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'lastName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('userName')\">\r\n                  {{ 'LblUserName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'userName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th *ngIf=\"isResetCookieAccess\" class=\"text-center\">{{ 'LblResetCookie' |\r\n                  translate }}</th>\r\n                <th *ngIf=\"isTwoFaResetKeyAccess\" class=\"text-center\">{{ 'LblResetTwoFA' |\r\n                  translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblResetPassword' | translate }}</th>\r\n                <th *ngFor=\"let role of roleAvailabilityList\" class=\"text-center\">\r\n                  {{role.presentationName}}\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let instanceAdmin of instanceAdminList\">\r\n                  <td class=\"text-center\">\r\n                    <input *ngIf=\"!instanceAdmin.isDeletable\" type=\"checkbox\" name=\"isActive\" disabled>\r\n                    <input *ngIf=\"instanceAdmin.isDeletable\" type=\"checkbox\" name=\"isActive\" [(ngModel)]=\"instanceAdmin.isChecked\">\r\n                  </td>\r\n                  <td>{{ instanceAdmin.firstName }}</td>\r\n                  <td>{{ instanceAdmin.lastName }}</td>\r\n                  <td>{{ instanceAdmin.userName }}</td>\r\n                  <td class=\"text-center\" *ngIf=\"isResetCookieAccess\">\r\n                    <a *ngIf=\"!instanceAdmin.twoFaDisabled\" class=\"btn btn-green btn-xs cursor-pointer\" (click)=\"ResetPersonCookies(instanceAdmin.personMasterHashId)\">\r\n                      {{ 'LblResetCookie' | translate}}\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\" *ngIf=\"isTwoFaResetKeyAccess\">\r\n                    <a *ngIf=\"instanceAdmin.resetKeyEnabled\" class=\"btn btn-green btn-xs cursor-pointer\" (click)=\"ResetPersonTwoFA(instanceAdmin.personMasterHashId)\">\r\n                      {{ 'LblResetTwoFA' | translate}}\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a class=\"cursor-pointer\">\r\n                      <i class=\"fa fa-refresh fa-fw text-success\" (click)=\"ShowResetPasswordModal(instanceAdmin.personMasterHashId)\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td *ngFor=\"let role of roleAvailabilityList\" class=\"text-center\">\r\n                    <a [ngClass]=\"{ 'cursor-pointer': instanceAdmin.isEditable }\" class=\"cursor-pointer\">\r\n                      <i *ngIf=\"!instanceAdmin.isEditable\" class=\"fa fa-fw\" [ngClass]=\"{ 'fa-check text-success': CheckRole(instanceAdmin.rolesHashIds, role.roleHashId), \r\n                    'fa-times text-danger' : !CheckRole(instanceAdmin.rolesHashIds, role.roleHashId) }\"></i>\r\n                      <i *ngIf=\"instanceAdmin.isEditable\" class=\"fa fa-fw\" (click)=\"ToggleRoleAvailibility(instanceAdmin.personMasterHashId,role.roleHashId,instanceAdmin.rolesHashIds,role.presentationName,instanceAdmin.userName)\"\r\n                        [ngClass]=\"{ 'fa-check text-success': CheckRole(instanceAdmin.rolesHashIds, role.roleHashId), \r\n                    'fa-times text-danger' : !CheckRole(instanceAdmin.rolesHashIds, role.roleHashId) }\"></i>\r\n                    </a>\r\n                  </td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" [attr.colspan]=\"5+roleColumns\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\"\r\n                [(ngModel)]=\"DataListModel.currentPage\" [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\"\r\n                previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\" lastText=\"&raquo;\" [rotate]=\"false\"\r\n                (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<wego-confirm-popup #alertModal [popupMsg]=\"deleteMessage\" (onConfirm)=\"SuccessAlertModalClick()\" (onReject)=\"HideAlertModal()\"></wego-confirm-popup>\r\n\r\n<wego-confirm-popup #resetPasswordModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessResetPasswordModalClick()\" (onReject)=\"HideResetPasswordModal()\"></wego-confirm-popup>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" [popupTitle]=\"popupTitle\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n\r\n<wego-confirm-popup #toggleRolePopup [popupMsg]=\"toggleRoleMsg\" (onConfirm)=\"ConfirmToggleRolePopup()\" (onReject)=\"HideToggleRolePopup()\"></wego-confirm-popup>\r\n\r\n<wego-invite-admin-popup #inviteAdminModal [popupTitle]=\"inviteTitle\" (onEmailSearch)=\"SearchEmailAddress($event)\"\r\n  (onConfirm)=\"SuccessInviteAdminModalClick($event)\" (onReject)=\"HideInviteAdminModal()\"></wego-invite-admin-popup>\r\n\r\n<wego-success-popup #adminDependencyModal [popupTitle]=\"adminDependencyModelTitle\" [popupMsg]=\"adminDependencyvalidationMessage\"\r\n  (onConfirm)=\"SuccessAdminDependencyModalClick()\"></wego-success-popup>";

/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var flatpickr_model_1 = __webpack_require__(83);
	var admin_invitation_service_1 = __webpack_require__(969);
	var admin_invitation_model_1 = __webpack_require__(970);
	var terms_condition_popup_service_1 = __webpack_require__(639);
	var privacy_popup_service_1 = __webpack_require__(640);
	var AdminInvitationComponent = (function () {
	    function AdminInvitationComponent(adminInvitationService, activeRoute, router, authService, translate, termsConditionPopup, privacyPopup) {
	        this.adminInvitationService = adminInvitationService;
	        this.activeRoute = activeRoute;
	        this.router = router;
	        this.authService = authService;
	        this.translate = translate;
	        this.termsConditionPopup = termsConditionPopup;
	        this.privacyPopup = privacyPopup;
	        this.allTNCList = [];
	        this.isBodyContent = false;
	        this.isPrivacyBodyContent = false;
	        this.submitted = false;
	        this.isPageLoad = false;
	        this.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_FORMAT;
	    }
	    AdminInvitationComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.isPageLoad = false;
	        this.isLoading = true;
	        this.translate.setDetectedLang();
	        this.popupTitle = this.translate.instant("LblError");
	        this.popupMsg = this.translate.instant("LblCommonErrorMessage");
	        this.flatPickrConfigDateOfBirth = this.SetDefaultFlatPickrConfig();
	        this.model = new admin_invitation_model_1.AdminInvitationProfileModel();
	        this.GetTelephoneCountry();
	        this.sub = this.activeRoute.params.subscribe(function (params) {
	            _this.activationCode = params["activationCode"] || "";
	            _this.rejectionCode = params["rejectionCode"] || "";
	            if (_this.activationCode != "") {
	                _this.adminInvitationService
	                    .CheckActivationCodeIsValid(_this.activationCode)
	                    .subscribe(function (res) {
	                    if (res.data) {
	                        _this.adminInvitationService
	                            .CheckPersonExistByActivationCode(_this.activationCode)
	                            .subscribe(function (res) {
	                            if (res.data != null) {
	                                _this.model.countryCode1 = res.data.countryCode;
	                                _this.model.countryCode2 = res.data.countryCode;
	                                if (res.data.status == "Found") {
	                                    _this.adminInvitationService
	                                        .CheckPersonRoleExistByActivationCode(_this.activationCode)
	                                        .subscribe(function (res) {
	                                        if (res.data) {
	                                            _this.adminInvitationService
	                                                .InvitationAccepted(_this.activationCode)
	                                                .subscribe(function (res) {
	                                                if (res.data) {
	                                                    _this.router.navigate([
	                                                        "/invitationaccept"
	                                                    ]);
	                                                }
	                                                else {
	                                                    _this.router.navigate([
	                                                        "/Linkexpired"
	                                                    ]);
	                                                }
	                                                _this.isPageLoad = true;
	                                                _this.isLoading = false;
	                                            }, function (error) {
	                                                _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	                                                _this.message = error;
	                                                _this.HandleError();
	                                            });
	                                        }
	                                        else {
	                                            _this.router.navigate([
	                                                "/personprofile",
	                                                {
	                                                    activationCode: _this.activationCode
	                                                }
	                                            ]);
	                                        }
	                                    }, function (error) {
	                                        _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	                                        _this.message = error;
	                                        _this.HandleError();
	                                    });
	                                }
	                                else {
	                                    _this.model.emailAddressModel.email = res.data.email;
	                                    _this.model.validateLiceanceNumber =
	                                        res.data.licenceRequired;
	                                    _this.isDriver = res.data.isDriver;
	                                    _this.isPageLoad = true;
	                                    ChangeBranding("", "", _this.activationCode);
	                                    _this.isLoading = false;
	                                }
	                            }
	                        }, function (error) {
	                            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	                            _this.message = error;
	                            _this.HandleError();
	                        });
	                    }
	                    else {
	                        _this.router.navigate(["/Linkexpired"]);
	                        _this.isPageLoad = true;
	                        _this.isLoading = false;
	                    }
	                }, function (error) {
	                    _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	                    _this.message = error;
	                    _this.HandleError();
	                });
	            }
	            else if (_this.rejectionCode != "") {
	                _this.adminInvitationService
	                    .InvitationRejected(_this.rejectionCode)
	                    .subscribe(function (res) {
	                    if (res.data) {
	                        _this.router.navigate(["/invitationreject"]);
	                    }
	                    else {
	                        _this.router.navigate(["/Linkexpired"]);
	                    }
	                    _this.isPageLoad = true;
	                    _this.isLoading = false;
	                }, function (error) {
	                    _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	                    _this.message = error;
	                    _this.HandleError();
	                });
	            }
	        });
	        this.GetTermsConditionByActivationCode(this.activationCode);
	        this.GetPrivacyByPersonActivationCode(this.activationCode);
	    };
	    AdminInvitationComponent.prototype.SetDefaultFlatPickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = false;
	        flatPickrConfig.time_24hr = false;
	        flatPickrConfig.dateFormat = this.dateFormat;
	        flatPickrConfig.minuteIncrement = 1;
	        flatPickrConfig.maxDate = new Date();
	        return flatPickrConfig;
	    };
	    AdminInvitationComponent.prototype.HandleError = function () {
	        this.isPageLoad = true;
	        this.isLoading = false;
	        this.ShowSuccessPopup();
	    };
	    AdminInvitationComponent.prototype.onSubmit = function (forms) {
	        this.submitted = true;
	        this.model.approvalCode = this.activationCode;
	        this.model.isDriver = this.isDriver;
	        this.AddPersonProfile();
	    };
	    AdminInvitationComponent.prototype.AddPersonProfile = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.model.termsAndConditionsHashId = this.termsAndConditionHashId;
	        this.model.privacyHashId = this.privacyHashId;
	        this.model.allTermsConditionsList = this.allTNCList;
	        this.adminInvitationService.AddPersonProfile(this.model).subscribe(function (res) {
	            if (res.data) {
	                //ChangeBranding();
	                _this.router.navigate(["/"]);
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	            _this.ShowSuccessPopup();
	        });
	    };
	    AdminInvitationComponent.prototype.GetTelephoneCountry = function () {
	        var _this = this;
	        this.authService.GetTelephoneCountry().subscribe(function (res) {
	            _this.countryList = res.data;
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    AdminInvitationComponent.prototype.showTnC = function (bodyHTMLText) {
	        this.termsConditionModel.show(bodyHTMLText);
	    };
	    AdminInvitationComponent.prototype.showPrivacyStatement = function () {
	        this.privacyModel.show(this.privacyBodyHTMLText);
	    };
	    AdminInvitationComponent.prototype.ShowSuccessPopup = function () {
	        this.errorSuccessPopup.show();
	    };
	    AdminInvitationComponent.prototype.HideSuccessPopup = function () {
	        this.errorSuccessPopup.hide();
	        this.RedirectToHomePage();
	    };
	    AdminInvitationComponent.prototype.ConfirmSuccessPopup = function () {
	        this.errorSuccessPopup.hide();
	        this.RedirectToHomePage();
	    };
	    AdminInvitationComponent.prototype.RedirectToHomePage = function () {
	        this.router.navigate(["/"]);
	    };
	    AdminInvitationComponent.prototype.SuccessModalClick = function () {
	        this.termsConditionModel.hide();
	    };
	    AdminInvitationComponent.prototype.GetTermsConditionByActivationCode = function (activationCode) {
	        var _this = this;
	        this.termsConditionPopup
	            .GetTermsAndConditionsByActivationCode(activationCode)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.allTNCList = res.data;
	            }
	            else {
	                _this.errorMessage = res.error;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    AdminInvitationComponent.prototype.GetPrivacyByPersonActivationCode = function (activationCode) {
	        var _this = this;
	        this.termsConditionPopup
	            .GetPrivacyStatementsByActivationCode(activationCode)
	            .subscribe(function (res) {
	            if (res.data && res.data.content) {
	                _this.privacyBodyHTMLText = res.data.content;
	                if (res.data.content) {
	                    _this.isPrivacyBodyContent = true;
	                }
	                _this.privacyHashId = res.data.termsAndConditionsHashId;
	            }
	            else {
	                _this.errorMessage = res.error;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    AdminInvitationComponent.prototype.ngOnDestroy = function () {
	        ChangeBranding();
	        if (this.sub) {
	            this.sub.unsubscribe();
	        }
	    };
	    __decorate([
	        core_1.ViewChild("errorSuccessPopup"), 
	        __metadata('design:type', Object)
	    ], AdminInvitationComponent.prototype, "errorSuccessPopup", void 0);
	    __decorate([
	        core_1.ViewChild("termsConditionModel"), 
	        __metadata('design:type', Object)
	    ], AdminInvitationComponent.prototype, "termsConditionModel", void 0);
	    __decorate([
	        core_1.ViewChild("privayStatementModel"), 
	        __metadata('design:type', Object)
	    ], AdminInvitationComponent.prototype, "privacyModel", void 0);
	    AdminInvitationComponent = __decorate([
	        core_1.Component({
	            selector: "wego-admin-invitation",
	            template: __webpack_require__(971),
	            providers: [
	                admin_invitation_service_1.AdminInvitationService,
	                terms_condition_popup_service_1.TermsConditionPopup,
	                privacy_popup_service_1.PrivacyStatementPopup
	            ],
	            styles: [
	                ".main-header {\n        margin-top:0px !important;\n      }\n      .input-group.telephone-group .input-group-addon {\n        padding: 0px;\n        border: 0px;\n      }\n      .country-select {\n        width: 60px;\n        border: 1px solid #d2d6de;\n        padding: 3px;\n      }\n    "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof admin_invitation_service_1.AdminInvitationService !== 'undefined' && admin_invitation_service_1.AdminInvitationService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _d) || Object, (typeof (_e = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _e) || Object, (typeof (_f = typeof terms_condition_popup_service_1.TermsConditionPopup !== 'undefined' && terms_condition_popup_service_1.TermsConditionPopup) === 'function' && _f) || Object, (typeof (_g = typeof privacy_popup_service_1.PrivacyStatementPopup !== 'undefined' && privacy_popup_service_1.PrivacyStatementPopup) === 'function' && _g) || Object])
	    ], AdminInvitationComponent);
	    return AdminInvitationComponent;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.AdminInvitationComponent = AdminInvitationComponent;


/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var AdminInvitationService = (function () {
	    function AdminInvitationService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    AdminInvitationService.prototype.CheckActivationCodeIsValid = function (activationCode) {
	        var getPersonUrl = config_1.WeGoConfig.API_GET_CHECK_ADMIN_VALID_ACTIVATION_CODE +
	            "?activationCode=" +
	            activationCode;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getPersonUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminInvitationService.prototype.CheckPersonExistByActivationCode = function (activationCode) {
	        var getPersonUrl = config_1.WeGoConfig.API_GET_CHECK_ADMIN_USER_EXIST_BY_ACTIVATION_CODE +
	            "?activationCode=" +
	            activationCode;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getPersonUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminInvitationService.prototype.CheckPersonRoleExistByActivationCode = function (activationCode) {
	        var getPersonUrl = config_1.WeGoConfig.API_GET_CHECK_ADMIN_USER_ROLE_EXIST_BY_ACTIVATION_CODE +
	            "?activationCode=" +
	            activationCode;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getPersonUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminInvitationService.prototype.InvitationRejected = function (rejectionCode) {
	        var getPersonUrl = config_1.WeGoConfig.API_GET_REJECT_ADMIN_INVITATION_BY_REJECTION_CODE +
	            "?rejectionCode=" +
	            rejectionCode;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getPersonUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminInvitationService.prototype.InvitationAccepted = function (activationCode) {
	        var getPersonUrl = config_1.WeGoConfig.API_GET_ACCEPT_ADMIN_INVITATION_BY_APPROVAL_CODE +
	            "?activationCode=" +
	            activationCode;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getPersonUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminInvitationService.prototype.AddPersonProfile = function (personModel) {
	        var body = personModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_ADMIN_ADD_DETAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminInvitationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], AdminInvitationService);
	    return AdminInvitationService;
	    var _a, _b;
	}());
	exports.AdminInvitationService = AdminInvitationService;


/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var personprofile_model_1 = __webpack_require__(637);
	var AdminInvitationProfileModel = (function () {
	    function AdminInvitationProfileModel() {
	        this.countryCode1 = "";
	        this.countryCode2 = "";
	        this.validateLiceanceNumber = false;
	        this.isAccepted = false;
	        this.isPrivacyStatementAccepted = false;
	        this.allTermsConditionsList = [];
	        this.emailAddressModel = new personprofile_model_1.EmailAddressModel();
	        this.allTermsConditionsList = [];
	    }
	    return AdminInvitationProfileModel;
	}());
	exports.AdminInvitationProfileModel = AdminInvitationProfileModel;


/***/ },
/* 971 */
/***/ function(module, exports) {

	module.exports = "<div class=\"no-role\">\r\n  <template [ngIf]=\"isPageLoad\">\r\n    <div class=\"ui-skins sidebar-mini\">\r\n      <header class=\"main-header\">\r\n        <a href=\"javascript:void(0)\" class=\"logo\">\r\n          <div class=\"logo-mini\"></div>\r\n          <!-- logo for regular state and mobile devices -->\r\n          <div class=\"logo-lg\">\r\n\r\n          </div>\r\n        </a>\r\n        <nav class=\"navbar navbar-static-top\">\r\n        </nav>\r\n      </header>\r\n      <div class=\"container\">\r\n        <section class=\"content-header\" style=\"margin-top: 60px;\">\r\n\r\n          <div class=\"clearfix\"></div>\r\n          <div class=\"clearfix\"></div>\r\n        </section>\r\n        <fieldset>\r\n          <section class=\"content\">\r\n            <p class=\"text-success\">{{ message }}</p>\r\n            <div class=\"nopad\">\r\n              <form (ngSubmit)=\"onSubmit(UpdatePersonProfile.value)\" #UpdatePersonProfile=\"ngForm\">\r\n\r\n                <div class=\"form-group col-md-4\">\r\n                  <label>\r\n                    <span class=\"text text-danger\">*</span>{{ 'LblUserName' | translate }}\r\n                  </label>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblUserName' | translate }}\" [(ngModel)]=\"model.userName\" name=\"UserName\"\r\n                    maxlength=\"100\">\r\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'userName' }}</span>\r\n                </div>\r\n\r\n\r\n                <div class=\"form-group col-md-4\">\r\n                  <label>\r\n                    <span class=\"text text-danger\">*</span>{{ 'LblPassword' | translate }}\r\n                  </label>\r\n                  <input type=\"password\" class=\"form-control\" placeholder=\"{{ 'LblPassword' | translate }}\" [(ngModel)]=\"model.personPassword\"\r\n                    name=\"PersonPassword\" maxlength=\"100\">\r\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'personPassword' }}</span>\r\n                </div>\r\n\r\n\r\n                <div class=\"form-group col-md-4\">\r\n                  <label>\r\n                    <span class=\"text text-danger\">*</span>{{ 'LblConfirmPassword' | translate }}\r\n                  </label>\r\n                  <input type=\"password\" class=\"form-control\" placeholder=\"{{ 'LblConfirmPassword' | translate }}\" [(ngModel)]=\"model.personConfirmPassword\"\r\n                    name=\"PersonConfirmPassword\" maxlength=\"100\">\r\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'personConfirmPassword' }}</span>\r\n                </div>\r\n\r\n                <div class=\"clearfix\"></div>\r\n\r\n                <div class=\"form-group col-md-4\">\r\n                  <label>\r\n                    <span class=\"text text-danger\">*</span>{{ 'LblFirstName' | translate }}\r\n                  </label>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblFirstName' | translate }}\" [(ngModel)]=\"model.firstName\" name=\"FirstName\"\r\n                    maxlength=\"100\">\r\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'firstName' }}</span>\r\n                </div>\r\n\r\n                <div class=\"form-group col-md-4\">\r\n                  <label>\r\n                    <span class=\"text text-danger\"></span>{{ 'LblMiddleName' | translate }}\r\n                  </label>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblMiddleName' | translate }}\" [(ngModel)]=\"model.middleName\" name=\"MiddleName\"\r\n                    maxlength=\"100\">\r\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'middleName' }}</span>\r\n                </div>\r\n\r\n                <div class=\"form-group col-md-4\">\r\n                  <label>\r\n                    <span class=\"text text-danger\">*</span>{{ 'LblLastName' | translate }}\r\n                  </label>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblLastName' | translate }}\" [(ngModel)]=\"model.lastName\" name=\"LastName\"\r\n                    maxlength=\"100\">\r\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'lastName' }}</span>\r\n                </div>\r\n                <div class=\"clearfix\"></div>\r\n\r\n                <div class=\"form-group col-md-4\">\r\n                  <label>\r\n                    <span class=\"text text-danger\">*</span>{{ 'LblEmail' | translate }}\r\n                  </label>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblEmail' | translate }}\" [ngModel]=\"model.emailAddressModel.email\"\r\n                    name=\"Email\" maxlength=\"100\" readonly>\r\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'emailAddressModel.email' }}</span>\r\n                </div>\r\n\r\n                <div class=\"form-group col-md-4\">\r\n                  <label>\r\n                    <span class=\"text text-danger\">*</span>{{ 'LblMobileNumber' | translate }}\r\n                  </label>\r\n                  <div class=\"input-group telephone-group\">\r\n                    <span class=\"input-group-addon\">\r\n                      <select [(ngModel)]=\"model.countryCode1\" class=\"form-control country-select\" name=\"countryCode1\">\r\n                        <option value=\"\">-</option>\r\n                        <option *ngFor=\"let item of countryList\" [ngValue]=\"item.value\">{{ item.value }}</option>\r\n                      </select>\r\n                    </span>\r\n                    <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblMobileNumber' | translate }}\" [(ngModel)]=\"model.telephone1\"\r\n                      name=\"telephone1\" maxlength=\"20\">\r\n                  </div>\r\n                  <div class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'countryCode1' }}</div>\r\n                  <div class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'telephone1' }}</div>\r\n                </div>\r\n                <div class=\"form-group col-md-4\">\r\n                  <label>\r\n                    {{ 'LblPhoneNumber' | translate }}\r\n                  </label>\r\n                  <div class=\"input-group telephone-group\">\r\n                    <span class=\"input-group-addon\">\r\n                      <select [(ngModel)]=\"model.countryCode2\" class=\"form-control country-select\" name=\"countryCode2\">\r\n                        <option value=\"\">-</option>\r\n                        <option *ngFor=\"let item of countryList\" [ngValue]=\"item.value\">{{ item.value }}</option>\r\n                      </select>\r\n                    </span>\r\n                    <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblPhoneNumber' | translate }}\" [(ngModel)]=\"model.telephone2\" name=\"telephone2\"\r\n                      maxlength=\"20\">\r\n                  </div>\r\n                  <div class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'countryCode2' }}</div>\r\n                  <div class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'telephone2' }}</div>\r\n                </div>\r\n                <div class=\"clearfix\"></div>\r\n                <div *ngIf=\"model.validateLiceanceNumber\" class=\"form-group col-md-4\">\r\n                  <label>\r\n                    <span class=\"text text-danger\">*</span> {{ 'LblDateOfBirth' | translate }}</label>\r\n                  <div class=\"input-group\">\r\n                    <span class=\"input-group-addon\">\r\n                      <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n                    </span>\r\n                    <input [disabled]=\"isDateOfBirth\" class=\"form-control\" [Config]=\"flatPickrConfigDateOfBirth\" placeholder=\"{{ 'LblDateOfBirth' | translate }}\"\r\n                      [(ngModel)]=\"model.dateOfBirth\" name=\"dateOfBirth\" flatpickr readonly>\r\n                  </div>\r\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'dateOfBirth' }}</span>\r\n                </div>\r\n                <div *ngIf=\"model.validateLiceanceNumber\" class=\"form-group col-md-4\">\r\n                  <label>\r\n                    <span class=\"text text-danger\">*</span> {{ 'LblDriverLicenceNumber' | translate }}\r\n                  </label>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblDriverLicenceNumber' | translate }}\" [(ngModel)]=\"model.driverLicenceNumber\"\r\n                    name=\"driverLicenceNumber\" maxlength=\"20\" [attr.readonly]=\"!model.liceanceNumberValidated?null:''\">\r\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'driverLicenceNumber' }}</span>\r\n                </div>\r\n                <div class=\"clearfix\"></div>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'termsConditionError' }}</span>\r\n                <div *ngFor=\"let item of allTNCList\" class=\"row no-margin\">\r\n                  <div class=\"col-md-4 form-group checkbox\">\r\n                    <span class=\"text text-danger\">*</span>\r\n                    <label>\r\n                      <input type=\"checkbox\" name=\"item.termsAndConditionHashId\" [(ngModel)]=\"item.accepted\">{{ 'LblReadAndAgree' | translate }}\r\n                    </label>\r\n                    <a class=\"cursor-pointer\" (click)=\"showTnC(item.content)\">{{ 'LblTermsAndCondition' | translate }}\r\n                      <span *ngIf=\"item.entityName\">({{ item.entityName }})</span>\r\n                    </a>\r\n                  </div>\r\n                </div>\r\n                <div class=\"clearfix\"></div>\r\n                <div class=\"row no-margin\">\r\n                  <div class=\"form-group col-md-4 checkbox\" *ngIf=\"isDriver && isPrivacyBodyContent\">\r\n                    <span class=\"text text-danger\">*</span>\r\n                    <label>\r\n                      <input type=\"checkbox\" name=\"model.isPrivacyStatementAccepted\" [(ngModel)]=\"model.isPrivacyStatementAccepted\">{{ 'LblReadAndAgree' | translate }}\r\n                    </label>\r\n                    <a class=\"cursor-pointer\" (click)=\"showPrivacyStatement()\">{{ 'LblPrivacyStatements' | translate }}</a>\r\n                    <br/>\r\n                    <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'isPrivacyStatementAccepted' }}</span>\r\n                  </div>\r\n                </div>\r\n\r\n                <div class=\"page-border-bottom mar_t_15\">Border bottom shadow</div>\r\n                <div class=\"clearfix\"></div>\r\n                <div class=\"container mar_t_25\">\r\n                  <button class=\"btn btn-highlight mar_left_10\" type=\"submit\">{{ 'LblSave' | translate }}</button>\r\n                </div>\r\n              </form>\r\n            </div>\r\n          </section>\r\n        </fieldset>\r\n      </div>\r\n    </div>\r\n  </template>\r\n</div>\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n<wego-success-popup #errorSuccessPopup [popupMsg]=\"popupMsg\" [popupTitle]=\"popupTitle\" (onConfirm)=\"RedirectToHomePage()\"></wego-success-popup>\r\n<wego-terms-condition-popup #termsConditionModel></wego-terms-condition-popup>\r\n<wego-privacy-popup #privayStatementModel></wego-privacy-popup>";

/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var index_1 = __webpack_require__(631);
	var AdminInvitationAcceptComponent = (function () {
	    function AdminInvitationAcceptComponent(translate) {
	        this.translate = translate;
	    }
	    AdminInvitationAcceptComponent.prototype.ngOnInit = function () { };
	    AdminInvitationAcceptComponent.prototype.ngOnDestroy = function () {
	        console.log("ngOnDestroy");
	    };
	    AdminInvitationAcceptComponent = __decorate([
	        core_1.Component({
	            selector: "admin-invitation-accept",
	            template: "\n  <section class=\"content\">\n\t\t<div class=\"col-md-12 text-center\">\n      <div class=\"panel panel-success\">\n      <div class=\"panel-heading\">\n      {{ 'LblInvitationSuccess' | translate }}\n      </div>\n      <div class=\"panel-body\">\n      <p>\n      <span> {{'LblThankYouForAcceptingInvitation' | translate}} </span><br>\n      <span> {{'LblPleaseClick' | translate}} </span> \n      <a routerLink=\"/\">{{ 'LblHere' | translate }}</a> \n      <span> {{ 'LblToLogin' | translate}}</span>\n      </p>\n      </div>\n    </div>\n         \n\t\t</div>\n  </section>\n  ",
	            styles: [
	                ".headerror {\n                font-size: 150px !important;\n                font-weight: normal;\n                line-height: 100px;\n                margin-top: 50px;\n                color: #2ba2aa;\n          }"
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof index_1.TranslateService !== 'undefined' && index_1.TranslateService) === 'function' && _a) || Object])
	    ], AdminInvitationAcceptComponent);
	    return AdminInvitationAcceptComponent;
	    var _a;
	}());
	exports.AdminInvitationAcceptComponent = AdminInvitationAcceptComponent;


/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var index_1 = __webpack_require__(631);
	var AdminInvitationRejectComponent = (function () {
	    function AdminInvitationRejectComponent(translate) {
	        this.translate = translate;
	    }
	    AdminInvitationRejectComponent.prototype.ngOnInit = function () { };
	    AdminInvitationRejectComponent.prototype.ngOnDestroy = function () {
	        console.log("ngOnDestroy");
	    };
	    AdminInvitationRejectComponent = __decorate([
	        core_1.Component({
	            selector: "admin-invitation-reject",
	            template: "\n  <section class=\"content\">\n\t\t<div class=\"col-md-12 text-center\">\n      <div class=\"panel panel-danger\">\n      <div class=\"panel-heading\">\n      {{ 'LblInvitationReject' | translate }}\n      </div>\n      <div class=\"panel-body\">\n      <p>\n      <span>{{ 'LblThankYouForConfirmation' | translate }}</span><br>\n      <span> {{ 'LblPleaseClick' | translate }} </span> <a routerLink=\"/\">{{ 'LblHere' | translate }}</a>\n      <span> {{ 'LblGoToHome' | translate }}</span>\n      </p>\n      </div>\n    </div>\n         \n\t\t</div>\n  </section>\n  ",
	            styles: [
	                ".headerror {\n                font-size: 150px !important;\n                font-weight: normal;\n                line-height: 100px;\n                margin-top: 50px;\n                color: #2ba2aa;\n          }"
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof index_1.TranslateService !== 'undefined' && index_1.TranslateService) === 'function' && _a) || Object])
	    ], AdminInvitationRejectComponent);
	    return AdminInvitationRejectComponent;
	    var _a;
	}());
	exports.AdminInvitationRejectComponent = AdminInvitationRejectComponent;


/***/ },
/* 974 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var person_service_1 = __webpack_require__(771);
	var admin_of_company_service_1 = __webpack_require__(975);
	var company_service_1 = __webpack_require__(501);
	var admin_to_invite_model_1 = __webpack_require__(963);
	var AdminOfCompanyListComponent = (function () {
	    function AdminOfCompanyListComponent(adminOfCompanyService, personService, companyService, activeRoute, authService, router, translate) {
	        this.adminOfCompanyService = adminOfCompanyService;
	        this.personService = personService;
	        this.companyService = companyService;
	        this.activeRoute = activeRoute;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.roleColumns = 0;
	    }
	    Object.defineProperty(AdminOfCompanyListComponent.prototype, "isAnyChecked", {
	        get: function () {
	            if (this.companyAdminList) {
	                var isCheck = this.companyAdminList.some(function (x) { return x.isChecked == true; });
	                if (isCheck) {
	                    if (this.companyAdminList.every(function (x) { return x.isChecked == true; }))
	                        this.isParentCheck = true;
	                    else
	                        this.isParentCheck = false;
	                }
	                else {
	                    this.isParentCheck = false;
	                }
	                return isCheck;
	            }
	            else {
	                this.isParentCheck = false;
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AdminOfCompanyListComponent.prototype, "isDeleteAccess", {
	        get: function () {
	            if (this.companyAdminList) {
	                return this.companyAdminList.some(function (x) { return x.isDeletable; });
	            }
	            else {
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    AdminOfCompanyListComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.module = this.translate.instant('LblCompanyAdmin');
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	        this.companyList = this.translate.instant('LblListPage', [this.translate.instant('LblCompany')]);
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = ["userName", "firstName", "lastName"];
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlCompanyList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_COMPANY_LIST);
	        this.inviteTitle = this.translate.instant('LblInvite') + " " + this.translate.instant('LblCompanyAdmin');
	        this.sub = this.activeRoute
	            .params
	            .subscribe(function (params) {
	            _this.companyHashId = params['id'] || '';
	            if (_this.companyHashId != '') {
	                _this.addCompanyAdminLink = new config_1.WeGoAuthorizedLink("", config_1.Permission.PR_COMPANY_ADMIN, config_1.PermissionType.INSERT, 'btn btn-highlight navbar-right', 'LblInvite', config_1.Entity.COMPANY, _this.companyHashId);
	                _this.GetCompanyDetails();
	            }
	        });
	    };
	    AdminOfCompanyListComponent.prototype.RoleAvailabilityList = function () {
	        var _this = this;
	        this.isLoading = true;
	        if (this.companyHashId) {
	            this.adminOfCompanyService.GetAllRoleAvailability(new config_1.DataListModel(), this.companyHashId)
	                .subscribe(function (res) {
	                _this.roleAvailabilityList = res.data;
	                _this.roleColumns = _this.roleAvailabilityList.length;
	                _this.GetAdminOfCompanyList();
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	                _this.isLoading = false;
	            });
	        }
	    };
	    AdminOfCompanyListComponent.prototype.GetCompanyDetails = function () {
	        var _this = this;
	        if (this.companyHashId) {
	            this.isLoading = true;
	            this.companyService.GetCompanyBasicDetail(this.companyHashId)
	                .subscribe(function (res) {
	                if (res.data) {
	                    _this.companyName = res.data.entityName;
	                    _this.RoleAvailabilityList();
	                }
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	                _this.isLoading = false;
	            });
	        }
	    };
	    AdminOfCompanyListComponent.prototype.GetAdminOfCompanyList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.adminOfCompanyService.GetAdminOfCompanyList(this.companyHashId, this.DataListModel)
	            .subscribe(function (res) {
	            _this.companyAdminList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.companyAdminList = [];
	            _this.DataListModel.infoMessage = error;
	            _this.isLoading = false;
	        });
	    };
	    AdminOfCompanyListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetAdminOfCompanyList();
	    };
	    AdminOfCompanyListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetAdminOfCompanyList();
	    };
	    AdminOfCompanyListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetAdminOfCompanyList();
	    };
	    ;
	    AdminOfCompanyListComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetAdminOfCompanyList();
	    };
	    AdminOfCompanyListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.adminOfCompanyService.ExportAdminOfCompanyList(this.companyHashId, this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "CompanyAdmin" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	        ;
	    };
	    AdminOfCompanyListComponent.prototype.DeleteAdminOfCompany = function (deleteCompanyAdminList) {
	        var _this = this;
	        this.isLoading = true;
	        this.adminOfCompanyService.DeleteAdminOfCompany(this.companyHashId, deleteCompanyAdminList)
	            .subscribe(function (res) {
	            _this.DataListModel.currentPage = 1;
	            _this.GetAdminOfCompanyList();
	            _this.popupMsg = _this.translate.instant('LblRecordRemovedSuccess', [_this.module]);
	            _this.ShowSuccessPopup();
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AdminOfCompanyListComponent.prototype.OnParentCheck = function (isChecked) {
	        this.companyAdminList.filter(function (x) { return x.isDeletable; }).forEach(function (x) { return x.isChecked = isChecked; });
	    };
	    AdminOfCompanyListComponent.prototype.ShowAlertModal = function (deletePersonMasterHashId) {
	        if (deletePersonMasterHashId) {
	            this.deleteMessage = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
	            this.isMultipleDelete = false;
	            this.deletePersonMasterHashId = deletePersonMasterHashId;
	        }
	        else {
	            this.deleteMessage = this.translate.instant('LblRecordMultiplDeleteConfirmation', [this.module]);
	            this.isMultipleDelete = true;
	        }
	        this.alertModal.show();
	    };
	    AdminOfCompanyListComponent.prototype.HideAlertModal = function () {
	        this.deletePersonMasterHashId = "";
	        this.alertModal.hide();
	    };
	    AdminOfCompanyListComponent.prototype.SuccessAlertModalClick = function () {
	        var deleteAdminOfCompanyList;
	        if (this.isMultipleDelete)
	            deleteAdminOfCompanyList = this.companyAdminList.filter(function (x) { return x.isChecked; }).map(function (x) { return x.personMasterHashId; });
	        else
	            deleteAdminOfCompanyList.push(this.deletePersonMasterHashId);
	        this.DeleteAdminOfCompany(deleteAdminOfCompanyList);
	        this.alertModal.hide();
	    };
	    // Add Instance admin popup
	    AdminOfCompanyListComponent.prototype.ShowAddCompanyAdminModal = function () {
	        this.ShowInviteAdminModal();
	    };
	    AdminOfCompanyListComponent.prototype.ToggleRoleAvailibility = function (personHashID, roleHashId, personRolesHashIds, roleName, userName) {
	        this.ToggleRolePersonHashID = personHashID;
	        this.ToggleRoleHashId = roleHashId;
	        this.ToggleUserName = userName;
	        this.ToggleRoleName = roleName;
	        if (this.CheckRole(personRolesHashIds, roleHashId)) {
	            this.toggleRoleMsg = this.translate.instant('LblDoYouWantToRemove', [userName, roleName]);
	            this.ToggleAddRole = false;
	            this.ShowToggleRolePopup();
	        }
	        else {
	            this.toggleRoleMsg = this.translate.instant('LblDoYouWantToAdd', [userName, roleName]);
	            this.ToggleAddRole = true;
	            this.ShowToggleRolePopup();
	        }
	    };
	    AdminOfCompanyListComponent.prototype.ShowToggleRolePopup = function () {
	        this.toggleRolePopup.show();
	    };
	    AdminOfCompanyListComponent.prototype.HideToggleRolePopup = function () {
	        this.ToggleRolePersonHashID = '';
	        this.ToggleRoleHashId = '';
	        this.ToggleUserName = '';
	        this.ToggleRoleName = '';
	        this.toggleRolePopup.hide();
	    };
	    AdminOfCompanyListComponent.prototype.ConfirmToggleRolePopup = function () {
	        var _this = this;
	        if (this.ToggleAddRole) {
	            this.adminOfCompanyService.AddAdminOfInstanceRole(this.companyHashId, this.ToggleRolePersonHashID, this.ToggleRoleHashId)
	                .subscribe(function (res) {
	                _this.GetAdminOfCompanyList();
	                _this.popupMsg = _this.translate.instant('LblRoleAddedSuccess', [_this.ToggleUserName, _this.ToggleRoleName]);
	                _this.HideToggleRolePopup();
	                _this.ShowSuccessPopup();
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	                _this.isLoading = false;
	                _this.HideToggleRolePopup();
	            });
	        }
	        else {
	            this.adminOfCompanyService.DeleteAdminOfInstanceRole(this.companyHashId, this.ToggleRolePersonHashID, this.ToggleRoleHashId)
	                .subscribe(function (res) {
	                _this.GetAdminOfCompanyList();
	                _this.popupMsg = _this.translate.instant('LblRoleDeletedSuccess', [_this.ToggleUserName, _this.ToggleRoleName]);
	                _this.HideToggleRolePopup();
	                _this.ShowSuccessPopup();
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	                _this.isLoading = false;
	                _this.HideToggleRolePopup();
	            });
	        }
	    };
	    //Reset company admin password
	    AdminOfCompanyListComponent.prototype.ResetPersonPassword = function (personHashID) {
	        var _this = this;
	        this.personService.ResetPersonPassword(personHashID)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblResetPasswordSuccess');
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblResetPasswordFailure');
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AdminOfCompanyListComponent.prototype.ShowResetPasswordModal = function (personHashID) {
	        this.resetPasswordPersonHashId = personHashID;
	        this.popupMsg = this.translate.instant('LblResetPasswordConfirmation');
	        this.resetPasswordModal.show();
	    };
	    AdminOfCompanyListComponent.prototype.HideResetPasswordModal = function () {
	        this.resetPasswordPersonHashId = "";
	        this.resetPasswordModal.hide();
	    };
	    AdminOfCompanyListComponent.prototype.SuccessResetPasswordModalClick = function () {
	        this.resetPasswordModal.hide();
	        console.log(this.resetPasswordPersonHashId);
	        this.ResetPersonPassword(this.resetPasswordPersonHashId);
	    };
	    AdminOfCompanyListComponent.prototype.ResendActivationMail = function (personHashID) {
	        var _this = this;
	        this.resetPasswordPersonHashId = personHashID;
	        this.personService.ReSendActivationMail(personHashID)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblResendActivationMailSuccess');
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblResendActivationMailFailure');
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AdminOfCompanyListComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    AdminOfCompanyListComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    AdminOfCompanyListComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    AdminOfCompanyListComponent.prototype.ShowInviteAdminModal = function () {
	        this.inviteAdminModal.availableRoles = JSON.parse(JSON.stringify(this.roleAvailabilityList));
	        this.inviteAdminModal.availablePersons = '';
	        this.inviteAdminModal.show();
	    };
	    AdminOfCompanyListComponent.prototype.HideInviteAdminModal = function () {
	        this.inviteAdminModal.hide();
	    };
	    AdminOfCompanyListComponent.prototype.SuccessInviteAdminModalClick = function ($event) {
	        var _this = this;
	        var adminInvitation = new admin_to_invite_model_1.CompanyAdminInvitationModel();
	        adminInvitation.emailAddress = $event.emailAddress;
	        adminInvitation.personHashId = $event.personHashId;
	        adminInvitation.roleHashIdList = $event.roleHashIdList;
	        adminInvitation.companyHashId = this.companyHashId;
	        this.adminOfCompanyService.InviteAdminOfInstance(adminInvitation)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblInvitationMailSuccess');
	                _this.HideInviteAdminModal();
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.inviteAdminModal.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	            _this.HideInviteAdminModal();
	        });
	    };
	    AdminOfCompanyListComponent.prototype.SearchEmailAddress = function ($event) {
	        var _this = this;
	        var emailAddress = $event.emailAddress;
	        this.isLoading = true;
	        this.adminOfCompanyService.GetPersonListToInvite(this.companyHashId, emailAddress)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.inviteAdminModal.availablePersons = res.data;
	                _this.inviteAdminModal.errorModel = [];
	            }
	            else {
	                _this.inviteAdminModal.errorModel = res.error;
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AdminOfCompanyListComponent.prototype.CheckRole = function (existingArray, currentRole) {
	        return existingArray.some(function (x) { return x == currentRole; });
	    };
	    Object.defineProperty(AdminOfCompanyListComponent.prototype, "isResetCookieAccess", {
	        get: function () {
	            if (this.companyAdminList) {
	                return this.companyAdminList.some(function (x) { return !x.twoFaDisabled; });
	            }
	            else {
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AdminOfCompanyListComponent.prototype, "isTwoFaResetKeyAccess", {
	        get: function () {
	            if (this.companyAdminList) {
	                return this.companyAdminList.some(function (x) { return x.resetKeyEnabled; });
	            }
	            else {
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    AdminOfCompanyListComponent.prototype.ResetPersonCookies = function (personHashID) {
	        var _this = this;
	        ;
	        this.personService.ResetTwoFaCookie(personHashID).subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblCookieResetSuccess');
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblCookieResetFailed');
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AdminOfCompanyListComponent.prototype.ResetPersonTwoFA = function (personHashID) {
	        var _this = this;
	        this.personService.ResetTwoFaKey(personHashID).subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblKeyResetSuccess');
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblKeyResetFailed');
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    __decorate([
	        core_1.ViewChild('alertModal'), 
	        __metadata('design:type', Object)
	    ], AdminOfCompanyListComponent.prototype, "alertModal", void 0);
	    __decorate([
	        core_1.ViewChild('resetPasswordModal'), 
	        __metadata('design:type', Object)
	    ], AdminOfCompanyListComponent.prototype, "resetPasswordModal", void 0);
	    __decorate([
	        core_1.ViewChild('inActiveModal'), 
	        __metadata('design:type', Object)
	    ], AdminOfCompanyListComponent.prototype, "inActiveModal", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], AdminOfCompanyListComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild('toggleRolePopup'), 
	        __metadata('design:type', Object)
	    ], AdminOfCompanyListComponent.prototype, "toggleRolePopup", void 0);
	    __decorate([
	        core_1.ViewChild('inviteAdminModal'), 
	        __metadata('design:type', Object)
	    ], AdminOfCompanyListComponent.prototype, "inviteAdminModal", void 0);
	    AdminOfCompanyListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-admin-of-company',
	            template: __webpack_require__(976),
	            providers: [admin_of_company_service_1.AdminOfCompanyService, person_service_1.PersonService, company_service_1.CompanyService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof admin_of_company_service_1.AdminOfCompanyService !== 'undefined' && admin_of_company_service_1.AdminOfCompanyService) === 'function' && _a) || Object, (typeof (_b = typeof person_service_1.PersonService !== 'undefined' && person_service_1.PersonService) === 'function' && _b) || Object, (typeof (_c = typeof company_service_1.CompanyService !== 'undefined' && company_service_1.CompanyService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object, (typeof (_e = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _f) || Object, (typeof (_g = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _g) || Object])
	    ], AdminOfCompanyListComponent);
	    return AdminOfCompanyListComponent;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.AdminOfCompanyListComponent = AdminOfCompanyListComponent;


/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var jquery_helper_service_1 = __webpack_require__(67);
	var AdminOfCompanyService = (function () {
	    function AdminOfCompanyService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	        this.JQueryHelper = new jquery_helper_service_1.JQueryHelperService();
	    }
	    AdminOfCompanyService.prototype.GetAdminOfCompanyList = function (companyHashID, input) {
	        var getInstanceAdminUrl = config_1.WeGoConfig.API_GET_ADMIN_OF_COMPANY_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getInstanceAdminUrl = getInstanceAdminUrl + "?" + queryString + "&companyHashID=" + companyHashID;
	        }
	        else {
	            getInstanceAdminUrl = getInstanceAdminUrl + "?companyHashID=" + companyHashID;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getInstanceAdminUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminOfCompanyService.prototype.DeleteAdminOfCompany = function (companyHashID, selectedAdminOfCustomerList) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        var urlDeleteAdminOfInstance = config_1.WeGoConfig.API_POST_DELETE_ADMIN_OF_COMPANY + "?companyHashID=" + companyHashID;
	        return this.http.post(urlDeleteAdminOfInstance, selectedAdminOfCustomerList, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminOfCompanyService.prototype.ExportAdminOfCompanyList = function (companyHashID, input) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var exportToCSVInstanceAdminUrl = config_1.WeGoConfig.API_EXPORT_ADMIN_OF_COMPANY_LIST + "?" + queryString + "&companyHashID=" + companyHashID;
	        var headers = this.authService.GetHeader('text/csv');
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(exportToCSVInstanceAdminUrl, options);
	    };
	    AdminOfCompanyService.prototype.GetAllRoleAvailability = function (input, companyHashID) {
	        var getRoleAvailabilityListUrl = config_1.WeGoConfig.API_GET_COMPANY_ROLEAVAILABILITY_LIST + "?companyHashID=" + companyHashID;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getRoleAvailabilityListUrl = getRoleAvailabilityListUrl + "&" + queryString;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getRoleAvailabilityListUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminOfCompanyService.prototype.DeleteAdminOfInstanceRole = function (companyHashID, personHashId, roleHashId) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        var urlDeleteAdminOfInstance = config_1.WeGoConfig.API_POST_DELETE_ADMIN_OF_COMPANY_ROLE + "?companyHashID=" + companyHashID + "&personHashId=" + personHashId + "&roleHashId=" + roleHashId;
	        return this.http.get(urlDeleteAdminOfInstance, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminOfCompanyService.prototype.AddAdminOfInstanceRole = function (companyHashID, personHashId, roleHashId) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        var urlAddAdminOfInstance = config_1.WeGoConfig.API_POST_ADD_ADMIN_OF_COMPANY_ROLE + "?companyHashID=" + companyHashID + "&personHashId=" + personHashId + "&roleHashId=" + roleHashId;
	        ;
	        return this.http.get(urlAddAdminOfInstance, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminOfCompanyService.prototype.GetPersonListToInvite = function (companyHashID, emailAddress) {
	        var getComapanyAdminUrl = config_1.WeGoConfig.API_GET_COMPANY_PERSON_TO_INVITE_LIST;
	        getComapanyAdminUrl = getComapanyAdminUrl + "?companyHashID=" + companyHashID + "&emailAddress=" + emailAddress;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getComapanyAdminUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminOfCompanyService.prototype.InviteAdminOfInstance = function (companyAdminInvitationModel) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        var urlInviteAdminOfCompany = config_1.WeGoConfig.API_POST_INVITE_ADMIN_OF_COMPANY;
	        return this.http.post(urlInviteAdminOfCompany, companyAdminInvitationModel, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminOfCompanyService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], AdminOfCompanyService);
	    return AdminOfCompanyService;
	    var _a, _b;
	}());
	exports.AdminOfCompanyService = AdminOfCompanyService;


/***/ },
/* 976 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ breadCrumbList}} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"urlCompanyList\">\r\n            <i class=\"fa fa-user-circle fa-fw\"></i> {{companyList }}</a>\r\n        </li>\r\n        <li class=\"active\"> {{ breadCrumbList}} </li>\r\n\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25 \">\r\n      <!-- <a class=\"btn btn-highlight navbar-right\" (click)=\"ShowAddCompanyAdminModal()\">{{ 'LblInvite' | translate }}</a> -->\r\n      <wego-authorized-link [LinkModel]=\"addCompanyAdminLink\" (onClick)=\"ShowAddCompanyAdminModal()\"></wego-authorized-link>\r\n\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <h4>\r\n          <label>{{ 'LblCompany' | translate }} : </label> {{companyName}}</h4>\r\n        <p class=\"text-success\">{{ message }}</p>\r\n        <wego-search-list [IsDeleted]=\"isDeleteAccess\" [IsDeleteEnabled]=\"isAnyChecked\" (OnDeleteAll)=\"ShowAlertModal()\"\r\n          (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\"\r\n          [SearchTerm]=\"DataListModel.searchTerm\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center parent-checkbox\">\r\n                  <input [disabled]=\"!isDeleteAccess\" type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\"\r\n                    (change)=\"OnParentCheck($event.target.checked)\">\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('firstName')\">\r\n                  {{ 'LblFirstName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'firstName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('lastName')\">\r\n                  {{ 'LblLastName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'lastName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('userName')\">\r\n                  {{ 'LblUserName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'userName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th *ngIf=\"isResetCookieAccess\" class=\"text-center\">{{ 'LblResetCookie' |\r\n                  translate }}</th>\r\n                <th *ngIf=\"isTwoFaResetKeyAccess\" class=\"text-center\">{{ 'LblResetTwoFA' |\r\n                  translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblResetPassword' | translate }}</th>\r\n                <th *ngFor=\"let role of roleAvailabilityList\" class=\"text-center\">\r\n                  {{role.presentationName}}\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let companyAdmin of companyAdminList\">\r\n                  <td class=\"text-center\">\r\n                    <input *ngIf=\"!companyAdmin.isDeletable\" type=\"checkbox\" name=\"isActive\" disabled>\r\n                    <input *ngIf=\"companyAdmin.isDeletable\" type=\"checkbox\" name=\"isActive\" [(ngModel)]=\"companyAdmin.isChecked\">\r\n                  </td>\r\n                  <td>{{ companyAdmin.firstName }}</td>\r\n                  <td>{{ companyAdmin.lastName }}</td>\r\n                  <td>{{ companyAdmin.userName }}</td>\r\n                  <td class=\"text-center\" *ngIf=\"isResetCookieAccess\">\r\n                    <a *ngIf=\"!companyAdmin.twoFaDisabled\" class=\"btn btn-green btn-xs cursor-pointer\" (click)=\"ResetPersonCookies(companyAdmin.personMasterHashId)\">\r\n                      {{ 'LblResetCookie' | translate}}\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\" *ngIf=\"isTwoFaResetKeyAccess\">\r\n                    <a *ngIf=\"companyAdmin.resetKeyEnabled\" class=\"btn btn-green btn-xs cursor-pointer\" (click)=\"ResetPersonTwoFA(companyAdmin.personMasterHashId)\">\r\n                      {{ 'LblResetTwoFA' | translate}}\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a class=\"cursor-pointer\">\r\n                      <i class=\"fa fa-refresh fa-fw text-success\" (click)=\"ShowResetPasswordModal(companyAdmin.personMasterHashId)\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td *ngFor=\"let role of roleAvailabilityList\" class=\"text-center\">\r\n                    <a [ngClass]=\"{ 'cursor-pointer': companyAdmin.isEditable }\" class=\"cursor-pointer\">\r\n                      <i *ngIf=\"companyAdmin.isEditable\" class=\"fa fa-fw\" (click)=\"ToggleRoleAvailibility(companyAdmin.personMasterHashId,role.roleHashId,companyAdmin.rolesHashIds,role.presentationName,companyAdmin.userName)\"\r\n                        [ngClass]=\"{ 'fa-check text-success': CheckRole(companyAdmin.rolesHashIds, role.roleHashId), \r\n                    'fa-times text-danger' : !CheckRole(companyAdmin.rolesHashIds, role.roleHashId) }\"></i>\r\n                      <i style=\"cursor: default;\" *ngIf=\"!companyAdmin.isEditable\" class=\"fa fa-fw\" [ngClass]=\"{ 'fa-check text-success': CheckRole(companyAdmin.rolesHashIds, role.roleHashId), \r\n                    'fa-times text-danger' : !CheckRole(companyAdmin.rolesHashIds, role.roleHashId) }\"></i>\r\n                    </a>\r\n                  </td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" [attr.colspan]=\"5+roleColumns\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\"\r\n                [(ngModel)]=\"DataListModel.currentPage\" [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\"\r\n                previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\" lastText=\"&raquo;\" [rotate]=\"false\"\r\n                (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<wego-confirm-popup #alertModal [popupMsg]=\"deleteMessage\" (onConfirm)=\"SuccessAlertModalClick()\" (onReject)=\"HideAlertModal()\"></wego-confirm-popup>\r\n\r\n<wego-confirm-popup #resetPasswordModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessResetPasswordModalClick()\" (onReject)=\"HideResetPasswordModal()\"></wego-confirm-popup>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" [popupTitle]=\"popupTitle\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n\r\n<wego-confirm-popup #toggleRolePopup [popupMsg]=\"toggleRoleMsg\" (onConfirm)=\"ConfirmToggleRolePopup()\" (onReject)=\"HideToggleRolePopup()\"></wego-confirm-popup>\r\n\r\n<wego-invite-admin-popup #inviteAdminModal [popupTitle]=\"inviteTitle\" (onEmailSearch)=\"SearchEmailAddress($event)\"\r\n  (onConfirm)=\"SuccessInviteAdminModalClick($event)\" (onReject)=\"HideInviteAdminModal()\"></wego-invite-admin-popup>";

/***/ },
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var admin_of_SharedVehicleGroup_service_1 = __webpack_require__(978);
	var person_service_1 = __webpack_require__(771);
	var sharedvehiclegroup_service_1 = __webpack_require__(510);
	var admin_to_invite_model_1 = __webpack_require__(963);
	var AdminOfsharedVehicleGroupListComponent = (function () {
	    function AdminOfsharedVehicleGroupListComponent(adminOfsharedVehicleGroupService, personService, sharedVehicleGroupService, activeRoute, authService, router, translate) {
	        this.adminOfsharedVehicleGroupService = adminOfsharedVehicleGroupService;
	        this.personService = personService;
	        this.sharedVehicleGroupService = sharedVehicleGroupService;
	        this.activeRoute = activeRoute;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.roleColumns = 0;
	    }
	    Object.defineProperty(AdminOfsharedVehicleGroupListComponent.prototype, "isAnyChecked", {
	        get: function () {
	            if (this.sharedVehicleGroupAdminList) {
	                var isCheck = this.sharedVehicleGroupAdminList.some(function (x) { return x.isChecked == true; });
	                if (isCheck) {
	                    if (this.sharedVehicleGroupAdminList.every(function (x) { return x.isChecked == true; }))
	                        this.isParentCheck = true;
	                    else
	                        this.isParentCheck = false;
	                }
	                else {
	                    this.isParentCheck = false;
	                }
	                return isCheck;
	            }
	            else {
	                this.isParentCheck = false;
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AdminOfsharedVehicleGroupListComponent.prototype, "isDeleteAccess", {
	        get: function () {
	            if (this.sharedVehicleGroupAdminList) {
	                return this.sharedVehicleGroupAdminList.some(function (x) { return x.isDeletable; });
	            }
	            else {
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    AdminOfsharedVehicleGroupListComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.module = this.translate.instant('LblSharedVehicleGroupAdmin');
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	        this.sharedVehicleGroupList = this.translate.instant('LblListPage', [this.translate.instant('LblSharedVehicleGroup')]);
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = ["userName", "firstName", "lastName"];
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlSharedVehicleGroupList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_SVG_LIST);
	        this.inviteTitle = this.translate.instant('LblInvite') + " " + this.translate.instant('LblSharedVehicleGroupAdmin');
	        this.sub = this.activeRoute
	            .params
	            .subscribe(function (params) {
	            _this.svgHashId = params['id'] || '';
	            if (_this.svgHashId != '') {
	                _this.addSvgAdminLink = new config_1.WeGoAuthorizedLink("", config_1.Permission.PR_SHARED_VEHICLE_GROUP_ADMIN_OVERVIEW, config_1.PermissionType.INSERT, 'btn btn-highlight navbar-right', 'LblInvite', config_1.Entity.SVG, _this.svgHashId);
	                _this.GetSharedVehicleGroupDetails();
	            }
	        });
	    };
	    AdminOfsharedVehicleGroupListComponent.prototype.RoleAvailabilityList = function () {
	        var _this = this;
	        this.isLoading = true;
	        if (this.svgHashId) {
	            this.adminOfsharedVehicleGroupService.GetAllRoleAvailability(new config_1.DataListModel(), this.svgHashId)
	                .subscribe(function (res) {
	                _this.roleAvailabilityList = res.data;
	                _this.roleColumns = _this.roleAvailabilityList.length;
	                _this.GetAdminOfsharedVehicleGroupList();
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	                _this.isLoading = false;
	            });
	        }
	    };
	    AdminOfsharedVehicleGroupListComponent.prototype.GetSharedVehicleGroupDetails = function () {
	        var _this = this;
	        if (this.svgHashId) {
	            this.isLoading = true;
	            this.sharedVehicleGroupService.GetSharedVehicleGroupBasicDetail(this.svgHashId)
	                .subscribe(function (res) {
	                if (res.data) {
	                    _this.sharedVehicleGroupName = res.data.entityName;
	                    _this.RoleAvailabilityList();
	                }
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	                _this.isLoading = false;
	            });
	        }
	    };
	    AdminOfsharedVehicleGroupListComponent.prototype.GetAdminOfsharedVehicleGroupList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.adminOfsharedVehicleGroupService.GetAdminOfSharedVehicleGroupList(this.svgHashId, this.DataListModel)
	            .subscribe(function (res) {
	            _this.sharedVehicleGroupAdminList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.sharedVehicleGroupAdminList = [];
	            _this.DataListModel.infoMessage = error;
	            _this.isLoading = false;
	        });
	    };
	    AdminOfsharedVehicleGroupListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetAdminOfsharedVehicleGroupList();
	    };
	    AdminOfsharedVehicleGroupListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetAdminOfsharedVehicleGroupList();
	    };
	    AdminOfsharedVehicleGroupListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetAdminOfsharedVehicleGroupList();
	    };
	    ;
	    AdminOfsharedVehicleGroupListComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetAdminOfsharedVehicleGroupList();
	    };
	    AdminOfsharedVehicleGroupListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.adminOfsharedVehicleGroupService.ExportAdminOfsharedVehicleGroupList(this.svgHashId, this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "SharedVehicleGroupAdmin" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	        ;
	    };
	    AdminOfsharedVehicleGroupListComponent.prototype.DeleteAdminOfSharedVehicleGroup = function (deleteAdminOfsvgList) {
	        var _this = this;
	        this.isLoading = true;
	        this.adminOfsharedVehicleGroupService.DeleteAdminOfSharedVehicleGroup(this.svgHashId, deleteAdminOfsvgList)
	            .subscribe(function (res) {
	            _this.DataListModel.currentPage = 1;
	            _this.GetAdminOfsharedVehicleGroupList();
	            _this.popupMsg = _this.translate.instant('LblRecordRemovedSuccess', [_this.module]);
	            _this.ShowSuccessPopup();
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AdminOfsharedVehicleGroupListComponent.prototype.OnParentCheck = function (isChecked) {
	        this.sharedVehicleGroupAdminList.filter(function (x) { return x.isDeletable; }).forEach(function (x) { return x.isChecked = isChecked; });
	    };
	    AdminOfsharedVehicleGroupListComponent.prototype.ShowAlertModal = function (deletePersonMasterHashId) {
	        if (deletePersonMasterHashId) {
	            this.deleteMessage = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
	            this.isMultipleDelete = false;
	            this.deletePersonMasterHashId = deletePersonMasterHashId;
	        }
	        else {
	            this.deleteMessage = this.translate.instant('LblRecordMultiplDeleteConfirmation', [this.module]);
	            this.isMultipleDelete = true;
	        }
	        this.alertModal.show();
	    };
	    AdminOfsharedVehicleGroupListComponent.prototype.HideAlertModal = function () {
	        this.deletePersonMasterHashId = "";
	        this.alertModal.hide();
	    };
	    AdminOfsharedVehicleGroupListComponent.prototype.SuccessAlertModalClick = function () {
	        var deleteAdminOfSVGList;
	        if (this.isMultipleDelete)
	            deleteAdminOfSVGList = this.sharedVehicleGroupAdminList.filter(function (x) { return x.isChecked; }).map(function (x) { return x.personMasterHashId; });
	        else
	            deleteAdminOfSVGList.push(this.deletePersonMasterHashId);
	        this.DeleteAdminOfSharedVehicleGroup(deleteAdminOfSVGList);
	        this.alertModal.hide();
	    };
	    // Add SharedVehicleGroup admin popup
	    AdminOfsharedVehicleGroupListComponent.prototype.ShowAddAdminOfSharedVehicleGroupModal = function () {
	        this.ShowInviteAdminModal();
	    };
	    AdminOfsharedVehicleGroupListComponent.prototype.ToggleRoleAvailability = function (personHashID, roleHashId, personRolesHashIds, roleName, userName) {
	        this.ToggleRolePersonHashID = personHashID;
	        this.ToggleRoleHashId = roleHashId;
	        this.ToggleUserName = userName;
	        this.ToggleRoleName = roleName;
	        if (this.CheckRole(personRolesHashIds, roleHashId)) {
	            this.toggleRoleMsg = this.translate.instant('LblDoYouWantToRemove', [userName, roleName]);
	            this.ToggleAddRole = false;
	            this.ShowToggleRolePopup();
	        }
	        else {
	            this.toggleRoleMsg = this.translate.instant('LblDoYouWantToAdd', [userName, roleName]);
	            this.ToggleAddRole = true;
	            this.ShowToggleRolePopup();
	        }
	    };
	    AdminOfsharedVehicleGroupListComponent.prototype.ShowToggleRolePopup = function () {
	        this.toggleRolePopup.show();
	    };
	    AdminOfsharedVehicleGroupListComponent.prototype.HideToggleRolePopup = function () {
	        this.ToggleRolePersonHashID = '';
	        this.ToggleRoleHashId = '';
	        this.ToggleUserName = '';
	        this.ToggleRoleName = '';
	        this.toggleRolePopup.hide();
	    };
	    AdminOfsharedVehicleGroupListComponent.prototype.ConfirmToggleRolePopup = function () {
	        var _this = this;
	        if (this.ToggleAddRole) {
	            this.adminOfsharedVehicleGroupService.AddAdminOfSharedVehicleGroupRole(this.svgHashId, this.ToggleRolePersonHashID, this.ToggleRoleHashId)
	                .subscribe(function (res) {
	                _this.GetAdminOfsharedVehicleGroupList();
	                _this.popupMsg = _this.translate.instant('LblRoleAddedSuccess', [_this.ToggleUserName, _this.ToggleRoleName]);
	                _this.HideToggleRolePopup();
	                _this.ShowSuccessPopup();
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	                _this.isLoading = false;
	                _this.HideToggleRolePopup();
	            });
	        }
	        else {
	            this.adminOfsharedVehicleGroupService.DeleteAdminOfSharedVehicleGroupRole(this.svgHashId, this.ToggleRolePersonHashID, this.ToggleRoleHashId)
	                .subscribe(function (res) {
	                _this.GetAdminOfsharedVehicleGroupList();
	                _this.popupMsg = _this.translate.instant('LblRoleDeletedSuccess', [_this.ToggleUserName, _this.ToggleRoleName]);
	                _this.HideToggleRolePopup();
	                _this.ShowSuccessPopup();
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	                _this.isLoading = false;
	                _this.HideToggleRolePopup();
	            });
	        }
	    };
	    //Reset company admin password
	    AdminOfsharedVehicleGroupListComponent.prototype.ResetPersonPassword = function (personHashID) {
	        var _this = this;
	        this.personService.ResetPersonPassword(personHashID)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblResetPasswordSuccess');
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblResetPasswordFailure');
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AdminOfsharedVehicleGroupListComponent.prototype.ShowResetPasswordModal = function (personHashID) {
	        this.resetPasswordPersonHashId = personHashID;
	        this.popupMsg = this.translate.instant('LblResetPasswordConfirmation');
	        this.resetPasswordModal.show();
	    };
	    AdminOfsharedVehicleGroupListComponent.prototype.HideResetPasswordModal = function () {
	        this.resetPasswordPersonHashId = "";
	        this.resetPasswordModal.hide();
	    };
	    AdminOfsharedVehicleGroupListComponent.prototype.SuccessResetPasswordModalClick = function () {
	        this.resetPasswordModal.hide();
	        this.ResetPersonPassword(this.resetPasswordPersonHashId);
	    };
	    AdminOfsharedVehicleGroupListComponent.prototype.ResendActivationMail = function (personHashID) {
	        var _this = this;
	        this.resetPasswordPersonHashId = personHashID;
	        this.personService.ReSendActivationMail(personHashID)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblResendActivationMailSuccess');
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblResendActivationMailFailure');
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AdminOfsharedVehicleGroupListComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    AdminOfsharedVehicleGroupListComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    AdminOfsharedVehicleGroupListComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	        this.toggleRolePopup.hide();
	    };
	    AdminOfsharedVehicleGroupListComponent.prototype.ShowInviteAdminModal = function () {
	        this.inviteAdminModal.availableRoles = JSON.parse(JSON.stringify(this.roleAvailabilityList));
	        this.inviteAdminModal.availablePersons = '';
	        this.inviteAdminModal.show();
	    };
	    AdminOfsharedVehicleGroupListComponent.prototype.HideInviteAdminModal = function () {
	        this.inviteAdminModal.hide();
	    };
	    AdminOfsharedVehicleGroupListComponent.prototype.SuccessInviteAdminModalClick = function ($event) {
	        var _this = this;
	        console.log($event);
	        var adminInvitation = new admin_to_invite_model_1.SharedVehicleGroupAdminInvitationModel();
	        adminInvitation.emailAddress = $event.emailAddress;
	        adminInvitation.personHashId = $event.personHashId;
	        adminInvitation.roleHashIdList = $event.roleHashIdList;
	        adminInvitation.sharedVehicleGroupHashId = this.svgHashId;
	        this.adminOfsharedVehicleGroupService.InviteAdminOfsharedVehicleGroup(adminInvitation)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblInvitationMailSuccess');
	                _this.HideInviteAdminModal();
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.inviteAdminModal.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	            _this.HideInviteAdminModal();
	        });
	    };
	    AdminOfsharedVehicleGroupListComponent.prototype.SearchEmailAddress = function ($event) {
	        var _this = this;
	        var emailAddress = $event.emailAddress;
	        this.isLoading = true;
	        this.adminOfsharedVehicleGroupService.GetPersonListToInvite(this.svgHashId, emailAddress)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.inviteAdminModal.availablePersons = res.data;
	                _this.inviteAdminModal.errorModel = [];
	            }
	            else {
	                _this.inviteAdminModal.errorModel = res.error;
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AdminOfsharedVehicleGroupListComponent.prototype.CheckRole = function (existingArray, currentRole) {
	        return existingArray.some(function (x) { return x == currentRole; });
	    };
	    Object.defineProperty(AdminOfsharedVehicleGroupListComponent.prototype, "isResetCookieAccess", {
	        get: function () {
	            if (this.sharedVehicleGroupAdminList) {
	                return this.sharedVehicleGroupAdminList.some(function (x) { return !x.twoFaDisabled; });
	            }
	            else {
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AdminOfsharedVehicleGroupListComponent.prototype, "isTwoFaResetKeyAccess", {
	        get: function () {
	            if (this.sharedVehicleGroupAdminList) {
	                return this.sharedVehicleGroupAdminList.some(function (x) { return x.resetKeyEnabled; });
	            }
	            else {
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    AdminOfsharedVehicleGroupListComponent.prototype.ResetPersonCookies = function (personHashID) {
	        var _this = this;
	        ;
	        this.personService.ResetTwoFaCookie(personHashID).subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblCookieResetSuccess');
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblCookieResetFailed');
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AdminOfsharedVehicleGroupListComponent.prototype.ResetPersonTwoFA = function (personHashID) {
	        var _this = this;
	        this.personService.ResetTwoFaKey(personHashID).subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblKeyResetSuccess');
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblKeyResetFailed');
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    __decorate([
	        core_1.ViewChild('alertModal'), 
	        __metadata('design:type', Object)
	    ], AdminOfsharedVehicleGroupListComponent.prototype, "alertModal", void 0);
	    __decorate([
	        core_1.ViewChild('resetPasswordModal'), 
	        __metadata('design:type', Object)
	    ], AdminOfsharedVehicleGroupListComponent.prototype, "resetPasswordModal", void 0);
	    __decorate([
	        core_1.ViewChild('inActiveModal'), 
	        __metadata('design:type', Object)
	    ], AdminOfsharedVehicleGroupListComponent.prototype, "inActiveModal", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], AdminOfsharedVehicleGroupListComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild('toggleRolePopup'), 
	        __metadata('design:type', Object)
	    ], AdminOfsharedVehicleGroupListComponent.prototype, "toggleRolePopup", void 0);
	    __decorate([
	        core_1.ViewChild('inviteAdminModal'), 
	        __metadata('design:type', Object)
	    ], AdminOfsharedVehicleGroupListComponent.prototype, "inviteAdminModal", void 0);
	    AdminOfsharedVehicleGroupListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-admin-of-sharedVehicleGroup',
	            template: __webpack_require__(979),
	            providers: [admin_of_SharedVehicleGroup_service_1.AdminOfSharedVehicleGroupService, person_service_1.PersonService, sharedvehiclegroup_service_1.SharedVehicleGroupService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof admin_of_SharedVehicleGroup_service_1.AdminOfSharedVehicleGroupService !== 'undefined' && admin_of_SharedVehicleGroup_service_1.AdminOfSharedVehicleGroupService) === 'function' && _a) || Object, (typeof (_b = typeof person_service_1.PersonService !== 'undefined' && person_service_1.PersonService) === 'function' && _b) || Object, (typeof (_c = typeof sharedvehiclegroup_service_1.SharedVehicleGroupService !== 'undefined' && sharedvehiclegroup_service_1.SharedVehicleGroupService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object, (typeof (_e = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _f) || Object, (typeof (_g = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _g) || Object])
	    ], AdminOfsharedVehicleGroupListComponent);
	    return AdminOfsharedVehicleGroupListComponent;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.AdminOfsharedVehicleGroupListComponent = AdminOfsharedVehicleGroupListComponent;


/***/ },
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var jquery_helper_service_1 = __webpack_require__(67);
	var AdminOfSharedVehicleGroupService = (function () {
	    function AdminOfSharedVehicleGroupService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	        this.JQueryHelper = new jquery_helper_service_1.JQueryHelperService();
	    }
	    AdminOfSharedVehicleGroupService.prototype.GetAdminOfSharedVehicleGroupList = function (svgHashID, input) {
	        var getSVGAdminUrl = config_1.WeGoConfig.API_GET_ADMIN_OF_SVG_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getSVGAdminUrl = getSVGAdminUrl + "?" + queryString + "&svgHashID=" + svgHashID;
	        }
	        else {
	            getSVGAdminUrl = getSVGAdminUrl + "?svgHashID=" + svgHashID;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getSVGAdminUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminOfSharedVehicleGroupService.prototype.ExportAdminOfsharedVehicleGroupList = function (svgHashId, input) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var getCompanyAdminUrl = config_1.WeGoConfig.API_EXPORT_ADMIN_OF_SVG_LIST + "?" + queryString + "&sharedVehicleGroupHashId=" + svgHashId;
	        var headers = this.authService.GetHeader('text/csv');
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getCompanyAdminUrl, options);
	    };
	    AdminOfSharedVehicleGroupService.prototype.DeleteAdminOfSharedVehicleGroup = function (svgHashId, selectedAdminOfSVGList) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        var urlDeleteAdminOfSVG = config_1.WeGoConfig.API_POST_DELETE_ADMIN_OF_SVG + "?sharedVehicleGroupHashId=" + svgHashId;
	        return this.http.post(urlDeleteAdminOfSVG, selectedAdminOfSVGList, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminOfSharedVehicleGroupService.prototype.GetAllRoleAvailability = function (input, svgHashId) {
	        var getRoleAvailabilityListUrl = config_1.WeGoConfig.API_GET_SVG_ROLEAVAILABILITY_LIST + "?svgHashId=" + svgHashId;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getRoleAvailabilityListUrl = getRoleAvailabilityListUrl + "&" + queryString;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getRoleAvailabilityListUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminOfSharedVehicleGroupService.prototype.DeleteAdminOfSharedVehicleGroupRole = function (svgHashId, personHashId, roleHashId) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        var urlDeleteAdminOfSVG = config_1.WeGoConfig.API_POST_DELETE_ADMIN_OF_SVG_ROLE + "?sharedVehicleGroupHashId=" + svgHashId + "&personHashId=" + personHashId + "&roleHashId=" + roleHashId;
	        return this.http.get(urlDeleteAdminOfSVG, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminOfSharedVehicleGroupService.prototype.AddAdminOfSharedVehicleGroupRole = function (svgHashId, personHashId, roleHashId) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        var urlAddAdminOfSVG = config_1.WeGoConfig.API_POST_ADD_ADMIN_OF_SVG_ROLE + "?sharedVehicleGroupHashId=" + svgHashId + "&personHashId=" + personHashId + "&roleHashId=" + roleHashId;
	        ;
	        return this.http.get(urlAddAdminOfSVG, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminOfSharedVehicleGroupService.prototype.GetPersonListToInvite = function (svgHashID, emailAddress) {
	        var getSVGAdminUrl = config_1.WeGoConfig.API_GET_SVG_PERSON_TO_INVITE_LIST;
	        getSVGAdminUrl = getSVGAdminUrl + "?sharedVehicleGroupHashID=" + svgHashID + "&emailAddress=" + emailAddress;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getSVGAdminUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminOfSharedVehicleGroupService.prototype.InviteAdminOfsharedVehicleGroup = function (svgAdminInvitationModel) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        var urlInviteAdminOfSharedVehicleGroup = config_1.WeGoConfig.API_POST_INVITE_ADMIN_OF_SVG;
	        return this.http.post(urlInviteAdminOfSharedVehicleGroup, svgAdminInvitationModel, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminOfSharedVehicleGroupService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], AdminOfSharedVehicleGroupService);
	    return AdminOfSharedVehicleGroupService;
	    var _a, _b;
	}());
	exports.AdminOfSharedVehicleGroupService = AdminOfSharedVehicleGroupService;


/***/ },
/* 979 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ breadCrumbList}} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"urlSharedVehicleGroupList\">\r\n            <i class=\"fa fa-user-circle fa-fw\"></i> {{sharedVehicleGroupList }}</a>\r\n        </li>\r\n        <li class=\"active\"> {{ breadCrumbList}} </li>\r\n\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25 \">\r\n      <!-- <a class=\"btn btn-highlight navbar-right\" (click)=\"ShowAddAdminOfSharedVehicleGroupModal()\">{{ 'LblInvite' | translate }}</a> -->\r\n      <wego-authorized-link [LinkModel]=\"addSvgAdminLink\" (onClick)=\"ShowAddAdminOfSharedVehicleGroupModal()\"></wego-authorized-link>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <h4>\r\n          <label>{{ 'LblSharedVehicleGroup' | translate }} : </label> {{sharedVehicleGroupName}}</h4>\r\n        <p class=\"text-success\">{{ message }}</p>\r\n        <wego-search-list [IsDeleted]=\"isDeleteAccess\" [IsDeleteEnabled]=\"isAnyChecked\" (OnDeleteAll)=\"ShowAlertModal()\"\r\n          (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\"\r\n          [SearchTerm]=\"DataListModel.searchTerm\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center parent-checkbox\">\r\n                  <input [disabled]=\"!isDeleteAccess\" type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\"\r\n                    (change)=\"OnParentCheck($event.target.checked)\">\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('firstName')\">\r\n                  {{ 'LblFirstName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'firstName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('lastName')\">\r\n                  {{ 'LblLastName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'lastName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('userName')\">\r\n                  {{ 'LblUserName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'userName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th *ngIf=\"isResetCookieAccess\" class=\"text-center\">{{ 'LblResetCookie' |\r\n                  translate }}</th>\r\n                <th *ngIf=\"isTwoFaResetKeyAccess\" class=\"text-center\">{{ 'LblResetTwoFA' |\r\n                  translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblResetPassword' | translate }}</th>\r\n                <th *ngFor=\"let role of roleAvailabilityList\" class=\"text-center\">\r\n                  {{role.presentationName}}\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let sharedVehicleGroupAdmin of sharedVehicleGroupAdminList\">\r\n                  <td class=\"text-center\">\r\n                    <input *ngIf=\"!sharedVehicleGroupAdmin.isDeletable\" type=\"checkbox\" name=\"isActive\" disabled>\r\n                    <input *ngIf=\"sharedVehicleGroupAdmin.isDeletable\" type=\"checkbox\" name=\"isActive\" [(ngModel)]=\"sharedVehicleGroupAdmin.isChecked\">\r\n                  </td>\r\n                  <td>{{ sharedVehicleGroupAdmin.firstName }}</td>\r\n                  <td>{{ sharedVehicleGroupAdmin.lastName }}</td>\r\n                  <td>{{ sharedVehicleGroupAdmin.userName }}</td>\r\n                  <td class=\"text-center\" *ngIf=\"isResetCookieAccess\">\r\n                    <a *ngIf=\"!sharedVehicleGroupAdmin.twoFaDisabled\" class=\"btn btn-green btn-xs cursor-pointer\" (click)=\"ResetPersonCookies(sharedVehicleGroupAdmin.personMasterHashId)\">\r\n                      {{ 'LblResetCookie' | translate}}\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\" *ngIf=\"isTwoFaResetKeyAccess\">\r\n                    <a *ngIf=\"sharedVehicleGroupAdmin.resetKeyEnabled\" class=\"btn btn-green btn-xs cursor-pointer\" (click)=\"ResetPersonTwoFA(sharedVehicleGroupAdmin.personMasterHashId)\">\r\n                      {{ 'LblResetTwoFA' | translate}}\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a class=\"cursor-pointer\">\r\n                      <i class=\"fa fa-refresh fa-fw text-success\" (click)=\"ShowResetPasswordModal(sharedVehicleGroupAdmin.personMasterHashId)\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td *ngFor=\"let role of roleAvailabilityList\" class=\"text-center\">\r\n                    <a [ngClass]=\"{ 'cursor-pointer': sharedVehicleGroupAdmin.isEditable }\" class=\"cursor-pointer\">\r\n                      <i *ngIf=\"!sharedVehicleGroupAdmin.isEditable\" class=\"fa fa-fw\" [ngClass]=\"{ 'fa-check text-success': CheckRole(sharedVehicleGroupAdmin.rolesHashIds, role.roleHashId), \r\n                      'fa-times text-danger' : !CheckRole(sharedVehicleGroupAdmin.rolesHashIds, role.roleHashId) }\"></i>\r\n\r\n                      <i *ngIf=\"sharedVehicleGroupAdmin.isEditable\" class=\"fa fa-fw\" (click)=\"ToggleRoleAvailability(sharedVehicleGroupAdmin.personMasterHashId,role.roleHashId,sharedVehicleGroupAdmin.rolesHashIds,role.presentationName,sharedVehicleGroupAdmin.userName)\"\r\n                        [ngClass]=\"{ 'fa-check text-success': CheckRole(sharedVehicleGroupAdmin.rolesHashIds, role.roleHashId), \r\n                      'fa-times text-danger' : !CheckRole(sharedVehicleGroupAdmin.rolesHashIds, role.roleHashId) }\"></i>\r\n                    </a>\r\n                  </td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" [attr.colspan]=\"5+roleColumns\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\"\r\n                [(ngModel)]=\"DataListModel.currentPage\" [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\"\r\n                previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\" lastText=\"&raquo;\" [rotate]=\"false\"\r\n                (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<wego-confirm-popup #alertModal [popupMsg]=\"deleteMessage\" (onConfirm)=\"SuccessAlertModalClick()\" (onReject)=\"HideAlertModal()\"></wego-confirm-popup>\r\n\r\n<wego-confirm-popup #resetPasswordModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessResetPasswordModalClick()\" (onReject)=\"HideResetPasswordModal()\"></wego-confirm-popup>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" [popupTitle]=\"popupTitle\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n\r\n<wego-confirm-popup #toggleRolePopup [popupMsg]=\"toggleRoleMsg\" (onConfirm)=\"ConfirmToggleRolePopup()\" (onReject)=\"HideToggleRolePopup()\"></wego-confirm-popup>\r\n\r\n<wego-invite-admin-popup #inviteAdminModal [popupTitle]=\"inviteTitle\" (onEmailSearch)=\"SearchEmailAddress($event)\"\r\n  (onConfirm)=\"SuccessInviteAdminModalClick($event)\" (onReject)=\"HideInviteAdminModal()\"></wego-invite-admin-popup>";

/***/ },
/* 980 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var admin_of_organization_service_1 = __webpack_require__(981);
	var person_service_1 = __webpack_require__(771);
	var admin_to_invite_model_1 = __webpack_require__(963);
	var organization_service_1 = __webpack_require__(614);
	var AdminOfOrganizationListComponent = (function () {
	    function AdminOfOrganizationListComponent(adminOfOrganizationService, personService, organizationService, activeRoute, authService, router, translate) {
	        this.adminOfOrganizationService = adminOfOrganizationService;
	        this.personService = personService;
	        this.organizationService = organizationService;
	        this.activeRoute = activeRoute;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.roleColumns = 0;
	    }
	    Object.defineProperty(AdminOfOrganizationListComponent.prototype, "isAnyChecked", {
	        get: function () {
	            if (this.organizationAdminList) {
	                var isCheck = this.organizationAdminList.some(function (x) { return x.isChecked == true; });
	                if (isCheck) {
	                    if (this.organizationAdminList.every(function (x) { return x.isChecked == true; }))
	                        this.isParentCheck = true;
	                    else
	                        this.isParentCheck = false;
	                }
	                else {
	                    this.isParentCheck = false;
	                }
	                return isCheck;
	            }
	            else {
	                this.isParentCheck = false;
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AdminOfOrganizationListComponent.prototype, "isDeleteAccess", {
	        get: function () {
	            if (this.organizationAdminList) {
	                return this.organizationAdminList.some(function (x) { return x.isDeletable; });
	            }
	            else {
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    AdminOfOrganizationListComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.module = this.translate.instant('LblOrganizationAdmin');
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	        this.organizationList = this.translate.instant('LblListPage', [this.translate.instant('LblOrganization')]);
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = ["userName", "firstName", "lastName"];
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlOrganizationList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_ORGANIZATION_LIST);
	        this.inviteTitle = this.translate.instant('LblInvite') + " " + this.translate.instant('LblOrganizationAdmin');
	        this.sub = this.activeRoute
	            .params
	            .subscribe(function (params) {
	            _this.organizationHashId = params['id'] || '';
	            if (_this.organizationHashId != '') {
	                _this.addOrganizationAdminLink = new config_1.WeGoAuthorizedLink("", config_1.Permission.PR_ORGANIZATION_ADMIN_OVERVIEW, config_1.PermissionType.INSERT, 'btn btn-highlight navbar-right', 'LblInvite', config_1.Entity.ORGANIZATION, _this.organizationHashId);
	                _this.GetOrganizationDetails();
	            }
	        });
	    };
	    AdminOfOrganizationListComponent.prototype.RoleAvailabilityList = function () {
	        var _this = this;
	        this.isLoading = true;
	        if (this.organizationHashId) {
	            this.adminOfOrganizationService.GetAllRoleAvailability(new config_1.DataListModel(), this.organizationHashId)
	                .subscribe(function (res) {
	                _this.roleAvailabilityList = res.data;
	                _this.roleColumns = _this.roleAvailabilityList.length;
	                _this.GetAdminOfOrganizationList();
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	                _this.isLoading = false;
	            });
	        }
	    };
	    AdminOfOrganizationListComponent.prototype.GetOrganizationDetails = function () {
	        var _this = this;
	        if (this.organizationHashId) {
	            this.isLoading = true;
	            this.organizationService.GetOrganizationBasicDetail(this.organizationHashId)
	                .subscribe(function (res) {
	                if (res.data) {
	                    _this.organizationName = res.data.entityName;
	                    _this.RoleAvailabilityList();
	                }
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	                _this.isLoading = false;
	            });
	        }
	    };
	    AdminOfOrganizationListComponent.prototype.GetAdminOfOrganizationList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.adminOfOrganizationService.GetAdminOfOrganizationList(this.organizationHashId, this.DataListModel)
	            .subscribe(function (res) {
	            _this.organizationAdminList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.organizationAdminList = [];
	            _this.DataListModel.infoMessage = error;
	            _this.isLoading = false;
	        });
	    };
	    AdminOfOrganizationListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetAdminOfOrganizationList();
	    };
	    AdminOfOrganizationListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetAdminOfOrganizationList();
	    };
	    AdminOfOrganizationListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetAdminOfOrganizationList();
	    };
	    ;
	    AdminOfOrganizationListComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetAdminOfOrganizationList();
	    };
	    AdminOfOrganizationListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.adminOfOrganizationService.ExportAdminOfOrganizationList(this.organizationHashId, this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "OrganizationAdmin" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	        ;
	    };
	    AdminOfOrganizationListComponent.prototype.DeleteAdminOfOrganization = function (deleteOrganizationAdminList) {
	        var _this = this;
	        this.isLoading = true;
	        this.adminOfOrganizationService.DeleteAdminOfOrganization(this.organizationHashId, deleteOrganizationAdminList)
	            .subscribe(function (res) {
	            _this.DataListModel.currentPage = 1;
	            _this.GetAdminOfOrganizationList();
	            _this.popupMsg = _this.translate.instant('LblRecordRemovedSuccess', [_this.module]);
	            _this.ShowSuccessPopup();
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AdminOfOrganizationListComponent.prototype.OnParentCheck = function (isChecked) {
	        this.organizationAdminList.filter(function (x) { return x.isDeletable; }).forEach(function (x) { return x.isChecked = isChecked; });
	    };
	    AdminOfOrganizationListComponent.prototype.ShowAlertModal = function (deletePersonMasterHashId) {
	        if (deletePersonMasterHashId) {
	            this.deleteMessage = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
	            this.isMultipleDelete = false;
	            this.deletePersonMasterHashId = deletePersonMasterHashId;
	        }
	        else {
	            this.deleteMessage = this.translate.instant('LblRecordMultiplDeleteConfirmation', [this.module]);
	            this.isMultipleDelete = true;
	        }
	        this.alertModal.show();
	    };
	    AdminOfOrganizationListComponent.prototype.HideAlertModal = function () {
	        this.deletePersonMasterHashId = "";
	        this.alertModal.hide();
	    };
	    AdminOfOrganizationListComponent.prototype.SuccessAlertModalClick = function () {
	        var deleteAdminOfOrganizationList;
	        if (this.isMultipleDelete)
	            deleteAdminOfOrganizationList = this.organizationAdminList.filter(function (x) { return x.isChecked; }).map(function (x) { return x.personMasterHashId; });
	        else
	            deleteAdminOfOrganizationList.push(this.deletePersonMasterHashId);
	        this.DeleteAdminOfOrganization(deleteAdminOfOrganizationList);
	        this.alertModal.hide();
	    };
	    // Add Organization admin popup
	    AdminOfOrganizationListComponent.prototype.ShowAddOrganizationAdminModal = function () {
	        this.ShowInviteAdminModal();
	    };
	    AdminOfOrganizationListComponent.prototype.ToggleRoleAvailibility = function (personHashID, roleHashId, personRolesHashIds, roleName, userName) {
	        this.ToggleRolePersonHashID = personHashID;
	        this.ToggleRoleHashId = roleHashId;
	        this.ToggleUserName = userName;
	        this.ToggleRoleName = roleName;
	        if (this.CheckRole(personRolesHashIds, roleHashId)) {
	            this.toggleRoleMsg = this.translate.instant('LblDoYouWantToRemove', [userName, roleName]);
	            this.ToggleAddRole = false;
	            this.ShowToggleRolePopup();
	        }
	        else {
	            this.toggleRoleMsg = this.translate.instant('LblDoYouWantToAdd', [userName, roleName]);
	            this.ToggleAddRole = true;
	            this.ShowToggleRolePopup();
	        }
	    };
	    AdminOfOrganizationListComponent.prototype.ShowToggleRolePopup = function () {
	        this.toggleRolePopup.show();
	    };
	    AdminOfOrganizationListComponent.prototype.HideToggleRolePopup = function () {
	        this.ToggleRolePersonHashID = '';
	        this.ToggleRoleHashId = '';
	        this.ToggleUserName = '';
	        this.ToggleRoleName = '';
	        this.toggleRolePopup.hide();
	    };
	    AdminOfOrganizationListComponent.prototype.ConfirmToggleRolePopup = function () {
	        var _this = this;
	        if (this.ToggleAddRole) {
	            this.adminOfOrganizationService.AddAdminOfOrganizationRole(this.organizationHashId, this.ToggleRolePersonHashID, this.ToggleRoleHashId)
	                .subscribe(function (res) {
	                _this.GetAdminOfOrganizationList();
	                _this.popupMsg = _this.translate.instant('LblRoleAddedSuccess', [_this.ToggleUserName, _this.ToggleRoleName]);
	                _this.HideToggleRolePopup();
	                _this.ShowSuccessPopup();
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	                _this.isLoading = false;
	                _this.HideToggleRolePopup();
	            });
	        }
	        else {
	            this.adminOfOrganizationService.DeleteAdminOfOrganizationRole(this.organizationHashId, this.ToggleRolePersonHashID, this.ToggleRoleHashId)
	                .subscribe(function (res) {
	                _this.GetAdminOfOrganizationList();
	                _this.popupMsg = _this.translate.instant('LblRoleDeletedSuccess', [_this.ToggleUserName, _this.ToggleRoleName]);
	                _this.HideToggleRolePopup();
	                _this.ShowSuccessPopup();
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	                _this.isLoading = false;
	                _this.HideToggleRolePopup();
	            });
	        }
	    };
	    //Reset company admin password
	    AdminOfOrganizationListComponent.prototype.ResetPersonPassword = function (personHashID) {
	        var _this = this;
	        this.personService.ResetPersonPassword(personHashID)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblResetPasswordSuccess');
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblResetPasswordFailure');
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AdminOfOrganizationListComponent.prototype.ShowResetPasswordModal = function (personHashID) {
	        this.resetPasswordPersonHashId = personHashID;
	        this.popupMsg = this.translate.instant('LblResetPasswordConfirmation');
	        this.resetPasswordModal.show();
	    };
	    AdminOfOrganizationListComponent.prototype.HideResetPasswordModal = function () {
	        this.resetPasswordPersonHashId = "";
	        this.resetPasswordModal.hide();
	    };
	    AdminOfOrganizationListComponent.prototype.SuccessResetPasswordModalClick = function () {
	        this.resetPasswordModal.hide();
	        console.log(this.resetPasswordPersonHashId);
	        this.ResetPersonPassword(this.resetPasswordPersonHashId);
	    };
	    AdminOfOrganizationListComponent.prototype.ResendActivationMail = function (personHashID) {
	        var _this = this;
	        this.resetPasswordPersonHashId = personHashID;
	        this.personService.ReSendActivationMail(personHashID, this.organizationHashId)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblResendActivationMailSuccess');
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblResendActivationMailFailure');
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AdminOfOrganizationListComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    AdminOfOrganizationListComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    AdminOfOrganizationListComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    AdminOfOrganizationListComponent.prototype.ShowInviteAdminModal = function () {
	        this.inviteAdminModal.availableRoles = JSON.parse(JSON.stringify(this.roleAvailabilityList));
	        this.inviteAdminModal.availablePersons = '';
	        this.inviteAdminModal.show();
	    };
	    AdminOfOrganizationListComponent.prototype.HideInviteAdminModal = function () {
	        this.inviteAdminModal.hide();
	    };
	    AdminOfOrganizationListComponent.prototype.SuccessInviteAdminModalClick = function ($event) {
	        var _this = this;
	        var adminInvitation = new admin_to_invite_model_1.OrganizationAdminInvitationModel();
	        adminInvitation.emailAddress = $event.emailAddress;
	        adminInvitation.personHashId = $event.personHashId;
	        adminInvitation.roleHashIdList = $event.roleHashIdList;
	        adminInvitation.organizationHashId = this.organizationHashId;
	        this.adminOfOrganizationService.InviteAdminOfOrganization(adminInvitation)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblInvitationMailSuccess');
	                _this.HideInviteAdminModal();
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.inviteAdminModal.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	            _this.HideInviteAdminModal();
	        });
	    };
	    AdminOfOrganizationListComponent.prototype.SearchEmailAddress = function ($event) {
	        var _this = this;
	        var emailAddress = $event.emailAddress;
	        this.isLoading = true;
	        this.adminOfOrganizationService.GetPersonListToInvite(this.organizationHashId, emailAddress)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.inviteAdminModal.availablePersons = res.data;
	                _this.inviteAdminModal.errorModel = [];
	            }
	            else {
	                _this.inviteAdminModal.errorModel = res.error;
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AdminOfOrganizationListComponent.prototype.CheckRole = function (existingArray, currentRole) {
	        return existingArray.some(function (x) { return x == currentRole; });
	    };
	    Object.defineProperty(AdminOfOrganizationListComponent.prototype, "isResetCookieAccess", {
	        get: function () {
	            if (this.organizationAdminList) {
	                return this.organizationAdminList.some(function (x) { return !x.twoFaDisabled; });
	            }
	            else {
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(AdminOfOrganizationListComponent.prototype, "isTwoFaResetKeyAccess", {
	        get: function () {
	            if (this.organizationAdminList) {
	                return this.organizationAdminList.some(function (x) { return x.resetKeyEnabled; });
	            }
	            else {
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    AdminOfOrganizationListComponent.prototype.ResetPersonCookies = function (personHashID) {
	        var _this = this;
	        ;
	        this.personService.ResetTwoFaCookie(personHashID).subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblCookieResetSuccess');
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblCookieResetFailed');
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AdminOfOrganizationListComponent.prototype.ResetPersonTwoFA = function (personHashID) {
	        var _this = this;
	        this.personService.ResetTwoFaKey(personHashID).subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblKeyResetSuccess');
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblKeyResetFailed');
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    __decorate([
	        core_1.ViewChild('alertModal'), 
	        __metadata('design:type', Object)
	    ], AdminOfOrganizationListComponent.prototype, "alertModal", void 0);
	    __decorate([
	        core_1.ViewChild('resetPasswordModal'), 
	        __metadata('design:type', Object)
	    ], AdminOfOrganizationListComponent.prototype, "resetPasswordModal", void 0);
	    __decorate([
	        core_1.ViewChild('inActiveModal'), 
	        __metadata('design:type', Object)
	    ], AdminOfOrganizationListComponent.prototype, "inActiveModal", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], AdminOfOrganizationListComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild('toggleRolePopup'), 
	        __metadata('design:type', Object)
	    ], AdminOfOrganizationListComponent.prototype, "toggleRolePopup", void 0);
	    __decorate([
	        core_1.ViewChild('inviteAdminModal'), 
	        __metadata('design:type', Object)
	    ], AdminOfOrganizationListComponent.prototype, "inviteAdminModal", void 0);
	    AdminOfOrganizationListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-admin-of-organization',
	            template: __webpack_require__(982),
	            providers: [admin_of_organization_service_1.AdminOfOrganizationService, person_service_1.PersonService, organization_service_1.OrganizationService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof admin_of_organization_service_1.AdminOfOrganizationService !== 'undefined' && admin_of_organization_service_1.AdminOfOrganizationService) === 'function' && _a) || Object, (typeof (_b = typeof person_service_1.PersonService !== 'undefined' && person_service_1.PersonService) === 'function' && _b) || Object, (typeof (_c = typeof organization_service_1.OrganizationService !== 'undefined' && organization_service_1.OrganizationService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object, (typeof (_e = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _f) || Object, (typeof (_g = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _g) || Object])
	    ], AdminOfOrganizationListComponent);
	    return AdminOfOrganizationListComponent;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.AdminOfOrganizationListComponent = AdminOfOrganizationListComponent;


/***/ },
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var jquery_helper_service_1 = __webpack_require__(67);
	var AdminOfOrganizationService = (function () {
	    function AdminOfOrganizationService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	        this.JQueryHelper = new jquery_helper_service_1.JQueryHelperService();
	    }
	    AdminOfOrganizationService.prototype.GetAdminOfOrganizationList = function (organizationHashID, input) {
	        var getOrganizationAdminUrl = config_1.WeGoConfig.API_GET_ADMIN_OF_ORGANIZATION_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getOrganizationAdminUrl = getOrganizationAdminUrl + "?" + queryString + "&organizationHashID=" + organizationHashID;
	        }
	        else {
	            getOrganizationAdminUrl = getOrganizationAdminUrl + "?organizationHashID=" + organizationHashID;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getOrganizationAdminUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminOfOrganizationService.prototype.DeleteAdminOfOrganization = function (organizationHashID, selectedAdminOfCustomerList) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        var urlDeleteAdminOfOrganization = config_1.WeGoConfig.API_POST_DELETE_ADMIN_OF_ORGANIZATION + "?organizationHashID=" + organizationHashID;
	        return this.http.post(urlDeleteAdminOfOrganization, selectedAdminOfCustomerList, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminOfOrganizationService.prototype.ExportAdminOfOrganizationList = function (organizationHashID, input) {
	        input.currentPage = 0;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var exportToCSVOrganizationAdminUrl = config_1.WeGoConfig.API_EXPORT_ADMIN_OF_ORGANIZATION_LIST + "?" + queryString + "&organizationHashID=" + organizationHashID;
	        var headers = this.authService.GetHeader('text/csv');
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(exportToCSVOrganizationAdminUrl, options);
	    };
	    AdminOfOrganizationService.prototype.GetAllRoleAvailability = function (input, organizationHashID) {
	        var getRoleAvailabilityListUrl = config_1.WeGoConfig.API_GET_ORGANIZATION_ROLEAVAILABILITY_LIST + "?organizationHashID=" + organizationHashID;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getRoleAvailabilityListUrl = getRoleAvailabilityListUrl + "&" + queryString;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getRoleAvailabilityListUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminOfOrganizationService.prototype.DeleteAdminOfOrganizationRole = function (organizationHashID, personHashId, roleHashId) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        var urlDeleteAdminOfOrganization = config_1.WeGoConfig.API_POST_DELETE_ADMIN_OF_ORGANIZATION_ROLE + "?organizationHashID=" + organizationHashID + "&personHashId=" + personHashId + "&roleHashId=" + roleHashId;
	        return this.http.get(urlDeleteAdminOfOrganization, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminOfOrganizationService.prototype.AddAdminOfOrganizationRole = function (organizationHashID, personHashId, roleHashId) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        var urlAddAdminOfOrganization = config_1.WeGoConfig.API_POST_ADD_ADMIN_OF_ORGANIZATION_ROLE + "?organizationHashID=" + organizationHashID + "&personHashId=" + personHashId + "&roleHashId=" + roleHashId;
	        ;
	        return this.http.get(urlAddAdminOfOrganization, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminOfOrganizationService.prototype.GetPersonListToInvite = function (organizationHashID, emailAddress) {
	        var getOrganizationAdminUrl = config_1.WeGoConfig.API_GET_ORGANIZATION_PERSON_TO_INVITE_LIST;
	        getOrganizationAdminUrl = getOrganizationAdminUrl + "?organizationHashID=" + organizationHashID + "&emailAddress=" + emailAddress;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getOrganizationAdminUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminOfOrganizationService.prototype.InviteAdminOfOrganization = function (organizationAdminInvitationModel) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        var urlInviteAdminOfOrganization = config_1.WeGoConfig.API_POST_INVITE_ADMIN_OF_ORGANIZATION;
	        return this.http.post(urlInviteAdminOfOrganization, organizationAdminInvitationModel, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    AdminOfOrganizationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], AdminOfOrganizationService);
	    return AdminOfOrganizationService;
	    var _a, _b;
	}());
	exports.AdminOfOrganizationService = AdminOfOrganizationService;


/***/ },
/* 982 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ breadCrumbList}} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"urlOrganizationList\">\r\n            <i class=\"fa fa-user-circle fa-fw\"></i> {{organizationList }}</a>\r\n        </li>\r\n        <li class=\"active\"> {{ breadCrumbList}} </li>\r\n\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25 \">\r\n      <!-- <a class=\"btn btn-highlight navbar-right\" (click)=\"ShowAddOrganizationAdminModal()\">{{ 'LblInvite' | translate }}</a> -->\r\n      <wego-authorized-link [LinkModel]=\"addOrganizationAdminLink\" (onClick)=\"ShowAddOrganizationAdminModal()\"></wego-authorized-link>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <h4>\r\n          <label>{{ 'LblOrganization' | translate }} : </label> {{organizationName}}</h4>\r\n        <p class=\"text-success\">{{ message }}</p>\r\n        <wego-search-list [IsDeleted]=\"isDeleteAccess\" [IsDeleteEnabled]=\"isAnyChecked\" (OnDeleteAll)=\"ShowAlertModal()\"\r\n          (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\"\r\n          [SearchTerm]=\"DataListModel.searchTerm\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center parent-checkbox\">\r\n                  <input [disabled]=\"!isDeleteAccess\" type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\"\r\n                    (change)=\"OnParentCheck($event.target.checked)\">\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('firstName')\">\r\n                  {{ 'LblFirstName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'firstName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('lastName')\">\r\n                  {{ 'LblLastName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'lastName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('userName')\">\r\n                  {{ 'LblUserName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'userName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th *ngIf=\"isResetCookieAccess\" class=\"text-center\">{{ 'LblResetCookie' |\r\n                  translate }}</th>\r\n                <th *ngIf=\"isTwoFaResetKeyAccess\" class=\"text-center\">{{ 'LblResetTwoFA' |\r\n                  translate }}</th>\r\n\r\n                <th class=\"text-center\">{{ 'LblResetPassword' | translate }}</th>\r\n                <th *ngFor=\"let role of roleAvailabilityList\" class=\"text-center\">\r\n                  {{role.presentationName}}\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let organizationAdmin of organizationAdminList\">\r\n                  <td class=\"text-center\">\r\n                    <input *ngIf=\"!organizationAdmin.isDeletable\" type=\"checkbox\" name=\"isActive\" disabled>\r\n                    <input *ngIf=\"organizationAdmin.isDeletable\" type=\"checkbox\" name=\"isActive\" [(ngModel)]=\"organizationAdmin.isChecked\">\r\n                  </td>\r\n                  <td>{{ organizationAdmin.firstName }}</td>\r\n                  <td>{{ organizationAdmin.lastName }}</td>\r\n                  <td>{{ organizationAdmin.userName }}</td>\r\n                  <td class=\"text-center\" *ngIf=\"isResetCookieAccess\">\r\n                    <a *ngIf=\"!organizationAdmin.twoFaDisabled\" class=\"btn btn-green btn-xs cursor-pointer\" (click)=\"ResetPersonCookies(organizationAdmin.personMasterHashId)\">\r\n                      {{ 'LblResetCookie' | translate}}\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\" *ngIf=\"isTwoFaResetKeyAccess\">\r\n                    <a *ngIf=\"organizationAdmin.resetKeyEnabled\" class=\"btn btn-green btn-xs cursor-pointer\" (click)=\"ResetPersonTwoFA(organizationAdmin.personMasterHashId)\">\r\n                      {{ 'LblResetTwoFA' | translate}}\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a class=\"cursor-pointer\">\r\n                      <i class=\"fa fa-refresh fa-fw text-success\" (click)=\"ShowResetPasswordModal(organizationAdmin.personMasterHashId)\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td *ngFor=\"let role of roleAvailabilityList\" class=\"text-center\">\r\n                    <a [ngClass]=\"{ 'cursor-pointer': organizationAdmin.isEditable }\" class=\"cursor-pointer\">\r\n                      <i *ngIf=\"!organizationAdmin.isEditable\" class=\"fa fa-fw\" [ngClass]=\"{ 'fa-check text-success': CheckRole(organizationAdmin.rolesHashIds, role.roleHashId), \r\n                    'fa-times text-danger' : !CheckRole(organizationAdmin.rolesHashIds, role.roleHashId) }\"></i>\r\n                      <i *ngIf=\"organizationAdmin.isEditable\" class=\"fa fa-fw\" (click)=\"ToggleRoleAvailibility(organizationAdmin.personMasterHashId,role.roleHashId,organizationAdmin.rolesHashIds,role.presentationName,organizationAdmin.userName)\"\r\n                        [ngClass]=\"{ 'fa-check text-success': CheckRole(organizationAdmin.rolesHashIds, role.roleHashId), \r\n                    'fa-times text-danger' : !CheckRole(organizationAdmin.rolesHashIds, role.roleHashId) }\"></i>\r\n                    </a>\r\n                  </td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" [attr.colspan]=\"5+roleColumns\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\"\r\n                [(ngModel)]=\"DataListModel.currentPage\" [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\"\r\n                previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\" lastText=\"&raquo;\" [rotate]=\"false\"\r\n                (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<wego-confirm-popup #alertModal [popupMsg]=\"deleteMessage\" (onConfirm)=\"SuccessAlertModalClick()\" (onReject)=\"HideAlertModal()\"></wego-confirm-popup>\r\n\r\n<wego-confirm-popup #resetPasswordModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessResetPasswordModalClick()\" (onReject)=\"HideResetPasswordModal()\"></wego-confirm-popup>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" [popupTitle]=\"popupTitle\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n\r\n<wego-confirm-popup #toggleRolePopup [popupMsg]=\"toggleRoleMsg\" (onConfirm)=\"ConfirmToggleRolePopup()\" (onReject)=\"HideToggleRolePopup()\"></wego-confirm-popup>\r\n\r\n<wego-invite-admin-popup #inviteAdminModal [popupTitle]=\"inviteTitle\" (onEmailSearch)=\"SearchEmailAddress($event)\"\r\n  (onConfirm)=\"SuccessInviteAdminModalClick($event)\" (onReject)=\"HideInviteAdminModal()\"></wego-invite-admin-popup>";

/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var config_1 = __webpack_require__(60);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_2 = __webpack_require__(60);
	var common_1 = __webpack_require__(22);
	var organization_service_1 = __webpack_require__(614);
	var organization_subscription_service_1 = __webpack_require__(984);
	var modal_1 = __webpack_require__(537);
	var OrganizationSubscriptionComponent = (function () {
	    function OrganizationSubscriptionComponent(organizationService, organizationSubscriptionService, activeRoute, router, authService, translate, locationService) {
	        this.organizationService = organizationService;
	        this.organizationSubscriptionService = organizationSubscriptionService;
	        this.activeRoute = activeRoute;
	        this.router = router;
	        this.authService = authService;
	        this.translate = translate;
	        this.locationService = locationService;
	        this.OrganizationHashId = "";
	    }
	    Object.defineProperty(OrganizationSubscriptionComponent.prototype, "isAnyChecked", {
	        get: function () {
	            if (this.subscriptionList) {
	                var isCheck = this.subscriptionList.some(function (x) { return x.isChecked == true; });
	                if (isCheck) {
	                    if (this.subscriptionList.every(function (x) { return x.isChecked == true; }))
	                        this.isParentCheck = true;
	                    else
	                        this.isParentCheck = false;
	                }
	                else {
	                    this.isParentCheck = false;
	                }
	                return isCheck;
	            }
	            else {
	                this.isParentCheck = false;
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    OrganizationSubscriptionComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.module = this.translate.instant('LblSubscription');
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = ["name", "groupName", "timeInterval", "invoiceInterval", "paymentInterval"];
	        this.urlDefaultPage = this.authService.GetURL(config_2.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlOrganizationList = this.authService.GetURL(config_2.ApplicationRouteURL.URL_ORGANIZATION_LIST);
	        this.activeRoute
	            .params
	            .subscribe(function (params) {
	            var OrganizationHashId = params['id'] || '';
	            if (OrganizationHashId != '') {
	                _this.OrganizationHashId = OrganizationHashId;
	                _this.addOrganizationSubscriptionLink = new config_1.WeGoAuthorizedLink("", config_1.Permission.PR_ORGANIZATION_SUBSCRIPTION_OVERVIEW, config_1.PermissionType.INSERT, 'btn btn-highlight navbar-right', 'LblAddNew', config_1.Entity.ORGANIZATION, _this.OrganizationHashId);
	                _this.GetSubscriptionListByOrganizationList();
	                _this.GetOrganizationDetailByHashId();
	            }
	        });
	    };
	    OrganizationSubscriptionComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.organizationSubscriptionService.ExportSubscriptionList(this.OrganizationHashId, this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "SubscriptionToOrganization" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    OrganizationSubscriptionComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetSubscriptionListByOrganizationList();
	    };
	    OrganizationSubscriptionComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetSubscriptionListByOrganizationList();
	    };
	    OrganizationSubscriptionComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetSubscriptionListByOrganizationList();
	    };
	    ;
	    OrganizationSubscriptionComponent.prototype.OnPagingChange = function (event) {
	        console.log(this.DataListModel);
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetSubscriptionListByOrganizationList();
	    };
	    OrganizationSubscriptionComponent.prototype.OnParentCheck = function (isChecked) {
	        this.subscriptionList.forEach(function (x) { return x.isChecked = isChecked; });
	    };
	    OrganizationSubscriptionComponent.prototype.DeleteSubscriptionMapping = function (subscriptionMapHashId) {
	        var _this = this;
	        this.isLoading = true;
	        this.organizationSubscriptionService.DeleteSubscriptionMapping(subscriptionMapHashId)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.apiResponse = res;
	                _this.DataListModel.currentPage = 1;
	                _this.GetSubscriptionListByOrganizationList();
	                _this.popupMsg = _this.translate.instant('LblRecordRemovedSuccess', [_this.module]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.validationMessage = res.error;
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.ShowAlertModal();
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    OrganizationSubscriptionComponent.prototype.ShowDeleteModal = function (subscriptionMapHashId) {
	        this.deleteSubscriptionMapHashId = subscriptionMapHashId;
	        this.popupMsg = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
	        this.deleteModal.show();
	    };
	    OrganizationSubscriptionComponent.prototype.HideDeleteModal = function () {
	        this.deleteSubscriptionMapHashId = "";
	        this.deleteModal.hide();
	    };
	    OrganizationSubscriptionComponent.prototype.SuccessModalClick = function () {
	        this.DeleteSubscriptionMapping(this.deleteSubscriptionMapHashId);
	        this.deleteModal.hide();
	    };
	    OrganizationSubscriptionComponent.prototype.GetSubscriptionListByOrganizationList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.organizationSubscriptionService.GetSubscriptionListByOrganizationHashId(this.OrganizationHashId, this.DataListModel)
	            .subscribe(function (res) {
	            _this.subscriptionList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    OrganizationSubscriptionComponent.prototype.GetOrganizationDetailByHashId = function () {
	        var _this = this;
	        this.organizationService.GetOrganizationBasicDetail(this.OrganizationHashId)
	            .subscribe(function (res) {
	            _this.organizationName = res.data.entityName;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    OrganizationSubscriptionComponent.prototype.ShowAssignSubscriptionToOrganizationModal = function () {
	        this.assignSubscriptionToOrganizationModal.OrganizationHashId = this.OrganizationHashId;
	        this.assignSubscriptionToOrganizationModal.show();
	    };
	    OrganizationSubscriptionComponent.prototype.SuccessAssignSubscriptionModal = function ($event) {
	        this.GetSubscriptionListByOrganizationList();
	        this.popupMsg = this.translate.instant('LblRecordAddedSuccess', [this.module]); //$event.SuccessMessage;
	        this.ShowSuccessPopup();
	    };
	    OrganizationSubscriptionComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    OrganizationSubscriptionComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	        // this.OnBackClick();
	    };
	    OrganizationSubscriptionComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	        // this.OnBackClick();
	    };
	    OrganizationSubscriptionComponent.prototype.SuccessAlertModalClick = function () {
	        this.alertModal.hide();
	    };
	    OrganizationSubscriptionComponent.prototype.ShowAlertModal = function () {
	        this.isLoading = false;
	        this.alertModal.show();
	    };
	    OrganizationSubscriptionComponent.prototype.OnBackClick = function () {
	        this.locationService.back();
	    };
	    OrganizationSubscriptionComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    __decorate([
	        core_1.ViewChild('deleteModal'), 
	        __metadata('design:type', Object)
	    ], OrganizationSubscriptionComponent.prototype, "deleteModal", void 0);
	    __decorate([
	        core_1.ViewChild('assignSubscriptionToOrganizationModal'), 
	        __metadata('design:type', Object)
	    ], OrganizationSubscriptionComponent.prototype, "assignSubscriptionToOrganizationModal", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], OrganizationSubscriptionComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild('alertModal'), 
	        __metadata('design:type', (typeof (_a = typeof modal_1.ModalDirective !== 'undefined' && modal_1.ModalDirective) === 'function' && _a) || Object)
	    ], OrganizationSubscriptionComponent.prototype, "alertModal", void 0);
	    OrganizationSubscriptionComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-organization-subscription-mapping',
	            template: __webpack_require__(985),
	            providers: [organization_service_1.OrganizationService, organization_subscription_service_1.OrganizationSubscriptionService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof organization_service_1.OrganizationService !== 'undefined' && organization_service_1.OrganizationService) === 'function' && _b) || Object, (typeof (_c = typeof organization_subscription_service_1.OrganizationSubscriptionService !== 'undefined' && organization_subscription_service_1.OrganizationSubscriptionService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object, (typeof (_e = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _e) || Object, (typeof (_f = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _f) || Object, (typeof (_g = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _g) || Object, (typeof (_h = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _h) || Object])
	    ], OrganizationSubscriptionComponent);
	    return OrganizationSubscriptionComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h;
	}());
	exports.OrganizationSubscriptionComponent = OrganizationSubscriptionComponent;


/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var OrganizationSubscriptionService = (function () {
	    function OrganizationSubscriptionService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    OrganizationSubscriptionService.prototype.GetSubscriptionListByOrganizationHashId = function (organizationHashId, input) {
	        var getSubscriptionListForOrganization = config_1.WeGoConfig.API_GET_SUBSCRIPTION_LIST_FOR_ORGANIZATION;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getSubscriptionListForOrganization = getSubscriptionListForOrganization + "?" + queryString + "&organizationHashId=" + organizationHashId;
	        }
	        else {
	            getSubscriptionListForOrganization = getSubscriptionListForOrganization + "?organizationHashId=" + organizationHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getSubscriptionListForOrganization, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OrganizationSubscriptionService.prototype.GetSubscriptionListByOrganizationToInstance = function (organizationHashId, input) {
	        var getSubscriptionListForOrganization = config_1.WeGoConfig.API_GET_SUBSCRIPTION_LIST_FOR_ORGANIZATION_TO_INSTANCE;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getSubscriptionListForOrganization = getSubscriptionListForOrganization + "?" + queryString + "&organizationHashId=" + organizationHashId;
	        }
	        else {
	            getSubscriptionListForOrganization = getSubscriptionListForOrganization + "?organizationHashId=" + organizationHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getSubscriptionListForOrganization, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OrganizationSubscriptionService.prototype.AssignSubscriptionToOrganization = function (organizationSubscriptionModel) {
	        var body = organizationSubscriptionModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_POST_ORGANIZATION_SUBSCRIPTION_DETAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OrganizationSubscriptionService.prototype.ExportSubscriptionList = function (organizationHashId, input) {
	        input.currentPage = 0;
	        var getSubscriptionUrl = config_1.WeGoConfig.API_EXPORT_ORGANIZATION_SUBSCRIPTION_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getSubscriptionUrl = getSubscriptionUrl + "?" + queryString + "&organizationHashId=" + organizationHashId;
	        }
	        else {
	            getSubscriptionUrl = getSubscriptionUrl + "?organizationHashId=" + organizationHashId;
	        }
	        var headers = this.authService.GetHeader('text/csv');
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getSubscriptionUrl, options);
	    };
	    OrganizationSubscriptionService.prototype.DeleteSubscriptionMapping = function (subscriptionMapHashId) {
	        var getSubscriptionToOrganizationUrl = config_1.WeGoConfig.API_DELETE_ORGANIZATION_SUBSCRIPTION_MAPPING + "?subscriptionMapHashId=" + subscriptionMapHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getSubscriptionToOrganizationUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OrganizationSubscriptionService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], OrganizationSubscriptionService);
	    return OrganizationSubscriptionService;
	    var _a, _b;
	}());
	exports.OrganizationSubscriptionService = OrganizationSubscriptionService;


/***/ },
/* 985 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ 'LblSubscription' | translate }} {{ 'LblList' | translate }} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li><a [routerLink]=\"urlDefaultPage\"><i class=\"fa fa-dashboard\"></i>{{ 'LblHome' | translate }}</a></li>\r\n        <li><a [routerLink]=\"urlOrganizationList\"><i class=\"fa fa-group fa-fw\"></i> {{ 'LblOrganization' | translate }} {{ 'LblList' | translate }}</a></li>\r\n        <li class=\"active\"> {{ 'LblSubscription' | translate }} {{ 'LblList' | translate }}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25 \">\r\n      <!-- <a class=\"btn btn-highlight navbar-right\" (click)=\"ShowAssignSubscriptionToOrganizationModal()\">{{ 'LblAddNew' | translate }}</a> -->\r\n      <wego-authorized-link  [LinkModel]=\"addOrganizationSubscriptionLink\" (onClick)=\"ShowAssignSubscriptionToOrganizationModal()\"></wego-authorized-link>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <h4><label>{{ 'LblOrganization' | translate }} : </label> {{organizationName}}</h4>\r\n        <p class=\"text-success\">{{ message }}</p>\r\n        <!-- [IsDeleted]=\"true\" [IsDeleteEnabled]=\"isAnyChecked\" (OnDeleteAll)=\"ShowDeleteModal()\" -->\r\n        <wego-search-list (OnSearch)=\"OnSearch($event)\"\r\n          (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('groupName')\">\r\n                  {{ 'LblSharedVehicleGroup' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'groupName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('name')\">\r\n                  {{ 'LblSubscriptionName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'name'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('amount')\">\r\n                  {{ 'LblAmount' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'amount'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('timeInterval')\">\r\n                  {{'LblSubscriptionInterval' | translate}}\r\n                  <wego-sort-list [FieldName]=\"'timeInterval'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('paymentInterval')\">\r\n                  {{ 'LblPaymentInterval' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'paymentInterval'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('invoiceInterval')\">\r\n                  {{ 'LblInvoicInterval' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'invoiceInterval'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <!-- <th class=\"cursor-pointer\" (click)=\"OnSort('startDateTimeUTC')\">\r\n                  {{'LblSubscriptionStartDate' | translate}}\r\n                  <wego-sort-list [FieldName]=\"'startDateTimeUTC'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('endDateTimeUTC')\">\r\n                  {{'LblsubscribeEndDate' | translate}}\r\n                  <wego-sort-list [FieldName]=\"'endDateTimeUTC'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th> -->\r\n                <th class=\"text-center\">{{ 'LblDelete' | translate }}</th>\r\n\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let subscription of subscriptionList\">\r\n                  <td>{{ subscription.groupName }}</td>\r\n                  <td>{{ subscription.name }}</td>\r\n                  <td>{{ subscription.amount | decimalFormatter }}</td>\r\n                  <td>{{ subscription.timeInterval }}</td>\r\n                  <td>{{ subscription.paymentInterval }}</td>\r\n                  <td>{{ subscription.invoiceInterval }}</td>\r\n                  <!-- <td>{{ subscription.startDateTime }}</td>\r\n                  <td>{{ subscription.endDateTime }}</td> -->\r\n\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"subscription.isDeletable\" class=\"cursor-pointer\" (click)=\"ShowDeleteModal(subscription.subscriptionMapHashId)\">\r\n                      <i class=\"fa fa-trash-o fa-fw text-danger\"></i>\r\n                    </a>\r\n                  </td>\r\n\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"7\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<wego-confirm-popup #deleteModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessModalClick()\" (onReject)=\"HideDeleteModal()\"></wego-confirm-popup>\r\n\r\n<wego-assign-subscription-to-organization-popup #assignSubscriptionToOrganizationModal (OnSuccessSelect)=\"SuccessAssignSubscriptionModal($event)\"></wego-assign-subscription-to-organization-popup>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n\r\n<wego-success-popup #alertModal [popupTitle]=\"popupTitle\" [popupMsg]=\"validationMessage\" (onConfirm)=\"SuccessAlertModalClick()\"></wego-success-popup>";

/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var config_1 = __webpack_require__(60);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_2 = __webpack_require__(60);
	var common_1 = __webpack_require__(22);
	var organization_service_1 = __webpack_require__(614);
	var organization_driver_service_1 = __webpack_require__(987);
	var modal_1 = __webpack_require__(537);
	var person_service_1 = __webpack_require__(771);
	var admin_to_invite_model_1 = __webpack_require__(963);
	var OrganizationDriverListComponent = (function () {
	    function OrganizationDriverListComponent(organizationService, organizationDriverService, personService, activeRoute, router, authService, translate, locationService) {
	        this.organizationService = organizationService;
	        this.organizationDriverService = organizationDriverService;
	        this.personService = personService;
	        this.activeRoute = activeRoute;
	        this.router = router;
	        this.authService = authService;
	        this.translate = translate;
	        this.locationService = locationService;
	        this.OrganizationHashId = '';
	        this.roleLevel = config_1.RoleLevel;
	    }
	    Object.defineProperty(OrganizationDriverListComponent.prototype, "isAnyChecked", {
	        get: function () {
	            if (this.driverList) {
	                var isCheck = this.driverList.some(function (x) { return x.isChecked == true; });
	                if (isCheck) {
	                    if (this.driverList.every(function (x) { return x.isChecked == true; }))
	                        this.isParentCheck = true;
	                    else
	                        this.isParentCheck = false;
	                }
	                else {
	                    this.isParentCheck = false;
	                }
	                return isCheck;
	            }
	            else {
	                this.isParentCheck = false;
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    OrganizationDriverListComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.module = this.translate.instant('LblDriver');
	        this.inviteTitle =
	            this.translate.instant('LblInvite') +
	                ' ' +
	                this.translate.instant('LblDriver');
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = ['driverName', 'firstName', 'lastName'];
	        this.urlDefaultPage = this.authService.GetURL(config_2.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlOrganizationList = this.authService.GetURL(config_2.ApplicationRouteURL.URL_ORGANIZATION_LIST);
	        this.LblAddDriverToOrganization = this.translate.instant('LblAddDriverToOrganization');
	        this.sub = this.activeRoute.params.subscribe(function (params) {
	            var OrganizationHashId = params['id'] || '';
	            if (OrganizationHashId != '') {
	                _this.OrganizationHashId = OrganizationHashId;
	                _this.GetDriverListByOrganizationList();
	                _this.GetOrganizationDetailByHashId();
	                _this.addOrganizationDriverLink = new config_2.WeGoAuthorizedLink('', config_2.Permission.PR_ORGANIZATION_DRIVER_OVERVIEW, config_2.PermissionType.INSERT, 'btn btn-highlight navbar-right', 'LblAddDriver', config_2.Entity.ORGANIZATION, _this.OrganizationHashId);
	            }
	        });
	    };
	    OrganizationDriverListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.organizationDriverService
	            .ExportDriverList(this.OrganizationHashId, this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = 'DriverToOrganization' + new Date().toISOString() + '.csv';
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    OrganizationDriverListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetDriverListByOrganizationList();
	    };
	    OrganizationDriverListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetDriverListByOrganizationList();
	    };
	    OrganizationDriverListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetDriverListByOrganizationList();
	    };
	    OrganizationDriverListComponent.prototype.OnPagingChange = function (event) {
	        console.log(this.DataListModel);
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetDriverListByOrganizationList();
	    };
	    OrganizationDriverListComponent.prototype.OnParentCheck = function (isChecked) {
	        this.driverList
	            .filter(function (x) { return x.isDeletable; })
	            .forEach(function (x) { return (x.isChecked = isChecked); });
	    };
	    OrganizationDriverListComponent.prototype.DeleteDriverMapping = function (organizationToDriverMapHashId) {
	        var _this = this;
	        this.isLoading = true;
	        this.organizationDriverService
	            .DeleteDriverMapping(organizationToDriverMapHashId)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.apiResponse = res;
	                _this.DataListModel.currentPage = 1;
	                _this.GetDriverListByOrganizationList();
	                _this.ShowDeleteSuccessPopup();
	            }
	            else {
	                _this.validationMessage = res.error;
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.ShowAlertModal();
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    OrganizationDriverListComponent.prototype.ShowDeleteModal = function (organizationToDriverMapHashId) {
	        this.deleteDriverMapHashId = organizationToDriverMapHashId;
	        this.popupMsg = this.translate.instant('LblRecordDeleteConfirmation', [
	            this.module
	        ]);
	        this.deleteModal.show();
	    };
	    OrganizationDriverListComponent.prototype.HideDeleteModal = function () {
	        this.deleteDriverMapHashId = '';
	        this.deleteModal.hide();
	    };
	    OrganizationDriverListComponent.prototype.SuccessModalClick = function () {
	        this.DeleteDriverMapping(this.deleteDriverMapHashId);
	        this.deleteModal.hide();
	    };
	    OrganizationDriverListComponent.prototype.GetDriverListByOrganizationList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.organizationDriverService
	            .GetDriverListByOrganizationHashId(this.OrganizationHashId, this.DataListModel)
	            .subscribe(function (res) {
	            _this.driverList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    OrganizationDriverListComponent.prototype.GetOrganizationDetailByHashId = function () {
	        var _this = this;
	        this.organizationService
	            .GetOrganizationBasicDetail(this.OrganizationHashId)
	            .subscribe(function (res) {
	            _this.organizationName = res.data.entityName;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    // public ShowAssignDriverToOrganizationModal() {
	    //   this.assignDriverToOrganizationModal.OrganizationHashId = this.OrganizationHashId;
	    //   this.assignDriverToOrganizationModal.show();
	    // }
	    OrganizationDriverListComponent.prototype.ShowAddOrganizationDriverModal = function () {
	        this.ShowInviteDriverModal();
	    };
	    OrganizationDriverListComponent.prototype.SuccessAssignDriverModal = function ($event) {
	        this.GetDriverListByOrganizationList();
	        this.popupMsg = this.translate.instant('LblRecordAddedSuccess', [
	            this.module
	        ]);
	        this.ShowSuccessPopup();
	    };
	    OrganizationDriverListComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    OrganizationDriverListComponent.prototype.ShowDeleteSuccessPopup = function () {
	        this.popupMsg = this.translate.instant('LblRecordRemovedSuccess', [
	            this.module
	        ]);
	        this.successPopup.show();
	    };
	    OrganizationDriverListComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    OrganizationDriverListComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    OrganizationDriverListComponent.prototype.SuccessAlertModalClick = function () {
	        this.alertModal.hide();
	    };
	    OrganizationDriverListComponent.prototype.ShowAlertModal = function () {
	        this.isLoading = false;
	        this.alertModal.show();
	    };
	    OrganizationDriverListComponent.prototype.OnBackClick = function () {
	        this.locationService.back();
	    };
	    OrganizationDriverListComponent.prototype.ShowResetPasswordModal = function (personHashID) {
	        this.resetPasswordPersonHashId = personHashID;
	        this.popupMsg = this.translate.instant('LblResetPasswordConfirmation');
	        this.resetPasswordModal.show();
	    };
	    OrganizationDriverListComponent.prototype.HideResetPasswordModal = function () {
	        this.resetPasswordPersonHashId = '';
	        this.resetPasswordModal.hide();
	    };
	    OrganizationDriverListComponent.prototype.SuccessResetPasswordModalClick = function () {
	        this.resetPasswordModal.hide();
	        this.ResetPersonPassword(this.resetPasswordPersonHashId);
	    };
	    //Reset group admin password
	    OrganizationDriverListComponent.prototype.ResetPersonPassword = function (personHashID) {
	        var _this = this;
	        this.personService.ResetPersonPassword(personHashID).subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblResetPasswordSuccess');
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblResetPasswordFailure');
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    OrganizationDriverListComponent.prototype.ResendActivationMail = function (personHashID) {
	        var _this = this;
	        this.resetPasswordPersonHashId = personHashID;
	        this.personService.ReSendActivationMail(personHashID, this.OrganizationHashId).subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.translate.instant('LblResendActivationMailSuccess');
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblResendActivationMailFailure');
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.ShowSuccessPopup();
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    OrganizationDriverListComponent.prototype.ShowInviteDriverModal = function () {
	        this.inviteDriverModal.availableRoles = [];
	        this.inviteDriverModal.availablePersons = '';
	        this.inviteDriverModal.show();
	    };
	    OrganizationDriverListComponent.prototype.HideInviteDriverModal = function () {
	        this.inviteDriverModal.hide();
	    };
	    OrganizationDriverListComponent.prototype.SuccessInviteDriverModalClick = function ($event) {
	        var _this = this;
	        var driverInvitation = new admin_to_invite_model_1.OrganizationDriverInvitationModel();
	        driverInvitation.emailAddress = $event.emailAddress;
	        driverInvitation.personHashId = $event.personHashId;
	        driverInvitation.roleHashIdList = [];
	        driverInvitation.organizationHashId = this.OrganizationHashId;
	        driverInvitation.userName = $event.UserName;
	        driverInvitation.rfidTagId = $event.rfidTagId;
	        this.organizationDriverService
	            .InviteAdminOfOrganization(driverInvitation)
	            .subscribe(function (res) {
	            if (res.data) {
	                if (driverInvitation.personHashId == '0')
	                    _this.popupMsg = _this.translate.instant('LblAddDriverSuccessMsg');
	                else {
	                    _this.popupMsg = _this.translate.instant('LblExistingDriverAddSuccessMsg');
	                }
	                _this.HideInviteDriverModal();
	                _this.ShowSuccessPopup();
	                _this.GetDriverListByOrganizationList();
	            }
	            else {
	                _this.inviteDriverModal.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	            _this.HideInviteDriverModal();
	        });
	    };
	    OrganizationDriverListComponent.prototype.SearchEmailAddress = function ($event) {
	        var _this = this;
	        var emailAddress = $event.emailAddress;
	        this.isLoading = true;
	        this.organizationDriverService
	            .GetPersonListToInvite(this.OrganizationHashId, emailAddress)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.inviteDriverModal.availablePersons = res.data;
	                _this.inviteDriverModal.errorModel = [];
	            }
	            else {
	                _this.inviteDriverModal.errorModel = res.error;
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    OrganizationDriverListComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    __decorate([
	        core_1.ViewChild('deleteModal'), 
	        __metadata('design:type', Object)
	    ], OrganizationDriverListComponent.prototype, "deleteModal", void 0);
	    __decorate([
	        core_1.ViewChild('inviteDriverModal'), 
	        __metadata('design:type', Object)
	    ], OrganizationDriverListComponent.prototype, "inviteDriverModal", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], OrganizationDriverListComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild('resetPasswordModal'), 
	        __metadata('design:type', Object)
	    ], OrganizationDriverListComponent.prototype, "resetPasswordModal", void 0);
	    __decorate([
	        core_1.ViewChild('alertModal'), 
	        __metadata('design:type', (typeof (_a = typeof modal_1.ModalDirective !== 'undefined' && modal_1.ModalDirective) === 'function' && _a) || Object)
	    ], OrganizationDriverListComponent.prototype, "alertModal", void 0);
	    OrganizationDriverListComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-organization-driver-mapping',
	            template: __webpack_require__(988),
	            providers: [organization_service_1.OrganizationService, organization_driver_service_1.OrganizationDriverService, person_service_1.PersonService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof organization_service_1.OrganizationService !== 'undefined' && organization_service_1.OrganizationService) === 'function' && _b) || Object, (typeof (_c = typeof organization_driver_service_1.OrganizationDriverService !== 'undefined' && organization_driver_service_1.OrganizationDriverService) === 'function' && _c) || Object, (typeof (_d = typeof person_service_1.PersonService !== 'undefined' && person_service_1.PersonService) === 'function' && _d) || Object, (typeof (_e = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _e) || Object, (typeof (_f = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _f) || Object, (typeof (_g = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _g) || Object, (typeof (_h = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _h) || Object, (typeof (_j = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _j) || Object])
	    ], OrganizationDriverListComponent);
	    return OrganizationDriverListComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
	}());
	exports.OrganizationDriverListComponent = OrganizationDriverListComponent;


/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var OrganizationDriverService = (function () {
	    function OrganizationDriverService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    OrganizationDriverService.prototype.GetDriverListByOrganizationHashId = function (organizationHashId, input) {
	        var getDriverListForOrganization = config_1.WeGoConfig.API_GET_DRIVER_LIST_FOR_ORGANIZATION;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getDriverListForOrganization =
	                getDriverListForOrganization +
	                    "?" +
	                    queryString +
	                    "&organizationHashId=" +
	                    organizationHashId;
	        }
	        else {
	            getDriverListForOrganization =
	                getDriverListForOrganization +
	                    "?organizationHashId=" +
	                    organizationHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getDriverListForOrganization, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OrganizationDriverService.prototype.GetDriverListByOrganizationToInstance = function (organizationHashId, input) {
	        var getDriverListForOrganization = config_1.WeGoConfig.API_GET_DRIVER_LIST_FOR_ORGANIZATION_TO_INSTANCE;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getDriverListForOrganization =
	                getDriverListForOrganization +
	                    "?" +
	                    queryString +
	                    "&organizationHashId=" +
	                    organizationHashId;
	        }
	        else {
	            getDriverListForOrganization =
	                getDriverListForOrganization +
	                    "?organizationHashId=" +
	                    organizationHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getDriverListForOrganization, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OrganizationDriverService.prototype.AssignDriverToOrganization = function (organizationDriverMappingModel) {
	        var body = organizationDriverMappingModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_ORGANIZATION_DRIVER_DETAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OrganizationDriverService.prototype.ExportDriverList = function (organizationHashId, input) {
	        input.currentPage = 0;
	        var getDriverUrl = config_1.WeGoConfig.API_EXPORT_ORGANIZATION_MAP_DRIVER_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getDriverUrl =
	                getDriverUrl +
	                    "?" +
	                    queryString +
	                    "&organizationHashId=" +
	                    organizationHashId;
	        }
	        else {
	            getDriverUrl = getDriverUrl + "?organizationHashId=" + organizationHashId;
	        }
	        var headers = this.authService.GetHeader("text/csv");
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getDriverUrl, options);
	    };
	    OrganizationDriverService.prototype.DeleteDriverMapping = function (organizationToDriverMapHashId) {
	        var getDriverToOrganizationUrl = config_1.WeGoConfig.API_DELETE_ORGANIZATION_DRIVER_MAPPING +
	            "?organizationToDriverMapHashId=" +
	            organizationToDriverMapHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getDriverToOrganizationUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OrganizationDriverService.prototype.AddPerson = function (driverPersonModel) {
	        var body = driverPersonModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_ORGANIZATION_DRIVER_PERSON_DETAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OrganizationDriverService.prototype.GetPersonListToInvite = function (organizationHashID, emailAddress) {
	        var getOrganizationDriverUrl = config_1.WeGoConfig.API_GET_ORGANIZATION_PERSON_TO_INVITE_AS_DRIVER_LIST;
	        getOrganizationDriverUrl =
	            getOrganizationDriverUrl +
	                "?organizationHashID=" +
	                organizationHashID +
	                "&emailAddress=" +
	                emailAddress;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getOrganizationDriverUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OrganizationDriverService.prototype.InviteAdminOfOrganization = function (organizationDriverInvitationModel) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        var urlInviteDriverOfOrganization = config_1.WeGoConfig.API_POST_INVITE_DRIVER_OF_ORGANIZATION;
	        return this.http
	            .post(urlInviteDriverOfOrganization, organizationDriverInvitationModel, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OrganizationDriverService.prototype.GetOrganizationBasedDriverList = function (input, customerHashId, instanceHashId, companyHashId, organizationHashId, pageName) {
	        if (customerHashId === void 0) { customerHashId = ""; }
	        if (instanceHashId === void 0) { instanceHashId = ""; }
	        if (companyHashId === void 0) { companyHashId = ""; }
	        if (organizationHashId === void 0) { organizationHashId = ""; }
	        if (pageName === void 0) { pageName = ""; }
	        var getDriverListUrl;
	        switch (pageName) {
	            case "Cost_Center_Report":
	                getDriverListUrl =
	                    config_1.WeGoConfig.API_GET_DRIVER_LIST_FOR_COST_CENTER_REPORT;
	                break;
	            default:
	                getDriverListUrl =
	                    config_1.WeGoConfig.API_GET_DRIVER_LIST_FOR_COST_CENTER_REPORT;
	                break;
	        }
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getDriverListUrl =
	                getDriverListUrl +
	                    "?" +
	                    queryString +
	                    "&customerHashId=" +
	                    customerHashId +
	                    "&instanceHashId=" +
	                    instanceHashId +
	                    "&companyHashId=" +
	                    companyHashId +
	                    "&organizationHashId=" +
	                    organizationHashId;
	        }
	        else {
	            getDriverListUrl =
	                getDriverListUrl +
	                    "?customerHashId=" +
	                    customerHashId +
	                    "&instanceHashId=" +
	                    instanceHashId +
	                    "&companyHashId=" +
	                    companyHashId +
	                    "&organizationHashId=" +
	                    organizationHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getDriverListUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    OrganizationDriverService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], OrganizationDriverService);
	    return OrganizationDriverService;
	    var _a, _b;
	}());
	exports.OrganizationDriverService = OrganizationDriverService;


/***/ },
/* 988 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ 'LblDriver' | translate }} {{ 'LblList' | translate }} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i>{{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"urlOrganizationList\">\r\n            <i class=\"fa fa-group fa-fw\"></i> {{ 'LblOrganization' | translate }} {{ 'LblList' | translate }}</a>\r\n        </li>\r\n        <li class=\"active\"> {{ 'LblDriver' | translate }} {{ 'LblList' | translate }}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25 \">\r\n      <wego-authorized-link  [LinkModel]=\"addOrganizationDriverLink\" (onClick)=\"ShowAddOrganizationDriverModal()\"></wego-authorized-link>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <h4>\r\n          <label>{{ 'LblOrganization' | translate }} : </label> {{organizationName}}</h4>\r\n        <p class=\"text-success\">{{ message }}</p>\r\n        <wego-search-list (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\"\r\n          [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('firstName')\">\r\n                  {{ 'LblFirstName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'firstName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('lastName')\">\r\n                  {{ 'LblLastName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'lastName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('driverName')\">\r\n                  {{ 'LblDriver' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'driverName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"text-center\">{{ 'LblResendActivationMail' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblResetPassword' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblDelete' | translate }}</th>\r\n\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let driver of driverList\">\r\n                  <td>{{ driver.firstName }}</td>\r\n                  <td>{{ driver.lastName }}</td>\r\n                  <td>{{ driver.driverName }}</td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"driver.personNotActive\" class=\"btn btn-green btn-xs cursor-pointer\" (click)=\"ResendActivationMail(driver.personMasterHashId)\">\r\n                      {{ 'LblReSend' | translate}}\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a class=\"cursor-pointer\">\r\n                      <i class=\"fa fa-refresh fa-fw text-success\" (click)=\"ShowResetPasswordModal(driver.personMasterHashId)\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a *ngIf=\"driver.isDeletable\" class=\"cursor-pointer\" (click)=\"ShowDeleteModal(driver.organizationToDriverMapHashId)\">\r\n                      <i class=\"fa fa-trash-o fa-fw text-danger\"></i>\r\n                    </a>\r\n                  </td>\r\n                </tr>\r\n\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"6\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<wego-confirm-popup #deleteModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessModalClick()\" (onReject)=\"HideDeleteModal()\"></wego-confirm-popup>\r\n\r\n<!-- <wego-assign-driver-to-organization-popup #assignDriverToOrganizationModal (OnSuccessSelect)=\"SuccessAssignDriverModal($event)\"></wego-assign-driver-to-organization-popup> -->\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n\r\n<wego-success-popup #alertModal [popupTitle]=\"popupTitle\" [popupMsg]=\"validationMessage\" (onConfirm)=\"SuccessAlertModalClick()\"></wego-success-popup>\r\n\r\n<wego-confirm-popup #resetPasswordModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessResetPasswordModalClick()\" (onReject)=\"HideResetPasswordModal()\"></wego-confirm-popup>\r\n\r\n<wego-invite-driver-popup #inviteDriverModal  [popupTitle]=\"LblAddDriverToOrganization\" (onEmailSearch)=\"SearchEmailAddress($event)\" (onConfirm)=\"SuccessInviteDriverModalClick($event)\" (onReject)=\"HideInviteDriverModal()\"></wego-invite-driver-popup>\r\n";

/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var core_1 = __webpack_require__(3);
	var auth_service_1 = __webpack_require__(58);
	var AdminComponent = (function () {
	    function AdminComponent(translate, authService) {
	        this.translate = translate;
	        this.authService = authService;
	        this.toggleClass = "ui-skins sidebar-mini";
	        this.menu = [];
	    }
	    AdminComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.translate.setDetectedLang();
	        this.authService.GetBackOfficeMenu().subscribe(function (res) {
	            _this.menu = res.data;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AdminComponent.prototype.ToggleMenuLocal = function () {
	        if (window.innerWidth > 767) {
	            if (this.toggleClass == "ui-skins sidebar-mini")
	                this.toggleClass = "ui-skins sidebar-mini sidebar-collapse";
	            else if (this.toggleClass == "ui-skins sidebar-mini sidebar-collapse" ||
	                this.toggleClass == "ui-skins sidebar-mini sidebar-open")
	                this.toggleClass = "ui-skins sidebar-mini";
	        }
	        else {
	            if (this.toggleClass == "ui-skins sidebar-mini")
	                this.toggleClass = "ui-skins sidebar-mini sidebar-open";
	            else if (this.toggleClass == "ui-skins sidebar-mini sidebar-open" ||
	                this.toggleClass == "ui-skins sidebar-mini sidebar-collapse")
	                this.toggleClass = "ui-skins sidebar-mini";
	        }
	    };
	    AdminComponent.prototype.onResize = function (event) { };
	    AdminComponent.prototype.ngOnDestroy = function () { };
	    AdminComponent = __decorate([
	        core_1.Component({
	            selector: "wego-admin",
	            template: "\n  <div class=\"admin-role\">\n    <div [class]=\"toggleClass\" (window:resize)=\"onResize($event)\" >\n      <wego-navbar (toggleMenu)=\"ToggleMenuLocal()\"></wego-navbar>\n      <wego-sidebar [menu]=\"menu\"></wego-sidebar>\n      <wego-content-wrapper></wego-content-wrapper>\n      <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\n      <wego-footer></wego-footer>\n    </div>\n  </div>\n  "
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object])
	    ], AdminComponent);
	    return AdminComponent;
	    var _a, _b;
	}());
	exports.AdminComponent = AdminComponent;


/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var auth_service_1 = __webpack_require__(58);
	var HomePageAuthGuard = (function () {
	    function HomePageAuthGuard(authService, router) {
	        this.authService = authService;
	        this.router = router;
	    }
	    HomePageAuthGuard.prototype.canActivate = function (route, state) {
	        var home_URL = localStorage.getItem('home_URL');
	        var urlData = this.authService.GetURL(home_URL != '' && home_URL != undefined ? home_URL : 'dashboard');
	        this.router.navigate([urlData]);
	        return false;
	    };
	    HomePageAuthGuard = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object])
	    ], HomePageAuthGuard);
	    return HomePageAuthGuard;
	    var _a, _b;
	}());
	exports.HomePageAuthGuard = HomePageAuthGuard;


/***/ },
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var flatpickr_model_1 = __webpack_require__(83);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var errorlog_service_1 = __webpack_require__(992);
	var errorlog_model_1 = __webpack_require__(993);
	var instance_service_1 = __webpack_require__(500);
	var $ = __webpack_require__(68);
	var moment = __webpack_require__(84);
	var SlimSelect = __webpack_require__(616);
	var ErrorLogListComponent = (function () {
	    function ErrorLogListComponent(errorLogService, authService, router, translate, instanceService) {
	        this.errorLogService = errorLogService;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.instanceService = instanceService;
	        this.errorLogList = [];
	    }
	    ErrorLogListComponent.prototype.ngOnInit = function () {
	        this.searchModel = new errorlog_model_1.ErrorLogFilterModel();
	        this.pageName = 'Error_Log';
	        this.NoDataFoundMsg = '';
	        this.module = this.translate.instant('LblErrorLog');
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = [
	            'instanceName',
	            'description',
	            'componentName',
	            'logType',
	            'EventDateTimeUTC'
	        ];
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	        this.GetErrorLogList();
	        this.GetInstanceList();
	        //this.GetLogTypeList();
	        this.logTypeList = [
	            {
	                Key: "ERROR",
	                Value: "ERROR"
	            },
	            {
	                Key: "WARNING",
	                Value: "WARNING"
	            },
	            {
	                Key: "NOTICE",
	                Value: "NOTICE"
	            }
	        ];
	        this.GetErrorLogComponentDropDownList();
	    };
	    ErrorLogListComponent.prototype.ViewLogDataPopup = function (errorLogDesc) {
	        this.errorLogData = errorLogDesc;
	        this.logDataPopup.show();
	    };
	    ErrorLogListComponent.prototype.GetInstanceList = function () {
	        var _this = this;
	        this.instanceService.GetDropdownInstanceList(this.pageName).subscribe(function (res) {
	            _this.instanceList = res.data;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    // public GetLogTypeList() {
	    //   this.errorLogService.GetErrorLogTypeDropdownList().subscribe(
	    //     res => {
	    //       this.logTypeList = res.data;
	    //     },
	    //     error => {
	    //       this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
	    //     }
	    //   );
	    // }
	    ErrorLogListComponent.prototype.GetErrorLogComponentDropDownList = function () {
	        var _this = this;
	        this.errorLogService.GetErrorLogComponentDropDownList().subscribe(function (res) {
	            _this.componentList = res.data;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    ErrorLogListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetErrorLogList();
	    };
	    ErrorLogListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        if (event.isReset) {
	            // this.instanceList = [];
	            this.searchModel.instanceHashId = '';
	            this.searchModel.logTypes = '';
	            this.searchModel.componentHashId = '';
	        }
	        this.GetErrorLogList();
	    };
	    ErrorLogListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetErrorLogList();
	    };
	    ErrorLogListComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetErrorLogList();
	    };
	    ErrorLogListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.errorLogService
	            .ExportErrorLog(this.searchModel, this.DataListModel)
	            .subscribe(function (res) {
	            if (res) {
	                var fileName = 'ErrorLog' + new Date().toISOString() + '.csv';
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    ErrorLogListComponent.prototype.GetErrorLogList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.errorLogService
	            .GetErrorLogList(this.searchModel, this.DataListModel)
	            .subscribe(function (res) {
	            _this.errorLogList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.errorModel = typeof res.error != 'string' ? res.error : null;
	            //this.errorModel =  res.error;
	            //this.NoFoundMsg = '';
	            if (res.totalRecords == 0) {
	                _this.NoDataFoundMsg = res.error;
	            }
	            else {
	                _this.NoDataFoundMsg = '';
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    ErrorLogListComponent.prototype.SetDefaultFlatPickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = true;
	        flatPickrConfig.time_24hr = true;
	        flatPickrConfig.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
	        flatPickrConfig.minuteIncrement = 1;
	        return flatPickrConfig;
	    };
	    ErrorLogListComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    __decorate([
	        core_1.ViewChild('logDataPopup'), 
	        __metadata('design:type', Object)
	    ], ErrorLogListComponent.prototype, "logDataPopup", void 0);
	    ErrorLogListComponent = __decorate([
	        core_1.Component({
	            selector: 'error-log',
	            template: __webpack_require__(994),
	            providers: [errorlog_service_1.ErrorLogService, instance_service_1.InstanceService],
	            styles: [
	                "\n    .search-icon {\n        color:#2ba2aa;\n    }\n    .reset-icon {\n        color:#DD9933;\n    }\n    .export-icon {\n        color:#01A2D9;\n    }\n    .delete-icon {\n        color:#f00;\n    }\n    .cancel-icon {\n        color:#f00;\n    }\n    .add-icon {\n        color:#080;\n    }\n    .nopad-left{\n      padding-left: 0px;\n    }\n    .errorLogClass{\n      max-width: 0;\n      overflow: hidden;\n      text-overflow: ellipsis;\n      white-space: nowrap;\n    }\n    "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof errorlog_service_1.ErrorLogService !== 'undefined' && errorlog_service_1.ErrorLogService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object, (typeof (_e = typeof instance_service_1.InstanceService !== 'undefined' && instance_service_1.InstanceService) === 'function' && _e) || Object])
	    ], ErrorLogListComponent);
	    return ErrorLogListComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.ErrorLogListComponent = ErrorLogListComponent;


/***/ },
/* 992 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var jquery_helper_service_1 = __webpack_require__(67);
	var ErrorLogService = (function () {
	    function ErrorLogService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	        this.JQueryHelper = new jquery_helper_service_1.JQueryHelperService();
	    }
	    ErrorLogService.prototype.GetErrorLogList = function (searchModel, input) {
	        var getErrorLogUrl = config_1.WeGoConfig.API_GET_ERRORLOG_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var queryStringErrorLog = this.JQueryHelper.Param(searchModel);
	        getErrorLogUrl = getErrorLogUrl + '?' + queryString + '&' + decodeURIComponent(queryStringErrorLog);
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getErrorLogUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    ErrorLogService.prototype.ExportErrorLog = function (searchModel, input) {
	        input.currentPage = 0;
	        var exportrrorLogUrl = config_1.WeGoConfig.API_GET_EXPORT_ERRORLOG;
	        var queryString = this.authService.HandleAPIListInput(input);
	        var queryStringErrorLog = this.JQueryHelper.Param(searchModel);
	        exportrrorLogUrl = exportrrorLogUrl + '?' + queryString + decodeURIComponent(queryStringErrorLog);
	        var headers = this.authService.GetHeader('text/csv');
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(exportrrorLogUrl, options);
	    };
	    ErrorLogService.prototype.GetErrorLogTypeDropdownList = function (input) {
	        var getErrorLogTypeDropdownUrl = config_1.WeGoConfig.API_GET_DROPDOWN_ERRORLOGTYPE_LIST;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getErrorLogTypeDropdownUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    ErrorLogService.prototype.GetErrorLogComponentDropDownList = function (input) {
	        var getErrorLogTypeDropdownUrl = config_1.WeGoConfig.API_GET_DROPDOWN_ERRORLOGCOMPONENT_LIST;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getErrorLogTypeDropdownUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    ErrorLogService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], ErrorLogService);
	    return ErrorLogService;
	    var _a, _b;
	}());
	exports.ErrorLogService = ErrorLogService;


/***/ },
/* 993 */
/***/ function(module, exports) {

	"use strict";
	var ErrorLogModel = (function () {
	    function ErrorLogModel() {
	        this.logType = "";
	        this.instanceHashId = "";
	    }
	    return ErrorLogModel;
	}());
	exports.ErrorLogModel = ErrorLogModel;
	var ErrorLogFilterModel = (function () {
	    function ErrorLogFilterModel() {
	        this.logTypes = "";
	        this.instanceHashId = "";
	        this.componentHashId = "";
	    }
	    return ErrorLogFilterModel;
	}());
	exports.ErrorLogFilterModel = ErrorLogFilterModel;


/***/ },
/* 994 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ breadCrumbList}} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li class=\"active\"> {{ breadCrumbList}} </li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <!-- <div class=\"col-md-4\" style=\"padding-left:0px;padding-right: 34px;\">\r\n          <span class=\"text text-danger\"></span>\r\n          <label>{{'LblCustomer' | translate }}</label>\r\n          <select [(ngModel)]=\"model.customerMasterHashId\" name=\"customer\" class=\"form-control\" (ngModelChange)=\"GetInstanceBasedOnCustomer()\">\r\n            <option value=\"\" [selected]=\"selected\">{{ 'LblSelect' | translate }} {{ 'LblCustomer' | translate }}</option>\r\n            <option *ngFor=\"let cust of customerList\" [ngValue]='cust.keyHash'>{{cust.value}}</option>\r\n          </select>\r\n        </div> -->\r\n      <div class=\"col-md-4 form-group\">\r\n        <span class=\"text text-danger\"></span>\r\n        <label>{{'LblInstance' | translate }}</label>\r\n        <select [(ngModel)]=\"searchModel.instanceHashId\" id=\"instance\" name=\"instance\" class=\"form-control\">\r\n          <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblInstance' | translate }}</option>\r\n          <option *ngFor=\"let inst of instanceList\" [ngValue]='inst.keyHash'>{{inst.value}}</option>\r\n        </select>\r\n      </div>\r\n      <div class=\"col-md-4 form-group\">\r\n        <span class=\"text text-danger\"></span>\r\n        <label>{{'LblLogType' | translate }}</label>\r\n        <select [(ngModel)]=\"searchModel.logTypes\" id=\"logTypes\" name=\"logTypes\" class=\"form-control\">\r\n          <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblLogType' | translate }}</option>\r\n            <option *ngFor=\"let logType of logTypeList\" [ngValue]='logType.Value'>{{logType.Value}}</option>\r\n        </select>\r\n      </div>\r\n      <div class=\"form-group col-md-4\">\r\n        <label>{{'LblComponent' | translate }}</label>\r\n        <select [(ngModel)]=\"searchModel.componentHashId\" name=\"component\" class=\"form-control\">\r\n          <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblComponent' | translate }}</option>\r\n          <option *ngFor=\"let component of componentList\" [ngValue]='component.keyHash'>{{component.value}}</option>\r\n        </select>\r\n        <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'componentHashId' }}</span>\r\n      </div>\r\n      <div class=\"clearfix\"></div>\r\n      <div class=\"form-group col-sm-3\">\r\n        <label>{{ 'LblFrom' | translate }}</label>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"input-group\">\r\n          <span class=\"input-group-addon\">\r\n            <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n          </span>\r\n          <input class=\"form-control\" [Config]=\"flatPickrConfigFrom\" placeholder=\"{{ 'LblFrom' | translate }}\" name=\"FromDateTime\"\r\n            [(ngModel)]=\"searchModel.StartDateTime\" flatpickr readonly>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'StartDateTime' }}</span>\r\n      </div>\r\n      <div class=\"form-group col-sm-3\">\r\n        <label>{{ 'LblTo' | translate }}</label>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"input-group\">\r\n          <span class=\"input-group-addon\">\r\n            <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n          </span>\r\n          <input class=\"form-control\" [Config]=\"flatPickrConfigTo\" placeholder=\"{{ 'LblTo' | translate }}\" name=\"ToDateTime\" [(ngModel)]=\"searchModel.EndDateTime\"\r\n            flatpickr readonly>\r\n        </div>\r\n      </div>\r\n      <!-- </div>\r\n      <div class=\"row\"> -->\r\n      <div class=\"col-md-12\">\r\n        <wego-search-list (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\"\r\n          [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('instanceName')\">\r\n                  {{ 'LblInstanceName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'instanceName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('componentName')\">\r\n                  {{ 'LblComponentName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'componentName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('logType')\">{{ 'LblLogType' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'logType'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer text-center\" style=\"width:40%\" (click)=\"OnSort('description')\">{{ 'LblDescription' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'description'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('eventDateTimeUTC')\">{{ 'LblEventDateTime' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'eventDateTimeUTC'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let errorLog of errorLogList\">\r\n                  <td>{{errorLog.instanceName }}</td>\r\n                  <td>{{errorLog.componentName }}</td>\r\n                  <td>{{errorLog.logType }}</td>\r\n                  <td class=\"errorLogClass\">\r\n                    <span title=\"View Event Data\">\r\n                      <a class=\"cursor-pointer\" (click)=\"ViewLogDataPopup(errorLog.description)\">\r\n                        <i class=\"fa fa-search fa-fw\"></i>\r\n                      </a>\r\n                    </span>\r\n                    {{errorLog.description }}</td>\r\n                  <td>{{errorLog.eventDateTimeString }}</td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"7\">\r\n                 {{NoDataFoundMsg}} {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n<div bsModal #logDataPopup=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n\r\n        <h4 class=\"modal-title\">\r\n          Log Data\r\n          <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"logDataPopup.hide()\">\r\n            <span aria-hidden=\"true\">&times;</span>\r\n          </button>\r\n        </h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <pre>{{ errorLogData }}</pre>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var config_1 = __webpack_require__(60);
	var errorescalation_service_1 = __webpack_require__(996);
	var errorescalation_model_1 = __webpack_require__(997);
	var modal_1 = __webpack_require__(537);
	var ErrorEscalationComponent = (function () {
	    function ErrorEscalationComponent(errorescalationService, authService, translate) {
	        this.errorescalationService = errorescalationService;
	        this.authService = authService;
	        this.translate = translate;
	        this.errorEscalationList = [];
	    }
	    ErrorEscalationComponent.prototype.ngOnInit = function () {
	        this.model = new errorescalation_model_1.ErrorEscalationModel();
	        this.pageName = 'Error_Escalation';
	        this.module = this.translate.instant('LblErrorEscalation');
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.addErrorEscalationConfigLink = this.authService.GetURL(config_1.ApplicationRouteURL.URL_ERROR_ESCALATION_ADD);
	        this.DataListModel.searchField = [
	            'customerName',
	            'instanceName',
	            'componentName',
	            'logType'
	        ];
	        this.urlErrorEsclationUpdate = this.authService.GetURL(config_1.ApplicationRouteURL.URL_ERROR_ESCALATION_UPDATE);
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	        this.GetErrorEscalationList();
	    };
	    ErrorEscalationComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetErrorEscalationList();
	    };
	    ErrorEscalationComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetErrorEscalationList();
	    };
	    ErrorEscalationComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetErrorEscalationList();
	    };
	    ErrorEscalationComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetErrorEscalationList();
	    };
	    ErrorEscalationComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.errorescalationService
	            .ExportErrorEscalation(this.model, this.DataListModel)
	            .subscribe(function (res) {
	            if (res) {
	                var fileName = 'ErrorEscalation' + new Date().toISOString() + '.csv';
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    ErrorEscalationComponent.prototype.ShowConfirmModal = function (errorEscalationHashId) {
	        this.errorEscalationHashId = errorEscalationHashId;
	        this.popupMsg = this.translate.instant('LblRecordDeleteConfirmation', [this.module]);
	        this.confirmModal.show();
	    };
	    ErrorEscalationComponent.prototype.HideConfirmModal = function () {
	        this.errorEscalationHashId = "";
	        this.confirmModal.hide();
	    };
	    ErrorEscalationComponent.prototype.SuccessModalClick = function () {
	        this.DeleteErrorEscalation(this.errorEscalationHashId);
	        this.confirmModal.hide();
	    };
	    ErrorEscalationComponent.prototype.DeleteErrorEscalation = function (deleteErrorEscalation) {
	        var _this = this;
	        this.isLoading = true;
	        this.errorescalationService.DeleteErrorEscalation(deleteErrorEscalation)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.DataListModel.currentPage = 1;
	                _this.GetErrorEscalationList();
	                _this.popupMsg = _this.translate.instant('LblRecordRemovedSuccess', [_this.module]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.validationMessage = res.error;
	                _this.popupTitle = _this.translate.instant('LblWarning');
	                _this.ShowAlertModal();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    ErrorEscalationComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    ErrorEscalationComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    ErrorEscalationComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    ErrorEscalationComponent.prototype.SuccessAlertModalClick = function () {
	        this.alertModal.hide();
	    };
	    ErrorEscalationComponent.prototype.ShowAlertModal = function () {
	        this.isLoading = false;
	        this.alertModal.show();
	    };
	    ErrorEscalationComponent.prototype.GetErrorEscalationList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.errorescalationService
	            .GetErrorEscalationConfigList(this.model, this.DataListModel)
	            .subscribe(function (res) {
	            _this.errorEscalationList = res.data;
	            console.log(res.data);
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    ErrorEscalationComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    __decorate([
	        core_1.ViewChild('confirmModal'), 
	        __metadata('design:type', Object)
	    ], ErrorEscalationComponent.prototype, "confirmModal", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], ErrorEscalationComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild('alertModal'), 
	        __metadata('design:type', (typeof (_a = typeof modal_1.ModalDirective !== 'undefined' && modal_1.ModalDirective) === 'function' && _a) || Object)
	    ], ErrorEscalationComponent.prototype, "alertModal", void 0);
	    ErrorEscalationComponent = __decorate([
	        core_1.Component({
	            selector: 'error-escalation',
	            template: __webpack_require__(998),
	            providers: [errorescalation_service_1.ErrorEscalationService],
	            styles: [
	                "\n    .search-icon {\n        color:#2ba2aa;\n    }\n    .reset-icon {\n        color:#DD9933;\n    }\n    .export-icon {\n        color:#01A2D9;\n    }\n    .delete-icon {\n        color:#f00;\n    }\n    .cancel-icon {\n        color:#f00;\n    }\n    .add-icon {\n        color:#080;\n    }\n    .nopad-left{\n      padding-left: 0px;\n    }\n    "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof errorescalation_service_1.ErrorEscalationService !== 'undefined' && errorescalation_service_1.ErrorEscalationService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object])
	    ], ErrorEscalationComponent);
	    return ErrorEscalationComponent;
	    var _a, _b, _c, _d;
	}());
	exports.ErrorEscalationComponent = ErrorEscalationComponent;


/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var jquery_helper_service_1 = __webpack_require__(67);
	var ErrorEscalationService = (function () {
	    function ErrorEscalationService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	        this.JQueryHelper = new jquery_helper_service_1.JQueryHelperService();
	    }
	    ErrorEscalationService.prototype.GetErrorEscalationConfigList = function (errorEscalationModel, input) {
	        var getErrorEscalationConfigUrl = config_1.WeGoConfig.API_GET_ErrorEscalation_LIST;
	        var queryString = this.authService.HandleAPIListInput(input);
	        if (queryString) {
	            getErrorEscalationConfigUrl =
	                getErrorEscalationConfigUrl + "?" + queryString;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getErrorEscalationConfigUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    ErrorEscalationService.prototype.DeleteErrorEscalation = function (errorEscalationHashID) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        var url = config_1.WeGoConfig.API_GET_DELETE_ERRORESCALATION +
	            "?errorEscalationHashID=" +
	            errorEscalationHashID;
	        return this.http
	            .get(config_1.WeGoConfig.API_GET_DELETE_ERRORESCALATION +
	            "?errorEscalationHashID=" +
	            errorEscalationHashID, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    ErrorEscalationService.prototype.GetErrorEscalationByHashId = function (errorEscalationHashId) {
	        var getRoleUrl = config_1.WeGoConfig.API_GET_ERRORESCALATION_BY_HASH +
	            "?errorEsclationHashID=" +
	            errorEscalationHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getRoleUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    ErrorEscalationService.prototype.UpdateErrorEscalation = function (errorEscalationModel) {
	        var body = errorEscalationModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_POST_ERRORESCALATION_DETAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    ErrorEscalationService.prototype.ExportErrorEscalation = function (errorEscalationLogModel, input) {
	        input.currentPage = 0;
	        var exportErrorEscalationUrl = config_1.WeGoConfig.API_GET_EXPORT_ErrorEscalation;
	        var queryString = this.authService.HandleAPIListInput(input) +
	            "&" +
	            this.JQueryHelper.Param(errorEscalationLogModel);
	        if (queryString) {
	            exportErrorEscalationUrl = exportErrorEscalationUrl + "?" + queryString;
	        }
	        var headers = this.authService.GetHeader("text/csv");
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(exportErrorEscalationUrl, options);
	    };
	    ErrorEscalationService.prototype.GetErrorEsclationDropdownList = function (isWegoAdmin) {
	        if (isWegoAdmin === void 0) { isWegoAdmin = false; }
	        var getErrorEsclationDropdownUrl = config_1.WeGoConfig.API_GET_DROPDOWN_ERRORESCLATION_LIST +
	            "?isWegoAdmin=" +
	            isWegoAdmin;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getErrorEsclationDropdownUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    ErrorEscalationService.prototype.GetInstanceAdminByInstance = function (instancaeHashId) {
	        var getInstanceAdminByInstanceUrl = config_1.WeGoConfig.API_GET_INSTANCEADMINLISTBYINSTANCE_LIST +
	            "?instanceHashId=" +
	            instancaeHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getInstanceAdminByInstanceUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    ErrorEscalationService.prototype.GetCustomerAdminByCustomer = function (customerHashId) {
	        var getCustomerAdminByCustomerUrl = config_1.WeGoConfig.API_GET_CUSTOMERADMINLISTBYCUSTOMER_LIST +
	            "?customerHashId=" +
	            customerHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getCustomerAdminByCustomerUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    ErrorEscalationService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], ErrorEscalationService);
	    return ErrorEscalationService;
	    var _a, _b;
	}());
	exports.ErrorEscalationService = ErrorEscalationService;


/***/ },
/* 997 */
/***/ function(module, exports) {

	"use strict";
	var ErrorEscalationModel = (function () {
	    function ErrorEscalationModel() {
	        this.componentHashId = '';
	        this.adminLevel = 'WEGOADMIN';
	        this.logType = '';
	        this.wegoAdminHashId = [];
	        this.instanceHashId = '';
	        this.instanceAdminHashId = [];
	        this.customerHashId = '';
	        this.customerAdminHashId = [];
	    }
	    return ErrorEscalationModel;
	}());
	exports.ErrorEscalationModel = ErrorEscalationModel;


/***/ },
/* 998 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ breadCrumbList}} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li class=\"active\"> {{ breadCrumbList}} </li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25\">\r\n      <a class=\"btn btn-highlight navbar-right\" [routerLink]=\"[addErrorEscalationConfigLink]\" routerLinkActive=\"active\">{{ 'LblAddNew' | translate }}</a>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25\">\r\n      <wego-authorized-link [LinkModel]=\"addErrorEscalationConfigLink\"></wego-authorized-link>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <!-- </div>\r\n        <div class=\"row\"> -->\r\n      <div class=\"col-md-12\">\r\n        <wego-search-list (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\"\r\n          [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('customerName')\">\r\n                  {{ 'LblCustomerName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'customerName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('instanceName')\">\r\n                  {{ 'LblInstanceName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'instanceName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('componentName')\">\r\n                  {{ 'LblComponentName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'customerName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('logType')\">{{ 'LblLogType' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'logType'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"text-center\">{{ 'LblEdit' | translate }}</th>\r\n                <th class=\"text-center\">{{ 'LblDelete' | translate }}</th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let errorEscalation of errorEscalationList\">\r\n                  <td>{{errorEscalation.customerName }}</td>\r\n                  <td>{{errorEscalation.instanceName }}</td>\r\n                  <td>{{errorEscalation.componentName }}</td>\r\n                  <td>{{errorEscalation.logType }}</td>\r\n                  <td class=\"text-center\">\r\n                    <a class=\"cursor-pointer\" [routerLink]=\"urlErrorEsclationUpdate + '/' + errorEscalation.errorEscalationHashId\">\r\n                      <i class=\"fa fa-pencil-square-o fa-fw\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td class=\"text-center\">\r\n                    <a class=\"cursor-pointer\" (click)=\"ShowConfirmModal(errorEscalation.errorEscalationHashId)\">\r\n                      <i class=\"fa fa-trash-o fa-fw text-danger\"></i>\r\n                    </a>\r\n                  </td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"7\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n<wego-confirm-popup #confirmModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessModalClick()\" (onReject)=\"HideConfirmModal()\"></wego-confirm-popup>\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n<wego-success-popup #alertModal [popupTitle]=\"popupTitle\" [popupMsg]=\"validationMessage\" (onConfirm)=\"SuccessAlertModalClick()\"></wego-success-popup>";

/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var interfacestatus_model_1 = __webpack_require__(1000);
	var interfacestatus_service_1 = __webpack_require__(1001);
	var customer_service_1 = __webpack_require__(664);
	var instance_service_1 = __webpack_require__(500);
	var $ = __webpack_require__(68);
	var moment = __webpack_require__(84);
	var SlimSelect = __webpack_require__(616);
	var InterfaceStatusListComponent = (function () {
	    function InterfaceStatusListComponent(interfaceStatusService, authService, router, translate, customerService, instanceService) {
	        this.interfaceStatusService = interfaceStatusService;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.customerService = customerService;
	        this.instanceService = instanceService;
	        this.customerList = [];
	    }
	    InterfaceStatusListComponent.prototype.ngOnInit = function () {
	        this.pageName = 'Interface_Status';
	        this.model = new interfacestatus_model_1.InterfaceStatusModel();
	        this.module = this.translate.instant('LblInterfaceStatus');
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.DataListModel.searchField = ['instanceName', 'status'];
	        this.breadCrumbList = this.translate.instant('LblListPage', [this.module]);
	        this.GetInterfaceStatusList();
	    };
	    InterfaceStatusListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetInterfaceStatusList();
	    };
	    InterfaceStatusListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetInterfaceStatusList();
	    };
	    InterfaceStatusListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetInterfaceStatusList();
	    };
	    InterfaceStatusListComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetInterfaceStatusList();
	    };
	    InterfaceStatusListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.interfaceStatusService
	            .ExportInterfaceStatus(this.model, this.DataListModel)
	            .subscribe(function (res) {
	            if (res) {
	                var fileName = 'InterfaceStatus_' + new Date().toISOString() + '.csv';
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    InterfaceStatusListComponent.prototype.GetInterfaceStatusList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.interfaceStatusService
	            .GetInterfaceStatusList(this.DataListModel)
	            .subscribe(function (res) {
	            _this.interfaceStatusList = res.data;
	            console.log(res.data);
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    InterfaceStatusListComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    InterfaceStatusListComponent = __decorate([
	        core_1.Component({
	            selector: 'interfacestatus-list',
	            template: __webpack_require__(1002),
	            providers: [interfacestatus_service_1.InterfaceStatusService, customer_service_1.CustomerService, instance_service_1.InstanceService],
	            styles: [
	                "\n    .search-icon {\n        color:#2ba2aa;\n    }\n    .reset-icon {\n        color:#DD9933;\n    }\n    .export-icon {\n        color:#01A2D9;\n    }\n    .delete-icon {\n        color:#f00;\n    }\n    .cancel-icon {\n        color:#f00;\n    }\n    .add-icon {\n        color:#080;\n    }\n    .nopad-left{\n      padding-left: 0px;\n    }\n    "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof interfacestatus_service_1.InterfaceStatusService !== 'undefined' && interfacestatus_service_1.InterfaceStatusService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object, (typeof (_e = typeof customer_service_1.CustomerService !== 'undefined' && customer_service_1.CustomerService) === 'function' && _e) || Object, (typeof (_f = typeof instance_service_1.InstanceService !== 'undefined' && instance_service_1.InstanceService) === 'function' && _f) || Object])
	    ], InterfaceStatusListComponent);
	    return InterfaceStatusListComponent;
	    var _a, _b, _c, _d, _e, _f;
	}());
	exports.InterfaceStatusListComponent = InterfaceStatusListComponent;


/***/ },
/* 1000 */
/***/ function(module, exports) {

	"use strict";
	var InterfaceStatusModel = (function () {
	    // public customerMasterHashId : string = '';
	    // public instanceHashIdList: string[] = [''];
	    function InterfaceStatusModel() {
	    }
	    return InterfaceStatusModel;
	}());
	exports.InterfaceStatusModel = InterfaceStatusModel;


/***/ },
/* 1001 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var jquery_helper_service_1 = __webpack_require__(67);
	var InterfaceStatusService = (function () {
	    function InterfaceStatusService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	        this.JQueryHelper = new jquery_helper_service_1.JQueryHelperService();
	    }
	    InterfaceStatusService.prototype.GetInterfaceStatusList = function (input) {
	        var getInterfaceStatusUrl = config_1.WeGoConfig.API_GET_INTERFACESTATUS_LIST;
	        var queryString = this.authService.HandleAPIListInput(input); //+ '&'+this.JQueryHelper.Param(interfaceStatus);
	        if (queryString) {
	            getInterfaceStatusUrl = getInterfaceStatusUrl + "?" + queryString;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(getInterfaceStatusUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    InterfaceStatusService.prototype.ExportInterfaceStatus = function (interfaceStatusModel, input) {
	        input.currentPage = 0;
	        var interfaceStatusUrl = config_1.WeGoConfig.API_GET_EXPORT_INTERFACESTATUS;
	        var queryString = this.authService.HandleAPIListInput(input); // + '&'+this.JQueryHelper.Param(interfaceStatusModel);
	        if (queryString) {
	            interfaceStatusUrl = interfaceStatusUrl + "?" + queryString;
	        }
	        var headers = this.authService.GetHeader('text/csv');
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.get(interfaceStatusUrl, options);
	    };
	    InterfaceStatusService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], InterfaceStatusService);
	    return InterfaceStatusService;
	    var _a, _b;
	}());
	exports.InterfaceStatusService = InterfaceStatusService;


/***/ },
/* 1002 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ breadCrumbList}} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li class=\"active\"> {{ breadCrumbList}} </li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <wego-search-list (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\"\r\n          [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th style=\"width:33%\" class=\"cursor-pointer\" (click)=\"OnSort('instanceName')\">\r\n                  {{ 'LblInstanceName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'instanceName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th style=\"width:33%\" class=\"cursor-pointer\" (click)=\"OnSort('status')\">\r\n                  {{ 'LblStatus' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'status'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('updatedDateTime')\">{{ 'LblUpdatedDateTime' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'updatedDateTime'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let interfaceStatus of interfaceStatusList\">\r\n                  <td>{{ interfaceStatus.instanceName }}</td>\r\n                  <td>{{interfaceStatus.status }}</td>\r\n                  <td>{{interfaceStatus.updatedDateTimeString }}</td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"7\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>";

/***/ },
/* 1003 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var common_1 = __webpack_require__(22);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var errorescalation_model_1 = __webpack_require__(997);
	var index_1 = __webpack_require__(631);
	var errorescalation_service_1 = __webpack_require__(996);
	var auth_service_1 = __webpack_require__(58);
	var instance_service_1 = __webpack_require__(500);
	var customer_service_1 = __webpack_require__(664);
	var $ = __webpack_require__(68);
	var moment = __webpack_require__(84);
	var SlimSelect = __webpack_require__(616);
	var ErrorEscalationUpdateComponent = (function () {
	    function ErrorEscalationUpdateComponent(translate, activeRoute, authService, router, locationService, errorEscalationService, instanceService, customerService) {
	        this.translate = translate;
	        this.activeRoute = activeRoute;
	        this.authService = authService;
	        this.router = router;
	        this.locationService = locationService;
	        this.errorEscalationService = errorEscalationService;
	        this.instanceService = instanceService;
	        this.customerService = customerService;
	        this.totalItems = 0;
	        this.currentPage = 1;
	        this.maxSize = config_1.WeGoConfig.GRID_MAX_PAGE_SIZE;
	        this.itemsPerPage = config_1.WeGoConfig.GRID_MAX_DATA_SIZE;
	        this.tempInstanceAdminList = [""];
	        this.tempCustomerAdminList = [""];
	        this.searchField = "";
	        this.searchTerm = "";
	    }
	    ErrorEscalationUpdateComponent.prototype.ngOnInit = function () {
	        this.logTypeList = [
	            {
	                Key: "ERROR",
	                Value: "ERROR"
	            },
	            {
	                Key: "WARNING",
	                Value: "WARNING"
	            },
	            {
	                Key: "NOTICE",
	                Value: "NOTICE"
	            }
	        ];
	        this.module = this.translate.instant("LblErrorEscalation");
	        this.duplicateEscalationMsg = this.translate.instant("LblDuplicateErrorEscalation");
	        this.LblDuplicateEscalation = "Duplicate Escalation";
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlErrorEscalationList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_ERROR_ESCALATION_LIST);
	        this.model = new errorescalation_model_1.ErrorEscalationModel();
	        this.GetErrorEsclationDropdownList();
	    };
	    ErrorEscalationUpdateComponent.prototype.GetErrorEsclationDropdownList = function () {
	        var _this = this;
	        this.errorEscalationService.GetErrorEsclationDropdownList().subscribe(function (res) {
	            _this.apiResponse = res;
	            _this.componentList = res.data.componentDropdownList;
	            //this.logTypeList = res.data.logTypeDropdownList;
	            _this.wegoAdminList = res.data.wegoAdminDropdownList;
	            _this.GetCustomerList();
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    ErrorEscalationUpdateComponent.prototype.GetWegoAdminDropDown = function () {
	        var _this = this;
	        this.errorEscalationService.GetErrorEsclationDropdownList(true).subscribe(function (res) {
	            _this.wegoAdminList = res.data.wegoAdminDropdownList;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    ErrorEscalationUpdateComponent.prototype.GetCustomerList = function () {
	        var _this = this;
	        this.customerService.GetCustomerDropdownList().subscribe(function (res) {
	            _this.apiResponse = res;
	            _this.customerList = res.data;
	            if (_this.customerList && _this.customerList.length > 0) {
	                if (!_this.model.customerHashId && _this.customerList.length == 1) {
	                    _this.model.customerHashId = _this.customerList[0].keyHash;
	                }
	            }
	            _this.GetErrorEscalationDetails();
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    ErrorEscalationUpdateComponent.prototype.GetErrorEscalationDetails = function () {
	        var _this = this;
	        this.sub = this.activeRoute.params.subscribe(function (params) {
	            _this.errorEscalationHashId = params["id"] || "";
	            if (_this.errorEscalationHashId != "") {
	                _this.isLoading = true;
	                _this.isEditMode = true;
	                _this.errorEscalationService
	                    .GetErrorEscalationByHashId(_this.errorEscalationHashId)
	                    .subscribe(function (res) {
	                    _this.model.adminLevel = res.data.adminLevel;
	                    _this.model = res.data;
	                    _this.BindDataOnEdit();
	                    console.log(res.data);
	                    _this.isLoading = false;
	                }, function (error) {
	                    _this.isLoading = false;
	                    _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	                });
	            }
	            else {
	                _this.isEditMode = false;
	                _this.model = new errorescalation_model_1.ErrorEscalationModel();
	            }
	        });
	        this.breadCrumbTitle = this.isEditMode
	            ? this.translate.instant("LblEditPage", [this.module])
	            : this.translate.instant("LblAddPage", [this.module]);
	        this.breadCrumbList = this.translate.instant("LblListPage", [this.module]);
	    };
	    ErrorEscalationUpdateComponent.prototype.BindDataOnEdit = function () {
	        if (this.model.adminLevel == "WEGOADMIN") {
	            this.wegoAdminMultiSelect.set(this.model.wegoAdminHashId);
	        }
	        else if (this.model.adminLevel == "CUSTOMER") {
	            this.bindFirstTime = true;
	            this.tempCustomerAdminList = this.model.customerAdminHashId;
	            this.OnCustomerChange();
	        }
	        else if (this.model.adminLevel == "INSTANCE") {
	            this.bindFirstTime = true;
	            this.tempInstanceAdminList = this.model.instanceAdminHashId;
	            this.GetInstanceBasedOnCustomer();
	        }
	    };
	    ErrorEscalationUpdateComponent.prototype.OnInstaceChange = function () {
	        var _this = this;
	        if (this.model.instanceHashId) {
	            this.errorEscalationService
	                .GetInstanceAdminByInstance(this.model.instanceHashId)
	                .subscribe(function (res) {
	                _this.instanceAdminList = res.data;
	                if (_this.bindFirstTime) {
	                    _this.bindFirstTime = false;
	                    _this.SetInstanceAdminOnEdit();
	                }
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            });
	        }
	        else {
	            this.ClearInstanceAdminDropDown();
	        }
	    };
	    ErrorEscalationUpdateComponent.prototype.SetInstanceAdminOnEdit = function () {
	        var _this = this;
	        setTimeout(function () {
	            _this.instanceAdminMultiSelect.set(_this.tempInstanceAdminList);
	        }, 100);
	    };
	    ErrorEscalationUpdateComponent.prototype.SetCustomerAdminOnEdit = function () {
	        var _this = this;
	        setTimeout(function () {
	            _this.customerAdminMultiSelect.set(_this.tempCustomerAdminList);
	        }, 100);
	    };
	    ErrorEscalationUpdateComponent.prototype.AdminSelectionChange = function () {
	        this.model.componentHashId = "";
	        this.model.logType = "";
	        this.ClearCustomerAdminDropDown();
	        this.ClearWegoAdminDropDown();
	        this.ClearInstanceAdminDropDown();
	        this.model.instanceHashId = "";
	        this.model.customerHashId = "";
	        this.OnCustomerChange();
	        this.OnInstaceChange();
	        if (this.model.adminLevel == "WEGOADMIN") {
	            this.GetWegoAdminDropDown();
	        }
	    };
	    ErrorEscalationUpdateComponent.prototype.OnCustomerChange = function () {
	        var _this = this;
	        if (this.model.adminLevel == "CUSTOMER") {
	            if (this.model.customerHashId) {
	                this.errorEscalationService
	                    .GetCustomerAdminByCustomer(this.model.customerHashId)
	                    .subscribe(function (res) {
	                    _this.customerAdminList = res.data;
	                    if (_this.bindFirstTime) {
	                        _this.bindFirstTime = false;
	                        _this.SetCustomerAdminOnEdit();
	                    }
	                }, function (error) {
	                    _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	                });
	            }
	            else {
	                this.ClearCustomerAdminDropDown();
	            }
	        }
	        else {
	            this.ClearInstanceDropDown();
	            this.ClearInstanceAdminDropDown();
	            this.GetInstanceBasedOnCustomer();
	        }
	    };
	    ErrorEscalationUpdateComponent.prototype.GetInstanceBasedOnCustomer = function () {
	        var _this = this;
	        var permissionType = "";
	        if (this.isEditMode) {
	            permissionType = config_1.PermissionType.EDIT;
	        }
	        else {
	            permissionType = config_1.PermissionType.INSERT;
	        }
	        if (this.model.customerHashId) {
	            this.instanceService
	                .GetInstanceListDropdownForAddUpdatePage("ErrorEsclation", permissionType, this.model.customerHashId)
	                .subscribe(function (res) {
	                _this.apiResponse = res;
	                _this.instanceList = res.data;
	                if (_this.isEditMode) {
	                    _this.OnInstaceChange();
	                }
	            }, function (error) {
	                _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            });
	        }
	        else {
	            this.ClearInstanceDropDown();
	            this.ClearInstanceAdminDropDown();
	        }
	    };
	    ErrorEscalationUpdateComponent.prototype.ngAfterViewInit = function () {
	        var _this = this;
	        this.wegoAdminMultiSelect = new SlimSelect({
	            select: "#wegoAdmin",
	            placeholder: "Select Wego Admin",
	            showSearch: false,
	            onChange: function (info) {
	                _this.model.wegoAdminHashId = info.map(function (x) { return x.value; });
	            }
	        });
	        this.customerAdminMultiSelect = new SlimSelect({
	            select: "#customerAdmin",
	            placeholder: "Select customer Admin",
	            showSearch: false,
	            onChange: function (info) {
	                console.log(_this.model.customerAdminHashId);
	                _this.model.customerAdminHashId = info.map(function (x) { return x.value; });
	            }
	        });
	        this.instanceAdminMultiSelect = new SlimSelect({
	            select: "#instanceAdmin",
	            placeholder: "Select Instance Admin",
	            showSearch: false,
	            onChange: function (info) {
	                _this.model.instanceAdminHashId = info.map(function (x) { return x.value; });
	                console.log(_this.model.instanceAdminHashId);
	            }
	        });
	    };
	    ErrorEscalationUpdateComponent.prototype.onSubmit = function (forms) {
	        if (this.model.adminLevel == "WEGOADMIN") {
	            this.ClearInstanceAdminDropDown();
	            this.ClearCustomerAdminDropDown();
	        }
	        else if (this.model.adminLevel == "CUTOMER") {
	            this.ClearWegoAdminDropDown();
	            this.ClearInstanceAdminDropDown();
	        }
	        else if (this.model.adminLevel == "INSTANCE") {
	            this.ClearWegoAdminDropDown();
	            this.ClearCustomerAdminDropDown();
	        }
	        this.UpdateErrorEscalation();
	    };
	    ErrorEscalationUpdateComponent.prototype.UpdateErrorEscalation = function () {
	        var _this = this;
	        this.errorEscalationService.UpdateErrorEscalation(this.model).subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.isEditMode
	                    ? _this.translate.instant("LblRecordUpdatedSuccess", [_this.module])
	                    : _this.translate.instant("LblRecordAddedSuccess", [_this.module]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.errorModel = res.error;
	                _this.CheckDuplicateErrorEscalation();
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    ErrorEscalationUpdateComponent.prototype.CheckDuplicateErrorEscalation = function () {
	        var isDuplicateErrorEscaltion = this.errorModel.find(function (x) { return x.key == "DuplicateEscalationValidationMessage"; });
	        if (isDuplicateErrorEscaltion != null) {
	            this.duplicateEscalationPopup.show(false);
	        }
	    };
	    ErrorEscalationUpdateComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    ErrorEscalationUpdateComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    ErrorEscalationUpdateComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    ErrorEscalationUpdateComponent.prototype.OnBackClick = function () {
	        this.locationService.back();
	    };
	    ErrorEscalationUpdateComponent.prototype.ClearCustomerAdminDropDown = function () {
	        this.customerAdminList = [];
	        this.model.customerAdminHashId = [];
	    };
	    ErrorEscalationUpdateComponent.prototype.ClearInstanceAdminDropDown = function () {
	        this.instanceAdminList = [];
	        this.model.instanceAdminHashId = [];
	    };
	    ErrorEscalationUpdateComponent.prototype.ClearInstanceDropDown = function () {
	        this.instanceList = [];
	        this.model.instanceHashId = "";
	    };
	    ErrorEscalationUpdateComponent.prototype.ClearWegoAdminDropDown = function () {
	        this.wegoAdminList = [];
	        this.model.wegoAdminHashId = [];
	    };
	    ErrorEscalationUpdateComponent.prototype.ngOnDestroy = function () {
	        if (this.sub) {
	            this.sub.unsubscribe();
	        }
	    };
	    __decorate([
	        core_1.ViewChild("successPopup"), 
	        __metadata('design:type', Object)
	    ], ErrorEscalationUpdateComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild("duplicateEscalationPopup"), 
	        __metadata('design:type', Object)
	    ], ErrorEscalationUpdateComponent.prototype, "duplicateEscalationPopup", void 0);
	    ErrorEscalationUpdateComponent = __decorate([
	        core_1.Component({
	            selector: "error-escalation",
	            template: __webpack_require__(1004),
	            providers: [errorescalation_service_1.ErrorEscalationService, instance_service_1.InstanceService, customer_service_1.CustomerService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof index_1.TranslateService !== 'undefined' && index_1.TranslateService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _e) || Object, (typeof (_f = typeof errorescalation_service_1.ErrorEscalationService !== 'undefined' && errorescalation_service_1.ErrorEscalationService) === 'function' && _f) || Object, (typeof (_g = typeof instance_service_1.InstanceService !== 'undefined' && instance_service_1.InstanceService) === 'function' && _g) || Object, (typeof (_h = typeof customer_service_1.CustomerService !== 'undefined' && customer_service_1.CustomerService) === 'function' && _h) || Object])
	    ], ErrorEscalationUpdateComponent);
	    return ErrorEscalationUpdateComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h;
	}());
	exports.ErrorEscalationUpdateComponent = ErrorEscalationUpdateComponent;


/***/ },
/* 1004 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{breadCrumbTitle}}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"urlErrorEscalationList\">\r\n            <i class=\"fa fa-gear\"></i>{{breadCrumbList}}</a>\r\n        </li>\r\n        <li class=\"active\">{{breadCrumbTitle}}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25 \">\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"nopad\">\r\n      <form (ngSubmit)=\"onSubmit()\">\r\n        <div class=\"form-group col-md-12\" style=\"padding-left: 0px;\">\r\n          <div class=\"form-group col-md-8\">\r\n            <label>\r\n              <span class=\"text text-danger\">*</span> {{ 'LblSelectAdminLevel' | translate }}</label>\r\n            <div>\r\n              <label class=\"radio-inline\">\r\n                <input type=\"radio\" name=\"adminLevel\" (change)=\"AdminSelectionChange()\" [(ngModel)]=\"model.adminLevel\" value=\"WEGOADMIN\">{{ 'LblWegoAdminLevel' | translate }}</label>\r\n              <label class=\"radio-inline\">\r\n                <input type=\"radio\" name=\"adminLevel\" (change)=\"AdminSelectionChange()\" [(ngModel)]=\"model.adminLevel\" value=\"CUSTOMER\">{{ 'LblCustomerAdminLevel' | translate }}</label>\r\n              <label class=\"radio-inline\">\r\n                <input type=\"radio\" name=\"adminLevel\" (change)=\"AdminSelectionChange()\" [(ngModel)]=\"model.adminLevel\" value=\"INSTANCE\">{{ 'LblInstanceAdminLevel' | translate }}</label>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"form-group col-md-4\">\r\n          <span class=\"text text-danger\">*</span>\r\n          <label>{{'LblComponent' | translate }}</label>\r\n          <select [(ngModel)]=\"model.componentHashId\" name=\"component\" class=\"form-control\">\r\n            <option  value=\"\" >{{ 'LblSelect' | translate }} {{ 'LblComponent' | translate }}</option>\r\n            <option *ngFor=\"let component of componentList\" [ngValue]='component.keyHash'>{{component.value}}</option>\r\n          </select>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'componentHashId' }}</span>\r\n        </div>\r\n\r\n        <div class=\"form-group col-md-4\">\r\n          <span class=\"text text-danger\">*</span>\r\n          <label>{{'LblLogType' | translate }}</label>\r\n          <select [(ngModel)]=\"model.logType\" name=\"logType\" class=\"form-control\">\r\n            <option value=\"\" [selected]=\"selected\">{{ 'LblSelect' | translate }} {{ 'LblLogType' | translate }}</option>\r\n            <option *ngFor=\"let logType of logTypeList\" [attr.value]='logType.Value'>{{logType.Value}}</option>\r\n          </select>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'logType' }}</span>\r\n        </div>\r\n        <div class=\"col-md-4\"></div>\r\n        <div class=\"clearfix\"></div>\r\n        <div [hidden]=\"model.adminLevel!='WEGOADMIN'\" class=\"col-md-12 form-group\" style=\"padding: 0px;\">\r\n          <div class=\"col-md-4\">\r\n            <span class=\"text text-danger\">*</span>\r\n            <label>{{'LblWegoAdmin' | translate }}</label>\r\n            <select  id=\"wegoAdmin\" name=\"wegoAdmin\"  multiple>\r\n              <option *ngFor=\"let wegoAdmin of wegoAdminList\" [attr.value]='wegoAdmin.keyHash'>{{wegoAdmin.value}}</option>\r\n            </select>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'wegoAdminHashId' }}</span>\r\n\r\n          </div>\r\n\r\n          <div class=\"col-md-4\"></div>\r\n          <div class=\"col-md-4\"></div>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div [hidden]=\"model.adminLevel!='INSTANCE'\" class=\"col-md-12 form-group\" style=\"padding: 0px;\">\r\n          <div class=\"col-md-4\">\r\n            <span class=\"text text-danger\">*</span>\r\n            <label>{{'LblCustomer' | translate }}</label>\r\n            <select [(ngModel)]=\"model.customerHashId\" name=\"customer\" class=\"form-control\" (change)=\"OnCustomerChange()\">\r\n              <option value=\"\" [selected]=\"selected\">{{ 'LblSelect' | translate }} {{ 'LblCustomer' | translate }}</option>\r\n              <option *ngFor=\"let customer of customerList\" [ngValue]='customer.keyHash'>{{customer.value}}</option>\r\n            </select>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'customerHashId' }}</span>\r\n          </div>\r\n          <div class=\"col-md-4\">\r\n            <span class=\"text text-danger\">*</span>\r\n            <label>{{'LblInstance' | translate }}</label>\r\n            <select [(ngModel)]=\"model.instanceHashId\" name=\"instance\" class=\"form-control\" (change)=\"OnInstaceChange()\">\r\n              <option value=\"\" [selected]=\"selected\">{{ 'LblSelect' | translate }} {{ 'LblInstance' | translate }}</option>\r\n              <option *ngFor=\"let instance of instanceList\" [ngValue]='instance.keyHash'>{{instance.value}}</option>\r\n            </select>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'instanceHashId' }}</span>\r\n          </div>\r\n          <!-- OLD CODE -->\r\n          <!-- <div class=\"col-md-4\">\r\n            <span class=\"text text-danger\">*</span>\r\n            <label>{{'LblInstanceAdmin' | translate }}</label>\r\n            <select [(ngModel)]=\"model.instanceAdminHashId\" id=\"instanceAdmin\" name=\"instanceAdmin\"  multiple>\r\n              <option *ngFor=\"let instanceAdmin of instanceAdminList\" [ngValue]='instanceAdmin.keyHash'>{{instanceAdmin.value}}</option>\r\n            </select>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'instanceAdminHashId' }}</span>\r\n          </div> -->\r\n          <div class=\"col-md-4\">\r\n            <span class=\"text text-danger\">*</span>\r\n            <label>{{'LblInstanceAdmin' | translate }}</label>\r\n            <select id=\"instanceAdmin\" name=\"instanceAdmin\"  multiple>\r\n              <option *ngFor=\"let instanceAdmin of instanceAdminList\" [attr.value] ='instanceAdmin.keyHash'>{{instanceAdmin.value}}</option>\r\n            </select>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'instanceAdminHashId' }}</span>\r\n\r\n          </div>\r\n\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div [hidden]=\"model.adminLevel!='CUSTOMER'\" class=\"col-md-12 form-group\" style=\"padding: 0px;\">\r\n          <div class=\"col-md-4\">\r\n            <span class=\"text text-danger\">*</span>\r\n            <label>{{'LblCustomer' | translate }}</label>\r\n            <select [(ngModel)]=\"model.customerHashId\" name=\"customer\" class=\"form-control\" (change)=\"OnCustomerChange()\">\r\n              <option value=\"\" [selected]=\"selected\">{{ 'LblSelect' | translate }} {{ 'LblCustomer' | translate }}</option>\r\n              <option *ngFor=\"let customer of customerList\" [ngValue]='customer.keyHash'>{{customer.value}}</option>\r\n            </select>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'customerHashId' }}</span>\r\n          </div>\r\n         <!-- OLDCODE -->\r\n          <!-- <div class=\"col-md-4\">\r\n            <span class=\"text text-danger\">*</span>\r\n            <label>{{'LblCustomerAdmin' | translate }}</label>\r\n            <select [(ngModel)]=\"model.customerAdminHashId\" id=\"customerAdmin\" name=\"customerAdmin\" multiple>\r\n              <option *ngFor=\"let customerAdmin of customerAdminList\" [ngValue]='customerAdmin.keyHash'>{{customerAdmin.value}}</option>\r\n            </select>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'customerAdminHashId' }}</span>\r\n          </div> -->\r\n          <div class=\"col-md-4\">\r\n              <span class=\"text text-danger\">*</span>\r\n              <label>{{'LblCustomerAdmin' | translate }}</label>\r\n              <select  id=\"customerAdmin\" name=\"customerAdmin\" multiple>\r\n                <option *ngFor=\"let customerAdmin of customerAdminList\" [attr.value]='customerAdmin.keyHash'>{{customerAdmin.value}}</option>\r\n              </select>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'customerAdminHashId' }}</span>\r\n            </div>\r\n          <div class=\"col-md-4\"></div>\r\n        </div>\r\n        <!-- save & cancel -->\r\n        <div class=\"row no-margin\">\r\n          <div class=\"col-sm-12\">\r\n            <hr>\r\n            <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnBackClick()\">{{ 'LblCancel' | translate }}</a> &nbsp;&nbsp;\r\n            <button class=\"btn btn-green\" type=\"submit\">{{ 'LblSave' | translate }}</button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n<wego-success-popup #duplicateEscalationPopup [popupTitle]=\"LblDuplicateEscalation\" [popupMsg]=\"duplicateEscalationMsg\" (onConfirm)=\"duplicateEscalationPopup.hide();\"></wego-success-popup>\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>";

/***/ },
/* 1005 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var config_1 = __webpack_require__(60);
	var auth_service_1 = __webpack_require__(58);
	var translate_service_1 = __webpack_require__(70);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_2 = __webpack_require__(60);
	var common_1 = __webpack_require__(22);
	var invoice_service_1 = __webpack_require__(723);
	var invoice_model_1 = __webpack_require__(719);
	var instance_service_1 = __webpack_require__(500);
	var company_service_1 = __webpack_require__(501);
	var cost_expense_model_1 = __webpack_require__(1006);
	var rounding_formatter_service_1 = __webpack_require__(1007);
	var InvoiceUpdateComponent = (function () {
	    function InvoiceUpdateComponent(invoiceService, instanceService, companyService, translate, activeRoute, authService, locationService, roundFormatterService) {
	        this.invoiceService = invoiceService;
	        this.instanceService = instanceService;
	        this.companyService = companyService;
	        this.translate = translate;
	        this.activeRoute = activeRoute;
	        this.authService = authService;
	        this.locationService = locationService;
	        this.roundFormatterService = roundFormatterService;
	        this.searchField = "";
	        this.searchTerm = "";
	        this.selectedInstance = "";
	        this.DataListModel = new config_1.DataListModel();
	        this.isEditable = true; //todo : set For readonly
	        this.costAndExpensesList = [];
	    }
	    Object.defineProperty(InvoiceUpdateComponent.prototype, "addresseeEnabled", {
	        get: function () {
	            if (this.model.isSenderInstance) {
	                return !!this.model.senderInstanceHashId;
	            }
	            if (!this.model.isSenderInstance) {
	                return (!!this.model.senderInstanceHashId && !!this.model.senderCompanyHashId);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    InvoiceUpdateComponent.prototype.ngOnInit = function () {
	        this.module = this.translate.instant("LblInvoice");
	        this.invoiceLine = this.translate.instant("LblInvoiceLine");
	        this.urlDefaultPage = this.authService.GetURL(config_2.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlCustomerList = this.authService.GetURL(config_2.ApplicationRouteURL.URL_BOOKING_INVOICE_LIST);
	        this.reportName = "invoice_update";
	        this.isEditMode = false;
	        this.model = new invoice_model_1.InvoiceModel();
	        this.GetAllInstanceList();
	        this.GetInvoiceDetails();
	    };
	    InvoiceUpdateComponent.prototype.GetInvoiceDetails = function () {
	        var _this = this;
	        this.sub = this.activeRoute.params.subscribe(function (params) {
	            _this.invoiceHashId = params["id"] || "";
	            if (_this.invoiceHashId != "") {
	                _this.isEditMode = true;
	                _this.invoiceService
	                    .GetManualInvoiceByHashId(_this.invoiceHashId)
	                    .subscribe(function (res) {
	                    _this.model = res.data;
	                    if (!_this.model.isSenderInstance) {
	                        _this.GetAllCompanyList();
	                    }
	                    _this.SetSenderAddress();
	                    _this.SetAddreseeAddress();
	                }, function (error) {
	                    _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	                });
	            }
	            else {
	                _this.GetInvoiceNumber();
	            }
	        });
	        this.breadCrumbTitle = this.isEditMode
	            ? this.translate.instant("LblEditPage", [this.module])
	            : this.translate.instant("LblAddPage", [this.module]);
	        this.breadCrumbList = this.translate.instant("LblListPage", [this.module]);
	    };
	    InvoiceUpdateComponent.prototype.GetInvoiceNumber = function () {
	        var _this = this;
	        this.invoiceService.GetInvoiceNumber().subscribe(function (res) {
	            _this.model.invoiceNumber = res.data;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    InvoiceUpdateComponent.prototype.SetSenderAddress = function () {
	        if (this.model.isSenderInstance) {
	            // todo : Implement Instance Address
	            this.model.senderAddress = "";
	        }
	        else {
	            this.GetCompanyAddress();
	        }
	    };
	    InvoiceUpdateComponent.prototype.SetAddreseeAddress = function () {
	        if (this.model.addresseeType == "DRIVER") {
	            this.GetDriverAddress();
	        }
	        else {
	            this.GetOrganizationAddress();
	        }
	    };
	    InvoiceUpdateComponent.prototype.GetCompanyAddress = function () {
	        var _this = this;
	        if (this.model.senderCompanyHashId) {
	            this.invoiceService
	                .GetCompanyAddress(this.model.senderCompanyHashId)
	                .subscribe(function (res) {
	                _this.model.senderAddress = res.data;
	            }, function (error) {
	                _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            });
	        }
	    };
	    InvoiceUpdateComponent.prototype.GetDriverAddress = function () {
	        var _this = this;
	        this.invoiceService.GetDriverAddress(this.model.driverHashId).subscribe(function (res) {
	            _this.model.addresseeAddress = res.data;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    InvoiceUpdateComponent.prototype.GetOrganizationAddress = function () {
	        var _this = this;
	        this.invoiceService
	            .GetOrganizationAddress(this.model.organizationHashId)
	            .subscribe(function (res) {
	            _this.model.addresseeAddress = res.data;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    InvoiceUpdateComponent.prototype.OnSaveClick = function () {
	        var _this = this;
	        this.invoiceService.UpdateManualInvoice(this.model).subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.isEditMode
	                    ? _this.translate.instant("LblRecordUpdatedSuccess", [_this.module])
	                    : _this.translate.instant("LblRecordAddedSuccess", [_this.module]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    InvoiceUpdateComponent.prototype.getPermissionType = function () {
	        if (this.isEditMode) {
	            if (this.invoiceHashId) {
	                return config_1.PermissionType.EDIT;
	            }
	            else {
	                return config_1.PermissionType.INSERT;
	            }
	        }
	        else {
	            return config_1.PermissionType.VIEW;
	        }
	    };
	    InvoiceUpdateComponent.prototype.GetAllInstanceList = function () {
	        var _this = this;
	        this.instanceService
	            .GetInstanceListDropdownForAddUpdatePage(this.reportName, this.getPermissionType())
	            .subscribe(function (res) {
	            _this.instanceList = res.data;
	            if (_this.instanceList && _this.instanceList.length > 0) {
	                if (!_this.model.senderInstanceHashId &&
	                    _this.instanceList.length == 1) {
	                    _this.model.senderInstanceHashId = _this.instanceList[0].keyHash;
	                    _this.model.senderName = _this.instanceList[0].value;
	                    _this.OnInstanceChange();
	                }
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    InvoiceUpdateComponent.prototype.OnInstanceChange = function () {
	        var _this = this;
	        this.model.senderCompanyHashId = "";
	        if (!this.model.isSenderInstance) {
	            if (this.model.senderInstanceHashId) {
	                this.GetAllCompanyList();
	            }
	            else {
	                this.companyList = [];
	            }
	        }
	        else {
	            this.model.senderName = this.instanceList.find(function (x) { return x.keyHash == _this.model.senderInstanceHashId; }).value;
	            //TODO: Set Instance Address function
	            this.model.senderAddress = "";
	        }
	        if (!this.invoiceHashId) {
	            this.model.costAndExpenseList = [];
	        }
	    };
	    InvoiceUpdateComponent.prototype.SenderChange = function () {
	        var _this = this;
	        if (!this.model.isSenderInstance) {
	            this.model.senderName = this.companyList.find(function (x) { return x.keyHash == _this.model.senderCompanyHashId; }).value;
	            this.GetAllCompanyList();
	        }
	        else {
	            this.model.senderName = this.instanceList.find(function (x) { return x.keyHash == _this.model.senderInstanceHashId; }).value;
	            this.model.senderCompanyHashId = "";
	            this.model.senderAddress = "";
	        }
	    };
	    InvoiceUpdateComponent.prototype.GetAllCompanyList = function () {
	        var _this = this;
	        this.companyService
	            .GetCompanyListDropdownForAddUpdatePage(this.reportName, this.getPermissionType(), this.model.senderInstanceHashId)
	            .subscribe(function (res) {
	            _this.companyList = res.data;
	            if (_this.companyList && _this.companyList.length > 0) {
	                if (!_this.model.senderCompanyHashId &&
	                    _this.companyList.length == 1) {
	                    _this.model.senderCompanyHashId = _this.companyList[0].keyHash;
	                    _this.GetCompanyAddress();
	                }
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    InvoiceUpdateComponent.prototype.OnCompanyChange = function () {
	        var _this = this;
	        if (!this.model.isSenderInstance) {
	            this.model.senderName = this.companyList.find(function (x) { return x.keyHash == _this.model.senderCompanyHashId; }).value;
	            this.GetCompanyAddress();
	        }
	        if (!this.invoiceHashId) {
	            this.model.costAndExpenseList = [];
	        }
	    };
	    InvoiceUpdateComponent.prototype.SuccessSelectDriverModal = function (event) {
	        this.model.driverHashId = event.DriverHashID;
	        this.model.sharedVehicleGroupDriverHashId = event.SharedVehicleGroupDriverHashId;
	        this.model.driverName = event.DriverName;
	        this.model.addresseeName = event.DriverFullName;
	        this.GetDriverAddress();
	        if (!this.invoiceHashId) {
	            this.model.costAndExpenseList = [];
	        }
	    };
	    InvoiceUpdateComponent.prototype.SuccessSelectOrganizationModal = function (event) {
	        this.model.organizationHashId = event.OrganizationHashID;
	        this.model.organizationName = event.OrganizationName;
	        this.model.addresseeName = event.OrganizationName;
	        this.GetOrganizationAddress();
	        if (!this.invoiceHashId) {
	            this.model.costAndExpenseList = [];
	        }
	    };
	    InvoiceUpdateComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    InvoiceUpdateComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    InvoiceUpdateComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    InvoiceUpdateComponent.prototype.ShowRemoveSuccessPopup = function () {
	        this.removesuccessPopup.show();
	    };
	    InvoiceUpdateComponent.prototype.HideRemoveSuccessPopup = function () {
	        this.removesuccessPopup.hide();
	    };
	    InvoiceUpdateComponent.prototype.ConfirmRemoveSuccessPopup = function () {
	        this.removesuccessPopup.hide();
	    };
	    InvoiceUpdateComponent.prototype.OnBackClick = function () {
	        this.locationService.back();
	    };
	    InvoiceUpdateComponent.prototype.AddManualInvoiceLine = function () {
	        if (this.model.driverHashId || this.model.organizationHashId) {
	            this.manualInvoiceLine.model = new cost_expense_model_1.CostAndExpenseModel();
	            this.manualInvoiceLine.model.recipientOrganizationHashId = this.model.organizationHashId;
	            this.manualInvoiceLine.model.recipientDriverHashId = this.model.driverHashId;
	            this.manualInvoiceLine.model.reportedByDriver = false;
	            this.manualInvoiceLine.model.chargeToDriver =
	                this.model.addresseeType == "DRIVER";
	            this.manualInvoiceLine.model.sharedVehicleGroupDriverHashId = this.model.sharedVehicleGroupDriverHashId;
	            this.manualInvoiceLine.model.module = "INVOICE";
	            this.manualInvoiceLine.SelectedExpenseHashIdList = this.model.costAndExpenseList.map(function (y) { return y.costAndExpenseHashId; });
	            this.manualInvoiceLine.show();
	        }
	    };
	    InvoiceUpdateComponent.prototype.ManualInvoiceLineSuccess = function (event) {
	        if (event.CostAndExpenseModel) {
	            var cost = event.CostAndExpenseModel;
	            this.model.costAndExpenseList.push(cost);
	        }
	        else {
	            var costList = event.CostAndExpenseModelList;
	            this.model.costAndExpenseList = this.model.costAndExpenseList.concat(costList);
	        }
	    };
	    // private OnAddreseeChange() {
	    //   if (this.model.addresseeType == "DRIVER") {
	    //     this.GetDriverAddress();
	    //   } else {
	    //     this.GetOrganizationAddress();
	    //   }
	    // }
	    InvoiceUpdateComponent.prototype.ShowConfirmModal = function (costAndExpensehashId, invoicehashId) {
	        this.removeCostAndExpensehashId = costAndExpensehashId;
	        this.removeCostAndExpenseinvoicehashId = invoicehashId;
	        this.deleteMessage = this.translate.instant("LblRecordDeleteConfirmation", [
	            this.invoiceLine
	        ]);
	        this.confirmModal.show();
	    };
	    InvoiceUpdateComponent.prototype.ConfirmSuccessClick = function () {
	        this.confirmModal.hide();
	        this.RemoveCostAndExpenses(this.removeCostAndExpensehashId);
	    };
	    InvoiceUpdateComponent.prototype.HideConfirmModal = function () {
	        this.removeCostAndExpensehashId = "";
	        this.removeCostAndExpenseinvoicehashId = "";
	        this.confirmModal.hide();
	    };
	    InvoiceUpdateComponent.prototype.RemoveCostAndExpenses = function (removeCostAndExpensehashId) {
	        var _this = this;
	        if (this.removeCostAndExpenseinvoicehashId) {
	            this.invoiceService
	                .RemoveCostAndExpenses(removeCostAndExpensehashId)
	                .subscribe(function (res) {
	                if (res.data) {
	                    var costExpenseIndex = _this.model.costAndExpenseList.findIndex(function (x) { return x.costAndExpenseHashId == removeCostAndExpensehashId; });
	                    if (costExpenseIndex > -1) {
	                        _this.model.costAndExpenseList.splice(costExpenseIndex, 1);
	                    }
	                    _this.popupMsg = _this.translate.instant("LblRecordRemovedSuccess", [_this.invoiceLine]);
	                    _this.ShowRemoveSuccessPopup();
	                }
	                else {
	                    _this.errorModel = res.error;
	                }
	            }, function (error) {
	                _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            });
	        }
	        else {
	            var costExpenseIndex = this.model.costAndExpenseList.findIndex(function (x) { return x.costAndExpenseHashId == removeCostAndExpensehashId; });
	            if (costExpenseIndex > -1) {
	                this.model.costAndExpenseList.splice(costExpenseIndex, 1);
	                this.popupMsg = this.translate.instant("LblRecordRemovedSuccess", [
	                    this.invoiceLine
	                ]);
	                this.ShowRemoveSuccessPopup();
	            }
	        }
	    };
	    InvoiceUpdateComponent.prototype.ShowSendConfirmModal = function () {
	        this.confirmMsg = this.translate.instant("LblSendInvoiceConfirm", [
	            this.module
	        ]);
	        this.sendConfirmModal.show();
	    };
	    InvoiceUpdateComponent.prototype.SuccessConfirmModalClick = function () {
	        this.sendConfirmModal.hide();
	        this.OnSendClick();
	    };
	    InvoiceUpdateComponent.prototype.HideSendConfirmModal = function () {
	        this.sendConfirmModal.hide();
	    };
	    InvoiceUpdateComponent.prototype.OnSendClick = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.invoiceService.UpdateManualInvoice(this.model, true).subscribe(function (res) {
	            if (res.data) {
	                _this.isLoading = false;
	                _this.popupMsg = _this.translate.instant("LblInvoiceSent");
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    InvoiceUpdateComponent.prototype.ShowUpdateManualInvoiceLinePopup = function (expense) {
	        this.manualInvoiceLineUpdate.model = expense;
	        this.manualInvoiceLineUpdate.model.recipientOrganizationHashId = this.model.organizationHashId;
	        this.manualInvoiceLineUpdate.model.recipientDriverHashId = this.model.driverHashId;
	        this.manualInvoiceLineUpdate.model.sharedVehicleGroupDriverHashId = this.model.sharedVehicleGroupDriverHashId;
	        this.manualInvoiceLineUpdate.model.module = "INVOICE";
	        // this.manualInvoiceLineUpdate.model.reportedByDriver = false;
	        this.manualInvoiceLineUpdate.model.chargeToDriver =
	            this.model.addresseeType == "DRIVER";
	        if (!expense.reportedByDriver) {
	            this.manualInvoiceLineUpdate.show(this.model.status == "OPEN");
	        }
	        else {
	            if (this.model.status == "OPEN") {
	                expense.isEditable = true;
	                expense.isDescCostTypeOnlyEdit = true;
	            }
	            else {
	                expense.isEditable = false;
	                expense.isDescCostTypeOnlyEdit = false;
	            }
	            this.costAndExpensePopup.show(expense);
	        }
	    };
	    InvoiceUpdateComponent.prototype.ManualInvoiceLineUpdateSuccess = function ($event) {
	        console.log($event);
	        var cost = $event.CostAndExpenseModel;
	        var costExpenseIndex = this.model.costAndExpenseList.findIndex(function (x) { return x.costAndExpenseHashId == cost.costAndExpenseHashId; });
	        if (costExpenseIndex >= 0) {
	            this.model.costAndExpenseList[costExpenseIndex] = cost;
	        }
	    };
	    Object.defineProperty(InvoiceUpdateComponent.prototype, "totalAmountExVatFormat", {
	        get: function () {
	            var totalAmount = 0;
	            totalAmount = this.model.costAndExpenseList
	                .map(function (x) { return parseFloat(x.approvedAmountExVat.toString().replace(",", ".")); })
	                .reduce(function (sum, item) { return sum + item; }, 0);
	            return totalAmount == 0 ? "" : totalAmount.toString();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(InvoiceUpdateComponent.prototype, "totalAmountInVatFormat", {
	        get: function () {
	            var totalAmountInVat = 0;
	            totalAmountInVat = this.model.costAndExpenseList
	                .map(function (x) { return parseFloat(x.approvedAmountInVat.toString().replace(",", ".")); })
	                .reduce(function (sum, item) { return sum + item; }, 0);
	            return totalAmountInVat == 0 ? "" : totalAmountInVat.toString();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(InvoiceUpdateComponent.prototype, "totalVatAmountFormat", {
	        get: function () {
	            var totalAmount = 0;
	            totalAmount = this.model.costAndExpenseList
	                .map(function (x) { return parseFloat(x.approvedAmountVat.toString().replace(",", ".")); })
	                .reduce(function (sum, item) { return sum + item; }, 0);
	            return totalAmount == 0 ? "" : totalAmount.toString();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(InvoiceUpdateComponent.prototype, "vatSummary", {
	        get: function () {
	            var finalGroup;
	            var groups = this.GroupByVATPercentage(this.model.costAndExpenseList);
	            var vatSummary = [];
	            for (var block in groups) {
	                var vatBlock = {};
	                vatBlock["percentage"] = block;
	                vatBlock["totalAmountExVat"] = groups[block]
	                    .map(function (x) { return parseFloat(x.approvedAmountExVat.toString().replace(",", ".")); })
	                    .reduce(function (sum, item) { return sum + item; }, 0);
	                vatBlock["totalAmountExVat"] = this.roundFormatterService.transform(vatBlock["totalAmountExVat"]);
	                vatBlock["totalVatAmount"] = groups[block]
	                    .map(function (x) { return parseFloat(x.approvedAmountVat.toString().replace(",", ".")); })
	                    .reduce(function (sum, item) { return sum + item; }, 0);
	                vatBlock["totalVatAmount"] = this.roundFormatterService.transform(vatBlock["totalVatAmount"]);
	                vatSummary.push(vatBlock);
	            }
	            return vatSummary;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    InvoiceUpdateComponent.prototype.GroupByVATPercentage = function (selectedCostExpenseList) {
	        if (selectedCostExpenseList) {
	            var prop_1 = "approvedVatPercentage";
	            return selectedCostExpenseList.reduce(function (groups, item) {
	                var vatPercentage = item[prop_1];
	                groups[vatPercentage] = groups[vatPercentage] || [];
	                groups[vatPercentage].push(item);
	                return groups;
	            }, {});
	        }
	        else {
	            return {};
	        }
	    };
	    InvoiceUpdateComponent.prototype.KeyOfObject = function (obj) {
	        return Object.keys(obj);
	    };
	    InvoiceUpdateComponent.prototype.ngOnDestroy = function () {
	        if (this.sub) {
	            this.sub.unsubscribe();
	        }
	    };
	    __decorate([
	        core_1.ViewChild("successPopup"), 
	        __metadata('design:type', Object)
	    ], InvoiceUpdateComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild("removesuccessPopup"), 
	        __metadata('design:type', Object)
	    ], InvoiceUpdateComponent.prototype, "removesuccessPopup", void 0);
	    __decorate([
	        core_1.ViewChild("sendConfirmModal"), 
	        __metadata('design:type', Object)
	    ], InvoiceUpdateComponent.prototype, "sendConfirmModal", void 0);
	    __decorate([
	        core_1.ViewChild("manualInvoiceLine"), 
	        __metadata('design:type', Object)
	    ], InvoiceUpdateComponent.prototype, "manualInvoiceLine", void 0);
	    __decorate([
	        core_1.ViewChild("confirmModal"), 
	        __metadata('design:type', Object)
	    ], InvoiceUpdateComponent.prototype, "confirmModal", void 0);
	    __decorate([
	        core_1.ViewChild("manualInvoiceLineUpdate"), 
	        __metadata('design:type', Object)
	    ], InvoiceUpdateComponent.prototype, "manualInvoiceLineUpdate", void 0);
	    __decorate([
	        core_1.ViewChild("costAndExpensePopup"), 
	        __metadata('design:type', Object)
	    ], InvoiceUpdateComponent.prototype, "costAndExpensePopup", void 0);
	    InvoiceUpdateComponent = __decorate([
	        core_1.Component({
	            selector: "wego-invoice",
	            template: __webpack_require__(1008),
	            providers: [invoice_service_1.InvoiceService, instance_service_1.InstanceService, company_service_1.CompanyService],
	            styles: [
	                "\n      .form-horizontal .control-label {\n        text-align: left;\n      }\n    "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof invoice_service_1.InvoiceService !== 'undefined' && invoice_service_1.InvoiceService) === 'function' && _a) || Object, (typeof (_b = typeof instance_service_1.InstanceService !== 'undefined' && instance_service_1.InstanceService) === 'function' && _b) || Object, (typeof (_c = typeof company_service_1.CompanyService !== 'undefined' && company_service_1.CompanyService) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object, (typeof (_e = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _e) || Object, (typeof (_f = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _f) || Object, (typeof (_g = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _g) || Object, (typeof (_h = typeof rounding_formatter_service_1.RoundingFormatterService !== 'undefined' && rounding_formatter_service_1.RoundingFormatterService) === 'function' && _h) || Object])
	    ], InvoiceUpdateComponent);
	    return InvoiceUpdateComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h;
	}());
	exports.InvoiceUpdateComponent = InvoiceUpdateComponent;


/***/ },
/* 1006 */
/***/ function(module, exports) {

	"use strict";
	var CostAndExpenseModel = (function () {
	    function CostAndExpenseModel() {
	        this.reportedByPersonHashId = '';
	        this.reportedByPersonHashIdList = [];
	        this.reportedByName = '';
	        this.reportedByNameList = [];
	        this.costTypeHashId = '';
	        this.recipientOrganizationHashId = '';
	        this.recipientDriverHashId = '';
	        this.isCharge = true;
	        this.chargeToDriver = true;
	        this.reportedByDriver = true;
	        this.bookingHashId = "";
	        this.isDescCostTypeOnlyEdit = false;
	        //public sharedVehicleDriverHashId:string;
	        this.sharedVehicleGroupDriverHashId = '';
	    }
	    return CostAndExpenseModel;
	}());
	exports.CostAndExpenseModel = CostAndExpenseModel;


/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var RoundingFormatterService = (function () {
	    function RoundingFormatterService() {
	    }
	    RoundingFormatterService.prototype.transform = function (value, fractionSize) {
	        if (fractionSize === void 0) { fractionSize = 2; }
	        var formattedValue = value != null ? value.toString() : "";
	        if (formattedValue) {
	            var floatValue = parseFloat(formattedValue);
	            // let roundingValue = Math.pow(10, fractionSize);
	            // return Math.round(floatValue * roundingValue) / roundingValue;
	            return floatValue.toFixed(fractionSize);
	        }
	        return;
	    };
	    RoundingFormatterService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [])
	    ], RoundingFormatterService);
	    return RoundingFormatterService;
	}());
	exports.RoundingFormatterService = RoundingFormatterService;


/***/ },
/* 1008 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ breadCrumbTitle }}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"urlCustomerList\">\r\n            <i class=\"fa fa-file-text\"></i> {{ breadCrumbList }}</a>\r\n        </li>\r\n        <li class=\"active\">{{ breadCrumbTitle }}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n\r\n    <div class=\"nopad\">\r\n      <div class=\"row\">\r\n        <form>\r\n          <fieldset [disabled]=\"model.status!='OPEN'\">\r\n            <div class=\"form-horizontal col-sm-12\">\r\n              <div class=\"col-sm-12\">\r\n                <div class=\"form-group\">\r\n                  <label class=\"col-sm-2\">\r\n                    {{ 'LblInvoiceNumber' | translate }}\r\n                  </label>\r\n                  <div class=\"col-sm-2\" style=\"overflow-wrap: break-word;\" >\r\n                    {{ model.invoiceNumber }}\r\n                  </div>\r\n                  <label class=\"col-sm-2\">\r\n                    {{ 'LblInvoiceStatus' | translate }}\r\n                  </label>\r\n                  <div class=\"col-sm-4\">\r\n                    {{ model.translatedStatus }}\r\n                  </div>\r\n                </div>\r\n                <div class=\"form-group\">\r\n                  <label class=\"control-label col-sm-2\">\r\n                    <span class=\"text text-danger\">*</span>{{ 'LblDescription' | translate }}\r\n                  </label>\r\n                  <div class=\"col-sm-10\">\r\n                    <input maxlength=\"100\" type=\"text\" class=\"form-control\" [(ngModel)]=\"model.description\" name=\"description\">\r\n                    <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'Description' }}</span>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-sm-12\">\r\n              <fieldset class=\"form-horizontal col-md-6\" [disabled]=\"isEditMode\">\r\n                <legend class=\"legendStyle\">\r\n                  {{ 'LblSender' | translate }}\r\n                </legend>\r\n                <div class=\"form-group col-sm-12\">\r\n                  <!-- <label class=\"radio-inline\">\r\n                    <input type=\"radio\" [(ngModel)]=\"model.isSenderInstance\" name=\"sender\" (change)=\"SenderChange()\" [value]=\"true\"> {{ 'LblInstance' | translate }}\r\n                  </label> -->\r\n                  <label class=\"radio-inline\">\r\n                    <input type=\"radio\" [(ngModel)]=\"model.isSenderInstance\" name=\"sender\" (change)=\"SenderChange()\" [value]=\"false\">{{ 'LblCompany' | translate }}\r\n                  </label>\r\n                </div>\r\n                <div class=\"form-group\">\r\n                  <label class=\"control-label col-sm-3\">\r\n                    <span class=\"text text-danger\">*</span>{{ 'LblInstance' | translate }}\r\n                  </label>\r\n                  <div class=\"col-sm-9\">\r\n                    <select [(ngModel)]=\"model.senderInstanceHashId\" name=\"instance\" class=\"form-control\" (change)=\"OnInstanceChange()\">\r\n                      <option value=\"\" selected>{{ 'LblSelect' | translate }} {{ 'LblInstance' | translate }}</option>\r\n                      <option *ngFor=\"let inst of instanceList\" [ngValue]='inst.keyHash'>{{inst.value}}</option>\r\n                    </select>\r\n                    <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'SenderInstanceHashId' }}</span>\r\n                  </div>\r\n                </div>\r\n                <div *ngIf=\"!model.isSenderInstance\" class=\"form-group\">\r\n                  <label class=\"control-label col-sm-3\">\r\n                    <span class=\"text text-danger\">*</span>{{ 'LblCompany' | translate }}\r\n                  </label>\r\n                  <div class=\"col-sm-9\">\r\n                    <select [(ngModel)]=\"model.senderCompanyHashId\" name=\"company\" class=\"form-control\" (change)=\"OnCompanyChange()\">\r\n                      <option value=\"\" selected>{{ 'LblSelect' | translate }} {{ 'LblCompany' | translate }}</option>\r\n                      <option *ngFor=\"let company of companyList\" [ngValue]='company.keyHash'>{{company.value}}</option>\r\n                    </select>\r\n                    <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'SenderCompanyHashId' }}</span>\r\n                  </div>\r\n                </div>\r\n                <hr>\r\n                <div class=\"form-group\">\r\n                  <label class=\"control-label col-sm-3\">{{ 'LblName' | translate }}</label>\r\n                  <div class=\"col-sm-9\">\r\n                    <input type=\"text\" class=\"form-control\" name=\"senderName\" id=\"senderName\" [(ngModel)]=\"model.senderName\" readonly>\r\n                  </div>\r\n                </div>\r\n                <div class=\"form-group\">\r\n                  <label class=\"control-label col-sm-3\">{{ 'LblAddress' | translate }}</label>\r\n                  <div class=\"col-sm-9\">\r\n                    <input type=\"text\" class=\"form-control\" name=\"senderAddress\" id=\"senderAddress\" [(ngModel)]=\"model.senderAddress\" readonly>\r\n                  </div>\r\n                </div>\r\n              </fieldset>\r\n              <fieldset class=\"form-horizontal col-md-6\" [disabled]=\"isEditMode\">\r\n                <legend class=\"legendStyle\">\r\n                  {{ 'LblAddressee' | translate }}\r\n                </legend>\r\n                <div class=\"form-group col-sm-12\">\r\n                  <label class=\"radio-inline\">\r\n                    <input type=\"radio\" [(ngModel)]=\"model.addresseeType\" name=\"addressee\" (change)=\"SetAddreseeAddress()\" value=\"DRIVER\">{{ 'LblDriver' | translate }}\r\n                  </label>\r\n                  <label class=\"radio-inline\">\r\n                    <input type=\"radio\" [(ngModel)]=\"model.addresseeType\" name=\"addressee\" (change)=\"SetAddreseeAddress()\" value=\"ORGANIZATION\">{{ 'LblOrganization' | translate }}\r\n                  </label>\r\n                </div>\r\n                <div *ngIf=\"model.addresseeType=='DRIVER'\" class=\"form-group\">\r\n                  <label class=\"control-label col-sm-3\">\r\n                    <span class=\"text text-danger\">*</span>{{ 'LblDriver' | translate }}\r\n                  </label>\r\n                  <div class=\"col-sm-9\">\r\n                    <div class=\"input-group\">\r\n                      <input [(ngModel)]=\"model.driverName\" name=\"driverName\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblDriver' | translate }}\"\r\n                        readonly>\r\n                      <div class=\"input-group-btn\">\r\n                        <button [disabled]=\"!addresseeEnabled\" class=\"btn btn-default\" type=\"button\" (click)=\"selectDriverModal.show(model.senderInstanceHashId,model.senderCompanyHashId)\">\r\n                          <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\r\n                        </button>\r\n                      </div>\r\n                    </div>\r\n                    <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'DriverHashId' }}</span>\r\n                  </div>\r\n                </div>\r\n                <div *ngIf=\"model.addresseeType=='ORGANIZATION'\" class=\"form-group\">\r\n                  <label class=\"control-label col-sm-3\">\r\n                    <span class=\"text text-danger\">*</span>{{ 'LblOrganization' | translate }}\r\n                  </label>\r\n                  <div class=\"col-sm-9\">\r\n                    <div class=\"input-group\">\r\n                      <input [(ngModel)]=\"model.organizationName\" name=\"organizationName\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblOrganization' | translate }}\"\r\n                        readonly>\r\n                      <div class=\"input-group-btn\">\r\n                        <button [disabled]=\"!addresseeEnabled\" class=\"btn btn-default\" type=\"button\" (click)=\"selectOrganizationModal.show(model.senderInstanceHashId,model.senderCompanyHashId)\">\r\n                          <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\r\n                        </button>\r\n                      </div>\r\n                    </div>\r\n                    <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'OrganizationHashId' }}</span>\r\n                  </div>\r\n                </div>\r\n                <div *ngIf=\"!model.isSenderInstance\" class=\"form-group\" style=\"height: 34px;\"></div>\r\n                <hr>\r\n                <div class=\"form-group\">\r\n                  <label class=\"control-label col-sm-3\">{{ 'LblName' | translate }}</label>\r\n                  <div class=\"col-sm-9\">\r\n                    <input type=\"text\" class=\"form-control\" name=\"addresseeName\" id=\"addresseeName\" [(ngModel)]=\"model.addresseeName\" readonly>\r\n                  </div>\r\n                </div>\r\n                <div class=\"form-group\">\r\n                  <label class=\"control-label col-sm-3\">{{ 'LblAddress' | translate }}</label>\r\n                  <div class=\"col-sm-9\">\r\n                    <input type=\"text\" class=\"form-control\" name=\"addresseeAddress\" id=\"addresseeAddress\" [(ngModel)]=\"model.addresseeAddress\"\r\n                      readonly>\r\n                  </div>\r\n                </div>\r\n              </fieldset>\r\n              <div class=\"clearfix\"></div>\r\n              <fieldset class=\"form-horizontal col-md-6\">\r\n                <legend class=\"legendStyle\">\r\n                  {{ 'LblInvoice' | translate }} {{ 'LblSummary' | translate }}\r\n                </legend>\r\n                <div class=\"form-group\">\r\n                  <label class=\"control-label col-sm-9\">{{ 'LblTotalAmount' | translate }} ({{ 'LblExVat' | translate }})</label>\r\n                  <div class=\"col-sm-3\">\r\n                    <input type=\"text\" class=\"form-control\" name=\"totalAmountExVat\" id=\"totalAmountExVat\" value=\"{{ totalAmountExVatFormat | roundingFormatter | decimalFormatter }}\"\r\n                      readonly>\r\n                  </div>\r\n                </div>\r\n                <div class=\"form-group\">\r\n                  <label class=\"control-label col-sm-9\">{{ 'LblVatAmount' | translate }}</label>\r\n                  <div class=\"col-sm-3\">\r\n                    <input type=\"text\" class=\"form-control\" name=\"totalVatAmount\" id=\"totalVatAmount\" value=\"{{ totalVatAmountFormat | roundingFormatter | decimalFormatter }}\"\r\n                      readonly>\r\n                  </div>\r\n                </div>\r\n                <div class=\"form-group\">\r\n                  <label class=\"control-label col-sm-9\">{{ 'LblTotalAmount' | translate }} ({{ 'LblInclVat' | translate }})</label>\r\n                  <div class=\"col-sm-3\">\r\n                    <input type=\"text\" class=\"form-control\" name=\"totalAmountExVat\" id=\"totalAmountExVat\" value=\"{{ totalAmountInVatFormat | roundingFormatter | decimalFormatter }}\"\r\n                      readonly>\r\n                  </div>\r\n                </div>\r\n              </fieldset>\r\n              <fieldset class=\"form-horizontal col-md-6\">\r\n                <legend class=\"legendStyle\">\r\n                  {{ 'LblVat' | translate }} {{ 'LblSummary' | translate }}\r\n                </legend>\r\n                <div class=\"table table-responsive mar_bot_ziro\">\r\n                  <table class=\"table table-bordered mar_bot_ziro\">\r\n                    <thead>\r\n                      <tr>\r\n                        <th>\r\n                          {{ 'LblVat' | translate }} %\r\n                        </th>\r\n                        <th>\r\n                          {{ 'LblAmount' | translate }}\r\n                        </th>\r\n                        <th>\r\n                          {{ 'LblVatAmount' | translate }}\r\n                        </th>\r\n                      </tr>\r\n                    </thead>\r\n                    <tbody>\r\n                      <tr *ngFor=\"let selectedVat of vatSummary\">\r\n                        <td>\r\n                          {{selectedVat.percentage | roundingFormatter | decimalFormatter }}\r\n                        </td>\r\n                        <td>\r\n                          {{selectedVat.totalAmountExVat | roundingFormatter | decimalFormatter }}\r\n                        </td>\r\n                        <td>\r\n                          {{selectedVat.totalVatAmount | roundingFormatter | decimalFormatter }}\r\n                        </td>\r\n                      </tr>\r\n                      <tr *ngIf=\"!vatSummary || (vatSummary && vatSummary.length == 0)\">\r\n                        <td class=\"text-center text-danger\" colspan=\"3\">\r\n                          {{ 'LblNoRecords' | translate }}\r\n                        </td>\r\n                      </tr>\r\n                    </tbody>\r\n                  </table>\r\n                </div>\r\n              </fieldset>\r\n              <div class=\"clearfix\"></div>\r\n              <fieldset class=\"col-md-12\">\r\n                <legend class=\"legendStyle\" style=\"padding-bottom: 5px;\">\r\n                  {{ 'LblInvoiceLines' | translate }}\r\n                  <a *ngIf=\"(model.driverHashId || model.organizationHashId) && model.status=='OPEN'\" class=\"btn btn-green btn-sm pull-right cursor-pointer\"\r\n                    (click)=\"AddManualInvoiceLine()\">{{ 'LblAddLine' | translate }}</a>                \r\n                </legend>\r\n                <div class=\"table table-responsive mar_bot_ziro\">\r\n                  <table class=\"table table-bordered mar_bot_ziro\">\r\n                    <thead>\r\n                      <tr>\r\n                        <th class=\"text-center parent-checkbox\">\r\n                        </th>\r\n                        <th>\r\n                          {{ 'LblDescription' | translate }}\r\n                        </th>\r\n                        <th>\r\n                          {{ 'LblAmount' | translate }} {{ 'LblExVat' | translate }}\r\n                        </th>\r\n                        <th>\r\n                          {{ 'LblAmount' | translate }} {{ 'LblInclVat' | translate }}\r\n                        </th>\r\n                        <th>\r\n                          {{ 'LblVat' | translate }} %\r\n                        </th>\r\n                        <th>\r\n                          {{ 'LblVatAmount' | translate }}\r\n                        </th>\r\n                      </tr>\r\n                    </thead>\r\n                    <tbody>\r\n                      <tr *ngFor=\"let expense of model.costAndExpenseList\">\r\n                        <td class=\"text-center\">\r\n                          <a *ngIf=\"model.status=='OPEN'\" class=\"cursor-pointer\" (click)=\"ShowConfirmModal(expense.costAndExpenseHashId,expense.invoiceHashId)\">\r\n                            <i class=\"fa fa-fw fa-times text-danger\"></i>\r\n                          </a>\r\n                        </td>\r\n                        <td>\r\n                          <a class=\"cursor-pointer\" (click)=\"ShowUpdateManualInvoiceLinePopup(expense)\">\r\n                            {{ expense.description }}\r\n                          </a>\r\n                        </td>\r\n                        <td>\r\n                          {{expense.approvedAmountExVat }}\r\n                        </td>\r\n                        <td>\r\n                          {{expense.approvedAmountInVat }}\r\n                        </td>\r\n                        <td>\r\n                          {{expense.approvedVatPercentage  }}\r\n                        </td>\r\n                        <td>\r\n                          {{expense.approvedAmountVat }}\r\n                        </td>\r\n                      </tr>\r\n                      <tr *ngIf=\"!model.costAndExpenseList || (model.costAndExpenseList && model.costAndExpenseList.length == 0)\">\r\n                        <td class=\"text-center text-danger\" colspan=\"6\">\r\n                          {{ 'LblNoRecords' | translate }}\r\n                        </td>\r\n                      </tr>\r\n                    </tbody>\r\n                  </table>\r\n                </div>\r\n              </fieldset>\r\n            </div>\r\n          </fieldset>\r\n          <div class=\"col-sm-12\">\r\n            <div class=\"col-sm-12\">\r\n              <hr>\r\n              <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnBackClick()\">{{ 'LblCancel' | translate }}</a> &nbsp;&nbsp;\r\n              <a class=\"btn btn-green cursor-pointer\" *ngIf=\"((model.status=='OPEN')) && model.costAndExpenseList && model.costAndExpenseList.length > 0\" (click)=\"ShowSendConfirmModal()\">{{ 'LblSendInvoice' | translate }}</a> &nbsp;&nbsp;\r\n            </div>\r\n          </div>\r\n        </form>\r\n      </div>\r\n    </div>\r\n\r\n  </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n<wego-invoice-driver-popup #selectDriverModal (OnSuccessSelect)=\"SuccessSelectDriverModal($event)\"></wego-invoice-driver-popup>\r\n<wego-invoice-organization-popup #selectOrganizationModal (OnSuccessSelect)=\"SuccessSelectOrganizationModal($event)\"></wego-invoice-organization-popup>\r\n<wego-manual-invoice-line-popup #manualInvoiceLine (OnSuccessSelect)=\"ManualInvoiceLineSuccess($event)\"></wego-manual-invoice-line-popup>\r\n<wego-confirm-popup #confirmModal [popupMsg]=\"deleteMessage\" (onConfirm)=\"ConfirmSuccessClick()\" (onReject)=\"HideConfirmModal()\"></wego-confirm-popup>\r\n<wego-success-popup #removesuccessPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmRemoveSuccessPopup()\"></wego-success-popup>\r\n<wego-manual-invoice-line-update-popup #manualInvoiceLineUpdate (OnSuccessSelect)=\"ManualInvoiceLineUpdateSuccess($event)\"></wego-manual-invoice-line-update-popup>\r\n<confirm-costandexpense-popup #costAndExpensePopup (OnSuccessSelect)=\"ManualInvoiceLineUpdateSuccess($event)\"></confirm-costandexpense-popup>\r\n<wego-confirm-popup #sendConfirmModal [popupMsg]=\"confirmMsg \" (onConfirm)=\"SuccessConfirmModalClick() \" (onReject)=\"HideSendConfirmModal() \"></wego-confirm-popup>";

/***/ },
/* 1009 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var flatpickr_model_1 = __webpack_require__(83);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var config_2 = __webpack_require__(60);
	var cost_expense_model_1 = __webpack_require__(1006);
	var cost_expense_service_1 = __webpack_require__(1010);
	var moment = __webpack_require__(84);
	var SlimSelect = __webpack_require__(616);
	var CostAndExpenseListComponent = (function () {
	    function CostAndExpenseListComponent(authService, router, translate, costAndExpenseService) {
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.costAndExpenseService = costAndExpenseService;
	        this.dateFormat = config_2.WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
	        this.DataListModel = new config_2.DataListModel();
	    }
	    Object.defineProperty(CostAndExpenseListComponent.prototype, "isAnyChecked", {
	        get: function () {
	            if (this.costAndExpenseList) {
	                var isCheck = this.costAndExpenseList.some(function (x) { return x.isChecked == true; });
	                if (isCheck) {
	                    if (this.costAndExpenseList
	                        .filter(function (y) { return y.isDeletable; })
	                        .every(function (x) { return x.isChecked == true; }))
	                        this.isParentCheck = true;
	                    else
	                        this.isParentCheck = false;
	                }
	                else {
	                    this.isParentCheck = false;
	                }
	                return isCheck;
	            }
	            else {
	                this.isParentCheck = false;
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    CostAndExpenseListComponent.prototype.ngOnInit = function () {
	        this.module = this.translate.instant("LblCostAndExpenses");
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = [
	            "ReportedByName",
	            "Description",
	            "CostType",
	            "Status",
	            "InvoiceNumber"
	        ];
	        this.model = new cost_expense_model_1.CostAndExpenseModel();
	        this.popupModel = new cost_expense_model_1.CostAndExpenseModel();
	        this.model.fromDateTime = moment()
	            .add(-1, "M")
	            .format("DD-MM-YYYY 00:00");
	        this.model.toDateTime = moment()
	            .format("DD-MM-YYYY 23:59");
	        this.LblStatus = this.translate.instant("LblStatus");
	        this.LblSelect = this.translate.instant("LblSelect");
	        this.CostStatus = [
	            {
	                Key: "PENDING",
	                Value: "PENDING"
	            },
	            {
	                Key: "APPROVED",
	                Value: "APPROVED"
	            },
	            {
	                Key: "REJECTED",
	                Value: "REJECTED"
	            }
	        ];
	        this.model.statusList = this.CostStatus.map(function (x) { return x.Value; });
	        this.model = this.authService.AssignFromStorage(this.constructor.name + "_model", this.model);
	        this.urlInvoice = this.authService.GetURL(config_1.ApplicationRouteURL.URL_INVOICE_UPDATE);
	        this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlPersonInfo = this.authService.GetURL(config_1.ApplicationRouteURL.URL_PERSON_UPDATE);
	        this.model.reportedByName = this.model.reportedByNameList.join();
	        this.itemPerPageList = config_2.WeGoConfig.GRID_PAGGING;
	        this.DataListModel.itemsPerPage = 10;
	        this.GetCostAndExpenseList();
	    };
	    CostAndExpenseListComponent.prototype.SetDefaultFlatPickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = true;
	        flatPickrConfig.time_24hr = true;
	        flatPickrConfig.dateFormat = this.dateFormat;
	        flatPickrConfig.minuteIncrement = 1;
	        return flatPickrConfig;
	    };
	    CostAndExpenseListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetCostAndExpenseList();
	    };
	    CostAndExpenseListComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        if (event.isReset) {
	            this.model.toDateTime = moment()
	                .add(+1, "days")
	                .format("DD-MM-YYYY 00:00");
	            this.model.fromDateTime = moment()
	                .add(-1, "M")
	                .format("DD-MM-YYYY 00:00");
	        }
	        this.GetCostAndExpenseList();
	    };
	    CostAndExpenseListComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetCostAndExpenseList();
	    };
	    CostAndExpenseListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.costAndExpenseService
	            .ExportCostAndExpenseList(this.model, this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "CostAndExpense" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    CostAndExpenseListComponent.prototype.GetCostAndExpenseList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.costAndExpenseService
	            .GetCostAndExpenseList(this.model, this.DataListModel)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.costAndExpenseList = res.data;
	                _this.DataListModel.totalItems = res.totalRecords;
	                _this.DataListModel.infoMessage = res.error;
	                _this.isParentCheckEnable =
	                    _this.costAndExpenseList.filter(function (x) { return x.isDeletable; }).length > 0
	                        ? true
	                        : false;
	                _this.isLoading = false;
	                _this.errorModel = null;
	            }
	            else {
	                _this.DataListModel.totalItems = res.totalRecords;
	                _this.DataListModel.infoMessage = _this.translate.instant("LblNoRecords");
	                _this.errorModel = res.error;
	                _this.isLoading = false;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    CostAndExpenseListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetCostAndExpenseList();
	    };
	    CostAndExpenseListComponent.prototype.OnParentCheck = function (isChecked) {
	        this.costAndExpenseList
	            .filter(function (y) { return y.isDeletable; })
	            .forEach(function (x) { return (x.isChecked = isChecked); });
	    };
	    CostAndExpenseListComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	        this.authService.SaveToStorage(this.constructor.name + "_model", this.model);
	    };
	    CostAndExpenseListComponent.prototype.StatusChangeMultiSelect = function () { };
	    CostAndExpenseListComponent.prototype.SuccessSelectDriverModal = function ($event) {
	        this.model.reportedByNameList = $event.PersonName;
	        this.model.reportedByName = this.model.reportedByNameList.join(",");
	        this.model.reportedByPersonHashIdList = $event.PersonHashID;
	    };
	    CostAndExpenseListComponent.prototype.ClearReportedBy = function () {
	        this.model.reportedByPersonHashId = "";
	        this.model.reportedByNameList = [];
	        this.model.reportedByName = "";
	        this.model.reportedByPersonHashIdList = [];
	    };
	    CostAndExpenseListComponent.prototype.ngAfterViewInit = function () {
	        var _this = this;
	        this.StatusSelect = new SlimSelect({
	            select: "#status",
	            placeholder: this.LblSelect + " " + this.LblStatus,
	            showSearch: false,
	            onChange: function (info) {
	                _this.model.statusList = info.map(function (x) { return x.value; });
	            }
	        });
	        this.StatusSelect.set(this.model.statusList);
	    };
	    Object.defineProperty(CostAndExpenseListComponent.prototype, "isDeleteAccess", {
	        get: function () {
	            if (this.costAndExpenseList) {
	                return this.costAndExpenseList.some(function (x) { return x.isDeletable; });
	            }
	            else {
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    CostAndExpenseListComponent.prototype.DeleteCostAndExpense = function (deleteCostAndExpenseHashId) {
	        var _this = this;
	        this.isLoading = true;
	        this.costAndExpenseService
	            .DeleteCostAndExpenses(deleteCostAndExpenseHashId)
	            .subscribe(function (res) {
	            _this.DataListModel.currentPage = 1;
	            _this.GetCostAndExpenseList();
	            _this.popupMsg = _this.translate.instant("LblRecordRemovedSuccess", [
	                _this.module
	            ]);
	            _this.ShowSuccessPopup();
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    CostAndExpenseListComponent.prototype.ShowAlertModal = function (costAndExpenseHashId) {
	        if (costAndExpenseHashId) {
	            this.popupMsg = this.translate.instant("LblRecordDeleteConfirmation", [
	                this.module
	            ]);
	            this.isMultipleDelete = false;
	            this.deletecostAndExpenseHashId = costAndExpenseHashId;
	        }
	        else {
	            this.popupMsg = this.translate.instant("LblRecordMultiplDeleteConfirmation", [this.module]);
	            this.isMultipleDelete = true;
	        }
	        this.alertModal.show();
	    };
	    CostAndExpenseListComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    CostAndExpenseListComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    CostAndExpenseListComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    CostAndExpenseListComponent.prototype.HideAlertModal = function () {
	        this.deletecostAndExpenseHashId = "";
	        this.alertModal.hide();
	    };
	    CostAndExpenseListComponent.prototype.SuccessAlertModalClick = function () {
	        var deleteCostAndExpenseList;
	        if (this.isMultipleDelete)
	            deleteCostAndExpenseList = this.costAndExpenseList
	                .filter(function (x) { return x.isChecked; })
	                .map(function (x) { return x.costAndExpenseHashId; });
	        else
	            deleteCostAndExpenseList.push(this.deletecostAndExpenseHashId);
	        this.DeleteCostAndExpense(deleteCostAndExpenseList);
	        this.alertModal.hide();
	    };
	    CostAndExpenseListComponent.prototype.ShowCostAndExpensemodel = function (costAndExpenseviewModel) {
	        var _this = this;
	        this.costAndExpenseService
	            .GetCostAndExpenseByHashId(costAndExpenseviewModel.costAndExpenseHashId)
	            .subscribe(function (res) {
	            res.data.module = "COSTANDEXPENSELIST";
	            if (res.data.reportedByDriver) {
	                _this.costAndExpensePopup.show(res.data);
	            }
	            else {
	                console.log(costAndExpenseviewModel);
	                _this.manualInvoiceLineUpdate.model = res.data;
	                if (costAndExpenseviewModel.invoiceStatus == "CLOSED") {
	                    _this.manualInvoiceLineUpdate.model.isEditable = false;
	                }
	                _this.manualInvoiceLineUpdate.show(_this.manualInvoiceLineUpdate.model.isEditable);
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    CostAndExpenseListComponent.prototype.SuccessCostAndExpenseList = function () {
	        this.popupMsg = this.translate.instant("LblRecordSavedSuccess", [
	            this.module
	        ]);
	        this.GetCostAndExpenseList();
	        this.ShowSuccessPopup();
	    };
	    __decorate([
	        core_1.ViewChild("alertModal"), 
	        __metadata('design:type', Object)
	    ], CostAndExpenseListComponent.prototype, "alertModal", void 0);
	    __decorate([
	        core_1.ViewChild("successPopup"), 
	        __metadata('design:type', Object)
	    ], CostAndExpenseListComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild("costAndExpensePopup"), 
	        __metadata('design:type', Object)
	    ], CostAndExpenseListComponent.prototype, "costAndExpensePopup", void 0);
	    __decorate([
	        core_1.ViewChild("manualInvoiceLineUpdate"), 
	        __metadata('design:type', Object)
	    ], CostAndExpenseListComponent.prototype, "manualInvoiceLineUpdate", void 0);
	    CostAndExpenseListComponent = __decorate([
	        core_1.Component({
	            selector: "wego-cost-expense-list",
	            template: __webpack_require__(1011),
	            providers: [cost_expense_service_1.CostAndExpenseService],
	            styles: [
	                "\n      .nopad-left {\n        padding-left: 0px;\n      }\n      .form-horizontal .control-label {\n        text-align: left;\n      }\n    "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _c) || Object, (typeof (_d = typeof cost_expense_service_1.CostAndExpenseService !== 'undefined' && cost_expense_service_1.CostAndExpenseService) === 'function' && _d) || Object])
	    ], CostAndExpenseListComponent);
	    return CostAndExpenseListComponent;
	    var _a, _b, _c, _d;
	}());
	exports.CostAndExpenseListComponent = CostAndExpenseListComponent;


/***/ },
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var http_1 = __webpack_require__(59);
	var core_1 = __webpack_require__(3);
	var auth_service_1 = __webpack_require__(58);
	var config_1 = __webpack_require__(60);
	var jquery_helper_service_1 = __webpack_require__(67);
	var CostAndExpenseService = (function () {
	    function CostAndExpenseService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	        this.JQueryHelper = new jquery_helper_service_1.JQueryHelperService();
	    }
	    CostAndExpenseService.prototype.GetCostAndExpenseList = function (model, input) {
	        var getBookingOverviewUrl = config_1.WeGoConfig.API_GET_COSTANDEXPENSE_LIST;
	        var queryStringDataListModel = this.authService.HandleAPIListInput(input);
	        var queryStringCostAndExpense = this.JQueryHelper.Param(model);
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        getBookingOverviewUrl =
	            getBookingOverviewUrl +
	                "?" +
	                queryStringDataListModel +
	                "&" +
	                decodeURIComponent(queryStringCostAndExpense);
	        return this.http
	            .get(getBookingOverviewUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CostAndExpenseService.prototype.ExportCostAndExpenseList = function (model, input) {
	        input.currentPage = 0;
	        var getBookingOverviewUrl = config_1.WeGoConfig.API_EXPORT_COSTANDEXPENSE_LIST;
	        var queryStringDataListModel = this.authService.HandleAPIListInput(input);
	        var queryStringCostAndExpense = this.JQueryHelper.Param(model);
	        var headers = this.authService.GetHeader("text/csv");
	        var options = new http_1.RequestOptions({ headers: headers });
	        getBookingOverviewUrl =
	            getBookingOverviewUrl +
	                "?" +
	                queryStringDataListModel +
	                "&" +
	                decodeURIComponent(queryStringCostAndExpense);
	        return this.http.get(getBookingOverviewUrl, options);
	    };
	    CostAndExpenseService.prototype.DeleteCostAndExpenses = function (selectedcostandExpensesHashId) {
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        var getContractTypeUrl = config_1.WeGoConfig.API_POST_DELETE_COSTANDEXPENSE;
	        return this.http
	            .post(getContractTypeUrl, selectedcostandExpensesHashId, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CostAndExpenseService.prototype.GetCostAndExpenseByHashId = function (costandExpensesHashId) {
	        var getContractTypeUrl = config_1.WeGoConfig.API_GET_COSTANDEXPENSE_BY_HASH +
	            "?costAndExpenseHashId=" +
	            costandExpensesHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getContractTypeUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CostAndExpenseService.prototype.GetDropdownCostTypeList = function (reportedByPerosnHashId, addreseeDriverHashId, addreseeOrganizationHashId) {
	        if (reportedByPerosnHashId === void 0) { reportedByPerosnHashId = ""; }
	        if (addreseeDriverHashId === void 0) { addreseeDriverHashId = ""; }
	        if (addreseeOrganizationHashId === void 0) { addreseeOrganizationHashId = ""; }
	        var getCostTypeUrl;
	        getCostTypeUrl = config_1.WeGoConfig.API_GET_DROPDOWN_COSTTYPE_LIST;
	        getCostTypeUrl =
	            getCostTypeUrl +
	                "?reportedByPerosnHashId=" +
	                reportedByPerosnHashId +
	                "&addreseeDriverHashId=" +
	                addreseeDriverHashId +
	                "&addreseeOrganizationHashId=" +
	                addreseeOrganizationHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getCostTypeUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CostAndExpenseService.prototype.GetDropdownOrganizationList = function (reportedByPerosnHashId, reportedByDriver) {
	        var getCostTypeUrl;
	        getCostTypeUrl =
	            config_1.WeGoConfig.API_GET_DROPDOWN_COSTANDEXPENSE_ORGANIZATION_LIST;
	        getCostTypeUrl =
	            getCostTypeUrl +
	                "?reportedByPerosnHashId=" +
	                reportedByPerosnHashId +
	                "&reportedByDriver=" +
	                reportedByDriver;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getCostTypeUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CostAndExpenseService.prototype.AcceptReject = function (model, approve, reject) {
	        var body = model;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        var getCostTypeUrl = config_1.WeGoConfig.API_POST_APPROVE_REJECT_COSTANDEXPENSE;
	        getCostTypeUrl =
	            getCostTypeUrl + "?approve=" + approve + "&reject=" + reject;
	        return this.http
	            .post(getCostTypeUrl, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CostAndExpenseService.prototype.GetApprovedExpenseList = function (sharedVehicleDriverHashId, organizationHashId) {
	        var getCostTypeUrl;
	        getCostTypeUrl = config_1.WeGoConfig.API_GET_APPROVED_COSTANDEXPENSE_LIST;
	        if (sharedVehicleDriverHashId) {
	            getCostTypeUrl = getCostTypeUrl +
	                "?sharedVehicleDriverHashId=" + sharedVehicleDriverHashId;
	        }
	        else if (organizationHashId) {
	            getCostTypeUrl = getCostTypeUrl +
	                "?organizationHashId=" + organizationHashId;
	        }
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getCostTypeUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CostAndExpenseService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], CostAndExpenseService);
	    return CostAndExpenseService;
	    var _a, _b;
	}());
	exports.CostAndExpenseService = CostAndExpenseService;


/***/ },
/* 1011 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ 'LblCostAndExpenses' | translate }}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li class=\"active\">{{ 'LblCostAndExpenses' | translate }}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"col-md-3 col-sm-6 mar_t_25\">\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <form (ngSubmit)=\"OnSearch($event)\">\r\n          <div class=\"row\">\r\n            <div class=\"form-group col-md-3\">\r\n              <label>{{ 'LblReportedBy' | translate }}</label>\r\n              <div class=\"input-group\">\r\n                <input [(ngModel)]=\"model.reportedByName\" [attr.title]=\"model.reportedByName\" name=\"ReportedBy\" type=\"text\" class=\"form-control\"\r\n                  placeholder=\"{{ 'LblAll' | translate }} {{ 'LblReportedBy' | translate }}\" readonly>\r\n                <div class=\"input-group-btn\">\r\n                  <button class=\"btn btn-default\" type=\"button\" (click)=\"selectReportedByModal.show(model.reportedByPersonHashIdList,model.reportedByNameList)\">\r\n                    <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\r\n                  </button>\r\n                  <button class=\"btn btn-default\" type=\"button\" (click)=\"ClearReportedBy()\">\r\n                    <i class=\"fa fa-eraser\" aria-hidden=\"true\"></i>\r\n                  </button>\r\n                </div>\r\n              </div>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'ReportedByPersonHashId' }}</span>\r\n            </div>\r\n            <div class=\"form-group col-md-3 nopad-left\">\r\n              <label>{{ 'LblStatus' | translate }} </label>\r\n              <select id=\"status\" name=\"status\" (change)=\"StatusChangeMultiSelect()\" multiple>\r\n                <option *ngFor=\"let item of CostStatus\" [attr.value]='item.Value'>{{item.Key}}</option>\r\n              </select>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'status' }}</span>\r\n            </div>\r\n            <div class=\"form-group col-md-3 nopad-left\">\r\n              <label>{{ 'LblFrom' | translate }}</label>\r\n              <div class=\"clearfix\"></div>\r\n              <div class=\"input-group\">\r\n                <span class=\"input-group-addon\">\r\n                  <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n                </span>\r\n                <input flatpickr readonly [Config]=\"flatPickrConfigFrom\" [(ngModel)]=\"model.fromDateTime\" name=\"fromDateTime\" type=\"text\"\r\n                  class=\"form-control\" placeholder=\"{{ 'LblFrom' | translate }}\">\r\n              </div>\r\n            </div>\r\n            <div class=\"form-group col-md-3 nopad-left\">\r\n              <label>{{ 'LblTo' | translate }}</label>\r\n              <div class=\"clearfix \"></div>\r\n              <div class=\"input-group\">\r\n                <span class=\"input-group-addon\">\r\n                  <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n                </span>\r\n                <input flatpickr readonly [Config]=\"flatPickrConfigTo\" [(ngModel)]=\"model.toDateTime\" name=\"toDateTime\" type=\"text\" class=\"form-control\"\r\n                  placeholder=\"{{ 'LblTo' | translate }}\">\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <wego-search-list [IsDeleted]=\"isDeleteAccess\" [IsDeleteEnabled]=\"isAnyChecked\" (OnSearch)=\"OnSearch($event)\" (OnDeleteAll)=\"ShowAlertModal()\"\r\n            (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\"\r\n            [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        </form>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center parent-checkbox\">\r\n                  <input type=\"checkbox\" [(ngModel)]=\"isParentCheck\" [disabled]=\"!isParentCheckEnable\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\">\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('reportedByName')\">\r\n                  {{ 'LblReportedBy' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'reportedByName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('reportedDateTimeUTC')\">\r\n                  {{ 'LblDate' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'reportedDateTimeUTC'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('description')\">\r\n                  {{ 'LblDescription' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'description'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('costType')\">\r\n                  {{ 'LblType' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'costType'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('reportedAmountInVatActual')\">\r\n                  {{ 'LblReportedAmount' | translate }} {{ 'LblInclVat' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'reportedAmountInVat'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('approvedAmountInVatActual')\">\r\n                  {{ 'LblApprovedAmount' | translate }} {{ 'LblInclVat' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'approvedAmountInVat'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('status')\">\r\n                  {{ 'LblStatus' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'status'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('invoiceNumber')\">\r\n                  {{ 'LblInvoiceNumber' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'invoiceNumber'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let expense of costAndExpenseList\">\r\n                  <td class=\"text-center\">\r\n                    <input *ngIf=\"!expense.isDeletable\" disabled type=\"checkbox\" name=\"isActive\">\r\n                    <input *ngIf=\"expense.isDeletable\" type=\"checkbox\" name=\"isActive\" [(ngModel)]=\"expense.isChecked\">\r\n                  </td>\r\n                  <td>\r\n                    <template [ngIf]=\"(expense.reportedByPersonHashId && !expense.isPersonDeleted && expense.isPersonEdit)\">\r\n                      <a [routerLink]=\"urlPersonInfo+'/'+ expense.reportedByPersonHashId\">\r\n                        {{ expense.reportedByName }}\r\n                      </a>\r\n                    </template>\r\n                    <template [ngIf]=\"expense.reportedByPersonHashId && (expense.isPersonDeleted || !expense.isPersonEdit)\">\r\n                      {{ expense.reportedByName }}\r\n                    </template>\r\n                  </td>\r\n                  <td>{{ expense.reportedDateTime}}</td>\r\n                  <td>\r\n                    <a class=\"cursor-pointer\" (click)=\"ShowCostAndExpensemodel(expense)\">\r\n                      {{expense.description }} </a>\r\n                  </td>\r\n                  <td>{{ expense.costType}}</td>\r\n                  <td>{{ expense.reportedAmountInVat }}</td>\r\n                  <td>{{ expense.approvedAmountInVat }}</td>\r\n                  <td>{{ expense.status}}</td>\r\n                  <td *ngIf=\"expense.invoiceType == 'MANUAL' && expense.isInvoiceEdit\">\r\n                      <a [routerLink]=\"urlInvoice + '/' + expense.invoiceHashId\">\r\n                        {{ expense.invoiceNumber }}\r\n                      </a>\r\n                  </td>\r\n                  <td *ngIf=\"expense.invoiceType !='MANUAL' || !expense.isInvoiceEdit\">                      \r\n                        {{ expense.invoiceNumber }}                      \r\n                  </td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"9\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<wego-confirm-popup #alertModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessAlertModalClick()\" (onReject)=\"HideAlertModal()\"></wego-confirm-popup>\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n<confirm-costandexpense-popup #costAndExpensePopup (OnSuccessSave)=\"SuccessCostAndExpenseList()\"></confirm-costandexpense-popup>\r\n<wego-costandexpense-person-popup #selectReportedByModal (OnSuccessSelect)=\"SuccessSelectDriverModal($event)\"></wego-costandexpense-person-popup>\r\n<wego-manual-invoice-line-update-popup #manualInvoiceLineUpdate (OnSuccessSelect)=\"SuccessCostAndExpenseList($event)\"></wego-manual-invoice-line-update-popup>";

/***/ },
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var auth_service_1 = __webpack_require__(58);
	var kickback_service_1 = __webpack_require__(1013);
	var instance_service_1 = __webpack_require__(500);
	var company_service_1 = __webpack_require__(501);
	var vehicle_service_1 = __webpack_require__(530);
	var sharedvehiclegroup_service_1 = __webpack_require__(510);
	var organization_service_1 = __webpack_require__(614);
	var customer_service_1 = __webpack_require__(664);
	var contracttypegroup_service_1 = __webpack_require__(730);
	var config_1 = __webpack_require__(60);
	var KickbackComponent = (function () {
	    function KickbackComponent(kickbackReportService, authService, customerService, instanceService, companyService, organizationService, sharedVehicleGroupService, vehicleService, contractTypeGroupService) {
	        this.kickbackReportService = kickbackReportService;
	        this.authService = authService;
	        this.customerService = customerService;
	        this.instanceService = instanceService;
	        this.companyService = companyService;
	        this.organizationService = organizationService;
	        this.sharedVehicleGroupService = sharedVehicleGroupService;
	        this.vehicleService = vehicleService;
	        this.contractTypeGroupService = contractTypeGroupService;
	        // @ViewChild("flatPickrConfigFromDate")
	        // public flatPickrConfigFromDate: FlatPickrDirective;
	        // @ViewChild("flatPickrConfigToDate")
	        // public flatPickrConfigToDate: FlatPickrDirective;
	        // public dateFormat: string = WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
	        // model: KickbackModel;
	        // KickbackList: KickbackModel[];
	        // flatPickrConfigFrom: FlatPickrModel;
	        // flatPickrConfigTo: FlatPickrModel;
	        // permissionType: string;
	        // apiErrorMsg: string;
	        // pageName: string;
	        // DataListModel: DataListModel;
	        // public listOfFilterRecord: any[];
	        this.isValidSearch = false;
	        this.roleLevel = config_1.RoleLevel;
	        this.isExport = false;
	    }
	    KickbackComponent.prototype.ngOnInit = function () {
	        this.reportName = "Kick_Back_Report";
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	    };
	    KickbackComponent.prototype.ResetValidSearch = function ($event) {
	        var isValidSearch = $event.isValidSearch;
	        this.isValidSearch = isValidSearch;
	        this.kickbackReportResult = [];
	    };
	    KickbackComponent.prototype.OnSearch = function ($event) {
	        var _this = this;
	        this.isLoading = true;
	        var model = $event.model;
	        this.kickbackReportService.GetKickbackRecord(model).subscribe(function (res) {
	            _this.errorModel = [];
	            if (!res.data) {
	                _this.isValidSearch = false;
	                _this.errorModel = res.error;
	            }
	            else {
	                console.log(res.data);
	                _this.kickbackReportResult = res.data;
	                _this.isValidSearch = res.data.length > 0 ? true : false;
	                if (typeof res.error === "string") {
	                    _this.errorMessage = res.error;
	                }
	                else {
	                    _this.errorModel = res.error;
	                }
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    KickbackComponent.prototype.OnExportExcel = function ($event) {
	        var _this = this;
	        this.isLoading = true;
	        var model = $event.model;
	        this.kickbackReportService.ExportKickBackReportExcel(model).subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "KickBackReport" + new Date().toISOString() + ".xlsx";
	                _this.authService.DownloadXlsFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    KickbackComponent.prototype.OnExportPDF = function ($event) {
	        var _this = this;
	        this.isLoading = true;
	        var model = $event.model;
	        this.kickbackReportService.ExportKickBackReportPdf(model).subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "KickBackReport" + new Date().toISOString() + ".pdf";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    KickbackComponent = __decorate([
	        core_1.Component({
	            selector: "wego-kickback-report",
	            template: __webpack_require__(1014),
	            styles: [
	                ".border-kickback {\n    border: 1px solid #E0E0E0;\n    padding: 5px 0px;\n  }"
	            ],
	            providers: [
	                customer_service_1.CustomerService,
	                instance_service_1.InstanceService,
	                company_service_1.CompanyService,
	                organization_service_1.OrganizationService,
	                sharedvehiclegroup_service_1.SharedVehicleGroupService,
	                vehicle_service_1.VehicleService,
	                contracttypegroup_service_1.ContractTypeGroupService,
	                kickback_service_1.KickbackService
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof kickback_service_1.KickbackService !== 'undefined' && kickback_service_1.KickbackService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof customer_service_1.CustomerService !== 'undefined' && customer_service_1.CustomerService) === 'function' && _c) || Object, (typeof (_d = typeof instance_service_1.InstanceService !== 'undefined' && instance_service_1.InstanceService) === 'function' && _d) || Object, (typeof (_e = typeof company_service_1.CompanyService !== 'undefined' && company_service_1.CompanyService) === 'function' && _e) || Object, (typeof (_f = typeof organization_service_1.OrganizationService !== 'undefined' && organization_service_1.OrganizationService) === 'function' && _f) || Object, (typeof (_g = typeof sharedvehiclegroup_service_1.SharedVehicleGroupService !== 'undefined' && sharedvehiclegroup_service_1.SharedVehicleGroupService) === 'function' && _g) || Object, (typeof (_h = typeof vehicle_service_1.VehicleService !== 'undefined' && vehicle_service_1.VehicleService) === 'function' && _h) || Object, (typeof (_j = typeof contracttypegroup_service_1.ContractTypeGroupService !== 'undefined' && contracttypegroup_service_1.ContractTypeGroupService) === 'function' && _j) || Object])
	    ], KickbackComponent);
	    return KickbackComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
	}());
	exports.KickbackComponent = KickbackComponent;


/***/ },
/* 1013 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var jquery_helper_service_1 = __webpack_require__(67);
	var KickbackService = (function () {
	    function KickbackService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	        this.JQueryHelper = new jquery_helper_service_1.JQueryHelperService();
	    }
	    KickbackService.prototype.GetKickbackRecord = function (input) {
	        var body = input;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_GET_KICKBACK_DATA_LIST, body, options).map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    KickbackService.prototype.ExportKickBackReportExcel = function (model) {
	        var getUrl = config_1.WeGoConfig.API_EXPORT_KICKBACK_REPORT_EXCEL;
	        var queryStringReportFilterModel = this.JQueryHelper.Param(model);
	        getUrl = getUrl + "?" + decodeURIComponent(queryStringReportFilterModel);
	        var headers = this.authService.GetHeader('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
	        var options = new http_1.RequestOptions({ headers: headers, responseType: http_1.ResponseContentType.Blob });
	        return this.http.get(getUrl, options);
	    };
	    KickbackService.prototype.ExportKickBackReportPdf = function (model) {
	        var getUrl = config_1.WeGoConfig.API_EXPORT_KICKBACK_REPORT_PDF;
	        var queryStringReportFilterModel = this.JQueryHelper.Param(model);
	        getUrl = getUrl + "?" + decodeURIComponent(queryStringReportFilterModel);
	        var headers = this.authService.GetHeader('application/pdf');
	        var options = new http_1.RequestOptions({ headers: headers, responseType: http_1.ResponseContentType.Blob });
	        return this.http.get(getUrl, options);
	    };
	    KickbackService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], KickbackService);
	    return KickbackService;
	    var _a, _b;
	}());
	exports.KickbackService = KickbackService;


/***/ },
/* 1014 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ 'LblKickbackReport' | translate }}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li class=\"active\">{{ 'LblKickbackReport' | translate }}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <div class=\"box box-default\">\r\n          <div class=\"box-body\" style=\"display: block;\">\r\n            <!--Filter-->\r\n            <wego-report-customer-filter [IsValidSearch]=\"isValidSearch\" [ErrorModel]=\"errorModel\" [ReportName]=\"reportName\" (OnSearch)=\"OnSearch($event)\"\r\n              (OnExportPDF)=\"OnExportPDF($event)\" (OnExportExcel)=\"OnExportExcel($event)\" (ResetValidSearch)=\"ResetValidSearch($event)\"></wego-report-customer-filter>\r\n            <!--End Filter-->\r\n\r\n            <!-- No Record Found Started -->\r\n            <div class=\"row\">\r\n              <div class=\"col-sm-12 text-danger text-center\">\r\n                <div *ngIf=\"kickbackReportResult && kickbackReportResult.length == 0\">\r\n                  {{ errorMessage }}\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!-- No Record Found End -->\r\n\r\n            <div class=\"row\" *ngIf=\"kickbackReportResult && kickbackReportResult.length > 0\">\r\n              <fieldset class=\"col-md-12\">\r\n                <legend class=\"legendStyle\">\r\n                  <div class=\"form-inline\" style=\"padding-bottom: 5px;\">\r\n                    <div class=\"form-group\">\r\n                      {{ 'LblKickbackReport' | translate }}\r\n                    </div>\r\n                  </div>\r\n                </legend>\r\n                <div class=\"clearfix\"></div>\r\n                <div class=\"row\">\r\n                  <div class=\"col-sm-12\">\r\n                    <div class=\"col-sm-12 border-kickback\">\r\n                      <div class=\"col-md-6\">\r\n                        &nbsp;\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        <b> {{ 'LblDescription' | translate}}</b>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        <b> {{ 'LblRevenue' | translate }}</b>\r\n                        <br>\r\n                        <b> ({{ 'LblExVat' | translate }})</b>\r\n                      </div>\r\n                      <div class=\"col-md-2\">\r\n                        <b>{{ 'LblRevenue' | translate }}</b>\r\n                        <br>\r\n                        <b> ({{ 'LblInclVat' | translate }})</b>\r\n                      </div>\r\n                    </div>\r\n                    <div class=\"col-sm-12\">\r\n                      <wego-kickback-data-grid [Data]=\"kickbackReportResult\"></wego-kickback-data-grid>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </fieldset>\r\n            </div>\r\n            <!-- End Details table -->\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>";

/***/ },
/* 1015 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var flatpickr_model_1 = __webpack_require__(83);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var config_2 = __webpack_require__(60);
	var cost_expense_service_1 = __webpack_require__(1010);
	var cost_expense_model_1 = __webpack_require__(1006);
	var moment = __webpack_require__(84);
	var SlimSelect = __webpack_require__(616);
	var CostAndExpenseListDriverComponent = (function () {
	    function CostAndExpenseListDriverComponent(authService, router, translate, costAndExpenseService) {
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.costAndExpenseService = costAndExpenseService;
	        this.dateFormat = config_2.WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
	        this.DataListModel = new config_2.DataListModel();
	    }
	    CostAndExpenseListDriverComponent.prototype.ngOnInit = function () {
	        this.module = this.translate.instant("LblCostAndExpenses");
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = [
	            "ReportedByName",
	            "Description",
	            "CostType",
	            "Status",
	            "InvoiceNumber"
	        ];
	        this.model = new cost_expense_model_1.CostAndExpenseModel();
	        this.popupModel = new cost_expense_model_1.CostAndExpenseModel();
	        this.model.fromDateTime = moment()
	            .add(-1, "M")
	            .format("DD-MM-YYYY 00:00");
	        this.model.toDateTime = moment()
	            .add(+1, "days")
	            .format("DD-MM-YYYY 00:00");
	        this.LblStatus = this.translate.instant("LblStatus");
	        this.LblSelect = this.translate.instant("LblSelect");
	        this.CostStatus = [
	            {
	                Key: "PENDING",
	                Value: "PENDING"
	            },
	            {
	                Key: "APPROVED",
	                Value: "APPROVED"
	            },
	            {
	                Key: "REJECTED",
	                Value: "REJECTED"
	            }
	        ];
	        this.model.statusList = this.CostStatus.map(function (x) { return x.Value; });
	        this.model = this.authService.AssignFromStorage(this.constructor.name + "_model", this.model);
	        this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlPersonInfo = this.authService.GetURL(config_1.ApplicationRouteURL.URL_PERSON_UPDATE);
	        this.model.reportedByName = this.model.reportedByNameList.join();
	        this.itemPerPageList = config_2.WeGoConfig.GRID_PAGGING;
	        this.DataListModel.itemsPerPage = 10;
	        this.GetCostAndExpenseList();
	    };
	    CostAndExpenseListDriverComponent.prototype.SetDefaultFlatPickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = true;
	        flatPickrConfig.time_24hr = true;
	        flatPickrConfig.dateFormat = this.dateFormat;
	        flatPickrConfig.minuteIncrement = 1;
	        return flatPickrConfig;
	    };
	    CostAndExpenseListDriverComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetCostAndExpenseList();
	    };
	    CostAndExpenseListDriverComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        if (event.isReset) {
	            this.model.toDateTime = moment().add(+1, "days").format("DD-MM-YYYY 00:00");
	            this.model.fromDateTime = moment().add(-1, "M").format("DD-MM-YYYY 00:00");
	        }
	        this.GetCostAndExpenseList();
	    };
	    CostAndExpenseListDriverComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetCostAndExpenseList();
	    };
	    CostAndExpenseListDriverComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.costAndExpenseService
	            .ExportCostAndExpenseList(this.model, this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "CostAndExpense" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    CostAndExpenseListDriverComponent.prototype.GetCostAndExpenseList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.costAndExpenseService
	            .GetCostAndExpenseList(this.model, this.DataListModel)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.costAndExpenseList = res.data;
	                _this.DataListModel.totalItems = res.totalRecords;
	                _this.DataListModel.infoMessage = res.error;
	                _this.isParentCheckEnable =
	                    _this.costAndExpenseList.filter(function (x) { return x.isDeletable; }).length > 0
	                        ? true
	                        : false;
	                _this.isLoading = false;
	                _this.errorModel = null;
	            }
	            else {
	                _this.DataListModel.totalItems = res.totalRecords;
	                _this.DataListModel.infoMessage = _this.translate.instant("LblNoRecords");
	                _this.errorModel = res.error;
	                _this.isLoading = false;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    CostAndExpenseListDriverComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetCostAndExpenseList();
	    };
	    CostAndExpenseListDriverComponent.prototype.OnParentCheck = function (isChecked) {
	        this.costAndExpenseList
	            .filter(function (y) { return y.isDeletable; })
	            .forEach(function (x) { return (x.isChecked = isChecked); });
	    };
	    CostAndExpenseListDriverComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	        this.authService.SaveToStorage(this.constructor.name + "_model", this.model);
	    };
	    CostAndExpenseListDriverComponent.prototype.StatusChangeMultiSelect = function () { };
	    CostAndExpenseListDriverComponent.prototype.SuccessSelectDriverModal = function ($event) {
	        this.model.reportedByNameList = $event.PersonName;
	        this.model.reportedByName = this.model.reportedByNameList.join(",");
	        this.model.reportedByPersonHashIdList = $event.PersonHashID;
	    };
	    CostAndExpenseListDriverComponent.prototype.ClearReportedBy = function () {
	        this.model.reportedByPersonHashId = "";
	        this.model.reportedByNameList = [];
	        this.model.reportedByName = "";
	        this.model.reportedByPersonHashIdList = [];
	    };
	    CostAndExpenseListDriverComponent.prototype.ngAfterViewInit = function () {
	        var _this = this;
	        this.StatusSelect = new SlimSelect({
	            select: "#status",
	            placeholder: this.LblSelect + " " + this.LblStatus,
	            showSearch: false,
	            onChange: function (info) {
	                _this.model.statusList = info.map(function (x) { return x.value; });
	            }
	        });
	        this.StatusSelect.set(this.model.statusList);
	    };
	    Object.defineProperty(CostAndExpenseListDriverComponent.prototype, "isDeleteAccess", {
	        get: function () {
	            if (this.costAndExpenseList) {
	                return this.costAndExpenseList.some(function (x) { return x.isDeletable; });
	            }
	            else {
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    CostAndExpenseListDriverComponent.prototype.DeleteCostAndExpense = function (deleteCostAndExpenseHashId) {
	        var _this = this;
	        this.isLoading = true;
	        this.costAndExpenseService
	            .DeleteCostAndExpenses(deleteCostAndExpenseHashId)
	            .subscribe(function (res) {
	            _this.DataListModel.currentPage = 1;
	            _this.GetCostAndExpenseList();
	            _this.popupMsg = _this.translate.instant("LblRecordRemovedSuccess", [
	                _this.module
	            ]);
	            _this.ShowSuccessPopup();
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    CostAndExpenseListDriverComponent.prototype.ShowAlertModal = function (costAndExpenseHashId) {
	        if (costAndExpenseHashId) {
	            this.popupMsg = this.translate.instant("LblRecordDeleteConfirmation", [
	                this.module
	            ]);
	            this.isMultipleDelete = false;
	            this.deletecostAndExpenseHashId = costAndExpenseHashId;
	        }
	        else {
	            this.popupMsg = this.translate.instant("LblRecordMultiplDeleteConfirmation", [this.module]);
	            this.isMultipleDelete = true;
	        }
	        this.alertModal.show();
	    };
	    CostAndExpenseListDriverComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    CostAndExpenseListDriverComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    CostAndExpenseListDriverComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    CostAndExpenseListDriverComponent.prototype.HideAlertModal = function () {
	        this.deletecostAndExpenseHashId = "";
	        this.alertModal.hide();
	    };
	    CostAndExpenseListDriverComponent.prototype.SuccessAlertModalClick = function () {
	        var deleteCostAndExpenseList;
	        if (this.isMultipleDelete)
	            deleteCostAndExpenseList = this.costAndExpenseList
	                .filter(function (x) { return x.isChecked; })
	                .map(function (x) { return x.costAndExpenseHashId; });
	        else
	            deleteCostAndExpenseList.push(this.deletecostAndExpenseHashId);
	        this.DeleteCostAndExpense(deleteCostAndExpenseList);
	        this.alertModal.hide();
	    };
	    CostAndExpenseListDriverComponent.prototype.ShowExpenseReportedByDrivermodal = function (costAndExpenseviewModel) {
	        var _this = this;
	        this.costAndExpenseService
	            .GetCostAndExpenseByHashId(costAndExpenseviewModel.costAndExpenseHashId)
	            .subscribe(function (res) {
	            _this.costAndExpensePopup.model = res.data;
	            _this.costAndExpensePopup.show();
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    CostAndExpenseListDriverComponent.prototype.ShowCostReportedByAdminmodal = function (costAndExpenseviewModel) {
	        var _this = this;
	        this.costAndExpenseService
	            .GetCostAndExpenseByHashId(costAndExpenseviewModel.costAndExpenseHashId)
	            .subscribe(function (res) {
	            _this.costAddedByAdminPopup.model = res.data;
	            _this.costAddedByAdminPopup.show();
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    CostAndExpenseListDriverComponent.prototype.SuccessCostAndExpenseList = function () {
	        this.popupMsg = this.translate.instant("LblRecordSavedSuccess", [
	            this.module
	        ]);
	        this.GetCostAndExpenseList();
	        this.ShowSuccessPopup();
	    };
	    __decorate([
	        core_1.ViewChild("alertModal"), 
	        __metadata('design:type', Object)
	    ], CostAndExpenseListDriverComponent.prototype, "alertModal", void 0);
	    __decorate([
	        core_1.ViewChild("successPopup"), 
	        __metadata('design:type', Object)
	    ], CostAndExpenseListDriverComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild("costAndExpensePopup"), 
	        __metadata('design:type', Object)
	    ], CostAndExpenseListDriverComponent.prototype, "costAndExpensePopup", void 0);
	    __decorate([
	        core_1.ViewChild("costAddedByAdminPopup"), 
	        __metadata('design:type', Object)
	    ], CostAndExpenseListDriverComponent.prototype, "costAddedByAdminPopup", void 0);
	    CostAndExpenseListDriverComponent = __decorate([
	        core_1.Component({
	            selector: "wego-cost-expense-driver-list",
	            template: __webpack_require__(1016),
	            providers: [cost_expense_service_1.CostAndExpenseService],
	            styles: [
	                "\n     .nopad-left {\n       padding-left: 0px;\n     }\n     .form-horizontal .control-label {\n       text-align: left;\n     }\n     \n    .form-control{\n      border: none;\n      border-radius: 3px;\n    }\n    .btn-default{\n      height: 34px;\n      border-radius: 0;\n      border: 0;\n    }\n    .btn-success{\n      height: 34px;\n      border-radius: 0;\n    }\n    .listTopMargin{\n      margin-top:5%;\n    }\n    "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _c) || Object, (typeof (_d = typeof cost_expense_service_1.CostAndExpenseService !== 'undefined' && cost_expense_service_1.CostAndExpenseService) === 'function' && _d) || Object])
	    ], CostAndExpenseListDriverComponent);
	    return CostAndExpenseListDriverComponent;
	    var _a, _b, _c, _d;
	}());
	exports.CostAndExpenseListDriverComponent = CostAndExpenseListDriverComponent;


/***/ },
/* 1016 */
/***/ function(module, exports) {

	module.exports = "<section class=\"banner-img-in\">\r\n  <div class=\"banner-in\">\r\n    <div class=\"search-bg-in\">\r\n      <div class=\"container-fluid\">\r\n        <form (ngSubmit)=\"OnSearch($event)\">\r\n          <div class=\"row\" style=\"padding-right:15px;\">\r\n            <div class=\"col-md-3\">\r\n              <h2 class=\"pagename\">{{ 'LblCostAndExpenses' | translate }}</h2>\r\n            </div>\r\n            <div class=\"col-md-5\">\r\n              <div class=\"row\" style=\"margin-top:10px;\">\r\n                <div class=\"form-group col-md-4 nopad-left\">\r\n                  <label>{{ 'LblStatus' | translate }} </label>\r\n                  <select id=\"status\" name=\"status\" (change)=\"StatusChangeMultiSelect()\" multiple>\r\n                    <option *ngFor=\"let item of CostStatus\" [attr.value]='item.Value'>{{item.Key}}</option>\r\n                  </select>\r\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'status' }}</span>\r\n                </div>\r\n                <div class=\"form-group col-md-4 nopad-left\">\r\n                  <label for=\"from\">{{ 'LblFrom' | translate }}</label>\r\n                  <div class=\"input-group\">\r\n                    <span class=\"input-group-addon\">\r\n                      <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n                    </span>\r\n                    <input flatpickr readonly [Config]=\"flatPickrConfigFrom\" [(ngModel)]=\"model.fromDateTime\" name=\"fromDateTime\" type=\"text\"\r\n                      class=\"form-control\" placeholder=\"{{ 'LblFrom' | translate }}\">\r\n                  </div>\r\n                </div>\r\n                <div class=\"form-group col-md-4 nopad-left\">\r\n                  <label for=\"to\">{{ 'LblTo' | translate }}</label>\r\n                  <div class=\"input-group\">\r\n                    <span class=\"input-group-addon\">\r\n                      <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n                    </span>\r\n                    <input flatpickr readonly [Config]=\"flatPickrConfigTo\" [(ngModel)]=\"model.toDateTime\" name=\"toDateTime\" type=\"text\" class=\"form-control\"\r\n                      placeholder=\"{{ 'LblTo' | translate }}\">\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-md-4 navbar-right\">\r\n              <div class=\"form-space-top pull-right\">\r\n                <wego-driver-search-list [IsDeleted]=\"false\" [IsExported]=\"true\" [IsDeleteEnabled]=\"false\" (OnSearch)=\"OnSearch($event)\"\r\n                  (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [SearchTerm]=\"DataListModel.searchTerm\"\r\n                  [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-driver-search-list>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </form>\r\n        <div class=\"clearfix\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n<div class=\"clearfix\"></div>\r\n<section class=\"content\">\r\n  <div class=\"row listTopMargin\">\r\n    <div class=\"col-md-12\">\r\n      <div class=\"table table-responsive mar_bot_ziro\">\r\n        <table class=\"table table-bordered mar_bot_ziro\">\r\n          <thead>\r\n            <tr>\r\n              <th class=\"cursor-pointer\" (click)=\"OnSort('reportedByName')\">\r\n                {{ 'LblReportedBy' | translate }}\r\n                <wego-sort-list [FieldName]=\"'reportedByName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n              </th>\r\n\r\n              <th class=\"cursor-pointer\" (click)=\"OnSort('reportedDateTimeUTC')\">\r\n                {{ 'LblDate' | translate }}\r\n                <wego-sort-list [FieldName]=\"'reportedDateTimeUTC'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n              </th>\r\n\r\n              <th class=\"cursor-pointer\" (click)=\"OnSort('description')\">\r\n                {{ 'LblDescription' | translate }}\r\n                <wego-sort-list [FieldName]=\"'description'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n              </th>\r\n              <th class=\"cursor-pointer\" (click)=\"OnSort('costType')\">\r\n                {{ 'LblType' | translate }}\r\n                <wego-sort-list [FieldName]=\"'costType'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n              </th>\r\n              <th class=\"cursor-pointer\" (click)=\"OnSort('reportedAmountInVat')\">\r\n                {{ 'LblReportedAmount' | translate }} {{ 'LblInclVat' | translate }}\r\n                <wego-sort-list [FieldName]=\"'reportedAmountInVat'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n              </th>\r\n              <th class=\"cursor-pointer\" (click)=\"OnSort('approvedAmountInVat')\">\r\n                {{ 'LblApprovedAmount' | translate }} {{ 'LblInclVat' | translate }}\r\n                <wego-sort-list [FieldName]=\"'approvedAmountInVat'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n              </th>\r\n              <th class=\"cursor-pointer\" (click)=\"OnSort('status')\">\r\n                {{ 'LblStatus' | translate }}\r\n                <wego-sort-list [FieldName]=\"'status'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n              </th>\r\n\r\n              <th class=\"cursor-pointer\" (click)=\"OnSort('invoiceNumber')\">\r\n                {{ 'LblInvoiceNumber' | translate }}\r\n                <wego-sort-list [FieldName]=\"'invoiceNumber'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n              </th>\r\n            </tr>\r\n          </thead>\r\n          <tbody>\r\n            <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n              <tr *ngFor=\"let expense of costAndExpenseList\">\r\n                <td>\r\n                  {{ expense.reportedByName }}\r\n                </td>\r\n                <td>{{ expense.reportedDateTime}}</td>\r\n                <td>\r\n                  <a class=\"cursor-pointer\" *ngIf=\"expense.reportedByDriver\" (click)=\"ShowExpenseReportedByDrivermodal(expense)\">\r\n                    {{expense.description }} </a>\r\n                  <a class=\"cursor-pointer\" *ngIf=\"!expense.reportedByDriver\" (click)=\"ShowCostReportedByAdminmodal(expense)\">\r\n                    {{expense.description }} </a>\r\n                </td>\r\n                <td>{{ expense.costType}}</td>\r\n                <td>{{ expense.reportedAmountInVat }}</td>\r\n                <td>{{ expense.approvedAmountInVat }}</td>\r\n                <td>{{ expense.status}}</td>\r\n                <td>\r\n                  <span *ngIf=\"expense.invoiceStatus =='OPEN'\">\r\n                    {{ expense.invoiceNumber}}\r\n                  </span>\r\n                  <a *ngIf=\"expense.invoiceStatus!='OPEN'\" [href]=\" 'OfflineInvoice/' + expense.invoiceNumber + '.pdf' \" target='_blank' download>\r\n                    {{ expense.invoiceNumber}}\r\n                  </a>\r\n                </td>\r\n              </tr>\r\n            </template>\r\n            <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n              <td class=\"text-center text-danger\" colspan=\"9\">\r\n                {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n              </td>\r\n            </tr>\r\n          </tbody>\r\n        </table>\r\n      </div>\r\n      <div class=\"clearfix\"></div>\r\n      <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n        <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n          <div class=\"col-md-12\">\r\n            <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n              [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n              lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n\r\n<wego-confirm-popup #alertModal [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessAlertModalClick()\" (onReject)=\"HideAlertModal()\"></wego-confirm-popup>\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>\r\n<confirm-costandexpense-driver-popup #costAndExpensePopup (OnSuccessSave)=\"SuccessCostAndExpenseList()\"></confirm-costandexpense-driver-popup>\r\n<cost-added-by-admin-popup #costAddedByAdminPopup></cost-added-by-admin-popup>\r\n<wego-costandexpense-driver-popup #selectReportedByModal (OnSuccessSelect)=\"SuccessSelectDriverModal($event)\"></wego-costandexpense-driver-popup>";

/***/ },
/* 1017 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var invoice_service_1 = __webpack_require__(723);
	var invoice_model_1 = __webpack_require__(719);
	var flatpickr_model_1 = __webpack_require__(83);
	var InvoicePaymentHistoryListComponent = (function () {
	    function InvoicePaymentHistoryListComponent(invoiceService, activeRoute, router, authService) {
	        this.invoiceService = invoiceService;
	        this.activeRoute = activeRoute;
	        this.router = router;
	        this.authService = authService;
	        this.invoiceBasicDetails = new invoice_model_1.InvoiceBasicDetails();
	        this.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_FORMAT;
	        this.dateTimeFormat = config_1.WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
	    }
	    InvoicePaymentHistoryListComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	        this.DataListModel.searchField = ["status", "paymentMode", "description"];
	        this.urlInvoiceList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_BOOKING_INVOICE_LIST);
	        this.paymentHistoryModel = new invoice_model_1.PaymentHistoryModel();
	        this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
	        this.activeRoute.params.subscribe(function (params) {
	            var invoiceHashId = params["invoiceHashId"] || "";
	            if (invoiceHashId != "") {
	                _this.paymentHistoryModel.invoiceHashId = invoiceHashId;
	                _this.GetInvoicePaymentHistory();
	                _this.GetBookingInvoiceBasicDetails();
	            }
	        });
	    };
	    InvoicePaymentHistoryListComponent.prototype.SetDefaultFlatPickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = false;
	        flatPickrConfig.time_24hr = true;
	        flatPickrConfig.dateFormat = this.dateTimeFormat;
	        flatPickrConfig.minuteIncrement = 1;
	        return flatPickrConfig;
	    };
	    InvoicePaymentHistoryListComponent.prototype.GetInvoicePaymentHistory = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.invoiceService
	            .GetInvoicePaymentHistory(this.paymentHistoryModel, this.DataListModel)
	            .subscribe(function (res) {
	            _this.paymentHistoryList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    InvoicePaymentHistoryListComponent.prototype.GetBookingInvoiceBasicDetails = function () {
	        var _this = this;
	        this.invoiceService
	            .GetBookingInvoiceBasicDetails(this.paymentHistoryModel.invoiceHashId)
	            .subscribe(function (res) {
	            _this.invoiceNumber = res.data.entityName;
	            _this.invoiceBasicDetails = res.data.data;
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    InvoicePaymentHistoryListComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.invoiceService
	            .ExportInvoicePaymentHistory(this.paymentHistoryModel, this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "InvoicePaymentHistory" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    InvoicePaymentHistoryListComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetInvoicePaymentHistory();
	    };
	    InvoicePaymentHistoryListComponent.prototype.OnSearch = function (event) {
	        if (event.isReset) {
	            this.paymentHistoryModel.startDateTime = "";
	            this.paymentHistoryModel.endDateTime = "";
	        }
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetInvoicePaymentHistory();
	    };
	    InvoicePaymentHistoryListComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetInvoicePaymentHistory();
	    };
	    InvoicePaymentHistoryListComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetInvoicePaymentHistory();
	    };
	    InvoicePaymentHistoryListComponent.prototype.ngOnDestroy = function () {
	        this.authService.SetFilter(this.constructor.name, this.DataListModel);
	    };
	    InvoicePaymentHistoryListComponent = __decorate([
	        core_1.Component({
	            selector: "invoice-payment-history",
	            template: __webpack_require__(1018),
	            providers: [invoice_service_1.InvoiceService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof invoice_service_1.InvoiceService !== 'undefined' && invoice_service_1.InvoiceService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _d) || Object])
	    ], InvoicePaymentHistoryListComponent);
	    return InvoicePaymentHistoryListComponent;
	    var _a, _b, _c, _d;
	}());
	exports.InvoicePaymentHistoryListComponent = InvoicePaymentHistoryListComponent;


/***/ },
/* 1018 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ 'LblInvoicePaymentHistory' | translate }} {{ 'LblList' | translate }} </h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i>{{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"urlInvoiceList\">\r\n            <i class=\"fa fa-file-text fa-fw\"></i> {{ 'LblBookingInvoice' | translate }} {{ 'LblList' | translate }}</a>\r\n        </li>\r\n        <li class=\"active\"> {{ 'LblInvoicePaymentHistory' | translate }} {{ 'LblList' | translate }}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <div class=\"row\">\r\n          <h4 class=\"col-md-6\">\r\n            <label>{{ 'LblInvoiceNumber' | translate }} : </label> {{ invoiceBasicDetails.invoiceNumber }}\r\n          </h4>\r\n        </div>\r\n        <div class=\"row\">\r\n          <div class=\"form-group col-md-3\">\r\n            <label>{{ 'LblFrom' | translate }}</label>\r\n            <div class=\"clearfix\"></div>\r\n            <div class=\"input-group\">\r\n              <span class=\"input-group-addon\">\r\n                <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n              </span>\r\n              <input flatpickr readonly [Config]=\"flatPickrConfigFrom\" [(ngModel)]=\"paymentHistoryModel.startDateTime\" name=\"TimeBlockStartDate\"\r\n                type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblFrom' | translate }}\">\r\n            </div>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'startDateTime' }}</span>\r\n          </div>\r\n          <div class=\"form-group col-md-3\">\r\n            <label>{{ 'LblTo' | translate }}</label>\r\n            <div class=\"clearfix \"></div>\r\n            <div class=\"input-group\">\r\n              <span class=\"input-group-addon\">\r\n                <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n              </span>\r\n              <input flatpickr readonly [Config]=\"flatPickrConfigTo\" [(ngModel)]=\"paymentHistoryModel.endDateTime\" name=\"TimeBlockStartDate\"\r\n                type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblTo' | translate }}\">\r\n            </div>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'endDateTime' }}</span>\r\n          </div>\r\n          <div class=\"form-group col-md-6\">\r\n            <label>&nbsp;</label>\r\n            <wego-search-list [IsDeleted]=\"false\" [IsExported]=\"true\" (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\"\r\n              [SearchTerm]=\"DataListModel.searchTerm\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n          </div>\r\n        </div>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('status')\">\r\n                  {{ 'LblStatus' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'status'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('insertedDateTimeUTC')\">\r\n                  {{ 'LblLogTime' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'insertedDateTime'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('paymentMode')\">\r\n                  {{ 'LblPaymentMode' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'paymentMode'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('paymentMode')\">\r\n                  {{ 'LblAmount' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'totalAmount'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('description')\">\r\n                  {{ 'LblDescription' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'description'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let paymentHistory of paymentHistoryList\">\r\n                  <td>{{ paymentHistory.status }}</td>\r\n                  <td>{{ paymentHistory.insertedDateTime }}</td>\r\n                  <td>{{ paymentHistory.paymentMode }}</td>\r\n                  <td>{{ paymentHistory.totalAmount }}</td>\r\n                  <td>{{ paymentHistory.description }}</td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"5\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n\r\n<div [hidden]=\"!isLoading\" class=\"my-loading\">\r\n  <div class=\"dimmer\"></div>\r\n  <div class=\"loading-bg\">\r\n    <i class=\"fa fa-refresh fa-spin fa-3x fa-fw\"></i>\r\n  </div>\r\n</div>\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>";

/***/ },
/* 1019 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var translate_service_1 = __webpack_require__(70);
	var core_1 = __webpack_require__(3);
	var config_1 = __webpack_require__(60);
	var terms_condition_model_1 = __webpack_require__(615);
	var instance_service_1 = __webpack_require__(500);
	var common_1 = __webpack_require__(22);
	var terms_conditions_service_1 = __webpack_require__(882);
	var router_1 = __webpack_require__(26);
	var company_service_1 = __webpack_require__(501);
	var organization_service_1 = __webpack_require__(614);
	var sharedvehiclegroup_service_1 = __webpack_require__(510);
	var contracttypegroup_service_1 = __webpack_require__(730);
	var sharedvehiclegroupsubscription_service_1 = __webpack_require__(753);
	var SlimSelect = __webpack_require__(616);
	var TermsAndConditionAddUpdateComponent = (function () {
	    function TermsAndConditionAddUpdateComponent(translate, authService, instanceService, locationService, termsAndConditionsService, router, activeRoute, companyService, organizationService, sharedVehicleGroupService, contractTypegroupService, subscriptionService) {
	        this.translate = translate;
	        this.authService = authService;
	        this.instanceService = instanceService;
	        this.locationService = locationService;
	        this.termsAndConditionsService = termsAndConditionsService;
	        this.router = router;
	        this.activeRoute = activeRoute;
	        this.companyService = companyService;
	        this.organizationService = organizationService;
	        this.sharedVehicleGroupService = sharedVehicleGroupService;
	        this.contractTypegroupService = contractTypegroupService;
	        this.subscriptionService = subscriptionService;
	        this.roleLevel = config_1.RoleLevel;
	    }
	    TermsAndConditionAddUpdateComponent.prototype.ngOnInit = function () {
	        this.model = new terms_condition_model_1.TermsConditionModel();
	        this.pageName = "Terms_And_Condition";
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.typeList = config_1.WeGoConfig.TERMS_CONDITION_PRIVACYTYPE;
	        if (!(this.authService.GetHighestRoleLevel() <= this.roleLevel.Instance)) {
	            this.typeList = this.typeList.filter(function (x) { return x != "Privacy"; });
	        }
	        this.urlTermsAndConditionList = this.authService.GetURL(config_1.ApplicationRouteURL.URL_TERMS_CONDITION_PAGE);
	        this.GerTermsAndConditionDetail();
	        this.module = this.translate.instant("LblTermsConditionPrivacy");
	        this.breadCrumbTitle = this.isEditMode
	            ? this.translate.instant("LblEditPage", [this.module])
	            : this.translate.instant("LblAddPage", [this.module]);
	        this.breadCrumbList = this.translate.instant("LblListPage", [this.module]);
	    };
	    TermsAndConditionAddUpdateComponent.prototype.ngAfterViewInit = function () {
	        this.ctgSelect = new SlimSelect({
	            select: "#ctg",
	            showSearch: false,
	            isMultiple: true
	        });
	    };
	    TermsAndConditionAddUpdateComponent.prototype.TypeChange = function () {
	        if (this.model.type == "Privacy" && !this.isEditMode) {
	            this.model.acceptanceMomentModel.contractTypeGroupList = [];
	            this.model.acceptanceMomentModel.repeatTimeOpenApp = false;
	            this.model.acceptanceMomentModel.repeatTimeInDay = 0;
	            this.model.acceptanceMomentModel.everyTimeOpenApp = false;
	            this.model.acceptanceMomentModel.makeBooking = false;
	            this.model.acceptanceMomentModel.startBooking = false;
	            this.model.acceptanceMomentModel.openBooking = false;
	            this.model.acceptanceMomentModel.ctgSelection = false;
	            this.model.acceptanceMomentModel.contractTypeGroupList = [];
	            this.model.companyHashId = "";
	            this.model.organizationHashId = "";
	            this.model.sharedVehicleGroupHashId = "";
	            this.model.subscriptionHashId = "";
	        }
	    };
	    TermsAndConditionAddUpdateComponent.prototype.resetAcceptanceMoment = function () { };
	    TermsAndConditionAddUpdateComponent.prototype.GetInstanceList = function (termsAndConditionsHashId) {
	        var _this = this;
	        var permissionType = "";
	        if (this.isEditMode) {
	            permissionType = config_1.PermissionType.EDIT;
	        }
	        else {
	            permissionType = config_1.PermissionType.INSERT;
	        }
	        this.termsAndConditionsService
	            .GetInstanceListDropdownList(termsAndConditionsHashId, this.pageName, permissionType)
	            .subscribe(function (res) {
	            _this.apiResponse = res;
	            _this.instanceList = res.data;
	            //this.model.instanceId = this.instanceList[0].instanceId;
	            if (_this.instanceList && _this.instanceList.length > 0) {
	                if (!_this.isEditMode &&
	                    !_this.model.instanceHashId &&
	                    _this.instanceList.length == 1) {
	                    _this.model.instanceHashIdList = [];
	                    _this.model.instanceHashIdList.push(_this.instanceList[0].keyHash);
	                    _this.model.instanceHashId = _this.instanceList[0].keyHash;
	                }
	                _this.OnInstanceChange();
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    TermsAndConditionAddUpdateComponent.prototype.OnInstanceChange = function () {
	        if (!this.isEditMode) {
	            this.model.companyHashId = "";
	            this.CompanyList = [];
	            this.model.organizationHashId = "";
	            this.OrganizationList = [];
	            this.model.sharedVehicleGroupHashId = "";
	            this.SVGList = [];
	        }
	        this.GetCompanyListDropdown();
	    };
	    TermsAndConditionAddUpdateComponent.prototype.GetCompanyListDropdown = function () {
	        var _this = this;
	        if (!(this.authService.GetHighestRoleLevel() <= this.roleLevel.Instance)) {
	            this.model.instanceHashIdList = this.instanceList.map(function (x) { return x.keyHash; });
	        }
	        if (this.model.instanceHashId) {
	            this.companyService
	                .GetCompanyListDropdownForAddUpdatePage(this.pageName, this.permissionType, this.model.instanceHashId)
	                .subscribe(function (res) {
	                _this.CompanyList = res.data;
	                if (_this.CompanyList != null && _this.CompanyList.length > 0) {
	                    if (!_this.isEditMode && !_this.model.companyHashId && _this.CompanyList.length == 1) {
	                        _this.model.companyHashIdList = [];
	                        _this.model.companyHashIdList.push(_this.CompanyList[0].keyHash);
	                        _this.model.companyHashId = _this.CompanyList[0].keyHash;
	                    }
	                    _this.OnCompanyChange();
	                }
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            });
	        }
	        else {
	        }
	    };
	    TermsAndConditionAddUpdateComponent.prototype.OnCompanyChange = function () {
	        if (!this.isEditMode) {
	            this.model.organizationHashId = "";
	            this.OrganizationList = [];
	            this.model.sharedVehicleGroupHashId = "";
	            this.SVGList = [];
	        }
	        this.GetOrganizationListDropdown();
	        if (this.model.companyHashId && !this.model.organizationHashId) {
	            this.model.acceptanceMomentModel.accountActivation = false;
	        }
	    };
	    TermsAndConditionAddUpdateComponent.prototype.GetOrganizationListDropdown = function () {
	        var _this = this;
	        if (!(this.authService.GetHighestRoleLevel() <= this.roleLevel.Company)) {
	            this.model.companyHashIdList = this.CompanyList.map(function (x) { return x.keyHash; });
	        }
	        if ((this.model.instanceHashId && this.model.companyHashId)
	            || (this.CompanyList.length > 1 && (!(this.authService.GetHighestRoleLevel() <= this.roleLevel.Company)))) {
	            this.organizationService
	                .GetOrganizationListDropdownForAddUpdatePage(this.pageName, this.permissionType, null, this.model.companyHashId)
	                .subscribe(function (res) {
	                _this.OrganizationList = res.data;
	                if (_this.OrganizationList != null &&
	                    _this.OrganizationList.length > 0) {
	                    if (!_this.isEditMode && !_this.model.organizationHashId &&
	                        _this.OrganizationList.length == 1) {
	                        _this.model.organizationHashIdList = [];
	                        _this.model.organizationHashIdList.push(_this.OrganizationList[0].keyHash);
	                        _this.model.organizationHashId = _this.OrganizationList[0].keyHash;
	                    }
	                    _this.OnOrganizationChange();
	                }
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            });
	        }
	        else {
	        }
	    };
	    TermsAndConditionAddUpdateComponent.prototype.OnOrganizationChange = function () {
	        if (!this.isEditMode) {
	            this.model.sharedVehicleGroupHashId = "";
	            this.SVGList = [];
	        }
	        this.GetSVGListDropdown();
	    };
	    TermsAndConditionAddUpdateComponent.prototype.GetSVGListDropdown = function () {
	        var _this = this;
	        if (!(this.authService.GetHighestRoleLevel() <= this.roleLevel.Organization)) {
	            this.model.organizationHashIdList = this.OrganizationList.map(function (x) { return x.keyHash; });
	        }
	        if (((this.model.instanceHashId &&
	            this.model.companyHashId) || !(this.authService.GetHighestRoleLevel() <= this.roleLevel.Company)) &&
	            this.model.organizationHashId) {
	            this.sharedVehicleGroupService
	                .GetSharedVehicleDropdownListByOrganization(this.pageName, this.permissionType, this.model.organizationHashId)
	                .subscribe(function (res) {
	                _this.SVGList = res.data;
	                if (_this.SVGList != null && _this.SVGList.length > 0) {
	                    if (!_this.isEditMode && !_this.model.sharedVehicleGroupHashId &&
	                        _this.SVGList.length == 1) {
	                        _this.model.sharedVehicleGroupHashIdList = [];
	                        _this.model.sharedVehicleGroupHashIdList.push(_this.SVGList[0].keyHash);
	                        _this.model.sharedVehicleGroupHashId = _this.SVGList[0].keyHash;
	                    }
	                }
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            });
	        }
	        else {
	        }
	    };
	    TermsAndConditionAddUpdateComponent.prototype.OnSharedVehicleGroupChange = function () {
	        if (!this.isEditMode) {
	            this.model.subscriptionHashId = "";
	        }
	        this.SubscriptionList = [];
	        this.GetContractTypeGroup();
	        this.GetSubscriptionListDropdown();
	        if (!this.model.sharedVehicleGroupHashId) {
	            this.model.acceptanceMomentModel.ctgSelection = false;
	            this.model.acceptanceMomentModel.contractTypeGroupList = [];
	        }
	    };
	    TermsAndConditionAddUpdateComponent.prototype.GetSubscriptionListDropdown = function () {
	        var _this = this;
	        if (this.model.instanceHashId &&
	            this.model.companyHashId &&
	            this.model.organizationHashId &&
	            this.model.sharedVehicleGroupHashId) {
	            this.subscriptionService
	                .GetSubscriptionDropdownList(this.permissionType, this.model.organizationHashId, this.model.sharedVehicleGroupHashId)
	                .subscribe(function (res) {
	                _this.SubscriptionList = res.data;
	                if (_this.SubscriptionList != null &&
	                    _this.SubscriptionList.length > 0) {
	                    if (!_this.isEditMode && !_this.model.subscriptionHashId &&
	                        _this.SubscriptionList.length == 1) {
	                        _this.model.subscriptionHashId = _this.SubscriptionList[0].keyHash;
	                    }
	                }
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            });
	        }
	        else {
	        }
	    };
	    TermsAndConditionAddUpdateComponent.prototype.OnSubscriptionChange = function () {
	        this.GetContractTypeGroup();
	    };
	    TermsAndConditionAddUpdateComponent.prototype.GetContractTypeGroup = function () {
	        var _this = this;
	        if (this.model.sharedVehicleGroupHashId) {
	            this.contractTypegroupService
	                .GetDropdownListCTGBySVG(this.pageName, this.model.instanceHashId, this.model.companyHashId, this.model.sharedVehicleGroupHashId, this.model.subscriptionHashId)
	                .subscribe(function (res) {
	                _this.contractTypeGroupList = res.data;
	                setTimeout(function () {
	                    _this.ctgSelect.set(_this.model.acceptanceMomentModel.contractTypeGroupList);
	                }, 200);
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            });
	        }
	        else {
	            this.contractTypeGroupList = [];
	        }
	    };
	    TermsAndConditionAddUpdateComponent.prototype.MceHtmlOutput = function ($event) {
	        //console.log($event);
	        this.model.bodyHtml = $event;
	    };
	    TermsAndConditionAddUpdateComponent.prototype.OnBackClick = function () {
	        this.locationService.back();
	    };
	    TermsAndConditionAddUpdateComponent.prototype.OnSubmit = function (forms) {
	        var _this = this;
	        this.isLoading = true;
	        if (this.ctgSelect.data) {
	            this.model.acceptanceMomentModel.contractTypeGroupList = this.ctgSelect.data
	                .getSelected()
	                .map(function (x) { return x.value; });
	        }
	        this.termsAndConditionsService
	            .UpdateTermsAndConditions(this.model)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.popupMsg = _this.isEditMode
	                    ? _this.translate.instant("LblRecordUpdatedSuccess", [_this.module])
	                    : _this.translate.instant("LblRecordAddedSuccess", [_this.module]);
	                _this.ShowSuccessPopup();
	            }
	            else {
	                _this.errorModel = res.error;
	                if (_this.OldVersion) {
	                    _this.model.version = _this.OldVersion;
	                }
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.isLoading = false;
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    TermsAndConditionAddUpdateComponent.prototype.OnNewVersionClick = function () {
	        this.OldVersion = this.model.version;
	        this.newVersion = Number((this.model.version + 0.1).toFixed(2));
	        this.newVersionModal.show();
	    };
	    TermsAndConditionAddUpdateComponent.prototype.VersionChanged = function () {
	        this.model.version = this.newVersion;
	        this.newVersionModal.hide();
	        this.OnSubmit(this.termsAndConditionForm.value);
	    };
	    TermsAndConditionAddUpdateComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    TermsAndConditionAddUpdateComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    TermsAndConditionAddUpdateComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	        this.OnBackClick();
	    };
	    TermsAndConditionAddUpdateComponent.prototype.SuccessModalClick = function () {
	        this.router.navigate([this.urlTermsAndConditionList]);
	    };
	    TermsAndConditionAddUpdateComponent.prototype.GerTermsAndConditionDetail = function () {
	        var _this = this;
	        this.sub = this.activeRoute.params.subscribe(function (params) {
	            _this.isEditMode = false;
	            _this.termsAndConditionHashId = params["id"] || "";
	            if (_this.termsAndConditionHashId != "") {
	                _this.isEditMode = true;
	                _this.termsAndConditionsService
	                    .GetTermsAndConditionsByHashId(_this.termsAndConditionHashId)
	                    .subscribe(function (res) {
	                    _this.model = res.data;
	                    _this.permissionType = config_1.PermissionType.EDIT;
	                    _this.selectedContractTypeGroupList = _this.model.acceptanceMomentModel.contractTypeGroupList;
	                    _this.GetInstanceList(_this.termsAndConditionHashId);
	                    _this.GetContractTypeGroup();
	                }, function (error) {
	                    _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	                });
	            }
	            else {
	                _this.GetInstanceList(_this.termsAndConditionHashId);
	                _this.permissionType = config_1.PermissionType.INSERT;
	            }
	        });
	    };
	    __decorate([
	        core_1.ViewChild("successPopup"), 
	        __metadata('design:type', Object)
	    ], TermsAndConditionAddUpdateComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild("newVersionModal"), 
	        __metadata('design:type', Object)
	    ], TermsAndConditionAddUpdateComponent.prototype, "newVersionModal", void 0);
	    __decorate([
	        core_1.ViewChild("termsAndConditionForm"), 
	        __metadata('design:type', Object)
	    ], TermsAndConditionAddUpdateComponent.prototype, "termsAndConditionForm", void 0);
	    TermsAndConditionAddUpdateComponent = __decorate([
	        core_1.Component({
	            selector: "Wego-Add-TermsAndCondition",
	            template: __webpack_require__(1020),
	            providers: [
	                instance_service_1.InstanceService,
	                terms_conditions_service_1.TermsAndConditionsService,
	                company_service_1.CompanyService,
	                organization_service_1.OrganizationService,
	                sharedvehiclegroup_service_1.SharedVehicleGroupService,
	                contracttypegroup_service_1.ContractTypeGroupService,
	                sharedvehiclegroupsubscription_service_1.SubscriptionService
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof instance_service_1.InstanceService !== 'undefined' && instance_service_1.InstanceService) === 'function' && _c) || Object, (typeof (_d = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _d) || Object, (typeof (_e = typeof terms_conditions_service_1.TermsAndConditionsService !== 'undefined' && terms_conditions_service_1.TermsAndConditionsService) === 'function' && _e) || Object, (typeof (_f = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _f) || Object, (typeof (_g = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _g) || Object, (typeof (_h = typeof company_service_1.CompanyService !== 'undefined' && company_service_1.CompanyService) === 'function' && _h) || Object, (typeof (_j = typeof organization_service_1.OrganizationService !== 'undefined' && organization_service_1.OrganizationService) === 'function' && _j) || Object, (typeof (_k = typeof sharedvehiclegroup_service_1.SharedVehicleGroupService !== 'undefined' && sharedvehiclegroup_service_1.SharedVehicleGroupService) === 'function' && _k) || Object, (typeof (_l = typeof contracttypegroup_service_1.ContractTypeGroupService !== 'undefined' && contracttypegroup_service_1.ContractTypeGroupService) === 'function' && _l) || Object, (typeof (_m = typeof sharedvehiclegroupsubscription_service_1.SubscriptionService !== 'undefined' && sharedvehiclegroupsubscription_service_1.SubscriptionService) === 'function' && _m) || Object])
	    ], TermsAndConditionAddUpdateComponent);
	    return TermsAndConditionAddUpdateComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
	}());
	exports.TermsAndConditionAddUpdateComponent = TermsAndConditionAddUpdateComponent;


/***/ },
/* 1020 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{breadCrumbTitle}}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li>\r\n          <a [routerLink]=\"urlTermsAndConditionList\">\r\n            <i class=\"fa fa-file-text\"></i> {{breadCrumbList}}</a>\r\n        </li>\r\n        <li class=\"active\">{{breadCrumbTitle}}\r\n        </li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border Bottom Shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <div class=\"content\">\r\n    <div class=\"nopad\">\r\n      <form *ngIf=\"model\" (ngSubmit)=\"OnSubmit(termsAndConditionForm.value)\" #termsAndConditionForm=\"ngForm\">\r\n        <div class=\"row\">\r\n          <div class=\"col-md-4\">\r\n            <div class=\"form-group col-md-12\">\r\n              <label>\r\n                <span class=\"text text-danger\">*</span>{{ 'LblType' | translate }}</label>\r\n              <select *ngIf=\"!isEditMode\" [(ngModel)]=\"model.type\" name=\"Type\" class=\"form-control\" (change)=\"TypeChange()\">\r\n                <option value=\"\" [selected]=\"selected\">{{ 'LblSelect' | translate }} {{ 'LblType' | translate }}</option>\r\n                <option *ngFor=\"let type of typeList\" [attr.value]='type'>{{type}}</option>\r\n              </select>\r\n              <select *ngIf=\"isEditMode\" [(ngModel)]=\"model.type\" name=\"Type\" class=\"form-control\" disabled=\"disabled\">\r\n                <option value=\"\" [selected]=\"selected\">{{ 'LblSelect' | translate }} {{ 'LblType' | translate }}</option>\r\n                <option *ngFor=\"let type of typeList\" [attr.value]='type'>{{type}}</option>\r\n              </select>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'type' }}</span>\r\n            </div>\r\n\r\n            <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Instance\" class=\"form-group col-md-12\">\r\n              <label>\r\n                <span class=\"text text-danger\">*</span>{{ 'LblInstance' | translate }}</label>\r\n              <input *ngIf=\"isEditMode\" type=\"text\" class=\"form-control\" [ngModel]=\"model.instanceName\" placeholder=\"-\" name=\"instanceName\" disabled>\r\n              <select *ngIf=\"!isEditMode\" [(ngModel)]=\"model.instanceHashId\" name=\"instance\" class=\"form-control\" (change)=\"OnInstanceChange()\">\r\n                <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblInstance' | translate }}</option>\r\n                <option *ngFor=\"let inst of instanceList\" [ngValue]='inst.keyHash'>{{inst.value}}</option>\r\n              </select>\r\n              <!-- <select *ngIf=\"isEditMode\" [ngModel]=\"model.instanceHashId\" name=\"instance\" class=\"form-control\" disabled=\"disabled\">\r\n              <option *ngFor=\"let inst of instanceList\" [ngValue]='inst.keyHash'>{{ inst.value }}</option>\r\n            </select> -->\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'InstanceHashId' }}</span>\r\n            </div>\r\n\r\n            <div *ngIf=\"model.type!='Privacy' &&  authService.GetHighestRoleLevel() <= roleLevel.Company\" class=\"form-group col-md-12\">\r\n              <span *ngIf=\"!isEditMode && !(authService.GetHighestRoleLevel() <= roleLevel.Instance)\" class=\"text text-danger\">*</span>&nbsp;\r\n              <label> {{'LblCompany' | translate }} </label>\r\n              <input *ngIf=\"isEditMode\" type=\"text\" class=\"form-control\" [ngModel]=\"model.companyName\" placeholder=\"-\" name=\"companyName\" disabled>\r\n              <select *ngIf=\"!isEditMode\" [(ngModel)]=\"model.companyHashId\" class=\"form-control\" name=\"companyHashId\" (change)=\"OnCompanyChange()\">\r\n                <option value=''>{{ 'LblSelect' | translate }} {{ 'LblCompany' | translate }} </option>\r\n                <option *ngFor=\"let item of CompanyList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\r\n              </select>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'companyHashId' }}</span>\r\n\r\n            </div>\r\n\r\n            <div *ngIf=\" model.type!='Privacy' &&  authService.GetHighestRoleLevel() <= roleLevel.Organization\" class=\"form-group col-md-12\">\r\n              <span *ngIf=\"!isEditMode && !(authService.GetHighestRoleLevel() <= roleLevel.Company)\" class=\"text text-danger\">*</span>&nbsp;\r\n              <label> {{'LblOrganization' | translate }} </label>\r\n              <input *ngIf=\"isEditMode\" type=\"text\" class=\"form-control\" [ngModel]=\"model.organizationName\" placeholder=\"-\" name=\"organizationName\" disabled>\r\n              <select *ngIf=\"!isEditMode\" [(ngModel)]=\"model.organizationHashId\" class=\"form-control\" name=\"organizationHashId\" (change)=\"OnOrganizationChange()\">\r\n                <option value=''>{{ 'LblSelect' | translate }} {{ 'LblOrganization' | translate }} </option>\r\n                <option *ngFor=\"let item of OrganizationList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\r\n              </select>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'organizationHashId' }}</span>\r\n\r\n            </div>\r\n\r\n            <div *ngIf=\" model.type!='Privacy' &&  authService.GetHighestRoleLevel() <= roleLevel.SVG\" class=\"form-group col-md-12\">\r\n              <label> {{'LblSharedVehicleGroup' | translate }} </label>\r\n              <input *ngIf=\"isEditMode\" type=\"text\" class=\"form-control\" [ngModel]=\"model.sharedVehicleGroupName\" placeholder=\"-\" name=\"sharedVehicleGroupName\"\r\n                disabled>\r\n              <select *ngIf=\"!isEditMode\" [(ngModel)]=\"model.sharedVehicleGroupHashId\" class=\"form-control\" name=\"svgHashId\" (change)=\"OnSharedVehicleGroupChange()\">\r\n                <option value=''>{{ 'LblSelect' | translate }} {{ 'LblSharedVehicleGroup' | translate }} </option>\r\n                <option *ngFor=\"let item of SVGList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\r\n              </select>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'svgHashId' }}</span>\r\n            </div>\r\n\r\n            <div *ngIf=\"model.type!='Privacy' &&  authService.GetHighestRoleLevel() <= roleLevel.SVG\" class=\"form-group col-md-12\">\r\n              <label> {{'LblSubscription' | translate }} </label>\r\n              <input *ngIf=\"isEditMode\" type=\"text\" class=\"form-control\" [ngModel]=\"model.subscriptionName\" placeholder=\"-\" name=\"subscriptionName\" disabled>\r\n              <select *ngIf=\"!isEditMode\" [(ngModel)]=\"model.subscriptionHashId\" class=\"form-control\" name=\"subscriptionHashId\" (change)=\"OnSubscriptionChange()\">\r\n                <option value=''>{{ 'LblSelect' | translate }} {{ 'LblSubscription' | translate }} </option>\r\n                <option *ngFor=\"let item of SubscriptionList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\r\n              </select>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'subscriptionHashId' }}</span>\r\n            </div>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'AlreadyUsed' }}</span>\r\n          </div>\r\n          <div *ngIf=\"model.acceptanceMomentModel\" class=\"col-md-8\">\r\n            <div class=\"form-group col-md-12\">\r\n              <div>\r\n                <label>\r\n                  <span class=\"text text-danger\">*</span>{{ 'LblAcceptanceMoment' | translate }}\r\n                </label>\r\n              </div>\r\n              <div class=\"checkbox\" *ngIf=\"!model.companyHashId || model.organizationHashId \">\r\n                <label>\r\n                  <input type=\"checkbox\" name=\"acceptanceMomentModel.accountActivation\" [(ngModel)]=\"model.acceptanceMomentModel.accountActivation\">{{ 'LblAcceptance1' | translate }}\r\n                </label>\r\n              </div>\r\n              <div [ngClass]=\" {'hidden':(model.type=='Privacy')}\" class=\"nopad\">\r\n                <div *ngIf=\"!model.companyHashId\">\r\n                  <div class=\"col-md-8 nopad\">\r\n                    <div class=\"checkbox\">\r\n                      <label>\r\n                        <input type=\"checkbox\" name=\"acceptanceMomentModel.repeatTimeOpenApp\" [(ngModel)]=\"model.acceptanceMomentModel.repeatTimeOpenApp\">{{ 'LblWhenOpeningAppAndRepeat' | translate }}\r\n                      </label>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"col-md-2 \">\r\n                    <div>\r\n                      <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblDays' | translate }}\" maxlength=\"4\" [(ngModel)]=\"model.acceptanceMomentModel.repeatTimeInDay\"\r\n                        name=\"model.acceptanceMomentModel.repeatTimeInDay\">\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"col-md-2 \" style=\"line-height: 30px;\">\r\n                    <div>\r\n                      {{ 'LblDays' | translate }}\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"clearfix\"></div>\r\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'acceptanceMomentModel.RepeatTimeInDay' }}</span>\r\n                </div>\r\n\r\n                <div *ngIf=\"!model.companyHashId\" class=\"checkbox\">\r\n                  <label>\r\n                    <input type=\"checkbox\" name=\"acceptanceMomentModel.everyTimeOpenApp\" [(ngModel)]=\"model.acceptanceMomentModel.everyTimeOpenApp\">{{ 'LblEveryTimeOpenApp' | translate }}\r\n                  </label>\r\n                </div>\r\n                <div class=\"checkbox\">\r\n                  <label>\r\n                    <input type=\"checkbox\" name=\"acceptanceMomentModel.makeBooking\" [(ngModel)]=\"model.acceptanceMomentModel.makeBooking\">{{ 'LblWhenMakeBooking' | translate }}\r\n                  </label>\r\n                </div>\r\n                <div class=\"checkbox\">\r\n                  <label>\r\n                    <input type=\"checkbox\" name=\"acceptanceMomentModel.startBooking\" [(ngModel)]=\"model.acceptanceMomentModel.startBooking\">{{ 'LblWhenStartBooking' | translate }}\r\n                  </label>\r\n                </div>\r\n                <div class=\"checkbox\">\r\n                  <label>\r\n                    <input type=\"checkbox\" name=\"acceptanceMomentModel.openBooking\" [(ngModel)]=\"model.acceptanceMomentModel.openBooking\">{{ 'LblWhenOpenBooking' | translate }}\r\n                  </label>\r\n                </div>               \r\n                <div class=\"form-group\" [ngClass]=\" {'hidden':(!model.sharedVehicleGroupHashId)}\">\r\n                  <label>{{ 'LblContractTypeGroup' | translate }} </label>\r\n                  <div class=\"checkbox\">\r\n                    <label>\r\n                      <input type=\"checkbox\" name=\"acceptanceMomentModel.ctgSelection\" [(ngModel)]=\"model.acceptanceMomentModel.ctgSelection\">{{ 'LblSelectContractTypeGroup' | translate }}\r\n                    </label>\r\n                  </div>\r\n                  <div [ngClass]=\" {'hidden':(!model.acceptanceMomentModel.ctgSelection)}\">\r\n                    <select id=\"ctg\" name=\"ctg\" class=\"form-group col-md-12\" multiple>\r\n                      <option *ngFor=\"let item of contractTypeGroupList\" [attr.value]='item.keyHash'>{{item.value}}</option>\r\n                    </select>\r\n                  </div>\r\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'acceptanceMomentModel.contractTypeGroupList' }}</span>\r\n                </div>\r\n              </div>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'acceptanceMomentModel.accountActivation' }}</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <div class=\"form-group col-md-11\">\r\n              <label>\r\n                <span class=\"text text-danger\">*</span>{{ 'LblName' | translate }}</label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblName' | translate }}\" [(ngModel)]=\"model.name\" name=\"name\" maxlength=\"200\"\r\n              />\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'name' }}</span>\r\n            </div>\r\n            <div class=\"form-group col-md-1\">\r\n              <label>\r\n                {{ 'LblVersion' | translate }}\r\n              </label>\r\n              <input type=\"number\" class=\"form-control\" [(ngModel)]=\"model.displayVersion\" ng-currency fraction=\"1\" step=\"0.1\" name=\"version\" disabled/>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"row\">\r\n          <div class=\"col-md-12\">\r\n            <div class=\"form-group col-md-12\">\r\n              <label>\r\n                <span class=\"text text-danger\">*</span>{{ 'LblContents' | translate }}\r\n              </label>\r\n              <tinymce-editor [MceHtmlInput]=\"model.bodyHtml\" (MceHtmlOutput)=\"MceHtmlOutput($event)\" name=\"bodyHtml\" style=\"height: 400px;\"></tinymce-editor>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'bodyHtml' }}</span>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"row no-margin\">\r\n          <div class=\"col-sm-12\">\r\n            <hr>\r\n            <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnBackClick()\">{{ 'LblCancel' | translate }}</a> &nbsp;&nbsp;\r\n            <a *ngIf=\"isEditMode\" class=\"btn btn-green cursor-pointer\" (click)=\"OnNewVersionClick()\">{{ 'LblNewVersion' | translate }}</a> &nbsp;&nbsp;\r\n            <button class=\"btn btn-green\" type=\"submit\">{{ 'LblSave' | translate }}</button>\r\n          </div>\r\n        </div>\r\n      </form>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"SuccessModalClick()\"></wego-success-popup>\r\n\r\n<div bsModal #newVersionModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-sm\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"newVersionModal.hide()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblNewVersion' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <div class=\"form-group col-md-12\">\r\n          <label> {{'LblName' | translate }} </label>\r\n          <input type=\"text\" class=\"form-control\" [ngModel]=\"model.name\" name=\"name1\" disabled>\r\n        </div>\r\n        <div class=\"form-group col-md-12\">\r\n          <label> {{'LblOldVersion' | translate }} </label>\r\n          <input type=\"text\" class=\"form-control\" [ngModel]=\"model.displayVersion\" name=\"version1\" disabled>\r\n        </div>\r\n        <div class=\"form-group col-md-12\">\r\n          <label> {{'LblNewVersion' | translate }} </label>\r\n          <input type=\"text\" class=\"form-control\" [ngModel]=\"newVersion\" name=\"version1\" disabled>\r\n        </div>\r\n        <div class=\"row no-margin\">\r\n          <div class=\"col-sm-12\">\r\n            <hr>\r\n            <a class=\"btn btn-gray cursor-pointer\" (click)=\"newVersionModal.hide();\">{{ 'LblCancel' | translate }}</a> &nbsp;&nbsp;\r\n            <a class=\"btn btn-green cursor-pointer\" (click)=\"VersionChanged()\">{{ 'LblSave' | translate }}</a> &nbsp;&nbsp;\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 1021 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var config_1 = __webpack_require__(60);
	var router_1 = __webpack_require__(26);
	var common_1 = __webpack_require__(22);
	var terms_condition_popup_service_1 = __webpack_require__(639);
	var terms_condition_model_1 = __webpack_require__(1022);
	var enum_helper_1 = __webpack_require__(578);
	var ViewTermsAndConditionPopupComponent = (function () {
	    function ViewTermsAndConditionPopupComponent(authService, locationService, router, activeRoute, termsConditionPopup) {
	        this.authService = authService;
	        this.locationService = locationService;
	        this.router = router;
	        this.activeRoute = activeRoute;
	        this.termsConditionPopup = termsConditionPopup;
	        this.isLoading = false;
	        this.curIndex = 0;
	        this.TotalTNC = 0;
	    }
	    ViewTermsAndConditionPopupComponent.prototype.ngOnInit = function () {
	        this.termsConditionActivityLogModel = new terms_condition_model_1.TermsConditionActivityLog();
	        this.urlTermsAndConditionPopup = this.authService.GetURL(config_1.ApplicationRouteURL.URL_TERMS_AND_CONDITION_POPUP);
	        this.CheckAccountActivationTermsConditionStatus();
	    };
	    ViewTermsAndConditionPopupComponent.prototype.CheckAccountActivationTermsConditionStatus = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.termsConditionPopup.GetTermsConditionForDriver([enum_helper_1.TNCAcceptanceMoment.ACCOUNT_ACTIVATION, enum_helper_1.TNCAcceptanceMoment.EVERY_TIME_OPEN_APP, enum_helper_1.TNCAcceptanceMoment.REPEAT_TIME_OPEN_APP]).subscribe(function (res) {
	            if (res.data && res.data.length == 0) {
	                var isAccepted = res.data.accepted;
	            }
	            else {
	                _this.termsAndCondList = res.data;
	                _this.curIndex = 0;
	                _this.termsAndConditionName = _this.termsAndCondList[0].name;
	                _this.TotalTNC = _this.termsAndCondList.length;
	                _this.bodyHTMLText = res.data[0].content;
	                _this.termsAndConditionHashId = res.data[0].termsAndConditionsHashId;
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    ViewTermsAndConditionPopupComponent.prototype.NavigateTo = function () {
	        this.router.navigate(['/privacystatement/popup']);
	    };
	    ViewTermsAndConditionPopupComponent.prototype.OnRejectClick = function (action) {
	        this.ActionOnAccountActivationTermsCondition(this.termsAndConditionHashId, enum_helper_1.TNCAction.REJECTED);
	    };
	    ViewTermsAndConditionPopupComponent.prototype.Logout = function () {
	        this.authService.Logout();
	        this.router.navigate(['/']);
	    };
	    ViewTermsAndConditionPopupComponent.prototype.OnAcceptClick = function (action) {
	        this.ActionOnAccountActivationTermsCondition(this.termsAndConditionHashId, enum_helper_1.TNCAction.ACCEPTED);
	    };
	    ViewTermsAndConditionPopupComponent.prototype.ActionOnAccountActivationTermsCondition = function (tncHashId, action) {
	        var _this = this;
	        this.termsConditionPopup
	            .ActionOnAccountActivationTermsCondition(tncHashId, action, '', '', [enum_helper_1.TNCAcceptanceMoment.ACCOUNT_ACTIVATION, enum_helper_1.TNCAcceptanceMoment.EVERY_TIME_OPEN_APP, enum_helper_1.TNCAcceptanceMoment.REPEAT_TIME_OPEN_APP])
	            .subscribe(function (res) {
	            if (action == enum_helper_1.TNCAction.ACCEPTED) {
	                _this.curIndex = _this.curIndex + 1;
	                if (_this.curIndex == _this.TotalTNC) {
	                    _this.NavigateTo();
	                }
	                else {
	                    _this.termsAndConditionName = _this.termsAndCondList[_this.curIndex].name;
	                    _this.bodyHTMLText = _this.termsAndCondList[_this.curIndex].content;
	                    _this.termsAndConditionHashId = _this.termsAndCondList[_this.curIndex].termsAndConditionsHashId;
	                }
	            }
	            else {
	                _this.Logout();
	            }
	            console.log('T&C updated successfully');
	        }, function (error) { });
	    };
	    ViewTermsAndConditionPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'Wego-Popup-TermsAndCondition',
	            template: __webpack_require__(1023),
	            providers: [terms_condition_popup_service_1.TermsConditionPopup]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object, (typeof (_e = typeof terms_condition_popup_service_1.TermsConditionPopup !== 'undefined' && terms_condition_popup_service_1.TermsConditionPopup) === 'function' && _e) || Object])
	    ], ViewTermsAndConditionPopupComponent);
	    return ViewTermsAndConditionPopupComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.ViewTermsAndConditionPopupComponent = ViewTermsAndConditionPopupComponent;


/***/ },
/* 1022 */
/***/ function(module, exports) {

	"use strict";
	var TermsConditionActivityLog = (function () {
	    function TermsConditionActivityLog() {
	        this.id = '';
	        this.termsAndConditionId = '';
	        this.driverHashId = '';
	        this.actionDateTime = '';
	        this.bookingId = '';
	        this.cTGId = '';
	    }
	    return TermsConditionActivityLog;
	}());
	exports.TermsConditionActivityLog = TermsConditionActivityLog;


/***/ },
/* 1023 */
/***/ function(module, exports) {

	module.exports = "<section class=\"login-bg\">\r\n  <div class=\"wrapper\" style=\"background-color: transparent;\">\r\n    <div class=\"container\" style=\"margin-top:120px\">\r\n      <div class=\"row\">\r\n        <div class=\"col-sm-10 login-center\">\r\n          <div class=\"login-panel panel-default\">\r\n            <div>\r\n              <form (ngSubmit)=\"onSubmit()\" #loginForm=\"ngForm\" method=\"post\">\r\n                <fieldset>\r\n                  <div class=\"row\">\r\n                    <div class=\"center-block\">\r\n                      <h1 class=\"text-center login-text\" style=\"color:#fff;\">Terms & Conditions</h1>\r\n                    </div>\r\n                  </div>\r\n                  <div *ngIf=\"this.termsAndCondList && this.termsAndCondList.length>0\" class=\"row\">\r\n                    <h2 class=\"text-center login-text\" style=\"color:#fff;\">{{curIndex+1}} {{'LblOutOf' | translate}} {{TotalTNC}} </h2>\r\n                    <div class=\"col-xs-12 col-sm-10 col-sm-offset-1\" style=\" overflow: auto;\">\r\n                      <span [innerHTML]=\"bodyHTMLText\" style=\"color:#fff; text-align: left;\"></span>\r\n                    </div>\r\n                    <br/>\r\n                    <br/>\r\n                    <div class=\"checkbox col-xs-12 col-sm-8 col-sm-offset-2\" style=\"text-align: center\">\r\n                      <a class=\"btn btn-green cursor-pointer\" (click)=\"OnAcceptClick()\">{{ 'LblAccept' | translate }}</a> &nbsp;&nbsp;\r\n                      <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnRejectClick()\">{{ 'LblReject' | translate }}</a> &nbsp;&nbsp;\r\n                    </div>\r\n                  </div>\r\n                </fieldset>\r\n              </form>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>";

/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var config_1 = __webpack_require__(60);
	var auth_service_1 = __webpack_require__(58);
	var customer_service_1 = __webpack_require__(664);
	var instance_service_1 = __webpack_require__(500);
	var company_service_1 = __webpack_require__(501);
	var organization_service_1 = __webpack_require__(614);
	var vehicle_service_1 = __webpack_require__(530);
	var report_filter_cost_center_model_1 = __webpack_require__(1025);
	var cost_center_report_service_1 = __webpack_require__(1026);
	var CostCenterReportComponent = (function () {
	    function CostCenterReportComponent(authService, customerService, instanceService, companyService, organizationService, vehicleService, costCenterReportService) {
	        this.authService = authService;
	        this.customerService = customerService;
	        this.instanceService = instanceService;
	        this.companyService = companyService;
	        this.organizationService = organizationService;
	        this.vehicleService = vehicleService;
	        this.costCenterReportService = costCenterReportService;
	        this.isValidSearch = false;
	        this.roleLevel = config_1.RoleLevel;
	        this.isExport = false;
	        this.reportFilterModel = new report_filter_cost_center_model_1.CostCenterReportFilter();
	    }
	    CostCenterReportComponent.prototype.ngOnInit = function () {
	        this.reportName = "Cost_Center_Report";
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	    };
	    CostCenterReportComponent.prototype.ResetValidSearch = function ($event) {
	        var isValidSearch = $event.isValidSearch;
	        this.isValidSearch = isValidSearch;
	        this.costCenterReportResult = [];
	    };
	    CostCenterReportComponent.prototype.OnSearch = function ($event) {
	        var _this = this;
	        this.isLoading = true;
	        this.reportFilterModel = $event.model;
	        this.costCenterReportService
	            .GetCostCenterReportData(this.reportFilterModel)
	            .subscribe(function (res) {
	            _this.errorModel = [];
	            if (!res.data) {
	                _this.isValidSearch = false;
	                _this.errorModel = res.error;
	            }
	            else {
	                _this.costCenterReportResult = res.data;
	                _this.isValidSearch = res.data.length > 0 ? true : false;
	                if (_this.isValidSearch) {
	                    _this.currencySymbol = _this.costCenterReportResult[0].currencySymbol;
	                }
	                if (typeof res.error === "string") {
	                    _this.errorMessage = res.error;
	                }
	                else {
	                    _this.errorModel = res.error;
	                }
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    CostCenterReportComponent.prototype.OnExportExcel = function ($event) {
	        var _this = this;
	        this.isLoading = true;
	        this.reportFilterModel = $event.model;
	        this.costCenterReportService
	            .ExportCostCenterReportExcel(this.reportFilterModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "CostCenterReport" + new Date().toISOString() + ".xlsx";
	                _this.authService.DownloadXlsFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    CostCenterReportComponent.prototype.OnExportPDF = function ($event) {
	        var _this = this;
	        this.isLoading = true;
	        this.reportFilterModel = $event.model;
	        this.costCenterReportService.ExportCostCenterReportPdf(this.reportFilterModel).subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "CostCenterReport" + new Date().toISOString() + ".pdf";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    CostCenterReportComponent.prototype.isDisplayColumn = function (columnName) {
	        if (this.reportFilterModel.costTypeHashIdList.length == 0 ||
	            this.reportFilterModel.costTypeHashIdList.indexOf(columnName) > -1) {
	            return true;
	        }
	        else
	            return false;
	    };
	    CostCenterReportComponent = __decorate([
	        core_1.Component({
	            selector: "wego-cost-center-report",
	            template: __webpack_require__(1027),
	            providers: [
	                customer_service_1.CustomerService,
	                instance_service_1.InstanceService,
	                company_service_1.CompanyService,
	                organization_service_1.OrganizationService,
	                vehicle_service_1.VehicleService,
	                cost_center_report_service_1.CostCenterReportService
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof customer_service_1.CustomerService !== 'undefined' && customer_service_1.CustomerService) === 'function' && _b) || Object, (typeof (_c = typeof instance_service_1.InstanceService !== 'undefined' && instance_service_1.InstanceService) === 'function' && _c) || Object, (typeof (_d = typeof company_service_1.CompanyService !== 'undefined' && company_service_1.CompanyService) === 'function' && _d) || Object, (typeof (_e = typeof organization_service_1.OrganizationService !== 'undefined' && organization_service_1.OrganizationService) === 'function' && _e) || Object, (typeof (_f = typeof vehicle_service_1.VehicleService !== 'undefined' && vehicle_service_1.VehicleService) === 'function' && _f) || Object, (typeof (_g = typeof cost_center_report_service_1.CostCenterReportService !== 'undefined' && cost_center_report_service_1.CostCenterReportService) === 'function' && _g) || Object])
	    ], CostCenterReportComponent);
	    return CostCenterReportComponent;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.CostCenterReportComponent = CostCenterReportComponent;


/***/ },
/* 1025 */
/***/ function(module, exports) {

	"use strict";
	var CostCenterReportFilter = (function () {
	    function CostCenterReportFilter() {
	        this.customerHashId = "";
	        this.instanceHashId = "";
	        this.companyHashId = "";
	        this.organizationHashId = "";
	        this.costTypeHashId = "";
	        this.vehicleHashIdList = [];
	        this.driverHashIdList = [];
	        this.searchLicenceTagList = [];
	        this.searchDriverNameList = [];
	        this.costTypeHashIdList = [];
	        this.searchCostTypeNameList = [];
	        this.showTotalOnly = false;
	    }
	    return CostCenterReportFilter;
	}());
	exports.CostCenterReportFilter = CostCenterReportFilter;
	var DropdownModel = (function () {
	    function DropdownModel() {
	    }
	    return DropdownModel;
	}());
	exports.DropdownModel = DropdownModel;


/***/ },
/* 1026 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var config_1 = __webpack_require__(60);
	var http_1 = __webpack_require__(59);
	var jquery_helper_service_1 = __webpack_require__(67);
	var auth_service_1 = __webpack_require__(58);
	var CostCenterReportService = (function () {
	    function CostCenterReportService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	        this.JQueryHelper = new jquery_helper_service_1.JQueryHelperService();
	    }
	    CostCenterReportService.prototype.GetCostTypeList = function (instanceHashId, pageName) {
	        if (pageName === void 0) { pageName = ""; }
	        var getCostTypeListUrl;
	        switch (pageName) {
	            case "Cost_Center_Report":
	                getCostTypeListUrl =
	                    config_1.WeGoConfig.API_GET_COST_TYPE_LIST_FOR_COST_CENTER_REPORT;
	                break;
	            default:
	                getCostTypeListUrl =
	                    config_1.WeGoConfig.API_GET_COST_TYPE_LIST_FOR_COST_CENTER_REPORT;
	                break;
	        }
	        if (instanceHashId)
	            getCostTypeListUrl =
	                getCostTypeListUrl + "?instanceHashId=" + instanceHashId;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getCostTypeListUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CostCenterReportService.prototype.GetCostCenterReportData = function (input) {
	        var body = input;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .post(config_1.WeGoConfig.API_GET_COST_CENTER_REPORT_DATA, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CostCenterReportService.prototype.ExportCostCenterReportExcel = function (model) {
	        var getUrl = config_1.WeGoConfig.API_EXPORT_COST_CENTER_REPORT_EXCEL;
	        var queryStringReportFilterModel = this.JQueryHelper.Param(model);
	        getUrl = getUrl + "?" + decodeURIComponent(queryStringReportFilterModel);
	        var headers = this.authService.GetHeader("application/vnd.openxmlformats-officedocument.spreadsheetml.sheet");
	        var options = new http_1.RequestOptions({
	            headers: headers,
	            responseType: http_1.ResponseContentType.Blob
	        });
	        return this.http.get(getUrl, options);
	    };
	    CostCenterReportService.prototype.ExportCostCenterReportPdf = function (model) {
	        var getUrl = config_1.WeGoConfig.API_EXPORT_COST_CENTER_REPORT_PDF;
	        var queryStringReportFilterModel = this.JQueryHelper.Param(model);
	        getUrl = getUrl + "?" + decodeURIComponent(queryStringReportFilterModel);
	        var headers = this.authService.GetHeader('application/pdf');
	        var options = new http_1.RequestOptions({ headers: headers, responseType: http_1.ResponseContentType.Blob });
	        return this.http.get(getUrl, options);
	    };
	    CostCenterReportService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], CostCenterReportService);
	    return CostCenterReportService;
	    var _a, _b;
	}());
	exports.CostCenterReportService = CostCenterReportService;


/***/ },
/* 1027 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ 'LblCostCenterReport' | translate }}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li class=\"active\">{{ 'LblCostCenterReport' | translate }}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <div class=\"box box-default\">\r\n          <div class=\"box-body\" style=\"display: block;\">\r\n            <!--Filter-->\r\n            <wego-report-filter-cost-center [IsValidSearch]=\"isValidSearch\" [ErrorModel]=\"errorModel\" [ReportName]=\"reportName\"\r\n              (ResetValidSearch)=\"ResetValidSearch($event)\" (OnSearch)=\"OnSearch($event)\" (OnExportExcel)=\"OnExportExcel($event)\"\r\n              (OnExportPDF)=\"OnExportPDF($event)\"></wego-report-filter-cost-center>\r\n            <!--End Filter-->\r\n\r\n            <!-- No Record Found Started -->\r\n            <div class=\"row\">\r\n              <div class=\"col-sm-12 text-danger text-center\">\r\n                <div *ngIf=\"costCenterReportResult && costCenterReportResult.length == 0\">\r\n                  {{ errorMessage }}\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <!-- No Record Found End -->\r\n            <div class=\"row\" *ngIf=\"costCenterReportResult && costCenterReportResult.length > 0\">\r\n              <fieldset class=\"col-md-12\">\r\n                <legend class=\"legendStyle\">\r\n                  <div class=\"form-inline\" style=\"padding-bottom: 5px;\">\r\n                    <div class=\"form-group\">\r\n                      {{ 'LblCostCenterReport' | translate }}\r\n                    </div>\r\n                  </div>\r\n                </legend>\r\n                <div class=\"clearfix\"></div>\r\n                <div class=\"row\">\r\n                  <div class=\"col-sm-12\">\r\n                    <table class=\"table table-bordered mar_bot_ziro\">\r\n                      <thead>\r\n                        <tr>\r\n                          <th>&nbsp;</th>\r\n                          <th>&nbsp;</th>\r\n                          <th>&nbsp;</th>\r\n                          <th>&nbsp;</th>\r\n                          <th>&nbsp;</th>\r\n                          <th>&nbsp;</th>\r\n                          <th *ngIf=\"isDisplayColumn('DISTANCE')\"> {{ 'LblDistance' | translate }} ({{currencySymbol}})\r\n                          </th>\r\n                          <th *ngIf=\"isDisplayColumn('TIME')\"> {{ 'LblTime' | translate }} ({{currencySymbol}})</th>\r\n                          <th *ngIf=\"isDisplayColumn('FIXEDFEE')\"> {{ 'LblFixedCost' | translate }} ({{currencySymbol}}) </th>\r\n                          <th *ngIf=\"isDisplayColumn('PENALTIES')\"> {{ 'LblPenalty' | translate }} ({{currencySymbol}}) </th>\r\n                          <th *ngIf=\"isDisplayColumn('SUBSCRIPTIONFEE')\"> {{ 'LblSubscription' | translate }} ({{currencySymbol}}) </th>\r\n                          <th *ngFor=\"let itemDynamicColumn of costCenterReportResult[0].costAndExpenseList\">\r\n                            {{itemDynamicColumn.caption}} ({{currencySymbol}})\r\n                          </th>\r\n                          <th>\r\n                            {{ 'LblTotal' | translate }} {{ 'LblExVat' | translate }} ({{currencySymbol}})\r\n                          </th>\r\n                          <th>\r\n                            {{ 'LblTotal' | translate }} {{ 'LblInclVat' | translate }} ({{currencySymbol}})\r\n                          </th>\r\n                        </tr>\r\n                      </thead>\r\n                      <tbody>\r\n                        <tr *ngFor=\"let item of costCenterReportResult\">\r\n                          <td [attr.colspan]=\"item.column1?6:1\">\r\n                            <b>{{item.column1}}</b>\r\n                          </td>\r\n                          <td *ngIf=\"item.levelNo>=2 \" [attr.colspan]=\"item.column2?5:1\">\r\n                            <b>{{item.column2}}</b>\r\n                          </td>\r\n                          <td *ngIf=\"item.levelNo>=3\" [attr.colspan]=\"item.column3?4:1\">\r\n                            <b>{{item.column3}}</b>\r\n                          </td>\r\n                          <td *ngIf=\"item.levelNo>=4\" [attr.colspan]=\"item.column4?3:1\">\r\n                            <b>{{item.column4}}</b>\r\n                          </td>\r\n                          <td *ngIf=\"item.levelNo>=5 \" [attr.colspan]=\"item.column5?2:1\">\r\n                            <b>{{item.column5}}</b>\r\n                          </td>\r\n                          <td *ngIf=\"item.levelNo>=6\" [attr.colspan]=\"1\">\r\n                            <b>{{item.column6}}</b>\r\n                          </td>\r\n                          <td *ngIf=\"isDisplayColumn('DISTANCE')\"> {{item.distanceCost}}</td>\r\n                          <td *ngIf=\"isDisplayColumn('TIME')\"> {{item.timeCost}}</td>\r\n                          <td *ngIf=\"isDisplayColumn('FIXEDFEE')\"> {{item.fixedCost}}</td>\r\n                          <td *ngIf=\"isDisplayColumn('PENALTIES')\"> {{item.penalty }}</td>\r\n                          <td *ngIf=\"isDisplayColumn('SUBSCRIPTIONFEE')\"> {{item.subscriptionCost }}</td>\r\n                          <td *ngFor=\"let itemDynamicColumn of item.costAndExpenseList\">\r\n                            {{ itemDynamicColumn.value}}\r\n                          </td>\r\n                          <td>\r\n                            <b>{{ item.totalExVat }}</b>\r\n                          </td>\r\n                          <td>\r\n                            <b>{{ item.totalIncVat }}</b>\r\n                          </td>\r\n                        </tr>\r\n                      </tbody>\r\n                    </table>\r\n                  </div>\r\n                </div>\r\n              </fieldset>\r\n            </div>\r\n            <!-- End Details table -->\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>";

/***/ },
/* 1028 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var config_1 = __webpack_require__(60);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var decimal_formatter_service_1 = __webpack_require__(69);
	var snail_trail_search_model_1 = __webpack_require__(1029);
	var snail_trail_driver_service_1 = __webpack_require__(1030);
	var router_1 = __webpack_require__(26);
	var SnailTrailDriverComponent = (function () {
	    function SnailTrailDriverComponent(snailTrailDriverService, decimalFormatter, authService, activeRoute) {
	        this.snailTrailDriverService = snailTrailDriverService;
	        this.decimalFormatter = decimalFormatter;
	        this.authService = authService;
	        this.activeRoute = activeRoute;
	        this.tripCounter = 0;
	        this.segmentCounter = 0;
	        this.roleLevel = config_1.RoleLevel;
	    }
	    SnailTrailDriverComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.urlDriverInfo = this.authService.GetURL(config_1.ApplicationRouteURL.URL_PERSON_UPDATE);
	        this.activeRoute
	            .params
	            .subscribe(function (params) {
	            _this.searchModel = new snail_trail_search_model_1.SnailTrailDriverSearchModel();
	            _this.searchModel.bookingHashId = params['id'] ? params['id'] : params['bookingHashId'];
	            _this.searchModel.reportSearchType = 'PER_BOOKING';
	            _this.GetSnailTrail();
	        });
	    };
	    SnailTrailDriverComponent.prototype.OnSearch = function ($event) {
	        this.HandleFilterParam($event);
	        // Get snail trail report from server
	        this.GetSnailTrail();
	    };
	    SnailTrailDriverComponent.prototype.OnExport = function ($event) {
	        this.HandleFilterParam($event);
	        // Get snail trail excel format report from server
	        this.ExportExcel();
	    };
	    SnailTrailDriverComponent.prototype.HandleFilterParam = function ($event) {
	        // Assigned filter parameter to search model
	        this.searchModel = new snail_trail_search_model_1.SnailTrailDriverSearchModel();
	        this.searchModel.reportSearchType = $event.reportSearchType;
	        if (this.searchModel.reportSearchType == 'PER_BOOKING') {
	            this.searchModel.bookingHashId = $event.bookingHashId;
	        }
	    };
	    // Get snail trail report from the server
	    SnailTrailDriverComponent.prototype.GetSnailTrail = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.snailTrailDriverService.GetSnailTrail(this.searchModel)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.listOfSnailTrail = res.data;
	                _this.errorModel = [];
	                if (_this.listOfSnailTrail && _this.listOfSnailTrail.length > 0) {
	                    _this.noDataFoundMsg = '';
	                    _this.SelectTrip(0);
	                }
	                else {
	                    _this.noDataFoundMsg = res.error;
	                }
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SnailTrailDriverComponent.prototype.ExportExcel = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.snailTrailDriverService.ExportSnailTrailExcel(this.searchModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "SnailTrail" + new Date().toISOString() + ".xlsx";
	                _this.authService.DownloadXlsFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    // Trip related event
	    SnailTrailDriverComponent.prototype.PreviousTrip = function () {
	        // If trip counter is 0 then don't allow to go to previous
	        if (this.tripCounter != 0) {
	            this.tripCounter--;
	            this.SelectTrip(this.tripCounter);
	        }
	    };
	    SnailTrailDriverComponent.prototype.NextTrip = function () {
	        // If trip counter try to reach more than record then don't allow to go to next
	        if (this.listOfSnailTrail && ((this.tripCounter + 1) != this.listOfSnailTrail.length)) {
	            this.tripCounter++;
	            this.SelectTrip(this.tripCounter);
	        }
	    };
	    SnailTrailDriverComponent.prototype.SelectTrip = function (position) {
	        // If data not available for position then don't allow
	        if (this.listOfSnailTrail && position < this.listOfSnailTrail.length) {
	            this.currentTrip = this.listOfSnailTrail[position];
	            this.tripCounter = position;
	            this.ResetSegment();
	            this.SelectSegment(0);
	        }
	    };
	    // Segment related event
	    SnailTrailDriverComponent.prototype.PreviousSegment = function () {
	        // If Segment counter is 0 then don't allow to go to previous
	        if (this.segmentCounter != 0) {
	            this.segmentCounter--;
	            this.SelectSegment(this.segmentCounter);
	        }
	    };
	    SnailTrailDriverComponent.prototype.NextSegment = function () {
	        // If current trip is not selected then segment is not available
	        // If Segment counter try to reach more than record then don't allow to go to next
	        if (this.currentTrip && ((this.segmentCounter + 1) != this.currentTrip.snailTrailSegment.length)) {
	            this.segmentCounter++;
	            this.SelectSegment(this.segmentCounter);
	        }
	    };
	    SnailTrailDriverComponent.prototype.SelectSegment = function (position) {
	        // If current trip is not selected then segment is not available
	        // If data not available for position then don't allow
	        if (this.currentTrip && this.currentTrip.snailTrailSegment && position < this.currentTrip.snailTrailSegment.length) {
	            this.currentSegment = this.currentTrip.snailTrailSegment[position];
	            this.segmentCounter = position;
	        }
	    };
	    SnailTrailDriverComponent.prototype.ResetSegment = function () {
	        this.currentSegment = null;
	        this.segmentCounter = 0;
	    };
	    SnailTrailDriverComponent.prototype.ResetData = function () {
	        // Reset the data based on change the filter parameter
	        this.searchModel = null;
	        this.errorModel = [];
	        this.listOfSnailTrail = [];
	        this.currentTrip = null;
	        this.currentSegment = null;
	        this.tripCounter = 0;
	        this.segmentCounter = 0;
	    };
	    SnailTrailDriverComponent.prototype.DecimalFormatter = function (value) {
	        return this.decimalFormatter.transform(value);
	    };
	    SnailTrailDriverComponent.prototype.ngOnDestroy = function () {
	    };
	    SnailTrailDriverComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-snail-trail-driver',
	            template: __webpack_require__(1031),
	            styles: [__webpack_require__(80)],
	            providers: [snail_trail_driver_service_1.SnailTrailDriverService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof snail_trail_driver_service_1.SnailTrailDriverService !== 'undefined' && snail_trail_driver_service_1.SnailTrailDriverService) === 'function' && _a) || Object, (typeof (_b = typeof decimal_formatter_service_1.DecimalFormatterService !== 'undefined' && decimal_formatter_service_1.DecimalFormatterService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object])
	    ], SnailTrailDriverComponent);
	    return SnailTrailDriverComponent;
	    var _a, _b, _c, _d;
	}());
	exports.SnailTrailDriverComponent = SnailTrailDriverComponent;


/***/ },
/* 1029 */
/***/ function(module, exports) {

	"use strict";
	var SnailTrailDriverSearchModel = (function () {
	    function SnailTrailDriverSearchModel() {
	    }
	    return SnailTrailDriverSearchModel;
	}());
	exports.SnailTrailDriverSearchModel = SnailTrailDriverSearchModel;


/***/ },
/* 1030 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var config_1 = __webpack_require__(60);
	var http_1 = __webpack_require__(59);
	var core_1 = __webpack_require__(3);
	var auth_service_1 = __webpack_require__(58);
	var jquery_helper_service_1 = __webpack_require__(67);
	var SnailTrailDriverService = (function () {
	    function SnailTrailDriverService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	        this.JQueryHelper = new jquery_helper_service_1.JQueryHelperService();
	    }
	    SnailTrailDriverService.prototype.GetSnailTrail = function (searchModel) {
	        var body = searchModel;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http.post(config_1.WeGoConfig.API_POST_SEARCH_SNAIL_TRAIL, body, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    SnailTrailDriverService.prototype.ExportSnailTrailExcel = function (model) {
	        var getUrl = config_1.WeGoConfig.API_GET_SEARCH_SNAIL_TRAIL_CSV;
	        var queryString = this.JQueryHelper.Param(model);
	        getUrl = getUrl + "?" + queryString;
	        var headers = this.authService.GetHeader('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
	        var options = new http_1.RequestOptions({ headers: headers, responseType: http_1.ResponseContentType.Blob });
	        return this.http.get(getUrl, options);
	    };
	    SnailTrailDriverService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], SnailTrailDriverService);
	    return SnailTrailDriverService;
	    var _a, _b;
	}());
	exports.SnailTrailDriverService = SnailTrailDriverService;


/***/ },
/* 1031 */
/***/ function(module, exports) {

	module.exports = "<!-- <wego-snail-trail-driver-filter [ErrorModel]=\"errorModel\" [IsValidReport]=\"listOfSnailTrail && listOfSnailTrail.length > 0\"\r\n  (OnResetData)=\"ResetData()\" (OnSearch)=\"OnSearch($event)\" (OnExportXls)=\"OnExport($event)\">\r\n</wego-snail-trail-driver-filter> -->\r\n\r\n<div class=\"clearfix\"></div>\r\n<section class=\"content\">\r\n  <div class=\"text-danger text-center\">\r\n    {{ noDataFoundMsg }}\r\n  </div>\r\n  <div class=\"row\" *ngIf=\"listOfSnailTrail && listOfSnailTrail.length > 0\">\r\n    <!--Map Panel-->\r\n    <div class=\"col-sm-8\">\r\n      <wego-snail-trail-map [CurrentTrip]=\"currentTrip\" [CurrentSegment]=\"currentSegment\" (OnSegmentChange)=\"SelectSegment($event.position)\"></wego-snail-trail-map>\r\n    </div>\r\n    <!--Trip and Segment Details-->\r\n    <div class=\"col-sm-4\" style=\"padding-left:0px\">\r\n      <!--Trip Details-->\r\n      <div class=\"box box-default\">\r\n        <div class=\"box-header with-border\">\r\n          <h3 class=\"box-title\">\r\n            <span>{{ 'LblTripDetail' | translate }}</span>\r\n          </h3>\r\n        </div>\r\n        <div class=\"box-body\">\r\n          <div class=\"form-horizontal\">\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-4\">{{ 'LblTripNumber' | translate }}: </label>\r\n              <div class=\"col-sm-8\">\r\n                <input type=\"text\" class=\"form-control input-sm\" [ngModel]=\"currentTrip?.tripNumber\" readonly>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-4\">{{ 'LblStart' | translate }}: </label>\r\n              <div class=\"col-sm-8\">\r\n                <input type=\"text\" class=\"form-control input-sm\" [ngModel]=\"currentTrip?.startDateTime\" readonly>\r\n              </div>\r\n            </div>\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-4\"></label>\r\n              <div class=\"col-sm-8\">\r\n                <input type=\"text\" class=\"form-control input-sm\" [ngModel]=\"currentTrip?.startLocation.location\" [title]=\"currentTrip?.startLocation.location\"\r\n                  readonly>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-4\">{{ 'LblEnd' | translate }}: </label>\r\n              <div class=\"col-sm-8\">\r\n                <input type=\"text\" class=\"form-control input-sm\" [ngModel]=\"currentTrip?.endDateTime\" readonly>\r\n              </div>\r\n            </div>\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-4\"></label>\r\n              <div class=\"col-sm-8\">\r\n                <input type=\"text\" class=\"form-control input-sm\" [ngModel]=\"currentTrip?.endLocation.location\" [title]=\"currentTrip?.endLocation.location\"\r\n                  readonly>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-4\">{{ 'LblAverageSpeed' | translate }} ({{ 'LblKMPerHour' | translate }}): </label>\r\n              <div class=\"col-sm-8\">\r\n                <input type=\"text\" class=\"form-control input-sm\" [ngModel]=\"DecimalFormatter(currentTrip?.avgSpeed)\" readonly>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\" *ngIf=\"currentTrip?.driverName\">\r\n              <label class=\"control-label col-sm-4\">{{ 'LblDriver' | translate }}: </label>\r\n              <div class=\"col-sm-8\">\r\n                <div class=\"input-group\">\r\n                  <input type=\"text\" class=\"form-control input-sm\" [ngModel]=\"currentTrip?.driverName\" readonly>\r\n                  <div *ngIf=\"(authService.GetHighestRoleLevel() <= roleLevel.Company) && !currentTrip?.isPersonDeleted && currentTrip.isPersonEdit\"\r\n                    class=\"input-group-btn\">\r\n                    <button class=\"btn btn-default btn-sm\" type=\"button\" [routerLink]=\"urlDriverInfo + '/' +  currentTrip?.personHashId\">\r\n                      <i class=\"fa fa-external-link\" aria-hidden=\"true\"></i>\r\n                    </button>\r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <ul class=\"pager\">\r\n            <li class=\"previous noselect\" [ngClass]=\"{'disabled': tripCounter == 0 }\">\r\n              <a (click)=\"PreviousTrip()\">\r\n                <i class=\"fa fa-arrow-left fa-fw\" aria-hidden=\"true\"></i> &nbsp; {{ 'LblPrevious' | translate }}</a>\r\n            </li>\r\n            <li class=\"next noselect\" [ngClass]=\"{'disabled': (tripCounter + 1) == listOfSnailTrail?.length }\">\r\n              <a (click)=\"NextTrip()\">{{ 'LblNext' | translate }} &nbsp;\r\n                <i class=\"fa fa-arrow-right fa-fw\" aria-hidden=\"true\"></i>\r\n              </a>\r\n            </li>\r\n          </ul>\r\n        </div>\r\n      </div>\r\n      <!--End Trip Details-->\r\n\r\n      <!--Segment Details-->\r\n      <div class=\"box box-default\">\r\n        <div class=\"box-header with-border\">\r\n          <h3 class=\"box-title\">\r\n            <span>{{ 'LblSegmentDetail' | translate }}</span>\r\n          </h3>\r\n        </div>\r\n        <div class=\"box-body\">\r\n          <div *ngIf=\"currentSegment\" class=\"form-horizontal\">\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-4\">{{ 'LblSegmentNumber' | translate }}: </label>\r\n              <div class=\"col-sm-8\">\r\n                <input type=\"text\" class=\"form-control input-sm\" [ngModel]=\"currentSegment?.segmentNumber\" readonly>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-4\" style=\"margin-right:0px;\">{{ 'LblDistance' | translate }} ({{ 'LblMeter' | translate }}):</label>\r\n              <div class=\"col-sm-8\">\r\n                <input type=\"text\" class=\"form-control input-sm\" [ngModel]=\"DecimalFormatter(currentSegment?.distance)\" readonly>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-4\">{{ 'LblStart' | translate }}: </label>\r\n              <div class=\"col-sm-8\">\r\n                <input type=\"text\" class=\"form-control input-sm\" [ngModel]=\"currentSegment?.startDateTime\" readonly>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-4\"></label>\r\n              <div class=\"col-sm-8\">\r\n                <input type=\"text\" class=\"form-control input-sm\" [ngModel]=\"currentSegment?.startLocation.location\" [title]=\"currentSegment?.startLocation.location\"\r\n                  readonly>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-4\">{{ 'LblSpeed' | translate }} ({{ 'LblKMPerHour' | translate }}):</label>\r\n              <div class=\"col-sm-8\">\r\n                <input type=\"text\" class=\"form-control input-sm\" [ngModel]=\"currentSegment?.startSpeed\" readonly>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-4\">{{ 'LblOdometer' | translate }} ({{ 'LblMeters' | translate }}):</label>\r\n              <div class=\"col-sm-8\">\r\n                <input type=\"text\" class=\"form-control input-sm\" [ngModel]=\"currentSegment?.startOdometer\" readonly>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-4\">{{ 'LblEnd' | translate }}: </label>\r\n              <div class=\"col-sm-8\">\r\n                <input type=\"text\" class=\"form-control input-sm\" [ngModel]=\"currentSegment?.endDateTime\" readonly>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-4\"></label>\r\n              <div class=\"col-sm-8\">\r\n                <input type=\"text\" class=\"form-control input-sm\" [ngModel]=\"currentSegment?.endLocation.location\" [title]=\"currentSegment?.endLocation.location\"\r\n                  readonly>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-4\">{{ 'LblSpeed' | translate }} ({{ 'LblKMPerHour' | translate }}):</label>\r\n              <div class=\"col-sm-8\">\r\n                <input type=\"text\" class=\"form-control input-sm\" [ngModel]=\"currentSegment?.endSpeed\" readonly>\r\n              </div>\r\n            </div>\r\n\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-4\">{{ 'LblOdometer' | translate }} ({{ 'LblMeters' | translate }}):</label>\r\n              <div class=\"col-sm-8\">\r\n                <input type=\"text\" class=\"form-control input-sm\" [ngModel]=\"currentSegment?.endOdometer\" readonly>\r\n              </div>\r\n            </div>\r\n\r\n            <ul class=\"pager\">\r\n              <li class=\"previous noselect\" [ngClass]=\"{'disabled': segmentCounter == 0 }\">\r\n                <a (click)=\"PreviousSegment()\">\r\n                  <i class=\"fa fa-arrow-left fa-fw\" aria-hidden=\"true\"></i> &nbsp; {{ 'LblPrevious' | translate }}</a>\r\n              </li>\r\n              <li class=\"next noselect\" [ngClass]=\"{'disabled': (segmentCounter + 1) == currentTrip?.snailTrailSegment.length }\">\r\n                <a (click)=\"NextSegment()\">{{ 'LblNext' | translate }} &nbsp;\r\n                  <i class=\"fa fa-arrow-right fa-fw\" aria-hidden=\"true\"></i>\r\n                </a>\r\n              </li>\r\n            </ul>\r\n          </div>\r\n\r\n          <div *ngIf=\"!currentSegment\">\r\n            <p class=\"text-center text-danger\">\r\n              {{ 'LblSegmentDetailNotAvailable' | translate }}\r\n            </p>\r\n          </div>\r\n        </div>\r\n        <!--End Segment Details-->\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n\r\n\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>";

/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var auth_service_1 = __webpack_require__(58);
	var config_1 = __webpack_require__(60);
	var terms_conditions_service_1 = __webpack_require__(882);
	var TCActivityLogDriverComponent = (function () {
	    function TCActivityLogDriverComponent(TermsAndConditionService, authService) {
	        this.TermsAndConditionService = TermsAndConditionService;
	        this.authService = authService;
	        this.DataListModel = new config_1.DataListModel();
	        this.LblIcon = "fa fa-plus-square";
	    }
	    TCActivityLogDriverComponent.prototype.ngOnInit = function () {
	        this.DataListModel.searchField = ["termsAndConditionName", "actionName", "companyName", "organizationName", "svgName", "version"];
	        this.GetTAndCActivityList();
	    };
	    TCActivityLogDriverComponent.prototype.GetTAndCActivityList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.TermsAndConditionService.GetTermsAndConditionActivityListDriver(this.DataListModel)
	            .subscribe(function (res) {
	            _this.TandCActivityLog = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    TCActivityLogDriverComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetTAndCActivityList();
	    };
	    TCActivityLogDriverComponent.prototype.OnSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, event.searchTerm, event.isReset);
	        this.GetTAndCActivityList();
	    };
	    TCActivityLogDriverComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetTAndCActivityList();
	    };
	    ;
	    TCActivityLogDriverComponent.prototype.OnPagingChange = function (event) {
	        console.log(this.DataListModel);
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetTAndCActivityList();
	    };
	    TCActivityLogDriverComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.TermsAndConditionService
	            .ExportTermsAndConditionActivityListDriver(this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "TermsAndConditionActivityLog" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    TCActivityLogDriverComponent.prototype.ConfirmRevokePopup = function () {
	        this.GetTAndCActivityList();
	    };
	    __decorate([
	        core_1.ViewChild("termsConditionModel"), 
	        __metadata('design:type', Object)
	    ], TCActivityLogDriverComponent.prototype, "termsConditionModel", void 0);
	    TCActivityLogDriverComponent = __decorate([
	        core_1.Component({
	            selector: "wego-tc-activitylog-driver",
	            template: __webpack_require__(1033),
	            providers: [
	                terms_conditions_service_1.TermsAndConditionsService
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof terms_conditions_service_1.TermsAndConditionsService !== 'undefined' && terms_conditions_service_1.TermsAndConditionsService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object])
	    ], TCActivityLogDriverComponent);
	    return TCActivityLogDriverComponent;
	    var _a, _b;
	}());
	exports.TCActivityLogDriverComponent = TCActivityLogDriverComponent;


/***/ },
/* 1033 */
/***/ function(module, exports) {

	module.exports = "<section class=\"banner-img-in\">\r\n  <div class=\"banner-in\">\r\n    <div class=\"search-bg-in\">\r\n      <div class=\"container-fluid\">\r\n        <div class=\"row\" style=\"padding-right:15px;\">\r\n          <div class=\"col-md-3 col-sm-6\">\r\n            <h2 class=\"pagename\">{{ 'LblActivityLog' | translate }}</h2>\r\n          </div>\r\n          <div class=\"col-md-4 navbar-right\">\r\n            <div class=\"form-space-top pull-right\">\r\n              <wego-driver-search-list (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\"\r\n                [SearchTerm]=\"DataListModel.searchTerm\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-driver-search-list>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n<div class=\"clearfix\"></div>\r\n<section class=\"content\">\r\n  <div class=\"container-fluid mar-top-25\">\r\n    <div class=\"table-responsive\">\r\n      <table class=\"table table-bordered mar_bot_ziro\">\r\n        <thead>\r\n          <tr>\r\n            <th class=\"cursor-pointer\" (click)=\"OnSort('termsAndConditionName')\">\r\n              {{ 'LblTAndCName' | translate }}\r\n              <wego-sort-list [FieldName]=\"'termsAndConditionName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n            </th>\r\n            <th class=\"cursor-pointer\" (click)=\"OnSort('actionName')\">\r\n              {{ 'LblAction' | translate }}\r\n              <wego-sort-list [FieldName]=\"'actionName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n            </th>\r\n            <th class=\"cursor-pointer\" (click)=\"OnSort('actionDatetimeUTC')\">\r\n              {{ 'LblDate' | translate }}\r\n              <wego-sort-list [FieldName]=\"'actionDatetimeUTC'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n            </th>\r\n            <th class=\"cursor-pointer\" (click)=\"OnSort('companyName')\">\r\n              {{ 'LblCompany' | translate }}\r\n              <wego-sort-list [FieldName]=\"'companyName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n            </th>\r\n            <th class=\"cursor-pointer\" (click)=\"OnSort('organizationName')\">\r\n              {{ 'LblOrganization' | translate }}\r\n              <wego-sort-list [FieldName]=\"'organizationName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n            </th>\r\n            <th class=\"cursor-pointer\" (click)=\"OnSort('svgName')\">\r\n              {{ 'LblSharedVehicleGroup' | translate }}\r\n              <wego-sort-list [FieldName]=\"'svgName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n            </th>\r\n            <th class=\"cursor-pointer\" (click)=\"OnSort('version')\">\r\n              {{ 'LblVersion' | translate }}\r\n              <wego-sort-list [FieldName]=\"'version'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n            </th>\r\n            <th>\r\n              {{ 'LblView' | translate }}\r\n            </th>\r\n          </tr>\r\n        </thead>\r\n        <tbody>\r\n          <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n            <tr *ngFor=\"let item of TandCActivityLog\">\r\n              <td>\r\n                {{ item.termsAndConditionName }}\r\n              </td>\r\n              <td>{{ item.actionName }}</td>\r\n              <td>{{ item.actionDateTime }}</td>\r\n              <td>{{ item.companyName }}</td>\r\n              <td>{{ item.organizationName }}</td>\r\n              <td>{{ item.svgName }}</td>\r\n              <td>{{ item.formattedVersion }}</td>\r\n              <td class=\"text-center cursor-pointer\">\r\n                <a (click)=\"termsConditionModel.show(item.tAndCActivityHashId)\">\r\n                  <i class=\"fa fa-eye fa-fw\"></i>\r\n                </a>\r\n              </td>\r\n            </tr>\r\n          </template>\r\n          <tr *ngIf=\"DataListModel.totalItems == 0\">\r\n            <td class=\"text-center text-danger\" colspan=\"8\">\r\n              {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n            </td>\r\n          </tr>\r\n        </tbody>\r\n      </table>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n      <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n        <div class=\"col-md-12\">\r\n          <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n            [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n            lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\r\n<wego-terms-condition-revoke-popup #termsConditionModel (onConfirm)=\"ConfirmRevokePopup()\"></wego-terms-condition-revoke-popup>";

/***/ },
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var config_1 = __webpack_require__(60);
	var pre_post_question_overview_service_1 = __webpack_require__(1035);
	var pre_post_question_search_model_1 = __webpack_require__(1036);
	var translate_1 = __webpack_require__(631);
	var moment = __webpack_require__(84);
	var PrePostQuestionsOverviewComponent = (function () {
	    function PrePostQuestionsOverviewComponent(authService, prePostTripQuestionOverviewService, translate) {
	        this.authService = authService;
	        this.prePostTripQuestionOverviewService = prePostTripQuestionOverviewService;
	        this.translate = translate;
	    }
	    PrePostQuestionsOverviewComponent.prototype.ngOnInit = function () {
	        this.model = new pre_post_question_search_model_1.PrePostQuestionSearchModel();
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	        this.urlBookingInformation = this.authService.GetURL(config_1.ApplicationRouteURL.URL_BOOKING_INFORMATION);
	        this.DataListModel = new config_1.DataListModel();
	        this.GetPrePostQuestionOverviewList();
	        // this.model.startDateTime = moment().format("DD-MM-YYYY 00:00");
	        // this.model.endDateTime = moment().add(+1, "M").format("DD-MM-YYYY 00:00");
	    };
	    PrePostQuestionsOverviewComponent.prototype.GetPrePostQuestionOverviewList = function () {
	        var _this = this;
	        this.prePostTripQuestionOverviewService
	            .GetPrePostTripQuestionList(this.model, this.DataListModel)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.prePostQuestionList = res.data;
	                _this.DataListModel.totalItems = res.totalRecords;
	                _this.DataListModel.infoMessage = res.error;
	                _this.isLoading = false;
	                _this.errorModel = null;
	            }
	            else {
	                _this.DataListModel.totalItems = res.totalRecords;
	                _this.DataListModel.infoMessage = _this.translate.instant("LblNoRecords");
	                _this.errorModel = res.error;
	                _this.isLoading = false;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    PrePostQuestionsOverviewComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetPrePostQuestionOverviewList();
	    };
	    PrePostQuestionsOverviewComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetPrePostQuestionOverviewList();
	    };
	    PrePostQuestionsOverviewComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.prePostTripQuestionOverviewService
	            .ExportPrePostTripQuestionList(this.model, this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "PrePostQuestionOverviewList" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    PrePostQuestionsOverviewComponent.prototype.OnAdvancedSearch = function (event) {
	        this.DataListModel = this.authService.GetSearchParameters(this.DataListModel, "", event.isReset);
	        if (!event.isReset) {
	            this.model = event.prePostSearchFilterModel;
	        }
	        else {
	            this.model.startDateTime = moment()
	                .add(+1, "days")
	                .format("DD-MM-YYYY 00:00");
	            this.model.endDateTime = moment()
	                .add(-1, "M")
	                .format("DD-MM-YYYY 00:00");
	            this.model = null;
	        }
	        this.GetPrePostQuestionOverviewList();
	    };
	    PrePostQuestionsOverviewComponent.prototype.OnAdvancedReset = function ($event) {
	        this.model = $event.prePostSearchFilterModel;
	        this.GetPrePostQuestionOverviewList();
	    };
	    PrePostQuestionsOverviewComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetPrePostQuestionOverviewList();
	    };
	    PrePostQuestionsOverviewComponent = __decorate([
	        core_1.Component({
	            selector: "wego-pre-post-questions-overview",
	            template: __webpack_require__(1037),
	            providers: [pre_post_question_overview_service_1.PrePostTripQuestionOverviewService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof pre_post_question_overview_service_1.PrePostTripQuestionOverviewService !== 'undefined' && pre_post_question_overview_service_1.PrePostTripQuestionOverviewService) === 'function' && _b) || Object, (typeof (_c = typeof translate_1.TranslateService !== 'undefined' && translate_1.TranslateService) === 'function' && _c) || Object])
	    ], PrePostQuestionsOverviewComponent);
	    return PrePostQuestionsOverviewComponent;
	    var _a, _b, _c;
	}());
	exports.PrePostQuestionsOverviewComponent = PrePostQuestionsOverviewComponent;


/***/ },
/* 1035 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var jquery_helper_service_1 = __webpack_require__(67);
	var PrePostTripQuestionOverviewService = (function () {
	    function PrePostTripQuestionOverviewService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	        this.JQueryHelper = new jquery_helper_service_1.JQueryHelperService();
	    }
	    PrePostTripQuestionOverviewService.prototype.GetPrePostTripQuestionList = function (prePostQuestionSearchModel, input) {
	        var url = config_1.WeGoConfig.API_PRE_POST_QUESTION_OVERVIEW;
	        var queryStringDataListModel = this.authService.HandleAPIListInput(input);
	        var queryStringPrePostTripQuestionModel = this.JQueryHelper.Param(prePostQuestionSearchModel);
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        url =
	            url +
	                "?" +
	                queryStringDataListModel +
	                "&" +
	                decodeURIComponent(queryStringPrePostTripQuestionModel);
	        return this.http
	            .get(url, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    PrePostTripQuestionOverviewService.prototype.GetDrowdownQuestionName = function (prePostQuestionSearchModel) {
	        var getQuestionNameListUrl = config_1.WeGoConfig.API_GET_PRE_POST_QUESTION_NAME;
	        var queryStringPrePostTripQuestionModel = this.JQueryHelper.Param(prePostQuestionSearchModel);
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        getQuestionNameListUrl =
	            getQuestionNameListUrl +
	                "?" +
	                decodeURIComponent(queryStringPrePostTripQuestionModel);
	        return this.http
	            .get(getQuestionNameListUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    PrePostTripQuestionOverviewService.prototype.ExportPrePostTripQuestionList = function (prePostQuestionSearchModel, input) {
	        var getUrl = config_1.WeGoConfig.API_PRE_POST_QUESTION__Export;
	        input.currentPage = 0;
	        var queryStringDataListModel = this.authService.HandleAPIListInput(input);
	        var queryStringBookingOverviewModel = this.JQueryHelper.Param(prePostQuestionSearchModel);
	        var headers = this.authService.GetHeader('text/csv');
	        var options = new http_1.RequestOptions({ headers: headers });
	        getUrl = getUrl + "?" + queryStringDataListModel + "&" + decodeURIComponent(queryStringBookingOverviewModel);
	        return this.http.get(getUrl, options);
	    };
	    PrePostTripQuestionOverviewService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], PrePostTripQuestionOverviewService);
	    return PrePostTripQuestionOverviewService;
	    var _a, _b;
	}());
	exports.PrePostTripQuestionOverviewService = PrePostTripQuestionOverviewService;


/***/ },
/* 1036 */
/***/ function(module, exports) {

	"use strict";
	var PrePostQuestionSearchModel = (function () {
	    function PrePostQuestionSearchModel() {
	        this.companyHashId = "";
	        this.instanceHashId = "";
	        this.startDateTime = "";
	        this.endDateTime = "";
	        this.vehicleHashIdList = [];
	        this.driverHashIdList = [];
	        this.searchLicenceTagList = [];
	        this.searchDriverNameList = [];
	        this.searchCompanyList = [];
	        this.companyHashIdList = [];
	        this.searchSVGNameList = [];
	        this.sharedVehicleGroupHashIdList = [];
	        this.questionTypeList = [1, 2, 3, 4];
	        this.questionHashId = "";
	        this.questionName = "";
	        this.instanceName = "";
	        this.companyName = "";
	        this.svgName = "";
	        this.vehicleName = "";
	        this.driverName = "";
	        this.driverHashId = "";
	        this.vehicleHashId = "";
	    }
	    return PrePostQuestionSearchModel;
	}());
	exports.PrePostQuestionSearchModel = PrePostQuestionSearchModel;


/***/ },
/* 1037 */
/***/ function(module, exports) {

	module.exports = "<div class=\"content-wrapper\">\r\n  <section class=\"content-header\">\r\n    <div class=\"col-md-9 col-sm-6\">\r\n      <h1 class=\"pagename\">{{ 'LblPrePostTripQuestions' | translate }}</h1>\r\n      <ol class=\"breadcrumb\">\r\n        <li>\r\n          <a [routerLink]=\"urlDefaultPage\">\r\n            <i class=\"fa fa-dashboard\"></i> {{ 'LblHome' | translate }}</a>\r\n        </li>\r\n        <li class=\"active\">{{'LblPrePostTripQuestions' | translate }}</li>\r\n      </ol>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div class=\"page-border-bottom\">Border bottom shadow</div>\r\n    <div class=\"clearfix\"></div>\r\n  </section>\r\n  <section class=\"content\">\r\n    <div class=\"row\">\r\n      <div class=\"col-md-12\">\r\n        <wego-pre-post-search-filter (OnAdvancedReset)=\"OnAdvancedReset($event)\" (OnExport)=\"OnExport($event)\" (OnAdvancedSearch)=\"OnAdvancedSearch($event)\"\r\n          (OnPagingChange)=\"OnPagingChange($event)\" [ItemPerPage]=\"DataListModel.itemsPerPage\" [ErrorModel]=\"errorModel\"></wego-pre-post-search-filter>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('questionName')\">\r\n                  {{ 'LblName' | translate}}\r\n                  <wego-sort-list [FieldName]=\"'questionName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('questionType')\">\r\n                  {{ 'LblType' | translate}}\r\n                  <wego-sort-list [FieldName]=\"'questionType'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('instanceName')\">\r\n                  {{ 'LblInstance' | translate}}\r\n                  <wego-sort-list [FieldName]=\"'instanceName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('companyName')\">\r\n                  {{ 'LblCompany' | translate}}\r\n                  <wego-sort-list [FieldName]=\"'companyName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('sharedVehicleGroupName')\">\r\n                  {{ 'LblSVG' | translate}}\r\n                  <wego-sort-list [FieldName]=\"'sharedVehicleGroupName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('vehicleName')\">\r\n                  {{ 'LblVehicle' | translate}}\r\n                  <wego-sort-list [FieldName]=\"'vehicleName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('driverName')\">\r\n                  {{ 'LblDriver' | translate}}\r\n                  <wego-sort-list [FieldName]=\"'driverName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('answer')\">\r\n                  {{ 'LblAnswer' | translate}}\r\n                  <wego-sort-list [FieldName]=\"'answer'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('AnswerDateTimeUTC')\">\r\n                  {{ 'LblDate' | translate}}\r\n                  <wego-sort-list [FieldName]=\"'AnswerDateTimeUTC'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let item of prePostQuestionList\">\r\n                  <td style=\"display:block;width:120px; word-wrap:break-word;\">\r\n                    {{ item.questionName }}\r\n                  </td>\r\n                  <td>\r\n                    {{ item.questionType }}\r\n                  </td>\r\n                  <td>\r\n                    {{ item.instanceName }}\r\n                  </td>\r\n                  <td>\r\n                    {{ item.companyName }}\r\n                  </td>\r\n                  <td>\r\n                    {{ item.sharedVehicleGroupName }}\r\n                  </td>\r\n                  <td>\r\n                    {{ item.vehicleName }}\r\n                  </td>\r\n                  <td>\r\n                    {{ item.driverName }}\r\n                  </td>\r\n                  <td>\r\n                    <popover-content #myPopover placement=\"left\" [closeOnClickOutside]=\"true\">\r\n                      <b>\r\n                        <label> {{ 'LblBookingId' | translate }} : </label>\r\n                      </b>\r\n                      <span>\r\n                        <!--<i *ngIf=\"bookings.reccuringID\" class=\"fa fa-refresh fa-fw text-success\"></i>-->\r\n                        <a *ngIf=\"item.isBookingOverviewAccess\" [routerLink]=\"urlBookingInformation+'/'+ item.bookingHashId\">\r\n                          {{ item.bookingId }}\r\n                        </a>\r\n                        <label *ngIf=\"!item.isBookingOverviewAccess\" style=\"font-weight: normal\"> {{ item.bookingId }} </label>\r\n                        <br/>\r\n                      </span>\r\n                      <b>{{ 'LblRemarks' | translate }} : </b>\r\n                      <label *ngIf=\"item.remark\" style=\"font-weight: normal\">{{item.remark}}</label>\r\n                    </popover-content>\r\n\r\n                    <a *ngIf=\"editItem!=item\" popover-placement=\"left\" [popover]=\"myPopover\" style=\"cursor:pointer;\">\r\n                      <span style=\"display:block;width:100px; word-wrap:break-word;\">\r\n                        <a>{{ item.answer}} </a>\r\n                      </span>\r\n                    </a>\r\n                    <span *ngIf=\"editItem==item\" style=\"display:block;width:100px; word-wrap:break-word;\">\r\n                        <input style=\"border: none\" type=\"text\" [(ngModel)]=\"editText\"/>\r\n                    </span>\r\n                    <a *ngIf=\"editItem != item\" class=\"cursor-pointer\" (click)=\"editItem = item; editText=item.answer;\">\r\n                      <i class=\"fa fa-edit\"></i>\r\n                    </a>\r\n                    <a *ngIf=\"editItem==item\" class=\"cursor-pointer\" (click)=\"item.answer = editText;editItem= null;\">\r\n                      <i class=\"fa fa-check\"></i>\r\n                    </a>\r\n                    <a *ngIf=\"editItem==item\" class=\"cursor-pointer\" (click)=\"editText=null;editItem=null;\">\r\n                      <i class=\"fa fa-close\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td>\r\n                    {{ item.answerDateTime }}\r\n                  </td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"12\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n";

/***/ },
/* 1038 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var config_1 = __webpack_require__(60);
	var router_1 = __webpack_require__(26);
	var common_1 = __webpack_require__(22);
	var privacy_popup_service_1 = __webpack_require__(640);
	var terms_condition_model_1 = __webpack_require__(1022);
	var enum_helper_1 = __webpack_require__(578);
	var ViewPrivacyStatementPopupComponent = (function () {
	    function ViewPrivacyStatementPopupComponent(authService, locationService, router, activeRoute, termsConditionPopup) {
	        this.authService = authService;
	        this.locationService = locationService;
	        this.router = router;
	        this.activeRoute = activeRoute;
	        this.termsConditionPopup = termsConditionPopup;
	        this.isLoading = false;
	    }
	    ViewPrivacyStatementPopupComponent.prototype.ngOnInit = function () {
	        this.termsConditionActivityLogModel = new terms_condition_model_1.TermsConditionActivityLog();
	        this.urlTermsAndConditionPopup = this.authService.GetURL(config_1.ApplicationRouteURL.URL_PRIVACY_STATEMENT_POPUP);
	        this.CheckAccountActivationTermsConditionStatus();
	    };
	    ViewPrivacyStatementPopupComponent.prototype.CheckAccountActivationTermsConditionStatus = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.authService.CheckAccountActivationPrivacyStatus().subscribe(function (res) {
	            var isAccepted = res.data.accepted;
	            if (!isAccepted) {
	                _this.bodyHTMLText = res.data.content;
	                _this.termsAndConditionHashId = res.data.termsAndConditionsHashId;
	            }
	            else {
	                _this.NavigateTo();
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    ViewPrivacyStatementPopupComponent.prototype.NavigateTo = function () {
	        this.router.navigate(['/driver']);
	    };
	    ViewPrivacyStatementPopupComponent.prototype.OnRejectClick = function (action) {
	        this.ActionOnAccountActivationTermsCondition(this.termsAndConditionHashId, enum_helper_1.TNCAction.REJECTED);
	    };
	    ViewPrivacyStatementPopupComponent.prototype.Logout = function () {
	        this.authService.Logout();
	        this.router.navigate(['/']);
	    };
	    ViewPrivacyStatementPopupComponent.prototype.OnAcceptClick = function (action) {
	        this.ActionOnAccountActivationTermsCondition(this.termsAndConditionHashId, enum_helper_1.TNCAction.ACCEPTED);
	    };
	    ViewPrivacyStatementPopupComponent.prototype.ActionOnAccountActivationTermsCondition = function (tncHashId, action) {
	        var _this = this;
	        this.termsConditionPopup
	            .ActionOnAccountActivationTermsCondition(tncHashId, action)
	            .subscribe(function (res) {
	            if (action == enum_helper_1.TNCAction.ACCEPTED) {
	                _this.NavigateTo();
	            }
	            else {
	                _this.Logout();
	            }
	            console.log('Privacy Statement updated successfully');
	        }, function (error) { });
	    };
	    ViewPrivacyStatementPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'Wego-Popup-PrivacyStatement',
	            template: __webpack_require__(1039),
	            providers: [privacy_popup_service_1.PrivacyStatementPopup]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _d) || Object, (typeof (_e = typeof privacy_popup_service_1.PrivacyStatementPopup !== 'undefined' && privacy_popup_service_1.PrivacyStatementPopup) === 'function' && _e) || Object])
	    ], ViewPrivacyStatementPopupComponent);
	    return ViewPrivacyStatementPopupComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.ViewPrivacyStatementPopupComponent = ViewPrivacyStatementPopupComponent;


/***/ },
/* 1039 */
/***/ function(module, exports) {

	module.exports = "<section class=\"login-bg\">\r\n    <div class=\"wrapper\" style=\"background-color: transparent;\">\r\n      <div class=\"container\" style=\"margin-top:120px\">\r\n        <div class=\"row\">\r\n          <div class=\"col-sm-5 login-center\">\r\n            <div class=\"login-panel panel-default privacy\">\r\n              <div>\r\n                <form (ngSubmit)=\"onSubmit()\" #loginForm=\"ngForm\" method=\"post\">\r\n                  <fieldset>\r\n                    <div class=\"row\">\r\n                      <div class=\"center-block\">\r\n                        <h1 class=\"text-center login-text\" style=\"color:#fff;\">{{ 'LblPrivacyStatements' | translate }}</h1>\r\n                      </div>\r\n                    </div>\r\n                    <div class=\"row\">\r\n                      <div class=\"col-xs-12 col-sm-10 col-sm-offset-1\">\r\n                        <span [innerHTML]=\"bodyHTMLText\" style=\"color:#fff; text-align: left;\"></span>\r\n                      </div>\r\n                      <br/><br/>\r\n                     \r\n                      <div class=\"checkbox col-xs-12 col-sm-8 col-sm-offset-2\" style=\"text-align: center\">\r\n                       <a class=\"btn btn-green cursor-pointer\" (click)=\"OnAcceptClick()\">{{ 'LblAccept' | translate }}</a> &nbsp;&nbsp;\r\n                       <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnRejectClick()\">{{ 'LblReject' | translate }}</a> &nbsp;&nbsp;\r\n                      </div>\r\n                    </div>\r\n                  </fieldset>\r\n                </form>\r\n              </div>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    </section>";

/***/ },
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var auth_service_1 = __webpack_require__(58);
	var config_1 = __webpack_require__(60);
	var router_1 = __webpack_require__(26);
	var credit_card_payment_service_1 = __webpack_require__(1041);
	var CreditCardPaymentSuccessComponent = (function () {
	    function CreditCardPaymentSuccessComponent(authService, creditCardPaymentService, activeRoute, router) {
	        this.authService = authService;
	        this.creditCardPaymentService = creditCardPaymentService;
	        this.activeRoute = activeRoute;
	        this.router = router;
	    }
	    CreditCardPaymentSuccessComponent.prototype.ngOnInit = function () {
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	    };
	    CreditCardPaymentSuccessComponent.prototype.onSubmit = function () {
	        var urlBookingOverview = this.authService.GetURL(config_1.ApplicationRouteURL.URL_BOOKING_OVERVIEW);
	        this.router.navigate([urlBookingOverview]);
	    };
	    CreditCardPaymentSuccessComponent = __decorate([
	        core_1.Component({
	            selector: "wego-creditcard-payment-success",
	            template: __webpack_require__(1042),
	            providers: [credit_card_payment_service_1.CreditCardPaymentService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof credit_card_payment_service_1.CreditCardPaymentService !== 'undefined' && credit_card_payment_service_1.CreditCardPaymentService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object])
	    ], CreditCardPaymentSuccessComponent);
	    return CreditCardPaymentSuccessComponent;
	    var _a, _b, _c, _d;
	}());
	exports.CreditCardPaymentSuccessComponent = CreditCardPaymentSuccessComponent;


/***/ },
/* 1041 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var config_1 = __webpack_require__(60);
	var auth_service_1 = __webpack_require__(58);
	var http_1 = __webpack_require__(59);
	var CreditCardPaymentService = (function () {
	    //private JQueryHelper: JQueryHelperService = new JQueryHelperService();
	    function CreditCardPaymentService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    CreditCardPaymentService.prototype.GetVerifyRedirectedUrlForPayment = function (transactionId) {
	        var getVerifyRedirectedUrlForPaymentUrl = config_1.WeGoConfig.API_GET_VERIFY_REDIRECT_FOR_PAYMENT;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        getVerifyRedirectedUrlForPaymentUrl =
	            getVerifyRedirectedUrlForPaymentUrl +
	                "?transactionKey=" +
	                transactionId;
	        return this.http
	            .post(getVerifyRedirectedUrlForPaymentUrl, transactionId, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    CreditCardPaymentService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], CreditCardPaymentService);
	    return CreditCardPaymentService;
	    var _a, _b;
	}());
	exports.CreditCardPaymentService = CreditCardPaymentService;


/***/ },
/* 1042 */
/***/ function(module, exports) {

	module.exports = "<section class=\"banner-img-in\">\r\n  <div class=\"banner-in\">\r\n    <div class=\"search-bg-in\">\r\n      <div class=\"container-fluid\">\r\n        <div class=\"row\" style=\"padding-right:15px;\">\r\n          <div class=\"col-md-3 col-sm-6\">\r\n            <h2 class=\"pagename\">{{ 'LblPaymentSuccess' | translate }}</h2>\r\n          </div>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n\r\n<div class=\"clearfix\"></div>\r\n<section class=\"content\">\r\n  <div class=\"container-fluid\">\r\n    <div class=\"row\">\r\n      <div class=\"col-sm-12\">\r\n        <h3>\r\n          <i class=\"fa fa-check\" aria-hidden=\"true\" style=\"color: green\"></i>\r\n          Awesome!!</h3>\r\n          {{ 'LblCompletedSuccess' | translate}}\r\n      </div>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <br/>\r\n    <br/>\r\n    <div>\r\n      <button class=\"btn btn-confirm btn-md mar-right-5\" (click)=\"onSubmit()\">{{ 'LblOK' | translate }}</button>\r\n    </div>\r\n  </div>\r\n</section>";

/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var auth_service_1 = __webpack_require__(58);
	var config_1 = __webpack_require__(60);
	var router_1 = __webpack_require__(26);
	var CreditCardPaymentFailureComponent = (function () {
	    function CreditCardPaymentFailureComponent(authService, router) {
	        this.authService = authService;
	        this.router = router;
	    }
	    CreditCardPaymentFailureComponent.prototype.ngOnInit = function () {
	        this.urlDefaultPage = this.authService.GetURL(config_1.ApplicationRouteURL.URL_DEFAULT_PAGE);
	    };
	    CreditCardPaymentFailureComponent.prototype.onClickOk = function () {
	        var urlBookingOverview = this.authService.GetURL(config_1.ApplicationRouteURL.URL_BOOKING);
	        this.router.navigate([urlBookingOverview]);
	    };
	    CreditCardPaymentFailureComponent = __decorate([
	        core_1.Component({
	            selector: "wego-creditcard-payment-failure",
	            template: __webpack_require__(1044)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object])
	    ], CreditCardPaymentFailureComponent);
	    return CreditCardPaymentFailureComponent;
	    var _a, _b;
	}());
	exports.CreditCardPaymentFailureComponent = CreditCardPaymentFailureComponent;


/***/ },
/* 1044 */
/***/ function(module, exports) {

	module.exports = "<section class=\"banner-img-in\">\r\n  <div class=\"banner-in\">\r\n    <div class=\"search-bg-in\">\r\n      <div class=\"container-fluid\">\r\n        <div class=\"row\" style=\"padding-right:15px;\">\r\n          <div class=\"col-md-3 col-sm-6\">\r\n            <h2 class=\"pagename\">{{ 'LblPaymentFailure' | translate }}</h2>\r\n          </div>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n\r\n<div class=\"clearfix\"></div>\r\n<section class=\"content\">\r\n  <div class=\"container-fluid\">\r\n    <div class=\"row\">\r\n      <div class=\"col-sm-12\">\r\n        <h3>\r\n          <i class=\"fa fa-close\" aria-hidden=\"true\" style=\"color: red\"></i>\r\n          Oooops!</h3>\r\n        {{ 'LblCompletedFailure' | translate}}\r\n      </div>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <br/>\r\n    <br/>\r\n    <div>\r\n      <button class=\"btn btn-confirm btn-md mar-right-5\" (click)=\"onClickOk()\">{{ 'LblOK' | translate }}</button>\r\n    </div>\r\n  </div>\r\n</section>";

/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var config_1 = __webpack_require__(60);
	var router_1 = __webpack_require__(26);
	var TwoFa_service_1 = __webpack_require__(1046);
	var TwoFASelectionPopupComponent = (function () {
	    function TwoFASelectionPopupComponent(authService, router, TwoFAService) {
	        this.authService = authService;
	        this.router = router;
	        this.TwoFAService = TwoFAService;
	        this.isLoading = false;
	        this.selectedTwoFa = "EMAIL";
	    }
	    TwoFASelectionPopupComponent.prototype.ngOnInit = function () {
	        this.TwoFa_method = this.authService.getTwoFaMethod();
	        if (this.TwoFa_method == "ALL") {
	            this.selectedTwoFa == "EMAIL";
	        }
	        else {
	            this.selectedTwoFa = this.TwoFa_method;
	        }
	    };
	    TwoFASelectionPopupComponent.prototype.NavigateTo = function () {
	        if (this.selectedTwoFa == "GOOGLE") {
	            this.router.navigate([config_1.ApplicationRouteURL.URL_TWO_FA_GOOGLE_SETUP]);
	        }
	        else {
	            this.SendEmailOTP();
	        }
	    };
	    TwoFASelectionPopupComponent.prototype.SendEmailOTP = function () {
	        var _this = this;
	        this.TwoFAService.SendEmailOTP()
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.router.navigate([config_1.ApplicationRouteURL.URL_TWO_FA_EMAIL_OTP]);
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    TwoFASelectionPopupComponent.prototype.Logout = function () {
	        this.authService.Logout();
	        this.router.navigate(['/']);
	    };
	    TwoFASelectionPopupComponent.prototype.OnAcceptClick = function (action) {
	    };
	    TwoFASelectionPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'Wego-Popup-two-fa-selection',
	            template: __webpack_require__(1047),
	            providers: [auth_service_1.AuthService, TwoFa_service_1.TwoFAService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof TwoFa_service_1.TwoFAService !== 'undefined' && TwoFa_service_1.TwoFAService) === 'function' && _c) || Object])
	    ], TwoFASelectionPopupComponent);
	    return TwoFASelectionPopupComponent;
	    var _a, _b, _c;
	}());
	exports.TwoFASelectionPopupComponent = TwoFASelectionPopupComponent;


/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var http_1 = __webpack_require__(59);
	var config_1 = __webpack_require__(60);
	var TwoFAService = (function () {
	    function TwoFAService(authService, http) {
	        this.authService = authService;
	        this.http = http;
	    }
	    TwoFAService.prototype.GetTwoFaGoogleSetup = function () {
	        var getTwoFaUrl = config_1.WeGoConfig.API_GET_TWOFA_GOOGLE_SETUP_DETAILS;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getTwoFaUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    TwoFAService.prototype.VerifyTwoFaTotp = function (totp) {
	        var getTwoFaUrl = config_1.WeGoConfig.API_VERIFY_TWOFA_TOTP;
	        getTwoFaUrl = getTwoFaUrl + "?totp=" + totp;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getTwoFaUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    TwoFAService.prototype.SendEmailOTP = function () {
	        var getTwoFaUrl = config_1.WeGoConfig.API_SEND_TWOFA_EMAIL_CODE;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getTwoFaUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    TwoFAService.prototype.VerifyTwoFaEmailOtp = function (totp) {
	        var getTwoFaUrl = config_1.WeGoConfig.API_VERIFY_EMAIL_CODE;
	        getTwoFaUrl = getTwoFaUrl + "?otp=" + totp;
	        var headers = this.authService.GetHeader();
	        var options = new http_1.RequestOptions({ headers: headers });
	        return this.http
	            .get(getTwoFaUrl, options)
	            .map(this.authService.HandleAPIResponse)
	            .catch(this.authService.HandleAPIError);
	    };
	    TwoFAService = __decorate([
	        core_1.Injectable(), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof http_1.Http !== 'undefined' && http_1.Http) === 'function' && _b) || Object])
	    ], TwoFAService);
	    return TwoFAService;
	    var _a, _b;
	}());
	exports.TwoFAService = TwoFAService;


/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div>\r\n  <section class=\"login-bg\">\r\n    <div class=\"wrapper\">\r\n      <div class=\"container\" style=\"margin-top:120px\">\r\n        <div class=\"row\">\r\n          <div class=\"col-sm-6 login-center\">\r\n            <div class=\"login-panel panel-default\">\r\n              <form #loginForm=\"ngForm\" method=\"post\">\r\n                <fieldset>\r\n                  <div class=\"row\">\r\n                    <div class=\"center-block\">\r\n                      <img src=\"" + __webpack_require__(634) + "\" alt=\"\" class=\"img-responsive login-profile-img\">\r\n                      <div class=\"text-center login-text\" style=\"color:#fff; line-height: 25px; font-size: 17px;\">{{\r\n                        'LblTwoFaMethodSelect' | translate }}</div>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\">\r\n                    <div class=\"col-xs-12 col-sm-8 col-sm-offset-2\">\r\n                      <div class=\"form-group col-md-12\">\r\n                        <div *ngIf=\"TwoFa_method=='ALL' || TwoFa_method=='EMAIL' \" class=\"radio\"><label style=\"color:#fff;\"><input\r\n                              type=\"radio\" name=\"selectedTwoFa\" [(ngModel)]=\"selectedTwoFa\" value=\"EMAIL\"> {{\r\n                            'LblEmailAuthentication' | translate }}</label></div>\r\n                        <div *ngIf=\"TwoFa_method=='ALL' || TwoFa_method=='GOOGLE' \" class=\"radio\"><label style=\"color:#fff;\"><input\r\n                              type=\"radio\" name=\"selectedTwoFa\" [(ngModel)]=\"selectedTwoFa\" value=\"GOOGLE\"> {{\r\n                            'LblGoogleAuthenticator' | translate }}</label></div>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"clearfix\"></div>\r\n                  <div class=\"form-group col-xs-12 text-center\">\r\n                    <button class=\"btn btn-green\" (click)=\"NavigateTo()\">{{ 'LblContinue' | translate }}</button>\r\n                    <button class=\"btn btn-green\" type=\"button\" (click)=\"Logout()\">{{ 'LblSignOut' | translate }}</button>\r\n                  </div>\r\n\r\n                </fieldset>\r\n              </form>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>";

/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var common_1 = __webpack_require__(22);
	var TwoFa_service_1 = __webpack_require__(1046);
	var translate_1 = __webpack_require__(631);
	var TwoFAGoogleSetupPopupComponent = (function () {
	    function TwoFAGoogleSetupPopupComponent(authService, router, TwoFAService, translate, locationService) {
	        this.authService = authService;
	        this.router = router;
	        this.TwoFAService = TwoFAService;
	        this.translate = translate;
	        this.locationService = locationService;
	        this.isLoading = false;
	        this.totp = "";
	    }
	    TwoFAGoogleSetupPopupComponent.prototype.ngOnInit = function () {
	        this.getTwoFASetup();
	    };
	    TwoFAGoogleSetupPopupComponent.prototype.OnSubmit = function (forms) {
	        var _this = this;
	        this.TwoFAService.VerifyTwoFaTotp(this.totp)
	            .subscribe(function (res) {
	            if (res.data) {
	                var role = localStorage.getItem('current_role');
	                if (role.toUpperCase() == 'WEGOADMIN') {
	                    _this.router.navigate(['/wegoadmin']);
	                }
	                else if (role.toUpperCase() == 'ADMIN') {
	                    _this.router.navigate(['/admin']);
	                }
	            }
	            else {
	                _this.errorMessage = res.error;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    TwoFAGoogleSetupPopupComponent.prototype.OnBackClick = function () {
	        this.locationService.back();
	    };
	    TwoFAGoogleSetupPopupComponent.prototype.getTwoFASetup = function () {
	        var _this = this;
	        this.TwoFAService.GetTwoFaGoogleSetup()
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.googleSetupCode = res.data;
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    TwoFAGoogleSetupPopupComponent.prototype.NavigateTo = function () {
	        this.router.navigate(['/privacystatement/popup']);
	    };
	    TwoFAGoogleSetupPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'Wego-Popup-two-fa-google-setup',
	            template: __webpack_require__(1049),
	            providers: [TwoFa_service_1.TwoFAService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof TwoFa_service_1.TwoFAService !== 'undefined' && TwoFa_service_1.TwoFAService) === 'function' && _c) || Object, (typeof (_d = typeof translate_1.TranslateService !== 'undefined' && translate_1.TranslateService) === 'function' && _d) || Object, (typeof (_e = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _e) || Object])
	    ], TwoFAGoogleSetupPopupComponent);
	    return TwoFAGoogleSetupPopupComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.TwoFAGoogleSetupPopupComponent = TwoFAGoogleSetupPopupComponent;


/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div>\r\n  <section class=\"login-bg\">\r\n    <div class=\"wrapper\">\r\n      <div class=\"container\" style=\"margin-top:120px\">\r\n        <div class=\"row\">\r\n          <div class=\"col-sm-5 login-center\">\r\n            <div class=\"login-panel panel-default\">\r\n              <form #loginForm=\"ngForm\" (ngSubmit)=\"OnSubmit()\" method=\"post\">\r\n                <fieldset>\r\n                  <div class=\"row\">\r\n                    <div class=\"center-block\">\r\n                      <img *ngIf=\"!(googleSetupCode && googleSetupCode.secretKey)\" src=\"" + __webpack_require__(634) + "\"\r\n                        alt=\"\" class=\"img-responsive login-profile-img\">\r\n                      <h2 class=\"text-center login-text\" style=\"color:#fff;\">{{\r\n                        'LblGoogleAuthenticator' | translate }}</h2>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row text-center\" *ngIf=\"googleSetupCode && googleSetupCode.secretKey\">\r\n                    <img [src]=\"googleSetupCode.secretKeyQRCodeURL\" class=\"img-thumbnail\" style=\"height: 150px\">\r\n                    <div class=\"clearfix\"></div>\r\n                    <div class=\"text-center login-text lead\" style=\"color:#fff;\">\r\n                      <label>{{ 'LblManualSecretKey' | translate }}</label>: &nbsp; <label>{{googleSetupCode.secretKey}}</label>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"clearfix\"></div>\r\n                  <div class=\"row\" style=\"margin: 10px;\">\r\n                    <label class=\"login-text\" style=\"color:#fff;\">{{ 'LblEnterTotp' | translate }} </label>\r\n                    <div class=\"clearfix\"></div>\r\n                    <div class=\"input-group\">\r\n                      <span class=\"input-group-addon\">\r\n                        <i class=\"fa fa-key fa-fw\" aria-hidden=\"true\"></i>\r\n                      </span>\r\n                      <input [(ngModel)]=\"totp\" class=\"login-form-control\" placeholder=\"TOTP\" name=\"totp\" type=\"text\"\r\n                        maxlength=\"6\" autofocus>\r\n                    </div>\r\n                    <div class=\"form-group\">\r\n                      <p *ngIf=\"errorMessage\" style=\"background-color: #eb4b4b; color: white; padding: 5px;\" class=\"text-center\">\r\n                        {{ errorMessage }}\r\n                      </p>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"clearfix\"></div>\r\n                  <div class=\"form-group col-xs-12 text-center\">\r\n                    <button class=\"btn btn-green\" type=\"button\" (click)=\"OnBackClick()\">{{ 'LblBack' | translate }}</button>\r\n                    <button class=\"btn btn-green\" type=\"submit\">{{ 'LblSubmit' | translate }}</button>\r\n                  </div>\r\n                  <div class=\"clearfix\"></div>\r\n                </fieldset>\r\n              </form>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>";

/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var common_1 = __webpack_require__(22);
	var TwoFa_service_1 = __webpack_require__(1046);
	var translate_1 = __webpack_require__(631);
	var TwoFAEmailOTPPopupComponent = (function () {
	    function TwoFAEmailOTPPopupComponent(authService, router, TwoFAService, translate, locationService) {
	        this.authService = authService;
	        this.router = router;
	        this.TwoFAService = TwoFAService;
	        this.translate = translate;
	        this.locationService = locationService;
	        this.isLoading = false;
	        this.totp = "";
	    }
	    TwoFAEmailOTPPopupComponent.prototype.ngOnInit = function () {
	        // this.SendOTP();
	    };
	    TwoFAEmailOTPPopupComponent.prototype.OnSubmit = function (forms) {
	        var _this = this;
	        this.TwoFAService.VerifyTwoFaEmailOtp(this.totp)
	            .subscribe(function (res) {
	            if (res.data) {
	                var role = localStorage.getItem('current_role');
	                if (role.toUpperCase() == 'WEGOADMIN') {
	                    _this.router.navigate(['/wegoadmin']);
	                }
	                else if (role.toUpperCase() == 'ADMIN') {
	                    _this.router.navigate(['/admin']);
	                }
	            }
	            else {
	                _this.errorMessage = res.error;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    TwoFAEmailOTPPopupComponent.prototype.ResendOTP = function () {
	        this.SendOTP();
	    };
	    TwoFAEmailOTPPopupComponent.prototype.OnBackClick = function () {
	        this.locationService.back();
	    };
	    TwoFAEmailOTPPopupComponent.prototype.SendOTP = function () {
	        var _this = this;
	        this.TwoFAService.SendEmailOTP()
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.googleSetupCode = res.data;
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    TwoFAEmailOTPPopupComponent.prototype.NavigateTo = function () {
	        this.router.navigate(['/privacystatement/popup']);
	    };
	    TwoFAEmailOTPPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'Wego-Popup-two-fa-email-otp',
	            template: __webpack_require__(1051),
	            providers: [TwoFa_service_1.TwoFAService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof TwoFa_service_1.TwoFAService !== 'undefined' && TwoFa_service_1.TwoFAService) === 'function' && _c) || Object, (typeof (_d = typeof translate_1.TranslateService !== 'undefined' && translate_1.TranslateService) === 'function' && _d) || Object, (typeof (_e = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _e) || Object])
	    ], TwoFAEmailOTPPopupComponent);
	    return TwoFAEmailOTPPopupComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.TwoFAEmailOTPPopupComponent = TwoFAEmailOTPPopupComponent;


/***/ },
/* 1051 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div>\r\n  <section class=\"login-bg\">\r\n    <div class=\"wrapper\">\r\n      <div class=\"container\" style=\"margin-top:120px\">\r\n        <div class=\"row\">\r\n          <div class=\"col-sm-5 login-center\">\r\n            <div class=\"login-panel panel-default\">\r\n              <form #loginForm=\"ngForm\" (ngSubmit)=\"OnSubmit()\" method=\"post\">\r\n                <fieldset>\r\n                  <div class=\"row\">\r\n                    <div class=\"center-block\">\r\n                      <img src=\"" + __webpack_require__(634) + "\" alt=\"\" class=\"img-responsive login-profile-img\">\r\n                      <h2 class=\"text-center login-text\" style=\"color:#fff;\">{{\r\n                        'LblEmailAuthentication' | translate }}</h2>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"row\" style=\"margin: 10px;\">\r\n                    <p style=\"color:#fff;\">{{ 'LblEmailOtpSent' | translate }}</p>\r\n                    <label class=\"login-text\" style=\"color:#fff;\">{{ 'LblEnterOtp' | translate }} </label>\r\n                    <div class=\"clearfix\"></div>\r\n                    <div class=\"input-group\">\r\n                      <span class=\"input-group-addon\">\r\n                        <i class=\"fa fa-key fa-fw\" aria-hidden=\"true\"></i>\r\n                      </span>\r\n                      <input [(ngModel)]=\"totp\" class=\"login-form-control\" placeholder=\"OTP\" name=\"otp\" type=\"text\"\r\n                        maxlength=\"10\" autofocus>\r\n                    </div>\r\n                    <div class=\"form-group\">\r\n                      <p *ngIf=\"errorMessage\" style=\"background-color: #eb4b4b; color: white; padding: 5px;\" class=\"text-center\">\r\n                        {{ errorMessage }}\r\n                      </p>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"clearfix\"></div>\r\n                  <div class=\"form-group col-xs-12 text-center\">\r\n                    <button class=\"btn btn-green\" type=\"button\" (click)=\"OnBackClick()\">{{'LblBack' |translate }}</button>\r\n                    <button class=\"btn btn-green\" type=\"button\" (click)=\"ResendOTP()\">{{'LblResend' |translate }}</button>\r\n                    <button class=\"btn btn-green\" type=\"submit\">{{ 'LblSubmit' | translate }}</button>\r\n                  </div>\r\n                  <div class=\"clearfix\"></div>\r\n                </fieldset>\r\n              </form>\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </section>\r\n</div>\r\n<wego-lodder [isLoading]=\"isLoading\"></wego-lodder>";

/***/ },
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_guard_admin_service_1 = __webpack_require__(25);
	var core_1 = __webpack_require__(3);
	var AppComponent = (function () {
	    function AppComponent(adminAuthGuard) {
	        this.adminAuthGuard = adminAuthGuard;
	        this.isLoading = false;
	    }
	    AppComponent.prototype.ngOnInit = function () {
	        this.HandleRoutingLoader();
	    };
	    AppComponent.prototype.HandleRoutingLoader = function () {
	        var _this = this;
	        this.sub = this.adminAuthGuard.GetLoaderStatus().subscribe(function (data) {
	            _this.isLoading = data;
	        }, function (err) {
	            console.log(err);
	        }, function () {
	            console.log("finished");
	        });
	    };
	    AppComponent.prototype.ngOnDestroy = function () {
	        if (this.sub) {
	            this.sub.unsubscribe();
	        }
	    };
	    AppComponent = __decorate([
	        core_1.Component({
	            selector: "wego-app",
	            template: "<router-outlet></router-outlet>\n  <wego-lodder [isLoading]=\"isLoading\"></wego-lodder>\n  "
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_guard_admin_service_1.AdminAuthGuard !== 'undefined' && auth_guard_admin_service_1.AdminAuthGuard) === 'function' && _a) || Object])
	    ], AppComponent);
	    return AppComponent;
	    var _a;
	}());
	exports.AppComponent = AppComponent;


/***/ },
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(1054));
	__export(__webpack_require__(1058));
	__export(__webpack_require__(1059));
	__export(__webpack_require__(1060));


/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_1 = __webpack_require__(631);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var NavbarComponent = (function () {
	    function NavbarComponent(router, authService, translateService) {
	        this.router = router;
	        this.authService = authService;
	        this.translateService = translateService;
	        this.toggleMenu = new core_1.EventEmitter();
	        this.unreadNotification = 0;
	        this.roleLevel = config_1.RoleLevel;
	    }
	    NavbarComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        this.GetUserSetting();
	        this.urlPersonUpdate = this.authService.GetURL(config_1.ApplicationRouteURL.URL_USER_PROFILE_UPDATE);
	        this.intervalHandler = setInterval(function () { return _this.GetNotificationCount(); }, (config_1.WeGoConfig.NOTIFICATION_REFRESH_INTERVAL_SEC * 1000));
	        this.GetNotificationCount();
	        switch (this.translateService.currentLang) {
	            case "en": {
	                this.language = "En";
	                this.languageLbl = "EN";
	                break;
	            }
	            case "nl": {
	                this.language = "Du";
	                this.languageLbl = "NL";
	                break;
	            }
	            case "de": {
	                this.language = "De";
	                this.languageLbl = "DE";
	                break;
	            }
	            case "fr": {
	                this.language = "Fr";
	                this.languageLbl = "FR";
	                break;
	            }
	            case "pl": {
	                this.language = "Pl";
	                this.languageLbl = "PL";
	                break;
	            }
	            case "pt": {
	                this.language = "Pt";
	                this.languageLbl = "PT";
	                break;
	            }
	            default: {
	                this.language = "Es";
	                this.languageLbl = "Lbl";
	                break;
	            }
	        }
	    };
	    NavbarComponent.prototype.Logout = function () {
	        this.SignOut();
	        this.authService.Logout();
	        this.router.navigate(['/']);
	    };
	    NavbarComponent.prototype.GetUserSetting = function () {
	        var userSetting = this.authService.GetUserSetting();
	        if (userSetting) {
	            this.firstName = userSetting.firstName;
	            this.lastName = userSetting.lastName;
	            this.middleName = userSetting.middleName;
	            this.highestEntityLevelRole = userSetting.highestEntityLevelRole;
	        }
	        var userRole = this.authService.GetCurrentRole();
	        if (userRole) {
	            this.currentRole = userRole;
	        }
	        var personHashId = this.authService.GetPersonHashId();
	        if (personHashId) {
	            this.personHashId = personHashId;
	        }
	    };
	    NavbarComponent.prototype.Profile = function () {
	        this.router.navigate(['/']);
	    };
	    NavbarComponent.prototype.ToggleMenuLocal = function ($event) {
	        this.toggleMenu.emit($event);
	    };
	    NavbarComponent.prototype.SignOut = function () {
	        this.authService.Signout()
	            .subscribe(function (res) {
	            console.log(res);
	        }, function (error) {
	            console.log(error);
	        });
	    };
	    NavbarComponent.prototype.GetNotificationCount = function () {
	        var _this = this;
	        this.authService.GetNotificationCount()
	            .subscribe(function (res) {
	            _this.unreadNotification = res.data;
	            console.log(_this.unreadNotification);
	        }, function (error) {
	            console.log(error);
	        });
	    };
	    NavbarComponent.prototype.ResetNotificationCount = function () {
	        var _this = this;
	        this.authService.ResetNotificationCount()
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.unreadNotification = 0;
	            }
	            var url = _this.authService.GetURL(config_1.ApplicationRouteURL.URL_INBOX_PAGE);
	            _this.router.navigate([url, { v: Date.now() }]);
	            //console.log(this.unreadNotification);
	        }, function (error) {
	            console.log(error);
	        });
	    };
	    NavbarComponent.prototype.ChangeCurrentLanguage = function (language) {
	        var _this = this;
	        if (language != 'de') {
	            this.authService.UpdateUserLanguagePreference(language)
	                .subscribe(function (res) {
	            }, function (error) {
	                _this.authService.HandleErrorStatusCode(error);
	            }, function () {
	                localStorage.setItem("language", language);
	                //this.translateService.setDetectedLang();
	                switch (_this.translateService.currentLang) {
	                    case "en": {
	                        _this.language = "En";
	                        _this.languageLbl = "EN";
	                        break;
	                    }
	                    case "nl": {
	                        _this.language = "Du";
	                        _this.languageLbl = "NL";
	                        break;
	                    }
	                    case "de": {
	                        _this.language = "De";
	                        _this.languageLbl = "DE";
	                        break;
	                    }
	                    case "fr": {
	                        _this.language = "Fr";
	                        _this.languageLbl = "FR";
	                        break;
	                    }
	                    case "pl": {
	                        _this.language = "Pl";
	                        _this.languageLbl = "PL";
	                        break;
	                    }
	                    case "pt": {
	                        _this.language = "Pt";
	                        _this.languageLbl = "PT";
	                        break;
	                    }
	                    default: {
	                        _this.language = "Es";
	                        _this.languageLbl = "Lbl";
	                        break;
	                    }
	                }
	                location.reload(true);
	            });
	        }
	        else {
	            localStorage.setItem("language", language);
	            //this.translateService.setDetectedLang();
	            this.language = "Es";
	            this.languageLbl = "Lbl";
	            location.reload(true);
	        }
	        //this.router.navigate(['/']);
	    };
	    NavbarComponent.prototype.ngOnDestroy = function () {
	        if (this.intervalHandler) {
	            clearInterval(this.intervalHandler);
	        }
	    };
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], NavbarComponent.prototype, "toggleMenu", void 0);
	    NavbarComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-navbar',
	            template: __webpack_require__(1055),
	            styles: [
	                "\n    .main-header .logo,\n    .main-header .logo:hover{\n      background-color: #fff;\n      border-bottom: 1px solid #E2E2E2;\n      padding: 0px;\n    }\n    .logo-lg{\n      padding-left: 5px;\n    }\n    "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof translate_1.TranslateService !== 'undefined' && translate_1.TranslateService) === 'function' && _c) || Object])
	    ], NavbarComponent);
	    return NavbarComponent;
	    var _a, _b, _c;
	}());
	exports.NavbarComponent = NavbarComponent;


/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<header class=\"main-header\">\r\n  <!-- Logo -->\r\n  <a href=\"javascript:void(0)\" class=\"logo\">\r\n    <!-- mini logo for sidebar mini 50x50 pixels -->\r\n    <div class=\"logo-mini\">\r\n      <!--<figure><img src=\"../../../../public/images/wego-logo-small.png\" alt=\"\" class=\"img-responsive\" style=\"height: 54px; max-width: 65px;\"></figure>-->\r\n    </div>\r\n    <!-- logo for regular state and mobile devices -->\r\n    <div class=\"logo-lg\">\r\n      <!--<figure><img src=\"../../../../public/images/wego-logo-big.png\" alt=\"\" class=\"img-responsive\" style=\"height: 58px;  max-width: 255px;\"></figure>-->\r\n    </div>\r\n  </a>\r\n  <!-- Header Navbar: style can be found in header.less -->\r\n  <nav class=\"navbar navbar-static-top\">\r\n    <!-- Sidebar toggle button-->\r\n    <a (click)=\"ToggleMenuLocal($event)\" class=\"sidebar-toggle\" data-toggle=\"offcanvas\" role=\"button\">\r\n      <span class=\"sr-only\">Toggle navigation</span>\r\n      <span class=\"icon-bar\"></span>\r\n      <span class=\"icon-bar\"></span>\r\n      <span class=\"icon-bar\"></span>\r\n    </a>\r\n\r\n    <div class=\"navbar-custom-menu\" (click)=\"$event.preventDefault()\">\r\n      <ul class=\"nav navbar-nav\">\r\n        <li class=\"dropdown\" dropdown>\r\n          <a class=\"dropdown-toggle cursor-pointer\" data-toggle=\"dropdown\" dropdownToggle style=\"min-width: auto;\">\r\n            <img *ngIf=\"language=='En'\" src=\"" + __webpack_require__(622) + "\" alt=\"English\" style=\"width: 18px;\">\r\n            <img *ngIf=\"language=='Du'\" src=\"" + __webpack_require__(623) + "\" alt=\"Dutch\" style=\"width: 18px;\">\r\n            <img *ngIf=\"language=='Fr'\" src=\"" + __webpack_require__(624) + "\" alt=\"French\" style=\"width: 18px;\">\r\n            <img *ngIf=\"language=='De'\" src=\"" + __webpack_require__(625) + "\" alt=\"German\" style=\"width: 18px;\">\r\n            <img *ngIf=\"language=='Pl'\" src=\"" + __webpack_require__(626) + "\" alt=\"Polish\" style=\"width: 18px;\">            \r\n            <img *ngIf=\"language=='Pt'\" src=\"" + __webpack_require__(627) + "\" alt=\"Portugal\" style=\"width: 18px;\">\r\n            <img *ngIf=\"language=='Es' && authService.GetHighestRoleLevel() == roleLevel.WeGo\" src=\"" + __webpack_require__(1056) + "\" alt=\"Lbl\" style=\"width: 18px;\">\r\n            <br>\r\n            <span class=\"light-blue-text text-darken-4\">{{languageLbl}}</span>\r\n            <i class=\"fa fa-angle-down\" aria-hidden=\"true\"></i>\r\n          </a>\r\n          <ul class=\"dropdown-menu\" dropdownMenu aria-labelledby=\"simple-dropdown\" style=\"min-width: auto;\">\r\n            <li *ngIf=\"language!='En'\">\r\n              <a href=\"#\" (click)=\"ChangeCurrentLanguage('en')\">\r\n                <img src=\"" + __webpack_require__(622) + "\" alt=\"English\" style=\"width: 18px;\">\r\n                <span class=\"light-blue-text text-darken-4\">&nbsp;EN</span>\r\n              </a>\r\n            </li>\r\n            <li *ngIf=\"language!='Du'\">\r\n              <a href=\"#\" (click)=\"ChangeCurrentLanguage('nl')\">\r\n                <img src=\"" + __webpack_require__(623) + "\" alt=\"Dutch\" style=\"width: 18px;\">\r\n                <span class=\"light-blue-text text-darken-4\">&nbsp;NL</span>\r\n              </a>\r\n            </li>\r\n            <li *ngIf=\"language!='De'\">\r\n              <a href=\"#\" (click)=\"ChangeCurrentLanguage('de')\">\r\n                <img src=\"" + __webpack_require__(625) + "\" alt=\"German\" style=\"width: 18px;\">\r\n                <span class=\"light-blue-text text-darken-4\">&nbsp;DE</span>\r\n              </a>\r\n            </li>\r\n            <li *ngIf=\"language!='Fr'\">\r\n              <a href=\"#\" (click)=\"ChangeCurrentLanguage('fr')\">\r\n                <img src=\"" + __webpack_require__(624) + "\" alt=\"French\" style=\"width: 18px;\">\r\n                <span class=\"light-blue-text text-darken-4\">&nbsp;FR</span>\r\n              </a>\r\n            </li>            \r\n            <li *ngIf=\"language!='Pl'\">\r\n              <a href=\"#\" (click)=\"ChangeCurrentLanguage('pl')\">\r\n                <img src=\"" + __webpack_require__(626) + "\" alt=\"Polish\" style=\"width: 18px;\">\r\n                <span class=\"light-blue-text text-darken-4\">&nbsp;PL</span>\r\n              </a>\r\n            </li>\r\n            <li *ngIf=\"language!='Pt'\">\r\n              <a href=\"#\" (click)=\"ChangeCurrentLanguage('pt')\">\r\n                <img src=\"" + __webpack_require__(627) + "\" alt=\"Portuguese\" style=\"width: 18px;\">\r\n                <span class=\"light-blue-text text-darken-4\">&nbsp;PT</span>\r\n              </a>\r\n            </li>\r\n            <li *ngIf=\"language!='Es' && authService.GetHighestRoleLevel() == roleLevel.WeGo\">\r\n              <a href=\"#\" (click)=\"ChangeCurrentLanguage('es')\">\r\n                <img src=\"" + __webpack_require__(1056) + "\" alt=\"Lbl\" style=\"width: 18px;\">\r\n                <span class=\"light-blue-text text-darken-4\">&nbsp;Lbl</span>\r\n              </a>\r\n            </li>\r\n          </ul>\r\n        </li>\r\n\r\n        <li class=\"dropdown notifications-menu\">\r\n          <a class=\"dropdown-toggle cursor-pointer\" (click)=\"ResetNotificationCount($event)\" style=\"min-width: 1px;\">\r\n            <i class=\"fa fa-bell-o fa-lg\" style=\"padding-top: 10px;\"></i>\r\n            <span *ngIf=\"unreadNotification > 0\" class=\"label label-warning\">{{ unreadNotification }}</span>\r\n          </a>\r\n        </li>\r\n        <!-- User Account: style can be found in dropdown.less -->\r\n        <li class=\"dropdown user user-menu\" dropdown>\r\n          <a class=\"dropdown-toggle cursor-pointer\" data-toggle=\"dropdown\" dropdownToggle>\r\n            <img src=\"" + __webpack_require__(1057) + "\" class=\"user-image\" alt=\"User Image\">\r\n            <span><strong>{{ firstName }} {{ middleName }} {{ lastName }}</strong> </span><br><span style=\"font-size:11px;\">{{ highestEntityLevelRole }}</span>\r\n            <!--<span style=\"margin-left:10px;\"><i class=\"fa fa-angle-down\" aria-hidden=\"true\"></i></span>-->\r\n          </a>\r\n          <ul class=\"dropdown-menu\" dropdownMenu aria-labelledby=\"simple-dropdown\">\r\n            <!-- User image -->\r\n            <li class=\"user-header highlight-panel\">\r\n              <img src=\"" + __webpack_require__(1057) + "\" class=\"img-circle\" alt=\"User Image\">\r\n              <p>\r\n                {{ firstName }} {{ middleName }} {{ lastName }}\r\n                <small>{{ highestEntityLevelRole }}</small>\r\n              </p>\r\n            </li>\r\n\r\n            <!-- Menu Footer-->\r\n            <li class=\"user-footer\">\r\n              <div class=\"pull-left\">\r\n\r\n                <a class=\"btn btn-default btn-flat\" [routerLink]=\"[urlPersonUpdate]\">\r\n                  {{'LblProfile' | translate }}\r\n                </a>\r\n              </div>\r\n              <div class=\"pull-right\">\r\n                <a (click)=\"Logout()\" class=\"btn btn-default btn-flat\">{{'LblSignOut' | translate }}</a>\r\n              </div>\r\n            </li>\r\n          </ul>\r\n        </li>\r\n      </ul>\r\n    </div>\r\n  </nav>\r\n</header>";

/***/ },
/* 1056 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/Label.3c7317a372b5592effa92028fbf8f2b5.jpg";

/***/ },
/* 1057 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "assets/user-profile-pic.8ea3997c076cd533a266d43a116167e8.png";

/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	//import { MenuItem } from './menu-item.component';
	var SidebarComponent = (function () {
	    // @Input("IsLoading") isLoading: string;
	    function SidebarComponent() {
	    }
	    SidebarComponent.prototype.ngOnInit = function () { };
	    SidebarComponent.prototype.ngOnDestroy = function () { };
	    __decorate([
	        core_1.Input("menu"), 
	        __metadata('design:type', String)
	    ], SidebarComponent.prototype, "menu", void 0);
	    SidebarComponent = __decorate([
	        core_1.Component({
	            selector: "wego-sidebar",
	            template: "\n            <aside class=\"main-sidebar\">\n              <section class=\"sidebar\">\n                <ul class=\"sidebar-menu text-capitalize\">\n                  <li class=\"menu-item cursor-pointer\" *ngFor=\"let menuItem of menu\" [data]=\"menuItem\">\n                  </li>\n                </ul>\n              </section>\n              <!-- <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder> -->\n            </aside>\n            "
	        }), 
	        __metadata('design:paramtypes', [])
	    ], SidebarComponent);
	    return SidebarComponent;
	}());
	exports.SidebarComponent = SidebarComponent;


/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var config_1 = __webpack_require__(60);
	var auth_service_1 = __webpack_require__(58);
	var router_1 = __webpack_require__(26);
	var core_1 = __webpack_require__(3);
	var MenuItem = (function () {
	    function MenuItem(router, authService) {
	        this.router = router;
	        this.authService = authService;
	        this._opened = false;
	        this._isActive = false;
	    }
	    Object.defineProperty(MenuItem.prototype, "opened", {
	        get: function () {
	            return this._opened;
	        },
	        set: function (val) {
	            this._opened = val;
	            if (!val) {
	                this.children.toArray().forEach(function (x) { return x.opened = false; });
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ;
	    ;
	    Object.defineProperty(MenuItem.prototype, "isActive", {
	        get: function () {
	            return this._isActive;
	        },
	        set: function (val) {
	            this._isActive = val;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ;
	    ;
	    MenuItem.prototype.onClick = function (e) {
	        this.opened = !this.opened;
	        this.isActive = !this.isActive;
	        if (this.children) {
	            e.stopPropagation();
	        }
	    };
	    MenuItem.prototype.GenerateDynamicURL = function (url) {
	        if (url === 'tripdetailreport') {
	            window.location.href = 'https://backoffice.wego.app/';
	            return;
	        }
	        //return url + ";ver=" + Date.now();
	        var urlData = this.authService.GetURL(url);
	        if (url == config_1.ApplicationRouteURL.URL_BOOKING)
	            this.router.navigate([urlData, { v: Date.now() }]);
	        else
	            this.router.navigate([urlData]);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', MenuItem)
	    ], MenuItem.prototype, "data", void 0);
	    __decorate([
	        core_1.ViewChildren(MenuItem), 
	        __metadata('design:type', (typeof (_a = typeof core_1.QueryList !== 'undefined' && core_1.QueryList) === 'function' && _a) || Object)
	    ], MenuItem.prototype, "children", void 0);
	    MenuItem = __decorate([
	        core_1.Component({
	            selector: 'li.menu-Item',
	            styles: ["\n    .menu-open {\n      display: block;\n    }\n  "],
	            template: "\n      <template [ngIf]=\"!data.items\">\n\t\t\t<a (click)=\"GenerateDynamicURL(data.redirectPath)\" >\n      <i class=\"{{data.icon}}\"></i> <span>{{ data.title | translate }}</span>\n      <span class=\"pull-right-container\">\n      <i [ngClass]=\"{'fa fa-angle-left pull-right ': !!data.items && !opened }\"></i>\n      <i [ngClass]=\"{'fa fa-angle-down pull-right': !!data.items && opened }\"></i>\n      </span>\n      </a>\n      </template>\n      <template [ngIf]=\"data.items\">\n\t\t\t<a (click)=\"onClick($event)\">\n      <i class=\"{{data.icon}}\"></i> <span>{{data.title | translate }}</span>\n      <span class=\"pull-right-container\">\n      <i [ngClass]=\"{'fa fa-angle-left pull-right ': !!data.items && !opened }\"></i>\n      <i [ngClass]=\"{'fa fa-angle-down pull-right': !!data.items && opened }\"></i>\n      </span>\n      </a>\n      </template>\n\t\t\t<template [ngIf]=\"!!data.items\">\n\t\t\t\t<ul class=\"treeview-menu\" [ngClass]=\"{'menu-open': opened}\">\n  \t\t\t   <li class=\"menu-item\" cursor:pointer  *ngFor=\"let menuItem of data.items\" [data]=\"menuItem\">\n\t        </li>\n  \t\t\t</ul>\n\t\t\t</template>\n  ",
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object])
	    ], MenuItem);
	    return MenuItem;
	    var _a, _b, _c;
	}());
	exports.MenuItem = MenuItem;


/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var config_1 = __webpack_require__(60);
	var core_1 = __webpack_require__(3);
	var FooterComponent = (function () {
	    function FooterComponent() {
	    }
	    FooterComponent.prototype.ngOnInit = function () {
	        this.versionNumber = config_1.WeGoConfig.APP_VERSION;
	        this.copyRightYear = (new Date()).getFullYear();
	    };
	    FooterComponent.prototype.ngOnDestroy = function () { };
	    FooterComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-footer',
	            template: "\n  <footer class=\"main-footer\">\n    <div class=\"pull-right\">\n      <strong>{{ versionNumber }}</strong>\n    </div>\n    <strong>Copyright \u00A9 {{copyRightYear}}  <a href=\"http://wegocarsharing.com\" target=\"_blank\"> wegocarsharing.com </a></strong> All rights\n    reserved.\n  </footer>\n  "
	        }), 
	        __metadata('design:paramtypes', [])
	    ], FooterComponent);
	    return FooterComponent;
	}());
	exports.FooterComponent = FooterComponent;


/***/ },
/* 1061 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	function __export(m) {
	    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
	}
	__export(__webpack_require__(1062));
	__export(__webpack_require__(676));
	__export(__webpack_require__(1068));
	__export(__webpack_require__(1072));
	__export(__webpack_require__(1077));
	__export(__webpack_require__(1078));
	__export(__webpack_require__(537));
	__export(__webpack_require__(1192));
	__export(__webpack_require__(1198));
	__export(__webpack_require__(671));
	__export(__webpack_require__(1202));
	__export(__webpack_require__(1205));
	__export(__webpack_require__(1211));
	__export(__webpack_require__(1214));
	__export(__webpack_require__(1220));
	__export(__webpack_require__(1216));
	__export(__webpack_require__(1210));
	__export(__webpack_require__(1074));
	var accordion_module_1 = __webpack_require__(1065);
	exports.AccordionModule = accordion_module_1.AccordionModule;
	var alert_module_1 = __webpack_require__(678);
	exports.AlertModule = alert_module_1.AlertModule;
	var buttons_module_1 = __webpack_require__(1071);
	exports.ButtonsModule = buttons_module_1.ButtonsModule;
	var carousel_module_1 = __webpack_require__(1075);
	exports.CarouselModule = carousel_module_1.CarouselModule;
	var collapse_module_1 = __webpack_require__(1066);
	exports.CollapseModule = collapse_module_1.CollapseModule;
	var datepicker_module_1 = __webpack_require__(1188);
	exports.DatepickerModule = datepicker_module_1.DatepickerModule;
	var dropdown_module_1 = __webpack_require__(1197);
	exports.DropdownModule = dropdown_module_1.DropdownModule;
	var modal_module_1 = __webpack_require__(544);
	exports.ModalModule = modal_module_1.ModalModule;
	var pagination_module_1 = __webpack_require__(1201);
	exports.PaginationModule = pagination_module_1.PaginationModule;
	var progressbar_module_1 = __webpack_require__(675);
	exports.ProgressbarModule = progressbar_module_1.ProgressbarModule;
	var rating_module_1 = __webpack_require__(1204);
	exports.RatingModule = rating_module_1.RatingModule;
	var tabs_module_1 = __webpack_require__(1209);
	exports.TabsModule = tabs_module_1.TabsModule;
	var timepicker_module_1 = __webpack_require__(1213);
	exports.TimepickerModule = timepicker_module_1.TimepickerModule;
	var tooltip_module_1 = __webpack_require__(1219);
	exports.TooltipModule = tooltip_module_1.TooltipModule;
	var typeahead_module_1 = __webpack_require__(1227);
	exports.TypeaheadModule = typeahead_module_1.TypeaheadModule;
	var components_helper_service_1 = __webpack_require__(541);
	exports.ComponentsHelper = components_helper_service_1.ComponentsHelper;
	var index_1 = __webpack_require__(1228);
	exports.Ng2BootstrapModule = index_1.Ng2BootstrapModule;


/***/ },
/* 1062 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var accordion_group_component_1 = __webpack_require__(1063);
	exports.AccordionPanelComponent = accordion_group_component_1.AccordionPanelComponent;
	var accordion_component_1 = __webpack_require__(1064);
	exports.AccordionComponent = accordion_component_1.AccordionComponent;
	var accordion_module_1 = __webpack_require__(1065);
	exports.AccordionModule = accordion_module_1.AccordionModule;


/***/ },
/* 1063 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	var core_1 = __webpack_require__(3);
	var accordion_component_1 = __webpack_require__(1064);
	/* tslint:disable-next-line */
	var MouseEvent = global.MouseEvent;
	/* tslint:disable:component-selector-name */
	var AccordionPanelComponent = (function () {
	    function AccordionPanelComponent(accordion) {
	        this.accordion = accordion;
	    }
	    Object.defineProperty(AccordionPanelComponent.prototype, "isOpen", {
	        // Questionable, maybe .panel-open should be on child div.panel element?
	        get: function () {
	            return this._isOpen;
	        },
	        set: function (value) {
	            this._isOpen = value;
	            if (value) {
	                this.accordion.closeOtherPanels(this);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    AccordionPanelComponent.prototype.ngOnInit = function () {
	        this.panelClass = this.panelClass || 'panel-default';
	        this.accordion.addGroup(this);
	    };
	    AccordionPanelComponent.prototype.ngOnDestroy = function () {
	        this.accordion.removeGroup(this);
	    };
	    AccordionPanelComponent.prototype.toggleOpen = function (event) {
	        event.preventDefault();
	        if (!this.isDisabled) {
	            this.isOpen = !this.isOpen;
	        }
	    };
	    AccordionPanelComponent.decorators = [
	        { type: core_1.Component, args: [{
	                    selector: 'accordion-group, accordion-panel',
	                    template: "\n    <div class=\"panel\" [ngClass]=\"panelClass\">\n      <div class=\"panel-heading\" (click)=\"toggleOpen($event)\">\n        <h4 class=\"panel-title\">\n          <a href tabindex=\"0\" class=\"accordion-toggle\">\n            <span *ngIf=\"heading\" [ngClass]=\"{'text-muted': isDisabled}\">{{heading}}</span>\n            <ng-content select=\"[accordion-heading]\"></ng-content>\n          </a>\n        </h4>\n      </div>\n      <div class=\"panel-collapse collapse\" [collapse]=\"!isOpen\">\n        <div class=\"panel-body\">\n          <ng-content></ng-content>\n        </div>\n      </div>\n    </div>\n  "
	                },] },
	    ];
	    /** @nocollapse */
	    AccordionPanelComponent.ctorParameters = [
	        { type: accordion_component_1.AccordionComponent, decorators: [{ type: core_1.Inject, args: [accordion_component_1.AccordionComponent,] },] },
	    ];
	    AccordionPanelComponent.propDecorators = {
	        'heading': [{ type: core_1.Input },],
	        'panelClass': [{ type: core_1.Input },],
	        'isDisabled': [{ type: core_1.Input },],
	        'isOpen': [{ type: core_1.HostBinding, args: ['class.panel-open',] }, { type: core_1.Input },],
	    };
	    return AccordionPanelComponent;
	}());
	exports.AccordionPanelComponent = AccordionPanelComponent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	// todo: support template url
	var AccordionComponent = (function () {
	    function AccordionComponent() {
	        /* tslint:disable:no-unused-variable */
	        this.addClass = true;
	        /* tslint:enable:no-unused-variable */
	        this.groups = [];
	    }
	    AccordionComponent.prototype.closeOtherPanels = function (openGroup) {
	        if (!this.closeOthers) {
	            return;
	        }
	        this.groups.forEach(function (group) {
	            if (group !== openGroup) {
	                group.isOpen = false;
	            }
	        });
	    };
	    AccordionComponent.prototype.addGroup = function (group) {
	        this.groups.push(group);
	    };
	    AccordionComponent.prototype.removeGroup = function (group) {
	        var index = this.groups.indexOf(group);
	        if (index !== -1) {
	            this.groups.splice(index, 1);
	        }
	    };
	    AccordionComponent.decorators = [
	        { type: core_1.Component, args: [{
	                    selector: 'accordion',
	                    template: "<ng-content></ng-content>"
	                },] },
	    ];
	    /** @nocollapse */
	    AccordionComponent.ctorParameters = [];
	    AccordionComponent.propDecorators = {
	        'closeOthers': [{ type: core_1.Input },],
	        'addClass': [{ type: core_1.HostBinding, args: ['class.panel-group',] },],
	    };
	    return AccordionComponent;
	}());
	exports.AccordionComponent = AccordionComponent;


/***/ },
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var common_1 = __webpack_require__(22);
	var core_1 = __webpack_require__(3);
	var collapse_module_1 = __webpack_require__(1066);
	var accordion_group_component_1 = __webpack_require__(1063);
	var accordion_component_1 = __webpack_require__(1064);
	var AccordionModule = (function () {
	    function AccordionModule() {
	    }
	    AccordionModule.decorators = [
	        { type: core_1.NgModule, args: [{
	                    imports: [common_1.CommonModule, collapse_module_1.CollapseModule],
	                    declarations: [accordion_component_1.AccordionComponent, accordion_group_component_1.AccordionPanelComponent],
	                    exports: [accordion_component_1.AccordionComponent, accordion_group_component_1.AccordionPanelComponent]
	                },] },
	    ];
	    /** @nocollapse */
	    AccordionModule.ctorParameters = [];
	    return AccordionModule;
	}());
	exports.AccordionModule = AccordionModule;


/***/ },
/* 1066 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var collapse_directive_1 = __webpack_require__(1067);
	var CollapseModule = (function () {
	    function CollapseModule() {
	    }
	    CollapseModule.decorators = [
	        { type: core_1.NgModule, args: [{
	                    declarations: [collapse_directive_1.CollapseDirective],
	                    exports: [collapse_directive_1.CollapseDirective]
	                },] },
	    ];
	    /** @nocollapse */
	    CollapseModule.ctorParameters = [];
	    return CollapseModule;
	}());
	exports.CollapseModule = CollapseModule;


/***/ },
/* 1067 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	// FIX: in order to update to rc.1 had to disable animation, sorry
	var core_1 = __webpack_require__(3);
	// import {AnimationBuilder} from '@angular/platform-browser/src/animate/animation_builder';
	// import {animate, animation, state, style, transition} from '@angular/core';
	/*@Directive({
	 selector: '[collapse]',
	 // templateUrl: 'app/panel.html',
	 // styleUrls: ['app/panel.css'],
	 animations: [
	 animation('active', [
	 state('void', style({ height: 0 })),
	 state('closed', style({ height: 0 })),
	 state('open', style({ height: '*' })),
	 transition('void => closed', [ animate(0) ]),
	 transition('closed => open', [ animate('350ms ease-out') ]),
	 transition('open => closed', [ animate('350ms ease-out') ])
	 ])
	 ]
	 })*/
	// fix: replace with // '@angular/animate';
	// when https://github.com/angular/angular/issues/5984 will be fixed
	// TODO: remove ElementRef
	// TODO: add on change
	// TODO: #576 add callbacks: expanding, collapsing after adding animation
	var CollapseDirective = (function () {
	    function CollapseDirective(/*_ab:AnimationBuilder, */ _el, _renderer) {
	        // private animation:any;
	        this.collapsed = new core_1.EventEmitter(false);
	        this.expanded = new core_1.EventEmitter(false);
	        // shown
	        this.isExpanded = true;
	        // hidden
	        this.isCollapsed = false;
	        // stale state
	        this.isCollapse = true;
	        // animation state
	        this.isCollapsing = false;
	        // this._ab = _ab;
	        this._el = _el;
	        this._renderer = _renderer;
	    }
	    Object.defineProperty(CollapseDirective.prototype, "collapse", {
	        get: function () {
	            return this.isExpanded;
	        },
	        // @Input() private transitionDuration:number = 500; // Duration in ms
	        set: function (value) {
	            this.isExpanded = value;
	            this.toggle();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    CollapseDirective.prototype.ngOnInit = function () {
	        // this.animation = this._ab.css();
	        // this.animation.setDuration(this.transitionDuration);
	    };
	    CollapseDirective.prototype.toggle = function () {
	        // this.open = !this.open;
	        if (this.isExpanded) {
	            this.hide();
	        }
	        else {
	            this.show();
	        }
	    };
	    CollapseDirective.prototype.hide = function () {
	        this.isCollapse = false;
	        this.isCollapsing = true;
	        this.isExpanded = false;
	        this.isCollapsed = true;
	        this.isCollapse = true;
	        this.isCollapsing = false;
	        this.display = 'none';
	        this.collapsed.emit(this);
	        /*  setTimeout(() => {
	         // this.height = '0';
	         // this.isCollapse = true;
	         // this.isCollapsing = false;
	         this.animation
	         .setFromStyles({
	         height: this._el.nativeElement.scrollHeight + 'px'
	         })
	         .setToStyles({
	         height: '0',
	         overflow: 'hidden'
	         });
	    
	         this.animation.start(this._el.nativeElement)
	         .onComplete(() => {
	         if (this._el.nativeElement.offsetHeight === 0) {
	         this.display = 'none';
	         }
	    
	         this.isCollapse = true;
	         this.isCollapsing = false;
	         });
	         }, 4);*/
	    };
	    CollapseDirective.prototype.show = function () {
	        this.isCollapse = false;
	        this.isCollapsing = true;
	        this.isExpanded = true;
	        this.isCollapsed = false;
	        this.display = 'block';
	        // this.height = 'auto';
	        this.isCollapse = true;
	        this.isCollapsing = false;
	        this._renderer.setElementStyle(this._el.nativeElement, 'overflow', 'visible');
	        this._renderer.setElementStyle(this._el.nativeElement, 'height', 'auto');
	        this.expanded.emit(this);
	        /*setTimeout(() => {
	         // this.height = 'auto';
	         // this.isCollapse = true;
	         // this.isCollapsing = false;
	         this.animation
	         .setFromStyles({
	         height: this._el.nativeElement.offsetHeight,
	         overflow: 'hidden'
	         })
	         .setToStyles({
	         height: this._el.nativeElement.scrollHeight + 'px'
	         });
	    
	         this.animation.start(this._el.nativeElement)
	         .onComplete(() => {
	         this.isCollapse = true;
	         this.isCollapsing = false;
	         this._renderer.setElementStyle(this._el.nativeElement, 'overflow', 'visible');
	         this._renderer.setElementStyle(this._el.nativeElement, 'height', 'auto');
	         });
	         }, 4);*/
	    };
	    CollapseDirective.decorators = [
	        { type: core_1.Directive, args: [{ selector: '[collapse]' },] },
	    ];
	    /** @nocollapse */
	    CollapseDirective.ctorParameters = [
	        { type: core_1.ElementRef, },
	        { type: core_1.Renderer, },
	    ];
	    CollapseDirective.propDecorators = {
	        'collapsed': [{ type: core_1.Output },],
	        'expanded': [{ type: core_1.Output },],
	        'display': [{ type: core_1.HostBinding, args: ['style.display',] },],
	        'isExpanded': [{ type: core_1.HostBinding, args: ['class.in',] }, { type: core_1.HostBinding, args: ['attr.aria-expanded',] },],
	        'isCollapsed': [{ type: core_1.HostBinding, args: ['attr.aria-hidden',] },],
	        'isCollapse': [{ type: core_1.HostBinding, args: ['class.collapse',] },],
	        'isCollapsing': [{ type: core_1.HostBinding, args: ['class.collapsing',] },],
	        'collapse': [{ type: core_1.Input },],
	    };
	    return CollapseDirective;
	}());
	exports.CollapseDirective = CollapseDirective;


/***/ },
/* 1068 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var button_checkbox_directive_1 = __webpack_require__(1069);
	exports.ButtonCheckboxDirective = button_checkbox_directive_1.ButtonCheckboxDirective;
	var button_radio_directive_1 = __webpack_require__(1070);
	exports.ButtonRadioDirective = button_radio_directive_1.ButtonRadioDirective;
	var buttons_module_1 = __webpack_require__(1071);
	exports.ButtonsModule = buttons_module_1.ButtonsModule;


/***/ },
/* 1069 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(826);
	// TODO: config: activeClass - Class to apply to the checked buttons.
	var ButtonCheckboxDirective = (function () {
	    function ButtonCheckboxDirective(cd) {
	        this.state = false;
	        this.onChange = Function.prototype;
	        this.onTouched = Function.prototype;
	        this.cd = cd;
	        // hack !
	        cd.valueAccessor = this;
	    }
	    // view -> model
	    ButtonCheckboxDirective.prototype.onClick = function () {
	        this.toggle(!this.state);
	        this.cd.viewToModelUpdate(this.value);
	    };
	    ButtonCheckboxDirective.prototype.ngOnInit = function () {
	        this.toggle(this.trueValue === this.value);
	    };
	    Object.defineProperty(ButtonCheckboxDirective.prototype, "trueValue", {
	        get: function () {
	            return typeof this.btnCheckboxTrue !== 'undefined'
	                ? this.btnCheckboxTrue
	                : true;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ButtonCheckboxDirective.prototype, "falseValue", {
	        get: function () {
	            return typeof this.btnCheckboxFalse !== 'undefined'
	                ? this.btnCheckboxFalse
	                : false;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ButtonCheckboxDirective.prototype.toggle = function (state) {
	        this.state = state;
	        this.value = this.state ? this.trueValue : this.falseValue;
	    };
	    // ControlValueAccessor
	    // model -> view
	    ButtonCheckboxDirective.prototype.writeValue = function (value) {
	        this.state = this.trueValue === value;
	        this.value = value;
	    };
	    ButtonCheckboxDirective.prototype.registerOnChange = function (fn) {
	        this.onChange = fn;
	    };
	    ButtonCheckboxDirective.prototype.registerOnTouched = function (fn) {
	        this.onTouched = fn;
	    };
	    ButtonCheckboxDirective.decorators = [
	        { type: core_1.Directive, args: [{ selector: '[btnCheckbox][ngModel]' },] },
	    ];
	    /** @nocollapse */
	    ButtonCheckboxDirective.ctorParameters = [
	        { type: forms_1.NgModel, decorators: [{ type: core_1.Self },] },
	    ];
	    ButtonCheckboxDirective.propDecorators = {
	        'btnCheckboxTrue': [{ type: core_1.Input },],
	        'btnCheckboxFalse': [{ type: core_1.Input },],
	        'state': [{ type: core_1.HostBinding, args: ['class.active',] },],
	        'onClick': [{ type: core_1.HostListener, args: ['click',] },],
	    };
	    return ButtonCheckboxDirective;
	}());
	exports.ButtonCheckboxDirective = ButtonCheckboxDirective;


/***/ },
/* 1070 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(826);
	/* tslint:disable */
	exports.RADIO_CONTROL_VALUE_ACCESSOR = {
	    provide: forms_1.NG_VALUE_ACCESSOR,
	    useExisting: core_1.forwardRef(function () { return ButtonRadioDirective; }),
	    multi: true
	};
	/* tslint:enable */
	var ButtonRadioDirective = (function () {
	    function ButtonRadioDirective(el) {
	        this.el = el;
	        this.onChange = Function.prototype;
	        this.onTouched = Function.prototype;
	    }
	    Object.defineProperty(ButtonRadioDirective.prototype, "isActive", {
	        get: function () {
	            return this.btnRadio === this.value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ButtonRadioDirective.prototype.onClick = function () {
	        if (this.el.nativeElement.attributes.disabled) {
	            return;
	        }
	        if (this.uncheckable && this.btnRadio === this.value) {
	            this.value = undefined;
	        }
	        else {
	            this.value = this.btnRadio;
	        }
	        this.onTouched();
	        this.onChange(this.value);
	    };
	    ButtonRadioDirective.prototype.ngOnInit = function () {
	        this.uncheckable = typeof this.uncheckable !== 'undefined';
	    };
	    ButtonRadioDirective.prototype.onBlur = function () {
	        this.onTouched();
	    };
	    // ControlValueAccessor
	    // model -> view
	    ButtonRadioDirective.prototype.writeValue = function (value) {
	        this.value = value;
	    };
	    ButtonRadioDirective.prototype.registerOnChange = function (fn) {
	        this.onChange = fn;
	    };
	    ButtonRadioDirective.prototype.registerOnTouched = function (fn) {
	        this.onTouched = fn;
	    };
	    ButtonRadioDirective.decorators = [
	        { type: core_1.Directive, args: [{ selector: '[btnRadio]', providers: [exports.RADIO_CONTROL_VALUE_ACCESSOR] },] },
	    ];
	    /** @nocollapse */
	    ButtonRadioDirective.ctorParameters = [
	        { type: core_1.ElementRef, },
	    ];
	    ButtonRadioDirective.propDecorators = {
	        'btnRadio': [{ type: core_1.Input },],
	        'uncheckable': [{ type: core_1.Input },],
	        'value': [{ type: core_1.Input },],
	        'isActive': [{ type: core_1.HostBinding, args: ['class.active',] },],
	        'onClick': [{ type: core_1.HostListener, args: ['click',] },],
	    };
	    return ButtonRadioDirective;
	}());
	exports.ButtonRadioDirective = ButtonRadioDirective;


/***/ },
/* 1071 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(826);
	var button_checkbox_directive_1 = __webpack_require__(1069);
	var button_radio_directive_1 = __webpack_require__(1070);
	var ButtonsModule = (function () {
	    function ButtonsModule() {
	    }
	    ButtonsModule.decorators = [
	        { type: core_1.NgModule, args: [{
	                    imports: [forms_1.FormsModule],
	                    declarations: [button_checkbox_directive_1.ButtonCheckboxDirective, button_radio_directive_1.ButtonRadioDirective],
	                    exports: [button_checkbox_directive_1.ButtonCheckboxDirective, button_radio_directive_1.ButtonRadioDirective, forms_1.FormsModule]
	                },] },
	    ];
	    /** @nocollapse */
	    ButtonsModule.ctorParameters = [];
	    return ButtonsModule;
	}());
	exports.ButtonsModule = ButtonsModule;


/***/ },
/* 1072 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var carousel_component_1 = __webpack_require__(1073);
	exports.CarouselComponent = carousel_component_1.CarouselComponent;
	var carousel_module_1 = __webpack_require__(1075);
	exports.CarouselModule = carousel_module_1.CarouselModule;
	var slide_component_1 = __webpack_require__(1076);
	exports.SlideComponent = slide_component_1.SlideComponent;


/***/ },
/* 1073 */
/***/ function(module, exports, __webpack_require__) {

	// todo: add animate
	"use strict";
	var core_1 = __webpack_require__(3);
	var ng2_bootstrap_config_1 = __webpack_require__(1074);
	(function (Direction) {
	    Direction[Direction["UNKNOWN"] = 0] = "UNKNOWN";
	    Direction[Direction["NEXT"] = 1] = "NEXT";
	    Direction[Direction["PREV"] = 2] = "PREV";
	})(exports.Direction || (exports.Direction = {}));
	var Direction = exports.Direction;
	// todo:
	// (ng-swipe-right)="prev()" (ng-swipe-left)="next()"
	/**
	 * Problems:
	 * 1) if we set an active slide via model changes, .active class remains on a current slide.
	 * 2) if we have only one slide, we shouldn't show prev/next nav buttons
	 * 3) if first or last slide is active and noWrap is true, there should be "disabled" class on the nav buttons.
	 * 4) default interval should be equal 5000
	 */
	var CarouselComponent = (function () {
	    function CarouselComponent() {
	        this.slides = [];
	        this.destroyed = false;
	    }
	    Object.defineProperty(CarouselComponent.prototype, "interval", {
	        get: function () {
	            return this._interval;
	        },
	        set: function (value) {
	            this._interval = value;
	            this.restartTimer();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CarouselComponent.prototype, "isBS4", {
	        get: function () {
	            return ng2_bootstrap_config_1.Ng2BootstrapConfig.theme === ng2_bootstrap_config_1.Ng2BootstrapTheme.BS4;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    CarouselComponent.prototype.ngOnDestroy = function () {
	        this.destroyed = true;
	    };
	    CarouselComponent.prototype.select = function (nextSlide, direction) {
	        if (direction === void 0) { direction = Direction.UNKNOWN; }
	        var nextIndex = nextSlide.index;
	        if (direction === Direction.UNKNOWN) {
	            direction = nextIndex > this.getCurrentIndex()
	                ? Direction.NEXT
	                : Direction.PREV;
	        }
	        // Prevent this user-triggered transition from occurring if there is
	        // already one in progress
	        if (nextSlide && nextSlide !== this.currentSlide) {
	            this.goNext(nextSlide, direction);
	        }
	    };
	    CarouselComponent.prototype.play = function () {
	        if (!this.isPlaying) {
	            this.isPlaying = true;
	            this.restartTimer();
	        }
	    };
	    CarouselComponent.prototype.pause = function () {
	        if (!this.noPause) {
	            this.isPlaying = false;
	            this.resetTimer();
	        }
	    };
	    CarouselComponent.prototype.next = function () {
	        var newIndex = (this.getCurrentIndex() + 1) % this.slides.length;
	        if (newIndex === 0 && this.noWrap) {
	            this.pause();
	            return;
	        }
	        return this.select(this.getSlideByIndex(newIndex), Direction.NEXT);
	    };
	    CarouselComponent.prototype.prev = function () {
	        var newIndex = this.getCurrentIndex() - 1 < 0
	            ? this.slides.length - 1
	            : this.getCurrentIndex() - 1;
	        if (this.noWrap && newIndex === this.slides.length - 1) {
	            this.pause();
	            return;
	        }
	        return this.select(this.getSlideByIndex(newIndex), Direction.PREV);
	    };
	    CarouselComponent.prototype.addSlide = function (slide) {
	        slide.index = this.slides.length;
	        this.slides.push(slide);
	        if (this.slides.length === 1 || slide.active) {
	            this.select(this.slides[this.slides.length - 1]);
	            if (this.slides.length === 1) {
	                this.play();
	            }
	        }
	        else {
	            slide.active = false;
	        }
	    };
	    CarouselComponent.prototype.removeSlide = function (slide) {
	        this.slides.splice(slide.index, 1);
	        if (this.slides.length === 0) {
	            this.currentSlide = void 0;
	            return;
	        }
	        for (var i = 0; i < this.slides.length; i++) {
	            this.slides[i].index = i;
	        }
	    };
	    CarouselComponent.prototype.goNext = function (slide, direction) {
	        if (this.destroyed) {
	            return;
	        }
	        slide.direction = direction;
	        slide.active = true;
	        if (this.currentSlide) {
	            this.currentSlide.direction = direction;
	            this.currentSlide.active = false;
	        }
	        this.currentSlide = slide;
	        // every time you change slides, reset the timer
	        this.restartTimer();
	    };
	    CarouselComponent.prototype.getSlideByIndex = function (index) {
	        var len = this.slides.length;
	        for (var i = 0; i < len; ++i) {
	            if (this.slides[i].index === index) {
	                return this.slides[i];
	            }
	        }
	        return void 0;
	    };
	    CarouselComponent.prototype.getCurrentIndex = function () {
	        return !this.currentSlide ? 0 : this.currentSlide.index;
	    };
	    CarouselComponent.prototype.restartTimer = function () {
	        var _this = this;
	        this.resetTimer();
	        var interval = +this.interval;
	        if (!isNaN(interval) && interval > 0) {
	            this.currentInterval = setInterval(function () {
	                var nInterval = +_this.interval;
	                if (_this.isPlaying && !isNaN(_this.interval) && nInterval > 0 && _this.slides.length) {
	                    _this.next();
	                }
	                else {
	                    _this.pause();
	                }
	            }, interval);
	        }
	    };
	    CarouselComponent.prototype.resetTimer = function () {
	        if (this.currentInterval) {
	            clearInterval(this.currentInterval);
	            this.currentInterval = void 0;
	        }
	    };
	    CarouselComponent.decorators = [
	        { type: core_1.Component, args: [{
	                    selector: 'carousel',
	                    template: "\n    <div (mouseenter)=\"pause()\" (mouseleave)=\"play()\" class=\"carousel slide\">\n      <ol class=\"carousel-indicators\" *ngIf=\"slides.length > 1\">\n         <li *ngFor=\"let slidez of slides\" [class.active]=\"slidez.active === true\" (click)=\"select(slidez)\"></li>\n      </ol>\n      <div class=\"carousel-inner\"><ng-content></ng-content></div>\n      <a class=\"left carousel-control\" (click)=\"prev()\" *ngIf=\"slides.length\">\n        <span class=\"icon-prev\" aria-hidden=\"true\"></span>\n        <span *ngIf=\"isBS4\" class=\"sr-only\">Previous</span>\n      </a>\n      <a class=\"right carousel-control\" (click)=\"next()\" *ngIf=\"slides.length\">\n        <span class=\"icon-next\" aria-hidden=\"true\"></span>\n        <span *ngIf=\"isBS4\" class=\"sr-only\">Next</span>\n      </a>\n    </div>\n  "
	                },] },
	    ];
	    /** @nocollapse */
	    CarouselComponent.ctorParameters = [];
	    CarouselComponent.propDecorators = {
	        'noWrap': [{ type: core_1.Input },],
	        'noPause': [{ type: core_1.Input },],
	        'noTransition': [{ type: core_1.Input },],
	        'interval': [{ type: core_1.Input },],
	    };
	    return CarouselComponent;
	}());
	exports.CarouselComponent = CarouselComponent;


/***/ },
/* 1074 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var browser_1 = __webpack_require__(543);
	(function (Ng2BootstrapTheme) {
	    Ng2BootstrapTheme[Ng2BootstrapTheme["BS3"] = 1] = "BS3";
	    Ng2BootstrapTheme[Ng2BootstrapTheme["BS4"] = 2] = "BS4";
	})(exports.Ng2BootstrapTheme || (exports.Ng2BootstrapTheme = {}));
	var Ng2BootstrapTheme = exports.Ng2BootstrapTheme;
	var Ng2BootstrapConfig = (function () {
	    function Ng2BootstrapConfig() {
	    }
	    Object.defineProperty(Ng2BootstrapConfig, "theme", {
	        get: function () {
	            // hack as for now
	            if (browser_1.window.__theme === 'bs4') {
	                return Ng2BootstrapTheme.BS4;
	            }
	            return (this._theme || Ng2BootstrapTheme.BS3);
	        },
	        set: function (v) {
	            this._theme = v;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    return Ng2BootstrapConfig;
	}());
	exports.Ng2BootstrapConfig = Ng2BootstrapConfig;


/***/ },
/* 1075 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var common_1 = __webpack_require__(22);
	var core_1 = __webpack_require__(3);
	var carousel_component_1 = __webpack_require__(1073);
	var slide_component_1 = __webpack_require__(1076);
	var CarouselModule = (function () {
	    function CarouselModule() {
	    }
	    CarouselModule.decorators = [
	        { type: core_1.NgModule, args: [{
	                    imports: [common_1.CommonModule],
	                    declarations: [slide_component_1.SlideComponent, carousel_component_1.CarouselComponent],
	                    exports: [slide_component_1.SlideComponent, carousel_component_1.CarouselComponent]
	                },] },
	    ];
	    /** @nocollapse */
	    CarouselModule.ctorParameters = [];
	    return CarouselModule;
	}());
	exports.CarouselModule = CarouselModule;


/***/ },
/* 1076 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var carousel_component_1 = __webpack_require__(1073);
	var SlideComponent = (function () {
	    function SlideComponent(carousel) {
	        this.addClass = true;
	        this.carousel = carousel;
	    }
	    SlideComponent.prototype.ngOnInit = function () {
	        this.carousel.addSlide(this);
	    };
	    SlideComponent.prototype.ngOnDestroy = function () {
	        this.carousel.removeSlide(this);
	    };
	    SlideComponent.decorators = [
	        { type: core_1.Component, args: [{
	                    selector: 'slide',
	                    template: "\n    <div [class.active]=\"active\" class=\"item\">\n      <ng-content></ng-content>\n    </div>\n  "
	                },] },
	    ];
	    /** @nocollapse */
	    SlideComponent.ctorParameters = [
	        { type: carousel_component_1.CarouselComponent, },
	    ];
	    SlideComponent.propDecorators = {
	        'index': [{ type: core_1.Input },],
	        'direction': [{ type: core_1.Input },],
	        'active': [{ type: core_1.HostBinding, args: ['class.active',] }, { type: core_1.Input },],
	        'addClass': [{ type: core_1.HostBinding, args: ['class.item',] }, { type: core_1.HostBinding, args: ['class.carousel-item',] },],
	    };
	    return SlideComponent;
	}());
	exports.SlideComponent = SlideComponent;


/***/ },
/* 1077 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var collapse_directive_1 = __webpack_require__(1067);
	exports.CollapseDirective = collapse_directive_1.CollapseDirective;
	var collapse_module_1 = __webpack_require__(1066);
	exports.CollapseModule = collapse_module_1.CollapseModule;


/***/ },
/* 1078 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	/*
	 todo: general:
	 1. Popup
	 2. Keyboard support
	 3. custom-class attribute support
	 4. date-disabled attribute support
	 5. template-url attribute support
	 */
	var datepicker_component_1 = __webpack_require__(1079);
	exports.DatePickerComponent = datepicker_component_1.DatePickerComponent;
	var datepicker_module_1 = __webpack_require__(1188);
	exports.DatepickerModule = datepicker_module_1.DatepickerModule;
	var daypicker_component_1 = __webpack_require__(1189);
	exports.DayPickerComponent = daypicker_component_1.DayPickerComponent;
	var monthpicker_component_1 = __webpack_require__(1190);
	exports.MonthPickerComponent = monthpicker_component_1.MonthPickerComponent;
	var yearpicker_component_1 = __webpack_require__(1191);
	exports.YearPickerComponent = yearpicker_component_1.YearPickerComponent;
	var date_formatter_1 = __webpack_require__(1081);
	exports.DateFormatter = date_formatter_1.DateFormatter;


/***/ },
/* 1079 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var datepicker_inner_component_1 = __webpack_require__(1080);
	var forms_1 = __webpack_require__(826);
	/* tslint:disable:component-selector-name component-selector-type */
	/* tslint:enable:component-selector-name component-selector-type */
	var DatePickerComponent = (function () {
	    function DatePickerComponent(cd) {
	        this.selectionDone = new core_1.EventEmitter(undefined);
	        this.onChange = Function.prototype;
	        this.onTouched = Function.prototype;
	        this._now = new Date();
	        this.cd = cd;
	        // hack
	        cd.valueAccessor = this;
	    }
	    Object.defineProperty(DatePickerComponent.prototype, "activeDate", {
	        get: function () {
	            return this._activeDate || this._now;
	        },
	        set: function (value) {
	            this._activeDate = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DatePickerComponent.prototype.onUpdate = function (event) {
	        this.cd.viewToModelUpdate(event);
	    };
	    DatePickerComponent.prototype.onSelectionDone = function (event) {
	        this.selectionDone.emit(event);
	    };
	    // todo: support null value
	    DatePickerComponent.prototype.writeValue = function (value) {
	        if (this._datePicker.compare(value, this._activeDate) === 0) {
	            return;
	        }
	        if (value && value instanceof Date) {
	            this.activeDate = value;
	            this._datePicker.select(value, false);
	            return;
	        }
	        this.activeDate = value ? new Date(value) : void 0;
	    };
	    DatePickerComponent.prototype.registerOnChange = function (fn) {
	        this.onChange = fn;
	    };
	    DatePickerComponent.prototype.registerOnTouched = function (fn) {
	        this.onTouched = fn;
	    };
	    DatePickerComponent.decorators = [
	        { type: core_1.Component, args: [{
	                    selector: 'datepicker[ngModel]',
	                    template: "\n    <datepicker-inner [activeDate]=\"activeDate\"\n                      (update)=\"onUpdate($event)\"\n                      [datepickerMode]=\"datepickerMode\"\n                      [initDate]=\"initDate\"\n                      [minDate]=\"minDate\"\n                      [maxDate]=\"maxDate\"\n                      [minMode]=\"minMode\"\n                      [maxMode]=\"maxMode\"\n                      [showWeeks]=\"showWeeks\"\n                      [formatDay]=\"formatDay\"\n                      [formatMonth]=\"formatMonth\"\n                      [formatYear]=\"formatYear\"\n                      [formatDayHeader]=\"formatDayHeader\"\n                      [formatDayTitle]=\"formatDayTitle\"\n                      [formatMonthTitle]=\"formatMonthTitle\"\n                      [startingDay]=\"startingDay\"\n                      [yearRange]=\"yearRange\"\n                      [customClass]=\"customClass\"\n                      [dateDisabled]=\"dateDisabled\"\n                      [onlyCurrentMonth]=\"onlyCurrentMonth\"\n                      [shortcutPropagation]=\"shortcutPropagation\"\n                      [monthColLimit]=\"monthColLimit\"\n                      [yearColLimit]=\"yearColLimit\"\n                      (selectionDone)=\"onSelectionDone($event)\">\n      <daypicker tabindex=\"0\"></daypicker>\n      <monthpicker tabindex=\"0\"></monthpicker>\n      <yearpicker tabindex=\"0\"></yearpicker>\n    </datepicker-inner>\n    ",
	                    providers: [forms_1.NgModel]
	                },] },
	    ];
	    /** @nocollapse */
	    DatePickerComponent.ctorParameters = [
	        { type: forms_1.NgModel, decorators: [{ type: core_1.Self },] },
	    ];
	    DatePickerComponent.propDecorators = {
	        'datepickerMode': [{ type: core_1.Input },],
	        'initDate': [{ type: core_1.Input },],
	        'minDate': [{ type: core_1.Input },],
	        'maxDate': [{ type: core_1.Input },],
	        'minMode': [{ type: core_1.Input },],
	        'maxMode': [{ type: core_1.Input },],
	        'showWeeks': [{ type: core_1.Input },],
	        'formatDay': [{ type: core_1.Input },],
	        'formatMonth': [{ type: core_1.Input },],
	        'formatYear': [{ type: core_1.Input },],
	        'formatDayHeader': [{ type: core_1.Input },],
	        'formatDayTitle': [{ type: core_1.Input },],
	        'formatMonthTitle': [{ type: core_1.Input },],
	        'startingDay': [{ type: core_1.Input },],
	        'yearRange': [{ type: core_1.Input },],
	        'onlyCurrentMonth': [{ type: core_1.Input },],
	        'shortcutPropagation': [{ type: core_1.Input },],
	        'customClass': [{ type: core_1.Input },],
	        'monthColLimit': [{ type: core_1.Input },],
	        'yearColLimit': [{ type: core_1.Input },],
	        'dateDisabled': [{ type: core_1.Input },],
	        'selectionDone': [{ type: core_1.Output },],
	        '_datePicker': [{ type: core_1.ViewChild, args: [datepicker_inner_component_1.DatePickerInnerComponent,] },],
	        'activeDate': [{ type: core_1.Input },],
	    };
	    return DatePickerComponent;
	}());
	exports.DatePickerComponent = DatePickerComponent;


/***/ },
/* 1080 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var date_formatter_1 = __webpack_require__(1081);
	var FORMAT_DAY = 'DD';
	var FORMAT_MONTH = 'MMMM';
	var FORMAT_YEAR = 'YYYY';
	var FORMAT_DAY_HEADER = 'dd';
	var FORMAT_DAY_TITLE = 'MMMM YYYY';
	var FORMAT_MONTH_TITLE = 'YYYY';
	var DATEPICKER_MODE = 'day';
	var MIN_MODE = 'day';
	var MAX_MODE = 'year';
	var SHOW_WEEKS = true;
	var ONLY_CURRENT_MONTH = false;
	var STARTING_DAY = 0;
	var YEAR_RANGE = 20;
	var MONTH_COL_LIMIT = 3;
	var YEAR_COL_LIMIT = 5;
	// const MIN_DATE:Date = void 0;
	// const MAX_DATE:Date = void 0;
	var SHORTCUT_PROPAGATION = false;
	// const DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
	/*
	 const KEYS = {
	 13: 'enter',
	 32: 'space',
	 33: 'pageup',
	 34: 'pagedown',
	 35: 'end',
	 36: 'home',
	 37: 'left',
	 38: 'up',
	 39: 'right',
	 40: 'down'
	 };
	 */
	var DatePickerInnerComponent = (function () {
	    function DatePickerInnerComponent() {
	        this.selectionDone = new core_1.EventEmitter(undefined);
	        this.update = new core_1.EventEmitter(false);
	        this.stepDay = {};
	        this.stepMonth = {};
	        this.stepYear = {};
	        this.modes = ['day', 'month', 'year'];
	        this.dateFormatter = new date_formatter_1.DateFormatter();
	    }
	    Object.defineProperty(DatePickerInnerComponent.prototype, "activeDate", {
	        get: function () {
	            return this._activeDate;
	        },
	        set: function (value) {
	            this._activeDate = value;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    // todo: add formatter value to Date object
	    DatePickerInnerComponent.prototype.ngOnInit = function () {
	        this.formatDay = this.formatDay || FORMAT_DAY;
	        this.formatMonth = this.formatMonth || FORMAT_MONTH;
	        this.formatYear = this.formatYear || FORMAT_YEAR;
	        this.formatDayHeader = this.formatDayHeader || FORMAT_DAY_HEADER;
	        this.formatDayTitle = this.formatDayTitle || FORMAT_DAY_TITLE;
	        this.formatMonthTitle = this.formatMonthTitle || FORMAT_MONTH_TITLE;
	        this.showWeeks = (this.showWeeks === undefined
	            ? SHOW_WEEKS
	            : this.showWeeks);
	        this.onlyCurrentMonth = (this.onlyCurrentMonth === undefined
	            ? ONLY_CURRENT_MONTH
	            : this.onlyCurrentMonth);
	        this.startingDay = this.startingDay || STARTING_DAY;
	        this.yearRange = this.yearRange || YEAR_RANGE;
	        this.shortcutPropagation = this.shortcutPropagation || SHORTCUT_PROPAGATION;
	        this.datepickerMode = this.datepickerMode || DATEPICKER_MODE;
	        this.minMode = this.minMode || MIN_MODE;
	        this.maxMode = this.maxMode || MAX_MODE;
	        this.monthColLimit = this.monthColLimit || MONTH_COL_LIMIT;
	        this.yearColLimit = this.yearColLimit || YEAR_COL_LIMIT;
	        // todo: use date for unique value
	        this.uniqueId = 'datepicker-' + '-' + Math.floor(Math.random() * 10000);
	        if (this.initDate) {
	            this.activeDate = this.initDate;
	            this.selectedDate = new Date(this.activeDate.valueOf());
	            this.update.emit(this.activeDate);
	        }
	        else if (this.activeDate === undefined) {
	            this.activeDate = new Date();
	        }
	    };
	    // this.refreshView should be called here to reflect the changes on the fly
	    // tslint:disable-next-line:no-unused-variable
	    DatePickerInnerComponent.prototype.ngOnChanges = function (changes) {
	        this.refreshView();
	    };
	    DatePickerInnerComponent.prototype.setCompareHandler = function (handler, type) {
	        if (type === 'day') {
	            this.compareHandlerDay = handler;
	        }
	        if (type === 'month') {
	            this.compareHandlerMonth = handler;
	        }
	        if (type === 'year') {
	            this.compareHandlerYear = handler;
	        }
	    };
	    DatePickerInnerComponent.prototype.compare = function (date1, date2) {
	        if (date1 === undefined || date2 === undefined) {
	            return undefined;
	        }
	        if (this.datepickerMode === 'day' && this.compareHandlerDay) {
	            return this.compareHandlerDay(date1, date2);
	        }
	        if (this.datepickerMode === 'month' && this.compareHandlerMonth) {
	            return this.compareHandlerMonth(date1, date2);
	        }
	        if (this.datepickerMode === 'year' && this.compareHandlerYear) {
	            return this.compareHandlerYear(date1, date2);
	        }
	        return void 0;
	    };
	    DatePickerInnerComponent.prototype.setRefreshViewHandler = function (handler, type) {
	        if (type === 'day') {
	            this.refreshViewHandlerDay = handler;
	        }
	        if (type === 'month') {
	            this.refreshViewHandlerMonth = handler;
	        }
	        if (type === 'year') {
	            this.refreshViewHandlerYear = handler;
	        }
	    };
	    DatePickerInnerComponent.prototype.refreshView = function () {
	        if (this.datepickerMode === 'day' && this.refreshViewHandlerDay) {
	            this.refreshViewHandlerDay();
	        }
	        if (this.datepickerMode === 'month' && this.refreshViewHandlerMonth) {
	            this.refreshViewHandlerMonth();
	        }
	        if (this.datepickerMode === 'year' && this.refreshViewHandlerYear) {
	            this.refreshViewHandlerYear();
	        }
	    };
	    DatePickerInnerComponent.prototype.dateFilter = function (date, format) {
	        return this.dateFormatter.format(date, format);
	    };
	    DatePickerInnerComponent.prototype.isActive = function (dateObject) {
	        if (this.compare(dateObject.date, this.activeDate) === 0) {
	            this.activeDateId = dateObject.uid;
	            return true;
	        }
	        return false;
	    };
	    DatePickerInnerComponent.prototype.createDateObject = function (date, format) {
	        var dateObject = {};
	        dateObject.date = new Date(date.getFullYear(), date.getMonth(), date.getDate());
	        dateObject.label = this.dateFilter(date, format);
	        dateObject.selected = this.compare(date, this.selectedDate) === 0;
	        dateObject.disabled = this.isDisabled(date);
	        dateObject.current = this.compare(date, new Date()) === 0;
	        dateObject.customClass = this.getCustomClassForDate(dateObject.date);
	        return dateObject;
	    };
	    DatePickerInnerComponent.prototype.split = function (arr, size) {
	        var arrays = [];
	        while (arr.length > 0) {
	            arrays.push(arr.splice(0, size));
	        }
	        return arrays;
	    };
	    // Fix a hard-reproducible bug with timezones
	    // The bug depends on OS, browser, current timezone and current date
	    // i.e.
	    // var date = new Date(2014, 0, 1);
	    // console.log(date.getFullYear(), date.getMonth(), date.getDate(),
	    // date.getHours()); can result in "2013 11 31 23" because of the bug.
	    DatePickerInnerComponent.prototype.fixTimeZone = function (date) {
	        var hours = date.getHours();
	        return new Date(date.getFullYear(), date.getMonth(), date.getDate(), hours === 23 ? hours + 2 : 0);
	    };
	    DatePickerInnerComponent.prototype.select = function (date, isManual) {
	        if (isManual === void 0) { isManual = true; }
	        if (this.datepickerMode === this.minMode) {
	            if (!this.activeDate) {
	                this.activeDate = new Date(0, 0, 0, 0, 0, 0, 0);
	            }
	            this.activeDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
	            if (isManual) {
	                this.selectionDone.emit(this.activeDate);
	            }
	        }
	        else {
	            this.activeDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
	            this.datepickerMode = this.modes[this.modes.indexOf(this.datepickerMode) - 1];
	        }
	        this.selectedDate = new Date(this.activeDate.valueOf());
	        this.update.emit(this.activeDate);
	        this.refreshView();
	    };
	    DatePickerInnerComponent.prototype.move = function (direction) {
	        var expectedStep;
	        if (this.datepickerMode === 'day') {
	            expectedStep = this.stepDay;
	        }
	        if (this.datepickerMode === 'month') {
	            expectedStep = this.stepMonth;
	        }
	        if (this.datepickerMode === 'year') {
	            expectedStep = this.stepYear;
	        }
	        if (expectedStep) {
	            var year = this.activeDate.getFullYear() + direction * (expectedStep.years || 0);
	            var month = this.activeDate.getMonth() + direction * (expectedStep.months || 0);
	            this.activeDate = new Date(year, month, 1);
	            this.refreshView();
	        }
	    };
	    DatePickerInnerComponent.prototype.toggleMode = function (direction) {
	        direction = direction || 1;
	        if ((this.datepickerMode === this.maxMode && direction === 1) ||
	            (this.datepickerMode === this.minMode && direction === -1)) {
	            return;
	        }
	        this.datepickerMode = this.modes[this.modes.indexOf(this.datepickerMode) + direction];
	        this.refreshView();
	    };
	    DatePickerInnerComponent.prototype.getCustomClassForDate = function (date) {
	        var _this = this;
	        if (!this.customClass) {
	            return '';
	        }
	        // todo: build a hash of custom classes, it will work faster
	        var customClassObject = this.customClass
	            .find(function (customClass) {
	            return customClass.date.valueOf() === date.valueOf() &&
	                customClass.mode === _this.datepickerMode;
	        }, this);
	        return customClassObject === undefined ? '' : customClassObject.clazz;
	    };
	    DatePickerInnerComponent.prototype.isDisabled = function (date) {
	        // todo: implement dateDisabled attribute
	        return ((this.minDate && this.compare(date, this.minDate) < 0) ||
	            (this.maxDate && this.compare(date, this.maxDate) > 0));
	    };
	    DatePickerInnerComponent.decorators = [
	        { type: core_1.Component, args: [{
	                    selector: 'datepicker-inner',
	                    template: "\n    <div *ngIf=\"datepickerMode\" class=\"well well-sm bg-faded p-a card\" role=\"application\" ><!--&lt;!&ndash;ng-keydown=\"keydown($event)\"&ndash;&gt;-->\n      <ng-content></ng-content>\n    </div>\n  "
	                },] },
	    ];
	    /** @nocollapse */
	    DatePickerInnerComponent.ctorParameters = [];
	    DatePickerInnerComponent.propDecorators = {
	        'datepickerMode': [{ type: core_1.Input },],
	        'startingDay': [{ type: core_1.Input },],
	        'yearRange': [{ type: core_1.Input },],
	        'minDate': [{ type: core_1.Input },],
	        'maxDate': [{ type: core_1.Input },],
	        'minMode': [{ type: core_1.Input },],
	        'maxMode': [{ type: core_1.Input },],
	        'showWeeks': [{ type: core_1.Input },],
	        'formatDay': [{ type: core_1.Input },],
	        'formatMonth': [{ type: core_1.Input },],
	        'formatYear': [{ type: core_1.Input },],
	        'formatDayHeader': [{ type: core_1.Input },],
	        'formatDayTitle': [{ type: core_1.Input },],
	        'formatMonthTitle': [{ type: core_1.Input },],
	        'onlyCurrentMonth': [{ type: core_1.Input },],
	        'shortcutPropagation': [{ type: core_1.Input },],
	        'customClass': [{ type: core_1.Input },],
	        'monthColLimit': [{ type: core_1.Input },],
	        'yearColLimit': [{ type: core_1.Input },],
	        'dateDisabled': [{ type: core_1.Input },],
	        'initDate': [{ type: core_1.Input },],
	        'selectionDone': [{ type: core_1.Output },],
	        'update': [{ type: core_1.Output },],
	        'activeDate': [{ type: core_1.Input },],
	    };
	    return DatePickerInnerComponent;
	}());
	exports.DatePickerInnerComponent = DatePickerInnerComponent;


/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var moment = __webpack_require__(1082);
	var DateFormatter = (function () {
	    function DateFormatter() {
	    }
	    DateFormatter.prototype.format = function (date, format) {
	        return moment(date.getTime()).format(format);
	    };
	    return DateFormatter;
	}());
	exports.DateFormatter = DateFormatter;


/***/ },
/* 1082 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.15.1
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, function () { 'use strict';
	
	    var hookCallback;
	
	    function utils_hooks__hooks () {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback (callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return input != null && Object.prototype.toString.call(input) === '[object Object]';
	    }
	
	    function isObjectEmpty(obj) {
	        var k;
	        for (k in obj) {
	            // even if its not own property I'd still call it non-empty
	            return false;
	        }
	        return true;
	    }
	
	    function isDate(input) {
	        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
	    }
	
	    function map(arr, fn) {
	        var res = [], i;
	        for (i = 0; i < arr.length; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function create_utc__createUTC (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty           : false,
	            unusedTokens    : [],
	            unusedInput     : [],
	            overflow        : -2,
	            charsLeftOver   : 0,
	            nullInput       : false,
	            invalidMonth    : null,
	            invalidFormat   : false,
	            userInvalidated : false,
	            iso             : false,
	            parsedDateParts : [],
	            meridiem        : null
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this);
	            var len = t.length >>> 0;
	
	            for (var i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function valid__isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m);
	            var parsedParts = some.call(flags.parsedDateParts, function (i) {
	                return i != null;
	            });
	            var isNowValid = !isNaN(m._d.getTime()) &&
	                flags.overflow < 0 &&
	                !flags.empty &&
	                !flags.invalidMonth &&
	                !flags.invalidWeekday &&
	                !flags.nullInput &&
	                !flags.invalidFormat &&
	                !flags.userInvalidated &&
	                (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid = isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            }
	            else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function valid__createInvalid (flags) {
	        var m = create_utc__createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        }
	        else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = utils_hooks__hooks.momentProperties = [];
	
	    function copyConfig(to, from) {
	        var i, prop, val;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentProperties.length > 0) {
	            for (i in momentProperties) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    var updateInProgress = false;
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            utils_hooks__hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment (obj) {
	        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
	    }
	
	    function absFloor (number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if ((dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    function warn(msg) {
	        if (utils_hooks__hooks.suppressDeprecationWarnings === false &&
	                (typeof console !==  'undefined') && console.warn) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (utils_hooks__hooks.deprecationHandler != null) {
	                utils_hooks__hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [];
	                var arg;
	                for (var i = 0; i < arguments.length; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (var key in arguments[0]) {
	                            arg += key + ': ' + arguments[0][key] + ', ';
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (utils_hooks__hooks.deprecationHandler != null) {
	            utils_hooks__hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    utils_hooks__hooks.suppressDeprecationWarnings = false;
	    utils_hooks__hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	    function locale_set__set (config) {
	        var prop, i;
	        for (i in config) {
	            prop = config[i];
	            if (isFunction(prop)) {
	                this[i] = prop;
	            } else {
	                this['_' + i] = prop;
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _ordinalParseLenient.
	        this._ordinalParseLenient = new RegExp(this._ordinalParse.source + '|' + (/\d{1,2}/).source);
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig), prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (hasOwnProp(parentConfig, prop) &&
	                    !hasOwnProp(childConfig, prop) &&
	                    isObject(parentConfig[prop])) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i, res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay : '[Today at] LT',
	        nextDay : '[Tomorrow at] LT',
	        nextWeek : 'dddd [at] LT',
	        lastDay : '[Yesterday at] LT',
	        lastWeek : '[Last] dddd [at] LT',
	        sameElse : 'L'
	    };
	
	    function locale_calendar__calendar (key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    var defaultLongDateFormat = {
	        LTS  : 'h:mm:ss A',
	        LT   : 'h:mm A',
	        L    : 'MM/DD/YYYY',
	        LL   : 'MMMM D, YYYY',
	        LLL  : 'MMMM D, YYYY h:mm A',
	        LLLL : 'dddd, MMMM D, YYYY h:mm A'
	    };
	
	    function longDateFormat (key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
	            return val.slice(1);
	        });
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate () {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d';
	    var defaultOrdinalParse = /\d{1,2}/;
	
	    function ordinal (number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future : 'in %s',
	        past   : '%s ago',
	        s  : 'a few seconds',
	        m  : 'a minute',
	        mm : '%d minutes',
	        h  : 'an hour',
	        hh : '%d hours',
	        d  : 'a day',
	        dd : '%d days',
	        M  : 'a month',
	        MM : '%d months',
	        y  : 'a year',
	        yy : '%d years'
	    };
	
	    function relative__relativeTime (number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return (isFunction(output)) ?
	            output(number, withoutSuffix, string, isFuture) :
	            output.replace(/%d/i, number);
	    }
	
	    function pastFuture (diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias (unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [];
	        for (var u in unitsObj) {
	            units.push({unit: u, priority: priorities[u]});
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function makeGetSet (unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                get_set__set(this, unit, value);
	                utils_hooks__hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get_set__get(this, unit);
	            }
	        };
	    }
	
	    function get_set__get (mom, unit) {
	        return mom.isValid() ?
	            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
	    }
	
	    function get_set__set (mom, unit, value) {
	        if (mom.isValid()) {
	            mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet (units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	
	    function stringSet (units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units);
	            for (var i = 0; i < prioritized.length; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
	    }
	
	    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;
	
	    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;
	
	    var formatFunctions = {};
	
	    var formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken (token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(func.apply(this, arguments), token);
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens), i, length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '', i;
	            for (i = 0; i < length; i++) {
	                output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var match1         = /\d/;            //       0 - 9
	    var match2         = /\d\d/;          //      00 - 99
	    var match3         = /\d{3}/;         //     000 - 999
	    var match4         = /\d{4}/;         //    0000 - 9999
	    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
	    var match1to2      = /\d\d?/;         //       0 - 99
	    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
	    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
	    var match1to3      = /\d{1,3}/;       //       0 - 999
	    var match1to4      = /\d{1,4}/;       //       0 - 9999
	    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999
	
	    var matchUnsigned  = /\d+/;           //       0 - inf
	    var matchSigned    = /[+-]?\d+/;      //    -inf - inf
	
	    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
	    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	
	    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123
	
	    // any word (or two) characters or numbers including two/three word month in arabic.
	    // includes scottish gaelic two word and hyphenated months
	    var matchWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i;
	
	
	    var regexes = {};
	
	    function addRegexToken (token, regex, strictRegex) {
	        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
	            return (isStrict && strictRegex) ? strictRegex : regex;
	        };
	    }
	
	    function getParseRegexForToken (token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
	            return p1 || p2 || p3 || p4;
	        }));
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken (token, callback) {
	        var i, func = callback;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (typeof callback === 'number') {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        for (i = 0; i < token.length; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken (token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0;
	    var MONTH = 1;
	    var DATE = 2;
	    var HOUR = 3;
	    var MINUTE = 4;
	    var SECOND = 5;
	    var MILLISECOND = 6;
	    var WEEK = 7;
	    var WEEKDAY = 8;
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M',    match1to2);
	    addRegexToken('MM',   match1to2, match2);
	    addRegexToken('MMM',  function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?/;
	    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
	    function localeMonths (m, format) {
	        if (!m) {
	            return this._months;
	        }
	        return isArray(this._months) ? this._months[m.month()] :
	            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
	    function localeMonthsShort (m, format) {
	        if (!m) {
	            return this._monthsShort;
	        }
	        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
	            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
	    }
	
	    function units_month__handleStrictParse(monthName, format, strict) {
	        var i, ii, mom, llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = create_utc__createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse (monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return units_month__handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = create_utc__createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
	                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth (mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (typeof value !== 'number') {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth (value) {
	        if (value != null) {
	            setMonth(this, value);
	            utils_hooks__hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get_set__get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth () {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    var defaultMonthsShortRegex = matchWord;
	    function monthsShortRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict ?
	                this._monthsShortStrictRegex : this._monthsShortRegex;
	        }
	    }
	
	    var defaultMonthsRegex = matchWord;
	    function monthsRegex (isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict ?
	                this._monthsStrictRegex : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = create_utc__createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? '' + y : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY',   4],       0, 'year');
	    addFormatToken(0, ['YYYYY',  5],       0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y',      matchSigned);
	    addRegexToken('YY',     match1to2, match2);
	    addRegexToken('YYYY',   match1to4, match4);
	    addRegexToken('YYYYY',  match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] = input.length === 2 ? utils_hooks__hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = utils_hooks__hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    // HOOKS
	
	    utils_hooks__hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear () {
	        return isLeapYear(this.year());
	    }
	
	    function createDate (y, m, d, h, M, s, ms) {
	        //can't just apply() to create a date:
	        //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
	        var date = new Date(y, m, d, h, M, s, ms);
	
	        //the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0 && isFinite(date.getFullYear())) {
	            date.setFullYear(y);
	        }
	        return date;
	    }
	
	    function createUTCDate (y) {
	        var date = new Date(Date.UTC.apply(null, arguments));
	
	        //the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0 && isFinite(date.getUTCFullYear())) {
	            date.setUTCFullYear(y);
	        }
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    //http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear, resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek, resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w',  match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W',  match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
	        week[token.substr(0, 1)] = toInt(input);
	    });
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek (mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow : 0, // Sunday is the first day of the week.
	        doy : 6  // The week that contains Jan 1st is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek () {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear () {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek (input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek (input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d',    match1to2);
	    addRegexToken('e',    match1to2);
	    addRegexToken('E',    match1to2);
	    addRegexToken('dd',   function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd',   function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd',   function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	
	    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
	    function localeWeekdays (m, format) {
	        if (!m) {
	            return this._weekdays;
	        }
	        return isArray(this._weekdays) ? this._weekdays[m.day()] :
	            this._weekdays[this._weekdays.isFormat.test(format) ? 'format' : 'standalone'][m.day()];
	    }
	
	    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
	    function localeWeekdaysShort (m) {
	        return (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
	    }
	
	    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
	    function localeWeekdaysMin (m) {
	        return (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
	    }
	
	    function day_of_week__handleStrictParse(weekdayName, format, strict) {
	        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = create_utc__createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse (weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return day_of_week__handleStrictParse.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = create_utc__createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\.?') + '$', 'i');
	                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\.?') + '$', 'i');
	                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\.?') + '$', 'i');
	            }
	            if (!this._weekdaysParse[i]) {
	                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek (input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    var defaultWeekdaysRegex = matchWord;
	    function weekdaysRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict ?
	                this._weekdaysStrictRegex : this._weekdaysRegex;
	        }
	    }
	
	    var defaultWeekdaysShortRegex = matchWord;
	    function weekdaysShortRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict ?
	                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
	        }
	    }
	
	    var defaultWeekdaysMinRegex = matchWord;
	    function weekdaysMinRegex (isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict ?
	                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
	        }
	    }
	
	
	    function computeWeekdaysParse () {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
	            i, mom, minp, shortp, longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = create_utc__createUTC([2000, 1]).day(i);
	            minp = this.weekdaysMin(mom, '');
	            shortp = this.weekdaysShort(mom, '');
	            longp = this.weekdays(mom, '');
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 7; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
	        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
	        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2);
	    });
	
	    function meridiem (token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem (isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a',  matchMeridiem);
	    addRegexToken('A',  matchMeridiem);
	    addRegexToken('H',  match1to2);
	    addRegexToken('h',  match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4;
	        var pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM (input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return ((input + '').toLowerCase().charAt(0) === 'p');
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
	    function localeMeridiem (hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	
	    // MOMENTS
	
	    // Setting the hour should keep the time, because the user explicitly
	    // specified which hour he wants. So trying to maintain the same hour (in
	    // a new timezone) makes sense. Adding/subtracting hours does not follow
	    // this rule.
	    var getSetHour = makeGetSet('Hours', true);
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        ordinalParse: defaultOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse
	    };
	
	    // internal storage for locale config files
	    var locales = {};
	    var globalLocale;
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0, j, next, locale, split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return null;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (!locales[name] && (typeof module !== 'undefined') &&
	                module && module.exports) {
	            try {
	                oldLocale = globalLocale._abbr;
	                __webpack_require__(1083)("./" + name);
	                // because defineLocale currently also sets the global locale, we
	                // want to undo that for lazy loaded locales
	                locale_locales__getSetGlobalLocale(oldLocale);
	            } catch (e) { }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function locale_locales__getSetGlobalLocale (key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = locale_locales__getLocale(key);
	            }
	            else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale (name, config) {
	        if (config !== null) {
	            var parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple('defineLocaleOverride',
	                        'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    // treat as if there is no base config
	                    deprecateSimple('parentLocaleUndefined',
	                            'specified parentLocale is not defined yet. See http://momentjs.com/guides/#/warnings/parent-locale/');
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            // backwards compat for now: also set the locale
	            locale_locales__getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale, parentConfig = baseConfig;
	            // MERGE
	            if (locales[name] != null) {
	                parentConfig = locales[name]._config;
	            }
	            config = mergeConfigs(parentConfig, config);
	            locale = new Locale(config);
	            locale.parentLocale = locales[name];
	            locales[name] = locale;
	
	            // backwards compat for now: also set the locale
	            locale_locales__getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function locale_locales__getLocale (key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function locale_locales__listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow (m) {
	        var overflow;
	        var a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
	                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
	                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
	                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
	                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
	                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
	                -1;
	
	            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
	    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?/;
	
	    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;
	
	    var isoDates = [
	        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	        ['YYYY-DDD', /\d{4}-\d{3}/],
	        ['YYYY-MM', /\d{4}-\d\d/, false],
	        ['YYYYYYMMDD', /[+-]\d{10}/],
	        ['YYYYMMDD', /\d{8}/],
	        // YYYYMM is NOT allowed by the standard
	        ['GGGG[W]WWE', /\d{4}W\d{3}/],
	        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	        ['YYYYDDD', /\d{7}/]
	    ];
	
	    // iso time formats and regexes
	    var isoTimes = [
	        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	        ['HH:mm', /\d\d:\d\d/],
	        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	        ['HHmmss', /\d\d\d\d\d\d/],
	        ['HHmm', /\d\d\d\d/],
	        ['HH', /\d\d/]
	    ];
	
	    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;
	
	    // date from iso format
	    function configFromISO(config) {
	        var i, l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime, dateFormat, timeFormat, tzFormat;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	
	            for (i = 0, l = isoDates.length; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimes.length; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from iso format or fallback
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	            utils_hooks__hooks.createFromInputFallback(config);
	        }
	    }
	
	    utils_hooks__hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized ISO format. moment construction falls back to js Date(), ' +
	        'which is not reliable across all browsers and versions. Non ISO date formats are ' +
	        'discouraged and will be removed in an upcoming major release. Please refer to ' +
	        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(utils_hooks__hooks.now());
	        if (config._useUTC) {
	            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray (config) {
	        var i, date, input = [], currentDate, yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (config._dayOfYear > daysInYear(yearToUse)) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (config._a[HOUR] === 24 &&
	                config._a[MINUTE] === 0 &&
	                config._a[SECOND] === 0 &&
	                config._a[MILLISECOND] === 0) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(local__createLocal(), 1, 4).year);
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            weekYear = defaults(w.gg, config._a[YEAR], weekOfYear(local__createLocal(), dow, doy).year);
	            week = defaults(w.w, 1);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from begining of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to begining of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    utils_hooks__hooks.ISO_8601 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === utils_hooks__hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i, parsedInput, tokens, token, skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0;
	
	        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
	
	        for (i = 0; i < tokens.length; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
	            // console.log('token', token, 'parsedInput', parsedInput,
	            //         'regex', getParseRegexForToken(token, config));
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                }
	                else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            }
	            else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	
	    function meridiemFixWrap (locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	
	            scoreToBeat,
	            i,
	            currentScore;
	
	        if (config._f.length === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < config._f.length; i++) {
	            currentScore = 0;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (!valid__isValid(tempConfig)) {
	                continue;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (scoreToBeat == null || currentScore < scoreToBeat) {
	                scoreToBeat = currentScore;
	                bestMoment = tempConfig;
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i);
	        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
	            return obj && parseInt(obj, 10);
	        });
	
	        configFromArray(config);
	    }
	
	    function createFromConfig (config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig (config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || locale_locales__getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return valid__createInvalid({nullInput: true});
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (format) {
	            configFromStringAndFormat(config);
	        }  else {
	            configFromInput(config);
	        }
	
	        if (!valid__isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (input === undefined) {
	            config._d = new Date(utils_hooks__hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (typeof(input) === 'object') {
	            configFromObject(config);
	        } else if (typeof(input) === 'number') {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            utils_hooks__hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC (input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (typeof(locale) === 'boolean') {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if ((isObject(input) && isObjectEmpty(input)) ||
	                (isArray(input) && input.length === 0)) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function local__createLocal (input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = local__createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other < this ? this : other;
	            } else {
	                return valid__createInvalid();
	            }
	        }
	    );
	
	    var prototypeMax = deprecate(
	        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	        function () {
	            var other = local__createLocal.apply(null, arguments);
	            if (this.isValid() && other.isValid()) {
	                return other > this ? this : other;
	            } else {
	                return valid__createInvalid();
	            }
	        }
	    );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return local__createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max () {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +(new Date());
	    };
	
	    function Duration (duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        // representation for dateAddRemove
	        this._milliseconds = +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days +
	            weeks * 7;
	        // It is impossible translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months +
	            quarters * 3 +
	            years * 12;
	
	        this._data = {};
	
	        this._locale = locale_locales__getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration (obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound (number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // FORMATTING
	
	    function offset (token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset();
	            var sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z',  matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = ((string || '').match(matcher) || []);
	        var chunk   = matches[matches.length - 1] || [];
	        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        var minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff = (isMoment(input) || isDate(input) ? input.valueOf() : local__createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            utils_hooks__hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return local__createLocal(input).local();
	        }
	    }
	
	    function getDateOffset (m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    utils_hooks__hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset (input, keepLocalTime) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	            } else if (Math.abs(input) < 16) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    add_subtract__addSubtract(this, create__createDuration(input - offset, 'm'), 1, false);
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    utils_hooks__hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone (input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC (keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal (keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset () {
	        if (this._tzm) {
	            this.utcOffset(this._tzm);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	
	            if (tZone === 0) {
	                this.utcOffset(0, true);
	            } else {
	                this.utcOffset(offsetFromString(matchOffset, this._i));
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset (input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? local__createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime () {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted () {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {};
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            var other = c._isUTC ? create_utc__createUTC(c._a) : local__createLocal(c._a);
	            this._isDSTShifted = this.isValid() &&
	                compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal () {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset () {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc () {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(\-)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;
	
	    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	    // and further modified to allow for strings containing both week and day
	    var isoRegex = /^(-)?P(?:(-?[0-9,.]*)Y)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)W)?(?:(-?[0-9,.]*)D)?(?:T(?:(-?[0-9,.]*)H)?(?:(-?[0-9,.]*)M)?(?:(-?[0-9,.]*)S)?)?$/;
	
	    function create__createDuration (input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms : input._milliseconds,
	                d  : input._days,
	                M  : input._months
	            };
	        } else if (typeof input === 'number') {
	            duration = {};
	            if (key) {
	                duration[key] = input;
	            } else {
	                duration.milliseconds = input;
	            }
	        } else if (!!(match = aspNetRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y  : 0,
	                d  : toInt(match[DATE])                         * sign,
	                h  : toInt(match[HOUR])                         * sign,
	                m  : toInt(match[MINUTE])                       * sign,
	                s  : toInt(match[SECOND])                       * sign,
	                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
	            };
	        } else if (!!(match = isoRegex.exec(input))) {
	            sign = (match[1] === '-') ? -1 : 1;
	            duration = {
	                y : parseIso(match[2], sign),
	                M : parseIso(match[3], sign),
	                w : parseIso(match[4], sign),
	                d : parseIso(match[5], sign),
	                h : parseIso(match[6], sign),
	                m : parseIso(match[7], sign),
	                s : parseIso(match[8], sign)
	            };
	        } else if (duration == null) {// checks for null or undefined
	            duration = {};
	        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
	            diffRes = momentsDifference(local__createLocal(duration.from), local__createLocal(duration.to));
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        return ret;
	    }
	
	    create__createDuration.fn = Duration.prototype;
	
	    function parseIso (inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {milliseconds: 0, months: 0};
	
	        res.months = other.month() - base.month() +
	            (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return {milliseconds: 0, months: 0};
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
	                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
	                tmp = val; val = period; period = tmp;
	            }
	
	            val = typeof val === 'string' ? +val : val;
	            dur = create__createDuration(val, period);
	            add_subtract__addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function add_subtract__addSubtract (mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (days) {
	            get_set__set(mom, 'Date', get_set__get(mom, 'Date') + days * isAdding);
	        }
	        if (months) {
	            setMonth(mom, get_set__get(mom, 'Month') + months * isAdding);
	        }
	        if (updateOffset) {
	            utils_hooks__hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add_subtract__add      = createAdder(1, 'add');
	    var add_subtract__subtract = createAdder(-1, 'subtract');
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6 ? 'sameElse' :
	                diff < -1 ? 'lastWeek' :
	                diff < 0 ? 'lastDay' :
	                diff < 1 ? 'sameDay' :
	                diff < 2 ? 'nextDay' :
	                diff < 7 ? 'nextWeek' : 'sameElse';
	    }
	
	    function moment_calendar__calendar (time, formats) {
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || local__createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = utils_hooks__hooks.calendarFormat(this, sod) || 'sameElse';
	
	        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
	
	        return this.format(output || this.localeData().calendar(format, this, local__createLocal(now)));
	    }
	
	    function clone () {
	        return new Moment(this);
	    }
	
	    function isAfter (input, units) {
	        var localInput = isMoment(input) ? input : local__createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore (input, units) {
	        var localInput = isMoment(input) ? input : local__createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(!isUndefined(units) ? units : 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween (from, to, units, inclusivity) {
	        inclusivity = inclusivity || '()';
	        return (inclusivity[0] === '(' ? this.isAfter(from, units) : !this.isBefore(from, units)) &&
	            (inclusivity[1] === ')' ? this.isBefore(to, units) : !this.isAfter(to, units));
	    }
	
	    function isSame (input, units) {
	        var localInput = isMoment(input) ? input : local__createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units || 'millisecond');
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
	        }
	    }
	
	    function isSameOrAfter (input, units) {
	        return this.isSame(input, units) || this.isAfter(input,units);
	    }
	
	    function isSameOrBefore (input, units) {
	        return this.isSame(input, units) || this.isBefore(input,units);
	    }
	
	    function diff (input, units, asFloat) {
	        var that,
	            zoneDelta,
	            delta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        if (units === 'year' || units === 'month' || units === 'quarter') {
	            output = monthDiff(this, that);
	            if (units === 'quarter') {
	                output = output / 3;
	            } else if (units === 'year') {
	                output = output / 12;
	            }
	        } else {
	            delta = this - that;
	            output = units === 'second' ? delta / 1e3 : // 1000
	                units === 'minute' ? delta / 6e4 : // 1000 * 60
	                units === 'hour' ? delta / 36e5 : // 1000 * 60 * 60
	                units === 'day' ? (delta - zoneDelta) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
	                units === 'week' ? (delta - zoneDelta) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
	                delta;
	        }
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff (a, b) {
	        // difference in months
	        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2, adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    utils_hooks__hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    utils_hooks__hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString () {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function moment_format__toISOString () {
	        var m = this.clone().utc();
	        if (0 < m.year() && m.year() <= 9999) {
	            if (isFunction(Date.prototype.toISOString)) {
	                // native implementation is ~50x faster, use it when we can
	                return this.toDate().toISOString();
	            } else {
	                return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	            }
	        } else {
	            return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
	        }
	    }
	
	    function format (inputString) {
	        if (!inputString) {
	            inputString = this.isUtc() ? utils_hooks__hooks.defaultFormatUtc : utils_hooks__hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 local__createLocal(time).isValid())) {
	            return create__createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow (withoutSuffix) {
	        return this.from(local__createLocal(), withoutSuffix);
	    }
	
	    function to (time, withoutSuffix) {
	        if (this.isValid() &&
	                ((isMoment(time) && time.isValid()) ||
	                 local__createLocal(time).isValid())) {
	            return create__createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow (withoutSuffix) {
	        return this.to(local__createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale (key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = locale_locales__getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData () {
	        return this._locale;
	    }
	
	    function startOf (units) {
	        units = normalizeUnits(units);
	        // the following switch intentionally omits break keywords
	        // to utilize falling through the cases.
	        switch (units) {
	            case 'year':
	                this.month(0);
	                /* falls through */
	            case 'quarter':
	            case 'month':
	                this.date(1);
	                /* falls through */
	            case 'week':
	            case 'isoWeek':
	            case 'day':
	            case 'date':
	                this.hours(0);
	                /* falls through */
	            case 'hour':
	                this.minutes(0);
	                /* falls through */
	            case 'minute':
	                this.seconds(0);
	                /* falls through */
	            case 'second':
	                this.milliseconds(0);
	        }
	
	        // weeks are a special case
	        if (units === 'week') {
	            this.weekday(0);
	        }
	        if (units === 'isoWeek') {
	            this.isoWeekday(1);
	        }
	
	        // quarters are also special
	        if (units === 'quarter') {
	            this.month(Math.floor(this.month() / 3) * 3);
	        }
	
	        return this;
	    }
	
	    function endOf (units) {
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond') {
	            return this;
	        }
	
	        // 'date' is an alias for 'day', so it should be considered as such.
	        if (units === 'date') {
	            units = 'day';
	        }
	
	        return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
	    }
	
	    function to_type__valueOf () {
	        return this._d.valueOf() - ((this._offset || 0) * 60000);
	    }
	
	    function unix () {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate () {
	        return new Date(this.valueOf());
	    }
	
	    function toArray () {
	        var m = this;
	        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
	    }
	
	    function toObject () {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds()
	        };
	    }
	
	    function toJSON () {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function moment_valid__isValid () {
	        return valid__isValid(this);
	    }
	
	    function parsingFlags () {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt () {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict
	        };
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken (token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg',     'weekYear');
	    addWeekYearFormatToken('ggggg',    'weekYear');
	    addWeekYearFormatToken('GGGG',  'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	
	    // PARSING
	
	    addRegexToken('G',      matchSigned);
	    addRegexToken('g',      matchSigned);
	    addRegexToken('GG',     match1to2, match2);
	    addRegexToken('gg',     match1to2, match2);
	    addRegexToken('GGGG',   match1to4, match4);
	    addRegexToken('gggg',   match1to4, match4);
	    addRegexToken('GGGGG',  match1to6, match6);
	    addRegexToken('ggggg',  match1to6, match6);
	
	    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
	        week[token.substr(0, 2)] = toInt(input);
	    });
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = utils_hooks__hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input,
	                this.week(),
	                this.weekday(),
	                this.localeData()._week.dow,
	                this.localeData()._week.doy);
	    }
	
	    function getSetISOWeekYear (input) {
	        return getSetWeekYearHelper.call(this,
	                input, this.isoWeek(), this.isoWeekday(), 1, 4);
	    }
	
	    function getISOWeeksInYear () {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getWeeksInYear () {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter (input) {
	        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIOROITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D',  match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        return isStrict ? locale._ordinalParse : locale._ordinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0], 10);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD',  match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear (input) {
	        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
	        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m',  match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s',  match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S',    match1to3, match1);
	    addRegexToken('SS',   match1to3, match2);
	    addRegexToken('SSS',  match1to3, match3);
	
	    var token;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	    // MOMENTS
	
	    var getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z',  0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr () {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName () {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var momentPrototype__proto = Moment.prototype;
	
	    momentPrototype__proto.add               = add_subtract__add;
	    momentPrototype__proto.calendar          = moment_calendar__calendar;
	    momentPrototype__proto.clone             = clone;
	    momentPrototype__proto.diff              = diff;
	    momentPrototype__proto.endOf             = endOf;
	    momentPrototype__proto.format            = format;
	    momentPrototype__proto.from              = from;
	    momentPrototype__proto.fromNow           = fromNow;
	    momentPrototype__proto.to                = to;
	    momentPrototype__proto.toNow             = toNow;
	    momentPrototype__proto.get               = stringGet;
	    momentPrototype__proto.invalidAt         = invalidAt;
	    momentPrototype__proto.isAfter           = isAfter;
	    momentPrototype__proto.isBefore          = isBefore;
	    momentPrototype__proto.isBetween         = isBetween;
	    momentPrototype__proto.isSame            = isSame;
	    momentPrototype__proto.isSameOrAfter     = isSameOrAfter;
	    momentPrototype__proto.isSameOrBefore    = isSameOrBefore;
	    momentPrototype__proto.isValid           = moment_valid__isValid;
	    momentPrototype__proto.lang              = lang;
	    momentPrototype__proto.locale            = locale;
	    momentPrototype__proto.localeData        = localeData;
	    momentPrototype__proto.max               = prototypeMax;
	    momentPrototype__proto.min               = prototypeMin;
	    momentPrototype__proto.parsingFlags      = parsingFlags;
	    momentPrototype__proto.set               = stringSet;
	    momentPrototype__proto.startOf           = startOf;
	    momentPrototype__proto.subtract          = add_subtract__subtract;
	    momentPrototype__proto.toArray           = toArray;
	    momentPrototype__proto.toObject          = toObject;
	    momentPrototype__proto.toDate            = toDate;
	    momentPrototype__proto.toISOString       = moment_format__toISOString;
	    momentPrototype__proto.toJSON            = toJSON;
	    momentPrototype__proto.toString          = toString;
	    momentPrototype__proto.unix              = unix;
	    momentPrototype__proto.valueOf           = to_type__valueOf;
	    momentPrototype__proto.creationData      = creationData;
	
	    // Year
	    momentPrototype__proto.year       = getSetYear;
	    momentPrototype__proto.isLeapYear = getIsLeapYear;
	
	    // Week Year
	    momentPrototype__proto.weekYear    = getSetWeekYear;
	    momentPrototype__proto.isoWeekYear = getSetISOWeekYear;
	
	    // Quarter
	    momentPrototype__proto.quarter = momentPrototype__proto.quarters = getSetQuarter;
	
	    // Month
	    momentPrototype__proto.month       = getSetMonth;
	    momentPrototype__proto.daysInMonth = getDaysInMonth;
	
	    // Week
	    momentPrototype__proto.week           = momentPrototype__proto.weeks        = getSetWeek;
	    momentPrototype__proto.isoWeek        = momentPrototype__proto.isoWeeks     = getSetISOWeek;
	    momentPrototype__proto.weeksInYear    = getWeeksInYear;
	    momentPrototype__proto.isoWeeksInYear = getISOWeeksInYear;
	
	    // Day
	    momentPrototype__proto.date       = getSetDayOfMonth;
	    momentPrototype__proto.day        = momentPrototype__proto.days             = getSetDayOfWeek;
	    momentPrototype__proto.weekday    = getSetLocaleDayOfWeek;
	    momentPrototype__proto.isoWeekday = getSetISODayOfWeek;
	    momentPrototype__proto.dayOfYear  = getSetDayOfYear;
	
	    // Hour
	    momentPrototype__proto.hour = momentPrototype__proto.hours = getSetHour;
	
	    // Minute
	    momentPrototype__proto.minute = momentPrototype__proto.minutes = getSetMinute;
	
	    // Second
	    momentPrototype__proto.second = momentPrototype__proto.seconds = getSetSecond;
	
	    // Millisecond
	    momentPrototype__proto.millisecond = momentPrototype__proto.milliseconds = getSetMillisecond;
	
	    // Offset
	    momentPrototype__proto.utcOffset            = getSetOffset;
	    momentPrototype__proto.utc                  = setOffsetToUTC;
	    momentPrototype__proto.local                = setOffsetToLocal;
	    momentPrototype__proto.parseZone            = setOffsetToParsedOffset;
	    momentPrototype__proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    momentPrototype__proto.isDST                = isDaylightSavingTime;
	    momentPrototype__proto.isLocal              = isLocal;
	    momentPrototype__proto.isUtcOffset          = isUtcOffset;
	    momentPrototype__proto.isUtc                = isUtc;
	    momentPrototype__proto.isUTC                = isUtc;
	
	    // Timezone
	    momentPrototype__proto.zoneAbbr = getZoneAbbr;
	    momentPrototype__proto.zoneName = getZoneName;
	
	    // Deprecations
	    momentPrototype__proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
	    momentPrototype__proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
	    momentPrototype__proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
	    momentPrototype__proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
	    momentPrototype__proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
	
	    var momentPrototype = momentPrototype__proto;
	
	    function moment__createUnix (input) {
	        return local__createLocal(input * 1000);
	    }
	
	    function moment__createInZone () {
	        return local__createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat (string) {
	        return string;
	    }
	
	    var prototype__proto = Locale.prototype;
	
	    prototype__proto.calendar        = locale_calendar__calendar;
	    prototype__proto.longDateFormat  = longDateFormat;
	    prototype__proto.invalidDate     = invalidDate;
	    prototype__proto.ordinal         = ordinal;
	    prototype__proto.preparse        = preParsePostFormat;
	    prototype__proto.postformat      = preParsePostFormat;
	    prototype__proto.relativeTime    = relative__relativeTime;
	    prototype__proto.pastFuture      = pastFuture;
	    prototype__proto.set             = locale_set__set;
	
	    // Month
	    prototype__proto.months            =        localeMonths;
	    prototype__proto.monthsShort       =        localeMonthsShort;
	    prototype__proto.monthsParse       =        localeMonthsParse;
	    prototype__proto.monthsRegex       = monthsRegex;
	    prototype__proto.monthsShortRegex  = monthsShortRegex;
	
	    // Week
	    prototype__proto.week = localeWeek;
	    prototype__proto.firstDayOfYear = localeFirstDayOfYear;
	    prototype__proto.firstDayOfWeek = localeFirstDayOfWeek;
	
	    // Day of Week
	    prototype__proto.weekdays       =        localeWeekdays;
	    prototype__proto.weekdaysMin    =        localeWeekdaysMin;
	    prototype__proto.weekdaysShort  =        localeWeekdaysShort;
	    prototype__proto.weekdaysParse  =        localeWeekdaysParse;
	
	    prototype__proto.weekdaysRegex       =        weekdaysRegex;
	    prototype__proto.weekdaysShortRegex  =        weekdaysShortRegex;
	    prototype__proto.weekdaysMinRegex    =        weekdaysMinRegex;
	
	    // Hours
	    prototype__proto.isPM = localeIsPM;
	    prototype__proto.meridiem = localeMeridiem;
	
	    function lists__get (format, index, field, setter) {
	        var locale = locale_locales__getLocale();
	        var utc = create_utc__createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl (format, index, field) {
	        if (typeof format === 'number') {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return lists__get(format, index, field, 'month');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = lists__get(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl (localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (typeof format === 'number') {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (typeof format === 'number') {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = locale_locales__getLocale(),
	            shift = localeSorted ? locale._week.dow : 0;
	
	        if (index != null) {
	            return lists__get(format, (index + shift) % 7, field, 'day');
	        }
	
	        var i;
	        var out = [];
	        for (i = 0; i < 7; i++) {
	            out[i] = lists__get(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function lists__listMonths (format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function lists__listMonthsShort (format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function lists__listWeekdays (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function lists__listWeekdaysShort (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function lists__listWeekdaysMin (localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    locale_locales__getSetGlobalLocale('en', {
	        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (toInt(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    // Side effect imports
	    utils_hooks__hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', locale_locales__getSetGlobalLocale);
	    utils_hooks__hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', locale_locales__getLocale);
	
	    var mathAbs = Math.abs;
	
	    function duration_abs__abs () {
	        var data           = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days         = mathAbs(this._days);
	        this._months       = mathAbs(this._months);
	
	        data.milliseconds  = mathAbs(data.milliseconds);
	        data.seconds       = mathAbs(data.seconds);
	        data.minutes       = mathAbs(data.minutes);
	        data.hours         = mathAbs(data.hours);
	        data.months        = mathAbs(data.months);
	        data.years         = mathAbs(data.years);
	
	        return this;
	    }
	
	    function duration_add_subtract__addSubtract (duration, input, value, direction) {
	        var other = create__createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days         += direction * other._days;
	        duration._months       += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function duration_add_subtract__add (input, value) {
	        return duration_add_subtract__addSubtract(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function duration_add_subtract__subtract (input, value) {
	        return duration_add_subtract__addSubtract(this, input, value, -1);
	    }
	
	    function absCeil (number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble () {
	        var milliseconds = this._milliseconds;
	        var days         = this._days;
	        var months       = this._months;
	        var data         = this._data;
	        var seconds, minutes, hours, years, monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0))) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds           = absFloor(milliseconds / 1000);
	        data.seconds      = seconds % 60;
	
	        minutes           = absFloor(seconds / 60);
	        data.minutes      = minutes % 60;
	
	        hours             = absFloor(minutes / 60);
	        data.hours        = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days   = days;
	        data.months = months;
	        data.years  = years;
	
	        return this;
	    }
	
	    function daysToMonths (days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return days * 4800 / 146097;
	    }
	
	    function monthsToDays (months) {
	        // the reverse of daysToMonths
	        return months * 146097 / 4800;
	    }
	
	    function as (units) {
	        var days;
	        var months;
	        var milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'year') {
	            days   = this._days   + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            return units === 'month' ? months : months / 12;
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week'   : return days / 7     + milliseconds / 6048e5;
	                case 'day'    : return days         + milliseconds / 864e5;
	                case 'hour'   : return days * 24    + milliseconds / 36e5;
	                case 'minute' : return days * 1440  + milliseconds / 6e4;
	                case 'second' : return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
	                default: throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function duration_as__valueOf () {
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs (alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms');
	    var asSeconds      = makeAs('s');
	    var asMinutes      = makeAs('m');
	    var asHours        = makeAs('h');
	    var asDays         = makeAs('d');
	    var asWeeks        = makeAs('w');
	    var asMonths       = makeAs('M');
	    var asYears        = makeAs('y');
	
	    function duration_get__get (units) {
	        units = normalizeUnits(units);
	        return this[units + 's']();
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this._data[name];
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds');
	    var seconds      = makeGetter('seconds');
	    var minutes      = makeGetter('minutes');
	    var hours        = makeGetter('hours');
	    var days         = makeGetter('days');
	    var months       = makeGetter('months');
	    var years        = makeGetter('years');
	
	    function weeks () {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round;
	    var thresholds = {
	        s: 45,  // seconds to minute
	        m: 45,  // minutes to hour
	        h: 22,  // hours to day
	        d: 26,  // days to month
	        M: 11   // months to year
	    };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function duration_humanize__relativeTime (posNegDuration, withoutSuffix, locale) {
	        var duration = create__createDuration(posNegDuration).abs();
	        var seconds  = round(duration.as('s'));
	        var minutes  = round(duration.as('m'));
	        var hours    = round(duration.as('h'));
	        var days     = round(duration.as('d'));
	        var months   = round(duration.as('M'));
	        var years    = round(duration.as('y'));
	
	        var a = seconds < thresholds.s && ['s', seconds]  ||
	                minutes <= 1           && ['m']           ||
	                minutes < thresholds.m && ['mm', minutes] ||
	                hours   <= 1           && ['h']           ||
	                hours   < thresholds.h && ['hh', hours]   ||
	                days    <= 1           && ['d']           ||
	                days    < thresholds.d && ['dd', days]    ||
	                months  <= 1           && ['M']           ||
	                months  < thresholds.M && ['MM', months]  ||
	                years   <= 1           && ['y']           || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function duration_humanize__getSetRelativeTimeRounding (roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof(roundingFunction) === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function duration_humanize__getSetRelativeTimeThreshold (threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        return true;
	    }
	
	    function humanize (withSuffix) {
	        var locale = this.localeData();
	        var output = duration_humanize__relativeTime(this, !withSuffix, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var iso_string__abs = Math.abs;
	
	    function iso_string__toISOString() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        var seconds = iso_string__abs(this._milliseconds) / 1000;
	        var days         = iso_string__abs(this._days);
	        var months       = iso_string__abs(this._months);
	        var minutes, hours, years;
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes           = absFloor(seconds / 60);
	        hours             = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years  = absFloor(months / 12);
	        months %= 12;
	
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        var Y = years;
	        var M = months;
	        var D = days;
	        var h = hours;
	        var m = minutes;
	        var s = seconds;
	        var total = this.asSeconds();
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        return (total < 0 ? '-' : '') +
	            'P' +
	            (Y ? Y + 'Y' : '') +
	            (M ? M + 'M' : '') +
	            (D ? D + 'D' : '') +
	            ((h || m || s) ? 'T' : '') +
	            (h ? h + 'H' : '') +
	            (m ? m + 'M' : '') +
	            (s ? s + 'S' : '');
	    }
	
	    var duration_prototype__proto = Duration.prototype;
	
	    duration_prototype__proto.abs            = duration_abs__abs;
	    duration_prototype__proto.add            = duration_add_subtract__add;
	    duration_prototype__proto.subtract       = duration_add_subtract__subtract;
	    duration_prototype__proto.as             = as;
	    duration_prototype__proto.asMilliseconds = asMilliseconds;
	    duration_prototype__proto.asSeconds      = asSeconds;
	    duration_prototype__proto.asMinutes      = asMinutes;
	    duration_prototype__proto.asHours        = asHours;
	    duration_prototype__proto.asDays         = asDays;
	    duration_prototype__proto.asWeeks        = asWeeks;
	    duration_prototype__proto.asMonths       = asMonths;
	    duration_prototype__proto.asYears        = asYears;
	    duration_prototype__proto.valueOf        = duration_as__valueOf;
	    duration_prototype__proto._bubble        = bubble;
	    duration_prototype__proto.get            = duration_get__get;
	    duration_prototype__proto.milliseconds   = milliseconds;
	    duration_prototype__proto.seconds        = seconds;
	    duration_prototype__proto.minutes        = minutes;
	    duration_prototype__proto.hours          = hours;
	    duration_prototype__proto.days           = days;
	    duration_prototype__proto.weeks          = weeks;
	    duration_prototype__proto.months         = months;
	    duration_prototype__proto.years          = years;
	    duration_prototype__proto.humanize       = humanize;
	    duration_prototype__proto.toISOString    = iso_string__toISOString;
	    duration_prototype__proto.toString       = iso_string__toISOString;
	    duration_prototype__proto.toJSON         = iso_string__toISOString;
	    duration_prototype__proto.locale         = locale;
	    duration_prototype__proto.localeData     = localeData;
	
	    // Deprecations
	    duration_prototype__proto.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', iso_string__toISOString);
	    duration_prototype__proto.lang = lang;
	
	    // Side effect imports
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input, 10) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    // Side effect imports
	
	
	    utils_hooks__hooks.version = '2.15.1';
	
	    setHookCallback(local__createLocal);
	
	    utils_hooks__hooks.fn                    = momentPrototype;
	    utils_hooks__hooks.min                   = min;
	    utils_hooks__hooks.max                   = max;
	    utils_hooks__hooks.now                   = now;
	    utils_hooks__hooks.utc                   = create_utc__createUTC;
	    utils_hooks__hooks.unix                  = moment__createUnix;
	    utils_hooks__hooks.months                = lists__listMonths;
	    utils_hooks__hooks.isDate                = isDate;
	    utils_hooks__hooks.locale                = locale_locales__getSetGlobalLocale;
	    utils_hooks__hooks.invalid               = valid__createInvalid;
	    utils_hooks__hooks.duration              = create__createDuration;
	    utils_hooks__hooks.isMoment              = isMoment;
	    utils_hooks__hooks.weekdays              = lists__listWeekdays;
	    utils_hooks__hooks.parseZone             = moment__createInZone;
	    utils_hooks__hooks.localeData            = locale_locales__getLocale;
	    utils_hooks__hooks.isDuration            = isDuration;
	    utils_hooks__hooks.monthsShort           = lists__listMonthsShort;
	    utils_hooks__hooks.weekdaysMin           = lists__listWeekdaysMin;
	    utils_hooks__hooks.defineLocale          = defineLocale;
	    utils_hooks__hooks.updateLocale          = updateLocale;
	    utils_hooks__hooks.locales               = locale_locales__listLocales;
	    utils_hooks__hooks.weekdaysShort         = lists__listWeekdaysShort;
	    utils_hooks__hooks.normalizeUnits        = normalizeUnits;
	    utils_hooks__hooks.relativeTimeRounding = duration_humanize__getSetRelativeTimeRounding;
	    utils_hooks__hooks.relativeTimeThreshold = duration_humanize__getSetRelativeTimeThreshold;
	    utils_hooks__hooks.calendarFormat        = getCalendarFormat;
	    utils_hooks__hooks.prototype             = momentPrototype;
	
	    var _moment = utils_hooks__hooks;
	
	    return _moment;
	
	}));
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(85)(module)))

/***/ },
/* 1083 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 1084,
		"./af.js": 1084,
		"./ar": 1085,
		"./ar-ly": 1086,
		"./ar-ly.js": 1086,
		"./ar-ma": 1087,
		"./ar-ma.js": 1087,
		"./ar-sa": 1088,
		"./ar-sa.js": 1088,
		"./ar-tn": 1089,
		"./ar-tn.js": 1089,
		"./ar.js": 1085,
		"./az": 1090,
		"./az.js": 1090,
		"./be": 1091,
		"./be.js": 1091,
		"./bg": 1092,
		"./bg.js": 1092,
		"./bn": 1093,
		"./bn.js": 1093,
		"./bo": 1094,
		"./bo.js": 1094,
		"./br": 1095,
		"./br.js": 1095,
		"./bs": 1096,
		"./bs.js": 1096,
		"./ca": 1097,
		"./ca.js": 1097,
		"./cs": 1098,
		"./cs.js": 1098,
		"./cv": 1099,
		"./cv.js": 1099,
		"./cy": 1100,
		"./cy.js": 1100,
		"./da": 1101,
		"./da.js": 1101,
		"./de": 1102,
		"./de-at": 1103,
		"./de-at.js": 1103,
		"./de.js": 1102,
		"./dv": 1104,
		"./dv.js": 1104,
		"./el": 1105,
		"./el.js": 1105,
		"./en-au": 1106,
		"./en-au.js": 1106,
		"./en-ca": 1107,
		"./en-ca.js": 1107,
		"./en-gb": 1108,
		"./en-gb.js": 1108,
		"./en-ie": 1109,
		"./en-ie.js": 1109,
		"./en-nz": 1110,
		"./en-nz.js": 1110,
		"./eo": 1111,
		"./eo.js": 1111,
		"./es": 1112,
		"./es-do": 1113,
		"./es-do.js": 1113,
		"./es.js": 1112,
		"./et": 1114,
		"./et.js": 1114,
		"./eu": 1115,
		"./eu.js": 1115,
		"./fa": 1116,
		"./fa.js": 1116,
		"./fi": 1117,
		"./fi.js": 1117,
		"./fo": 1118,
		"./fo.js": 1118,
		"./fr": 1119,
		"./fr-ca": 1120,
		"./fr-ca.js": 1120,
		"./fr-ch": 1121,
		"./fr-ch.js": 1121,
		"./fr.js": 1119,
		"./fy": 1122,
		"./fy.js": 1122,
		"./gd": 1123,
		"./gd.js": 1123,
		"./gl": 1124,
		"./gl.js": 1124,
		"./he": 1125,
		"./he.js": 1125,
		"./hi": 1126,
		"./hi.js": 1126,
		"./hr": 1127,
		"./hr.js": 1127,
		"./hu": 1128,
		"./hu.js": 1128,
		"./hy-am": 1129,
		"./hy-am.js": 1129,
		"./id": 1130,
		"./id.js": 1130,
		"./is": 1131,
		"./is.js": 1131,
		"./it": 1132,
		"./it.js": 1132,
		"./ja": 1133,
		"./ja.js": 1133,
		"./jv": 1134,
		"./jv.js": 1134,
		"./ka": 1135,
		"./ka.js": 1135,
		"./kk": 1136,
		"./kk.js": 1136,
		"./km": 1137,
		"./km.js": 1137,
		"./ko": 1138,
		"./ko.js": 1138,
		"./ky": 1139,
		"./ky.js": 1139,
		"./lb": 1140,
		"./lb.js": 1140,
		"./lo": 1141,
		"./lo.js": 1141,
		"./lt": 1142,
		"./lt.js": 1142,
		"./lv": 1143,
		"./lv.js": 1143,
		"./me": 1144,
		"./me.js": 1144,
		"./mi": 1145,
		"./mi.js": 1145,
		"./mk": 1146,
		"./mk.js": 1146,
		"./ml": 1147,
		"./ml.js": 1147,
		"./mr": 1148,
		"./mr.js": 1148,
		"./ms": 1149,
		"./ms-my": 1150,
		"./ms-my.js": 1150,
		"./ms.js": 1149,
		"./my": 1151,
		"./my.js": 1151,
		"./nb": 1152,
		"./nb.js": 1152,
		"./ne": 1153,
		"./ne.js": 1153,
		"./nl": 1154,
		"./nl.js": 1154,
		"./nn": 1155,
		"./nn.js": 1155,
		"./pa-in": 1156,
		"./pa-in.js": 1156,
		"./pl": 1157,
		"./pl.js": 1157,
		"./pt": 1158,
		"./pt-br": 1159,
		"./pt-br.js": 1159,
		"./pt.js": 1158,
		"./ro": 1160,
		"./ro.js": 1160,
		"./ru": 1161,
		"./ru.js": 1161,
		"./se": 1162,
		"./se.js": 1162,
		"./si": 1163,
		"./si.js": 1163,
		"./sk": 1164,
		"./sk.js": 1164,
		"./sl": 1165,
		"./sl.js": 1165,
		"./sq": 1166,
		"./sq.js": 1166,
		"./sr": 1167,
		"./sr-cyrl": 1168,
		"./sr-cyrl.js": 1168,
		"./sr.js": 1167,
		"./ss": 1169,
		"./ss.js": 1169,
		"./sv": 1170,
		"./sv.js": 1170,
		"./sw": 1171,
		"./sw.js": 1171,
		"./ta": 1172,
		"./ta.js": 1172,
		"./te": 1173,
		"./te.js": 1173,
		"./th": 1174,
		"./th.js": 1174,
		"./tl-ph": 1175,
		"./tl-ph.js": 1175,
		"./tlh": 1176,
		"./tlh.js": 1176,
		"./tr": 1177,
		"./tr.js": 1177,
		"./tzl": 1178,
		"./tzl.js": 1178,
		"./tzm": 1179,
		"./tzm-latn": 1180,
		"./tzm-latn.js": 1180,
		"./tzm.js": 1179,
		"./uk": 1181,
		"./uk.js": 1181,
		"./uz": 1182,
		"./uz.js": 1182,
		"./vi": 1183,
		"./vi.js": 1183,
		"./x-pseudo": 1184,
		"./x-pseudo.js": 1184,
		"./zh-cn": 1185,
		"./zh-cn.js": 1185,
		"./zh-hk": 1186,
		"./zh-hk.js": 1186,
		"./zh-tw": 1187,
		"./zh-tw.js": 1187
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1083;


/***/ },
/* 1084 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var af = moment.defineLocale('af', {
	        months : 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split('_'),
	        weekdaysShort : 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin : 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM : function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Vandag om] LT',
	            nextDay : '[Môre om] LT',
	            nextWeek : 'dddd [om] LT',
	            lastDay : '[Gister om] LT',
	            lastWeek : '[Laas] dddd [om] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'oor %s',
	            past : '%s gelede',
	            s : '\'n paar sekondes',
	            m : '\'n minuut',
	            mm : '%d minute',
	            h : '\'n uur',
	            hh : '%d ure',
	            d : '\'n dag',
	            dd : '%d dae',
	            M : '\'n maand',
	            MM : '%d maande',
	            y : '\'n jaar',
	            yy : '%d jaar'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de'); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week : {
	            dow : 1, // Maandag is die eerste dag van die week.
	            doy : 4  // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        }
	    });
	
	    return af;
	
	}));

/***/ },
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'كانون الثاني يناير',
	        'شباط فبراير',
	        'آذار مارس',
	        'نيسان أبريل',
	        'أيار مايو',
	        'حزيران يونيو',
	        'تموز يوليو',
	        'آب أغسطس',
	        'أيلول سبتمبر',
	        'تشرين الأول أكتوبر',
	        'تشرين الثاني نوفمبر',
	        'كانون الأول ديسمبر'
	    ];
	
	    var ar = moment.defineLocale('ar', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/\u200f/g, '').replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar;
	
	}));

/***/ },
/* 1086 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Lybia) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '1',
	        '2': '2',
	        '3': '3',
	        '4': '4',
	        '5': '5',
	        '6': '6',
	        '7': '7',
	        '8': '8',
	        '9': '9',
	        '0': '0'
	    }, pluralForm = function (n) {
	        return n === 0 ? 0 : n === 1 ? 1 : n === 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5;
	    }, plurals = {
	        s : ['أقل من ثانية', 'ثانية واحدة', ['ثانيتان', 'ثانيتين'], '%d ثوان', '%d ثانية', '%d ثانية'],
	        m : ['أقل من دقيقة', 'دقيقة واحدة', ['دقيقتان', 'دقيقتين'], '%d دقائق', '%d دقيقة', '%d دقيقة'],
	        h : ['أقل من ساعة', 'ساعة واحدة', ['ساعتان', 'ساعتين'], '%d ساعات', '%d ساعة', '%d ساعة'],
	        d : ['أقل من يوم', 'يوم واحد', ['يومان', 'يومين'], '%d أيام', '%d يومًا', '%d يوم'],
	        M : ['أقل من شهر', 'شهر واحد', ['شهران', 'شهرين'], '%d أشهر', '%d شهرا', '%d شهر'],
	        y : ['أقل من عام', 'عام واحد', ['عامان', 'عامين'], '%d أعوام', '%d عامًا', '%d عام']
	    }, pluralize = function (u) {
	        return function (number, withoutSuffix, string, isFuture) {
	            var f = pluralForm(number),
	                str = plurals[u][pluralForm(number)];
	            if (f === 2) {
	                str = str[withoutSuffix ? 0 : 1];
	            }
	            return str.replace(/%d/i, number);
	        };
	    }, months = [
	        'يناير',
	        'فبراير',
	        'مارس',
	        'أبريل',
	        'مايو',
	        'يونيو',
	        'يوليو',
	        'أغسطس',
	        'سبتمبر',
	        'أكتوبر',
	        'نوفمبر',
	        'ديسمبر'
	    ];
	
	    var ar_ly = moment.defineLocale('ar-ly', {
	        months : months,
	        monthsShort : months,
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/\u200FM/\u200FYYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'بعد %s',
	            past : 'منذ %s',
	            s : pluralize('s'),
	            m : pluralize('m'),
	            mm : pluralize('m'),
	            h : pluralize('h'),
	            hh : pluralize('h'),
	            d : pluralize('d'),
	            dd : pluralize('d'),
	            M : pluralize('M'),
	            MM : pluralize('M'),
	            y : pluralize('y'),
	            yy : pluralize('y')
	        },
	        preparse: function (string) {
	            return string.replace(/\u200f/g, '').replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar_ly;
	
	}));

/***/ },
/* 1087 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ar_ma = moment.defineLocale('ar-ma', {
	        months : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split('_'),
	        weekdays : 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar_ma;
	
	}));

/***/ },
/* 1088 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '١',
	        '2': '٢',
	        '3': '٣',
	        '4': '٤',
	        '5': '٥',
	        '6': '٦',
	        '7': '٧',
	        '8': '٨',
	        '9': '٩',
	        '0': '٠'
	    }, numberMap = {
	        '١': '1',
	        '٢': '2',
	        '٣': '3',
	        '٤': '4',
	        '٥': '5',
	        '٦': '6',
	        '٧': '7',
	        '٨': '8',
	        '٩': '9',
	        '٠': '0'
	    };
	
	    var ar_sa = moment.defineLocale('ar-sa', {
	        months : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort : 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays : 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort : 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin : 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ص|م/,
	        isPM : function (input) {
	            return 'م' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar : {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'في %s',
	            past : 'منذ %s',
	            s : 'ثوان',
	            m : 'دقيقة',
	            mm : '%d دقائق',
	            h : 'ساعة',
	            hh : '%d ساعات',
	            d : 'يوم',
	            dd : '%d أيام',
	            M : 'شهر',
	            MM : '%d أشهر',
	            y : 'سنة',
	            yy : '%d سنوات'
	        },
	        preparse: function (string) {
	            return string.replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ar_sa;
	
	}));

/***/ },
/* 1089 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ar_tn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        monthsShort: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split('_'),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ar_tn;
	
	}));

/***/ },
/* 1090 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı'
	    };
	
	    var az = moment.defineLocale('az', {
	        months : 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split('_'),
	        monthsShort : 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays : 'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split('_'),
	        weekdaysShort : 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin : 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[sabah saat] LT',
	            nextWeek : '[gələn həftə] dddd [saat] LT',
	            lastDay : '[dünən] LT',
	            lastWeek : '[keçən həftə] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s əvvəl',
	            s : 'birneçə saniyyə',
	            m : 'bir dəqiqə',
	            mm : '%d dəqiqə',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir il',
	            yy : '%d il'
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM : function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        ordinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return az;
	
	}));

/***/ },
/* 1091 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            'hh': withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            'dd': 'дзень_дні_дзён',
	            'MM': 'месяц_месяцы_месяцаў',
	            'yy': 'год_гады_гадоў'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months : {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split('_'),
	            standalone: 'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split('_')
	        },
	        monthsShort : 'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays : {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split('_'),
	            standalone: 'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:мінулую|наступную)? ?\] ?dddd/
	        },
	        weekdaysShort : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'праз %s',
	            past : '%s таму',
	            s : 'некалькі секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithPlural,
	            hh : relativeTimeWithPlural,
	            d : 'дзень',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM : function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        ordinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) && (number % 100 !== 12 && number % 100 !== 13) ? number + '-і' : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return be;
	
	}));

/***/ },
/* 1092 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var bg = moment.defineLocale('bg', {
	        months : 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'янр_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Днес в] LT',
	            nextDay : '[Утре в] LT',
	            nextWeek : 'dddd [в] LT',
	            lastDay : '[Вчера в] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[В изминалата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[В изминалия] dddd [в] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'след %s',
	            past : 'преди %s',
	            s : 'няколко секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дни',
	            M : 'месец',
	            MM : '%d месеца',
	            y : 'година',
	            yy : '%d години'
	        },
	        ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bg;
	
	}));

/***/ },
/* 1093 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '১',
	        '2': '২',
	        '3': '৩',
	        '4': '৪',
	        '5': '৫',
	        '6': '৬',
	        '7': '৭',
	        '8': '৮',
	        '9': '৯',
	        '0': '০'
	    },
	    numberMap = {
	        '১': '1',
	        '২': '2',
	        '৩': '3',
	        '৪': '4',
	        '৫': '5',
	        '৬': '6',
	        '৭': '7',
	        '৮': '8',
	        '৯': '9',
	        '০': '0'
	    };
	
	    var bn = moment.defineLocale('bn', {
	        months : 'জানুয়ারী_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split('_'),
	        monthsShort : 'জানু_ফেব_মার্চ_এপ্র_মে_জুন_জুল_আগ_সেপ্ট_অক্টো_নভে_ডিসে'.split('_'),
	        weekdays : 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split('_'),
	        weekdaysShort : 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin : 'রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm সময়',
	            LTS : 'A h:mm:ss সময়',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm সময়',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm সময়'
	        },
	        calendar : {
	            sameDay : '[আজ] LT',
	            nextDay : '[আগামীকাল] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[গতকাল] LT',
	            lastWeek : '[গত] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s পরে',
	            past : '%s আগে',
	            s : 'কয়েক সেকেন্ড',
	            m : 'এক মিনিট',
	            mm : '%d মিনিট',
	            h : 'এক ঘন্টা',
	            hh : '%d ঘন্টা',
	            d : 'এক দিন',
	            dd : '%d দিন',
	            M : 'এক মাস',
	            MM : '%d মাস',
	            y : 'এক বছর',
	            yy : '%d বছর'
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'রাত' && hour >= 4) ||
	                    (meridiem === 'দুপুর' && hour < 5) ||
	                    meridiem === 'বিকাল') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bn;
	
	}));

/***/ },
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '༡',
	        '2': '༢',
	        '3': '༣',
	        '4': '༤',
	        '5': '༥',
	        '6': '༦',
	        '7': '༧',
	        '8': '༨',
	        '9': '༩',
	        '0': '༠'
	    },
	    numberMap = {
	        '༡': '1',
	        '༢': '2',
	        '༣': '3',
	        '༤': '4',
	        '༥': '5',
	        '༦': '6',
	        '༧': '7',
	        '༨': '8',
	        '༩': '9',
	        '༠': '0'
	    };
	
	    var bo = moment.defineLocale('bo', {
	        months : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        monthsShort : 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split('_'),
	        weekdays : 'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split('_'),
	        weekdaysShort : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        weekdaysMin : 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[དི་རིང] LT',
	            nextDay : '[སང་ཉིན] LT',
	            nextWeek : '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay : '[ཁ་སང] LT',
	            lastWeek : '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ལ་',
	            past : '%s སྔན་ལ',
	            s : 'ལམ་སང',
	            m : 'སྐར་མ་གཅིག',
	            mm : '%d སྐར་མ',
	            h : 'ཆུ་ཚོད་གཅིག',
	            hh : '%d ཆུ་ཚོད',
	            d : 'ཉིན་གཅིག',
	            dd : '%d ཉིན་',
	            M : 'ཟླ་བ་གཅིག',
	            MM : '%d ཟླ་བ',
	            y : 'ལོ་གཅིག',
	            yy : '%d ལོ'
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'མཚན་མོ' && hour >= 4) ||
	                    (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                    meridiem === 'དགོང་དག') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bo;
	
	}));

/***/ },
/* 1095 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            'mm': 'munutenn',
	            'MM': 'miz',
	            'dd': 'devezh'
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            'm': 'v',
	            'b': 'v',
	            'd': 'z'
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var br = moment.defineLocale('br', {
	        months : 'Genver_C\'hwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split('_'),
	        monthsShort : 'Gen_C\'hwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays : 'Sul_Lun_Meurzh_Merc\'her_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort : 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin : 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h[e]mm A',
	            LTS : 'h[e]mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [a viz] MMMM YYYY',
	            LLL : 'D [a viz] MMMM YYYY h[e]mm A',
	            LLLL : 'dddd, D [a viz] MMMM YYYY h[e]mm A'
	        },
	        calendar : {
	            sameDay : '[Hiziv da] LT',
	            nextDay : '[Warc\'hoazh da] LT',
	            nextWeek : 'dddd [da] LT',
	            lastDay : '[Dec\'h da] LT',
	            lastWeek : 'dddd [paset da] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'a-benn %s',
	            past : '%s \'zo',
	            s : 'un nebeud segondennoù',
	            m : 'ur vunutenn',
	            mm : relativeTimeWithMutation,
	            h : 'un eur',
	            hh : '%d eur',
	            d : 'un devezh',
	            dd : relativeTimeWithMutation,
	            M : 'ur miz',
	            MM : relativeTimeWithMutation,
	            y : 'ur bloaz',
	            yy : specialMutationForYears
	        },
	        ordinalParse: /\d{1,2}(añ|vet)/,
	        ordinal : function (number) {
	            var output = (number === 1) ? 'añ' : 'vet';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return br;
	
	}));

/***/ },
/* 1096 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months : 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return bs;
	
	}));

/***/ },
/* 1097 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ca = moment.defineLocale('ca', {
	        months : 'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split('_'),
	        monthsShort : 'gen._febr._mar._abr._mai._jun._jul._ag._set._oct._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split('_'),
	        weekdaysShort : 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin : 'Dg_Dl_Dt_Dc_Dj_Dv_Ds'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[avui a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextDay : function () {
	                return '[demà a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastDay : function () {
	                return '[ahir a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [passat a ' + ((this.hours() !== 1) ? 'les' : 'la') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'fa %s',
	            s : 'uns segons',
	            m : 'un minut',
	            mm : '%d minuts',
	            h : 'una hora',
	            hh : '%d hores',
	            d : 'un dia',
	            dd : '%d dies',
	            M : 'un mes',
	            MM : '%d mesos',
	            y : 'un any',
	            yy : '%d anys'
	        },
	        ordinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal : function (number, period) {
	            var output = (number === 1) ? 'r' :
	                (number === 2) ? 'n' :
	                (number === 3) ? 'r' :
	                (number === 4) ? 't' : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ca;
	
	}));

/***/ },
/* 1098 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_'),
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	                break;
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParse : (function (months, monthsShort) {
	            var i, _monthsParse = [];
	            for (i = 0; i < 12; i++) {
	                // use custom parser to solve problem with July (červenec)
	                _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
	            }
	            return _monthsParse;
	        }(months, monthsShort)),
	        shortMonthsParse : (function (monthsShort) {
	            var i, _shortMonthsParse = [];
	            for (i = 0; i < 12; i++) {
	                _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
	            }
	            return _shortMonthsParse;
	        }(monthsShort)),
	        longMonthsParse : (function (months) {
	            var i, _longMonthsParse = [];
	            for (i = 0; i < 12; i++) {
	                _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
	            }
	            return _longMonthsParse;
	        }(months)),
	        weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm',
	            l : 'D. M. YYYY'
	        },
	        calendar : {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'před %s',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse : /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cs;
	
	}));

/***/ },
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var cv = moment.defineLocale('cv', {
	        months : 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split('_'),
	        monthsShort : 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays : 'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split('_'),
	        weekdaysShort : 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin : 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL : 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL : 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm'
	        },
	        calendar : {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (output) {
	                var affix = /сехет$/i.exec(output) ? 'рен' : /ҫул$/i.exec(output) ? 'тан' : 'ран';
	                return output + affix;
	            },
	            past : '%s каялла',
	            s : 'пӗр-ик ҫеккунт',
	            m : 'пӗр минут',
	            mm : '%d минут',
	            h : 'пӗр сехет',
	            hh : '%d сехет',
	            d : 'пӗр кун',
	            dd : '%d кун',
	            M : 'пӗр уйӑх',
	            MM : '%d уйӑх',
	            y : 'пӗр ҫул',
	            yy : '%d ҫул'
	        },
	        ordinalParse: /\d{1,2}-мӗш/,
	        ordinal : '%d-мӗш',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return cv;
	
	}));

/***/ },
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split('_'),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split('_'),
	        weekdays: 'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split('_'),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact : true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd'
	        },
	        ordinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '', 'af', 'il', 'ydd', 'ydd', 'ed', 'ed', 'ed', 'fed', 'fed', 'fed', // 1af to 10fed
	                    'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'eg', 'fed', 'eg', 'fed' // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return cy;
	
	}));

/***/ },
/* 1101 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var da = moment.defineLocale('da', {
	        months : 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd [d.] D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[I dag kl.] LT',
	            nextDay : '[I morgen kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[I går kl.] LT',
	            lastWeek : '[sidste] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'få sekunder',
	            m : 'et minut',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dage',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'et år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return da;
	
	}));

/***/ },
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de;
	
	}));

/***/ },
/* 1103 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eine Minute', 'einer Minute'],
	            'h': ['eine Stunde', 'einer Stunde'],
	            'd': ['ein Tag', 'einem Tag'],
	            'dd': [number + ' Tage', number + ' Tagen'],
	            'M': ['ein Monat', 'einem Monat'],
	            'MM': [number + ' Monate', number + ' Monaten'],
	            'y': ['ein Jahr', 'einem Jahr'],
	            'yy': [number + ' Jahre', number + ' Jahren']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de_at = moment.defineLocale('de-at', {
	        months : 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort : 'Jän._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
	        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY HH:mm',
	            LLLL : 'dddd, D. MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : 'vor %s',
	            s : 'ein paar Sekunden',
	            m : processRelativeTime,
	            mm : '%d Minuten',
	            h : processRelativeTime,
	            hh : '%d Stunden',
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return de_at;
	
	}));

/***/ },
/* 1104 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var months = [
	        'ޖެނުއަރީ',
	        'ފެބްރުއަރީ',
	        'މާރިޗު',
	        'އޭޕްރީލު',
	        'މޭ',
	        'ޖޫން',
	        'ޖުލައި',
	        'އޯގަސްޓު',
	        'ސެޕްޓެމްބަރު',
	        'އޮކްޓޯބަރު',
	        'ނޮވެމްބަރު',
	        'ޑިސެމްބަރު'
	    ], weekdays = [
	        'އާދިއްތަ',
	        'ހޯމަ',
	        'އަންގާރަ',
	        'ބުދަ',
	        'ބުރާސްފަތި',
	        'ހުކުރު',
	        'ހޮނިހިރު'
	    ];
	
	    var dv = moment.defineLocale('dv', {
	        months : months,
	        monthsShort : months,
	        weekdays : weekdays,
	        weekdaysShort : weekdays,
	        weekdaysMin : 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat : {
	
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'D/M/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM : function (input) {
	            return 'މފ' === input;
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar : {
	            sameDay : '[މިއަދު] LT',
	            nextDay : '[މާދަމާ] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[އިއްޔެ] LT',
	            lastWeek : '[ފާއިތުވި] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ތެރޭގައި %s',
	            past : 'ކުރިން %s',
	            s : 'ސިކުންތުކޮޅެއް',
	            m : 'މިނިޓެއް',
	            mm : 'މިނިޓު %d',
	            h : 'ގަޑިއިރެއް',
	            hh : 'ގަޑިއިރު %d',
	            d : 'ދުވަހެއް',
	            dd : 'ދުވަސް %d',
	            M : 'މަހެއް',
	            MM : 'މަސް %d',
	            y : 'އަހަރެއް',
	            yy : 'އަހަރު %d'
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week : {
	            dow : 7,  // Sunday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return dv;
	
	}));

/***/ },
/* 1105 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	    function isFunction(input) {
	        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
	    }
	
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl : 'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split('_'),
	        monthsGenitiveEl : 'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split('_'),
	        months : function (momentToFormat, format) {
	            if (/D/.test(format.substring(0, format.indexOf('MMMM')))) { // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays : 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
	        weekdaysShort : 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin : 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM : function (input) {
	            return ((input + '').toLowerCase()[0] === 'μ');
	        },
	        meridiemParse : /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendarEl : {
	            sameDay : '[Σήμερα {}] LT',
	            nextDay : '[Αύριο {}] LT',
	            nextWeek : 'dddd [{}] LT',
	            lastDay : '[Χθες {}] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        calendar : function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', (hours % 12 === 1 ? 'στη' : 'στις'));
	        },
	        relativeTime : {
	            future : 'σε %s',
	            past : '%s πριν',
	            s : 'λίγα δευτερόλεπτα',
	            m : 'ένα λεπτό',
	            mm : '%d λεπτά',
	            h : 'μία ώρα',
	            hh : '%d ώρες',
	            d : 'μία μέρα',
	            dd : '%d μέρες',
	            M : 'ένας μήνας',
	            MM : '%d μήνες',
	            y : 'ένας χρόνος',
	            yy : '%d χρόνια'
	        },
	        ordinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4st is the first week of the year.
	        }
	    });
	
	    return el;
	
	}));

/***/ },
/* 1106 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_au = moment.defineLocale('en-au', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_au;
	
	}));

/***/ },
/* 1107 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_ca = moment.defineLocale('en-ca', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'YYYY-MM-DD',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY h:mm A',
	            LLLL : 'dddd, MMMM D, YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        }
	    });
	
	    return en_ca;
	
	}));

/***/ },
/* 1108 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_gb = moment.defineLocale('en-gb', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_gb;
	
	}));

/***/ },
/* 1109 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_ie = moment.defineLocale('en-ie', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_ie;
	
	}));

/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var en_nz = moment.defineLocale('en-nz', {
	        months : 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays : 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        weekdaysShort : 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin : 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Today at] LT',
	            nextDay : '[Tomorrow at] LT',
	            nextWeek : 'dddd [at] LT',
	            lastDay : '[Yesterday at] LT',
	            lastWeek : '[Last] dddd [at] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'in %s',
	            past : '%s ago',
	            s : 'a few seconds',
	            m : 'a minute',
	            mm : '%d minutes',
	            h : 'an hour',
	            hh : '%d hours',
	            d : 'a day',
	            dd : '%d days',
	            M : 'a month',
	            MM : '%d months',
	            y : 'a year',
	            yy : '%d years'
	        },
	        ordinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return en_nz;
	
	}));

/***/ },
/* 1111 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! komento: Mi estas malcerta se mi korekte traktis akuzativojn en tiu traduko.
	//!          Se ne, bonvolu korekti kaj avizi min por ke mi povas lerni!
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var eo = moment.defineLocale('eo', {
	        months : 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aŭg_sep_okt_nov_dec'.split('_'),
	        weekdays : 'Dimanĉo_Lundo_Mardo_Merkredo_Ĵaŭdo_Vendredo_Sabato'.split('_'),
	        weekdaysShort : 'Dim_Lun_Mard_Merk_Ĵaŭ_Ven_Sab'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Ĵa_Ve_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D[-an de] MMMM, YYYY',
	            LLL : 'D[-an de] MMMM, YYYY HH:mm',
	            LLLL : 'dddd, [la] D[-an de] MMMM, YYYY HH:mm'
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar : {
	            sameDay : '[Hodiaŭ je] LT',
	            nextDay : '[Morgaŭ je] LT',
	            nextWeek : 'dddd [je] LT',
	            lastDay : '[Hieraŭ je] LT',
	            lastWeek : '[pasinta] dddd [je] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'je %s',
	            past : 'antaŭ %s',
	            s : 'sekundoj',
	            m : 'minuto',
	            mm : '%d minutoj',
	            h : 'horo',
	            hh : '%d horoj',
	            d : 'tago',//ne 'diurno', ĉar estas uzita por proksimumo
	            dd : '%d tagoj',
	            M : 'monato',
	            MM : '%d monatoj',
	            y : 'jaro',
	            yy : '%d jaroj'
	        },
	        ordinalParse: /\d{1,2}a/,
	        ordinal : '%da',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return eo;
	
	}));

/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var es = moment.defineLocale('es', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es;
	
	}));

/***/ },
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsShortDot = 'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_');
	
	    var es_do = moment.defineLocale('es-do', {
	        months : 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoy a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañana a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastDay : function () {
	                return '[ayer a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            lastWeek : function () {
	                return '[el] dddd [pasado a la' + ((this.hours() !== 1) ? 's' : '') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'en %s',
	            past : 'hace %s',
	            s : 'unos segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'una hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un año',
	            yy : '%d años'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return es_do;
	
	}));

/***/ },
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's' : ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            'm' : ['ühe minuti', 'üks minut'],
	            'mm': [number + ' minuti', number + ' minutit'],
	            'h' : ['ühe tunni', 'tund aega', 'üks tund'],
	            'hh': [number + ' tunni', number + ' tundi'],
	            'd' : ['ühe päeva', 'üks päev'],
	            'M' : ['kuu aja', 'kuu aega', 'üks kuu'],
	            'MM': [number + ' kuu', number + ' kuud'],
	            'y' : ['ühe aasta', 'aasta', 'üks aasta'],
	            'yy': [number + ' aasta', number + ' aastat']
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months        : 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split('_'),
	        monthsShort   : 'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays      : 'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split('_'),
	        weekdaysShort : 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin   : 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat : {
	            LT   : 'H:mm',
	            LTS : 'H:mm:ss',
	            L    : 'DD.MM.YYYY',
	            LL   : 'D. MMMM YYYY',
	            LLL  : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[Täna,] LT',
	            nextDay  : '[Homme,] LT',
	            nextWeek : '[Järgmine] dddd LT',
	            lastDay  : '[Eile,] LT',
	            lastWeek : '[Eelmine] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s pärast',
	            past   : '%s tagasi',
	            s      : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : '%d päeva',
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return et;
	
	}));

/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var eu = moment.defineLocale('eu', {
	        months : 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split('_'),
	        monthsShort : 'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split('_'),
	        weekdaysShort : 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin : 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY[ko] MMMM[ren] D[a]',
	            LLL : 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL : 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l : 'YYYY-M-D',
	            ll : 'YYYY[ko] MMM D[a]',
	            lll : 'YYYY[ko] MMM D[a] HH:mm',
	            llll : 'ddd, YYYY[ko] MMM D[a] HH:mm'
	        },
	        calendar : {
	            sameDay : '[gaur] LT[etan]',
	            nextDay : '[bihar] LT[etan]',
	            nextWeek : 'dddd LT[etan]',
	            lastDay : '[atzo] LT[etan]',
	            lastWeek : '[aurreko] dddd LT[etan]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s barru',
	            past : 'duela %s',
	            s : 'segundo batzuk',
	            m : 'minutu bat',
	            mm : '%d minutu',
	            h : 'ordu bat',
	            hh : '%d ordu',
	            d : 'egun bat',
	            dd : '%d egun',
	            M : 'hilabete bat',
	            MM : '%d hilabete',
	            y : 'urte bat',
	            yy : '%d urte'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return eu;
	
	}));

/***/ },
/* 1116 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '۱',
	        '2': '۲',
	        '3': '۳',
	        '4': '۴',
	        '5': '۵',
	        '6': '۶',
	        '7': '۷',
	        '8': '۸',
	        '9': '۹',
	        '0': '۰'
	    }, numberMap = {
	        '۱': '1',
	        '۲': '2',
	        '۳': '3',
	        '۴': '4',
	        '۵': '5',
	        '۶': '6',
	        '۷': '7',
	        '۸': '8',
	        '۹': '9',
	        '۰': '0'
	    };
	
	    var fa = moment.defineLocale('fa', {
	        months : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        monthsShort : 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split('_'),
	        weekdays : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysShort : 'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split('_'),
	        weekdaysMin : 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar : {
	            sameDay : '[امروز ساعت] LT',
	            nextDay : '[فردا ساعت] LT',
	            nextWeek : 'dddd [ساعت] LT',
	            lastDay : '[دیروز ساعت] LT',
	            lastWeek : 'dddd [پیش] [ساعت] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'در %s',
	            past : '%s پیش',
	            s : 'چندین ثانیه',
	            m : 'یک دقیقه',
	            mm : '%d دقیقه',
	            h : 'یک ساعت',
	            hh : '%d ساعت',
	            d : 'یک روز',
	            dd : '%d روز',
	            M : 'یک ماه',
	            MM : '%d ماه',
	            y : 'یک سال',
	            yy : '%d سال'
	        },
	        preparse: function (string) {
	            return string.replace(/[۰-۹]/g, function (match) {
	                return numberMap[match];
	            }).replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            }).replace(/,/g, '،');
	        },
	        ordinalParse: /\d{1,2}م/,
	        ordinal : '%dم',
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return fa;
	
	}));

/***/ },
/* 1117 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var numbersPast = 'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(' '),
	        numbersFuture = [
	            'nolla', 'yhden', 'kahden', 'kolmen', 'neljän', 'viiden', 'kuuden',
	            numbersPast[7], numbersPast[8], numbersPast[9]
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10 ? (isFuture ? numbersFuture[number] : numbersPast[number]) : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months : 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split('_'),
	        monthsShort : 'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split('_'),
	        weekdays : 'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split('_'),
	        weekdaysShort : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin : 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'Do MMMM[ta] YYYY',
	            LLL : 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL : 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l : 'D.M.YYYY',
	            ll : 'Do MMM YYYY',
	            lll : 'Do MMM YYYY, [klo] HH.mm',
	            llll : 'ddd, Do MMM YYYY, [klo] HH.mm'
	        },
	        calendar : {
	            sameDay : '[tänään] [klo] LT',
	            nextDay : '[huomenna] [klo] LT',
	            nextWeek : 'dddd [klo] LT',
	            lastDay : '[eilen] [klo] LT',
	            lastWeek : '[viime] dddd[na] [klo] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s päästä',
	            past : '%s sitten',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fi;
	
	}));

/***/ },
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fo = moment.defineLocale('fo', {
	        months : 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split('_'),
	        weekdaysShort : 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin : 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D. MMMM, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Í dag kl.] LT',
	            nextDay : '[Í morgin kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[Í gjár kl.] LT',
	            lastWeek : '[síðstu] dddd [kl] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'um %s',
	            past : '%s síðani',
	            s : 'fá sekund',
	            m : 'ein minutt',
	            mm : '%d minuttir',
	            h : 'ein tími',
	            hh : '%d tímar',
	            d : 'ein dagur',
	            dd : '%d dagar',
	            M : 'ein mánaði',
	            MM : '%d mánaðir',
	            y : 'eitt ár',
	            yy : '%d ár'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fo;
	
	}));

/***/ },
/* 1119 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fr = moment.defineLocale('fr', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|)/,
	        ordinal : function (number) {
	            return number + (number === 1 ? 'er' : '');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr;
	
	}));

/***/ },
/* 1120 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fr_ca = moment.defineLocale('fr-ca', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number) {
	            return number + (number === 1 ? 'er' : 'e');
	        }
	    });
	
	    return fr_ca;
	
	}));

/***/ },
/* 1121 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var fr_ch = moment.defineLocale('fr-ch', {
	        months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
	        monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Aujourd\'hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dans %s',
	            past : 'il y a %s',
	            s : 'quelques secondes',
	            m : 'une minute',
	            mm : '%d minutes',
	            h : 'une heure',
	            hh : '%d heures',
	            d : 'un jour',
	            dd : '%d jours',
	            M : 'un mois',
	            MM : '%d mois',
	            y : 'un an',
	            yy : '%d ans'
	        },
	        ordinalParse: /\d{1,2}(er|e)/,
	        ordinal : function (number) {
	            return number + (number === 1 ? 'er' : 'e');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fr_ch;
	
	}));

/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months : 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact : true,
	        weekdays : 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split('_'),
	        weekdaysShort : 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin : 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'oer %s',
	            past : '%s lyn',
	            s : 'in pear sekonden',
	            m : 'ien minút',
	            mm : '%d minuten',
	            h : 'ien oere',
	            hh : '%d oeren',
	            d : 'ien dei',
	            dd : '%d dagen',
	            M : 'ien moanne',
	            MM : '%d moannen',
	            y : 'ien jier',
	            yy : '%d jierren'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return fy;
	
	}));

/***/ },
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var months = [
	        'Am Faoilleach', 'An Gearran', 'Am Màrt', 'An Giblean', 'An Cèitean', 'An t-Ògmhios', 'An t-Iuchar', 'An Lùnastal', 'An t-Sultain', 'An Dàmhair', 'An t-Samhain', 'An Dùbhlachd'
	    ];
	
	    var monthsShort = ['Faoi', 'Gear', 'Màrt', 'Gibl', 'Cèit', 'Ògmh', 'Iuch', 'Lùn', 'Sult', 'Dàmh', 'Samh', 'Dùbh'];
	
	    var weekdays = ['Didòmhnaich', 'Diluain', 'Dimàirt', 'Diciadain', 'Diardaoin', 'Dihaoine', 'Disathairne'];
	
	    var weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'];
	
	    var weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months : months,
	        monthsShort : monthsShort,
	        monthsParseExact : true,
	        weekdays : weekdays,
	        weekdaysShort : weekdaysShort,
	        weekdaysMin : weekdaysMin,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[An-diugh aig] LT',
	            nextDay : '[A-màireach aig] LT',
	            nextWeek : 'dddd [aig] LT',
	            lastDay : '[An-dè aig] LT',
	            lastWeek : 'dddd [seo chaidh] [aig] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ann an %s',
	            past : 'bho chionn %s',
	            s : 'beagan diogan',
	            m : 'mionaid',
	            mm : '%d mionaidean',
	            h : 'uair',
	            hh : '%d uairean',
	            d : 'latha',
	            dd : '%d latha',
	            M : 'mìos',
	            MM : '%d mìosan',
	            y : 'bliadhna',
	            yy : '%d bliadhna'
	        },
	        ordinalParse : /\d{1,2}(d|na|mh)/,
	        ordinal : function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gd;
	
	}));

/***/ },
/* 1124 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var gl = moment.defineLocale('gl', {
	        months : 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split('_'),
	        monthsShort : 'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort : 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin : 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY H:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY H:mm'
	        },
	        calendar : {
	            sameDay : function () {
	                return '[hoxe ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextDay : function () {
	                return '[mañá ' + ((this.hours() !== 1) ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek : function () {
	                return 'dddd [' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            lastDay : function () {
	                return '[onte ' + ((this.hours() !== 1) ? 'á' : 'a') + '] LT';
	            },
	            lastWeek : function () {
	                return '[o] dddd [pasado ' + ((this.hours() !== 1) ? 'ás' : 'a') + '] LT';
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past : 'hai %s',
	            s : 'uns segundos',
	            m : 'un minuto',
	            mm : '%d minutos',
	            h : 'unha hora',
	            hh : '%d horas',
	            d : 'un día',
	            dd : '%d días',
	            M : 'un mes',
	            MM : '%d meses',
	            y : 'un ano',
	            yy : '%d anos'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return gl;
	
	}));

/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var he = moment.defineLocale('he', {
	        months : 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split('_'),
	        monthsShort : 'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays : 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort : 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin : 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [ב]MMMM YYYY',
	            LLL : 'D [ב]MMMM YYYY HH:mm',
	            LLLL : 'dddd, D [ב]MMMM YYYY HH:mm',
	            l : 'D/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[היום ב־]LT',
	            nextDay : '[מחר ב־]LT',
	            nextWeek : 'dddd [בשעה] LT',
	            lastDay : '[אתמול ב־]LT',
	            lastWeek : '[ביום] dddd [האחרון בשעה] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'בעוד %s',
	            past : 'לפני %s',
	            s : 'מספר שניות',
	            m : 'דקה',
	            mm : '%d דקות',
	            h : 'שעה',
	            hh : function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d : 'יום',
	            dd : function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M : 'חודש',
	            MM : function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y : 'שנה',
	            yy : function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            }
	        },
	        meridiemParse: /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM : function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        }
	    });
	
	    return he;
	
	}));

/***/ },
/* 1126 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var hi = moment.defineLocale('hi', {
	        months : 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split('_'),
	        monthsShort : 'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm बजे',
	            LTS : 'A h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm बजे'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[कल] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[कल] LT',
	            lastWeek : '[पिछले] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s में',
	            past : '%s पहले',
	            s : 'कुछ ही क्षण',
	            m : 'एक मिनट',
	            mm : '%d मिनट',
	            h : 'एक घंटा',
	            hh : '%d घंटे',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महीने',
	            MM : '%d महीने',
	            y : 'एक वर्ष',
	            yy : '%d वर्ष'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hi;
	
	}));

/***/ },
/* 1127 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months : {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split('_'),
	            standalone: 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_')
	        },
	        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danas u] LT',
	            nextDay  : '[sutra u] LT',
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[jučer u] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'par sekundi',
	            m      : translate,
	            mm     : translate,
	            h      : translate,
	            hh     : translate,
	            d      : 'dan',
	            dd     : translate,
	            M      : 'mjesec',
	            MM     : translate,
	            y      : 'godinu',
	            yy     : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hr;
	
	}));

/***/ },
/* 1128 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number,
	            suffix;
	        switch (key) {
	            case 's':
	                return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months : 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
	        monthsShort : 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
	        weekdays : 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort : 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin : 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'YYYY.MM.DD.',
	            LL : 'YYYY. MMMM D.',
	            LLL : 'YYYY. MMMM D. H:mm',
	            LLLL : 'YYYY. MMMM D., dddd H:mm'
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar : {
	            sameDay : '[ma] LT[-kor]',
	            nextDay : '[holnap] LT[-kor]',
	            nextWeek : function () {
	                return week.call(this, true);
	            },
	            lastDay : '[tegnap] LT[-kor]',
	            lastWeek : function () {
	                return week.call(this, false);
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s múlva',
	            past : '%s',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hu;
	
	}));

/***/ },
/* 1129 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var hy_am = moment.defineLocale('hy-am', {
	        months : {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split('_'),
	            standalone: 'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split('_')
	        },
	        monthsShort : 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays : 'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split('_'),
	        weekdaysShort : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin : 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY թ.',
	            LLL : 'D MMMM YYYY թ., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY թ., HH:mm'
	        },
	        calendar : {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s հետո',
	            past : '%s առաջ',
	            s : 'մի քանի վայրկյան',
	            m : 'րոպե',
	            mm : '%d րոպե',
	            h : 'ժամ',
	            hh : '%d ժամ',
	            d : 'օր',
	            dd : '%d օր',
	            M : 'ամիս',
	            MM : '%d ամիս',
	            y : 'տարի',
	            yy : '%d տարի'
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem : function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        ordinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return hy_am;
	
	}));

/***/ },
/* 1130 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var id = moment.defineLocale('id', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Besok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kemarin pukul] LT',
	            lastWeek : 'dddd [lalu pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lalu',
	            s : 'beberapa detik',
	            m : 'semenit',
	            mm : '%d menit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return id;
	
	}));

/***/ },
/* 1131 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nokkrar sekúndur' : 'nokkrum sekúndum';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum');
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'klukkustundir' : 'klukkustundum');
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months : 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays : 'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split('_'),
	        weekdaysShort : 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin : 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd, D. MMMM YYYY [kl.] H:mm'
	        },
	        calendar : {
	            sameDay : '[í dag kl.] LT',
	            nextDay : '[á morgun kl.] LT',
	            nextWeek : 'dddd [kl.] LT',
	            lastDay : '[í gær kl.] LT',
	            lastWeek : '[síðasta] dddd [kl.] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'eftir %s',
	            past : 'fyrir %s síðan',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : 'klukkustund',
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return is;
	
	}));

/***/ },
/* 1132 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var it = moment.defineLocale('it', {
	        months : 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split('_'),
	        monthsShort : 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays : 'Domenica_Lunedì_Martedì_Mercoledì_Giovedì_Venerdì_Sabato'.split('_'),
	        weekdaysShort : 'Dom_Lun_Mar_Mer_Gio_Ven_Sab'.split('_'),
	        weekdaysMin : 'Do_Lu_Ma_Me_Gi_Ve_Sa'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return ((/^[0-9].+$/).test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past : '%s fa',
	            s : 'alcuni secondi',
	            m : 'un minuto',
	            mm : '%d minuti',
	            h : 'un\'ora',
	            hh : '%d ore',
	            d : 'un giorno',
	            dd : '%d giorni',
	            M : 'un mese',
	            MM : '%d mesi',
	            y : 'un anno',
	            yy : '%d anni'
	        },
	        ordinalParse : /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return it;
	
	}));

/***/ },
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ja = moment.defineLocale('ja', {
	        months : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort : '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin : '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat : {
	            LT : 'Ah時m分',
	            LTS : 'Ah時m分s秒',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY年M月D日',
	            LLL : 'YYYY年M月D日Ah時m分',
	            LLLL : 'YYYY年M月D日Ah時m分 dddd'
	        },
	        meridiemParse: /午前|午後/i,
	        isPM : function (input) {
	            return input === '午後';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar : {
	            sameDay : '[今日] LT',
	            nextDay : '[明日] LT',
	            nextWeek : '[来週]dddd LT',
	            lastDay : '[昨日] LT',
	            lastWeek : '[前週]dddd LT',
	            sameElse : 'L'
	        },
	        ordinalParse : /\d{1,2}日/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s後',
	            past : '%s前',
	            s : '数秒',
	            m : '1分',
	            mm : '%d分',
	            h : '1時間',
	            hh : '%d時間',
	            d : '1日',
	            dd : '%d日',
	            M : '1ヶ月',
	            MM : '%dヶ月',
	            y : '1年',
	            yy : '%d年'
	        }
	    });
	
	    return ja;
	
	}));

/***/ },
/* 1134 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var jv = moment.defineLocale('jv', {
	        months : 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split('_'),
	        monthsShort : 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays : 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort : 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin : 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar : {
	            sameDay : '[Dinten puniko pukul] LT',
	            nextDay : '[Mbenjang pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kala wingi pukul] LT',
	            lastWeek : 'dddd [kepengker pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'wonten ing %s',
	            past : '%s ingkang kepengker',
	            s : 'sawetawis detik',
	            m : 'setunggal menit',
	            mm : '%d menit',
	            h : 'setunggal jam',
	            hh : '%d jam',
	            d : 'sedinten',
	            dd : '%d dinten',
	            M : 'sewulan',
	            MM : '%d wulan',
	            y : 'setaun',
	            yy : '%d taun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return jv;
	
	}));

/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/irakli-janiashvili
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ka = moment.defineLocale('ka', {
	        months : {
	            standalone: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split('_'),
	            format: 'იანვარს_თებერვალს_მარტს_აპრილის_მაისს_ივნისს_ივლისს_აგვისტს_სექტემბერს_ოქტომბერს_ნოემბერს_დეკემბერს'.split('_')
	        },
	        monthsShort : 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays : {
	            standalone: 'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split('_'),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split('_'),
	            isFormat: /(წინა|შემდეგ)/
	        },
	        weekdaysShort : 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin : 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[დღეს] LT[-ზე]',
	            nextDay : '[ხვალ] LT[-ზე]',
	            lastDay : '[გუშინ] LT[-ზე]',
	            nextWeek : '[შემდეგ] dddd LT[-ზე]',
	            lastWeek : '[წინა] dddd LT-ზე',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : function (s) {
	                return (/(წამი|წუთი|საათი|წელი)/).test(s) ?
	                    s.replace(/ი$/, 'ში') :
	                    s + 'ში';
	            },
	            past : function (s) {
	                if ((/(წამი|წუთი|საათი|დღე|თვე)/).test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if ((/წელი/).test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	            },
	            s : 'რამდენიმე წამი',
	            m : 'წუთი',
	            mm : '%d წუთი',
	            h : 'საათი',
	            hh : '%d საათი',
	            d : 'დღე',
	            dd : '%d დღე',
	            M : 'თვე',
	            MM : '%d თვე',
	            y : 'წელი',
	            yy : '%d წელი'
	        },
	        ordinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal : function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if ((number < 20) || (number <= 100 && (number % 20 === 0)) || (number % 100 === 0)) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week : {
	            dow : 1,
	            doy : 7
	        }
	    });
	
	    return ka;
	
	}));

/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші'
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months : 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split('_'),
	        monthsShort : 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays : 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split('_'),
	        weekdaysShort : 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin : 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгін сағат] LT',
	            nextDay : '[Ертең сағат] LT',
	            nextWeek : 'dddd [сағат] LT',
	            lastDay : '[Кеше сағат] LT',
	            lastWeek : '[Өткен аптаның] dddd [сағат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ішінде',
	            past : '%s бұрын',
	            s : 'бірнеше секунд',
	            m : 'бір минут',
	            mm : '%d минут',
	            h : 'бір сағат',
	            hh : '%d сағат',
	            d : 'бір күн',
	            dd : '%d күн',
	            M : 'бір ай',
	            MM : '%d ай',
	            y : 'бір жыл',
	            yy : '%d жыл'
	        },
	        ordinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return kk;
	
	}));

/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	        monthsShort: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split('_'),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysMin: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ'
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return km;
	
	}));

/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ko = moment.defineLocale('ko', {
	        months : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort : '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        weekdays : '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort : '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin : '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat : {
	            LT : 'A h시 m분',
	            LTS : 'A h시 m분 s초',
	            L : 'YYYY.MM.DD',
	            LL : 'YYYY년 MMMM D일',
	            LLL : 'YYYY년 MMMM D일 A h시 m분',
	            LLLL : 'YYYY년 MMMM D일 dddd A h시 m분'
	        },
	        calendar : {
	            sameDay : '오늘 LT',
	            nextDay : '내일 LT',
	            nextWeek : 'dddd LT',
	            lastDay : '어제 LT',
	            lastWeek : '지난주 dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s 후',
	            past : '%s 전',
	            s : '몇 초',
	            ss : '%d초',
	            m : '일분',
	            mm : '%d분',
	            h : '한 시간',
	            hh : '%d시간',
	            d : '하루',
	            dd : '%d일',
	            M : '한 달',
	            MM : '%d달',
	            y : '일 년',
	            yy : '%d년'
	        },
	        ordinalParse : /\d{1,2}일/,
	        ordinal : '%d일',
	        meridiemParse : /오전|오후/,
	        isPM : function (token) {
	            return token === '오후';
	        },
	        meridiem : function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        }
	    });
	
	    return ko;
	
	}));

/***/ },
/* 1139 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү'
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months : 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_'),
	        monthsShort : 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split('_'),
	        weekdaysShort : 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin : 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бүгүн саат] LT',
	            nextDay : '[Эртең саат] LT',
	            nextWeek : 'dddd [саат] LT',
	            lastDay : '[Кече саат] LT',
	            lastWeek : '[Өткен аптанын] dddd [күнү] [саат] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ичинде',
	            past : '%s мурун',
	            s : 'бирнече секунд',
	            m : 'бир мүнөт',
	            mm : '%d мүнөт',
	            h : 'бир саат',
	            hh : '%d саат',
	            d : 'бир күн',
	            dd : '%d күн',
	            M : 'бир ай',
	            MM : '%d ай',
	            y : 'бир жыл',
	            yy : '%d жыл'
	        },
	        ordinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal : function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ky;
	
	}));

/***/ },
/* 1140 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            'm': ['eng Minutt', 'enger Minutt'],
	            'h': ['eng Stonn', 'enger Stonn'],
	            'd': ['een Dag', 'engem Dag'],
	            'M': ['ee Mount', 'engem Mount'],
	            'y': ['ee Joer', 'engem Joer']
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10, firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
	        monthsShort: 'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split('_'),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]'
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            }
	        },
	        relativeTime : {
	            future : processFutureTime,
	            past : processPastTime,
	            s : 'e puer Sekonnen',
	            m : processRelativeTime,
	            mm : '%d Minutten',
	            h : processRelativeTime,
	            hh : '%d Stonnen',
	            d : processRelativeTime,
	            dd : '%d Deeg',
	            M : processRelativeTime,
	            MM : '%d Méint',
	            y : processRelativeTime,
	            yy : '%d Joer'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lb;
	
	}));

/***/ },
/* 1141 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var lo = moment.defineLocale('lo', {
	        months : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        monthsShort : 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split('_'),
	        weekdays : 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort : 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin : 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'ວັນdddd D MMMM YYYY HH:mm'
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar : {
	            sameDay : '[ມື້ນີ້ເວລາ] LT',
	            nextDay : '[ມື້ອື່ນເວລາ] LT',
	            nextWeek : '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay : '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek : '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'ອີກ %s',
	            past : '%sຜ່ານມາ',
	            s : 'ບໍ່ເທົ່າໃດວິນາທີ',
	            m : '1 ນາທີ',
	            mm : '%d ນາທີ',
	            h : '1 ຊົ່ວໂມງ',
	            hh : '%d ຊົ່ວໂມງ',
	            d : '1 ມື້',
	            dd : '%d ມື້',
	            M : '1 ເດືອນ',
	            MM : '%d ເດືອນ',
	            y : '1 ປີ',
	            yy : '%d ປີ'
	        },
	        ordinalParse: /(ທີ່)\d{1,2}/,
	        ordinal : function (number) {
	            return 'ທີ່' + number;
	        }
	    });
	
	    return lo;
	
	}));

/***/ },
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var units = {
	        'm' : 'minutė_minutės_minutę',
	        'mm': 'minutės_minučių_minutes',
	        'h' : 'valanda_valandos_valandą',
	        'hh': 'valandos_valandų_valandas',
	        'd' : 'diena_dienos_dieną',
	        'dd': 'dienos_dienų_dienas',
	        'M' : 'mėnuo_mėnesio_mėnesį',
	        'MM': 'mėnesiai_mėnesių_mėnesius',
	        'y' : 'metai_metų_metus',
	        'yy': 'metai_metų_metus'
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix ? forms(key)[0] : (isFuture ? forms(key)[1] : forms(key)[2]);
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return result + translateSingular(number, withoutSuffix, key[0], isFuture);
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months : {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split('_'),
	            standalone: 'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split('_'),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s+)+MMMM?|MMMM?(\[[^\[\]]*\]|\s+)+D[oD]?/
	        },
	        monthsShort : 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays : {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split('_'),
	            standalone: 'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split('_'),
	            isFormat: /dddd HH:mm/
	        },
	        weekdaysShort : 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin : 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY [m.] MMMM D [d.]',
	            LLL : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL : 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY [m.] MMMM D [d.]',
	            lll : 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll : 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]'
	        },
	        calendar : {
	            sameDay : '[Šiandien] LT',
	            nextDay : '[Rytoj] LT',
	            nextWeek : 'dddd LT',
	            lastDay : '[Vakar] LT',
	            lastWeek : '[Praėjusį] dddd LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'po %s',
	            past : 'prieš %s',
	            s : translateSeconds,
	            m : translateSingular,
	            mm : translate,
	            h : translateSingular,
	            hh : translate,
	            d : translateSingular,
	            dd : translate,
	            M : translateSingular,
	            MM : translate,
	            y : translateSingular,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}-oji/,
	        ordinal : function (number) {
	            return number + '-oji';
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lt;
	
	}));

/***/ },
/* 1143 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var units = {
	        'm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'mm': 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        'h': 'stundas_stundām_stunda_stundas'.split('_'),
	        'hh': 'stundas_stundām_stunda_stundas'.split('_'),
	        'd': 'dienas_dienām_diena_dienas'.split('_'),
	        'dd': 'dienas_dienām_diena_dienas'.split('_'),
	        'M': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'MM': 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        'y': 'gada_gadiem_gads_gadi'.split('_'),
	        'yy': 'gada_gadiem_gads_gadi'.split('_')
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months : 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split('_'),
	        weekdaysShort : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin : 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY.',
	            LL : 'YYYY. [gada] D. MMMM',
	            LLL : 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL : 'YYYY. [gada] D. MMMM, dddd, HH:mm'
	        },
	        calendar : {
	            sameDay : '[Šodien pulksten] LT',
	            nextDay : '[Rīt pulksten] LT',
	            nextWeek : 'dddd [pulksten] LT',
	            lastDay : '[Vakar pulksten] LT',
	            lastWeek : '[Pagājušā] dddd [pulksten] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'pēc %s',
	            past : 'pirms %s',
	            s : relativeSeconds,
	            m : relativeTimeWithSingular,
	            mm : relativeTimeWithPlural,
	            h : relativeTimeWithSingular,
	            hh : relativeTimeWithPlural,
	            d : relativeTimeWithSingular,
	            dd : relativeTimeWithPlural,
	            M : relativeTimeWithSingular,
	            MM : relativeTimeWithPlural,
	            y : relativeTimeWithSingular,
	            yy : relativeTimeWithPlural
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return lv;
	
	}));

/***/ },
/* 1144 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact : true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'prije %s',
	            s      : 'nekoliko sekundi',
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mjesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return me;
	
	}));

/***/ },
/* 1145 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split('_'),
	        monthsShort: 'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split('_'),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm'
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau'
	        },
	        ordinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return mi;
	
	}));

/***/ },
/* 1146 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var mk = moment.defineLocale('mk', {
	        months : 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split('_'),
	        monthsShort : 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays : 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split('_'),
	        weekdaysShort : 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin : 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'D.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay : '[Денес во] LT',
	            nextDay : '[Утре во] LT',
	            nextWeek : '[Во] dddd [во] LT',
	            lastDay : '[Вчера во] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'после %s',
	            past : 'пред %s',
	            s : 'неколку секунди',
	            m : 'минута',
	            mm : '%d минути',
	            h : 'час',
	            hh : '%d часа',
	            d : 'ден',
	            dd : '%d дена',
	            M : 'месец',
	            MM : '%d месеци',
	            y : 'година',
	            yy : '%d години'
	        },
	        ordinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal : function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return mk;
	
	}));

/***/ },
/* 1147 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ml = moment.defineLocale('ml', {
	        months : 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split('_'),
	        monthsShort : 'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split('_'),
	        weekdaysShort : 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin : 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm -നു',
	            LTS : 'A h:mm:ss -നു',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm -നു',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm -നു'
	        },
	        calendar : {
	            sameDay : '[ഇന്ന്] LT',
	            nextDay : '[നാളെ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ഇന്നലെ] LT',
	            lastWeek : '[കഴിഞ്ഞ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s കഴിഞ്ഞ്',
	            past : '%s മുൻപ്',
	            s : 'അൽപ നിമിഷങ്ങൾ',
	            m : 'ഒരു മിനിറ്റ്',
	            mm : '%d മിനിറ്റ്',
	            h : 'ഒരു മണിക്കൂർ',
	            hh : '%d മണിക്കൂർ',
	            d : 'ഒരു ദിവസം',
	            dd : '%d ദിവസം',
	            M : 'ഒരു മാസം',
	            MM : '%d മാസം',
	            y : 'ഒരു വർഷം',
	            yy : '%d വർഷം'
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if ((meridiem === 'രാത്രി' && hour >= 4) ||
	                    meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                    meridiem === 'വൈകുന്നേരം') {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        }
	    });
	
	    return ml;
	
	}));

/***/ },
/* 1148 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture)
	    {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's': output = 'काही सेकंद'; break;
	                case 'm': output = 'एक मिनिट'; break;
	                case 'mm': output = '%d मिनिटे'; break;
	                case 'h': output = 'एक तास'; break;
	                case 'hh': output = '%d तास'; break;
	                case 'd': output = 'एक दिवस'; break;
	                case 'dd': output = '%d दिवस'; break;
	                case 'M': output = 'एक महिना'; break;
	                case 'MM': output = '%d महिने'; break;
	                case 'y': output = 'एक वर्ष'; break;
	                case 'yy': output = '%d वर्षे'; break;
	            }
	        }
	        else {
	            switch (string) {
	                case 's': output = 'काही सेकंदां'; break;
	                case 'm': output = 'एका मिनिटा'; break;
	                case 'mm': output = '%d मिनिटां'; break;
	                case 'h': output = 'एका तासा'; break;
	                case 'hh': output = '%d तासां'; break;
	                case 'd': output = 'एका दिवसा'; break;
	                case 'dd': output = '%d दिवसां'; break;
	                case 'M': output = 'एका महिन्या'; break;
	                case 'MM': output = '%d महिन्यां'; break;
	                case 'y': output = 'एका वर्षा'; break;
	                case 'yy': output = '%d वर्षां'; break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months : 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split('_'),
	        monthsShort: 'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort : 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin : 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm वाजता',
	            LTS : 'A h:mm:ss वाजता',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm वाजता',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm वाजता'
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[उद्या] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /रात्री|सकाळी|दुपारी|सायंकाळी/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात्री') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळी') {
	                return hour;
	            } else if (meridiem === 'दुपारी') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'सायंकाळी') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात्री';
	            } else if (hour < 10) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return mr;
	
	}));

/***/ },
/* 1149 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ms = moment.defineLocale('ms', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ms;
	
	}));

/***/ },
/* 1150 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var ms_my = moment.defineLocale('ms-my', {
	        months : 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays : 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort : 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin : 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [pukul] HH.mm',
	            LLLL : 'dddd, D MMMM YYYY [pukul] HH.mm'
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar : {
	            sameDay : '[Hari ini pukul] LT',
	            nextDay : '[Esok pukul] LT',
	            nextWeek : 'dddd [pukul] LT',
	            lastDay : '[Kelmarin pukul] LT',
	            lastWeek : 'dddd [lepas pukul] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'dalam %s',
	            past : '%s yang lepas',
	            s : 'beberapa saat',
	            m : 'seminit',
	            mm : '%d minit',
	            h : 'sejam',
	            hh : '%d jam',
	            d : 'sehari',
	            dd : '%d hari',
	            M : 'sebulan',
	            MM : '%d bulan',
	            y : 'setahun',
	            yy : '%d tahun'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ms_my;
	
	}));

/***/ },
/* 1151 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '၁',
	        '2': '၂',
	        '3': '၃',
	        '4': '၄',
	        '5': '၅',
	        '6': '၆',
	        '7': '၇',
	        '8': '၈',
	        '9': '၉',
	        '0': '၀'
	    }, numberMap = {
	        '၁': '1',
	        '၂': '2',
	        '၃': '3',
	        '၄': '4',
	        '၅': '5',
	        '၆': '6',
	        '၇': '7',
	        '၈': '8',
	        '၉': '9',
	        '၀': '0'
	    };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split('_'),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split('_'),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L'
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်'
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4 // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return my;
	
	}));

/***/ },
/* 1152 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var nb = moment.defineLocale('nb', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan._feb._mars_april_mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort : 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin : 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s siden',
	            s : 'noen sekunder',
	            m : 'ett minutt',
	            mm : '%d minutter',
	            h : 'en time',
	            hh : '%d timer',
	            d : 'en dag',
	            dd : '%d dager',
	            M : 'en måned',
	            MM : '%d måneder',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nb;
	
	}));

/***/ },
/* 1153 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '१',
	        '2': '२',
	        '3': '३',
	        '4': '४',
	        '5': '५',
	        '6': '६',
	        '7': '७',
	        '8': '८',
	        '9': '९',
	        '0': '०'
	    },
	    numberMap = {
	        '१': '1',
	        '२': '2',
	        '३': '3',
	        '४': '4',
	        '५': '5',
	        '६': '6',
	        '७': '7',
	        '८': '8',
	        '९': '9',
	        '०': '0'
	    };
	
	    var ne = moment.defineLocale('ne', {
	        months : 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split('_'),
	        monthsShort : 'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split('_'),
	        weekdaysShort : 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin : 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'Aको h:mm बजे',
	            LTS : 'Aको h:mm:ss बजे',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL : 'dddd, D MMMM YYYY, Aको h:mm बजे'
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar : {
	            sameDay : '[आज] LT',
	            nextDay : '[भोलि] LT',
	            nextWeek : '[आउँदो] dddd[,] LT',
	            lastDay : '[हिजो] LT',
	            lastWeek : '[गएको] dddd[,] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sमा',
	            past : '%s अगाडि',
	            s : 'केही क्षण',
	            m : 'एक मिनेट',
	            mm : '%d मिनेट',
	            h : 'एक घण्टा',
	            hh : '%d घण्टा',
	            d : 'एक दिन',
	            dd : '%d दिन',
	            M : 'एक महिना',
	            MM : '%d महिना',
	            y : 'एक बर्ष',
	            yy : '%d बर्ष'
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ne;
	
	}));

/***/ },
/* 1154 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_');
	
	    var monthsParse = [/^jan/i, /^feb/i, /^maart|mrt.?$/i, /^apr/i, /^mei$/i, /^jun[i.]?$/i, /^jul[i.]?$/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i];
	    var monthsRegex = /^(januari|februari|maart|april|mei|april|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months : 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split('_'),
	        monthsShort : function (m, format) {
	            if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: /^(januari|februari|maart|mei|ju[nl]i|april|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        weekdays : 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort : 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin : 'Zo_Ma_Di_Wo_Do_Vr_Za'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD-MM-YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'over %s',
	            past : '%s geleden',
	            s : 'een paar seconden',
	            m : 'één minuut',
	            mm : '%d minuten',
	            h : 'één uur',
	            hh : '%d uur',
	            d : 'één dag',
	            dd : '%d dagen',
	            M : 'één maand',
	            MM : '%d maanden',
	            y : 'één jaar',
	            yy : '%d jaar'
	        },
	        ordinalParse: /\d{1,2}(ste|de)/,
	        ordinal : function (number) {
	            return number + ((number === 1 || number === 8 || number >= 20) ? 'ste' : 'de');
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nl;
	
	}));

/***/ },
/* 1155 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! author : https://github.com/mechuwind
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var nn = moment.defineLocale('nn', {
	        months : 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays : 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort : 'sun_mån_tys_ons_tor_fre_lau'.split('_'),
	        weekdaysMin : 'su_må_ty_on_to_fr_lø'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY [kl.] H:mm',
	            LLLL : 'dddd D. MMMM YYYY [kl.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : '%s sidan',
	            s : 'nokre sekund',
	            m : 'eit minutt',
	            mm : '%d minutt',
	            h : 'ein time',
	            hh : '%d timar',
	            d : 'ein dag',
	            dd : '%d dagar',
	            M : 'ein månad',
	            MM : '%d månader',
	            y : 'eit år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return nn;
	
	}));

/***/ },
/* 1156 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '੧',
	        '2': '੨',
	        '3': '੩',
	        '4': '੪',
	        '5': '੫',
	        '6': '੬',
	        '7': '੭',
	        '8': '੮',
	        '9': '੯',
	        '0': '੦'
	    },
	    numberMap = {
	        '੧': '1',
	        '੨': '2',
	        '੩': '3',
	        '੪': '4',
	        '੫': '5',
	        '੬': '6',
	        '੭': '7',
	        '੮': '8',
	        '੯': '9',
	        '੦': '0'
	    };
	
	    var pa_in = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calender but they are not used as rigidly in modern Punjabi.
	        months : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        monthsShort : 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split('_'),
	        weekdays : 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split('_'),
	        weekdaysShort : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin : 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm ਵਜੇ',
	            LTS : 'A h:mm:ss ਵਜੇ',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm ਵਜੇ'
	        },
	        calendar : {
	            sameDay : '[ਅਜ] LT',
	            nextDay : '[ਕਲ] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[ਕਲ] LT',
	            lastWeek : '[ਪਿਛਲੇ] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s ਵਿੱਚ',
	            past : '%s ਪਿਛਲੇ',
	            s : 'ਕੁਝ ਸਕਿੰਟ',
	            m : 'ਇਕ ਮਿੰਟ',
	            mm : '%d ਮਿੰਟ',
	            h : 'ਇੱਕ ਘੰਟਾ',
	            hh : '%d ਘੰਟੇ',
	            d : 'ਇੱਕ ਦਿਨ',
	            dd : '%d ਦਿਨ',
	            M : 'ਇੱਕ ਮਹੀਨਾ',
	            MM : '%d ਮਹੀਨੇ',
	            y : 'ਇੱਕ ਸਾਲ',
	            yy : '%d ਸਾਲ'
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return pa_in;
	
	}));

/***/ },
/* 1157 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_'),
	        monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
	    function plural(n) {
	        return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix  ? 'godzina'  : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months : function (momentToFormat, format) {
	            if (format === '') {
	                // Hack: if format empty we know this is used to generate
	                // RegExp by moment. Give then back both valid forms of months
	                // in RegExp ready format.
	                return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort : 'nie_pon_wt_śr_czw_pt_sb'.split('_'),
	        weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: '[W] dddd [o] LT',
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : '%s temu',
	            s : 'kilka sekund',
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : '1 dzień',
	            dd : '%d dni',
	            M : 'miesiąc',
	            MM : translate,
	            y : 'rok',
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pl;
	
	}));

/***/ },
/* 1158 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var pt = moment.defineLocale('pt', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-Feira_Terça-Feira_Quarta-Feira_Quinta-Feira_Sexta-Feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : 'há %s',
	            s : 'segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        ordinalParse: /\d{1,2}º/,
	        ordinal : '%dº',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return pt;
	
	}));

/***/ },
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var pt_br = moment.defineLocale('pt-br', {
	        months : 'Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays : 'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split('_'),
	        weekdaysShort : 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin : 'Dom_2ª_3ª_4ª_5ª_6ª_Sáb'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D [de] MMMM [de] YYYY',
	            LLL : 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL : 'dddd, D [de] MMMM [de] YYYY [às] HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return (this.day() === 0 || this.day() === 6) ?
	                    '[Último] dddd [às] LT' : // Saturday + Sunday
	                    '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'em %s',
	            past : '%s atrás',
	            s : 'poucos segundos',
	            m : 'um minuto',
	            mm : '%d minutos',
	            h : 'uma hora',
	            hh : '%d horas',
	            d : 'um dia',
	            dd : '%d dias',
	            M : 'um mês',
	            MM : '%d meses',
	            y : 'um ano',
	            yy : '%d anos'
	        },
	        ordinalParse: /\d{1,2}º/,
	        ordinal : '%dº'
	    });
	
	    return pt_br;
	
	}));

/***/ },
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                'mm': 'minute',
	                'hh': 'ore',
	                'dd': 'zile',
	                'MM': 'luni',
	                'yy': 'ani'
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months : 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split('_'),
	        monthsShort : 'ian._febr._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY H:mm',
	            LLLL : 'dddd, D MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'peste %s',
	            past : '%s în urmă',
	            s : 'câteva secunde',
	            m : 'un minut',
	            mm : relativeTimeWithPlural,
	            h : 'o oră',
	            hh : relativeTimeWithPlural,
	            d : 'o zi',
	            dd : relativeTimeWithPlural,
	            M : 'o lună',
	            MM : relativeTimeWithPlural,
	            y : 'un an',
	            yy : relativeTimeWithPlural
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ro;
	
	}));

/***/ },
/* 1161 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! Author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            'hh': 'час_часа_часов',
	            'dd': 'день_дня_дней',
	            'MM': 'месяц_месяца_месяцев',
	            'yy': 'год_года_лет'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months : {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
	            standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
	        },
	        monthsShort : {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
	            standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
	        },
	        weekdays : {
	            standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
	        },
	        weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse : monthsParse,
	        longMonthsParse : monthsParse,
	        shortMonthsParse : monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соотвествует только сокращённым формам
	        monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY г.',
	            LLL : 'D MMMM YYYY г., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY г., HH:mm'
	        },
	        calendar : {
	            sameDay: '[Сегодня в] LT',
	            nextDay: '[Завтра в] LT',
	            lastDay: '[Вчера в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd [в] LT';
	                    } else {
	                        return '[В] dddd [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd [в] LT';
	                    } else {
	                        return '[В] dddd [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'через %s',
	            past : '%s назад',
	            s : 'несколько секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'час',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'месяц',
	            MM : relativeTimeWithPlural,
	            y : 'год',
	            yy : relativeTimeWithPlural
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM : function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        ordinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ru;
	
	}));

/***/ },
/* 1162 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	
	    var se = moment.defineLocale('se', {
	        months : 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split('_'),
	        monthsShort : 'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays : 'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split('_'),
	        weekdaysShort : 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin : 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'MMMM D. [b.] YYYY',
	            LLL : 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL : 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm'
	        },
	        calendar : {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s geažes',
	            past : 'maŋit %s',
	            s : 'moadde sekunddat',
	            m : 'okta minuhta',
	            mm : '%d minuhtat',
	            h : 'okta diimmu',
	            hh : '%d diimmut',
	            d : 'okta beaivi',
	            dd : '%d beaivvit',
	            M : 'okta mánnu',
	            MM : '%d mánut',
	            y : 'okta jahki',
	            yy : '%d jagit'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return se;
	
	}));

/***/ },
/* 1163 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months : 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split('_'),
	        monthsShort : 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split('_'),
	        weekdays : 'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split('_'),
	        weekdaysShort : 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin : 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'a h:mm',
	            LTS : 'a h:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'YYYY MMMM D',
	            LLL : 'YYYY MMMM D, a h:mm',
	            LLLL : 'YYYY MMMM D [වැනි] dddd, a h:mm:ss'
	        },
	        calendar : {
	            sameDay : '[අද] LT[ට]',
	            nextDay : '[හෙට] LT[ට]',
	            nextWeek : 'dddd LT[ට]',
	            lastDay : '[ඊයේ] LT[ට]',
	            lastWeek : '[පසුගිය] dddd LT[ට]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%sකින්',
	            past : '%sකට පෙර',
	            s : 'තත්පර කිහිපය',
	            m : 'මිනිත්තුව',
	            mm : 'මිනිත්තු %d',
	            h : 'පැය',
	            hh : 'පැය %d',
	            d : 'දිනය',
	            dd : 'දින %d',
	            M : 'මාසය',
	            MM : 'මාස %d',
	            y : 'වසර',
	            yy : 'වසර %d'
	        },
	        ordinalParse: /\d{1,2} වැනි/,
	        ordinal : function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse : /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM : function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        }
	    });
	
	    return si;
	
	}));

/***/ },
/* 1164 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var months = 'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split('_'),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return (n > 1) && (n < 5);
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':  // a few seconds / in a few seconds / a few seconds ago
	                return (withoutSuffix || isFuture) ? 'pár sekúnd' : 'pár sekundami';
	            case 'm':  // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : (isFuture ? 'minútu' : 'minútou');
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	                break;
	            case 'h':  // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	                break;
	            case 'd':  // a day / in a day / a day ago
	                return (withoutSuffix || isFuture) ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	                break;
	            case 'M':  // a month / in a month / a month ago
	                return (withoutSuffix || isFuture) ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	                break;
	            case 'y':  // a year / in a year / a year ago
	                return (withoutSuffix || isFuture) ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	                break;
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months : months,
	        monthsShort : monthsShort,
	        weekdays : 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort : 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin : 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat : {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past : 'pred %s',
	            s : translate,
	            m : translate,
	            mm : translate,
	            h : translate,
	            hh : translate,
	            d : translate,
	            dd : translate,
	            M : translate,
	            MM : translate,
	            y : translate,
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sk;
	
	}));

/***/ },
/* 1165 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM YYYY',
	            LLL : 'D. MMMM YYYY H:mm',
	            LLLL : 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar : {
	            sameDay  : '[danes ob] LT',
	            nextDay  : '[jutri ob] LT',
	
	            nextWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay  : '[včeraj ob] LT',
	            lastWeek : function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'čez %s',
	            past   : 'pred %s',
	            s      : processRelativeTime,
	            m      : processRelativeTime,
	            mm     : processRelativeTime,
	            h      : processRelativeTime,
	            hh     : processRelativeTime,
	            d      : processRelativeTime,
	            dd     : processRelativeTime,
	            M      : processRelativeTime,
	            MM     : processRelativeTime,
	            y      : processRelativeTime,
	            yy     : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sl;
	
	}));

/***/ },
/* 1166 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var sq = moment.defineLocale('sq', {
	        months : 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split('_'),
	        monthsShort : 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays : 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split('_'),
	        weekdaysShort : 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin : 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem : function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[Sot në] LT',
	            nextDay : '[Nesër në] LT',
	            nextWeek : 'dddd [në] LT',
	            lastDay : '[Dje në] LT',
	            lastWeek : 'dddd [e kaluar në] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'në %s',
	            past : '%s më parë',
	            s : 'disa sekonda',
	            m : 'një minutë',
	            mm : '%d minuta',
	            h : 'një orë',
	            hh : '%d orë',
	            d : 'një ditë',
	            dd : '%d ditë',
	            M : 'një muaj',
	            MM : '%d muaj',
	            y : 'një vit',
	            yy : '%d vite'
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sq;
	
	}));

/***/ },
/* 1167 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['jedan minut', 'jedne minute'],
	            mm: ['minut', 'minute', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            yy: ['godina', 'godine', 'godina']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split('_'),
	        monthsShort: 'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split('_'),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay  : '[juče u] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'za %s',
	            past   : 'pre %s',
	            s      : 'nekoliko sekundi',
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'dan',
	            dd     : translator.translate,
	            M      : 'mesec',
	            MM     : translator.translate,
	            y      : 'godinu',
	            yy     : translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sr;
	
	}));

/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var translator = {
	        words: { //Different grammatical cases
	            m: ['један минут', 'једне минуте'],
	            mm: ['минут', 'минуте', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            dd: ['дан', 'дана', 'дана'],
	            MM: ['месец', 'месеца', 'месеци'],
	            yy: ['година', 'године', 'година']
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
	            }
	        }
	    };
	
	    var sr_cyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split('_'),
	        monthsShort: 'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS : 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm'
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay  : '[јуче у] LT',
	            lastWeek : function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT'
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past   : 'пре %s',
	            s      : 'неколико секунди',
	            m      : translator.translate,
	            mm     : translator.translate,
	            h      : translator.translate,
	            hh     : translator.translate,
	            d      : 'дан',
	            dd     : translator.translate,
	            M      : 'месец',
	            MM     : translator.translate,
	            y      : 'годину',
	            yy     : translator.translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sr_cyrl;
	
	}));

/***/ },
/* 1169 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	
	    var ss = moment.defineLocale('ss', {
	        months : "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split('_'),
	        monthsShort : 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays : 'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split('_'),
	        weekdaysShort : 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin : 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'h:mm A',
	            LTS : 'h:mm:ss A',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY h:mm A',
	            LLLL : 'dddd, D MMMM YYYY h:mm A'
	        },
	        calendar : {
	            sameDay : '[Namuhla nga] LT',
	            nextDay : '[Kusasa nga] LT',
	            nextWeek : 'dddd [nga] LT',
	            lastDay : '[Itolo nga] LT',
	            lastWeek : 'dddd [leliphelile] [nga] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'nga %s',
	            past : 'wenteka nga %s',
	            s : 'emizuzwana lomcane',
	            m : 'umzuzu',
	            mm : '%d emizuzu',
	            h : 'lihora',
	            hh : '%d emahora',
	            d : 'lilanga',
	            dd : '%d emalanga',
	            M : 'inyanga',
	            MM : '%d tinyanga',
	            y : 'umnyaka',
	            yy : '%d iminyaka'
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        ordinalParse: /\d{1,2}/,
	        ordinal : '%d',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return ss;
	
	}));

/***/ },
/* 1170 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var sv = moment.defineLocale('sv', {
	        months : 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split('_'),
	        monthsShort : 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays : 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort : 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin : 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'YYYY-MM-DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY [kl.] HH:mm',
	            LLLL : 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'om %s',
	            past : 'för %s sedan',
	            s : 'några sekunder',
	            m : 'en minut',
	            mm : '%d minuter',
	            h : 'en timme',
	            hh : '%d timmar',
	            d : 'en dag',
	            dd : '%d dagar',
	            M : 'en månad',
	            MM : '%d månader',
	            y : 'ett år',
	            yy : '%d år'
	        },
	        ordinalParse: /\d{1,2}(e|a)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'e' :
	                (b === 1) ? 'a' :
	                (b === 2) ? 'a' :
	                (b === 3) ? 'e' : 'e';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return sv;
	
	}));

/***/ },
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var sw = moment.defineLocale('sw', {
	        months : 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split('_'),
	        monthsShort : 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays : 'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split('_'),
	        weekdaysShort : 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin : 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[leo saa] LT',
	            nextDay : '[kesho saa] LT',
	            nextWeek : '[wiki ijayo] dddd [saat] LT',
	            lastDay : '[jana] LT',
	            lastWeek : '[wiki iliyopita] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s baadaye',
	            past : 'tokea %s',
	            s : 'hivi punde',
	            m : 'dakika moja',
	            mm : 'dakika %d',
	            h : 'saa limoja',
	            hh : 'masaa %d',
	            d : 'siku moja',
	            dd : 'masiku %d',
	            M : 'mwezi mmoja',
	            MM : 'miezi %d',
	            y : 'mwaka mmoja',
	            yy : 'miaka %d'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return sw;
	
	}));

/***/ },
/* 1172 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var symbolMap = {
	        '1': '௧',
	        '2': '௨',
	        '3': '௩',
	        '4': '௪',
	        '5': '௫',
	        '6': '௬',
	        '7': '௭',
	        '8': '௮',
	        '9': '௯',
	        '0': '௦'
	    }, numberMap = {
	        '௧': '1',
	        '௨': '2',
	        '௩': '3',
	        '௪': '4',
	        '௫': '5',
	        '௬': '6',
	        '௭': '7',
	        '௮': '8',
	        '௯': '9',
	        '௦': '0'
	    };
	
	    var ta = moment.defineLocale('ta', {
	        months : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        monthsShort : 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split('_'),
	        weekdays : 'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split('_'),
	        weekdaysShort : 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split('_'),
	        weekdaysMin : 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, HH:mm',
	            LLLL : 'dddd, D MMMM YYYY, HH:mm'
	        },
	        calendar : {
	            sameDay : '[இன்று] LT',
	            nextDay : '[நாளை] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[நேற்று] LT',
	            lastWeek : '[கடந்த வாரம்] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s இல்',
	            past : '%s முன்',
	            s : 'ஒரு சில விநாடிகள்',
	            m : 'ஒரு நிமிடம்',
	            mm : '%d நிமிடங்கள்',
	            h : 'ஒரு மணி நேரம்',
	            hh : '%d மணி நேரம்',
	            d : 'ஒரு நாள்',
	            dd : '%d நாட்கள்',
	            M : 'ஒரு மாதம்',
	            MM : '%d மாதங்கள்',
	            y : 'ஒரு வருடம்',
	            yy : '%d ஆண்டுகள்'
	        },
	        ordinalParse: /\d{1,2}வது/,
	        ordinal : function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை';  // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return ta;
	
	}));

/***/ },
/* 1173 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var te = moment.defineLocale('te', {
	        months : 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జూలై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split('_'),
	        monthsShort : 'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జూలై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split('_'),
	        weekdaysShort : 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin : 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat : {
	            LT : 'A h:mm',
	            LTS : 'A h:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY, A h:mm',
	            LLLL : 'dddd, D MMMM YYYY, A h:mm'
	        },
	        calendar : {
	            sameDay : '[నేడు] LT',
	            nextDay : '[రేపు] LT',
	            nextWeek : 'dddd, LT',
	            lastDay : '[నిన్న] LT',
	            lastWeek : '[గత] dddd, LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s లో',
	            past : '%s క్రితం',
	            s : 'కొన్ని క్షణాలు',
	            m : 'ఒక నిమిషం',
	            mm : '%d నిమిషాలు',
	            h : 'ఒక గంట',
	            hh : '%d గంటలు',
	            d : 'ఒక రోజు',
	            dd : '%d రోజులు',
	            M : 'ఒక నెల',
	            MM : '%d నెలలు',
	            y : 'ఒక సంవత్సరం',
	            yy : '%d సంవత్సరాలు'
	        },
	        ordinalParse : /\d{1,2}వ/,
	        ordinal : '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week : {
	            dow : 0, // Sunday is the first day of the week.
	            doy : 6  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return te;
	
	}));

/***/ },
/* 1174 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var th = moment.defineLocale('th', {
	        months : 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split('_'),
	        monthsShort : 'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split('_'),
	        monthsParseExact: true,
	        weekdays : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort : 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin : 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'H:mm',
	            LTS : 'H:mm:ss',
	            L : 'YYYY/MM/DD',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY เวลา H:mm',
	            LLLL : 'วันddddที่ D MMMM YYYY เวลา H:mm'
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar : {
	            sameDay : '[วันนี้ เวลา] LT',
	            nextDay : '[พรุ่งนี้ เวลา] LT',
	            nextWeek : 'dddd[หน้า เวลา] LT',
	            lastDay : '[เมื่อวานนี้ เวลา] LT',
	            lastWeek : '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'อีก %s',
	            past : '%sที่แล้ว',
	            s : 'ไม่กี่วินาที',
	            m : '1 นาที',
	            mm : '%d นาที',
	            h : '1 ชั่วโมง',
	            hh : '%d ชั่วโมง',
	            d : '1 วัน',
	            dd : '%d วัน',
	            M : '1 เดือน',
	            MM : '%d เดือน',
	            y : '1 ปี',
	            yy : '%d ปี'
	        }
	    });
	
	    return th;
	
	}));

/***/ },
/* 1175 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var tl_ph = moment.defineLocale('tl-ph', {
	        months : 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split('_'),
	        monthsShort : 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays : 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split('_'),
	        weekdaysShort : 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin : 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'MM/D/YYYY',
	            LL : 'MMMM D, YYYY',
	            LLL : 'MMMM D, YYYY HH:mm',
	            LLLL : 'dddd, MMMM DD, YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Ngayon sa] LT',
	            nextDay: '[Bukas sa] LT',
	            nextWeek: 'dddd [sa] LT',
	            lastDay: '[Kahapon sa] LT',
	            lastWeek: 'dddd [huling linggo] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'sa loob ng %s',
	            past : '%s ang nakalipas',
	            s : 'ilang segundo',
	            m : 'isang minuto',
	            mm : '%d minuto',
	            h : 'isang oras',
	            hh : '%d oras',
	            d : 'isang araw',
	            dd : '%d araw',
	            M : 'isang buwan',
	            MM : '%d buwan',
	            y : 'isang taon',
	            yy : '%d taon'
	        },
	        ordinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tl_ph;
	
	}));

/***/ },
/* 1176 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'leS' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'waQ' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'nem' :
	        time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time = (output.indexOf('jaj') !== -1) ?
	        time.slice(0, -3) + 'Hu’' :
	        (output.indexOf('jar') !== -1) ?
	        time.slice(0, -3) + 'wen' :
	        (output.indexOf('DIS') !== -1) ?
	        time.slice(0, -3) + 'ben' :
	        time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	        ten = Math.floor((number % 100) / 10),
	        one = number % 10,
	        word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += ((word !== '') ? ' ' : '') + numbersNouns[one];
	        }
	        return (word === '') ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months : 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split('_'),
	        monthsShort : 'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysShort : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin : 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : translateFuture,
	            past : translatePast,
	            s : 'puS lup',
	            m : 'wa’ tup',
	            mm : translate,
	            h : 'wa’ rep',
	            hh : translate,
	            d : 'wa’ jaj',
	            dd : translate,
	            M : 'wa’ jar',
	            MM : translate,
	            y : 'wa’ DIS',
	            yy : translate
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return tlh;
	
	}));

/***/ },
/* 1177 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var suffixes = {
	        1: '\'inci',
	        5: '\'inci',
	        8: '\'inci',
	        70: '\'inci',
	        80: '\'inci',
	        2: '\'nci',
	        7: '\'nci',
	        20: '\'nci',
	        50: '\'nci',
	        3: '\'üncü',
	        4: '\'üncü',
	        100: '\'üncü',
	        6: '\'ncı',
	        9: '\'uncu',
	        10: '\'uncu',
	        30: '\'uncu',
	        60: '\'ıncı',
	        90: '\'ıncı'
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months : 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split('_'),
	        monthsShort : 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays : 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split('_'),
	        weekdaysShort : 'Paz_Pts_Sal_Çar_Per_Cum_Cts'.split('_'),
	        weekdaysMin : 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[bugün saat] LT',
	            nextDay : '[yarın saat] LT',
	            nextWeek : '[haftaya] dddd [saat] LT',
	            lastDay : '[dün] LT',
	            lastWeek : '[geçen hafta] dddd [saat] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : '%s sonra',
	            past : '%s önce',
	            s : 'birkaç saniye',
	            m : 'bir dakika',
	            mm : '%d dakika',
	            h : 'bir saat',
	            hh : '%d saat',
	            d : 'bir gün',
	            dd : '%d gün',
	            M : 'bir ay',
	            MM : '%d ay',
	            y : 'bir yıl',
	            yy : '%d yıl'
	        },
	        ordinalParse: /\d{1,2}'(inci|nci|üncü|ncı|uncu|ıncı)/,
	        ordinal : function (number) {
	            if (number === 0) {  // special case for zero
	                return number + '\'ıncı';
	            }
	            var a = number % 10,
	                b = number % 100 - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tr;
	
	}));

/***/ },
/* 1178 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months : 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split('_'),
	        monthsShort : 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays : 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort : 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin : 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat : {
	            LT : 'HH.mm',
	            LTS : 'HH.mm.ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D. MMMM [dallas] YYYY',
	            LLL : 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL : 'dddd, [li] D. MMMM [dallas] YYYY HH.mm'
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM : function (input) {
	            return 'd\'o' === input.toLowerCase();
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'd\'o' : 'D\'O';
	            } else {
	                return isLower ? 'd\'a' : 'D\'A';
	            }
	        },
	        calendar : {
	            sameDay : '[oxhi à] LT',
	            nextDay : '[demà à] LT',
	            nextWeek : 'dddd [à] LT',
	            lastDay : '[ieiri à] LT',
	            lastWeek : '[sür el] dddd [lasteu à] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'osprei %s',
	            past : 'ja%s',
	            s : processRelativeTime,
	            m : processRelativeTime,
	            mm : processRelativeTime,
	            h : processRelativeTime,
	            hh : processRelativeTime,
	            d : processRelativeTime,
	            dd : processRelativeTime,
	            M : processRelativeTime,
	            MM : processRelativeTime,
	            y : processRelativeTime,
	            yy : processRelativeTime
	        },
	        ordinalParse: /\d{1,2}\./,
	        ordinal : '%d.',
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            's': ['viensas secunds', '\'iensas secunds'],
	            'm': ['\'n míut', '\'iens míut'],
	            'mm': [number + ' míuts', '' + number + ' míuts'],
	            'h': ['\'n þora', '\'iensa þora'],
	            'hh': [number + ' þoras', '' + number + ' þoras'],
	            'd': ['\'n ziua', '\'iensa ziua'],
	            'dd': [number + ' ziuas', '' + number + ' ziuas'],
	            'M': ['\'n mes', '\'iens mes'],
	            'MM': [number + ' mesen', '' + number + ' mesen'],
	            'y': ['\'n ar', '\'iens ar'],
	            'yy': [number + ' ars', '' + number + ' ars']
	        };
	        return isFuture ? format[key][0] : (withoutSuffix ? format[key][0] : format[key][1]);
	    }
	
	    return tzl;
	
	}));

/***/ },
/* 1179 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var tzm = moment.defineLocale('tzm', {
	        months : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        monthsShort : 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split('_'),
	        weekdays : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin : 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past : 'ⵢⴰⵏ %s',
	            s : 'ⵉⵎⵉⴽ',
	            m : 'ⵎⵉⵏⵓⴺ',
	            mm : '%d ⵎⵉⵏⵓⴺ',
	            h : 'ⵙⴰⵄⴰ',
	            hh : '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d : 'ⴰⵙⵙ',
	            dd : '%d oⵙⵙⴰⵏ',
	            M : 'ⴰⵢoⵓⵔ',
	            MM : '%d ⵉⵢⵢⵉⵔⵏ',
	            y : 'ⴰⵙⴳⴰⵙ',
	            yy : '%d ⵉⵙⴳⴰⵙⵏ'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tzm;
	
	}));

/***/ },
/* 1180 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var tzm_latn = moment.defineLocale('tzm-latn', {
	        months : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        monthsShort : 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split('_'),
	        weekdays : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin : 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'dadkh s yan %s',
	            past : 'yan %s',
	            s : 'imik',
	            m : 'minuḍ',
	            mm : '%d minuḍ',
	            h : 'saɛa',
	            hh : '%d tassaɛin',
	            d : 'ass',
	            dd : '%d ossan',
	            M : 'ayowr',
	            MM : '%d iyyirn',
	            y : 'asgas',
	            yy : '%d isgasn'
	        },
	        week : {
	            dow : 6, // Saturday is the first day of the week.
	            doy : 12  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return tzm_latn;
	
	}));

/***/ },
/* 1181 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            'dd': 'день_дні_днів',
	            'MM': 'місяць_місяці_місяців',
	            'yy': 'рік_роки_років'
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        }
	        else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        }
	        else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	            'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
	            'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
	            'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
	        },
	        nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
	            'accusative' :
	            ((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
	                'genitive' :
	                'nominative');
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months : {
	            'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
	            'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
	        },
	        monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
	        weekdays : weekdaysCaseReplace,
	        weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD.MM.YYYY',
	            LL : 'D MMMM YYYY р.',
	            LLL : 'D MMMM YYYY р., HH:mm',
	            LLLL : 'dddd, D MMMM YYYY р., HH:mm'
	        },
	        calendar : {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : 'за %s',
	            past : '%s тому',
	            s : 'декілька секунд',
	            m : relativeTimeWithPlural,
	            mm : relativeTimeWithPlural,
	            h : 'годину',
	            hh : relativeTimeWithPlural,
	            d : 'день',
	            dd : relativeTimeWithPlural,
	            M : 'місяць',
	            MM : relativeTimeWithPlural,
	            y : 'рік',
	            yy : relativeTimeWithPlural
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem : function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        ordinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 1st is the first week of the year.
	        }
	    });
	
	    return uk;
	
	}));

/***/ },
/* 1182 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var uz = moment.defineLocale('uz', {
	        months : 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split('_'),
	        monthsShort : 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays : 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort : 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin : 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'D MMMM YYYY, dddd HH:mm'
	        },
	        calendar : {
	            sameDay : '[Бугун соат] LT [да]',
	            nextDay : '[Эртага] LT [да]',
	            nextWeek : 'dddd [куни соат] LT [да]',
	            lastDay : '[Кеча соат] LT [да]',
	            lastWeek : '[Утган] dddd [куни соат] LT [да]',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'Якин %s ичида',
	            past : 'Бир неча %s олдин',
	            s : 'фурсат',
	            m : 'бир дакика',
	            mm : '%d дакика',
	            h : 'бир соат',
	            hh : '%d соат',
	            d : 'бир кун',
	            dd : '%d кун',
	            M : 'бир ой',
	            MM : '%d ой',
	            y : 'бир йил',
	            yy : '%d йил'
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 7  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return uz;
	
	}));

/***/ },
/* 1183 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var vi = moment.defineLocale('vi', {
	        months : 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split('_'),
	        monthsShort : 'Th01_Th02_Th03_Th04_Th05_Th06_Th07_Th08_Th09_Th10_Th11_Th12'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split('_'),
	        weekdaysShort : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin : 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact : true,
	        meridiemParse: /sa|ch/i,
	        isPM : function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem : function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat : {
	            LT : 'HH:mm',
	            LTS : 'HH:mm:ss',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM [năm] YYYY',
	            LLL : 'D MMMM [năm] YYYY HH:mm',
	            LLLL : 'dddd, D MMMM [năm] YYYY HH:mm',
	            l : 'DD/M/YYYY',
	            ll : 'D MMM YYYY',
	            lll : 'D MMM YYYY HH:mm',
	            llll : 'ddd, D MMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần rồi lúc] LT',
	            sameElse: 'L'
	        },
	        relativeTime : {
	            future : '%s tới',
	            past : '%s trước',
	            s : 'vài giây',
	            m : 'một phút',
	            mm : '%d phút',
	            h : 'một giờ',
	            hh : '%d giờ',
	            d : 'một ngày',
	            dd : '%d ngày',
	            M : 'một tháng',
	            MM : '%d tháng',
	            y : 'một năm',
	            yy : '%d năm'
	        },
	        ordinalParse: /\d{1,2}/,
	        ordinal : function (number) {
	            return number;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return vi;
	
	}));

/***/ },
/* 1184 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var x_pseudo = moment.defineLocale('x-pseudo', {
	        months : 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split('_'),
	        monthsShort : 'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split('_'),
	        monthsParseExact : true,
	        weekdays : 'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split('_'),
	        weekdaysShort : 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin : 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact : true,
	        longDateFormat : {
	            LT : 'HH:mm',
	            L : 'DD/MM/YYYY',
	            LL : 'D MMMM YYYY',
	            LLL : 'D MMMM YYYY HH:mm',
	            LLLL : 'dddd, D MMMM YYYY HH:mm'
	        },
	        calendar : {
	            sameDay : '[T~ódá~ý át] LT',
	            nextDay : '[T~ómó~rró~w át] LT',
	            nextWeek : 'dddd [át] LT',
	            lastDay : '[Ý~ést~érdá~ý át] LT',
	            lastWeek : '[L~ást] dddd [át] LT',
	            sameElse : 'L'
	        },
	        relativeTime : {
	            future : 'í~ñ %s',
	            past : '%s á~gó',
	            s : 'á ~féw ~sécó~ñds',
	            m : 'á ~míñ~úté',
	            mm : '%d m~íñú~tés',
	            h : 'á~ñ hó~úr',
	            hh : '%d h~óúrs',
	            d : 'á ~dáý',
	            dd : '%d d~áýs',
	            M : 'á ~móñ~th',
	            MM : '%d m~óñt~hs',
	            y : 'á ~ýéár',
	            yy : '%d ý~éárs'
	        },
	        ordinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal : function (number) {
	            var b = number % 10,
	                output = (~~(number % 100 / 10) === 1) ? 'th' :
	                (b === 1) ? 'st' :
	                (b === 2) ? 'nd' :
	                (b === 3) ? 'rd' : 'th';
	            return number + output;
	        },
	        week : {
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return x_pseudo;
	
	}));

/***/ },
/* 1185 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var zh_cn = moment.defineLocale('zh-cn', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'Ah点mm分',
	            LTS : 'Ah点m分s秒',
	            L : 'YYYY-MM-DD',
	            LL : 'YYYY年MMMD日',
	            LLL : 'YYYY年MMMD日Ah点mm分',
	            LLLL : 'YYYY年MMMD日ddddAh点mm分',
	            l : 'YYYY-MM-DD',
	            ll : 'YYYY年MMMD日',
	            lll : 'YYYY年MMMD日Ah点mm分',
	            llll : 'YYYY年MMMD日ddddAh点mm分'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' ||
	                    meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : function () {
	                return this.minutes() === 0 ? '[今天]Ah[点整]' : '[今天]LT';
	            },
	            nextDay : function () {
	                return this.minutes() === 0 ? '[明天]Ah[点整]' : '[明天]LT';
	            },
	            lastDay : function () {
	                return this.minutes() === 0 ? '[昨天]Ah[点整]' : '[昨天]LT';
	            },
	            nextWeek : function () {
	                var startOfWeek, prefix;
	                startOfWeek = moment().startOf('week');
	                prefix = this.diff(startOfWeek, 'days') >= 7 ? '[下]' : '[本]';
	                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	            },
	            lastWeek : function () {
	                var startOfWeek, prefix;
	                startOfWeek = moment().startOf('week');
	                prefix = this.unix() < startOfWeek.unix()  ? '[上]' : '[本]';
	                return this.minutes() === 0 ? prefix + 'dddAh点整' : prefix + 'dddAh点mm';
	            },
	            sameElse : 'LL'
	        },
	        ordinalParse: /\d{1,2}(日|月|周)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s内',
	            past : '%s前',
	            s : '几秒',
	            m : '1 分钟',
	            mm : '%d 分钟',
	            h : '1 小时',
	            hh : '%d 小时',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 个月',
	            MM : '%d 个月',
	            y : '1 年',
	            yy : '%d 年'
	        },
	        week : {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow : 1, // Monday is the first day of the week.
	            doy : 4  // The week that contains Jan 4th is the first week of the year.
	        }
	    });
	
	    return zh_cn;
	
	}));

/***/ },
/* 1186 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var zh_hk = moment.defineLocale('zh-hk', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'Ah點mm分',
	            LTS : 'Ah點m分s秒',
	            L : 'YYYY年MMMD日',
	            LL : 'YYYY年MMMD日',
	            LLL : 'YYYY年MMMD日Ah點mm分',
	            LLLL : 'YYYY年MMMD日ddddAh點mm分',
	            l : 'YYYY年MMMD日',
	            ll : 'YYYY年MMMD日',
	            lll : 'YYYY年MMMD日Ah點mm分',
	            llll : 'YYYY年MMMD日ddddAh點mm分'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        ordinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zh_hk;
	
	}));

/***/ },
/* 1187 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(1082)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, function (moment) { 'use strict';
	
	
	    var zh_tw = moment.defineLocale('zh-tw', {
	        months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
	        monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat : {
	            LT : 'Ah點mm分',
	            LTS : 'Ah點m分s秒',
	            L : 'YYYY年MMMD日',
	            LL : 'YYYY年MMMD日',
	            LLL : 'YYYY年MMMD日Ah點mm分',
	            LLLL : 'YYYY年MMMD日ddddAh點mm分',
	            l : 'YYYY年MMMD日',
	            ll : 'YYYY年MMMD日',
	            lll : 'YYYY年MMMD日Ah點mm分',
	            llll : 'YYYY年MMMD日ddddAh點mm分'
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour : function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem : function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar : {
	            sameDay : '[今天]LT',
	            nextDay : '[明天]LT',
	            nextWeek : '[下]ddddLT',
	            lastDay : '[昨天]LT',
	            lastWeek : '[上]ddddLT',
	            sameElse : 'L'
	        },
	        ordinalParse: /\d{1,2}(日|月|週)/,
	        ordinal : function (number, period) {
	            switch (period) {
	                case 'd' :
	                case 'D' :
	                case 'DDD' :
	                    return number + '日';
	                case 'M' :
	                    return number + '月';
	                case 'w' :
	                case 'W' :
	                    return number + '週';
	                default :
	                    return number;
	            }
	        },
	        relativeTime : {
	            future : '%s內',
	            past : '%s前',
	            s : '幾秒',
	            m : '1 分鐘',
	            mm : '%d 分鐘',
	            h : '1 小時',
	            hh : '%d 小時',
	            d : '1 天',
	            dd : '%d 天',
	            M : '1 個月',
	            MM : '%d 個月',
	            y : '1 年',
	            yy : '%d 年'
	        }
	    });
	
	    return zh_tw;
	
	}));

/***/ },
/* 1188 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var common_1 = __webpack_require__(22);
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(826);
	var datepicker_inner_component_1 = __webpack_require__(1080);
	var datepicker_component_1 = __webpack_require__(1079);
	var daypicker_component_1 = __webpack_require__(1189);
	var monthpicker_component_1 = __webpack_require__(1190);
	var yearpicker_component_1 = __webpack_require__(1191);
	var components_helper_service_1 = __webpack_require__(541);
	var DatepickerModule = (function () {
	    function DatepickerModule() {
	    }
	    DatepickerModule.decorators = [
	        { type: core_1.NgModule, args: [{
	                    imports: [common_1.CommonModule, forms_1.FormsModule],
	                    declarations: [datepicker_component_1.DatePickerComponent, datepicker_inner_component_1.DatePickerInnerComponent, daypicker_component_1.DayPickerComponent,
	                        monthpicker_component_1.MonthPickerComponent, yearpicker_component_1.YearPickerComponent],
	                    exports: [datepicker_component_1.DatePickerComponent, datepicker_inner_component_1.DatePickerInnerComponent, daypicker_component_1.DayPickerComponent, forms_1.FormsModule,
	                        monthpicker_component_1.MonthPickerComponent, yearpicker_component_1.YearPickerComponent],
	                    providers: [components_helper_service_1.ComponentsHelper]
	                },] },
	    ];
	    /** @nocollapse */
	    DatepickerModule.ctorParameters = [];
	    return DatepickerModule;
	}());
	exports.DatepickerModule = DatepickerModule;


/***/ },
/* 1189 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var ng2_bootstrap_config_1 = __webpack_require__(1074);
	var datepicker_inner_component_1 = __webpack_require__(1080);
	// write an interface for template options
	var TEMPLATE_OPTIONS = (_a = {},
	    _a[ng2_bootstrap_config_1.Ng2BootstrapTheme.BS4] = {
	        ARROW_LEFT: '&lt;',
	        ARROW_RIGHT: '&gt;'
	    },
	    _a[ng2_bootstrap_config_1.Ng2BootstrapTheme.BS3] = {
	        ARROW_LEFT: "\n    <i class=\"glyphicon glyphicon-chevron-left\"></i>\n    ",
	        ARROW_RIGHT: "\n    <i class=\"glyphicon glyphicon-chevron-right\"></i>\n    "
	    },
	    _a
	);
	var DayPickerComponent = (function () {
	    function DayPickerComponent(datePicker) {
	        this.labels = [];
	        this.rows = [];
	        this.weekNumbers = [];
	        this.CURRENT_THEME_TEMPLATE = TEMPLATE_OPTIONS[ng2_bootstrap_config_1.Ng2BootstrapConfig.theme || ng2_bootstrap_config_1.Ng2BootstrapTheme.BS3];
	        this.datePicker = datePicker;
	    }
	    Object.defineProperty(DayPickerComponent.prototype, "isBS4", {
	        get: function () {
	            return ng2_bootstrap_config_1.Ng2BootstrapConfig.theme === ng2_bootstrap_config_1.Ng2BootstrapTheme.BS4;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    /*private getDaysInMonth(year:number, month:number) {
	     return ((month === 1) && (year % 4 === 0) &&
	     ((year % 100 !== 0) || (year % 400 === 0))) ? 29 : DAYS_IN_MONTH[month];
	     }*/
	    DayPickerComponent.prototype.ngOnInit = function () {
	        var self = this;
	        this.datePicker.stepDay = { months: 1 };
	        this.datePicker.setRefreshViewHandler(function () {
	            var year = this.activeDate.getFullYear();
	            var month = this.activeDate.getMonth();
	            var firstDayOfMonth = new Date(year, month, 1);
	            var difference = this.startingDay - firstDayOfMonth.getDay();
	            var numDisplayedFromPreviousMonth = (difference > 0)
	                ? 7 - difference
	                : -difference;
	            var firstDate = new Date(firstDayOfMonth.getTime());
	            if (numDisplayedFromPreviousMonth > 0) {
	                firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
	            }
	            // 42 is the number of days on a six-week calendar
	            var _days = self.getDates(firstDate, 42);
	            var days = [];
	            for (var i = 0; i < 42; i++) {
	                var _dateObject = this.createDateObject(_days[i], this.formatDay);
	                _dateObject.secondary = _days[i].getMonth() !== month;
	                _dateObject.uid = this.uniqueId + '-' + i;
	                days[i] = _dateObject;
	            }
	            self.labels = [];
	            for (var j = 0; j < 7; j++) {
	                self.labels[j] = {};
	                self.labels[j].abbr = this.dateFilter(days[j].date, this.formatDayHeader);
	                self.labels[j].full = this.dateFilter(days[j].date, 'EEEE');
	            }
	            self.title = this.dateFilter(this.activeDate, this.formatDayTitle);
	            self.rows = this.split(days, 7);
	            if (this.showWeeks) {
	                self.weekNumbers = [];
	                var thursdayIndex = (4 + 7 - this.startingDay) % 7;
	                var numWeeks = self.rows.length;
	                for (var curWeek = 0; curWeek < numWeeks; curWeek++) {
	                    self.weekNumbers.push(self.getISO8601WeekNumber(self.rows[curWeek][thursdayIndex].date));
	                }
	            }
	        }, 'day');
	        this.datePicker.setCompareHandler(function (date1, date2) {
	            var d1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
	            var d2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
	            return d1.getTime() - d2.getTime();
	        }, 'day');
	        this.datePicker.refreshView();
	    };
	    DayPickerComponent.prototype.getDates = function (startDate, n) {
	        var dates = new Array(n);
	        var current = new Date(startDate.getTime());
	        var i = 0;
	        var date;
	        while (i < n) {
	            date = new Date(current.getTime());
	            date = this.datePicker.fixTimeZone(date);
	            dates[i++] = date;
	            current = new Date(current.getFullYear(), current.getMonth(), current.getDate() + 1);
	        }
	        return dates;
	    };
	    DayPickerComponent.prototype.getISO8601WeekNumber = function (date) {
	        var checkDate = new Date(date.getTime());
	        // Thursday
	        checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7));
	        var time = checkDate.getTime();
	        // Compare with Jan 1
	        checkDate.setMonth(0);
	        checkDate.setDate(1);
	        return Math.floor(Math.round((time - checkDate.getTime()) / 86400000) / 7) + 1;
	    };
	    // todo: key events implementation
	    DayPickerComponent.decorators = [
	        { type: core_1.Component, args: [{
	                    selector: 'daypicker',
	                    template: "\n<table *ngIf=\"datePicker.datepickerMode==='day'\" role=\"grid\" [attr.aria-labelledby]=\"datePicker.uniqueId+'-title'\" aria-activedescendant=\"activeDateId\">\n  <thead>\n    <tr>\n      <th>\n        <button type=\"button\" \n                class=\"btn btn-default btn-secondary btn-sm pull-left\" \n                (click)=\"datePicker.move(-1)\" \n                tabindex=\"-1\"\n                [innerHTML]=\"CURRENT_THEME_TEMPLATE.ARROW_LEFT\">\n        </button>\n      </th>\n      <th [attr.colspan]=\"5 + (datePicker.showWeeks ? 1 : 0)\">\n        <button [id]=\"datePicker.uniqueId + '-title'\"\n                type=\"button\" class=\"btn btn-default btn-secondary btn-sm\"\n                (click)=\"datePicker.toggleMode()\"\n                [disabled]=\"datePicker.datepickerMode === datePicker.maxMode\"\n                [ngClass]=\"{disabled: datePicker.datepickerMode === datePicker.maxMode}\" tabindex=\"-1\" style=\"width:100%;\">\n          <strong>{{title}}</strong>\n        </button>\n      </th>\n      <th>\n        <button type=\"button\" \n                class=\"btn btn-default btn-secondary btn-sm pull-right\" \n                (click)=\"datePicker.move(1)\" \n                tabindex=\"-1\"\n                [innerHTML]=\"CURRENT_THEME_TEMPLATE.ARROW_RIGHT\">\n        </button>\n      </th>\n    </tr>\n    <tr>\n      <th *ngIf=\"datePicker.showWeeks\"></th>\n      <th *ngFor=\"let labelz of labels\" [ngClass]=\"{'text-xs-center':isBS4, 'text-center': !isBS4}\">\n        <small aria-label=\"labelz.full\"><b>{{labelz.abbr}}</b></small>\n      </th>\n    </tr>\n  </thead>\n  <tbody>\n    <template ngFor [ngForOf]=\"rows\" let-rowz=\"$implicit\" let-index=\"index\">\n      <tr *ngIf=\"!(datePicker.onlyCurrentMonth && rowz[0].secondary && rowz[6].secondary)\">\n        <td *ngIf=\"datePicker.showWeeks\" class=\"h6\" [ngClass]=\"{'text-xs-center':isBS4, 'text-center': !isBS4}\">\n          <em>{{ weekNumbers[index] }}</em>\n        </td>\n        <td *ngFor=\"let dtz of rowz\" [ngClass]=\"{'text-xs-center':isBS4, 'text-center': !isBS4}\" role=\"gridcell\" [id]=\"dtz.uid\">\n          <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-sm {{dtz.customClass}}\"\n                  *ngIf=\"!(datePicker.onlyCurrentMonth && dtz.secondary)\"\n                  [ngClass]=\"{'btn-secondary': isBS4 && !dtz.selected && !datePicker.isActive(dtz), 'btn-info': dtz.selected, disabled: dtz.disabled, active: !isBS4 && datePicker.isActive(dtz), 'btn-default': !isBS4}\"\n                  [disabled]=\"dtz.disabled\"\n                  (click)=\"datePicker.select(dtz.date)\" tabindex=\"-1\">\n            <span [ngClass]=\"{'text-muted': dtz.secondary || dtz.current, 'text-info': !isBS4 && dtz.current}\">{{dtz.label}}</span>\n          </button>\n        </td>\n      </tr>\n    </template>\n  </tbody>\n</table>\n  "
	                },] },
	    ];
	    /** @nocollapse */
	    DayPickerComponent.ctorParameters = [
	        { type: datepicker_inner_component_1.DatePickerInnerComponent, },
	    ];
	    return DayPickerComponent;
	}());
	exports.DayPickerComponent = DayPickerComponent;
	var _a;


/***/ },
/* 1190 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var ng2_bootstrap_config_1 = __webpack_require__(1074);
	var datepicker_inner_component_1 = __webpack_require__(1080);
	var MonthPickerComponent = (function () {
	    function MonthPickerComponent(datePicker) {
	        this.rows = [];
	        this.datePicker = datePicker;
	    }
	    Object.defineProperty(MonthPickerComponent.prototype, "isBS4", {
	        get: function () {
	            return ng2_bootstrap_config_1.Ng2BootstrapConfig.theme === ng2_bootstrap_config_1.Ng2BootstrapTheme.BS4;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    MonthPickerComponent.prototype.ngOnInit = function () {
	        var self = this;
	        this.datePicker.stepMonth = { years: 1 };
	        this.datePicker.setRefreshViewHandler(function () {
	            var months = new Array(12);
	            var year = this.activeDate.getFullYear();
	            var date;
	            for (var i = 0; i < 12; i++) {
	                date = new Date(year, i, 1);
	                date = this.fixTimeZone(date);
	                months[i] = this.createDateObject(date, this.formatMonth);
	                months[i].uid = this.uniqueId + '-' + i;
	            }
	            self.title = this.dateFilter(this.activeDate, this.formatMonthTitle);
	            self.rows = this.split(months, self.datePicker.monthColLimit);
	        }, 'month');
	        this.datePicker.setCompareHandler(function (date1, date2) {
	            var d1 = new Date(date1.getFullYear(), date1.getMonth());
	            var d2 = new Date(date2.getFullYear(), date2.getMonth());
	            return d1.getTime() - d2.getTime();
	        }, 'month');
	        this.datePicker.refreshView();
	    };
	    // todo: key events implementation
	    MonthPickerComponent.decorators = [
	        { type: core_1.Component, args: [{
	                    selector: 'monthpicker',
	                    template: "\n<table *ngIf=\"datePicker.datepickerMode==='month'\" role=\"grid\">\n  <thead>\n    <tr>\n      <th>\n        <button type=\"button\" class=\"btn btn-default btn-sm pull-left\"\n                (click)=\"datePicker.move(-1)\" tabindex=\"-1\">\n          <i class=\"glyphicon glyphicon-chevron-left\"></i>\n        </button></th>\n      <th [attr.colspan]=\"((datePicker.monthColLimit - 2) <= 0) ? 1 : datePicker.monthColLimit - 2\">\n        <button [id]=\"datePicker.uniqueId + '-title'\"\n                type=\"button\" class=\"btn btn-default btn-sm\"\n                (click)=\"datePicker.toggleMode()\"\n                [disabled]=\"datePicker.datepickerMode === maxMode\"\n                [ngClass]=\"{disabled: datePicker.datepickerMode === maxMode}\" tabindex=\"-1\" style=\"width:100%;\">\n          <strong>{{title}}</strong>\n        </button>\n      </th>\n      <th>\n        <button type=\"button\" class=\"btn btn-default btn-sm pull-right\"\n                (click)=\"datePicker.move(1)\" tabindex=\"-1\">\n          <i class=\"glyphicon glyphicon-chevron-right\"></i>\n        </button>\n      </th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr *ngFor=\"let rowz of rows\">\n      <td *ngFor=\"let dtz of rowz\" class=\"text-center\" role=\"gridcell\" id=\"{{dtz.uid}}\" [ngClass]=\"dtz.customClass\">\n        <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default\"\n                [ngClass]=\"{'btn-link': isBS4 && !dtz.selected && !datePicker.isActive(dtz), 'btn-info': dtz.selected || (isBS4 && !dtz.selected && datePicker.isActive(dtz)), disabled: dtz.disabled, active: !isBS4 && datePicker.isActive(dtz)}\"\n                [disabled]=\"dtz.disabled\"\n                (click)=\"datePicker.select(dtz.date)\" tabindex=\"-1\">\n          <span [ngClass]=\"{'text-success': isBS4 && dtz.current, 'text-info': !isBS4 && dtz.current}\">{{dtz.label}}</span>\n        </button>\n      </td>\n    </tr>\n  </tbody>\n</table>\n  "
	                },] },
	    ];
	    /** @nocollapse */
	    MonthPickerComponent.ctorParameters = [
	        { type: datepicker_inner_component_1.DatePickerInnerComponent, },
	    ];
	    return MonthPickerComponent;
	}());
	exports.MonthPickerComponent = MonthPickerComponent;


/***/ },
/* 1191 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var ng2_bootstrap_config_1 = __webpack_require__(1074);
	var datepicker_inner_component_1 = __webpack_require__(1080);
	var YearPickerComponent = (function () {
	    function YearPickerComponent(datePicker) {
	        this.rows = [];
	        this.datePicker = datePicker;
	    }
	    Object.defineProperty(YearPickerComponent.prototype, "isBS4", {
	        get: function () {
	            return ng2_bootstrap_config_1.Ng2BootstrapConfig.theme === ng2_bootstrap_config_1.Ng2BootstrapTheme.BS4;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    YearPickerComponent.prototype.ngOnInit = function () {
	        var self = this;
	        this.datePicker.stepYear = { years: this.datePicker.yearRange };
	        this.datePicker.setRefreshViewHandler(function () {
	            var years = new Array(this.yearRange);
	            var date;
	            var start = self.getStartingYear(this.activeDate.getFullYear());
	            for (var i = 0; i < this.yearRange; i++) {
	                date = new Date(start + i, 0, 1);
	                date = this.fixTimeZone(date);
	                years[i] = this.createDateObject(date, this.formatYear);
	                years[i].uid = this.uniqueId + '-' + i;
	            }
	            self.title = [years[0].label,
	                years[this.yearRange - 1].label].join(' - ');
	            self.rows = this.split(years, self.datePicker.yearColLimit);
	        }, 'year');
	        this.datePicker.setCompareHandler(function (date1, date2) {
	            return date1.getFullYear() - date2.getFullYear();
	        }, 'year');
	        this.datePicker.refreshView();
	    };
	    YearPickerComponent.prototype.getStartingYear = function (year) {
	        // todo: parseInt
	        return ((year - 1) / this.datePicker.yearRange) * this.datePicker.yearRange + 1;
	    };
	    YearPickerComponent.decorators = [
	        { type: core_1.Component, args: [{
	                    selector: 'yearpicker',
	                    template: "\n<table *ngIf=\"datePicker.datepickerMode==='year'\" role=\"grid\">\n  <thead>\n    <tr>\n      <th>\n        <button type=\"button\" class=\"btn btn-default btn-sm pull-left\"\n                (click)=\"datePicker.move(-1)\" tabindex=\"-1\">\n          <i class=\"glyphicon glyphicon-chevron-left\"></i>\n        </button>\n      </th>\n      <th [attr.colspan]=\"((datePicker.yearColLimit - 2) <= 0) ? 1 : datePicker.yearColLimit - 2\">\n        <button [id]=\"datePicker.uniqueId + '-title'\" role=\"heading\"\n                type=\"button\" class=\"btn btn-default btn-sm\"\n                (click)=\"datePicker.toggleMode()\"\n                [disabled]=\"datePicker.datepickerMode === datePicker.maxMode\"\n                [ngClass]=\"{disabled: datePicker.datepickerMode === datePicker.maxMode}\" tabindex=\"-1\" style=\"width:100%;\">\n          <strong>{{title}}</strong>\n        </button>\n      </th>\n      <th>\n        <button type=\"button\" class=\"btn btn-default btn-sm pull-right\"\n                (click)=\"datePicker.move(1)\" tabindex=\"-1\">\n          <i class=\"glyphicon glyphicon-chevron-right\"></i>\n        </button>\n      </th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr *ngFor=\"let rowz of rows\">\n      <td *ngFor=\"let dtz of rowz\" class=\"text-center\" role=\"gridcell\">\n        <button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default\"\n                [ngClass]=\"{'btn-link': isBS4 && !dtz.selected && !datePicker.isActive(dtz), 'btn-info': dtz.selected || (isBS4 && !dtz.selected && datePicker.isActive(dtz)), disabled: dtz.disabled, active: !isBS4 && datePicker.isActive(dtz)}\"\n                [disabled]=\"dtz.disabled\"\n                (click)=\"datePicker.select(dtz.date)\" tabindex=\"-1\">\n          <span [ngClass]=\"{'text-success': isBS4 && dtz.current, 'text-info': !isBS4 && dtz.current}\">{{dtz.label}}</span>\n        </button>\n      </td>\n    </tr>\n  </tbody>\n</table>\n  "
	                },] },
	    ];
	    /** @nocollapse */
	    YearPickerComponent.ctorParameters = [
	        { type: datepicker_inner_component_1.DatePickerInnerComponent, },
	    ];
	    return YearPickerComponent;
	}());
	exports.YearPickerComponent = YearPickerComponent;


/***/ },
/* 1192 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var dropdown_menu_directive_1 = __webpack_require__(1193);
	exports.DropdownMenuDirective = dropdown_menu_directive_1.DropdownMenuDirective;
	var dropdown_toggle_directive_1 = __webpack_require__(1196);
	exports.DropdownToggleDirective = dropdown_toggle_directive_1.DropdownToggleDirective;
	var dropdown_directive_1 = __webpack_require__(1194);
	exports.DropdownDirective = dropdown_directive_1.DropdownDirective;
	var dropdown_service_1 = __webpack_require__(1195);
	exports.DropdownService = dropdown_service_1.DropdownService;
	var dropdown_module_1 = __webpack_require__(1197);
	exports.DropdownModule = dropdown_module_1.DropdownModule;


/***/ },
/* 1193 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var dropdown_directive_1 = __webpack_require__(1194);
	var DropdownMenuDirective = (function () {
	    /* tslint:enable:no-unused-variable */
	    function DropdownMenuDirective(dropdown, el) {
	        /* tslint:disable:no-unused-variable */
	        this.addClass = true;
	        this.dropdown = dropdown;
	        this.el = el;
	    }
	    DropdownMenuDirective.prototype.ngOnInit = function () {
	        this.dropdown.dropDownMenu = this;
	    };
	    DropdownMenuDirective.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: '[dropdownMenu]',
	                    exportAs: 'bs-dropdown-menu'
	                },] },
	    ];
	    /** @nocollapse */
	    DropdownMenuDirective.ctorParameters = [
	        { type: dropdown_directive_1.DropdownDirective, decorators: [{ type: core_1.Host },] },
	        { type: core_1.ElementRef, },
	    ];
	    DropdownMenuDirective.propDecorators = {
	        'addClass': [{ type: core_1.HostBinding, args: ['class.dropdown-menu',] },],
	    };
	    return DropdownMenuDirective;
	}());
	exports.DropdownMenuDirective = DropdownMenuDirective;


/***/ },
/* 1194 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var dropdown_service_1 = __webpack_require__(1195);
	var DropdownDirective = (function () {
	    function DropdownDirective(el, ref) {
	        this.onToggle = new core_1.EventEmitter(false);
	        this.isOpenChange = new core_1.EventEmitter(false);
	        this.addClass = true;
	        // @Query('dropdownMenu', {descendants: false})
	        // dropdownMenuList:QueryList<ElementRef>) {
	        this.el = el;
	        this._changeDetector = ref;
	        // todo: bind to route change event
	    }
	    Object.defineProperty(DropdownDirective.prototype, "isOpen", {
	        get: function () {
	            return this._isOpen;
	        },
	        set: function (value) {
	            this._isOpen = !!value;
	            // todo: implement after porting position
	            // if (this.appendToBody && this.menuEl) {
	            //
	            // }
	            // todo: $animate open<->close transitions, as soon as ng2Animate will be
	            // ready
	            if (this.isOpen) {
	                this.focusToggleElement();
	                dropdown_service_1.dropdownService.open(this);
	            }
	            else {
	                dropdown_service_1.dropdownService.close(this);
	                this.selectedOption = void 0;
	            }
	            this.onToggle.emit(this.isOpen);
	            this.isOpenChange.emit(this.isOpen);
	            this._changeDetector.markForCheck();
	            // todo: implement call to setIsOpen if set and function
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DropdownDirective.prototype.ngOnInit = function () {
	        this.autoClose = this.autoClose || dropdown_service_1.NONINPUT;
	        if (this.isOpen) {
	        }
	    };
	    DropdownDirective.prototype.ngOnDestroy = function () {
	        if (this.appendToBody && this.menuEl) {
	            this.menuEl.nativeElement.remove();
	        }
	    };
	    Object.defineProperty(DropdownDirective.prototype, "dropDownMenu", {
	        set: function (dropdownMenu) {
	            // init drop down menu
	            this.menuEl = dropdownMenu.el;
	            if (this.appendToBody) {
	                window.document.body.appendChild(this.menuEl.nativeElement);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(DropdownDirective.prototype, "dropDownToggle", {
	        set: function (dropdownToggle) {
	            // init toggle element
	            this.toggleEl = dropdownToggle.el;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DropdownDirective.prototype.toggle = function (open) {
	        return this.isOpen = arguments.length ? !!open : !this.isOpen;
	    };
	    DropdownDirective.prototype.focusDropdownEntry = function (keyCode) {
	        // If append to body is used.
	        var hostEl = this.menuEl ?
	            this.menuEl.nativeElement :
	            this.el.nativeElement.getElementsByTagName('ul')[0];
	        if (!hostEl) {
	            // todo: throw exception?
	            return;
	        }
	        var elems = hostEl.getElementsByTagName('a');
	        if (!elems || !elems.length) {
	            // todo: throw exception?
	            return;
	        }
	        // todo: use parseInt to detect isNumber?
	        // todo: or implement selectedOption as a get\set pair with parseInt on set
	        switch (keyCode) {
	            case (40):
	                if (typeof this.selectedOption !== 'number') {
	                    this.selectedOption = 0;
	                    break;
	                }
	                if (this.selectedOption === elems.length - 1) {
	                    break;
	                }
	                this.selectedOption++;
	                break;
	            case (38):
	                if (typeof this.selectedOption !== 'number') {
	                    return;
	                }
	                if (this.selectedOption === 0) {
	                    // todo: return?
	                    break;
	                }
	                this.selectedOption--;
	                break;
	            default:
	                break;
	        }
	        elems[this.selectedOption].focus();
	    };
	    DropdownDirective.prototype.focusToggleElement = function () {
	        if (this.toggleEl) {
	            this.toggleEl.nativeElement.focus();
	        }
	    };
	    DropdownDirective.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: '[dropdown]',
	                    exportAs: 'bs-dropdown'
	                },] },
	    ];
	    /** @nocollapse */
	    DropdownDirective.ctorParameters = [
	        { type: core_1.ElementRef, },
	        { type: core_1.ChangeDetectorRef, },
	    ];
	    DropdownDirective.propDecorators = {
	        'isOpen': [{ type: core_1.HostBinding, args: ['class.open',] }, { type: core_1.Input },],
	        'autoClose': [{ type: core_1.Input },],
	        'keyboardNav': [{ type: core_1.Input },],
	        'appendToBody': [{ type: core_1.Input },],
	        'onToggle': [{ type: core_1.Output },],
	        'isOpenChange': [{ type: core_1.Output },],
	        'addClass': [{ type: core_1.HostBinding, args: ['class.dropdown',] },],
	    };
	    return DropdownDirective;
	}());
	exports.DropdownDirective = DropdownDirective;


/***/ },
/* 1195 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	exports.ALWAYS = 'always';
	exports.DISABLED = 'disabled';
	exports.OUTSIDECLICK = 'outsideClick';
	exports.NONINPUT = 'nonInput';
	/* tslint:disable-next-line */
	var KeyboardEvent = global.KeyboardEvent;
	/* tslint:disable-next-line */
	var MouseEvent = global.MouseEvent;
	var DropdownService = (function () {
	    function DropdownService() {
	        this.closeDropdownBind = this.closeDropdown.bind(this);
	        this.keybindFilterBind = this.keybindFilter.bind(this);
	    }
	    DropdownService.prototype.open = function (dropdownScope) {
	        if (!this.openScope) {
	            window.document.addEventListener('click', this.closeDropdownBind, true);
	            window.document.addEventListener('keydown', this.keybindFilterBind);
	        }
	        if (this.openScope && this.openScope !== dropdownScope) {
	            this.openScope.isOpen = false;
	        }
	        this.openScope = dropdownScope;
	    };
	    DropdownService.prototype.close = function (dropdownScope) {
	        if (this.openScope !== dropdownScope) {
	            return;
	        }
	        this.openScope = void 0;
	        window.document.removeEventListener('click', this.closeDropdownBind, true);
	        window.document.removeEventListener('keydown', this.keybindFilterBind);
	    };
	    DropdownService.prototype.closeDropdown = function (event) {
	        if (!this.openScope) {
	            return;
	        }
	        if (event && this.openScope.autoClose === exports.DISABLED) {
	            return;
	        }
	        if (event && this.openScope.toggleEl &&
	            this.openScope.toggleEl.nativeElement.contains(event.target)) {
	            return;
	        }
	        if (event && this.openScope.autoClose === exports.NONINPUT &&
	            this.openScope.menuEl &&
	            /input|textarea/i.test(event.target.tagName) &&
	            this.openScope.menuEl.nativeElement.contains(event.target)) {
	            return;
	        }
	        if (event && this.openScope.autoClose === exports.OUTSIDECLICK &&
	            this.openScope.menuEl &&
	            this.openScope.menuEl.nativeElement.contains(event.target)) {
	            return;
	        }
	        this.openScope.isOpen = false;
	    };
	    DropdownService.prototype.keybindFilter = function (event) {
	        if (event.which === 27) {
	            this.openScope.focusToggleElement();
	            this.closeDropdown(void 0);
	            return;
	        }
	        if (this.openScope.keyboardNav && this.openScope.isOpen &&
	            (event.which === 38 || event.which === 40)) {
	            event.preventDefault();
	            event.stopPropagation();
	            this.openScope.focusDropdownEntry(event.which);
	        }
	    };
	    return DropdownService;
	}());
	exports.DropdownService = DropdownService;
	exports.dropdownService = new DropdownService();
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1196 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	var core_1 = __webpack_require__(3);
	var dropdown_directive_1 = __webpack_require__(1194);
	/* tslint:disable-next-line */
	var MouseEvent = global.MouseEvent;
	var DropdownToggleDirective = (function () {
	    function DropdownToggleDirective(dropdown, el) {
	        this.isDisabled = false;
	        this.addToggleClass = true;
	        this.addClass = true;
	        this.dropdown = dropdown;
	        this.el = el;
	    }
	    DropdownToggleDirective.prototype.ngOnInit = function () {
	        this.dropdown.dropDownToggle = this;
	    };
	    Object.defineProperty(DropdownToggleDirective.prototype, "isOpen", {
	        get: function () {
	            return this.dropdown.isOpen;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    DropdownToggleDirective.prototype.toggleDropdown = function (event) {
	        event.stopPropagation();
	        if (!this.isDisabled) {
	            this.dropdown.toggle();
	        }
	        return false;
	    };
	    DropdownToggleDirective.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: '[dropdownToggle]',
	                    exportAs: 'bs-dropdown-toggle'
	                },] },
	    ];
	    /** @nocollapse */
	    DropdownToggleDirective.ctorParameters = [
	        { type: dropdown_directive_1.DropdownDirective, decorators: [{ type: core_1.Host },] },
	        { type: core_1.ElementRef, },
	    ];
	    DropdownToggleDirective.propDecorators = {
	        'isDisabled': [{ type: core_1.HostBinding, args: ['class.disabled',] }, { type: core_1.Input },],
	        'addToggleClass': [{ type: core_1.HostBinding, args: ['class.dropdown-toggle',] }, { type: core_1.Input },],
	        'addClass': [{ type: core_1.HostBinding, args: ['attr.aria-haspopup',] },],
	        'isOpen': [{ type: core_1.HostBinding, args: ['attr.aria-expanded',] },],
	        'toggleDropdown': [{ type: core_1.HostListener, args: ['click', ['$event'],] },],
	    };
	    return DropdownToggleDirective;
	}());
	exports.DropdownToggleDirective = DropdownToggleDirective;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1197 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var dropdown_menu_directive_1 = __webpack_require__(1193);
	var dropdown_toggle_directive_1 = __webpack_require__(1196);
	var dropdown_directive_1 = __webpack_require__(1194);
	var DropdownModule = (function () {
	    function DropdownModule() {
	    }
	    DropdownModule.decorators = [
	        { type: core_1.NgModule, args: [{
	                    declarations: [dropdown_directive_1.DropdownDirective, dropdown_menu_directive_1.DropdownMenuDirective, dropdown_toggle_directive_1.DropdownToggleDirective],
	                    exports: [dropdown_directive_1.DropdownDirective, dropdown_menu_directive_1.DropdownMenuDirective, dropdown_toggle_directive_1.DropdownToggleDirective]
	                },] },
	    ];
	    /** @nocollapse */
	    DropdownModule.ctorParameters = [];
	    return DropdownModule;
	}());
	exports.DropdownModule = DropdownModule;


/***/ },
/* 1198 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var pager_component_1 = __webpack_require__(1199);
	exports.PagerComponent = pager_component_1.PagerComponent;
	var pagination_component_1 = __webpack_require__(1200);
	exports.PaginationComponent = pagination_component_1.PaginationComponent;
	var pagination_module_1 = __webpack_require__(1201);
	exports.PaginationModule = pagination_module_1.PaginationModule;


/***/ },
/* 1199 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __extends = (this && this.__extends) || function (d, b) {
	    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
	    function __() { this.constructor = d; }
	    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
	};
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(826);
	var pagination_component_1 = __webpack_require__(1200);
	var pagerConfig = {
	    itemsPerPage: 10,
	    previousText: '« Previous',
	    nextText: 'Next »',
	    pageBtnClass: '',
	    align: true
	};
	var PAGER_TEMPLATE = "\n    <ul class=\"pager\">\n      <li [class.disabled]=\"noPrevious()\" [class.previous]=\"align\" [ngClass]=\"{'pull-right': align}\" class=\"{{ pageBtnClass }}\">\n        <a href (click)=\"selectPage(page - 1, $event)\">{{getText('previous')}}</a>\n      </li>\n      <li [class.disabled]=\"noNext()\" [class.next]=\"align\" [ngClass]=\"{'pull-right': align}\" class=\"{{ pageBtnClass }}\">\n        <a href (click)=\"selectPage(page + 1, $event)\">{{getText('next')}}</a>\n      </li>\n  </ul>\n";
	/* tslint:disable */
	/* tslint:enable */
	var PagerComponent = (function (_super) {
	    __extends(PagerComponent, _super);
	    function PagerComponent(cd, renderer, elementRef) {
	        _super.call(this, cd, renderer, elementRef);
	        this.config = pagerConfig;
	    }
	    PagerComponent.decorators = [
	        { type: core_1.Component, args: [{
	                    selector: 'pager[ngModel]',
	                    template: PAGER_TEMPLATE,
	                    providers: [forms_1.NgModel]
	                },] },
	    ];
	    /** @nocollapse */
	    PagerComponent.ctorParameters = [
	        { type: forms_1.NgModel, decorators: [{ type: core_1.Self },] },
	        { type: core_1.Renderer, },
	        { type: core_1.ElementRef, },
	    ];
	    return PagerComponent;
	}(pagination_component_1.PaginationComponent));
	exports.PagerComponent = PagerComponent;


/***/ },
/* 1200 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(826);
	/* tslint:disable-next-line */
	var MouseEvent = global.MouseEvent;
	var paginationConfig = {
	    maxSize: void 0,
	    itemsPerPage: 10,
	    boundaryLinks: false,
	    directionLinks: true,
	    firstText: 'First',
	    previousText: 'Previous',
	    nextText: 'Next',
	    lastText: 'Last',
	    pageBtnClass: '',
	    rotate: true
	};
	var PAGINATION_TEMPLATE = "\n  <ul class=\"pagination\" [ngClass]=\"classMap\">\n    <li class=\"pagination-first page-item\"\n        *ngIf=\"boundaryLinks\"\n        [class.disabled]=\"noPrevious()||disabled\">\n      <a class=\"page-link\" href (click)=\"selectPage(1, $event)\" [innerHTML]=\"getText('first')\"></a>\n    </li>\n\n    <li class=\"pagination-prev page-item\"\n        *ngIf=\"directionLinks\"\n        [class.disabled]=\"noPrevious()||disabled\">\n      <a class=\"page-link\" href (click)=\"selectPage(page - 1, $event)\" [innerHTML]=\"getText('previous')\"></a>\n      </li>\n\n    <li *ngFor=\"let pg of pages\"\n        [class.active]=\"pg.active\"\n        [class.disabled]=\"disabled&&!pg.active\"\n        class=\"pagination-page page-item\">\n      <a class=\"page-link\" href (click)=\"selectPage(pg.number, $event)\" [innerHTML]=\"pg.text\"></a>\n    </li>\n\n    <li class=\"pagination-next page-item\"\n        *ngIf=\"directionLinks\"\n        [class.disabled]=\"noNext()||disabled\">\n      <a class=\"page-link\" href (click)=\"selectPage(page + 1, $event)\" [innerHTML]=\"getText('next')\"></a></li>\n\n    <li class=\"pagination-last page-item\"\n        *ngIf=\"boundaryLinks\"\n        [class.disabled]=\"noNext()||disabled\">\n      <a class=\"page-link\" href (click)=\"selectPage(totalPages, $event)\" [innerHTML]=\"getText('last')\"></a></li>\n  </ul>\n  ";
	/* tslint:disable */
	/* tslint:enable */
	var PaginationComponent = (function () {
	    function PaginationComponent(cd, renderer, elementRef) {
	        this.numPages = new core_1.EventEmitter(false);
	        this.pageChanged = new core_1.EventEmitter(false);
	        this.onChange = Function.prototype;
	        this.onTouched = Function.prototype;
	        this.inited = false;
	        this.cd = cd;
	        this.renderer = renderer;
	        this.elementRef = elementRef;
	        cd.valueAccessor = this;
	        this.config = this.config || paginationConfig;
	    }
	    Object.defineProperty(PaginationComponent.prototype, "itemsPerPage", {
	        get: function () {
	            return this._itemsPerPage;
	        },
	        set: function (v) {
	            this._itemsPerPage = v;
	            this.totalPages = this.calculateTotalPages();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(PaginationComponent.prototype, "totalItems", {
	        get: function () {
	            return this._totalItems;
	        },
	        set: function (v) {
	            this._totalItems = v;
	            this.totalPages = this.calculateTotalPages();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(PaginationComponent.prototype, "totalPages", {
	        get: function () {
	            return this._totalPages;
	        },
	        set: function (v) {
	            this._totalPages = v;
	            this.numPages.emit(v);
	            if (this.inited) {
	                this.selectPage(this.page);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(PaginationComponent.prototype, "page", {
	        get: function () {
	            return this._page;
	        },
	        set: function (value) {
	            var _previous = this._page;
	            this._page = (value > this.totalPages) ? this.totalPages : (value || 1);
	            if (_previous === this._page || typeof _previous === 'undefined') {
	                return;
	            }
	            this.pageChanged.emit({
	                page: this._page,
	                itemsPerPage: this.itemsPerPage
	            });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    PaginationComponent.prototype.ngOnInit = function () {
	        this.classMap = this.elementRef.nativeElement.getAttribute('class') || '';
	        // watch for maxSize
	        this.maxSize = typeof this.maxSize !== 'undefined'
	            ? this.maxSize
	            : paginationConfig.maxSize;
	        this.rotate = typeof this.rotate !== 'undefined'
	            ? this.rotate
	            : paginationConfig.rotate;
	        this.boundaryLinks = typeof this.boundaryLinks !== 'undefined'
	            ? this.boundaryLinks
	            : paginationConfig.boundaryLinks;
	        this.directionLinks = typeof this.directionLinks !== 'undefined'
	            ? this.directionLinks
	            : paginationConfig.directionLinks;
	        this.pageBtnClass = typeof this.pageBtnClass !== 'undefined'
	            ? this.pageBtnClass
	            : paginationConfig.pageBtnClass;
	        // base class
	        this.itemsPerPage = typeof this.itemsPerPage !== 'undefined'
	            ? this.itemsPerPage
	            : paginationConfig.itemsPerPage;
	        this.totalPages = this.calculateTotalPages();
	        // this class
	        this.pages = this.getPages(this.page, this.totalPages);
	        this.page = this.cd.value;
	        this.inited = true;
	    };
	    PaginationComponent.prototype.writeValue = function (value) {
	        this.page = value;
	        this.pages = this.getPages(this.page, this.totalPages);
	    };
	    PaginationComponent.prototype.getText = function (key) {
	        return this[key + 'Text'] || paginationConfig[key + 'Text'];
	    };
	    PaginationComponent.prototype.noPrevious = function () {
	        return this.page === 1;
	    };
	    PaginationComponent.prototype.noNext = function () {
	        return this.page === this.totalPages;
	    };
	    PaginationComponent.prototype.registerOnChange = function (fn) {
	        this.onChange = fn;
	    };
	    PaginationComponent.prototype.registerOnTouched = function (fn) {
	        this.onTouched = fn;
	    };
	    PaginationComponent.prototype.selectPage = function (page, event) {
	        if (event) {
	            event.preventDefault();
	        }
	        if (!this.disabled) {
	            if (event && event.target) {
	                var target = event.target;
	                target.blur();
	            }
	            this.writeValue(page);
	            this.cd.viewToModelUpdate(this.page);
	        }
	    };
	    // Create page object used in template
	    PaginationComponent.prototype.makePage = function (num, text, isActive) {
	        return {
	            number: num,
	            text: text,
	            active: isActive
	        };
	    };
	    PaginationComponent.prototype.getPages = function (currentPage, totalPages) {
	        var pages = [];
	        // Default page limits
	        var startPage = 1;
	        var endPage = totalPages;
	        var isMaxSized = typeof this.maxSize !== 'undefined' && this.maxSize < totalPages;
	        // recompute if maxSize
	        if (isMaxSized) {
	            if (this.rotate) {
	                // Current page is displayed in the middle of the visible ones
	                startPage = Math.max(currentPage - Math.floor(this.maxSize / 2), 1);
	                endPage = startPage + this.maxSize - 1;
	                // Adjust if limit is exceeded
	                if (endPage > totalPages) {
	                    endPage = totalPages;
	                    startPage = endPage - this.maxSize + 1;
	                }
	            }
	            else {
	                // Visible pages are paginated with maxSize
	                startPage = ((Math.ceil(currentPage / this.maxSize) - 1) * this.maxSize) + 1;
	                // Adjust last page if limit is exceeded
	                endPage = Math.min(startPage + this.maxSize - 1, totalPages);
	            }
	        }
	        // Add page number links
	        for (var num = startPage; num <= endPage; num++) {
	            var page = this.makePage(num, num.toString(), num === currentPage);
	            pages.push(page);
	        }
	        // Add links to move between page sets
	        if (isMaxSized && !this.rotate) {
	            if (startPage > 1) {
	                var previousPageSet = this.makePage(startPage - 1, '...', false);
	                pages.unshift(previousPageSet);
	            }
	            if (endPage < totalPages) {
	                var nextPageSet = this.makePage(endPage + 1, '...', false);
	                pages.push(nextPageSet);
	            }
	        }
	        return pages;
	    };
	    // base class
	    PaginationComponent.prototype.calculateTotalPages = function () {
	        var totalPages = this.itemsPerPage < 1
	            ? 1
	            : Math.ceil(this.totalItems / this.itemsPerPage);
	        return Math.max(totalPages || 0, 1);
	    };
	    PaginationComponent.decorators = [
	        { type: core_1.Component, args: [{
	                    selector: 'pagination[ngModel]',
	                    template: PAGINATION_TEMPLATE,
	                    providers: [forms_1.NgModel]
	                },] },
	    ];
	    /** @nocollapse */
	    PaginationComponent.ctorParameters = [
	        { type: forms_1.NgModel, decorators: [{ type: core_1.Self },] },
	        { type: core_1.Renderer, },
	        { type: core_1.ElementRef, },
	    ];
	    PaginationComponent.propDecorators = {
	        'align': [{ type: core_1.Input },],
	        'maxSize': [{ type: core_1.Input },],
	        'boundaryLinks': [{ type: core_1.Input },],
	        'directionLinks': [{ type: core_1.Input },],
	        'firstText': [{ type: core_1.Input },],
	        'previousText': [{ type: core_1.Input },],
	        'nextText': [{ type: core_1.Input },],
	        'lastText': [{ type: core_1.Input },],
	        'rotate': [{ type: core_1.Input },],
	        'pageBtnClass': [{ type: core_1.Input },],
	        'disabled': [{ type: core_1.Input },],
	        'numPages': [{ type: core_1.Output },],
	        'pageChanged': [{ type: core_1.Output },],
	        'itemsPerPage': [{ type: core_1.Input },],
	        'totalItems': [{ type: core_1.Input },],
	    };
	    return PaginationComponent;
	}());
	exports.PaginationComponent = PaginationComponent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1201 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var common_1 = __webpack_require__(22);
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(826);
	var pager_component_1 = __webpack_require__(1199);
	var pagination_component_1 = __webpack_require__(1200);
	var PaginationModule = (function () {
	    function PaginationModule() {
	    }
	    PaginationModule.decorators = [
	        { type: core_1.NgModule, args: [{
	                    imports: [common_1.CommonModule, forms_1.FormsModule],
	                    declarations: [pager_component_1.PagerComponent, pagination_component_1.PaginationComponent],
	                    exports: [forms_1.FormsModule, pager_component_1.PagerComponent, pagination_component_1.PaginationComponent]
	                },] },
	    ];
	    /** @nocollapse */
	    PaginationModule.ctorParameters = [];
	    return PaginationModule;
	}());
	exports.PaginationModule = PaginationModule;


/***/ },
/* 1202 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var rating_component_1 = __webpack_require__(1203);
	exports.RatingComponent = rating_component_1.RatingComponent;
	var rating_module_1 = __webpack_require__(1204);
	exports.RatingModule = rating_module_1.RatingModule;


/***/ },
/* 1203 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(826);
	/* tslint:disable-next-line */
	var KeyboardEvent = global.KeyboardEvent;
	var RatingComponent = (function () {
	    function RatingComponent(cd) {
	        this.onHover = new core_1.EventEmitter(false);
	        this.onLeave = new core_1.EventEmitter(false);
	        this.onChange = Function.prototype;
	        this.onTouched = Function.prototype;
	        this.cd = cd;
	        cd.valueAccessor = this;
	    }
	    RatingComponent.prototype.onKeydown = function (event) {
	        if ([37, 38, 39, 40].indexOf(event.which) === -1) {
	            return;
	        }
	        event.preventDefault();
	        event.stopPropagation();
	        var sign = event.which === 38 || event.which === 39 ? 1 : -1;
	        this.rate(this.value + sign);
	    };
	    RatingComponent.prototype.ngOnInit = function () {
	        this.max = typeof this.max !== 'undefined' ? this.max : 5;
	        this.readonly = this.readonly === true;
	        this.stateOn = typeof this.stateOn !== 'undefined'
	            ? this.stateOn
	            : 'glyphicon-star';
	        this.stateOff = typeof this.stateOff !== 'undefined'
	            ? this.stateOff
	            : 'glyphicon-star-empty';
	        this.titles = typeof this.titles !== 'undefined' && this.titles.length > 0
	            ? this.titles
	            : ['one', 'two', 'three', 'four', 'five'];
	        this.range = this.buildTemplateObjects(this.ratingStates, this.max);
	    };
	    // model -> view
	    RatingComponent.prototype.writeValue = function (value) {
	        if (value % 1 !== value) {
	            this.value = Math.round(value);
	            this.preValue = value;
	            return;
	        }
	        this.preValue = value;
	        this.value = value;
	    };
	    RatingComponent.prototype.enter = function (value) {
	        if (!this.readonly) {
	            this.value = value;
	            this.onHover.emit(value);
	        }
	    };
	    RatingComponent.prototype.reset = function () {
	        this.value = this.preValue;
	        this.onLeave.emit(this.value);
	    };
	    RatingComponent.prototype.registerOnChange = function (fn) {
	        this.onChange = fn;
	    };
	    RatingComponent.prototype.registerOnTouched = function (fn) {
	        this.onTouched = fn;
	    };
	    RatingComponent.prototype.buildTemplateObjects = function (ratingStates, max) {
	        ratingStates = ratingStates || [];
	        var count = ratingStates.length || max;
	        var result = [];
	        for (var i = 0; i < count; i++) {
	            result.push(Object.assign({
	                index: i,
	                stateOn: this.stateOn,
	                stateOff: this.stateOff,
	                title: this.titles[i] || i + 1
	            }, ratingStates[i] || {}));
	        }
	        return result;
	    };
	    RatingComponent.prototype.rate = function (value) {
	        if (!this.readonly && value >= 0 && value <= this.range.length) {
	            this.writeValue(value);
	            this.cd.viewToModelUpdate(value);
	        }
	    };
	    RatingComponent.decorators = [
	        { type: core_1.Component, args: [{
	                    /* tslint:disable */
	                    selector: 'rating[ngModel]',
	                    /* tslint:enable */
	                    template: "\n    <span (mouseleave)=\"reset()\" (keydown)=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" [attr.aria-valuemax]=\"range.length\" [attr.aria-valuenow]=\"value\">\n      <template ngFor let-r [ngForOf]=\"range\" let-index=\"index\">\n        <span class=\"sr-only\">({{ index < value ? '*' : ' ' }})</span>\n        <i (mouseenter)=\"enter(index + 1)\" (click)=\"rate(index + 1)\" class=\"glyphicon\" [ngClass]=\"index < value ? r.stateOn : r.stateOff\" [title]=\"r.title\" ></i>\n      </template>\n    </span>\n  ",
	                    providers: [forms_1.NgModel]
	                },] },
	    ];
	    /** @nocollapse */
	    RatingComponent.ctorParameters = [
	        { type: forms_1.NgModel, decorators: [{ type: core_1.Self },] },
	    ];
	    RatingComponent.propDecorators = {
	        'max': [{ type: core_1.Input },],
	        'stateOn': [{ type: core_1.Input },],
	        'stateOff': [{ type: core_1.Input },],
	        'readonly': [{ type: core_1.Input },],
	        'titles': [{ type: core_1.Input },],
	        'ratingStates': [{ type: core_1.Input },],
	        'onHover': [{ type: core_1.Output },],
	        'onLeave': [{ type: core_1.Output },],
	        'onKeydown': [{ type: core_1.HostListener, args: ['keydown', ['$event'],] },],
	    };
	    return RatingComponent;
	}());
	exports.RatingComponent = RatingComponent;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1204 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var common_1 = __webpack_require__(22);
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(826);
	var rating_component_1 = __webpack_require__(1203);
	var RatingModule = (function () {
	    function RatingModule() {
	    }
	    RatingModule.decorators = [
	        { type: core_1.NgModule, args: [{
	                    imports: [common_1.CommonModule, forms_1.FormsModule],
	                    declarations: [rating_component_1.RatingComponent],
	                    exports: [forms_1.FormsModule, rating_component_1.RatingComponent]
	                },] },
	    ];
	    /** @nocollapse */
	    RatingModule.ctorParameters = [];
	    return RatingModule;
	}());
	exports.RatingModule = RatingModule;


/***/ },
/* 1205 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var tab_heading_directive_1 = __webpack_require__(1206);
	exports.TabHeadingDirective = tab_heading_directive_1.TabHeadingDirective;
	var tabset_component_1 = __webpack_require__(1208);
	exports.TabsetComponent = tabset_component_1.TabsetComponent;
	var tab_directive_1 = __webpack_require__(1207);
	exports.TabDirective = tab_directive_1.TabDirective;
	var tabs_module_1 = __webpack_require__(1209);
	exports.TabsModule = tabs_module_1.TabsModule;


/***/ },
/* 1206 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var tab_directive_1 = __webpack_require__(1207);
	var TabHeadingDirective = (function () {
	    function TabHeadingDirective(templateRef, tab) {
	        tab.headingRef = templateRef;
	    }
	    TabHeadingDirective.decorators = [
	        { type: core_1.Directive, args: [{ selector: '[tabHeading]' },] },
	    ];
	    /** @nocollapse */
	    TabHeadingDirective.ctorParameters = [
	        { type: core_1.TemplateRef, },
	        { type: tab_directive_1.TabDirective, },
	    ];
	    return TabHeadingDirective;
	}());
	exports.TabHeadingDirective = TabHeadingDirective;


/***/ },
/* 1207 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var tabset_component_1 = __webpack_require__(1208);
	/* tslint:disable */
	/* tslint:enable */
	var TabDirective = (function () {
	    function TabDirective(tabset) {
	        this.select = new core_1.EventEmitter(false);
	        this.deselect = new core_1.EventEmitter(false);
	        this.removed = new core_1.EventEmitter(false);
	        this.addClass = true;
	        this.tabset = tabset;
	        this.tabset.addTab(this);
	    }
	    Object.defineProperty(TabDirective.prototype, "active", {
	        /** tab active state toggle */
	        get: function () {
	            return this._active;
	        },
	        set: function (active) {
	            var _this = this;
	            if (this.disabled && active || !active) {
	                if (!active) {
	                    this._active = active;
	                }
	                this.deselect.emit(this);
	                return;
	            }
	            this._active = active;
	            this.select.emit(this);
	            this.tabset.tabs.forEach(function (tab) {
	                if (tab !== _this) {
	                    tab.active = false;
	                }
	            });
	        },
	        enumerable: true,
	        configurable: true
	    });
	    TabDirective.prototype.ngOnInit = function () {
	        this.removable = !!this.removable;
	    };
	    TabDirective.prototype.ngOnDestroy = function () {
	        this.tabset.removeTab(this);
	    };
	    TabDirective.decorators = [
	        { type: core_1.Directive, args: [{ selector: 'tab, [tab]' },] },
	    ];
	    /** @nocollapse */
	    TabDirective.ctorParameters = [
	        { type: tabset_component_1.TabsetComponent, },
	    ];
	    TabDirective.propDecorators = {
	        'heading': [{ type: core_1.Input },],
	        'disabled': [{ type: core_1.Input },],
	        'removable': [{ type: core_1.Input },],
	        'customClass': [{ type: core_1.Input },],
	        'active': [{ type: core_1.HostBinding, args: ['class.active',] }, { type: core_1.Input },],
	        'select': [{ type: core_1.Output },],
	        'deselect': [{ type: core_1.Output },],
	        'removed': [{ type: core_1.Output },],
	        'addClass': [{ type: core_1.HostBinding, args: ['class.tab-pane',] },],
	    };
	    return TabDirective;
	}());
	exports.TabDirective = TabDirective;


/***/ },
/* 1208 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	// todo: add active event to tab
	// todo: fix? mixing static and dynamic tabs position tabs in order of creation
	var TabsetComponent = (function () {
	    function TabsetComponent() {
	        this.clazz = true;
	        this.tabs = [];
	        this.classMap = {};
	    }
	    Object.defineProperty(TabsetComponent.prototype, "vertical", {
	        get: function () {
	            return this._vertical;
	        },
	        set: function (value) {
	            this._vertical = value;
	            this.setClassMap();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ;
	    Object.defineProperty(TabsetComponent.prototype, "justified", {
	        get: function () {
	            return this._justified;
	        },
	        set: function (value) {
	            this._justified = value;
	            this.setClassMap();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ;
	    Object.defineProperty(TabsetComponent.prototype, "type", {
	        get: function () {
	            return this._type;
	        },
	        set: function (value) {
	            this._type = value;
	            this.setClassMap();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ;
	    TabsetComponent.prototype.ngOnInit = function () {
	        this.type = this.type !== 'undefined' ? this.type : 'tabs';
	    };
	    TabsetComponent.prototype.ngOnDestroy = function () {
	        this.isDestroyed = true;
	    };
	    TabsetComponent.prototype.addTab = function (tab) {
	        this.tabs.push(tab);
	        tab.active = this.tabs.length === 1 && tab.active !== false;
	    };
	    TabsetComponent.prototype.removeTab = function (tab) {
	        var index = this.tabs.indexOf(tab);
	        if (index === -1 || this.isDestroyed) {
	            return;
	        }
	        // Select a new tab if the tab to be removed is selected and not destroyed
	        if (tab.active && this.hasAvailableTabs(index)) {
	            var newActiveIndex = this.getClosestTabIndex(index);
	            this.tabs[newActiveIndex].active = true;
	        }
	        tab.removed.emit(tab);
	        this.tabs.splice(index, 1);
	    };
	    TabsetComponent.prototype.getClosestTabIndex = function (index) {
	        var tabsLength = this.tabs.length;
	        if (!tabsLength) {
	            return -1;
	        }
	        for (var step = 1; step <= tabsLength; step += 1) {
	            var prevIndex = index - step;
	            var nextIndex = index + step;
	            if (this.tabs[prevIndex] && !this.tabs[prevIndex].disabled) {
	                return prevIndex;
	            }
	            if (this.tabs[nextIndex] && !this.tabs[nextIndex].disabled) {
	                return nextIndex;
	            }
	        }
	        return -1;
	    };
	    TabsetComponent.prototype.hasAvailableTabs = function (index) {
	        var tabsLength = this.tabs.length;
	        if (!tabsLength) {
	            return false;
	        }
	        for (var i = 0; i < tabsLength; i += 1) {
	            if (!this.tabs[i].disabled && i !== index) {
	                return true;
	            }
	        }
	        return false;
	    };
	    TabsetComponent.prototype.setClassMap = function () {
	        this.classMap = (_a = {
	                'nav-stacked': this.vertical,
	                'nav-justified': this.justified
	            },
	            _a['nav-' + (this.type || 'tabs')] = true,
	            _a
	        );
	        var _a;
	    };
	    TabsetComponent.decorators = [
	        { type: core_1.Component, args: [{
	                    selector: 'tabset',
	                    template: "\n    <ul class=\"nav\" [ngClass]=\"classMap\" (click)=\"$event.preventDefault()\">\n        <li *ngFor=\"let tabz of tabs\" class=\"nav-item {{tabz.customClass}}\"\n          [class.active]=\"tabz.active\" [class.disabled]=\"tabz.disabled\">\n          <a href=\"javascript:void(0);\" class=\"nav-link\"\n            [class.active]=\"tabz.active\" [class.disabled]=\"tabz.disabled\"\n            (click)=\"tabz.active = true\">\n            <span [ngTransclude]=\"tabz.headingRef\">{{tabz.heading}}</span>\n            <span *ngIf=\"tabz.removable\">\n              <span (click)=\"$event.preventDefault(); removeTab(tabz);\" class=\"glyphicon glyphicon-remove-circle\"></span>\n            </span>\n          </a>\n        </li>\n    </ul>\n    <div class=\"tab-content\">\n      <ng-content></ng-content>\n    </div>\n  "
	                },] },
	    ];
	    /** @nocollapse */
	    TabsetComponent.ctorParameters = [];
	    TabsetComponent.propDecorators = {
	        'vertical': [{ type: core_1.Input },],
	        'justified': [{ type: core_1.Input },],
	        'type': [{ type: core_1.Input },],
	        'clazz': [{ type: core_1.HostBinding, args: ['class.tab-container',] },],
	    };
	    return TabsetComponent;
	}());
	exports.TabsetComponent = TabsetComponent;


/***/ },
/* 1209 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var common_1 = __webpack_require__(22);
	var core_1 = __webpack_require__(3);
	var common_2 = __webpack_require__(1210);
	var tab_heading_directive_1 = __webpack_require__(1206);
	var tab_directive_1 = __webpack_require__(1207);
	var tabset_component_1 = __webpack_require__(1208);
	var TabsModule = (function () {
	    function TabsModule() {
	    }
	    TabsModule.decorators = [
	        { type: core_1.NgModule, args: [{
	                    imports: [common_1.CommonModule],
	                    declarations: [common_2.NgTranscludeDirective, tab_directive_1.TabDirective, tabset_component_1.TabsetComponent, tab_heading_directive_1.TabHeadingDirective],
	                    exports: [tab_directive_1.TabDirective, tabset_component_1.TabsetComponent, tab_heading_directive_1.TabHeadingDirective]
	                },] },
	    ];
	    /** @nocollapse */
	    TabsModule.ctorParameters = [];
	    return TabsModule;
	}());
	exports.TabsModule = TabsModule;


/***/ },
/* 1210 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var NgTranscludeDirective = (function () {
	    function NgTranscludeDirective(_viewRef) {
	        this._viewRef = _viewRef;
	        this.viewRef = _viewRef;
	    }
	    Object.defineProperty(NgTranscludeDirective.prototype, "ngTransclude", {
	        get: function () {
	            return this._ngTransclude;
	        },
	        set: function (templateRef) {
	            this._ngTransclude = templateRef;
	            if (templateRef) {
	                this.viewRef.createEmbeddedView(templateRef);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    NgTranscludeDirective.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: '[ngTransclude]'
	                },] },
	    ];
	    /** @nocollapse */
	    NgTranscludeDirective.ctorParameters = [
	        { type: core_1.ViewContainerRef, },
	    ];
	    NgTranscludeDirective.propDecorators = {
	        'ngTransclude': [{ type: core_1.Input },],
	    };
	    return NgTranscludeDirective;
	}());
	exports.NgTranscludeDirective = NgTranscludeDirective;


/***/ },
/* 1211 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var timepicker_component_1 = __webpack_require__(1212);
	exports.TimepickerComponent = timepicker_component_1.TimepickerComponent;
	var timepicker_module_1 = __webpack_require__(1213);
	exports.TimepickerModule = timepicker_module_1.TimepickerModule;


/***/ },
/* 1212 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(826);
	// todo: implement global configuration via DI
	// todo: refactor directive has to many functions! (extract to stateless helper)
	// todo: use moment js?
	// todo: implement `time` validator
	// todo: replace increment/decrement blockers with getters, or extract
	// todo: unify work with selected
	exports.timepickerConfig = {
	    hourStep: 1,
	    minuteStep: 1,
	    showMeridian: true,
	    meridians: void 0,
	    readonlyInput: false,
	    mousewheel: true,
	    arrowkeys: true,
	    showSpinners: true,
	    min: void 0,
	    max: void 0
	};
	function isDefined(value) {
	    return typeof value !== 'undefined';
	}
	function def(value, fn, defaultValue) {
	    return fn(value) ? value : defaultValue;
	}
	function addMinutes(date, minutes) {
	    var dt = new Date(date.getTime() + minutes * 60000);
	    var newDate = new Date(date);
	    newDate.setHours(dt.getHours(), dt.getMinutes());
	    return newDate;
	}
	var TimepickerComponent = (function () {
	    function TimepickerComponent(cd) {
	        this.meridians = ['AM', 'PM']; // ??
	        this.onChange = Function.prototype;
	        this.onTouched = Function.prototype;
	        // result value
	        this._selected = new Date();
	        this.cd = cd;
	        cd.valueAccessor = this;
	    }
	    Object.defineProperty(TimepickerComponent.prototype, "showMeridian", {
	        get: function () {
	            return this._showMeridian;
	        },
	        set: function (value) {
	            this._showMeridian = value;
	            // || !this.$error.time
	            // if (true) {
	            this.updateTemplate();
	            return;
	            // }
	            // Evaluate from template
	            /*let hours = this.getHoursFromTemplate();
	             let minutes = this.getMinutesFromTemplate();
	             if (isDefined(hours) && isDefined(minutes)) {
	             this.selected.setHours(hours);
	             this.refresh();
	             }*/
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TimepickerComponent.prototype, "selected", {
	        get: function () {
	            return this._selected;
	        },
	        set: function (v) {
	            if (v) {
	                this._selected = v;
	                this.updateTemplate();
	                this.cd.viewToModelUpdate(this.selected);
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    // todo: add formatter value to Date object
	    TimepickerComponent.prototype.ngOnInit = function () {
	        // todo: take in account $locale.DATETIME_FORMATS.AMPMS;
	        this.meridians = def(this.meridians, isDefined, exports.timepickerConfig.meridians) || ['AM',
	            'PM'];
	        this.mousewheel = def(this.mousewheel, isDefined, exports.timepickerConfig.mousewheel);
	        if (this.mousewheel) {
	        }
	        this.arrowkeys = def(this.arrowkeys, isDefined, exports.timepickerConfig.arrowkeys);
	        if (this.arrowkeys) {
	        }
	        this.readonlyInput = def(this.readonlyInput, isDefined, exports.timepickerConfig.readonlyInput);
	        // this.setupInputEvents();
	        this.hourStep = def(this.hourStep, isDefined, exports.timepickerConfig.hourStep);
	        this.minuteStep = def(this.minuteStep, isDefined, exports.timepickerConfig.minuteStep);
	        this.min = def(this.min, isDefined, exports.timepickerConfig.min);
	        this.max = def(this.max, isDefined, exports.timepickerConfig.max);
	        // 12H / 24H mode
	        this.showMeridian = def(this.showMeridian, isDefined, exports.timepickerConfig.showMeridian);
	        this.showSpinners = def(this.showSpinners, isDefined, exports.timepickerConfig.showSpinners);
	    };
	    TimepickerComponent.prototype.writeValue = function (v) {
	        if (v === this.selected) {
	            return;
	        }
	        if (v && v instanceof Date) {
	            this.selected = v;
	            return;
	        }
	        this.selected = v ? new Date(v) : void 0;
	    };
	    TimepickerComponent.prototype.registerOnChange = function (fn) {
	        this.onChange = fn;
	    };
	    TimepickerComponent.prototype.registerOnTouched = function (fn) {
	        this.onTouched = fn;
	    };
	    TimepickerComponent.prototype.setDisabledState = function (isDisabled) {
	        this.readonlyInput = isDisabled;
	    };
	    TimepickerComponent.prototype.updateHours = function () {
	        if (this.readonlyInput) {
	            return;
	        }
	        var hours = this.getHoursFromTemplate();
	        var minutes = this.getMinutesFromTemplate();
	        this.invalidHours = !isDefined(hours);
	        this.invalidMinutes = !isDefined(minutes);
	        if (this.invalidHours || this.invalidMinutes) {
	            // TODO: needed a validation functionality.
	            return;
	        }
	        this.selected.setHours(hours);
	        this.invalidHours = (this.selected < this.min || this.selected > this.max);
	        if (this.invalidHours) {
	            // todo: validation?
	            // invalidate(true);
	            return;
	        }
	        else {
	            this.refresh();
	        }
	    };
	    // tslint:disable-next-line:no-unused-variable
	    TimepickerComponent.prototype.hoursOnBlur = function (event) {
	        if (this.readonlyInput) {
	            return;
	        }
	        // todo: binded with validation
	        if (!this.invalidHours && parseInt(this.hours, 10) < 10) {
	            this.hours = this.pad(this.hours);
	        }
	    };
	    TimepickerComponent.prototype.updateMinutes = function () {
	        if (this.readonlyInput) {
	            return;
	        }
	        var minutes = this.getMinutesFromTemplate();
	        var hours = this.getHoursFromTemplate();
	        this.invalidMinutes = !isDefined(minutes);
	        this.invalidHours = !isDefined(hours);
	        if (this.invalidMinutes || this.invalidHours) {
	            // TODO: needed a validation functionality.
	            return;
	        }
	        this.selected.setMinutes(minutes);
	        this.invalidMinutes = (this.selected < this.min || this.selected > this.max);
	        if (this.invalidMinutes) {
	            // todo: validation
	            // invalidate(undefined, true);
	            return;
	        }
	        else {
	            this.refresh();
	        }
	    };
	    // tslint:disable-next-line:no-unused-variable
	    TimepickerComponent.prototype.minutesOnBlur = function (event) {
	        if (this.readonlyInput) {
	            return;
	        }
	        if (!this.invalidMinutes && parseInt(this.minutes, 10) < 10) {
	            this.minutes = this.pad(this.minutes);
	        }
	    };
	    TimepickerComponent.prototype.incrementHours = function () {
	        if (!this.noIncrementHours()) {
	            this.addMinutesToSelected(this.hourStep * 60);
	        }
	    };
	    TimepickerComponent.prototype.decrementHours = function () {
	        if (!this.noDecrementHours()) {
	            this.addMinutesToSelected(-this.hourStep * 60);
	        }
	    };
	    TimepickerComponent.prototype.incrementMinutes = function () {
	        if (!this.noIncrementMinutes()) {
	            this.addMinutesToSelected(this.minuteStep);
	        }
	    };
	    TimepickerComponent.prototype.decrementMinutes = function () {
	        if (!this.noDecrementMinutes()) {
	            this.addMinutesToSelected(-this.minuteStep);
	        }
	    };
	    TimepickerComponent.prototype.noIncrementHours = function () {
	        var incrementedSelected = addMinutes(this.selected, this.hourStep * 60);
	        return incrementedSelected > this.max ||
	            (incrementedSelected < this.selected && incrementedSelected < this.min);
	    };
	    TimepickerComponent.prototype.noDecrementHours = function () {
	        var decrementedSelected = addMinutes(this.selected, -this.hourStep * 60);
	        return decrementedSelected < this.min ||
	            (decrementedSelected > this.selected && decrementedSelected > this.max);
	    };
	    TimepickerComponent.prototype.noIncrementMinutes = function () {
	        var incrementedSelected = addMinutes(this.selected, this.minuteStep);
	        return incrementedSelected > this.max ||
	            (incrementedSelected < this.selected && incrementedSelected < this.min);
	    };
	    TimepickerComponent.prototype.noDecrementMinutes = function () {
	        var decrementedSelected = addMinutes(this.selected, -this.minuteStep);
	        return decrementedSelected < this.min ||
	            (decrementedSelected > this.selected && decrementedSelected > this.max);
	    };
	    TimepickerComponent.prototype.toggleMeridian = function () {
	        if (!this.noToggleMeridian()) {
	            var sign = this.selected.getHours() < 12 ? 1 : -1;
	            this.addMinutesToSelected(12 * 60 * sign);
	        }
	    };
	    TimepickerComponent.prototype.refresh = function () {
	        // this.makeValid();
	        this.updateTemplate();
	        this.cd.viewToModelUpdate(this.selected);
	    };
	    TimepickerComponent.prototype.updateTemplate = function () {
	        var hours = this.selected.getHours();
	        var minutes = this.selected.getMinutes();
	        if (this.showMeridian) {
	            // Convert 24 to 12 hour system
	            hours = (hours === 0 || hours === 12) ? 12 : hours % 12;
	        }
	        // this.hours = keyboardChange === 'h' ? hours : this.pad(hours);
	        // if (keyboardChange !== 'm') {
	        //  this.minutes = this.pad(minutes);
	        // }
	        this.hours = this.pad(hours);
	        this.minutes = this.pad(minutes);
	        this.meridian = this.selected.getHours() < 12
	            ? this.meridians[0]
	            : this.meridians[1];
	    };
	    TimepickerComponent.prototype.getHoursFromTemplate = function () {
	        var hours = parseInt(this.hours, 10);
	        var valid = this.showMeridian
	            ? (hours > 0 && hours < 13)
	            : (hours >= 0 && hours < 24);
	        if (!valid) {
	            return void 0;
	        }
	        if (this.showMeridian) {
	            if (hours === 12) {
	                hours = 0;
	            }
	            if (this.meridian === this.meridians[1]) {
	                hours = hours + 12;
	            }
	        }
	        return hours;
	    };
	    TimepickerComponent.prototype.getMinutesFromTemplate = function () {
	        var minutes = parseInt(this.minutes, 10);
	        return (minutes >= 0 && minutes < 60) ? minutes : undefined;
	    };
	    TimepickerComponent.prototype.pad = function (value) {
	        return (isDefined(value) && value.toString().length < 2)
	            ? '0' + value
	            : value.toString();
	    };
	    TimepickerComponent.prototype.addMinutesToSelected = function (minutes) {
	        this.selected = addMinutes(this.selected, minutes);
	        this.refresh();
	    };
	    TimepickerComponent.prototype.noToggleMeridian = function () {
	        if (this.readonlyInput) {
	            return true;
	        }
	        if (this.selected.getHours() < 13) {
	            return addMinutes(this.selected, 12 * 60) > this.max;
	        }
	        else {
	            return addMinutes(this.selected, -12 * 60) < this.min;
	        }
	    };
	    TimepickerComponent.decorators = [
	        { type: core_1.Component, args: [{
	                    /* tslint:disable */
	                    selector: 'timepicker[ngModel]',
	                    /* tslint:enable */
	                    template: "\n    <table>\n      <tbody>\n        <tr class=\"text-center\" [ngClass]=\"{hidden: !showSpinners || readonlyInput}\">\n          <td><a (click)=\"incrementHours()\" [ngClass]=\"{disabled: noIncrementHours()}\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n          <td>&nbsp;</td>\n          <td><a (click)=\"incrementMinutes()\" [ngClass]=\"{disabled: noIncrementMinutes()}\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n          <td [ngClass]=\"{hidden: !showMeridian}\" *ngIf=\"showMeridian\"></td>\n        </tr>\n        <tr>\n          <td class=\"form-group\" [ngClass]=\"{'has-error': invalidHours}\">\n            <input style=\"width:50px;\" type=\"text\" [(ngModel)]=\"hours\" (change)=\"updateHours()\" class=\"form-control text-center\" [readonly]=\"readonlyInput\" (blur)=\"hoursOnBlur($event)\" maxlength=\"2\">\n          </td>\n          <td>:</td>\n          <td class=\"form-group\" [ngClass]=\"{'has-error': invalidMinutes}\">\n            <input style=\"width:50px;\" type=\"text\" [(ngModel)]=\"minutes\" (change)=\"updateMinutes()\" class=\"form-control text-center\" [readonly]=\"readonlyInput\" (blur)=\"minutesOnBlur($event)\" maxlength=\"2\">\n          </td>\n          <td [ngClass]=\"{hidden: !showMeridian}\" *ngIf=\"showMeridian\"><button type=\"button\" [ngClass]=\"{disabled: noToggleMeridian() || readonlyInput}\" class=\"btn btn-default text-center\" (click)=\"toggleMeridian()\">{{meridian}}</button></td>\n        </tr>\n        <tr class=\"text-center\" [ngClass]=\"{hidden: !showSpinners || readonlyInput}\">\n          <td><a (click)=\"decrementHours()\" [ngClass]=\"{disabled: noDecrementHours()}\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n          <td>&nbsp;</td>\n          <td><a (click)=\"decrementMinutes()\" [ngClass]=\"{disabled: noDecrementMinutes()}\" class=\"btn btn-link\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n          <td [ngClass]=\"{hidden: !showMeridian}\" *ngIf=\"showMeridian\"></td>\n        </tr>\n      </tbody>\n    </table>\n  ",
	                    providers: [forms_1.NgModel]
	                },] },
	    ];
	    /** @nocollapse */
	    TimepickerComponent.ctorParameters = [
	        { type: forms_1.NgModel, decorators: [{ type: core_1.Self },] },
	    ];
	    TimepickerComponent.propDecorators = {
	        'hourStep': [{ type: core_1.Input },],
	        'minuteStep': [{ type: core_1.Input },],
	        'readonlyInput': [{ type: core_1.Input },],
	        'mousewheel': [{ type: core_1.Input },],
	        'arrowkeys': [{ type: core_1.Input },],
	        'showSpinners': [{ type: core_1.Input },],
	        'min': [{ type: core_1.Input },],
	        'max': [{ type: core_1.Input },],
	        'meridians': [{ type: core_1.Input },],
	        'showMeridian': [{ type: core_1.Input },],
	    };
	    return TimepickerComponent;
	}());
	exports.TimepickerComponent = TimepickerComponent;


/***/ },
/* 1213 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var common_1 = __webpack_require__(22);
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(826);
	var timepicker_component_1 = __webpack_require__(1212);
	var TimepickerModule = (function () {
	    function TimepickerModule() {
	    }
	    TimepickerModule.decorators = [
	        { type: core_1.NgModule, args: [{
	                    imports: [common_1.CommonModule, forms_1.FormsModule],
	                    declarations: [timepicker_component_1.TimepickerComponent],
	                    exports: [forms_1.FormsModule, timepicker_component_1.TimepickerComponent]
	                },] },
	    ];
	    /** @nocollapse */
	    TimepickerModule.ctorParameters = [];
	    return TimepickerModule;
	}());
	exports.TimepickerModule = TimepickerModule;


/***/ },
/* 1214 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var tooltip_container_component_1 = __webpack_require__(1215);
	exports.TooltipContainerComponent = tooltip_container_component_1.TooltipContainerComponent;
	var tooltip_directive_1 = __webpack_require__(1218);
	exports.TooltipDirective = tooltip_directive_1.TooltipDirective;
	var tooltip_module_1 = __webpack_require__(1219);
	exports.TooltipModule = tooltip_module_1.TooltipModule;


/***/ },
/* 1215 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var position_1 = __webpack_require__(1216);
	var tooltip_options_class_1 = __webpack_require__(1217);
	var TooltipContainerComponent = (function () {
	    function TooltipContainerComponent(element, cdr, options) {
	        this.top = '-1000px';
	        this.left = '-1000px';
	        this.display = 'block';
	        this.element = element;
	        this.cdr = cdr;
	        Object.assign(this, options);
	        this.classMap = { 'in': false, 'fade': false };
	        this.classMap[options.placement] = true;
	        this.classMap['tooltip-' + options.placement] = true;
	    }
	    TooltipContainerComponent.prototype.ngAfterViewInit = function () {
	        var p = position_1.positionService
	            .positionElements(this.hostEl.nativeElement, this.element.nativeElement.children[0], this.placement, this.appendToBody);
	        this.top = p.top + 'px';
	        this.left = p.left + 'px';
	        this.classMap.in = true;
	        if (this.animation) {
	            this.classMap.fade = true;
	        }
	        if (this.popupClass) {
	            this.classMap[this.popupClass] = true;
	        }
	        this.cdr.detectChanges();
	    };
	    Object.defineProperty(TooltipContainerComponent.prototype, "isTemplate", {
	        get: function () {
	            return this.htmlContent instanceof core_1.TemplateRef;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    TooltipContainerComponent.decorators = [
	        { type: core_1.Component, args: [{
	                    selector: 'tooltip-container',
	                    // changeDetection: ChangeDetectionStrategy.OnPush,
	                    template: "<div class=\"tooltip\" role=\"tooltip\"\n     [ngStyle]=\"{top: top, left: left, display: display}\"\n     [ngClass]=\"classMap\">\n      <div class=\"tooltip-arrow\"></div>\n      <div class=\"tooltip-inner\"\n           *ngIf=\"htmlContent && !isTemplate\" \n           innerHtml=\"{{htmlContent}}\">\n      </div>\n      <div class=\"tooltip-inner\"\n           *ngIf=\"htmlContent && isTemplate\">\n        <template [ngTemplateOutlet]=\"htmlContent\"\n                  [ngOutletContext]=\"{model: context}\">\n        </template>\n      </div>\n      <div class=\"tooltip-inner\"\n           *ngIf=\"content\">\n        {{content}}\n      </div>\n    </div>"
	                },] },
	    ];
	    /** @nocollapse */
	    TooltipContainerComponent.ctorParameters = [
	        { type: core_1.ElementRef, },
	        { type: core_1.ChangeDetectorRef, },
	        { type: tooltip_options_class_1.TooltipOptions, decorators: [{ type: core_1.Inject, args: [tooltip_options_class_1.TooltipOptions,] },] },
	    ];
	    return TooltipContainerComponent;
	}());
	exports.TooltipContainerComponent = TooltipContainerComponent;


/***/ },
/* 1216 */
/***/ function(module, exports) {

	"use strict";
	var PositionService = (function () {
	    function PositionService() {
	    }
	    /**
	     * Provides read-only equivalent of jQuery's position function:
	     * http://api.jquery.com/position/
	     */
	    PositionService.prototype.position = function (nativeEl) {
	        var elBCR = this.offset(nativeEl);
	        var offsetParentBCR = { top: 0, left: 0 };
	        var offsetParentEl = this.parentOffsetEl(nativeEl);
	        if (offsetParentEl !== this.document) {
	            offsetParentBCR = this.offset(offsetParentEl);
	            offsetParentBCR.top += offsetParentEl.clientTop - offsetParentEl.scrollTop;
	            offsetParentBCR.left += offsetParentEl.clientLeft - offsetParentEl.scrollLeft;
	        }
	        var boundingClientRect = nativeEl.getBoundingClientRect();
	        return {
	            width: boundingClientRect.width || nativeEl.offsetWidth,
	            height: boundingClientRect.height || nativeEl.offsetHeight,
	            top: elBCR.top - offsetParentBCR.top,
	            left: elBCR.left - offsetParentBCR.left
	        };
	    };
	    /**
	     * Provides read-only equivalent of jQuery's offset function:
	     * http://api.jquery.com/offset/
	     */
	    PositionService.prototype.offset = function (nativeEl) {
	        var boundingClientRect = nativeEl.getBoundingClientRect();
	        return {
	            width: boundingClientRect.width || nativeEl.offsetWidth,
	            height: boundingClientRect.height || nativeEl.offsetHeight,
	            top: boundingClientRect.top + (this.window.pageYOffset || this.document.documentElement.scrollTop),
	            left: boundingClientRect.left + (this.window.pageXOffset || this.document.documentElement.scrollLeft)
	        };
	    };
	    /**
	     * Provides coordinates for the targetEl in relation to hostEl
	     */
	    PositionService.prototype.positionElements = function (hostEl, targetEl, positionStr, appendToBody) {
	        var positionStrParts = positionStr.split('-');
	        var pos0 = positionStrParts[0];
	        var pos1 = positionStrParts[1] || 'center';
	        var hostElPos = appendToBody ?
	            this.offset(hostEl) :
	            this.position(hostEl);
	        var targetElWidth = targetEl.offsetWidth;
	        var targetElHeight = targetEl.offsetHeight;
	        var shiftWidth = {
	            center: function () {
	                return hostElPos.left + hostElPos.width / 2 - targetElWidth / 2;
	            },
	            left: function () {
	                return hostElPos.left;
	            },
	            right: function () {
	                return hostElPos.left + hostElPos.width;
	            }
	        };
	        var shiftHeight = {
	            center: function () {
	                return hostElPos.top + hostElPos.height / 2 - targetElHeight / 2;
	            },
	            top: function () {
	                return hostElPos.top;
	            },
	            bottom: function () {
	                return hostElPos.top + hostElPos.height;
	            }
	        };
	        var targetElPos;
	        switch (pos0) {
	            case 'right':
	                targetElPos = {
	                    top: shiftHeight[pos1](),
	                    left: shiftWidth[pos0]()
	                };
	                break;
	            case 'left':
	                targetElPos = {
	                    top: shiftHeight[pos1](),
	                    left: hostElPos.left - targetElWidth
	                };
	                break;
	            case 'bottom':
	                targetElPos = {
	                    top: shiftHeight[pos0](),
	                    left: shiftWidth[pos1]()
	                };
	                break;
	            default:
	                targetElPos = {
	                    top: hostElPos.top - targetElHeight,
	                    left: shiftWidth[pos1]()
	                };
	                break;
	        }
	        return targetElPos;
	    };
	    Object.defineProperty(PositionService.prototype, "window", {
	        get: function () {
	            return window;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(PositionService.prototype, "document", {
	        get: function () {
	            return window.document;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    PositionService.prototype.getStyle = function (nativeEl, cssProp) {
	        // IE
	        if (nativeEl.currentStyle) {
	            return nativeEl.currentStyle[cssProp];
	        }
	        if (this.window.getComputedStyle) {
	            return this.window.getComputedStyle(nativeEl)[cssProp];
	        }
	        // finally try and get inline style
	        return nativeEl.style[cssProp];
	    };
	    /**
	     * Checks if a given element is statically positioned
	     * @param nativeEl - raw DOM element
	     */
	    PositionService.prototype.isStaticPositioned = function (nativeEl) {
	        return (this.getStyle(nativeEl, 'position') || 'static') === 'static';
	    };
	    /**
	     * returns the closest, non-statically positioned parentOffset of a given
	     * element
	     * @param nativeEl
	     */
	    PositionService.prototype.parentOffsetEl = function (nativeEl) {
	        var offsetParent = nativeEl.offsetParent || this.document;
	        while (offsetParent && offsetParent !== this.document &&
	            this.isStaticPositioned(offsetParent)) {
	            offsetParent = offsetParent.offsetParent;
	        }
	        return offsetParent || this.document;
	    };
	    ;
	    return PositionService;
	}());
	exports.PositionService = PositionService;
	exports.positionService = new PositionService();


/***/ },
/* 1217 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var TooltipOptions = (function () {
	    function TooltipOptions(options) {
	        Object.assign(this, options);
	    }
	    TooltipOptions.decorators = [
	        { type: core_1.Injectable },
	    ];
	    /** @nocollapse */
	    TooltipOptions.ctorParameters = [
	        { type: Object, },
	    ];
	    return TooltipOptions;
	}());
	exports.TooltipOptions = TooltipOptions;


/***/ },
/* 1218 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var tooltip_container_component_1 = __webpack_require__(1215);
	var tooltip_options_class_1 = __webpack_require__(1217);
	var components_helper_service_1 = __webpack_require__(541);
	/* tslint:disable */
	/* tslint:enable */
	var TooltipDirective = (function () {
	    function TooltipDirective(viewContainerRef, componentsHelper, changeDetectorRef) {
	        this.placement = 'top';
	        this.enable = true;
	        this.animation = true;
	        this.appendToBody = false;
	        this.delay = 0;
	        /* tslint:enable */
	        this.tooltipStateChanged = new core_1.EventEmitter();
	        this.visible = false;
	        this.viewContainerRef = viewContainerRef;
	        this.componentsHelper = componentsHelper;
	        this.changeDetectorRef = changeDetectorRef;
	    }
	    // todo: filter triggers
	    // params: event, target
	    TooltipDirective.prototype.show = function () {
	        var _this = this;
	        if (this.visible || !this.enable || this.delayTimeoutId) {
	            return;
	        }
	        var showTooltip = function () {
	            _this.visible = true;
	            var options = new tooltip_options_class_1.TooltipOptions({
	                content: _this.content,
	                htmlContent: _this.htmlContent,
	                placement: _this.placement,
	                animation: _this.animation,
	                appendToBody: _this.appendToBody,
	                hostEl: _this.viewContainerRef.element,
	                popupClass: _this.popupClass,
	                context: _this.tooltipContext
	            });
	            if (_this.appendToBody) {
	                _this.tooltip = _this.componentsHelper
	                    .appendNextToRoot(tooltip_container_component_1.TooltipContainerComponent, tooltip_options_class_1.TooltipOptions, options);
	            }
	            else {
	                var binding = core_1.ReflectiveInjector.resolve([
	                    { provide: tooltip_options_class_1.TooltipOptions, useValue: options }
	                ]);
	                _this.tooltip = _this.componentsHelper
	                    .appendNextToLocation(tooltip_container_component_1.TooltipContainerComponent, _this.viewContainerRef, binding);
	            }
	            _this.changeDetectorRef.markForCheck();
	            _this.triggerStateChanged();
	        };
	        if (this.delay) {
	            this.delayTimeoutId = setTimeout(function () { showTooltip(); }, this.delay);
	        }
	        else {
	            showTooltip();
	        }
	    };
	    // params event, target
	    TooltipDirective.prototype.hide = function () {
	        if (this.delayTimeoutId) {
	            clearTimeout(this.delayTimeoutId);
	            this.delayTimeoutId = undefined;
	        }
	        if (!this.visible) {
	            return;
	        }
	        this.visible = false;
	        this.tooltip.destroy();
	        this.triggerStateChanged();
	    };
	    TooltipDirective.prototype.triggerStateChanged = function () {
	        this.tooltipStateChanged.emit(this.visible);
	    };
	    TooltipDirective.decorators = [
	        { type: core_1.Directive, args: [{
	                    selector: '[tooltip], [tooltipHtml]',
	                    exportAs: 'bs-tooltip'
	                },] },
	    ];
	    /** @nocollapse */
	    TooltipDirective.ctorParameters = [
	        { type: core_1.ViewContainerRef, },
	        { type: components_helper_service_1.ComponentsHelper, },
	        { type: core_1.ChangeDetectorRef, },
	    ];
	    TooltipDirective.propDecorators = {
	        'content': [{ type: core_1.Input, args: ['tooltip',] },],
	        'htmlContent': [{ type: core_1.Input, args: ['tooltipHtml',] },],
	        'placement': [{ type: core_1.Input, args: ['tooltipPlacement',] },],
	        'isOpen': [{ type: core_1.Input, args: ['tooltipIsOpen',] },],
	        'enable': [{ type: core_1.Input, args: ['tooltipEnable',] },],
	        'animation': [{ type: core_1.Input, args: ['tooltipAnimation',] },],
	        'appendToBody': [{ type: core_1.Input, args: ['tooltipAppendToBody',] },],
	        'popupClass': [{ type: core_1.Input, args: ['tooltipClass',] },],
	        'tooltipContext': [{ type: core_1.Input, args: ['tooltipContext',] },],
	        'delay': [{ type: core_1.Input, args: ['tooltipPopupDelay',] },],
	        'tooltipStateChanged': [{ type: core_1.Output },],
	        'show': [{ type: core_1.HostListener, args: ['focusin',] }, { type: core_1.HostListener, args: ['mouseenter',] },],
	        'hide': [{ type: core_1.HostListener, args: ['focusout',] }, { type: core_1.HostListener, args: ['mouseleave',] },],
	    };
	    return TooltipDirective;
	}());
	exports.TooltipDirective = TooltipDirective;


/***/ },
/* 1219 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var common_1 = __webpack_require__(22);
	var core_1 = __webpack_require__(3);
	var tooltip_container_component_1 = __webpack_require__(1215);
	var tooltip_directive_1 = __webpack_require__(1218);
	var components_helper_service_1 = __webpack_require__(541);
	var TooltipModule = (function () {
	    function TooltipModule() {
	    }
	    TooltipModule.decorators = [
	        { type: core_1.NgModule, args: [{
	                    imports: [common_1.CommonModule],
	                    declarations: [tooltip_directive_1.TooltipDirective, tooltip_container_component_1.TooltipContainerComponent],
	                    exports: [tooltip_directive_1.TooltipDirective, tooltip_container_component_1.TooltipContainerComponent],
	                    providers: [components_helper_service_1.ComponentsHelper],
	                    entryComponents: [tooltip_container_component_1.TooltipContainerComponent]
	                },] },
	    ];
	    /** @nocollapse */
	    TooltipModule.ctorParameters = [];
	    return TooltipModule;
	}());
	exports.TooltipModule = TooltipModule;


/***/ },
/* 1220 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var typeahead_match_class_1 = __webpack_require__(1221);
	exports.TypeaheadMatch = typeahead_match_class_1.TypeaheadMatch;
	var typeahead_options_class_1 = __webpack_require__(1222);
	exports.TypeaheadOptions = typeahead_options_class_1.TypeaheadOptions;
	var typeahead_utils_1 = __webpack_require__(1223);
	exports.TypeaheadUtils = typeahead_utils_1.TypeaheadUtils;
	var typeahead_container_component_1 = __webpack_require__(1225);
	exports.TypeaheadContainerComponent = typeahead_container_component_1.TypeaheadContainerComponent;
	var typeahead_directive_1 = __webpack_require__(1226);
	exports.TypeaheadDirective = typeahead_directive_1.TypeaheadDirective;
	var typeahead_module_1 = __webpack_require__(1227);
	exports.TypeaheadModule = typeahead_module_1.TypeaheadModule;


/***/ },
/* 1221 */
/***/ function(module, exports) {

	"use strict";
	var TypeaheadMatch = (function () {
	    function TypeaheadMatch(item, value, header) {
	        if (value === void 0) { value = item; }
	        if (header === void 0) { header = false; }
	        this.item = item;
	        this.value = value;
	        this.header = header;
	    }
	    TypeaheadMatch.prototype.isHeader = function () {
	        return this.header;
	    };
	    TypeaheadMatch.prototype.toString = function () {
	        return this.value;
	    };
	    return TypeaheadMatch;
	}());
	exports.TypeaheadMatch = TypeaheadMatch;


/***/ },
/* 1222 */
/***/ function(module, exports) {

	"use strict";
	var TypeaheadOptions = (function () {
	    function TypeaheadOptions(options) {
	        Object.assign(this, options);
	    }
	    return TypeaheadOptions;
	}());
	exports.TypeaheadOptions = TypeaheadOptions;


/***/ },
/* 1223 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var latin_map_1 = __webpack_require__(1224);
	var TypeaheadUtils = (function () {
	    function TypeaheadUtils() {
	    }
	    TypeaheadUtils.latinize = function (str) {
	        if (!str) {
	            return '';
	        }
	        return str.replace(/[^A-Za-z0-9\[\] ]/g, function (a) {
	            return TypeaheadUtils.latinMap[a] || a;
	        });
	    };
	    TypeaheadUtils.escapeRegexp = function (queryToEscape) {
	        // Regex: capture the whole query string and replace it with the string
	        // that will be used to match the results, for example if the capture is
	        // 'a' the result will be \a
	        return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
	    };
	    /* tslint:disable */
	    TypeaheadUtils.tokenize = function (str, wordRegexDelimiters, phraseRegexDelimiters) {
	        if (wordRegexDelimiters === void 0) { wordRegexDelimiters = ' '; }
	        if (phraseRegexDelimiters === void 0) { phraseRegexDelimiters = ''; }
	        /* tslint:enable */
	        var regexStr = '(?:[' + phraseRegexDelimiters + '])([^' + phraseRegexDelimiters + ']+)(?:[' + phraseRegexDelimiters + '])|([^' + wordRegexDelimiters + ']+)';
	        var preTokenized = str.split(new RegExp(regexStr, 'g'));
	        var result = [];
	        var preTokenizedLength = preTokenized.length;
	        var token;
	        var replacePhraseDelimiters = new RegExp('[' + phraseRegexDelimiters + ']+', 'g');
	        for (var i = 0; i < preTokenizedLength; i += 1) {
	            token = preTokenized[i];
	            if (token && token.length && token !== wordRegexDelimiters) {
	                result.push(token.replace(replacePhraseDelimiters, ''));
	            }
	        }
	        return result;
	    };
	    TypeaheadUtils.getValueFromObject = function (object, option) {
	        if (!option || typeof object !== 'object') {
	            return object.toString();
	        }
	        if (option.endsWith('()')) {
	            var functionName = option.slice(0, option.length - 2);
	            return object[functionName]().toString();
	        }
	        var properties = option.replace(/\[(\w+)\]/g, '.$1')
	            .replace(/^\./, '');
	        var propertiesArray = properties.split('.');
	        for (var _i = 0, propertiesArray_1 = propertiesArray; _i < propertiesArray_1.length; _i++) {
	            var property = propertiesArray_1[_i];
	            if (property in object) {
	                object = object[property];
	            }
	        }
	        return object.toString();
	    };
	    TypeaheadUtils.latinMap = latin_map_1.latinMap;
	    return TypeaheadUtils;
	}());
	exports.TypeaheadUtils = TypeaheadUtils;


/***/ },
/* 1224 */
/***/ function(module, exports) {

	"use strict";
	exports.latinMap = {
	    'Á': 'A',
	    'Ă': 'A',
	    'Ắ': 'A',
	    'Ặ': 'A',
	    'Ằ': 'A',
	    'Ẳ': 'A',
	    'Ẵ': 'A',
	    'Ǎ': 'A',
	    'Â': 'A',
	    'Ấ': 'A',
	    'Ậ': 'A',
	    'Ầ': 'A',
	    'Ẩ': 'A',
	    'Ẫ': 'A',
	    'Ä': 'A',
	    'Ǟ': 'A',
	    'Ȧ': 'A',
	    'Ǡ': 'A',
	    'Ạ': 'A',
	    'Ȁ': 'A',
	    'À': 'A',
	    'Ả': 'A',
	    'Ȃ': 'A',
	    'Ā': 'A',
	    'Ą': 'A',
	    'Å': 'A',
	    'Ǻ': 'A',
	    'Ḁ': 'A',
	    'Ⱥ': 'A',
	    'Ã': 'A',
	    'Ꜳ': 'AA',
	    'Æ': 'AE',
	    'Ǽ': 'AE',
	    'Ǣ': 'AE',
	    'Ꜵ': 'AO',
	    'Ꜷ': 'AU',
	    'Ꜹ': 'AV',
	    'Ꜻ': 'AV',
	    'Ꜽ': 'AY',
	    'Ḃ': 'B',
	    'Ḅ': 'B',
	    'Ɓ': 'B',
	    'Ḇ': 'B',
	    'Ƀ': 'B',
	    'Ƃ': 'B',
	    'Ć': 'C',
	    'Č': 'C',
	    'Ç': 'C',
	    'Ḉ': 'C',
	    'Ĉ': 'C',
	    'Ċ': 'C',
	    'Ƈ': 'C',
	    'Ȼ': 'C',
	    'Ď': 'D',
	    'Ḑ': 'D',
	    'Ḓ': 'D',
	    'Ḋ': 'D',
	    'Ḍ': 'D',
	    'Ɗ': 'D',
	    'Ḏ': 'D',
	    'ǲ': 'D',
	    'ǅ': 'D',
	    'Đ': 'D',
	    'Ƌ': 'D',
	    'Ǳ': 'DZ',
	    'Ǆ': 'DZ',
	    'É': 'E',
	    'Ĕ': 'E',
	    'Ě': 'E',
	    'Ȩ': 'E',
	    'Ḝ': 'E',
	    'Ê': 'E',
	    'Ế': 'E',
	    'Ệ': 'E',
	    'Ề': 'E',
	    'Ể': 'E',
	    'Ễ': 'E',
	    'Ḙ': 'E',
	    'Ë': 'E',
	    'Ė': 'E',
	    'Ẹ': 'E',
	    'Ȅ': 'E',
	    'È': 'E',
	    'Ẻ': 'E',
	    'Ȇ': 'E',
	    'Ē': 'E',
	    'Ḗ': 'E',
	    'Ḕ': 'E',
	    'Ę': 'E',
	    'Ɇ': 'E',
	    'Ẽ': 'E',
	    'Ḛ': 'E',
	    'Ꝫ': 'ET',
	    'Ḟ': 'F',
	    'Ƒ': 'F',
	    'Ǵ': 'G',
	    'Ğ': 'G',
	    'Ǧ': 'G',
	    'Ģ': 'G',
	    'Ĝ': 'G',
	    'Ġ': 'G',
	    'Ɠ': 'G',
	    'Ḡ': 'G',
	    'Ǥ': 'G',
	    'Ḫ': 'H',
	    'Ȟ': 'H',
	    'Ḩ': 'H',
	    'Ĥ': 'H',
	    'Ⱨ': 'H',
	    'Ḧ': 'H',
	    'Ḣ': 'H',
	    'Ḥ': 'H',
	    'Ħ': 'H',
	    'Í': 'I',
	    'Ĭ': 'I',
	    'Ǐ': 'I',
	    'Î': 'I',
	    'Ï': 'I',
	    'Ḯ': 'I',
	    'İ': 'I',
	    'Ị': 'I',
	    'Ȉ': 'I',
	    'Ì': 'I',
	    'Ỉ': 'I',
	    'Ȋ': 'I',
	    'Ī': 'I',
	    'Į': 'I',
	    'Ɨ': 'I',
	    'Ĩ': 'I',
	    'Ḭ': 'I',
	    'Ꝺ': 'D',
	    'Ꝼ': 'F',
	    'Ᵹ': 'G',
	    'Ꞃ': 'R',
	    'Ꞅ': 'S',
	    'Ꞇ': 'T',
	    'Ꝭ': 'IS',
	    'Ĵ': 'J',
	    'Ɉ': 'J',
	    'Ḱ': 'K',
	    'Ǩ': 'K',
	    'Ķ': 'K',
	    'Ⱪ': 'K',
	    'Ꝃ': 'K',
	    'Ḳ': 'K',
	    'Ƙ': 'K',
	    'Ḵ': 'K',
	    'Ꝁ': 'K',
	    'Ꝅ': 'K',
	    'Ĺ': 'L',
	    'Ƚ': 'L',
	    'Ľ': 'L',
	    'Ļ': 'L',
	    'Ḽ': 'L',
	    'Ḷ': 'L',
	    'Ḹ': 'L',
	    'Ⱡ': 'L',
	    'Ꝉ': 'L',
	    'Ḻ': 'L',
	    'Ŀ': 'L',
	    'Ɫ': 'L',
	    'ǈ': 'L',
	    'Ł': 'L',
	    'Ǉ': 'LJ',
	    'Ḿ': 'M',
	    'Ṁ': 'M',
	    'Ṃ': 'M',
	    'Ɱ': 'M',
	    'Ń': 'N',
	    'Ň': 'N',
	    'Ņ': 'N',
	    'Ṋ': 'N',
	    'Ṅ': 'N',
	    'Ṇ': 'N',
	    'Ǹ': 'N',
	    'Ɲ': 'N',
	    'Ṉ': 'N',
	    'Ƞ': 'N',
	    'ǋ': 'N',
	    'Ñ': 'N',
	    'Ǌ': 'NJ',
	    'Ó': 'O',
	    'Ŏ': 'O',
	    'Ǒ': 'O',
	    'Ô': 'O',
	    'Ố': 'O',
	    'Ộ': 'O',
	    'Ồ': 'O',
	    'Ổ': 'O',
	    'Ỗ': 'O',
	    'Ö': 'O',
	    'Ȫ': 'O',
	    'Ȯ': 'O',
	    'Ȱ': 'O',
	    'Ọ': 'O',
	    'Ő': 'O',
	    'Ȍ': 'O',
	    'Ò': 'O',
	    'Ỏ': 'O',
	    'Ơ': 'O',
	    'Ớ': 'O',
	    'Ợ': 'O',
	    'Ờ': 'O',
	    'Ở': 'O',
	    'Ỡ': 'O',
	    'Ȏ': 'O',
	    'Ꝋ': 'O',
	    'Ꝍ': 'O',
	    'Ō': 'O',
	    'Ṓ': 'O',
	    'Ṑ': 'O',
	    'Ɵ': 'O',
	    'Ǫ': 'O',
	    'Ǭ': 'O',
	    'Ø': 'O',
	    'Ǿ': 'O',
	    'Õ': 'O',
	    'Ṍ': 'O',
	    'Ṏ': 'O',
	    'Ȭ': 'O',
	    'Ƣ': 'OI',
	    'Ꝏ': 'OO',
	    'Ɛ': 'E',
	    'Ɔ': 'O',
	    'Ȣ': 'OU',
	    'Ṕ': 'P',
	    'Ṗ': 'P',
	    'Ꝓ': 'P',
	    'Ƥ': 'P',
	    'Ꝕ': 'P',
	    'Ᵽ': 'P',
	    'Ꝑ': 'P',
	    'Ꝙ': 'Q',
	    'Ꝗ': 'Q',
	    'Ŕ': 'R',
	    'Ř': 'R',
	    'Ŗ': 'R',
	    'Ṙ': 'R',
	    'Ṛ': 'R',
	    'Ṝ': 'R',
	    'Ȑ': 'R',
	    'Ȓ': 'R',
	    'Ṟ': 'R',
	    'Ɍ': 'R',
	    'Ɽ': 'R',
	    'Ꜿ': 'C',
	    'Ǝ': 'E',
	    'Ś': 'S',
	    'Ṥ': 'S',
	    'Š': 'S',
	    'Ṧ': 'S',
	    'Ş': 'S',
	    'Ŝ': 'S',
	    'Ș': 'S',
	    'Ṡ': 'S',
	    'Ṣ': 'S',
	    'Ṩ': 'S',
	    'Ť': 'T',
	    'Ţ': 'T',
	    'Ṱ': 'T',
	    'Ț': 'T',
	    'Ⱦ': 'T',
	    'Ṫ': 'T',
	    'Ṭ': 'T',
	    'Ƭ': 'T',
	    'Ṯ': 'T',
	    'Ʈ': 'T',
	    'Ŧ': 'T',
	    'Ɐ': 'A',
	    'Ꞁ': 'L',
	    'Ɯ': 'M',
	    'Ʌ': 'V',
	    'Ꜩ': 'TZ',
	    'Ú': 'U',
	    'Ŭ': 'U',
	    'Ǔ': 'U',
	    'Û': 'U',
	    'Ṷ': 'U',
	    'Ü': 'U',
	    'Ǘ': 'U',
	    'Ǚ': 'U',
	    'Ǜ': 'U',
	    'Ǖ': 'U',
	    'Ṳ': 'U',
	    'Ụ': 'U',
	    'Ű': 'U',
	    'Ȕ': 'U',
	    'Ù': 'U',
	    'Ủ': 'U',
	    'Ư': 'U',
	    'Ứ': 'U',
	    'Ự': 'U',
	    'Ừ': 'U',
	    'Ử': 'U',
	    'Ữ': 'U',
	    'Ȗ': 'U',
	    'Ū': 'U',
	    'Ṻ': 'U',
	    'Ų': 'U',
	    'Ů': 'U',
	    'Ũ': 'U',
	    'Ṹ': 'U',
	    'Ṵ': 'U',
	    'Ꝟ': 'V',
	    'Ṿ': 'V',
	    'Ʋ': 'V',
	    'Ṽ': 'V',
	    'Ꝡ': 'VY',
	    'Ẃ': 'W',
	    'Ŵ': 'W',
	    'Ẅ': 'W',
	    'Ẇ': 'W',
	    'Ẉ': 'W',
	    'Ẁ': 'W',
	    'Ⱳ': 'W',
	    'Ẍ': 'X',
	    'Ẋ': 'X',
	    'Ý': 'Y',
	    'Ŷ': 'Y',
	    'Ÿ': 'Y',
	    'Ẏ': 'Y',
	    'Ỵ': 'Y',
	    'Ỳ': 'Y',
	    'Ƴ': 'Y',
	    'Ỷ': 'Y',
	    'Ỿ': 'Y',
	    'Ȳ': 'Y',
	    'Ɏ': 'Y',
	    'Ỹ': 'Y',
	    'Ź': 'Z',
	    'Ž': 'Z',
	    'Ẑ': 'Z',
	    'Ⱬ': 'Z',
	    'Ż': 'Z',
	    'Ẓ': 'Z',
	    'Ȥ': 'Z',
	    'Ẕ': 'Z',
	    'Ƶ': 'Z',
	    'Ĳ': 'IJ',
	    'Œ': 'OE',
	    'ᴀ': 'A',
	    'ᴁ': 'AE',
	    'ʙ': 'B',
	    'ᴃ': 'B',
	    'ᴄ': 'C',
	    'ᴅ': 'D',
	    'ᴇ': 'E',
	    'ꜰ': 'F',
	    'ɢ': 'G',
	    'ʛ': 'G',
	    'ʜ': 'H',
	    'ɪ': 'I',
	    'ʁ': 'R',
	    'ᴊ': 'J',
	    'ᴋ': 'K',
	    'ʟ': 'L',
	    'ᴌ': 'L',
	    'ᴍ': 'M',
	    'ɴ': 'N',
	    'ᴏ': 'O',
	    'ɶ': 'OE',
	    'ᴐ': 'O',
	    'ᴕ': 'OU',
	    'ᴘ': 'P',
	    'ʀ': 'R',
	    'ᴎ': 'N',
	    'ᴙ': 'R',
	    'ꜱ': 'S',
	    'ᴛ': 'T',
	    'ⱻ': 'E',
	    'ᴚ': 'R',
	    'ᴜ': 'U',
	    'ᴠ': 'V',
	    'ᴡ': 'W',
	    'ʏ': 'Y',
	    'ᴢ': 'Z',
	    'á': 'a',
	    'ă': 'a',
	    'ắ': 'a',
	    'ặ': 'a',
	    'ằ': 'a',
	    'ẳ': 'a',
	    'ẵ': 'a',
	    'ǎ': 'a',
	    'â': 'a',
	    'ấ': 'a',
	    'ậ': 'a',
	    'ầ': 'a',
	    'ẩ': 'a',
	    'ẫ': 'a',
	    'ä': 'a',
	    'ǟ': 'a',
	    'ȧ': 'a',
	    'ǡ': 'a',
	    'ạ': 'a',
	    'ȁ': 'a',
	    'à': 'a',
	    'ả': 'a',
	    'ȃ': 'a',
	    'ā': 'a',
	    'ą': 'a',
	    'ᶏ': 'a',
	    'ẚ': 'a',
	    'å': 'a',
	    'ǻ': 'a',
	    'ḁ': 'a',
	    'ⱥ': 'a',
	    'ã': 'a',
	    'ꜳ': 'aa',
	    'æ': 'ae',
	    'ǽ': 'ae',
	    'ǣ': 'ae',
	    'ꜵ': 'ao',
	    'ꜷ': 'au',
	    'ꜹ': 'av',
	    'ꜻ': 'av',
	    'ꜽ': 'ay',
	    'ḃ': 'b',
	    'ḅ': 'b',
	    'ɓ': 'b',
	    'ḇ': 'b',
	    'ᵬ': 'b',
	    'ᶀ': 'b',
	    'ƀ': 'b',
	    'ƃ': 'b',
	    'ɵ': 'o',
	    'ć': 'c',
	    'č': 'c',
	    'ç': 'c',
	    'ḉ': 'c',
	    'ĉ': 'c',
	    'ɕ': 'c',
	    'ċ': 'c',
	    'ƈ': 'c',
	    'ȼ': 'c',
	    'ď': 'd',
	    'ḑ': 'd',
	    'ḓ': 'd',
	    'ȡ': 'd',
	    'ḋ': 'd',
	    'ḍ': 'd',
	    'ɗ': 'd',
	    'ᶑ': 'd',
	    'ḏ': 'd',
	    'ᵭ': 'd',
	    'ᶁ': 'd',
	    'đ': 'd',
	    'ɖ': 'd',
	    'ƌ': 'd',
	    'ı': 'i',
	    'ȷ': 'j',
	    'ɟ': 'j',
	    'ʄ': 'j',
	    'ǳ': 'dz',
	    'ǆ': 'dz',
	    'é': 'e',
	    'ĕ': 'e',
	    'ě': 'e',
	    'ȩ': 'e',
	    'ḝ': 'e',
	    'ê': 'e',
	    'ế': 'e',
	    'ệ': 'e',
	    'ề': 'e',
	    'ể': 'e',
	    'ễ': 'e',
	    'ḙ': 'e',
	    'ë': 'e',
	    'ė': 'e',
	    'ẹ': 'e',
	    'ȅ': 'e',
	    'è': 'e',
	    'ẻ': 'e',
	    'ȇ': 'e',
	    'ē': 'e',
	    'ḗ': 'e',
	    'ḕ': 'e',
	    'ⱸ': 'e',
	    'ę': 'e',
	    'ᶒ': 'e',
	    'ɇ': 'e',
	    'ẽ': 'e',
	    'ḛ': 'e',
	    'ꝫ': 'et',
	    'ḟ': 'f',
	    'ƒ': 'f',
	    'ᵮ': 'f',
	    'ᶂ': 'f',
	    'ǵ': 'g',
	    'ğ': 'g',
	    'ǧ': 'g',
	    'ģ': 'g',
	    'ĝ': 'g',
	    'ġ': 'g',
	    'ɠ': 'g',
	    'ḡ': 'g',
	    'ᶃ': 'g',
	    'ǥ': 'g',
	    'ḫ': 'h',
	    'ȟ': 'h',
	    'ḩ': 'h',
	    'ĥ': 'h',
	    'ⱨ': 'h',
	    'ḧ': 'h',
	    'ḣ': 'h',
	    'ḥ': 'h',
	    'ɦ': 'h',
	    'ẖ': 'h',
	    'ħ': 'h',
	    'ƕ': 'hv',
	    'í': 'i',
	    'ĭ': 'i',
	    'ǐ': 'i',
	    'î': 'i',
	    'ï': 'i',
	    'ḯ': 'i',
	    'ị': 'i',
	    'ȉ': 'i',
	    'ì': 'i',
	    'ỉ': 'i',
	    'ȋ': 'i',
	    'ī': 'i',
	    'į': 'i',
	    'ᶖ': 'i',
	    'ɨ': 'i',
	    'ĩ': 'i',
	    'ḭ': 'i',
	    'ꝺ': 'd',
	    'ꝼ': 'f',
	    'ᵹ': 'g',
	    'ꞃ': 'r',
	    'ꞅ': 's',
	    'ꞇ': 't',
	    'ꝭ': 'is',
	    'ǰ': 'j',
	    'ĵ': 'j',
	    'ʝ': 'j',
	    'ɉ': 'j',
	    'ḱ': 'k',
	    'ǩ': 'k',
	    'ķ': 'k',
	    'ⱪ': 'k',
	    'ꝃ': 'k',
	    'ḳ': 'k',
	    'ƙ': 'k',
	    'ḵ': 'k',
	    'ᶄ': 'k',
	    'ꝁ': 'k',
	    'ꝅ': 'k',
	    'ĺ': 'l',
	    'ƚ': 'l',
	    'ɬ': 'l',
	    'ľ': 'l',
	    'ļ': 'l',
	    'ḽ': 'l',
	    'ȴ': 'l',
	    'ḷ': 'l',
	    'ḹ': 'l',
	    'ⱡ': 'l',
	    'ꝉ': 'l',
	    'ḻ': 'l',
	    'ŀ': 'l',
	    'ɫ': 'l',
	    'ᶅ': 'l',
	    'ɭ': 'l',
	    'ł': 'l',
	    'ǉ': 'lj',
	    'ſ': 's',
	    'ẜ': 's',
	    'ẛ': 's',
	    'ẝ': 's',
	    'ḿ': 'm',
	    'ṁ': 'm',
	    'ṃ': 'm',
	    'ɱ': 'm',
	    'ᵯ': 'm',
	    'ᶆ': 'm',
	    'ń': 'n',
	    'ň': 'n',
	    'ņ': 'n',
	    'ṋ': 'n',
	    'ȵ': 'n',
	    'ṅ': 'n',
	    'ṇ': 'n',
	    'ǹ': 'n',
	    'ɲ': 'n',
	    'ṉ': 'n',
	    'ƞ': 'n',
	    'ᵰ': 'n',
	    'ᶇ': 'n',
	    'ɳ': 'n',
	    'ñ': 'n',
	    'ǌ': 'nj',
	    'ó': 'o',
	    'ŏ': 'o',
	    'ǒ': 'o',
	    'ô': 'o',
	    'ố': 'o',
	    'ộ': 'o',
	    'ồ': 'o',
	    'ổ': 'o',
	    'ỗ': 'o',
	    'ö': 'o',
	    'ȫ': 'o',
	    'ȯ': 'o',
	    'ȱ': 'o',
	    'ọ': 'o',
	    'ő': 'o',
	    'ȍ': 'o',
	    'ò': 'o',
	    'ỏ': 'o',
	    'ơ': 'o',
	    'ớ': 'o',
	    'ợ': 'o',
	    'ờ': 'o',
	    'ở': 'o',
	    'ỡ': 'o',
	    'ȏ': 'o',
	    'ꝋ': 'o',
	    'ꝍ': 'o',
	    'ⱺ': 'o',
	    'ō': 'o',
	    'ṓ': 'o',
	    'ṑ': 'o',
	    'ǫ': 'o',
	    'ǭ': 'o',
	    'ø': 'o',
	    'ǿ': 'o',
	    'õ': 'o',
	    'ṍ': 'o',
	    'ṏ': 'o',
	    'ȭ': 'o',
	    'ƣ': 'oi',
	    'ꝏ': 'oo',
	    'ɛ': 'e',
	    'ᶓ': 'e',
	    'ɔ': 'o',
	    'ᶗ': 'o',
	    'ȣ': 'ou',
	    'ṕ': 'p',
	    'ṗ': 'p',
	    'ꝓ': 'p',
	    'ƥ': 'p',
	    'ᵱ': 'p',
	    'ᶈ': 'p',
	    'ꝕ': 'p',
	    'ᵽ': 'p',
	    'ꝑ': 'p',
	    'ꝙ': 'q',
	    'ʠ': 'q',
	    'ɋ': 'q',
	    'ꝗ': 'q',
	    'ŕ': 'r',
	    'ř': 'r',
	    'ŗ': 'r',
	    'ṙ': 'r',
	    'ṛ': 'r',
	    'ṝ': 'r',
	    'ȑ': 'r',
	    'ɾ': 'r',
	    'ᵳ': 'r',
	    'ȓ': 'r',
	    'ṟ': 'r',
	    'ɼ': 'r',
	    'ᵲ': 'r',
	    'ᶉ': 'r',
	    'ɍ': 'r',
	    'ɽ': 'r',
	    'ↄ': 'c',
	    'ꜿ': 'c',
	    'ɘ': 'e',
	    'ɿ': 'r',
	    'ś': 's',
	    'ṥ': 's',
	    'š': 's',
	    'ṧ': 's',
	    'ş': 's',
	    'ŝ': 's',
	    'ș': 's',
	    'ṡ': 's',
	    'ṣ': 's',
	    'ṩ': 's',
	    'ʂ': 's',
	    'ᵴ': 's',
	    'ᶊ': 's',
	    'ȿ': 's',
	    'ɡ': 'g',
	    'ᴑ': 'o',
	    'ᴓ': 'o',
	    'ᴝ': 'u',
	    'ť': 't',
	    'ţ': 't',
	    'ṱ': 't',
	    'ț': 't',
	    'ȶ': 't',
	    'ẗ': 't',
	    'ⱦ': 't',
	    'ṫ': 't',
	    'ṭ': 't',
	    'ƭ': 't',
	    'ṯ': 't',
	    'ᵵ': 't',
	    'ƫ': 't',
	    'ʈ': 't',
	    'ŧ': 't',
	    'ᵺ': 'th',
	    'ɐ': 'a',
	    'ᴂ': 'ae',
	    'ǝ': 'e',
	    'ᵷ': 'g',
	    'ɥ': 'h',
	    'ʮ': 'h',
	    'ʯ': 'h',
	    'ᴉ': 'i',
	    'ʞ': 'k',
	    'ꞁ': 'l',
	    'ɯ': 'm',
	    'ɰ': 'm',
	    'ᴔ': 'oe',
	    'ɹ': 'r',
	    'ɻ': 'r',
	    'ɺ': 'r',
	    'ⱹ': 'r',
	    'ʇ': 't',
	    'ʌ': 'v',
	    'ʍ': 'w',
	    'ʎ': 'y',
	    'ꜩ': 'tz',
	    'ú': 'u',
	    'ŭ': 'u',
	    'ǔ': 'u',
	    'û': 'u',
	    'ṷ': 'u',
	    'ü': 'u',
	    'ǘ': 'u',
	    'ǚ': 'u',
	    'ǜ': 'u',
	    'ǖ': 'u',
	    'ṳ': 'u',
	    'ụ': 'u',
	    'ű': 'u',
	    'ȕ': 'u',
	    'ù': 'u',
	    'ủ': 'u',
	    'ư': 'u',
	    'ứ': 'u',
	    'ự': 'u',
	    'ừ': 'u',
	    'ử': 'u',
	    'ữ': 'u',
	    'ȗ': 'u',
	    'ū': 'u',
	    'ṻ': 'u',
	    'ų': 'u',
	    'ᶙ': 'u',
	    'ů': 'u',
	    'ũ': 'u',
	    'ṹ': 'u',
	    'ṵ': 'u',
	    'ᵫ': 'ue',
	    'ꝸ': 'um',
	    'ⱴ': 'v',
	    'ꝟ': 'v',
	    'ṿ': 'v',
	    'ʋ': 'v',
	    'ᶌ': 'v',
	    'ⱱ': 'v',
	    'ṽ': 'v',
	    'ꝡ': 'vy',
	    'ẃ': 'w',
	    'ŵ': 'w',
	    'ẅ': 'w',
	    'ẇ': 'w',
	    'ẉ': 'w',
	    'ẁ': 'w',
	    'ⱳ': 'w',
	    'ẘ': 'w',
	    'ẍ': 'x',
	    'ẋ': 'x',
	    'ᶍ': 'x',
	    'ý': 'y',
	    'ŷ': 'y',
	    'ÿ': 'y',
	    'ẏ': 'y',
	    'ỵ': 'y',
	    'ỳ': 'y',
	    'ƴ': 'y',
	    'ỷ': 'y',
	    'ỿ': 'y',
	    'ȳ': 'y',
	    'ẙ': 'y',
	    'ɏ': 'y',
	    'ỹ': 'y',
	    'ź': 'z',
	    'ž': 'z',
	    'ẑ': 'z',
	    'ʑ': 'z',
	    'ⱬ': 'z',
	    'ż': 'z',
	    'ẓ': 'z',
	    'ȥ': 'z',
	    'ẕ': 'z',
	    'ᵶ': 'z',
	    'ᶎ': 'z',
	    'ʐ': 'z',
	    'ƶ': 'z',
	    'ɀ': 'z',
	    'ﬀ': 'ff',
	    'ﬃ': 'ffi',
	    'ﬄ': 'ffl',
	    'ﬁ': 'fi',
	    'ﬂ': 'fl',
	    'ĳ': 'ij',
	    'œ': 'oe',
	    'ﬆ': 'st',
	    'ₐ': 'a',
	    'ₑ': 'e',
	    'ᵢ': 'i',
	    'ⱼ': 'j',
	    'ₒ': 'o',
	    'ᵣ': 'r',
	    'ᵤ': 'u',
	    'ᵥ': 'v',
	    'ₓ': 'x'
	};


/***/ },
/* 1225 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var ng2_bootstrap_config_1 = __webpack_require__(1074);
	var position_1 = __webpack_require__(1216);
	var typeahead_options_class_1 = __webpack_require__(1222);
	var typeahead_utils_1 = __webpack_require__(1223);
	var bs4 = "\n  <div class=\"dropdown-menu\"\n       [ngStyle]=\"{top: top, left: left, display: 'block'}\"\n       (mouseleave)=\"focusLost()\">\n    <template ngFor let-match let-i=\"index\" [ngForOf]=\"matches\">\n       <h6 *ngIf=\"match.isHeader()\" class=\"dropdown-header\">{{match}}</h6>\n       <div *ngIf=\"!match.isHeader() && !itemTemplate\">\n          <a href=\"#\"\n            class=\"dropdown-item\"\n            (click)=\"selectMatch(match, $event)\"\n            (mouseenter)=\"selectActive(match)\"\n            [class.active]=\"isActive(match)\"\n            [innerHtml]=\"hightlight(match, query)\"></a>\n      </div>\n      <div *ngIf=\"!match.isHeader() && itemTemplate\">\n        <a href=\"#\"\n         class=\"dropdown-item\"\n         (click)=\"selectMatch(match, $event)\"\n         (mouseenter)=\"selectActive(match)\"\n         [class.active]=\"isActive(match)\">\n          <template [ngTemplateOutlet]=\"itemTemplate\"\n                    [ngOutletContext]=\"{item: match.item, index: i}\">\n          </template>\n         </a>\n      </div>\n    </template>\n  </div>\n";
	var bs3 = "\n  <ul class=\"dropdown-menu\"\n      [ngStyle]=\"{top: top, left: left, display: 'block'}\"\n      (mouseleave)=\"focusLost()\">\n    <template ngFor let-match let-i=\"index\" [ngForOf]=\"matches\">\n      <li *ngIf=\"match.isHeader()\" class=\"dropdown-header\">{{match}}</li>\n      <li *ngIf=\"!match.isHeader()\"\n        [class.active]=\"isActive(match)\"\n        (mouseenter)=\"selectActive(match)\">\n        <a href=\"#\"\n           *ngIf=\"!itemTemplate\"\n           (click)=\"selectMatch(match, $event)\"\n           tabindex=\"-1\"\n           [innerHtml]=\"hightlight(match, query)\"></a>\n        <a href=\"#\"\n           *ngIf=\"itemTemplate\"\n           (click)=\"selectMatch(match, $event)\"\n           tabindex=\"-1\">\n            <template [ngTemplateOutlet]=\"itemTemplate\"\n                      [ngOutletContext]=\"{item: match.item, index: i}\">\n            </template>\n        </a>\n      </li>\n    </template>\n  </ul>\n";
	var isBS4 = ng2_bootstrap_config_1.Ng2BootstrapConfig.theme === ng2_bootstrap_config_1.Ng2BootstrapTheme.BS4;
	var TypeaheadContainerComponent = (function () {
	    function TypeaheadContainerComponent(element, options) {
	        this.isFocused = false;
	        this._matches = [];
	        this.element = element;
	        Object.assign(this, options);
	    }
	    Object.defineProperty(TypeaheadContainerComponent.prototype, "matches", {
	        get: function () {
	            return this._matches;
	        },
	        set: function (value) {
	            this._matches = value;
	            if (this._matches.length > 0) {
	                this._active = this._matches[0];
	                if (this._active.isHeader()) {
	                    this.nextActiveMatch();
	                }
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(TypeaheadContainerComponent.prototype, "itemTemplate", {
	        get: function () {
	            return this.parent ? this.parent.typeaheadItemTemplate : undefined;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    TypeaheadContainerComponent.prototype.position = function (hostEl) {
	        this.top = '0px';
	        this.left = '0px';
	        var p = position_1.positionService
	            .positionElements(hostEl.nativeElement, this.element.nativeElement.children[0], this.placement, false);
	        this.top = p.top + 'px';
	        this.left = p.left + 'px';
	    };
	    TypeaheadContainerComponent.prototype.selectActiveMatch = function () {
	        this.selectMatch(this._active);
	    };
	    TypeaheadContainerComponent.prototype.prevActiveMatch = function () {
	        var index = this.matches.indexOf(this._active);
	        this._active = this.matches[index - 1 < 0
	            ? this.matches.length - 1
	            : index - 1];
	        if (this._active.isHeader()) {
	            this.prevActiveMatch();
	        }
	    };
	    TypeaheadContainerComponent.prototype.nextActiveMatch = function () {
	        var index = this.matches.indexOf(this._active);
	        this._active = this.matches[index + 1 > this.matches.length - 1
	            ? 0
	            : index + 1];
	        if (this._active.isHeader()) {
	            this.nextActiveMatch();
	        }
	    };
	    TypeaheadContainerComponent.prototype.selectActive = function (value) {
	        this.isFocused = true;
	        this._active = value;
	    };
	    TypeaheadContainerComponent.prototype.hightlight = function (match, query) {
	        var itemStr = match.value;
	        var itemStrHelper = (this.parent && this.parent.typeaheadLatinize
	            ? typeahead_utils_1.TypeaheadUtils.latinize(itemStr)
	            : itemStr).toLowerCase();
	        var startIdx;
	        var tokenLen;
	        // Replaces the capture string with the same string inside of a "strong" tag
	        if (typeof query === 'object') {
	            var queryLen = query.length;
	            for (var i = 0; i < queryLen; i += 1) {
	                // query[i] is already latinized and lower case
	                startIdx = itemStrHelper.indexOf(query[i]);
	                tokenLen = query[i].length;
	                if (startIdx >= 0 && tokenLen > 0) {
	                    itemStr = itemStr.substring(0, startIdx) + '<strong>' + itemStr.substring(startIdx, startIdx + tokenLen) + '</strong>' + itemStr.substring(startIdx + tokenLen);
	                    itemStrHelper = itemStrHelper.substring(0, startIdx) + '        ' + ' '.repeat(tokenLen) + '         ' + itemStrHelper.substring(startIdx + tokenLen);
	                }
	            }
	        }
	        else if (query) {
	            // query is already latinized and lower case
	            startIdx = itemStrHelper.indexOf(query);
	            tokenLen = query.length;
	            if (startIdx >= 0 && tokenLen > 0) {
	                itemStr = itemStr.substring(0, startIdx) + '<strong>' + itemStr.substring(startIdx, startIdx + tokenLen) + '</strong>' + itemStr.substring(startIdx + tokenLen);
	            }
	        }
	        return itemStr;
	    };
	    TypeaheadContainerComponent.prototype.focusLost = function () {
	        this.isFocused = false;
	    };
	    TypeaheadContainerComponent.prototype.isActive = function (value) {
	        return this._active === value;
	    };
	    TypeaheadContainerComponent.prototype.selectMatch = function (value, e) {
	        var _this = this;
	        if (e === void 0) { e = void 0; }
	        if (e) {
	            e.stopPropagation();
	            e.preventDefault();
	        }
	        this.parent.changeModel(value);
	        setTimeout(function () {
	            return _this.parent.typeaheadOnSelect.emit(value);
	        }, 0);
	        return false;
	    };
	    TypeaheadContainerComponent.decorators = [
	        { type: core_1.Component, args: [{
	                    selector: 'typeahead-container',
	                    template: isBS4 ? bs4 : bs3,
	                    encapsulation: core_1.ViewEncapsulation.None
	                },] },
	    ];
	    /** @nocollapse */
	    TypeaheadContainerComponent.ctorParameters = [
	        { type: core_1.ElementRef, },
	        { type: typeahead_options_class_1.TypeaheadOptions, },
	    ];
	    return TypeaheadContainerComponent;
	}());
	exports.TypeaheadContainerComponent = TypeaheadContainerComponent;


/***/ },
/* 1226 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(826);
	var typeahead_container_component_1 = __webpack_require__(1225);
	var typeahead_options_class_1 = __webpack_require__(1222);
	var typeahead_utils_1 = __webpack_require__(1223);
	var Observable_1 = __webpack_require__(5);
	__webpack_require__(224);
	__webpack_require__(316);
	__webpack_require__(343);
	__webpack_require__(368);
	__webpack_require__(377);
	__webpack_require__(470);
	var components_helper_service_1 = __webpack_require__(541);
	var typeahead_match_class_1 = __webpack_require__(1221);
	/* tslint:disable-next-line */
	var KeyboardEvent = global.KeyboardEvent;
	var TypeaheadDirective = (function () {
	    function TypeaheadDirective(control, viewContainerRef, element, renderer, componentsHelper) {
	        this.typeaheadLoading = new core_1.EventEmitter(false);
	        this.typeaheadNoResults = new core_1.EventEmitter(false);
	        this.typeaheadOnSelect = new core_1.EventEmitter(false);
	        this.typeaheadMinLength = void 0;
	        this.typeaheadAsync = void 0;
	        this.typeaheadLatinize = true;
	        this.typeaheadSingleWords = true;
	        this.typeaheadWordDelimiters = ' ';
	        this.typeaheadPhraseDelimiters = '\'"';
	        this.isTypeaheadOptionsListActive = false;
	        this.keyUpEventEmitter = new core_1.EventEmitter();
	        this.placement = 'bottom-left';
	        this.element = element;
	        this.ngControl = control;
	        this.viewContainerRef = viewContainerRef;
	        this.renderer = renderer;
	        this.componentsHelper = componentsHelper;
	    }
	    TypeaheadDirective.prototype.onChange = function (e) {
	        if (this.container) {
	            // esc
	            if (e.keyCode === 27) {
	                this.hide();
	                return;
	            }
	            // up
	            if (e.keyCode === 38) {
	                this.container.prevActiveMatch();
	                return;
	            }
	            // down
	            if (e.keyCode === 40) {
	                this.container.nextActiveMatch();
	                return;
	            }
	            // enter
	            if (e.keyCode === 13) {
	                this.container.selectActiveMatch();
	                return;
	            }
	        }
	        // For `<input>`s, use the `value` property. For others that don't have a
	        // `value` (such as `<span contenteditable="true">`, use `innerText`.
	        var value = e.target.value !== undefined ? e.target.value : e.target.innerText;
	        if (value.trim().length >= this.typeaheadMinLength) {
	            this.typeaheadLoading.emit(true);
	            this.keyUpEventEmitter.emit(e.target.value);
	        }
	        else {
	            this.typeaheadLoading.emit(false);
	            this.typeaheadNoResults.emit(false);
	            this.hide();
	        }
	    };
	    TypeaheadDirective.prototype.onFocus = function () {
	        if (this.typeaheadMinLength === 0) {
	            this.typeaheadLoading.emit(true);
	            this.keyUpEventEmitter.emit('');
	        }
	    };
	    TypeaheadDirective.prototype.onBlur = function () {
	        if (this.container && !this.container.isFocused) {
	            this.hide();
	        }
	    };
	    TypeaheadDirective.prototype.onKeydown = function (e) {
	        // no container - no problems
	        if (!this.container) {
	            return;
	        }
	        // if items is visible - prevent form submition
	        if (e.keyCode === 13) {
	            e.preventDefault();
	            return;
	        }
	        // if tab default browser behavior will select next input field, and therefore we should close the items list
	        if (e.keyCode === 9) {
	            this.hide();
	            return;
	        }
	    };
	    TypeaheadDirective.prototype.ngOnInit = function () {
	        this.typeaheadOptionsLimit = this.typeaheadOptionsLimit || 20;
	        this.typeaheadMinLength = this.typeaheadMinLength === void 0 ? 1 : this.typeaheadMinLength;
	        this.typeaheadWaitMs = this.typeaheadWaitMs || 0;
	        // async should be false in case of array
	        if (this.typeaheadAsync === undefined && !(this.typeahead instanceof Observable_1.Observable)) {
	            this.typeaheadAsync = false;
	        }
	        if (this.typeahead instanceof Observable_1.Observable) {
	            this.typeaheadAsync = true;
	        }
	        if (this.typeaheadAsync) {
	            this.asyncActions();
	        }
	        else {
	            this.syncActions();
	        }
	    };
	    TypeaheadDirective.prototype.changeModel = function (match) {
	        var valueStr = match.value;
	        this.ngControl.viewToModelUpdate(valueStr);
	        this.ngControl.control.setValue(valueStr);
	        this.hide();
	    };
	    Object.defineProperty(TypeaheadDirective.prototype, "matches", {
	        get: function () {
	            return this._matches;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    TypeaheadDirective.prototype.show = function () {
	        var options = new typeahead_options_class_1.TypeaheadOptions({
	            typeaheadRef: this,
	            placement: this.placement,
	            animation: false
	        });
	        var binding = core_1.ReflectiveInjector.resolve([
	            { provide: typeahead_options_class_1.TypeaheadOptions, useValue: options }
	        ]);
	        this.popup = this.componentsHelper
	            .appendNextToLocation(typeahead_container_component_1.TypeaheadContainerComponent, this.viewContainerRef, binding);
	        this.popup.instance.position(this.viewContainerRef.element);
	        this.container = this.popup.instance;
	        this.container.parent = this;
	        // This improves the speed as it won't have to be done for each list item
	        var normalizedQuery = (this.typeaheadLatinize
	            ? typeahead_utils_1.TypeaheadUtils.latinize(this.ngControl.control.value)
	            : this.ngControl.control.value).toString()
	            .toLowerCase();
	        this.container.query = this.typeaheadSingleWords
	            ? typeahead_utils_1.TypeaheadUtils.tokenize(normalizedQuery, this.typeaheadWordDelimiters, this.typeaheadPhraseDelimiters)
	            : normalizedQuery;
	        this.container.matches = this._matches;
	        this.element.nativeElement.focus();
	    };
	    TypeaheadDirective.prototype.hide = function () {
	        if (this.container) {
	            this.popup.destroy();
	            this.container = void 0;
	        }
	    };
	    TypeaheadDirective.prototype.asyncActions = function () {
	        var _this = this;
	        this.keyUpEventEmitter
	            .debounceTime(this.typeaheadWaitMs)
	            .mergeMap(function () { return _this.typeahead; })
	            .subscribe(function (matches) {
	            _this.finalizeAsyncCall(matches);
	        }, function (err) {
	            console.error(err);
	        });
	    };
	    TypeaheadDirective.prototype.syncActions = function () {
	        var _this = this;
	        this.keyUpEventEmitter
	            .debounceTime(this.typeaheadWaitMs)
	            .mergeMap(function (value) {
	            var normalizedQuery = _this.normalizeQuery(value);
	            return Observable_1.Observable.from(_this.typeahead)
	                .filter(function (option) {
	                return option && _this.testMatch(_this.normalizeOption(option), normalizedQuery);
	            })
	                .toArray();
	        })
	            .subscribe(function (matches) {
	            _this.finalizeAsyncCall(matches);
	        }, function (err) {
	            console.error(err);
	        });
	    };
	    TypeaheadDirective.prototype.normalizeOption = function (option) {
	        var optionValue = typeahead_utils_1.TypeaheadUtils.getValueFromObject(option, this.typeaheadOptionField);
	        var normalizedOption = this.typeaheadLatinize ? typeahead_utils_1.TypeaheadUtils.latinize(optionValue) : optionValue;
	        return normalizedOption.toLowerCase();
	    };
	    TypeaheadDirective.prototype.normalizeQuery = function (value) {
	        // If singleWords, break model here to not be doing extra work on each iteration
	        var normalizedQuery = (this.typeaheadLatinize ? typeahead_utils_1.TypeaheadUtils.latinize(value) : value)
	            .toString()
	            .toLowerCase();
	        normalizedQuery = this.typeaheadSingleWords ?
	            typeahead_utils_1.TypeaheadUtils.tokenize(normalizedQuery, this.typeaheadWordDelimiters, this.typeaheadPhraseDelimiters) :
	            normalizedQuery;
	        return normalizedQuery;
	    };
	    TypeaheadDirective.prototype.testMatch = function (match, test) {
	        var spaceLength;
	        if (typeof test === 'object') {
	            spaceLength = test.length;
	            for (var i = 0; i < spaceLength; i += 1) {
	                if (test[i].length > 0 && match.indexOf(test[i]) < 0) {
	                    return false;
	                }
	            }
	            return true;
	        }
	        else {
	            return match.indexOf(test) >= 0;
	        }
	    };
	    TypeaheadDirective.prototype.finalizeAsyncCall = function (matches) {
	        this.prepareMatches(matches);
	        this.typeaheadLoading.emit(false);
	        this.typeaheadNoResults.emit(!this.hasMatches());
	        if (!this.hasMatches()) {
	            this.hide();
	            return;
	        }
	        if (this.container) {
	            // This improves the speed as it won't have to be done for each list item
	            var normalizedQuery = (this.typeaheadLatinize
	                ? typeahead_utils_1.TypeaheadUtils.latinize(this.ngControl.control.value)
	                : this.ngControl.control.value).toString()
	                .toLowerCase();
	            this.container.query = this.typeaheadSingleWords
	                ? typeahead_utils_1.TypeaheadUtils.tokenize(normalizedQuery, this.typeaheadWordDelimiters, this.typeaheadPhraseDelimiters)
	                : normalizedQuery;
	            this.container.matches = this._matches;
	        }
	        else {
	            this.show();
	        }
	    };
	    TypeaheadDirective.prototype.prepareMatches = function (options) {
	        var _this = this;
	        var limited = options.slice(0, this.typeaheadOptionsLimit);
	        if (this.typeaheadGroupField) {
	            var matches_1 = [];
	            // extract all group names
	            var groups = limited
	                .map(function (option) { return typeahead_utils_1.TypeaheadUtils.getValueFromObject(option, _this.typeaheadGroupField); })
	                .filter(function (v, i, a) { return a.indexOf(v) === i; });
	            groups.forEach(function (group) {
	                // add group header to array of matches
	                matches_1.push(new typeahead_match_class_1.TypeaheadMatch(group, group, true));
	                // add each item of group to array of matches
	                matches_1 = matches_1.concat(limited
	                    .filter(function (option) { return typeahead_utils_1.TypeaheadUtils.getValueFromObject(option, _this.typeaheadGroupField) === group; })
	                    .map(function (option) { return new typeahead_match_class_1.TypeaheadMatch(option, typeahead_utils_1.TypeaheadUtils.getValueFromObject(option, _this.typeaheadOptionField)); }));
	            });
	            this._matches = matches_1;
	        }
	        else {
	            this._matches = limited.map(function (option) { return new typeahead_match_class_1.TypeaheadMatch(option, typeahead_utils_1.TypeaheadUtils.getValueFromObject(option, _this.typeaheadOptionField)); });
	        }
	    };
	    TypeaheadDirective.prototype.hasMatches = function () {
	        return this._matches.length > 0;
	    };
	    TypeaheadDirective.decorators = [
	        { type: core_1.Directive, args: [{
	                    /* tslint:disable */
	                    selector: '[typeahead][ngModel],[typeahead][formControlName]'
	                },] },
	    ];
	    /** @nocollapse */
	    TypeaheadDirective.ctorParameters = [
	        { type: forms_1.NgControl, },
	        { type: core_1.ViewContainerRef, },
	        { type: core_1.ElementRef, },
	        { type: core_1.Renderer, },
	        { type: components_helper_service_1.ComponentsHelper, },
	    ];
	    TypeaheadDirective.propDecorators = {
	        'typeaheadLoading': [{ type: core_1.Output },],
	        'typeaheadNoResults': [{ type: core_1.Output },],
	        'typeaheadOnSelect': [{ type: core_1.Output },],
	        'typeahead': [{ type: core_1.Input },],
	        'typeaheadMinLength': [{ type: core_1.Input },],
	        'typeaheadWaitMs': [{ type: core_1.Input },],
	        'typeaheadOptionsLimit': [{ type: core_1.Input },],
	        'typeaheadOptionField': [{ type: core_1.Input },],
	        'typeaheadGroupField': [{ type: core_1.Input },],
	        'typeaheadAsync': [{ type: core_1.Input },],
	        'typeaheadLatinize': [{ type: core_1.Input },],
	        'typeaheadSingleWords': [{ type: core_1.Input },],
	        'typeaheadWordDelimiters': [{ type: core_1.Input },],
	        'typeaheadPhraseDelimiters': [{ type: core_1.Input },],
	        'typeaheadItemTemplate': [{ type: core_1.Input },],
	        'onChange': [{ type: core_1.HostListener, args: ['keyup', ['$event'],] },],
	        'onFocus': [{ type: core_1.HostListener, args: ['focus',] },],
	        'onBlur': [{ type: core_1.HostListener, args: ['blur',] },],
	        'onKeydown': [{ type: core_1.HostListener, args: ['keydown', ['$event'],] },],
	    };
	    return TypeaheadDirective;
	}());
	exports.TypeaheadDirective = TypeaheadDirective;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1227 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var common_1 = __webpack_require__(22);
	var core_1 = __webpack_require__(3);
	var forms_1 = __webpack_require__(826);
	var typeahead_container_component_1 = __webpack_require__(1225);
	var typeahead_directive_1 = __webpack_require__(1226);
	var components_helper_service_1 = __webpack_require__(541);
	var TypeaheadModule = (function () {
	    function TypeaheadModule() {
	    }
	    TypeaheadModule.decorators = [
	        { type: core_1.NgModule, args: [{
	                    imports: [common_1.CommonModule, forms_1.FormsModule],
	                    declarations: [typeahead_container_component_1.TypeaheadContainerComponent, typeahead_directive_1.TypeaheadDirective],
	                    exports: [forms_1.FormsModule, typeahead_container_component_1.TypeaheadContainerComponent, typeahead_directive_1.TypeaheadDirective],
	                    providers: [components_helper_service_1.ComponentsHelper],
	                    entryComponents: [typeahead_container_component_1.TypeaheadContainerComponent]
	                },] },
	    ];
	    /** @nocollapse */
	    TypeaheadModule.ctorParameters = [];
	    return TypeaheadModule;
	}());
	exports.TypeaheadModule = TypeaheadModule;


/***/ },
/* 1228 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var core_1 = __webpack_require__(3);
	var accordion_module_1 = __webpack_require__(1065);
	var alert_module_1 = __webpack_require__(678);
	var buttons_module_1 = __webpack_require__(1071);
	var carousel_module_1 = __webpack_require__(1075);
	var collapse_module_1 = __webpack_require__(1066);
	var datepicker_module_1 = __webpack_require__(1188);
	var dropdown_module_1 = __webpack_require__(1197);
	var modal_module_1 = __webpack_require__(544);
	var pagination_module_1 = __webpack_require__(1201);
	var progressbar_module_1 = __webpack_require__(675);
	var rating_module_1 = __webpack_require__(1204);
	var tabs_module_1 = __webpack_require__(1209);
	var timepicker_module_1 = __webpack_require__(1213);
	var tooltip_module_1 = __webpack_require__(1219);
	var typeahead_module_1 = __webpack_require__(1227);
	var components_helper_service_1 = __webpack_require__(541);
	var Ng2BootstrapModule = (function () {
	    function Ng2BootstrapModule() {
	    }
	    Ng2BootstrapModule.decorators = [
	        { type: core_1.NgModule, args: [{
	                    exports: [
	                        accordion_module_1.AccordionModule, alert_module_1.AlertModule, buttons_module_1.ButtonsModule, carousel_module_1.CarouselModule, collapse_module_1.CollapseModule, datepicker_module_1.DatepickerModule, dropdown_module_1.DropdownModule,
	                        modal_module_1.ModalModule, pagination_module_1.PaginationModule, progressbar_module_1.ProgressbarModule, rating_module_1.RatingModule, tabs_module_1.TabsModule, timepicker_module_1.TimepickerModule, tooltip_module_1.TooltipModule,
	                        typeahead_module_1.TypeaheadModule
	                    ],
	                    providers: [
	                        { provide: components_helper_service_1.ComponentsHelper, useClass: components_helper_service_1.ComponentsHelper }
	                    ]
	                },] },
	    ];
	    /** @nocollapse */
	    Ng2BootstrapModule.ctorParameters = [];
	    return Ng2BootstrapModule;
	}());
	exports.Ng2BootstrapModule = Ng2BootstrapModule;


/***/ },
/* 1229 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var additionalfreeitems_service_1 = __webpack_require__(887);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var SelectDriverSubscriptionPopupComponent = (function () {
	    function SelectDriverSubscriptionPopupComponent(additionalFreeItemService, authService, router, translate) {
	        this.additionalFreeItemService = additionalFreeItemService;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.onSuccessSelect = new core_1.EventEmitter();
	    }
	    SelectDriverSubscriptionPopupComponent.prototype.ngOnInit = function () {
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.searchField = ["driverName", "subscriptionName", "sharedVehicleGroup"];
	    };
	    SelectDriverSubscriptionPopupComponent.prototype.ngOnChanges = function (change) {
	        console.log(change);
	    };
	    SelectDriverSubscriptionPopupComponent.prototype.show = function () {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.sortType = "";
	        this.DataListModel.sortReverse = null;
	        this.DataListModel.searchTerm = "";
	        this.DataListModel.infoMessage = "";
	        this.GetDriverList();
	        this.driverSubscriptionModal.show();
	    };
	    SelectDriverSubscriptionPopupComponent.prototype.hide = function () {
	        this.driverSubscriptionModal.hide();
	    };
	    SelectDriverSubscriptionPopupComponent.prototype.GetDriverList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.additionalFreeItemService.GetDriverSubscriptionList(this.DataListModel)
	            .subscribe(function (res) {
	            _this.driverSubscriptionList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SelectDriverSubscriptionPopupComponent.prototype.select = function (driverSubscription) {
	        this.isLoading = true;
	        this.onSuccessSelect.emit({ sharedVehicleDriverHashId: driverSubscription.sharedVehicleDriverHashId, driverName: driverSubscription.driverName });
	        this.isLoading = false;
	        this.hide();
	    };
	    SelectDriverSubscriptionPopupComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetDriverList();
	    };
	    SelectDriverSubscriptionPopupComponent.prototype.OnSearch = function (event) {
	        this.DataListModel.searchTerm = event.searchTerm;
	        this.DataListModel.currentPage = 1;
	        this.GetDriverList();
	    };
	    SelectDriverSubscriptionPopupComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetDriverList();
	    };
	    ;
	    SelectDriverSubscriptionPopupComponent.prototype.OnPagingChange = function (event) {
	        console.log(this.DataListModel);
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetDriverList();
	    };
	    SelectDriverSubscriptionPopupComponent.prototype.OnSuccessSelect = function () {
	    };
	    __decorate([
	        core_1.Output('OnSuccessSelect'), 
	        __metadata('design:type', Object)
	    ], SelectDriverSubscriptionPopupComponent.prototype, "onSuccessSelect", void 0);
	    __decorate([
	        core_1.ViewChild('driverSubscriptionModal'), 
	        __metadata('design:type', Object)
	    ], SelectDriverSubscriptionPopupComponent.prototype, "driverSubscriptionModal", void 0);
	    SelectDriverSubscriptionPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-select-driver-subscription-popup',
	            template: __webpack_require__(1230),
	            providers: [additionalfreeitems_service_1.AdditionalFreeItemService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof additionalfreeitems_service_1.AdditionalFreeItemService !== 'undefined' && additionalfreeitems_service_1.AdditionalFreeItemService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object])
	    ], SelectDriverSubscriptionPopupComponent);
	    return SelectDriverSubscriptionPopupComponent;
	    var _a, _b, _c, _d;
	}());
	exports.SelectDriverSubscriptionPopupComponent = SelectDriverSubscriptionPopupComponent;


/***/ },
/* 1230 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #driverSubscriptionModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n                    <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblSelect' | translate }} {{ 'LblDriver' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <wego-search-list [IsExported]=\"false\" [SearchTerm]=\"DataListModel.searchTerm\" (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center\">\r\n                  {{ 'LblSelect' | translate }}\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('driverName')\">\r\n                  {{ 'LblDriver' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'driverName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('organizationName')\">\r\n                  {{ 'LblOrganization' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'organizationName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('sharedVehicleGroup')\">\r\n                  {{ 'LblSharedVehicleGroup' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'sharedVehicleGroup'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('subscriptionName')\">\r\n                  {{ 'LblSubscriptionName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'subscriptionName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n\r\n\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let driverSubscription of driverSubscriptionList\">\r\n                  <td class=\"text-center\">\r\n                    <a class=\"cursor-pointer\" (click)=\"select(driverSubscription)\">\r\n                      <i class=\"fa fa-plus-square\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td>{{ driverSubscription.driverName }}</td>\r\n                  <td>{{ driverSubscription.organizationName }}</td>\r\n                  <td>{{ driverSubscription.sharedVehicleGroup }}</td>\r\n                  <td>{{ driverSubscription.subscriptionName }}</td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0\">\r\n                <td class=\"text-center text-danger\" colspan=\"4\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\" [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\"\r\n                firstText=\"&laquo;\" lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 1231 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var flatpickr_directive_1 = __webpack_require__(82);
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var booking_information_model_1 = __webpack_require__(705);
	var router_1 = __webpack_require__(26);
	var flatpickr_model_1 = __webpack_require__(83);
	var unlock_service_1 = __webpack_require__(702);
	var booking_service_1 = __webpack_require__(556);
	var moment = __webpack_require__(84);
	var BookingTripDetailpopupComponent = (function () {
	    function BookingTripDetailpopupComponent(authService, router, translate, unlockService, zone, bookingService) {
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.unlockService = unlockService;
	        this.zone = zone;
	        this.bookingService = bookingService;
	        this.model = new booking_information_model_1.BookingTripDetail();
	        this.dateFormat = "d-m-Y H:i:S";
	        this.onSuccessSave = new core_1.EventEmitter();
	    }
	    BookingTripDetailpopupComponent.prototype.ngOnInit = function () {
	        this.headers = this.authService.GetHeaderForFile();
	        this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
	        this.model.startDateTime = moment().format('DD-MM-YYYY 00:00');
	        this.model.endDateTime = moment().add(+1, 'M').format('DD-MM-YYYY 00:00');
	        this.GetContactTypeGroup();
	    };
	    BookingTripDetailpopupComponent.prototype.SetDefaultFlatPickrConfig = function (isDateOnly) {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = true;
	        flatPickrConfig.enableSeconds = true;
	        flatPickrConfig.time_24hr = true;
	        flatPickrConfig.dateFormat = this.dateFormat;
	        flatPickrConfig.minuteIncrement = 1;
	        return flatPickrConfig;
	    };
	    BookingTripDetailpopupComponent.prototype.show = function () {
	        this.errorMsg = '';
	        this.errorModel = [];
	        var newDate = moment(this.bookingInfoModel.allowedStartDateTime, "DD-MM-YYYY HH:mm:ss").toDate();
	        this.flatPickrConfigStartDate.SetOption("minDate", newDate);
	        this.model.BookingHashId = this.bookingHashId;
	        this.bookingTripDetailModal.show();
	    };
	    BookingTripDetailpopupComponent.prototype.OnFromDateChange = function (value) {
	        if (value) {
	            var format = 'DD-MM-YYYY HH:mm:ss';
	            var newDate = moment(value, format).toDate();
	            var endDate = moment(this.model.endDateTime, format).toDate();
	            var endDateVal = moment(value, format);
	            if (endDate < newDate) {
	                endDateVal = endDateVal.add('H', 1);
	                this.flatPickrConfigEndDate.ChangeValue(endDateVal.format('DD-MM-YYYY HH:mm:ss'));
	            }
	            this.flatPickrConfigEndDate.SetOption("minDate", newDate);
	        }
	    };
	    BookingTripDetailpopupComponent.prototype.GetContactTypeGroup = function () {
	        var _this = this;
	        this.unlockService.GetContactTypeGroupList(this.bookingHashId)
	            .subscribe(function (res) {
	            _this.contractTypeGroupList = res.data;
	        }, function (error) {
	        });
	    };
	    BookingTripDetailpopupComponent.prototype.hide = function () {
	        this.model = new booking_information_model_1.BookingTripDetail();
	        this.bookingTripDetailModal.hide();
	    };
	    BookingTripDetailpopupComponent.prototype.OnSuccessSave = function () {
	        this.hide();
	        var successMsg = this.translate.instant('LblTripSuccess');
	        this.onSuccessSave.emit({ SuccessMessage: successMsg });
	    };
	    BookingTripDetailpopupComponent.prototype.OnSubmit = function (forms) {
	        var _this = this;
	        console.log(this.model);
	        if (this.model) {
	            this.bookingService.UpdateBookingTrip(this.model).subscribe(function (res) {
	                _this.isLoading = false;
	                if (res.data) {
	                    _this.OnSuccessSave();
	                }
	                else {
	                    _this.errorModel = res.error;
	                    _this.errorMsg = res.error;
	                }
	            }, function (error) {
	                _this.errorMsg = _this.authService.HandleErrorStatusCode(error);
	                _this.isLoading = false;
	            });
	        }
	    };
	    __decorate([
	        core_1.ViewChild('bookingTripDetailModal'), 
	        __metadata('design:type', Object)
	    ], BookingTripDetailpopupComponent.prototype, "bookingTripDetailModal", void 0);
	    __decorate([
	        core_1.ViewChild('flatPickrConfigStartDate'), 
	        __metadata('design:type', (typeof (_a = typeof flatpickr_directive_1.FlatPickrDirective !== 'undefined' && flatpickr_directive_1.FlatPickrDirective) === 'function' && _a) || Object)
	    ], BookingTripDetailpopupComponent.prototype, "flatPickrConfigStartDate", void 0);
	    __decorate([
	        core_1.ViewChild('flatPickrConfigEndDate'), 
	        __metadata('design:type', (typeof (_b = typeof flatpickr_directive_1.FlatPickrDirective !== 'undefined' && flatpickr_directive_1.FlatPickrDirective) === 'function' && _b) || Object)
	    ], BookingTripDetailpopupComponent.prototype, "flatPickrConfigEndDate", void 0);
	    __decorate([
	        core_1.Output('OnSuccessSave'), 
	        __metadata('design:type', Object)
	    ], BookingTripDetailpopupComponent.prototype, "onSuccessSave", void 0);
	    __decorate([
	        core_1.Input('BookingHashId'), 
	        __metadata('design:type', Object)
	    ], BookingTripDetailpopupComponent.prototype, "bookingHashId", void 0);
	    __decorate([
	        core_1.Input('BookingInfoModel'), 
	        __metadata('design:type', Object)
	    ], BookingTripDetailpopupComponent.prototype, "bookingInfoModel", void 0);
	    BookingTripDetailpopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-bookingtrip-detail-popup',
	            template: __webpack_require__(1232),
	        }), 
	        __metadata('design:paramtypes', [(typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _e) || Object, (typeof (_f = typeof unlock_service_1.UnlockService !== 'undefined' && unlock_service_1.UnlockService) === 'function' && _f) || Object, (typeof (_g = typeof core_1.NgZone !== 'undefined' && core_1.NgZone) === 'function' && _g) || Object, (typeof (_h = typeof booking_service_1.BookingService !== 'undefined' && booking_service_1.BookingService) === 'function' && _h) || Object])
	    ], BookingTripDetailpopupComponent);
	    return BookingTripDetailpopupComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h;
	}());
	exports.BookingTripDetailpopupComponent = BookingTripDetailpopupComponent;


/***/ },
/* 1232 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #bookingTripDetailModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n                    <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblBookingTripDetail' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <form (ngSubmit)=\"OnSubmit(bookingTripDetailModal.value)\" #bookingTripDetailModal=\"ngForm\">\r\n          <input type=\"hidden\" class=\"form-control\" [(ngModel)]=\"model.id\" name=\"bookingTripid\">\r\n\r\n          <div class=\"form-group col-md-4\">\r\n            <label> <span class=\"text text-danger\">*</span>{{ 'LblContractTypeGroup' | translate }} </label>\r\n            <select [(ngModel)]=\"model.contractTypeGroupHashId\" name=\"contractTypeGroupHashId\" class=\"form-control\">\r\n            <option  value=\"\">{{ 'LblSelect' | translate }} {{ 'LblContractTypeGroup' | translate }}</option>\r\n            <option *ngFor=\"let inst of contractTypeGroupList\"  [ngValue]='inst.contactTypeGroupHashId' >{{inst.contactTypeGroupName}}</option>\r\n          </select>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'contractTypeGroupHashId' }}</span>\r\n          </div>\r\n\r\n          <div class=\"form-group col-md-3\">\r\n            <label><span class=\"text text-danger\">*</span>{{ 'LblStartDateTime' | translate }}</label>\r\n            <div class=\"input-group\">\r\n              <span class=\"input-group-addon\"><i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i></span>\r\n              <input  #flatPickrConfigStartDate=\"wego-flatpickr\" flatpickr readonly [Config]=\"flatPickrConfigFrom\" name=\"startDateTime1\" type=\"text\" class=\"form-control\" [(ngModel)]=\"model.startDateTime\"\r\n                placeholder=\"{{ 'LblStartDateTime' | translate }}\"  (change)=\"OnFromDateChange($event.target.value)\">\r\n            </div>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'startDateTime' }}</span>\r\n          </div>\r\n\r\n\r\n          <div class=\"form-group col-md-3\">\r\n            <label><span class=\"text text-danger\">*</span>{{ 'LblEndDateTime' | translate }}</label>\r\n            <div class=\"input-group\">\r\n              <span class=\"input-group-addon\"><i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i></span>\r\n              <input #flatPickrConfigEndDate=\"wego-flatpickr\"  flatpickr readonly [Config]=\"flatPickrConfigTo\" [(ngModel)]=\"model.endDateTime\" name=\"endDateTime1\" type=\"text\" class=\"form-control\"\r\n                placeholder=\"{{ 'LblEndDateTime' | translate }}\">\r\n            </div>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'endDateTime' }}</span>\r\n          </div>\r\n\r\n          <div class=\"form-group col-md-2\">\r\n            <label> <span class=\"text text-danger\">*</span>{{ 'LblDistance' | translate }} (KM)</label>\r\n            <div>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblDistance' | translate }}\" [(ngModel)]=\"model.distance\" name=\"distance\">\r\n            </div>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'distance' }}</span>\r\n          </div>\r\n\r\n          <div class=\"row\">\r\n            <div class=\"col-sm-12\">\r\n              <hr>\r\n              <a class=\"btn btn-gray cursor-pointer\" (click)=\"hide()\">{{ 'LblCancel' | translate }}</a> &nbsp;&nbsp;\r\n              <button class=\"btn btn-green\" type=\"submit\">{{ 'LblSave' | translate }}</button>\r\n            </div>\r\n          </div>\r\n        </form>\r\n        <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 1233 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var modal_1 = __webpack_require__(537);
	var core_1 = __webpack_require__(3);
	var translate_1 = __webpack_require__(631);
	var ImagePopupComponent = (function () {
	    function ImagePopupComponent(translate) {
	        this.translate = translate;
	        this._popupTitle = this.translate.instant('LblConfirm');
	    }
	    ImagePopupComponent.prototype.ngOnInit = function () {
	    };
	    ImagePopupComponent.prototype.show = function () {
	        this.confirmModal.show();
	    };
	    ImagePopupComponent.prototype.hide = function () {
	        this.confirmModal.hide();
	    };
	    ImagePopupComponent.prototype.ngOnDestroy = function () {
	    };
	    __decorate([
	        core_1.ViewChild('imageModal'), 
	        __metadata('design:type', (typeof (_a = typeof modal_1.ModalDirective !== 'undefined' && modal_1.ModalDirective) === 'function' && _a) || Object)
	    ], ImagePopupComponent.prototype, "confirmModal", void 0);
	    __decorate([
	        core_1.Input('imagepath'), 
	        __metadata('design:type', String)
	    ], ImagePopupComponent.prototype, "imagepath", void 0);
	    ImagePopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-image-popup',
	            template: "\n  <div bsModal #imageModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" \n  aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\"  [config]=\"{backdrop: false, keyboard: false}\">\n    <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\" style=\"border: none;\">\n                <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\n                    <span aria-hidden=\"true\">&times;</span></button>\n                <h4 class=\"modal-title\">{{ popupTitle }}</h4>\n            </div>\n            <div class=\"modal-body\" style=\"height: 100%;min-height: 100%;text-align: center;\">           \n                 <img *ngIf=\"imagepath\" [src]=\"imagepath\"  style=\"max-width: 100%;max-height: 100%;\"> \n            </div>            \n        </div>\n    </div>\n  </div>"
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof translate_1.TranslateService !== 'undefined' && translate_1.TranslateService) === 'function' && _b) || Object])
	    ], ImagePopupComponent);
	    return ImagePopupComponent;
	    var _a, _b;
	}());
	exports.ImagePopupComponent = ImagePopupComponent;


/***/ },
/* 1234 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var booking_information_model_1 = __webpack_require__(705);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var booking_service_1 = __webpack_require__(556);
	var cost_expense_service_1 = __webpack_require__(1010);
	var moment = __webpack_require__(84);
	var BookingExpensePopupComponent = (function () {
	    function BookingExpensePopupComponent(authService, router, translate, zone, bookingService, costAndExpenseService) {
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.zone = zone;
	        this.bookingService = bookingService;
	        this.costAndExpenseService = costAndExpenseService;
	        this.model = new booking_information_model_1.Expense();
	        this.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
	        this.onSuccessSave = new core_1.EventEmitter();
	    }
	    BookingExpensePopupComponent.prototype.ngOnInit = function () {
	        this.headers = this.authService.GetHeaderForFile();
	        this.GetVatSettingDropdownList();
	    };
	    BookingExpensePopupComponent.prototype.show = function () {
	        this.errorMsg = '';
	        this.errorModel = [];
	        this.bookingExpenseModal.show();
	        this.GetCostTypeList();
	    };
	    BookingExpensePopupComponent.prototype.hide = function () {
	        this.model = new booking_information_model_1.Expense();
	        this.bookingExpenseModal.hide();
	    };
	    BookingExpensePopupComponent.prototype.OnSuccessSave = function () {
	        this.hide();
	        var successMsg = this.translate.instant('LblExpenseSuccess');
	        this.onSuccessSave.emit({ SuccessMessage: successMsg });
	    };
	    BookingExpensePopupComponent.prototype.OnSubmit = function (forms) {
	        var _this = this;
	        if (this.model) {
	            this.bookingService.UpdateUserExpense(this.model).subscribe(function (res) {
	                _this.isLoading = false;
	                if (res.data) {
	                    _this.OnSuccessSave();
	                }
	                else {
	                    _this.errorModel = res.error;
	                    _this.errorMsg = res.error;
	                }
	            }, function (error) {
	                _this.errorMsg = _this.authService.HandleErrorStatusCode(error);
	                _this.isLoading = false;
	            });
	        }
	    };
	    BookingExpensePopupComponent.prototype.GetVatSettingDropdownList = function () {
	        var _this = this;
	        this.bookingService.GetVatSettingDropdownList(this.bookingHashId).subscribe(function (res) {
	            if (res.data) {
	                _this.vatSettingList = res.data;
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.errorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    BookingExpensePopupComponent.prototype.GetVatSettingDefaultValues = function () {
	        var _this = this;
	        this.bookingService
	            .GetVatSettingDefaultValues(this.bookingHashId)
	            .subscribe(function (res) {
	            if (res.data) {
	                var vatSettingDefaultValues = res.data;
	                _this.vatSettingDefaultCost =
	                    vatSettingDefaultValues.vatSettingDefaultCost;
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.errorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    BookingExpensePopupComponent.prototype.GetCostTypeList = function () {
	        var _this = this;
	        this.costAndExpenseService.GetDropdownCostTypeList().subscribe(function (res) {
	            _this.costTypeList = res.data;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    BookingExpensePopupComponent.prototype.SetVatDefaultCost = function (vatSettingDefaultCost) {
	        return vatSettingDefaultCost
	            ? this.translate.instant('LblExcludingVat')
	            : this.translate.instant('LblIncludingVat');
	    };
	    __decorate([
	        core_1.ViewChild('bookingExpenseModal'), 
	        __metadata('design:type', Object)
	    ], BookingExpensePopupComponent.prototype, "bookingExpenseModal", void 0);
	    __decorate([
	        core_1.Output('OnSuccessSave'), 
	        __metadata('design:type', Object)
	    ], BookingExpensePopupComponent.prototype, "onSuccessSave", void 0);
	    __decorate([
	        core_1.Input('BookingInfoModel'), 
	        __metadata('design:type', Object)
	    ], BookingExpensePopupComponent.prototype, "bookingInfoModel", void 0);
	    __decorate([
	        core_1.Input('BookingHashId'), 
	        __metadata('design:type', String)
	    ], BookingExpensePopupComponent.prototype, "bookingHashId", void 0);
	    BookingExpensePopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-booking-expense-popup',
	            template: __webpack_require__(1235),
	            providers: [cost_expense_service_1.CostAndExpenseService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _c) || Object, (typeof (_d = typeof core_1.NgZone !== 'undefined' && core_1.NgZone) === 'function' && _d) || Object, (typeof (_e = typeof booking_service_1.BookingService !== 'undefined' && booking_service_1.BookingService) === 'function' && _e) || Object, (typeof (_f = typeof cost_expense_service_1.CostAndExpenseService !== 'undefined' && cost_expense_service_1.CostAndExpenseService) === 'function' && _f) || Object])
	    ], BookingExpensePopupComponent);
	    return BookingExpensePopupComponent;
	    var _a, _b, _c, _d, _e, _f;
	}());
	exports.BookingExpensePopupComponent = BookingExpensePopupComponent;


/***/ },
/* 1235 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #bookingExpenseModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblBookingExpenseDetail' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <form (ngSubmit)=\"OnSubmit(bookingExpenseModal.value)\" #bookingTripDetailModal=\"ngForm\">\r\n          <div class=\"form-group col-md-4\">\r\n            <label>\r\n              <span class=\"text text-danger\">*</span>{{ 'LblCostType' | translate }}</label>\r\n            <div>\r\n              <select [(ngModel)]=\"model.costTypeHashId\" class=\"form-control\" name=\"costTypeHashId\">\r\n                <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblCostType' | translate }}</option>\r\n                <option *ngFor=\"let item of costTypeList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\r\n              </select>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'costTypeHashId' }}</span>\r\n              <!-- <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblExpenseName' | translate }}\" [(ngModel)]=\"model.expenseName\"\r\n                name=\"expenseName\" maxlength=\"50\"> -->\r\n            </div>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'expenseName' }}</span>\r\n          </div>\r\n          <div class=\"form-group col-md-4\">\r\n            <label>\r\n              <span class=\"text text-danger\">*</span>{{ 'LblExpenseAmount' | translate }}</label>\r\n            <div class=\"input-group\">\r\n              <span *ngIf=\"model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblExpenseAmount' | translate }}\" [(ngModel)]=\"model.reportedAmountExVat\"\r\n                name=\"reportedAmountExVat\" maxlength=\"7\">\r\n              <span *ngIf=\"!model.isCurrencySymbolBefore\" class=\"input-group-addon\">{{model.currencySymbol}}</span>\r\n            </div>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'reportedAmountExVat' }}</span>\r\n          </div>\r\n          <div class=\"form-group col-md-4\">\r\n            <label>\r\n              <span class=\"text text-danger\">*</span>{{ 'LblExpenseAmountVat' | translate }}</label>\r\n            <div>\r\n              <select [(ngModel)]=\"model.reportedVatPercentage\" name=\"reportedVatPercentage\" class=\"form-control\">\r\n                <option *ngFor=\"let item of vatSettingList\" [value]='item.value'>{{item.data}}</option>\r\n              </select>\r\n            </div>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'amount' }}</span>\r\n          </div>\r\n          <div class=\"form-group col-md-4\">\r\n            <label>\r\n              <span class=\"text text-danger\">*</span>{{ 'LblDescription' | translate }}</label>\r\n            <div>\r\n              <textarea type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblDescription' | translate }}\" [(ngModel)]=\"model.description\"\r\n                name=\"description\"> </textarea>\r\n            </div>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'description' }}</span>\r\n          </div>\r\n          <div class=\"row\">\r\n            <div class=\"col-sm-12\">\r\n              <hr>\r\n              <a class=\"btn btn-gray cursor-pointer\" (click)=\"hide()\">{{ 'LblCancel' | translate }}</a> &nbsp;&nbsp;\r\n              <button class=\"btn btn-green\" type=\"submit\">{{ 'LblSave' | translate }}</button>\r\n            </div>\r\n          </div>\r\n        </form>\r\n        <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 1236 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var freebookingmodel_1 = __webpack_require__(1237);
	var booking_service_1 = __webpack_require__(556);
	var moment = __webpack_require__(84);
	var FreeBookingpopupComponent = (function () {
	    function FreeBookingpopupComponent(authService, router, translate, zone, bookingService) {
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.zone = zone;
	        this.bookingService = bookingService;
	        this.model = new freebookingmodel_1.FreeBooking();
	        this.onSuccessSave = new core_1.EventEmitter();
	    }
	    FreeBookingpopupComponent.prototype.ngOnInit = function () {
	        this.model = new freebookingmodel_1.FreeBooking();
	    };
	    FreeBookingpopupComponent.prototype.show = function () {
	        this.errorMsg = '';
	        this.errorModel = [];
	        this.freebookingModal.show();
	    };
	    FreeBookingpopupComponent.prototype.hide = function () {
	        this.model = new freebookingmodel_1.FreeBooking();
	        this.freebookingModal.hide();
	    };
	    FreeBookingpopupComponent.prototype.OnSuccessSave = function () {
	        this.hide();
	        var successMsg = this.translate.instant('LblFreeBookingSuccess');
	        this.onSuccessSave.emit({ SuccessMessage: successMsg });
	    };
	    FreeBookingpopupComponent.prototype.OnSubmit = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.bookingService.UpdateFreeBooking(this.model).subscribe(function (res) {
	            _this.isLoading = false;
	            if (res.data) {
	                _this.OnSuccessSave();
	            }
	            else {
	                _this.errorModel = res.error;
	                _this.errorMsg = res.error;
	            }
	        }, function (error) {
	            _this.errorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    __decorate([
	        core_1.ViewChild('freebookingModal'), 
	        __metadata('design:type', Object)
	    ], FreeBookingpopupComponent.prototype, "freebookingModal", void 0);
	    __decorate([
	        core_1.Output('OnSuccessSave'), 
	        __metadata('design:type', Object)
	    ], FreeBookingpopupComponent.prototype, "onSuccessSave", void 0);
	    __decorate([
	        core_1.Input('BookingHashId'), 
	        __metadata('design:type', Object)
	    ], FreeBookingpopupComponent.prototype, "bookingHashId", void 0);
	    FreeBookingpopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-free-booking-popup',
	            template: __webpack_require__(1238),
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _c) || Object, (typeof (_d = typeof core_1.NgZone !== 'undefined' && core_1.NgZone) === 'function' && _d) || Object, (typeof (_e = typeof booking_service_1.BookingService !== 'undefined' && booking_service_1.BookingService) === 'function' && _e) || Object])
	    ], FreeBookingpopupComponent);
	    return FreeBookingpopupComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.FreeBookingpopupComponent = FreeBookingpopupComponent;


/***/ },
/* 1237 */
/***/ function(module, exports) {

	"use strict";
	var FreeBooking = (function () {
	    function FreeBooking() {
	    }
	    return FreeBooking;
	}());
	exports.FreeBooking = FreeBooking;


/***/ },
/* 1238 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #freebookingModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-sm\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n                    <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\"> {{ 'LblFreeBooking' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <div class=\"form-group col-md-12\">\r\n          <label> <span class=\"text text-danger\">*</span>{{ 'LblBookingCustomFee' | translate }}</label>\r\n          <div>\r\n            <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblBookingCustomFee' | translate }}\" [(ngModel)]=\"model.bookingCustomFee\" name=\"bookingCustomFee\" maxlength=\"9\">\r\n          </div>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'bookingCustomFee' }}</span>\r\n          <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'bookingHashId' }}</span>\r\n\r\n        </div>\r\n\r\n        <div class=\"row\">\r\n          <div class=\"col-sm-12\">\r\n            <hr>\r\n            <a class=\"btn btn-gray cursor-pointer\" (click)=\"hide()\">{{ 'LblCancel' | translate }}</a> &nbsp;&nbsp;\r\n            <button class=\"btn btn-green\" type=\"button\" (click)=\"OnSubmit()\">{{ 'LblSave' | translate }}</button>\r\n          </div>\r\n        </div>\r\n        <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 1239 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var modal_1 = __webpack_require__(537);
	var core_1 = __webpack_require__(3);
	var translate_service_1 = __webpack_require__(70);
	var $ = __webpack_require__(68);
	var moment = __webpack_require__(84);
	var fullCalendar = __webpack_require__(586);
	var CalanderPopupComponent = (function () {
	    function CalanderPopupComponent(translate) {
	        this.translate = translate;
	    }
	    CalanderPopupComponent.prototype.ngOnInit = function () {
	        var _this = this;
	        var LblWeekdays = this.translate.instant("LblWeekdays");
	        var LblMonths = this.translate.instant("LblMonths");
	        var LblButtonText = this.translate.instant("LblButtonText");
	        $("#calendar").fullCalendar({
	            header: {
	                left: "prev,today,next ",
	                center: "title",
	                right: "month,agendaWeek,agendaDay"
	            },
	            displayEventEnd: {
	                month: true,
	                basicWeek: true,
	                default: true
	            },
	            eventRender: function (event, element) {
	                element.attr("href", "javascript:void(0);");
	                element.click(function () {
	                    event.licenceTag = _this.licenceTag;
	                    _this.bookingInfoModel.bookingInfo = event;
	                    _this.bookingInfoModel.show();
	                });
	            },
	            //locale: currentLang,
	            buttonText: LblButtonText,
	            monthNames: LblMonths.longhand,
	            monthNamesShort: LblMonths.shorthand,
	            dayNames: LblWeekdays.longhand,
	            dayNamesShort: LblWeekdays.shorthand,
	            navLinks: true,
	            editable: false,
	            eventLimit: true // allow "more" link when too many events
	        });
	    };
	    CalanderPopupComponent.prototype.show = function () {
	        this.confirmModal.show();
	        $("#calendar").fullCalendar("removeEvents");
	        $("#calendar").fullCalendar("addEventSource", {
	            events: this.occupiedTime
	        });
	        $("#calendar").fullCalendar("render");
	        $("#calendar").fullCalendar("refetchEvents");
	    };
	    CalanderPopupComponent.prototype.hide = function () {
	        this.confirmModal.hide();
	    };
	    CalanderPopupComponent.prototype.ngOnDestroy = function () { };
	    __decorate([
	        core_1.ViewChild("calanderModal"), 
	        __metadata('design:type', (typeof (_a = typeof modal_1.ModalDirective !== 'undefined' && modal_1.ModalDirective) === 'function' && _a) || Object)
	    ], CalanderPopupComponent.prototype, "confirmModal", void 0);
	    __decorate([
	        core_1.ViewChild("bookingInfoModel"), 
	        __metadata('design:type', Object)
	    ], CalanderPopupComponent.prototype, "bookingInfoModel", void 0);
	    __decorate([
	        core_1.Input("occupiedTime"), 
	        __metadata('design:type', Object)
	    ], CalanderPopupComponent.prototype, "occupiedTime", void 0);
	    __decorate([
	        core_1.Input("licenceTag"), 
	        __metadata('design:type', String)
	    ], CalanderPopupComponent.prototype, "licenceTag", void 0);
	    __decorate([
	        core_1.Input("driverName"), 
	        __metadata('design:type', String)
	    ], CalanderPopupComponent.prototype, "driverName", void 0);
	    __decorate([
	        core_1.Input("email"), 
	        __metadata('design:type', String)
	    ], CalanderPopupComponent.prototype, "email", void 0);
	    __decorate([
	        core_1.Input("mobileNumber"), 
	        __metadata('design:type', String)
	    ], CalanderPopupComponent.prototype, "mobileNumber", void 0);
	    __decorate([
	        core_1.Input("bookingReferenceId"), 
	        __metadata('design:type', String)
	    ], CalanderPopupComponent.prototype, "bookingReferenceId", void 0);
	    __decorate([
	        core_1.Input("popupTitle"), 
	        __metadata('design:type', String)
	    ], CalanderPopupComponent.prototype, "popupTitle", void 0);
	    CalanderPopupComponent = __decorate([
	        core_1.Component({
	            selector: "wego-calander-popup",
	            template: "\n  <div bsModal #calanderModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" \n  aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\"  [config]=\"{backdrop: false, keyboard: false}\">\n    <div class=\"modal-dialog modal-lg\">\n        <div class=\"modal-content\">\n            <div class=\"modal-header\" style=\"border: 0px;padding-bottom: 0px;\">\n                <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\n                    <span aria-hidden=\"true\">&times;</span></button>\n                <h4 class=\"modal-title\"><strong>{{ popupTitle }}</strong></h4>    \n                <h5 class=\"modal-title\">{{ licenceTag }}</h5>  \n                <h5 class=\"modal-title\">{{ driverName }}</h5>\n                <h5 class=\"modal-title\">{{ email }}</h5>   \n                <h5 class=\"modal-title\">{{ mobileNumber }}</h5>      \n              </div>      \n                       \n            <div class=\"modal-body\" style=\"padding-top: 0px;\">    \n                  <div class=\"row\">\n                  <div class=\"col-sm-12\" style=\"padding: 10px 10px;\">\n                    <div id=\"calendar\"></div>\n                  </div>\n                </div>\n            </div>            \n        </div>\n    </div>\n  </div>\n  <booking-info-popup #bookingInfoModel></booking-info-popup>"
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _b) || Object])
	    ], CalanderPopupComponent);
	    return CalanderPopupComponent;
	    var _a, _b;
	}());
	exports.CalanderPopupComponent = CalanderPopupComponent;


/***/ },
/* 1240 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var modal_1 = __webpack_require__(537);
	var core_1 = __webpack_require__(3);
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var BookingInfoPopupComponent = (function () {
	    function BookingInfoPopupComponent(translate, authService, router) {
	        this.translate = translate;
	        this.authService = authService;
	        this.router = router;
	        this._popupTitle = this.translate.instant('LblConfirm');
	        this.onConfirm = new core_1.EventEmitter();
	    }
	    Object.defineProperty(BookingInfoPopupComponent.prototype, "bookingInfo", {
	        get: function () { return this._bookingInfo; },
	        set: function (bookingInfo) {
	            this._bookingInfo = bookingInfo;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(BookingInfoPopupComponent.prototype, "popupTitle", {
	        get: function () { return this._popupTitle; },
	        set: function (popupTitle) {
	            this._popupTitle = (popupTitle && popupTitle.trim()) || this.translate.instant('LblConfirm');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    BookingInfoPopupComponent.prototype.ngOnInit = function () {
	        this.urlBookingInformation = this.authService.GetURL(config_1.ApplicationRouteURL.URL_BOOKING_INFORMATION);
	        this.isDriver = this.authService.IsDriver();
	    };
	    BookingInfoPopupComponent.prototype.show = function () {
	        this.bookingInfoModel.show();
	        this.bookingInfoLink = new config_1.WeGoAuthorizedLink(this.urlBookingInformation + "/" + this.bookingInfo.bookingHashId, config_1.Permission.PR_BOOKINGS_OVERVIEW, config_1.PermissionType.VIEW, '', this.bookingInfo.bookingReferenceID, "", "", true, "");
	    };
	    BookingInfoPopupComponent.prototype.hide = function () {
	        this.bookingInfoModel.hide();
	    };
	    BookingInfoPopupComponent.prototype.Confirm = function ($event) {
	        this.onConfirm.emit($event);
	    };
	    BookingInfoPopupComponent.prototype.ngOnDestroy = function () {
	    };
	    __decorate([
	        core_1.ViewChild('bookingInfoModel'), 
	        __metadata('design:type', (typeof (_a = typeof modal_1.ModalDirective !== 'undefined' && modal_1.ModalDirective) === 'function' && _a) || Object)
	    ], BookingInfoPopupComponent.prototype, "bookingInfoModel", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object), 
	        __metadata('design:paramtypes', [Object])
	    ], BookingInfoPopupComponent.prototype, "bookingInfo", null);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String), 
	        __metadata('design:paramtypes', [String])
	    ], BookingInfoPopupComponent.prototype, "popupTitle", null);
	    __decorate([
	        core_1.Output('onConfirm'), 
	        __metadata('design:type', Object)
	    ], BookingInfoPopupComponent.prototype, "onConfirm", void 0);
	    BookingInfoPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'booking-info-popup',
	            styles: ["\n     .table th, .table td { \n        border-top: none !important;\n        border-left: none !important;\n      }\n      #bookingInfobody .col-sm-5 {\n        padding-right: 1px;\n      }\n      #bookingInfobody .col-sm-7 {\n        padding-right: 1px;\n      }\n    "
	            ],
	            template: " <div bsModal #bookingInfoModel=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" \n  aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\n    <div class=\"modal-dialog modal-sm\" >\n <div class=\"modal-content\" style=\"border-radius: 25px;\">            \n  <div *ngIf=\"bookingInfo\" class=\"modal-body\" id=\"bookingInfobody\">\n              <div class=\"row\">\n              <div class=\"col-sm-5\"><strong>{{ 'LblBooking' | translate }}</strong></div>\n              <div *ngIf=\"!isDriver\" class=\"col-sm-7\">       \n                <wego-authorized-link [LinkModel]=\"bookingInfoLink\"></wego-authorized-link>\n               </div>\n              <div *ngIf=\"isDriver\" class=\"col-sm-7\"> {{ bookingInfo.bookingReferenceID }}</div>\n              </div>\n              <div class=\"row\">\n              <div class=\"col-sm-5\"><strong>{{ 'LblFrom' | translate }}</strong></div>\n              <div class=\"col-sm-7\">{{ bookingInfo.startDateTime }}</div>\n              </div>\n              <div class=\"row\">\n              <div class=\"col-sm-5\"><strong>{{ 'LblTo' | translate }}</strong></div>\n              <div class=\"col-sm-7\">{{ bookingInfo.endDateTime }}</div>\n              </div>\n              <div class=\"row\">\n              <div class=\"col-sm-5\"><strong>{{ 'LblLicenceTag' | translate }}</strong></div>\n              <div class=\"col-sm-7\">{{ bookingInfo.licenceTag }}</div>\n              </div>\n              <div *ngIf=\"bookingInfo.driverName\" class=\"row\">\n              <div class=\"col-sm-5\"><strong>{{ 'LblDriver' | translate }}</strong></div>\n              <div class=\"col-sm-7\">{{ bookingInfo.driverName }}</div>\n              </div>\n              <div *ngIf=\"bookingInfo.mobile\" class=\"row\">\n              <div class=\"col-sm-5\"><strong>{{ 'LblMobile' | translate }}</strong></div>\n              <div class=\"col-sm-7\">{{ bookingInfo.mobile }}</div>\n              </div>\n              <div *ngIf=\"bookingInfo.email\" class=\"row\">\n              <div class=\"col-sm-5\"><strong>{{ 'LblEmail' | translate }}</strong></div>\n              <div class=\"col-sm-7\" style=\"word-wrap: break-word;\">{{ bookingInfo.email }}</div>\n        </div>       \n       </div>\n            <div class=\"modal-footer\">\n                <button type=\"button\" class=\"btn btn-green\" (click)=\"hide($event)\">{{ 'LblOK' | translate }}</button>                \n            </div>\n        </div>\n    </div>\n  </div>"
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object])
	    ], BookingInfoPopupComponent);
	    return BookingInfoPopupComponent;
	    var _a, _b, _c, _d;
	}());
	exports.BookingInfoPopupComponent = BookingInfoPopupComponent;


/***/ },
/* 1241 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var signup_list_model_1 = __webpack_require__(914);
	var signup_list_service_1 = __webpack_require__(913);
	var moment = __webpack_require__(84);
	var ConfirmSignupPopupComponent = (function () {
	    function ConfirmSignupPopupComponent(authService, router, translate, zone, signupListService) {
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.zone = zone;
	        this.signupListService = signupListService;
	        this.onSuccessSave = new core_1.EventEmitter();
	    }
	    Object.defineProperty(ConfirmSignupPopupComponent.prototype, "model", {
	        get: function () { return this._model; },
	        set: function (_signupOverviewList) {
	            this._model = _signupOverviewList;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ConfirmSignupPopupComponent.prototype.ngOnInit = function () {
	    };
	    ConfirmSignupPopupComponent.prototype.show = function () {
	        this.errorMsg = '';
	        this.errorModel = [];
	        this.approvalSignupModel.show();
	    };
	    ConfirmSignupPopupComponent.prototype.hide = function () {
	        this.model = new signup_list_model_1.SignupOverviewList();
	        this.approvalSignupModel.hide();
	    };
	    ConfirmSignupPopupComponent.prototype.OnSuccessSave = function () {
	        this.hide();
	        var successMsg = this.translate.instant('LblSuccess');
	        this.onSuccessSave.emit({ SuccessMessage: successMsg });
	    };
	    ConfirmSignupPopupComponent.prototype.OnSubmit = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.signupListService.AcceptRejectSignup(this.model, true, false).subscribe(function (res) {
	            _this.isLoading = false;
	            _this.OnSuccessSave();
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    ConfirmSignupPopupComponent.prototype.OnReject = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.signupListService.AcceptRejectSignup(this.model, false, true).subscribe(function (res) {
	            _this.isLoading = false;
	            _this.OnSuccessSave();
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    __decorate([
	        core_1.ViewChild('approvalSignupModel'), 
	        __metadata('design:type', Object)
	    ], ConfirmSignupPopupComponent.prototype, "approvalSignupModel", void 0);
	    __decorate([
	        core_1.Output('OnSuccessSave'), 
	        __metadata('design:type', Object)
	    ], ConfirmSignupPopupComponent.prototype, "onSuccessSave", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof signup_list_model_1.SignupOverviewList !== 'undefined' && signup_list_model_1.SignupOverviewList) === 'function' && _a) || Object), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof signup_list_model_1.SignupOverviewList !== 'undefined' && signup_list_model_1.SignupOverviewList) === 'function' && _b) || Object])
	    ], ConfirmSignupPopupComponent.prototype, "model", null);
	    ConfirmSignupPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'confirm-signup-popup',
	            template: __webpack_require__(1242),
	        }), 
	        __metadata('design:paramtypes', [(typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _e) || Object, (typeof (_f = typeof core_1.NgZone !== 'undefined' && core_1.NgZone) === 'function' && _f) || Object, (typeof (_g = typeof signup_list_service_1.SignupListService !== 'undefined' && signup_list_service_1.SignupListService) === 'function' && _g) || Object])
	    ], ConfirmSignupPopupComponent);
	    return ConfirmSignupPopupComponent;
	    var _a, _b, _c, _d, _e, _f, _g;
	}());
	exports.ConfirmSignupPopupComponent = ConfirmSignupPopupComponent;


/***/ },
/* 1242 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #approvalSignupModel=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n                    <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\"> {{ 'LblSignupApproval' | translate }}</h4>\r\n      </div>\r\n      <div *ngIf=\"model\" class=\"modal-body\">\r\n        <form>\r\n          <div class=\"form-group row\">\r\n            <div class=\"col-sm-4\">\r\n              <label>{{ 'LblUserName' | translate }}</label>\r\n            </div>\r\n            <div class=\"col-sm-8\">\r\n              <input type=\"text\" class=\"form-control\" name=\"UserName\" [(ngModel)]=\"model.userName\" disabled>\r\n            </div>\r\n          </div>\r\n          <div class=\"clearfix\"></div>\r\n          <div class=\"form-group row\">\r\n            <div class=\"col-sm-4\">\r\n              <label>\r\n              {{ 'LblEmail' | translate }}\r\n          </label></div>\r\n            <div class=\"col-sm-8\">\r\n              <input type=\"text\" class=\"form-control\" [(ngModel)]=\"model.email\" name=\"Email\" disabled>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-group row\">\r\n            <div class=\"col-sm-4\">\r\n              <label>\r\n              {{ 'LblInstance' | translate }}\r\n          </label>\r\n            </div>\r\n            <div class=\"col-sm-8\">\r\n              <input type=\"text\" class=\"form-control\" [(ngModel)]=\"model.instanceName\" name=\"instanceName\" disabled>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-group row\">\r\n            <div class=\"col-sm-4\">\r\n              <label>\r\n              {{ 'LblSignUpForm' | translate }}\r\n          </label>\r\n            </div>\r\n            <div class=\"col-sm-8\">\r\n              <textarea class=\"form-control\" [(ngModel)]=\"model.signupFormDescription\" name=\"signupFormDescription\" disabled></textarea>\r\n            </div>\r\n          </div>\r\n\r\n          <div class=\"row\">\r\n            <div class=\"col-sm-12 text-right\">\r\n              <hr>\r\n              <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnReject()\">{{ 'LblReject' | translate }}</a> &nbsp;&nbsp;\r\n              <button class=\"btn btn-green\" type=\"button\" (click)=\"OnSubmit()\">{{ 'LblAccept' | translate }}</button>\r\n            </div>\r\n          </div>\r\n        </form>\r\n        <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 1243 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var invoice_model_1 = __webpack_require__(719);
	var moment = __webpack_require__(84);
	var MissingIBANPopupComponent = (function () {
	    function MissingIBANPopupComponent(authService, router, translate, zone) {
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.zone = zone;
	        this.onSuccessSave = new core_1.EventEmitter();
	    }
	    Object.defineProperty(MissingIBANPopupComponent.prototype, "model", {
	        get: function () { return this._model; },
	        set: function (_invoiceList) {
	            this._model = _invoiceList;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    MissingIBANPopupComponent.prototype.ngOnInit = function () {
	    };
	    MissingIBANPopupComponent.prototype.show = function () {
	        this.errorMsg = '';
	        this.errorModel = [];
	        this.missingIBANModel.show();
	    };
	    MissingIBANPopupComponent.prototype.hide = function () {
	        this.model = invoice_model_1.InvoiceModel[0];
	        this.missingIBANModel.hide();
	    };
	    MissingIBANPopupComponent.prototype.OnExport = function (event) {
	        var exportData = this.model.map(function (val) {
	            return {
	                "LblDriverName": val.driverName,
	                "LblInstance": val.instanceName
	            };
	        });
	        this.JSONToCSVConvertor(exportData, "Missing_IBAN", true);
	    };
	    MissingIBANPopupComponent.prototype.JSONToCSVConvertor = function (JSONData, ReportTitle, ShowLabel) {
	        var arrData = typeof JSONData != 'object' ? JSON.parse(JSONData) : JSONData;
	        var CSV = '';
	        if (ShowLabel) {
	            var row = "";
	            //This loop will extract the label from 1st index of on array
	            for (var index in arrData[0]) {
	                //Now convert each value to string and comma-seprated
	                row += this.translate.instant(index) + ',';
	            }
	            row = row.slice(0, -1);
	            CSV += row + '\r\n';
	        }
	        //1st loop is to extract each row
	        for (var i = 0; i < arrData.length; i++) {
	            var row = "";
	            //2nd loop will extract each column and convert it in string comma-seprated
	            for (var index in arrData[i]) {
	                row += '"' + arrData[i][index] + '",';
	            }
	            row.slice(0, row.length - 1);
	            //add a line break after each row
	            CSV += row + '\r\n';
	        }
	        if (CSV == '') {
	            alert("Invalid data");
	            return;
	        }
	        //Generate a file name
	        var fileName = "File_";
	        //this will remove the blank-spaces from the title and replace it with an underscore
	        fileName += ReportTitle.replace(/ /g, "_");
	        //Initialize file format you want csv or xls
	        var uri = 'data:text/csv;charset=utf-8,' + encodeURIComponent(CSV);
	        // Now the little tricky part.
	        // you can use either>> window.open(uri);
	        // but this will not work in some browsers
	        // or you will not get the correct file extension    
	        //this trick will generate a temp a /> tag
	        var link = document.createElement("a");
	        link.href = uri;
	        //set the visibility hidden so it will not effect on your web-layout
	        link.style = "visibility:hidden";
	        link.download = fileName + ".csv";
	        //this part will append the anchor tag and remove it after automatic click
	        document.body.appendChild(link);
	        link.click();
	        document.body.removeChild(link);
	    };
	    MissingIBANPopupComponent.prototype.OnSuccessSave = function () {
	        this.hide();
	        var successMsg = this.translate.instant('LblSuccess');
	        this.onSuccessSave.emit({ SuccessMessage: successMsg });
	    };
	    __decorate([
	        core_1.ViewChild('missingIBANModel'), 
	        __metadata('design:type', Object)
	    ], MissingIBANPopupComponent.prototype, "missingIBANModel", void 0);
	    __decorate([
	        core_1.Output('OnSuccessSave'), 
	        __metadata('design:type', Object)
	    ], MissingIBANPopupComponent.prototype, "onSuccessSave", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array), 
	        __metadata('design:paramtypes', [Array])
	    ], MissingIBANPopupComponent.prototype, "model", null);
	    MissingIBANPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'missing-iban-popup',
	            template: __webpack_require__(1244),
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _c) || Object, (typeof (_d = typeof core_1.NgZone !== 'undefined' && core_1.NgZone) === 'function' && _d) || Object])
	    ], MissingIBANPopupComponent);
	    return MissingIBANPopupComponent;
	    var _a, _b, _c, _d;
	}());
	exports.MissingIBANPopupComponent = MissingIBANPopupComponent;


/***/ },
/* 1244 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #missingIBANModel=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n                    <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\"> {{ 'LblMissingIBANNumber' | translate }}</h4>\r\n      </div>\r\n      <div *ngIf=\"model\" class=\"modal-body\">\r\n        <form>\r\n            <div class=\"table table-responsive mar_bot_ziro\">\r\n                <table class=\"table table-bordered mar_bot_ziro\">\r\n                  <thead>\r\n                    <tr>                    \r\n                      <th class=\"cursor-pointer\" (click)=\"OnSort('firstName')\">\r\n                        {{ 'LblDriverName' | translate }}                        \r\n                      </th>\r\n                      <th class=\"cursor-pointer\" (click)=\"OnSort('lastName')\">\r\n                        {{ 'LblInstance' | translate }}                        \r\n                      </th>                      \r\n                    </tr>\r\n                  </thead>\r\n                  <tbody>                 \r\n                      <tr *ngFor=\"let item of model\">                     \r\n                        <td>{{ item.driverName }}</td>\r\n                        <td>{{ item.instanceName }} </td>                        \r\n                      </tr>                            \r\n                  </tbody>\r\n                </table>\r\n              </div>\r\n          <div class=\"row\">\r\n            <div class=\"col-sm-12 text-right\">\r\n              <hr>\r\n              <button class=\"btn btn-default export-icon\" type=\"button\" (click)=\"OnExport($event)\" title=\"{{'LblExportAll(CSV)' | translate}}\">\r\n                  <i class=\"fa fa-download\" aria-hidden=\"true\"></i>\r\n                </button>\r\n              <a class=\"btn btn-gray cursor-pointer\" (click)=\"hide()\">{{ 'LblCancel' | translate }}</a> &nbsp;&nbsp;\r\n\r\n            </div>\r\n          </div>\r\n        </form>\r\n        <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 1245 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var direct_debit_file_model_1 = __webpack_require__(917);
	var invoice_service_1 = __webpack_require__(723);
	var flatpickr_model_1 = __webpack_require__(83);
	var flatpickr_directive_1 = __webpack_require__(82);
	var moment = __webpack_require__(84);
	var CreateDirectDebitFilePopupComponent = (function () {
	    function CreateDirectDebitFilePopupComponent(authService, router, translate, zone, invoiceService) {
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.zone = zone;
	        this.invoiceService = invoiceService;
	        this.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_FORMAT;
	        this.collectionDate = "";
	        this.onSuccessSave = new core_1.EventEmitter();
	        this.onFormatChange = new core_1.EventEmitter();
	    }
	    Object.defineProperty(CreateDirectDebitFilePopupComponent.prototype, "model", {
	        get: function () { return this._model; },
	        set: function (_directDebitFileList) {
	            this._model = _directDebitFileList;
	            this.InitCompanyArray();
	            if (!this.isFormatChange || this.isDirectDebitClick) {
	                this.format = '';
	                this.selectedCompany = new direct_debit_file_model_1.DirectDebitFileXML();
	                var newDate = moment(this.selectedCompany.minCollectionDate, "DD-MM-YYYY").toDate();
	                this.flatPickrConfigFrom.minDate = newDate;
	                this.collectionDate = this.selectedCompany.minCollectionDate;
	                if (this.flatPickrConfigDate) {
	                    this.flatPickrConfigDate.ChangeValue(this.collectionDate);
	                }
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CreateDirectDebitFilePopupComponent.prototype, "companyDDModel", {
	        get: function () {
	            return this._companyDDModel;
	        },
	        set: function (_directDebitFileList) {
	            if (!this.isFormatChange || this.isDirectDebitClick)
	                this._companyDDModel = _directDebitFileList;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(CreateDirectDebitFilePopupComponent.prototype, "isDirectDebitClick", {
	        get: function () {
	            return this._isDirectDebitClick;
	        },
	        set: function (_IsDirectDebitClick) {
	            this._isDirectDebitClick = _IsDirectDebitClick;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    CreateDirectDebitFilePopupComponent.prototype.ngOnInit = function () {
	        this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
	        this.formatList = [
	            {
	                Key: '',
	                Value: 'Select'
	            },
	            {
	                Key: 'Default',
	                Value: 'Rabobank'
	            },
	            {
	                Key: 'ABN',
	                Value: 'ABN Amro Bank'
	            }];
	    };
	    CreateDirectDebitFilePopupComponent.prototype.SetDefaultFlatPickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = false;
	        flatPickrConfig.time_24hr = true;
	        flatPickrConfig.dateFormat = this.dateFormat;
	        flatPickrConfig.minuteIncrement = 1;
	        flatPickrConfig.disable = [function (date) {
	                return (date.getDay() === 0 || date.getDay() === 6);
	            }];
	        return flatPickrConfig;
	    };
	    CreateDirectDebitFilePopupComponent.prototype.show = function () {
	        this.errorMsg = '';
	        this.errorModel = [];
	        this.createDirectDebitModel.show();
	    };
	    CreateDirectDebitFilePopupComponent.prototype.hide = function () {
	        this.createDirectDebitModel.hide();
	        this.companyDDModel = null;
	        this.model = null;
	        this.onSuccessSave.emit({ SuccessMessage: "" });
	    };
	    CreateDirectDebitFilePopupComponent.prototype.hideModel = function () {
	        this.hide();
	    };
	    CreateDirectDebitFilePopupComponent.prototype.SelectFile = function (event) {
	        var _this = this;
	        if (this.format) {
	            this.selectedCompany = this.model.find(function (x) { return x.id == _this.selectedCompanyid; });
	        }
	    };
	    CreateDirectDebitFilePopupComponent.prototype.OnFormatChange = function (event) {
	        this.isFormatChange = true;
	        this.onFormatChange.emit({ format: this.format });
	    };
	    CreateDirectDebitFilePopupComponent.prototype.OnExport = function () {
	        var _this = this;
	        if (this.collectionDate) {
	            this.errorMsg = "";
	            this.invoiceService.DownloadDirectDebitFile(this.selectedCompany.invoiceId, this.collectionDate, this.format).subscribe(function (res) {
	                if (res && res._body) {
	                    var fileName = "directDebitFile" + new Date().toISOString() + ".xml";
	                    _this.authService.DownloadFile(fileName, res._body);
	                    _this.popupMsg = _this.translate.instant('LblDirectDebitDownloadSuccess');
	                    _this.successPopup.show();
	                    if (_this.model.length == 1) {
	                        _this.createDirectDebitModel.hide();
	                        _this.onSuccessSave.emit({ SuccessMessage: "" });
	                    }
	                    else {
	                        _this._companyDDModel = _this.companyDDModel.filter(function (x) { return x.id != _this.selectedCompanyid; });
	                        _this.model = _this.model.filter(function (x) { return x.id != _this.selectedCompanyid; });
	                        if (_this.model.length == 0) {
	                            _this.createDirectDebitModel.hide();
	                            _this.onSuccessSave.emit({ SuccessMessage: "" });
	                        }
	                        _this.selectedCompanyid = _this.selectedCompany.id;
	                    }
	                }
	                _this.isLoading = false;
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	                _this.isLoading = false;
	            });
	        }
	        else {
	            this.errorMsg = this.translate.instant('LblPleaseEnterCollectionDate');
	            ;
	        }
	    };
	    CreateDirectDebitFilePopupComponent.prototype.InitCompanyArray = function () {
	        if (this.format) {
	            this.selectedCompany = this.model[0];
	        }
	        else {
	            this.selectedCompany = new direct_debit_file_model_1.DirectDebitFileXML();
	        }
	        if (!this.isFormatChange || this.isDirectDebitClick) {
	            if (this.selectedCompany.id) {
	                this.selectedCompanyid = this.selectedCompany.id;
	            }
	            else if (this.companyDDModel.length > 0) {
	                this.selectedCompanyid = this.companyDDModel[0].id;
	            }
	        }
	    };
	    __decorate([
	        core_1.ViewChild('flatPickrConfigDate'), 
	        __metadata('design:type', (typeof (_a = typeof flatpickr_directive_1.FlatPickrDirective !== 'undefined' && flatpickr_directive_1.FlatPickrDirective) === 'function' && _a) || Object)
	    ], CreateDirectDebitFilePopupComponent.prototype, "flatPickrConfigDate", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], CreateDirectDebitFilePopupComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.ViewChild('createDirectDebitModel'), 
	        __metadata('design:type', Object)
	    ], CreateDirectDebitFilePopupComponent.prototype, "createDirectDebitModel", void 0);
	    __decorate([
	        core_1.ViewChild('directDebitCollectionDateModel'), 
	        __metadata('design:type', Object)
	    ], CreateDirectDebitFilePopupComponent.prototype, "directDebitCollectionDateModel", void 0);
	    __decorate([
	        core_1.Output('OnSuccessSave'), 
	        __metadata('design:type', Object)
	    ], CreateDirectDebitFilePopupComponent.prototype, "onSuccessSave", void 0);
	    __decorate([
	        core_1.Output('OnFormatChange'), 
	        __metadata('design:type', Object)
	    ], CreateDirectDebitFilePopupComponent.prototype, "onFormatChange", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array), 
	        __metadata('design:paramtypes', [Array])
	    ], CreateDirectDebitFilePopupComponent.prototype, "model", null);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array), 
	        __metadata('design:paramtypes', [Array])
	    ], CreateDirectDebitFilePopupComponent.prototype, "companyDDModel", null);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Boolean), 
	        __metadata('design:paramtypes', [Boolean])
	    ], CreateDirectDebitFilePopupComponent.prototype, "isDirectDebitClick", null);
	    CreateDirectDebitFilePopupComponent = __decorate([
	        core_1.Component({
	            selector: 'create-directdebit-file-popup',
	            template: __webpack_require__(1246),
	            providers: [invoice_service_1.InvoiceService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object, (typeof (_e = typeof core_1.NgZone !== 'undefined' && core_1.NgZone) === 'function' && _e) || Object, (typeof (_f = typeof invoice_service_1.InvoiceService !== 'undefined' && invoice_service_1.InvoiceService) === 'function' && _f) || Object])
	    ], CreateDirectDebitFilePopupComponent);
	    return CreateDirectDebitFilePopupComponent;
	    var _a, _b, _c, _d, _e, _f;
	}());
	exports.CreateDirectDebitFilePopupComponent = CreateDirectDebitFilePopupComponent;


/***/ },
/* 1246 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #createDirectDebitModel=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\"> {{ 'LblDirectDebitFile' | translate }}</h4>\r\n      </div>\r\n      <div *ngIf=\"model && selectedCompany\" class=\"modal-body\">\r\n        <form>\r\n          <div>\r\n            <div class=\"row col-sm-12\" style=\"margin-bottom: 10px;\">\r\n              <div class=\"row\">\r\n                <div class=\"form-group col-md-4 \">\r\n                  <label>{{ 'LblCompanyName' | translate }}</label>\r\n                  <select [(ngModel)]=\"selectedCompanyid\" name=\"selectedCompany\" class=\"form-control\" (change)=\"SelectFile($event)\">\r\n                    <option *ngFor=\"let directDebitFile of companyDDModel \" [ngValue]='directDebitFile.id'>{{directDebitFile.companyName}}</option>\r\n                  </select>\r\n\r\n                </div>\r\n                <div class=\"form-group col-md-4\">\r\n                  <label>{{ 'LblCollectionDate' | translate }}</label>\r\n                  <div class=\"input-group\">\r\n                    <span class=\"input-group-addon\">\r\n                      <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n                    </span>\r\n                    <input #flatPickrConfigDate=\"wego-flatpickr\" flatpickr readonly [Config]=\"flatPickrConfigFrom\" [(ngModel)]=\"collectionDate\"\r\n                      name=\"collectionDate\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblCollectionDate' | translate }}\">\r\n                  </div>\r\n                  <span class=\"text text-danger\">{{ errorMsg }}</span>\r\n                </div>\r\n                <div class=\"form-group col-md-4 \">\r\n                  <label>{{ 'LblFormat' | translate }}</label>\r\n                  <select [(ngModel)]=\"format\" name=\"format\" class=\"form-control\" (change)=\"OnFormatChange($event)\">\r\n                    <option *ngFor=\"let format of formatList\" [ngValue]='format.Key'>{{format.Value}}</option>\r\n                  </select>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <textarea readonly class=\"form-control\" style=\"height: 150px;\"> {{  selectedCompany.xmlFile}}\r\n            </textarea>\r\n\r\n            <h4>{{ 'LblWarnings' | translate }}</h4>\r\n            <div class=\"form-control\" style=\"height: 100px; overflow:auto;\" readonly>\r\n              <ul>\r\n                <li *ngFor=\"let warning of selectedCompany.warnings\" style=\"list-style: none;\">\r\n                  {{warning}}\r\n                </li>\r\n              </ul>\r\n            </div>\r\n          </div>\r\n          <hr>\r\n          <div class=\"col-sm-12 nopad\">\r\n            <button [disabled]=\"!(selectedCompany && selectedCompany.warnings && selectedCompany.warnings.length==0)\"\r\n             class=\"btn btn-green pull-right\"  type=\"button\" (click)=\"OnExport()\">\r\n              {{'LblCreateDirectDebitFile' | translate}}\r\n            </button>\r\n          </div>\r\n          <div class=\"clearfix\"></div>\r\n        </form>\r\n        <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\"></wego-success-popup>\r\n<directdebit-collection-date-popup #directDebitCollectionDateModel (OnSuccessSave)=\"OnDownloadDirectDebitSaved()\"></directdebit-collection-date-popup>";

/***/ },
/* 1247 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var flatpickr_model_1 = __webpack_require__(83);
	var moment = __webpack_require__(84);
	var DirectdebitCollectionDatePopupComponent = (function () {
	    function DirectdebitCollectionDatePopupComponent(authService, router, translate, zone) {
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.zone = zone;
	        this.collectionDate = "";
	        this.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
	        this.onSuccessSave = new core_1.EventEmitter();
	    }
	    DirectdebitCollectionDatePopupComponent.prototype.ngOnInit = function () {
	        this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
	    };
	    DirectdebitCollectionDatePopupComponent.prototype.SetDefaultFlatPickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = true;
	        flatPickrConfig.time_24hr = true;
	        flatPickrConfig.dateFormat = this.dateFormat;
	        flatPickrConfig.minuteIncrement = 1;
	        return flatPickrConfig;
	    };
	    DirectdebitCollectionDatePopupComponent.prototype.show = function () {
	        this.errorMsg = '';
	        this.errorModel = [];
	        this.collectionDateModel.show();
	    };
	    DirectdebitCollectionDatePopupComponent.prototype.hide = function () {
	        this.collectionDateModel.hide();
	    };
	    DirectdebitCollectionDatePopupComponent.prototype.OnExport = function (event) {
	    };
	    DirectdebitCollectionDatePopupComponent.prototype.OnSuccessSave = function () {
	        this.hide();
	        var successMsg = this.translate.instant('LblSuccess');
	        this.onSuccessSave.emit({ SuccessMessage: successMsg });
	    };
	    __decorate([
	        core_1.ViewChild('collectionDateModel'), 
	        __metadata('design:type', Object)
	    ], DirectdebitCollectionDatePopupComponent.prototype, "collectionDateModel", void 0);
	    __decorate([
	        core_1.Output('OnSuccessSave'), 
	        __metadata('design:type', Object)
	    ], DirectdebitCollectionDatePopupComponent.prototype, "onSuccessSave", void 0);
	    DirectdebitCollectionDatePopupComponent = __decorate([
	        core_1.Component({
	            selector: 'directdebit-collection-date-popup',
	            template: __webpack_require__(1248),
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _c) || Object, (typeof (_d = typeof core_1.NgZone !== 'undefined' && core_1.NgZone) === 'function' && _d) || Object])
	    ], DirectdebitCollectionDatePopupComponent);
	    return DirectdebitCollectionDatePopupComponent;
	    var _a, _b, _c, _d;
	}());
	exports.DirectdebitCollectionDatePopupComponent = DirectdebitCollectionDatePopupComponent;


/***/ },
/* 1248 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #collectionDateModel=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n                    <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\"> {{ 'LblDirectDebitDate' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <form>\r\n          <div class=\"col-sm-12 text-right\">\r\n            <hr>\r\n            <button class=\"btn btn-default export-icon\" type=\"button\" (click)=\"DirectDebitdate()\" title=\"{{'LblExportAll' | translate}}\">\r\n                      <i class=\"fa fa-download\" aria-hidden=\"true\"></i>\r\n                    </button>\r\n          </div>\r\n          <div class=\"form-group col-md-12\">\r\n            <label>{{ 'LblCollectionDate' | translate }}</label>\r\n            <div class=\"clearfix\"></div>\r\n            <div class=\"input-group\">\r\n              <span class=\"input-group-addon\"><i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i></span>\r\n              <input flatpickr readonly [Config]=\"flatPickrConfigFrom\" [(ngModel)]=\"collectionDate\" name=\"collectionDate\" type=\"text\" class=\"form-control\"\r\n                placeholder=\"{{ 'LblCollectionDate' | translate }}\">\r\n            </div>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'collectionDate' }}</span>\r\n          </div>\r\n        </form>\r\n\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>";

/***/ },
/* 1249 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var config_1 = __webpack_require__(60);
	var translate_service_1 = __webpack_require__(70);
	var sharedvehiclegroup_service_1 = __webpack_require__(510);
	var auth_service_1 = __webpack_require__(58);
	var batch_upload_person_model_1 = __webpack_require__(920);
	var AssignToSVGComponent = (function () {
	    function AssignToSVGComponent(translate, SVGService, authService) {
	        this.translate = translate;
	        this.SVGService = SVGService;
	        this.authService = authService;
	        this.onSuccessSelect = new core_1.EventEmitter();
	    }
	    AssignToSVGComponent.prototype.ngOnInit = function () {
	        this.LblAssignToSvg = this.translate.instant('LblAssign') + " " + this.translate.instant('LblSharedVehicleGroup');
	        this.LblIcon = 'fa fa-plus-square';
	        this.breadCrumbTitle = this.LblAssignToSvg;
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.searchField = ["groupName"];
	    };
	    AssignToSVGComponent.prototype.show = function () {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.sortType = "";
	        this.DataListModel.sortReverse = null;
	        this.DataListModel.searchTerm = "";
	        this.DataListModel.infoMessage = "";
	        this.GetSVGList();
	        this.assignToSVGModal.show();
	    };
	    AssignToSVGComponent.prototype.hide = function () {
	        this.assignToSVGModal.hide();
	    };
	    AssignToSVGComponent.prototype.GetSVGList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.SVGService.GetSVGListForBatchUpload(this.instanceHashId, this.organizationMasterHashId, this.DataListModel)
	            .subscribe(function (res) {
	            _this.sharedVehicleGroupList = res.data;
	            _this.sharedVehicleGroupList.forEach(function (x) {
	                x.selectedSubscription = x.listOfSubscription[0].organizationSubscriptionHashId;
	            });
	            if (_this.sVGModel != null && _this.sVGModel.length > 0) {
	                _this.sharedVehicleGroupList.filter(function (x) { return _this.sVGModel.map(function (svg) { return svg.sharedvehiclegroupHashId; }).indexOf(x.sharedvehiclegroupHashId) > -1; })
	                    .forEach(function (x) {
	                    x.isChecked = true;
	                    var subscriptionHashId = _this.sVGModel.find(function (y) { return y.sharedvehiclegroupHashId == x.sharedvehiclegroupHashId; }).subscriptionId;
	                    x.selectedSubscription = x.listOfSubscription.some(function (y) { return y.organizationSubscriptionHashId == subscriptionHashId; }) ? subscriptionHashId : x.listOfSubscription[0].organizationSubscriptionHashId;
	                });
	            }
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AssignToSVGComponent.prototype.OnSearch = function (event) {
	        this.DataListModel.searchTerm = event.searchTerm;
	        this.DataListModel.currentPage = 1;
	        this.GetSVGList();
	    };
	    AssignToSVGComponent.prototype.OnParentCheck = function (isChecked) {
	        this.sharedVehicleGroupList.forEach(function (x) { return x.isChecked = isChecked; });
	    };
	    AssignToSVGComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetSVGList();
	    };
	    ;
	    AssignToSVGComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetSVGList();
	    };
	    AssignToSVGComponent.prototype.OnAdd = function (event) {
	        var sVGModel1;
	        sVGModel1 = this.sharedVehicleGroupList.filter(function (x) { return x.isChecked; }).map(function (x) {
	            var temp = new batch_upload_person_model_1.SVGModel();
	            temp.sharedvehiclegroupHashId = x.sharedvehiclegroupHashId;
	            temp.subscriptionId = x.selectedSubscription;
	            temp.groupName = x.groupName;
	            temp.subscriptionName = x.listOfSubscription.find(function (x) { return x.organizationSubscriptionHashId == temp.subscriptionId; }).name;
	            return temp;
	        });
	        this.OnSuccessSelect(sVGModel1);
	        this.assignToSVGModal.hide();
	    };
	    AssignToSVGComponent.prototype.OnSuccessSelect = function (sVGModel) {
	        this.onSuccessSelect.emit({ SVGModel: sVGModel });
	    };
	    Object.defineProperty(AssignToSVGComponent.prototype, "isAnyChecked", {
	        get: function () {
	            if (this.sharedVehicleGroupList) {
	                var isCheck = this.sharedVehicleGroupList.some(function (x) { return x.isChecked == true; });
	                if (isCheck) {
	                    if (this.sharedVehicleGroupList.every(function (x) { return x.isChecked == true; }))
	                        this.isParentCheck = true;
	                    else
	                        this.isParentCheck = false;
	                }
	                else {
	                    this.isParentCheck = false;
	                }
	                return isCheck;
	            }
	            else {
	                this.isParentCheck = false;
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    __decorate([
	        core_1.Output('OnSuccessSelect'), 
	        __metadata('design:type', Object)
	    ], AssignToSVGComponent.prototype, "onSuccessSelect", void 0);
	    __decorate([
	        core_1.ViewChild('assignToSVGModal'), 
	        __metadata('design:type', Object)
	    ], AssignToSVGComponent.prototype, "assignToSVGModal", void 0);
	    AssignToSVGComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-assign-svg-popup',
	            template: __webpack_require__(1250),
	            providers: [sharedvehiclegroup_service_1.SharedVehicleGroupService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _a) || Object, (typeof (_b = typeof sharedvehiclegroup_service_1.SharedVehicleGroupService !== 'undefined' && sharedvehiclegroup_service_1.SharedVehicleGroupService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object])
	    ], AssignToSVGComponent);
	    return AssignToSVGComponent;
	    var _a, _b, _c;
	}());
	exports.AssignToSVGComponent = AssignToSVGComponent;


/***/ },
/* 1250 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #assignToSVGModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n\t\t\t\t\t<span aria-hidden=\"true\">&times;</span>\r\n\t\t</button>\r\n        <h4 class=\"modal-title\">{{ breadCrumbTitle }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <wego-search-list [IsExported]=\"false\" [SearchTerm]=\"DataListModel.searchTerm\" [CustomeIcon]=\"LblIcon\" [IsCustomButton]='true'\r\n          [Title]=\"LblAssignToSvg\" [IsCustomButtonEnabled]=\"isAnyChecked\" (OnCustomeButton)=\"OnAdd($event)\" (OnSearch)=\"OnSearch($event)\"\r\n          (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center parent-checkbox\">\r\n                  <input type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\">\r\n                </th>\r\n                <th class=\"cursor-pointer\">\r\n                  {{ 'LblSVG' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'groupName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\">\r\n                  {{ 'LblSubscription' | translate }}\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let sharedVehicleGroup of sharedVehicleGroupList\">\r\n                  <td class=\"text-center\">\r\n                    <input type=\"checkbox\" name=\"isActive\" [(ngModel)]=\"sharedVehicleGroup.isChecked\">\r\n                  </td>\r\n                  <td>{{ sharedVehicleGroup.groupName }}</td>\r\n                  <td>\r\n                    <select class=\"form-control\" name=\"subscriptionHash\" [(ngModel)]=\"sharedVehicleGroup.selectedSubscription\">  \r\n                        <option *ngFor=\"let item of sharedVehicleGroup.listOfSubscription\"  [ngValue]=\"item.organizationSubscriptionHashId\">{{ item.name }}</option>\r\n                    </select>\r\n                  </td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0\">\r\n                <td class=\"text-center text-danger\" colspan=\"4\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n          <div class=\"clearfix\"></div>\r\n          <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n            <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n              <div class=\"col-md-12\">\r\n                <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                  [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                  lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 1251 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var vehicle_service_1 = __webpack_require__(530);
	var sharedvehiclegroup_service_1 = __webpack_require__(510);
	var company_service_1 = __webpack_require__(501);
	var instance_service_1 = __webpack_require__(500);
	var report_filter_model_1 = __webpack_require__(1252);
	var flatpickr_model_1 = __webpack_require__(83);
	var config_1 = __webpack_require__(60);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var report_filter_service_1 = __webpack_require__(929);
	var ReportFilter = (function () {
	    function ReportFilter(authService, instanceService, companyService, sharedVehicleGroupService, vehicleService, reportFilterService) {
	        this.authService = authService;
	        this.instanceService = instanceService;
	        this.companyService = companyService;
	        this.sharedVehicleGroupService = sharedVehicleGroupService;
	        this.vehicleService = vehicleService;
	        this.reportFilterService = reportFilterService;
	        this.onSearch = new core_1.EventEmitter();
	        this.onExportPDF = new core_1.EventEmitter();
	        this.onExportExcel = new core_1.EventEmitter();
	        this.resetValidSearch = new core_1.EventEmitter();
	        this.isValidSearch = false;
	        this.roleLevel = config_1.RoleLevel;
	    }
	    ReportFilter.prototype.ngOnInit = function () {
	        this.model = new report_filter_model_1.ReportFilterModel();
	        this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigTo.defaultDate = "23:59";
	        this.InitReportFilter();
	    };
	    ReportFilter.prototype.SetDefaultFlatPickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = true;
	        flatPickrConfig.time_24hr = true;
	        flatPickrConfig.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
	        flatPickrConfig.minuteIncrement = 1;
	        return flatPickrConfig;
	    };
	    ReportFilter.prototype.InitReportFilter = function () {
	        this.GetAllInstanceList();
	    };
	    ReportFilter.prototype.GetAllInstanceList = function () {
	        var _this = this;
	        this.instanceService.GetDropdownInstanceList(this.reportName).subscribe(function (res) {
	            _this.instanceList = res.data;
	            if (_this.instanceList && _this.instanceList.length > 0) {
	                if (!_this.model.instanceHashId && _this.instanceList.length == 1) {
	                    _this.model.instanceHashId = _this.instanceList[0].keyHash;
	                }
	                _this.OnInstanceChange();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    ReportFilter.prototype.GetAllCompanyList = function () {
	        var _this = this;
	        this.companyService
	            .GetDropdownCompanyList(this.reportName, this.model.instanceHashId)
	            .subscribe(function (res) {
	            _this.companyList = res.data;
	            _this.isLoader = false;
	            if (_this.companyList && _this.companyList.length > 0) {
	                // if (!this.model.companyHashId && this.companyList.length == 1) {
	                //   this.model.companyHashId = this.companyList[0].keyHash;
	                // } else {
	                //   this.OnCompanyChange();
	                //   this.GetVehicleBySVG();
	                // }
	                _this.OnCompanyChange();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoader = false;
	        });
	    };
	    // Value should be null in case required all svg
	    ReportFilter.prototype.GetAllSVGList = function () {
	        var _this = this;
	        this.sharedVehicleGroupService
	            .GetDropdownSVGList(this.reportName, this.model.companyHashId, this.model.instanceHashId)
	            .subscribe(function (res) {
	            _this.sharedVehicleGroupList = res.data;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    ReportFilter.prototype.GetCompanyListByInstance = function (instanceHashId) {
	        var _this = this;
	        this.companyService.GetCompanybyInstance(instanceHashId).subscribe(function (res) {
	            _this.companyList = res.data;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    ReportFilter.prototype.GetVehicleBySVG = function () {
	        var _this = this;
	        // instanceHashId: string, companyHashId: string, sVGHashId: string
	        // let company = sVGHashId != "" ? "" : companyHashId;
	        this.vehicleService
	            .GetDropdownVehicleList(this.reportName, this.model.instanceHashId, this.model.companyHashId, this.model.sVGHashId)
	            .subscribe(function (res) {
	            _this.vehicleList = res.data;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    // Event
	    ReportFilter.prototype.OnInstanceChange = function () {
	        this.isLoader = true;
	        this.ResetValidSearch();
	        if (this.model.instanceHashId) {
	            //this.GetCompanyListByInstance(this.model.instanceHashId);
	            this.GetAllCompanyList();
	            this.model.companyHashId = "";
	        }
	        else {
	            this.companyList = [];
	            this.sharedVehicleGroupList = [];
	            this.vehicleList = [];
	            this.model.companyHashId = "";
	            this.model.sVGHashId = "";
	            this.model.vehicleHashId = "";
	        }
	    };
	    ReportFilter.prototype.OnCompanyChange = function () {
	        this.ResetValidSearch();
	        //this.GetAllSVGList(this.model.companyHashId,this.model.instanceHashId);
	        this.GetAllSVGList();
	        this.model.sVGHashId = "";
	        this.OnSVGChange();
	    };
	    ReportFilter.prototype.OnSVGChange = function () {
	        this.ResetValidSearch();
	        //this.GetVehicleBySVG(this.model.instanceHashId, this.model.companyHashId, this.model.sVGHashId);
	        this.GetVehicleBySVG();
	        this.model.vehicleHashId = "";
	    };
	    ReportFilter.prototype.OnVehicleChange = function () {
	        this.ResetValidSearch();
	    };
	    ReportFilter.prototype.OnFromDateChange = function () {
	        this.ResetValidSearch();
	    };
	    ReportFilter.prototype.OnToDateChange = function () {
	        this.ResetValidSearch();
	    };
	    ReportFilter.prototype.ResetValidSearch = function () {
	        this.isValidSearch = false;
	        this.resetValidSearch.emit({ isValidSearch: this.isValidSearch });
	    };
	    // Button Click
	    ReportFilter.prototype.OnSearch = function ($event) {
	        this.onSearch.emit({ model: this.model });
	    };
	    ReportFilter.prototype.OnExportPDF = function ($event) {
	        this.onExportPDF.emit({ model: this.model });
	    };
	    ReportFilter.prototype.OnExportExcel = function ($event) {
	        this.onExportExcel.emit({ model: this.model });
	    };
	    __decorate([
	        core_1.Output("OnSearch"), 
	        __metadata('design:type', Object)
	    ], ReportFilter.prototype, "onSearch", void 0);
	    __decorate([
	        core_1.Output("OnExportPDF"), 
	        __metadata('design:type', Object)
	    ], ReportFilter.prototype, "onExportPDF", void 0);
	    __decorate([
	        core_1.Output("OnExportExcel"), 
	        __metadata('design:type', Object)
	    ], ReportFilter.prototype, "onExportExcel", void 0);
	    __decorate([
	        core_1.Output("ResetValidSearch"), 
	        __metadata('design:type', Object)
	    ], ReportFilter.prototype, "resetValidSearch", void 0);
	    __decorate([
	        core_1.Input("IsValidSearch"), 
	        __metadata('design:type', Boolean)
	    ], ReportFilter.prototype, "isValidSearch", void 0);
	    __decorate([
	        core_1.Input("ErrorModel"), 
	        __metadata('design:type', Array)
	    ], ReportFilter.prototype, "errorModel", void 0);
	    __decorate([
	        core_1.Input("ReportName"), 
	        __metadata('design:type', String)
	    ], ReportFilter.prototype, "reportName", void 0);
	    ReportFilter = __decorate([
	        core_1.Component({
	            selector: "wego-report-filter",
	            template: __webpack_require__(1253),
	            providers: [
	                instance_service_1.InstanceService,
	                company_service_1.CompanyService,
	                sharedvehiclegroup_service_1.SharedVehicleGroupService,
	                vehicle_service_1.VehicleService,
	                report_filter_service_1.ReportFilterService
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof instance_service_1.InstanceService !== 'undefined' && instance_service_1.InstanceService) === 'function' && _b) || Object, (typeof (_c = typeof company_service_1.CompanyService !== 'undefined' && company_service_1.CompanyService) === 'function' && _c) || Object, (typeof (_d = typeof sharedvehiclegroup_service_1.SharedVehicleGroupService !== 'undefined' && sharedvehiclegroup_service_1.SharedVehicleGroupService) === 'function' && _d) || Object, (typeof (_e = typeof vehicle_service_1.VehicleService !== 'undefined' && vehicle_service_1.VehicleService) === 'function' && _e) || Object, (typeof (_f = typeof report_filter_service_1.ReportFilterService !== 'undefined' && report_filter_service_1.ReportFilterService) === 'function' && _f) || Object])
	    ], ReportFilter);
	    return ReportFilter;
	    var _a, _b, _c, _d, _e, _f;
	}());
	exports.ReportFilter = ReportFilter;


/***/ },
/* 1252 */
/***/ function(module, exports) {

	"use strict";
	var ReportFilterModel = (function () {
	    function ReportFilterModel() {
	        this.instanceHashId = '';
	        this.companyHashId = '';
	        this.sVGHashId = '';
	        this.vehicleHashId = '';
	        this.organizationHashId = '';
	        this.customerHashId = '';
	        this.companyMasterHashId = '';
	        this.sharedVehicleGroupHashId = '';
	        this.contractTypeGroupHashId = '';
	        this.groupByType = 'VEHICLE';
	    }
	    return ReportFilterModel;
	}());
	exports.ReportFilterModel = ReportFilterModel;
	var DropdownModel = (function () {
	    function DropdownModel() {
	    }
	    return DropdownModel;
	}());
	exports.DropdownModel = DropdownModel;


/***/ },
/* 1253 */
/***/ function(module, exports) {

	module.exports = "<form #searchForm=\"ngForm\">\r\n  <div class=\"row\">\r\n    <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Instance\" class=\"form-group col-md-3\">\r\n      <label><span class=\"text text-danger\">*</span>{{ 'LblInstance' | translate }}</label>\r\n      <select [(ngModel)]=\"model.instanceHashId\" name=\"Instance\" class=\"form-control\" (change)=\"OnInstanceChange()\">\r\n        <option  value=\"\">{{ 'LblSelect' | translate }} {{ 'LblInstance' | translate }} </option>\r\n        <option *ngFor=\"let item of instanceList\"  [ngValue]='item.keyHash' >{{item.value}}</option>\r\n      </select>\r\n      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'instanceHashId' }}</span>\r\n    </div>\r\n    <!-- *ngIf=\"model.instanceHashId == '' || isLoader || AllowToDisplayDropDown(companyList, model.companyHashId, SetCompanyDropDownValue)\" -->\r\n    <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Company\" class=\"form-group col-md-3\">\r\n      <label>{{ 'LblCompany' | translate }}</label>\r\n      <select [(ngModel)]=\"model.companyHashId\" name=\"ownerCompanyID\" class=\"form-control\" (change)=\"OnCompanyChange()\">\r\n          <option  value=\"\">{{ 'LblAll' | translate }} {{ 'LblCompany' | translate }} </option>\r\n          <option *ngFor=\"let company of companyList\"  [ngValue]='company.keyHash' >{{company.value}}</option>\r\n      </select>\r\n    </div>\r\n    <div class=\"form-group col-md-3\">\r\n      <label>{{ 'LblSharedVehicleGroup' | translate }}</label>\r\n      <select [(ngModel)]=\"model.sVGHashId\" name=\"sharedvehiclegroup\" class=\"form-control\" (change)=\"OnSVGChange()\">\r\n          <option  value=\"\">{{ 'LblAll' | translate }} {{ 'LblSharedVehicleGroup' | translate }} </option>\r\n          <option *ngFor=\"let sharedvehiclegroup of sharedVehicleGroupList\"  [ngValue]='sharedvehiclegroup.keyHash' >{{sharedvehiclegroup.value}}</option>\r\n        </select>\r\n    </div>\r\n    <div class=\"clearfix\">\r\n    </div>\r\n    <div class=\"form-group col-md-3\">\r\n      <label>{{ 'LblVehicle' | translate }}</label>\r\n      <select [(ngModel)]=\"model.vehicleHashId\" name=\"ddehicle\" class=\"form-control\" (change)=\"OnVehicleChange()\">\r\n          <option  value=\"\">{{ 'LblAll' | translate }} {{ 'LblVehicle' | translate }} </option>\r\n          <option *ngFor=\"let vehicle of vehicleList\"  [ngValue]='vehicle.keyHash' >{{vehicle.value}}</option>\r\n        </select>\r\n    </div>\r\n    <div class=\"form-group col-md-3\">\r\n      <label><span class=\"text text-danger\">*</span>{{ 'LblFrom' | translate }}</label>\r\n      <div class=\"clearfix\"></div>\r\n      <div class=\"input-group\">\r\n        <span class=\"input-group-addon\"><i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i></span>\r\n        <input #flatPickrConfigFromDate=\"wego-flatpickr\" flatpickr readonly [Config]=\"flatPickrConfigFrom\" [(ngModel)]=\"model.startDateTime\"\r\n          name=\"startDateTime\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblFrom' | translate }}\" (change)=\"OnFromDateChange()\">\r\n      </div>\r\n      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'StartDateTime' }}</span>\r\n    </div>\r\n    <div class=\"form-group col-md-3\">\r\n      <label><span class=\"text text-danger\">*</span>{{ 'LblTo' | translate }}</label>\r\n      <div class=\"clearfix \"></div>\r\n      <div class=\"input-group\">\r\n        <span class=\"input-group-addon\"><i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i></span>\r\n        <input #flatPickrConfigToDate=\"wego-flatpickr\" flatpickr readonly [Config]=\"flatPickrConfigTo\" [(ngModel)]=\"model.endDateTime\"\r\n          name=\"endDateTime\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblTo' | translate }}\" (change)=\"OnToDateChange()\">\r\n      </div>\r\n      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'EndDateTime' }}</span>\r\n    </div>\r\n    <div class=\"form-group col-md-3\">\r\n      <div class=\"input-group\">\r\n        <label>&nbsp;</label>\r\n        <div class=\"clearfix\"></div>\r\n        <button class=\"btn btn-default\" (click)=\"OnSearch($event)\"><i class=\"fa fa-search\" aria-hidden=\"true\"></i></button>&nbsp;\r\n        <button *ngIf=\"isValidSearch\" class=\"btn btn-default\" (click)=\"OnExportPDF($event)\"><i class=\"fa fa-file-pdf-o\" aria-hidden=\"true\"></i></button>&nbsp;\r\n        <button *ngIf=\"isValidSearch\" class=\"btn btn-default\" (click)=\"OnExportExcel($event)\"><i class=\"fa fa-file-excel-o\" aria-hidden=\"true\"></i></button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</form>";

/***/ },
/* 1254 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var organization_service_1 = __webpack_require__(614);
	var OrganizationContactPopupComponent = (function () {
	    function OrganizationContactPopupComponent(organizationService, authService, router) {
	        this.organizationService = organizationService;
	        this.authService = authService;
	        this.router = router;
	        this.onSuccessSelect = new core_1.EventEmitter();
	    }
	    OrganizationContactPopupComponent.prototype.ngOnInit = function () {
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.searchField = ["userName", "firstName", "lastName"];
	        this.urlPersonUpdate = this.authService.GetURL(config_1.ApplicationRouteURL.URL_PERSON_UPDATE);
	    };
	    OrganizationContactPopupComponent.prototype.ngOnChanges = function (change) {
	        console.log(change);
	    };
	    OrganizationContactPopupComponent.prototype.show = function () {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.sortType = "";
	        this.DataListModel.sortReverse = null;
	        this.DataListModel.searchTerm = "";
	        this.DataListModel.infoMessage = "";
	        this.GetContactPersonList();
	        this.contactPersonModal.show();
	    };
	    OrganizationContactPopupComponent.prototype.hide = function () {
	        this.contactPersonModal.hide();
	    };
	    OrganizationContactPopupComponent.prototype.GetContactPersonList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.organizationService.GetPersonListForContactPerson(this.organizationMasterHashId, this.DataListModel)
	            .subscribe(function (res) {
	            _this.personList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    OrganizationContactPopupComponent.prototype.select = function (hashId) {
	        var _this = this;
	        this.isLoading = true;
	        this.organizationService.UpdateOrganizationContactPerson(this.organizationMasterHashId, hashId)
	            .subscribe(function (res) {
	            _this.message = "Record Saved successfully.";
	            _this.OnSuccessSelect();
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        }, function () {
	            _this.contactPersonModal.hide();
	            _this.isLoading = false;
	        });
	    };
	    OrganizationContactPopupComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetContactPersonList();
	    };
	    OrganizationContactPopupComponent.prototype.OnSearch = function (event) {
	        this.DataListModel.searchTerm = event.searchTerm;
	        this.DataListModel.currentPage = 1;
	        this.GetContactPersonList();
	    };
	    OrganizationContactPopupComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetContactPersonList();
	    };
	    ;
	    OrganizationContactPopupComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetContactPersonList();
	    };
	    OrganizationContactPopupComponent.prototype.OnSuccessSelect = function () {
	        this.onSuccessSelect.emit({ SuccessMessage: this.message });
	    };
	    __decorate([
	        core_1.Output('OnSuccessSelect'), 
	        __metadata('design:type', Object)
	    ], OrganizationContactPopupComponent.prototype, "onSuccessSelect", void 0);
	    __decorate([
	        core_1.ViewChild('contactPersonModal'), 
	        __metadata('design:type', Object)
	    ], OrganizationContactPopupComponent.prototype, "contactPersonModal", void 0);
	    OrganizationContactPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-organization-contact-person',
	            template: __webpack_require__(1255),
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof organization_service_1.OrganizationService !== 'undefined' && organization_service_1.OrganizationService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object])
	    ], OrganizationContactPopupComponent);
	    return OrganizationContactPopupComponent;
	    var _a, _b, _c;
	}());
	exports.OrganizationContactPopupComponent = OrganizationContactPopupComponent;


/***/ },
/* 1255 */
833,
/* 1256 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var organizationAdmin_service_1 = __webpack_require__(940);
	var organizationAdmin_model_1 = __webpack_require__(1257);
	var organization_service_1 = __webpack_require__(614);
	var AddOrganizationAdminPopupComponent = (function () {
	    function AddOrganizationAdminPopupComponent(organizationAdminService, organizationService, authService, router, translate) {
	        this.organizationAdminService = organizationAdminService;
	        this.organizationService = organizationService;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.onSuccessSelect = new core_1.EventEmitter();
	    }
	    AddOrganizationAdminPopupComponent.prototype.ngOnInit = function () {
	        this.module = this.translate.instant('LblOrganizationAdmin');
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.searchField = ["userName", "firstName", "lastName"];
	        this.urlPersonUpdate = this.authService.GetURL(config_1.ApplicationRouteURL.URL_PERSON_UPDATE);
	        this.breadCrumbTitle = this.translate.instant('LblAddPage', [this.module]);
	    };
	    AddOrganizationAdminPopupComponent.prototype.ngOnChanges = function (change) {
	        console.log(change);
	    };
	    AddOrganizationAdminPopupComponent.prototype.show = function () {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.sortType = "";
	        this.DataListModel.sortReverse = null;
	        this.DataListModel.searchTerm = "";
	        this.DataListModel.infoMessage = "";
	        this.GetOrganizationAdminPersonList();
	        this.organizationAdminModal.show();
	    };
	    AddOrganizationAdminPopupComponent.prototype.hide = function () {
	        this.organizationAdminModal.hide();
	    };
	    AddOrganizationAdminPopupComponent.prototype.GetOrganizationAdminPersonList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.organizationAdminService.GetPersonListByOrganizationId(this.organizationMasterHashId, this.DataListModel)
	            .subscribe(function (res) {
	            _this.personList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AddOrganizationAdminPopupComponent.prototype.select = function (personMasterHashId) {
	        var _this = this;
	        this.isLoading = true;
	        var model = new organizationAdmin_model_1.OrganizationAdminModel();
	        model.personHashID = personMasterHashId;
	        model.organizationMasterHashId = this.organizationMasterHashId;
	        this.organizationAdminService.AddNewOrganizationAdmin(model)
	            .subscribe(function (res) {
	            _this.popupMsg = _this.translate.instant('LblRecordAddedSuccess', [_this.module]);
	            ;
	            _this.OnSuccessSelect();
	            _this.isLoading = false;
	            _this.ShowSuccessPopup();
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        }, function () {
	            _this.organizationAdminModal.hide();
	            _this.isLoading = false;
	        });
	    };
	    AddOrganizationAdminPopupComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetOrganizationAdminPersonList();
	    };
	    AddOrganizationAdminPopupComponent.prototype.OnSearch = function (event) {
	        this.DataListModel.searchTerm = event.searchTerm;
	        this.DataListModel.currentPage = 1;
	        this.GetOrganizationAdminPersonList();
	    };
	    AddOrganizationAdminPopupComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetOrganizationAdminPersonList();
	    };
	    ;
	    AddOrganizationAdminPopupComponent.prototype.OnPagingChange = function (event) {
	        console.log(this.DataListModel);
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetOrganizationAdminPersonList();
	    };
	    AddOrganizationAdminPopupComponent.prototype.OnSuccessSelect = function () {
	        this.onSuccessSelect.emit({ SuccessMessage: this.message });
	    };
	    AddOrganizationAdminPopupComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    AddOrganizationAdminPopupComponent.prototype.HideSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    AddOrganizationAdminPopupComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    __decorate([
	        core_1.Output('OnSuccessSelect'), 
	        __metadata('design:type', Object)
	    ], AddOrganizationAdminPopupComponent.prototype, "onSuccessSelect", void 0);
	    __decorate([
	        core_1.ViewChild('organizationAdminModal'), 
	        __metadata('design:type', Object)
	    ], AddOrganizationAdminPopupComponent.prototype, "organizationAdminModal", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], AddOrganizationAdminPopupComponent.prototype, "successPopup", void 0);
	    AddOrganizationAdminPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-add-organizationadmin',
	            template: __webpack_require__(1258),
	            styles: [".my-loading {\n      position: absolute;\n      top: 0;\n      left: 0;\n      bottom: 0%;\n      right: 0%;\n      text-align: center;\n      z-index: 9999;\n    }\n    \n    .my-loading .dimmer {\n      position: absolute;\n      top: 0;\n      left: 0;\n      background-color: #000;\n      opacity: 0.5;\n      width: 100%;\n      height: 100%;\n    }\n    \n    .my-loading .loading-bg {\n      position: absolute;\n      display: inline-block;\n      top: 50%;\n      left: -webkit-calc(50% - 40px);\n      left: -moz-calc(50% - 40px);\n      left: calc(50% - 40px);\n      transform: translateY(-50%);\n      padding: 22px;\n      background-color: #fff;\n      border-radius: 15px;\n      text-align: center;\n    }"]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof organizationAdmin_service_1.OrganizationAdminService !== 'undefined' && organizationAdmin_service_1.OrganizationAdminService) === 'function' && _a) || Object, (typeof (_b = typeof organization_service_1.OrganizationService !== 'undefined' && organization_service_1.OrganizationService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _e) || Object])
	    ], AddOrganizationAdminPopupComponent);
	    return AddOrganizationAdminPopupComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.AddOrganizationAdminPopupComponent = AddOrganizationAdminPopupComponent;


/***/ },
/* 1257 */
/***/ function(module, exports) {

	"use strict";
	var OrganizationAdminModel = (function () {
	    function OrganizationAdminModel() {
	    }
	    return OrganizationAdminModel;
	}());
	exports.OrganizationAdminModel = OrganizationAdminModel;


/***/ },
/* 1258 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #organizationAdminModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n                    <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ breadCrumbTitle }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <wego-search-list [IsExported]=\"false\" [SearchTerm]=\"DataListModel.searchTerm\" (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center\">\r\n                  {{ 'LblSelect' | translate }}\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('firstName')\">\r\n                  {{ 'LblFirstName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'firstName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('lastName')\">\r\n                  {{ 'LblLastName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'lastName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('userName')\">\r\n                  {{ 'LblUserName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'userName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let person of personList\">\r\n                  <td class=\"text-center\">\r\n                    <a class=\"cursor-pointer\" (click)=\"select(person.personMasterHashId)\">\r\n                      <i class=\"fa fa-plus-square\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td>{{ person.firstName }}</td>\r\n                  <td>{{ person.lastName }} </td>\r\n                  <td>{{ person.userName }}</td>               \r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0\">\r\n                <td class=\"text-center text-danger\" colspan=\"4\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\" [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\"\r\n                firstText=\"&laquo;\" lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>";

/***/ },
/* 1259 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var driver_service_1 = __webpack_require__(570);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var SnailTrailDriverPopupComponent = (function () {
	    function SnailTrailDriverPopupComponent(driverService, authService, router, translate) {
	        this.driverService = driverService;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.onSuccessSelect = new core_1.EventEmitter();
	    }
	    SnailTrailDriverPopupComponent.prototype.ngOnInit = function () {
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.searchField = ["driverName", "firstName", "lastName"];
	    };
	    SnailTrailDriverPopupComponent.prototype.ngOnChanges = function (change) {
	        console.log(change);
	    };
	    SnailTrailDriverPopupComponent.prototype.show = function () {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.sortType = "";
	        this.DataListModel.sortReverse = null;
	        this.DataListModel.searchTerm = "";
	        this.DataListModel.infoMessage = "";
	        this.GetDriverList();
	        this.driverModal.show();
	    };
	    SnailTrailDriverPopupComponent.prototype.hide = function () {
	        this.driverModal.hide();
	    };
	    SnailTrailDriverPopupComponent.prototype.GetDriverList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.driverService.GetActiveDriverList(this.DataListModel, true, config_1.Permission.PR_SANIL_TRAIL_REPORT)
	            .subscribe(function (res) {
	            _this.driverList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SnailTrailDriverPopupComponent.prototype.select = function (driver) {
	        this.isLoading = true;
	        this.onSuccessSelect.emit({ DriverHashID: driver.driverMasterHashId, DriverName: driver.driverName });
	        this.isLoading = false;
	        this.hide();
	    };
	    SnailTrailDriverPopupComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetDriverList();
	    };
	    SnailTrailDriverPopupComponent.prototype.OnSearch = function (event) {
	        this.DataListModel.searchTerm = event.searchTerm;
	        this.DataListModel.currentPage = 1;
	        this.GetDriverList();
	    };
	    SnailTrailDriverPopupComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetDriverList();
	    };
	    ;
	    SnailTrailDriverPopupComponent.prototype.OnPagingChange = function (event) {
	        console.log(this.DataListModel);
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetDriverList();
	    };
	    SnailTrailDriverPopupComponent.prototype.OnSuccessSelect = function () {
	    };
	    __decorate([
	        core_1.Output('OnSuccessSelect'), 
	        __metadata('design:type', Object)
	    ], SnailTrailDriverPopupComponent.prototype, "onSuccessSelect", void 0);
	    __decorate([
	        core_1.ViewChild('driverModal'), 
	        __metadata('design:type', Object)
	    ], SnailTrailDriverPopupComponent.prototype, "driverModal", void 0);
	    SnailTrailDriverPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-snail-trail-driver-popup',
	            template: __webpack_require__(1260),
	            providers: [driver_service_1.DriverService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof driver_service_1.DriverService !== 'undefined' && driver_service_1.DriverService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object])
	    ], SnailTrailDriverPopupComponent);
	    return SnailTrailDriverPopupComponent;
	    var _a, _b, _c, _d;
	}());
	exports.SnailTrailDriverPopupComponent = SnailTrailDriverPopupComponent;


/***/ },
/* 1260 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #driverModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\"\r\n  [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n                    <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblSelect' | translate }} {{ 'LblDriver' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <wego-search-list [IsExported]=\"false\" [SearchTerm]=\"DataListModel.searchTerm\" (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\"\r\n          (OnPagingChange)=\"OnPagingChange($event)\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center\">\r\n                  {{ 'LblSelect' | translate }}\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('driverName')\">\r\n                  {{ 'LblDriver' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'driverName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('firstName')\">\r\n                  {{ 'LblFirstName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'firstName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('lastName')\">\r\n                  {{ 'LblLastName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'lastName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let driver of driverList\">\r\n                  <td class=\"text-center\">\r\n                    <a class=\"cursor-pointer\" (click)=\"select(driver)\">\r\n                      <i class=\"fa fa-plus-square\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td>{{ driver.driverName }}</td>\r\n                  <td>{{ driver.firstName }}</td>\r\n                  <td>{{ driver.lastName }}</td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0\">\r\n                <td class=\"text-center text-danger\" colspan=\"4\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 1261 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var booking_service_1 = __webpack_require__(556);
	var SnailTrailBookingPopupComponent = (function () {
	    function SnailTrailBookingPopupComponent(bookingService, authService, router, translate) {
	        this.bookingService = bookingService;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.onSuccessSelect = new core_1.EventEmitter();
	    }
	    SnailTrailBookingPopupComponent.prototype.ngOnInit = function () {
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.searchField = ["driver", "bookingReferenceID", "licenceTag", "translatedBookingStatus"];
	    };
	    SnailTrailBookingPopupComponent.prototype.ngOnChanges = function (change) {
	        console.log(change);
	    };
	    SnailTrailBookingPopupComponent.prototype.show = function () {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.sortType = "";
	        this.DataListModel.sortReverse = null;
	        this.DataListModel.searchTerm = "";
	        this.DataListModel.infoMessage = "";
	        this.GetBookingList();
	        this.bookingModal.show();
	    };
	    SnailTrailBookingPopupComponent.prototype.hide = function () {
	        this.bookingModal.hide();
	    };
	    SnailTrailBookingPopupComponent.prototype.GetBookingList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.bookingService.GetNormalBookingList(this.DataListModel, true, config_1.Permission.PR_SANIL_TRAIL_REPORT)
	            .subscribe(function (res) {
	            _this.bookingList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SnailTrailBookingPopupComponent.prototype.select = function (booking) {
	        this.isLoading = true;
	        this.onSuccessSelect.emit({ BookingHashID: booking.bookingHashId, BookingReferenceId: booking.bookingReferenceID,
	            DriverHashID: booking.driverHashId, DriverName: booking.driver, LicenceTage: booking.licenceTag, VehicleMasterHashID: booking.vehicleHashId });
	        this.isLoading = false;
	        this.hide();
	    };
	    SnailTrailBookingPopupComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetBookingList();
	    };
	    SnailTrailBookingPopupComponent.prototype.OnSearch = function (event) {
	        this.DataListModel.searchTerm = event.searchTerm;
	        this.DataListModel.currentPage = 1;
	        this.GetBookingList();
	    };
	    SnailTrailBookingPopupComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetBookingList();
	    };
	    ;
	    SnailTrailBookingPopupComponent.prototype.OnPagingChange = function (event) {
	        console.log(this.DataListModel);
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetBookingList();
	    };
	    SnailTrailBookingPopupComponent.prototype.OnSuccessSelect = function () {
	    };
	    __decorate([
	        core_1.Output('OnSuccessSelect'), 
	        __metadata('design:type', Object)
	    ], SnailTrailBookingPopupComponent.prototype, "onSuccessSelect", void 0);
	    __decorate([
	        core_1.ViewChild('bookingModal'), 
	        __metadata('design:type', Object)
	    ], SnailTrailBookingPopupComponent.prototype, "bookingModal", void 0);
	    SnailTrailBookingPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-snail-trail-booking-popup',
	            template: __webpack_require__(1262),
	            providers: [booking_service_1.BookingService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof booking_service_1.BookingService !== 'undefined' && booking_service_1.BookingService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object])
	    ], SnailTrailBookingPopupComponent);
	    return SnailTrailBookingPopupComponent;
	    var _a, _b, _c, _d;
	}());
	exports.SnailTrailBookingPopupComponent = SnailTrailBookingPopupComponent;


/***/ },
/* 1262 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #bookingModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n                    <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblSelect' | translate }} {{ 'LblBooking' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <wego-search-list [IsExported]=\"false\" [SearchTerm]=\"DataListModel.searchTerm\" (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\"\r\n          (OnPagingChange)=\"OnPagingChange($event)\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center\">\r\n                  {{ 'LblSelect' | translate }}\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('bookingReferenceID')\">\r\n                  {{ 'LblBookingReferenceId' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'bookingReferenceID'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('startDateTimeUTC')\">\r\n                  {{ 'LblFrom' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'startDateTimeUTC'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('endDateTimeUTC')\">\r\n                  {{ 'LblTo' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'endDateTimeUTC'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('driver')\">\r\n                  {{ 'LblDriver' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'driver'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('licenceTag')\">\r\n                  {{ 'LblVehicle' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'licenceTag'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('translatedBookingStatus')\">\r\n                  {{ 'LblStatus' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'translatedBookingStatus'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let booking of bookingList\">\r\n                  <td class=\"text-center\">\r\n                    <a class=\"cursor-pointer\" (click)=\"select(booking)\">\r\n                      <i class=\"fa fa-plus-square\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td>{{ booking.bookingReferenceID }}</td>\r\n                  <td>{{ booking.startDateTime }}</td>\r\n                  <td>{{ booking.endDateTime }}</td>\r\n                  <td>{{ booking.driver }}</td>\r\n                  <td>{{ booking.licenceTag }}</td>\r\n                  <td>{{ booking.translatedBookingStatus }}</td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0\">\r\n                <td class=\"text-center text-danger\" colspan=\"7\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 1263 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var vehicle_service_1 = __webpack_require__(530);
	var SnailTrailVehiclePopupComponent = (function () {
	    function SnailTrailVehiclePopupComponent(vehicleService, authService, router, translate) {
	        this.vehicleService = vehicleService;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.onSuccessSelect = new core_1.EventEmitter();
	    }
	    SnailTrailVehiclePopupComponent.prototype.ngOnInit = function () {
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.searchField = ["licenceTag", 'ownerName', 'brand', 'type', 'vehicleClass', 'color'];
	    };
	    SnailTrailVehiclePopupComponent.prototype.ngOnChanges = function (change) {
	        console.log(change);
	    };
	    SnailTrailVehiclePopupComponent.prototype.show = function () {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.sortType = "";
	        this.DataListModel.sortReverse = null;
	        this.DataListModel.searchTerm = "";
	        this.DataListModel.infoMessage = "";
	        this.GetVehicleList();
	        this.vehicleModal.show();
	    };
	    SnailTrailVehiclePopupComponent.prototype.hide = function () {
	        this.vehicleModal.hide();
	    };
	    SnailTrailVehiclePopupComponent.prototype.GetVehicleList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.vehicleService.GetVehicleList(this.DataListModel, null, null, null, true, false, false, false, config_1.Permission.PR_SANIL_TRAIL_REPORT)
	            .subscribe(function (res) {
	            _this.vehicleList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SnailTrailVehiclePopupComponent.prototype.select = function (vehicle) {
	        this.isLoading = true;
	        this.onSuccessSelect.emit({ VehicleMasterHashID: vehicle.vehicleMasterHashId, LicenceTage: vehicle.licenceTag });
	        this.isLoading = false;
	        this.hide();
	    };
	    SnailTrailVehiclePopupComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetVehicleList();
	    };
	    SnailTrailVehiclePopupComponent.prototype.OnSearch = function (event) {
	        this.DataListModel.searchTerm = event.searchTerm;
	        this.DataListModel.currentPage = 1;
	        this.GetVehicleList();
	    };
	    SnailTrailVehiclePopupComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetVehicleList();
	    };
	    ;
	    SnailTrailVehiclePopupComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetVehicleList();
	    };
	    SnailTrailVehiclePopupComponent.prototype.OnSuccessSelect = function () {
	    };
	    __decorate([
	        core_1.Output('OnSuccessSelect'), 
	        __metadata('design:type', Object)
	    ], SnailTrailVehiclePopupComponent.prototype, "onSuccessSelect", void 0);
	    __decorate([
	        core_1.ViewChild('vehicleModal'), 
	        __metadata('design:type', Object)
	    ], SnailTrailVehiclePopupComponent.prototype, "vehicleModal", void 0);
	    SnailTrailVehiclePopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-snail-trail-vehicle-popup',
	            template: __webpack_require__(1264),
	            providers: [vehicle_service_1.VehicleService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof vehicle_service_1.VehicleService !== 'undefined' && vehicle_service_1.VehicleService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object])
	    ], SnailTrailVehiclePopupComponent);
	    return SnailTrailVehiclePopupComponent;
	    var _a, _b, _c, _d;
	}());
	exports.SnailTrailVehiclePopupComponent = SnailTrailVehiclePopupComponent;


/***/ },
/* 1264 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #vehicleModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n                    <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblSelect' | translate }} {{ 'LblVehicle' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <wego-search-list [IsExported]=\"false\" [SearchTerm]=\"DataListModel.searchTerm\" (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center\">\r\n                  {{ 'LblSelect' | translate }}\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('licenceTag')\">\r\n                  {{ 'LblLicenceTag' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'licenceTag'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('ownerName')\">\r\n                  {{ 'LblVehicleOwner' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'ownerName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('brand')\">\r\n                  {{ 'LblBrand' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'brand'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('type')\">\r\n                  {{ 'LblType' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'type'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('vehicleClass')\">\r\n                  {{ 'LblVehicleClass' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'vehicleClass'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('color')\">\r\n                  {{ 'LblColor' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'color'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let vehicle of vehicleList\">\r\n                  <td class=\"text-center\">\r\n                    <a class=\"cursor-pointer\" (click)=\"select(vehicle)\">\r\n                      <i class=\"fa fa-plus-square\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td>{{ vehicle.licenceTag }}</td>\r\n                  <td>{{vehicle.ownerName}}</td>\r\n                  <td>{{vehicle.brand}}</td>\r\n                  <td>{{vehicle.type}}</td>\r\n                  <td>{{vehicle.vehicleClass}}</td>\r\n                  <td>{{vehicle.color}}</td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0\">\r\n                <td class=\"text-center text-danger\" colspan=\"7\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\" [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\"\r\n                firstText=\"&laquo;\" lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 1265 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var vehicle_service_1 = __webpack_require__(530);
	var BookingVehiclePopupComponent = (function () {
	    function BookingVehiclePopupComponent(vehicleService, authService, router, translate) {
	        this.vehicleService = vehicleService;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.SelectedNames = [];
	        this.SelectedList = [];
	        this.LblIcon = "fa fa-plus-square";
	        this.isParentCheck = false;
	        this.onSuccessSelect = new core_1.EventEmitter();
	    }
	    BookingVehiclePopupComponent.prototype.ngOnInit = function () {
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.searchField = ["licenceTag", 'ownerName', 'brand', 'type', 'vehicleClass', 'color'];
	    };
	    BookingVehiclePopupComponent.prototype.ngOnChanges = function (change) {
	        console.log(change);
	    };
	    BookingVehiclePopupComponent.prototype.show = function (svgHashId, SelectedList, SelectedNameList) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.sortType = "";
	        this.DataListModel.sortReverse = null;
	        this.DataListModel.searchTerm = "";
	        this.DataListModel.infoMessage = "";
	        this.svgHashId = svgHashId;
	        this.SelectedList = SelectedList;
	        this.SelectedNames = SelectedNameList;
	        this.GetVehicleList();
	        this.vehicleModal.show();
	    };
	    BookingVehiclePopupComponent.prototype.hide = function () {
	        this.vehicleModal.hide();
	    };
	    BookingVehiclePopupComponent.prototype.GetVehicleList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.vehicleService.GetVehicleList(this.DataListModel, null, this.svgHashId, null, false, false, false, false, config_1.Permission.PR_BOOKINGS_OVERVIEW)
	            .subscribe(function (res) {
	            _this.vehicleList = res.data;
	            _this.vehicleList.forEach(function (x) { return x.isChecked =
	                (_this.SelectedList.indexOf(x.vehicleMasterHashId) > -1); });
	            _this.isParentCheck = _this.vehicleList.every(function (x) { return x.isChecked; });
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BookingVehiclePopupComponent.prototype.select = function (vehicle) {
	        this.isLoading = true;
	        this.onSuccessSelect.emit({ VehicleMasterHashID: vehicle.vehicleMasterHashId, LicenceTage: vehicle.licenceTag });
	        this.isLoading = false;
	        this.hide();
	    };
	    BookingVehiclePopupComponent.prototype.selectMultiple = function () {
	        this.isLoading = true;
	        this.onSuccessSelect.emit({ VehicleMasterHashID: this.SelectedList, LicenceTage: this.SelectedNames });
	        this.isLoading = false;
	        this.hide();
	    };
	    BookingVehiclePopupComponent.prototype.ItemCheckChanged = function (VehicleMasterHashId, LicenceTag, isChecked) {
	        if (isChecked) {
	            if (this.SelectedList.indexOf(VehicleMasterHashId) == -1) {
	                this.SelectedList.push(VehicleMasterHashId);
	            }
	            if (this.SelectedNames.indexOf(LicenceTag) == -1) {
	                this.SelectedNames.push(LicenceTag);
	            }
	            this.isParentCheck = this.vehicleList.filter(function (x) { return x.vehicleMasterHashId != VehicleMasterHashId; }).every(function (x) { return x.isChecked; });
	        }
	        else {
	            this.SelectedList = this.SelectedList.filter(function (x) { return x != VehicleMasterHashId; });
	            this.SelectedNames = this.SelectedNames.filter(function (x) { return x != LicenceTag; });
	            this.isParentCheck = false;
	        }
	    };
	    BookingVehiclePopupComponent.prototype.OnParentCheck = function (isChecked) {
	        var _this = this;
	        this.vehicleList.forEach(function (x) {
	            x.isChecked = isChecked;
	            if (isChecked) {
	                if (_this.SelectedList.indexOf(x.vehicleMasterHashId) == -1) {
	                    _this.SelectedList.push(x.vehicleMasterHashId);
	                }
	                if (_this.SelectedNames.indexOf(x.licenceTag) == -1) {
	                    _this.SelectedNames.push(x.licenceTag);
	                }
	            }
	            else {
	                _this.SelectedList = _this.SelectedList.filter(function (y) { return y != x.vehicleMasterHashId; });
	                _this.SelectedNames = _this.SelectedNames.filter(function (y) { return y != x.licenceTag; });
	            }
	        });
	    };
	    BookingVehiclePopupComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetVehicleList();
	    };
	    BookingVehiclePopupComponent.prototype.OnSearch = function (event) {
	        this.DataListModel.searchTerm = event.searchTerm;
	        this.DataListModel.currentPage = 1;
	        this.GetVehicleList();
	    };
	    BookingVehiclePopupComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetVehicleList();
	    };
	    ;
	    BookingVehiclePopupComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetVehicleList();
	    };
	    BookingVehiclePopupComponent.prototype.OnSuccessSelect = function () {
	    };
	    __decorate([
	        core_1.Output('OnSuccessSelect'), 
	        __metadata('design:type', Object)
	    ], BookingVehiclePopupComponent.prototype, "onSuccessSelect", void 0);
	    __decorate([
	        core_1.ViewChild('vehicleModal'), 
	        __metadata('design:type', Object)
	    ], BookingVehiclePopupComponent.prototype, "vehicleModal", void 0);
	    BookingVehiclePopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-booking-vehicle-popup',
	            template: __webpack_require__(1266),
	            providers: [vehicle_service_1.VehicleService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof vehicle_service_1.VehicleService !== 'undefined' && vehicle_service_1.VehicleService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object])
	    ], BookingVehiclePopupComponent);
	    return BookingVehiclePopupComponent;
	    var _a, _b, _c, _d;
	}());
	exports.BookingVehiclePopupComponent = BookingVehiclePopupComponent;


/***/ },
/* 1266 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #vehicleModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n                    <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblSelect' | translate }} {{ 'LblVehicle' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <wego-search-list [IsExported]=\"false\" [SearchTerm]=\"DataListModel.searchTerm\" (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\"\r\n          (OnPagingChange)=\"OnPagingChange($event)\" [ItemPerPage]=\"DataListModel.itemsPerPage\" [CustomeIcon]=\"LblIcon\" [IsCustomButton]='true'\r\n          (OnCustomeButton)=\"selectMultiple()\" [IsCustomButtonEnabled]=\"SelectedList && SelectedList.length>0\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <!-- <th class=\"text-center\">\r\n                  {{ 'LblSelect' | translate }}\r\n                </th> -->\r\n                <th class=\"text-center parent-checkbox\"><input type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\"></th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('licenceTag')\">\r\n                  {{ 'LblLicenceTag' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'licenceTag'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('ownerName')\">\r\n                  {{ 'LblVehicleOwner' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'ownerName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('brand')\">\r\n                  {{ 'LblBrand' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'brand'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('type')\">\r\n                  {{ 'LblType' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'type'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('vehicleClass')\">\r\n                  {{ 'LblVehicleClass' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'vehicleClass'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('color')\">\r\n                  {{ 'LblColor' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'color'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let vehicle of vehicleList\">\r\n                  <!-- <td class=\"text-center\">\r\n                    <a class=\"cursor-pointer\" (click)=\"select(vehicle)\">\r\n                      <i class=\"fa fa-plus-square\"></i>\r\n                    </a>\r\n                  </td> -->\r\n                  <td class=\"text-center\"><input type=\"checkbox\" name=\"isActive\" (click)=\"ItemCheckChanged(vehicle.vehicleMasterHashId,vehicle.licenceTag,$event.target.checked)\"\r\n                      [(ngModel)]=\"vehicle.isChecked\">\r\n                  </td>\r\n                  <td>{{ vehicle.licenceTag }}</td>\r\n                  <td>{{vehicle.ownerName}}</td>\r\n                  <td>{{vehicle.brand}}</td>\r\n                  <td>{{vehicle.type}}</td>\r\n                  <td>{{vehicle.vehicleClass}}</td>\r\n                  <td>{{vehicle.color}}</td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0\">\r\n                <td class=\"text-center text-danger\" colspan=\"7\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 1267 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var driver_service_1 = __webpack_require__(570);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var BookingDriverPopupComponent = (function () {
	    function BookingDriverPopupComponent(driverService, authService, router, translate) {
	        this.driverService = driverService;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.SelectedNames = [];
	        this.SelectedList = [];
	        this.LblIcon = "fa fa-plus-square";
	        this.isParentCheck = false;
	        this.onSuccessSelect = new core_1.EventEmitter();
	    }
	    BookingDriverPopupComponent.prototype.ngOnInit = function () {
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.searchField = ["driverName", "firstName", "lastName"];
	    };
	    BookingDriverPopupComponent.prototype.ngOnChanges = function (change) {
	        console.log(change);
	    };
	    BookingDriverPopupComponent.prototype.show = function (SelectedList, SelectedNamesList) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.sortType = "";
	        this.DataListModel.sortReverse = null;
	        this.DataListModel.searchTerm = "";
	        this.DataListModel.infoMessage = "";
	        this.SelectedList = SelectedList;
	        this.SelectedNames = SelectedNamesList;
	        this.GetDriverList();
	        this.driverModal.show();
	    };
	    BookingDriverPopupComponent.prototype.hide = function () {
	        this.driverModal.hide();
	    };
	    BookingDriverPopupComponent.prototype.GetDriverList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.driverService.GetDriverList(this.DataListModel)
	            .subscribe(function (res) {
	            _this.driverList = res.data;
	            _this.driverList.forEach(function (x) { return x.isChecked =
	                (_this.SelectedList.indexOf(x.driverMasterHashId) > -1); });
	            _this.isParentCheck = _this.driverList.every(function (x) { return x.isChecked; });
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BookingDriverPopupComponent.prototype.select = function (driver) {
	        this.isLoading = true;
	        this.onSuccessSelect.emit({ DriverHashID: driver.driverMasterHashId, DriverName: driver.driverName });
	        this.isLoading = false;
	        this.hide();
	    };
	    BookingDriverPopupComponent.prototype.selectMultiple = function () {
	        this.isLoading = true;
	        this.onSuccessSelect.emit({ DriverHashID: this.SelectedList, DriverName: this.SelectedNames });
	        this.isLoading = false;
	        this.hide();
	    };
	    BookingDriverPopupComponent.prototype.ItemCheckChanged = function (DriverHashID, DriverName, isChecked) {
	        if (isChecked) {
	            if (this.SelectedList.indexOf(DriverHashID) == -1) {
	                this.SelectedList.push(DriverHashID);
	            }
	            if (this.SelectedNames.indexOf(DriverName) == -1) {
	                this.SelectedNames.push(DriverName);
	            }
	            this.isParentCheck = this.driverList.filter(function (x) { return x.driverMasterHashId != DriverHashID; }).every(function (x) { return x.isChecked; });
	        }
	        else {
	            this.SelectedList = this.SelectedList.filter(function (x) { return x != DriverHashID; });
	            this.SelectedNames = this.SelectedNames.filter(function (x) { return x != DriverName; });
	            this.isParentCheck = false;
	        }
	    };
	    BookingDriverPopupComponent.prototype.OnParentCheck = function (isChecked) {
	        var _this = this;
	        this.driverList.forEach(function (x) {
	            x.isChecked = isChecked;
	            if (isChecked) {
	                if (_this.SelectedList.indexOf(x.driverMasterHashId) == -1) {
	                    _this.SelectedList.push(x.driverMasterHashId);
	                }
	                if (_this.SelectedNames.indexOf(x.driverName) == -1) {
	                    _this.SelectedNames.push(x.driverName);
	                }
	            }
	            else {
	                _this.SelectedList = _this.SelectedList.filter(function (y) { return y != x.driverMasterHashId; });
	                _this.SelectedNames = _this.SelectedNames.filter(function (y) { return y != x.driverName; });
	            }
	        });
	    };
	    BookingDriverPopupComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetDriverList();
	    };
	    BookingDriverPopupComponent.prototype.OnSearch = function (event) {
	        this.DataListModel.searchTerm = event.searchTerm;
	        this.DataListModel.currentPage = 1;
	        this.GetDriverList();
	    };
	    BookingDriverPopupComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetDriverList();
	    };
	    ;
	    BookingDriverPopupComponent.prototype.OnPagingChange = function (event) {
	        console.log(this.DataListModel);
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetDriverList();
	    };
	    BookingDriverPopupComponent.prototype.OnSuccessSelect = function () {
	    };
	    __decorate([
	        core_1.Output('OnSuccessSelect'), 
	        __metadata('design:type', Object)
	    ], BookingDriverPopupComponent.prototype, "onSuccessSelect", void 0);
	    __decorate([
	        core_1.ViewChild('driverModal'), 
	        __metadata('design:type', Object)
	    ], BookingDriverPopupComponent.prototype, "driverModal", void 0);
	    BookingDriverPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-booking-driver-popup',
	            template: __webpack_require__(1268),
	            providers: [driver_service_1.DriverService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof driver_service_1.DriverService !== 'undefined' && driver_service_1.DriverService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object])
	    ], BookingDriverPopupComponent);
	    return BookingDriverPopupComponent;
	    var _a, _b, _c, _d;
	}());
	exports.BookingDriverPopupComponent = BookingDriverPopupComponent;


/***/ },
/* 1268 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #driverModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\"\r\n  [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n                    <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblSelect' | translate }} {{ 'LblDriver' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <wego-search-list [IsExported]=\"false\" [SearchTerm]=\"DataListModel.searchTerm\" (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\"\r\n          (OnPagingChange)=\"OnPagingChange($event)\" [ItemPerPage]=\"DataListModel.itemsPerPage\" [CustomeIcon]=\"LblIcon\" [IsCustomButton]='true'\r\n          (OnCustomeButton)=\"selectMultiple()\" [IsCustomButtonEnabled]=\"SelectedList && SelectedList.length>0\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <!-- <th class=\"text-center\">\r\n                  {{ 'LblSelect' | translate }}\r\n                </th> -->\r\n                <th class=\"text-center parent-checkbox\"><input type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\"></th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('driverName')\">\r\n                  {{ 'LblDriver' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'driverName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('firstName')\">\r\n                  {{ 'LblFirstName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'firstName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('lastName')\">\r\n                  {{ 'LblLastName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'lastName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let driver of driverList\">\r\n                  <!-- <td class=\"text-center\">\r\n                    <a class=\"cursor-pointer\" (click)=\"select(driver)\">\r\n                      <i class=\"fa fa-plus-square\"></i>\r\n                    </a>\r\n                  </td> -->\r\n                  <td class=\"text-center\"><input type=\"checkbox\" name=\"isActive\" (click)=\"ItemCheckChanged(driver.driverMasterHashId,driver.driverName,$event.target.checked)\"\r\n                      [(ngModel)]=\"driver.isChecked\">\r\n                  </td>\r\n                  <td>{{ driver.driverName }}</td>\r\n                  <td>{{ driver.firstName }}</td>\r\n                  <td>{{ driver.lastName }}</td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0\">\r\n                <td class=\"text-center text-danger\" colspan=\"4\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 1269 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var person_service_1 = __webpack_require__(771);
	var BookingRequestAdminPopupComponent = (function () {
	    function BookingRequestAdminPopupComponent(personService, authService, router, translate) {
	        this.personService = personService;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.SelectedNames = [];
	        this.SelectedList = [];
	        this.LblIcon = "fa fa-plus-square";
	        this.isParentCheck = false;
	        this.onSuccessSelect = new core_1.EventEmitter();
	    }
	    BookingRequestAdminPopupComponent.prototype.ngOnInit = function () {
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.searchField = ["userName", "firstName", "lastName"];
	    };
	    BookingRequestAdminPopupComponent.prototype.ngOnChanges = function (change) {
	        console.log(change);
	    };
	    BookingRequestAdminPopupComponent.prototype.show = function (SelectedList, SelectedNamesList) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.sortType = "";
	        this.DataListModel.sortReverse = null;
	        this.DataListModel.searchTerm = "";
	        this.DataListModel.infoMessage = "";
	        this.SelectedList = SelectedList;
	        this.SelectedNames = SelectedNamesList;
	        this.GetAdminList();
	        this.adminModal.show();
	    };
	    BookingRequestAdminPopupComponent.prototype.hide = function () {
	        this.adminModal.hide();
	    };
	    BookingRequestAdminPopupComponent.prototype.GetAdminList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.personService.GetAdminList(this.DataListModel)
	            .subscribe(function (res) {
	            _this.adminList = res.data;
	            _this.adminList.forEach(function (x) { return x.isChecked =
	                (_this.SelectedList.indexOf(x.personMasterHashId) > -1); });
	            _this.isParentCheck = _this.adminList.every(function (x) { return x.isChecked; });
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BookingRequestAdminPopupComponent.prototype.select = function (person) {
	        this.isLoading = true;
	        this.onSuccessSelect.emit({ PersonHashID: person.personMasterHashId, UserName: person.userName });
	        this.isLoading = false;
	        this.hide();
	    };
	    BookingRequestAdminPopupComponent.prototype.selectMultiple = function () {
	        this.isLoading = true;
	        this.onSuccessSelect.emit({ PersonHashID: this.SelectedList, UserName: this.SelectedNames });
	        this.isLoading = false;
	        this.hide();
	    };
	    BookingRequestAdminPopupComponent.prototype.ItemCheckChanged = function (personHashID, personName, isChecked) {
	        if (isChecked) {
	            if (this.SelectedList.indexOf(personHashID) == -1) {
	                this.SelectedList.push(personHashID);
	            }
	            if (this.SelectedNames.indexOf(personName) == -1) {
	                this.SelectedNames.push(personName);
	            }
	            this.isParentCheck = this.adminList.filter(function (x) { return x.personMasterHashId != personHashID; }).every(function (x) { return x.isChecked; });
	        }
	        else {
	            this.SelectedList = this.SelectedList.filter(function (x) { return x != personHashID; });
	            this.SelectedNames = this.SelectedNames.filter(function (x) { return x != personName; });
	            this.isParentCheck = false;
	        }
	    };
	    BookingRequestAdminPopupComponent.prototype.OnParentCheck = function (isChecked) {
	        var _this = this;
	        this.adminList.forEach(function (x) {
	            x.isChecked = isChecked;
	            if (isChecked) {
	                if (_this.SelectedList.indexOf(x.personMasterHashId) == -1) {
	                    _this.SelectedList.push(x.personMasterHashId);
	                }
	                if (_this.SelectedNames.indexOf(x.userName) == -1) {
	                    _this.SelectedNames.push(x.userName);
	                }
	            }
	            else {
	                _this.SelectedList = _this.SelectedList.filter(function (y) { return y != x.personMasterHashId; });
	                _this.SelectedNames = _this.SelectedNames.filter(function (y) { return y != x.userName; });
	            }
	        });
	    };
	    BookingRequestAdminPopupComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetAdminList();
	    };
	    BookingRequestAdminPopupComponent.prototype.OnSearch = function (event) {
	        this.DataListModel.searchTerm = event.searchTerm;
	        this.DataListModel.currentPage = 1;
	        this.GetAdminList();
	    };
	    BookingRequestAdminPopupComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetAdminList();
	    };
	    ;
	    BookingRequestAdminPopupComponent.prototype.OnPagingChange = function (event) {
	        console.log(this.DataListModel);
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetAdminList();
	    };
	    BookingRequestAdminPopupComponent.prototype.OnSuccessSelect = function () {
	    };
	    __decorate([
	        core_1.Output('OnSuccessSelect'), 
	        __metadata('design:type', Object)
	    ], BookingRequestAdminPopupComponent.prototype, "onSuccessSelect", void 0);
	    __decorate([
	        core_1.ViewChild('adminModal'), 
	        __metadata('design:type', Object)
	    ], BookingRequestAdminPopupComponent.prototype, "adminModal", void 0);
	    BookingRequestAdminPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-booking-request-admin-popup',
	            template: __webpack_require__(1270),
	            providers: [person_service_1.PersonService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof person_service_1.PersonService !== 'undefined' && person_service_1.PersonService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object])
	    ], BookingRequestAdminPopupComponent);
	    return BookingRequestAdminPopupComponent;
	    var _a, _b, _c, _d;
	}());
	exports.BookingRequestAdminPopupComponent = BookingRequestAdminPopupComponent;


/***/ },
/* 1270 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #adminModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\"\r\n  [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n                    <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblSelect' | translate }} {{ 'LblAdmin' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <wego-search-list [IsExported]=\"false\" [SearchTerm]=\"DataListModel.searchTerm\" (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\"\r\n          (OnPagingChange)=\"OnPagingChange($event)\" [ItemPerPage]=\"DataListModel.itemsPerPage\" [CustomeIcon]=\"LblIcon\" [IsCustomButton]='true'\r\n          (OnCustomeButton)=\"selectMultiple()\" [IsCustomButtonEnabled]=\"SelectedList && SelectedList.length>0\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <!-- <th class=\"text-center\">\r\n                  {{ 'LblSelect' | translate }}\r\n                </th> -->\r\n                <th class=\"text-center parent-checkbox\"><input type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\"></th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('userName')\">\r\n                  {{ 'LblUserName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'userName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('firstName')\">\r\n                  {{ 'LblFirstName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'firstName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('lastName')\">\r\n                  {{ 'LblLastName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'lastName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let admin of adminList\">\r\n                  <!-- <td class=\"text-center\">\r\n                    <a class=\"cursor-pointer\" (click)=\"select(driver)\">\r\n                      <i class=\"fa fa-plus-square\"></i>\r\n                    </a>\r\n                  </td> -->\r\n                  <td class=\"text-center\"><input type=\"checkbox\" name=\"isActive\" (click)=\"ItemCheckChanged(admin.personMasterHashId,admin.userName,$event.target.checked)\"\r\n                      [(ngModel)]=\"admin.isChecked\">\r\n                  </td>\r\n                  <td>{{ admin.userName }}</td>\r\n                  <td>{{ admin.firstName }}</td>\r\n                  <td>{{ admin.lastName }}</td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0\">\r\n                <td class=\"text-center text-danger\" colspan=\"4\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 1271 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var sharedvehiclegroup_service_1 = __webpack_require__(510);
	var BookingSvgPopupComponent = (function () {
	    function BookingSvgPopupComponent(sharedVehicleGroupService, authService, router, translate) {
	        this.sharedVehicleGroupService = sharedVehicleGroupService;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.companyHashIdList = "";
	        this.SelectedNames = [];
	        this.SelectedList = [];
	        this.LblIcon = "fa fa-plus-square";
	        this.isParentCheck = false;
	        this.onSuccessSelect = new core_1.EventEmitter();
	    }
	    BookingSvgPopupComponent.prototype.ngOnInit = function () {
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.searchField = ["groupName", "companyName"];
	    };
	    BookingSvgPopupComponent.prototype.ngOnChanges = function (change) {
	        console.log(change);
	    };
	    BookingSvgPopupComponent.prototype.show = function (SelectedList, SelectedNameList, companyHashId, permission) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.sortType = "";
	        this.DataListModel.sortReverse = null;
	        this.DataListModel.searchTerm = "";
	        this.DataListModel.infoMessage = "";
	        this.SelectedList = SelectedList;
	        this.SelectedNames = SelectedNameList;
	        this.companyHashIdList = companyHashId;
	        this.permissionName = permission;
	        this.GetSvgList();
	        this.svgModal.show();
	    };
	    BookingSvgPopupComponent.prototype.hide = function () {
	        this.svgModal.hide();
	    };
	    BookingSvgPopupComponent.prototype.GetSvgList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.sharedVehicleGroupService
	            .GetSharedVehicleGroupList(this.DataListModel, this.companyHashIdList, null, null, this.permissionName)
	            .subscribe(function (res) {
	            _this.svgList = res.data;
	            _this.svgList.forEach(function (x) {
	                return (x.isChecked =
	                    _this.SelectedList.indexOf(x.sharedvehiclegroupHashId) > -1);
	            });
	            _this.isParentCheck = _this.svgList.every(function (x) { return x.isChecked; });
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    BookingSvgPopupComponent.prototype.select = function (svg) {
	        this.isLoading = true;
	        this.onSuccessSelect.emit({
	            SvgMasterHashID: svg.sharedvehiclegroupHashId,
	            SvgName: svg.groupName
	        });
	        this.isLoading = false;
	        this.hide();
	    };
	    BookingSvgPopupComponent.prototype.selectMultiple = function () {
	        this.isLoading = true;
	        this.onSuccessSelect.emit({
	            SvgMasterHashID: this.SelectedList,
	            SvgName: this.SelectedNames
	        });
	        this.isLoading = false;
	        this.hide();
	    };
	    BookingSvgPopupComponent.prototype.ItemCheckChanged = function (SvgMasterHashID, svgName, isChecked) {
	        if (isChecked) {
	            if (this.SelectedList.indexOf(SvgMasterHashID) == -1) {
	                this.SelectedList.push(SvgMasterHashID);
	            }
	            if (this.SelectedNames.indexOf(svgName) == -1) {
	                this.SelectedNames.push(svgName);
	            }
	            this.isParentCheck = this.svgList
	                .filter(function (x) { return x.sharedvehiclegroupHashId != SvgMasterHashID; })
	                .every(function (x) { return x.isChecked; });
	        }
	        else {
	            this.SelectedList = this.SelectedList.filter(function (x) { return x != SvgMasterHashID; });
	            this.SelectedNames = this.SelectedNames.filter(function (x) { return x != svgName; });
	            this.isParentCheck = false;
	        }
	    };
	    BookingSvgPopupComponent.prototype.OnParentCheck = function (isChecked) {
	        var _this = this;
	        this.svgList.forEach(function (x) {
	            x.isChecked = isChecked;
	            if (isChecked) {
	                if (_this.SelectedList.indexOf(x.sharedvehiclegroupHashId) == -1) {
	                    _this.SelectedList.push(x.sharedvehiclegroupHashId);
	                }
	                if (_this.SelectedNames.indexOf(x.groupName) == -1) {
	                    _this.SelectedNames.push(x.groupName);
	                }
	            }
	            else {
	                _this.SelectedList = _this.SelectedList.filter(function (y) { return y != x.sharedvehiclegroupHashId; });
	                _this.SelectedNames = _this.SelectedNames.filter(function (y) { return y != x.groupName; });
	            }
	        });
	    };
	    BookingSvgPopupComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetSvgList();
	    };
	    BookingSvgPopupComponent.prototype.OnSearch = function (event) {
	        this.DataListModel.searchTerm = event.searchTerm;
	        this.DataListModel.currentPage = 1;
	        this.GetSvgList();
	    };
	    BookingSvgPopupComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetSvgList();
	    };
	    BookingSvgPopupComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetSvgList();
	    };
	    BookingSvgPopupComponent.prototype.OnSuccessSelect = function () { };
	    __decorate([
	        core_1.Output("OnSuccessSelect"), 
	        __metadata('design:type', Object)
	    ], BookingSvgPopupComponent.prototype, "onSuccessSelect", void 0);
	    __decorate([
	        core_1.ViewChild("svgModal"), 
	        __metadata('design:type', Object)
	    ], BookingSvgPopupComponent.prototype, "svgModal", void 0);
	    BookingSvgPopupComponent = __decorate([
	        core_1.Component({
	            selector: "wego-booking-svg-popup",
	            template: __webpack_require__(1272),
	            providers: [sharedvehiclegroup_service_1.SharedVehicleGroupService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof sharedvehiclegroup_service_1.SharedVehicleGroupService !== 'undefined' && sharedvehiclegroup_service_1.SharedVehicleGroupService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object])
	    ], BookingSvgPopupComponent);
	    return BookingSvgPopupComponent;
	    var _a, _b, _c, _d;
	}());
	exports.BookingSvgPopupComponent = BookingSvgPopupComponent;


/***/ },
/* 1272 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #svgModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\"\r\n  [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n                  <span aria-hidden=\"true\">&times;</span>\r\n      </button>\r\n        <h4 class=\"modal-title\">{{ 'LblSelect' | translate }} {{ 'LblSharedVehicleGroup' | translate }}</h4>\r\n\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <wego-search-list [IsExported]=\"false\" [SearchTerm]=\"DataListModel.searchTerm\" (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\"\r\n          (OnPagingChange)=\"OnPagingChange($event)\" [ItemPerPage]=\"DataListModel.itemsPerPage\" [CustomeIcon]=\"LblIcon\" [IsCustomButton]='true'\r\n          (OnCustomeButton)=\"selectMultiple()\" [IsCustomButtonEnabled]=\"SelectedList && SelectedList.length>0\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <!-- <th class=\"text-center\">\r\n                  {{ 'LblSelect' | translate }}\r\n                </th> -->\r\n                <th class=\"text-center parent-checkbox\"><input type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\"></th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('groupName')\">\r\n                  {{ 'LblSharedVehicleGroup' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'groupName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('companyName')\">\r\n                  {{ 'LblCompanyName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'companyName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let svg of svgList\">\r\n                  <!-- <td class=\"text-center\">\r\n                    <a class=\"cursor-pointer\" (click)=\"select(svg)\">\r\n                      <i class=\"fa fa-plus-square\"></i>\r\n                    </a>\r\n                  </td> -->\r\n                  <td class=\"text-center\"><input type=\"checkbox\" name=\"isActive\" (click)=\"ItemCheckChanged(svg.sharedvehiclegroupHashId,svg.groupName,$event.target.checked)\"\r\n                      [(ngModel)]=\"svg.isChecked\">\r\n\r\n                  </td>\r\n                  <td>{{ svg.groupName }}</td>\r\n                  <td>{{svg.companyName}}</td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0\">\r\n                <td class=\"text-center text-danger\" colspan=\"7\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 1273 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var common_1 = __webpack_require__(22);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var role_service_1 = __webpack_require__(952);
	var CopyRolePopupComponent = (function () {
	    function CopyRolePopupComponent(roleService, authService, router, translate, locationService) {
	        this.roleService = roleService;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.locationService = locationService;
	        this.selectedRoleHashId = "";
	        this.onSuccessSelect = new core_1.EventEmitter();
	    }
	    CopyRolePopupComponent.prototype.GetRoleDropdownList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.roleService
	            .GetRoleDropdownListByEntity(this.selectedRoleEntity.entity)
	            .subscribe(function (res) {
	            _this.roleList = res.data;
	            if (_this.roleList) {
	                var index = _this.roleList.findIndex(function (x) { return x.roleHashId == _this.selectedRoleEntity.roleHashId; });
	                if (index !== -1) {
	                    _this.roleList.splice(index, 1);
	                }
	            }
	            _this.selectedRoleHashId = "";
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    CopyRolePopupComponent.prototype.UpdateAccessMatrix = function () {
	        var _this = this;
	        if (this.selectedRoleHashId) {
	            this.isLoading = true;
	            this.roleService
	                .GetAccessibilityMatrixByRoleHashId(this.selectedRoleHashId)
	                .subscribe(function (res) {
	                _this.accessibilityMatrixList = res.data;
	                _this.isLoading = false;
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	                _this.isLoading = false;
	            });
	        }
	    };
	    CopyRolePopupComponent.prototype.show = function () {
	        this.accessibilityMatrixList = [];
	        this.GetRoleDropdownList();
	        this.copyRoleModal.show();
	    };
	    CopyRolePopupComponent.prototype.hide = function () {
	        this.copyRoleModal.hide();
	    };
	    CopyRolePopupComponent.prototype.CopyRoleAccessMatrix = function () {
	        this.onSuccessSelect.emit({
	            accessibilityMatrixList: this.accessibilityMatrixList
	        });
	        this.hide();
	    };
	    __decorate([
	        core_1.Output("OnSuccessSelect"), 
	        __metadata('design:type', Object)
	    ], CopyRolePopupComponent.prototype, "onSuccessSelect", void 0);
	    __decorate([
	        core_1.ViewChild("copyRoleModal"), 
	        __metadata('design:type', Object)
	    ], CopyRolePopupComponent.prototype, "copyRoleModal", void 0);
	    CopyRolePopupComponent = __decorate([
	        core_1.Component({
	            selector: "wego-copy-role-popup",
	            template: __webpack_require__(1274)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof role_service_1.RoleService !== 'undefined' && role_service_1.RoleService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object, (typeof (_e = typeof common_1.Location !== 'undefined' && common_1.Location) === 'function' && _e) || Object])
	    ], CopyRolePopupComponent);
	    return CopyRolePopupComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.CopyRolePopupComponent = CopyRolePopupComponent;


/***/ },
/* 1274 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #copyRoleModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblCopyAccessibilityMatrix' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <div class=\"form-group col-md-4\">\r\n          <label>\r\n            <span class=\"text text-danger\">*</span>{{ 'LblRoleManagement' | translate }}</label>\r\n          <select [(ngModel)]=\"selectedRoleHashId\" class=\"form-control\" name=\"entity\" (ngModelChange)=\"UpdateAccessMatrix()\">\r\n            <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblRoleManagement' | translate }}</option>\r\n            <option *ngFor=\"let item of roleList\" [ngValue]=\"item.roleHashId\">{{ item.roleName }}</option>\r\n          </select>\r\n        </div>\r\n        <div class=\"form-group col-md-1 mar_t_25\">\r\n          <button *ngIf=\"selectedRoleHashId\" class=\"btn btn-green\" type=\"button\" (click)=\"CopyRoleAccessMatrix()\" routerLinkActive=\"active\">\r\n            {{ 'LblCopy' | translate }}</button>\r\n        </div>\r\n\r\n        <div class=\"clearfix\"></div>\r\n\r\n        <template [ngIf]=\"selectedRoleHashId\">\r\n          <div class=\"row col-md-12\">\r\n            <fieldset class=\"col-md-12\">\r\n              <legend class=\"legendStyle\">\r\n                <div class=\"pull-left\">\r\n                  {{ 'LblAccessibilityMatrix' | translate }}\r\n                </div>\r\n              </legend>\r\n\r\n              <div class=\"clearfix\"></div>\r\n\r\n              <div class=\"table table-responsive mar_bot_ziro\">\r\n                <table class=\"table table-bordered mar_bot_ziro\">\r\n                  <thead>\r\n                    <tr>\r\n                      <th>{{ 'LblAccess' | translate }}</th>\r\n                      <th class=\"text-center\">{{ 'LblView' | translate }}</th>\r\n                      <th class=\"text-center\">{{ 'LblAdd' | translate }}</th>\r\n                      <th class=\"text-center\">{{ 'LblUpdate' | translate }}</th>\r\n                      <th class=\"text-center\">{{ 'LblDelete' | translate }}</th>\r\n                    </tr>\r\n                  </thead>\r\n                  <tbody>\r\n\r\n                    <template ngFor let-item [ngForOf]=\"accessibilityMatrixList\" let-i=\"index\">\r\n\r\n                      <template [ngIf]=\"i == 0 || item.logicalGroupName != accessibilityMatrixList[i-1].logicalGroupName\">\r\n                        <tr>\r\n                          <td colspan=\"5\">\r\n                            <b>{{item.logicalGroupName | translate}}</b>\r\n                          </td>\r\n                        </tr>\r\n                      </template>\r\n\r\n                      <tr>\r\n                        <td>{{item.permissionName | translate}} </td>\r\n                        <td class=\"text-center\">\r\n                          <input type=\"checkbox\" disabled [name]=\"i + '_view'\" [(ngModel)]=\"item.view\">\r\n                        </td>\r\n                        <td class=\"text-center\">\r\n                          <input type=\"checkbox\" disabled [name]=\"i + '_insert'\" [(ngModel)]=\"item.insert\">\r\n                        </td>\r\n                        <td class=\"text-center\">\r\n                          <input type=\"checkbox\" disabled [name]=\"i + '_edit'\" [(ngModel)]=\"item.edit\">\r\n                        </td>\r\n                        <td class=\"text-center\">\r\n                          <input type=\"checkbox\" disabled [name]=\"i + '_delete'\" [(ngModel)]=\"item.delete\">\r\n                        </td>\r\n                      </tr>\r\n                    </template>\r\n                  </tbody>\r\n                </table>\r\n              </div>\r\n            </fieldset>\r\n          </div>\r\n          <div class=\"clearfix\"></div>\r\n        </template>\r\n\r\n        <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n      </div>\r\n    </div>\r\n  </div>";

/***/ },
/* 1275 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var modal_1 = __webpack_require__(537);
	var core_1 = __webpack_require__(3);
	var translate_service_1 = __webpack_require__(70);
	var roleavailability_model_1 = __webpack_require__(959);
	var roleavailability_service_1 = __webpack_require__(958);
	var auth_service_1 = __webpack_require__(58);
	var RoleAvailabilityPopupComponent = (function () {
	    function RoleAvailabilityPopupComponent(translate, roleAvailabilityService, authService) {
	        this.translate = translate;
	        this.roleAvailabilityService = roleAvailabilityService;
	        this.authService = authService;
	        this.ErrorMsg = '';
	        this.errorModel = [];
	        this._popupTitle = this.translate.instant('LblRoleAvailability');
	        this.onConfirm = new core_1.EventEmitter();
	        this.onCancel = new core_1.EventEmitter();
	    }
	    Object.defineProperty(RoleAvailabilityPopupComponent.prototype, "popupTitle", {
	        get: function () { return this._popupTitle; },
	        set: function (popupTitle) {
	            this._popupTitle = (popupTitle && popupTitle.trim()) || this.translate.instant('LblRoleAvailability');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(RoleAvailabilityPopupComponent.prototype, "model", {
	        get: function () { return this._model; },
	        set: function (model) {
	            this._model = model;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    RoleAvailabilityPopupComponent.prototype.ngOnInit = function () {
	    };
	    RoleAvailabilityPopupComponent.prototype.show = function () {
	        this.ErrorMsg = "";
	        this.errorModel = [];
	        this.UpdateRoleAvailabilityModal.show();
	    };
	    RoleAvailabilityPopupComponent.prototype.hide = function () {
	        this.UpdateRoleAvailabilityModal.hide();
	    };
	    RoleAvailabilityPopupComponent.prototype.Confirm = function ($event) {
	        var _this = this;
	        this.roleAvailabilityService.UpdateRoleAvailability(this.model)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.hide();
	                _this.onConfirm.emit();
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.ErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    RoleAvailabilityPopupComponent.prototype.Reject = function ($event) {
	        this.hide();
	        this.onCancel.emit($event);
	    };
	    RoleAvailabilityPopupComponent.prototype.ngOnDestroy = function () {
	    };
	    __decorate([
	        core_1.ViewChild('UpdateRoleAvailabilityModal'), 
	        __metadata('design:type', (typeof (_a = typeof modal_1.ModalDirective !== 'undefined' && modal_1.ModalDirective) === 'function' && _a) || Object)
	    ], RoleAvailabilityPopupComponent.prototype, "UpdateRoleAvailabilityModal", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String), 
	        __metadata('design:paramtypes', [String])
	    ], RoleAvailabilityPopupComponent.prototype, "popupTitle", null);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_b = typeof roleavailability_model_1.RoleAvailabilityModel !== 'undefined' && roleavailability_model_1.RoleAvailabilityModel) === 'function' && _b) || Object), 
	        __metadata('design:paramtypes', [(typeof (_c = typeof roleavailability_model_1.RoleAvailabilityModel !== 'undefined' && roleavailability_model_1.RoleAvailabilityModel) === 'function' && _c) || Object])
	    ], RoleAvailabilityPopupComponent.prototype, "model", null);
	    __decorate([
	        core_1.Output('onConfirm'), 
	        __metadata('design:type', Object)
	    ], RoleAvailabilityPopupComponent.prototype, "onConfirm", void 0);
	    __decorate([
	        core_1.Output('onCancel'), 
	        __metadata('design:type', Object)
	    ], RoleAvailabilityPopupComponent.prototype, "onCancel", void 0);
	    RoleAvailabilityPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-roleavailability-update-popup',
	            template: __webpack_require__(1276),
	            providers: [roleavailability_service_1.RoleAvailabilityService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object, (typeof (_e = typeof roleavailability_service_1.RoleAvailabilityService !== 'undefined' && roleavailability_service_1.RoleAvailabilityService) === 'function' && _e) || Object, (typeof (_f = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _f) || Object])
	    ], RoleAvailabilityPopupComponent);
	    return RoleAvailabilityPopupComponent;
	    var _a, _b, _c, _d, _e, _f;
	}());
	exports.RoleAvailabilityPopupComponent = RoleAvailabilityPopupComponent;


/***/ },
/* 1276 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #UpdateRoleAvailabilityModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-sm\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ popupTitle }}</h4>\r\n      </div>\r\n      <div *ngIf=\"model\" class=\"modal-body\">\r\n        <span class=\"text text-danger\">{{ ErrorMsg}}</span>\r\n        <div class=\"row\">\r\n          <div class=\"form-group col-xs-12\">\r\n            <label>\r\n              {{ 'LblInternalRoleName' | translate }}\r\n            </label>\r\n            <input disabled type=\"text\" class=\"form-control\" name=\"internalRoleName\" [(ngModel)]=\"model.internalRoleName\">\r\n          </div>\r\n        </div>\r\n        <div class=\"row\">\r\n          <div class=\"form-group col-xs-12\">\r\n            <label>\r\n              {{ 'LblEntityName' | translate }}\r\n            </label>\r\n            <input disabled type=\"text\" class=\"form-control\" name=\"entity\" [(ngModel)]=\"model.entity\">\r\n          </div>\r\n        </div>\r\n        <div class=\"row\">\r\n          <div class=\"form-group col-xs-12\">\r\n            <label>\r\n              {{ 'LblRoleType' | translate }}\r\n            </label>\r\n            <input disabled type=\"text\" class=\"form-control\" name=\"roleType\" [(ngModel)]=\"model.roleType\">\r\n          </div>\r\n        </div>\r\n        <div class=\"row\">\r\n          <div class=\"form-group col-xs-12\">\r\n            <label>\r\n              <span class=\"text text-danger\">*</span>{{ 'LblPresentationName' | translate }}\r\n            </label>\r\n            <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblPresentationName' | translate }}\" name=\"PresentationName\" [(ngModel)]=\"model.presentationName\"\r\n              maxlength=\"50\">\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'presentationName' }}</span>\r\n          </div>           \r\n        </div>\r\n      </div>\r\n      <div class=\"modal-footer\">\r\n        <button type=\"button\" class=\"btn btn-green\" (click)=\"Confirm($event)\">{{ 'LblOK' | translate }}</button>\r\n        <button type=\"button\" class=\"btn btn-gray\" (click)=\"Reject($event)\">{{ 'LblCancel' | translate }}</button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 1277 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var modal_1 = __webpack_require__(537);
	var core_1 = __webpack_require__(3);
	var translate_service_1 = __webpack_require__(70);
	var roleavailability_service_1 = __webpack_require__(958);
	var auth_service_1 = __webpack_require__(58);
	var SaveRoleAvailablityPopupComponent = (function () {
	    function SaveRoleAvailablityPopupComponent(translate, roleAvailabilityService, authService) {
	        this.translate = translate;
	        this.roleAvailabilityService = roleAvailabilityService;
	        this.authService = authService;
	        this.errorModel = [];
	        this._popupTitle = this.translate.instant('LblAssign') + " " + this.translate.instant('LblRole');
	        this.onConfirm = new core_1.EventEmitter();
	        this.onCancel = new core_1.EventEmitter();
	    }
	    Object.defineProperty(SaveRoleAvailablityPopupComponent.prototype, "popupTitle", {
	        get: function () { return this._popupTitle; },
	        set: function (popupTitle) {
	            this._popupTitle = (popupTitle && popupTitle.trim()) || this.translate.instant('LblRoleAvailability');
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(SaveRoleAvailablityPopupComponent.prototype, "model", {
	        get: function () { return this._model; },
	        set: function (model) {
	            this._model = model;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SaveRoleAvailablityPopupComponent.prototype.ngOnInit = function () {
	    };
	    SaveRoleAvailablityPopupComponent.prototype.show = function () {
	        this.ErrorMsg = "";
	        this.errorModel = [];
	        this.saveRoleAvailabilityModal.show();
	    };
	    SaveRoleAvailablityPopupComponent.prototype.hide = function () {
	        this.saveRoleAvailabilityModal.hide();
	    };
	    SaveRoleAvailablityPopupComponent.prototype.Confirm = function ($event) {
	        var _this = this;
	        this.ErrorMsg = "";
	        this.roleAvailabilityService.AddRoleAvailability(this.model)
	            .subscribe(function (res) {
	            if (res.data) {
	                _this.hide();
	                _this.onConfirm.emit();
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.ErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    SaveRoleAvailablityPopupComponent.prototype.Reject = function ($event) {
	        this.hide();
	        this.onCancel.emit($event);
	    };
	    SaveRoleAvailablityPopupComponent.prototype.GetErrorKey = function (i) {
	        var errorKey = 'model[' + i + '].PresentationName';
	        return errorKey;
	    };
	    SaveRoleAvailablityPopupComponent.prototype.ngOnDestroy = function () {
	    };
	    __decorate([
	        core_1.ViewChild('saveRoleAvailabilityModal'), 
	        __metadata('design:type', (typeof (_a = typeof modal_1.ModalDirective !== 'undefined' && modal_1.ModalDirective) === 'function' && _a) || Object)
	    ], SaveRoleAvailablityPopupComponent.prototype, "saveRoleAvailabilityModal", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String), 
	        __metadata('design:paramtypes', [String])
	    ], SaveRoleAvailablityPopupComponent.prototype, "popupTitle", null);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array), 
	        __metadata('design:paramtypes', [Array])
	    ], SaveRoleAvailablityPopupComponent.prototype, "model", null);
	    __decorate([
	        core_1.Output('onConfirm'), 
	        __metadata('design:type', Object)
	    ], SaveRoleAvailablityPopupComponent.prototype, "onConfirm", void 0);
	    __decorate([
	        core_1.Output('onCancel'), 
	        __metadata('design:type', Object)
	    ], SaveRoleAvailablityPopupComponent.prototype, "onCancel", void 0);
	    SaveRoleAvailablityPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-save-roleavailability-popup',
	            template: __webpack_require__(1278),
	            providers: [roleavailability_service_1.RoleAvailabilityService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _b) || Object, (typeof (_c = typeof roleavailability_service_1.RoleAvailabilityService !== 'undefined' && roleavailability_service_1.RoleAvailabilityService) === 'function' && _c) || Object, (typeof (_d = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _d) || Object])
	    ], SaveRoleAvailablityPopupComponent);
	    return SaveRoleAvailablityPopupComponent;
	    var _a, _b, _c, _d;
	}());
	exports.SaveRoleAvailablityPopupComponent = SaveRoleAvailablityPopupComponent;


/***/ },
/* 1278 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #saveRoleAvailabilityModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ popupTitle }}</h4>\r\n      </div>\r\n      <div *ngIf=\"model\" class=\"modal-body\">\r\n        <span class=\"text text-danger\">{{ ErrorMsg}}</span>\r\n        <table class=\"table table-bordered mar_bot_ziro\">\r\n          <thead>\r\n            <tr>\r\n              <th class=\"cursor-pointer\">\r\n                {{ 'LblRoleName' | translate }}\r\n              </th>\r\n              <th class=\"cursor-pointer\">\r\n                {{ 'LblEntityName' | translate }}\r\n              </th>\r\n              <th class=\"cursor-pointer\">\r\n                {{ 'LblPresentationName' | translate }}\r\n              </th>\r\n            </tr>\r\n          </thead>\r\n          <tbody>\r\n            <template [ngIf]=\"model\">\r\n              <tr *ngFor=\"let roleAvailability of model; let i = index;\">\r\n                <td>{{ roleAvailability.internalRoleName }}</td>\r\n                <td>{{ roleAvailability.entity }}</td>\r\n                <td>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblPresentationName' | translate }}\" name=\"PresentationName\" [(ngModel)]=\"roleAvailability.presentationName\"\r\n                    maxlength=\"50\">\r\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : GetErrorKey(i) }}</span>\r\n                </td>\r\n              </tr>\r\n            </template>\r\n          </tbody>\r\n        </table>\r\n      </div>\r\n      <div class=\"modal-footer\">\r\n        <button type=\"button\" class=\"btn btn-green\" (click)=\"Confirm($event)\">{{ 'LblOK' | translate }}</button>\r\n        <button type=\"button\" class=\"btn btn-gray\" (click)=\"Reject($event)\">{{ 'LblCancel' | translate }}</button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 1279 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var config_1 = __webpack_require__(60);
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var roleavailability_service_1 = __webpack_require__(958);
	var AssignRoleToCustomerComponent = (function () {
	    function AssignRoleToCustomerComponent(translate, roleAvailabilityService, authService) {
	        this.translate = translate;
	        this.roleAvailabilityService = roleAvailabilityService;
	        this.authService = authService;
	        this.isParentCheck = false;
	        this.onConfirm = new core_1.EventEmitter();
	    }
	    Object.defineProperty(AssignRoleToCustomerComponent.prototype, "customerHashId", {
	        get: function () { return this._customerHashId; },
	        set: function (customerHashId) {
	            this._customerHashId = customerHashId;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    AssignRoleToCustomerComponent.prototype.ngOnInit = function () {
	        this.LblAssignToCustomer = this.translate.instant('LblAssign') + " " + this.translate.instant('LblRole');
	        this.LblIcon = 'fa fa-plus-square';
	        this.breadCrumbTitle = this.LblAssignToCustomer;
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.searchField = ["roleName", "entity", "roleType"];
	    };
	    AssignRoleToCustomerComponent.prototype.show = function () {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.sortType = "";
	        this.DataListModel.sortReverse = null;
	        this.DataListModel.searchTerm = "";
	        this.DataListModel.infoMessage = "";
	        this.GetRoleList();
	        this.assignToCustomerModal.show();
	    };
	    AssignRoleToCustomerComponent.prototype.hide = function () {
	        this.assignToCustomerModal.hide();
	    };
	    AssignRoleToCustomerComponent.prototype.GetRoleList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.roleAvailabilityService.GetRoleForAssignToCustomer(this.DataListModel, this.customerHashId)
	            .subscribe(function (res) {
	            _this.roleList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AssignRoleToCustomerComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetRoleList();
	    };
	    AssignRoleToCustomerComponent.prototype.OnSearch = function (event) {
	        this.DataListModel.searchTerm = event.searchTerm;
	        this.DataListModel.currentPage = 1;
	        this.GetRoleList();
	    };
	    AssignRoleToCustomerComponent.prototype.OnParentCheck = function (isChecked) {
	        this.roleList.forEach(function (x) { return x.isChecked = isChecked; });
	    };
	    AssignRoleToCustomerComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetRoleList();
	    };
	    ;
	    AssignRoleToCustomerComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetRoleList();
	    };
	    AssignRoleToCustomerComponent.prototype.OnAdd = function (event) {
	        var roleModelList;
	        roleModelList = this.roleList.filter(function (x) { return x.isChecked; });
	        this.OnSuccessSelect(roleModelList);
	        this.assignToCustomerModal.hide();
	    };
	    AssignRoleToCustomerComponent.prototype.OnSuccessSelect = function (roleModelList) {
	        this.onConfirm.emit({ RoleModelList: roleModelList });
	    };
	    Object.defineProperty(AssignRoleToCustomerComponent.prototype, "isAnyChecked", {
	        get: function () {
	            if (this.roleList && this.roleList.length > 0) {
	                var isCheck = this.roleList.some(function (x) { return x.isChecked == true; });
	                if (isCheck) {
	                    if (this.roleList.every(function (x) { return x.isChecked == true; }))
	                        this.isParentCheck = true;
	                    else
	                        this.isParentCheck = false;
	                }
	                else {
	                    this.isParentCheck = false;
	                }
	                return isCheck;
	            }
	            else {
	                this.isParentCheck = false;
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    __decorate([
	        core_1.Output('onConfirm'), 
	        __metadata('design:type', Object)
	    ], AssignRoleToCustomerComponent.prototype, "onConfirm", void 0);
	    __decorate([
	        core_1.ViewChild('assignToCustomerModal'), 
	        __metadata('design:type', Object)
	    ], AssignRoleToCustomerComponent.prototype, "assignToCustomerModal", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String), 
	        __metadata('design:paramtypes', [String])
	    ], AssignRoleToCustomerComponent.prototype, "customerHashId", null);
	    AssignRoleToCustomerComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-assign-role-to-customer-popup',
	            template: __webpack_require__(1280),
	            providers: [roleavailability_service_1.RoleAvailabilityService],
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _a) || Object, (typeof (_b = typeof roleavailability_service_1.RoleAvailabilityService !== 'undefined' && roleavailability_service_1.RoleAvailabilityService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object])
	    ], AssignRoleToCustomerComponent);
	    return AssignRoleToCustomerComponent;
	    var _a, _b, _c;
	}());
	exports.AssignRoleToCustomerComponent = AssignRoleToCustomerComponent;


/***/ },
/* 1280 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #assignToCustomerModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ breadCrumbTitle }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <wego-search-list [IsExported]=\"false\" [SearchTerm]=\"DataListModel.searchTerm\" [CustomeIcon]=\"LblIcon\" [IsCustomButton]='true'\r\n          [Title]=\"LblAssignToSvg\" [IsCustomButtonEnabled]=\"isAnyChecked\" (OnCustomeButton)=\"OnAdd($event)\" (OnSearch)=\"OnSearch($event)\"\r\n          (OnPagingChange)=\"OnPagingChange($event)\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center parent-checkbox\">\r\n                  <input type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\">\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('roleName')\">\r\n                  {{ 'LblRoleName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'roleName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('entity')\">\r\n                  {{ 'LblEntityName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'entity'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('roleType')\">\r\n                  {{ 'LblRoleType' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'roleType'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let role of roleList\">\r\n                  <td class=\"text-center\">\r\n                    <input type=\"checkbox\" name=\"isActive\" [(ngModel)]=\"role.isChecked\">\r\n                  </td>\r\n                  <td>{{ role.roleName }}</td>\r\n                  <td>{{ role.entity }}</td>\r\n                  <td>{{ role.roleType }}</td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0\">\r\n                <td class=\"text-center text-danger\" colspan=\"4\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n          <div class=\"clearfix\"></div>\r\n          <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n            <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n              <div class=\"col-md-12\">\r\n                <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                  [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                  lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 1281 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var modal_1 = __webpack_require__(537);
	var core_1 = __webpack_require__(3);
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var InviteAdminPopupComponent = (function () {
	    function InviteAdminPopupComponent(translate, authService) {
	        this.translate = translate;
	        this.authService = authService;
	        this.availablePersons = [];
	        this.ErrorMsg = '';
	        this.errorModel = [];
	        this._popupTitle = this.translate.instant('LblInvite');
	        this.availableRoles = [];
	        this.personHashId = "";
	        this.onConfirm = new core_1.EventEmitter();
	        this.onCancel = new core_1.EventEmitter();
	        this.onEmailSearch = new core_1.EventEmitter();
	    }
	    Object.defineProperty(InviteAdminPopupComponent.prototype, "popupTitle", {
	        get: function () { return this._popupTitle; },
	        set: function (popupTitle) {
	            this._popupTitle = (popupTitle && popupTitle.trim());
	        },
	        enumerable: true,
	        configurable: true
	    });
	    InviteAdminPopupComponent.prototype.ngOnInit = function () {
	    };
	    InviteAdminPopupComponent.prototype.show = function () {
	        this.ErrorMsg = "";
	        this.errorModel = [];
	        this.personHashId = "";
	        this.email = "";
	        this.availablePersons = [];
	        this.InviteAdminModal.show();
	    };
	    InviteAdminPopupComponent.prototype.hide = function () {
	        this.InviteAdminModal.hide();
	    };
	    InviteAdminPopupComponent.prototype.Confirm = function ($event) {
	        var selectedRoleId = this.availableRoles.filter(function (x) { return x.isChecked; }).map(function (y) { return y.roleHashId; });
	        this.onConfirm.emit({ emailAddress: this.email, personHashId: this.personHashId, roleHashIdList: selectedRoleId });
	    };
	    InviteAdminPopupComponent.prototype.Reject = function ($event) {
	        this.hide();
	        this.onCancel.emit($event);
	    };
	    InviteAdminPopupComponent.prototype.SearchUsers = function () {
	        this.onEmailSearch.emit({ emailAddress: this.email });
	    };
	    InviteAdminPopupComponent.prototype.EmailAddressChange = function () {
	        this.personHashId = "";
	        this.availablePersons = [];
	    };
	    InviteAdminPopupComponent.prototype.ngOnDestroy = function () {
	    };
	    __decorate([
	        core_1.ViewChild('InviteAdminModal'), 
	        __metadata('design:type', (typeof (_a = typeof modal_1.ModalDirective !== 'undefined' && modal_1.ModalDirective) === 'function' && _a) || Object)
	    ], InviteAdminPopupComponent.prototype, "InviteAdminModal", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String), 
	        __metadata('design:paramtypes', [String])
	    ], InviteAdminPopupComponent.prototype, "popupTitle", null);
	    __decorate([
	        core_1.Output('onConfirm'), 
	        __metadata('design:type', Object)
	    ], InviteAdminPopupComponent.prototype, "onConfirm", void 0);
	    __decorate([
	        core_1.Output('onCancel'), 
	        __metadata('design:type', Object)
	    ], InviteAdminPopupComponent.prototype, "onCancel", void 0);
	    __decorate([
	        core_1.Output('onEmailSearch'), 
	        __metadata('design:type', Object)
	    ], InviteAdminPopupComponent.prototype, "onEmailSearch", void 0);
	    InviteAdminPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-invite-admin-popup',
	            template: __webpack_require__(1282),
	            providers: []
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object])
	    ], InviteAdminPopupComponent);
	    return InviteAdminPopupComponent;
	    var _a, _b, _c;
	}());
	exports.InviteAdminPopupComponent = InviteAdminPopupComponent;


/***/ },
/* 1282 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #InviteAdminModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ popupTitle }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <span class=\"text text-danger\">{{ ErrorMsg}}</span>\r\n        <div class=\"row\">\r\n          <form>\r\n            <div class=\"form-group col-xs-12\">\r\n              <label>\r\n                <span class=\"text text-danger\">*</span>{{ 'LblEmail' | translate }}\r\n              </label>\r\n              <div class=\"input-group col-xs-6\">\r\n                <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblEmail' | translate }}\" name=\"email\" [(ngModel)]=\"email\" maxlength=\"100\"\r\n                  (ngModelChange)=\"EmailAddressChange()\">\r\n                <div class=\"input-group-btn\">\r\n                  <button class=\"btn btn-default search-icon\" type=\"submit\" (click)=\"SearchUsers()\">\r\n                    <i class=\"fa fa-search\" aria-hidden=\"true\"></i>\r\n                  </button>\r\n                </div>\r\n              </div>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'EmailAddress' }}</span>\r\n            </div>\r\n          </form>\r\n        </div>\r\n        <div class=\"row\">\r\n          <div class=\"form-group col-xs-6\">\r\n            <label>\r\n              <span class=\"text text-danger\">*</span>{{ 'LblPerson' | translate }}\r\n            </label>\r\n            <div *ngIf=\"availablePersons\">\r\n              <div class=\"radio\">\r\n                <label>\r\n                  <input type=\"radio\" [(ngModel)]=\"personHashId\" name=\"personHashId\" value=\"0\">{{ 'LblCreateNew' | translate }}\r\n                </label>\r\n              </div>\r\n              <div class=\"radio\" *ngFor=\"let person of availablePersons\">\r\n                <label>\r\n                  <input type=\"radio\" [(ngModel)]=\"personHashId\" name=\"personHashId\" [value]=\"person.personHashId\"> {{ person.userName }}\r\n                </label>\r\n              </div>\r\n              <div class=\"clearfix\"></div>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'personHashId' }}</span>\r\n            </div>\r\n          </div>\r\n          <div class=\"form-group col-xs-6\">\r\n            <label>\r\n              <span class=\"text text-danger\">*</span>{{ 'LblRole' | translate }}\r\n            </label>\r\n            <div *ngFor=\"let role of availableRoles\" class=\"checkbox\">\r\n              <label>\r\n                <input type=\"checkbox\" name=\"role.internalName\" [(ngModel)]=\"role.isChecked\">{{role.presentationName}}</label>\r\n            </div>\r\n            <div class=\"clearfix\"></div>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'roleIdList' }}</span>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"modal-footer\">\r\n        <button type=\"button\" class=\"btn btn-green\" (click)=\"Confirm($event)\">{{ 'LblInvite' | translate }}</button>\r\n        <button type=\"button\" class=\"btn btn-gray\" (click)=\"Reject($event)\">{{ 'LblCancel' | translate }}</button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 1283 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var organization_subscription_model_1 = __webpack_require__(1284);
	var organization_subscription_service_1 = __webpack_require__(984);
	var AssignOrganizationSubscriptionPopupComponent = (function () {
	    function AssignOrganizationSubscriptionPopupComponent(organizationSubscriptionService, authService, router, translate) {
	        this.organizationSubscriptionService = organizationSubscriptionService;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.onSuccessSelect = new core_1.EventEmitter();
	    }
	    Object.defineProperty(AssignOrganizationSubscriptionPopupComponent.prototype, "isAnyChecked", {
	        get: function () {
	            if (this.subscriptionList) {
	                var isCheck = this.subscriptionList.some(function (x) { return x.isChecked == true; });
	                if (isCheck) {
	                    if (this.subscriptionList.every(function (x) { return x.isChecked == true; }))
	                        this.isParentCheck = true;
	                    else
	                        this.isParentCheck = false;
	                }
	                else {
	                    this.isParentCheck = false;
	                }
	                return isCheck;
	            }
	            else {
	                this.isParentCheck = false;
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    AssignOrganizationSubscriptionPopupComponent.prototype.ngOnInit = function () {
	        this.LblAssignSubscription = this.translate.instant('LblAssign') + this.translate.instant('LblSubscription');
	        this.LblIcon = 'fa fa-plus-square';
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.searchField = ["name", "groupName", "timeInterval", "invoiceInterval", "paymentInterval"];
	    };
	    AssignOrganizationSubscriptionPopupComponent.prototype.ngOnChanges = function (change) {
	        console.log(change);
	    };
	    AssignOrganizationSubscriptionPopupComponent.prototype.show = function () {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.sortType = "";
	        this.DataListModel.sortReverse = null;
	        this.DataListModel.searchTerm = "";
	        this.DataListModel.infoMessage = "";
	        this.GetSubscriptionListForOrganization();
	        this.subscriptionModel.show();
	    };
	    AssignOrganizationSubscriptionPopupComponent.prototype.hide = function () {
	        this.subscriptionModel.hide();
	    };
	    AssignOrganizationSubscriptionPopupComponent.prototype.GetSubscriptionListForOrganization = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.organizationSubscriptionService.GetSubscriptionListByOrganizationToInstance(this.OrganizationHashId, this.DataListModel)
	            .subscribe(function (res) {
	            _this.subscriptionList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AssignOrganizationSubscriptionPopupComponent.prototype.OnParentCheck = function (isChecked) {
	        this.subscriptionList.forEach(function (x) { return x.isChecked = isChecked; });
	    };
	    AssignOrganizationSubscriptionPopupComponent.prototype.select = function (subscriptionHashId) {
	        var _this = this;
	        this.isLoading = true;
	        var model = new organization_subscription_model_1.OrganizationSubscriptionModel();
	        model.subscriptionHashId = subscriptionHashId;
	        model.organizationHashId = this.OrganizationHashId;
	        this.organizationSubscriptionService.AssignSubscriptionToOrganization(model)
	            .subscribe(function (res) {
	            _this.message = _this.translate.instant('LblRecordSavedSuccess');
	            _this.OnSuccessSelect();
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        }, function () {
	            _this.subscriptionModel.hide();
	            _this.isLoading = false;
	        });
	    };
	    AssignOrganizationSubscriptionPopupComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetSubscriptionListForOrganization();
	    };
	    AssignOrganizationSubscriptionPopupComponent.prototype.OnSearch = function (event) {
	        this.DataListModel.searchTerm = event.searchTerm;
	        this.DataListModel.currentPage = 1;
	        this.GetSubscriptionListForOrganization();
	    };
	    AssignOrganizationSubscriptionPopupComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetSubscriptionListForOrganization();
	    };
	    ;
	    AssignOrganizationSubscriptionPopupComponent.prototype.OnPagingChange = function (event) {
	        console.log(this.DataListModel);
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetSubscriptionListForOrganization();
	    };
	    AssignOrganizationSubscriptionPopupComponent.prototype.OnSuccessSelect = function () {
	        this.onSuccessSelect.emit({ SuccessMessage: this.message });
	    };
	    AssignOrganizationSubscriptionPopupComponent.prototype.OnAdd = function (event) {
	        var _this = this;
	        var subscriptionHashIdList;
	        subscriptionHashIdList = this.subscriptionList.filter(function (x) { return x.isChecked; }).map(function (x) { return x.sharedVehicleSubscriptionHashId; });
	        this.isLoading = true;
	        var model = new organization_subscription_model_1.OrganizationSubscriptionModel();
	        model.listOfSubscriptionHashId = subscriptionHashIdList;
	        model.organizationHashId = this.OrganizationHashId;
	        this.organizationSubscriptionService.AssignSubscriptionToOrganization(model)
	            .subscribe(function (res) {
	            _this.message = _this.translate.instant('LblRecordSavedSuccess');
	            _this.OnSuccessSelect();
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        }, function () {
	            _this.subscriptionModel.hide();
	            _this.isLoading = false;
	        });
	    };
	    __decorate([
	        core_1.Output('OnSuccessSelect'), 
	        __metadata('design:type', Object)
	    ], AssignOrganizationSubscriptionPopupComponent.prototype, "onSuccessSelect", void 0);
	    __decorate([
	        core_1.ViewChild('subscriptionModel'), 
	        __metadata('design:type', Object)
	    ], AssignOrganizationSubscriptionPopupComponent.prototype, "subscriptionModel", void 0);
	    AssignOrganizationSubscriptionPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-assign-subscription-to-organization-popup',
	            template: __webpack_require__(1285),
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof organization_subscription_service_1.OrganizationSubscriptionService !== 'undefined' && organization_subscription_service_1.OrganizationSubscriptionService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object])
	    ], AssignOrganizationSubscriptionPopupComponent);
	    return AssignOrganizationSubscriptionPopupComponent;
	    var _a, _b, _c, _d;
	}());
	exports.AssignOrganizationSubscriptionPopupComponent = AssignOrganizationSubscriptionPopupComponent;


/***/ },
/* 1284 */
/***/ function(module, exports) {

	"use strict";
	var OrganizationSubscriptionModel = (function () {
	    function OrganizationSubscriptionModel() {
	        this.listOfSubscriptionHashId = [];
	    }
	    return OrganizationSubscriptionModel;
	}());
	exports.OrganizationSubscriptionModel = OrganizationSubscriptionModel;
	var SubscriptionModel = (function () {
	    function SubscriptionModel() {
	        this.timeInterval = '';
	        this.sharedVehicleGroupHashId = '';
	        this.contractTypeGroupList = [];
	        this.paymentInterval = '';
	        this.invoiceInterval = '';
	        this.freeKilometerInterval = '';
	        this.freeMinuteInterval = '';
	    }
	    return SubscriptionModel;
	}());
	exports.SubscriptionModel = SubscriptionModel;
	var SubscriptionDropDownModel = (function () {
	    function SubscriptionDropDownModel() {
	    }
	    return SubscriptionDropDownModel;
	}());
	exports.SubscriptionDropDownModel = SubscriptionDropDownModel;


/***/ },
/* 1285 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #subscriptionModel=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n                    <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblAssign' | translate }} {{ 'LblSubscription' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <wego-search-list [IsExported]=\"false\" [SearchTerm]=\"DataListModel.searchTerm\" [CustomeIcon]=\"LblIcon\" [IsCustomButton]='true'\r\n          [Title]=\"LblAssignSubscription\" [IsCustomButtonEnabled]=\"isAnyChecked\" (OnCustomeButton)=\"OnAdd($event)\" (OnSearch)=\"OnSearch($event)\"\r\n          (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center parent-checkbox\"><input type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\"></th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('groupName')\">\r\n                  {{ 'LblSharedVehicleGroup' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'groupName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('name')\">\r\n                  {{ 'LblSubscriptionName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'name'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('amount')\">\r\n                  {{ 'LblAmount' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'amount'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('timeInterval')\">\r\n                  {{'LblSubscriptionInterval' | translate}}\r\n                  <wego-sort-list [FieldName]=\"'timeInterval'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('paymentInterval')\">\r\n                  {{ 'LblPaymentInterval' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'paymentInterval'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('invoiceInterval')\">\r\n                  {{ 'LblInvoicInterval' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'invoiceInterval'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <!-- <th class=\"cursor-pointer\" (click)=\"OnSort('startDateTimeUTC')\">\r\n                  {{'LblSubscriptionStartDate' | translate}}\r\n                  <wego-sort-list [FieldName]=\"'startDateTimeUTC'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('endDateTimeUTC')\">\r\n                  {{'LblsubscribeEndDate' | translate}}\r\n                  <wego-sort-list [FieldName]=\"'endDateTimeUTC'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th> -->\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let subscription of subscriptionList\">\r\n                  <td class=\"text-center\"><input type=\"checkbox\" name=\"isActive\" [(ngModel)]=\"subscription.isChecked\"></td>\r\n                  <td>{{ subscription.groupName }}</td>\r\n                  <td>{{ subscription.name }}</td>\r\n                  <td>{{ subscription.amount | decimalFormatter }}</td>\r\n                  <td>{{ subscription.timeInterval }}</td>\r\n                  <td>{{ subscription.paymentInterval }}</td>\r\n                  <td>{{ subscription.invoiceInterval }}</td>\r\n                  <!-- <td>{{ subscription.startDateTime }}</td>\r\n                  <td>{{ subscription.endDateTime }}</td> -->\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                <td class=\"text-center text-danger\" colspan=\"7\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n          <div class=\"clearfix\"></div>\r\n          <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n            <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n              <div class=\"col-md-12\">\r\n                <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                  [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                  lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>";

/***/ },
/* 1286 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var organization_driver_model_1 = __webpack_require__(1287);
	var organization_driver_service_1 = __webpack_require__(987);
	var AssignOrganizationDriverPopupComponent = (function () {
	    function AssignOrganizationDriverPopupComponent(organizationDriverService, authService, router, translate) {
	        this.organizationDriverService = organizationDriverService;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.isNewDriver = 1;
	        this.onSuccessSelect = new core_1.EventEmitter();
	    }
	    Object.defineProperty(AssignOrganizationDriverPopupComponent.prototype, "isAnyChecked", {
	        get: function () {
	            if (this.driverList) {
	                var isCheck = this.driverList.some(function (x) { return x.isChecked == true; });
	                if (isCheck) {
	                    if (this.driverList.every(function (x) { return x.isChecked == true; }))
	                        this.isParentCheck = true;
	                    else
	                        this.isParentCheck = false;
	                }
	                else {
	                    this.isParentCheck = false;
	                }
	                return isCheck;
	            }
	            else {
	                this.isParentCheck = false;
	                return false;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    AssignOrganizationDriverPopupComponent.prototype.ngOnInit = function () {
	        this.LblAssignDriver =
	            this.translate.instant("LblAssign") + this.translate.instant("LblDriver");
	        this.LblIcon = "fa fa-plus-square";
	        this.isNewDriver = 1;
	        this.DataListModel = new config_1.DataListModel();
	        this.model = new organization_driver_model_1.OrganizationDriverPersonModel();
	        this.DataListModel.searchField = ["driverName", "firstName", "lastName"];
	    };
	    AssignOrganizationDriverPopupComponent.prototype.ngOnChanges = function (change) {
	        console.log(change);
	    };
	    AssignOrganizationDriverPopupComponent.prototype.show = function () {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.sortType = "";
	        this.DataListModel.sortReverse = null;
	        this.DataListModel.searchTerm = "";
	        this.DataListModel.infoMessage = "";
	        this.GetDriverListForOrganization();
	        this.isNewDriver = 1;
	        this.model.userName = "";
	        this.model.emailAddressModel.email = "";
	        this.errorModel = [];
	        this.driverPopupModel.show();
	    };
	    AssignOrganizationDriverPopupComponent.prototype.hide = function () {
	        this.driverPopupModel.hide();
	    };
	    AssignOrganizationDriverPopupComponent.prototype.GetDriverListForOrganization = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.organizationDriverService
	            .GetDriverListByOrganizationToInstance(this.OrganizationHashId, this.DataListModel)
	            .subscribe(function (res) {
	            _this.driverList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    AssignOrganizationDriverPopupComponent.prototype.OnParentCheck = function (isChecked) {
	        this.driverList.forEach(function (x) { return (x.isChecked = isChecked); });
	    };
	    AssignOrganizationDriverPopupComponent.prototype.select = function (driverHashId) {
	        var _this = this;
	        this.isLoading = true;
	        var model = new organization_driver_model_1.OrganizationDriverMappingModel();
	        model.driverHashId = driverHashId;
	        model.organizationHashId = this.OrganizationHashId;
	        this.organizationDriverService.AssignDriverToOrganization(model).subscribe(function (res) {
	            _this.message = _this.translate.instant("LblRecordSavedSuccess");
	            _this.OnSuccessSelect();
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        }, function () {
	            _this.driverPopupModel.hide();
	            _this.isLoading = false;
	        });
	    };
	    AssignOrganizationDriverPopupComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetDriverListForOrganization();
	    };
	    AssignOrganizationDriverPopupComponent.prototype.OnSearch = function (event) {
	        this.DataListModel.searchTerm = event.searchTerm;
	        this.DataListModel.currentPage = 1;
	        this.GetDriverListForOrganization();
	    };
	    AssignOrganizationDriverPopupComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetDriverListForOrganization();
	    };
	    AssignOrganizationDriverPopupComponent.prototype.OnPagingChange = function (event) {
	        console.log(this.DataListModel);
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetDriverListForOrganization();
	    };
	    AssignOrganizationDriverPopupComponent.prototype.OnSuccessSelect = function () {
	        this.onSuccessSelect.emit({ SuccessMessage: this.message });
	    };
	    AssignOrganizationDriverPopupComponent.prototype.OnAdd = function (event) {
	        var _this = this;
	        var driverHashIdList;
	        driverHashIdList = this.driverList
	            .filter(function (x) { return x.isChecked; })
	            .map(function (x) { return x.driverMasterHashId; });
	        this.isLoading = true;
	        var model = new organization_driver_model_1.OrganizationDriverMappingModel();
	        model.listOfDriverHashId = driverHashIdList;
	        model.organizationHashId = this.OrganizationHashId;
	        this.organizationDriverService.AssignDriverToOrganization(model).subscribe(function (res) {
	            _this.message = _this.translate.instant("LblRecordSavedSuccess");
	            _this.OnSuccessSelect();
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        }, function () {
	            _this.driverPopupModel.hide();
	            _this.isLoading = false;
	        });
	    };
	    AssignOrganizationDriverPopupComponent.prototype.AddNewPerson = function () {
	        var _this = this;
	        this.model.organizationHashId = this.OrganizationHashId;
	        this.organizationDriverService.AddPerson(this.model).subscribe(function (res) {
	            if (res.data) {
	                // this.popupMsg = this.translate.instant('LblRecordAddedSuccess', [this.module]);
	                // this.ShowSuccessPopup();
	                _this.OnSuccessSelect();
	                _this.isLoading = false;
	                _this.hide();
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    __decorate([
	        core_1.Output("OnSuccessSelect"), 
	        __metadata('design:type', Object)
	    ], AssignOrganizationDriverPopupComponent.prototype, "onSuccessSelect", void 0);
	    __decorate([
	        core_1.ViewChild("driverPopupModel"), 
	        __metadata('design:type', Object)
	    ], AssignOrganizationDriverPopupComponent.prototype, "driverPopupModel", void 0);
	    AssignOrganizationDriverPopupComponent = __decorate([
	        core_1.Component({
	            selector: "wego-assign-driver-to-organization-popup",
	            template: __webpack_require__(1288)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof organization_driver_service_1.OrganizationDriverService !== 'undefined' && organization_driver_service_1.OrganizationDriverService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object])
	    ], AssignOrganizationDriverPopupComponent);
	    return AssignOrganizationDriverPopupComponent;
	    var _a, _b, _c, _d;
	}());
	exports.AssignOrganizationDriverPopupComponent = AssignOrganizationDriverPopupComponent;


/***/ },
/* 1287 */
/***/ function(module, exports) {

	"use strict";
	var OrganizationDriverMappingModel = (function () {
	    function OrganizationDriverMappingModel() {
	        this.listOfDriverHashId = [];
	    }
	    return OrganizationDriverMappingModel;
	}());
	exports.OrganizationDriverMappingModel = OrganizationDriverMappingModel;
	var OrganizationDriverModel = (function () {
	    function OrganizationDriverModel() {
	    }
	    return OrganizationDriverModel;
	}());
	exports.OrganizationDriverModel = OrganizationDriverModel;
	var OrganizationDriverPersonModel = (function () {
	    function OrganizationDriverPersonModel() {
	        this.organizationHashId = "";
	        this.emailAddressModel = new OrganizationDriverEmailAddressModel();
	    }
	    return OrganizationDriverPersonModel;
	}());
	exports.OrganizationDriverPersonModel = OrganizationDriverPersonModel;
	var OrganizationDriverEmailAddressModel = (function () {
	    function OrganizationDriverEmailAddressModel() {
	    }
	    return OrganizationDriverEmailAddressModel;
	}());
	exports.OrganizationDriverEmailAddressModel = OrganizationDriverEmailAddressModel;


/***/ },
/* 1288 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #driverPopupModel=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblAdd' | translate }} {{ 'LblDriver' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n\r\n        <div class=\"radio\">\r\n          <label>\r\n            <input type=\"radio\" [(ngModel)]=\"isNewDriver\" name=\"newDriver\" [value]=\"1\">{{ 'LblCreateNew' | translate }}\r\n          </label>\r\n          &nbsp;\r\n          <label>\r\n            <input type=\"radio\" [(ngModel)]=\"isNewDriver\" name=\"existingDriver\" [value]=\"0\"> {{ 'LblAssignExisting' | translate }}\r\n          </label>\r\n        </div>\r\n\r\n        <template [ngIf]=\"isNewDriver == 1\">\r\n          <!-- <form (ngSubmit)=\"onSubmit(AddPersonForm.value)\" #AddPersonForm=\"ngForm\"> -->\r\n            <div class=\"row\">\r\n            <div class=\"form-group col-md-4\">\r\n              <label>\r\n                <span class=\"text text-danger\">*</span>{{ 'LblUserName' | translate }}\r\n              </label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblUserName' | translate }}\" [(ngModel)]=\"model.userName\" name=\"UserName\"\r\n                maxlength=\"100\">\r\n\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'userName' }}</span>\r\n            </div>\r\n\r\n            <div class=\"form-group col-md-4\">\r\n              <label>\r\n                <span class=\"text text-danger\">*</span>{{ 'LblEmail' | translate }}\r\n              </label>\r\n              <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblEmail' | translate }}\" [(ngModel)]=\"model.emailAddressModel.email\"\r\n                name=\"Email\" maxlength=\"100\">\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'emailAddressModel.email' }}</span>\r\n            </div>\r\n          </div>\r\n          <!-- </form> -->\r\n        </template>\r\n\r\n        <template [ngIf]=\"isNewDriver == 0\">\r\n          <wego-search-list [IsExported]=\"false\" [SearchTerm]=\"DataListModel.searchTerm\" [CustomeIcon]=\"LblIcon\" [IsCustomButton]='true'\r\n            [Title]=\"LblAssignDriver\" [IsCustomButtonEnabled]=\"isAnyChecked\" (OnCustomeButton)=\"OnAdd($event)\" (OnSearch)=\"OnSearch($event)\"\r\n            (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n          <div class=\"table table-responsive mar_bot_ziro\">\r\n            <table class=\"table table-bordered mar_bot_ziro\">\r\n              <thead>\r\n                <tr>\r\n                  <th class=\"text-center parent-checkbox\">\r\n                    <input type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\">\r\n                  </th>\r\n                  <th class=\"cursor-pointer\" (click)=\"OnSort('firstName')\">\r\n                    {{ 'LblFirstName' | translate }}\r\n                    <wego-sort-list [FieldName]=\"'firstName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                  </th>\r\n                  <th class=\"cursor-pointer\" (click)=\"OnSort('lastName')\">\r\n                    {{ 'LblLastName' | translate }}\r\n                    <wego-sort-list [FieldName]=\"'lastName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                  </th>\r\n                  <th class=\"cursor-pointer\" (click)=\"OnSort('driverName')\">\r\n                    {{ 'LblDriver' | translate }}\r\n                    <wego-sort-list [FieldName]=\"'driverName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                  </th>\r\n                </tr>\r\n              </thead>\r\n              <tbody>\r\n                <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                  <tr *ngFor=\"let driver of driverList\">\r\n                    <td class=\"text-center\">\r\n                      <input type=\"checkbox\" name=\"isActive\" [(ngModel)]=\"driver.isChecked\">\r\n                    </td>\r\n                    <td>{{ driver.firstName }}</td>\r\n                    <td>{{ driver.lastName }}</td>\r\n                    <td>{{ driver.driverName }}</td>\r\n                  </tr>\r\n                </template>\r\n                <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                  <td class=\"text-center text-danger\" colspan=\"4\">\r\n                    {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                  </td>\r\n                </tr>\r\n              </tbody>\r\n            </table>\r\n            <div class=\"clearfix\"></div>\r\n            <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n              <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n                <div class=\"col-md-12\">\r\n                  <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                    [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                    lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n          </div>\r\n        </template>\r\n      </div>\r\n\r\n\r\n      <template [ngIf]=\"isNewDriver == 1\">\r\n        <div class=\"modal-footer\">\r\n          <button class=\"btn btn-green\" type=\"button\" (click)=\"AddNewPerson()\" >{{ 'LblCreateNew' | translate }}</button>\r\n          <button type=\"button\" class=\"btn btn-gray\" (click)=\"hide()\">{{ 'LblCancel' | translate }}</button>\r\n        </div>\r\n      </template>\r\n\r\n    </div>\r\n  </div>\r\n";

/***/ },
/* 1289 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var modal_1 = __webpack_require__(537);
	var core_1 = __webpack_require__(3);
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var person_service_1 = __webpack_require__(771);
	var InviteDriverPopupComponent = (function () {
	    function InviteDriverPopupComponent(translate, authService, personService) {
	        this.translate = translate;
	        this.authService = authService;
	        this.personService = personService;
	        this.availablePersons = [];
	        this.ErrorMsg = '';
	        this.userName = '';
	        this.errorModel = [];
	        this._popupTitle = this.translate.instant('LblInvite');
	        this.personHashId = "";
	        this.onConfirm = new core_1.EventEmitter();
	        this.onCancel = new core_1.EventEmitter();
	        this.onEmailSearch = new core_1.EventEmitter();
	    }
	    Object.defineProperty(InviteDriverPopupComponent.prototype, "popupTitle", {
	        get: function () { return this._popupTitle; },
	        set: function (popupTitle) {
	            this._popupTitle = (popupTitle && popupTitle.trim());
	        },
	        enumerable: true,
	        configurable: true
	    });
	    InviteDriverPopupComponent.prototype.ngOnInit = function () {
	    };
	    InviteDriverPopupComponent.prototype.show = function () {
	        this.ErrorMsg = "";
	        this.errorModel = [];
	        this.personHashId = "";
	        this.email = "";
	        this.availablePersons = [];
	        this.InviteDriverModal.show();
	    };
	    InviteDriverPopupComponent.prototype.hide = function () {
	        this.InviteDriverModal.hide();
	    };
	    InviteDriverPopupComponent.prototype.OnchangeCreateNew = function () {
	        if (this.personHashId == '0') {
	            this.userName = '';
	            this.errorModel = [];
	            this.availablePersons = [];
	            this.rfidTagId = null;
	        }
	    };
	    InviteDriverPopupComponent.prototype.Confirm = function ($event) {
	        this.onConfirm.emit({
	            emailAddress: this.email,
	            personHashId: this.personHashId,
	            UserName: this.userName,
	            roleHashIdList: [],
	            rfidTagId: this.rfidTagId
	        });
	    };
	    InviteDriverPopupComponent.prototype.Reject = function ($event) {
	        this.hide();
	        this.onCancel.emit($event);
	    };
	    InviteDriverPopupComponent.prototype.SearchUsers = function () {
	        this.personHashId = '';
	        this.errorModel = [];
	        this.onEmailSearch.emit({ emailAddress: this.email });
	    };
	    InviteDriverPopupComponent.prototype.EmailAddressChange = function () {
	        this.personHashId = "";
	        this.availablePersons = [];
	        this.rfidTagId = null;
	    };
	    InviteDriverPopupComponent.prototype.ngOnDestroy = function () {
	    };
	    InviteDriverPopupComponent.prototype.fixRfid = function () {
	        if (this.rfidTagId) {
	            var tag = this.rfidTagId.toUpperCase();
	            this.CorrectTag(tag);
	        }
	    };
	    InviteDriverPopupComponent.prototype.CorrectTag = function (rfidTagId) {
	        var _this = this;
	        this.personService.CorrectTag(rfidTagId)
	            .subscribe(function (res) {
	            _this.fixRfidMsg = "";
	            if (res.data && !res.error) {
	                _this.rfidTagId = res.data;
	            }
	            else {
	                _this.fixRfidMsg = res.error[0].value;
	            }
	        }, function (error) {
	            _this.fixRfidMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    __decorate([
	        core_1.ViewChild('InviteDriverModal'), 
	        __metadata('design:type', (typeof (_a = typeof modal_1.ModalDirective !== 'undefined' && modal_1.ModalDirective) === 'function' && _a) || Object)
	    ], InviteDriverPopupComponent.prototype, "InviteDriverModal", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String), 
	        __metadata('design:paramtypes', [String])
	    ], InviteDriverPopupComponent.prototype, "popupTitle", null);
	    __decorate([
	        core_1.Output('onConfirm'), 
	        __metadata('design:type', Object)
	    ], InviteDriverPopupComponent.prototype, "onConfirm", void 0);
	    __decorate([
	        core_1.Output('onCancel'), 
	        __metadata('design:type', Object)
	    ], InviteDriverPopupComponent.prototype, "onCancel", void 0);
	    __decorate([
	        core_1.Output('onEmailSearch'), 
	        __metadata('design:type', Object)
	    ], InviteDriverPopupComponent.prototype, "onEmailSearch", void 0);
	    InviteDriverPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-invite-driver-popup',
	            template: __webpack_require__(1290),
	            providers: []
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof person_service_1.PersonService !== 'undefined' && person_service_1.PersonService) === 'function' && _d) || Object])
	    ], InviteDriverPopupComponent);
	    return InviteDriverPopupComponent;
	    var _a, _b, _c, _d;
	}());
	exports.InviteDriverPopupComponent = InviteDriverPopupComponent;


/***/ },
/* 1290 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #InviteDriverModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ popupTitle }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <span class=\"text text-danger\">{{ ErrorMsg}}</span>\r\n        <div class=\"row\">\r\n          <form>\r\n            <div class=\"form-group col-xs-12\">\r\n              <label>\r\n                <span class=\"text text-danger\">*</span>{{ 'LblEmail' | translate }}\r\n              </label>\r\n              <div class=\"input-group col-xs-6\">\r\n                <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblEmail' | translate }}\" name=\"email\" [(ngModel)]=\"email\" maxlength=\"100\"\r\n                  (ngModelChange)=\"EmailAddressChange()\">\r\n                <div class=\"input-group-btn\">\r\n                  <button class=\"btn btn-default search-icon\" type=\"submit\" (click)=\"SearchUsers()\">\r\n                    <i class=\"fa fa-search\" aria-hidden=\"true\"></i>\r\n                  </button>\r\n                </div>\r\n              </div>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'EmailAddress' }}</span>\r\n            </div>\r\n          </form>\r\n        </div>\r\n        <div class=\"row\">\r\n          <div class=\"form-group col-xs-6\" style=\"padding-right:  0px;\">\r\n            <!-- <label>\r\n              <span class=\"text text-danger\">*</span>{{ 'LblPerson' | translate }}\r\n            </label> -->\r\n          \r\n            <div *ngIf=\"availablePersons\">\r\n              <div class=\"radio\">\r\n                <label>\r\n                  <input type=\"radio\" [(ngModel)]=\"personHashId\" name=\"personHashId\" value=\"0\" (change)= \"OnchangeCreateNew()\">{{ 'LblCreateNew' | translate }} {{'LblPerson'|translate}}\r\n                </label>\r\n              </div>\r\n              <div class=\"radio\" *ngFor=\"let person of availablePersons\">\r\n                <label>\r\n                  <input type=\"radio\" [(ngModel)]=\"personHashId\" name=\"personHashId\" [value]=\"person.personHashId\"> {{ person.userName }}\r\n                </label>\r\n              </div>\r\n\r\n              <div *ngIf=\"personHashId == '0' && availablePersons.length==0\" class=\"form-group col-xs-12\" \r\n              style=\"padding-left:  0px;padding-right:  0px;\">\r\n                <label>\r\n                  <span class=\"text text-danger\">*</span>{{ 'LblUserName' | translate }}\r\n                </label>\r\n                  <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblUserName' | translate }}\" [(ngModel)] =\"userName\" name=\"UserName\"  maxlength=\"100\">\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'userName' }}</span>\r\n\r\n                <label style=\"margin-top: 10px\">\r\n                   <span class=\"text text-danger\"></span>{{ 'LblRfidTagId' | translate }}\r\n                </label>\r\n                <div class=\"row\">\r\n                  <div class=\"col-xs-9\">\r\n                    <input type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblRfidTagId' | translate }}\" [(ngModel)] =\"rfidTagId\" name=\"rfidTagId\"  maxlength=\"50\">\r\n                  </div>\r\n                  <div class=\"col-xs-3\">\r\n                    <input type=\"button\" value=\"Fix tag\" (click)=\"fixRfid()\" class=\"btn btn-green\" />\r\n                  </div>                  \r\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'rfidTagId' }}</span>\r\n                </div>\r\n\r\n              </div>\r\n\r\n              <div class=\"clearfix\"></div>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'personHashId' }}</span>\r\n\r\n            </div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"modal-footer\">\r\n        <button type=\"button\" class=\"btn btn-green\" (click)=\"Confirm($event)\">{{ 'LblAdd' | translate }}</button>\r\n        <button type=\"button\" class=\"btn btn-gray\" (click)=\"Reject($event)\">{{ 'LblCancel' | translate }}</button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n";

/***/ },
/* 1291 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var config_1 = __webpack_require__(60);
	var router_1 = __webpack_require__(26);
	var AuthorizedLinkComponent = (function () {
	    function AuthorizedLinkComponent(authService, router) {
	        this.authService = authService;
	        this.router = router;
	        this.onClick = new core_1.EventEmitter();
	    }
	    AuthorizedLinkComponent.prototype.ngOnInit = function () {
	        this.authorizedLink = false;
	    };
	    AuthorizedLinkComponent.prototype.RaiseOnClick = function () {
	        if (this.LinkModel.routerLink) {
	            this.router.navigate([this.LinkModel.routerLink]);
	        }
	        else {
	            this.onClick.emit();
	        }
	    };
	    Object.defineProperty(AuthorizedLinkComponent.prototype, "LinkModel", {
	        get: function () {
	            return this._linkModel;
	        },
	        set: function (linkModel) {
	            this._linkModel = linkModel;
	            this.IsAuthorizedLink();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    AuthorizedLinkComponent.prototype.IsAuthorizedLink = function () {
	        var _this = this;
	        if (this.LinkModel) {
	            this.authService
	                .IsAuthorizeURL(this.LinkModel.permissionName, this.LinkModel.permissionType, this.LinkModel.Entity, this.LinkModel.EntityId)
	                .subscribe(function (res) {
	                console.log("Authorized Link" + res.data);
	                _this.authorizedLink = res.data;
	            });
	        }
	        else {
	            this.authorizedLink = false;
	        }
	    };
	    __decorate([
	        core_1.Output('onClick'), 
	        __metadata('design:type', Object)
	    ], AuthorizedLinkComponent.prototype, "onClick", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof config_1.WeGoAuthorizedLink !== 'undefined' && config_1.WeGoAuthorizedLink) === 'function' && _a) || Object), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof config_1.WeGoAuthorizedLink !== 'undefined' && config_1.WeGoAuthorizedLink) === 'function' && _b) || Object])
	    ], AuthorizedLinkComponent.prototype, "LinkModel", null);
	    AuthorizedLinkComponent = __decorate([
	        core_1.Component({
	            selector: "wego-authorized-link",
	            template: "<a *ngIf=\"authorizedLink\"  class=\"cursor-pointer\" [ngClass]=\"LinkModel.cssClass\" \n              (click)=\"RaiseOnClick()\">\n              <template *ngIf=\"LinkModel.iconClass\">\n              <i [ngClass]= \"LinkModel.iconClass\"></i>&nbsp;\n              </template>\n              {{ LinkModel.label | translate }}</a>\n              <span *ngIf=\"!authorizedLink && LinkModel && LinkModel.displayElementIfNotAuth\">             \n              {{ LinkModel.label | translate }}\n              </span>\n              "
	        }), 
	        __metadata('design:paramtypes', [(typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object])
	    ], AuthorizedLinkComponent);
	    return AuthorizedLinkComponent;
	    var _a, _b, _c, _d;
	}());
	exports.AuthorizedLinkComponent = AuthorizedLinkComponent;


/***/ },
/* 1292 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var modal_1 = __webpack_require__(537);
	var translate_service_1 = __webpack_require__(70);
	var flatpickr_directive_1 = __webpack_require__(82);
	var config_1 = __webpack_require__(60);
	var flatpickr_model_1 = __webpack_require__(83);
	var VatSettingsPopupComponent = (function () {
	    function VatSettingsPopupComponent(translate) {
	        this.translate = translate;
	        this.onVatConfirm = new core_1.EventEmitter();
	        this.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_FORMAT;
	    }
	    VatSettingsPopupComponent.prototype.ngOnInit = function () {
	        this.vatDescription = "";
	        this.vatPercentage = "";
	        this.vatStartDate = "";
	        this.flatPickrConfigStart = this.SetDefaultFlatPickrConfig();
	    };
	    VatSettingsPopupComponent.prototype.Confirm = function () {
	        var isValid = true;
	        isValid = this.Validate();
	        if (isValid) {
	            this.onVatConfirm.emit({
	                vatDescription: this.vatDescription,
	                vatPercentage: this.vatPercentage,
	                vatStartDate: this.vatStartDate
	            });
	            this.hide();
	        }
	    };
	    VatSettingsPopupComponent.prototype.Validate = function () {
	        var isValid = true;
	        this.ClearErrorMessage();
	        if (this.vatDescription == undefined || this.vatDescription == "") {
	            this.LblVatDescriptionError = this.translate.instant('LblVatDescriptionError');
	            isValid = false;
	        }
	        if (this.vatPercentage == undefined || this.vatPercentage == "") {
	            this.LblVatPercentageError = this.translate.instant('LblVatPercentageError');
	            isValid = false;
	        }
	        if (this.vatStartDate == undefined || this.vatStartDate == "") {
	            this.LblVatStartDateError = this.translate.instant('LblVatStartDateError');
	            isValid = false;
	        }
	        return isValid;
	    };
	    VatSettingsPopupComponent.prototype.show = function () {
	        this.vatDescription = "";
	        this.vatPercentage = "";
	        this.vatStartDate = "";
	        this.ClearErrorMessage();
	        this.vatSettings.show();
	    };
	    VatSettingsPopupComponent.prototype.hide = function () {
	        this.vatSettings.hide();
	    };
	    VatSettingsPopupComponent.prototype.SetDefaultFlatPickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = false;
	        flatPickrConfig.minDate = new Date(new Date().setHours(0, 0, 0));
	        flatPickrConfig.dateFormat = this.dateFormat;
	        return flatPickrConfig;
	    };
	    VatSettingsPopupComponent.prototype.ClearErrorMessage = function () {
	        this.LblVatDescriptionError = "";
	        this.LblVatPercentageError = "";
	        this.LblVatStartDateError = "";
	    };
	    __decorate([
	        core_1.ViewChild('vatSettings'), 
	        __metadata('design:type', (typeof (_a = typeof modal_1.ModalDirective !== 'undefined' && modal_1.ModalDirective) === 'function' && _a) || Object)
	    ], VatSettingsPopupComponent.prototype, "vatSettings", void 0);
	    __decorate([
	        core_1.ViewChild('flatPickrConfigFromDate'), 
	        __metadata('design:type', (typeof (_b = typeof flatpickr_directive_1.FlatPickrDirective !== 'undefined' && flatpickr_directive_1.FlatPickrDirective) === 'function' && _b) || Object)
	    ], VatSettingsPopupComponent.prototype, "flatPickrConfigFromDate", void 0);
	    __decorate([
	        core_1.Output('onVatConfirm'), 
	        __metadata('design:type', Object)
	    ], VatSettingsPopupComponent.prototype, "onVatConfirm", void 0);
	    VatSettingsPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-vat-setting-popup',
	            template: __webpack_require__(1293)
	        }), 
	        __metadata('design:paramtypes', [(typeof (_c = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _c) || Object])
	    ], VatSettingsPopupComponent);
	    return VatSettingsPopupComponent;
	    var _a, _b, _c;
	}());
	exports.VatSettingsPopupComponent = VatSettingsPopupComponent;


/***/ },
/* 1293 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #vatSettings=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\"\r\n  [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblVatSettings' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <div class=\"row\">\r\n          <div class=\"form-group col-md-6\">\r\n            <span class=\"text text-danger\">*</span> <label>{{ 'LblDescription' | translate }}</label>\r\n            <input maxlength=\"100\" id=\"VatDescription\" name=\"VatDescription\" [(ngModel)]=\"vatDescription\" placeholder=\"{{ 'LblVatEnterDescription' | translate }}\"\r\n              class=\"form-control\" type=\"text\">\r\n            <span id=\"VatDescriptionError\" class=\"text text-danger\">{{ LblVatDescriptionError }}</span>\r\n          </div>\r\n          <div class=\"form-group col-md-6\">\r\n            <span class=\"text text-danger\">*</span> <label>{{ 'LblVat' | translate }} ({{'LblChargingPercentage'| translate}})</label>\r\n            <input id=\"VatPercentage\" maxlength=\"5\" name=\"VatPercentage\" [(ngModel)]=\"vatPercentage\" placeholder=\"{{ 'LblEnterVatPercentage' | translate }}\"\r\n              class=\"form-control\" type=\"text\">\r\n            <span id=\"VatPercentageError\" class=\"text text-danger\">{{ LblVatPercentageError }}</span>\r\n          </div>\r\n        </div>\r\n        <div class=\"row\">\r\n          <div class=\"form-group col-md-6\">\r\n            <span class=\"text text-danger\">*</span> <label>{{ 'LblVatStartDate' | translate }}</label>\r\n            <input #flatPickrConfigFromDate=\"wego-flatpickr\" flatpickr readonly [Config]=\"flatPickrConfigStart\" [(ngModel)]=\"vatStartDate\"\r\n              name=\"VatStartDate\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblVat' | translate }} {{ 'LblStart' | translate }}\">\r\n            <span id=\"VatStartDateError\" class=\"text text-danger\">{{ LblVatStartDateError }}</span>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"modal-footer\">\r\n        <button type=\"button\" class=\"btn btn-green\" (click)=\"Confirm()\">{{ 'LblOK' | translate }}</button>\r\n        <button type=\"button\" class=\"btn btn-gray\" (click)=\"hide()\">{{ 'LblCancel' | translate }}</button>\r\n      </div>\r\n    </div>\r\n  </div>";

/***/ },
/* 1294 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var translate_service_1 = __webpack_require__(70);
	var vat_settings_model_1 = __webpack_require__(515);
	var flatpickr_model_1 = __webpack_require__(83);
	var config_1 = __webpack_require__(60);
	var flatpickr_directive_1 = __webpack_require__(82);
	var moment = __webpack_require__(84);
	var VatSettingsComponent = (function () {
	    function VatSettingsComponent(translate) {
	        this.translate = translate;
	        this.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_FORMAT;
	        this.onVatSetting = new core_1.EventEmitter();
	    }
	    VatSettingsComponent.prototype.ngOnInit = function () {
	        this.flatPickrConfigEndDate = this.SetDefaultFlatPickrConfig();
	    };
	    VatSettingsComponent.prototype.onVatConfirm = function ($event) {
	        var vatSettingsModel = new vat_settings_model_1.VatSettingsModel();
	        vatSettingsModel.description = $event.vatDescription;
	        vatSettingsModel.vat = $event.vatPercentage;
	        vatSettingsModel.vatStartDate = $event.vatStartDate;
	        this.vatSettingsList.push(vatSettingsModel);
	        this.SetDefaultRate();
	        this.onVatSetting.emit({
	            vatSettingsList: this.vatSettingsList,
	            vatSettingDefaultCost: this.vatSettingDefaultCost
	        });
	    };
	    VatSettingsComponent.prototype.SetDefaultRate = function () {
	        this.vatDefaultRate.defaultVatDistanceRates =
	            this.vatDefaultRate.defaultVatDistanceRates &&
	                this.vatSettingsList.length > 0
	                ? this.vatDefaultRate.defaultVatDistanceRates
	                : this.vatSettingsList.length > 0
	                    ? this.vatSettingsList[0].vat
	                    : "";
	        this.vatDefaultRate.defaultVatFixedRates =
	            this.vatDefaultRate.defaultVatFixedRates &&
	                this.vatSettingsList.length > 0
	                ? this.vatDefaultRate.defaultVatFixedRates
	                : this.vatSettingsList.length > 0
	                    ? this.vatSettingsList[0].vat
	                    : "";
	        this.vatDefaultRate.defaultVatPenaltyCost =
	            this.vatDefaultRate.defaultVatPenaltyCost &&
	                this.vatSettingsList.length > 0
	                ? this.vatDefaultRate.defaultVatPenaltyCost
	                : this.vatSettingsList.length > 0
	                    ? this.vatSettingsList[0].vat
	                    : "";
	        this.vatDefaultRate.defaultVatSubscriptionCost =
	            this.vatDefaultRate.defaultVatSubscriptionCost &&
	                this.vatSettingsList.length > 0
	                ? this.vatDefaultRate.defaultVatSubscriptionCost
	                : this.vatSettingsList.length > 0
	                    ? this.vatSettingsList[0].vat
	                    : "";
	        this.vatDefaultRate.defaultVatTimeRates =
	            this.vatDefaultRate.defaultVatTimeRates && this.vatSettingsList.length > 0
	                ? this.vatDefaultRate.defaultVatTimeRates
	                : this.vatSettingsList.length > 0
	                    ? this.vatSettingsList[0].vat
	                    : "";
	        this.vatDefaultRate.defaultVatPeriodRates =
	            this.vatDefaultRate.defaultVatPeriodRates && this.vatSettingsList.length > 0
	                ? this.vatDefaultRate.defaultVatPeriodRates
	                : this.vatSettingsList.length > 0
	                    ? this.vatSettingsList[0].vat
	                    : "";
	    };
	    VatSettingsComponent.prototype.onChange = function () {
	        this.onVatSetting.emit({
	            vatSettingsList: this.vatSettingsList,
	            vatSettingDefaultCost: this.vatSettingDefaultCost
	        });
	    };
	    VatSettingsComponent.prototype.ShowAlertModal = function (index) {
	        if (this.vatSettingsList[index].vatSettingHashId) {
	            var format = "DD-MM-YYYY";
	            var newDate = moment(this.vatSettingsList[index].vatStartDate, format).toDate();
	            this.flatPickrConfigEndDateDir.SetOption("minDate", newDate);
	            this.vatEndDateValidationMessage = "";
	            this.vatIndex = index;
	            this.alertModal.show();
	        }
	        else {
	            this.vatSettingsList.splice(index, 1);
	            this.SetDefaultRate();
	        }
	    };
	    VatSettingsComponent.prototype.SuccessAlertModalClick = function () {
	        if (this.vatEndDate) {
	            this.removeVatDetail(this.vatIndex);
	            this.alertModal.hide();
	        }
	        else {
	            this.vatEndDateValidationMessage = this.translate.instant("LblVatEndDateError");
	        }
	    };
	    VatSettingsComponent.prototype.removeVatDetail = function (index) {
	        if (this.vatSettingsList[index].vatSettingHashId) {
	            this.vatSettingsList[index].vatEndDate = this.vatEndDate;
	        }
	        this.vatIndex = null;
	    };
	    VatSettingsComponent.prototype.SetDefaultFlatPickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = false;
	        flatPickrConfig.minDate = new Date(new Date().setHours(0, 0, 0));
	        flatPickrConfig.dateFormat = this.dateFormat;
	        flatPickrConfig.minuteIncrement = 1;
	        return flatPickrConfig;
	    };
	    VatSettingsComponent.prototype.HideAlertModal = function () {
	        this.alertModal.hide();
	    };
	    __decorate([
	        core_1.ViewChild("flatPickrConfigEndDateDir"), 
	        __metadata('design:type', (typeof (_a = typeof flatpickr_directive_1.FlatPickrDirective !== 'undefined' && flatpickr_directive_1.FlatPickrDirective) === 'function' && _a) || Object)
	    ], VatSettingsComponent.prototype, "flatPickrConfigEndDateDir", void 0);
	    __decorate([
	        core_1.ViewChild("vatSettingspopup"), 
	        __metadata('design:type', Object)
	    ], VatSettingsComponent.prototype, "vatSettingsPopup", void 0);
	    __decorate([
	        core_1.ViewChild("alertModal"), 
	        __metadata('design:type', Object)
	    ], VatSettingsComponent.prototype, "alertModal", void 0);
	    __decorate([
	        core_1.Input("VatSettingsList"), 
	        __metadata('design:type', Object)
	    ], VatSettingsComponent.prototype, "vatSettingsList", void 0);
	    __decorate([
	        core_1.Input("VatSettingDefaultCost"), 
	        __metadata('design:type', Boolean)
	    ], VatSettingsComponent.prototype, "vatSettingDefaultCost", void 0);
	    __decorate([
	        core_1.Input("VatDefaultRate"), 
	        __metadata('design:type', (typeof (_b = typeof vat_settings_model_1.VatDefaultModel !== 'undefined' && vat_settings_model_1.VatDefaultModel) === 'function' && _b) || Object)
	    ], VatSettingsComponent.prototype, "vatDefaultRate", void 0);
	    __decorate([
	        core_1.Input("ErrorModel"), 
	        __metadata('design:type', Array)
	    ], VatSettingsComponent.prototype, "errorModel", void 0);
	    __decorate([
	        core_1.Output("OnVatSetting"), 
	        __metadata('design:type', Object)
	    ], VatSettingsComponent.prototype, "onVatSetting", void 0);
	    VatSettingsComponent = __decorate([
	        core_1.Component({
	            selector: "wego-vat-setting",
	            template: __webpack_require__(1295),
	            styles: [
	                "\n      .vatlineheight {\n        line-height: 30px;\n      }\n      .margin-bottom {\n        margin-bottom: 5px;\n      }\n    "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_c = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _c) || Object])
	    ], VatSettingsComponent);
	    return VatSettingsComponent;
	    var _a, _b, _c;
	}());
	exports.VatSettingsComponent = VatSettingsComponent;


/***/ },
/* 1295 */
/***/ function(module, exports) {

	module.exports = "<div class=\"form-group col-md-12\">\r\n  <div class=\"form-group col-sm-12\" style=\"margin-top: 10px; padding-left: 0px\">\r\n    <div class=\"push-right\">\r\n      <a class=\"btn btn-highlight navbar-right\" (click)=\"vatSettingsPopup.show()\">{{ 'LblAdd' | translate }} {{ 'LblVat' | translate }} {{ 'LblChargingPercentage' | translate }}</a>\r\n    </div>\r\n    <div class=\"push-left\">\r\n      <label>{{ 'LblVatPercentages' | translate }}</label>\r\n    </div>\r\n  </div>\r\n  <table class=\"table table-bordered mar_bot_ziro\">\r\n    <thead>\r\n      <tr>\r\n        <th style=\"width: 20px;\"></th>\r\n        <th style=\"width: 100px;\">{{ 'LblDescription' | translate }}</th>\r\n        <th style=\"width: 30px;\">{{ 'LblChargingPercentage' | translate }}</th>\r\n        <th style=\"width: 100px;\">{{ 'LblVatStartDate' | translate }}</th>\r\n        <th style=\"width: 100px;\">{{ 'LblVatEndDate' | translate }}</th>\r\n      </tr>\r\n    </thead>\r\n    <tbody *ngIf=\"vatSettingsList.length == 0\">\r\n      <tr>\r\n        <td colspan=\"5\" class=\"text-center\">\r\n          No Data found\r\n        </td>\r\n      </tr>\r\n    </tbody>\r\n    <tbody *ngIf=\"vatSettingsList && vatSettingsList.length > 0\">\r\n      <tr *ngFor=\"let vatSettings of vatSettingsList;let i = index\">\r\n        <td class=\"text-center\">\r\n          <a *ngIf=\"!vatSettings.vatEndDate\" href=\"javascript:\" (click)=\"ShowAlertModal(i)\">X</a>\r\n        </td>\r\n        <td>\r\n          {{vatSettings.description}}\r\n        </td>\r\n        <td>\r\n          {{vatSettings.vat}}\r\n        </td>\r\n        <td>\r\n          {{vatSettings.vatStartDate}}\r\n        </td>\r\n        <td>\r\n          {{vatSettings.vatEndDate}}\r\n        </td>\r\n      </tr>\r\n    </tbody>\r\n  </table>\r\n</div>\r\n<div class=\"col-md-12\">\r\n  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'vatSettingsList' }}</span>\r\n</div>\r\n<div class=\"form-group col-md-12\">\r\n  <label>{{ 'LblDefaultCost' | translate }}</label>\r\n  <div class=\"radio\">\r\n    <label>\r\n      <input type=\"radio\" [(ngModel)]=\"vatSettingDefaultCost\" name=\"vatSettingDefaultCost\" [value]=\"true\" (change)=\"onChange()\">{{ 'LblExcludingVat' | translate }}</label>\r\n  </div>\r\n  <div class=\"radio\">\r\n    <label>\r\n      <input type=\"radio\" [(ngModel)]=\"vatSettingDefaultCost\" name=\"vatSettingDefaultCost\" [value]=\"false\" (change)=\"onChange()\">{{ 'LblIncludingVat' | translate }}</label>\r\n  </div>\r\n  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'vatSettingDefaultCost' }}</span>\r\n</div>\r\n<div class=\"form-group col-md-6\">\r\n  <label>{{ 'LblDefaultVatContractTypeGroupCost' | translate }}</label>\r\n  <div class=\"col-md-7 nopadding vatlineheight\">\r\n    {{ 'LblPenaltyCost' | translate }}\r\n  </div>\r\n  <div class=\"col-md-5 nopadding\">\r\n    <select [(ngModel)]=\"vatDefaultRate.defaultVatPenaltyCost\" name=\"penaltyCost\" class=\"form-control input-sm text-transform-uppercase margin-bottom\">\r\n      <option value=\"\">-</option>\r\n      <option *ngFor=\"let item of vatSettingsList\" [value]='item.vat'>{{item.vat}}</option>\r\n    </select>\r\n  </div>\r\n  <br>\r\n  <!-- <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'defaultVatPenaltyCost' }}</span> -->\r\n  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'VatDefaultRate.defaultVatPenaltyCost' }}</span>\r\n</div>\r\n<div class=\"form-group col-md-6 vatlineheight\">\r\n  <label>{{ 'LblDefaultVatSubscriptionCost' | translate }}</label>\r\n  <div class=\"col-md-7 nopadding\">\r\n    {{ 'LblSubscriptionCost' | translate }}\r\n  </div>\r\n  <div class=\"col-md-5 nopadding\">\r\n    <select [(ngModel)]=\"vatDefaultRate.defaultVatSubscriptionCost\" name=\"subscriptionCost\" class=\"form-control input-sm text-transform-uppercase margin-bottom\">\r\n      <option value=\"\">-</option>\r\n      <option *ngFor=\"let item of vatSettingsList\" [value]='item.vat'>{{item.vat}}</option>\r\n    </select>\r\n  </div>\r\n  <br>\r\n  <!-- <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'defaultVatSubscriptionCost' }}</span> -->\r\n  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'VatDefaultRate.defaultVatSubscriptionCost' }}</span>\r\n</div>\r\n<div class=\"clearfix\"></div>\r\n<div class=\"form-group col-md-6 vatlineheight\">\r\n  <label>{{ 'LblDefaultVatContractTypeCost' | translate }}</label>\r\n  <div class=\"col-md-7 nopadding\">\r\n    {{ 'LblTimeRates' | translate }}\r\n  </div>\r\n  <div class=\"col-md-5 nopadding \">\r\n    <select [(ngModel)]=\"vatDefaultRate.defaultVatTimeRates\" name=\"timeRates\" class=\"form-control input-sm text-transform-uppercase margin-bottom\">\r\n      <option value=\"\">-</option>\r\n      <option *ngFor=\"let item of vatSettingsList\" [value]='item.vat'>{{item.vat}}</option>\r\n    </select>\r\n  </div>\r\n  <br>\r\n  <!-- <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'defaultVatTimeRates' }}</span> -->\r\n  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'VatDefaultRate.defaultVatTimeRates' }}</span>\r\n  <div class=\"clearfix\"></div>\r\n  <div class=\"col-md-7 nopadding\">\r\n    {{ 'LblPeriodRate' | translate }}\r\n  </div>\r\n  <div class=\"col-md-5 nopadding \">\r\n    <select [(ngModel)]=\"vatDefaultRate.defaultVatPeriodRates\" name=\"periodRates\" class=\"form-control input-sm text-transform-uppercase margin-bottom\">\r\n      <option value=\"\">-</option>\r\n      <option *ngFor=\"let item of vatSettingsList\" [value]='item.vat'>{{item.vat}}</option>\r\n    </select>\r\n  </div>\r\n  <br>\r\n  <!-- <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'defaultVatTimeRates' }}</span> -->\r\n  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'VatDefaultRate.defaultVatPeriodRates' }}</span>\r\n  <div class=\"clearfix\"></div>\r\n  <div class=\"col-md-7 nopadding vatlineheight\">\r\n    {{ 'LblDistanceRates' | translate }}\r\n  </div>\r\n  <div class=\"col-md-5 nopadding\">\r\n    <select [(ngModel)]=\"vatDefaultRate.defaultVatDistanceRates\" name=\"distanceRates\" class=\"form-control input-sm text-transform-uppercase margin-bottom\">\r\n      <option value=\"\">-</option>\r\n      <option *ngFor=\"let item of vatSettingsList\" [value]='item.vat'>{{item.vat}}</option>\r\n    </select>\r\n  </div>\r\n  <br>\r\n  <!-- <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'defaultVatDistanceRates' }}</span> -->\r\n  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'VatDefaultRate.defaultVatDistanceRates' }}</span>\r\n  <div class=\"clearfix\"></div>\r\n  <div class=\"col-md-7 nopadding vatlineheight\">\r\n    {{ 'LblFixedRates' | translate }}\r\n  </div>\r\n  <div class=\"col-md-5 nopadding\">\r\n    <select [(ngModel)]=\"vatDefaultRate.defaultVatFixedRates\" name=\"fixedRates\" class=\"form-control input-sm text-transform-uppercase margin-bottom\">\r\n      <option value=\"\">-</option>\r\n      <option *ngFor=\"let item of vatSettingsList\" [value]='item.vat'>{{item.vat}}</option>\r\n    </select>\r\n  </div>\r\n  <br>\r\n  <!-- <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'defaultVatFixedRates' }}</span> -->\r\n  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'VatDefaultRate.defaultVatFixedRates' }}</span>\r\n</div>\r\n\r\n\r\n<div bsModal #alertModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\"\r\n  [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-sm\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"HideAlertModal()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblConfirm' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <span class=\"text text-danger\">*</span> {{ 'LblVatDeleteConfirmation' | translate }}\r\n        <br/>\r\n        <br/>\r\n        <div class=\"input-group\">\r\n          <span class=\"input-group-addon\">\r\n            <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n          </span>\r\n          <input #flatPickrConfigEndDateDir=\"wego-flatpickr\" flatpickr readonly [Config]=\"flatPickrConfigEndDate\" type=\"text\" class=\"form-control\"\r\n            placeholder=\"{{ 'LblVat' | translate }} {{ 'LblVatEndDate' | translate }}\" [(ngModel)]=\"vatEndDate\" name=\"vatEndDate\"\r\n            maxlength=\"100\">\r\n        </div>\r\n        <span class=\"text text-danger\">{{ vatEndDateValidationMessage }}</span>\r\n        <br>\r\n        <span class=\"text text-yellow\">{{ 'LblVatEndDateNote' | translate }}</span>\r\n      </div>\r\n      <div class=\"modal-footer\">\r\n        <button type=\"button\" class=\"btn btn-green\" (click)=\"SuccessAlertModalClick()\">{{ 'LblYes' | translate }}</button>\r\n        <button type=\"button\" class=\"btn btn-gray cursor-pointer\" (click)=\"HideAlertModal()\">{{ 'LblNo' | translate }}</button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<wego-vat-setting-popup #vatSettingsPopup (onVatConfirm)=\"onVatConfirm($event)\"></wego-vat-setting-popup>";

/***/ },
/* 1296 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var vehicle_service_1 = __webpack_require__(530);
	var sharedvehiclegroup_service_1 = __webpack_require__(510);
	var company_service_1 = __webpack_require__(501);
	var instance_service_1 = __webpack_require__(500);
	var report_filter_model_1 = __webpack_require__(1252);
	var flatpickr_model_1 = __webpack_require__(83);
	var config_1 = __webpack_require__(60);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var report_filter_service_1 = __webpack_require__(929);
	var customer_service_1 = __webpack_require__(664);
	var organization_service_1 = __webpack_require__(614);
	var contracttypegroup_service_1 = __webpack_require__(730);
	var ReportCustomerFilter = (function () {
	    function ReportCustomerFilter(customerService, authService, instanceService, companyService, sharedVehicleGroupService, vehicleService, reportFilterService, organizationService, contractTypegroupService) {
	        this.customerService = customerService;
	        this.authService = authService;
	        this.instanceService = instanceService;
	        this.companyService = companyService;
	        this.sharedVehicleGroupService = sharedVehicleGroupService;
	        this.vehicleService = vehicleService;
	        this.reportFilterService = reportFilterService;
	        this.organizationService = organizationService;
	        this.contractTypegroupService = contractTypegroupService;
	        this.onSearch = new core_1.EventEmitter();
	        this.onExportPDF = new core_1.EventEmitter();
	        this.onExportExcel = new core_1.EventEmitter();
	        this.resetValidSearch = new core_1.EventEmitter();
	        this.isValidSearch = false;
	        this.roleLevel = config_1.RoleLevel;
	    }
	    ReportCustomerFilter.prototype.ngOnInit = function () {
	        this.model = new report_filter_model_1.ReportFilterModel();
	        this.permissionType = config_1.PermissionType.VIEW;
	        this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigTo.defaultDate = "23:59";
	        this.InitReportFilter();
	    };
	    ReportCustomerFilter.prototype.SetDefaultFlatPickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = true;
	        flatPickrConfig.time_24hr = true;
	        flatPickrConfig.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
	        flatPickrConfig.minuteIncrement = 1;
	        return flatPickrConfig;
	    };
	    ReportCustomerFilter.prototype.InitReportFilter = function () {
	        // this.GetAllInstanceList();
	        this.GetCustomerListDropdown();
	    };
	    ReportCustomerFilter.prototype.GetCustomerListDropdown = function () {
	        var _this = this;
	        this.customerService.GetDropdownListCustomer(this.reportName).subscribe(function (res) {
	            _this.customerList = res.data;
	            if (_this.customerList != null && _this.customerList.length > 0) {
	                if (!_this.model.customerHashId && _this.customerList.length == 1) {
	                    _this.model.customerHashId = _this.customerList[0].keyHash;
	                }
	                _this.OnCustomerChange();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    ReportCustomerFilter.prototype.GetInstanceListDropdown = function () {
	        var _this = this;
	        this.instanceService
	            .GetDropdownInstanceList(this.reportName, this.model.customerHashId)
	            .subscribe(function (res) {
	            _this.instanceList = res.data;
	            if (_this.instanceList && _this.instanceList.length > 0) {
	                if (!_this.model.instanceHashId && _this.instanceList.length == 1) {
	                    _this.model.instanceHashId = _this.instanceList[0].keyHash;
	                }
	                _this.OnInstanceChange();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    ReportCustomerFilter.prototype.GetAllCompanyList = function () {
	        var _this = this;
	        this.companyService
	            .GetDropdownCompanyList(this.reportName, this.model.instanceHashId)
	            .subscribe(function (res) {
	            _this.companyList = res.data;
	            if (_this.companyList && _this.companyList.length > 0) {
	                if (!_this.model.companyMasterHashId &&
	                    _this.companyList.length == 1) {
	                    _this.model.companyMasterHashId = _this.companyList[0].keyHash;
	                }
	                _this.OnCompanyChange();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoader = false;
	        });
	    };
	    // Value should be null in case required all svg
	    ReportCustomerFilter.prototype.GetAllSVGList = function () {
	        var _this = this;
	        this.sharedVehicleGroupService
	            .GetDropdownSVGList(this.reportName, this.model.companyMasterHashId, this.model.instanceHashId)
	            .subscribe(function (res) {
	            _this.sharedVehicleGroupList = res.data;
	            if (_this.sharedVehicleGroupList &&
	                _this.sharedVehicleGroupList.length > 0) {
	                if (!_this.model.sharedVehicleGroupHashId &&
	                    _this.sharedVehicleGroupList.length == 1) {
	                    _this.model.sharedVehicleGroupHashId = _this.sharedVehicleGroupList[0].keyHash;
	                }
	                _this.OnSVGChange();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    ReportCustomerFilter.prototype.GetCompanyListByInstance = function () {
	        var _this = this;
	        this.companyService
	            .GetDropdownCompanyList(this.reportName, this.model.instanceHashId)
	            .subscribe(function (res) {
	            _this.companyList = res.data;
	            if (_this.companyList && _this.companyList.length > 0) {
	                if (!_this.model.companyMasterHashId &&
	                    _this.companyList.length == 1) {
	                    _this.model.companyMasterHashId = _this.companyList[0].keyHash;
	                }
	                _this.OnCompanyChange();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    ReportCustomerFilter.prototype.GetSVGBaseOrganizationDropDown = function () {
	        var _this = this;
	        // instanceHashId: string, companyMasterHashId: string, sVGHashId: string
	        // let company = sVGHashId != "" ? "" : companyMasterHashId;
	        this.organizationService
	            .GetSVGBaseOrganizationDropDown(this.reportName, this.model.instanceHashId, this.model.companyMasterHashId, this.model.sharedVehicleGroupHashId)
	            .subscribe(function (res) {
	            _this.organizationList = res.data;
	            if (_this.organizationList && _this.organizationList.length > 0) {
	                if (!_this.model.organizationHashId &&
	                    _this.organizationList.length == 1) {
	                    _this.model.organizationHashId = _this.organizationList[0].keyHash;
	                }
	                _this.OnOrganizationChange();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    ReportCustomerFilter.prototype.GetVehicleBySVG = function () {
	        var _this = this;
	        // instanceHashId: string, companyMasterHashId: string, sVGHashId: string
	        // let company = sVGHashId != "" ? "" : companyMasterHashId;
	        this.vehicleService
	            .GetDropdownVehicleList(this.reportName, this.model.instanceHashId, this.model.companyMasterHashId, this.model.sharedVehicleGroupHashId)
	            .subscribe(function (res) {
	            _this.vehicleList = res.data;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    ReportCustomerFilter.prototype.GetContractTypeGroupBySVG = function () {
	        var _this = this;
	        this.contractTypegroupService
	            .GetDropdownListCTGBySVG(this.reportName, this.model.instanceHashId, this.model.companyMasterHashId, this.model.sharedVehicleGroupHashId)
	            .subscribe(function (res) {
	            _this.contractTypeGroupList = res.data;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    // Event
	    ReportCustomerFilter.prototype.OnCustomerChange = function () {
	        this.model.instanceHashId = "";
	        this.instanceList = [];
	        this.model.companyMasterHashId = "";
	        this.companyList = [];
	        this.model.organizationHashId = "";
	        this.organizationList = [];
	        this.model.sharedVehicleGroupHashId = "";
	        this.sharedVehicleGroupList = [];
	        this.model.contractTypeGroupHashId = "";
	        this.contractTypeGroupList = [];
	        this.model.vehicleHashId = "";
	        this.vehicleList = [];
	        this.contractTypeGroupList = [];
	        this.model.contractTypeGroupHashId = "";
	        this.ResetValidSearch();
	        if (this.model.customerHashId) {
	            this.GetInstanceListDropdown();
	        }
	    };
	    ReportCustomerFilter.prototype.OnInstanceChange = function () {
	        this.companyList = null;
	        this.sharedVehicleGroupList = null;
	        this.vehicleList = null;
	        this.organizationList = null;
	        this.model.companyMasterHashId = "";
	        this.model.sharedVehicleGroupHashId = "";
	        this.model.vehicleHashId = "";
	        this.model.organizationHashId = "";
	        this.isLoader = true;
	        this.contractTypeGroupList = null;
	        this.model.contractTypeGroupHashId = "";
	        this.ResetValidSearch();
	        if (this.model.instanceHashId) {
	            this.GetCompanyListByInstance();
	        }
	        else {
	            this.companyList = [];
	            this.sharedVehicleGroupList = [];
	            this.vehicleList = [];
	            this.organizationList = [];
	            this.model.organizationHashId = "";
	            this.model.companyMasterHashId = "";
	            this.model.sharedVehicleGroupHashId = "";
	            this.model.vehicleHashId = "";
	            this.contractTypeGroupList = [];
	            this.model.contractTypeGroupHashId = "";
	        }
	    };
	    ReportCustomerFilter.prototype.OnCompanyChange = function () {
	        this.sharedVehicleGroupList = null;
	        this.vehicleList = null;
	        this.organizationList = null;
	        this.model.sharedVehicleGroupHashId = "";
	        this.model.vehicleHashId = "";
	        this.model.organizationHashId = "";
	        this.isLoader = true;
	        this.contractTypeGroupList = null;
	        this.model.contractTypeGroupHashId = "";
	        this.ResetValidSearch();
	        if (this.model.companyMasterHashId) {
	            this.GetAllSVGList();
	        }
	        else {
	            this.sharedVehicleGroupList = [];
	            this.vehicleList = [];
	            this.organizationList = [];
	            this.contractTypeGroupList = [];
	            this.model.contractTypeGroupHashId = "";
	            this.model.organizationHashId = "";
	            this.model.sharedVehicleGroupHashId = "";
	            this.model.vehicleHashId = "";
	        }
	    };
	    ReportCustomerFilter.prototype.OnSVGChange = function () {
	        this.vehicleList = [];
	        this.organizationList = [];
	        this.contractTypeGroupList = [];
	        this.model.vehicleHashId = "";
	        this.model.organizationHashId = "";
	        this.model.contractTypeGroupHashId = "";
	        this.isLoader = true;
	        this.ResetValidSearch();
	        this.GetSVGBaseOrganizationDropDown();
	        this.GetVehicleBySVG();
	        this.GetContractTypeGroupBySVG();
	    };
	    ReportCustomerFilter.prototype.OnOrganizationChange = function () {
	        this.ResetValidSearch();
	    };
	    ReportCustomerFilter.prototype.OnVehicleChange = function () {
	        this.ResetValidSearch();
	    };
	    ReportCustomerFilter.prototype.OnCTGChange = function () {
	        this.ResetValidSearch();
	    };
	    ReportCustomerFilter.prototype.OnFromDateChange = function () {
	        this.ResetValidSearch();
	    };
	    ReportCustomerFilter.prototype.OnToDateChange = function () {
	        this.ResetValidSearch();
	    };
	    ReportCustomerFilter.prototype.ResetValidSearch = function () {
	        this.isValidSearch = false;
	        this.resetValidSearch.emit({ isValidSearch: this.isValidSearch });
	    };
	    // Button Click
	    ReportCustomerFilter.prototype.OnSearch = function ($event) {
	        this.onSearch.emit({ model: this.model });
	    };
	    ReportCustomerFilter.prototype.OnExportPDF = function ($event) {
	        this.onExportPDF.emit({ model: this.model });
	    };
	    ReportCustomerFilter.prototype.OnExportExcel = function ($event) {
	        this.onExportExcel.emit({ model: this.model });
	    };
	    ReportCustomerFilter.prototype.OnSearchChange = function () {
	        this.ResetValidSearch();
	    };
	    __decorate([
	        core_1.Output("OnSearch"), 
	        __metadata('design:type', Object)
	    ], ReportCustomerFilter.prototype, "onSearch", void 0);
	    __decorate([
	        core_1.Output("OnExportPDF"), 
	        __metadata('design:type', Object)
	    ], ReportCustomerFilter.prototype, "onExportPDF", void 0);
	    __decorate([
	        core_1.Output("OnExportExcel"), 
	        __metadata('design:type', Object)
	    ], ReportCustomerFilter.prototype, "onExportExcel", void 0);
	    __decorate([
	        core_1.Output("ResetValidSearch"), 
	        __metadata('design:type', Object)
	    ], ReportCustomerFilter.prototype, "resetValidSearch", void 0);
	    __decorate([
	        core_1.Input("IsValidSearch"), 
	        __metadata('design:type', Boolean)
	    ], ReportCustomerFilter.prototype, "isValidSearch", void 0);
	    __decorate([
	        core_1.Input("ErrorModel"), 
	        __metadata('design:type', Array)
	    ], ReportCustomerFilter.prototype, "errorModel", void 0);
	    __decorate([
	        core_1.Input("ReportName"), 
	        __metadata('design:type', String)
	    ], ReportCustomerFilter.prototype, "reportName", void 0);
	    ReportCustomerFilter = __decorate([
	        core_1.Component({
	            selector: "wego-report-customer-filter",
	            template: __webpack_require__(1297),
	            providers: [
	                instance_service_1.InstanceService,
	                company_service_1.CompanyService,
	                sharedvehiclegroup_service_1.SharedVehicleGroupService,
	                vehicle_service_1.VehicleService,
	                organization_service_1.OrganizationService,
	                report_filter_service_1.ReportFilterService,
	                contracttypegroup_service_1.ContractTypeGroupService
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof customer_service_1.CustomerService !== 'undefined' && customer_service_1.CustomerService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof instance_service_1.InstanceService !== 'undefined' && instance_service_1.InstanceService) === 'function' && _c) || Object, (typeof (_d = typeof company_service_1.CompanyService !== 'undefined' && company_service_1.CompanyService) === 'function' && _d) || Object, (typeof (_e = typeof sharedvehiclegroup_service_1.SharedVehicleGroupService !== 'undefined' && sharedvehiclegroup_service_1.SharedVehicleGroupService) === 'function' && _e) || Object, (typeof (_f = typeof vehicle_service_1.VehicleService !== 'undefined' && vehicle_service_1.VehicleService) === 'function' && _f) || Object, (typeof (_g = typeof report_filter_service_1.ReportFilterService !== 'undefined' && report_filter_service_1.ReportFilterService) === 'function' && _g) || Object, (typeof (_h = typeof organization_service_1.OrganizationService !== 'undefined' && organization_service_1.OrganizationService) === 'function' && _h) || Object, (typeof (_j = typeof contracttypegroup_service_1.ContractTypeGroupService !== 'undefined' && contracttypegroup_service_1.ContractTypeGroupService) === 'function' && _j) || Object])
	    ], ReportCustomerFilter);
	    return ReportCustomerFilter;
	    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
	}());
	exports.ReportCustomerFilter = ReportCustomerFilter;


/***/ },
/* 1297 */
/***/ function(module, exports) {

	module.exports = "<form #searchForm=\"ngForm\">\r\n  <div class=\"row\">\r\n    <div class=\"form-group col-md-3\">\r\n      <label>\r\n        <span class=\"text text-danger\">*</span>&nbsp;{{ 'LblFrom' | translate }}</label>\r\n      <div class=\"clearfix\"></div>\r\n      <div class=\"input-group\">\r\n        <span class=\"input-group-addon\">\r\n          <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n        </span>\r\n        <input #flatPickrConfigFromDate=\"wego-flatpickr\" flatpickr readonly [Config]=\"flatPickrConfigFrom\" [(ngModel)]=\"model.startDateTime\"\r\n          name=\"startDateTime\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblFrom' | translate}}\" (change)=\"OnFromDateChange()\">\r\n      </div>\r\n      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'StartDateTime' }}</span>\r\n    </div>\r\n    <div class=\"form-group col-md-3\">\r\n      <label>\r\n        <span class=\"text text-danger\">*</span>&nbsp;{{ 'LblTo' | translate }}</label>\r\n      <div class=\"clearfix \"></div>\r\n      <div class=\"input-group\">\r\n        <span class=\"input-group-addon\">\r\n          <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n        </span>\r\n        <input #flatPickrConfigToDate=\"wego-flatpickr\" flatpickr readonly [Config]=\"flatPickrConfigTo\" [(ngModel)]=\"model.endDateTime\"\r\n          name=\"endDateTime\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblTo' | translate }}\" (change)=\"OnToDateChange()\">\r\n      </div>\r\n      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'EndDateTime' }}</span>\r\n    </div>\r\n    <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Customer\" class=\"form-group col-md-3\">\r\n      <label>\r\n        <span *ngIf=\"!isEditMode\" class=\"text text-danger\">*</span>&nbsp;{{'LblCustomer' | translate }}\r\n      </label>\r\n      <select *ngIf=\"!isEditMode\" [(ngModel)]=\"model.customerHashId\" class=\"form-control\" name=\"customerHashId\" (change)=\"OnCustomerChange()\">\r\n        <option value=''>{{ 'LblSelect' | translate }} {{ 'LblCustomer' | translate }} </option>\r\n        <option *ngFor=\"let item of customerList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\r\n      </select>\r\n      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'customerHashId' }}</span>\r\n    </div>\r\n    <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Instance\" class=\"form-group col-md-3\">\r\n      <span *ngIf=\"!isEditMode && !(authService.GetHighestRoleLevel() <= roleLevel.Instance)\" class=\"text text-danger\">*</span>&nbsp;\r\n      <label>\r\n        <span *ngIf=\"!isEditMode\" class=\"text text-danger\">*</span>&nbsp;{{'LblInstance' | translate }}\r\n      </label>\r\n      <select *ngIf=\"!isEditMode\" [(ngModel)]=\"model.instanceHashId\" class=\"form-control\" name=\"instanceHashId\" (change)=\"OnInstanceChange()\">\r\n        <option value=''>{{ 'LblSelect' | translate }} {{ 'LblInstance' | translate }} </option>\r\n        <option *ngFor=\"let item of instanceList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\r\n      </select>\r\n      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'instanceHashId' }}</span>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Company\" class=\"form-group col-md-3\">\r\n      <span *ngIf=\"!isEditMode && !(authService.GetHighestRoleLevel() <= roleLevel.Company)\" class=\"text text-danger\">*</span>&nbsp;\r\n      <label>\r\n        <span *ngIf=\"!isEditMode\" class=\"text text-danger\">*</span>&nbsp;{{'LblCompany' | translate }}\r\n      </label>\r\n      <select *ngIf=\"!isEditMode\" [(ngModel)]=\"model.companyMasterHashId\" class=\"form-control\" name=\"companyMasterHashId\" (change)=\"OnCompanyChange()\">\r\n        <option value=''>{{ 'LblSelect' | translate }} {{ 'LblCompany' | translate }} </option>\r\n        <option *ngFor=\"let item of companyList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\r\n      </select>\r\n      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'companyMasterHashId' }}</span>\r\n    </div>\r\n    <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.SVG\" class=\"form-group col-md-3\">\r\n      <label> {{'LblSharedVehicleGroup' | translate }} </label>\r\n      <select *ngIf=\"!isEditMode\" [(ngModel)]=\"model.sharedVehicleGroupHashId\" class=\"form-control\" name=\"sharedVehicleGroupHashId\"\r\n        (change)=\"OnSVGChange()\">\r\n        <option value=''>{{ 'LblAll' | translate }} {{ 'LblSharedVehicleGroup' | translate }} </option>\r\n        <option *ngFor=\"let item of sharedVehicleGroupList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\r\n      </select>\r\n      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'sharedVehicleGroupHashId' }}</span>\r\n    </div>\r\n    <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Organization\" class=\"form-group col-md-3\">\r\n      <label> {{'LblOrganization' | translate }} </label>\r\n      <select *ngIf=\"!isEditMode\" [(ngModel)]=\"model.organizationHashId\" class=\"form-control\" name=\"organizationHashId\" (change)=\"OnOrganizationChange()\">\r\n        <option value=''>{{ 'LblAll' | translate }} {{ 'LblOrganization' | translate }} </option>\r\n        <option *ngFor=\"let item of organizationList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\r\n      </select>\r\n      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'organizationHashId' }}</span>\r\n    </div>\r\n    <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.SVG\" class=\"form-group col-md-3\">\r\n      <label> {{'LblVehicle' | translate }} </label>\r\n      <select *ngIf=\"!isEditMode\" [(ngModel)]=\"model.vehicleHashId\" class=\"form-control\" name=\"vehicleHashId\" (change)=\"OnVehicleChange()\">\r\n        <option value=''>{{ 'LblAll' | translate }} {{ 'LblVehicle' | translate }} </option>\r\n        <option *ngFor=\"let vehicle of vehicleList\" [ngValue]=\"vehicle.keyHash\">{{ vehicle.value }}</option>\r\n      </select>\r\n      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'vehicleHashId' }}</span>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <!-- Contract Type Group Dropdown Started -->\r\n    <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.SVG\" class=\"form-group col-md-3\">\r\n      <label> {{'LblContractTypeGroup' | translate }} </label>\r\n      <select *ngIf=\"!isEditMode\" [(ngModel)]=\"model.contractTypeGroupHashId\" class=\"form-control\" name=\"contractTypeGroupHashId\"\r\n        (change)=\"OnCTGChange()\">\r\n        <option value=''>{{ 'LblAll' | translate }} {{ 'LblContractTypeGroup' | translate }} </option>\r\n        <option *ngFor=\"let item of contractTypeGroupList\" [ngValue]=\"item.keyHash\"> {{ item.data }} - {{ item.value }}</option>\r\n      </select>\r\n      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'contractTypeGroupHashId' }}</span>\r\n    </div>\r\n    <!-- Contract Type Group Dropdown End -->\r\n    <div class=\"form-group col-md-4\">\r\n      <label> {{ 'LblGroupBy' | translate }} </label>\r\n      <div class=\"clearfix\"></div>\r\n      <label class=\"radio-inline\">\r\n        <input type=\"radio\" [(ngModel)]=\"model.groupByType\" name=\"groupByType\" (change)=\"OnSearchChange()\" value=\"VEHICLE\">{{ 'LblByVehicle' | translate}}</label>\r\n      <label class=\"radio-inline\">\r\n        <input type=\"radio\" [(ngModel)]=\"model.groupByType\" name=\"groupByType\" (change)=\"OnSearchChange()\" value=\"ORGANIZATION\">{{ 'LblByOrganization' | translate}}</label>\r\n    </div>\r\n    <div class=\"form-group col-md-3 pull-right\">\r\n      <div class=\"input-group pull-right\">\r\n        <button class=\"btn btn-default\" (click)=\"OnSearch($event)\">\r\n          <i class=\"fa fa-search\" aria-hidden=\"true\"></i>\r\n        </button>&nbsp;\r\n         <button *ngIf=\"isValidSearch\" class=\"btn btn-default\" (click)=\"OnExportPDF($event)\">\r\n          <i class=\"fa fa-file-pdf-o\" aria-hidden=\"true\"></i>\r\n        </button>&nbsp; \r\n        <button *ngIf=\"isValidSearch\" class=\"btn btn-default\" (click)=\"OnExportExcel($event)\">\r\n          <i class=\"fa fa-file-excel-o\" aria-hidden=\"true\"></i>\r\n        </button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</form>";

/***/ },
/* 1298 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var cost_expense_service_1 = __webpack_require__(1010);
	var person_service_1 = __webpack_require__(771);
	var CostAndExpensePersonPopupComponent = (function () {
	    function CostAndExpensePersonPopupComponent(costAndExpenseService, personService, authService, router, translate) {
	        this.costAndExpenseService = costAndExpenseService;
	        this.personService = personService;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.SelectedNames = [];
	        this.SelectedList = [];
	        this.LblIcon = "fa fa-plus-square";
	        this.isParentCheck = false;
	        this.pageName = "COST_EXPENSE_LIST";
	        this.onSuccessSelect = new core_1.EventEmitter();
	    }
	    CostAndExpensePersonPopupComponent.prototype.ngOnInit = function () {
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.searchField = ["userName", "firstName", "lastName"];
	    };
	    CostAndExpensePersonPopupComponent.prototype.ngOnChanges = function (change) {
	        console.log(change);
	    };
	    CostAndExpensePersonPopupComponent.prototype.show = function (SelectedList, SelectedNamesList) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.sortType = "";
	        this.DataListModel.sortReverse = null;
	        this.DataListModel.searchTerm = "";
	        this.DataListModel.infoMessage = "";
	        this.SelectedList = SelectedList;
	        this.SelectedNames = SelectedNamesList;
	        this.GetPersonList();
	        this.personModal.show();
	    };
	    CostAndExpensePersonPopupComponent.prototype.hide = function () {
	        this.personModal.hide();
	    };
	    CostAndExpensePersonPopupComponent.prototype.GetPersonList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.personService.GetPersonListByAccessRight(this.DataListModel, this.pageName)
	            .subscribe(function (res) {
	            _this.personList = res.data;
	            _this.personList.forEach(function (x) { return x.isChecked =
	                (_this.SelectedList.indexOf(x.personMasterHashId) > -1); });
	            _this.isParentCheck = _this.personList.every(function (x) { return x.isChecked; });
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    CostAndExpensePersonPopupComponent.prototype.select = function (person) {
	        this.isLoading = true;
	        this.onSuccessSelect.emit({ PersonHashID: person.personMasterHashId, PersonName: person.userName });
	        this.isLoading = false;
	        this.hide();
	    };
	    CostAndExpensePersonPopupComponent.prototype.selectMultiple = function () {
	        this.isLoading = true;
	        this.onSuccessSelect.emit({ PersonHashID: this.SelectedList, PersonName: this.SelectedNames });
	        this.isLoading = false;
	        this.hide();
	    };
	    CostAndExpensePersonPopupComponent.prototype.ItemCheckChanged = function (PersonMasterHashID, PersonName, isChecked) {
	        if (isChecked) {
	            if (this.SelectedList.indexOf(PersonMasterHashID) == -1) {
	                this.SelectedList.push(PersonMasterHashID);
	            }
	            if (this.SelectedNames.indexOf(PersonName) == -1) {
	                this.SelectedNames.push(PersonName);
	            }
	            this.isParentCheck = this.personList.filter(function (x) { return x.personMasterHashId != PersonMasterHashID; }).every(function (x) { return x.isChecked; });
	        }
	        else {
	            this.SelectedList = this.SelectedList.filter(function (x) { return x != PersonMasterHashID; });
	            this.SelectedNames = this.SelectedNames.filter(function (x) { return x != PersonName; });
	            this.isParentCheck = false;
	        }
	    };
	    CostAndExpensePersonPopupComponent.prototype.OnParentCheck = function (isChecked) {
	        var _this = this;
	        this.personList.forEach(function (x) {
	            x.isChecked = isChecked;
	            if (isChecked) {
	                if (_this.SelectedList.indexOf(x.personMasterHashId) == -1) {
	                    _this.SelectedList.push(x.personMasterHashId);
	                }
	                if (_this.SelectedNames.indexOf(x.userName) == -1) {
	                    _this.SelectedNames.push(x.userName);
	                }
	            }
	            else {
	                _this.SelectedList = _this.SelectedList.filter(function (y) { return y != x.personMasterHashId; });
	                _this.SelectedNames = _this.SelectedNames.filter(function (y) { return y != x.userName; });
	            }
	        });
	    };
	    CostAndExpensePersonPopupComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetPersonList();
	    };
	    CostAndExpensePersonPopupComponent.prototype.OnSearch = function (event) {
	        this.DataListModel.searchTerm = event.searchTerm;
	        this.DataListModel.currentPage = 1;
	        this.GetPersonList();
	    };
	    CostAndExpensePersonPopupComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetPersonList();
	    };
	    ;
	    CostAndExpensePersonPopupComponent.prototype.OnPagingChange = function (event) {
	        console.log(this.DataListModel);
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetPersonList();
	    };
	    CostAndExpensePersonPopupComponent.prototype.OnSuccessSelect = function () {
	    };
	    __decorate([
	        core_1.Output('OnSuccessSelect'), 
	        __metadata('design:type', Object)
	    ], CostAndExpensePersonPopupComponent.prototype, "onSuccessSelect", void 0);
	    __decorate([
	        core_1.ViewChild('personModal'), 
	        __metadata('design:type', Object)
	    ], CostAndExpensePersonPopupComponent.prototype, "personModal", void 0);
	    CostAndExpensePersonPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-costandexpense-person-popup',
	            template: __webpack_require__(1299),
	            providers: [cost_expense_service_1.CostAndExpenseService, person_service_1.PersonService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof cost_expense_service_1.CostAndExpenseService !== 'undefined' && cost_expense_service_1.CostAndExpenseService) === 'function' && _a) || Object, (typeof (_b = typeof person_service_1.PersonService !== 'undefined' && person_service_1.PersonService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _e) || Object])
	    ], CostAndExpensePersonPopupComponent);
	    return CostAndExpensePersonPopupComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.CostAndExpensePersonPopupComponent = CostAndExpensePersonPopupComponent;


/***/ },
/* 1299 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #personModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\"\r\n  [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n                    <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblSelect' | translate }} {{ 'LblPerson' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <wego-search-list [IsExported]=\"false\" [SearchTerm]=\"DataListModel.searchTerm\" (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\"\r\n          (OnPagingChange)=\"OnPagingChange($event)\" [ItemPerPage]=\"DataListModel.itemsPerPage\" [CustomeIcon]=\"LblIcon\" [IsCustomButton]='true'\r\n          (OnCustomeButton)=\"selectMultiple()\" [IsCustomButtonEnabled]=\"SelectedList && SelectedList.length>0\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>               \r\n                <th class=\"text-center parent-checkbox\"><input type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\"></th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('userName')\">\r\n                  {{ 'LblPerson' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'userName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('firstName')\">\r\n                  {{ 'LblFirstName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'firstName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('lastName')\">\r\n                  {{ 'LblLastName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'lastName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let person of personList\">                \r\n                  <td class=\"text-center\"><input type=\"checkbox\" name=\"isActive\" (click)=\"ItemCheckChanged(person.personMasterHashId,person.userName,$event.target.checked)\"\r\n                      [(ngModel)]=\"person.isChecked\">\r\n                  </td>\r\n                  <td>{{ person.userName }}</td>\r\n                  <td>{{ person.firstName }}</td>\r\n                  <td>{{ person.lastName }}</td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0\">\r\n                <td class=\"text-center text-danger\" colspan=\"4\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 1300 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var config_1 = __webpack_require__(60);
	var router_1 = __webpack_require__(26);
	var config_2 = __webpack_require__(60);
	var cost_expense_model_1 = __webpack_require__(1006);
	var cost_expense_service_1 = __webpack_require__(1010);
	var booking_service_1 = __webpack_require__(556);
	var moment = __webpack_require__(84);
	var ConfirmCostAndExpenseComponent = (function () {
	    function ConfirmCostAndExpenseComponent(authService, router, translate, zone, costAndExpenseService, bookingService) {
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.zone = zone;
	        this.costAndExpenseService = costAndExpenseService;
	        this.bookingService = bookingService;
	        this.onSuccessSave = new core_1.EventEmitter();
	        this.OnSuccessSelect = new core_1.EventEmitter();
	        this.OnHidden = new core_1.EventEmitter();
	    }
	    // @Input()
	    // set model(_costAndExpenseModel: CostAndExpenseModel) {
	    //   this._model = _costAndExpenseModel;
	    // }
	    // get model() {
	    //   return this._model;
	    // }
	    ConfirmCostAndExpenseComponent.prototype.ngOnInit = function () {
	        this.urlPersonInfo = this.authService.GetURL(config_2.ApplicationRouteURL.URL_PERSON_UPDATE);
	        this.urlBookingInfo = this.authService.GetURL(config_2.ApplicationRouteURL.URL_BOOKING_INFORMATION);
	    };
	    ConfirmCostAndExpenseComponent.prototype.show = function (model) {
	        this.errorMsg = "";
	        this.errorModel = [];
	        this.model = JSON.parse(JSON.stringify(model));
	        this.viewPersonLink = new config_1.WeGoAuthorizedLink(this.urlPersonInfo + "/" + this.model.reportedByPersonHashId, config_1.Permission.PR_PERSON_OVERVIEW, config_1.PermissionType.EDIT, "", this.model.reportedByName, "", "", true);
	        this.viewBookingLink = new config_1.WeGoAuthorizedLink(this.urlBookingInfo + "/" + this.model.bookingHashId, config_1.Permission.PR_BOOKINGS_OVERVIEW, config_1.PermissionType.VIEW, "", this.model.bookingReferenceID, "", "", true);
	        this.approvalCostAndExpenseModel.show();
	        this.GetCostTypeList();
	    };
	    ConfirmCostAndExpenseComponent.prototype.GetCostTypeList = function () {
	        var _this = this;
	        this.costAndExpenseService
	            .GetDropdownCostTypeList(this.model.reportedByPersonHashId)
	            .subscribe(function (res) {
	            _this.costTypeList = res.data;
	            _this.GetOrganizationList();
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    ConfirmCostAndExpenseComponent.prototype.GetOrganizationList = function () {
	        var _this = this;
	        this.costAndExpenseService
	            .GetDropdownOrganizationList(this.model.reportedByPersonHashId, this.model.reportedByDriver)
	            .subscribe(function (res) {
	            _this.organizationList = res.data;
	            _this.GetVatSettingDropdownList();
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    ConfirmCostAndExpenseComponent.prototype.hide = function () {
	        this.model = new cost_expense_model_1.CostAndExpenseModel();
	        this.approvalCostAndExpenseModel.hide();
	    };
	    ConfirmCostAndExpenseComponent.prototype.GetVatSettingDropdownList = function () {
	        var _this = this;
	        if (this.model.bookingHashId) {
	            this.bookingService
	                .GetVatSettingDropdownList(this.model.bookingHashId)
	                .subscribe(function (res) {
	                if (res.data) {
	                    _this.vatSettingList = res.data;
	                }
	                else {
	                    _this.apiErrorMsg = res.error;
	                }
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            });
	        }
	    };
	    ConfirmCostAndExpenseComponent.prototype.GetVatSettingDefaultValues = function () {
	        var _this = this;
	        this.bookingService
	            .GetVatSettingDefaultValues(this.model.bookingHashId)
	            .subscribe(function (res) {
	            if (res.data) {
	                var vatSettingDefaultValues = res.data;
	                _this.vatSettingDefaultCost =
	                    vatSettingDefaultValues.vatSettingDefaultCost;
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.errorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    ConfirmCostAndExpenseComponent.prototype.OnSuccessSave = function () {
	        this.isLoading = false;
	        this.OnSuccessSelect.emit({ CostAndExpenseModel: this.model });
	        this.hide();
	        var successMsg = this.translate.instant("LblSuccess");
	        this.onSuccessSave.emit({ SuccessMessage: successMsg });
	    };
	    ConfirmCostAndExpenseComponent.prototype.OnApprove = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.costAndExpenseService.AcceptReject(this.model, true, false).subscribe(function (res) {
	            if (res.data) {
	                _this.OnSuccessSave();
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    ConfirmCostAndExpenseComponent.prototype.OnReject = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.costAndExpenseService.AcceptReject(this.model, false, true).subscribe(function (res) {
	            if (res.data) {
	                _this.OnSuccessSave();
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    ConfirmCostAndExpenseComponent.prototype.ApprovedAmtExVatChange = function () {
	        if (this.model.approvedAmountExVat && this.model.approvedVatPercentage) {
	            this.model.approvedAmountInVat =
	                parseFloat(this.model.approvedAmountExVat.toString()) +
	                    parseFloat(this.model.approvedAmountExVat.toString()) *
	                        parseFloat(this.model.approvedVatPercentage.toString()) /
	                        100;
	            this.model.approvedAmountInVat =
	                Math.round(this.model.approvedAmountInVat * 100) / 100;
	        }
	    };
	    ConfirmCostAndExpenseComponent.prototype.ApprovedVatChange = function () {
	        this.ApprovedAmtExVatChange();
	    };
	    ConfirmCostAndExpenseComponent.prototype.ApprovedAmtInVatChange = function () {
	        if (this.model.approvedAmountInVat && this.model.approvedVatPercentage) {
	            this.model.approvedAmountExVat = this.GetBasevalueFromPercentage(parseFloat(this.model.approvedAmountInVat.toString()), parseFloat(this.model.approvedVatPercentage.toString()));
	            this.model.approvedAmountExVat =
	                Math.round(this.model.approvedAmountExVat * 100) / 100;
	        }
	    };
	    ConfirmCostAndExpenseComponent.prototype.GetBasevalueFromPercentage = function (FinalValue, Percentage) {
	        return FinalValue * 100 / (100 + Percentage);
	    };
	    ConfirmCostAndExpenseComponent.prototype.GetImagePath = function (path) {
	        return config_2.WeGoConfig.API_SERVER_URL + path;
	    };
	    ConfirmCostAndExpenseComponent.prototype.ShowReceipt = function (imagepath) {
	        this.receiptImagePopup.imagepath = imagepath;
	        this.receiptImagePopup.show();
	    };
	    ConfirmCostAndExpenseComponent.prototype.onHidden = function ($event) {
	        this.OnHidden.emit();
	    };
	    ConfirmCostAndExpenseComponent.prototype.SetVatDefaultCost = function (vatSettingDefaultCost) {
	        return vatSettingDefaultCost
	            ? this.translate.instant('LblExcludingVat')
	            : this.translate.instant('LblIncludingVat');
	    };
	    __decorate([
	        core_1.ViewChild("approvalCostAndExpenseModel"), 
	        __metadata('design:type', Object)
	    ], ConfirmCostAndExpenseComponent.prototype, "approvalCostAndExpenseModel", void 0);
	    __decorate([
	        core_1.ViewChild("receiptImagePopup"), 
	        __metadata('design:type', Object)
	    ], ConfirmCostAndExpenseComponent.prototype, "receiptImagePopup", void 0);
	    __decorate([
	        core_1.Output("OnSuccessSave"), 
	        __metadata('design:type', Object)
	    ], ConfirmCostAndExpenseComponent.prototype, "onSuccessSave", void 0);
	    __decorate([
	        core_1.Output("OnSuccessSelect"), 
	        __metadata('design:type', Object)
	    ], ConfirmCostAndExpenseComponent.prototype, "OnSuccessSelect", void 0);
	    __decorate([
	        core_1.Output("OnHidden"), 
	        __metadata('design:type', Object)
	    ], ConfirmCostAndExpenseComponent.prototype, "OnHidden", void 0);
	    ConfirmCostAndExpenseComponent = __decorate([
	        core_1.Component({
	            selector: "confirm-costandexpense-popup",
	            template: __webpack_require__(1301),
	            providers: [cost_expense_service_1.CostAndExpenseService, booking_service_1.BookingService],
	            styles: [
	                "\n      .form-horizontal .control-label {\n        text-align: left;\n      }\n      .image-expense {\n            max-width: 100%;\n            max-height: 350px;\n      }\n      .overlay-magnifier {\n        display: flex;\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        height: 100%;\n        background: rgba(0,0,0,0.2);\n        align-items: center;\n        justify-content: center;\n      }\n    "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _c) || Object, (typeof (_d = typeof core_1.NgZone !== 'undefined' && core_1.NgZone) === 'function' && _d) || Object, (typeof (_e = typeof cost_expense_service_1.CostAndExpenseService !== 'undefined' && cost_expense_service_1.CostAndExpenseService) === 'function' && _e) || Object, (typeof (_f = typeof booking_service_1.BookingService !== 'undefined' && booking_service_1.BookingService) === 'function' && _f) || Object])
	    ], ConfirmCostAndExpenseComponent);
	    return ConfirmCostAndExpenseComponent;
	    var _a, _b, _c, _d, _e, _f;
	}());
	exports.ConfirmCostAndExpenseComponent = ConfirmCostAndExpenseComponent;


/***/ },
/* 1301 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #approvalCostAndExpenseModel=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\" (onHidden)=\"onHidden($event)\">\r\n  <div class=\"modal-dialog modal-md\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\"> {{ 'LblCostDetail' | translate }}</h4>\r\n      </div>\r\n      <div *ngIf=\"model\" class=\"modal-body\">\r\n        <form class=\"form-horizontal\">\r\n          <fieldset [disabled]=\"!model.isEditable\">\r\n            <div class=\"col-sm-3 nopad\">\r\n              <img class=\"media-object image-expense\" [src]=\"GetImagePath(model.receiptPath)\" alt=\"No Receipt\"\r\n               />\r\n              <div class=\"overlay-magnifier cursor-pointer\" (click)=\"ShowReceipt(GetImagePath(model.receiptPath))\"><i class=\"fa fa-search fa-lg\"></i></div>\r\n            </div>\r\n            <div class=\"col-sm-9\">\r\n              <div class=\"form-group\">\r\n                <label class=\"col-sm-4\">{{ 'LblDate' | translate }}</label>\r\n                <div class=\"col-sm-8\">\r\n                  {{ model.reportedDateTime }}\r\n                </div>\r\n              </div>\r\n              <div class=\"form-group\">\r\n                <label class=\"col-sm-4\">{{ 'LblReportedBy' | translate }}</label>\r\n                <div class=\"col-sm-8\">\r\n                  <span>\r\n                    <wego-authorized-link [LinkModel]=\"viewPersonLink\"></wego-authorized-link>\r\n                  </span>\r\n                </div>\r\n              </div>\r\n              <div class=\"form-group\">\r\n                <label class=\"col-sm-4\">{{ 'LblBookingId' | translate }}</label>\r\n                <div class=\"col-sm-8\">\r\n                  <span>\r\n                    <wego-authorized-link [LinkModel]=\"viewBookingLink\"></wego-authorized-link>\r\n                  </span>\r\n                </div>\r\n              </div>\r\n              <div class=\"form-group\">\r\n                <label class=\"control-label col-sm-4\">{{ 'LblDescription' | translate }}</label>\r\n                <div class=\"col-sm-8\">\r\n                  <input type=\"text\" class=\"form-control\" [(ngModel)]=\"model.description\" name=\"description\">\r\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'Description' }}</span>\r\n                </div>\r\n              </div>\r\n              <div class=\"form-group\">\r\n                <label class=\"control-label col-sm-4\">\r\n                  <span *ngIf=\"!invoiceAlreadySent\" class=\"text-danger\">*</span>\r\n                  {{ 'LblCostType' | translate }}\r\n                </label>\r\n                <div class=\"col-sm-8\">\r\n                  <select [(ngModel)]=\"model.costTypeHashId\" class=\"form-control\" name=\"costTypeHashId\">\r\n                    <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblCostType' | translate }}</option>\r\n                    <option *ngFor=\"let item of costTypeList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\r\n                  </select>\r\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'CostTypeHashId' }}</span>\r\n                </div>\r\n              </div>\r\n              <fieldset [disabled]=\"!model.isEditable || model.isDescCostTypeOnlyEdit\">\r\n                <div class=\"form-group\">\r\n                  <label class=\"control-label col-sm-4\">{{ 'LblRecipient' | translate }}</label>\r\n                  <div class=\"col-sm-8\">\r\n                    <label class=\"radio-inline\">\r\n                      <input type=\"radio\" [(ngModel)]=\"model.isCharge\" name=\"isCharge\" [value]=\"true\">{{ 'LblChargeTo' | translate }}\r\n                    </label>\r\n                    <label class=\"radio-inline\">\r\n                      <input type=\"radio\" [(ngModel)]=\"model.isCharge\" name=\"isCharge\" [value]=\"false\">{{ 'LblReimburseTo' | translate }}\r\n                    </label>\r\n                    <div class=\"clearfix\"></div>\r\n                    <label class=\"radio-inline\">\r\n                      <input [disabled]=\"model.invoiceNumber\" type=\"radio\" [(ngModel)]=\"model.chargeToDriver\" name=\"chargeToDriver\" [value]=\"true\">{{ 'LblDriver' | translate }}\r\n                    </label>\r\n                    <label class=\"radio-inline\">\r\n                      <input [disabled]=\"model.invoiceNumber\" type=\"radio\" [(ngModel)]=\"model.chargeToDriver\" name=\"chargeToDriver\" [value]=\"false\"> {{ 'LblOrganization' | translate }}\r\n                    </label>\r\n                    <div class=\"clearfix\"></div>\r\n                    <div *ngIf=\"!model.chargeToDriver\" class=\"pad_t_10\">\r\n                      <select [disabled]=\"model.invoiceNumber\" [(ngModel)]=\"model.recipientOrganizationHashId\" class=\"form-control\" name=\"recipientOrganizationHashId\">\r\n                        <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblOrganization' | translate }}</option>\r\n                        <option *ngFor=\"let item of organizationList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\r\n                      </select>\r\n                      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'RecipientOrganizationHashId' }}</span>\r\n                    </div>\r\n\r\n                  </div>\r\n                </div>\r\n              </fieldset>\r\n            </div>\r\n            <div class=\"form-group\">\r\n              <label class=\"col-sm-3\">{{ 'LblStatus' | translate }}</label>\r\n              <div class=\"col-sm-3\">\r\n                {{model.status}}\r\n              </div>\r\n              <label class=\"col-sm-3\">{{ 'LblInvoiceNumber' | translate }}</label>\r\n              <div class=\"col-sm-3\" style=\"padding-left: 0px;\">\r\n                {{model.invoiceNumber}}\r\n              </div>\r\n            </div>\r\n            <div class=\"form-group row\">\r\n              <fieldset class=\"col-md-6\">\r\n                <legend class=\"legendStyle\">\r\n                  {{ 'LblReportedAmount' | translate }}\r\n                </legend>\r\n                <div class=\"form-horizontal\">\r\n                  <div class=\"form-group\">\r\n                    <label class=\"control-label col-sm-6\">{{ 'LblExcludingVat' | translate }}</label>\r\n                    <div class=\"col-sm-6\">\r\n                      <input disabled type=\"text\" class=\"form-control\" value=\"{{ model.reportedAmountExVat}}\"\r\n                        name=\"reportedAmountExVat\">\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"form-group\">\r\n                    <label class=\"control-label col-sm-6\">{{ 'LblVat' | translate }}</label>\r\n                    <div class=\"col-sm-6\">\r\n                      <input disabled type=\"text\" class=\"form-control\" value=\"{{ model.reportedVatPercentage }}\"\r\n                        name=\"reportedVatPercentage\">\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"form-group\">\r\n                    <label class=\"control-label col-sm-6\">{{ 'LblIncludingVat' | translate }}</label>\r\n                    <div class=\"col-sm-6\">\r\n                      <input disabled type=\"text\" class=\"form-control\" value=\"{{ model.reportedAmountInVat}}\"\r\n                        name=\"reportedAmountInVat\">\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </fieldset>\r\n              <fieldset class=\"col-md-6\" [disabled]=\"!model.isEditable || model.isDescCostTypeOnlyEdit\">\r\n                <legend class=\"legendStyle\">\r\n                  <span *ngIf=\"!invoiceAlreadySent\" class=\"text-danger\">*</span>{{ 'LblApprovedAmount' | translate }}\r\n                </legend>\r\n                <div class=\"form-horizontal\">\r\n                  <div class=\"form-group\">\r\n                    <label class=\"control-label col-sm-6\">{{ 'LblExcludingVat' | translate }}</label>\r\n                    <div class=\"col-sm-6\">\r\n                      <input maxlength=\"7\" [disabled]=\"invoiceAlreadySent\" type=\"text\" class=\"form-control\" [(ngModel)]=\"model.approvedAmountExVat\"\r\n                        name=\"approvedAmountExVat\" (change)=\"ApprovedAmtExVatChange()\">\r\n                      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'ApprovedAmountExVat' }}</span>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"form-group\">\r\n                    <label class=\"control-label col-sm-6\">{{ 'LblVat' | translate }}</label>\r\n                    <div class=\"col-sm-6\">\r\n                      <select [disabled]=\"invoiceAlreadySent\" [(ngModel)]=\"model.approvedVatPercentage\" (change)=\"ApprovedVatChange()\" name=\"approvedVatPercentage\"\r\n                        class=\"form-control\">\r\n                        <option *ngFor=\"let item of vatSettingList\" [value]=\"item.value\">{{ item.data }}</option>\r\n                      </select>\r\n                      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'approvedVatPercentage' }}</span>\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"form-group\">\r\n                    <label class=\"control-label col-sm-6\">{{ 'LblIncludingVat' | translate }}</label>\r\n                    <div class=\"col-sm-6\">\r\n                      <input maxlength=\"7\" [disabled]=\"invoiceAlreadySent\" type=\"text\" class=\"form-control\" [(ngModel)]=\"model.approvedAmountInVat\"\r\n                        name=\"approvedAmountInVat\" (change)=\"ApprovedAmtInVatChange()\">\r\n                      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'ApprovedAmountInVat' }}</span>\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </fieldset>\r\n            </div>\r\n            <div *ngIf=\"model.isEditable || model.isDescCostTypeOnlyEdit\" class=\"row\">\r\n              <hr>\r\n              <div class=\"col-sm-12 text-right\">\r\n                <a *ngIf=\"!model.invoiceNumber\" class=\"btn btn-gray cursor-pointer\" (click)=\"OnReject()\">{{ 'LblReject' | translate }}</a> &nbsp;&nbsp;\r\n                <button class=\"btn btn-green\" type=\"button\" (click)=\"OnApprove()\">{{ 'LblAccept' | translate }}</button>\r\n              </div>\r\n            </div>\r\n          </fieldset>\r\n        </form>\r\n        <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<wego-image-popup #receiptImagePopup></wego-image-popup>";

/***/ },
/* 1302 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var invoice_service_1 = __webpack_require__(723);
	var InvoiceDriverPopupComponent = (function () {
	    function InvoiceDriverPopupComponent(authService, router, translate, invoiceService) {
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.invoiceService = invoiceService;
	        this.onSuccessSelect = new core_1.EventEmitter();
	    }
	    InvoiceDriverPopupComponent.prototype.ngOnInit = function () {
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.searchField = ['driverName', 'firstName', 'lastName'];
	    };
	    InvoiceDriverPopupComponent.prototype.ngOnChanges = function (change) {
	        console.log(change);
	    };
	    InvoiceDriverPopupComponent.prototype.show = function (instanceHashId, companyHashId) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.sortType = '';
	        this.DataListModel.sortReverse = null;
	        this.DataListModel.searchTerm = '';
	        this.DataListModel.infoMessage = '';
	        this.instanceHashId = instanceHashId;
	        this.companyHashId = companyHashId;
	        this.GetDriverList();
	        this.driverModal.show();
	    };
	    InvoiceDriverPopupComponent.prototype.hide = function () {
	        this.driverModal.hide();
	    };
	    InvoiceDriverPopupComponent.prototype.GetDriverList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.invoiceService
	            .GetDriverList(this.instanceHashId, this.DataListModel, this.companyHashId)
	            .subscribe(function (res) {
	            _this.driverList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    InvoiceDriverPopupComponent.prototype.select = function (driver) {
	        this.isLoading = true;
	        this.onSuccessSelect.emit({
	            DriverHashID: driver.driverHashId,
	            SharedVehicleGroupDriverHashId: driver.sharedVehicleDriverHashId,
	            DriverName: driver.driverName,
	            DriverFullName: !driver.firstName && !driver.lastName
	                ? driver.driverName
	                : ((driver.firstName ? driver.firstName : ' ') +
	                    ' ' +
	                    (driver.lastName ? driver.lastName : ' ')).trim()
	        });
	        this.isLoading = false;
	        this.hide();
	    };
	    InvoiceDriverPopupComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetDriverList();
	    };
	    InvoiceDriverPopupComponent.prototype.OnSearch = function (event) {
	        this.DataListModel.searchTerm = event.searchTerm;
	        this.DataListModel.currentPage = 1;
	        this.GetDriverList();
	    };
	    InvoiceDriverPopupComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetDriverList();
	    };
	    InvoiceDriverPopupComponent.prototype.OnPagingChange = function (event) {
	        console.log(this.DataListModel);
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetDriverList();
	    };
	    InvoiceDriverPopupComponent.prototype.OnSuccessSelect = function () { };
	    __decorate([
	        core_1.Output('OnSuccessSelect'), 
	        __metadata('design:type', Object)
	    ], InvoiceDriverPopupComponent.prototype, "onSuccessSelect", void 0);
	    __decorate([
	        core_1.ViewChild('driverModal'), 
	        __metadata('design:type', Object)
	    ], InvoiceDriverPopupComponent.prototype, "driverModal", void 0);
	    InvoiceDriverPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-invoice-driver-popup',
	            template: __webpack_require__(1303),
	            providers: [invoice_service_1.InvoiceService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _c) || Object, (typeof (_d = typeof invoice_service_1.InvoiceService !== 'undefined' && invoice_service_1.InvoiceService) === 'function' && _d) || Object])
	    ], InvoiceDriverPopupComponent);
	    return InvoiceDriverPopupComponent;
	    var _a, _b, _c, _d;
	}());
	exports.InvoiceDriverPopupComponent = InvoiceDriverPopupComponent;


/***/ },
/* 1303 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #driverModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n    <div class=\"modal-dialog modal-lg\">\r\n      <div class=\"modal-content\">\r\n        <div class=\"modal-header\">\r\n          <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n                      <span aria-hidden=\"true\">&times;</span>\r\n          </button>\r\n          <h4 class=\"modal-title\">{{ 'LblSelect' | translate }} {{ 'LblDriver' | translate }}</h4>\r\n        </div>\r\n        <div class=\"modal-body\">\r\n          <wego-search-list [IsExported]=\"false\" [SearchTerm]=\"DataListModel.searchTerm\" (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n          <div class=\"table table-responsive mar_bot_ziro\">\r\n            <table class=\"table table-bordered mar_bot_ziro\">\r\n              <thead>\r\n                <tr>\r\n                  <th class=\"text-center\">\r\n                    {{ 'LblSelect' | translate }}\r\n                  </th>\r\n                  <th class=\"cursor-pointer\" (click)=\"OnSort('firstName')\">\r\n                    {{ 'LblFirstName' | translate }}\r\n                    <wego-sort-list [FieldName]=\"'firstName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                  </th>\r\n                  <th class=\"cursor-pointer\" (click)=\"OnSort('lastName')\">\r\n                    {{ 'LblLastName' | translate }}\r\n                    <wego-sort-list [FieldName]=\"'lastName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                  </th>\r\n                  <th class=\"cursor-pointer\" (click)=\"OnSort('driverName')\">\r\n                    {{ 'LblDriver' | translate }}\r\n                    <wego-sort-list [FieldName]=\"'driverName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                  </th>\r\n                  <th class=\"cursor-pointer\" (click)=\"OnSort('organizationName')\">\r\n                    {{ 'LblOrganization' | translate }}\r\n                    <wego-sort-list [FieldName]=\"'organizationName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                  </th>\r\n                  <th class=\"cursor-pointer\" (click)=\"OnSort('sharedVechicleGroupName')\">\r\n                    {{ 'LblSharedVehicleGroup' | translate }}\r\n                    <wego-sort-list [FieldName]=\"'sharedVechicleGroupName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                  </th>\r\n                  <th class=\"cursor-pointer\" (click)=\"OnSort('endDateTimeUTC')\">\r\n                    {{ 'LblEndDateTime' | translate }}\r\n                    <wego-sort-list [FieldName]=\"'endDateTimeUTC'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                  </th>\r\n                  <!-- <th class=\"cursor-pointer\" (click)=\"OnSort('subscriptionName')\">\r\n                    {{ 'LblSubscription' | translate }}\r\n                    <wego-sort-list [FieldName]=\"'subscriptionName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                  </th> -->\r\n  \r\n                </tr>\r\n              </thead>\r\n              <tbody>\r\n                <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                  <tr *ngFor=\"let driver of driverList\">\r\n                    <td class=\"text-center\">\r\n                      <a class=\"cursor-pointer\" (click)=\"select(driver)\">\r\n                        <i class=\"fa fa-plus-square\"></i>\r\n                      </a>\r\n                    </td>\r\n                    <td>{{ driver.firstName }}</td>\r\n                    <td>{{ driver.lastName }}</td>\r\n                    <td>{{ driver.driverName }}</td>\r\n                    <td>{{ driver.organizationName }}</td>\r\n                    <td>{{ driver.sharedVechicleGroupName }}</td>\r\n                    <td>{{ driver.endDatetime }}</td>\r\n                    <!-- <td>{{ driver.subscriptionName }}</td>                     -->\r\n                  </tr>\r\n                </template>\r\n                <tr *ngIf=\"DataListModel.totalItems == 0\">\r\n                  <td class=\"text-center text-danger\" colspan=\"6\">\r\n                    {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                  </td>\r\n                </tr>\r\n              </tbody>\r\n            </table>\r\n          </div>\r\n          <div class=\"clearfix\"></div>\r\n          <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n            <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n              <div class=\"col-md-12\">\r\n                <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\" [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\"\r\n                  firstText=\"&laquo;\" lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>";

/***/ },
/* 1304 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var invoice_service_1 = __webpack_require__(723);
	var InvoiceOrganizationPopupComponent = (function () {
	    function InvoiceOrganizationPopupComponent(authService, router, translate, invoiceService) {
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.invoiceService = invoiceService;
	        this.onSuccessSelect = new core_1.EventEmitter();
	    }
	    InvoiceOrganizationPopupComponent.prototype.ngOnInit = function () {
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.searchField = ["organizationName", "companyName", "instanceName"];
	    };
	    InvoiceOrganizationPopupComponent.prototype.ngOnChanges = function (change) {
	        console.log(change);
	    };
	    InvoiceOrganizationPopupComponent.prototype.show = function (instanceHashId, companyHashId) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.sortType = "";
	        this.DataListModel.sortReverse = null;
	        this.DataListModel.searchTerm = "";
	        this.DataListModel.infoMessage = "";
	        this.instanceHashId = instanceHashId;
	        this.companyHashId = companyHashId;
	        this.GetOrganizationList();
	        this.driverModal.show();
	    };
	    InvoiceOrganizationPopupComponent.prototype.hide = function () {
	        this.driverModal.hide();
	    };
	    InvoiceOrganizationPopupComponent.prototype.GetOrganizationList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.invoiceService.GetOrganizationList(this.instanceHashId, this.DataListModel, this.companyHashId)
	            .subscribe(function (res) {
	            _this.organizationList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    InvoiceOrganizationPopupComponent.prototype.select = function (organization) {
	        this.isLoading = true;
	        this.onSuccessSelect.emit({ OrganizationHashID: organization.organizationMasterHashId, OrganizationName: organization.organizationName });
	        this.isLoading = false;
	        this.hide();
	    };
	    InvoiceOrganizationPopupComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetOrganizationList();
	    };
	    InvoiceOrganizationPopupComponent.prototype.OnSearch = function (event) {
	        this.DataListModel.searchTerm = event.searchTerm;
	        this.DataListModel.currentPage = 1;
	        this.GetOrganizationList();
	    };
	    InvoiceOrganizationPopupComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetOrganizationList();
	    };
	    ;
	    InvoiceOrganizationPopupComponent.prototype.OnPagingChange = function (event) {
	        console.log(this.DataListModel);
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetOrganizationList();
	    };
	    InvoiceOrganizationPopupComponent.prototype.OnSuccessSelect = function () {
	    };
	    __decorate([
	        core_1.Output('OnSuccessSelect'), 
	        __metadata('design:type', Object)
	    ], InvoiceOrganizationPopupComponent.prototype, "onSuccessSelect", void 0);
	    __decorate([
	        core_1.ViewChild('driverModal'), 
	        __metadata('design:type', Object)
	    ], InvoiceOrganizationPopupComponent.prototype, "driverModal", void 0);
	    InvoiceOrganizationPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-invoice-organization-popup',
	            template: __webpack_require__(1305),
	            providers: [invoice_service_1.InvoiceService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _c) || Object, (typeof (_d = typeof invoice_service_1.InvoiceService !== 'undefined' && invoice_service_1.InvoiceService) === 'function' && _d) || Object])
	    ], InvoiceOrganizationPopupComponent);
	    return InvoiceOrganizationPopupComponent;
	    var _a, _b, _c, _d;
	}());
	exports.InvoiceOrganizationPopupComponent = InvoiceOrganizationPopupComponent;


/***/ },
/* 1305 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #driverModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n    <div class=\"modal-dialog modal-lg\">\r\n      <div class=\"modal-content\">\r\n        <div class=\"modal-header\">\r\n          <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n                      <span aria-hidden=\"true\">&times;</span>\r\n          </button>\r\n          <h4 class=\"modal-title\">{{ 'LblSelect' | translate }} {{ 'LblOrganization' | translate }}</h4>\r\n        </div>\r\n        <div class=\"modal-body\">\r\n          <wego-search-list [IsExported]=\"false\" [SearchTerm]=\"DataListModel.searchTerm\" (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\" (OnPagingChange)=\"OnPagingChange($event)\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n          <div class=\"table table-responsive mar_bot_ziro\">\r\n            <table class=\"table table-bordered mar_bot_ziro\">\r\n              <thead>\r\n                <tr>\r\n                  <th class=\"text-center\">\r\n                    {{ 'LblSelect' | translate }}\r\n                  </th>\r\n                  <th class=\"cursor-pointer\" (click)=\"OnSort('organizationName')\">\r\n                    {{ 'LblOrganization' | translate }}\r\n                    <wego-sort-list [FieldName]=\"'organizationName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                  </th>\r\n                  <th class=\"cursor-pointer\" (click)=\"OnSort('companyName')\">\r\n                    {{ 'LblCompany' | translate }}\r\n                    <wego-sort-list [FieldName]=\"'companyName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                  </th>\r\n                  <th class=\"cursor-pointer\" (click)=\"OnSort('instanceName')\">\r\n                    {{ 'LblInstance' | translate }}\r\n                    <wego-sort-list [FieldName]=\"'instanceName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                  </th>\r\n  \r\n                </tr>\r\n              </thead>\r\n              <tbody>\r\n                <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                  <tr *ngFor=\"let organization of organizationList\">\r\n                    <td class=\"text-center\">\r\n                      <a class=\"cursor-pointer\" (click)=\"select(organization)\">\r\n                        <i class=\"fa fa-plus-square\"></i>\r\n                      </a>\r\n                    </td>\r\n                    <td>{{ organization.organizationName }}</td>\r\n                    <td>{{ organization.companyName }}</td>\r\n                    <td>{{ organization.instanceName }}</td>\r\n                  </tr>\r\n                </template>\r\n                <tr *ngIf=\"DataListModel.totalItems == 0\">\r\n                  <td class=\"text-center text-danger\" colspan=\"4\">\r\n                    {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                  </td>\r\n                </tr>\r\n              </tbody>\r\n            </table>\r\n          </div>\r\n          <div class=\"clearfix\"></div>\r\n          <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n            <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n              <div class=\"col-md-12\">\r\n                <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\" [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\"\r\n                  firstText=\"&laquo;\" lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n              </div>\r\n            </div>\r\n          </div>\r\n          <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>";

/***/ },
/* 1306 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var modal_1 = __webpack_require__(537);
	var core_1 = __webpack_require__(3);
	var translate_1 = __webpack_require__(631);
	var cost_expense_model_1 = __webpack_require__(1006);
	var config_1 = __webpack_require__(60);
	var flatpickr_model_1 = __webpack_require__(83);
	var cost_expense_service_1 = __webpack_require__(1010);
	var auth_service_1 = __webpack_require__(58);
	var invoice_service_1 = __webpack_require__(723);
	var booking_service_1 = __webpack_require__(556);
	var ManualInvoiceLinePopupComponent = (function () {
	    function ManualInvoiceLinePopupComponent(translate, costAndExpenseService, authService, invoiceService, bookingService) {
	        this.translate = translate;
	        this.costAndExpenseService = costAndExpenseService;
	        this.authService = authService;
	        this.invoiceService = invoiceService;
	        this.bookingService = bookingService;
	        this._model = new cost_expense_model_1.CostAndExpenseModel();
	        this.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
	        this.BookingList = [];
	        this.costAndExpenseList = [];
	        this.DataListModel = new config_1.DataListModel();
	        this.isNew = true;
	        // @Input()
	        // set addreseeOrganizationId(addreseeOrganizationId: string) {
	        //   this._addreseeOrganizationId = addreseeOrganizationId;
	        // }
	        // get addreseeOrganizationId() { return this._addreseeOrganizationId; }
	        this.OnSuccessSelect = new core_1.EventEmitter();
	        this.costAndExpensesList = [];
	    }
	    Object.defineProperty(ManualInvoiceLinePopupComponent.prototype, "model", {
	        get: function () {
	            return this._model;
	        },
	        set: function (model) {
	            this._model = model;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ManualInvoiceLinePopupComponent.prototype, "SelectedExpenseHashIdList", {
	        get: function () {
	            return this._selectedExpenseHashIdList;
	        },
	        set: function (selectedExpenseHashIdList) {
	            this._selectedExpenseHashIdList = selectedExpenseHashIdList;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ManualInvoiceLinePopupComponent.prototype.ngOnInit = function () {
	        this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
	        //this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
	    };
	    ManualInvoiceLinePopupComponent.prototype.SetDefaultFlatPickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = true;
	        flatPickrConfig.time_24hr = true;
	        flatPickrConfig.dateFormat = this.dateFormat;
	        flatPickrConfig.minuteIncrement = 1;
	        return flatPickrConfig;
	    };
	    ManualInvoiceLinePopupComponent.prototype.GetCostTypeList = function () {
	        var _this = this;
	        this.costAndExpenseService
	            .GetDropdownCostTypeList('', this.model.recipientDriverHashId, this.model.recipientOrganizationHashId)
	            .subscribe(function (res) {
	            _this.costTypeList = res.data;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    ManualInvoiceLinePopupComponent.prototype.GetBookingList = function () {
	        var _this = this;
	        this.invoiceService
	            .GetDropdownBookingList(this.model.sharedVehicleGroupDriverHashId, this.model.recipientOrganizationHashId)
	            .subscribe(function (res) {
	            _this.BookingList = res.data;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    ManualInvoiceLinePopupComponent.prototype.GetApprovedCostAndExpenseList = function () {
	        var _this = this;
	        this.costAndExpenseService
	            .GetApprovedExpenseList(this.model.sharedVehicleGroupDriverHashId, this.model.recipientOrganizationHashId)
	            .subscribe(function (res) {
	            _this.costAndExpenseList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            // this.NoDataValidation = res.error;
	            console.log(_this.DataListModel);
	            _this.costAndExpenseList = _this.costAndExpenseList.filter(function (x) {
	                return !(_this.SelectedExpenseHashIdList.indexOf(x.costAndExpenseHashId) >
	                    -1);
	            });
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    ManualInvoiceLinePopupComponent.prototype.show = function () {
	        this.apiErrorMsg = '';
	        this.existingExpenseMsg = '';
	        this.errorModel = [];
	        this.manualInvoiceLineModal.show();
	        this.GetBookingList();
	        this.GetCostTypeList();
	        this.GetVatSettingDropdownList();
	        this.GetApprovedCostAndExpenseList();
	    };
	    ManualInvoiceLinePopupComponent.prototype.hide = function () {
	        this.manualInvoiceLineModal.hide();
	    };
	    ManualInvoiceLinePopupComponent.prototype.Confirm = function ($event) {
	        this.hide();
	    };
	    ManualInvoiceLinePopupComponent.prototype.OnBookingChange = function () {
	        this.GetVatSettingDropdownList();
	    };
	    ManualInvoiceLinePopupComponent.prototype.GetVatSettingDropdownList = function () {
	        var _this = this;
	        if (this.model.bookingHashId) {
	            this.bookingService
	                .GetVatSettingDropdownList(this.model.bookingHashId)
	                .subscribe(function (res) {
	                if (res.data) {
	                    _this.vatSettingList = res.data;
	                    if (_this.vatSettingList.length > 0) {
	                        _this.model.reportedVatPercentage = _this.vatSettingList[0].data;
	                    }
	                }
	                else {
	                    _this.apiErrorMsg = res.error;
	                }
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            });
	        }
	    };
	    ManualInvoiceLinePopupComponent.prototype.GetVatSettingDefaultValues = function () {
	        var _this = this;
	        this.bookingService
	            .GetVatSettingDefaultValues(this.model.bookingHashId)
	            .subscribe(function (res) {
	            if (res.data) {
	                var vatSettingDefaultValues = res.data;
	                _this.vatSettingDefaultCost =
	                    vatSettingDefaultValues.vatSettingDefaultCost;
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    ManualInvoiceLinePopupComponent.prototype.onSubmit = function () {
	        if (this.isNew) {
	            var frmData = new FormData();
	            this.model.reportedByDriver = false;
	            if (this.receiptFile &&
	                this.receiptFile.nativeElement &&
	                this.receiptFile.nativeElement.files &&
	                this.receiptFile.nativeElement.files.length > 0) {
	                frmData.append('receiptFile', this.receiptFile.nativeElement.files[0], this.receiptFile.nativeElement.files[0].name);
	            }
	            if (this.model) {
	                frmData.append('manualInvoiceLine', JSON.stringify(this.model));
	            }
	            this.UploadManualLine(frmData);
	        }
	        else {
	            var selectedExpense = this.costAndExpenseList
	                .filter(function (x) { return x.isChecked; })
	                .map(function (x) { return x; });
	            if (!selectedExpense || selectedExpense.length == 0) {
	                this.existingExpenseMsg = this.translate.instant('LblSelectAtLeastOneExpense');
	            }
	            else {
	                this.existingExpenseMsg = '';
	                this.OnSuccessSelect.emit({ CostAndExpenseModelList: selectedExpense });
	                this.hide();
	            }
	        }
	    };
	    ManualInvoiceLinePopupComponent.prototype.ClearFileInput = function () {
	        if (this.receiptFile && this.receiptFile.nativeElement) {
	            this.receiptFile.nativeElement.value = '';
	        }
	    };
	    ManualInvoiceLinePopupComponent.prototype.UploadManualLine = function (formData) {
	        var _this = this;
	        this.invoiceService
	            .UpdateCostAndExpenses(formData, this._model.module)
	            .subscribe(function (res) {
	            console.log(res);
	            if (res.data) {
	                _this.errorModel = [];
	                _this.ClearFileInput();
	                if (!_this._model.costAndExpenseHashId) {
	                    // this._model.approvedVatPercentage = this._model.reportedVatPercentage;
	                    // this._model.reportedVatAmount = (
	                    //   this._model.reportedAmountExVat *
	                    //   this._model.reportedVatPercentage /
	                    //   100
	                    // ).valueOf();
	                    // this._model.approvedAmountVat = this._model.reportedVatAmount;
	                    // this._model.reportedAmountInVat =
	                    //   Number.parseFloat(this._model.reportedAmountExVat.toString()) +
	                    //   Number.parseFloat(this._model.reportedVatAmount.toString());
	                    // this._model.approvedAmountInVat = this._model.reportedAmountInVat;
	                    // this._model.approvedAmountExVat = this._model.reportedAmountExVat;
	                    _this._model.costAndExpenseHashId = res.data;
	                    _this.costAndExpenseService
	                        .GetCostAndExpenseByHashId(_this._model.costAndExpenseHashId)
	                        .subscribe(function (res) {
	                        _this._model.approvedVatPercentage = res.data.reportedVatPercentage;
	                        _this._model.reportedVatAmount = (res.data.reportedAmountExVatActual * res.data.reportedVatPercentage / 100).valueOf();
	                        _this._model.approvedAmountVat = res.data.approvedAmountVat;
	                        _this._model.reportedAmountInVat = res.data.reportedAmountInVat;
	                        _this._model.approvedAmountInVat = res.data.approvedAmountInVat;
	                        _this._model.approvedAmountExVat = res.data.approvedAmountExVat;
	                        _this.OnSuccessSelect.emit({ CostAndExpenseModel: _this._model });
	                        _this.hide();
	                    }, function (error) {
	                        _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	                    });
	                }
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            console.log(error);
	            _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    ManualInvoiceLinePopupComponent.prototype.ShowUpdateManualInvoiceLinePopup = function (expense) {
	        this.manualInvoiceLineUpdate.model = expense;
	        if (!expense.reportedByDriver) {
	            this.manualInvoiceLineUpdate.show(true);
	        }
	        else {
	            expense.isEditable = false;
	            this.costAndExpensePopup.show(expense);
	        }
	    };
	    ManualInvoiceLinePopupComponent.prototype.ManualInvoiceLineUpdateSuccess = function ($event) {
	        console.log($event);
	        var cost = $event.CostAndExpenseModel;
	        var costExpenseIndex = this.costAndExpenseList.findIndex(function (x) { return x.costAndExpenseHashId == cost.costAndExpenseHashId; });
	        if (costExpenseIndex >= 0) {
	            this.costAndExpenseList[costExpenseIndex] = cost;
	        }
	    };
	    ManualInvoiceLinePopupComponent.prototype.ChildPopupHidden = function () {
	        document.body.classList.add('modal-open');
	    };
	    ManualInvoiceLinePopupComponent.prototype.SetVatDefaultCost = function (vatSettingDefaultCost) {
	        return vatSettingDefaultCost
	            ? this.translate.instant('LblExcludingVat')
	            : this.translate.instant('LblIncludingVat');
	    };
	    ManualInvoiceLinePopupComponent.prototype.ngOnDestroy = function () { };
	    __decorate([
	        core_1.ViewChild('receiptFile'), 
	        __metadata('design:type', Object)
	    ], ManualInvoiceLinePopupComponent.prototype, "receiptFile", void 0);
	    __decorate([
	        core_1.ViewChild('manualInvoiceLineModal'), 
	        __metadata('design:type', (typeof (_a = typeof modal_1.ModalDirective !== 'undefined' && modal_1.ModalDirective) === 'function' && _a) || Object)
	    ], ManualInvoiceLinePopupComponent.prototype, "manualInvoiceLineModal", void 0);
	    __decorate([
	        core_1.ViewChild('manualInvoiceLineUpdate'), 
	        __metadata('design:type', Object)
	    ], ManualInvoiceLinePopupComponent.prototype, "manualInvoiceLineUpdate", void 0);
	    __decorate([
	        core_1.ViewChild('costAndExpensePopup'), 
	        __metadata('design:type', Object)
	    ], ManualInvoiceLinePopupComponent.prototype, "costAndExpensePopup", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_b = typeof cost_expense_model_1.CostAndExpenseModel !== 'undefined' && cost_expense_model_1.CostAndExpenseModel) === 'function' && _b) || Object), 
	        __metadata('design:paramtypes', [(typeof (_c = typeof cost_expense_model_1.CostAndExpenseModel !== 'undefined' && cost_expense_model_1.CostAndExpenseModel) === 'function' && _c) || Object])
	    ], ManualInvoiceLinePopupComponent.prototype, "model", null);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array), 
	        __metadata('design:paramtypes', [Array])
	    ], ManualInvoiceLinePopupComponent.prototype, "SelectedExpenseHashIdList", null);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], ManualInvoiceLinePopupComponent.prototype, "OnSuccessSelect", void 0);
	    ManualInvoiceLinePopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-manual-invoice-line-popup',
	            template: __webpack_require__(1307),
	            providers: [cost_expense_service_1.CostAndExpenseService, invoice_service_1.InvoiceService, booking_service_1.BookingService],
	            styles: [
	                "\n    .form-horizontal .control-label{\n      text-align: left;\n    }\n  "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_d = typeof translate_1.TranslateService !== 'undefined' && translate_1.TranslateService) === 'function' && _d) || Object, (typeof (_e = typeof cost_expense_service_1.CostAndExpenseService !== 'undefined' && cost_expense_service_1.CostAndExpenseService) === 'function' && _e) || Object, (typeof (_f = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _f) || Object, (typeof (_g = typeof invoice_service_1.InvoiceService !== 'undefined' && invoice_service_1.InvoiceService) === 'function' && _g) || Object, (typeof (_h = typeof booking_service_1.BookingService !== 'undefined' && booking_service_1.BookingService) === 'function' && _h) || Object])
	    ], ManualInvoiceLinePopupComponent);
	    return ManualInvoiceLinePopupComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h;
	}());
	exports.ManualInvoiceLinePopupComponent = ManualInvoiceLinePopupComponent;


/***/ },
/* 1307 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #manualInvoiceLineModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-md\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblManualInvoiceLine' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <div class=\"radio-inline\">\r\n          <label>\r\n            <input type=\"radio\" [(ngModel)]=\"isNew\" name=\"isNew\" [value]=\"true\">{{ 'LblAddNewInvoiceLine' | translate }}\r\n          </label>\r\n        </div>\r\n        <fieldset [disabled]=\"!isNew\">\r\n          <form class=\"form-horizontal col-sm-12 mar_t_10\">\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-4\">\r\n                <span *ngIf=\"isNew\" class=\"text text-danger\">*</span>\r\n                {{ 'LblBookingId' | translate }}\r\n              </label>\r\n              <div class=\"col-sm-8\">\r\n                <select [(ngModel)]=\"model.bookingHashId\" class=\"form-control\" (change)=\"OnBookingChange()\" name=\"bookingId\">\r\n                  <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblBookingId' | translate }}</option>\r\n                  <option *ngFor=\"let item of BookingList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\r\n                </select>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'BookingHashId' }}</span>\r\n              </div>\r\n            </div>\r\n            <div class=\"form-group\">\r\n              <label class=\"col-sm-4\">{{ 'LblReceiptOrSupport' | translate }}</label>\r\n              <div class=\"col-sm-8\">\r\n                <input [disabled]=\"!model.bookingHashId\" #receiptFile type=\"file\" name=\"receiptFile\" accept=\"image/x-png,image/png,image/gif,image/jpeg\"\r\n                  style=\"width: 100%;\">\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'receipt' }}</span>\r\n              </div>\r\n            </div>\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-4\">\r\n                <span *ngIf=\"isNew\" class=\"text text-danger\">*</span>\r\n                {{ 'LblDate' | translate }}\r\n              </label>\r\n              <div class=\"col-sm-8\">\r\n                <input maxlength=\"100\" [disabled]=\"!model.bookingHashId\" class=\"form-control\" flatpickr readonly [Config]=\"flatPickrConfigFrom\"\r\n                  [(ngModel)]=\"model.reportedDateTime\" name=\"date\" id=\"date\" placeholder=\"{{ 'LblDate' | translate }}\">\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'ReportedDateTime' }}</span>\r\n              </div>\r\n            </div>\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-4\">\r\n                <span *ngIf=\"isNew\" class=\"text text-danger\">*</span>\r\n                {{ 'LblDescription' | translate }}\r\n              </label>\r\n              <div class=\"col-sm-8\">\r\n                <input [disabled]=\"!model.bookingHashId\" [(ngModel)]=\"model.description\" class=\"form-control\" name=\"description\" id=\"description\"\r\n                  placeholder=\"{{ 'LblDescription' | translate }}\">\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'Description' }}</span>\r\n              </div>\r\n            </div>\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-4\">\r\n                <span *ngIf=\"isNew\" class=\"text text-danger\">*</span>\r\n                {{ 'LblType' | translate }}\r\n              </label>\r\n              <div class=\"col-sm-8\">\r\n                <select [disabled]=\"!model.bookingHashId\" [(ngModel)]=\"model.costTypeHashId\" class=\"form-control\" name=\"costTypeHashId\">\r\n                  <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblCostType' | translate }}</option>\r\n                  <option *ngFor=\"let item of costTypeList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\r\n                </select>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'CostTypeHashId' }}</span>\r\n              </div>\r\n            </div>\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-4\">\r\n                <span *ngIf=\"isNew\" class=\"text text-danger\">*</span>\r\n                {{ 'LblAmount' | translate }} {{ 'LblExVat' | translate }}\r\n              </label>\r\n              <div class=\"col-sm-8\">\r\n                <input maxlength=\"7\" [disabled]=\"!model.bookingHashId\" class=\"form-control\" [(ngModel)]=\"model.reportedAmountExVat\" name=\"reportedAmountExVat\"\r\n                  id=\"reportedAmountExVat\" placeholder=\"{{ 'LblAmount' | translate }} {{ 'LblExVat' | translate }}\">\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'ReportedAmountExVat' }}</span>\r\n              </div>\r\n            </div>\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-4\">{{ 'LblVATPercentage' | translate }}</label>\r\n              <div class=\"col-sm-8\">\r\n                <select [disabled]=\"!model.bookingHashId\" [(ngModel)]=\"model.reportedVatPercentage\" name=\"reportedVatPercentage\" class=\"form-control\">\r\n                  <option *ngFor=\"let item of vatSettingList\" [value]='item.value'>{{item.data}}</option>\r\n                </select>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'ReportedVatPercentage' }}</span>\r\n              </div>\r\n            </div>\r\n            <fieldset [disabled]=\"!model.bookingHashId\" class=\"form-group col-sm-12\">\r\n              <div class=\"radio-inline\">\r\n                <label>\r\n                  <input type=\"radio\" [(ngModel)]=\"model.isCharge\" name=\"isCharge\" [value]=\"true\">{{ 'LblChargeTo' | translate }}\r\n                </label>\r\n              </div>\r\n              <div class=\"radio-inline\">\r\n                <label>\r\n                  <input type=\"radio\" [(ngModel)]=\"model.isCharge\" name=\"isCharge\" [value]=\"false\">{{ 'LblReimburseTo' | translate }}\r\n                </label>\r\n              </div>\r\n            </fieldset>\r\n          </form>\r\n        </fieldset>\r\n        <div class=\"radio-inline\">\r\n          <label>\r\n            <input type=\"radio\" [(ngModel)]=\"isNew\" name=\"isNew\" [value]=\"false\">{{ 'LblSelectUnprocessedExpenses' | translate }}\r\n          </label>\r\n        </div>\r\n        <fieldset [disabled]=\"isNew\">\r\n          <div class=\"col-sm-12 mar_t_10\">\r\n            <span class=\"text-danger\">{{ existingExpenseMsg }}</span>\r\n            <div class=\"table table-responsive mar_bot_ziro\">\r\n              <table class=\"table table-bordered mar_bot_ziro\">\r\n                <thead>\r\n                  <tr>\r\n                    <th class=\"text-center parent-checkbox\">\r\n                    </th>\r\n                    <th class=\"cursor-pointer\">\r\n                      {{ 'LblDescription' | translate }}\r\n                    </th>\r\n                    <th class=\"cursor-pointer\">\r\n                      {{ 'LblReportedBy' | translate }}\r\n                    </th>\r\n                    <th class=\"cursor-pointer\">\r\n                      {{ 'LblBookingId' | translate }}\r\n                    </th>\r\n                    <th class=\"cursor-pointer\">\r\n                      {{ 'LblApprovedAmount' | translate }} {{ 'LblInclVat' | translate }}\r\n                    </th>\r\n                  </tr>\r\n                </thead>\r\n                <tbody>\r\n                  <tr *ngFor=\"let expense of costAndExpenseList\">\r\n                    <td class=\"text-center\">\r\n                      <input type=\"checkbox\" name=\"isActive\" [(ngModel)]=\"expense.isChecked\">\r\n                    </td>\r\n                    <td>\r\n                      <a class=\"cursor-pointer\" *ngIf=\"!expense.invoiceNumber\" (click)=\"ShowUpdateManualInvoiceLinePopup(expense)\">\r\n                        {{ expense.description }}\r\n                      </a>\r\n                      <span *ngIf=\"expense.invoiceNumber\"> {{ expense.description}}</span>\r\n                    </td>\r\n                    <td>{{ expense.reportedByName}}</td>\r\n                    <td>{{ expense.bookingReferenceID}}</td>\r\n                    <td>{{ expense.approvedAmountInVat }}</td>\r\n                  </tr>\r\n                  <tr *ngIf=\"DataListModel.totalItems == 0 && !isLoading\">\r\n                    <td class=\"text-center text-danger\" colspan=\"5\">\r\n                      <!-- {{ NoDataValidation }} {{ apiErrorMsg }} -->\r\n                      {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                    </td>\r\n                  </tr>\r\n                </tbody>\r\n              </table>\r\n            </div>\r\n          </div>\r\n        </fieldset>\r\n      </div>\r\n      <div class=\"modal-footer\">\r\n        <button type=\"button\" (click)=\"onSubmit()\" class=\"btn btn-green\">{{ 'LblOK' | translate }}</button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<wego-manual-invoice-line-update-popup #manualInvoiceLineUpdate (OnHidden)=\"ChildPopupHidden()\" (OnSuccessSelect)=\"ManualInvoiceLineUpdateSuccess($event)\"></wego-manual-invoice-line-update-popup>\r\n<confirm-costandexpense-popup #costAndExpensePopup (OnHidden)=\"ChildPopupHidden()\" (OnSuccessSave)=\"SuccessCostAndExpenseList()\"></confirm-costandexpense-popup>";

/***/ },
/* 1308 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var modal_1 = __webpack_require__(537);
	var core_1 = __webpack_require__(3);
	var terms_condition_popup_service_1 = __webpack_require__(639);
	var auth_service_1 = __webpack_require__(58);
	var TermsAndConditionsPopup = (function () {
	    function TermsAndConditionsPopup(termsConditionPopup, authService) {
	        this.termsConditionPopup = termsConditionPopup;
	        this.authService = authService;
	    }
	    TermsAndConditionsPopup.prototype.ngOnInit = function () {
	    };
	    TermsAndConditionsPopup.prototype.Confirm = function ($event) {
	        this.hide();
	        //this.onConfirm.emit($event);
	    };
	    TermsAndConditionsPopup.prototype.show = function (bodyHTMLText) {
	        this.bodyHTMLText = bodyHTMLText;
	        this.termsConditionModel.show();
	    };
	    TermsAndConditionsPopup.prototype.hide = function () {
	        this.termsConditionModel.hide();
	    };
	    __decorate([
	        core_1.ViewChild('termsConditionModel'), 
	        __metadata('design:type', (typeof (_a = typeof modal_1.ModalDirective !== 'undefined' && modal_1.ModalDirective) === 'function' && _a) || Object)
	    ], TermsAndConditionsPopup.prototype, "termsConditionModel", void 0);
	    TermsAndConditionsPopup = __decorate([
	        core_1.Component({
	            selector: 'wego-terms-condition-popup',
	            template: __webpack_require__(1309),
	            providers: [terms_condition_popup_service_1.TermsConditionPopup],
	            encapsulation: core_1.ViewEncapsulation.None,
	            styles: ["\n  span.popimgstyle img {\n    max-width: 100% !important;\n    height: auto !important;\n}\n"]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof terms_condition_popup_service_1.TermsConditionPopup !== 'undefined' && terms_condition_popup_service_1.TermsConditionPopup) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object])
	    ], TermsAndConditionsPopup);
	    return TermsAndConditionsPopup;
	    var _a, _b, _c;
	}());
	exports.TermsAndConditionsPopup = TermsAndConditionsPopup;


/***/ },
/* 1309 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #termsConditionModel=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-md\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <h4 class=\"modal-title\">{{ 'LblTermsAndCondition' | translate }}</h4>\r\n      </div>\r\n      <div class=\"model-content\">\r\n        <div class=\"row\">\r\n          <div class=\"col-xs-12 col-sm-8 col-sm-offset-1\">\r\n            <span [innerHTML]=\"bodyHTMLText\" style=\"text-align: left;\" class=\"popimgstyle\"></span>\r\n          </div>\r\n        </div>\r\n        <br/><br/>\r\n      </div>\r\n      <div class=\"modal-footer\">\r\n        <button type=\"button\" class=\"btn btn-green\" (click)=\"Confirm($event)\">{{ 'LblClose' |  translate }}</button>\r\n      </div>\r\n    </div>\r\n  </div>";

/***/ },
/* 1310 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var KickbackDataGridComponent = (function () {
	    function KickbackDataGridComponent() {
	    }
	    KickbackDataGridComponent.prototype.ngOnInit = function () { };
	    KickbackDataGridComponent.prototype.GetLabelName = function (groupName) {
	        switch (groupName) {
	            case "INSTANCE":
	                return "LblInstance";
	            case "COMPANY":
	                return "LblCompany";
	            case "VEHICLE":
	                return "LblVehicle";
	            case "SVG":
	                return "LblSVG";
	            case "ORGANIZATION":
	                return "LblOrganization";
	            case "CTG":
	                return "LblContractTypeGroup";
	        }
	    };
	    __decorate([
	        core_1.Input("Data"), 
	        __metadata('design:type', Array)
	    ], KickbackDataGridComponent.prototype, "data", void 0);
	    KickbackDataGridComponent = __decorate([
	        core_1.Component({
	            selector: "wego-kickback-data-grid",
	            template: __webpack_require__(1311),
	            styles: [
	                "\n      .level-1 {\n        padding-left: 15px;\n      }\n      .level-2 {\n        padding-left: 45px;\n      }\n      .level-3 {\n        padding-left: 75px;\n      }\n      .level-4 {\n        padding-left: 105px;\n      }\n      .level-5 {\n        padding-left: 135px;\n      }\n      .level-6 {\n        padding-left: 165px;\n      }\n      .border-kickback-data-grid {\n        border: 1px solid #E0E0E0;\n        border-top: none;\n        padding: 5px 0px;\n      }\n    "
	            ]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], KickbackDataGridComponent);
	    return KickbackDataGridComponent;
	}());
	exports.KickbackDataGridComponent = KickbackDataGridComponent;


/***/ },
/* 1311 */
/***/ function(module, exports) {

	module.exports = "<div *ngFor=\"let item of data\">\r\n  <div class=\"row border-kickback-data-grid\">\r\n    <div class=\"col-md-6\" [ngClass]=\"'level-' + item.levelNo\">\r\n      <b>{{ GetLabelName(item.groupName) | translate }}: {{ item.name }}</b>\r\n    </div>\r\n    <div class=\"col-md-2\">\r\n      {{ 'LblDistance' | translate }}\r\n      <br/> {{ 'LblTime' | translate }}\r\n      <br/> {{ 'LblFixedCost' | translate }}\r\n      <br/>\r\n      <b>{{ 'LblTotal' | translate }}: {{ item.name }}</b>\r\n    </div>\r\n    <div class=\"col-md-2\">\r\n      {{ item.kilometerCostModel.costExVatFormatted }}\r\n      <br/> {{ item.timeCostModel.costExVatFormatted }}\r\n      <br/> {{ item.fixedFeeCostModel.costExVatFormatted }}\r\n      <br/>\r\n      <b> {{ item.totalCostModel.costExVatFormatted }}</b>\r\n    </div>\r\n    <div class=\"col-md-2\">\r\n      {{ item.kilometerCostModel.costInVatFormatted }}\r\n      <br/> {{ item.timeCostModel.costInVatFormatted }}\r\n      <br/> {{ item.fixedFeeCostModel.costInVatFormatted }}\r\n      <br/>\r\n      <b> {{ item.totalCostModel.costInVatFormatted }}</b>\r\n    </div>\r\n  </div>\r\n  <template [ngIf]=\"item.subKickbackModel\">\r\n    <wego-kickback-data-grid [Data]=\"item.subKickbackModel\"></wego-kickback-data-grid>\r\n  </template>\r\n</div>";

/***/ },
/* 1312 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var invoicing_setting_model_1 = __webpack_require__(828);
	var company_model_1 = __webpack_require__(827);
	var InvoicingSettingComponent = (function () {
	    function InvoicingSettingComponent() {
	        this._childCompanyName = "";
	        this._combinedCompanyAddress = "";
	        this.companyAddressModel = new company_model_1.CompanyAddressModel();
	    }
	    Object.defineProperty(InvoicingSettingComponent.prototype, "childCompanyName", {
	        get: function () {
	            return this._childCompanyName;
	        },
	        set: function (input) {
	            if (!this.childCompanyNameElement.nativeElement.classList.contains("ng-dirty")) {
	                this._childCompanyName = input;
	                this.invoiceSettings.companyName = this._childCompanyName;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(InvoicingSettingComponent.prototype, "companyAddress", {
	        get: function () {
	            return this._combinedCompanyAddress;
	        },
	        set: function (input) {
	            if (!this.childAddressElement.nativeElement.classList.contains("ng-dirty")) {
	                this._combinedCompanyAddress = input;
	                this.invoiceSettings.address = this._combinedCompanyAddress;
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    InvoicingSettingComponent.prototype.ngOnInit = function () { };
	    __decorate([
	        core_1.Input("ErrorModel"), 
	        __metadata('design:type', Array)
	    ], InvoicingSettingComponent.prototype, "errorModel", void 0);
	    __decorate([
	        core_1.Input("InvoiceSettings"), 
	        __metadata('design:type', (typeof (_a = typeof invoicing_setting_model_1.InvoiceSettingModel !== 'undefined' && invoicing_setting_model_1.InvoiceSettingModel) === 'function' && _a) || Object)
	    ], InvoicingSettingComponent.prototype, "invoiceSettings", void 0);
	    __decorate([
	        core_1.ViewChild("childCompanyNameElement"), 
	        __metadata('design:type', (typeof (_b = typeof core_1.ElementRef !== 'undefined' && core_1.ElementRef) === 'function' && _b) || Object)
	    ], InvoicingSettingComponent.prototype, "childCompanyNameElement", void 0);
	    __decorate([
	        core_1.ViewChild("childAddressElement"), 
	        __metadata('design:type', (typeof (_c = typeof core_1.ElementRef !== 'undefined' && core_1.ElementRef) === 'function' && _c) || Object)
	    ], InvoicingSettingComponent.prototype, "childAddressElement", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String), 
	        __metadata('design:paramtypes', [String])
	    ], InvoicingSettingComponent.prototype, "childCompanyName", null);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String), 
	        __metadata('design:paramtypes', [String])
	    ], InvoicingSettingComponent.prototype, "companyAddress", null);
	    InvoicingSettingComponent = __decorate([
	        core_1.Component({
	            selector: "wego-invoicing-setting",
	            template: __webpack_require__(1313)
	        }), 
	        __metadata('design:paramtypes', [])
	    ], InvoicingSettingComponent);
	    return InvoicingSettingComponent;
	    var _a, _b, _c;
	}());
	exports.InvoicingSettingComponent = InvoicingSettingComponent;


/***/ },
/* 1313 */
/***/ function(module, exports) {

	module.exports = "<div class=\"form-group col-md-12\">\r\n  <div class=\"row\">\r\n\r\n    <div class=\"col-md-12\">\r\n      <h5><label>{{ 'LblInvoiceSender' | translate }}</label></h5>\r\n    </div>\r\n\r\n    <div class=\"form-group col-md-6\">\r\n      <label><span class=\"text text-danger\">*</span> {{ 'LblCompanyName' | translate }}</label>\r\n      <input #childCompanyNameElement type=\"text\" class=\"form-control\" [(ngModel)]=\"invoiceSettings.companyName\" placeholder=\"{{ 'LblCompanyName' | translate }}\" name=\"companyName\" maxlength=\"100\" value=\"{{ childCompanyName }}\">\r\n      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'invoiceSettings.companyName' }}</span>\r\n    </div>\r\n\r\n    <div class=\"form-group col-md-6\">\r\n      <label><span class=\"text text-danger\">*</span> {{ 'LblAddress' | translate }}</label>\r\n      <input #childAddressElement type=\"text\" class=\"form-control\" [(ngModel)]=\"invoiceSettings.address\" placeholder=\"{{ 'LblAddress' | translate }}\" name=\"address\" maxlength=\"200\" value=\"{{ companyAddress }}\">\r\n      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'invoiceSettings.address' }}</span>\r\n    </div>\r\n\r\n    <div class=\"form-group col-md-6\">\r\n      <label>{{ 'LblEmail' | translate }}</label>\r\n      <input type=\"text\" class=\"form-control\" [(ngModel)]=\"invoiceSettings.email\" placeholder=\"{{ 'LblEmail' | translate }}\" name=\"email\" maxlength=\"100\">\r\n      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'invoiceSettings.email' }}</span>\r\n    </div>\r\n\r\n    <div class=\"form-group col-md-6\">\r\n      <label>{{ 'LblIBANNumber' | translate }}</label>\r\n      <input type=\"text\" class=\"form-control\" [(ngModel)]=\"invoiceSettings.ibanNumber\" placeholder=\"{{ 'LblIBANNumber' | translate }}\" name=\"iBANNumber\" maxlength=\"100\">\r\n      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'invoiceSettings.iBANNumber' }}</span>\r\n    </div>\r\n\r\n    <div class=\"form-group col-md-6\">\r\n      <label>{{ 'LblChamberOfCommerce' | translate }}</label>\r\n      <input type=\"text\" class=\"form-control\" [(ngModel)]=\"invoiceSettings.chamberOfCommerce\" placeholder=\"{{ 'LblChamberOfCommerce' | translate }}\" name=\"chamberOfCommerce\" maxlength=\"100\">\r\n      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'invoiceSettings.chamberOfCommerce' }}</span>\r\n    </div>\r\n\r\n    <div class=\"form-group col-md-6\">\r\n      <label>{{ 'LblVatNumber' | translate }}</label>\r\n      <input type=\"text\" class=\"form-control\" [(ngModel)]=\"invoiceSettings.vatNumber\" placeholder=\"{{ 'LblVatNumber' | translate }}\" name=\"vatNumber\" maxlength=\"100\">\r\n      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'invoiceSettings.vatNumber' }}</span>\r\n    </div>\r\n\r\n    <div class=\"form-group col-md-6\">\r\n      <label>{{ 'LblInvoicePreFix' | translate }}</label>\r\n      <input type=\"text\" class=\"form-control\" [(ngModel)]=\"invoiceSettings.invoicePreFix\" placeholder=\"{{ 'LblInvoicePreFix' | translate }}\" name=\"invoicePreFix\" maxlength=\"20\">\r\n      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'invoiceSettings.invoicePreFix' }}</span>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n\r\n  </div>\r\n</div>";

/***/ },
/* 1314 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var cost_expense_service_1 = __webpack_require__(1010);
	var CostAndExpenseDriverPopupComponent = (function () {
	    function CostAndExpenseDriverPopupComponent(costAndExpenseService, authService, router, translate) {
	        this.costAndExpenseService = costAndExpenseService;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.SelectedNames = [];
	        this.SelectedList = [];
	        this.LblIcon = "fa fa-plus-square";
	        this.isParentCheck = false;
	        this.onSuccessSelect = new core_1.EventEmitter();
	    }
	    CostAndExpenseDriverPopupComponent.prototype.ngOnInit = function () {
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.searchField = ["userName", "firstName", "lastName"];
	    };
	    CostAndExpenseDriverPopupComponent.prototype.ngOnChanges = function (change) {
	        console.log(change);
	    };
	    CostAndExpenseDriverPopupComponent.prototype.show = function (SelectedList, SelectedNamesList) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.sortType = "";
	        this.DataListModel.sortReverse = null;
	        this.DataListModel.searchTerm = "";
	        this.DataListModel.infoMessage = "";
	        this.SelectedList = SelectedList;
	        this.SelectedNames = SelectedNamesList;
	        this.personModal.show();
	    };
	    CostAndExpenseDriverPopupComponent.prototype.hide = function () {
	        this.personModal.hide();
	    };
	    CostAndExpenseDriverPopupComponent.prototype.select = function (person) {
	        this.isLoading = true;
	        this.onSuccessSelect.emit({ PersonHashID: person.personMasterHashId, PersonName: person.userName });
	        this.isLoading = false;
	        this.hide();
	    };
	    CostAndExpenseDriverPopupComponent.prototype.selectMultiple = function () {
	        this.isLoading = true;
	        this.onSuccessSelect.emit({ PersonHashID: this.SelectedList, PersonName: this.SelectedNames });
	        this.isLoading = false;
	        this.hide();
	    };
	    CostAndExpenseDriverPopupComponent.prototype.ItemCheckChanged = function (PersonMasterHashID, PersonName, isChecked) {
	        if (isChecked) {
	            if (this.SelectedList.indexOf(PersonMasterHashID) == -1) {
	                this.SelectedList.push(PersonMasterHashID);
	            }
	            if (this.SelectedNames.indexOf(PersonName) == -1) {
	                this.SelectedNames.push(PersonName);
	            }
	            this.isParentCheck = this.personList.filter(function (x) { return x.personMasterHashId != PersonMasterHashID; }).every(function (x) { return x.isChecked; });
	        }
	        else {
	            this.SelectedList = this.SelectedList.filter(function (x) { return x != PersonMasterHashID; });
	            this.SelectedNames = this.SelectedNames.filter(function (x) { return x != PersonName; });
	            this.isParentCheck = false;
	        }
	    };
	    CostAndExpenseDriverPopupComponent.prototype.OnParentCheck = function (isChecked) {
	        var _this = this;
	        this.personList.forEach(function (x) {
	            x.isChecked = isChecked;
	            if (isChecked) {
	                if (_this.SelectedList.indexOf(x.personMasterHashId) == -1) {
	                    _this.SelectedList.push(x.personMasterHashId);
	                }
	                if (_this.SelectedNames.indexOf(x.userName) == -1) {
	                    _this.SelectedNames.push(x.userName);
	                }
	            }
	            else {
	                _this.SelectedList = _this.SelectedList.filter(function (y) { return y != x.personMasterHashId; });
	                _this.SelectedNames = _this.SelectedNames.filter(function (y) { return y != x.userName; });
	            }
	        });
	    };
	    CostAndExpenseDriverPopupComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	    };
	    CostAndExpenseDriverPopupComponent.prototype.OnSearch = function (event) {
	        this.DataListModel.searchTerm = event.searchTerm;
	        this.DataListModel.currentPage = 1;
	    };
	    CostAndExpenseDriverPopupComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	    };
	    ;
	    CostAndExpenseDriverPopupComponent.prototype.OnPagingChange = function (event) {
	        console.log(this.DataListModel);
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	    };
	    CostAndExpenseDriverPopupComponent.prototype.OnSuccessSelect = function () {
	    };
	    __decorate([
	        core_1.Output('OnSuccessSelect'), 
	        __metadata('design:type', Object)
	    ], CostAndExpenseDriverPopupComponent.prototype, "onSuccessSelect", void 0);
	    __decorate([
	        core_1.ViewChild('personModal'), 
	        __metadata('design:type', Object)
	    ], CostAndExpenseDriverPopupComponent.prototype, "personModal", void 0);
	    CostAndExpenseDriverPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-costandexpense-driver-popup',
	            template: __webpack_require__(1315),
	            providers: [cost_expense_service_1.CostAndExpenseService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof cost_expense_service_1.CostAndExpenseService !== 'undefined' && cost_expense_service_1.CostAndExpenseService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object])
	    ], CostAndExpenseDriverPopupComponent);
	    return CostAndExpenseDriverPopupComponent;
	    var _a, _b, _c, _d;
	}());
	exports.CostAndExpenseDriverPopupComponent = CostAndExpenseDriverPopupComponent;


/***/ },
/* 1315 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #personModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\"\r\n  [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblSelect' | translate }} {{ 'LblPerson' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <wego-search-list [IsExported]=\"false\" [SearchTerm]=\"DataListModel.searchTerm\" (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\"\r\n          (OnPagingChange)=\"OnPagingChange($event)\" [ItemPerPage]=\"DataListModel.itemsPerPage\" [CustomeIcon]=\"LblIcon\" [IsCustomButton]='true'\r\n          (OnCustomeButton)=\"selectMultiple()\" [IsCustomButtonEnabled]=\"SelectedList && SelectedList.length>0\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center parent-checkbox\">\r\n                  <input type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\">\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('userName')\">\r\n                  {{ 'LblPerson' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'userName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('firstName')\">\r\n                  {{ 'LblFirstName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'firstName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('lastName')\">\r\n                  {{ 'LblLastName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'lastName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let person of personList\">\r\n                  <td class=\"text-center\">\r\n                    <input type=\"checkbox\" name=\"isActive\" (click)=\"ItemCheckChanged(person.personMasterHashId,person.userName,$event.target.checked)\"\r\n                      [(ngModel)]=\"person.isChecked\">\r\n                  </td>\r\n                  <td>{{ person.userName }}</td>\r\n                  <td>{{ person.firstName }}</td>\r\n                  <td>{{ person.lastName }}</td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0\">\r\n                <td class=\"text-center text-danger\" colspan=\"4\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 1316 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var config_1 = __webpack_require__(60);
	var router_1 = __webpack_require__(26);
	var config_2 = __webpack_require__(60);
	var booking_service_1 = __webpack_require__(556);
	var cost_expense_service_1 = __webpack_require__(1010);
	var cost_expense_model_1 = __webpack_require__(1006);
	var moment = __webpack_require__(84);
	var ConfirmCostAndExpenseDriverComponent = (function () {
	    function ConfirmCostAndExpenseDriverComponent(authService, router, translate, zone, costAndExpenseService, bookingService) {
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.zone = zone;
	        this.costAndExpenseService = costAndExpenseService;
	        this.bookingService = bookingService;
	    }
	    Object.defineProperty(ConfirmCostAndExpenseDriverComponent.prototype, "model", {
	        get: function () {
	            return this._model;
	        },
	        set: function (_costAndExpenseModel) {
	            this._model = _costAndExpenseModel;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ConfirmCostAndExpenseDriverComponent.prototype.ngOnInit = function () {
	        this.urlPersonInfo = this.authService.GetURL(config_2.ApplicationRouteURL.URL_PERSON_UPDATE);
	        this.urlBookingInfo = this.authService.GetURL(config_2.ApplicationRouteURL.URL_BOOKING_INFORMATION);
	    };
	    ConfirmCostAndExpenseDriverComponent.prototype.show = function () {
	        this.errorMsg = "";
	        this.errorModel = [];
	        this.viewPersonLink = new config_1.WeGoAuthorizedLink(this.urlPersonInfo + "/" + this.model.reportedByPersonHashId, config_1.Permission.PR_PERSON_OVERVIEW, config_1.PermissionType.EDIT, "", this.model.reportedByName, "", "", true);
	        this.viewBookingLink = new config_1.WeGoAuthorizedLink(this.urlBookingInfo + "/" + this.model.bookingHashId, config_1.Permission.PR_BOOKINGS_OVERVIEW, config_1.PermissionType.VIEW, "", this.model.bookingReferenceID, "", "", true);
	        this.approvalCostAndExpenseModel.show();
	    };
	    ConfirmCostAndExpenseDriverComponent.prototype.hide = function () {
	        this.model = new cost_expense_model_1.CostAndExpenseModel();
	        this.approvalCostAndExpenseModel.hide();
	    };
	    ConfirmCostAndExpenseDriverComponent.prototype.GetImagePath = function (path) {
	        return config_2.WeGoConfig.API_SERVER_URL + path;
	    };
	    ConfirmCostAndExpenseDriverComponent.prototype.ShowReceipt = function (imagepath) {
	        this.receiptImagePopup.imagepath = imagepath;
	        this.receiptImagePopup.show();
	    };
	    __decorate([
	        core_1.ViewChild("approvalCostAndExpenseModel"), 
	        __metadata('design:type', Object)
	    ], ConfirmCostAndExpenseDriverComponent.prototype, "approvalCostAndExpenseModel", void 0);
	    __decorate([
	        core_1.ViewChild("receiptImagePopup"), 
	        __metadata('design:type', Object)
	    ], ConfirmCostAndExpenseDriverComponent.prototype, "receiptImagePopup", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof cost_expense_model_1.CostAndExpenseModel !== 'undefined' && cost_expense_model_1.CostAndExpenseModel) === 'function' && _a) || Object), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof cost_expense_model_1.CostAndExpenseModel !== 'undefined' && cost_expense_model_1.CostAndExpenseModel) === 'function' && _b) || Object])
	    ], ConfirmCostAndExpenseDriverComponent.prototype, "model", null);
	    ConfirmCostAndExpenseDriverComponent = __decorate([
	        core_1.Component({
	            selector: "confirm-costandexpense-driver-popup",
	            template: __webpack_require__(1317),
	            providers: [cost_expense_service_1.CostAndExpenseService, booking_service_1.BookingService],
	            styles: [
	                "\n      .form-horizontal .control-label {\n        text-align: left;\n      }\n      .image-expense {\n            max-width: 100%;\n            max-height: 350px;\n      }\n      .overlay-magnifier {\n        display: flex;\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        height: 100%;\n        background: rgba(0,0,0,0.2);\n        align-items: center;\n        justify-content: center;\n      }\n    "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _e) || Object, (typeof (_f = typeof core_1.NgZone !== 'undefined' && core_1.NgZone) === 'function' && _f) || Object, (typeof (_g = typeof cost_expense_service_1.CostAndExpenseService !== 'undefined' && cost_expense_service_1.CostAndExpenseService) === 'function' && _g) || Object, (typeof (_h = typeof booking_service_1.BookingService !== 'undefined' && booking_service_1.BookingService) === 'function' && _h) || Object])
	    ], ConfirmCostAndExpenseDriverComponent);
	    return ConfirmCostAndExpenseDriverComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h;
	}());
	exports.ConfirmCostAndExpenseDriverComponent = ConfirmCostAndExpenseDriverComponent;


/***/ },
/* 1317 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #approvalCostAndExpenseModel=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-md\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\"> {{ 'LblCostDetail' | translate }}</h4>\r\n      </div>\r\n      <div *ngIf=\"model\" class=\"modal-body\">\r\n        <form class=\"form-horizontal\">\r\n          <fieldset [disabled]=\"!model.isEditable\">\r\n            <div class=\"col-sm-3 nopad\">\r\n              <img class=\"media-object image-expense\" [src]=\"GetImagePath(model.receiptPath)\" alt=\"No Receipt\">\r\n              <div class=\"overlay-magnifier cursor-pointer\" (click)=\"ShowReceipt(GetImagePath(model.receiptPath))\">\r\n                <i class=\"fa fa-search fa-lg\"></i>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-sm-9\">\r\n              <div class=\"form-group\">\r\n                <label class=\"col-sm-4\">{{ 'LblDate' | translate }}</label>\r\n                <div class=\"col-sm-8\">\r\n                  {{ model.reportedDateTime }}\r\n                </div>\r\n              </div>\r\n              <div class=\"form-group\">\r\n                <label class=\"col-sm-4\">{{ 'LblReportedBy' | translate }}</label>\r\n                <div class=\"col-sm-8\">\r\n                  <span>\r\n                    {{model.reportedByName}}\r\n                  </span>\r\n                </div>\r\n              </div>\r\n              <div class=\"form-group\">\r\n                <label class=\"col-sm-4\">{{ 'LblBookingId' | translate }}</label>\r\n                <div class=\"col-sm-8\">\r\n                  <span>\r\n                    {{model.bookingReferenceID}}\r\n                  </span>\r\n                </div>\r\n              </div>\r\n              <div class=\"form-group\">\r\n                <label class=\"col-sm-4\">{{ 'LblDescription' | translate }}</label>\r\n                <div class=\"col-sm-8\">\r\n                  <span>{{model.description}}</span>\r\n                </div>\r\n              </div>\r\n              <div class=\"form-group\">\r\n                <label class=\"col-sm-4\">\r\n                  {{ 'LblCostType' | translate }}\r\n                </label>\r\n                <div class=\"col-sm-8\">\r\n                  {{model.costType}}\r\n                </div>\r\n              </div>\r\n              <div class=\"form-group\">\r\n                <label class=\"col-sm-4\">\r\n\r\n                  {{ 'LblStatus' | translate }}\r\n                </label>\r\n                <div class=\"col-sm-8\">\r\n                  {{model.status}}\r\n                </div>\r\n              </div>\r\n              <div class=\"form-group\">\r\n                <label class=\"col-sm-4\">\r\n\r\n                  {{ 'LblInvoiceNumber' | translate }}\r\n                </label>\r\n                <div class=\"col-sm-8\">\r\n                  {{model.invoiceNumber}}\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"form-group row\">\r\n              <fieldset class=\"col-md-6\">\r\n                <legend class=\"legendStyle\">\r\n                  {{ 'LblReportedAmount' | translate }}\r\n                </legend>\r\n                <div class=\"form-horizontal\">\r\n                  <div class=\"form-group\">\r\n                    <label class=\"col-sm-6\">{{ 'LblExcludingVat' | translate }}</label>\r\n                    <div class=\"col-sm-6\">\r\n                      <!-- <input disabled type=\"text\" class=\"form-control\" value=\"{{ model.reportedAmountExVat | roundingFormatter |  decimalFormatter}}\" name=\"reportedAmountExVat\"> -->\r\n                      {{ model.reportedAmountExVat }}\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"form-group\">\r\n                    <label class=\"col-sm-6\">{{ 'LblVat' | translate }}</label>\r\n                    <div class=\"col-sm-6\">\r\n                      <!-- <input disabled type=\"text\" class=\"form-control\" value=\"{{ model.reportedVatPercentage | roundingFormatter |  decimalFormatter}}\" name=\"reportedVatPercentage\"> -->\r\n                      {{ model.reportedVatPercentage}}\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"form-group\">\r\n                    <label class=\"col-sm-6\">{{ 'LblIncludingVat' | translate }}</label>\r\n                    <div class=\"col-sm-6\">\r\n                      <!-- <input disabled type=\"text\" class=\"form-control\" value=\"{{ model.reportedAmountInVat | roundingFormatter |  decimalFormatter }}\" name=\"reportedAmountInVat\"> -->\r\n                      {{ model.reportedAmountInVat }}\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </fieldset>\r\n              <fieldset class=\"col-md-6\">\r\n                <legend class=\"legendStyle\">\r\n                  {{ 'LblApprovedAmount' | translate }}\r\n                </legend>\r\n                <div class=\"form-horizontal\">\r\n                  <div class=\"form-group\">\r\n                    <label class=\"col-sm-6\">{{ 'LblExcludingVat' | translate }}</label>\r\n                    <div class=\"col-sm-6\">\r\n                      <!-- <input disabled type=\"text\" class=\"form-control\" [(ngModel)]=\"model.approvedAmountExVat\" name=\"approvedAmountExVat\">\r\n                      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'ApprovedAmountExVat' }}</span> -->\r\n                      {{ model.approvedAmountExVat }}\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"form-group\">\r\n                    <label class=\"col-sm-6\">{{ 'LblVat' | translate }}</label>\r\n                    <div class=\"col-sm-6\">\r\n                      <!-- <input disabled type=\"text\" class=\"form-control\" value=\"{{ model.approvedVatPercentage | roundingFormatter |  decimalFormatter }}\" name=\"approvedVatPercentage\"> -->\r\n                      {{ model.approvedVatPercentage }}\r\n                    </div>\r\n                  </div>\r\n                  <div class=\"form-group\">\r\n                    <label class=\"col-sm-6\">{{ 'LblIncludingVat' | translate }}</label>\r\n                    <div class=\"col-sm-6\">\r\n                      <!-- <input disabled type=\"text\" class=\"form-control\" [(ngModel)]=\"model.approvedAmountInVat\" name=\"approvedAmountInVat\"> -->\r\n                      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'ApprovedAmountInVat' }}</span>\r\n                      {{ model.approvedAmountInVat }}\r\n                    </div>\r\n                  </div>\r\n                </div>\r\n              </fieldset>\r\n            </div>\r\n          </fieldset>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n<wego-image-popup #receiptImagePopup></wego-image-popup>";

/***/ },
/* 1318 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var modal_1 = __webpack_require__(537);
	var core_1 = __webpack_require__(3);
	var translate_1 = __webpack_require__(631);
	var cost_expense_model_1 = __webpack_require__(1006);
	var config_1 = __webpack_require__(60);
	var flatpickr_model_1 = __webpack_require__(83);
	var cost_expense_service_1 = __webpack_require__(1010);
	var auth_service_1 = __webpack_require__(58);
	var invoice_service_1 = __webpack_require__(723);
	var booking_service_1 = __webpack_require__(556);
	var ManualInvoiceLineUpdatePopupComponent = (function () {
	    function ManualInvoiceLineUpdatePopupComponent(translate, costAndExpenseService, authService, invoiceService, bookingService) {
	        this.translate = translate;
	        this.costAndExpenseService = costAndExpenseService;
	        this.authService = authService;
	        this.invoiceService = invoiceService;
	        this.bookingService = bookingService;
	        this._model = new cost_expense_model_1.CostAndExpenseModel();
	        this.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
	        this.BookingList = [];
	        this.costAndExpenseList = [];
	        this.DataListModel = new config_1.DataListModel();
	        this.isNew = true;
	        this.OnSuccessSelect = new core_1.EventEmitter();
	        this.OnHidden = new core_1.EventEmitter();
	        this.costAndExpensesList = [];
	    }
	    Object.defineProperty(ManualInvoiceLineUpdatePopupComponent.prototype, "model", {
	        get: function () { return this._model; },
	        set: function (model) {
	            this._model = model;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ManualInvoiceLineUpdatePopupComponent.prototype, "SelectedExpenseHashIdList", {
	        get: function () { return this._selectedExpenseHashIdList; },
	        set: function (selectedExpenseHashIdList) {
	            this._selectedExpenseHashIdList = selectedExpenseHashIdList;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ManualInvoiceLineUpdatePopupComponent.prototype.ngOnInit = function () {
	        this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
	    };
	    ManualInvoiceLineUpdatePopupComponent.prototype.SetDefaultFlatPickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = true;
	        flatPickrConfig.time_24hr = true;
	        flatPickrConfig.dateFormat = this.dateFormat;
	        flatPickrConfig.minuteIncrement = 1;
	        return flatPickrConfig;
	    };
	    ManualInvoiceLineUpdatePopupComponent.prototype.GetCostTypeList = function () {
	        //this.tempVatPer = this.model.reportedVatPercentage;
	        var _this = this;
	        this.costAndExpenseService
	            .GetDropdownCostTypeList("", this.model.recipientDriverHashId, this.model.recipientOrganizationHashId)
	            .subscribe(function (res) {
	            _this.costTypeList = res.data;
	            //   this.model.reportedVatPercentage = this.tempVatPer;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    ManualInvoiceLineUpdatePopupComponent.prototype.GetBookingList = function () {
	        var _this = this;
	        this.invoiceService.GetDropdownBookingList(this.model.sharedVehicleGroupDriverHashId, this.model.recipientOrganizationHashId)
	            .subscribe(function (res) {
	            _this.BookingList = res.data;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    ManualInvoiceLineUpdatePopupComponent.prototype.show = function (isEdit) {
	        this.apiErrorMsg = "";
	        this.errorModel = [];
	        this.manualInvoiceLineModal.show();
	        this.model = JSON.parse(JSON.stringify(this.model));
	        //let tempModel = JSON.parse(JSON.stringify(this.model));
	        this.GetBookingList();
	        this.GetCostTypeList();
	        this.GetVatSettingDropdownList();
	        //this.model = JSON.parse(JSON.stringify(tempModel));;
	        this.isEdit = isEdit;
	    };
	    ManualInvoiceLineUpdatePopupComponent.prototype.hide = function () {
	        this.model = new cost_expense_model_1.CostAndExpenseModel();
	        this.BookingList = [];
	        this.costTypeList = [];
	        this.manualInvoiceLineModal.hide();
	    };
	    ManualInvoiceLineUpdatePopupComponent.prototype.Confirm = function ($event) {
	        this.hide();
	    };
	    ManualInvoiceLineUpdatePopupComponent.prototype.OnBookingChange = function () {
	        this.GetVatSettingDropdownList();
	    };
	    ManualInvoiceLineUpdatePopupComponent.prototype.GetVatSettingDropdownList = function () {
	        var _this = this;
	        if (this.model.bookingHashId) {
	            this.bookingService.GetVatSettingDropdownList(this.model.bookingHashId)
	                .subscribe(function (res) {
	                if (res.data) {
	                    _this.vatSettingList = res.data;
	                }
	                else {
	                    _this.apiErrorMsg = res.error;
	                }
	            }, function (error) {
	                _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            });
	        }
	    };
	    ManualInvoiceLineUpdatePopupComponent.prototype.GetVatSettingDefaultValues = function () {
	        var _this = this;
	        this.bookingService
	            .GetVatSettingDefaultValues(this.model.bookingHashId)
	            .subscribe(function (res) {
	            if (res.data) {
	                var vatSettingDefaultValues = res.data;
	                _this.vatSettingDefaultCost =
	                    vatSettingDefaultValues.vatSettingDefaultCost;
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    ManualInvoiceLineUpdatePopupComponent.prototype.onHidden = function ($event) {
	        this.OnHidden.emit();
	    };
	    ManualInvoiceLineUpdatePopupComponent.prototype.onSubmit = function () {
	        var _this = this;
	        var frmData = new FormData();
	        this.model.reportedByDriver = false;
	        var selectedBooking = this.BookingList.find(function (x) { return x.keyHash == _this.model.bookingHashId; });
	        if (selectedBooking) {
	            this.model.bookingReferenceID = selectedBooking.value;
	        }
	        if (this.model) {
	            frmData.append("manualInvoiceLine", JSON.stringify(this.model));
	            this.UploadManualLine(frmData);
	        }
	    };
	    ManualInvoiceLineUpdatePopupComponent.prototype.ClearFileInput = function () {
	        if (this.receiptFile && this.receiptFile.nativeElement) {
	            this.receiptFile.nativeElement.value = "";
	        }
	    };
	    ManualInvoiceLineUpdatePopupComponent.prototype.UploadManualLine = function (formData) {
	        var _this = this;
	        this.invoiceService.UpdateCostAndExpenses(formData, this._model.module).subscribe(function (res) {
	            console.log(res);
	            if (res.data) {
	                _this.errorModel = [];
	                _this.ClearFileInput();
	                _this.model.approvedVatPercentage = _this.model.reportedVatPercentage;
	                _this.model.reportedVatAmount = (_this.model.reportedAmountExVat * _this.model.reportedVatPercentage / 100).valueOf();
	                _this.model.approvedAmountVat = _this.model.reportedVatAmount;
	                _this.model.reportedAmountInVat = Number.parseFloat(_this.model.reportedAmountExVat.toString()) + Number.parseFloat(_this._model.reportedVatAmount.toString());
	                _this.model.approvedAmountInVat = _this.model.reportedAmountInVat;
	                _this.model.approvedAmountExVat = _this.model.reportedAmountExVat;
	                _this.model.costAndExpenseHashId = res.data;
	                _this.OnSuccessSelect.emit({ CostAndExpenseModel: _this.model });
	                _this.hide();
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	        }, function (error) {
	            console.log(error);
	            _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    ManualInvoiceLineUpdatePopupComponent.prototype.SetVatDefaultCost = function (vatSettingDefaultCost) {
	        return vatSettingDefaultCost
	            ? this.translate.instant('LblExcludingVat')
	            : this.translate.instant('LblIncludingVat');
	    };
	    ManualInvoiceLineUpdatePopupComponent.prototype.ngOnDestroy = function () {
	    };
	    __decorate([
	        core_1.ViewChild("receiptFile"), 
	        __metadata('design:type', Object)
	    ], ManualInvoiceLineUpdatePopupComponent.prototype, "receiptFile", void 0);
	    __decorate([
	        core_1.ViewChild('manualInvoiceLineModal'), 
	        __metadata('design:type', (typeof (_a = typeof modal_1.ModalDirective !== 'undefined' && modal_1.ModalDirective) === 'function' && _a) || Object)
	    ], ManualInvoiceLineUpdatePopupComponent.prototype, "manualInvoiceLineModal", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_b = typeof cost_expense_model_1.CostAndExpenseModel !== 'undefined' && cost_expense_model_1.CostAndExpenseModel) === 'function' && _b) || Object), 
	        __metadata('design:paramtypes', [(typeof (_c = typeof cost_expense_model_1.CostAndExpenseModel !== 'undefined' && cost_expense_model_1.CostAndExpenseModel) === 'function' && _c) || Object])
	    ], ManualInvoiceLineUpdatePopupComponent.prototype, "model", null);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Array), 
	        __metadata('design:paramtypes', [Array])
	    ], ManualInvoiceLineUpdatePopupComponent.prototype, "SelectedExpenseHashIdList", null);
	    __decorate([
	        core_1.Output("OnSuccessSelect"), 
	        __metadata('design:type', Object)
	    ], ManualInvoiceLineUpdatePopupComponent.prototype, "OnSuccessSelect", void 0);
	    __decorate([
	        core_1.Output("OnHidden"), 
	        __metadata('design:type', Object)
	    ], ManualInvoiceLineUpdatePopupComponent.prototype, "OnHidden", void 0);
	    ManualInvoiceLineUpdatePopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-manual-invoice-line-update-popup',
	            template: __webpack_require__(1319),
	            providers: [cost_expense_service_1.CostAndExpenseService, invoice_service_1.InvoiceService, booking_service_1.BookingService],
	            styles: ["\n    .form-horizontal .control-label{\n      text-align: left;\n    }\n  "]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_d = typeof translate_1.TranslateService !== 'undefined' && translate_1.TranslateService) === 'function' && _d) || Object, (typeof (_e = typeof cost_expense_service_1.CostAndExpenseService !== 'undefined' && cost_expense_service_1.CostAndExpenseService) === 'function' && _e) || Object, (typeof (_f = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _f) || Object, (typeof (_g = typeof invoice_service_1.InvoiceService !== 'undefined' && invoice_service_1.InvoiceService) === 'function' && _g) || Object, (typeof (_h = typeof booking_service_1.BookingService !== 'undefined' && booking_service_1.BookingService) === 'function' && _h) || Object])
	    ], ManualInvoiceLineUpdatePopupComponent);
	    return ManualInvoiceLineUpdatePopupComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h;
	}());
	exports.ManualInvoiceLineUpdatePopupComponent = ManualInvoiceLineUpdatePopupComponent;


/***/ },
/* 1319 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #manualInvoiceLineModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\" (onHidden)=\"onHidden($event)\">\r\n  <div class=\"modal-dialog modal-md\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblManualInvoiceLine' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <fieldset [disabled]=\"!isEdit\">\r\n          <form class=\"form-horizontal\">\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-3\" for=\"type\">{{ 'LblBookingId' | translate }}</label>\r\n              <div class=\"col-sm-9\">\r\n                <select [(ngModel)]=\"model.bookingHashId\" class=\"form-control\" (change)=\"OnBookingChange()\" name=\"bookingId\">\r\n                  <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblBookingId' | translate }}</option>\r\n                  <option *ngFor=\"let item of BookingList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\r\n                </select>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'BookingHashId' }}</span>\r\n              </div>\r\n            </div>\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-3\" for=\"date\">{{ 'LblDate' | translate }}</label>\r\n              <div class=\"col-sm-9\">\r\n                <input [disabled]=\"!model.bookingHashId\" class=\"form-control\" flatpickr readonly [Config]=\"flatPickrConfigFrom\" [(ngModel)]=\"model.reportedDateTime\"\r\n                  name=\"date\" id=\"date\" placeholder=\"{{ 'LblDate' | translate }}\">\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'ReportedDateTime' }}</span>\r\n              </div>\r\n            </div>\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-3\" for=\"description\">{{ 'LblDescription' | translate }}</label>\r\n              <div class=\"col-sm-9\">\r\n                <input maxlength=\"100\" [disabled]=\"!model.bookingHashId\" [(ngModel)]=\"model.description\" class=\"form-control\" name=\"description\"\r\n                  id=\"description\" placeholder=\"{{ 'LblDescription' | translate }}\">\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'Description' }}</span>\r\n              </div>\r\n            </div>\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-3\" for=\"type\">{{ 'LblType' | translate }}</label>\r\n              <div class=\"col-sm-9\">\r\n                <select [disabled]=\"!model.bookingHashId\" [(ngModel)]=\"model.costTypeHashId\" class=\"form-control\" name=\"costTypeHashId\">\r\n                  <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblCostType' | translate }}</option>\r\n                  <option *ngFor=\"let item of costTypeList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\r\n                </select>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'CostTypeHashId' }}</span>\r\n              </div>\r\n            </div>\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-3\" for=\"reportedAmountExVat\">{{ 'LblAmount' | translate }} {{ 'LblExVat' | translate }}</label>\r\n              <div class=\"col-sm-9\">\r\n                <input maxlength=\"7\" [disabled]=\"!model.bookingHashId\" class=\"form-control\" [(ngModel)]=\"model.reportedAmountExVat\" name=\"reportedAmountExVat\"\r\n                  id=\"reportedAmountExVat\" placeholder=\"{{ 'LblAmount' | translate }} {{ 'LblExVat' | translate }}\">\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'ReportedAmountExVat' }}</span>\r\n              </div>\r\n            </div>\r\n            <div class=\"form-group\">\r\n              <label class=\"control-label col-sm-3\" for=\"type\">{{ 'LblVATPercentage' | translate }}</label>\r\n              <div class=\"col-sm-9\">\r\n                <select [disabled]=\"!model.bookingHashId\" [(ngModel)]=\"model.reportedVatPercentage\" name=\"reportedVatPercentage\" class=\"form-control\">\r\n                  <option *ngFor=\"let item of vatSettingList\" [value]='item.value'>{{item.data}}</option>\r\n                </select>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'ReportedVatPercentage' }}</span>\r\n              </div>\r\n            </div>\r\n            <div class=\"form-group col-sm-12\">\r\n              <div class=\"radio-inline\">\r\n                <label>\r\n                  <input [disabled]=\"!model.bookingHashId || model.invoiceNumber == null\" type=\"radio\" [(ngModel)]=\"model.isCharge\" name=\"isCharge\"\r\n                    [value]=\"true\">{{ 'LblChargeTo' | translate }}\r\n                </label>\r\n              </div>\r\n              <div class=\"radio-inline\">\r\n                <label>\r\n                  <input [disabled]=\"!model.bookingHashId || model.invoiceNumber\" type=\"radio\" [(ngModel)]=\"model.isCharge\" name=\"isCharge\"\r\n                    [value]=\"false\">{{ 'LblReimburseTo' | translate }}\r\n                </label>\r\n              </div>\r\n            </div>\r\n          </form>\r\n        </fieldset>\r\n      </div>\r\n      <div *ngIf=\"isEdit\" class=\"modal-footer\">\r\n        <a class=\"btn btn-gray cursor-pointer\" (click)=\"hide()\">{{ 'LblCancel' | translate }}</a> &nbsp;&nbsp;\r\n        <a class=\"btn btn-green cursor-pointer\" (click)=\"onSubmit()\">{{ 'LblSave' | translate }}</a>\r\n      </div>\r\n      <div *ngIf=\"!isEdit\" class=\"modal-footer\">\r\n        <button type=\"button\" (click)=\"hide()\" class=\"btn btn-green\">{{ 'LblOK' | translate }}</button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 1320 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var config_1 = __webpack_require__(60);
	var router_1 = __webpack_require__(26);
	var config_2 = __webpack_require__(60);
	var booking_service_1 = __webpack_require__(556);
	var cost_expense_service_1 = __webpack_require__(1010);
	var cost_expense_model_1 = __webpack_require__(1006);
	var moment = __webpack_require__(84);
	var CostAddedByAdminPopupComponent = (function () {
	    function CostAddedByAdminPopupComponent(authService, router, translate, zone, costAndExpenseService, bookingService) {
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.zone = zone;
	        this.costAndExpenseService = costAndExpenseService;
	        this.bookingService = bookingService;
	    }
	    Object.defineProperty(CostAddedByAdminPopupComponent.prototype, "model", {
	        get: function () {
	            return this._model;
	        },
	        set: function (_costAndExpenseModel) {
	            this._model = _costAndExpenseModel;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    CostAddedByAdminPopupComponent.prototype.ngOnInit = function () {
	        this.urlPersonInfo = this.authService.GetURL(config_2.ApplicationRouteURL.URL_PERSON_UPDATE);
	        this.urlBookingInfo = this.authService.GetURL(config_2.ApplicationRouteURL.URL_BOOKING_INFORMATION);
	    };
	    CostAddedByAdminPopupComponent.prototype.show = function () {
	        this.errorMsg = "";
	        this.errorModel = [];
	        this.viewPersonLink = new config_1.WeGoAuthorizedLink(this.urlPersonInfo + "/" + this.model.reportedByPersonHashId, config_1.Permission.PR_PERSON_OVERVIEW, config_1.PermissionType.EDIT, "", this.model.reportedByName, "", "", true);
	        this.viewBookingLink = new config_1.WeGoAuthorizedLink(this.urlBookingInfo + "/" + this.model.bookingHashId, config_1.Permission.PR_BOOKINGS_OVERVIEW, config_1.PermissionType.VIEW, "", this.model.bookingReferenceID, "", "", true);
	        this.costAddedByAdminPopup.show();
	    };
	    CostAddedByAdminPopupComponent.prototype.hide = function () {
	        this.model = new cost_expense_model_1.CostAndExpenseModel();
	        this.costAddedByAdminPopup.hide();
	    };
	    CostAddedByAdminPopupComponent.prototype.GetImagePath = function (path) {
	        return config_2.WeGoConfig.API_SERVER_URL + path;
	    };
	    __decorate([
	        core_1.ViewChild("costAddedByAdminPopup"), 
	        __metadata('design:type', Object)
	    ], CostAddedByAdminPopupComponent.prototype, "costAddedByAdminPopup", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', (typeof (_a = typeof cost_expense_model_1.CostAndExpenseModel !== 'undefined' && cost_expense_model_1.CostAndExpenseModel) === 'function' && _a) || Object), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof cost_expense_model_1.CostAndExpenseModel !== 'undefined' && cost_expense_model_1.CostAndExpenseModel) === 'function' && _b) || Object])
	    ], CostAddedByAdminPopupComponent.prototype, "model", null);
	    CostAddedByAdminPopupComponent = __decorate([
	        core_1.Component({
	            selector: "cost-added-by-admin-popup",
	            template: __webpack_require__(1321),
	            providers: [cost_expense_service_1.CostAndExpenseService, booking_service_1.BookingService],
	            styles: [
	                "\n      .form-horizontal .control-label {\n        text-align: left;\n      }\n      .image-expense {\n            max-width: 100%;\n            max-height: 350px;\n      }\n      .radioMarginInCostModal {\n        margin-left:0%;\n      }\n    "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object, (typeof (_e = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _e) || Object, (typeof (_f = typeof core_1.NgZone !== 'undefined' && core_1.NgZone) === 'function' && _f) || Object, (typeof (_g = typeof cost_expense_service_1.CostAndExpenseService !== 'undefined' && cost_expense_service_1.CostAndExpenseService) === 'function' && _g) || Object, (typeof (_h = typeof booking_service_1.BookingService !== 'undefined' && booking_service_1.BookingService) === 'function' && _h) || Object])
	    ], CostAddedByAdminPopupComponent);
	    return CostAddedByAdminPopupComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h;
	}());
	exports.CostAddedByAdminPopupComponent = CostAddedByAdminPopupComponent;


/***/ },
/* 1321 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #costAddedByAdminPopup=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-md\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\"> {{ 'LblCostDetail' | translate }}</h4>\r\n      </div>\r\n      <div *ngIf=\"model\" class=\"modal-body\">\r\n        <form class=\"form-horizontal\">\r\n          <fieldset [disabled]=\"true\">\r\n            <div class=\"col-sm-3\">\r\n              <img class=\"media-object image-expense\" [src]=\"GetImagePath(model.receiptPath)\" alt=\"No Receipt\">\r\n            </div>\r\n            <div class=\"col-sm-9\">\r\n              <div class=\"form-group\">\r\n                <label class=\"col-sm-4\">{{ 'LblDate' | translate }}</label>\r\n                <div class=\"col-sm-8\">\r\n                  {{ model.reportedDateTime }}\r\n                </div>\r\n              </div>\r\n              <div class=\"form-group\">\r\n                <label class=\"col-sm-4\">{{ 'LblDescription' | translate }}</label>\r\n                <div class=\"col-sm-8\">\r\n                  <span>{{model.description}}</span>\r\n                </div>\r\n              </div>\r\n              <div class=\"form-group\">\r\n                <label class=\"col-sm-4\">\r\n                  {{ 'LblCostType' | translate }}\r\n                </label>\r\n                <div class=\"col-sm-8\">\r\n                  {{model.costType}}\r\n                </div>\r\n              </div>\r\n              <div class=\"form-group\">\r\n                <label class=\"col-sm-4\">\r\n                  {{ 'LblExcludingVat' | translate }}\r\n                </label>\r\n                <div class=\"col-sm-8\">\r\n                  {{ model.reportedAmountExVat}}\r\n                </div>\r\n              </div>\r\n              <div class=\"form-group\">\r\n                <label class=\"col-sm-4\">\r\n                  {{ 'LblIncludingVat' | translate }}\r\n                </label>\r\n                <div class=\"col-sm-8\">\r\n                  {{ model.reportedAmountInVat}}\r\n                </div>\r\n              </div>\r\n              <div class=\"form-group\">\r\n                <label class=\"col-sm-4\">\r\n                  {{ 'LblVat' | translate }}\r\n                </label>\r\n                <div class=\"col-sm-8\">\r\n                  {{ model.reportedVatPercentage}}\r\n                </div>\r\n              </div>\r\n              <div class=\"form-group\">\r\n                <label class=\"col-sm-4\">{{ 'LblBookingId' | translate }}</label>\r\n                <div class=\"col-sm-8\">\r\n                  <span>\r\n                    {{model.bookingReferenceID}}\r\n                  </span>\r\n                </div>\r\n              </div>\r\n              <div class=\"form-group\">\r\n                <label class=\"col-sm-4\">\r\n                  {{ 'LblInvoiceNumber' | translate }}\r\n                </label>\r\n                <div class=\"col-sm-8\">\r\n                  {{model.invoiceNumber}}\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"col-sm-offset-3 col-sm-9\">\r\n              <div class=\"form-group radioMarginInCostModal\">\r\n                <label class=\"radio-inline\">\r\n                  <input type=\"radio\" [(ngModel)]=\"model.isCharge\" name=\"isCharge\" [value]=\"true\">{{ 'LblChargeTo' | translate }} {{ 'LblDriver' | translate }}\r\n                </label>\r\n                <label class=\"radio-inline\">\r\n                  <input type=\"radio\" [(ngModel)]=\"model.isCharge\" name=\"isCharge\" [value]=\"false\">{{ 'LblReimburseTo' | translate }} {{ 'LblDriver' | translate }}\r\n                </label>\r\n              </div>\r\n            </div>\r\n          </fieldset>\r\n        </form>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 1322 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var rounding_formatter_service_1 = __webpack_require__(1007);
	var RoundingFormatterPipe = (function () {
	    function RoundingFormatterPipe(roundingFormatterService) {
	        this.roundingFormatterService = roundingFormatterService;
	    }
	    RoundingFormatterPipe.prototype.transform = function (value, fractionSize) {
	        if (fractionSize === void 0) { fractionSize = 2; }
	        return this.roundingFormatterService.transform(value, fractionSize);
	    };
	    RoundingFormatterPipe = __decorate([
	        core_1.Pipe({
	            name: "roundingFormatter"
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof rounding_formatter_service_1.RoundingFormatterService !== 'undefined' && rounding_formatter_service_1.RoundingFormatterService) === 'function' && _a) || Object])
	    ], RoundingFormatterPipe);
	    return RoundingFormatterPipe;
	    var _a;
	}());
	exports.RoundingFormatterPipe = RoundingFormatterPipe;


/***/ },
/* 1323 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var platform_browser_1 = __webpack_require__(21);
	var SafeHtmlPipe = (function () {
	    function SafeHtmlPipe(sanitized) {
	        this.sanitized = sanitized;
	    }
	    SafeHtmlPipe.prototype.transform = function (value) {
	        return this.sanitized.bypassSecurityTrustHtml(value);
	    };
	    SafeHtmlPipe = __decorate([
	        core_1.Pipe({ name: 'safeHtml' }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof platform_browser_1.DomSanitizer !== 'undefined' && platform_browser_1.DomSanitizer) === 'function' && _a) || Object])
	    ], SafeHtmlPipe);
	    return SafeHtmlPipe;
	    var _a;
	}());
	exports.SafeHtmlPipe = SafeHtmlPipe;


/***/ },
/* 1324 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var vehicle_service_1 = __webpack_require__(530);
	var vehicle_model_1 = __webpack_require__(553);
	var sharedvehiclegroup_service_1 = __webpack_require__(510);
	var company_service_1 = __webpack_require__(501);
	var instance_service_1 = __webpack_require__(500);
	var flatpickr_model_1 = __webpack_require__(83);
	var config_1 = __webpack_require__(60);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var report_filter_service_1 = __webpack_require__(929);
	var customer_service_1 = __webpack_require__(664);
	var organization_service_1 = __webpack_require__(614);
	var contracttypegroup_service_1 = __webpack_require__(730);
	var report_filter_cost_center_model_1 = __webpack_require__(1025);
	var organization_driver_model_1 = __webpack_require__(1287);
	var ReportFilterCostCenterComponent = (function () {
	    function ReportFilterCostCenterComponent(customerService, authService, instanceService, companyService, vehicleService, reportFilterService, organizationService, contractTypegroupService) {
	        this.customerService = customerService;
	        this.authService = authService;
	        this.instanceService = instanceService;
	        this.companyService = companyService;
	        this.vehicleService = vehicleService;
	        this.reportFilterService = reportFilterService;
	        this.organizationService = organizationService;
	        this.contractTypegroupService = contractTypegroupService;
	        this.onSearch = new core_1.EventEmitter();
	        this.onExportPDF = new core_1.EventEmitter();
	        this.onExportExcel = new core_1.EventEmitter();
	        this.resetValidSearch = new core_1.EventEmitter();
	        this.isValidSearch = false;
	        this.roleLevel = config_1.RoleLevel;
	    }
	    Object.defineProperty(ReportFilterCostCenterComponent.prototype, "vehicleMappingModel", {
	        get: function () {
	            var vehicleMapping = new vehicle_model_1.VehicleMappingModel();
	            vehicleMapping.companyHashId = this.model.companyHashId;
	            vehicleMapping.organizationHashId = this.model.organizationHashId;
	            vehicleMapping.customerHashId = this.model.customerHashId;
	            vehicleMapping.instanceHashId = this.model.instanceHashId;
	            return vehicleMapping;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ReportFilterCostCenterComponent.prototype, "organizationDriverModel", {
	        get: function () {
	            var organizationDriverMapping = new organization_driver_model_1.OrganizationDriverMappingModel();
	            organizationDriverMapping.companyHashId = this.model.companyHashId;
	            organizationDriverMapping.organizationHashId = this.model.organizationHashId;
	            organizationDriverMapping.customerHashId = this.model.customerHashId;
	            organizationDriverMapping.instanceHashId = this.model.instanceHashId;
	            return organizationDriverMapping;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ReportFilterCostCenterComponent.prototype, "isInstanceSelected", {
	        get: function () {
	            return !!this.model.customerHashId && !!this.model.instanceHashId;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ReportFilterCostCenterComponent.prototype.ngOnInit = function () {
	        this.model = new report_filter_cost_center_model_1.CostCenterReportFilter();
	        this.permissionType = config_1.PermissionType.VIEW;
	        this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigTo.defaultDate = "23:59";
	        this.searchCostTypeName = this.model.searchCostTypeNameList.join();
	        this.InitReportFilter();
	    };
	    ReportFilterCostCenterComponent.prototype.SetDefaultFlatPickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = true;
	        flatPickrConfig.time_24hr = true;
	        flatPickrConfig.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
	        flatPickrConfig.minuteIncrement = 1;
	        return flatPickrConfig;
	    };
	    ReportFilterCostCenterComponent.prototype.InitReportFilter = function () {
	        // this.GetAllInstanceList();
	        this.GetCustomerListDropdown();
	    };
	    ReportFilterCostCenterComponent.prototype.GetCustomerListDropdown = function () {
	        var _this = this;
	        this.customerService.GetDropdownListCustomer(this.reportName).subscribe(function (res) {
	            _this.customerList = res.data;
	            if (_this.customerList != null && _this.customerList.length > 0) {
	                if (!_this.model.customerHashId && _this.customerList.length == 1) {
	                    _this.model.customerHashId = _this.customerList[0].keyHash;
	                }
	                _this.OnCustomerChange();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    ReportFilterCostCenterComponent.prototype.GetInstanceListDropdown = function () {
	        var _this = this;
	        this.instanceService
	            .GetDropdownInstanceList(this.reportName, this.model.customerHashId)
	            .subscribe(function (res) {
	            _this.instanceList = res.data;
	            if (_this.instanceList && _this.instanceList.length > 0) {
	                if (!_this.model.instanceHashId && _this.instanceList.length == 1) {
	                    _this.model.instanceHashId = _this.instanceList[0].keyHash;
	                }
	                _this.OnInstanceChange();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    ReportFilterCostCenterComponent.prototype.GetCompanyListByInstance = function () {
	        var _this = this;
	        this.companyService
	            .GetDropdownCompanyList(this.reportName, this.model.instanceHashId)
	            .subscribe(function (res) {
	            _this.companyList = res.data;
	            if (_this.companyList && _this.companyList.length > 0) {
	                if (!_this.model.companyHashId && _this.companyList.length == 1) {
	                    _this.model.companyHashId = _this.companyList[0].keyHash;
	                }
	                _this.OnCompanyChange();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    ReportFilterCostCenterComponent.prototype.GetCompanyBaseOrganizationDropDown = function () {
	        var _this = this;
	        this.organizationService
	            .GetSVGBaseOrganizationDropDown(this.reportName, this.model.instanceHashId, this.model.companyHashId, "")
	            .subscribe(function (res) {
	            _this.organizationList = res.data;
	            if (_this.organizationList && _this.organizationList.length > 0) {
	                if (!_this.model.organizationHashId &&
	                    _this.organizationList.length == 1) {
	                    _this.model.organizationHashId = _this.organizationList[0].keyHash;
	                }
	                _this.OnOrganizationChange();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    // Event
	    ReportFilterCostCenterComponent.prototype.OnCustomerChange = function () {
	        this.model.instanceHashId = "";
	        this.instanceList = [];
	        this.model.companyHashId = "";
	        this.companyList = [];
	        this.model.organizationHashId = "";
	        this.organizationList = [];
	        this.contractTypeGroupList = [];
	        //this.model.vehicleHashId = "";
	        this.vehicleList = [];
	        this.contractTypeGroupList = [];
	        this.ResetValidSearch();
	        if (this.model.customerHashId) {
	            this.GetInstanceListDropdown();
	        }
	    };
	    ReportFilterCostCenterComponent.prototype.OnInstanceChange = function () {
	        this.companyList = null;
	        this.sharedVehicleGroupList = null;
	        this.vehicleList = null;
	        this.organizationList = null;
	        this.model.companyHashId = "";
	        //this.model.vehicleHashId = "";
	        this.model.organizationHashId = "";
	        this.isLoader = true;
	        this.contractTypeGroupList = null;
	        this.ResetValidSearch();
	        if (this.model.instanceHashId) {
	            this.GetCompanyListByInstance();
	        }
	        else {
	            this.companyList = [];
	            this.sharedVehicleGroupList = [];
	            this.vehicleList = [];
	            this.organizationList = [];
	            this.model.organizationHashId = "";
	            this.model.companyHashId = "";
	            //this.model.vehicleHashId = "";
	            this.contractTypeGroupList = [];
	        }
	    };
	    ReportFilterCostCenterComponent.prototype.OnCompanyChange = function () {
	        this.sharedVehicleGroupList = null;
	        this.vehicleList = null;
	        this.organizationList = null;
	        //this.model.vehicleHashId = "";
	        this.model.organizationHashId = "";
	        this.isLoader = true;
	        this.contractTypeGroupList = null;
	        this.ResetValidSearch();
	        this.GetCompanyBaseOrganizationDropDown();
	        this.sharedVehicleGroupList = [];
	        this.vehicleList = [];
	        this.organizationList = [];
	        this.contractTypeGroupList = [];
	        //this.model.vehicleHashId = "";
	    };
	    ReportFilterCostCenterComponent.prototype.OnOrganizationChange = function () {
	        this.ResetValidSearch();
	    };
	    ReportFilterCostCenterComponent.prototype.OnVehicleChange = function () {
	        this.ResetValidSearch();
	    };
	    ReportFilterCostCenterComponent.prototype.OnFromDateChange = function () {
	        this.ResetValidSearch();
	    };
	    ReportFilterCostCenterComponent.prototype.OnToDateChange = function () {
	        this.ResetValidSearch();
	    };
	    ReportFilterCostCenterComponent.prototype.ResetValidSearch = function () {
	        this.clearDriverList();
	        this.clearVehicleList();
	        this.isValidSearch = false;
	        this.resetValidSearch.emit({ isValidSearch: this.isValidSearch });
	    };
	    // Button Click
	    ReportFilterCostCenterComponent.prototype.OnSearch = function ($event) {
	        this.onSearch.emit({ model: this.model });
	    };
	    ReportFilterCostCenterComponent.prototype.OnExportPDF = function ($event) {
	        this.onExportPDF.emit({ model: this.model });
	    };
	    ReportFilterCostCenterComponent.prototype.OnExportExcel = function ($event) {
	        this.onExportExcel.emit({ model: this.model });
	    };
	    ReportFilterCostCenterComponent.prototype.OnSearchChange = function () {
	        this.ResetValidSearch();
	    };
	    ReportFilterCostCenterComponent.prototype.clearcostType = function () {
	        this.model.searchCostTypeNameList = [];
	        this.searchCostTypeName = "";
	        this.model.costTypeHashId = "";
	        this.model.costTypeHashIdList = [];
	        this.isValidSearch = false;
	        this.resetValidSearch.emit({ isValidSearch: this.isValidSearch });
	    };
	    ReportFilterCostCenterComponent.prototype.clearDriverList = function () {
	        this.model.searchDriverNameList = [];
	        this.searchDriverName = "";
	        this.model.driverHashIdList = [];
	        this.isValidSearch = false;
	        this.resetValidSearch.emit({ isValidSearch: this.isValidSearch });
	    };
	    ReportFilterCostCenterComponent.prototype.clearVehicleList = function () {
	        this.model.searchLicenceTagList = [];
	        this.searchLicenceTag = "";
	        this.model.vehicleHashIdList = [];
	        this.isValidSearch = false;
	        this.resetValidSearch.emit({ isValidSearch: this.isValidSearch });
	    };
	    ReportFilterCostCenterComponent.prototype.SuccessSelectCostCenterModal = function ($event) {
	        this.model.searchCostTypeNameList = $event.CostTypeName;
	        this.searchCostTypeName = this.model.searchCostTypeNameList.join();
	        this.model.costTypeHashIdList = $event.CostTypeHashId;
	        this.isValidSearch = false;
	        this.resetValidSearch.emit({ isValidSearch: this.isValidSearch });
	    };
	    ReportFilterCostCenterComponent.prototype.SuccessSelectDriverModal = function ($event) {
	        this.model.searchDriverNameList = $event.DriverName;
	        this.searchDriverName = this.model.searchDriverNameList.join();
	        this.model.driverHashIdList = $event.DriverHashId;
	        this.isValidSearch = false;
	        this.resetValidSearch.emit({ isValidSearch: this.isValidSearch });
	    };
	    ReportFilterCostCenterComponent.prototype.SuccessSelectVehicleModal = function ($event) {
	        this.model.searchLicenceTagList = $event.LicenceTag;
	        this.searchLicenceTag = this.model.searchLicenceTagList.join();
	        this.model.vehicleHashIdList = $event.VehicleMasterHashID;
	        this.isValidSearch = false;
	        this.resetValidSearch.emit({ isValidSearch: this.isValidSearch });
	    };
	    __decorate([
	        core_1.Output("OnSearch"), 
	        __metadata('design:type', Object)
	    ], ReportFilterCostCenterComponent.prototype, "onSearch", void 0);
	    __decorate([
	        core_1.Output("OnExportPDF"), 
	        __metadata('design:type', Object)
	    ], ReportFilterCostCenterComponent.prototype, "onExportPDF", void 0);
	    __decorate([
	        core_1.Output("OnExportExcel"), 
	        __metadata('design:type', Object)
	    ], ReportFilterCostCenterComponent.prototype, "onExportExcel", void 0);
	    __decorate([
	        core_1.Output("ResetValidSearch"), 
	        __metadata('design:type', Object)
	    ], ReportFilterCostCenterComponent.prototype, "resetValidSearch", void 0);
	    __decorate([
	        core_1.Input("IsValidSearch"), 
	        __metadata('design:type', Boolean)
	    ], ReportFilterCostCenterComponent.prototype, "isValidSearch", void 0);
	    __decorate([
	        core_1.Input("ErrorModel"), 
	        __metadata('design:type', Array)
	    ], ReportFilterCostCenterComponent.prototype, "errorModel", void 0);
	    __decorate([
	        core_1.Input("ReportName"), 
	        __metadata('design:type', String)
	    ], ReportFilterCostCenterComponent.prototype, "reportName", void 0);
	    ReportFilterCostCenterComponent = __decorate([
	        core_1.Component({
	            selector: "wego-report-filter-cost-center",
	            template: __webpack_require__(1325),
	            providers: [
	                instance_service_1.InstanceService,
	                company_service_1.CompanyService,
	                sharedvehiclegroup_service_1.SharedVehicleGroupService,
	                vehicle_service_1.VehicleService,
	                organization_service_1.OrganizationService,
	                report_filter_service_1.ReportFilterService,
	                contracttypegroup_service_1.ContractTypeGroupService
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof customer_service_1.CustomerService !== 'undefined' && customer_service_1.CustomerService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof instance_service_1.InstanceService !== 'undefined' && instance_service_1.InstanceService) === 'function' && _c) || Object, (typeof (_d = typeof company_service_1.CompanyService !== 'undefined' && company_service_1.CompanyService) === 'function' && _d) || Object, (typeof (_e = typeof vehicle_service_1.VehicleService !== 'undefined' && vehicle_service_1.VehicleService) === 'function' && _e) || Object, (typeof (_f = typeof report_filter_service_1.ReportFilterService !== 'undefined' && report_filter_service_1.ReportFilterService) === 'function' && _f) || Object, (typeof (_g = typeof organization_service_1.OrganizationService !== 'undefined' && organization_service_1.OrganizationService) === 'function' && _g) || Object, (typeof (_h = typeof contracttypegroup_service_1.ContractTypeGroupService !== 'undefined' && contracttypegroup_service_1.ContractTypeGroupService) === 'function' && _h) || Object])
	    ], ReportFilterCostCenterComponent);
	    return ReportFilterCostCenterComponent;
	    var _a, _b, _c, _d, _e, _f, _g, _h;
	}());
	exports.ReportFilterCostCenterComponent = ReportFilterCostCenterComponent;


/***/ },
/* 1325 */
/***/ function(module, exports) {

	module.exports = "<form #searchForm=\"ngForm\">\r\n  <div class=\"row\">\r\n    <div class=\"form-group col-md-3\">\r\n      <label>\r\n        <span class=\"text text-danger\">*</span>&nbsp;{{ 'LblFrom' | translate }}</label>\r\n      <div class=\"clearfix\"></div>\r\n      <div class=\"input-group\">\r\n        <span class=\"input-group-addon\">\r\n          <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n        </span>\r\n        <input #flatPickrConfigFromDate=\"wego-flatpickr\" flatpickr readonly [Config]=\"flatPickrConfigFrom\" [(ngModel)]=\"model.startDateTime\"\r\n          name=\"startDateTime\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblFrom' | translate}}\" (change)=\"OnFromDateChange()\">\r\n      </div>\r\n      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'StartDateTime' }}</span>\r\n    </div>\r\n    <div class=\"form-group col-md-3\">\r\n      <label>\r\n        <span class=\"text text-danger\">*</span>&nbsp;{{ 'LblTo' | translate }}</label>\r\n      <div class=\"clearfix \"></div>\r\n      <div class=\"input-group\">\r\n        <span class=\"input-group-addon\">\r\n          <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n        </span>\r\n        <input #flatPickrConfigToDate=\"wego-flatpickr\" flatpickr readonly [Config]=\"flatPickrConfigTo\" [(ngModel)]=\"model.endDateTime\"\r\n          name=\"endDateTime\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblTo' | translate }}\" (change)=\"OnToDateChange()\">\r\n      </div>\r\n      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'EndDateTime' }}</span>\r\n    </div>\r\n    <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Customer\" class=\"form-group col-md-3\">\r\n      <label>\r\n        <span *ngIf=\"!isEditMode\" class=\"text text-danger\">*</span>&nbsp;{{'LblCustomer' | translate }}\r\n      </label>\r\n      <select *ngIf=\"!isEditMode\" [(ngModel)]=\"model.customerHashId\" class=\"form-control\" name=\"customerHashId\" (change)=\"OnCustomerChange()\">\r\n        <option value=''>{{ 'LblSelect' | translate }} {{ 'LblCustomer' | translate }} </option>\r\n        <option *ngFor=\"let item of customerList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\r\n      </select>\r\n      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'customerHashId' }}</span>\r\n    </div>\r\n    <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Instance\" class=\"form-group col-md-3\">\r\n      <label>\r\n        <span *ngIf=\"!isEditMode\" class=\"text text-danger\">*</span>&nbsp;{{'LblInstance' | translate }}\r\n      </label>\r\n      <select *ngIf=\"!isEditMode\" [(ngModel)]=\"model.instanceHashId\" class=\"form-control\" name=\"instanceHashId\" (change)=\"OnInstanceChange()\">\r\n        <option value=''>{{ 'LblSelect' | translate }} {{ 'LblInstance' | translate }} </option>\r\n        <option *ngFor=\"let item of instanceList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\r\n      </select>\r\n      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'instanceHashId' }}</span>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Company\" class=\"form-group col-md-3\">\r\n      <label>\r\n        {{'LblCompany' | translate }}\r\n      </label>\r\n      <select *ngIf=\"!isEditMode\" [(ngModel)]=\"model.companyHashId\" class=\"form-control\" name=\"companyHashId\" (change)=\"OnCompanyChange()\">\r\n        <option value=''>{{ 'LblAll' | translate }} {{ 'LblCompany' | translate }} </option>\r\n        <option *ngFor=\"let item of companyList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\r\n      </select>\r\n      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'companyHashId' }}</span>\r\n    </div>\r\n    <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Organization\" class=\"form-group col-md-3\">\r\n      <label> {{'LblOrganization' | translate }} </label>\r\n      <select *ngIf=\"!isEditMode\" [(ngModel)]=\"model.organizationHashId\" class=\"form-control\" name=\"organizationHashId\" (change)=\"OnOrganizationChange()\">\r\n        <option value=''>{{ 'LblAll' | translate }} {{ 'LblOrganization' | translate }} </option>\r\n        <option *ngFor=\"let item of organizationList\" [ngValue]=\"item.keyHash\">{{ item.value }}</option>\r\n      </select>\r\n      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'organizationHashId' }}</span>\r\n    </div>\r\n    <!-- Vehicle Multi select Dropdown Started -->\r\n    <div class=\"form-group col-md-3\">\r\n      <label>\r\n        {{ 'LblVehicle' | translate }} </label>\r\n      <div class=\"input-group\">\r\n        <input [(ngModel)]=\"searchLicenceTag\" name=\"vehicleHashId\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblAll' | translate }} {{ 'LblVehicle' | translate }}\"\r\n          readonly>\r\n        <div class=\"input-group-btn\">\r\n          <button [disabled]=\"!isInstanceSelected\" class=\"btn btn-default\" type=\"button\" (click)=\"selectVehicleModal.show(model.vehicleHashIdList, model.searchLicenceTagList,this.vehicleMappingModel)\">\r\n            <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\r\n          </button>\r\n          <button [disabled]=\"!isInstanceSelected\" class=\"btn btn-default\" type=\"button\" (click)=\"clearVehicleList()\">\r\n            <i class=\"fa fa-eraser\" aria-hidden=\"true\"></i>\r\n          </button>\r\n        </div>\r\n      </div>\r\n      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'VehicleHashId' }}</span>\r\n    </div>\r\n    <!-- Vehicle Multi select Dropdown End -->\r\n    <!-- Cost Type Multi select Dropdown Started -->\r\n    <div class=\"form-group col-md-3\">\r\n      <label>\r\n        {{ 'LblCostType' | translate }}</label>\r\n      <div class=\"input-group\">\r\n        <input [(ngModel)]=\"searchCostTypeName\" [attr.title]=\"searchCostTypeName\" name=\"costTypeName\" type=\"text\" class=\"form-control\"\r\n          placeholder=\"{{ 'LblAll' | translate }} {{ 'LblCostType' | translate }}\" readonly>\r\n        <div class=\"input-group-btn\">\r\n          <button [disabled]=\"!isInstanceSelected\" class=\"btn btn-default\" type=\"button\" (click)=\"selectCostTypeModal.show(model.costTypeHashIdList, model.searchCostTypeNameList)\">\r\n            <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\r\n          </button>\r\n          <button [disabled]=\"!isInstanceSelected\" class=\"btn btn-default\" type=\"button\" (click)=\"clearcostType()\">\r\n            <i class=\"fa fa-eraser\" aria-hidden=\"true\"></i>\r\n          </button>\r\n        </div>\r\n      </div>\r\n      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'costTypeHashId' }}</span>\r\n    </div>\r\n    <div class=\"clearfix\"></div>\r\n    <!-- Cost Type Multi select Dropdown End-->\r\n    <!-- Driver Multi select Dropdown End-->\r\n    <div class=\"form-group col-md-3\">\r\n      <label>\r\n        {{ 'LblDriver' | translate }}</label>\r\n      <div class=\"input-group\">\r\n        <input [(ngModel)]=\"searchDriverName\" name=\"driverHashId\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblAll' | translate }} {{ 'LblDriver' | translate }}\"\r\n          readonly>\r\n        <div class=\"input-group-btn\">\r\n          <button [disabled]=\"!isInstanceSelected\" class=\"btn btn-default\" type=\"button\" (click)=\"selectDriverModal.show(model.driverHashIdList, model.searchDriverNameList, this.organizationDriverModel)\">\r\n            <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\r\n          </button>\r\n          <button [disabled]=\"!isInstanceSelected\" class=\"btn btn-default\" type=\"button\" (click)=\"clearDriverList()\">\r\n            <i class=\"fa fa-eraser\" aria-hidden=\"true\"></i>\r\n          </button>\r\n        </div>\r\n      </div>\r\n      <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'driverHashId' }}</span>\r\n    </div>\r\n    <div class=\"form-group col-md-3\">\r\n      <label> {{ 'LblShowTotalOnly' | translate }} </label>\r\n      <div class=\"clearfix\"></div>\r\n      <label class=\"radio-inline\">\r\n        <input type=\"radio\" [(ngModel)]=\"model.showTotalOnly\" name=\"showTotalOnly\" (change)=\"OnSearchChange()\" [value]=\"true\">{{ 'LblYes' | translate}}\r\n      </label>\r\n      <label class=\"radio-inline\">\r\n        <input type=\"radio\" [(ngModel)]=\"model.showTotalOnly\" name=\"showTotalOnly\" (change)=\"OnSearchChange()\" [value]=\"false\">{{ 'LblNo' | translate}}\r\n      </label>\r\n    </div>\r\n    <!-- Driver Multi select Dropdown End-->\r\n    <div class=\"form-group col-md-3 pull-right\">\r\n      <div class=\"input-group pull-right\">\r\n        <button class=\"btn btn-default\" (click)=\"OnSearch($event)\">\r\n          <i class=\"fa fa-search\" aria-hidden=\"true\"></i>\r\n        </button>&nbsp;\r\n        <button *ngIf=\"isValidSearch\" class=\"btn btn-default\" (click)=\"OnExportPDF($event)\">\r\n            <i class=\"fa fa-file-pdf-o\" aria-hidden=\"true\"></i>\r\n          </button>&nbsp;\r\n        <button *ngIf=\"isValidSearch\" class=\"btn btn-default\" (click)=\"OnExportExcel($event)\">\r\n          <i class=\"fa fa-file-excel-o\" aria-hidden=\"true\"></i>\r\n        </button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</form>\r\n<select-costtype-popup #selectCostTypeModal (OnSuccessSelect)=\"SuccessSelectCostCenterModal($event)\" [PageName]=\"reportName\"></select-costtype-popup>\r\n<wego-organization-driver-list-popup #selectDriverModal (OnSuccessSelect)=\"SuccessSelectDriverModal($event)\" [PageName]=\"reportName\"></wego-organization-driver-list-popup>\r\n<select-vehicle-cost-center-popup #selectVehicleModal (OnSuccessSelect)=\"SuccessSelectVehicleModal($event)\" [PageName]=\"reportName\"></select-vehicle-cost-center-popup>";

/***/ },
/* 1326 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var cost_center_report_model_1 = __webpack_require__(1327);
	var cost_center_report_service_1 = __webpack_require__(1026);
	var auth_service_1 = __webpack_require__(58);
	var router_1 = __webpack_require__(26);
	var translate_1 = __webpack_require__(631);
	var SelectCostTypePopupComponent = (function () {
	    function SelectCostTypePopupComponent(costCenterReportService, authService, router, translate) {
	        this.costCenterReportService = costCenterReportService;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.SelectedNames = [];
	        this.SelectedList = [];
	        this.costTypeList = [];
	        this.LblIcon = "fa fa-plus-square";
	        this.isParentCheck = false;
	        this.onCostTypeSelect = new core_1.EventEmitter();
	    }
	    SelectCostTypePopupComponent.prototype.ngOnInit = function () { };
	    SelectCostTypePopupComponent.prototype.show = function (SelectedList, SelectedNamesList) {
	        this.SelectedList = SelectedList;
	        this.SelectedNames = SelectedNamesList;
	        if (SelectedList.length == 0) {
	            this.SelectedList = cost_center_report_model_1.DefaultCostTypeList.map(function (x) { return x.costTypeHashId; });
	            this.SelectedNames = cost_center_report_model_1.DefaultCostTypeList.map(function (x) { return x.name; });
	        }
	        this.GetCostTypeList();
	        this.costTypeModal.show();
	    };
	    SelectCostTypePopupComponent.prototype.hide = function () {
	        this.costTypeModal.hide();
	    };
	    SelectCostTypePopupComponent.prototype.GetCostTypeList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.costCenterReportService.GetCostTypeList("", this.pageName).subscribe(function (res) {
	            _this.costTypeList = res.data;
	            cost_center_report_model_1.DefaultCostTypeList.forEach(function (x) { return _this.costTypeList.push(x); });
	            _this.costTypeList.forEach(function (x) { return (x.isChecked = _this.SelectedList.indexOf(x.costTypeHashId) > -1); });
	            _this.isParentCheck = _this.costTypeList.every(function (x) { return x.isChecked; });
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SelectCostTypePopupComponent.prototype.ItemCheckChanged = function (defaultName, costTypeHashId, costTypeName, isChecked) {
	        if (isChecked) {
	            if (this.SelectedList.indexOf(costTypeHashId) == -1) {
	                this.SelectedList.push(costTypeHashId);
	            }
	            if (this.SelectedNames.indexOf(costTypeName) == -1) {
	                this.SelectedNames.push(costTypeName);
	            }
	            this.isParentCheck = this.costTypeList
	                .filter(function (x) { return x.costTypeHashId != costTypeHashId; })
	                .every(function (x) { return x.isChecked; });
	        }
	        else {
	            this.SelectedList = this.SelectedList.filter(function (x) { return x != costTypeHashId; });
	            this.SelectedNames = this.SelectedNames.filter(function (x) { return x != costTypeName; });
	            this.isParentCheck = false;
	        }
	    };
	    SelectCostTypePopupComponent.prototype.OnParentCheck = function (isChecked) {
	        var _this = this;
	        this.costTypeList.forEach(function (x) {
	            x.isChecked = isChecked;
	            if (isChecked) {
	                if (_this.SelectedList.indexOf(x.costTypeHashId) == -1) {
	                    _this.SelectedList.push(x.costTypeHashId);
	                }
	                if (_this.SelectedNames.indexOf(x.name) == -1) {
	                    _this.SelectedNames.push(x.name);
	                }
	            }
	            else {
	                _this.SelectedList = _this.SelectedList.filter(function (y) { return y != x.costTypeHashId; });
	                _this.SelectedNames = _this.SelectedNames.filter(function (y) { return y != x.name; });
	            }
	        });
	    };
	    SelectCostTypePopupComponent.prototype.select = function (costType) {
	        this.isLoading = true;
	        this.onCostTypeSelect.emit({
	            CostTypeHashId: costType.costTypeHashId,
	            CostTypeName: costType.name
	        });
	        this.isLoading = false;
	        this.hide();
	    };
	    SelectCostTypePopupComponent.prototype.selectMultiple = function () {
	        this.isLoading = true;
	        this.onCostTypeSelect.emit({
	            CostTypeHashId: this.SelectedList,
	            CostTypeName: this.SelectedNames
	        });
	        this.isLoading = false;
	        this.hide();
	    };
	    SelectCostTypePopupComponent.prototype.CostTypeSelectModal = function () { };
	    __decorate([
	        core_1.Input("PageName"), 
	        __metadata('design:type', String)
	    ], SelectCostTypePopupComponent.prototype, "pageName", void 0);
	    __decorate([
	        core_1.Output("OnSuccessSelect"), 
	        __metadata('design:type', Object)
	    ], SelectCostTypePopupComponent.prototype, "onCostTypeSelect", void 0);
	    __decorate([
	        core_1.ViewChild("costTypeModal"), 
	        __metadata('design:type', Object)
	    ], SelectCostTypePopupComponent.prototype, "costTypeModal", void 0);
	    SelectCostTypePopupComponent = __decorate([
	        core_1.Component({
	            selector: "select-costtype-popup",
	            template: __webpack_require__(1328),
	            providers: [cost_center_report_service_1.CostCenterReportService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof cost_center_report_service_1.CostCenterReportService !== 'undefined' && cost_center_report_service_1.CostCenterReportService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_1.TranslateService !== 'undefined' && translate_1.TranslateService) === 'function' && _d) || Object])
	    ], SelectCostTypePopupComponent);
	    return SelectCostTypePopupComponent;
	    var _a, _b, _c, _d;
	}());
	exports.SelectCostTypePopupComponent = SelectCostTypePopupComponent;


/***/ },
/* 1327 */
/***/ function(module, exports) {

	"use strict";
	var CostCenterReportResult = (function () {
	    function CostCenterReportResult() {
	    }
	    return CostCenterReportResult;
	}());
	exports.CostCenterReportResult = CostCenterReportResult;
	var CostExpoenseModel = (function () {
	    function CostExpoenseModel() {
	    }
	    return CostExpoenseModel;
	}());
	exports.CostExpoenseModel = CostExpoenseModel;
	var BaseCostModel = (function () {
	    function BaseCostModel() {
	    }
	    return BaseCostModel;
	}());
	exports.BaseCostModel = BaseCostModel;
	var CostTypeModel = (function () {
	    function CostTypeModel() {
	        this.isDefaultCostType = false;
	    }
	    return CostTypeModel;
	}());
	exports.CostTypeModel = CostTypeModel;
	exports.DefaultCostTypeList = [
	    {
	        name: "Distance",
	        defaultName: "DISTANCE",
	        isDefaultCostType: true,
	        costTypeHashId: "DISTANCE",
	        isChecked: true
	    },
	    {
	        name: "Time",
	        defaultName: "TIME",
	        isDefaultCostType: true,
	        costTypeHashId: "TIME",
	        isChecked: true
	    },
	    {
	        name: "Fixed Fee",
	        defaultName: "FIXEDFEE",
	        isDefaultCostType: true,
	        costTypeHashId: "FIXEDFEE",
	        isChecked: true
	    },
	    {
	        name: "Penalties",
	        defaultName: "PENALTIES",
	        isDefaultCostType: true,
	        costTypeHashId: "PENALTIES",
	        isChecked: true
	    },
	    {
	        name: "Subscription",
	        defaultName: "SUBSCRIPTIONFEE",
	        isDefaultCostType: true,
	        costTypeHashId: "SUBSCRIPTIONFEE",
	        isChecked: true
	    }
	];


/***/ },
/* 1328 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #costTypeModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblSelect' | translate }} {{ 'LblCostType' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center parent-checkbox\">\r\n                  <input type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\">\r\n                </th>\r\n                <th class=\"cursor-pointer\">\r\n                  {{ 'LblCostType' | translate }}\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <tr *ngFor=\"let costType of costTypeList\">\r\n                <td class=\"text-center\">\r\n                  <input type=\"checkbox\" name=\"isActive\" (click)=\"ItemCheckChanged(costType.defaultName,costType.costTypeHashId,costType.name,$event.target.checked)\"\r\n                    [(ngModel)]=\"costType.isChecked\">\r\n                </td>\r\n                <td>{{ costType.name }}</td>\r\n              </tr>\r\n              <tr *ngIf=\"costTypeList.length == 0\">\r\n                <td class=\"text-center text-danger\" colspan=\"2\">\r\n                  {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n      </div>\r\n      <div class=\"modal-footer\">\r\n        <button type=\"button\" class=\"btn btn-green\" (click)=\"selectMultiple()\">{{ 'LblOK' | translate }}</button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 1329 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var config_1 = __webpack_require__(60);
	var auth_service_1 = __webpack_require__(58);
	var router_1 = __webpack_require__(26);
	var translate_1 = __webpack_require__(631);
	var organization_driver_service_1 = __webpack_require__(987);
	var organization_driver_model_1 = __webpack_require__(1287);
	var OrganizationDriverListPopupComponent = (function () {
	    function OrganizationDriverListPopupComponent(organizationDriverService, authService, router, translate) {
	        this.organizationDriverService = organizationDriverService;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.SelectedNames = [];
	        this.SelectedList = [];
	        this.LblIcon = "fa fa-plus-square";
	        this.isParentCheck = false;
	        this.organizationHashId = "";
	        this.model = new organization_driver_model_1.OrganizationDriverMappingModel();
	        this.onDriverSelect = new core_1.EventEmitter();
	    }
	    OrganizationDriverListPopupComponent.prototype.ngOnInit = function () {
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.searchField = ["driverName", "firstName", "lastName"];
	    };
	    OrganizationDriverListPopupComponent.prototype.show = function (SelectedList, SelectedNamesList, organizationDriverMapping) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.sortType = "";
	        this.DataListModel.sortReverse = null;
	        this.DataListModel.searchTerm = "";
	        this.DataListModel.infoMessage = "";
	        this.SelectedList = SelectedList;
	        this.SelectedNames = SelectedNamesList;
	        this.model = organizationDriverMapping;
	        this.GetOrganizationDriverList();
	        this.driverModal.show();
	    };
	    OrganizationDriverListPopupComponent.prototype.hide = function () {
	        this.driverModal.hide();
	    };
	    OrganizationDriverListPopupComponent.prototype.GetOrganizationDriverList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.organizationDriverService
	            .GetOrganizationBasedDriverList(this.DataListModel, this.model.customerHashId, this.model.instanceHashId, this.model.companyHashId, this.model.organizationHashId, this.pageName)
	            .subscribe(function (res) {
	            _this.driverList = res.data;
	            _this.driverList.forEach(function (x) {
	                return (x.isChecked =
	                    _this.SelectedList.indexOf(x.driverMasterHashId) > -1);
	            });
	            // this.isParentCheck = this.driverList.every(x => x.isChecked);
	            if (_this.driverList) {
	                var isCheck = _this.driverList.some(function (x) { return x.isChecked == true; });
	                if (isCheck) {
	                    if (_this.driverList.every(function (x) { return x.isChecked == true; }))
	                        _this.isParentCheck = true;
	                    else
	                        _this.isParentCheck = false;
	                }
	                else {
	                    _this.isParentCheck = false;
	                }
	            }
	            else {
	                _this.isParentCheck = false;
	            }
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    OrganizationDriverListPopupComponent.prototype.ItemCheckChanged = function (driverMasterHashId, driverName, isChecked) {
	        if (isChecked) {
	            if (this.SelectedList.indexOf(driverMasterHashId) == -1) {
	                this.SelectedList.push(driverMasterHashId);
	            }
	            if (this.SelectedNames.indexOf(driverName) == -1) {
	                this.SelectedNames.push(driverName);
	            }
	            this.isParentCheck = this.driverList
	                .filter(function (x) { return x.driverMasterHashId != driverMasterHashId; })
	                .every(function (x) { return x.isChecked; });
	        }
	        else {
	            this.SelectedList = this.SelectedList.filter(function (x) { return x != driverMasterHashId; });
	            this.SelectedNames = this.SelectedNames.filter(function (x) { return x != driverName; });
	            this.isParentCheck = false;
	        }
	    };
	    OrganizationDriverListPopupComponent.prototype.OnParentCheck = function (isChecked) {
	        var _this = this;
	        this.driverList.forEach(function (x) {
	            x.isChecked = isChecked;
	            if (isChecked) {
	                if (_this.SelectedList.indexOf(x.driverMasterHashId) == -1) {
	                    _this.SelectedList.push(x.driverMasterHashId);
	                }
	                if (_this.SelectedNames.indexOf(x.driverName) == -1) {
	                    _this.SelectedNames.push(x.driverName);
	                }
	            }
	            else {
	                _this.SelectedList = _this.SelectedList.filter(function (y) { return y != x.driverMasterHashId; });
	                _this.SelectedNames = _this.SelectedNames.filter(function (y) { return y != x.driverName; });
	            }
	        });
	    };
	    OrganizationDriverListPopupComponent.prototype.selectMultiple = function () {
	        this.isLoading = true;
	        this.onDriverSelect.emit({
	            DriverHashId: this.SelectedList,
	            DriverName: this.SelectedNames
	        });
	        this.isLoading = false;
	        this.hide();
	    };
	    OrganizationDriverListPopupComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetOrganizationDriverList();
	    };
	    OrganizationDriverListPopupComponent.prototype.OnSearch = function (event) {
	        this.DataListModel.searchTerm = event.searchTerm;
	        this.DataListModel.currentPage = 1;
	        this.GetOrganizationDriverList();
	    };
	    OrganizationDriverListPopupComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetOrganizationDriverList();
	    };
	    OrganizationDriverListPopupComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetOrganizationDriverList();
	    };
	    __decorate([
	        core_1.Input("PageName"), 
	        __metadata('design:type', String)
	    ], OrganizationDriverListPopupComponent.prototype, "pageName", void 0);
	    __decorate([
	        core_1.Output("OnSuccessSelect"), 
	        __metadata('design:type', Object)
	    ], OrganizationDriverListPopupComponent.prototype, "onDriverSelect", void 0);
	    __decorate([
	        core_1.ViewChild("driverModal"), 
	        __metadata('design:type', Object)
	    ], OrganizationDriverListPopupComponent.prototype, "driverModal", void 0);
	    OrganizationDriverListPopupComponent = __decorate([
	        core_1.Component({
	            selector: "wego-organization-driver-list-popup",
	            template: __webpack_require__(1330),
	            providers: [organization_driver_service_1.OrganizationDriverService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof organization_driver_service_1.OrganizationDriverService !== 'undefined' && organization_driver_service_1.OrganizationDriverService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_1.TranslateService !== 'undefined' && translate_1.TranslateService) === 'function' && _d) || Object])
	    ], OrganizationDriverListPopupComponent);
	    return OrganizationDriverListPopupComponent;
	    var _a, _b, _c, _d;
	}());
	exports.OrganizationDriverListPopupComponent = OrganizationDriverListPopupComponent;


/***/ },
/* 1330 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #driverModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\"\r\n  [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblSelect' | translate }} {{ 'LblDriver' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <wego-search-list [IsExported]=\"false\" [SearchTerm]=\"DataListModel.searchTerm\" (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\"\r\n          (OnPagingChange)=\"OnPagingChange($event)\" [ItemPerPage]=\"DataListModel.itemsPerPage\" [CustomeIcon]=\"LblIcon\" [IsCustomButton]='true'\r\n          (OnCustomeButton)=\"selectMultiple()\" [IsCustomButtonEnabled]=\"SelectedList && SelectedList.length>0\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <!-- <th class=\"text-center\">\r\n                  {{ 'LblSelect' | translate }}\r\n                </th> -->\r\n                <th class=\"text-center parent-checkbox\">\r\n                  <input type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\">\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('driverName')\">\r\n                  {{ 'LblDriver' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'driverName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('firstName')\">\r\n                  {{ 'LblFirstName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'firstName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('lastName')\">\r\n                  {{ 'LblLastName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'lastName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let driver of driverList\">\r\n                  <!-- <td class=\"text-center\">\r\n                    <a class=\"cursor-pointer\" (click)=\"select(driver)\">\r\n                      <i class=\"fa fa-plus-square\"></i>\r\n                    </a>\r\n                  </td> -->\r\n                  <td class=\"text-center\">\r\n                    <input type=\"checkbox\" name=\"isActive\" (click)=\"ItemCheckChanged(driver.driverMasterHashId,driver.driverName,$event.target.checked)\"\r\n                      [(ngModel)]=\"driver.isChecked\">\r\n                  </td>\r\n                  <td>{{ driver.driverName }}</td>\r\n                  <td>{{ driver.firstName }}</td>\r\n                  <td>{{ driver.lastName }}</td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0\">\r\n                <td class=\"text-center text-danger\" colspan=\"4\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 1331 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var vehicle_model_1 = __webpack_require__(553);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var vehicle_service_1 = __webpack_require__(530);
	var SelectVehicleListPopupComponent = (function () {
	    function SelectVehicleListPopupComponent(vehicleService, authService, router, translate) {
	        this.vehicleService = vehicleService;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.SelectedNames = [];
	        this.SelectedList = [];
	        this.LblIcon = "fa fa-plus-square";
	        this.isParentCheck = false;
	        this.model = new vehicle_model_1.VehicleMappingModel();
	        this.onSuccessSelect = new core_1.EventEmitter();
	    }
	    SelectVehicleListPopupComponent.prototype.ngOnInit = function () {
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.searchField = [
	            "licenceTag",
	            "ownerName",
	            "brand",
	            "type",
	            "vehicleClass",
	            "color"
	        ];
	    };
	    SelectVehicleListPopupComponent.prototype.ngOnChanges = function (change) {
	        console.log(change);
	    };
	    SelectVehicleListPopupComponent.prototype.show = function (SelectedList, SelectedNameList, vehicleMappingModel) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.sortType = "";
	        this.DataListModel.sortReverse = null;
	        this.DataListModel.searchTerm = "";
	        this.DataListModel.infoMessage = "";
	        this.SelectedList = SelectedList;
	        this.SelectedNames = SelectedNameList;
	        this.model = vehicleMappingModel;
	        this.GetVehicleList();
	        this.vehicleModal.show();
	    };
	    SelectVehicleListPopupComponent.prototype.hide = function () {
	        this.vehicleModal.hide();
	    };
	    SelectVehicleListPopupComponent.prototype.GetVehicleList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.vehicleService
	            .GetVehicleListByOrganization(this.DataListModel, this.model.customerHashId, this.model.instanceHashId, this.model.companyHashId, this.model.organizationHashId, this.model.svgHashId, this.pageName)
	            .subscribe(function (res) {
	            _this.vehicleList = res.data;
	            _this.vehicleList.forEach(function (x) {
	                return (x.isChecked =
	                    _this.SelectedList.indexOf(x.vehicleMasterHashId) > -1);
	            });
	            // this.isParentCheck = this.vehicleList.every(x => x.isChecked);
	            if (_this.vehicleList) {
	                var isCheck = _this.vehicleList.some(function (x) { return x.isChecked == true; });
	                if (isCheck) {
	                    if (_this.vehicleList.every(function (x) { return x.isChecked == true; }))
	                        _this.isParentCheck = true;
	                    else
	                        _this.isParentCheck = false;
	                }
	                else {
	                    _this.isParentCheck = false;
	                }
	            }
	            else {
	                _this.isParentCheck = false;
	            }
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SelectVehicleListPopupComponent.prototype.select = function (vehicle) {
	        this.isLoading = true;
	        this.onSuccessSelect.emit({
	            VehicleMasterHashID: vehicle.vehicleMasterHashId,
	            LicenceTag: vehicle.licenceTag
	        });
	        this.isLoading = false;
	        this.hide();
	    };
	    SelectVehicleListPopupComponent.prototype.selectMultiple = function () {
	        this.isLoading = true;
	        this.onSuccessSelect.emit({
	            VehicleMasterHashID: this.SelectedList,
	            LicenceTag: this.SelectedNames
	        });
	        this.isLoading = false;
	        this.hide();
	    };
	    SelectVehicleListPopupComponent.prototype.ItemCheckChanged = function (VehicleMasterHashId, LicenceTag, isChecked) {
	        if (isChecked) {
	            if (this.SelectedList.indexOf(VehicleMasterHashId) == -1) {
	                this.SelectedList.push(VehicleMasterHashId);
	            }
	            if (this.SelectedNames.indexOf(LicenceTag) == -1) {
	                this.SelectedNames.push(LicenceTag);
	            }
	            this.isParentCheck = this.vehicleList
	                .filter(function (x) { return x.vehicleMasterHashId != VehicleMasterHashId; })
	                .every(function (x) { return x.isChecked; });
	        }
	        else {
	            this.SelectedList = this.SelectedList.filter(function (x) { return x != VehicleMasterHashId; });
	            this.SelectedNames = this.SelectedNames.filter(function (x) { return x != LicenceTag; });
	            this.isParentCheck = false;
	        }
	    };
	    SelectVehicleListPopupComponent.prototype.OnParentCheck = function (isChecked) {
	        var _this = this;
	        this.vehicleList.forEach(function (x) {
	            x.isChecked = isChecked;
	            if (isChecked) {
	                if (_this.SelectedList.indexOf(x.vehicleMasterHashId) == -1) {
	                    _this.SelectedList.push(x.vehicleMasterHashId);
	                }
	                if (_this.SelectedNames.indexOf(x.licenceTag) == -1) {
	                    _this.SelectedNames.push(x.licenceTag);
	                }
	            }
	            else {
	                _this.SelectedList = _this.SelectedList.filter(function (y) { return y != x.vehicleMasterHashId; });
	                _this.SelectedNames = _this.SelectedNames.filter(function (y) { return y != x.licenceTag; });
	            }
	        });
	    };
	    SelectVehicleListPopupComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetVehicleList();
	    };
	    SelectVehicleListPopupComponent.prototype.OnSearch = function (event) {
	        this.DataListModel.searchTerm = event.searchTerm;
	        this.DataListModel.currentPage = 1;
	        this.GetVehicleList();
	    };
	    SelectVehicleListPopupComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetVehicleList();
	    };
	    SelectVehicleListPopupComponent.prototype.OnPagingChange = function (event) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetVehicleList();
	    };
	    SelectVehicleListPopupComponent.prototype.OnSuccessSelect = function () { };
	    __decorate([
	        core_1.Input("PageName"), 
	        __metadata('design:type', String)
	    ], SelectVehicleListPopupComponent.prototype, "pageName", void 0);
	    __decorate([
	        core_1.Output("OnSuccessSelect"), 
	        __metadata('design:type', Object)
	    ], SelectVehicleListPopupComponent.prototype, "onSuccessSelect", void 0);
	    __decorate([
	        core_1.ViewChild("vehicleModal"), 
	        __metadata('design:type', Object)
	    ], SelectVehicleListPopupComponent.prototype, "vehicleModal", void 0);
	    SelectVehicleListPopupComponent = __decorate([
	        core_1.Component({
	            selector: "select-vehicle-cost-center-popup",
	            template: __webpack_require__(1332),
	            providers: [vehicle_service_1.VehicleService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof vehicle_service_1.VehicleService !== 'undefined' && vehicle_service_1.VehicleService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object])
	    ], SelectVehicleListPopupComponent);
	    return SelectVehicleListPopupComponent;
	    var _a, _b, _c, _d;
	}());
	exports.SelectVehicleListPopupComponent = SelectVehicleListPopupComponent;


/***/ },
/* 1332 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #vehicleModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n\t<div class=\"modal-dialog modal-lg\">\r\n\t\t<div class=\"modal-content\">\r\n\t\t\t<div class=\"modal-header\">\r\n\t\t\t\t<button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n\t\t\t\t\t<span aria-hidden=\"true\">&times;</span>\r\n\t\t\t\t</button>\r\n\t\t\t\t<h4 class=\"modal-title\">{{ 'LblSelect' | translate }} {{ 'LblVehicle' | translate }}</h4>\r\n\t\t\t</div>\r\n\t\t\t<div class=\"modal-body\">\r\n\t\t\t\t<wego-search-list [IsExported]=\"false\" [SearchTerm]=\"DataListModel.searchTerm\" (OnSearch)=\"OnSearch($event)\" (OnPagingChange)=\"OnPagingChange($event)\"\r\n\t\t\t\t [ItemPerPage]=\"DataListModel.itemsPerPage\" [CustomeIcon]=\"LblIcon\" [IsCustomButton]='true' (OnCustomeButton)=\"selectMultiple()\"\r\n\t\t\t\t [IsCustomButtonEnabled]=\"SelectedList && SelectedList.length>0\"></wego-search-list>\r\n\t\t\t\t<div class=\"table table-responsive mar_bot_ziro\">\r\n\t\t\t\t\t<table class=\"table table-bordered mar_bot_ziro\">\r\n\t\t\t\t\t\t<thead>\r\n\t\t\t\t\t\t\t<tr>\r\n\t\t\t\t\t\t\t\t<!-- <th class=\"text-center\">\r\n                  {{ 'LblSelect' | translate }}\r\n                </th> -->\r\n\t\t\t\t\t\t\t\t<th class=\"text-center parent-checkbox\">\r\n\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\">\r\n\t\t\t\t\t\t\t\t</th>\r\n\t\t\t\t\t\t\t\t<th class=\"cursor-pointer\" (click)=\"OnSort('licenceTag')\">\r\n\t\t\t\t\t\t\t\t\t{{ 'LblLicenceTag' | translate }}\r\n\t\t\t\t\t\t\t\t\t<wego-sort-list [FieldName]=\"'licenceTag'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n\t\t\t\t\t\t\t\t</th>\r\n\t\t\t\t\t\t\t\t<th class=\"cursor-pointer\" (click)=\"OnSort('ownerName')\">\r\n\t\t\t\t\t\t\t\t\t{{ 'LblVehicleOwner' | translate }}\r\n\t\t\t\t\t\t\t\t\t<wego-sort-list [FieldName]=\"'ownerName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n\t\t\t\t\t\t\t\t</th>\r\n\t\t\t\t\t\t\t\t<th class=\"cursor-pointer\" (click)=\"OnSort('brand')\">\r\n\t\t\t\t\t\t\t\t\t{{ 'LblBrand' | translate }}\r\n\t\t\t\t\t\t\t\t\t<wego-sort-list [FieldName]=\"'brand'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n\t\t\t\t\t\t\t\t</th>\r\n\t\t\t\t\t\t\t\t<th class=\"cursor-pointer\" (click)=\"OnSort('type')\">\r\n\t\t\t\t\t\t\t\t\t{{ 'LblType' | translate }}\r\n\t\t\t\t\t\t\t\t\t<wego-sort-list [FieldName]=\"'type'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n\t\t\t\t\t\t\t\t</th>\r\n\t\t\t\t\t\t\t\t<th class=\"cursor-pointer\" (click)=\"OnSort('vehicleClass')\">\r\n\t\t\t\t\t\t\t\t\t{{ 'LblVehicleClass' | translate }}\r\n\t\t\t\t\t\t\t\t\t<wego-sort-list [FieldName]=\"'vehicleClass'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n\t\t\t\t\t\t\t\t</th>\r\n\t\t\t\t\t\t\t\t<th class=\"cursor-pointer\" (click)=\"OnSort('color')\">\r\n\t\t\t\t\t\t\t\t\t{{ 'LblColor' | translate }}\r\n\t\t\t\t\t\t\t\t\t<wego-sort-list [FieldName]=\"'color'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n\t\t\t\t\t\t\t\t</th>\r\n\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t</thead>\r\n\t\t\t\t\t\t<tbody>\r\n\t\t\t\t\t\t\t<template [ngIf]=\"DataListModel.totalItems != 0\">\r\n\t\t\t\t\t\t\t\t<tr *ngFor=\"let vehicle of vehicleList\">\r\n\t\t\t\t\t\t\t\t\t<!-- <td class=\"text-center\">\r\n                    <a class=\"cursor-pointer\" (click)=\"select(vehicle)\">\r\n                      <i class=\"fa fa-plus-square\"></i>\r\n                    </a>\r\n                  </td> -->\r\n\t\t\t\t\t\t\t\t\t<td class=\"text-center\">\r\n\t\t\t\t\t\t\t\t\t\t<input type=\"checkbox\" name=\"isActive\" (click)=\"ItemCheckChanged(vehicle.vehicleMasterHashId,vehicle.licenceTag,$event.target.checked)\"\r\n\t\t\t\t\t\t\t\t\t\t [(ngModel)]=\"vehicle.isChecked\">\r\n\t\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t\t\t<td>{{ vehicle.licenceTag }}</td>\r\n\t\t\t\t\t\t\t\t\t<td>{{vehicle.ownerName}}</td>\r\n\t\t\t\t\t\t\t\t\t<td>{{vehicle.brand}}</td>\r\n\t\t\t\t\t\t\t\t\t<td>{{vehicle.type}}</td>\r\n\t\t\t\t\t\t\t\t\t<td>{{vehicle.vehicleClass}}</td>\r\n\t\t\t\t\t\t\t\t\t<td>{{vehicle.color}}</td>\r\n\t\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t\t</template>\r\n\t\t\t\t\t\t\t<tr *ngIf=\"DataListModel.totalItems == 0\">\r\n\t\t\t\t\t\t\t\t<td class=\"text-center text-danger\" colspan=\"7\">\r\n\t\t\t\t\t\t\t\t\t{{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n\t\t\t\t\t\t\t\t</td>\r\n\t\t\t\t\t\t\t</tr>\r\n\t\t\t\t\t\t</tbody>\r\n\t\t\t\t\t</table>\r\n\t\t\t\t</div>\r\n\t\t\t\t<div class=\"clearfix\"></div>\r\n\t\t\t\t<div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n\t\t\t\t\t<div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n\t\t\t\t\t\t<div class=\"col-md-12\">\r\n\t\t\t\t\t\t\t<pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n\t\t\t\t\t\t\t [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n\t\t\t\t\t\t\t lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n\t\t\t\t\t\t</div>\r\n\t\t\t\t\t</div>\r\n\t\t\t\t</div>\r\n\t\t\t\t<wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n</div>";

/***/ },
/* 1333 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var config_1 = __webpack_require__(60);
	var booking_service_1 = __webpack_require__(556);
	var SnailTrailDriverBookingPopupComponent = (function () {
	    function SnailTrailDriverBookingPopupComponent(bookingService, authService, router, translate) {
	        this.bookingService = bookingService;
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.onSuccessSelect = new core_1.EventEmitter();
	    }
	    SnailTrailDriverBookingPopupComponent.prototype.ngOnInit = function () {
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.searchField = ["driver", "bookingReferenceID", "licenceTag", "bookingStatus"];
	    };
	    SnailTrailDriverBookingPopupComponent.prototype.ngOnChanges = function (change) {
	        console.log(change);
	    };
	    SnailTrailDriverBookingPopupComponent.prototype.show = function () {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.sortType = "";
	        this.DataListModel.sortReverse = null;
	        this.DataListModel.searchTerm = "";
	        this.DataListModel.infoMessage = "";
	        this.GetBookingList();
	        this.bookingModal.show();
	    };
	    SnailTrailDriverBookingPopupComponent.prototype.hide = function () {
	        this.bookingModal.hide();
	    };
	    SnailTrailDriverBookingPopupComponent.prototype.GetBookingList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.bookingService.GetNormalBookingList(this.DataListModel, true, config_1.Permission.PR_SANIL_TRAIL_REPORT)
	            .subscribe(function (res) {
	            _this.bookingList = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    SnailTrailDriverBookingPopupComponent.prototype.select = function (booking) {
	        this.isLoading = true;
	        this.onSuccessSelect.emit({ BookingHashID: booking.bookingHashId, BookingReferenceId: booking.bookingReferenceID,
	            DriverHashID: booking.driverHashId, DriverName: booking.driver, LicenceTage: booking.licenceTag, VehicleMasterHashID: booking.vehicleHashId });
	        this.isLoading = false;
	        this.hide();
	    };
	    SnailTrailDriverBookingPopupComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetBookingList();
	    };
	    SnailTrailDriverBookingPopupComponent.prototype.OnSearch = function (event) {
	        this.DataListModel.searchTerm = event.searchTerm;
	        this.DataListModel.currentPage = 1;
	        this.GetBookingList();
	    };
	    SnailTrailDriverBookingPopupComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetBookingList();
	    };
	    ;
	    SnailTrailDriverBookingPopupComponent.prototype.OnPagingChange = function (event) {
	        console.log(this.DataListModel);
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetBookingList();
	    };
	    SnailTrailDriverBookingPopupComponent.prototype.OnSuccessSelect = function () {
	    };
	    __decorate([
	        core_1.Output('OnSuccessSelect'), 
	        __metadata('design:type', Object)
	    ], SnailTrailDriverBookingPopupComponent.prototype, "onSuccessSelect", void 0);
	    __decorate([
	        core_1.ViewChild('bookingModal'), 
	        __metadata('design:type', Object)
	    ], SnailTrailDriverBookingPopupComponent.prototype, "bookingModal", void 0);
	    SnailTrailDriverBookingPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-snail-trail-driver-booking-popup',
	            template: __webpack_require__(1334),
	            providers: [booking_service_1.BookingService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof booking_service_1.BookingService !== 'undefined' && booking_service_1.BookingService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object])
	    ], SnailTrailDriverBookingPopupComponent);
	    return SnailTrailDriverBookingPopupComponent;
	    var _a, _b, _c, _d;
	}());
	exports.SnailTrailDriverBookingPopupComponent = SnailTrailDriverBookingPopupComponent;


/***/ },
/* 1334 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #bookingModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n                    <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblSelect' | translate }} {{ 'LblBooking' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <wego-search-list [IsExported]=\"false\" [SearchTerm]=\"DataListModel.searchTerm\" (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\"\r\n          (OnPagingChange)=\"OnPagingChange($event)\" [ItemPerPage]=\"DataListModel.itemsPerPage\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center\">\r\n                  {{ 'LblSelect' | translate }}\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('bookingReferenceID')\">\r\n                  {{ 'LblBookingReferenceId' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'bookingReferenceID'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('startDateTimeUTC')\">\r\n                  {{ 'LblFrom' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'startDateTimeUTC'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('endDateTimeUTC')\">\r\n                  {{ 'LblTo' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'endDateTimeUTC'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('driver')\">\r\n                  {{ 'LblDriver' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'driver'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('licenceTag')\">\r\n                  {{ 'LblVehicle' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'licenceTag'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('bookingStatus')\">\r\n                  {{ 'LblStatus' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'bookingStatus'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let booking of bookingList\">\r\n                  <td class=\"text-center\">\r\n                    <a class=\"cursor-pointer\" (click)=\"select(booking)\">\r\n                      <i class=\"fa fa-plus-square\"></i>\r\n                    </a>\r\n                  </td>\r\n                  <td>{{ booking.bookingReferenceID }}</td>\r\n                  <td>{{ booking.startDateTime }}</td>\r\n                  <td>{{ booking.endDateTime }}</td>\r\n                  <td>{{ booking.driver }}</td>\r\n                  <td>{{ booking.licenceTag }}</td>\r\n                  <td>{{ booking.bookingStatus }}</td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0\">\r\n                <td class=\"text-center text-danger\" colspan=\"7\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 1335 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var moment = __webpack_require__(84);
	var SnailTrailDriverFilterComponent = (function () {
	    function SnailTrailDriverFilterComponent() {
	        this.onSearchEvent = new core_1.EventEmitter();
	        this.onExportXls = new core_1.EventEmitter();
	        this.onResetData = new core_1.EventEmitter();
	        this.isValidReport = false;
	    }
	    Object.defineProperty(SnailTrailDriverFilterComponent.prototype, "ErrorModel", {
	        get: function () { return this.errorModel; },
	        set: function (errorModel) {
	            this.errorModel = errorModel;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    SnailTrailDriverFilterComponent.prototype.ngOnInit = function () {
	    };
	    SnailTrailDriverFilterComponent.prototype.SuccessSelectDriverModal = function ($event) {
	        this.driverhashId = $event.DriverHashID;
	        this.OnFilterReset();
	    };
	    SnailTrailDriverFilterComponent.prototype.SuccessSelectBookingModal = function ($event) {
	        this.bookingRefrenceId = $event.BookingReferenceId;
	        this.bookingHashId = $event.BookingHashID;
	        this.driverhashId = $event.DriverHashID;
	        this.licenceTag = $event.LicenceTage;
	        this.vehicleHashId = $event.VehicleMasterHashID;
	        this.OnFilterReset();
	    };
	    SnailTrailDriverFilterComponent.prototype.SuccessSelectVehicleModal = function ($event) {
	        this.licenceTag = $event.LicenceTage;
	        this.vehicleHashId = $event.VehicleMasterHashID;
	        this.OnFilterReset();
	    };
	    SnailTrailDriverFilterComponent.prototype.OnFilterReset = function () {
	        this.onResetData.emit();
	    };
	    SnailTrailDriverFilterComponent.prototype.OnSearchChange = function () {
	        this.bookingRefrenceId = "";
	        this.bookingHashId = "";
	        this.driverhashId = "";
	        this.licenceTag = "";
	        this.vehicleHashId = "";
	        this.onResetData.emit();
	    };
	    SnailTrailDriverFilterComponent.prototype.OnSearch = function ($event) {
	        this.onSearchEvent.emit({ reportSearchType: 'PER_BOOKING', bookingHashId: this.bookingHashId, driverHashId: "", vehicleHashId: "", startDateTime: "", endDateTime: "" });
	    };
	    SnailTrailDriverFilterComponent.prototype.OnExportXls = function ($event) {
	        this.onExportXls.emit({ reportSearchType: 'PER_BOOKING', bookingHashId: this.bookingHashId, driverHashId: "", vehicleHashId: "", startDateTime: "", endDateTime: "" });
	    };
	    SnailTrailDriverFilterComponent.prototype.ngOnDestroy = function () {
	    };
	    __decorate([
	        core_1.Output('OnSearch'), 
	        __metadata('design:type', Object)
	    ], SnailTrailDriverFilterComponent.prototype, "onSearchEvent", void 0);
	    __decorate([
	        core_1.Output('OnExportXls'), 
	        __metadata('design:type', Object)
	    ], SnailTrailDriverFilterComponent.prototype, "onExportXls", void 0);
	    __decorate([
	        core_1.Output('OnResetData'), 
	        __metadata('design:type', Object)
	    ], SnailTrailDriverFilterComponent.prototype, "onResetData", void 0);
	    __decorate([
	        core_1.Input('IsValidReport'), 
	        __metadata('design:type', Boolean)
	    ], SnailTrailDriverFilterComponent.prototype, "isValidReport", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', Object), 
	        __metadata('design:paramtypes', [Object])
	    ], SnailTrailDriverFilterComponent.prototype, "ErrorModel", null);
	    SnailTrailDriverFilterComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-snail-trail-driver-filter',
	            template: __webpack_require__(1336),
	            styles: ["\n    .nopad-left{\n      padding-left: 0px;\n    } \n  "]
	        }), 
	        __metadata('design:paramtypes', [])
	    ], SnailTrailDriverFilterComponent);
	    return SnailTrailDriverFilterComponent;
	}());
	exports.SnailTrailDriverFilterComponent = SnailTrailDriverFilterComponent;


/***/ },
/* 1336 */
/***/ function(module, exports) {

	module.exports = "<section class=\"banner-img-in\">\r\n  <div class=\"banner-in\">\r\n    <div class=\"search-bg-in\">\r\n      <div class=\"container-fluid\">\r\n        <div class=\"row\" style=\"padding-right:15px;\">\r\n          <div class=\"col-md-3\">\r\n            <h2 class=\"pagename\">{{ 'LblSnailTrailReport' | translate }}</h2>\r\n          </div>\r\n          <div class=\"col-md-5 navbar-right\">\r\n            <div class=\"row\" style=\"margin-top:10px;\">\r\n              <!--Per Booking Option-->\r\n              \r\n                <div class=\"form-group col-md-4 nopad-left\">\r\n                  <label>\r\n                    <span class=\"text text-danger\">*</span>{{ 'LblBooking' | translate }}</label>\r\n                  <div class=\"input-group\">\r\n                    <input [(ngModel)]=\"bookingRefrenceId\" name=\"bookingRefrenceId\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblSelect' | translate }} {{ 'LblBooking' | translate }}\"\r\n                      readonly>\r\n                    <div class=\"input-group-btn\">\r\n                      <button class=\"btn btn-default\" type=\"button\" (click)=\"selectBookingModal.show()\">\r\n                        <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\r\n                      </button>\r\n                    </div>\r\n                  </div>\r\n                  <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'BookingHashId' }}</span>\r\n                </div>\r\n\r\n                <div class=\"form-group col-md-4 nopad-left\">\r\n                  <label>{{ 'LblVehicle' | translate }}</label>\r\n                  <input [ngModel]=\"licenceTag\" name=\"LicenceTag\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblVehicle' | translate }}\"\r\n                    readonly>\r\n                </div>\r\n                <!--End Per Booking Option-->\r\n                <div class=\"col-md-4 navbar-right\">\r\n                  <label>&nbsp;</label>\r\n                  <div class=\"clearfix\"></div>\r\n                  <button class=\"btn btn-default\" type=\"button\" (click)=\"OnSearch($event)\" title=\"{{'LblSearch' | translate}}\">\r\n                    <i class=\"fa fa-search\" aria-hidden=\"true\"></i>\r\n                  </button>\r\n                  <button *ngIf=\"isValidReport\" class=\"btn btn-default\" type=\"button\" (click)=\"OnExportXls($event)\" title=\"{{'LblExportReport' | translate}}\"\r\n                    style=\"margin-left:10px;\">\r\n                    <i class=\"fa fa-file-excel-o\" aria-hidden=\"true\"></i>\r\n                  </button>\r\n                </div>\r\n              </div>                     \r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</section>\r\n\r\n<wego-snail-trail-driver-booking-popup #selectBookingModal (OnSuccessSelect)=\"SuccessSelectBookingModal($event)\"></wego-snail-trail-driver-booking-popup>";

/***/ },
/* 1337 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var modal_1 = __webpack_require__(537);
	var core_1 = __webpack_require__(3);
	var privacy_popup_service_1 = __webpack_require__(640);
	var auth_service_1 = __webpack_require__(58);
	var PrivacyPopupComponent = (function () {
	    function PrivacyPopupComponent(authService) {
	        this.authService = authService;
	    }
	    PrivacyPopupComponent.prototype.ngOnInit = function () {
	    };
	    PrivacyPopupComponent.prototype.Confirm = function ($event) {
	        this.hide();
	    };
	    PrivacyPopupComponent.prototype.show = function (bodyHTMLText) {
	        this.bodyHTMLText = bodyHTMLText;
	        this.privayStatementModel.show();
	    };
	    PrivacyPopupComponent.prototype.hide = function () {
	        this.privayStatementModel.hide();
	    };
	    __decorate([
	        core_1.ViewChild('privayStatementModel'), 
	        __metadata('design:type', (typeof (_a = typeof modal_1.ModalDirective !== 'undefined' && modal_1.ModalDirective) === 'function' && _a) || Object)
	    ], PrivacyPopupComponent.prototype, "privayStatementModel", void 0);
	    PrivacyPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-privacy-popup',
	            template: __webpack_require__(1338),
	            providers: [privacy_popup_service_1.PrivacyStatementPopup],
	            encapsulation: core_1.ViewEncapsulation.None,
	            styles: ["\n  span.popimgstyle img {\n    max-width: 100% !important;\n    height: auto !important;\n}\n"]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object])
	    ], PrivacyPopupComponent);
	    return PrivacyPopupComponent;
	    var _a, _b;
	}());
	exports.PrivacyPopupComponent = PrivacyPopupComponent;


/***/ },
/* 1338 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #privayStatementModel=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-md\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <h4 class=\"modal-title\">{{ 'LblPrivacyStatements' | translate }}</h4>\r\n      </div>\r\n      <div class=\"model-content\">\r\n        <div class=\"row\">\r\n          <div class=\"col-xs-12 col-sm-8 col-sm-offset-1\">\r\n            <span [innerHTML]=\"bodyHTMLText\" style=\"text-align: left;\" class=\"popimgstyle\"></span>\r\n          </div>\r\n        </div>\r\n        <br/><br/>\r\n      </div>\r\n      <div class=\"modal-footer\">\r\n        <button type=\"button\" class=\"btn btn-green\" (click)=\"Confirm($event)\">{{ 'LblClose' |  translate }}</button>\r\n      </div>\r\n    </div>\r\n  </div>";

/***/ },
/* 1339 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var modal_1 = __webpack_require__(537);
	var core_1 = __webpack_require__(3);
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var pre_post_trip_question_service_1 = __webpack_require__(746);
	var config_1 = __webpack_require__(60);
	var router_1 = __webpack_require__(26);
	var custom_question_model_1 = __webpack_require__(747);
	var PrePostTripQuestionUpdateComponent = (function () {
	    function PrePostTripQuestionUpdateComponent(authService, translate, prePostTripQuestionService, activeRoute) {
	        this.authService = authService;
	        this.translate = translate;
	        this.prePostTripQuestionService = prePostTripQuestionService;
	        this.activeRoute = activeRoute;
	        this.defaultlanguage = 'EN';
	        this.selectedLanguage = 'EN';
	        this.QuestionError = '';
	        this.onClose = new core_1.EventEmitter();
	    }
	    Object.defineProperty(PrePostTripQuestionUpdateComponent.prototype, "popupTitle", {
	        get: function () {
	            return this._popupTitle;
	        },
	        set: function (popupTitle) {
	            this._popupTitle = popupTitle && popupTitle.trim();
	        },
	        enumerable: true,
	        configurable: true
	    });
	    PrePostTripQuestionUpdateComponent.prototype.ngOnInit = function () {
	        this.model = new custom_question_model_1.CustomeTripQuestion();
	        this.module = this.translate.instant('LblPrePostTripQuestion');
	        this.preferredLanguageList = config_1.WeGoConfig.PREFERRED_LANGUAGE;
	    };
	    PrePostTripQuestionUpdateComponent.prototype.hide = function () {
	        this.UpdatePrePostTripQuestion.hide();
	    };
	    PrePostTripQuestionUpdateComponent.prototype.show = function (questionType, prePostQuestionHashId, iitem, isEditMode) {
	        this.QuestionError = '';
	        this.isEditMode = isEditMode;
	        console.log('value of  : ' + prePostQuestionHashId);
	        if (questionType == 'PREBEFORE' || questionType == 'PREAFTER') {
	            this.popupTitle =
	                this.translate.instant('LblCustom') +
	                    ' ' +
	                    this.translate.instant('LblPreTripQuestion');
	        }
	        else if (questionType == 'FAZ') {
	            this.popupTitle =
	                this.translate.instant('LblCustom') +
	                    ' ' +
	                    this.translate.instant('LblFazTripQuestion');
	        }
	        else {
	            this.popupTitle =
	                this.translate.instant('LblCustom') +
	                    ' ' +
	                    this.translate.instant('LblPostTripQuestion');
	        }
	        this.clearInputs();
	        this.indexNumber = iitem;
	        if (prePostQuestionHashId) {
	            this.model = prePostQuestionHashId;
	            this.selectedLanguage = this.model.defaultLanguage;
	            this.originalmodel = JSON.parse(JSON.stringify(this.model));
	        }
	        if (this.model.defaultLanguage) {
	            this.selectedLanguage = this.model.defaultLanguage;
	        }
	        else {
	            this.selectedLanguage = this.defaultlanguage;
	        }
	        if (questionType == 'FAZ') {
	            this.model.answerType = 'TEXT';
	            this.model.isRequired = true;
	            this.model.defaultLanguage = this.selectedLanguage = this.defaultlanguage = 'EN';
	        }
	        this.UpdatePrePostTripQuestion.show();
	    };
	    PrePostTripQuestionUpdateComponent.prototype.OnClose = function () {
	        this.model.name = this.originalmodel.name;
	        this.model.question = this.originalmodel.question;
	        this.model.isRequired = this.originalmodel.isRequired;
	        this.model.questionType = this.originalmodel.questionType;
	        this.model.answerType = this.originalmodel.answerType;
	        this.model.defaultLanguage = this.originalmodel.defaultLanguage;
	        this.model.prepostQuestionsByLangList = this.originalmodel.prepostQuestionsByLangList;
	        this.hide();
	    };
	    PrePostTripQuestionUpdateComponent.prototype.OnAddTranslation = function () {
	        var _this = this;
	        //Check if translation already exists if there, replace it
	        if (!this.model.question) {
	            this.QuestionError = this.translate.instant('LblQestionTextRequired');
	            return;
	        }
	        this.QuestionError = '';
	        var translation = this.model.prepostQuestionsByLangList.find(function (x) { return x.languageCode == _this.selectedLanguage; });
	        if (translation) {
	            if (!translation.isDeleted) {
	                translation.questionText = this.model.question;
	            }
	            else {
	                translation.isDeleted = false;
	                translation.questionText = this.model.question;
	            }
	        }
	        else {
	            translation = new custom_question_model_1.PrepostQuestionsByLang();
	            translation.language = this.selectedLanguage;
	            translation.languageCode = this.selectedLanguage;
	            translation.questionText = this.model.question;
	            translation.isDeleted = false;
	            this.model.prepostQuestionsByLangList.push(translation);
	        }
	    };
	    PrePostTripQuestionUpdateComponent.prototype.OnLanguageChange = function () {
	        var _this = this;
	        var translation = this.model.prepostQuestionsByLangList.find(function (x) { return !x.isDeleted && x.languageCode == _this.selectedLanguage; });
	        if (translation) {
	            this.model.question = translation.questionText;
	        }
	        else {
	            this.model.question = '';
	        }
	    };
	    PrePostTripQuestionUpdateComponent.prototype.DeleteQuestionLanguage = function (item) {
	        item.isDeleted = true;
	        if (item.languageCode == this.selectedLanguage) {
	            this.model.question = '';
	        }
	    };
	    PrePostTripQuestionUpdateComponent.prototype.GetlanguageQuetionList = function () {
	        return this.model.prepostQuestionsByLangList.filter(function (x) { return !x.isDeleted; });
	    };
	    PrePostTripQuestionUpdateComponent.prototype.OnSubmit = function (forms) {
	        var _this = this;
	        if (this.model.questionType == 'FAZ') {
	            this.OnAddTranslation();
	            console.log('OnAddTranslation called');
	        }
	        this.isLoading = true;
	        this.prePostTripQuestionService
	            .CheckCustomTripQuestion(this.model)
	            .subscribe(function (res) {
	            if (res.data) {
	                if (_this.model) {
	                    console.log(_this.model);
	                    _this.onClose.emit({
	                        model: _this.model,
	                        isEditMode: _this.isEditMode
	                    });
	                    _this.hide();
	                }
	            }
	            else {
	                _this.errorModel = res.error;
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.isLoading = false;
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    PrePostTripQuestionUpdateComponent.prototype.ShowSuccessPopup = function () {
	        this.successPopup.show();
	    };
	    PrePostTripQuestionUpdateComponent.prototype.ConfirmSuccessPopup = function () {
	        this.successPopup.hide();
	    };
	    PrePostTripQuestionUpdateComponent.prototype.clearInputs = function () {
	        this.model = new custom_question_model_1.CustomeTripQuestion();
	        this.errorModel = [];
	    };
	    PrePostTripQuestionUpdateComponent.prototype.GetPrePostQuestionDetailsByHashId = function (prePostQuestionHashId) {
	        var _this = this;
	        this.sub = this.activeRoute.params.subscribe(function (params) {
	            _this.isEditMode = false;
	            //prePostQuestionHashId = params["id"] || "";
	            if (prePostQuestionHashId != '') {
	                _this.isEditMode = true;
	                _this.prePostTripQuestionService
	                    .GetPrePostTripQuestionByHashId(prePostQuestionHashId)
	                    .subscribe(function (res) {
	                    _this.model = res.data;
	                }, function (error) {
	                    _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	                });
	            }
	        });
	    };
	    __decorate([
	        core_1.ViewChild('UpdatePrePostTripQuestion'), 
	        __metadata('design:type', (typeof (_a = typeof modal_1.ModalDirective !== 'undefined' && modal_1.ModalDirective) === 'function' && _a) || Object)
	    ], PrePostTripQuestionUpdateComponent.prototype, "UpdatePrePostTripQuestion", void 0);
	    __decorate([
	        core_1.ViewChild('successPopup'), 
	        __metadata('design:type', Object)
	    ], PrePostTripQuestionUpdateComponent.prototype, "successPopup", void 0);
	    __decorate([
	        core_1.Output('OnClose'), 
	        __metadata('design:type', Object)
	    ], PrePostTripQuestionUpdateComponent.prototype, "onClose", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String), 
	        __metadata('design:paramtypes', [String])
	    ], PrePostTripQuestionUpdateComponent.prototype, "popupTitle", null);
	    PrePostTripQuestionUpdateComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-update-pre-post-trip-question',
	            template: __webpack_require__(1340),
	            providers: [pre_post_trip_question_service_1.PrePostTripQuestionService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object, (typeof (_c = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _c) || Object, (typeof (_d = typeof pre_post_trip_question_service_1.PrePostTripQuestionService !== 'undefined' && pre_post_trip_question_service_1.PrePostTripQuestionService) === 'function' && _d) || Object, (typeof (_e = typeof router_1.ActivatedRoute !== 'undefined' && router_1.ActivatedRoute) === 'function' && _e) || Object])
	    ], PrePostTripQuestionUpdateComponent);
	    return PrePostTripQuestionUpdateComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.PrePostTripQuestionUpdateComponent = PrePostTripQuestionUpdateComponent;


/***/ },
/* 1340 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #UpdatePrePostTripQuestion=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ popupTitle }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <div class=\"row\">\r\n          <form (ngSubmit)=\"OnSubmit(prePostTripQuestionForm.value)\" #prePostTripQuestionForm=\"ngForm\">\r\n            <div class=\"form-group col-xs-12\">\r\n              <label>\r\n                <span class=\"text text-danger\">*</span>{{ 'LblName' | translate }}</label>\r\n              <div class=\"input-group col-xs-6\">\r\n                <input type=\"text\" maxlength=\"50\" [(ngModel)]=\"model.name\" class=\"form-control\" placeholder=\"{{ 'LblName' | translate }}\"\r\n                  name=\"name\">\r\n              </div>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'Name' }}</span>\r\n            </div>\r\n            <div class=\"form-group col-xs-12\">\r\n              <div class=\"row\">\r\n                <div class=\"form-group col-xs-2\" *ngIf=\"model.questionType != 'FAZ'\">\r\n                  <label>\r\n                    <span class=\"text text-danger\">*</span> {{ 'LblPreferredLanguage' | translate }}\r\n                  </label>\r\n                  <select [(ngModel)]=\"selectedLanguage\" name=\"selectedLanguage\" (change)=\"OnLanguageChange()\" class=\"form-control\">\r\n                    <option *ngFor=\"let preferredLanguage of preferredLanguageList\">{{preferredLanguage}}</option>\r\n                  </select>\r\n                </div>\r\n                <div class=\"form-group col-xs-7\">\r\n                  <label>\r\n                    <span class=\"text text-danger\">*</span>{{ 'LblQuestion' | translate }}</label>\r\n                  <div class=\"input-group col-xs-12\">\r\n                    <input type=\"text\" class=\"form-control\" [(ngModel)]=\"model.question\" placeholder=\"{{ 'LblQuestion' | translate }}\"\r\n                      name=\"question\">\r\n                  </div>\r\n                  <span class=\"text text-danger\">{{QuestionError }}</span>\r\n                </div>\r\n                <div class=\"form-group col-xs-3 text-right\" *ngIf=\"model.questionType != 'FAZ'\">\r\n                  <label>&nbsp;</label>\r\n                  <div class=\"input-group col-xs-12\">\r\n                    <button  type=\"button\" (click)=\"OnAddTranslation()\" class=\"btn btn-green\">{{ 'LblAdd' | translate }}</button>                  \r\n                  </div>\r\n                </div>\r\n              </div>\r\n            </div>\r\n            <div class=\"form-group col-xs-12\" *ngIf=\"model.questionType != 'FAZ'\">\r\n              <!--Question Transaltion List -->\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'defaultLanguageQuestion' }}</span>\r\n              <table class=\"table table-bordered mar_bot_ziro\">\r\n                <thead>\r\n                  <tr>\r\n                    <th>{{ 'LblPreferredLanguage' | translate }} </th>\r\n                    <th>{{ 'LblText' | translate }} </th>\r\n                    <th class=\"text-center\">{{ 'LblDelete' | translate }}</th>\r\n                  </tr>\r\n                </thead>\r\n                <tbody>\r\n                  <tr *ngFor=\"let item of  GetlanguageQuetionList() ;let iitem = index\">\r\n                    <td>{{ item.languageCode}}</td>\r\n                    <td>{{ item.questionText}}</td>\r\n                    <td class=\"text-center\">\r\n                      <a class=\"cursor-pointer\" (click)=\"DeleteQuestionLanguage(item)\">\r\n                        <i class=\"fa fa-trash-o fa-fw text-danger\"></i>\r\n                      </a>\r\n                    </td>\r\n                  </tr>\r\n                </tbody>\r\n              </table>\r\n            </div>\r\n            <div class=\"form-group col-xs-12\" *ngIf=\"model.questionType != 'FAZ'\">\r\n              <label>\r\n                <span class=\"text text-danger\">*</span> {{ 'LblDefaultLanguage' | translate }}\r\n              </label>\r\n              <select [(ngModel)]=\"model.defaultLanguage\" name=\"defaultLanguage\" class=\"form-control col-xs-3\">\r\n                <option value=\"\" [selected]=\"selected\">{{ 'LblSelect' | translate }} {{ 'LblPreferredLanguage' |\r\n                  translate }}</option>\r\n                <option *ngFor=\"let preferredLanguage of preferredLanguageList\" [attr.value]='preferredLanguage'>{{preferredLanguage}}</option>\r\n              </select>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'defaultLanguage' }}</span>\r\n            </div>\r\n            <div class=\"form-group col-xs-12\" *ngIf=\"model.questionType != 'FAZ'\">\r\n              <label class=\"radio-inline\">\r\n                <input type=\"radio\" name=\"isRequired\" [(ngModel)]=\"model.isRequired\" [value]=\"true\">{{ 'LblRequired'\r\n                |\r\n                translate }} </label>&nbsp;&nbsp;&nbsp;&nbsp;\r\n              <label class=\"radio-inline\">\r\n                <input type=\"radio\" name=\"isRequired\" [(ngModel)]=\"model.isRequired\" [value]=\"false\">{{ 'LblOptional'\r\n                |\r\n                translate }}</label>\r\n            </div>\r\n            <div class=\"form-group col-xs-12\" *ngIf=\"model.questionType != 'POST' && model.questionType != 'FAZ'\">\r\n              <label class=\"radio-inline\">\r\n                <input type=\"radio\" name=\"questionType\" [(ngModel)]=\"model.questionType\" value=\"PREBEFORE\">{{\r\n                'LblBeforeOpeningTheVehicle' | translate }}</label>&nbsp;&nbsp;&nbsp;&nbsp;\r\n              <label class=\"radio-inline\">\r\n                <input type=\"radio\" name=\"questionType\" [(ngModel)]=\"model.questionType\" value=\"PREAFTER\">{{\r\n                'LblAfterOpeningTheVehicle' | translate }}</label>\r\n              <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'QuestionType' }}</span>\r\n            </div>\r\n            <div class=\"form-group col-xs-12\" *ngIf=\"model.questionType != 'FAZ'\">\r\n              <label><span class=\"text text-danger\">*</span>{{ 'LblAnswerType' | translate }}</label>\r\n              <div class=\"input-group col-xs-6\">\r\n                <select class=\"form-control\" [(ngModel)]=\"model.answerType\" name=\"answerType\">\r\n                  <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblAnswerType' | translate }} </option>\r\n                  <option value=\"TEXT\">{{ 'LblText' | translate }} </option>\r\n                  <option value=\"YESNO\">{{ 'LblYesNo' | translate }} </option>\r\n                </select>\r\n                <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'AnswerType' }}</span>\r\n              </div>\r\n            </div>\r\n            <div class=\"modal-footer\">\r\n              <button type=\"submit\" class=\"btn btn-green\">{{ 'LblSave' | translate }}</button>\r\n              <button type=\"button\" class=\"btn btn-gray\" (click)=\"OnClose()\">{{ 'LblCancel' | translate }}</button>\r\n            </div>\r\n          </form>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<wego-success-popup #successPopup [popupMsg]=\"popupMsg\" (onConfirm)=\"ConfirmSuccessPopup()\"></wego-success-popup>";

/***/ },
/* 1341 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var instance_service_1 = __webpack_require__(500);
	var flatpickr_model_1 = __webpack_require__(83);
	var config_1 = __webpack_require__(60);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var pre_post_question_search_model_1 = __webpack_require__(1036);
	var vehicle_model_1 = __webpack_require__(553);
	var organization_driver_model_1 = __webpack_require__(1287);
	var pre_post_question_overview_service_1 = __webpack_require__(1035);
	var company_service_1 = __webpack_require__(501);
	var SlimSelect1 = __webpack_require__(616);
	var moment = __webpack_require__(84);
	var PrePostQuestionSearchComponent = (function () {
	    function PrePostQuestionSearchComponent(instanceService, companyService, authService, translate, prePostTripQuestionOverviewService) {
	        this.instanceService = instanceService;
	        this.companyService = companyService;
	        this.authService = authService;
	        this.translate = translate;
	        this.prePostTripQuestionOverviewService = prePostTripQuestionOverviewService;
	        this.roleLevel = config_1.RoleLevel;
	        this.resetValidSearch = new core_1.EventEmitter();
	        this.onAdvancedReset = new core_1.EventEmitter();
	        this.onExport = new core_1.EventEmitter();
	        this.showCancelModal = new core_1.EventEmitter();
	        this.onAdvancedSearch = new core_1.EventEmitter();
	        this.onPagingChange = new core_1.EventEmitter();
	        this.isExported = true;
	        this.searchTerm = "";
	    }
	    Object.defineProperty(PrePostQuestionSearchComponent.prototype, "isInstanceSelected", {
	        get: function () {
	            return !!this.model.instanceHashId;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(PrePostQuestionSearchComponent.prototype, "isCompanySelected", {
	        get: function () {
	            return !!this.model.companyHashIdList;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    PrePostQuestionSearchComponent.prototype.ngOnInit = function () {
	        this.model = new pre_post_question_search_model_1.PrePostQuestionSearchModel();
	        this.QuestionTypeAll = [
	            {
	                Key: "PREBEFORE",
	                Value: 1
	            },
	            {
	                Key: "PREAFTER",
	                Value: 2
	            },
	            {
	                Key: "POST",
	                Value: 3
	            },
	            {
	                Key: "CUSTOM",
	                Value: 4
	            }
	        ];
	        this.questionType = this.QuestionTypeAll;
	        this.model.questionTypeList = this.questionType.map(function (x) { return x.Value; });
	        this.pageName = "Pre-Post-Question";
	        this.permission = config_1.Permission.PR_PRE_POST_TRIP_QUESTIONS;
	        this.LblSelect = this.translate.instant("LblSelect");
	        this.LblType = this.translate.instant("LblType");
	        this.LblQuestion = this.translate.instant("LblQuestion");
	        this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
	        this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
	        this.itemPerPageList = config_1.WeGoConfig.GRID_PAGGING;
	        this.GetAllInstanceList();
	    };
	    PrePostQuestionSearchComponent.prototype.SetDefaultFlatPickrConfig = function () {
	        var flatPickrConfig = new flatpickr_model_1.FlatPickrModel();
	        flatPickrConfig.enableTime = true;
	        flatPickrConfig.time_24hr = true;
	        flatPickrConfig.dateFormat = config_1.WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
	        flatPickrConfig.minuteIncrement = 1;
	        return flatPickrConfig;
	    };
	    PrePostQuestionSearchComponent.prototype.GetAllInstanceList = function () {
	        var _this = this;
	        this.instanceService.GetDropdownInstanceList(this.pageName).subscribe(function (res) {
	            _this.instanceList = res.data;
	            if (_this.instanceList && _this.instanceList.length > 0) {
	                if (!_this.model.instanceHashId && _this.instanceList.length == 1) {
	                    _this.model.instanceHashId = _this.instanceList[0].keyHash;
	                }
	                _this.OnInstanceChange();
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    PrePostQuestionSearchComponent.prototype.OnInstanceChange = function () {
	        this.isLoader = true;
	        this.ResetValidSearch();
	        this.vehicleList = null;
	        this.companyList = [];
	        this.questionNameList = [];
	        this.GetAllQuestionNameList();
	    };
	    PrePostQuestionSearchComponent.prototype.OnFromDateChange = function () {
	        //this.ResetValidSearch();
	    };
	    PrePostQuestionSearchComponent.prototype.OnToDateChange = function () {
	        //this.ResetValidSearch();
	    };
	    Object.defineProperty(PrePostQuestionSearchComponent.prototype, "vehicleMappingModel", {
	        get: function () {
	            var vehicleMapping = new vehicle_model_1.VehicleMappingModel();
	            vehicleMapping.companyHashId = this.model.companyHashId;
	            vehicleMapping.instanceHashId = this.model.instanceHashId;
	            return vehicleMapping;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(PrePostQuestionSearchComponent.prototype, "organizationDriverModel", {
	        get: function () {
	            var organizationDriverMapping = new organization_driver_model_1.OrganizationDriverMappingModel();
	            organizationDriverMapping.companyHashId = this.model.companyHashId;
	            organizationDriverMapping.instanceHashId = this.model.instanceHashId;
	            return organizationDriverMapping;
	        },
	        enumerable: true,
	        configurable: true
	    });
	    PrePostQuestionSearchComponent.prototype.GetAllQuestionNameList = function () {
	        var _this = this;
	        this.prePostTripQuestionOverviewService
	            .GetDrowdownQuestionName(this.model)
	            .subscribe(function (res) {
	            _this.questionNameList = res.data;
	            if (_this.questionNameList && _this.questionNameList.length > 0) {
	                if (!_this.model.questionHashId &&
	                    _this.questionNameList.length == 1) {
	                    _this.model.questionHashId = _this.questionNameList[0].keyHash;
	                }
	            }
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    PrePostQuestionSearchComponent.prototype.ResetValidSearch = function () {
	        this.clearDriverList();
	        this.clearVehicleList();
	        this.clearCompanyList();
	        this.ClearSvg();
	        this.isValidSearch = false;
	        this.resetValidSearch.emit({ isValidSearch: this.isValidSearch });
	    };
	    PrePostQuestionSearchComponent.prototype.SuccessSelectDriverModal = function ($event) {
	        this.model.searchDriverNameList = $event.DriverName;
	        this.searchDriverName = this.model.searchDriverNameList.join();
	        this.model.driverHashIdList = $event.DriverHashId;
	        this.GetAllQuestionNameList();
	        this.isValidSearch = false;
	        this.resetValidSearch.emit({ isValidSearch: this.isValidSearch });
	    };
	    PrePostQuestionSearchComponent.prototype.SuccessSelectVehicleModal = function ($event) {
	        this.model.searchLicenceTagList = $event.LicenceTag;
	        this.searchLicenceTag = this.model.searchLicenceTagList.join();
	        this.model.vehicleHashIdList = $event.VehicleMasterHashID;
	        this.GetAllQuestionNameList();
	        this.isValidSearch = false;
	        this.resetValidSearch.emit({ isValidSearch: this.isValidSearch });
	    };
	    PrePostQuestionSearchComponent.prototype.SuccessSelectCompanyModal = function ($event) {
	        this.model.searchCompanyList = $event.CompanyName;
	        this.companyName = this.model.searchCompanyList.join();
	        this.model.companyHashIdList = $event.CompanyHashId;
	        this.GetAllQuestionNameList();
	        this.isValidSearch = false;
	        this.resetValidSearch.emit({ isValidSearch: this.isValidSearch });
	    };
	    PrePostQuestionSearchComponent.prototype.SuccessSelectSvgModal = function ($event) {
	        this.model.searchSVGNameList = $event.SvgName;
	        this.searchSVGName = this.model.searchSVGNameList.join();
	        this.model.sharedVehicleGroupHashIdList = $event.SvgMasterHashID;
	        this.GetAllQuestionNameList();
	    };
	    PrePostQuestionSearchComponent.prototype.clearCompanyList = function () {
	        this.model.searchCompanyList = [];
	        this.companyName = "";
	        this.model.companyHashIdList = [];
	        this.isValidSearch = false;
	        this.resetValidSearch.emit({ isValidSearch: this.isValidSearch });
	    };
	    PrePostQuestionSearchComponent.prototype.clearDriverList = function () {
	        this.model.searchDriverNameList = [];
	        this.searchDriverName = "";
	        this.model.driverHashIdList = [];
	        this.isValidSearch = false;
	        this.resetValidSearch.emit({ isValidSearch: this.isValidSearch });
	    };
	    PrePostQuestionSearchComponent.prototype.clearVehicleList = function () {
	        this.model.searchLicenceTagList = [];
	        this.searchLicenceTag = "";
	        this.model.vehicleHashIdList = [];
	        this.isValidSearch = false;
	        this.resetValidSearch.emit({ isValidSearch: this.isValidSearch });
	    };
	    PrePostQuestionSearchComponent.prototype.ClearSvg = function () {
	        this.model.searchSVGNameList = [];
	        this.searchSVGName = "";
	        this.model.sharedVehicleGroupHashId = "";
	        this.model.sharedVehicleGroupHashIdList = [];
	    };
	    PrePostQuestionSearchComponent.prototype.ngAfterViewInit = function () {
	        var _this = this;
	        this.questionTypeSelect = new SlimSelect1({
	            select: "#questionType",
	            placeholder: this.LblSelect + " " + this.LblQuestion + " " + this.LblType,
	            showSearch: false,
	            onChange: function (info) {
	                _this.model.questionTypeList = info.map(function (x) { return x.value; });
	            }
	        });
	        this.questionTypeSelect.set(this.model.questionTypeList);
	    };
	    PrePostQuestionSearchComponent.prototype.OnAdvancedSearch = function () {
	        this.onAdvancedSearch.emit({ prePostSearchFilterModel: this.model });
	    };
	    PrePostQuestionSearchComponent.prototype.OnExport = function ($event) {
	        this.onExport.emit($event);
	    };
	    PrePostQuestionSearchComponent.prototype.OnAdvancedReset = function ($event) {
	        this.companyName = "";
	        this.searchSVGName = "";
	        this.searchLicenceTag = "";
	        this.searchDriverName = "";
	        this.model = new pre_post_question_search_model_1.PrePostQuestionSearchModel();
	        this.model.questionTypeList = this.questionType.map(function (x) { return x.Value; });
	        this.questionTypeSelect.set(this.model.questionTypeList);
	        this.onAdvancedReset.emit({
	            prePostSearchFilterModel: this.model,
	            isReset: true
	        });
	        this.GetAllInstanceList();
	    };
	    PrePostQuestionSearchComponent.prototype.OnPagingChange = function ($event) {
	        this.onPagingChange.emit({ itemPerPage: $event });
	    };
	    __decorate([
	        core_1.Output("ResetValidSearch"), 
	        __metadata('design:type', Object)
	    ], PrePostQuestionSearchComponent.prototype, "resetValidSearch", void 0);
	    __decorate([
	        core_1.Output("OnAdvancedReset"), 
	        __metadata('design:type', Object)
	    ], PrePostQuestionSearchComponent.prototype, "onAdvancedReset", void 0);
	    __decorate([
	        core_1.Output("OnExport"), 
	        __metadata('design:type', Object)
	    ], PrePostQuestionSearchComponent.prototype, "onExport", void 0);
	    __decorate([
	        core_1.Output("ShowCancelModal"), 
	        __metadata('design:type', Object)
	    ], PrePostQuestionSearchComponent.prototype, "showCancelModal", void 0);
	    __decorate([
	        core_1.Output("OnAdvancedSearch"), 
	        __metadata('design:type', Object)
	    ], PrePostQuestionSearchComponent.prototype, "onAdvancedSearch", void 0);
	    __decorate([
	        core_1.Output("OnPagingChange"), 
	        __metadata('design:type', Object)
	    ], PrePostQuestionSearchComponent.prototype, "onPagingChange", void 0);
	    __decorate([
	        core_1.Input("IsExported"), 
	        __metadata('design:type', Boolean)
	    ], PrePostQuestionSearchComponent.prototype, "isExported", void 0);
	    __decorate([
	        core_1.Input("SearchTerm"), 
	        __metadata('design:type', String)
	    ], PrePostQuestionSearchComponent.prototype, "searchTerm", void 0);
	    __decorate([
	        core_1.Input("itemPerPageList"), 
	        __metadata('design:type', Object)
	    ], PrePostQuestionSearchComponent.prototype, "itemPerPageList", void 0);
	    __decorate([
	        core_1.Input("ItemPerPage"), 
	        __metadata('design:type', Object)
	    ], PrePostQuestionSearchComponent.prototype, "itemPerPage", void 0);
	    __decorate([
	        core_1.Input("ErrorModel"), 
	        __metadata('design:type', Array)
	    ], PrePostQuestionSearchComponent.prototype, "errorModel", void 0);
	    PrePostQuestionSearchComponent = __decorate([
	        core_1.Component({
	            selector: "wego-pre-post-search-filter",
	            template: __webpack_require__(1342),
	            providers: [
	                instance_service_1.InstanceService,
	                pre_post_question_overview_service_1.PrePostTripQuestionOverviewService,
	                company_service_1.CompanyService
	            ],
	            styles: [
	                "\n    .search-icon {\n        color:#2ba2aa;\n    }\n    .reset-icon {\n        color:#DD9933;\n    }\n    .export-icon {\n        color:#01A2D9;\n    }\n    .delete-icon {\n        color:#f00;\n    }\n    .cancel-icon {\n        color:#f00;\n    }\n    .add-icon {\n        color:#080;\n    }\n    .nopad-left{\n      padding-left: 0px;\n    }\n    "
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof instance_service_1.InstanceService !== 'undefined' && instance_service_1.InstanceService) === 'function' && _a) || Object, (typeof (_b = typeof company_service_1.CompanyService !== 'undefined' && company_service_1.CompanyService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _d) || Object, (typeof (_e = typeof pre_post_question_overview_service_1.PrePostTripQuestionOverviewService !== 'undefined' && pre_post_question_overview_service_1.PrePostTripQuestionOverviewService) === 'function' && _e) || Object])
	    ], PrePostQuestionSearchComponent);
	    return PrePostQuestionSearchComponent;
	    var _a, _b, _c, _d, _e;
	}());
	exports.PrePostQuestionSearchComponent = PrePostQuestionSearchComponent;


/***/ },
/* 1342 */
/***/ function(module, exports) {

	module.exports = "<form #PrePostSearchForm=\"ngForm\" (ngSubmit)=\"OnAdvancedSearch($event)\">\r\n    <div class=\"row\">\r\n        <div class=\"form-group col-md-3\">\r\n            <label>\r\n                {{ 'LblFrom' | translate }}</label>\r\n            <div class=\"clearfix\"></div>\r\n            <div class=\"input-group\">\r\n                <span class=\"input-group-addon\">\r\n                    <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n                </span>\r\n                <input #flatPickrConfigFromDate=\"wego-flatpickr\" flatpickr readonly [Config]=\"flatPickrConfigFrom\" [(ngModel)]=\"model.startDateTime\"\r\n                    name=\"startDateTime\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblFrom' | translate }}\" (change)=\"OnFromDateChange()\">\r\n            </div>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'StartDateTime' }}</span>\r\n        </div>\r\n        <div class=\"form-group col-md-3\">\r\n            <label>\r\n                {{ 'LblTo' | translate }}</label>\r\n            <div class=\"clearfix \"></div>\r\n            <div class=\"input-group\">\r\n                <span class=\"input-group-addon\">\r\n                    <i class=\"fa fa-calendar fa-fw\" aria-hidden=\"true\"></i>\r\n                </span>\r\n                <input #flatPickrConfigToDate=\"wego-flatpickr\" flatpickr readonly [Config]=\"flatPickrConfigTo\" [(ngModel)]=\"model.endDateTime\"\r\n                    name=\"endDateTime\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblTo' | translate }}\" (change)=\"OnToDateChange()\">\r\n            </div>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'EndDateTime' }}</span>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Instance\" class=\"form-group col-md-3\">\r\n            <label>\r\n                {{ 'LblInstance' | translate }}</label>\r\n            <select [(ngModel)]=\"model.instanceHashId\" name=\"Instance\" class=\"form-control\" (change)=\"OnInstanceChange()\">\r\n                <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblInstance' | translate }} </option>\r\n                <option *ngFor=\"let item of instanceList\" [ngValue]='item.keyHash'>{{item.value}}</option>\r\n            </select>\r\n        </div>\r\n        <!-- Company Multi selection-->\r\n        <div class=\"form-group col-md-3\" *ngIf=\"authService.GetHighestRoleLevel() <= roleLevel.Company\">\r\n            <label>\r\n                {{ 'LblCompany' | translate }}</label>\r\n            <div class=\"input-group\">\r\n                <input [(ngModel)]=\"companyName\" name=\"companyHashId\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblAll' | translate }} {{ 'LblCompany' | translate }}\"\r\n                    readonly>\r\n                <div class=\"input-group-btn\">\r\n                    <button [disabled]=\"!isInstanceSelected\" class=\"btn btn-default\" type=\"button\" (click)=\"selectCompanyModal.show(model.companyHashIdList, model.searchCompanyList, model.instanceHashId, model.instanceHashId)\">\r\n                        <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\r\n                    </button>\r\n                    <button [disabled]=\"!isInstanceSelected\" class=\"btn btn-default\" type=\"button\" (click)=\"clearCompanyList()\">\r\n                        <i class=\"fa fa-eraser\" aria-hidden=\"true\"></i>\r\n                    </button>\r\n                </div>\r\n            </div>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'driverHashId' }}</span>\r\n        </div>\r\n        <!-- End Company Multi selection-->\r\n        <!-- Svg  Multi selection-->\r\n        <div class=\"form-group col-md-3\">\r\n            <label>{{ 'LblSharedVehicleGroup' | translate }}</label>\r\n            <div class=\"input-group\">\r\n                <input [(ngModel)]=\"searchSVGName\" [attr.title]=\"searchSVGName\" name=\"sharedVehicleGroupHashId\" type=\"text\" class=\"form-control\"\r\n                    placeholder=\"{{ 'LblAll' | translate }} {{ 'LblSharedVehicleGroup' | translate }}\" readonly>\r\n                <div class=\"input-group-btn\">\r\n                    <button [disabled]=\"!isCompanySelected\" class=\"btn btn-default\" type=\"button\" (click)=\"selectSvgModal.show(model.sharedVehicleGroupHashIdList,model.searchSVGNameList, model.companyHashIdList, permission)\">\r\n                        <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\r\n                    </button>\r\n                    <button [disabled]=\"!isCompanySelected\" class=\"btn btn-default\" type=\"button\" (click)=\"ClearSvg()\">\r\n                        <i class=\"fa fa-eraser\" aria-hidden=\"true\"></i>\r\n                    </button>\r\n                </div>\r\n            </div>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'sharedVehicleGroupHashId' }}</span>\r\n        </div>\r\n        <!-- End Svg Multi selection-->\r\n        <div class=\"clearfix\"></div>\r\n        <!-- Vehicle Multi selection-->\r\n        <div class=\"form-group col-md-3\">\r\n            <label>\r\n                {{ 'LblVehicle' | translate }} </label>\r\n            <div class=\"input-group\">\r\n                <input [(ngModel)]=\"searchLicenceTag\" name=\"vehicleHashId\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblAll' | translate }} {{ 'LblVehicle' | translate }}\"\r\n                    readonly>\r\n                <div class=\"input-group-btn\">\r\n                    <button [disabled]=\"!isInstanceSelected\" class=\"btn btn-default\" type=\"button\" (click)=\"selectVehicleModal.show(model.vehicleHashIdList, model.searchLicenceTagList,this.vehicleMappingModel)\">\r\n                        <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\r\n                    </button>\r\n                    <button [disabled]=\"!isInstanceSelected\" class=\"btn btn-default\" type=\"button\" (click)=\"clearVehicleList()\">\r\n                        <i class=\"fa fa-eraser\" aria-hidden=\"true\"></i>\r\n                    </button>\r\n                </div>\r\n            </div>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'VehicleHashId' }}</span>\r\n        </div>\r\n        <!-- End Vehicle Multi selection-->\r\n        <!-- Driver Multi selection-->\r\n        <div class=\"form-group col-md-3\">\r\n            <label>\r\n                {{ 'LblDriver' | translate }}</label>\r\n            <div class=\"input-group\">\r\n                <input [(ngModel)]=\"searchDriverName\" name=\"driverHashId\" type=\"text\" class=\"form-control\" placeholder=\"{{ 'LblAll' | translate }} {{ 'LblDriver' | translate }}\"\r\n                    readonly>\r\n                <div class=\"input-group-btn\">\r\n                    <button [disabled]=\"!isInstanceSelected\" class=\"btn btn-default\" type=\"button\" (click)=\"selectDriverModal.show(model.driverHashIdList, model.searchDriverNameList, this.organizationDriverModel)\">\r\n                        <i class=\"fa fa-plus\" aria-hidden=\"true\"></i>\r\n                    </button>\r\n                    <button [disabled]=\"!isInstanceSelected\" class=\"btn btn-default\" type=\"button\" (click)=\"clearDriverList()\">\r\n                        <i class=\"fa fa-eraser\" aria-hidden=\"true\"></i>\r\n                    </button>\r\n                </div>\r\n            </div>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'driverHashId' }}</span>\r\n        </div>\r\n        <!-- End Driver Multi selection-->\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"form-group col-md-3\">\r\n            <label> {{ 'LblQuestion' | translate }}{{ 'LblType' | translate }} </label>\r\n            <select id=\"questionType\" name=\"questionType\" multiple>\r\n                <!-- <option value=\"\">{{ 'LblAll' | translate }} {{ 'LblStatus' | translate }}</option> -->\r\n                <option *ngFor=\"let item of QuestionTypeAll\" [attr.value]='item.Value'>{{item.Key}}</option>\r\n            </select>\r\n            <span class=\"text text-danger\">{{ errorModel | serverErrorMessage : 'questionType' }}</span>\r\n        </div>\r\n        <div class=\"form-group col-md-3\">\r\n            <label>\r\n                {{ 'LblQuestion' | translate }} {{ 'LblName' | translate }}</label>\r\n            <select [(ngModel)]=\"model.questionHashId\" name=\"Instance\" class=\"form-control\">\r\n                <option value=\"\">{{ 'LblSelect' | translate }} {{ 'LblQuestion' | translate }} {{ 'LblName' | translate }} </option>\r\n                <option *ngFor=\"let item of questionNameList\" [ngValue]='item.keyHash'>{{item.value}}</option>\r\n            </select>\r\n        </div>\r\n        <div class=\"form-group col-md-6 nopad-left\">\r\n            <div class=\"form-group col-md-4\">\r\n                <label>&nbsp;</label>\r\n                <div class=\"clearfix\"></div>\r\n                <button type=\"submit\" class=\"btn btn-default search-icon\">\r\n                    <i class=\"fa fa-search\" aria-hidden=\"true\"></i>\r\n                </button>\r\n                <button class=\"btn btn-default reset-icon\" type=\"button\" (click)=\"OnAdvancedReset($event)\">\r\n                    <i class=\"fa fa-eraser\" aria-hidden=\"true\"></i>\r\n                </button>\r\n                <button class=\"btn btn-default export-icon\" type=\"button\" (click)=\"OnExport($event)\" title=\"{{'LblExportAll(CSV)' | translate}}\">\r\n                    <i class=\"fa fa-download\" aria-hidden=\"true\"></i>\r\n                </button>\r\n            </div>\r\n            <div class=\"form-group col-md-3 pull-right\">\r\n                <label>&nbsp;</label>\r\n                <select class=\"form-control\" title='Items Per Page' [(ngModel)]=\"itemPerPage\" name=\"itemPerPage\" (change)=\"OnPagingChange($event.target.value)\">\r\n                    <option *ngFor=\"let item of itemPerPageList\" [attr.value]='item.value'>{{ item }}</option>\r\n                </select>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</form>\r\n\r\n<wego-organization-driver-list-popup #selectDriverModal (OnSuccessSelect)=\"SuccessSelectDriverModal($event)\" [PageName]=\"reportName\"></wego-organization-driver-list-popup>\r\n<select-vehicle-cost-center-popup #selectVehicleModal (OnSuccessSelect)=\"SuccessSelectVehicleModal($event)\" [PageName]=\"reportName\"></select-vehicle-cost-center-popup>\r\n<wego-company-popup #selectCompanyModal (OnSuccessSelect)=\"SuccessSelectCompanyModal($event)\"></wego-company-popup>\r\n<wego-booking-svg-popup #selectSvgModal (OnSuccessSelect)=\"SuccessSelectSvgModal($event)\"></wego-booking-svg-popup>";

/***/ },
/* 1343 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var auth_service_1 = __webpack_require__(58);
	var config_1 = __webpack_require__(60);
	var company_service_1 = __webpack_require__(501);
	var CompanyPopupComponent = (function () {
	    function CompanyPopupComponent(companyService, authService) {
	        this.companyService = companyService;
	        this.authService = authService;
	        this.isParentCheck = false;
	        this.SelectedList = [];
	        this.SelectedNames = [];
	        this.LblIcon = "fa fa-plus-square";
	        this.onSuccessSelect = new core_1.EventEmitter();
	    }
	    CompanyPopupComponent.prototype.ngOnInit = function () {
	        this.DataListModel = new config_1.DataListModel();
	        this.DataListModel.searchField = ["companyName", "instanceName"];
	    };
	    CompanyPopupComponent.prototype.show = function (SelectedList, SelectedNamesList, instanceHashId) {
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.sortType = "";
	        this.DataListModel.sortReverse = null;
	        this.DataListModel.searchTerm = "";
	        this.DataListModel.infoMessage = "";
	        this.SelectedList = SelectedList;
	        this.SelectedNames = SelectedNamesList;
	        this.instanceHashId = instanceHashId;
	        this.GetCompanyListByInstanceId();
	        this.companyModal.show();
	    };
	    CompanyPopupComponent.prototype.OnParentCheck = function (isChecked) {
	        var _this = this;
	        this.companyList.forEach(function (x) {
	            x.isChecked = isChecked;
	            if (isChecked) {
	                if (_this.SelectedList.indexOf(x.companyMasterHashId) == -1) {
	                    _this.SelectedList.push(x.companyMasterHashId);
	                }
	                if (_this.SelectedNames.indexOf(x.companyName) == -1) {
	                    _this.SelectedNames.push(x.companyName);
	                }
	            }
	            else {
	                _this.SelectedList = _this.SelectedList.filter(function (y) { return y != x.companyMasterHashId; });
	                _this.SelectedNames = _this.SelectedNames.filter(function (y) { return y != x.companyName; });
	            }
	        });
	    };
	    CompanyPopupComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetCompanyListByInstanceId();
	    };
	    CompanyPopupComponent.prototype.GetCompanyListByInstanceId = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.companyService.GetCompanybyInstanceHashId(this.DataListModel, this.instanceHashId)
	            .subscribe(function (res) {
	            _this.companyList = res.data;
	            _this.companyList.forEach(function (x) { return x.isChecked =
	                (_this.SelectedList.indexOf(x.companyMasterHashId) > -1); });
	            _this.isParentCheck = _this.companyList.every(function (x) { return x.isChecked; });
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    CompanyPopupComponent.prototype.ItemCheckChanged = function (companyMasterHashId, companyName, isChecked) {
	        if (isChecked) {
	            if (this.SelectedList.indexOf(companyMasterHashId) == -1) {
	                this.SelectedList.push(companyMasterHashId);
	            }
	            if (this.SelectedNames.indexOf(companyName) == -1) {
	                this.SelectedNames.push(companyName);
	            }
	            this.isParentCheck = this.companyList.filter(function (x) { return x.companyMasterHashId != companyMasterHashId; }).every(function (x) { return x.isChecked; });
	        }
	        else {
	            this.SelectedList = this.SelectedList.filter(function (x) { return x != companyMasterHashId; });
	            this.SelectedNames = this.SelectedNames.filter(function (x) { return x != companyName; });
	            this.isParentCheck = false;
	        }
	    };
	    CompanyPopupComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetCompanyListByInstanceId();
	    };
	    ;
	    CompanyPopupComponent.prototype.OnSearch = function (event) {
	        this.DataListModel.searchTerm = event.searchTerm;
	        this.DataListModel.currentPage = 1;
	        this.GetCompanyListByInstanceId();
	    };
	    CompanyPopupComponent.prototype.OnPagingChange = function (event) {
	        console.log(this.DataListModel);
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetCompanyListByInstanceId();
	    };
	    CompanyPopupComponent.prototype.hide = function () {
	        this.companyModal.hide();
	    };
	    CompanyPopupComponent.prototype.selectMultiple = function () {
	        this.isLoading = true;
	        this.onSuccessSelect.emit({ CompanyHashId: this.SelectedList, CompanyName: this.SelectedNames });
	        this.isLoading = false;
	        this.hide();
	    };
	    __decorate([
	        core_1.Output('OnSuccessSelect'), 
	        __metadata('design:type', Object)
	    ], CompanyPopupComponent.prototype, "onSuccessSelect", void 0);
	    __decorate([
	        core_1.ViewChild('companyModal'), 
	        __metadata('design:type', Object)
	    ], CompanyPopupComponent.prototype, "companyModal", void 0);
	    CompanyPopupComponent = __decorate([
	        core_1.Component({
	            selector: "wego-company-popup",
	            template: __webpack_require__(1344),
	            providers: [
	                company_service_1.CompanyService
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof company_service_1.CompanyService !== 'undefined' && company_service_1.CompanyService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object])
	    ], CompanyPopupComponent);
	    return CompanyPopupComponent;
	    var _a, _b;
	}());
	exports.CompanyPopupComponent = CompanyPopupComponent;


/***/ },
/* 1344 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #companyModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblSelect' | translate}} {{ 'LblCompany' | translate }} </h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <wego-search-list [IsExported]=\"false\" [SearchTerm]=\"DataListModel.searchTerm\" (OnSearch)=\"OnSearch($event)\" (OnExport)=\"OnExport($event)\"\r\n          (OnPagingChange)=\"OnPagingChange($event)\" [ItemPerPage]=\"DataListModel.itemsPerPage\" [CustomeIcon]=\"LblIcon\" [IsCustomButton]='true'\r\n          (OnCustomeButton)=\"selectMultiple()\" [IsCustomButtonEnabled]=\"SelectedList && SelectedList.length>0\"></wego-search-list>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"text-center parent-checkbox\">\r\n                  <input type=\"checkbox\" [(ngModel)]=\"isParentCheck\" name=\"parentCheck\" (change)=\"OnParentCheck($event.target.checked)\">\r\n                  <th class=\"cursor-pointer\" (click)=\"OnSort('companyName')\">\r\n                    {{ 'LblCompanyName' | translate }}\r\n                    <wego-sort-list [FieldName]=\"'companyName'\"></wego-sort-list>\r\n                  </th>\r\n                  <th class=\"cursor-pointer\" (click)=\"OnSort('instanceName')\">\r\n                    {{ 'LblInstanceName' | translate }}\r\n                    <wego-sort-list [FieldName]=\"'instanceName'\"></wego-sort-list>\r\n                  </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let company of companyList\">\r\n                  <td class=\"text-center\">\r\n                    <input type=\"checkbox\" name=\"isActive\" (click)=\"ItemCheckChanged(company.companyMasterHashId,company.companyName,$event.target.checked)\"\r\n                      [(ngModel)]=\"company.isChecked\">\r\n                  </td>\r\n                  <td>{{ company.companyName }}</td>\r\n                  <td>{{ company.instanceName }}</td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0\">\r\n                <td class=\"text-center text-danger\" colspan=\"4\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 1345 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var events_1 = __webpack_require__(1346);
	var translate_1 = __webpack_require__(631);
	var modal_1 = __webpack_require__(537);
	var ImageSliderComponent = (function () {
	    function ImageSliderComponent(translate) {
	        this.translate = translate;
	        this._popupTitle = this.translate.instant("LblSuccess");
	        this._additionalInfo = "";
	        this.onConfirm = new events_1.EventEmitter();
	        this.Imagelist = [];
	    }
	    Object.defineProperty(ImageSliderComponent.prototype, "popupTitle", {
	        get: function () {
	            return this._popupTitle;
	        },
	        set: function (popupTitle) {
	            this._popupTitle =
	                (popupTitle && popupTitle.trim()) || this.translate.instant("LblSuccess");
	        },
	        enumerable: true,
	        configurable: true
	    });
	    Object.defineProperty(ImageSliderComponent.prototype, "additionalInformation", {
	        get: function () {
	            return this._additionalInfo;
	        },
	        set: function (additionalInfo) {
	            this._additionalInfo = (additionalInfo && additionalInfo.trim()) || "";
	        },
	        enumerable: true,
	        configurable: true
	    });
	    ImageSliderComponent.prototype.ngOnInit = function () {
	        this.Imagelist = [];
	    };
	    ImageSliderComponent.prototype.GetImageURL = function (imagePath) {
	        return imagePath;
	    };
	    ImageSliderComponent.prototype.show = function (popupTitle, additionalInfo, imageList) {
	        if (popupTitle === void 0) { popupTitle = ""; }
	        if (additionalInfo === void 0) { additionalInfo = ""; }
	        this._popupTitle = popupTitle;
	        this.Imagelist = imageList;
	        this._additionalInfo = additionalInfo;
	        this.imageSliderModal.show();
	    };
	    ImageSliderComponent.prototype.hide = function () {
	        this.imageSliderModal.hide();
	    };
	    ImageSliderComponent.prototype.Confirm = function ($event) {
	        this.hide();
	        this.onConfirm.emit($event);
	    };
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String), 
	        __metadata('design:paramtypes', [String])
	    ], ImageSliderComponent.prototype, "popupTitle", null);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String), 
	        __metadata('design:paramtypes', [String])
	    ], ImageSliderComponent.prototype, "additionalInformation", null);
	    __decorate([
	        core_1.Output(), 
	        __metadata('design:type', Object)
	    ], ImageSliderComponent.prototype, "onConfirm", void 0);
	    __decorate([
	        core_1.ViewChild("imageSliderModal"), 
	        __metadata('design:type', (typeof (_a = typeof modal_1.ModalDirective !== 'undefined' && modal_1.ModalDirective) === 'function' && _a) || Object)
	    ], ImageSliderComponent.prototype, "imageSliderModal", void 0);
	    ImageSliderComponent = __decorate([
	        core_1.Component({
	            selector: "wego-image-slider",
	            template: __webpack_require__(1347),
	            styles: [
	                ".custom-modal-width {\n                width:530px;\n          }\n      .image-max-width{\n        max-width: 500px;\n      }"
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof translate_1.TranslateService !== 'undefined' && translate_1.TranslateService) === 'function' && _b) || Object])
	    ], ImageSliderComponent);
	    return ImageSliderComponent;
	    var _a, _b;
	}());
	exports.ImageSliderComponent = ImageSliderComponent;


/***/ },
/* 1346 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var R = typeof Reflect === 'object' ? Reflect : null
	var ReflectApply = R && typeof R.apply === 'function'
	  ? R.apply
	  : function ReflectApply(target, receiver, args) {
	    return Function.prototype.apply.call(target, receiver, args);
	  }
	
	var ReflectOwnKeys
	if (R && typeof R.ownKeys === 'function') {
	  ReflectOwnKeys = R.ownKeys
	} else if (Object.getOwnPropertySymbols) {
	  ReflectOwnKeys = function ReflectOwnKeys(target) {
	    return Object.getOwnPropertyNames(target)
	      .concat(Object.getOwnPropertySymbols(target));
	  };
	} else {
	  ReflectOwnKeys = function ReflectOwnKeys(target) {
	    return Object.getOwnPropertyNames(target);
	  };
	}
	
	function ProcessEmitWarning(warning) {
	  if (console && console.warn) console.warn(warning);
	}
	
	var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
	  return value !== value;
	}
	
	function EventEmitter() {
	  EventEmitter.init.call(this);
	}
	module.exports = EventEmitter;
	module.exports.once = once;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._eventsCount = 0;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	var defaultMaxListeners = 10;
	
	function checkListener(listener) {
	  if (typeof listener !== 'function') {
	    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
	  }
	}
	
	Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
	  enumerable: true,
	  get: function() {
	    return defaultMaxListeners;
	  },
	  set: function(arg) {
	    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
	      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
	    }
	    defaultMaxListeners = arg;
	  }
	});
	
	EventEmitter.init = function() {
	
	  if (this._events === undefined ||
	      this._events === Object.getPrototypeOf(this)._events) {
	    this._events = Object.create(null);
	    this._eventsCount = 0;
	  }
	
	  this._maxListeners = this._maxListeners || undefined;
	};
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
	  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
	    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
	  }
	  this._maxListeners = n;
	  return this;
	};
	
	function _getMaxListeners(that) {
	  if (that._maxListeners === undefined)
	    return EventEmitter.defaultMaxListeners;
	  return that._maxListeners;
	}
	
	EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
	  return _getMaxListeners(this);
	};
	
	EventEmitter.prototype.emit = function emit(type) {
	  var args = [];
	  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
	  var doError = (type === 'error');
	
	  var events = this._events;
	  if (events !== undefined)
	    doError = (doError && events.error === undefined);
	  else if (!doError)
	    return false;
	
	  // If there is no 'error' event listener then throw.
	  if (doError) {
	    var er;
	    if (args.length > 0)
	      er = args[0];
	    if (er instanceof Error) {
	      // Note: The comments on the `throw` lines are intentional, they show
	      // up in Node's output if this results in an unhandled exception.
	      throw er; // Unhandled 'error' event
	    }
	    // At least give some kind of context to the user
	    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
	    err.context = er;
	    throw err; // Unhandled 'error' event
	  }
	
	  var handler = events[type];
	
	  if (handler === undefined)
	    return false;
	
	  if (typeof handler === 'function') {
	    ReflectApply(handler, this, args);
	  } else {
	    var len = handler.length;
	    var listeners = arrayClone(handler, len);
	    for (var i = 0; i < len; ++i)
	      ReflectApply(listeners[i], this, args);
	  }
	
	  return true;
	};
	
	function _addListener(target, type, listener, prepend) {
	  var m;
	  var events;
	  var existing;
	
	  checkListener(listener);
	
	  events = target._events;
	  if (events === undefined) {
	    events = target._events = Object.create(null);
	    target._eventsCount = 0;
	  } else {
	    // To avoid recursion in the case that type === "newListener"! Before
	    // adding it to the listeners, first emit "newListener".
	    if (events.newListener !== undefined) {
	      target.emit('newListener', type,
	                  listener.listener ? listener.listener : listener);
	
	      // Re-assign `events` because a newListener handler could have caused the
	      // this._events to be assigned to a new object
	      events = target._events;
	    }
	    existing = events[type];
	  }
	
	  if (existing === undefined) {
	    // Optimize the case of one listener. Don't need the extra array object.
	    existing = events[type] = listener;
	    ++target._eventsCount;
	  } else {
	    if (typeof existing === 'function') {
	      // Adding the second element, need to change to array.
	      existing = events[type] =
	        prepend ? [listener, existing] : [existing, listener];
	      // If we've already got an array, just append.
	    } else if (prepend) {
	      existing.unshift(listener);
	    } else {
	      existing.push(listener);
	    }
	
	    // Check for listener leak
	    m = _getMaxListeners(target);
	    if (m > 0 && existing.length > m && !existing.warned) {
	      existing.warned = true;
	      // No error code for this since it is a Warning
	      // eslint-disable-next-line no-restricted-syntax
	      var w = new Error('Possible EventEmitter memory leak detected. ' +
	                          existing.length + ' ' + String(type) + ' listeners ' +
	                          'added. Use emitter.setMaxListeners() to ' +
	                          'increase limit');
	      w.name = 'MaxListenersExceededWarning';
	      w.emitter = target;
	      w.type = type;
	      w.count = existing.length;
	      ProcessEmitWarning(w);
	    }
	  }
	
	  return target;
	}
	
	EventEmitter.prototype.addListener = function addListener(type, listener) {
	  return _addListener(this, type, listener, false);
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.prependListener =
	    function prependListener(type, listener) {
	      return _addListener(this, type, listener, true);
	    };
	
	function onceWrapper() {
	  if (!this.fired) {
	    this.target.removeListener(this.type, this.wrapFn);
	    this.fired = true;
	    if (arguments.length === 0)
	      return this.listener.call(this.target);
	    return this.listener.apply(this.target, arguments);
	  }
	}
	
	function _onceWrap(target, type, listener) {
	  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
	  var wrapped = onceWrapper.bind(state);
	  wrapped.listener = listener;
	  state.wrapFn = wrapped;
	  return wrapped;
	}
	
	EventEmitter.prototype.once = function once(type, listener) {
	  checkListener(listener);
	  this.on(type, _onceWrap(this, type, listener));
	  return this;
	};
	
	EventEmitter.prototype.prependOnceListener =
	    function prependOnceListener(type, listener) {
	      checkListener(listener);
	      this.prependListener(type, _onceWrap(this, type, listener));
	      return this;
	    };
	
	// Emits a 'removeListener' event if and only if the listener was removed.
	EventEmitter.prototype.removeListener =
	    function removeListener(type, listener) {
	      var list, events, position, i, originalListener;
	
	      checkListener(listener);
	
	      events = this._events;
	      if (events === undefined)
	        return this;
	
	      list = events[type];
	      if (list === undefined)
	        return this;
	
	      if (list === listener || list.listener === listener) {
	        if (--this._eventsCount === 0)
	          this._events = Object.create(null);
	        else {
	          delete events[type];
	          if (events.removeListener)
	            this.emit('removeListener', type, list.listener || listener);
	        }
	      } else if (typeof list !== 'function') {
	        position = -1;
	
	        for (i = list.length - 1; i >= 0; i--) {
	          if (list[i] === listener || list[i].listener === listener) {
	            originalListener = list[i].listener;
	            position = i;
	            break;
	          }
	        }
	
	        if (position < 0)
	          return this;
	
	        if (position === 0)
	          list.shift();
	        else {
	          spliceOne(list, position);
	        }
	
	        if (list.length === 1)
	          events[type] = list[0];
	
	        if (events.removeListener !== undefined)
	          this.emit('removeListener', type, originalListener || listener);
	      }
	
	      return this;
	    };
	
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	
	EventEmitter.prototype.removeAllListeners =
	    function removeAllListeners(type) {
	      var listeners, events, i;
	
	      events = this._events;
	      if (events === undefined)
	        return this;
	
	      // not listening for removeListener, no need to emit
	      if (events.removeListener === undefined) {
	        if (arguments.length === 0) {
	          this._events = Object.create(null);
	          this._eventsCount = 0;
	        } else if (events[type] !== undefined) {
	          if (--this._eventsCount === 0)
	            this._events = Object.create(null);
	          else
	            delete events[type];
	        }
	        return this;
	      }
	
	      // emit removeListener for all listeners on all events
	      if (arguments.length === 0) {
	        var keys = Object.keys(events);
	        var key;
	        for (i = 0; i < keys.length; ++i) {
	          key = keys[i];
	          if (key === 'removeListener') continue;
	          this.removeAllListeners(key);
	        }
	        this.removeAllListeners('removeListener');
	        this._events = Object.create(null);
	        this._eventsCount = 0;
	        return this;
	      }
	
	      listeners = events[type];
	
	      if (typeof listeners === 'function') {
	        this.removeListener(type, listeners);
	      } else if (listeners !== undefined) {
	        // LIFO order
	        for (i = listeners.length - 1; i >= 0; i--) {
	          this.removeListener(type, listeners[i]);
	        }
	      }
	
	      return this;
	    };
	
	function _listeners(target, type, unwrap) {
	  var events = target._events;
	
	  if (events === undefined)
	    return [];
	
	  var evlistener = events[type];
	  if (evlistener === undefined)
	    return [];
	
	  if (typeof evlistener === 'function')
	    return unwrap ? [evlistener.listener || evlistener] : [evlistener];
	
	  return unwrap ?
	    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
	}
	
	EventEmitter.prototype.listeners = function listeners(type) {
	  return _listeners(this, type, true);
	};
	
	EventEmitter.prototype.rawListeners = function rawListeners(type) {
	  return _listeners(this, type, false);
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  if (typeof emitter.listenerCount === 'function') {
	    return emitter.listenerCount(type);
	  } else {
	    return listenerCount.call(emitter, type);
	  }
	};
	
	EventEmitter.prototype.listenerCount = listenerCount;
	function listenerCount(type) {
	  var events = this._events;
	
	  if (events !== undefined) {
	    var evlistener = events[type];
	
	    if (typeof evlistener === 'function') {
	      return 1;
	    } else if (evlistener !== undefined) {
	      return evlistener.length;
	    }
	  }
	
	  return 0;
	}
	
	EventEmitter.prototype.eventNames = function eventNames() {
	  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
	};
	
	function arrayClone(arr, n) {
	  var copy = new Array(n);
	  for (var i = 0; i < n; ++i)
	    copy[i] = arr[i];
	  return copy;
	}
	
	function spliceOne(list, index) {
	  for (; index + 1 < list.length; index++)
	    list[index] = list[index + 1];
	  list.pop();
	}
	
	function unwrapListeners(arr) {
	  var ret = new Array(arr.length);
	  for (var i = 0; i < ret.length; ++i) {
	    ret[i] = arr[i].listener || arr[i];
	  }
	  return ret;
	}
	
	function once(emitter, name) {
	  return new Promise(function (resolve, reject) {
	    function errorListener(err) {
	      emitter.removeListener(name, resolver);
	      reject(err);
	    }
	
	    function resolver() {
	      if (typeof emitter.removeListener === 'function') {
	        emitter.removeListener('error', errorListener);
	      }
	      resolve([].slice.call(arguments));
	    };
	
	    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
	    if (name !== 'error') {
	      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
	    }
	  });
	}
	
	function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
	  if (typeof emitter.on === 'function') {
	    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
	  }
	}
	
	function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
	  if (typeof emitter.on === 'function') {
	    if (flags.once) {
	      emitter.once(name, listener);
	    } else {
	      emitter.on(name, listener);
	    }
	  } else if (typeof emitter.addEventListener === 'function') {
	    // EventTarget does not have `error` event semantics like Node
	    // EventEmitters, we do not listen for `error` events here.
	    emitter.addEventListener(name, function wrapListener(arg) {
	      // IE does not have builtin `{ once: true }` support so we
	      // have to do it manually.
	      if (flags.once) {
	        emitter.removeEventListener(name, wrapListener);
	      }
	      listener(arg);
	    });
	  } else {
	    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
	  }
	}


/***/ },
/* 1347 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #imageSliderModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog custom-modal-width\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <h4 class=\"modal-title\">{{ popupTitle }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\" style=\"word-wrap: break-word;\">\r\n        <carousel>\r\n          <slide *ngFor=\"let item of Imagelist\">\r\n            <img *ngIf=\"item\" class=\"media-object image-max-width\" [src]=\"GetImageURL(item)\" alt=\"No Image Available\">\r\n          </slide>\r\n        </carousel>\r\n        <label>{{ 'LblReportedOn' | translate}} {{ additionalInformation }}</label>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 1348 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var auth_service_1 = __webpack_require__(58);
	var config_1 = __webpack_require__(60);
	var terms_conditions_service_1 = __webpack_require__(882);
	var TCActivityPopupComponent = (function () {
	    function TCActivityPopupComponent(TermsAndConditionService, authService) {
	        this.TermsAndConditionService = TermsAndConditionService;
	        this.authService = authService;
	        this.DataListModel = new config_1.DataListModel();
	        this.LblIcon = "fa fa-plus-square";
	    }
	    TCActivityPopupComponent.prototype.ngOnInit = function () {
	        this.urlDriverInfo = this.authService.GetURL(config_1.ApplicationRouteURL.URL_PERSON_UPDATE);
	        this.urlBookingInformation = this.authService.GetURL(config_1.ApplicationRouteURL.URL_BOOKING_INFORMATION);
	        this.urlctgUpdate = this.authService.GetURL(config_1.ApplicationRouteURL.URL_CONTRACT_TYPE__GROUP_UPDATE);
	    };
	    TCActivityPopupComponent.prototype.show = function (termsConditionhashId, TermsAndConditionName) {
	        this.termsConditionhashId = termsConditionhashId;
	        this.TermsAndConditionName = TermsAndConditionName;
	        this.GetTAndCActivityList();
	        this.tcActivityModel.show();
	    };
	    TCActivityPopupComponent.prototype.OnSort = function (sortName) {
	        this.DataListModel.sortType = sortName;
	        this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
	        this.GetTAndCActivityList();
	    };
	    TCActivityPopupComponent.prototype.GetTAndCActivityList = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.TermsAndConditionService.GetTermsAndConditionActivityList(this.termsConditionhashId, this.DataListModel)
	            .subscribe(function (res) {
	            _this.TandCActivityLog = res.data;
	            _this.DataListModel.totalItems = res.totalRecords;
	            _this.DataListModel.infoMessage = res.error;
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    TCActivityPopupComponent.prototype.OnExport = function (event) {
	        var _this = this;
	        this.isLoading = true;
	        this.TermsAndConditionService
	            .ExportTermsAndConditionActivityList(this.termsConditionhashId, this.DataListModel)
	            .subscribe(function (res) {
	            if (res && res._body) {
	                var fileName = "TermsAndConditionActivityLog" + new Date().toISOString() + ".csv";
	                _this.authService.DownloadFile(fileName, res._body);
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.apiErrorMsg = _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    TCActivityPopupComponent.prototype.OnPageChanged = function (event) {
	        this.DataListModel.currentPage = event.page;
	        this.GetTAndCActivityList();
	    };
	    ;
	    TCActivityPopupComponent.prototype.OnPagingChange = function (event) {
	        console.log(this.DataListModel);
	        this.DataListModel.currentPage = 1;
	        this.DataListModel.totalItems = 0;
	        this.DataListModel.itemsPerPage = event.itemPerPage;
	        this.GetTAndCActivityList();
	    };
	    TCActivityPopupComponent.prototype.hide = function () {
	        this.tcActivityModel.hide();
	    };
	    __decorate([
	        core_1.ViewChild('tcActivityModel'), 
	        __metadata('design:type', Object)
	    ], TCActivityPopupComponent.prototype, "tcActivityModel", void 0);
	    TCActivityPopupComponent = __decorate([
	        core_1.Component({
	            selector: "wego-tc-activity-popup",
	            template: __webpack_require__(1349),
	            providers: [
	                terms_conditions_service_1.TermsAndConditionsService
	            ]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof terms_conditions_service_1.TermsAndConditionsService !== 'undefined' && terms_conditions_service_1.TermsAndConditionsService) === 'function' && _a) || Object, (typeof (_b = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _b) || Object])
	    ], TCActivityPopupComponent);
	    return TCActivityPopupComponent;
	    var _a, _b;
	}());
	exports.TCActivityPopupComponent = TCActivityPopupComponent;


/***/ },
/* 1349 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #tcActivityModel=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-lg\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"tcActivityModel.hide()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblActivityLog' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <div class=\"form-group col-md-12\">\r\n          <div class=\"col-md-9\">\r\n            <h4>\r\n              <label>{{ 'LblTAndCName' | translate }} : </label>\r\n              <label> {{TermsAndConditionName}} </label>\r\n            </h4>\r\n          </div>\r\n          <div class=\"col-md-3\">\r\n            <button class=\"btn btn-default pull-right \" type=\"button\" (click)=\"OnExport($event)\" title=\"{{'LblExportReport' | translate}}\">\r\n              <i class=\"fa fa-file-excel-o\" aria-hidden=\"true\"></i>\r\n            </button>\r\n          </div>\r\n          <div class=\"clearfix\"></div>\r\n        </div>\r\n        <div class=\"table table-responsive mar_bot_ziro\">\r\n          <table class=\"table table-bordered mar_bot_ziro\">\r\n            <thead>\r\n              <tr>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('userName')\">\r\n                  {{ 'LblUserName' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'userName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('actionId')\">\r\n                  {{ 'LblAction' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'actionId'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('actionDatetimeUTC')\">\r\n                  {{ 'LblDate' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'actionDatetimeUTC'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('acceptanceMoment')\">\r\n                  {{ 'LblAcceptanceMoment' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'acceptanceMoment'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('bookingReferenceID')\">\r\n                  {{ 'LblBookingId' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'bookingReferenceID'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('ctgName')\">\r\n                  {{ 'LblContractTypeGroup' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'ctgName'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n                <th class=\"cursor-pointer\" (click)=\"OnSort('version')\">\r\n                  {{ 'LblVersion' | translate }}\r\n                  <wego-sort-list [FieldName]=\"'version'\" [SortType]=\"DataListModel.sortType\" [SortReverse]=\"DataListModel.sortReverse\"></wego-sort-list>\r\n                </th>\r\n              </tr>\r\n            </thead>\r\n            <tbody>\r\n              <template [ngIf]=\"DataListModel.totalItems != 0\">\r\n                <tr *ngFor=\"let item of TandCActivityLog\">\r\n                  <td>\r\n                    <template [ngIf]=\"item.isDriverEdit && !item.isPersonDeleted\">\r\n                      <template [ngIf]=\"item.driverPersonHashId\">\r\n                        <a [routerLink]=\"urlDriverInfo + '/' + item.driverPersonHashId\">\r\n                          {{ item.userName }}\r\n                        </a>\r\n                      </template>\r\n                    </template>\r\n                    <template [ngIf]=\"(item.isPersonDeleted || !item.isDriverEdit)\">\r\n                      {{ item.userName }}\r\n                    </template>\r\n                  </td>\r\n                  <td>{{ item.actionName }}</td>\r\n                  <td>{{ item.actionDateTime }}</td>\r\n                  <td>{{ item.acceptanceMomentName }}</td>\r\n                  <td>\r\n                    <template [ngIf]=\"item.isBookingEdit\">\r\n                      <a [routerLink]=\"urlBookingInformation + '/' + item.bookingHashId\">\r\n                        {{ item.bookingReferenceID }}\r\n                      </a>\r\n                    </template>\r\n                  </td>\r\n                  <td>\r\n                    <template [ngIf]=\"item.isCtgEdit\">\r\n                      <a [routerLink]=\"urlctgUpdate + '/' + item.svgHashId + '/' + item.ctgHashId\">\r\n                        {{ item.ctgName }}\r\n                      </a>\r\n                    </template>\r\n                  </td>\r\n                  <td>{{ item.formattedVersion }}</td>\r\n                </tr>\r\n              </template>\r\n              <tr *ngIf=\"DataListModel.totalItems == 0\">\r\n                <td class=\"text-center text-danger\" colspan=\"7\">\r\n                  {{ DataListModel.infoMessage }} {{ apiErrorMsg }}\r\n                </td>\r\n              </tr>\r\n            </tbody>\r\n          </table>\r\n        </div>\r\n        <div class=\"clearfix\"></div>\r\n        <div class=\"panel panel-default mar_bot_ziro border-top-zero border-radius-ziro\">\r\n          <div class=\"panel-body border-radius-ziro border-top-zero nopad\">\r\n            <div class=\"col-md-12\">\r\n              <pagination class=\"pull-right\" [totalItems]=\"DataListModel.totalItems\" [itemsPerPage]=\"DataListModel.itemsPerPage\" [(ngModel)]=\"DataListModel.currentPage\"\r\n                [maxSize]=\"DataListModel.maxSize\" [boundaryLinks]=\"true\" previousText=\"&lsaquo;\" nextText=\"&rsaquo;\" firstText=\"&laquo;\"\r\n                lastText=\"&raquo;\" [rotate]=\"false\" (pageChanged)=\"OnPageChanged($event)\"></pagination>\r\n            </div>\r\n          </div>\r\n        </div>\r\n        <wego-popup-lodder [isLoading]=\"isLoading\"></wego-popup-lodder>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";

/***/ },
/* 1350 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var modal_1 = __webpack_require__(537);
	var core_1 = __webpack_require__(3);
	var terms_condition_popup_service_1 = __webpack_require__(639);
	var auth_service_1 = __webpack_require__(58);
	var translate_1 = __webpack_require__(631);
	var TermsAndConditionsRevokePopup = (function () {
	    function TermsAndConditionsRevokePopup(translate, termsConditionPopup, authService) {
	        this.translate = translate;
	        this.termsConditionPopup = termsConditionPopup;
	        this.authService = authService;
	        this.onConfirm = new core_1.EventEmitter();
	    }
	    TermsAndConditionsRevokePopup.prototype.ngOnInit = function () {
	        this.popupMsg = this.translate.instant('LblSureToRevoke');
	    };
	    TermsAndConditionsRevokePopup.prototype.Confirm = function ($event) {
	        this.childModal.show();
	    };
	    TermsAndConditionsRevokePopup.prototype.HideChildModal = function () {
	        this.childModal.hide();
	        this.hide();
	    };
	    TermsAndConditionsRevokePopup.prototype.RevokeTermsAndConditions = function () {
	        var _this = this;
	        this.termsConditionPopup.RevokeTermsAndConditions(this.termsAndConditionHashId).subscribe(function (res) {
	            if (res.data) {
	                _this.HideChildModal();
	                _this.hide();
	                _this.onConfirm.emit();
	            }
	        }, function (error) {
	            _this.errorMessage = error;
	        });
	    };
	    TermsAndConditionsRevokePopup.prototype.show = function (termsAndConditionHashId) {
	        this.termsAndConditionHashId = termsAndConditionHashId;
	        this.GerTermsAndConditionDetail();
	    };
	    TermsAndConditionsRevokePopup.prototype.GerTermsAndConditionDetail = function () {
	        var _this = this;
	        if (this.termsAndConditionHashId != "") {
	            this.termsConditionPopup.GetTermsAndConditionsActivityByHashId(this.termsAndConditionHashId).subscribe(function (res) {
	                if (res.data) {
	                    _this.popupMsg = _this.translate.instant('LblSureToRevoke', [res.data.type]);
	                    _this.termsAndConditionName = res.data.termsAndConditionName;
	                    _this.acceptanceMoment = res.data.actionDateTime;
	                    _this.bodyHTMLText = res.data.bodyHtml;
	                    _this.isEditable = res.data.isEditable;
	                    _this.termsConditionModel.show();
	                }
	            }, function (error) {
	                _this.errorMessage = error;
	            });
	        }
	    };
	    TermsAndConditionsRevokePopup.prototype.hide = function () {
	        this.termsConditionModel.hide();
	    };
	    __decorate([
	        core_1.ViewChild('termsConditionModel'), 
	        __metadata('design:type', (typeof (_a = typeof modal_1.ModalDirective !== 'undefined' && modal_1.ModalDirective) === 'function' && _a) || Object)
	    ], TermsAndConditionsRevokePopup.prototype, "termsConditionModel", void 0);
	    __decorate([
	        core_1.ViewChild("childModal"), 
	        __metadata('design:type', Object)
	    ], TermsAndConditionsRevokePopup.prototype, "childModal", void 0);
	    __decorate([
	        core_1.Output('onConfirm'), 
	        __metadata('design:type', Object)
	    ], TermsAndConditionsRevokePopup.prototype, "onConfirm", void 0);
	    TermsAndConditionsRevokePopup = __decorate([
	        core_1.Component({
	            selector: 'wego-terms-condition-revoke-popup',
	            template: __webpack_require__(1351),
	            providers: [terms_condition_popup_service_1.TermsConditionPopup,]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof translate_1.TranslateService !== 'undefined' && translate_1.TranslateService) === 'function' && _b) || Object, (typeof (_c = typeof terms_condition_popup_service_1.TermsConditionPopup !== 'undefined' && terms_condition_popup_service_1.TermsConditionPopup) === 'function' && _c) || Object, (typeof (_d = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _d) || Object])
	    ], TermsAndConditionsRevokePopup);
	    return TermsAndConditionsRevokePopup;
	    var _a, _b, _c, _d;
	}());
	exports.TermsAndConditionsRevokePopup = TermsAndConditionsRevokePopup;


/***/ },
/* 1351 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #termsConditionModel=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-md\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <h4 class=\"modal-title\">{{ 'LblTermsAndCondition' | translate }} - {{termsAndConditionName}}</h4>\r\n      </div>\r\n      <div class=\"model-content\" style=\"overflow-y: auto; max-height: 450px;\">\r\n        <span class=\"text text-danger\">{{ errorMessage }}</span>\r\n        <div class=\"col-sm-12\">\r\n          <div class=\"col-sm-12\">\r\n            {{ 'LblAcceptanceMoment' | translate }} : {{acceptanceMoment}}\r\n          </div>\r\n        </div>\r\n        <div class=\"col-sm-12\">\r\n          <div class=\"col-sm-12\">\r\n            <span [innerHTML]=\"bodyHTMLText\" style=\"text-align: left;\"></span>\r\n          </div>\r\n        </div>\r\n        <br/>\r\n        <br/>\r\n      </div>\r\n      <div class=\"modal-footer\">\r\n        <button *ngIf=\"isEditable\" type=\"button\" class=\"btn btn-danger\" (click)=\"Confirm($event)\">{{ 'LblRevoke' | translate }}</button>\r\n        <button type=\"button\" class=\"btn\" (click)=\"hide()\">{{ 'LblClose' | translate }}</button>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <wego-confirm-popup #childModal [popupMsg]=\"popupMsg\" (onConfirm)=\"RevokeTermsAndConditions()\" (onReject)=\"HideChildModal()\"></wego-confirm-popup>";

/***/ },
/* 1352 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var modal_1 = __webpack_require__(537);
	var core_1 = __webpack_require__(3);
	var terms_condition_popup_service_1 = __webpack_require__(639);
	var auth_service_1 = __webpack_require__(58);
	var translate_1 = __webpack_require__(631);
	var enum_helper_1 = __webpack_require__(578);
	var TermsAndConditionsAcceptRejectPopup = (function () {
	    function TermsAndConditionsAcceptRejectPopup(translate, termsConditionPopup, authService) {
	        this.translate = translate;
	        this.termsConditionPopup = termsConditionPopup;
	        this.authService = authService;
	        this.onAccept = new core_1.EventEmitter();
	        this.onReject = new core_1.EventEmitter();
	    }
	    TermsAndConditionsAcceptRejectPopup.prototype.ngOnInit = function () {
	        this.popupMsg = this.translate.instant('LblSureToRevoke');
	        //this.acceptanceMomentList = [TNCAcceptanceMoment.ACCOUNT_ACTIVATION];
	    };
	    TermsAndConditionsAcceptRejectPopup.prototype.Confirm = function ($event) {
	        this.childModal.show();
	    };
	    TermsAndConditionsAcceptRejectPopup.prototype.HideChildModal = function () {
	        this.childModal.hide();
	        this.hide();
	    };
	    TermsAndConditionsAcceptRejectPopup.prototype.RevokeTermsAndConditions = function () {
	        var _this = this;
	        this.termsConditionPopup.RevokeTermsAndConditions(this.termsAndConditionHashId).subscribe(function (res) {
	            if (res.data) {
	                _this.HideChildModal();
	                _this.hide();
	                _this.onAccept.emit();
	            }
	        }, function (error) {
	            _this.errorMessage = error;
	        });
	    };
	    TermsAndConditionsAcceptRejectPopup.prototype.show = function (acceptanceMomentList, bookingHashId, ctgHashId, acceptanceMoment) {
	        if (bookingHashId === void 0) { bookingHashId = ''; }
	        if (ctgHashId === void 0) { ctgHashId = ''; }
	        if (acceptanceMoment === void 0) { acceptanceMoment = enum_helper_1.TNCAcceptanceMoment.ACCOUNT_ACTIVATION; }
	        this.acceptanceMomentList = acceptanceMomentList;
	        this.bookingHashId = bookingHashId;
	        this.acceptanceMoment = acceptanceMoment;
	        this.CheckAccountActivationTermsConditionStatus();
	    };
	    TermsAndConditionsAcceptRejectPopup.prototype.CheckAccountActivationTermsConditionStatus = function () {
	        var _this = this;
	        this.isLoading = true;
	        this.termsConditionPopup.GetTermsConditionForDriver(this.acceptanceMomentList, this.bookingHashId).subscribe(function (res) {
	            if (res.data && res.data.length == 0) {
	                var isAccepted = res.data.accepted;
	                _this.AllConfirmed();
	            }
	            else {
	                _this.popupMsg = _this.translate.instant('LblSureToRevoke', [res.data.type]);
	                _this.termsAndCondList = res.data;
	                _this.curIndex = 0;
	                _this.TotalTNC = _this.termsAndCondList.length;
	                _this.termsAndConditionName = _this.termsAndCondList[0].name;
	                _this.bodyHTMLText = _this.termsAndCondList[0].content;
	                _this.termsAndConditionHashId = _this.termsAndCondList[0].termsAndConditionsHashId;
	                _this.termsConditionModel.show();
	            }
	            _this.isLoading = false;
	        }, function (error) {
	            _this.authService.HandleErrorStatusCode(error);
	            _this.isLoading = false;
	        });
	    };
	    TermsAndConditionsAcceptRejectPopup.prototype.OnRejectClick = function (action) {
	        this.ActionOnAccountActivationTermsCondition(this.termsAndConditionHashId, enum_helper_1.TNCAction.REJECTED);
	    };
	    TermsAndConditionsAcceptRejectPopup.prototype.OnAcceptClick = function (action) {
	        this.ActionOnAccountActivationTermsCondition(this.termsAndConditionHashId, enum_helper_1.TNCAction.ACCEPTED);
	    };
	    TermsAndConditionsAcceptRejectPopup.prototype.AllConfirmed = function () {
	        this.onAccept.emit();
	        this.hide();
	    };
	    TermsAndConditionsAcceptRejectPopup.prototype.Rejected = function () {
	        this.onReject.emit();
	        this.hide();
	    };
	    TermsAndConditionsAcceptRejectPopup.prototype.ActionOnAccountActivationTermsCondition = function (tncHashId, action) {
	        var _this = this;
	        this.termsConditionPopup
	            .ActionOnAccountActivationTermsCondition(tncHashId, action, this.bookingHashId, '', [this.acceptanceMoment])
	            .subscribe(function (res) {
	            if (action == enum_helper_1.TNCAction.ACCEPTED) {
	                _this.curIndex = _this.curIndex + 1;
	                if (_this.curIndex == _this.TotalTNC) {
	                    _this.AllConfirmed();
	                }
	                else {
	                    _this.termsAndConditionName = _this.termsAndCondList[_this.curIndex].name;
	                    _this.bodyHTMLText = _this.termsAndCondList[_this.curIndex].content;
	                    _this.termsAndConditionHashId = _this.termsAndCondList[_this.curIndex].termsAndConditionsHashId;
	                }
	            }
	            else {
	                _this.Rejected();
	            }
	        }, function (error) {
	            _this.errorMessage = _this.authService.HandleErrorStatusCode(error);
	            ;
	        });
	    };
	    TermsAndConditionsAcceptRejectPopup.prototype.hide = function () {
	        this.termsConditionModel.hide();
	    };
	    __decorate([
	        core_1.ViewChild('termsConditionModel'), 
	        __metadata('design:type', (typeof (_a = typeof modal_1.ModalDirective !== 'undefined' && modal_1.ModalDirective) === 'function' && _a) || Object)
	    ], TermsAndConditionsAcceptRejectPopup.prototype, "termsConditionModel", void 0);
	    __decorate([
	        core_1.ViewChild("childModal"), 
	        __metadata('design:type', Object)
	    ], TermsAndConditionsAcceptRejectPopup.prototype, "childModal", void 0);
	    __decorate([
	        core_1.Output('onAccept'), 
	        __metadata('design:type', Object)
	    ], TermsAndConditionsAcceptRejectPopup.prototype, "onAccept", void 0);
	    __decorate([
	        core_1.Output('onReject'), 
	        __metadata('design:type', Object)
	    ], TermsAndConditionsAcceptRejectPopup.prototype, "onReject", void 0);
	    TermsAndConditionsAcceptRejectPopup = __decorate([
	        core_1.Component({
	            selector: 'wego-terms-condition-accept-reject-popup',
	            template: __webpack_require__(1353),
	            providers: [terms_condition_popup_service_1.TermsConditionPopup,]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof translate_1.TranslateService !== 'undefined' && translate_1.TranslateService) === 'function' && _b) || Object, (typeof (_c = typeof terms_condition_popup_service_1.TermsConditionPopup !== 'undefined' && terms_condition_popup_service_1.TermsConditionPopup) === 'function' && _c) || Object, (typeof (_d = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _d) || Object])
	    ], TermsAndConditionsAcceptRejectPopup);
	    return TermsAndConditionsAcceptRejectPopup;
	    var _a, _b, _c, _d;
	}());
	exports.TermsAndConditionsAcceptRejectPopup = TermsAndConditionsAcceptRejectPopup;


/***/ },
/* 1353 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #termsConditionModel=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog modal-md\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <h4 class=\"modal-title\">{{ 'LblTermsAndCondition' | translate }} - {{termsAndConditionName}}</h4>\r\n        <h6 class=\"text-center login-text\">{{curIndex+1}} {{'LblOutOf' | translate}} {{TotalTNC}} </h6>\r\n      </div>\r\n      <div class=\"model-content\" style=\"overflow-y: auto; max-height: 450px;\">\r\n        <span class=\"text text-danger\">{{ errorMessage }}</span>        \r\n        <div class=\"col-sm-12\">\r\n          <div class=\"col-sm-12\">\r\n            <span [innerHTML]=\"bodyHTMLText\" style=\"text-align: left;\"></span>\r\n          </div>\r\n        </div>\r\n        <br/>\r\n        <br/>\r\n      </div>\r\n      <div class=\"modal-footer\">\r\n        <div class=\"checkbox col-xs-12 col-sm-8 col-sm-offset-2\" style=\"text-align: center\">\r\n          <button class=\"btn btn-confirm cursor-pointer\" (click)=\"OnAcceptClick()\">{{ 'LblAccept' | translate }}</button> &nbsp;&nbsp;\r\n          <a class=\"btn btn-gray cursor-pointer\" (click)=\"OnRejectClick()\">{{ 'LblReject' | translate }}</a> &nbsp;&nbsp;\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n\r\n  <wego-confirm-popup #childModal [popupMsg]=\"popupMsg\" (onConfirm)=\"RevokeTermsAndConditions()\" (onReject)=\"HideChildModal()\"></wego-confirm-popup>";

/***/ },
/* 1354 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var core_1 = __webpack_require__(3);
	var modal_1 = __webpack_require__(537);
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var router_1 = __webpack_require__(26);
	var CreditCardPaymentPopupComponent = (function () {
	    function CreditCardPaymentPopupComponent(translate, authService, router) {
	        this.translate = translate;
	        this.authService = authService;
	        this.router = router;
	        this.onProceed = new core_1.EventEmitter();
	        this.onCancel = new core_1.EventEmitter();
	        this.isAllowInitialPayment = new core_1.EventEmitter();
	    }
	    Object.defineProperty(CreditCardPaymentPopupComponent.prototype, "errorMessage", {
	        get: function () {
	            return this._errorMessage;
	        },
	        set: function (errorMessage) {
	            if (errorMessage) {
	                var stringErrorMessage = errorMessage.substring(0, errorMessage.indexOf(':'));
	                this._errorMessage = stringErrorMessage && stringErrorMessage.trim();
	            }
	        },
	        enumerable: true,
	        configurable: true
	    });
	    CreditCardPaymentPopupComponent.prototype.ngOnInit = function () { };
	    CreditCardPaymentPopupComponent.prototype.show = function () {
	        this.errorMessage = '';
	        this._errorMessage = '';
	        this.isAllowPayment = false;
	        this.creditCardPaymentModal.show();
	    };
	    CreditCardPaymentPopupComponent.prototype.hide = function () {
	        this.creditCardPaymentModal.hide();
	    };
	    CreditCardPaymentPopupComponent.prototype.GetCheckedValue = function ($event) {
	        this.isAllowInitialPayment.emit($event.currentTarget.checked);
	    };
	    CreditCardPaymentPopupComponent.prototype.Proceed = function () {
	        this.onProceed.emit();
	    };
	    CreditCardPaymentPopupComponent.prototype.Cancel = function ($event) {
	        this.hide();
	        this.onCancel.emit($event);
	    };
	    __decorate([
	        core_1.ViewChild('creditCardPaymentModal'), 
	        __metadata('design:type', (typeof (_a = typeof modal_1.ModalDirective !== 'undefined' && modal_1.ModalDirective) === 'function' && _a) || Object)
	    ], CreditCardPaymentPopupComponent.prototype, "creditCardPaymentModal", void 0);
	    __decorate([
	        core_1.Output('onProceed'), 
	        __metadata('design:type', Object)
	    ], CreditCardPaymentPopupComponent.prototype, "onProceed", void 0);
	    __decorate([
	        core_1.Output('onCancel'), 
	        __metadata('design:type', Object)
	    ], CreditCardPaymentPopupComponent.prototype, "onCancel", void 0);
	    __decorate([
	        core_1.Output('isAllowInitialPayment'), 
	        __metadata('design:type', Object)
	    ], CreditCardPaymentPopupComponent.prototype, "isAllowInitialPayment", void 0);
	    __decorate([
	        core_1.Input('initialPaymentPopupTitle'), 
	        __metadata('design:type', String)
	    ], CreditCardPaymentPopupComponent.prototype, "initialPaymentPopupTitle", void 0);
	    __decorate([
	        core_1.Input('popupDescription'), 
	        __metadata('design:type', String)
	    ], CreditCardPaymentPopupComponent.prototype, "popupDescription", void 0);
	    __decorate([
	        core_1.Input(), 
	        __metadata('design:type', String), 
	        __metadata('design:paramtypes', [String])
	    ], CreditCardPaymentPopupComponent.prototype, "errorMessage", null);
	    CreditCardPaymentPopupComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-credit-card-payment-popup',
	            template: __webpack_require__(1355),
	            providers: []
	        }), 
	        __metadata('design:paramtypes', [(typeof (_b = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _b) || Object, (typeof (_c = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _c) || Object, (typeof (_d = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _d) || Object])
	    ], CreditCardPaymentPopupComponent);
	    return CreditCardPaymentPopupComponent;
	    var _a, _b, _c, _d;
	}());
	exports.CreditCardPaymentPopupComponent = CreditCardPaymentPopupComponent;


/***/ },
/* 1355 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #creditCardPaymentModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\"\r\n  aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\r\n  <div class=\"modal-dialog\">\r\n    <div class=\"modal-content\">\r\n      <div class=\"modal-header\">\r\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\r\n          <span aria-hidden=\"true\">&times;</span>\r\n        </button>\r\n        <h4 class=\"modal-title\">{{ 'LblCrediCardPayment' | translate }}</h4>\r\n      </div>\r\n      <div class=\"modal-body\">\r\n        <label> {{ initialPaymentPopupTitle }} </label>\r\n        <br/>\r\n        <div class=\"item-input-wrap\" style=\"text-align: justify\">\r\n          {{ popupDescription }}\r\n          <br/>\r\n          <br/>\r\n          <div class=\"checkbox\">\r\n            <label>\r\n              <input type=\"checkbox\" [(ngModel)]=\"isAllowPayment\" name=\"isAllowPayment\" id=\"isAllowPayment\" (click)=\"GetCheckedValue($event)\">\r\n              <i class=\"icon icon-checkbox margin-right\"></i>\r\n              {{ 'LblAllowRecurringPayment' | translate }}\r\n            </label>\r\n          </div>\r\n          <span class=\"text text-danger\">{{ errorMessage }}</span>\r\n        </div>\r\n      </div>\r\n      <div class=\"modal-footer\">\r\n        <button type=\"button\" class=\"btn btn-gray\" (click)=\"Cancel($event)\">{{ 'LblCancel' | translate }}</button>\r\n        <button type=\"button\" class=\"btn btn-green\" (click)=\"Proceed()\">{{ 'LblProceed' | translate }}</button>\r\n      </div>\r\n    </div>";

/***/ },
/* 1356 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
	    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
	    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
	    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	    return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	var __metadata = (this && this.__metadata) || function (k, v) {
	    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
	};
	var translate_service_1 = __webpack_require__(70);
	var auth_service_1 = __webpack_require__(58);
	var core_1 = __webpack_require__(3);
	var router_1 = __webpack_require__(26);
	var tripcomment_model_1 = __webpack_require__(1357);
	var tripcomment_service_1 = __webpack_require__(932);
	var TripCommentComponent = (function () {
	    function TripCommentComponent(authService, router, translate, tripCommentService) {
	        this.authService = authService;
	        this.router = router;
	        this.translate = translate;
	        this.tripCommentService = tripCommentService;
	        this.model = new tripcomment_model_1.TripCommentModel();
	        this.onCommentConfirm = new core_1.EventEmitter();
	    }
	    TripCommentComponent.prototype.ngOnInit = function () {
	        this.model = new tripcomment_model_1.TripCommentModel();
	    };
	    TripCommentComponent.prototype.show = function () {
	        this.tripCommentModal.show();
	    };
	    TripCommentComponent.prototype.AddTripComment = function () {
	        var _this = this;
	        var formData = new FormData();
	        formData.append("tripcomment", JSON.stringify(this.model));
	        this.tripCommentService.AddTripComment(formData).subscribe(function (res) {
	            if (res.data) {
	                _this.OnSuccessSelect();
	            }
	            else {
	                _this.tripCommentModal.errorMsg = res.error;
	            }
	        }, function (error) {
	            console.log(error);
	            _this.authService.HandleErrorStatusCode(error);
	        });
	    };
	    TripCommentComponent.prototype.OnSuccessSelect = function () {
	        this.hide();
	    };
	    TripCommentComponent.prototype.hide = function () {
	        this.model = new tripcomment_model_1.TripCommentModel();
	        this.errorMsg = "";
	        this.tripCommentModal.hide();
	    };
	    TripCommentComponent.prototype.OnCancel = function ($event) {
	        this.hide();
	    };
	    __decorate([
	        core_1.ViewChild('tripCommentModal'), 
	        __metadata('design:type', Object)
	    ], TripCommentComponent.prototype, "tripCommentModal", void 0);
	    __decorate([
	        core_1.Output('onCommentConfirm'), 
	        __metadata('design:type', Object)
	    ], TripCommentComponent.prototype, "onCommentConfirm", void 0);
	    TripCommentComponent = __decorate([
	        core_1.Component({
	            selector: 'wego-tripcomment-popup',
	            template: __webpack_require__(1358),
	            providers: [tripcomment_service_1.TripCommentService]
	        }), 
	        __metadata('design:paramtypes', [(typeof (_a = typeof auth_service_1.AuthService !== 'undefined' && auth_service_1.AuthService) === 'function' && _a) || Object, (typeof (_b = typeof router_1.Router !== 'undefined' && router_1.Router) === 'function' && _b) || Object, (typeof (_c = typeof translate_service_1.TranslateService !== 'undefined' && translate_service_1.TranslateService) === 'function' && _c) || Object, (typeof (_d = typeof tripcomment_service_1.TripCommentService !== 'undefined' && tripcomment_service_1.TripCommentService) === 'function' && _d) || Object])
	    ], TripCommentComponent);
	    return TripCommentComponent;
	    var _a, _b, _c, _d;
	}());
	exports.TripCommentComponent = TripCommentComponent;


/***/ },
/* 1357 */
/***/ function(module, exports) {

	"use strict";
	var TripCommentModel = (function () {
	    function TripCommentModel() {
	    }
	    return TripCommentModel;
	}());
	exports.TripCommentModel = TripCommentModel;


/***/ },
/* 1358 */
/***/ function(module, exports) {

	module.exports = "<div bsModal #tripCommentModal=\"bs-modal\" class=\"modal fade\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"mySmallModalLabel\" aria-hidden=\"true\" [config]=\"{backdrop: false, keyboard: false}\">\n  <div class=\"modal-dialog\">\n    <div class=\"modal-content\">\n      <div class=\"modal-header\">\n        <button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"hide()\">\n          <span aria-hidden=\"true\">&times;</span>\n        </button>\n        <h4 class=\"modal-title\">{{ 'LblTripComments' | translate }}</h4>\n      </div>\n      <div class=\"modal-body\">\n        <form (ngSubmit)=\"AddTripComment()\" #TripCommentForm=\"ngForm\">\n          <div class=\"row\">\n            <div class=\"col-md-12\">\n              <span class=\"text text-danger\">*</span> <label>{{ 'LblComment' | translate }}</label>\n              <input type=\"hidden\" id=\"tripId\" name=\"tripId\" [(ngModel)]=\"model.tripId\" />\n              <textarea class=\"form-control\" id=\"tripComment\" name=\"tripComment\" [(ngModel)]=\"model.tripComment\" rows=\"8\" placeholder=\"{{ 'LblTripCommentDescription' | translate }}\"></textarea>\n              <span id=\"errorMsg\" class=\"text text-danger\">{{ LblTripCommentError }}</span>\n              <div class=\"row mar_t_15\" *ngIf=\"model.tripCommentBy != 0\">\n                <div class=\"col-md-6\"><label class=\"d-block mar_right_5\">{{ 'LblTripCommentBy' | translate }}</label><span>{{ model.tripCommentByFullname }}</span></div>\n                <div class=\"col-md-6\"><label class=\"d-block mar_right_5\">{{ 'LblTripCommentOn' | translate }}</label><span>{{ model.tripCommentOn | date: 'dd-MM-yyyy HH:mm:ss' }}</span></div>\n              </div>\n            </div>\n          </div>\n          <hr>\n          <div class=\"form-group row\">\n            <div class=\"col-sm-12\">\n              <button *ngIf=\"model.tripCommentBy == 0\" type=\"submit\" class=\"btn btn-green\">{{ 'LblOK' | translate }}</button>\n              <button type=\"button\" class=\"btn btn-gray\" (click)=\"hide()\">{{ 'LblCancel' | translate }}</button>\n            </div>\n          </div>\n        </form>\n      </div>        \n    </div>\n  </div>\n</div>";

/***/ }
]);


// WEBPACK FOOTER //
// app.040b606fd5379ae866cf.js